function _mergeNamespaces(n12, m) {
  for (var i = 0; i < m.length; i++) {
    const e = m[i];
    if (typeof e !== "string" && !Array.isArray(e)) {
      for (const k in e) {
        if (k !== "default" && !(k in n12)) {
          const d = Object.getOwnPropertyDescriptor(e, k);
          if (d) {
            Object.defineProperty(n12, k, d.get ? d : {
              enumerable: true,
              get: () => e[k]
            });
          }
        }
      }
    }
  }
  return Object.freeze(Object.defineProperty(n12, Symbol.toStringTag, { value: "Module" }));
}
let _mode = "production";
const setMode = (mode) => {
  _mode = mode;
};
const isProduction = () => {
  return _mode === "production";
};
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2[LogLevel2["ERROR"] = 10] = "ERROR";
  LogLevel2[LogLevel2["WARN"] = 20] = "WARN";
  LogLevel2[LogLevel2["TIME"] = 30] = "TIME";
  LogLevel2[LogLevel2["INFO"] = 40] = "INFO";
  LogLevel2[LogLevel2["DEBUG"] = 50] = "DEBUG";
  LogLevel2[LogLevel2["TRACE"] = 60] = "TRACE";
  return LogLevel2;
})(LogLevel || {});
const noop$7 = () => {
};
const op$1 = (method) => {
  if (!console) {
    return noop$7;
  }
  if (!console[method] && Boolean(console.log)) {
    return (data) => {
      console.log(data);
    };
  }
  return (data) => {
    console[method](data);
  };
};
const consoleMap = /* @__PURE__ */ new Map([
  [LogLevel.ERROR, op$1("error")],
  [LogLevel.WARN, op$1("warn")],
  [LogLevel.TIME, op$1("log")],
  [LogLevel.INFO, op$1("log")],
  [LogLevel.DEBUG, op$1("log")],
  [LogLevel.TRACE, op$1("log")]
]);
const consoleTransport = (log2) => {
  const transport = consoleMap.get(log2.level);
  if (transport) {
    transport(log2);
  }
};
const makeLogMethod = ({ level, transports }) => (logLevel) => (log2) => {
  if (logLevel > level) {
    return;
  }
  let data = log2;
  if (typeof log2 !== "object") {
    data = { msg: JSON.stringify(log2) };
  }
  data.level = level;
  data.ts = Date.now();
  Promise.allSettled(
    transports.map((t16) => Promise.resolve(t16(data)))
  );
};
const makeLogger = (config2) => {
  return {
    config: config2,
    error: makeLogMethod(config2)(LogLevel.ERROR),
    warn: makeLogMethod(config2)(LogLevel.WARN),
    info: makeLogMethod(config2)(LogLevel.INFO),
    debug: makeLogMethod(config2)(LogLevel.DEBUG),
    trace: makeLogMethod(config2)(LogLevel.TRACE)
  };
};
const changeLoggerLevel = (logger, level) => {
  Object.assign(logger, makeLogger({ ...logger.config, level }));
};
const addLoggerTransport = (logger, transport) => {
  Object.assign(
    logger,
    makeLogger({
      ...logger.config,
      transports: [...logger.config.transports, transport]
    })
  );
};
const makeDefaultLogger = (level) => makeLogger({
  level,
  transports: [consoleTransport]
});
const AnalyticsPageEvents = {
  activate: "Activate",
  "admin/config/templates/list": "Property Template List",
  "admin/config/templates/manage": "Property Template Add/Edit",
  "admin/config/templates/properties/audit": "Property Template List Properties Audit",
  "admin/config/templates/properties/org/audit": "Property Template Org Audit",
  "admin/setup/accounting/vendor_invoice_format/config": "Vendor Invoice Format Edit",
  "admin/setup/accounting/vendor_invoice_format/list": "Vendor Invoice Formats List",
  "admin/setup/approval_groups/accounts_receivable/add": "Accounts Receivable Add",
  "admin/setup/approval_groups/accounts_receivable/edit": "Accounts Receivable Edit",
  "admin/setup/approval_groups/accounts_receivable/list": "Accounts Receivable List",
  "admin/setup/contract/contract_agencies/list": "Contract Agency Code list",
  "admin/setup/datalake/criteria/add": "DataLake Criteria Add",
  "admin/setup/datalake/criteria/edit": "DataLake Criteria Edit",
  "admin/setup/datalake/criteria/list": "DataLake Criteria List",
  "contracts/project/assign": "Assign from PO",
  "contracts/add": "Create a new contract",
  "contracts/edit": "Edit an existing contract",
  "contract_clauses/list": "Contract Clause List",
  "contract_clauses/associate": "Contract Clause Associate",
  error: "Error on Page",
  fixed_assets: "Fixed Assets Dashboard",
  "fixed_assets/alerts": "Fixed Assets Alerts",
  "fixed_assets/list": "Fixed Assets List",
  "fixed_assets/search": "Fixed Assets Search",
  "fixed_assets/view": "Fixed Asset View",
  "fixed_assets/add": "Fixed Asset Add",
  "fixed_assets/edit": "Fixed Asset Edit",
  "fixed_assets/post": "Fixed Assets Post",
  "fixed_assets/unpost": "Fixed Assets Unpost",
  "fixed_assets/setup/classes": "Fixed Assets Setup - Classes",
  "fixed_assets/setup/statuses": "Fixed Assets Setup - Statuses",
  "forecast/people_planner": "People Planner",
  "forecast/people_assigner": "People Assigner",
  generic: "Page Change",
  login: "Login",
  pageNotFound: "Page Not Found",
  properties: "Properties",
  "purchasing/receipts/add": "Receipts Add",
  "purchasing/receipts/edit": "Receipts Edit",
  "purchasing/receipts/list": "Receipts List",
  "purchasing/receipts/po_search": "Receipts Purchase Order Search",
  "purchasing/receipts/view": "Receipts View",
  "reports/audit_logs": "Audit Logs",
  time: "Time Dashboard",
  "time/approval": "Time Approval"
};
const getPageTypeAndId = (pathname) => {
  try {
    let splitPath = pathname.split("/");
    const spaActionIdx = splitPath.indexOf("spa_action");
    splitPath = splitPath.filter((p, i) => p && i > spaActionIdx);
    if (splitPath.length === 1) {
      const path = splitPath[0];
      if (path === "404") {
        return {
          type: AnalyticsPageEvents.pageNotFound,
          id: ""
        };
      } else if (path === "login") {
        return { type: AnalyticsPageEvents.login, id: "" };
      } else if (path === "active") {
        return {
          type: AnalyticsPageEvents.activate,
          id: ""
        };
      } else if (path === "properties") {
        return {
          type: AnalyticsPageEvents.properties,
          id: ""
        };
      } else if (path === "error") {
        return { type: AnalyticsPageEvents.error, id: "" };
      }
    }
    const last2 = splitPath[splitPath.length - 1];
    if (last2.includes("search")) {
      splitPath[splitPath.length - 1] = "search";
    }
    const id = !isNaN(parseInt(last2)) ? last2 : "";
    const joinPath = id ? splitPath.slice(0, -1).join("/") : splitPath.join("/");
    const type = `${AnalyticsPageEvents[joinPath] ?? AnalyticsPageEvents.generic}`;
    return { type, id };
  } catch (e) {
    return { type: AnalyticsPageEvents.generic, id: "" };
  }
};
const keepUnique = (content) => [
  ...new Set(content)
];
const withoutChars = (chars, charsToExclude) => chars.filter((char2) => !charsToExclude.includes(char2));
const onlyChars = (chars, keepChars) => chars.filter((char2) => keepChars.includes(char2));
const isIntegerNumber = (n12) => typeof n12 === "bigint" || !Number.isNaN(Number(n12)) && Math.floor(Number(n12)) === n12;
const isPositiveAndFinite = (n12) => typeof n12 === "bigint" || n12 >= 0 && Number.isSafeInteger(n12);
function shuffle(alphabetChars, saltChars) {
  if (saltChars.length === 0) {
    return alphabetChars;
  }
  let integer;
  const transformed = [...alphabetChars];
  for (let i = transformed.length - 1, v = 0, p = 0; i > 0; i--, v++) {
    v %= saltChars.length;
    p += integer = saltChars[v].codePointAt(0);
    const j = (integer + v + p) % i;
    const a = transformed[i];
    const b = transformed[j];
    transformed[j] = a;
    transformed[i] = b;
  }
  return transformed;
}
const toAlphabet = (input, alphabetChars) => {
  const id = [];
  let value = input;
  if (typeof value === "bigint") {
    const alphabetLength = BigInt(alphabetChars.length);
    do {
      id.unshift(alphabetChars[Number(value % alphabetLength)]);
      value /= alphabetLength;
    } while (value > BigInt(0));
  } else {
    do {
      id.unshift(alphabetChars[value % alphabetChars.length]);
      value = Math.floor(value / alphabetChars.length);
    } while (value > 0);
  }
  return id;
};
const fromAlphabet = (inputChars, alphabetChars) => inputChars.reduce((carry, item) => {
  const index2 = alphabetChars.indexOf(item);
  if (index2 === -1) {
    throw new Error(`The provided ID (${inputChars.join("")}) is invalid, as it contains characters that do not exist in the alphabet (${alphabetChars.join("")})`);
  }
  if (typeof carry === "bigint") {
    return carry * BigInt(alphabetChars.length) + BigInt(index2);
  }
  const value = carry * alphabetChars.length + index2;
  const isSafeValue = Number.isSafeInteger(value);
  if (isSafeValue) {
    return value;
  }
  throwIfBigIntNotAvailable(`Unable to decode the provided string, due to lack of support for BigInt numbers in the current environment`);
  return BigInt(carry) * BigInt(alphabetChars.length) + BigInt(index2);
}, 0);
const safeToParseNumberRegExp = /^\+?\d+$/;
const safeParseInt10 = (str) => {
  if (!safeToParseNumberRegExp.test(str)) {
    return Number.NaN;
  }
  const int10 = Number.parseInt(str, 10);
  if (Number.isSafeInteger(int10)) {
    return int10;
  }
  throwIfBigIntNotAvailable("Unable to encode the provided BigInt string without loss of information due to lack of support for BigInt type in the current environment");
  return BigInt(str);
};
const splitAtIntervalAndMap = (str, nth, map2) => Array.from({ length: Math.ceil(str.length / nth) }, (_, index2) => map2(str.slice(index2 * nth, (index2 + 1) * nth)));
const makeAnyOfCharsRegExp = (chars) => new RegExp(chars.map((char2) => escapeRegExp(char2)).sort((a, b) => b.length - a.length).join("|"));
const makeAtLeastSomeCharRegExp = (chars) => new RegExp(`^[${chars.map((char2) => escapeRegExp(char2)).sort((a, b) => b.length - a.length).join("")}]+$`);
const escapeRegExp = (text) => text.replace(/[\s#$()*+,.?[\\\]^{|}-]/g, "\\$&");
const throwIfBigIntNotAvailable = (errorMessage = "BigInt is not available in this environment") => {
  if (typeof BigInt !== "function") {
    throw new TypeError(errorMessage);
  }
};
const MIN_ALPHABET_LENGTH = 16;
const SEPARATOR_DIV = 3.5;
const GUARD_DIV = 12;
const HEXADECIMAL = 16;
const SPLIT_AT_EVERY_NTH = 12;
const MODULO_PART = 100;
class Hashids {
  constructor(salt = "", minLength = 0, alphabet = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890", seps = "cfhistuCFHISTU") {
    this.minLength = minLength;
    if (typeof minLength !== "number") {
      throw new TypeError(`Hashids: Provided 'minLength' has to be a number (is ${typeof minLength})`);
    }
    if (typeof salt !== "string") {
      throw new TypeError(`Hashids: Provided 'salt' has to be a string (is ${typeof salt})`);
    }
    if (typeof alphabet !== "string") {
      throw new TypeError(`Hashids: Provided alphabet has to be a string (is ${typeof alphabet})`);
    }
    const saltChars = Array.from(salt);
    const alphabetChars = Array.from(alphabet);
    const sepsChars = Array.from(seps);
    this.salt = saltChars;
    const uniqueAlphabet = keepUnique(alphabetChars);
    if (uniqueAlphabet.length < MIN_ALPHABET_LENGTH) {
      throw new Error(`Hashids: alphabet must contain at least ${MIN_ALPHABET_LENGTH} unique characters, provided: ${uniqueAlphabet.join("")}`);
    }
    this.alphabet = withoutChars(uniqueAlphabet, sepsChars);
    const filteredSeps = onlyChars(sepsChars, uniqueAlphabet);
    this.seps = shuffle(filteredSeps, saltChars);
    let sepsLength;
    let diff2;
    if (this.seps.length === 0 || this.alphabet.length / this.seps.length > SEPARATOR_DIV) {
      sepsLength = Math.ceil(this.alphabet.length / SEPARATOR_DIV);
      if (sepsLength > this.seps.length) {
        diff2 = sepsLength - this.seps.length;
        this.seps.push(...this.alphabet.slice(0, diff2));
        this.alphabet = this.alphabet.slice(diff2);
      }
    }
    this.alphabet = shuffle(this.alphabet, saltChars);
    const guardCount = Math.ceil(this.alphabet.length / GUARD_DIV);
    if (this.alphabet.length < 3) {
      this.guards = this.seps.slice(0, guardCount);
      this.seps = this.seps.slice(guardCount);
    } else {
      this.guards = this.alphabet.slice(0, guardCount);
      this.alphabet = this.alphabet.slice(guardCount);
    }
    this.guardsRegExp = makeAnyOfCharsRegExp(this.guards);
    this.sepsRegExp = makeAnyOfCharsRegExp(this.seps);
    this.allowedCharsRegExp = makeAtLeastSomeCharRegExp([
      ...this.alphabet,
      ...this.guards,
      ...this.seps
    ]);
  }
  encode(first, ...inputNumbers) {
    const ret = "";
    let numbers = Array.isArray(first) ? first : [...first != null ? [first] : [], ...inputNumbers];
    if (numbers.length === 0) {
      return ret;
    }
    if (!numbers.every(isIntegerNumber)) {
      numbers = numbers.map((n12) => typeof n12 === "bigint" || typeof n12 === "number" ? n12 : safeParseInt10(String(n12)));
    }
    if (!numbers.every(isPositiveAndFinite)) {
      return ret;
    }
    return this._encode(numbers).join("");
  }
  decode(id) {
    if (!id || typeof id !== "string" || id.length === 0)
      return [];
    return this._decode(id);
  }
  /**
   * @description Splits a hex string into groups of 12-digit hexadecimal numbers,
   * then prefixes each with '1' and encodes the resulting array of numbers
   *
   * Encoding '00000000000f00000000000f000f' would be the equivalent of:
   * Hashids.encode([0x100000000000f, 0x100000000000f, 0x1000f])
   *
   * This means that if your environment supports BigInts,
   * you will get different (shorter) results if you provide
   * a BigInt representation of your hex and use `encode` directly, e.g.:
   * Hashids.encode(BigInt(`0x${hex}`))
   *
   * To decode such a representation back to a hex string, use the following snippet:
   * Hashids.decode(id)[0].toString(16)
   */
  encodeHex(inputHex) {
    let hex = inputHex;
    switch (typeof hex) {
      case "bigint":
        hex = hex.toString(HEXADECIMAL);
        break;
      case "string":
        if (!/^[\dA-Fa-f]+$/.test(hex))
          return "";
        break;
      default:
        throw new Error(`Hashids: The provided value is neither a string, nor a BigInt (got: ${typeof hex})`);
    }
    const numbers = splitAtIntervalAndMap(hex, SPLIT_AT_EVERY_NTH, (part) => Number.parseInt(`1${part}`, 16));
    return this.encode(numbers);
  }
  decodeHex(id) {
    return this.decode(id).map((number) => number.toString(HEXADECIMAL).slice(1)).join("");
  }
  isValidId(id) {
    return this.allowedCharsRegExp.test(id);
  }
  _encode(numbers) {
    let { alphabet } = this;
    const numbersIdInt = numbers.reduce((last2, number, i) => last2 + (typeof number === "bigint" ? Number(number % BigInt(i + MODULO_PART)) : number % (i + MODULO_PART)), 0);
    let ret = [alphabet[numbersIdInt % alphabet.length]];
    const lottery = [...ret];
    const { seps } = this;
    const { guards } = this;
    numbers.forEach((number, i) => {
      const buffer2 = lottery.concat(this.salt, alphabet);
      alphabet = shuffle(alphabet, buffer2);
      const last2 = toAlphabet(number, alphabet);
      ret.push(...last2);
      if (i + 1 < numbers.length) {
        const charCode = last2[0].codePointAt(0) + i;
        const extraNumber = typeof number === "bigint" ? Number(number % BigInt(charCode)) : number % charCode;
        ret.push(seps[extraNumber % seps.length]);
      }
    });
    if (ret.length < this.minLength) {
      const prefixGuardIndex = (numbersIdInt + ret[0].codePointAt(0)) % guards.length;
      ret.unshift(guards[prefixGuardIndex]);
      if (ret.length < this.minLength) {
        const suffixGuardIndex = (numbersIdInt + ret[2].codePointAt(0)) % guards.length;
        ret.push(guards[suffixGuardIndex]);
      }
    }
    const halfLength = Math.floor(alphabet.length / 2);
    while (ret.length < this.minLength) {
      alphabet = shuffle(alphabet, alphabet);
      ret.unshift(...alphabet.slice(halfLength));
      ret.push(...alphabet.slice(0, halfLength));
      const excess = ret.length - this.minLength;
      if (excess > 0) {
        const halfOfExcess = excess / 2;
        ret = ret.slice(halfOfExcess, halfOfExcess + this.minLength);
      }
    }
    return ret;
  }
  _decode(id) {
    if (!this.isValidId(id)) {
      throw new Error(`The provided ID (${id}) is invalid, as it contains characters that do not exist in the alphabet (${this.guards.join("")}${this.seps.join("")}${this.alphabet.join("")})`);
    }
    const idGuardsArray = id.split(this.guardsRegExp);
    const splitIndex = idGuardsArray.length === 3 || idGuardsArray.length === 2 ? 1 : 0;
    const idBreakdown = idGuardsArray[splitIndex];
    if (idBreakdown.length === 0)
      return [];
    const lotteryChar = idBreakdown[Symbol.iterator]().next().value;
    const idArray = idBreakdown.slice(lotteryChar.length).split(this.sepsRegExp);
    let lastAlphabet = this.alphabet;
    const result = [];
    for (const subId of idArray) {
      const buffer2 = [lotteryChar, ...this.salt, ...lastAlphabet];
      const nextAlphabet = shuffle(lastAlphabet, buffer2.slice(0, lastAlphabet.length));
      result.push(fromAlphabet(Array.from(subId), nextAlphabet));
      lastAlphabet = nextAlphabet;
    }
    if (this._encode(result).join("") !== id)
      return [];
    return result;
  }
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var localforage = { exports: {} };
var hasRequiredLocalforage;
function requireLocalforage() {
  if (hasRequiredLocalforage) return localforage.exports;
  hasRequiredLocalforage = 1;
  (function(module2, exports2) {
    (function(f) {
      {
        module2.exports = f();
      }
    })(function() {
      return (function e(t16, n12, r12) {
        function s12(o12, u) {
          if (!n12[o12]) {
            if (!t16[o12]) {
              var a = typeof commonjsRequire == "function" && commonjsRequire;
              if (!u && a) return a(o12, true);
              if (i) return i(o12, true);
              var f = new Error("Cannot find module '" + o12 + "'");
              throw f.code = "MODULE_NOT_FOUND", f;
            }
            var l2 = n12[o12] = { exports: {} };
            t16[o12][0].call(l2.exports, function(e12) {
              var n13 = t16[o12][1][e12];
              return s12(n13 ? n13 : e12);
            }, l2, l2.exports, e, t16, n12, r12);
          }
          return n12[o12].exports;
        }
        var i = typeof commonjsRequire == "function" && commonjsRequire;
        for (var o = 0; o < r12.length; o++) s12(r12[o]);
        return s12;
      })({ 1: [function(_dereq_, module3, exports3) {
        (function(global2) {
          var Mutation = global2.MutationObserver || global2.WebKitMutationObserver;
          var scheduleDrain;
          {
            if (Mutation) {
              var called = 0;
              var observer = new Mutation(nextTick2);
              var element = global2.document.createTextNode("");
              observer.observe(element, {
                characterData: true
              });
              scheduleDrain = function() {
                element.data = called = ++called % 2;
              };
            } else if (!global2.setImmediate && typeof global2.MessageChannel !== "undefined") {
              var channel = new global2.MessageChannel();
              channel.port1.onmessage = nextTick2;
              scheduleDrain = function() {
                channel.port2.postMessage(0);
              };
            } else if ("document" in global2 && "onreadystatechange" in global2.document.createElement("script")) {
              scheduleDrain = function() {
                var scriptEl = global2.document.createElement("script");
                scriptEl.onreadystatechange = function() {
                  nextTick2();
                  scriptEl.onreadystatechange = null;
                  scriptEl.parentNode.removeChild(scriptEl);
                  scriptEl = null;
                };
                global2.document.documentElement.appendChild(scriptEl);
              };
            } else {
              scheduleDrain = function() {
                setTimeout(nextTick2, 0);
              };
            }
          }
          var draining;
          var queue2 = [];
          function nextTick2() {
            draining = true;
            var i, oldQueue;
            var len = queue2.length;
            while (len) {
              oldQueue = queue2;
              queue2 = [];
              i = -1;
              while (++i < len) {
                oldQueue[i]();
              }
              len = queue2.length;
            }
            draining = false;
          }
          module3.exports = immediate;
          function immediate(task) {
            if (queue2.push(task) === 1 && !draining) {
              scheduleDrain();
            }
          }
        }).call(this, typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
      }, {}], 2: [function(_dereq_, module3, exports3) {
        var immediate = _dereq_(1);
        function INTERNAL() {
        }
        var handlers = {};
        var REJECTED = ["REJECTED"];
        var FULFILLED = ["FULFILLED"];
        var PENDING = ["PENDING"];
        module3.exports = Promise2;
        function Promise2(resolver) {
          if (typeof resolver !== "function") {
            throw new TypeError("resolver must be a function");
          }
          this.state = PENDING;
          this.queue = [];
          this.outcome = void 0;
          if (resolver !== INTERNAL) {
            safelyResolveThenable(this, resolver);
          }
        }
        Promise2.prototype["catch"] = function(onRejected) {
          return this.then(null, onRejected);
        };
        Promise2.prototype.then = function(onFulfilled, onRejected) {
          if (typeof onFulfilled !== "function" && this.state === FULFILLED || typeof onRejected !== "function" && this.state === REJECTED) {
            return this;
          }
          var promise = new this.constructor(INTERNAL);
          if (this.state !== PENDING) {
            var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
            unwrap(promise, resolver, this.outcome);
          } else {
            this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
          }
          return promise;
        };
        function QueueItem(promise, onFulfilled, onRejected) {
          this.promise = promise;
          if (typeof onFulfilled === "function") {
            this.onFulfilled = onFulfilled;
            this.callFulfilled = this.otherCallFulfilled;
          }
          if (typeof onRejected === "function") {
            this.onRejected = onRejected;
            this.callRejected = this.otherCallRejected;
          }
        }
        QueueItem.prototype.callFulfilled = function(value) {
          handlers.resolve(this.promise, value);
        };
        QueueItem.prototype.otherCallFulfilled = function(value) {
          unwrap(this.promise, this.onFulfilled, value);
        };
        QueueItem.prototype.callRejected = function(value) {
          handlers.reject(this.promise, value);
        };
        QueueItem.prototype.otherCallRejected = function(value) {
          unwrap(this.promise, this.onRejected, value);
        };
        function unwrap(promise, func, value) {
          immediate(function() {
            var returnValue;
            try {
              returnValue = func(value);
            } catch (e) {
              return handlers.reject(promise, e);
            }
            if (returnValue === promise) {
              handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
            } else {
              handlers.resolve(promise, returnValue);
            }
          });
        }
        handlers.resolve = function(self2, value) {
          var result = tryCatch(getThen, value);
          if (result.status === "error") {
            return handlers.reject(self2, result.value);
          }
          var thenable = result.value;
          if (thenable) {
            safelyResolveThenable(self2, thenable);
          } else {
            self2.state = FULFILLED;
            self2.outcome = value;
            var i = -1;
            var len = self2.queue.length;
            while (++i < len) {
              self2.queue[i].callFulfilled(value);
            }
          }
          return self2;
        };
        handlers.reject = function(self2, error) {
          self2.state = REJECTED;
          self2.outcome = error;
          var i = -1;
          var len = self2.queue.length;
          while (++i < len) {
            self2.queue[i].callRejected(error);
          }
          return self2;
        };
        function getThen(obj) {
          var then = obj && obj.then;
          if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") {
            return function appyThen() {
              then.apply(obj, arguments);
            };
          }
        }
        function safelyResolveThenable(self2, thenable) {
          var called = false;
          function onError(value) {
            if (called) {
              return;
            }
            called = true;
            handlers.reject(self2, value);
          }
          function onSuccess(value) {
            if (called) {
              return;
            }
            called = true;
            handlers.resolve(self2, value);
          }
          function tryToUnwrap() {
            thenable(onSuccess, onError);
          }
          var result = tryCatch(tryToUnwrap);
          if (result.status === "error") {
            onError(result.value);
          }
        }
        function tryCatch(func, value) {
          var out = {};
          try {
            out.value = func(value);
            out.status = "success";
          } catch (e) {
            out.status = "error";
            out.value = e;
          }
          return out;
        }
        Promise2.resolve = resolve2;
        function resolve2(value) {
          if (value instanceof this) {
            return value;
          }
          return handlers.resolve(new this(INTERNAL), value);
        }
        Promise2.reject = reject;
        function reject(reason) {
          var promise = new this(INTERNAL);
          return handlers.reject(promise, reason);
        }
        Promise2.all = all;
        function all(iterable) {
          var self2 = this;
          if (Object.prototype.toString.call(iterable) !== "[object Array]") {
            return this.reject(new TypeError("must be an array"));
          }
          var len = iterable.length;
          var called = false;
          if (!len) {
            return this.resolve([]);
          }
          var values2 = new Array(len);
          var resolved = 0;
          var i = -1;
          var promise = new this(INTERNAL);
          while (++i < len) {
            allResolver(iterable[i], i);
          }
          return promise;
          function allResolver(value, i12) {
            self2.resolve(value).then(resolveFromAll, function(error) {
              if (!called) {
                called = true;
                handlers.reject(promise, error);
              }
            });
            function resolveFromAll(outValue) {
              values2[i12] = outValue;
              if (++resolved === len && !called) {
                called = true;
                handlers.resolve(promise, values2);
              }
            }
          }
        }
        Promise2.race = race;
        function race(iterable) {
          var self2 = this;
          if (Object.prototype.toString.call(iterable) !== "[object Array]") {
            return this.reject(new TypeError("must be an array"));
          }
          var len = iterable.length;
          var called = false;
          if (!len) {
            return this.resolve([]);
          }
          var i = -1;
          var promise = new this(INTERNAL);
          while (++i < len) {
            resolver(iterable[i]);
          }
          return promise;
          function resolver(value) {
            self2.resolve(value).then(function(response) {
              if (!called) {
                called = true;
                handlers.resolve(promise, response);
              }
            }, function(error) {
              if (!called) {
                called = true;
                handlers.reject(promise, error);
              }
            });
          }
        }
      }, { "1": 1 }], 3: [function(_dereq_, module3, exports3) {
        (function(global2) {
          if (typeof global2.Promise !== "function") {
            global2.Promise = _dereq_(2);
          }
        }).call(this, typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
      }, { "2": 2 }], 4: [function(_dereq_, module3, exports3) {
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
          return typeof obj;
        } : function(obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function getIDB() {
          try {
            if (typeof indexedDB !== "undefined") {
              return indexedDB;
            }
            if (typeof webkitIndexedDB !== "undefined") {
              return webkitIndexedDB;
            }
            if (typeof mozIndexedDB !== "undefined") {
              return mozIndexedDB;
            }
            if (typeof OIndexedDB !== "undefined") {
              return OIndexedDB;
            }
            if (typeof msIndexedDB !== "undefined") {
              return msIndexedDB;
            }
          } catch (e) {
            return;
          }
        }
        var idb = getIDB();
        function isIndexedDBValid() {
          try {
            if (!idb || !idb.open) {
              return false;
            }
            var isSafari2 = typeof openDatabase !== "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
            var hasFetch = typeof fetch === "function" && fetch.toString().indexOf("[native code") !== -1;
            return (!isSafari2 || hasFetch) && typeof indexedDB !== "undefined" && // some outdated implementations of IDB that appear on Samsung
            // and HTC Android devices <4.4 are missing IDBKeyRange
            // See: https://github.com/mozilla/localForage/issues/128
            // See: https://github.com/mozilla/localForage/issues/272
            typeof IDBKeyRange !== "undefined";
          } catch (e) {
            return false;
          }
        }
        function createBlob(parts, properties2) {
          parts = parts || [];
          properties2 = properties2 || {};
          try {
            return new Blob(parts, properties2);
          } catch (e) {
            if (e.name !== "TypeError") {
              throw e;
            }
            var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
            var builder = new Builder();
            for (var i = 0; i < parts.length; i += 1) {
              builder.append(parts[i]);
            }
            return builder.getBlob(properties2.type);
          }
        }
        if (typeof Promise === "undefined") {
          _dereq_(3);
        }
        var Promise$12 = Promise;
        function executeCallback2(promise, callback) {
          if (callback) {
            promise.then(function(result) {
              callback(null, result);
            }, function(error) {
              callback(error);
            });
          }
        }
        function executeTwoCallbacks(promise, callback, errorCallback) {
          if (typeof callback === "function") {
            promise.then(callback);
          }
          if (typeof errorCallback === "function") {
            promise["catch"](errorCallback);
          }
        }
        function normalizeKey2(key2) {
          if (typeof key2 !== "string") {
            console.warn(key2 + " used as a key, but it is not a string.");
            key2 = String(key2);
          }
          return key2;
        }
        function getCallback() {
          if (arguments.length && typeof arguments[arguments.length - 1] === "function") {
            return arguments[arguments.length - 1];
          }
        }
        var DETECT_BLOB_SUPPORT_STORE = "local-forage-detect-blob-support";
        var supportsBlobs = void 0;
        var dbContexts = {};
        var toString4 = Object.prototype.toString;
        var READ_ONLY = "readonly";
        var READ_WRITE = "readwrite";
        function _binStringToArrayBuffer(bin) {
          var length3 = bin.length;
          var buf = new ArrayBuffer(length3);
          var arr = new Uint8Array(buf);
          for (var i = 0; i < length3; i++) {
            arr[i] = bin.charCodeAt(i);
          }
          return buf;
        }
        function _checkBlobSupportWithoutCaching(idb2) {
          return new Promise$12(function(resolve2) {
            var txn = idb2.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
            var blob = createBlob([""]);
            txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, "key");
            txn.onabort = function(e) {
              e.preventDefault();
              e.stopPropagation();
              resolve2(false);
            };
            txn.oncomplete = function() {
              var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
              var matchedEdge = navigator.userAgent.match(/Edge\//);
              resolve2(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
            };
          })["catch"](function() {
            return false;
          });
        }
        function _checkBlobSupport(idb2) {
          if (typeof supportsBlobs === "boolean") {
            return Promise$12.resolve(supportsBlobs);
          }
          return _checkBlobSupportWithoutCaching(idb2).then(function(value) {
            supportsBlobs = value;
            return supportsBlobs;
          });
        }
        function _deferReadiness(dbInfo) {
          var dbContext = dbContexts[dbInfo.name];
          var deferredOperation = {};
          deferredOperation.promise = new Promise$12(function(resolve2, reject) {
            deferredOperation.resolve = resolve2;
            deferredOperation.reject = reject;
          });
          dbContext.deferredOperations.push(deferredOperation);
          if (!dbContext.dbReady) {
            dbContext.dbReady = deferredOperation.promise;
          } else {
            dbContext.dbReady = dbContext.dbReady.then(function() {
              return deferredOperation.promise;
            });
          }
        }
        function _advanceReadiness(dbInfo) {
          var dbContext = dbContexts[dbInfo.name];
          var deferredOperation = dbContext.deferredOperations.pop();
          if (deferredOperation) {
            deferredOperation.resolve();
            return deferredOperation.promise;
          }
        }
        function _rejectReadiness(dbInfo, err) {
          var dbContext = dbContexts[dbInfo.name];
          var deferredOperation = dbContext.deferredOperations.pop();
          if (deferredOperation) {
            deferredOperation.reject(err);
            return deferredOperation.promise;
          }
        }
        function _getConnection(dbInfo, upgradeNeeded) {
          return new Promise$12(function(resolve2, reject) {
            dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
            if (dbInfo.db) {
              if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
              } else {
                return resolve2(dbInfo.db);
              }
            }
            var dbArgs = [dbInfo.name];
            if (upgradeNeeded) {
              dbArgs.push(dbInfo.version);
            }
            var openreq = idb.open.apply(idb, dbArgs);
            if (upgradeNeeded) {
              openreq.onupgradeneeded = function(e) {
                var db2 = openreq.result;
                try {
                  db2.createObjectStore(dbInfo.storeName);
                  if (e.oldVersion <= 1) {
                    db2.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                  }
                } catch (ex2) {
                  if (ex2.name === "ConstraintError") {
                    console.warn('The database "' + dbInfo.name + '" has been upgraded from version ' + e.oldVersion + " to version " + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                  } else {
                    throw ex2;
                  }
                }
              };
            }
            openreq.onerror = function(e) {
              e.preventDefault();
              reject(openreq.error);
            };
            openreq.onsuccess = function() {
              var db2 = openreq.result;
              db2.onversionchange = function(e) {
                e.target.close();
              };
              resolve2(db2);
              _advanceReadiness(dbInfo);
            };
          });
        }
        function _getOriginalConnection(dbInfo) {
          return _getConnection(dbInfo, false);
        }
        function _getUpgradedConnection(dbInfo) {
          return _getConnection(dbInfo, true);
        }
        function _isUpgradeNeeded(dbInfo, defaultVersion) {
          if (!dbInfo.db) {
            return true;
          }
          var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
          var isDowngrade = dbInfo.version < dbInfo.db.version;
          var isUpgrade = dbInfo.version > dbInfo.db.version;
          if (isDowngrade) {
            if (dbInfo.version !== defaultVersion) {
              console.warn('The database "' + dbInfo.name + `" can't be downgraded from version ` + dbInfo.db.version + " to version " + dbInfo.version + ".");
            }
            dbInfo.version = dbInfo.db.version;
          }
          if (isUpgrade || isNewStore) {
            if (isNewStore) {
              var incVersion = dbInfo.db.version + 1;
              if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
              }
            }
            return true;
          }
          return false;
        }
        function _encodeBlob(blob) {
          return new Promise$12(function(resolve2, reject) {
            var reader = new FileReader();
            reader.onerror = reject;
            reader.onloadend = function(e) {
              var base64 = btoa(e.target.result || "");
              resolve2({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
              });
            };
            reader.readAsBinaryString(blob);
          });
        }
        function _decodeBlob(encodedBlob) {
          var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
          return createBlob([arrayBuff], { type: encodedBlob.type });
        }
        function _isEncodedBlob(value) {
          return value && value.__local_forage_encoded_blob;
        }
        function _fullyReady(callback) {
          var self2 = this;
          var promise = self2._initReady().then(function() {
            var dbContext = dbContexts[self2._dbInfo.name];
            if (dbContext && dbContext.dbReady) {
              return dbContext.dbReady;
            }
          });
          executeTwoCallbacks(promise, callback, callback);
          return promise;
        }
        function _tryReconnect(dbInfo) {
          _deferReadiness(dbInfo);
          var dbContext = dbContexts[dbInfo.name];
          var forages = dbContext.forages;
          for (var i = 0; i < forages.length; i++) {
            var forage = forages[i];
            if (forage._dbInfo.db) {
              forage._dbInfo.db.close();
              forage._dbInfo.db = null;
            }
          }
          dbInfo.db = null;
          return _getOriginalConnection(dbInfo).then(function(db2) {
            dbInfo.db = db2;
            if (_isUpgradeNeeded(dbInfo)) {
              return _getUpgradedConnection(dbInfo);
            }
            return db2;
          }).then(function(db2) {
            dbInfo.db = dbContext.db = db2;
            for (var i12 = 0; i12 < forages.length; i12++) {
              forages[i12]._dbInfo.db = db2;
            }
          })["catch"](function(err) {
            _rejectReadiness(dbInfo, err);
            throw err;
          });
        }
        function createTransaction(dbInfo, mode, callback, retries) {
          if (retries === void 0) {
            retries = 1;
          }
          try {
            var tx2 = dbInfo.db.transaction(dbInfo.storeName, mode);
            callback(null, tx2);
          } catch (err) {
            if (retries > 0 && (!dbInfo.db || err.name === "InvalidStateError" || err.name === "NotFoundError")) {
              return Promise$12.resolve().then(function() {
                if (!dbInfo.db || err.name === "NotFoundError" && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                  if (dbInfo.db) {
                    dbInfo.version = dbInfo.db.version + 1;
                  }
                  return _getUpgradedConnection(dbInfo);
                }
              }).then(function() {
                return _tryReconnect(dbInfo).then(function() {
                  createTransaction(dbInfo, mode, callback, retries - 1);
                });
              })["catch"](callback);
            }
            callback(err);
          }
        }
        function createDbContext() {
          return {
            // Running localForages sharing a database.
            forages: [],
            // Shared database.
            db: null,
            // Database readiness (promise).
            dbReady: null,
            // Deferred operations on the database.
            deferredOperations: []
          };
        }
        function _initStorage(options) {
          var self2 = this;
          var dbInfo = {
            db: null
          };
          if (options) {
            for (var i in options) {
              dbInfo[i] = options[i];
            }
          }
          var dbContext = dbContexts[dbInfo.name];
          if (!dbContext) {
            dbContext = createDbContext();
            dbContexts[dbInfo.name] = dbContext;
          }
          dbContext.forages.push(self2);
          if (!self2._initReady) {
            self2._initReady = self2.ready;
            self2.ready = _fullyReady;
          }
          var initPromises = [];
          function ignoreErrors() {
            return Promise$12.resolve();
          }
          for (var j = 0; j < dbContext.forages.length; j++) {
            var forage = dbContext.forages[j];
            if (forage !== self2) {
              initPromises.push(forage._initReady()["catch"](ignoreErrors));
            }
          }
          var forages = dbContext.forages.slice(0);
          return Promise$12.all(initPromises).then(function() {
            dbInfo.db = dbContext.db;
            return _getOriginalConnection(dbInfo);
          }).then(function(db2) {
            dbInfo.db = db2;
            if (_isUpgradeNeeded(dbInfo, self2._defaultConfig.version)) {
              return _getUpgradedConnection(dbInfo);
            }
            return db2;
          }).then(function(db2) {
            dbInfo.db = dbContext.db = db2;
            self2._dbInfo = dbInfo;
            for (var k = 0; k < forages.length; k++) {
              var forage2 = forages[k];
              if (forage2 !== self2) {
                forage2._dbInfo.db = dbInfo.db;
                forage2._dbInfo.version = dbInfo.version;
              }
            }
          });
        }
        function getItem(key2, callback) {
          var self2 = this;
          key2 = normalizeKey2(key2);
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                if (err) {
                  return reject(err);
                }
                try {
                  var store2 = transaction.objectStore(self2._dbInfo.storeName);
                  var req = store2.get(key2);
                  req.onsuccess = function() {
                    var value = req.result;
                    if (value === void 0) {
                      value = null;
                    }
                    if (_isEncodedBlob(value)) {
                      value = _decodeBlob(value);
                    }
                    resolve2(value);
                  };
                  req.onerror = function() {
                    reject(req.error);
                  };
                } catch (e) {
                  reject(e);
                }
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function iterate(iterator2, callback) {
          var self2 = this;
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                if (err) {
                  return reject(err);
                }
                try {
                  var store2 = transaction.objectStore(self2._dbInfo.storeName);
                  var req = store2.openCursor();
                  var iterationNumber = 1;
                  req.onsuccess = function() {
                    var cursor2 = req.result;
                    if (cursor2) {
                      var value = cursor2.value;
                      if (_isEncodedBlob(value)) {
                        value = _decodeBlob(value);
                      }
                      var result = iterator2(value, cursor2.key, iterationNumber++);
                      if (result !== void 0) {
                        resolve2(result);
                      } else {
                        cursor2["continue"]();
                      }
                    } else {
                      resolve2();
                    }
                  };
                  req.onerror = function() {
                    reject(req.error);
                  };
                } catch (e) {
                  reject(e);
                }
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function setItem(key2, value, callback) {
          var self2 = this;
          key2 = normalizeKey2(key2);
          var promise = new Promise$12(function(resolve2, reject) {
            var dbInfo;
            self2.ready().then(function() {
              dbInfo = self2._dbInfo;
              if (toString4.call(value) === "[object Blob]") {
                return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                  if (blobSupport) {
                    return value;
                  }
                  return _encodeBlob(value);
                });
              }
              return value;
            }).then(function(value2) {
              createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
                if (err) {
                  return reject(err);
                }
                try {
                  var store2 = transaction.objectStore(self2._dbInfo.storeName);
                  if (value2 === null) {
                    value2 = void 0;
                  }
                  var req = store2.put(value2, key2);
                  transaction.oncomplete = function() {
                    if (value2 === void 0) {
                      value2 = null;
                    }
                    resolve2(value2);
                  };
                  transaction.onabort = transaction.onerror = function() {
                    var err2 = req.error ? req.error : req.transaction.error;
                    reject(err2);
                  };
                } catch (e) {
                  reject(e);
                }
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function removeItem(key2, callback) {
          var self2 = this;
          key2 = normalizeKey2(key2);
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
                if (err) {
                  return reject(err);
                }
                try {
                  var store2 = transaction.objectStore(self2._dbInfo.storeName);
                  var req = store2["delete"](key2);
                  transaction.oncomplete = function() {
                    resolve2();
                  };
                  transaction.onerror = function() {
                    reject(req.error);
                  };
                  transaction.onabort = function() {
                    var err2 = req.error ? req.error : req.transaction.error;
                    reject(err2);
                  };
                } catch (e) {
                  reject(e);
                }
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function clear(callback) {
          var self2 = this;
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
                if (err) {
                  return reject(err);
                }
                try {
                  var store2 = transaction.objectStore(self2._dbInfo.storeName);
                  var req = store2.clear();
                  transaction.oncomplete = function() {
                    resolve2();
                  };
                  transaction.onabort = transaction.onerror = function() {
                    var err2 = req.error ? req.error : req.transaction.error;
                    reject(err2);
                  };
                } catch (e) {
                  reject(e);
                }
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function length2(callback) {
          var self2 = this;
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                if (err) {
                  return reject(err);
                }
                try {
                  var store2 = transaction.objectStore(self2._dbInfo.storeName);
                  var req = store2.count();
                  req.onsuccess = function() {
                    resolve2(req.result);
                  };
                  req.onerror = function() {
                    reject(req.error);
                  };
                } catch (e) {
                  reject(e);
                }
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function key(n12, callback) {
          var self2 = this;
          var promise = new Promise$12(function(resolve2, reject) {
            if (n12 < 0) {
              resolve2(null);
              return;
            }
            self2.ready().then(function() {
              createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                if (err) {
                  return reject(err);
                }
                try {
                  var store2 = transaction.objectStore(self2._dbInfo.storeName);
                  var advanced = false;
                  var req = store2.openKeyCursor();
                  req.onsuccess = function() {
                    var cursor2 = req.result;
                    if (!cursor2) {
                      resolve2(null);
                      return;
                    }
                    if (n12 === 0) {
                      resolve2(cursor2.key);
                    } else {
                      if (!advanced) {
                        advanced = true;
                        cursor2.advance(n12);
                      } else {
                        resolve2(cursor2.key);
                      }
                    }
                  };
                  req.onerror = function() {
                    reject(req.error);
                  };
                } catch (e) {
                  reject(e);
                }
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function keys2(callback) {
          var self2 = this;
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                if (err) {
                  return reject(err);
                }
                try {
                  var store2 = transaction.objectStore(self2._dbInfo.storeName);
                  var req = store2.openKeyCursor();
                  var keys3 = [];
                  req.onsuccess = function() {
                    var cursor2 = req.result;
                    if (!cursor2) {
                      resolve2(keys3);
                      return;
                    }
                    keys3.push(cursor2.key);
                    cursor2["continue"]();
                  };
                  req.onerror = function() {
                    reject(req.error);
                  };
                } catch (e) {
                  reject(e);
                }
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function dropInstance(options, callback) {
          callback = getCallback.apply(this, arguments);
          var currentConfig = this.config();
          options = typeof options !== "function" && options || {};
          if (!options.name) {
            options.name = options.name || currentConfig.name;
            options.storeName = options.storeName || currentConfig.storeName;
          }
          var self2 = this;
          var promise;
          if (!options.name) {
            promise = Promise$12.reject("Invalid arguments");
          } else {
            var isCurrentDb = options.name === currentConfig.name && self2._dbInfo.db;
            var dbPromise = isCurrentDb ? Promise$12.resolve(self2._dbInfo.db) : _getOriginalConnection(options).then(function(db2) {
              var dbContext = dbContexts[options.name];
              var forages = dbContext.forages;
              dbContext.db = db2;
              for (var i = 0; i < forages.length; i++) {
                forages[i]._dbInfo.db = db2;
              }
              return db2;
            });
            if (!options.storeName) {
              promise = dbPromise.then(function(db2) {
                _deferReadiness(options);
                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;
                db2.close();
                for (var i = 0; i < forages.length; i++) {
                  var forage = forages[i];
                  forage._dbInfo.db = null;
                }
                var dropDBPromise = new Promise$12(function(resolve2, reject) {
                  var req = idb.deleteDatabase(options.name);
                  req.onerror = function() {
                    var db3 = req.result;
                    if (db3) {
                      db3.close();
                    }
                    reject(req.error);
                  };
                  req.onblocked = function() {
                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                  };
                  req.onsuccess = function() {
                    var db3 = req.result;
                    if (db3) {
                      db3.close();
                    }
                    resolve2(db3);
                  };
                });
                return dropDBPromise.then(function(db3) {
                  dbContext.db = db3;
                  for (var i12 = 0; i12 < forages.length; i12++) {
                    var _forage = forages[i12];
                    _advanceReadiness(_forage._dbInfo);
                  }
                })["catch"](function(err) {
                  (_rejectReadiness(options, err) || Promise$12.resolve())["catch"](function() {
                  });
                  throw err;
                });
              });
            } else {
              promise = dbPromise.then(function(db2) {
                if (!db2.objectStoreNames.contains(options.storeName)) {
                  return;
                }
                var newVersion = db2.version + 1;
                _deferReadiness(options);
                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;
                db2.close();
                for (var i = 0; i < forages.length; i++) {
                  var forage = forages[i];
                  forage._dbInfo.db = null;
                  forage._dbInfo.version = newVersion;
                }
                var dropObjectPromise = new Promise$12(function(resolve2, reject) {
                  var req = idb.open(options.name, newVersion);
                  req.onerror = function(err) {
                    var db3 = req.result;
                    db3.close();
                    reject(err);
                  };
                  req.onupgradeneeded = function() {
                    var db3 = req.result;
                    db3.deleteObjectStore(options.storeName);
                  };
                  req.onsuccess = function() {
                    var db3 = req.result;
                    db3.close();
                    resolve2(db3);
                  };
                });
                return dropObjectPromise.then(function(db3) {
                  dbContext.db = db3;
                  for (var j = 0; j < forages.length; j++) {
                    var _forage2 = forages[j];
                    _forage2._dbInfo.db = db3;
                    _advanceReadiness(_forage2._dbInfo);
                  }
                })["catch"](function(err) {
                  (_rejectReadiness(options, err) || Promise$12.resolve())["catch"](function() {
                  });
                  throw err;
                });
              });
            }
          }
          executeCallback2(promise, callback);
          return promise;
        }
        var asyncStorage = {
          _driver: "asyncStorage",
          _initStorage,
          _support: isIndexedDBValid(),
          iterate,
          getItem,
          setItem,
          removeItem,
          clear,
          length: length2,
          key,
          keys: keys2,
          dropInstance
        };
        function isWebSQLValid() {
          return typeof openDatabase === "function";
        }
        var BASE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var BLOB_TYPE_PREFIX = "~~local_forage_type~";
        var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
        var SERIALIZED_MARKER = "__lfsc__:";
        var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
        var TYPE_ARRAYBUFFER = "arbf";
        var TYPE_BLOB = "blob";
        var TYPE_INT8ARRAY = "si08";
        var TYPE_UINT8ARRAY = "ui08";
        var TYPE_UINT8CLAMPEDARRAY = "uic8";
        var TYPE_INT16ARRAY = "si16";
        var TYPE_INT32ARRAY = "si32";
        var TYPE_UINT16ARRAY = "ur16";
        var TYPE_UINT32ARRAY = "ui32";
        var TYPE_FLOAT32ARRAY = "fl32";
        var TYPE_FLOAT64ARRAY = "fl64";
        var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
        var toString$12 = Object.prototype.toString;
        function stringToBuffer(serializedString) {
          var bufferLength = serializedString.length * 0.75;
          var len = serializedString.length;
          var i;
          var p = 0;
          var encoded1, encoded2, encoded3, encoded4;
          if (serializedString[serializedString.length - 1] === "=") {
            bufferLength--;
            if (serializedString[serializedString.length - 2] === "=") {
              bufferLength--;
            }
          }
          var buffer2 = new ArrayBuffer(bufferLength);
          var bytes = new Uint8Array(buffer2);
          for (i = 0; i < len; i += 4) {
            encoded1 = BASE_CHARS.indexOf(serializedString[i]);
            encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
            encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
            encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
          }
          return buffer2;
        }
        function bufferToString(buffer2) {
          var bytes = new Uint8Array(buffer2);
          var base64String = "";
          var i;
          for (i = 0; i < bytes.length; i += 3) {
            base64String += BASE_CHARS[bytes[i] >> 2];
            base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
            base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
            base64String += BASE_CHARS[bytes[i + 2] & 63];
          }
          if (bytes.length % 3 === 2) {
            base64String = base64String.substring(0, base64String.length - 1) + "=";
          } else if (bytes.length % 3 === 1) {
            base64String = base64String.substring(0, base64String.length - 2) + "==";
          }
          return base64String;
        }
        function serialize2(value, callback) {
          var valueType = "";
          if (value) {
            valueType = toString$12.call(value);
          }
          if (value && (valueType === "[object ArrayBuffer]" || value.buffer && toString$12.call(value.buffer) === "[object ArrayBuffer]")) {
            var buffer2;
            var marker = SERIALIZED_MARKER;
            if (value instanceof ArrayBuffer) {
              buffer2 = value;
              marker += TYPE_ARRAYBUFFER;
            } else {
              buffer2 = value.buffer;
              if (valueType === "[object Int8Array]") {
                marker += TYPE_INT8ARRAY;
              } else if (valueType === "[object Uint8Array]") {
                marker += TYPE_UINT8ARRAY;
              } else if (valueType === "[object Uint8ClampedArray]") {
                marker += TYPE_UINT8CLAMPEDARRAY;
              } else if (valueType === "[object Int16Array]") {
                marker += TYPE_INT16ARRAY;
              } else if (valueType === "[object Uint16Array]") {
                marker += TYPE_UINT16ARRAY;
              } else if (valueType === "[object Int32Array]") {
                marker += TYPE_INT32ARRAY;
              } else if (valueType === "[object Uint32Array]") {
                marker += TYPE_UINT32ARRAY;
              } else if (valueType === "[object Float32Array]") {
                marker += TYPE_FLOAT32ARRAY;
              } else if (valueType === "[object Float64Array]") {
                marker += TYPE_FLOAT64ARRAY;
              } else {
                callback(new Error("Failed to get type for BinaryArray"));
              }
            }
            callback(marker + bufferToString(buffer2));
          } else if (valueType === "[object Blob]") {
            var fileReader = new FileReader();
            fileReader.onload = function() {
              var str = BLOB_TYPE_PREFIX + value.type + "~" + bufferToString(this.result);
              callback(SERIALIZED_MARKER + TYPE_BLOB + str);
            };
            fileReader.readAsArrayBuffer(value);
          } else {
            try {
              callback(JSON.stringify(value));
            } catch (e) {
              console.error("Couldn't convert value into a JSON string: ", value);
              callback(null, e);
            }
          }
        }
        function deserialize(value) {
          if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
            return JSON.parse(value);
          }
          var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
          var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
          var blobType;
          if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
            var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
            blobType = matcher[1];
            serializedString = serializedString.substring(matcher[0].length);
          }
          var buffer2 = stringToBuffer(serializedString);
          switch (type) {
            case TYPE_ARRAYBUFFER:
              return buffer2;
            case TYPE_BLOB:
              return createBlob([buffer2], { type: blobType });
            case TYPE_INT8ARRAY:
              return new Int8Array(buffer2);
            case TYPE_UINT8ARRAY:
              return new Uint8Array(buffer2);
            case TYPE_UINT8CLAMPEDARRAY:
              return new Uint8ClampedArray(buffer2);
            case TYPE_INT16ARRAY:
              return new Int16Array(buffer2);
            case TYPE_UINT16ARRAY:
              return new Uint16Array(buffer2);
            case TYPE_INT32ARRAY:
              return new Int32Array(buffer2);
            case TYPE_UINT32ARRAY:
              return new Uint32Array(buffer2);
            case TYPE_FLOAT32ARRAY:
              return new Float32Array(buffer2);
            case TYPE_FLOAT64ARRAY:
              return new Float64Array(buffer2);
            default:
              throw new Error("Unkown type: " + type);
          }
        }
        var localforageSerializer = {
          serialize: serialize2,
          deserialize,
          stringToBuffer,
          bufferToString
        };
        function createDbTable(t16, dbInfo, callback, errorCallback) {
          t16.executeSql("CREATE TABLE IF NOT EXISTS " + dbInfo.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], callback, errorCallback);
        }
        function _initStorage$1(options) {
          var self2 = this;
          var dbInfo = {
            db: null
          };
          if (options) {
            for (var i in options) {
              dbInfo[i] = typeof options[i] !== "string" ? options[i].toString() : options[i];
            }
          }
          var dbInfoPromise = new Promise$12(function(resolve2, reject) {
            try {
              dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
            } catch (e) {
              return reject(e);
            }
            dbInfo.db.transaction(function(t16) {
              createDbTable(t16, dbInfo, function() {
                self2._dbInfo = dbInfo;
                resolve2();
              }, function(t17, error) {
                reject(error);
              });
            }, reject);
          });
          dbInfo.serializer = localforageSerializer;
          return dbInfoPromise;
        }
        function tryExecuteSql(t16, dbInfo, sqlStatement, args, callback, errorCallback) {
          t16.executeSql(sqlStatement, args, callback, function(t17, error) {
            if (error.code === error.SYNTAX_ERR) {
              t17.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [dbInfo.storeName], function(t18, results) {
                if (!results.rows.length) {
                  createDbTable(t18, dbInfo, function() {
                    t18.executeSql(sqlStatement, args, callback, errorCallback);
                  }, errorCallback);
                } else {
                  errorCallback(t18, error);
                }
              }, errorCallback);
            } else {
              errorCallback(t17, error);
            }
          }, errorCallback);
        }
        function getItem$1(key2, callback) {
          var self2 = this;
          key2 = normalizeKey2(key2);
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              dbInfo.db.transaction(function(t16) {
                tryExecuteSql(t16, dbInfo, "SELECT * FROM " + dbInfo.storeName + " WHERE key = ? LIMIT 1", [key2], function(t17, results) {
                  var result = results.rows.length ? results.rows.item(0).value : null;
                  if (result) {
                    result = dbInfo.serializer.deserialize(result);
                  }
                  resolve2(result);
                }, function(t17, error) {
                  reject(error);
                });
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function iterate$1(iterator2, callback) {
          var self2 = this;
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              dbInfo.db.transaction(function(t16) {
                tryExecuteSql(t16, dbInfo, "SELECT * FROM " + dbInfo.storeName, [], function(t17, results) {
                  var rows = results.rows;
                  var length3 = rows.length;
                  for (var i = 0; i < length3; i++) {
                    var item = rows.item(i);
                    var result = item.value;
                    if (result) {
                      result = dbInfo.serializer.deserialize(result);
                    }
                    result = iterator2(result, item.key, i + 1);
                    if (result !== void 0) {
                      resolve2(result);
                      return;
                    }
                  }
                  resolve2();
                }, function(t17, error) {
                  reject(error);
                });
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function _setItem(key2, value, callback, retriesLeft) {
          var self2 = this;
          key2 = normalizeKey2(key2);
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              if (value === void 0) {
                value = null;
              }
              var originalValue = value;
              var dbInfo = self2._dbInfo;
              dbInfo.serializer.serialize(value, function(value2, error) {
                if (error) {
                  reject(error);
                } else {
                  dbInfo.db.transaction(function(t16) {
                    tryExecuteSql(t16, dbInfo, "INSERT OR REPLACE INTO " + dbInfo.storeName + " (key, value) VALUES (?, ?)", [key2, value2], function() {
                      resolve2(originalValue);
                    }, function(t17, error2) {
                      reject(error2);
                    });
                  }, function(sqlError) {
                    if (sqlError.code === sqlError.QUOTA_ERR) {
                      if (retriesLeft > 0) {
                        resolve2(_setItem.apply(self2, [key2, originalValue, callback, retriesLeft - 1]));
                        return;
                      }
                      reject(sqlError);
                    }
                  });
                }
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function setItem$1(key2, value, callback) {
          return _setItem.apply(this, [key2, value, callback, 1]);
        }
        function removeItem$1(key2, callback) {
          var self2 = this;
          key2 = normalizeKey2(key2);
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              dbInfo.db.transaction(function(t16) {
                tryExecuteSql(t16, dbInfo, "DELETE FROM " + dbInfo.storeName + " WHERE key = ?", [key2], function() {
                  resolve2();
                }, function(t17, error) {
                  reject(error);
                });
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function clear$1(callback) {
          var self2 = this;
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              dbInfo.db.transaction(function(t16) {
                tryExecuteSql(t16, dbInfo, "DELETE FROM " + dbInfo.storeName, [], function() {
                  resolve2();
                }, function(t17, error) {
                  reject(error);
                });
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function length$1(callback) {
          var self2 = this;
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              dbInfo.db.transaction(function(t16) {
                tryExecuteSql(t16, dbInfo, "SELECT COUNT(key) as c FROM " + dbInfo.storeName, [], function(t17, results) {
                  var result = results.rows.item(0).c;
                  resolve2(result);
                }, function(t17, error) {
                  reject(error);
                });
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function key$1(n12, callback) {
          var self2 = this;
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              dbInfo.db.transaction(function(t16) {
                tryExecuteSql(t16, dbInfo, "SELECT key FROM " + dbInfo.storeName + " WHERE id = ? LIMIT 1", [n12 + 1], function(t17, results) {
                  var result = results.rows.length ? results.rows.item(0).key : null;
                  resolve2(result);
                }, function(t17, error) {
                  reject(error);
                });
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function keys$1(callback) {
          var self2 = this;
          var promise = new Promise$12(function(resolve2, reject) {
            self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              dbInfo.db.transaction(function(t16) {
                tryExecuteSql(t16, dbInfo, "SELECT key FROM " + dbInfo.storeName, [], function(t17, results) {
                  var keys3 = [];
                  for (var i = 0; i < results.rows.length; i++) {
                    keys3.push(results.rows.item(i).key);
                  }
                  resolve2(keys3);
                }, function(t17, error) {
                  reject(error);
                });
              });
            })["catch"](reject);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function getAllStoreNames(db2) {
          return new Promise$12(function(resolve2, reject) {
            db2.transaction(function(t16) {
              t16.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t17, results) {
                var storeNames = [];
                for (var i = 0; i < results.rows.length; i++) {
                  storeNames.push(results.rows.item(i).name);
                }
                resolve2({
                  db: db2,
                  storeNames
                });
              }, function(t17, error) {
                reject(error);
              });
            }, function(sqlError) {
              reject(sqlError);
            });
          });
        }
        function dropInstance$1(options, callback) {
          callback = getCallback.apply(this, arguments);
          var currentConfig = this.config();
          options = typeof options !== "function" && options || {};
          if (!options.name) {
            options.name = options.name || currentConfig.name;
            options.storeName = options.storeName || currentConfig.storeName;
          }
          var self2 = this;
          var promise;
          if (!options.name) {
            promise = Promise$12.reject("Invalid arguments");
          } else {
            promise = new Promise$12(function(resolve2) {
              var db2;
              if (options.name === currentConfig.name) {
                db2 = self2._dbInfo.db;
              } else {
                db2 = openDatabase(options.name, "", "", 0);
              }
              if (!options.storeName) {
                resolve2(getAllStoreNames(db2));
              } else {
                resolve2({
                  db: db2,
                  storeNames: [options.storeName]
                });
              }
            }).then(function(operationInfo) {
              return new Promise$12(function(resolve2, reject) {
                operationInfo.db.transaction(function(t16) {
                  function dropTable(storeName) {
                    return new Promise$12(function(resolve3, reject2) {
                      t16.executeSql("DROP TABLE IF EXISTS " + storeName, [], function() {
                        resolve3();
                      }, function(t17, error) {
                        reject2(error);
                      });
                    });
                  }
                  var operations = [];
                  for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                    operations.push(dropTable(operationInfo.storeNames[i]));
                  }
                  Promise$12.all(operations).then(function() {
                    resolve2();
                  })["catch"](function(e) {
                    reject(e);
                  });
                }, function(sqlError) {
                  reject(sqlError);
                });
              });
            });
          }
          executeCallback2(promise, callback);
          return promise;
        }
        var webSQLStorage = {
          _driver: "webSQLStorage",
          _initStorage: _initStorage$1,
          _support: isWebSQLValid(),
          iterate: iterate$1,
          getItem: getItem$1,
          setItem: setItem$1,
          removeItem: removeItem$1,
          clear: clear$1,
          length: length$1,
          key: key$1,
          keys: keys$1,
          dropInstance: dropInstance$1
        };
        function isLocalStorageValid() {
          try {
            return typeof localStorage !== "undefined" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
            !!localStorage.setItem;
          } catch (e) {
            return false;
          }
        }
        function _getKeyPrefix(options, defaultConfig) {
          var keyPrefix = options.name + "/";
          if (options.storeName !== defaultConfig.storeName) {
            keyPrefix += options.storeName + "/";
          }
          return keyPrefix;
        }
        function checkIfLocalStorageThrows() {
          var localStorageTestKey = "_localforage_support_test";
          try {
            localStorage.setItem(localStorageTestKey, true);
            localStorage.removeItem(localStorageTestKey);
            return false;
          } catch (e) {
            return true;
          }
        }
        function _isLocalStorageUsable() {
          return !checkIfLocalStorageThrows() || localStorage.length > 0;
        }
        function _initStorage$2(options) {
          var self2 = this;
          var dbInfo = {};
          if (options) {
            for (var i in options) {
              dbInfo[i] = options[i];
            }
          }
          dbInfo.keyPrefix = _getKeyPrefix(options, self2._defaultConfig);
          if (!_isLocalStorageUsable()) {
            return Promise$12.reject();
          }
          self2._dbInfo = dbInfo;
          dbInfo.serializer = localforageSerializer;
          return Promise$12.resolve();
        }
        function clear$2(callback) {
          var self2 = this;
          var promise = self2.ready().then(function() {
            var keyPrefix = self2._dbInfo.keyPrefix;
            for (var i = localStorage.length - 1; i >= 0; i--) {
              var key2 = localStorage.key(i);
              if (key2.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key2);
              }
            }
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function getItem$2(key2, callback) {
          var self2 = this;
          key2 = normalizeKey2(key2);
          var promise = self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            var result = localStorage.getItem(dbInfo.keyPrefix + key2);
            if (result) {
              result = dbInfo.serializer.deserialize(result);
            }
            return result;
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function iterate$2(iterator2, callback) {
          var self2 = this;
          var promise = self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            var keyPrefix = dbInfo.keyPrefix;
            var keyPrefixLength = keyPrefix.length;
            var length3 = localStorage.length;
            var iterationNumber = 1;
            for (var i = 0; i < length3; i++) {
              var key2 = localStorage.key(i);
              if (key2.indexOf(keyPrefix) !== 0) {
                continue;
              }
              var value = localStorage.getItem(key2);
              if (value) {
                value = dbInfo.serializer.deserialize(value);
              }
              value = iterator2(value, key2.substring(keyPrefixLength), iterationNumber++);
              if (value !== void 0) {
                return value;
              }
            }
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function key$2(n12, callback) {
          var self2 = this;
          var promise = self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            var result;
            try {
              result = localStorage.key(n12);
            } catch (error) {
              result = null;
            }
            if (result) {
              result = result.substring(dbInfo.keyPrefix.length);
            }
            return result;
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function keys$2(callback) {
          var self2 = this;
          var promise = self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            var length3 = localStorage.length;
            var keys3 = [];
            for (var i = 0; i < length3; i++) {
              var itemKey = localStorage.key(i);
              if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                keys3.push(itemKey.substring(dbInfo.keyPrefix.length));
              }
            }
            return keys3;
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function length$2(callback) {
          var self2 = this;
          var promise = self2.keys().then(function(keys3) {
            return keys3.length;
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function removeItem$2(key2, callback) {
          var self2 = this;
          key2 = normalizeKey2(key2);
          var promise = self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            localStorage.removeItem(dbInfo.keyPrefix + key2);
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function setItem$2(key2, value, callback) {
          var self2 = this;
          key2 = normalizeKey2(key2);
          var promise = self2.ready().then(function() {
            if (value === void 0) {
              value = null;
            }
            var originalValue = value;
            return new Promise$12(function(resolve2, reject) {
              var dbInfo = self2._dbInfo;
              dbInfo.serializer.serialize(value, function(value2, error) {
                if (error) {
                  reject(error);
                } else {
                  try {
                    localStorage.setItem(dbInfo.keyPrefix + key2, value2);
                    resolve2(originalValue);
                  } catch (e) {
                    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") {
                      reject(e);
                    }
                    reject(e);
                  }
                }
              });
            });
          });
          executeCallback2(promise, callback);
          return promise;
        }
        function dropInstance$2(options, callback) {
          callback = getCallback.apply(this, arguments);
          options = typeof options !== "function" && options || {};
          if (!options.name) {
            var currentConfig = this.config();
            options.name = options.name || currentConfig.name;
            options.storeName = options.storeName || currentConfig.storeName;
          }
          var self2 = this;
          var promise;
          if (!options.name) {
            promise = Promise$12.reject("Invalid arguments");
          } else {
            promise = new Promise$12(function(resolve2) {
              if (!options.storeName) {
                resolve2(options.name + "/");
              } else {
                resolve2(_getKeyPrefix(options, self2._defaultConfig));
              }
            }).then(function(keyPrefix) {
              for (var i = localStorage.length - 1; i >= 0; i--) {
                var key2 = localStorage.key(i);
                if (key2.indexOf(keyPrefix) === 0) {
                  localStorage.removeItem(key2);
                }
              }
            });
          }
          executeCallback2(promise, callback);
          return promise;
        }
        var localStorageWrapper = {
          _driver: "localStorageWrapper",
          _initStorage: _initStorage$2,
          _support: isLocalStorageValid(),
          iterate: iterate$2,
          getItem: getItem$2,
          setItem: setItem$2,
          removeItem: removeItem$2,
          clear: clear$2,
          length: length$2,
          key: key$2,
          keys: keys$2,
          dropInstance: dropInstance$2
        };
        var sameValue = function sameValue2(x, y) {
          return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
        };
        var includes3 = function includes4(array, searchElement) {
          var len = array.length;
          var i = 0;
          while (i < len) {
            if (sameValue(array[i], searchElement)) {
              return true;
            }
            i++;
          }
          return false;
        };
        var isArray2 = Array.isArray || function(arg2) {
          return Object.prototype.toString.call(arg2) === "[object Array]";
        };
        var DefinedDrivers = {};
        var DriverSupport = {};
        var DefaultDrivers = {
          INDEXEDDB: asyncStorage,
          WEBSQL: webSQLStorage,
          LOCALSTORAGE: localStorageWrapper
        };
        var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];
        var OptionalDriverMethods = ["dropInstance"];
        var LibraryMethods = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(OptionalDriverMethods);
        var DefaultConfig = {
          description: "",
          driver: DefaultDriverOrder.slice(),
          name: "localforage",
          // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
          // we can use without a prompt.
          size: 4980736,
          storeName: "keyvaluepairs",
          version: 1
        };
        function callWhenReady(localForageInstance, libraryMethod) {
          localForageInstance[libraryMethod] = function() {
            var _args = arguments;
            return localForageInstance.ready().then(function() {
              return localForageInstance[libraryMethod].apply(localForageInstance, _args);
            });
          };
        }
        function extend2() {
          for (var i = 1; i < arguments.length; i++) {
            var arg2 = arguments[i];
            if (arg2) {
              for (var _key in arg2) {
                if (arg2.hasOwnProperty(_key)) {
                  if (isArray2(arg2[_key])) {
                    arguments[0][_key] = arg2[_key].slice();
                  } else {
                    arguments[0][_key] = arg2[_key];
                  }
                }
              }
            }
          }
          return arguments[0];
        }
        var LocalForage = (function() {
          function LocalForage2(options) {
            _classCallCheck(this, LocalForage2);
            for (var driverTypeKey in DefaultDrivers) {
              if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                var driver = DefaultDrivers[driverTypeKey];
                var driverName = driver._driver;
                this[driverTypeKey] = driverName;
                if (!DefinedDrivers[driverName]) {
                  this.defineDriver(driver);
                }
              }
            }
            this._defaultConfig = extend2({}, DefaultConfig);
            this._config = extend2({}, this._defaultConfig, options);
            this._driverSet = null;
            this._initDriver = null;
            this._ready = false;
            this._dbInfo = null;
            this._wrapLibraryMethodsWithReady();
            this.setDriver(this._config.driver)["catch"](function() {
            });
          }
          LocalForage2.prototype.config = function config2(options) {
            if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
              if (this._ready) {
                return new Error("Can't call config() after localforage has been used.");
              }
              for (var i in options) {
                if (i === "storeName") {
                  options[i] = options[i].replace(/\W/g, "_");
                }
                if (i === "version" && typeof options[i] !== "number") {
                  return new Error("Database version must be a number.");
                }
                this._config[i] = options[i];
              }
              if ("driver" in options && options.driver) {
                return this.setDriver(this._config.driver);
              }
              return true;
            } else if (typeof options === "string") {
              return this._config[options];
            } else {
              return this._config;
            }
          };
          LocalForage2.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
            var promise = new Promise$12(function(resolve2, reject) {
              try {
                var driverName = driverObject._driver;
                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                if (!driverObject._driver) {
                  reject(complianceError);
                  return;
                }
                var driverMethods = LibraryMethods.concat("_initStorage");
                for (var i = 0, len = driverMethods.length; i < len; i++) {
                  var driverMethodName = driverMethods[i];
                  var isRequired = !includes3(OptionalDriverMethods, driverMethodName);
                  if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== "function") {
                    reject(complianceError);
                    return;
                  }
                }
                var configureMissingMethods = function configureMissingMethods2() {
                  var methodNotImplementedFactory = function methodNotImplementedFactory2(methodName) {
                    return function() {
                      var error = new Error("Method " + methodName + " is not implemented by the current driver");
                      var promise2 = Promise$12.reject(error);
                      executeCallback2(promise2, arguments[arguments.length - 1]);
                      return promise2;
                    };
                  };
                  for (var _i2 = 0, _len = OptionalDriverMethods.length; _i2 < _len; _i2++) {
                    var optionalDriverMethod = OptionalDriverMethods[_i2];
                    if (!driverObject[optionalDriverMethod]) {
                      driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                    }
                  }
                };
                configureMissingMethods();
                var setDriverSupport = function setDriverSupport2(support) {
                  if (DefinedDrivers[driverName]) {
                    console.info("Redefining LocalForage driver: " + driverName);
                  }
                  DefinedDrivers[driverName] = driverObject;
                  DriverSupport[driverName] = support;
                  resolve2();
                };
                if ("_support" in driverObject) {
                  if (driverObject._support && typeof driverObject._support === "function") {
                    driverObject._support().then(setDriverSupport, reject);
                  } else {
                    setDriverSupport(!!driverObject._support);
                  }
                } else {
                  setDriverSupport(true);
                }
              } catch (e) {
                reject(e);
              }
            });
            executeTwoCallbacks(promise, callback, errorCallback);
            return promise;
          };
          LocalForage2.prototype.driver = function driver() {
            return this._driver || null;
          };
          LocalForage2.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
            var getDriverPromise = DefinedDrivers[driverName] ? Promise$12.resolve(DefinedDrivers[driverName]) : Promise$12.reject(new Error("Driver not found."));
            executeTwoCallbacks(getDriverPromise, callback, errorCallback);
            return getDriverPromise;
          };
          LocalForage2.prototype.getSerializer = function getSerializer(callback) {
            var serializerPromise = Promise$12.resolve(localforageSerializer);
            executeTwoCallbacks(serializerPromise, callback);
            return serializerPromise;
          };
          LocalForage2.prototype.ready = function ready2(callback) {
            var self2 = this;
            var promise = self2._driverSet.then(function() {
              if (self2._ready === null) {
                self2._ready = self2._initDriver();
              }
              return self2._ready;
            });
            executeTwoCallbacks(promise, callback, callback);
            return promise;
          };
          LocalForage2.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
            var self2 = this;
            if (!isArray2(drivers)) {
              drivers = [drivers];
            }
            var supportedDrivers = this._getSupportedDrivers(drivers);
            function setDriverToConfig() {
              self2._config.driver = self2.driver();
            }
            function extendSelfWithDriver(driver) {
              self2._extend(driver);
              setDriverToConfig();
              self2._ready = self2._initStorage(self2._config);
              return self2._ready;
            }
            function initDriver(supportedDrivers2) {
              return function() {
                var currentDriverIndex = 0;
                function driverPromiseLoop() {
                  while (currentDriverIndex < supportedDrivers2.length) {
                    var driverName = supportedDrivers2[currentDriverIndex];
                    currentDriverIndex++;
                    self2._dbInfo = null;
                    self2._ready = null;
                    return self2.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                  }
                  setDriverToConfig();
                  var error = new Error("No available storage method found.");
                  self2._driverSet = Promise$12.reject(error);
                  return self2._driverSet;
                }
                return driverPromiseLoop();
              };
            }
            var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
              return Promise$12.resolve();
            }) : Promise$12.resolve();
            this._driverSet = oldDriverSetDone.then(function() {
              var driverName = supportedDrivers[0];
              self2._dbInfo = null;
              self2._ready = null;
              return self2.getDriver(driverName).then(function(driver) {
                self2._driver = driver._driver;
                setDriverToConfig();
                self2._wrapLibraryMethodsWithReady();
                self2._initDriver = initDriver(supportedDrivers);
              });
            })["catch"](function() {
              setDriverToConfig();
              var error = new Error("No available storage method found.");
              self2._driverSet = Promise$12.reject(error);
              return self2._driverSet;
            });
            executeTwoCallbacks(this._driverSet, callback, errorCallback);
            return this._driverSet;
          };
          LocalForage2.prototype.supports = function supports(driverName) {
            return !!DriverSupport[driverName];
          };
          LocalForage2.prototype._extend = function _extend(libraryMethodsAndProperties) {
            extend2(this, libraryMethodsAndProperties);
          };
          LocalForage2.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
            var supportedDrivers = [];
            for (var i = 0, len = drivers.length; i < len; i++) {
              var driverName = drivers[i];
              if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
              }
            }
            return supportedDrivers;
          };
          LocalForage2.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
            for (var i = 0, len = LibraryMethods.length; i < len; i++) {
              callWhenReady(this, LibraryMethods[i]);
            }
          };
          LocalForage2.prototype.createInstance = function createInstance(options) {
            return new LocalForage2(options);
          };
          return LocalForage2;
        })();
        var localforage_js = new LocalForage();
        module3.exports = localforage_js;
      }, { "3": 3 }] }, {}, [4])(4);
    });
  })(localforage);
  return localforage.exports;
}
var localforageExports = requireLocalforage();
const localForage = /* @__PURE__ */ getDefaultExportFromCjs(localforageExports);
function executeCallback(promise, callback) {
  if (callback) {
    promise.then(function(result) {
      callback(null, result);
    }, function(error) {
      callback(error);
    });
  }
  return promise;
}
function removeItemsGeneric(keys2, callback) {
  var localforageInstance = this;
  var itemPromises = [];
  for (var i = 0, len = keys2.length; i < len; i++) {
    var key = keys2[i];
    itemPromises.push(localforageInstance.removeItem(key));
  }
  var promise = Promise.all(itemPromises);
  executeCallback(promise, callback);
  return promise;
}
function removeItemsIndexedDB(keys2, callback) {
  var localforageInstance = this;
  var promise = localforageInstance.ready().then(function() {
    return new Promise(function(resolve2, reject) {
      var dbInfo = localforageInstance._dbInfo;
      var transaction = dbInfo.db.transaction(dbInfo.storeName, "readwrite");
      var store2 = transaction.objectStore(dbInfo.storeName);
      var firstError;
      transaction.oncomplete = function() {
        resolve2();
      };
      transaction.onabort = transaction.onerror = function() {
        if (!firstError) {
          reject(transaction.error || "Unknown error");
        }
      };
      function requestOnError(evt) {
        var request3 = evt.target || this;
        if (!firstError) {
          firstError = request3.error || request3.transaction.error;
          reject(firstError);
        }
      }
      for (var i = 0, len = keys2.length; i < len; i++) {
        var key = keys2[i];
        if (typeof key !== "string") {
          console.warn(key + " used as a key, but it is not a string.");
          key = String(key);
        }
        var request2 = store2.delete(key);
        request2.onerror = requestOnError;
      }
    });
  });
  executeCallback(promise, callback);
  return promise;
}
function executeSqlAsync(transaction, sql, parameters) {
  return new Promise(function(resolve2, reject) {
    transaction.executeSql(sql, parameters, function() {
      resolve2();
    }, function(t16, error) {
      reject(error);
    });
  });
}
function removeItemsWebsql(keys2, callback) {
  var localforageInstance = this;
  var promise = localforageInstance.ready().then(function() {
    return new Promise(function(resolve2, reject) {
      var dbInfo = localforageInstance._dbInfo;
      dbInfo.db.transaction(function(t16) {
        var storeName = dbInfo.storeName;
        var itemPromises = [];
        for (var i = 0, len = keys2.length; i < len; i++) {
          var key = keys2[i];
          if (typeof key !== "string") {
            console.warn(key + " used as a key, but it is not a string.");
            key = String(key);
          }
          itemPromises.push(executeSqlAsync(t16, "DELETE FROM " + storeName + " WHERE key = ?", [key]));
        }
        Promise.all(itemPromises).then(resolve2, reject);
      }, function(sqlError) {
        reject(sqlError);
      });
    });
  });
  executeCallback(promise, callback);
  return promise;
}
function localforageRemoveItems() {
  var localforageInstance = this;
  var currentDriver = localforageInstance.driver();
  if (currentDriver === localforageInstance.INDEXEDDB) {
    return removeItemsIndexedDB.apply(localforageInstance, arguments);
  } else if (currentDriver === localforageInstance.WEBSQL) {
    return removeItemsWebsql.apply(localforageInstance, arguments);
  } else {
    return removeItemsGeneric.apply(localforageInstance, arguments);
  }
}
function extendPrototype(localforage$$1) {
  var localforagePrototype = Object.getPrototypeOf(localforage$$1);
  if (localforagePrototype) {
    localforagePrototype.removeItems = localforageRemoveItems;
    localforagePrototype.removeItems.indexedDB = function() {
      return removeItemsIndexedDB.apply(this, arguments);
    };
    localforagePrototype.removeItems.websql = function() {
      return removeItemsWebsql.apply(this, arguments);
    };
    localforagePrototype.removeItems.generic = function() {
      return removeItemsGeneric.apply(this, arguments);
    };
  }
}
extendPrototype(localForage);
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
var Symbol$1 = root.Symbol;
var objectProto$h = Object.prototype;
var hasOwnProperty$h = objectProto$h.hasOwnProperty;
var nativeObjectToString$1 = objectProto$h.toString;
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$h.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$g = Object.prototype;
var nativeObjectToString = objectProto$g.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString$1(value);
}
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var symbolTag$3 = "[object Symbol]";
function isSymbol$2(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag$3;
}
function arrayMap(array, iteratee) {
  var index2 = -1, length2 = array == null ? 0 : array.length, result = Array(length2);
  while (++index2 < length2) {
    result[index2] = iteratee(array[index2], index2, array);
  }
  return result;
}
var isArray$3 = Array.isArray;
var symbolProto$2 = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto$2 ? symbolProto$2.toString : void 0;
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$3(value)) {
    return arrayMap(value, baseToString) + "";
  }
  if (isSymbol$2(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
var reWhitespace = /\s/;
function trimmedEndIndex(string2) {
  var index2 = string2.length;
  while (index2-- && reWhitespace.test(string2.charAt(index2))) {
  }
  return index2;
}
var reTrimStart = /^\s+/;
function baseTrim(string2) {
  return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
}
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$2(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol$2(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$1(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var INFINITY$1 = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber$2(value);
  if (value === INFINITY$1 || value === -INFINITY$1) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
function toInteger(value) {
  var result = toFinite(value), remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}
function identity(value) {
  return value;
}
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$1(value) {
  if (!isObject$1(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root["__core-js_shared__"];
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
})();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype, objectProto$f = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$g = objectProto$f.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$g).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function getValue$2(object, key) {
  return object == null ? void 0 : object[key];
}
function getNative(object, key) {
  var value = getValue$2(object, key);
  return baseIsNative(value) ? value : void 0;
}
var WeakMap$1 = getNative(root, "WeakMap");
var objectCreate = Object.create;
var baseCreate = /* @__PURE__ */ (function() {
  function object() {
  }
  return function(proto) {
    if (!isObject$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = void 0;
    return result;
  };
})();
function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
function noop$6() {
}
function copyArray(source, array) {
  var index2 = -1, length2 = source.length;
  array || (array = Array(length2));
  while (++index2 < length2) {
    array[index2] = source[index2];
  }
  return array;
}
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut(func) {
  var count2 = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count2 >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count2 = 0;
    }
    return func.apply(void 0, arguments);
  };
}
function constant(value) {
  return function() {
    return value;
  };
}
var defineProperty = (function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e) {
  }
})();
var baseSetToString = !defineProperty ? identity : function(func, string2) {
  return defineProperty(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string2),
    "writable": true
  });
};
var setToString = shortOut(baseSetToString);
function arrayEach(array, iteratee) {
  var index2 = -1, length2 = array == null ? 0 : array.length;
  while (++index2 < length2) {
    if (iteratee(array[index2], index2, array) === false) {
      break;
    }
  }
  return array;
}
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length2 = array.length, index2 = fromIndex + -1;
  while (++index2 < length2) {
    if (predicate(array[index2], index2, array)) {
      return index2;
    }
  }
  return -1;
}
function baseIsNaN(value) {
  return value !== value;
}
function strictIndexOf(array, value, fromIndex) {
  var index2 = fromIndex - 1, length2 = array.length;
  while (++index2 < length2) {
    if (array[index2] === value) {
      return index2;
    }
  }
  return -1;
}
function baseIndexOf(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
function arrayIncludes$1(array, value) {
  var length2 = array == null ? 0 : array.length;
  return !!length2 && baseIndexOf(array, value, 0) > -1;
}
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length2) {
  var type = typeof value;
  length2 = length2 == null ? MAX_SAFE_INTEGER$1 : length2;
  return !!length2 && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
}
function baseAssignValue(object, key, value) {
  if (key == "__proto__" && defineProperty) {
    defineProperty(object, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object[key] = value;
  }
}
function eq$1(value, other) {
  return value === other || value !== value && other !== other;
}
var objectProto$e = Object.prototype;
var hasOwnProperty$f = objectProto$e.hasOwnProperty;
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$f.call(object, key) && eq$1(objValue, value)) || value === void 0 && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index2 = -1, length2 = props.length;
  while (++index2 < length2) {
    var key = props[index2];
    var newValue = void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}
var nativeMax$2 = Math.max;
function overRest(func, start2, transform2) {
  start2 = nativeMax$2(start2 === void 0 ? func.length - 1 : start2, 0);
  return function() {
    var args = arguments, index2 = -1, length2 = nativeMax$2(args.length - start2, 0), array = Array(length2);
    while (++index2 < length2) {
      array[index2] = args[start2 + index2];
    }
    index2 = -1;
    var otherArgs = Array(start2 + 1);
    while (++index2 < start2) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start2] = transform2(array);
    return apply$1(func, this, otherArgs);
  };
}
function baseRest(func, start2) {
  return setToString(overRest(func, start2, identity), func + "");
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}
function isIterateeCall(value, index2, object) {
  if (!isObject$1(object)) {
    return false;
  }
  var type = typeof index2;
  if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
    return eq$1(object[index2], value);
  }
  return false;
}
var objectProto$d = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$d;
  return value === proto;
}
function baseTimes(n12, iteratee) {
  var index2 = -1, result = Array(n12);
  while (++index2 < n12) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var argsTag$3 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$3;
}
var objectProto$c = Object.prototype;
var hasOwnProperty$e = objectProto$c.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$c.propertyIsEnumerable;
var isArguments = baseIsArguments(/* @__PURE__ */ (function() {
  return arguments;
})()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$e.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
function stubFalse() {
  return false;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$4 = moduleExports$2 ? root.Buffer : void 0;
var nativeIsBuffer = Buffer$4 ? Buffer$4.isBuffer : void 0;
var isBuffer$2 = nativeIsBuffer || stubFalse;
var argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", funcTag$1 = "[object Function]", mapTag$6 = "[object Map]", numberTag$4 = "[object Number]", objectTag$4 = "[object Object]", regexpTag$3 = "[object RegExp]", setTag$6 = "[object Set]", stringTag$3 = "[object String]", weakMapTag$2 = "[object WeakMap]";
var arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$6] = typedArrayTags[numberTag$4] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$6] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$2] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal.process;
var nodeUtil = (function() {
  try {
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    if (types) {
      return types;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e) {
  }
})();
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var objectProto$b = Object.prototype;
var hasOwnProperty$d = objectProto$b.hasOwnProperty;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$3(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer$2(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length2 = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$d.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length2)))) {
      result.push(key);
    }
  }
  return result;
}
function overArg(func, transform2) {
  return function(arg2) {
    return func(transform2(arg2));
  };
}
var nativeKeys = overArg(Object.keys, Object);
var objectProto$a = Object.prototype;
var hasOwnProperty$c = objectProto$a.hasOwnProperty;
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$c.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}
var objectProto$9 = Object.prototype;
var hasOwnProperty$b = objectProto$9.hasOwnProperty;
function baseKeysIn(object) {
  if (!isObject$1(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object), result = [];
  for (var key in object) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$b.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp$1 = /^\w*$/;
function isKey$1(value, object) {
  if (isArray$3(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol$2(value)) {
    return true;
  }
  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) || object != null && value in Object(object);
}
var nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$8 = Object.prototype;
var hasOwnProperty$a = objectProto$8.hasOwnProperty;
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$a.call(data, key) ? data[key] : void 0;
}
var objectProto$7 = Object.prototype;
var hasOwnProperty$9 = objectProto$7.hasOwnProperty;
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== void 0 : hasOwnProperty$9.call(data, key);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
function Hash(entries2) {
  var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries2[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function assocIndexOf(array, key) {
  var length2 = array.length;
  while (length2--) {
    if (eq$1(array[length2][0], key)) {
      return length2;
    }
  }
  return -1;
}
var arrayProto$1 = Array.prototype;
var splice = arrayProto$1.splice;
function listCacheDelete(key) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index2, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  return index2 < 0 ? void 0 : data[index2][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
function ListCache(entries2) {
  var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries2[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$1 = getNative(root, "Map");
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$1 || ListCache)(),
    "string": new Hash()
  };
}
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function getMapData(map2, key) {
  var data = map2.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function mapCacheDelete(key) {
  var result = getMapData(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  var data = getMapData(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
function MapCache(entries2) {
  var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries2[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize$2(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key)) {
      return cache2.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache2.set(key, result) || cache2;
    return result;
  };
  memoized.cache = new (memoize$2.Cache || MapCache)();
  return memoized;
}
memoize$2.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result = memoize$2(func, function(key) {
    if (cache2.size === MAX_MEMOIZE_SIZE) {
      cache2.clear();
    }
    return key;
  });
  var cache2 = result.cache;
  return result;
}
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar$1 = /\\(\\)?/g;
var stringToPath$1 = memoizeCapped(function(string2) {
  var result = [];
  if (string2.charCodeAt(0) === 46) {
    result.push("");
  }
  string2.replace(rePropName$1, function(match2, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, "$1") : number || match2);
  });
  return result;
});
function toString$2(value) {
  return value == null ? "" : baseToString(value);
}
function castPath$1(value, object) {
  if (isArray$3(value)) {
    return value;
  }
  return isKey$1(value, object) ? [value] : stringToPath$1(toString$2(value));
}
function toKey$1(value) {
  if (typeof value == "string" || isSymbol$2(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function baseGet(object, path) {
  path = castPath$1(path, object);
  var index2 = 0, length2 = path.length;
  while (object != null && index2 < length2) {
    object = object[toKey$1(path[index2++])];
  }
  return index2 && index2 == length2 ? object : void 0;
}
function get$2(object, path, defaultValue) {
  var result = object == null ? void 0 : baseGet(object, path);
  return result === void 0 ? defaultValue : result;
}
function arrayPush(array, values2) {
  var index2 = -1, length2 = values2.length, offset2 = array.length;
  while (++index2 < length2) {
    array[offset2 + index2] = values2[index2];
  }
  return array;
}
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
function isFlattenable(value) {
  return isArray$3(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index2 = -1, length2 = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index2 < length2) {
    var value = array[index2];
    if (predicate(value)) {
      {
        arrayPush(result, value);
      }
    } else {
      result[result.length] = value;
    }
  }
  return result;
}
function flatten(array) {
  var length2 = array == null ? 0 : array.length;
  return length2 ? baseFlatten(array) : [];
}
function flatRest(func) {
  return setToString(overRest(func, void 0, flatten), func + "");
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
var objectTag$3 = "[object Object]";
var funcProto = Function.prototype, objectProto$6 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$8 = objectProto$6.hasOwnProperty;
var objectCtorString = funcToString.call(Object);
function isPlainObject$3(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$8.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
function baseSlice(array, start2, end2) {
  var index2 = -1, length2 = array.length;
  if (start2 < 0) {
    start2 = -start2 > length2 ? 0 : length2 + start2;
  }
  end2 = end2 > length2 ? length2 : end2;
  if (end2 < 0) {
    end2 += length2;
  }
  length2 = start2 > end2 ? 0 : end2 - start2 >>> 0;
  start2 >>>= 0;
  var result = Array(length2);
  while (++index2 < length2) {
    result[index2] = array[index2 + start2];
  }
  return result;
}
function castSlice(array, start2, end2) {
  var length2 = array.length;
  end2 = end2 === void 0 ? length2 : end2;
  return !start2 && end2 >= length2 ? array : baseSlice(array, start2, end2);
}
var rsAstralRange$2 = "\\ud800-\\udfff", rsComboMarksRange$3 = "\\u0300-\\u036f", reComboHalfMarksRange$3 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$3 = "\\u20d0-\\u20ff", rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3, rsVarRange$2 = "\\ufe0e\\ufe0f";
var rsZWJ$2 = "\\u200d";
var reHasUnicode = RegExp("[" + rsZWJ$2 + rsAstralRange$2 + rsComboRange$3 + rsVarRange$2 + "]");
function hasUnicode(string2) {
  return reHasUnicode.test(string2);
}
function asciiToArray(string2) {
  return string2.split("");
}
var rsAstralRange$1 = "\\ud800-\\udfff", rsComboMarksRange$2 = "\\u0300-\\u036f", reComboHalfMarksRange$2 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$2 = "\\u20d0-\\u20ff", rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2, rsVarRange$1 = "\\ufe0e\\ufe0f";
var rsAstral = "[" + rsAstralRange$1 + "]", rsCombo$2 = "[" + rsComboRange$2 + "]", rsFitz$1 = "\\ud83c[\\udffb-\\udfff]", rsModifier$1 = "(?:" + rsCombo$2 + "|" + rsFitz$1 + ")", rsNonAstral$1 = "[^" + rsAstralRange$1 + "]", rsRegional$1 = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair$1 = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsZWJ$1 = "\\u200d";
var reOptMod$1 = rsModifier$1 + "?", rsOptVar$1 = "[" + rsVarRange$1 + "]?", rsOptJoin$1 = "(?:" + rsZWJ$1 + "(?:" + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join("|") + ")" + rsOptVar$1 + reOptMod$1 + ")*", rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1, rsSymbol = "(?:" + [rsNonAstral$1 + rsCombo$2 + "?", rsCombo$2, rsRegional$1, rsSurrPair$1, rsAstral].join("|") + ")";
var reUnicode = RegExp(rsFitz$1 + "(?=" + rsFitz$1 + ")|" + rsSymbol + rsSeq$1, "g");
function unicodeToArray(string2) {
  return string2.match(reUnicode) || [];
}
function stringToArray(string2) {
  return hasUnicode(string2) ? unicodeToArray(string2) : asciiToArray(string2);
}
function createCaseFirst(methodName) {
  return function(string2) {
    string2 = toString$2(string2);
    var strSymbols = hasUnicode(string2) ? stringToArray(string2) : void 0;
    var chr = strSymbols ? strSymbols[0] : string2.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string2.slice(1);
    return chr[methodName]() + trailing;
  };
}
var upperFirst = createCaseFirst("toUpperCase");
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index2 = -1, length2 = array == null ? 0 : array.length;
  while (++index2 < length2) {
    accumulator = iteratee(accumulator, array[index2], index2, array);
  }
  return accumulator;
}
function basePropertyOf(object) {
  return function(key) {
    return object == null ? void 0 : object[key];
  };
}
var deburredLetters = {
  // Latin-1 Supplement block.
  "À": "A",
  "Á": "A",
  "Â": "A",
  "Ã": "A",
  "Ä": "A",
  "Å": "A",
  "à": "a",
  "á": "a",
  "â": "a",
  "ã": "a",
  "ä": "a",
  "å": "a",
  "Ç": "C",
  "ç": "c",
  "Ð": "D",
  "ð": "d",
  "È": "E",
  "É": "E",
  "Ê": "E",
  "Ë": "E",
  "è": "e",
  "é": "e",
  "ê": "e",
  "ë": "e",
  "Ì": "I",
  "Í": "I",
  "Î": "I",
  "Ï": "I",
  "ì": "i",
  "í": "i",
  "î": "i",
  "ï": "i",
  "Ñ": "N",
  "ñ": "n",
  "Ò": "O",
  "Ó": "O",
  "Ô": "O",
  "Õ": "O",
  "Ö": "O",
  "Ø": "O",
  "ò": "o",
  "ó": "o",
  "ô": "o",
  "õ": "o",
  "ö": "o",
  "ø": "o",
  "Ù": "U",
  "Ú": "U",
  "Û": "U",
  "Ü": "U",
  "ù": "u",
  "ú": "u",
  "û": "u",
  "ü": "u",
  "Ý": "Y",
  "ý": "y",
  "ÿ": "y",
  "Æ": "Ae",
  "æ": "ae",
  "Þ": "Th",
  "þ": "th",
  "ß": "ss",
  // Latin Extended-A block.
  "Ā": "A",
  "Ă": "A",
  "Ą": "A",
  "ā": "a",
  "ă": "a",
  "ą": "a",
  "Ć": "C",
  "Ĉ": "C",
  "Ċ": "C",
  "Č": "C",
  "ć": "c",
  "ĉ": "c",
  "ċ": "c",
  "č": "c",
  "Ď": "D",
  "Đ": "D",
  "ď": "d",
  "đ": "d",
  "Ē": "E",
  "Ĕ": "E",
  "Ė": "E",
  "Ę": "E",
  "Ě": "E",
  "ē": "e",
  "ĕ": "e",
  "ė": "e",
  "ę": "e",
  "ě": "e",
  "Ĝ": "G",
  "Ğ": "G",
  "Ġ": "G",
  "Ģ": "G",
  "ĝ": "g",
  "ğ": "g",
  "ġ": "g",
  "ģ": "g",
  "Ĥ": "H",
  "Ħ": "H",
  "ĥ": "h",
  "ħ": "h",
  "Ĩ": "I",
  "Ī": "I",
  "Ĭ": "I",
  "Į": "I",
  "İ": "I",
  "ĩ": "i",
  "ī": "i",
  "ĭ": "i",
  "į": "i",
  "ı": "i",
  "Ĵ": "J",
  "ĵ": "j",
  "Ķ": "K",
  "ķ": "k",
  "ĸ": "k",
  "Ĺ": "L",
  "Ļ": "L",
  "Ľ": "L",
  "Ŀ": "L",
  "Ł": "L",
  "ĺ": "l",
  "ļ": "l",
  "ľ": "l",
  "ŀ": "l",
  "ł": "l",
  "Ń": "N",
  "Ņ": "N",
  "Ň": "N",
  "Ŋ": "N",
  "ń": "n",
  "ņ": "n",
  "ň": "n",
  "ŋ": "n",
  "Ō": "O",
  "Ŏ": "O",
  "Ő": "O",
  "ō": "o",
  "ŏ": "o",
  "ő": "o",
  "Ŕ": "R",
  "Ŗ": "R",
  "Ř": "R",
  "ŕ": "r",
  "ŗ": "r",
  "ř": "r",
  "Ś": "S",
  "Ŝ": "S",
  "Ş": "S",
  "Š": "S",
  "ś": "s",
  "ŝ": "s",
  "ş": "s",
  "š": "s",
  "Ţ": "T",
  "Ť": "T",
  "Ŧ": "T",
  "ţ": "t",
  "ť": "t",
  "ŧ": "t",
  "Ũ": "U",
  "Ū": "U",
  "Ŭ": "U",
  "Ů": "U",
  "Ű": "U",
  "Ų": "U",
  "ũ": "u",
  "ū": "u",
  "ŭ": "u",
  "ů": "u",
  "ű": "u",
  "ų": "u",
  "Ŵ": "W",
  "ŵ": "w",
  "Ŷ": "Y",
  "ŷ": "y",
  "Ÿ": "Y",
  "Ź": "Z",
  "Ż": "Z",
  "Ž": "Z",
  "ź": "z",
  "ż": "z",
  "ž": "z",
  "Ĳ": "IJ",
  "ĳ": "ij",
  "Œ": "Oe",
  "œ": "oe",
  "ŉ": "'n",
  "ſ": "s"
};
var deburrLetter = basePropertyOf(deburredLetters);
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
var rsComboMarksRange$1 = "\\u0300-\\u036f", reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$1 = "\\u20d0-\\u20ff", rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
var rsCombo$1 = "[" + rsComboRange$1 + "]";
var reComboMark = RegExp(rsCombo$1, "g");
function deburr(string2) {
  string2 = toString$2(string2);
  return string2 && string2.replace(reLatin, deburrLetter).replace(reComboMark, "");
}
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function asciiWords(string2) {
  return string2.match(reAsciiWord) || [];
}
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function hasUnicodeWord(string2) {
  return reHasUnicodeWord.test(string2);
}
var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
var rsApos$1 = "['’]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos$1 + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos$1 + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq;
var reUnicodeWord = RegExp([
  rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
  rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
  rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
  rsUpper + "+" + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join("|"), "g");
function unicodeWords(string2) {
  return string2.match(reUnicodeWord) || [];
}
function words(string2, pattern, guard) {
  string2 = toString$2(string2);
  pattern = pattern;
  if (pattern === void 0) {
    return hasUnicodeWord(string2) ? unicodeWords(string2) : asciiWords(string2);
  }
  return string2.match(pattern) || [];
}
var rsApos = "['’]";
var reApos = RegExp(rsApos, "g");
function createCompounder(callback) {
  return function(string2) {
    return arrayReduce(words(deburr(string2).replace(reApos, "")), callback, "");
  };
}
var nativeIsFinite = root.isFinite, nativeMin$1 = Math.min;
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber$2(number);
    precision = precision == null ? 0 : nativeMin$1(toInteger(precision), 292);
    if (precision && nativeIsFinite(number)) {
      var pair = (toString$2(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
      pair = (toString$2(value) + "e").split("e");
      return +(pair[0] + "e" + (+pair[1] - precision));
    }
    return func(number);
  };
}
var nativeCeil = Math.ceil, nativeMax$1 = Math.max;
function chunk(array, size, guard) {
  if (size === void 0) {
    size = 1;
  } else {
    size = nativeMax$1(toInteger(size), 0);
  }
  var length2 = array == null ? 0 : array.length;
  if (!length2 || size < 1) {
    return [];
  }
  var index2 = 0, resIndex = 0, result = Array(nativeCeil(length2 / size));
  while (index2 < length2) {
    result[resIndex++] = baseSlice(array, index2, index2 += size);
  }
  return result;
}
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== void 0) {
      number = number <= upper ? number : upper;
    }
    {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
function stackDelete(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
function stackGet(key) {
  return this.__data__.get(key);
}
function stackHas(key) {
  return this.__data__.has(key);
}
var LARGE_ARRAY_SIZE$2 = 200;
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE$2 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
function Stack(entries2) {
  var data = this.__data__ = new ListCache(entries2);
  this.size = data.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer$3 = moduleExports ? root.Buffer : void 0, allocUnsafe$2 = Buffer$3 ? Buffer$3.allocUnsafe : void 0;
function cloneBuffer(buffer2, isDeep) {
  if (isDeep) {
    return buffer2.slice();
  }
  var length2 = buffer2.length, result = allocUnsafe$2 ? allocUnsafe$2(length2) : new buffer2.constructor(length2);
  buffer2.copy(result);
  return result;
}
function arrayFilter(array, predicate) {
  var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
  while (++index2 < length2) {
    var value = array[index2];
    if (predicate(value, index2, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
function stubArray() {
  return [];
}
var objectProto$5 = Object.prototype;
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols$1 ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$3(object) ? result : arrayPush(result, symbolsFunc(object));
}
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
var DataView = getNative(root, "DataView");
var Promise$1 = getNative(root, "Promise");
var Set$1 = getNative(root, "Set");
var mapTag$5 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$5 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$3 = "[object DataView]";
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1);
var getTag$1 = baseGetTag;
if (DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag$3 || Map$1 && getTag$1(new Map$1()) != mapTag$5 || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag$5 || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag$1) {
  getTag$1 = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$2 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$3;
        case mapCtorString:
          return mapTag$5;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$5;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var objectProto$4 = Object.prototype;
var hasOwnProperty$7 = objectProto$4.hasOwnProperty;
function initCloneArray(array) {
  var length2 = array.length, result = new array.constructor(length2);
  if (length2 && typeof array[0] == "string" && hasOwnProperty$7.call(array, "index")) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}
var Uint8Array$1 = root.Uint8Array;
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}
function cloneDataView(dataView, isDeep) {
  var buffer2 = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer2, dataView.byteOffset, dataView.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}
function cloneTypedArray(typedArray, isDeep) {
  var buffer2 = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer2, typedArray.byteOffset, typedArray.length);
}
var boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", mapTag$4 = "[object Map]", numberTag$3 = "[object Number]", regexpTag$2 = "[object RegExp]", setTag$4 = "[object Set]", stringTag$2 = "[object String]", symbolTag$2 = "[object Symbol]";
var arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(object);
    case boolTag$2:
    case dateTag$2:
      return new Ctor(+object);
    case dataViewTag$2:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);
    case mapTag$4:
      return new Ctor();
    case numberTag$3:
    case stringTag$2:
      return new Ctor(object);
    case regexpTag$2:
      return cloneRegExp(object);
    case setTag$4:
      return new Ctor();
    case symbolTag$2:
      return cloneSymbol(object);
  }
}
function initCloneObject(object) {
  return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
var mapTag$3 = "[object Map]";
function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$3;
}
var nodeIsMap = nodeUtil && nodeUtil.isMap;
var isMap$1 = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
var setTag$3 = "[object Set]";
function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$3;
}
var nodeIsSet = nodeUtil && nodeUtil.isSet;
var isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var CLONE_DEEP_FLAG$2 = 1, CLONE_FLAT_FLAG$1 = 2, CLONE_SYMBOLS_FLAG$2 = 4;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag$2 = "[object Map]", numberTag$2 = "[object Number]", objectTag$1 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$1] = cloneableTags[dateTag$1] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$2] = cloneableTags[numberTag$2] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$2] = cloneableTags[stringTag$1] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
function baseClone(value, bitmask, customizer, key, object, stack2) {
  var result, isDeep = bitmask & CLONE_DEEP_FLAG$2, isFlat = bitmask & CLONE_FLAT_FLAG$1, isFull = bitmask & CLONE_SYMBOLS_FLAG$2;
  if (customizer) {
    result = object ? customizer(value, key, object, stack2) : customizer(value);
  }
  if (result !== void 0) {
    return result;
  }
  if (!isObject$1(value)) {
    return value;
  }
  var isArr = isArray$3(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value), isFunc = tag == funcTag || tag == genTag;
    if (isBuffer$2(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$1 || tag == argsTag$1 || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  stack2 || (stack2 = new Stack());
  var stacked = stack2.get(value);
  if (stacked) {
    return stacked;
  }
  stack2.set(value, result);
  if (isSet$1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack2));
    });
  } else if (isMap$1(value)) {
    value.forEach(function(subValue, key2) {
      result.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack2));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
  var props = isArr ? void 0 : keysFunc(value);
  arrayEach(props || value, function(subValue, key2) {
    if (props) {
      key2 = subValue;
      subValue = value[key2];
    }
    assignValue(result, key2, baseClone(subValue, bitmask, customizer, key2, value, stack2));
  });
  return result;
}
var CLONE_DEEP_FLAG$1 = 1, CLONE_SYMBOLS_FLAG$1 = 4;
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value) {
  return this.__data__.has(value);
}
function SetCache(values2) {
  var index2 = -1, length2 = values2 == null ? 0 : values2.length;
  this.__data__ = new MapCache();
  while (++index2 < length2) {
    this.add(values2[index2]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(array, predicate) {
  var index2 = -1, length2 = array == null ? 0 : array.length;
  while (++index2 < length2) {
    if (predicate(array[index2], index2, array)) {
      return true;
    }
  }
  return false;
}
function cacheHas(cache2, key) {
  return cache2.has(key);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(array, other, bitmask, customizer, equalFunc, stack2) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack2.get(array);
  var othStacked = stack2.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  stack2.set(array, other);
  stack2.set(other, array);
  while (++index2 < arrLength) {
    var arrValue = array[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack2) : customizer(arrValue, othValue, index2, array, other, stack2);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack2))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack2))) {
      result = false;
      break;
    }
  }
  stack2["delete"](array);
  stack2["delete"](other);
  return result;
}
function mapToArray(map2) {
  var index2 = -1, result = Array(map2.size);
  map2.forEach(function(value, key) {
    result[++index2] = [key, value];
  });
  return result;
}
function setToArray(set) {
  var index2 = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag$1 = "[object Map]", numberTag$1 = "[object Number]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack2) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag$1:
      return eq$1(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      return object == other + "";
    case mapTag$1:
      var convert = mapToArray;
    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack2.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack2.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack2);
      stack2["delete"](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$3 = Object.prototype;
var hasOwnProperty$6 = objectProto$3.hasOwnProperty;
function equalObjects(object, other, bitmask, customizer, equalFunc, stack2) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$6.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack2.get(object);
  var othStacked = stack2.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack2.set(object, other);
  stack2.set(other, object);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack2) : customizer(objValue, othValue, key, object, other, stack2);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack2) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack2["delete"](object);
  stack2["delete"](other);
  return result;
}
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto$2 = Object.prototype;
var hasOwnProperty$5 = objectProto$2.hasOwnProperty;
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack2) {
  var objIsArr = isArray$3(object), othIsArr = isArray$3(other), objTag = objIsArr ? arrayTag : getTag$1(object), othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$2(object)) {
    if (!isBuffer$2(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack2 || (stack2 = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack2) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack2);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$5.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$5.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
      stack2 || (stack2 = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack2);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack2 || (stack2 = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack2);
}
function baseIsEqual(value, other, bitmask, customizer, stack2) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack2);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(object, source, matchData, customizer) {
  var index2 = matchData.length, length2 = index2;
  if (object == null) {
    return !length2;
  }
  object = Object(object);
  while (index2--) {
    var data = matchData[index2];
    if (data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index2 < length2) {
    data = matchData[index2];
    var key = data[0], objValue = object[key], srcValue = data[1];
    if (data[2]) {
      if (objValue === void 0 && !(key in object)) {
        return false;
      }
    } else {
      var stack2 = new Stack();
      var result;
      if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack2) : result)) {
        return false;
      }
    }
  }
  return true;
}
function isStrictComparable(value) {
  return value === value && !isObject$1(value);
}
function getMatchData(object) {
  var result = keys(object), length2 = result.length;
  while (length2--) {
    var key = result[length2], value = object[key];
    result[length2] = [key, value, isStrictComparable(value)];
  }
  return result;
}
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
  };
}
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}
function hasPath(object, path, hasFunc) {
  path = castPath$1(path, object);
  var index2 = -1, length2 = path.length, result = false;
  while (++index2 < length2) {
    var key = toKey$1(path[index2]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index2 != length2) {
    return result;
  }
  length2 = object == null ? 0 : object.length;
  return !!length2 && isLength(length2) && isIndex(key, length2) && (isArray$3(object) || isArguments(object));
}
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function(object) {
    var objValue = get$2(object, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(key) {
  return function(object) {
    return object == null ? void 0 : object[key];
  };
}
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}
function property(path) {
  return isKey$1(path) ? baseProperty(toKey$1(path)) : basePropertyDeep(path);
}
function baseIteratee(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == "object") {
    return isArray$3(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object), props = keysFunc(object), length2 = props.length;
    while (length2--) {
      var key = props[++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var baseFor = createBaseFor();
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length2 = collection.length, index2 = -1, iterable = Object(collection);
    while (++index2 < length2) {
      if (iteratee(iterable[index2], index2, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var baseEach = createBaseEach(baseForOwn);
var now$2 = function() {
  return root.Date.now();
};
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce$3(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber$2(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber$2(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time2;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time2) {
    lastInvokeTime = time2;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time2) : result;
  }
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time2 = now$2();
    if (shouldInvoke(time2)) {
      return trailingEdge(time2);
    }
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  function trailingEdge(time2) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time2);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now$2());
  }
  function debounced() {
    var time2 = now$2(), isInvoking = shouldInvoke(time2);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time2;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}
var LARGE_ARRAY_SIZE$1 = 200;
function baseDifference(array, values2, iteratee, comparator) {
  var index2 = -1, includes3 = arrayIncludes$1, isCommon = true, length2 = array.length, result = [], valuesLength = values2.length;
  if (!length2) {
    return result;
  }
  if (values2.length >= LARGE_ARRAY_SIZE$1) {
    includes3 = cacheHas;
    isCommon = false;
    values2 = new SetCache(values2);
  }
  outer:
    while (++index2 < length2) {
      var value = array[index2], computed2 = value;
      value = value !== 0 ? value : 0;
      if (isCommon && computed2 === computed2) {
        var valuesIndex = valuesLength;
        while (valuesIndex--) {
          if (values2[valuesIndex] === computed2) {
            continue outer;
          }
        }
        result.push(value);
      } else if (!includes3(values2, computed2, comparator)) {
        result.push(value);
      }
    }
  return result;
}
function last$1(array) {
  var length2 = array == null ? 0 : array.length;
  return length2 ? array[length2 - 1] : void 0;
}
function baseMap(collection, iteratee) {
  var index2 = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach(collection, function(value, key, collection2) {
    result[++index2] = iteratee(value, key, collection2);
  });
  return result;
}
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}
var mapTag = "[object Map]", setTag = "[object Set]";
var objectProto$1 = Object.prototype;
var hasOwnProperty$4 = objectProto$1.hasOwnProperty;
function isEmpty$3(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray$3(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer$2(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag$1(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$4.call(value, key)) {
      return false;
    }
  }
  return true;
}
function isEqual(value, other) {
  return baseIsEqual(value, other);
}
var numberTag = "[object Number]";
function isNumber$1(value) {
  return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
}
function isNil(value) {
  return value == null;
}
var objectProto = Object.prototype;
var hasOwnProperty$3 = objectProto.hasOwnProperty;
function baseUnset(object, path) {
  path = castPath$1(path, object);
  var index2 = -1, length2 = path.length;
  if (!length2) {
    return true;
  }
  while (++index2 < length2) {
    var key = toKey$1(path[index2]);
    if (key === "__proto__" && !hasOwnProperty$3.call(object, "__proto__")) {
      return false;
    }
    if ((key === "constructor" || key === "prototype") && index2 < length2 - 1) {
      return false;
    }
  }
  var obj = parent(object, path);
  return obj == null || delete obj[toKey$1(last$1(path))];
}
function customOmitClone(value) {
  return isPlainObject$3(value) ? void 0 : value;
}
var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
var omit$1 = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath$1(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length2 = paths.length;
  while (length2--) {
    baseUnset(result, paths[length2]);
  }
  return result;
});
function baseSortBy(array, comparer) {
  var length2 = array.length;
  array.sort(comparer);
  while (length2--) {
    array[length2] = array[length2].value;
  }
  return array;
}
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol$2(value);
    var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol$2(other);
    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}
function compareMultiple(object, other, orders) {
  var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length2 = objCriteria.length, ordersLength = orders.length;
  while (++index2 < length2) {
    var result = compareAscending(objCriteria[index2], othCriteria[index2]);
    if (result) {
      if (index2 >= ordersLength) {
        return result;
      }
      var order2 = orders[index2];
      return result * (order2 == "desc" ? -1 : 1);
    }
  }
  return object.index - other.index;
}
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray$3(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }
  var index2 = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
  var result = baseMap(collection, function(value, key, collection2) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { "criteria": criteria, "index": ++index2, "value": value };
  });
  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}
var round$5 = createRound("round");
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length2 = iteratees.length;
  if (length2 > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length2 > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees), []);
});
var startCase = createCompounder(function(result, word, index2) {
  return result + (index2 ? " " : "") + upperFirst(word);
});
function startsWith(string2, target, position2) {
  string2 = toString$2(string2);
  position2 = position2 == null ? 0 : baseClamp(toInteger(position2), 0, string2.length);
  target = baseToString(target);
  return string2.slice(position2, position2 + target.length) == target;
}
function take(array, n12, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n12 = n12 === void 0 ? 1 : toInteger(n12);
  return baseSlice(array, 0, n12 < 0 ? 0 : n12);
}
function takeRight(array, n12, guard) {
  var length2 = array == null ? 0 : array.length;
  if (!length2) {
    return [];
  }
  n12 = n12 === void 0 ? 1 : toInteger(n12);
  n12 = length2 - n12;
  return baseSlice(array, n12 < 0 ? 0 : n12, length2);
}
function toLower(value) {
  return toString$2(value).toLowerCase();
}
var htmlUnescapes = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'"
};
var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reHasEscapedHtml = RegExp(reEscapedHtml.source);
function unescape$1(string2) {
  string2 = toString$2(string2);
  return string2 && reHasEscapedHtml.test(string2) ? string2.replace(reEscapedHtml, unescapeHtmlChar) : string2;
}
var INFINITY = 1 / 0;
var createSet = !(Set$1 && 1 / setToArray(new Set$1([, -0]))[1] == INFINITY) ? noop$6 : function(values2) {
  return new Set$1(values2);
};
var LARGE_ARRAY_SIZE = 200;
function baseUniq(array, iteratee, comparator) {
  var index2 = -1, includes3 = arrayIncludes$1, length2 = array.length, isCommon = true, result = [], seen = result;
  if (length2 >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes3 = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer:
    while (++index2 < length2) {
      var value = array[index2], computed2 = iteratee ? iteratee(value) : value;
      value = value !== 0 ? value : 0;
      if (isCommon && computed2 === computed2) {
        var seenIndex = seen.length;
        while (seenIndex--) {
          if (seen[seenIndex] === computed2) {
            continue outer;
          }
        }
        if (iteratee) {
          seen.push(computed2);
        }
        result.push(value);
      } else if (!includes3(seen, computed2, comparator)) {
        if (seen !== result) {
          seen.push(computed2);
        }
        result.push(value);
      }
    }
  return result;
}
function uniq(array) {
  return array && array.length ? baseUniq(array) : [];
}
function uniqBy(array, iteratee) {
  return array && array.length ? baseUniq(array, baseIteratee(iteratee)) : [];
}
function baseXor(arrays, iteratee, comparator) {
  var length2 = arrays.length;
  if (length2 < 2) {
    return length2 ? baseUniq(arrays[0]) : [];
  }
  var index2 = -1, result = Array(length2);
  while (++index2 < length2) {
    var array = arrays[index2], othIndex = -1;
    while (++othIndex < length2) {
      if (othIndex != index2) {
        result[index2] = baseDifference(result[index2] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result), iteratee, comparator);
}
var xor = baseRest(function(arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});
extendPrototype(localForage);
const identityTransform = (x) => {
  return JSON.parse(JSON.stringify(x));
};
const jsonTransform = (x) => {
  return JSON.stringify(x);
};
let _store = null;
let _startup = { ready: false, logTransform: jsonTransform };
const ready = () => {
  return _store && _startup.ready;
};
const hash$3 = new Hashids(
  "unanet-logger-salt",
  6,
  "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"
);
let count = 0;
const cleanup = debounce$3((bufferSize) => {
  if (!ready()) {
    return;
  }
  _store?.keys().then((keys2) => {
    const diff2 = keys2.length - bufferSize;
    if (diff2 <= 0) {
      return;
    }
    const toRemove = keys2.slice(0, diff2);
    _store?.removeItems(toRemove).catch(() => null);
  }).catch(() => null);
}, 5e3);
const startLogging = () => {
  console.log(`browser storage driver: ${_store?.driver()}`);
  _startup = {
    ready: true,
    // we can log the object directly to IndexedDB, but in other cases
    // we prefer to control the serialization by using the JSON transform.
    logTransform: _store?.driver() === localForage.INDEXEDDB ? identityTransform : jsonTransform
  };
};
const startupFailed = (e) => {
  if (console?.warn) {
    console.warn(`Failed to start browser storage transport: ${e}`);
  }
};
const browserStorageTransport = (bufferSize) => (log2) => {
  if (!ready()) {
    return;
  }
  count = ++count % bufferSize;
  const id = `${new Date(log2.ts).toISOString()}|${hash$3.encode(count)}`;
  _store?.setItem(id, _startup.logTransform(log2)).catch((e) => {
    console.log("failed to set item", e);
    return null;
  });
  cleanup(bufferSize);
};
const makeBrowserStorageTransport = (appName, bufferSize = 500) => {
  console.log("makeBrowserStorageTransport");
  const store2 = localForage.createInstance({
    name: appName,
    storeName: "logs",
    description: `Unanet (${appName}) application logs`
  });
  _store = store2;
  store2.ready().then(startLogging).catch(startupFailed);
  return browserStorageTransport(bufferSize);
};
const readBrowserStorageLogs = async () => {
  if (!ready()) {
    return [];
  }
  const keys2 = await _store?.keys() ?? [];
  const data = await Promise.all(
    keys2.map(async (k) => _store?.getItem(k).catch(() => null))
  );
  return data.filter((d) => Boolean(d)).sort((a, b) => b.ts - a.ts);
};
const log = makeDefaultLogger(
  isProduction() ? LogLevel.INFO : LogLevel.DEBUG
);
var MimeTypes = /* @__PURE__ */ ((MimeTypes2) => {
  MimeTypes2[".aac"] = "audio/aac";
  MimeTypes2[".abw"] = "application/x-abiword";
  MimeTypes2[".arc"] = "application/x-freearc";
  MimeTypes2[".avi"] = "video/x-msvideo";
  MimeTypes2[".azw"] = "application/vnd.amazon.ebook";
  MimeTypes2[".bin"] = "application/octet-stream";
  MimeTypes2[".bmp"] = "image/bmp";
  MimeTypes2[".bz"] = "application/x-bzip";
  MimeTypes2[".bz2"] = "application/x-bzip2";
  MimeTypes2[".csh"] = "application/x-csh";
  MimeTypes2[".css"] = "text/css";
  MimeTypes2[".csv"] = "text/csv";
  MimeTypes2[".doc"] = "application/msword";
  MimeTypes2[".docx"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  MimeTypes2[".eot"] = "application/vnd.ms-fontobject";
  MimeTypes2[".epub"] = "application/epub+zip";
  MimeTypes2[".gz"] = "application/gzip";
  MimeTypes2[".gif"] = "image/gif";
  MimeTypes2[".html"] = "text/html";
  MimeTypes2[".ico"] = "image/vnd.microsoft.icon";
  MimeTypes2[".ics"] = "text/calendar";
  MimeTypes2[".jar"] = "application/java-archive";
  MimeTypes2[".jpeg"] = ".jpg";
  MimeTypes2[".js"] = "text/javascript";
  MimeTypes2[".json"] = "application/json";
  MimeTypes2[".jsonld"] = "application/ld+json";
  MimeTypes2[".mid"] = ".midi";
  MimeTypes2[".mp3"] = "audio/mpeg";
  MimeTypes2[".mpeg"] = "video/mpeg";
  MimeTypes2[".mpkg"] = "application/vnd.apple.installer+xml";
  MimeTypes2[".odp"] = "application/vnd.oasis.opendocument.presentation";
  MimeTypes2[".ods"] = "application/vnd.oasis.opendocument.spreadsheet";
  MimeTypes2[".odt"] = "application/vnd.oasis.opendocument.text";
  MimeTypes2[".oga"] = "audio/ogg";
  MimeTypes2[".ogv"] = "video/ogg";
  MimeTypes2[".ogx"] = "application/ogg";
  MimeTypes2[".opus"] = "audio/opus";
  MimeTypes2[".otf"] = "font/otf";
  MimeTypes2[".png"] = "image/png";
  MimeTypes2[".pdf"] = "application/pdf";
  MimeTypes2[".php"] = "application/php";
  MimeTypes2[".ppt"] = "application/vnd.ms-powerpoint";
  MimeTypes2[".pptx"] = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
  MimeTypes2[".rar"] = "application/vnd.rar";
  MimeTypes2[".rtf"] = "application/rtf";
  MimeTypes2[".sh"] = "application/x-sh";
  MimeTypes2[".svg"] = "image/svg+xml";
  MimeTypes2[".swf"] = "application/x-shockwave-flash";
  MimeTypes2[".tar"] = "application/x-tar";
  MimeTypes2[".tiff"] = "image/tiff";
  MimeTypes2[".ts"] = "video/mp2t";
  MimeTypes2[".ttf"] = "font/ttf";
  MimeTypes2[".txt"] = "text/plain";
  MimeTypes2[".vsd"] = "application/vnd.visio";
  MimeTypes2[".wav"] = "audio/wav";
  MimeTypes2[".weba"] = "audio/webm";
  MimeTypes2[".webm"] = "video/webm";
  MimeTypes2[".webp"] = "image/webp";
  MimeTypes2[".woff"] = "font/woff";
  MimeTypes2[".woff2"] = "font/woff2";
  MimeTypes2[".xhtml"] = "application/xhtml+xml";
  MimeTypes2[".xls"] = "application/vnd.ms-excel";
  MimeTypes2[".xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  MimeTypes2[".xml"] = "XML";
  MimeTypes2[".xul"] = "application/vnd.mozilla.xul+xml";
  MimeTypes2[".zip"] = "application/zip";
  MimeTypes2[".3gp"] = "video/3gpp";
  MimeTypes2[".3g2"] = "video/3gpp2";
  MimeTypes2[".7z"] = "application/x-7z-compressed";
  return MimeTypes2;
})(MimeTypes || {});
var ErrorResponse;
((ErrorResponse2) => {
  ErrorResponse2.CodeEnum = {
    UNAUTHORIZED: "UNAUTHORIZED",
    EXPIREDCREDENTIALS: "EXPIRED_CREDENTIALS",
    ACCOUNTLOCKED: "ACCOUNT_LOCKED",
    BADREQUEST: "BAD_REQUEST",
    FORBIDDEN: "FORBIDDEN",
    NOTFOUND: "NOT_FOUND",
    CONFLICT: "CONFLICT",
    UNSUPPORTED: "UNSUPPORTED",
    INTERNALERROR: "INTERNAL_ERROR",
    UNAVAILABLE: "UNAVAILABLE",
    INVALIDTOKEN: "INVALID_TOKEN",
    EXPIREDTOKEN: "EXPIRED_TOKEN",
    INVALIDCLAIM: "INVALID_CLAIM",
    MISSINGTOKEN: "MISSING_TOKEN",
    REVOKEDTOKEN: "REVOKED_TOKEN",
    BADTOKEN: "BAD_TOKEN",
    REQUESTVALIDATION: "REQUEST_VALIDATION",
    PAYLOADTOOLARGE: "PAYLOAD_TOO_LARGE",
    JSONPARSINGERROR: "JSON_PARSING_ERROR",
    JSONMAPPINGERROR: "JSON_MAPPING_ERROR",
    INSUFFICIENTLICENSE: "INSUFFICIENT_LICENSE",
    INSUFFICIENTCONFIGURATION: "INSUFFICIENT_CONFIGURATION",
    INSUFFICIENTROLES: "INSUFFICIENT_ROLES"
  };
})(ErrorResponse || (ErrorResponse = {}));
const PLATFORM_RESPONSE_MSG = "Platform response";
const PLATFORM_REQUEST_MSG = "Platform request";
const context = window.location.pathname.split("/").filter(Boolean)[0];
const platformTokenErrors = /* @__PURE__ */ new Set([
  ErrorResponse.CodeEnum.EXPIREDCREDENTIALS,
  ErrorResponse.CodeEnum.EXPIREDTOKEN,
  ErrorResponse.CodeEnum.INVALIDTOKEN,
  ErrorResponse.CodeEnum.MISSINGTOKEN,
  ErrorResponse.CodeEnum.REVOKEDTOKEN,
  ErrorResponse.CodeEnum.UNAUTHORIZED
]);
const defaultRequestOptions = {
  bypassReactAction: false,
  mimeType: MimeTypes[".json"],
  returnHeaders: false
};
class HttpError extends Error {
  constructor(statusCode, message, details) {
    super(message);
    this.name = "HttpError";
    this.statusCode = statusCode;
    this.code = statusCode.toString();
    this.details = details;
  }
}
class TokenError extends Error {
  constructor(code) {
    super("Token error");
    this.code = code;
    this.name = "TokenError";
  }
}
const extractErrorMessages = (error, defaultMessage) => {
  const { details } = error;
  if (details?.description) {
    return [details.description];
  } else if (details?.messages) {
    return details.messages.map((m) => m?.message);
  } else {
    return [defaultMessage || "An error occurred (no details available)."];
  }
};
const mapErrorCodes = (error, customErrors, defaultMessage) => {
  const errors = error.details?.errors ?? [];
  if (errors.length) {
    let sawUnmappedCode = false;
    const result = [];
    errors.forEach((e) => {
      const mappedMessage = e?.code && customErrors[e.code];
      if (mappedMessage) {
        result.push(mappedMessage);
      } else if (!sawUnmappedCode) {
        sawUnmappedCode = true;
        result.push(defaultMessage);
      }
    });
    return result;
  }
  return [defaultMessage];
};
const buildOptions = ({
  body,
  bypassReactAction = false,
  method,
  token: token2 = [],
  signal
}) => {
  const isReactAction = isProduction() && !bypassReactAction;
  const addAuthorizationHeader = !isReactAction && token2.length;
  const headers = new Headers();
  headers.set("Content-Type", "application/json");
  if (!isReactAction) {
    headers.set("x-una-app", "WEBAPP");
  }
  if (addAuthorizationHeader) {
    headers.set("Authorization", `Bearer ${token2.join("")}`);
  }
  if (isStateChangingMethod(method)) {
    const csrfToken = getCsrfToken();
    if (csrfToken) {
      headers.set(CSRF_HEADER_NAME, csrfToken);
      headers.set(DEPRECATED_CSRF_HEADER_NAME, csrfToken);
    }
  }
  const options = {
    body: body ? JSON.stringify(body) : void 0,
    method,
    headers,
    signal
  };
  return options;
};
const buildFileUploadOptions = ({
  file,
  token: token2 = []
}) => {
  const addAuthorizationHeader = !isProduction() && token2.length;
  const fileSize = file.size.toString();
  const formData = new FormData();
  const headers = new Headers();
  formData.append("file", file);
  headers.set("Accept", "application/json");
  headers.set("Content-Length", fileSize);
  if (!isProduction()) {
    headers.set("x-una-app", "WEBAPP");
  }
  if (addAuthorizationHeader) {
    headers.set("Authorization", `Bearer ${token2.join("")}`);
  }
  const csrfToken = getCsrfToken();
  if (csrfToken) {
    headers.set(CSRF_HEADER_NAME, csrfToken);
    headers.set(DEPRECATED_CSRF_HEADER_NAME, csrfToken);
  }
  const options = {
    body: formData,
    headers,
    method: "POST"
  };
  return options;
};
const buildUrl$1 = ({
  action,
  bypassReactAction,
  method,
  serverUrl: serverUrl2 = "",
  url: url2
}) => {
  if (action) {
    return `/${context}/action/${action}`;
  }
  return isProduction() && !bypassReactAction ? `/${context}/action/spa_action?pRoute=${encodeURIComponent(
    url2
  )}&pMethod=${method}` : `${serverUrl2}${url2}`;
};
const devServerUrlInvalid = (serverUrl2) => !serverUrl2 && !isProduction();
const isValidRequestBody = ({ body }) => {
  try {
    if (!body || !isObject$1(body)) {
      return true;
    }
    const arrValues = Object.values(body).filter(
      (property2) => isArray$3(property2)
    );
    return arrValues.every((value) => value.every((v) => v !== null));
  } catch (e) {
    log.warn({ msg: "Error validating request body", error: `${e}` });
    return false;
  }
};
const _parser = async ({
  mimeType,
  response
}) => {
  const _mimeTypeParsers = {
    [MimeTypes[".csv"]]: async () => {
      const text = await response.text();
      return text ?? null;
    },
    [MimeTypes[".json"]]: async () => {
      const text = await response.text();
      return text ? JSON.parse(text) : null;
    }
  };
  const parsed = await _mimeTypeParsers[mimeType ?? MimeTypes[".json"]]();
  return parsed;
};
const responseHandler = async ({
  bypassReactAction,
  mimeType,
  requestUrl,
  response,
  returnHeaders
}) => {
  const isReactActionHandler = isProduction() && !bypassReactAction;
  const parsed = await _parser({ mimeType, response });
  const isValidDevResponse = !isReactActionHandler && response.ok;
  const isValidProdResponse = isReactActionHandler && response.ok && !parsed?.errorStatusCode;
  if (isValidDevResponse || isValidProdResponse) {
    return returnHeaders ? { results: parsed, headers: response.headers } : parsed;
  }
  const errorText = isReactActionHandler ? {
    errorStatusCode: parsed?.errorStatusCode ?? response.status,
    error: parsed?.errorJson ?? {}
  } : {
    errorStatusCode: response.status,
    error: parsed
  };
  const { errorStatusCode, error } = errorText;
  if (error?.code && platformTokenErrors.has(error.code)) {
    throw new TokenError(error?.code ?? "");
  }
  log.warn({ msg: "Platform Response Error", errorStatusCode, requestUrl });
  throw new HttpError(errorStatusCode, error?.description ?? "", error);
};
const CSRF_COOKIE_NAME = "CSRF_TOKEN";
const CSRF_HEADER_NAME = "X-Csrf-Token";
const DEPRECATED_CSRF_HEADER_NAME = "CSRF_TOKEN";
const COOKIE_PATTERN = /=(.*)/;
const getCsrfToken = () => {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split(COOKIE_PATTERN);
    if (name === CSRF_COOKIE_NAME) {
      return value;
    }
  }
  return void 0;
};
const isStateChangingMethod = (method) => {
  return method !== "GET";
};
const submitForm = (action) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = action;
  const csrfToken = getCsrfToken();
  if (csrfToken) {
    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = "CSRF_TOKEN";
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);
  }
  document.body.appendChild(form);
  form.submit();
};
const submitFormInNewTab = ({
  action,
  fields
}) => {
  const form = document.createElement("form");
  form.action = action;
  form.method = "POST";
  form.rel = "noreferrer";
  form.target = "_blank";
  const csrfToken = getCsrfToken();
  if (csrfToken) {
    const csrfInput = document.createElement("input");
    csrfInput.name = "CSRF_TOKEN";
    csrfInput.type = "hidden";
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);
  }
  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.name = name;
    input.type = "hidden";
    input.value = value;
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
let serverUrl;
let token$2;
const setToken = (v = []) => {
  token$2 = v;
};
const getToken = () => {
  return token$2;
};
const setServerUrl = (url2) => {
  serverUrl = url2;
};
const request = async ({
  action,
  body,
  method,
  options: {
    bypassReactAction,
    mimeType,
    returnHeaders,
    signal
  } = defaultRequestOptions,
  url: url2
}) => {
  if (devServerUrlInvalid(serverUrl)) {
    throw new Error("Server URL is not set.");
  }
  if (!isValidRequestBody({ body })) {
    throw new Error("Invalid Request Body");
  }
  try {
    const options = buildOptions({
      body,
      bypassReactAction,
      method,
      token: token$2,
      signal
    });
    const requestUrl = buildUrl$1({
      action,
      bypassReactAction,
      method,
      serverUrl,
      url: url2
    });
    try {
      log.debug({ msg: PLATFORM_REQUEST_MSG, url: requestUrl, method });
      const response = await fetch(requestUrl, options);
      log.debug({
        msg: PLATFORM_RESPONSE_MSG,
        url: requestUrl,
        method,
        status: response.status
      });
      const results = await responseHandler({
        bypassReactAction,
        mimeType,
        response,
        requestUrl,
        returnHeaders
      });
      return results;
    } catch (e) {
      log.warn({
        msg: "Error making api request or parsing response",
        error: `${e}`
      });
      throw e;
    }
  } catch (e) {
    log.warn({ msg: "API Request Error", error: `${e}` });
    throw e;
  }
};
const requestFileUpload = async ({
  url: url2,
  method = "POST_FILE",
  file
}) => {
  if (devServerUrlInvalid(serverUrl)) {
    throw new Error("Server URL is not set.");
  }
  const options = buildFileUploadOptions({ file, token: token$2 });
  const requestUrl = buildUrl$1({ method, serverUrl, url: url2 });
  log.debug({ msg: PLATFORM_REQUEST_MSG, url: requestUrl, method });
  const response = await fetch(requestUrl, options);
  log.debug({
    msg: PLATFORM_RESPONSE_MSG,
    url: requestUrl,
    method,
    status: response.status
  });
  const results = await responseHandler({ response, requestUrl });
  return results;
};
const with404 = async (requestMethod, defaultValue) => {
  try {
    const data = await requestMethod();
    return data;
  } catch (e) {
    if (e.statusCode === 404) {
      log.info({ msg: "Expected 404 - returning default" });
      return defaultValue;
    }
    throw e;
  }
};
const modelFromJSON = (json) => JSON.parse(json);
const modelToJSON = (model) => JSON.stringify(model);
class LuxonError extends Error {
}
class InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
}
class InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
}
class InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
}
class ConflictingSpecificationError extends LuxonError {
}
class InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
}
class InvalidArgumentError extends LuxonError {
}
class ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}
const n = "numeric", s = "short", l = "long";
const DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
const DATE_MED = {
  year: n,
  month: s,
  day: n
};
const DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
const DATE_FULL = {
  year: n,
  month: l,
  day: n
};
const DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
const TIME_SIMPLE = {
  hour: n,
  minute: n
};
const TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
const TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
const TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
const TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
const TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
const TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
const TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
const DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
const DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
const DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
const DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
const DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
const DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
const DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
const DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
const DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
class Zone {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts2, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts2, format2) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts2) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
}
let singleton$1 = null;
class SystemZone extends Zone {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton$1 === null) {
      singleton$1 = new SystemZone();
    }
    return singleton$1;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts2, { format: format2, locale }) {
    return parseZoneInfo(ts2, format2, locale);
  }
  /** @override **/
  formatOffset(ts2, format2) {
    return formatOffset(this.offset(ts2), format2);
  }
  /** @override **/
  offset(ts2) {
    return -new Date(ts2).getTimezoneOffset();
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }
  /** @override **/
  get isValid() {
    return true;
  }
}
const dtfCache = /* @__PURE__ */ new Map();
function makeDTF(zoneName) {
  let dtf = dtfCache.get(zoneName);
  if (dtf === void 0) {
    dtf = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zoneName,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
    dtfCache.set(zoneName, dtf);
  }
  return dtf;
}
const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}
function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
const ianaZoneCache = /* @__PURE__ */ new Map();
class IANAZone extends Zone {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name) {
    let zone = ianaZoneCache.get(name);
    if (zone === void 0) {
      ianaZoneCache.set(name, zone = new IANAZone(name));
    }
    return zone;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache.clear();
    dtfCache.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(s12) {
    return this.isValidZone(s12);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e) {
      return false;
    }
  }
  constructor(name) {
    super();
    this.zoneName = name;
    this.valid = IANAZone.isValidZone(name);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return false;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts2, { format: format2, locale }) {
    return parseZoneInfo(ts2, format2, locale, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts2, format2) {
    return formatOffset(this.offset(ts2), format2);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts2) {
    if (!this.valid) return NaN;
    const date = new Date(ts2);
    if (isNaN(date)) return NaN;
    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0
    });
    let asTS = +date;
    const over = asTS % 1e3;
    asTS -= over >= 0 ? over : 1e3 + over;
    return (asUTC - asTS) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
const intlDTCache = /* @__PURE__ */ new Map();
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache.get(key);
  if (dtf === void 0) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache.set(key, dtf);
  }
  return dtf;
}
const intlNumCache = /* @__PURE__ */ new Map();
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache.get(key);
  if (inf === void 0) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache.set(key, inf);
  }
  return inf;
}
const intlRelCache = /* @__PURE__ */ new Map();
function getCachedRTF(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts;
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache.get(key);
  if (inf === void 0) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache.set(key, inf);
  }
  return inf;
}
let sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
const intlResolvedOptionsCache = /* @__PURE__ */ new Map();
function getCachedIntResolvedOptions(locString) {
  let opts = intlResolvedOptionsCache.get(locString);
  if (opts === void 0) {
    opts = new Intl.DateTimeFormat(locString).resolvedOptions();
    intlResolvedOptionsCache.set(locString, opts);
  }
  return opts;
}
const weekInfoCache = /* @__PURE__ */ new Map();
function getCachedWeekInfo(locString) {
  let data = weekInfoCache.get(locString);
  if (!data) {
    const locale = new Intl.Locale(locString);
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    if (!("minimalDays" in data)) {
      data = { ...fallbackWeekSettings, ...data };
    }
    weekInfoCache.set(locString, data);
  }
  return data;
}
function parseLocaleString(localeStr) {
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const { numberingSystem, calendar: calendar2 } = options;
    return [selectedStr, numberingSystem, calendar2];
  }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
function mapMonths(f) {
  const ms2 = [];
  for (let i = 1; i <= 12; i++) {
    const dt2 = DateTime.utc(2009, i, 1);
    ms2.push(f(dt2));
  }
  return ms2;
}
function mapWeekdays(f) {
  const ms2 = [];
  for (let i = 1; i <= 7; i++) {
    const dt2 = DateTime.utc(2016, 11, 13 + i);
    ms2.push(f(dt2));
  }
  return ms2;
}
function listStuff(loc, length2, englishFn, intlFn) {
  const mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length2);
  } else {
    return intlFn(length2);
  }
}
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
  }
}
class PolyNumberFormatter {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const { padTo, floor, ...otherOpts } = opts;
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}
class PolyDateFormatter {
  constructor(dt2, intl, opts) {
    this.opts = opts;
    this.originalZone = void 0;
    let z = void 0;
    if (this.opts.timeZone) {
      this.dt = dt2;
    } else if (dt2.zone.type === "fixed") {
      const gmtOffset = -1 * (dt2.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt2.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt2;
      } else {
        z = "UTC";
        this.dt = dt2.offset === 0 ? dt2 : dt2.setZone("UTC").plus({ minutes: dt2.offset });
        this.originalZone = dt2.zone;
      }
    } else if (dt2.zone.type === "system") {
      this.dt = dt2;
    } else if (dt2.zone.type === "iana") {
      this.dt = dt2;
      z = dt2.zone.name;
    } else {
      z = "UTC";
      this.dt = dt2.setZone("UTC").plus({ minutes: dt2.offset });
      this.originalZone = dt2.zone;
    }
    const intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    if (this.originalZone) {
      return this.formatToParts().map(({ value }) => value).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName
          });
          return {
            ...part,
            value: offsetName
          };
        } else {
          return part;
        }
      });
    }
    return parts;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class PolyRelFormatter {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  format(count2, unit) {
    if (this.rtf) {
      return this.rtf.format(count2, unit);
    } else {
      return formatRelativeTime(unit, count2, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count2, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count2, unit);
    } else {
      return [];
    }
  }
}
const fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class Locale {
  static fromOpts(opts) {
    return Locale.create(
      opts.locale,
      opts.numberingSystem,
      opts.outputCalendar,
      opts.weekSettings,
      opts.defaultToEN
    );
  }
  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null;
    intlDTCache.clear();
    intlNumCache.clear();
    intlRelCache.clear();
    intlResolvedOptionsCache.clear();
    weekInfoCache.clear();
  }
  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }
  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        validateWeekSettings(alts.weekSettings) || this.weekSettings,
        alts.defaultToEN || false
      );
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }
  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }
  months(length2, format2 = false) {
    return listStuff(this, length2, months, () => {
      const monthSpecialCase = this.intl === "ja" || this.intl.startsWith("ja-");
      format2 &= !monthSpecialCase;
      const intl = format2 ? { month: length2, day: "numeric" } : { month: length2 }, formatStr = format2 ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length2]) {
        const mapper = !monthSpecialCase ? (dt2) => this.extract(dt2, intl, "month") : (dt2) => this.dtFormatter(dt2, intl).format();
        this.monthsCache[formatStr][length2] = mapMonths(mapper);
      }
      return this.monthsCache[formatStr][length2];
    });
  }
  weekdays(length2, format2 = false) {
    return listStuff(this, length2, weekdays, () => {
      const intl = format2 ? { weekday: length2, year: "numeric", month: "long", day: "numeric" } : { weekday: length2 }, formatStr = format2 ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length2]) {
        this.weekdaysCache[formatStr][length2] = mapWeekdays(
          (dt2) => this.extract(dt2, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length2];
    });
  }
  meridiems() {
    return listStuff(
      this,
      void 0,
      () => meridiems,
      () => {
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(
            (dt2) => this.extract(dt2, intl, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(length2) {
    return listStuff(this, length2, eras, () => {
      const intl = { era: length2 };
      if (!this.eraCache[length2]) {
        this.eraCache[length2] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(
          (dt2) => this.extract(dt2, intl, "era")
        );
      }
      return this.eraCache[length2];
    });
  }
  extract(dt2, intlOpts, field) {
    const df2 = this.dtFormatter(dt2, intlOpts), results = df2.formatToParts(), matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt2, intlOpts = {}) {
    return new PolyDateFormatter(dt2, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let singleton = null;
class FixedOffsetZone extends Zone {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (singleton === null) {
      singleton = new FixedOffsetZone(0);
    }
    return singleton;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset2) {
    return offset2 === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset2);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s12) {
    if (s12) {
      const r12 = s12.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r12) {
        return new FixedOffsetZone(signedOffset(r12[1], r12[2]));
      }
    }
    return null;
  }
  constructor(offset2) {
    super();
    this.fixed = offset2;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts2, format2) {
    return formatOffset(this.fixed, format2);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return true;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return true;
  }
}
class InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    this.zoneName = zoneName;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return false;
  }
  /** @override **/
  get isValid() {
    return false;
  }
}
function normalizeZone(input, defaultZone2) {
  if (isUndefined(input) || input === null) {
    return defaultZone2;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString$1(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone2;
    else if (lowered === "local" || lowered === "system") return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
    else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    return input;
  } else {
    return new InvalidZone(input);
  }
}
const numberingSystems = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
};
const numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
};
const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min2, max2] = numberingSystemsUTF16[key];
          if (code >= min2 && code <= max2) {
            value += code - min2;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
const digitRegexCache = /* @__PURE__ */ new Map();
function resetDigitRegexCache() {
  digitRegexCache.clear();
}
function digitRegex({ numberingSystem }, append2 = "") {
  const ns = numberingSystem || "latn";
  let appendCache = digitRegexCache.get(ns);
  if (appendCache === void 0) {
    appendCache = /* @__PURE__ */ new Map();
    digitRegexCache.set(ns, appendCache);
  }
  let regex = appendCache.get(append2);
  if (regex === void 0) {
    regex = new RegExp(`${numberingSystems[ns]}${append2}`);
    appendCache.set(append2, regex);
  }
  return regex;
}
let now$1 = () => Date.now(), defaultZone = "system", defaultLocale = null, defaultNumberingSystem = null, defaultOutputCalendar = null, twoDigitCutoffYear = 60, throwOnInvalid, defaultWeekSettings = null;
class Settings {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now$1;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n12) {
    now$1 = n12;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone = zone;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t16) {
    throwOnInvalid = t16;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
    DateTime.resetCache();
    resetDigitRegexCache();
  }
}
class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
}
const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange(unit, value) {
  return new Invalid(
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}
function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  const js2 = d.getUTCDay();
  return js2 === 0 ? 7 : js2;
}
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex((i) => i < ordinal), day = ordinal - table[month0];
  return { month: month0 + 1, day };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return { weekYear, weekNumber, weekday, ...timeObject(gregObj) };
}
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(weekData) };
}
function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return { year, ordinal, ...timeObject(gregData) };
}
function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(ordinalData) };
}
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    }
    if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
  }
}
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger(obj.weekYear), validWeek = integerBetween(
    obj.weekNumber,
    1,
    weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)
  ), validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}
function isUndefined(o) {
  return typeof o === "undefined";
}
function isNumber(o) {
  return typeof o === "number";
}
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString$1(o) {
  return typeof o === "string";
}
function isDate$1(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}
function hasLocaleWeekInfo() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e) {
    return false;
  }
}
function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by2, compare5) {
  if (arr.length === 0) {
    return void 0;
  }
  return arr.reduce((best, next2) => {
    const pair = [by2(next2), next2];
    if (!best) {
      return pair;
    } else if (compare5(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick$1(obj, keys2) {
  return keys2.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}
function hasOwnProperty$2(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v) => !integerBetween(v, 1, 7))) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}
function integerBetween(thing, bottom2, top2) {
  return isInteger(thing) && thing >= bottom2 && thing <= top2;
}
function floorMod(x, n12) {
  return x - n12 * Math.floor(x / n12);
}
function padStart(input, n12 = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n12, "0");
  } else {
    padded = ("" + input).padStart(n12, "0");
  }
  return padded;
}
function parseInteger(string2) {
  if (isUndefined(string2) || string2 === null || string2 === "") {
    return void 0;
  } else {
    return parseInt(string2, 10);
  }
}
function parseFloating(string2) {
  if (isUndefined(string2) || string2 === null || string2 === "") {
    return void 0;
  } else {
    return parseFloat(string2);
  }
}
function parseMillis(fraction) {
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return void 0;
  } else {
    const f = parseFloat("0." + fraction) * 1e3;
    return Math.floor(f);
  }
}
function roundTo(number, digits, rounding = "round") {
  const factor = 10 ** digits;
  switch (rounding) {
    case "expand":
      return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
    case "trunc":
      return Math.trunc(number * factor) / factor;
    case "round":
      return Math.round(number * factor) / factor;
    case "floor":
      return Math.floor(number * factor) / factor;
    case "ceil":
      return Math.ceil(number * factor) / factor;
    default:
      throw new RangeError(`Value rounding ${rounding} is out of range`);
  }
}
function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}
function objToLocalTS(obj) {
  let d = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2e3 + year;
}
function parseZoneInfo(ts2, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts2), intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = { timeZoneName: offsetFormat, ...intlOpts };
  const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue))
    throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty$2(obj, u)) {
      const v = obj[u];
      if (v === void 0 || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}
function formatOffset(offset2, format2) {
  const hours = Math.trunc(Math.abs(offset2 / 60)), minutes = Math.trunc(Math.abs(offset2 % 60)), sign = offset2 >= 0 ? "+" : "-";
  switch (format2) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format2} is out of range for property format`);
  }
}
function timeObject(obj) {
  return pick$1(obj, ["hour", "minute", "second", "millisecond"]);
}
const monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
const monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length2) {
  switch (length2) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
const weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length2) {
  switch (length2) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const meridiems = ["AM", "PM"];
const erasLong = ["Before Christ", "Anno Domini"];
const erasShort = ["BC", "AD"];
const erasNarrow = ["B", "A"];
function eras(length2) {
  switch (length2) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}
function meridiemForDateTime(dt2) {
  return meridiems[dt2.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt2, length2) {
  return weekdays(length2)[dt2.weekday - 1];
}
function monthForDateTime(dt2, length2) {
  return months(length2)[dt2.month - 1];
}
function eraForDateTime(dt2, length2) {
  return eras(length2)[dt2.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count2, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count2) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
    }
  }
  const isInPast = Object.is(count2, -0) || count2 < 0, fmtValue = Math.abs(count2), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function stringifyTokens(splits, tokenToString) {
  let s12 = "";
  for (const token2 of splits) {
    if (token2.literal) {
      s12 += token2.val;
    } else {
      s12 += tokenToString(token2.val);
    }
  }
  return s12;
}
const macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
class Formatter {
  static create(locale, opts = {}) {
    return new Formatter(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null, currentFull = "", bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0 || bracketed) {
          splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull === "" ? "'" : currentFull
          });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: /^\s+$/.test(currentFull), val: currentFull });
        }
        currentFull = c;
        current = c;
      }
    }
    if (currentFull.length > 0) {
      splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token2) {
    return macroTokenToFormatOpts[token2];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt2, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df2 = this.systemLoc.dtFormatter(dt2, { ...this.opts, ...opts });
    return df2.format();
  }
  dtFormatter(dt2, opts = {}) {
    return this.loc.dtFormatter(dt2, { ...this.opts, ...opts });
  }
  formatDateTime(dt2, opts) {
    return this.dtFormatter(dt2, opts).format();
  }
  formatDateTimeParts(dt2, opts) {
    return this.dtFormatter(dt2, opts).formatToParts();
  }
  formatInterval(interval2, opts) {
    const df2 = this.dtFormatter(interval2.start, opts);
    return df2.dtf.formatRange(interval2.start.toJSDate(), interval2.end.toJSDate());
  }
  resolvedOptions(dt2, opts) {
    return this.dtFormatter(dt2, opts).resolvedOptions();
  }
  num(n12, p = 0, signDisplay = void 0) {
    if (this.opts.forceSimple) {
      return padStart(n12, p);
    }
    const opts = { ...this.opts };
    if (p > 0) {
      opts.padTo = p;
    }
    if (signDisplay) {
      opts.signDisplay = signDisplay;
    }
    return this.loc.numberFormatter(opts).format(n12);
  }
  formatDateTimeFromString(dt2, fmt) {
    const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string2 = (opts, extract2) => this.loc.extract(dt2, opts, extract2), formatOffset2 = (opts) => {
      if (dt2.isOffsetFixed && dt2.offset === 0 && opts.allowZ) {
        return "Z";
      }
      return dt2.isValid ? dt2.zone.formatOffset(dt2.ts, opts.format) : "";
    }, meridiem = () => knownEnglish ? meridiemForDateTime(dt2) : string2({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), month = (length2, standalone) => knownEnglish ? monthForDateTime(dt2, length2) : string2(standalone ? { month: length2 } : { month: length2, day: "numeric" }, "month"), weekday = (length2, standalone) => knownEnglish ? weekdayForDateTime(dt2, length2) : string2(
      standalone ? { weekday: length2 } : { weekday: length2, month: "long", day: "numeric" },
      "weekday"
    ), maybeMacro = (token2) => {
      const formatOpts = Formatter.macroTokenToFormatOpts(token2);
      if (formatOpts) {
        return this.formatWithSystemDefault(dt2, formatOpts);
      } else {
        return token2;
      }
    }, era = (length2) => knownEnglish ? eraForDateTime(dt2, length2) : string2({ era: length2 }, "era"), tokenToString = (token2) => {
      switch (token2) {
        // ms
        case "S":
          return this.num(dt2.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(dt2.millisecond, 3);
        // seconds
        case "s":
          return this.num(dt2.second);
        case "ss":
          return this.num(dt2.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(dt2.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(dt2.millisecond / 100));
        // minutes
        case "m":
          return this.num(dt2.minute);
        case "mm":
          return this.num(dt2.minute, 2);
        // hours
        case "h":
          return this.num(dt2.hour % 12 === 0 ? 12 : dt2.hour % 12);
        case "hh":
          return this.num(dt2.hour % 12 === 0 ? 12 : dt2.hour % 12, 2);
        case "H":
          return this.num(dt2.hour);
        case "HH":
          return this.num(dt2.hour, 2);
        // offset
        case "Z":
          return formatOffset2({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return formatOffset2({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return formatOffset2({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return dt2.zone.offsetName(dt2.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return dt2.zone.offsetName(dt2.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return dt2.zoneName;
        // meridiems
        case "a":
          return meridiem();
        // dates
        case "d":
          return useDateTimeFormatter ? string2({ day: "numeric" }, "day") : this.num(dt2.day);
        case "dd":
          return useDateTimeFormatter ? string2({ day: "2-digit" }, "day") : this.num(dt2.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(dt2.weekday);
        case "ccc":
          return weekday("short", true);
        case "cccc":
          return weekday("long", true);
        case "ccccc":
          return weekday("narrow", true);
        // weekdays - format
        case "E":
          return this.num(dt2.weekday);
        case "EEE":
          return weekday("short", false);
        case "EEEE":
          return weekday("long", false);
        case "EEEEE":
          return weekday("narrow", false);
        // months - standalone
        case "L":
          return useDateTimeFormatter ? string2({ month: "numeric", day: "numeric" }, "month") : this.num(dt2.month);
        case "LL":
          return useDateTimeFormatter ? string2({ month: "2-digit", day: "numeric" }, "month") : this.num(dt2.month, 2);
        case "LLL":
          return month("short", true);
        case "LLLL":
          return month("long", true);
        case "LLLLL":
          return month("narrow", true);
        // months - format
        case "M":
          return useDateTimeFormatter ? string2({ month: "numeric" }, "month") : this.num(dt2.month);
        case "MM":
          return useDateTimeFormatter ? string2({ month: "2-digit" }, "month") : this.num(dt2.month, 2);
        case "MMM":
          return month("short", false);
        case "MMMM":
          return month("long", false);
        case "MMMMM":
          return month("narrow", false);
        // years
        case "y":
          return useDateTimeFormatter ? string2({ year: "numeric" }, "year") : this.num(dt2.year);
        case "yy":
          return useDateTimeFormatter ? string2({ year: "2-digit" }, "year") : this.num(dt2.year.toString().slice(-2), 2);
        case "yyyy":
          return useDateTimeFormatter ? string2({ year: "numeric" }, "year") : this.num(dt2.year, 4);
        case "yyyyyy":
          return useDateTimeFormatter ? string2({ year: "numeric" }, "year") : this.num(dt2.year, 6);
        // eras
        case "G":
          return era("short");
        case "GG":
          return era("long");
        case "GGGGG":
          return era("narrow");
        case "kk":
          return this.num(dt2.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(dt2.weekYear, 4);
        case "W":
          return this.num(dt2.weekNumber);
        case "WW":
          return this.num(dt2.weekNumber, 2);
        case "n":
          return this.num(dt2.localWeekNumber);
        case "nn":
          return this.num(dt2.localWeekNumber, 2);
        case "ii":
          return this.num(dt2.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(dt2.localWeekYear, 4);
        case "o":
          return this.num(dt2.ordinal);
        case "ooo":
          return this.num(dt2.ordinal, 3);
        case "q":
          return this.num(dt2.quarter);
        case "qq":
          return this.num(dt2.quarter, 2);
        case "X":
          return this.num(Math.floor(dt2.ts / 1e3));
        case "x":
          return this.num(dt2.ts);
        default:
          return maybeMacro(token2);
      }
    };
    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
    const tokenToField = (token2) => {
      switch (token2[0]) {
        case "S":
          return "milliseconds";
        case "s":
          return "seconds";
        case "m":
          return "minutes";
        case "h":
          return "hours";
        case "d":
          return "days";
        case "w":
          return "weeks";
        case "M":
          return "months";
        case "y":
          return "years";
        default:
          return null;
      }
    }, tokenToString = (lildur, info) => (token2) => {
      const mapped = tokenToField(token2);
      if (mapped) {
        const inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
        let signDisplay;
        if (this.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) {
          signDisplay = "never";
        } else if (this.opts.signMode === "all") {
          signDisplay = "always";
        } else {
          signDisplay = "auto";
        }
        return this.num(lildur.get(mapped) * inversionFactor, token2.length, signDisplay);
      } else {
        return token2;
      }
    }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(
      (found, { literal, val }) => literal ? found : found.concat(val),
      []
    ), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t16) => t16)), durationInfo = {
      isNegativeDuration: collapsed < 0,
      // this relies on "collapsed" being based on "shiftTo", which builds up the object
      // in order
      largestUnit: Object.keys(collapsed.values)[0]
    };
    return stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
  }
}
const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r12) => f + r12.source, "");
  return RegExp(`^${full}$`);
}
function combineExtractors(...extractors) {
  return (m) => extractors.reduce(
    ([mergedVals, mergedZone, cursor2], ex2) => {
      const [val, zone, next2] = ex2(m, cursor2);
      return [{ ...mergedVals, ...val }, zone || mergedZone, next2];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function parse$4(s12, ...patterns) {
  if (s12 == null) {
    return [null, null];
  }
  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s12);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}
function simpleParse(...keys2) {
  return (match2, cursor2) => {
    const ret = {};
    let i;
    for (i = 0; i < keys2.length; i++) {
      ret[keys2[i]] = parseInteger(match2[cursor2 + i]);
    }
    return [ret, null, cursor2 + i];
  };
}
const offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:[Tt]${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData = simpleParse("year", "ordinal");
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/;
const sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int$1(match2, pos, fallback) {
  const m = match2[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match2, cursor2) {
  const item = {
    year: int$1(match2, cursor2),
    month: int$1(match2, cursor2 + 1, 1),
    day: int$1(match2, cursor2 + 2, 1)
  };
  return [item, null, cursor2 + 3];
}
function extractISOTime(match2, cursor2) {
  const item = {
    hours: int$1(match2, cursor2, 0),
    minutes: int$1(match2, cursor2 + 1, 0),
    seconds: int$1(match2, cursor2 + 2, 0),
    milliseconds: parseMillis(match2[cursor2 + 3])
  };
  return [item, null, cursor2 + 4];
}
function extractISOOffset(match2, cursor2) {
  const local = !match2[cursor2] && !match2[cursor2 + 1], fullOffset = signedOffset(match2[cursor2 + 1], match2[cursor2 + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor2 + 3];
}
function extractIANAZone(match2, cursor2) {
  const zone = match2[cursor2] ? IANAZone.create(match2[cursor2]) : null;
  return [{}, zone, cursor2 + 1];
}
const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
const isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match2) {
  const [s12, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match2;
  const hasNegativePrefix = s12[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = (num, force = false) => num !== void 0 && (force || num && hasNegativePrefix) ? -num : num;
  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
    }
  ];
}
const obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}
const rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match2) {
  const [
    ,
    weekdayStr,
    dayStr,
    monthStr,
    yearStr,
    hourStr,
    minuteStr,
    secondStr,
    obsOffset,
    milOffset,
    offHourStr,
    offMinuteStr
  ] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset2;
  if (obsOffset) {
    offset2 = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset2 = 0;
  } else {
    offset2 = signedOffset(offHourStr, offMinuteStr);
  }
  return [result, new FixedOffsetZone(offset2)];
}
function preprocessRFC2822(s12) {
  return s12.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
function extractASCII(match2) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
const extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOTimeAndOffset = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseISODate(s12) {
  return parse$4(
    s12,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}
function parseRFC2822Date(s12) {
  return parse$4(preprocessRFC2822(s12), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s12) {
  return parse$4(
    s12,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}
function parseISODuration(s12) {
  return parse$4(s12, [isoDuration, extractISODuration]);
}
const extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s12) {
  return parse$4(s12, [isoTimeOnly, extractISOTimeOnly]);
}
const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
const extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseSQL(s12) {
  return parse$4(
    s12,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}
const INVALID$2 = "Invalid Duration";
const lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, casualMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
}, daysInYearAccurate = 146097 / 400, daysInMonthAccurate = 146097 / 4800, accurateMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
};
const orderedUnits$1 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
];
const reverseUnits = orderedUnits$1.slice(0).reverse();
function clone$1(dur, alts, clear = false) {
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...alts.values || {} },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
function durationToMillis(matrix, vals) {
  let sum = vals.milliseconds ?? 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}
function normalizeValues(matrix, vals) {
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits$1.reduceRight((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);
  orderedUnits$1.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}
class Duration {
  /**
   * @private
   */
  constructor(config2) {
    const accurate = config2.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;
    if (config2.matrix) {
      matrix = config2.matrix;
    }
    this.values = config2.values;
    this.loc = config2.loc || Locale.create();
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    this.invalid = config2.invalid || null;
    this.matrix = matrix;
    this.isLuxonDuration = true;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count2, opts) {
    return Duration.fromObject({ milliseconds: count2 }, opts);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`
      );
    }
    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({ invalid });
    }
  }
  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o) {
    return o && o.isLuxonDuration || false;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false
    };
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID$2;
    const showZeros = opts.showZeros !== false;
    const l2 = orderedUnits$1.map((unit) => {
      const val = this.values[unit];
      if (isUndefined(val) || val === 0 && !showZeros) {
        return null;
      }
      return this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) }).format(val);
    }).filter((n12) => n12);
    return this.loc.listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts }).format(l2);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid) return {};
    return { ...this.values };
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let s12 = "P";
    if (this.years !== 0) s12 += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s12 += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s12 += this.weeks + "W";
    if (this.days !== 0) s12 += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s12 += "T";
    if (this.hours !== 0) s12 += this.hours + "H";
    if (this.minutes !== 0) s12 += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      s12 += roundTo(this.seconds + this.milliseconds / 1e3, 3) + "S";
    if (s12 === "P") s12 += "T0S";
    return s12;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 864e5) return null;
    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
      includeOffset: false
    };
    const dateTime = DateTime.fromMillis(millis, { zone: "UTC" });
    return dateTime.toISOTime(opts);
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    if (!this.isValid) return NaN;
    return durationToMillis(this.matrix, this.values);
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration2) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration2), result = {};
    for (const k of orderedUnits$1) {
      if (hasOwnProperty$2(dur.values, k) || hasOwnProperty$2(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }
    return clone$1(this, { values: result }, true);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration2) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration2);
    return this.plus(dur.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn3) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn3(this.values[k], k));
    }
    return clone$1(this, { values: result }, true);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values2) {
    if (!this.isValid) return this;
    const mixed = { ...this.values, ...normalizeObject(values2, Duration.normalizeUnit) };
    return clone$1(this, { values: mixed });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem });
    const opts = { loc, matrix, conversionAccuracy };
    return clone$1(this, opts);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid) return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map((u) => Duration.normalizeUnit(u));
    const built = {}, accumulated = {}, vals = this.toObject();
    let lastUnit;
    for (const k of orderedUnits$1) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        let own = 0;
        for (const ak2 in accumulated) {
          own += this.matrix[ak2][k] * accumulated[ak2];
          accumulated[ak2] = 0;
        }
        if (isNumber(vals[k])) {
          own += vals[k];
        }
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1e3 - i * 1e3) / 1e3;
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues(this.matrix, built);
    return clone$1(this, { values: built }, true);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone$1(this, { values: negated }, true);
  }
  /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */
  removeZeros() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.values);
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq2(v12, v22) {
      if (v12 === void 0 || v12 === 0) return v22 === void 0 || v22 === 0;
      return v12 === v22;
    }
    for (const u of orderedUnits$1) {
      if (!eq2(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
}
const INVALID$1 = "Invalid Interval";
function validateStartEnd(start2, end2) {
  if (!start2 || !start2.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end2 || !end2.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end2 < start2) {
    return Interval.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start2.toISO()} and end=${end2.toISO()}`
    );
  } else {
    return null;
  }
}
class Interval {
  /**
   * @private
   */
  constructor(config2) {
    this.s = config2.start;
    this.e = config2.end;
    this.invalid = config2.invalid || null;
    this.isLuxonInterval = true;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({ invalid });
    }
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start2, end2) {
    const builtStart = friendlyDateTime(start2), builtEnd = friendlyDateTime(end2);
    const validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start2, duration2) {
    const dur = Duration.fromDurationLike(duration2), dt2 = friendlyDateTime(start2);
    return Interval.fromDateTimes(dt2, dt2.plus(dur));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end2, duration2) {
    const dur = Duration.fromDurationLike(duration2), dt2 = friendlyDateTime(end2);
    return Interval.fromDateTimes(dt2.minus(dur), dt2);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s12, e] = (text || "").split("/", 2);
    if (s12 && e) {
      let start2, startIsValid;
      try {
        start2 = DateTime.fromISO(s12, opts);
        startIsValid = start2.isValid;
      } catch (e12) {
        startIsValid = false;
      }
      let end2, endIsValid;
      try {
        end2 = DateTime.fromISO(e, opts);
        endIsValid = end2.isValid;
      } catch (e12) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start2, end2);
      }
      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return Interval.after(start2, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s12, opts);
        if (dur.isValid) {
          return Interval.before(end2, dur);
        }
      }
    }
    return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o) {
    return o && o.isLuxonInterval || false;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid ? this.e ? this.e.minus(1) : null : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start2 = this.start.startOf(unit, opts);
    let end2;
    if (opts?.useLocaleWeeks) {
      end2 = this.end.reconfigure({ locale: start2.locale });
    } else {
      end2 = this.end;
    }
    end2 = end2.startOf(unit, opts);
    return Math.floor(end2.diff(start2, unit).get(unit)) + (end2.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: start2, end: end2 } = {}) {
    if (!this.isValid) return this;
    return Interval.fromDateTimes(start2 || this.s, end2 || this.e);
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes.map(friendlyDateTime).filter((d) => this.contains(d)).sort((a, b) => a.toMillis() - b.toMillis()), results = [];
    let { s: s12 } = this, i = 0;
    while (s12 < this.e) {
      const added = sorted[i] || this.e, next2 = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s12, next2));
      s12 = next2;
      i += 1;
    }
    return results;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration2) {
    const dur = Duration.fromDurationLike(duration2);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let { s: s12 } = this, idx = 1, next2;
    const results = [];
    while (s12 < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next2 = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s12, next2));
      s12 = next2;
      idx += 1;
    }
    return results;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid) return this;
    const s12 = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
    if (s12 >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s12, e);
    }
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid) return this;
    const s12 = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s12, e);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals.sort((a, b) => a.s - b.s).reduce(
      ([sofar, current], item) => {
        if (!current) {
          return [sofar, item];
        } else if (current.overlaps(item) || current.abutsStart(item)) {
          return [sofar, current.union(item)];
        } else {
          return [sofar.concat([current]), item];
        }
      },
      [[], null]
    );
    if (final) {
      found.push(final);
    }
    return found;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start2 = null, currentCount = 0;
    const results = [], ends = intervals.map((i) => [
      { time: i.s, type: "s" },
      { time: i.e, type: "e" }
    ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b) => a.time - b.time);
    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start2 = i.time;
      } else {
        if (start2 && +start2 !== +i.time) {
          results.push(Interval.fromDateTimes(start2, i.time));
        }
        start2 = null;
      }
    }
    return Interval.merge(results);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return Interval.xor([this].concat(intervals)).map((i) => this.intersection(i)).filter((i) => i && !i.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid) return INVALID$1;
    return `[${this.s.toISO()} – ${this.e.toISO()})`;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(dateFormat, { separator = " – " } = {}) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
}
class Info {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({ month: 12 });
    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(length2 = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length2);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(length2 = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length2, true);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length2 = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length2);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(length2 = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length2, true);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length2 = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length2);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: hasRelative(), localeWeek: hasLocaleWeekInfo() };
  }
}
function dayDiff(earlier, later) {
  const utcDayStart = (dt2) => dt2.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(), ms2 = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms2).as("days"));
}
function highOrderDiffs(cursor2, later, units) {
  const differs = [
    ["years", (a, b) => b.year - a.year],
    ["quarters", (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4],
    ["months", (a, b) => b.month - a.month + (b.year - a.year) * 12],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - days % 7) / 7;
      }
    ],
    ["days", dayDiff]
  ];
  const results = {};
  const earlier = cursor2;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor2, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        results[unit]--;
        cursor2 = earlier.plus(results);
        if (cursor2 > later) {
          highWater = cursor2;
          results[unit]--;
          cursor2 = earlier.plus(results);
        }
      } else {
        cursor2 = highWater;
      }
    }
  }
  return [cursor2, results, highWater, lowestOrder];
}
function diff(earlier, later, units, opts) {
  let [cursor2, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor2;
  const lowerOrderUnits = units.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor2.plus({ [lowestOrder]: 1 });
    }
    if (highWater !== cursor2) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor2);
    }
  }
  const duration2 = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration2);
  } else {
    return duration2;
  }
}
const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post2 = (i) => i) {
  return { regex, deser: ([s12]) => post2(parseDigits(s12)) };
}
const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `[ ${NBSP}]`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s12) {
  return s12.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s12) {
  return s12.replace(/\./g, "").replace(spaceOrNBSPRegExp, " ").toLowerCase();
}
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s12]) => strings.findIndex((i) => stripInsensitivities(s12) === stripInsensitivities(i)) + startIndex
    };
  }
}
function offset$2(regex, groups) {
  return { regex, deser: ([, h12, m]) => signedOffset(h12, m), groups };
}
function simple(regex) {
  return { regex, deser: ([s12]) => s12 };
}
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function unitForToken(token2, loc) {
  const one2 = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal = (t16) => ({ regex: RegExp(escapeToken(t16.val)), deser: ([s12]) => s12, literal: true }), unitate = (t16) => {
    if (token2.literal) {
      return literal(t16);
    }
    switch (t16.val) {
      // era
      case "G":
        return oneOf(loc.eras("short"), 0);
      case "GG":
        return oneOf(loc.eras("long"), 0);
      // years
      case "y":
        return intUnit(oneToSix);
      case "yy":
        return intUnit(twoToFour, untruncateYear);
      case "yyyy":
        return intUnit(four);
      case "yyyyy":
        return intUnit(fourToSix);
      case "yyyyyy":
        return intUnit(six);
      // months
      case "M":
        return intUnit(oneOrTwo);
      case "MM":
        return intUnit(two);
      case "MMM":
        return oneOf(loc.months("short", true), 1);
      case "MMMM":
        return oneOf(loc.months("long", true), 1);
      case "L":
        return intUnit(oneOrTwo);
      case "LL":
        return intUnit(two);
      case "LLL":
        return oneOf(loc.months("short", false), 1);
      case "LLLL":
        return oneOf(loc.months("long", false), 1);
      // dates
      case "d":
        return intUnit(oneOrTwo);
      case "dd":
        return intUnit(two);
      // ordinals
      case "o":
        return intUnit(oneToThree);
      case "ooo":
        return intUnit(three);
      // time
      case "HH":
        return intUnit(two);
      case "H":
        return intUnit(oneOrTwo);
      case "hh":
        return intUnit(two);
      case "h":
        return intUnit(oneOrTwo);
      case "mm":
        return intUnit(two);
      case "m":
        return intUnit(oneOrTwo);
      case "q":
        return intUnit(oneOrTwo);
      case "qq":
        return intUnit(two);
      case "s":
        return intUnit(oneOrTwo);
      case "ss":
        return intUnit(two);
      case "S":
        return intUnit(oneToThree);
      case "SSS":
        return intUnit(three);
      case "u":
        return simple(oneToNine);
      case "uu":
        return simple(oneOrTwo);
      case "uuu":
        return intUnit(one2);
      // meridiem
      case "a":
        return oneOf(loc.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return intUnit(four);
      case "kk":
        return intUnit(twoToFour, untruncateYear);
      // weekNumber (W)
      case "W":
        return intUnit(oneOrTwo);
      case "WW":
        return intUnit(two);
      // weekdays
      case "E":
      case "c":
        return intUnit(one2);
      case "EEE":
        return oneOf(loc.weekdays("short", false), 1);
      case "EEEE":
        return oneOf(loc.weekdays("long", false), 1);
      case "ccc":
        return oneOf(loc.weekdays("short", true), 1);
      case "cccc":
        return oneOf(loc.weekdays("long", true), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return offset$2(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
      case "ZZZ":
        return offset$2(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return simple(/[^\S\n\r]/);
      default:
        return literal(t16);
    }
  };
  const unit = unitate(token2) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token2;
  return unit;
}
const partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type, value } = part;
  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  const style2 = formatOpts[type];
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style2];
  }
  if (val) {
    return {
      literal: false,
      val
    };
  }
  return void 0;
}
function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r12) => `${f}(${r12.source})`, "");
  return [`^${re}$`, units];
}
function match$1(input, regex, handlers) {
  const matches = input.match(regex);
  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty$2(handlers, i)) {
        const h12 = handlers[i], groups = h12.groups ? h12.groups + 1 : 1;
        if (!h12.literal && h12.token) {
          all[h12.token.val[0]] = h12.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}
function dateTimeFromMatches(matches) {
  const toField = (token2) => {
    switch (token2) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  const vals = Object.keys(matches).reduce((r12, k) => {
    const f = toField(k);
    if (f) {
      r12[f] = matches[k];
    }
    return r12;
  }, {});
  return [vals, zone, specificOffset];
}
let dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
function maybeExpandMacroToken(token2, locale) {
  if (token2.literal) {
    return token2;
  }
  const formatOpts = Formatter.macroTokenToFormatOpts(token2.val);
  const tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(void 0)) {
    return token2;
  }
  return tokens;
}
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t16) => maybeExpandMacroToken(t16, locale)));
}
class TokenParser {
  constructor(locale, format2) {
    this.locale = locale;
    this.format = format2;
    this.tokens = expandMacroTokens(Formatter.parseFormat(format2), locale);
    this.units = this.tokens.map((t16) => unitForToken(t16, locale));
    this.disqualifyingUnit = this.units.find((t16) => t16.invalidReason);
    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }
  explainFromTokens(input) {
    if (!this.isValid) {
      return { input, tokens: this.tokens, invalidReason: this.invalidReason };
    } else {
      const [rawMatches, matches] = match$1(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [null, null, void 0];
      if (hasOwnProperty$2(matches, "a") && hasOwnProperty$2(matches, "H")) {
        throw new ConflictingSpecificationError(
          "Can't include meridiem when specifying 24-hour format"
        );
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches,
        result,
        zone,
        specificOffset
      };
    }
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function explainFromTokens(locale, input, format2) {
  const parser = new TokenParser(locale, format2);
  return parser.explainFromTokens(input);
}
function parseFromTokens(locale, input, format2) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format2);
  return [result, zone, specificOffset, invalidReason];
}
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter = Formatter.create(locale, formatOpts);
  const df2 = formatter.dtFormatter(getDummyDateTime());
  const parts = df2.formatToParts();
  const resolvedOpts = df2.resolvedOptions();
  return parts.map((p) => tokenForPart(p, formatOpts, resolvedOpts));
}
const INVALID$3 = "Invalid DateTime";
const MAX_DATE = 864e13;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
function possiblyCachedWeekData(dt2) {
  if (dt2.weekData === null) {
    dt2.weekData = gregorianToWeek(dt2.c);
  }
  return dt2.weekData;
}
function possiblyCachedLocalWeekData(dt2) {
  if (dt2.localWeekData === null) {
    dt2.localWeekData = gregorianToWeek(
      dt2.c,
      dt2.loc.getMinDaysInFirstWeek(),
      dt2.loc.getStartOfWeek()
    );
  }
  return dt2.localWeekData;
}
function clone(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime({ ...current, ...alts, old: current });
}
function fixOffset(localTS, o, tz2) {
  let utcGuess = localTS - o * 60 * 1e3;
  const o22 = tz2.offset(utcGuess);
  if (o === o22) {
    return [utcGuess, o];
  }
  utcGuess -= (o22 - o) * 60 * 1e3;
  const o32 = tz2.offset(utcGuess);
  if (o22 === o32) {
    return [utcGuess, o22];
  }
  return [localTS - Math.min(o22, o32) * 60 * 1e3, Math.max(o22, o32)];
}
function tsToObj(ts2, offset2) {
  ts2 += offset2 * 60 * 1e3;
  const d = new Date(ts2);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
}
function objToTS(obj, offset2, zone) {
  return fixOffset(objToLocalTS(obj), offset2, zone);
}
function adjustTime(inst, dur) {
  const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = {
    ...inst.c,
    year,
    month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }, millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"), localTS = objToLocalTS(c);
  let [ts2, o] = fixOffset(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts2 += millisToAdd;
    o = inst.zone.offset(ts2);
  }
  return { ts: ts2, o };
}
function parseDataToDateTime(parsed, parsedZone, opts, format2, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    const interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, {
      ...opts,
      zone: interpretationZone,
      specificOffset
    });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(
      new Invalid("unparsable", `the input "${text}" can't be parsed as ${format2}`)
    );
  }
}
function toTechFormat(dt2, format2, allowZ = true) {
  return dt2.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt2, format2) : null;
}
function toISODate(o, extended, precision) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);
  if (precision === "year") return c;
  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    if (precision === "month") return c;
    c += "-";
  } else {
    c += padStart(o.c.month);
    if (precision === "month") return c;
  }
  c += padStart(o.c.day);
  return c;
}
function toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
  let showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
  switch (precision) {
    case "day":
    case "month":
    case "year":
      break;
    default:
      c += padStart(o.c.hour);
      if (precision === "hour") break;
      if (extended) {
        c += ":";
        c += padStart(o.c.minute);
        if (precision === "minute") break;
        if (showSeconds) {
          c += ":";
          c += padStart(o.c.second);
        }
      } else {
        c += padStart(o.c.minute);
        if (precision === "minute") break;
        if (showSeconds) {
          c += padStart(o.c.second);
        }
      }
      if (precision === "second") break;
      if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
        c += ".";
        c += padStart(o.c.millisecond, 3);
      }
  }
  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }
  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}
const defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
const orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"], orderedWeekUnits = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}
function guessOffsetForZone(zone) {
  if (zoneOffsetTs === void 0) {
    zoneOffsetTs = Settings.now();
  }
  if (zone.type !== "iana") {
    return zone.offset(zoneOffsetTs);
  }
  const zoneName = zone.name;
  let offsetGuess = zoneOffsetGuessCache.get(zoneName);
  if (offsetGuess === void 0) {
    offsetGuess = zone.offset(zoneOffsetTs);
    zoneOffsetGuessCache.set(zoneName, offsetGuess);
  }
  return offsetGuess;
}
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }
  const loc = Locale.fromObject(opts);
  let ts2, o;
  if (!isUndefined(obj.year)) {
    for (const u of orderedUnits) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const offsetProvis = guessOffsetForZone(zone);
    [ts2, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts2 = Settings.now();
  }
  return new DateTime({ ts: ts2, zone, loc, o });
}
function diffRelative(start2, end2, opts) {
  const round2 = isUndefined(opts.round) ? true : opts.round, rounding = isUndefined(opts.rounding) ? "trunc" : opts.rounding, format2 = (c, unit) => {
    c = roundTo(c, round2 || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
    const formatter = end2.loc.clone(opts).relFormatter(opts);
    return formatter.format(c, unit);
  }, differ = (unit) => {
    if (opts.calendary) {
      if (!end2.hasSame(start2, unit)) {
        return end2.startOf(unit).diff(start2.startOf(unit), unit).get(unit);
      } else return 0;
    } else {
      return end2.diff(start2, unit).get(unit);
    }
  };
  if (opts.unit) {
    return format2(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count2 = differ(unit);
    if (Math.abs(count2) >= 1) {
      return format2(count2, unit);
    }
  }
  return format2(start2 > end2 ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
  let opts = {}, args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}
let zoneOffsetTs;
const zoneOffsetGuessCache = /* @__PURE__ */ new Map();
class DateTime {
  /**
   * @access private
   */
  constructor(config2) {
    const zone = config2.zone || Settings.defaultZone;
    let invalid = config2.invalid || (Number.isNaN(config2.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    this.ts = isUndefined(config2.ts) ? Settings.now() : config2.ts;
    let c = null, o = null;
    if (!invalid) {
      const unchanged = config2.old && config2.old.ts === this.ts && config2.old.zone.equals(zone);
      if (unchanged) {
        [c, o] = [config2.old.c, config2.old.o];
      } else {
        const ot2 = isNumber(config2.o) && !config2.old ? config2.o : zone.offset(this.ts);
        c = tsToObj(this.ts, ot2);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot2;
      }
    }
    this._zone = zone;
    this.loc = config2.loc || Locale.create();
    this.invalid = invalid;
    this.weekData = null;
    this.localWeekData = null;
    this.c = c;
    this.o = o;
    this.isLuxonDateTime = true;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new DateTime({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date, options = {}) {
    const ts2 = isDate$1(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts2)) {
      return DateTime.invalid("invalid input");
    }
    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new DateTime({
      ts: ts2,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1e3,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);
    const tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
    let units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }
    const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc
    });
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }
    if (!inst.isValid) {
      return DateTime.invalid(inst.invalid);
    }
    return inst;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    }), [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return DateTime.fromFormat(text, fmt, opts);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({ invalid });
    }
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t16) => t16 ? t16.val : null).join("");
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t16) => t16.val).join("");
  }
  static resetCache() {
    zoneOffsetTs = void 0;
    zoneOffsetGuessCache.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Info.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Info.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
    }
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    const dayMs = 864e5;
    const minuteMs = 6e4;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);
    const o12 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o22 = this.zone.offset(localTS - oLater * minuteMs);
    if (o12 === o22) {
      return [this];
    }
    const ts12 = localTS - o12 * minuteMs;
    const ts2 = localTS - o22 * minuteMs;
    const c1 = tsToObj(ts12, o12);
    const c22 = tsToObj(ts2, o22);
    if (c1.hour === c22.hour && c1.minute === c22.minute && c1.second === c22.second && c1.millisecond === c22.millisecond) {
      return [clone(this, { ts: ts12 }), clone(this, { ts: ts2 })];
    }
    return [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? weeksInWeekYear(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar: calendar2 } = Formatter.create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar2 };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset2 = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset2), opts);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone(this, { ts: newTS, zone });
    }
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone(this, { loc });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({ locale });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values2) {
    if (!this.isValid) return this;
    const normalized = normalizeObject(values2, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);
    const settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(
        { ...gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), ...normalized },
        minDaysInFirstWeek,
        startOfWeek
      );
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts2, o] = objToTS(mixed, this.o, this.zone);
    return clone(this, { ts: ts2, o });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration2) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration2);
    return clone(this, adjustTime(this, dur));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration2) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration2).negate();
    return clone(this, adjustTime(this, dur));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;
    const o = {}, normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
    }
    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }
    return this.set(o);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit, opts) {
    return this.isValid ? this.plus({ [unit]: 1 }).startOf(unit, opts).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID$3;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID$3;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */
  toISO({
    format: format2 = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false,
    precision = "milliseconds"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    precision = normalizeUnit(precision);
    const ext = format2 === "extended";
    let c = toISODate(this, ext, precision);
    if (orderedUnits.indexOf(precision) >= 3) c += "T";
    c += toISOTime(
      this,
      ext,
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone,
      precision
    );
    return c;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */
  toISODate({ format: format2 = "extended", precision = "day" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format2 === "extended", normalizeUnit(precision));
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format: format2 = "extended",
    precision = "milliseconds"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    precision = normalizeUnit(precision);
    let c = includePrefix && orderedUnits.indexOf(precision) >= 3 ? "T" : "";
    return c + toISOTime(
      this,
      format2 === "extended",
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone,
      precision
    );
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID$3;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid) return {};
    const base = { ...this.c };
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };
    const units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(DateTime.now(), unit, opts);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || DateTime.fromObject({}, { zone: this.zone }), padding2 = options.padding ? this < base ? -options.padding : options.padding : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = void 0;
    }
    return diffRelative(base, this.plus(padding2), {
      ...options,
      numeric: "always",
      units,
      unit
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;
    return diffRelative(options.base || DateTime.fromObject({}, { zone: this.zone }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    });
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options = {}) {
    return DateTime.fromFormatExplain(text, fmt, options);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return new TokenParser(localeToUse, fmt);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined(text) || isUndefined(formatParser)) {
      throw new InvalidArgumentError(
        "fromFormatParser requires an input string and a format parser"
      );
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError(
        `fromFormatParser called with a locale of ${localeToUse}, but the format parser was created for ${formatParser.locale}`
      );
    }
    const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);
    if (invalidReason) {
      return DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(
        result,
        zone,
        opts,
        `format ${formatParser.format}`,
        text,
        specificOffset
      );
    }
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
}
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}
const destroy = async (url2, options) => request({ url: url2, method: "DELETE", options });
const get$1 = async (url2, action, options) => request({ action, url: url2, method: "GET", options });
const post = async (url2, body, options) => request({ url: url2, method: "POST", body, options });
const postFile = async (url2, file) => requestFileUpload({ url: url2, file });
const put = async (url2, body, options) => request({ url: url2, method: "PUT", body, options });
const FAILURE_DELAY_SECONDS = 60;
const INTERVAL_DELAY_SECONDS = 5;
const SEND_LOGS_CHUNK_SIZE = 5;
const PLATFORM_MSGS = [PLATFORM_REQUEST_MSG, PLATFORM_RESPONSE_MSG];
let buffer$1 = [];
let last = DateTime.local().minus({ minutes: 5 });
let failureCutoff = DateTime.local().minus({ minutes: 5 });
let interval = null;
const toPlatformLog = (log2) => {
  const context2 = {};
  Object.keys(omit$1(log2, ["msg", "level", "ts"])).forEach((k) => {
    context2[k] = JSON.stringify(log2[k]);
  });
  return {
    msg: log2.msg,
    level: LogLevel[log2.level],
    timestamp: DateTime.fromMillis(log2.ts).toUTC().toISO(),
    context: context2
  };
};
const handleFailure = (e) => {
  const now2 = DateTime.local();
  if (e.statusCode === 401 && now2 > failureCutoff) {
    failureCutoff = now2.plus({ seconds: FAILURE_DELAY_SECONDS });
  }
};
const canSendLogs = () => {
  const now2 = DateTime.local();
  return buffer$1.length > 0 && Math.abs(now2.diff(last).as("seconds")) > INTERVAL_DELAY_SECONDS && now2 > failureCutoff;
};
const sendLogs = async (clientName) => {
  const toPush = [...buffer$1];
  buffer$1 = [];
  await Promise.allSettled(
    chunk(toPush, SEND_LOGS_CHUNK_SIZE).map(
      (chunk2) => post("/log", {
        clientAppId: clientName,
        msgs: chunk2.map(toPlatformLog)
      }).catch(handleFailure)
    )
  );
  last = DateTime.local();
  return toPush.length;
};
const makePlatformLogTransport = (clientName) => (log2) => {
  if (!PLATFORM_MSGS.includes(log2.msg)) {
    buffer$1.push(log2);
  }
  if (!interval) {
    interval = setInterval(() => {
      if (canSendLogs()) {
        sendLogs(clientName);
      }
    }, INTERVAL_DELAY_SECONDS * 1e3);
  }
};
const token$1 = "%[a-f0-9]{2}";
const multiMatcher = new RegExp(`(${token$1})+`, "gi");
const hexPair = /^[a-f\d]{2}$/i;
function parsePercentByte(input, position2) {
  if (input.codePointAt(position2) !== 37 || position2 + 3 > input.length) {
    return;
  }
  const digits = input.slice(position2 + 1, position2 + 3);
  if (!hexPair.test(digits)) {
    return;
  }
  return { byte: Number.parseInt(digits, 16), next: position2 + 3 };
}
function utf8SequenceLength(byte) {
  if (byte <= 127) {
    return 1;
  }
  if (byte >= 194 && byte <= 223) {
    return 2;
  }
  if (byte >= 224 && byte <= 239) {
    return 3;
  }
  if (byte >= 240 && byte <= 244) {
    return 4;
  }
  return 0;
}
function isContinuationByte(byte) {
  return byte >= 128 && byte <= 191;
}
function decode$1(input) {
  try {
    return decodeURIComponent(input);
  } catch {
    let output = "";
    let position2 = 0;
    while (position2 < input.length) {
      if (input.codePointAt(position2) !== 37) {
        output += input.charAt(position2);
        position2++;
        continue;
      }
      const firstByte = parsePercentByte(input, position2);
      if (!firstByte) {
        output += input.charAt(position2);
        position2++;
        continue;
      }
      const sequenceLength = utf8SequenceLength(firstByte.byte);
      if (sequenceLength === 0) {
        output += input.slice(position2, position2 + 3);
        position2 += 3;
        continue;
      }
      let end2 = firstByte.next;
      let validSequence = true;
      for (let index2 = 1; index2 < sequenceLength; index2++) {
        const nextByte = parsePercentByte(input, end2);
        if (!nextByte || !isContinuationByte(nextByte.byte)) {
          validSequence = false;
          break;
        }
        end2 = nextByte.next;
      }
      if (validSequence) {
        const encodedSequence = input.slice(position2, end2);
        try {
          output += decodeURIComponent(encodedSequence);
          position2 = end2;
          continue;
        } catch {
        }
      }
      output += input.slice(position2, position2 + 3);
      position2 += 3;
    }
    return output;
  }
}
function customDecodeURIComponent(input) {
  const replaceMap = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let match2 = multiMatcher.exec(input);
  while (match2) {
    try {
      replaceMap[match2[0]] = decodeURIComponent(match2[0]);
    } catch {
      const result = decode$1(match2[0]);
      if (result !== match2[0]) {
        replaceMap[match2[0]] = result;
      }
    }
    match2 = multiMatcher.exec(input);
  }
  replaceMap["%C2"] = "�";
  const entries2 = Object.keys(replaceMap);
  for (const key of entries2) {
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
  }
  return input;
}
function decodeUriComponent(encodedURI) {
  if (typeof encodedURI !== "string") {
    throw new TypeError(`Expected \`encodedURI\` to be of type \`string\`, got \`${typeof encodedURI}\``);
  }
  try {
    return decodeURIComponent(encodedURI);
  } catch {
    return customDecodeURIComponent(encodedURI);
  }
}
function includeKeys(object, predicate) {
  const result = {};
  if (Array.isArray(predicate)) {
    for (const key of predicate) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      if (descriptor?.enumerable) {
        Object.defineProperty(result, key, descriptor);
      }
    }
  } else {
    for (const key of Reflect.ownKeys(object)) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      if (descriptor.enumerable) {
        const value = object[key];
        if (predicate(key, value, object)) {
          Object.defineProperty(result, key, descriptor);
        }
      }
    }
  }
  return result;
}
function splitOnFirst(string2, separator) {
  if (!(typeof string2 === "string" && typeof separator === "string")) {
    throw new TypeError("Expected the arguments to be of type `string`");
  }
  if (string2 === "" || separator === "") {
    return [];
  }
  const separatorIndex = string2.indexOf(separator);
  if (separatorIndex === -1) {
    return [];
  }
  return [
    string2.slice(0, separatorIndex),
    string2.slice(separatorIndex + separator.length)
  ];
}
const isNullOrUndefined = (value) => value === null || value === void 0;
const strictUriEncode = (string2) => encodeURIComponent(string2).replaceAll(/[!'()*]/g, (x) => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const encodeFragmentIdentifier = /* @__PURE__ */ Symbol("encodeFragmentIdentifier");
function encoderForArrayFormat(options) {
  switch (options.arrayFormat) {
    case "index": {
      return (key) => (result, value) => {
        const index2 = result.length;
        if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
          return result;
        }
        if (value === null) {
          result.push([encode(key, options), "[", index2, "]"].join(""));
          return result;
        }
        result.push([encode(key, options), "[", encode(index2, options), "]=", encode(value, options)].join(""));
        return result;
      };
    }
    case "bracket": {
      return (key) => (result, value) => {
        if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
          return result;
        }
        if (value === null) {
          result.push([encode(key, options), "[]"].join(""));
          return result;
        }
        result.push([encode(key, options), "[]=", encode(value, options)].join(""));
        return result;
      };
    }
    case "colon-list-separator": {
      return (key) => (result, value) => {
        if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
          return result;
        }
        if (value === null) {
          result.push([encode(key, options), ":list="].join(""));
          return result;
        }
        result.push([encode(key, options), ":list=", encode(value, options)].join(""));
        return result;
      };
    }
    case "comma":
    case "separator":
    case "bracket-separator": {
      const keyValueSeparator = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (key) => (result, value) => {
        if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
          return result;
        }
        value = value === null ? "" : value;
        if (result.length === 0) {
          result.push([encode(key, options), keyValueSeparator, encode(value, options)].join(""));
          return result;
        }
        result.push(encode(value, options));
        return result;
      };
    }
    default: {
      return (key) => (result, value) => {
        if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
          return result;
        }
        if (value === null) {
          result.push(encode(key, options));
          return result;
        }
        result.push([encode(key, options), "=", encode(value, options)].join(""));
        return result;
      };
    }
  }
}
function parserForArrayFormat(options) {
  let result;
  switch (options.arrayFormat) {
    case "index": {
      return (key, value, accumulator) => {
        result = /\[(\d*)]$/.exec(key);
        key = key.replace(/\[\d*]$/, "");
        if (!result) {
          accumulator[key] = value;
          return;
        }
        if (accumulator[key] === void 0) {
          accumulator[key] = {};
        }
        accumulator[key][result[1]] = value;
      };
    }
    case "bracket": {
      return (key, value, accumulator) => {
        result = /(\[])$/.exec(key);
        key = key.replace(/\[]$/, "");
        if (!result) {
          accumulator[key] = value;
          return;
        }
        if (accumulator[key] === void 0) {
          accumulator[key] = [value];
          return;
        }
        if (!Array.isArray(accumulator[key])) {
          accumulator[key] = [accumulator[key], value];
          return;
        }
        accumulator[key].push(value);
      };
    }
    case "colon-list-separator": {
      return (key, value, accumulator) => {
        result = /(:list)$/.exec(key);
        key = key.replace(/:list$/, "");
        if (!result) {
          accumulator[key] = value;
          return;
        }
        if (accumulator[key] === void 0) {
          accumulator[key] = [value];
          return;
        }
        if (!Array.isArray(accumulator[key])) {
          accumulator[key] = [accumulator[key], value];
          return;
        }
        accumulator[key].push(value);
      };
    }
    case "comma":
    case "separator": {
      return (key, value, accumulator) => {
        const isArray2 = typeof value === "string" && value.includes(options.arrayFormatSeparator);
        const newValue = isArray2 ? value.split(options.arrayFormatSeparator).map((item) => decode(item, options)) : value === null ? value : decode(value, options);
        accumulator[key] = newValue;
      };
    }
    case "bracket-separator": {
      return (key, value, accumulator) => {
        const isArray2 = /(\[])$/.test(key);
        key = key.replace(/\[]$/, "");
        if (!isArray2) {
          accumulator[key] = value ? decode(value, options) : value;
          return;
        }
        const arrayValue = value === null ? [] : decode(value, options).split(options.arrayFormatSeparator);
        if (accumulator[key] === void 0) {
          accumulator[key] = arrayValue;
          return;
        }
        if (!Array.isArray(accumulator[key])) {
          accumulator[key] = [accumulator[key]];
        }
        for (const item of arrayValue) {
          accumulator[key].push(item);
        }
      };
    }
    default: {
      return (key, value, accumulator) => {
        if (accumulator[key] === void 0) {
          accumulator[key] = value;
          return;
        }
        if (Array.isArray(accumulator[key])) {
          accumulator[key].push(value);
          return;
        }
        accumulator[key] = [accumulator[key], value];
      };
    }
  }
}
function validateArrayFormatSeparator(value) {
  if (typeof value !== "string" || value.length !== 1) {
    throw new TypeError("arrayFormatSeparator must be single character string");
  }
}
function encode(value, options) {
  if (options.encode) {
    return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
  }
  return value;
}
function decode(value, options) {
  if (options.decode) {
    return decodeUriComponent(value);
  }
  return value;
}
function keysSorter(input) {
  if (Array.isArray(input)) {
    return input.sort();
  }
  if (typeof input === "object") {
    return keysSorter(Object.keys(input)).sort((a, b) => Number(a) - Number(b)).map((key) => input[key]);
  }
  return input;
}
function removeHash(input) {
  const hashStart = input.indexOf("#");
  if (hashStart !== -1) {
    input = input.slice(0, hashStart);
  }
  return input;
}
function getHash(url2) {
  let hash2 = "";
  const hashStart = url2.indexOf("#");
  if (hashStart !== -1) {
    hash2 = url2.slice(hashStart);
  }
  return hash2;
}
function getUrlWithoutQuery(url2) {
  const queryStart = url2.indexOf("?");
  return queryStart === -1 ? url2 : url2.slice(0, queryStart);
}
function parseValue(value, options, type) {
  if (type === "string" && typeof value === "string") {
    return value;
  }
  if (typeof type === "function" && typeof value === "string") {
    return type(value);
  }
  if (type === "boolean" && value === null) {
    return true;
  }
  if (type === "boolean" && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) {
    return value.toLowerCase() === "true";
  }
  if (type === "boolean" && value !== null && (value.toLowerCase() === "1" || value.toLowerCase() === "0")) {
    return value.toLowerCase() === "1";
  }
  if (type === "string[]" && options.arrayFormat !== "none" && typeof value === "string") {
    return [value];
  }
  if (type === "number[]" && options.arrayFormat !== "none" && !Number.isNaN(Number(value)) && (typeof value === "string" && value.trim() !== "")) {
    return [Number(value)];
  }
  if (type === "number" && !Number.isNaN(Number(value)) && (typeof value === "string" && value.trim() !== "")) {
    return Number(value);
  }
  if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) {
    return value.toLowerCase() === "true";
  }
  if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === "string" && value.trim() !== "")) {
    return Number(value);
  }
  return value;
}
function extract(input) {
  input = removeHash(input);
  const queryStart = input.indexOf("?");
  if (queryStart === -1) {
    return "";
  }
  return input.slice(queryStart + 1);
}
function parse$3(query, options) {
  options = {
    decode: true,
    sort: true,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: false,
    parseBooleans: false,
    types: /* @__PURE__ */ Object.create(null),
    ...options
  };
  validateArrayFormatSeparator(options.arrayFormatSeparator);
  const formatter = parserForArrayFormat(options);
  const returnValue = /* @__PURE__ */ Object.create(null);
  if (typeof query !== "string") {
    return returnValue;
  }
  query = query.trim().replace(/^[?#&]/, "");
  if (!query) {
    return returnValue;
  }
  if (/^&+$/.test(query)) {
    return returnValue;
  }
  let parameterStart = 0;
  let firstSeparator = query.indexOf("&");
  if (firstSeparator === -1) {
    firstSeparator = query.length;
  }
  for (let index2 = firstSeparator; index2 <= query.length; index2++) {
    if (index2 < query.length && query[index2] !== "&") {
      continue;
    }
    if (index2 === parameterStart) {
      parameterStart = index2 + 1;
      continue;
    }
    const parameter = query.slice(parameterStart, index2);
    const parameter_ = options.decode ? parameter.replaceAll("+", " ") : parameter;
    let [key, value] = splitOnFirst(parameter_, "=");
    if (key === void 0) {
      key = parameter_;
    }
    value = value === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(options.arrayFormat) ? value : decode(value, options);
    formatter(decode(key, options), value, returnValue);
    parameterStart = index2 + 1;
  }
  for (const [key, value] of Object.entries(returnValue)) {
    if (typeof value === "object" && value !== null && options.types[key] !== "string") {
      for (const [key2, value2] of Object.entries(value)) {
        const typeOption = options.types[key];
        const type = typeof typeOption === "function" ? typeOption : typeOption ? typeOption.replace("[]", "") : void 0;
        value[key2] = parseValue(value2, options, type);
      }
    } else if (typeof value === "object" && value !== null && options.types[key] === "string") {
      returnValue[key] = Object.values(value).join(options.arrayFormatSeparator);
    } else {
      returnValue[key] = parseValue(value, options, options.types[key]);
    }
  }
  if (options.sort === false) {
    return returnValue;
  }
  return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key) => {
    const value = returnValue[key];
    result[key] = Boolean(value) && typeof value === "object" && !Array.isArray(value) ? keysSorter(value) : value;
    return result;
  }, /* @__PURE__ */ Object.create(null));
}
function stringify$3(object, options) {
  if (!object) {
    return "";
  }
  options = {
    encode: true,
    strict: true,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...options
  };
  validateArrayFormatSeparator(options.arrayFormatSeparator);
  const shouldFilter = (key) => options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
  const formatter = encoderForArrayFormat(options);
  const objectCopy = {};
  for (const [key, value] of Object.entries(object)) {
    if (!shouldFilter(key)) {
      objectCopy[key] = value;
    }
  }
  const keys2 = Object.keys(objectCopy);
  if (options.sort !== false) {
    keys2.sort(options.sort);
  }
  return keys2.map((key) => {
    let value = object[key];
    if (options.replacer) {
      value = options.replacer(key, value);
      if (value === void 0) {
        return "";
      }
    }
    if (value === void 0) {
      return "";
    }
    if (value === null) {
      return encode(key, options);
    }
    if (Array.isArray(value)) {
      if (value.length === 0 && options.arrayFormat === "bracket-separator") {
        return encode(key, options) + "[]";
      }
      let processedArray = value;
      if (options.replacer) {
        processedArray = value.map(
          (item, index2) => options.replacer(`${key}[${index2}]`, item)
        ).filter((item) => item !== void 0);
      }
      const result = processedArray.reduce(formatter(key), []);
      const arrayFormatSeparator = ["comma", "separator", "bracket-separator"].includes(options.arrayFormat) ? options.arrayFormatSeparator : "&";
      return result.join(arrayFormatSeparator);
    }
    return encode(key, options) + "=" + encode(value, options);
  }).filter((x) => x.length > 0).join("&");
}
function parseUrl(url2, options) {
  options = {
    decode: true,
    ...options
  };
  let [url_, hash2] = splitOnFirst(url2, "#");
  if (url_ === void 0) {
    url_ = url2;
  }
  return {
    url: getUrlWithoutQuery(url_ ?? ""),
    query: parse$3(extract(url2), options),
    ...options && options.parseFragmentIdentifier && hash2 ? { fragmentIdentifier: decode(hash2, options) } : {}
  };
}
function stringifyUrl(object, options) {
  options = {
    encode: true,
    strict: true,
    [encodeFragmentIdentifier]: true,
    ...options
  };
  const url2 = getUrlWithoutQuery(removeHash(object.url)) || "";
  const queryFromUrl = extract(object.url);
  const query = {
    ...parse$3(queryFromUrl, { sort: false, ...options }),
    ...object.query
  };
  let queryString2 = stringify$3(query, options);
  queryString2 &&= `?${queryString2}`;
  let hash2 = getHash(object.url);
  if (typeof object.fragmentIdentifier === "string") {
    hash2 = `#${object.fragmentIdentifier}`;
    if (options[encodeFragmentIdentifier]) {
      const throwawayUrl = new URL("https://query-string.invalid");
      throwawayUrl.hash = hash2;
      hash2 = throwawayUrl.hash;
    }
  }
  return `${url2}${queryString2}${hash2}`;
}
function pick(input, filter, options) {
  options = {
    parseFragmentIdentifier: true,
    [encodeFragmentIdentifier]: false,
    ...options
  };
  const { url: url2, query, fragmentIdentifier } = parseUrl(input, options);
  return stringifyUrl({
    url: url2,
    query: includeKeys(query, filter),
    fragmentIdentifier
  }, options);
}
function exclude(input, filter, options) {
  if (Array.isArray(filter)) {
    const filterSet = new Set(filter);
    return pick(input, (key) => !filterSet.has(key), options);
  }
  return pick(input, (key, value) => !filter(key, value), options);
}
const queryString = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude,
  extract,
  parse: parse$3,
  parseUrl,
  pick,
  stringify: stringify$3,
  stringifyUrl
}, Symbol.toStringTag, { value: "Module" }));
const url = (url2, query) => queryString.stringifyUrl({ url: url2, query });
const getCostElements = async ({
  page,
  pageSize: pageSize2
}) => get$1(url("/cost-elements", { page, pageSize: pageSize2 }));
const getCostStructures = async ({
  active,
  page,
  pageSize: pageSize2
}) => get$1(
  url("/cost-structures", { active, page, pageSize: pageSize2 })
);
const getCostStructureLabor = async ({
  costStructureKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/cost-structures/${costStructureKey}/labor`, {
    page,
    pageSize: pageSize2
  })
);
const fetchAllItems = async ({
  fetch: fetch2,
  errorMessage = "Fetching all items failed",
  throwOnPageError = false
}) => {
  try {
    const items = [];
    for (let page = 1, pageCount = page; page <= pageCount; ++page) {
      try {
        const resultPage = await fetch2(page)();
        items.push(...resultPage.items);
        pageCount = resultPage.pageCount;
      } catch (e) {
        if (throwOnPageError) {
          throw e;
        }
        if (page === 1) {
          pageCount++;
        }
        log.warn({ msg: errorMessage, error: `${e}`, page, pageCount });
      }
    }
    return items;
  } catch (e) {
    log.warn({ msg: errorMessage, error: `${e}` });
    throw e;
  }
};
var AccountCategoryModel;
((AccountCategoryModel2) => {
  AccountCategoryModel2.CategoryEnum = {
    BILLED: "BILLED",
    DEFERREDREVENUE: "DEFERRED_REVENUE",
    RECOGNIZEDREVENUE: "RECOGNIZED_REVENUE",
    TAX: "TAX",
    UNBILLED: "UNBILLED",
    LABORCOST: "LABOR_COST",
    LABORCOSTOFFSETEMPLOYEES: "LABOR_COST_OFFSET_EMPLOYEES",
    REVENUEWRITEOFF: "REVENUE_WRITE_OFF",
    FUNDINGCAPADJUSTMENTREVENUE: "FUNDING_CAP_ADJUSTMENT_REVENUE",
    ARDISCOUNTTAKEN: "AR_DISCOUNT_TAKEN",
    ARSMALLBALANCEWRITEOFF: "AR_SMALL_BALANCE_WRITE_OFF",
    ARUNAPPLIEDPAYMENTACCOUNT: "AR_UNAPPLIED_PAYMENT_ACCOUNT",
    ACCOUNTSPAYABLE: "ACCOUNTS_PAYABLE",
    APDISCOUNTTAKEN: "AP_DISCOUNT_TAKEN",
    APUNAPPLIEDPAYMENTACCOUNT: "AP_UNAPPLIED_PAYMENT_ACCOUNT",
    EXPENSEREPORTCOST: "EXPENSE_REPORT_COST",
    EXPENSEREPORTOFFSETREIMBURSABLE: "EXPENSE_REPORT_OFFSET_REIMBURSABLE",
    EXPENSEREPORTOFFSETNONREIMBURSABLE: "EXPENSE_REPORT_OFFSET_NON_REIMBURSABLE",
    LABORCOSTOFFSETSUBCONTRACTORS: "LABOR_COST_OFFSET_SUBCONTRACTORS",
    CROSSCHARGELABOR: "CROSS_CHARGE_LABOR",
    CROSSCHARGELABOROFFSET: "CROSS_CHARGE_LABOR_OFFSET",
    FIXEDFEEADJUSTMENTREVENUE: "FIXED_FEE_ADJUSTMENT_REVENUE",
    RETAINEDEARNINGS: "RETAINED_EARNINGS",
    NETINCOME: "NET_INCOME",
    INVALIDLEGALENTITYBILLINGPOST: "INVALID_LEGAL_ENTITY_BILLING_POST",
    INVALIDLEGALENTITYINVOICECOMPLETION: "INVALID_LEGAL_ENTITY_INVOICE_COMPLETION",
    INVALIDLEGALENTITYLABORCOSTPOST: "INVALID_LEGAL_ENTITY_LABOR_COST_POST",
    INVALIDLEGALENTITYEXPENSECOSTPOST: "INVALID_LEGAL_ENTITY_EXPENSE_COST_POST",
    VIFUNDINGCAPADJUSTMENT: "VI_FUNDING_CAP_ADJUSTMENT",
    INVENTORYASSETACCOUNT: "INVENTORY_ASSET_ACCOUNT",
    INVENTORYSHRINKAGEACCOUNT: "INVENTORY_SHRINKAGE_ACCOUNT",
    INVENTORYPAYABLEACCOUNT: "INVENTORY_PAYABLE_ACCOUNT",
    FIXEDASSET: "FIXED_ASSET",
    FIXEDASSETDEPRECIATIONEXPENSE: "FIXED_ASSET_DEPRECIATION_EXPENSE",
    FIXEDASSETACCUMULATEDDEPRECIATION: "FIXED_ASSET_ACCUMULATED_DEPRECIATION",
    FIXEDASSETDISPOSAL: "FIXED_ASSET_DISPOSAL",
    PILOB: "PILOB",
    FIXEDASSETCASHPROCEEDS: "FIXED_ASSET_CASH_PROCEEDS",
    PILOBCOSTOFFSET: "PILOB_COST_OFFSET",
    DUETO: "DUE_TO",
    DUEFROM: "DUE_FROM",
    INTERCOMPANYREVENUE: "INTERCOMPANY_REVENUE",
    INTERCOMPANYLABORCOST: "INTERCOMPANY_LABOR_COST",
    INTERCOMPANYEXPENSEREPORTCOST: "INTERCOMPANY_EXPENSE_REPORT_COST",
    INTERCOMPANYCOSTALLOCATIONDUEFROMDUETO: "INTERCOMPANY_COST_ALLOCATION_DUE_FROM_DUE_TO",
    UNREALIZEDFOREIGNEXCHANGEGAIN: "UNREALIZED_FOREIGN_EXCHANGE_GAIN",
    UNREALIZEDFOREIGNEXCHANGELOSS: "UNREALIZED_FOREIGN_EXCHANGE_LOSS",
    REALIZEDFOREIGNEXCHANGEGAIN: "REALIZED_FOREIGN_EXCHANGE_GAIN",
    REALIZEDFOREIGNEXCHANGELOSS: "REALIZED_FOREIGN_EXCHANGE_LOSS",
    APREVALUATIONOFFSET: "AP_REVALUATION_OFFSET",
    ARREVALUATIONOFFSET: "AR_REVALUATION_OFFSET",
    TIMESHEETITEMCOST: "TIMESHEET_ITEM_COST",
    TIMESHEETITEMCOSTOFFSET: "TIMESHEET_ITEM_COST_OFFSET"
  };
})(AccountCategoryModel || (AccountCategoryModel = {}));
var AccountExpenseTypeModel;
((AccountExpenseTypeModel2) => {
  AccountExpenseTypeModel2.TypeEnum = {
    ASSET: "ASSET",
    EXPENSE: "EXPENSE",
    REVENUE: "REVENUE",
    LIABILITY: "LIABILITY"
  };
})(AccountExpenseTypeModel || (AccountExpenseTypeModel = {}));
var AccountModel;
((AccountModel2) => {
  AccountModel2.TypeEnum = {
    ASSET: "ASSET",
    EXPENSE: "EXPENSE",
    REVENUE: "REVENUE",
    LIABILITY: "LIABILITY"
  };
})(AccountModel || (AccountModel = {}));
var AccountSourceSupplierModel;
((AccountSourceSupplierModel2) => {
  AccountSourceSupplierModel2.AccountSourceEnum = {
    ORGANIZATION: "ORGANIZATION",
    PAYCODE: "PAY_CODE",
    PAYMENTMETHOD: "PAYMENT_METHOD",
    PROJECTTYPE: "PROJECT_TYPE",
    PROJECT: "PROJECT",
    TASK: "TASK",
    EMPLOYEETYPE: "EMPLOYEE_TYPE",
    LABORCATEGORY: "LABOR_CATEGORY",
    COSTELEMENT: "COST_ELEMENT",
    PERSON: "PERSON",
    EXPENSETYPE: "EXPENSE_TYPE",
    ADDITIONALITEMTYPE: "ADDITIONAL_ITEM_TYPE",
    FIXEDASSETCLASS: "FIXED_ASSET_CLASS"
  };
  AccountSourceSupplierModel2.SupplierEnum = {
    TRUE: "TRUE",
    FALSE: "FALSE",
    NOTAPPLICABLE: "NOT_APPLICABLE"
  };
})(AccountSourceSupplierModel || (AccountSourceSupplierModel = {}));
var AccrualScheduleModel;
((AccrualScheduleModel2) => {
  AccrualScheduleModel2.CapTypeEnum = {
    NONE: "NONE",
    HIREDATE: "HIRE_DATE",
    CALENDAR: "CALENDAR",
    PERIOD: "PERIOD"
  };
  AccrualScheduleModel2.AccrualCapTypeEnum = {
    NONE: "NONE",
    CALENDAR: "CALENDAR",
    PERIOD: "PERIOD"
  };
})(AccrualScheduleModel || (AccrualScheduleModel = {}));
var AdvFundContractModCreateModel;
((AdvFundContractModCreateModel2) => {
  AdvFundContractModCreateModel2.ModTypeEnum = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL",
    ORIGINAL: "ORIGINAL"
  };
})(AdvFundContractModCreateModel || (AdvFundContractModCreateModel = {}));
var AdvFundContractModModel;
((AdvFundContractModModel2) => {
  AdvFundContractModModel2.ModTypeEnum = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL",
    ORIGINAL: "ORIGINAL"
  };
  AdvFundContractModModel2.ModStateEnum = {
    DRAFT: "DRAFT",
    INREVIEW: "IN_REVIEW",
    COMPLETE: "COMPLETE"
  };
})(AdvFundContractModModel || (AdvFundContractModModel = {}));
var AdvFundContractStateHistoryModel;
((AdvFundContractStateHistoryModel2) => {
  AdvFundContractStateHistoryModel2.ToStateEnum = {
    DRAFT: "DRAFT",
    INREVIEW: "IN_REVIEW",
    ACTIVE: "ACTIVE",
    CLOSING: "CLOSING",
    COMPLETE: "COMPLETE"
  };
})(AdvFundContractStateHistoryModel || (AdvFundContractStateHistoryModel = {}));
var AlertPrefsModel;
((AlertPrefsModel2) => {
  AlertPrefsModel2.HoursAlertDenomEnum = {
    BUDGET: "BUDGET",
    ESTIMATEDTOTAL: "ESTIMATED_TOTAL"
  };
  AlertPrefsModel2.TotalCostAlertDenomEnum = {
    BUDGET: "BUDGET",
    ESTIMATEDTOTAL: "ESTIMATED_TOTAL"
  };
  AlertPrefsModel2.LaborCostAlertDenomEnum = {
    BUDGET: "BUDGET",
    ESTIMATEDTOTAL: "ESTIMATED_TOTAL"
  };
  AlertPrefsModel2.ExpenseCostAlertDenomEnum = {
    BUDGET: "BUDGET",
    ESTIMATEDTOTAL: "ESTIMATED_TOTAL"
  };
  AlertPrefsModel2.TotalBillAlertDenomEnum = {
    BUDGET: "BUDGET",
    ESTIMATEDTOTAL: "ESTIMATED_TOTAL"
  };
})(AlertPrefsModel || (AlertPrefsModel = {}));
var AnomalyDetectionRequestModel;
((AnomalyDetectionRequestModel2) => {
  AnomalyDetectionRequestModel2.PeriodTypeEnum = {
    MONTH: "MONTH",
    QUARTER: "QUARTER",
    YEAR: "YEAR"
  };
})(AnomalyDetectionRequestModel || (AnomalyDetectionRequestModel = {}));
var ApprovalGroupCreateModel;
((ApprovalGroupCreateModel2) => {
  ApprovalGroupCreateModel2.TypeEnum = {
    ACCOUNTSPAYABLE: "ACCOUNTS_PAYABLE",
    PURCHASING: "PURCHASING",
    TIMEANDEXPENSE: "TIME_AND_EXPENSE",
    ACCOUNTSRECEIVABLE: "ACCOUNTS_RECEIVABLE"
  };
})(ApprovalGroupCreateModel || (ApprovalGroupCreateModel = {}));
var ApprovalGroupModel;
((ApprovalGroupModel2) => {
  ApprovalGroupModel2.TypeEnum = {
    ACCOUNTSPAYABLE: "ACCOUNTS_PAYABLE",
    PURCHASING: "PURCHASING",
    TIMEANDEXPENSE: "TIME_AND_EXPENSE",
    ACCOUNTSRECEIVABLE: "ACCOUNTS_RECEIVABLE"
  };
})(ApprovalGroupModel || (ApprovalGroupModel = {}));
var ApprovalGroupSearchModel;
((ApprovalGroupSearchModel2) => {
  ApprovalGroupSearchModel2.ApprovalGroupTypesEnum = {
    ACCOUNTSPAYABLE: "ACCOUNTS_PAYABLE",
    PURCHASING: "PURCHASING",
    TIMEANDEXPENSE: "TIME_AND_EXPENSE",
    ACCOUNTSRECEIVABLE: "ACCOUNTS_RECEIVABLE"
  };
})(ApprovalGroupSearchModel || (ApprovalGroupSearchModel = {}));
var ApproverAlternateModel;
((ApproverAlternateModel2) => {
  ApproverAlternateModel2.ApprovalTypesEnum = {
    LEAVEREQUEST: "LEAVE_REQUEST",
    TIME: "TIME",
    EXPENSEREQUEST: "EXPENSE_REQUEST",
    EXPENSEREPORT: "EXPENSE_REPORT",
    PURCHASEREQUEST: "PURCHASE_REQUEST",
    PURCHASEORDER: "PURCHASE_ORDER",
    VENDORINVOICE: "VENDOR_INVOICE",
    CUSTOMERINVOICE: "CUSTOMER_INVOICE"
  };
})(ApproverAlternateModel || (ApproverAlternateModel = {}));
var AssignablePlannedTimeModel;
((AssignablePlannedTimeModel2) => {
  AssignablePlannedTimeModel2.BillRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  AssignablePlannedTimeModel2.CostRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
})(AssignablePlannedTimeModel || (AssignablePlannedTimeModel = {}));
var AssignablePlannedTimeSearchModel;
((AssignablePlannedTimeSearchModel2) => {
  AssignablePlannedTimeSearchModel2.UnitTypeEnum = {
    PROJECT: "PROJECT",
    TASK: "TASK",
    ALL: "ALL"
  };
})(AssignablePlannedTimeSearchModel || (AssignablePlannedTimeSearchModel = {}));
var AssigningMatrixSearchCriteriaModel;
((AssigningMatrixSearchCriteriaModel2) => {
  AssigningMatrixSearchCriteriaModel2.UnitTypeEnum = {
    PROJECT: "PROJECT",
    TASK: "TASK",
    ALL: "ALL"
  };
})(AssigningMatrixSearchCriteriaModel || (AssigningMatrixSearchCriteriaModel = {}));
var AssigningMatrixSearchCriteriaReadModel;
((AssigningMatrixSearchCriteriaReadModel2) => {
  AssigningMatrixSearchCriteriaReadModel2.UnitTypeEnum = {
    PROJECT: "PROJECT",
    TASK: "TASK",
    ALL: "ALL"
  };
  AssigningMatrixSearchCriteriaReadModel2.DashboardsEnum = {
    HOME: "HOME",
    ORGANIZATIONS: "ORGANIZATIONS",
    CONTRACTS: "CONTRACTS",
    CONTRACT: "CONTRACT",
    PROJECT: "PROJECT",
    PEOPLE: "PEOPLE",
    TIME: "TIME",
    EXPENSE: "EXPENSE",
    FORECAST: "FORECAST",
    FINANCIALS: "FINANCIALS",
    PURCHASING: "PURCHASING",
    ACCOUNTSPAYABLE: "ACCOUNTS_PAYABLE",
    ACCOUNTSRECEIVABLE: "ACCOUNTS_RECEIVABLE",
    BILLING: "BILLING",
    GENERALLEDGER: "GENERAL_LEDGER",
    DOCUMENTS: "DOCUMENTS",
    ADMIN: "ADMIN",
    REPORTS: "REPORTS"
  };
})(AssigningMatrixSearchCriteriaReadModel || (AssigningMatrixSearchCriteriaReadModel = {}));
var AssigningMatrixSearchModel;
((AssigningMatrixSearchModel2) => {
  AssigningMatrixSearchModel2.UnitTypeEnum = {
    PROJECT: "PROJECT",
    TASK: "TASK",
    ALL: "ALL"
  };
})(AssigningMatrixSearchModel || (AssigningMatrixSearchModel = {}));
var AssignmentDefaultsModel;
((AssignmentDefaultsModel2) => {
  AssignmentDefaultsModel2.CostRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  AssignmentDefaultsModel2.BillRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
})(AssignmentDefaultsModel || (AssignmentDefaultsModel = {}));
var AssignmentMatrixData;
((AssignmentMatrixData2) => {
  AssignmentMatrixData2.BillRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  AssignmentMatrixData2.CostRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
})(AssignmentMatrixData || (AssignmentMatrixData = {}));
var AuditDataSearchModel;
((AuditDataSearchModel2) => {
  AuditDataSearchModel2.CategoriesEnum = {
    ACCOUNTS: "ACCOUNTS",
    ACCOUNTSPAYABLE: "ACCOUNTS_PAYABLE",
    ACCOUNTSRECEIVABLE: "ACCOUNTS_RECEIVABLE",
    ACCRUALPLANS: "ACCRUAL_PLANS",
    ADDRESSES: "ADDRESSES",
    APPROVALS: "APPROVALS",
    APPROVALGROUPS: "APPROVAL_GROUPS",
    APPROVALHISTORY: "APPROVAL_HISTORY",
    APPROVERS: "APPROVERS",
    BANKACCOUNTS: "BANK_ACCOUNTS",
    BANKRECONCILIATION: "BANK_RECONCILIATION",
    BUDGETS: "BUDGETS",
    BUSINESSWEEKS: "BUSINESS_WEEKS",
    CHANGEREASONS: "CHANGE_REASONS",
    CONTRACTS: "CONTRACTS",
    CONTRACTCLAUSES: "CONTRACT_CLAUSES",
    CONTRACTFUNDING: "CONTRACT_FUNDING",
    CONTRACTTYPES: "CONTRACT_TYPES",
    COSTELEMENT: "COST_ELEMENT",
    COSTPOOLS: "COST_POOLS",
    COSTREPORT: "COST_REPORT",
    CREDITCARDS: "CREDIT_CARDS",
    CUSTOMERPAYMENTS: "CUSTOMER_PAYMENTS",
    CUSTOMLINKS: "CUSTOM_LINKS",
    DEPOSITS: "DEPOSITS",
    EMAILTEMPLATES: "EMAIL_TEMPLATES",
    EMPLOYEETYPES: "EMPLOYEE_TYPES",
    EXCHANGERATES: "EXCHANGE_RATES",
    EXPENSEREPORTS: "EXPENSE_REPORTS",
    EXPENSEREQUESTS: "EXPENSE_REQUESTS",
    EXPENSEAPPROVALHISTORY: "EXPENSE_APPROVAL_HISTORY",
    EXPENSEPOLICIES: "EXPENSE_POLICIES",
    EXPENSETYPES: "EXPENSE_TYPES",
    EXPORTTEMPLATE: "EXPORT_TEMPLATE",
    FEEMETHOD: "FEE_METHOD",
    FINANCIALDOCUMENTS: "FINANCIAL_DOCUMENTS",
    FISCALYEAR: "FISCAL_YEAR",
    FIXEDASSETS: "FIXED_ASSETS",
    GENERALLEDGER: "GENERAL_LEDGER",
    HISTORICALDATA: "HISTORICAL_DATA",
    HOLIDAYS: "HOLIDAYS",
    IMPORTEXPORTACCESS: "IMPORT_EXPORT_ACCESS",
    IMPORTEDCREDITCARD: "IMPORTED_CREDIT_CARD",
    IMPORTEDEXPENSES: "IMPORTED_EXPENSES",
    INTERCOMPANYJOURNALENTRIES: "INTERCOMPANY_JOURNAL_ENTRIES",
    INVENTORY: "INVENTORY",
    INVOICING: "INVOICING",
    ITEMS: "ITEMS",
    JOURNALENTRIES: "JOURNAL_ENTRIES",
    LABORCATEGORIES: "LABOR_CATEGORIES",
    LEAVE: "LEAVE",
    LOCATIONS: "LOCATIONS",
    MILEAGERATES: "MILEAGE_RATES",
    MLE: "MLE",
    OCCUPATIONS: "OCCUPATIONS",
    ORGANIZATIONS: "ORGANIZATIONS",
    ORGANIZATIONTYPES: "ORGANIZATION_TYPES",
    PAYCODES: "PAY_CODES",
    PAYMENTMETHODS: "PAYMENT_METHODS",
    PEOPLE: "PEOPLE",
    PEOPLEASSIGNMENTS: "PEOPLE_ASSIGNMENTS",
    PERDIEMS: "PER_DIEMS",
    PERSONBENEFITS: "PERSON_BENEFITS",
    PLANSETS: "PLAN_SETS",
    PILOB: "PILOB",
    POSTINGOPTIONS: "POSTING_OPTIONS",
    PROJECTS: "PROJECTS",
    PROJECTNOTESTATUSES: "PROJECT_NOTE_STATUSES",
    PROJECTNOTETYPES: "PROJECT_NOTE_TYPES",
    PROJECTSTATUSES: "PROJECT_STATUSES",
    PROJECTTYPES: "PROJECT_TYPES",
    PROPERTYTEMPLATES: "PROPERTY_TEMPLATES",
    PURCHASEORDERS: "PURCHASE_ORDERS",
    PURCHASEORDERALERTS: "PURCHASE_ORDER_ALERTS",
    PURCHASEORDERASSIGNMENTS: "PURCHASE_ORDER_ASSIGNMENTS",
    PURCHASEORDERREQUISITIONS: "PURCHASE_ORDER_REQUISITIONS",
    RECEIVING: "RECEIVING",
    RESOURCEREQUESTS: "RESOURCE_REQUESTS",
    SKILLS: "SKILLS",
    STATISTICALJOURNALENTRIES: "STATISTICAL_JOURNAL_ENTRIES",
    SYSTEMPROPERTIES: "SYSTEM_PROPERTIES",
    TASKS: "TASKS",
    TIMESHEETS: "TIMESHEETS",
    TIMEPERIODS: "TIME_PERIODS",
    UDFS: "UDFS",
    UNKNOWN: "UNKNOWN",
    UOM: "UOM",
    VAT: "VAT",
    VENDORS: "VENDORS",
    VENDORINVOICE: "VENDOR_INVOICE",
    VENDORPAYMENTS: "VENDOR_PAYMENTS",
    WAGEDETERMINATION: "WAGE_DETERMINATION",
    WIZARDS: "WIZARDS"
  };
  AuditDataSearchModel2.UpdateSuppressionTypeEnum = {
    NONE: "NONE",
    EMPTY: "EMPTY",
    UNCHANGED: "UNCHANGED"
  };
})(AuditDataSearchModel || (AuditDataSearchModel = {}));
var BankAccountModel;
((BankAccountModel2) => {
  BankAccountModel2.TypeEnum = {
    BANKACCOUNT: "BANK_ACCOUNT",
    UNDEPOSITEDFUNDS: "UNDEPOSITED_FUNDS",
    OTHER: "OTHER"
  };
})(BankAccountModel || (BankAccountModel = {}));
var BasePurchasingDocumentSearchModel;
((BasePurchasingDocumentSearchModel2) => {
  BasePurchasingDocumentSearchModel2.DocumentNumberPredicateEnum = {
    EQUALS: "EQUALS",
    EQUALSIGNORECASE: "EQUALS_IGNORE_CASE",
    CONTAINS: "CONTAINS",
    STARTSWITH: "STARTS_WITH",
    ENDSWITH: "ENDS_WITH"
  };
})(BasePurchasingDocumentSearchModel || (BasePurchasingDocumentSearchModel = {}));
var BillingTypeModel;
((BillingTypeModel2) => {
  BillingTypeModel2.TypeEnum = {
    COSTPLUS: "COST_PLUS",
    FIXEDPRICE: "FIXED_PRICE",
    TIMEANDMATERIALS: "TIME_AND_MATERIALS",
    NONBILLABLE: "NON_BILLABLE"
  };
})(BillingTypeModel || (BillingTypeModel = {}));
var CashFlowOptimizationRequestModel;
((CashFlowOptimizationRequestModel2) => {
  CashFlowOptimizationRequestModel2.PeriodTypeEnum = {
    MONTH: "MONTH",
    QUARTER: "QUARTER",
    YEAR: "YEAR"
  };
})(CashFlowOptimizationRequestModel || (CashFlowOptimizationRequestModel = {}));
var CategoryAccountKeyModel;
((CategoryAccountKeyModel2) => {
  CategoryAccountKeyModel2.CategoryEnum = {
    BILLED: "BILLED",
    DEFERREDREVENUE: "DEFERRED_REVENUE",
    RECOGNIZEDREVENUE: "RECOGNIZED_REVENUE",
    TAX: "TAX",
    UNBILLED: "UNBILLED",
    LABORCOST: "LABOR_COST",
    LABORCOSTOFFSETEMPLOYEES: "LABOR_COST_OFFSET_EMPLOYEES",
    REVENUEWRITEOFF: "REVENUE_WRITE_OFF",
    FUNDINGCAPADJUSTMENTREVENUE: "FUNDING_CAP_ADJUSTMENT_REVENUE",
    ARDISCOUNTTAKEN: "AR_DISCOUNT_TAKEN",
    ARSMALLBALANCEWRITEOFF: "AR_SMALL_BALANCE_WRITE_OFF",
    ARUNAPPLIEDPAYMENTACCOUNT: "AR_UNAPPLIED_PAYMENT_ACCOUNT",
    ACCOUNTSPAYABLE: "ACCOUNTS_PAYABLE",
    APDISCOUNTTAKEN: "AP_DISCOUNT_TAKEN",
    APUNAPPLIEDPAYMENTACCOUNT: "AP_UNAPPLIED_PAYMENT_ACCOUNT",
    EXPENSEREPORTCOST: "EXPENSE_REPORT_COST",
    EXPENSEREPORTOFFSETREIMBURSABLE: "EXPENSE_REPORT_OFFSET_REIMBURSABLE",
    EXPENSEREPORTOFFSETNONREIMBURSABLE: "EXPENSE_REPORT_OFFSET_NON_REIMBURSABLE",
    LABORCOSTOFFSETSUBCONTRACTORS: "LABOR_COST_OFFSET_SUBCONTRACTORS",
    CROSSCHARGELABOR: "CROSS_CHARGE_LABOR",
    CROSSCHARGELABOROFFSET: "CROSS_CHARGE_LABOR_OFFSET",
    FIXEDFEEADJUSTMENTREVENUE: "FIXED_FEE_ADJUSTMENT_REVENUE",
    RETAINEDEARNINGS: "RETAINED_EARNINGS",
    NETINCOME: "NET_INCOME",
    INVALIDLEGALENTITYBILLINGPOST: "INVALID_LEGAL_ENTITY_BILLING_POST",
    INVALIDLEGALENTITYINVOICECOMPLETION: "INVALID_LEGAL_ENTITY_INVOICE_COMPLETION",
    INVALIDLEGALENTITYLABORCOSTPOST: "INVALID_LEGAL_ENTITY_LABOR_COST_POST",
    INVALIDLEGALENTITYEXPENSECOSTPOST: "INVALID_LEGAL_ENTITY_EXPENSE_COST_POST",
    VIFUNDINGCAPADJUSTMENT: "VI_FUNDING_CAP_ADJUSTMENT",
    INVENTORYASSETACCOUNT: "INVENTORY_ASSET_ACCOUNT",
    INVENTORYSHRINKAGEACCOUNT: "INVENTORY_SHRINKAGE_ACCOUNT",
    INVENTORYPAYABLEACCOUNT: "INVENTORY_PAYABLE_ACCOUNT",
    FIXEDASSET: "FIXED_ASSET",
    FIXEDASSETDEPRECIATIONEXPENSE: "FIXED_ASSET_DEPRECIATION_EXPENSE",
    FIXEDASSETACCUMULATEDDEPRECIATION: "FIXED_ASSET_ACCUMULATED_DEPRECIATION",
    FIXEDASSETDISPOSAL: "FIXED_ASSET_DISPOSAL",
    PILOB: "PILOB",
    FIXEDASSETCASHPROCEEDS: "FIXED_ASSET_CASH_PROCEEDS",
    PILOBCOSTOFFSET: "PILOB_COST_OFFSET",
    DUETO: "DUE_TO",
    DUEFROM: "DUE_FROM",
    INTERCOMPANYREVENUE: "INTERCOMPANY_REVENUE",
    INTERCOMPANYLABORCOST: "INTERCOMPANY_LABOR_COST",
    INTERCOMPANYEXPENSEREPORTCOST: "INTERCOMPANY_EXPENSE_REPORT_COST",
    INTERCOMPANYCOSTALLOCATIONDUEFROMDUETO: "INTERCOMPANY_COST_ALLOCATION_DUE_FROM_DUE_TO",
    UNREALIZEDFOREIGNEXCHANGEGAIN: "UNREALIZED_FOREIGN_EXCHANGE_GAIN",
    UNREALIZEDFOREIGNEXCHANGELOSS: "UNREALIZED_FOREIGN_EXCHANGE_LOSS",
    REALIZEDFOREIGNEXCHANGEGAIN: "REALIZED_FOREIGN_EXCHANGE_GAIN",
    REALIZEDFOREIGNEXCHANGELOSS: "REALIZED_FOREIGN_EXCHANGE_LOSS",
    APREVALUATIONOFFSET: "AP_REVALUATION_OFFSET",
    ARREVALUATIONOFFSET: "AR_REVALUATION_OFFSET",
    TIMESHEETITEMCOST: "TIMESHEET_ITEM_COST",
    TIMESHEETITEMCOSTOFFSET: "TIMESHEET_ITEM_COST_OFFSET"
  };
})(CategoryAccountKeyModel || (CategoryAccountKeyModel = {}));
var CategoryAccountModel;
((CategoryAccountModel2) => {
  CategoryAccountModel2.CategoryEnum = {
    BILLED: "BILLED",
    DEFERREDREVENUE: "DEFERRED_REVENUE",
    RECOGNIZEDREVENUE: "RECOGNIZED_REVENUE",
    TAX: "TAX",
    UNBILLED: "UNBILLED",
    LABORCOST: "LABOR_COST",
    LABORCOSTOFFSETEMPLOYEES: "LABOR_COST_OFFSET_EMPLOYEES",
    REVENUEWRITEOFF: "REVENUE_WRITE_OFF",
    FUNDINGCAPADJUSTMENTREVENUE: "FUNDING_CAP_ADJUSTMENT_REVENUE",
    ARDISCOUNTTAKEN: "AR_DISCOUNT_TAKEN",
    ARSMALLBALANCEWRITEOFF: "AR_SMALL_BALANCE_WRITE_OFF",
    ARUNAPPLIEDPAYMENTACCOUNT: "AR_UNAPPLIED_PAYMENT_ACCOUNT",
    ACCOUNTSPAYABLE: "ACCOUNTS_PAYABLE",
    APDISCOUNTTAKEN: "AP_DISCOUNT_TAKEN",
    APUNAPPLIEDPAYMENTACCOUNT: "AP_UNAPPLIED_PAYMENT_ACCOUNT",
    EXPENSEREPORTCOST: "EXPENSE_REPORT_COST",
    EXPENSEREPORTOFFSETREIMBURSABLE: "EXPENSE_REPORT_OFFSET_REIMBURSABLE",
    EXPENSEREPORTOFFSETNONREIMBURSABLE: "EXPENSE_REPORT_OFFSET_NON_REIMBURSABLE",
    LABORCOSTOFFSETSUBCONTRACTORS: "LABOR_COST_OFFSET_SUBCONTRACTORS",
    CROSSCHARGELABOR: "CROSS_CHARGE_LABOR",
    CROSSCHARGELABOROFFSET: "CROSS_CHARGE_LABOR_OFFSET",
    FIXEDFEEADJUSTMENTREVENUE: "FIXED_FEE_ADJUSTMENT_REVENUE",
    RETAINEDEARNINGS: "RETAINED_EARNINGS",
    NETINCOME: "NET_INCOME",
    INVALIDLEGALENTITYBILLINGPOST: "INVALID_LEGAL_ENTITY_BILLING_POST",
    INVALIDLEGALENTITYINVOICECOMPLETION: "INVALID_LEGAL_ENTITY_INVOICE_COMPLETION",
    INVALIDLEGALENTITYLABORCOSTPOST: "INVALID_LEGAL_ENTITY_LABOR_COST_POST",
    INVALIDLEGALENTITYEXPENSECOSTPOST: "INVALID_LEGAL_ENTITY_EXPENSE_COST_POST",
    VIFUNDINGCAPADJUSTMENT: "VI_FUNDING_CAP_ADJUSTMENT",
    INVENTORYASSETACCOUNT: "INVENTORY_ASSET_ACCOUNT",
    INVENTORYSHRINKAGEACCOUNT: "INVENTORY_SHRINKAGE_ACCOUNT",
    INVENTORYPAYABLEACCOUNT: "INVENTORY_PAYABLE_ACCOUNT",
    FIXEDASSET: "FIXED_ASSET",
    FIXEDASSETDEPRECIATIONEXPENSE: "FIXED_ASSET_DEPRECIATION_EXPENSE",
    FIXEDASSETACCUMULATEDDEPRECIATION: "FIXED_ASSET_ACCUMULATED_DEPRECIATION",
    FIXEDASSETDISPOSAL: "FIXED_ASSET_DISPOSAL",
    PILOB: "PILOB",
    FIXEDASSETCASHPROCEEDS: "FIXED_ASSET_CASH_PROCEEDS",
    PILOBCOSTOFFSET: "PILOB_COST_OFFSET",
    DUETO: "DUE_TO",
    DUEFROM: "DUE_FROM",
    INTERCOMPANYREVENUE: "INTERCOMPANY_REVENUE",
    INTERCOMPANYLABORCOST: "INTERCOMPANY_LABOR_COST",
    INTERCOMPANYEXPENSEREPORTCOST: "INTERCOMPANY_EXPENSE_REPORT_COST",
    INTERCOMPANYCOSTALLOCATIONDUEFROMDUETO: "INTERCOMPANY_COST_ALLOCATION_DUE_FROM_DUE_TO",
    UNREALIZEDFOREIGNEXCHANGEGAIN: "UNREALIZED_FOREIGN_EXCHANGE_GAIN",
    UNREALIZEDFOREIGNEXCHANGELOSS: "UNREALIZED_FOREIGN_EXCHANGE_LOSS",
    REALIZEDFOREIGNEXCHANGEGAIN: "REALIZED_FOREIGN_EXCHANGE_GAIN",
    REALIZEDFOREIGNEXCHANGELOSS: "REALIZED_FOREIGN_EXCHANGE_LOSS",
    APREVALUATIONOFFSET: "AP_REVALUATION_OFFSET",
    ARREVALUATIONOFFSET: "AR_REVALUATION_OFFSET",
    TIMESHEETITEMCOST: "TIMESHEET_ITEM_COST",
    TIMESHEETITEMCOSTOFFSET: "TIMESHEET_ITEM_COST_OFFSET"
  };
})(CategoryAccountModel || (CategoryAccountModel = {}));
var ContractCreateModel;
((ContractCreateModel2) => {
  ContractCreateModel2.PrimeOrSubEnum = {
    PRIME: "PRIME",
    SUB: "SUB",
    NONE: "NONE"
  };
  ContractCreateModel2.ScaRateFlagEnum = {
    BASE: "BASE",
    WAGE: "WAGE"
  };
  ContractCreateModel2.BusinessSizeClassificationEnum = {
    LARGE: "LARGE",
    SMALL: "SMALL",
    NONPROFIT: "NON_PROFIT",
    FOREIGNOROTHER: "FOREIGN_OR_OTHER"
  };
  ContractCreateModel2.SecurityClearanceEnum = {
    TOPSECRET: "TOP_SECRET",
    SECRET: "SECRET",
    CONFIDENTIAL: "CONFIDENTIAL"
  };
})(ContractCreateModel || (ContractCreateModel = {}));
var ContractDetailModel;
((ContractDetailModel2) => {
  ContractDetailModel2.FundingMethodEnum = {
    FIFO: "FIFO",
    LIFO: "LIFO",
    PERCENT: "PERCENT"
  };
})(ContractDetailModel || (ContractDetailModel = {}));
var ContractLineCreateModel;
((ContractLineCreateModel2) => {
  ContractLineCreateModel2.FundingConsumptionMethodEnum = {
    FIFO: "FIFO",
    LIFO: "LIFO",
    PERCENT: "PERCENT"
  };
})(ContractLineCreateModel || (ContractLineCreateModel = {}));
var ContractLineModCreateModel;
((ContractLineModCreateModel2) => {
  ContractLineModCreateModel2.FundingConsumptionMethodEnum = {
    FIFO: "FIFO",
    LIFO: "LIFO",
    PERCENT: "PERCENT"
  };
})(ContractLineModCreateModel || (ContractLineModCreateModel = {}));
var ContractLineModModel;
((ContractLineModModel2) => {
  ContractLineModModel2.FundingConsumptionMethodEnum = {
    FIFO: "FIFO",
    LIFO: "LIFO",
    PERCENT: "PERCENT"
  };
})(ContractLineModModel || (ContractLineModModel = {}));
var ContractLineModel;
((ContractLineModel2) => {
  ContractLineModel2.FundingConsumptionMethodEnum = {
    FIFO: "FIFO",
    LIFO: "LIFO",
    PERCENT: "PERCENT"
  };
})(ContractLineModel || (ContractLineModel = {}));
var ContractLineSearchModel;
((ContractLineSearchModel2) => {
  ContractLineSearchModel2.FundingMethodEnum = {
    FIFO: "FIFO",
    LIFO: "LIFO",
    PERCENT: "PERCENT"
  };
})(ContractLineSearchModel || (ContractLineSearchModel = {}));
var ContractListModel;
((ContractListModel2) => {
  ContractListModel2.PrimeOrSubEnum = {
    PRIME: "PRIME",
    SUB: "SUB",
    NONE: "NONE"
  };
  ContractListModel2.ScaRateFlagEnum = {
    BASE: "BASE",
    WAGE: "WAGE"
  };
  ContractListModel2.BusinessSizeClassificationEnum = {
    LARGE: "LARGE",
    SMALL: "SMALL",
    NONPROFIT: "NON_PROFIT",
    FOREIGNOROTHER: "FOREIGN_OR_OTHER"
  };
  ContractListModel2.SecurityClearanceEnum = {
    TOPSECRET: "TOP_SECRET",
    SECRET: "SECRET",
    CONFIDENTIAL: "CONFIDENTIAL"
  };
  ContractListModel2.AdvFundStateEnum = {
    DRAFT: "DRAFT",
    ACTIVE: "ACTIVE",
    COMPLETE: "COMPLETE"
  };
})(ContractListModel || (ContractListModel = {}));
var ContractModel;
((ContractModel2) => {
  ContractModel2.PrimeOrSubEnum = {
    PRIME: "PRIME",
    SUB: "SUB",
    NONE: "NONE"
  };
  ContractModel2.ScaRateFlagEnum = {
    BASE: "BASE",
    WAGE: "WAGE"
  };
  ContractModel2.BusinessSizeClassificationEnum = {
    LARGE: "LARGE",
    SMALL: "SMALL",
    NONPROFIT: "NON_PROFIT",
    FOREIGNOROTHER: "FOREIGN_OR_OTHER"
  };
  ContractModel2.SecurityClearanceEnum = {
    TOPSECRET: "TOP_SECRET",
    SECRET: "SECRET",
    CONFIDENTIAL: "CONFIDENTIAL"
  };
  ContractModel2.AdvFundStateEnum = {
    DRAFT: "DRAFT",
    ACTIVE: "ACTIVE",
    COMPLETE: "COMPLETE"
  };
})(ContractModel || (ContractModel = {}));
var CostElementModel;
((CostElementModel2) => {
  CostElementModel2.TypeEnum = {
    LABOR: "LABOR",
    ODC: "ODC",
    POOL: "POOL"
  };
})(CostElementModel || (CostElementModel = {}));
var CostPlusInvoiceSectionFormatCreateModel;
((CostPlusInvoiceSectionFormatCreateModel2) => {
  CostPlusInvoiceSectionFormatCreateModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  CostPlusInvoiceSectionFormatCreateModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  CostPlusInvoiceSectionFormatCreateModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  CostPlusInvoiceSectionFormatCreateModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  CostPlusInvoiceSectionFormatCreateModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  CostPlusInvoiceSectionFormatCreateModel2.QuantityToShowEnum = {
    HOURS: "HOURS",
    ITEMQTY: "ITEM_QTY",
    BOTH: "BOTH"
  };
})(CostPlusInvoiceSectionFormatCreateModel || (CostPlusInvoiceSectionFormatCreateModel = {}));
var CostPlusInvoiceSectionFormatModel;
((CostPlusInvoiceSectionFormatModel2) => {
  CostPlusInvoiceSectionFormatModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  CostPlusInvoiceSectionFormatModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  CostPlusInvoiceSectionFormatModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  CostPlusInvoiceSectionFormatModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  CostPlusInvoiceSectionFormatModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  CostPlusInvoiceSectionFormatModel2.QuantityToShowEnum = {
    HOURS: "HOURS",
    ITEMQTY: "ITEM_QTY",
    BOTH: "BOTH"
  };
})(CostPlusInvoiceSectionFormatModel || (CostPlusInvoiceSectionFormatModel = {}));
var CostReportElementModel;
((CostReportElementModel2) => {
  CostReportElementModel2.ValueFormatEnum = {
    PERCENT: "PERCENT",
    NUMBER: "NUMBER"
  };
})(CostReportElementModel || (CostReportElementModel = {}));
var CostStructPoolRateModel;
((CostStructPoolRateModel2) => {
  CostStructPoolRateModel2.RateTypeEnum = {
    PROVISIONAL: "PROVISIONAL",
    TARGET: "TARGET"
  };
})(CostStructPoolRateModel || (CostStructPoolRateModel = {}));
var CostStructPoolRateUpdateModel;
((CostStructPoolRateUpdateModel2) => {
  CostStructPoolRateUpdateModel2.RateTypeEnum = {
    PROVISIONAL: "PROVISIONAL",
    TARGET: "TARGET"
  };
})(CostStructPoolRateUpdateModel || (CostStructPoolRateUpdateModel = {}));
var CustomLinkListModel;
((CustomLinkListModel2) => {
  CustomLinkListModel2.LinkTypeEnum = {
    COMPANY: "COMPANY",
    QUICK: "QUICK",
    REPORT: "REPORT",
    HOWTO: "HOW_TO",
    TIP: "TIP"
  };
  CustomLinkListModel2.ApplicationTypeEnum = {
    NONE: "NONE",
    WEBAPP: "WEBAPP",
    SUBCONTRACTOR: "SUBCONTRACTOR",
    MOBILE: "MOBILE",
    CONNECT: "CONNECT",
    APAUTOMATION: "APAUTOMATION",
    CUSTOM: "CUSTOM",
    SIMPLYWORK: "SIMPLY_WORK",
    COBBLESTONE: "COBBLESTONE",
    FORPROJECT: "FORPROJECT",
    PROLIANT: "PROLIANT",
    UNISON: "UNISON",
    CONTRAQER: "CONTRAQER",
    MESH: "MESH"
  };
})(CustomLinkListModel || (CustomLinkListModel = {}));
var CustomLinkModel;
((CustomLinkModel2) => {
  CustomLinkModel2.LinkTypeEnum = {
    COMPANY: "COMPANY",
    QUICK: "QUICK",
    REPORT: "REPORT",
    HOWTO: "HOW_TO",
    TIP: "TIP"
  };
  CustomLinkModel2.ApplicationTypeEnum = {
    NONE: "NONE",
    WEBAPP: "WEBAPP",
    SUBCONTRACTOR: "SUBCONTRACTOR",
    MOBILE: "MOBILE",
    CONNECT: "CONNECT",
    APAUTOMATION: "APAUTOMATION",
    CUSTOM: "CUSTOM",
    SIMPLYWORK: "SIMPLY_WORK",
    COBBLESTONE: "COBBLESTONE",
    FORPROJECT: "FORPROJECT",
    PROLIANT: "PROLIANT",
    UNISON: "UNISON",
    CONTRAQER: "CONTRAQER",
    MESH: "MESH"
  };
})(CustomLinkModel || (CustomLinkModel = {}));
var CustomerPaymentIncludedModel;
((CustomerPaymentIncludedModel2) => {
  CustomerPaymentIncludedModel2.IncludedDocumentTypeEnum = {
    PAYMENT: "PAYMENT",
    INVOICE: "INVOICE"
  };
})(CustomerPaymentIncludedModel || (CustomerPaymentIncludedModel = {}));
var CustomerPaymentModel;
((CustomerPaymentModel2) => {
  CustomerPaymentModel2.DocumentTypeEnum = {
    VENDORINVOICE: "VENDOR_INVOICE",
    VENDORPAYMENT: "VENDOR_PAYMENT",
    CUSTOMERPAYMENT: "CUSTOMER_PAYMENT",
    DEPOSIT: "DEPOSIT",
    JOURNALENTRY: "JOURNAL_ENTRY",
    INTERCOMPANYJOURNALENTRY: "INTERCOMPANY_JOURNAL_ENTRY",
    INTERCOMPANYVENDORINVOICE: "INTERCOMPANY_VENDOR_INVOICE"
  };
  CustomerPaymentModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED",
    APPROVED: "APPROVED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED"
  };
})(CustomerPaymentModel || (CustomerPaymentModel = {}));
var CustomerPaymentSearchModel;
((CustomerPaymentSearchModel2) => {
  CustomerPaymentSearchModel2.StatusesEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED",
    APPROVED: "APPROVED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED"
  };
})(CustomerPaymentSearchModel || (CustomerPaymentSearchModel = {}));
var DashboardTypePagedResponse;
((DashboardTypePagedResponse2) => {
  DashboardTypePagedResponse2.ItemsEnum = {
    HOME: "HOME",
    ORGANIZATIONS: "ORGANIZATIONS",
    CONTRACTS: "CONTRACTS",
    CONTRACT: "CONTRACT",
    PROJECT: "PROJECT",
    PEOPLE: "PEOPLE",
    TIME: "TIME",
    EXPENSE: "EXPENSE",
    FORECAST: "FORECAST",
    FINANCIALS: "FINANCIALS",
    PURCHASING: "PURCHASING",
    ACCOUNTSPAYABLE: "ACCOUNTS_PAYABLE",
    ACCOUNTSRECEIVABLE: "ACCOUNTS_RECEIVABLE",
    BILLING: "BILLING",
    GENERALLEDGER: "GENERAL_LEDGER",
    DOCUMENTS: "DOCUMENTS",
    ADMIN: "ADMIN",
    REPORTS: "REPORTS"
  };
})(DashboardTypePagedResponse || (DashboardTypePagedResponse = {}));
var DataLakeCriteriaFieldsModel;
((DataLakeCriteriaFieldsModel2) => {
  DataLakeCriteriaFieldsModel2.IndirectCostRateTypeEnum = {
    RATEACTUAL: "RATE_ACTUAL",
    RATETYPEPROVISIONAL: "RATE_TYPE_PROVISIONAL",
    RATETYPETARGET: "RATE_TYPE_TARGET"
  };
  DataLakeCriteriaFieldsModel2.PeriodTypeEnum = {
    DAY: "DAY",
    CALENDARWEEK: "CALENDAR_WEEK",
    CALENDARSEMIMONTH: "CALENDAR_SEMI_MONTH",
    CALENDARMONTH: "CALENDAR_MONTH",
    CALENDARQUARTER: "CALENDAR_QUARTER",
    CALENDARYEAR: "CALENDAR_YEAR",
    FISCALWEEK: "FISCAL_WEEK",
    FISCALMONTH: "FISCAL_MONTH",
    FISCALQUARTER: "FISCAL_QUARTER",
    FISCALYEAR: "FISCAL_YEAR"
  };
})(DataLakeCriteriaFieldsModel || (DataLakeCriteriaFieldsModel = {}));
var DepositSearchModel;
((DepositSearchModel2) => {
  DepositSearchModel2.StatusesEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED",
    APPROVED: "APPROVED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED"
  };
})(DepositSearchModel || (DepositSearchModel = {}));
var DepositSummaryModel;
((DepositSummaryModel2) => {
  DepositSummaryModel2.DocumentTypeEnum = {
    VENDORINVOICE: "VENDOR_INVOICE",
    VENDORPAYMENT: "VENDOR_PAYMENT",
    CUSTOMERPAYMENT: "CUSTOMER_PAYMENT",
    DEPOSIT: "DEPOSIT",
    JOURNALENTRY: "JOURNAL_ENTRY",
    INTERCOMPANYJOURNALENTRY: "INTERCOMPANY_JOURNAL_ENTRY",
    INTERCOMPANYVENDORINVOICE: "INTERCOMPANY_VENDOR_INVOICE"
  };
  DepositSummaryModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED",
    APPROVED: "APPROVED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED"
  };
})(DepositSummaryModel || (DepositSummaryModel = {}));
var EmailTemplateModel;
((EmailTemplateModel2) => {
  EmailTemplateModel2.TypeEnum = {
    NOTIFICATION: "NOTIFICATION",
    REMINDERBROADCAST: "REMINDER_BROADCAST",
    REMINDEREXPENSECUST: "REMINDER_EXPENSE_CUST",
    REMINDEREXPENSEMGR: "REMINDER_EXPENSE_MGR",
    REMINDEREXPENSEPM: "REMINDER_EXPENSE_PM",
    REMINDERTIMESHEETCUST: "REMINDER_TIMESHEET_CUST",
    REMINDERTIMESHEETMGR: "REMINDER_TIMESHEET_MGR",
    REMINDERTIMESHEETPM: "REMINDER_TIMESHEET_PM",
    REMINDERTIMESHEETSUBMIT: "REMINDER_TIMESHEET_SUBMIT",
    REMINDERTIMESHEETMINIMUM: "REMINDER_TIMESHEET_MINIMUM",
    REMINDEREXPENSECUSTALT: "REMINDER_EXPENSE_CUST_ALT",
    REMINDEREXPENSEMGRALT: "REMINDER_EXPENSE_MGR_ALT",
    REMINDEREXPENSEPMALT: "REMINDER_EXPENSE_PM_ALT",
    REMINDERTIMESHEETCUSTALT: "REMINDER_TIMESHEET_CUST_ALT",
    REMINDERTIMESHEETMGRALT: "REMINDER_TIMESHEET_MGR_ALT",
    REMINDERTIMESHEETPMALT: "REMINDER_TIMESHEET_PM_ALT",
    INVOICESEND: "INVOICE_SEND",
    PURCHASEORDERSEND: "PURCHASE_ORDER_SEND",
    REMINDERPOCUST: "REMINDER_PO_CUST",
    REMINDERPOCUSTALT: "REMINDER_PO_CUST_ALT",
    REMINDERPOMGR: "REMINDER_PO_MGR",
    REMINDERPOMGRALT: "REMINDER_PO_MGR_ALT",
    REMINDERPOPM: "REMINDER_PO_PM",
    REMINDERPOPMALT: "REMINDER_PO_PM_ALT",
    REMINDERPRCUST: "REMINDER_PR_CUST",
    REMINDERPRCUSTALT: "REMINDER_PR_CUST_ALT",
    REMINDERPRMGR: "REMINDER_PR_MGR",
    REMINDERPRMGRALT: "REMINDER_PR_MGR_ALT",
    REMINDERPRPM: "REMINDER_PR_PM",
    REMINDERPRPMALT: "REMINDER_PR_PM_ALT",
    REMINDERVICUST: "REMINDER_VI_CUST",
    REMINDERVICUSTALT: "REMINDER_VI_CUST_ALT",
    REMINDERVIMGR: "REMINDER_VI_MGR",
    REMINDERVIMGRALT: "REMINDER_VI_MGR_ALT",
    REMINDERVIPM: "REMINDER_VI_PM",
    REMINDERVIPMALT: "REMINDER_VI_PM_ALT",
    REMINDERVIRECEIVERAPPROVER: "REMINDER_VI_RECEIVER_APPROVER",
    REMINDERVIRECEIVERAPPROVERALT: "REMINDER_VI_RECEIVER_APPROVER_ALT",
    UNPAIDINVOICEREMINDER: "UNPAID_INVOICE_REMINDER",
    SUBKNOTIFICATION: "SUBK_NOTIFICATION"
  };
})(EmailTemplateModel || (EmailTemplateModel = {}));
var EntertainmentWizardModel;
((EntertainmentWizardModel2) => {
  EntertainmentWizardModel2.TookPlaceEnum = {
    BEFORE: "BEFORE",
    DURING: "DURING",
    AFTER: "AFTER"
  };
})(EntertainmentWizardModel || (EntertainmentWizardModel = {}));
var ErrorInstance;
((ErrorInstance2) => {
  ErrorInstance2.CodeEnum = {
    VALIDATIONGENERIC: "VALIDATION_GENERIC",
    VALIDATIONINVALIDPARAM: "VALIDATION_INVALID_PARAM",
    VALIDATIONINVALIDFIELD: "VALIDATION_INVALID_FIELD",
    VALIDATIONBELOWMIN: "VALIDATION_BELOW_MIN",
    VALIDATIONEXCEEDSMAX: "VALIDATION_EXCEEDS_MAX",
    VALIDATIONDECIMALOUTOFBOUNDS: "VALIDATION_DECIMAL_OUT_OF_BOUNDS",
    VALIDATIONEMAILBADFORMAT: "VALIDATION_EMAIL_BAD_FORMAT",
    VALIDATIONMUSTNOTBEBLANK: "VALIDATION_MUST_NOT_BE_BLANK",
    VALIDATIONMUSTNOTBENULL: "VALIDATION_MUST_NOT_BE_NULL",
    VALIDATIONMUSTBENULLORNOTBLANK: "VALIDATION_MUST_BE_NULL_OR_NOT_BLANK",
    VALIDATIONMUSTNOTBEEMPTY: "VALIDATION_MUST_NOT_BE_EMPTY",
    VALIDATIONMUSTCONTAINNOWHITESPACE: "VALIDATION_MUST_CONTAIN_NO_WHITESPACE",
    VALIDATIONMUSTBENULL: "VALIDATION_MUST_BE_NULL",
    VALIDATIONPATTERNMISMATCH: "VALIDATION_PATTERN_MISMATCH",
    VALIDATIONMUSTBEGREATERTHANZERO: "VALIDATION_MUST_BE_GREATER_THAN_ZERO",
    VALIDATIONMUSTBEGREATERTHANEQUALZERO: "VALIDATION_MUST_BE_GREATER_THAN_EQUAL_ZERO",
    VALIDATIONMUSTNOTBEZERO: "VALIDATION_MUST_NOT_BE_ZERO",
    VALIDATIONINVALIDSIZE: "VALIDATION_INVALID_SIZE",
    VALIDATIONDATEOUTOFRANGE: "VALIDATION_DATE_OUT_OF_RANGE",
    VALIDATIONTIMEOUTOFRANGE: "VALIDATION_TIME_OUT_OF_RANGE",
    VALIDATIONTIMEFIELDSOUTOFORDER: "VALIDATION_TIME_FIELDS_OUT_OF_ORDER",
    VALIDATIONDATEFIELDSOUTOFORDER: "VALIDATION_DATE_FIELDS_OUT_OF_ORDER",
    VALIDATIONRESOURCEALREADYEXISTS: "VALIDATION_RESOURCE_ALREADY_EXISTS",
    VALIDATIONFIELDALREADYEXISTS: "VALIDATION_FIELD_ALREADY_EXISTS",
    VALIDATIONREQUIREDFIELD: "VALIDATION_REQUIRED_FIELD",
    VALIDATIONORGNOTLEGALENTITY: "VALIDATION_ORG_NOT_LEGAL_ENTITY",
    VALIDATIONORGNOTFINANCIALORG: "VALIDATION_ORG_NOT_FINANCIAL_ORG",
    VALIDATIONNOTBELONGTOLEGALENTITY: "VALIDATION_NOT_BELONG_TO_LEGAL_ENTITY",
    VALIDATIONINVALIDACCESS: "VALIDATION_INVALID_ACCESS",
    VALIDATIONREFERENCENOTFOUND: "VALIDATION_REFERENCE_NOT_FOUND",
    VALIDATIONREFERENCEEMPTY: "VALIDATION_REFERENCE_EMPTY",
    VALIDATIONREFERENCEMISMATCH: "VALIDATION_REFERENCE_MISMATCH",
    VALIDATIONASSOCIATIONEXISTS: "VALIDATION_ASSOCIATION_EXISTS",
    VALIDATIONINCONSISTENTFIELDS: "VALIDATION_INCONSISTENT_FIELDS",
    VALIDATIONUNEXPECTEDVALUE: "VALIDATION_UNEXPECTED_VALUE",
    VALIDATIONATLEASTONEMUSTBETRUE: "VALIDATION_AT_LEAST_ONE_MUST_BE_TRUE",
    VALIDATIONONLYONEOFCANBESET: "VALIDATION_ONLY_ONE_OF_CAN_BE_SET",
    VALIDATIONREQUIREDWHENTRUE: "VALIDATION_REQUIRED_WHEN_TRUE",
    VALIDATIONREQUIREDWHENFALSE: "VALIDATION_REQUIRED_WHEN_FALSE",
    VALIDATIONONLYVALIDWHENTRUE: "VALIDATION_ONLY_VALID_WHEN_TRUE",
    VALIDATIONONLYVALIDWHENFALSE: "VALIDATION_ONLY_VALID_WHEN_FALSE",
    VALIDATIONNOTACTIVE: "VALIDATION_NOT_ACTIVE",
    VALIDATIONUNSUPPORTEDFIELD: "VALIDATION_UNSUPPORTED_FIELD",
    VALIDATIONUNSUPPORTEDVALUE: "VALIDATION_UNSUPPORTED_VALUE",
    VALIDATIONCANNOTBESAME: "VALIDATION_CANNOT_BE_SAME",
    VALIDATIONONEOFREQUIRED: "VALIDATION_ONE_OF_REQUIRED",
    VALIDATIONFEATURENOTENABLED: "VALIDATION_FEATURE_NOT_ENABLED",
    VALIDATIONNOTHINGTOUPDATE: "VALIDATION_NOTHING_TO_UPDATE",
    VALIDATIONUPDATECANNOTMODIFYFIELD: "VALIDATION_UPDATE_CANNOT_MODIFY_FIELD",
    VALIDATIONUPDATECANNOTMODIFYRESOURCE: "VALIDATION_UPDATE_CANNOT_MODIFY_RESOURCE",
    VALIDATIONINSUFFICIENTLICENSE: "VALIDATION_INSUFFICIENT_LICENSE",
    VALIDATIONINSUFFICIENTCONFIG: "VALIDATION_INSUFFICIENT_CONFIG",
    VALIDATIONINSUFFICENTPERMISSIONS: "VALIDATION_INSUFFICENT_PERMISSIONS",
    VALIDATIONDUPLICATES: "VALIDATION_DUPLICATES",
    VALIDATIONDELETENOTALLOWED: "VALIDATION_DELETE_NOT_ALLOWED",
    VALIDATIONUNABLETODELETEDUETOEXISTINGDEPENDENCIES: "VALIDATION_UNABLE_TO_DELETE_DUE_TO_EXISTING_DEPENDENCIES",
    VALIDATIONFISCALMONTHNOTFOUND: "VALIDATION_FISCAL_MONTH_NOT_FOUND",
    VALIDATIONBYTELENGTHMISMATCH: "VALIDATION_BYTE_LENGTH_MISMATCH",
    VALIDATIONUDFINPUT: "VALIDATION_UDF_INPUT",
    VALIDATIONINVALIDSTATUS: "VALIDATION_INVALID_STATUS",
    VALIDATIONCONFLICTINGSEARCHPARAMETERS: "VALIDATION_CONFLICTING_SEARCH_PARAMETERS",
    VALIDATIONINVALIDVERIFICATIONCODE: "VALIDATION_INVALID_VERIFICATION_CODE",
    VALIDATIONINVALIDMONETARYAMOUNT: "VALIDATION_INVALID_MONETARY_AMOUNT",
    VALIDATIONDATENOTINOPENFISCALPERIOD: "VALIDATION_DATE_NOT_IN_OPEN_FISCAL_PERIOD",
    VALIDATIONINVALIDORGANIZATION: "VALIDATION_INVALID_ORGANIZATION",
    INVALIDCONFIGURATION: "INVALID_CONFIGURATION",
    CONSTRAINTVIOLATION: "CONSTRAINT_VIOLATION",
    PAYLOADTOOLARGE: "PAYLOAD_TOO_LARGE",
    JSONPARSINGERROR: "JSON_PARSING_ERROR",
    JSONMAPPINGERROR: "JSON_MAPPING_ERROR",
    LOGINACCOUNTLOCKED: "LOGIN_ACCOUNT_LOCKED",
    LOGININVALIDCREDENTIALS: "LOGIN_INVALID_CREDENTIALS",
    LOGINEXPIREDCREDENTIALS: "LOGIN_EXPIRED_CREDENTIALS",
    NOTDELETABLE: "NOT_DELETABLE",
    REQUESTBODYNOTREADABLE: "REQUEST_BODY_NOT_READABLE",
    UNAUTHORIZED: "UNAUTHORIZED",
    JWTINVALIDTOKENSIGNATURE: "JWT_INVALID_TOKEN_SIGNATURE",
    JWTEXPIREDTOKEN: "JWT_EXPIRED_TOKEN",
    JWTINVALIDCLAIM: "JWT_INVALID_CLAIM",
    JWTMISSINGTOKEN: "JWT_MISSING_TOKEN",
    JWTREVOKEDTOKEN: "JWT_REVOKED_TOKEN",
    JWTBADLYFORMATTEDTOKEN: "JWT_BADLY_FORMATTED_TOKEN",
    FORBIDDEN: "FORBIDDEN",
    FORBIDDENINSUFFICIENTLICENSE: "FORBIDDEN_INSUFFICIENT_LICENSE",
    FORBIDDENINSUFFICIENTCONFIGURATION: "FORBIDDEN_INSUFFICIENT_CONFIGURATION",
    FORBIDDENINSUFFICIENTROLE: "FORBIDDEN_INSUFFICIENT_ROLE",
    FORBIDDENNOTOWNER: "FORBIDDEN_NOT_OWNER",
    FORBIDDENNOTMANAGER: "FORBIDDEN_NOT_MANAGER",
    FORBIDDENNOTPROJECTMANAGER: "FORBIDDEN_NOT_PROJECT_MANAGER",
    FORBIDDENCANNOTASSIGNTOPROJECT: "FORBIDDEN_CANNOT_ASSIGN_TO_PROJECT",
    FORBIDDENNOTHRADMIN: "FORBIDDEN_NOT_HR_ADMIN",
    NOTHINGTOEXTRACT: "NOTHING_TO_EXTRACT",
    NOTFOUND: "NOT_FOUND",
    DUPLICATE: "DUPLICATE",
    CONFLICT: "CONFLICT",
    UNSUPPORTEDMEDIATYPE: "UNSUPPORTED_MEDIA_TYPE",
    TOOMANYREQUESTS: "TOO_MANY_REQUESTS",
    INTERNALGENERIC: "INTERNAL_GENERIC",
    EXTERNALGENERIC: "EXTERNAL_GENERIC",
    EXTERNALUNAUTHORIZED: "EXTERNAL_UNAUTHORIZED",
    EXTERNALFORBIDDEN: "EXTERNAL_FORBIDDEN",
    EXTERNALNOTFOUND: "EXTERNAL_NOT_FOUND",
    INTERNALINSERT: "INTERNAL_INSERT",
    INTERNALUPDATE: "INTERNAL_UPDATE",
    INTERNALDELETE: "INTERNAL_DELETE",
    UNAVAILABLE: "UNAVAILABLE",
    AGSELFAPPROVALDISABLED: "AG_SELF_APPROVAL_DISABLED",
    AGAPPROVALREQUIRED: "AG_APPROVAL_REQUIRED",
    AGINVALIDAPPROVALGROUPTYPE: "AG_INVALID_APPROVAL_GROUP_TYPE",
    AGEXPAPPROVALUNAVAILABLE: "AG_EXP_APPROVAL_UNAVAILABLE",
    AGEXPAPPROVALFORBIDDEN: "AG_EXP_APPROVAL_FORBIDDEN",
    AGTIMEAPPROVALUNAVAILABLE: "AG_TIME_APPROVAL_UNAVAILABLE",
    AGTIMEAPPROVALFORBIDDEN: "AG_TIME_APPROVAL_FORBIDDEN",
    AGTYPEMISMATCH: "AG_TYPE_MISMATCH",
    AGSUBMITTERNOTREMOVABLE: "AG_SUBMITTER_NOT_REMOVABLE",
    AGSUBMITTINGPROJECTNOTSETUPFORINVOICING: "AG_SUBMITTING_PROJECT_NOT_SETUP_FOR_INVOICING",
    AGINVOICEAPPROVALUNAVAILABLE: "AG_INVOICE_APPROVAL_UNAVAILABLE",
    AGINVOICEAPPROVALFORBIDDEN: "AG_INVOICE_APPROVAL_FORBIDDEN",
    AGPOAPPROVALFORBIDDEN: "AG_PO_APPROVAL_FORBIDDEN",
    AGPOAPPROVALUNAVAILABLE: "AG_PO_APPROVAL_UNAVAILABLE",
    ALTERNATECANNOTASSIGNSAMEUSER: "ALTERNATE_CANNOT_ASSIGN_SAME_USER",
    ALTERNATERESTRICTEDTOEMPLOYEES: "ALTERNATE_RESTRICTED_TO_EMPLOYEES",
    ALTERNATERESTRICTEDTOMANAGERS: "ALTERNATE_RESTRICTED_TO_MANAGERS",
    ALTERNATERESTRICTEDTOROLE: "ALTERNATE_RESTRICTED_TO_ROLE",
    BANKRECONCILIATIONNOTFOUND: "BANK_RECONCILIATION_NOT_FOUND",
    BANKRECONCILIATIONATTACHMENTNOTASSOCIATEDWITHBANKRECONCILIATION: "BANK_RECONCILIATION_ATTACHMENT_NOT_ASSOCIATED_WITH_BANK_RECONCILIATION",
    BANKRECONCILIATIONINVALIDGLKEYS: "BANK_RECONCILIATION_INVALID_GL_KEYS",
    BANKFEEDEXCLUSIONREASONREQUIRED: "BANK_FEED_EXCLUSION_REASON_REQUIRED",
    BANKFEEDWORKFLOWRULENOTFOUND: "BANK_FEED_WORKFLOW_RULE_NOT_FOUND",
    BANKFEEDWORKFLOWRULEVALUENOTFOUND: "BANK_FEED_WORKFLOW_RULE_VALUE_NOT_FOUND",
    CONTRACTWAGEDETERMINATIONSTARTDATEBEFORECONTRACTSTARTDATE: "CONTRACT_WAGE_DETERMINATION_START_DATE_BEFORE_CONTRACT_START_DATE",
    CONTRACTWAGEDETERMINATIONENDDATEAFTERCONTRACTENDDATE: "CONTRACT_WAGE_DETERMINATION_END_DATE_AFTER_CONTRACT_END_DATE",
    CONTRACTSTARTDATEBEFOREPREVIOUSSTARTDATE: "CONTRACT_START_DATE_BEFORE_PREVIOUS_START_DATE",
    CONTRACTENDDATEAFTERNEXTSTARTDATE: "CONTRACT_END_DATE_AFTER_NEXT_START_DATE",
    CONTRACTCOVERAGEMUSTBECONTINUOUS: "CONTRACT_COVERAGE_MUST_BE_CONTINUOUS",
    CONTRACTSCARATEREQUIRED: "CONTRACT_SCA_RATE_REQUIRED",
    CONTRACTPRIMECONTRACTKEYNOTALLOWED: "CONTRACT_PRIME_CONTRACT_KEY_NOT_ALLOWED",
    CUSTOMERPAYMENTISAPPLIED: "CUSTOMER_PAYMENT_IS_APPLIED",
    CPPOSTED: "CP_POSTED",
    CPSUBMITTED: "CP_SUBMITTED",
    DEPOSITPOSTED: "DEPOSIT_POSTED",
    DEPOSITSUBMITTED: "DEPOSIT_SUBMITTED",
    DEPOSITEDDOCAPPLIED: "DEPOSITED_DOC_APPLIED",
    DEPOSITEDDOCNOTPOSTED: "DEPOSITED_DOC_NOT_POSTED",
    DEPOSITEDDOCVOIDED: "DEPOSITED_DOC_VOIDED",
    DEPOSITEDDOCVOIDING: "DEPOSITED_DOC_VOIDING",
    DEPOSITEDDOCLEGALENTITYMISMATCH: "DEPOSITED_DOC_LEGAL_ENTITY_MISMATCH",
    DEPOSITEDDOCALREADYINCLUDED: "DEPOSITED_DOC_ALREADY_INCLUDED",
    DEPOSITEDDOCZEROAMOUNT: "DEPOSITED_DOC_ZERO_AMOUNT",
    DEPOSITEDDOCINVALIDBANKACCOUNTTYPE: "DEPOSITED_DOC_INVALID_BANK_ACCOUNT_TYPE",
    EXCHANGERATETYPECANNOTREMOVEDEFAULTSTATUS: "EXCHANGE_RATE_TYPE_CANNOT_REMOVE_DEFAULT_STATUS",
    EXCHANGERATETYPECANNOTDELETEDEFAULT: "EXCHANGE_RATE_TYPE_CANNOT_DELETE_DEFAULT",
    EXCHANGERATETYPECANNOTDELETEINUSE: "EXCHANGE_RATE_TYPE_CANNOT_DELETE_IN_USE",
    EXCHANGERATESAMEFROMTOCURRENCY: "EXCHANGE_RATE_SAME_FROM_TO_CURRENCY",
    EXCHANGERATENOTFOUND: "EXCHANGE_RATE_NOT_FOUND",
    EXPENSESUMMARYREQUIREDWHENWITHWIZARD: "EXPENSE_SUMMARY_REQUIRED_WHEN_WITH_WIZARD",
    EXPENSEATTACHMENTNOTASSOCIATEDWITHEXPENSE: "EXPENSE_ATTACHMENT_NOT_ASSOCIATED_WITH_EXPENSE",
    EXPENSEPROJECTALLOCATIONPROJECTKEYMUSTNOTBENULL: "EXPENSE_PROJECT_ALLOCATION_PROJECT_KEY_MUST_NOT_BE_NULL",
    EXPENSEPROJECTALLOCATIONPROJECTNOTFOUND: "EXPENSE_PROJECT_ALLOCATION_PROJECT_NOT_FOUND",
    EXPENSEPROJECTALLOCATIONTASKINVALID: "EXPENSE_PROJECT_ALLOCATION_TASK_INVALID",
    EXPENSEPROJECTALLOCATIONTASKNOTFOUND: "EXPENSE_PROJECT_ALLOCATION_TASK_NOT_FOUND",
    EXPENSEPROJECTALLOCATIONPERCENTAGEMUSTNOTBENULL: "EXPENSE_PROJECT_ALLOCATION_PERCENTAGE_MUST_NOT_BE_NULL",
    EXPENSE_PROJECT_ALLOCATION_PERCENTAGES_MUST_TOTAL_100: "EXPENSE_PROJECT_ALLOCATION_PERCENTAGES_MUST_TOTAL_100",
    EXPENSEPROJECTALLOCATIONDUPLICATIONS: "EXPENSE_PROJECT_ALLOCATION_DUPLICATIONS",
    EXPENSEREPORTMULTIENTITYNOTENABLED: "EXPENSE_REPORT_MULTI_ENTITY_NOT_ENABLED",
    EXPENSEREPORTMULTIENTITYNOASSIGNMENT: "EXPENSE_REPORT_MULTI_ENTITY_NO_ASSIGNMENT",
    EXPENSEDETAILAMOUNTMISMATCH: "EXPENSE_DETAIL_AMOUNT_MISMATCH",
    EXPENSEDETAILEXCHANGERATEMUSTBEONE: "EXPENSE_DETAIL_EXCHANGE_RATE_MUST_BE_ONE",
    FADISPOSALFIELDSREQUIRED: "FA_DISPOSAL_FIELDS_REQUIRED",
    FADISPOSALBEFOREDEPRECIATIONSTART: "FA_DISPOSAL_BEFORE_DEPRECIATION_START",
    FADISPOSALBEFOREFISCALPERIODBEGIN: "FA_DISPOSAL_BEFORE_FISCAL_PERIOD_BEGIN",
    FADISPOSALBEFOREFISCALPERIODEND: "FA_DISPOSAL_BEFORE_FISCAL_PERIOD_END",
    FADISPOSALEQUALSFISCALPERIODEND: "FA_DISPOSAL_EQUALS_FISCAL_PERIOD_END",
    FAJOURNALENTRYNOTFOUND: "FA_JOURNAL_ENTRY_NOT_FOUND",
    FAHASPOSTEDDISPOSAL: "FA_HAS_POSTED_DISPOSAL",
    FAHASPOSTEDTRANSACTIONS: "FA_HAS_POSTED_TRANSACTIONS",
    FANOLONGERPOSTABLE: "FA_NO_LONGER_POSTABLE",
    FATRANSACTIONENTRYNOTALLOWEDFORACCOUNT: "FA_TRANSACTION_ENTRY_NOT_ALLOWED_FOR_ACCOUNT",
    FAPROJECTREQUIREDFORACCOUNT: "FA_PROJECT_REQUIRED_FOR_ACCOUNT",
    FALOCATIONCONFLICT: "FA_LOCATION_CONFLICT",
    FAPNOORGFORFIXEDASSET: "FAP_NO_ORG_FOR_FIXED_ASSET",
    FAPFISCALPERIODCLOSED: "FAP_FISCAL_PERIOD_CLOSED",
    FAPINCLUDEDINBANKRECONCILIATION: "FAP_INCLUDED_IN_BANK_RECONCILIATION",
    FAPNOTLATESTPOSTFORLEGALENTITY: "FAP_NOT_LATEST_POST_FOR_LEGAL_ENTITY",
    FAPSTATUSREQUIREDWHENDISPOSEDASSETSINCLUDED: "FAP_STATUS_REQUIRED_WHEN_DISPOSED_ASSETS_INCLUDED",
    FPIEITHERBILLDATEORBILLONCOMPLETIONREQUIRED: "FPI_EITHER_BILL_DATE_OR_BILL_ON_COMPLETION_REQUIRED",
    FPIBILLANDBILLONCOMPLETIONSET: "FPI_BILL_AND_BILL_ON_COMPLETION_SET",
    FPIINVALIDREVRECOGNITIONMETHODFORSCHEDULE: "FPI_INVALID_REV_RECOGNITION_METHOD_FOR_SCHEDULE",
    FPIITEMPOSTEDFORBILLING: "FPI_ITEM_POSTED_FOR_BILLING",
    FPIITEMONCOMPLETEDINVOICE: "FPI_ITEM_ON_COMPLETED_INVOICE",
    IMPORTEDEXPENSEEXPENSETYPEINVALID: "IMPORTED_EXPENSE_EXPENSE_TYPE_INVALID",
    IMPORTEDEXPENSENOTAVAILABLE: "IMPORTED_EXPENSE_NOT_AVAILABLE",
    INTEGRATIONUSEREXISTS: "INTEGRATION_USER_EXISTS",
    INVENTORYTASKPROJECTMISMATCH: "INVENTORY_TASK_PROJECT_MISMATCH",
    INVENTORYCANNOTASSOCIATEITEMWITHTASKNOTSUPPORTINGITEMS: "INVENTORY_CANNOT_ASSOCIATE_ITEM_WITH_TASK_NOT_SUPPORTING_ITEMS",
    INVENTORYCANNOTASSOCIATEITEMWITHPROJECTNOTSUPPORTINGITEMS: "INVENTORY_CANNOT_ASSOCIATE_ITEM_WITH_PROJECT_NOT_SUPPORTING_ITEMS",
    INVENTORYTASKCONTAINSPROJECTNOTASSOCIATEDWITHITEM: "INVENTORY_TASK_CONTAINS_PROJECT_NOT_ASSOCIATED_WITH_ITEM",
    INVOICEPDFNOTFOUND: "INVOICE_PDF_NOT_FOUND",
    INVOICEPDFEXCEEDSMAXSIZE: "INVOICE_PDF_EXCEEDS_MAX_SIZE",
    INVOICEPROJECTNOTBELONGTOOWNINGORG: "INVOICE_PROJECT_NOT_BELONG_TO_OWNING_ORG",
    INVOICEPROJECTOWNINGORGNOTFOUND: "INVOICE_PROJECT_OWNING_ORG_NOT_FOUND",
    INVOICEPROJECTOWNINGORGLEGALENTITYNOTFOUND: "INVOICE_PROJECT_OWNING_ORG_LEGAL_ENTITY_NOT_FOUND",
    INVOICEPROJECTOWNINGORGLEGALENTITYHASNOPOSTINGORG: "INVOICE_PROJECT_OWNING_ORG_LEGAL_ENTITY_HAS_NO_POSTING_ORG",
    INVOICEPROJECTCUSTOMERORGNOTVALIDFORLEGALENTITY: "INVOICE_PROJECT_CUSTOMER_ORG_NOT_VALID_FOR_LEGAL_ENTITY",
    INVOICEPROJECTCUSTOMERORGHASNOBANKACCOUNT: "INVOICE_PROJECT_CUSTOMER_ORG_HAS_NO_BANK_ACCOUNT",
    INVOICEPROJECTCUSTOMERORGHASNOFEEACCOUNT: "INVOICE_PROJECT_CUSTOMER_ORG_HAS_NO_FEE_ACCOUNT",
    INVOICEAUTOPAYMENTMETHODNOTFOUND: "INVOICE_AUTO_PAYMENT_METHOD_NOT_FOUND",
    INVOICEPAYOUTNOTMATCHDETAILSUM: "INVOICE_PAYOUT_NOT_MATCH_DETAIL_SUM",
    INVOICEMORETHANONEPAYMENTFOUND: "INVOICE_MORE_THAN_ONE_PAYMENT_FOUND",
    INVOICESINGLEPAYOUTFORMULTIPLELEGALENTITIES: "INVOICE_SINGLE_PAYOUT_FOR_MULTIPLE_LEGAL_ENTITIES",
    INVOICEBANKACCOUNTNOTFOUND: "INVOICE_BANK_ACCOUNT_NOT_FOUND",
    INVOICEMULTIPLEBANKACCOUNTSFOUND: "INVOICE_MULTIPLE_BANK_ACCOUNTS_FOUND",
    INVOICESTATUSNOTALLOWSUBMIT: "INVOICE_STATUS_NOT_ALLOW_SUBMIT",
    INVOICECANNOTSUBMITDUETOAPPROVALS: "INVOICE_CANNOT_SUBMIT_DUE_TO_APPROVALS",
    INVOICESTATUSNOTALLOWCOMPLETE: "INVOICE_STATUS_NOT_ALLOW_COMPLETE",
    INVOICECANNOTPOSTCOMPLETION: "INVOICE_CANNOT_POST_COMPLETION",
    INVOICEFUNDINGALLOCATION: "INVOICE_FUNDING_ALLOCATION",
    INVOICEFORMATOPTIONSSECTIONVALIDATEWORKDATE: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_WORK_DATE",
    INVOICEFORMATOPTIONSSECTIONVALIDATECOMMENTS: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_COMMENTS",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWDATE: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_DATE",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWCOMMENTS: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_COMMENTS",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWCOST: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_COST",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWMARKUPPCT: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_MARKUP_PCT",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWMARKUPMULT: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_MARKUP_MULT",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWMARKUP: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_MARKUP",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWCOSTRATE: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_COST_RATE",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWBILLDATE: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_BILL_DATE",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWINDV: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_INDV",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWITEMDATE: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_ITEM_DATE",
    INVOICEFORMATOPTIONSSECTIONVALIDATECOLVALUEMISSING: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_COL_VALUE_MISSING",
    INVOICEFORMATOPTIONSSECTIONVALIDATECOLVALUEHEADING: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_COL_VALUE_HEADING",
    INVOICEFORMATOPTIONSSECTIONVALIDATECOLVALUEDUPLICATE: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_COL_VALUE_DUPLICATE",
    INVOICEFORMATOPTIONSSECTIONVALIDATESUBQTY: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SUB_QTY",
    INVOICEFORMATOPTIONSSECTIONVALIDATESUBITDQTY: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SUB_ITD_QTY",
    INVOICEFORMATOPTIONSSECTIONVALIDATEKEY: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_KEY",
    JOURNALPROJECTREQUIREDWHENFIELDPROVIDED: "JOURNAL_PROJECT_REQUIRED_WHEN_FIELD_PROVIDED",
    JOURNALFIELDREQUIREDWHENPROJECTPROVIDED: "JOURNAL_FIELD_REQUIRED_WHEN_PROJECT_PROVIDED",
    JOURNALREVERSINGDATEMUSTBEINFISCALPERIODAFTERPOSTDATE: "JOURNAL_REVERSING_DATE_MUST_BE_IN_FISCAL_PERIOD_AFTER_POST_DATE",
    JOURNALTASKPROJECTMISMATCH: "JOURNAL_TASK_PROJECT_MISMATCH",
    LOGOTYPEINVALID: "LOGO_TYPE_INVALID",
    LEAVEAPPROVALQUEUEINVALIDAPPROVER: "LEAVE_APPROVAL_QUEUE_INVALID_APPROVER",
    LEAVEAPPROVALUNAVAILABLE: "LEAVE_APPROVAL_UNAVAILABLE",
    MAILUNABLETOVERIFYSIGNATURE: "MAIL_UNABLE_TO_VERIFY_SIGNATURE",
    INSTANCECURRENCYNOTFOUND: "INSTANCE_CURRENCY_NOT_FOUND",
    MULTICURRENCYALREADYACTIVATED: "MULTICURRENCY_ALREADY_ACTIVATED",
    MULTICURRENCYINSTANCECURRENCYNOTSET: "MULTICURRENCY_INSTANCE_CURRENCY_NOT_SET",
    MULTICURRENCYINSTANCECURRENCYINVALID: "MULTICURRENCY_INSTANCE_CURRENCY_INVALID",
    MULTICURRENCYREQUIRESCURRENCYCODE: "MULTICURRENCY_REQUIRES_CURRENCY_CODE",
    MULTICURRENCYOPERATIONNOTENABLED: "MULTICURRENCY_OPERATION_NOT_ENABLED",
    MULTICURRENCYINVALIDPAYMENTMETHOD: "MULTICURRENCY_INVALID_PAYMENT_METHOD",
    MULTICURRENCYREQUIRESUSD: "MULTICURRENCY_REQUIRES_USD",
    NOTIFICATIONTITLEREQUIRESARGUMENTS: "NOTIFICATION_TITLE_REQUIRES_ARGUMENTS",
    NOTIFICATIONMESSAGEREQUIRESARGUMENTS: "NOTIFICATION_MESSAGE_REQUIRES_ARGUMENTS",
    ORGVENDORPROFILEMISMATCH: "ORG_VENDOR_PROFILE_MISMATCH",
    ORGFEDERALTAXIDINVALID: "ORG_FEDERAL_TAX_ID_INVALID",
    ORGGLPOSTORGMISMATCH: "ORG_GL_POST_ORG_MISMATCH",
    ORGACCOUNTCATEGORYINVALID: "ORG_ACCOUNT_CATEGORY_INVALID",
    PERSONPASSWORDMISMATCH: "PERSON_PASSWORD_MISMATCH",
    PERSONUNABLETODELETEDUETOEXISTINGDEPENDENCIES: "PERSON_UNABLE_TO_DELETE_DUE_TO_EXISTING_DEPENDENCIES",
    PERSONNOTFOUND: "PERSON_NOT_FOUND",
    PERSONATTACHMENTNOTASSOCIATEDWITHPERSON: "PERSON_ATTACHMENT_NOT_ASSOCIATED_WITH_PERSON",
    PERSONPUNCHCLOCKUSERREQUIRESTIMESHEETUSERROLE: "PERSON_PUNCH_CLOCK_USER_REQUIRES_TIMESHEET_USER_ROLE",
    PERSONRATEHASEXTRACTEDTIME: "PERSON_RATE_HAS_EXTRACTED_TIME",
    PERSONRATEEXEMPTCANNOTSETSCAWAGEFLAG: "PERSON_RATE_EXEMPT_CANNOT_SET_SCA_WAGE_FLAG",
    PLANSETNAMEMUSTHAVESYSDEFAULT: "PLAN_SET_NAME_MUST_HAVE_SYS_DEFAULT",
    POPRKEYREQUIRED: "PO_PR_KEY_REQUIRED",
    POPRINVALIDSTATUS: "PO_PR_INVALID_STATUS",
    POCOMMITMENTDATENOTINOPENFISCALPERIOD: "PO_COMMITMENT_DATE_NOT_IN_OPEN_FISCAL_PERIOD",
    POLINENOTINOPENSTATE: "PO_LINE_NOT_IN_OPEN_STATE",
    POMODNOTORIGINALPO: "PO_MOD_NOT_ORIGINAL_PO",
    POMODNUMBERREQUIRED: "PO_MOD_NUMBER_REQUIRED",
    POMODINVALIDVIOVERAGE: "PO_MOD_INVALID_VI_OVERAGE",
    POMODCANNOTUPDATE: "PO_MOD_CANNOT_UPDATE",
    PONOTINOPENSTATE: "PO_NOT_IN_OPEN_STATE",
    PONOTMOD: "PO_NOT_MOD",
    PONOTORIGINAL: "PO_NOT_ORIGINAL",
    POSUBMITVALIDATION: "PO_SUBMIT_VALIDATION",
    POSTATUSNOTALLOWSUBMIT: "PO_STATUS_NOT_ALLOW_SUBMIT",
    POWITHEXISTINGDETAILSINVALIDUPDATE: "PO_WITH_EXISTING_DETAILS_INVALID_UPDATE",
    POPRREFERENCEMISMATCH: "PO_PR_REFERENCE_MISMATCH",
    POCANNOTSUBMITTOAPPROVALGROUP: "PO_CANNOT_SUBMIT_TO_APPROVAL_GROUP",
    PODETAILSPROJECTNOTALLOWCHARGES: "PO_DETAILS_PROJECT_NOT_ALLOW_CHARGES",
    PODETAILSINVALIDVALUE: "PO_DETAILS_INVALID_VALUE",
    PODETAILSACCOUNTMUSTREQUIREPROJECTS: "PO_DETAILS_ACCOUNT_MUST_REQUIRE_PROJECTS",
    PODETAILSACCOUNTINVALID: "PO_DETAILS_ACCOUNT_INVALID",
    PODETAILSTERMINALSTATUS: "PO_DETAILS_TERMINAL_STATUS",
    PODETAILSREFLINEEXISTS: "PO_DETAILS_REF_LINE_EXISTS",
    PODETAILSPRREFERENCEMISMATCH: "PO_DETAILS_PR_REFERENCE_MISMATCH",
    PODETAILSPRLINEREFERENCEMISMATCH: "PO_DETAILS_PR_LINE_REFERENCE_MISMATCH",
    POWITHDETAILSCANNOTUPDATEVENDORWITHDIFFERENTCURRENCY: "PO_WITH_DETAILS_CANNOT_UPDATE_VENDOR_WITH_DIFFERENT_CURRENCY",
    PDANDVENDORWITHDIFFERENTCURRENCIES: "PD_AND_VENDOR_WITH_DIFFERENT_CURRENCIES",
    POASSIGNMENTOVERLAPSEXISTINGASSIGNMENT: "PO_ASSIGNMENT_OVERLAPS_EXISTING_ASSIGNMENT",
    POSTINGGROUPCANNOTUPDATEACTIVESTATUS: "POSTING_GROUP_CANNOT_UPDATE_ACTIVE_STATUS",
    POSTINGGROUPCANNOTUPDATETYPE: "POSTING_GROUP_CANNOT_UPDATE_TYPE",
    POSTINGGROUPTYPEMUSTBECUSTOM: "POSTING_GROUP_TYPE_MUST_BE_CUSTOM",
    POSTINGGROUPSOURCEACCOUNTREQUIRED: "POSTING_GROUP_SOURCE_ACCOUNT_REQUIRED",
    POSTINGGROUPSOURCEACCOUNTSOURCEINVALID: "POSTING_GROUP_SOURCE_ACCOUNT_SOURCE_INVALID",
    POSTINGGROUPSOURCEACCOUNTSOURCEINVALIDSTATE: "POSTING_GROUP_SOURCE_ACCOUNT_SOURCE_INVALID_STATE",
    POSTINGGROUPSOURCEINVALIDORGANIZATIONSOURCE: "POSTING_GROUP_SOURCE_INVALID_ORGANIZATION_SOURCE",
    POSTINGGROUPSOURCEPOSTINGGROUPMISMATCH: "POSTING_GROUP_SOURCE_POSTING_GROUP_MISMATCH",
    PRMODCANNOTUPDATE: "PR_MOD_CANNOT_UPDATE",
    PRWITHEXISTINGDETAILSINVALIDUPDATE: "PR_WITH_EXISTING_DETAILS_INVALID_UPDATE",
    PRTERMINALSTATUS: "PR_TERMINAL_STATUS",
    PRNOTTERMINALSTATUS: "PR_NOT_TERMINAL_STATUS",
    PRNOTMOD: "PR_NOT_MOD",
    PRNOTORIGINAL: "PR_NOT_ORIGINAL",
    PRMODNOTORIGINALPR: "PR_MOD_NOT_ORIGINAL_PR",
    PRNOTINOPENSTATE: "PR_NOT_IN_OPEN_STATE",
    PRMODNUMBERREQUIRED: "PR_MOD_NUMBER_REQUIRED",
    PRDETAILSTERMINALSTATUS: "PR_DETAILS_TERMINAL_STATUS",
    PRDETAILSREFLINEEXISTS: "PR_DETAILS_REF_LINE_EXISTS",
    PRDETAILSACCOUNTMUSTREQUIREPROJECTS: "PR_DETAILS_ACCOUNT_MUST_REQUIRE_PROJECTS",
    PRCANNOTSUBMIT: "PR_CANNOT_SUBMIT",
    PRDETAILSCANNOTUPDATECURRENCY: "PR_DETAILS_CANNOT_UPDATE_CURRENCY",
    PDDETAILSPROJECTNOTALLOWCHARGES: "PD_DETAILS_PROJECT_NOT_ALLOW_CHARGES",
    PDDETAILSACCOUNTINVALID: "PD_DETAILS_ACCOUNT_INVALID",
    PDDETAILSEXCESSREVERSEVALUE: "PD_DETAILS_EXCESS_REVERSE_VALUE",
    PROJECTDUPLICATERATES: "PROJECT_DUPLICATE_RATES",
    PROJECTRATESREQUIREDWITHNOMASTERRATES: "PROJECT_RATES_REQUIRED_WITH_NO_MASTER_RATES",
    PROJECTRATESNOTALLOWEDWITHMASTERRATES: "PROJECT_RATES_NOT_ALLOWED_WITH_MASTER_RATES",
    PROJECTLOCATIONSMISSINGPROJECTDEFAULT: "PROJECT_LOCATIONS_MISSING_PROJECT_DEFAULT",
    PROJECTDEFAULTPROJECTLOCATIONDELETENOTALLOWED: "PROJECT_DEFAULT_PROJECT_LOCATION_DELETE_NOT_ALLOWED",
    PROJECTCUSTOMRATEUPDATENOTALLOWED: "PROJECT_CUSTOM_RATE_UPDATE_NOT_ALLOWED",
    PROJECTINACTIVEUSER: "PROJECT_INACTIVE_USER",
    PROJECTCONTRIBUTORINVOICEMUSTHAVEGENERATEINVOICEFLAGSET: "PROJECT_CONTRIBUTOR_INVOICE_MUST_HAVE_GENERATE_INVOICE_FLAG_SET",
    PROJECTLEADPROJECTREQUIREDFORINVOICECONTRIBUTORS: "PROJECT_LEAD_PROJECT_REQUIRED_FOR_INVOICE_CONTRIBUTORS",
    PROJECTLEADPROJECTMUSTBEDIFFERENTTHANCONTRIBUTORPROJECT: "PROJECT_LEAD_PROJECT_MUST_BE_DIFFERENT_THAN_CONTRIBUTOR_PROJECT",
    PROJECTORGNOTWITHINOWNINGORGLEGALENTITY: "PROJECT_ORG_NOT_WITHIN_OWNING_ORG_LEGAL_ENTITY",
    PROJECTLEADANDCONTRIBUTORPROJECTSMUSTHAVESAMELEGALENTITY: "PROJECT_LEAD_AND_CONTRIBUTOR_PROJECTS_MUST_HAVE_SAME_LEGAL_ENTITY",
    PROJECTADDRESSREQUIREDWHENDEFAULTNOTAVAILABLE: "PROJECT_ADDRESS_REQUIRED_WHEN_DEFAULT_NOT_AVAILABLE",
    PROJECTINVOICESETUPNOTFOUNDFORLEADPROJECT: "PROJECT_INVOICE_SETUP_NOT_FOUND_FOR_LEAD_PROJECT",
    PROJECTINVOICESETUPINVALIDACTIONDUETOPENDINGAPPROVALS: "PROJECT_INVOICE_SETUP_INVALID_ACTION_DUE_TO_PENDING_APPROVALS",
    PROJECTINVALIDLEADPROJECTASSIGNEDTOINVOICEGROUP: "PROJECT_INVALID_LEAD_PROJECT_ASSIGNED_TO_INVOICE_GROUP",
    PROJECTINVALIDCONTRIBUTORPROJECTASSIGNEDTOINVOICEGROUP: "PROJECT_INVALID_CONTRIBUTOR_PROJECT_ASSIGNED_TO_INVOICE_GROUP",
    PROJECTDUPLICATEINVOICEFORMATSSPECIFIED: "PROJECT_DUPLICATE_INVOICE_FORMATS_SPECIFIED",
    PROJECTPAYCODEMISSINGPROJECTDEFAULT: "PROJECT_PAY_CODE_MISSING_PROJECT_DEFAULT",
    PROJECTDEFAULTPROJECTPAYCODEDELETENOTALLOWED: "PROJECT_DEFAULT_PROJECT_PAY_CODE_DELETE_NOT_ALLOWED",
    PROJECTPAYMENTOPTIONREQUIREDWHENELECTRONICPAYMENTSENABLED: "PROJECT_PAYMENT_OPTION_REQUIRED_WHEN_ELECTRONIC_PAYMENTS_ENABLED",
    PROJECTACCOUNTCATEGORYINVALID: "PROJECT_ACCOUNT_CATEGORY_INVALID",
    PROJECTTASKLEVELMUSTHAVETASK: "PROJECT_TASK_LEVEL_MUST_HAVE_TASK",
    PROJECTTASKLEVELMUSTNOTHAVETASK: "PROJECT_TASK_LEVEL_MUST_NOT_HAVE_TASK",
    PROJECTASSIGNMENT: "PROJECT_ASSIGNMENT",
    PROJECTTASKASSIGNMENT: "PROJECT_TASK_ASSIGNMENT",
    PROJECTMUSTASSIGNTOCONTRACT: "PROJECT_MUST_ASSIGN_TO_CONTRACT",
    PROJECTEXCEEDCONTRACTCEILINGAMOUNT: "PROJECT_EXCEED_CONTRACT_CEILING_AMOUNT",
    PROJECTALERTTHRESHOLDPERCENTAGEREQUIRED: "PROJECT_ALERT_THRESHOLD_PERCENTAGE_REQUIRED",
    PROJECTINTERCOMPANYNOTPROVIDED: "PROJECT_INTERCOMPANY_NOT_PROVIDED",
    PROJECTINTERCOMPANYMUSTBEENABLED: "PROJECT_INTERCOMPANY_MUST_BE_ENABLED",
    PROJECTPRIMARYAPPROVERREQUIREDFORALTERNATE: "PROJECT_PRIMARY_APPROVER_REQUIRED_FOR_ALTERNATE",
    PROJECTINVALIDPRIMARYCONTROLLER: "PROJECT_INVALID_PRIMARY_CONTROLLER",
    PROJECTINVALIDALTERNATECONTROLLER: "PROJECT_INVALID_ALTERNATE_CONTROLLER",
    PROJECTORGASSIGNMENTTASKLEVEL: "PROJECT_ORG_ASSIGNMENT_TASK_LEVEL",
    PROJECTPREBILLEDLABORBALANCE: "PROJECT_PREBILLED_LABOR_BALANCE",
    PROJECTPREBILLEDLABORPOSTED: "PROJECT_PREBILLED_LABOR_POSTED",
    PROJECTEXPENSEPLANLOCKEDPLANSET: "PROJECT_EXPENSE_PLAN_LOCKED_PLAN_SET",
    PROJECTEXPENSEPLANMULTIPLEPLANSETSNOTENABLED: "PROJECT_EXPENSE_PLAN_MULTIPLE_PLAN_SETS_NOT_ENABLED",
    PROJECTHASPOSTEDTRANSACTIONS: "PROJECT_HAS_POSTED_TRANSACTIONS",
    PROJECTLABORCATEGORYINVALID: "PROJECT_LABOR_CATEGORY_INVALID",
    PROJECTLABORCATEGORYCANNOTDEFAULTTOMASTERRATE: "PROJECT_LABOR_CATEGORY_CANNOT_DEFAULT_TO_MASTER_RATE",
    PROJECTTYPEACCOUNTCATEGORYINVALID: "PROJECT_TYPE_ACCOUNT_CATEGORY_INVALID",
    RECEIVINGDOCUMENTITEMEXCEEDSQUANTITY: "RECEIVING_DOCUMENT_ITEM_EXCEEDS_QUANTITY",
    RECEIVINGDOCUMENTNOTRETRACTABLE: "RECEIVING_DOCUMENT_NOT_RETRACTABLE",
    TASKINVALIDPLAN: "TASK_INVALID_PLAN",
    TASKINVALIDASSIGNMENT: "TASK_INVALID_ASSIGNMENT",
    TASKVALIDATION: "TASK_VALIDATION",
    TASKPROJECTMISMATCH: "TASK_PROJECT_MISMATCH",
    TASKPARENTTASKPROJECTMISMATCH: "TASK_PARENT_TASK_PROJECT_MISMATCH",
    TASKCANNOTLIMITBILLTOFUNDEDWITHOUTFUNDEDVALUE: "TASK_CANNOT_LIMIT_BILL_TO_FUNDED_WITHOUT_FUNDED_VALUE",
    TASKCANNOTLIMITREVENUETOFUNDEDWITHOUTFUNDEDVALUE: "TASK_CANNOT_LIMIT_REVENUE_TO_FUNDED_WITHOUT_FUNDED_VALUE",
    TASKBILLINGTYPECANNOTBESETUNLESSALSOSETONPROJECT: "TASK_BILLING_TYPE_CANNOT_BE_SET_UNLESS_ALSO_SET_ON_PROJECT",
    TASKCANNOTOVERRIDEBILLINGTYPE: "TASK_CANNOT_OVERRIDE_BILLING_TYPE",
    TASKMODIFIEDRELATIVETASKPROJECTDOESNOTMATCHMODIFIEDTASKPROJECT: "TASK_MODIFIED_RELATIVE_TASK_PROJECT_DOES_NOT_MATCH_MODIFIED_TASK_PROJECT",
    TASKACCOUNTCATEGORYINVALID: "TASK_ACCOUNT_CATEGORY_INVALID",
    TASKPREDECESSORNOTAVAILABLE: "TASK_PREDECESSOR_NOT_AVAILABLE",
    TASKPREDECESSORINVALIDDATERANGE: "TASK_PREDECESSOR_INVALID_DATE_RANGE",
    TIMERATINGGENERIC: "TIME_RATING_GENERIC",
    TIMESHEETTIMESLIPNOTFOUND: "TIMESHEET_TIMESLIP_NOT_FOUND",
    TIMESHEETITEMENTRYNOTFOUND: "TIMESHEET_ITEM_ENTRY_NOT_FOUND",
    TIMESHEETTITONOTFOUND: "TIMESHEET_TITO_NOT_FOUND",
    TIMESHEETTITOWITHNULLSTOPTIME: "TIMESHEET_TITO_WITH_NULL_STOP_TIME",
    TIMESHEETTITOOVERLAP: "TIMESHEET_TITO_OVERLAP",
    TIMESHEETTITOINVALIDTIMEUNITS: "TIMESHEET_TITO_INVALID_TIME_UNITS",
    TIMESHEETTITONONWORKHOURSEXCEEDSTITODURATION: "TIMESHEET_TITO_NONWORK_HOURS_EXCEEDS_TITO_DURATION",
    TIMESHEETTITODUPLICATE: "TIMESHEET_TITO_DUPLICATE",
    TIMESHEETDAILYTITOEMPTY: "TIMESHEET_DAILY_TITO_EMPTY",
    TIMESHEETOWNERINSUFFICIENTROLES: "TIMESHEET_OWNER_INSUFFICIENT_ROLES",
    TIMESHEETOWNERINVALIDTIMEPERIOD: "TIMESHEET_OWNER_INVALID_TIME_PERIOD",
    TIMESHEETTIMEPERIODNOTFOUND: "TIMESHEET_TIME_PERIOD_NOT_FOUND",
    TIMESHEETDATEOUTOFTIMEPERIODRANGE: "TIMESHEET_DATE_OUT_OF_TIME_PERIOD_RANGE",
    TIMESHEETTIMEPERIODPERMISSIONS: "TIMESHEET_TIME_PERIOD_PERMISSIONS",
    TIMESHEETDATEREQUIREDFORSEMIMONTHLYTIMEPERIODS: "TIMESHEET_DATE_REQUIRED_FOR_SEMIMONTHLY_TIME_PERIODS",
    TIMESHEETDATEINVALIDFORTIMEPERIODTYPE: "TIMESHEET_DATE_INVALID_FOR_TIME_PERIOD_TYPE",
    TIMESHEETTIMEPERIODDATESMUSTBEINSAMEMONTHYEAR: "TIMESHEET_TIME_PERIOD_DATES_MUST_BE_IN_SAME_MONTH_YEAR",
    TIMESHEETDEFAULTPAYCODENOTFOUND: "TIMESHEET_DEFAULT_PAY_CODE_NOT_FOUND",
    TIMESHEETINVALIDSTATUSFORSUBMISSION: "TIMESHEET_INVALID_STATUS_FOR_SUBMISSION",
    TIMESHEETSEARCHACTIVEORSTATUSLISTS: "TIMESHEET_SEARCH_ACTIVE_OR_STATUS_LISTS",
    TIMESHEETTASKREQUIREDFORPROJECTSWITHTASKLEVELASSIGNMENT: "TIMESHEET_TASK_REQUIRED_FOR_PROJECTS_WITH_TASK_LEVEL_ASSIGNMENT",
    JEPOSTED: "JE_POSTED",
    VIPOSTED: "VI_POSTED",
    VIVOIDED: "VI_VOIDED",
    VICANNOTCHANGESTATUS: "VI_CANNOT_CHANGE_STATUS",
    VISTATUSNOTALLOWSUBMIT: "VI_STATUS_NOT_ALLOW_SUBMIT",
    VICANNOTSUBMITTOAPPROVALGROUP: "VI_CANNOT_SUBMIT_TO_APPROVAL_GROUP",
    VICANNOTSUBMITDUETOAPPROVALS: "VI_CANNOT_SUBMIT_DUE_TO_APPROVALS",
    VINOPOASSIGNED: "VI_NO_PO_ASSIGNED",
    VIVENDORNOTVALIDFORLEGALENTITY: "VI_VENDOR_NOT_VALID_FOR_LEGAL_ENTITY",
    VIPOISAMOD: "VI_PO_IS_A_MOD",
    VIPONOTINOPENSTATE: "VI_PO_NOT_IN_OPEN_STATE",
    VIAPORGLEGALENTITYMISMATCH: "VI_AP_ORG_LEGAL_ENTITY_MISMATCH",
    VIPOLEGALENTITYMISMATCH: "VI_PO_LEGAL_ENTITY_MISMATCH",
    VIPOVENDORMISMATCH: "VI_PO_VENDOR_MISMATCH",
    VIORGNOTALLOWTRANSACTIONENTRY: "VI_ORG_NOT_ALLOW_TRANSACTION_ENTRY",
    VIFIELDCHANGENOTALLOWEDWHENTRANSACTIONSEXIST: "VI_FIELD_CHANGE_NOT_ALLOWED_WHEN_TRANSACTIONS_EXIST",
    VINOAPACCOUNTFORLEGALENTITY: "VI_NO_AP_ACCOUNT_FOR_LEGAL_ENTITY",
    VIMUSTHAVEPOASSIGNED: "VI_MUST_HAVE_PO_ASSIGNED",
    VINOAPORGFORLEGALENTITY: "VI_NO_AP_ORG_FOR_LEGAL_ENTITY",
    VIDETAILSPROJECTNOTALLOWCHARGES: "VI_DETAILS_PROJECT_NOT_ALLOW_CHARGES",
    VIDETAILSACCOUNTTXNSDONOTALLOWPROJECTS: "VI_DETAILS_ACCOUNT_TXNS_DO_NOT_ALLOW_PROJECTS",
    VIDETAILSLABORREQPROJECTS: "VI_DETAILS_LABOR_REQ_PROJECTS",
    VIDETAILSACCOUNTTXNSREQUIREPROJECTS: "VI_DETAILS_ACCOUNT_TXNS_REQUIRE_PROJECTS",
    VIDETAILSACCOUNTINVALID: "VI_DETAILS_ACCOUNT_INVALID",
    VIDETAILSPOFIELDSBOTHSETORBLANK: "VI_DETAILS_PO_FIELDS_BOTH_SET_OR_BLANK",
    VIDETAILSPROJECTNOTALLOWLABORCAT: "VI_DETAILS_PROJECT_NOT_ALLOW_LABOR_CAT",
    VIDETAILSLABORCATNOTVALIDFORPROJECT: "VI_DETAILS_LABOR_CAT_NOT_VALID_FOR_PROJECT",
    VIDETAILSPROJECTREQUIRESLABORCAT: "VI_DETAILS_PROJECT_REQUIRES_LABOR_CAT",
    VIDETAILSEXPTYPENOTVALIDFORPROJECT: "VI_DETAILS_EXP_TYPE_NOT_VALID_FOR_PROJECT",
    VIDETAILSITEMNOTVALIDFORPROJECT: "VI_DETAILS_ITEM_NOT_VALID_FOR_PROJECT",
    VIDETAILSACCTNOTVALIDFOREXPTYPE: "VI_DETAILS_ACCT_NOT_VALID_FOR_EXP_TYPE",
    VIDETAILSACCTNOTVALIDFORITEMEXPTYPE: "VI_DETAILS_ACCT_NOT_VALID_FOR_ITEM_EXP_TYPE",
    VIDETAILSITEMINVENTORYNOTALLOWPROJ: "VI_DETAILS_ITEM_INVENTORY_NOT_ALLOW_PROJ",
    VIDETAILSITEMREQUIRESPROJ: "VI_DETAILS_ITEM_REQUIRES_PROJ",
    JEVOIDED: "JE_VOIDED",
    VPPOSTED: "VP_POSTED",
    VPSUBMITTED: "VP_SUBMITTED",
    VPVOIDED: "VP_VOIDED",
    VPINVALIDPAYMENTMETHOD: "VP_INVALID_PAYMENT_METHOD",
    PAIDDOCNOTPOSTED: "PAID_DOC_NOT_POSTED",
    PAIDDOCVOIDED: "PAID_DOC_VOIDED",
    PAIDDOCVOIDING: "PAID_DOC_VOIDING",
    PAIDDOCLEGALENTITYMISMATCH: "PAID_DOC_LEGAL_ENTITY_MISMATCH",
    PAIDDOCVENDORMISMATCH: "PAID_DOC_VENDOR_MISMATCH",
    PAIDDOCOTHERUNPOSTED: "PAID_DOC_OTHER_UNPOSTED",
    PAIDDOCOTHERUNPOSTEDAPP: "PAID_DOC_OTHER_UNPOSTED_APP",
    PAIDDOCZEROBALANCE: "PAID_DOC_ZERO_BALANCE",
    PAIDDOCZEROAMOUNTS: "PAID_DOC_ZERO_AMOUNTS",
    PAIDDOCPAYMENTDISCOUNT: "PAID_DOC_PAYMENT_DISCOUNT",
    PAIDDOCEXCESSDISCOUNT: "PAID_DOC_EXCESS_DISCOUNT",
    PAIDDOCCUSTOMERMISMATCH: "PAID_DOC_CUSTOMER_MISMATCH",
    PAIDDOCPAYMENTWRITEOFF: "PAID_DOC_PAYMENT_WRITEOFF",
    PAIDDOCEXCESSWRITEOFF: "PAID_DOC_EXCESS_WRITEOFF",
    PAIDDOCINVNOTCOMPLETED: "PAID_DOC_INV_NOT_COMPLETED",
    PAIDDOCPOSTEDAFTERPOSTPERIODENDDATE: "PAID_DOC_POSTED_AFTER_POST_PERIOD_END_DATE",
    PAIDDOCPAYMENTEXCEEDSBALANCE: "PAID_DOC_PAYMENT_EXCEEDS_BALANCE"
  };
})(ErrorInstance || (ErrorInstance = {}));
var ExpenseBaseModel;
((ExpenseBaseModel2) => {
  ExpenseBaseModel2.StatusEnum = {
    REQUESTING: "REQUESTING",
    DENIED: "DENIED",
    PREAPPROVING: "PREAPPROVING",
    PREAPPROVED: "PREAPPROVED",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED",
    PENDINGREVIEW: "PENDING_REVIEW",
    REQUESTSUBMITTED: "REQUEST_SUBMITTED"
  };
  ExpenseBaseModel2.VoucherTypeEnum = {
    EXPENSEREPORT: "EXPENSE_REPORT",
    EXPENSEREQUEST: "EXPENSE_REQUEST"
  };
})(ExpenseBaseModel || (ExpenseBaseModel = {}));
var ExpenseCreateModel;
((ExpenseCreateModel2) => {
  ExpenseCreateModel2.VoucherTypeEnum = {
    EXPENSEREPORT: "EXPENSE_REPORT",
    EXPENSEREQUEST: "EXPENSE_REQUEST"
  };
})(ExpenseCreateModel || (ExpenseCreateModel = {}));
var ExpenseInvoiceSectionFormatCreateModel;
((ExpenseInvoiceSectionFormatCreateModel2) => {
  ExpenseInvoiceSectionFormatCreateModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  ExpenseInvoiceSectionFormatCreateModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  ExpenseInvoiceSectionFormatCreateModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  ExpenseInvoiceSectionFormatCreateModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  ExpenseInvoiceSectionFormatCreateModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(ExpenseInvoiceSectionFormatCreateModel || (ExpenseInvoiceSectionFormatCreateModel = {}));
var ExpenseInvoiceSectionFormatModel;
((ExpenseInvoiceSectionFormatModel2) => {
  ExpenseInvoiceSectionFormatModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  ExpenseInvoiceSectionFormatModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  ExpenseInvoiceSectionFormatModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  ExpenseInvoiceSectionFormatModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  ExpenseInvoiceSectionFormatModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(ExpenseInvoiceSectionFormatModel || (ExpenseInvoiceSectionFormatModel = {}));
var ExpenseLineModel;
((ExpenseLineModel2) => {
  ExpenseLineModel2.LineTypeEnum = {
    LABOR: "LABOR",
    EXPENSE: "EXPENSE",
    ITEM: "ITEM"
  };
})(ExpenseLineModel || (ExpenseLineModel = {}));
var ExpenseModel;
((ExpenseModel2) => {
  ExpenseModel2.StatusEnum = {
    REQUESTING: "REQUESTING",
    DENIED: "DENIED",
    PREAPPROVING: "PREAPPROVING",
    PREAPPROVED: "PREAPPROVED",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED",
    PENDINGREVIEW: "PENDING_REVIEW",
    REQUESTSUBMITTED: "REQUEST_SUBMITTED"
  };
  ExpenseModel2.VoucherTypeEnum = {
    EXPENSEREPORT: "EXPENSE_REPORT",
    EXPENSEREQUEST: "EXPENSE_REQUEST"
  };
})(ExpenseModel || (ExpenseModel = {}));
var ExpenseSearchModel;
((ExpenseSearchModel2) => {
  ExpenseSearchModel2.StatusesEnum = {
    REQUESTING: "REQUESTING",
    DENIED: "DENIED",
    PREAPPROVING: "PREAPPROVING",
    PREAPPROVED: "PREAPPROVED",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED",
    PENDINGREVIEW: "PENDING_REVIEW",
    REQUESTSUBMITTED: "REQUEST_SUBMITTED"
  };
  ExpenseSearchModel2.VoucherTypeEnum = {
    EXPENSEREPORT: "EXPENSE_REPORT",
    EXPENSEREQUEST: "EXPENSE_REQUEST"
  };
})(ExpenseSearchModel || (ExpenseSearchModel = {}));
var ExpenseStatusHistoryModel;
((ExpenseStatusHistoryModel2) => {
  ExpenseStatusHistoryModel2.StatusEnum = {
    REQUESTING: "REQUESTING",
    DENIED: "DENIED",
    PREAPPROVING: "PREAPPROVING",
    PREAPPROVED: "PREAPPROVED",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED",
    PENDINGREVIEW: "PENDING_REVIEW",
    REQUESTSUBMITTED: "REQUEST_SUBMITTED"
  };
})(ExpenseStatusHistoryModel || (ExpenseStatusHistoryModel = {}));
var ExpenseTypeModel;
((ExpenseTypeModel2) => {
  ExpenseTypeModel2.WizardTypeEnum = {
    ADVANCE: "ADVANCE",
    AIR: "AIR",
    CASHRETURN: "CASH_RETURN",
    CELLPHONE: "CELL_PHONE",
    COMPANYCAR: "COMPANY_CAR",
    EMPBUSMTG: "EMP_BUS_MTG",
    ENTERTAINMENT: "ENTERTAINMENT",
    LODGING: "LODGING",
    LODGINGALLOWABLE: "LODGING_ALLOWABLE",
    LODGINGPERDIEM: "LODGING_PER_DIEM",
    MIEALLOWABLE: "MIE_ALLOWABLE",
    MIEPERDIEM: "MIE_PER_DIEM",
    MILEAGE: "MILEAGE"
  };
})(ExpenseTypeModel || (ExpenseTypeModel = {}));
var ExpenseTypeSummaryModel;
((ExpenseTypeSummaryModel2) => {
  ExpenseTypeSummaryModel2.WizardTypeEnum = {
    ADVANCE: "ADVANCE",
    AIR: "AIR",
    CASHRETURN: "CASH_RETURN",
    CELLPHONE: "CELL_PHONE",
    COMPANYCAR: "COMPANY_CAR",
    EMPBUSMTG: "EMP_BUS_MTG",
    ENTERTAINMENT: "ENTERTAINMENT",
    LODGING: "LODGING",
    LODGINGALLOWABLE: "LODGING_ALLOWABLE",
    LODGINGPERDIEM: "LODGING_PER_DIEM",
    MIEALLOWABLE: "MIE_ALLOWABLE",
    MIEPERDIEM: "MIE_PER_DIEM",
    MILEAGE: "MILEAGE"
  };
})(ExpenseTypeSummaryModel || (ExpenseTypeSummaryModel = {}));
var FinancialDocumentStatusHistoryModel;
((FinancialDocumentStatusHistoryModel2) => {
  FinancialDocumentStatusHistoryModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED",
    APPROVED: "APPROVED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED"
  };
})(FinancialDocumentStatusHistoryModel || (FinancialDocumentStatusHistoryModel = {}));
var FixedAssetAlertModel;
((FixedAssetAlertModel2) => {
  FixedAssetAlertModel2.FeatureEnum = {
    VENDORINVOICEPOST: "VENDOR_INVOICE_POST",
    VENDORPAYMENTPOST: "VENDOR_PAYMENT_POST",
    CUSTOMERPAYMENTPOST: "CUSTOMER_PAYMENT_POST",
    DEPOSITPOST: "DEPOSIT_POST",
    JOURNALENTRYPOST: "JOURNAL_ENTRY_POST",
    BILLINGPOST: "BILLING_POST",
    INVOICEPOST: "INVOICE_POST",
    LABORCOSTPOST: "LABOR_COST_POST",
    EXPENSECOSTPOST: "EXPENSE_COST_POST",
    GLCLOSING: "GL_CLOSING",
    COSTPOOLPOST: "COST_POOL_POST",
    COMMITMENT: "COMMITMENT",
    FIXEDASSETPOST: "FIXED_ASSET_POST",
    PILOB: "PILOB",
    INTERCOMPANYPOST: "INTERCOMPANY_POST",
    APREVALUATION: "AP_REVALUATION",
    ARREVALUATION: "AR_REVALUATION",
    STATISTICALDOCUMENTPOST: "STATISTICAL_DOCUMENT_POST"
  };
})(FixedAssetAlertModel || (FixedAssetAlertModel = {}));
var FixedAssetCreateModel;
((FixedAssetCreateModel2) => {
  FixedAssetCreateModel2.DisposalTypeEnum = {
    SALE: "SALE",
    WRITEOFF: "WRITE_OFF"
  };
  FixedAssetCreateModel2.DepreciationMethodEnum = {
    STRAIGHTLINE: "STRAIGHT_LINE",
    NONE: "NONE"
  };
  FixedAssetCreateModel2.AveragingMethodEnum = {
    FISCALPERIOD: "FISCAL_PERIOD",
    DAILY: "DAILY"
  };
})(FixedAssetCreateModel || (FixedAssetCreateModel = {}));
var FixedAssetJournalEntryModel;
((FixedAssetJournalEntryModel2) => {
  FixedAssetJournalEntryModel2.CategoryEnum = {
    BILLED: "BILLED",
    DEFERREDREVENUE: "DEFERRED_REVENUE",
    RECOGNIZEDREVENUE: "RECOGNIZED_REVENUE",
    TAX: "TAX",
    UNBILLED: "UNBILLED",
    LABORCOST: "LABOR_COST",
    LABORCOSTOFFSETEMPLOYEES: "LABOR_COST_OFFSET_EMPLOYEES",
    REVENUEWRITEOFF: "REVENUE_WRITE_OFF",
    FUNDINGCAPADJUSTMENTREVENUE: "FUNDING_CAP_ADJUSTMENT_REVENUE",
    ARDISCOUNTTAKEN: "AR_DISCOUNT_TAKEN",
    ARSMALLBALANCEWRITEOFF: "AR_SMALL_BALANCE_WRITE_OFF",
    ARUNAPPLIEDPAYMENTACCOUNT: "AR_UNAPPLIED_PAYMENT_ACCOUNT",
    ACCOUNTSPAYABLE: "ACCOUNTS_PAYABLE",
    APDISCOUNTTAKEN: "AP_DISCOUNT_TAKEN",
    APUNAPPLIEDPAYMENTACCOUNT: "AP_UNAPPLIED_PAYMENT_ACCOUNT",
    EXPENSEREPORTCOST: "EXPENSE_REPORT_COST",
    EXPENSEREPORTOFFSETREIMBURSABLE: "EXPENSE_REPORT_OFFSET_REIMBURSABLE",
    EXPENSEREPORTOFFSETNONREIMBURSABLE: "EXPENSE_REPORT_OFFSET_NON_REIMBURSABLE",
    LABORCOSTOFFSETSUBCONTRACTORS: "LABOR_COST_OFFSET_SUBCONTRACTORS",
    CROSSCHARGELABOR: "CROSS_CHARGE_LABOR",
    CROSSCHARGELABOROFFSET: "CROSS_CHARGE_LABOR_OFFSET",
    FIXEDFEEADJUSTMENTREVENUE: "FIXED_FEE_ADJUSTMENT_REVENUE",
    RETAINEDEARNINGS: "RETAINED_EARNINGS",
    NETINCOME: "NET_INCOME",
    INVALIDLEGALENTITYBILLINGPOST: "INVALID_LEGAL_ENTITY_BILLING_POST",
    INVALIDLEGALENTITYINVOICECOMPLETION: "INVALID_LEGAL_ENTITY_INVOICE_COMPLETION",
    INVALIDLEGALENTITYLABORCOSTPOST: "INVALID_LEGAL_ENTITY_LABOR_COST_POST",
    INVALIDLEGALENTITYEXPENSECOSTPOST: "INVALID_LEGAL_ENTITY_EXPENSE_COST_POST",
    VIFUNDINGCAPADJUSTMENT: "VI_FUNDING_CAP_ADJUSTMENT",
    INVENTORYASSETACCOUNT: "INVENTORY_ASSET_ACCOUNT",
    INVENTORYSHRINKAGEACCOUNT: "INVENTORY_SHRINKAGE_ACCOUNT",
    INVENTORYPAYABLEACCOUNT: "INVENTORY_PAYABLE_ACCOUNT",
    FIXEDASSET: "FIXED_ASSET",
    FIXEDASSETDEPRECIATIONEXPENSE: "FIXED_ASSET_DEPRECIATION_EXPENSE",
    FIXEDASSETACCUMULATEDDEPRECIATION: "FIXED_ASSET_ACCUMULATED_DEPRECIATION",
    FIXEDASSETDISPOSAL: "FIXED_ASSET_DISPOSAL",
    PILOB: "PILOB",
    FIXEDASSETCASHPROCEEDS: "FIXED_ASSET_CASH_PROCEEDS",
    PILOBCOSTOFFSET: "PILOB_COST_OFFSET",
    DUETO: "DUE_TO",
    DUEFROM: "DUE_FROM",
    INTERCOMPANYREVENUE: "INTERCOMPANY_REVENUE",
    INTERCOMPANYLABORCOST: "INTERCOMPANY_LABOR_COST",
    INTERCOMPANYEXPENSEREPORTCOST: "INTERCOMPANY_EXPENSE_REPORT_COST",
    INTERCOMPANYCOSTALLOCATIONDUEFROMDUETO: "INTERCOMPANY_COST_ALLOCATION_DUE_FROM_DUE_TO",
    UNREALIZEDFOREIGNEXCHANGEGAIN: "UNREALIZED_FOREIGN_EXCHANGE_GAIN",
    UNREALIZEDFOREIGNEXCHANGELOSS: "UNREALIZED_FOREIGN_EXCHANGE_LOSS",
    REALIZEDFOREIGNEXCHANGEGAIN: "REALIZED_FOREIGN_EXCHANGE_GAIN",
    REALIZEDFOREIGNEXCHANGELOSS: "REALIZED_FOREIGN_EXCHANGE_LOSS",
    APREVALUATIONOFFSET: "AP_REVALUATION_OFFSET",
    ARREVALUATIONOFFSET: "AR_REVALUATION_OFFSET",
    TIMESHEETITEMCOST: "TIMESHEET_ITEM_COST",
    TIMESHEETITEMCOSTOFFSET: "TIMESHEET_ITEM_COST_OFFSET"
  };
})(FixedAssetJournalEntryModel || (FixedAssetJournalEntryModel = {}));
var FixedAssetModel;
((FixedAssetModel2) => {
  FixedAssetModel2.DisposalTypeEnum = {
    SALE: "SALE",
    WRITEOFF: "WRITE_OFF"
  };
  FixedAssetModel2.DepreciationMethodEnum = {
    STRAIGHTLINE: "STRAIGHT_LINE",
    NONE: "NONE"
  };
  FixedAssetModel2.AveragingMethodEnum = {
    FISCALPERIOD: "FISCAL_PERIOD",
    DAILY: "DAILY"
  };
})(FixedAssetModel || (FixedAssetModel = {}));
var FixedAssetPostDocumentModel;
((FixedAssetPostDocumentModel2) => {
  FixedAssetPostDocumentModel2.GeneralLedgerExpensePostLevelEnum = {
    DETAIL: "DETAIL",
    SUMMARY: "SUMMARY"
  };
  FixedAssetPostDocumentModel2.GeneralLedgerDepreciationPostLevelEnum = {
    DETAIL: "DETAIL",
    SUMMARY: "SUMMARY"
  };
})(FixedAssetPostDocumentModel || (FixedAssetPostDocumentModel = {}));
var FixedAssetSearchReadModel;
((FixedAssetSearchReadModel2) => {
  FixedAssetSearchReadModel2.DashboardsEnum = {
    HOME: "HOME",
    ORGANIZATIONS: "ORGANIZATIONS",
    CONTRACTS: "CONTRACTS",
    CONTRACT: "CONTRACT",
    PROJECT: "PROJECT",
    PEOPLE: "PEOPLE",
    TIME: "TIME",
    EXPENSE: "EXPENSE",
    FORECAST: "FORECAST",
    FINANCIALS: "FINANCIALS",
    PURCHASING: "PURCHASING",
    ACCOUNTSPAYABLE: "ACCOUNTS_PAYABLE",
    ACCOUNTSRECEIVABLE: "ACCOUNTS_RECEIVABLE",
    BILLING: "BILLING",
    GENERALLEDGER: "GENERAL_LEDGER",
    DOCUMENTS: "DOCUMENTS",
    ADMIN: "ADMIN",
    REPORTS: "REPORTS"
  };
})(FixedAssetSearchReadModel || (FixedAssetSearchReadModel = {}));
var FixedPriceInvoiceSectionFormatCreateModel;
((FixedPriceInvoiceSectionFormatCreateModel2) => {
  FixedPriceInvoiceSectionFormatCreateModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  FixedPriceInvoiceSectionFormatCreateModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  FixedPriceInvoiceSectionFormatCreateModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  FixedPriceInvoiceSectionFormatCreateModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  FixedPriceInvoiceSectionFormatCreateModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(FixedPriceInvoiceSectionFormatCreateModel || (FixedPriceInvoiceSectionFormatCreateModel = {}));
var FixedPriceInvoiceSectionFormatModel;
((FixedPriceInvoiceSectionFormatModel2) => {
  FixedPriceInvoiceSectionFormatModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  FixedPriceInvoiceSectionFormatModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  FixedPriceInvoiceSectionFormatModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  FixedPriceInvoiceSectionFormatModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  FixedPriceInvoiceSectionFormatModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(FixedPriceInvoiceSectionFormatModel || (FixedPriceInvoiceSectionFormatModel = {}));
var FixedPriceItemCreateModel;
((FixedPriceItemCreateModel2) => {
  FixedPriceItemCreateModel2.RevenueRecognitionMethodEnum = {
    ONBILL: "ON_BILL",
    PERCENTCOMPLETE: "PERCENT_COMPLETE",
    ONSCHEDULE: "ON_SCHEDULE"
  };
})(FixedPriceItemCreateModel || (FixedPriceItemCreateModel = {}));
var FixedPriceItemModel;
((FixedPriceItemModel2) => {
  FixedPriceItemModel2.RevenueRecognitionMethodEnum = {
    ONBILL: "ON_BILL",
    PERCENTCOMPLETE: "PERCENT_COMPLETE",
    ONSCHEDULE: "ON_SCHEDULE"
  };
})(FixedPriceItemModel || (FixedPriceItemModel = {}));
var ForecastRequestModel;
((ForecastRequestModel2) => {
  ForecastRequestModel2.HistoricalPeriodTypeEnum = {
    MONTH: "MONTH",
    QUARTER: "QUARTER",
    YEAR: "YEAR"
  };
  ForecastRequestModel2.ForecastPeriodTypeEnum = {
    MONTH: "MONTH",
    QUARTER: "QUARTER",
    YEAR: "YEAR"
  };
})(ForecastRequestModel || (ForecastRequestModel = {}));
var FundedValueAdjustmentInvoiceSectionFormatCreateModel;
((FundedValueAdjustmentInvoiceSectionFormatCreateModel2) => {
  FundedValueAdjustmentInvoiceSectionFormatCreateModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  FundedValueAdjustmentInvoiceSectionFormatCreateModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  FundedValueAdjustmentInvoiceSectionFormatCreateModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  FundedValueAdjustmentInvoiceSectionFormatCreateModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  FundedValueAdjustmentInvoiceSectionFormatCreateModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(FundedValueAdjustmentInvoiceSectionFormatCreateModel || (FundedValueAdjustmentInvoiceSectionFormatCreateModel = {}));
var FundedValueAdjustmentInvoiceSectionFormatModel;
((FundedValueAdjustmentInvoiceSectionFormatModel2) => {
  FundedValueAdjustmentInvoiceSectionFormatModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  FundedValueAdjustmentInvoiceSectionFormatModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  FundedValueAdjustmentInvoiceSectionFormatModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  FundedValueAdjustmentInvoiceSectionFormatModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  FundedValueAdjustmentInvoiceSectionFormatModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(FundedValueAdjustmentInvoiceSectionFormatModel || (FundedValueAdjustmentInvoiceSectionFormatModel = {}));
var ImportDefinitionColumnModel;
((ImportDefinitionColumnModel2) => {
  ImportDefinitionColumnModel2.TypeEnum = {
    CHAR: "CHAR",
    STRING: "STRING",
    DATE: "DATE",
    TIMESTAMP: "TIMESTAMP",
    NUMBER: "NUMBER",
    CURRENCY: "CURRENCY",
    RATE: "RATE",
    EXCHANGERATE: "EXCHANGE_RATE"
  };
})(ImportDefinitionColumnModel || (ImportDefinitionColumnModel = {}));
var ImportErrorModel;
((ImportErrorModel2) => {
  ImportErrorModel2.ErrorCodeEnum = {
    VALIDATIONGENERIC: "VALIDATION_GENERIC",
    VALIDATIONINVALIDPARAM: "VALIDATION_INVALID_PARAM",
    VALIDATIONINVALIDFIELD: "VALIDATION_INVALID_FIELD",
    VALIDATIONBELOWMIN: "VALIDATION_BELOW_MIN",
    VALIDATIONEXCEEDSMAX: "VALIDATION_EXCEEDS_MAX",
    VALIDATIONDECIMALOUTOFBOUNDS: "VALIDATION_DECIMAL_OUT_OF_BOUNDS",
    VALIDATIONEMAILBADFORMAT: "VALIDATION_EMAIL_BAD_FORMAT",
    VALIDATIONMUSTNOTBEBLANK: "VALIDATION_MUST_NOT_BE_BLANK",
    VALIDATIONMUSTNOTBENULL: "VALIDATION_MUST_NOT_BE_NULL",
    VALIDATIONMUSTBENULLORNOTBLANK: "VALIDATION_MUST_BE_NULL_OR_NOT_BLANK",
    VALIDATIONMUSTNOTBEEMPTY: "VALIDATION_MUST_NOT_BE_EMPTY",
    VALIDATIONMUSTCONTAINNOWHITESPACE: "VALIDATION_MUST_CONTAIN_NO_WHITESPACE",
    VALIDATIONMUSTBENULL: "VALIDATION_MUST_BE_NULL",
    VALIDATIONPATTERNMISMATCH: "VALIDATION_PATTERN_MISMATCH",
    VALIDATIONMUSTBEGREATERTHANZERO: "VALIDATION_MUST_BE_GREATER_THAN_ZERO",
    VALIDATIONMUSTBEGREATERTHANEQUALZERO: "VALIDATION_MUST_BE_GREATER_THAN_EQUAL_ZERO",
    VALIDATIONMUSTNOTBEZERO: "VALIDATION_MUST_NOT_BE_ZERO",
    VALIDATIONINVALIDSIZE: "VALIDATION_INVALID_SIZE",
    VALIDATIONDATEOUTOFRANGE: "VALIDATION_DATE_OUT_OF_RANGE",
    VALIDATIONTIMEOUTOFRANGE: "VALIDATION_TIME_OUT_OF_RANGE",
    VALIDATIONTIMEFIELDSOUTOFORDER: "VALIDATION_TIME_FIELDS_OUT_OF_ORDER",
    VALIDATIONDATEFIELDSOUTOFORDER: "VALIDATION_DATE_FIELDS_OUT_OF_ORDER",
    VALIDATIONRESOURCEALREADYEXISTS: "VALIDATION_RESOURCE_ALREADY_EXISTS",
    VALIDATIONFIELDALREADYEXISTS: "VALIDATION_FIELD_ALREADY_EXISTS",
    VALIDATIONREQUIREDFIELD: "VALIDATION_REQUIRED_FIELD",
    VALIDATIONORGNOTLEGALENTITY: "VALIDATION_ORG_NOT_LEGAL_ENTITY",
    VALIDATIONORGNOTFINANCIALORG: "VALIDATION_ORG_NOT_FINANCIAL_ORG",
    VALIDATIONNOTBELONGTOLEGALENTITY: "VALIDATION_NOT_BELONG_TO_LEGAL_ENTITY",
    VALIDATIONINVALIDACCESS: "VALIDATION_INVALID_ACCESS",
    VALIDATIONREFERENCENOTFOUND: "VALIDATION_REFERENCE_NOT_FOUND",
    VALIDATIONREFERENCEEMPTY: "VALIDATION_REFERENCE_EMPTY",
    VALIDATIONREFERENCEMISMATCH: "VALIDATION_REFERENCE_MISMATCH",
    VALIDATIONASSOCIATIONEXISTS: "VALIDATION_ASSOCIATION_EXISTS",
    VALIDATIONINCONSISTENTFIELDS: "VALIDATION_INCONSISTENT_FIELDS",
    VALIDATIONUNEXPECTEDVALUE: "VALIDATION_UNEXPECTED_VALUE",
    VALIDATIONATLEASTONEMUSTBETRUE: "VALIDATION_AT_LEAST_ONE_MUST_BE_TRUE",
    VALIDATIONONLYONEOFCANBESET: "VALIDATION_ONLY_ONE_OF_CAN_BE_SET",
    VALIDATIONREQUIREDWHENTRUE: "VALIDATION_REQUIRED_WHEN_TRUE",
    VALIDATIONREQUIREDWHENFALSE: "VALIDATION_REQUIRED_WHEN_FALSE",
    VALIDATIONONLYVALIDWHENTRUE: "VALIDATION_ONLY_VALID_WHEN_TRUE",
    VALIDATIONONLYVALIDWHENFALSE: "VALIDATION_ONLY_VALID_WHEN_FALSE",
    VALIDATIONNOTACTIVE: "VALIDATION_NOT_ACTIVE",
    VALIDATIONUNSUPPORTEDFIELD: "VALIDATION_UNSUPPORTED_FIELD",
    VALIDATIONUNSUPPORTEDVALUE: "VALIDATION_UNSUPPORTED_VALUE",
    VALIDATIONCANNOTBESAME: "VALIDATION_CANNOT_BE_SAME",
    VALIDATIONONEOFREQUIRED: "VALIDATION_ONE_OF_REQUIRED",
    VALIDATIONFEATURENOTENABLED: "VALIDATION_FEATURE_NOT_ENABLED",
    VALIDATIONNOTHINGTOUPDATE: "VALIDATION_NOTHING_TO_UPDATE",
    VALIDATIONUPDATECANNOTMODIFYFIELD: "VALIDATION_UPDATE_CANNOT_MODIFY_FIELD",
    VALIDATIONUPDATECANNOTMODIFYRESOURCE: "VALIDATION_UPDATE_CANNOT_MODIFY_RESOURCE",
    VALIDATIONINSUFFICIENTLICENSE: "VALIDATION_INSUFFICIENT_LICENSE",
    VALIDATIONINSUFFICIENTCONFIG: "VALIDATION_INSUFFICIENT_CONFIG",
    VALIDATIONINSUFFICENTPERMISSIONS: "VALIDATION_INSUFFICENT_PERMISSIONS",
    VALIDATIONDUPLICATES: "VALIDATION_DUPLICATES",
    VALIDATIONDELETENOTALLOWED: "VALIDATION_DELETE_NOT_ALLOWED",
    VALIDATIONUNABLETODELETEDUETOEXISTINGDEPENDENCIES: "VALIDATION_UNABLE_TO_DELETE_DUE_TO_EXISTING_DEPENDENCIES",
    VALIDATIONFISCALMONTHNOTFOUND: "VALIDATION_FISCAL_MONTH_NOT_FOUND",
    VALIDATIONBYTELENGTHMISMATCH: "VALIDATION_BYTE_LENGTH_MISMATCH",
    VALIDATIONUDFINPUT: "VALIDATION_UDF_INPUT",
    VALIDATIONINVALIDSTATUS: "VALIDATION_INVALID_STATUS",
    VALIDATIONCONFLICTINGSEARCHPARAMETERS: "VALIDATION_CONFLICTING_SEARCH_PARAMETERS",
    VALIDATIONINVALIDVERIFICATIONCODE: "VALIDATION_INVALID_VERIFICATION_CODE",
    VALIDATIONINVALIDMONETARYAMOUNT: "VALIDATION_INVALID_MONETARY_AMOUNT",
    VALIDATIONDATENOTINOPENFISCALPERIOD: "VALIDATION_DATE_NOT_IN_OPEN_FISCAL_PERIOD",
    VALIDATIONINVALIDORGANIZATION: "VALIDATION_INVALID_ORGANIZATION",
    INVALIDCONFIGURATION: "INVALID_CONFIGURATION",
    CONSTRAINTVIOLATION: "CONSTRAINT_VIOLATION",
    PAYLOADTOOLARGE: "PAYLOAD_TOO_LARGE",
    JSONPARSINGERROR: "JSON_PARSING_ERROR",
    JSONMAPPINGERROR: "JSON_MAPPING_ERROR",
    LOGINACCOUNTLOCKED: "LOGIN_ACCOUNT_LOCKED",
    LOGININVALIDCREDENTIALS: "LOGIN_INVALID_CREDENTIALS",
    LOGINEXPIREDCREDENTIALS: "LOGIN_EXPIRED_CREDENTIALS",
    NOTDELETABLE: "NOT_DELETABLE",
    REQUESTBODYNOTREADABLE: "REQUEST_BODY_NOT_READABLE",
    UNAUTHORIZED: "UNAUTHORIZED",
    JWTINVALIDTOKENSIGNATURE: "JWT_INVALID_TOKEN_SIGNATURE",
    JWTEXPIREDTOKEN: "JWT_EXPIRED_TOKEN",
    JWTINVALIDCLAIM: "JWT_INVALID_CLAIM",
    JWTMISSINGTOKEN: "JWT_MISSING_TOKEN",
    JWTREVOKEDTOKEN: "JWT_REVOKED_TOKEN",
    JWTBADLYFORMATTEDTOKEN: "JWT_BADLY_FORMATTED_TOKEN",
    FORBIDDEN: "FORBIDDEN",
    FORBIDDENINSUFFICIENTLICENSE: "FORBIDDEN_INSUFFICIENT_LICENSE",
    FORBIDDENINSUFFICIENTCONFIGURATION: "FORBIDDEN_INSUFFICIENT_CONFIGURATION",
    FORBIDDENINSUFFICIENTROLE: "FORBIDDEN_INSUFFICIENT_ROLE",
    FORBIDDENNOTOWNER: "FORBIDDEN_NOT_OWNER",
    FORBIDDENNOTMANAGER: "FORBIDDEN_NOT_MANAGER",
    FORBIDDENNOTPROJECTMANAGER: "FORBIDDEN_NOT_PROJECT_MANAGER",
    FORBIDDENCANNOTASSIGNTOPROJECT: "FORBIDDEN_CANNOT_ASSIGN_TO_PROJECT",
    FORBIDDENNOTHRADMIN: "FORBIDDEN_NOT_HR_ADMIN",
    NOTHINGTOEXTRACT: "NOTHING_TO_EXTRACT",
    NOTFOUND: "NOT_FOUND",
    DUPLICATE: "DUPLICATE",
    CONFLICT: "CONFLICT",
    UNSUPPORTEDMEDIATYPE: "UNSUPPORTED_MEDIA_TYPE",
    TOOMANYREQUESTS: "TOO_MANY_REQUESTS",
    INTERNALGENERIC: "INTERNAL_GENERIC",
    EXTERNALGENERIC: "EXTERNAL_GENERIC",
    EXTERNALUNAUTHORIZED: "EXTERNAL_UNAUTHORIZED",
    EXTERNALFORBIDDEN: "EXTERNAL_FORBIDDEN",
    EXTERNALNOTFOUND: "EXTERNAL_NOT_FOUND",
    INTERNALINSERT: "INTERNAL_INSERT",
    INTERNALUPDATE: "INTERNAL_UPDATE",
    INTERNALDELETE: "INTERNAL_DELETE",
    UNAVAILABLE: "UNAVAILABLE",
    AGSELFAPPROVALDISABLED: "AG_SELF_APPROVAL_DISABLED",
    AGAPPROVALREQUIRED: "AG_APPROVAL_REQUIRED",
    AGINVALIDAPPROVALGROUPTYPE: "AG_INVALID_APPROVAL_GROUP_TYPE",
    AGEXPAPPROVALUNAVAILABLE: "AG_EXP_APPROVAL_UNAVAILABLE",
    AGEXPAPPROVALFORBIDDEN: "AG_EXP_APPROVAL_FORBIDDEN",
    AGTIMEAPPROVALUNAVAILABLE: "AG_TIME_APPROVAL_UNAVAILABLE",
    AGTIMEAPPROVALFORBIDDEN: "AG_TIME_APPROVAL_FORBIDDEN",
    AGTYPEMISMATCH: "AG_TYPE_MISMATCH",
    AGSUBMITTERNOTREMOVABLE: "AG_SUBMITTER_NOT_REMOVABLE",
    AGSUBMITTINGPROJECTNOTSETUPFORINVOICING: "AG_SUBMITTING_PROJECT_NOT_SETUP_FOR_INVOICING",
    AGINVOICEAPPROVALUNAVAILABLE: "AG_INVOICE_APPROVAL_UNAVAILABLE",
    AGINVOICEAPPROVALFORBIDDEN: "AG_INVOICE_APPROVAL_FORBIDDEN",
    AGPOAPPROVALFORBIDDEN: "AG_PO_APPROVAL_FORBIDDEN",
    AGPOAPPROVALUNAVAILABLE: "AG_PO_APPROVAL_UNAVAILABLE",
    ALTERNATECANNOTASSIGNSAMEUSER: "ALTERNATE_CANNOT_ASSIGN_SAME_USER",
    ALTERNATERESTRICTEDTOEMPLOYEES: "ALTERNATE_RESTRICTED_TO_EMPLOYEES",
    ALTERNATERESTRICTEDTOMANAGERS: "ALTERNATE_RESTRICTED_TO_MANAGERS",
    ALTERNATERESTRICTEDTOROLE: "ALTERNATE_RESTRICTED_TO_ROLE",
    BANKRECONCILIATIONNOTFOUND: "BANK_RECONCILIATION_NOT_FOUND",
    BANKRECONCILIATIONATTACHMENTNOTASSOCIATEDWITHBANKRECONCILIATION: "BANK_RECONCILIATION_ATTACHMENT_NOT_ASSOCIATED_WITH_BANK_RECONCILIATION",
    BANKRECONCILIATIONINVALIDGLKEYS: "BANK_RECONCILIATION_INVALID_GL_KEYS",
    BANKFEEDEXCLUSIONREASONREQUIRED: "BANK_FEED_EXCLUSION_REASON_REQUIRED",
    BANKFEEDWORKFLOWRULENOTFOUND: "BANK_FEED_WORKFLOW_RULE_NOT_FOUND",
    BANKFEEDWORKFLOWRULEVALUENOTFOUND: "BANK_FEED_WORKFLOW_RULE_VALUE_NOT_FOUND",
    CONTRACTWAGEDETERMINATIONSTARTDATEBEFORECONTRACTSTARTDATE: "CONTRACT_WAGE_DETERMINATION_START_DATE_BEFORE_CONTRACT_START_DATE",
    CONTRACTWAGEDETERMINATIONENDDATEAFTERCONTRACTENDDATE: "CONTRACT_WAGE_DETERMINATION_END_DATE_AFTER_CONTRACT_END_DATE",
    CONTRACTSTARTDATEBEFOREPREVIOUSSTARTDATE: "CONTRACT_START_DATE_BEFORE_PREVIOUS_START_DATE",
    CONTRACTENDDATEAFTERNEXTSTARTDATE: "CONTRACT_END_DATE_AFTER_NEXT_START_DATE",
    CONTRACTCOVERAGEMUSTBECONTINUOUS: "CONTRACT_COVERAGE_MUST_BE_CONTINUOUS",
    CONTRACTSCARATEREQUIRED: "CONTRACT_SCA_RATE_REQUIRED",
    CONTRACTPRIMECONTRACTKEYNOTALLOWED: "CONTRACT_PRIME_CONTRACT_KEY_NOT_ALLOWED",
    CUSTOMERPAYMENTISAPPLIED: "CUSTOMER_PAYMENT_IS_APPLIED",
    CPPOSTED: "CP_POSTED",
    CPSUBMITTED: "CP_SUBMITTED",
    DEPOSITPOSTED: "DEPOSIT_POSTED",
    DEPOSITSUBMITTED: "DEPOSIT_SUBMITTED",
    DEPOSITEDDOCAPPLIED: "DEPOSITED_DOC_APPLIED",
    DEPOSITEDDOCNOTPOSTED: "DEPOSITED_DOC_NOT_POSTED",
    DEPOSITEDDOCVOIDED: "DEPOSITED_DOC_VOIDED",
    DEPOSITEDDOCVOIDING: "DEPOSITED_DOC_VOIDING",
    DEPOSITEDDOCLEGALENTITYMISMATCH: "DEPOSITED_DOC_LEGAL_ENTITY_MISMATCH",
    DEPOSITEDDOCALREADYINCLUDED: "DEPOSITED_DOC_ALREADY_INCLUDED",
    DEPOSITEDDOCZEROAMOUNT: "DEPOSITED_DOC_ZERO_AMOUNT",
    DEPOSITEDDOCINVALIDBANKACCOUNTTYPE: "DEPOSITED_DOC_INVALID_BANK_ACCOUNT_TYPE",
    EXCHANGERATETYPECANNOTREMOVEDEFAULTSTATUS: "EXCHANGE_RATE_TYPE_CANNOT_REMOVE_DEFAULT_STATUS",
    EXCHANGERATETYPECANNOTDELETEDEFAULT: "EXCHANGE_RATE_TYPE_CANNOT_DELETE_DEFAULT",
    EXCHANGERATETYPECANNOTDELETEINUSE: "EXCHANGE_RATE_TYPE_CANNOT_DELETE_IN_USE",
    EXCHANGERATESAMEFROMTOCURRENCY: "EXCHANGE_RATE_SAME_FROM_TO_CURRENCY",
    EXCHANGERATENOTFOUND: "EXCHANGE_RATE_NOT_FOUND",
    EXPENSESUMMARYREQUIREDWHENWITHWIZARD: "EXPENSE_SUMMARY_REQUIRED_WHEN_WITH_WIZARD",
    EXPENSEATTACHMENTNOTASSOCIATEDWITHEXPENSE: "EXPENSE_ATTACHMENT_NOT_ASSOCIATED_WITH_EXPENSE",
    EXPENSEPROJECTALLOCATIONPROJECTKEYMUSTNOTBENULL: "EXPENSE_PROJECT_ALLOCATION_PROJECT_KEY_MUST_NOT_BE_NULL",
    EXPENSEPROJECTALLOCATIONPROJECTNOTFOUND: "EXPENSE_PROJECT_ALLOCATION_PROJECT_NOT_FOUND",
    EXPENSEPROJECTALLOCATIONTASKINVALID: "EXPENSE_PROJECT_ALLOCATION_TASK_INVALID",
    EXPENSEPROJECTALLOCATIONTASKNOTFOUND: "EXPENSE_PROJECT_ALLOCATION_TASK_NOT_FOUND",
    EXPENSEPROJECTALLOCATIONPERCENTAGEMUSTNOTBENULL: "EXPENSE_PROJECT_ALLOCATION_PERCENTAGE_MUST_NOT_BE_NULL",
    EXPENSE_PROJECT_ALLOCATION_PERCENTAGES_MUST_TOTAL_100: "EXPENSE_PROJECT_ALLOCATION_PERCENTAGES_MUST_TOTAL_100",
    EXPENSEPROJECTALLOCATIONDUPLICATIONS: "EXPENSE_PROJECT_ALLOCATION_DUPLICATIONS",
    EXPENSEREPORTMULTIENTITYNOTENABLED: "EXPENSE_REPORT_MULTI_ENTITY_NOT_ENABLED",
    EXPENSEREPORTMULTIENTITYNOASSIGNMENT: "EXPENSE_REPORT_MULTI_ENTITY_NO_ASSIGNMENT",
    EXPENSEDETAILAMOUNTMISMATCH: "EXPENSE_DETAIL_AMOUNT_MISMATCH",
    EXPENSEDETAILEXCHANGERATEMUSTBEONE: "EXPENSE_DETAIL_EXCHANGE_RATE_MUST_BE_ONE",
    FADISPOSALFIELDSREQUIRED: "FA_DISPOSAL_FIELDS_REQUIRED",
    FADISPOSALBEFOREDEPRECIATIONSTART: "FA_DISPOSAL_BEFORE_DEPRECIATION_START",
    FADISPOSALBEFOREFISCALPERIODBEGIN: "FA_DISPOSAL_BEFORE_FISCAL_PERIOD_BEGIN",
    FADISPOSALBEFOREFISCALPERIODEND: "FA_DISPOSAL_BEFORE_FISCAL_PERIOD_END",
    FADISPOSALEQUALSFISCALPERIODEND: "FA_DISPOSAL_EQUALS_FISCAL_PERIOD_END",
    FAJOURNALENTRYNOTFOUND: "FA_JOURNAL_ENTRY_NOT_FOUND",
    FAHASPOSTEDDISPOSAL: "FA_HAS_POSTED_DISPOSAL",
    FAHASPOSTEDTRANSACTIONS: "FA_HAS_POSTED_TRANSACTIONS",
    FANOLONGERPOSTABLE: "FA_NO_LONGER_POSTABLE",
    FATRANSACTIONENTRYNOTALLOWEDFORACCOUNT: "FA_TRANSACTION_ENTRY_NOT_ALLOWED_FOR_ACCOUNT",
    FAPROJECTREQUIREDFORACCOUNT: "FA_PROJECT_REQUIRED_FOR_ACCOUNT",
    FALOCATIONCONFLICT: "FA_LOCATION_CONFLICT",
    FAPNOORGFORFIXEDASSET: "FAP_NO_ORG_FOR_FIXED_ASSET",
    FAPFISCALPERIODCLOSED: "FAP_FISCAL_PERIOD_CLOSED",
    FAPINCLUDEDINBANKRECONCILIATION: "FAP_INCLUDED_IN_BANK_RECONCILIATION",
    FAPNOTLATESTPOSTFORLEGALENTITY: "FAP_NOT_LATEST_POST_FOR_LEGAL_ENTITY",
    FAPSTATUSREQUIREDWHENDISPOSEDASSETSINCLUDED: "FAP_STATUS_REQUIRED_WHEN_DISPOSED_ASSETS_INCLUDED",
    FPIEITHERBILLDATEORBILLONCOMPLETIONREQUIRED: "FPI_EITHER_BILL_DATE_OR_BILL_ON_COMPLETION_REQUIRED",
    FPIBILLANDBILLONCOMPLETIONSET: "FPI_BILL_AND_BILL_ON_COMPLETION_SET",
    FPIINVALIDREVRECOGNITIONMETHODFORSCHEDULE: "FPI_INVALID_REV_RECOGNITION_METHOD_FOR_SCHEDULE",
    FPIITEMPOSTEDFORBILLING: "FPI_ITEM_POSTED_FOR_BILLING",
    FPIITEMONCOMPLETEDINVOICE: "FPI_ITEM_ON_COMPLETED_INVOICE",
    IMPORTEDEXPENSEEXPENSETYPEINVALID: "IMPORTED_EXPENSE_EXPENSE_TYPE_INVALID",
    IMPORTEDEXPENSENOTAVAILABLE: "IMPORTED_EXPENSE_NOT_AVAILABLE",
    INTEGRATIONUSEREXISTS: "INTEGRATION_USER_EXISTS",
    INVENTORYTASKPROJECTMISMATCH: "INVENTORY_TASK_PROJECT_MISMATCH",
    INVENTORYCANNOTASSOCIATEITEMWITHTASKNOTSUPPORTINGITEMS: "INVENTORY_CANNOT_ASSOCIATE_ITEM_WITH_TASK_NOT_SUPPORTING_ITEMS",
    INVENTORYCANNOTASSOCIATEITEMWITHPROJECTNOTSUPPORTINGITEMS: "INVENTORY_CANNOT_ASSOCIATE_ITEM_WITH_PROJECT_NOT_SUPPORTING_ITEMS",
    INVENTORYTASKCONTAINSPROJECTNOTASSOCIATEDWITHITEM: "INVENTORY_TASK_CONTAINS_PROJECT_NOT_ASSOCIATED_WITH_ITEM",
    INVOICEPDFNOTFOUND: "INVOICE_PDF_NOT_FOUND",
    INVOICEPDFEXCEEDSMAXSIZE: "INVOICE_PDF_EXCEEDS_MAX_SIZE",
    INVOICEPROJECTNOTBELONGTOOWNINGORG: "INVOICE_PROJECT_NOT_BELONG_TO_OWNING_ORG",
    INVOICEPROJECTOWNINGORGNOTFOUND: "INVOICE_PROJECT_OWNING_ORG_NOT_FOUND",
    INVOICEPROJECTOWNINGORGLEGALENTITYNOTFOUND: "INVOICE_PROJECT_OWNING_ORG_LEGAL_ENTITY_NOT_FOUND",
    INVOICEPROJECTOWNINGORGLEGALENTITYHASNOPOSTINGORG: "INVOICE_PROJECT_OWNING_ORG_LEGAL_ENTITY_HAS_NO_POSTING_ORG",
    INVOICEPROJECTCUSTOMERORGNOTVALIDFORLEGALENTITY: "INVOICE_PROJECT_CUSTOMER_ORG_NOT_VALID_FOR_LEGAL_ENTITY",
    INVOICEPROJECTCUSTOMERORGHASNOBANKACCOUNT: "INVOICE_PROJECT_CUSTOMER_ORG_HAS_NO_BANK_ACCOUNT",
    INVOICEPROJECTCUSTOMERORGHASNOFEEACCOUNT: "INVOICE_PROJECT_CUSTOMER_ORG_HAS_NO_FEE_ACCOUNT",
    INVOICEAUTOPAYMENTMETHODNOTFOUND: "INVOICE_AUTO_PAYMENT_METHOD_NOT_FOUND",
    INVOICEPAYOUTNOTMATCHDETAILSUM: "INVOICE_PAYOUT_NOT_MATCH_DETAIL_SUM",
    INVOICEMORETHANONEPAYMENTFOUND: "INVOICE_MORE_THAN_ONE_PAYMENT_FOUND",
    INVOICESINGLEPAYOUTFORMULTIPLELEGALENTITIES: "INVOICE_SINGLE_PAYOUT_FOR_MULTIPLE_LEGAL_ENTITIES",
    INVOICEBANKACCOUNTNOTFOUND: "INVOICE_BANK_ACCOUNT_NOT_FOUND",
    INVOICEMULTIPLEBANKACCOUNTSFOUND: "INVOICE_MULTIPLE_BANK_ACCOUNTS_FOUND",
    INVOICESTATUSNOTALLOWSUBMIT: "INVOICE_STATUS_NOT_ALLOW_SUBMIT",
    INVOICECANNOTSUBMITDUETOAPPROVALS: "INVOICE_CANNOT_SUBMIT_DUE_TO_APPROVALS",
    INVOICESTATUSNOTALLOWCOMPLETE: "INVOICE_STATUS_NOT_ALLOW_COMPLETE",
    INVOICECANNOTPOSTCOMPLETION: "INVOICE_CANNOT_POST_COMPLETION",
    INVOICEFUNDINGALLOCATION: "INVOICE_FUNDING_ALLOCATION",
    INVOICEFORMATOPTIONSSECTIONVALIDATEWORKDATE: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_WORK_DATE",
    INVOICEFORMATOPTIONSSECTIONVALIDATECOMMENTS: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_COMMENTS",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWDATE: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_DATE",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWCOMMENTS: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_COMMENTS",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWCOST: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_COST",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWMARKUPPCT: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_MARKUP_PCT",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWMARKUPMULT: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_MARKUP_MULT",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWMARKUP: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_MARKUP",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWCOSTRATE: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_COST_RATE",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWBILLDATE: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_BILL_DATE",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWINDV: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_INDV",
    INVOICEFORMATOPTIONSSECTIONVALIDATESHOWITEMDATE: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SHOW_ITEM_DATE",
    INVOICEFORMATOPTIONSSECTIONVALIDATECOLVALUEMISSING: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_COL_VALUE_MISSING",
    INVOICEFORMATOPTIONSSECTIONVALIDATECOLVALUEHEADING: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_COL_VALUE_HEADING",
    INVOICEFORMATOPTIONSSECTIONVALIDATECOLVALUEDUPLICATE: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_COL_VALUE_DUPLICATE",
    INVOICEFORMATOPTIONSSECTIONVALIDATESUBQTY: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SUB_QTY",
    INVOICEFORMATOPTIONSSECTIONVALIDATESUBITDQTY: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_SUB_ITD_QTY",
    INVOICEFORMATOPTIONSSECTIONVALIDATEKEY: "INVOICE_FORMAT_OPTIONS_SECTION_VALIDATE_KEY",
    JOURNALPROJECTREQUIREDWHENFIELDPROVIDED: "JOURNAL_PROJECT_REQUIRED_WHEN_FIELD_PROVIDED",
    JOURNALFIELDREQUIREDWHENPROJECTPROVIDED: "JOURNAL_FIELD_REQUIRED_WHEN_PROJECT_PROVIDED",
    JOURNALREVERSINGDATEMUSTBEINFISCALPERIODAFTERPOSTDATE: "JOURNAL_REVERSING_DATE_MUST_BE_IN_FISCAL_PERIOD_AFTER_POST_DATE",
    JOURNALTASKPROJECTMISMATCH: "JOURNAL_TASK_PROJECT_MISMATCH",
    LOGOTYPEINVALID: "LOGO_TYPE_INVALID",
    LEAVEAPPROVALQUEUEINVALIDAPPROVER: "LEAVE_APPROVAL_QUEUE_INVALID_APPROVER",
    LEAVEAPPROVALUNAVAILABLE: "LEAVE_APPROVAL_UNAVAILABLE",
    MAILUNABLETOVERIFYSIGNATURE: "MAIL_UNABLE_TO_VERIFY_SIGNATURE",
    INSTANCECURRENCYNOTFOUND: "INSTANCE_CURRENCY_NOT_FOUND",
    MULTICURRENCYALREADYACTIVATED: "MULTICURRENCY_ALREADY_ACTIVATED",
    MULTICURRENCYINSTANCECURRENCYNOTSET: "MULTICURRENCY_INSTANCE_CURRENCY_NOT_SET",
    MULTICURRENCYINSTANCECURRENCYINVALID: "MULTICURRENCY_INSTANCE_CURRENCY_INVALID",
    MULTICURRENCYREQUIRESCURRENCYCODE: "MULTICURRENCY_REQUIRES_CURRENCY_CODE",
    MULTICURRENCYOPERATIONNOTENABLED: "MULTICURRENCY_OPERATION_NOT_ENABLED",
    MULTICURRENCYINVALIDPAYMENTMETHOD: "MULTICURRENCY_INVALID_PAYMENT_METHOD",
    MULTICURRENCYREQUIRESUSD: "MULTICURRENCY_REQUIRES_USD",
    NOTIFICATIONTITLEREQUIRESARGUMENTS: "NOTIFICATION_TITLE_REQUIRES_ARGUMENTS",
    NOTIFICATIONMESSAGEREQUIRESARGUMENTS: "NOTIFICATION_MESSAGE_REQUIRES_ARGUMENTS",
    ORGVENDORPROFILEMISMATCH: "ORG_VENDOR_PROFILE_MISMATCH",
    ORGFEDERALTAXIDINVALID: "ORG_FEDERAL_TAX_ID_INVALID",
    ORGGLPOSTORGMISMATCH: "ORG_GL_POST_ORG_MISMATCH",
    ORGACCOUNTCATEGORYINVALID: "ORG_ACCOUNT_CATEGORY_INVALID",
    PERSONPASSWORDMISMATCH: "PERSON_PASSWORD_MISMATCH",
    PERSONUNABLETODELETEDUETOEXISTINGDEPENDENCIES: "PERSON_UNABLE_TO_DELETE_DUE_TO_EXISTING_DEPENDENCIES",
    PERSONNOTFOUND: "PERSON_NOT_FOUND",
    PERSONATTACHMENTNOTASSOCIATEDWITHPERSON: "PERSON_ATTACHMENT_NOT_ASSOCIATED_WITH_PERSON",
    PERSONPUNCHCLOCKUSERREQUIRESTIMESHEETUSERROLE: "PERSON_PUNCH_CLOCK_USER_REQUIRES_TIMESHEET_USER_ROLE",
    PERSONRATEHASEXTRACTEDTIME: "PERSON_RATE_HAS_EXTRACTED_TIME",
    PERSONRATEEXEMPTCANNOTSETSCAWAGEFLAG: "PERSON_RATE_EXEMPT_CANNOT_SET_SCA_WAGE_FLAG",
    PLANSETNAMEMUSTHAVESYSDEFAULT: "PLAN_SET_NAME_MUST_HAVE_SYS_DEFAULT",
    POPRKEYREQUIRED: "PO_PR_KEY_REQUIRED",
    POPRINVALIDSTATUS: "PO_PR_INVALID_STATUS",
    POCOMMITMENTDATENOTINOPENFISCALPERIOD: "PO_COMMITMENT_DATE_NOT_IN_OPEN_FISCAL_PERIOD",
    POLINENOTINOPENSTATE: "PO_LINE_NOT_IN_OPEN_STATE",
    POMODNOTORIGINALPO: "PO_MOD_NOT_ORIGINAL_PO",
    POMODNUMBERREQUIRED: "PO_MOD_NUMBER_REQUIRED",
    POMODINVALIDVIOVERAGE: "PO_MOD_INVALID_VI_OVERAGE",
    POMODCANNOTUPDATE: "PO_MOD_CANNOT_UPDATE",
    PONOTINOPENSTATE: "PO_NOT_IN_OPEN_STATE",
    PONOTMOD: "PO_NOT_MOD",
    PONOTORIGINAL: "PO_NOT_ORIGINAL",
    POSUBMITVALIDATION: "PO_SUBMIT_VALIDATION",
    POSTATUSNOTALLOWSUBMIT: "PO_STATUS_NOT_ALLOW_SUBMIT",
    POWITHEXISTINGDETAILSINVALIDUPDATE: "PO_WITH_EXISTING_DETAILS_INVALID_UPDATE",
    POPRREFERENCEMISMATCH: "PO_PR_REFERENCE_MISMATCH",
    POCANNOTSUBMITTOAPPROVALGROUP: "PO_CANNOT_SUBMIT_TO_APPROVAL_GROUP",
    PODETAILSPROJECTNOTALLOWCHARGES: "PO_DETAILS_PROJECT_NOT_ALLOW_CHARGES",
    PODETAILSINVALIDVALUE: "PO_DETAILS_INVALID_VALUE",
    PODETAILSACCOUNTMUSTREQUIREPROJECTS: "PO_DETAILS_ACCOUNT_MUST_REQUIRE_PROJECTS",
    PODETAILSACCOUNTINVALID: "PO_DETAILS_ACCOUNT_INVALID",
    PODETAILSTERMINALSTATUS: "PO_DETAILS_TERMINAL_STATUS",
    PODETAILSREFLINEEXISTS: "PO_DETAILS_REF_LINE_EXISTS",
    PODETAILSPRREFERENCEMISMATCH: "PO_DETAILS_PR_REFERENCE_MISMATCH",
    PODETAILSPRLINEREFERENCEMISMATCH: "PO_DETAILS_PR_LINE_REFERENCE_MISMATCH",
    POWITHDETAILSCANNOTUPDATEVENDORWITHDIFFERENTCURRENCY: "PO_WITH_DETAILS_CANNOT_UPDATE_VENDOR_WITH_DIFFERENT_CURRENCY",
    PDANDVENDORWITHDIFFERENTCURRENCIES: "PD_AND_VENDOR_WITH_DIFFERENT_CURRENCIES",
    POASSIGNMENTOVERLAPSEXISTINGASSIGNMENT: "PO_ASSIGNMENT_OVERLAPS_EXISTING_ASSIGNMENT",
    POSTINGGROUPCANNOTUPDATEACTIVESTATUS: "POSTING_GROUP_CANNOT_UPDATE_ACTIVE_STATUS",
    POSTINGGROUPCANNOTUPDATETYPE: "POSTING_GROUP_CANNOT_UPDATE_TYPE",
    POSTINGGROUPTYPEMUSTBECUSTOM: "POSTING_GROUP_TYPE_MUST_BE_CUSTOM",
    POSTINGGROUPSOURCEACCOUNTREQUIRED: "POSTING_GROUP_SOURCE_ACCOUNT_REQUIRED",
    POSTINGGROUPSOURCEACCOUNTSOURCEINVALID: "POSTING_GROUP_SOURCE_ACCOUNT_SOURCE_INVALID",
    POSTINGGROUPSOURCEACCOUNTSOURCEINVALIDSTATE: "POSTING_GROUP_SOURCE_ACCOUNT_SOURCE_INVALID_STATE",
    POSTINGGROUPSOURCEINVALIDORGANIZATIONSOURCE: "POSTING_GROUP_SOURCE_INVALID_ORGANIZATION_SOURCE",
    POSTINGGROUPSOURCEPOSTINGGROUPMISMATCH: "POSTING_GROUP_SOURCE_POSTING_GROUP_MISMATCH",
    PRMODCANNOTUPDATE: "PR_MOD_CANNOT_UPDATE",
    PRWITHEXISTINGDETAILSINVALIDUPDATE: "PR_WITH_EXISTING_DETAILS_INVALID_UPDATE",
    PRTERMINALSTATUS: "PR_TERMINAL_STATUS",
    PRNOTTERMINALSTATUS: "PR_NOT_TERMINAL_STATUS",
    PRNOTMOD: "PR_NOT_MOD",
    PRNOTORIGINAL: "PR_NOT_ORIGINAL",
    PRMODNOTORIGINALPR: "PR_MOD_NOT_ORIGINAL_PR",
    PRNOTINOPENSTATE: "PR_NOT_IN_OPEN_STATE",
    PRMODNUMBERREQUIRED: "PR_MOD_NUMBER_REQUIRED",
    PRDETAILSTERMINALSTATUS: "PR_DETAILS_TERMINAL_STATUS",
    PRDETAILSREFLINEEXISTS: "PR_DETAILS_REF_LINE_EXISTS",
    PRDETAILSACCOUNTMUSTREQUIREPROJECTS: "PR_DETAILS_ACCOUNT_MUST_REQUIRE_PROJECTS",
    PRCANNOTSUBMIT: "PR_CANNOT_SUBMIT",
    PRDETAILSCANNOTUPDATECURRENCY: "PR_DETAILS_CANNOT_UPDATE_CURRENCY",
    PDDETAILSPROJECTNOTALLOWCHARGES: "PD_DETAILS_PROJECT_NOT_ALLOW_CHARGES",
    PDDETAILSACCOUNTINVALID: "PD_DETAILS_ACCOUNT_INVALID",
    PDDETAILSEXCESSREVERSEVALUE: "PD_DETAILS_EXCESS_REVERSE_VALUE",
    PROJECTDUPLICATERATES: "PROJECT_DUPLICATE_RATES",
    PROJECTRATESREQUIREDWITHNOMASTERRATES: "PROJECT_RATES_REQUIRED_WITH_NO_MASTER_RATES",
    PROJECTRATESNOTALLOWEDWITHMASTERRATES: "PROJECT_RATES_NOT_ALLOWED_WITH_MASTER_RATES",
    PROJECTLOCATIONSMISSINGPROJECTDEFAULT: "PROJECT_LOCATIONS_MISSING_PROJECT_DEFAULT",
    PROJECTDEFAULTPROJECTLOCATIONDELETENOTALLOWED: "PROJECT_DEFAULT_PROJECT_LOCATION_DELETE_NOT_ALLOWED",
    PROJECTCUSTOMRATEUPDATENOTALLOWED: "PROJECT_CUSTOM_RATE_UPDATE_NOT_ALLOWED",
    PROJECTINACTIVEUSER: "PROJECT_INACTIVE_USER",
    PROJECTCONTRIBUTORINVOICEMUSTHAVEGENERATEINVOICEFLAGSET: "PROJECT_CONTRIBUTOR_INVOICE_MUST_HAVE_GENERATE_INVOICE_FLAG_SET",
    PROJECTLEADPROJECTREQUIREDFORINVOICECONTRIBUTORS: "PROJECT_LEAD_PROJECT_REQUIRED_FOR_INVOICE_CONTRIBUTORS",
    PROJECTLEADPROJECTMUSTBEDIFFERENTTHANCONTRIBUTORPROJECT: "PROJECT_LEAD_PROJECT_MUST_BE_DIFFERENT_THAN_CONTRIBUTOR_PROJECT",
    PROJECTORGNOTWITHINOWNINGORGLEGALENTITY: "PROJECT_ORG_NOT_WITHIN_OWNING_ORG_LEGAL_ENTITY",
    PROJECTLEADANDCONTRIBUTORPROJECTSMUSTHAVESAMELEGALENTITY: "PROJECT_LEAD_AND_CONTRIBUTOR_PROJECTS_MUST_HAVE_SAME_LEGAL_ENTITY",
    PROJECTADDRESSREQUIREDWHENDEFAULTNOTAVAILABLE: "PROJECT_ADDRESS_REQUIRED_WHEN_DEFAULT_NOT_AVAILABLE",
    PROJECTINVOICESETUPNOTFOUNDFORLEADPROJECT: "PROJECT_INVOICE_SETUP_NOT_FOUND_FOR_LEAD_PROJECT",
    PROJECTINVOICESETUPINVALIDACTIONDUETOPENDINGAPPROVALS: "PROJECT_INVOICE_SETUP_INVALID_ACTION_DUE_TO_PENDING_APPROVALS",
    PROJECTINVALIDLEADPROJECTASSIGNEDTOINVOICEGROUP: "PROJECT_INVALID_LEAD_PROJECT_ASSIGNED_TO_INVOICE_GROUP",
    PROJECTINVALIDCONTRIBUTORPROJECTASSIGNEDTOINVOICEGROUP: "PROJECT_INVALID_CONTRIBUTOR_PROJECT_ASSIGNED_TO_INVOICE_GROUP",
    PROJECTDUPLICATEINVOICEFORMATSSPECIFIED: "PROJECT_DUPLICATE_INVOICE_FORMATS_SPECIFIED",
    PROJECTPAYCODEMISSINGPROJECTDEFAULT: "PROJECT_PAY_CODE_MISSING_PROJECT_DEFAULT",
    PROJECTDEFAULTPROJECTPAYCODEDELETENOTALLOWED: "PROJECT_DEFAULT_PROJECT_PAY_CODE_DELETE_NOT_ALLOWED",
    PROJECTPAYMENTOPTIONREQUIREDWHENELECTRONICPAYMENTSENABLED: "PROJECT_PAYMENT_OPTION_REQUIRED_WHEN_ELECTRONIC_PAYMENTS_ENABLED",
    PROJECTACCOUNTCATEGORYINVALID: "PROJECT_ACCOUNT_CATEGORY_INVALID",
    PROJECTTASKLEVELMUSTHAVETASK: "PROJECT_TASK_LEVEL_MUST_HAVE_TASK",
    PROJECTTASKLEVELMUSTNOTHAVETASK: "PROJECT_TASK_LEVEL_MUST_NOT_HAVE_TASK",
    PROJECTASSIGNMENT: "PROJECT_ASSIGNMENT",
    PROJECTTASKASSIGNMENT: "PROJECT_TASK_ASSIGNMENT",
    PROJECTMUSTASSIGNTOCONTRACT: "PROJECT_MUST_ASSIGN_TO_CONTRACT",
    PROJECTEXCEEDCONTRACTCEILINGAMOUNT: "PROJECT_EXCEED_CONTRACT_CEILING_AMOUNT",
    PROJECTALERTTHRESHOLDPERCENTAGEREQUIRED: "PROJECT_ALERT_THRESHOLD_PERCENTAGE_REQUIRED",
    PROJECTINTERCOMPANYNOTPROVIDED: "PROJECT_INTERCOMPANY_NOT_PROVIDED",
    PROJECTINTERCOMPANYMUSTBEENABLED: "PROJECT_INTERCOMPANY_MUST_BE_ENABLED",
    PROJECTPRIMARYAPPROVERREQUIREDFORALTERNATE: "PROJECT_PRIMARY_APPROVER_REQUIRED_FOR_ALTERNATE",
    PROJECTINVALIDPRIMARYCONTROLLER: "PROJECT_INVALID_PRIMARY_CONTROLLER",
    PROJECTINVALIDALTERNATECONTROLLER: "PROJECT_INVALID_ALTERNATE_CONTROLLER",
    PROJECTORGASSIGNMENTTASKLEVEL: "PROJECT_ORG_ASSIGNMENT_TASK_LEVEL",
    PROJECTPREBILLEDLABORBALANCE: "PROJECT_PREBILLED_LABOR_BALANCE",
    PROJECTPREBILLEDLABORPOSTED: "PROJECT_PREBILLED_LABOR_POSTED",
    PROJECTEXPENSEPLANLOCKEDPLANSET: "PROJECT_EXPENSE_PLAN_LOCKED_PLAN_SET",
    PROJECTEXPENSEPLANMULTIPLEPLANSETSNOTENABLED: "PROJECT_EXPENSE_PLAN_MULTIPLE_PLAN_SETS_NOT_ENABLED",
    PROJECTHASPOSTEDTRANSACTIONS: "PROJECT_HAS_POSTED_TRANSACTIONS",
    PROJECTLABORCATEGORYINVALID: "PROJECT_LABOR_CATEGORY_INVALID",
    PROJECTLABORCATEGORYCANNOTDEFAULTTOMASTERRATE: "PROJECT_LABOR_CATEGORY_CANNOT_DEFAULT_TO_MASTER_RATE",
    PROJECTTYPEACCOUNTCATEGORYINVALID: "PROJECT_TYPE_ACCOUNT_CATEGORY_INVALID",
    RECEIVINGDOCUMENTITEMEXCEEDSQUANTITY: "RECEIVING_DOCUMENT_ITEM_EXCEEDS_QUANTITY",
    RECEIVINGDOCUMENTNOTRETRACTABLE: "RECEIVING_DOCUMENT_NOT_RETRACTABLE",
    TASKINVALIDPLAN: "TASK_INVALID_PLAN",
    TASKINVALIDASSIGNMENT: "TASK_INVALID_ASSIGNMENT",
    TASKVALIDATION: "TASK_VALIDATION",
    TASKPROJECTMISMATCH: "TASK_PROJECT_MISMATCH",
    TASKPARENTTASKPROJECTMISMATCH: "TASK_PARENT_TASK_PROJECT_MISMATCH",
    TASKCANNOTLIMITBILLTOFUNDEDWITHOUTFUNDEDVALUE: "TASK_CANNOT_LIMIT_BILL_TO_FUNDED_WITHOUT_FUNDED_VALUE",
    TASKCANNOTLIMITREVENUETOFUNDEDWITHOUTFUNDEDVALUE: "TASK_CANNOT_LIMIT_REVENUE_TO_FUNDED_WITHOUT_FUNDED_VALUE",
    TASKBILLINGTYPECANNOTBESETUNLESSALSOSETONPROJECT: "TASK_BILLING_TYPE_CANNOT_BE_SET_UNLESS_ALSO_SET_ON_PROJECT",
    TASKCANNOTOVERRIDEBILLINGTYPE: "TASK_CANNOT_OVERRIDE_BILLING_TYPE",
    TASKMODIFIEDRELATIVETASKPROJECTDOESNOTMATCHMODIFIEDTASKPROJECT: "TASK_MODIFIED_RELATIVE_TASK_PROJECT_DOES_NOT_MATCH_MODIFIED_TASK_PROJECT",
    TASKACCOUNTCATEGORYINVALID: "TASK_ACCOUNT_CATEGORY_INVALID",
    TASKPREDECESSORNOTAVAILABLE: "TASK_PREDECESSOR_NOT_AVAILABLE",
    TASKPREDECESSORINVALIDDATERANGE: "TASK_PREDECESSOR_INVALID_DATE_RANGE",
    TIMERATINGGENERIC: "TIME_RATING_GENERIC",
    TIMESHEETTIMESLIPNOTFOUND: "TIMESHEET_TIMESLIP_NOT_FOUND",
    TIMESHEETITEMENTRYNOTFOUND: "TIMESHEET_ITEM_ENTRY_NOT_FOUND",
    TIMESHEETTITONOTFOUND: "TIMESHEET_TITO_NOT_FOUND",
    TIMESHEETTITOWITHNULLSTOPTIME: "TIMESHEET_TITO_WITH_NULL_STOP_TIME",
    TIMESHEETTITOOVERLAP: "TIMESHEET_TITO_OVERLAP",
    TIMESHEETTITOINVALIDTIMEUNITS: "TIMESHEET_TITO_INVALID_TIME_UNITS",
    TIMESHEETTITONONWORKHOURSEXCEEDSTITODURATION: "TIMESHEET_TITO_NONWORK_HOURS_EXCEEDS_TITO_DURATION",
    TIMESHEETTITODUPLICATE: "TIMESHEET_TITO_DUPLICATE",
    TIMESHEETDAILYTITOEMPTY: "TIMESHEET_DAILY_TITO_EMPTY",
    TIMESHEETOWNERINSUFFICIENTROLES: "TIMESHEET_OWNER_INSUFFICIENT_ROLES",
    TIMESHEETOWNERINVALIDTIMEPERIOD: "TIMESHEET_OWNER_INVALID_TIME_PERIOD",
    TIMESHEETTIMEPERIODNOTFOUND: "TIMESHEET_TIME_PERIOD_NOT_FOUND",
    TIMESHEETDATEOUTOFTIMEPERIODRANGE: "TIMESHEET_DATE_OUT_OF_TIME_PERIOD_RANGE",
    TIMESHEETTIMEPERIODPERMISSIONS: "TIMESHEET_TIME_PERIOD_PERMISSIONS",
    TIMESHEETDATEREQUIREDFORSEMIMONTHLYTIMEPERIODS: "TIMESHEET_DATE_REQUIRED_FOR_SEMIMONTHLY_TIME_PERIODS",
    TIMESHEETDATEINVALIDFORTIMEPERIODTYPE: "TIMESHEET_DATE_INVALID_FOR_TIME_PERIOD_TYPE",
    TIMESHEETTIMEPERIODDATESMUSTBEINSAMEMONTHYEAR: "TIMESHEET_TIME_PERIOD_DATES_MUST_BE_IN_SAME_MONTH_YEAR",
    TIMESHEETDEFAULTPAYCODENOTFOUND: "TIMESHEET_DEFAULT_PAY_CODE_NOT_FOUND",
    TIMESHEETINVALIDSTATUSFORSUBMISSION: "TIMESHEET_INVALID_STATUS_FOR_SUBMISSION",
    TIMESHEETSEARCHACTIVEORSTATUSLISTS: "TIMESHEET_SEARCH_ACTIVE_OR_STATUS_LISTS",
    TIMESHEETTASKREQUIREDFORPROJECTSWITHTASKLEVELASSIGNMENT: "TIMESHEET_TASK_REQUIRED_FOR_PROJECTS_WITH_TASK_LEVEL_ASSIGNMENT",
    JEPOSTED: "JE_POSTED",
    VIPOSTED: "VI_POSTED",
    VIVOIDED: "VI_VOIDED",
    VICANNOTCHANGESTATUS: "VI_CANNOT_CHANGE_STATUS",
    VISTATUSNOTALLOWSUBMIT: "VI_STATUS_NOT_ALLOW_SUBMIT",
    VICANNOTSUBMITTOAPPROVALGROUP: "VI_CANNOT_SUBMIT_TO_APPROVAL_GROUP",
    VICANNOTSUBMITDUETOAPPROVALS: "VI_CANNOT_SUBMIT_DUE_TO_APPROVALS",
    VINOPOASSIGNED: "VI_NO_PO_ASSIGNED",
    VIVENDORNOTVALIDFORLEGALENTITY: "VI_VENDOR_NOT_VALID_FOR_LEGAL_ENTITY",
    VIPOISAMOD: "VI_PO_IS_A_MOD",
    VIPONOTINOPENSTATE: "VI_PO_NOT_IN_OPEN_STATE",
    VIAPORGLEGALENTITYMISMATCH: "VI_AP_ORG_LEGAL_ENTITY_MISMATCH",
    VIPOLEGALENTITYMISMATCH: "VI_PO_LEGAL_ENTITY_MISMATCH",
    VIPOVENDORMISMATCH: "VI_PO_VENDOR_MISMATCH",
    VIORGNOTALLOWTRANSACTIONENTRY: "VI_ORG_NOT_ALLOW_TRANSACTION_ENTRY",
    VIFIELDCHANGENOTALLOWEDWHENTRANSACTIONSEXIST: "VI_FIELD_CHANGE_NOT_ALLOWED_WHEN_TRANSACTIONS_EXIST",
    VINOAPACCOUNTFORLEGALENTITY: "VI_NO_AP_ACCOUNT_FOR_LEGAL_ENTITY",
    VIMUSTHAVEPOASSIGNED: "VI_MUST_HAVE_PO_ASSIGNED",
    VINOAPORGFORLEGALENTITY: "VI_NO_AP_ORG_FOR_LEGAL_ENTITY",
    VIDETAILSPROJECTNOTALLOWCHARGES: "VI_DETAILS_PROJECT_NOT_ALLOW_CHARGES",
    VIDETAILSACCOUNTTXNSDONOTALLOWPROJECTS: "VI_DETAILS_ACCOUNT_TXNS_DO_NOT_ALLOW_PROJECTS",
    VIDETAILSLABORREQPROJECTS: "VI_DETAILS_LABOR_REQ_PROJECTS",
    VIDETAILSACCOUNTTXNSREQUIREPROJECTS: "VI_DETAILS_ACCOUNT_TXNS_REQUIRE_PROJECTS",
    VIDETAILSACCOUNTINVALID: "VI_DETAILS_ACCOUNT_INVALID",
    VIDETAILSPOFIELDSBOTHSETORBLANK: "VI_DETAILS_PO_FIELDS_BOTH_SET_OR_BLANK",
    VIDETAILSPROJECTNOTALLOWLABORCAT: "VI_DETAILS_PROJECT_NOT_ALLOW_LABOR_CAT",
    VIDETAILSLABORCATNOTVALIDFORPROJECT: "VI_DETAILS_LABOR_CAT_NOT_VALID_FOR_PROJECT",
    VIDETAILSPROJECTREQUIRESLABORCAT: "VI_DETAILS_PROJECT_REQUIRES_LABOR_CAT",
    VIDETAILSEXPTYPENOTVALIDFORPROJECT: "VI_DETAILS_EXP_TYPE_NOT_VALID_FOR_PROJECT",
    VIDETAILSITEMNOTVALIDFORPROJECT: "VI_DETAILS_ITEM_NOT_VALID_FOR_PROJECT",
    VIDETAILSACCTNOTVALIDFOREXPTYPE: "VI_DETAILS_ACCT_NOT_VALID_FOR_EXP_TYPE",
    VIDETAILSACCTNOTVALIDFORITEMEXPTYPE: "VI_DETAILS_ACCT_NOT_VALID_FOR_ITEM_EXP_TYPE",
    VIDETAILSITEMINVENTORYNOTALLOWPROJ: "VI_DETAILS_ITEM_INVENTORY_NOT_ALLOW_PROJ",
    VIDETAILSITEMREQUIRESPROJ: "VI_DETAILS_ITEM_REQUIRES_PROJ",
    JEVOIDED: "JE_VOIDED",
    VPPOSTED: "VP_POSTED",
    VPSUBMITTED: "VP_SUBMITTED",
    VPVOIDED: "VP_VOIDED",
    VPINVALIDPAYMENTMETHOD: "VP_INVALID_PAYMENT_METHOD",
    PAIDDOCNOTPOSTED: "PAID_DOC_NOT_POSTED",
    PAIDDOCVOIDED: "PAID_DOC_VOIDED",
    PAIDDOCVOIDING: "PAID_DOC_VOIDING",
    PAIDDOCLEGALENTITYMISMATCH: "PAID_DOC_LEGAL_ENTITY_MISMATCH",
    PAIDDOCVENDORMISMATCH: "PAID_DOC_VENDOR_MISMATCH",
    PAIDDOCOTHERUNPOSTED: "PAID_DOC_OTHER_UNPOSTED",
    PAIDDOCOTHERUNPOSTEDAPP: "PAID_DOC_OTHER_UNPOSTED_APP",
    PAIDDOCZEROBALANCE: "PAID_DOC_ZERO_BALANCE",
    PAIDDOCZEROAMOUNTS: "PAID_DOC_ZERO_AMOUNTS",
    PAIDDOCPAYMENTDISCOUNT: "PAID_DOC_PAYMENT_DISCOUNT",
    PAIDDOCEXCESSDISCOUNT: "PAID_DOC_EXCESS_DISCOUNT",
    PAIDDOCCUSTOMERMISMATCH: "PAID_DOC_CUSTOMER_MISMATCH",
    PAIDDOCPAYMENTWRITEOFF: "PAID_DOC_PAYMENT_WRITEOFF",
    PAIDDOCEXCESSWRITEOFF: "PAID_DOC_EXCESS_WRITEOFF",
    PAIDDOCINVNOTCOMPLETED: "PAID_DOC_INV_NOT_COMPLETED",
    PAIDDOCPOSTEDAFTERPOSTPERIODENDDATE: "PAID_DOC_POSTED_AFTER_POST_PERIOD_END_DATE",
    PAIDDOCPAYMENTEXCEEDSBALANCE: "PAID_DOC_PAYMENT_EXCEEDS_BALANCE"
  };
})(ImportErrorModel || (ImportErrorModel = {}));
var ImportedExpenseSearchModel;
((ImportedExpenseSearchModel2) => {
  ImportedExpenseSearchModel2.StatusEnum = {
    AVAILABLE: "AVAILABLE",
    USED: "USED",
    ALL: "ALL"
  };
})(ImportedExpenseSearchModel || (ImportedExpenseSearchModel = {}));
var IntegrationUserSearchModel;
((IntegrationUserSearchModel2) => {
  IntegrationUserSearchModel2.IntegrationUserTypeEnum = {
    VENDORINVOICEAUTOMATION: "VENDOR_INVOICE_AUTOMATION",
    PASSPORTINTEGRATIONUSER: "PASSPORT_INTEGRATION_USER",
    BANKFEEDSINTEGRATIONUSER: "BANK_FEEDS_INTEGRATION_USER"
  };
})(IntegrationUserSearchModel || (IntegrationUserSearchModel = {}));
const IntegrationUserType = {
  VENDORINVOICEAUTOMATION: "VENDOR_INVOICE_AUTOMATION",
  PASSPORTINTEGRATIONUSER: "PASSPORT_INTEGRATION_USER",
  BANKFEEDSINTEGRATIONUSER: "BANK_FEEDS_INTEGRATION_USER"
};
var IntegrationValueModel;
((IntegrationValueModel2) => {
  IntegrationValueModel2.TypeEnum = {
    PURCHASEORDER: "PURCHASE_ORDER",
    PURCHASEORDERITEMLINE: "PURCHASE_ORDER_ITEM_LINE",
    PURCHASEORDERITEMLINEDESCRIPTOR: "PURCHASE_ORDER_ITEM_LINE_DESCRIPTOR",
    PURCHASEORDERLABORLINE: "PURCHASE_ORDER_LABOR_LINE",
    PURCHASEORDERLABORLINEDESCRIPTOR: "PURCHASE_ORDER_LABOR_LINE_DESCRIPTOR",
    PURCHASEORDEREXPENSELINE: "PURCHASE_ORDER_EXPENSE_LINE",
    PURCHASEORDEREXPENSELINEDESCRIPTOR: "PURCHASE_ORDER_EXPENSE_LINE_DESCRIPTOR",
    VENDORINVOICE: "VENDOR_INVOICE",
    VENDORINVOICEITEMLINE: "VENDOR_INVOICE_ITEM_LINE",
    VENDORINVOICELABORLINE: "VENDOR_INVOICE_LABOR_LINE",
    VENDORINVOICEEXPENSELINE: "VENDOR_INVOICE_EXPENSE_LINE",
    ITEM: "ITEM",
    CUSTOM: "CUSTOM"
  };
})(IntegrationValueModel || (IntegrationValueModel = {}));
var InvoiceFormatCreateModel;
((InvoiceFormatCreateModel2) => {
  InvoiceFormatCreateModel2.TaskGroupLevelEnum = {
    EVERYTASK: "EVERY_TASK",
    TASK_LEVEL_1: "TASK_LEVEL_1",
    TASK_LEVEL_2: "TASK_LEVEL_2",
    TASK_LEVEL_3: "TASK_LEVEL_3",
    TASK_LEVEL_4: "TASK_LEVEL_4",
    TASK_LEVEL_5: "TASK_LEVEL_5"
  };
})(InvoiceFormatCreateModel || (InvoiceFormatCreateModel = {}));
var InvoiceFormatModel;
((InvoiceFormatModel2) => {
  InvoiceFormatModel2.TaskGroupLevelEnum = {
    EVERYTASK: "EVERY_TASK",
    TASK_LEVEL_1: "TASK_LEVEL_1",
    TASK_LEVEL_2: "TASK_LEVEL_2",
    TASK_LEVEL_3: "TASK_LEVEL_3",
    TASK_LEVEL_4: "TASK_LEVEL_4",
    TASK_LEVEL_5: "TASK_LEVEL_5"
  };
})(InvoiceFormatModel || (InvoiceFormatModel = {}));
var InvoiceListModel;
((InvoiceListModel2) => {
  InvoiceListModel2.InvoiceOptionEnum = {
    STANDALONE: "STANDALONE",
    LEAD: "LEAD",
    CONTRIBUTOR: "CONTRIBUTOR"
  };
})(InvoiceListModel || (InvoiceListModel = {}));
var InvoiceModel;
((InvoiceModel2) => {
  InvoiceModel2.InvoiceOptionEnum = {
    STANDALONE: "STANDALONE",
    LEAD: "LEAD",
    CONTRIBUTOR: "CONTRIBUTOR"
  };
  InvoiceModel2.StatusEnum = {
    DRAFT: "DRAFT",
    SUBMITTED: "SUBMITTED",
    APPROVING: "APPROVING",
    APPROVED: "APPROVED",
    DISAPPROVED: "DISAPPROVED",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED"
  };
})(InvoiceModel || (InvoiceModel = {}));
var InvoiceStatusHistoryModel;
((InvoiceStatusHistoryModel2) => {
  InvoiceStatusHistoryModel2.StatusEnum = {
    DRAFT: "DRAFT",
    SUBMITTED: "SUBMITTED",
    APPROVING: "APPROVING",
    APPROVED: "APPROVED",
    DISAPPROVED: "DISAPPROVED",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED"
  };
})(InvoiceStatusHistoryModel || (InvoiceStatusHistoryModel = {}));
var ItemCreateModel;
((ItemCreateModel2) => {
  ItemCreateModel2.BillByEnum = {
    MARKUP: "MARKUP",
    RATE: "RATE"
  };
})(ItemCreateModel || (ItemCreateModel = {}));
var ItemModel;
((ItemModel2) => {
  ItemModel2.BillByEnum = {
    MARKUP: "MARKUP",
    RATE: "RATE"
  };
})(ItemModel || (ItemModel = {}));
var JournalEntryExpenseDetailModel;
((JournalEntryExpenseDetailModel2) => {
  JournalEntryExpenseDetailModel2.DetailTypeEnum = {
    LABOR: "LABOR",
    EXPENSE: "EXPENSE",
    ITEM: "ITEM"
  };
})(JournalEntryExpenseDetailModel || (JournalEntryExpenseDetailModel = {}));
var JournalEntryItemDetailModel;
((JournalEntryItemDetailModel2) => {
  JournalEntryItemDetailModel2.DetailTypeEnum = {
    LABOR: "LABOR",
    EXPENSE: "EXPENSE",
    ITEM: "ITEM"
  };
})(JournalEntryItemDetailModel || (JournalEntryItemDetailModel = {}));
var JournalEntrySearchModel;
((JournalEntrySearchModel2) => {
  JournalEntrySearchModel2.StatusesEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED",
    APPROVED: "APPROVED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED"
  };
  JournalEntrySearchModel2.SortOrderEnum = {
    ASC: "ASC",
    DESC: "DESC"
  };
})(JournalEntrySearchModel || (JournalEntrySearchModel = {}));
var JournalEntrySummaryModel;
((JournalEntrySummaryModel2) => {
  JournalEntrySummaryModel2.DocumentTypeEnum = {
    VENDORINVOICE: "VENDOR_INVOICE",
    VENDORPAYMENT: "VENDOR_PAYMENT",
    CUSTOMERPAYMENT: "CUSTOMER_PAYMENT",
    DEPOSIT: "DEPOSIT",
    JOURNALENTRY: "JOURNAL_ENTRY",
    INTERCOMPANYJOURNALENTRY: "INTERCOMPANY_JOURNAL_ENTRY",
    INTERCOMPANYVENDORINVOICE: "INTERCOMPANY_VENDOR_INVOICE"
  };
  JournalEntrySummaryModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED",
    APPROVED: "APPROVED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED"
  };
})(JournalEntrySummaryModel || (JournalEntrySummaryModel = {}));
var LaborInvoiceSectionFormatCreateModel;
((LaborInvoiceSectionFormatCreateModel2) => {
  LaborInvoiceSectionFormatCreateModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  LaborInvoiceSectionFormatCreateModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  LaborInvoiceSectionFormatCreateModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  LaborInvoiceSectionFormatCreateModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  LaborInvoiceSectionFormatCreateModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(LaborInvoiceSectionFormatCreateModel || (LaborInvoiceSectionFormatCreateModel = {}));
var LaborInvoiceSectionFormatModel;
((LaborInvoiceSectionFormatModel2) => {
  LaborInvoiceSectionFormatModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  LaborInvoiceSectionFormatModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  LaborInvoiceSectionFormatModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  LaborInvoiceSectionFormatModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  LaborInvoiceSectionFormatModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(LaborInvoiceSectionFormatModel || (LaborInvoiceSectionFormatModel = {}));
var LeaveRequestModel;
((LeaveRequestModel2) => {
  LeaveRequestModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    LOCKED: "LOCKED",
    CANCELED: "CANCELED"
  };
})(LeaveRequestModel || (LeaveRequestModel = {}));
var LeaveStatusHistoryModel;
((LeaveStatusHistoryModel2) => {
  LeaveStatusHistoryModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    LOCKED: "LOCKED",
    CANCELED: "CANCELED"
  };
})(LeaveStatusHistoryModel || (LeaveStatusHistoryModel = {}));
var LogMessageModel;
((LogMessageModel2) => {
  LogMessageModel2.LevelEnum = {
    ERROR: "ERROR",
    WARN: "WARN",
    INFO: "INFO",
    DEBUG: "DEBUG"
  };
})(LogMessageModel || (LogMessageModel = {}));
var MatrixPersonModel;
((MatrixPersonModel2) => {
  MatrixPersonModel2.CurrentClassificationEnum = {
    EXEMPT: "EXEMPT",
    NONEXEMPT: "NON_EXEMPT",
    NONEMPLOYEE: "NON_EMPLOYEE",
    SUBCONTRACTOR: "SUBCONTRACTOR"
  };
})(MatrixPersonModel || (MatrixPersonModel = {}));
var MeTimesheetSearchModel;
((MeTimesheetSearchModel2) => {
  MeTimesheetSearchModel2.StatusesEnum = {
    NEW: "NEW",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED"
  };
  MeTimesheetSearchModel2.AdjustmentStatusesEnum = {
    NEW: "NEW",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED"
  };
  MeTimesheetSearchModel2.SortByEnum = {
    BEGINDATE: "BEGIN_DATE",
    HOURS: "HOURS",
    STATUS: "STATUS",
    CONTROLLER: "CONTROLLER"
  };
  MeTimesheetSearchModel2.SortOrderEnum = {
    ASC: "ASC",
    DESC: "DESC"
  };
})(MeTimesheetSearchModel || (MeTimesheetSearchModel = {}));
var MileageRateSetModel;
((MileageRateSetModel2) => {
  MileageRateSetModel2.UnitEnum = {
    KILOMETERS: "KILOMETERS",
    MILES: "MILES"
  };
})(MileageRateSetModel || (MileageRateSetModel = {}));
var NaturalLanguageSummaryRequestModel;
((NaturalLanguageSummaryRequestModel2) => {
  NaturalLanguageSummaryRequestModel2.PeriodTypeEnum = {
    MONTH: "MONTH",
    QUARTER: "QUARTER",
    YEAR: "YEAR"
  };
  NaturalLanguageSummaryRequestModel2.DetailLevelEnum = {
    EXECUTIVEBRIEF: "EXECUTIVE_BRIEF",
    MANAGEMENTREPORT: "MANAGEMENT_REPORT",
    COMPREHENSIVEANALYSIS: "COMPREHENSIVE_ANALYSIS"
  };
})(NaturalLanguageSummaryRequestModel || (NaturalLanguageSummaryRequestModel = {}));
var NewCookie;
((NewCookie2) => {
  NewCookie2.SameSiteEnum = {
    NONE: "NONE",
    LAX: "LAX",
    STRICT: "STRICT"
  };
})(NewCookie || (NewCookie = {}));
var OnetimeInvoiceSectionFormatCreateModel;
((OnetimeInvoiceSectionFormatCreateModel2) => {
  OnetimeInvoiceSectionFormatCreateModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  OnetimeInvoiceSectionFormatCreateModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  OnetimeInvoiceSectionFormatCreateModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  OnetimeInvoiceSectionFormatCreateModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  OnetimeInvoiceSectionFormatCreateModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(OnetimeInvoiceSectionFormatCreateModel || (OnetimeInvoiceSectionFormatCreateModel = {}));
var OnetimeInvoiceSectionFormatModel;
((OnetimeInvoiceSectionFormatModel2) => {
  OnetimeInvoiceSectionFormatModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  OnetimeInvoiceSectionFormatModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  OnetimeInvoiceSectionFormatModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  OnetimeInvoiceSectionFormatModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  OnetimeInvoiceSectionFormatModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(OnetimeInvoiceSectionFormatModel || (OnetimeInvoiceSectionFormatModel = {}));
var OrgAccessPersonSearchModel;
((OrgAccessPersonSearchModel2) => {
  OrgAccessPersonSearchModel2.OrgAccessTypeEnum = {
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    FINANCIAL: "FINANCIAL",
    CONTACT: "CONTACT",
    OWNING: "OWNING",
    DOCUMENT: "DOCUMENT",
    VENDOR: "VENDOR"
  };
})(OrgAccessPersonSearchModel || (OrgAccessPersonSearchModel = {}));
var OrganizationCreateModel;
((OrganizationCreateModel2) => {
  OrganizationCreateModel2.FederalTaxIdTypeEnum = {
    EIN: "EIN",
    SSN: "SSN",
    ITIN: "ITIN"
  };
})(OrganizationCreateModel || (OrganizationCreateModel = {}));
var OrganizationModel;
((OrganizationModel2) => {
  OrganizationModel2.FederalTaxIdTypeEnum = {
    EIN: "EIN",
    SSN: "SSN",
    ITIN: "ITIN"
  };
})(OrganizationModel || (OrganizationModel = {}));
var OrganizationSummaryModel;
((OrganizationSummaryModel2) => {
  OrganizationSummaryModel2.FederalTaxIdTypeEnum = {
    EIN: "EIN",
    SSN: "SSN",
    ITIN: "ITIN"
  };
})(OrganizationSummaryModel || (OrganizationSummaryModel = {}));
var POAlertPreferencesModel;
((POAlertPreferencesModel2) => {
  POAlertPreferencesModel2.AlertLevelEnum = {
    NONE: "NONE",
    CUSTOM: "CUSTOM"
  };
})(POAlertPreferencesModel || (POAlertPreferencesModel = {}));
var PODetail;
((PODetail2) => {
  PODetail2.LineTypeEnum = {
    LABOR: "LABOR",
    EXPENSE: "EXPENSE",
    ITEM: "ITEM"
  };
})(PODetail || (PODetail = {}));
var POExpenseLineCreateModel;
((POExpenseLineCreateModel2) => {
  POExpenseLineCreateModel2.ViOverageEnum = {
    L: "L",
    D: "D",
    F: "F"
  };
})(POExpenseLineCreateModel || (POExpenseLineCreateModel = {}));
var POExpenseLineFromApprovedCreateModel;
((POExpenseLineFromApprovedCreateModel2) => {
  POExpenseLineFromApprovedCreateModel2.ViOverageEnum = {
    L: "L",
    D: "D",
    F: "F"
  };
})(POExpenseLineFromApprovedCreateModel || (POExpenseLineFromApprovedCreateModel = {}));
var POExpenseLineModel;
((POExpenseLineModel2) => {
  POExpenseLineModel2.LineTypeEnum = {
    LABOR: "LABOR",
    EXPENSE: "EXPENSE",
    ITEM: "ITEM"
  };
  POExpenseLineModel2.ViOverageEnum = {
    L: "L",
    D: "D",
    F: "F"
  };
})(POExpenseLineModel || (POExpenseLineModel = {}));
var POFormatOptionsModel;
((POFormatOptionsModel2) => {
  POFormatOptionsModel2.DeliveryOptionEnum = {
    NONESPECIFIED: "NONE_SPECIFIED",
    EMAIL: "EMAIL",
    PRINTMAIL: "PRINT_MAIL"
  };
  POFormatOptionsModel2.DetailLevelsEnum = {
    SINGLE: "SINGLE",
    CONSOLIDATED: "CONSOLIDATED",
    DETAIL: "DETAIL"
  };
})(POFormatOptionsModel || (POFormatOptionsModel = {}));
var POItemLineCreateModel;
((POItemLineCreateModel2) => {
  POItemLineCreateModel2.ViOverageEnum = {
    L: "L",
    D: "D",
    F: "F"
  };
})(POItemLineCreateModel || (POItemLineCreateModel = {}));
var POItemLineFromApprovedCreateModel;
((POItemLineFromApprovedCreateModel2) => {
  POItemLineFromApprovedCreateModel2.ViOverageEnum = {
    L: "L",
    D: "D",
    F: "F"
  };
})(POItemLineFromApprovedCreateModel || (POItemLineFromApprovedCreateModel = {}));
var POItemLineModel;
((POItemLineModel2) => {
  POItemLineModel2.LineTypeEnum = {
    LABOR: "LABOR",
    EXPENSE: "EXPENSE",
    ITEM: "ITEM"
  };
  POItemLineModel2.ViOverageEnum = {
    L: "L",
    D: "D",
    F: "F"
  };
})(POItemLineModel || (POItemLineModel = {}));
var POLaborLineCreateModel;
((POLaborLineCreateModel2) => {
  POLaborLineCreateModel2.ViOverageEnum = {
    L: "L",
    D: "D",
    F: "F"
  };
})(POLaborLineCreateModel || (POLaborLineCreateModel = {}));
var POLaborLineFromApprovedCreateModel;
((POLaborLineFromApprovedCreateModel2) => {
  POLaborLineFromApprovedCreateModel2.ViOverageEnum = {
    L: "L",
    D: "D",
    F: "F"
  };
})(POLaborLineFromApprovedCreateModel || (POLaborLineFromApprovedCreateModel = {}));
var POLaborLineModel;
((POLaborLineModel2) => {
  POLaborLineModel2.LineTypeEnum = {
    LABOR: "LABOR",
    EXPENSE: "EXPENSE",
    ITEM: "ITEM"
  };
  POLaborLineModel2.ViOverageEnum = {
    L: "L",
    D: "D",
    F: "F"
  };
})(POLaborLineModel || (POLaborLineModel = {}));
var PRExpenseLineModel;
((PRExpenseLineModel2) => {
  PRExpenseLineModel2.LineTypeEnum = {
    LABOR: "LABOR",
    EXPENSE: "EXPENSE",
    ITEM: "ITEM"
  };
})(PRExpenseLineModel || (PRExpenseLineModel = {}));
var PRItemLineModel;
((PRItemLineModel2) => {
  PRItemLineModel2.LineTypeEnum = {
    LABOR: "LABOR",
    EXPENSE: "EXPENSE",
    ITEM: "ITEM"
  };
})(PRItemLineModel || (PRItemLineModel = {}));
var PRLaborLineModel;
((PRLaborLineModel2) => {
  PRLaborLineModel2.LineTypeEnum = {
    LABOR: "LABOR",
    EXPENSE: "EXPENSE",
    ITEM: "ITEM"
  };
})(PRLaborLineModel || (PRLaborLineModel = {}));
var PaidCustomerDocumentModel;
((PaidCustomerDocumentModel2) => {
  PaidCustomerDocumentModel2.DocumentTypeEnum = {
    PAYMENT: "PAYMENT",
    INVOICE: "INVOICE"
  };
})(PaidCustomerDocumentModel || (PaidCustomerDocumentModel = {}));
var PaidVendorDocumentModel;
((PaidVendorDocumentModel2) => {
  PaidVendorDocumentModel2.DocumentTypeEnum = {
    VENDORPAYMENT: "VENDOR_PAYMENT",
    VENDORINVOICE: "VENDOR_INVOICE"
  };
})(PaidVendorDocumentModel || (PaidVendorDocumentModel = {}));
var PayCodeModel;
((PayCodeModel2) => {
  PayCodeModel2.ExemptUsageEnum = {
    REGULAR: "REGULAR",
    PREMIUM: "PREMIUM",
    EXCLUDE: "EXCLUDE",
    LWOP: "LWOP"
  };
})(PayCodeModel || (PayCodeModel = {}));
var PayableCustomerDocumentModel;
((PayableCustomerDocumentModel2) => {
  PayableCustomerDocumentModel2.DocumentTypeEnum = {
    PAYMENT: "PAYMENT",
    INVOICE: "INVOICE"
  };
})(PayableCustomerDocumentModel || (PayableCustomerDocumentModel = {}));
var PayableVendorDocumentModel;
((PayableVendorDocumentModel2) => {
  PayableVendorDocumentModel2.DocumentTypeEnum = {
    VENDORPAYMENT: "VENDOR_PAYMENT",
    VENDORINVOICE: "VENDOR_INVOICE"
  };
})(PayableVendorDocumentModel || (PayableVendorDocumentModel = {}));
var PaymentMethodCreateModel;
((PaymentMethodCreateModel2) => {
  PaymentMethodCreateModel2.ApPaymentTypeEnum = {
    MANUALCHECK: "MANUAL_CHECK",
    OTHER: "OTHER",
    SYSTEMCHECK: "SYSTEM_CHECK"
  };
  PaymentMethodCreateModel2.ArPaymentTypeEnum = {
    CHECK: "CHECK",
    OTHER: "OTHER"
  };
})(PaymentMethodCreateModel || (PaymentMethodCreateModel = {}));
var PaymentMethodModel;
((PaymentMethodModel2) => {
  PaymentMethodModel2.ApPaymentTypeEnum = {
    MANUALCHECK: "MANUAL_CHECK",
    OTHER: "OTHER",
    SYSTEMCHECK: "SYSTEM_CHECK"
  };
  PaymentMethodModel2.ArPaymentTypeEnum = {
    CHECK: "CHECK",
    OTHER: "OTHER"
  };
})(PaymentMethodModel || (PaymentMethodModel = {}));
var PersonAccrualPlanModel;
((PersonAccrualPlanModel2) => {
  PersonAccrualPlanModel2.RateMethodEnum = {
    PERIOD: "PERIOD",
    HOURS: "HOURS"
  };
  PersonAccrualPlanModel2.AccrualPeriodEnum = {
    WEEKLY: "WEEKLY",
    BIWEEKLY: "BIWEEKLY",
    SEMIMONTHLY: "SEMI_MONTHLY",
    MONTHLY: "MONTHLY",
    YEARLY: "YEARLY"
  };
})(PersonAccrualPlanModel || (PersonAccrualPlanModel = {}));
var PersonCreateModel;
((PersonCreateModel2) => {
  PersonCreateModel2.TitoRequiredEnum = {
    NOTREQUIRED: "NOT_REQUIRED",
    PROJECT: "PROJECT",
    DAILY: "DAILY"
  };
  PersonCreateModel2.TitoButtonSettingEnum = {
    ALWAYSREQUIRED: "ALWAYS_REQUIRED",
    NEVERREQUIRED: "NEVER_REQUIRED",
    WHENREQUIRED: "WHEN_REQUIRED"
  };
})(PersonCreateModel || (PersonCreateModel = {}));
var PersonModel;
((PersonModel2) => {
  PersonModel2.TitoRequiredEnum = {
    NOTREQUIRED: "NOT_REQUIRED",
    PROJECT: "PROJECT",
    DAILY: "DAILY"
  };
  PersonModel2.TitoButtonSettingEnum = {
    ALWAYSREQUIRED: "ALWAYS_REQUIRED",
    NEVERREQUIRED: "NEVER_REQUIRED",
    WHENREQUIRED: "WHEN_REQUIRED"
  };
})(PersonModel || (PersonModel = {}));
var PersonRateBaseModel;
((PersonRateBaseModel2) => {
  PersonRateBaseModel2.ClassificationEnum = {
    EXEMPT: "EXEMPT",
    NONEXEMPT: "NON_EXEMPT",
    NONEMPLOYEE: "NON_EMPLOYEE",
    SUBCONTRACTOR: "SUBCONTRACTOR"
  };
})(PersonRateBaseModel || (PersonRateBaseModel = {}));
var PersonRateCreateModel;
((PersonRateCreateModel2) => {
  PersonRateCreateModel2.ClassificationEnum = {
    EXEMPT: "EXEMPT",
    NONEXEMPT: "NON_EXEMPT",
    NONEMPLOYEE: "NON_EMPLOYEE",
    SUBCONTRACTOR: "SUBCONTRACTOR"
  };
})(PersonRateCreateModel || (PersonRateCreateModel = {}));
var PersonRateModel;
((PersonRateModel2) => {
  PersonRateModel2.ClassificationEnum = {
    EXEMPT: "EXEMPT",
    NONEXEMPT: "NON_EXEMPT",
    NONEMPLOYEE: "NON_EMPLOYEE",
    SUBCONTRACTOR: "SUBCONTRACTOR"
  };
})(PersonRateModel || (PersonRateModel = {}));
var PersonSearchModel;
((PersonSearchModel2) => {
  PersonSearchModel2.ApprovalTypesEnum = {
    LEAVEREQUEST: "LEAVE_REQUEST",
    TIME: "TIME",
    EXPENSEREQUEST: "EXPENSE_REQUEST",
    EXPENSEREPORT: "EXPENSE_REPORT",
    PURCHASEREQUEST: "PURCHASE_REQUEST",
    PURCHASEORDER: "PURCHASE_ORDER",
    VENDORINVOICE: "VENDOR_INVOICE",
    CUSTOMERINVOICE: "CUSTOMER_INVOICE"
  };
  PersonSearchModel2.ClassificationEnum = {
    EXEMPT: "EXEMPT",
    NONEXEMPT: "NON_EXEMPT",
    NONEMPLOYEE: "NON_EMPLOYEE",
    SUBCONTRACTOR: "SUBCONTRACTOR"
  };
})(PersonSearchModel || (PersonSearchModel = {}));
var PlanDefaultsModel;
((PlanDefaultsModel2) => {
  PlanDefaultsModel2.CostRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  PlanDefaultsModel2.BillRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
})(PlanDefaultsModel || (PlanDefaultsModel = {}));
var PlanSetAuditModel;
((PlanSetAuditModel2) => {
  PlanSetAuditModel2.EventEnum = {
    ACTIVATED: "ACTIVATED",
    DEACTIVATED: "DEACTIVATED",
    LOCKED: "LOCKED",
    CREATED: "CREATED",
    RENAMED: "RENAMED"
  };
})(PlanSetAuditModel || (PlanSetAuditModel = {}));
var PlannedTimeCreateModel;
((PlannedTimeCreateModel2) => {
  PlannedTimeCreateModel2.BillRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  PlannedTimeCreateModel2.CostRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
})(PlannedTimeCreateModel || (PlannedTimeCreateModel = {}));
var PlannedTimeModel;
((PlannedTimeModel2) => {
  PlannedTimeModel2.BillRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  PlannedTimeModel2.CostRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
})(PlannedTimeModel || (PlannedTimeModel = {}));
var PlannedTimeSearchModel;
((PlannedTimeSearchModel2) => {
  PlannedTimeSearchModel2.SortOrderEnum = {
    ASC: "ASC",
    DESC: "DESC"
  };
})(PlannedTimeSearchModel || (PlannedTimeSearchModel = {}));
var PlanningMatrixSearchCriteriaModel;
((PlanningMatrixSearchCriteriaModel2) => {
  PlanningMatrixSearchCriteriaModel2.UnitTypeEnum = {
    PROJECT: "PROJECT",
    TASK: "TASK",
    ALL: "ALL"
  };
})(PlanningMatrixSearchCriteriaModel || (PlanningMatrixSearchCriteriaModel = {}));
var PlanningMatrixSearchCriteriaReadModel;
((PlanningMatrixSearchCriteriaReadModel2) => {
  PlanningMatrixSearchCriteriaReadModel2.UnitTypeEnum = {
    PROJECT: "PROJECT",
    TASK: "TASK",
    ALL: "ALL"
  };
  PlanningMatrixSearchCriteriaReadModel2.DashboardsEnum = {
    HOME: "HOME",
    ORGANIZATIONS: "ORGANIZATIONS",
    CONTRACTS: "CONTRACTS",
    CONTRACT: "CONTRACT",
    PROJECT: "PROJECT",
    PEOPLE: "PEOPLE",
    TIME: "TIME",
    EXPENSE: "EXPENSE",
    FORECAST: "FORECAST",
    FINANCIALS: "FINANCIALS",
    PURCHASING: "PURCHASING",
    ACCOUNTSPAYABLE: "ACCOUNTS_PAYABLE",
    ACCOUNTSRECEIVABLE: "ACCOUNTS_RECEIVABLE",
    BILLING: "BILLING",
    GENERALLEDGER: "GENERAL_LEDGER",
    DOCUMENTS: "DOCUMENTS",
    ADMIN: "ADMIN",
    REPORTS: "REPORTS"
  };
})(PlanningMatrixSearchCriteriaReadModel || (PlanningMatrixSearchCriteriaReadModel = {}));
var PlanningMatrixSearchModel;
((PlanningMatrixSearchModel2) => {
  PlanningMatrixSearchModel2.UnitTypeEnum = {
    PROJECT: "PROJECT",
    TASK: "TASK",
    ALL: "ALL"
  };
})(PlanningMatrixSearchModel || (PlanningMatrixSearchModel = {}));
const PostingFeature = {
  VENDORINVOICEPOST: "VENDOR_INVOICE_POST",
  VENDORPAYMENTPOST: "VENDOR_PAYMENT_POST",
  CUSTOMERPAYMENTPOST: "CUSTOMER_PAYMENT_POST",
  DEPOSITPOST: "DEPOSIT_POST",
  JOURNALENTRYPOST: "JOURNAL_ENTRY_POST",
  BILLINGPOST: "BILLING_POST",
  INVOICEPOST: "INVOICE_POST",
  LABORCOSTPOST: "LABOR_COST_POST",
  EXPENSECOSTPOST: "EXPENSE_COST_POST",
  GLCLOSING: "GL_CLOSING",
  COSTPOOLPOST: "COST_POOL_POST",
  COMMITMENT: "COMMITMENT",
  FIXEDASSETPOST: "FIXED_ASSET_POST",
  PILOB: "PILOB",
  INTERCOMPANYPOST: "INTERCOMPANY_POST",
  APREVALUATION: "AP_REVALUATION",
  ARREVALUATION: "AR_REVALUATION",
  STATISTICALDOCUMENTPOST: "STATISTICAL_DOCUMENT_POST"
};
var PostingGroupModel;
((PostingGroupModel2) => {
  PostingGroupModel2.TypeEnum = {
    DEFAULT: "DEFAULT",
    CUSTOM: "CUSTOM"
  };
})(PostingGroupModel || (PostingGroupModel = {}));
var PostingGroupSourceModel;
((PostingGroupSourceModel2) => {
  PostingGroupSourceModel2.CategoryEnum = {
    BILLED: "BILLED",
    DEFERREDREVENUE: "DEFERRED_REVENUE",
    RECOGNIZEDREVENUE: "RECOGNIZED_REVENUE",
    TAX: "TAX",
    UNBILLED: "UNBILLED",
    LABORCOST: "LABOR_COST",
    LABORCOSTOFFSETEMPLOYEES: "LABOR_COST_OFFSET_EMPLOYEES",
    REVENUEWRITEOFF: "REVENUE_WRITE_OFF",
    FUNDINGCAPADJUSTMENTREVENUE: "FUNDING_CAP_ADJUSTMENT_REVENUE",
    ARDISCOUNTTAKEN: "AR_DISCOUNT_TAKEN",
    ARSMALLBALANCEWRITEOFF: "AR_SMALL_BALANCE_WRITE_OFF",
    ARUNAPPLIEDPAYMENTACCOUNT: "AR_UNAPPLIED_PAYMENT_ACCOUNT",
    ACCOUNTSPAYABLE: "ACCOUNTS_PAYABLE",
    APDISCOUNTTAKEN: "AP_DISCOUNT_TAKEN",
    APUNAPPLIEDPAYMENTACCOUNT: "AP_UNAPPLIED_PAYMENT_ACCOUNT",
    EXPENSEREPORTCOST: "EXPENSE_REPORT_COST",
    EXPENSEREPORTOFFSETREIMBURSABLE: "EXPENSE_REPORT_OFFSET_REIMBURSABLE",
    EXPENSEREPORTOFFSETNONREIMBURSABLE: "EXPENSE_REPORT_OFFSET_NON_REIMBURSABLE",
    LABORCOSTOFFSETSUBCONTRACTORS: "LABOR_COST_OFFSET_SUBCONTRACTORS",
    CROSSCHARGELABOR: "CROSS_CHARGE_LABOR",
    CROSSCHARGELABOROFFSET: "CROSS_CHARGE_LABOR_OFFSET",
    FIXEDFEEADJUSTMENTREVENUE: "FIXED_FEE_ADJUSTMENT_REVENUE",
    RETAINEDEARNINGS: "RETAINED_EARNINGS",
    NETINCOME: "NET_INCOME",
    INVALIDLEGALENTITYBILLINGPOST: "INVALID_LEGAL_ENTITY_BILLING_POST",
    INVALIDLEGALENTITYINVOICECOMPLETION: "INVALID_LEGAL_ENTITY_INVOICE_COMPLETION",
    INVALIDLEGALENTITYLABORCOSTPOST: "INVALID_LEGAL_ENTITY_LABOR_COST_POST",
    INVALIDLEGALENTITYEXPENSECOSTPOST: "INVALID_LEGAL_ENTITY_EXPENSE_COST_POST",
    VIFUNDINGCAPADJUSTMENT: "VI_FUNDING_CAP_ADJUSTMENT",
    INVENTORYASSETACCOUNT: "INVENTORY_ASSET_ACCOUNT",
    INVENTORYSHRINKAGEACCOUNT: "INVENTORY_SHRINKAGE_ACCOUNT",
    INVENTORYPAYABLEACCOUNT: "INVENTORY_PAYABLE_ACCOUNT",
    FIXEDASSET: "FIXED_ASSET",
    FIXEDASSETDEPRECIATIONEXPENSE: "FIXED_ASSET_DEPRECIATION_EXPENSE",
    FIXEDASSETACCUMULATEDDEPRECIATION: "FIXED_ASSET_ACCUMULATED_DEPRECIATION",
    FIXEDASSETDISPOSAL: "FIXED_ASSET_DISPOSAL",
    PILOB: "PILOB",
    FIXEDASSETCASHPROCEEDS: "FIXED_ASSET_CASH_PROCEEDS",
    PILOBCOSTOFFSET: "PILOB_COST_OFFSET",
    DUETO: "DUE_TO",
    DUEFROM: "DUE_FROM",
    INTERCOMPANYREVENUE: "INTERCOMPANY_REVENUE",
    INTERCOMPANYLABORCOST: "INTERCOMPANY_LABOR_COST",
    INTERCOMPANYEXPENSEREPORTCOST: "INTERCOMPANY_EXPENSE_REPORT_COST",
    INTERCOMPANYCOSTALLOCATIONDUEFROMDUETO: "INTERCOMPANY_COST_ALLOCATION_DUE_FROM_DUE_TO",
    UNREALIZEDFOREIGNEXCHANGEGAIN: "UNREALIZED_FOREIGN_EXCHANGE_GAIN",
    UNREALIZEDFOREIGNEXCHANGELOSS: "UNREALIZED_FOREIGN_EXCHANGE_LOSS",
    REALIZEDFOREIGNEXCHANGEGAIN: "REALIZED_FOREIGN_EXCHANGE_GAIN",
    REALIZEDFOREIGNEXCHANGELOSS: "REALIZED_FOREIGN_EXCHANGE_LOSS",
    APREVALUATIONOFFSET: "AP_REVALUATION_OFFSET",
    ARREVALUATIONOFFSET: "AR_REVALUATION_OFFSET",
    TIMESHEETITEMCOST: "TIMESHEET_ITEM_COST",
    TIMESHEETITEMCOSTOFFSET: "TIMESHEET_ITEM_COST_OFFSET"
  };
  PostingGroupSourceModel2.AccountSourceTypeEnum = {
    FIXED: "FIXED",
    VARIABLE: "VARIABLE"
  };
  PostingGroupSourceModel2.OrganizationSourceEnum = {
    LEGALENTITY: "LEGAL_ENTITY",
    PROJECT: "PROJECT",
    PERSON: "PERSON",
    NONE: "NONE",
    FIXEDASSET: "FIXED_ASSET"
  };
})(PostingGroupSourceModel || (PostingGroupSourceModel = {}));
var PrebilledLaborInvoiceSectionFormatCreateModel;
((PrebilledLaborInvoiceSectionFormatCreateModel2) => {
  PrebilledLaborInvoiceSectionFormatCreateModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  PrebilledLaborInvoiceSectionFormatCreateModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  PrebilledLaborInvoiceSectionFormatCreateModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  PrebilledLaborInvoiceSectionFormatCreateModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  PrebilledLaborInvoiceSectionFormatCreateModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(PrebilledLaborInvoiceSectionFormatCreateModel || (PrebilledLaborInvoiceSectionFormatCreateModel = {}));
var PrebilledLaborInvoiceSectionFormatModel;
((PrebilledLaborInvoiceSectionFormatModel2) => {
  PrebilledLaborInvoiceSectionFormatModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  PrebilledLaborInvoiceSectionFormatModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  PrebilledLaborInvoiceSectionFormatModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  PrebilledLaborInvoiceSectionFormatModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  PrebilledLaborInvoiceSectionFormatModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(PrebilledLaborInvoiceSectionFormatModel || (PrebilledLaborInvoiceSectionFormatModel = {}));
var PrebilledLaborOffsetInvoiceSectionFormatCreateModel;
((PrebilledLaborOffsetInvoiceSectionFormatCreateModel2) => {
  PrebilledLaborOffsetInvoiceSectionFormatCreateModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  PrebilledLaborOffsetInvoiceSectionFormatCreateModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  PrebilledLaborOffsetInvoiceSectionFormatCreateModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  PrebilledLaborOffsetInvoiceSectionFormatCreateModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  PrebilledLaborOffsetInvoiceSectionFormatCreateModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(PrebilledLaborOffsetInvoiceSectionFormatCreateModel || (PrebilledLaborOffsetInvoiceSectionFormatCreateModel = {}));
var PrebilledLaborOffsetInvoiceSectionFormatModel;
((PrebilledLaborOffsetInvoiceSectionFormatModel2) => {
  PrebilledLaborOffsetInvoiceSectionFormatModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  PrebilledLaborOffsetInvoiceSectionFormatModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  PrebilledLaborOffsetInvoiceSectionFormatModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  PrebilledLaborOffsetInvoiceSectionFormatModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  PrebilledLaborOffsetInvoiceSectionFormatModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(PrebilledLaborOffsetInvoiceSectionFormatModel || (PrebilledLaborOffsetInvoiceSectionFormatModel = {}));
var ProjectAlertPrefsModel;
((ProjectAlertPrefsModel2) => {
  ProjectAlertPrefsModel2.StateEnum = {
    NONE: "NONE",
    DEFAULT: "DEFAULT",
    CUSTOM: "CUSTOM"
  };
})(ProjectAlertPrefsModel || (ProjectAlertPrefsModel = {}));
var ProjectAlertsModel;
((ProjectAlertsModel2) => {
  ProjectAlertsModel2.TypeEnum = {
    TIME: "TIME",
    HOURBUDGET: "HOUR_BUDGET",
    HOURESTTOT: "HOUR_EST_TOT",
    TOTCOSTBUDGET: "TOT_COST_BUDGET",
    TOTCOSTESTTOT: "TOT_COST_EST_TOT",
    LABORCOSTBUDGET: "LABOR_COST_BUDGET",
    LABORCOSTESTTOT: "LABOR_COST_EST_TOT",
    EXPCOSTBUDGET: "EXP_COST_BUDGET",
    EXPCOSTESTTOT: "EXP_COST_EST_TOT",
    TOTBILLBUDGET: "TOT_BILL_BUDGET",
    TOTBILLESTTOT: "TOT_BILL_EST_TOT",
    FUNDINGEXPENDED: "FUNDING_EXPENDED"
  };
})(ProjectAlertsModel || (ProjectAlertsModel = {}));
var ProjectApproverModel;
((ProjectApproverModel2) => {
  ProjectApproverModel2.ApprovalTypeEnum = {
    LEAVEREQUEST: "LEAVE_REQUEST",
    TIME: "TIME",
    EXPENSEREQUEST: "EXPENSE_REQUEST",
    EXPENSEREPORT: "EXPENSE_REPORT",
    PURCHASEREQUEST: "PURCHASE_REQUEST",
    PURCHASEORDER: "PURCHASE_ORDER",
    VENDORINVOICE: "VENDOR_INVOICE",
    CUSTOMERINVOICE: "CUSTOMER_INVOICE"
  };
})(ProjectApproverModel || (ProjectApproverModel = {}));
var ProjectApproverUpdateModel;
((ProjectApproverUpdateModel2) => {
  ProjectApproverUpdateModel2.ApprovalTypeEnum = {
    LEAVEREQUEST: "LEAVE_REQUEST",
    TIME: "TIME",
    EXPENSEREQUEST: "EXPENSE_REQUEST",
    EXPENSEREPORT: "EXPENSE_REPORT",
    PURCHASEREQUEST: "PURCHASE_REQUEST",
    PURCHASEORDER: "PURCHASE_ORDER",
    VENDORINVOICE: "VENDOR_INVOICE",
    CUSTOMERINVOICE: "CUSTOMER_INVOICE"
  };
})(ProjectApproverUpdateModel || (ProjectApproverUpdateModel = {}));
var ProjectAssignmentCreateModel;
((ProjectAssignmentCreateModel2) => {
  ProjectAssignmentCreateModel2.BillRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  ProjectAssignmentCreateModel2.CostRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
})(ProjectAssignmentCreateModel || (ProjectAssignmentCreateModel = {}));
var ProjectAssignmentModel;
((ProjectAssignmentModel2) => {
  ProjectAssignmentModel2.BillRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  ProjectAssignmentModel2.CostRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
})(ProjectAssignmentModel || (ProjectAssignmentModel = {}));
var ProjectAssignmentUpdateModel;
((ProjectAssignmentUpdateModel2) => {
  ProjectAssignmentUpdateModel2.BillRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  ProjectAssignmentUpdateModel2.CostRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
})(ProjectAssignmentUpdateModel || (ProjectAssignmentUpdateModel = {}));
var ProjectBudgetHistoryModel;
((ProjectBudgetHistoryModel2) => {
  ProjectBudgetHistoryModel2.PctComplRuleEnum = {
    HOURS: "HOURS",
    LABOR: "LABOR",
    TOTAL: "TOTAL",
    TOTALWITHBURDEN: "TOTAL_WITH_BURDEN"
  };
})(ProjectBudgetHistoryModel || (ProjectBudgetHistoryModel = {}));
var ProjectContractModel;
((ProjectContractModel2) => {
  ProjectContractModel2.ColorEnum = {
    GREEN: "GREEN",
    RED: "RED",
    YELLOW: "YELLOW"
  };
})(ProjectContractModel || (ProjectContractModel = {}));
var ProjectControllerModel;
((ProjectControllerModel2) => {
  ProjectControllerModel2.ApprovalTypeEnum = {
    LEAVEREQUEST: "LEAVE_REQUEST",
    TIME: "TIME",
    EXPENSEREQUEST: "EXPENSE_REQUEST",
    EXPENSEREPORT: "EXPENSE_REPORT",
    PURCHASEREQUEST: "PURCHASE_REQUEST",
    PURCHASEORDER: "PURCHASE_ORDER",
    VENDORINVOICE: "VENDOR_INVOICE",
    CUSTOMERINVOICE: "CUSTOMER_INVOICE"
  };
})(ProjectControllerModel || (ProjectControllerModel = {}));
var ProjectCreateModel;
((ProjectCreateModel2) => {
  ProjectCreateModel2.ProjectColorEnum = {
    GREEN: "GREEN",
    RED: "RED",
    YELLOW: "YELLOW"
  };
  ProjectCreateModel2.PctComplRuleEnum = {
    HOURS: "HOURS",
    LABOR: "LABOR",
    TOTAL: "TOTAL",
    TOTALWITHBURDEN: "TOTAL_WITH_BURDEN"
  };
  ProjectCreateModel2.AllowSelfPlanEnum = {
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    ASSIGN: "ASSIGN"
  };
  ProjectCreateModel2.TitoRequiredEnum = {
    USERSETTING: "USER_SETTING",
    REQUIRED: "REQUIRED",
    NOTREQUIRED: "NOT_REQUIRED"
  };
  ProjectCreateModel2.BillRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  ProjectCreateModel2.CostRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  ProjectCreateModel2.UseLaborCategoryEnum = {
    REQUIRED: "REQUIRED",
    FORBIDDEN: "FORBIDDEN",
    OPTIONAL: "OPTIONAL"
  };
})(ProjectCreateModel || (ProjectCreateModel = {}));
var ProjectFeeCreateModel;
((ProjectFeeCreateModel2) => {
  ProjectFeeCreateModel2.FeeFactorTypeEnum = {
    NUMBER: "NUMBER",
    PERCENTAGE: "PERCENTAGE"
  };
})(ProjectFeeCreateModel || (ProjectFeeCreateModel = {}));
var ProjectFeeModel;
((ProjectFeeModel2) => {
  ProjectFeeModel2.FeeFactorTypeEnum = {
    NUMBER: "NUMBER",
    PERCENTAGE: "PERCENTAGE"
  };
})(ProjectFeeModel || (ProjectFeeModel = {}));
var ProjectInvoiceCreateModel;
((ProjectInvoiceCreateModel2) => {
  ProjectInvoiceCreateModel2.InvoiceOptionEnum = {
    STANDALONE: "STANDALONE",
    LEAD: "LEAD",
    CONTRIBUTOR: "CONTRIBUTOR"
  };
  ProjectInvoiceCreateModel2.DeliveryOptionEnum = {
    EMAIL: "EMAIL",
    PRINTMAIL: "PRINT_MAIL"
  };
})(ProjectInvoiceCreateModel || (ProjectInvoiceCreateModel = {}));
var ProjectInvoiceModel;
((ProjectInvoiceModel2) => {
  ProjectInvoiceModel2.InvoiceOptionEnum = {
    STANDALONE: "STANDALONE",
    LEAD: "LEAD",
    CONTRIBUTOR: "CONTRIBUTOR"
  };
  ProjectInvoiceModel2.DeliveryOptionEnum = {
    EMAIL: "EMAIL",
    PRINTMAIL: "PRINT_MAIL"
  };
})(ProjectInvoiceModel || (ProjectInvoiceModel = {}));
var ProjectItemUpdateModel;
((ProjectItemUpdateModel2) => {
  ProjectItemUpdateModel2.BillByEnum = {
    MARKUP: "MARKUP",
    RATE: "RATE"
  };
})(ProjectItemUpdateModel || (ProjectItemUpdateModel = {}));
var ProjectModel;
((ProjectModel2) => {
  ProjectModel2.ProjectColorEnum = {
    GREEN: "GREEN",
    RED: "RED",
    YELLOW: "YELLOW"
  };
  ProjectModel2.PctComplRuleEnum = {
    HOURS: "HOURS",
    LABOR: "LABOR",
    TOTAL: "TOTAL",
    TOTALWITHBURDEN: "TOTAL_WITH_BURDEN"
  };
  ProjectModel2.AllowSelfPlanEnum = {
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    ASSIGN: "ASSIGN"
  };
  ProjectModel2.TitoRequiredEnum = {
    USERSETTING: "USER_SETTING",
    REQUIRED: "REQUIRED",
    NOTREQUIRED: "NOT_REQUIRED"
  };
  ProjectModel2.BillRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  ProjectModel2.CostRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  ProjectModel2.UseLaborCategoryEnum = {
    REQUIRED: "REQUIRED",
    FORBIDDEN: "FORBIDDEN",
    OPTIONAL: "OPTIONAL"
  };
})(ProjectModel || (ProjectModel = {}));
var ProjectPeopleAssignmentSearchModel;
((ProjectPeopleAssignmentSearchModel2) => {
  ProjectPeopleAssignmentSearchModel2.ClassificationEnum = {
    EXEMPT: "EXEMPT",
    NONEXEMPT: "NON_EXEMPT",
    NONEMPLOYEE: "NON_EMPLOYEE",
    SUBCONTRACTOR: "SUBCONTRACTOR"
  };
})(ProjectPeopleAssignmentSearchModel || (ProjectPeopleAssignmentSearchModel = {}));
var ProjectUpdateModel;
((ProjectUpdateModel2) => {
  ProjectUpdateModel2.ProjectColorEnum = {
    GREEN: "GREEN",
    RED: "RED",
    YELLOW: "YELLOW"
  };
  ProjectUpdateModel2.PctComplRuleEnum = {
    HOURS: "HOURS",
    LABOR: "LABOR",
    TOTAL: "TOTAL",
    TOTALWITHBURDEN: "TOTAL_WITH_BURDEN"
  };
  ProjectUpdateModel2.AllowSelfPlanEnum = {
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    ASSIGN: "ASSIGN"
  };
  ProjectUpdateModel2.TitoRequiredEnum = {
    USERSETTING: "USER_SETTING",
    REQUIRED: "REQUIRED",
    NOTREQUIRED: "NOT_REQUIRED"
  };
  ProjectUpdateModel2.BillRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  ProjectUpdateModel2.CostRateSourceEnum = {
    PERSON: "PERSON",
    LABORCATEGORY: "LABOR_CATEGORY",
    OVERRIDE: "OVERRIDE"
  };
  ProjectUpdateModel2.UseLaborCategoryEnum = {
    REQUIRED: "REQUIRED",
    FORBIDDEN: "FORBIDDEN",
    OPTIONAL: "OPTIONAL"
  };
})(ProjectUpdateModel || (ProjectUpdateModel = {}));
var PurchaseOrderCreateModel;
((PurchaseOrderCreateModel2) => {
  PurchaseOrderCreateModel2.ViOverageEnum = {
    L: "L",
    D: "D",
    F: "F"
  };
})(PurchaseOrderCreateModel || (PurchaseOrderCreateModel = {}));
var PurchaseOrderModCreateModel;
((PurchaseOrderModCreateModel2) => {
  PurchaseOrderModCreateModel2.ViOverageEnum = {
    L: "L",
    D: "D",
    F: "F"
  };
})(PurchaseOrderModCreateModel || (PurchaseOrderModCreateModel = {}));
var PurchaseOrderModModel;
((PurchaseOrderModModel2) => {
  PurchaseOrderModModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED",
    APPROVED: "APPROVED",
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    CANCELED: "CANCELED"
  };
  PurchaseOrderModModel2.ViOverageEnum = {
    L: "L",
    D: "D",
    F: "F"
  };
})(PurchaseOrderModModel || (PurchaseOrderModModel = {}));
var PurchaseOrderModel;
((PurchaseOrderModel2) => {
  PurchaseOrderModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED",
    APPROVED: "APPROVED",
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    CANCELED: "CANCELED"
  };
  PurchaseOrderModel2.ViOverageEnum = {
    L: "L",
    D: "D",
    F: "F"
  };
})(PurchaseOrderModel || (PurchaseOrderModel = {}));
var PurchaseOrderSearchModel;
((PurchaseOrderSearchModel2) => {
  PurchaseOrderSearchModel2.DocumentNumberPredicateEnum = {
    EQUALS: "EQUALS",
    EQUALSIGNORECASE: "EQUALS_IGNORE_CASE",
    CONTAINS: "CONTAINS",
    STARTSWITH: "STARTS_WITH",
    ENDSWITH: "ENDS_WITH"
  };
  PurchaseOrderSearchModel2.OriginalDocumentNumberPredicateEnum = {
    EQUALS: "EQUALS",
    EQUALSIGNORECASE: "EQUALS_IGNORE_CASE",
    CONTAINS: "CONTAINS",
    STARTSWITH: "STARTS_WITH",
    ENDSWITH: "ENDS_WITH"
  };
  PurchaseOrderSearchModel2.AssignmentTypeEnum = {
    LABOR: "LABOR",
    EXPENSE: "EXPENSE"
  };
  PurchaseOrderSearchModel2.DocumentStatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED",
    APPROVED: "APPROVED",
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    CANCELED: "CANCELED"
  };
  PurchaseOrderSearchModel2.OriginalDocumentStatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED",
    APPROVED: "APPROVED",
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    CANCELED: "CANCELED"
  };
})(PurchaseOrderSearchModel || (PurchaseOrderSearchModel = {}));
var PurchaseOrderSummaryModel;
((PurchaseOrderSummaryModel2) => {
  PurchaseOrderSummaryModel2.DocumentStatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED",
    APPROVED: "APPROVED",
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    CANCELED: "CANCELED"
  };
  PurchaseOrderSummaryModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED",
    APPROVED: "APPROVED",
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    CANCELED: "CANCELED"
  };
})(PurchaseOrderSummaryModel || (PurchaseOrderSummaryModel = {}));
var PurchaseRequisitionModCreateModel;
((PurchaseRequisitionModCreateModel2) => {
  PurchaseRequisitionModCreateModel2.AmountControlEnum = {
    SUMMARY: "SUMMARY",
    DETAIL: "DETAIL"
  };
})(PurchaseRequisitionModCreateModel || (PurchaseRequisitionModCreateModel = {}));
var PurchaseRequisitionModel;
((PurchaseRequisitionModel2) => {
  PurchaseRequisitionModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED",
    APPROVED: "APPROVED",
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    CANCELED: "CANCELED"
  };
  PurchaseRequisitionModel2.AmountControlEnum = {
    SUMMARY: "SUMMARY",
    DETAIL: "DETAIL"
  };
})(PurchaseRequisitionModel || (PurchaseRequisitionModel = {}));
var PurchaseRequisitionOrigCreateModel;
((PurchaseRequisitionOrigCreateModel2) => {
  PurchaseRequisitionOrigCreateModel2.AmountControlEnum = {
    SUMMARY: "SUMMARY",
    DETAIL: "DETAIL"
  };
})(PurchaseRequisitionOrigCreateModel || (PurchaseRequisitionOrigCreateModel = {}));
var PurchaseRequisitionSearchModel;
((PurchaseRequisitionSearchModel2) => {
  PurchaseRequisitionSearchModel2.DocumentStatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED",
    APPROVED: "APPROVED",
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    CANCELED: "CANCELED"
  };
})(PurchaseRequisitionSearchModel || (PurchaseRequisitionSearchModel = {}));
var PurchaseRequisitionSummaryModel;
((PurchaseRequisitionSummaryModel2) => {
  PurchaseRequisitionSummaryModel2.DocumentStatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED",
    APPROVED: "APPROVED",
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    CANCELED: "CANCELED"
  };
})(PurchaseRequisitionSummaryModel || (PurchaseRequisitionSummaryModel = {}));
var PurchasingApprovalHistoryModel;
((PurchasingApprovalHistoryModel2) => {
  PurchasingApprovalHistoryModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED",
    APPROVED: "APPROVED",
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    CANCELED: "CANCELED"
  };
})(PurchasingApprovalHistoryModel || (PurchasingApprovalHistoryModel = {}));
var PurchasingBalanceModel;
((PurchasingBalanceModel2) => {
  PurchasingBalanceModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED",
    APPROVED: "APPROVED",
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    CANCELED: "CANCELED"
  };
})(PurchasingBalanceModel || (PurchasingBalanceModel = {}));
var ReceivingDocumentModel;
((ReceivingDocumentModel2) => {
  ReceivingDocumentModel2.StatusEnum = {
    INUSE: "INUSE",
    COMPLETED: "COMPLETED",
    RETRACTED: "RETRACTED"
  };
})(ReceivingDocumentModel || (ReceivingDocumentModel = {}));
var ReceivingDocumentSearchModel;
((ReceivingDocumentSearchModel2) => {
  ReceivingDocumentSearchModel2.DocumentNumberPredicateEnum = {
    EQUALS: "EQUALS",
    EQUALSIGNORECASE: "EQUALS_IGNORE_CASE",
    CONTAINS: "CONTAINS",
    STARTSWITH: "STARTS_WITH",
    ENDSWITH: "ENDS_WITH"
  };
  ReceivingDocumentSearchModel2.PoDocumentNumberPredicateEnum = {
    EQUALS: "EQUALS",
    EQUALSIGNORECASE: "EQUALS_IGNORE_CASE",
    CONTAINS: "CONTAINS",
    STARTSWITH: "STARTS_WITH",
    ENDSWITH: "ENDS_WITH"
  };
  ReceivingDocumentSearchModel2.StatusesEnum = {
    INUSE: "INUSE",
    COMPLETED: "COMPLETED",
    RETRACTED: "RETRACTED"
  };
})(ReceivingDocumentSearchModel || (ReceivingDocumentSearchModel = {}));
var ReceivingPurchaseOrderSearchModel;
((ReceivingPurchaseOrderSearchModel2) => {
  ReceivingPurchaseOrderSearchModel2.DocumentNumberPredicateEnum = {
    EQUALS: "EQUALS",
    EQUALSIGNORECASE: "EQUALS_IGNORE_CASE",
    CONTAINS: "CONTAINS",
    STARTSWITH: "STARTS_WITH",
    ENDSWITH: "ENDS_WITH"
  };
})(ReceivingPurchaseOrderSearchModel || (ReceivingPurchaseOrderSearchModel = {}));
var ReportExplanationRequestModel;
((ReportExplanationRequestModel2) => {
  ReportExplanationRequestModel2.IntentEnum = {
    SUMMARIZE: "SUMMARIZE",
    EXPLAIN: "EXPLAIN",
    COMPARE: "COMPARE",
    FINDANOMALIES: "FIND_ANOMALIES",
    RECOMMEND: "RECOMMEND",
    SUMMARIZE2: "SUMMARIZE",
    EXPLAIN2: "EXPLAIN",
    COMPARE2: "COMPARE",
    FIND_ANOMALIES2: "FIND_ANOMALIES",
    RECOMMEND2: "RECOMMEND"
  };
  ReportExplanationRequestModel2.DetailLevelEnum = {
    BRIEF: "BRIEF",
    STANDARD: "STANDARD",
    COMPREHENSIVE: "COMPREHENSIVE",
    BRIEF2: "BRIEF",
    STANDARD2: "STANDARD",
    COMPREHENSIVE2: "COMPREHENSIVE"
  };
})(ReportExplanationRequestModel || (ReportExplanationRequestModel = {}));
var ReportExplanationResponse;
((ReportExplanationResponse2) => {
  ReportExplanationResponse2.AnalyzedIntentEnum = {
    SUMMARIZE: "SUMMARIZE",
    EXPLAIN: "EXPLAIN",
    COMPARE: "COMPARE",
    FINDANOMALIES: "FIND_ANOMALIES",
    RECOMMEND: "RECOMMEND"
  };
})(ReportExplanationResponse || (ReportExplanationResponse = {}));
var SchedulingPersonSearchModel;
((SchedulingPersonSearchModel2) => {
  SchedulingPersonSearchModel2.ApprovalTypesEnum = {
    LEAVEREQUEST: "LEAVE_REQUEST",
    TIME: "TIME",
    EXPENSEREQUEST: "EXPENSE_REQUEST",
    EXPENSEREPORT: "EXPENSE_REPORT",
    PURCHASEREQUEST: "PURCHASE_REQUEST",
    PURCHASEORDER: "PURCHASE_ORDER",
    VENDORINVOICE: "VENDOR_INVOICE",
    CUSTOMERINVOICE: "CUSTOMER_INVOICE"
  };
  SchedulingPersonSearchModel2.ClassificationEnum = {
    EXEMPT: "EXEMPT",
    NONEXEMPT: "NON_EXEMPT",
    NONEMPLOYEE: "NON_EMPLOYEE",
    SUBCONTRACTOR: "SUBCONTRACTOR"
  };
})(SchedulingPersonSearchModel || (SchedulingPersonSearchModel = {}));
var SectionFilter;
((SectionFilter2) => {
  SectionFilter2.TypeEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    EXPENSETYPE: "EXPENSE_TYPE",
    LABORCATEGORY: "LABOR_CATEGORY",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    BASECOSTELEMENT: "BASE_COST_ELEMENT",
    BASECOSTPLUSELEMENTTYPE: "BASE_COST_PLUS_ELEMENT_TYPE",
    DOCUMENTTYPE: "DOCUMENT_TYPE",
    BILLBYMETHODTYPE: "BILL_BY_METHOD_TYPE"
  };
})(SectionFilter || (SectionFilter = {}));
var StatisticalAccountJournalEntryModel;
((StatisticalAccountJournalEntryModel2) => {
  StatisticalAccountJournalEntryModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED"
  };
})(StatisticalAccountJournalEntryModel || (StatisticalAccountJournalEntryModel = {}));
var StatisticalAccountJournalEntrySearchModel;
((StatisticalAccountJournalEntrySearchModel2) => {
  StatisticalAccountJournalEntrySearchModel2.StatusesEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED"
  };
  StatisticalAccountJournalEntrySearchModel2.DocumentReversalOptionsEnum = {
    NONVOID: "NON_VOID",
    VOIDING: "VOIDING",
    VOIDED: "VOIDED"
  };
})(StatisticalAccountJournalEntrySearchModel || (StatisticalAccountJournalEntrySearchModel = {}));
var StatusType;
((StatusType2) => {
  StatusType2.FamilyEnum = {
    INFORMATIONAL: "INFORMATIONAL",
    SUCCESSFUL: "SUCCESSFUL",
    REDIRECTION: "REDIRECTION",
    CLIENTERROR: "CLIENT_ERROR",
    SERVERERROR: "SERVER_ERROR",
    OTHER: "OTHER"
  };
})(StatusType || (StatusType = {}));
var TaskCreateModel;
((TaskCreateModel2) => {
  TaskCreateModel2.AllowTimeEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
  TaskCreateModel2.AllowExpenseEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
  TaskCreateModel2.AllowItemsEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
  TaskCreateModel2.TsSubPoRequiredEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
  TaskCreateModel2.ExpSubPoRequiredEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
})(TaskCreateModel || (TaskCreateModel = {}));
var TaskDependencyCreateModel;
((TaskDependencyCreateModel2) => {
  TaskDependencyCreateModel2.TypeEnum = {
    FS: "FS",
    SS: "SS",
    FF: "FF",
    SF: "SF"
  };
})(TaskDependencyCreateModel || (TaskDependencyCreateModel = {}));
var TaskDependencyModel;
((TaskDependencyModel2) => {
  TaskDependencyModel2.TypeEnum = {
    FS: "FS",
    SS: "SS",
    FF: "FF",
    SF: "SF"
  };
})(TaskDependencyModel || (TaskDependencyModel = {}));
var TaskModel;
((TaskModel2) => {
  TaskModel2.AllowTimeEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
  TaskModel2.TsSubPoRequiredEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
  TaskModel2.AllowExpenseEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
  TaskModel2.ExpSubPoRequiredEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
  TaskModel2.AllowItemsEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
})(TaskModel || (TaskModel = {}));
var TaskMoveModel;
((TaskMoveModel2) => {
  TaskMoveModel2.RelativePositionEnum = {
    CHILD: "CHILD",
    BEFORE: "BEFORE",
    AFTER: "AFTER"
  };
})(TaskMoveModel || (TaskMoveModel = {}));
var TaskSummaryModel;
((TaskSummaryModel2) => {
  TaskSummaryModel2.AllowItemsEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
})(TaskSummaryModel || (TaskSummaryModel = {}));
var TaskUpdateModel;
((TaskUpdateModel2) => {
  TaskUpdateModel2.AllowTimeEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
  TaskUpdateModel2.TsSubPoRequiredEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
  TaskUpdateModel2.AllowExpenseEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
  TaskUpdateModel2.ExpSubPoRequiredEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
  TaskUpdateModel2.AllowItemsEnum = {
    DEFAULTTOPROJECT: "DEFAULT_TO_PROJECT",
    YES: "YES",
    NO: "NO"
  };
})(TaskUpdateModel || (TaskUpdateModel = {}));
var TaxInvoiceSectionFormatCreateModel;
((TaxInvoiceSectionFormatCreateModel2) => {
  TaxInvoiceSectionFormatCreateModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  TaxInvoiceSectionFormatCreateModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  TaxInvoiceSectionFormatCreateModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  TaxInvoiceSectionFormatCreateModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  TaxInvoiceSectionFormatCreateModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(TaxInvoiceSectionFormatCreateModel || (TaxInvoiceSectionFormatCreateModel = {}));
var TaxInvoiceSectionFormatModel;
((TaxInvoiceSectionFormatModel2) => {
  TaxInvoiceSectionFormatModel2.TypeEnum = {
    COST: "COST",
    EXPENSE: "EXPENSE",
    FIXEDPRICE: "FIXED_PRICE",
    LABOR: "LABOR",
    ONETIME: "ONETIME",
    PREBILL: "PREBILL",
    PREBILLOFFSET: "PREBILL_OFFSET",
    TAX: "TAX",
    FUNDEDVALUEADJUSTMENT: "FUNDED_VALUE_ADJUSTMENT"
  };
  TaxInvoiceSectionFormatModel2.Col1FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  TaxInvoiceSectionFormatModel2.Col2FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  TaxInvoiceSectionFormatModel2.Col3FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
  TaxInvoiceSectionFormatModel2.Col4FieldEnum = {
    NONE: "NONE",
    COSTELEMENT: "COST_ELEMENT",
    COSTPLUSELEMENTTYPE: "COST_PLUS_ELEMENT_TYPE",
    DESCRIPTION: "DESCRIPTION",
    EXPENSETYPE: "EXPENSE_TYPE",
    FEEMETHODNAME: "FEE_METHOD_NAME",
    LABORCATEGORY: "LABOR_CATEGORY",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    ONETIMECHARGETYPE: "ONETIME_CHARGE_TYPE",
    PAYCODE: "PAY_CODE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    VENDOR: "VENDOR",
    DOCUMENTNUMBER: "DOCUMENT_NUMBER",
    LOCATIONREFERENCE: "LOCATION_REFERENCE",
    ITEMCODE: "ITEM_CODE",
    ITEMNAME: "ITEM_NAME"
  };
})(TaxInvoiceSectionFormatModel || (TaxInvoiceSectionFormatModel = {}));
var TimeExtractModel;
((TimeExtractModel2) => {
  TimeExtractModel2.AdjustmentOptionEnum = {
    NONE: "NONE",
    INCLUDE: "INCLUDE",
    ONLY: "ONLY"
  };
})(TimeExtractModel || (TimeExtractModel = {}));
var TimePeriodAvailabilityModel;
((TimePeriodAvailabilityModel2) => {
  TimePeriodAvailabilityModel2.UnavailableReasonEnum = {
    BEYONDCUTOFFDATE: "BEYOND_CUTOFF_DATE",
    EXCEEDSMAXFUTUREPERIODS: "EXCEEDS_MAX_FUTURE_PERIODS",
    BEFORESTARTDATE: "BEFORE_START_DATE"
  };
})(TimePeriodAvailabilityModel || (TimePeriodAvailabilityModel = {}));
var TimePeriodSetupCreateModel;
((TimePeriodSetupCreateModel2) => {
  TimePeriodSetupCreateModel2.TypeEnum = {
    BIWEEKLY: "BIWEEKLY",
    BIWEEKLYOVERLAP: "BIWEEKLY_OVERLAP",
    MONTHLY: "MONTHLY",
    SEMIMONTHLY: "SEMIMONTHLY",
    WEEKLY: "WEEKLY",
    WEEKLYOVERLAP: "WEEKLY_OVERLAP"
  };
})(TimePeriodSetupCreateModel || (TimePeriodSetupCreateModel = {}));
var TimePeriodSetupModel;
((TimePeriodSetupModel2) => {
  TimePeriodSetupModel2.TypeEnum = {
    BIWEEKLY: "BIWEEKLY",
    BIWEEKLYOVERLAP: "BIWEEKLY_OVERLAP",
    MONTHLY: "MONTHLY",
    SEMIMONTHLY: "SEMIMONTHLY",
    WEEKLY: "WEEKLY",
    WEEKLYOVERLAP: "WEEKLY_OVERLAP"
  };
})(TimePeriodSetupModel || (TimePeriodSetupModel = {}));
var TimeStatusHistoryModel;
((TimeStatusHistoryModel2) => {
  TimeStatusHistoryModel2.StatusEnum = {
    NEW: "NEW",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED"
  };
  TimeStatusHistoryModel2.AdjustmentStatusEnum = {
    NEW: "NEW",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED"
  };
})(TimeStatusHistoryModel || (TimeStatusHistoryModel = {}));
var TimesheetListModel;
((TimesheetListModel2) => {
  TimesheetListModel2.StatusEnum = {
    NEW: "NEW",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED"
  };
  TimesheetListModel2.AdjustmentStatusEnum = {
    NEW: "NEW",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED"
  };
})(TimesheetListModel || (TimesheetListModel = {}));
var TimesheetModel;
((TimesheetModel2) => {
  TimesheetModel2.StatusEnum = {
    NEW: "NEW",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED"
  };
  TimesheetModel2.AdjustmentStatusEnum = {
    NEW: "NEW",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED"
  };
  TimesheetModel2.LastDrawerStateEnum = {
    DURATION: "DURATION",
    TITO: "TITO"
  };
})(TimesheetModel || (TimesheetModel = {}));
var TimesheetOwnerModel;
((TimesheetOwnerModel2) => {
  TimesheetOwnerModel2.TitoRequiredEnum = {
    NOTREQUIRED: "NOT_REQUIRED",
    PROJECT: "PROJECT",
    DAILY: "DAILY"
  };
})(TimesheetOwnerModel || (TimesheetOwnerModel = {}));
var TimesheetProjectModel;
((TimesheetProjectModel2) => {
  TimesheetProjectModel2.UseLaborCategoryEnum = {
    REQUIRED: "REQUIRED",
    FORBIDDEN: "FORBIDDEN",
    OPTIONAL: "OPTIONAL"
  };
  TimesheetProjectModel2.TitoRequiredEnum = {
    USERSETTING: "USER_SETTING",
    REQUIRED: "REQUIRED",
    NOTREQUIRED: "NOT_REQUIRED"
  };
})(TimesheetProjectModel || (TimesheetProjectModel = {}));
var TimesheetSearchModel;
((TimesheetSearchModel2) => {
  TimesheetSearchModel2.StatusesEnum = {
    NEW: "NEW",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED"
  };
  TimesheetSearchModel2.AdjustmentStatusesEnum = {
    NEW: "NEW",
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    DISAPPROVED: "DISAPPROVED",
    APPROVING: "APPROVING",
    COMPLETED: "COMPLETED",
    EXTRACTED: "EXTRACTED",
    LOCKED: "LOCKED"
  };
  TimesheetSearchModel2.SortByEnum = {
    BEGINDATE: "BEGIN_DATE",
    HOURS: "HOURS",
    STATUS: "STATUS",
    CONTROLLER: "CONTROLLER"
  };
  TimesheetSearchModel2.SortOrderEnum = {
    ASC: "ASC",
    DESC: "DESC"
  };
})(TimesheetSearchModel || (TimesheetSearchModel = {}));
var TimesheetUpdateModel;
((TimesheetUpdateModel2) => {
  TimesheetUpdateModel2.LastDrawerStateEnum = {
    DURATION: "DURATION",
    TITO: "TITO"
  };
})(TimesheetUpdateModel || (TimesheetUpdateModel = {}));
var UdfMetadataModel;
((UdfMetadataModel2) => {
  UdfMetadataModel2.DataTypeEnum = {
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    STRING: "STRING",
    LIST: "LIST",
    URL: "URL"
  };
  UdfMetadataModel2.VisibilityEnum = {
    NONE: "NONE",
    DISABLED: "DISABLED",
    ENABLED: "ENABLED"
  };
})(UdfMetadataModel || (UdfMetadataModel = {}));
var VendorInvoiceExpenseModel;
((VendorInvoiceExpenseModel2) => {
  VendorInvoiceExpenseModel2.PwpMatchingTypeEnum = {
    AUTO: "AUTO",
    MANUAL: "MANUAL",
    NA: "NA"
  };
})(VendorInvoiceExpenseModel || (VendorInvoiceExpenseModel = {}));
var VendorInvoiceFormatSectionModel;
((VendorInvoiceFormatSectionModel2) => {
  VendorInvoiceFormatSectionModel2.TypeEnum = {
    LABORDETAILS: "LABOR_DETAILS",
    EXPENSEDETAILS: "EXPENSE_DETAILS",
    MATCHEDLABOR: "MATCHED_LABOR",
    MATCHEDEXPENSES: "MATCHED_EXPENSES",
    ITEMDETAILS: "ITEM_DETAILS",
    POFUNDINGCAPADJUSTMENTS: "PO_FUNDING_CAP_ADJUSTMENTS"
  };
  VendorInvoiceFormatSectionModel2.Col1FieldEnum = {
    NONE: "NONE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    EXPENSETYPE: "EXPENSE_TYPE",
    EXPENSEDOCUMENTNUMBER: "EXPENSE_DOCUMENT_NUMBER",
    LABORCATEGORYNAME: "LABOR_CATEGORY_NAME",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    PURCHASEORDER: "PURCHASE_ORDER",
    PURCHASEORDERLINE: "PURCHASE_ORDER_LINE",
    ITEM: "ITEM",
    DESCRIPTION: "DESCRIPTION",
    PURCHASEORDERLINEREFERENCE: "PURCHASE_ORDER_LINE_REFERENCE"
  };
  VendorInvoiceFormatSectionModel2.Col2FieldEnum = {
    NONE: "NONE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    EXPENSETYPE: "EXPENSE_TYPE",
    EXPENSEDOCUMENTNUMBER: "EXPENSE_DOCUMENT_NUMBER",
    LABORCATEGORYNAME: "LABOR_CATEGORY_NAME",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    PURCHASEORDER: "PURCHASE_ORDER",
    PURCHASEORDERLINE: "PURCHASE_ORDER_LINE",
    ITEM: "ITEM",
    DESCRIPTION: "DESCRIPTION",
    PURCHASEORDERLINEREFERENCE: "PURCHASE_ORDER_LINE_REFERENCE"
  };
  VendorInvoiceFormatSectionModel2.Col3FieldEnum = {
    NONE: "NONE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    EXPENSETYPE: "EXPENSE_TYPE",
    EXPENSEDOCUMENTNUMBER: "EXPENSE_DOCUMENT_NUMBER",
    LABORCATEGORYNAME: "LABOR_CATEGORY_NAME",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    PURCHASEORDER: "PURCHASE_ORDER",
    PURCHASEORDERLINE: "PURCHASE_ORDER_LINE",
    ITEM: "ITEM",
    DESCRIPTION: "DESCRIPTION",
    PURCHASEORDERLINEREFERENCE: "PURCHASE_ORDER_LINE_REFERENCE"
  };
  VendorInvoiceFormatSectionModel2.Col4FieldEnum = {
    NONE: "NONE",
    PERSON: "PERSON",
    PROJECT: "PROJECT",
    TASK: "TASK",
    EXPENSETYPE: "EXPENSE_TYPE",
    EXPENSEDOCUMENTNUMBER: "EXPENSE_DOCUMENT_NUMBER",
    LABORCATEGORYNAME: "LABOR_CATEGORY_NAME",
    LABORCATEGORYDESCRIPTION: "LABOR_CATEGORY_DESCRIPTION",
    LOCATION: "LOCATION",
    PURCHASEORDER: "PURCHASE_ORDER",
    PURCHASEORDERLINE: "PURCHASE_ORDER_LINE",
    ITEM: "ITEM",
    DESCRIPTION: "DESCRIPTION",
    PURCHASEORDERLINEREFERENCE: "PURCHASE_ORDER_LINE_REFERENCE"
  };
})(VendorInvoiceFormatSectionModel || (VendorInvoiceFormatSectionModel = {}));
var VendorInvoiceFormatSectionTotalGroupModel;
((VendorInvoiceFormatSectionTotalGroupModel2) => {
  VendorInvoiceFormatSectionTotalGroupModel2.TypeEnum = {
    LABORDETAILS: "LABOR_DETAILS",
    EXPENSEDETAILS: "EXPENSE_DETAILS",
    MATCHEDLABOR: "MATCHED_LABOR",
    MATCHEDEXPENSES: "MATCHED_EXPENSES",
    ITEMDETAILS: "ITEM_DETAILS",
    POFUNDINGCAPADJUSTMENTS: "PO_FUNDING_CAP_ADJUSTMENTS"
  };
})(VendorInvoiceFormatSectionTotalGroupModel || (VendorInvoiceFormatSectionTotalGroupModel = {}));
var VendorInvoiceItemModel;
((VendorInvoiceItemModel2) => {
  VendorInvoiceItemModel2.PwpMatchingTypeEnum = {
    AUTO: "AUTO",
    MANUAL: "MANUAL",
    NA: "NA"
  };
})(VendorInvoiceItemModel || (VendorInvoiceItemModel = {}));
var VendorInvoiceLaborModel;
((VendorInvoiceLaborModel2) => {
  VendorInvoiceLaborModel2.PwpMatchingTypeEnum = {
    AUTO: "AUTO",
    MANUAL: "MANUAL",
    NA: "NA"
  };
})(VendorInvoiceLaborModel || (VendorInvoiceLaborModel = {}));
var VendorInvoiceLaborProjectModel;
((VendorInvoiceLaborProjectModel2) => {
  VendorInvoiceLaborProjectModel2.UseLaborCategoryEnum = {
    REQUIRED: "REQUIRED",
    FORBIDDEN: "FORBIDDEN",
    OPTIONAL: "OPTIONAL"
  };
})(VendorInvoiceLaborProjectModel || (VendorInvoiceLaborProjectModel = {}));
var VendorInvoiceMatchedExpenseElementModel;
((VendorInvoiceMatchedExpenseElementModel2) => {
  VendorInvoiceMatchedExpenseElementModel2.PwpMatchingTypeEnum = {
    AUTO: "AUTO",
    MANUAL: "MANUAL",
    NA: "NA"
  };
})(VendorInvoiceMatchedExpenseElementModel || (VendorInvoiceMatchedExpenseElementModel = {}));
var VendorInvoiceMatchedItemElementModel;
((VendorInvoiceMatchedItemElementModel2) => {
  VendorInvoiceMatchedItemElementModel2.PwpMatchingTypeEnum = {
    AUTO: "AUTO",
    MANUAL: "MANUAL",
    NA: "NA"
  };
})(VendorInvoiceMatchedItemElementModel || (VendorInvoiceMatchedItemElementModel = {}));
var VendorInvoiceMatchedLaborElementModel;
((VendorInvoiceMatchedLaborElementModel2) => {
  VendorInvoiceMatchedLaborElementModel2.PwpMatchingTypeEnum = {
    AUTO: "AUTO",
    MANUAL: "MANUAL",
    NA: "NA"
  };
})(VendorInvoiceMatchedLaborElementModel || (VendorInvoiceMatchedLaborElementModel = {}));
var VendorInvoiceSearchModel;
((VendorInvoiceSearchModel2) => {
  VendorInvoiceSearchModel2.ReferencePredicateEnum = {
    EQUALS: "EQUALS",
    EQUALSIGNORECASE: "EQUALS_IGNORE_CASE",
    CONTAINS: "CONTAINS",
    STARTSWITH: "STARTS_WITH",
    ENDSWITH: "ENDS_WITH"
  };
  VendorInvoiceSearchModel2.StatusesEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED",
    APPROVED: "APPROVED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED"
  };
  VendorInvoiceSearchModel2.SortOrderEnum = {
    ASC: "ASC",
    DESC: "DESC"
  };
})(VendorInvoiceSearchModel || (VendorInvoiceSearchModel = {}));
var VendorInvoiceSummaryListModel;
((VendorInvoiceSummaryListModel2) => {
  VendorInvoiceSummaryListModel2.DocumentTypeEnum = {
    VENDORINVOICE: "VENDOR_INVOICE",
    VENDORPAYMENT: "VENDOR_PAYMENT",
    CUSTOMERPAYMENT: "CUSTOMER_PAYMENT",
    DEPOSIT: "DEPOSIT",
    JOURNALENTRY: "JOURNAL_ENTRY",
    INTERCOMPANYJOURNALENTRY: "INTERCOMPANY_JOURNAL_ENTRY",
    INTERCOMPANYVENDORINVOICE: "INTERCOMPANY_VENDOR_INVOICE"
  };
  VendorInvoiceSummaryListModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED",
    APPROVED: "APPROVED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED"
  };
})(VendorInvoiceSummaryListModel || (VendorInvoiceSummaryListModel = {}));
var VendorInvoiceSummaryModel;
((VendorInvoiceSummaryModel2) => {
  VendorInvoiceSummaryModel2.DocumentTypeEnum = {
    VENDORINVOICE: "VENDOR_INVOICE",
    VENDORPAYMENT: "VENDOR_PAYMENT",
    CUSTOMERPAYMENT: "CUSTOMER_PAYMENT",
    DEPOSIT: "DEPOSIT",
    JOURNALENTRY: "JOURNAL_ENTRY",
    INTERCOMPANYJOURNALENTRY: "INTERCOMPANY_JOURNAL_ENTRY",
    INTERCOMPANYVENDORINVOICE: "INTERCOMPANY_VENDOR_INVOICE"
  };
  VendorInvoiceSummaryModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED",
    APPROVED: "APPROVED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED"
  };
})(VendorInvoiceSummaryModel || (VendorInvoiceSummaryModel = {}));
var VendorPaymentIncludedModel;
((VendorPaymentIncludedModel2) => {
  VendorPaymentIncludedModel2.DocumentTypeEnum = {
    VENDORPAYMENT: "VENDOR_PAYMENT",
    VENDORINVOICE: "VENDOR_INVOICE"
  };
})(VendorPaymentIncludedModel || (VendorPaymentIncludedModel = {}));
var VendorPaymentModel;
((VendorPaymentModel2) => {
  VendorPaymentModel2.DocumentTypeEnum = {
    VENDORINVOICE: "VENDOR_INVOICE",
    VENDORPAYMENT: "VENDOR_PAYMENT",
    CUSTOMERPAYMENT: "CUSTOMER_PAYMENT",
    DEPOSIT: "DEPOSIT",
    JOURNALENTRY: "JOURNAL_ENTRY",
    INTERCOMPANYJOURNALENTRY: "INTERCOMPANY_JOURNAL_ENTRY",
    INTERCOMPANYVENDORINVOICE: "INTERCOMPANY_VENDOR_INVOICE"
  };
  VendorPaymentModel2.StatusEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED",
    APPROVED: "APPROVED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED"
  };
})(VendorPaymentModel || (VendorPaymentModel = {}));
var VendorPaymentSearchModel;
((VendorPaymentSearchModel2) => {
  VendorPaymentSearchModel2.StatusesEnum = {
    INUSE: "INUSE",
    SUBMITTED: "SUBMITTED",
    POSTED: "POSTED",
    APPROVED: "APPROVED",
    APPROVING: "APPROVING",
    DISAPPROVED: "DISAPPROVED"
  };
})(VendorPaymentSearchModel || (VendorPaymentSearchModel = {}));
var LineState = /* @__PURE__ */ ((LineState2) => {
  LineState2["OPEN"] = "OPEN";
  LineState2["CLOSED"] = "CLOSED";
  return LineState2;
})(LineState || {});
const MAX_PLATFORM_PAGE_SIZE = 2e3;
const emptyListPage = (page = 1, pageSize2 = 50) => ({
  page,
  pageSize: pageSize2,
  pageCount: 0,
  resultCount: 0,
  items: []
});
const mapListPage = (page, fn3) => ({ ...page, items: page.items.map(fn3) });
const isLastPage = ({ page, pageCount }) => {
  return pageCount === 0 || page === pageCount;
};
const fetchAccounts$1 = async ({
  entryAllowed = true,
  includeInactive,
  page = 1,
  pageSize: pageSize2 = 5e3,
  type
}) => get$1(
  url("/accounts", { entryAllowed, includeInactive, page, pageSize: pageSize2, type })
);
const accounts = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchAccounts: fetchAccounts$1
}, Symbol.toStringTag, { value: "Module" }));
const getClinChanges$1 = async ({
  contractKey,
  modNumber,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(
    `/contracts/${contractKey}/advanced-funding-mods/${modNumber}/clin-changes`,
    { page, pageSize: pageSize2 }
  )
);
const createClinChange$1 = async ({
  contractKey,
  modNumber,
  requestBody
}) => post(
  `/contracts/${contractKey}/advanced-funding-mods/${modNumber}/clin-changes`,
  requestBody
);
const updateClinChange$1 = async ({
  contractKey,
  modNumber,
  clinModKey,
  requestBody
}) => put(
  `/contracts/${contractKey}/advanced-funding-mods/${modNumber}/clin-changes/${clinModKey}`,
  requestBody
);
const deleteClinChange$1 = async ({
  contractKey,
  modNumber,
  clinModKey
}) => destroy(
  `/contracts/${contractKey}/advanced-funding-mods/${modNumber}/clin-changes/${clinModKey}`
);
const advFundClinChanges = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createClinChange: createClinChange$1,
  deleteClinChange: deleteClinChange$1,
  getClinChanges: getClinChanges$1,
  updateClinChange: updateClinChange$1
}, Symbol.toStringTag, { value: "Module" }));
const getAdvFundMods$1 = async ({
  contractKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/contracts/${contractKey}/advanced-funding-mods`, { page, pageSize: pageSize2 })
);
const getAdvFundMod$1 = async ({
  contractKey,
  modNumber
}) => get$1(
  `/contracts/${contractKey}/advanced-funding-mods/${modNumber}`
);
const createAdvFundMod$1 = async ({
  contractKey,
  requestBody
}) => post(
  `/contracts/${contractKey}/advanced-funding-mods`,
  requestBody
);
const updateAdvFundMod$1 = async ({
  contractKey,
  modNumber,
  requestBody
}) => put(
  `/contracts/${contractKey}/advanced-funding-mods/${modNumber}`,
  requestBody
);
const deleteAdvFundMod$1 = async ({
  contractKey,
  modNumber
}) => destroy(`/contracts/${contractKey}/advanced-funding-mods/${modNumber}`);
const submitAdvFundModForReview$1 = async ({
  contractKey,
  modNumber
}) => post(
  `/contracts/${contractKey}/advanced-funding-mods/${modNumber}/submit-for-review`
);
const returnAdvFundModToDraft$1 = async ({
  contractKey,
  modNumber
}) => post(
  `/contracts/${contractKey}/advanced-funding-mods/${modNumber}/return-to-draft`
);
const commitAdvFundMod$1 = async ({
  contractKey,
  modNumber
}) => post(
  `/contracts/${contractKey}/advanced-funding-mods/${modNumber}/commit`
);
const getAdvFundModSummary$1 = async ({
  contractKey,
  modNumber
}) => get$1(
  `/contracts/${contractKey}/advanced-funding-mods/${modNumber}/summary`
);
const advFundContractMods = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  commitAdvFundMod: commitAdvFundMod$1,
  createAdvFundMod: createAdvFundMod$1,
  deleteAdvFundMod: deleteAdvFundMod$1,
  getAdvFundMod: getAdvFundMod$1,
  getAdvFundModSummary: getAdvFundModSummary$1,
  getAdvFundMods: getAdvFundMods$1,
  returnAdvFundModToDraft: returnAdvFundModToDraft$1,
  submitAdvFundModForReview: submitAdvFundModForReview$1,
  updateAdvFundMod: updateAdvFundMod$1
}, Symbol.toStringTag, { value: "Module" }));
const getSlinChanges$1 = async ({
  contractKey,
  modNumber,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(
    `/contracts/${contractKey}/advanced-funding-mods/${modNumber}/slin-changes`,
    { page, pageSize: pageSize2 }
  )
);
const createSlinChange$1 = async ({
  contractKey,
  modNumber,
  requestBody
}) => post(
  `/contracts/${contractKey}/advanced-funding-mods/${modNumber}/slin-changes`,
  requestBody
);
const updateSlinChange$1 = async ({
  contractKey,
  modNumber,
  slinModKey,
  requestBody
}) => put(
  `/contracts/${contractKey}/advanced-funding-mods/${modNumber}/slin-changes/${slinModKey}`,
  requestBody
);
const deleteSlinChange$1 = async ({
  contractKey,
  modNumber,
  slinModKey
}) => destroy(
  `/contracts/${contractKey}/advanced-funding-mods/${modNumber}/slin-changes/${slinModKey}`
);
const advFundSlinChanges = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createSlinChange: createSlinChange$1,
  deleteSlinChange: deleteSlinChange$1,
  getSlinChanges: getSlinChanges$1,
  updateSlinChange: updateSlinChange$1
}, Symbol.toStringTag, { value: "Module" }));
const addApprovalGroup = async (approvalGroup2) => post(`/approval-groups`, approvalGroup2);
const deleteApprovalGroup$1 = async (id) => destroy(`/approval-groups/${id}`);
const fetchApproversForApprovalGroup = async ({
  approvalGroupKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/approval-groups/${approvalGroupKey}/approvers`, {
    page,
    pageSize: pageSize2
  })
);
const fetchApprovalGroup = async ({ id }) => get$1(`/approval-groups/${id}`);
const fetchProjectSubmittersForApprovalGroup = async (id, page = 1, pageSize2 = 50) => get$1(
  url(`/approval-groups/${id}/ci-submitting-projects`, { page, pageSize: pageSize2 })
);
const fetchApprovalGroupsByType = async ({
  approvalGroupType,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/approval-groups`, { approvalGroupType, page, pageSize: pageSize2 })
);
const searchApprovalGroups = async (searchBody, page = 1, pageSize2 = 50) => post(
  url(`/approval-groups/search`, {
    page,
    pageSize: pageSize2
  }),
  searchBody
);
const updateApprovers = async (approvers, id) => put(`/approval-groups/${id}/approvers`, approvers);
const updateApprovalGroup = async (id, approvalGroup2) => put(`/approval-groups/${id}`, approvalGroup2);
const approvalGroup = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addApprovalGroup,
  deleteApprovalGroup: deleteApprovalGroup$1,
  fetchApprovalGroup,
  fetchApprovalGroupsByType,
  fetchApproversForApprovalGroup,
  fetchProjectSubmittersForApprovalGroup,
  searchApprovalGroups,
  updateApprovalGroup,
  updateApprovers
}, Symbol.toStringTag, { value: "Module" }));
const searchAssignedTimeMatrix$1 = async (requestBody) => post("/assigning/matrix", requestBody);
const searchAssignedTimePeopleAllocation$1 = async (requestBody) => post(
  "/assigning/people/allocation",
  requestBody
);
const searchAssignedTimePeople$1 = async ({
  requestBody,
  page = 1,
  pageSize: pageSize2 = 50
}) => post(
  url("/assigning/people", { page, pageSize: pageSize2 }),
  requestBody
);
const searchAssignedTimeProjects$1 = async ({
  requestBody,
  page = 1,
  pageSize: pageSize2 = 50
}) => post(
  url("/assigning/projects", { page, pageSize: pageSize2 }),
  requestBody
);
const createAssignedTimeSaveCriteria$1 = async ({
  requestBody,
  dashboards: dashboards2
}) => post(
  url("/assigning/matrix/criteria", { dashboard: dashboards2 }),
  requestBody
);
const createAssignedTimeSharedSaveCriteria$1 = async (requestBody) => post("/assigning/matrix/criteria/share", requestBody);
const deleteAssignedTimeSaveCriteria$1 = async (id) => destroy(`/assigning/matrix/criteria/${id}`);
const deleteAssignedTimeSharedSaveCriteria$1 = async (id) => destroy(`/assigning/matrix/criteria/${id}/share`);
const getAssignedTimePersonOrganizations$1 = async ({
  code,
  projectKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/assigning/person/organizations", {
    page,
    pageSize: pageSize2,
    code,
    projectKey
  })
);
const getAssignedTimeProjectOrganizations$1 = async ({
  code,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/assigning/projects/organizations", {
    page,
    pageSize: pageSize2,
    code
  })
);
const getAssignedTimeSaveCriteria$1 = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/assigning/matrix/criteria", { page, pageSize: pageSize2 })
);
const getAssignedTimeSharedSaveCriteria$1 = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/assigning/matrix/criteria/share", { page, pageSize: pageSize2 })
);
const getProjectAssignmentDefaults$1 = async ({
  projectKey,
  personKey,
  date
}) => get$1(
  `/assigning/defaults/project/${projectKey}/person/${personKey}/${date}`
);
const updateAssignedTimeSaveCriteria$1 = async ({
  dashboards: dashboards2,
  id,
  requestBody
}) => put(
  url(`/assigning/matrix/criteria/${id}`, { dashboard: dashboards2 }),
  requestBody
);
const updateAssignedTimeSharedSaveCriteria$1 = async ({
  id,
  requestBody
}) => put(`/assigning/matrix/criteria/${id}/share`, requestBody);
const assigning = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createAssignedTimeSaveCriteria: createAssignedTimeSaveCriteria$1,
  createAssignedTimeSharedSaveCriteria: createAssignedTimeSharedSaveCriteria$1,
  deleteAssignedTimeSaveCriteria: deleteAssignedTimeSaveCriteria$1,
  deleteAssignedTimeSharedSaveCriteria: deleteAssignedTimeSharedSaveCriteria$1,
  getAssignedTimePersonOrganizations: getAssignedTimePersonOrganizations$1,
  getAssignedTimeProjectOrganizations: getAssignedTimeProjectOrganizations$1,
  getAssignedTimeSaveCriteria: getAssignedTimeSaveCriteria$1,
  getAssignedTimeSharedSaveCriteria: getAssignedTimeSharedSaveCriteria$1,
  getProjectAssignmentDefaults: getProjectAssignmentDefaults$1,
  searchAssignedTimeMatrix: searchAssignedTimeMatrix$1,
  searchAssignedTimePeople: searchAssignedTimePeople$1,
  searchAssignedTimePeopleAllocation: searchAssignedTimePeopleAllocation$1,
  searchAssignedTimeProjects: searchAssignedTimeProjects$1,
  updateAssignedTimeSaveCriteria: updateAssignedTimeSaveCriteria$1,
  updateAssignedTimeSharedSaveCriteria: updateAssignedTimeSharedSaveCriteria$1
}, Symbol.toStringTag, { value: "Module" }));
const downloadAuditLogs$1 = async (body) => post("/audit/search/download", body, {
  bypassReactAction: true,
  mimeType: MimeTypes[".csv"],
  returnHeaders: true
});
const audit = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  downloadAuditLogs: downloadAuditLogs$1
}, Symbol.toStringTag, { value: "Module" }));
const login$1 = async (customerId, username, password) => post("/login", {
  customerId,
  username,
  password
});
const refresh$1 = async () => get$1("/token/refresh");
const auth = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  login: login$1,
  refresh: refresh$1
}, Symbol.toStringTag, { value: "Module" }));
const fetchBankAccounts$1 = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  name,
  bankAccountNumber
}) => get$1(
  url("/bank-accounts", { page, pageSize: pageSize2, name, bankAccountNumber })
);
const bankAccounts = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchBankAccounts: fetchBankAccounts$1
}, Symbol.toStringTag, { value: "Module" }));
const fetchLegalEntities$1 = async () => get$1("/bank-reconciliations/legal-entities");
const fetchBankAccountsByLegalEntity$1 = async ({
  legalEntityKey
}) => (
  // todo bank feeds: update import type once swagger provides
  get$1(
    `/bank-reconciliations/legal-entities/${legalEntityKey}/bank-accounts`
  )
);
const createBankReconciliation$1 = async (body) => post("/bank-reconciliations", body);
const updateBankReconciliationDetails$1 = async ({
  bankReconciliationKey,
  generalLedgerKeys
}) => put(
  `/bank-reconciliations/${bankReconciliationKey}/details`,
  generalLedgerKeys
);
const deleteBankReconciliation$1 = async (key) => destroy(`/bank-reconciliations/${key}`);
const getAvailableVendors$1 = async ({
  page,
  pageSize: pageSize2,
  name,
  code,
  active = true,
  legalEntityKeys
}) => get$1(
  url("/bank-reconciliations/available-vendors", {
    page,
    pageSize: pageSize2,
    name,
    code,
    active,
    legalEntityId: legalEntityKeys
  })
);
const searchTransactions = async ({
  page,
  pageSize: pageSize2,
  query
}) => post(
  url("/bank-reconciliations/transactions/search", { page, pageSize: pageSize2 }),
  query
);
const createMatchedTransactions = async ({
  bankAccountKey,
  matchedTransaction
}) => post(
  `/bank-reconciliations/bank-accounts/${bankAccountKey}/matched-transactions`,
  matchedTransaction
);
const updateMatchedTransaction$1 = async ({
  bankAccountKey,
  matchedTransaction,
  matchedTransactionKey
}) => put(
  `/bank-reconciliations/bank-accounts/${bankAccountKey}/matched-transactions/${matchedTransactionKey}`,
  { ...matchedTransaction, key: matchedTransactionKey }
);
const searchBankReconciliations$1 = async ({
  page,
  pageSize: pageSize2,
  query
}) => post(
  url("/bank-reconciliations/search", { page, pageSize: pageSize2 }),
  query
);
const fetchLatestBankRec$1 = async ({
  bankAccountKey,
  legalEntityKey
}) => {
  const query = {
    legalEntityKey,
    bankAccountKeys: [bankAccountKey],
    includeReconciled: true,
    includeUnreconciled: true
  };
  const firstPage = await searchBankReconciliations$1({
    page: 1,
    pageSize: 1,
    query
  });
  const resultCount = firstPage.resultCount ?? 0;
  if (resultCount === 0) {
    return null;
  }
  if (resultCount === 1) {
    return firstPage.items?.[0] ?? null;
  }
  const lastPage = await searchBankReconciliations$1({
    page: resultCount,
    pageSize: 1,
    query
  });
  return lastPage.items?.[0] ?? null;
};
const fetchMatchedTransactions$1 = async ({
  bankAccountKey,
  page = 1,
  pageSize: pageSize2 = 2e3
}) => get$1(
  url(
    `/bank-reconciliations/bank-accounts/${bankAccountKey}/matched-transactions`,
    { page, pageSize: pageSize2 }
  )
);
const fetchMatchedTransactionDetail$1 = async ({
  bankAccountKey,
  matchedTransactionKey
}) => get$1(
  `/bank-reconciliations/bank-accounts/${bankAccountKey}/matched-transactions/${matchedTransactionKey}`
);
const deleteMatchedTransaction$1 = async ({
  bankAccountKey,
  matchedTransactionKey
}) => destroy(
  `/bank-reconciliations/bank-accounts/${bankAccountKey}/matched-transactions/${matchedTransactionKey}`
);
const excludeMatchedTransactions$1 = async ({
  bankAccountKey,
  body
}) => post(
  `/bank-reconciliations/bank-accounts/${bankAccountKey}/matched-transactions/exclude`,
  body
);
const restoreMatchedTransactions$1 = async ({
  bankAccountKey,
  body
}) => post(
  `/bank-reconciliations/bank-accounts/${bankAccountKey}/matched-transactions/restore`,
  body
);
const deleteBankReconciliationAttachment$1 = async ({
  attachmentKey,
  bankReconciliationKey
}) => destroy(
  `/bank-reconciliations/${bankReconciliationKey}/attachments/${attachmentKey}`
);
const uploadBankReconciliationAttachment = async ({
  bankReconciliationKey,
  attachment
}) => post(
  `/bank-reconciliations/${bankReconciliationKey}/attachments`,
  attachment
);
const updateBankReconciliation$1 = async ({
  bankReconciliationKey,
  body
}) => put(`/bank-reconciliations/${bankReconciliationKey}`, body);
const reconcileBankReconciliation$1 = async ({
  bankReconciliationKey
}) => post(`/bank-reconciliations/${bankReconciliationKey}/reconcile`, {});
const unreconcileBankReconciliation$1 = async ({
  bankReconciliationKey
}) => post(`/bank-reconciliations/${bankReconciliationKey}/unreconcile`, {});
const fetchBankReconciliation$1 = async ({
  bankReconciliationKey
}) => get$1(
  `/bank-reconciliations/${bankReconciliationKey}`
);
const fetchBankReconciliationDetails$1 = async ({
  bankReconciliationKey,
  documentType,
  page = 1,
  pageSize: pageSize2 = 2e3,
  throughDate,
  transactionEndDate,
  transactionStartDate,
  transactionType
}) => get$1(
  url(`/bank-reconciliations/${bankReconciliationKey}/details`, {
    documentType,
    page,
    pageSize: pageSize2,
    throughDate,
    transactionEndDate,
    transactionStartDate,
    transactionType
  })
);
const fetchBankReconciliationAvailableCredits$1 = async ({
  bankReconciliationKey,
  documentType,
  page = 1,
  pageSize: pageSize2 = 2e3,
  throughDate,
  transactionEndDate,
  transactionStartDate
}) => get$1(
  url(`/bank-reconciliations/${bankReconciliationKey}/available-credits`, {
    documentType,
    page,
    pageSize: pageSize2,
    throughDate,
    transactionEndDate,
    transactionStartDate
  })
);
const fetchBankReconciliationAttachments$1 = async ({
  bankReconciliationKey,
  page,
  pageSize: pageSize2
}) => get$1(
  url(`/bank-reconciliations/${bankReconciliationKey}/attachments`, {
    page,
    pageSize: pageSize2
  })
);
const fetchBankReconciliationAvailableDebits$1 = async ({
  bankReconciliationKey,
  documentType,
  page = 1,
  pageSize: pageSize2 = 2e3,
  throughDate,
  transactionEndDate,
  transactionStartDate
}) => get$1(
  url(`/bank-reconciliations/${bankReconciliationKey}/available-debits`, {
    documentType,
    page,
    pageSize: pageSize2,
    throughDate,
    transactionEndDate,
    transactionStartDate
  })
);
const fetchBankReconciliationAttachment$1 = async ({
  attachmentKey,
  bankReconciliationKey
}) => get$1(
  `/bank-reconciliations/${bankReconciliationKey}/attachments/${attachmentKey}`
);
const fetchWorkflowRules = async ({
  page,
  pageSize: pageSize2,
  ruleType
}) => get$1(
  url("/bank-reconciliations/workflow-rules", { page, pageSize: pageSize2, ruleType })
);
const fetchWorkflowRule = async ({ ruleKey }) => get$1(
  `/bank-reconciliations/workflow-rules/${ruleKey}`
);
const createWorkflowRule = async (body) => post("/bank-reconciliations/workflow-rules", body);
const updateWorkflowRule = async ({
  body,
  ruleKey
}) => put(`/bank-reconciliations/workflow-rules/${ruleKey}`, body);
const deleteWorkflowRule = async ({ ruleKey }) => destroy(`/bank-reconciliations/workflow-rules/${ruleKey}`);
const fetchWorkflowRuleValues = async ({
  page,
  pageSize: pageSize2,
  ruleKey
}) => get$1(
  url(`/bank-reconciliations/workflow-rules/${ruleKey}/values`, {
    page,
    pageSize: pageSize2
  })
);
const fetchWorkflowRuleValue = async ({
  ruleKey,
  valueKey
}) => get$1(
  `/bank-reconciliations/workflow-rules/${ruleKey}/values/${valueKey}`
);
const createWorkflowRuleValue = async ({
  body,
  ruleKey
}) => post(
  `/bank-reconciliations/workflow-rules/${ruleKey}/values`,
  body
);
const updateWorkflowRuleValue = async ({
  body,
  ruleKey,
  valueKey
}) => put(
  `/bank-reconciliations/workflow-rules/${ruleKey}/values/${valueKey}`,
  body
);
const deleteWorkflowRuleValue = async ({
  ruleKey,
  valueKey
}) => destroy(
  `/bank-reconciliations/workflow-rules/${ruleKey}/values/${valueKey}`
);
const bankReconciliation = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createBankReconciliation: createBankReconciliation$1,
  createMatchedTransactions,
  createWorkflowRule,
  createWorkflowRuleValue,
  deleteBankReconciliation: deleteBankReconciliation$1,
  deleteBankReconciliationAttachment: deleteBankReconciliationAttachment$1,
  deleteMatchedTransaction: deleteMatchedTransaction$1,
  deleteWorkflowRule,
  deleteWorkflowRuleValue,
  excludeMatchedTransactions: excludeMatchedTransactions$1,
  fetchBankAccountsByLegalEntity: fetchBankAccountsByLegalEntity$1,
  fetchBankReconciliation: fetchBankReconciliation$1,
  fetchBankReconciliationAttachment: fetchBankReconciliationAttachment$1,
  fetchBankReconciliationAttachments: fetchBankReconciliationAttachments$1,
  fetchBankReconciliationAvailableCredits: fetchBankReconciliationAvailableCredits$1,
  fetchBankReconciliationAvailableDebits: fetchBankReconciliationAvailableDebits$1,
  fetchBankReconciliationDetails: fetchBankReconciliationDetails$1,
  fetchLatestBankRec: fetchLatestBankRec$1,
  fetchLegalEntities: fetchLegalEntities$1,
  fetchMatchedTransactionDetail: fetchMatchedTransactionDetail$1,
  fetchMatchedTransactions: fetchMatchedTransactions$1,
  fetchWorkflowRule,
  fetchWorkflowRuleValue,
  fetchWorkflowRuleValues,
  fetchWorkflowRules,
  getAvailableVendors: getAvailableVendors$1,
  reconcileBankReconciliation: reconcileBankReconciliation$1,
  restoreMatchedTransactions: restoreMatchedTransactions$1,
  searchBankReconciliations: searchBankReconciliations$1,
  searchTransactions,
  unreconcileBankReconciliation: unreconcileBankReconciliation$1,
  updateBankReconciliation: updateBankReconciliation$1,
  updateBankReconciliationDetails: updateBankReconciliationDetails$1,
  updateMatchedTransaction: updateMatchedTransaction$1,
  updateWorkflowRule,
  updateWorkflowRuleValue,
  uploadBankReconciliationAttachment
}, Symbol.toStringTag, { value: "Module" }));
const getBusinessWeek$1 = async (key) => get$1(`/business-weeks/${key}`);
const getBusinessWeeks = async (page = 1, pageSize2 = 200, name) => get$1(
  url("/business-weeks", { page, pageSize: pageSize2, name })
);
const businessWeeks = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getBusinessWeek: getBusinessWeek$1,
  getBusinessWeeks
}, Symbol.toStringTag, { value: "Module" }));
const getCalendarRanges$1 = async (startDate) => get$1(`/calendar/ranges?start=${startDate.toISODate()}`);
const getFiscalYears = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/calendar/fiscal/years", { page, pageSize: pageSize2 })
);
const getFiscalYearBreakdown$1 = async ({
  id,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/calendar/fiscal/years/${id}/breakdown`, { page, pageSize: pageSize2 })
);
const calendar = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getCalendarRanges: getCalendarRanges$1,
  getFiscalYearBreakdown: getFiscalYearBreakdown$1,
  getFiscalYears
}, Symbol.toStringTag, { value: "Module" }));
const getChangeReasons = async ({
  page,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  timesheetKey
}) => get$1(
  url("/change-reasons", { page, pageSize: pageSize2, timesheetKey })
);
const changeReasons = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getChangeReasons
}, Symbol.toStringTag, { value: "Module" }));
const createAgencyCode$1 = async (requestBody) => post(
  `/contracts/contract-clauses/agencies`,
  requestBody
);
const createContractClause$1 = async (requestBody) => post(`/contracts/contract-clauses`, requestBody);
const createIncludedContractClause$1 = async (contractKey, requestBody) => post(`/contracts/${contractKey}/contract-clauses`, requestBody);
const deleteAgencyCode$1 = async (key) => destroy(`/contracts/contract-clauses/agencies/${key}`);
const deleteContractClause$1 = async (key) => destroy(`/contracts/contract-clauses/${key}`);
const deleteIncludedContractClause$1 = async (contractKey, clauseKey) => destroy(`/contracts/${contractKey}/contract-clauses/${clauseKey}`);
const editAgencyCode$1 = async (requestBody) => put(
  `/contracts/contract-clauses/agencies/${requestBody.key}`,
  requestBody
);
const editContractClause$1 = async (requestBody) => put(`/contracts/contract-clauses/${requestBody.key}`, requestBody);
const editIncludedContractClause$1 = async (contractKey, requestBody) => put(
  `/contracts/${contractKey}/contract-clauses/${requestBody.clause.key}`,
  requestBody
);
const fetchContractAgencies = async ({
  active,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/contracts/contract-clauses/agencies", { active, page, pageSize: pageSize2 })
);
const fetchContractClauseByKey$1 = async (key) => get$1(`/contracts/contract-clauses/${key}`);
const fetchContractClauseImportDefinition$1 = async () => get$1(`/contracts/contract-clauses/import/definition`);
const fetchContractClauses = async (page = 1, pageSize2 = 50) => get$1(
  url("/contracts/contract-clauses", { page, pageSize: pageSize2 })
);
const fetchIncludedContractClauses = async (contractKey, page = 1, pageSize2 = 50) => get$1(
  url(`/contracts/${contractKey}/contract-clauses`, {
    page,
    pageSize: pageSize2
  })
);
const importContractClauses$1 = async (file, {
  dryRun = false,
  enableProgressFeedback = false
}) => {
  return postFile(
    url("/contracts/contract-clauses/import", {
      dryRun,
      enableProgressFeedback
    }),
    file
  );
};
const contractClauses = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createAgencyCode: createAgencyCode$1,
  createContractClause: createContractClause$1,
  createIncludedContractClause: createIncludedContractClause$1,
  deleteAgencyCode: deleteAgencyCode$1,
  deleteContractClause: deleteContractClause$1,
  deleteIncludedContractClause: deleteIncludedContractClause$1,
  editAgencyCode: editAgencyCode$1,
  editContractClause: editContractClause$1,
  editIncludedContractClause: editIncludedContractClause$1,
  fetchContractAgencies,
  fetchContractClauseByKey: fetchContractClauseByKey$1,
  fetchContractClauseImportDefinition: fetchContractClauseImportDefinition$1,
  fetchContractClauses,
  fetchIncludedContractClauses,
  importContractClauses: importContractClauses$1
}, Symbol.toStringTag, { value: "Module" }));
const getClinProjectTaskMapping$1 = ({
  mappingKey
}) => {
  return get$1(
    `/contracts/clin-project-task-mappings/${mappingKey}`
  );
};
const getClinProjectTaskMappings$1 = ({
  contractKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  return get$1(
    url(`/contracts/${contractKey}/clin-project-task-mappings`, {
      page,
      pageSize: pageSize2
    })
  );
};
const getWbsHierarchyPaged = ({
  contractKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  return get$1(
    url(`/contracts/${contractKey}/clin-project-task-mappings/wbs-hierarchy`, {
      page,
      pageSize: pageSize2
    })
  );
};
const createClinProjectTaskMapping$1 = ({
  contractKey,
  mapping
}) => {
  return post(
    `/contracts/${contractKey}/clin-project-task-mappings`,
    mapping
  );
};
const updateClinProjectTaskMapping$1 = ({
  contractKey,
  mapping,
  mappingKey
}) => {
  return put(
    `/contracts/${contractKey}/clin-project-task-mappings/${mappingKey}`,
    mapping
  );
};
const deleteClinProjectTaskMapping$1 = ({
  contractKey,
  mappingKey
}) => {
  return destroy(
    `/contracts/${contractKey}/clin-project-task-mappings/${mappingKey}`
  );
};
const validateClinProjectTaskMappings$1 = ({
  contractKey
}) => {
  return post(
    `/contracts/${contractKey}/clin-project-task-mappings/validate`
  );
};
const clinProjectTaskMappings = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createClinProjectTaskMapping: createClinProjectTaskMapping$1,
  deleteClinProjectTaskMapping: deleteClinProjectTaskMapping$1,
  getClinProjectTaskMapping: getClinProjectTaskMapping$1,
  getClinProjectTaskMappings: getClinProjectTaskMappings$1,
  getWbsHierarchyPaged,
  updateClinProjectTaskMapping: updateClinProjectTaskMapping$1,
  validateClinProjectTaskMappings: validateClinProjectTaskMappings$1
}, Symbol.toStringTag, { value: "Module" }));
const activateMulticurrency$1 = async () => post("/config/multicurrency/activate");
const getLicenses$1 = async () => get$1("/config/license");
const getLogo = async (logoType) => get$1(url("/config/logos", { logoType }));
const getMulticurrency = async () => get$1("/config/multicurrency");
const editMulticurrencyConfig$1 = async (requestBody) => put("/config/multicurrency", requestBody);
const getBankFeedSettings = async () => get$1("/config/bank-feed-settings");
const saveBankFeedSettings$1 = async (requestBody) => put("/config/bank-feed-settings", requestBody);
const getSystemConfig = async () => get$1("/config/system");
const config$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  activateMulticurrency: activateMulticurrency$1,
  editMulticurrencyConfig: editMulticurrencyConfig$1,
  getBankFeedSettings,
  getLicenses: getLicenses$1,
  getLogo,
  getMulticurrency,
  getSystemConfig,
  saveBankFeedSettings: saveBankFeedSettings$1
}, Symbol.toStringTag, { value: "Module" }));
const createContract$1 = async (requestBody) => post(`/contracts`, requestBody);
const updateContract$1 = async (requestBody) => put(`/contracts/${requestBody.key}`, requestBody);
const getContractStatuses = async (page = 1, pageSize2 = 50) => get$1(
  url("/contracts/statuses", { page, pageSize: pageSize2 })
);
const getContractTypes = async (page = 1, pageSize2 = 50) => get$1(url("/contracts/types", { page, pageSize: pageSize2 }));
const getAllBillingAnalysts$1 = async (pageSize2 = MAX_PLATFORM_PAGE_SIZE, includeInactive = true) => fetchAllItems({
  fetch: (page) => () => getBillingAnalysts(page, pageSize2, includeInactive)
});
const getBillingAnalysts = async (page = 1, pageSize2 = 50, includeInactive = true) => get$1(
  url("/contracts/billing-analysts", {
    page,
    pageSize: pageSize2,
    includeInactive
  })
);
const getContract$1 = async ({ contractKey }) => get$1(`/contracts/${contractKey}`);
const getAllContractManagers$1 = async (pageSize2 = MAX_PLATFORM_PAGE_SIZE, includeInactive = true) => fetchAllItems({
  fetch: (page) => () => getContractManagers(page, pageSize2, includeInactive)
});
const getContractManagers = async (page = 1, pageSize2 = 50, includeInactive = true) => get$1(
  url("/contracts/contract-managers", {
    page,
    pageSize: pageSize2,
    includeInactive
  })
);
const getContractProvisions$1 = async (page = 1, pageSize2 = 50) => get$1(
  url("/contracts/provisions", { page, pageSize: pageSize2 })
);
const getMasterContracts = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  owningOrgId,
  contractKey,
  contractCode,
  contractTitle
}) => get$1(
  url(`/contracts/owning-organizations/${owningOrgId}/master-contracts`, {
    page,
    pageSize: pageSize2,
    contractKey,
    contractCode,
    contractTitle
  })
);
const getOwningOrganizations = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/contracts/owning-organizations", { page, pageSize: pageSize2 })
);
const getWageDeterminations = async ({
  contractKey,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/contracts/${contractKey}/wage-determinations`, {
    page,
    pageSize: pageSize2
  })
);
const searchContracts$1 = async (page = 1, pageSize2 = 50, requestBody) => post(
  url("/contracts/search", { page, pageSize: pageSize2 }),
  requestBody
);
const searchContractDetails$1 = async ({
  body,
  contractId,
  page = 1,
  pageSize: pageSize2 = 10
}) => post(
  url(`/contracts/${contractId}/contract-lines/search`, { page, pageSize: pageSize2 }),
  body
);
const searchContractLines = async ({
  contractKey,
  page = 1,
  pageSize: pageSize2 = 50,
  requestBody = { contractLineId: "", description: "", pscCode: "" }
}) => post(
  url(`/contracts/${contractKey}/contract-lines/search`, { page, pageSize: pageSize2 }),
  requestBody
);
const createContractLine$1 = async ({
  body,
  contractId
}) => post(`/contracts/${contractId}/contract-lines`, body);
const getContractLine$1 = async ({
  contractId,
  lineId
}) => get$1(`/contracts/${contractId}/contract-lines/${lineId}`);
const updateContractLine$1 = async ({
  body,
  contractId,
  lineId
}) => put(`/contracts/${contractId}/contract-lines/${lineId}`, body);
const deleteContractLine$1 = async ({
  contractId,
  lineId
}) => destroy(`/contracts/${contractId}/contract-lines/${lineId}`);
const createContractSubline$1 = async ({
  body,
  contractId,
  lineId
}) => post(
  `/contracts/${contractId}/contract-lines/${lineId}/contract-sublines`,
  body
);
const getContractSubline$1 = async ({
  contractId,
  lineId,
  sublineId
}) => get$1(
  `/contracts/${contractId}/contract-lines/${lineId}/contract-sublines/${sublineId}`
);
const updateContractSubline$1 = async ({
  body,
  contractId,
  lineId,
  sublineId
}) => put(
  `/contracts/${contractId}/contract-lines/${lineId}/contract-sublines/${sublineId}`,
  body
);
const deleteContractSubline$1 = async ({
  contractId,
  lineId,
  sublineId
}) => destroy(
  `/contracts/${contractId}/contract-lines/${lineId}/contract-sublines/${sublineId}`
);
const getBillingTypes = async (page = 1, pageSize2 = 50) => get$1(
  url("/config/billing-types", { page, pageSize: pageSize2 })
);
const getFundingItems$1 = async ({
  contractId,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/contracts/${contractId}/funding-items`, { page, pageSize: pageSize2 })
);
const getFundingItem$1 = async ({
  contractId,
  fundingItemId
}) => get$1(
  `/contracts/${contractId}/funding-items/${fundingItemId}`
);
const createFundingItem$1 = async ({
  body,
  contractId
}) => post(`/contracts/${contractId}/funding-items`, body);
const updateFundingItem$1 = async ({
  body,
  contractId,
  fundingItemId
}) => put(`/contracts/${contractId}/funding-items/${fundingItemId}`, body);
const deleteFundingItem$1 = async ({
  contractId,
  fundingItemId
}) => destroy(`/contracts/${contractId}/funding-items/${fundingItemId}`);
const contracts = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createContract: createContract$1,
  createContractLine: createContractLine$1,
  createContractSubline: createContractSubline$1,
  createFundingItem: createFundingItem$1,
  deleteContractLine: deleteContractLine$1,
  deleteContractSubline: deleteContractSubline$1,
  deleteFundingItem: deleteFundingItem$1,
  getAllBillingAnalysts: getAllBillingAnalysts$1,
  getAllContractManagers: getAllContractManagers$1,
  getBillingAnalysts,
  getBillingTypes,
  getContract: getContract$1,
  getContractLine: getContractLine$1,
  getContractManagers,
  getContractProvisions: getContractProvisions$1,
  getContractStatuses,
  getContractSubline: getContractSubline$1,
  getContractTypes,
  getFundingItem: getFundingItem$1,
  getFundingItems: getFundingItems$1,
  getMasterContracts,
  getOwningOrganizations,
  getWageDeterminations,
  searchContractDetails: searchContractDetails$1,
  searchContractLines,
  searchContracts: searchContracts$1,
  updateContract: updateContract$1,
  updateContractLine: updateContractLine$1,
  updateContractSubline: updateContractSubline$1,
  updateFundingItem: updateFundingItem$1
}, Symbol.toStringTag, { value: "Module" }));
const getCostReportElements = async ({
  costReportKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/cost-reports/${costReportKey}/report-elements`, { page, pageSize: pageSize2 })
);
const getCostReports = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(url("/cost-reports", { page, pageSize: pageSize2 }));
const costReports = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getCostReportElements,
  getCostReports
}, Symbol.toStringTag, { value: "Module" }));
const getCurrencyCodes = async ({
  page,
  pageSize: pageSize2 = 50
}) => {
  return get$1(
    url("/currencies/currency-codes", { page, pageSize: pageSize2 })
  );
};
const currencies = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getCurrencyCodes
}, Symbol.toStringTag, { value: "Module" }));
var DashboardMenuId = /* @__PURE__ */ ((DashboardMenuId2) => {
  DashboardMenuId2["AccountsPayable"] = "gc.financials.accounts_payable.dashboard";
  DashboardMenuId2["AccountsReceivable"] = "gc.financials.accounts_receivable.dashboard";
  DashboardMenuId2["Admin"] = "gc.admin.dashboard";
  DashboardMenuId2["Billing"] = "gc.financials.billing.dashboard";
  DashboardMenuId2["Contracts"] = "gc.contracts.dashboard";
  DashboardMenuId2["ContractsContracts"] = "gc.contracts.contracts.dashboard";
  DashboardMenuId2["Expense"] = "gc.expense.dashboard";
  DashboardMenuId2["Financials"] = "gc.financials.dashboard";
  DashboardMenuId2["FixedAssets"] = "gc.financials.fixed_assets.dashboard";
  DashboardMenuId2["Forecast"] = "gc.forecast.dashboard";
  DashboardMenuId2["GeneralLedger"] = "gc.financials.general_ledger.dashboard";
  DashboardMenuId2["Home"] = "gc.home.dashboard";
  DashboardMenuId2["Organizations"] = "gc.organizations.dashboard";
  DashboardMenuId2["People"] = "gc.people.dashboard";
  DashboardMenuId2["Projects"] = "gc.contracts.projects.dashboard";
  DashboardMenuId2["Purchasing"] = "gc.financials.purchasing.dashboard";
  DashboardMenuId2["Reports"] = "gc.reports.dashboard";
  DashboardMenuId2["Documents"] = "gc.shareddocs.dashboard";
  DashboardMenuId2["Time"] = "gc.time.dashboard";
  return DashboardMenuId2;
})(DashboardMenuId || {});
var ApplicationType = /* @__PURE__ */ ((ApplicationType2) => {
  ApplicationType2["Connect"] = "CONNECT";
  ApplicationType2["Custom"] = "CUSTOM";
  ApplicationType2["Mobile"] = "MOBILE";
  ApplicationType2["None"] = "NONE";
  ApplicationType2["Subcontractor"] = "SUBCONTRACTOR";
  ApplicationType2["WebApp"] = "WEBAPP";
  return ApplicationType2;
})(ApplicationType || {});
var LinkType$1 = /* @__PURE__ */ ((LinkType2) => {
  LinkType2["Company"] = "COMPANY";
  LinkType2["HowTo"] = "HOW_TO";
  LinkType2["Quick"] = "QUICK";
  LinkType2["Report"] = "REPORT";
  LinkType2["Tip"] = "TIP";
  return LinkType2;
})(LinkType$1 || {});
const getCustomLinks$1 = async ({
  active = true,
  applicationType,
  dashboardMenuId,
  forConfig,
  linkType,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/custom-links", {
    active,
    applicationType,
    dashboardMenuId,
    forConfig,
    linkType,
    page,
    pageSize: pageSize2
  })
);
const customLinks = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ApplicationType,
  DashboardMenuId,
  LinkType: LinkType$1,
  getCustomLinks: getCustomLinks$1
}, Symbol.toStringTag, { value: "Module" }));
const fetchAvailableDashboards = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/dashboards/available", { page, pageSize: pageSize2 })
);
const dashboards = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchAvailableDashboards
}, Symbol.toStringTag, { value: "Module" }));
const createDataLakeCriteria$1 = async (model) => post("/data-lake/criteria", model);
const deleteDataLakeCriteria$1 = async (criteriaKey) => destroy(`/data-lake/criteria/${criteriaKey}`);
const getDataLakeCriteria$1 = async (criteriaKey) => get$1(`/data-lake/criteria/${criteriaKey}`);
const getDataLakeCriteriaList = async ({
  page,
  pageSize: pageSize2 = 100
}) => get$1(
  url("/data-lake/criteria", { page, pageSize: pageSize2 })
);
const getDataLakeViewList = async ({
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/data-lake/criteria/types", { page, pageSize: pageSize2 })
);
const updateDataLakeCriteria$1 = async (criteria) => put(`/data-lake/criteria/${criteria.key}`, criteria);
const datalakeCriteria = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createDataLakeCriteria: createDataLakeCriteria$1,
  deleteDataLakeCriteria: deleteDataLakeCriteria$1,
  getDataLakeCriteria: getDataLakeCriteria$1,
  getDataLakeCriteriaList,
  getDataLakeViewList,
  updateDataLakeCriteria: updateDataLakeCriteria$1
}, Symbol.toStringTag, { value: "Module" }));
const getEmployeeTypes = async (page = 1, pageSize2 = 200, code) => get$1(
  url("/employee-types", { page, pageSize: pageSize2, code })
);
const employeeTypes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getEmployeeTypes
}, Symbol.toStringTag, { value: "Module" }));
const createExchangeRate$1 = async (requestBody) => post("/exchange-rates", requestBody);
const removeExchangeRate$1 = async (key) => destroy(`/exchange-rates/${key}`);
const searchExchangeRates = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  body
}) => {
  const results = await post(
    url("/exchange-rates/search", { page, pageSize: pageSize2 }),
    body
  );
  return mapListPage(results, (o) => o);
};
const updateExchangeRate = async (requestBody) => put(`/exchange-rates/${requestBody.key}`, requestBody);
const exchangeRates = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createExchangeRate: createExchangeRate$1,
  removeExchangeRate: removeExchangeRate$1,
  searchExchangeRates,
  updateExchangeRate
}, Symbol.toStringTag, { value: "Module" }));
const createExchangeRateType$1 = async (requestBody) => post(`/exchange-rates/types`, requestBody);
const getExchangeRateTypes = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  const results = await get$1(
    url(`/exchange-rates/types`, {
      page,
      pageSize: pageSize2
    })
  );
  return mapListPage(results, (o) => o);
};
const removeExchangeRateType$1 = async (key) => destroy(`/exchange-rates/types/${key}`);
const updateExchangeRateType = async (requestBody) => put(`/exchange-rates/types/${requestBody.key}`, requestBody);
const exchangeRateTypes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createExchangeRateType: createExchangeRateType$1,
  getExchangeRateTypes,
  removeExchangeRateType: removeExchangeRateType$1,
  updateExchangeRateType
}, Symbol.toStringTag, { value: "Module" }));
const fetchFeatureFlagById$1 = async ({ id }) => get$1(`/feature-flags/${id}`);
const featureFlag = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchFeatureFlagById: fetchFeatureFlagById$1
}, Symbol.toStringTag, { value: "Module" }));
const addFixedAssetClass = async ({
  requestBody
}) => post(`/fixed-assets/classes`, requestBody);
const addFixedAsset = async ({
  asset,
  alertKey
}) => post(url("/fixed-assets", { alertKey }), asset);
const addFixedAssetStatus$1 = async (requestBody) => post(`/fixed-assets/statuses`, requestBody);
const addFixedAssetLocation$1 = async ({
  fixedAssetKey,
  location
}) => post(
  `/fixed-assets/${fixedAssetKey}/locations`,
  location
);
const createFixedAssetAttachment = async ({
  fixedAssetKey,
  attachment
}) => post(
  `/fixed-assets/${fixedAssetKey}/attachments`,
  attachment
);
const deleteFixedAssetAlert$1 = async ({
  alertKey
}) => destroy(`/fixed-assets/alerts/${alertKey}`);
const destroyFixedAssetClass$1 = async ({
  classKey
}) => destroy(`/fixed-assets/classes/${classKey}`);
const destroyFixedAsset$1 = async ({
  fixedAssetKey
}) => destroy(`/fixed-assets/${fixedAssetKey}`);
const destroyFixedAssetAttachment$1 = async ({
  fixedAssetKey,
  attachmentKey
}) => destroy(`/fixed-assets/${fixedAssetKey}/attachments/${attachmentKey}`);
const destroyFixedAssetStatus$1 = async ({
  statusKey
}) => destroy(`/fixed-assets/statuses/${statusKey}`);
const destroyFixedAssetLocation$1 = async ({
  fixedAssetKey,
  locationKey
}) => destroy(`/fixed-assets/${fixedAssetKey}/locations/${locationKey}`);
const editFixedAssetClass = async ({
  classKey,
  requestBody
}) => put(`/fixed-assets/classes/${classKey}`, requestBody);
const editFixedAsset$1 = async ({ asset }) => put(`/fixed-assets/${asset.key}`, asset);
const editFixedAssetClassAccounts$1 = async ({
  classKey,
  accounts: accounts2
}) => put(`/fixed-assets/classes/${classKey}/accounts`, accounts2);
const editFixedAssetFilterCriteria$1 = async ({
  filterKey,
  requestBody,
  dashboards: dashboards2
}) => put(
  url(`/fixed-assets/search/criteria/${filterKey}`, {
    dashboard: dashboards2
  }),
  requestBody
);
const editFixedAssetStatus$1 = async ({
  statusKey,
  requestBody
}) => put(`/fixed-assets/statuses/${statusKey}`, requestBody);
const editFixedAssetLocation$1 = async ({
  fixedAssetKey,
  location,
  toUpdate
}) => put(`/fixed-assets/${fixedAssetKey}/locations/${toUpdate}`, location);
const fetchFixedAssetClass = async ({
  classKey
}) => get$1(`/fixed-assets/classes/${classKey}`);
const fetchFixedAssetsClassAccountCategories$1 = async () => get$1(`/fixed-assets/classes/account-categories`);
const fetchFixedAssetClassAccounts = async ({
  classKey
}) => get$1(`/fixed-assets/classes/${classKey}/accounts`);
const fetchFixedAssetClasses = async ({
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/fixed-assets/classes", { page, pageSize: pageSize2 })
);
const fetchFixedAsset$1 = async ({
  fixedAssetKey
}) => get$1(`/fixed-assets/${fixedAssetKey}`);
const fetchFixedAssetAttachment$1 = async ({
  fixedAssetKey,
  attachmentKey
}) => get$1(
  `/fixed-assets/${fixedAssetKey}/attachments/${attachmentKey}`
);
const fetchFixedAssetDepreciationSchedules = async ({
  fixedAssetKey,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/fixed-assets/${fixedAssetKey}/schedules`, { page, pageSize: pageSize2 })
);
const fetchFixedAssetImportDefinition = async () => get$1(`/fixed-assets/import/definition`);
const fetchFixedAssetJournalEntries = async ({
  fixedAssetKey,
  category,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/fixed-assets/${fixedAssetKey}/journal-entries`, {
    category,
    page,
    pageSize: pageSize2
  })
);
const fetchFixedAssetLegalEntityFiscalPeriods$1 = async ({
  legalEntityKey,
  page,
  pageSize: pageSize2 = 50,
  beginDate,
  includeClosedPeriods = false
}) => {
  const params = {
    page,
    pageSize: pageSize2,
    includeClosedPeriods
  };
  if (beginDate) {
    Object.assign(params, { beginDate });
  }
  return get$1(
    url(`/fixed-assets/legal-entities/${legalEntityKey}/fiscal-periods`, params)
  );
};
const fetchFixedAssetLegalEntityOrganizations = async ({
  legalEntityKey,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/fixed-assets/legal-entities/${legalEntityKey}/organizations`, {
    page,
    pageSize: pageSize2
  })
);
const fetchFixedAssetPosters = async ({
  includeInactive,
  page,
  pageSize: pageSize2
}) => get$1(
  url("/fixed-assets/posts/posters", {
    includeInactive,
    page,
    pageSize: pageSize2
  })
);
const fetchFixedAssets$1 = async ({
  page,
  pageSize: pageSize2 = 50
}) => get$1(url("/fixed-assets", { page, pageSize: pageSize2 }));
const fetchFixedAssetsAlerts = async ({
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/fixed-assets/alerts", { page, pageSize: pageSize2 })
);
const fetchFixedAssetAttachments$1 = async ({
  fixedAssetKey,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/fixed-assets/${fixedAssetKey}/attachments`, { page, pageSize: pageSize2 })
);
const fetchFixedAssetSavedFilter$1 = async ({
  filterKey
}) => get$1(`/fixed-assets/search/criteria/${filterKey}`);
const fetchFixedAssetSavedFilters = async ({
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/fixed-assets/search/criteria", { page, pageSize: pageSize2 })
);
const fetchFixedAssetsLegalEntities = async ({
  active = true,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/fixed-assets/legal-entities", { active, page, pageSize: pageSize2 })
);
const fetchFixedAssetsStatuses = async ({
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/fixed-assets/statuses", { page, pageSize: pageSize2 })
);
const fetchFixedAssetLegalEntityBalances = async ({
  legalEntityKey
}) => get$1(
  `/fixed-assets/legal-entities/${legalEntityKey}/balances`
);
const getFixedAssetLocations$1 = async ({
  fixedAssetKey,
  page,
  pageSize: pageSize2 = 250
}) => get$1(
  url(`/fixed-assets/${fixedAssetKey}/locations`, { page, pageSize: pageSize2 })
);
const importFixedAssets$1 = async (file, {
  dryRun = false,
  enableProgressFeedback = false
}) => postFile(
  url("/fixed-assets/import", { dryRun, enableProgressFeedback }),
  file
);
const postFixedAssets$1 = async ({
  requestBody
}) => post(`/fixed-assets/posts`, requestBody);
const saveFixedAssetsFilterCriteria = async ({
  requestBody,
  dashboards: dashboards2
}) => post(
  url("/fixed-assets/search/criteria", { dashboard: dashboards2 }),
  requestBody
);
const searchFixedAssetsPosts$1 = async ({
  requestBody,
  page,
  pageSize: pageSize2 = 50
}) => post(
  url(`/fixed-assets/posts/search`, { page, pageSize: pageSize2 }),
  requestBody
);
const searchFixedAssets$1 = async ({
  requestBody,
  page,
  pageSize: pageSize2 = 50
}) => post(
  url("/fixed-assets/search", { page, pageSize: pageSize2 }),
  requestBody
);
const setFixedAssetAlertReadStatus$1 = async ({
  alertKey,
  read: read2
}) => put(`/fixed-assets/alerts/${alertKey}`, { key: alertKey, read: read2 });
const unpostFixedAsset$1 = async ({
  fixedAssetKey,
  statusKey
}) => destroy(
  url(`/fixed-assets/posts/${fixedAssetKey}`, {
    faStatusKey: statusKey
  })
);
const fixedAssets = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addFixedAsset,
  addFixedAssetClass,
  addFixedAssetLocation: addFixedAssetLocation$1,
  addFixedAssetStatus: addFixedAssetStatus$1,
  createFixedAssetAttachment,
  deleteFixedAssetAlert: deleteFixedAssetAlert$1,
  destroyFixedAsset: destroyFixedAsset$1,
  destroyFixedAssetAttachment: destroyFixedAssetAttachment$1,
  destroyFixedAssetClass: destroyFixedAssetClass$1,
  destroyFixedAssetLocation: destroyFixedAssetLocation$1,
  destroyFixedAssetStatus: destroyFixedAssetStatus$1,
  editFixedAsset: editFixedAsset$1,
  editFixedAssetClass,
  editFixedAssetClassAccounts: editFixedAssetClassAccounts$1,
  editFixedAssetFilterCriteria: editFixedAssetFilterCriteria$1,
  editFixedAssetLocation: editFixedAssetLocation$1,
  editFixedAssetStatus: editFixedAssetStatus$1,
  fetchFixedAsset: fetchFixedAsset$1,
  fetchFixedAssetAttachment: fetchFixedAssetAttachment$1,
  fetchFixedAssetAttachments: fetchFixedAssetAttachments$1,
  fetchFixedAssetClass,
  fetchFixedAssetClassAccounts,
  fetchFixedAssetClasses,
  fetchFixedAssetDepreciationSchedules,
  fetchFixedAssetImportDefinition,
  fetchFixedAssetJournalEntries,
  fetchFixedAssetLegalEntityBalances,
  fetchFixedAssetLegalEntityFiscalPeriods: fetchFixedAssetLegalEntityFiscalPeriods$1,
  fetchFixedAssetLegalEntityOrganizations,
  fetchFixedAssetPosters,
  fetchFixedAssetSavedFilter: fetchFixedAssetSavedFilter$1,
  fetchFixedAssetSavedFilters,
  fetchFixedAssets: fetchFixedAssets$1,
  fetchFixedAssetsAlerts,
  fetchFixedAssetsClassAccountCategories: fetchFixedAssetsClassAccountCategories$1,
  fetchFixedAssetsLegalEntities,
  fetchFixedAssetsStatuses,
  getFixedAssetLocations: getFixedAssetLocations$1,
  importFixedAssets: importFixedAssets$1,
  postFixedAssets: postFixedAssets$1,
  saveFixedAssetsFilterCriteria,
  searchFixedAssets: searchFixedAssets$1,
  searchFixedAssetsPosts: searchFixedAssetsPosts$1,
  setFixedAssetAlertReadStatus: setFixedAssetAlertReadStatus$1,
  unpostFixedAsset: unpostFixedAsset$1
}, Symbol.toStringTag, { value: "Module" }));
const fetchIndustries$1 = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(url("/industries", { page, pageSize: pageSize2 }));
const industry = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchIndustries: fetchIndustries$1
}, Symbol.toStringTag, { value: "Module" }));
const createIntegrationUser = async (requestBody) => post(`/integrations/users`, requestBody);
const resetIntegrationUser = async (integrationUserKey) => post(`/integrations/users/${integrationUserKey}/reset`);
const searchIntegrationUsers = async (requestBody, page = 1, pageSize2 = 50) => post(
  url(`/integrations/users/search`, { page, pageSize: pageSize2 }),
  requestBody
);
const integrations = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createIntegrationUser,
  resetIntegrationUser,
  searchIntegrationUsers
}, Symbol.toStringTag, { value: "Module" }));
const fetchLaborCategories = async ({
  active,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/labor-categories", { page, pageSize: pageSize2, active })
);
const fetchLaborCategoryRates = async ({
  key,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/labor-categories/${key}/rates`, { page, pageSize: pageSize2 })
);
const laborCategories = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchLaborCategories,
  fetchLaborCategoryRates
}, Symbol.toStringTag, { value: "Module" }));
const getAvailableLeadProjects$1 = async ({
  contractKey,
  name,
  owningOrg,
  projectOrg,
  projectStatus,
  projectType,
  page = 1,
  pageSize: pageSize2 = 50,
  signal
}) => get$1(
  url(`/contracts/${contractKey}/lead-project/available`, {
    name,
    owningOrg,
    projectOrg,
    projectStatus,
    projectType,
    page,
    pageSize: pageSize2
  }),
  void 0,
  { signal }
);
const associateLeadProject$1 = async ({
  contractKey,
  projectKey
}) => post(`/contracts/${contractKey}/lead-project`, {
  projectKey
});
const disassociateLeadProject$1 = async ({
  contractKey
}) => destroy(`/contracts/${contractKey}/lead-project`);
const getLeadProject$1 = async ({
  contractKey
}) => get$1(`/contracts/${contractKey}/lead-project`);
const leadProject = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  associateLeadProject: associateLeadProject$1,
  disassociateLeadProject: disassociateLeadProject$1,
  getAvailableLeadProjects: getAvailableLeadProjects$1,
  getLeadProject: getLeadProject$1
}, Symbol.toStringTag, { value: "Module" }));
const getMyLeaveRequests$1 = async ({
  endsAfter,
  page,
  pageSize: pageSize2,
  sortBy: sortBy2,
  sortOrder,
  start: start2,
  statuses,
  ownerKey
}) => get$1(
  url(`/me/leave-requests`, {
    endsAfter,
    page,
    pageSize: pageSize2,
    sortBy: sortBy2,
    sortOrder,
    start: start2,
    status: statuses,
    ownerKey
  })
);
const cancelMyLeaveRequest$1 = async ({
  leaveRequestKey
}) => post(`/me/leave-requests/${leaveRequestKey}/cancel`);
const deleteMyLeaveRequest$1 = async ({
  leaveRequestKey
}) => destroy(`/me/leave-requests/${leaveRequestKey}`);
const getLeaveRequests$1 = async ({
  page,
  pageSize: pageSize2,
  sortBy: sortBy2,
  sortOrder,
  start: start2,
  end: end2,
  peopleKeys,
  statuses,
  statusStart,
  statusEnd
}) => get$1(
  url(`/leave-requests`, {
    page,
    pageSize: pageSize2,
    sortBy: sortBy2,
    sortOrder,
    start: start2,
    end: end2,
    personKey: peopleKeys,
    status: statuses,
    statusStart,
    statusEnd
  })
);
const cancelLeaveRequest$1 = async ({
  leaveRequestKey
}) => post(`/leave-requests/${leaveRequestKey}/cancel`);
const deleteLeaveRequest$1 = async ({
  leaveRequestKey
}) => destroy(`/leave-requests/${leaveRequestKey}`);
const leaveRequests = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cancelLeaveRequest: cancelLeaveRequest$1,
  cancelMyLeaveRequest: cancelMyLeaveRequest$1,
  deleteLeaveRequest: deleteLeaveRequest$1,
  deleteMyLeaveRequest: deleteMyLeaveRequest$1,
  getLeaveRequests: getLeaveRequests$1,
  getMyLeaveRequests: getMyLeaveRequests$1
}, Symbol.toStringTag, { value: "Module" }));
const fetchLocations$1 = async ({
  active,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(url("/locations", { page, pageSize: pageSize2, active }));
const locations = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchLocations: fetchLocations$1
}, Symbol.toStringTag, { value: "Module" }));
const getMe$1 = async () => get$1("/me");
const getMeAlternatesFor$1 = async ({
  page,
  pageSize: pageSize2 = 50
}) => get$1(url("/me/alternates/for", { page, pageSize: pageSize2 }));
const me$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getMe: getMe$1,
  getMeAlternatesFor: getMeAlternatesFor$1
}, Symbol.toStringTag, { value: "Module" }));
const fetchNaicsCodes = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(url("/naics-codes", { page, pageSize: pageSize2 }));
const naicsCodes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchNaicsCodes
}, Symbol.toStringTag, { value: "Module" }));
const getOrganization$1 = async ({ key }) => get$1(`/organizations/${key}`);
const getOrganizationContacts$1 = async (page = 1, pageSize2 = 50, id) => get$1(
  url(`/organizations/${id}/contacts`, { page, pageSize: pageSize2 })
);
const getOrganizationContactsList = async ({
  owningOrgId,
  active
}) => get$1(
  url(`/organizations/${owningOrgId}/contacts/list`, {
    active
  })
);
const getOrganizationVendorProfiles$1 = async (page = 1, pageSize2 = 50, id) => get$1(
  url(`/organizations/${id}/vendor-profiles`, { page, pageSize: pageSize2 })
);
const listOrganizations = async ({
  active = true,
  financialOrg
}) => get$1(url("/organizations/list", { active, financialOrg }));
const searchOrganizations$1 = async (page = 1, pageSize2 = 50, params) => post(
  url("/organizations/search", { page, pageSize: pageSize2 }),
  params
);
const organizations = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getOrganization: getOrganization$1,
  getOrganizationContacts: getOrganizationContacts$1,
  getOrganizationContactsList,
  getOrganizationVendorProfiles: getOrganizationVendorProfiles$1,
  listOrganizations,
  searchOrganizations: searchOrganizations$1
}, Symbol.toStringTag, { value: "Module" }));
const fetchPayCodes = async ({
  active = true,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(url("/pay-codes", { page, pageSize: pageSize2, active }));
const payCodes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchPayCodes
}, Symbol.toStringTag, { value: "Module" }));
const fetchPaymentMethods$1 = async ({
  activeOnly,
  page,
  pageSize: pageSize2 = 100
}) => get$1(
  url("/payment-methods", { activeOnly, page, pageSize: pageSize2 })
);
const fetchPaymentMethod$1 = async ({ key }) => get$1(`/payment-methods/${key}`);
const createPaymentMethod$1 = async ({
  body
}) => post(
  "/payment-methods",
  body
);
const updatePaymentMethod$1 = async ({
  key,
  ...body
}) => put(`/payment-methods/${key}`, { key, ...body });
const deletePaymentMethod$1 = async ({ key }) => destroy(`/payment-methods/${key}`);
const fetchPaymentMethodAccountCategories$1 = async () => get$1(`/payment-methods/account-categories`);
const fetchPaymentMethodAccounts$1 = async ({ key }) => get$1(`/payment-methods/${key}/accounts`);
const updatePaymentMethodAccounts$1 = async ({
  key,
  accounts: accounts2
}) => put(
  `/payment-methods/${key}/accounts`,
  accounts2
);
const paymentMethods = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createPaymentMethod: createPaymentMethod$1,
  deletePaymentMethod: deletePaymentMethod$1,
  fetchPaymentMethod: fetchPaymentMethod$1,
  fetchPaymentMethodAccountCategories: fetchPaymentMethodAccountCategories$1,
  fetchPaymentMethodAccounts: fetchPaymentMethodAccounts$1,
  fetchPaymentMethods: fetchPaymentMethods$1,
  updatePaymentMethod: updatePaymentMethod$1,
  updatePaymentMethodAccounts: updatePaymentMethodAccounts$1
}, Symbol.toStringTag, { value: "Module" }));
const fetchPaymentTerms$1 = async ({
  active,
  page,
  pageSize: pageSize2 = 100
}) => get$1(
  url("/payment-terms", { active, page, pageSize: pageSize2 })
);
const fetchPaymentTerm$1 = async ({ key }) => get$1(`/payment-terms/${key}`);
const createPaymentTerm$1 = async ({
  body
}) => post("/payment-terms", body);
const updatePaymentTerm$1 = async ({ key, ...body }) => put(`/payment-terms/${key}`, { key, ...body });
const deletePaymentTerm$1 = async ({ key }) => destroy(`/payment-terms/${key}`);
const paymentTerms = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createPaymentTerm: createPaymentTerm$1,
  deletePaymentTerm: deletePaymentTerm$1,
  fetchPaymentTerm: fetchPaymentTerm$1,
  fetchPaymentTerms: fetchPaymentTerms$1,
  updatePaymentTerm: updatePaymentTerm$1
}, Symbol.toStringTag, { value: "Module" }));
const getApproverGroupsForPerson = async ({
  personKey
}) => get$1(`/people/${personKey}/approval-groups/approver`);
const getMyRates$1 = async () => get$1(`/me/rates`);
const getPerson$1 = async (personKey) => get$1(`/people/${personKey}`);
const getPersonClassificationByDate$1 = async (personKey, dateKey2) => get$1(`/people/${personKey}/classification/${dateKey2}`);
const getPersonRates$1 = async (personKey) => get$1(`/people/${personKey}/rates`);
const getSkillLevels = async ({
  name,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/skill-levels", { name, page, pageSize: pageSize2 })
);
const getSkillTypes = ({
  name,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(url("/skill-types", { name, page, pageSize: pageSize2 }));
const searchPeopleAssignments$1 = async (page = 1, pageSize2 = MAX_PLATFORM_PAGE_SIZE, requestBody) => post(
  url("/people/assignments/search", { page, pageSize: pageSize2 }),
  requestBody
);
const updatePerson = async (personKey, person) => put(`/people/${personKey}`, person);
const updatePersonRate$1 = async (rate) => put(`/people/${rate.personKey}/rates/${rate.key}`, rate);
const people = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getApproverGroupsForPerson,
  getMyRates: getMyRates$1,
  getPerson: getPerson$1,
  getPersonClassificationByDate: getPersonClassificationByDate$1,
  getPersonRates: getPersonRates$1,
  getSkillLevels,
  getSkillTypes,
  searchPeopleAssignments: searchPeopleAssignments$1,
  updatePerson,
  updatePersonRate: updatePersonRate$1
}, Symbol.toStringTag, { value: "Module" }));
const ping = async () => get$1(`/ping`);
const ping$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ping
}, Symbol.toStringTag, { value: "Module" }));
const createPlannedTime$1 = async (requestBody) => post(`/planning/time`, requestBody);
const createPlannedTimeCriteria$1 = async ({
  dashboards: dashboards2,
  requestBody
}) => post(
  url("/planning/time/matrix/criteria", { dashboard: dashboards2 }),
  requestBody
);
const createPlannedTimeSharedCriteria$1 = async (requestBody, dashboards2) => post(
  url("/planning/time/matrix/criteria/share", {
    dashboard: dashboards2
  }),
  requestBody
);
const deletePlannedTime$1 = async (id) => destroy(`/planning/time/${id}`);
const deletePlannedTimeCriteria = async (id) => destroy(`/planning/time/matrix/criteria/${id}`);
const deletePlannedTimeSharedCriteria = async (id) => destroy(`/planning/time/matrix/criteria/${id}/share`);
const getBookedPlannedTime$1 = async (id, requestBody) => post(
  `/planning/time/people/${id}/booked`,
  requestBody
);
const getPlannedTime$1 = async (id) => get$1(`/planning/time/${id}`);
const getPlannedTimePersonOrganizations$1 = async ({
  code,
  projectKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/planning/person/organizations", {
    page,
    pageSize: pageSize2,
    code,
    projectKey
  })
);
const getPlannedTimeProjectOrganizations = async (code, page = 1, pageSize2 = 50) => get$1(
  url("/planning/projects/organizations", { page, pageSize: pageSize2, code })
);
const getPlannedTimeProjectOwningOrganizations = async (code, page = 1, pageSize2 = 50) => get$1(
  url("/planning/projects/owning-organizations?", {
    page,
    pageSize: pageSize2,
    code
  })
);
const getPlannedTimeSaveCriteria$1 = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/planning/time/matrix/criteria", { page, pageSize: pageSize2 })
);
const getPlannedTimeSaveCriteriaById$1 = async (id) => get$1(
  `/planning/time/matrix/criteria/${id}`
);
const getPlannedTimeSharedSaveCriteria$1 = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/planning/time/matrix/criteria/share", { page, pageSize: pageSize2 })
);
const getPlannedTimeSharedSaveCriteriaById$1 = async (id) => get$1(
  `/planning/time/matrix/criteria/${id}/share/`
);
const getProjectPlanDefaults$1 = async (projectKey, personKey, date) => get$1(
  `/planning/time/defaults/project/${projectKey}/person/${personKey}/${date}`
);
const searchAssignablePlannedTime$1 = async (requestBody, page = 1, pageSize2 = 50) => post(
  url("/planning/time/assignable", { page, pageSize: pageSize2 }),
  requestBody
);
const searchPlannedTime$1 = async (page = 1, pageSize2 = MAX_PLATFORM_PAGE_SIZE, requestBody) => post(
  url("/planning/time/search", { page, pageSize: pageSize2 }),
  requestBody
);
const searchPlannedTimeMatrix$1 = async (requestBody) => post(`/planning/time/matrix`, requestBody);
const searchPlannedTimePeople$1 = async ({
  requestBody,
  page = 1,
  pageSize: pageSize2 = 50
}) => post(
  url("/planning/people", { page, pageSize: pageSize2 }),
  requestBody
);
const searchPlannedTimePeopleAllocation$1 = async (requestBody) => post(
  `/planning/time/people/allocation`,
  requestBody
);
const searchPlannedTimeProjects = async (page = 1, pageSize2 = 50, requestBody) => post(
  url("/planning/projects", { page, pageSize: pageSize2 }),
  requestBody
);
const updatePlannedTime$1 = async (time2) => put(`/planning/time/${time2.key}`, time2);
const updatePlannedTimeSaveCriteria$1 = async ({
  dashboards: dashboards2,
  id,
  requestBody
}) => put(
  url(`/planning/time/matrix/criteria/${id}`, {
    dashboard: dashboards2
  }),
  requestBody
);
const updatePlannedTimeSharedSaveCriteria$1 = async ({
  id,
  requestBody
}) => put(`/planning/time/matrix/criteria/${id}/share`, requestBody);
const planning = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createPlannedTime: createPlannedTime$1,
  createPlannedTimeCriteria: createPlannedTimeCriteria$1,
  createPlannedTimeSharedCriteria: createPlannedTimeSharedCriteria$1,
  deletePlannedTime: deletePlannedTime$1,
  deletePlannedTimeCriteria,
  deletePlannedTimeSharedCriteria,
  getBookedPlannedTime: getBookedPlannedTime$1,
  getPlannedTime: getPlannedTime$1,
  getPlannedTimePersonOrganizations: getPlannedTimePersonOrganizations$1,
  getPlannedTimeProjectOrganizations,
  getPlannedTimeProjectOwningOrganizations,
  getPlannedTimeSaveCriteria: getPlannedTimeSaveCriteria$1,
  getPlannedTimeSaveCriteriaById: getPlannedTimeSaveCriteriaById$1,
  getPlannedTimeSharedSaveCriteria: getPlannedTimeSharedSaveCriteria$1,
  getPlannedTimeSharedSaveCriteriaById: getPlannedTimeSharedSaveCriteriaById$1,
  getProjectPlanDefaults: getProjectPlanDefaults$1,
  searchAssignablePlannedTime: searchAssignablePlannedTime$1,
  searchPlannedTime: searchPlannedTime$1,
  searchPlannedTimeMatrix: searchPlannedTimeMatrix$1,
  searchPlannedTimePeople: searchPlannedTimePeople$1,
  searchPlannedTimePeopleAllocation: searchPlannedTimePeopleAllocation$1,
  searchPlannedTimeProjects,
  updatePlannedTime: updatePlannedTime$1,
  updatePlannedTimeSaveCriteria: updatePlannedTimeSaveCriteria$1,
  updatePlannedTimeSharedSaveCriteria: updatePlannedTimeSharedSaveCriteria$1
}, Symbol.toStringTag, { value: "Module" }));
const createProjectAssignment$1 = async (projectKey, requestBody) => post(
  `/projects/${projectKey}/people-assignments`,
  requestBody
);
const createProjectTaskPredecessor$1 = async ({
  projectKey,
  taskKey,
  predecessor
}) => post(
  `/projects/${projectKey}/tasks/${taskKey}/predecessors`,
  predecessor
);
const deleteProjectAssignment$1 = async (projectKey, assignmentId) => destroy(`/projects/${projectKey}/people-assignments/${assignmentId}`);
const deleteProjectTaskPredecessor$1 = async ({
  projectKey,
  taskKey,
  predecessorKey
}) => destroy(
  `/projects/${projectKey}/tasks/${taskKey}/predecessors/${predecessorKey}`
);
const getDefaultProjectAssignmentValues = async ({
  projectKey,
  personKey,
  date
}) => get$1(
  `/projects/${projectKey}/people-assignments/defaults/person/${personKey}/${date}`
);
const getProject = async (projectKey) => get$1(`/projects/${projectKey}`);
const getProjectAssignment$1 = async ({
  assignmentKey,
  includeInactive,
  projectKey
}) => get$1(
  url(`/projects/${projectKey}/people-assignments/${assignmentKey}`, {
    includeInactive
  })
);
const getProjectLaborCategories = async ({
  laborCategoryKeys,
  projectKey,
  asOfDate,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/projects/${projectKey}/labor-categories`, {
    asOfDate,
    laborCategoryId: laborCategoryKeys,
    page,
    pageSize: pageSize2
  })
);
const getProjectExpenseTypes = async ({
  projectKey,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/projects/${projectKey}/expense-types`, { page, pageSize: pageSize2 })
);
const getProjectItems = async ({
  projectKey,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/projects/${projectKey}/items`, { page, pageSize: pageSize2 })
);
const getProjectFixedPriceItems = async ({
  projectKey,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/projects/${projectKey}/fixed-price-items`, { page, pageSize: pageSize2 })
);
const getProjectLocations = async ({
  projectKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/projects/${projectKey}/locations`, { page, pageSize: pageSize2 })
);
const getProjectPlanSets = async (projectKey, page = 1, pageSize2 = 50) => get$1(
  url(`/projects/${projectKey}/plan-sets`, { page, pageSize: pageSize2 })
);
const getProjectStatuses = async (page = 1, pageSize2 = 50, name = "") => get$1(
  url("/project-statuses", { page, pageSize: pageSize2, name })
);
const getProjectTask = async ({
  projectKey,
  taskKey
}) => get$1(`/projects/${projectKey}/tasks/${taskKey}`);
const getProjectTaskPredecessors = async ({
  projectKey,
  taskKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/projects/${projectKey}/tasks/${taskKey}/predecessors`, {
    page,
    pageSize: pageSize2
  })
);
const getProjectTasks$1 = async ({
  page,
  pageSize: pageSize2 = 50,
  projectKey
}) => get$1(
  url(`/projects/${projectKey}/tasks`, { page, pageSize: pageSize2 })
);
const getProjectTypes = async (page = 1, pageSize2 = 50, name = "", active = true) => get$1(
  url("/project-types", { page, pageSize: pageSize2, name, active })
);
const searchProjectAssignments$1 = async ({
  projectKey,
  page,
  pageSize: pageSize2,
  query
}) => post(
  url(`/projects/${projectKey}/people-assignments/search`, {
    page,
    pageSize: pageSize2
  }),
  query
);
const searchProjects$1 = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  params
}) => post(
  url("/projects/search", { page, pageSize: pageSize2 }),
  params
);
const searchTasks$1 = async ({
  body,
  page = 1,
  pageSize: pageSize2 = 50
}) => post(
  url("/projects/tasks/search", { page, pageSize: pageSize2 }),
  body
);
const updateProject$1 = async ({
  project
}) => put(`/projects/${project.key}`, project);
const updateProjectAssignment$1 = async (assignmentKey, projectKey, requestBody) => put(
  `/projects/${projectKey}/people-assignments/${assignmentKey}`,
  requestBody
);
const updateProjectTask$1 = async ({ task }) => put(`/projects/${task.projectKey}/tasks/${task.key}`, task);
const updateProjectTaskPredecessor$1 = async ({
  projectKey,
  taskKey,
  predecessor
}) => put(
  `/projects/${projectKey}/tasks/${taskKey}/predecessors/${predecessor.predecessorTask.key}`,
  predecessor
);
const projects = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createProjectAssignment: createProjectAssignment$1,
  createProjectTaskPredecessor: createProjectTaskPredecessor$1,
  deleteProjectAssignment: deleteProjectAssignment$1,
  deleteProjectTaskPredecessor: deleteProjectTaskPredecessor$1,
  getDefaultProjectAssignmentValues,
  getProject,
  getProjectAssignment: getProjectAssignment$1,
  getProjectExpenseTypes,
  getProjectFixedPriceItems,
  getProjectItems,
  getProjectLaborCategories,
  getProjectLocations,
  getProjectPlanSets,
  getProjectStatuses,
  getProjectTask,
  getProjectTaskPredecessors,
  getProjectTasks: getProjectTasks$1,
  getProjectTypes,
  searchProjectAssignments: searchProjectAssignments$1,
  searchProjects: searchProjects$1,
  searchTasks: searchTasks$1,
  updateProject: updateProject$1,
  updateProjectAssignment: updateProjectAssignment$1,
  updateProjectTask: updateProjectTask$1,
  updateProjectTaskPredecessor: updateProjectTaskPredecessor$1
}, Symbol.toStringTag, { value: "Module" }));
const getProperties = async (...keys2) => post(`/config/properties`, { keys: keys2 });
const properties$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getProperties
}, Symbol.toStringTag, { value: "Module" }));
const createPropertyTemplate$1 = async (model) => post("/config/property-templates", model);
const updatePropertyTemplate$1 = async (model) => put(`/config/property-templates/${model.key}`, model);
const getPropertyTemplate = async (templateKey) => get$1(`/config/property-templates/${templateKey}`);
const fetchPropertyTemplatesList = async ({
  page = 1,
  pageSize: pageSize2 = 100,
  includeInactive = true
}) => get$1(
  url("/config/property-templates", { page, pageSize: pageSize2, includeInactive })
);
const getPropertyTemplateHistory = async ({
  templateKey,
  page = 1,
  pageSize: pageSize2 = 100
}) => get$1(
  url(`/config/property-templates/${templateKey}/history`, { page, pageSize: pageSize2 })
);
const deletePropertyTemplate$1 = async ({
  templateKey
}) => destroy(`/config/property-templates/${templateKey}`);
const getTemplateOrgHistory = async ({
  templateKey,
  page = 1,
  pageSize: pageSize2 = 100
}) => get$1(
  url(`/config/property-templates/${templateKey}/legal-entities/history`, {
    page,
    pageSize: pageSize2
  })
);
const propertyTemplates = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createPropertyTemplate: createPropertyTemplate$1,
  deletePropertyTemplate: deletePropertyTemplate$1,
  fetchPropertyTemplatesList,
  getPropertyTemplate,
  getPropertyTemplateHistory,
  getTemplateOrgHistory,
  updatePropertyTemplate: updatePropertyTemplate$1
}, Symbol.toStringTag, { value: "Module" }));
const bulkPurchaseOrderLaborAssignmentNotifications = async (purchaseOrderKey, descriptorKey, projectKey) => post(
  url(
    `/purchase-orders/${purchaseOrderKey}/labor/${descriptorKey}/assignments/notify`,
    {
      projKey: projectKey ?? ""
    }
  )
);
const createPurchaseOrderExpenseAssignment = async (purchaseOrderKey, descriptorKey, params) => post(
  `/purchase-orders/${purchaseOrderKey}/expenses/${descriptorKey}/assignments`,
  params
);
const createPurchaseOrderLaborAssignment = async (purchaseOrderKey, descriptorKey, params) => post(
  `/purchase-orders/${purchaseOrderKey}/labor/${descriptorKey}/assignments`,
  params
);
const deletePurchaseOrderExpenseAssignment = async (purchaseOrderKey, descriptorKey, assignmentKey) => destroy(
  `/purchase-orders/${purchaseOrderKey}/expenses/${descriptorKey}/assignments/${assignmentKey}`
);
const deletePurchaseOrderLaborAssignment = async (purchaseOrderKey, descriptorKey, assignmentKey) => destroy(
  `/purchase-orders/${purchaseOrderKey}/labor/${descriptorKey}/assignments/${assignmentKey}`
);
const getAvailableVendors = async ({
  page,
  pageSize: pageSize2,
  name,
  code,
  active = true,
  legalEntityKeys
}) => get$1(
  url("/purchase-orders/available-vendors", {
    page,
    pageSize: pageSize2,
    name,
    code,
    active,
    legalEntityId: legalEntityKeys
  })
);
const getLegalEntities = async ({
  page,
  pageSize: pageSize2,
  active = true
}) => get$1(
  url("/purchase-orders/legal-entities", {
    page,
    pageSize: pageSize2,
    active
  })
);
const getPurchaseOrder$1 = async (purchaseOrderKey) => get$1(`/purchase-orders/${purchaseOrderKey}`);
const getPurchaseOrderAttachments = async ({
  purchaseOrderKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/purchase-orders/${purchaseOrderKey}/attachments`, { page, pageSize: pageSize2 })
);
const getPurchaseOrderBalances$1 = async (purchaseOrderKey) => get$1(
  `/purchase-orders/${purchaseOrderKey}/balances`
);
const getPurchaseOrderExpenses$1 = async ({
  purchaseOrderKey,
  page = 1,
  pageSize: pageSize2 = 1e3
}) => get$1(
  url(`/purchase-orders/${purchaseOrderKey}/expenses`, {
    page,
    pageSize: pageSize2
  })
);
const getPurchaseOrderExpenseAssignments$1 = async (purchaseOrderKey, page = 1, pageSize2 = 100) => get$1(
  url(`/purchase-orders/${purchaseOrderKey}/expenses/assignments`, {
    page,
    pageSize: pageSize2
  })
);
const getPurchaseOrderItems$1 = async ({
  purchaseOrderKey,
  page = 1,
  pageSize: pageSize2 = 1e3
}) => get$1(
  url(`/purchase-orders/${purchaseOrderKey}/items`, {
    page,
    pageSize: pageSize2
  })
);
const getPurchaseOrderLabor$1 = async ({
  purchaseOrderKey,
  page = 1,
  pageSize: pageSize2 = 1e3
}) => get$1(
  url(`/purchase-orders/${purchaseOrderKey}/labor`, {
    page,
    pageSize: pageSize2
  })
);
const getPurchaseOrderLaborAssignments$1 = async ({
  purchaseOrderKey,
  laborLineKey,
  page,
  pageSize: pageSize2 = 100
}) => get$1(
  url(`/purchase-orders/${purchaseOrderKey}/labor/assignments`, {
    page,
    pageSize: pageSize2,
    lineId: laborLineKey
  })
);
const getPurchaseOrderVIBalances$1 = async (purchaseOrderKey) => get$1(
  `/purchase-orders/${purchaseOrderKey}/vendor-invoices/balances`
);
const searchPurchaseOrders$1 = async (page, pageSize2, query) => post(
  url("/purchase-orders/search", { page, pageSize: pageSize2 }),
  query
);
const updatePurchaseOrderExpenseAssignment = async (purchaseOrderKey, descriptorKey, assignmentKey, params) => put(
  `/purchase-orders/${purchaseOrderKey}/expenses/${descriptorKey}/assignments/${assignmentKey}`,
  params
);
const updatePurchaseOrderLaborAssignment = async (purchaseOrderKey, descriptorKey, assignmentKey, notify = false, params) => put(
  url(
    `/purchase-orders/${purchaseOrderKey}/labor/${descriptorKey}/assignments/${assignmentKey}`,
    {
      notify
    }
  ),
  params
);
const purchaseOrders = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bulkPurchaseOrderLaborAssignmentNotifications,
  createPurchaseOrderExpenseAssignment,
  createPurchaseOrderLaborAssignment,
  deletePurchaseOrderExpenseAssignment,
  deletePurchaseOrderLaborAssignment,
  getAvailableVendors,
  getLegalEntities,
  getPurchaseOrder: getPurchaseOrder$1,
  getPurchaseOrderAttachments,
  getPurchaseOrderBalances: getPurchaseOrderBalances$1,
  getPurchaseOrderExpenseAssignments: getPurchaseOrderExpenseAssignments$1,
  getPurchaseOrderExpenses: getPurchaseOrderExpenses$1,
  getPurchaseOrderItems: getPurchaseOrderItems$1,
  getPurchaseOrderLabor: getPurchaseOrderLabor$1,
  getPurchaseOrderLaborAssignments: getPurchaseOrderLaborAssignments$1,
  getPurchaseOrderVIBalances: getPurchaseOrderVIBalances$1,
  searchPurchaseOrders: searchPurchaseOrders$1,
  updatePurchaseOrderExpenseAssignment,
  updatePurchaseOrderLaborAssignment
}, Symbol.toStringTag, { value: "Module" }));
const completeReceipt$1 = async (receiptKey) => post(`/receiving-documents/${receiptKey}/complete`);
const createReceipt$1 = async (model) => post("/receiving-documents", model);
const createReceiptAttachment = async ({
  receiptKey,
  attachment
}) => post(
  `/receiving-documents/${receiptKey}/attachments`,
  attachment
);
const createReceiptItem$1 = async ({
  receiptKey,
  model
}) => post(`/receiving-documents/${receiptKey}/items`, model);
const deleteReceipt$1 = async ({ receiptKey }) => destroy(`/receiving-documents/${receiptKey}`);
const deleteReceiptAttachment$1 = async ({
  receiptKey,
  attachmentKey
}) => destroy(
  `/receiving-documents/${receiptKey}/attachments/${attachmentKey}`
);
const deleteReceiptItem$1 = async ({
  receiptKey,
  itemKey
}) => destroy(`/receiving-documents/${receiptKey}/items/${itemKey}`);
const getReceipt$1 = async (receiptKey) => get$1(`/receiving-documents/${receiptKey}`);
const getReceiptAttachment$1 = async ({
  receiptKey,
  attachmentKey
}) => get$1(
  `/receiving-documents/${receiptKey}/attachments/${attachmentKey}`
);
const getReceiptAttachments$1 = async ({
  receiptKey,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/receiving-documents/${receiptKey}/attachments`, { page, pageSize: pageSize2 })
);
const getReceiptItem$1 = async ({
  receiptKey,
  itemKey
}) => get$1(
  `/receiving-documents/${receiptKey}/items/${itemKey}`
);
const getReceiptItems = async ({
  receiptKey,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/receiving-documents/${receiptKey}/items`, { page, pageSize: pageSize2 })
);
const getReceiptPurchaseOrderItems = async ({
  purchaseOrderKey,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/receiving-documents/purchase-orders/${purchaseOrderKey}/items`, {
    page,
    pageSize: pageSize2
  })
);
const getReceiptLegalEntities = async ({
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/receiving-documents/legal-entities", {
    page,
    pageSize: pageSize2
  })
);
const getReceiptOwningOrgs = async ({
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/receiving-documents/owning-organizations", {
    page,
    pageSize: pageSize2
  })
);
const getReceiptPeople = async ({
  name,
  role,
  page,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/receiving-documents/people", {
    name,
    role,
    page,
    pageSize: pageSize2
  })
);
const getReceiptProjects = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/receiving-documents/projects", {
    page,
    pageSize: pageSize2
  })
);
const getReceiptVendors = async ({
  legalEntityKeys,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/receiving-documents/vendors", {
    legalEntityId: legalEntityKeys,
    page,
    pageSize: pageSize2
  })
);
const updateReceiptItem$1 = async ({
  receiptKey,
  item
}) => put(`/receiving-documents/${receiptKey}/items/${item.key}`, item);
const searchReceipts$1 = async ({
  params,
  page,
  pageSize: pageSize2
}) => post(
  url("/receiving-documents/search", { page, pageSize: pageSize2 }),
  params
);
const searchReceiptPurchaseOrders$1 = async ({
  params,
  page,
  pageSize: pageSize2
}) => post(
  url("/receiving-documents/purchase-orders", { page, pageSize: pageSize2 }),
  params
);
const updateReceipt$1 = async (receipt) => put(`/receiving-documents/${receipt.key}`, receipt);
const retractReceipt$1 = async ({ receiptKey }) => post(`/receiving-documents/${receiptKey}/retract`);
const getReceiptsImportDefinition$1 = async () => get$1(`/receiving-documents/import/definition`);
const importReceipts$1 = async (file, {
  dryRun,
  enableProgressFeedback
}) => postFile(
  url("/receiving-documents/import", { dryRun, enableProgressFeedback }),
  file
);
const receipts = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  completeReceipt: completeReceipt$1,
  createReceipt: createReceipt$1,
  createReceiptAttachment,
  createReceiptItem: createReceiptItem$1,
  deleteReceipt: deleteReceipt$1,
  deleteReceiptAttachment: deleteReceiptAttachment$1,
  deleteReceiptItem: deleteReceiptItem$1,
  getReceipt: getReceipt$1,
  getReceiptAttachment: getReceiptAttachment$1,
  getReceiptAttachments: getReceiptAttachments$1,
  getReceiptItem: getReceiptItem$1,
  getReceiptItems,
  getReceiptLegalEntities,
  getReceiptOwningOrgs,
  getReceiptPeople,
  getReceiptProjects,
  getReceiptPurchaseOrderItems,
  getReceiptVendors,
  getReceiptsImportDefinition: getReceiptsImportDefinition$1,
  importReceipts: importReceipts$1,
  retractReceipt: retractReceipt$1,
  searchReceiptPurchaseOrders: searchReceiptPurchaseOrders$1,
  searchReceipts: searchReceipts$1,
  updateReceipt: updateReceipt$1,
  updateReceiptItem: updateReceiptItem$1
}, Symbol.toStringTag, { value: "Module" }));
const fetchSocioeconomicStatuses$1 = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url("/socioeconomic-statuses", { page, pageSize: pageSize2 })
);
const socioeconomicStatus = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchSocioeconomicStatuses: fetchSocioeconomicStatuses$1
}, Symbol.toStringTag, { value: "Module" }));
const fetchStatisticalAccounts = async ({
  entryAllowed = true,
  page,
  pageSize: pageSize2 = 100
}) => get$1(
  url("/statistical-accounts", { entryAllowed, page, pageSize: pageSize2 })
);
const statisticalAccounts = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchStatisticalAccounts
}, Symbol.toStringTag, { value: "Module" }));
const searchStatisticalJournals$1 = async ({
  searchQuery,
  page,
  pageSize: pageSize2
}) => post(
  url("/statistical-account-journal-entries/search", { page, pageSize: pageSize2 }),
  searchQuery
);
const fetchStatisticalJournalLegalEntities = async ({
  page,
  pageSize: pageSize2
}) => get$1(
  url("/statistical-account-journal-entries/legal-entities", {
    page,
    pageSize: pageSize2
  })
);
const fetchStatisticalJournalOrganizations = async ({
  legalEntityKey,
  page,
  pageSize: pageSize2
}) => get$1(
  url(
    `/statistical-account-journal-entries/legal-entities/${legalEntityKey}/organizations`,
    {
      page,
      pageSize: pageSize2
    }
  )
);
const fetchStatisticalJournalLegalEntityFiscalPeriods = async ({
  legalEntityKey,
  includeClosedPeriods,
  page,
  pageSize: pageSize2
}) => get$1(
  url(
    `/statistical-account-journal-entries/legal-entities/${legalEntityKey}/fiscal-periods`,
    {
      includeClosedPeriods,
      page,
      pageSize: pageSize2
    }
  )
);
const getStatisticalJournalEntry$1 = async ({ key }) => get$1(
  `/statistical-account-journal-entries/${key}`
);
const createStatisticalJournalEntry$1 = async ({
  requestBody
}) => post(
  "/statistical-account-journal-entries",
  requestBody
);
const updateStatisticalJournalEntry$1 = async ({
  key,
  requestBody
}) => put(`/statistical-account-journal-entries/${key}`, requestBody);
const getStatisticalJournalEntryDetails$1 = async ({
  key,
  page,
  pageSize: pageSize2
}) => get$1(
  url(`/statistical-account-journal-entries/${key}/details`, {
    page,
    pageSize: pageSize2
  })
);
const createStatisticalJournalEntryDetails$1 = async ({
  key,
  requestBody
}) => post(
  `/statistical-account-journal-entries/${key}/details`,
  requestBody
);
const updateStatisticalJournalEntryDetails$1 = async ({
  key,
  requestBody
}) => put(`/statistical-account-journal-entries/${key}/details`, requestBody);
const putStatisticalJournalEntryInUse$1 = async ({
  key
}) => post(`/statistical-account-journal-entries/${key}/put-inuse`);
const submitStatisticalJournalEntry$1 = async ({ key }) => post(`/statistical-account-journal-entries/${key}/submit`);
const postStatisticalJournalEntry$1 = async ({ key }) => post(`/statistical-account-journal-entries/${key}/post`);
const voidStatisticalJournalEntry$1 = async ({
  key,
  requestBody
}) => post(`/statistical-account-journal-entries/${key}/void`, requestBody);
const validateForSubmit$1 = async ({
  documentKey
}) => get$1(
  `/statistical-account-journal-entries/${documentKey}/submit/validate`
);
const validateForPost$1 = async ({
  documentKey
}) => get$1(
  `/statistical-account-journal-entries/${documentKey}/post/validate`
);
const deleteStatisticalJournalEntry$1 = async ({ key }) => destroy(`/statistical-account-journal-entries/${key}`);
const deleteStatisticalJournalEntryDetail$1 = async ({
  key,
  lineId
}) => destroy(
  `/statistical-account-journal-entries/${key}/details/${lineId}`
);
const fetchStatisticalJournalAttachments$1 = async ({
  documentKey,
  page,
  pageSize: pageSize2
}) => get$1(
  url(`/statistical-account-journal-entries/${documentKey}/attachments`, {
    page,
    pageSize: pageSize2
  })
);
const fetchStatisticalJournalAttachment$1 = async ({
  attachmentKey,
  documentKey
}) => get$1(
  `/statistical-account-journal-entries/${documentKey}/attachments/${attachmentKey}`
);
const createStatisticalJournalAttachment = async ({
  attachment,
  documentKey
}) => post(
  `/statistical-account-journal-entries/${documentKey}/attachments`,
  attachment
);
const deleteStatisticalJournalAttachment$1 = async ({
  attachmentKey,
  documentKey
}) => destroy(
  `/statistical-account-journal-entries/${documentKey}/attachments/${attachmentKey}`
);
const statisticalAccountJournals = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createStatisticalJournalAttachment,
  createStatisticalJournalEntry: createStatisticalJournalEntry$1,
  createStatisticalJournalEntryDetails: createStatisticalJournalEntryDetails$1,
  deleteStatisticalJournalAttachment: deleteStatisticalJournalAttachment$1,
  deleteStatisticalJournalEntry: deleteStatisticalJournalEntry$1,
  deleteStatisticalJournalEntryDetail: deleteStatisticalJournalEntryDetail$1,
  fetchStatisticalJournalAttachment: fetchStatisticalJournalAttachment$1,
  fetchStatisticalJournalAttachments: fetchStatisticalJournalAttachments$1,
  fetchStatisticalJournalLegalEntities,
  fetchStatisticalJournalLegalEntityFiscalPeriods,
  fetchStatisticalJournalOrganizations,
  getStatisticalJournalEntry: getStatisticalJournalEntry$1,
  getStatisticalJournalEntryDetails: getStatisticalJournalEntryDetails$1,
  postStatisticalJournalEntry: postStatisticalJournalEntry$1,
  putStatisticalJournalEntryInUse: putStatisticalJournalEntryInUse$1,
  searchStatisticalJournals: searchStatisticalJournals$1,
  submitStatisticalJournalEntry: submitStatisticalJournalEntry$1,
  updateStatisticalJournalEntry: updateStatisticalJournalEntry$1,
  updateStatisticalJournalEntryDetails: updateStatisticalJournalEntryDetails$1,
  validateForPost: validateForPost$1,
  validateForSubmit: validateForSubmit$1,
  voidStatisticalJournalEntry: voidStatisticalJournalEntry$1
}, Symbol.toStringTag, { value: "Module" }));
const approveTimesheetAsManager$1 = async ({
  timesheetKey,
  projectKey,
  comment: comment2
}) => post(`/me/approvals/time/manager/${timesheetKey}/approve`, {
  projectKey,
  comment: comment2
});
const createMyTimesheet$1 = async ({
  date,
  ownerKey
}) => post(url(`/me/time`, { ownerKey }), { date });
const createTimesheet$1 = async ({
  date,
  ownerKey
}) => post(url(`/time`, { ownerKey }), { date });
const deleteMyTimesheet$1 = async ({
  timesheetKey
}) => destroy(`/me/time/${timesheetKey}`);
const deleteTimesheet$1 = async ({
  timesheetKey
}) => destroy(`/time/${timesheetKey}`);
const disapproveTimesheetAsManager$1 = async ({
  timesheetKey,
  disapproveInfo
}) => post(
  `/me/approvals/time/manager/${timesheetKey}/disapprove`,
  disapproveInfo
);
const reviewMyTimesheet$1 = async ({
  comment: comment2,
  timesheetKey
}) => post(`/me/reviews/time/${timesheetKey}`, {
  // projectKey intentionally omitted — platform rejects non-null for owner review
  comment: comment2 || void 0
});
const getMyTimesheet$1 = async (id) => get$1(`/me/time/${id}`);
const getTimePeriods = async ({
  personKey,
  page,
  pageSize: pageSize2 = 50,
  start: start2,
  end: end2,
  includeProjected = false
}) => get$1(
  url(`/time/available-time-periods`, {
    personKey,
    page,
    pageSize: pageSize2,
    start: start2,
    end: end2,
    includeProjected
  })
);
const getMyTimesheetHistory$1 = async ({
  timesheetKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/me/time/${timesheetKey}/history`, { page, pageSize: pageSize2 })
);
const getMyTimesheets$1 = async ({
  active,
  page,
  pageSize: pageSize2,
  sortBy: sortBy2,
  sortOrder
}) => get$1(
  url(`/me/time`, { active, page, pageSize: pageSize2, sortBy: sortBy2, sortOrder })
);
const getTimesheet$1 = async (id) => get$1(`/time/${id}`);
const getTimesheetAdjustments$1 = async ({
  timesheetKey,
  projectKey,
  adjustmentTypes
}) => get$1(
  url(`/time/${timesheetKey}/adjustments`, {
    projectId: projectKey,
    type: adjustmentTypes
  })
);
const getMyTimesheetAdjustments = async ({
  timesheetKey,
  projectKey,
  adjustmentTypes
}) => get$1(
  url(`/me/time/${timesheetKey}/adjustments`, {
    projectId: projectKey,
    type: adjustmentTypes
  })
);
const getTimesheetAudits = async ({
  timesheetKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/time/${timesheetKey}/audit`, { page, pageSize: pageSize2 })
);
const fetchAllTimesheetAudits = async ({
  timesheetKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  fetch: (page) => () => getTimesheetAudits({ timesheetKey, page, pageSize: pageSize2 }),
  errorMessage: "Retrieving timesheet audit history failed"
});
const getTimesheetHistory$1 = async ({
  timesheetKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/time/${timesheetKey}/history`, { page, pageSize: pageSize2 })
);
const getTimesheetProjectLaborCategories = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  projectKey,
  timesheetKey
}) => get$1(
  url(`/time/${timesheetKey}/projects/${projectKey}/labor-categories`, {
    page,
    pageSize: pageSize2
  })
);
const getTimesheetProjectLocations = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  projectKey,
  timesheetKey
}) => get$1(
  url(`/time/${timesheetKey}/projects/${projectKey}/locations`, {
    page,
    pageSize: pageSize2
  })
);
const getTimesheetProjects = async ({
  timesheetKey,
  page,
  pageSize: pageSize2
}) => get$1(
  url(`/time/${timesheetKey}/projects`, { page, pageSize: pageSize2 })
);
const getTimesheetProjectTypes = async ({
  timesheetKey,
  page,
  pageSize: pageSize2
}) => get$1(
  url(`/time/${timesheetKey}/project-types`, { page, pageSize: pageSize2 })
);
const getTimesheetsForApproval = async (page, pageSize2) => get$1(
  url("/me/approvals/time/manager", { page, pageSize: pageSize2 })
);
const getTimesheetTaskLaborCategories = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  taskKey,
  timesheetKey
}) => get$1(
  url(`/time/${timesheetKey}/tasks/${taskKey}/labor-categories`, {
    page,
    pageSize: pageSize2
  })
);
const getTimesheetTaskLocations = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  taskKey,
  timesheetKey
}) => get$1(
  url(`/time/${timesheetKey}/tasks/${taskKey}/locations`, {
    page,
    pageSize: pageSize2
  })
);
const searchMyTimesheets = async (page = 1, pageSize2 = 50, params) => post(
  url("/me/time/search", { page, pageSize: pageSize2 }),
  params
);
const searchTimesheets = async (page = 1, pageSize2 = 50, params) => post(
  url("/time/search", { page, pageSize: pageSize2 }),
  params
);
const searchTimePeriods = async ({
  timePeriodSetupKey,
  page = 1,
  pageSize: pageSize2 = 50,
  searchCriteria = {}
}) => post(
  url(`/time-periods-setup/${timePeriodSetupKey}/time-periods/search`, {
    page,
    pageSize: pageSize2
  }),
  searchCriteria
);
const submitTimesheet$1 = async ({
  timesheetKey,
  submitInfo
}) => post(`/time/${timesheetKey}/submit`, submitInfo);
const submitMyTimesheet$1 = async ({
  timesheetKey,
  submitInfo
}) => post(`/me/time/${timesheetKey}/submit`, submitInfo);
const updateTimesheet$1 = async (timesheet) => put(`/time/${timesheet.key}`, timesheet);
const updateMyTimesheet$1 = async ({
  timesheet
}) => put(`/me/time/${timesheet.key}`, timesheet);
const updateAdjustmentReasons = async ({
  reasons,
  timesheetKey
}) => post(`/time/${timesheetKey}/adjustments/reason`, reasons);
const updateMyAdjustmentReasons = async ({
  reasons,
  timesheetKey
}) => post(`/me/time/${timesheetKey}/adjustments/reason`, reasons);
const updateAuditComments = async ({
  comments,
  timesheetKey
}) => post(`/time/${timesheetKey}/audit/comment`, comments);
const updateMyAuditComments = async ({
  comments,
  timesheetKey
}) => post(`/me/time/${timesheetKey}/audit/comment`, comments);
const validateMyTimesheet$1 = async ({
  key,
  submitValidation = false
}) => get$1(
  `/me/time/${key}/validate?submitValidation=${submitValidation}`
);
const getTimeAttachments = async ({
  timesheetKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => get$1(
  url(`/me/time/${timesheetKey}/attachments`, { page, pageSize: pageSize2 })
);
const getTimesheetAutofillRows = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  timesheetKey
}) => get$1(
  url(`/time/${timesheetKey}/auto-fill`, {
    page,
    pageSize: pageSize2
  })
);
const getDeletedTimesheetAutofillRows = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  timesheetKey
}) => get$1(
  url(`/time/${timesheetKey}/auto-fill/deleted`, {
    page,
    pageSize: pageSize2
  })
);
const deleteTimesheetAutofillRow$1 = async ({
  autofillRow,
  timesheetKey
}) => post(`/time/${timesheetKey}/auto-fill`, autofillRow);
const validateTimesheet$1 = async ({
  key,
  submitValidation = false
}) => get$1(
  `/time/${key}/validate?submitValidation=${submitValidation}`
);
const time = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  approveTimesheetAsManager: approveTimesheetAsManager$1,
  createMyTimesheet: createMyTimesheet$1,
  createTimesheet: createTimesheet$1,
  deleteMyTimesheet: deleteMyTimesheet$1,
  deleteTimesheet: deleteTimesheet$1,
  deleteTimesheetAutofillRow: deleteTimesheetAutofillRow$1,
  disapproveTimesheetAsManager: disapproveTimesheetAsManager$1,
  fetchAllTimesheetAudits,
  getDeletedTimesheetAutofillRows,
  getMyTimesheet: getMyTimesheet$1,
  getMyTimesheetAdjustments,
  getMyTimesheetHistory: getMyTimesheetHistory$1,
  getMyTimesheets: getMyTimesheets$1,
  getTimeAttachments,
  getTimePeriods,
  getTimesheet: getTimesheet$1,
  getTimesheetAdjustments: getTimesheetAdjustments$1,
  getTimesheetAudits,
  getTimesheetAutofillRows,
  getTimesheetHistory: getTimesheetHistory$1,
  getTimesheetProjectLaborCategories,
  getTimesheetProjectLocations,
  getTimesheetProjectTypes,
  getTimesheetProjects,
  getTimesheetTaskLaborCategories,
  getTimesheetTaskLocations,
  getTimesheetsForApproval,
  reviewMyTimesheet: reviewMyTimesheet$1,
  searchMyTimesheets,
  searchTimePeriods,
  searchTimesheets,
  submitMyTimesheet: submitMyTimesheet$1,
  submitTimesheet: submitTimesheet$1,
  updateAdjustmentReasons,
  updateAuditComments,
  updateMyAdjustmentReasons,
  updateMyAuditComments,
  updateMyTimesheet: updateMyTimesheet$1,
  updateTimesheet: updateTimesheet$1,
  validateMyTimesheet: validateMyTimesheet$1,
  validateTimesheet: validateTimesheet$1
}, Symbol.toStringTag, { value: "Module" }));
const getCoreUserInfo$1 = async () => get$1("USER_INFO");
const getMyMenu$1 = async ({ menuId } = {}) => {
  if (menuId) {
    return get$1(`/menu?menuId=${menuId}`, `menu?menuId=${menuId}`);
  } else {
    return get$1("/menu", "menu");
  }
};
const getLicenseHolder$1 = async () => get$1("/licenseHolder", "licenseHolder");
const unanetCore = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getCoreUserInfo: getCoreUserInfo$1,
  getLicenseHolder: getLicenseHolder$1,
  getMyMenu: getMyMenu$1
}, Symbol.toStringTag, { value: "Module" }));
const createVendorInvoice$1 = async (requestBody) => post(`/vendor-invoices`, requestBody);
const createVendorInvoiceFormat$1 = async (requestBody) => post(`/vendor-invoices/formats`, requestBody);
const createVendorInvoiceFormatSection$1 = async (key, requestBody) => post(
  `/vendor-invoices/formats/${key}/sections`,
  requestBody
);
const deleteVendorInvoiceFormat$1 = async (key) => destroy(`/vendor-invoices/formats/${key}`);
const editVendorInvoiceFormat$1 = async (requestBody) => put(`/vendor-invoices/formats/${requestBody.key}`, requestBody);
const editVendorInvoiceFormatSection$1 = async (requestBody) => put(
  `/vendor-invoices/formats/${requestBody.vendorInvoiceFormatKey}/sections/${requestBody.key}`,
  requestBody
);
const fetchVendorInvoice$1 = async ({
  vendorInvoiceKey
}) => get$1(`/vendor-invoices/${vendorInvoiceKey}`);
const fetchVendorInvoiceFormatByKey$1 = async (key) => get$1(`/vendor-invoices/formats/${key}`);
const fetchVendorInvoiceFormats$1 = async (page = 1, pageSize2 = 50) => get$1(
  url("/vendor-invoices/formats", { page, pageSize: pageSize2 })
);
const fetchVendorInvoiceFormatSections = async (key) => get$1(
  `/vendor-invoices/formats/${key}/sections`
);
const fetchVendorInvoiceExpenseProjects$1 = async ({
  legalEntityKey,
  page,
  pageSize: pageSize2
}) => get$1(
  url(`/vendor-invoices/legal-entities/${legalEntityKey}/projects/expense`, {
    page,
    pageSize: pageSize2
  })
);
const fetchVendorInvoiceItemProjects$1 = async ({
  legalEntityKey,
  page,
  pageSize: pageSize2
}) => get$1(
  url(`/vendor-invoices/legal-entities/${legalEntityKey}/projects/item`, {
    page,
    pageSize: pageSize2
  })
);
const fetchVendorInvoiceLaborProjects$1 = async ({
  legalEntityKey,
  page,
  pageSize: pageSize2
}) => get$1(
  url(`/vendor-invoices/legal-entities/${legalEntityKey}/projects/labor`, {
    page,
    pageSize: pageSize2
  })
);
const fetchVendorInvoiceLegalEntityVendors$1 = async ({
  legalEntityKey,
  name,
  page,
  pageSize: pageSize2
}) => (
  //There's a bug in platform where the swagger definition thinks this route returns
  //a KeyNameModel instead of a VIVendorModel. We will map feature layer.
  get$1(
    url(`/vendor-invoices/legal-entities/${legalEntityKey}/vendors`, {
      name,
      page,
      pageSize: pageSize2
    })
  )
);
const fetchVendorInvoiceLegalEntityFiscalPeriods = async ({
  legalEntityKey,
  includeClosedPeriods,
  page,
  pageSize: pageSize2
}) => get$1(
  url(`/vendor-invoices/legal-entities/${legalEntityKey}/fiscal-periods`, {
    includeClosedPeriods,
    page,
    pageSize: pageSize2
  })
);
const fetchVendorInvoiceLegalEntityAPDefaults$1 = async ({
  id
}) => get$1(
  `/vendor-invoices/legal-entities/${id}/ap-defaults`
);
const postVendorInvoice$1 = async ({ viKey }) => post(`/vendor-invoices/${viKey}/post`);
const postVendorInvoiceValidate$1 = async ({ viKey }) => get$1(
  `/vendor-invoices/${viKey}/post/validate`
);
const submitVendorInvoice$1 = async ({
  approvalGroupKey,
  body,
  viKey
}) => post(
  url(`/vendor-invoices/${viKey}/submit`, {
    approvalGroupId: approvalGroupKey
  }),
  body
);
const vendorInvoices = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createVendorInvoice: createVendorInvoice$1,
  createVendorInvoiceFormat: createVendorInvoiceFormat$1,
  createVendorInvoiceFormatSection: createVendorInvoiceFormatSection$1,
  deleteVendorInvoiceFormat: deleteVendorInvoiceFormat$1,
  editVendorInvoiceFormat: editVendorInvoiceFormat$1,
  editVendorInvoiceFormatSection: editVendorInvoiceFormatSection$1,
  fetchVendorInvoice: fetchVendorInvoice$1,
  fetchVendorInvoiceExpenseProjects: fetchVendorInvoiceExpenseProjects$1,
  fetchVendorInvoiceFormatByKey: fetchVendorInvoiceFormatByKey$1,
  fetchVendorInvoiceFormatSections,
  fetchVendorInvoiceFormats: fetchVendorInvoiceFormats$1,
  fetchVendorInvoiceItemProjects: fetchVendorInvoiceItemProjects$1,
  fetchVendorInvoiceLaborProjects: fetchVendorInvoiceLaborProjects$1,
  fetchVendorInvoiceLegalEntityAPDefaults: fetchVendorInvoiceLegalEntityAPDefaults$1,
  fetchVendorInvoiceLegalEntityFiscalPeriods,
  fetchVendorInvoiceLegalEntityVendors: fetchVendorInvoiceLegalEntityVendors$1,
  postVendorInvoice: postVendorInvoice$1,
  postVendorInvoiceValidate: postVendorInvoiceValidate$1,
  submitVendorInvoice: submitVendorInvoice$1
}, Symbol.toStringTag, { value: "Module" }));
const perf = typeof performance === "object" && performance && typeof performance.now === "function" ? performance : Date;
const now = () => perf.now();
const isPosInt = (n12) => !!n12 && n12 === Math.floor(n12) && n12 > 0 && isFinite(n12);
const isPosIntOrInf = (n12) => n12 === Infinity || isPosInt(n12);
const TIMER_MAX = 2 ** 31 - 1;
class TTLCache {
  expirations = /* @__PURE__ */ Object.create(null);
  data = /* @__PURE__ */ new Map();
  expirationMap = /* @__PURE__ */ new Map();
  ttl;
  max;
  updateAgeOnGet;
  updateAgeOnHas;
  noUpdateTTL;
  noDisposeOnSet;
  checkAgeOnGet;
  checkAgeOnHas;
  dispose;
  timer;
  timerExpiration;
  immortalKeys = /* @__PURE__ */ new Set();
  constructor({ max: max2 = Infinity, ttl, updateAgeOnGet = false, checkAgeOnGet = false, updateAgeOnHas = false, checkAgeOnHas = false, noUpdateTTL = false, dispose, noDisposeOnSet = false } = {}) {
    if (ttl !== void 0 && !isPosIntOrInf(ttl)) {
      throw new TypeError("ttl must be positive integer or Infinity if set");
    }
    if (!isPosIntOrInf(max2)) {
      throw new TypeError("max must be positive integer or Infinity");
    }
    this.ttl = ttl;
    this.max = max2;
    this.updateAgeOnGet = !!updateAgeOnGet;
    this.checkAgeOnGet = !!checkAgeOnGet;
    this.updateAgeOnHas = !!updateAgeOnHas;
    this.checkAgeOnHas = !!checkAgeOnHas;
    this.noUpdateTTL = !!noUpdateTTL;
    this.noDisposeOnSet = !!noDisposeOnSet;
    if (dispose !== void 0) {
      if (typeof dispose !== "function") {
        throw new TypeError("dispose must be function if set");
      }
      this.dispose = dispose;
    } else {
      this.dispose = (_, __2, ___) => {
      };
    }
    this.timer = void 0;
    this.timerExpiration = void 0;
  }
  setTimer(expiration, ttl) {
    if (this.timerExpiration && this.timerExpiration < expiration) {
      return;
    }
    if (this.timer) {
      clearTimeout(this.timer);
    }
    const t16 = setTimeout(() => {
      this.timer = void 0;
      this.timerExpiration = void 0;
      this.purgeStale();
      for (const exp in this.expirations) {
        const e = Number(exp);
        this.setTimer(e, e - now());
        break;
      }
    }, Math.min(TIMER_MAX, Math.max(0, ttl)));
    if (t16.unref)
      t16.unref();
    this.timerExpiration = expiration;
    this.timer = t16;
  }
  // hang onto the timer so we can clearTimeout if all items
  // are deleted.  Deno doesn't have Timer.unref(), so it
  // hangs otherwise.
  cancelTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timerExpiration = void 0;
      this.timer = void 0;
    }
  }
  /* c8 ignore start */
  cancelTimers() {
    process.emitWarning('TTLCache.cancelTimers has been renamed to TTLCache.cancelTimer (no "s"), and will be removed in the next major version update');
    return this.cancelTimer();
  }
  /* c8 ignore stop */
  clear() {
    const entries2 = this.dispose !== TTLCache.prototype.dispose ? [...this] : [];
    this.data.clear();
    this.expirationMap.clear();
    this.cancelTimer();
    this.expirations = /* @__PURE__ */ Object.create(null);
    for (const [key, val] of entries2) {
      this.dispose(val, key, "delete");
    }
  }
  setTTL(key, ttl = this.ttl) {
    const current = this.expirationMap.get(key);
    if (current !== void 0) {
      const exp = this.expirations[current];
      if (!exp || exp.length <= 1) {
        delete this.expirations[current];
      } else {
        this.expirations[current] = exp.filter((k) => k !== key);
      }
    }
    if (ttl && ttl !== Infinity) {
      this.immortalKeys.delete(key);
      const expiration = Math.floor(now() + ttl);
      this.expirationMap.set(key, expiration);
      if (!this.expirations[expiration]) {
        this.expirations[expiration] = [];
        this.setTimer(expiration, ttl);
      }
      this.expirations[expiration].push(key);
    } else {
      this.immortalKeys.add(key);
      this.expirationMap.set(key, Infinity);
    }
  }
  set(key, val, { ttl = this.ttl, noUpdateTTL = this.noUpdateTTL, noDisposeOnSet = this.noDisposeOnSet } = {}) {
    if (!isPosIntOrInf(ttl)) {
      throw new TypeError("ttl must be positive integer or Infinity");
    }
    if (this.expirationMap.has(key)) {
      if (!noUpdateTTL) {
        this.setTTL(key, ttl);
      }
      const oldValue = this.data.get(key);
      const disp = !noDisposeOnSet && this.data.has(key);
      if (oldValue !== val) {
        this.data.set(key, val);
        if (disp) {
          this.dispose(oldValue, key, "set");
        }
      }
    } else {
      this.setTTL(key, ttl);
      this.data.set(key, val);
    }
    while (this.size > this.max) {
      this.purgeToCapacity();
    }
    return this;
  }
  has(key, { checkAgeOnHas = this.checkAgeOnHas, ttl = this.ttl, updateAgeOnHas = this.updateAgeOnHas } = {}) {
    if (this.data.has(key)) {
      if (checkAgeOnHas && this.getRemainingTTL(key) === 0) {
        this.delete(key);
        return false;
      }
      if (updateAgeOnHas) {
        this.setTTL(key, ttl);
      }
      return true;
    }
    return false;
  }
  getRemainingTTL(key) {
    const expiration = this.expirationMap.get(key);
    return expiration === Infinity ? expiration : expiration !== void 0 ? Math.max(0, Math.ceil(expiration - now())) : 0;
  }
  get(key, { updateAgeOnGet = this.updateAgeOnGet, ttl = this.ttl, checkAgeOnGet = this.checkAgeOnGet } = {}) {
    const val = this.data.get(key);
    if (checkAgeOnGet && this.getRemainingTTL(key) === 0) {
      this.delete(key);
      return void 0;
    }
    if (updateAgeOnGet) {
      this.setTTL(key, ttl);
    }
    return val;
  }
  delete(key) {
    const current = this.expirationMap.get(key);
    if (current !== void 0) {
      const value = this.data.get(key);
      this.data.delete(key);
      this.expirationMap.delete(key);
      this.immortalKeys.delete(key);
      const exp = this.expirations[current];
      if (exp) {
        if (exp.length <= 1) {
          delete this.expirations[current];
        } else {
          this.expirations[current] = exp.filter((k) => k !== key);
        }
      }
      this.dispose(value, key, "delete");
      if (this.size === 0) {
        this.cancelTimer();
      }
      return true;
    }
    return false;
  }
  purgeToCapacity() {
    for (const exp in this.expirations) {
      const keys2 = this.expirations[exp];
      if (this.size - keys2.length >= this.max) {
        delete this.expirations[exp];
        const entries2 = [];
        for (const key of keys2) {
          entries2.push([key, this.data.get(key)]);
          this.data.delete(key);
          this.expirationMap.delete(key);
        }
        for (const [key, val] of entries2) {
          this.dispose(val, key, "evict");
        }
      } else {
        const s12 = this.size - this.max;
        const entries2 = [];
        for (const key of keys2.splice(0, s12)) {
          entries2.push([key, this.data.get(key)]);
          this.data.delete(key);
          this.expirationMap.delete(key);
        }
        for (const [key, val] of entries2) {
          this.dispose(val, key, "evict");
        }
        return;
      }
    }
  }
  get size() {
    return this.data.size;
  }
  purgeStale() {
    const n12 = Math.ceil(now());
    for (const exp in this.expirations) {
      if (exp === "Infinity" || Number(exp) > n12) {
        return;
      }
      const keys2 = [...this.expirations[exp] || []];
      const entries2 = [];
      delete this.expirations[exp];
      for (const key of keys2) {
        entries2.push([key, this.data.get(key)]);
        this.data.delete(key);
        this.expirationMap.delete(key);
      }
      for (const [key, val] of entries2) {
        this.dispose(val, key, "stale");
      }
    }
    if (this.size === 0) {
      this.cancelTimer();
    }
  }
  *entries() {
    for (const exp in this.expirations) {
      for (const key of this.expirations[exp]) {
        yield [key, this.data.get(key)];
      }
    }
    for (const key of this.immortalKeys) {
      yield [key, this.data.get(key)];
    }
  }
  *keys() {
    for (const exp in this.expirations) {
      for (const key of this.expirations[exp]) {
        yield key;
      }
    }
    for (const key of this.immortalKeys) {
      yield key;
    }
  }
  *values() {
    for (const exp in this.expirations) {
      for (const key of this.expirations[exp]) {
        yield this.data.get(key);
      }
    }
    for (const key of this.immortalKeys) {
      yield this.data.get(key);
    }
  }
  [Symbol.iterator]() {
    return this.entries();
  }
}
const cache = new TTLCache({
  ttl: 5 * 60 * 1e3
});
const cached = (section) => {
  return function decorator(target, context2) {
    const methodName = String(context2.name);
    async function replacementMethod(...args) {
      const cacheKey = `${section}/${methodName}/${JSON.stringify(args)}`;
      if (cache.has(cacheKey)) {
        return cache.get(cacheKey);
      } else {
        const item = await target.call(this, ...args);
        cache.set(cacheKey, item);
        return item;
      }
    }
    return replacementMethod;
  };
};
function clearApiCache(section) {
  if (section) {
    for (const cacheKey of cache.keys()) {
      if (cacheKey.startsWith(section)) {
        cache.delete(cacheKey);
      }
    }
  } else {
    cache.clear();
  }
}
class HashMap {
  constructor(entries2) {
    this._keys = {};
    this._data = {};
    if (entries2?.length) {
      entries2.forEach(([key, v]) => this.set(key, v));
    }
  }
  static addToMap(map2, key, value) {
    const next2 = new HashMap(map2.entries());
    next2.set(key, value);
    return next2;
  }
  static remove(map2, key) {
    return new HashMap(map2.entries().filter((entry) => entry[0] !== key));
  }
  entries() {
    return this.keys().map((k) => [k, this.get(k)]);
  }
  get(key) {
    return this.has(key) ? this._data[key] : void 0;
  }
  has(key) {
    return !!this._keys[key];
  }
  keys() {
    const keys2 = [];
    for (const key in this._keys) {
      keys2.push(key);
    }
    return keys2;
  }
  set(key, value) {
    this._keys[key] = true;
    this._data[key] = value;
  }
  get size() {
    return this.keys().length;
  }
  values() {
    return this.keys().map((k) => this.get(k));
  }
}
const DEFAULT_CURRENCY_CODE = "USD";
var TrackingStatus = /* @__PURE__ */ ((TrackingStatus2) => {
  TrackingStatus2[TrackingStatus2["None"] = 0] = "None";
  TrackingStatus2[TrackingStatus2["Add"] = 1] = "Add";
  TrackingStatus2[TrackingStatus2["Delete"] = 2] = "Delete";
  TrackingStatus2[TrackingStatus2["Update"] = 3] = "Update";
  return TrackingStatus2;
})(TrackingStatus || {});
var TimeEntryIncrementHours = /* @__PURE__ */ ((TimeEntryIncrementHours2) => {
  TimeEntryIncrementHours2[TimeEntryIncrementHours2["Hundredth"] = 0.01] = "Hundredth";
  TimeEntryIncrementHours2[TimeEntryIncrementHours2["Twentieth"] = 0.05] = "Twentieth";
  TimeEntryIncrementHours2[TimeEntryIncrementHours2["Tenth"] = 0.1] = "Tenth";
  TimeEntryIncrementHours2[TimeEntryIncrementHours2["Quarter"] = 0.25] = "Quarter";
  TimeEntryIncrementHours2[TimeEntryIncrementHours2["Half"] = 0.5] = "Half";
  TimeEntryIncrementHours2[TimeEntryIncrementHours2["One"] = 1] = "One";
  TimeEntryIncrementHours2[TimeEntryIncrementHours2["Four"] = 4] = "Four";
  TimeEntryIncrementHours2[TimeEntryIncrementHours2["Eight"] = 8] = "Eight";
  return TimeEntryIncrementHours2;
})(TimeEntryIncrementHours || {});
const TimeEntryIncrementSet = /* @__PURE__ */ new Set([
  0.01,
  0.05,
  0.1,
  0.25,
  0.5,
  1,
  4,
  8
  /* Eight */
]);
const UNANET_LOGO = "data:image/png;base64, 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";
const UNANET_LOGO_WHITE = "data:image/png;base64, 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";
const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const toCSV = ({
  headerRow,
  dataRows,
  separator,
  enclosingCharacter
}) => {
  const rows = headerRow ? [headerRow, ...dataRows] : dataRows;
  return rows.filter(Boolean).map(
    (row, rowIndex) => row.map((column2) => {
      const value = column2.trim();
      return headerRow && rowIndex === 0 ? value : `${enclosingCharacter}${value}${enclosingCharacter}`;
    }).join(separator)
  ).join("\n");
};
const buildImportHeaderRow = (template) => {
  return template.columns?.map(
    (c, i) => `${i === 0 ? "*" : ""}${c.fieldName ?? ""}`
  ) ?? null;
};
const buildURI = ({
  headerRow,
  dataRows = [[]],
  separator = ",",
  enclosingCharacter = '"',
  includeByteOrderMark = true
}) => {
  const csv = toCSV({
    headerRow,
    dataRows,
    separator,
    enclosingCharacter
  });
  const type = isSafari() ? "application/csv" : "text/csv";
  const bom = includeByteOrderMark ? "\uFEFF" : "";
  const blob = new Blob([bom, csv], { type });
  const dataURI = `data:${type};charset=utf-8,${bom}${csv}`;
  const URL2 = window.URL || window.webkitURL;
  return typeof URL2.createObjectURL === "undefined" ? dataURI : URL2.createObjectURL(blob);
};
const downloadFileFromUrl = (url2, filename) => {
  const a = document.createElement("a");
  a.href = url2;
  a.download = filename || "download";
  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url2);
      a.removeEventListener("click", clickHandler);
    }, 1);
  };
  a.addEventListener("click", clickHandler, false);
  a.click();
};
const replaceLineBreaksWithSpace = (s12) => s12.replace(/\r\n?|\n/g, " ");
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2["None"] = "None";
  ErrorCode2["ArgumentInvalid"] = "ArgumentInvalid";
  ErrorCode2["AuditRequired"] = "AuditRequired";
  ErrorCode2["HoursNotANumber"] = "HoursNotANumber";
  ErrorCode2["HoursOutOfRange"] = "HoursOutOfRange";
  ErrorCode2["Inactive"] = "Inactive";
  ErrorCode2["InvalidStatus"] = "InvalidStatus";
  ErrorCode2["Locked"] = "Locked";
  ErrorCode2["NotOwner"] = "NotOwner";
  ErrorCode2["OperationInvalid"] = "OperationInvalid";
  ErrorCode2["PlatformVersionInvalid"] = "PlatformVersionInvalid";
  ErrorCode2["PropertyDisabled"] = "PropertyDisabled";
  ErrorCode2["TBD"] = "TBD";
  ErrorCode2["TimePeriodAdminOnly"] = "TimePeriodAdminOnly";
  ErrorCode2["TimePeriodAllowAdjustments"] = "TimePeriodAllowAdjustments";
  ErrorCode2["TimeProjectFutureCharge"] = "TimeProjectFutureCharge";
  ErrorCode2["Unauthorized"] = "Unauthorized";
  ErrorCode2["Unexpected"] = "Unexpected";
  ErrorCode2["Uniqueness"] = "Uniqueness";
  ErrorCode2["ValidationErrors"] = "ValidationErrors";
  ErrorCode2["VendorInvoiceOnly"] = "VendorInvoiceOnly";
  return ErrorCode2;
})(ErrorCode || {});
class AppError extends Error {
  constructor(message, code, payload = {}) {
    super(message);
    this.name = "AppError";
    this.code = code;
    this.payload = payload || {};
  }
  toJSON() {
    return {
      message: this.message,
      code: this.code,
      ...this.payload
    };
  }
}
const RATE_MAX_DECIMALS = 5;
const formatAmount = ({
  amount,
  currencyCode,
  currencySign,
  locale,
  missingAmountIndicator,
  negativeIndicator
}) => {
  return format({
    currencyCode,
    currencySign,
    locale,
    missingValueIndicator: missingAmountIndicator,
    negativeIndicator,
    value: amount
  });
};
const formatRate = ({
  currencyCode,
  currencySign,
  locale,
  missingRateIndicator,
  negativeIndicator,
  rate
}) => {
  return format({
    currencyCode,
    currencySign,
    locale,
    maxDecimals: RATE_MAX_DECIMALS,
    missingValueIndicator: missingRateIndicator,
    negativeIndicator,
    value: rate
  });
};
const format = ({
  currencyCode,
  currencySign = "code",
  locale,
  maxDecimals,
  missingValueIndicator = "",
  negativeIndicator = "parentheses",
  value
}) => {
  if (value === void 0 || value === null || isNaN(value)) {
    return missingValueIndicator;
  }
  const decimals = new Intl.NumberFormat(locale, {
    currency: currencyCode,
    style: "currency"
  }).resolvedOptions().maximumFractionDigits;
  const intlFormatted = new Intl.NumberFormat(locale, {
    currency: currencyCode,
    currencyDisplay: currencySign === "none" ? "code" : currencySign,
    currencySign: negativeIndicator === "parentheses" ? "accounting" : "standard",
    maximumFractionDigits: maxDecimals ?? decimals,
    minimumFractionDigits: decimals,
    style: "currency"
  }).format(value);
  const formattedString = currencySign === "none" ? (
    // also remove non-breaking space between the currency code and the amount, e.g. 'USD 32.00' or "32,00 EUR"
    intlFormatted.replace(currencyCode, "").replace(/\xa0/, "")
  ) : intlFormatted;
  return formattedString;
};
const DATE_TIME_PICKER_ESCAPE_LITERALS = [
  ".",
  "^",
  "$",
  "*",
  "+",
  "-",
  "?",
  "(",
  ")",
  "[",
  "]",
  "{",
  "}",
  "|",
  "\\"
];
class DateTimeParser {
  #partKeys;
  constructor(locale) {
    this.#partKeys = this.#initPartKeys();
    this.locale = locale ?? "en-US";
    this.tracker = this.#initTracker();
    this.localeParts = this.#initLocaleParts();
  }
  //PRIVATE
  #getMinPartLength(type) {
    const { minParts } = this.localeParts;
    const matchingPart = minParts.find((mp2) => mp2.type === type);
    return matchingPart?.value.length ?? -1;
  }
  #initLocaleParts() {
    const { locale } = this;
    const localeNow = DateTime.now().setLocale(locale);
    const parts = localeNow.toLocaleParts(DateTime.DATETIME_SHORT);
    return {
      dateParts: localeNow.toLocaleParts(DateTime.DATE_SHORT),
      literals: uniqBy(
        parts.filter((p) => p.type === "literal"),
        (literal) => literal.value
      ),
      parts,
      minParts: localeNow.set({ month: 1, day: 1, hour: 1, minute: 1 }).toLocaleParts(DateTime.DATETIME_SHORT),
      maxParts: localeNow.set({ month: 12, day: 31, hour: 23, minute: 59 }).toLocaleParts(DateTime.DATETIME_SHORT),
      timeParts: localeNow.toLocaleParts(DateTime.TIME_SIMPLE)
    };
  }
  #initPartKeys() {
    return {
      day: "DD",
      month: "MM",
      year: "YYYY",
      hour: "HH",
      minute: "mm",
      dayPeriod: "AM"
    };
  }
  #initTracker() {
    return {
      day: false,
      month: false,
      year: false,
      hour: false,
      minute: false,
      dayPeriod: false,
      literalCount: 0
    };
  }
  //END: PRIVATE
  //INSTANCE
  buildLuxonDateTimeFormats(timeOnly) {
    const {
      localeParts: { parts, timeParts }
    } = this;
    const defaults = [
      "f",
      "F",
      "D t",
      "D, t",
      "D T",
      "D, T",
      "L/d/yyyy, h:mm a"
    ];
    const buildFrom = timeOnly ? timeParts : parts;
    const builtParts = buildFrom.reduce(
      (formatObj, part) => {
        const { type, value } = part;
        const { short, short24, long, long24 } = formatObj;
        if (type === "literal") {
          return {
            short: short + value,
            short24: short24 + value,
            long: long + value,
            long24: long24 + value
          };
        }
        if (type === "hour") {
          return {
            short: short + "h",
            short24: short24 + "H",
            long: long + "hh",
            long24: long24 + "HH"
          };
        }
        if (type === "minute") {
          return {
            short: short + "m",
            short24: short24 + "m",
            long: long + "mm",
            long24: long24 + "mm"
          };
        }
        if (type === "day") {
          return {
            short: short + "d",
            short24: short24 + "d",
            long: long + "dd",
            long24: long24 + "dd"
          };
        }
        if (type === "month") {
          return {
            short: short + "L",
            short24: short24 + "L",
            long: long + "LL",
            long24: long24 + "LL"
          };
        }
        if (type === "year") {
          return {
            short: short + "y",
            short24: short24 + "y",
            long: long + "yyyy",
            long24: long24 + "yyyy"
          };
        }
        if (type === "dayPeriod") {
          return {
            short: short + "a",
            short24: short24 + "a",
            long: long + "a",
            long24: long24 + "a"
          };
        }
        return formatObj;
      },
      { short: "", short24: "", long: "", long24: "" }
    );
    Object.values(builtParts).forEach((part) => defaults.unshift(part));
    return defaults;
  }
  day(currentValue, matchedLiterals) {
    if (!currentValue) {
      return "";
    }
    let dayValue = currentValue;
    const minCharLength = this.#getMinPartLength("day");
    const { tracker } = this;
    const numberValue = Number(dayValue);
    const isValidDay = Number.isFinite(numberValue);
    const inPaddingRange = numberValue > 3 && numberValue < 10;
    const addPadding = minCharLength === 2 && !startsWith(dayValue, "0") && (inPaddingRange || matchedLiterals[tracker.literalCount]);
    if (addPadding) {
      dayValue = "0" + dayValue;
    }
    if (dayValue.length === 2 || matchedLiterals[tracker.literalCount] || numberValue > 3) {
      tracker.day = true;
    }
    if (isValidDay || dayValue === "0") {
      return dayValue;
    }
  }
  dayPeriod(currentValue) {
    if (!currentValue) {
      return "";
    }
    return currentValue.toLowerCase() === "m" ? "A" + currentValue.toUpperCase() : currentValue.toUpperCase();
  }
  hour(currentValue, matchedLiterals) {
    if (!currentValue) {
      return "";
    }
    let hourValue = currentValue;
    const { tracker } = this;
    const numberValue = Number(hourValue);
    const shortcuts = DateTimeParser.getValidShortCuts();
    const minCharLength = this.#getMinPartLength("hour");
    const isValidHour = Number.isFinite(numberValue);
    const inPaddingRange = numberValue > 2 && numberValue < 10;
    const addPadding = minCharLength === 2 && !startsWith(hourValue, "0") && (inPaddingRange || matchedLiterals[tracker.literalCount] && numberValue < 10);
    if (addPadding) {
      hourValue = "0" + hourValue;
    }
    if (shortcuts.includes(currentValue.toLowerCase())) {
      return currentValue;
    }
    if (hourValue.length >= 2 || matchedLiterals[tracker.literalCount]) {
      tracker.hour = true;
    }
    if (isValidHour) {
      return hourValue;
    }
  }
  getPlaceholderDisplay() {
    let placeholder = "";
    this.localeParts.parts.forEach(
      (part) => placeholder = part.type === "literal" ? placeholder + part.value : placeholder + this.#partKeys[part.type]
    );
    return placeholder.toLowerCase();
  }
  getDateFnsLocaleFormat() {
    let placeholder = "";
    this.localeParts.dateParts.forEach((part) => {
      placeholder = part.type === "literal" ? placeholder + part.value : placeholder + this.#partKeys[part.type];
    });
    return placeholder.toLowerCase().replace("mm", "MM");
  }
  literal(currentValue, _matchedLiterals, part, index2) {
    const {
      tracker,
      localeParts: { parts }
    } = this;
    const previousBlockValid = tracker[parts[index2 - 1].type];
    const previousBlockIsHour = parts[index2 - 1].type === "hour";
    if (currentValue && previousBlockIsHour && previousBlockValid && (currentValue.toLowerCase() === "a" || currentValue.toLowerCase() === "p")) {
      return currentValue;
    }
    tracker.literalCount = tracker.literalCount + 1;
    return previousBlockValid ? part.value : "";
  }
  minute(currentValue, matchedLiterals) {
    if (!currentValue) {
      return "";
    }
    let minuteValue = currentValue;
    const isValidMinute = minuteValue && Number(minuteValue);
    if (minuteValue.length === 2) {
      this.tracker.minute = true;
    }
    if (Number(minuteValue) === 0 || isValidMinute && Number(minuteValue) <= 59) {
      return minuteValue;
    }
  }
  month(currentValue, matchedLiterals) {
    if (!currentValue) {
      return "";
    }
    let monthValue = currentValue;
    const minCharLength = this.#getMinPartLength("hour");
    const isValidMonth = monthValue && Number(monthValue);
    const inPaddingRange = Number(monthValue) > 1 && Number(monthValue) < 10;
    const addPadding = minCharLength === 2 && !startsWith(monthValue, "0") && (inPaddingRange || matchedLiterals[this.tracker.literalCount]);
    if (addPadding) {
      monthValue = "0" + monthValue;
    }
    if (monthValue.length === 2 || matchedLiterals[this.tracker.literalCount] || Number(monthValue) > 1) {
      this.tracker.month = true;
    }
    if (isValidMonth || monthValue === "0") {
      return monthValue;
    }
  }
  year(currentValue, matchedLiterals) {
    if (!currentValue) {
      return "";
    }
    const joinedLiterals = DateTimeParser.joinLiterals(
      this.localeParts.literals
    );
    const stripLiteralsRegExp = new RegExp(`[${joinedLiterals},\\s]`, "g");
    const cleanedYear = currentValue.replace(stripLiteralsRegExp, "");
    const isValidYear = cleanedYear && Number(cleanedYear);
    if (cleanedYear.length === 4 || matchedLiterals[this.tracker.literalCount]) {
      this.tracker.year = true;
    }
    if (isValidYear) {
      return cleanedYear;
    }
  }
  //END: INSTANCE
  //PARSER
  parse(inputValue) {
    let parsedValue = "";
    const {
      tracker,
      localeParts,
      localeParts: { parts }
    } = this;
    const splitInputRegExp = new RegExp(
      DateTimeParser.joinLiterals(localeParts.literals),
      "g"
    );
    const splitString = inputValue.split(splitInputRegExp);
    const matchedLiterals = [...inputValue.matchAll(splitInputRegExp)];
    for (const [index2, part] of parts.entries()) {
      const value = splitString[index2 - tracker.literalCount];
      parsedValue = this[part.type] ? parsedValue + (this[part.type](value, matchedLiterals, part, index2) ?? "") : parsedValue;
    }
    return parsedValue;
  }
  //STATIC
  static getValidShortCuts() {
    const shortcuts = [];
    Array(13).fill("", 1, 13).forEach((_placeholder, index2) => {
      shortcuts.push(`${index2}a`);
      shortcuts.push(`${index2} a`);
      shortcuts.push(`${index2}p`);
      shortcuts.push(`${index2} p`);
      shortcuts.push(`${index2}am`);
      shortcuts.push(`${index2} am`);
      shortcuts.push(`${index2}pm`);
      shortcuts.push(`${index2} pm`);
    });
    return shortcuts;
  }
  static joinLiterals(literals, joinChar = "|") {
    return literals.map(
      (literal) => DATE_TIME_PICKER_ESCAPE_LITERALS.includes(literal.value) ? `\\${literal.value}` : literal.value
    ).join(joinChar);
  }
  //END: STATIC
}
const fetchBankFeedSettings = async () => {
  try {
    return await getBankFeedSettings();
  } catch (e) {
    log.warn({
      msg: "Failed to retrieve bank feed settings",
      error: `${e}`
    });
    throw e;
  }
};
const saveBankFeedSettings = async (bankFeedSettings) => {
  try {
    return await saveBankFeedSettings$1(bankFeedSettings);
  } catch (e) {
    log.warn({
      msg: "Failed to save bank feed settings",
      error: `${e}`
    });
    throw e;
  }
};
var UnanetApplicationMode = /* @__PURE__ */ ((UnanetApplicationMode2) => {
  UnanetApplicationMode2["Production"] = "PRODUCTION";
  UnanetApplicationMode2["Sandbox"] = "SANDBOX";
  return UnanetApplicationMode2;
})(UnanetApplicationMode || {});
const defaultProperties = /* @__PURE__ */ new Map([
  ["approval_process.require.approval.expense_request", "true"],
  ["approval_process.require.approval.purchase_order", "true"],
  ["approval_process.require.approval.purchase_requisition", "true"],
  ["approval_process.require.approval.vendor_invoice", "D"],
  ["mail.host", "mail"],
  ["passport.enabled", "false"],
  ["udf.fields.default_number", "10"],
  ["udf.objects", "project;person;customer;task"],
  [
    "unanet.TimeslipFactory.getHoursReported.oracle.hint",
    "/*+ index(ptd idx_person_time_data1) */"
  ],
  ["unaitem.enable", "false"],
  ["unanet.adp.expense_amount_header", "Adjust Ded Amount"],
  ["unanet.adp.expense_code", "E"],
  ["unanet.adp.expense_code_header", "Adjust Ded Code"],
  ["unanet.amplitude.api_key", ""],
  [
    "unanet.application.mode",
    "PRODUCTION"
    /* Production */
  ],
  ["unanet.approve.force_view", "false"],
  ["unanet.approve.self", "true"],
  ["unanet.assign_search.enabled", "false"],
  ["unanet.assign_search.result_limit", "1000"],
  ["unanet.attachment.invalid_file_extensions", ""],
  ["unanet.attachment.max_size", "10485760"],
  ["unanet.attachment.valid_file_extensions", ""],
  ["unanet.authentication", "unanet"],
  ["unanet.auto.project_code.sequence_number.min_length", "1"],
  ["unanet.auto.project_code.source", ""],
  ["unanet.autocomplete.max_results", "250"],
  ["unanet.autocomplete.min_query_length", "1"],
  ["unanet.autocomplete.query_delay", "250"],
  ["unanet.billing.post.suppress_preview", ""],
  ["unanet.build.timestamp", "@TIMESTAMP@"],
  ["unanet.buildnumber", "@BUILDNUMBER@"],
  ["unanet.chameleon.api_key", ""],
  ["unanet.churnzero.api_key", ""],
  ["unanet.contextual.help.service.url", ""],
  [
    "unanet.cookie.comment",
    "This is the security key allowing you to access the various pages of Unanet."
  ],
  ["unanet.cookie.http_only", "true"],
  ["unanet.cookie.maxage", "-1"],
  ["unanet.cookie.name", "unanetAccess"],
  ["unanet.cookie.nonce", "[quuP6Qe-/afD<Ph6}v.;?HP}kP%)[g"],
  ["unanet.cookie.secure", "false"],
  ["unanet.customer.logo", ""],
  ["unanet.customer_invoice.cost_plus_expense.search_enable.limit", "0"],
  ["unanet.customer_invoice.cost_plus_fee_cap_adj.search_enable.limit", "0"],
  ["unanet.customer_invoice.cost_plus_item.search_enable.limit", "0"],
  ["unanet.customer_invoice.cost_plus_labor.search_enable.limit", "1000"],
  ["unanet.customer_invoice.fixed_price.search_enable.limit", "0"],
  ["unanet.customer_invoice.funding_cap_adj.search_enable.limit", "0"],
  ["unanet.customer_invoice.prebilled_labor.search_enable.limit", "0"],
  ["unanet.customer_invoice.time_materials_expense.search_enable.limit", "0"],
  ["unanet.customer_invoice.time_materials_item.search_enable.limit", "0"],
  ["unanet.customer_invoice.time_materials_labor.search_enable.limit", "1000"],
  ["unanet.dbversion_match", "Version 20.2"],
  ["unanet.default.allow_budget_to_exceed", "false"],
  ["unanet.default_dates_to_linked.assignments", "true"],
  ["unanet.default_dates_to_linked.plans", "true"],
  ["unanet.export.adp_user", "false"],
  ["unanet.export.jarversion_match", "1.1.1"],
  ["unanet.extract.require_org", "false"],
  ["unanet.financials.allow_customer_payment_delete", "true"],
  ["unanet.financials.allow_deposit_delete", "true"],
  ["unanet.financials.allow_journal_entry_delete", "true"],
  ["unanet.financials.allow_vendor_invoice_delete", "true"],
  ["unanet.financials.allow_vendor_payment_delete", "true"],
  ["unanet.financials.disallow_posting_to_closed_fiscal_period", "false"],
  ["unanet.financials.duplicate_vendor_invoice", "warn"],
  ["unanet.financials.gl_post_level.billing", "detail"],
  ["unanet.financials.gl_post_level.expense_cost", "detail"],
  [
    "unanet.financials.gl_post_level.expense_cost_non-reimbursable_offset",
    "detail"
  ],
  [
    "unanet.financials.gl_post_level.expense_cost_reimbursable_offset",
    "summary"
  ],
  ["unanet.financials.gl_post_level.invoice", "detail"],
  ["unanet.financials.gl_post_level.labor_cost_offset", "timesheet"],
  ["unanet.financials.gl_post_level.labor_cost", "detail"],
  ["unanet.financials.open_fiscal_periods", "0"],
  ["unanet.financials.post_labor_cross_charge", "false"],
  ["unanet.financials.post_to_gl.eff_date", ""],
  ["unanet.financials.post_to_gl", "false"],
  ["unanet.financials.statistical_accounts.enabled", "true"],
  ["unanet.financials.use_financial_orgs", "false"],
  ["unanet.fiscal_calendar.enabled", "false"],
  ["unanet.gzip", "true"],
  ["unanet.idp.host.url", ""],
  ["unanet.image.max_size", "10485760"],
  ["unanet.invoice.add.suppress_preview", ""],
  ["unanet.invoice.currency_header", "false"],
  ["unanet.invoice.date_format", ""],
  ["unanet.invoice.show.currency_code", "false"],
  ["unanet.jaas.application", "unanet"],
  ["unanet.jarversion_match", "2.0.1"],
  ["unanet.license_check.warning_interval", "0"],
  ["unanet.license_expires_warning", "30"],
  ["unanet.locale", ""],
  ["unanet.log.format", "{0,date,yyyy-MM-dd HH:mm:ss.SSS} [{1}] {2} - {3}"],
  ["unanet.log.level", "CONFIG"],
  ["unanet.log.output", "stdout"],
  ["unanet.login_attempts_before_locked", "0"],
  ["unanet.logo.alt", ""],
  ["unanet.logo.src", ""],
  ["unanet.logo.url", ""],
  ["unanet.new.people.planner.view.booked.projects", "false"],
  ["unanet.non_cost_mgr.allow_cost_reporting", "false"],
  ["unanet.non_cost_mgr.allow_project_cost_reporting", "false"],
  ["unanet.non_cost_mgr.allow_project_margin_reporting", "false"],
  ["unanet.org_access.HRAdministrator.people.default_to_all", "false"],
  ["unanet.org_access.billingManager.owning.default_to_all", "false"],
  ["unanet.org_access.billingManager.project.default_to_all", "false"],
  ["unanet.org_access.manager.people.default_to_all", "false"],
  ["unanet.org_access.projectManager.owning.default_to_all", "false"],
  ["unanet.org_access.projectManager.project.default_to_all", "false"],
  ["unanet.org_access.projectViewer.owning.default_to_all", "false"],
  ["unanet.org_access.projectViewer.project.default_to_all", "false"],
  ["unanet.org_access.resourceManager.owning.default_to_all", "false"],
  ["unanet.org_access.resourceManager.people.default_to_all", "false"],
  ["unanet.org_access.resourceManager.project.default_to_all", "false"],
  ["unanet.org_access.viewer.people.default_to_all", "false"],
  ["unanet.org_assignment.my_projects.select_by_default", "true"],
  ["unanet.password.character.lowercase", "abcdefghijklmnopqrstuvwxyz"],
  ["unanet.password.character.number", "0123456789"],
  [
    "unanet.password.character.special",
    "!@#$%~^&*()-', '_+[]{}\\|;:'\"<>,.?/`"
  ],
  ["unanet.password.character.uppercase", "ABCDEFGHIJKLMNOPQRSTUVWXYZ"],
  ["unanet.password.expire.warn", "7"],
  ["unanet.password.expire", "0"],
  ["unanet.password.minimum.character.lowercase", "0"],
  ["unanet.password.minimum.character.number", "0"],
  ["unanet.password.minimum.character.special", "0"],
  ["unanet.password.minimum.character.uppercase", "0"],
  ["unanet.password.minimum.length", "0"],
  ["unanet.password.nonce", ""],
  ["unanet.password_reset.enabled", "false"],
  ["unanet.password_reset.time_to_live", "3600000"],
  ["unanet.plan_set_list.search_enable.limit", "0"],
  ["unanet.plan_sets.enabled", "false"],
  ["unanet.poweredby.logo", "images/poweredby.gif"],
  ["unanet.preload_jsp", "true"],
  ["unanet.prevent.administrative.login", "false"],
  ["unanet.prevent.nonemployee.be.alternate", "false"],
  ["unanet.prevent.nonmanager.be.alternate", "false"],
  ["unanet.project_search.require_project_code", "false"],
  ["unanet.properties.show_transfer_button", "false"],
  ["unanet.purchasing.po.can_delete_unapproved", "true"],
  ["unanet.purchasing.pr.can_delete_unapproved", "true"],
  ["unanet.report.criteria.all_people", "true"],
  ["unanet.restrict_alternates_by_role", "false"],
  ["unanet.restricted_access", "false"],
  ["unanet.scheduler.clusterCheckinInterval", "30000"],
  ["unanet.scheduler.dbFailureRetryInterval", "60000"],
  ["unanet.scheduler.disabled", "false"],
  ["unanet.scheduler.idleWaitTime", "60000"],
  ["unanet.scheduler.threads", "3"],
  ["unanet.session.enabled", "false"],
  ["unanet.session.timeout", "30"],
  ["unanet.show_emp_type_employees", "true"],
  ["unanet.show_existing_plans_assignments", "true"],
  ["unanet.splash.alt", ""],
  ["unanet.splash.target", ""],
  ["unanet.splash.url", ""],
  ["unanet.sso.oauth.issuer", ""],
  ["unanet.task.sort.order.by_sequence", "true"],
  ["unanet.task_list.search_enable.limit", "0"],
  ["unanet.tempFileReaper.max_temp_chart_age", "600000"],
  ["unanet.tempFileReaper.max_temp_file_age", "86400000"],
  ["unanet.tempFileReaper.max_temp_import_file_age", "604800000"],
  ["unanet.tempFileReaper.sleep_time", "30000"],
  ["unanet.temp_directory", "."],
  ["unanet.time.approval.acknowledgement", ""],
  ["unanet.username.format.hint", ""],
  ["unanet.version", "@VERSION@"],
  ["unanet.volume_search.filter_limit", "250"],
  ["unasense.approval.authority.report", "false"],
  ["unasense.approval.authority.request.skip_zero_approver", "false"],
  ["unasense.approval.authority.request", "false"],
  ["unasense.approval.required", "true"],
  ["unasense.autolock", "false"],
  ["unasense.creditcards.allow_imported_item_delete.admin", "true"],
  ["unasense.creditcards.allow_imported_item_delete.user", "true"],
  ["unasense.creditcards.enable", "false"],
  ["unasense.creditcards.import.feedback_interval", "10"],
  ["unasense.creditcards.import.purge_days", "90"],
  ["unasense.creditcards.selfedit", "false"],
  ["unasense.customer.review.required", "false"],
  ["unasense.customer.view_approval_history", "false"],
  ["unasense.customer.view_attachments", "false"],
  ["unasense.email.required", "false"],
  ["unasense.enable_copy", "true"],
  ["unasense.expense.admin.edit", "false"],
  ["unasense.expense.manager.edit", "false"],
  ["unasense.expense.org.display", "true"],
  ["unasense.expense_extract.post_date.required", "false"],
  ["unasense.location.required", "false"],
  ["unasense.lodging_allowable.include_tax_overage", "true"],
  ["unasense.manager.review.required", "false"],
  ["unasense.meal.cap", "0"],
  ["unasense.meal.expense_types", ""],
  ["unasense.per_diem.mie.breakdown.breakfast.percent", "15"],
  ["unasense.per_diem.mie.breakdown.dinner.percent", "40"],
  ["unasense.per_diem.mie.breakdown.lunch.percent", "25"],
  ["unasense.per_diem.mie.first_day.proration.percent", "75"],
  ["unasense.per_diem.mie.last_day.proration.percent", "75"],
  ["unasense.per_diem.special_situation.enabled", "false"],
  ["unasense.per_diem.special_situation.factor", "1"],
  ["unasense.pm.review.required", "false"],
  ["unasense.preview.expand./expense/allocate/review", "allocations"],
  ["unasense.preview.expand./expense/allocate", "allocations"],
  ["unasense.preview.expand./expense/view/attach", "attachments"],
  ["unasense.preview.expand./expense/view/review", ""],
  ["unasense.preview.expand./expense/view", ""],
  ["unasense.preview.expand./people/expense/allocate", "allocations"],
  [
    "unasense.preview.expand./people/expense/allocate_info",
    "allocations,history"
  ],
  [
    "unasense.preview.expand./people/expense/view/approve/attach",
    "attachments,history"
  ],
  ["unasense.preview.expand./people/expense/view/approve", "history"],
  ["unasense.preview.expand./people/expense/view/attach", "attachments"],
  ["unasense.preview.expand./people/expense/view/review", "history"],
  ["unasense.preview.expand./people/expense/view", ""],
  [
    "unasense.preview.expand./projects/expense/view/approve/attach",
    "allocations,attachments,history"
  ],
  [
    "unasense.preview.expand./projects/expense/view/approve",
    "allocations,history"
  ],
  [
    "unasense.preview.expand./projects/expense/view/review",
    "allocations,history"
  ],
  [
    "unasense.preview.expand./reports/people/status/expense/invoice_preview/report",
    "history"
  ],
  ["unasense.preview.expand./reports/people/status/expense/report", "history"],
  ["unasense.project.title.display", "false"],
  ["unasense.purpose.required", "false"],
  ["unasense.request.enable", "true"],
  ["unasense.single.project.expense.limit", "false"],
  ["unasense.submit.stored_procedure.include_submitter", "false"],
  ["unasense.submit.stored_procedure", ""],
  ["unasense.threshold.exceeded.need_comments", "false"],
  ["unasense.user.review.required", "false"],
  ["unasense.vat.enabled", "false"],
  ["unasense.wizard.message", ""],
  ["unasource.allow_bill_rate_edit", "true"],
  ["unasource.allow_cost_rate_edit", "true"],
  ["unasource.overbooking.blockout.allowed", "true"],
  ["unasource.user.plan.show_labor_category", "false"],
  ["unatime.accruals.hire_date_cap.post_first", "true"],
  ["unatime.adjustment.allow_other_change_reason", "false"],
  ["unatime.admin.edit", "false"],
  ["unatime.admin_bulk_approve.enable", "false"],
  ["unatime.administrator.review.required", "false"],
  ["unatime.allow_custom_time_periods", "false"],
  ["unatime.allow_timesheet_delete", "false"],
  ["unatime.approval.approve.next.view.comments", "false"],
  ["unatime.approval.required", "false"],
  ["unatime.audit.allow_other_change_reason", "false"],
  ["unatime.audit", "false"],
  ["unatime.autolock", "false"],
  ["unatime.bulk_approvals.review.required", "false"],
  ["unatime.cost.dilution.class", "Style0CostDilution"],
  ["unatime.customer.review.required", "false"],
  ["unatime.daily_actuals.num_time_periods", "15"],
  ["unatime.daily_time_entry", "false"],
  ["unatime.default.work.hours", "8"],
  ["unatime.dilution_hours_from_business_week", "false"],
  ["unatime.email.default_from_address", "unatime"],
  ["unatime.email", "false"],
  ["unatime.end_user_adjustment.enable", "false"],
  ["unatime.etc_collection.enabled", "true"],
  ["unatime.holiday.hours_from_business_week", "false"],
  ["unatime.leave_request.enabled", "true"],
  ["unatime.manager.edit", "true"],
  ["unatime.manager.review.required", "false"],
  ["unatime.payroll_info.enable", "false"],
  ["unatime.pm.review.required", "false"],
  ["unatime.pm_approval.view_all", "false"],
  ["unatime.prevent_post_on_weekly_overlap", "false"],
  ["unatime.preview.expand./people/time/view/adjust", ""],
  ["unatime.preview.expand./people/time/view/approve", "cell-details,history"],
  ["unatime.preview.expand./people/time/view/review", "cell-details,history"],
  ["unatime.preview.expand./people/time/view", ""],
  [
    "unatime.preview.expand./projects/time/view/approve",
    "cell-details,history"
  ],
  ["unatime.preview.expand./projects/time/view/review", "cell-details,history"],
  ["unatime.preview.expand./projects/time/view", ""],
  ["unatime.preview.expand./time/signature", "cell-details"],
  ["unatime.preview.expand./time/view/review", ""],
  ["unatime.preview.expand./time/view", ""],
  ["unatime.quick_reports.leave_balance.accrued_budgets", "false"],
  ["unatime.req_non_owner_submit_comment", "false"],
  ["unatime.submit.stored_procedure.include_submitter", "false"],
  ["unatime.submit.stored_procedure", ""],
  ["unatime.tasks.show_numbers", "false"],
  ["unatime.time.populate.approve", "false"],
  ["unatime.time_period_criteria.sort_by_type", "true"],
  ["unatime.timesheet.attachments.enabled", "true"],
  ["unatime.timesheet.classification.display", "true"],
  ["unatime.timesheet.hide.comments", "false"],
  ["unatime.timesheet.hide.labor_category", "false"],
  ["unatime.timesheet.hide.location", "false"],
  ["unatime.timesheet.hide.pay_code", "false"],
  ["unatime.timesheet.hide.project_type", "false"],
  ["unatime.timesheet.hide.task", "false"],
  ["unatime.timesheet.org.display", "true"],
  ["unatime.timesheet.project.title.display", "true"],
  ["unatime.timesheet.project.title.hover", "true"],
  ["unatime.tito.daily.enabled", "true"],
  ["unatime.tito.enforce.user_time_increment", "false"],
  ["unatime.tito.project.enabled", "true"],
  ["unatime.ts_status_rpt.exempt_users.hours_from_dilution", "false"],
  ["unatime.use_server_clock", "false"],
  ["unatime.user.review.required", "false"],
  ["unatime.weekly_overlap.rate_align", "false"]
]);
const store = new Map(defaultProperties.entries());
const __TEST_STORE = store;
let _interval = null;
const fetchProperty = async (property2) => {
  if (getProperty(property2)) {
    return getProperty(property2);
  } else {
    try {
      const data = await getProperties(property2);
      Object.keys(data).forEach((key) => store.set(key, data[key]));
      return data[property2];
    } catch (e) {
      return null;
    }
  }
};
const loadAllProperties = async () => {
  try {
    const data = await getProperties(
      "approval_process.require.approval.expense_request",
      "approval_process.require.approval.vendor_invoice",
      "passport.enabled",
      "sf_cust_id",
      "timesheet.printview.footer.exempt",
      "timesheet.printview.footer.nonemployee",
      "timesheet.printview.footer.nonexempt",
      "timesheet.submit.confirm.exempt",
      "timesheet.submit.confirm.nonemployee",
      "timesheet.submit.confirm.nonexempt",
      "timesheet.submit.confirm.subcontractor",
      "unaitem.enable",
      "unanet.amplitude.api_key",
      "unanet.application.mode",
      "unanet.approve.force_view",
      "unanet.attachment.invalid_file_extensions",
      "unanet.attachment.max_size",
      "unanet.attachment.valid_file_extensions",
      "unanet.chameleon.api_key",
      "unanet.churnzero.api_key",
      "unanet.contextual.help.service.url",
      "unanet.default.allow_budget_to_exceed",
      "unanet.financials.1099.enabled",
      "unanet.financials.allow_journal_entry_delete",
      "unanet.financials.allow_vendor_invoice_delete",
      "unanet.financials.disallow_posting_to_closed_fiscal_period",
      "unanet.fiscal_calendar.enabled",
      "unanet.idp.host.url",
      "unanet.inference.enabled",
      "unanet.invoice.currency_header",
      "unanet.invoice.show.currency_code",
      "unanet.locale",
      "unanet.new.people.planner.view.booked.projects",
      "unanet.password_reset.enabled",
      "unanet.password_reset.time_to_live",
      "unanet.password.character.lowercase",
      "unanet.password.character.number",
      "unanet.password.character.special",
      "unanet.password.character.uppercase",
      "unanet.password.expire.warn",
      "unanet.password.expire",
      "unanet.password.minimum.character.lowercase",
      "unanet.password.minimum.character.number",
      "unanet.password.minimum.character.special",
      "unanet.password.minimum.character.uppercase",
      "unanet.password.minimum.length",
      "unanet.plan_sets.enabled",
      "unanet.session.enabled",
      "unanet.session.timeout",
      "unanet.sso.oauth.issuer",
      "unanet.time.approval.acknowledgement",
      "unanet.username.format.hint",
      "unanet.pendo.api_key",
      "unasense.autolock",
      "unasense.expense.admin.edit",
      "unasense.expense.org.display",
      "unasense.hide.project_type",
      "unasense.location.required",
      "unasense.project.title.display",
      "unasense.purpose.required",
      "unasense.threshold.exceeded.need_comments",
      "unatime.adjustment.allow_other_change_reason",
      "unatime.admin.edit",
      "unatime.allow_timesheet_delete",
      "unatime.approval.approve.next.view.comments",
      "unatime.audit.allow_other_change_reason",
      "unatime.audit",
      "unatime.autolock",
      "unatime.daily_time_entry",
      "unatime.default.work.hours",
      "unatime.end_user_adjustment.enable",
      "unatime.leave_request.enabled",
      "unatime.manager.edit",
      "unatime.req_non_owner_submit_comment",
      "unatime.timesheet.classification.display",
      "unatime.timesheet.hide.comments",
      "unatime.timesheet.hide.labor_category",
      "unatime.timesheet.hide.location",
      "unatime.timesheet.hide.pay_code",
      "unatime.timesheet.hide.project_type",
      "unatime.timesheet.hide.task",
      "unatime.timesheet.org.display",
      "unatime.timesheet.project.title.display",
      "unatime.timesheet.project.title.hover",
      "unatime.tito.daily.enabled",
      "unatime.tito.enforce.user_time_increment",
      "unatime.tito.project.enabled",
      "unatime.user.review.required",
      "unasense.user.review.required",
      "unasense.expense_extract.post_date.required",
      "unasense.per_diem.special_situation.factor",
      "unasense.per_diem.special_situation.enabled",
      "unatime.timesheet.attachments.enabled",
      "unanet.financials.statistical_accounts.enabled",
      "unanet.financials.use_financial_orgs"
    );
    Object.entries(data).forEach(([key, value]) => store.set(key, value));
  } catch (e) {
    log.warn({ msg: "Error loading Unanet Properties", error: `${e}` });
  }
};
const startPropertiesInterval = (minutes) => {
  if (_interval) {
    stopPropertiesInterval();
  }
  _interval = setInterval(
    () => loadAllProperties().catch(() => null),
    minutes * 6e4
  );
};
const stopPropertiesInterval = () => {
  if (_interval) {
    clearInterval(_interval);
  }
};
const getProperty = (key) => store.get(key) || null;
const getPropertyTransform = (key, transform2) => transform2(getProperty(key));
const bool = (key, defaultValue = false) => {
  return store.has(key) ? getPropertyTransform(key, (x) => x === "true") : defaultValue;
};
const float = (key, defaultValue = 0) => {
  return store.has(key) ? getPropertyTransform(key, (x) => parseFloat(x)) : defaultValue;
};
const entries = () => {
  return Array.from(store.entries());
};
const string = (key, defaultValue = "") => {
  return store.has(key) ? store.get(key) : defaultValue;
};
const int = (key, defaultValue = 0) => {
  return store.has(key) ? getPropertyTransform(key, (x) => parseInt(x, 10)) : defaultValue;
};
const getApplicationMode = () => {
  const mode = getProperty(
    "unanet.application.mode"
  );
  return mode ?? UnanetApplicationMode.Production;
};
const helpers = {
  bool,
  float,
  entries,
  string,
  int,
  getApplicationMode
};
var UdfMetadataType = /* @__PURE__ */ ((UdfMetadataType2) => {
  UdfMetadataType2["CUSTOMER_ORG"] = "CUSTOMER_ORG";
  UdfMetadataType2["EXPENSE_TYPE"] = "EXPENSE_TYPE";
  UdfMetadataType2["FIXED_ASSET"] = "FIXED_ASSET";
  UdfMetadataType2["ORG_CONTACT"] = "ORG_CONTACT";
  UdfMetadataType2["ORGANIZATION"] = "ORGANIZATION";
  UdfMetadataType2["PERSON"] = "PERSON";
  UdfMetadataType2["PROJECT"] = "PROJECT";
  UdfMetadataType2["PROJECT_NOTE"] = "PROJECT_NOTE";
  UdfMetadataType2["PURCHASE_ORDER"] = "PURCHASE_ORDER";
  UdfMetadataType2["PURCHASE_REQUISITION"] = "PURCHASE_REQUISITION";
  UdfMetadataType2["SHARED_DOC"] = "SHARED_DOC";
  UdfMetadataType2["TASK"] = "TASK";
  UdfMetadataType2["VENDOR_ORG"] = "VENDOR_ORG";
  UdfMetadataType2["CONTRACT"] = "CONTRACT";
  return UdfMetadataType2;
})(UdfMetadataType || {});
const fetchUdfMetadataList = async (type) => {
  const results = await get$1(
    `/config/udf-metadata/${type}`
  );
  return results.items ? results.items.filter(
    (item) => item.metadata?.active && item.metadata?.visibility !== "NONE"
  ) : [];
};
const getLicenses = async () => {
  try {
    const licenses = await getLicenses$1();
    return licenses;
  } catch (e) {
    log.warn({
      msg: "Error getting licenses",
      error: `${e}`
    });
    throw e;
  }
};
const getLicenseHolder = async () => {
  try {
    const licenseHolder = await getLicenseHolder$1();
    return licenseHolder;
  } catch (e) {
    log.warn({
      msg: "Error getting license holder from unanet core",
      error: `${e}`
    });
    throw e;
  }
};
const fetchCustomerLogo = async () => {
  let base64 = UNANET_LOGO;
  let altText = "";
  await getLogo("CUSTOMER_LOGO").then((res) => {
    base64 = `data:${res.mimeType};base64, ${res.data}`;
    altText = res.altText ?? "Unanet";
  }).catch((err) => {
    log.debug({ msg: "Error fetching customer logo", error: `${err}` });
  });
  return { base64, altText };
};
const fetchAllCurrencies = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  return fetchAllItems({
    fetch: (page) => () => getCurrencyCodes({ page, pageSize: pageSize2 }),
    errorMessage: "Retrieving Currencies failed"
  });
};
const createExchangeRate = async (exchangeRate) => {
  try {
    const { key } = await createExchangeRate$1(exchangeRate);
    return key;
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error creating exchange rate type`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Creating exchange rate type failed`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const editExchangeRate = async (exchangeRate) => {
  try {
    await updateExchangeRate(exchangeRate);
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Unexpected error editing exchange rate type: key=${exchangeRate.key}`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Editing exchange rate failed: key=${exchangeRate.key}`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const fetchAllExchangeRates = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  const body = {};
  return fetchAllItems({
    fetch: (page) => () => searchExchangeRates({ page, pageSize: pageSize2, body }),
    errorMessage: "Retrieving all Exchange Rates failed"
  });
};
const removeExchangeRate = async (key) => {
  try {
    const result = await removeExchangeRate$1(key);
    return result;
  } catch (e) {
    log.warn({
      msg: `Removing exchange rate failed: key=${key}`,
      error: `${e}`
    });
    throw e;
  }
};
const searchAllExchangeRates = async ({
  body,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  return fetchAllItems({
    fetch: (page) => () => searchExchangeRates({ page, pageSize: pageSize2, body }),
    errorMessage: "Searching Exchange Rates failed"
  });
};
const createExchangeRateType = async (exchangeRateType) => {
  try {
    const { key } = await createExchangeRateType$1(exchangeRateType);
    return key;
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error creating exchange rate type`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Creating exchange rate type failed`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const editExchangeRateType = async (exchangeRateType) => {
  try {
    await updateExchangeRateType(exchangeRateType);
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error editing exchange rate type: key=${exchangeRateType.key}`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Editing approval group failed: key=${exchangeRateType.key}`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const fetchAllExchangeRateTypes = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  return fetchAllItems({
    fetch: (page) => () => getExchangeRateTypes({ page, pageSize: pageSize2 }),
    errorMessage: "Retrieving Exchange Rate types failed"
  });
};
const removeExchangeRateType = async (key) => {
  try {
    const result = await removeExchangeRateType$1(key);
    return result;
  } catch (e) {
    log.warn({
      msg: `Removing exchange rate type failed: key=${key}`,
      error: `${e}`
    });
    throw e;
  }
};
const DEFAULT_CURRENCY = {
  decimals: 2,
  isoCurrencyCode: "USD",
  isoNumericCode: "840",
  key: 119,
  name: "US Dollar"
};
const DEFAULT_EXCHANGE_RATE_TYPE = {
  key: -1,
  exchangeRateType: ""
};
const toCurrencyCodeDisplayModel = (currency) => {
  return {
    key: currency.key,
    name: currency.name,
    code: currency.isoCurrencyCode,
    decimals: currency.decimals
  };
};
const toCurrencyDisplayString = ({
  currency,
  includeName = true,
  missingDisplayString = ""
}) => {
  if (!currency) {
    return missingDisplayString;
  } else if (includeName && currency.name) {
    return `${currency.code} - ${currency.name}`;
  } else {
    return currency.code ?? missingDisplayString;
  }
};
const getCurrencySpec = (currencyCode) => {
  const locale = getUnanetLocale();
  const format2 = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode
  });
  const parts = format2.formatToParts(1000.1875);
  const getPart = (type) => {
    return parts.find((p) => p.type === type)?.value;
  };
  const symbol = getPart("currency") ?? "";
  const thousandSeparator = getPart("group") ?? "";
  const decimalSeparator = getPart("decimal") ?? ".";
  const decimals = getPart("fraction")?.length ?? 4;
  return {
    symbol,
    thousandSeparator,
    decimalSeparator,
    decimals
  };
};
const DEFAULT_MULTICURRENCY_SETUP = {
  enabled: false,
  instanceCurrency: DEFAULT_CURRENCY
};
const DEFAULT_MULTICURRENCY_CONFIG = {
  ...DEFAULT_MULTICURRENCY_SETUP,
  balanceSheetTranslationRateType: DEFAULT_EXCHANGE_RATE_TYPE,
  incomeStatementTranslationRateType: DEFAULT_EXCHANGE_RATE_TYPE
};
const toExchangeRateType = (rate) => {
  if (!rate) {
    return DEFAULT_EXCHANGE_RATE_TYPE;
  }
  return {
    key: rate.key,
    exchangeRateType: rate?.name ?? ""
  };
};
const fromMulticurrencySetupModel = (mcsm) => ({
  enabled: !!mcsm.enabled,
  instanceCurrency: mcsm.instanceCurrency ?? DEFAULT_CURRENCY,
  balanceSheetTranslationRateType: toExchangeRateType(
    mcsm.balanceSheetTranslationRateType
  ),
  incomeStatementTranslationRateType: toExchangeRateType(
    mcsm.incomeStatementTranslationRateType
  )
});
const activateMulticurrency = async () => {
  try {
    await activateMulticurrency$1();
  } catch (e) {
    log.warn({
      msg: "Failed to activate multicurrency",
      error: `${e}`
    });
    throw e;
  }
};
const fetchMulticurrencySetup = async () => {
  try {
    const mcsm = await getMulticurrency();
    return fromMulticurrencySetupModel(mcsm);
  } catch (e) {
    log.warn({
      msg: "Failed to retrieve multicurrency setup",
      error: `${e}`
    });
    return {
      enabled: false,
      instanceCurrency: DEFAULT_CURRENCY
    };
  }
};
const fetchMulticurrencyConfig = async () => {
  try {
    return fromMulticurrencySetupModel(await getMulticurrency());
  } catch (e) {
    log.warn({
      msg: "Failed to retrieve multicurrency setup",
      error: `${e}`
    });
    throw e;
  }
};
const editMulticurrencyConfig = async (requestBody) => {
  try {
    await editMulticurrencyConfig$1({
      balanceSheetTranslationRateType: {
        key: requestBody.balanceSheetTranslationRateType.key
      },
      incomeStatementTranslationRateType: {
        key: requestBody.incomeStatementTranslationRateType.key
      }
    });
    return requestBody;
  } catch (e) {
    log.warn({
      msg: "Updating Multicurrency config failed",
      error: `${e}`
    });
    throw e;
  }
};
const BOTKey$1 = "1900-01-01";
const EOTKey$1 = "2099-12-31";
const BOT = DateTime.fromISO(BOTKey$1);
const EOT = DateTime.fromISO(EOTKey$1);
const BOT_STR$1 = "BOT";
const EOT_STR$1 = "EOT";
const getUnanetLocale = () => {
  let locale = helpers.string("unanet.locale").replace("_", "-");
  if (locale === "en-CA" || locale === "en_CA") {
    locale = "en-GB";
  }
  return locale || "en-US";
};
const getDateLocalePartOrder = () => {
  return DateTime.now().setLocale(getUnanetLocale()).toLocaleParts(DateTime.DATE_SHORT).filter(
    (p) => p.type === "day" || p.type === "month" || p.type === "year"
  ).map((p) => p.type);
};
const getLocaleAwareDatePlaceholder = () => {
  return new DateTimeParser(getUnanetLocale()).getDateFnsLocaleFormat().toLowerCase();
};
const formatDate = (date, options = {}) => {
  const { format: format2 = "local", useBotEot = true } = options;
  if (useBotEot) {
    if (date.hasSame(BOT, "day")) {
      return BOT_STR$1;
    }
    if (date.hasSame(EOT, "day")) {
      return EOT_STR$1;
    }
  }
  if (format2 === "iso") {
    return date.toISODate();
  } else {
    return date.setLocale(getUnanetLocale()).toLocaleString(DateTime.DATE_SHORT);
  }
};
const formatDateCustom = (date, format2) => date.setLocale(getUnanetLocale()).toFormat(format2);
const formatDateTime = (date, format2 = "local", nonBreakingSpace = true) => {
  return format2 === "iso" ? date.toISO() : date.toFormat(`D${nonBreakingSpace ? " " : " "}t`);
};
const formatDateRange = (begin, end2, options = {}) => `${formatDate(begin, options)} – ${formatDate(end2, options)}`;
const fromISODateString = (s12) => {
  if (typeof s12 === "string") {
    return DateTime.fromISO(s12).startOf("day");
  } else if (typeof s12 === "number") {
    return DateTime.fromMillis(s12).startOf("day");
  } else {
    return null;
  }
};
const fromISODateTimeString = (s12) => {
  if (typeof s12 === "string") {
    return DateTime.fromISO(s12, { zone: "utc" }).toLocal();
  } else if (typeof s12 === "number") {
    return DateTime.fromMillis(s12, { zone: "utc" }).toLocal();
  } else {
    return null;
  }
};
const fromHoursNumber = (h12) => isNumber$1(h12) ? h12 : null;
const dateKey = (d) => d.isValid ? d.toISODate() ?? "" : "";
const formatTimestamp = (iso) => {
  if (!iso) {
    return void 0;
  }
  return DateTime.fromISO(iso).toLocaleString(DateTime.TIME_WITH_SECONDS);
};
var PeriodType = /* @__PURE__ */ ((PeriodType2) => {
  PeriodType2["CALENDAR"] = "CALENDAR";
  PeriodType2["FISCAL"] = "FISCAL";
  return PeriodType2;
})(PeriodType || {});
var Period = /* @__PURE__ */ ((Period2) => {
  Period2["DAYS"] = "DAYS";
  Period2["WEEKS"] = "WEEKS";
  Period2["SEMI_MONTHS"] = "SEMI_MONTHS";
  Period2["MONTHS"] = "MONTHS";
  Period2["QUARTERS"] = "QUARTERS";
  Period2["YEARS"] = "YEARS";
  return Period2;
})(Period || {});
var BudgetByOptions = /* @__PURE__ */ ((BudgetByOptions2) => {
  BudgetByOptions2["HOURS"] = "hours";
  BudgetByOptions2["UTILIZATION"] = "utilization";
  return BudgetByOptions2;
})(BudgetByOptions || {});
var AllocationColor = /* @__PURE__ */ ((AllocationColor2) => {
  AllocationColor2["None"] = "None";
  AllocationColor2["Yellow"] = "Yellow";
  AllocationColor2["Green"] = "Green";
  AllocationColor2["Red"] = "Red";
  return AllocationColor2;
})(AllocationColor || {});
var AssignablePlannedTimeUnassignableReasons = /* @__PURE__ */ ((AssignablePlannedTimeUnassignableReasons2) => {
  AssignablePlannedTimeUnassignableReasons2["AssignLevel"] = "ASSIGN_LEVEL";
  AssignablePlannedTimeUnassignableReasons2["InactivePlanSet"] = "INACTIVE_PLAN_SET";
  AssignablePlannedTimeUnassignableReasons2["InsufficientAccess"] = "INSUFFICIENT_ACCESS";
  AssignablePlannedTimeUnassignableReasons2["InvalidLaborCategory"] = "INVALID_LABOR_CATEGORY";
  AssignablePlannedTimeUnassignableReasons2["LaborCategory"] = "LABOR_CATEGORY";
  AssignablePlannedTimeUnassignableReasons2["MissingICAttributes"] = "MISSING_IC_ATTRIBUTES";
  return AssignablePlannedTimeUnassignableReasons2;
})(AssignablePlannedTimeUnassignableReasons || {});
var PlannedTimeUneditableReason = /* @__PURE__ */ ((PlannedTimeUneditableReason2) => {
  PlannedTimeUneditableReason2["PlanNotAligned"] = "PLAN_NOT_ALIGNED";
  PlannedTimeUneditableReason2["PlanRequestKey"] = "PLAN_REQUEST_KEY";
  PlannedTimeUneditableReason2["PlanSetLocked"] = "PLAN_SET_LOCKED";
  PlannedTimeUneditableReason2["PopWbsDates"] = "POP_WBS_DATES";
  PlannedTimeUneditableReason2["WbsDates"] = "WBS_DATES";
  return PlannedTimeUneditableReason2;
})(PlannedTimeUneditableReason || {});
const fromDateString = (date) => {
  if (!date) {
    return "";
  }
  return DateTime.fromISO(date).toLocaleString();
};
const calendarQuarters = (currentDate) => {
  return {
    1: {
      begin: DateTime.local(currentDate.year, 1, 1),
      end: DateTime.local(currentDate.year, 3, 31)
    },
    2: {
      begin: DateTime.local(currentDate.year, 4, 1),
      end: DateTime.local(currentDate.year, 6, 30)
    },
    3: {
      begin: DateTime.local(currentDate.year, 7, 1),
      end: DateTime.local(currentDate.year, 9, 30)
    },
    4: {
      begin: DateTime.local(currentDate.year, 10, 1),
      end: DateTime.local(currentDate.year, 12, 31)
    }
  };
};
const botToEOT = () => {
  return { begin: BOT, end: EOT };
};
const botToToday = () => {
  return { begin: BOT, end: DateTime.local() };
};
const calendarCurrentMonth = () => {
  const currentDate = DateTime.local();
  return {
    begin: DateTime.local(currentDate.year, currentDate.month, 1),
    end: DateTime.local(
      currentDate.year,
      currentDate.month,
      currentDate.daysInMonth ?? 0
    )
  };
};
const calendarCurrentQuarter = () => {
  const currentDate = DateTime.local();
  const quarters = calendarQuarters(currentDate);
  return {
    begin: quarters[currentDate.quarter].begin,
    end: quarters[currentDate.quarter].end
  };
};
const today = () => {
  const currentDate = DateTime.local();
  return {
    begin: currentDate,
    end: currentDate
  };
};
const tomorrow = () => {
  const currentDate = DateTime.local();
  return {
    begin: DateTime.local(
      currentDate.year,
      currentDate.month,
      currentDate.day + 1
    ),
    end: DateTime.local(
      currentDate.year,
      currentDate.month,
      currentDate.day + 1
    )
  };
};
const yesterday = () => {
  const currentDate = DateTime.local();
  return {
    begin: DateTime.local(
      currentDate.year,
      currentDate.month,
      currentDate.day - 1
    ),
    end: DateTime.local(
      currentDate.year,
      currentDate.month,
      currentDate.day - 1
    )
  };
};
const dateWithinRange = (startDate, endDate, period) => {
  const periodBeginDate = DateTime.fromISO(period.beginDate);
  const periodEndDate = DateTime.fromISO(period.endDate);
  if (startDate >= periodBeginDate && startDate <= periodEndDate) {
    return period;
  } else if (endDate >= periodBeginDate && endDate <= periodEndDate) {
    return period;
  }
  return periodBeginDate >= startDate && periodEndDate <= endDate;
};
const dateAfterStart = (startDate, period) => {
  const periodBeginDate = DateTime.fromISO(period.beginDate);
  const periodEndDate = DateTime.fromISO(period.endDate);
  return startDate >= periodBeginDate && startDate <= periodEndDate || startDate < periodBeginDate;
};
const generateCalendarQuarterPeriodsByCount = (startDate, periodCount) => {
  const quarterStart = startDate.startOf("month");
  const periods = [];
  for (let i = 0; i < periodCount; i++) {
    const rangeStart = quarterStart.plus({ months: i * 3 }).toISODate() ?? "";
    const rangeEnd = quarterStart.plus({ months: i * 3 + 3 }).minus({ days: 1 }).toISODate() ?? "";
    periods.push({ rangeStart, rangeEnd });
  }
  return periods;
};
const generateCalendarQuarterPeriodsByDates = (startDate, endDate) => {
  const quarterStart = startDate.startOf("month");
  const monthsFromStart = endDate.startOf("month").diff(quarterStart, "months").months;
  const periodCount = Math.ceil((monthsFromStart + 1) / 3);
  return generateCalendarQuarterPeriodsByCount(startDate, periodCount);
};
const getStartEndDateByDates = (startDate, endDate, period) => {
  if (period === Period.QUARTERS) {
    const quarterPeriods = generateCalendarQuarterPeriodsByDates(
      startDate,
      endDate
    );
    const planStartDate = DateTime.fromISO(quarterPeriods[0].rangeStart);
    const planEndDate = DateTime.fromISO(
      quarterPeriods[quarterPeriods.length - 1].rangeEnd
    );
    return { planStartDate, planEndDate };
  } else {
    const unit = period.toLowerCase();
    const planStartDate = startDate.startOf(unit);
    const planEndDate = endDate.endOf(unit);
    return { planStartDate, planEndDate };
  }
};
const getWeeklyStartEndDateByDates = (startDate, endDate) => {
  const planStartDateDay = parseInt(startDate.toFormat("c"));
  const planEndDateDay = parseInt(endDate.toFormat("c"));
  let planStartDate = startDate.startOf("day");
  let planEndDate = endDate.endOf("day");
  if (planStartDateDay !== 7) {
    planStartDate = startDate.startOf("week").minus({ day: 1 });
  }
  if (planEndDateDay !== 6) {
    planEndDate = endDate.endOf("week").minus({ day: 1 });
  }
  return { planStartDate, planEndDate };
};
const getSemiMonthStartEndDateByDates = (startDate, endDate) => {
  let planStartDate, planEndDate;
  const startDayOfMonth = startDate.toFormat("dd");
  const startMonth = startDate.toFormat("LL");
  const startYear = startDate.toFormat("y");
  const endDayOfMonth = endDate.toFormat("dd");
  const endMonth = endDate.toFormat("LL");
  const endYear = endDate.toFormat("y");
  if (parseInt(startDayOfMonth) > 15) {
    planStartDate = DateTime.fromISO(`${startYear}-${startMonth}-16`);
  } else {
    planStartDate = DateTime.fromISO(`${startYear}-${startMonth}-01`);
  }
  if (parseInt(endDayOfMonth) > 15) {
    planEndDate = endDate.endOf("month");
  } else {
    planEndDate = DateTime.fromISO(`${endYear}-${endMonth}-15`);
  }
  return { planStartDate, planEndDate };
};
const getStartEndDateByPeriodCount = (startDate, period, periodCount, calendarType) => {
  if (period === Period.QUARTERS) {
    const quarterPeriods = generateCalendarQuarterPeriodsByCount(
      startDate,
      periodCount
    );
    const planStartDate = DateTime.fromISO(quarterPeriods[0].rangeStart);
    const planEndDate = DateTime.fromISO(
      quarterPeriods[quarterPeriods.length - 1].rangeEnd
    );
    return {
      planStartDate,
      planEndDate: calendarType ? planEndDate : void 0
    };
  } else {
    const unit = period.toLowerCase();
    const planStartDate = startDate.startOf(unit);
    const planEndDate = planStartDate.plus({ [period.toLowerCase()]: periodCount - 1 }).endOf(unit);
    return {
      planStartDate,
      planEndDate: calendarType ? planEndDate : void 0
    };
  }
};
const getWeeklyStartEndDateByPeriodCount = (startDate, periodCount, calendarType) => {
  const planStartDateDay = parseInt(startDate.toFormat("c"));
  if (planStartDateDay === 7) {
    const planStartDate = startDate.startOf("day");
    const planEndDate = startDate.plus({ day: 1 }).plus({ ["weeks"]: periodCount - 1 }).endOf("week").minus({ day: 1 });
    return {
      planStartDate,
      planEndDate: calendarType ? planEndDate : void 0
    };
  } else {
    const planStartDate = startDate.startOf("week").minus({ day: 1 });
    const planEndDate = startDate.startOf("week").plus({ weeks: periodCount - 1 }).endOf("week").minus({ day: 1 });
    return {
      planStartDate,
      planEndDate: calendarType ? planEndDate : void 0
    };
  }
};
const getSemiMonthStartEndDateByPeriodCount = (startDate, periodCount, calendarType) => {
  let planStartDate, planEndDate;
  const dayOfMonth = startDate.toFormat("dd");
  const currentMonth = startDate.toFormat("LL");
  const currentYear = startDate.toFormat("y");
  if (parseInt(dayOfMonth) > 15) {
    planStartDate = DateTime.fromISO(`${currentYear}-${currentMonth}-16`);
    if (periodCount % 2 === 0) {
      planEndDate = planStartDate.plus({ ["months"]: periodCount / 2 });
    } else {
      planEndDate = planStartDate.plus({ ["months"]: Math.floor(periodCount / 2) }).endOf("months");
    }
  } else {
    planStartDate = DateTime.fromISO(`${currentYear}-${currentMonth}-01`);
    if (periodCount % 2 === 0) {
      planEndDate = planStartDate.plus({ ["months"]: periodCount / 2 - 1 }).endOf("months");
    } else {
      planEndDate = planStartDate.plus({ ["months"]: Math.floor(periodCount / 2) }).plus({ ["days"]: 15 });
    }
  }
  return { planStartDate, planEndDate: calendarType ? planEndDate : void 0 };
};
const generatePeriodsForSemiMonthByPeriods = (startDate, periodCount, periods = []) => {
  const day = startDate.toFormat("dd");
  const month = startDate.toFormat("LL");
  const year = startDate.toFormat("y");
  let periodsRemaining = periodCount;
  for (let i = 1; i <= 12; i++) {
    if (parseInt(month) <= i && periodsRemaining > 0) {
      const currentMonth = i.toString().padStart(2, "0");
      const startOfMonth = DateTime.fromISO(`${year}-${currentMonth}-01`).toISODate() ?? "";
      const endOfFirstSemiMonth = DateTime.fromISO(`${year}-${currentMonth}-15`).toISODate() ?? "";
      const startOfSecondSemiMonth = DateTime.fromISO(`${year}-${currentMonth}-16`).toISODate() ?? "";
      const endOfMonth = DateTime.fromISO(`${year}-${currentMonth}-01`).endOf("month").toISODate() ?? "";
      if (periodsRemaining === periodCount && parseInt(day) > 15) {
        periods.push({
          rangeStart: startOfSecondSemiMonth,
          rangeEnd: endOfMonth
        });
        periodsRemaining -= 1;
      } else {
        if (periodsRemaining === 1) {
          periods.push({
            rangeStart: startOfMonth,
            rangeEnd: endOfFirstSemiMonth
          });
          periodsRemaining -= 1;
        } else {
          periods.push({
            rangeStart: startOfMonth,
            rangeEnd: endOfFirstSemiMonth
          });
          periods.push({
            rangeStart: startOfSecondSemiMonth,
            rangeEnd: endOfMonth
          });
          periodsRemaining -= 2;
        }
      }
    }
  }
  if (periodsRemaining > 0) {
    const nextYear = startDate.plus({ ["years"]: 1 }).startOf("year");
    return generatePeriodsForSemiMonthByPeriods(
      nextYear,
      periodsRemaining,
      periods
    );
  }
  return periods;
};
const generatePeriodsForSemiMonthByDates = (startDate, endDate, periods = []) => {
  const startDay = startDate.toFormat("dd");
  const startMonth = startDate.toFormat("LL");
  const startYear = startDate.toFormat("y");
  const endDay = endDate.toFormat("dd");
  const endMonth = endDate.toFormat("LL");
  const endYear = endDate.toFormat("y");
  for (let i = 1; i <= 12; i++) {
    if (startYear === endYear) {
      const currentMonth = i.toString().padStart(2, "0");
      const startOfMonth = DateTime.fromISO(`${endYear}-${currentMonth}-01`).toISODate() ?? "";
      const endOfFirstSemiMonth = DateTime.fromISO(`${endYear}-${currentMonth}-15`).toISODate() ?? "";
      const startOfSecondSemiMonth = DateTime.fromISO(`${endYear}-${currentMonth}-16`).toISODate() ?? "";
      const endOfMonth = DateTime.fromISO(`${endYear}-${currentMonth}-01`).endOf("month").toISODate() ?? "";
      if (parseInt(startMonth) <= i && parseInt(endMonth) > i) {
        periods.push({
          rangeStart: startOfMonth,
          rangeEnd: endOfFirstSemiMonth
        });
        periods.push({
          rangeStart: startOfSecondSemiMonth,
          rangeEnd: endOfMonth
        });
      } else if (i === parseInt(endMonth)) {
        if (parseInt(endDay) <= 15) {
          periods.push({
            rangeStart: startOfMonth,
            rangeEnd: endOfFirstSemiMonth
          });
        } else {
          periods.push({
            rangeStart: startOfMonth,
            rangeEnd: endOfFirstSemiMonth
          });
          periods.push({
            rangeStart: startOfSecondSemiMonth,
            rangeEnd: endOfMonth
          });
        }
      }
    } else {
      if (parseInt(startMonth) <= i) {
        const currentMonth = i.toString().padStart(2, "0");
        const startOfMonth = DateTime.fromISO(`${startYear}-${currentMonth}-01`).toISODate() ?? "";
        const endOfFirstSemiMonth = DateTime.fromISO(`${startYear}-${currentMonth}-15`).toISODate() ?? "";
        const startOfSecondSemiMonth = DateTime.fromISO(`${startYear}-${currentMonth}-16`).toISODate() ?? "";
        const endOfMonth = DateTime.fromISO(`${startYear}-${currentMonth}-01`).endOf("month").toISODate() ?? "";
        if (parseInt(startDay) > 15 && parseInt(startMonth) === parseInt(currentMonth)) {
          periods.push({
            rangeStart: startOfSecondSemiMonth,
            rangeEnd: endOfMonth
          });
        } else {
          periods.push({
            rangeStart: startOfMonth,
            rangeEnd: endOfFirstSemiMonth
          });
          periods.push({
            rangeStart: startOfSecondSemiMonth,
            rangeEnd: endOfMonth
          });
        }
      }
    }
  }
  if (startYear !== endYear) {
    const nextYear = startDate.plus({ ["years"]: 1 }).startOf("year");
    return generatePeriodsForSemiMonthByDates(nextYear, endDate, periods);
  }
  return periods;
};
const workHoursBetween = (startDate, endDate) => {
  const defaultWorkHours = helpers.string("unatime.default.work.hours");
  const dayHours = defaultWorkHours ? parseInt(defaultWorkHours) : 8;
  return workDaysBetween(startDate, endDate) * dayHours;
};
const workDaysBetween = (startDate, endDate) => {
  startDate = startDate.startOf("day");
  endDate = endDate.startOf("day");
  let numWeekdays = 0;
  const startDateWeekday = startDate.weekday;
  let numDays = 0;
  for (let weekday = startDateWeekday; weekday !== 1; weekday = weekday === 7 ? 1 : weekday + 1) {
    if (weekday <= 5) {
      numWeekdays++;
    }
    numDays++;
  }
  const firstMonday = startDate.plus({ day: numDays });
  const endDateWeekday = endDate.weekday;
  numDays = 0;
  for (let weekday = endDateWeekday; weekday !== 7; weekday = weekday === 1 ? 7 : weekday - 1) {
    if (weekday <= 5) {
      numWeekdays++;
    }
    numDays++;
  }
  const lastSunday = endDate.minus({ day: numDays });
  const numWeeks = (lastSunday.diff(firstMonday, ["days"]).days + 1) / 7;
  numWeekdays += numWeeks * 5;
  return numWeekdays;
};
const nextWorkDay = (date) => {
  switch (date.weekday) {
    case 5:
      return date.plus({ day: 3 });
    case 6:
      return date.plus({ day: 2 });
    default:
      return date.plus({ day: 1 });
  }
};
const previousWorkDay = (date) => {
  switch (date.weekday) {
    case 1:
      return date.minus({ day: 3 });
    case 7:
      return date.minus({ day: 2 });
    default:
      return date.minus({ day: 1 });
  }
};
const addWorkDays = (date, workDays) => {
  if (workDays === 0) {
    return date;
  } else if (date.weekday >= 6) {
    return getDateForWorkDaysBetween(date, workDays);
  } else {
    return getDateForWorkDaysBetween(date, workDays + Math.sign(workDays));
  }
};
const BOT_EOT_WORK_DAYS = 52179;
const getDateForWorkDaysBetween = (date, workDays) => {
  let endDate;
  if (workDays === 0) {
    endDate = date;
  } else {
    endDate = date.plus({ days: Math.round(workDays * 7 / 5) });
    let diff2 = 0;
    if (workDays > 0) {
      while ((diff2 = workDaysBetween(date, endDate) - workDays) !== 0) {
        endDate = endDate.plus({ day: diff2 > 0 ? -1 : 1 });
      }
    } else {
      while ((diff2 = workDaysBetween(endDate, date) + workDays) !== 0) {
        endDate = endDate.minus({ day: diff2 > 0 ? -1 : 1 });
      }
    }
    if (endDate.weekday >= 6) {
      if (workDays > 0) {
        endDate = endDate.minus({ day: endDate.weekday - 5 });
      } else {
        endDate = endDate.plus({ day: 8 - endDate.weekday });
      }
    }
  }
  return endDate;
};
const isWeekdayIncluded = (weekday, businessWeek) => {
  switch (weekday) {
    case 1:
      return businessWeek.monday;
    case 2:
      return businessWeek.tuesday;
    case 3:
      return businessWeek.wednesday;
    case 4:
      return businessWeek.thursday;
    case 5:
      return businessWeek.friday;
    case 6:
      return businessWeek.saturday;
    case 7:
      return businessWeek.sunday;
    default:
      return false;
  }
};
const countBusinessDays = (businessWeek) => {
  let count2 = 0;
  for (let weekday = 1; weekday <= 7; ++weekday) {
    if (isWeekdayIncluded(weekday, businessWeek)) {
      ++count2;
    }
  }
  return count2;
};
const businessHoursBetween = (startDate, endDate, businessWeek) => {
  startDate = startDate.startOf("day");
  endDate = endDate.startOf("day");
  let numWeekdays = 0;
  const startDateWeekday = startDate.weekday;
  let numDays = 0;
  for (let weekday = startDateWeekday; weekday !== 1; weekday = weekday === 7 ? 1 : weekday + 1) {
    if (isWeekdayIncluded(weekday, businessWeek)) {
      numWeekdays++;
    }
    numDays++;
  }
  const firstMonday = startDate.plus({ day: numDays });
  const endDateWeekday = endDate.weekday;
  numDays = 0;
  for (let weekday = endDateWeekday; weekday !== 7; weekday = weekday === 1 ? 7 : weekday - 1) {
    if (isWeekdayIncluded(weekday, businessWeek)) {
      numWeekdays++;
    }
    numDays++;
  }
  const lastSunday = endDate.minus({ day: numDays });
  const numWeeks = (lastSunday.diff(firstMonday, ["days"]).days + 1) / 7;
  numWeekdays += numWeeks * countBusinessDays(businessWeek);
  const numBusinessHours = numWeekdays * businessWeek.hours;
  return numBusinessHours;
};
const base64ToObjectURL = ({
  base64,
  type
}) => {
  try {
    const binaryString = atob(base64);
    const byteArray = Uint8Array.from(binaryString, (c) => c.charCodeAt(0));
    return URL.createObjectURL(new Blob([byteArray], { type }));
  } catch (error) {
    log.error({
      msg: "Failed to convert base64 to ObjectURL",
      error: `${error}`
    });
    return null;
  }
};
var global$1$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
var lookup$1 = [];
var revLookup$1 = [];
var Arr$1 = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var inited$1 = false;
function init$1() {
  inited$1 = true;
  var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  for (var i = 0, len = code.length; i < len; ++i) {
    lookup$1[i] = code[i];
    revLookup$1[code.charCodeAt(i)] = i;
  }
  revLookup$1["-".charCodeAt(0)] = 62;
  revLookup$1["_".charCodeAt(0)] = 63;
}
function toByteArray$1(b64) {
  if (!inited$1) {
    init$1();
  }
  var i, j, l2, tmp, placeHolders, arr;
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error("Invalid string. Length must be a multiple of 4");
  }
  placeHolders = b64[len - 2] === "=" ? 2 : b64[len - 1] === "=" ? 1 : 0;
  arr = new Arr$1(len * 3 / 4 - placeHolders);
  l2 = placeHolders > 0 ? len - 4 : len;
  var L = 0;
  for (i = 0, j = 0; i < l2; i += 4, j += 3) {
    tmp = revLookup$1[b64.charCodeAt(i)] << 18 | revLookup$1[b64.charCodeAt(i + 1)] << 12 | revLookup$1[b64.charCodeAt(i + 2)] << 6 | revLookup$1[b64.charCodeAt(i + 3)];
    arr[L++] = tmp >> 16 & 255;
    arr[L++] = tmp >> 8 & 255;
    arr[L++] = tmp & 255;
  }
  if (placeHolders === 2) {
    tmp = revLookup$1[b64.charCodeAt(i)] << 2 | revLookup$1[b64.charCodeAt(i + 1)] >> 4;
    arr[L++] = tmp & 255;
  } else if (placeHolders === 1) {
    tmp = revLookup$1[b64.charCodeAt(i)] << 10 | revLookup$1[b64.charCodeAt(i + 1)] << 4 | revLookup$1[b64.charCodeAt(i + 2)] >> 2;
    arr[L++] = tmp >> 8 & 255;
    arr[L++] = tmp & 255;
  }
  return arr;
}
function tripletToBase64$1(num) {
  return lookup$1[num >> 18 & 63] + lookup$1[num >> 12 & 63] + lookup$1[num >> 6 & 63] + lookup$1[num & 63];
}
function encodeChunk$1(uint8, start2, end2) {
  var tmp;
  var output = [];
  for (var i = start2; i < end2; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
    output.push(tripletToBase64$1(tmp));
  }
  return output.join("");
}
function fromByteArray$1(uint8) {
  if (!inited$1) {
    init$1();
  }
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3;
  var output = "";
  var parts = [];
  var maxChunkLength = 16383;
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk$1(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    output += lookup$1[tmp >> 2];
    output += lookup$1[tmp << 4 & 63];
    output += "==";
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    output += lookup$1[tmp >> 10];
    output += lookup$1[tmp >> 4 & 63];
    output += lookup$1[tmp << 2 & 63];
    output += "=";
  }
  parts.push(output);
  return parts.join("");
}
function read$2(buffer2, offset2, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s12 = buffer2[offset2 + i];
  i += d;
  e = s12 & (1 << -nBits) - 1;
  s12 >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer2[offset2 + i], i += d, nBits -= 8) {
  }
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer2[offset2 + i], i += d, nBits -= 8) {
  }
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s12 ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s12 ? -1 : 1) * m * Math.pow(2, e - mLen);
}
function write$2(buffer2, value, offset2, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s12 = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);
  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer2[offset2 + i] = m & 255, i += d, m /= 256, mLen -= 8) {
  }
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer2[offset2 + i] = e & 255, i += d, e /= 256, eLen -= 8) {
  }
  buffer2[offset2 + i - d] |= s12 * 128;
}
var toString$1 = {}.toString;
var isArray$2 = Array.isArray || function(arr) {
  return toString$1.call(arr) == "[object Array]";
};
var INSPECT_MAX_BYTES$1 = 50;
Buffer$2.TYPED_ARRAY_SUPPORT = global$1$1.TYPED_ARRAY_SUPPORT !== void 0 ? global$1$1.TYPED_ARRAY_SUPPORT : true;
kMaxLength$1();
function kMaxLength$1() {
  return Buffer$2.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function createBuffer$1(that, length2) {
  if (kMaxLength$1() < length2) {
    throw new RangeError("Invalid typed array length");
  }
  if (Buffer$2.TYPED_ARRAY_SUPPORT) {
    that = new Uint8Array(length2);
    that.__proto__ = Buffer$2.prototype;
  } else {
    if (that === null) {
      that = new Buffer$2(length2);
    }
    that.length = length2;
  }
  return that;
}
function Buffer$2(arg2, encodingOrOffset, length2) {
  if (!Buffer$2.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer$2)) {
    return new Buffer$2(arg2, encodingOrOffset, length2);
  }
  if (typeof arg2 === "number") {
    if (typeof encodingOrOffset === "string") {
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    }
    return allocUnsafe$1(this, arg2);
  }
  return from$2(this, arg2, encodingOrOffset, length2);
}
Buffer$2.poolSize = 8192;
Buffer$2._augment = function(arr) {
  arr.__proto__ = Buffer$2.prototype;
  return arr;
};
function from$2(that, value, encodingOrOffset, length2) {
  if (typeof value === "number") {
    throw new TypeError('"value" argument must not be a number');
  }
  if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) {
    return fromArrayBuffer$1(that, value, encodingOrOffset, length2);
  }
  if (typeof value === "string") {
    return fromString$1(that, value, encodingOrOffset);
  }
  return fromObject$1(that, value);
}
Buffer$2.from = function(value, encodingOrOffset, length2) {
  return from$2(null, value, encodingOrOffset, length2);
};
if (Buffer$2.TYPED_ARRAY_SUPPORT) {
  Buffer$2.prototype.__proto__ = Uint8Array.prototype;
  Buffer$2.__proto__ = Uint8Array;
  if (typeof Symbol !== "undefined" && Symbol.species && Buffer$2[Symbol.species] === Buffer$2) ;
}
function assertSize$1(size) {
  if (typeof size !== "number") {
    throw new TypeError('"size" argument must be a number');
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative');
  }
}
function alloc$2(that, size, fill3, encoding) {
  assertSize$1(size);
  if (size <= 0) {
    return createBuffer$1(that, size);
  }
  if (fill3 !== void 0) {
    return typeof encoding === "string" ? createBuffer$1(that, size).fill(fill3, encoding) : createBuffer$1(that, size).fill(fill3);
  }
  return createBuffer$1(that, size);
}
Buffer$2.alloc = function(size, fill3, encoding) {
  return alloc$2(null, size, fill3, encoding);
};
function allocUnsafe$1(that, size) {
  assertSize$1(size);
  that = createBuffer$1(that, size < 0 ? 0 : checked$1(size) | 0);
  if (!Buffer$2.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that;
}
Buffer$2.allocUnsafe = function(size) {
  return allocUnsafe$1(null, size);
};
Buffer$2.allocUnsafeSlow = function(size) {
  return allocUnsafe$1(null, size);
};
function fromString$1(that, string2, encoding) {
  if (typeof encoding !== "string" || encoding === "") {
    encoding = "utf8";
  }
  if (!Buffer$2.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding');
  }
  var length2 = byteLength$1(string2, encoding) | 0;
  that = createBuffer$1(that, length2);
  var actual = that.write(string2, encoding);
  if (actual !== length2) {
    that = that.slice(0, actual);
  }
  return that;
}
function fromArrayLike$1(that, array) {
  var length2 = array.length < 0 ? 0 : checked$1(array.length) | 0;
  that = createBuffer$1(that, length2);
  for (var i = 0; i < length2; i += 1) {
    that[i] = array[i] & 255;
  }
  return that;
}
function fromArrayBuffer$1(that, array, byteOffset, length2) {
  array.byteLength;
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError("'offset' is out of bounds");
  }
  if (array.byteLength < byteOffset + (length2 || 0)) {
    throw new RangeError("'length' is out of bounds");
  }
  if (byteOffset === void 0 && length2 === void 0) {
    array = new Uint8Array(array);
  } else if (length2 === void 0) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length2);
  }
  if (Buffer$2.TYPED_ARRAY_SUPPORT) {
    that = array;
    that.__proto__ = Buffer$2.prototype;
  } else {
    that = fromArrayLike$1(that, array);
  }
  return that;
}
function fromObject$1(that, obj) {
  if (internalIsBuffer$1(obj)) {
    var len = checked$1(obj.length) | 0;
    that = createBuffer$1(that, len);
    if (that.length === 0) {
      return that;
    }
    obj.copy(that, 0, 0, len);
    return that;
  }
  if (obj) {
    if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
      if (typeof obj.length !== "number" || isnan$1(obj.length)) {
        return createBuffer$1(that, 0);
      }
      return fromArrayLike$1(that, obj);
    }
    if (obj.type === "Buffer" && isArray$2(obj.data)) {
      return fromArrayLike$1(that, obj.data);
    }
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked$1(length2) {
  if (length2 >= kMaxLength$1()) {
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength$1().toString(16) + " bytes");
  }
  return length2 | 0;
}
Buffer$2.isBuffer = isBuffer$1;
function internalIsBuffer$1(b) {
  return !!(b != null && b._isBuffer);
}
Buffer$2.compare = function compare(a, b) {
  if (!internalIsBuffer$1(a) || !internalIsBuffer$1(b)) {
    throw new TypeError("Arguments must be Buffers");
  }
  if (a === b) return 0;
  var x = a.length;
  var y = b.length;
  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};
Buffer$2.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return true;
    default:
      return false;
  }
};
Buffer$2.concat = function concat(list2, length2) {
  if (!isArray$2(list2)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }
  if (list2.length === 0) {
    return Buffer$2.alloc(0);
  }
  var i;
  if (length2 === void 0) {
    length2 = 0;
    for (i = 0; i < list2.length; ++i) {
      length2 += list2[i].length;
    }
  }
  var buffer2 = Buffer$2.allocUnsafe(length2);
  var pos = 0;
  for (i = 0; i < list2.length; ++i) {
    var buf = list2[i];
    if (!internalIsBuffer$1(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    buf.copy(buffer2, pos);
    pos += buf.length;
  }
  return buffer2;
};
function byteLength$1(string2, encoding) {
  if (internalIsBuffer$1(string2)) {
    return string2.length;
  }
  if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string2) || string2 instanceof ArrayBuffer)) {
    return string2.byteLength;
  }
  if (typeof string2 !== "string") {
    string2 = "" + string2;
  }
  var len = string2.length;
  if (len === 0) return 0;
  var loweredCase = false;
  for (; ; ) {
    switch (encoding) {
      case "ascii":
      case "latin1":
      case "binary":
        return len;
      case "utf8":
      case "utf-8":
      case void 0:
        return utf8ToBytes$1(string2).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return len * 2;
      case "hex":
        return len >>> 1;
      case "base64":
        return base64ToBytes$1(string2).length;
      default:
        if (loweredCase) return utf8ToBytes$1(string2).length;
        encoding = ("" + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer$2.byteLength = byteLength$1;
function slowToString$1(encoding, start2, end2) {
  var loweredCase = false;
  if (start2 === void 0 || start2 < 0) {
    start2 = 0;
  }
  if (start2 > this.length) {
    return "";
  }
  if (end2 === void 0 || end2 > this.length) {
    end2 = this.length;
  }
  if (end2 <= 0) {
    return "";
  }
  end2 >>>= 0;
  start2 >>>= 0;
  if (end2 <= start2) {
    return "";
  }
  if (!encoding) encoding = "utf8";
  while (true) {
    switch (encoding) {
      case "hex":
        return hexSlice$1(this, start2, end2);
      case "utf8":
      case "utf-8":
        return utf8Slice$1(this, start2, end2);
      case "ascii":
        return asciiSlice$1(this, start2, end2);
      case "latin1":
      case "binary":
        return latin1Slice$1(this, start2, end2);
      case "base64":
        return base64Slice$1(this, start2, end2);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return utf16leSlice$1(this, start2, end2);
      default:
        if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
        encoding = (encoding + "").toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer$2.prototype._isBuffer = true;
function swap$1(b, n12, m) {
  var i = b[n12];
  b[n12] = b[m];
  b[m] = i;
}
Buffer$2.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  }
  for (var i = 0; i < len; i += 2) {
    swap$1(this, i, i + 1);
  }
  return this;
};
Buffer$2.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  }
  for (var i = 0; i < len; i += 4) {
    swap$1(this, i, i + 3);
    swap$1(this, i + 1, i + 2);
  }
  return this;
};
Buffer$2.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  }
  for (var i = 0; i < len; i += 8) {
    swap$1(this, i, i + 7);
    swap$1(this, i + 1, i + 6);
    swap$1(this, i + 2, i + 5);
    swap$1(this, i + 3, i + 4);
  }
  return this;
};
Buffer$2.prototype.toString = function toString() {
  var length2 = this.length | 0;
  if (length2 === 0) return "";
  if (arguments.length === 0) return utf8Slice$1(this, 0, length2);
  return slowToString$1.apply(this, arguments);
};
Buffer$2.prototype.equals = function equals(b) {
  if (!internalIsBuffer$1(b)) throw new TypeError("Argument must be a Buffer");
  if (this === b) return true;
  return Buffer$2.compare(this, b) === 0;
};
Buffer$2.prototype.inspect = function inspect() {
  var str = "";
  var max2 = INSPECT_MAX_BYTES$1;
  if (this.length > 0) {
    str = this.toString("hex", 0, max2).match(/.{2}/g).join(" ");
    if (this.length > max2) str += " ... ";
  }
  return "<Buffer " + str + ">";
};
Buffer$2.prototype.compare = function compare2(target, start2, end2, thisStart, thisEnd) {
  if (!internalIsBuffer$1(target)) {
    throw new TypeError("Argument must be a Buffer");
  }
  if (start2 === void 0) {
    start2 = 0;
  }
  if (end2 === void 0) {
    end2 = target ? target.length : 0;
  }
  if (thisStart === void 0) {
    thisStart = 0;
  }
  if (thisEnd === void 0) {
    thisEnd = this.length;
  }
  if (start2 < 0 || end2 > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError("out of range index");
  }
  if (thisStart >= thisEnd && start2 >= end2) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start2 >= end2) {
    return 1;
  }
  start2 >>>= 0;
  end2 >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;
  if (this === target) return 0;
  var x = thisEnd - thisStart;
  var y = end2 - start2;
  var len = Math.min(x, y);
  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start2, end2);
  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};
function bidirectionalIndexOf$1(buffer2, val, byteOffset, encoding, dir) {
  if (buffer2.length === 0) return -1;
  if (typeof byteOffset === "string") {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 2147483647) {
    byteOffset = 2147483647;
  } else if (byteOffset < -2147483648) {
    byteOffset = -2147483648;
  }
  byteOffset = +byteOffset;
  if (isNaN(byteOffset)) {
    byteOffset = dir ? 0 : buffer2.length - 1;
  }
  if (byteOffset < 0) byteOffset = buffer2.length + byteOffset;
  if (byteOffset >= buffer2.length) {
    if (dir) return -1;
    else byteOffset = buffer2.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;
    else return -1;
  }
  if (typeof val === "string") {
    val = Buffer$2.from(val, encoding);
  }
  if (internalIsBuffer$1(val)) {
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf$1(buffer2, val, byteOffset, encoding, dir);
  } else if (typeof val === "number") {
    val = val & 255;
    if (Buffer$2.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer2, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer2, val, byteOffset);
      }
    }
    return arrayIndexOf$1(buffer2, [val], byteOffset, encoding, dir);
  }
  throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf$1(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;
  if (encoding !== void 0) {
    encoding = String(encoding).toLowerCase();
    if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }
  function read2(buf, i12) {
    if (indexSize === 1) {
      return buf[i12];
    } else {
      return buf.readUInt16BE(i12 * indexSize);
    }
  }
  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read2(arr, i) === read2(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read2(arr, i + j) !== read2(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }
  return -1;
}
Buffer$2.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer$2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf$1(this, val, byteOffset, encoding, true);
};
Buffer$2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf$1(this, val, byteOffset, encoding, false);
};
function hexWrite$1(buf, string2, offset2, length2) {
  offset2 = Number(offset2) || 0;
  var remaining = buf.length - offset2;
  if (!length2) {
    length2 = remaining;
  } else {
    length2 = Number(length2);
    if (length2 > remaining) {
      length2 = remaining;
    }
  }
  var strLen = string2.length;
  if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
  if (length2 > strLen / 2) {
    length2 = strLen / 2;
  }
  for (var i = 0; i < length2; ++i) {
    var parsed = parseInt(string2.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i;
    buf[offset2 + i] = parsed;
  }
  return i;
}
function utf8Write$1(buf, string2, offset2, length2) {
  return blitBuffer$1(utf8ToBytes$1(string2, buf.length - offset2), buf, offset2, length2);
}
function asciiWrite$1(buf, string2, offset2, length2) {
  return blitBuffer$1(asciiToBytes$1(string2), buf, offset2, length2);
}
function latin1Write$1(buf, string2, offset2, length2) {
  return asciiWrite$1(buf, string2, offset2, length2);
}
function base64Write$1(buf, string2, offset2, length2) {
  return blitBuffer$1(base64ToBytes$1(string2), buf, offset2, length2);
}
function ucs2Write$1(buf, string2, offset2, length2) {
  return blitBuffer$1(utf16leToBytes$1(string2, buf.length - offset2), buf, offset2, length2);
}
Buffer$2.prototype.write = function write(string2, offset2, length2, encoding) {
  if (offset2 === void 0) {
    encoding = "utf8";
    length2 = this.length;
    offset2 = 0;
  } else if (length2 === void 0 && typeof offset2 === "string") {
    encoding = offset2;
    length2 = this.length;
    offset2 = 0;
  } else if (isFinite(offset2)) {
    offset2 = offset2 | 0;
    if (isFinite(length2)) {
      length2 = length2 | 0;
      if (encoding === void 0) encoding = "utf8";
    } else {
      encoding = length2;
      length2 = void 0;
    }
  } else {
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  }
  var remaining = this.length - offset2;
  if (length2 === void 0 || length2 > remaining) length2 = remaining;
  if (string2.length > 0 && (length2 < 0 || offset2 < 0) || offset2 > this.length) {
    throw new RangeError("Attempt to write outside buffer bounds");
  }
  if (!encoding) encoding = "utf8";
  var loweredCase = false;
  for (; ; ) {
    switch (encoding) {
      case "hex":
        return hexWrite$1(this, string2, offset2, length2);
      case "utf8":
      case "utf-8":
        return utf8Write$1(this, string2, offset2, length2);
      case "ascii":
        return asciiWrite$1(this, string2, offset2, length2);
      case "latin1":
      case "binary":
        return latin1Write$1(this, string2, offset2, length2);
      case "base64":
        return base64Write$1(this, string2, offset2, length2);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return ucs2Write$1(this, string2, offset2, length2);
      default:
        if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
        encoding = ("" + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};
Buffer$2.prototype.toJSON = function toJSON() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function base64Slice$1(buf, start2, end2) {
  if (start2 === 0 && end2 === buf.length) {
    return fromByteArray$1(buf);
  } else {
    return fromByteArray$1(buf.slice(start2, end2));
  }
}
function utf8Slice$1(buf, start2, end2) {
  end2 = Math.min(buf.length, end2);
  var res = [];
  var i = start2;
  while (i < end2) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
    if (i + bytesPerSequence <= end2) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;
      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 128) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 192) === 128) {
            tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
            if (tempCodePoint > 127) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
            tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
            if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
            tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
            if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
              codePoint = tempCodePoint;
            }
          }
      }
    }
    if (codePoint === null) {
      codePoint = 65533;
      bytesPerSequence = 1;
    } else if (codePoint > 65535) {
      codePoint -= 65536;
      res.push(codePoint >>> 10 & 1023 | 55296);
      codePoint = 56320 | codePoint & 1023;
    }
    res.push(codePoint);
    i += bytesPerSequence;
  }
  return decodeCodePointsArray$1(res);
}
var MAX_ARGUMENTS_LENGTH$1 = 4096;
function decodeCodePointsArray$1(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH$1) {
    return String.fromCharCode.apply(String, codePoints);
  }
  var res = "";
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH$1)
    );
  }
  return res;
}
function asciiSlice$1(buf, start2, end2) {
  var ret = "";
  end2 = Math.min(buf.length, end2);
  for (var i = start2; i < end2; ++i) {
    ret += String.fromCharCode(buf[i] & 127);
  }
  return ret;
}
function latin1Slice$1(buf, start2, end2) {
  var ret = "";
  end2 = Math.min(buf.length, end2);
  for (var i = start2; i < end2; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}
function hexSlice$1(buf, start2, end2) {
  var len = buf.length;
  if (!start2 || start2 < 0) start2 = 0;
  if (!end2 || end2 < 0 || end2 > len) end2 = len;
  var out = "";
  for (var i = start2; i < end2; ++i) {
    out += toHex$1(buf[i]);
  }
  return out;
}
function utf16leSlice$1(buf, start2, end2) {
  var bytes = buf.slice(start2, end2);
  var res = "";
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}
Buffer$2.prototype.slice = function slice(start2, end2) {
  var len = this.length;
  start2 = ~~start2;
  end2 = end2 === void 0 ? len : ~~end2;
  if (start2 < 0) {
    start2 += len;
    if (start2 < 0) start2 = 0;
  } else if (start2 > len) {
    start2 = len;
  }
  if (end2 < 0) {
    end2 += len;
    if (end2 < 0) end2 = 0;
  } else if (end2 > len) {
    end2 = len;
  }
  if (end2 < start2) end2 = start2;
  var newBuf;
  if (Buffer$2.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start2, end2);
    newBuf.__proto__ = Buffer$2.prototype;
  } else {
    var sliceLen = end2 - start2;
    newBuf = new Buffer$2(sliceLen, void 0);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start2];
    }
  }
  return newBuf;
};
function checkOffset$1(offset2, ext, length2) {
  if (offset2 % 1 !== 0 || offset2 < 0) throw new RangeError("offset is not uint");
  if (offset2 + ext > length2) throw new RangeError("Trying to access beyond buffer length");
}
Buffer$2.prototype.readUIntLE = function readUIntLE(offset2, byteLength2, noAssert) {
  offset2 = offset2 | 0;
  byteLength2 = byteLength2 | 0;
  if (!noAssert) checkOffset$1(offset2, byteLength2, this.length);
  var val = this[offset2];
  var mul = 1;
  var i = 0;
  while (++i < byteLength2 && (mul *= 256)) {
    val += this[offset2 + i] * mul;
  }
  return val;
};
Buffer$2.prototype.readUIntBE = function readUIntBE(offset2, byteLength2, noAssert) {
  offset2 = offset2 | 0;
  byteLength2 = byteLength2 | 0;
  if (!noAssert) {
    checkOffset$1(offset2, byteLength2, this.length);
  }
  var val = this[offset2 + --byteLength2];
  var mul = 1;
  while (byteLength2 > 0 && (mul *= 256)) {
    val += this[offset2 + --byteLength2] * mul;
  }
  return val;
};
Buffer$2.prototype.readUInt8 = function readUInt8(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 1, this.length);
  return this[offset2];
};
Buffer$2.prototype.readUInt16LE = function readUInt16LE(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 2, this.length);
  return this[offset2] | this[offset2 + 1] << 8;
};
Buffer$2.prototype.readUInt16BE = function readUInt16BE(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 2, this.length);
  return this[offset2] << 8 | this[offset2 + 1];
};
Buffer$2.prototype.readUInt32LE = function readUInt32LE(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 4, this.length);
  return (this[offset2] | this[offset2 + 1] << 8 | this[offset2 + 2] << 16) + this[offset2 + 3] * 16777216;
};
Buffer$2.prototype.readUInt32BE = function readUInt32BE(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 4, this.length);
  return this[offset2] * 16777216 + (this[offset2 + 1] << 16 | this[offset2 + 2] << 8 | this[offset2 + 3]);
};
Buffer$2.prototype.readIntLE = function readIntLE(offset2, byteLength2, noAssert) {
  offset2 = offset2 | 0;
  byteLength2 = byteLength2 | 0;
  if (!noAssert) checkOffset$1(offset2, byteLength2, this.length);
  var val = this[offset2];
  var mul = 1;
  var i = 0;
  while (++i < byteLength2 && (mul *= 256)) {
    val += this[offset2 + i] * mul;
  }
  mul *= 128;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
  return val;
};
Buffer$2.prototype.readIntBE = function readIntBE(offset2, byteLength2, noAssert) {
  offset2 = offset2 | 0;
  byteLength2 = byteLength2 | 0;
  if (!noAssert) checkOffset$1(offset2, byteLength2, this.length);
  var i = byteLength2;
  var mul = 1;
  var val = this[offset2 + --i];
  while (i > 0 && (mul *= 256)) {
    val += this[offset2 + --i] * mul;
  }
  mul *= 128;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
  return val;
};
Buffer$2.prototype.readInt8 = function readInt8(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 1, this.length);
  if (!(this[offset2] & 128)) return this[offset2];
  return (255 - this[offset2] + 1) * -1;
};
Buffer$2.prototype.readInt16LE = function readInt16LE(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 2, this.length);
  var val = this[offset2] | this[offset2 + 1] << 8;
  return val & 32768 ? val | 4294901760 : val;
};
Buffer$2.prototype.readInt16BE = function readInt16BE(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 2, this.length);
  var val = this[offset2 + 1] | this[offset2] << 8;
  return val & 32768 ? val | 4294901760 : val;
};
Buffer$2.prototype.readInt32LE = function readInt32LE(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 4, this.length);
  return this[offset2] | this[offset2 + 1] << 8 | this[offset2 + 2] << 16 | this[offset2 + 3] << 24;
};
Buffer$2.prototype.readInt32BE = function readInt32BE(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 4, this.length);
  return this[offset2] << 24 | this[offset2 + 1] << 16 | this[offset2 + 2] << 8 | this[offset2 + 3];
};
Buffer$2.prototype.readFloatLE = function readFloatLE(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 4, this.length);
  return read$2(this, offset2, true, 23, 4);
};
Buffer$2.prototype.readFloatBE = function readFloatBE(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 4, this.length);
  return read$2(this, offset2, false, 23, 4);
};
Buffer$2.prototype.readDoubleLE = function readDoubleLE(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 8, this.length);
  return read$2(this, offset2, true, 52, 8);
};
Buffer$2.prototype.readDoubleBE = function readDoubleBE(offset2, noAssert) {
  if (!noAssert) checkOffset$1(offset2, 8, this.length);
  return read$2(this, offset2, false, 52, 8);
};
function checkInt$1(buf, value, offset2, ext, max2, min2) {
  if (!internalIsBuffer$1(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max2 || value < min2) throw new RangeError('"value" argument is out of bounds');
  if (offset2 + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer$2.prototype.writeUIntLE = function writeUIntLE(value, offset2, byteLength2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  byteLength2 = byteLength2 | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength2) - 1;
    checkInt$1(this, value, offset2, byteLength2, maxBytes, 0);
  }
  var mul = 1;
  var i = 0;
  this[offset2] = value & 255;
  while (++i < byteLength2 && (mul *= 256)) {
    this[offset2 + i] = value / mul & 255;
  }
  return offset2 + byteLength2;
};
Buffer$2.prototype.writeUIntBE = function writeUIntBE(value, offset2, byteLength2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  byteLength2 = byteLength2 | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength2) - 1;
    checkInt$1(this, value, offset2, byteLength2, maxBytes, 0);
  }
  var i = byteLength2 - 1;
  var mul = 1;
  this[offset2 + i] = value & 255;
  while (--i >= 0 && (mul *= 256)) {
    this[offset2 + i] = value / mul & 255;
  }
  return offset2 + byteLength2;
};
Buffer$2.prototype.writeUInt8 = function writeUInt8(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt$1(this, value, offset2, 1, 255, 0);
  if (!Buffer$2.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset2] = value & 255;
  return offset2 + 1;
};
function objectWriteUInt16$1(buf, value, offset2, littleEndian) {
  if (value < 0) value = 65535 + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset2, 2); i < j; ++i) {
    buf[offset2 + i] = (value & 255 << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
  }
}
Buffer$2.prototype.writeUInt16LE = function writeUInt16LE(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt$1(this, value, offset2, 2, 65535, 0);
  if (Buffer$2.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value & 255;
    this[offset2 + 1] = value >>> 8;
  } else {
    objectWriteUInt16$1(this, value, offset2, true);
  }
  return offset2 + 2;
};
Buffer$2.prototype.writeUInt16BE = function writeUInt16BE(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt$1(this, value, offset2, 2, 65535, 0);
  if (Buffer$2.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value >>> 8;
    this[offset2 + 1] = value & 255;
  } else {
    objectWriteUInt16$1(this, value, offset2, false);
  }
  return offset2 + 2;
};
function objectWriteUInt32$1(buf, value, offset2, littleEndian) {
  if (value < 0) value = 4294967295 + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset2, 4); i < j; ++i) {
    buf[offset2 + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 255;
  }
}
Buffer$2.prototype.writeUInt32LE = function writeUInt32LE(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt$1(this, value, offset2, 4, 4294967295, 0);
  if (Buffer$2.TYPED_ARRAY_SUPPORT) {
    this[offset2 + 3] = value >>> 24;
    this[offset2 + 2] = value >>> 16;
    this[offset2 + 1] = value >>> 8;
    this[offset2] = value & 255;
  } else {
    objectWriteUInt32$1(this, value, offset2, true);
  }
  return offset2 + 4;
};
Buffer$2.prototype.writeUInt32BE = function writeUInt32BE(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt$1(this, value, offset2, 4, 4294967295, 0);
  if (Buffer$2.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value >>> 24;
    this[offset2 + 1] = value >>> 16;
    this[offset2 + 2] = value >>> 8;
    this[offset2 + 3] = value & 255;
  } else {
    objectWriteUInt32$1(this, value, offset2, false);
  }
  return offset2 + 4;
};
Buffer$2.prototype.writeIntLE = function writeIntLE(value, offset2, byteLength2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength2 - 1);
    checkInt$1(this, value, offset2, byteLength2, limit - 1, -limit);
  }
  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset2] = value & 255;
  while (++i < byteLength2 && (mul *= 256)) {
    if (value < 0 && sub === 0 && this[offset2 + i - 1] !== 0) {
      sub = 1;
    }
    this[offset2 + i] = (value / mul >> 0) - sub & 255;
  }
  return offset2 + byteLength2;
};
Buffer$2.prototype.writeIntBE = function writeIntBE(value, offset2, byteLength2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength2 - 1);
    checkInt$1(this, value, offset2, byteLength2, limit - 1, -limit);
  }
  var i = byteLength2 - 1;
  var mul = 1;
  var sub = 0;
  this[offset2 + i] = value & 255;
  while (--i >= 0 && (mul *= 256)) {
    if (value < 0 && sub === 0 && this[offset2 + i + 1] !== 0) {
      sub = 1;
    }
    this[offset2 + i] = (value / mul >> 0) - sub & 255;
  }
  return offset2 + byteLength2;
};
Buffer$2.prototype.writeInt8 = function writeInt8(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt$1(this, value, offset2, 1, 127, -128);
  if (!Buffer$2.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 255 + value + 1;
  this[offset2] = value & 255;
  return offset2 + 1;
};
Buffer$2.prototype.writeInt16LE = function writeInt16LE(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt$1(this, value, offset2, 2, 32767, -32768);
  if (Buffer$2.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value & 255;
    this[offset2 + 1] = value >>> 8;
  } else {
    objectWriteUInt16$1(this, value, offset2, true);
  }
  return offset2 + 2;
};
Buffer$2.prototype.writeInt16BE = function writeInt16BE(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt$1(this, value, offset2, 2, 32767, -32768);
  if (Buffer$2.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value >>> 8;
    this[offset2 + 1] = value & 255;
  } else {
    objectWriteUInt16$1(this, value, offset2, false);
  }
  return offset2 + 2;
};
Buffer$2.prototype.writeInt32LE = function writeInt32LE(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt$1(this, value, offset2, 4, 2147483647, -2147483648);
  if (Buffer$2.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value & 255;
    this[offset2 + 1] = value >>> 8;
    this[offset2 + 2] = value >>> 16;
    this[offset2 + 3] = value >>> 24;
  } else {
    objectWriteUInt32$1(this, value, offset2, true);
  }
  return offset2 + 4;
};
Buffer$2.prototype.writeInt32BE = function writeInt32BE(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt$1(this, value, offset2, 4, 2147483647, -2147483648);
  if (value < 0) value = 4294967295 + value + 1;
  if (Buffer$2.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value >>> 24;
    this[offset2 + 1] = value >>> 16;
    this[offset2 + 2] = value >>> 8;
    this[offset2 + 3] = value & 255;
  } else {
    objectWriteUInt32$1(this, value, offset2, false);
  }
  return offset2 + 4;
};
function checkIEEE754$1(buf, value, offset2, ext, max2, min2) {
  if (offset2 + ext > buf.length) throw new RangeError("Index out of range");
  if (offset2 < 0) throw new RangeError("Index out of range");
}
function writeFloat$1(buf, value, offset2, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754$1(buf, value, offset2, 4);
  }
  write$2(buf, value, offset2, littleEndian, 23, 4);
  return offset2 + 4;
}
Buffer$2.prototype.writeFloatLE = function writeFloatLE(value, offset2, noAssert) {
  return writeFloat$1(this, value, offset2, true, noAssert);
};
Buffer$2.prototype.writeFloatBE = function writeFloatBE(value, offset2, noAssert) {
  return writeFloat$1(this, value, offset2, false, noAssert);
};
function writeDouble$1(buf, value, offset2, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754$1(buf, value, offset2, 8);
  }
  write$2(buf, value, offset2, littleEndian, 52, 8);
  return offset2 + 8;
}
Buffer$2.prototype.writeDoubleLE = function writeDoubleLE(value, offset2, noAssert) {
  return writeDouble$1(this, value, offset2, true, noAssert);
};
Buffer$2.prototype.writeDoubleBE = function writeDoubleBE(value, offset2, noAssert) {
  return writeDouble$1(this, value, offset2, false, noAssert);
};
Buffer$2.prototype.copy = function copy(target, targetStart, start2, end2) {
  if (!start2) start2 = 0;
  if (!end2 && end2 !== 0) end2 = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end2 > 0 && end2 < start2) end2 = start2;
  if (end2 === start2) return 0;
  if (target.length === 0 || this.length === 0) return 0;
  if (targetStart < 0) {
    throw new RangeError("targetStart out of bounds");
  }
  if (start2 < 0 || start2 >= this.length) throw new RangeError("sourceStart out of bounds");
  if (end2 < 0) throw new RangeError("sourceEnd out of bounds");
  if (end2 > this.length) end2 = this.length;
  if (target.length - targetStart < end2 - start2) {
    end2 = target.length - targetStart + start2;
  }
  var len = end2 - start2;
  var i;
  if (this === target && start2 < targetStart && targetStart < end2) {
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start2];
    }
  } else if (len < 1e3 || !Buffer$2.TYPED_ARRAY_SUPPORT) {
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start2];
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start2, start2 + len),
      targetStart
    );
  }
  return len;
};
Buffer$2.prototype.fill = function fill(val, start2, end2, encoding) {
  if (typeof val === "string") {
    if (typeof start2 === "string") {
      encoding = start2;
      start2 = 0;
      end2 = this.length;
    } else if (typeof end2 === "string") {
      encoding = end2;
      end2 = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== void 0 && typeof encoding !== "string") {
      throw new TypeError("encoding must be a string");
    }
    if (typeof encoding === "string" && !Buffer$2.isEncoding(encoding)) {
      throw new TypeError("Unknown encoding: " + encoding);
    }
  } else if (typeof val === "number") {
    val = val & 255;
  }
  if (start2 < 0 || this.length < start2 || this.length < end2) {
    throw new RangeError("Out of range index");
  }
  if (end2 <= start2) {
    return this;
  }
  start2 = start2 >>> 0;
  end2 = end2 === void 0 ? this.length : end2 >>> 0;
  if (!val) val = 0;
  var i;
  if (typeof val === "number") {
    for (i = start2; i < end2; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = internalIsBuffer$1(val) ? val : utf8ToBytes$1(new Buffer$2(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end2 - start2; ++i) {
      this[i + start2] = bytes[i % len];
    }
  }
  return this;
};
var INVALID_BASE64_RE$1 = /[^+\/0-9A-Za-z-_]/g;
function base64clean$1(str) {
  str = stringtrim$1(str).replace(INVALID_BASE64_RE$1, "");
  if (str.length < 2) return "";
  while (str.length % 4 !== 0) {
    str = str + "=";
  }
  return str;
}
function stringtrim$1(str) {
  if (str.trim) return str.trim();
  return str.replace(/^\s+|\s+$/g, "");
}
function toHex$1(n12) {
  if (n12 < 16) return "0" + n12.toString(16);
  return n12.toString(16);
}
function utf8ToBytes$1(string2, units) {
  units = units || Infinity;
  var codePoint;
  var length2 = string2.length;
  var leadSurrogate = null;
  var bytes = [];
  for (var i = 0; i < length2; ++i) {
    codePoint = string2.charCodeAt(i);
    if (codePoint > 55295 && codePoint < 57344) {
      if (!leadSurrogate) {
        if (codePoint > 56319) {
          if ((units -= 3) > -1) bytes.push(239, 191, 189);
          continue;
        } else if (i + 1 === length2) {
          if ((units -= 3) > -1) bytes.push(239, 191, 189);
          continue;
        }
        leadSurrogate = codePoint;
        continue;
      }
      if (codePoint < 56320) {
        if ((units -= 3) > -1) bytes.push(239, 191, 189);
        leadSurrogate = codePoint;
        continue;
      }
      codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
    } else if (leadSurrogate) {
      if ((units -= 3) > -1) bytes.push(239, 191, 189);
    }
    leadSurrogate = null;
    if (codePoint < 128) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 2048) {
      if ((units -= 2) < 0) break;
      bytes.push(
        codePoint >> 6 | 192,
        codePoint & 63 | 128
      );
    } else if (codePoint < 65536) {
      if ((units -= 3) < 0) break;
      bytes.push(
        codePoint >> 12 | 224,
        codePoint >> 6 & 63 | 128,
        codePoint & 63 | 128
      );
    } else if (codePoint < 1114112) {
      if ((units -= 4) < 0) break;
      bytes.push(
        codePoint >> 18 | 240,
        codePoint >> 12 & 63 | 128,
        codePoint >> 6 & 63 | 128,
        codePoint & 63 | 128
      );
    } else {
      throw new Error("Invalid code point");
    }
  }
  return bytes;
}
function asciiToBytes$1(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    byteArray.push(str.charCodeAt(i) & 255);
  }
  return byteArray;
}
function utf16leToBytes$1(str, units) {
  var c, hi, lo2;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;
    c = str.charCodeAt(i);
    hi = c >> 8;
    lo2 = c % 256;
    byteArray.push(lo2);
    byteArray.push(hi);
  }
  return byteArray;
}
function base64ToBytes$1(str) {
  return toByteArray$1(base64clean$1(str));
}
function blitBuffer$1(src, dst, offset2, length2) {
  for (var i = 0; i < length2; ++i) {
    if (i + offset2 >= dst.length || i >= src.length) break;
    dst[i + offset2] = src[i];
  }
  return i;
}
function isnan$1(val) {
  return val !== val;
}
function isBuffer$1(obj) {
  return obj != null && (!!obj._isBuffer || isFastBuffer$1(obj) || isSlowBuffer$1(obj));
}
function isFastBuffer$1(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
function isSlowBuffer$1(obj) {
  return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isFastBuffer$1(obj.slice(0, 0));
}
let CsvError$1 = class CsvError extends Error {
  constructor(code, message, options, ...contexts) {
    if (Array.isArray(message)) message = message.join(" ").trim();
    super(message);
    if (Error.captureStackTrace !== void 0) {
      Error.captureStackTrace(this, CsvError);
    }
    this.code = code;
    for (const context2 of contexts) {
      for (const key in context2) {
        const value = context2[key];
        this[key] = isBuffer$1(value) ? value.toString(options.encoding) : value == null ? value : JSON.parse(JSON.stringify(value));
      }
    }
  }
};
const is_object$1 = function(obj) {
  return typeof obj === "object" && obj !== null && !Array.isArray(obj);
};
const normalize_columns_array = function(columns) {
  const normalizedColumns = [];
  for (let i = 0, l2 = columns.length; i < l2; i++) {
    const column2 = columns[i];
    if (column2 === void 0 || column2 === null || column2 === false) {
      normalizedColumns[i] = { disabled: true };
    } else if (typeof column2 === "string" || typeof column2 === "number") {
      normalizedColumns[i] = { name: `${column2}` };
    } else if (is_object$1(column2)) {
      if (typeof column2.name !== "string") {
        throw new CsvError$1("CSV_OPTION_COLUMNS_MISSING_NAME", [
          "Option columns missing name:",
          `property "name" is required at position ${i}`,
          "when column is an object literal"
        ]);
      }
      normalizedColumns[i] = column2;
    } else {
      throw new CsvError$1("CSV_INVALID_COLUMN_DEFINITION", [
        "Invalid column definition:",
        "expect a string or a literal object,",
        `got ${JSON.stringify(column2)} at position ${i}`
      ]);
    }
  }
  return normalizedColumns;
};
class ResizeableBuffer {
  constructor(size = 100) {
    this.size = size;
    this.length = 0;
    this.buf = Buffer$2.allocUnsafe(size);
  }
  prepend(val) {
    if (isBuffer$1(val)) {
      const length2 = this.length + val.length;
      if (length2 >= this.size) {
        this.resize();
        if (length2 >= this.size) {
          throw Error("INVALID_BUFFER_STATE");
        }
      }
      const buf = this.buf;
      this.buf = Buffer$2.allocUnsafe(this.size);
      val.copy(this.buf, 0);
      buf.copy(this.buf, val.length);
      this.length += val.length;
    } else {
      const length2 = this.length++;
      if (length2 === this.size) {
        this.resize();
      }
      const buf = this.clone();
      this.buf[0] = val;
      buf.copy(this.buf, 1, 0, length2);
    }
  }
  append(val) {
    const length2 = this.length++;
    if (length2 === this.size) {
      this.resize();
    }
    this.buf[length2] = val;
  }
  clone() {
    return Buffer$2.from(this.buf.slice(0, this.length));
  }
  resize() {
    const length2 = this.length;
    this.size = this.size * 2;
    const buf = Buffer$2.allocUnsafe(this.size);
    this.buf.copy(buf, 0, 0, length2);
    this.buf = buf;
  }
  toString(encoding) {
    if (encoding) {
      return this.buf.slice(0, this.length).toString(encoding);
    } else {
      return Uint8Array.prototype.slice.call(this.buf.slice(0, this.length));
    }
  }
  toJSON() {
    return this.toString("utf8");
  }
  reset() {
    this.length = 0;
  }
}
const np = 12;
const cr$1 = 13;
const nl$1 = 10;
const space = 32;
const tab = 9;
const init_state = function(options) {
  return {
    bomSkipped: false,
    bufBytesStart: 0,
    castField: options.cast_function,
    commenting: false,
    // Current error encountered by a record
    error: void 0,
    enabled: options.from_line === 1,
    escaping: false,
    escapeIsQuote: isBuffer$1(options.escape) && isBuffer$1(options.quote) && Buffer$2.compare(options.escape, options.quote) === 0,
    // columns can be `false`, `true`, `Array`
    expectedRecordLength: Array.isArray(options.columns) ? options.columns.length : void 0,
    field: new ResizeableBuffer(20),
    firstLineToHeaders: options.cast_first_line_to_header,
    needMoreDataSize: Math.max(
      // Skip if the remaining buffer smaller than comment
      options.comment !== null ? options.comment.length : 0,
      ...options.delimiter.map((delimiter2) => delimiter2.length),
      // Skip if the remaining buffer can be escape sequence
      options.quote !== null ? options.quote.length : 0
    ),
    previousBuf: void 0,
    quoting: false,
    stop: false,
    rawBuffer: new ResizeableBuffer(100),
    record: [],
    recordHasError: false,
    record_length: 0,
    recordDelimiterMaxLength: options.record_delimiter.length === 0 ? 0 : Math.max(...options.record_delimiter.map((v) => v.length)),
    trimChars: [
      Buffer$2.from(" ", options.encoding)[0],
      Buffer$2.from("	", options.encoding)[0]
    ],
    wasQuoting: false,
    wasRowDelimiter: false,
    timchars: [
      Buffer$2.from(Buffer$2.from([cr$1], "utf8").toString(), options.encoding),
      Buffer$2.from(Buffer$2.from([nl$1], "utf8").toString(), options.encoding),
      Buffer$2.from(Buffer$2.from([np], "utf8").toString(), options.encoding),
      Buffer$2.from(Buffer$2.from([space], "utf8").toString(), options.encoding),
      Buffer$2.from(Buffer$2.from([tab], "utf8").toString(), options.encoding)
    ]
  };
};
const underscore$1 = function(str) {
  return str.replace(/([A-Z])/g, function(_, match2) {
    return "_" + match2.toLowerCase();
  });
};
const normalize_options$1 = function(opts) {
  const options = {};
  for (const opt in opts) {
    options[underscore$1(opt)] = opts[opt];
  }
  if (options.encoding === void 0 || options.encoding === true) {
    options.encoding = "utf8";
  } else if (options.encoding === null || options.encoding === false) {
    options.encoding = null;
  } else if (typeof options.encoding !== "string" && options.encoding !== null) {
    throw new CsvError$1(
      "CSV_INVALID_OPTION_ENCODING",
      [
        "Invalid option encoding:",
        "encoding must be a string or null to return a buffer,",
        `got ${JSON.stringify(options.encoding)}`
      ],
      options
    );
  }
  if (options.bom === void 0 || options.bom === null || options.bom === false) {
    options.bom = false;
  } else if (options.bom !== true) {
    throw new CsvError$1(
      "CSV_INVALID_OPTION_BOM",
      [
        "Invalid option bom:",
        "bom must be true,",
        `got ${JSON.stringify(options.bom)}`
      ],
      options
    );
  }
  options.cast_function = null;
  if (options.cast === void 0 || options.cast === null || options.cast === false || options.cast === "") {
    options.cast = void 0;
  } else if (typeof options.cast === "function") {
    options.cast_function = options.cast;
    options.cast = true;
  } else if (options.cast !== true) {
    throw new CsvError$1(
      "CSV_INVALID_OPTION_CAST",
      [
        "Invalid option cast:",
        "cast must be true or a function,",
        `got ${JSON.stringify(options.cast)}`
      ],
      options
    );
  }
  if (options.cast_date === void 0 || options.cast_date === null || options.cast_date === false || options.cast_date === "") {
    options.cast_date = false;
  } else if (options.cast_date === true) {
    options.cast_date = function(value) {
      const date = Date.parse(value);
      return !isNaN(date) ? new Date(date) : value;
    };
  } else if (typeof options.cast_date !== "function") {
    throw new CsvError$1(
      "CSV_INVALID_OPTION_CAST_DATE",
      [
        "Invalid option cast_date:",
        "cast_date must be true or a function,",
        `got ${JSON.stringify(options.cast_date)}`
      ],
      options
    );
  }
  options.cast_first_line_to_header = void 0;
  if (options.columns === true) {
    options.cast_first_line_to_header = void 0;
  } else if (typeof options.columns === "function") {
    options.cast_first_line_to_header = options.columns;
    options.columns = true;
  } else if (Array.isArray(options.columns)) {
    options.columns = normalize_columns_array(options.columns);
  } else if (options.columns === void 0 || options.columns === null || options.columns === false) {
    options.columns = false;
  } else {
    throw new CsvError$1(
      "CSV_INVALID_OPTION_COLUMNS",
      [
        "Invalid option columns:",
        "expect an array, a function or true,",
        `got ${JSON.stringify(options.columns)}`
      ],
      options
    );
  }
  if (options.group_columns_by_name === void 0 || options.group_columns_by_name === null || options.group_columns_by_name === false) {
    options.group_columns_by_name = false;
  } else if (options.group_columns_by_name !== true) {
    throw new CsvError$1(
      "CSV_INVALID_OPTION_GROUP_COLUMNS_BY_NAME",
      [
        "Invalid option group_columns_by_name:",
        "expect an boolean,",
        `got ${JSON.stringify(options.group_columns_by_name)}`
      ],
      options
    );
  } else if (options.columns === false) {
    throw new CsvError$1(
      "CSV_INVALID_OPTION_GROUP_COLUMNS_BY_NAME",
      [
        "Invalid option group_columns_by_name:",
        "the `columns` mode must be activated."
      ],
      options
    );
  }
  if (options.comment === void 0 || options.comment === null || options.comment === false || options.comment === "") {
    options.comment = null;
  } else {
    if (typeof options.comment === "string") {
      options.comment = Buffer$2.from(options.comment, options.encoding);
    }
    if (!isBuffer$1(options.comment)) {
      throw new CsvError$1(
        "CSV_INVALID_OPTION_COMMENT",
        [
          "Invalid option comment:",
          "comment must be a buffer or a string,",
          `got ${JSON.stringify(options.comment)}`
        ],
        options
      );
    }
  }
  if (options.comment_no_infix === void 0 || options.comment_no_infix === null || options.comment_no_infix === false) {
    options.comment_no_infix = false;
  } else if (options.comment_no_infix !== true) {
    throw new CsvError$1(
      "CSV_INVALID_OPTION_COMMENT",
      [
        "Invalid option comment_no_infix:",
        "value must be a boolean,",
        `got ${JSON.stringify(options.comment_no_infix)}`
      ],
      options
    );
  }
  const delimiter_json = JSON.stringify(options.delimiter);
  if (!Array.isArray(options.delimiter))
    options.delimiter = [options.delimiter];
  if (options.delimiter.length === 0) {
    throw new CsvError$1(
      "CSV_INVALID_OPTION_DELIMITER",
      [
        "Invalid option delimiter:",
        "delimiter must be a non empty string or buffer or array of string|buffer,",
        `got ${delimiter_json}`
      ],
      options
    );
  }
  options.delimiter = options.delimiter.map(function(delimiter2) {
    if (delimiter2 === void 0 || delimiter2 === null || delimiter2 === false) {
      return Buffer$2.from(",", options.encoding);
    }
    if (typeof delimiter2 === "string") {
      delimiter2 = Buffer$2.from(delimiter2, options.encoding);
    }
    if (!isBuffer$1(delimiter2) || delimiter2.length === 0) {
      throw new CsvError$1(
        "CSV_INVALID_OPTION_DELIMITER",
        [
          "Invalid option delimiter:",
          "delimiter must be a non empty string or buffer or array of string|buffer,",
          `got ${delimiter_json}`
        ],
        options
      );
    }
    return delimiter2;
  });
  if (options.escape === void 0 || options.escape === true) {
    options.escape = Buffer$2.from('"', options.encoding);
  } else if (typeof options.escape === "string") {
    options.escape = Buffer$2.from(options.escape, options.encoding);
  } else if (options.escape === null || options.escape === false) {
    options.escape = null;
  }
  if (options.escape !== null) {
    if (!isBuffer$1(options.escape)) {
      throw new Error(
        `Invalid Option: escape must be a buffer, a string or a boolean, got ${JSON.stringify(options.escape)}`
      );
    }
  }
  if (options.from === void 0 || options.from === null) {
    options.from = 1;
  } else {
    if (typeof options.from === "string" && /\d+/.test(options.from)) {
      options.from = parseInt(options.from);
    }
    if (Number.isInteger(options.from)) {
      if (options.from < 0) {
        throw new Error(
          `Invalid Option: from must be a positive integer, got ${JSON.stringify(opts.from)}`
        );
      }
    } else {
      throw new Error(
        `Invalid Option: from must be an integer, got ${JSON.stringify(options.from)}`
      );
    }
  }
  if (options.from_line === void 0 || options.from_line === null) {
    options.from_line = 1;
  } else {
    if (typeof options.from_line === "string" && /\d+/.test(options.from_line)) {
      options.from_line = parseInt(options.from_line);
    }
    if (Number.isInteger(options.from_line)) {
      if (options.from_line <= 0) {
        throw new Error(
          `Invalid Option: from_line must be a positive integer greater than 0, got ${JSON.stringify(opts.from_line)}`
        );
      }
    } else {
      throw new Error(
        `Invalid Option: from_line must be an integer, got ${JSON.stringify(opts.from_line)}`
      );
    }
  }
  if (options.ignore_last_delimiters === void 0 || options.ignore_last_delimiters === null) {
    options.ignore_last_delimiters = false;
  } else if (typeof options.ignore_last_delimiters === "number") {
    options.ignore_last_delimiters = Math.floor(options.ignore_last_delimiters);
    if (options.ignore_last_delimiters === 0) {
      options.ignore_last_delimiters = false;
    }
  } else if (typeof options.ignore_last_delimiters !== "boolean") {
    throw new CsvError$1(
      "CSV_INVALID_OPTION_IGNORE_LAST_DELIMITERS",
      [
        "Invalid option `ignore_last_delimiters`:",
        "the value must be a boolean value or an integer,",
        `got ${JSON.stringify(options.ignore_last_delimiters)}`
      ],
      options
    );
  }
  if (options.ignore_last_delimiters === true && options.columns === false) {
    throw new CsvError$1(
      "CSV_IGNORE_LAST_DELIMITERS_REQUIRES_COLUMNS",
      [
        "The option `ignore_last_delimiters`",
        "requires the activation of the `columns` option"
      ],
      options
    );
  }
  if (options.info === void 0 || options.info === null || options.info === false) {
    options.info = false;
  } else if (options.info !== true) {
    throw new Error(
      `Invalid Option: info must be true, got ${JSON.stringify(options.info)}`
    );
  }
  if (options.max_record_size === void 0 || options.max_record_size === null || options.max_record_size === false) {
    options.max_record_size = 0;
  } else if (Number.isInteger(options.max_record_size) && options.max_record_size >= 0) ;
  else if (typeof options.max_record_size === "string" && /\d+/.test(options.max_record_size)) {
    options.max_record_size = parseInt(options.max_record_size);
  } else {
    throw new Error(
      `Invalid Option: max_record_size must be a positive integer, got ${JSON.stringify(options.max_record_size)}`
    );
  }
  if (options.objname === void 0 || options.objname === null || options.objname === false) {
    options.objname = void 0;
  } else if (isBuffer$1(options.objname)) {
    if (options.objname.length === 0) {
      throw new Error(`Invalid Option: objname must be a non empty buffer`);
    }
    if (options.encoding === null) ;
    else {
      options.objname = options.objname.toString(options.encoding);
    }
  } else if (typeof options.objname === "string") {
    if (options.objname.length === 0) {
      throw new Error(`Invalid Option: objname must be a non empty string`);
    }
  } else if (typeof options.objname === "number") ;
  else {
    throw new Error(
      `Invalid Option: objname must be a string or a buffer, got ${options.objname}`
    );
  }
  if (options.objname !== void 0) {
    if (typeof options.objname === "number") {
      if (options.columns !== false) {
        throw Error(
          "Invalid Option: objname index cannot be combined with columns or be defined as a field"
        );
      }
    } else {
      if (options.columns === false) {
        throw Error(
          "Invalid Option: objname field must be combined with columns or be defined as an index"
        );
      }
    }
  }
  if (options.on_record === void 0 || options.on_record === null) {
    options.on_record = void 0;
  } else if (typeof options.on_record !== "function") {
    throw new CsvError$1(
      "CSV_INVALID_OPTION_ON_RECORD",
      [
        "Invalid option `on_record`:",
        "expect a function,",
        `got ${JSON.stringify(options.on_record)}`
      ],
      options
    );
  }
  if (options.on_skip !== void 0 && options.on_skip !== null && typeof options.on_skip !== "function") {
    throw new Error(
      `Invalid Option: on_skip must be a function, got ${JSON.stringify(options.on_skip)}`
    );
  }
  if (options.quote === null || options.quote === false || options.quote === "") {
    options.quote = null;
  } else {
    if (options.quote === void 0 || options.quote === true) {
      options.quote = Buffer$2.from('"', options.encoding);
    } else if (typeof options.quote === "string") {
      options.quote = Buffer$2.from(options.quote, options.encoding);
    }
    if (!isBuffer$1(options.quote)) {
      throw new Error(
        `Invalid Option: quote must be a buffer or a string, got ${JSON.stringify(options.quote)}`
      );
    }
  }
  if (options.raw === void 0 || options.raw === null || options.raw === false) {
    options.raw = false;
  } else if (options.raw !== true) {
    throw new Error(
      `Invalid Option: raw must be true, got ${JSON.stringify(options.raw)}`
    );
  }
  if (options.record_delimiter === void 0) {
    options.record_delimiter = [];
  } else if (typeof options.record_delimiter === "string" || isBuffer$1(options.record_delimiter)) {
    if (options.record_delimiter.length === 0) {
      throw new CsvError$1(
        "CSV_INVALID_OPTION_RECORD_DELIMITER",
        [
          "Invalid option `record_delimiter`:",
          "value must be a non empty string or buffer,",
          `got ${JSON.stringify(options.record_delimiter)}`
        ],
        options
      );
    }
    options.record_delimiter = [options.record_delimiter];
  } else if (!Array.isArray(options.record_delimiter)) {
    throw new CsvError$1(
      "CSV_INVALID_OPTION_RECORD_DELIMITER",
      [
        "Invalid option `record_delimiter`:",
        "value must be a string, a buffer or array of string|buffer,",
        `got ${JSON.stringify(options.record_delimiter)}`
      ],
      options
    );
  }
  options.record_delimiter = options.record_delimiter.map(function(rd, i) {
    if (typeof rd !== "string" && !isBuffer$1(rd)) {
      throw new CsvError$1(
        "CSV_INVALID_OPTION_RECORD_DELIMITER",
        [
          "Invalid option `record_delimiter`:",
          "value must be a string, a buffer or array of string|buffer",
          `at index ${i},`,
          `got ${JSON.stringify(rd)}`
        ],
        options
      );
    } else if (rd.length === 0) {
      throw new CsvError$1(
        "CSV_INVALID_OPTION_RECORD_DELIMITER",
        [
          "Invalid option `record_delimiter`:",
          "value must be a non empty string or buffer",
          `at index ${i},`,
          `got ${JSON.stringify(rd)}`
        ],
        options
      );
    }
    if (typeof rd === "string") {
      rd = Buffer$2.from(rd, options.encoding);
    }
    return rd;
  });
  if (typeof options.relax_column_count === "boolean") ;
  else if (options.relax_column_count === void 0 || options.relax_column_count === null) {
    options.relax_column_count = false;
  } else {
    throw new Error(
      `Invalid Option: relax_column_count must be a boolean, got ${JSON.stringify(options.relax_column_count)}`
    );
  }
  if (typeof options.relax_column_count_less === "boolean") ;
  else if (options.relax_column_count_less === void 0 || options.relax_column_count_less === null) {
    options.relax_column_count_less = false;
  } else {
    throw new Error(
      `Invalid Option: relax_column_count_less must be a boolean, got ${JSON.stringify(options.relax_column_count_less)}`
    );
  }
  if (typeof options.relax_column_count_more === "boolean") ;
  else if (options.relax_column_count_more === void 0 || options.relax_column_count_more === null) {
    options.relax_column_count_more = false;
  } else {
    throw new Error(
      `Invalid Option: relax_column_count_more must be a boolean, got ${JSON.stringify(options.relax_column_count_more)}`
    );
  }
  if (typeof options.relax_quotes === "boolean") ;
  else if (options.relax_quotes === void 0 || options.relax_quotes === null) {
    options.relax_quotes = false;
  } else {
    throw new Error(
      `Invalid Option: relax_quotes must be a boolean, got ${JSON.stringify(options.relax_quotes)}`
    );
  }
  if (typeof options.skip_empty_lines === "boolean") ;
  else if (options.skip_empty_lines === void 0 || options.skip_empty_lines === null) {
    options.skip_empty_lines = false;
  } else {
    throw new Error(
      `Invalid Option: skip_empty_lines must be a boolean, got ${JSON.stringify(options.skip_empty_lines)}`
    );
  }
  if (typeof options.skip_records_with_empty_values === "boolean") ;
  else if (options.skip_records_with_empty_values === void 0 || options.skip_records_with_empty_values === null) {
    options.skip_records_with_empty_values = false;
  } else {
    throw new Error(
      `Invalid Option: skip_records_with_empty_values must be a boolean, got ${JSON.stringify(options.skip_records_with_empty_values)}`
    );
  }
  if (typeof options.skip_records_with_error === "boolean") ;
  else if (options.skip_records_with_error === void 0 || options.skip_records_with_error === null) {
    options.skip_records_with_error = false;
  } else {
    throw new Error(
      `Invalid Option: skip_records_with_error must be a boolean, got ${JSON.stringify(options.skip_records_with_error)}`
    );
  }
  if (options.rtrim === void 0 || options.rtrim === null || options.rtrim === false) {
    options.rtrim = false;
  } else if (options.rtrim !== true) {
    throw new Error(
      `Invalid Option: rtrim must be a boolean, got ${JSON.stringify(options.rtrim)}`
    );
  }
  if (options.ltrim === void 0 || options.ltrim === null || options.ltrim === false) {
    options.ltrim = false;
  } else if (options.ltrim !== true) {
    throw new Error(
      `Invalid Option: ltrim must be a boolean, got ${JSON.stringify(options.ltrim)}`
    );
  }
  if (options.trim === void 0 || options.trim === null || options.trim === false) {
    options.trim = false;
  } else if (options.trim !== true) {
    throw new Error(
      `Invalid Option: trim must be a boolean, got ${JSON.stringify(options.trim)}`
    );
  }
  if (options.trim === true && opts.ltrim !== false) {
    options.ltrim = true;
  } else if (options.ltrim !== true) {
    options.ltrim = false;
  }
  if (options.trim === true && opts.rtrim !== false) {
    options.rtrim = true;
  } else if (options.rtrim !== true) {
    options.rtrim = false;
  }
  if (options.to === void 0 || options.to === null) {
    options.to = -1;
  } else if (options.to !== -1) {
    if (typeof options.to === "string" && /\d+/.test(options.to)) {
      options.to = parseInt(options.to);
    }
    if (Number.isInteger(options.to)) {
      if (options.to <= 0) {
        throw new Error(
          `Invalid Option: to must be a positive integer greater than 0, got ${JSON.stringify(opts.to)}`
        );
      }
    } else {
      throw new Error(
        `Invalid Option: to must be an integer, got ${JSON.stringify(opts.to)}`
      );
    }
  }
  if (options.to_line === void 0 || options.to_line === null) {
    options.to_line = -1;
  } else if (options.to_line !== -1) {
    if (typeof options.to_line === "string" && /\d+/.test(options.to_line)) {
      options.to_line = parseInt(options.to_line);
    }
    if (Number.isInteger(options.to_line)) {
      if (options.to_line <= 0) {
        throw new Error(
          `Invalid Option: to_line must be a positive integer greater than 0, got ${JSON.stringify(opts.to_line)}`
        );
      }
    } else {
      throw new Error(
        `Invalid Option: to_line must be an integer, got ${JSON.stringify(opts.to_line)}`
      );
    }
  }
  return options;
};
const isRecordEmpty = function(record) {
  return record.every(
    (field) => field == null || field.toString && field.toString().trim() === ""
  );
};
const cr$2 = 13;
const nl$2 = 10;
const boms = {
  // Note, the following are equals:
  // Buffer.from("\ufeff")
  // Buffer.from([239, 187, 191])
  // Buffer.from('EFBBBF', 'hex')
  utf8: Buffer$2.from([239, 187, 191]),
  // Note, the following are equals:
  // Buffer.from "\ufeff", 'utf16le
  // Buffer.from([255, 254])
  utf16le: Buffer$2.from([255, 254])
};
const transform = function(original_options = {}) {
  const info = {
    bytes: 0,
    bytes_records: 0,
    comment_lines: 0,
    empty_lines: 0,
    invalid_field_length: 0,
    lines: 1,
    records: 0
  };
  const options = normalize_options$1(original_options);
  return {
    info,
    original_options,
    options,
    state: init_state(options),
    __needMoreData: function(i, bufLen, end2) {
      if (end2) return false;
      const { encoding, escape: escape2, quote } = this.options;
      const { quoting, needMoreDataSize, recordDelimiterMaxLength } = this.state;
      const numOfCharLeft = bufLen - i - 1;
      const requiredLength = Math.max(
        needMoreDataSize,
        // Skip if the remaining buffer smaller than record delimiter
        // If "record_delimiter" is yet to be discovered:
        // 1. It is equals to `[]` and "recordDelimiterMaxLength" equals `0`
        // 2. We set the length to windows line ending in the current encoding
        // Note, that encoding is known from user or bom discovery at that point
        // recordDelimiterMaxLength,
        recordDelimiterMaxLength === 0 ? Buffer$2.from("\r\n", encoding).length : recordDelimiterMaxLength,
        // Skip if remaining buffer can be an escaped quote
        quoting ? (escape2 === null ? 0 : escape2.length) + quote.length : 0,
        // Skip if remaining buffer can be record delimiter following the closing quote
        quoting ? quote.length + recordDelimiterMaxLength : 0
      );
      return numOfCharLeft < requiredLength;
    },
    // Central parser implementation
    parse: function(nextBuf, end2, push, close) {
      const {
        bom,
        comment_no_infix,
        encoding,
        from_line,
        ltrim,
        max_record_size,
        raw,
        relax_quotes,
        rtrim,
        skip_empty_lines,
        to: to2,
        to_line
      } = this.options;
      let { comment: comment2, escape: escape2, quote, record_delimiter } = this.options;
      const { bomSkipped, previousBuf, rawBuffer, escapeIsQuote } = this.state;
      let buf;
      if (previousBuf === void 0) {
        if (nextBuf === void 0) {
          close();
          return;
        } else {
          buf = nextBuf;
        }
      } else if (previousBuf !== void 0 && nextBuf === void 0) {
        buf = previousBuf;
      } else {
        buf = Buffer$2.concat([previousBuf, nextBuf]);
      }
      if (bomSkipped === false) {
        if (bom === false) {
          this.state.bomSkipped = true;
        } else if (buf.length < 3) {
          if (end2 === false) {
            this.state.previousBuf = buf;
            return;
          }
        } else {
          for (const encoding2 in boms) {
            if (boms[encoding2].compare(buf, 0, boms[encoding2].length) === 0) {
              const bomLength = boms[encoding2].length;
              this.state.bufBytesStart += bomLength;
              buf = buf.slice(bomLength);
              const options2 = normalize_options$1({
                ...this.original_options,
                encoding: encoding2
              });
              for (const key in options2) {
                this.options[key] = options2[key];
              }
              ({ comment: comment2, escape: escape2, quote } = this.options);
              break;
            }
          }
          this.state.bomSkipped = true;
        }
      }
      const bufLen = buf.length;
      let pos;
      for (pos = 0; pos < bufLen; pos++) {
        if (this.__needMoreData(pos, bufLen, end2)) {
          break;
        }
        if (this.state.wasRowDelimiter === true) {
          this.info.lines++;
          this.state.wasRowDelimiter = false;
        }
        if (to_line !== -1 && this.info.lines > to_line) {
          this.state.stop = true;
          close();
          return;
        }
        if (this.state.quoting === false && record_delimiter.length === 0) {
          const record_delimiterCount = this.__autoDiscoverRecordDelimiter(
            buf,
            pos
          );
          if (record_delimiterCount) {
            record_delimiter = this.options.record_delimiter;
          }
        }
        const chr = buf[pos];
        if (raw === true) {
          rawBuffer.append(chr);
        }
        if ((chr === cr$2 || chr === nl$2) && this.state.wasRowDelimiter === false) {
          this.state.wasRowDelimiter = true;
        }
        if (this.state.escaping === true) {
          this.state.escaping = false;
        } else {
          if (escape2 !== null && this.state.quoting === true && this.__isEscape(buf, pos, chr) && pos + escape2.length < bufLen) {
            if (escapeIsQuote) {
              if (this.__isQuote(buf, pos + escape2.length)) {
                this.state.escaping = true;
                pos += escape2.length - 1;
                continue;
              }
            } else {
              this.state.escaping = true;
              pos += escape2.length - 1;
              continue;
            }
          }
          if (this.state.commenting === false && this.__isQuote(buf, pos)) {
            if (this.state.quoting === true) {
              const nextChr = buf[pos + quote.length];
              const isNextChrTrimable = rtrim && this.__isCharTrimable(buf, pos + quote.length);
              const isNextChrComment = comment2 !== null && this.__compareBytes(comment2, buf, pos + quote.length, nextChr);
              const isNextChrDelimiter = this.__isDelimiter(
                buf,
                pos + quote.length,
                nextChr
              );
              const isNextChrRecordDelimiter = record_delimiter.length === 0 ? this.__autoDiscoverRecordDelimiter(buf, pos + quote.length) : this.__isRecordDelimiter(nextChr, buf, pos + quote.length);
              if (escape2 !== null && this.__isEscape(buf, pos, chr) && this.__isQuote(buf, pos + escape2.length)) {
                pos += escape2.length - 1;
              } else if (!nextChr || isNextChrDelimiter || isNextChrRecordDelimiter || isNextChrComment || isNextChrTrimable) {
                this.state.quoting = false;
                this.state.wasQuoting = true;
                pos += quote.length - 1;
                continue;
              } else if (relax_quotes === false) {
                const err = this.__error(
                  new CsvError$1(
                    "CSV_INVALID_CLOSING_QUOTE",
                    [
                      "Invalid Closing Quote:",
                      `got "${String.fromCharCode(nextChr)}"`,
                      `at line ${this.info.lines}`,
                      "instead of delimiter, record delimiter, trimable character",
                      "(if activated) or comment"
                    ],
                    this.options,
                    this.__infoField()
                  )
                );
                if (err !== void 0) return err;
              } else {
                this.state.quoting = false;
                this.state.wasQuoting = true;
                this.state.field.prepend(quote);
                pos += quote.length - 1;
              }
            } else {
              if (this.state.field.length !== 0) {
                if (relax_quotes === false) {
                  const info2 = this.__infoField();
                  const bom2 = Object.keys(boms).map(
                    (b) => boms[b].equals(this.state.field.toString()) ? b : false
                  ).filter(Boolean)[0];
                  const err = this.__error(
                    new CsvError$1(
                      "INVALID_OPENING_QUOTE",
                      [
                        "Invalid Opening Quote:",
                        `a quote is found on field ${JSON.stringify(info2.column)} at line ${info2.lines}, value is ${JSON.stringify(this.state.field.toString(encoding))}`,
                        bom2 ? `(${bom2} bom)` : void 0
                      ],
                      this.options,
                      info2,
                      {
                        field: this.state.field
                      }
                    )
                  );
                  if (err !== void 0) return err;
                }
              } else {
                this.state.quoting = true;
                pos += quote.length - 1;
                continue;
              }
            }
          }
          if (this.state.quoting === false) {
            const recordDelimiterLength = this.__isRecordDelimiter(
              chr,
              buf,
              pos
            );
            if (recordDelimiterLength !== 0) {
              const skipCommentLine = this.state.commenting && this.state.wasQuoting === false && this.state.record.length === 0 && this.state.field.length === 0;
              if (skipCommentLine) {
                this.info.comment_lines++;
              } else {
                if (this.state.enabled === false && this.info.lines + (this.state.wasRowDelimiter === true ? 1 : 0) >= from_line) {
                  this.state.enabled = true;
                  this.__resetField();
                  this.__resetRecord();
                  pos += recordDelimiterLength - 1;
                  continue;
                }
                if (skip_empty_lines === true && this.state.wasQuoting === false && this.state.record.length === 0 && this.state.field.length === 0) {
                  this.info.empty_lines++;
                  pos += recordDelimiterLength - 1;
                  continue;
                }
                this.info.bytes = this.state.bufBytesStart + pos;
                const errField = this.__onField();
                if (errField !== void 0) return errField;
                this.info.bytes = this.state.bufBytesStart + pos + recordDelimiterLength;
                const errRecord = this.__onRecord(push);
                if (errRecord !== void 0) return errRecord;
                if (to2 !== -1 && this.info.records >= to2) {
                  this.state.stop = true;
                  close();
                  return;
                }
              }
              this.state.commenting = false;
              pos += recordDelimiterLength - 1;
              continue;
            }
            if (this.state.commenting) {
              continue;
            }
            if (comment2 !== null && (comment_no_infix === false || this.state.record.length === 0 && this.state.field.length === 0)) {
              const commentCount = this.__compareBytes(comment2, buf, pos, chr);
              if (commentCount !== 0) {
                this.state.commenting = true;
                continue;
              }
            }
            const delimiterLength = this.__isDelimiter(buf, pos, chr);
            if (delimiterLength !== 0) {
              this.info.bytes = this.state.bufBytesStart + pos;
              const errField = this.__onField();
              if (errField !== void 0) return errField;
              pos += delimiterLength - 1;
              continue;
            }
          }
        }
        if (this.state.commenting === false) {
          if (max_record_size !== 0 && this.state.record_length + this.state.field.length > max_record_size) {
            return this.__error(
              new CsvError$1(
                "CSV_MAX_RECORD_SIZE",
                [
                  "Max Record Size:",
                  "record exceed the maximum number of tolerated bytes",
                  `of ${max_record_size}`,
                  `at line ${this.info.lines}`
                ],
                this.options,
                this.__infoField()
              )
            );
          }
        }
        const lappend = ltrim === false || this.state.quoting === true || this.state.field.length !== 0 || !this.__isCharTrimable(buf, pos);
        const rappend = rtrim === false || this.state.wasQuoting === false;
        if (lappend === true && rappend === true) {
          this.state.field.append(chr);
        } else if (rtrim === true && !this.__isCharTrimable(buf, pos)) {
          return this.__error(
            new CsvError$1(
              "CSV_NON_TRIMABLE_CHAR_AFTER_CLOSING_QUOTE",
              [
                "Invalid Closing Quote:",
                "found non trimable byte after quote",
                `at line ${this.info.lines}`
              ],
              this.options,
              this.__infoField()
            )
          );
        } else {
          if (lappend === false) {
            pos += this.__isCharTrimable(buf, pos) - 1;
          }
          continue;
        }
      }
      if (end2 === true) {
        if (this.state.quoting === true) {
          const err = this.__error(
            new CsvError$1(
              "CSV_QUOTE_NOT_CLOSED",
              [
                "Quote Not Closed:",
                `the parsing is finished with an opening quote at line ${this.info.lines}`
              ],
              this.options,
              this.__infoField()
            )
          );
          if (err !== void 0) return err;
        } else {
          if (this.state.wasQuoting === true || this.state.record.length !== 0 || this.state.field.length !== 0) {
            this.info.bytes = this.state.bufBytesStart + pos;
            const errField = this.__onField();
            if (errField !== void 0) return errField;
            const errRecord = this.__onRecord(push);
            if (errRecord !== void 0) return errRecord;
          } else if (this.state.wasRowDelimiter === true) {
            this.info.empty_lines++;
          } else if (this.state.commenting === true) {
            this.info.comment_lines++;
          }
        }
      } else {
        this.state.bufBytesStart += pos;
        this.state.previousBuf = buf.slice(pos);
      }
      if (this.state.wasRowDelimiter === true) {
        this.info.lines++;
        this.state.wasRowDelimiter = false;
      }
    },
    __onRecord: function(push) {
      const {
        columns,
        group_columns_by_name,
        encoding,
        info: info2,
        from: from2,
        relax_column_count,
        relax_column_count_less,
        relax_column_count_more,
        raw,
        skip_records_with_empty_values
      } = this.options;
      const { enabled, record } = this.state;
      if (enabled === false) {
        return this.__resetRecord();
      }
      const recordLength = record.length;
      if (columns === true) {
        if (skip_records_with_empty_values === true && isRecordEmpty(record)) {
          this.__resetRecord();
          return;
        }
        return this.__firstLineToColumns(record);
      }
      if (columns === false && this.info.records === 0) {
        this.state.expectedRecordLength = recordLength;
      }
      if (recordLength !== this.state.expectedRecordLength) {
        const err = columns === false ? new CsvError$1(
          "CSV_RECORD_INCONSISTENT_FIELDS_LENGTH",
          [
            "Invalid Record Length:",
            `expect ${this.state.expectedRecordLength},`,
            `got ${recordLength} on line ${this.info.lines}`
          ],
          this.options,
          this.__infoField(),
          {
            record
          }
        ) : new CsvError$1(
          "CSV_RECORD_INCONSISTENT_COLUMNS",
          [
            "Invalid Record Length:",
            `columns length is ${columns.length},`,
            // rename columns
            `got ${recordLength} on line ${this.info.lines}`
          ],
          this.options,
          this.__infoField(),
          {
            record
          }
        );
        if (relax_column_count === true || relax_column_count_less === true && recordLength < this.state.expectedRecordLength || relax_column_count_more === true && recordLength > this.state.expectedRecordLength) {
          this.info.invalid_field_length++;
          this.state.error = err;
        } else {
          const finalErr = this.__error(err);
          if (finalErr) return finalErr;
        }
      }
      if (skip_records_with_empty_values === true && isRecordEmpty(record)) {
        this.__resetRecord();
        return;
      }
      if (this.state.recordHasError === true) {
        this.__resetRecord();
        this.state.recordHasError = false;
        return;
      }
      this.info.records++;
      if (from2 === 1 || this.info.records >= from2) {
        const { objname } = this.options;
        if (columns !== false) {
          const obj = {};
          for (let i = 0, l2 = record.length; i < l2; i++) {
            if (columns[i] === void 0 || columns[i].disabled) continue;
            if (group_columns_by_name === true && obj[columns[i].name] !== void 0) {
              if (Array.isArray(obj[columns[i].name])) {
                obj[columns[i].name] = obj[columns[i].name].concat(record[i]);
              } else {
                obj[columns[i].name] = [obj[columns[i].name], record[i]];
              }
            } else {
              obj[columns[i].name] = record[i];
            }
          }
          if (raw === true || info2 === true) {
            const extRecord = Object.assign(
              { record: obj },
              raw === true ? { raw: this.state.rawBuffer.toString(encoding) } : {},
              info2 === true ? { info: this.__infoRecord() } : {}
            );
            const err = this.__push(
              objname === void 0 ? extRecord : [obj[objname], extRecord],
              push
            );
            if (err) {
              return err;
            }
          } else {
            const err = this.__push(
              objname === void 0 ? obj : [obj[objname], obj],
              push
            );
            if (err) {
              return err;
            }
          }
        } else {
          if (raw === true || info2 === true) {
            const extRecord = Object.assign(
              { record },
              raw === true ? { raw: this.state.rawBuffer.toString(encoding) } : {},
              info2 === true ? { info: this.__infoRecord() } : {}
            );
            const err = this.__push(
              objname === void 0 ? extRecord : [record[objname], extRecord],
              push
            );
            if (err) {
              return err;
            }
          } else {
            const err = this.__push(
              objname === void 0 ? record : [record[objname], record],
              push
            );
            if (err) {
              return err;
            }
          }
        }
      }
      this.__resetRecord();
    },
    __firstLineToColumns: function(record) {
      const { firstLineToHeaders } = this.state;
      try {
        const headers = firstLineToHeaders === void 0 ? record : firstLineToHeaders.call(null, record);
        if (!Array.isArray(headers)) {
          return this.__error(
            new CsvError$1(
              "CSV_INVALID_COLUMN_MAPPING",
              [
                "Invalid Column Mapping:",
                "expect an array from column function,",
                `got ${JSON.stringify(headers)}`
              ],
              this.options,
              this.__infoField(),
              {
                headers
              }
            )
          );
        }
        const normalizedHeaders = normalize_columns_array(headers);
        this.state.expectedRecordLength = normalizedHeaders.length;
        this.options.columns = normalizedHeaders;
        this.__resetRecord();
        return;
      } catch (err) {
        return err;
      }
    },
    __resetRecord: function() {
      if (this.options.raw === true) {
        this.state.rawBuffer.reset();
      }
      this.state.error = void 0;
      this.state.record = [];
      this.state.record_length = 0;
    },
    __onField: function() {
      const { cast, encoding, rtrim, max_record_size } = this.options;
      const { enabled, wasQuoting } = this.state;
      if (enabled === false) {
        return this.__resetField();
      }
      let field = this.state.field.toString(encoding);
      if (rtrim === true && wasQuoting === false) {
        field = field.trimRight();
      }
      if (cast === true) {
        const [err, f] = this.__cast(field);
        if (err !== void 0) return err;
        field = f;
      }
      this.state.record.push(field);
      if (max_record_size !== 0 && typeof field === "string") {
        this.state.record_length += field.length;
      }
      this.__resetField();
    },
    __resetField: function() {
      this.state.field.reset();
      this.state.wasQuoting = false;
    },
    __push: function(record, push) {
      const { on_record } = this.options;
      if (on_record !== void 0) {
        const info2 = this.__infoRecord();
        try {
          record = on_record.call(null, record, info2);
        } catch (err) {
          return err;
        }
        if (record === void 0 || record === null) {
          return;
        }
      }
      this.info.bytes_records += this.info.bytes;
      push(record);
    },
    // Return a tuple with the error and the casted value
    __cast: function(field) {
      const { columns, relax_column_count } = this.options;
      const isColumns = Array.isArray(columns);
      if (isColumns === true && relax_column_count && this.options.columns.length <= this.state.record.length) {
        return [void 0, void 0];
      }
      if (this.state.castField !== null) {
        try {
          const info2 = this.__infoField();
          return [void 0, this.state.castField.call(null, field, info2)];
        } catch (err) {
          return [err];
        }
      }
      if (this.__isFloat(field)) {
        return [void 0, parseFloat(field)];
      } else if (this.options.cast_date !== false) {
        const info2 = this.__infoField();
        return [void 0, this.options.cast_date.call(null, field, info2)];
      }
      return [void 0, field];
    },
    // Helper to test if a character is a space or a line delimiter
    __isCharTrimable: function(buf, pos) {
      const isTrim = (buf2, pos2) => {
        const { timchars } = this.state;
        loop1: for (let i = 0; i < timchars.length; i++) {
          const timchar = timchars[i];
          for (let j = 0; j < timchar.length; j++) {
            if (timchar[j] !== buf2[pos2 + j]) continue loop1;
          }
          return timchar.length;
        }
        return 0;
      };
      return isTrim(buf, pos);
    },
    // Keep it in case we implement the `cast_int` option
    // __isInt(value){
    //   // return Number.isInteger(parseInt(value))
    //   // return !isNaN( parseInt( obj ) );
    //   return /^(\-|\+)?[1-9][0-9]*$/.test(value)
    // }
    __isFloat: function(value) {
      return value - parseFloat(value) + 1 >= 0;
    },
    __compareBytes: function(sourceBuf, targetBuf, targetPos, firstByte) {
      if (sourceBuf[0] !== firstByte) return 0;
      const sourceLength = sourceBuf.length;
      for (let i = 1; i < sourceLength; i++) {
        if (sourceBuf[i] !== targetBuf[targetPos + i]) return 0;
      }
      return sourceLength;
    },
    __isDelimiter: function(buf, pos, chr) {
      const { delimiter: delimiter2, ignore_last_delimiters } = this.options;
      if (ignore_last_delimiters === true && this.state.record.length === this.options.columns.length - 1) {
        return 0;
      } else if (ignore_last_delimiters !== false && typeof ignore_last_delimiters === "number" && this.state.record.length === ignore_last_delimiters - 1) {
        return 0;
      }
      loop1: for (let i = 0; i < delimiter2.length; i++) {
        const del = delimiter2[i];
        if (del[0] === chr) {
          for (let j = 1; j < del.length; j++) {
            if (del[j] !== buf[pos + j]) continue loop1;
          }
          return del.length;
        }
      }
      return 0;
    },
    __isRecordDelimiter: function(chr, buf, pos) {
      const { record_delimiter } = this.options;
      const recordDelimiterLength = record_delimiter.length;
      loop1: for (let i = 0; i < recordDelimiterLength; i++) {
        const rd = record_delimiter[i];
        const rdLength = rd.length;
        if (rd[0] !== chr) {
          continue;
        }
        for (let j = 1; j < rdLength; j++) {
          if (rd[j] !== buf[pos + j]) {
            continue loop1;
          }
        }
        return rd.length;
      }
      return 0;
    },
    __isEscape: function(buf, pos, chr) {
      const { escape: escape2 } = this.options;
      if (escape2 === null) return false;
      const l2 = escape2.length;
      if (escape2[0] === chr) {
        for (let i = 0; i < l2; i++) {
          if (escape2[i] !== buf[pos + i]) {
            return false;
          }
        }
        return true;
      }
      return false;
    },
    __isQuote: function(buf, pos) {
      const { quote } = this.options;
      if (quote === null) return false;
      const l2 = quote.length;
      for (let i = 0; i < l2; i++) {
        if (quote[i] !== buf[pos + i]) {
          return false;
        }
      }
      return true;
    },
    __autoDiscoverRecordDelimiter: function(buf, pos) {
      const { encoding } = this.options;
      const rds = [
        // Important, the windows line ending must be before mac os 9
        Buffer$2.from("\r\n", encoding),
        Buffer$2.from("\n", encoding),
        Buffer$2.from("\r", encoding)
      ];
      loop: for (let i = 0; i < rds.length; i++) {
        const l2 = rds[i].length;
        for (let j = 0; j < l2; j++) {
          if (rds[i][j] !== buf[pos + j]) {
            continue loop;
          }
        }
        this.options.record_delimiter.push(rds[i]);
        this.state.recordDelimiterMaxLength = rds[i].length;
        return rds[i].length;
      }
      return 0;
    },
    __error: function(msg) {
      const { encoding, raw, skip_records_with_error } = this.options;
      const err = typeof msg === "string" ? new Error(msg) : msg;
      if (skip_records_with_error) {
        this.state.recordHasError = true;
        if (this.options.on_skip !== void 0) {
          try {
            this.options.on_skip(
              err,
              raw ? this.state.rawBuffer.toString(encoding) : void 0
            );
          } catch (err2) {
            return err2;
          }
        }
        return void 0;
      } else {
        return err;
      }
    },
    __infoDataSet: function() {
      return {
        ...this.info,
        columns: this.options.columns
      };
    },
    __infoRecord: function() {
      const { columns, raw, encoding } = this.options;
      return {
        ...this.__infoDataSet(),
        bytes_records: this.info.bytes,
        error: this.state.error,
        header: columns === true,
        index: this.state.record.length,
        raw: raw ? this.state.rawBuffer.toString(encoding) : void 0
      };
    },
    __infoField: function() {
      const { columns } = this.options;
      const isColumns = Array.isArray(columns);
      const bytes_records = this.info.bytes_records;
      return {
        ...this.__infoRecord(),
        bytes_records,
        column: isColumns === true ? columns.length > this.state.record.length ? columns[this.state.record.length].name : null : this.state.record.length,
        quoting: this.state.wasQuoting
      };
    }
  };
};
const parse$2 = function(data, opts = {}) {
  if (typeof data === "string") {
    data = Buffer$2.from(data);
  }
  const records = opts && opts.objname ? {} : [];
  const parser = transform(opts);
  const push = (record) => {
    if (parser.options.objname === void 0) records.push(record);
    else {
      records[record[0]] = record[1];
    }
  };
  const close = () => {
  };
  const error = parser.parse(data, true, push, close);
  if (error !== void 0) throw error;
  return records;
};
var ImportResultStatus = /* @__PURE__ */ ((ImportResultStatus2) => {
  ImportResultStatus2[ImportResultStatus2["None"] = 0] = "None";
  ImportResultStatus2[ImportResultStatus2["Pending"] = 1] = "Pending";
  ImportResultStatus2[ImportResultStatus2["Added"] = 2] = "Added";
  ImportResultStatus2[ImportResultStatus2["Updated"] = 3] = "Updated";
  ImportResultStatus2[ImportResultStatus2["Rejected"] = 4] = "Rejected";
  ImportResultStatus2[ImportResultStatus2["Removed"] = 5] = "Removed";
  ImportResultStatus2[ImportResultStatus2["Error"] = 6] = "Error";
  ImportResultStatus2[ImportResultStatus2["Submitted"] = 7] = "Submitted";
  return ImportResultStatus2;
})(ImportResultStatus || {});
var ImportAction = /* @__PURE__ */ ((ImportAction2) => {
  ImportAction2["Add"] = "add";
  ImportAction2["Update"] = "update";
  ImportAction2["Reject"] = "reject";
  ImportAction2["Remove"] = "remove";
  ImportAction2["Ignore"] = "ignore";
  ImportAction2["Submit"] = "submit";
  return ImportAction2;
})(ImportAction || {});
var ImportCommand = /* @__PURE__ */ ((ImportCommand2) => {
  ImportCommand2["Remove"] = "!DELETE!";
  return ImportCommand2;
})(ImportCommand || {});
const getImportDefault = () => {
  return {
    laborCategory: {
      key: 0,
      name: ""
    },
    payCode: {
      key: 0,
      name: ""
    },
    projectType: {
      key: 0,
      name: ""
    },
    location: {
      key: 0,
      name: ""
    }
  };
};
const createImportJob = (items, options = {}) => {
  const job = {
    batchSize: options.batchSize || 1,
    endTime: null,
    processed: [],
    processing: [],
    queue: [...items],
    startTime: null
  };
  return job;
};
const filterImportResults = (items) => {
  const importFailures = (i) => i.action === "reject" || i.result === 4 || i.result === 6;
  const added = items.filter(
    (i) => i.result === 2
    /* Added */
  ) ?? [];
  const updated = items.filter(
    (i) => i.result === 3
    /* Updated */
  ) ?? [];
  const removed = items.filter(
    (i) => i.result === 5
    /* Removed */
  ) ?? [];
  const ignored = items.filter(
    (i) => i.result === 0
    /* None */
  ) ?? [];
  const failed = items.filter(importFailures) ?? [];
  return { added, updated, removed, ignored, failed };
};
const IMPORT_ACTION_COLUMN = "import_action";
const USER_IMPORT_ACTIONS = [
  ImportAction.Add,
  ImportAction.Update,
  ImportAction.Remove
];
const createImportRecordsFromCSV = (csv, parser) => {
  const records = parse$2(csv, {
    columns: true,
    skip_empty_lines: true
  });
  return records.map(parser);
};
const createAsyncImportRecordsFromCSV = async (csv, parser) => {
  const records = parse$2(csv, {
    columns: true,
    skip_empty_lines: true
  });
  const parsedRecords = [];
  for (const r12 of records) {
    const parsed = await parser(r12);
    parsedRecords.push(parsed);
  }
  return parsedRecords;
};
const createSingleImportRecordFromCSV = async (csv, parser) => {
  const records = parse$2(csv, {
    columns: true,
    skip_empty_lines: true
  });
  const r12 = records[0];
  const parsed = await parser(r12);
  return parsed;
};
const parseImportRecordAction = (record, fieldName = IMPORT_ACTION_COLUMN) => {
  const action = record[fieldName];
  if (!action || !USER_IMPORT_ACTIONS.includes(action)) {
    return ImportAction.Reject;
  }
  return action;
};
const csvStringField = (name, { required }, isValidFn, parseFn) => ({
  name,
  canParse: (record) => {
    if (required && isValidFn) {
      return !!record[name] && isValidFn(record[name]);
    } else if (isValidFn) {
      return isValidFn(record[name]);
    } else {
      return false;
    }
  },
  parse: (record) => parseFn ? parseFn(record[name]) : record[name]
});
const processImportBatch = async (job, importer) => {
  if (job.queue.length === 0) {
    return job;
  }
  if (job.processing.length > 0) {
    throw new AppError(
      "Job processing already in progress",
      ErrorCode.OperationInvalid
    );
  }
  if (job.processed.length === 0) {
    job.startTime = DateTime.local();
  }
  const processSize = Math.min(job.batchSize, job.queue.length);
  job.processing = take(job.queue, processSize);
  job.queue = takeRight(job.queue, Math.max(0, job.queue.length - processSize));
  const processingRecords = [];
  for (let record of job.processing) {
    const { status, errors = [] } = await importer(record.action, record.data);
    record = {
      ...record,
      result: status,
      errors: [...record.errors, ...errors]
    };
    processingRecords.push(record);
  }
  job.processed = [...job.processed, ...processingRecords];
  job.processing = [];
  if (job.queue.length === 0) {
    job.endTime = DateTime.local();
  }
  return job;
};
const importJobPercentComplete = (job) => {
  return job.processed.length / (job.processing.length + job.queue.length);
};
const importJobDuration = (job) => {
  if (!job.startTime) {
    return 0;
  }
  return DateTime.local().diff(job.startTime).as("milliseconds");
};
const importJobIsComplete = (job) => {
  return job.queue.length === 0;
};
const importJobProcessedCounts = (job) => {
  const map2 = /* @__PURE__ */ new Map();
  job.processed.forEach((item) => {
    map2.set(item.action, (map2.get(item.action) || 0) + 1);
  });
  return map2;
};
const importJobStats = (job) => {
  const counts = importJobProcessedCounts(job);
  const remaining = job.queue.length + job.processing.length;
  return {
    added: counts.get(ImportAction.Add) || 0,
    duration: importJobDuration(job),
    percentage: importJobPercentComplete(job),
    remaining,
    removed: counts.get(ImportAction.Remove) || 0,
    updated: counts.get(ImportAction.Update) || 0
  };
};
const index$5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IMPORT_ACTION_COLUMN,
  ImportAction,
  ImportCommand,
  ImportResultStatus,
  USER_IMPORT_ACTIONS,
  createAsyncImportRecordsFromCSV,
  createImportJob,
  createImportRecordsFromCSV,
  createSingleImportRecordFromCSV,
  csvStringField,
  filterImportResults,
  getImportDefault,
  importJobDuration,
  importJobIsComplete,
  importJobPercentComplete,
  importJobProcessedCounts,
  importJobStats,
  parseImportRecordAction,
  processImportBatch
}, Symbol.toStringTag, { value: "Module" }));
const addToMap = (map2, key, value) => {
  const next2 = new Map(map2);
  next2.set(key, value);
  return next2;
};
var DP$1 = 20, RM$1 = 1, MAX_DP = 1e6, MAX_POWER = 1e6, NE$1 = -7, PE$1 = 21, STRICT = false, NAME = "[big.js] ", INVALID = NAME + "Invalid ", INVALID_DP = INVALID + "decimal places", INVALID_RM = INVALID + "rounding mode", DIV_BY_ZERO = NAME + "Division by zero", P = {}, UNDEFINED = void 0, NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
function _Big_() {
  function Big2(n12) {
    var x = this;
    if (!(x instanceof Big2)) {
      return n12 === UNDEFINED && arguments.length === 0 ? _Big_() : new Big2(n12);
    }
    if (n12 instanceof Big2) {
      x.s = n12.s;
      x.e = n12.e;
      x.c = n12.c.slice();
    } else {
      if (typeof n12 !== "string") {
        if (Big2.strict === true && typeof n12 !== "bigint") {
          throw TypeError(INVALID + "value");
        }
        n12 = n12 === 0 && 1 / n12 < 0 ? "-0" : String(n12);
      }
      parse$1(x, n12);
    }
    x.constructor = Big2;
  }
  Big2.prototype = P;
  Big2.DP = DP$1;
  Big2.RM = RM$1;
  Big2.NE = NE$1;
  Big2.PE = PE$1;
  Big2.strict = STRICT;
  Big2.roundDown = 0;
  Big2.roundHalfUp = 1;
  Big2.roundHalfEven = 2;
  Big2.roundUp = 3;
  return Big2;
}
function parse$1(x, n12) {
  var e, i, nl2;
  if (!NUMERIC.test(n12)) {
    throw Error(INVALID + "number");
  }
  x.s = n12.charAt(0) == "-" ? (n12 = n12.slice(1), -1) : 1;
  if ((e = n12.indexOf(".")) > -1) n12 = n12.replace(".", "");
  if ((i = n12.search(/e/i)) > 0) {
    if (e < 0) e = i;
    e += +n12.slice(i + 1);
    n12 = n12.substring(0, i);
  } else if (e < 0) {
    e = n12.length;
  }
  nl2 = n12.length;
  for (i = 0; i < nl2 && n12.charAt(i) == "0"; ) ++i;
  if (i == nl2) {
    x.c = [x.e = 0];
  } else {
    for (; nl2 > 0 && n12.charAt(--nl2) == "0"; ) ;
    x.e = e - i - 1;
    x.c = [];
    for (e = 0; i <= nl2; ) x.c[e++] = +n12.charAt(i++);
  }
  return x;
}
function round$4(x, sd2, rm2, more) {
  var xc2 = x.c;
  if (rm2 === UNDEFINED) rm2 = x.constructor.RM;
  if (rm2 !== 0 && rm2 !== 1 && rm2 !== 2 && rm2 !== 3) {
    throw Error(INVALID_RM);
  }
  if (sd2 < 1) {
    more = rm2 === 3 && (more || !!xc2[0]) || sd2 === 0 && (rm2 === 1 && xc2[0] >= 5 || rm2 === 2 && (xc2[0] > 5 || xc2[0] === 5 && (more || xc2[1] !== UNDEFINED)));
    xc2.length = 1;
    if (more) {
      x.e = x.e - sd2 + 1;
      xc2[0] = 1;
    } else {
      xc2[0] = x.e = 0;
    }
  } else if (sd2 < xc2.length) {
    more = rm2 === 1 && xc2[sd2] >= 5 || rm2 === 2 && (xc2[sd2] > 5 || xc2[sd2] === 5 && (more || xc2[sd2 + 1] !== UNDEFINED || xc2[sd2 - 1] & 1)) || rm2 === 3 && (more || !!xc2[0]);
    xc2.length = sd2;
    if (more) {
      for (; ++xc2[--sd2] > 9; ) {
        xc2[sd2] = 0;
        if (sd2 === 0) {
          ++x.e;
          xc2.unshift(1);
          break;
        }
      }
    }
    for (sd2 = xc2.length; !xc2[--sd2]; ) xc2.pop();
  }
  return x;
}
function stringify$2(x, doExponential, isNonzero) {
  var e = x.e, s12 = x.c.join(""), n12 = s12.length;
  if (doExponential) {
    s12 = s12.charAt(0) + (n12 > 1 ? "." + s12.slice(1) : "") + (e < 0 ? "e" : "e+") + e;
  } else if (e < 0) {
    for (; ++e; ) s12 = "0" + s12;
    s12 = "0." + s12;
  } else if (e > 0) {
    if (++e > n12) {
      for (e -= n12; e--; ) s12 += "0";
    } else if (e < n12) {
      s12 = s12.slice(0, e) + "." + s12.slice(e);
    }
  } else if (n12 > 1) {
    s12 = s12.charAt(0) + "." + s12.slice(1);
  }
  return x.s < 0 && isNonzero ? "-" + s12 : s12;
}
P.abs = function() {
  var x = new this.constructor(this);
  x.s = 1;
  return x;
};
P.cmp = function(y) {
  var isneg, x = this, xc2 = x.c, yc2 = (y = new x.constructor(y)).c, i = x.s, j = y.s, k = x.e, l2 = y.e;
  if (!xc2[0] || !yc2[0]) return !xc2[0] ? !yc2[0] ? 0 : -j : i;
  if (i != j) return i;
  isneg = i < 0;
  if (k != l2) return k > l2 ^ isneg ? 1 : -1;
  j = (k = xc2.length) < (l2 = yc2.length) ? k : l2;
  for (i = -1; ++i < j; ) {
    if (xc2[i] != yc2[i]) return xc2[i] > yc2[i] ^ isneg ? 1 : -1;
  }
  return k == l2 ? 0 : k > l2 ^ isneg ? 1 : -1;
};
P.div = function(y) {
  var x = this, Big2 = x.constructor, a = x.c, b = (y = new Big2(y)).c, k = x.s == y.s ? 1 : -1, dp2 = Big2.DP;
  if (dp2 !== ~~dp2 || dp2 < 0 || dp2 > MAX_DP) {
    throw Error(INVALID_DP);
  }
  if (!b[0]) {
    throw Error(DIV_BY_ZERO);
  }
  if (!a[0]) {
    y.s = k;
    y.c = [y.e = 0];
    return y;
  }
  var bl, bt, n12, cmp, ri, bz2 = b.slice(), ai2 = bl = b.length, al2 = a.length, r12 = a.slice(0, bl), rl2 = r12.length, q = y, qc2 = q.c = [], qi2 = 0, p = dp2 + (q.e = x.e - y.e) + 1;
  q.s = k;
  k = p < 0 ? 0 : p;
  bz2.unshift(0);
  for (; rl2++ < bl; ) r12.push(0);
  do {
    for (n12 = 0; n12 < 10; n12++) {
      if (bl != (rl2 = r12.length)) {
        cmp = bl > rl2 ? 1 : -1;
      } else {
        for (ri = -1, cmp = 0; ++ri < bl; ) {
          if (b[ri] != r12[ri]) {
            cmp = b[ri] > r12[ri] ? 1 : -1;
            break;
          }
        }
      }
      if (cmp < 0) {
        for (bt = rl2 == bl ? b : bz2; rl2; ) {
          if (r12[--rl2] < bt[rl2]) {
            ri = rl2;
            for (; ri && !r12[--ri]; ) r12[ri] = 9;
            --r12[ri];
            r12[rl2] += 10;
          }
          r12[rl2] -= bt[rl2];
        }
        for (; !r12[0]; ) r12.shift();
      } else {
        break;
      }
    }
    qc2[qi2++] = cmp ? n12 : ++n12;
    if (r12[0] && cmp) r12[rl2] = a[ai2] || 0;
    else r12 = [a[ai2]];
  } while ((ai2++ < al2 || r12[0] !== UNDEFINED) && k--);
  if (!qc2[0] && qi2 != 1) {
    qc2.shift();
    q.e--;
    p--;
  }
  if (qi2 > p) round$4(q, p, Big2.RM, r12[0] !== UNDEFINED);
  return q;
};
P.eq = function(y) {
  return this.cmp(y) === 0;
};
P.gt = function(y) {
  return this.cmp(y) > 0;
};
P.gte = function(y) {
  return this.cmp(y) > -1;
};
P.lt = function(y) {
  return this.cmp(y) < 0;
};
P.lte = function(y) {
  return this.cmp(y) < 1;
};
P.minus = P.sub = function(y) {
  var i, j, t16, xlty, x = this, Big2 = x.constructor, a = x.s, b = (y = new Big2(y)).s;
  if (a != b) {
    y.s = -b;
    return x.plus(y);
  }
  var xc2 = x.c.slice(), xe2 = x.e, yc2 = y.c, ye = y.e;
  if (!xc2[0] || !yc2[0]) {
    if (yc2[0]) {
      y.s = -b;
    } else if (xc2[0]) {
      y = new Big2(x);
    } else {
      y.s = 1;
    }
    return y;
  }
  if (a = xe2 - ye) {
    if (xlty = a < 0) {
      a = -a;
      t16 = xc2;
    } else {
      ye = xe2;
      t16 = yc2;
    }
    t16.reverse();
    for (b = a; b--; ) t16.push(0);
    t16.reverse();
  } else {
    j = ((xlty = xc2.length < yc2.length) ? xc2 : yc2).length;
    for (a = b = 0; b < j; b++) {
      if (xc2[b] != yc2[b]) {
        xlty = xc2[b] < yc2[b];
        break;
      }
    }
  }
  if (xlty) {
    t16 = xc2;
    xc2 = yc2;
    yc2 = t16;
    y.s = -y.s;
  }
  if ((b = (j = yc2.length) - (i = xc2.length)) > 0) for (; b--; ) xc2[i++] = 0;
  for (b = i; j > a; ) {
    if (xc2[--j] < yc2[j]) {
      for (i = j; i && !xc2[--i]; ) xc2[i] = 9;
      --xc2[i];
      xc2[j] += 10;
    }
    xc2[j] -= yc2[j];
  }
  for (; xc2[--b] === 0; ) xc2.pop();
  for (; xc2[0] === 0; ) {
    xc2.shift();
    --ye;
  }
  if (!xc2[0]) {
    y.s = 1;
    xc2 = [ye = 0];
  }
  y.c = xc2;
  y.e = ye;
  return y;
};
P.mod = function(y) {
  var ygtx, x = this, Big2 = x.constructor, a = x.s, b = (y = new Big2(y)).s;
  if (!y.c[0]) {
    throw Error(DIV_BY_ZERO);
  }
  x.s = y.s = 1;
  ygtx = y.cmp(x) == 1;
  x.s = a;
  y.s = b;
  if (ygtx) return new Big2(x);
  a = Big2.DP;
  b = Big2.RM;
  Big2.DP = Big2.RM = 0;
  x = x.div(y);
  Big2.DP = a;
  Big2.RM = b;
  return this.minus(x.times(y));
};
P.neg = function() {
  var x = new this.constructor(this);
  x.s = -x.s;
  return x;
};
P.plus = P.add = function(y) {
  var e, k, t16, x = this, Big2 = x.constructor;
  y = new Big2(y);
  if (x.s != y.s) {
    y.s = -y.s;
    return x.minus(y);
  }
  var xe2 = x.e, xc2 = x.c, ye = y.e, yc2 = y.c;
  if (!xc2[0] || !yc2[0]) {
    if (!yc2[0]) {
      if (xc2[0]) {
        y = new Big2(x);
      } else {
        y.s = x.s;
      }
    }
    return y;
  }
  xc2 = xc2.slice();
  if (e = xe2 - ye) {
    if (e > 0) {
      ye = xe2;
      t16 = yc2;
    } else {
      e = -e;
      t16 = xc2;
    }
    t16.reverse();
    for (; e--; ) t16.push(0);
    t16.reverse();
  }
  if (xc2.length - yc2.length < 0) {
    t16 = yc2;
    yc2 = xc2;
    xc2 = t16;
  }
  e = yc2.length;
  for (k = 0; e; xc2[e] %= 10) k = (xc2[--e] = xc2[e] + yc2[e] + k) / 10 | 0;
  if (k) {
    xc2.unshift(k);
    ++ye;
  }
  for (e = xc2.length; xc2[--e] === 0; ) xc2.pop();
  y.c = xc2;
  y.e = ye;
  return y;
};
P.pow = function(n12) {
  var x = this, one2 = new x.constructor("1"), y = one2, isneg = n12 < 0;
  if (n12 !== ~~n12 || n12 < -MAX_POWER || n12 > MAX_POWER) {
    throw Error(INVALID + "exponent");
  }
  if (isneg) n12 = -n12;
  for (; ; ) {
    if (n12 & 1) y = y.times(x);
    n12 >>= 1;
    if (!n12) break;
    x = x.times(x);
  }
  return isneg ? one2.div(y) : y;
};
P.prec = function(sd2, rm2) {
  if (sd2 !== ~~sd2 || sd2 < 1 || sd2 > MAX_DP) {
    throw Error(INVALID + "precision");
  }
  return round$4(new this.constructor(this), sd2, rm2);
};
P.round = function(dp2, rm2) {
  if (dp2 === UNDEFINED) dp2 = 0;
  else if (dp2 !== ~~dp2 || dp2 < -MAX_DP || dp2 > MAX_DP) {
    throw Error(INVALID_DP);
  }
  return round$4(new this.constructor(this), dp2 + this.e + 1, rm2);
};
P.sqrt = function() {
  var r12, c, t16, x = this, Big2 = x.constructor, s12 = x.s, e = x.e, half = new Big2("0.5");
  if (!x.c[0]) return new Big2(x);
  if (s12 < 0) {
    throw Error(NAME + "No square root");
  }
  s12 = Math.sqrt(+stringify$2(x, true, true));
  if (s12 === 0 || s12 === 1 / 0) {
    c = x.c.join("");
    if (!(c.length + e & 1)) c += "0";
    s12 = Math.sqrt(c);
    e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
    r12 = new Big2((s12 == 1 / 0 ? "5e" : (s12 = s12.toExponential()).slice(0, s12.indexOf("e") + 1)) + e);
  } else {
    r12 = new Big2(s12 + "");
  }
  e = r12.e + (Big2.DP += 4);
  do {
    t16 = r12;
    r12 = half.times(t16.plus(x.div(t16)));
  } while (t16.c.slice(0, e).join("") !== r12.c.slice(0, e).join(""));
  return round$4(r12, (Big2.DP -= 4) + r12.e + 1, Big2.RM);
};
P.times = P.mul = function(y) {
  var c, x = this, Big2 = x.constructor, xc2 = x.c, yc2 = (y = new Big2(y)).c, a = xc2.length, b = yc2.length, i = x.e, j = y.e;
  y.s = x.s == y.s ? 1 : -1;
  if (!xc2[0] || !yc2[0]) {
    y.c = [y.e = 0];
    return y;
  }
  y.e = i + j;
  if (a < b) {
    c = xc2;
    xc2 = yc2;
    yc2 = c;
    j = a;
    a = b;
    b = j;
  }
  for (c = new Array(j = a + b); j--; ) c[j] = 0;
  for (i = b; i--; ) {
    b = 0;
    for (j = a + i; j > i; ) {
      b = c[j] + yc2[i] * xc2[j - i - 1] + b;
      c[j--] = b % 10;
      b = b / 10 | 0;
    }
    c[j] = b;
  }
  if (b) ++y.e;
  else c.shift();
  for (i = c.length; !c[--i]; ) c.pop();
  y.c = c;
  return y;
};
P.toExponential = function(dp2, rm2) {
  var x = this, n12 = x.c[0];
  if (dp2 !== UNDEFINED) {
    if (dp2 !== ~~dp2 || dp2 < 0 || dp2 > MAX_DP) {
      throw Error(INVALID_DP);
    }
    x = round$4(new x.constructor(x), ++dp2, rm2);
    for (; x.c.length < dp2; ) x.c.push(0);
  }
  return stringify$2(x, true, !!n12);
};
P.toFixed = function(dp2, rm2) {
  var x = this, n12 = x.c[0];
  if (dp2 !== UNDEFINED) {
    if (dp2 !== ~~dp2 || dp2 < 0 || dp2 > MAX_DP) {
      throw Error(INVALID_DP);
    }
    x = round$4(new x.constructor(x), dp2 + x.e + 1, rm2);
    for (dp2 = dp2 + x.e + 1; x.c.length < dp2; ) x.c.push(0);
  }
  return stringify$2(x, false, !!n12);
};
P.toJSON = P.toString = function() {
  var x = this, Big2 = x.constructor;
  return stringify$2(x, x.e <= Big2.NE || x.e >= Big2.PE, !!x.c[0]);
};
if (typeof Symbol !== "undefined") {
  P[/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")] = P.toJSON;
}
P.toNumber = function() {
  var n12 = +stringify$2(this, true, true);
  if (this.constructor.strict === true && !this.eq(n12.toString())) {
    throw Error(NAME + "Imprecise conversion");
  }
  return n12;
};
P.toPrecision = function(sd2, rm2) {
  var x = this, Big2 = x.constructor, n12 = x.c[0];
  if (sd2 !== UNDEFINED) {
    if (sd2 !== ~~sd2 || sd2 < 1 || sd2 > MAX_DP) {
      throw Error(INVALID + "precision");
    }
    x = round$4(new Big2(x), sd2, rm2);
    for (; x.c.length < sd2; ) x.c.push(0);
  }
  return stringify$2(x, sd2 <= x.e || x.e <= Big2.NE || x.e >= Big2.PE, !!n12);
};
P.valueOf = function() {
  var x = this, Big2 = x.constructor;
  if (Big2.strict === true) {
    throw Error(NAME + "valueOf disallowed");
  }
  return stringify$2(x, x.e <= Big2.NE || x.e >= Big2.PE, true);
};
var Big = _Big_();
const toNumber$1 = (s12) => {
  if (typeof s12 === "number") {
    return s12;
  }
  if (s12 === null) {
    return NaN;
  }
  return parseFloat(s12);
};
const countDigits = (value) => {
  try {
    const num = new Big(value);
    const integerDigits = Math.max(0, num.e + 1);
    const decimalDigits = Math.max(0, num.c.length - (num.e + 1));
    return {
      integerDigits,
      decimalDigits
    };
  } catch (error) {
    log.error({
      msg: `Failed to count digits from ${value}`,
      error: `${error}`
    });
    return {
      integerDigits: 0,
      decimalDigits: 0
    };
  }
};
const isWithinDigitLimits = ({
  value,
  maxDecimalDigits,
  maxIntegerDigits
}) => {
  const { decimalDigits, integerDigits } = countDigits(value);
  return integerDigits <= maxIntegerDigits && decimalDigits <= maxDecimalDigits;
};
const omit = (obj, props) => Object.fromEntries(Object.entries(obj).filter(([k]) => !props.includes(k)));
const UDF_URL_CHARACTER_LIMIT = 2e3;
const formatUdfValue = (field, options) => {
  const { metadata, value } = field;
  if (metadata?.dataType === UdfMetadataModel.DataTypeEnum.DATE) {
    return value ? formatDate(value, options) ?? void 0 : void 0;
  }
  if (metadata?.dataType === UdfMetadataModel.DataTypeEnum.LIST) {
    const option = metadata?.listOptions?.find(
      (option2) => option2.value === value?.toString()
    );
    return option?.text ?? value?.toString();
  }
  return value?.toString();
};
const removeEmptyUdfValues = (udfs) => {
  return udfs.map((udf) => {
    if (udf.value === "") {
      delete udf.value;
    }
    return udf;
  });
};
const fromPlatformMetadata = (metadata) => {
  const result = {
    ...metadata,
    dataType: metadata.dataType ?? "STRING",
    label: metadata.label ?? ""
  };
  if (metadata.listOptions) {
    result.listOptions = metadata.listOptions;
  }
  return result;
};
const fromPlatformUdfValueListModel = (udfs) => {
  if (udfs?.values) {
    return udfs.values.map((u) => {
      const result = { index: u.index ?? 0, value: void 0 };
      if (u.metadata) {
        result.metadata = fromPlatformMetadata(u.metadata);
      }
      const dataType = u.metadata?.dataType;
      if (dataType === "NUMERIC") {
        result.value = Number.isNaN(Number(u.value)) ? null : Number(u.value);
      } else if (dataType === "DATE") {
        result.value = u.value ? DateTime.fromISO(u.value) : null;
      } else {
        result.value = u.value?.toString() ?? null;
      }
      return result;
    });
  } else {
    return [];
  }
};
const toPlatformUdfValueFormat = (field) => {
  const { metadata, value } = field;
  if (metadata?.dataType === "DATE") {
    return value ? value.toISODate() ?? "" : void 0;
  } else {
    return value?.toString();
  }
};
const toPlatformUdfValueListModel = (udfs) => {
  const values2 = udfs.map((u) => {
    const result = {
      index: u.index,
      value: toPlatformUdfValueFormat(u)
    };
    if (u.metadata) {
      result.metadata = u.metadata;
    }
    return result;
  });
  return { values: values2 };
};
const getUrlContext = () => {
  return window.location.pathname.split("/").filter(Boolean)[0];
};
const ABSOLUTE_URL_REGEX = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/;
const isAbsoluteUrl = (url2) => {
  return ABSOLUTE_URL_REGEX.test(url2);
};
const isBlank = (value) => {
  return isEmpty$3(value) && !isNumber$1(value) || isNaN(value);
};
const noop$5 = () => {
};
const emptyKeyName = () => ({ key: -1, name: "" });
const fromKeyNameOrEmpty = (k) => k ?? emptyKeyName();
const removeEmptyName = (property2) => {
  const _property = { ...property2 };
  if (_property.name === "") {
    delete _property.name;
  }
  return _property;
};
const removeNullableEmptyName = (property2) => {
  if (!property2?.key) {
    return;
  }
  const _property = { ...property2 };
  if (_property.name === "") {
    delete _property.name;
  }
  return _property;
};
const toKeyName = (key, name) => {
  const keyValue = key ? key : -1;
  const keyName = { key: keyValue, name };
  if (!name) {
    delete keyName.name;
  }
  return keyName;
};
const platformVersionMeetsMinimum = (minimum, platform) => {
  if (!platform) {
    return false;
  }
  const platformParts = platform.split(".").map((part) => parseInt(part, 10));
  const min2 = take(minimum, Math.min(minimum.length, platformParts.length));
  for (let i = 0; i < min2.length; ++i) {
    const minPart = min2[i];
    const part = platformParts[i];
    if (part > minPart) {
      return true;
    } else if (part < minPart) {
      return false;
    }
  }
  return true;
};
const requirePlatformVersion = async (minimum) => {
  const { platform } = await get$1("/ping/version");
  if (!platformVersionMeetsMinimum(minimum, platform)) {
    throw new AppError(
      "Platform does not meet minimum version",
      ErrorCode.PlatformVersionInvalid,
      { platformVersion: platform, minimum: minimum.join(".") }
    );
  }
};
const version = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  platformVersionMeetsMinimum,
  requirePlatformVersion
}, Symbol.toStringTag, { value: "Module" }));
const index$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get AccountCategoryModel() {
    return AccountCategoryModel;
  },
  get AccountExpenseTypeModel() {
    return AccountExpenseTypeModel;
  },
  get AccountModel() {
    return AccountModel;
  },
  get AccountSourceSupplierModel() {
    return AccountSourceSupplierModel;
  },
  get AccrualScheduleModel() {
    return AccrualScheduleModel;
  },
  get AdvFundContractModCreateModel() {
    return AdvFundContractModCreateModel;
  },
  get AdvFundContractModModel() {
    return AdvFundContractModModel;
  },
  get AdvFundContractStateHistoryModel() {
    return AdvFundContractStateHistoryModel;
  },
  get AlertPrefsModel() {
    return AlertPrefsModel;
  },
  get AnomalyDetectionRequestModel() {
    return AnomalyDetectionRequestModel;
  },
  get ApprovalGroupCreateModel() {
    return ApprovalGroupCreateModel;
  },
  get ApprovalGroupModel() {
    return ApprovalGroupModel;
  },
  get ApprovalGroupSearchModel() {
    return ApprovalGroupSearchModel;
  },
  get ApproverAlternateModel() {
    return ApproverAlternateModel;
  },
  get AssignablePlannedTimeModel() {
    return AssignablePlannedTimeModel;
  },
  get AssignablePlannedTimeSearchModel() {
    return AssignablePlannedTimeSearchModel;
  },
  get AssigningMatrixSearchCriteriaModel() {
    return AssigningMatrixSearchCriteriaModel;
  },
  get AssigningMatrixSearchCriteriaReadModel() {
    return AssigningMatrixSearchCriteriaReadModel;
  },
  get AssigningMatrixSearchModel() {
    return AssigningMatrixSearchModel;
  },
  get AssignmentDefaultsModel() {
    return AssignmentDefaultsModel;
  },
  get AssignmentMatrixData() {
    return AssignmentMatrixData;
  },
  get AuditDataSearchModel() {
    return AuditDataSearchModel;
  },
  get BankAccountModel() {
    return BankAccountModel;
  },
  get BasePurchasingDocumentSearchModel() {
    return BasePurchasingDocumentSearchModel;
  },
  get BillingTypeModel() {
    return BillingTypeModel;
  },
  get CashFlowOptimizationRequestModel() {
    return CashFlowOptimizationRequestModel;
  },
  get CategoryAccountKeyModel() {
    return CategoryAccountKeyModel;
  },
  get CategoryAccountModel() {
    return CategoryAccountModel;
  },
  get ContractCreateModel() {
    return ContractCreateModel;
  },
  get ContractDetailModel() {
    return ContractDetailModel;
  },
  get ContractLineCreateModel() {
    return ContractLineCreateModel;
  },
  get ContractLineModCreateModel() {
    return ContractLineModCreateModel;
  },
  get ContractLineModModel() {
    return ContractLineModModel;
  },
  get ContractLineModel() {
    return ContractLineModel;
  },
  get ContractLineSearchModel() {
    return ContractLineSearchModel;
  },
  get ContractListModel() {
    return ContractListModel;
  },
  get ContractModel() {
    return ContractModel;
  },
  get CostElementModel() {
    return CostElementModel;
  },
  get CostPlusInvoiceSectionFormatCreateModel() {
    return CostPlusInvoiceSectionFormatCreateModel;
  },
  get CostPlusInvoiceSectionFormatModel() {
    return CostPlusInvoiceSectionFormatModel;
  },
  get CostReportElementModel() {
    return CostReportElementModel;
  },
  get CostStructPoolRateModel() {
    return CostStructPoolRateModel;
  },
  get CostStructPoolRateUpdateModel() {
    return CostStructPoolRateUpdateModel;
  },
  get CustomLinkListModel() {
    return CustomLinkListModel;
  },
  get CustomLinkModel() {
    return CustomLinkModel;
  },
  get CustomerPaymentIncludedModel() {
    return CustomerPaymentIncludedModel;
  },
  get CustomerPaymentModel() {
    return CustomerPaymentModel;
  },
  get CustomerPaymentSearchModel() {
    return CustomerPaymentSearchModel;
  },
  get DashboardTypePagedResponse() {
    return DashboardTypePagedResponse;
  },
  get DataLakeCriteriaFieldsModel() {
    return DataLakeCriteriaFieldsModel;
  },
  get DepositSearchModel() {
    return DepositSearchModel;
  },
  get DepositSummaryModel() {
    return DepositSummaryModel;
  },
  get EmailTemplateModel() {
    return EmailTemplateModel;
  },
  get EntertainmentWizardModel() {
    return EntertainmentWizardModel;
  },
  get ErrorInstance() {
    return ErrorInstance;
  },
  get ErrorResponse() {
    return ErrorResponse;
  },
  get ExpenseBaseModel() {
    return ExpenseBaseModel;
  },
  get ExpenseCreateModel() {
    return ExpenseCreateModel;
  },
  get ExpenseInvoiceSectionFormatCreateModel() {
    return ExpenseInvoiceSectionFormatCreateModel;
  },
  get ExpenseInvoiceSectionFormatModel() {
    return ExpenseInvoiceSectionFormatModel;
  },
  get ExpenseLineModel() {
    return ExpenseLineModel;
  },
  get ExpenseModel() {
    return ExpenseModel;
  },
  get ExpenseSearchModel() {
    return ExpenseSearchModel;
  },
  get ExpenseStatusHistoryModel() {
    return ExpenseStatusHistoryModel;
  },
  get ExpenseTypeModel() {
    return ExpenseTypeModel;
  },
  get ExpenseTypeSummaryModel() {
    return ExpenseTypeSummaryModel;
  },
  get FinancialDocumentStatusHistoryModel() {
    return FinancialDocumentStatusHistoryModel;
  },
  get FixedAssetAlertModel() {
    return FixedAssetAlertModel;
  },
  get FixedAssetCreateModel() {
    return FixedAssetCreateModel;
  },
  get FixedAssetJournalEntryModel() {
    return FixedAssetJournalEntryModel;
  },
  get FixedAssetModel() {
    return FixedAssetModel;
  },
  get FixedAssetPostDocumentModel() {
    return FixedAssetPostDocumentModel;
  },
  get FixedAssetSearchReadModel() {
    return FixedAssetSearchReadModel;
  },
  get FixedPriceInvoiceSectionFormatCreateModel() {
    return FixedPriceInvoiceSectionFormatCreateModel;
  },
  get FixedPriceInvoiceSectionFormatModel() {
    return FixedPriceInvoiceSectionFormatModel;
  },
  get FixedPriceItemCreateModel() {
    return FixedPriceItemCreateModel;
  },
  get FixedPriceItemModel() {
    return FixedPriceItemModel;
  },
  get ForecastRequestModel() {
    return ForecastRequestModel;
  },
  get FundedValueAdjustmentInvoiceSectionFormatCreateModel() {
    return FundedValueAdjustmentInvoiceSectionFormatCreateModel;
  },
  get FundedValueAdjustmentInvoiceSectionFormatModel() {
    return FundedValueAdjustmentInvoiceSectionFormatModel;
  },
  HttpError,
  get ImportDefinitionColumnModel() {
    return ImportDefinitionColumnModel;
  },
  get ImportErrorModel() {
    return ImportErrorModel;
  },
  get ImportedExpenseSearchModel() {
    return ImportedExpenseSearchModel;
  },
  get IntegrationUserSearchModel() {
    return IntegrationUserSearchModel;
  },
  IntegrationUserType,
  get IntegrationValueModel() {
    return IntegrationValueModel;
  },
  get InvoiceFormatCreateModel() {
    return InvoiceFormatCreateModel;
  },
  get InvoiceFormatModel() {
    return InvoiceFormatModel;
  },
  get InvoiceListModel() {
    return InvoiceListModel;
  },
  get InvoiceModel() {
    return InvoiceModel;
  },
  get InvoiceStatusHistoryModel() {
    return InvoiceStatusHistoryModel;
  },
  get ItemCreateModel() {
    return ItemCreateModel;
  },
  get ItemModel() {
    return ItemModel;
  },
  get JournalEntryExpenseDetailModel() {
    return JournalEntryExpenseDetailModel;
  },
  get JournalEntryItemDetailModel() {
    return JournalEntryItemDetailModel;
  },
  get JournalEntrySearchModel() {
    return JournalEntrySearchModel;
  },
  get JournalEntrySummaryModel() {
    return JournalEntrySummaryModel;
  },
  get LaborInvoiceSectionFormatCreateModel() {
    return LaborInvoiceSectionFormatCreateModel;
  },
  get LaborInvoiceSectionFormatModel() {
    return LaborInvoiceSectionFormatModel;
  },
  get LeaveRequestModel() {
    return LeaveRequestModel;
  },
  get LeaveStatusHistoryModel() {
    return LeaveStatusHistoryModel;
  },
  LineState,
  get LogMessageModel() {
    return LogMessageModel;
  },
  MAX_PLATFORM_PAGE_SIZE,
  get MatrixPersonModel() {
    return MatrixPersonModel;
  },
  get MeTimesheetSearchModel() {
    return MeTimesheetSearchModel;
  },
  get MileageRateSetModel() {
    return MileageRateSetModel;
  },
  MimeTypes,
  get NaturalLanguageSummaryRequestModel() {
    return NaturalLanguageSummaryRequestModel;
  },
  get NewCookie() {
    return NewCookie;
  },
  get OnetimeInvoiceSectionFormatCreateModel() {
    return OnetimeInvoiceSectionFormatCreateModel;
  },
  get OnetimeInvoiceSectionFormatModel() {
    return OnetimeInvoiceSectionFormatModel;
  },
  get OrgAccessPersonSearchModel() {
    return OrgAccessPersonSearchModel;
  },
  get OrganizationCreateModel() {
    return OrganizationCreateModel;
  },
  get OrganizationModel() {
    return OrganizationModel;
  },
  get OrganizationSummaryModel() {
    return OrganizationSummaryModel;
  },
  get POAlertPreferencesModel() {
    return POAlertPreferencesModel;
  },
  get PODetail() {
    return PODetail;
  },
  get POExpenseLineCreateModel() {
    return POExpenseLineCreateModel;
  },
  get POExpenseLineFromApprovedCreateModel() {
    return POExpenseLineFromApprovedCreateModel;
  },
  get POExpenseLineModel() {
    return POExpenseLineModel;
  },
  get POFormatOptionsModel() {
    return POFormatOptionsModel;
  },
  get POItemLineCreateModel() {
    return POItemLineCreateModel;
  },
  get POItemLineFromApprovedCreateModel() {
    return POItemLineFromApprovedCreateModel;
  },
  get POItemLineModel() {
    return POItemLineModel;
  },
  get POLaborLineCreateModel() {
    return POLaborLineCreateModel;
  },
  get POLaborLineFromApprovedCreateModel() {
    return POLaborLineFromApprovedCreateModel;
  },
  get POLaborLineModel() {
    return POLaborLineModel;
  },
  get PRExpenseLineModel() {
    return PRExpenseLineModel;
  },
  get PRItemLineModel() {
    return PRItemLineModel;
  },
  get PRLaborLineModel() {
    return PRLaborLineModel;
  },
  get PaidCustomerDocumentModel() {
    return PaidCustomerDocumentModel;
  },
  get PaidVendorDocumentModel() {
    return PaidVendorDocumentModel;
  },
  get PayCodeModel() {
    return PayCodeModel;
  },
  get PayableCustomerDocumentModel() {
    return PayableCustomerDocumentModel;
  },
  get PayableVendorDocumentModel() {
    return PayableVendorDocumentModel;
  },
  get PaymentMethodCreateModel() {
    return PaymentMethodCreateModel;
  },
  get PaymentMethodModel() {
    return PaymentMethodModel;
  },
  get PersonAccrualPlanModel() {
    return PersonAccrualPlanModel;
  },
  get PersonCreateModel() {
    return PersonCreateModel;
  },
  get PersonModel() {
    return PersonModel;
  },
  get PersonRateBaseModel() {
    return PersonRateBaseModel;
  },
  get PersonRateCreateModel() {
    return PersonRateCreateModel;
  },
  get PersonRateModel() {
    return PersonRateModel;
  },
  get PersonSearchModel() {
    return PersonSearchModel;
  },
  get PlanDefaultsModel() {
    return PlanDefaultsModel;
  },
  get PlanSetAuditModel() {
    return PlanSetAuditModel;
  },
  get PlannedTimeCreateModel() {
    return PlannedTimeCreateModel;
  },
  get PlannedTimeModel() {
    return PlannedTimeModel;
  },
  get PlannedTimeSearchModel() {
    return PlannedTimeSearchModel;
  },
  get PlanningMatrixSearchCriteriaModel() {
    return PlanningMatrixSearchCriteriaModel;
  },
  get PlanningMatrixSearchCriteriaReadModel() {
    return PlanningMatrixSearchCriteriaReadModel;
  },
  get PlanningMatrixSearchModel() {
    return PlanningMatrixSearchModel;
  },
  PostingFeature,
  get PostingGroupModel() {
    return PostingGroupModel;
  },
  get PostingGroupSourceModel() {
    return PostingGroupSourceModel;
  },
  get PrebilledLaborInvoiceSectionFormatCreateModel() {
    return PrebilledLaborInvoiceSectionFormatCreateModel;
  },
  get PrebilledLaborInvoiceSectionFormatModel() {
    return PrebilledLaborInvoiceSectionFormatModel;
  },
  get PrebilledLaborOffsetInvoiceSectionFormatCreateModel() {
    return PrebilledLaborOffsetInvoiceSectionFormatCreateModel;
  },
  get PrebilledLaborOffsetInvoiceSectionFormatModel() {
    return PrebilledLaborOffsetInvoiceSectionFormatModel;
  },
  get ProjectAlertPrefsModel() {
    return ProjectAlertPrefsModel;
  },
  get ProjectAlertsModel() {
    return ProjectAlertsModel;
  },
  get ProjectApproverModel() {
    return ProjectApproverModel;
  },
  get ProjectApproverUpdateModel() {
    return ProjectApproverUpdateModel;
  },
  get ProjectAssignmentCreateModel() {
    return ProjectAssignmentCreateModel;
  },
  get ProjectAssignmentModel() {
    return ProjectAssignmentModel;
  },
  get ProjectAssignmentUpdateModel() {
    return ProjectAssignmentUpdateModel;
  },
  get ProjectBudgetHistoryModel() {
    return ProjectBudgetHistoryModel;
  },
  get ProjectContractModel() {
    return ProjectContractModel;
  },
  get ProjectControllerModel() {
    return ProjectControllerModel;
  },
  get ProjectCreateModel() {
    return ProjectCreateModel;
  },
  get ProjectFeeCreateModel() {
    return ProjectFeeCreateModel;
  },
  get ProjectFeeModel() {
    return ProjectFeeModel;
  },
  get ProjectInvoiceCreateModel() {
    return ProjectInvoiceCreateModel;
  },
  get ProjectInvoiceModel() {
    return ProjectInvoiceModel;
  },
  get ProjectItemUpdateModel() {
    return ProjectItemUpdateModel;
  },
  get ProjectModel() {
    return ProjectModel;
  },
  get ProjectPeopleAssignmentSearchModel() {
    return ProjectPeopleAssignmentSearchModel;
  },
  get ProjectUpdateModel() {
    return ProjectUpdateModel;
  },
  get PurchaseOrderCreateModel() {
    return PurchaseOrderCreateModel;
  },
  get PurchaseOrderModCreateModel() {
    return PurchaseOrderModCreateModel;
  },
  get PurchaseOrderModModel() {
    return PurchaseOrderModModel;
  },
  get PurchaseOrderModel() {
    return PurchaseOrderModel;
  },
  get PurchaseOrderSearchModel() {
    return PurchaseOrderSearchModel;
  },
  get PurchaseOrderSummaryModel() {
    return PurchaseOrderSummaryModel;
  },
  get PurchaseRequisitionModCreateModel() {
    return PurchaseRequisitionModCreateModel;
  },
  get PurchaseRequisitionModel() {
    return PurchaseRequisitionModel;
  },
  get PurchaseRequisitionOrigCreateModel() {
    return PurchaseRequisitionOrigCreateModel;
  },
  get PurchaseRequisitionSearchModel() {
    return PurchaseRequisitionSearchModel;
  },
  get PurchaseRequisitionSummaryModel() {
    return PurchaseRequisitionSummaryModel;
  },
  get PurchasingApprovalHistoryModel() {
    return PurchasingApprovalHistoryModel;
  },
  get PurchasingBalanceModel() {
    return PurchasingBalanceModel;
  },
  get ReceivingDocumentModel() {
    return ReceivingDocumentModel;
  },
  get ReceivingDocumentSearchModel() {
    return ReceivingDocumentSearchModel;
  },
  get ReceivingPurchaseOrderSearchModel() {
    return ReceivingPurchaseOrderSearchModel;
  },
  get ReportExplanationRequestModel() {
    return ReportExplanationRequestModel;
  },
  get ReportExplanationResponse() {
    return ReportExplanationResponse;
  },
  get SchedulingPersonSearchModel() {
    return SchedulingPersonSearchModel;
  },
  get SectionFilter() {
    return SectionFilter;
  },
  get StatisticalAccountJournalEntryModel() {
    return StatisticalAccountJournalEntryModel;
  },
  get StatisticalAccountJournalEntrySearchModel() {
    return StatisticalAccountJournalEntrySearchModel;
  },
  get StatusType() {
    return StatusType;
  },
  get TaskCreateModel() {
    return TaskCreateModel;
  },
  get TaskDependencyCreateModel() {
    return TaskDependencyCreateModel;
  },
  get TaskDependencyModel() {
    return TaskDependencyModel;
  },
  get TaskModel() {
    return TaskModel;
  },
  get TaskMoveModel() {
    return TaskMoveModel;
  },
  get TaskSummaryModel() {
    return TaskSummaryModel;
  },
  get TaskUpdateModel() {
    return TaskUpdateModel;
  },
  get TaxInvoiceSectionFormatCreateModel() {
    return TaxInvoiceSectionFormatCreateModel;
  },
  get TaxInvoiceSectionFormatModel() {
    return TaxInvoiceSectionFormatModel;
  },
  get TimeExtractModel() {
    return TimeExtractModel;
  },
  get TimePeriodAvailabilityModel() {
    return TimePeriodAvailabilityModel;
  },
  get TimePeriodSetupCreateModel() {
    return TimePeriodSetupCreateModel;
  },
  get TimePeriodSetupModel() {
    return TimePeriodSetupModel;
  },
  get TimeStatusHistoryModel() {
    return TimeStatusHistoryModel;
  },
  get TimesheetListModel() {
    return TimesheetListModel;
  },
  get TimesheetModel() {
    return TimesheetModel;
  },
  get TimesheetOwnerModel() {
    return TimesheetOwnerModel;
  },
  get TimesheetProjectModel() {
    return TimesheetProjectModel;
  },
  get TimesheetSearchModel() {
    return TimesheetSearchModel;
  },
  get TimesheetUpdateModel() {
    return TimesheetUpdateModel;
  },
  TokenError,
  get UdfMetadataModel() {
    return UdfMetadataModel;
  },
  get VendorInvoiceExpenseModel() {
    return VendorInvoiceExpenseModel;
  },
  get VendorInvoiceFormatSectionModel() {
    return VendorInvoiceFormatSectionModel;
  },
  get VendorInvoiceFormatSectionTotalGroupModel() {
    return VendorInvoiceFormatSectionTotalGroupModel;
  },
  get VendorInvoiceItemModel() {
    return VendorInvoiceItemModel;
  },
  get VendorInvoiceLaborModel() {
    return VendorInvoiceLaborModel;
  },
  get VendorInvoiceLaborProjectModel() {
    return VendorInvoiceLaborProjectModel;
  },
  get VendorInvoiceMatchedExpenseElementModel() {
    return VendorInvoiceMatchedExpenseElementModel;
  },
  get VendorInvoiceMatchedItemElementModel() {
    return VendorInvoiceMatchedItemElementModel;
  },
  get VendorInvoiceMatchedLaborElementModel() {
    return VendorInvoiceMatchedLaborElementModel;
  },
  get VendorInvoiceSearchModel() {
    return VendorInvoiceSearchModel;
  },
  get VendorInvoiceSummaryListModel() {
    return VendorInvoiceSummaryListModel;
  },
  get VendorInvoiceSummaryModel() {
    return VendorInvoiceSummaryModel;
  },
  get VendorPaymentIncludedModel() {
    return VendorPaymentIncludedModel;
  },
  get VendorPaymentModel() {
    return VendorPaymentModel;
  },
  get VendorPaymentSearchModel() {
    return VendorPaymentSearchModel;
  },
  accounts,
  advFundClinChanges,
  advFundContractMods,
  advFundSlinChanges,
  approvalGroups: approvalGroup,
  assigning,
  audit,
  auth,
  bankAccount: bankAccounts,
  bankReconciliation,
  businessWeeks,
  calendar,
  changeReasons,
  clauses: contractClauses,
  clinProjectTaskMappings,
  config: config$1,
  contracts,
  costReports,
  currencies,
  customLinks,
  dashboards,
  dataLakeCriteria: datalakeCriteria,
  destroy,
  employeeTypes,
  emptyListPage,
  exchangeRateTypes,
  exchangeRates,
  extractErrorMessages,
  featureFlags: featureFlag,
  fetchAllItems,
  fixedAssets,
  get: get$1,
  getCostElements,
  getCostStructureLabor,
  getCostStructures,
  getToken,
  industry,
  integrations,
  isLastPage,
  laborCategories,
  leadProject,
  leaveRequests,
  locations,
  makePlatformLogTransport,
  mapErrorCodes,
  mapListPage,
  me: me$1,
  modelFromJSON,
  modelToJSON,
  naicsCodes,
  organizations,
  payCodes,
  paymentMethods,
  paymentTerms,
  people,
  ping: ping$1,
  planning,
  post,
  postFile,
  projects,
  properties: properties$1,
  propertyTemplates,
  purchaseOrders,
  put,
  receipts,
  request,
  requestFileUpload,
  setServerUrl,
  setToken,
  socioeconomicStatus,
  statisticalAccountJournals,
  statisticalAccounts,
  submitForm,
  submitFormInNewTab,
  time,
  unanetCore,
  vendorInvoices,
  version,
  with404
}, Symbol.toStringTag, { value: "Module" }));
const fetchAccounts = async ({
  entryAllowed,
  includeInactive,
  page = 1,
  pageSize: pageSize2 = 50,
  type
}) => {
  try {
    return await fetchAccounts$1({
      entryAllowed,
      includeInactive,
      page,
      pageSize: pageSize2,
      type
    });
  } catch (e) {
    log.warn({
      msg: `Error fetching accounts for type: ${type ?? "ALL"}`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchAllAccounts = async ({
  entryAllowed = true,
  includeInactive,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  type
}) => fetchAllItems({
  fetch: (page) => () => fetchAccounts$1({
    entryAllowed,
    includeInactive,
    page,
    pageSize: pageSize2,
    type
  })
});
const index$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchAccounts,
  fetchAllAccounts
}, Symbol.toStringTag, { value: "Module" }));
const createApprovalGroup = async (approvalGroup$1) => {
  try {
    const { key } = await addApprovalGroup(approvalGroup$1);
    return key;
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error creating approval group`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Creating approval group failed`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const deleteApprovalGroup = async (approvalGroupId) => {
  try {
    await deleteApprovalGroup$1(approvalGroupId);
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error deleting approval group`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Deleting approval group failed`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const editApprovalGroup = async (approvalGroupId, approvalGroup$1) => {
  try {
    return await updateApprovalGroup(
      approvalGroupId,
      approvalGroup$1
    );
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error editing approval group: key=${approvalGroupId}`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Editing approval group failed: key=${approvalGroupId}`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const fetchAllApprovalGroupMembers = async ({
  approvalGroupKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  fetch: (page) => () => fetchApproversForApprovalGroup({
    approvalGroupKey,
    page,
    pageSize: pageSize2
  })
});
const fetchAllApprovalGroups = async (approvalGroupType, pageSize2 = MAX_PLATFORM_PAGE_SIZE) => fetchAllItems({
  fetch: (page) => () => fetchApprovalGroupsByType({
    approvalGroupType,
    page,
    pageSize: pageSize2
  })
});
const fetchApproverGroupsForPerson = async (personKey) => (
  //This call doesn't have any paging, and is typed as a KeyNameModel for some reason
  await getApproverGroupsForPerson({
    personKey
  })
);
const filterApprovalGroups = async (query, page = 1, pageSize2 = 50) => {
  try {
    return await searchApprovalGroups(query, page, pageSize2);
  } catch (e) {
    log.warn({
      msg: `Searching approval groups failed: ${JSON.stringify(query)}`,
      error: `${e}`
    });
    throw e;
  }
};
const getApprovalGroup = async ({
  approvalGroupId
}) => {
  try {
    return await fetchApprovalGroup({ id: approvalGroupId });
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error editing approval group: key=${approvalGroupId}`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Editing approval group failed: key=${approvalGroupId}`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const searchAllApprovalGroups = async (query, pageSize2 = MAX_PLATFORM_PAGE_SIZE) => fetchAllItems({
  fetch: (page) => () => searchApprovalGroups(query, page, pageSize2)
});
const addApprovers = async (id, approverIds) => {
  const array = Array.isArray(approverIds) ? approverIds : [approverIds];
  try {
    return await post(`/approval-groups/${id}/approvers`, array);
  } catch (e) {
    if (e.statusCode === 400) {
      log.warn({
        msg: "Expected error on adding new approvers",
        error: `${e}`
      });
    } else {
      log.warn({ msg: "Adding new approvers failed", error: `${e}` });
    }
    throw e;
  }
};
const removeApprover = async (approvalGroupId, approverId) => {
  try {
    return await destroy(
      `/approval-groups/${approvalGroupId}/approvers/${approverId}`
    );
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error removing approver`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Removing approver failed`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const editApprovers = async (approvalGroupId, approvers) => {
  try {
    return await updateApprovers(approvers, approvalGroupId);
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error editing approvers: key=${approvalGroupId}`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Editing approvers failed: key=${approvalGroupId}`,
        error: `${e}`
      });
    }
    throw e;
  }
};
var ApprovalGroupType = /* @__PURE__ */ ((ApprovalGroupType2) => {
  ApprovalGroupType2[ApprovalGroupType2["ACCOUNTS_PAYABLE"] = 1] = "ACCOUNTS_PAYABLE";
  ApprovalGroupType2[ApprovalGroupType2["PURCHASING"] = 2] = "PURCHASING";
  ApprovalGroupType2[ApprovalGroupType2["TIME_AND_EXPENSE"] = 3] = "TIME_AND_EXPENSE";
  ApprovalGroupType2[ApprovalGroupType2["ACCOUNTS_RECEIVABLE"] = 4] = "ACCOUNTS_RECEIVABLE";
  return ApprovalGroupType2;
})(ApprovalGroupType || {});
const groupTypes = /* @__PURE__ */ new Map([
  [
    1,
    ApprovalGroupSearchModel.ApprovalGroupTypesEnum.ACCOUNTSPAYABLE
  ],
  [
    2,
    ApprovalGroupSearchModel.ApprovalGroupTypesEnum.PURCHASING
  ],
  [
    3,
    ApprovalGroupSearchModel.ApprovalGroupTypesEnum.TIMEANDEXPENSE
  ],
  [
    4,
    ApprovalGroupSearchModel.ApprovalGroupTypesEnum.ACCOUNTSRECEIVABLE
  ]
]);
const toPlatformApprovalGroupSearch = (query) => ({
  ...query,
  approvalGroupTypes: query.approvalGroupTypes && query.approvalGroupTypes.length > 0 ? query.approvalGroupTypes.map((type) => groupTypes.get(type)).filter(
    (t16) => t16 !== void 0
  ) : void 0
});
const fetchAllProjectSubmittersInApprovalGroup = async (approvalGroupId, pageSize2 = MAX_PLATFORM_PAGE_SIZE) => fetchAllItems({
  fetch: (page) => () => fetchProjectSubmittersForApprovalGroup(
    approvalGroupId,
    page,
    pageSize2
  )
});
var Role = /* @__PURE__ */ ((Role2) => {
  Role2["Administrator"] = "administrator";
  Role2["APAdmin"] = "apAdmin";
  Role2["APManager"] = "apManager";
  Role2["APManagerAlt"] = "apManager~";
  Role2["APPoster"] = "apPoster";
  Role2["APUser"] = "apUser";
  Role2["APViewer"] = "apViewer";
  Role2["ARAdmin"] = "arAdmin";
  Role2["ARPoster"] = "arPoster";
  Role2["ARUser"] = "arUser";
  Role2["AuditorUser"] = "auditorUser";
  Role2["BankReconciler"] = "bankReconciler";
  Role2["BillRateManager"] = "billRateManager";
  Role2["ContractManager"] = "contractManager";
  Role2["ContractManagerAlt"] = "contractManager~";
  Role2["ContractViewer"] = "contractViewer";
  Role2["ContractViewerAlt"] = "contractViewer~";
  Role2["CostRateManager"] = "costRateManager";
  Role2["Expense"] = "expenseUser";
  Role2["GLAdmin"] = "glAdmin";
  Role2["GLPoster"] = "glPoster";
  Role2["GLUser"] = "glUser";
  Role2["GLViewer"] = "glViewer";
  Role2["HRAdmin"] = "HRAdministrator";
  Role2["Manager"] = "manager";
  Role2["ManagerAlternate"] = "manager~";
  Role2["POAssigner"] = "purchaseOrderAssigner";
  Role2["POOwner"] = "poOwner";
  Role2["PostingManager"] = "postingManager";
  Role2["POViewer"] = "purchaseOrderViewer";
  Role2["PRAdministrator"] = "prAdministrator";
  Role2["ProjectLead"] = "projectLead";
  Role2["ProjectManager"] = "projectManager";
  Role2["ProjectViewer"] = "projectViewer";
  Role2["Purchaser"] = "purchaser";
  Role2["ReceiptUser"] = "receiptUser";
  Role2["ReceiptViewer"] = "receiptViewer";
  Role2["ResourceAssigner"] = "resourceAssigner";
  Role2["ResourcePlanner"] = "resourcePlanner";
  Role2["Timesheet"] = "timesheetUser";
  Role2["TimesheetUserAlternate"] = "timesheetUser~";
  Role2["TimesheetAdmin"] = "tsAdmin";
  Role2["TimesheetSpecialist"] = "tsSpecialist";
  Role2["UnaSourceUser"] = "unaSourceUser";
  Role2["ViUser"] = "viUser";
  return Role2;
})(Role || {});
const emptySession = () => ({
  token: [],
  customerId: "",
  userKey: -1,
  username: "",
  roles: []
});
const validSession = (tokenModel) => Object.assign(emptySession(), tokenModel, {
  token: tokenModel.token?.split("")
});
const hasRole = (me2, role) => (me2?.roles ?? []).map((r12) => r12.toLowerCase()).includes(
  role.toLowerCase() || "administrator"
  /* Administrator */
);
const _PENDO_EXCLUDED_ROLES = new Set(
  [
    "expenseUser",
    "timesheetUser",
    "unaSourceUser"
    /* UnaSourceUser */
  ].map((r12) => r12.toLowerCase())
);
const isPendoExcludedUser = (me2) => {
  const roles = me2?.roles ?? [];
  if (roles.length === 0) {
    return false;
  }
  return roles.every((role) => _PENDO_EXCLUDED_ROLES.has(role.toLowerCase()));
};
const toAlternateRole = (role) => {
  return role.endsWith("~") ? role : role + "~";
};
const addAlternateRoles = (me2, alternates) => {
  const alternateRoles = alternates.map((a) => a.roles ?? []).flat().map((role) => toAlternateRole(role.code ?? ""));
  me2.roles = uniq([...me2.roles ?? [], ...alternateRoles]);
};
var INT_ROLES = /* @__PURE__ */ ((INT_ROLES2) => {
  INT_ROLES2[INT_ROLES2["Administrator"] = 1] = "Administrator";
  INT_ROLES2[INT_ROLES2["Purchaser"] = 45] = "Purchaser";
  INT_ROLES2[INT_ROLES2["PoOwner"] = 54] = "PoOwner";
  INT_ROLES2[INT_ROLES2["ReceiptUser"] = 64] = "ReceiptUser";
  INT_ROLES2[INT_ROLES2["ReceiptViewer"] = 65] = "ReceiptViewer";
  return INT_ROLES2;
})(INT_ROLES || {});
const DEFAULT_PERSON_CLASSIFICATION = SchedulingPersonSearchModel.ClassificationEnum.EXEMPT;
const PERSON_CLASSIFICATIONS_KEY_NAME = Object.entries(SchedulingPersonSearchModel.ClassificationEnum).map(
  ([k, v], i, arr) => ({ key: v, name: v })
);
const PERSON_CLASSIFICATIONS_KEY_CODE_NAME = Object.entries(SchedulingPersonSearchModel.ClassificationEnum).map(
  ([k, v], i, arr) => ({ key: v, code: v, name: v })
);
const emptyPersonSummary = () => ({
  key: -1,
  username: "",
  firstName: "",
  middleInitial: "",
  lastName: "",
  suffix: "",
  email: "",
  activationPending: false,
  active: false
});
const fromPersonBaseModel = (ts2) => ({
  key: ts2.key,
  username: ts2.username || "",
  firstName: ts2.firstName || "",
  middleInitial: ts2.middleInitial || "",
  lastName: ts2.lastName || "",
  suffix: ts2.suffix || "",
  email: ts2.email || "",
  activationPending: !!ts2.activationPending,
  active: !!ts2.active
});
const fromPersonBaseModelOrEmpty = (ts2) => ts2 ? fromPersonBaseModel(ts2) : emptyPersonSummary();
const timeEntryIncrementList = [
  { key: 0.01, name: "1/100 hr" },
  { key: 0.05, name: "1/20 hr" },
  { key: 0.1, name: "1/10 hour" },
  { key: 0.25, name: "1/4 hour" },
  { key: 0.5, name: "1/2 hour" },
  { key: 1, name: "1 hour" },
  { key: 4, name: "4 hour" },
  { key: 8, name: "8 hour" }
];
class Person {
  constructor(values2 = {}) {
    this.key = -1;
    this.username = "";
    this.firstName = "";
    this.lastName = "";
    this.email = "";
    this.active = true;
    this.activationPending = false;
    this.timeEntryIncrement = 0.01;
    this.roles = [];
    this.udfs = [];
    this.approverFor = null;
    this.assign(values2);
  }
  assign(values2) {
    Object.assign(this, omit$1(values2, ["udfs"]));
    const keys2 = Object.keys(this);
    for (const key of keys2) {
      if (this[key] === null) {
        delete this[key];
      }
    }
    this.hireDate = values2.hireDate ? DateTime.fromISO(values2.hireDate, { zone: "utc" }) : void 0;
    if (values2.udfs?.values) {
      this.udfs = values2.udfs?.values;
    }
    if (Array.isArray(values2.udfs)) {
      this.udfs = values2.udfs;
    }
  }
  get displayName() {
    return `${this.lastName}, ${this.firstName}`;
  }
  get fullDisplayName() {
    return Person.fullDisplayName(this);
  }
  static fullDisplayName(p) {
    const name = `${p.lastName ?? ""}, ${p.firstName ?? ""} ${p.middleInitial ?? ""}${p.suffix ? `, ${p.suffix}` : ""}`;
    return name.trim().replace(/ +/g, " ");
  }
  /**
   * Defaults: suffix = true, middleInitial = true, username = false
   */
  static fullName(person, { suffix = true, middleInitial = true, username = false } = {}) {
    const parts = [];
    if (person.firstName) {
      parts.push(person.firstName);
    }
    if (person.middleInitial && middleInitial) {
      parts.push(person.middleInitial);
    }
    if (person.lastName) {
      parts.push(person.lastName);
    }
    if (person.suffix && suffix) {
      parts.push(person.suffix);
    }
    if (person.username && username) {
      parts.push(`(${person.username.toLowerCase()})`);
    }
    return parts.join(" ");
  }
  get fullName() {
    return Person.fullName(this);
  }
  get status() {
    if (this.activationPending) {
      return "pending";
    } else {
      return this.active ? "active" : "inactive";
    }
  }
  set status(value) {
    if (value === "pending") {
      this.activationPending = true;
      this.active = false;
    } else if (value === "active") {
      delete this.activationPending;
      this.active = true;
    } else {
      this.activationPending = false;
      this.active = false;
    }
  }
  get isManager() {
    return !!this.roles && this.roles.some((r12) => r12 === Role.Manager);
  }
  get isHRAdmin() {
    return !!this.roles && this.roles.some((r12) => r12 === Role.HRAdmin);
  }
  get isPowerUser() {
    return this.isHRAdmin || this.isManager;
  }
}
const lastNameFirstNameWithUsername = (person) => {
  if (!person) {
    return "";
  }
  if (person?.name) {
    return person.name;
  }
  return `${person?.lastName ? `${person?.lastName},` : ""} ${person?.firstName ?? ""} ${person?.username ? `(${person?.username.toLowerCase()})` : ""}`;
};
const searchAssignedTimeMatrix = async (params) => {
  try {
    const result = await searchAssignedTimeMatrix$1(params);
    return result.entries ?? [];
  } catch (e) {
    log.warn({
      msg: "Searching assigned time matrix data failed",
      error: `${e}`
    });
    throw e;
  }
};
const searchAssignedTimePeopleAllocation = async (params) => {
  try {
    const result = await searchAssignedTimePeopleAllocation$1(params);
    return result.people ?? [];
  } catch (e) {
    log.warn({
      msg: "Searching assigned time people allocation data failed",
      error: `${e}`
    });
    throw e;
  }
};
const searchAllAssignedTimePeople = async ({
  params,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const items = await fetchAllItems({
    errorMessage: "Searching and returning all assigned time people failed",
    fetch: (page) => () => searchAssignedTimePeople({ params, page, pageSize: pageSize2 })
  });
  return items.map((ci) => new Person(ci));
};
const searchAssignedTimePeople = async ({
  params,
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    const results = await searchAssignedTimePeople$1({
      requestBody: params,
      page,
      pageSize: pageSize2
    });
    return mapListPage(results, (item) => new Person(item));
  } catch (e) {
    log.warn({
      msg: "Searching assigned people failed",
      error: `${e}`
    });
    throw e;
  }
};
const searchAllAssignedTimeProjects = async ({
  params = {},
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  errorMessage: "Searching and returning all assigned time projects failed",
  fetch: (page) => () => searchAssignedTimeProjects({ page, pageSize: pageSize2, params })
});
const searchAssignedTimeProjects = async ({
  params = {},
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    return await searchAssignedTimeProjects$1({
      requestBody: params,
      page,
      pageSize: pageSize2
    });
  } catch (e) {
    log.warn({
      msg: "Searching assigned time projects failed",
      error: `${e}`
    });
    throw e;
  }
};
const createAssignedTimeSaveCriteria = async (params) => {
  try {
    return await createAssignedTimeSaveCriteria$1(params);
  } catch (e) {
    log.warn({
      msg: "Saving assigned time save criteria failed",
      error: `${e}`
    });
    throw e;
  }
};
const createAssignedTimeSharedSaveCriteria = async (requestBody) => {
  try {
    return await createAssignedTimeSharedSaveCriteria$1(requestBody);
  } catch (e) {
    log.warn({
      msg: "Saving assigned time shared save criteria failed",
      error: `${e}`
    });
    throw e;
  }
};
const deleteAssignedTimeSaveCriteria = async (id) => {
  try {
    await deleteAssignedTimeSaveCriteria$1(id);
    return { key: id };
  } catch (e) {
    log.warn({
      msg: `Deleting assigned time save criteria for id: ${id} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteAssignedTimeSharedSaveCriteria = async (id) => {
  try {
    await deleteAssignedTimeSharedSaveCriteria$1(id);
    return { key: id };
  } catch (e) {
    log.warn({
      msg: `Deleting assigned time shared save criteria for id: ${id} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const getAllAssignedTimePersonOrganizations = async ({
  code,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  projectKey
}) => fetchAllItems({
  errorMessage: "Getting all assigned time person organizations failed",
  fetch: (page) => () => getAssignedTimePersonOrganizations({ code, page, pageSize: pageSize2, projectKey })
});
const getAssignedTimePersonOrganizations = async ({
  code,
  projectKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    return await getAssignedTimePersonOrganizations$1({
      code,
      projectKey,
      page,
      pageSize: pageSize2
    });
  } catch (e) {
    log.warn({
      msg: "Getting assigned time person organizations failed",
      error: `${e}`
    });
    throw e;
  }
};
const getAllAssignedTimeProjectOrganizations = async ({
  code,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  fetch: (page) => () => getAssignedTimeProjectOrganizations({ code, page, pageSize: pageSize2 })
});
const getAssignedTimeProjectOrganizations = async ({
  code,
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    return await getAssignedTimeProjectOrganizations$1({
      code,
      page,
      pageSize: pageSize2
    });
  } catch (e) {
    log.warn({
      msg: "Getting assigned time project organizations failed",
      error: `${e}`
    });
    throw e;
  }
};
const getAllAssignedTimeSaveCriteria = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const items = await fetchAllItems({
    errorMessage: "Searching and returning all assigned time save criteria failed",
    fetch: (page) => () => getAssignedTimeSaveCriteria({ page, pageSize: pageSize2 })
  });
  return items.map((item) => ({ ...item, shared: false }));
};
const getAllAssignedTimeSharedSaveCriteria = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const items = await fetchAllItems({
    errorMessage: "Searching and returning all assigned shared save criteria failed",
    fetch: (page) => () => getAssignedTimeSharedSaveCriteria({ page, pageSize: pageSize2 })
  });
  return items.map((item) => ({ ...item, shared: true }));
};
const getAssignedTimeSaveCriteria = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    return await getAssignedTimeSaveCriteria$1({ page, pageSize: pageSize2 });
  } catch (e) {
    log.warn({
      msg: "Getting assigned time save criteria failed",
      error: `${e}`
    });
    throw e;
  }
};
const getAssignedTimeSharedSaveCriteria = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    return await getAssignedTimeSharedSaveCriteria$1({
      page,
      pageSize: pageSize2
    });
  } catch (e) {
    log.warn({
      msg: "Getting assigned time shared save criteria failed",
      error: `${e}`
    });
    throw e;
  }
};
const getProjectAssignmentDefaults = async ({
  projectKey,
  personKey,
  date
}) => {
  try {
    return await getProjectAssignmentDefaults$1({
      projectKey,
      personKey,
      date
    });
  } catch (e) {
    log.warn({
      msg: "Getting assignment defaults failed",
      error: `${e}`
    });
    throw e;
  }
};
const updateAssignedTimeSaveCriteria = async (params) => {
  try {
    await updateAssignedTimeSaveCriteria$1(params);
    return { key: params.id };
  } catch (e) {
    log.warn({
      msg: `Updating assigned time save criteria for id: ${params.id} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const updateAssignedTimeSharedSaveCriteria = async (params) => {
  try {
    await updateAssignedTimeSharedSaveCriteria$1(params);
    return { key: params.id };
  } catch (e) {
    log.warn({
      msg: `Updating assigned time sahred save criteria for id: ${params.id} failed`,
      error: `${e}`
    });
    throw e;
  }
};
var AuditLogCategoryType = /* @__PURE__ */ ((AuditLogCategoryType2) => {
  AuditLogCategoryType2["ACCOUNTS"] = "accounts";
  AuditLogCategoryType2["APPROVAL_GROUPS"] = "approval_groups";
  AuditLogCategoryType2["BANK_ACCOUNTS"] = "bank_accounts";
  AuditLogCategoryType2["BANK_RECONCILIATIONS"] = "bank_reconciliations";
  AuditLogCategoryType2["BUDGETS"] = "budgets";
  AuditLogCategoryType2["CONTRACT_FUNDING"] = "contract_funding";
  AuditLogCategoryType2["CONTRACTS"] = "contracts";
  AuditLogCategoryType2["COST_POOLS"] = "cost_pools";
  AuditLogCategoryType2["CUSTOMER_PAYMENTS_DEPOSITS"] = "customer_payments_deposits";
  AuditLogCategoryType2["FISCAL_YEAR"] = "fiscal_year";
  AuditLogCategoryType2["FIXED_ASSETS"] = "fixed_assets";
  AuditLogCategoryType2["IMPORT_EXPORT_ACCESS"] = "import_export_access";
  AuditLogCategoryType2["INVOICING"] = "invoicing";
  AuditLogCategoryType2["ITEMS"] = "items";
  AuditLogCategoryType2["JOURNAL_ENTRIES"] = "journal_entries";
  AuditLogCategoryType2["ORGANIZATIONS"] = "organizations";
  AuditLogCategoryType2["PAY_CODES"] = "pay_codes";
  AuditLogCategoryType2["PEOPLE"] = "people";
  AuditLogCategoryType2["PEOPLE_ASSIGNMENTS"] = "people_assignments";
  AuditLogCategoryType2["PLAN_SETS"] = "plan_sets";
  AuditLogCategoryType2["POSTING_OPTIONS"] = "posting_options";
  AuditLogCategoryType2["PROJECTS"] = "projects";
  AuditLogCategoryType2["TASKS"] = "tasks";
  AuditLogCategoryType2["SKILLS"] = "skills";
  AuditLogCategoryType2["SYSTEM_PROPERTIES"] = "system_properties";
  AuditLogCategoryType2["UOM"] = "uom";
  AuditLogCategoryType2["VENDOR_INVOICE"] = "vendor_invoice";
  AuditLogCategoryType2["VENDOR_PAYMENTS"] = "vendor_payments";
  AuditLogCategoryType2["WAGE_DETERMINATION"] = "wage_determination";
  return AuditLogCategoryType2;
})(AuditLogCategoryType || {});
const auditLogCategoryMap = {
  [
    "accounts"
    /* ACCOUNTS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.ACCOUNTS
  ],
  [
    "approval_groups"
    /* APPROVAL_GROUPS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.APPROVALGROUPS
  ],
  [
    "bank_accounts"
    /* BANK_ACCOUNTS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.BANKACCOUNTS
  ],
  [
    "bank_reconciliations"
    /* BANK_RECONCILIATIONS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.BANKRECONCILIATION
  ],
  [
    "budgets"
    /* BUDGETS */
  ]: [AuditDataSearchModel.CategoriesEnum.BUDGETS],
  [
    "contract_funding"
    /* CONTRACT_FUNDING */
  ]: [
    AuditDataSearchModel.CategoriesEnum.CONTRACTFUNDING
  ],
  [
    "contracts"
    /* CONTRACTS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.CONTRACTS
  ],
  [
    "customer_payments_deposits"
    /* CUSTOMER_PAYMENTS_DEPOSITS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.CUSTOMERPAYMENTS,
    AuditDataSearchModel.CategoriesEnum.DEPOSITS
  ],
  [
    "cost_pools"
    /* COST_POOLS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.COSTPOOLS
  ],
  [
    "fiscal_year"
    /* FISCAL_YEAR */
  ]: [
    AuditDataSearchModel.CategoriesEnum.FISCALYEAR
  ],
  [
    "fixed_assets"
    /* FIXED_ASSETS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.FIXEDASSETS
  ],
  [
    "import_export_access"
    /* IMPORT_EXPORT_ACCESS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.IMPORTEXPORTACCESS
  ],
  [
    "invoicing"
    /* INVOICING */
  ]: [
    AuditDataSearchModel.CategoriesEnum.INVOICING
  ],
  [
    "items"
    /* ITEMS */
  ]: [AuditDataSearchModel.CategoriesEnum.ITEMS],
  [
    "journal_entries"
    /* JOURNAL_ENTRIES */
  ]: [
    AuditDataSearchModel.CategoriesEnum.JOURNALENTRIES
  ],
  [
    "organizations"
    /* ORGANIZATIONS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.ORGANIZATIONS,
    AuditDataSearchModel.CategoriesEnum.VENDORS
  ],
  [
    "pay_codes"
    /* PAY_CODES */
  ]: [
    AuditDataSearchModel.CategoriesEnum.PAYCODES
  ],
  [
    "people"
    /* PEOPLE */
  ]: [AuditDataSearchModel.CategoriesEnum.PEOPLE],
  [
    "people_assignments"
    /* PEOPLE_ASSIGNMENTS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.PEOPLEASSIGNMENTS
  ],
  [
    "plan_sets"
    /* PLAN_SETS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.PLANSETS
  ],
  [
    "posting_options"
    /* POSTING_OPTIONS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.POSTINGOPTIONS
  ],
  [
    "projects"
    /* PROJECTS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.PROJECTS
  ],
  [
    "skills"
    /* SKILLS */
  ]: [AuditDataSearchModel.CategoriesEnum.SKILLS],
  [
    "system_properties"
    /* SYSTEM_PROPERTIES */
  ]: [
    AuditDataSearchModel.CategoriesEnum.SYSTEMPROPERTIES
  ],
  [
    "tasks"
    /* TASKS */
  ]: [AuditDataSearchModel.CategoriesEnum.TASKS],
  [
    "uom"
    /* UOM */
  ]: [AuditDataSearchModel.CategoriesEnum.UOM],
  [
    "vendor_invoice"
    /* VENDOR_INVOICE */
  ]: [
    AuditDataSearchModel.CategoriesEnum.VENDORINVOICE
  ],
  [
    "vendor_payments"
    /* VENDOR_PAYMENTS */
  ]: [
    AuditDataSearchModel.CategoriesEnum.VENDORPAYMENTS
  ],
  [
    "wage_determination"
    /* WAGE_DETERMINATION */
  ]: [
    AuditDataSearchModel.CategoriesEnum.WAGEDETERMINATION
  ]
};
const toAuditLogDownloadBody = ({
  category,
  endDate,
  personKeys,
  startDate,
  updateSuppressionType
}) => {
  const categories = auditLogCategoryMap[category];
  return {
    categories,
    range: {
      rangeStart: startDate.toISODate() ?? BOTKey$1,
      rangeEnd: endDate.toISODate() ?? EOTKey$1
    },
    personKeys,
    updateSuppressionType
  };
};
const downloadAuditLogs = async (request2) => {
  try {
    const body = toAuditLogDownloadBody(request2);
    const { results: logs, headers } = await downloadAuditLogs$1(body);
    const md5 = headers.get("x-una-file-hash-md5") ?? "";
    return { logs, md5 };
  } catch (e) {
    log.warn({ msg: "Error downloading Audit Logs" });
    throw e;
  }
};
var License = /* @__PURE__ */ ((License2) => {
  License2["BankFeeds"] = "bankfeeds";
  License2["Costing"] = "costing";
  License2["Financials"] = "financials";
  License2["Purchasing"] = "purchasing";
  License2["Unasource"] = "unasource";
  License2["Unatime"] = "unatime";
  License2["ViAutomation"] = "viautomation";
  return License2;
})(License || {});
const hasLicense = (licenses, license) => licenses.map((l2) => l2.toLowerCase()).includes(license.toLowerCase());
function isAuthorized(tokenModel) {
  if (tokenModel.subcontractor) {
    return false;
  }
  return true;
}
const login = async (customerId, username, password) => {
  try {
    const tokenModel = await login$1(customerId, username, password);
    if (!isAuthorized(tokenModel)) {
      throw new Error(ErrorCode.Unauthorized);
    }
    return validSession(tokenModel);
  } catch (e) {
    log.warn({ msg: "Login failed", username, customerId });
    throw new AppError("Login failed", ErrorCode.Unauthorized, {
      customerId,
      username
    });
  }
};
const refresh = async () => {
  try {
    const tokenModel = await refresh$1();
    return validSession(tokenModel);
  } catch (e) {
    log.warn({ msg: "Token refresh failed" });
    throw new AppError("Token refresh failed", ErrorCode.Unauthorized);
  }
};
const getBusinessWeek = async (key) => {
  const businessWeek = await getBusinessWeek$1(key);
  return businessWeek;
};
const getAllBusinessWeeks = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  errorMessage: "Getting all business weeks failed",
  fetch: (page) => () => getBusinessWeeks(page, pageSize2)
});
const fromCalendarRangeModel = (r12) => ({
  id: r12.id,
  name: r12.name ?? "",
  beginDate: DateTime.fromISO(r12.beginDate ?? BOTKey$1),
  endDate: DateTime.fromISO(r12.endDate ?? EOTKey$1)
});
const getAllFiscalYears = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  errorMessage: "Getting all fiscal years failed",
  fetch: (page) => () => getFiscalYears({ page, pageSize: pageSize2 })
});
const getFiscalYearBreakdown = async (id, page = 1, pageSize2 = 50) => getFiscalYearBreakdown$1({ id, page, pageSize: pageSize2 });
const getCalendarRanges = async (startDate = DateTime.local()) => {
  const ranges = await getCalendarRanges$1(startDate);
  return ranges.map(fromCalendarRangeModel);
};
const getAllChangeReasons = ({
  timesheetKey
} = {}) => fetchAllItems({
  fetch: (page) => () => getChangeReasons({ page, timesheetKey }),
  errorMessage: "Fetching all change reasons failed"
});
var LinkType = /* @__PURE__ */ ((LinkType2) => {
  LinkType2["HOW_TO"] = "How To";
  LinkType2["TIPS"] = "Tips";
  return LinkType2;
})(LinkType || {});
const fetchContextualHelpArticles = async ({
  baseUrl,
  linkType,
  linkId
}) => {
  const url2 = `${baseUrl}/articles/`;
  try {
    const response = await fetch(url2, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ criteria: { linkType, linkId } })
    });
    if (response.ok) {
      const { items } = await response.json();
      return items;
    } else {
      const errorMessage = await response.text();
      throw new Error(errorMessage);
    }
  } catch (e) {
    log.warn({
      msg: `Error fetching ${linkType} articles for dashboard '${linkId}'`,
      error: `${e}`,
      url: url2
    });
    throw e;
  }
};
const fetchAllContractAgencies = async ({
  active,
  errorMessage,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  fetch: (page) => () => fetchContractAgencies({ active, page, pageSize: pageSize2 }),
  errorMessage
});
const createAgencyCode = async (requestBody) => {
  try {
    return await createAgencyCode$1(requestBody);
  } catch (e) {
    log.warn({
      msg: "Creating new agency code failed",
      error: `${e}`
    });
    throw e;
  }
};
const deleteAgencyCode = async (key) => {
  try {
    return await deleteAgencyCode$1(key);
  } catch (e) {
    log.warn({
      msg: `Deleting agency code failed (key: ${key})`,
      error: `${e}`
    });
    throw e;
  }
};
const editAgencyCode = async (requestBody) => {
  try {
    if (!requestBody.key) {
      throw new Error("Missing Agency Code key");
    }
    await editAgencyCode$1(requestBody);
    return { key: requestBody.key };
  } catch (e) {
    log.warn({
      msg: `Editing agency code failed (key: ${requestBody.key})`,
      error: `${e}`
    });
    throw e;
  }
};
var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var inited = false;
function init() {
  inited = true;
  var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  for (var i = 0, len = code.length; i < len; ++i) {
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
  }
  revLookup["-".charCodeAt(0)] = 62;
  revLookup["_".charCodeAt(0)] = 63;
}
function toByteArray(b64) {
  if (!inited) {
    init();
  }
  var i, j, l2, tmp, placeHolders, arr;
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error("Invalid string. Length must be a multiple of 4");
  }
  placeHolders = b64[len - 2] === "=" ? 2 : b64[len - 1] === "=" ? 1 : 0;
  arr = new Arr(len * 3 / 4 - placeHolders);
  l2 = placeHolders > 0 ? len - 4 : len;
  var L = 0;
  for (i = 0, j = 0; i < l2; i += 4, j += 3) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[L++] = tmp >> 16 & 255;
    arr[L++] = tmp >> 8 & 255;
    arr[L++] = tmp & 255;
  }
  if (placeHolders === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[L++] = tmp & 255;
  } else if (placeHolders === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[L++] = tmp >> 8 & 255;
    arr[L++] = tmp & 255;
  }
  return arr;
}
function tripletToBase64(num) {
  return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
}
function encodeChunk(uint8, start2, end2) {
  var tmp;
  var output = [];
  for (var i = start2; i < end2; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
    output.push(tripletToBase64(tmp));
  }
  return output.join("");
}
function fromByteArray(uint8) {
  if (!inited) {
    init();
  }
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3;
  var output = "";
  var parts = [];
  var maxChunkLength = 16383;
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    output += lookup[tmp >> 2];
    output += lookup[tmp << 4 & 63];
    output += "==";
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    output += lookup[tmp >> 10];
    output += lookup[tmp >> 4 & 63];
    output += lookup[tmp << 2 & 63];
    output += "=";
  }
  parts.push(output);
  return parts.join("");
}
function read$1(buffer2, offset2, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s12 = buffer2[offset2 + i];
  i += d;
  e = s12 & (1 << -nBits) - 1;
  s12 >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer2[offset2 + i], i += d, nBits -= 8) {
  }
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer2[offset2 + i], i += d, nBits -= 8) {
  }
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s12 ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s12 ? -1 : 1) * m * Math.pow(2, e - mLen);
}
function write$1(buffer2, value, offset2, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s12 = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);
  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer2[offset2 + i] = m & 255, i += d, m /= 256, mLen -= 8) {
  }
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer2[offset2 + i] = e & 255, i += d, e /= 256, eLen -= 8) {
  }
  buffer2[offset2 + i - d] |= s12 * 128;
}
var toString2 = {}.toString;
var isArray$1 = Array.isArray || function(arr) {
  return toString2.call(arr) == "[object Array]";
};
var INSPECT_MAX_BYTES = 50;
Buffer$1.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== void 0 ? global$1.TYPED_ARRAY_SUPPORT : true;
kMaxLength();
function kMaxLength() {
  return Buffer$1.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function createBuffer(that, length2) {
  if (kMaxLength() < length2) {
    throw new RangeError("Invalid typed array length");
  }
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    that = new Uint8Array(length2);
    that.__proto__ = Buffer$1.prototype;
  } else {
    if (that === null) {
      that = new Buffer$1(length2);
    }
    that.length = length2;
  }
  return that;
}
function Buffer$1(arg2, encodingOrOffset, length2) {
  if (!Buffer$1.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer$1)) {
    return new Buffer$1(arg2, encodingOrOffset, length2);
  }
  if (typeof arg2 === "number") {
    if (typeof encodingOrOffset === "string") {
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    }
    return allocUnsafe(this, arg2);
  }
  return from$1(this, arg2, encodingOrOffset, length2);
}
Buffer$1.poolSize = 8192;
Buffer$1._augment = function(arr) {
  arr.__proto__ = Buffer$1.prototype;
  return arr;
};
function from$1(that, value, encodingOrOffset, length2) {
  if (typeof value === "number") {
    throw new TypeError('"value" argument must not be a number');
  }
  if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length2);
  }
  if (typeof value === "string") {
    return fromString(that, value, encodingOrOffset);
  }
  return fromObject(that, value);
}
Buffer$1.from = function(value, encodingOrOffset, length2) {
  return from$1(null, value, encodingOrOffset, length2);
};
if (Buffer$1.TYPED_ARRAY_SUPPORT) {
  Buffer$1.prototype.__proto__ = Uint8Array.prototype;
  Buffer$1.__proto__ = Uint8Array;
  if (typeof Symbol !== "undefined" && Symbol.species && Buffer$1[Symbol.species] === Buffer$1) ;
}
function assertSize(size) {
  if (typeof size !== "number") {
    throw new TypeError('"size" argument must be a number');
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative');
  }
}
function alloc$1(that, size, fill3, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(that, size);
  }
  if (fill3 !== void 0) {
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill3, encoding) : createBuffer(that, size).fill(fill3);
  }
  return createBuffer(that, size);
}
Buffer$1.alloc = function(size, fill3, encoding) {
  return alloc$1(null, size, fill3, encoding);
};
function allocUnsafe(that, size) {
  assertSize(size);
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
  if (!Buffer$1.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that;
}
Buffer$1.allocUnsafe = function(size) {
  return allocUnsafe(null, size);
};
Buffer$1.allocUnsafeSlow = function(size) {
  return allocUnsafe(null, size);
};
function fromString(that, string2, encoding) {
  if (typeof encoding !== "string" || encoding === "") {
    encoding = "utf8";
  }
  if (!Buffer$1.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding');
  }
  var length2 = byteLength(string2, encoding) | 0;
  that = createBuffer(that, length2);
  var actual = that.write(string2, encoding);
  if (actual !== length2) {
    that = that.slice(0, actual);
  }
  return that;
}
function fromArrayLike(that, array) {
  var length2 = array.length < 0 ? 0 : checked(array.length) | 0;
  that = createBuffer(that, length2);
  for (var i = 0; i < length2; i += 1) {
    that[i] = array[i] & 255;
  }
  return that;
}
function fromArrayBuffer(that, array, byteOffset, length2) {
  array.byteLength;
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError("'offset' is out of bounds");
  }
  if (array.byteLength < byteOffset + (length2 || 0)) {
    throw new RangeError("'length' is out of bounds");
  }
  if (byteOffset === void 0 && length2 === void 0) {
    array = new Uint8Array(array);
  } else if (length2 === void 0) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length2);
  }
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    that = array;
    that.__proto__ = Buffer$1.prototype;
  } else {
    that = fromArrayLike(that, array);
  }
  return that;
}
function fromObject(that, obj) {
  if (internalIsBuffer(obj)) {
    var len = checked(obj.length) | 0;
    that = createBuffer(that, len);
    if (that.length === 0) {
      return that;
    }
    obj.copy(that, 0, 0, len);
    return that;
  }
  if (obj) {
    if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
      if (typeof obj.length !== "number" || isnan(obj.length)) {
        return createBuffer(that, 0);
      }
      return fromArrayLike(that, obj);
    }
    if (obj.type === "Buffer" && isArray$1(obj.data)) {
      return fromArrayLike(that, obj.data);
    }
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length2) {
  if (length2 >= kMaxLength()) {
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
  }
  return length2 | 0;
}
Buffer$1.isBuffer = isBuffer;
function internalIsBuffer(b) {
  return !!(b != null && b._isBuffer);
}
Buffer$1.compare = function compare3(a, b) {
  if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
    throw new TypeError("Arguments must be Buffers");
  }
  if (a === b) return 0;
  var x = a.length;
  var y = b.length;
  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};
Buffer$1.isEncoding = function isEncoding2(encoding) {
  switch (String(encoding).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return true;
    default:
      return false;
  }
};
Buffer$1.concat = function concat2(list2, length2) {
  if (!isArray$1(list2)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }
  if (list2.length === 0) {
    return Buffer$1.alloc(0);
  }
  var i;
  if (length2 === void 0) {
    length2 = 0;
    for (i = 0; i < list2.length; ++i) {
      length2 += list2[i].length;
    }
  }
  var buffer2 = Buffer$1.allocUnsafe(length2);
  var pos = 0;
  for (i = 0; i < list2.length; ++i) {
    var buf = list2[i];
    if (!internalIsBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    buf.copy(buffer2, pos);
    pos += buf.length;
  }
  return buffer2;
};
function byteLength(string2, encoding) {
  if (internalIsBuffer(string2)) {
    return string2.length;
  }
  if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string2) || string2 instanceof ArrayBuffer)) {
    return string2.byteLength;
  }
  if (typeof string2 !== "string") {
    string2 = "" + string2;
  }
  var len = string2.length;
  if (len === 0) return 0;
  var loweredCase = false;
  for (; ; ) {
    switch (encoding) {
      case "ascii":
      case "latin1":
      case "binary":
        return len;
      case "utf8":
      case "utf-8":
      case void 0:
        return utf8ToBytes(string2).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return len * 2;
      case "hex":
        return len >>> 1;
      case "base64":
        return base64ToBytes(string2).length;
      default:
        if (loweredCase) return utf8ToBytes(string2).length;
        encoding = ("" + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer$1.byteLength = byteLength;
function slowToString(encoding, start2, end2) {
  var loweredCase = false;
  if (start2 === void 0 || start2 < 0) {
    start2 = 0;
  }
  if (start2 > this.length) {
    return "";
  }
  if (end2 === void 0 || end2 > this.length) {
    end2 = this.length;
  }
  if (end2 <= 0) {
    return "";
  }
  end2 >>>= 0;
  start2 >>>= 0;
  if (end2 <= start2) {
    return "";
  }
  if (!encoding) encoding = "utf8";
  while (true) {
    switch (encoding) {
      case "hex":
        return hexSlice(this, start2, end2);
      case "utf8":
      case "utf-8":
        return utf8Slice(this, start2, end2);
      case "ascii":
        return asciiSlice(this, start2, end2);
      case "latin1":
      case "binary":
        return latin1Slice(this, start2, end2);
      case "base64":
        return base64Slice(this, start2, end2);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return utf16leSlice(this, start2, end2);
      default:
        if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
        encoding = (encoding + "").toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer$1.prototype._isBuffer = true;
function swap(b, n12, m) {
  var i = b[n12];
  b[n12] = b[m];
  b[m] = i;
}
Buffer$1.prototype.swap16 = function swap162() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};
Buffer$1.prototype.swap32 = function swap322() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};
Buffer$1.prototype.swap64 = function swap642() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};
Buffer$1.prototype.toString = function toString3() {
  var length2 = this.length | 0;
  if (length2 === 0) return "";
  if (arguments.length === 0) return utf8Slice(this, 0, length2);
  return slowToString.apply(this, arguments);
};
Buffer$1.prototype.equals = function equals2(b) {
  if (!internalIsBuffer(b)) throw new TypeError("Argument must be a Buffer");
  if (this === b) return true;
  return Buffer$1.compare(this, b) === 0;
};
Buffer$1.prototype.inspect = function inspect2() {
  var str = "";
  var max2 = INSPECT_MAX_BYTES;
  if (this.length > 0) {
    str = this.toString("hex", 0, max2).match(/.{2}/g).join(" ");
    if (this.length > max2) str += " ... ";
  }
  return "<Buffer " + str + ">";
};
Buffer$1.prototype.compare = function compare4(target, start2, end2, thisStart, thisEnd) {
  if (!internalIsBuffer(target)) {
    throw new TypeError("Argument must be a Buffer");
  }
  if (start2 === void 0) {
    start2 = 0;
  }
  if (end2 === void 0) {
    end2 = target ? target.length : 0;
  }
  if (thisStart === void 0) {
    thisStart = 0;
  }
  if (thisEnd === void 0) {
    thisEnd = this.length;
  }
  if (start2 < 0 || end2 > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError("out of range index");
  }
  if (thisStart >= thisEnd && start2 >= end2) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start2 >= end2) {
    return 1;
  }
  start2 >>>= 0;
  end2 >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;
  if (this === target) return 0;
  var x = thisEnd - thisStart;
  var y = end2 - start2;
  var len = Math.min(x, y);
  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start2, end2);
  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};
function bidirectionalIndexOf(buffer2, val, byteOffset, encoding, dir) {
  if (buffer2.length === 0) return -1;
  if (typeof byteOffset === "string") {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 2147483647) {
    byteOffset = 2147483647;
  } else if (byteOffset < -2147483648) {
    byteOffset = -2147483648;
  }
  byteOffset = +byteOffset;
  if (isNaN(byteOffset)) {
    byteOffset = dir ? 0 : buffer2.length - 1;
  }
  if (byteOffset < 0) byteOffset = buffer2.length + byteOffset;
  if (byteOffset >= buffer2.length) {
    if (dir) return -1;
    else byteOffset = buffer2.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;
    else return -1;
  }
  if (typeof val === "string") {
    val = Buffer$1.from(val, encoding);
  }
  if (internalIsBuffer(val)) {
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer2, val, byteOffset, encoding, dir);
  } else if (typeof val === "number") {
    val = val & 255;
    if (Buffer$1.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer2, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer2, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer2, [val], byteOffset, encoding, dir);
  }
  throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;
  if (encoding !== void 0) {
    encoding = String(encoding).toLowerCase();
    if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }
  function read2(buf, i12) {
    if (indexSize === 1) {
      return buf[i12];
    } else {
      return buf.readUInt16BE(i12 * indexSize);
    }
  }
  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read2(arr, i) === read2(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read2(arr, i + j) !== read2(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }
  return -1;
}
Buffer$1.prototype.includes = function includes2(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer$1.prototype.indexOf = function indexOf2(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer$1.prototype.lastIndexOf = function lastIndexOf2(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string2, offset2, length2) {
  offset2 = Number(offset2) || 0;
  var remaining = buf.length - offset2;
  if (!length2) {
    length2 = remaining;
  } else {
    length2 = Number(length2);
    if (length2 > remaining) {
      length2 = remaining;
    }
  }
  var strLen = string2.length;
  if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
  if (length2 > strLen / 2) {
    length2 = strLen / 2;
  }
  for (var i = 0; i < length2; ++i) {
    var parsed = parseInt(string2.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i;
    buf[offset2 + i] = parsed;
  }
  return i;
}
function utf8Write(buf, string2, offset2, length2) {
  return blitBuffer(utf8ToBytes(string2, buf.length - offset2), buf, offset2, length2);
}
function asciiWrite(buf, string2, offset2, length2) {
  return blitBuffer(asciiToBytes(string2), buf, offset2, length2);
}
function latin1Write(buf, string2, offset2, length2) {
  return asciiWrite(buf, string2, offset2, length2);
}
function base64Write(buf, string2, offset2, length2) {
  return blitBuffer(base64ToBytes(string2), buf, offset2, length2);
}
function ucs2Write(buf, string2, offset2, length2) {
  return blitBuffer(utf16leToBytes(string2, buf.length - offset2), buf, offset2, length2);
}
Buffer$1.prototype.write = function write2(string2, offset2, length2, encoding) {
  if (offset2 === void 0) {
    encoding = "utf8";
    length2 = this.length;
    offset2 = 0;
  } else if (length2 === void 0 && typeof offset2 === "string") {
    encoding = offset2;
    length2 = this.length;
    offset2 = 0;
  } else if (isFinite(offset2)) {
    offset2 = offset2 | 0;
    if (isFinite(length2)) {
      length2 = length2 | 0;
      if (encoding === void 0) encoding = "utf8";
    } else {
      encoding = length2;
      length2 = void 0;
    }
  } else {
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  }
  var remaining = this.length - offset2;
  if (length2 === void 0 || length2 > remaining) length2 = remaining;
  if (string2.length > 0 && (length2 < 0 || offset2 < 0) || offset2 > this.length) {
    throw new RangeError("Attempt to write outside buffer bounds");
  }
  if (!encoding) encoding = "utf8";
  var loweredCase = false;
  for (; ; ) {
    switch (encoding) {
      case "hex":
        return hexWrite(this, string2, offset2, length2);
      case "utf8":
      case "utf-8":
        return utf8Write(this, string2, offset2, length2);
      case "ascii":
        return asciiWrite(this, string2, offset2, length2);
      case "latin1":
      case "binary":
        return latin1Write(this, string2, offset2, length2);
      case "base64":
        return base64Write(this, string2, offset2, length2);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return ucs2Write(this, string2, offset2, length2);
      default:
        if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
        encoding = ("" + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};
Buffer$1.prototype.toJSON = function toJSON2() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function base64Slice(buf, start2, end2) {
  if (start2 === 0 && end2 === buf.length) {
    return fromByteArray(buf);
  } else {
    return fromByteArray(buf.slice(start2, end2));
  }
}
function utf8Slice(buf, start2, end2) {
  end2 = Math.min(buf.length, end2);
  var res = [];
  var i = start2;
  while (i < end2) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
    if (i + bytesPerSequence <= end2) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;
      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 128) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 192) === 128) {
            tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
            if (tempCodePoint > 127) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
            tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
            if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
            tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
            if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
              codePoint = tempCodePoint;
            }
          }
      }
    }
    if (codePoint === null) {
      codePoint = 65533;
      bytesPerSequence = 1;
    } else if (codePoint > 65535) {
      codePoint -= 65536;
      res.push(codePoint >>> 10 & 1023 | 55296);
      codePoint = 56320 | codePoint & 1023;
    }
    res.push(codePoint);
    i += bytesPerSequence;
  }
  return decodeCodePointsArray(res);
}
var MAX_ARGUMENTS_LENGTH = 4096;
function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints);
  }
  var res = "";
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    );
  }
  return res;
}
function asciiSlice(buf, start2, end2) {
  var ret = "";
  end2 = Math.min(buf.length, end2);
  for (var i = start2; i < end2; ++i) {
    ret += String.fromCharCode(buf[i] & 127);
  }
  return ret;
}
function latin1Slice(buf, start2, end2) {
  var ret = "";
  end2 = Math.min(buf.length, end2);
  for (var i = start2; i < end2; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}
function hexSlice(buf, start2, end2) {
  var len = buf.length;
  if (!start2 || start2 < 0) start2 = 0;
  if (!end2 || end2 < 0 || end2 > len) end2 = len;
  var out = "";
  for (var i = start2; i < end2; ++i) {
    out += toHex(buf[i]);
  }
  return out;
}
function utf16leSlice(buf, start2, end2) {
  var bytes = buf.slice(start2, end2);
  var res = "";
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}
Buffer$1.prototype.slice = function slice2(start2, end2) {
  var len = this.length;
  start2 = ~~start2;
  end2 = end2 === void 0 ? len : ~~end2;
  if (start2 < 0) {
    start2 += len;
    if (start2 < 0) start2 = 0;
  } else if (start2 > len) {
    start2 = len;
  }
  if (end2 < 0) {
    end2 += len;
    if (end2 < 0) end2 = 0;
  } else if (end2 > len) {
    end2 = len;
  }
  if (end2 < start2) end2 = start2;
  var newBuf;
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start2, end2);
    newBuf.__proto__ = Buffer$1.prototype;
  } else {
    var sliceLen = end2 - start2;
    newBuf = new Buffer$1(sliceLen, void 0);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start2];
    }
  }
  return newBuf;
};
function checkOffset(offset2, ext, length2) {
  if (offset2 % 1 !== 0 || offset2 < 0) throw new RangeError("offset is not uint");
  if (offset2 + ext > length2) throw new RangeError("Trying to access beyond buffer length");
}
Buffer$1.prototype.readUIntLE = function readUIntLE2(offset2, byteLength2, noAssert) {
  offset2 = offset2 | 0;
  byteLength2 = byteLength2 | 0;
  if (!noAssert) checkOffset(offset2, byteLength2, this.length);
  var val = this[offset2];
  var mul = 1;
  var i = 0;
  while (++i < byteLength2 && (mul *= 256)) {
    val += this[offset2 + i] * mul;
  }
  return val;
};
Buffer$1.prototype.readUIntBE = function readUIntBE2(offset2, byteLength2, noAssert) {
  offset2 = offset2 | 0;
  byteLength2 = byteLength2 | 0;
  if (!noAssert) {
    checkOffset(offset2, byteLength2, this.length);
  }
  var val = this[offset2 + --byteLength2];
  var mul = 1;
  while (byteLength2 > 0 && (mul *= 256)) {
    val += this[offset2 + --byteLength2] * mul;
  }
  return val;
};
Buffer$1.prototype.readUInt8 = function readUInt82(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 1, this.length);
  return this[offset2];
};
Buffer$1.prototype.readUInt16LE = function readUInt16LE2(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 2, this.length);
  return this[offset2] | this[offset2 + 1] << 8;
};
Buffer$1.prototype.readUInt16BE = function readUInt16BE2(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 2, this.length);
  return this[offset2] << 8 | this[offset2 + 1];
};
Buffer$1.prototype.readUInt32LE = function readUInt32LE2(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 4, this.length);
  return (this[offset2] | this[offset2 + 1] << 8 | this[offset2 + 2] << 16) + this[offset2 + 3] * 16777216;
};
Buffer$1.prototype.readUInt32BE = function readUInt32BE2(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 4, this.length);
  return this[offset2] * 16777216 + (this[offset2 + 1] << 16 | this[offset2 + 2] << 8 | this[offset2 + 3]);
};
Buffer$1.prototype.readIntLE = function readIntLE2(offset2, byteLength2, noAssert) {
  offset2 = offset2 | 0;
  byteLength2 = byteLength2 | 0;
  if (!noAssert) checkOffset(offset2, byteLength2, this.length);
  var val = this[offset2];
  var mul = 1;
  var i = 0;
  while (++i < byteLength2 && (mul *= 256)) {
    val += this[offset2 + i] * mul;
  }
  mul *= 128;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
  return val;
};
Buffer$1.prototype.readIntBE = function readIntBE2(offset2, byteLength2, noAssert) {
  offset2 = offset2 | 0;
  byteLength2 = byteLength2 | 0;
  if (!noAssert) checkOffset(offset2, byteLength2, this.length);
  var i = byteLength2;
  var mul = 1;
  var val = this[offset2 + --i];
  while (i > 0 && (mul *= 256)) {
    val += this[offset2 + --i] * mul;
  }
  mul *= 128;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
  return val;
};
Buffer$1.prototype.readInt8 = function readInt82(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 1, this.length);
  if (!(this[offset2] & 128)) return this[offset2];
  return (255 - this[offset2] + 1) * -1;
};
Buffer$1.prototype.readInt16LE = function readInt16LE2(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 2, this.length);
  var val = this[offset2] | this[offset2 + 1] << 8;
  return val & 32768 ? val | 4294901760 : val;
};
Buffer$1.prototype.readInt16BE = function readInt16BE2(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 2, this.length);
  var val = this[offset2 + 1] | this[offset2] << 8;
  return val & 32768 ? val | 4294901760 : val;
};
Buffer$1.prototype.readInt32LE = function readInt32LE2(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 4, this.length);
  return this[offset2] | this[offset2 + 1] << 8 | this[offset2 + 2] << 16 | this[offset2 + 3] << 24;
};
Buffer$1.prototype.readInt32BE = function readInt32BE2(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 4, this.length);
  return this[offset2] << 24 | this[offset2 + 1] << 16 | this[offset2 + 2] << 8 | this[offset2 + 3];
};
Buffer$1.prototype.readFloatLE = function readFloatLE2(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 4, this.length);
  return read$1(this, offset2, true, 23, 4);
};
Buffer$1.prototype.readFloatBE = function readFloatBE2(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 4, this.length);
  return read$1(this, offset2, false, 23, 4);
};
Buffer$1.prototype.readDoubleLE = function readDoubleLE2(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 8, this.length);
  return read$1(this, offset2, true, 52, 8);
};
Buffer$1.prototype.readDoubleBE = function readDoubleBE2(offset2, noAssert) {
  if (!noAssert) checkOffset(offset2, 8, this.length);
  return read$1(this, offset2, false, 52, 8);
};
function checkInt(buf, value, offset2, ext, max2, min2) {
  if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max2 || value < min2) throw new RangeError('"value" argument is out of bounds');
  if (offset2 + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer$1.prototype.writeUIntLE = function writeUIntLE2(value, offset2, byteLength2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  byteLength2 = byteLength2 | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength2) - 1;
    checkInt(this, value, offset2, byteLength2, maxBytes, 0);
  }
  var mul = 1;
  var i = 0;
  this[offset2] = value & 255;
  while (++i < byteLength2 && (mul *= 256)) {
    this[offset2 + i] = value / mul & 255;
  }
  return offset2 + byteLength2;
};
Buffer$1.prototype.writeUIntBE = function writeUIntBE2(value, offset2, byteLength2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  byteLength2 = byteLength2 | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength2) - 1;
    checkInt(this, value, offset2, byteLength2, maxBytes, 0);
  }
  var i = byteLength2 - 1;
  var mul = 1;
  this[offset2 + i] = value & 255;
  while (--i >= 0 && (mul *= 256)) {
    this[offset2 + i] = value / mul & 255;
  }
  return offset2 + byteLength2;
};
Buffer$1.prototype.writeUInt8 = function writeUInt82(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt(this, value, offset2, 1, 255, 0);
  if (!Buffer$1.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset2] = value & 255;
  return offset2 + 1;
};
function objectWriteUInt16(buf, value, offset2, littleEndian) {
  if (value < 0) value = 65535 + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset2, 2); i < j; ++i) {
    buf[offset2 + i] = (value & 255 << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
  }
}
Buffer$1.prototype.writeUInt16LE = function writeUInt16LE2(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt(this, value, offset2, 2, 65535, 0);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value & 255;
    this[offset2 + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset2, true);
  }
  return offset2 + 2;
};
Buffer$1.prototype.writeUInt16BE = function writeUInt16BE2(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt(this, value, offset2, 2, 65535, 0);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value >>> 8;
    this[offset2 + 1] = value & 255;
  } else {
    objectWriteUInt16(this, value, offset2, false);
  }
  return offset2 + 2;
};
function objectWriteUInt32(buf, value, offset2, littleEndian) {
  if (value < 0) value = 4294967295 + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset2, 4); i < j; ++i) {
    buf[offset2 + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 255;
  }
}
Buffer$1.prototype.writeUInt32LE = function writeUInt32LE2(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt(this, value, offset2, 4, 4294967295, 0);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset2 + 3] = value >>> 24;
    this[offset2 + 2] = value >>> 16;
    this[offset2 + 1] = value >>> 8;
    this[offset2] = value & 255;
  } else {
    objectWriteUInt32(this, value, offset2, true);
  }
  return offset2 + 4;
};
Buffer$1.prototype.writeUInt32BE = function writeUInt32BE2(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt(this, value, offset2, 4, 4294967295, 0);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value >>> 24;
    this[offset2 + 1] = value >>> 16;
    this[offset2 + 2] = value >>> 8;
    this[offset2 + 3] = value & 255;
  } else {
    objectWriteUInt32(this, value, offset2, false);
  }
  return offset2 + 4;
};
Buffer$1.prototype.writeIntLE = function writeIntLE2(value, offset2, byteLength2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength2 - 1);
    checkInt(this, value, offset2, byteLength2, limit - 1, -limit);
  }
  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset2] = value & 255;
  while (++i < byteLength2 && (mul *= 256)) {
    if (value < 0 && sub === 0 && this[offset2 + i - 1] !== 0) {
      sub = 1;
    }
    this[offset2 + i] = (value / mul >> 0) - sub & 255;
  }
  return offset2 + byteLength2;
};
Buffer$1.prototype.writeIntBE = function writeIntBE2(value, offset2, byteLength2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength2 - 1);
    checkInt(this, value, offset2, byteLength2, limit - 1, -limit);
  }
  var i = byteLength2 - 1;
  var mul = 1;
  var sub = 0;
  this[offset2 + i] = value & 255;
  while (--i >= 0 && (mul *= 256)) {
    if (value < 0 && sub === 0 && this[offset2 + i + 1] !== 0) {
      sub = 1;
    }
    this[offset2 + i] = (value / mul >> 0) - sub & 255;
  }
  return offset2 + byteLength2;
};
Buffer$1.prototype.writeInt8 = function writeInt82(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt(this, value, offset2, 1, 127, -128);
  if (!Buffer$1.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 255 + value + 1;
  this[offset2] = value & 255;
  return offset2 + 1;
};
Buffer$1.prototype.writeInt16LE = function writeInt16LE2(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt(this, value, offset2, 2, 32767, -32768);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value & 255;
    this[offset2 + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset2, true);
  }
  return offset2 + 2;
};
Buffer$1.prototype.writeInt16BE = function writeInt16BE2(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt(this, value, offset2, 2, 32767, -32768);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value >>> 8;
    this[offset2 + 1] = value & 255;
  } else {
    objectWriteUInt16(this, value, offset2, false);
  }
  return offset2 + 2;
};
Buffer$1.prototype.writeInt32LE = function writeInt32LE2(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt(this, value, offset2, 4, 2147483647, -2147483648);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value & 255;
    this[offset2 + 1] = value >>> 8;
    this[offset2 + 2] = value >>> 16;
    this[offset2 + 3] = value >>> 24;
  } else {
    objectWriteUInt32(this, value, offset2, true);
  }
  return offset2 + 4;
};
Buffer$1.prototype.writeInt32BE = function writeInt32BE2(value, offset2, noAssert) {
  value = +value;
  offset2 = offset2 | 0;
  if (!noAssert) checkInt(this, value, offset2, 4, 2147483647, -2147483648);
  if (value < 0) value = 4294967295 + value + 1;
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset2] = value >>> 24;
    this[offset2 + 1] = value >>> 16;
    this[offset2 + 2] = value >>> 8;
    this[offset2 + 3] = value & 255;
  } else {
    objectWriteUInt32(this, value, offset2, false);
  }
  return offset2 + 4;
};
function checkIEEE754(buf, value, offset2, ext, max2, min2) {
  if (offset2 + ext > buf.length) throw new RangeError("Index out of range");
  if (offset2 < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset2, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset2, 4);
  }
  write$1(buf, value, offset2, littleEndian, 23, 4);
  return offset2 + 4;
}
Buffer$1.prototype.writeFloatLE = function writeFloatLE2(value, offset2, noAssert) {
  return writeFloat(this, value, offset2, true, noAssert);
};
Buffer$1.prototype.writeFloatBE = function writeFloatBE2(value, offset2, noAssert) {
  return writeFloat(this, value, offset2, false, noAssert);
};
function writeDouble(buf, value, offset2, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset2, 8);
  }
  write$1(buf, value, offset2, littleEndian, 52, 8);
  return offset2 + 8;
}
Buffer$1.prototype.writeDoubleLE = function writeDoubleLE2(value, offset2, noAssert) {
  return writeDouble(this, value, offset2, true, noAssert);
};
Buffer$1.prototype.writeDoubleBE = function writeDoubleBE2(value, offset2, noAssert) {
  return writeDouble(this, value, offset2, false, noAssert);
};
Buffer$1.prototype.copy = function copy2(target, targetStart, start2, end2) {
  if (!start2) start2 = 0;
  if (!end2 && end2 !== 0) end2 = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end2 > 0 && end2 < start2) end2 = start2;
  if (end2 === start2) return 0;
  if (target.length === 0 || this.length === 0) return 0;
  if (targetStart < 0) {
    throw new RangeError("targetStart out of bounds");
  }
  if (start2 < 0 || start2 >= this.length) throw new RangeError("sourceStart out of bounds");
  if (end2 < 0) throw new RangeError("sourceEnd out of bounds");
  if (end2 > this.length) end2 = this.length;
  if (target.length - targetStart < end2 - start2) {
    end2 = target.length - targetStart + start2;
  }
  var len = end2 - start2;
  var i;
  if (this === target && start2 < targetStart && targetStart < end2) {
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start2];
    }
  } else if (len < 1e3 || !Buffer$1.TYPED_ARRAY_SUPPORT) {
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start2];
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start2, start2 + len),
      targetStart
    );
  }
  return len;
};
Buffer$1.prototype.fill = function fill2(val, start2, end2, encoding) {
  if (typeof val === "string") {
    if (typeof start2 === "string") {
      encoding = start2;
      start2 = 0;
      end2 = this.length;
    } else if (typeof end2 === "string") {
      encoding = end2;
      end2 = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== void 0 && typeof encoding !== "string") {
      throw new TypeError("encoding must be a string");
    }
    if (typeof encoding === "string" && !Buffer$1.isEncoding(encoding)) {
      throw new TypeError("Unknown encoding: " + encoding);
    }
  } else if (typeof val === "number") {
    val = val & 255;
  }
  if (start2 < 0 || this.length < start2 || this.length < end2) {
    throw new RangeError("Out of range index");
  }
  if (end2 <= start2) {
    return this;
  }
  start2 = start2 >>> 0;
  end2 = end2 === void 0 ? this.length : end2 >>> 0;
  if (!val) val = 0;
  var i;
  if (typeof val === "number") {
    for (i = start2; i < end2; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = internalIsBuffer(val) ? val : utf8ToBytes(new Buffer$1(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end2 - start2; ++i) {
      this[i + start2] = bytes[i % len];
    }
  }
  return this;
};
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
  str = stringtrim(str).replace(INVALID_BASE64_RE, "");
  if (str.length < 2) return "";
  while (str.length % 4 !== 0) {
    str = str + "=";
  }
  return str;
}
function stringtrim(str) {
  if (str.trim) return str.trim();
  return str.replace(/^\s+|\s+$/g, "");
}
function toHex(n12) {
  if (n12 < 16) return "0" + n12.toString(16);
  return n12.toString(16);
}
function utf8ToBytes(string2, units) {
  units = units || Infinity;
  var codePoint;
  var length2 = string2.length;
  var leadSurrogate = null;
  var bytes = [];
  for (var i = 0; i < length2; ++i) {
    codePoint = string2.charCodeAt(i);
    if (codePoint > 55295 && codePoint < 57344) {
      if (!leadSurrogate) {
        if (codePoint > 56319) {
          if ((units -= 3) > -1) bytes.push(239, 191, 189);
          continue;
        } else if (i + 1 === length2) {
          if ((units -= 3) > -1) bytes.push(239, 191, 189);
          continue;
        }
        leadSurrogate = codePoint;
        continue;
      }
      if (codePoint < 56320) {
        if ((units -= 3) > -1) bytes.push(239, 191, 189);
        leadSurrogate = codePoint;
        continue;
      }
      codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
    } else if (leadSurrogate) {
      if ((units -= 3) > -1) bytes.push(239, 191, 189);
    }
    leadSurrogate = null;
    if (codePoint < 128) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 2048) {
      if ((units -= 2) < 0) break;
      bytes.push(
        codePoint >> 6 | 192,
        codePoint & 63 | 128
      );
    } else if (codePoint < 65536) {
      if ((units -= 3) < 0) break;
      bytes.push(
        codePoint >> 12 | 224,
        codePoint >> 6 & 63 | 128,
        codePoint & 63 | 128
      );
    } else if (codePoint < 1114112) {
      if ((units -= 4) < 0) break;
      bytes.push(
        codePoint >> 18 | 240,
        codePoint >> 12 & 63 | 128,
        codePoint >> 6 & 63 | 128,
        codePoint & 63 | 128
      );
    } else {
      throw new Error("Invalid code point");
    }
  }
  return bytes;
}
function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    byteArray.push(str.charCodeAt(i) & 255);
  }
  return byteArray;
}
function utf16leToBytes(str, units) {
  var c, hi, lo2;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;
    c = str.charCodeAt(i);
    hi = c >> 8;
    lo2 = c % 256;
    byteArray.push(lo2);
    byteArray.push(hi);
  }
  return byteArray;
}
function base64ToBytes(str) {
  return toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset2, length2) {
  for (var i = 0; i < length2; ++i) {
    if (i + offset2 >= dst.length || i >= src.length) break;
    dst[i + offset2] = src[i];
  }
  return i;
}
function isnan(val) {
  return val !== val;
}
function isBuffer(obj) {
  return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj));
}
function isFastBuffer(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isFastBuffer(obj.slice(0, 0));
}
const charCodeOfDot = ".".charCodeAt(0);
const reEscapeChar = /\\(\\)?/g;
const rePropName = RegExp(
  // Match anything that isn't a dot or bracket.
  `[^.[\\]]+|\\[(?:([^"'][^[]*)|(["'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))`,
  "g"
);
const reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
const reIsPlainProp = /^\w*$/;
const getTag = function(value) {
  return Object.prototype.toString.call(value);
};
const isSymbol$1 = function(value) {
  const type = typeof value;
  return type === "symbol" || type === "object" && value && getTag(value) === "[object Symbol]";
};
const isKey = function(value, object) {
  if (Array.isArray(value)) {
    return false;
  }
  const type = typeof value;
  if (type === "number" || type === "symbol" || type === "boolean" || !value || isSymbol$1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
};
const stringToPath = function(string2) {
  const result = [];
  if (string2.charCodeAt(0) === charCodeOfDot) {
    result.push("");
  }
  string2.replace(rePropName, function(match2, expression, quote, subString) {
    let key = match2;
    if (quote) {
      key = subString.replace(reEscapeChar, "$1");
    } else if (expression) {
      key = expression.trim();
    }
    result.push(key);
  });
  return result;
};
const castPath = function(value, object) {
  if (Array.isArray(value)) {
    return value;
  } else {
    return isKey(value, object) ? [value] : stringToPath(value);
  }
};
const toKey = function(value) {
  if (typeof value === "string" || isSymbol$1(value)) return value;
  const result = `${value}`;
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
};
const get = function(object, path) {
  path = castPath(path, object);
  let index2 = 0;
  const length2 = path.length;
  while (object != null && index2 < length2) {
    object = object[toKey(path[index2++])];
  }
  return index2 && index2 === length2 ? object : void 0;
};
const is_object = function(obj) {
  return typeof obj === "object" && obj !== null && !Array.isArray(obj);
};
const normalize_columns = function(columns) {
  if (columns === void 0 || columns === null) {
    return [void 0, void 0];
  }
  if (typeof columns !== "object") {
    return [Error('Invalid option "columns": expect an array or an object')];
  }
  if (!Array.isArray(columns)) {
    const newcolumns = [];
    for (const k in columns) {
      newcolumns.push({
        key: k,
        header: columns[k]
      });
    }
    columns = newcolumns;
  } else {
    const newcolumns = [];
    for (const column2 of columns) {
      if (typeof column2 === "string") {
        newcolumns.push({
          key: column2,
          header: column2
        });
      } else if (typeof column2 === "object" && column2 !== null && !Array.isArray(column2)) {
        if (!column2.key) {
          return [
            Error('Invalid column definition: property "key" is required')
          ];
        }
        if (column2.header === void 0) {
          column2.header = column2.key;
        }
        newcolumns.push(column2);
      } else {
        return [
          Error("Invalid column definition: expect a string or an object")
        ];
      }
    }
    columns = newcolumns;
  }
  return [void 0, columns];
};
class CsvError2 extends Error {
  constructor(code, message, ...contexts) {
    if (Array.isArray(message)) message = message.join(" ");
    super(message);
    if (Error.captureStackTrace !== void 0) {
      Error.captureStackTrace(this, CsvError2);
    }
    this.code = code;
    for (const context2 of contexts) {
      for (const key in context2) {
        const value = context2[key];
        this[key] = isBuffer(value) ? value.toString() : value == null ? value : JSON.parse(JSON.stringify(value));
      }
    }
  }
}
const underscore = function(str) {
  return str.replace(/([A-Z])/g, function(_, match2) {
    return "_" + match2.toLowerCase();
  });
};
const normalize_options = function(opts) {
  const options = {};
  for (const opt in opts) {
    options[underscore(opt)] = opts[opt];
  }
  if (options.bom === void 0 || options.bom === null || options.bom === false) {
    options.bom = false;
  } else if (options.bom !== true) {
    return [
      new CsvError2("CSV_OPTION_BOOLEAN_INVALID_TYPE", [
        "option `bom` is optional and must be a boolean value,",
        `got ${JSON.stringify(options.bom)}`
      ])
    ];
  }
  if (options.delimiter === void 0 || options.delimiter === null) {
    options.delimiter = ",";
  } else if (isBuffer(options.delimiter)) {
    options.delimiter = options.delimiter.toString();
  } else if (typeof options.delimiter !== "string") {
    return [
      new CsvError2("CSV_OPTION_DELIMITER_INVALID_TYPE", [
        "option `delimiter` must be a buffer or a string,",
        `got ${JSON.stringify(options.delimiter)}`
      ])
    ];
  }
  if (options.quote === void 0 || options.quote === null) {
    options.quote = '"';
  } else if (options.quote === true) {
    options.quote = '"';
  } else if (options.quote === false) {
    options.quote = "";
  } else if (isBuffer(options.quote)) {
    options.quote = options.quote.toString();
  } else if (typeof options.quote !== "string") {
    return [
      new CsvError2("CSV_OPTION_QUOTE_INVALID_TYPE", [
        "option `quote` must be a boolean, a buffer or a string,",
        `got ${JSON.stringify(options.quote)}`
      ])
    ];
  }
  if (options.quoted === void 0 || options.quoted === null) {
    options.quoted = false;
  }
  if (options.escape_formulas === void 0 || options.escape_formulas === null) {
    options.escape_formulas = false;
  } else if (typeof options.escape_formulas !== "boolean") {
    return [
      new CsvError2("CSV_OPTION_ESCAPE_FORMULAS_INVALID_TYPE", [
        "option `escape_formulas` must be a boolean,",
        `got ${JSON.stringify(options.escape_formulas)}`
      ])
    ];
  }
  if (options.quoted_empty === void 0 || options.quoted_empty === null) {
    options.quoted_empty = void 0;
  }
  if (options.quoted_match === void 0 || options.quoted_match === null || options.quoted_match === false) {
    options.quoted_match = null;
  } else if (!Array.isArray(options.quoted_match)) {
    options.quoted_match = [options.quoted_match];
  }
  if (options.quoted_match) {
    for (const quoted_match of options.quoted_match) {
      const isString2 = typeof quoted_match === "string";
      const isRegExp = quoted_match instanceof RegExp;
      if (!isString2 && !isRegExp) {
        return [
          new CsvError2("CSV_OPTION_QUOTED_MATCH", [
            "option `quoted_match` must be a string or a regex,",
            `got ${JSON.stringify(options.quoted_match)}`
          ])
        ];
      }
    }
  }
  if (options.quoted_string === void 0 || options.quoted_string === null) {
    options.quoted_string = false;
  }
  if (options.eof === void 0 || options.eof === null) {
    options.eof = true;
  }
  if (options.escape === void 0 || options.escape === null) {
    options.escape = '"';
  } else if (isBuffer(options.escape)) {
    options.escape = options.escape.toString();
  } else if (typeof options.escape !== "string") {
    return [
      Error(
        `Invalid Option: escape must be a buffer or a string, got ${JSON.stringify(options.escape)}`
      )
    ];
  }
  if (options.escape.length > 1) {
    return [
      Error(
        `Invalid Option: escape must be one character, got ${options.escape.length} characters`
      )
    ];
  }
  if (options.header === void 0 || options.header === null || options.header === false) {
    options.header = false;
  } else if (options.header !== true) {
    throw new CsvError2(
      "CSV_INVALID_OPTION_HEADER",
      [
        "option `header` is expected to be a boolean,",
        `got ${JSON.stringify(options.header)}`
      ],
      options
    );
  }
  if (options.header_as_comment === void 0 || options.header_as_comment === null || options.header_as_comment === false) {
    options.header_as_comment = false;
  } else if (options.header_as_comment === true) {
    options.header_as_comment = "#";
  } else if (isBuffer(options.header_as_comment)) {
    options.header_as_comment = options.header_as_comment.toString();
  } else if (typeof options.header_as_comment !== "string") {
    throw new CsvError2(
      "CSV_INVALID_OPTION_HEADER_AS_COMMENT",
      [
        "option `header_as_comment` must be a boolean, a string or a buffer,",
        `got ${JSON.stringify(options.header_as_comment)}`
      ],
      options
    );
  }
  const [errColumns, columns] = normalize_columns(options.columns);
  if (errColumns !== void 0) return [errColumns];
  options.columns = columns;
  if (options.quoted === void 0 || options.quoted === null) {
    options.quoted = false;
  }
  if (options.cast === void 0 || options.cast === null) {
    options.cast = {};
  }
  if (options.cast.bigint === void 0 || options.cast.bigint === null) {
    options.cast.bigint = (value) => "" + value;
  }
  if (options.cast.boolean === void 0 || options.cast.boolean === null) {
    options.cast.boolean = (value) => value ? "1" : "";
  }
  if (options.cast.date === void 0 || options.cast.date === null) {
    options.cast.date = (value) => "" + value.getTime();
  }
  if (options.cast.number === void 0 || options.cast.number === null) {
    options.cast.number = (value) => "" + value;
  }
  if (options.cast.object === void 0 || options.cast.object === null) {
    options.cast.object = (value) => JSON.stringify(value);
  }
  if (options.cast.string === void 0 || options.cast.string === null) {
    options.cast.string = function(value) {
      return value;
    };
  }
  if (options.on_record !== void 0 && typeof options.on_record !== "function") {
    return [Error(`Invalid Option: "on_record" must be a function.`)];
  }
  if (options.record_delimiter === void 0 || options.record_delimiter === null) {
    options.record_delimiter = "\n";
  } else if (isBuffer(options.record_delimiter)) {
    options.record_delimiter = options.record_delimiter.toString();
  } else if (typeof options.record_delimiter !== "string") {
    return [
      Error(
        `Invalid Option: record_delimiter must be a buffer or a string, got ${JSON.stringify(options.record_delimiter)}`
      )
    ];
  }
  switch (options.record_delimiter) {
    case "unix":
      options.record_delimiter = "\n";
      break;
    case "mac":
      options.record_delimiter = "\r";
      break;
    case "windows":
      options.record_delimiter = "\r\n";
      break;
    case "ascii":
      options.record_delimiter = "";
      break;
    case "unicode":
      options.record_delimiter = "\u2028";
      break;
  }
  return [void 0, options];
};
const bom_utf8 = Buffer$1.from([239, 187, 191]);
const emits_separator = function(value, separator) {
  return separator.length !== 0 && (value.indexOf(separator) !== -1 || separator.length > 1 && (value + separator).indexOf(separator) < value.length);
};
const matches_quoted_match = function(value, quoted_match) {
  if (!quoted_match) return false;
  return quoted_match.some(
    (pattern) => typeof pattern === "string" ? value.indexOf(pattern) !== -1 : value.search(pattern) !== -1
  );
};
const stringifier = function(options, state, info) {
  return {
    options,
    state,
    info,
    __transform: function(chunk2, push) {
      if (!Array.isArray(chunk2) && typeof chunk2 !== "object") {
        return Error(
          `Invalid Record: expect an array or an object, got ${JSON.stringify(chunk2)}`
        );
      }
      if (this.info.records === 0) {
        if (Array.isArray(chunk2)) {
          if (this.options.header === true && this.options.columns === void 0) {
            return Error(
              "Undiscoverable Columns: header option requires column option or object records"
            );
          }
        } else if (this.options.columns === void 0) {
          const [err2, columns] = normalize_columns(Object.keys(chunk2));
          if (err2) return;
          this.options.columns = columns;
        }
      }
      if (this.info.records === 0) {
        this.bom(push);
        const err2 = this.headers(push);
        if (err2) return err2;
      }
      try {
        if (this.options.on_record) {
          this.options.on_record(chunk2, this.info.records);
        }
      } catch (err2) {
        return err2;
      }
      let err, chunk_string;
      if (this.options.eof) {
        [err, chunk_string] = this.stringify(chunk2);
        if (err) return err;
        if (chunk_string === void 0) {
          return;
        } else {
          chunk_string = chunk_string + this.options.record_delimiter;
        }
      } else {
        [err, chunk_string] = this.stringify(chunk2);
        if (err) return err;
        if (chunk_string === void 0) {
          return;
        } else {
          if (this.options.header || this.info.records) {
            chunk_string = this.options.record_delimiter + chunk_string;
          }
        }
      }
      this.info.records++;
      push(chunk_string);
    },
    stringify: function(chunk2, chunkIsHeader = false) {
      if (typeof chunk2 !== "object") {
        return [void 0, chunk2];
      }
      const { columns } = this.options;
      const record = [];
      if (Array.isArray(chunk2)) {
        if (columns) {
          chunk2.splice(columns.length);
        }
        for (let i = 0; i < chunk2.length; i++) {
          const field = chunk2[i];
          const [err, value] = this.__cast(field, {
            index: i,
            column: i,
            records: this.info.records,
            header: chunkIsHeader
          });
          if (err) return [err];
          record[i] = [value, field];
        }
      } else {
        for (let i = 0; i < columns.length; i++) {
          const field = get(chunk2, columns[i].key);
          const [err, value] = this.__cast(field, {
            index: i,
            column: columns[i].key,
            records: this.info.records,
            header: chunkIsHeader
          });
          if (err) return [err];
          record[i] = [value, field];
        }
      }
      let csvrecord = "";
      for (let i = 0; i < record.length; i++) {
        let options2, err;
        let [value, field] = record[i];
        if (typeof value === "string") {
          options2 = this.options;
        } else if (is_object(value)) {
          options2 = value;
          value = options2.value;
          delete options2.value;
          if (typeof value !== "string" && value !== void 0 && value !== null) {
            if (err)
              return [
                Error(
                  `Invalid Casting Value: returned value must return a string, null or undefined, got ${JSON.stringify(value)}`
                )
              ];
          }
          options2 = { ...this.options, ...options2 };
          [err, options2] = normalize_options(options2);
          if (err !== void 0) {
            return [err];
          }
        } else if (value === void 0 || value === null) {
          options2 = this.options;
        } else {
          return [
            Error(
              `Invalid Casting Value: returned value must return a string, an object, null or undefined, got ${JSON.stringify(value)}`
            )
          ];
        }
        const {
          delimiter: delimiter2,
          escape: escape2,
          quote,
          quoted,
          quoted_empty,
          quoted_string,
          quoted_match,
          record_delimiter,
          escape_formulas
        } = options2;
        if ("" === value && "" === field) {
          const quotedMatch = matches_quoted_match(value, quoted_match);
          const shouldQuote = quotedMatch || true === quoted_empty || true === quoted_string && false !== quoted_empty;
          if (shouldQuote === true) {
            value = quote + value + quote;
          }
          csvrecord += value;
        } else if (value) {
          if (typeof value !== "string") {
            return [
              Error(
                `Formatter must return a string, null or undefined, got ${JSON.stringify(value)}`
              )
            ];
          }
          const containsdelimiter = emits_separator(value, delimiter2);
          const containsQuote = quote !== "" && value.indexOf(quote) >= 0;
          const containsEscape = value.indexOf(escape2) >= 0 && escape2 !== quote;
          const containsRecordDelimiter = emits_separator(
            value,
            record_delimiter
          );
          const quotedString = quoted_string && typeof field === "string";
          const quotedMatch = matches_quoted_match(value, quoted_match);
          if (escape_formulas) {
            switch (value[0]) {
              case "=":
              case "+":
              case "-":
              case "@":
              case "	":
              case "\r":
              case "＝":
              // Unicode '='
              case "＋":
              // Unicode '+'
              case "－":
              // Unicode '-'
              case "＠":
                value = `'${value}`;
                break;
            }
          }
          const shouldQuote = containsQuote === true || containsdelimiter || containsRecordDelimiter || quoted || quotedString || quotedMatch;
          if (shouldQuote === true && containsEscape === true) {
            value = value.replaceAll(escape2, () => escape2 + escape2);
          }
          if (containsQuote === true) {
            value = value.replaceAll(quote, () => escape2 + quote);
          }
          if (shouldQuote === true) {
            value = quote + value + quote;
          }
          csvrecord += value;
        } else if (quoted_empty === true || field === "" && quoted_string === true && quoted_empty !== false) {
          csvrecord += quote + quote;
        }
        if (i !== record.length - 1) {
          csvrecord += delimiter2;
        }
      }
      return [void 0, csvrecord];
    },
    bom: function(push) {
      if (this.options.bom !== true) {
        return;
      }
      push(bom_utf8);
    },
    headers: function(push) {
      if (this.options.header === false) {
        return;
      }
      if (this.options.columns === void 0) {
        return;
      }
      let err;
      let headers = this.options.columns.map((column2) => column2.header);
      if (this.options.eof) {
        [err, headers] = this.stringify(headers, true);
        headers += this.options.record_delimiter;
      } else {
        [err, headers] = this.stringify(headers);
      }
      if (err) return err;
      if (this.options.header_as_comment) {
        headers = this.options.header_as_comment + " " + headers;
      }
      push(headers);
    },
    __cast: function(value, context2) {
      const type = typeof value;
      try {
        if (type === "string") {
          return [void 0, this.options.cast.string(value, context2)];
        } else if (type === "bigint") {
          return [void 0, this.options.cast.bigint(value, context2)];
        } else if (type === "number") {
          return [void 0, this.options.cast.number(value, context2)];
        } else if (type === "boolean") {
          return [void 0, this.options.cast.boolean(value, context2)];
        } else if (value instanceof Date) {
          return [void 0, this.options.cast.date(value, context2)];
        } else if (type === "object" && value !== null) {
          return [void 0, this.options.cast.object(value, context2)];
        } else if (value === null && this.options.cast.null !== void 0) {
          return [void 0, this.options.cast.null(value, context2)];
        } else if (value === void 0 && this.options.cast.undefined !== void 0) {
          return [void 0, this.options.cast.undefined(value, context2)];
        } else {
          return [void 0, value];
        }
      } catch (err) {
        return [err];
      }
    }
  };
};
const stringify$1 = function(records, opts = {}) {
  const data = [];
  const [err, options] = normalize_options(opts);
  if (err !== void 0) throw err;
  const state = {
    stop: false
  };
  const info = {
    records: 0
  };
  const api = stringifier(options, state, info);
  for (const record of records) {
    const err2 = api.__transform(record, function(record2) {
      data.push(record2);
    });
    if (err2 !== void 0) throw err2;
  }
  if (data.length === 0) {
    api.bom((d) => {
      data.push(d);
    });
    const err2 = api.headers((headers) => {
      data.push(headers);
    });
    if (err2 !== void 0) throw err2;
  }
  return data.join("");
};
const csvHeader = [
  "*clause_number",
  "agency_code",
  "title",
  "description",
  "status",
  "delete"
];
const getContractClauseCsv = async ({
  clauses
}) => {
  const rows = [csvHeader];
  clauses.forEach((c) => {
    rows.push([
      c.clauseNumber,
      c.agency.code ?? "",
      c.title,
      replaceLineBreaksWithSpace(c.description),
      c.active ? "A" : "I",
      ""
    ]);
  });
  return stringify$1(rows);
};
const fetchAllContractClauses = async (errorMessage, pageSize2 = MAX_PLATFORM_PAGE_SIZE) => fetchAllItems({
  fetch: (page) => () => fetchContractClauses(page, pageSize2),
  errorMessage
});
const createContractClause = async (requestBody) => {
  try {
    return await createContractClause$1(requestBody);
  } catch (e) {
    log.warn({
      msg: "Creating new contract clause failed",
      error: `${e}`
    });
    throw e;
  }
};
const deleteContractClause = async (key) => {
  try {
    return await deleteContractClause$1(key);
  } catch (e) {
    log.warn({
      msg: `Deleting contract clause failed (key: ${key})`,
      error: `${e}`
    });
    throw e;
  }
};
const editContractClause = async (requestBody) => {
  try {
    if (!requestBody.key) {
      throw new Error("Missing Contract Clause key");
    }
    await editContractClause$1(requestBody);
    return { key: requestBody.key };
  } catch (e) {
    log.warn({
      msg: `Editing contract clause failed (key: ${requestBody.key})`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchContractClauseByKey = async (key) => {
  try {
    return await fetchContractClauseByKey$1(key);
  } catch (e) {
    log.warn({
      msg: `Fetching contract clause (${key}) failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchContractClauseImportDefinition = async () => {
  try {
    return await fetchContractClauseImportDefinition$1();
  } catch (e) {
    log.warn({
      msg: `Fetching Contract Clause Import Template failed`,
      error: `${e}`
    });
    throw e;
  }
};
const importContractClauses = async (file, {
  dryRun = false,
  enableProgressFeedback = false
}) => {
  try {
    return await importContractClauses$1(file, {
      dryRun,
      enableProgressFeedback
    });
  } catch (e) {
    log.warn({
      msg: `Uploading Contract Clause Import failed`,
      error: `${e}`
    });
    throw e;
  }
};
const getClinProjectTaskMapping = async ({
  mappingKey
}) => {
  try {
    return await getClinProjectTaskMapping$1({
      mappingKey
    });
  } catch (error) {
    log.error({
      error,
      mappingKey,
      msg: "Failed to get CLIN project-task mapping"
    });
    return null;
  }
};
const getClinProjectTaskMappings = async ({
  contractKey,
  page,
  pageSize: pageSize2
}) => {
  try {
    return await getClinProjectTaskMappings$1({
      contractKey,
      page,
      pageSize: pageSize2
    });
  } catch (error) {
    log.error({
      contractKey,
      error,
      msg: "Failed to get CLIN project-task mappings",
      page,
      pageSize: pageSize2
    });
    return null;
  }
};
const getWbsHierarchy = async ({
  contractKey
}) => {
  try {
    const pageSize2 = 50;
    const allProjects = await fetchAllItems({
      errorMessage: "Failed to fetch WBS hierarchy",
      fetch: (page) => () => getWbsHierarchyPaged({
        contractKey,
        page,
        pageSize: pageSize2
      })
    });
    return {
      contractKey,
      projects: allProjects
    };
  } catch (error) {
    log.error({
      contractKey,
      error,
      msg: "Failed to get WBS hierarchy"
    });
    return null;
  }
};
const createClinProjectTaskMapping = async ({
  contractKey,
  mapping
}) => {
  try {
    return await createClinProjectTaskMapping$1({
      contractKey,
      mapping
    });
  } catch (error) {
    log.error({
      contractKey,
      error,
      mapping,
      msg: "Failed to create CLIN project-task mapping"
    });
    throw error;
  }
};
const updateClinProjectTaskMapping = async ({
  contractKey,
  mapping,
  mappingKey
}) => {
  try {
    const result = await updateClinProjectTaskMapping$1({
      contractKey,
      mapping,
      mappingKey
    });
    return result;
  } catch (error) {
    log.error({
      contractKey,
      error,
      mapping,
      mappingKey,
      msg: "Failed to update CLIN project-task mapping"
    });
    throw error;
  }
};
const deleteClinProjectTaskMapping = async ({
  contractKey,
  mappingKey
}) => {
  try {
    await deleteClinProjectTaskMapping$1({
      contractKey,
      mappingKey
    });
  } catch (error) {
    log.error({
      contractKey,
      error,
      mappingKey,
      msg: "Failed to delete CLIN project-task mapping"
    });
    throw error;
  }
};
const validateClinProjectTaskMappings = async ({
  contractKey
}) => {
  try {
    return await validateClinProjectTaskMappings$1({
      contractKey
    });
  } catch (error) {
    log.error({
      contractKey,
      error,
      msg: "Failed to validate CLIN project-task mappings"
    });
    return null;
  }
};
const getAvailableLaborCategories = async ({
  projectKey
}) => {
  try {
    const response = await getProjectLaborCategories({
      page: 1,
      pageSize: 1e3,
      projectKey
    });
    return response.items?.map((item) => ({
      key: item.laborCategory?.key ?? 0,
      name: item.laborCategory?.name ?? ""
    })) || [];
  } catch (error) {
    log.error({
      error,
      msg: "Failed to get available labor categories",
      projectKey
    });
    return [];
  }
};
const getAvailableExpenseTypes = async ({
  projectKey
}) => {
  try {
    const response = await getProjectExpenseTypes({
      page: 1,
      pageSize: 1e3,
      projectKey
    });
    return response.items?.map((item) => ({
      key: item.expenseType?.key ?? 0,
      name: item.expenseType?.name ?? ""
    })) || [];
  } catch (error) {
    log.error({
      error,
      msg: "Failed to get available expense types",
      projectKey
    });
    return [];
  }
};
const getAvailableItems = async ({
  projectKey
}) => {
  try {
    const response = await getProjectItems({
      page: 1,
      pageSize: 1e3,
      projectKey
    });
    return response.items?.map((item) => ({
      key: item.key,
      name: item.name
    })) || [];
  } catch (error) {
    log.error({
      error,
      msg: "Failed to get available items",
      projectKey
    });
    return [];
  }
};
const getAvailableFixedPriceItems = async ({
  projectKey
}) => {
  const response = await getProjectFixedPriceItems({
    page: 1,
    pageSize: 1e3,
    projectKey
  });
  return response.items?.filter(
    (item) => item.key != null && item.description != null
  ).map((item) => ({
    key: item.key,
    name: item.description
  })) || [];
};
const getAdvFundMods = async ({
  contractKey
}) => fetchAllItems({
  fetch: (page) => () => getAdvFundMods$1({
    contractKey,
    page,
    pageSize: MAX_PLATFORM_PAGE_SIZE
  }),
  errorMessage: `Fetching advanced funding mods failed (contractKey: ${contractKey})`,
  // These lists back tables whose empty state reads as "nothing staged",
  // so a swallowed failure would be shown to the user as fact.
  throwOnPageError: true
});
const getAdvFundMod = async ({
  contractKey,
  modNumber
}) => {
  try {
    return await getAdvFundMod$1({ contractKey, modNumber });
  } catch (e) {
    log.warn({
      msg: `Fetching advanced funding mod failed (contractKey: ${contractKey}, modNumber: ${modNumber})`,
      error: `${e}`
    });
    throw e;
  }
};
const createAdvFundMod = async ({
  contractKey,
  requestBody
}) => {
  try {
    return await createAdvFundMod$1({
      contractKey,
      requestBody
    });
  } catch (e) {
    log.warn({
      msg: `Creating advanced funding mod failed (contractKey: ${contractKey})`,
      error: `${e}`
    });
    throw e;
  }
};
const updateAdvFundMod = async ({
  contractKey,
  modNumber,
  requestBody
}) => {
  try {
    await updateAdvFundMod$1({
      contractKey,
      modNumber,
      requestBody
    });
    return { contractKey, modNumber };
  } catch (e) {
    log.warn({
      msg: `Updating advanced funding mod failed (contractKey: ${contractKey}, modNumber: ${modNumber})`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteAdvFundMod = async ({
  contractKey,
  modNumber
}) => {
  try {
    await deleteAdvFundMod$1({ contractKey, modNumber });
    return { contractKey, modNumber };
  } catch (e) {
    log.warn({
      msg: `Deleting advanced funding mod failed (contractKey: ${contractKey}, modNumber: ${modNumber})`,
      error: `${e}`
    });
    throw e;
  }
};
const submitAdvFundModForReview = async ({
  contractKey,
  modNumber
}) => {
  try {
    return await submitAdvFundModForReview$1({
      contractKey,
      modNumber
    });
  } catch (e) {
    log.warn({
      msg: `Submitting advanced funding mod for review failed (contractKey: ${contractKey}, modNumber: ${modNumber})`,
      error: `${e}`
    });
    throw e;
  }
};
const returnAdvFundModToDraft = async ({
  contractKey,
  modNumber
}) => {
  try {
    return await returnAdvFundModToDraft$1({
      contractKey,
      modNumber
    });
  } catch (e) {
    log.warn({
      msg: `Returning advanced funding mod to draft failed (contractKey: ${contractKey}, modNumber: ${modNumber})`,
      error: `${e}`
    });
    throw e;
  }
};
const commitAdvFundMod = async ({
  contractKey,
  modNumber
}) => {
  try {
    return await commitAdvFundMod$1({
      contractKey,
      modNumber
    });
  } catch (e) {
    log.warn({
      msg: `Committing advanced funding mod failed (contractKey: ${contractKey}, modNumber: ${modNumber})`,
      error: `${e}`
    });
    throw e;
  }
};
const getAdvFundModSummary = async ({
  contractKey,
  modNumber
}) => {
  try {
    return await getAdvFundModSummary$1({
      contractKey,
      modNumber
    });
  } catch (e) {
    log.warn({
      msg: `Fetching advanced funding mod summary failed (contractKey: ${contractKey}, modNumber: ${modNumber})`,
      error: `${e}`
    });
    throw e;
  }
};
const getClinChanges = async ({
  contractKey,
  modNumber
}) => fetchAllItems({
  fetch: (page) => () => getClinChanges$1({
    contractKey,
    modNumber,
    page,
    pageSize: MAX_PLATFORM_PAGE_SIZE
  }),
  errorMessage: `Fetching CLIN changes failed (contractKey: ${contractKey}, modNumber: ${modNumber})`,
  // These lists back tables whose empty state reads as "nothing staged",
  // so a swallowed failure would be shown to the user as fact.
  throwOnPageError: true
});
const createClinChange = async ({
  contractKey,
  modNumber,
  requestBody
}) => {
  try {
    return await createClinChange$1({
      contractKey,
      modNumber,
      requestBody
    });
  } catch (e) {
    log.warn({
      msg: `Creating CLIN change failed (contractKey: ${contractKey}, modNumber: ${modNumber})`,
      error: `${e}`
    });
    throw e;
  }
};
const updateClinChange = async ({
  clinModKey,
  contractKey,
  modNumber,
  requestBody
}) => {
  try {
    await updateClinChange$1({
      clinModKey,
      contractKey,
      modNumber,
      requestBody
    });
    return { clinModKey, contractKey, modNumber };
  } catch (e) {
    log.warn({
      msg: `Updating CLIN change failed (contractKey: ${contractKey}, modNumber: ${modNumber}, clinModKey: ${clinModKey})`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteClinChange = async ({
  clinModKey,
  contractKey,
  modNumber
}) => {
  try {
    await deleteClinChange$1({
      clinModKey,
      contractKey,
      modNumber
    });
    return { clinModKey, contractKey, modNumber };
  } catch (e) {
    log.warn({
      msg: `Deleting CLIN change failed (contractKey: ${contractKey}, modNumber: ${modNumber}, clinModKey: ${clinModKey})`,
      error: `${e}`
    });
    throw e;
  }
};
const getSlinChanges = async ({
  contractKey,
  modNumber
}) => fetchAllItems({
  fetch: (page) => () => getSlinChanges$1({
    contractKey,
    modNumber,
    page,
    pageSize: MAX_PLATFORM_PAGE_SIZE
  }),
  errorMessage: `Fetching SLIN changes failed (contractKey: ${contractKey}, modNumber: ${modNumber})`,
  // These lists back tables whose empty state reads as "nothing staged",
  // so a swallowed failure would be shown to the user as fact.
  throwOnPageError: true
});
const createSlinChange = async ({
  contractKey,
  modNumber,
  requestBody
}) => {
  try {
    return await createSlinChange$1({
      contractKey,
      modNumber,
      requestBody
    });
  } catch (e) {
    log.warn({
      msg: `Creating SLIN change failed (contractKey: ${contractKey}, modNumber: ${modNumber})`,
      error: `${e}`
    });
    throw e;
  }
};
const updateSlinChange = async ({
  contractKey,
  modNumber,
  requestBody,
  slinModKey
}) => {
  try {
    await updateSlinChange$1({
      contractKey,
      modNumber,
      requestBody,
      slinModKey
    });
    return { contractKey, modNumber, slinModKey };
  } catch (e) {
    log.warn({
      msg: `Updating SLIN change failed (contractKey: ${contractKey}, modNumber: ${modNumber}, slinModKey: ${slinModKey})`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteSlinChange = async ({
  contractKey,
  modNumber,
  slinModKey
}) => {
  try {
    await deleteSlinChange$1({
      contractKey,
      modNumber,
      slinModKey
    });
    return { contractKey, modNumber, slinModKey };
  } catch (e) {
    log.warn({
      msg: `Deleting SLIN change failed (contractKey: ${contractKey}, modNumber: ${modNumber}, slinModKey: ${slinModKey})`,
      error: `${e}`
    });
    throw e;
  }
};
const createContract = async (requestBody) => {
  try {
    return await createContract$1(requestBody);
  } catch (e) {
    log.warn({
      msg: "Creating new contract failed",
      error: `${e}`
    });
    throw e;
  }
};
const updateContract = async (requestBody) => {
  try {
    if (!requestBody.key) {
      throw new Error("Missing Contract key");
    }
    await updateContract$1(requestBody);
    return { key: requestBody.key };
  } catch (e) {
    log.warn({
      msg: `Updating contract failed (key: ${requestBody.key})`,
      error: `${e}`
    });
    throw e;
  }
};
const getAllContractStatuses = async (pageSize2 = MAX_PLATFORM_PAGE_SIZE) => {
  try {
    return await fetchAllItems({
      fetch: (page) => () => getContractStatuses(page, pageSize2),
      errorMessage: "Fetching contract statuses failed"
    });
  } catch (e) {
    log.warn({
      msg: "Fetching contract statuses for contract status filter data failed",
      error: `${e}`
    });
    throw e;
  }
};
const getAllContractTypes = async (pageSize2 = MAX_PLATFORM_PAGE_SIZE) => {
  try {
    return await fetchAllItems({
      fetch: (page) => () => getContractTypes(page, pageSize2),
      errorMessage: "Fetching contract types failed"
    });
  } catch (e) {
    log.warn({
      msg: "Fetching contract types for contract type filter data failed",
      error: `${e}`
    });
    throw e;
  }
};
const getAllBillingAnalysts = async (pageSize2 = MAX_PLATFORM_PAGE_SIZE) => {
  try {
    const items = await getAllBillingAnalysts$1(pageSize2);
    return items ?? [];
  } catch (e) {
    log.warn({
      msg: "Fetching billing analysts for contract failed",
      error: `${e}`
    });
    throw e;
  }
};
const getContract = async ({ contractKey }) => {
  try {
    return await with404(() => getContract$1({ contractKey }), null);
  } catch (e) {
    log.warn({ msg: `Error fetching contract: ${contractKey}`, error: `${e}` });
    throw e;
  }
};
const getAdminSetupLeftMenu = async () => {
  try {
    return await getMyMenu$1({ menuId: "menu.admin.setup" });
  } catch (e) {
    log.warn({
      msg: "Error fetching admin setup left menu from unanet core",
      error: `${e}`
    });
    throw e;
  }
};
const getContractLeftMenu = async () => {
  try {
    return await getMyMenu$1({ menuId: "menu.contract" });
  } catch (e) {
    log.warn({
      msg: "Error fetching contract left menu from unanet core",
      error: `${e}`
    });
    throw e;
  }
};
const getAllContractManagers = async (pageSize2 = MAX_PLATFORM_PAGE_SIZE) => {
  try {
    const items = await getAllContractManagers$1(pageSize2);
    return items ?? [];
  } catch (e) {
    log.warn({
      msg: "Fetching contract managers for contract failed",
      error: `${e}`
    });
    throw e;
  }
};
const getContractOfficers = async ({
  owningOrgId,
  active
}) => {
  try {
    const list2 = await getOrganizationContactsList({
      owningOrgId,
      active
    });
    return list2 ?? [];
  } catch (e) {
    log.warn({
      msg: "Fetching contract officers for contract failed",
      error: `${e}`
    });
    throw e;
  }
};
const getContractProvisions = async (pageSize2 = 250) => {
  try {
    const list2 = await getContractProvisions$1(1, pageSize2);
    return list2.items ?? [];
  } catch (e) {
    log.warn({
      msg: "Fetching contract provisions for contract failed",
      error: `${e}`
    });
    throw e;
  }
};
const getContractUdfMetadata = async () => {
  try {
    return await fetchUdfMetadataList(UdfMetadataType.CONTRACT);
  } catch (e) {
    log.warn({
      msg: "Getting contract UDF Metadata failed",
      error: `${e}`
    });
    throw e;
  }
};
const getHasWageDeterminations = async ({
  contractKey
}) => {
  try {
    const list2 = await with404(
      () => getWageDeterminations({
        contractKey,
        page: 1,
        pageSize: 1
      }),
      null
    );
    return !!list2?.resultCount;
  } catch (e) {
    log.warn({
      msg: `Error fetching contract wage determinations: ${contractKey}`,
      error: `${e}`
    });
    throw e;
  }
};
const getAllMasterContracts = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  owningOrgId,
  contractKey,
  contractCode,
  contractTitle
}) => fetchAllItems({
  fetch: (page) => () => getMasterContracts({
    page,
    pageSize: pageSize2,
    owningOrgId,
    contractKey,
    contractCode,
    contractTitle
  }),
  errorMessage: "Could not fetch all master contracts."
});
const getAllOwningOrganizations = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  try {
    return await fetchAllItems({
      fetch: (page) => () => getOwningOrganizations({ page, pageSize: pageSize2 }),
      errorMessage: "Fetching owning organizations failed"
    });
  } catch (e) {
    log.warn({
      msg: "Fetching owning organizations for contract failed",
      error: `${e}`
    });
    throw e;
  }
};
const searchContracts = async (pageSize2 = 250, requestBody) => {
  try {
    const list2 = await searchContracts$1(1, pageSize2, requestBody);
    return list2.items ?? [];
  } catch (e) {
    log.warn({
      msg: "Fetching contracts for contract filter data failed",
      error: `${e}`
    });
    throw e;
  }
};
const searchContractDetails = async ({
  body,
  contractId,
  page,
  pageSize: pageSize2
}) => {
  try {
    return await searchContractDetails$1({
      body,
      contractId,
      page,
      pageSize: pageSize2
    });
  } catch (e) {
    log.warn({
      msg: `Fetching contract details failed (contractId: ${contractId})`,
      error: `${e}`
    });
    throw e;
  }
};
const createContractLine = async ({
  body,
  contractId
}) => {
  try {
    return await createContractLine$1({ body, contractId });
  } catch (e) {
    log.warn({
      msg: `Creating contract line failed (contractId: ${contractId})`,
      error: `${e}`
    });
    throw e;
  }
};
const getContractLine = async ({
  contractId,
  lineId
}) => {
  try {
    return await getContractLine$1({ contractId, lineId });
  } catch (e) {
    log.warn({
      msg: `Fetching contract line failed (lineId: ${lineId})`,
      error: `${e}`
    });
    throw e;
  }
};
const updateContractLine = async ({
  body,
  contractId,
  lineId
}) => {
  try {
    await updateContractLine$1({ body, contractId, lineId });
  } catch (e) {
    log.warn({
      msg: `Updating contract line failed (lineId: ${lineId})`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteContractLine = async ({
  contractId,
  lineId
}) => {
  try {
    await deleteContractLine$1({ contractId, lineId });
  } catch (e) {
    log.warn({
      msg: `Deleting contract line failed (lineId: ${lineId})`,
      error: `${e}`
    });
    throw e;
  }
};
const createContractSubline = async ({
  body,
  contractId,
  lineId
}) => {
  try {
    return await createContractSubline$1({
      body,
      contractId,
      lineId
    });
  } catch (e) {
    log.warn({
      msg: `Creating contract subline failed (lineId: ${lineId})`,
      error: `${e}`
    });
    throw e;
  }
};
const getContractSubline = async ({
  contractId,
  lineId,
  sublineId
}) => {
  try {
    return await getContractSubline$1({
      contractId,
      lineId,
      sublineId
    });
  } catch (e) {
    log.warn({
      msg: `Fetching contract subline failed (sublineId: ${sublineId})`,
      error: `${e}`
    });
    throw e;
  }
};
const updateContractSubline = async ({
  body,
  contractId,
  lineId,
  sublineId
}) => {
  try {
    await updateContractSubline$1({
      body,
      contractId,
      lineId,
      sublineId
    });
  } catch (e) {
    log.warn({
      msg: `Updating contract subline failed (sublineId: ${sublineId})`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteContractSubline = async ({
  contractId,
  lineId,
  sublineId
}) => {
  try {
    await deleteContractSubline$1({
      contractId,
      lineId,
      sublineId
    });
  } catch (e) {
    log.warn({
      msg: `Deleting contract subline failed (sublineId: ${sublineId})`,
      error: `${e}`
    });
    throw e;
  }
};
const getAllBillingTypes = async (pageSize2 = MAX_PLATFORM_PAGE_SIZE) => {
  try {
    return await fetchAllItems({
      fetch: (page) => () => getBillingTypes(page, pageSize2),
      errorMessage: "Fetching billing types failed"
    });
  } catch (e) {
    log.warn({ msg: "Fetching billing types failed", error: `${e}` });
    throw e;
  }
};
const getFundingItems = async ({
  contractId,
  page,
  pageSize: pageSize2
}) => {
  try {
    return await getFundingItems$1({
      contractId,
      page,
      pageSize: pageSize2
    });
  } catch (e) {
    log.warn({
      msg: `Fetching funding items failed (contractId: ${contractId})`,
      error: `${e}`
    });
    throw e;
  }
};
const getFundingItem = async ({
  contractId,
  fundingItemId
}) => {
  try {
    return await getFundingItem$1({
      contractId,
      fundingItemId
    });
  } catch (e) {
    log.warn({
      msg: `Fetching funding item failed (fundingItemId: ${fundingItemId})`,
      error: `${e}`
    });
    throw e;
  }
};
const createFundingItem = async ({
  body,
  contractId
}) => {
  try {
    return await createFundingItem$1({ body, contractId });
  } catch (e) {
    log.warn({
      msg: `Creating funding item failed (contractId: ${contractId})`,
      error: `${e}`
    });
    throw e;
  }
};
const updateFundingItem = async ({
  body,
  contractId,
  fundingItemId
}) => {
  try {
    await updateFundingItem$1({
      body,
      contractId,
      fundingItemId
    });
  } catch (e) {
    log.warn({
      msg: `Updating funding item failed (fundingItemId: ${fundingItemId})`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteFundingItem = async ({
  contractId,
  fundingItemId
}) => {
  try {
    await deleteFundingItem$1({ contractId, fundingItemId });
  } catch (e) {
    log.warn({
      msg: `Deleting funding item failed (fundingItemId: ${fundingItemId})`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchAllIncludedContractClauses = async (contractKey, errorMessage, pageSize2 = MAX_PLATFORM_PAGE_SIZE) => fetchAllItems({
  fetch: (page) => () => fetchIncludedContractClauses(contractKey, page, pageSize2),
  errorMessage
});
const createIncludedContractClause = async (contractKey, requestBody) => {
  try {
    return await createIncludedContractClause$1(contractKey, requestBody);
  } catch (e) {
    log.warn({
      msg: "Creating new included contract clause failed",
      error: `${e}`
    });
    throw e;
  }
};
const deleteIncludedContractClause = async (contractKey, clauseKey) => {
  try {
    return await deleteIncludedContractClause$1(contractKey, clauseKey);
  } catch (e) {
    log.warn({
      msg: `Deleting included contract clause failed (contract: ${contractKey}, clause: ${clauseKey})`,
      error: `${e}`
    });
    throw e;
  }
};
const editIncludedContractClause = async (contractKey, requestBody) => {
  try {
    if (!contractKey) {
      throw new Error("Missing Contract key");
    }
    if (!requestBody.clause.key) {
      throw new Error("Missing Clause key");
    }
    return await editIncludedContractClause$1(contractKey, requestBody);
  } catch (e) {
    log.warn({
      msg: `Editing contract clause failed (contract: ${contractKey} clause: ${requestBody.clause.key})`,
      error: `${e}`
    });
    throw e;
  }
};
const formatLeadProject = (project) => {
  if (!project) {
    return "";
  }
  return [project.code, project.name].filter(Boolean).join(" – ");
};
const _withLeadProjectLogging = async (operation, { contractKey, msg }) => {
  try {
    return await operation();
  } catch (error) {
    log.warn({ contractKey, error, msg });
    throw error;
  }
};
const getAvailableLeadProjects = async (params) => _withLeadProjectLogging(() => getAvailableLeadProjects$1(params), {
  contractKey: params.contractKey,
  msg: "Fetching available lead projects failed"
});
const associateLeadProject = async (params) => _withLeadProjectLogging(() => associateLeadProject$1(params), {
  contractKey: params.contractKey,
  msg: "Associating lead project failed"
});
const disassociateLeadProject = async (params) => _withLeadProjectLogging(() => disassociateLeadProject$1(params), {
  contractKey: params.contractKey,
  msg: "Disassociating lead project failed"
});
const getLeadProject = async (params) => _withLeadProjectLogging(() => getLeadProject$1(params), {
  contractKey: params.contractKey,
  msg: "Fetching lead project failed"
});
const fetchAllCostElements = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  fetch: (page) => () => getCostElements({ page, pageSize: pageSize2 }),
  errorMessage: `Fetching all Cost Elements failed`
});
const fetchAllCostStructures = async ({
  active,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  fetch: (page) => () => getCostStructures({ page, pageSize: pageSize2, active }),
  errorMessage: `Fetching all Cost Structures failed`
});
const fetchAllCostStructureLabor = async ({
  costStructureKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  fetch: (page) => () => getCostStructureLabor({ costStructureKey, page, pageSize: pageSize2 }),
  errorMessage: `Fetching all Cost Structure Labor failed`
});
var __create$5 = Object.create;
var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
var __knownSymbol$5 = (name, symbol) => (symbol = Symbol[name]) ? symbol : /* @__PURE__ */ Symbol.for("Symbol." + name);
var __typeError$5 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __decoratorStart$5 = (base) => [, , , __create$5(null)];
var __decoratorStrings$5 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$5 = (fn3) => fn3 !== void 0 && typeof fn3 !== "function" ? __typeError$5("Function expected") : fn3;
var __decoratorContext$5 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$5[kind], name, metadata, addInitializer: (fn3) => done._ ? __typeError$5("Already initialized") : fns.push(__expectFn$5(fn3 || null)) });
var __decoratorMetadata$5 = (array, target) => __defNormalProp$5(target, __knownSymbol$5("metadata"), array[3]);
var __runInitializers$5 = (array, flags, self2, value) => {
  for (var i = 0, fns = array[flags >> 1], n12 = fns && fns.length; i < n12; i++) fns[i].call(self2);
  return value;
};
var __decorateElement$5 = (array, flags, name, decorators, target, extra) => {
  var it, done, ctx, access, k = flags & 7, s12 = false, p = false;
  var j = 2, key = __decoratorStrings$5[k + 5];
  var extraInitializers = array[j] || (array[j] = []);
  var desc = (target = target.prototype, __getOwnPropDesc$5(target, name));
  for (var i = decorators.length - 1; i >= 0; i--) {
    ctx = __decoratorContext$5(k, name, done = {}, array[3], extraInitializers);
    {
      ctx.static = s12, ctx.private = p, access = ctx.access = { has: (x) => name in x };
      access.get = (x) => x[name];
    }
    it = (0, decorators[i])(desc[key], ctx), done._ = 1;
    __expectFn$5(it) && (desc[key] = it);
  }
  return desc && __defProp$5(target, name, desc), target;
};
var _getAllCostStructureLabor_dec, _getAllCostStructures_dec, _getAllCostElements_dec, _init$5;
_getAllCostElements_dec = [cached("CostElements")], _getAllCostStructures_dec = [cached("CostElements")], _getAllCostStructureLabor_dec = [cached("CostElements")];
class CostElementsCachedApi {
  constructor() {
    __runInitializers$5(_init$5, 5, this);
  }
  async getAllCostElements(arg2 = {}) {
    return fetchAllCostElements(arg2);
  }
  async getAllCostStructures(arg2 = {}) {
    return fetchAllCostStructures(arg2);
  }
  async getAllCostStructureLabor(arg2) {
    return fetchAllCostStructureLabor(arg2);
  }
}
_init$5 = __decoratorStart$5();
__decorateElement$5(_init$5, 1, "getAllCostElements", _getAllCostElements_dec, CostElementsCachedApi);
__decorateElement$5(_init$5, 1, "getAllCostStructures", _getAllCostStructures_dec, CostElementsCachedApi);
__decorateElement$5(_init$5, 1, "getAllCostStructureLabor", _getAllCostStructureLabor_dec, CostElementsCachedApi);
__decoratorMetadata$5(_init$5, CostElementsCachedApi);
const costElementsCachedApi = new CostElementsCachedApi();
const getAllCostReports = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  fetch: (page) => () => getCostReports({ page, pageSize: pageSize2 }),
  errorMessage: "Returning all cost reports failed"
});
const getAllCostReportElements = async ({
  costReportKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  fetch: (page) => () => getCostReportElements({ costReportKey, page, pageSize: pageSize2 }),
  errorMessage: "Returning all cost report elements failed"
});
const fromPlatformCustomLink = (link) => {
  const url2 = link.linkUrl;
  let targetUrl;
  if (!url2 || url2.startsWith("/") || isAbsoluteUrl(url2)) {
    targetUrl = url2;
  } else {
    const context2 = getUrlContext();
    targetUrl = `/${context2}/${url2}`;
  }
  return {
    ...link,
    created: fromISODateTimeString(link.created),
    linkUrl: targetUrl
  };
};
const getCustomLinks = async ({
  active,
  dashboardMenuId,
  forConfig,
  page,
  pageSize: pageSize2,
  applicationType,
  linkType
}) => {
  const response = await getCustomLinks$1({
    active,
    applicationType,
    dashboardMenuId,
    forConfig,
    linkType,
    page,
    pageSize: pageSize2
  });
  return mapListPage(response, fromPlatformCustomLink);
};
const getAllCustomLinks = async ({
  active,
  applicationType,
  dashboardMenuId,
  forConfig,
  linkType,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const links = await fetchAllItems({
    fetch: (page) => () => getCustomLinks$1({
      active,
      applicationType,
      dashboardMenuId,
      forConfig,
      linkType,
      page,
      pageSize: pageSize2
    }),
    errorMessage: `Fetching all custom links for dashboard "${dashboardMenuId}" and link type "${linkType}" failed`
  });
  return links.map(fromPlatformCustomLink);
};
const fetchAllAvailableDashboards = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  return fetchAllItems({
    fetch: (page) => () => fetchAvailableDashboards({
      page,
      pageSize: pageSize2
    }),
    errorMessage: "Fetching available dashboards failed"
  });
};
const dashboardItemEnumToDisplay = (dashboard) => startCase(toLower(dashboard));
const toDashboardItemEnum = (dashboard) => DashboardTypePagedResponse.ItemsEnum[dashboard.replace("_", "")];
const fromPlatformPayCode = (p) => ({
  key: p.key || -1,
  name: p.name || "",
  description: p.description || "",
  defaultList: !!p.defaultList,
  defaultSelected: !!p.defaultSelected,
  active: !!p.active
});
const fromTimesheetTaskModel = (t16) => ({
  key: t16.key || -1,
  projectKey: t16.projectKey || -1,
  projectTypeKey: t16.projectTypeKey || -1,
  indentLevel: t16.indentLevel || 0,
  number: t16.number || "",
  name: t16.name || "",
  active: !!t16.active,
  sequence: t16.sequence || 0,
  originalStartDate: fromISODateString(t16.originalStartDate),
  originalEndDate: fromISODateString(t16.originalEndDate),
  revisedStartDate: fromISODateString(t16.revisedStartDate),
  revisedEndDate: fromISODateString(t16.revisedEndDate),
  actualsStartDate: fromISODateString(t16.actualsStartDate),
  actualsEndDate: fromISODateString(t16.actualsEndDate),
  duration: t16.duration || 0,
  owningOrganizationKey: t16.owningOrganizationKey || -1,
  allowTime: !!t16.allowTime,
  allowItems: !!t16.allowItems,
  completedDate: null
  // FIXME: get from platform
});
var UseLaborCategory = /* @__PURE__ */ ((UseLaborCategory2) => {
  UseLaborCategory2["Required"] = "REQUIRED";
  UseLaborCategory2["Forbidden"] = "FORBIDDEN";
  UseLaborCategory2["Optional"] = "OPTIONAL";
  return UseLaborCategory2;
})(UseLaborCategory || {});
const getExpenseProjectDescription = (p) => getDescription(
  p,
  helpers.bool("unasense.project.title.display"),
  helpers.bool("unasense.expense.org.display")
);
const getDescription = (p, showTitle, showOrg) => {
  const { name } = fromKeyNameOrEmpty(p.customer);
  const code = p.projectCode || "";
  const title = p.title || "";
  const codeAndTitle = showTitle && !!title ? `${code} - ${title}` : code;
  return [showOrg ? name : "", codeAndTitle].join(" ");
};
const getProjectTitle = (project) => {
  const titleParts = [];
  if (project.projectOrg.code) {
    titleParts.push(project.projectOrg.code);
  }
  if (project.code) {
    titleParts.push(project.code);
  }
  return titleParts.join(" ");
};
const fromExpenseProjectModel = (p) => {
  return {
    ...fromTimesheetProjectModel(p),
    description: getExpenseProjectDescription(p)
  };
};
const fromTimesheetProjectModel = (p) => {
  return {
    allowItems: !!p.allowItems,
    allowTime: !!p.allowTime,
    alwaysRequireComments: !!p.alwaysRequireComments,
    actualsStartDate: p.actualsStartDate,
    actualsEndDate: p.actualsEndDate,
    enforceWbsDates: p.enforceWbsDates,
    completedDate: null,
    // FIXME: get from platform
    customer: fromKeyNameOrEmpty(p.customer),
    description: getDescription(
      p,
      helpers.bool("unatime.timesheet.project.title.display"),
      helpers.bool("unatime.timesheet.org.display")
    ),
    futureCharge: !!p.futureCharge,
    itemTaskRequired: !!p.itemTaskRequired,
    key: p.key || -1,
    locationKey: p.locationKey || -1,
    locationRequired: !!p.locationRequired,
    managerApproval: !!p.managerApproval,
    payCodeKey: p.payCodeKey || -1,
    payCodes: (p.payCodes ?? []).map(fromPlatformPayCode),
    projectCode: p.projectCode || "",
    projectTypeKey: p.projectTypeKey || -1,
    taskRequired: !!p.taskRequired,
    tasks: (p.tasks ?? []).map(fromTimesheetTaskModel),
    title: p.title || "",
    titoRequired: p.titoRequired ?? TimesheetProjectModel.TitoRequiredEnum.NOTREQUIRED,
    useLaborCategory: p.useLaborCategory ? p.useLaborCategory : "OPTIONAL"
    /* Optional */
  };
};
const fromPlatformProjectType = (p) => ({
  key: p.key || -1,
  description: p.description || "",
  name: p.name || "",
  administrative: !!p.administrative,
  billable: !!p.billable,
  active: !!p.active
});
const fetchAllLaborCategories = async ({
  active,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  fetch: (page) => () => fetchLaborCategories({ active, page, pageSize: pageSize2 }),
  errorMessage: `Fetching all labor categories failed.`
});
const fetchAllLaborCategoryRates = async ({
  key,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  fetch: (page) => () => fetchLaborCategoryRates({ key, page, pageSize: pageSize2 }),
  errorMessage: `Fetching all labor category rates failed.`
});
var __create$4 = Object.create;
var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __knownSymbol$4 = (name, symbol) => (symbol = Symbol[name]) ? symbol : /* @__PURE__ */ Symbol.for("Symbol." + name);
var __typeError$4 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __decoratorStart$4 = (base) => [, , , __create$4(null)];
var __decoratorStrings$4 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$4 = (fn3) => fn3 !== void 0 && typeof fn3 !== "function" ? __typeError$4("Function expected") : fn3;
var __decoratorContext$4 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$4[kind], name, metadata, addInitializer: (fn3) => done._ ? __typeError$4("Already initialized") : fns.push(__expectFn$4(fn3 || null)) });
var __decoratorMetadata$4 = (array, target) => __defNormalProp$4(target, __knownSymbol$4("metadata"), array[3]);
var __runInitializers$4 = (array, flags, self2, value) => {
  for (var i = 0, fns = array[flags >> 1], n12 = fns && fns.length; i < n12; i++) fns[i].call(self2);
  return value;
};
var __decorateElement$4 = (array, flags, name, decorators, target, extra) => {
  var it, done, ctx, access, k = flags & 7, s12 = false, p = false;
  var j = 2, key = __decoratorStrings$4[k + 5];
  var extraInitializers = array[j] || (array[j] = []);
  var desc = (target = target.prototype, __getOwnPropDesc$4(target, name));
  for (var i = decorators.length - 1; i >= 0; i--) {
    ctx = __decoratorContext$4(k, name, done = {}, array[3], extraInitializers);
    {
      ctx.static = s12, ctx.private = p, access = ctx.access = { has: (x) => name in x };
      access.get = (x) => x[name];
    }
    it = (0, decorators[i])(desc[key], ctx), done._ = 1;
    __expectFn$4(it) && (desc[key] = it);
  }
  return desc && __defProp$4(target, name, desc), target;
};
var _getAllLaborCategoryRates_dec, _getAllLaborCategories_dec, _init$4;
_getAllLaborCategories_dec = [cached("LaborCategories")], _getAllLaborCategoryRates_dec = [cached("LaborCategories")];
class LaborCategoriesCachedApi {
  constructor() {
    __runInitializers$4(_init$4, 5, this);
  }
  async getAllLaborCategories(arg2) {
    return fetchAllLaborCategories(arg2);
  }
  async getAllLaborCategoryRates(arg2) {
    return fetchAllLaborCategoryRates(arg2);
  }
}
_init$4 = __decoratorStart$4();
__decorateElement$4(_init$4, 1, "getAllLaborCategories", _getAllLaborCategories_dec, LaborCategoriesCachedApi);
__decorateElement$4(_init$4, 1, "getAllLaborCategoryRates", _getAllLaborCategoryRates_dec, LaborCategoriesCachedApi);
__decoratorMetadata$4(_init$4, LaborCategoriesCachedApi);
const laborCategoriesCachedApi = new LaborCategoriesCachedApi();
const createProjectAssignment = async (projectKey, requestBody) => {
  try {
    clearApiCache("Projects");
    const results = await createProjectAssignment$1(
      projectKey,
      requestBody
    );
    return results.key;
  } catch (e) {
    log.warn({
      msg: `Error creating project assignment`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteProjectAssignment = async (projectKey, assignmentKey) => {
  try {
    clearApiCache("Projects");
    await deleteProjectAssignment$1(projectKey, assignmentKey);
    return assignmentKey;
  } catch (e) {
    log.warn({
      msg: `Deleting Project Assignment (key: ${assignmentKey}) failed`,
      error: `${e}`
    });
    throw e;
  }
};
const searchProjectAssignments = async ({
  projectKey,
  page,
  pageSize: pageSize2 = 50,
  query
}) => {
  try {
    const assignments = await with404(
      () => searchProjectAssignments$1({
        projectKey,
        page,
        pageSize: pageSize2,
        query
      }),
      null
    );
    return assignments !== null ? assignments : null;
  } catch (e) {
    if (e.statusCode === 400) {
      return null;
    }
    throw e;
  }
};
const searchAllProjectAssignments = async ({
  projectKey,
  query
}) => {
  const pageSize2 = MAX_PLATFORM_PAGE_SIZE;
  return fetchAllItems({
    fetch: (page) => () => searchProjectAssignments({
      projectKey,
      page,
      pageSize: pageSize2,
      query
    })
  });
};
const searchProjects = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  params = {}
}) => {
  const results = await searchProjects$1({ page, pageSize: pageSize2, params });
  return mapListPage(results, (o) => ({
    key: o.key,
    code: o.code,
    projectOrg: o.projectOrg,
    owningOrg: o.owningOrg,
    title: o.title,
    projectType: o.projectType,
    status: o.status,
    billingType: o.billingType,
    taskLevelAssignment: o.taskLevelAssignment
  }));
};
const searchAllProjects = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  params = {}
} = {}) => fetchAllItems({
  errorMessage: "Searching and returning all projects failed",
  fetch: (page) => () => searchProjects$1({ page, pageSize: pageSize2, params })
});
const getAllProjectTypes = async ({
  active = true,
  name = "",
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  try {
    const projectTypes = await fetchAllItems({
      fetch: (page) => () => getProjectTypes(page, pageSize2, name, active)
    });
    return projectTypes.map(fromPlatformProjectType);
  } catch (e) {
    log.warn({
      msg: "Returning all project types failed",
      error: `${e}`
    });
    throw e;
  }
};
const getAllProjectStatuses = async ({
  name = "",
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  fetch: (page) => () => getProjectStatuses(page, pageSize2, name),
  errorMessage: "Returning all project statuses failed"
});
const fetchProject = async ({
  projectKey
}) => {
  try {
    const project = await getProject(projectKey);
    return project;
  } catch (e) {
    log.warn({
      msg: "Fetching project failed",
      error: `${e}`
    });
    throw e;
  }
};
const updateProject = async ({
  project
}) => {
  try {
    clearApiCache("Projects");
    await updateProject$1({ project });
  } catch (e) {
    log.warn({
      msg: "Updating project failed",
      error: `${e}`
    });
    throw e;
  }
};
const fetchProjectTask = async ({
  projectKey,
  taskKey
}) => {
  try {
    const task = await getProjectTask({ projectKey, taskKey });
    return task;
  } catch (e) {
    log.warn({
      msg: "Fetching project task failed",
      error: `${e}`
    });
    throw e;
  }
};
const updateProjectTask = async ({
  task
}) => {
  try {
    clearApiCache("Projects");
    await updateProjectTask$1({ task });
  } catch (e) {
    log.warn({
      msg: "Updating task failed",
      error: `${e}`
    });
    throw e;
  }
};
const getProjectTasks = async ({
  page,
  pageSize: pageSize2 = 50,
  projectKey
}) => {
  const results = await getProjectTasks$1({
    page,
    pageSize: pageSize2,
    projectKey
  });
  return mapListPage(results, (o) => o);
};
const getAllProjectsTasksBatch = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  projectKeys
}) => {
  const tasks = [];
  for (const projectKey of projectKeys) {
    const projectTasks = await fetchAllItems({
      errorMessage: `Fetching tasks by project key failed. Project: ${projectKey}`,
      fetch: (page) => () => getProjectTasks$1({ page, pageSize: pageSize2, projectKey })
    });
    tasks.push(...projectTasks);
  }
  return tasks;
};
const fetchDefaultValuesForProjectAssignment = async ({
  projectKey,
  personKey,
  date
}) => {
  const assigmnentDefaultValues = await with404(
    () => getDefaultProjectAssignmentValues({
      projectKey,
      personKey,
      date
    }),
    null
  );
  return assigmnentDefaultValues;
};
const getProjectAssignment = async ({
  key,
  projectKey
}) => {
  try {
    if (!projectKey) {
      throw "No ProjectKey given";
    }
    return await getProjectAssignment$1({
      assignmentKey: key,
      includeInactive: true,
      projectKey
    });
  } catch (e) {
    log.warn({
      msg: "Getting project assignment failed",
      error: `${e}`
    });
    throw e;
  }
};
const updateProjectAssignment = async (assignmentKey, projectKey, requestBody) => {
  try {
    clearApiCache("Projects");
    await updateProjectAssignment$1(
      assignmentKey,
      projectKey,
      requestBody
    );
    return requestBody.key;
  } catch (e) {
    log.warn({
      msg: `Error creating project assignment`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchAllProjectLocationsDefaults = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  projectKey
}) => {
  try {
    const projectLocations = [];
    try {
      const fetchedProjectLocations = await fetchAllItems({
        fetch: (page) => () => getProjectLocations({ projectKey, page, pageSize: pageSize2 })
      });
      projectLocations.push(...fetchedProjectLocations);
    } catch (e) {
      log.warn({
        msg: "Fetching all Project Location Defaults failed",
        error: `${e}`
      });
    }
    if (!projectLocations.length) {
      try {
        const allLocations = await fetchAllItems({
          fetch: (page) => () => fetchLocations$1({ page, pageSize: pageSize2 })
        });
        projectLocations.push(...allLocations);
      } catch (e) {
        log.warn({
          msg: "Fetching all Location Defaults (active) failed",
          error: `${e}`
        });
      }
    }
    return projectLocations;
  } catch (e) {
    log.warn({
      msg: "Fetching all Project Location Defaults failed.",
      error: `${e}`
    });
    throw e;
  }
};
const fetchAllProjectLaborCategories = async ({
  asOfDate,
  laborCategoryKeys,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  projectKey
}) => {
  const results = await fetchAllItems({
    fetch: (page) => () => getProjectLaborCategories({
      asOfDate,
      laborCategoryKeys,
      page,
      pageSize: pageSize2,
      projectKey
    })
  });
  return results;
};
const fetchProjectLaborCategoriesExist = async ({
  projectKey
}) => {
  const result = await getProjectLaborCategories({
    page: 1,
    pageSize: 1,
    projectKey
  });
  return result.resultCount > 0;
};
const fetchAllProjectLaborCategoriesDefaults = async ({
  projectKey,
  asOfDate,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const projectLaborCategories = await fetchAllItems({
    errorMessage: "Fetching all Project Labor Categories failed",
    fetch: (page) => () => getProjectLaborCategories({
      asOfDate,
      page,
      pageSize: pageSize2,
      projectKey
    })
  });
  let allLaborCategories = [];
  if (!projectLaborCategories.length) {
    const laborCategories2 = await fetchAllLaborCategories({ active: true });
    allLaborCategories = laborCategories2.map((item) => ({
      key: item.key,
      name: item.name
    }));
  }
  return { allLaborCategories, projectLaborCategories };
};
const fetchAllProjectPlanSets = async (id) => fetchAllItems({
  fetch: (page) => () => getProjectPlanSets(id, page, MAX_PLATFORM_PAGE_SIZE)
});
const getAllProjectTaskPredecessors = async ({
  projectKey,
  taskKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  errorMessage: "Fetching all project task predecessors failed",
  fetch: (page) => () => getProjectTaskPredecessors({
    page,
    pageSize: pageSize2,
    projectKey,
    taskKey
  })
});
const updateProjectTaskPredecessor = async ({
  projectKey,
  taskKey,
  predecessor
}) => {
  try {
    clearApiCache("Projects");
    await updateProjectTaskPredecessor$1({
      projectKey,
      taskKey,
      predecessor
    });
  } catch (e) {
    log.warn({
      msg: `Error updating project task predecessor`,
      error: `${e}`
    });
    throw e;
  }
};
const createProjectTaskPredecessor = async ({
  projectKey,
  taskKey,
  predecessor
}) => {
  try {
    clearApiCache("Projects");
    await createProjectTaskPredecessor$1({
      projectKey,
      taskKey,
      predecessor
    });
  } catch (e) {
    log.warn({
      msg: `Error creating project task predecessor`,
      error: `${e}`
    });
    throw e;
  }
};
const searchTasks = async (searchTasksRequest) => {
  try {
    const results = await searchTasks$1(searchTasksRequest);
    return results.items;
  } catch (e) {
    log.warn({ msg: "Error searching tasks", error: `${e}` });
    throw e;
  }
};
const searchAllTasks = async ({
  body,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  try {
    const results = await fetchAllItems({
      fetch: (page) => () => searchTasks$1({ body, page, pageSize: pageSize2 })
    });
    return results;
  } catch (e) {
    log.warn({ msg: "Error searching all tasks", error: `${e}` });
    throw e;
  }
};
const deleteProjectTaskPredecessor = async ({
  projectKey,
  taskKey,
  predecessorKey
}) => {
  try {
    clearApiCache("Projects");
    await deleteProjectTaskPredecessor$1({
      projectKey,
      taskKey,
      predecessorKey
    });
  } catch (e) {
    log.warn({
      msg: `Error deleting project task predecessor`,
      error: `${e}`
    });
    throw e;
  }
};
const formatProjectName = (project) => {
  if (!project) {
    return "";
  }
  if ("title" in project) {
    if ("projectCode" in project) {
      return `${project.projectCode} ${project.title}`;
    } else {
      return `${project.code} ${project.title}`;
    }
  } else if ("name" in project) {
    if ("code" in project) {
      return `${project.code} ${project.name}`;
    } else {
      return project.name ?? "";
    }
  } else {
    return "";
  }
};
const toProjectUpdateModel = (project) => {
  const {
    billingType,
    contract,
    costStructure,
    defaultAdvancedCostingCostStructLabor,
    defaultIntercompanyCostStructLabor,
    location,
    owningOrg,
    payCode,
    postingGroup,
    projectManager,
    projectOrg,
    projectType,
    status,
    //ProjectUpdateModel does not have the following properties.
    //We simply destructure them here, and then it won't be included
    //in rest operator (...) projectUpdate cloneDeep below.
    //This way we don't have to use omit (and iterate over the object)
    //or worry about deleting it from the mapped object.
    //eslint-disable-next-line unused-imports/no-unused-vars
    createdTimestamp,
    //eslint-disable-next-line unused-imports/no-unused-vars
    lastUpdatedTimestamp,
    //eslint-disable-next-line unused-imports/no-unused-vars
    projectLead,
    ...projectUpdate
  } = project;
  return {
    ...cloneDeep(projectUpdate),
    billingTypeKey: billingType?.key,
    contractKey: contract?.key,
    costStructureKey: costStructure?.key,
    defaultAdvancedCostingCostStructLaborKey: defaultAdvancedCostingCostStructLabor?.key,
    defaultIntercompanyCostStructLaborKey: defaultIntercompanyCostStructLabor?.key,
    locationKey: location?.key,
    owningOrgKey: owningOrg?.key,
    payCodeKey: payCode?.key,
    postingGroupKey: postingGroup.key,
    projectManagerKey: projectManager?.key,
    projectOrgKey: projectOrg.key ?? -1,
    projectTypeKey: projectType.key ?? -1,
    statusKey: status.key
  };
};
const toTaskUpdateModel = (task) => {
  const {
    billingType,
    duration: _unusedDuration,
    indentLevel: _unusedIndentLevel,
    name,
    number: _unusedNumber,
    owningOrg,
    parentTask: _unusedParentTask,
    project,
    projectType,
    sequence: _unusedSequence,
    ...taskUpdate
  } = task;
  return {
    ...cloneDeep(taskUpdate),
    billingTypeKey: billingType?.key,
    name: name ?? "",
    owningOrgKey: owningOrg?.key,
    projectKey: project.key ?? -1,
    projectTypeKey: projectType?.key
  };
};
var __create$3 = Object.create;
var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __knownSymbol$3 = (name, symbol) => (symbol = Symbol[name]) ? symbol : /* @__PURE__ */ Symbol.for("Symbol." + name);
var __typeError$3 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __decoratorStart$3 = (base) => [, , , __create$3(null)];
var __decoratorStrings$3 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$3 = (fn3) => fn3 !== void 0 && typeof fn3 !== "function" ? __typeError$3("Function expected") : fn3;
var __decoratorContext$3 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$3[kind], name, metadata, addInitializer: (fn3) => done._ ? __typeError$3("Already initialized") : fns.push(__expectFn$3(fn3 || null)) });
var __decoratorMetadata$3 = (array, target) => __defNormalProp$3(target, __knownSymbol$3("metadata"), array[3]);
var __runInitializers$3 = (array, flags, self2, value) => {
  for (var i = 0, fns = array[flags >> 1], n12 = fns && fns.length; i < n12; i++) fns[i].call(self2);
  return value;
};
var __decorateElement$3 = (array, flags, name, decorators, target, extra) => {
  var it, done, ctx, access, k = flags & 7, s12 = false, p = false;
  var j = 2, key = __decoratorStrings$3[k + 5];
  var extraInitializers = array[j] || (array[j] = []);
  var desc = (target = target.prototype, __getOwnPropDesc$3(target, name));
  for (var i = decorators.length - 1; i >= 0; i--) {
    ctx = __decoratorContext$3(k, name, done = {}, array[3], extraInitializers);
    {
      ctx.static = s12, ctx.private = p, access = ctx.access = { has: (x) => name in x };
      access.get = (x) => x[name];
    }
    it = (0, decorators[i])(desc[key], ctx), done._ = 1;
    __expectFn$3(it) && (desc[key] = it);
  }
  return desc && __defProp$3(target, name, desc), target;
};
var _getAllProjectsTasksBatch_dec, _searchProjectAssignments_dec, _getAllProjectLocations_dec, _getProjectLaborCategoriesExist_dec, _getAllProjectLaborCategories_dec, _getDefaultValuesForProjectAssignment_dec, _searchAllProjects_dec, _getProject_dec, _init$3;
_getProject_dec = [cached("Projects")], _searchAllProjects_dec = [cached("Projects")], _getDefaultValuesForProjectAssignment_dec = [cached("Projects")], _getAllProjectLaborCategories_dec = [cached("Projects")], _getProjectLaborCategoriesExist_dec = [cached("Projects")], _getAllProjectLocations_dec = [cached("Projects")], _searchProjectAssignments_dec = [cached("Projects")], _getAllProjectsTasksBatch_dec = [cached("Projects")];
class ProjectsCachedApi {
  constructor() {
    __runInitializers$3(_init$3, 5, this);
  }
  async getProject(arg2) {
    return fetchProject(arg2);
  }
  async searchAllProjects(arg2) {
    return searchAllProjects(arg2);
  }
  async getDefaultValuesForProjectAssignment(arg2) {
    return fetchDefaultValuesForProjectAssignment(arg2);
  }
  async getAllProjectLaborCategories(arg2) {
    return fetchAllProjectLaborCategories(arg2);
  }
  async getProjectLaborCategoriesExist(arg2) {
    return fetchProjectLaborCategoriesExist(arg2);
  }
  async getAllProjectLocations(arg2) {
    return fetchAllProjectLocationsDefaults(arg2);
  }
  async searchProjectAssignments(arg2) {
    return searchProjectAssignments(arg2);
  }
  async getAllProjectsTasksBatch(arg2) {
    return getAllProjectsTasksBatch(arg2);
  }
}
_init$3 = __decoratorStart$3();
__decorateElement$3(_init$3, 1, "getProject", _getProject_dec, ProjectsCachedApi);
__decorateElement$3(_init$3, 1, "searchAllProjects", _searchAllProjects_dec, ProjectsCachedApi);
__decorateElement$3(_init$3, 1, "getDefaultValuesForProjectAssignment", _getDefaultValuesForProjectAssignment_dec, ProjectsCachedApi);
__decorateElement$3(_init$3, 1, "getAllProjectLaborCategories", _getAllProjectLaborCategories_dec, ProjectsCachedApi);
__decorateElement$3(_init$3, 1, "getProjectLaborCategoriesExist", _getProjectLaborCategoriesExist_dec, ProjectsCachedApi);
__decorateElement$3(_init$3, 1, "getAllProjectLocations", _getAllProjectLocations_dec, ProjectsCachedApi);
__decorateElement$3(_init$3, 1, "searchProjectAssignments", _searchProjectAssignments_dec, ProjectsCachedApi);
__decorateElement$3(_init$3, 1, "getAllProjectsTasksBatch", _getAllProjectsTasksBatch_dec, ProjectsCachedApi);
__decoratorMetadata$3(_init$3, ProjectsCachedApi);
const projectsCachedApi = new ProjectsCachedApi();
const DATALAKE_CRITERIA_DEFAULT_PERIOD_COUNT = 12;
const DATALAKE_CRITERIA_MAX_PERIOD_COUNT = 65;
const DATALAKE_CRITERIA_MIN_PERIOD_COUNT = 1;
const DATALAKE_VIEWS = [
  {
    viewName: "prj_periodic_jsr",
    displayName: "Cost Summary"
  }
];
var IndirectCostRateTypes = /* @__PURE__ */ ((IndirectCostRateTypes2) => {
  IndirectCostRateTypes2["Target"] = "RATE_TYPE_TARGET";
  IndirectCostRateTypes2["Provisional"] = "RATE_TYPE_PROVISIONAL";
  IndirectCostRateTypes2["Actual"] = "RATE_ACTUAL";
  return IndirectCostRateTypes2;
})(IndirectCostRateTypes || {});
const getDataLakeViewDisplayValue = (viewName) => {
  const dataLakeView = DATALAKE_VIEWS.find((view) => {
    return view.viewName === viewName;
  });
  return dataLakeView ? `${dataLakeView.displayName} (${dataLakeView.viewName})` : viewName;
};
const getValidDataLakePeriodCount = (periodCount) => {
  let numOfPeriods = periodCount ?? 0;
  if (numOfPeriods < DATALAKE_CRITERIA_MIN_PERIOD_COUNT || numOfPeriods > DATALAKE_CRITERIA_MAX_PERIOD_COUNT) {
    numOfPeriods = DATALAKE_CRITERIA_DEFAULT_PERIOD_COUNT;
  }
  return numOfPeriods;
};
const fromDataLakeCriteria = (model) => {
  return {
    key: model.key,
    name: model.name,
    description: model.description,
    type: {
      key: model.view.key,
      value: model.view.value
    },
    active: model.active,
    criteria: {
      costReportKey: model.costReportKey,
      includePostedDataOnly: model.includePostedDataOnly,
      indirectCostRateType: model.indirectCostRateType,
      periods: getValidDataLakePeriodCount(model.numOfPeriods),
      periodType: model.reportingPeriodType,
      projectStatusKeys: model.projectStatuses?.map((ps2) => ps2.key),
      projectTypeKeys: model.projectTypes?.map((pt2) => pt2.key),
      showActuals: model.showActuals,
      showActualsBudgets: model.showActualsBudgets,
      showActualsPlans: model.showActualsPlans,
      showBudgets: model.showBudgets,
      showInactiveTasks: model.showInactiveTasks,
      showPlans: model.showPlans,
      showTasks: model.showTasks,
      startDate: model.startDate
    }
  };
};
const toCreateModel = (model) => {
  const platformModel = fromDataLakeCriteria(model);
  return {
    name: platformModel.name,
    description: platformModel.description,
    type: platformModel.type,
    active: platformModel.active,
    criteria: platformModel.criteria
  };
};
const toDataLakeCriteria = (model) => {
  return {
    key: model.key,
    name: model.name,
    description: model.description ?? "",
    view: {
      key: model.type.key,
      value: model.type.value,
      displayValue: getDataLakeViewDisplayValue(model.type.value ?? "")
    },
    active: model.active,
    costReportKey: model.criteria.costReportKey,
    includePostedDataOnly: model.criteria.includePostedDataOnly,
    indirectCostRateType: model.criteria.indirectCostRateType,
    numOfPeriods: model.criteria.periods,
    projectStatuses: model.criteria.projectStatusKeys?.map((psk) => ({
      key: psk,
      name: ""
      // names set (for display purposes) when project status list is retrieved
    })),
    projectTypes: model.criteria.projectTypeKeys?.map((ptk) => ({
      key: ptk,
      name: ""
      // names set (for display purposes) when project type list is retrieved
    })),
    reportingPeriodType: model.criteria.periodType,
    showActuals: model.criteria.showActuals,
    showActualsBudgets: model.criteria.showActualsBudgets,
    showActualsPlans: model.criteria.showActualsPlans,
    showBudgets: model.criteria.showBudgets,
    showInactiveTasks: model.criteria.showInactiveTasks,
    showPlans: model.criteria.showPlans,
    showTasks: model.criteria.showTasks,
    startDate: model.criteria.startDate
  };
};
const toDataLakeView = (model) => {
  return {
    ...model,
    displayValue: getDataLakeViewDisplayValue(model.value ?? "")
  };
};
const createDataLakeCriteria = async (model) => {
  try {
    const { key } = await createDataLakeCriteria$1(
      toCreateModel(model)
    );
    return key;
  } catch (e) {
    log.warn({
      msg: "Creating DataLake Criteria failed",
      ...model,
      error: `${e}`
    });
    throw e;
  }
};
const deleteDataLakeCriteria = async (criteriaKey) => {
  try {
    await deleteDataLakeCriteria$1(criteriaKey);
  } catch (e) {
    log.warn({
      msg: "Deleting DataLake Criteria failed",
      criteriaKey,
      error: `${e}`
    });
    throw e;
  }
};
const getEstimatedDataLakeRecordCount = async (criteria) => {
  try {
    let projectTaskCount = 0;
    const projectList = await searchAllProjects({
      params: {
        projectStatusKeys: criteria.projectStatuses?.map((ps2) => ps2.key),
        projectTypeKeys: criteria.projectTypes?.map((pt2) => pt2.key)
      }
    });
    if (!criteria.showTasks) {
      projectTaskCount = projectList.length;
    } else {
      const projKeys = projectList.map((proj) => proj.key);
      const projKeyBatchSize = 1e3;
      for (let projKeyIdx = 0; projKeyIdx < projKeys.length; projKeyIdx += projKeyBatchSize) {
        const taskList = await searchTasks$1({
          body: {
            projectKeys: projKeys.slice(
              projKeyIdx,
              projKeyIdx + projKeyBatchSize
            )
          }
        });
        projectTaskCount += taskList.resultCount;
      }
    }
    const costReportElements = await getAllCostReportElements({
      costReportKey: criteria.costReportKey ?? 0
    });
    const costReportElementCount = costReportElements.length;
    const periodCount = criteria.numOfPeriods ?? DATALAKE_CRITERIA_DEFAULT_PERIOD_COUNT;
    let rowOptionCount = [
      criteria.showActuals,
      criteria.showActualsBudgets,
      criteria.showActualsPlans,
      criteria.showBudgets,
      criteria.showPlans
    ].filter(Boolean).length;
    if (rowOptionCount === 0) {
      rowOptionCount = 1;
    }
    return projectTaskCount * costReportElementCount * periodCount * rowOptionCount;
  } catch (e) {
    log.warn({
      msg: "Estimating DataLake record count failed",
      criteriaKey: criteria.key,
      error: `${e}`
    });
    throw e;
  }
};
const getDataLakeCriteria = async (criteriaKey) => {
  try {
    return toDataLakeCriteria(
      await getDataLakeCriteria$1(criteriaKey)
    );
  } catch (e) {
    log.warn({
      msg: "Fetching DataLake Criteria data failed",
      criteriaKey,
      error: `${e}`
    });
    throw e;
  }
};
const getAllDataLakeCriteriaList = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  const items = await fetchAllItems({
    errorMessage: "Fetching DataLake Criteria list failed",
    fetch: (page) => () => getDataLakeCriteriaList({ page, pageSize: pageSize2 })
  });
  return items.map(toDataLakeCriteria);
};
const getAllDataLakeViews = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  const items = await fetchAllItems({
    errorMessage: "Fetching DataLake Views failed",
    fetch: (page) => () => getDataLakeViewList({ page, pageSize: pageSize2 })
  });
  return items.map(toDataLakeView);
};
const updateDataLakeCriteria = async (criteria) => {
  try {
    await updateDataLakeCriteria$1(
      fromDataLakeCriteria(criteria)
    );
  } catch (e) {
    log.warn({
      msg: "Updating DataLake Criteria failed",
      criteriaKey: criteria.key,
      error: `${e}`
    });
    throw e;
  }
};
const getAllEmployeeTypes = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  errorMessage: "Getting all employee types failed",
  fetch: (page) => () => getEmployeeTypes(page, pageSize2)
});
const fetchFeatureFlagById = async ({ id }) => {
  try {
    return await fetchFeatureFlagById$1({ id });
  } catch (e) {
    log.warn({
      msg: `Error fetching feature flag by ID: ${id}`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchAllFeatureFlags = async (featureFlagIds) => {
  try {
    const flags = [];
    for (const id of featureFlagIds) {
      try {
        const fetchedFlag = await fetchFeatureFlagById$1({ id });
        flags.push(fetchedFlag);
      } catch (e) {
        log.warn({
          msg: `Load All Feature Flags: Error fetching feature flag: ${id}`
        });
        continue;
      }
    }
    return flags;
  } catch (e) {
    log.warn({ msg: `Load All Feature Flags: Error fetching feature flags` });
    throw e;
  }
};
var FeatureFlag = /* @__PURE__ */ ((FeatureFlag2) => {
  FeatureFlag2["ACRN"] = "acrn";
  FeatureFlag2["AuditLogs"] = "audit_log";
  FeatureFlag2["BankRecs"] = "bank_recs";
  FeatureFlag2["ContractProfileNds"] = "contract_profile_nds";
  FeatureFlag2["DatalakeShowInactiveTasks"] = "datalake_show_inactive_tasks";
  FeatureFlag2["FixedAssetsProjectedDepreciation"] = "fixed_assets_projected_depreciation";
  FeatureFlag2["ModernTimesheet"] = "modern_timesheet_ux";
  FeatureFlag2["PaymentMethods"] = "payment_methods";
  FeatureFlag2["PaymentTerms"] = "payment_terms";
  FeatureFlag2["TimeDashboard"] = "new-time-dashboard";
  return FeatureFlag2;
})(FeatureFlag || {});
var ToggleStatus = /* @__PURE__ */ ((ToggleStatus2) => {
  ToggleStatus2["OptedIn"] = "opted-in";
  ToggleStatus2["OptedOut"] = "opted-out";
  return ToggleStatus2;
})(ToggleStatus || {});
const BANK_REC_TOGGLE_STORAGE_KEY = "unanet:webComponent:bank-rec-toggle";
const TIME_DASHBOARD_TOGGLE_STORAGE_KEY = "unanet:webComponent:time-dashboard-toggle";
const TIMESHEET_TOGGLE_STORAGE_KEY = "unanet:webComponent:timesheet-toggle";
const _TOGGLE_STORAGE_KEYS = {
  [FeatureFlag.BankRecs]: BANK_REC_TOGGLE_STORAGE_KEY,
  [FeatureFlag.ModernTimesheet]: TIMESHEET_TOGGLE_STORAGE_KEY,
  [FeatureFlag.TimeDashboard]: TIME_DASHBOARD_TOGGLE_STORAGE_KEY
};
const optOutToggleForPerson = ({
  flag,
  personKey
}) => {
  const key = _TOGGLE_STORAGE_KEYS[flag];
  if (!key || personKey < 0) {
    return;
  }
  try {
    const existing = JSON.parse(localStorage.getItem(key) ?? "{}");
    localStorage.setItem(
      key,
      JSON.stringify({
        ...existing,
        [personKey]: "opted-out"
        /* OptedOut */
      })
    );
  } catch (e) {
    log.warn({
      msg: "optOutToggleForPerson: failed to write localStorage",
      error: `${e}`
    });
  }
};
const getAnomalyDetectionInsight = async (params, signal) => {
  return request({
    url: "/financialdashboard/anomaly-detection",
    method: "POST",
    body: params,
    options: { signal }
  });
};
const getCloseReadinessInsight = async (params, signal) => {
  return request({
    url: "/financialdashboard/close-readiness",
    method: "POST",
    body: params,
    options: { signal }
  });
};
const getIceReadinessInsight = async (params, signal) => {
  return request({
    url: "/financialdashboard/ice-readiness",
    method: "POST",
    body: params,
    options: { signal }
  });
};
const getBankReconciliationInsight = async (params, signal) => {
  return request({
    url: "/financialdashboard/bank-reconciliation",
    method: "POST",
    body: params,
    options: { signal }
  });
};
const getTimeLaborInsight = async (params, signal) => {
  return request({
    url: "/financialdashboard/time-labor",
    method: "POST",
    body: params,
    options: { signal }
  });
};
const getRiskDetectionInsight = async (params, signal) => {
  return request({
    url: "/financialdashboard/risk-detection",
    method: "POST",
    body: params,
    options: { signal }
  });
};
const getForecastInsight = async (params, signal) => {
  return request({
    url: "/financialdashboard/forecast",
    method: "POST",
    body: params,
    options: { signal }
  });
};
const addFixedAssetsClass = async (requestBody) => {
  try {
    const results = await addFixedAssetClass({ requestBody });
    return results;
  } catch (e) {
    log.warn({ msg: "Adding new fixed assets class failed", error: `${e}` });
    throw e;
  }
};
const editFixedAssetsClass = async (faClass) => {
  try {
    const results = await editFixedAssetClass({
      classKey: faClass.key,
      requestBody: faClass
    });
    return results;
  } catch (e) {
    log.warn({ msg: "Updating fixed assets classes failed", error: `${e}` });
    throw e;
  }
};
const fetchAllFixedAssetsClasses = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  return fetchAllItems({
    fetch: (page) => () => fetchFixedAssetClasses({ page, pageSize: pageSize2 }),
    errorMessage: "Fetching fixed assets classes failed"
  });
};
const fetchFixedAssetsClassAccountCategories = async () => {
  try {
    const results = await fetchFixedAssetsClassAccountCategories$1();
    return results;
  } catch (e) {
    log.warn({
      msg: "Fetching fixed assets class account categories failed",
      error: `${e}`
    });
    throw e;
  }
};
const fetchFixedAssetsClassAccounts = async ({
  classKey
}) => {
  try {
    const results = await fetchFixedAssetClassAccounts({
      classKey
    });
    return results;
  } catch (e) {
    log.warn({
      msg: "Fetching fixed assets class accounts failed",
      error: `${e}`
    });
    throw e;
  }
};
const editFixedAssetClassAccounts = async ({
  classKey,
  accounts: accounts2
}) => {
  try {
    const results = await editFixedAssetClassAccounts$1({
      classKey,
      accounts: accounts2
    });
    return results;
  } catch (e) {
    log.warn({
      msg: "Fetching fixed assets class accounts failed",
      error: `${e}`
    });
    throw e;
  }
};
const destroyFixedAssetClass = async ({
  classKey
}) => {
  try {
    const result = await destroyFixedAssetClass$1({ classKey });
    return result;
  } catch (e) {
    log.warn({
      msg: `Failed to remove fixed asset class with key: ${classKey}`,
      error: `${e}`
    });
    throw e;
  }
};
const fromPersonModel = (o) => new Person(o);
const getPerson = async ({
  personKey
}) => {
  const result = await getPerson$1(personKey);
  return fromPersonModel(result);
};
const fetchPeopleList = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  const results = await get$1(
    `/people?page=${page}&pageSize=${pageSize2}`
  );
  return mapListPage(results, fromPersonModel);
};
const listPeople = async (page, pageSize2) => {
  const results = await get$1(
    `/people?page=${page}&pageSize=${pageSize2}`
  );
  return mapListPage(results, (o) => new Person(o));
};
const searchPeople = async (page, pageSize2, options) => {
  if (!options.name) {
    delete options.name;
  }
  const results = await post(
    `/people/search?page=${page}&pageSize=${pageSize2}`,
    options
  );
  return mapListPage(results, (o) => {
    const values2 = { ...omit$1(o, ["udfs"]), udfs: o.udfs?.values };
    return new Person(values2);
  });
};
const searchAllPeopleSummaries = async ({ active, name = "", personKeys = [] }, pageSize2 = MAX_PLATFORM_PAGE_SIZE) => {
  let items = await fetchAllItems({
    fetch: (page) => () => get$1(
      `/people/list?${queryString.stringify({
        name,
        page,
        pageSize: pageSize2,
        personKey: personKeys
      })}`
    )
  });
  if (active !== void 0) {
    items = items.filter((item) => item.active === active);
  }
  const results = {
    items,
    page: 1,
    pageSize: items.length,
    pageCount: items.length > 0 ? 1 : 0,
    resultCount: items.length
  };
  return mapListPage(results, (o) => {
    const values2 = { ...omit$1(o, ["udfs"]), udfs: o.udfs?.values };
    return new Person(values2);
  });
};
const searchAllPeople = async (options, pageSize2 = MAX_PLATFORM_PAGE_SIZE) => {
  if (!options.name) {
    delete options.name;
  }
  const items = await fetchAllItems({
    fetch: (page) => () => post(
      `/people/search?page=${page}&pageSize=${pageSize2}`,
      options
    )
  });
  const results = {
    items,
    page: 1,
    pageSize: items.length,
    pageCount: items.length > 0 ? 1 : 0,
    resultCount: items.length
  };
  return mapListPage(results, (o) => {
    const values2 = { ...omit$1(o, ["udfs"]), udfs: o.udfs?.values };
    return new Person(values2);
  });
};
const searchPeopleWithOrgAccess = async (page, pageSize2, options) => {
  const results = await post(`/people/search/org-access?page=${page}&pageSize=${pageSize2}`, options);
  return mapListPage(
    results,
    (person) => new Person(person)
  );
};
const searchAllPeopleWithOrgAccess = async ({
  options,
  active,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  let items = await fetchAllItems({
    fetch: (page) => () => post(
      `/people/search/org-access?page=${page}&pageSize=${pageSize2}`,
      options
    )
  });
  if (active !== void 0) {
    items = items.filter((item) => item.active === active);
  }
  const results = {
    items,
    page: 1,
    pageSize: items.length,
    pageCount: items.length > 0 ? 1 : 0,
    resultCount: items.length
  };
  return mapListPage(
    results,
    (person) => new Person(person)
  );
};
const searchAllPeopleByKeys = async (pageSize2, options) => {
  return searchAllPeopleSummaries(options, pageSize2);
};
const searchAllPeopleByName = async (pageSize2, options) => {
  return searchAllPeopleSummaries(options, pageSize2);
};
const readPerson = async (id) => {
  const results = await get$1(`/people/${id}`);
  return new Person(results);
};
const getPersonClassificationByDate = async (personKey, date = DateTime.local()) => get$1(`/people/${personKey}/classification/${dateKey(date)}`);
const getPersonUdfMetadata = async () => fetchUdfMetadataList(UdfMetadataType.PERSON);
const searchAllSkills = async ({
  options,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  return fetchAllItems({
    fetch: (page) => () => post(url("/skills/search", { page, pageSize: pageSize2 }), options),
    errorMessage: "Fetching all skills failed"
  });
};
const getAllSkillTypes = async ({
  name,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  return fetchAllItems({
    fetch: (page) => () => getSkillTypes({ name, page, pageSize: pageSize2 }),
    errorMessage: "Fetching all Skill Types failed."
  });
};
const getAllSkillLevels = async ({
  name,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  return fetchAllItems({
    fetch: (page) => () => getSkillLevels({ name, page, pageSize: pageSize2 }),
    errorMessage: "Fetching all Skill Levels failed."
  });
};
const searchPeopleAssignments = async (requestBody, page, pageSize2) => {
  try {
    const results = await searchPeopleAssignments$1(
      page,
      pageSize2,
      requestBody
    );
    return results.items || [];
  } catch (e) {
    log.warn({ msg: "Searching planned time data failed", error: `${e}` });
    throw e;
  }
};
const searchAllPeopleAssignments = async (requestBody, pageSize2 = MAX_PLATFORM_PAGE_SIZE) => fetchAllItems({
  errorMessage: "Searching and returning all planned times failed",
  fetch: (page) => () => searchPeopleAssignments$1(page, pageSize2, requestBody)
});
var __create$2 = Object.create;
var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __knownSymbol$2 = (name, symbol) => (symbol = Symbol[name]) ? symbol : /* @__PURE__ */ Symbol.for("Symbol." + name);
var __typeError$2 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __decoratorStart$2 = (base) => [, , , __create$2(null)];
var __decoratorStrings$2 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$2 = (fn3) => fn3 !== void 0 && typeof fn3 !== "function" ? __typeError$2("Function expected") : fn3;
var __decoratorContext$2 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$2[kind], name, metadata, addInitializer: (fn3) => done._ ? __typeError$2("Already initialized") : fns.push(__expectFn$2(fn3 || null)) });
var __decoratorMetadata$2 = (array, target) => __defNormalProp$2(target, __knownSymbol$2("metadata"), array[3]);
var __runInitializers$2 = (array, flags, self2, value) => {
  for (var i = 0, fns = array[flags >> 1], n12 = fns && fns.length; i < n12; i++) fns[i].call(self2);
  return value;
};
var __decorateElement$2 = (array, flags, name, decorators, target, extra) => {
  var it, done, ctx, access, k = flags & 7, s12 = false, p = false;
  var j = 2, key = __decoratorStrings$2[k + 5];
  var extraInitializers = array[j] || (array[j] = []);
  var desc = (target = target.prototype, __getOwnPropDesc$2(target, name));
  for (var i = decorators.length - 1; i >= 0; i--) {
    ctx = __decoratorContext$2(k, name, done = {}, array[3], extraInitializers);
    {
      ctx.static = s12, ctx.private = p, access = ctx.access = { has: (x) => name in x };
      access.get = (x) => x[name];
    }
    it = (0, decorators[i])(desc[key], ctx), done._ = 1;
    __expectFn$2(it) && (desc[key] = it);
  }
  return desc && __defProp$2(target, name, desc), target;
};
var _searchAllPeopleWithOrgAccess_dec, _init$2;
_searchAllPeopleWithOrgAccess_dec = [cached("People")];
class PeopleCachedApi {
  constructor() {
    __runInitializers$2(_init$2, 5, this);
  }
  async searchAllPeopleWithOrgAccess(arg2) {
    return searchAllPeopleWithOrgAccess(arg2);
  }
}
_init$2 = __decoratorStart$2();
__decorateElement$2(_init$2, 1, "searchAllPeopleWithOrgAccess", _searchAllPeopleWithOrgAccess_dec, PeopleCachedApi);
__decoratorMetadata$2(_init$2, PeopleCachedApi);
const peopleCachedApi = new PeopleCachedApi();
const classificationMap = /* @__PURE__ */ new Map([
  ["EXEMPT", "exempt"],
  ["NON_EXEMPT", "non-exempt"],
  ["NON_EMPLOYEE", "non-employee"],
  ["SUBCONTRACTOR", "subcontractor"],
  ["UNEXPECTED", "unexpected"]
]);
const getPlatformClassification = (classification) => {
  for (const [key, value] of Array.from(classificationMap.entries())) {
    if (classification === value) {
      return key;
    }
  }
  throw new Error("Unexpected classification `${classification}`");
};
const fromPlatformPersonRateModel = (r12) => {
  const classification = classificationMap.get(r12.classification) ?? "unexpected";
  const person = {
    key: r12.key || -1,
    personKey: r12.personKey || -1,
    costStructLaborKey: r12.costStructLaborKey || 0,
    costRate: r12.costRate || 0,
    billRate: r12.billRate || 0,
    classification,
    beginDate: fromISODateString(r12.beginDate),
    endDate: fromISODateString(r12.endDate)
  };
  if (!r12.costStructLaborKey) {
    delete person.costStructLaborKey;
  }
  return person;
};
const toPlatformPersonRateModel = (r12) => {
  return {
    key: r12.key,
    personKey: r12.personKey,
    costStructLaborKey: r12.costStructLaborKey,
    costRate: r12.costRate,
    billRate: r12.billRate,
    classification: getPlatformClassification(r12.classification),
    beginDate: formatDate(r12.beginDate, { format: "iso", useBotEot: false }) ?? void 0,
    endDate: formatDate(r12.endDate, { format: "iso", useBotEot: false }) ?? void 0
  };
};
const getMyRates = async () => {
  try {
    const result = await with404(() => getMyRates$1(), []);
    return result.map(fromPlatformPersonRateModel);
  } catch (e) {
    return [];
  }
};
const getPseudoRatesForClassification = async (personKey, classificationDate) => {
  const rate = fromPlatformPersonRateModel({
    personKey,
    classification: "",
    beginDate: BOTKey$1,
    endDate: EOTKey$1
  });
  try {
    const classification = await getPersonClassificationByDate$1(
      personKey,
      classificationDate
    );
    rate.classification = classificationMap.get(classification) ?? "unexpected";
    return [rate];
  } catch (e) {
    return [rate];
  }
};
const getPersonRates = async (personKey) => {
  try {
    const result = await with404(() => getPersonRates$1(personKey), []);
    return result.map(fromPlatformPersonRateModel);
  } catch (e) {
    return [];
  }
};
const updatePersonRate = async (rate) => {
  const body = toPlatformPersonRateModel(rate);
  await updatePersonRate$1(body);
};
const effectiveDate = (rates) => {
  const sorted = (rates || []).sort(
    (a, b) => a.beginDate.diff(b.beginDate).as("days")
  );
  return sorted.length ? sorted[0].beginDate : DateTime.local(NaN, NaN, NaN);
};
const index$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEFAULT_PERSON_CLASSIFICATION,
  INT_ROLES,
  PERSON_CLASSIFICATIONS_KEY_CODE_NAME,
  PERSON_CLASSIFICATIONS_KEY_NAME,
  Person,
  effectiveDate,
  emptyPersonSummary,
  fetchPeopleList,
  fromPersonBaseModel,
  fromPersonBaseModelOrEmpty,
  fromPersonModel,
  getAllSkillLevels,
  getAllSkillTypes,
  getMyRates,
  getPerson,
  getPersonClassificationByDate,
  getPersonRates,
  getPersonUdfMetadata,
  getPseudoRatesForClassification,
  lastNameFirstNameWithUsername,
  listPeople,
  peopleCachedApi,
  readPerson,
  searchAllPeople,
  searchAllPeopleAssignments,
  searchAllPeopleByKeys,
  searchAllPeopleByName,
  searchAllPeopleSummaries,
  searchAllPeopleWithOrgAccess,
  searchAllSkills,
  searchPeople,
  searchPeopleAssignments,
  searchPeopleWithOrgAccess,
  timeEntryIncrementList,
  updatePersonRate
}, Symbol.toStringTag, { value: "Module" }));
const fileToAttachment = async (attachment) => {
  let binary = "";
  const bytes = new Uint8Array(await attachment.arrayBuffer());
  for (let i = 0, len = bytes.length; i < len; ++i) {
    binary += String.fromCharCode(bytes[i]);
  }
  return {
    name: attachment.name,
    mimeType: attachment.type,
    length: attachment.size,
    data: btoa(binary)
  };
};
const fromPlatformFiscalPeriod = (fiscalPeriod) => ({
  ...fiscalPeriod,
  beginDate: fiscalPeriod.beginDate ? DateTime.fromISO(fiscalPeriod.beginDate) : void 0,
  endDate: fiscalPeriod.endDate ? DateTime.fromISO(fiscalPeriod.endDate) : void 0
});
const fromPlatformFixedAssetJournalEntry = (journalEntry) => ({
  ...journalEntry,
  extractTimestamp: journalEntry.extractTimestamp ? DateTime.fromISO(journalEntry.extractTimestamp) : void 0,
  postDate: DateTime.fromISO(journalEntry.postDate),
  transactionDate: journalEntry.transactionDate ? DateTime.fromISO(journalEntry.transactionDate) : void 0
});
const fromPlatformFixedAsset = (fixedAsset) => ({
  ...fixedAsset,
  acquisitionDate: fixedAsset.acquisitionDate ? DateTime.fromISO(fixedAsset.acquisitionDate) : void 0,
  depreciationStartDate: DateTime.fromISO(fixedAsset.depreciationStartDate),
  disposalDate: fixedAsset.disposalDate ? DateTime.fromISO(fixedAsset.disposalDate) : void 0,
  inServiceDate: DateTime.fromISO(fixedAsset.inServiceDate),
  lastPostDate: fixedAsset.lastPostDate ? DateTime.fromISO(fixedAsset.lastPostDate) : void 0,
  udfs: fromPlatformUdfValueListModel(fixedAsset.udfs)
});
const fromPlatformFixedAssetCreateModel = (model) => {
  const {
    acquisitionDate,
    disposalDate,
    inServiceDate,
    depreciationStartDate,
    udfs
  } = model;
  return {
    ...model,
    acquisitionDate: acquisitionDate ? DateTime.fromISO(acquisitionDate) : void 0,
    disposalDate: disposalDate ? DateTime.fromISO(disposalDate) : void 0,
    inServiceDate: DateTime.fromISO(inServiceDate),
    depreciationStartDate: DateTime.fromISO(depreciationStartDate),
    udfs: fromPlatformUdfValueListModel(udfs)
  };
};
const fromPlatformFixedAssetSchedule = (schedule) => ({
  ...schedule,
  beginDate: DateTime.fromISO(schedule.beginDate),
  endDate: DateTime.fromISO(schedule.endDate)
});
const toPlatformFixedAssetCreateModel = (model) => {
  const {
    acquisitionDate,
    disposalDate,
    inServiceDate,
    depreciationStartDate,
    udfs
  } = model;
  return {
    ...model,
    acquisitionDate: acquisitionDate?.toISODate() ?? void 0,
    disposalDate: disposalDate?.toISODate() ?? void 0,
    inServiceDate: inServiceDate?.toISODate() ?? "",
    depreciationStartDate: depreciationStartDate?.toISODate() ?? "",
    udfs: toPlatformUdfValueListModel(udfs)
  };
};
const fromPlatformFixedAssetNoExtras = (fixedAsset) => ({
  ...fixedAsset,
  acquisitionDate: fixedAsset.acquisitionDate ? DateTime.fromISO(fixedAsset.acquisitionDate) : void 0,
  depreciationStartDate: DateTime.fromISO(fixedAsset.depreciationStartDate),
  disposalDate: fixedAsset.disposalDate ? DateTime.fromISO(fixedAsset.disposalDate) : void 0,
  disposalValue: fixedAsset.disposalType == "WRITE_OFF" ? void 0 : fixedAsset.disposalValue,
  inServiceDate: DateTime.fromISO(fixedAsset.inServiceDate),
  lastPostDate: fixedAsset.lastPostDate ? DateTime.fromISO(fixedAsset.lastPostDate) : void 0,
  udfs: fromPlatformUdfValueListModel(fixedAsset.udfs)
});
const toPlatformFixedAssetModel = (model) => {
  const {
    acquisitionDate,
    depreciationStartDate,
    disposalDate,
    inServiceDate,
    lastPostDate,
    udfs
  } = model;
  return {
    ...model,
    acquisitionDate: acquisitionDate?.toISODate() ?? void 0,
    depreciationStartDate: depreciationStartDate?.toISODate() ?? "",
    disposalDate: disposalDate?.toISODate() ?? void 0,
    inServiceDate: inServiceDate?.toISODate() ?? "",
    lastPostDate: lastPostDate?.toISODate() ?? void 0,
    udfs: toPlatformUdfValueListModel(udfs)
  };
};
const fromPlatformFixedAssetPostDocumentModel = (postDocument) => ({
  ...postDocument,
  actualsThroughDate: postDocument.actualsThroughDate ? DateTime.fromISO(postDocument.actualsThroughDate) : void 0,
  postDate: postDocument.postDate ? DateTime.fromISO(postDocument.postDate) : void 0
});
const fixedAssetAlertDocumentTypesMap = /* @__PURE__ */ new Map([
  ["VENDOR_INVOICE_POST", "Vendor Invoice"],
  ["VENDOR_PAYMENT_POST", "Vendor Payment"],
  ["CUSTOMER_PAYMENT_POST", "Customer Payment"],
  ["DEPOSIT_POST", "Deposit"],
  ["JOURNAL_ENTRY_POST", "Journal Entry"],
  ["BILLING_POST", "Billing"],
  ["INVOICE_POST", "Customer Invoice"],
  ["LABOR_COST_POST", "Timesheet"],
  ["EXPENSE_COST_POST", "Expense Report"],
  ["GL_CLOSING", "General Ledger"],
  ["COST_POOL_POST", "Cost Pool"],
  ["COMMITMENT", "Commitment"],
  ["FIXED_ASSET_POST", "Fixed Asset"],
  ["PILOB", "Pay In Lieu of Benefits"]
]);
const getFixedAssetAlertDocumentType = (feature) => fixedAssetAlertDocumentTypesMap.get(feature);
const getFixedAssetAlertDocumentTitle = (row) => {
  const feature = fixedAssetAlertDocumentTypesMap.get(row.feature);
  if (feature === "Expense Report" && row.description) {
    const descriptionSplit = row.description.split(" ");
    return descriptionSplit?.[1] ?? row.documentNumber;
  }
  return row.documentNumber;
};
const getFiscalPeriodDisplay = (fp) => {
  return fp.periodName ?? `${fp.fiscalYearName}-${fp.periodNumber.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false })}`;
};
const isFixedAssetDisposed = ({ asset }) => Boolean(asset.disposalDate);
const createFixedAsset = async ({
  asset,
  alertKey
}) => {
  try {
    const assetModel = toPlatformFixedAssetCreateModel(asset);
    const { key } = await addFixedAsset({
      asset: assetModel,
      alertKey
    });
    return key;
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error creating fixed asset`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Creating fixed asset failed`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const destroyFixedAsset = async ({
  fixedAssetKey
}) => {
  try {
    return await destroyFixedAsset$1({ fixedAssetKey });
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error deleting fixed asset: key=${fixedAssetKey}`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Deleting fixed asset failed: key=${fixedAssetKey}`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const editFixedAsset = async ({ asset }) => {
  try {
    const platformAsset = toPlatformFixedAssetModel(asset);
    return await editFixedAsset$1({ asset: platformAsset });
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error editing fixed asset: key=${asset.key}`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Editing fixed asset failed: key=${asset.key}`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const editFixedAssetFilterCriteria = async ({
  filterKey,
  requestBody,
  dashboards: dashboards2
}) => {
  try {
    return await editFixedAssetFilterCriteria$1({
      filterKey,
      requestBody,
      dashboards: dashboards2
    });
  } catch (e) {
    log.warn({
      msg: `Updating Fixed Asset Filter Criteria failed: ${JSON.stringify(
        requestBody
      )}`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchFixedAsset = async ({
  fixedAssetKey
}) => {
  try {
    const asset = await fetchFixedAsset$1({ fixedAssetKey });
    return fromPlatformFixedAssetNoExtras(asset);
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error fetching fixed asset: key=${fixedAssetKey}`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Fetching fixed asset failed: key=${fixedAssetKey}`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const fetchFixedAssets = async ({
  page
}) => {
  try {
    const results = await fetchFixedAssets$1({ page });
    return results.items ? {
      ...results,
      items: results.items.map(fromPlatformFixedAsset)
    } : {
      ...results,
      items: []
    };
  } catch (e) {
    log.warn({ msg: "Fetching fixed assets failed", error: `${e}` });
    throw e;
  }
};
const fetchFixedAssetLegalEntityFiscalPeriods = async ({
  legalEntityKey,
  page,
  pageSize: pageSize2,
  beginDate,
  includeClosedPeriods
}) => {
  try {
    const results = await fetchFixedAssetLegalEntityFiscalPeriods$1({
      legalEntityKey,
      page,
      pageSize: pageSize2,
      beginDate,
      includeClosedPeriods
    });
    return results.items ? {
      ...results,
      items: results.items.map(fromPlatformFiscalPeriod)
    } : {
      ...results,
      items: []
    };
  } catch (e) {
    log.warn({
      msg: "Fetching Fixed Asset Legal Entity Fiscal Periods failed",
      error: `${e}`
    });
    return { items: [] };
  }
};
const fetchAllFixedAssetSavedFilters = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  return fetchAllItems({
    fetch: (page) => () => fetchFixedAssetSavedFilters({
      page,
      pageSize: pageSize2
    }),
    errorMessage: "Fetching fixed assets saved filters failed"
  });
};
const fetchFixedAssetSavedFilter = async ({
  filterKey
}) => {
  try {
    const result = await fetchFixedAssetSavedFilter$1({
      filterKey
    });
    return result;
  } catch (e) {
    log.warn({
      msg: `Fetching fixed assets saved filter (filterKey:${filterKey}) failed`,
      error: `${e}`
    });
    throw e;
  }
};
const findFiscalPeriodByDate = ({
  fiscalPeriods,
  date
}) => {
  return fiscalPeriods.find(
    (fp) => !!date && !!fp.beginDate && !!fp.endDate && fp.beginDate.startOf("day") <= date.startOf("day") && fp.endDate.startOf("day") >= date.startOf("day")
  ) ?? null;
};
const findFixedAssetScheduleByDate = ({
  fixedAssetSchedule,
  date
}) => {
  return fixedAssetSchedule.find(
    (fas) => !!date && !!fas.beginDate && !!fas.endDate && fas.beginDate.startOf("day") <= date.startOf("day") && fas.endDate.startOf("day") >= date.startOf("day")
  ) ?? null;
};
const filterFixedAssetJournalEntriesByDateRange = ({
  journalEntries,
  beginDate,
  endDate
}) => {
  return journalEntries.filter((entry) => {
    const { transactionDate: date } = entry;
    return !!date && beginDate.startOf("day") <= date && date <= endDate.endOf("day");
  });
};
const getAllFixedAssetsLegalEntities = async ({
  active = true,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  errorMessage: "Fetching legal entities for fixed asset filter data failed",
  fetch: (page) => () => fetchFixedAssetsLegalEntities({ active, page, pageSize: pageSize2 })
});
const getFixedAssetDepreciationSchedules = async ({
  fixedAssetKey,
  page,
  pageSize: pageSize2 = 50
}) => {
  try {
    const results = await fetchFixedAssetDepreciationSchedules({
      fixedAssetKey,
      page,
      pageSize: pageSize2
    });
    return results.items ? {
      ...results,
      items: results.items.map(fromPlatformFixedAssetSchedule)
    } : {
      ...results,
      items: []
    };
  } catch (e) {
    log.warn({
      msg: `Fetching fixed asset (key: ${fixedAssetKey}}) depreciation schedules failed`,
      error: `${e}`
    });
    throw e;
  }
};
const getAllFixedAssetDepreciationSchedules = async ({
  fixedAssetKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const items = await fetchAllItems({
    errorMessage: `Fetching fixed asset (key: ${fixedAssetKey}) depreciation schedules failed`,
    fetch: (page) => () => fetchFixedAssetDepreciationSchedules({
      fixedAssetKey,
      page,
      pageSize: pageSize2
    })
  });
  return items.map(fromPlatformFixedAssetSchedule);
};
const getFixedAssetJournalEntries = async ({
  fixedAssetKey,
  category,
  page,
  pageSize: pageSize2 = 50
}) => {
  try {
    const resultPage = await fetchFixedAssetJournalEntries({
      fixedAssetKey,
      category,
      page,
      pageSize: pageSize2
    });
    return mapListPage(resultPage, fromPlatformFixedAssetJournalEntry);
  } catch (e) {
    log.warn({
      msg: `Fetching fixed asset (id: ${fixedAssetKey}}) journal entries failed`,
      error: `${e}`
    });
    throw e;
  }
};
const getAllFixedAssetJournalEntries = async ({
  category,
  fixedAssetKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const items = await fetchAllItems({
    errorMessage: `Fetching fixed asset (key: ${fixedAssetKey}}) journal entries failed`,
    fetch: (page) => () => fetchFixedAssetJournalEntries({
      category,
      fixedAssetKey,
      page,
      pageSize: pageSize2
    })
  });
  return items.map(fromPlatformFixedAssetJournalEntry);
};
const getAllFixedAssetLegalEntityOrganizations = async ({
  legalEntityKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  errorMessage: `Fetching fixed asset legal entity organizations failed: legalEntityKey=${legalEntityKey}`,
  fetch: (page) => () => fetchFixedAssetLegalEntityOrganizations({
    legalEntityKey,
    page,
    pageSize: pageSize2
  })
});
const getAllFixedAssetPosters = async ({
  includeInactive,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const items = await fetchAllItems({
    errorMessage: "Fetching fixed asset posters failed",
    fetch: (page) => () => fetchFixedAssetPosters({ includeInactive, page, pageSize: pageSize2 })
  });
  return items.map((i) => new Person(i));
};
const getFixedAssetNetValue = ({
  fixedAsset
}) => {
  if (fixedAsset.hasPostedDisposal) {
    return 0;
  } else {
    const depreciation = (fixedAsset.depreciationStartBalance ?? 0) + (fixedAsset.accumulatedDepreciation ?? 0);
    return fixedAsset.acquisitionValue - depreciation;
  }
};
const getFixedAssetsUdfMetadata = async () => fetchUdfMetadataList(UdfMetadataType.FIXED_ASSET);
const postFixedAssets = async ({
  requestBody
}) => {
  try {
    return await postFixedAssets$1({ requestBody });
  } catch (e) {
    log.warn({
      msg: `Posting Fixed Assets failed`,
      error: `${e}`
    });
    throw e;
  }
};
const saveFixedAssetFilterCriteria = async ({
  requestBody,
  dashboards: dashboards2
}) => {
  try {
    return await saveFixedAssetsFilterCriteria({
      requestBody,
      dashboards: dashboards2
    });
  } catch (e) {
    log.warn({
      msg: `Saving Fixed Asset Filter Criteria failed: ${JSON.stringify(requestBody)}`,
      error: `${e}`
    });
    throw e;
  }
};
const searchFixedAssets = async ({
  search,
  page,
  pageSize: pageSize2 = 50
}) => {
  try {
    const list2 = await searchFixedAssets$1({
      requestBody: search,
      page,
      pageSize: pageSize2
    });
    return mapListPage(list2, fromPlatformFixedAsset);
  } catch (e) {
    log.warn({
      msg: `Searching fixed assets failed: ${JSON.stringify(search)}`,
      error: `${e}`
    });
    throw e;
  }
};
const searchAllFixedAssets = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  search
}) => {
  const items = await fetchAllItems({
    errorMessage: "Fetching all fixed assets failed",
    fetch: (page) => () => searchFixedAssets$1({ requestBody: search, page, pageSize: pageSize2 })
  });
  return items.map(fromPlatformFixedAsset);
};
const getFixedAssetImportDefinition = async () => {
  try {
    return await fetchFixedAssetImportDefinition();
  } catch (e) {
    log.warn({
      msg: `Fetching Fixed Asset Import Template failed`,
      error: `${e}`
    });
    throw e;
  }
};
const importFixedAssets = async (file, {
  dryRun = false,
  enableProgressFeedback = false
}) => {
  try {
    return await importFixedAssets$1(file, {
      dryRun,
      enableProgressFeedback
    });
  } catch (e) {
    log.warn({
      msg: `Uploading Fixed Asset Import failed`,
      error: `${e}`
    });
    throw e;
  }
};
const searchFixedAssetsPosts = async ({
  search,
  page,
  pageSize: pageSize2 = 50
}) => {
  try {
    const results = await searchFixedAssetsPosts$1({
      requestBody: search,
      page,
      pageSize: pageSize2
    });
    return results.items ? {
      ...results,
      items: results.items.map(fromPlatformFixedAssetPostDocumentModel)
    } : {
      ...results,
      items: []
    };
  } catch (e) {
    log.warn({
      msg: "Searching fixed asset posts failed",
      error: `${e}`
    });
    throw e;
  }
};
const unpostFixedAsset = async ({
  fixedAssetKey,
  statusKey
}) => {
  try {
    await unpostFixedAsset$1({ fixedAssetKey, statusKey });
    return { key: fixedAssetKey };
  } catch (e) {
    log.warn({
      msg: `Unposting document key:${fixedAssetKey} failed`
    });
    throw e;
  }
};
const getLegalEntityFiscalPeriodBalances = async ({
  legalEntityKey
}) => {
  try {
    const balances = await fetchFixedAssetLegalEntityBalances({
      legalEntityKey
    });
    return balances;
  } catch (e) {
    log.warn({
      msg: `Fetching Fixed Asset Fiscal Period Balances failed`,
      error: `${e}`
    });
    throw e;
  }
};
const getAllFixedAssetsAlerts = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  return fetchAllItems({
    fetch: (page) => () => fetchFixedAssetsAlerts({ page, pageSize: pageSize2 }),
    errorMessage: "Fetching fixed assets alerts failed"
  });
};
const deleteFixedAssetAlert = async ({
  alertKey
}) => {
  try {
    await deleteFixedAssetAlert$1({ alertKey });
    return alertKey;
  } catch (e) {
    log.warn({ msg: "Deleting fixed asset alert failed", error: `${e}` });
    throw e;
  }
};
const setFixedAssetAlertReadStatus = async ({
  alertKey,
  read: read2
}) => {
  try {
    await setFixedAssetAlertReadStatus$1({
      alertKey,
      read: read2
    });
    return alertKey;
  } catch (e) {
    log.warn({ msg: "Setting fixed assets alert failed", error: `${e}` });
    throw e;
  }
};
const fetchFixedAssetAttachments = async ({
  fixedAssetKey
}) => fetchAllItems({
  errorMessage: "Fetching fixed asset attachments failed",
  fetch: (page) => () => fetchFixedAssetAttachments$1({ fixedAssetKey, page })
});
const fetchFixedAssetAttachment = async ({
  fixedAssetKey,
  attachmentKey
}) => {
  try {
    const attachment = await fetchFixedAssetAttachment$1({
      fixedAssetKey,
      attachmentKey
    });
    return attachment;
  } catch (e) {
    log.warn({
      msg: `Fetching Fixed Asset Attachment failed`,
      error: `${e}`
    });
    throw e;
  }
};
const createFixedAssetAttachments = async ({
  fixedAssetKey,
  files
}) => {
  const promises = files.map(async (file) => {
    const attachment = await fileToAttachment(file);
    const { key: fileKey } = await createFixedAssetAttachment({
      fixedAssetKey,
      attachment
    });
    return fileKey;
  });
  const results = await Promise.allSettled(promises);
  log.info({
    msg: "Fixed Asset attachments uploaded",
    files: files.length,
    rejected: results.filter((r12) => r12.status === "rejected").length
  });
  if (results.some((r12) => r12.status === "rejected")) {
    throw new AppError("Error uploading attachments", ErrorCode.None);
  }
  return results;
};
const destroyFixedAssetAttachment = async ({
  fixedAssetKey,
  attachmentKey
}) => {
  try {
    return await destroyFixedAssetAttachment$1({
      fixedAssetKey,
      attachmentKey
    });
  } catch (e) {
    if (e.statusCode === 400) {
      log.info({
        msg: `Expected error deleting fixed asset attachment: fixedAssetKey=${fixedAssetKey}, attachmentKey=${attachmentKey}`,
        error: `${e}`
      });
    } else {
      log.warn({
        msg: `Deleting fixed asset attachment failed: fixedAssetKey=${fixedAssetKey}, attachmentKey=${attachmentKey}`,
        error: `${e}`
      });
    }
    throw e;
  }
};
const getFixedAssetLocations = async ({
  fixedAssetKey,
  page,
  pageSize: pageSize2
}) => {
  try {
    return await getFixedAssetLocations$1({
      fixedAssetKey,
      page,
      pageSize: pageSize2
    });
  } catch (e) {
    log.info({
      msg: `Error fetching fixed asset locations (fixedAssetKey: ${fixedAssetKey})`,
      error: `${e}`
    });
    throw e;
  }
};
const addFixedAssetLocation = async ({
  fixedAssetKey,
  location
}) => {
  try {
    return await addFixedAssetLocation$1({
      fixedAssetKey,
      location
    });
  } catch (e) {
    log.warn({
      msg: `Error adding fixed asset location (fixedAssetKey: ${fixedAssetKey})`,
      error: `${e}`
    });
    throw e;
  }
};
const addFixedAssetLocations = async ({
  fixedAssetKey,
  locations: locations2
}) => {
  try {
    for (const location of locations2) {
      await addFixedAssetLocation$1({ fixedAssetKey, location });
    }
  } catch (e) {
    log.warn({
      msg: `Error adding fixed asset locations (fixedAssetKey: ${fixedAssetKey})`,
      error: `${e}`
    });
    throw e;
  }
};
const editFixedAssetLocation = async ({
  fixedAssetKey,
  location,
  toUpdate
}) => {
  try {
    return await editFixedAssetLocation$1({
      fixedAssetKey,
      location,
      toUpdate
    });
  } catch (e) {
    log.warn({
      msg: `Error updating fixed asset location (fixedAssetKey: ${fixedAssetKey})`,
      error: `${e}`
    });
    throw e;
  }
};
const destroyFixedAssetLocation = async ({
  fixedAssetKey,
  locationKey
}) => {
  try {
    return await destroyFixedAssetLocation$1({
      fixedAssetKey,
      locationKey
    });
  } catch (e) {
    log.warn({
      msg: `Error deleting fixed asset location (fixedAssetKey: ${fixedAssetKey}, locationKey: ${locationKey})`,
      error: `${e}`
    });
    throw e;
  }
};
const destroyAllFixedAssetLocations = async ({
  fixedAssetKey,
  locationKeys
}) => {
  try {
    return await Promise.all(
      locationKeys.map(
        (locationKey) => destroyFixedAssetLocation$1({ fixedAssetKey, locationKey })
      )
    );
  } catch (e) {
    log.warn({
      msg: `Error deleting all fixed asset locations (fixedAssetKey: ${fixedAssetKey}, locationKeys: ${locationKeys})`,
      error: `${e}`
    });
    throw e;
  }
};
const CSV_HEADER = [
  "*fixed_asset_number",
  "legal_entity",
  "owner",
  "serial_number",
  "name",
  "description",
  "class",
  "status",
  "acquisition_date",
  "acquisition_value",
  "disposal_date",
  "disposal_value",
  "disposal_type",
  "placed_in_service_date",
  "useful_life",
  "salvage_value",
  "depreciation_start_date",
  "prior_depreciation_balance",
  "depreciation_method",
  "depreciation_averaging_method",
  "location",
  "location_begin_date",
  "asset_org",
  "expense_org",
  // UDF's will be inserted after this field
  "delete"
];
const extractUsername = (name) => {
  if (!name) {
    return "";
  }
  const pos1 = name.lastIndexOf("(");
  if (pos1 < 0) {
    return "";
  }
  const pos2 = name.indexOf(")", pos1 + 1);
  if (pos2 < 0) {
    return "";
  }
  return name.substring(pos1 + 1, pos2);
};
const getHeaderRow = (udfs) => {
  const udfsToInsert = udfs.map((_, index2) => {
    const udfNumber = index2 + 1;
    const udf = `user${udfNumber.toString().padStart(2, "0")}`;
    return udf;
  });
  const insertIndex = CSV_HEADER.indexOf("expense_org") + 1;
  const row = [...CSV_HEADER];
  row.splice(insertIndex, 0, ...udfsToInsert);
  return row;
};
const convertDepreciationAveragingMethod = (method) => {
  if (method === "FISCAL_PERIOD") {
    return "M";
  }
  if (method === "DAILY") {
    return "D";
  }
  return " ";
};
const convertDepreciationMethod = (method) => {
  if (method === "STRAIGHT_LINE") {
    return "S";
  }
  if (method === "NONE") {
    return "N";
  }
  return " ";
};
const getFixedAssetsCsv = async ({
  assets
}) => {
  const rows = [];
  rows.push(getHeaderRow(assets[0].udfs));
  for (const asset of assets) {
    const assetLocation = await fetchFixedAssetLocations({
      fixedAssetKey: asset.key,
      page: 1
    });
    let row;
    if (assetLocation?.error) {
      row = [asset.key, "Failed to get location", assetLocation.error];
    } else {
      const decimals = asset.currency?.code ? getCurrencySpec(asset.currency.code).decimals : 4;
      const location = assetLocation?.location;
      row = [
        asset.fixedAssetNumber,
        asset.legalEntity.code,
        asset.owner?.name ? extractUsername(asset.owner.name) : "",
        asset.serialNumber ?? "",
        asset.name,
        asset.description ?? "",
        asset.faClassKey?.name ?? "",
        asset.faStatusKey?.name ?? "",
        asset.acquisitionDate ? formatDate(asset.acquisitionDate, {
          format: "iso",
          useBotEot: false
        }) : "",
        asset.acquisitionValue.toFixed(decimals),
        asset.disposalDate ? formatDate(asset.disposalDate, {
          format: "iso",
          useBotEot: false
        }) : "",
        asset.disposalValue?.toFixed(decimals) ?? "",
        asset.disposalType ?? "",
        formatDate(asset.inServiceDate, {
          format: "iso",
          useBotEot: false
        }),
        asset.usefulLife,
        asset.salvageValue?.toFixed(decimals) ?? "",
        asset.depreciationStartDate ? formatDate(asset.depreciationStartDate, {
          format: "iso",
          useBotEot: false
        }) : "",
        asset.depreciationStartBalance?.toFixed(decimals) ?? "",
        convertDepreciationMethod(asset.depreciationMethod),
        convertDepreciationAveragingMethod(asset.averagingMethod),
        location?.location?.name ?? "",
        location?.beginDate ?? "",
        asset.assetOrg?.code ?? "",
        asset.expenseOrg?.code ?? ""
      ];
      asset.udfs.forEach((u) => {
        let value;
        if (u.metadata?.visibility !== "NONE") {
          value = formatUdfValue(u, { format: "iso", useBotEot: false }) ?? "";
        }
        row.push(value ?? "");
      });
      row.push("");
    }
    rows.push(row);
  }
  return stringify$1(rows);
};
const fetchFixedAssetLocations = async ({
  fixedAssetKey,
  page
}) => {
  try {
    const locations2 = await getFixedAssetLocations({ fixedAssetKey, page });
    const now2 = DateTime.local();
    const currentLocations = locations2.items.filter((loc) => {
      const beginDate = DateTime.fromISO(loc.beginDate);
      const endDate = DateTime.fromISO(loc.endDate);
      return beginDate <= now2 && now2 <= endDate;
    });
    return { location: currentLocations[0] };
  } catch (e) {
    log.warn({
      msg: `Failed to get locations for fixed asset with key: ${fixedAssetKey}`,
      e
    });
    return { error: e };
  }
};
const addFixedAssetStatus = async (requestBody) => {
  try {
    const results = await addFixedAssetStatus$1(requestBody);
    return results;
  } catch (e) {
    log.warn({ msg: "Adding new fixed assets statuses failed", error: `${e}` });
    throw e;
  }
};
const destroyFixedAssetStatus = async ({
  fixedAssetKey
}) => {
  try {
    const results = await destroyFixedAssetStatus$1({
      statusKey: fixedAssetKey
    });
    return results;
  } catch (e) {
    log.warn({
      msg: `Deleting fixed assets status:${fixedAssetKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const editFixedAssetStatus = async (status) => {
  try {
    const results = await editFixedAssetStatus$1({
      statusKey: status.key,
      requestBody: status
    });
    return results;
  } catch (e) {
    log.warn({ msg: "Updating fixed assets statuses failed", error: `${e}` });
    throw e;
  }
};
const fetchAllFixedAssetStatuses = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  return fetchAllItems({
    fetch: (page) => () => fetchFixedAssetsStatuses({ page, pageSize: pageSize2 }),
    errorMessage: "Fetching fixed assets statuses failed"
  });
};
const searchPlannedTime = async (requestBody, page, pageSize2) => {
  try {
    const results = await searchPlannedTime$1(
      page,
      pageSize2,
      requestBody
    );
    return results.items || [];
  } catch (e) {
    log.warn({ msg: "Searching planned time data failed", error: `${e}` });
    throw e;
  }
};
const searchAllPlannedTime = async (requestBody, pageSize2 = MAX_PLATFORM_PAGE_SIZE) => fetchAllItems({
  errorMessage: "Searching and returning all planned times failed",
  fetch: (page) => () => searchPlannedTime$1(page, pageSize2, requestBody)
});
const searchPlannedTimeMatrix = async (params) => {
  try {
    const matrix = await searchPlannedTimeMatrix$1(params);
    return matrix.entries ?? [];
  } catch (e) {
    log.warn({
      msg: "Searching planned time matrix data failed",
      error: `${e}`
    });
    throw e;
  }
};
const searchPlannedTimePeopleAllocation = async (params) => {
  try {
    const result = await searchPlannedTimePeopleAllocation$1(params);
    return result.people ?? [];
  } catch (e) {
    log.warn({
      msg: "Searching planned time people allocation data failed",
      error: `${e}`
    });
    throw e;
  }
};
const searchAllPlannedTimePeople = async ({
  params = {},
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const items = await fetchAllItems({
    errorMessage: "Searching and returning all planned time people failed",
    fetch: (page) => () => searchPlannedTimePeople({ params, page, pageSize: pageSize2 })
  });
  return items.map((ci) => new Person(ci));
};
const searchPlannedTimePeople = async ({
  params,
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    const results = await searchPlannedTimePeople$1({
      requestBody: params,
      page,
      pageSize: pageSize2
    });
    return mapListPage(results, (item) => new Person(item));
  } catch (e) {
    log.warn({
      msg: "Searching planned time people data failed",
      error: `${e}`
    });
    throw e;
  }
};
const searchAllPlannedTimeProjects = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  params = {}
}) => fetchAllItems({
  errorMessage: "Searching and returning all planned time projects failed",
  fetch: (page) => () => searchPlannedTimeProjects(page, pageSize2, params)
});
const searchAssignablePlannedTime = async (requestBody, page = 1, pageSize2 = 50) => {
  try {
    const result = await searchAssignablePlannedTime$1(
      requestBody,
      page,
      pageSize2
    );
    return result;
  } catch (e) {
    log.warn({
      msg: "Searching assignable planned time data failed",
      error: `${e}`
    });
    throw e;
  }
};
const getAllAssignablePlannedTime = async (requestBody, pageSize2 = MAX_PLATFORM_PAGE_SIZE) => {
  return fetchAllItems({
    fetch: (page) => () => searchAssignablePlannedTime(requestBody, page, pageSize2)
  });
};
const getPlannedTime = async (id) => {
  try {
    const plannedTime = await getPlannedTime$1(id);
    return plannedTime;
  } catch (e) {
    log.warn({
      msg: "Fetching planned time data failed",
      key: id,
      error: `${e}`
    });
    throw e;
  }
};
const updatePlannedTime = async (time2) => {
  try {
    await updatePlannedTime$1(time2);
    log.info({ msg: "Planned time updated", key: time2.key });
  } catch (e) {
    log.warn({
      msg: "Updating planned time failed",
      key: time2.key,
      error: `${e}`
    });
    throw e;
  }
};
const createPlannedTime = async (time2) => {
  try {
    const { key } = await createPlannedTime$1(time2);
    log.info({ msg: "Planned time created", key });
    return key;
  } catch (e) {
    log.warn({ msg: "Creating planned time failed", time: time2, error: `${e}` });
    throw e;
  }
};
const deletePlannedTime = async (key) => {
  try {
    await deletePlannedTime$1(key);
    log.info({ msg: "Planned time deleted", key });
  } catch (e) {
    log.warn({ msg: "Deleting planned time failed", key, error: `${e}` });
    throw e;
  }
};
const getProjectPlanDefaults = async ({
  projectKey,
  personKey,
  date
}) => {
  try {
    return await getProjectPlanDefaults$1(projectKey, personKey, date);
  } catch (e) {
    log.warn({
      msg: "Fetching plan defaults failed",
      error: `${e}`
    });
    throw e;
  }
};
const getAllPlannedTimeSaveCriteria = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  errorMessage: "Searching and returning all planned time save criteria failed",
  fetch: (page) => () => getPlannedTimeSaveCriteria({ page, pageSize: pageSize2 })
});
const getPlannedTimeSaveCriteria = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    return await getPlannedTimeSaveCriteria$1({ page, pageSize: pageSize2 });
  } catch (e) {
    log.warn({
      msg: "Getting planned time save criteria failed",
      error: `${e}`
    });
    throw e;
  }
};
const getPlannedTimeSaveCriteriaById = async (id) => {
  try {
    return await getPlannedTimeSaveCriteriaById$1(id);
  } catch (e) {
    log.warn({
      msg: `Getting planned time save criteria for id: ${id} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const updatePlannedTimeSaveCriteria = async (params) => {
  try {
    await updatePlannedTimeSaveCriteria$1(params);
    return { key: params.id };
  } catch (e) {
    log.warn({
      msg: `Updating planned time save criteria for id: ${params.id} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const getAllPlannedTimeSharedSaveCriteria = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  errorMessage: "Searching and returning all planned shared save criteria failed",
  fetch: (page) => () => getPlannedTimeSharedSaveCriteria({ page, pageSize: pageSize2 })
});
const getPlannedTimeSharedSaveCriteria = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    return await getPlannedTimeSharedSaveCriteria$1({ page, pageSize: pageSize2 });
  } catch (e) {
    log.warn({
      msg: "Getting planned time shared save criteria failed",
      error: `${e}`
    });
    throw e;
  }
};
const getPlannedTimeSharedSaveCriteriaById = async (id) => {
  try {
    return await getPlannedTimeSharedSaveCriteriaById$1(id);
  } catch (e) {
    log.warn({
      msg: `Getting planned time shared save criteria for id: ${id} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const updatePlannedTimeSharedSaveCriteria = async (params) => {
  try {
    await updatePlannedTimeSharedSaveCriteria$1(params);
    return { key: params.id };
  } catch (e) {
    log.warn({
      msg: `Updating planned time shared save criteria for id: ${params.id} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const createPlannedTimeCriteria = async (params) => {
  try {
    return await createPlannedTimeCriteria$1(params);
  } catch (e) {
    log.warn({
      msg: "Saving planned time save criteria failed",
      error: `${e}`
    });
    throw e;
  }
};
const createPlannedTimeSharedCriteria = async (requestBody, dashboards2) => {
  try {
    return await createPlannedTimeSharedCriteria$1(
      requestBody,
      dashboards2
    );
  } catch (e) {
    log.warn({
      msg: "Saving planned time shared save criteria failed",
      error: `${e}`
    });
    throw e;
  }
};
const deletePlannedTimeSaveCriteria = async (id) => {
  try {
    await deletePlannedTimeCriteria(id);
    return { key: id };
  } catch (e) {
    log.warn({
      msg: `Deleting planned time save criteria for id: ${id} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const deletePlannedTimeSharedSaveCriteria = async (id) => {
  try {
    await deletePlannedTimeSharedCriteria(id);
    return { key: id };
  } catch (e) {
    log.warn({
      msg: `Deleting planned time shared save criteria for id: ${id} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const getPlannedTimePersonOrganizations = async ({
  code,
  projectKey,
  page,
  pageSize: pageSize2
}) => {
  try {
    return await getPlannedTimePersonOrganizations$1({
      code,
      projectKey,
      page,
      pageSize: pageSize2
    });
  } catch (e) {
    log.warn({
      msg: `Getting planned time person organizations failed`,
      error: `${e}`
    });
    throw e;
  }
};
const getAllPlannedTimePersonOrganizations = async ({
  code,
  projectKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  return fetchAllItems({
    fetch: (page) => () => getPlannedTimePersonOrganizations$1({
      code,
      projectKey,
      page,
      pageSize: pageSize2
    }),
    errorMessage: "Getting all planned time person organizations failed"
  });
};
const getBookedPlannedTime = async (id, requestBody) => {
  try {
    const bookedPlan = await getBookedPlannedTime$1(id, requestBody);
    return bookedPlan;
  } catch (e) {
    log.warn({
      msg: `Fetching planned booked time for id: ${id} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const getBusinessHoursForPeriods = ({
  businessWeek,
  periods
}) => {
  if (!businessWeek) {
    return 0;
  }
  return periods.reduce((total, period) => {
    const start2 = DateTime.fromISO(period.rangeStart);
    const end2 = DateTime.fromISO(period.rangeEnd);
    if (!start2.isValid || !end2.isValid || end2 < start2) {
      return total;
    }
    return total + businessHoursBetween(start2, end2, businessWeek);
  }, 0);
};
const getUtilizationForPeriods = ({
  businessWeek,
  hours,
  periods
}) => {
  const businessHours = getBusinessHoursForPeriods({ businessWeek, periods });
  if (!(businessHours > 0)) {
    return null;
  }
  return hours / businessHours;
};
var ForecastingMatrixSearchCriteriaTypesEnum = /* @__PURE__ */ ((ForecastingMatrixSearchCriteriaTypesEnum2) => {
  ForecastingMatrixSearchCriteriaTypesEnum2["assigning"] = "FORECASTING_MATRIX_SEARCH_CRITERIA_TYPE_ASSIGNING";
  ForecastingMatrixSearchCriteriaTypesEnum2["planning"] = "FORECASTING_MATRIX_SEARCH_CRITERIA_TYPE_PLANNING";
  return ForecastingMatrixSearchCriteriaTypesEnum2;
})(ForecastingMatrixSearchCriteriaTypesEnum || {});
const mapAssignedSaveCriteriaToForcastedSaveCriteria = ({
  assigningCriteria,
  shared = false
}) => {
  const forecastingCriteria = {
    ...assigningCriteria,
    shared,
    type: ForecastingMatrixSearchCriteriaTypesEnum.assigning
  };
  return forecastingCriteria;
};
const mapForecastedSaveCriteriaToAssignedSaveCriteria = (forecastedSaveCriteria) => {
  const assigningSearchCriteria = {
    ...omit(forecastedSaveCriteria, [
      "dashboards",
      "interactivePlanner",
      "plan",
      "planSetKey",
      "planSetNameKey",
      "shared",
      "type"
    ])
  };
  return assigningSearchCriteria;
};
const mapForecastedSaveCriteriaToPlannedSaveCriteria = (forecastedSaveCriteria) => {
  const planningSearchCriteria = {
    ...omit(forecastedSaveCriteria, ["dashboards", "shared", "setup", "type"]),
    plan: forecastedSaveCriteria.setup
  };
  return planningSearchCriteria;
};
const mapPlannedSaveCriteriaToForcastedSaveCriteria = ({
  planningCriteria,
  shared = false
}) => {
  const forecastingCriteria = {
    ...planningCriteria,
    shared,
    type: ForecastingMatrixSearchCriteriaTypesEnum.planning
  };
  return forecastingCriteria;
};
const mapProjectAssignmentToPlannedTime = (assignment) => {
  const plannedTime = {
    ...assignment,
    plannedHours: assignment?.budgetHours ?? 0,
    costStructLaborKey: assignment?.costStructureLaborElement?.key,
    costStructLabor: assignment?.costStructureLaborElement,
    icCostStructLaborKey: assignment?.icCostStructureLaborElement?.key,
    icCostStructLabor: assignment?.icCostStructureLaborElement
  };
  delete plannedTime.budgetHours;
  delete plannedTime.icCostStructureLaborElement;
  delete plannedTime.costStructureLaborElement;
  return plannedTime;
};
const roundPlannedHours = (hours) => round$5(hours, 2);
const mapPlannedTimeToProjectAssignment = (plan) => {
  const assignment = {
    ...plan,
    budgetHours: plan?.plannedHours ?? 0,
    costStructureLaborElement: plan?.costStructLaborKey ? { key: plan?.costStructLaborKey } : void 0,
    icCostStructureLaborElement: plan?.icCostStructLaborKey ? { key: plan?.icCostStructLaborKey } : void 0,
    location: plan?.location?.key ? { key: plan?.location?.key } : void 0
  };
  delete assignment.plannedHours;
  delete assignment.costStructLaborKey;
  delete assignment.costStructLabor;
  delete assignment.icCostStructLaborKey;
  delete assignment.icCostStructLabor;
  if (!assignment.costStructureLaborElement) {
    delete assignment.costStructureLaborElement;
  }
  if (!assignment.icCostStructLaborKey) {
    delete assignment.icCostStructLaborKey;
  }
  if (!assignment.location) {
    delete assignment.location;
  }
  if (!assignment.laborCategory?.key) {
    delete assignment.laborCategory;
  }
  return assignment;
};
const mapPlannedTimeCreateToProjectAssignmentCreate = (plan) => {
  const {
    plannedHours,
    costStructLaborKey,
    icCostStructLaborKey,
    ...otherPlanProps
  } = plan;
  const assignment = {
    ...otherPlanProps,
    budgetHours: plannedHours ?? 0,
    costStructureLaborKey: costStructLaborKey,
    icCostStructureLaborKey: icCostStructLaborKey
  };
  return assignment;
};
const mapPlannedTimeSearchToProjectAssignmentSearch = (plannedTimeSearch) => {
  const projectPeopleAssignmentSearch = {
    dateRange: {
      rangeStart: plannedTimeSearch.beginDate,
      rangeEnd: plannedTimeSearch.endDate
    },
    personKeys: plannedTimeSearch.peopleKeys,
    taskKeys: plannedTimeSearch.taskKeys
  };
  return projectPeopleAssignmentSearch;
};
const filterProjectAssignmentsByTask = (assignments, taskKeys) => {
  return assignments.filter((a) => taskKeys.includes(a.task?.key));
};
const mapForecastingTimeToPlannedTime = (forecast2) => {
  delete forecast2.personOrganization;
  delete forecast2.projectOrganization;
  if (forecast2.location?.key) {
    forecast2.location = { key: forecast2.location.key };
  } else {
    delete forecast2.location;
  }
  if (!forecast2.laborCategory?.key) {
    delete forecast2.laborCategory;
  }
  return forecast2;
};
const getForecastedTime = async ({
  key,
  isAssigner,
  projectKey
}) => {
  if (isAssigner) {
    const assignment = await getProjectAssignment({ projectKey, key });
    const plannedTime = mapProjectAssignmentToPlannedTime(assignment);
    return plannedTime;
  } else {
    const plannedTime = await getPlannedTime(key);
    return plannedTime;
  }
};
const searchForecastedTime = async ({
  requestBody,
  isAssigner,
  page,
  pageSize: pageSize2
}) => {
  if (isAssigner) {
    const assignmentSearch = mapPlannedTimeSearchToProjectAssignmentSearch(requestBody);
    const searchPromises = requestBody.projectKeys?.map(
      (projectKey) => searchAllProjectAssignments({ projectKey, query: assignmentSearch })
    );
    const assignments = await Promise.all(searchPromises);
    return assignments.flat().map((a) => mapProjectAssignmentToPlannedTime(a));
  } else {
    return searchPlannedTime(requestBody);
  }
};
const searchAllForecastedTime = async ({
  isAssigner,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  requestBody
}) => {
  if (isAssigner) {
    const assignmentSearch = mapPlannedTimeSearchToProjectAssignmentSearch(requestBody);
    const searchPromises = requestBody.projectKeys?.map(
      (projectKey) => searchAllProjectAssignments({ projectKey, query: assignmentSearch })
    );
    const assignments = await Promise.all(searchPromises);
    return assignments.flat().map((a) => mapProjectAssignmentToPlannedTime(a));
  } else {
    return searchAllPlannedTime(requestBody);
  }
};
const updateForecastedTime = async ({
  plan,
  isAssigner
}) => {
  const planRounded = {
    ...plan,
    plannedHours: roundPlannedHours(plan.plannedHours)
  };
  if (isAssigner) {
    const assignment = mapPlannedTimeToProjectAssignment(planRounded);
    await updateProjectAssignment(
      assignment.key,
      assignment.project?.key,
      assignment
    );
  } else {
    await updatePlannedTime(mapForecastingTimeToPlannedTime(planRounded));
  }
};
const createForecastedTime = async ({
  plan,
  isAssigner
}) => {
  const planRounded = {
    ...plan,
    plannedHours: roundPlannedHours(plan.plannedHours)
  };
  if (isAssigner) {
    const assignment = mapPlannedTimeCreateToProjectAssignmentCreate(planRounded);
    return createProjectAssignment(assignment.projectKey, assignment);
  } else {
    return createPlannedTime(planRounded);
  }
};
const createForecastedTimeSaveCriteria = async ({
  forecastingSearchCriteria
}) => {
  const { dashboards: dashboards2 = [] } = forecastingSearchCriteria;
  const isAssigner = forecastingSearchCriteria.type === ForecastingMatrixSearchCriteriaTypesEnum.assigning;
  const requestBody = isAssigner ? mapForecastedSaveCriteriaToAssignedSaveCriteria(forecastingSearchCriteria) : mapForecastedSaveCriteriaToPlannedSaveCriteria(forecastingSearchCriteria);
  return isAssigner ? createAssignedTimeSaveCriteria({
    requestBody,
    dashboards: dashboards2
  }) : createPlannedTimeCriteria({
    requestBody,
    dashboards: dashboards2
  });
};
const createForecastedTimeSharedSaveCriteria = async ({
  forecastingSearchCriteria
}) => {
  const isAssigner = forecastingSearchCriteria.type === ForecastingMatrixSearchCriteriaTypesEnum.assigning;
  const requestBody = isAssigner ? mapForecastedSaveCriteriaToAssignedSaveCriteria(forecastingSearchCriteria) : mapForecastedSaveCriteriaToPlannedSaveCriteria(forecastingSearchCriteria);
  return isAssigner ? createAssignedTimeSharedSaveCriteria(requestBody) : createPlannedTimeSharedCriteria(requestBody, []);
};
const deleteForecastedTime = async ({
  projectKey,
  key,
  isAssigner
}) => {
  if (isAssigner) {
    if (projectKey) {
      await deleteProjectAssignment(projectKey, key);
    }
  } else {
    await deletePlannedTime(key);
  }
};
const deleteForecastedTimeSaveCriteria = async ({
  savedCriteria
}) => {
  try {
    const isAssigner = savedCriteria.type === ForecastingMatrixSearchCriteriaTypesEnum.assigning;
    const id = savedCriteria.savedFilter?.key ?? null;
    if (!id) {
      throw "Error: save filter key not found";
    }
    return isAssigner ? await deleteAssignedTimeSaveCriteria(id) : await deletePlannedTimeSaveCriteria(id);
  } catch (e) {
    log.warn({ msg: "Error: save filter key not found", error: `${e}` });
    return Promise.resolve({ key: -1 });
  }
};
const deleteForecastedTimeSharedSaveCriteria = async ({
  savedCriteria
}) => {
  try {
    const isAssigner = savedCriteria.type === ForecastingMatrixSearchCriteriaTypesEnum.assigning;
    const id = savedCriteria.savedFilter?.key ?? null;
    if (!id) {
      throw "Error: save filter key not found";
    }
    return isAssigner ? await deleteAssignedTimeSharedSaveCriteria(id) : await deletePlannedTimeSharedSaveCriteria(id);
  } catch (e) {
    log.warn({ msg: "Error: save filter key not found", error: `${e}` });
    return Promise.resolve({ key: -1 });
  }
};
const getAllForecastedTimeSaveCriteria = async ({
  isAssigner,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const shared = false;
  if (isAssigner) {
    const allCriteria = await getAllAssignedTimeSaveCriteria({
      pageSize: pageSize2
    });
    return allCriteria.map(
      (assigningCriteria) => mapAssignedSaveCriteriaToForcastedSaveCriteria({
        assigningCriteria,
        shared
      })
    );
  } else {
    const allCriteria = await getAllPlannedTimeSaveCriteria({ pageSize: pageSize2 });
    return allCriteria.map(
      (planningCriteria) => mapPlannedSaveCriteriaToForcastedSaveCriteria({
        planningCriteria,
        shared
      })
    );
  }
};
const getAllForecastedTimeSharedSaveCriteria = async ({
  isAssigner,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const shared = true;
  if (isAssigner) {
    const allCriteria = await getAllAssignedTimeSharedSaveCriteria({
      pageSize: pageSize2
    });
    return allCriteria.map(
      (assigningCriteria) => mapAssignedSaveCriteriaToForcastedSaveCriteria({
        assigningCriteria,
        shared
      })
    );
  } else {
    const allCriteria = await getAllPlannedTimeSharedSaveCriteria({ pageSize: pageSize2 });
    return allCriteria.map(
      (planningCriteria) => mapPlannedSaveCriteriaToForcastedSaveCriteria({
        planningCriteria,
        shared
      })
    );
  }
};
const getProjectForecastDefaults = async ({
  projectKey,
  personKey,
  date,
  isAssigner
}) => {
  return isAssigner ? getProjectAssignmentDefaults({ projectKey, personKey, date }) : getProjectPlanDefaults({ projectKey, personKey, date });
};
const getMostRecentPreviousForecast = async ({
  page = 1,
  pageSize: pageSize2 = 1,
  isAssigner = false,
  searchBody
}) => {
  if (isAssigner) {
    return void 0;
  } else {
    const result = await searchPlannedTime(
      { ...searchBody, sortOrder: PlannedTimeSearchModel.SortOrderEnum.DESC },
      page,
      pageSize2
    );
    if (pageSize2 === 1) {
      return result[0];
    }
    return result.find((t16) => !t16.task?.key);
  }
};
const searchAllForecastedTimePeople = async ({
  isAssigner = false,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  searchBody
}) => {
  const forecastPeople = isAssigner ? await searchAllAssignedTimePeople({ params: searchBody, pageSize: pageSize2 }) : await searchAllPlannedTimePeople({ params: searchBody, pageSize: pageSize2 });
  return forecastPeople.map((p) => new Person(p));
};
const searchForecastedTimeMatrix = async ({
  isAssigner,
  params
}) => {
  return isAssigner ? searchAssignedTimeMatrix(params) : searchPlannedTimeMatrix(params);
};
const searchAllForecastedTimeProjects = async ({
  isAssigner,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  params = {}
}) => {
  return isAssigner ? searchAllAssignedTimeProjects({ pageSize: pageSize2, params }) : searchAllPlannedTimeProjects({ pageSize: pageSize2, params });
};
const searchForecastedTimePeopleAllocation = async ({
  isAssigner,
  params
}) => {
  return isAssigner ? searchAssignedTimePeopleAllocation(params) : searchPlannedTimePeopleAllocation(params);
};
const updateForecastedTimeSaveCriteria = async ({
  forecastingSearchCriteria,
  updateKey
}) => {
  const { dashboards: dashboards2 = [] } = forecastingSearchCriteria;
  const isAssigner = forecastingSearchCriteria.type === ForecastingMatrixSearchCriteriaTypesEnum.assigning;
  const requestBody = isAssigner ? mapForecastedSaveCriteriaToAssignedSaveCriteria(forecastingSearchCriteria) : mapForecastedSaveCriteriaToPlannedSaveCriteria(forecastingSearchCriteria);
  return isAssigner ? updateAssignedTimeSaveCriteria({ dashboards: dashboards2, id: updateKey, requestBody }) : updatePlannedTimeSaveCriteria({ dashboards: dashboards2, id: updateKey, requestBody });
};
const updateForecastedTimeSharedSaveCriteria = async ({
  forecastingSearchCriteria,
  updateKey
}) => {
  const isAssigner = forecastingSearchCriteria.type === ForecastingMatrixSearchCriteriaTypesEnum.assigning;
  const requestBody = isAssigner ? mapForecastedSaveCriteriaToAssignedSaveCriteria(forecastingSearchCriteria) : mapForecastedSaveCriteriaToPlannedSaveCriteria(forecastingSearchCriteria);
  return isAssigner ? updateAssignedTimeSharedSaveCriteria({ id: updateKey, requestBody }) : updatePlannedTimeSharedSaveCriteria({ id: updateKey, requestBody });
};
const getAllForecastedTimePersonOrganizations = async ({
  code,
  isAssigner,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  projectKey
}) => {
  return isAssigner ? getAllAssignedTimePersonOrganizations({ code, pageSize: pageSize2, projectKey }) : getAllPlannedTimePersonOrganizations({ code, pageSize: pageSize2, projectKey });
};
const getAllForecastedTimeProjectOrganizations = async ({
  code,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  return getAllAssignedTimeProjectOrganizations({ code, pageSize: pageSize2 });
};
class HubApi {
  #token;
  #serverUrl;
  constructor({ token: token2 = [], serverUrl: serverUrl2 = "" }) {
    this.#token = token2;
    this.#serverUrl = serverUrl2;
  }
  async destroy(destroyParams) {
    return this.#request({ ...destroyParams, method: "DELETE" });
  }
  async get(getParams) {
    return this.#request({ ...getParams, method: "GET" });
  }
  async post(postParams) {
    return this.#request({ ...postParams, method: "POST" });
  }
  async put(putParams) {
    return this.#request({ ...putParams, method: "PUT" });
  }
  setToken(v = []) {
    this.#token = v;
  }
  setServerUrl(url2 = "") {
    this.#serverUrl = url2;
  }
  #buildOptions({
    body,
    method = "GET"
  }) {
    const headers = new Headers();
    headers.set("Content-Type", "application/json");
    if (this.#tokenValid()) {
      headers.set("Authorization", `Bearer ${this.#token.join("")}`);
    }
    return {
      body: body ? JSON.stringify(body) : void 0,
      method,
      headers
    };
  }
  #buildUrl(url2 = "") {
    return `${this.#serverUrl}${url2}`;
  }
  //R = Response
  //A = Arguments
  async #request({
    body,
    method,
    options,
    url: url2
  }) {
    try {
      const requestOptions = this.#buildOptions({ body, method });
      const requestUrl = this.#buildUrl(url2);
      try {
        log.debug({ msg: "Hub API request", url: requestUrl, method });
        const response = await fetch(requestUrl, requestOptions);
        log.debug({
          msg: "Hub API response",
          url: requestUrl,
          method,
          status: response.status
        });
        try {
          const results = await this.#responseHandler({
            response,
            options
          });
          return results;
        } catch (e) {
          log.warn({
            msg: "Hub API Response Error",
            errorStatusCode: response.status,
            requestUrl
          });
          throw e;
        }
      } catch (e) {
        log.warn({
          msg: "Error making Hub API request",
          error: `${e}`
        });
        throw e;
      }
    } catch (e) {
      log.warn({ msg: "Hub API Request Error", error: `${e}` });
      throw e;
    }
  }
  async #responseHandler({
    response,
    options: { returnHeaders, mimeType } = {
      returnHeaders: false,
      mimeType: MimeTypes[".json"]
    }
  }) {
    const parsed = await this.#responseParser({ mimeType, response });
    if (response.ok) {
      return returnHeaders ? { results: parsed, headers: response.headers } : parsed;
    }
    throw new HttpError(response.status, "", parsed);
  }
  async #responseParser({
    mimeType,
    response
  }) {
    const _mimeTypeParsers = {
      [MimeTypes[".csv"]]: async () => {
        const text = await response.text();
        return text ?? null;
      },
      [MimeTypes[".json"]]: async () => {
        const text = await response.text();
        return text ? JSON.parse(text) : null;
      }
    };
    const parsed = await _mimeTypeParsers[mimeType ?? MimeTypes[".json"]]();
    return parsed;
  }
  #tokenValid() {
    return this.#token.length > 0;
  }
}
const getHubURL = (defaultURL) => {
  const href = window.location.href;
  const isLowerQA = href.includes(".qa.unanet.io") || href.includes(".qa.unanetgc.io");
  const isLowerINT = href.includes(".int.unanet.io") || href.includes(".int.unanetgc.io");
  const isStage = href.includes(".stage.unanet.biz");
  if (isLowerQA) {
    return "https://hub.qa.unanetae.io/hub";
  }
  if (isLowerINT) {
    return "https://hub.int.unanetae.io/hub";
  }
  if (isStage) {
    return "https://hub.stage.unanetae.biz/hub";
  }
  return defaultURL;
};
const getHubAPI = ({
  defaultHubURL,
  // example: HUB_URL constant from `apps/portal`
  userPlatformToken
  // example: coreMeInfo.user.platformToken
}) => {
  return new HubApi({
    token: userPlatformToken ? userPlatformToken : getToken() ?? [""],
    serverUrl: getHubURL(defaultHubURL ?? "")
  });
};
const getBankTransaction = async ({
  transactionID,
  hubURL,
  platformToken
}) => {
  const hubAPI = getHubAPI({
    defaultHubURL: hubURL,
    userPlatformToken: platformToken
  });
  const bankTransaction = await hubAPI.get({
    url: `/transactions/govcon/transactions/${transactionID}`
  });
  return bankTransaction;
};
const searchHubTransactions = async ({
  hubURL,
  platformToken,
  query
}) => {
  const hubAPI = getHubAPI({
    defaultHubURL: hubURL,
    userPlatformToken: platformToken
  });
  const params = new URLSearchParams();
  if (query.status) {
    params.append("status", query.status);
  }
  if (query.startDate) {
    params.append("startDate", query.startDate);
  }
  if (query.endDate) {
    params.append("endDate", query.endDate);
  }
  if (query.limit !== void 0) {
    params.append("limit", String(query.limit));
  }
  if (query.next) {
    params.append("next", query.next);
  }
  const queryString2 = params.toString();
  const url2 = `/transactions/govcon/accounts/${query.accountID}/transactions${queryString2 ? `?${queryString2}` : ""}`;
  const response = await hubAPI.get({
    url: url2
  });
  return response;
};
const refreshBankAccountTransactions = async ({
  accountID,
  hubURL,
  platformToken
}) => {
  const hubAPI = getHubAPI({
    defaultHubURL: hubURL,
    userPlatformToken: platformToken
  });
  await hubAPI.post({
    url: `/transactions/govcon/accounts/${accountID}/refresh`
  });
};
const searchBankFeedTransactions = async ({
  accountID,
  hubURL,
  limit,
  next: next2,
  platformToken,
  request: request2
}) => {
  const hubAPI = getHubAPI({
    defaultHubURL: hubURL,
    userPlatformToken: platformToken
  });
  const params = new URLSearchParams();
  if (limit !== void 0) {
    params.append("limit", String(limit));
  }
  if (next2) {
    params.append("next", next2);
  }
  const queryString2 = params.toString();
  const url2 = `/transactions/govcon/accounts/${accountID}/bank-feed-transactions/search${queryString2 ? `?${queryString2}` : ""}`;
  const response = await hubAPI.post({
    body: request2,
    url: url2
  });
  return response;
};
const getBankFeedTransaction$1 = async ({
  accountID,
  bankAccountKey,
  hubURL,
  platformToken,
  transactionID
}) => {
  const hubAPI = getHubAPI({
    defaultHubURL: hubURL,
    userPlatformToken: platformToken
  });
  const url2 = `/transactions/govcon/accounts/${accountID}/bank-feed-transactions/${transactionID}?bankAccountKey=${bankAccountKey}`;
  const response = await hubAPI.get({
    url: url2
  });
  return response;
};
const bankTransactions = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getBankFeedTransaction: getBankFeedTransaction$1,
  getBankTransaction,
  refreshBankAccountTransactions,
  searchBankFeedTransactions,
  searchHubTransactions
}, Symbol.toStringTag, { value: "Module" }));
const common = {
  black: "#000",
  white: "#fff"
};
const red = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
};
const purple = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
};
const blue = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
};
const lightBlue = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
};
const green = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
const orange = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
};
const grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function formatMuiErrorMessage(code, ...args) {
  const url2 = new URL(`https://mui.com/production-error/?code=${code}`);
  args.forEach((arg2) => url2.searchParams.append("args[]", arg2));
  return `Minified MUI error #${code}; visit ${url2} for the full message.`;
}
const THEME_ID = "$$material";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n12) {
    for (var e = 1; e < arguments.length; e++) {
      var t16 = arguments[e];
      for (var r12 in t16) ({}).hasOwnProperty.call(t16, r12) && (n12[r12] = t16[r12]);
    }
    return n12;
  }, _extends.apply(null, arguments);
}
var react = { exports: {} };
var react_production = {};
var hasRequiredReact_production;
function requireReact_production() {
  if (hasRequiredReact_production) return react_production;
  hasRequiredReact_production = 1;
  var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense"), REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo"), REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = /* @__PURE__ */ Symbol.for("react.activity"), REACT_VIEW_TRANSITION_TYPE = /* @__PURE__ */ Symbol.for("react.view_transition"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
  function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
  }
  var ReactNoopUpdateQueue = {
    isMounted: function() {
      return false;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, assign2 = Object.assign, emptyObject = {};
  function Component(props, context2, updater) {
    this.props = props;
    this.context = context2;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
  }
  Component.prototype.isReactComponent = {};
  Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, partialState, callback, "setState");
  };
  Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
  };
  function ComponentDummy() {
  }
  ComponentDummy.prototype = Component.prototype;
  function PureComponent(props, context2, updater) {
    this.props = props;
    this.context = context2;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
  }
  var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
  pureComponentPrototype.constructor = PureComponent;
  assign2(pureComponentPrototype, Component.prototype);
  pureComponentPrototype.isPureReactComponent = true;
  var isArrayImpl = Array.isArray;
  function noop2() {
  }
  var ReactSharedInternals = { H: null, A: null, T: null, S: null }, hasOwnProperty2 = Object.prototype.hasOwnProperty;
  function ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type,
      key,
      ref: void 0 !== refProp ? refProp : null,
      props
    };
  }
  function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, oldElement.props);
  }
  function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
  }
  function escape2(key) {
    var escaperLookup = { "=": "=0", ":": "=2" };
    return "$" + key.replace(/[=:]/g, function(match2) {
      return escaperLookup[match2];
    });
  }
  var userProvidedKeyEscapeRegex = /\/+/g;
  function getElementKey(element, index2) {
    return "object" === typeof element && null !== element && null != element.key ? escape2("" + element.key) : index2.toString(36);
  }
  function resolveThenable(thenable) {
    switch (thenable.status) {
      case "fulfilled":
        return thenable.value;
      case "rejected":
        throw thenable.reason;
      default:
        switch ("string" === typeof thenable.status ? thenable.then(noop2, noop2) : (thenable.status = "pending", thenable.then(
          function(fulfilledValue) {
            "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
          },
          function(error) {
            "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
          }
        )), thenable.status) {
          case "fulfilled":
            return thenable.value;
          case "rejected":
            throw thenable.reason;
        }
    }
    throw thenable;
  }
  function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = false;
    if (null === children) invokeCallback = true;
    else
      switch (type) {
        case "bigint":
        case "string":
        case "number":
          invokeCallback = true;
          break;
        case "object":
          switch (children.$$typeof) {
            case REACT_ELEMENT_TYPE:
            case REACT_PORTAL_TYPE:
              invokeCallback = true;
              break;
            case REACT_LAZY_TYPE:
              return invokeCallback = children._init, mapIntoArray(
                invokeCallback(children._payload),
                array,
                escapedPrefix,
                nameSoFar,
                callback
              );
          }
      }
    if (invokeCallback)
      return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
      })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(
        callback,
        escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(
          userProvidedKeyEscapeRegex,
          "$&/"
        ) + "/") + invokeCallback
      )), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children))
      for (var i = 0; i < children.length; i++)
        nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(
          nameSoFar,
          array,
          escapedPrefix,
          type,
          callback
        );
    else if (i = getIteratorFn(children), "function" === typeof i)
      for (children = i.call(children), i = 0; !(nameSoFar = children.next()).done; )
        nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(
          nameSoFar,
          array,
          escapedPrefix,
          type,
          callback
        );
    else if ("object" === type) {
      if ("function" === typeof children.then)
        return mapIntoArray(
          resolveThenable(children),
          array,
          escapedPrefix,
          nameSoFar,
          callback
        );
      array = String(children);
      throw Error(
        "Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return invokeCallback;
  }
  function mapChildren(children, func, context2) {
    if (null == children) return children;
    var result = [], count2 = 0;
    mapIntoArray(children, result, "", "", function(child) {
      return func.call(context2, child, count2++);
    });
    return result;
  }
  function lazyInitializer(payload) {
    if (-1 === payload._status) {
      var ctor = payload._result, thenable = ctor();
      thenable.then(
        function(moduleObject) {
          if (0 === payload._status || -1 === payload._status)
            payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        },
        function(error) {
          if (0 === payload._status || -1 === payload._status)
            payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        }
      );
      -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
  }
  var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
      var event2 = new window.ErrorEvent("error", {
        bubbles: true,
        cancelable: true,
        message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
        error
      });
      if (!window.dispatchEvent(event2)) return;
    } else if ("object" === typeof process && "function" === typeof process.emit) {
      process.emit("uncaughtException", error);
      return;
    }
    console.error(error);
  };
  function startTransition(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    ReactSharedInternals.T = currentTransition;
    try {
      var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
      null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
      "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop2, reportGlobalError);
    } catch (error) {
      reportGlobalError(error);
    } finally {
      null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
  }
  function addTransitionType(type) {
    var transition = ReactSharedInternals.T;
    if (null !== transition) {
      var transitionTypes = transition.types;
      null === transitionTypes ? transition.types = [type] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else startTransition(addTransitionType.bind(null, type));
  }
  var Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
      mapChildren(
        children,
        function() {
          forEachFunc.apply(this, arguments);
        },
        forEachContext
      );
    },
    count: function(children) {
      var n12 = 0;
      mapChildren(children, function() {
        n12++;
      });
      return n12;
    },
    toArray: function(children) {
      return mapChildren(children, function(child) {
        return child;
      }) || [];
    },
    only: function(children) {
      if (!isValidElement(children))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return children;
    }
  };
  react_production.Activity = REACT_ACTIVITY_TYPE;
  react_production.Children = Children;
  react_production.Component = Component;
  react_production.Fragment = REACT_FRAGMENT_TYPE;
  react_production.Profiler = REACT_PROFILER_TYPE;
  react_production.PureComponent = PureComponent;
  react_production.StrictMode = REACT_STRICT_MODE_TYPE;
  react_production.Suspense = REACT_SUSPENSE_TYPE;
  react_production.ViewTransition = REACT_VIEW_TRANSITION_TYPE;
  react_production.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
  react_production.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
      return ReactSharedInternals.H.useMemoCache(size);
    }
  };
  react_production.addTransitionType = addTransitionType;
  react_production.cache = function(fn3) {
    return function() {
      return fn3.apply(null, arguments);
    };
  };
  react_production.cacheSignal = function() {
    return null;
  };
  react_production.cloneElement = function(element, config2, children) {
    if (null === element || void 0 === element)
      throw Error(
        "The argument must be a React element, but you passed " + element + "."
      );
    var props = assign2({}, element.props), key = element.key;
    if (null != config2)
      for (propName in void 0 !== config2.key && (key = "" + config2.key), config2)
        !hasOwnProperty2.call(config2, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config2.ref || (props[propName] = config2[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
      for (var childArray = Array(propName), i = 0; i < propName; i++)
        childArray[i] = arguments[i + 2];
      props.children = childArray;
    }
    return ReactElement(element.type, key, props);
  };
  react_production.createContext = function(defaultValue) {
    defaultValue = {
      $$typeof: REACT_CONTEXT_TYPE,
      _currentValue: defaultValue,
      _currentValue2: defaultValue,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
      $$typeof: REACT_CONSUMER_TYPE,
      _context: defaultValue
    };
    return defaultValue;
  };
  react_production.createElement = function(type, config2, children) {
    var propName, props = {}, key = null;
    if (null != config2)
      for (propName in void 0 !== config2.key && (key = "" + config2.key), config2)
        hasOwnProperty2.call(config2, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config2[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
      for (var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)
        childArray[i] = arguments[i + 2];
      props.children = childArray;
    }
    if (type && type.defaultProps)
      for (propName in childrenLength = type.defaultProps, childrenLength)
        void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, props);
  };
  react_production.createRef = function() {
    return { current: null };
  };
  react_production.forwardRef = function(render) {
    return { $$typeof: REACT_FORWARD_REF_TYPE, render };
  };
  react_production.isValidElement = isValidElement;
  react_production.lazy = function(ctor) {
    return {
      $$typeof: REACT_LAZY_TYPE,
      _payload: { _status: -1, _result: ctor },
      _init: lazyInitializer
    };
  };
  react_production.memo = function(type, compare5) {
    return {
      $$typeof: REACT_MEMO_TYPE,
      type,
      compare: void 0 === compare5 ? null : compare5
    };
  };
  react_production.startTransition = startTransition;
  react_production.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
  };
  react_production.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
  };
  react_production.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
  };
  react_production.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
  };
  react_production.useContext = function(Context2) {
    return ReactSharedInternals.H.useContext(Context2);
  };
  react_production.useDebugValue = function() {
  };
  react_production.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
  };
  react_production.useEffect = function(create, deps) {
    return ReactSharedInternals.H.useEffect(create, deps);
  };
  react_production.useEffectEvent = function(callback) {
    return ReactSharedInternals.H.useEffectEvent(callback);
  };
  react_production.useId = function() {
    return ReactSharedInternals.H.useId();
  };
  react_production.useImperativeHandle = function(ref2, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref2, create, deps);
  };
  react_production.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
  };
  react_production.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
  };
  react_production.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
  };
  react_production.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
  };
  react_production.useReducer = function(reducer, initialArg, init2) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init2);
  };
  react_production.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
  };
  react_production.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
  };
  react_production.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(
      subscribe,
      getSnapshot,
      getServerSnapshot
    );
  };
  react_production.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
  };
  react_production.version = "19.3.0";
  return react_production;
}
var react_development = { exports: {} };
react_development.exports;
var hasRequiredReact_development;
function requireReact_development() {
  if (hasRequiredReact_development) return react_development.exports;
  hasRequiredReact_development = 1;
  (function(module2, exports2) {
    "production" !== process.env.NODE_ENV && (function() {
      function defineDeprecationWarning(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
          get: function() {
            console.warn(
              "%s(...) is deprecated in plain JavaScript React classes. %s",
              info[0],
              info[1]
            );
          }
        });
      }
      function getIteratorFn(maybeIterable) {
        if (null === maybeIterable || "object" !== typeof maybeIterable)
          return null;
        maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
        return "function" === typeof maybeIterable ? maybeIterable : null;
      }
      function warnNoop(publicInstance, callerName) {
        publicInstance = (publicInstance = publicInstance.constructor) && (publicInstance.displayName || publicInstance.name) || "ReactClass";
        var warningKey = publicInstance + "." + callerName;
        didWarnStateUpdateForUnmountedComponent[warningKey] || (console.error(
          "Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.",
          callerName,
          publicInstance
        ), didWarnStateUpdateForUnmountedComponent[warningKey] = true);
      }
      function Component(props, context2, updater) {
        this.props = props;
        this.context = context2;
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
      }
      function ComponentDummy() {
      }
      function PureComponent(props, context2, updater) {
        this.props = props;
        this.context = context2;
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
      }
      function noop2() {
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        try {
          testStringCoercion(value);
          var JSCompiler_inline_result = false;
        } catch (e) {
          JSCompiler_inline_result = true;
        }
        if (JSCompiler_inline_result) {
          JSCompiler_inline_result = console;
          var JSCompiler_temp_const = JSCompiler_inline_result.error;
          var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          JSCompiler_temp_const.call(
            JSCompiler_inline_result,
            "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
            JSCompiler_inline_result$jscomp$0
          );
          return testStringCoercion(value);
        }
      }
      function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type)
          return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
          case REACT_ACTIVITY_TYPE:
            return "Activity";
          case REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
        }
        if ("object" === typeof type)
          switch ("number" === typeof type.tag && console.error(
            "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
          ), type.$$typeof) {
            case REACT_PORTAL_TYPE:
              return "Portal";
            case REACT_CONTEXT_TYPE:
              return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
              return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
              var innerType = type.render;
              type = type.displayName;
              type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
              return type;
            case REACT_MEMO_TYPE:
              return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
              innerType = type._payload;
              type = type._init;
              try {
                return getComponentNameFromType(type(innerType));
              } catch (x) {
              }
          }
        return null;
      }
      function getTaskName(type) {
        if (type === REACT_FRAGMENT_TYPE) return "<>";
        if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE)
          return "<...>";
        try {
          var name = getComponentNameFromType(type);
          return name ? "<" + name + ">" : "<...>";
        } catch (x) {
          return "<...>";
        }
      }
      function getOwner() {
        var dispatcher = ReactSharedInternals.A;
        return null === dispatcher ? null : dispatcher.getOwner();
      }
      function UnknownOwner() {
        return Error("react-stack-top-frame");
      }
      function hasValidKey(config2) {
        if (hasOwnProperty2.call(config2, "key")) {
          var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
          if (getter && getter.isReactWarning) return false;
        }
        return void 0 !== config2.key;
      }
      function defineKeyPropWarningGetter(props, displayName) {
        function warnAboutAccessingKey() {
          specialPropKeyWarningShown || (specialPropKeyWarningShown = true, console.error(
            "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
            displayName
          ));
        }
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
          get: warnAboutAccessingKey,
          configurable: true
        });
      }
      function elementRefGetterWithDeprecationWarning() {
        var componentName = getComponentNameFromType(this.type);
        didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = true, console.error(
          "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
        ));
        componentName = this.props.ref;
        return void 0 !== componentName ? componentName : null;
      }
      function ReactElement(type, key, props, owner, debugStack, debugTask) {
        var refProp = props.ref;
        type = {
          $$typeof: REACT_ELEMENT_TYPE,
          type,
          key,
          props,
          _owner: owner
        };
        null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
          enumerable: false,
          get: elementRefGetterWithDeprecationWarning
        }) : Object.defineProperty(type, "ref", { enumerable: false, value: null });
        type._store = {};
        Object.defineProperty(type._store, "validated", {
          configurable: false,
          enumerable: false,
          writable: true,
          value: 0
        });
        Object.defineProperty(type, "_debugInfo", {
          configurable: false,
          enumerable: false,
          writable: true,
          value: null
        });
        Object.defineProperty(type, "_debugStack", {
          configurable: false,
          enumerable: false,
          writable: true,
          value: debugStack
        });
        Object.defineProperty(type, "_debugTask", {
          configurable: false,
          enumerable: false,
          writable: true,
          value: debugTask
        });
        Object.freeze && (Object.freeze(type.props), Object.freeze(type));
        return type;
      }
      function cloneAndReplaceKey(oldElement, newKey) {
        newKey = ReactElement(
          oldElement.type,
          newKey,
          oldElement.props,
          oldElement._owner,
          oldElement._debugStack,
          oldElement._debugTask
        );
        oldElement._store && (newKey._store.validated = oldElement._store.validated);
        return newKey;
      }
      function validateChildKeys(node2) {
        isValidElement(node2) ? node2._store && (node2._store.validated = 1) : "object" === typeof node2 && null !== node2 && node2.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node2._payload.status ? isValidElement(node2._payload.value) && node2._payload.value._store && (node2._payload.value._store.validated = 1) : node2._store && (node2._store.validated = 1));
      }
      function isValidElement(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function escape2(key) {
        var escaperLookup = { "=": "=0", ":": "=2" };
        return "$" + key.replace(/[=:]/g, function(match2) {
          return escaperLookup[match2];
        });
      }
      function getElementKey(element, index2) {
        return "object" === typeof element && null !== element && null != element.key ? (checkKeyStringCoercion(element.key), escape2("" + element.key)) : index2.toString(36);
      }
      function resolveThenable(thenable) {
        switch (thenable.status) {
          case "fulfilled":
            return thenable.value;
          case "rejected":
            throw thenable.reason;
          default:
            switch ("string" === typeof thenable.status ? thenable.then(noop2, noop2) : (thenable.status = "pending", thenable.then(
              function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
              },
              function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
              }
            )), thenable.status) {
              case "fulfilled":
                return thenable.value;
              case "rejected":
                throw thenable.reason;
            }
        }
        throw thenable;
      }
      function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if ("undefined" === type || "boolean" === type) children = null;
        var invokeCallback = false;
        if (null === children) invokeCallback = true;
        else
          switch (type) {
            case "bigint":
            case "string":
            case "number":
              invokeCallback = true;
              break;
            case "object":
              switch (children.$$typeof) {
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                  invokeCallback = true;
                  break;
                case REACT_LAZY_TYPE:
                  return invokeCallback = children._init, mapIntoArray(
                    invokeCallback(children._payload),
                    array,
                    escapedPrefix,
                    nameSoFar,
                    callback
                  );
              }
          }
        if (invokeCallback) {
          invokeCallback = children;
          callback = callback(invokeCallback);
          var childKey = "" === nameSoFar ? "." + getElementKey(invokeCallback, 0) : nameSoFar;
          isArrayImpl(callback) ? (escapedPrefix = "", null != childKey && (escapedPrefix = childKey.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
            return c;
          })) : null != callback && (isValidElement(callback) && (null != callback.key && (invokeCallback && invokeCallback.key === callback.key || checkKeyStringCoercion(callback.key)), escapedPrefix = cloneAndReplaceKey(
            callback,
            escapedPrefix + (null == callback.key || invokeCallback && invokeCallback.key === callback.key ? "" : ("" + callback.key).replace(
              userProvidedKeyEscapeRegex,
              "$&/"
            ) + "/") + childKey
          ), "" !== nameSoFar && null != invokeCallback && isValidElement(invokeCallback) && null == invokeCallback.key && invokeCallback._store && !invokeCallback._store.validated && (escapedPrefix._store.validated = 2), callback = escapedPrefix), array.push(callback));
          return 1;
        }
        invokeCallback = 0;
        childKey = "" === nameSoFar ? "." : nameSoFar + ":";
        if (isArrayImpl(children))
          for (var i = 0; i < children.length; i++)
            nameSoFar = children[i], type = childKey + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(
              nameSoFar,
              array,
              escapedPrefix,
              type,
              callback
            );
        else if (i = getIteratorFn(children), "function" === typeof i)
          for (i === children.entries && (didWarnAboutMaps || console.warn(
            "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
          ), didWarnAboutMaps = true), children = i.call(children), i = 0; !(nameSoFar = children.next()).done; )
            nameSoFar = nameSoFar.value, type = childKey + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(
              nameSoFar,
              array,
              escapedPrefix,
              type,
              callback
            );
        else if ("object" === type) {
          if ("function" === typeof children.then)
            return mapIntoArray(
              resolveThenable(children),
              array,
              escapedPrefix,
              nameSoFar,
              callback
            );
          array = String(children);
          throw Error(
            "Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead."
          );
        }
        return invokeCallback;
      }
      function mapChildren(children, func, context2) {
        if (null == children) return children;
        var result = [], count2 = 0;
        mapIntoArray(children, result, "", "", function(child) {
          return func.call(context2, child, count2++);
        });
        return result;
      }
      function lazyInitializer(payload) {
        if (-1 === payload._status) {
          var resolveDebugValue = null, rejectDebugValue = null, ioInfo = payload._ioInfo;
          null != ioInfo && (ioInfo.start = ioInfo.end = performance.now(), ioInfo.value = new Promise(function(resolve2, reject) {
            resolveDebugValue = resolve2;
            rejectDebugValue = reject;
          }));
          ioInfo = payload._result;
          var thenable = ioInfo();
          thenable.then(
            function(moduleObject) {
              if (0 === payload._status || -1 === payload._status) {
                payload._status = 1;
                payload._result = moduleObject;
                var _ioInfo = payload._ioInfo;
                if (null != _ioInfo) {
                  _ioInfo.end = performance.now();
                  var debugValue = null == moduleObject ? void 0 : moduleObject.default;
                  resolveDebugValue(debugValue);
                  _ioInfo.value.status = "fulfilled";
                  _ioInfo.value.value = debugValue;
                }
                void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
              }
            },
            function(error) {
              if (0 === payload._status || -1 === payload._status) {
                payload._status = 2;
                payload._result = error;
                var _ioInfo2 = payload._ioInfo;
                null != _ioInfo2 && (_ioInfo2.end = performance.now(), _ioInfo2.value.then(noop2, noop2), rejectDebugValue(error), _ioInfo2.value.status = "rejected", _ioInfo2.value.reason = error);
                void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
              }
            }
          );
          ioInfo = payload._ioInfo;
          if (null != ioInfo) {
            var displayName = thenable.displayName;
            "string" === typeof displayName && (ioInfo.name = displayName);
          }
          -1 === payload._status && (payload._status = 0, payload._result = thenable);
        }
        if (1 === payload._status)
          return ioInfo = payload._result, void 0 === ioInfo && console.error(
            "lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?",
            ioInfo
          ), "default" in ioInfo || console.error(
            "lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))",
            ioInfo
          ), ioInfo.default;
        throw payload._result;
      }
      function resolveDispatcher() {
        var dispatcher = ReactSharedInternals.H;
        null === dispatcher && console.error(
          "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem."
        );
        return dispatcher;
      }
      function releaseAsyncTransition() {
        ReactSharedInternals.asyncTransitions--;
      }
      function startTransition(scope) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        currentTransition._updatedFibers = /* @__PURE__ */ new Set();
        ReactSharedInternals.T = currentTransition;
        try {
          var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
          null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
          "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(noop2, reportGlobalError));
        } catch (error) {
          reportGlobalError(error);
        } finally {
          null === prevTransition && currentTransition._updatedFibers && (scope = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < scope && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          )), null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error(
            "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
          ), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
        }
      }
      function addTransitionType(type) {
        var transition = ReactSharedInternals.T;
        if (null !== transition) {
          var transitionTypes = transition.types;
          null === transitionTypes ? transition.types = [type] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
        } else
          0 === ReactSharedInternals.asyncTransitions && console.error(
            "addTransitionType can only be called inside a `startTransition()` callback. It must be associated with a specific Transition."
          ), startTransition(addTransitionType.bind(null, type));
      }
      function enqueueTask(task) {
        if (null === enqueueTaskImpl)
          try {
            var requireString = ("require" + Math.random()).slice(0, 7);
            enqueueTaskImpl = (module2 && module2[requireString]).call(
              module2,
              "timers"
            ).setImmediate;
          } catch (_err) {
            enqueueTaskImpl = function(callback) {
              false === didWarnAboutMessageChannel && (didWarnAboutMessageChannel = true, "undefined" === typeof MessageChannel && console.error(
                "This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."
              ));
              var channel = new MessageChannel();
              channel.port1.onmessage = callback;
              channel.port2.postMessage(void 0);
            };
          }
        return enqueueTaskImpl(task);
      }
      function aggregateErrors(errors) {
        return 1 < errors.length && "function" === typeof AggregateError ? new AggregateError(errors) : errors[0];
      }
      function popActScope(prevActQueue, prevActScopeDepth) {
        prevActScopeDepth !== actScopeDepth - 1 && console.error(
          "You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "
        );
        actScopeDepth = prevActScopeDepth;
      }
      function recursivelyFlushAsyncActWork(returnValue, resolve2, reject) {
        var queue2 = ReactSharedInternals.actQueue;
        if (null !== queue2)
          if (0 !== queue2.length)
            try {
              flushActQueue(queue2);
              enqueueTask(function() {
                return recursivelyFlushAsyncActWork(returnValue, resolve2, reject);
              });
              return;
            } catch (error) {
              ReactSharedInternals.thrownErrors.push(error);
            }
          else ReactSharedInternals.actQueue = null;
        0 < ReactSharedInternals.thrownErrors.length ? (queue2 = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, reject(queue2)) : resolve2(returnValue);
      }
      function flushActQueue(queue2) {
        if (!isFlushing) {
          isFlushing = true;
          var i = 0;
          try {
            for (; i < queue2.length; i++) {
              var callback = queue2[i];
              do {
                ReactSharedInternals.didUsePromise = false;
                var continuation = callback(false);
                if (null !== continuation) {
                  if (ReactSharedInternals.didUsePromise) {
                    queue2[i] = callback;
                    queue2.splice(0, i);
                    return;
                  }
                  callback = continuation;
                } else break;
              } while (1);
            }
            queue2.length = 0;
          } catch (error) {
            queue2.splice(0, i + 1), ReactSharedInternals.thrownErrors.push(error);
          } finally {
            isFlushing = false;
          }
        }
      }
      "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
      var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo"), REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = /* @__PURE__ */ Symbol.for("react.activity"), REACT_VIEW_TRANSITION_TYPE = /* @__PURE__ */ Symbol.for("react.view_transition"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, didWarnStateUpdateForUnmountedComponent = {}, ReactNoopUpdateQueue = {
        isMounted: function() {
          return false;
        },
        enqueueForceUpdate: function(publicInstance) {
          warnNoop(publicInstance, "forceUpdate");
        },
        enqueueReplaceState: function(publicInstance) {
          warnNoop(publicInstance, "replaceState");
        },
        enqueueSetState: function(publicInstance) {
          warnNoop(publicInstance, "setState");
        }
      }, assign2 = Object.assign, emptyObject = {};
      Object.freeze(emptyObject);
      Component.prototype.isReactComponent = {};
      Component.prototype.setState = function(partialState, callback) {
        if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState)
          throw Error(
            "takes an object of state variables to update or a function which returns an object of state variables."
          );
        this.updater.enqueueSetState(this, partialState, callback, "setState");
      };
      Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
      };
      var deprecatedAPIs = {
        isMounted: [
          "isMounted",
          "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
          "replaceState",
          "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
      };
      for (fnName in deprecatedAPIs)
        deprecatedAPIs.hasOwnProperty(fnName) && defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
      ComponentDummy.prototype = Component.prototype;
      deprecatedAPIs = PureComponent.prototype = new ComponentDummy();
      deprecatedAPIs.constructor = PureComponent;
      assign2(deprecatedAPIs, Component.prototype);
      deprecatedAPIs.isPureReactComponent = true;
      var isArrayImpl = Array.isArray, REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference"), ReactSharedInternals = {
        H: null,
        A: null,
        T: null,
        S: null,
        actQueue: null,
        asyncTransitions: 0,
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false,
        didUsePromise: false,
        thrownErrors: [],
        getCurrentStack: null,
        recentlyCreatedOwnerStacks: 0
      }, hasOwnProperty2 = Object.prototype.hasOwnProperty, createTask = console.createTask ? console.createTask : function() {
        return null;
      };
      deprecatedAPIs = {
        react_stack_bottom_frame: function(callStackForError) {
          return callStackForError();
        }
      };
      var specialPropKeyWarningShown, didWarnAboutOldJSXRuntime;
      var didWarnAboutElementRef = {};
      var unknownOwnerDebugStack = deprecatedAPIs.react_stack_bottom_frame.bind(
        deprecatedAPIs,
        UnknownOwner
      )();
      var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
      var didWarnAboutMaps = false, userProvidedKeyEscapeRegex = /\/+/g, reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
        if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
          var event2 = new window.ErrorEvent("error", {
            bubbles: true,
            cancelable: true,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error
          });
          if (!window.dispatchEvent(event2)) return;
        } else if ("object" === typeof process && "function" === typeof process.emit) {
          process.emit("uncaughtException", error);
          return;
        }
        console.error(error);
      }, didWarnAboutMessageChannel = false, enqueueTaskImpl = null, actScopeDepth = 0, didWarnNoAwaitAct = false, isFlushing = false, queueSeveralMicrotasks = "function" === typeof queueMicrotask ? function(callback) {
        queueMicrotask(function() {
          return queueMicrotask(callback);
        });
      } : enqueueTask;
      deprecatedAPIs = Object.freeze({
        __proto__: null,
        c: function(size) {
          return resolveDispatcher().useMemoCache(size);
        }
      });
      var fnName = {
        map: mapChildren,
        forEach: function(children, forEachFunc, forEachContext) {
          mapChildren(
            children,
            function() {
              forEachFunc.apply(this, arguments);
            },
            forEachContext
          );
        },
        count: function(children) {
          var n12 = 0;
          mapChildren(children, function() {
            n12++;
          });
          return n12;
        },
        toArray: function(children) {
          return mapChildren(children, function(child) {
            return child;
          }) || [];
        },
        only: function(children) {
          if (!isValidElement(children))
            throw Error(
              "React.Children.only expected to receive a single React element child."
            );
          return children;
        }
      };
      exports2.Activity = REACT_ACTIVITY_TYPE;
      exports2.Children = fnName;
      exports2.Component = Component;
      exports2.Fragment = REACT_FRAGMENT_TYPE;
      exports2.Profiler = REACT_PROFILER_TYPE;
      exports2.PureComponent = PureComponent;
      exports2.StrictMode = REACT_STRICT_MODE_TYPE;
      exports2.Suspense = REACT_SUSPENSE_TYPE;
      exports2.ViewTransition = REACT_VIEW_TRANSITION_TYPE;
      exports2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
      exports2.__COMPILER_RUNTIME = deprecatedAPIs;
      exports2.act = function(callback) {
        var prevActQueue = ReactSharedInternals.actQueue, prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        var queue2 = ReactSharedInternals.actQueue = null !== prevActQueue ? prevActQueue : [], didAwaitActCall = false;
        try {
          var result = callback();
        } catch (error) {
          ReactSharedInternals.thrownErrors.push(error);
        }
        if (0 < ReactSharedInternals.thrownErrors.length)
          throw popActScope(prevActQueue, prevActScopeDepth), callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
        if (null !== result && "object" === typeof result && "function" === typeof result.then) {
          var thenable = result;
          queueSeveralMicrotasks(function() {
            didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = true, console.error(
              "You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"
            ));
          });
          return {
            then: function(resolve2, reject) {
              didAwaitActCall = true;
              thenable.then(
                function(returnValue) {
                  popActScope(prevActQueue, prevActScopeDepth);
                  if (0 === prevActScopeDepth) {
                    try {
                      flushActQueue(queue2), enqueueTask(function() {
                        return recursivelyFlushAsyncActWork(
                          returnValue,
                          resolve2,
                          reject
                        );
                      });
                    } catch (error$0) {
                      ReactSharedInternals.thrownErrors.push(error$0);
                    }
                    if (0 < ReactSharedInternals.thrownErrors.length) {
                      var _thrownError = aggregateErrors(
                        ReactSharedInternals.thrownErrors
                      );
                      ReactSharedInternals.thrownErrors.length = 0;
                      reject(_thrownError);
                    }
                  } else resolve2(returnValue);
                },
                function(error) {
                  popActScope(prevActQueue, prevActScopeDepth);
                  0 < ReactSharedInternals.thrownErrors.length ? (error = aggregateErrors(
                    ReactSharedInternals.thrownErrors
                  ), ReactSharedInternals.thrownErrors.length = 0, reject(error)) : reject(error);
                }
              );
            }
          };
        }
        var returnValue$jscomp$0 = result;
        popActScope(prevActQueue, prevActScopeDepth);
        0 === prevActScopeDepth && (flushActQueue(queue2), 0 !== queue2.length && queueSeveralMicrotasks(function() {
          didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = true, console.error(
            "A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"
          ));
        }), ReactSharedInternals.actQueue = null);
        if (0 < ReactSharedInternals.thrownErrors.length)
          throw callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
        return {
          then: function(resolve2, reject) {
            didAwaitActCall = true;
            0 === prevActScopeDepth ? (ReactSharedInternals.actQueue = queue2, enqueueTask(function() {
              return recursivelyFlushAsyncActWork(
                returnValue$jscomp$0,
                resolve2,
                reject
              );
            })) : resolve2(returnValue$jscomp$0);
          }
        };
      };
      exports2.addTransitionType = addTransitionType;
      exports2.cache = function(fn3) {
        return function() {
          return fn3.apply(null, arguments);
        };
      };
      exports2.cacheSignal = function() {
        return null;
      };
      exports2.captureOwnerStack = function() {
        var getCurrentStack = ReactSharedInternals.getCurrentStack;
        return null === getCurrentStack ? null : getCurrentStack();
      };
      exports2.cloneElement = function(element, config2, children) {
        if (null === element || void 0 === element)
          throw Error(
            "The argument must be a React element, but you passed " + element + "."
          );
        var props = assign2({}, element.props), key = element.key, owner = element._owner;
        if (null != config2) {
          var JSCompiler_inline_result;
          a: {
            if (hasOwnProperty2.call(config2, "ref") && (JSCompiler_inline_result = Object.getOwnPropertyDescriptor(
              config2,
              "ref"
            ).get) && JSCompiler_inline_result.isReactWarning) {
              JSCompiler_inline_result = false;
              break a;
            }
            JSCompiler_inline_result = void 0 !== config2.ref;
          }
          JSCompiler_inline_result && (owner = getOwner());
          hasValidKey(config2) && (checkKeyStringCoercion(config2.key), key = "" + config2.key);
          for (propName in config2)
            !hasOwnProperty2.call(config2, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config2.ref || (props[propName] = config2[propName]);
        }
        var propName = arguments.length - 2;
        if (1 === propName) props.children = children;
        else if (1 < propName) {
          JSCompiler_inline_result = Array(propName);
          for (var i = 0; i < propName; i++)
            JSCompiler_inline_result[i] = arguments[i + 2];
          props.children = JSCompiler_inline_result;
        }
        props = ReactElement(
          element.type,
          key,
          props,
          owner,
          element._debugStack,
          element._debugTask
        );
        for (key = 2; key < arguments.length; key++)
          validateChildKeys(arguments[key]);
        return props;
      };
      exports2.createContext = function(defaultValue) {
        defaultValue = {
          $$typeof: REACT_CONTEXT_TYPE,
          _currentValue: defaultValue,
          _currentValue2: defaultValue,
          _threadCount: 0,
          Provider: null,
          Consumer: null
        };
        defaultValue.Provider = defaultValue;
        defaultValue.Consumer = {
          $$typeof: REACT_CONSUMER_TYPE,
          _context: defaultValue
        };
        defaultValue._currentRenderer = null;
        defaultValue._currentRenderer2 = null;
        return defaultValue;
      };
      exports2.createElement = function(type, config2, children) {
        for (var i = 2; i < arguments.length; i++)
          validateChildKeys(arguments[i]);
        var propName;
        i = {};
        var key = null;
        if (null != config2)
          for (propName in didWarnAboutOldJSXRuntime || !("__self" in config2) || "key" in config2 || (didWarnAboutOldJSXRuntime = true, console.warn(
            "Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform"
          )), hasValidKey(config2) && (checkKeyStringCoercion(config2.key), key = "" + config2.key), config2)
            hasOwnProperty2.call(config2, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (i[propName] = config2[propName]);
        var childrenLength = arguments.length - 2;
        if (1 === childrenLength) i.children = children;
        else if (1 < childrenLength) {
          for (var childArray = Array(childrenLength), _i2 = 0; _i2 < childrenLength; _i2++)
            childArray[_i2] = arguments[_i2 + 2];
          Object.freeze && Object.freeze(childArray);
          i.children = childArray;
        }
        if (type && type.defaultProps)
          for (propName in childrenLength = type.defaultProps, childrenLength)
            void 0 === i[propName] && (i[propName] = childrenLength[propName]);
        key && defineKeyPropWarningGetter(
          i,
          "function" === typeof type ? type.displayName || type.name || "Unknown" : type
        );
        (propName = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++) ? (childArray = Error.stackTraceLimit, Error.stackTraceLimit = 10, childrenLength = Error("react-stack-top-frame"), Error.stackTraceLimit = childArray) : childrenLength = unknownOwnerDebugStack;
        return ReactElement(
          type,
          key,
          i,
          getOwner(),
          childrenLength,
          propName ? createTask(getTaskName(type)) : unknownOwnerDebugTask
        );
      };
      exports2.createRef = function() {
        var refObject = { current: null };
        Object.seal(refObject);
        return refObject;
      };
      exports2.forwardRef = function(render) {
        null != render && render.$$typeof === REACT_MEMO_TYPE ? console.error(
          "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))."
        ) : "function" !== typeof render ? console.error(
          "forwardRef requires a render function but was given %s.",
          null === render ? "null" : typeof render
        ) : 0 !== render.length && 2 !== render.length && console.error(
          "forwardRef render functions accept exactly two parameters: props and ref. %s",
          1 === render.length ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."
        );
        null != render && null != render.defaultProps && console.error(
          "forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?"
        );
        var elementType = { $$typeof: REACT_FORWARD_REF_TYPE, render }, ownName;
        Object.defineProperty(elementType, "displayName", {
          enumerable: false,
          configurable: true,
          get: function() {
            return ownName;
          },
          set: function(name) {
            ownName = name;
            render.name || render.displayName || (Object.defineProperty(render, "name", { value: name }), render.displayName = name);
          }
        });
        return elementType;
      };
      exports2.isValidElement = isValidElement;
      exports2.lazy = function(ctor) {
        ctor = { _status: -1, _result: ctor };
        var lazyType = {
          $$typeof: REACT_LAZY_TYPE,
          _payload: ctor,
          _init: lazyInitializer
        }, ioInfo = {
          name: "lazy",
          start: -1,
          end: -1,
          value: null,
          owner: null,
          debugStack: Error("react-stack-top-frame"),
          debugTask: console.createTask ? console.createTask("lazy()") : null
        };
        ctor._ioInfo = ioInfo;
        lazyType._debugInfo = [{ awaited: ioInfo }];
        return lazyType;
      };
      exports2.memo = function(type, compare5) {
        null == type && console.error(
          "memo: The first argument must be a component. Instead received: %s",
          null === type ? "null" : typeof type
        );
        compare5 = {
          $$typeof: REACT_MEMO_TYPE,
          type,
          compare: void 0 === compare5 ? null : compare5
        };
        var ownName;
        Object.defineProperty(compare5, "displayName", {
          enumerable: false,
          configurable: true,
          get: function() {
            return ownName;
          },
          set: function(name) {
            ownName = name;
            type.name || type.displayName || (Object.defineProperty(type, "name", { value: name }), type.displayName = name);
          }
        });
        return compare5;
      };
      exports2.startTransition = startTransition;
      exports2.unstable_useCacheRefresh = function() {
        return resolveDispatcher().useCacheRefresh();
      };
      exports2.use = function(usable) {
        return resolveDispatcher().use(usable);
      };
      exports2.useActionState = function(action, initialState, permalink) {
        return resolveDispatcher().useActionState(
          action,
          initialState,
          permalink
        );
      };
      exports2.useCallback = function(callback, deps) {
        return resolveDispatcher().useCallback(callback, deps);
      };
      exports2.useContext = function(Context2) {
        var dispatcher = resolveDispatcher();
        Context2.$$typeof === REACT_CONSUMER_TYPE && console.error(
          "Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?"
        );
        return dispatcher.useContext(Context2);
      };
      exports2.useDebugValue = function(value, formatterFn) {
        return resolveDispatcher().useDebugValue(value, formatterFn);
      };
      exports2.useDeferredValue = function(value, initialValue) {
        return resolveDispatcher().useDeferredValue(value, initialValue);
      };
      exports2.useEffect = function(create, deps) {
        null == create && console.warn(
          "React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        );
        return resolveDispatcher().useEffect(create, deps);
      };
      exports2.useEffectEvent = function(callback) {
        return resolveDispatcher().useEffectEvent(callback);
      };
      exports2.useId = function() {
        return resolveDispatcher().useId();
      };
      exports2.useImperativeHandle = function(ref2, create, deps) {
        return resolveDispatcher().useImperativeHandle(ref2, create, deps);
      };
      exports2.useInsertionEffect = function(create, deps) {
        null == create && console.warn(
          "React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        );
        return resolveDispatcher().useInsertionEffect(create, deps);
      };
      exports2.useLayoutEffect = function(create, deps) {
        null == create && console.warn(
          "React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        );
        return resolveDispatcher().useLayoutEffect(create, deps);
      };
      exports2.useMemo = function(create, deps) {
        return resolveDispatcher().useMemo(create, deps);
      };
      exports2.useOptimistic = function(passthrough, reducer) {
        return resolveDispatcher().useOptimistic(passthrough, reducer);
      };
      exports2.useReducer = function(reducer, initialArg, init2) {
        return resolveDispatcher().useReducer(reducer, initialArg, init2);
      };
      exports2.useRef = function(initialValue) {
        return resolveDispatcher().useRef(initialValue);
      };
      exports2.useState = function(initialState) {
        return resolveDispatcher().useState(initialState);
      };
      exports2.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
        return resolveDispatcher().useSyncExternalStore(
          subscribe,
          getSnapshot,
          getServerSnapshot
        );
      };
      exports2.useTransition = function() {
        return resolveDispatcher().useTransition();
      };
      exports2.version = "19.3.0";
      "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    })();
  })(react_development, react_development.exports);
  return react_development.exports;
}
var hasRequiredReact;
function requireReact() {
  if (hasRequiredReact) return react.exports;
  hasRequiredReact = 1;
  if (process.env.NODE_ENV === "production") {
    react.exports = requireReact_production();
  } else {
    react.exports = requireReact_development();
  }
  return react.exports;
}
var reactExports = requireReact();
const React = /* @__PURE__ */ getDefaultExportFromCjs(reactExports);
const React$1 = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: React
}, [reactExports]);
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
  return void 0;
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ (function() {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      var _tag$parentNode;
      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
})();
var MS$1 = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs = Math.abs;
var from = String.fromCharCode;
var assign$1 = Object.assign;
function hash$2(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end2) {
  return value.slice(begin, end2);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array) {
  return array.push(value), value;
}
function combine$1(array, callback) {
  return array.map(callback).join("");
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root2, parent2, type, props, children, length2) {
  return { value, root: root2, parent: parent2, type, props, children, line, column, length: length2, return: "" };
}
function copy3(root2, props) {
  return assign$1(node("", null, null, "", null, null, 0), root2, { length: -root2.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice3(begin, end2) {
  return substr(characters, begin, end2);
}
function token(type) {
  switch (type) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type) {
  return trim(slice3(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace(type) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count2) {
  while (--count2 && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice3(index2, caret() + (count2 < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
  while (next())
    switch (character) {
      // ] ) " '
      case type:
        return position;
      // " '
      case 34:
      case 39:
        if (type !== 34 && type !== 39)
          delimiter(character);
        break;
      // (
      case 40:
        if (type === 41)
          delimiter(type);
        break;
      // \
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type, index2) {
  while (next())
    if (type + character === 47 + 10)
      break;
    else if (type + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice3(index2, position - 1) + "*" + from(type === 47 ? type : next());
}
function identifier(index2) {
  while (!token(peek()))
    next();
  return slice3(index2, position);
}
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root2, parent2, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset2 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property2 = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type = "";
  var props = rules;
  var children = rulesets;
  var reference2 = rule;
  var characters2 = type;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      // (
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      // \
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root2, parent2), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      // {
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      // } ; \0
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          // \0 }
          case 0:
          case 125:
            scanning = 0;
          // ;
          case 59 + offset2:
            if (ampersand == -1) characters2 = replace(characters2, /\f/g, "");
            if (property2 > 0 && strlen(characters2) - length2)
              append(property2 > 32 ? declaration(characters2 + ";", rule, parent2, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent2, length2 - 2), declarations);
            break;
          // @ ;
          case 59:
            characters2 += ";";
          // { rule/at-rule
          default:
            append(reference2 = ruleset(characters2, root2, parent2, index2, offset2, rules, points, type, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset2 === 0)
                parse(characters2, root2, reference2, reference2, props, rulesets, length2, points, children);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse(value, reference2, reference2, rule && append(ruleset(value, reference2, reference2, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse(characters2, reference2, reference2, reference2, [""], children, 0, points, children);
                }
        }
        index2 = offset2 = property2 = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
        break;
      // :
      case 58:
        length2 = 1 + strlen(characters2), property2 = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          // &
          case 38:
            ampersand = offset2 > 0 ? 1 : (characters2 += "\f", -1);
            break;
          // ,
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          // @
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset2 = length2 = strlen(type = characters2 += identifier(caret())), character2++;
            break;
          // -
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root2, parent2, index2, offset2, rules, points, type, props, children, length2) {
  var post2 = offset2 - 1;
  var rule = offset2 === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index2; ++i)
    for (var x = 0, y = substr(value, post2 + 1, post2 = abs(j = points[i])), z = value; x < size; ++x)
      if (z = trim(j > 0 ? rule[x] + " " + y : replace(y, /&\f/g, rule[x])))
        props[k++] = z;
  return node(value, root2, parent2, offset2 === 0 ? RULESET : type, props, children, length2);
}
function comment(value, root2, parent2) {
  return node(value, root2, parent2, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root2, parent2, length2) {
  return node(value, root2, parent2, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i = 0; i < length2; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index2, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index2, children, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element, index2, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
function memoize$1(fn3) {
  var cache2 = /* @__PURE__ */ Object.create(null);
  return function(arg2) {
    if (cache2[arg2] === void 0) cache2[arg2] = fn3(arg2);
    return cache2[arg2];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice3(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      // fallthrough
      default:
        parsed[index2] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value;
  var parent2 = element.parent;
  var isImplicitRule = element.column === parent2.column && element.line === parent2.line;
  while (parent2.type !== "rule") {
    parent2 = parent2.parent;
    if (!parent2) return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent2)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent2.props;
  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (
      // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98
    ) {
      element["return"] = "";
      element.value = "";
    }
  }
};
function prefix(value, length2) {
  switch (hash$2(value, length2)) {
    // color-adjust
    case 5103:
      return WEBKIT + "print-" + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS$1 + value + value;
    // flex, flex-direction
    case 6828:
    case 4268:
      return WEBKIT + value + MS$1 + value + value;
    // order
    case 6165:
      return WEBKIT + value + MS$1 + "flex-" + value + value;
    // align-items
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS$1 + "flex-$1$2") + value;
    // align-self
    case 5443:
      return WEBKIT + value + MS$1 + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    // align-content
    case 4675:
      return WEBKIT + value + MS$1 + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    // flex-shrink
    case 5548:
      return WEBKIT + value + MS$1 + replace(value, "shrink", "negative") + value;
    // flex-basis
    case 5292:
      return WEBKIT + value + MS$1 + replace(value, "basis", "preferred-size") + value;
    // flex-grow
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS$1 + replace(value, "grow", "positive") + value;
    // transition
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    // cursor
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    // background, background-image
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    // justify-content
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS$1 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6) switch (charat(value, length2 + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (charat(value, length2 + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
        // (s)tretch
        case 115:
          return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
      }
      break;
    // position: sticky
    case 4949:
      if (charat(value, length2 + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        // (inline-)?fl(e)x
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS$1 + "$2box$3") + value;
      }
      break;
    // writing-mode
    case 5936:
      switch (charat(value, length2 + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS$1 + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        // vertical-r(l)
        case 108:
          return WEBKIT + value + MS$1 + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        // horizontal(-)tb
        case 45:
          return WEBKIT + value + MS$1 + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS$1 + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element, index2, children, callback) {
  if (element.length > -1) {
    if (!element["return"]) switch (element.type) {
      case DECLARATION:
        element["return"] = prefix(element.value, element.length);
        break;
      case KEYFRAMES:
        return serialize([copy3(element, {
          value: replace(element.value, "@", "@" + WEBKIT)
        })], callback);
      case RULESET:
        if (element.length) return combine$1(element.props, function(value) {
          switch (match(value, /(::plac\w+|:read-\w+)/)) {
            // :read-(only|write)
            case ":read-only":
            case ":read-write":
              return serialize([copy3(element, {
                props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
              })], callback);
            // :placeholder
            case "::placeholder":
              return serialize([copy3(element, {
                props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
              }), copy3(element, {
                props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
              }), copy3(element, {
                props: [replace(value, /:(plac\w+)/, MS$1 + "input-$1")]
              })], callback);
          }
          return "";
        });
    }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options) {
  var key = options.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options.container || document.head;
    Array.prototype.forEach.call(
      // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll('style[data-emotion^="' + key + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles2) {
      return serialize(compile(styles2), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache2.inserted[serialized.name] = true;
      }
    };
  }
  var cache2 = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache2.sheet.hydrate(nodesToHydrate);
  return cache2;
};
var reactIs$2 = { exports: {} };
var reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? /* @__PURE__ */ Symbol.for("react.element") : 60103, d = b ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, e = b ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, f = b ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, g = b ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, h12 = b ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, k = b ? /* @__PURE__ */ Symbol.for("react.context") : 60110, l2 = b ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, m = b ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, n12 = b ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, p = b ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, q = b ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, r12 = b ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, t16 = b ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, v = b ? /* @__PURE__ */ Symbol.for("react.block") : 60121, w = b ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, x = b ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, y = b ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l2:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n12:
                case t16:
                case r12:
                case h12:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l2;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h12;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n12;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t16;
  reactIs_production_min.Memo = r12;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z(a) === l2;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z(a) === h12;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z(a) === n12;
  };
  reactIs_production_min.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z(a) === t16;
  };
  reactIs_production_min.isMemo = function(a) {
    return z(a) === r12;
  };
  reactIs_production_min.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t16 || a.$$typeof === r12 || a.$$typeof === h12 || a.$$typeof === k || a.$$typeof === n12 || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development$2 = {};
var hasRequiredReactIs_development$2;
function requireReactIs_development$2() {
  if (hasRequiredReactIs_development$2) return reactIs_development$2;
  hasRequiredReactIs_development$2 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal3 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense2(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$2.AsyncMode = AsyncMode;
      reactIs_development$2.ConcurrentMode = ConcurrentMode;
      reactIs_development$2.ContextConsumer = ContextConsumer;
      reactIs_development$2.ContextProvider = ContextProvider;
      reactIs_development$2.Element = Element2;
      reactIs_development$2.ForwardRef = ForwardRef;
      reactIs_development$2.Fragment = Fragment2;
      reactIs_development$2.Lazy = Lazy;
      reactIs_development$2.Memo = Memo;
      reactIs_development$2.Portal = Portal3;
      reactIs_development$2.Profiler = Profiler;
      reactIs_development$2.StrictMode = StrictMode;
      reactIs_development$2.Suspense = Suspense;
      reactIs_development$2.isAsyncMode = isAsyncMode;
      reactIs_development$2.isConcurrentMode = isConcurrentMode;
      reactIs_development$2.isContextConsumer = isContextConsumer;
      reactIs_development$2.isContextProvider = isContextProvider;
      reactIs_development$2.isElement = isElement2;
      reactIs_development$2.isForwardRef = isForwardRef;
      reactIs_development$2.isFragment = isFragment;
      reactIs_development$2.isLazy = isLazy;
      reactIs_development$2.isMemo = isMemo;
      reactIs_development$2.isPortal = isPortal;
      reactIs_development$2.isProfiler = isProfiler;
      reactIs_development$2.isStrictMode = isStrictMode;
      reactIs_development$2.isSuspense = isSuspense2;
      reactIs_development$2.isValidElementType = isValidElementType;
      reactIs_development$2.typeOf = typeOf;
    })();
  }
  return reactIs_development$2;
}
var hasRequiredReactIs$2;
function requireReactIs$2() {
  if (hasRequiredReactIs$2) return reactIs$2.exports;
  hasRequiredReactIs$2 = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs$2.exports = requireReactIs_production_min();
  } else {
    reactIs$2.exports = requireReactIs_development$2();
  }
  return reactIs$2.exports;
}
var hoistNonReactStatics_cjs;
var hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var reactIs2 = requireReactIs$2();
  var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  };
  var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  };
  var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs2.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs2.Memo] = MEMO_STATICS;
  function getStatics(component) {
    if (reactIs2.isMemo(component)) {
      return MEMO_STATICS;
    }
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
  }
  var defineProperty2 = Object.defineProperty;
  var getOwnPropertyNames = Object.getOwnPropertyNames;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var getPrototypeOf = Object.getPrototypeOf;
  var objectPrototype = Object.prototype;
  function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
      if (objectPrototype) {
        var inheritedComponent = getPrototypeOf(sourceComponent);
        if (inheritedComponent && inheritedComponent !== objectPrototype) {
          hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
      }
      var keys2 = getOwnPropertyNames(sourceComponent);
      if (getOwnPropertySymbols) {
        keys2 = keys2.concat(getOwnPropertySymbols(sourceComponent));
      }
      var targetStatics = getStatics(targetComponent);
      var sourceStatics = getStatics(sourceComponent);
      for (var i = 0; i < keys2.length; ++i) {
        var key = keys2[i];
        if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
          var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
          try {
            defineProperty2(targetComponent, key, descriptor);
          } catch (e) {
          }
        }
      }
    }
    return targetComponent;
  }
  hoistNonReactStatics_cjs = hoistNonReactStatics;
  return hoistNonReactStatics_cjs;
}
requireHoistNonReactStatics_cjs();
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = "";
  classNames.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache2, serialized, isStringTag2) {
  var className = cache2.key + "-" + serialized.name;
  if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag2 === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache2.registered[className] === void 0
  ) {
    cache2.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache2, serialized, isStringTag2) {
  registerStyles(cache2, serialized, isStringTag2);
  var className = cache2.key + "-" + serialized.name;
  if (cache2.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache2.insert(serialized === current ? "." + className : "", current, cache2.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h12 = 0;
  var k, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h12 = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h12 & 65535) * 1540483477 + ((h12 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h12 ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h12 ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h12 ^= str.charCodeAt(i) & 255;
      h12 = /* Math.imul(h, m): */
      (h12 & 65535) * 1540483477 + ((h12 >>> 16) * 59797 << 16);
  }
  h12 ^= h12 >>> 13;
  h12 = /* Math.imul(h, m): */
  (h12 & 65535) * 1540483477 + ((h12 >>> 16) * 59797 << 16);
  return ((h12 ^ h12 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property2) {
  return property2.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize$1(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p12, p22) {
          cursor = {
            name: p12,
            styles: p22,
            next: cursor
          };
          return p12;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  var componentSelector = interpolation;
  if (componentSelector.__emotion_styles !== void 0) {
    return componentSelector;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      var keyframes2 = interpolation;
      if (keyframes2.anim === 1) {
        cursor = {
          name: keyframes2.name,
          styles: keyframes2.styles,
          next: cursor
        };
        return keyframes2.name;
      }
      var serializedStyles = interpolation;
      if (serializedStyles.styles !== void 0) {
        var next2 = serializedStyles.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles2 = serializedStyles.styles + ";";
        return styles2;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  var asString = interpolation;
  if (registered == null) {
    return asString;
  }
  var cached2 = registered[asString];
  return cached2 !== void 0 ? cached2 : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string2 = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string2 += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];
      if (typeof value !== "object") {
        var asString = value;
        if (registered != null && registered[asString] !== void 0) {
          string2 += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string2 += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i2 = 0; _i2 < value.length; _i2++) {
            if (isProcessableValue(value[_i2])) {
              string2 += processStyleName(key) + ":" + processStyleValue(key, value[_i2]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (key) {
            case "animation":
            case "animationName": {
              string2 += processStyleName(key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string2 += key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string2;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles2 = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles2 += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;
    styles2 += asTemplateStringsArr[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles2 += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      var templateStringsArr = strings;
      styles2 += templateStringsArr[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles2)) !== null) {
    identifierName += "-" + match2[1];
  }
  var name = murmur2(styles2) + identifierName;
  return {
    name,
    styles: styles2,
    next: cursor
  };
}
var syncFallback = function syncFallback2(create) {
  return create();
};
var useInsertionEffect = React$1["useInsertionEffect"] ? React$1["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || reactExports.useLayoutEffect;
var EmotionCacheContext = /* @__PURE__ */ reactExports.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return reactExports.useContext(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ reactExports.forwardRef(function(props, ref2) {
    var cache2 = reactExports.useContext(EmotionCacheContext);
    return func(props, cache2, ref2);
  });
};
var ThemeContext = /* @__PURE__ */ reactExports.createContext({});
var hasOwn$1 = {}.hasOwnProperty;
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type, props) {
  var newProps = {};
  for (var _key in props) {
    if (hasOwn$1.call(props, _key)) {
      newProps[_key] = props[_key];
    }
  }
  newProps[typePropName] = type;
  return newProps;
};
var Insertion$1 = function Insertion(_ref) {
  var cache2 = _ref.cache, serialized = _ref.serialized, isStringTag2 = _ref.isStringTag;
  registerStyles(cache2, serialized, isStringTag2);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache2, serialized, isStringTag2);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache2, ref2) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache2.registered[cssProp] !== void 0) {
    cssProp = cache2.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache2.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, reactExports.useContext(ThemeContext));
  className += cache2.key + "-" + serialized.name;
  var newProps = {};
  for (var _key2 in props) {
    if (hasOwn$1.call(props, _key2) && _key2 !== "css" && _key2 !== typePropName && true) {
      newProps[_key2] = props[_key2];
    }
  }
  newProps.className = className;
  if (ref2) {
    newProps.ref = ref2;
  }
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(Insertion$1, {
    cache: cache2,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ reactExports.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;
var jsx = function jsx2(type, props) {
  var args = arguments;
  if (props == null || !hasOwn$1.call(props, "css")) {
    return reactExports.createElement.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }
  return reactExports.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
  var JSX;
  /* @__PURE__ */ (function(_JSX) {
  })(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
})(jsx || (jsx = {}));
var Global = /* @__PURE__ */ withEmotionCache(function(props, cache2) {
  var styles2 = props.styles;
  var serialized = serializeStyles([styles2], void 0, reactExports.useContext(ThemeContext));
  var sheetRef = reactExports.useRef();
  useInsertionEffectWithLayoutFallback(function() {
    var key = cache2.key + "-global";
    var sheet = new cache2.sheet.constructor({
      key,
      nonce: cache2.sheet.nonce,
      container: cache2.sheet.container,
      speedy: cache2.sheet.isSpeedy
    });
    var rehydrating = false;
    var node2 = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
    if (cache2.sheet.tags.length) {
      sheet.before = cache2.sheet.tags[0];
    }
    if (node2 !== null) {
      rehydrating = true;
      node2.setAttribute("data-emotion", key);
      sheet.hydrate([node2]);
    }
    sheetRef.current = [sheet, rehydrating];
    return function() {
      sheet.flush();
    };
  }, [cache2]);
  useInsertionEffectWithLayoutFallback(function() {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }
    if (serialized.next !== void 0) {
      insertStyles(cache2, serialized.next, true);
    }
    if (sheet.tags.length) {
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }
    cache2.insert("", serialized, sheet, false);
  }, [cache2, serialized.name]);
  return null;
});
function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString4() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid = /* @__PURE__ */ memoize$1(
  function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
var testOmitPropsOnStringTag = isPropValid;
var testOmitPropsOnComponent = function testOmitPropsOnComponent2(key) {
  return key !== "theme";
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp2(tag) {
  return typeof tag === "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps2(tag, options, isReal) {
  var shouldForwardProp2;
  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp2 = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }
  if (typeof shouldForwardProp2 !== "function" && isReal) {
    shouldForwardProp2 = tag.__emotion_forwardProp;
  }
  return shouldForwardProp2;
};
var Insertion2 = function Insertion3(_ref) {
  var cache2 = _ref.cache, serialized = _ref.serialized, isStringTag2 = _ref.isStringTag;
  registerStyles(cache2, serialized, isStringTag2);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache2, serialized, isStringTag2);
  });
  return null;
};
var createStyled$1 = function createStyled(tag, options) {
  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;
  if (options !== void 0) {
    identifierName = options.label;
    targetClassName = options.target;
  }
  var shouldForwardProp2 = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp2 || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp("as");
  return function() {
    var args = arguments;
    var styles2 = isReal && tag.__emotion_styles !== void 0 ? tag.__emotion_styles.slice(0) : [];
    if (identifierName !== void 0) {
      styles2.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === void 0) {
      styles2.push.apply(styles2, args);
    } else {
      var templateStringsArr = args[0];
      styles2.push(templateStringsArr[0]);
      var len = args.length;
      var i = 1;
      for (; i < len; i++) {
        styles2.push(args[i], templateStringsArr[i]);
      }
    }
    var Styled = withEmotionCache(function(props, cache2, ref2) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = "";
      var classInterpolations = [];
      var mergedProps = props;
      if (props.theme == null) {
        mergedProps = {};
        for (var key in props) {
          mergedProps[key] = props[key];
        }
        mergedProps.theme = reactExports.useContext(ThemeContext);
      }
      if (typeof props.className === "string") {
        className = getRegisteredStyles(cache2.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }
      var serialized = serializeStyles(styles2.concat(classInterpolations), cache2.registered, mergedProps);
      className += cache2.key + "-" + serialized.name;
      if (targetClassName !== void 0) {
        className += " " + targetClassName;
      }
      var finalShouldForwardProp = shouldUseAs && shouldForwardProp2 === void 0 ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};
      for (var _key in props) {
        if (shouldUseAs && _key === "as") continue;
        if (finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }
      newProps.className = className;
      if (ref2) {
        newProps.ref = ref2;
      }
      return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(Insertion2, {
        cache: cache2,
        serialized,
        isStringTag: typeof FinalTag === "string"
      }), /* @__PURE__ */ reactExports.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== void 0 ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles2;
    Styled.__emotion_forwardProp = shouldForwardProp2;
    Object.defineProperty(Styled, "toString", {
      value: function value() {
        return "." + targetClassName;
      }
    });
    Styled.withComponent = function(nextTag, nextOptions) {
      var newStyled = createStyled(nextTag, _extends({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      }));
      return newStyled.apply(void 0, styles2);
    };
    return Styled;
  };
};
var tags = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
var styled$2 = createStyled$1.bind(null);
tags.forEach(function(tagName) {
  styled$2[tagName] = styled$2(tagName);
});
var propTypes = { exports: {} };
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n12) {
        return test2[n12];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from2;
    var to2 = toObject(target);
    var symbols;
    for (var s12 = 1; s12 < arguments.length; s12++) {
      from2 = Object(arguments[s12]);
      for (var key in from2) {
        if (hasOwnProperty2.call(from2, key)) {
          to2[key] = from2[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from2);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from2, symbols[i])) {
            to2[symbols[i]] = from2[symbols[i]];
          }
        }
      }
    }
    return to2;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = /* @__PURE__ */ requireHas();
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values2, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex2) {
            error = ex2;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack2 = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack2 != null ? stack2 : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs$2();
  var assign2 = requireObjectAssign();
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  var has2 = /* @__PURE__ */ requireHas();
  var checkPropTypes = /* @__PURE__ */ requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer2(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i12 = 0; i12 < arrayOfTypeCheckers.length; i12++) {
          var checker2 = arrayOfTypeCheckers[i12];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator2 = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator2.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator2.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol2(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol2(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  hasRequiredPropTypes = 1;
  if (process.env.NODE_ENV !== "production") {
    var ReactIs = requireReactIs$2();
    var throwOnDirectAccess = true;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
  } else {
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  }
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production = {};
var hasRequiredReactJsxRuntime_production;
function requireReactJsxRuntime_production() {
  if (hasRequiredReactJsxRuntime_production) return reactJsxRuntime_production;
  hasRequiredReactJsxRuntime_production = 1;
  var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
  function jsxProd(type, config2, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config2.key && (key = "" + config2.key);
    if ("key" in config2) {
      maybeKey = {};
      for (var propName in config2)
        "key" !== propName && (maybeKey[propName] = config2[propName]);
    } else maybeKey = config2;
    config2 = maybeKey.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type,
      key,
      ref: void 0 !== config2 ? config2 : null,
      props: maybeKey
    };
  }
  reactJsxRuntime_production.Fragment = REACT_FRAGMENT_TYPE;
  reactJsxRuntime_production.jsx = jsxProd;
  reactJsxRuntime_production.jsxs = jsxProd;
  return reactJsxRuntime_production;
}
var reactJsxRuntime_development = {};
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function getComponentNameFromType(type) {
      if (null == type) return null;
      if ("function" === typeof type)
        return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
      if ("string" === typeof type) return type;
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
          return "Activity";
        case REACT_VIEW_TRANSITION_TYPE:
          return "ViewTransition";
      }
      if ("object" === typeof type)
        switch ("number" === typeof type.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type.$$typeof) {
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
          case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
          case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
              return getComponentNameFromType(type(innerType));
            } catch (x) {
            }
        }
      return null;
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function checkKeyStringCoercion(value) {
      try {
        testStringCoercion(value);
        var JSCompiler_inline_result = false;
      } catch (e) {
        JSCompiler_inline_result = true;
      }
      if (JSCompiler_inline_result) {
        JSCompiler_inline_result = console;
        var JSCompiler_temp_const = JSCompiler_inline_result.error;
        var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        JSCompiler_temp_const.call(
          JSCompiler_inline_result,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          JSCompiler_inline_result$jscomp$0
        );
        return testStringCoercion(value);
      }
    }
    function getTaskName(type) {
      if (type === REACT_FRAGMENT_TYPE) return "<>";
      if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE)
        return "<...>";
      try {
        var name = getComponentNameFromType(type);
        return name ? "<" + name + ">" : "<...>";
      } catch (x) {
        return "<...>";
      }
    }
    function getOwner() {
      var dispatcher = ReactSharedInternals.A;
      return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
      return Error("react-stack-top-frame");
    }
    function hasValidKey(config2) {
      if (hasOwnProperty2.call(config2, "key")) {
        var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
        if (getter && getter.isReactWarning) return false;
      }
      return void 0 !== config2.key;
    }
    function defineKeyPropWarningGetter(props, displayName) {
      function warnAboutAccessingKey() {
        specialPropKeyWarningShown || (specialPropKeyWarningShown = true, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          displayName
        ));
      }
      warnAboutAccessingKey.isReactWarning = true;
      Object.defineProperty(props, "key", {
        get: warnAboutAccessingKey,
        configurable: true
      });
    }
    function elementRefGetterWithDeprecationWarning() {
      var componentName = getComponentNameFromType(this.type);
      didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = true, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      ));
      componentName = this.props.ref;
      return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props, owner, debugStack, debugTask) {
      var refProp = props.ref;
      type = {
        $$typeof: REACT_ELEMENT_TYPE,
        type,
        key,
        props,
        _owner: owner
      };
      null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
        enumerable: false,
        get: elementRefGetterWithDeprecationWarning
      }) : Object.defineProperty(type, "ref", { enumerable: false, value: null });
      type._store = {};
      Object.defineProperty(type._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: 0
      });
      Object.defineProperty(type, "_debugInfo", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: null
      });
      Object.defineProperty(type, "_debugStack", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugStack
      });
      Object.defineProperty(type, "_debugTask", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugTask
      });
      Object.freeze && (Object.freeze(type.props), Object.freeze(type));
      return type;
    }
    function jsxDEVImpl(type, config2, maybeKey, isStaticChildren, debugStack, debugTask) {
      var children = config2.children;
      if (void 0 !== children)
        if (isStaticChildren)
          if (isArrayImpl(children)) {
            for (isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)
              validateChildKeys(children[isStaticChildren]);
            Object.freeze && Object.freeze(children);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else validateChildKeys(children);
      if (hasOwnProperty2.call(config2, "key")) {
        children = getComponentNameFromType(type);
        var keys2 = Object.keys(config2).filter(function(k) {
          return "key" !== k;
        });
        isStaticChildren = 0 < keys2.length ? "{key: someKey, " + keys2.join(": ..., ") + ": ...}" : "{key: someKey}";
        didWarnAboutKeySpread[children + isStaticChildren] || (keys2 = 0 < keys2.length ? "{" + keys2.join(": ..., ") + ": ...}" : "{}", console.error(
          'A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />',
          isStaticChildren,
          children,
          keys2,
          children
        ), didWarnAboutKeySpread[children + isStaticChildren] = true);
      }
      children = null;
      void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
      hasValidKey(config2) && (checkKeyStringCoercion(config2.key), children = "" + config2.key);
      if ("key" in config2) {
        maybeKey = {};
        for (var propName in config2)
          "key" !== propName && (maybeKey[propName] = config2[propName]);
      } else maybeKey = config2;
      children && defineKeyPropWarningGetter(
        maybeKey,
        "function" === typeof type ? type.displayName || type.name || "Unknown" : type
      );
      return ReactElement(
        type,
        children,
        maybeKey,
        getOwner(),
        debugStack,
        debugTask
      );
    }
    function validateChildKeys(node2) {
      isValidElement(node2) ? node2._store && (node2._store.validated = 1) : "object" === typeof node2 && null !== node2 && node2.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node2._payload.status ? isValidElement(node2._payload.value) && node2._payload.value._store && (node2._payload.value._store.validated = 1) : node2._store && (node2._store.validated = 1));
    }
    function isValidElement(object) {
      return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React2 = requireReact(), REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo"), REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = /* @__PURE__ */ Symbol.for("react.activity"), REACT_VIEW_TRANSITION_TYPE = /* @__PURE__ */ Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference"), ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty2 = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
      return null;
    };
    React2 = {
      react_stack_bottom_frame: function(callStackForError) {
        return callStackForError();
      }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React2.react_stack_bottom_frame.bind(
      React2,
      UnknownOwner
    )();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
    reactJsxRuntime_development.jsx = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      if (trackActualOwner) {
        var previousStackTraceLimit = Error.stackTraceLimit;
        Error.stackTraceLimit = 10;
        var debugStackDEV = Error("react-stack-top-frame");
        Error.stackTraceLimit = previousStackTraceLimit;
      } else debugStackDEV = unknownOwnerDebugStack;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        false,
        debugStackDEV,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
    reactJsxRuntime_development.jsxs = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      if (trackActualOwner) {
        var previousStackTraceLimit = Error.stackTraceLimit;
        Error.stackTraceLimit = 10;
        var debugStackDEV = Error("react-stack-top-frame");
        Error.stackTraceLimit = previousStackTraceLimit;
      } else debugStackDEV = unknownOwnerDebugStack;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        true,
        debugStackDEV,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
  })();
  return reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime.exports = requireReactJsxRuntime_production();
  } else {
    jsxRuntime.exports = requireReactJsxRuntime_development();
  }
  return jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
function isEmpty$2(obj) {
  return obj === void 0 || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles$2(props) {
  const {
    styles: styles2,
    defaultTheme: defaultTheme2 = {}
  } = props;
  const globalStyles = typeof styles2 === "function" ? (themeInput) => styles2(isEmpty$2(themeInput) ? defaultTheme2 : themeInput) : styles2;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Global, {
    styles: globalStyles
  });
}
process.env.NODE_ENV !== "production" ? GlobalStyles$2.propTypes = {
  defaultTheme: PropTypes.object,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object, PropTypes.func])
} : void 0;
function styled$1(tag, options) {
  const stylesFactory = styled$2(tag, options);
  if (process.env.NODE_ENV !== "production") {
    return (...styles2) => {
      const component = typeof tag === "string" ? `"${tag}"` : "component";
      if (styles2.length === 0) {
        console.error([`MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join("\n"));
      } else if (styles2.some((style2) => style2 === void 0)) {
        console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
      }
      return stylesFactory(...styles2);
    };
  }
  return stylesFactory;
}
function internal_mutateStyles(tag, processor) {
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
}
const wrapper = [];
function internal_serializeStyles(styles2) {
  wrapper[0] = styles2;
  return serializeStyles(wrapper);
}
var reactIs$1 = { exports: {} };
var reactIs_production$1 = {};
var hasRequiredReactIs_production$1;
function requireReactIs_production$1() {
  if (hasRequiredReactIs_production$1) return reactIs_production$1;
  hasRequiredReactIs_production$1 = 1;
  var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo"), REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = /* @__PURE__ */ Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
  function typeOf(object) {
    if ("object" === typeof object && null !== object) {
      var $$typeof = object.$$typeof;
      switch ($$typeof) {
        case REACT_ELEMENT_TYPE:
          switch (object = object.type, object) {
            case REACT_FRAGMENT_TYPE:
            case REACT_PROFILER_TYPE:
            case REACT_STRICT_MODE_TYPE:
            case REACT_SUSPENSE_TYPE:
            case REACT_SUSPENSE_LIST_TYPE:
            case REACT_VIEW_TRANSITION_TYPE:
              return object;
            default:
              switch (object = object && object.$$typeof, object) {
                case REACT_CONTEXT_TYPE:
                case REACT_FORWARD_REF_TYPE:
                case REACT_LAZY_TYPE:
                case REACT_MEMO_TYPE:
                  return object;
                case REACT_CONSUMER_TYPE:
                  return object;
                default:
                  return $$typeof;
              }
          }
        case REACT_PORTAL_TYPE:
          return $$typeof;
      }
    }
  }
  reactIs_production$1.ContextConsumer = REACT_CONSUMER_TYPE;
  reactIs_production$1.ContextProvider = REACT_CONTEXT_TYPE;
  reactIs_production$1.Element = REACT_ELEMENT_TYPE;
  reactIs_production$1.ForwardRef = REACT_FORWARD_REF_TYPE;
  reactIs_production$1.Fragment = REACT_FRAGMENT_TYPE;
  reactIs_production$1.Lazy = REACT_LAZY_TYPE;
  reactIs_production$1.Memo = REACT_MEMO_TYPE;
  reactIs_production$1.Portal = REACT_PORTAL_TYPE;
  reactIs_production$1.Profiler = REACT_PROFILER_TYPE;
  reactIs_production$1.StrictMode = REACT_STRICT_MODE_TYPE;
  reactIs_production$1.Suspense = REACT_SUSPENSE_TYPE;
  reactIs_production$1.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
  reactIs_production$1.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
  };
  reactIs_production$1.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
  };
  reactIs_production$1.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
  };
  reactIs_production$1.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
  };
  reactIs_production$1.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
  };
  reactIs_production$1.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
  };
  reactIs_production$1.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
  };
  reactIs_production$1.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
  };
  reactIs_production$1.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
  };
  reactIs_production$1.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
  };
  reactIs_production$1.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
  };
  reactIs_production$1.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
  };
  reactIs_production$1.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_VIEW_TRANSITION_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
  };
  reactIs_production$1.typeOf = typeOf;
  return reactIs_production$1;
}
var reactIs_development$1 = {};
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function typeOf(object) {
      if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            switch (object = object.type, object) {
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
              case REACT_SUSPENSE_LIST_TYPE:
              case REACT_VIEW_TRANSITION_TYPE:
                return object;
              default:
                switch (object = object && object.$$typeof, object) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                    return object;
                  case REACT_CONSUMER_TYPE:
                    return object;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
    }
    var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo"), REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = /* @__PURE__ */ Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
    reactIs_development$1.ContextConsumer = REACT_CONSUMER_TYPE;
    reactIs_development$1.ContextProvider = REACT_CONTEXT_TYPE;
    reactIs_development$1.Element = REACT_ELEMENT_TYPE;
    reactIs_development$1.ForwardRef = REACT_FORWARD_REF_TYPE;
    reactIs_development$1.Fragment = REACT_FRAGMENT_TYPE;
    reactIs_development$1.Lazy = REACT_LAZY_TYPE;
    reactIs_development$1.Memo = REACT_MEMO_TYPE;
    reactIs_development$1.Portal = REACT_PORTAL_TYPE;
    reactIs_development$1.Profiler = REACT_PROFILER_TYPE;
    reactIs_development$1.StrictMode = REACT_STRICT_MODE_TYPE;
    reactIs_development$1.Suspense = REACT_SUSPENSE_TYPE;
    reactIs_development$1.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    reactIs_development$1.isContextConsumer = function(object) {
      return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    reactIs_development$1.isContextProvider = function(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    reactIs_development$1.isElement = function(object) {
      return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    };
    reactIs_development$1.isForwardRef = function(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    reactIs_development$1.isFragment = function(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    reactIs_development$1.isLazy = function(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    };
    reactIs_development$1.isMemo = function(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    };
    reactIs_development$1.isPortal = function(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    };
    reactIs_development$1.isProfiler = function(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    };
    reactIs_development$1.isStrictMode = function(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    reactIs_development$1.isSuspense = function(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    reactIs_development$1.isSuspenseList = function(object) {
      return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    reactIs_development$1.isValidElementType = function(type) {
      return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_VIEW_TRANSITION_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
    };
    reactIs_development$1.typeOf = typeOf;
  })();
  return reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  if (hasRequiredReactIs$1) return reactIs$1.exports;
  hasRequiredReactIs$1 = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs$1.exports = /* @__PURE__ */ requireReactIs_production$1();
  } else {
    reactIs$1.exports = /* @__PURE__ */ requireReactIs_development$1();
  }
  return reactIs$1.exports;
}
var reactIsExports$1 = /* @__PURE__ */ requireReactIs$1();
function isPlainObject$2(item) {
  if (typeof item !== "object" || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (/* @__PURE__ */ reactExports.isValidElement(source) || reactIsExports$1.isValidElementType(source) || !isPlainObject$2(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach((key) => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? {
    ...target
  } : target;
  if (isPlainObject$2(target) && isPlainObject$2(source)) {
    Object.keys(source).forEach((key) => {
      if (/* @__PURE__ */ reactExports.isValidElement(source[key]) || reactIsExports$1.isValidElementType(source[key])) {
        output[key] = source[key];
      } else if (isPlainObject$2(source[key]) && // Avoid prototype pollution
      Object.prototype.hasOwnProperty.call(target, key) && isPlainObject$2(target[key])) {
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject$2(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}
const sortBreakpointsValues = (values2) => {
  const breakpointsAsArray = Object.keys(values2).map((key) => ({
    key,
    val: values2[key]
  })) || [];
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return {
      ...acc,
      [obj.key]: obj.val
    };
  }, {});
};
function createBreakpoints(breakpoints) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: values2 = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit = "px",
    step = 5,
    ...other
  } = breakpoints;
  const sortedValues = sortBreakpointsValues(values2);
  const keys2 = Object.keys(sortedValues);
  function up2(key) {
    const value = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start2, end2) {
    const endIndex = keys2.indexOf(end2);
    return `@media (min-width:${typeof values2[start2] === "number" ? values2[start2] : start2}${unit}) and (max-width:${(endIndex !== -1 && typeof values2[keys2[endIndex]] === "number" ? values2[keys2[endIndex]] : end2) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys2.indexOf(key) + 1 < keys2.length) {
      return between(key, keys2[keys2.indexOf(key) + 1]);
    }
    return up2(key);
  }
  function not(key) {
    const keyIndex = keys2.indexOf(key);
    if (keyIndex === 0) {
      return up2(keys2[1]);
    }
    if (keyIndex === keys2.length - 1) {
      return down(keys2[keyIndex]);
    }
    return between(key, keys2[keys2.indexOf(key) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: keys2,
    values: sortedValues,
    up: up2,
    down,
    between,
    only,
    not,
    unit,
    ...other
  };
}
function sortContainerQueries(theme, css2) {
  if (!theme.containerQueries) {
    return css2;
  }
  const sorted = Object.keys(css2).filter((key) => key.startsWith("@container")).sort((a, b) => {
    const regex = /min-width:\s*([0-9.]+)/;
    return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
  });
  if (!sorted.length) {
    return css2;
  }
  return sorted.reduce((acc, key) => {
    const value = css2[key];
    delete acc[key];
    acc[key] = value;
    return acc;
  }, {
    ...css2
  });
}
function isCqShorthand(breakpointKeys, value) {
  return value === "@" || value.startsWith("@") && (breakpointKeys.some((key) => value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function getContainerQuery(theme, shorthand) {
  const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
  if (!matches) {
    if (process.env.NODE_ENV !== "production") {
      throw (
        /* minify-error */
        new Error(`MUI: The provided shorthand ${`(${shorthand})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.`)
      );
    }
    return null;
  }
  const [, containerQuery, containerName] = matches;
  const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
  return theme.containerQueries(containerName).up(value);
}
function cssContainerQueries(themeInput) {
  const toContainerQuery = (mediaQuery, name) => mediaQuery.replace("@media", name ? `@container ${name}` : "@container");
  function attachCq(node3, name) {
    node3.up = (...args) => toContainerQuery(themeInput.breakpoints.up(...args), name);
    node3.down = (...args) => toContainerQuery(themeInput.breakpoints.down(...args), name);
    node3.between = (...args) => toContainerQuery(themeInput.breakpoints.between(...args), name);
    node3.only = (...args) => toContainerQuery(themeInput.breakpoints.only(...args), name);
    node3.not = (...args) => {
      const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
      if (result.includes("not all and")) {
        return result.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or");
      }
      return result;
    };
  }
  const node2 = {};
  const containerQueries = (name) => {
    attachCq(node2, name);
    return node2;
  };
  attachCq(containerQueries);
  return {
    ...themeInput,
    containerQueries
  };
}
const shape = {
  borderRadius: 4
};
const responsivePropType = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge(acc, item, {
    clone: false
    // No need to clone deep, it's way faster.
  });
}
const values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (key) => `@media (min-width:${values$1[key]}px)`
};
const defaultContainerQueries = {
  containerQueries: (containerName) => ({
    up: (key) => {
      let result = typeof key === "number" ? key : values$1[key] || key;
      if (typeof result === "number") {
        result = `${result}px`;
      }
      return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
    }
  })
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index2) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index2])] = styleFromPropValue(propValue[index2]);
      return acc;
    }, {});
  }
  if (typeof propValue === "object") {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      if (isCqShorthand(themeBreakpoints.keys, breakpoint)) {
        const containerKey = getContainerQuery(theme.containerQueries ? theme : defaultContainerQueries, breakpoint);
        if (containerKey) {
          acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
        }
      } else if (Object.keys(themeBreakpoints.values || values$1).includes(breakpoint)) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style2) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style2);
}
function capitalize$2(string2) {
  if (typeof string2 !== "string") {
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage(7));
  }
  return string2.charAt(0).toUpperCase() + string2.slice(1);
}
function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== "string") {
    return null;
  }
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split(".").reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split(".").reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue$1(themeMapping, transform2, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === "function") {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform2) {
    value = transform2(value, userValue, themeMapping);
  }
  return value;
}
function style$1(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform: transform2
  } = options;
  const fn3 = (props) => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = (propValueFinal) => {
      let value = getStyleValue$1(themeMapping, transform2, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === "string") {
        value = getStyleValue$1(themeMapping, transform2, `${prop}${propValueFinal === "default" ? "" : capitalize$2(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn3.propTypes = process.env.NODE_ENV !== "production" ? {
    [prop]: responsivePropType
  } : {};
  fn3.filterProps = [prop];
  return fn3;
}
function memoize(fn3) {
  const cache2 = {};
  return (arg2) => {
    if (cache2[arg2] === void 0) {
      cache2[arg2] = fn3(arg2);
    }
    return cache2[arg2];
  };
}
const properties = {
  m: "margin",
  p: "padding"
};
const directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
};
const aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
};
const getCssProperties = memoize((prop) => {
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split("");
  const property2 = properties[a];
  const direction = directions[b] || "";
  return Array.isArray(direction) ? direction.map((dir) => property2 + dir) : [property2 + direction];
});
const marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"];
const paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  const themeSpacing = getPath(theme, themeKey, true) ?? defaultValue;
  if (typeof themeSpacing === "number" || typeof themeSpacing === "string") {
    return (val) => {
      if (typeof val === "string") {
        return val;
      }
      if (process.env.NODE_ENV !== "production") {
        if (typeof val !== "number") {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${val}.`);
        }
      }
      if (typeof themeSpacing === "string") {
        if (themeSpacing.startsWith("var(") && val === 0) {
          return 0;
        }
        if (themeSpacing.startsWith("var(") && val === 1) {
          return themeSpacing;
        }
        return `calc(${val} * ${themeSpacing})`;
      }
      return themeSpacing * val;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return (val) => {
      if (typeof val === "string") {
        return val;
      }
      const abs2 = Math.abs(val);
      if (process.env.NODE_ENV !== "production") {
        if (!Number.isInteger(abs2)) {
          console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join("\n"));
        } else if (abs2 > themeSpacing.length - 1) {
          console.error([`MUI: The value provided (${abs2}) overflows.`, `The supported values are: ${JSON.stringify(themeSpacing)}.`, `${abs2} > ${themeSpacing.length - 1}, you need to add the missing values.`].join("\n"));
        }
      }
      const transformed = themeSpacing[abs2];
      if (val >= 0) {
        return transformed;
      }
      if (typeof transformed === "number") {
        return -transformed;
      }
      if (typeof transformed === "string" && transformed.startsWith("var(")) {
        return `calc(-1 * ${transformed})`;
      }
      return `-${transformed}`;
    };
  }
  if (typeof themeSpacing === "function") {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== "production") {
    console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`, "It should be a number, an array or a function."].join("\n"));
  }
  return () => void 0;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, "spacing", 8, "spacing");
}
function getValue$1(transformer, propValue) {
  if (typeof propValue === "string" || propValue == null) {
    return propValue;
  }
  return transformer(propValue);
}
function getStyleFromPropValue(cssProperties, transformer) {
  return (propValue) => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue$1(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys2, prop, transformer) {
  if (!keys2.includes(prop)) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style(props, keys2) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map((prop) => resolveCssProperty(props, keys2, prop, transformer)).reduce(merge, {});
}
function margin(props) {
  return style(props, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== "production" ? marginKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
margin.filterProps = marginKeys;
function padding(props) {
  return style(props, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== "production" ? paddingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== "production" ? spacingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
function createSpacing(spacingInput = 8, transform2 = createUnarySpacing({
  spacing: spacingInput
})) {
  if (spacingInput.mui) {
    return spacingInput;
  }
  const spacing = (...argsInput) => {
    if (process.env.NODE_ENV !== "production") {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map((argument) => {
      const output = transform2(argument);
      return typeof output === "number" ? `${output}px` : output;
    }).join(" ");
  };
  spacing.mui = true;
  return spacing;
}
function compose(...styles2) {
  const handlers = styles2.reduce((acc, style2) => {
    style2.filterProps.forEach((prop) => {
      acc[prop] = style2;
    });
    return acc;
  }, {});
  const fn3 = (props) => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn3.propTypes = process.env.NODE_ENV !== "production" ? styles2.reduce((acc, style2) => Object.assign(acc, style2.propTypes), {}) : {};
  fn3.filterProps = styles2.reduce((acc, style2) => acc.concat(style2.filterProps), []);
  return fn3;
}
function borderTransform(value) {
  if (typeof value !== "number") {
    return value;
  }
  return `${value}px solid`;
}
function createBorderStyle(prop, transform2) {
  return style$1({
    prop,
    themeKey: "borders",
    transform: transform2
  });
}
const border = createBorderStyle("border", borderTransform);
const borderTop = createBorderStyle("borderTop", borderTransform);
const borderRight = createBorderStyle("borderRight", borderTransform);
const borderBottom = createBorderStyle("borderBottom", borderTransform);
const borderLeft = createBorderStyle("borderLeft", borderTransform);
const borderColor = createBorderStyle("borderColor");
const borderTopColor = createBorderStyle("borderTopColor");
const borderRightColor = createBorderStyle("borderRightColor");
const borderBottomColor = createBorderStyle("borderBottomColor");
const borderLeftColor = createBorderStyle("borderLeftColor");
const outline = createBorderStyle("outline", borderTransform);
const outlineColor = createBorderStyle("outlineColor");
const borderRadius = (props) => {
  if (props.borderRadius !== void 0 && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, "shape.borderRadius", 4, "borderRadius");
    const styleFromPropValue = (propValue) => ({
      borderRadius: getValue$1(transformer, propValue)
    });
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType
} : {};
borderRadius.filterProps = ["borderRadius"];
compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
const gap = (props) => {
  if (props.gap !== void 0 && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "gap");
    const styleFromPropValue = (propValue) => ({
      gap: getValue$1(transformer, propValue)
    });
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: responsivePropType
} : {};
gap.filterProps = ["gap"];
const columnGap = (props) => {
  if (props.columnGap !== void 0 && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "columnGap");
    const styleFromPropValue = (propValue) => ({
      columnGap: getValue$1(transformer, propValue)
    });
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: responsivePropType
} : {};
columnGap.filterProps = ["columnGap"];
const rowGap = (props) => {
  if (props.rowGap !== void 0 && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "rowGap");
    const styleFromPropValue = (propValue) => ({
      rowGap: getValue$1(transformer, propValue)
    });
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: responsivePropType
} : {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$1({
  prop: "gridColumn"
});
const gridRow = style$1({
  prop: "gridRow"
});
const gridAutoFlow = style$1({
  prop: "gridAutoFlow"
});
const gridAutoColumns = style$1({
  prop: "gridAutoColumns"
});
const gridAutoRows = style$1({
  prop: "gridAutoRows"
});
const gridTemplateColumns = style$1({
  prop: "gridTemplateColumns"
});
const gridTemplateRows = style$1({
  prop: "gridTemplateRows"
});
const gridTemplateAreas = style$1({
  prop: "gridTemplateAreas"
});
const gridArea = style$1({
  prop: "gridArea"
});
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(value, userValue) {
  if (userValue === "grey") {
    return userValue;
  }
  return value;
}
const color = style$1({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
});
const bgcolor = style$1({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
const backgroundColor = style$1({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose(color, bgcolor, backgroundColor);
function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = style$1({
  prop: "width",
  transform: sizingTransform
});
const maxWidth = (props) => {
  if (props.maxWidth !== void 0 && props.maxWidth !== null) {
    const styleFromPropValue = (propValue) => {
      const breakpoint = props.theme?.breakpoints?.values?.[propValue] || values$1[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (props.theme?.breakpoints?.unit !== "px") {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$1({
  prop: "minWidth",
  transform: sizingTransform
});
const height = style$1({
  prop: "height",
  transform: sizingTransform
});
const maxHeight = style$1({
  prop: "maxHeight",
  transform: sizingTransform
});
const minHeight = style$1({
  prop: "minHeight",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
const boxSizing = style$1({
  prop: "boxSizing"
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: (value) => ({
      "@media print": {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: "typography"
  }
};
function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys2, object) => keys2.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every((object) => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg2) {
  return typeof maybeFn === "function" ? maybeFn(arg2) : maybeFn;
}
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config2) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config2[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform: transform2,
      style: style2
    } = options;
    if (val == null) {
      return null;
    }
    if (themeKey === "typography" && val === "inherit") {
      return {
        [prop]: val
      };
    }
    const themeMapping = getPath(theme, themeKey) || {};
    if (style2) {
      return style2(props);
    }
    const styleFromPropValue = (propValueFinal) => {
      let value = getStyleValue$1(themeMapping, transform2, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === "string") {
        value = getStyleValue$1(themeMapping, transform2, `${prop}${propValueFinal === "default" ? "" : capitalize$2(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, val, styleFromPropValue);
  }
  function styleFunctionSx2(props) {
    const {
      sx: sx2,
      theme = {},
      nested
    } = props || {};
    if (!sx2) {
      return null;
    }
    const config2 = theme.unstable_sxConfig ?? defaultSxConfig;
    function traverse2(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === "function") {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== "object") {
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css2 = emptyBreakpoints;
      Object.keys(sxObject).forEach((styleKey) => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== void 0) {
          if (typeof value === "object") {
            if (config2[styleKey]) {
              css2 = merge(css2, getThemeValue(styleKey, value, theme, config2));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value, (x) => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css2[styleKey] = styleFunctionSx2({
                  sx: value,
                  theme,
                  nested: true
                });
              } else {
                css2 = merge(css2, breakpointsValues);
              }
            }
          } else {
            css2 = merge(css2, getThemeValue(styleKey, value, theme, config2));
          }
        }
      });
      if (!nested && theme.modularCssLayers) {
        return {
          "@layer sx": sortContainerQueries(theme, removeUnusedBreakpoints(breakpointsKeys, css2))
        };
      }
      return sortContainerQueries(theme, removeUnusedBreakpoints(breakpointsKeys, css2));
    }
    return Array.isArray(sx2) ? sx2.map(traverse2) : traverse2(sx2);
  }
  return styleFunctionSx2;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ["sx"];
function applyStyles$2(key, styles2) {
  const theme = this;
  if (theme.vars) {
    if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== "function") {
      return {};
    }
    let selector = theme.getColorSchemeSelector(key);
    if (selector === "&") {
      return styles2;
    }
    if (selector.includes("data-") || selector.includes(".")) {
      selector = `*:where(${selector.replace(/\s*&$/, "")}) &`;
    }
    return {
      [selector]: styles2
    };
  }
  if (theme.palette.mode === key) {
    return styles2;
  }
  return {};
}
function createTheme$1(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {},
    ...other
  } = options;
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge({
    breakpoints,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...paletteInput
    },
    spacing,
    shape: {
      ...shape,
      ...shapeInput
    }
  }, other);
  muiTheme = cssContainerQueries(muiTheme);
  muiTheme.applyStyles = applyStyles$2;
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = {
    ...defaultSxConfig,
    ...other?.unstable_sxConfig
  };
  muiTheme.unstable_sx = function sx2(props) {
    return styleFunctionSx({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
function isObjectEmpty$2(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme$2(defaultTheme2 = null) {
  const contextTheme = reactExports.useContext(ThemeContext);
  return !contextTheme || isObjectEmpty$2(contextTheme) ? defaultTheme2 : contextTheme;
}
const systemDefaultTheme$1 = createTheme$1();
function useTheme$1(defaultTheme2 = systemDefaultTheme$1) {
  return useTheme$2(defaultTheme2);
}
function wrapGlobalLayer(styles2) {
  const serialized = internal_serializeStyles(styles2);
  if (styles2 !== serialized && serialized.styles) {
    if (!serialized.styles.match(/^@layer\s+[^{]*$/)) {
      serialized.styles = `@layer global{${serialized.styles}}`;
    }
    return serialized;
  }
  return styles2;
}
function GlobalStyles$1({
  styles: styles2,
  themeId,
  defaultTheme: defaultTheme2 = {}
}) {
  const upperTheme = useTheme$1(defaultTheme2);
  const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
  let globalStyles = typeof styles2 === "function" ? styles2(resolvedTheme) : styles2;
  if (resolvedTheme.modularCssLayers) {
    if (Array.isArray(globalStyles)) {
      globalStyles = globalStyles.map((styleArg2) => {
        if (typeof styleArg2 === "function") {
          return wrapGlobalLayer(styleArg2(resolvedTheme));
        }
        return wrapGlobalLayer(styleArg2);
      });
    } else {
      globalStyles = wrapGlobalLayer(globalStyles);
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$2, {
    styles: globalStyles
  });
}
process.env.NODE_ENV !== "production" ? GlobalStyles$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: PropTypes.object,
  /**
   * @ignore
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool]),
  /**
   * @ignore
   */
  themeId: PropTypes.string
} : void 0;
const splitProps = (props) => {
  const result = {
    systemProps: {},
    otherProps: {}
  };
  const config2 = props?.theme?.unstable_sxConfig ?? defaultSxConfig;
  Object.keys(props).forEach((prop) => {
    if (config2[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};
function extendSxProp$1(props) {
  const {
    sx: inSx,
    ...other
  } = props;
  const {
    systemProps,
    otherProps
  } = splitProps(other);
  let finalSx;
  if (Array.isArray(inSx)) {
    finalSx = [systemProps, ...inSx];
  } else if (typeof inSx === "function") {
    finalSx = (...args) => {
      const result = inSx(...args);
      if (!isPlainObject$2(result)) {
        return systemProps;
      }
      return {
        ...systemProps,
        ...result
      };
    };
  } else {
    finalSx = {
      ...systemProps,
      ...inSx
    };
  }
  return {
    ...otherProps,
    sx: finalSx
  };
}
const defaultGenerator = (componentName) => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
function r(e) {
  var t16, f, n12 = "";
  if ("string" == typeof e || "number" == typeof e) n12 += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t16 = 0; t16 < o; t16++) e[t16] && (f = r(e[t16])) && (n12 && (n12 += " "), n12 += f);
  } else for (f in e) e[f] && (n12 && (n12 += " "), n12 += f);
  return n12;
}
function clsx() {
  for (var e, t16, f = 0, n12 = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t16 = r(e)) && (n12 && (n12 += " "), n12 += t16);
  return n12;
}
function createBox(options = {}) {
  const {
    themeId,
    defaultTheme: defaultTheme2,
    defaultClassName = "MuiBox-root",
    generateClassName
  } = options;
  const BoxRoot = styled$1("div", {
    shouldForwardProp: (prop) => prop !== "theme" && prop !== "sx" && prop !== "as"
  })(styleFunctionSx);
  const Box2 = /* @__PURE__ */ reactExports.forwardRef(function Box3(inProps, ref2) {
    const theme = useTheme$1(defaultTheme2);
    const {
      className,
      component = "div",
      ...other
    } = extendSxProp$1(inProps);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxRoot, {
      as: component,
      ref: ref2,
      className: clsx(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: themeId ? theme[themeId] || theme : theme,
      ...other
    });
  });
  return Box2;
}
const globalStateClasses = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass(componentName, slot, globalStatePrefix = "Mui") {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator.generate(componentName)}-${slot}`;
}
function generateUtilityClasses(componentName, slots, globalStatePrefix = "Mui") {
  const result = {};
  slots.forEach((slot) => {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}
function getFunctionComponentName(Component, fallback = "") {
  return Component.displayName || Component.name || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function getDisplayName(Component) {
  if (Component == null) {
    return void 0;
  }
  if (typeof Component === "string") {
    return Component;
  }
  if (typeof Component === "function") {
    return getFunctionComponentName(Component, "Component");
  }
  if (typeof Component === "object") {
    switch (Component.$$typeof) {
      case reactIsExports$1.ForwardRef:
        return getWrappedName(Component, Component.render, "ForwardRef");
      case reactIsExports$1.Memo:
        return getWrappedName(Component, Component.type, "memo");
      default:
        return void 0;
    }
  }
  return void 0;
}
function preprocessStyles(input) {
  const {
    variants,
    ...style2
  } = input;
  const result = {
    variants,
    style: internal_serializeStyles(style2),
    isProcessed: true
  };
  if (result.style === style2) {
    return result;
  }
  if (variants) {
    variants.forEach((variant) => {
      if (typeof variant.style !== "function") {
        variant.style = internal_serializeStyles(variant.style);
      }
    });
  }
  return result;
}
const systemDefaultTheme = createTheme$1();
function shouldForwardProp(prop) {
  return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
function shallowLayer(serialized, layerName) {
  if (layerName && serialized && typeof serialized === "object" && serialized.styles && !serialized.styles.startsWith("@layer")) {
    serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
  }
  return serialized;
}
function defaultOverridesResolver(slot) {
  if (!slot) {
    return null;
  }
  return (_props, styles2) => styles2[slot];
}
function attachTheme(props, themeId, defaultTheme2) {
  props.theme = isObjectEmpty$1(props.theme) ? defaultTheme2 : props.theme[themeId] || props.theme;
}
function processStyle(props, style2, layerName) {
  const resolvedStyle = typeof style2 === "function" ? style2(props) : style2;
  if (Array.isArray(resolvedStyle)) {
    return resolvedStyle.flatMap((subStyle) => processStyle(props, subStyle, layerName));
  }
  if (Array.isArray(resolvedStyle?.variants)) {
    let rootStyle;
    if (resolvedStyle.isProcessed) {
      rootStyle = layerName ? shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
    } else {
      const {
        variants,
        ...otherStyles
      } = resolvedStyle;
      rootStyle = layerName ? shallowLayer(internal_serializeStyles(otherStyles), layerName) : otherStyles;
    }
    return processStyleVariants(props, resolvedStyle.variants, [rootStyle], layerName);
  }
  if (resolvedStyle?.isProcessed) {
    return layerName ? shallowLayer(internal_serializeStyles(resolvedStyle.style), layerName) : resolvedStyle.style;
  }
  return layerName ? shallowLayer(internal_serializeStyles(resolvedStyle), layerName) : resolvedStyle;
}
function processStyleVariants(props, variants, results = [], layerName = void 0) {
  let mergedState;
  variantLoop: for (let i = 0; i < variants.length; i += 1) {
    const variant = variants[i];
    if (typeof variant.props === "function") {
      mergedState ??= {
        ...props,
        ...props.ownerState,
        ownerState: props.ownerState
      };
      if (!variant.props(mergedState)) {
        continue;
      }
    } else {
      for (const key in variant.props) {
        if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) {
          continue variantLoop;
        }
      }
    }
    if (typeof variant.style === "function") {
      mergedState ??= {
        ...props,
        ...props.ownerState,
        ownerState: props.ownerState
      };
      results.push(layerName ? shallowLayer(internal_serializeStyles(variant.style(mergedState)), layerName) : variant.style(mergedState));
    } else {
      results.push(layerName ? shallowLayer(internal_serializeStyles(variant.style), layerName) : variant.style);
    }
  }
  return results;
}
function createStyled2(input = {}) {
  const {
    themeId,
    defaultTheme: defaultTheme2 = systemDefaultTheme,
    rootShouldForwardProp: rootShouldForwardProp2 = shouldForwardProp,
    slotShouldForwardProp: slotShouldForwardProp2 = shouldForwardProp
  } = input;
  function styleAttachTheme(props) {
    attachTheme(props, themeId, defaultTheme2);
  }
  const styled2 = (tag, inputOptions = {}) => {
    internal_mutateStyles(tag, (styles2) => styles2.filter((style2) => style2 !== styleFunctionSx));
    const {
      name: componentName,
      slot: componentSlot,
      skipVariantsResolver: inputSkipVariantsResolver,
      skipSx: inputSkipSx,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: overridesResolver2 = defaultOverridesResolver(lowercaseFirstLetter(componentSlot)),
      ...options
    } = inputOptions;
    const layerName = componentName && componentName.startsWith("Mui") || !!componentSlot ? "components" : "custom";
    const skipVariantsResolver = inputSkipVariantsResolver !== void 0 ? inputSkipVariantsResolver : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false
    );
    const skipSx = inputSkipSx || false;
    let shouldForwardPropOption = shouldForwardProp;
    if (componentSlot === "Root" || componentSlot === "root") {
      shouldForwardPropOption = rootShouldForwardProp2;
    } else if (componentSlot) {
      shouldForwardPropOption = slotShouldForwardProp2;
    } else if (isStringTag(tag)) {
      shouldForwardPropOption = void 0;
    }
    const defaultStyledResolver = styled$1(tag, {
      shouldForwardProp: shouldForwardPropOption,
      label: generateStyledLabel(componentName, componentSlot),
      ...options
    });
    const transformStyle = (style2) => {
      if (style2.__emotion_real === style2) {
        return style2;
      }
      if (typeof style2 === "function") {
        return function styleFunctionProcessor(props) {
          return processStyle(props, style2, props.theme.modularCssLayers ? layerName : void 0);
        };
      }
      if (isPlainObject$2(style2)) {
        const serialized = preprocessStyles(style2);
        return function styleObjectProcessor(props) {
          if (!serialized.variants) {
            return props.theme.modularCssLayers ? shallowLayer(serialized.style, layerName) : serialized.style;
          }
          return processStyle(props, serialized, props.theme.modularCssLayers ? layerName : void 0);
        };
      }
      return style2;
    };
    const muiStyledResolver = (...expressionsInput) => {
      const expressionsHead = [];
      const expressionsBody = expressionsInput.map(transformStyle);
      const expressionsTail = [];
      expressionsHead.push(styleAttachTheme);
      if (componentName && overridesResolver2) {
        expressionsTail.push(function styleThemeOverrides(props) {
          const theme = props.theme;
          const styleOverrides = theme.components?.[componentName]?.styleOverrides;
          if (!styleOverrides) {
            return null;
          }
          const resolvedStyleOverrides = {};
          for (const slotKey in styleOverrides) {
            resolvedStyleOverrides[slotKey] = processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? "theme" : void 0);
          }
          return overridesResolver2(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsTail.push(function styleThemeVariants(props) {
          const theme = props.theme;
          const themeVariants = theme?.components?.[componentName]?.variants;
          if (!themeVariants) {
            return null;
          }
          return processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? "theme" : void 0);
        });
      }
      if (!skipSx) {
        expressionsTail.push(styleFunctionSx);
      }
      if (Array.isArray(expressionsBody[0])) {
        const inputStrings = expressionsBody.shift();
        const placeholdersHead = new Array(expressionsHead.length).fill("");
        const placeholdersTail = new Array(expressionsTail.length).fill("");
        let outputStrings;
        {
          outputStrings = [...placeholdersHead, ...inputStrings, ...placeholdersTail];
          outputStrings.raw = [...placeholdersHead, ...inputStrings.raw, ...placeholdersTail];
        }
        expressionsHead.unshift(outputStrings);
      }
      const expressions = [...expressionsHead, ...expressionsBody, ...expressionsTail];
      const Component = defaultStyledResolver(...expressions);
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      if (process.env.NODE_ENV !== "production") {
        Component.displayName = generateDisplayName(componentName, componentSlot, tag);
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
  return styled2;
}
function generateDisplayName(componentName, componentSlot, tag) {
  if (componentName) {
    return `${componentName}${capitalize$2(componentSlot || "")}`;
  }
  return `Styled(${getDisplayName(tag)})`;
}
function generateStyledLabel(componentName, componentSlot) {
  let label;
  if (process.env.NODE_ENV !== "production") {
    if (componentName) {
      label = `${componentName}-${lowercaseFirstLetter(componentSlot || "Root")}`;
    }
  }
  return label;
}
function isObjectEmpty$1(object) {
  for (const _ in object) {
    return false;
  }
  return true;
}
function isStringTag(tag) {
  return typeof tag === "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}
function lowercaseFirstLetter(string2) {
  if (!string2) {
    return string2;
  }
  return string2.charAt(0).toLowerCase() + string2.slice(1);
}
function resolveProps(defaultProps2, props, mergeClassNameAndStyle = false) {
  const output = {
    ...props
  };
  for (const key in defaultProps2) {
    if (Object.prototype.hasOwnProperty.call(defaultProps2, key)) {
      const propName = key;
      if (propName === "components" || propName === "slots") {
        output[propName] = {
          ...defaultProps2[propName],
          ...output[propName]
        };
      } else if (propName === "componentsProps" || propName === "slotProps") {
        const defaultSlotProps = defaultProps2[propName];
        const slotProps = props[propName];
        if (!slotProps) {
          output[propName] = defaultSlotProps || {};
        } else if (!defaultSlotProps) {
          output[propName] = slotProps;
        } else {
          output[propName] = {
            ...slotProps
          };
          for (const slotKey in defaultSlotProps) {
            if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
              const slotPropName = slotKey;
              output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName], mergeClassNameAndStyle);
            }
          }
        }
      } else if (propName === "className" && mergeClassNameAndStyle && props.className) {
        output.className = clsx(defaultProps2?.className, props?.className);
      } else if (propName === "style" && mergeClassNameAndStyle && props.style) {
        output.style = {
          ...defaultProps2?.style,
          ...props?.style
        };
      } else if (output[propName] === void 0) {
        output[propName] = defaultProps2[propName];
      }
    }
  }
  return output;
}
function getThemeProps$1(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return resolveProps(theme.components[name].defaultProps, props);
}
function useThemeProps$1({
  props,
  name,
  defaultTheme: defaultTheme2,
  themeId
}) {
  let theme = useTheme$1(defaultTheme2);
  {
    theme = theme[themeId] || theme;
  }
  return getThemeProps$1({
    theme,
    name,
    props
  });
}
const useEnhancedEffect = typeof window !== "undefined" ? reactExports.useLayoutEffect : reactExports.useEffect;
function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const [match2, setMatch] = reactExports.useState(() => {
    if (noSsr && matchMedia) {
      return matchMedia(query).matches;
    }
    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    }
    return defaultMatches;
  });
  useEnhancedEffect(() => {
    if (!matchMedia) {
      return void 0;
    }
    const queryList = matchMedia(query);
    const updateMatch = () => {
      setMatch(queryList.matches);
    };
    updateMatch();
    queryList.addEventListener("change", updateMatch);
    return () => {
      queryList.removeEventListener("change", updateMatch);
    };
  }, [query, matchMedia]);
  return match2;
}
const safeReact$1 = {
  ...React$1
};
const maybeReactUseSyncExternalStore = safeReact$1.useSyncExternalStore;
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const getDefaultSnapshot = reactExports.useCallback(() => defaultMatches, [defaultMatches]);
  const getServerSnapshot = reactExports.useMemo(() => {
    if (noSsr && matchMedia) {
      return () => matchMedia(query).matches;
    }
    if (ssrMatchMedia !== null) {
      const {
        matches
      } = ssrMatchMedia(query);
      return () => matches;
    }
    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia, noSsr, matchMedia]);
  const [getSnapshot, subscribe] = reactExports.useMemo(() => {
    if (matchMedia === null) {
      return [getDefaultSnapshot, () => () => {
      }];
    }
    const mediaQueryList = matchMedia(query);
    return [() => mediaQueryList.matches, (notify) => {
      mediaQueryList.addEventListener("change", notify);
      return () => {
        mediaQueryList.removeEventListener("change", notify);
      };
    }];
  }, [getDefaultSnapshot, matchMedia, query]);
  const match2 = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match2;
}
function unstable_createUseMediaQuery(params = {}) {
  const {
    themeId
  } = params;
  return function useMediaQuery2(queryInput, options = {}) {
    let theme = useTheme$2();
    if (theme && themeId) {
      theme = theme[themeId] || theme;
    }
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const {
      defaultMatches = false,
      matchMedia = supportMatchMedia ? window.matchMedia : null,
      ssrMatchMedia = null,
      noSsr = false
    } = getThemeProps$1({
      name: "MuiUseMediaQuery",
      props: options,
      theme
    });
    if (process.env.NODE_ENV !== "production") {
      if (typeof queryInput === "function" && theme === null) {
        console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join("\n"));
      }
    }
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    if (query.includes("print")) {
      console.warn([`MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`, "Using the print media query to modify print styles can lead to unexpected results.", "Consider using the `displayPrint` field in the `sx` prop instead.", "More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print."].join("\n"));
    }
    const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== void 0 ? useMediaQueryNew : useMediaQueryOld;
    const match2 = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    if (process.env.NODE_ENV !== "production") {
      reactExports.useDebugValue({
        query,
        match: match2
      });
    }
    return match2;
  };
}
unstable_createUseMediaQuery();
function clamp(val, min2 = Number.MIN_SAFE_INTEGER, max2 = Number.MAX_SAFE_INTEGER) {
  return Math.max(min2, Math.min(val, max2));
}
function clampWrapper(value, min2 = 0, max2 = 1) {
  if (process.env.NODE_ENV !== "production") {
    if (value < min2 || value > max2) {
      console.error(`MUI: The value provided ${value} is out of range [${min2}, ${max2}].`);
    }
  }
  return clamp(value, min2, max2);
}
function hexToRgb(color2) {
  color2 = color2.slice(1);
  const re = new RegExp(`.{1,${color2.length >= 6 ? 2 : 1}}`, "g");
  let colors = color2.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map((n12) => n12 + n12);
  }
  if (process.env.NODE_ENV !== "production") {
    if (color2.length !== color2.trim().length) {
      console.error(`MUI: The color: "${color2}" is invalid. Make sure the color input doesn't contain leading/trailing space.`);
    }
  }
  return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n12, index2) => {
    return index2 < 3 ? parseInt(n12, 16) : Math.round(parseInt(n12, 16) / 255 * 1e3) / 1e3;
  }).join(", ")})` : "";
}
function decomposeColor(color2) {
  if (color2.type) {
    return color2;
  }
  if (color2.charAt(0) === "#") {
    return decomposeColor(hexToRgb(color2));
  }
  const marker = color2.indexOf("(");
  const type = color2.substring(0, marker);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(type)) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${color2}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : formatMuiErrorMessage(9, color2));
  }
  let values2 = color2.substring(marker + 1, color2.length - 1);
  let colorSpace;
  if (type === "color") {
    values2 = values2.split(" ");
    colorSpace = values2.shift();
    if (values2.length === 4 && values2[3].charAt(0) === "/") {
      values2[3] = values2[3].slice(1);
    }
    if (!["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(colorSpace)) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : formatMuiErrorMessage(10, colorSpace));
    }
  } else {
    values2 = values2.split(",");
  }
  values2 = values2.map((value) => parseFloat(value));
  return {
    type,
    values: values2,
    colorSpace
  };
}
const colorChannel = (color2) => {
  const decomposedColor = decomposeColor(color2);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.includes("hsl") && idx !== 0 ? `${val}%` : val).join(" ");
};
const private_safeColorChannel = (color2, warning) => {
  try {
    return colorChannel(color2);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== "production") {
      console.warn(warning);
    }
    return color2;
  }
};
function recomposeColor(color2) {
  const {
    type,
    colorSpace
  } = color2;
  let {
    values: values2
  } = color2;
  if (type.includes("rgb")) {
    values2 = values2.map((n12, i) => i < 3 ? parseInt(n12, 10) : n12);
  } else if (type.includes("hsl")) {
    values2[1] = `${values2[1]}%`;
    values2[2] = `${values2[2]}%`;
  }
  if (type.includes("color")) {
    values2 = `${colorSpace} ${values2.join(" ")}`;
  } else {
    values2 = `${values2.join(", ")}`;
  }
  return `${type}(${values2})`;
}
function hslToRgb(color2) {
  color2 = decomposeColor(color2);
  const {
    values: values2
  } = color2;
  const h12 = values2[0];
  const s12 = values2[1] / 100;
  const l2 = values2[2] / 100;
  const a = s12 * Math.min(l2, 1 - l2);
  const f = (n12, k = (n12 + h12 / 30) % 12) => l2 - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = "rgb";
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color2.type === "hsla") {
    type += "a";
    rgb.push(values2[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
function getLuminance(color2) {
  color2 = decomposeColor(color2);
  let rgb = color2.type === "hsl" || color2.type === "hsla" ? decomposeColor(hslToRgb(color2)).values : color2.values;
  rgb = rgb.map((val) => {
    if (color2.type !== "color") {
      val /= 255;
    }
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function alpha(color2, value) {
  color2 = decomposeColor(color2);
  value = clampWrapper(value);
  if (color2.type === "rgb" || color2.type === "hsl") {
    color2.type += "a";
  }
  if (color2.type === "color") {
    color2.values[3] = `/${value}`;
  } else {
    color2.values[3] = value;
  }
  return recomposeColor(color2);
}
function private_safeAlpha(color2, value, warning) {
  try {
    return alpha(color2, value);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== "production") {
      console.warn(warning);
    }
    return color2;
  }
}
function darken(color2, coefficient) {
  color2 = decomposeColor(color2);
  coefficient = clampWrapper(coefficient);
  if (color2.type.includes("hsl")) {
    color2.values[2] *= 1 - coefficient;
  } else if (color2.type.includes("rgb") || color2.type.includes("color")) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color2);
}
function private_safeDarken(color2, coefficient, warning) {
  try {
    return darken(color2, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== "production") {
      console.warn(warning);
    }
    return color2;
  }
}
function lighten(color2, coefficient) {
  color2 = decomposeColor(color2);
  coefficient = clampWrapper(coefficient);
  if (color2.type.includes("hsl")) {
    color2.values[2] += (100 - color2.values[2]) * coefficient;
  } else if (color2.type.includes("rgb")) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] += (255 - color2.values[i]) * coefficient;
    }
  } else if (color2.type.includes("color")) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] += (1 - color2.values[i]) * coefficient;
    }
  }
  return recomposeColor(color2);
}
function private_safeLighten(color2, coefficient, warning) {
  try {
    return lighten(color2, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== "production") {
      console.warn(warning);
    }
    return color2;
  }
}
function emphasize(color2, coefficient = 0.15) {
  return getLuminance(color2) > 0.5 ? darken(color2, coefficient) : lighten(color2, coefficient);
}
function private_safeEmphasize(color2, coefficient, warning) {
  try {
    return emphasize(color2, coefficient);
  } catch (error) {
    return color2;
  }
}
const specialProperty = "exact-prop: ​";
function exactProp(propTypes2) {
  if (process.env.NODE_ENV === "production") {
    return propTypes2;
  }
  return {
    ...propTypes2,
    [specialProperty]: (props) => {
      const unsupportedProps = Object.keys(props).filter((prop) => !propTypes2.hasOwnProperty(prop));
      if (unsupportedProps.length > 0) {
        return new Error(`The following props are not supported: ${unsupportedProps.map((prop) => `\`${prop}\``).join(", ")}. Please remove them.`);
      }
      return null;
    }
  };
}
const RtlContext = /* @__PURE__ */ reactExports.createContext();
process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  value: PropTypes.bool
} : void 0;
const useRtl = () => {
  const value = reactExports.useContext(RtlContext);
  return value ?? false;
};
const PropsContext = /* @__PURE__ */ reactExports.createContext(void 0);
process.env.NODE_ENV !== "production" ? {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  value: PropTypes.object
} : void 0;
function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name]) {
    return props;
  }
  const config2 = theme.components[name];
  if (config2.defaultProps) {
    return resolveProps(config2.defaultProps, props, theme.components.mergeClassNameAndStyle);
  }
  if (!config2.styleOverrides && !config2.variants) {
    return resolveProps(config2, props, theme.components.mergeClassNameAndStyle);
  }
  return props;
}
function useDefaultProps$1({
  props,
  name
}) {
  const ctx = reactExports.useContext(PropsContext);
  return getThemeProps({
    props,
    name,
    theme: {
      components: ctx
    }
  });
}
let globalId = 0;
function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = reactExports.useState(idOverride);
  const id = idOverride || defaultId;
  reactExports.useEffect(() => {
    if (defaultId == null) {
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id;
}
const safeReact = {
  ...React$1
};
const maybeReactUseId = safeReact.useId;
function useId(idOverride) {
  if (maybeReactUseId !== void 0) {
    const reactId = maybeReactUseId();
    return idOverride ?? reactId;
  }
  return useGlobalId(idOverride);
}
const arg = {
  theme: void 0
};
function unstable_memoTheme(styleFn) {
  let lastValue;
  let lastTheme;
  return function styleMemoized(props) {
    let value = lastValue;
    if (value === void 0 || props.theme !== lastTheme) {
      arg.theme = props.theme;
      value = preprocessStyles(styleFn(arg));
      lastValue = value;
      lastTheme = props.theme;
    }
    return value;
  };
}
function createGetCssVar$1(prefix2 = "") {
  function appendVar(...vars) {
    if (!vars.length) {
      return "";
    }
    const value = vars[0];
    if (typeof value === "string" && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) {
      return `, var(--${prefix2 ? `${prefix2}-` : ""}${value}${appendVar(...vars.slice(1))})`;
    }
    return `, ${value}`;
  }
  const getCssVar = (field, ...fallbacks) => {
    return `var(--${prefix2 ? `${prefix2}-` : ""}${field}${appendVar(...fallbacks)})`;
  };
  return getCssVar;
}
const assignNestedKeys = (obj, keys2, value, arrayKeys = []) => {
  let temp = obj;
  keys2.forEach((k, index2) => {
    if (index2 === keys2.length - 1) {
      if (Array.isArray(temp)) {
        temp[Number(k)] = value;
      } else if (temp && typeof temp === "object") {
        temp[k] = value;
      }
    } else if (temp && typeof temp === "object") {
      if (!temp[k]) {
        temp[k] = arrayKeys.includes(k) ? [] : {};
      }
      temp = temp[k];
    }
  });
};
const walkObjectDeep = (obj, callback, shouldSkipPaths) => {
  function recurse(object, parentKeys = [], arrayKeys = []) {
    Object.entries(object).forEach(([key, value]) => {
      if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([...parentKeys, key])) {
        if (value !== void 0 && value !== null) {
          if (typeof value === "object" && Object.keys(value).length > 0) {
            recurse(value, [...parentKeys, key], Array.isArray(value) ? [...arrayKeys, key] : arrayKeys);
          } else {
            callback([...parentKeys, key], value, arrayKeys);
          }
        }
      }
    });
  }
  recurse(obj);
};
const getCssValue = (keys2, value) => {
  if (typeof value === "number") {
    if (["lineHeight", "fontWeight", "opacity", "zIndex"].some((prop) => keys2.includes(prop))) {
      return value;
    }
    const lastKey = keys2[keys2.length - 1];
    if (lastKey.toLowerCase().includes("opacity")) {
      return value;
    }
    return `${value}px`;
  }
  return value;
};
function cssVarsParser(theme, options) {
  const {
    prefix: prefix2,
    shouldSkipGeneratingVar: shouldSkipGeneratingVar2
  } = options || {};
  const css2 = {};
  const vars = {};
  const varsWithDefaults = {};
  walkObjectDeep(
    theme,
    (keys2, value, arrayKeys) => {
      if (typeof value === "string" || typeof value === "number") {
        if (!shouldSkipGeneratingVar2 || !shouldSkipGeneratingVar2(keys2, value)) {
          const cssVar = `--${prefix2 ? `${prefix2}-` : ""}${keys2.join("-")}`;
          const resolvedValue = getCssValue(keys2, value);
          Object.assign(css2, {
            [cssVar]: resolvedValue
          });
          assignNestedKeys(vars, keys2, `var(${cssVar})`, arrayKeys);
          assignNestedKeys(varsWithDefaults, keys2, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
        }
      }
    },
    (keys2) => keys2[0] === "vars"
    // skip 'vars/*' paths
  );
  return {
    css: css2,
    vars,
    varsWithDefaults
  };
}
function prepareCssVars(theme, parserConfig = {}) {
  const {
    getSelector = defaultGetSelector2,
    disableCssColorScheme,
    colorSchemeSelector: selector,
    enableContrastVars
  } = parserConfig;
  const {
    colorSchemes = {},
    components,
    defaultColorScheme = "light",
    ...otherTheme
  } = theme;
  const {
    vars: rootVars,
    css: rootCss,
    varsWithDefaults: rootVarsWithDefaults
  } = cssVarsParser(otherTheme, parserConfig);
  let themeVars = rootVarsWithDefaults;
  const colorSchemesMap = {};
  const {
    [defaultColorScheme]: defaultScheme,
    ...otherColorSchemes
  } = colorSchemes;
  Object.entries(otherColorSchemes || {}).forEach(([key, scheme]) => {
    const {
      vars,
      css: css2,
      varsWithDefaults
    } = cssVarsParser(scheme, parserConfig);
    themeVars = deepmerge(themeVars, varsWithDefaults);
    colorSchemesMap[key] = {
      css: css2,
      vars
    };
  });
  if (defaultScheme) {
    const {
      css: css2,
      vars,
      varsWithDefaults
    } = cssVarsParser(defaultScheme, parserConfig);
    themeVars = deepmerge(themeVars, varsWithDefaults);
    colorSchemesMap[defaultColorScheme] = {
      css: css2,
      vars
    };
  }
  function defaultGetSelector2(colorScheme, cssObject) {
    let rule = selector;
    if (selector === "class") {
      rule = ".%s";
    }
    if (selector === "data") {
      rule = "[data-%s]";
    }
    if (selector?.startsWith("data-") && !selector.includes("%s")) {
      rule = `[${selector}="%s"]`;
    }
    if (colorScheme) {
      if (rule === "media") {
        if (theme.defaultColorScheme === colorScheme) {
          return ":root";
        }
        const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
        return {
          [`@media (prefers-color-scheme: ${mode})`]: {
            ":root": cssObject
          }
        };
      }
      if (rule) {
        if (theme.defaultColorScheme === colorScheme) {
          return `:root, ${rule.replace("%s", String(colorScheme))}`;
        }
        return rule.replace("%s", String(colorScheme));
      }
    }
    return ":root";
  }
  const generateThemeVars = () => {
    let vars = {
      ...rootVars
    };
    Object.entries(colorSchemesMap).forEach(([, {
      vars: schemeVars
    }]) => {
      vars = deepmerge(vars, schemeVars);
    });
    return vars;
  };
  const generateStyleSheets = () => {
    const stylesheets = [];
    const colorScheme = theme.defaultColorScheme || "light";
    function insertStyleSheet(key, css2) {
      if (Object.keys(css2).length) {
        stylesheets.push(typeof key === "string" ? {
          [key]: {
            ...css2
          }
        } : key);
      }
    }
    insertStyleSheet(getSelector(void 0, {
      ...rootCss
    }), rootCss);
    const {
      [colorScheme]: defaultSchemeVal,
      ...other
    } = colorSchemesMap;
    if (defaultSchemeVal) {
      const {
        css: css2
      } = defaultSchemeVal;
      const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
      const finalCss = !disableCssColorScheme && cssColorSheme ? {
        colorScheme: cssColorSheme,
        ...css2
      } : {
        ...css2
      };
      insertStyleSheet(getSelector(colorScheme, {
        ...finalCss
      }), finalCss);
    }
    Object.entries(other).forEach(([key, {
      css: css2
    }]) => {
      const cssColorSheme = colorSchemes[key]?.palette?.mode;
      const finalCss = !disableCssColorScheme && cssColorSheme ? {
        colorScheme: cssColorSheme,
        ...css2
      } : {
        ...css2
      };
      insertStyleSheet(getSelector(key, {
        ...finalCss
      }), finalCss);
    });
    if (enableContrastVars) {
      stylesheets.push({
        ":root": {
          // use double underscore to indicate that these are private variables
          "--__l-threshold": "0.7",
          "--__l": "clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)",
          "--__a": "clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)"
          // 0.87 is the default alpha value for black text.
        }
      });
    }
    return stylesheets;
  };
  return {
    vars: themeVars,
    generateThemeVars,
    generateStyleSheets
  };
}
function createGetColorSchemeSelector(selector) {
  return function getColorSchemeSelector(colorScheme) {
    if (selector === "media") {
      if (process.env.NODE_ENV !== "production") {
        if (colorScheme !== "light" && colorScheme !== "dark") {
          console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${colorScheme}'.`);
        }
      }
      return `@media (prefers-color-scheme: ${colorScheme})`;
    }
    if (selector) {
      if (selector.startsWith("data-") && !selector.includes("%s")) {
        return `[${selector}="${colorScheme}"] &`;
      }
      if (selector === "class") {
        return `.${colorScheme} &`;
      }
      if (selector === "data") {
        return `[data-${colorScheme}] &`;
      }
      return `${selector.replace("%s", colorScheme)} &`;
    }
    return "&";
  };
}
function composeClasses(slots, getUtilityClass, classes = void 0) {
  const output = {};
  for (const slotName in slots) {
    const slot = slots[slotName];
    let buffer2 = "";
    let start2 = true;
    for (let i = 0; i < slot.length; i += 1) {
      const value = slot[i];
      if (value) {
        buffer2 += (start2 === true ? "" : " ") + getUtilityClass(value);
        start2 = false;
        if (classes && classes[value]) {
          buffer2 += " " + classes[value];
        }
      }
    }
    output[slotName] = buffer2;
  }
  return output;
}
function isMuiElement(element, muiNames) {
  return /* @__PURE__ */ reactExports.isValidElement(element) && muiNames.indexOf(
    // For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName
  ) !== -1;
}
function getLight() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: common.white,
      default: common.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const light = getLight();
function getDark() {
  return {
    text: {
      primary: common.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: common.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const dark = getDark();
function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === "light") {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === "dark") {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}
function mixLightOrDark(colorSpace, intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === "light") {
      intent.light = `color-mix(in ${colorSpace}, ${intent.main}, #fff ${(tonalOffsetLight * 100).toFixed(0)}%)`;
    } else if (direction === "dark") {
      intent.dark = `color-mix(in ${colorSpace}, ${intent.main}, #000 ${(tonalOffsetDark * 100).toFixed(0)}%)`;
    }
  }
}
function getDefaultPrimary(mode = "light") {
  if (mode === "dark") {
    return {
      main: blue[200],
      light: blue[50],
      dark: blue[400]
    };
  }
  return {
    main: blue[700],
    light: blue[400],
    dark: blue[800]
  };
}
function getDefaultSecondary(mode = "light") {
  if (mode === "dark") {
    return {
      main: purple[200],
      light: purple[50],
      dark: purple[400]
    };
  }
  return {
    main: purple[500],
    light: purple[300],
    dark: purple[700]
  };
}
function getDefaultError(mode = "light") {
  if (mode === "dark") {
    return {
      main: red[500],
      light: red[300],
      dark: red[700]
    };
  }
  return {
    main: red[700],
    light: red[400],
    dark: red[800]
  };
}
function getDefaultInfo(mode = "light") {
  if (mode === "dark") {
    return {
      main: lightBlue[400],
      light: lightBlue[300],
      dark: lightBlue[700]
    };
  }
  return {
    main: lightBlue[700],
    light: lightBlue[500],
    dark: lightBlue[900]
  };
}
function getDefaultSuccess(mode = "light") {
  if (mode === "dark") {
    return {
      main: green[400],
      light: green[300],
      dark: green[700]
    };
  }
  return {
    main: green[800],
    light: green[500],
    dark: green[900]
  };
}
function getDefaultWarning(mode = "light") {
  if (mode === "dark") {
    return {
      main: orange[400],
      light: orange[300],
      dark: orange[700]
    };
  }
  return {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange[500],
    dark: orange[900]
  };
}
function contrastColor(background) {
  return `oklch(from ${background} var(--__l) 0 h / var(--__a))`;
}
function createPalette(palette) {
  const {
    mode = "light",
    contrastThreshold = 3,
    tonalOffset = 0.2,
    colorSpace,
    ...other
  } = palette;
  const primary = palette.primary || getDefaultPrimary(mode);
  const secondary = palette.secondary || getDefaultSecondary(mode);
  const error = palette.error || getDefaultError(mode);
  const info = palette.info || getDefaultInfo(mode);
  const success = palette.success || getDefaultSuccess(mode);
  const warning = palette.warning || getDefaultWarning(mode);
  function getContrastText(background) {
    if (colorSpace) {
      return contrastColor(background);
    }
    const contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const contrast = getContrastRatio(background, contrastText);
      if (contrast < 3) {
        console.error([`MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join("\n"));
      }
    }
    return contrastText;
  }
  const augmentColor = ({
    color: color2,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color2 = {
      ...color2
    };
    if (!color2.main && color2[mainShade]) {
      color2.main = color2[mainShade];
    }
    if (!color2.hasOwnProperty("main")) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${mainShade}\` property.` : formatMuiErrorMessage(11, name ? ` (${name})` : "", mainShade));
    }
    if (typeof color2.main !== "string") {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(color2.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage(12, name ? ` (${name})` : "", JSON.stringify(color2.main)));
    }
    if (colorSpace) {
      mixLightOrDark(colorSpace, color2, "light", lightShade, tonalOffset);
      mixLightOrDark(colorSpace, color2, "dark", darkShade, tonalOffset);
    } else {
      addLightOrDark(color2, "light", lightShade, tonalOffset);
      addLightOrDark(color2, "dark", darkShade, tonalOffset);
    }
    if (!color2.contrastText) {
      color2.contrastText = getContrastText(color2.main);
    }
    return color2;
  };
  let modeHydrated;
  if (mode === "light") {
    modeHydrated = getLight();
  } else if (mode === "dark") {
    modeHydrated = getDark();
  }
  if (process.env.NODE_ENV !== "production") {
    if (!modeHydrated) {
      console.error(`MUI: The palette mode \`${mode}\` is not supported.`);
    }
  }
  const paletteOutput = deepmerge({
    // A collection of common colors.
    common: {
      ...common
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: "success"
    }),
    // The grey colors.
    grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset,
    // The light and dark mode object.
    ...modeHydrated
  }, other);
  return paletteOutput;
}
function prepareTypographyVars(typography) {
  const vars = {};
  const entries2 = Object.entries(typography);
  entries2.forEach((entry) => {
    const [key, value] = entry;
    if (typeof value === "object") {
      vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ""}${value.fontVariant ? `${value.fontVariant} ` : ""}${value.fontWeight ? `${value.fontWeight} ` : ""}${value.fontStretch ? `${value.fontStretch} ` : ""}${value.fontSize || ""}${value.lineHeight ? `/${value.lineHeight} ` : ""}${value.fontFamily || ""}`;
    }
  });
  return vars;
}
function createMixins(breakpoints, mixins) {
  return {
    toolbar: {
      minHeight: 56,
      [breakpoints.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [breakpoints.up("sm")]: {
        minHeight: 64
      }
    },
    ...mixins
  };
}
function round$3(value) {
  return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette, typography) {
  const {
    fontFamily: fontFamily2 = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize = 14,
    // px
    fontWeightLight = 300,
    fontWeightRegular = 400,
    fontWeightMedium = 500,
    fontWeightBold = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16,
    // Apply the CSS properties to all the variants.
    allVariants,
    pxToRem: pxToRem2,
    ...other
  } = typeof typography === "function" ? typography(palette) : typography;
  if (process.env.NODE_ENV !== "production") {
    if (typeof fontSize !== "number") {
      console.error("MUI: `fontSize` is required to be a number.");
    }
    if (typeof htmlFontSize !== "number") {
      console.error("MUI: `htmlFontSize` is required to be a number.");
    }
  }
  const coef = fontSize / 14;
  const pxToRem = pxToRem2 || ((size) => `${size / htmlFontSize * coef}rem`);
  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => ({
    fontFamily: fontFamily2,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...fontFamily2 === defaultFontFamily ? {
      letterSpacing: `${round$3(letterSpacing / size)}em`
    } : {},
    ...casing,
    ...allVariants
  });
  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge({
    htmlFontSize,
    pxToRem,
    fontFamily: fontFamily2,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold,
    ...variants
  }, other, {
    clone: false
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px2) {
  return [`${px2[0]}px ${px2[1]}px ${px2[2]}px ${px2[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px2[4]}px ${px2[5]}px ${px2[6]}px ${px2[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px2[8]}px ${px2[9]}px ${px2[10]}px ${px2[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
const easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height2) {
  if (!height2) {
    return 0;
  }
  const constant2 = height2 / 36;
  return Math.min(Math.round((4 + 15 * constant2 ** 0.25 + constant2 / 5) * 10), 3e3);
}
function createTransitions(inputTransitions) {
  const mergedEasing = {
    ...easing,
    ...inputTransitions.easing
  };
  const mergedDuration = {
    ...duration,
    ...inputTransitions.duration
  };
  const create = (props = ["all"], options = {}) => {
    const {
      duration: durationOption = mergedDuration.standard,
      easing: easingOption = mergedEasing.easeInOut,
      delay = 0,
      ...other
    } = options;
    if (process.env.NODE_ENV !== "production") {
      const isString2 = (value) => typeof value === "string";
      const isNumber2 = (value) => !Number.isNaN(parseFloat(value));
      if (!isString2(props) && !Array.isArray(props)) {
        console.error('MUI: Argument "props" must be a string or Array.');
      }
      if (!isNumber2(durationOption) && !isString2(durationOption)) {
        console.error(`MUI: Argument "duration" must be a number or a string but found ${durationOption}.`);
      }
      if (!isString2(easingOption)) {
        console.error('MUI: Argument "easing" must be a string.');
      }
      if (!isNumber2(delay) && !isString2(delay)) {
        console.error('MUI: Argument "delay" must be a number or a string.');
      }
      if (typeof options !== "object") {
        console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join("\n"));
      }
      if (Object.keys(other).length !== 0) {
        console.error(`MUI: Unrecognized argument(s) [${Object.keys(other).join(",")}].`);
      }
    }
    return (Array.isArray(props) ? props : [props]).map((animatedProp) => `${animatedProp} ${typeof durationOption === "string" ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : formatMs(delay)}`).join(",");
  };
  return {
    getAutoHeightDuration,
    create,
    ...inputTransitions,
    easing: mergedEasing,
    duration: mergedDuration
  };
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function isSerializable(val) {
  return isPlainObject$2(val) || typeof val === "undefined" || typeof val === "string" || typeof val === "boolean" || typeof val === "number" || Array.isArray(val);
}
function stringifyTheme(baseTheme = {}) {
  const serializableTheme = {
    ...baseTheme
  };
  function serializeTheme(object) {
    const array = Object.entries(object);
    for (let index2 = 0; index2 < array.length; index2++) {
      const [key, value] = array[index2];
      if (!isSerializable(value) || key.startsWith("unstable_")) {
        delete object[key];
      } else if (isPlainObject$2(value)) {
        object[key] = {
          ...value
        };
        serializeTheme(object[key]);
      }
    }
  }
  serializeTheme(serializableTheme);
  return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function coefficientToPercentage(coefficient) {
  if (typeof coefficient === "number") {
    return `${(coefficient * 100).toFixed(0)}%`;
  }
  return `calc((${coefficient}) * 100%)`;
}
const parseAddition = (str) => {
  if (!Number.isNaN(+str)) {
    return +str;
  }
  const numbers = str.match(/\d*\.?\d+/g);
  if (!numbers) {
    return 0;
  }
  let sum = 0;
  for (let i = 0; i < numbers.length; i += 1) {
    sum += +numbers[i];
  }
  return sum;
};
function attachColorManipulators(theme) {
  Object.assign(theme, {
    alpha(color2, coefficient) {
      const obj = this || theme;
      if (obj.colorSpace) {
        return `oklch(from ${color2} l c h / ${typeof coefficient === "string" ? `calc(${coefficient})` : coefficient})`;
      }
      if (obj.vars) {
        return `rgba(${color2.replace(/var\(--([^,\s)]+)(?:,[^)]+)?\)+/g, "var(--$1Channel)")} / ${typeof coefficient === "string" ? `calc(${coefficient})` : coefficient})`;
      }
      return alpha(color2, parseAddition(coefficient));
    },
    lighten(color2, coefficient) {
      const obj = this || theme;
      if (obj.colorSpace) {
        return `color-mix(in ${obj.colorSpace}, ${color2}, #fff ${coefficientToPercentage(coefficient)})`;
      }
      return lighten(color2, coefficient);
    },
    darken(color2, coefficient) {
      const obj = this || theme;
      if (obj.colorSpace) {
        return `color-mix(in ${obj.colorSpace}, ${color2}, #000 ${coefficientToPercentage(coefficient)})`;
      }
      return darken(color2, coefficient);
    }
  });
}
function createThemeNoVars(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput,
    mixins: mixinsInput = {},
    spacing: spacingInput,
    palette: paletteInput = {},
    transitions: transitionsInput = {},
    typography: typographyInput = {},
    shape: shapeInput,
    colorSpace,
    ...other
  } = options;
  if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  options.generateThemeVars === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://v7.mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : formatMuiErrorMessage(20));
  }
  const palette = createPalette({
    ...paletteInput,
    colorSpace
  });
  const systemTheme = createTheme$1(options);
  let muiTheme = deepmerge(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: {
      ...zIndex
    }
  });
  muiTheme = deepmerge(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  if (process.env.NODE_ENV !== "production") {
    const stateClasses = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"];
    const traverse2 = (node2, component) => {
      let key;
      for (key in node2) {
        const child = node2[key];
        if (stateClasses.includes(key) && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const stateClass = generateUtilityClass("", key);
            console.error([`MUI: The \`${component}\` component increases the CSS specificity of the \`${key}\` internal state.`, "You can not override it like this: ", JSON.stringify(node2, null, 2), "", `Instead, you need to use the '&.${stateClass}' syntax:`, JSON.stringify({
              root: {
                [`&.${stateClass}`]: child
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join("\n"));
          }
          node2[key] = {};
        }
      }
    };
    Object.keys(muiTheme.components).forEach((component) => {
      const styleOverrides = muiTheme.components[component].styleOverrides;
      if (styleOverrides && component.startsWith("Mui")) {
        traverse2(styleOverrides, component);
      }
    });
  }
  muiTheme.unstable_sxConfig = {
    ...defaultSxConfig,
    ...other?.unstable_sxConfig
  };
  muiTheme.unstable_sx = function sx2(props) {
    return styleFunctionSx({
      sx: props,
      theme: this
    });
  };
  muiTheme.toRuntimeSource = stringifyTheme;
  attachColorManipulators(muiTheme);
  return muiTheme;
}
function getOverlayAlpha(elevation) {
  let alphaValue;
  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }
  return Math.round(alphaValue * 10) / 1e3;
}
const defaultDarkOverlays = [...Array(25)].map((_, index2) => {
  if (index2 === 0) {
    return "none";
  }
  const overlay = getOverlayAlpha(index2);
  return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function getOpacity(mode) {
  return {
    inputPlaceholder: mode === "dark" ? 0.5 : 0.42,
    inputUnderline: mode === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: mode === "dark" ? 0.2 : 0.12,
    switchTrack: mode === "dark" ? 0.3 : 0.38
  };
}
function getOverlays(mode) {
  return mode === "dark" ? defaultDarkOverlays : [];
}
function createColorScheme(options) {
  const {
    palette: paletteInput = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity,
    overlays,
    colorSpace,
    ...other
  } = options;
  const palette = createPalette({
    ...paletteInput,
    colorSpace
  });
  return {
    palette,
    opacity: {
      ...getOpacity(palette.mode),
      ...opacity
    },
    overlays: overlays || getOverlays(palette.mode),
    ...other
  };
}
function shouldSkipGeneratingVar(keys2) {
  return !!keys2[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys2[0].match(/sxConfig$/) || // ends with sxConfig
  keys2[0] === "palette" && !!keys2[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}
const excludeVariablesFromRoot = (cssVarPrefix) => [...[...Array(25)].map((_, index2) => `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}overlays-${index2}`), `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}palette-AppBar-darkBg`, `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}palette-AppBar-darkColor`];
const defaultGetSelector = (theme) => (colorScheme, css2) => {
  const root2 = theme.rootSelector || ":root";
  const selector = theme.colorSchemeSelector;
  let rule = selector;
  if (selector === "class") {
    rule = ".%s";
  }
  if (selector === "data") {
    rule = "[data-%s]";
  }
  if (selector?.startsWith("data-") && !selector.includes("%s")) {
    rule = `[${selector}="%s"]`;
  }
  if (theme.defaultColorScheme === colorScheme) {
    if (colorScheme === "dark") {
      const excludedVariables = {};
      excludeVariablesFromRoot(theme.cssVarPrefix).forEach((cssVar) => {
        excludedVariables[cssVar] = css2[cssVar];
        delete css2[cssVar];
      });
      if (rule === "media") {
        return {
          [root2]: css2,
          [`@media (prefers-color-scheme: dark)`]: {
            [root2]: excludedVariables
          }
        };
      }
      if (rule) {
        return {
          [rule.replace("%s", colorScheme)]: excludedVariables,
          [`${root2}, ${rule.replace("%s", colorScheme)}`]: css2
        };
      }
      return {
        [root2]: {
          ...css2,
          ...excludedVariables
        }
      };
    }
    if (rule && rule !== "media") {
      return `${root2}, ${rule.replace("%s", String(colorScheme))}`;
    }
  } else if (colorScheme) {
    if (rule === "media") {
      return {
        [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
          [root2]: css2
        }
      };
    }
    if (rule) {
      return rule.replace("%s", String(colorScheme));
    }
  }
  return root2;
};
function assignNode(obj, keys2) {
  keys2.forEach((k) => {
    if (!obj[k]) {
      obj[k] = {};
    }
  });
}
function setColor(obj, key, defaultValue) {
  if (!obj[key] && defaultValue) {
    obj[key] = defaultValue;
  }
}
function toRgb(color2) {
  if (typeof color2 !== "string" || !color2.startsWith("hsl")) {
    return color2;
  }
  return hslToRgb(color2);
}
function setColorChannel(obj, key) {
  if (!(`${key}Channel` in obj)) {
    obj[`${key}Channel`] = private_safeColorChannel(toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
  }
}
function getSpacingVal(spacingInput) {
  if (typeof spacingInput === "number") {
    return `${spacingInput}px`;
  }
  if (typeof spacingInput === "string" || typeof spacingInput === "function" || Array.isArray(spacingInput)) {
    return spacingInput;
  }
  return "8px";
}
const silent = (fn3) => {
  try {
    return fn3();
  } catch (error) {
  }
  return void 0;
};
const createGetCssVar = (cssVarPrefix = "mui") => createGetCssVar$1(cssVarPrefix);
function attachColorScheme$1(colorSpace, colorSchemes, scheme, restTheme, colorScheme) {
  if (!scheme) {
    return void 0;
  }
  scheme = scheme === true ? {} : scheme;
  const mode = colorScheme === "dark" ? "dark" : "light";
  if (!restTheme) {
    colorSchemes[colorScheme] = createColorScheme({
      ...scheme,
      palette: {
        mode,
        ...scheme?.palette
      },
      colorSpace
    });
    return void 0;
  }
  const {
    palette,
    ...muiTheme
  } = createThemeNoVars({
    ...restTheme,
    palette: {
      mode,
      ...scheme?.palette
    },
    colorSpace
  });
  colorSchemes[colorScheme] = {
    ...scheme,
    palette,
    opacity: {
      ...getOpacity(mode),
      ...scheme?.opacity
    },
    overlays: scheme?.overlays || getOverlays(mode)
  };
  return muiTheme;
}
function createThemeWithVars(options = {}, ...args) {
  const {
    colorSchemes: colorSchemesInput = {
      light: true
    },
    defaultColorScheme: defaultColorSchemeInput,
    disableCssColorScheme = false,
    cssVarPrefix = "mui",
    nativeColor = false,
    shouldSkipGeneratingVar: shouldSkipGeneratingVar$1 = shouldSkipGeneratingVar,
    colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? "media" : void 0,
    rootSelector = ":root",
    ...input
  } = options;
  const firstColorScheme = Object.keys(colorSchemesInput)[0];
  const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== "light" ? "light" : firstColorScheme);
  const getCssVar = createGetCssVar(cssVarPrefix);
  const {
    [defaultColorScheme]: defaultSchemeInput,
    light: builtInLight,
    dark: builtInDark,
    ...customColorSchemes
  } = colorSchemesInput;
  const colorSchemes = {
    ...customColorSchemes
  };
  let defaultScheme = defaultSchemeInput;
  if (defaultColorScheme === "dark" && !("dark" in colorSchemesInput) || defaultColorScheme === "light" && !("light" in colorSchemesInput)) {
    defaultScheme = true;
  }
  if (!defaultScheme) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${defaultColorScheme}\` option is either missing or invalid.` : formatMuiErrorMessage(21, defaultColorScheme));
  }
  let colorSpace;
  if (nativeColor) {
    colorSpace = "oklch";
  }
  const muiTheme = attachColorScheme$1(colorSpace, colorSchemes, defaultScheme, input, defaultColorScheme);
  if (builtInLight && !colorSchemes.light) {
    attachColorScheme$1(colorSpace, colorSchemes, builtInLight, void 0, "light");
  }
  if (builtInDark && !colorSchemes.dark) {
    attachColorScheme$1(colorSpace, colorSchemes, builtInDark, void 0, "dark");
  }
  let theme = {
    defaultColorScheme,
    ...muiTheme,
    cssVarPrefix,
    colorSchemeSelector: selector,
    rootSelector,
    getCssVar,
    colorSchemes,
    font: {
      ...prepareTypographyVars(muiTheme.typography),
      ...muiTheme.font
    },
    spacing: getSpacingVal(input.spacing)
  };
  Object.keys(theme.colorSchemes).forEach((key) => {
    const palette = theme.colorSchemes[key].palette;
    const setCssVarColor = (cssVar) => {
      const tokens = cssVar.split("-");
      const color2 = tokens[1];
      const colorToken = tokens[2];
      return getCssVar(cssVar, palette[color2][colorToken]);
    };
    if (palette.mode === "light") {
      setColor(palette.common, "background", "#fff");
      setColor(palette.common, "onBackground", "#000");
    }
    if (palette.mode === "dark") {
      setColor(palette.common, "background", "#000");
      setColor(palette.common, "onBackground", "#fff");
    }
    function colorMix(method, color2, coefficient) {
      if (colorSpace) {
        let mixer;
        if (method === private_safeAlpha) {
          mixer = `transparent ${((1 - coefficient) * 100).toFixed(0)}%`;
        }
        if (method === private_safeDarken) {
          mixer = `#000 ${(coefficient * 100).toFixed(0)}%`;
        }
        if (method === private_safeLighten) {
          mixer = `#fff ${(coefficient * 100).toFixed(0)}%`;
        }
        return `color-mix(in ${colorSpace}, ${color2}, ${mixer})`;
      }
      return method(color2, coefficient);
    }
    assignNode(palette, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]);
    if (palette.mode === "light") {
      setColor(palette.Alert, "errorColor", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-error-light") : palette.error.light, 0.6));
      setColor(palette.Alert, "infoColor", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-info-light") : palette.info.light, 0.6));
      setColor(palette.Alert, "successColor", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-success-light") : palette.success.light, 0.6));
      setColor(palette.Alert, "warningColor", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-warning-light") : palette.warning.light, 0.6));
      setColor(palette.Alert, "errorFilledBg", setCssVarColor("palette-error-main"));
      setColor(palette.Alert, "infoFilledBg", setCssVarColor("palette-info-main"));
      setColor(palette.Alert, "successFilledBg", setCssVarColor("palette-success-main"));
      setColor(palette.Alert, "warningFilledBg", setCssVarColor("palette-warning-main"));
      setColor(palette.Alert, "errorFilledColor", silent(() => palette.getContrastText(palette.error.main)));
      setColor(palette.Alert, "infoFilledColor", silent(() => palette.getContrastText(palette.info.main)));
      setColor(palette.Alert, "successFilledColor", silent(() => palette.getContrastText(palette.success.main)));
      setColor(palette.Alert, "warningFilledColor", silent(() => palette.getContrastText(palette.warning.main)));
      setColor(palette.Alert, "errorStandardBg", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-error-light") : palette.error.light, 0.9));
      setColor(palette.Alert, "infoStandardBg", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-info-light") : palette.info.light, 0.9));
      setColor(palette.Alert, "successStandardBg", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-success-light") : palette.success.light, 0.9));
      setColor(palette.Alert, "warningStandardBg", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-warning-light") : palette.warning.light, 0.9));
      setColor(palette.Alert, "errorIconColor", setCssVarColor("palette-error-main"));
      setColor(palette.Alert, "infoIconColor", setCssVarColor("palette-info-main"));
      setColor(palette.Alert, "successIconColor", setCssVarColor("palette-success-main"));
      setColor(palette.Alert, "warningIconColor", setCssVarColor("palette-warning-main"));
      setColor(palette.AppBar, "defaultBg", setCssVarColor("palette-grey-100"));
      setColor(palette.Avatar, "defaultBg", setCssVarColor("palette-grey-400"));
      setColor(palette.Button, "inheritContainedBg", setCssVarColor("palette-grey-300"));
      setColor(palette.Button, "inheritContainedHoverBg", setCssVarColor("palette-grey-A100"));
      setColor(palette.Chip, "defaultBorder", setCssVarColor("palette-grey-400"));
      setColor(palette.Chip, "defaultAvatarColor", setCssVarColor("palette-grey-700"));
      setColor(palette.Chip, "defaultIconColor", setCssVarColor("palette-grey-700"));
      setColor(palette.FilledInput, "bg", "rgba(0, 0, 0, 0.06)");
      setColor(palette.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)");
      setColor(palette.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)");
      setColor(palette.LinearProgress, "primaryBg", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-primary-main") : palette.primary.main, 0.62));
      setColor(palette.LinearProgress, "secondaryBg", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-secondary-main") : palette.secondary.main, 0.62));
      setColor(palette.LinearProgress, "errorBg", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-error-main") : palette.error.main, 0.62));
      setColor(palette.LinearProgress, "infoBg", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-info-main") : palette.info.main, 0.62));
      setColor(palette.LinearProgress, "successBg", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-success-main") : palette.success.main, 0.62));
      setColor(palette.LinearProgress, "warningBg", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-warning-light") : palette.warning.main, 0.62));
      setColor(palette.Skeleton, "bg", colorSpace ? colorMix(private_safeAlpha, nativeColor ? getCssVar("palette-text-primary") : palette.text.primary, 0.11) : `rgba(${setCssVarColor("palette-text-primaryChannel")} / 0.11)`);
      setColor(palette.Slider, "primaryTrack", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-primary-main") : palette.primary.main, 0.62));
      setColor(palette.Slider, "secondaryTrack", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-secondary-main") : palette.secondary.main, 0.62));
      setColor(palette.Slider, "errorTrack", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-error-main") : palette.error.main, 0.62));
      setColor(palette.Slider, "infoTrack", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-info-main") : palette.info.main, 0.62));
      setColor(palette.Slider, "successTrack", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-success-main") : palette.success.main, 0.62));
      setColor(palette.Slider, "warningTrack", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-warning-main") : palette.warning.main, 0.62));
      const snackbarContentBackground = colorSpace ? colorMix(private_safeDarken, nativeColor ? getCssVar("palette-background-default") : palette.background.default, 0.6825) : private_safeEmphasize(palette.background.default, 0.8);
      setColor(palette.SnackbarContent, "bg", snackbarContentBackground);
      setColor(palette.SnackbarContent, "color", silent(() => colorSpace ? dark.text.primary : palette.getContrastText(snackbarContentBackground)));
      setColor(palette.SpeedDialAction, "fabHoverBg", private_safeEmphasize(palette.background.paper, 0.15));
      setColor(palette.StepConnector, "border", setCssVarColor("palette-grey-400"));
      setColor(palette.StepContent, "border", setCssVarColor("palette-grey-400"));
      setColor(palette.Switch, "defaultColor", setCssVarColor("palette-common-white"));
      setColor(palette.Switch, "defaultDisabledColor", setCssVarColor("palette-grey-100"));
      setColor(palette.Switch, "primaryDisabledColor", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-primary-main") : palette.primary.main, 0.62));
      setColor(palette.Switch, "secondaryDisabledColor", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-secondary-main") : palette.secondary.main, 0.62));
      setColor(palette.Switch, "errorDisabledColor", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-error-main") : palette.error.main, 0.62));
      setColor(palette.Switch, "infoDisabledColor", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-info-main") : palette.info.main, 0.62));
      setColor(palette.Switch, "successDisabledColor", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-success-main") : palette.success.main, 0.62));
      setColor(palette.Switch, "warningDisabledColor", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-warning-main") : palette.warning.main, 0.62));
      setColor(palette.TableCell, "border", colorMix(private_safeLighten, private_safeAlpha(nativeColor ? getCssVar("palette-divider") : palette.divider, 1), 0.88));
      setColor(palette.Tooltip, "bg", colorMix(private_safeAlpha, nativeColor ? getCssVar("palette-grey-700") : palette.grey[700], 0.92));
    }
    if (palette.mode === "dark") {
      setColor(palette.Alert, "errorColor", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-error-light") : palette.error.light, 0.6));
      setColor(palette.Alert, "infoColor", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-info-light") : palette.info.light, 0.6));
      setColor(palette.Alert, "successColor", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-success-light") : palette.success.light, 0.6));
      setColor(palette.Alert, "warningColor", colorMix(private_safeLighten, nativeColor ? getCssVar("palette-warning-light") : palette.warning.light, 0.6));
      setColor(palette.Alert, "errorFilledBg", setCssVarColor("palette-error-dark"));
      setColor(palette.Alert, "infoFilledBg", setCssVarColor("palette-info-dark"));
      setColor(palette.Alert, "successFilledBg", setCssVarColor("palette-success-dark"));
      setColor(palette.Alert, "warningFilledBg", setCssVarColor("palette-warning-dark"));
      setColor(palette.Alert, "errorFilledColor", silent(() => palette.getContrastText(palette.error.dark)));
      setColor(palette.Alert, "infoFilledColor", silent(() => palette.getContrastText(palette.info.dark)));
      setColor(palette.Alert, "successFilledColor", silent(() => palette.getContrastText(palette.success.dark)));
      setColor(palette.Alert, "warningFilledColor", silent(() => palette.getContrastText(palette.warning.dark)));
      setColor(palette.Alert, "errorStandardBg", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-error-light") : palette.error.light, 0.9));
      setColor(palette.Alert, "infoStandardBg", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-info-light") : palette.info.light, 0.9));
      setColor(palette.Alert, "successStandardBg", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-success-light") : palette.success.light, 0.9));
      setColor(palette.Alert, "warningStandardBg", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-warning-light") : palette.warning.light, 0.9));
      setColor(palette.Alert, "errorIconColor", setCssVarColor("palette-error-main"));
      setColor(palette.Alert, "infoIconColor", setCssVarColor("palette-info-main"));
      setColor(palette.Alert, "successIconColor", setCssVarColor("palette-success-main"));
      setColor(palette.Alert, "warningIconColor", setCssVarColor("palette-warning-main"));
      setColor(palette.AppBar, "defaultBg", setCssVarColor("palette-grey-900"));
      setColor(palette.AppBar, "darkBg", setCssVarColor("palette-background-paper"));
      setColor(palette.AppBar, "darkColor", setCssVarColor("palette-text-primary"));
      setColor(palette.Avatar, "defaultBg", setCssVarColor("palette-grey-600"));
      setColor(palette.Button, "inheritContainedBg", setCssVarColor("palette-grey-800"));
      setColor(palette.Button, "inheritContainedHoverBg", setCssVarColor("palette-grey-700"));
      setColor(palette.Chip, "defaultBorder", setCssVarColor("palette-grey-700"));
      setColor(palette.Chip, "defaultAvatarColor", setCssVarColor("palette-grey-300"));
      setColor(palette.Chip, "defaultIconColor", setCssVarColor("palette-grey-300"));
      setColor(palette.FilledInput, "bg", "rgba(255, 255, 255, 0.09)");
      setColor(palette.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)");
      setColor(palette.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)");
      setColor(palette.LinearProgress, "primaryBg", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-primary-main") : palette.primary.main, 0.5));
      setColor(palette.LinearProgress, "secondaryBg", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-secondary-main") : palette.secondary.main, 0.5));
      setColor(palette.LinearProgress, "errorBg", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-error-main") : palette.error.main, 0.5));
      setColor(palette.LinearProgress, "infoBg", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-info-main") : palette.info.main, 0.5));
      setColor(palette.LinearProgress, "successBg", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-success-main") : palette.success.main, 0.5));
      setColor(palette.LinearProgress, "warningBg", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-warning-main") : palette.warning.main, 0.5));
      setColor(palette.Skeleton, "bg", colorSpace ? colorMix(private_safeAlpha, nativeColor ? getCssVar("palette-text-primary") : palette.text.primary, 0.13) : `rgba(${setCssVarColor("palette-text-primaryChannel")} / 0.13)`);
      setColor(palette.Slider, "primaryTrack", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-primary-main") : palette.primary.main, 0.5));
      setColor(palette.Slider, "secondaryTrack", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-secondary-main") : palette.secondary.main, 0.5));
      setColor(palette.Slider, "errorTrack", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-error-main") : palette.error.main, 0.5));
      setColor(palette.Slider, "infoTrack", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-info-main") : palette.info.main, 0.5));
      setColor(palette.Slider, "successTrack", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-success-main") : palette.success.main, 0.5));
      setColor(palette.Slider, "warningTrack", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-warning-light") : palette.warning.main, 0.5));
      const snackbarContentBackground = colorSpace ? colorMix(private_safeLighten, nativeColor ? getCssVar("palette-background-default") : palette.background.default, 0.985) : private_safeEmphasize(palette.background.default, 0.98);
      setColor(palette.SnackbarContent, "bg", snackbarContentBackground);
      setColor(palette.SnackbarContent, "color", silent(() => colorSpace ? light.text.primary : palette.getContrastText(snackbarContentBackground)));
      setColor(palette.SpeedDialAction, "fabHoverBg", private_safeEmphasize(palette.background.paper, 0.15));
      setColor(palette.StepConnector, "border", setCssVarColor("palette-grey-600"));
      setColor(palette.StepContent, "border", setCssVarColor("palette-grey-600"));
      setColor(palette.Switch, "defaultColor", setCssVarColor("palette-grey-300"));
      setColor(palette.Switch, "defaultDisabledColor", setCssVarColor("palette-grey-600"));
      setColor(palette.Switch, "primaryDisabledColor", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-primary-main") : palette.primary.main, 0.55));
      setColor(palette.Switch, "secondaryDisabledColor", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-secondary-main") : palette.secondary.main, 0.55));
      setColor(palette.Switch, "errorDisabledColor", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-error-main") : palette.error.main, 0.55));
      setColor(palette.Switch, "infoDisabledColor", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-info-main") : palette.info.main, 0.55));
      setColor(palette.Switch, "successDisabledColor", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-success-main") : palette.success.main, 0.55));
      setColor(palette.Switch, "warningDisabledColor", colorMix(private_safeDarken, nativeColor ? getCssVar("palette-warning-light") : palette.warning.main, 0.55));
      setColor(palette.TableCell, "border", colorMix(private_safeDarken, private_safeAlpha(nativeColor ? getCssVar("palette-divider") : palette.divider, 1), 0.68));
      setColor(palette.Tooltip, "bg", colorMix(private_safeAlpha, nativeColor ? getCssVar("palette-grey-700") : palette.grey[700], 0.92));
    }
    if (!nativeColor) {
      setColorChannel(palette.background, "default");
      setColorChannel(palette.background, "paper");
      setColorChannel(palette.common, "background");
      setColorChannel(palette.common, "onBackground");
      setColorChannel(palette, "divider");
    }
    Object.keys(palette).forEach((color2) => {
      const colors = palette[color2];
      if (color2 !== "tonalOffset" && !nativeColor && colors && typeof colors === "object") {
        if (colors.main) {
          setColor(palette[color2], "mainChannel", private_safeColorChannel(toRgb(colors.main)));
        }
        if (colors.light) {
          setColor(palette[color2], "lightChannel", private_safeColorChannel(toRgb(colors.light)));
        }
        if (colors.dark) {
          setColor(palette[color2], "darkChannel", private_safeColorChannel(toRgb(colors.dark)));
        }
        if (colors.contrastText) {
          setColor(palette[color2], "contrastTextChannel", private_safeColorChannel(toRgb(colors.contrastText)));
        }
        if (color2 === "text") {
          setColorChannel(palette[color2], "primary");
          setColorChannel(palette[color2], "secondary");
        }
        if (color2 === "action") {
          if (colors.active) {
            setColorChannel(palette[color2], "active");
          }
          if (colors.selected) {
            setColorChannel(palette[color2], "selected");
          }
        }
      }
    });
  });
  theme = args.reduce((acc, argument) => deepmerge(acc, argument), theme);
  const parserConfig = {
    prefix: cssVarPrefix,
    disableCssColorScheme,
    shouldSkipGeneratingVar: shouldSkipGeneratingVar$1,
    getSelector: defaultGetSelector(theme),
    enableContrastVars: nativeColor
  };
  const {
    vars,
    generateThemeVars,
    generateStyleSheets
  } = prepareCssVars(theme, parserConfig);
  theme.vars = vars;
  Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value]) => {
    theme[key] = value;
  });
  theme.generateThemeVars = generateThemeVars;
  theme.generateStyleSheets = generateStyleSheets;
  theme.generateSpacing = function generateSpacing() {
    return createSpacing(input.spacing, createUnarySpacing(this));
  };
  theme.getColorSchemeSelector = createGetColorSchemeSelector(selector);
  theme.spacing = theme.generateSpacing();
  theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar$1;
  theme.unstable_sxConfig = {
    ...defaultSxConfig,
    ...input?.unstable_sxConfig
  };
  theme.unstable_sx = function sx2(props) {
    return styleFunctionSx({
      sx: props,
      theme: this
    });
  };
  theme.toRuntimeSource = stringifyTheme;
  return theme;
}
function attachColorScheme(theme, scheme, colorScheme) {
  if (!theme.colorSchemes) {
    return void 0;
  }
  if (colorScheme) {
    theme.colorSchemes[scheme] = {
      ...colorScheme !== true && colorScheme,
      palette: createPalette({
        ...colorScheme === true ? {} : colorScheme.palette,
        mode: scheme
      })
      // cast type to skip module augmentation test
    };
  }
}
function createTheme(options = {}, ...args) {
  const {
    palette,
    cssVariables = false,
    colorSchemes: initialColorSchemes = !palette ? {
      light: true
    } : void 0,
    defaultColorScheme: initialDefaultColorScheme = palette?.mode,
    ...other
  } = options;
  const defaultColorSchemeInput = initialDefaultColorScheme || "light";
  const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
  const colorSchemesInput = {
    ...initialColorSchemes,
    ...palette ? {
      [defaultColorSchemeInput]: {
        ...typeof defaultScheme !== "boolean" && defaultScheme,
        palette
      }
    } : void 0
  };
  if (cssVariables === false) {
    if (!("colorSchemes" in options)) {
      return createThemeNoVars(options, ...args);
    }
    let paletteOptions = palette;
    if (!("palette" in options)) {
      if (colorSchemesInput[defaultColorSchemeInput]) {
        if (colorSchemesInput[defaultColorSchemeInput] !== true) {
          paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
        } else if (defaultColorSchemeInput === "dark") {
          paletteOptions = {
            mode: "dark"
          };
        }
      }
    }
    const theme = createThemeNoVars({
      ...options,
      palette: paletteOptions
    }, ...args);
    theme.defaultColorScheme = defaultColorSchemeInput;
    theme.colorSchemes = colorSchemesInput;
    if (theme.palette.mode === "light") {
      theme.colorSchemes.light = {
        ...colorSchemesInput.light !== true && colorSchemesInput.light,
        palette: theme.palette
      };
      attachColorScheme(theme, "dark", colorSchemesInput.dark);
    }
    if (theme.palette.mode === "dark") {
      theme.colorSchemes.dark = {
        ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
        palette: theme.palette
      };
      attachColorScheme(theme, "light", colorSchemesInput.light);
    }
    return theme;
  }
  if (!palette && !("light" in colorSchemesInput) && defaultColorSchemeInput === "light") {
    colorSchemesInput.light = true;
  }
  return createThemeWithVars({
    ...other,
    colorSchemes: colorSchemesInput,
    defaultColorScheme: defaultColorSchemeInput,
    ...typeof cssVariables !== "boolean" && cssVariables
  }, ...args);
}
function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function toUnitless(length2) {
  return parseFloat(length2);
}
const defaultTheme$1 = createTheme();
function useTheme() {
  const theme = useTheme$1(defaultTheme$1);
  if (process.env.NODE_ENV !== "production") {
    reactExports.useDebugValue(theme);
  }
  return theme[THEME_ID] || theme;
}
function useThemeProps({
  props,
  name
}) {
  return useThemeProps$1({
    props,
    name,
    defaultTheme: defaultTheme$1,
    themeId: THEME_ID
  });
}
function slotShouldForwardProp(prop) {
  return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const rootShouldForwardProp = (prop) => slotShouldForwardProp(prop) && prop !== "classes";
const styled = createStyled2({
  themeId: THEME_ID,
  defaultTheme: defaultTheme$1,
  rootShouldForwardProp
});
function createChainedFunction(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }
    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {
  });
}
function GlobalStyles(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$1, {
    ...props,
    defaultTheme: defaultTheme$1,
    themeId: THEME_ID
  });
}
process.env.NODE_ENV !== "production" ? GlobalStyles.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool])
} : void 0;
function globalCss(styles2) {
  return function GlobalStylesWrapper(props) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles, {
        styles: typeof styles2 === "function" ? (theme) => styles2({
          theme,
          ...props
        }) : styles2
      })
    );
  };
}
function internal_createExtendSxProp() {
  return extendSxProp$1;
}
const memoTheme = unstable_memoTheme;
process.env.NODE_ENV !== "production" ? {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  value: PropTypes.object.isRequired
} : void 0;
function useDefaultProps(params) {
  return useDefaultProps$1(params);
}
function getSvgIconUtilityClass(slot) {
  return generateUtilityClass("MuiSvgIcon", slot);
}
const svgIconClasses = generateUtilityClasses("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const useUtilityClasses$1h = (ownerState) => {
  const {
    color: color2,
    fontSize,
    classes
  } = ownerState;
  const slots = {
    root: ["root", color2 !== "inherit" && `color${capitalize$2(color2)}`, `fontSize${capitalize$2(fontSize)}`]
  };
  return composeClasses(slots, getSvgIconUtilityClass, classes);
};
const SvgIconRoot = styled("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.color !== "inherit" && styles2[`color${capitalize$2(ownerState.color)}`], styles2[`fontSize${capitalize$2(ownerState.fontSize)}`]];
  }
})(memoTheme(({
  theme
}) => ({
  userSelect: "none",
  width: "1em",
  height: "1em",
  display: "inline-block",
  flexShrink: 0,
  transition: theme.transitions?.create?.("fill", {
    duration: (theme.vars ?? theme).transitions?.duration?.shorter
  }),
  variants: [
    {
      props: (props) => !props.hasSvgAsChild,
      style: {
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: "currentColor"
      }
    },
    {
      props: {
        fontSize: "inherit"
      },
      style: {
        fontSize: "inherit"
      }
    },
    {
      props: {
        fontSize: "small"
      },
      style: {
        fontSize: theme.typography?.pxToRem?.(20) || "1.25rem"
      }
    },
    {
      props: {
        fontSize: "medium"
      },
      style: {
        fontSize: theme.typography?.pxToRem?.(24) || "1.5rem"
      }
    },
    {
      props: {
        fontSize: "large"
      },
      style: {
        fontSize: theme.typography?.pxToRem?.(35) || "2.1875rem"
      }
    },
    // TODO v5 deprecate color prop, v6 remove for sx
    ...Object.entries((theme.vars ?? theme).palette).filter(([, value]) => value && value.main).map(([color2]) => ({
      props: {
        color: color2
      },
      style: {
        color: (theme.vars ?? theme).palette?.[color2]?.main
      }
    })),
    {
      props: {
        color: "action"
      },
      style: {
        color: (theme.vars ?? theme).palette?.action?.active
      }
    },
    {
      props: {
        color: "disabled"
      },
      style: {
        color: (theme.vars ?? theme).palette?.action?.disabled
      }
    },
    {
      props: {
        color: "inherit"
      },
      style: {
        color: void 0
      }
    }
  ]
})));
const SvgIcon = /* @__PURE__ */ reactExports.forwardRef(function SvgIcon2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiSvgIcon"
  });
  const {
    children,
    className,
    color: color2 = "inherit",
    component = "svg",
    fontSize = "medium",
    htmlColor,
    inheritViewBox = false,
    titleAccess,
    viewBox = "0 0 24 24",
    ...other
  } = props;
  const hasSvgAsChild = /* @__PURE__ */ reactExports.isValidElement(children) && children.type === "svg";
  const ownerState = {
    ...props,
    color: color2,
    component,
    fontSize,
    instanceFontSize: inProps.fontSize,
    inheritViewBox,
    viewBox,
    hasSvgAsChild
  };
  const more = {};
  if (!inheritViewBox) {
    more.viewBox = viewBox;
  }
  const classes = useUtilityClasses$1h(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SvgIconRoot, {
    as: component,
    className: clsx(classes.root, className),
    focusable: "false",
    color: htmlColor,
    "aria-hidden": titleAccess ? void 0 : true,
    role: titleAccess ? "img" : void 0,
    ref: ref2,
    ...more,
    ...other,
    ...hasSvgAsChild && children.props,
    ownerState,
    children: [hasSvgAsChild ? children.props.children : children, titleAccess ? /* @__PURE__ */ jsxRuntimeExports.jsx("title", {
      children: titleAccess
    }) : null]
  });
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "large", "medium", "small"]), PropTypes.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Reference/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = "SvgIcon";
function createSvgIcon(path, displayName) {
  function Component(props, ref2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon, {
      "data-testid": process.env.NODE_ENV !== "production" ? `${displayName}Icon` : void 0,
      ref: ref2,
      ...props,
      children: path
    });
  }
  if (process.env.NODE_ENV !== "production") {
    Component.displayName = `${displayName}Icon`;
  }
  Component.muiName = SvgIcon.muiName;
  return /* @__PURE__ */ reactExports.memo(/* @__PURE__ */ reactExports.forwardRef(Component));
}
function debounce$2(func, wait = 166) {
  let timeout2;
  function debounced(...args) {
    const later = () => {
      func.apply(this, args);
    };
    clearTimeout(timeout2);
    timeout2 = setTimeout(later, wait);
  }
  debounced.clear = () => {
    clearTimeout(timeout2);
  };
  return debounced;
}
function ownerDocument(node2) {
  return node2 && node2.ownerDocument || document;
}
function ownerWindow(node2) {
  const doc = ownerDocument(node2);
  return doc.defaultView || window;
}
function setRef$1(ref2, value) {
  if (typeof ref2 === "function") {
    ref2(value);
  } else if (ref2) {
    ref2.current = value;
  }
}
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === "production") {
    return null;
  }
  const propFullNameSafe = propFullName || propName;
  if (typeof props[propName] !== "undefined") {
    return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
  }
  return null;
}
function useControlled(props) {
  const {
    controlled,
    default: defaultProp,
    name,
    state = "value"
  } = props;
  const {
    current: isControlled
  } = reactExports.useRef(controlled !== void 0);
  const [valueState, setValue] = reactExports.useState(defaultProp);
  const value = isControlled ? controlled : valueState;
  if (process.env.NODE_ENV !== "production") {
    reactExports.useEffect(() => {
      if (isControlled !== (controlled !== void 0)) {
        console.error([`MUI: A component is changing the ${isControlled ? "" : "un"}controlled ${state} state of ${name} to be ${isControlled ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${name} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join("\n"));
      }
    }, [state, name, controlled]);
    const {
      current: defaultValue
    } = reactExports.useRef(defaultProp);
    reactExports.useEffect(() => {
      if (!isControlled && JSON.stringify(defaultProp) !== JSON.stringify(defaultValue)) {
        console.error([`MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. To suppress this warning opt to use a controlled ${name}.`].join("\n"));
      }
    }, [JSON.stringify(defaultProp)]);
  }
  const setValueIfUncontrolled = reactExports.useCallback((newValue) => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}
function useEventCallback(fn3) {
  const ref2 = reactExports.useRef(fn3);
  useEnhancedEffect(() => {
    ref2.current = fn3;
  });
  return reactExports.useRef((...args) => (
    // @ts-expect-error hide `this`
    (0, ref2.current)(...args)
  )).current;
}
function useForkRef(...refs) {
  const cleanupRef = reactExports.useRef(void 0);
  const refEffect = reactExports.useCallback((instance) => {
    const cleanups = refs.map((ref2) => {
      if (ref2 == null) {
        return null;
      }
      if (typeof ref2 === "function") {
        const refCallback = ref2;
        const refCleanup = refCallback(instance);
        return typeof refCleanup === "function" ? refCleanup : () => {
          refCallback(null);
        };
      }
      ref2.current = instance;
      return () => {
        ref2.current = null;
      };
    });
    return () => {
      cleanups.forEach((refCleanup) => refCleanup?.());
    };
  }, refs);
  return reactExports.useMemo(() => {
    if (refs.every((ref2) => ref2 == null)) {
      return null;
    }
    return (value) => {
      if (cleanupRef.current) {
        cleanupRef.current();
        cleanupRef.current = void 0;
      }
      if (value != null) {
        cleanupRef.current = refEffect(value);
      }
    };
  }, refs);
}
function isEventHandler(key, value) {
  const thirdCharCode = key.charCodeAt(2);
  return key[0] === "o" && key[1] === "n" && thirdCharCode >= 65 && thirdCharCode <= 90 && typeof value === "function";
}
function mergeSlotProps$2(externalSlotProps, defaultSlotProps) {
  if (!externalSlotProps) {
    return defaultSlotProps;
  }
  function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
    const handlers2 = {};
    Object.keys(defaultSlotPropsValue).forEach((key) => {
      if (isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === "function") {
        handlers2[key] = (...args) => {
          externalSlotPropsValue[key](...args);
          defaultSlotPropsValue[key](...args);
        };
      }
    });
    return handlers2;
  }
  if (typeof externalSlotProps === "function" || typeof defaultSlotProps === "function") {
    return (ownerState) => {
      const defaultSlotPropsValue = typeof defaultSlotProps === "function" ? defaultSlotProps(ownerState) : defaultSlotProps;
      const externalSlotPropsValue = typeof externalSlotProps === "function" ? externalSlotProps({
        ...ownerState,
        ...defaultSlotPropsValue
      }) : externalSlotProps;
      const className2 = clsx(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
      const handlers2 = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
      return {
        ...defaultSlotPropsValue,
        ...externalSlotPropsValue,
        ...handlers2,
        ...!!className2 && {
          className: className2
        },
        ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
          style: {
            ...defaultSlotPropsValue.style,
            ...externalSlotPropsValue.style
          }
        },
        ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
          sx: [...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [defaultSlotPropsValue.sx], ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [externalSlotPropsValue.sx]]
        }
      };
    };
  }
  const typedDefaultSlotProps = defaultSlotProps;
  const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
  const className = clsx(typedDefaultSlotProps?.className, externalSlotProps?.className);
  return {
    ...defaultSlotProps,
    ...externalSlotProps,
    ...handlers,
    ...!!className && {
      className
    },
    ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
      style: {
        ...typedDefaultSlotProps.style,
        ...externalSlotProps.style
      }
    },
    ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
      sx: [...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [typedDefaultSlotProps.sx], ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [externalSlotProps.sx]]
    }
  };
}
var reactIs = { exports: {} };
var reactIs_production = {};
var hasRequiredReactIs_production;
function requireReactIs_production() {
  if (hasRequiredReactIs_production) return reactIs_production;
  hasRequiredReactIs_production = 1;
  var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo"), REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = /* @__PURE__ */ Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
  function typeOf(object) {
    if ("object" === typeof object && null !== object) {
      var $$typeof = object.$$typeof;
      switch ($$typeof) {
        case REACT_ELEMENT_TYPE:
          switch (object = object.type, object) {
            case REACT_FRAGMENT_TYPE:
            case REACT_PROFILER_TYPE:
            case REACT_STRICT_MODE_TYPE:
            case REACT_SUSPENSE_TYPE:
            case REACT_SUSPENSE_LIST_TYPE:
            case REACT_VIEW_TRANSITION_TYPE:
              return object;
            default:
              switch (object = object && object.$$typeof, object) {
                case REACT_CONTEXT_TYPE:
                case REACT_FORWARD_REF_TYPE:
                case REACT_LAZY_TYPE:
                case REACT_MEMO_TYPE:
                  return object;
                case REACT_CONSUMER_TYPE:
                  return object;
                default:
                  return $$typeof;
              }
          }
        case REACT_PORTAL_TYPE:
          return $$typeof;
      }
    }
  }
  reactIs_production.ContextConsumer = REACT_CONSUMER_TYPE;
  reactIs_production.ContextProvider = REACT_CONTEXT_TYPE;
  reactIs_production.Element = REACT_ELEMENT_TYPE;
  reactIs_production.ForwardRef = REACT_FORWARD_REF_TYPE;
  reactIs_production.Fragment = REACT_FRAGMENT_TYPE;
  reactIs_production.Lazy = REACT_LAZY_TYPE;
  reactIs_production.Memo = REACT_MEMO_TYPE;
  reactIs_production.Portal = REACT_PORTAL_TYPE;
  reactIs_production.Profiler = REACT_PROFILER_TYPE;
  reactIs_production.StrictMode = REACT_STRICT_MODE_TYPE;
  reactIs_production.Suspense = REACT_SUSPENSE_TYPE;
  reactIs_production.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
  reactIs_production.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
  };
  reactIs_production.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
  };
  reactIs_production.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
  };
  reactIs_production.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
  };
  reactIs_production.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
  };
  reactIs_production.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
  };
  reactIs_production.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
  };
  reactIs_production.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
  };
  reactIs_production.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
  };
  reactIs_production.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
  };
  reactIs_production.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
  };
  reactIs_production.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
  };
  reactIs_production.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_VIEW_TRANSITION_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
  };
  reactIs_production.typeOf = typeOf;
  return reactIs_production;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function typeOf(object) {
      if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            switch (object = object.type, object) {
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
              case REACT_SUSPENSE_LIST_TYPE:
              case REACT_VIEW_TRANSITION_TYPE:
                return object;
              default:
                switch (object = object && object.$$typeof, object) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                    return object;
                  case REACT_CONSUMER_TYPE:
                    return object;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
    }
    var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo"), REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = /* @__PURE__ */ Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
    reactIs_development.ContextConsumer = REACT_CONSUMER_TYPE;
    reactIs_development.ContextProvider = REACT_CONTEXT_TYPE;
    reactIs_development.Element = REACT_ELEMENT_TYPE;
    reactIs_development.ForwardRef = REACT_FORWARD_REF_TYPE;
    reactIs_development.Fragment = REACT_FRAGMENT_TYPE;
    reactIs_development.Lazy = REACT_LAZY_TYPE;
    reactIs_development.Memo = REACT_MEMO_TYPE;
    reactIs_development.Portal = REACT_PORTAL_TYPE;
    reactIs_development.Profiler = REACT_PROFILER_TYPE;
    reactIs_development.StrictMode = REACT_STRICT_MODE_TYPE;
    reactIs_development.Suspense = REACT_SUSPENSE_TYPE;
    reactIs_development.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    reactIs_development.isContextConsumer = function(object) {
      return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    reactIs_development.isContextProvider = function(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    reactIs_development.isElement = function(object) {
      return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    };
    reactIs_development.isForwardRef = function(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    reactIs_development.isFragment = function(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    reactIs_development.isLazy = function(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    };
    reactIs_development.isMemo = function(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    };
    reactIs_development.isPortal = function(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    };
    reactIs_development.isProfiler = function(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    };
    reactIs_development.isStrictMode = function(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    reactIs_development.isSuspense = function(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    reactIs_development.isSuspenseList = function(object) {
      return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    reactIs_development.isValidElementType = function(type) {
      return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_VIEW_TRANSITION_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
    };
    reactIs_development.typeOf = typeOf;
  })();
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = /* @__PURE__ */ requireReactIs_production();
  } else {
    reactIs.exports = /* @__PURE__ */ requireReactIs_development();
  }
  return reactIs.exports;
}
var reactIsExports = /* @__PURE__ */ requireReactIs();
function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === "production") {
    return () => null;
  }
  return function validate(...args) {
    return propType1(...args) || propType2(...args);
  };
}
function _objectWithoutPropertiesLoose(r12, e) {
  if (null == r12) return {};
  var t16 = {};
  for (var n12 in r12) if ({}.hasOwnProperty.call(r12, n12)) {
    if (-1 !== e.indexOf(n12)) continue;
    t16[n12] = r12[n12];
  }
  return t16;
}
function _setPrototypeOf(t16, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t17, e12) {
    return t17.__proto__ = e12, t17;
  }, _setPrototypeOf(t16, e);
}
function _inheritsLoose(t16, o) {
  t16.prototype = Object.create(o.prototype), t16.prototype.constructor = t16, _setPrototypeOf(t16, o);
}
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
function addClass(element, className) {
  if (element.classList) element.classList.add(className);
  else if (!hasClass(element, className)) if (typeof element.className === "string") element.className = element.className + " " + className;
  else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
}
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === "string") {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute("class", replaceClassName(element.className && element.className.baseVal || "", className));
  }
}
var reactDom = { exports: {} };
var reactDom_production = {};
var hasRequiredReactDom_production;
function requireReactDom_production() {
  if (hasRequiredReactDom_production) return reactDom_production;
  hasRequiredReactDom_production = 1;
  var React2 = requireReact();
  function formatProdErrorMessage(code) {
    var url2 = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
      url2 += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var i = 2; i < arguments.length; i++)
        url2 += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url2 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function noop2() {
  }
  var Internals = {
    d: {
      f: noop2,
      r: function() {
        throw Error(formatProdErrorMessage(522));
      },
      D: noop2,
      C: noop2,
      L: noop2,
      m: noop2,
      X: noop2,
      S: noop2,
      M: noop2
    },
    p: 0,
    findDOMNode: null
  }, REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_RECOVERABLE_TYPE = /* @__PURE__ */ Symbol.for("react.recoverable"), REACT_OPTIMISTIC_KEY = /* @__PURE__ */ Symbol.for("react.optimistic_key");
  function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
      $$typeof: REACT_PORTAL_TYPE,
      key: null == key ? null : key === REACT_OPTIMISTIC_KEY ? REACT_OPTIMISTIC_KEY : "" + key,
      children,
      containerInfo,
      implementation
    };
  }
  var ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input)
      return "use-credentials" === input ? input : "";
  }
  reactDom_production.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
  reactDom_production.browser = function(reason) {
    return { $$typeof: REACT_RECOVERABLE_TYPE, _reason: reason };
  };
  reactDom_production.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType)
      throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
  };
  reactDom_production.flushSync = function(fn3) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
      if (ReactSharedInternals.T = null, Internals.p = 2, fn3) return fn3();
    } finally {
      ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
  };
  reactDom_production.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
  };
  reactDom_production.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
  };
  reactDom_production.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
      var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
      "style" === as ? Internals.d.S(
        href,
        "string" === typeof options.precedence ? options.precedence : void 0,
        {
          crossOrigin,
          integrity,
          fetchPriority
        }
      ) : "script" === as && Internals.d.X(href, {
        crossOrigin,
        integrity,
        fetchPriority,
        nonce: "string" === typeof options.nonce ? options.nonce : void 0
      });
    }
  };
  reactDom_production.preinitModule = function(href, options) {
    if ("string" === typeof href)
      if ("object" === typeof options && null !== options) {
        if (null == options.as || "script" === options.as) {
          var crossOrigin = getCrossOriginStringAs(
            options.as,
            options.crossOrigin
          );
          Internals.d.M(href, {
            crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
          });
        }
      } else null == options && Internals.d.M(href);
  };
  reactDom_production.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
      var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
      Internals.d.L(href, as, {
        crossOrigin,
        integrity: "string" === typeof options.integrity ? options.integrity : void 0,
        nonce: "string" === typeof options.nonce ? options.nonce : void 0,
        type: "string" === typeof options.type ? options.type : void 0,
        fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
        referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
        imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
        imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
        media: "string" === typeof options.media ? options.media : void 0
      });
    }
  };
  reactDom_production.preloadModule = function(href, options) {
    if ("string" === typeof href)
      if (options) {
        var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
        Internals.d.m(href, {
          as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
          crossOrigin,
          integrity: "string" === typeof options.integrity ? options.integrity : void 0,
          nonce: "string" === typeof options.nonce ? options.nonce : void 0,
          fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
        });
      } else Internals.d.m(href);
  };
  reactDom_production.requestFormReset = function(form) {
    Internals.d.r(form);
  };
  reactDom_production.unstable_batchedUpdates = function(fn3, a) {
    return fn3(a);
  };
  reactDom_production.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
  };
  reactDom_production.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
  };
  reactDom_production.version = "19.3.0";
  return reactDom_production;
}
var reactDom_development = {};
var hasRequiredReactDom_development;
function requireReactDom_development() {
  if (hasRequiredReactDom_development) return reactDom_development;
  hasRequiredReactDom_development = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function noop2() {
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function createPortal$1(children, containerInfo, implementation) {
      var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
      if (null == key) key = null;
      else if (key === REACT_OPTIMISTIC_KEY) key = REACT_OPTIMISTIC_KEY;
      else {
        try {
          testStringCoercion(key);
          var JSCompiler_inline_result = false;
        } catch (e) {
          JSCompiler_inline_result = true;
        }
        JSCompiler_inline_result && (console.error(
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          "function" === typeof Symbol && Symbol.toStringTag && key[Symbol.toStringTag] || key.constructor.name || "Object"
        ), testStringCoercion(key));
        key = "" + key;
      }
      return {
        $$typeof: REACT_PORTAL_TYPE,
        key,
        children,
        containerInfo,
        implementation
      };
    }
    function getCrossOriginStringAs(as, input) {
      if ("font" === as) return "";
      if ("string" === typeof input)
        return "use-credentials" === input ? input : "";
    }
    function getValueDescriptorExpectingObjectForWarning(thing) {
      return null === thing ? "`null`" : void 0 === thing ? "`undefined`" : "" === thing ? "an empty string" : 'something with type "' + typeof thing + '"';
    }
    function getValueDescriptorExpectingEnumForWarning(thing) {
      return null === thing ? "`null`" : void 0 === thing ? "`undefined`" : "" === thing ? "an empty string" : "string" === typeof thing ? JSON.stringify(thing) : "number" === typeof thing ? "`" + thing + "`" : 'something with type "' + typeof thing + '"';
    }
    function resolveDispatcher() {
      var dispatcher = ReactSharedInternals.H;
      null === dispatcher && console.error(
        "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem."
      );
      return dispatcher;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React2 = requireReact(), Internals = {
      d: {
        f: noop2,
        r: function() {
          throw Error(
            "Invalid form element. requestFormReset must be passed a form that was rendered by React."
          );
        },
        D: noop2,
        C: noop2,
        L: noop2,
        m: noop2,
        X: noop2,
        S: noop2,
        M: noop2
      },
      p: 0,
      findDOMNode: null
    }, REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_RECOVERABLE_TYPE = /* @__PURE__ */ Symbol.for("react.recoverable"), REACT_OPTIMISTIC_KEY = /* @__PURE__ */ Symbol.for("react.optimistic_key"), ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
    );
    reactDom_development.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
    reactDom_development.browser = function(reason) {
      return { $$typeof: REACT_RECOVERABLE_TYPE, _reason: reason };
    };
    reactDom_development.createPortal = function(children, container) {
      var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
      if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType)
        throw Error("Target container is not a DOM element.");
      return createPortal$1(children, container, null, key);
    };
    reactDom_development.flushSync = function(fn3) {
      var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
      try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn3)
          return fn3();
      } finally {
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f() && console.error(
          "flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."
        );
      }
    };
    reactDom_development.preconnect = function(href, options) {
      "string" === typeof href && href ? null != options && "object" !== typeof options ? console.error(
        "ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.",
        getValueDescriptorExpectingEnumForWarning(options)
      ) : null != options && "string" !== typeof options.crossOrigin && console.error(
        "ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.",
        getValueDescriptorExpectingObjectForWarning(options.crossOrigin)
      ) : console.error(
        "ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        getValueDescriptorExpectingObjectForWarning(href)
      );
      "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
    };
    reactDom_development.prefetchDNS = function(href) {
      if ("string" !== typeof href || !href)
        console.error(
          "ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
          getValueDescriptorExpectingObjectForWarning(href)
        );
      else if (1 < arguments.length) {
        var options = arguments[1];
        "object" === typeof options && options.hasOwnProperty("crossOrigin") ? console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          getValueDescriptorExpectingEnumForWarning(options)
        ) : console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          getValueDescriptorExpectingEnumForWarning(options)
        );
      }
      "string" === typeof href && Internals.d.D(href);
    };
    reactDom_development.preinit = function(href, options) {
      "string" === typeof href && href ? null == options || "object" !== typeof options ? console.error(
        "ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.",
        getValueDescriptorExpectingEnumForWarning(options)
      ) : "style" !== options.as && "script" !== options.as && console.error(
        'ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".',
        getValueDescriptorExpectingEnumForWarning(options.as)
      ) : console.error(
        "ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        getValueDescriptorExpectingObjectForWarning(href)
      );
      if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(
          href,
          "string" === typeof options.precedence ? options.precedence : void 0,
          {
            crossOrigin,
            integrity,
            fetchPriority
          }
        ) : "script" === as && Internals.d.X(href, {
          crossOrigin,
          integrity,
          fetchPriority,
          nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
      }
    };
    reactDom_development.preinitModule = function(href, options) {
      var encountered = "";
      "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
      void 0 !== options && "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && "as" in options && "script" !== options.as && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingEnumForWarning(options.as) + ".");
      if (encountered)
        console.error(
          "ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s",
          encountered
        );
      else
        switch (encountered = options && "string" === typeof options.as ? options.as : "script", encountered) {
          case "script":
            break;
          default:
            encountered = getValueDescriptorExpectingEnumForWarning(encountered), console.error(
              'ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)',
              encountered,
              href
            );
        }
      if ("string" === typeof href)
        if ("object" === typeof options && null !== options) {
          if (null == options.as || "script" === options.as)
            encountered = getCrossOriginStringAs(
              options.as,
              options.crossOrigin
            ), Internals.d.M(href, {
              crossOrigin: encountered,
              integrity: "string" === typeof options.integrity ? options.integrity : void 0,
              nonce: "string" === typeof options.nonce ? options.nonce : void 0,
              fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else null == options && Internals.d.M(href);
    };
    reactDom_development.preload = function(href, options) {
      var encountered = "";
      "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
      null == options || "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : "string" === typeof options.as && options.as || (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
      encountered && console.error(
        'ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s',
        encountered
      );
      if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        encountered = options.as;
        var crossOrigin = getCrossOriginStringAs(
          encountered,
          options.crossOrigin
        );
        Internals.d.L(href, encountered, {
          crossOrigin,
          integrity: "string" === typeof options.integrity ? options.integrity : void 0,
          nonce: "string" === typeof options.nonce ? options.nonce : void 0,
          type: "string" === typeof options.type ? options.type : void 0,
          fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
          referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
          imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
          imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
          media: "string" === typeof options.media ? options.media : void 0
        });
      }
    };
    reactDom_development.preloadModule = function(href, options) {
      var encountered = "";
      "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
      void 0 !== options && "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && "as" in options && "string" !== typeof options.as && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
      encountered && console.error(
        'ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s',
        encountered
      );
      "string" === typeof href && (options ? (encountered = getCrossOriginStringAs(
        options.as,
        options.crossOrigin
      ), Internals.d.m(href, {
        as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
        crossOrigin: encountered,
        integrity: "string" === typeof options.integrity ? options.integrity : void 0,
        nonce: "string" === typeof options.nonce ? options.nonce : void 0,
        fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
      })) : Internals.d.m(href));
    };
    reactDom_development.requestFormReset = function(form) {
      Internals.d.r(form);
    };
    reactDom_development.unstable_batchedUpdates = function(fn3, a) {
      return fn3(a);
    };
    reactDom_development.useFormState = function(action, initialState, permalink) {
      return resolveDispatcher().useFormState(action, initialState, permalink);
    };
    reactDom_development.useFormStatus = function() {
      return resolveDispatcher().useHostTransitionStatus();
    };
    reactDom_development.version = "19.3.0";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })();
  return reactDom_development;
}
var hasRequiredReactDom;
function requireReactDom() {
  if (hasRequiredReactDom) return reactDom.exports;
  hasRequiredReactDom = 1;
  function checkDCE() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
      return;
    }
    if (process.env.NODE_ENV !== "production") {
      throw new Error("^_^");
    }
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      console.error(err);
    }
  }
  if (process.env.NODE_ENV === "production") {
    checkDCE();
    reactDom.exports = requireReactDom_production();
  } else {
    reactDom.exports = requireReactDom_development();
  }
  return reactDom.exports;
}
var reactDomExports = requireReactDom();
const ReactDOM = /* @__PURE__ */ getDefaultExportFromCjs(reactDomExports);
const config = {
  disabled: false
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
const TransitionGroupContext = React.createContext(null);
var forceReflow$1 = function forceReflow(node2) {
  return node2.scrollTop;
};
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
var Transition$1 = /* @__PURE__ */ (function(_React$Component) {
  _inheritsLoose(Transition2, _React$Component);
  function Transition2(props, context2) {
    var _this;
    _this = _React$Component.call(this, props, context2) || this;
    var parentGroup = context2;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  };
  var _proto = Transition2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout2 = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout2;
    if (timeout2 != null && typeof timeout2 !== "number") {
      exit = timeout2.exit;
      enter = timeout2.enter;
      appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
    }
    return {
      exit,
      enter,
      appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
          if (node2) forceReflow$1(node2);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function() {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function() {
        _this2.safeSetState({
          status: ENTERED
        }, function() {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? void 0 : ReactDOM.findDOMNode(this);
    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function() {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function() {
        _this3.safeSetState({
          status: EXITED
        }, function() {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function(event2) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event2);
      }
    };
    this.nextCallback.cancel = function() {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout2, handler) {
    this.setNextCallback(handler);
    var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
    if (!node2 || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node2, this.nextCallback], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout2 != null) {
      setTimeout(this.nextCallback, timeout2);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props, children = _this$props.children;
    _this$props.in;
    _this$props.mountOnEnter;
    _this$props.unmountOnExit;
    _this$props.appear;
    _this$props.enter;
    _this$props.exit;
    _this$props.timeout;
    _this$props.addEndListener;
    _this$props.onEnter;
    _this$props.onEntering;
    _this$props.onEntered;
    _this$props.onExit;
    _this$props.onExiting;
    _this$props.onExited;
    _this$props.nodeRef;
    var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === "function" ? children(status, childProps) : React.cloneElement(React.Children.only(children), childProps))
    );
  };
  return Transition2;
})(React.Component);
Transition$1.contextType = TransitionGroupContext;
Transition$1.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === "undefined" ? PropTypes.any : function(propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt2 = timeoutsShape;
    if (!props.addEndListener) pt2 = pt2.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt2.apply(void 0, [props].concat(args));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop$4() {
}
Transition$1.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$4,
  onEntering: noop$4,
  onEntered: noop$4,
  onExit: noop$4,
  onExiting: noop$4,
  onExited: noop$4
};
Transition$1.UNMOUNTED = UNMOUNTED;
Transition$1.EXITED = EXITED;
Transition$1.ENTERING = ENTERING;
Transition$1.ENTERED = ENTERED;
Transition$1.EXITING = EXITING;
var _addClass = function addClass$1(node2, classes) {
  return node2 && classes && classes.split(" ").forEach(function(c) {
    return addClass(node2, c);
  });
};
var removeClass = function removeClass2(node2, classes) {
  return node2 && classes && classes.split(" ").forEach(function(c) {
    return removeClass$1(node2, c);
  });
};
var CSSTransition = /* @__PURE__ */ (function(_React$Component) {
  _inheritsLoose(CSSTransition2, _React$Component);
  function CSSTransition2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };
    _this.onEnter = function(maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node2 = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
      _this.removeClasses(node2, "exit");
      _this.addClass(node2, appearing ? "appear" : "enter", "base");
      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };
    _this.onEntering = function(maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node2 = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
      var type = appearing ? "appear" : "enter";
      _this.addClass(node2, type, "active");
      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };
    _this.onEntered = function(maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node2 = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
      var type = appearing ? "appear" : "enter";
      _this.removeClasses(node2, type);
      _this.addClass(node2, type, "done");
      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };
    _this.onExit = function(maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node2 = _this$resolveArgument4[0];
      _this.removeClasses(node2, "appear");
      _this.removeClasses(node2, "enter");
      _this.addClass(node2, "exit", "base");
      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };
    _this.onExiting = function(maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node2 = _this$resolveArgument5[0];
      _this.addClass(node2, "exit", "active");
      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };
    _this.onExited = function(maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node2 = _this$resolveArgument6[0];
      _this.removeClasses(node2, "exit");
      _this.addClass(node2, "exit", "done");
      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };
    _this.resolveArguments = function(maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] : [maybeNode, maybeAppearing];
    };
    _this.getClassNames = function(type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === "string";
      var prefix2 = isStringClassNames && classNames ? classNames + "-" : "";
      var baseClassName = isStringClassNames ? "" + prefix2 + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName,
        activeClassName,
        doneClassName
      };
    };
    return _this;
  }
  var _proto = CSSTransition2.prototype;
  _proto.addClass = function addClass2(node2, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];
    var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
    if (type === "appear" && phase === "done" && doneClassName) {
      className += " " + doneClassName;
    }
    if (phase === "active") {
      if (node2) forceReflow$1(node2);
    }
    if (className) {
      this.appliedClasses[type][phase] = className;
      _addClass(node2, className);
    }
  };
  _proto.removeClasses = function removeClasses(node2, type) {
    var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};
    if (baseClassName) {
      removeClass(node2, baseClassName);
    }
    if (activeClassName) {
      removeClass(node2, activeClassName);
    }
    if (doneClassName) {
      removeClass(node2, doneClassName);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props;
    _this$props.classNames;
    var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
    return /* @__PURE__ */ React.createElement(Transition$1, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };
  return CSSTransition2;
})(React.Component);
CSSTransition.defaultProps = {
  classNames: ""
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, Transition$1.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function getChildMapping(children, mapFn) {
  var mapper = function mapper2(child) {
    return mapFn && reactExports.isValidElement(child) ? mapFn(child) : child;
  };
  var result = /* @__PURE__ */ Object.create(null);
  if (children) reactExports.Children.map(children, function(c) {
    return c;
  }).forEach(function(child) {
    result[child.key] = mapper(child);
  });
  return result;
}
function mergeChildMappings(prev2, next2) {
  prev2 = prev2 || {};
  next2 = next2 || {};
  function getValueForKey(key) {
    return key in next2 ? next2[key] : prev2[key];
  }
  var nextKeysPending = /* @__PURE__ */ Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev2) {
    if (prevKey in next2) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next2) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function(child) {
    return reactExports.cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, "appear", props),
      enter: getProp(child, "enter", props),
      exit: getProp(child, "exit", props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function(key) {
    var child = children[key];
    if (!reactExports.isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = reactExports.isValidElement(prevChild) && !prevChild.props.in;
    if (hasNext && (!hasPrev || isLeaving)) {
      children[key] = reactExports.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      children[key] = reactExports.cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && reactExports.isValidElement(prevChild)) {
      children[key] = reactExports.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    }
  });
  return children;
}
var values = Object.values || function(obj) {
  return Object.keys(obj).map(function(k) {
    return obj[k];
  });
};
var defaultProps = {
  component: "div",
  childFactory: function childFactory(child) {
    return child;
  }
};
var TransitionGroup = /* @__PURE__ */ (function(_React$Component) {
  _inheritsLoose(TransitionGroup2, _React$Component);
  function TransitionGroup2(props, context2) {
    var _this;
    _this = _React$Component.call(this, props, context2) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this));
    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup2.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };
  _proto.handleExited = function handleExited(child, node2) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node2);
    }
    if (this.mounted) {
      this.setState(function(state) {
        var children = _extends({}, state.children);
        delete children[child.key];
        return {
          children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props, Component = _this$props.component, childFactory2 = _this$props.childFactory, props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory2);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component === null) {
      return /* @__PURE__ */ React.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }
    return /* @__PURE__ */ React.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /* @__PURE__ */ React.createElement(Component, props, children));
  };
  return TransitionGroup2;
})(React.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
const UNINITIALIZED = {};
function useLazyRef(init2, initArg) {
  const ref2 = reactExports.useRef(UNINITIALIZED);
  if (ref2.current === UNINITIALIZED) {
    ref2.current = init2(initArg);
  }
  return ref2;
}
const EMPTY = [];
function useOnMount(fn3) {
  reactExports.useEffect(fn3, EMPTY);
}
class Timeout {
  static create() {
    return new Timeout();
  }
  currentId = null;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(delay, fn3) {
    this.clear();
    this.currentId = setTimeout(() => {
      this.currentId = null;
      fn3();
    }, delay);
  }
  clear = () => {
    if (this.currentId !== null) {
      clearTimeout(this.currentId);
      this.currentId = null;
    }
  };
  disposeEffect = () => {
    return this.clear;
  };
}
function useTimeout() {
  const timeout2 = useLazyRef(Timeout.create).current;
  useOnMount(timeout2.disposeEffect);
  return timeout2;
}
function isClassComponent$3(elementType) {
  const {
    prototype = {}
  } = elementType;
  return Boolean(prototype.isReactComponent);
}
function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  const propValue = props[propName];
  const safePropName = propFullName || propName;
  if (propValue == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window === "undefined") {
    return null;
  }
  let warningHint;
  if (typeof propValue === "function" && !isClassComponent$3(propValue)) {
    warningHint = "Did you accidentally provide a plain function component instead?";
  }
  if (propValue === reactExports.Fragment) {
    warningHint = "Did you accidentally provide a React.Fragment instead?";
  }
  if (warningHint !== void 0) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. Expected an element type that can hold a ref. ${warningHint} For more information see https://v7.mui.com/r/caveat-with-refs-guide`);
  }
  return null;
}
const elementTypeAcceptingRef$1 = chainPropTypes(PropTypes.elementType, elementTypeAcceptingRef);
const reflow = (node2) => node2.scrollTop;
function normalizedTransitionCallback(nodeRef, callback) {
  return (maybeIsAppearing) => {
    if (callback) {
      const node2 = nodeRef.current;
      if (maybeIsAppearing === void 0) {
        callback(node2);
      } else {
        callback(node2, maybeIsAppearing);
      }
    }
  };
}
function getTransitionChildStyle(state, inProp, baseStyles, hiddenStyles2, styleProp, childStyle) {
  const base = state === "exited" && !inProp ? hiddenStyles2 : baseStyles[state] || baseStyles.exited;
  return styleProp || childStyle ? {
    ...base,
    ...styleProp,
    ...childStyle
  } : base;
}
function getTransitionProps(props, options) {
  const {
    timeout: timeout2,
    easing: easing2,
    style: style2 = {}
  } = props;
  return {
    duration: style2.transitionDuration ?? (typeof timeout2 === "number" ? timeout2 : timeout2[options.mode] || 0),
    easing: style2.transitionTimingFunction ?? (typeof easing2 === "object" ? easing2[options.mode] : easing2),
    delay: style2.transitionDelay
  };
}
function isHostComponent(element) {
  return typeof element === "string";
}
function appendOwnerState(elementType, otherProps, ownerState) {
  if (elementType === void 0 || isHostComponent(elementType)) {
    return otherProps;
  }
  return {
    ...otherProps,
    ownerState: {
      ...otherProps.ownerState,
      ...ownerState
    }
  };
}
function resolveComponentProps(componentProps, ownerState, slotState) {
  if (typeof componentProps === "function") {
    return componentProps(ownerState, slotState);
  }
  return componentProps;
}
function extractEventHandlers(object, excludeKeys = []) {
  if (object === void 0) {
    return {};
  }
  const result = {};
  Object.keys(object).filter((prop) => prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop) => {
    result[prop] = object[prop];
  });
  return result;
}
function omitEventHandlers(object) {
  if (object === void 0) {
    return {};
  }
  const result = {};
  Object.keys(object).filter((prop) => !(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop) => {
    result[prop] = object[prop];
  });
  return result;
}
function mergeSlotProps$1(parameters) {
  const {
    getSlotProps,
    additionalProps,
    externalSlotProps,
    externalForwardedProps,
    className
  } = parameters;
  if (!getSlotProps) {
    const joinedClasses2 = clsx(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle2 = {
      ...additionalProps?.style,
      ...externalForwardedProps?.style,
      ...externalSlotProps?.style
    };
    const props2 = {
      ...additionalProps,
      ...externalForwardedProps,
      ...externalSlotProps
    };
    if (joinedClasses2.length > 0) {
      props2.className = joinedClasses2;
    }
    if (Object.keys(mergedStyle2).length > 0) {
      props2.style = mergedStyle2;
    }
    return {
      props: props2,
      internalRef: void 0
    };
  }
  const eventHandlers = extractEventHandlers({
    ...externalForwardedProps,
    ...externalSlotProps
  });
  const componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
  const otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
  const internalSlotProps = getSlotProps(eventHandlers);
  const joinedClasses = clsx(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
  const mergedStyle = {
    ...internalSlotProps?.style,
    ...additionalProps?.style,
    ...externalForwardedProps?.style,
    ...externalSlotProps?.style
  };
  const props = {
    ...internalSlotProps,
    ...additionalProps,
    ...otherPropsWithoutEventHandlers,
    ...componentsPropsWithoutEventHandlers
  };
  if (joinedClasses.length > 0) {
    props.className = joinedClasses;
  }
  if (Object.keys(mergedStyle).length > 0) {
    props.style = mergedStyle;
  }
  return {
    props,
    internalRef: internalSlotProps.ref
  };
}
function useSlot(name, parameters) {
  const {
    className,
    elementType: initialElementType,
    ownerState,
    externalForwardedProps,
    internalForwardedProps,
    shouldForwardComponentProp = false,
    ...useSlotPropsParams
  } = parameters;
  const {
    component: rootComponent,
    slots = {
      [name]: void 0
    },
    slotProps = {
      [name]: void 0
    },
    ...other
  } = externalForwardedProps;
  const elementType = slots[name] || initialElementType;
  const resolvedComponentsProps = resolveComponentProps(slotProps[name], ownerState);
  const {
    props: {
      component: slotComponent,
      ...mergedProps
    },
    internalRef
  } = mergeSlotProps$1({
    className,
    ...useSlotPropsParams,
    externalForwardedProps: name === "root" ? other : void 0,
    externalSlotProps: resolvedComponentsProps
  });
  const ref2 = useForkRef(internalRef, resolvedComponentsProps?.ref, parameters.ref);
  const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
  const props = appendOwnerState(elementType, {
    ...name === "root" && !rootComponent && !slots[name] && internalForwardedProps,
    ...name !== "root" && !slots[name] && internalForwardedProps,
    ...mergedProps,
    ...LeafComponent && !shouldForwardComponentProp && {
      as: LeafComponent
    },
    ...LeafComponent && shouldForwardComponentProp && {
      component: LeafComponent
    },
    ref: ref2
  }, ownerState);
  return [elementType, props];
}
function getCollapseUtilityClass(slot) {
  return generateUtilityClass("MuiCollapse", slot);
}
generateUtilityClasses("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const useUtilityClasses$1g = (ownerState) => {
  const {
    orientation,
    classes
  } = ownerState;
  const slots = {
    root: ["root", orientation],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", orientation],
    wrapperInner: ["wrapperInner", orientation]
  };
  return composeClasses(slots, getCollapseUtilityClass, classes);
};
const CollapseRoot = styled("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, styles2[ownerState.orientation], ownerState.state === "entered" && styles2.entered, ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles2.hidden];
  }
})(memoTheme(({
  theme
}) => ({
  height: 0,
  overflow: "hidden",
  transition: theme.transitions.create("height"),
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "auto",
      width: 0,
      transition: theme.transitions.create("width")
    }
  }, {
    props: {
      state: "entered"
    },
    style: {
      height: "auto",
      overflow: "visible"
    }
  }, {
    props: {
      state: "entered",
      orientation: "horizontal"
    },
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px",
    style: {
      visibility: "hidden"
    }
  }]
})));
const CollapseWrapper = styled("div", {
  name: "MuiCollapse",
  slot: "Wrapper"
})({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
});
const CollapseWrapperInner = styled("div", {
  name: "MuiCollapse",
  slot: "WrapperInner"
})({
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
});
const Collapse = /* @__PURE__ */ reactExports.forwardRef(function Collapse2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiCollapse"
  });
  const {
    addEndListener,
    children,
    className,
    collapsedSize: collapsedSizeProp = "0px",
    component,
    easing: easing2,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    orientation = "vertical",
    slots = {},
    slotProps = {},
    style: style2,
    timeout: timeout2 = duration.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Transition$1,
    ...other
  } = props;
  const ownerState = {
    ...props,
    orientation,
    collapsedSize: collapsedSizeProp
  };
  const classes = useUtilityClasses$1g(ownerState);
  const theme = useTheme();
  const timer = useTimeout();
  const wrapperRef = reactExports.useRef(null);
  const autoTransitionDuration = reactExports.useRef();
  const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
  const isHorizontal2 = orientation === "horizontal";
  const size = isHorizontal2 ? "width" : "height";
  const nodeRef = reactExports.useRef(null);
  const handleRef = useForkRef(ref2, nodeRef);
  const getWrapperSize = () => wrapperRef.current ? wrapperRef.current[isHorizontal2 ? "clientWidth" : "clientHeight"] : 0;
  const handleEnter = normalizedTransitionCallback(nodeRef, (node2, isAppearing) => {
    if (wrapperRef.current && isHorizontal2) {
      wrapperRef.current.style.position = "absolute";
    }
    node2.style[size] = collapsedSize;
    if (onEnter) {
      onEnter(node2, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback(nodeRef, (node2, isAppearing) => {
    const wrapperSize = getWrapperSize();
    if (wrapperRef.current && isHorizontal2) {
      wrapperRef.current.style.position = "";
    }
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style: style2,
      timeout: timeout2,
      easing: easing2
    }, {
      mode: "enter"
    });
    if (timeout2 === "auto") {
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node2.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node2.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
    }
    node2.style[size] = `${wrapperSize}px`;
    node2.style.transitionTimingFunction = transitionTimingFunction;
    if (onEntering) {
      onEntering(node2, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(nodeRef, (node2, isAppearing) => {
    node2.style[size] = "auto";
    if (onEntered) {
      onEntered(node2, isAppearing);
    }
  });
  const handleExit = normalizedTransitionCallback(nodeRef, (node2) => {
    node2.style[size] = `${getWrapperSize()}px`;
    if (onExit) {
      onExit(node2);
    }
  });
  const handleExited = normalizedTransitionCallback(nodeRef, onExited);
  const handleExiting = normalizedTransitionCallback(nodeRef, (node2) => {
    const wrapperSize = getWrapperSize();
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style: style2,
      timeout: timeout2,
      easing: easing2
    }, {
      mode: "exit"
    });
    if (timeout2 === "auto") {
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node2.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node2.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
    }
    node2.style[size] = collapsedSize;
    node2.style.transitionTimingFunction = transitionTimingFunction;
    if (onExiting) {
      onExiting(node2);
    }
  });
  const handleAddEndListener = (next2) => {
    if (timeout2 === "auto") {
      timer.start(autoTransitionDuration.current || 0, next2);
    }
    if (addEndListener) {
      addEndListener(nodeRef.current, next2);
    }
  };
  const externalForwardedProps = {
    slots,
    slotProps,
    component
  };
  const [RootSlot, rootSlotProps] = useSlot("root", {
    ref: handleRef,
    className: clsx(classes.root, className),
    elementType: CollapseRoot,
    externalForwardedProps,
    ownerState,
    additionalProps: {
      style: {
        [isHorizontal2 ? "minWidth" : "minHeight"]: collapsedSize,
        ...style2
      }
    }
  });
  const [WrapperSlot, wrapperSlotProps] = useSlot("wrapper", {
    ref: wrapperRef,
    className: classes.wrapper,
    elementType: CollapseWrapper,
    externalForwardedProps,
    ownerState
  });
  const [WrapperInnerSlot, wrapperInnerSlotProps] = useSlot("wrapperInner", {
    className: classes.wrapperInner,
    elementType: CollapseWrapperInner,
    externalForwardedProps,
    ownerState
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionComponent, {
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef,
    timeout: timeout2 === "auto" ? null : timeout2,
    ...other,
    children: (state, {
      ownerState: incomingOwnerState,
      ...restChildProps
    }) => {
      const stateOwnerState = {
        ...ownerState,
        state
      };
      return /* @__PURE__ */ jsxRuntimeExports.jsx(RootSlot, {
        ...rootSlotProps,
        className: clsx(rootSlotProps.className, {
          "entered": classes.entered,
          "exited": !inProp && collapsedSize === "0px" && classes.hidden
        }[state]),
        ownerState: stateOwnerState,
        ...restChildProps,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(WrapperSlot, {
          ...wrapperSlotProps,
          ownerState: stateOwnerState,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(WrapperInnerSlot, {
            ...wrapperInnerSlotProps,
            ownerState: stateOwnerState,
            children
          })
        })
      });
    }
  });
});
process.env.NODE_ENV !== "production" ? Collapse.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * The content node to be collapsed.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    wrapper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    wrapperInner: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType,
    wrapper: PropTypes.elementType,
    wrapperInner: PropTypes.elementType
  }),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
if (Collapse) {
  Collapse.muiSupportAuto = true;
}
function getTypeByValue(value) {
  const valueType = typeof value;
  switch (valueType) {
    case "number":
      if (Number.isNaN(value)) {
        return "NaN";
      }
      if (!Number.isFinite(value)) {
        return "Infinity";
      }
      if (value !== Math.floor(value)) {
        return "float";
      }
      return "number";
    case "object":
      if (value === null) {
        return "null";
      }
      return value.constructor.name;
    default:
      return valueType;
  }
}
function requiredInteger(props, propName, componentName, location) {
  const propValue = props[propName];
  if (propValue == null || !Number.isInteger(propValue)) {
    const propType = getTypeByValue(propValue);
    return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
  }
  return null;
}
function validator(props, propName, componentName, location) {
  const propValue = props[propName];
  if (propValue === void 0) {
    return null;
  }
  return requiredInteger(props, propName, componentName, location);
}
function validatorNoop() {
  return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
const integerPropType = process.env.NODE_ENV === "production" ? validatorNoop : validator;
function getPaperUtilityClass(slot) {
  return generateUtilityClass("MuiPaper", slot);
}
generateUtilityClasses("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const useUtilityClasses$1f = (ownerState) => {
  const {
    square,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ["root", variant, !square && "rounded", variant === "elevation" && `elevation${elevation}`]
  };
  return composeClasses(slots, getPaperUtilityClass, classes);
};
const PaperRoot = styled("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, styles2[ownerState.variant], !ownerState.square && styles2.rounded, ownerState.variant === "elevation" && styles2[`elevation${ownerState.elevation}`]];
  }
})(memoTheme(({
  theme
}) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
  color: (theme.vars || theme).palette.text.primary,
  transition: theme.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState
    }) => !ownerState.square,
    style: {
      borderRadius: theme.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(theme.vars || theme).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
})));
const Paper = /* @__PURE__ */ reactExports.forwardRef(function Paper2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiPaper"
  });
  const theme = useTheme();
  const {
    className,
    component = "div",
    elevation = 1,
    square = false,
    variant = "elevation",
    ...other
  } = props;
  const ownerState = {
    ...props,
    component,
    elevation,
    square,
    variant
  };
  const classes = useUtilityClasses$1f(ownerState);
  if (process.env.NODE_ENV !== "production") {
    if (theme.shadows[elevation] === void 0) {
      console.error([`MUI: The elevation provided <Paper elevation={${elevation}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${elevation}]\` is defined.`].join("\n"));
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PaperRoot, {
    as: component,
    ownerState,
    className: clsx(classes.root, className),
    ref: ref2,
    ...other,
    style: {
      ...variant === "elevation" && {
        "--Paper-shadow": (theme.vars || theme).shadows[elevation],
        ...theme.vars && {
          "--Paper-overlay": theme.vars.overlays?.[elevation]
        },
        ...!theme.vars && theme.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${alpha("#fff", getOverlayAlpha(elevation))}, ${alpha("#fff", getOverlayAlpha(elevation))})`
        }
      },
      ...other.style
    }
  });
});
process.env.NODE_ENV !== "production" ? Paper.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: chainPropTypes(integerPropType, (props) => {
    const {
      elevation,
      variant
    } = props;
    if (elevation > 0 && variant === "outlined") {
      return new Error(`MUI: Combining \`elevation={${elevation}}\` with \`variant="${variant}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`);
    }
    return null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["elevation", "outlined"]), PropTypes.string])
} : void 0;
const AccordionContext = /* @__PURE__ */ reactExports.createContext({});
if (process.env.NODE_ENV !== "production") {
  AccordionContext.displayName = "AccordionContext";
}
function getAccordionUtilityClass(slot) {
  return generateUtilityClass("MuiAccordion", slot);
}
const accordionClasses = generateUtilityClasses("MuiAccordion", ["root", "heading", "rounded", "expanded", "disabled", "gutters", "region"]);
const useUtilityClasses$1e = (ownerState) => {
  const {
    classes,
    square,
    expanded,
    disabled,
    disableGutters
  } = ownerState;
  const slots = {
    root: ["root", !square && "rounded", expanded && "expanded", disabled && "disabled", !disableGutters && "gutters"],
    heading: ["heading"],
    region: ["region"]
  };
  return composeClasses(slots, getAccordionUtilityClass, classes);
};
const AccordionRoot = styled(Paper, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${accordionClasses.region}`]: styles2.region
    }, styles2.root, !ownerState.square && styles2.rounded, !ownerState.disableGutters && styles2.gutters];
  }
})(memoTheme(({
  theme
}) => {
  const transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: theme.transitions.create(["margin"], transition),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (theme.vars || theme).palette.divider,
      transition: theme.transitions.create(["opacity", "background-color"], transition)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${accordionClasses.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${accordionClasses.disabled}`]: {
      backgroundColor: (theme.vars || theme).palette.action.disabledBackground
    }
  };
}), memoTheme(({
  theme
}) => ({
  variants: [{
    props: (props) => !props.square,
    style: {
      borderRadius: 0,
      "&:first-of-type": {
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
      },
      "&:last-of-type": {
        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: (props) => !props.disableGutters,
    style: {
      [`&.${accordionClasses.expanded}`]: {
        margin: "16px 0"
      }
    }
  }]
})));
const AccordionHeading = styled("h3", {
  name: "MuiAccordion",
  slot: "Heading"
})({
  all: "unset"
});
const AccordionRegion = styled("div", {
  name: "MuiAccordion",
  slot: "Region"
})({});
const Accordion = /* @__PURE__ */ reactExports.forwardRef(function Accordion2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiAccordion"
  });
  const {
    children: childrenProp,
    className,
    defaultExpanded = false,
    disabled = false,
    disableGutters = false,
    expanded: expandedProp,
    onChange,
    slots = {},
    slotProps = {},
    TransitionComponent: TransitionComponentProp,
    TransitionProps: TransitionPropsProp,
    ...other
  } = props;
  const [expanded, setExpandedState] = useControlled({
    controlled: expandedProp,
    default: defaultExpanded,
    name: "Accordion",
    state: "expanded"
  });
  const handleChange = reactExports.useCallback((event2) => {
    setExpandedState(!expanded);
    if (onChange) {
      onChange(event2, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);
  const [summary, ...children] = reactExports.Children.toArray(childrenProp);
  const contextValue = reactExports.useMemo(() => ({
    expanded,
    disabled,
    disableGutters,
    toggle: handleChange
  }), [expanded, disabled, disableGutters, handleChange]);
  const ownerState = {
    ...props,
    disabled,
    disableGutters,
    expanded
  };
  const classes = useUtilityClasses$1e(ownerState);
  const backwardCompatibleSlots = {
    transition: TransitionComponentProp,
    ...slots
  };
  const backwardCompatibleSlotProps = {
    transition: TransitionPropsProp,
    ...slotProps
  };
  const externalForwardedProps = {
    slots: backwardCompatibleSlots,
    slotProps: backwardCompatibleSlotProps
  };
  const [RootSlot, rootProps] = useSlot("root", {
    elementType: AccordionRoot,
    externalForwardedProps: {
      ...externalForwardedProps,
      ...other
    },
    className: clsx(classes.root, className),
    shouldForwardComponentProp: true,
    ownerState,
    ref: ref2
  });
  const [AccordionHeadingSlot, accordionProps] = useSlot("heading", {
    elementType: AccordionHeading,
    externalForwardedProps,
    className: classes.heading,
    ownerState
  });
  const [TransitionSlot, transitionProps] = useSlot("transition", {
    elementType: Collapse,
    externalForwardedProps,
    ownerState
  });
  const [AccordionRegionSlot, accordionRegionProps] = useSlot("region", {
    elementType: AccordionRegion,
    externalForwardedProps,
    ownerState,
    className: classes.region,
    additionalProps: {
      "aria-labelledby": summary.props.id,
      id: summary.props["aria-controls"],
      role: "region"
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(RootSlot, {
    ...rootProps,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(AccordionHeadingSlot, {
      ...accordionProps,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionContext.Provider, {
        value: contextValue,
        children: summary
      })
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionSlot, {
      in: expanded,
      timeout: "auto",
      ...transitionProps,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionRegionSlot, {
        ...accordionRegionProps,
        children
      })
    })]
  });
});
process.env.NODE_ENV !== "production" ? Accordion.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: chainPropTypes(PropTypes.node.isRequired, (props) => {
    const summary = reactExports.Children.toArray(props.children)[0];
    if (reactIsExports.isFragment(summary)) {
      return new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.");
    }
    if (!/* @__PURE__ */ reactExports.isValidElement(summary)) {
      return new Error("MUI: Expected the first child of Accordion to be a valid element.");
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and prevents the increased height when expanded.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, expands the accordion, otherwise collapses it.
   * Setting this prop enables control over the accordion.
   */
  expanded: PropTypes.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: PropTypes.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    heading: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    region: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    heading: PropTypes.elementType,
    region: PropTypes.elementType,
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: PropTypes.object
} : void 0;
function getAccordionDetailsUtilityClass(slot) {
  return generateUtilityClass("MuiAccordionDetails", slot);
}
generateUtilityClasses("MuiAccordionDetails", ["root"]);
const useUtilityClasses$1d = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getAccordionDetailsUtilityClass, classes);
};
const AccordionDetailsRoot = styled("div", {
  name: "MuiAccordionDetails",
  slot: "Root"
})(memoTheme(({
  theme
}) => ({
  padding: theme.spacing(1, 2, 2)
})));
const AccordionDetails = /* @__PURE__ */ reactExports.forwardRef(function AccordionDetails2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiAccordionDetails"
  });
  const {
    className,
    ...other
  } = props;
  const ownerState = props;
  const classes = useUtilityClasses$1d(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionDetailsRoot, {
    className: clsx(classes.root, className),
    ref: ref2,
    ownerState,
    ...other
  });
});
process.env.NODE_ENV !== "production" ? AccordionDetails.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
function isFocusVisible(element) {
  try {
    return element.matches(":focus-visible");
  } catch (error) {
    if (process.env.NODE_ENV !== "production" && !window.navigator.userAgent.includes("jsdom")) {
      console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join("\n"));
    }
  }
  return false;
}
class LazyRipple {
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new LazyRipple();
  }
  static use() {
    const ripple = useLazyRef(LazyRipple.create).current;
    const [shouldMount, setShouldMount] = reactExports.useState(false);
    ripple.shouldMount = shouldMount;
    ripple.setShouldMount = setShouldMount;
    reactExports.useEffect(ripple.mountEffect, [shouldMount]);
    return ripple;
  }
  constructor() {
    this.ref = {
      current: null
    };
    this.mounted = null;
    this.didMount = false;
    this.shouldMount = false;
    this.setShouldMount = null;
  }
  mount() {
    if (!this.mounted) {
      this.mounted = createControlledPromise();
      this.shouldMount = true;
      this.setShouldMount(this.shouldMount);
    }
    return this.mounted;
  }
  mountEffect = () => {
    if (this.shouldMount && !this.didMount) {
      if (this.ref.current !== null) {
        this.didMount = true;
        this.mounted.resolve();
      }
    }
  };
  /* Ripple API */
  start(...args) {
    this.mount().then(() => this.ref.current?.start(...args));
  }
  stop(...args) {
    this.mount().then(() => this.ref.current?.stop(...args));
  }
  pulsate(...args) {
    this.mount().then(() => this.ref.current?.pulsate(...args));
  }
}
function useLazyRipple() {
  return LazyRipple.use();
}
function createControlledPromise() {
  let resolve2;
  let reject;
  const p = new Promise((resolveFn, rejectFn) => {
    resolve2 = resolveFn;
    reject = rejectFn;
  });
  p.resolve = resolve2;
  p.reject = reject;
  return p;
}
function Ripple(props) {
  const {
    className,
    classes,
    pulsate = false,
    rippleX,
    rippleY,
    rippleSize,
    in: inProp,
    onExited,
    timeout: timeout2
  } = props;
  const [leaving, setLeaving] = reactExports.useState(false);
  const rippleClassName = clsx(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  const rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  const childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  if (!inProp && !leaving) {
    setLeaving(true);
  }
  reactExports.useEffect(() => {
    if (!inProp && onExited != null) {
      const timeoutId = setTimeout(onExited, timeout2);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    return void 0;
  }, [onExited, inProp, timeout2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    className: rippleClassName,
    style: rippleStyles,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: childClassName
    })
  });
}
process.env.NODE_ENV !== "production" ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,
  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
} : void 0;
const touchRippleClasses = generateUtilityClasses("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]);
const DURATION = 550;
const DELAY_RIPPLE = 80;
const enterKeyframe = keyframes`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const exitKeyframe = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const pulsateKeyframe = keyframes`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const TouchRippleRoot = styled("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
});
const TouchRippleRipple = styled(Ripple, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${touchRippleClasses.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${enterKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({
  theme
}) => theme.transitions.easing.easeInOut};
  }

  &.${touchRippleClasses.ripplePulsate} {
    animation-duration: ${({
  theme
}) => theme.transitions.duration.shorter}ms;
  }

  & .${touchRippleClasses.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${touchRippleClasses.childLeaving} {
    opacity: 0;
    animation-name: ${exitKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({
  theme
}) => theme.transitions.easing.easeInOut};
  }

  & .${touchRippleClasses.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme
}) => theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
const TouchRipple = /* @__PURE__ */ reactExports.forwardRef(function TouchRipple2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiTouchRipple"
  });
  const {
    center: centerProp = false,
    classes = {},
    className,
    ...other
  } = props;
  const [ripples, setRipples] = reactExports.useState([]);
  const nextKey = reactExports.useRef(0);
  const rippleCallback = reactExports.useRef(null);
  reactExports.useEffect(() => {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]);
  const ignoringMouseDown = reactExports.useRef(false);
  const startTimer = useTimeout();
  const startTimerCommit = reactExports.useRef(null);
  const container = reactExports.useRef(null);
  const startCommit = reactExports.useCallback((params) => {
    const {
      pulsate: pulsate2,
      rippleX,
      rippleY,
      rippleSize,
      cb: cb2
    } = params;
    setRipples((oldRipples) => [...oldRipples, /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRipple, {
      classes: {
        ripple: clsx(classes.ripple, touchRippleClasses.ripple),
        rippleVisible: clsx(classes.rippleVisible, touchRippleClasses.rippleVisible),
        ripplePulsate: clsx(classes.ripplePulsate, touchRippleClasses.ripplePulsate),
        child: clsx(classes.child, touchRippleClasses.child),
        childLeaving: clsx(classes.childLeaving, touchRippleClasses.childLeaving),
        childPulsate: clsx(classes.childPulsate, touchRippleClasses.childPulsate)
      },
      timeout: DURATION,
      pulsate: pulsate2,
      rippleX,
      rippleY,
      rippleSize
    }, nextKey.current)]);
    nextKey.current += 1;
    rippleCallback.current = cb2;
  }, [classes]);
  const start2 = reactExports.useCallback((event2 = {}, options = {}, cb2 = () => {
  }) => {
    const {
      pulsate: pulsate2 = false,
      center = centerProp || options.pulsate,
      fakeElement = false
      // For test purposes
    } = options;
    if (event2?.type === "mousedown" && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }
    if (event2?.type === "touchstart") {
      ignoringMouseDown.current = true;
    }
    const element = fakeElement ? null : container.current;
    const rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let rippleX;
    let rippleY;
    let rippleSize;
    if (center || event2 === void 0 || event2.clientX === 0 && event2.clientY === 0 || !event2.clientX && !event2.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      const {
        clientX,
        clientY
      } = event2.touches && event2.touches.length > 0 ? event2.touches[0] : event2;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }
    if (center) {
      rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
    }
    if (event2?.touches) {
      if (startTimerCommit.current === null) {
        startTimerCommit.current = () => {
          startCommit({
            pulsate: pulsate2,
            rippleX,
            rippleY,
            rippleSize,
            cb: cb2
          });
        };
        startTimer.start(DELAY_RIPPLE, () => {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        });
      }
    } else {
      startCommit({
        pulsate: pulsate2,
        rippleX,
        rippleY,
        rippleSize,
        cb: cb2
      });
    }
  }, [centerProp, startCommit, startTimer]);
  const pulsate = reactExports.useCallback(() => {
    start2({}, {
      pulsate: true
    });
  }, [start2]);
  const stop = reactExports.useCallback((event2, cb2) => {
    startTimer.clear();
    if (event2?.type === "touchend" && startTimerCommit.current) {
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.start(0, () => {
        stop(event2, cb2);
      });
      return;
    }
    startTimerCommit.current = null;
    setRipples((oldRipples) => {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }
      return oldRipples;
    });
    rippleCallback.current = cb2;
  }, [startTimer]);
  reactExports.useImperativeHandle(ref2, () => ({
    pulsate,
    start: start2,
    stop
  }), [pulsate, start2, stop]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRoot, {
    className: clsx(touchRippleClasses.root, classes.root, className),
    ref: container,
    ...other,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionGroup, {
      component: null,
      exit: true,
      children: ripples
    })
  });
});
process.env.NODE_ENV !== "production" ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
function getButtonBaseUtilityClass(slot) {
  return generateUtilityClass("MuiButtonBase", slot);
}
const buttonBaseClasses = generateUtilityClasses("MuiButtonBase", ["root", "disabled", "focusVisible"]);
const useUtilityClasses$1c = (ownerState) => {
  const {
    disabled,
    focusVisible,
    focusVisibleClassName,
    classes
  } = ownerState;
  const slots = {
    root: ["root", disabled && "disabled", focusVisible && "focusVisible"]
  };
  const composedClasses = composeClasses(slots, getButtonBaseUtilityClass, classes);
  if (focusVisible && focusVisibleClassName) {
    composedClasses.root += ` ${focusVisibleClassName}`;
  }
  return composedClasses;
};
const ButtonBaseRoot = styled("button", {
  name: "MuiButtonBase",
  slot: "Root"
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${buttonBaseClasses.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
});
const ButtonBase = /* @__PURE__ */ reactExports.forwardRef(function ButtonBase2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiButtonBase"
  });
  const {
    action,
    centerRipple = false,
    children,
    className,
    component = "button",
    disabled = false,
    disableRipple = false,
    disableTouchRipple = false,
    focusRipple = false,
    focusVisibleClassName,
    LinkComponent = "a",
    onBlur,
    onClick,
    onContextMenu,
    onDragLeave,
    onFocus,
    onFocusVisible,
    onKeyDown,
    onKeyUp,
    onMouseDown,
    onMouseLeave,
    onMouseUp,
    onTouchEnd,
    onTouchMove,
    onTouchStart,
    tabIndex = 0,
    TouchRippleProps,
    touchRippleRef,
    type,
    ...other
  } = props;
  const buttonRef = reactExports.useRef(null);
  const ripple = useLazyRipple();
  const handleRippleRef = useForkRef(ripple.ref, touchRippleRef);
  const [focusVisible, setFocusVisible] = reactExports.useState(false);
  if (disabled && focusVisible) {
    setFocusVisible(false);
  }
  reactExports.useImperativeHandle(action, () => ({
    focusVisible: () => {
      setFocusVisible(true);
      buttonRef.current.focus();
    }
  }), []);
  const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
  reactExports.useEffect(() => {
    if (focusVisible && focusRipple && !disableRipple) {
      ripple.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible, ripple]);
  const handleMouseDown = useRippleHandler(ripple, "start", onMouseDown, disableTouchRipple);
  const handleContextMenu = useRippleHandler(ripple, "stop", onContextMenu, disableTouchRipple);
  const handleDragLeave = useRippleHandler(ripple, "stop", onDragLeave, disableTouchRipple);
  const handleMouseUp = useRippleHandler(ripple, "stop", onMouseUp, disableTouchRipple);
  const handleMouseLeave = useRippleHandler(ripple, "stop", (event2) => {
    if (focusVisible) {
      event2.preventDefault();
    }
    if (onMouseLeave) {
      onMouseLeave(event2);
    }
  }, disableTouchRipple);
  const handleTouchStart = useRippleHandler(ripple, "start", onTouchStart, disableTouchRipple);
  const handleTouchEnd = useRippleHandler(ripple, "stop", onTouchEnd, disableTouchRipple);
  const handleTouchMove = useRippleHandler(ripple, "stop", onTouchMove, disableTouchRipple);
  const handleBlur = useRippleHandler(ripple, "stop", (event2) => {
    if (!isFocusVisible(event2.target)) {
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event2);
    }
  }, false);
  const handleFocus = useEventCallback((event2) => {
    if (!buttonRef.current) {
      buttonRef.current = event2.currentTarget;
    }
    if (isFocusVisible(event2.target)) {
      setFocusVisible(true);
      if (onFocusVisible) {
        onFocusVisible(event2);
      }
    }
    if (onFocus) {
      onFocus(event2);
    }
  });
  const isNonNativeButton = () => {
    const button2 = buttonRef.current;
    if (!button2) {
      return component && component !== "button";
    }
    if (button2.tagName === "BUTTON") {
      return false;
    }
    return !(button2.tagName === "A" && button2.href);
  };
  const handleKeyDown = useEventCallback((event2) => {
    if (focusRipple && !event2.repeat && focusVisible && event2.key === " ") {
      ripple.stop(event2, () => {
        ripple.start(event2);
      });
    }
    if (event2.target === event2.currentTarget && isNonNativeButton() && event2.key === " ") {
      event2.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event2);
    }
    if (event2.target === event2.currentTarget && isNonNativeButton() && event2.key === "Enter" && !disabled) {
      event2.preventDefault();
      if (onClick) {
        onClick(event2);
      }
    }
  });
  const handleKeyUp = useEventCallback((event2) => {
    if (focusRipple && event2.key === " " && focusVisible && !event2.defaultPrevented) {
      ripple.stop(event2, () => {
        ripple.pulsate(event2);
      });
    }
    if (onKeyUp) {
      onKeyUp(event2);
    }
    if (onClick && event2.target === event2.currentTarget && isNonNativeButton() && event2.key === " " && !event2.defaultPrevented && !disabled) {
      onClick(event2);
    }
  });
  let ComponentProp = component;
  if (ComponentProp === "button" && (other.href || other.to)) {
    ComponentProp = LinkComponent;
  }
  const buttonProps = {};
  if (ComponentProp === "button") {
    const hasFormAttributes = !!other.formAction;
    buttonProps.type = type === void 0 && !hasFormAttributes ? "button" : type;
    buttonProps.disabled = disabled;
  } else {
    if (!other.href && !other.to) {
      buttonProps.role = "button";
    }
    if (disabled) {
      buttonProps["aria-disabled"] = disabled;
    }
  }
  const handleRef = useForkRef(ref2, buttonRef);
  const ownerState = {
    ...props,
    centerRipple,
    component,
    disabled,
    disableRipple,
    disableTouchRipple,
    focusRipple,
    tabIndex,
    focusVisible
  };
  const classes = useUtilityClasses$1c(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonBaseRoot, {
    as: ComponentProp,
    className: clsx(classes.root, className),
    ownerState,
    onBlur: handleBlur,
    onClick,
    onContextMenu: handleContextMenu,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex,
    type,
    ...buttonProps,
    ...other,
    children: [children, enableTouchRipple ? /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRipple, {
      ref: handleRippleRef,
      center: centerRipple,
      ...TouchRippleProps
    }) : null]
  });
});
function useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
  return useEventCallback((event2) => {
    if (eventCallback) {
      eventCallback(event2);
    }
    if (!skipRippleAction) {
      ripple[rippleAction](event2);
    }
    return true;
  });
}
process.env.NODE_ENV !== "production" ? ButtonBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  formAction: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  /**
   * @ignore
   */
  href: PropTypes.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onContextMenu: PropTypes.func,
  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,
  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,
  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,
  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,
  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string])
} : void 0;
function getAccordionSummaryUtilityClass(slot) {
  return generateUtilityClass("MuiAccordionSummary", slot);
}
const accordionSummaryClasses = generateUtilityClasses("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]);
const useUtilityClasses$1b = (ownerState) => {
  const {
    classes,
    expanded,
    disabled,
    disableGutters
  } = ownerState;
  const slots = {
    root: ["root", expanded && "expanded", disabled && "disabled", !disableGutters && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", expanded && "expanded", !disableGutters && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", expanded && "expanded"]
  };
  return composeClasses(slots, getAccordionSummaryUtilityClass, classes);
};
const AccordionSummaryRoot = styled(ButtonBase, {
  name: "MuiAccordionSummary",
  slot: "Root"
})(memoTheme(({
  theme
}) => {
  const transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    display: "flex",
    width: "100%",
    minHeight: 48,
    padding: theme.spacing(0, 2),
    transition: theme.transitions.create(["min-height", "background-color"], transition),
    [`&.${accordionSummaryClasses.focusVisible}`]: {
      backgroundColor: (theme.vars || theme).palette.action.focus
    },
    [`&.${accordionSummaryClasses.disabled}`]: {
      opacity: (theme.vars || theme).palette.action.disabledOpacity
    },
    [`&:hover:not(.${accordionSummaryClasses.disabled})`]: {
      cursor: "pointer"
    },
    variants: [{
      props: (props) => !props.disableGutters,
      style: {
        [`&.${accordionSummaryClasses.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
}));
const AccordionSummaryContent = styled("span", {
  name: "MuiAccordionSummary",
  slot: "Content"
})(memoTheme(({
  theme
}) => ({
  display: "flex",
  textAlign: "start",
  flexGrow: 1,
  margin: "12px 0",
  variants: [{
    props: (props) => !props.disableGutters,
    style: {
      transition: theme.transitions.create(["margin"], {
        duration: theme.transitions.duration.shortest
      }),
      [`&.${accordionSummaryClasses.expanded}`]: {
        margin: "20px 0"
      }
    }
  }]
})));
const AccordionSummaryExpandIconWrapper = styled("span", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper"
})(memoTheme(({
  theme
}) => ({
  display: "flex",
  color: (theme.vars || theme).palette.action.active,
  transform: "rotate(0deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${accordionSummaryClasses.expanded}`]: {
    transform: "rotate(180deg)"
  }
})));
const AccordionSummary = /* @__PURE__ */ reactExports.forwardRef(function AccordionSummary2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiAccordionSummary"
  });
  const {
    children,
    className,
    expandIcon,
    focusVisibleClassName,
    onClick,
    slots,
    slotProps,
    ...other
  } = props;
  const {
    disabled = false,
    disableGutters,
    expanded,
    toggle: toggle2
  } = reactExports.useContext(AccordionContext);
  const handleChange = (event2) => {
    if (toggle2) {
      toggle2(event2);
    }
    if (onClick) {
      onClick(event2);
    }
  };
  const ownerState = {
    ...props,
    expanded,
    disabled,
    disableGutters
  };
  const classes = useUtilityClasses$1b(ownerState);
  const externalForwardedProps = {
    slots,
    slotProps
  };
  const [RootSlot, rootSlotProps] = useSlot("root", {
    ref: ref2,
    shouldForwardComponentProp: true,
    className: clsx(classes.root, className),
    elementType: AccordionSummaryRoot,
    externalForwardedProps: {
      ...externalForwardedProps,
      ...other
    },
    ownerState,
    additionalProps: {
      focusRipple: false,
      disableRipple: true,
      disabled,
      "aria-expanded": expanded,
      focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName)
    },
    getSlotProps: (handlers) => ({
      ...handlers,
      onClick: (event2) => {
        handlers.onClick?.(event2);
        handleChange(event2);
      }
    })
  });
  const [ContentSlot, contentSlotProps] = useSlot("content", {
    className: classes.content,
    elementType: AccordionSummaryContent,
    externalForwardedProps,
    ownerState
  });
  const [ExpandIconWrapperSlot, expandIconWrapperSlotProps] = useSlot("expandIconWrapper", {
    className: classes.expandIconWrapper,
    elementType: AccordionSummaryExpandIconWrapper,
    externalForwardedProps,
    ownerState
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(RootSlot, {
    ...rootSlotProps,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ContentSlot, {
      ...contentSlotProps,
      children
    }), expandIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(ExpandIconWrapperSlot, {
      ...expandIconWrapperSlotProps,
      children: expandIcon
    })]
  });
});
process.env.NODE_ENV !== "production" ? AccordionSummary.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: PropTypes.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    content: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    expandIconWrapper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    content: PropTypes.elementType,
    expandIconWrapper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function hasCorrectMainProperty(obj) {
  return typeof obj.main === "string";
}
function checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
  if (!hasCorrectMainProperty(obj)) {
    return false;
  }
  for (const value of additionalPropertiesToCheck) {
    if (!obj.hasOwnProperty(value) || typeof obj[value] !== "string") {
      return false;
    }
  }
  return true;
}
function createSimplePaletteValueFilter(additionalPropertiesToCheck = []) {
  return ([, value]) => value && checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}
function getCircularProgressUtilityClass(slot) {
  return generateUtilityClass("MuiCircularProgress", slot);
}
generateUtilityClasses("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "track", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const SIZE = 44;
const circularRotateKeyframe = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const circularDashKeyframe = keyframes`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
const rotateAnimation = typeof circularRotateKeyframe !== "string" ? css`
        animation: ${circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const dashAnimation = typeof circularDashKeyframe !== "string" ? css`
        animation: ${circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const useUtilityClasses$1a = (ownerState) => {
  const {
    classes,
    variant,
    color: color2,
    disableShrink
  } = ownerState;
  const slots = {
    root: ["root", variant, `color${capitalize$2(color2)}`],
    svg: ["svg"],
    track: ["track"],
    circle: ["circle", `circle${capitalize$2(variant)}`, disableShrink && "circleDisableShrink"]
  };
  return composeClasses(slots, getCircularProgressUtilityClass, classes);
};
const CircularProgressRoot = styled("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, styles2[ownerState.variant], styles2[`color${capitalize$2(ownerState.color)}`]];
  }
})(memoTheme(({
  theme
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: theme.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: rotateAnimation || {
      animation: `${circularRotateKeyframe} 1.4s linear infinite`
    }
  }, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color2]) => ({
    props: {
      color: color2
    },
    style: {
      color: (theme.vars || theme).palette[color2].main
    }
  }))]
})));
const CircularProgressSVG = styled("svg", {
  name: "MuiCircularProgress",
  slot: "Svg"
})({
  display: "block"
  // Keeps the progress centered
});
const CircularProgressCircle = styled("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.circle, styles2[`circle${capitalize$2(ownerState.variant)}`], ownerState.disableShrink && styles2.circleDisableShrink];
  }
})(memoTheme(({
  theme
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: theme.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.variant === "indeterminate" && !ownerState.disableShrink,
    style: dashAnimation || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${circularDashKeyframe} 1.4s ease-in-out infinite`
    }
  }]
})));
const CircularProgressTrack = styled("circle", {
  name: "MuiCircularProgress",
  slot: "Track"
})(memoTheme(({
  theme
}) => ({
  stroke: "currentColor",
  opacity: (theme.vars || theme).palette.action.activatedOpacity
})));
const CircularProgress = /* @__PURE__ */ reactExports.forwardRef(function CircularProgress2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiCircularProgress"
  });
  const {
    className,
    color: color2 = "primary",
    disableShrink = false,
    enableTrackSlot = false,
    size = 40,
    style: style2,
    thickness = 3.6,
    value = 0,
    variant = "indeterminate",
    ...other
  } = props;
  const ownerState = {
    ...props,
    color: color2,
    disableShrink,
    size,
    thickness,
    value,
    variant,
    enableTrackSlot
  };
  const classes = useUtilityClasses$1a(ownerState);
  const circleStyle = {};
  const rootStyle = {};
  const rootProps = {};
  if (variant === "determinate") {
    const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps["aria-valuenow"] = Math.round(value);
    circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
    rootStyle.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressRoot, {
    className: clsx(classes.root, className),
    style: {
      width: size,
      height: size,
      ...rootStyle,
      ...style2
    },
    ownerState,
    ref: ref2,
    role: "progressbar",
    ...rootProps,
    ...other,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CircularProgressSVG, {
      className: classes.svg,
      ownerState,
      viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
      children: [enableTrackSlot ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressTrack, {
        className: classes.track,
        ownerState,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness,
        "aria-hidden": "true"
      }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressCircle, {
        className: classes.circle,
        style: circleStyle,
        ownerState,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
      })]
    })
  });
});
process.env.NODE_ENV !== "production" ? CircularProgress.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: chainPropTypes(PropTypes.bool, (props) => {
    if (props.disableShrink && props.variant && props.variant !== "indeterminate") {
      return new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.");
    }
    return null;
  }),
  /**
   * If `true`, a track circle slot is mounted to show a subtle background for the progress.
   * The `size` and `thickness` apply to the track slot to be consistent with the progress circle.
   * @default false
   */
  enableTrackSlot: PropTypes.bool,
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: PropTypes.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(["determinate", "indeterminate"])
} : void 0;
function getIconButtonUtilityClass(slot) {
  return generateUtilityClass("MuiIconButton", slot);
}
const iconButtonClasses = generateUtilityClasses("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]);
const useUtilityClasses$19 = (ownerState) => {
  const {
    classes,
    disabled,
    color: color2,
    edge,
    size,
    loading
  } = ownerState;
  const slots = {
    root: ["root", loading && "loading", disabled && "disabled", color2 !== "default" && `color${capitalize$2(color2)}`, edge && `edge${capitalize$2(edge)}`, `size${capitalize$2(size)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return composeClasses(slots, getIconButtonUtilityClass, classes);
};
const IconButtonRoot = styled(ButtonBase, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.loading && styles2.loading, ownerState.color !== "default" && styles2[`color${capitalize$2(ownerState.color)}`], ownerState.edge && styles2[`edge${capitalize$2(ownerState.edge)}`], styles2[`size${capitalize$2(ownerState.size)}`]];
  }
})(memoTheme(({
  theme
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: theme.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (theme.vars || theme).palette.action.active,
  transition: theme.transitions.create("background-color", {
    duration: theme.transitions.duration.shortest
  }),
  variants: [{
    props: (props) => !props.disableRipple,
    style: {
      "--IconButton-hoverBg": theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), memoTheme(({
  theme
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color2]) => ({
    props: {
      color: color2
    },
    style: {
      color: (theme.vars || theme).palette[color2].main
    }
  })), ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color2]) => ({
    props: {
      color: color2
    },
    style: {
      "--IconButton-hoverBg": theme.alpha((theme.vars || theme).palette[color2].main, (theme.vars || theme).palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: theme.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: theme.typography.pxToRem(28)
    }
  }],
  [`&.${iconButtonClasses.disabled}`]: {
    backgroundColor: "transparent",
    color: (theme.vars || theme).palette.action.disabled
  },
  [`&.${iconButtonClasses.loading}`]: {
    color: "transparent"
  }
})));
const IconButtonLoadingIndicator = styled("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator"
})(({
  theme
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (theme.vars || theme).palette.action.disabled,
  variants: [{
    props: {
      loading: true
    },
    style: {
      display: "flex"
    }
  }]
}));
const IconButton = /* @__PURE__ */ reactExports.forwardRef(function IconButton2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiIconButton"
  });
  const {
    edge = false,
    children,
    className,
    color: color2 = "default",
    disabled = false,
    disableFocusRipple = false,
    size = "medium",
    id: idProp,
    loading = null,
    loadingIndicator: loadingIndicatorProp,
    ...other
  } = props;
  const loadingId = useId(idProp);
  const loadingIndicator = loadingIndicatorProp ?? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, {
    "aria-labelledby": loadingId,
    color: "inherit",
    size: 16
  });
  const ownerState = {
    ...props,
    edge,
    color: color2,
    disabled,
    disableFocusRipple,
    loading,
    loadingIndicator,
    size
  };
  const classes = useUtilityClasses$19(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(IconButtonRoot, {
    id: loading ? loadingId : idProp,
    className: clsx(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled || loading,
    ref: ref2,
    ...other,
    ownerState,
    children: [typeof loading === "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: classes.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconButtonLoadingIndicator, {
        className: classes.loadingIndicator,
        ownerState,
        children: loading && loadingIndicator
      })
    }), children]
  });
});
process.env.NODE_ENV !== "production" ? IconButton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: chainPropTypes(PropTypes.node, (props) => {
    const found = reactExports.Children.toArray(props.children).some((child) => /* @__PURE__ */ reactExports.isValidElement(child) && child.props.onClick);
    if (found) {
      return new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join("\n"));
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", false]),
  /**
   * @ignore
   */
  id: PropTypes.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: PropTypes.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: PropTypes.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
const ClearIcon$1 = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
function getTypographyUtilityClass(slot) {
  return generateUtilityClass("MuiTypography", slot);
}
const typographyClasses = generateUtilityClasses("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const v6Colors$1 = {
  primary: true,
  secondary: true,
  error: true,
  info: true,
  success: true,
  warning: true,
  textPrimary: true,
  textSecondary: true,
  textDisabled: true
};
const extendSxProp = internal_createExtendSxProp();
const useUtilityClasses$18 = (ownerState) => {
  const {
    align,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ["root", variant, ownerState.align !== "inherit" && `align${capitalize$2(align)}`, gutterBottom && "gutterBottom", noWrap && "noWrap", paragraph && "paragraph"]
  };
  return composeClasses(slots, getTypographyUtilityClass, classes);
};
const TypographyRoot = styled("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.variant && styles2[ownerState.variant], ownerState.align !== "inherit" && styles2[`align${capitalize$2(ownerState.align)}`], ownerState.noWrap && styles2.noWrap, ownerState.gutterBottom && styles2.gutterBottom, ownerState.paragraph && styles2.paragraph];
  }
})(memoTheme(({
  theme
}) => ({
  margin: 0,
  variants: [{
    props: {
      variant: "inherit"
    },
    style: {
      // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
      font: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  }, ...Object.entries(theme.typography).filter(([variant, value]) => variant !== "inherit" && value && typeof value === "object").map(([variant, value]) => ({
    props: {
      variant
    },
    style: value
  })), ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color2]) => ({
    props: {
      color: color2
    },
    style: {
      color: (theme.vars || theme).palette[color2].main
    }
  })), ...Object.entries(theme.palette?.text || {}).filter(([, value]) => typeof value === "string").map(([color2]) => ({
    props: {
      color: `text${capitalize$2(color2)}`
    },
    style: {
      color: (theme.vars || theme).palette.text[color2]
    }
  })), {
    props: ({
      ownerState
    }) => ownerState.align !== "inherit",
    style: {
      textAlign: "var(--Typography-textAlign)"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.noWrap,
    style: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.gutterBottom,
    style: {
      marginBottom: "0.35em"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.paragraph,
    style: {
      marginBottom: 16
    }
  }]
})));
const defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
};
const Typography$1 = /* @__PURE__ */ reactExports.forwardRef(function Typography(inProps, ref2) {
  const {
    color: color2,
    ...themeProps
  } = useDefaultProps({
    props: inProps,
    name: "MuiTypography"
  });
  const isSxColor = !v6Colors$1[color2];
  const props = extendSxProp({
    ...themeProps,
    ...isSxColor && {
      color: color2
    }
  });
  const {
    align = "inherit",
    className,
    component,
    gutterBottom = false,
    noWrap = false,
    paragraph = false,
    variant = "body1",
    variantMapping = defaultVariantMapping,
    ...other
  } = props;
  const ownerState = {
    ...props,
    align,
    color: color2,
    className,
    component,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    variantMapping
  };
  const Component = component || (paragraph ? "p" : variantMapping[variant] || defaultVariantMapping[variant]) || "span";
  const classes = useUtilityClasses$18(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TypographyRoot, {
    as: Component,
    ref: ref2,
    className: clsx(classes.root, className),
    ...other,
    ownerState,
    style: {
      ...align !== "inherit" && {
        "--Typography-textAlign": align
      },
      ...other.style
    }
  });
});
process.env.NODE_ENV !== "production" ? Typography$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: PropTypes.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: PropTypes.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: PropTypes.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: PropTypes.bool,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), PropTypes.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: PropTypes.object
} : void 0;
const alertTitleClasses = generateUtilityClasses("MuiAlertTitle", ["root"]);
function useForcedRerendering() {
  const [, setState] = reactExports.useState({});
  return reactExports.useCallback(() => {
    setState({});
  }, []);
}
function contains$1(parent2, child) {
  if (!parent2 || !child) {
    return false;
  }
  if (parent2.contains(child)) {
    return true;
  }
  const rootNode = child.getRootNode?.();
  if (rootNode && rootNode instanceof ShadowRoot) {
    let next2 = child;
    while (next2) {
      if (parent2 === next2) {
        return true;
      }
      next2 = next2.parentNode ?? next2.host ?? null;
    }
  }
  return false;
}
function usePreviousProps(value) {
  const ref2 = reactExports.useRef({});
  reactExports.useEffect(() => {
    ref2.current = value;
  });
  return ref2.current;
}
function areArraysSame({
  array1,
  array2,
  parser = (value) => value
}) {
  return array1 && array2 && array1.length === array2.length && array1.every((prevOption, index2) => parser(prevOption) === parser(array2[index2]));
}
function stripDiacritics(string2) {
  return string2.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function createFilterOptions(config2 = {}) {
  const {
    ignoreAccents = true,
    ignoreCase = true,
    limit,
    matchFrom = "any",
    stringify: stringify2,
    trim: trim2 = false
  } = config2;
  return (options, {
    inputValue,
    getOptionLabel
  }) => {
    let input = trim2 ? inputValue.trim() : inputValue;
    if (ignoreCase) {
      input = input.toLowerCase();
    }
    if (ignoreAccents) {
      input = stripDiacritics(input);
    }
    const filteredOptions = !input ? options : options.filter((option) => {
      let candidate = (stringify2 || getOptionLabel)(option);
      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }
      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }
      return matchFrom === "start" ? candidate.startsWith(input) : candidate.includes(input);
    });
    return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
  };
}
const defaultFilterOptions = createFilterOptions();
const pageSize = 5;
const defaultIsActiveElementInListbox = (listboxRef) => listboxRef.current !== null && contains$1(listboxRef.current.parentElement, document.activeElement);
const defaultIsOptionEqualToValue = (option, value) => option === value;
const MULTIPLE_DEFAULT_VALUE = [];
function getInputValue(value, multiple, getOptionLabel, renderValue) {
  if (multiple || value == null || renderValue) {
    return "";
  }
  const optionLabel = getOptionLabel(value);
  return typeof optionLabel === "string" ? optionLabel : "";
}
function useAutocomplete(props) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = defaultIsActiveElementInListbox,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = "Mui",
    autoComplete = false,
    autoHighlight = false,
    autoSelect = false,
    blurOnSelect = false,
    clearOnBlur = !props.freeSolo,
    clearOnEscape = false,
    componentName = "useAutocomplete",
    defaultValue = props.multiple ? MULTIPLE_DEFAULT_VALUE : null,
    disableClearable = false,
    disableCloseOnSelect = false,
    disabled: disabledProp,
    disabledItemsFocusable = false,
    disableListWrap = false,
    filterOptions = defaultFilterOptions,
    filterSelectedOptions = false,
    freeSolo = false,
    getOptionDisabled,
    getOptionKey,
    getOptionLabel: getOptionLabelProp = (option) => option.label ?? option,
    groupBy,
    handleHomeEndKeys = !props.freeSolo,
    id: idProp,
    includeInputInList = false,
    inputValue: inputValueProp,
    isOptionEqualToValue = defaultIsOptionEqualToValue,
    multiple = false,
    onChange,
    onClose,
    onHighlightChange,
    onInputChange,
    onOpen,
    open: openProp,
    openOnFocus = false,
    options,
    readOnly = false,
    renderValue,
    selectOnFocus = !props.freeSolo,
    value: valueProp
  } = props;
  const id = useId(idProp);
  let getOptionLabel = getOptionLabelProp;
  getOptionLabel = (option) => {
    const optionLabel = getOptionLabelProp(option);
    if (typeof optionLabel !== "string") {
      if (process.env.NODE_ENV !== "production") {
        const erroneousReturn = optionLabel === void 0 ? "undefined" : `${typeof optionLabel} (${optionLabel})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${componentName} returned ${erroneousReturn} instead of a string for ${JSON.stringify(option)}.`);
      }
      return String(optionLabel);
    }
    return optionLabel;
  };
  const ignoreFocus = reactExports.useRef(false);
  const firstFocus = reactExports.useRef(true);
  const inputRef = reactExports.useRef(null);
  const listboxRef = reactExports.useRef(null);
  const windowLostFocus = reactExports.useRef(false);
  const [anchorEl, setAnchorEl] = reactExports.useState(null);
  const [focusedItem, setFocusedItem] = reactExports.useState(-1);
  const defaultHighlighted = autoHighlight ? 0 : -1;
  const highlightedIndexRef = reactExports.useRef(defaultHighlighted);
  const highlightReasonRef = reactExports.useRef(null);
  const touchScrolledRef = reactExports.useRef(false);
  const isTouchRef = reactExports.useRef(false);
  const initialInputValue = reactExports.useRef(getInputValue(defaultValue ?? valueProp, multiple, getOptionLabel)).current;
  const [value, setValueState] = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: componentName
  });
  const [inputValue, setInputValueState] = useControlled({
    controlled: inputValueProp,
    default: initialInputValue,
    name: componentName,
    state: "inputValue"
  });
  const [focused, setFocused] = reactExports.useState(false);
  const resetInputValue = reactExports.useCallback((event2, newValue, reason) => {
    const isOptionSelected2 = multiple ? value.length < newValue.length : newValue !== null;
    if (!isOptionSelected2 && !clearOnBlur) {
      return;
    }
    const newInputValue = getInputValue(newValue, multiple, getOptionLabel, renderValue);
    if (inputValue === newInputValue) {
      return;
    }
    setInputValueState(newInputValue);
    if (onInputChange) {
      onInputChange(event2, newInputValue, reason);
    }
  }, [getOptionLabel, inputValue, multiple, onInputChange, setInputValueState, clearOnBlur, value, renderValue]);
  const [open2, setOpenState] = useControlled({
    controlled: openProp,
    default: false,
    name: componentName,
    state: "open"
  });
  const [inputPristine, setInputPristine] = reactExports.useState(true);
  const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
  const popupOpen = open2 && !readOnly;
  const selectedValues = reactExports.useMemo(() => {
    if (multiple) {
      return value;
    }
    if (value != null) {
      return [value];
    }
    return [];
  }, [multiple, value]);
  const selectedValuesSet = reactExports.useMemo(() => {
    if (isOptionEqualToValue !== defaultIsOptionEqualToValue || selectedValues.length === 0) {
      return null;
    }
    return new Set(selectedValues);
  }, [isOptionEqualToValue, selectedValues]);
  const isOptionSelected = reactExports.useCallback((option) => {
    if (selectedValuesSet) {
      return selectedValuesSet.has(option);
    }
    return selectedValues.some((value2) => value2 != null && isOptionEqualToValue(option, value2));
  }, [isOptionEqualToValue, selectedValues, selectedValuesSet]);
  const filteredOptions = popupOpen ? filterOptions(
    options.filter((option) => {
      if (filterSelectedOptions && isOptionSelected(option)) {
        return false;
      }
      return true;
    }),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
      getOptionLabel
    }
  ) : [];
  const previousProps = usePreviousProps({
    filteredOptions,
    value,
    inputValue
  });
  reactExports.useEffect(() => {
    const valueChange = value !== previousProps.value;
    if (focused && !valueChange) {
      return;
    }
    if (freeSolo && !valueChange) {
      return;
    }
    resetInputValue(null, value, "reset");
  }, [value, resetInputValue, focused, previousProps.value, freeSolo]);
  const listboxAvailable = open2 && filteredOptions.length > 0 && !readOnly;
  const focusItem = useEventCallback((itemToFocus) => {
    if (itemToFocus === -1) {
      inputRef.current.focus();
    } else {
      const indexType = renderValue ? "data-item-index" : "data-tag-index";
      anchorEl.querySelector(`[${indexType}="${itemToFocus}"]`).focus();
    }
  });
  reactExports.useEffect(() => {
    if (multiple && focusedItem > value.length - 1) {
      setFocusedItem(-1);
      focusItem(-1);
    }
  }, [value, multiple, focusedItem, focusItem]);
  function validOptionIndex(index2, direction) {
    if (!listboxRef.current || index2 < 0 || index2 >= filteredOptions.length) {
      return -1;
    }
    let nextFocus = index2;
    while (true) {
      const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
      const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
      if (option && option.hasAttribute("tabindex") && !nextFocusDisabled) {
        return nextFocus;
      }
      if (direction === "next") {
        nextFocus = (nextFocus + 1) % filteredOptions.length;
      } else {
        nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
      }
      if (nextFocus === index2) {
        return -1;
      }
    }
  }
  const syncHighlightedIndexToDOM = useEventCallback(({
    index: index2,
    reason,
    preserveScroll = false
  }) => {
    if (index2 === -1) {
      inputRef.current.removeAttribute("aria-activedescendant");
    } else {
      inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index2}`);
    }
    if (!listboxRef.current) {
      return;
    }
    const prev2 = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
    if (prev2) {
      prev2.classList.remove(`${unstable_classNamePrefix}-focused`);
      prev2.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
    }
    let listboxNode = listboxRef.current;
    if (listboxRef.current.getAttribute("role") !== "listbox") {
      listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
    }
    if (!listboxNode) {
      return;
    }
    if (index2 === -1) {
      if (!preserveScroll) {
        listboxNode.scrollTop = 0;
      }
      return;
    }
    const option = listboxRef.current.querySelector(`[data-option-index="${index2}"]`);
    if (!option) {
      return;
    }
    option.classList.add(`${unstable_classNamePrefix}-focused`);
    if (reason === "keyboard") {
      option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
    }
    if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse" && reason !== "touch") {
      const element = option;
      const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
      const elementBottom = element.offsetTop + element.offsetHeight;
      if (elementBottom > scrollBottom) {
        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
      } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
        listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
      }
    }
  });
  const setHighlightedIndex = useEventCallback(({
    event: event2,
    index: index2,
    reason,
    preserveScroll = false
  }) => {
    highlightedIndexRef.current = index2;
    highlightReasonRef.current = reason ?? null;
    if (onHighlightChange && ["mouse", "keyboard", "touch"].includes(reason)) {
      onHighlightChange(event2, index2 === -1 ? null : filteredOptions[index2], reason);
    }
    syncHighlightedIndexToDOM({
      index: index2,
      reason,
      preserveScroll
    });
  });
  const setHighlightedIndexFromSync = useEventCallback(({
    index: index2
  }) => {
    highlightedIndexRef.current = index2;
    syncHighlightedIndexToDOM({
      index: index2,
      reason: highlightReasonRef.current
    });
  });
  const changeHighlightedIndex = useEventCallback(({
    event: event2,
    diff: diff2,
    direction = "next",
    reason,
    preserveScroll
  }) => {
    if (!popupOpen) {
      return;
    }
    if (reason === "keyboard") {
      touchScrolledRef.current = false;
      isTouchRef.current = false;
    }
    const getNextIndex = () => {
      const maxIndex = filteredOptions.length - 1;
      if (diff2 === "reset") {
        return defaultHighlighted;
      }
      if (diff2 === "start") {
        return 0;
      }
      if (diff2 === "end") {
        return maxIndex;
      }
      const newIndex = highlightedIndexRef.current + diff2;
      if (newIndex < 0) {
        if (newIndex === -1 && includeInputInList) {
          return -1;
        }
        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff2) > 1) {
          return 0;
        }
        return maxIndex;
      }
      if (newIndex > maxIndex) {
        if (newIndex === maxIndex + 1 && includeInputInList) {
          return -1;
        }
        if (disableListWrap || Math.abs(diff2) > 1) {
          return maxIndex;
        }
        return 0;
      }
      return newIndex;
    };
    const nextIndex = validOptionIndex(getNextIndex(), direction);
    setHighlightedIndex({
      index: nextIndex,
      reason,
      event: event2,
      preserveScroll
    });
    if (autoComplete && diff2 !== "reset") {
      if (nextIndex === -1) {
        inputRef.current.value = inputValue;
      } else {
        const option = getOptionLabel(filteredOptions[nextIndex]);
        inputRef.current.value = option;
        const index2 = option.toLowerCase().indexOf(inputValue.toLowerCase());
        if (index2 === 0 && inputValue.length > 0) {
          inputRef.current.setSelectionRange(inputValue.length, option.length);
        }
      }
    }
  });
  const filteredOptionsChanged = !areArraysSame({
    array1: previousProps.filteredOptions,
    array2: filteredOptions,
    parser: getOptionLabel
  });
  const getPreviousHighlightedOptionIndex = () => {
    const isSameValue = (value1, value2) => {
      const label1 = value1 ? getOptionLabel(value1) : "";
      const label2 = value2 ? getOptionLabel(value2) : "";
      return label1 === label2;
    };
    if (highlightedIndexRef.current !== -1 && !areArraysSame({
      array1: previousProps.filteredOptions,
      array2: filteredOptions,
      parser: getOptionLabel
    }) && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i) => getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
      const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
      if (previousHighlightedOption) {
        return filteredOptions.findIndex((option) => {
          return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
        });
      }
    }
    return -1;
  };
  const syncHighlightedIndex = reactExports.useCallback(() => {
    if (!popupOpen) {
      return;
    }
    const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
    if (previousHighlightedOptionIndex !== -1) {
      setHighlightedIndexFromSync({
        index: previousHighlightedOptionIndex
      });
      return;
    }
    const valueItem = multiple ? value[0] : value;
    if (filteredOptions.length === 0 || valueItem == null) {
      const isAppendOnly = filteredOptionsChanged && previousProps.inputValue === inputValue && previousProps.filteredOptions?.length > 0 && filteredOptions.length > previousProps.filteredOptions.length && previousProps.filteredOptions.every((option, index2) => getOptionLabel(option) === getOptionLabel(filteredOptions[index2]));
      changeHighlightedIndex({
        diff: "reset",
        preserveScroll: isAppendOnly
      });
      return;
    }
    if (!listboxRef.current) {
      return;
    }
    if (valueItem != null) {
      const currentOption = filteredOptions[highlightedIndexRef.current];
      if (multiple && currentOption && value.findIndex((val) => isOptionEqualToValue(currentOption, val)) !== -1 && previousProps.filteredOptions?.length > 0) {
        setHighlightedIndexFromSync({
          index: highlightedIndexRef.current
        });
        return;
      }
      const itemIndex = filteredOptions.findIndex((optionItem) => isOptionEqualToValue(optionItem, valueItem));
      if (itemIndex === -1) {
        changeHighlightedIndex({
          diff: "reset"
        });
      } else {
        setHighlightedIndex({
          index: itemIndex
        });
      }
      return;
    }
    if (highlightedIndexRef.current >= filteredOptions.length - 1) {
      setHighlightedIndex({
        index: filteredOptions.length - 1
      });
      return;
    }
    setHighlightedIndex({
      index: highlightedIndexRef.current
    });
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    filteredOptions.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    multiple ? false : value,
    changeHighlightedIndex,
    setHighlightedIndex,
    setHighlightedIndexFromSync,
    popupOpen,
    inputValue,
    multiple
  ]);
  const handleListboxRef = useEventCallback((node2) => {
    setRef$1(listboxRef, node2);
    if (!node2) {
      return;
    }
    syncHighlightedIndex();
  });
  if (process.env.NODE_ENV !== "production") {
    reactExports.useEffect(() => {
      if (!inputRef.current || inputRef.current.nodeName !== "INPUT") {
        if (inputRef.current && inputRef.current.nodeName === "TEXTAREA") {
          console.warn([`A textarea element was provided to ${componentName} where input was expected.`, `This is not a supported scenario but it may work under certain conditions.`, `A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).`, `Make sure to test keyboard navigation and add custom event handlers if necessary.`].join("\n"));
        } else {
          console.error([`MUI: Unable to find the input element. It was resolved to ${inputRef.current} while an HTMLInputElement was expected.`, `Instead, ${componentName} expects an input element.`, "", componentName === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join("\n"));
        }
      }
    }, [componentName]);
  }
  reactExports.useEffect(() => {
    if (filteredOptionsChanged || popupOpen && !disableCloseOnSelect) {
      syncHighlightedIndex();
    }
  }, [syncHighlightedIndex, filteredOptionsChanged, popupOpen, disableCloseOnSelect]);
  reactExports.useEffect(() => {
    if (typeof window === "undefined") {
      return void 0;
    }
    const handleWindowBlur = () => {
      windowLostFocus.current = true;
    };
    window.addEventListener("blur", handleWindowBlur);
    return () => {
      window.removeEventListener("blur", handleWindowBlur);
    };
  }, []);
  const handleOpen = (event2) => {
    if (open2) {
      return;
    }
    setOpenState(true);
    setInputPristine(true);
    isTouchRef.current = false;
    if (onOpen) {
      onOpen(event2);
    }
  };
  const handleClose = (event2, reason) => {
    if (!open2) {
      return;
    }
    setOpenState(false);
    touchScrolledRef.current = false;
    highlightReasonRef.current = null;
    if (onClose) {
      onClose(event2, reason);
    }
  };
  const handleValue = (event2, newValue, reason, details) => {
    if (multiple) {
      if (value.length === newValue.length && value.every((val, i) => val === newValue[i])) {
        return;
      }
    } else if (value === newValue) {
      return;
    }
    if (onChange) {
      onChange(event2, newValue, reason, details);
    }
    setValueState(newValue);
  };
  const selectNewValue = (event2, option, reasonProp = "selectOption", origin = "options") => {
    let reason = reasonProp;
    let newValue = option;
    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];
      if (process.env.NODE_ENV !== "production") {
        const matches = newValue.filter((val) => isOptionEqualToValue(option, val));
        if (matches.length > 1) {
          console.error([`MUI: The \`isOptionEqualToValue\` method of ${componentName} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${matches.length} matches.`].join("\n"));
        }
      }
      const itemIndex = newValue.findIndex((valueItem) => isOptionEqualToValue(option, valueItem));
      if (itemIndex === -1) {
        newValue.push(option);
      } else if (origin !== "freeSolo") {
        newValue.splice(itemIndex, 1);
        reason = "removeOption";
      }
    }
    resetInputValue(event2, newValue, reason);
    handleValue(event2, newValue, reason, {
      option
    });
    if (!disableCloseOnSelect && (!event2 || !event2.ctrlKey && !event2.metaKey)) {
      handleClose(event2, reason);
    }
    if (blurOnSelect === true || blurOnSelect === "touch" && isTouchRef.current || blurOnSelect === "mouse" && !isTouchRef.current) {
      inputRef.current.blur();
    }
  };
  function validItemIndex(index2, direction) {
    if (index2 === -1) {
      return -1;
    }
    let nextFocus = index2;
    while (true) {
      if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) {
        return -1;
      }
      const indexType = renderValue ? "data-item-index" : "data-tag-index";
      const option = anchorEl.querySelector(`[${indexType}="${nextFocus}"]`);
      if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") {
        nextFocus += direction === "next" ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }
  const handleFocusItem = (event2, direction) => {
    if (!multiple) {
      return;
    }
    if (inputValue === "") {
      handleClose(event2, "toggleInput");
    }
    let nextItem2 = focusedItem;
    if (focusedItem === -1 && direction === "previous") {
      nextItem2 = value.length - 1;
      if (freeSolo && inputValue !== "") {
        setInputValueState("");
        if (onInputChange) {
          onInputChange(event2, "", "reset");
        }
      }
    } else {
      nextItem2 += direction === "next" ? 1 : -1;
      if (nextItem2 < 0) {
        nextItem2 = 0;
      }
      if (nextItem2 === value.length) {
        nextItem2 = -1;
      }
    }
    nextItem2 = validItemIndex(nextItem2, direction);
    setFocusedItem(nextItem2);
    focusItem(nextItem2);
  };
  const handleClear = (event2) => {
    ignoreFocus.current = true;
    setInputValueState("");
    if (onInputChange) {
      onInputChange(event2, "", "clear");
    }
    handleValue(event2, multiple ? [] : null, "clear");
  };
  const handleKeyDown = (other) => (event2) => {
    if (other.onKeyDown) {
      other.onKeyDown(event2);
    }
    if (event2.defaultMuiPrevented) {
      return;
    }
    if (focusedItem !== -1 && !["ArrowLeft", "ArrowRight"].includes(event2.key)) {
      setFocusedItem(-1);
      focusItem(-1);
    }
    if (event2.which !== 229) {
      switch (event2.key) {
        case "Home":
          if (popupOpen && handleHomeEndKeys) {
            event2.preventDefault();
            changeHighlightedIndex({
              diff: "start",
              direction: "next",
              reason: "keyboard",
              event: event2
            });
          }
          break;
        case "End":
          if (popupOpen && handleHomeEndKeys) {
            event2.preventDefault();
            changeHighlightedIndex({
              diff: "end",
              direction: "previous",
              reason: "keyboard",
              event: event2
            });
          }
          break;
        case "PageUp":
          event2.preventDefault();
          changeHighlightedIndex({
            diff: -pageSize,
            direction: "previous",
            reason: "keyboard",
            event: event2
          });
          handleOpen(event2);
          break;
        case "PageDown":
          event2.preventDefault();
          changeHighlightedIndex({
            diff: pageSize,
            direction: "next",
            reason: "keyboard",
            event: event2
          });
          handleOpen(event2);
          break;
        case "ArrowDown":
          event2.preventDefault();
          changeHighlightedIndex({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: event2
          });
          handleOpen(event2);
          break;
        case "ArrowUp":
          event2.preventDefault();
          changeHighlightedIndex({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: event2
          });
          handleOpen(event2);
          break;
        case "ArrowLeft": {
          const input = inputRef.current;
          const caretAtStart = input && input.selectionStart === 0 && input.selectionEnd === 0;
          if (!caretAtStart) {
            return;
          }
          if (!multiple && renderValue && value != null) {
            if (freeSolo && inputValue !== "") {
              setInputValueState("");
              if (onInputChange) {
                onInputChange(event2, "", "reset");
              }
            }
            setFocusedItem(0);
            focusItem(0);
          } else {
            handleFocusItem(event2, "previous");
          }
          break;
        }
        case "ArrowRight":
          if (!multiple && renderValue) {
            setFocusedItem(-1);
            focusItem(-1);
          } else {
            handleFocusItem(event2, "next");
          }
          break;
        case "Enter": {
          const shouldSelectHighlighted = !freeSolo || inputPristine || highlightReasonRef.current !== null;
          if (highlightedIndexRef.current !== -1 && popupOpen && shouldSelectHighlighted && // After a touch-scroll the highlight is stale (the user scrolled
          // past it), so skip selection until the next deliberate interaction.
          !touchScrolledRef.current) {
            const option = filteredOptions[highlightedIndexRef.current];
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            event2.preventDefault();
            if (disabled) {
              return;
            }
            selectNewValue(event2, option, "selectOption");
            if (autoComplete) {
              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }
          } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
            if (multiple) {
              event2.preventDefault();
            }
            selectNewValue(event2, inputValue, "createOption", "freeSolo");
          } else if (popupOpen && touchScrolledRef.current) {
            event2.preventDefault();
            handleClose(event2, "escape");
          }
          break;
        }
        case "Escape":
          if (popupOpen) {
            event2.preventDefault();
            event2.stopPropagation();
            handleClose(event2, "escape");
          } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0 || renderValue)) {
            event2.preventDefault();
            event2.stopPropagation();
            handleClear(event2);
          }
          break;
        case "Backspace":
          if (multiple && !readOnly && inputValue === "" && value.length > 0) {
            const index2 = focusedItem === -1 ? value.length - 1 : focusedItem;
            const newValue = value.slice();
            newValue.splice(index2, 1);
            handleValue(event2, newValue, "removeOption", {
              option: value[index2]
            });
          }
          if (!multiple && renderValue && !readOnly && inputValue === "") {
            handleValue(event2, null, "removeOption", {
              option: value
            });
          }
          break;
        case "Delete":
          if (multiple && !readOnly && inputValue === "" && value.length > 0 && focusedItem !== -1) {
            const index2 = focusedItem;
            const newValue = value.slice();
            newValue.splice(index2, 1);
            handleValue(event2, newValue, "removeOption", {
              option: value[index2]
            });
          }
          if (!multiple && renderValue && !readOnly && inputValue === "") {
            handleValue(event2, null, "removeOption", {
              option: value
            });
          }
          break;
      }
    }
  };
  const handleFocus = (event2) => {
    setFocused(true);
    if (focusedItem !== -1) {
      setFocusedItem(-1);
      focusItem(-1);
    }
    if (windowLostFocus.current) {
      windowLostFocus.current = false;
      return;
    }
    if (openOnFocus && !ignoreFocus.current) {
      handleOpen(event2);
    }
  };
  const handleBlur = (event2) => {
    if (unstable_isActiveElementInListbox(listboxRef)) {
      inputRef.current.focus();
      return;
    }
    setFocused(false);
    firstFocus.current = true;
    ignoreFocus.current = false;
    if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen && highlightReasonRef.current !== "mouse" && highlightReasonRef.current !== "touch") {
      selectNewValue(event2, filteredOptions[highlightedIndexRef.current], "blur");
    } else if (autoSelect && freeSolo && inputValue !== "") {
      selectNewValue(event2, inputValue, "blur", "freeSolo");
    } else if (clearOnBlur) {
      resetInputValue(event2, value, "blur");
    }
    handleClose(event2, "blur");
  };
  const handleInputChange = (event2) => {
    const newValue = event2.target.value;
    const valueChanged = inputValue !== newValue;
    if (valueChanged) {
      setInputValueState(newValue);
      touchScrolledRef.current = false;
      if (onInputChange) {
        onInputChange(event2, newValue, "input");
      }
    }
    if (newValue === "") {
      if (!disableClearable && !multiple && !renderValue) {
        handleValue(event2, null, "clear");
      }
    } else {
      handleOpen(event2);
    }
    if (valueChanged) {
      setInputPristine(false);
    }
  };
  const handleOptionMouseMove = (event2) => {
    const index2 = Number(event2.currentTarget.getAttribute("data-option-index"));
    if (highlightedIndexRef.current !== index2) {
      setHighlightedIndex({
        event: event2,
        index: index2,
        reason: "mouse"
      });
    } else {
      highlightReasonRef.current = "mouse";
    }
    if (!isTouchRef.current) {
      touchScrolledRef.current = false;
    }
  };
  const handleOptionTouchStart = (event2) => {
    touchScrolledRef.current = false;
    setHighlightedIndex({
      event: event2,
      index: Number(event2.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    });
    isTouchRef.current = true;
  };
  const handleOptionClick = (event2) => {
    const index2 = Number(event2.currentTarget.getAttribute("data-option-index"));
    selectNewValue(event2, filteredOptions[index2], "selectOption");
    isTouchRef.current = false;
  };
  const handleItemDelete = (index2) => (event2) => {
    const newValue = value.slice();
    newValue.splice(index2, 1);
    handleValue(event2, newValue, "removeOption", {
      option: value[index2]
    });
  };
  const handleSingleItemDelete = (event2) => {
    handleValue(event2, null, "removeOption", {
      option: value
    });
  };
  const handlePopupIndicator = (event2) => {
    if (open2) {
      handleClose(event2, "toggleInput");
    } else {
      handleOpen(event2);
    }
  };
  const handleMouseDown = (event2) => {
    if (!contains$1(event2.currentTarget, event2.target)) {
      return;
    }
    if (anchorEl && !contains$1(anchorEl, event2.target)) {
      return;
    }
    if (event2.target.getAttribute("id") !== id) {
      event2.preventDefault();
    }
  };
  const handleClick = (event2) => {
    if (!contains$1(event2.currentTarget, event2.target)) {
      return;
    }
    if (anchorEl && !contains$1(anchorEl, event2.target)) {
      return;
    }
    inputRef.current.focus();
    if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
      inputRef.current.select();
    }
    firstFocus.current = false;
  };
  const handleInputMouseDown = (event2) => {
    if (!disabledProp && (inputValue === "" || !open2)) {
      handlePopupIndicator(event2);
    }
  };
  let dirty = freeSolo && inputValue.length > 0;
  dirty = dirty || (multiple ? value.length > 0 : value !== null);
  let groupedOptions = filteredOptions;
  if (groupBy) {
    const indexBy = /* @__PURE__ */ new Map();
    let warn2 = false;
    groupedOptions = filteredOptions.reduce((acc, option, index2) => {
      const group = groupBy(option);
      if (acc.length > 0 && acc[acc.length - 1].group === group) {
        acc[acc.length - 1].options.push(option);
      } else {
        if (process.env.NODE_ENV !== "production") {
          if (indexBy.get(group) && !warn2) {
            console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${componentName} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`.");
            warn2 = true;
          }
          indexBy.set(group, true);
        }
        acc.push({
          key: index2,
          index: index2,
          group,
          options: [option]
        });
      }
      return acc;
    }, []);
  }
  if (disabledProp && focused) {
    handleBlur();
  }
  return {
    getRootProps: (other = {}) => ({
      ...other,
      onKeyDown: handleKeyDown(other),
      onMouseDown: handleMouseDown,
      onClick: handleClick
    }),
    getInputLabelProps: () => ({
      id: `${id}-label`,
      htmlFor: id
    }),
    getInputProps: () => ({
      id,
      value: inputValue,
      onBlur: handleBlur,
      onFocus: handleFocus,
      onChange: handleInputChange,
      onMouseDown: handleInputMouseDown,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": popupOpen ? "" : null,
      "aria-autocomplete": autoComplete ? "both" : "list",
      "aria-controls": listboxAvailable ? `${id}-listbox` : void 0,
      "aria-expanded": listboxAvailable,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: inputRef,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: disabledProp
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: handleClear
    }),
    getItemProps: ({
      index: index2 = 0
    } = {}) => ({
      ...multiple && {
        key: index2
      },
      ...renderValue ? {
        "data-item-index": index2
      } : {
        "data-tag-index": index2
      },
      tabIndex: -1,
      ...!readOnly && {
        onDelete: multiple ? handleItemDelete(index2) : handleSingleItemDelete
      }
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: handlePopupIndicator
    }),
    // deprecated
    getTagProps: ({
      index: index2
    }) => ({
      key: index2,
      "data-tag-index": index2,
      tabIndex: -1,
      ...!readOnly && {
        onDelete: handleItemDelete(index2)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${id}-listbox`,
      "aria-labelledby": `${id}-label`,
      "aria-multiselectable": multiple || void 0,
      ref: handleListboxRef,
      onMouseDown: (event2) => {
        event2.preventDefault();
      },
      onScroll: () => {
        if (isTouchRef.current) {
          touchScrolledRef.current = true;
        }
      }
    }),
    getOptionProps: ({
      index: index2,
      option
    }) => {
      const selected = isOptionSelected(option);
      const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
      return {
        key: getOptionKey?.(option) ?? getOptionLabel(option),
        tabIndex: -1,
        role: "option",
        id: `${id}-option-${index2}`,
        onMouseMove: handleOptionMouseMove,
        onClick: handleOptionClick,
        onTouchStart: handleOptionTouchStart,
        "data-option-index": index2,
        "aria-disabled": disabled,
        "aria-selected": selected
      };
    },
    id,
    inputValue,
    value,
    dirty,
    expanded: popupOpen && anchorEl,
    popupOpen,
    focused: focused || focusedItem !== -1,
    anchorEl,
    setAnchorEl,
    focusedItem,
    // deprecated
    focusedTag: focusedItem,
    groupedOptions
  };
}
function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === "production") {
    return null;
  }
  const propValue = props[propName];
  const safePropName = propFullName || propName;
  if (propValue == null) {
    return null;
  }
  if (propValue && propValue.nodeType !== 1) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. Expected an HTMLElement.`);
  }
  return null;
}
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write3 = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write3, afterWrite];
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow(node2) {
  if (node2 == null) {
    return window;
  }
  if (node2.toString() !== "[object Window]") {
    var ownerDocument2 = node2.ownerDocument;
    return ownerDocument2 ? ownerDocument2.defaultView || window : window;
  }
  return node2;
}
function isElement(node2) {
  var OwnElement = getWindow(node2).Element;
  return node2 instanceof OwnElement || node2 instanceof Element;
}
function isHTMLElement$1(node2) {
  var OwnElement = getWindow(node2).HTMLElement;
  return node2 instanceof OwnElement || node2 instanceof HTMLElement;
}
function isShadowRoot(node2) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node2).ShadowRoot;
  return node2 instanceof OwnElement || node2 instanceof ShadowRoot;
}
function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function(name) {
    var style2 = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement$1(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style2);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style2 = styleProperties.reduce(function(style3, property2) {
        style3[property2] = "";
        return style3;
      }, {});
      if (!isHTMLElement$1(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style2);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max = Math.max;
var min = Math.min;
var round$2 = Math.round;
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function(item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement$1(element)) {
    scaleX = element.offsetWidth > 0 ? round$2(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$2(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window, visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width2 = clientRect.width / scaleX;
  var height2 = clientRect.height / scaleY;
  return {
    width: width2,
    height: height2,
    top: y,
    right: x + width2,
    bottom: y + height2,
    left: x,
    x,
    y
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width2 = element.offsetWidth;
  var height2 = element.offsetHeight;
  if (Math.abs(clientRect.width - width2) <= 1) {
    width2 = clientRect.width;
  }
  if (Math.abs(clientRect.height - height2) <= 1) {
    height2 = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width2,
    height: height2
  };
}
function contains(parent2, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent2.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next2 = child;
    do {
      if (next2 && parent2.isSameNode(next2)) {
        return true;
      }
      next2 = next2.parentNode || next2.host;
    } while (next2);
  }
  return false;
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : (
    // $FlowFixMe[prop-missing]
    element.document
  )) || window.document).documentElement;
}
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    (isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element)
  );
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement$1(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement$1(element)) {
    var elementCss = getComputedStyle$1(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement$1(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css2 = getComputedStyle$1(currentNode);
    if (css2.transform !== "none" || css2.perspective !== "none" || css2.contain === "paint" || ["transform", "perspective"].indexOf(css2.willChange) !== -1 || isFirefox && css2.willChange === "filter" || isFirefox && css2.filter && css2.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min2, value, max2) {
  var v = within(min2, value, max2);
  return v > max2 ? max2 : v;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys2) {
  return keys2.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding2, state) {
  padding2 = typeof padding2 === "function" ? padding2(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding2;
  return mergePaddingObject(typeof padding2 !== "number" ? padding2 : expandToHashMap(padding2, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state, name = _ref.name, options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state, options = _ref2.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
const arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x, y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$2(x * dpr) / dpr || 0,
    y: round$2(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position2 = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle$1(offsetParent).position !== "static" && position2 === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        offsetParent[heightProp]
      );
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        offsetParent[widthProp]
      );
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position2
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x,
    y
  }, getWindow(popper2)) : {
    x,
    y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state, instance = _ref.instance, options = _ref.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function getWindowScroll(node2) {
  var win = getWindow(node2);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width2 = html.clientWidth;
  var height2 = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width2 = visualViewport.width;
    height2 = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width: width2,
    height: height2,
    x: x + getWindowScrollBarX(element),
    y
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width2 = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height2 = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle$1(body || html).direction === "rtl") {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width2;
  }
  return {
    width: width2,
    height: height2,
    x,
    y
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$1(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node2) {
  if (["html", "body", "#document"].indexOf(getNodeName(node2)) >= 0) {
    return node2.ownerDocument.body;
  }
  if (isHTMLElement$1(node2) && isScrollParent(node2)) {
    return node2;
  }
  return getScrollParent(getParentNode(node2));
}
function listScrollParents(element, list2) {
  var _element$ownerDocumen;
  if (list2 === void 0) {
    list2 = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list2.concat(target);
  return isBody ? updatedList : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode(target)))
  );
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement$1(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref) {
  var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding2 = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding2 !== "number" ? padding2 : expandToHashMap(padding2, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding2 = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding: padding2
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a, b) {
    return overflows[a] - overflows[b];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding2 = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding: padding2,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding: padding2
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i3) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i3).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i2 = numberOfChecks; _i2 > 0; _i2--) {
      var _ret = _loop(_i2);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
const flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state, name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
const hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref[0], distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
const offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(_ref) {
  var state = _ref.state, name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    placement: state.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding2 = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding: padding2,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min$1 = offset2 + overflow[mainSide];
    var max$1 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset2, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node2) {
  if (node2 === getWindow(node2) || !isHTMLElement$1(node2)) {
    return getWindowScroll(node2);
  } else {
    return getHTMLElementScroll(node2);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$2(rect.width) / element.offsetWidth || 1;
  var scaleY = round$2(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  var offsetParentIsScaled = isHTMLElement$1(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map2 = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map2.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map2.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce$1(fn3) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve2) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve2(fn3());
        });
      });
    }
    return pending;
  };
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn3 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn3 === "function") {
            state = fn3({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$1(function() {
        return new Promise(function(resolve2) {
          instance.forceUpdate();
          resolve2(state);
        });
      }),
      destroy: function destroy2() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref) {
        var name = _ref.name, _ref$options = _ref.options, options2 = _ref$options === void 0 ? {} : _ref$options, effect2 = _ref.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn3) {
        return fn3();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
function useSlotProps(parameters) {
  const {
    elementType,
    externalSlotProps,
    ownerState,
    skipResolvingSlotProps = false,
    ...other
  } = parameters;
  const resolvedComponentsProps = skipResolvingSlotProps ? {} : resolveComponentProps(externalSlotProps, ownerState);
  const {
    props: mergedProps,
    internalRef
  } = mergeSlotProps$1({
    ...other,
    externalSlotProps: resolvedComponentsProps
  });
  const ref2 = useForkRef(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
  const props = appendOwnerState(elementType, {
    ...mergedProps,
    ref: ref2
  }, ownerState);
  return props;
}
function isLayoutSupported() {
  return !(/jsdom|HappyDOM/.test(window.navigator.userAgent) || // TODO(v9): Remove the test environment check
  // eslint-disable-next-line mui/consistent-production-guard
  process.env.NODE_ENV === "test");
}
function getReactElementRef(element) {
  if (parseInt(reactExports.version, 10) >= 19) {
    return element?.props?.ref || null;
  }
  return element?.ref || null;
}
function getContainer$1(container) {
  return typeof container === "function" ? container() : container;
}
const Portal = /* @__PURE__ */ reactExports.forwardRef(function Portal2(props, forwardedRef) {
  const {
    children,
    container,
    disablePortal = false
  } = props;
  const [mountNode, setMountNode] = reactExports.useState(null);
  const handleRef = useForkRef(/* @__PURE__ */ reactExports.isValidElement(children) ? getReactElementRef(children) : null, forwardedRef);
  useEnhancedEffect(() => {
    if (!disablePortal) {
      setMountNode(getContainer$1(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect(() => {
    if (mountNode && !disablePortal) {
      setRef$1(forwardedRef, mountNode);
      return () => {
        setRef$1(forwardedRef, null);
      };
    }
    return void 0;
  }, [forwardedRef, mountNode, disablePortal]);
  if (disablePortal) {
    if (/* @__PURE__ */ reactExports.isValidElement(children)) {
      const newProps = {
        ref: handleRef
      };
      return /* @__PURE__ */ reactExports.cloneElement(children, newProps);
    }
    return children;
  }
  return mountNode ? /* @__PURE__ */ reactDomExports.createPortal(children, mountNode) : mountNode;
});
process.env.NODE_ENV !== "production" ? Portal.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool
} : void 0;
if (process.env.NODE_ENV !== "production") {
  Portal["propTypes"] = exactProp(Portal.propTypes);
}
function getPopperUtilityClass(slot) {
  return generateUtilityClass("MuiPopper", slot);
}
generateUtilityClasses("MuiPopper", ["root"]);
function flipPlacement(placement, direction) {
  if (direction === "ltr") {
    return placement;
  }
  switch (placement) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return placement;
  }
}
function resolveAnchorEl$1(anchorEl) {
  return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function isHTMLElement(element) {
  return element.nodeType !== void 0;
}
function isVirtualElement(element) {
  return !isHTMLElement(element);
}
const useUtilityClasses$17 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getPopperUtilityClass, classes);
};
const defaultPopperOptions = {};
const PopperTooltip = /* @__PURE__ */ reactExports.forwardRef(function PopperTooltip2(props, forwardedRef) {
  const {
    anchorEl,
    children,
    direction,
    disablePortal,
    modifiers,
    open: open2,
    placement: initialPlacement,
    popperOptions,
    popperRef: popperRefProp,
    slotProps = {},
    slots = {},
    TransitionProps,
    // @ts-ignore internal logic
    ownerState: ownerStateProp,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other
  } = props;
  const tooltipRef = reactExports.useRef(null);
  const ownRef = useForkRef(tooltipRef, forwardedRef);
  const popperRef = reactExports.useRef(null);
  const handlePopperRef = useForkRef(popperRef, popperRefProp);
  const handlePopperRefRef = reactExports.useRef(handlePopperRef);
  useEnhancedEffect(() => {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  reactExports.useImperativeHandle(popperRefProp, () => popperRef.current, []);
  const rtlPlacement = flipPlacement(initialPlacement, direction);
  const [placement, setPlacement] = reactExports.useState(rtlPlacement);
  const [resolvedAnchorElement, setResolvedAnchorElement] = reactExports.useState(resolveAnchorEl$1(anchorEl));
  reactExports.useEffect(() => {
    if (popperRef.current) {
      popperRef.current.forceUpdate();
    }
  });
  reactExports.useEffect(() => {
    if (anchorEl) {
      setResolvedAnchorElement(resolveAnchorEl$1(anchorEl));
    }
  }, [anchorEl]);
  useEnhancedEffect(() => {
    if (!resolvedAnchorElement || !open2) {
      return void 0;
    }
    const handlePopperUpdate = (data) => {
      setPlacement(data.placement);
    };
    if (process.env.NODE_ENV !== "production") {
      if (resolvedAnchorElement && isHTMLElement(resolvedAnchorElement) && resolvedAnchorElement.nodeType === 1) {
        const box = resolvedAnchorElement.getBoundingClientRect();
        if (isLayoutSupported() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join("\n"));
        }
      }
    }
    let popperModifiers = [{
      name: "preventOverflow",
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: "flip",
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: "onUpdate",
      enabled: true,
      phase: "afterWrite",
      fn: ({
        state
      }) => {
        handlePopperUpdate(state);
      }
    }];
    if (modifiers != null) {
      popperModifiers = popperModifiers.concat(modifiers);
    }
    if (popperOptions && popperOptions.modifiers != null) {
      popperModifiers = popperModifiers.concat(popperOptions.modifiers);
    }
    const popper2 = createPopper(resolvedAnchorElement, tooltipRef.current, {
      placement: rtlPlacement,
      ...popperOptions,
      modifiers: popperModifiers
    });
    handlePopperRefRef.current(popper2);
    const popperElement = tooltipRef.current;
    return () => {
      if (popperElement) {
        const {
          style: style2
        } = popperElement;
        const position2 = style2.position;
        const top2 = style2.top;
        const left2 = style2.left;
        const transform2 = style2.transform;
        popper2.destroy();
        style2.position = position2;
        style2.top = top2;
        style2.left = left2;
        style2.transform = transform2;
      } else {
        popper2.destroy();
      }
      handlePopperRefRef.current(null);
    };
  }, [resolvedAnchorElement, disablePortal, modifiers, open2, popperOptions, rtlPlacement]);
  const childProps = {
    placement
  };
  if (TransitionProps !== null) {
    childProps.TransitionProps = TransitionProps;
  }
  const classes = useUtilityClasses$17(props);
  const Root = slots.root ?? "div";
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    additionalProps: {
      role: "tooltip",
      ref: ownRef
    },
    ownerState: props,
    className: classes.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Root, {
    ...rootProps,
    children: typeof children === "function" ? children(childProps) : children
  });
});
const Popper$1 = /* @__PURE__ */ reactExports.forwardRef(function Popper(props, forwardedRef) {
  const {
    anchorEl,
    children,
    container: containerProp,
    direction = "ltr",
    disablePortal = false,
    keepMounted = false,
    modifiers,
    open: open2,
    placement = "bottom",
    popperOptions = defaultPopperOptions,
    popperRef,
    style: style2,
    transition = false,
    slotProps = {},
    slots = {},
    ...other
  } = props;
  const [exited, setExited] = reactExports.useState(true);
  const handleEnter = () => {
    setExited(false);
  };
  const handleExited = () => {
    setExited(true);
  };
  if (!keepMounted && !open2 && (!transition || exited)) {
    return null;
  }
  let container;
  if (containerProp) {
    container = containerProp;
  } else if (anchorEl) {
    const resolvedAnchorEl = resolveAnchorEl$1(anchorEl);
    container = resolvedAnchorEl && isHTMLElement(resolvedAnchorEl) ? ownerDocument(resolvedAnchorEl).body : ownerDocument(null).body;
  }
  const display = !open2 && keepMounted && (!transition || exited) ? "none" : void 0;
  const transitionProps = transition ? {
    in: open2,
    onEnter: handleEnter,
    onExited: handleExited
  } : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    disablePortal,
    container,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopperTooltip, {
      anchorEl,
      direction,
      disablePortal,
      modifiers,
      ref: forwardedRef,
      open: transition ? !exited : open2,
      placement,
      popperOptions,
      popperRef,
      slotProps,
      slots,
      ...other,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display,
        ...style2
      },
      TransitionProps: transitionProps,
      children
    })
  });
});
process.env.NODE_ENV !== "production" ? Popper$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), (props) => {
    if (props.open) {
      const resolvedAnchorEl = resolveAnchorEl$1(props.anchorEl);
      if (resolvedAnchorEl && isHTMLElement(resolvedAnchorEl) && resolvedAnchorEl.nodeType === 1) {
        const box = resolvedAnchorEl.getBoundingClientRect();
        if (process.env.NODE_ENV !== "production") {
          if (isLayoutSupported() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
            return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join("\n"));
          }
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.getBoundingClientRect !== "function" || isVirtualElement(resolvedAnchorEl) && resolvedAnchorEl.contextElement != null && resolvedAnchorEl.contextElement.nodeType !== 1) {
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join("\n"));
      }
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: PropTypes.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
} : void 0;
const PopperRoot = styled(Popper$1, {
  name: "MuiPopper",
  slot: "Root"
})({});
const Popper2 = /* @__PURE__ */ reactExports.forwardRef(function Popper3(inProps, ref2) {
  const isRtl = useRtl();
  const props = useDefaultProps({
    props: inProps,
    name: "MuiPopper"
  });
  const {
    anchorEl,
    component,
    components,
    componentsProps,
    container,
    disablePortal,
    keepMounted,
    modifiers,
    open: open2,
    placement,
    popperOptions,
    popperRef,
    transition,
    slots,
    slotProps,
    ...other
  } = props;
  const RootComponent = slots?.root ?? components?.Root;
  const otherProps = {
    anchorEl,
    container,
    disablePortal,
    keepMounted,
    modifiers,
    open: open2,
    placement,
    popperOptions,
    popperRef,
    transition,
    ...other
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PopperRoot, {
    as: component,
    direction: isRtl ? "rtl" : "ltr",
    slots: {
      root: RootComponent
    },
    slotProps: slotProps ?? componentsProps,
    ...otherProps,
    ref: ref2
  });
});
process.env.NODE_ENV !== "production" ? Popper2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
} : void 0;
function getListSubheaderUtilityClass(slot) {
  return generateUtilityClass("MuiListSubheader", slot);
}
generateUtilityClasses("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const useUtilityClasses$16 = (ownerState) => {
  const {
    classes,
    color: color2,
    disableGutters,
    inset,
    disableSticky
  } = ownerState;
  const slots = {
    root: ["root", color2 !== "default" && `color${capitalize$2(color2)}`, !disableGutters && "gutters", inset && "inset", !disableSticky && "sticky"]
  };
  return composeClasses(slots, getListSubheaderUtilityClass, classes);
};
const ListSubheaderRoot = styled("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.color !== "default" && styles2[`color${capitalize$2(ownerState.color)}`], !ownerState.disableGutters && styles2.gutters, ownerState.inset && styles2.inset, !ownerState.disableSticky && styles2.sticky];
  }
})(memoTheme(({
  theme
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (theme.vars || theme).palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (theme.vars || theme).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: ({
      ownerState
    }) => !ownerState.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.inset,
    style: {
      paddingLeft: 72
    }
  }, {
    props: ({
      ownerState
    }) => !ownerState.disableSticky,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (theme.vars || theme).palette.background.paper
    }
  }]
})));
const ListSubheader = /* @__PURE__ */ reactExports.forwardRef(function ListSubheader2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiListSubheader"
  });
  const {
    className,
    color: color2 = "default",
    component = "li",
    disableGutters = false,
    disableSticky = false,
    inset = false,
    ...other
  } = props;
  const ownerState = {
    ...props,
    color: color2,
    component,
    disableGutters,
    disableSticky,
    inset
  };
  const classes = useUtilityClasses$16(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListSubheaderRoot, {
    as: component,
    className: clsx(classes.root, className),
    ref: ref2,
    ownerState,
    ...other
  });
});
if (ListSubheader) {
  ListSubheader.muiSkipListHighlight = true;
}
process.env.NODE_ENV !== "production" ? ListSubheader.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: PropTypes.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: PropTypes.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
const CancelIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function getChipUtilityClass(slot) {
  return generateUtilityClass("MuiChip", slot);
}
const chipClasses = generateUtilityClasses("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]);
const useUtilityClasses$15 = (ownerState) => {
  const {
    classes,
    disabled,
    size,
    color: color2,
    iconColor,
    onDelete,
    clickable,
    variant
  } = ownerState;
  const slots = {
    root: ["root", variant, disabled && "disabled", `size${capitalize$2(size)}`, `color${capitalize$2(color2)}`, clickable && "clickable", clickable && `clickableColor${capitalize$2(color2)}`, onDelete && "deletable", onDelete && `deletableColor${capitalize$2(color2)}`, `${variant}${capitalize$2(color2)}`],
    label: ["label", `label${capitalize$2(size)}`],
    avatar: ["avatar", `avatar${capitalize$2(size)}`, `avatarColor${capitalize$2(color2)}`],
    icon: ["icon", `icon${capitalize$2(size)}`, `iconColor${capitalize$2(iconColor)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${capitalize$2(size)}`, `deleteIconColor${capitalize$2(color2)}`, `deleteIcon${capitalize$2(variant)}Color${capitalize$2(color2)}`]
  };
  return composeClasses(slots, getChipUtilityClass, classes);
};
const ChipRoot = styled("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    const {
      color: color2,
      iconColor,
      clickable,
      onDelete,
      size,
      variant
    } = ownerState;
    return [{
      [`& .${chipClasses.avatar}`]: styles2.avatar
    }, {
      [`& .${chipClasses.avatar}`]: styles2[`avatar${capitalize$2(size)}`]
    }, {
      [`& .${chipClasses.avatar}`]: styles2[`avatarColor${capitalize$2(color2)}`]
    }, {
      [`& .${chipClasses.icon}`]: styles2.icon
    }, {
      [`& .${chipClasses.icon}`]: styles2[`icon${capitalize$2(size)}`]
    }, {
      [`& .${chipClasses.icon}`]: styles2[`iconColor${capitalize$2(iconColor)}`]
    }, {
      [`& .${chipClasses.deleteIcon}`]: styles2.deleteIcon
    }, {
      [`& .${chipClasses.deleteIcon}`]: styles2[`deleteIcon${capitalize$2(size)}`]
    }, {
      [`& .${chipClasses.deleteIcon}`]: styles2[`deleteIconColor${capitalize$2(color2)}`]
    }, {
      [`& .${chipClasses.deleteIcon}`]: styles2[`deleteIcon${capitalize$2(variant)}Color${capitalize$2(color2)}`]
    }, styles2.root, styles2[`size${capitalize$2(size)}`], styles2[`color${capitalize$2(color2)}`], clickable && styles2.clickable, clickable && color2 !== "default" && styles2[`clickableColor${capitalize$2(color2)}`], onDelete && styles2.deletable, onDelete && color2 !== "default" && styles2[`deletableColor${capitalize$2(color2)}`], styles2[variant], styles2[`${variant}${capitalize$2(color2)}`]];
  }
})(memoTheme(({
  theme
}) => {
  const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    lineHeight: 1.5,
    color: (theme.vars || theme).palette.text.primary,
    backgroundColor: (theme.vars || theme).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: theme.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${chipClasses.disabled}`]: {
      opacity: (theme.vars || theme).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${chipClasses.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
      fontSize: theme.typography.pxToRem(12)
    },
    [`& .${chipClasses.avatarColorPrimary}`]: {
      color: (theme.vars || theme).palette.primary.contrastText,
      backgroundColor: (theme.vars || theme).palette.primary.dark
    },
    [`& .${chipClasses.avatarColorSecondary}`]: {
      color: (theme.vars || theme).palette.secondary.contrastText,
      backgroundColor: (theme.vars || theme).palette.secondary.dark
    },
    [`& .${chipClasses.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: theme.typography.pxToRem(10)
    },
    [`& .${chipClasses.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${chipClasses.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: theme.alpha((theme.vars || theme).palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${chipClasses.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${chipClasses.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["contrastText"])).map(([color2]) => {
      return {
        props: {
          color: color2
        },
        style: {
          backgroundColor: (theme.vars || theme).palette[color2].main,
          color: (theme.vars || theme).palette[color2].contrastText,
          [`& .${chipClasses.deleteIcon}`]: {
            color: theme.alpha((theme.vars || theme).palette[color2].contrastText, 0.7),
            "&:hover, &:active": {
              color: (theme.vars || theme).palette[color2].contrastText
            }
          }
        }
      };
    }), {
      props: (props) => props.iconColor === props.color,
      style: {
        [`& .${chipClasses.icon}`]: {
          color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }
      }
    }, {
      props: (props) => props.iconColor === props.color && props.color !== "default",
      style: {
        [`& .${chipClasses.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: true
      },
      style: {
        [`&.${chipClasses.focusVisible}`]: {
          backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
        }
      }
    }, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["dark"])).map(([color2]) => {
      return {
        props: {
          color: color2,
          onDelete: true
        },
        style: {
          [`&.${chipClasses.focusVisible}`]: {
            background: (theme.vars || theme).palette[color2].dark
          }
        }
      };
    }), {
      props: {
        clickable: true
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
        },
        [`&.${chipClasses.focusVisible}`]: {
          backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
        },
        "&:active": {
          boxShadow: (theme.vars || theme).shadows[1]
        }
      }
    }, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["dark"])).map(([color2]) => ({
      props: {
        color: color2,
        clickable: true
      },
      style: {
        [`&:hover, &.${chipClasses.focusVisible}`]: {
          backgroundColor: (theme.vars || theme).palette[color2].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${chipClasses.clickable}:hover`]: {
          backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${chipClasses.focusVisible}`]: {
          backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${chipClasses.avatar}`]: {
          marginLeft: 4
        },
        [`& .${chipClasses.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${chipClasses.icon}`]: {
          marginLeft: 4
        },
        [`& .${chipClasses.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${chipClasses.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${chipClasses.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color2]) => ({
      props: {
        variant: "outlined",
        color: color2
      },
      style: {
        color: (theme.vars || theme).palette[color2].main,
        border: `1px solid ${theme.alpha((theme.vars || theme).palette[color2].main, 0.7)}`,
        [`&.${chipClasses.clickable}:hover`]: {
          backgroundColor: theme.alpha((theme.vars || theme).palette[color2].main, (theme.vars || theme).palette.action.hoverOpacity)
        },
        [`&.${chipClasses.focusVisible}`]: {
          backgroundColor: theme.alpha((theme.vars || theme).palette[color2].main, (theme.vars || theme).palette.action.focusOpacity)
        },
        [`& .${chipClasses.deleteIcon}`]: {
          color: theme.alpha((theme.vars || theme).palette[color2].main, 0.7),
          "&:hover, &:active": {
            color: (theme.vars || theme).palette[color2].main
          }
        }
      }
    }))]
  };
}));
const ChipLabel = styled("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    const {
      size
    } = ownerState;
    return [styles2.label, styles2[`label${capitalize$2(size)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
const Chip = /* @__PURE__ */ reactExports.forwardRef(function Chip2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiChip"
  });
  const {
    avatar: avatarProp,
    className,
    clickable: clickableProp,
    color: color2 = "default",
    component: ComponentProp,
    deleteIcon: deleteIconProp,
    disabled = false,
    icon: iconProp,
    label,
    onClick,
    onDelete,
    onKeyDown,
    onKeyUp,
    size = "medium",
    variant = "filled",
    tabIndex,
    skipFocusWhenDisabled = false,
    // TODO v6: Rename to `focusableWhenDisabled`.
    slots = {},
    slotProps = {},
    ...other
  } = props;
  const chipRef = reactExports.useRef(null);
  const handleRef = useForkRef(chipRef, ref2);
  const handleDeleteIconClick = (event2) => {
    event2.stopPropagation();
    onDelete(event2);
  };
  const handleKeyDown = (event2) => {
    if (event2.currentTarget === event2.target && isDeleteKeyboardEvent(event2)) {
      event2.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event2);
    }
  };
  const handleKeyUp = (event2) => {
    if (event2.currentTarget === event2.target) {
      if (onDelete && isDeleteKeyboardEvent(event2)) {
        onDelete(event2);
      }
    }
    if (onKeyUp) {
      onKeyUp(event2);
    }
  };
  const clickable = clickableProp !== false && onClick ? true : clickableProp;
  const component = clickable || onDelete ? ButtonBase : ComponentProp || "div";
  const ownerState = {
    ...props,
    component,
    disabled,
    size,
    color: color2,
    iconColor: /* @__PURE__ */ reactExports.isValidElement(iconProp) ? iconProp.props.color || color2 : color2,
    onDelete: !!onDelete,
    clickable,
    variant
  };
  const classes = useUtilityClasses$15(ownerState);
  const moreProps = component === ButtonBase ? {
    component: ComponentProp || "div",
    focusVisibleClassName: classes.focusVisible,
    ...onDelete && {
      disableRipple: true
    }
  } : {};
  let deleteIcon = null;
  if (onDelete) {
    deleteIcon = deleteIconProp && /* @__PURE__ */ reactExports.isValidElement(deleteIconProp) ? /* @__PURE__ */ reactExports.cloneElement(deleteIconProp, {
      className: clsx(deleteIconProp.props.className, classes.deleteIcon),
      onClick: handleDeleteIconClick
    }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CancelIcon, {
      className: classes.deleteIcon,
      onClick: handleDeleteIconClick
    });
  }
  let avatar = null;
  if (avatarProp && /* @__PURE__ */ reactExports.isValidElement(avatarProp)) {
    avatar = /* @__PURE__ */ reactExports.cloneElement(avatarProp, {
      className: clsx(classes.avatar, avatarProp.props.className)
    });
  }
  let icon = null;
  if (iconProp && /* @__PURE__ */ reactExports.isValidElement(iconProp)) {
    icon = /* @__PURE__ */ reactExports.cloneElement(iconProp, {
      className: clsx(classes.icon, iconProp.props.className)
    });
  }
  if (process.env.NODE_ENV !== "production") {
    if (avatar && icon) {
      console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one.");
    }
  }
  const externalForwardedProps = {
    slots,
    slotProps
  };
  const [RootSlot, rootProps] = useSlot("root", {
    elementType: ChipRoot,
    externalForwardedProps: {
      ...externalForwardedProps,
      ...other
    },
    ownerState,
    // The `component` prop is preserved because `Chip` relies on it for internal logic. If `shouldForwardComponentProp` were `false`, `useSlot` would remove the `component` prop, potentially breaking the component's behavior.
    shouldForwardComponentProp: true,
    ref: handleRef,
    className: clsx(classes.root, className),
    additionalProps: {
      disabled: clickable && disabled ? true : void 0,
      tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
      ...moreProps
    },
    getSlotProps: (handlers) => ({
      ...handlers,
      onClick: (event2) => {
        handlers.onClick?.(event2);
        onClick?.(event2);
      },
      onKeyDown: (event2) => {
        handlers.onKeyDown?.(event2);
        handleKeyDown(event2);
      },
      onKeyUp: (event2) => {
        handlers.onKeyUp?.(event2);
        handleKeyUp(event2);
      }
    })
  });
  const [LabelSlot, labelProps] = useSlot("label", {
    elementType: ChipLabel,
    externalForwardedProps,
    ownerState,
    className: classes.label
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(RootSlot, {
    as: component,
    ...rootProps,
    children: [avatar || icon, /* @__PURE__ */ jsxRuntimeExports.jsx(LabelSlot, {
      ...labelProps,
      children: label
    }), deleteIcon]
  });
});
process.env.NODE_ENV !== "production" ? Chip.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: PropTypes.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: PropTypes.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Icon element.
   */
  icon: PropTypes.element,
  /**
   * The content of the component.
   */
  label: PropTypes.node,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    label: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  tabIndex: PropTypes.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["filled", "outlined"]), PropTypes.string])
} : void 0;
function getStyleValue(value) {
  return parseInt(value, 10) || 0;
}
const styles$3 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function isObjectEmpty(object) {
  for (const _ in object) {
    return false;
  }
  return true;
}
function isEmpty$1(obj) {
  return isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
const TextareaAutosize = /* @__PURE__ */ reactExports.forwardRef(function TextareaAutosize2(props, forwardedRef) {
  const {
    onChange,
    maxRows,
    minRows = 1,
    style: style2,
    value,
    ...other
  } = props;
  const {
    current: isControlled
  } = reactExports.useRef(value != null);
  const textareaRef = reactExports.useRef(null);
  const handleRef = useForkRef(forwardedRef, textareaRef);
  const heightRef = reactExports.useRef(null);
  const hiddenTextareaRef = reactExports.useRef(null);
  const calculateTextareaStyles = reactExports.useCallback(() => {
    const textarea = textareaRef.current;
    const hiddenTextarea = hiddenTextareaRef.current;
    if (!textarea || !hiddenTextarea) {
      return void 0;
    }
    const containerWindow = ownerWindow(textarea);
    const computedStyle = containerWindow.getComputedStyle(textarea);
    if (computedStyle.width === "0px") {
      return {
        outerHeightStyle: 0,
        overflowing: false
      };
    }
    hiddenTextarea.style.width = computedStyle.width;
    hiddenTextarea.value = textarea.value || props.placeholder || "x";
    if (hiddenTextarea.value.slice(-1) === "\n") {
      hiddenTextarea.value += " ";
    }
    const boxSizing2 = computedStyle.boxSizing;
    const padding2 = getStyleValue(computedStyle.paddingBottom) + getStyleValue(computedStyle.paddingTop);
    const border2 = getStyleValue(computedStyle.borderBottomWidth) + getStyleValue(computedStyle.borderTopWidth);
    const innerHeight = hiddenTextarea.scrollHeight;
    hiddenTextarea.value = "x";
    const singleRowHeight = hiddenTextarea.scrollHeight;
    let outerHeight = innerHeight;
    if (minRows) {
      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
    }
    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }
    outerHeight = Math.max(outerHeight, singleRowHeight);
    const outerHeightStyle = outerHeight + (boxSizing2 === "border-box" ? padding2 + border2 : 0);
    const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
    return {
      outerHeightStyle,
      overflowing
    };
  }, [maxRows, minRows, props.placeholder]);
  const didHeightChange = useEventCallback(() => {
    const textarea = textareaRef.current;
    const textareaStyles = calculateTextareaStyles();
    if (!textarea || !textareaStyles || isEmpty$1(textareaStyles)) {
      return false;
    }
    const outerHeightStyle = textareaStyles.outerHeightStyle;
    return heightRef.current != null && heightRef.current !== outerHeightStyle;
  });
  const syncHeight = reactExports.useCallback(() => {
    const textarea = textareaRef.current;
    const textareaStyles = calculateTextareaStyles();
    if (!textarea || !textareaStyles || isEmpty$1(textareaStyles)) {
      return;
    }
    const outerHeightStyle = textareaStyles.outerHeightStyle;
    if (heightRef.current !== outerHeightStyle) {
      heightRef.current = outerHeightStyle;
      textarea.style.height = `${outerHeightStyle}px`;
    }
    textarea.style.overflow = textareaStyles.overflowing ? "hidden" : "";
  }, [calculateTextareaStyles]);
  const frameRef = reactExports.useRef(-1);
  useEnhancedEffect(() => {
    const debouncedHandleResize = debounce$2(syncHeight);
    const textarea = textareaRef?.current;
    if (!textarea) {
      return void 0;
    }
    const containerWindow = ownerWindow(textarea);
    containerWindow.addEventListener("resize", debouncedHandleResize);
    let resizeObserver;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(() => {
        if (didHeightChange()) {
          resizeObserver.unobserve(textarea);
          cancelAnimationFrame(frameRef.current);
          syncHeight();
          frameRef.current = requestAnimationFrame(() => {
            resizeObserver.observe(textarea);
          });
        }
      });
      resizeObserver.observe(textarea);
    }
    return () => {
      debouncedHandleResize.clear();
      cancelAnimationFrame(frameRef.current);
      containerWindow.removeEventListener("resize", debouncedHandleResize);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [calculateTextareaStyles, syncHeight, didHeightChange]);
  useEnhancedEffect(() => {
    syncHeight();
  });
  const handleChange = (event2) => {
    if (!isControlled) {
      syncHeight();
    }
    const textarea = event2.target;
    const countOfCharacters = textarea.value.length;
    const isLastCharacterNewLine = textarea.value.endsWith("\n");
    const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
    if (isLastCharacterNewLine && isEndOfTheLine) {
      textarea.setSelectionRange(countOfCharacters, countOfCharacters);
    }
    if (onChange) {
      onChange(event2);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("textarea", {
      value,
      onChange: handleChange,
      ref: handleRef,
      rows: minRows,
      style: style2,
      ...other
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", {
      "aria-hidden": true,
      className: props.className,
      readOnly: true,
      ref: hiddenTextareaRef,
      tabIndex: -1,
      style: {
        ...styles$3.shadow,
        ...style2,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
process.env.NODE_ENV !== "production" ? TextareaAutosize.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  placeholder: PropTypes.string,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
} : void 0;
function formControlState({
  props,
  states,
  muiFormControl
}) {
  return states.reduce((acc, state) => {
    acc[state] = props[state];
    if (muiFormControl) {
      if (typeof props[state] === "undefined") {
        acc[state] = muiFormControl[state];
      }
    }
    return acc;
  }, {});
}
const FormControlContext = /* @__PURE__ */ reactExports.createContext(void 0);
if (process.env.NODE_ENV !== "production") {
  FormControlContext.displayName = "FormControlContext";
}
function useFormControl() {
  return reactExports.useContext(FormControlContext);
}
function activeElement(doc) {
  let element = doc.activeElement;
  while (element?.shadowRoot?.activeElement != null) {
    element = element.shadowRoot.activeElement;
  }
  return element;
}
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
}
function isFilled(obj, SSR = false) {
  return obj && (hasValue(obj.value) && obj.value !== "" || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== "");
}
function isAdornedStart(obj) {
  return obj.startAdornment;
}
function getInputBaseUtilityClass(slot) {
  return generateUtilityClass("MuiInputBase", slot);
}
const inputBaseClasses = generateUtilityClasses("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var _InputGlobalStyles;
const MUI_AUTO_FILL = "mui-auto-fill";
const MUI_AUTO_FILL_CANCEL = "mui-auto-fill-cancel";
const rootOverridesResolver = (props, styles2) => {
  const {
    ownerState
  } = props;
  return [styles2.root, ownerState.formControl && styles2.formControl, ownerState.startAdornment && styles2.adornedStart, ownerState.endAdornment && styles2.adornedEnd, ownerState.error && styles2.error, ownerState.size === "small" && styles2.sizeSmall, ownerState.multiline && styles2.multiline, ownerState.color && styles2[`color${capitalize$2(ownerState.color)}`], ownerState.fullWidth && styles2.fullWidth, ownerState.hiddenLabel && styles2.hiddenLabel];
};
const inputOverridesResolver = (props, styles2) => {
  const {
    ownerState
  } = props;
  return [styles2.input, ownerState.size === "small" && styles2.inputSizeSmall, ownerState.multiline && styles2.inputMultiline, ownerState.type === "search" && styles2.inputTypeSearch, ownerState.startAdornment && styles2.inputAdornedStart, ownerState.endAdornment && styles2.inputAdornedEnd, ownerState.hiddenLabel && styles2.inputHiddenLabel];
};
const useUtilityClasses$14 = (ownerState) => {
  const {
    classes,
    color: color2,
    disabled,
    error,
    endAdornment,
    focused,
    formControl,
    fullWidth,
    hiddenLabel,
    multiline,
    readOnly,
    size,
    startAdornment,
    type
  } = ownerState;
  const slots = {
    root: ["root", `color${capitalize$2(color2)}`, disabled && "disabled", error && "error", fullWidth && "fullWidth", focused && "focused", formControl && "formControl", size && size !== "medium" && `size${capitalize$2(size)}`, multiline && "multiline", startAdornment && "adornedStart", endAdornment && "adornedEnd", hiddenLabel && "hiddenLabel", readOnly && "readOnly"],
    input: ["input", disabled && "disabled", type === "search" && "inputTypeSearch", multiline && "inputMultiline", size === "small" && "inputSizeSmall", hiddenLabel && "inputHiddenLabel", startAdornment && "inputAdornedStart", endAdornment && "inputAdornedEnd", readOnly && "readOnly"]
  };
  return composeClasses(slots, getInputBaseUtilityClass, classes);
};
const InputBaseRoot = styled("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(memoTheme(({
  theme
}) => ({
  ...theme.typography.body1,
  color: (theme.vars || theme).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${inputBaseClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState
    }) => ownerState.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState,
      size
    }) => ownerState.multiline && size === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.fullWidth,
    style: {
      width: "100%"
    }
  }]
})));
const InputBaseInput = styled("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(memoTheme(({
  theme
}) => {
  const light2 = theme.palette.mode === "light";
  const placeholder = {
    color: "currentColor",
    ...theme.vars ? {
      opacity: theme.vars.opacity.inputPlaceholder
    } : {
      opacity: light2 ? 0.42 : 0.5
    },
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.shorter
    })
  };
  const placeholderHidden = {
    opacity: "0 !important"
  };
  const placeholderVisible = theme.vars ? {
    opacity: theme.vars.opacity.inputPlaceholder
  } : {
    opacity: light2 ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": placeholder,
    "&::-moz-placeholder": placeholder,
    // Firefox 19+
    "&::-ms-input-placeholder": placeholder,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${inputBaseClasses.formControl} &`]: {
      "&::-webkit-input-placeholder": placeholderHidden,
      "&::-moz-placeholder": placeholderHidden,
      // Firefox 19+
      "&::-ms-input-placeholder": placeholderHidden,
      // Edge
      "&:focus::-webkit-input-placeholder": placeholderVisible,
      "&:focus::-moz-placeholder": placeholderVisible,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": placeholderVisible
      // Edge
    },
    [`&.${inputBaseClasses.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (theme.vars || theme).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState
      }) => !ownerState.disableInjectingGlobalStyles,
      style: {
        animationName: MUI_AUTO_FILL_CANCEL,
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: MUI_AUTO_FILL
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
}));
const InputGlobalStyles = globalCss({
  // Keep keyframes non-empty for Emotion production builds. Animation properties are ignored
  // inside keyframes, avoiding the visible display animation triggered by Chrome 117+.
  [`@keyframes ${MUI_AUTO_FILL}`]: {
    from: {
      animationName: MUI_AUTO_FILL
    }
  },
  [`@keyframes ${MUI_AUTO_FILL_CANCEL}`]: {
    from: {
      animationName: MUI_AUTO_FILL_CANCEL
    }
  }
});
const InputBase = /* @__PURE__ */ reactExports.forwardRef(function InputBase2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiInputBase"
  });
  const {
    "aria-describedby": ariaDescribedby,
    autoComplete,
    autoFocus,
    className,
    color: color2,
    components = {},
    componentsProps = {},
    defaultValue,
    disabled,
    disableInjectingGlobalStyles,
    endAdornment,
    error,
    fullWidth = false,
    id,
    inputComponent = "input",
    inputProps: inputPropsProp = {},
    inputRef: inputRefProp,
    margin: margin2,
    maxRows,
    minRows,
    multiline = false,
    name,
    onBlur,
    onChange,
    onClick,
    onFocus,
    onKeyDown,
    onKeyUp,
    placeholder,
    readOnly,
    renderSuffix,
    rows,
    size,
    slotProps = {},
    slots = {},
    startAdornment,
    type = "text",
    value: valueProp,
    ...other
  } = props;
  const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
  const {
    current: isControlled
  } = reactExports.useRef(value != null);
  const inputRef = reactExports.useRef();
  const handleInputRefWarning = reactExports.useCallback((instance) => {
    if (process.env.NODE_ENV !== "production") {
      if (instance && instance.nodeName !== "INPUT" && !instance.focus) {
        console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join("\n"));
      }
    }
  }, []);
  const handleInputRef = useForkRef(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
  const [focused, setFocused] = reactExports.useState(false);
  const muiFormControl = useFormControl();
  if (process.env.NODE_ENV !== "production") {
    reactExports.useEffect(() => {
      if (muiFormControl) {
        return muiFormControl.registerEffect();
      }
      return void 0;
    }, [muiFormControl]);
  }
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused;
  reactExports.useEffect(() => {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);
      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  const onFilled = muiFormControl && muiFormControl.onFilled;
  const onEmpty = muiFormControl && muiFormControl.onEmpty;
  const checkDirty = reactExports.useCallback((obj) => {
    if (isFilled(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  useEnhancedEffect(() => {
    if (isControlled) {
      checkDirty({
        value
      });
    }
  }, [value, checkDirty, isControlled]);
  useEnhancedEffect(() => {
    if (!autoFocus) {
      return;
    }
    const input = inputRef.current;
    if (!input) {
      return;
    }
    const doc = ownerDocument(input);
    const activeElement$1 = activeElement(doc);
    const noElementFocused = activeElement$1 == null || activeElement$1 === doc.body || activeElement$1 === doc.documentElement;
    if (input === activeElement$1) {
      if (muiFormControl && muiFormControl.onFocus) {
        muiFormControl.onFocus();
      } else {
        setFocused(true);
      }
    } else if (noElementFocused) {
      input.focus();
    }
  }, [autoFocus]);
  const handleFocus = (event2) => {
    if (onFocus) {
      onFocus(event2);
    }
    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event2);
    }
    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event2);
    } else {
      setFocused(true);
    }
  };
  const handleBlur = (event2) => {
    if (onBlur) {
      onBlur(event2);
    }
    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event2);
    }
    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event2);
    } else {
      setFocused(false);
    }
  };
  const handleChange = (event2, ...args) => {
    if (!isControlled) {
      const element = event2.target || inputRef.current;
      if (element == null) {
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : formatMuiErrorMessage(1));
      }
      checkDirty({
        value: element.value
      });
    }
    if (inputPropsProp.onChange) {
      inputPropsProp.onChange(event2, ...args);
    }
    if (onChange) {
      onChange(event2, ...args);
    }
  };
  reactExports.useEffect(() => {
    checkDirty(inputRef.current);
  }, []);
  const handleClick = (event2) => {
    if (inputRef.current && event2.currentTarget === event2.target) {
      inputRef.current.focus();
    }
    if (onClick) {
      onClick(event2);
    }
  };
  let InputComponent = inputComponent;
  let inputProps = inputPropsProp;
  if (multiline && InputComponent === "input") {
    if (rows) {
      if (process.env.NODE_ENV !== "production") {
        if (minRows || maxRows) {
          console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set.");
        }
      }
      inputProps = {
        type: void 0,
        minRows: rows,
        maxRows: rows,
        ...inputProps
      };
    } else {
      inputProps = {
        type: void 0,
        maxRows,
        minRows,
        ...inputProps
      };
    }
    InputComponent = TextareaAutosize;
  }
  const handleAutoFill = (event2) => {
    checkDirty(event2.animationName === MUI_AUTO_FILL_CANCEL ? inputRef.current : {
      value: "x"
    });
  };
  reactExports.useEffect(() => {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  const ownerState = {
    ...props,
    color: fcs.color || "primary",
    disabled: fcs.disabled,
    endAdornment,
    error: fcs.error,
    focused: fcs.focused,
    formControl: muiFormControl,
    fullWidth,
    hiddenLabel: fcs.hiddenLabel,
    multiline,
    size: fcs.size,
    startAdornment,
    type
  };
  const classes = useUtilityClasses$14(ownerState);
  const Root = slots.root || components.Root || InputBaseRoot;
  const rootProps = slotProps.root || componentsProps.root || {};
  const Input3 = slots.input || components.Input || InputBaseInput;
  inputProps = {
    ...inputProps,
    ...slotProps.input ?? componentsProps.input
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
    children: [!disableInjectingGlobalStyles && typeof InputGlobalStyles === "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (_InputGlobalStyles || (_InputGlobalStyles = /* @__PURE__ */ jsxRuntimeExports.jsx(InputGlobalStyles, {}))), /* @__PURE__ */ jsxRuntimeExports.jsxs(Root, {
      ...rootProps,
      ref: ref2,
      onClick: handleClick,
      ...other,
      ...!isHostComponent(Root) && {
        ownerState: {
          ...ownerState,
          ...rootProps.ownerState
        }
      },
      className: clsx(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
      children: [startAdornment, /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
        value: null,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input3, {
          "aria-invalid": fcs.error,
          "aria-describedby": ariaDescribedby,
          autoComplete,
          autoFocus,
          defaultValue,
          disabled: fcs.disabled,
          id,
          onAnimationStart: handleAutoFill,
          name,
          placeholder,
          readOnly,
          required: fcs.required,
          rows,
          value,
          onKeyDown,
          onKeyUp,
          type,
          ...inputProps,
          ...!isHostComponent(Input3) && {
            as: InputComponent,
            ownerState: {
              ...ownerState,
              ...inputProps.ownerState
            }
          },
          ref: handleInputRef,
          className: clsx(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
          onBlur: handleBlur,
          onChange: handleChange,
          onFocus: handleFocus
        })
      }), endAdornment, renderSuffix ? renderSuffix({
        ...fcs,
        startAdornment
      }) : null]
    })]
  });
});
process.env.NODE_ENV !== "production" ? InputBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: elementTypeAcceptingRef$1,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The size of the component.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
function getInputUtilityClass(slot) {
  return generateUtilityClass("MuiInput", slot);
}
const inputClasses = {
  ...inputBaseClasses,
  ...generateUtilityClasses("MuiInput", ["root", "underline", "input"])
};
function getOutlinedInputUtilityClass(slot) {
  return generateUtilityClass("MuiOutlinedInput", slot);
}
const outlinedInputClasses = {
  ...inputBaseClasses,
  ...generateUtilityClasses("MuiOutlinedInput", ["root", "notchedOutline", "input"])
};
function getFilledInputUtilityClass(slot) {
  return generateUtilityClass("MuiFilledInput", slot);
}
const filledInputClasses = {
  ...inputBaseClasses,
  ...generateUtilityClasses("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
};
const ArrowDropDownIcon$1 = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function getAutocompleteUtilityClass(slot) {
  return generateUtilityClass("MuiAutocomplete", slot);
}
const autocompleteClasses = generateUtilityClasses("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var _ClearIcon, _ArrowDropDownIcon;
const useUtilityClasses$13 = (ownerState) => {
  const {
    classes,
    disablePortal,
    expanded,
    focused,
    fullWidth,
    hasClearIcon,
    hasPopupIcon,
    inputFocused,
    popupOpen,
    size
  } = ownerState;
  const slots = {
    root: ["root", expanded && "expanded", focused && "focused", fullWidth && "fullWidth", hasClearIcon && "hasClearIcon", hasPopupIcon && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", inputFocused && "inputFocused"],
    tag: ["tag", `tagSize${capitalize$2(size)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", popupOpen && "popupIndicatorOpen"],
    popper: ["popper", disablePortal && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return composeClasses(slots, getAutocompleteUtilityClass, classes);
};
const AutocompleteRoot = styled("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    const {
      fullWidth,
      hasClearIcon,
      hasPopupIcon,
      inputFocused,
      size
    } = ownerState;
    return [{
      [`& .${autocompleteClasses.tag}`]: styles2.tag
    }, {
      [`& .${autocompleteClasses.tag}`]: styles2[`tagSize${capitalize$2(size)}`]
    }, {
      [`& .${autocompleteClasses.inputRoot}`]: styles2.inputRoot
    }, {
      [`& .${autocompleteClasses.input}`]: styles2.input
    }, {
      [`& .${autocompleteClasses.input}`]: inputFocused && styles2.inputFocused
    }, styles2.root, fullWidth && styles2.fullWidth, hasPopupIcon && styles2.hasPopupIcon, hasClearIcon && styles2.hasClearIcon];
  }
})({
  [`&.${autocompleteClasses.focused} .${autocompleteClasses.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${autocompleteClasses.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${autocompleteClasses.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${autocompleteClasses.inputRoot}`]: {
    [`.${autocompleteClasses.hasPopupIcon}&, .${autocompleteClasses.hasClearIcon}&`]: {
      paddingRight: 26 + 4
    },
    [`.${autocompleteClasses.hasPopupIcon}.${autocompleteClasses.hasClearIcon}&`]: {
      paddingRight: 52 + 4
    },
    [`& .${autocompleteClasses.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${inputClasses.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${inputClasses.root}.${inputBaseClasses.sizeSmall}`]: {
    [`& .${inputClasses.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${outlinedInputClasses.root}`]: {
    padding: 9,
    [`.${autocompleteClasses.hasPopupIcon}&, .${autocompleteClasses.hasClearIcon}&`]: {
      paddingRight: 26 + 4 + 9
    },
    [`.${autocompleteClasses.hasPopupIcon}.${autocompleteClasses.hasClearIcon}&`]: {
      paddingRight: 52 + 4 + 9
    },
    [`& .${autocompleteClasses.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${autocompleteClasses.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${outlinedInputClasses.root}.${inputBaseClasses.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${autocompleteClasses.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${filledInputClasses.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${autocompleteClasses.hasPopupIcon}&, .${autocompleteClasses.hasClearIcon}&`]: {
      paddingRight: 26 + 4 + 9
    },
    [`.${autocompleteClasses.hasPopupIcon}.${autocompleteClasses.hasClearIcon}&`]: {
      paddingRight: 52 + 4 + 9
    },
    [`& .${filledInputClasses.input}`]: {
      padding: "7px 4px"
    },
    [`& .${autocompleteClasses.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${filledInputClasses.root}.${inputBaseClasses.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${filledInputClasses.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${inputBaseClasses.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${filledInputClasses.root}.${inputBaseClasses.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${autocompleteClasses.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${filledInputClasses.root}.${inputBaseClasses.hiddenLabel}.${inputBaseClasses.sizeSmall}`]: {
    [`& .${autocompleteClasses.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${autocompleteClasses.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: true
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${autocompleteClasses.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: true
    },
    style: {
      [`& .${autocompleteClasses.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: true
    },
    style: {
      [`& .${autocompleteClasses.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
});
const AutocompleteEndAdornment = styled("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment"
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
});
const AutocompleteClearIndicator = styled(IconButton, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator"
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
});
const AutocompletePopupIndicator = styled(IconButton, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.popupIndicator, ownerState.popupOpen && styles2.popupIndicatorOpen];
  }
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: true
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
});
const AutocompletePopper = styled(Popper2, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${autocompleteClasses.option}`]: styles2.option
    }, styles2.popper, ownerState.disablePortal && styles2.popperDisablePortal];
  }
})(memoTheme(({
  theme
}) => ({
  zIndex: (theme.vars || theme).zIndex.modal,
  variants: [{
    props: {
      disablePortal: true
    },
    style: {
      position: "absolute"
    }
  }]
})));
const AutocompletePaper = styled(Paper, {
  name: "MuiAutocomplete",
  slot: "Paper"
})(memoTheme(({
  theme
}) => ({
  ...theme.typography.body1,
  overflow: "auto"
})));
const AutocompleteLoading = styled("div", {
  name: "MuiAutocomplete",
  slot: "Loading"
})(memoTheme(({
  theme
}) => ({
  color: (theme.vars || theme).palette.text.secondary,
  padding: "14px 16px"
})));
const AutocompleteNoOptions = styled("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions"
})(memoTheme(({
  theme
}) => ({
  color: (theme.vars || theme).palette.text.secondary,
  padding: "14px 16px"
})));
const AutocompleteListbox = styled("ul", {
  name: "MuiAutocomplete",
  slot: "Listbox"
})(memoTheme(({
  theme
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${autocompleteClasses.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [theme.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${autocompleteClasses.focused}`]: {
      backgroundColor: (theme.vars || theme).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (theme.vars || theme).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${autocompleteClasses.focusVisible}`]: {
      backgroundColor: (theme.vars || theme).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
      [`&.${autocompleteClasses.focused}`]: {
        backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (theme.vars || theme).palette.action.selected
        }
      },
      [`&.${autocompleteClasses.focusVisible}`]: {
        backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
      }
    }
  }
})));
const AutocompleteGroupLabel = styled(ListSubheader, {
  name: "MuiAutocomplete",
  slot: "GroupLabel"
})(memoTheme(({
  theme
}) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
  top: -8
})));
const AutocompleteGroupUl = styled("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl"
})({
  padding: 0,
  [`& .${autocompleteClasses.option}`]: {
    paddingLeft: 24
  }
});
const Autocomplete = /* @__PURE__ */ reactExports.forwardRef(function Autocomplete2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiAutocomplete"
  });
  const {
    autoComplete = false,
    autoHighlight = false,
    autoSelect = false,
    blurOnSelect = false,
    ChipProps: ChipPropsProp,
    className,
    clearIcon = _ClearIcon || (_ClearIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(ClearIcon$1, {
      fontSize: "small"
    })),
    clearOnBlur = !props.freeSolo,
    clearOnEscape = false,
    clearText = "Clear",
    closeText = "Close",
    componentsProps,
    defaultValue = props.multiple ? [] : null,
    disableClearable = false,
    disableCloseOnSelect = false,
    disabled = false,
    disabledItemsFocusable = false,
    disableListWrap = false,
    disablePortal = false,
    filterOptions,
    filterSelectedOptions = false,
    forcePopupIcon = "auto",
    freeSolo = false,
    fullWidth = false,
    getLimitTagsText = (more) => `+${more}`,
    getOptionDisabled,
    getOptionKey,
    getOptionLabel: getOptionLabelProp,
    isOptionEqualToValue,
    groupBy,
    handleHomeEndKeys = !props.freeSolo,
    id: idProp,
    includeInputInList = false,
    inputValue: inputValueProp,
    limitTags = -1,
    ListboxComponent: ListboxComponentProp,
    ListboxProps: ListboxPropsProp,
    loading = false,
    loadingText = "Loading…",
    multiple = false,
    noOptionsText = "No options",
    onChange,
    onClose,
    onHighlightChange,
    onInputChange,
    onOpen,
    open: open2,
    openOnFocus = false,
    openText = "Open",
    options,
    PaperComponent: PaperComponentProp,
    PopperComponent: PopperComponentProp,
    popupIcon = _ArrowDropDownIcon || (_ArrowDropDownIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowDropDownIcon$1, {})),
    readOnly = false,
    renderGroup: renderGroupProp,
    renderInput,
    renderOption: renderOptionProp,
    renderTags,
    renderValue,
    selectOnFocus = !props.freeSolo,
    size = "medium",
    slots = {},
    slotProps = {},
    value: valueProp,
    ...other
  } = props;
  const {
    getRootProps,
    getInputProps,
    getInputLabelProps,
    getPopupIndicatorProps,
    getClearProps,
    getItemProps,
    getListboxProps,
    getOptionProps,
    value,
    dirty,
    expanded,
    id,
    popupOpen,
    focused,
    focusedItem,
    anchorEl,
    setAnchorEl,
    inputValue,
    groupedOptions
  } = useAutocomplete({
    ...props,
    componentName: "Autocomplete"
  });
  const forceRenderOnResize = useForcedRerendering();
  reactExports.useEffect(() => {
    if (!popupOpen || !anchorEl || typeof ResizeObserver === "undefined") {
      return void 0;
    }
    let lastWidth = anchorEl.clientWidth;
    const observer = new ResizeObserver(() => {
      const newWidth = anchorEl.clientWidth;
      if (lastWidth !== newWidth) {
        lastWidth = newWidth;
        forceRenderOnResize();
      }
    });
    observer.observe(anchorEl);
    return () => {
      observer.disconnect();
    };
  }, [popupOpen, anchorEl, forceRenderOnResize]);
  const previousGroupedOptionsRef = reactExports.useRef([]);
  const prevPopupOpenRef = reactExports.useRef(false);
  const renderedOptions = popupOpen ? groupedOptions : previousGroupedOptionsRef.current;
  useEnhancedEffect(() => {
    if (popupOpen && !prevPopupOpenRef.current) {
      previousGroupedOptionsRef.current = [];
    }
    prevPopupOpenRef.current = popupOpen;
    if (popupOpen && groupedOptions.length > 0) {
      previousGroupedOptionsRef.current = groupedOptions;
    }
  }, [popupOpen, groupedOptions]);
  const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
  const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
  const {
    onMouseDown: handleInputMouseDown
  } = getInputProps();
  const {
    ref: listboxRef,
    ...otherListboxProps
  } = getListboxProps();
  const defaultGetOptionLabel = (option) => option.label ?? option;
  const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
  const ownerState = {
    ...props,
    disablePortal,
    expanded,
    focused,
    fullWidth,
    getOptionLabel,
    hasClearIcon,
    hasPopupIcon,
    inputFocused: focusedItem === -1,
    popupOpen,
    size
  };
  const classes = useUtilityClasses$13(ownerState);
  const externalForwardedProps = {
    slots: {
      paper: PaperComponentProp,
      popper: PopperComponentProp,
      ...slots
    },
    slotProps: {
      chip: ChipPropsProp,
      listbox: ListboxPropsProp,
      ...componentsProps,
      ...slotProps
    }
  };
  const [RootSlot, rootProps] = useSlot("root", {
    ref: ref2,
    className: [classes.root, className],
    elementType: AutocompleteRoot,
    externalForwardedProps: {
      ...externalForwardedProps,
      ...other
    },
    getSlotProps: getRootProps,
    ownerState
  });
  const [ListboxSlot, listboxProps] = useSlot("listbox", {
    elementType: AutocompleteListbox,
    externalForwardedProps,
    ownerState,
    className: classes.listbox,
    additionalProps: otherListboxProps,
    ref: listboxRef
  });
  const [PaperSlot, paperProps] = useSlot("paper", {
    elementType: Paper,
    externalForwardedProps,
    ownerState,
    className: classes.paper
  });
  const [PopperSlot, popperProps] = useSlot("popper", {
    elementType: Popper2,
    externalForwardedProps,
    ownerState,
    className: classes.popper,
    additionalProps: {
      disablePortal,
      style: {
        width: anchorEl ? anchorEl.clientWidth : null,
        // Prevent interaction with stale cached options during exit transitions.
        // The hook's filteredOptions is [] when popupOpen=false, so clicks on stale
        // rendered options would pass undefined to selectNewValue.
        pointerEvents: popupOpen ? void 0 : "none"
      },
      role: "presentation",
      anchorEl,
      open: popupOpen
    }
  });
  const hasPopupContent = renderedOptions.length > 0 || loading || !freeSolo || popperProps.keepMounted === true;
  const [ClearIndicatorSlot, clearIndicatorProps] = useSlot("clearIndicator", {
    elementType: AutocompleteClearIndicator,
    externalForwardedProps,
    ownerState,
    className: classes.clearIndicator,
    shouldForwardComponentProp: true,
    additionalProps: {
      ...getClearProps(),
      "aria-label": clearText,
      title: clearText
    }
  });
  const [PopupIndicatorSlot, popupIndicatorProps] = useSlot("popupIndicator", {
    elementType: AutocompletePopupIndicator,
    externalForwardedProps,
    ownerState,
    className: classes.popupIndicator,
    shouldForwardComponentProp: true,
    additionalProps: {
      ...getPopupIndicatorProps(),
      disabled,
      "aria-label": popupOpen ? closeText : openText,
      title: popupOpen ? closeText : openText
    }
  });
  let startAdornment;
  const getCustomizedItemProps = (params) => ({
    className: classes.tag,
    disabled,
    ...getItemProps(params)
  });
  if (multiple) {
    if (value.length > 0) {
      if (renderTags) {
        startAdornment = renderTags(value, getCustomizedItemProps, ownerState);
      } else if (renderValue) {
        startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
      } else {
        startAdornment = value.map((option, index2) => {
          const {
            key,
            ...customItemProps
          } = getCustomizedItemProps({
            index: index2
          });
          return /* @__PURE__ */ jsxRuntimeExports.jsx(Chip, {
            label: getOptionLabel(option),
            size,
            ...customItemProps,
            ...externalForwardedProps.slotProps.chip
          }, key);
        });
      }
    }
  } else if (renderValue && value != null) {
    startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
  }
  if (limitTags > -1 && Array.isArray(startAdornment)) {
    const more = startAdornment.length - limitTags;
    if (!focused && more > 0) {
      startAdornment = startAdornment.splice(0, limitTags);
      startAdornment.push(/* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: classes.tag,
        children: getLimitTagsText(more)
      }, startAdornment.length));
    }
  }
  const defaultRenderGroup = (params) => /* @__PURE__ */ jsxRuntimeExports.jsxs("li", {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(AutocompleteGroupLabel, {
      className: classes.groupLabel,
      ownerState,
      component: "div",
      children: params.group
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(AutocompleteGroupUl, {
      className: classes.groupUl,
      ownerState,
      children: params.children
    })]
  }, params.key);
  const renderGroup = renderGroupProp || defaultRenderGroup;
  const defaultRenderOption = (props2, option) => {
    const {
      key,
      ...otherProps
    } = props2;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("li", {
      ...otherProps,
      children: getOptionLabel(option)
    }, key);
  };
  const renderOption = renderOptionProp || defaultRenderOption;
  const renderListOption = (option, index2) => {
    const optionProps = getOptionProps({
      option,
      index: index2
    });
    return renderOption({
      ...optionProps,
      className: classes.option
    }, option, {
      selected: optionProps["aria-selected"],
      index: index2,
      inputValue
    }, ownerState);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(RootSlot, {
      ...rootProps,
      children: renderInput({
        id,
        disabled,
        fullWidth: props.fullWidth ?? true,
        size: size === "small" ? "small" : void 0,
        InputLabelProps: getInputLabelProps(),
        InputProps: {
          ref: setAnchorEl,
          className: classes.inputRoot,
          startAdornment,
          onMouseDown: (event2) => {
            if (event2.target === event2.currentTarget) {
              handleInputMouseDown(event2);
            }
          },
          ...(hasClearIcon || hasPopupIcon) && {
            endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsxs(AutocompleteEndAdornment, {
              className: classes.endAdornment,
              ownerState,
              children: [hasClearIcon ? /* @__PURE__ */ jsxRuntimeExports.jsx(ClearIndicatorSlot, {
                ...clearIndicatorProps,
                children: clearIcon
              }) : null, hasPopupIcon ? /* @__PURE__ */ jsxRuntimeExports.jsx(PopupIndicatorSlot, {
                ...popupIndicatorProps,
                children: popupIcon
              }) : null]
            })
          }
        },
        inputProps: {
          className: classes.input,
          disabled,
          readOnly,
          ...getInputProps()
        }
      })
    }), anchorEl && hasPopupContent ? /* @__PURE__ */ jsxRuntimeExports.jsx(AutocompletePopper, {
      as: PopperSlot,
      ...popperProps,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AutocompletePaper, {
        as: PaperSlot,
        ...paperProps,
        children: [loading && renderedOptions.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(AutocompleteLoading, {
          className: classes.loading,
          ownerState,
          children: loadingText
        }) : null, renderedOptions.length === 0 && !freeSolo && !loading ? /* @__PURE__ */ jsxRuntimeExports.jsx(AutocompleteNoOptions, {
          className: classes.noOptions,
          ownerState,
          role: "presentation",
          onMouseDown: (event2) => {
            event2.preventDefault();
          },
          children: noOptionsText
        }) : null, renderedOptions.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(ListboxSlot, {
          ...listboxProps,
          children: renderedOptions.map((option, index2) => {
            if (groupBy) {
              return renderGroup({
                key: option.key,
                group: option.group,
                children: option.options.map((option2, index22) => renderListOption(option2, option.index + index22))
              });
            }
            return renderListOption(option, index2);
          })
        }) : null]
      })
    }) : null]
  });
});
process.env.NODE_ENV !== "production" ? Autocomplete.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: PropTypes.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: PropTypes.bool,
  /**
   * If `true`, the value is updated when the input loses focus under one of these conditions:
   *
   * - An option highlighted via keyboard navigation or `autoHighlight` is selected.
   *   Hover and touch highlights are ignored.
   * - Otherwise, in `freeSolo` mode, the typed text becomes the value.
   * @default false
   */
  autoSelect: PropTypes.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: PropTypes.oneOfType([PropTypes.oneOf(["mouse", "touch"]), PropTypes.bool]),
  /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ChipProps: PropTypes.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: PropTypes.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: PropTypes.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: PropTypes.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: PropTypes.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: PropTypes.string,
  /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: PropTypes.shape({
    clearIndicator: PropTypes.object,
    paper: PropTypes.object,
    popper: PropTypes.object,
    popupIndicator: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: chainPropTypes(PropTypes.any, (props) => {
    if (props.multiple && props.defaultValue !== void 0 && !Array.isArray(props.defaultValue)) {
      return new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${props.defaultValue} was provided.`].join("\n"));
    }
    return null;
  }),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: PropTypes.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: PropTypes.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: PropTypes.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: PropTypes.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: PropTypes.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @template Value The option shape. Will be the same shape as an item of the options.
   * @returns {boolean}
   */
  getOptionDisabled: PropTypes.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: PropTypes.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: PropTypes.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} option The Autocomplete option.
   * @returns {string}
   */
  groupBy: PropTypes.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: PropTypes.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: PropTypes.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: PropTypes.bool,
  /**
   * The input value.
   */
  inputValue: PropTypes.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: PropTypes.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: integerPropType,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxComponent: PropTypes.elementType,
  /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxProps: PropTypes.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: PropTypes.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: PropTypes.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: PropTypes.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */
  onInputChange: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: PropTypes.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: PropTypes.string,
  /**
   * A list of options that will be shown in the Autocomplete.
   */
  options: PropTypes.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperComponent: PropTypes.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: PropTypes.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: PropTypes.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: PropTypes.func,
  /**
   * Render the input.
   *
   * **Note:** The `renderInput` prop must return a `TextField` component or a compatible custom component
   * that correctly forwards `InputProps.ref` and spreads `inputProps`. This ensures proper integration
   * with the Autocomplete's internal logic (e.g., focus management and keyboard navigation).
   *
   * Avoid using components like `DatePicker` or `Select` directly, as they may not forward the required props,
   * leading to runtime errors or unexpected behavior.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: PropTypes.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: PropTypes.func,
  /**
   * Render the selected value when doing multiple selections.
   *
   * @deprecated Use `renderValue` prop instead
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: PropTypes.func,
  /**
   * Renders the selected value(s) as rich content in the input for both single and multiple selections.
   *
   * @param {AutocompleteRenderValue<Value, Multiple, FreeSolo>} value The `value` provided to the component.
   * @param {function} getItemProps The value item props.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium"]), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    chip: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    clearIndicator: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    listbox: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    popper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    popupIndicator: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    clearIndicator: PropTypes.elementType,
    listbox: PropTypes.elementType,
    paper: PropTypes.elementType,
    popper: PropTypes.elementType,
    popupIndicator: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: chainPropTypes(PropTypes.any, (props) => {
    if (props.multiple && props.value !== void 0 && !Array.isArray(props.value)) {
      return new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${props.value} was provided.`].join("\n"));
    }
    return null;
  })
} : void 0;
function isClassComponent$2(elementType) {
  const {
    prototype = {}
  } = elementType;
  return Boolean(prototype.isReactComponent);
}
function acceptingRef(props, propName, componentName, location, propFullName) {
  const element = props[propName];
  const safePropName = propFullName || propName;
  if (element == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window === "undefined") {
    return null;
  }
  let warningHint;
  const elementType = element.type;
  if (typeof elementType === "function" && !isClassComponent$2(elementType)) {
    warningHint = "Did you accidentally use a plain function component for an element instead?";
  }
  if (warningHint !== void 0) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. Expected an element that can hold a ref. ${warningHint} For more information see https://mui.com/r/caveat-with-refs-guide`);
  }
  return null;
}
const elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
const styles$2 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  },
  exited: {
    opacity: 0
  }
};
const hiddenStyles$2 = {
  opacity: 0,
  visibility: "hidden"
};
const Fade = /* @__PURE__ */ reactExports.forwardRef(function Fade2(props, ref2) {
  const theme = useTheme();
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
    addEndListener,
    appear = true,
    children,
    easing: easing2,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style: style2,
    timeout: timeout2 = defaultTimeout,
    ...other
  } = props;
  const nodeRef = reactExports.useRef(null);
  const handleRef = useForkRef(nodeRef, getReactElementRef(children), ref2);
  const handleEntering = normalizedTransitionCallback(nodeRef, onEntering);
  const handleEnter = normalizedTransitionCallback(nodeRef, (node2, isAppearing) => {
    reflow(node2);
    const transitionProps = getTransitionProps({
      style: style2,
      timeout: timeout2,
      easing: easing2
    }, {
      mode: "enter"
    });
    node2.style.transition = theme.transitions.create("opacity", transitionProps);
    if (onEnter) {
      onEnter(node2, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(nodeRef, onEntered);
  const handleExiting = normalizedTransitionCallback(nodeRef, onExiting);
  const handleExit = normalizedTransitionCallback(nodeRef, (node2) => {
    const transitionProps = getTransitionProps({
      style: style2,
      timeout: timeout2,
      easing: easing2
    }, {
      mode: "exit"
    });
    node2.style.transition = theme.transitions.create("opacity", transitionProps);
    if (onExit) {
      onExit(node2);
    }
  });
  const handleExited = normalizedTransitionCallback(nodeRef, (node2) => {
    node2.style.transition = "";
    if (onExited) {
      onExited(node2);
    }
  });
  const handleAddEndListener = (next2) => {
    if (addEndListener) {
      addEndListener(nodeRef.current, next2);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Transition$1, {
    appear,
    in: inProp,
    nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout2,
    ...other,
    children: (state, {
      ownerState,
      ...restChildProps
    }) => {
      const childStyle = getTransitionChildStyle(state, inProp, styles$2, hiddenStyles$2, style2, children.props.style);
      return /* @__PURE__ */ reactExports.cloneElement(children, {
        style: childStyle,
        ref: handleRef,
        ...restChildProps
      });
    }
  });
});
process.env.NODE_ENV !== "production" ? Fade.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
function getBackdropUtilityClass(slot) {
  return generateUtilityClass("MuiBackdrop", slot);
}
generateUtilityClasses("MuiBackdrop", ["root", "invisible"]);
const useUtilityClasses$12 = (ownerState) => {
  const {
    classes,
    invisible
  } = ownerState;
  const slots = {
    root: ["root", invisible && "invisible"]
  };
  return composeClasses(slots, getBackdropUtilityClass, classes);
};
const BackdropRoot = styled("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.invisible && styles2.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: true
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
});
const Backdrop = /* @__PURE__ */ reactExports.forwardRef(function Backdrop2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiBackdrop"
  });
  const {
    children,
    className,
    component = "div",
    invisible = false,
    open: open2,
    components = {},
    componentsProps = {},
    slotProps = {},
    slots = {},
    TransitionComponent: TransitionComponentProp,
    transitionDuration,
    ...other
  } = props;
  const ownerState = {
    ...props,
    component,
    invisible
  };
  const classes = useUtilityClasses$12(ownerState);
  const backwardCompatibleSlots = {
    transition: TransitionComponentProp,
    root: components.Root,
    ...slots
  };
  const backwardCompatibleSlotProps = {
    ...componentsProps,
    ...slotProps
  };
  const externalForwardedProps = {
    component,
    slots: backwardCompatibleSlots,
    slotProps: backwardCompatibleSlotProps
  };
  const [RootSlot, rootProps] = useSlot("root", {
    elementType: BackdropRoot,
    externalForwardedProps,
    className: clsx(classes.root, className),
    ownerState
  });
  const [TransitionSlot, transitionProps] = useSlot("transition", {
    elementType: Fade,
    externalForwardedProps,
    ownerState
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionSlot, {
    in: open2,
    timeout: transitionDuration,
    ...other,
    ...transitionProps,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(RootSlot, {
      "aria-hidden": true,
      ...rootProps,
      ref: ref2,
      children
    })
  });
});
process.env.NODE_ENV !== "production" ? Backdrop.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: PropTypes.bool,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
const boxClasses = generateUtilityClasses("MuiBox", ["root"]);
const defaultTheme = createTheme();
const Box = createBox({
  themeId: THEME_ID,
  defaultTheme,
  defaultClassName: boxClasses.root,
  generateClassName: ClassNameGenerator.generate
});
process.env.NODE_ENV !== "production" ? Box.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
const MoreHorizIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz");
const BreadcrumbCollapsedButton = styled(ButtonBase, {
  name: "MuiBreadcrumbCollapsed"
})(memoTheme(({
  theme
}) => ({
  display: "flex",
  marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
  marginRight: `calc(${theme.spacing(1)} * 0.5)`,
  ...theme.palette.mode === "light" ? {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.grey[700]
  } : {
    backgroundColor: theme.palette.grey[700],
    color: theme.palette.grey[100]
  },
  borderRadius: 2,
  "&:hover, &:focus": {
    ...theme.palette.mode === "light" ? {
      backgroundColor: theme.palette.grey[200]
    } : {
      backgroundColor: theme.palette.grey[600]
    }
  },
  "&:active": {
    boxShadow: theme.shadows[0],
    ...theme.palette.mode === "light" ? {
      backgroundColor: emphasize(theme.palette.grey[200], 0.12)
    } : {
      backgroundColor: emphasize(theme.palette.grey[600], 0.12)
    }
  }
})));
const BreadcrumbCollapsedIcon = styled(MoreHorizIcon)({
  width: 24,
  height: 16
});
function BreadcrumbCollapsed(props) {
  const {
    slots = {},
    slotProps = {},
    ...otherProps
  } = props;
  const ownerState = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("li", {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(BreadcrumbCollapsedButton, {
      focusRipple: true,
      ...otherProps,
      ownerState,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(BreadcrumbCollapsedIcon, {
        as: slots.CollapsedIcon,
        ownerState,
        ...slotProps.collapsedIcon
      })
    })
  });
}
process.env.NODE_ENV !== "production" ? BreadcrumbCollapsed.propTypes = {
  /**
   * The props used for the CollapsedIcon slot.
   * @default {}
   */
  slotProps: PropTypes.shape({
    collapsedIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the BreadcumbCollapsed.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    CollapsedIcon: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.object
} : void 0;
function getBreadcrumbsUtilityClass(slot) {
  return generateUtilityClass("MuiBreadcrumbs", slot);
}
const breadcrumbsClasses = generateUtilityClasses("MuiBreadcrumbs", ["root", "ol", "li", "separator"]);
const useUtilityClasses$11 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    li: ["li"],
    ol: ["ol"],
    separator: ["separator"]
  };
  return composeClasses(slots, getBreadcrumbsUtilityClass, classes);
};
const BreadcrumbsRoot = styled(Typography$1, {
  name: "MuiBreadcrumbs",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    return [{
      [`& .${breadcrumbsClasses.li}`]: styles2.li
    }, styles2.root];
  }
})({});
const BreadcrumbsOl = styled("ol", {
  name: "MuiBreadcrumbs",
  slot: "Ol"
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
const BreadcrumbsSeparator = styled("li", {
  name: "MuiBreadcrumbs",
  slot: "Separator"
})({
  display: "flex",
  userSelect: "none",
  marginLeft: 8,
  marginRight: 8
});
function insertSeparators(items, className, separator, ownerState) {
  return items.reduce((acc, current, index2) => {
    if (index2 < items.length - 1) {
      acc = acc.concat(current, /* @__PURE__ */ jsxRuntimeExports.jsx(BreadcrumbsSeparator, {
        "aria-hidden": true,
        className,
        ownerState,
        children: separator
      }, `separator-${index2}`));
    } else {
      acc.push(current);
    }
    return acc;
  }, []);
}
const Breadcrumbs = /* @__PURE__ */ reactExports.forwardRef(function Breadcrumbs2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiBreadcrumbs"
  });
  const {
    children,
    className,
    component = "nav",
    slots = {},
    slotProps = {},
    expandText = "Show path",
    itemsAfterCollapse = 1,
    itemsBeforeCollapse = 1,
    maxItems = 8,
    separator = "/",
    ...other
  } = props;
  const [expanded, setExpanded] = reactExports.useState(false);
  const ownerState = {
    ...props,
    component,
    expanded,
    expandText,
    itemsAfterCollapse,
    itemsBeforeCollapse,
    maxItems,
    separator
  };
  const classes = useUtilityClasses$11(ownerState);
  const collapsedIconSlotProps = useSlotProps({
    elementType: slots.CollapsedIcon,
    externalSlotProps: slotProps.collapsedIcon,
    ownerState
  });
  const listRef = reactExports.useRef(null);
  const renderItemsBeforeAndAfter = (allItems2) => {
    const handleClickExpand = () => {
      setExpanded(true);
      const focusable = listRef.current.querySelector("a[href],button,[tabindex]");
      if (focusable) {
        focusable.focus();
      }
    };
    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems2.length) {
      if (process.env.NODE_ENV !== "production") {
        console.error(["MUI: You have provided an invalid combination of props to the Breadcrumbs.", `itemsAfterCollapse={${itemsAfterCollapse}} + itemsBeforeCollapse={${itemsBeforeCollapse}} >= maxItems={${maxItems}}`].join("\n"));
      }
      return allItems2;
    }
    return [...allItems2.slice(0, itemsBeforeCollapse), /* @__PURE__ */ jsxRuntimeExports.jsx(BreadcrumbCollapsed, {
      "aria-label": expandText,
      slots: {
        CollapsedIcon: slots.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: collapsedIconSlotProps
      },
      onClick: handleClickExpand
    }, "ellipsis"), ...allItems2.slice(allItems2.length - itemsAfterCollapse, allItems2.length)];
  };
  const allItems = reactExports.Children.toArray(children).filter((child) => {
    if (process.env.NODE_ENV !== "production") {
      if (reactIsExports.isFragment(child)) {
        console.error(["MUI: The Breadcrumbs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join("\n"));
      }
    }
    return /* @__PURE__ */ reactExports.isValidElement(child);
  }).map((child, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", {
    className: classes.li,
    children: child
  }, `child-${index2}`));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BreadcrumbsRoot, {
    ref: ref2,
    component,
    color: "textSecondary",
    className: clsx(classes.root, className),
    ownerState,
    ...other,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(BreadcrumbsOl, {
      className: classes.ol,
      ref: listRef,
      ownerState,
      children: insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
    })
  });
});
process.env.NODE_ENV !== "production" ? Breadcrumbs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Show path'
   */
  expandText: PropTypes.string,
  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */
  itemsAfterCollapse: integerPropType,
  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */
  itemsBeforeCollapse: integerPropType,
  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */
  maxItems: integerPropType,
  /**
   * Custom separator node.
   * @default '/'
   */
  separator: PropTypes.node,
  /**
   * The props used for each slot inside the Breadcumb.
   * @default {}
   */
  slotProps: PropTypes.shape({
    collapsedIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Breadcumb.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    CollapsedIcon: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getButtonUtilityClass(slot) {
  return generateUtilityClass("MuiButton", slot);
}
const buttonClasses = generateUtilityClasses("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge", "loading", "loadingWrapper", "loadingIconPlaceholder", "loadingIndicator", "loadingPositionCenter", "loadingPositionStart", "loadingPositionEnd"]);
const ButtonGroupContext = /* @__PURE__ */ reactExports.createContext({});
if (process.env.NODE_ENV !== "production") {
  ButtonGroupContext.displayName = "ButtonGroupContext";
}
const ButtonGroupButtonContext = /* @__PURE__ */ reactExports.createContext(void 0);
if (process.env.NODE_ENV !== "production") {
  ButtonGroupButtonContext.displayName = "ButtonGroupButtonContext";
}
const useUtilityClasses$10 = (ownerState) => {
  const {
    color: color2,
    disableElevation,
    fullWidth,
    size,
    variant,
    loading,
    loadingPosition,
    classes
  } = ownerState;
  const slots = {
    root: ["root", loading && "loading", variant, `${variant}${capitalize$2(color2)}`, `size${capitalize$2(size)}`, `${variant}Size${capitalize$2(size)}`, `color${capitalize$2(color2)}`, disableElevation && "disableElevation", fullWidth && "fullWidth", loading && `loadingPosition${capitalize$2(loadingPosition)}`],
    startIcon: ["icon", "startIcon", `iconSize${capitalize$2(size)}`],
    endIcon: ["icon", "endIcon", `iconSize${capitalize$2(size)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  const composedClasses = composeClasses(slots, getButtonUtilityClass, classes);
  return {
    ...classes,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...composedClasses
  };
};
const commonIconStyles = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}];
const ButtonRoot = styled(ButtonBase, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, styles2[ownerState.variant], styles2[`${ownerState.variant}${capitalize$2(ownerState.color)}`], styles2[`size${capitalize$2(ownerState.size)}`], styles2[`${ownerState.variant}Size${capitalize$2(ownerState.size)}`], ownerState.color === "inherit" && styles2.colorInherit, ownerState.disableElevation && styles2.disableElevation, ownerState.fullWidth && styles2.fullWidth, ownerState.loading && styles2.loading];
  }
})(memoTheme(({
  theme
}) => {
  const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
  const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
  return {
    ...theme.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: theme.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${buttonClasses.disabled}`]: {
      color: (theme.vars || theme).palette.action.disabled
    },
    variants: [{
      props: ({
        ownerState
      }) => ownerState.startIcon || ownerState.loading && ownerState.loadingPosition === "start",
      style: {
        "&::before": {
          content: '"\\200b"',
          width: 0,
          overflow: "hidden"
        }
      }
    }, {
      props: {
        variant: "contained"
      },
      style: {
        color: `var(--variant-containedColor)`,
        backgroundColor: `var(--variant-containedBg)`,
        boxShadow: (theme.vars || theme).shadows[2],
        "&:hover": {
          boxShadow: (theme.vars || theme).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (theme.vars || theme).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (theme.vars || theme).shadows[8]
        },
        [`&.${buttonClasses.focusVisible}`]: {
          boxShadow: (theme.vars || theme).shadows[6]
        },
        [`&.${buttonClasses.disabled}`]: {
          color: (theme.vars || theme).palette.action.disabled,
          boxShadow: (theme.vars || theme).shadows[0],
          backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: `var(--variant-outlinedBorder, currentColor)`,
        backgroundColor: `var(--variant-outlinedBg)`,
        color: `var(--variant-outlinedColor)`,
        [`&.${buttonClasses.disabled}`]: {
          border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: `var(--variant-textColor)`,
        backgroundColor: `var(--variant-textBg)`
      }
    }, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color2]) => ({
      props: {
        color: color2
      },
      style: {
        "--variant-textColor": (theme.vars || theme).palette[color2].main,
        "--variant-outlinedColor": (theme.vars || theme).palette[color2].main,
        "--variant-outlinedBorder": theme.alpha((theme.vars || theme).palette[color2].main, 0.5),
        "--variant-containedColor": (theme.vars || theme).palette[color2].contrastText,
        "--variant-containedBg": (theme.vars || theme).palette[color2].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (theme.vars || theme).palette[color2].dark,
            "--variant-textBg": theme.alpha((theme.vars || theme).palette[color2].main, (theme.vars || theme).palette.action.hoverOpacity),
            "--variant-outlinedBorder": (theme.vars || theme).palette[color2].main,
            "--variant-outlinedBg": theme.alpha((theme.vars || theme).palette[color2].main, (theme.vars || theme).palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            "--variant-textBg": theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
            "--variant-outlinedBg": theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: true
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${buttonClasses.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${buttonClasses.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: true
      },
      style: {
        width: "100%"
      }
    }, {
      props: {
        loadingPosition: "center"
      },
      style: {
        transition: theme.transitions.create(["background-color", "box-shadow", "border-color"], {
          duration: theme.transitions.duration.short
        }),
        [`&.${buttonClasses.loading}`]: {
          color: "transparent"
        }
      }
    }]
  };
}));
const ButtonStartIcon = styled("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.startIcon, ownerState.loading && styles2.startIconLoadingStart, styles2[`iconSize${capitalize$2(ownerState.size)}`]];
  }
})(({
  theme
}) => ({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: true
    },
    style: {
      transition: theme.transitions.create(["opacity"], {
        duration: theme.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: true,
      fullWidth: true
    },
    style: {
      marginRight: -8
    }
  }, ...commonIconStyles]
}));
const ButtonEndIcon = styled("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.endIcon, ownerState.loading && styles2.endIconLoadingEnd, styles2[`iconSize${capitalize$2(ownerState.size)}`]];
  }
})(({
  theme
}) => ({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: true
    },
    style: {
      transition: theme.transitions.create(["opacity"], {
        duration: theme.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: true,
      fullWidth: true
    },
    style: {
      marginLeft: -8
    }
  }, ...commonIconStyles]
}));
const ButtonLoadingIndicator = styled("span", {
  name: "MuiButton",
  slot: "LoadingIndicator"
})(({
  theme
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  variants: [{
    props: {
      loading: true
    },
    style: {
      display: "flex"
    }
  }, {
    props: {
      loadingPosition: "start"
    },
    style: {
      left: 14
    }
  }, {
    props: {
      loadingPosition: "start",
      size: "small"
    },
    style: {
      left: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "start"
    },
    style: {
      left: 6
    }
  }, {
    props: {
      loadingPosition: "center"
    },
    style: {
      left: "50%",
      transform: "translate(-50%)",
      color: (theme.vars || theme).palette.action.disabled
    }
  }, {
    props: {
      loadingPosition: "end"
    },
    style: {
      right: 14
    }
  }, {
    props: {
      loadingPosition: "end",
      size: "small"
    },
    style: {
      right: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "end"
    },
    style: {
      right: 6
    }
  }, {
    props: {
      loadingPosition: "start",
      fullWidth: true
    },
    style: {
      position: "relative",
      left: -10
    }
  }, {
    props: {
      loadingPosition: "end",
      fullWidth: true
    },
    style: {
      position: "relative",
      right: -10
    }
  }]
}));
const ButtonLoadingIconPlaceholder = styled("span", {
  name: "MuiButton",
  slot: "LoadingIconPlaceholder"
})({
  display: "inline-block",
  width: "1em",
  height: "1em"
});
const Button$1 = /* @__PURE__ */ reactExports.forwardRef(function Button(inProps, ref2) {
  const contextProps = reactExports.useContext(ButtonGroupContext);
  const buttonGroupButtonContextPositionClassName = reactExports.useContext(ButtonGroupButtonContext);
  const resolvedProps = resolveProps(contextProps, inProps);
  const props = useDefaultProps({
    props: resolvedProps,
    name: "MuiButton"
  });
  const {
    children,
    color: color2 = "primary",
    component = "button",
    className,
    disabled = false,
    disableElevation = false,
    disableFocusRipple = false,
    endIcon: endIconProp,
    focusVisibleClassName,
    fullWidth = false,
    id: idProp,
    loading = null,
    loadingIndicator: loadingIndicatorProp,
    loadingPosition = "center",
    size = "medium",
    startIcon: startIconProp,
    type,
    variant = "text",
    ...other
  } = props;
  const loadingId = useId(idProp);
  const loadingIndicator = loadingIndicatorProp ?? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, {
    "aria-labelledby": loadingId,
    color: "inherit",
    size: 16
  });
  const ownerState = {
    ...props,
    color: color2,
    component,
    disabled,
    disableElevation,
    disableFocusRipple,
    fullWidth,
    loading,
    loadingIndicator,
    loadingPosition,
    size,
    type,
    variant
  };
  const classes = useUtilityClasses$10(ownerState);
  const startIcon = (startIconProp || loading && loadingPosition === "start") && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonStartIcon, {
    className: classes.startIcon,
    ownerState,
    children: startIconProp || /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonLoadingIconPlaceholder, {
      className: classes.loadingIconPlaceholder,
      ownerState
    })
  });
  const endIcon = (endIconProp || loading && loadingPosition === "end") && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonEndIcon, {
    className: classes.endIcon,
    ownerState,
    children: endIconProp || /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonLoadingIconPlaceholder, {
      className: classes.loadingIconPlaceholder,
      ownerState
    })
  });
  const positionClassName = buttonGroupButtonContextPositionClassName || "";
  const loader = typeof loading === "boolean" ? (
    // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: classes.loadingWrapper,
      style: {
        display: "contents"
      },
      children: loading && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonLoadingIndicator, {
        className: classes.loadingIndicator,
        ownerState,
        children: loadingIndicator
      })
    })
  ) : null;
  const {
    root: root2,
    ...forwardedClasses
  } = classes;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonRoot, {
    ownerState,
    className: clsx(contextProps.className, classes.root, className, positionClassName),
    component,
    disabled: disabled || loading,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
    ref: ref2,
    type,
    id: loading ? loadingId : idProp,
    ...other,
    classes: forwardedClasses,
    children: [startIcon, loadingPosition !== "end" && loader, children, loadingPosition === "end" && loader, endIcon]
  });
});
process.env.NODE_ENV !== "production" ? Button$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,
  /**
   * @ignore
   */
  id: PropTypes.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: PropTypes.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: PropTypes.node,
  /**
   * The loading indicator can be positioned on the start, end, or the center of the button.
   * @default 'center'
   */
  loadingPosition: PropTypes.oneOf(["center", "end", "start"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["contained", "outlined", "text"]), PropTypes.string])
} : void 0;
function getValidReactChildren(children) {
  return reactExports.Children.toArray(children).filter((child) => /* @__PURE__ */ reactExports.isValidElement(child));
}
function getButtonGroupUtilityClass(slot) {
  return generateUtilityClass("MuiButtonGroup", slot);
}
const buttonGroupClasses = generateUtilityClasses("MuiButtonGroup", ["root", "contained", "outlined", "text", "disableElevation", "disabled", "firstButton", "fullWidth", "horizontal", "vertical", "colorPrimary", "colorSecondary", "grouped", "groupedHorizontal", "groupedVertical", "groupedText", "groupedTextHorizontal", "groupedTextVertical", "groupedTextPrimary", "groupedTextSecondary", "groupedOutlined", "groupedOutlinedHorizontal", "groupedOutlinedVertical", "groupedOutlinedPrimary", "groupedOutlinedSecondary", "groupedContained", "groupedContainedHorizontal", "groupedContainedVertical", "groupedContainedPrimary", "groupedContainedSecondary", "lastButton", "middleButton"]);
const overridesResolver$6 = (props, styles2) => {
  const {
    ownerState
  } = props;
  return [{
    [`& .${buttonGroupClasses.grouped}`]: styles2.grouped
  }, {
    [`& .${buttonGroupClasses.grouped}`]: styles2[`grouped${capitalize$2(ownerState.orientation)}`]
  }, {
    [`& .${buttonGroupClasses.grouped}`]: styles2[`grouped${capitalize$2(ownerState.variant)}`]
  }, {
    [`& .${buttonGroupClasses.grouped}`]: styles2[`grouped${capitalize$2(ownerState.variant)}${capitalize$2(ownerState.orientation)}`]
  }, {
    [`& .${buttonGroupClasses.grouped}`]: styles2[`grouped${capitalize$2(ownerState.variant)}${capitalize$2(ownerState.color)}`]
  }, {
    [`& .${buttonGroupClasses.firstButton}`]: styles2.firstButton
  }, {
    [`& .${buttonGroupClasses.lastButton}`]: styles2.lastButton
  }, {
    [`& .${buttonGroupClasses.middleButton}`]: styles2.middleButton
  }, styles2.root, styles2[ownerState.variant], ownerState.disableElevation === true && styles2.disableElevation, ownerState.fullWidth && styles2.fullWidth, ownerState.orientation === "vertical" && styles2.vertical];
};
const useUtilityClasses$$ = (ownerState) => {
  const {
    classes,
    color: color2,
    disabled,
    disableElevation,
    fullWidth,
    orientation,
    variant
  } = ownerState;
  const slots = {
    root: ["root", variant, orientation, fullWidth && "fullWidth", disableElevation && "disableElevation", `color${capitalize$2(color2)}`],
    grouped: ["grouped", `grouped${capitalize$2(orientation)}`, `grouped${capitalize$2(variant)}`, `grouped${capitalize$2(variant)}${capitalize$2(orientation)}`, `grouped${capitalize$2(variant)}${capitalize$2(color2)}`, disabled && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return composeClasses(slots, getButtonGroupUtilityClass, classes);
};
const ButtonGroupRoot = styled("div", {
  name: "MuiButtonGroup",
  slot: "Root",
  overridesResolver: overridesResolver$6
})(memoTheme(({
  theme
}) => ({
  display: "inline-flex",
  borderRadius: (theme.vars || theme).shape.borderRadius,
  variants: [{
    props: {
      variant: "contained"
    },
    style: {
      boxShadow: (theme.vars || theme).shadows[2],
      [`& .${buttonGroupClasses.grouped}`]: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        }
      }
    }
  }, {
    props: {
      disableElevation: true
    },
    style: {
      boxShadow: "none"
    }
  }, {
    props: {
      fullWidth: true
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      flexDirection: "column",
      [`& .${buttonGroupClasses.lastButton},& .${buttonGroupClasses.middleButton}`]: {
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0
      },
      [`& .${buttonGroupClasses.firstButton},& .${buttonGroupClasses.middleButton}`]: {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      [`& .${buttonGroupClasses.firstButton},& .${buttonGroupClasses.middleButton}`]: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      [`& .${buttonGroupClasses.lastButton},& .${buttonGroupClasses.middleButton}`]: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }, {
    props: {
      variant: "text",
      orientation: "horizontal"
    },
    style: {
      [`& .${buttonGroupClasses.firstButton},& .${buttonGroupClasses.middleButton}`]: {
        borderRight: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${buttonGroupClasses.disabled}`]: {
          borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
        }
      }
    }
  }, {
    props: {
      variant: "text",
      orientation: "vertical"
    },
    style: {
      [`& .${buttonGroupClasses.firstButton},& .${buttonGroupClasses.middleButton}`]: {
        borderBottom: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${buttonGroupClasses.disabled}`]: {
          borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
        }
      }
    }
  }, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).flatMap(([color2]) => [{
    props: {
      variant: "text",
      color: color2
    },
    style: {
      [`& .${buttonGroupClasses.firstButton},& .${buttonGroupClasses.middleButton}`]: {
        borderColor: theme.alpha((theme.vars || theme).palette[color2].main, 0.5)
      }
    }
  }]), {
    props: {
      variant: "outlined",
      orientation: "horizontal"
    },
    style: {
      [`& .${buttonGroupClasses.firstButton},& .${buttonGroupClasses.middleButton}`]: {
        borderRightColor: "transparent",
        "&:hover": {
          borderRightColor: "currentColor"
        }
      },
      [`& .${buttonGroupClasses.lastButton},& .${buttonGroupClasses.middleButton}`]: {
        marginLeft: -1
      }
    }
  }, {
    props: {
      variant: "outlined",
      orientation: "vertical"
    },
    style: {
      [`& .${buttonGroupClasses.firstButton},& .${buttonGroupClasses.middleButton}`]: {
        borderBottomColor: "transparent",
        "&:hover": {
          borderBottomColor: "currentColor"
        }
      },
      [`& .${buttonGroupClasses.lastButton},& .${buttonGroupClasses.middleButton}`]: {
        marginTop: -1
      }
    }
  }, {
    props: {
      variant: "contained",
      orientation: "horizontal"
    },
    style: {
      [`& .${buttonGroupClasses.firstButton},& .${buttonGroupClasses.middleButton}`]: {
        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
        [`&.${buttonGroupClasses.disabled}`]: {
          borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
        }
      }
    }
  }, {
    props: {
      variant: "contained",
      orientation: "vertical"
    },
    style: {
      [`& .${buttonGroupClasses.firstButton},& .${buttonGroupClasses.middleButton}`]: {
        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
        [`&.${buttonGroupClasses.disabled}`]: {
          borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
        }
      }
    }
  }, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["dark"])).map(([color2]) => ({
    props: {
      variant: "contained",
      color: color2
    },
    style: {
      [`& .${buttonGroupClasses.firstButton},& .${buttonGroupClasses.middleButton}`]: {
        borderColor: (theme.vars || theme).palette[color2].dark
      }
    }
  }))],
  [`& .${buttonGroupClasses.grouped}`]: {
    minWidth: 40
  }
})));
const ButtonGroup = /* @__PURE__ */ reactExports.forwardRef(function ButtonGroup2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiButtonGroup"
  });
  const {
    children,
    className,
    color: color2 = "primary",
    component = "div",
    disabled = false,
    disableElevation = false,
    disableFocusRipple = false,
    disableRipple = false,
    fullWidth = false,
    orientation = "horizontal",
    size = "medium",
    variant = "outlined",
    ...other
  } = props;
  const ownerState = {
    ...props,
    color: color2,
    component,
    disabled,
    disableElevation,
    disableFocusRipple,
    disableRipple,
    fullWidth,
    orientation,
    size,
    variant
  };
  const classes = useUtilityClasses$$(ownerState);
  const context2 = reactExports.useMemo(() => ({
    className: classes.grouped,
    color: color2,
    disabled,
    disableElevation,
    disableFocusRipple,
    disableRipple,
    fullWidth,
    size,
    variant
  }), [color2, disabled, disableElevation, disableFocusRipple, disableRipple, fullWidth, size, variant, classes.grouped]);
  const validChildren = getValidReactChildren(children);
  const childrenCount = validChildren.length;
  const getButtonPositionClassName = (index2) => {
    const isFirstButton = index2 === 0;
    const isLastButton = index2 === childrenCount - 1;
    if (isFirstButton && isLastButton) {
      return "";
    }
    if (isFirstButton) {
      return classes.firstButton;
    }
    if (isLastButton) {
      return classes.lastButton;
    }
    return classes.middleButton;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupRoot, {
    as: component,
    role: "group",
    className: clsx(classes.root, className),
    ref: ref2,
    ownerState,
    ...other,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupContext.Provider, {
      value: context2,
      children: validChildren.map((child, index2) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupButtonContext.Provider, {
          value: getButtonPositionClassName(index2),
          children: child
        }, index2);
      })
    })
  });
});
process.env.NODE_ENV !== "production" ? ButtonGroup.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: PropTypes.bool,
  /**
   * If `true`, the button keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the button ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the buttons will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["contained", "outlined", "text"]), PropTypes.string])
} : void 0;
function getCardUtilityClass(slot) {
  return generateUtilityClass("MuiCard", slot);
}
generateUtilityClasses("MuiCard", ["root"]);
const useUtilityClasses$_ = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getCardUtilityClass, classes);
};
const CardRoot = styled(Paper, {
  name: "MuiCard",
  slot: "Root"
})({
  overflow: "hidden"
});
const Card = /* @__PURE__ */ reactExports.forwardRef(function Card2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiCard"
  });
  const {
    className,
    raised = false,
    ...other
  } = props;
  const ownerState = {
    ...props,
    raised
  };
  const classes = useUtilityClasses$_(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CardRoot, {
    className: clsx(classes.root, className),
    elevation: raised ? 8 : void 0,
    ref: ref2,
    ownerState,
    ...other
  });
});
process.env.NODE_ENV !== "production" ? Card.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: chainPropTypes(PropTypes.bool, (props) => {
    if (props.raised && props.variant === "outlined") {
      return new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.');
    }
    return null;
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getCardActionsUtilityClass(slot) {
  return generateUtilityClass("MuiCardActions", slot);
}
generateUtilityClasses("MuiCardActions", ["root", "spacing"]);
const useUtilityClasses$Z = (ownerState) => {
  const {
    classes,
    disableSpacing
  } = ownerState;
  const slots = {
    root: ["root", !disableSpacing && "spacing"]
  };
  return composeClasses(slots, getCardActionsUtilityClass, classes);
};
const CardActionsRoot = styled("div", {
  name: "MuiCardActions",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, !ownerState.disableSpacing && styles2.spacing];
  }
})({
  display: "flex",
  alignItems: "center",
  padding: 8,
  variants: [{
    props: {
      disableSpacing: false
    },
    style: {
      "& > :not(style) ~ :not(style)": {
        marginLeft: 8
      }
    }
  }]
});
const CardActions$1 = /* @__PURE__ */ reactExports.forwardRef(function CardActions(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiCardActions"
  });
  const {
    disableSpacing = false,
    className,
    ...other
  } = props;
  const ownerState = {
    ...props,
    disableSpacing
  };
  const classes = useUtilityClasses$Z(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CardActionsRoot, {
    className: clsx(classes.root, className),
    ownerState,
    ref: ref2,
    ...other
  });
});
process.env.NODE_ENV !== "production" ? CardActions$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getCardContentUtilityClass(slot) {
  return generateUtilityClass("MuiCardContent", slot);
}
generateUtilityClasses("MuiCardContent", ["root"]);
const useUtilityClasses$Y = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getCardContentUtilityClass, classes);
};
const CardContentRoot = styled("div", {
  name: "MuiCardContent",
  slot: "Root"
})({
  padding: 16,
  "&:last-child": {
    paddingBottom: 24
  }
});
const CardContent$1 = /* @__PURE__ */ reactExports.forwardRef(function CardContent(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiCardContent"
  });
  const {
    className,
    component = "div",
    ...other
  } = props;
  const ownerState = {
    ...props,
    component
  };
  const classes = useUtilityClasses$Y(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CardContentRoot, {
    as: component,
    className: clsx(classes.root, className),
    ownerState,
    ref: ref2,
    ...other
  });
});
process.env.NODE_ENV !== "production" ? CardContent$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getCardHeaderUtilityClass(slot) {
  return generateUtilityClass("MuiCardHeader", slot);
}
const cardHeaderClasses = generateUtilityClasses("MuiCardHeader", ["root", "avatar", "action", "content", "title", "subheader"]);
const useUtilityClasses$X = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    avatar: ["avatar"],
    action: ["action"],
    content: ["content"],
    title: ["title"],
    subheader: ["subheader"]
  };
  return composeClasses(slots, getCardHeaderUtilityClass, classes);
};
const CardHeaderRoot = styled("div", {
  name: "MuiCardHeader",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    return [{
      [`& .${cardHeaderClasses.title}`]: styles2.title
    }, {
      [`& .${cardHeaderClasses.subheader}`]: styles2.subheader
    }, styles2.root];
  }
})({
  display: "flex",
  alignItems: "center",
  padding: 16
});
const CardHeaderAvatar = styled("div", {
  name: "MuiCardHeader",
  slot: "Avatar"
})({
  display: "flex",
  flex: "0 0 auto",
  marginRight: 16
});
const CardHeaderAction = styled("div", {
  name: "MuiCardHeader",
  slot: "Action"
})({
  flex: "0 0 auto",
  alignSelf: "flex-start",
  marginTop: -4,
  marginRight: -8,
  marginBottom: -4
});
const CardHeaderContent = styled("div", {
  name: "MuiCardHeader",
  slot: "Content"
})({
  flex: "1 1 auto",
  // Combine this and the below selector once https://github.com/emotion-js/emotion/issues/3366 is solved
  [`.${typographyClasses.root}:where(& .${cardHeaderClasses.title})`]: {
    display: "block"
  },
  [`.${typographyClasses.root}:where(& .${cardHeaderClasses.subheader})`]: {
    display: "block"
  }
});
const CardHeader$1 = /* @__PURE__ */ reactExports.forwardRef(function CardHeader(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiCardHeader"
  });
  const {
    action,
    avatar,
    component = "div",
    disableTypography = false,
    subheader: subheaderProp,
    subheaderTypographyProps,
    title: titleProp,
    titleTypographyProps,
    slots = {},
    slotProps = {},
    ...other
  } = props;
  const ownerState = {
    ...props,
    component,
    disableTypography
  };
  const classes = useUtilityClasses$X(ownerState);
  const externalForwardedProps = {
    slots,
    slotProps: {
      title: titleTypographyProps,
      subheader: subheaderTypographyProps,
      ...slotProps
    }
  };
  let title = titleProp;
  const [TitleSlot, titleSlotProps] = useSlot("title", {
    className: classes.title,
    elementType: Typography$1,
    externalForwardedProps,
    ownerState,
    additionalProps: {
      variant: avatar ? "body2" : "h5",
      component: "span"
    }
  });
  if (title != null && title.type !== Typography$1 && !disableTypography) {
    title = /* @__PURE__ */ jsxRuntimeExports.jsx(TitleSlot, {
      ...titleSlotProps,
      children: title
    });
  }
  let subheader = subheaderProp;
  const [SubheaderSlot, subheaderSlotProps] = useSlot("subheader", {
    className: classes.subheader,
    elementType: Typography$1,
    externalForwardedProps,
    ownerState,
    additionalProps: {
      variant: avatar ? "body2" : "body1",
      color: "textSecondary",
      component: "span"
    }
  });
  if (subheader != null && subheader.type !== Typography$1 && !disableTypography) {
    subheader = /* @__PURE__ */ jsxRuntimeExports.jsx(SubheaderSlot, {
      ...subheaderSlotProps,
      children: subheader
    });
  }
  const [RootSlot, rootSlotProps] = useSlot("root", {
    ref: ref2,
    className: classes.root,
    elementType: CardHeaderRoot,
    externalForwardedProps: {
      ...externalForwardedProps,
      ...other,
      component
    },
    ownerState
  });
  const [AvatarSlot, avatarSlotProps] = useSlot("avatar", {
    className: classes.avatar,
    elementType: CardHeaderAvatar,
    externalForwardedProps,
    ownerState
  });
  const [ContentSlot, contentSlotProps] = useSlot("content", {
    className: classes.content,
    elementType: CardHeaderContent,
    externalForwardedProps,
    ownerState
  });
  const [ActionSlot, actionSlotProps] = useSlot("action", {
    className: classes.action,
    elementType: CardHeaderAction,
    externalForwardedProps,
    ownerState
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(RootSlot, {
    ...rootSlotProps,
    children: [avatar && /* @__PURE__ */ jsxRuntimeExports.jsx(AvatarSlot, {
      ...avatarSlotProps,
      children: avatar
    }), /* @__PURE__ */ jsxRuntimeExports.jsxs(ContentSlot, {
      ...contentSlotProps,
      children: [title, subheader]
    }), action && /* @__PURE__ */ jsxRuntimeExports.jsx(ActionSlot, {
      ...actionSlotProps,
      children: action
    })]
  });
});
process.env.NODE_ENV !== "production" ? CardHeader$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display in the card header.
   */
  action: PropTypes.node,
  /**
   * The Avatar element to display.
   */
  avatar: PropTypes.node,
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    action: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    avatar: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    content: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    subheader: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    title: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    action: PropTypes.elementType,
    avatar: PropTypes.elementType,
    content: PropTypes.elementType,
    root: PropTypes.elementType,
    subheader: PropTypes.elementType,
    title: PropTypes.elementType
  }),
  /**
   * The content of the component.
   */
  subheader: PropTypes.node,
  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.subheader` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  subheaderTypographyProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The content of the component.
   */
  title: PropTypes.node,
  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.title` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  titleTypographyProps: PropTypes.object
} : void 0;
function getSwitchBaseUtilityClass(slot) {
  return generateUtilityClass("PrivateSwitchBase", slot);
}
generateUtilityClasses("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const useUtilityClasses$W = (ownerState) => {
  const {
    classes,
    checked: checked2,
    disabled,
    edge
  } = ownerState;
  const slots = {
    root: ["root", checked2 && "checked", disabled && "disabled", edge && `edge${capitalize$2(edge)}`],
    input: ["input"]
  };
  return composeClasses(slots, getSwitchBaseUtilityClass, classes);
};
const SwitchBaseRoot = styled(ButtonBase, {
  name: "MuiSwitchBase"
})({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge,
      ownerState
    }) => edge === "start" && ownerState.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge,
      ownerState
    }) => edge === "end" && ownerState.size !== "small",
    style: {
      marginRight: -12
    }
  }]
});
const SwitchBaseInput = styled("input", {
  name: "MuiSwitchBase",
  shouldForwardProp: rootShouldForwardProp
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
});
const SwitchBase = /* @__PURE__ */ reactExports.forwardRef(function SwitchBase2(props, ref2) {
  const {
    autoFocus,
    checked: checkedProp,
    checkedIcon,
    defaultChecked,
    disabled: disabledProp,
    disableFocusRipple = false,
    edge = false,
    icon,
    id,
    inputProps,
    inputRef,
    name,
    onBlur,
    onChange,
    onFocus,
    readOnly,
    required = false,
    tabIndex,
    type,
    value,
    slots = {},
    slotProps = {},
    ...other
  } = props;
  const [checked2, setCheckedState] = useControlled({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: "SwitchBase",
    state: "checked"
  });
  const muiFormControl = useFormControl();
  const handleFocus = (event2) => {
    if (onFocus) {
      onFocus(event2);
    }
    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event2);
    }
  };
  const handleBlur = (event2) => {
    if (onBlur) {
      onBlur(event2);
    }
    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event2);
    }
  };
  const handleInputChange = (event2) => {
    if (event2.nativeEvent.defaultPrevented || readOnly) {
      return;
    }
    const newChecked = event2.target.checked;
    setCheckedState(newChecked);
    if (onChange) {
      onChange(event2, newChecked);
    }
  };
  let disabled = disabledProp;
  if (muiFormControl) {
    if (typeof disabled === "undefined") {
      disabled = muiFormControl.disabled;
    }
  }
  const hasLabelFor = type === "checkbox" || type === "radio";
  const ownerState = {
    ...props,
    checked: checked2,
    disabled,
    disableFocusRipple,
    edge
  };
  const classes = useUtilityClasses$W(ownerState);
  const externalForwardedProps = {
    slots,
    slotProps: {
      input: inputProps,
      ...slotProps
    }
  };
  const [RootSlot, rootSlotProps] = useSlot("root", {
    ref: ref2,
    elementType: SwitchBaseRoot,
    className: classes.root,
    shouldForwardComponentProp: true,
    externalForwardedProps: {
      ...externalForwardedProps,
      component: "span",
      ...other
    },
    getSlotProps: (handlers) => ({
      ...handlers,
      onFocus: (event2) => {
        handlers.onFocus?.(event2);
        handleFocus(event2);
      },
      onBlur: (event2) => {
        handlers.onBlur?.(event2);
        handleBlur(event2);
      }
    }),
    ownerState,
    additionalProps: {
      centerRipple: true,
      focusRipple: !disableFocusRipple,
      role: void 0,
      tabIndex: null
    }
  });
  const [InputSlot, inputSlotProps] = useSlot("input", {
    ref: inputRef,
    elementType: SwitchBaseInput,
    className: classes.input,
    externalForwardedProps,
    getSlotProps: (handlers) => ({
      ...handlers,
      onChange: (event2) => {
        handlers.onChange?.(event2);
        handleInputChange(event2);
      }
    }),
    ownerState,
    additionalProps: {
      autoFocus,
      checked: checkedProp,
      defaultChecked,
      disabled,
      id: hasLabelFor ? id : void 0,
      name,
      readOnly,
      required,
      tabIndex,
      type,
      ...type === "checkbox" && value === void 0 ? {} : {
        value
      }
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(RootSlot, {
    ...rootSlotProps,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(InputSlot, {
      ...inputSlotProps
    }), checked2 ? checkedIcon : icon]
  });
});
process.env.NODE_ENV !== "production" ? SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", false]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /*
   * @ignore
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The input component prop `type`.
   */
  type: PropTypes.string.isRequired,
  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
const CheckBoxOutlineBlankIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");
const CheckBoxIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");
const IndeterminateCheckBoxIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function getCheckboxUtilityClass(slot) {
  return generateUtilityClass("MuiCheckbox", slot);
}
const checkboxClasses = generateUtilityClasses("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]);
const useUtilityClasses$V = (ownerState) => {
  const {
    classes,
    indeterminate,
    color: color2,
    size
  } = ownerState;
  const slots = {
    root: ["root", indeterminate && "indeterminate", `color${capitalize$2(color2)}`, `size${capitalize$2(size)}`]
  };
  const composedClasses = composeClasses(slots, getCheckboxUtilityClass, classes);
  return {
    ...classes,
    // forward the disabled and checked classes to the SwitchBase
    ...composedClasses
  };
};
const CheckboxRoot = styled(SwitchBase, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.indeterminate && styles2.indeterminate, styles2[`size${capitalize$2(ownerState.size)}`], ownerState.color !== "default" && styles2[`color${capitalize$2(ownerState.color)}`]];
  }
})(memoTheme(({
  theme
}) => ({
  color: (theme.vars || theme).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: false
    },
    style: {
      "&:hover": {
        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color2]) => ({
    props: {
      color: color2,
      disableRipple: false
    },
    style: {
      "&:hover": {
        backgroundColor: theme.alpha((theme.vars || theme).palette[color2].main, (theme.vars || theme).palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color2]) => ({
    props: {
      color: color2
    },
    style: {
      [`&.${checkboxClasses.checked}, &.${checkboxClasses.indeterminate}`]: {
        color: (theme.vars || theme).palette[color2].main
      },
      [`&.${checkboxClasses.disabled}`]: {
        color: (theme.vars || theme).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: false
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
})));
const defaultCheckedIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(CheckBoxIcon, {});
const defaultIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(CheckBoxOutlineBlankIcon, {});
const defaultIndeterminateIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(IndeterminateCheckBoxIcon, {});
const Checkbox$1 = /* @__PURE__ */ reactExports.forwardRef(function Checkbox(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiCheckbox"
  });
  const {
    checkedIcon = defaultCheckedIcon,
    color: color2 = "primary",
    icon: iconProp = defaultIcon,
    indeterminate = false,
    indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon,
    inputProps,
    size = "medium",
    disableRipple = false,
    className,
    slots = {},
    slotProps = {},
    ...other
  } = props;
  const icon = indeterminate ? indeterminateIconProp : iconProp;
  const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  const ownerState = {
    ...props,
    disableRipple,
    color: color2,
    indeterminate,
    size
  };
  const classes = useUtilityClasses$V(ownerState);
  const externalInputProps = slotProps.input ?? inputProps;
  const [RootSlot, rootSlotProps] = useSlot("root", {
    ref: ref2,
    elementType: CheckboxRoot,
    className: clsx(classes.root, className),
    shouldForwardComponentProp: true,
    externalForwardedProps: {
      slots,
      slotProps,
      ...other
    },
    ownerState,
    additionalProps: {
      type: "checkbox",
      icon: /* @__PURE__ */ reactExports.cloneElement(icon, {
        fontSize: icon.props.fontSize ?? size
      }),
      checkedIcon: /* @__PURE__ */ reactExports.cloneElement(indeterminateIcon, {
        fontSize: indeterminateIcon.props.fontSize ?? size
      }),
      disableRipple,
      slots,
      slotProps: {
        input: mergeSlotProps$2(typeof externalInputProps === "function" ? externalInputProps(ownerState) : externalInputProps, {
          "data-indeterminate": indeterminate,
          "aria-checked": indeterminate ? "mixed" : void 0
        })
      }
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RootSlot, {
    ...rootSlotProps,
    classes
  });
});
process.env.NODE_ENV !== "production" ? Checkbox$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: PropTypes.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: PropTypes.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: PropTypes.object,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
} : void 0;
function getScrollbarSize(win = window) {
  const documentWidth = win.document.documentElement.clientWidth;
  return win.innerWidth - documentWidth;
}
function isOverflowing(container) {
  const doc = ownerDocument(container);
  if (doc.body === container) {
    return ownerWindow(container).innerWidth > doc.documentElement.clientWidth;
  }
  return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, hide2) {
  if (hide2) {
    element.setAttribute("aria-hidden", "true");
  } else {
    element.removeAttribute("aria-hidden");
  }
}
function getPaddingRight(element) {
  return parseFloat(ownerWindow(element).getComputedStyle(element).paddingRight) || 0;
}
function isAriaHiddenForbiddenOnElement(element) {
  const forbiddenTagNames = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"];
  const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
  const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
  return isForbiddenTagName || isInputHidden;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide2) {
  const blacklist = [mountElement, currentElement, ...elementsToExclude];
  [].forEach.call(container.children, (element) => {
    const isNotExcludedElement = !blacklist.includes(element);
    const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
    if (isNotExcludedElement && isNotForbiddenElement) {
      ariaHidden(element, hide2);
    }
  });
}
function findIndexOf(items, callback) {
  let idx = -1;
  items.some((item, index2) => {
    if (callback(item)) {
      idx = index2;
      return true;
    }
    return false;
  });
  return idx;
}
function handleContainer(containerInfo, props) {
  const restoreStyle = [];
  const container = containerInfo.container;
  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      const scrollbarSize = getScrollbarSize(ownerWindow(container));
      restoreStyle.push({
        value: container.style.paddingRight,
        property: "padding-right",
        el: container
      });
      container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`;
      const fixedElements2 = ownerDocument(container).querySelectorAll(".mui-fixed");
      [].forEach.call(fixedElements2, (element) => {
        restoreStyle.push({
          value: element.style.paddingRight,
          property: "padding-right",
          el: element
        });
        element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
      });
    }
    let scrollContainer;
    if (container.parentNode instanceof DocumentFragment) {
      scrollContainer = ownerDocument(container).body;
    } else {
      const parent2 = container.parentElement;
      const containerWindow = ownerWindow(container);
      scrollContainer = parent2?.nodeName === "HTML" && containerWindow.getComputedStyle(parent2).overflowY === "scroll" ? parent2 : container;
    }
    restoreStyle.push({
      value: scrollContainer.style.overflow,
      property: "overflow",
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowX,
      property: "overflow-x",
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowY,
      property: "overflow-y",
      el: scrollContainer
    });
    scrollContainer.style.overflow = "hidden";
  }
  const restore = () => {
    restoreStyle.forEach(({
      value,
      el,
      property: property2
    }) => {
      if (value) {
        el.style.setProperty(property2, value);
      } else {
        el.style.removeProperty(property2);
      }
    });
  };
  return restore;
}
function getHiddenSiblings(container) {
  const hiddenSiblings = [];
  [].forEach.call(container.children, (element) => {
    if (element.getAttribute("aria-hidden") === "true") {
      hiddenSiblings.push(element);
    }
  });
  return hiddenSiblings;
}
class ModalManager {
  constructor() {
    this.modals = [];
    this.containers = [];
  }
  add(modal, container) {
    let modalIndex = this.modals.indexOf(modal);
    if (modalIndex !== -1) {
      return modalIndex;
    }
    modalIndex = this.modals.length;
    this.modals.push(modal);
    if (modal.modalRef) {
      ariaHidden(modal.modalRef, false);
    }
    const hiddenSiblings = getHiddenSiblings(container);
    ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
    const containerIndex = findIndexOf(this.containers, (item) => item.container === container);
    if (containerIndex !== -1) {
      this.containers[containerIndex].modals.push(modal);
      return modalIndex;
    }
    this.containers.push({
      modals: [modal],
      container,
      restore: null,
      hiddenSiblings
    });
    return modalIndex;
  }
  mount(modal, props) {
    const containerIndex = findIndexOf(this.containers, (item) => item.modals.includes(modal));
    const containerInfo = this.containers[containerIndex];
    if (!containerInfo.restore) {
      containerInfo.restore = handleContainer(containerInfo, props);
    }
  }
  remove(modal, ariaHiddenState = true) {
    const modalIndex = this.modals.indexOf(modal);
    if (modalIndex === -1) {
      return modalIndex;
    }
    const containerIndex = findIndexOf(this.containers, (item) => item.modals.includes(modal));
    const containerInfo = this.containers[containerIndex];
    containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
    this.modals.splice(modalIndex, 1);
    if (containerInfo.modals.length === 0) {
      if (containerInfo.restore) {
        containerInfo.restore();
      }
      if (modal.modalRef) {
        ariaHidden(modal.modalRef, ariaHiddenState);
      }
      ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
      this.containers.splice(containerIndex, 1);
    } else {
      const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
      if (nextTop.modalRef) {
        ariaHidden(nextTop.modalRef, false);
      }
    }
    return modalIndex;
  }
  isTopModal(modal) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
  }
}
const FOCUSABLE_ATTRIBUTE = "data-mui-focusable";
function getFocusTarget(rootElement) {
  if (!rootElement) {
    return null;
  }
  return rootElement.hasAttribute(FOCUSABLE_ATTRIBUTE) ? rootElement : rootElement.querySelector(`[${FOCUSABLE_ATTRIBUTE}]`);
}
const candidatesSelector = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function getTabIndex(node2) {
  const tabindexAttr = parseInt(node2.getAttribute("tabindex") || "", 10);
  if (!Number.isNaN(tabindexAttr)) {
    return tabindexAttr;
  }
  if (node2.contentEditable === "true" || (node2.nodeName === "AUDIO" || node2.nodeName === "VIDEO" || node2.nodeName === "DETAILS") && node2.getAttribute("tabindex") === null) {
    return 0;
  }
  return node2.tabIndex;
}
function isNonTabbableRadio(node2) {
  if (node2.tagName !== "INPUT" || node2.type !== "radio") {
    return false;
  }
  if (!node2.name) {
    return false;
  }
  const getRadio = (selector) => node2.ownerDocument.querySelector(`input[type="radio"]${selector}`);
  let roving = getRadio(`[name="${node2.name}"]:checked`);
  if (!roving) {
    roving = getRadio(`[name="${node2.name}"]`);
  }
  return roving !== node2;
}
function isNodeMatchingSelectorFocusable(node2) {
  if (node2.disabled || node2.tagName === "INPUT" && node2.type === "hidden" || isNonTabbableRadio(node2)) {
    return false;
  }
  return true;
}
function defaultGetTabbable(root2) {
  const regularTabNodes = [];
  const orderedTabNodes = [];
  Array.from(root2.querySelectorAll(candidatesSelector)).forEach((node2, i) => {
    const nodeTabIndex = getTabIndex(node2);
    if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node2)) {
      return;
    }
    if (nodeTabIndex === 0) {
      regularTabNodes.push(node2);
    } else {
      orderedTabNodes.push({
        documentOrder: i,
        tabIndex: nodeTabIndex,
        node: node2
      });
    }
  });
  return orderedTabNodes.sort((a, b) => a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a) => a.node).concat(regularTabNodes);
}
function defaultIsEnabled() {
  return true;
}
function FocusTrap(props) {
  const {
    children,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableRestoreFocus = false,
    getTabbable = defaultGetTabbable,
    isEnabled = defaultIsEnabled,
    open: open2
  } = props;
  const ignoreNextEnforceFocus = reactExports.useRef(false);
  const sentinelStart = reactExports.useRef(null);
  const sentinelEnd = reactExports.useRef(null);
  const nodeToRestore = reactExports.useRef(null);
  const reactFocusEventTarget = reactExports.useRef(null);
  const activated = reactExports.useRef(false);
  const rootRef = reactExports.useRef(null);
  const handleRef = useForkRef(getReactElementRef(children), rootRef);
  const lastKeydown = reactExports.useRef(null);
  reactExports.useEffect(() => {
    if (!open2 || !rootRef.current) {
      return;
    }
    activated.current = !disableAutoFocus;
  }, [disableAutoFocus, open2]);
  reactExports.useEffect(() => {
    ignoreNextEnforceFocus.current = false;
    if (!open2 || !rootRef.current) {
      return;
    }
    const doc = ownerDocument(rootRef.current);
    const activeElement$1 = activeElement(doc);
    const focusTarget = getFocusTarget(rootRef.current) ?? rootRef.current;
    if (!contains$1(rootRef.current, activeElement$1)) {
      if (!focusTarget.hasAttribute("tabIndex")) {
        if (process.env.NODE_ENV !== "production") {
          console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join("\n"));
        }
        focusTarget.setAttribute("tabIndex", "-1");
      }
      if (activated.current) {
        focusTarget.focus();
      }
    }
    return () => {
      if (!disableRestoreFocus) {
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          ignoreNextEnforceFocus.current = true;
          nodeToRestore.current.focus();
        }
        nodeToRestore.current = null;
      }
    };
  }, [open2]);
  reactExports.useEffect(() => {
    if (!open2 || !rootRef.current) {
      return;
    }
    const doc = ownerDocument(rootRef.current);
    const loopFocus = (nativeEvent) => {
      lastKeydown.current = nativeEvent;
      if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") {
        return;
      }
      const activeElement$1 = activeElement(doc);
      if (activeElement$1 === rootRef.current && nativeEvent.shiftKey) {
        ignoreNextEnforceFocus.current = true;
        if (sentinelEnd.current) {
          sentinelEnd.current.focus();
        }
      }
    };
    const contain = () => {
      const rootElement = rootRef.current;
      if (rootElement === null) {
        return;
      }
      const activeEl = activeElement(doc);
      if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }
      if (contains$1(rootElement, activeEl)) {
        return;
      }
      if (disableEnforceFocus && activeEl !== sentinelStart.current && activeEl !== sentinelEnd.current) {
        return;
      }
      if (activeEl !== reactFocusEventTarget.current) {
        reactFocusEventTarget.current = null;
      } else if (reactFocusEventTarget.current !== null) {
        return;
      }
      if (!activated.current) {
        return;
      }
      let tabbable = [];
      if (activeEl === sentinelStart.current || activeEl === sentinelEnd.current) {
        tabbable = getTabbable(rootRef.current);
      }
      if (tabbable.length > 0) {
        const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === "Tab");
        const focusNext = tabbable[0];
        const focusPrevious = tabbable[tabbable.length - 1];
        if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
          if (isShiftTab) {
            focusPrevious.focus();
          } else {
            focusNext.focus();
          }
        }
      } else {
        rootElement.focus();
      }
    };
    doc.addEventListener("focusin", contain);
    doc.addEventListener("keydown", loopFocus, true);
    const interval2 = setInterval(() => {
      const activeEl = activeElement(doc);
      if (activeEl && activeEl.tagName === "BODY") {
        contain();
      }
    }, 50);
    return () => {
      clearInterval(interval2);
      doc.removeEventListener("focusin", contain);
      doc.removeEventListener("keydown", loopFocus, true);
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open2, getTabbable]);
  const onFocus = (event2) => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event2.relatedTarget;
    }
    activated.current = true;
    reactFocusEventTarget.current = event2.target;
    const childrenPropsHandler = children.props.onFocus;
    if (childrenPropsHandler) {
      childrenPropsHandler(event2);
    }
  };
  const handleFocusSentinel = (event2) => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event2.relatedTarget;
    }
    activated.current = true;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: open2 ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelStart,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ reactExports.cloneElement(children, {
      ref: handleRef,
      onFocus
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: open2 ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelEnd,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" ? FocusTrap.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes.bool.isRequired
} : void 0;
if (process.env.NODE_ENV !== "production") {
  FocusTrap["propTypes"] = exactProp(FocusTrap.propTypes);
}
function getContainer(container) {
  return typeof container === "function" ? container() : container;
}
function getHasTransition(children) {
  return children ? children.props.hasOwnProperty("in") : false;
}
const noop$3 = () => {
};
const manager = new ModalManager();
function useModal(parameters) {
  const {
    container,
    disableEscapeKeyDown = false,
    disableScrollLock = false,
    closeAfterTransition = false,
    onTransitionEnter,
    onTransitionExited,
    children,
    onClose,
    open: open2,
    rootRef
  } = parameters;
  const modal = reactExports.useRef({});
  const mountNodeRef = reactExports.useRef(null);
  const modalRef = reactExports.useRef(null);
  const handleRef = useForkRef(modalRef, rootRef);
  const [exited, setExited] = reactExports.useState(!open2);
  const hasTransition = getHasTransition(children);
  let ariaHiddenProp = true;
  if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) {
    ariaHiddenProp = false;
  }
  const getDoc = () => ownerDocument(mountNodeRef.current);
  const getModal = () => {
    modal.current.modalRef = modalRef.current;
    modal.current.mount = mountNodeRef.current;
    return modal.current;
  };
  const handleMounted = () => {
    manager.mount(getModal(), {
      disableScrollLock
    });
    if (modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  };
  const handleOpen = useEventCallback(() => {
    const resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer);
    if (modalRef.current) {
      handleMounted();
    }
  });
  const isTopModal = () => manager.isTopModal(getModal());
  const handlePortalRef = useEventCallback((node2) => {
    mountNodeRef.current = node2;
    if (!node2) {
      return;
    }
    if (open2 && isTopModal()) {
      handleMounted();
    } else if (modalRef.current) {
      ariaHidden(modalRef.current, ariaHiddenProp);
    }
  });
  const handleClose = reactExports.useCallback(() => {
    manager.remove(getModal(), ariaHiddenProp);
  }, [ariaHiddenProp]);
  reactExports.useEffect(() => {
    return () => {
      handleClose();
    };
  }, [handleClose]);
  reactExports.useEffect(() => {
    if (open2) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open2, handleClose, hasTransition, closeAfterTransition, handleOpen]);
  const createHandleKeyDown = (otherHandlers) => (event2) => {
    otherHandlers.onKeyDown?.(event2);
    if (event2.key !== "Escape" || event2.which === 229 || // Wait until IME is settled.
    !isTopModal()) {
      return;
    }
    if (!disableEscapeKeyDown) {
      event2.stopPropagation();
      if (onClose) {
        onClose(event2, "escapeKeyDown");
      }
    }
  };
  const createHandleBackdropClick = (otherHandlers) => (event2) => {
    otherHandlers.onClick?.(event2);
    if (event2.target !== event2.currentTarget) {
      return;
    }
    if (onClose) {
      onClose(event2, "backdropClick");
    }
  };
  const getRootProps = (otherHandlers = {}) => {
    const propsEventHandlers = extractEventHandlers(parameters);
    delete propsEventHandlers.onTransitionEnter;
    delete propsEventHandlers.onTransitionExited;
    const externalEventHandlers = {
      ...propsEventHandlers,
      ...otherHandlers
    };
    return {
      /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */
      role: "presentation",
      ...externalEventHandlers,
      onKeyDown: createHandleKeyDown(externalEventHandlers),
      ref: handleRef
    };
  };
  const getBackdropProps = (otherHandlers = {}) => {
    const externalEventHandlers = otherHandlers;
    return {
      "aria-hidden": true,
      ...externalEventHandlers,
      onClick: createHandleBackdropClick(externalEventHandlers),
      open: open2
    };
  };
  const getTransitionProps2 = () => {
    const handleEnter = () => {
      setExited(false);
      if (onTransitionEnter) {
        onTransitionEnter();
      }
    };
    const handleExited = () => {
      setExited(true);
      if (onTransitionExited) {
        onTransitionExited();
      }
      if (closeAfterTransition) {
        handleClose();
      }
    };
    return {
      onEnter: createChainedFunction(handleEnter, children?.props.onEnter ?? noop$3),
      onExited: createChainedFunction(handleExited, children?.props.onExited ?? noop$3)
    };
  };
  return {
    getRootProps,
    getBackdropProps,
    getTransitionProps: getTransitionProps2,
    rootRef: handleRef,
    portalRef: handlePortalRef,
    isTopModal,
    exited,
    hasTransition
  };
}
function getModalUtilityClass(slot) {
  return generateUtilityClass("MuiModal", slot);
}
generateUtilityClasses("MuiModal", ["root", "hidden", "backdrop"]);
const useUtilityClasses$U = (ownerState) => {
  const {
    open: open2,
    exited,
    classes
  } = ownerState;
  const slots = {
    root: ["root", !open2 && exited && "hidden"],
    backdrop: ["backdrop"]
  };
  return composeClasses(slots, getModalUtilityClass, classes);
};
const ModalRoot = styled("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, !ownerState.open && ownerState.exited && styles2.hidden];
  }
})(memoTheme(({
  theme
}) => ({
  position: "fixed",
  zIndex: (theme.vars || theme).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState
    }) => !ownerState.open && ownerState.exited,
    style: {
      visibility: "hidden"
    }
  }]
})));
const ModalBackdrop = styled(Backdrop, {
  name: "MuiModal",
  slot: "Backdrop"
})({
  zIndex: -1
});
const Modal = /* @__PURE__ */ reactExports.forwardRef(function Modal2(inProps, ref2) {
  const props = useDefaultProps({
    name: "MuiModal",
    props: inProps
  });
  const {
    BackdropComponent = ModalBackdrop,
    BackdropProps,
    classes: classesProp,
    className,
    closeAfterTransition = false,
    children,
    container,
    component,
    components = {},
    componentsProps = {},
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = false,
    disableRestoreFocus = false,
    disableScrollLock = false,
    hideBackdrop = false,
    keepMounted = false,
    onClose,
    onTransitionEnter,
    onTransitionExited,
    open: open2,
    slotProps = {},
    slots = {},
    // eslint-disable-next-line react/prop-types
    theme,
    ...other
  } = props;
  const propsWithDefaults = {
    ...props,
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted
  };
  const {
    getRootProps,
    getBackdropProps,
    getTransitionProps: getTransitionProps2,
    portalRef,
    isTopModal,
    exited,
    hasTransition
  } = useModal({
    ...propsWithDefaults,
    rootRef: ref2
  });
  const ownerState = {
    ...propsWithDefaults,
    exited
  };
  const classes = useUtilityClasses$U(ownerState);
  const childProps = {};
  if (children.props.tabIndex === void 0) {
    childProps.tabIndex = "-1";
  }
  if (hasTransition) {
    const {
      onEnter,
      onExited
    } = getTransitionProps2();
    childProps.onEnter = onEnter;
    childProps.onExited = onExited;
  }
  const externalForwardedProps = {
    slots: {
      root: components.Root,
      backdrop: components.Backdrop,
      ...slots
    },
    slotProps: {
      ...componentsProps,
      ...slotProps
    }
  };
  const [RootSlot, rootProps] = useSlot("root", {
    ref: ref2,
    elementType: ModalRoot,
    externalForwardedProps: {
      ...externalForwardedProps,
      ...other,
      component
    },
    getSlotProps: getRootProps,
    ownerState,
    className: clsx(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
  });
  const [BackdropSlot, backdropProps] = useSlot("backdrop", {
    ref: BackdropProps?.ref,
    elementType: BackdropComponent,
    externalForwardedProps,
    shouldForwardComponentProp: true,
    additionalProps: BackdropProps,
    getSlotProps: (otherHandlers) => {
      return getBackdropProps({
        ...otherHandlers,
        onClick: (event2) => {
          if (otherHandlers?.onClick) {
            otherHandlers.onClick(event2);
          }
        }
      });
    },
    className: clsx(BackdropProps?.className, classes?.backdrop),
    ownerState
  });
  if (!keepMounted && !open2 && (!hasTransition || exited)) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    ref: portalRef,
    container,
    disablePortal,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(RootSlot, {
      ...rootProps,
      children: [!hideBackdrop && BackdropComponent ? /* @__PURE__ */ jsxRuntimeExports.jsx(BackdropSlot, {
        ...backdropProps
      }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap, {
        disableEnforceFocus,
        disableAutoFocus,
        disableRestoreFocus,
        isEnabled: isTopModal,
        open: open2,
        children: /* @__PURE__ */ reactExports.cloneElement(children, childProps)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" ? Modal.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: PropTypes.object,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Backdrop: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getDialogUtilityClass(slot) {
  return generateUtilityClass("MuiDialog", slot);
}
const dialogClasses = generateUtilityClasses("MuiDialog", ["root", "backdrop", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]);
const DialogContext = /* @__PURE__ */ reactExports.createContext({});
if (process.env.NODE_ENV !== "production") {
  DialogContext.displayName = "DialogContext";
}
const DialogBackdrop = styled(Backdrop, {
  name: "MuiDialog",
  slot: "Backdrop"
})({
  // Improve scrollable dialog support.
  zIndex: -1
});
const useUtilityClasses$T = (ownerState) => {
  const {
    classes,
    scroll,
    maxWidth: maxWidth2,
    fullWidth,
    fullScreen
  } = ownerState;
  const slots = {
    root: ["root"],
    backdrop: ["backdrop"],
    container: ["container", `scroll${capitalize$2(scroll)}`],
    paper: ["paper", `paperScroll${capitalize$2(scroll)}`, `paperWidth${capitalize$2(String(maxWidth2))}`, fullWidth && "paperFullWidth", fullScreen && "paperFullScreen"]
  };
  return composeClasses(slots, getDialogUtilityClass, classes);
};
const DialogRoot = styled(Modal, {
  name: "MuiDialog",
  slot: "Root"
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
});
const DialogContainer = styled("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.container, styles2[`scroll${capitalize$2(ownerState.scroll)}`]];
  }
})({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&::after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0"
      }
    }
  }]
});
const DialogPaper = styled(Paper, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.paper, styles2[`scrollPaper${capitalize$2(ownerState.scroll)}`], styles2[`paperWidth${capitalize$2(String(ownerState.maxWidth))}`], ownerState.fullWidth && styles2.paperFullWidth, ownerState.fullScreen && styles2.paperFullScreen];
  }
})(memoTheme(({
  theme
}) => ({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  },
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100% - 64px)"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      display: "inline-block",
      verticalAlign: "middle",
      textAlign: "initial"
    }
  }, {
    props: ({
      ownerState
    }) => !ownerState.maxWidth,
    style: {
      maxWidth: "calc(100% - 64px)"
    }
  }, {
    props: {
      maxWidth: "xs"
    },
    style: {
      maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
      [`&.${dialogClasses.paperScrollBody}`]: {
        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  }, ...Object.keys(theme.breakpoints.values).filter((maxWidth2) => maxWidth2 !== "xs").map((maxWidth2) => ({
    props: {
      maxWidth: maxWidth2
    },
    style: {
      maxWidth: `${theme.breakpoints.values[maxWidth2]}${theme.breakpoints.unit}`,
      [`&.${dialogClasses.paperScrollBody}`]: {
        [theme.breakpoints.down(theme.breakpoints.values[maxWidth2] + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  })), {
    props: ({
      ownerState
    }) => ownerState.fullWidth,
    style: {
      width: "calc(100% - 64px)"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.fullScreen,
    style: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
      [`&.${dialogClasses.paperScrollBody}`]: {
        margin: 0,
        maxWidth: "100%"
      }
    }
  }]
})));
const Dialog = /* @__PURE__ */ reactExports.forwardRef(function Dialog2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiDialog"
  });
  const theme = useTheme();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledbyProp,
    "aria-modal": ariaModal = true,
    BackdropComponent,
    BackdropProps,
    children,
    className,
    disableEscapeKeyDown = false,
    fullScreen = false,
    fullWidth = false,
    maxWidth: maxWidth2 = "sm",
    onClick,
    onClose,
    open: open2,
    PaperComponent = Paper,
    PaperProps = {},
    role = "dialog",
    scroll = "paper",
    slots = {},
    slotProps = {},
    TransitionComponent = Fade,
    transitionDuration = defaultTransitionDuration,
    TransitionProps,
    ...other
  } = props;
  const ownerState = {
    ...props,
    disableEscapeKeyDown,
    fullScreen,
    fullWidth,
    maxWidth: maxWidth2,
    scroll
  };
  const classes = useUtilityClasses$T(ownerState);
  const backdropClick = reactExports.useRef();
  const handleMouseDown = (event2) => {
    backdropClick.current = event2.target === event2.currentTarget;
  };
  const handleBackdropClick = (event2) => {
    if (onClick) {
      onClick(event2);
    }
    if (!backdropClick.current) {
      return;
    }
    backdropClick.current = null;
    if (onClose) {
      onClose(event2, "backdropClick");
    }
  };
  const ariaLabelledby = useId(ariaLabelledbyProp);
  const dialogContextValue = reactExports.useMemo(() => {
    return {
      titleId: ariaLabelledby
    };
  }, [ariaLabelledby]);
  const backwardCompatibleSlots = {
    transition: TransitionComponent,
    ...slots
  };
  const backwardCompatibleSlotProps = {
    transition: TransitionProps,
    paper: PaperProps,
    backdrop: BackdropProps,
    ...slotProps
  };
  const externalForwardedProps = {
    slots: backwardCompatibleSlots,
    slotProps: backwardCompatibleSlotProps
  };
  const [RootSlot, rootSlotProps] = useSlot("root", {
    elementType: DialogRoot,
    shouldForwardComponentProp: true,
    externalForwardedProps,
    ownerState,
    className: clsx(classes.root, className),
    ref: ref2
  });
  const [BackdropSlot, backdropSlotProps] = useSlot("backdrop", {
    elementType: DialogBackdrop,
    shouldForwardComponentProp: true,
    externalForwardedProps,
    ownerState,
    className: classes.backdrop
  });
  const [PaperSlot, paperSlotProps] = useSlot("paper", {
    elementType: DialogPaper,
    shouldForwardComponentProp: true,
    externalForwardedProps,
    ownerState,
    className: classes.paper,
    additionalProps: {
      elevation: 24,
      role,
      "aria-describedby": ariaDescribedby,
      "aria-labelledby": ariaLabelledby,
      "aria-modal": ariaModal,
      tabIndex: -1,
      [FOCUSABLE_ATTRIBUTE]: ""
    }
  });
  const [ContainerSlot, containerSlotProps] = useSlot("container", {
    elementType: DialogContainer,
    externalForwardedProps,
    ownerState,
    className: classes.container
  });
  const [TransitionSlot, transitionSlotProps] = useSlot("transition", {
    elementType: Fade,
    externalForwardedProps,
    ownerState,
    additionalProps: {
      appear: true,
      in: open2,
      timeout: transitionDuration,
      role: "presentation"
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RootSlot, {
    closeAfterTransition: true,
    slots: {
      backdrop: BackdropSlot
    },
    slotProps: {
      backdrop: {
        transitionDuration,
        as: BackdropComponent,
        ...backdropSlotProps
      }
    },
    disableEscapeKeyDown,
    onClose,
    open: open2,
    onClick: handleBackdropClick,
    ...rootSlotProps,
    ...other,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionSlot, {
      ...transitionSlotProps,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerSlot, {
        onMouseDown: handleMouseDown,
        ...containerSlotProps,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PaperSlot, {
          as: PaperComponent,
          ...paperSlotProps,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContext.Provider, {
            value: dialogContextValue,
            children
          })
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" ? Dialog.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": PropTypes.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": PropTypes.string,
  /**
   * Informs assistive technologies that the element is modal.
   * It's added on the element with role="dialog".
   * @default true
   */
  "aria-modal": PropTypes.oneOfType([PropTypes.oneOf(["false", "true"]), PropTypes.bool]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: PropTypes.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: PropTypes.oneOfType([PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", false]), PropTypes.string]),
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @default {}
   * @deprecated Use `slotProps.paper` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperProps: PropTypes.object,
  /**
   * The ARIA role for the dialog element.
   * The main dialog role is `dialog`, but `alertdialog` can be used if the content of the dialog requires immediate attention.
   * See https://www.w3.org/TR/wai-aria-1.2/#dialog and https://www.w3.org/TR/wai-aria-1.2/#alertdialog for more details.
   * @default 'dialog'
   */
  role: PropTypes.oneOf(["alertdialog", "dialog"]),
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: PropTypes.oneOf(["body", "paper"]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    container: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    container: PropTypes.elementType,
    paper: PropTypes.elementType,
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: PropTypes.object
} : void 0;
function getDialogActionsUtilityClass(slot) {
  return generateUtilityClass("MuiDialogActions", slot);
}
generateUtilityClasses("MuiDialogActions", ["root", "spacing"]);
const useUtilityClasses$S = (ownerState) => {
  const {
    classes,
    disableSpacing
  } = ownerState;
  const slots = {
    root: ["root", !disableSpacing && "spacing"]
  };
  return composeClasses(slots, getDialogActionsUtilityClass, classes);
};
const DialogActionsRoot = styled("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, !ownerState.disableSpacing && styles2.spacing];
  }
})({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto",
  variants: [{
    props: ({
      ownerState
    }) => !ownerState.disableSpacing,
    style: {
      "& > :not(style) ~ :not(style)": {
        marginLeft: 8
      }
    }
  }]
});
const DialogActions = /* @__PURE__ */ reactExports.forwardRef(function DialogActions2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiDialogActions"
  });
  const {
    className,
    disableSpacing = false,
    ...other
  } = props;
  const ownerState = {
    ...props,
    disableSpacing
  };
  const classes = useUtilityClasses$S(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DialogActionsRoot, {
    className: clsx(classes.root, className),
    ownerState,
    ref: ref2,
    ...other
  });
});
process.env.NODE_ENV !== "production" ? DialogActions.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getDialogContentUtilityClass(slot) {
  return generateUtilityClass("MuiDialogContent", slot);
}
generateUtilityClasses("MuiDialogContent", ["root", "dividers"]);
const dialogTitleClasses = generateUtilityClasses("MuiDialogTitle", ["root"]);
const useUtilityClasses$R = (ownerState) => {
  const {
    classes,
    dividers
  } = ownerState;
  const slots = {
    root: ["root", dividers && "dividers"]
  };
  return composeClasses(slots, getDialogContentUtilityClass, classes);
};
const DialogContentRoot = styled("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.dividers && styles2.dividers];
  }
})(memoTheme(({
  theme
}) => ({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px",
  variants: [{
    props: ({
      ownerState
    }) => ownerState.dividers,
    style: {
      padding: "16px 24px",
      borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
      borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }
  }, {
    props: ({
      ownerState
    }) => !ownerState.dividers,
    style: {
      [`.${dialogTitleClasses.root} + &`]: {
        paddingTop: 0
      }
    }
  }]
})));
const DialogContent = /* @__PURE__ */ reactExports.forwardRef(function DialogContent2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiDialogContent"
  });
  const {
    className,
    dividers = false,
    ...other
  } = props;
  const ownerState = {
    ...props,
    dividers
  };
  const classes = useUtilityClasses$R(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContentRoot, {
    className: clsx(classes.root, className),
    ownerState,
    ref: ref2,
    ...other
  });
});
process.env.NODE_ENV !== "production" ? DialogContent.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getDividerUtilityClass(slot) {
  return generateUtilityClass("MuiDivider", slot);
}
const dividerClasses = generateUtilityClasses("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]);
const useUtilityClasses$Q = (ownerState) => {
  const {
    absolute,
    children,
    classes,
    flexItem,
    light: light2,
    orientation,
    textAlign,
    variant
  } = ownerState;
  const slots = {
    root: ["root", absolute && "absolute", variant, light2 && "light", orientation === "vertical" && "vertical", flexItem && "flexItem", children && "withChildren", children && orientation === "vertical" && "withChildrenVertical", textAlign === "right" && orientation !== "vertical" && "textAlignRight", textAlign === "left" && orientation !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", orientation === "vertical" && "wrapperVertical"]
  };
  return composeClasses(slots, getDividerUtilityClass, classes);
};
const DividerRoot = styled("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.absolute && styles2.absolute, styles2[ownerState.variant], ownerState.light && styles2.light, ownerState.orientation === "vertical" && styles2.vertical, ownerState.flexItem && styles2.flexItem, ownerState.children && styles2.withChildren, ownerState.children && ownerState.orientation === "vertical" && styles2.withChildrenVertical, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles2.textAlignRight, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles2.textAlignLeft];
  }
})(memoTheme(({
  theme
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (theme.vars || theme).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: true
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: true
    },
    style: {
      borderColor: theme.alpha((theme.vars || theme).palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: true
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState
    }) => !!ownerState.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.children && ownerState.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.orientation === "vertical" && ownerState.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.textAlign === "right" && ownerState.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.textAlign === "left" && ownerState.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
})));
const DividerWrapper = styled("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.wrapper, ownerState.orientation === "vertical" && styles2.wrapperVertical];
  }
})(memoTheme(({
  theme
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
  paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }
  }]
})));
const Divider = /* @__PURE__ */ reactExports.forwardRef(function Divider2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiDivider"
  });
  const {
    absolute = false,
    children,
    className,
    orientation = "horizontal",
    component = children || orientation === "vertical" ? "div" : "hr",
    flexItem = false,
    light: light2 = false,
    role = component !== "hr" ? "separator" : void 0,
    textAlign = "center",
    variant = "fullWidth",
    ...other
  } = props;
  const ownerState = {
    ...props,
    absolute,
    component,
    flexItem,
    light: light2,
    orientation,
    role,
    textAlign,
    variant
  };
  const classes = useUtilityClasses$Q(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DividerRoot, {
    as: component,
    className: clsx(classes.root, className),
    role,
    ref: ref2,
    ownerState,
    "aria-orientation": role === "separator" && (component !== "hr" || orientation === "vertical") ? orientation : void 0,
    ...other,
    children: children ? /* @__PURE__ */ jsxRuntimeExports.jsx(DividerWrapper, {
      className: classes.wrapper,
      ownerState,
      children
    }) : null
  });
});
if (Divider) {
  Divider.muiSkipListHighlight = true;
}
process.env.NODE_ENV !== "production" ? Divider.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: PropTypes.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  light: PropTypes.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: PropTypes.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["fullWidth", "inset", "middle"]), PropTypes.string])
} : void 0;
const hiddenStyles$1 = {
  visibility: "hidden"
};
function getTranslateValue(direction, node2, resolvedContainer) {
  const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
  const containerWindow = ownerWindow(node2);
  const previousTransform = node2.style.transform;
  const previousTransition = node2.style.transition;
  node2.style.transition = "";
  node2.style.transform = "";
  const rect = node2.getBoundingClientRect();
  const computedStyle = containerWindow.getComputedStyle(node2);
  const transform2 = computedStyle.getPropertyValue("transform");
  node2.style.transform = previousTransform;
  node2.style.transition = previousTransition;
  let offsetX = 0;
  let offsetY = 0;
  if (transform2 && transform2 !== "none" && typeof transform2 === "string") {
    const transformValues = transform2.split("(")[1].split(")")[0].split(",");
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }
  if (direction === "left") {
    if (containerRect) {
      return `translateX(${containerRect.right + offsetX - rect.left}px)`;
    }
    return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
  }
  if (direction === "right") {
    if (containerRect) {
      return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
    }
    return `translateX(-${rect.left + rect.width - offsetX}px)`;
  }
  if (direction === "up") {
    if (containerRect) {
      return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
    }
    return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
  }
  if (containerRect) {
    return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
  }
  return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function resolveContainer(containerPropProp) {
  return typeof containerPropProp === "function" ? containerPropProp() : containerPropProp;
}
function setTranslateValue(direction, node2, containerProp) {
  const resolvedContainer = resolveContainer(containerProp);
  const transform2 = getTranslateValue(direction, node2, resolvedContainer);
  if (transform2) {
    node2.style.transform = transform2;
  }
}
const Slide = /* @__PURE__ */ reactExports.forwardRef(function Slide2(props, ref2) {
  const theme = useTheme();
  const defaultEasing = {
    enter: theme.transitions.easing.easeOut,
    exit: theme.transitions.easing.sharp
  };
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
    addEndListener,
    appear = true,
    children,
    container: containerProp,
    direction = "down",
    easing: easingProp = defaultEasing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style: style2,
    timeout: timeout2 = defaultTimeout,
    ...other
  } = props;
  const childrenRef = reactExports.useRef(null);
  const handleRef = useForkRef(getReactElementRef(children), childrenRef, ref2);
  const handleEnter = normalizedTransitionCallback(childrenRef, (node2, isAppearing) => {
    setTranslateValue(direction, node2, containerProp);
    reflow(node2);
    if (onEnter) {
      onEnter(node2, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback(childrenRef, (node2, isAppearing) => {
    const transitionProps = getTransitionProps({
      timeout: timeout2,
      style: style2,
      easing: easingProp
    }, {
      mode: "enter"
    });
    node2.style.transition = theme.transitions.create("transform", transitionProps);
    node2.style.transform = "none";
    if (onEntering) {
      onEntering(node2, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(childrenRef, onEntered);
  const handleExiting = normalizedTransitionCallback(childrenRef, onExiting);
  const handleExit = normalizedTransitionCallback(childrenRef, (node2) => {
    const transitionProps = getTransitionProps({
      timeout: timeout2,
      style: style2,
      easing: easingProp
    }, {
      mode: "exit"
    });
    node2.style.transition = theme.transitions.create("transform", transitionProps);
    setTranslateValue(direction, node2, containerProp);
    if (onExit) {
      onExit(node2);
    }
  });
  const handleExited = normalizedTransitionCallback(childrenRef, (node2) => {
    node2.style.transition = "";
    if (onExited) {
      onExited(node2);
    }
  });
  const handleAddEndListener = (next2) => {
    if (addEndListener) {
      addEndListener(childrenRef.current, next2);
    }
  };
  const updatePosition = reactExports.useCallback(() => {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current, containerProp);
    }
  }, [direction, containerProp]);
  reactExports.useEffect(() => {
    if (inProp || direction === "down" || direction === "right") {
      return void 0;
    }
    const handleResize = debounce$2(() => {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current, containerProp);
      }
    });
    const containerWindow = ownerWindow(childrenRef.current);
    containerWindow.addEventListener("resize", handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener("resize", handleResize);
    };
  }, [direction, inProp, containerProp]);
  reactExports.useEffect(() => {
    if (!inProp) {
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Transition$1, {
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    appear,
    in: inProp,
    timeout: timeout2,
    ...other,
    children: (state, {
      ownerState,
      ...restChildProps
    }) => {
      let childStyle;
      if (state === "exited" && !inProp) {
        childStyle = style2 || children.props.style ? {
          visibility: "hidden",
          ...style2,
          ...children.props.style
        } : hiddenStyles$1;
      } else if (style2 && children.props.style) {
        childStyle = {
          ...style2,
          ...children.props.style
        };
      } else {
        childStyle = style2 || children.props.style;
      }
      return /* @__PURE__ */ reactExports.cloneElement(children, {
        ref: handleRef,
        style: childStyle,
        ...restChildProps
      });
    }
  });
});
process.env.NODE_ENV !== "production" ? Slide.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), (props) => {
    if (props.open) {
      const resolvedContainer = resolveContainer(props.container);
      if (resolvedContainer && resolvedContainer.nodeType === 1) {
        const box = resolvedContainer.getBoundingClientRect();
        if (process.env.NODE_ENV !== "production") {
          if (isLayoutSupported() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
            return new Error(["MUI: The `container` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join("\n"));
          }
        }
      } else if (!resolvedContainer || typeof resolvedContainer.getBoundingClientRect !== "function" || resolvedContainer.contextElement != null && resolvedContainer.contextElement.nodeType !== 1) {
        return new Error(["MUI: The `container` prop provided to the component is invalid.", "It should be an HTML element instance."].join("\n"));
      }
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: PropTypes.oneOf(["down", "left", "right", "up"]),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
function getDrawerUtilityClass(slot) {
  return generateUtilityClass("MuiDrawer", slot);
}
generateUtilityClasses("MuiDrawer", ["root", "docked", "paper", "anchorLeft", "anchorRight", "anchorTop", "anchorBottom", "paperAnchorLeft", "paperAnchorRight", "paperAnchorTop", "paperAnchorBottom", "paperAnchorDockedLeft", "paperAnchorDockedRight", "paperAnchorDockedTop", "paperAnchorDockedBottom", "modal"]);
const overridesResolver$5 = (props, styles2) => {
  const {
    ownerState
  } = props;
  return [styles2.root, (ownerState.variant === "permanent" || ownerState.variant === "persistent") && styles2.docked, ownerState.variant === "temporary" && styles2.modal];
};
const useUtilityClasses$P = (ownerState) => {
  const {
    classes,
    anchor,
    variant
  } = ownerState;
  const slots = {
    root: ["root", `anchor${capitalize$2(anchor)}`],
    docked: [(variant === "permanent" || variant === "persistent") && "docked"],
    modal: ["modal"],
    paper: ["paper", `paperAnchor${capitalize$2(anchor)}`, variant !== "temporary" && `paperAnchorDocked${capitalize$2(anchor)}`]
  };
  return composeClasses(slots, getDrawerUtilityClass, classes);
};
const DrawerRoot = styled(Modal, {
  name: "MuiDrawer",
  slot: "Root",
  overridesResolver: overridesResolver$5
})(memoTheme(({
  theme
}) => ({
  zIndex: (theme.vars || theme).zIndex.drawer
})));
const DrawerDockedRoot = styled("div", {
  shouldForwardProp: rootShouldForwardProp,
  name: "MuiDrawer",
  slot: "Docked",
  skipVariantsResolver: false,
  overridesResolver: overridesResolver$5
})({
  flex: "0 0 auto"
});
const DrawerPaper = styled(Paper, {
  name: "MuiDrawer",
  slot: "Paper",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.paper, styles2[`paperAnchor${capitalize$2(ownerState.anchor)}`], ownerState.variant !== "temporary" && styles2[`paperAnchorDocked${capitalize$2(ownerState.anchor)}`]];
  }
})(memoTheme(({
  theme
}) => ({
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  flex: "1 0 auto",
  zIndex: (theme.vars || theme).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  // temporary style
  position: "fixed",
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0,
  variants: [{
    props: {
      anchor: "left"
    },
    style: {
      left: 0
    }
  }, {
    props: {
      anchor: "top"
    },
    style: {
      top: 0,
      left: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: {
      anchor: "right"
    },
    style: {
      right: 0
    }
  }, {
    props: {
      anchor: "bottom"
    },
    style: {
      top: "auto",
      left: 0,
      bottom: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.anchor === "left" && ownerState.variant !== "temporary",
    style: {
      borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.anchor === "top" && ownerState.variant !== "temporary",
    style: {
      borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.anchor === "right" && ownerState.variant !== "temporary",
    style: {
      borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.anchor === "bottom" && ownerState.variant !== "temporary",
    style: {
      borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }
  }]
})));
const oppositeDirection = {
  left: "right",
  right: "left",
  top: "down",
  bottom: "up"
};
function isHorizontal(anchor) {
  return ["left", "right"].includes(anchor);
}
function getAnchor({
  direction
}, anchor) {
  return direction === "rtl" && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
const Drawer = /* @__PURE__ */ reactExports.forwardRef(function Drawer2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiDrawer"
  });
  const theme = useTheme();
  const isRtl = useRtl();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
    anchor: anchorProp = "left",
    BackdropProps,
    children,
    className,
    elevation = 16,
    hideBackdrop = false,
    ModalProps: {
      BackdropProps: BackdropPropsProp,
      ...ModalProps
    } = {},
    onClose,
    open: open2 = false,
    PaperProps = {},
    SlideProps,
    // eslint-disable-next-line react/prop-types
    TransitionComponent,
    transitionDuration = defaultTransitionDuration,
    variant = "temporary",
    slots = {},
    slotProps = {},
    ...other
  } = props;
  const mounted = reactExports.useRef(false);
  const rootRef = reactExports.useRef(null);
  const handleRef = useForkRef(ref2, rootRef);
  reactExports.useEffect(() => {
    mounted.current = true;
  }, []);
  const resolveSlideContainer = reactExports.useCallback(() => rootRef.current, []);
  const anchorInvariant = getAnchor({
    direction: isRtl ? "rtl" : "ltr"
  }, anchorProp);
  const anchor = anchorProp;
  const ownerState = {
    ...props,
    anchor,
    elevation,
    open: open2,
    variant,
    ...other
  };
  const classes = useUtilityClasses$P(ownerState);
  const externalForwardedProps = {
    slots: {
      transition: TransitionComponent,
      ...slots
    },
    slotProps: {
      paper: PaperProps,
      transition: SlideProps,
      ...slotProps,
      backdrop: mergeSlotProps$2(slotProps.backdrop || {
        ...BackdropProps,
        ...BackdropPropsProp
      }, {
        transitionDuration
      })
    }
  };
  const [RootSlot, rootSlotProps] = useSlot("root", {
    ref: handleRef,
    elementType: DrawerRoot,
    className: clsx(classes.root, classes.modal, className),
    shouldForwardComponentProp: true,
    ownerState,
    externalForwardedProps: {
      ...externalForwardedProps,
      ...other,
      ...ModalProps
    },
    additionalProps: {
      closeAfterTransition: true,
      open: open2,
      onClose,
      hideBackdrop,
      slots: {
        backdrop: externalForwardedProps.slots.backdrop
      },
      slotProps: {
        backdrop: externalForwardedProps.slotProps.backdrop
      }
    }
  });
  const [PaperSlot, paperSlotProps] = useSlot("paper", {
    elementType: DrawerPaper,
    shouldForwardComponentProp: true,
    className: clsx(classes.paper, PaperProps.className),
    ownerState,
    externalForwardedProps,
    additionalProps: {
      elevation: variant === "temporary" ? elevation : 0,
      square: true,
      ...variant === "temporary" && {
        role: "dialog",
        "aria-modal": "true",
        [FOCUSABLE_ATTRIBUTE]: "",
        tabIndex: -1
      }
    }
  });
  const [DockedSlot, dockedSlotProps] = useSlot("docked", {
    elementType: DrawerDockedRoot,
    ref: handleRef,
    className: clsx(classes.root, classes.docked, className),
    ownerState,
    externalForwardedProps,
    additionalProps: other
    // pass `other` here because `DockedSlot` is also a root slot for some variants
  });
  const [TransitionSlot, transitionSlotProps] = useSlot("transition", {
    elementType: Slide,
    ownerState,
    externalForwardedProps,
    additionalProps: {
      in: open2,
      direction: oppositeDirection[anchorInvariant],
      timeout: transitionDuration,
      appear: mounted.current,
      ...variant === "temporary" && (slots.transition == null || slots.transition === Slide) && {
        container: resolveSlideContainer
      }
    }
  });
  const drawer = /* @__PURE__ */ jsxRuntimeExports.jsx(PaperSlot, {
    ...paperSlotProps,
    children
  });
  if (variant === "permanent") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DockedSlot, {
      ...dockedSlotProps,
      children: drawer
    });
  }
  const slidingDrawer = /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionSlot, {
    ...transitionSlotProps,
    children: drawer
  });
  if (variant === "persistent") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DockedSlot, {
      ...dockedSlotProps,
      children: slidingDrawer
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RootSlot, {
    ...rootSlotProps,
    children: slidingDrawer
  });
});
process.env.NODE_ENV !== "production" ? Drawer.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: PropTypes.oneOf(["bottom", "left", "right", "top"]),
  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: integerPropType,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Props applied to the [`Modal`](https://mui.com/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @deprecated use the `slotProps.paper` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PaperProps: PropTypes.object,
  /**
   * Props applied to the [`Slide`](https://mui.com/material-ui/api/slide/) element.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SlideProps: PropTypes.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    docked: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    docked: PropTypes.elementType,
    paper: PropTypes.elementType,
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: PropTypes.oneOf(["permanent", "persistent", "temporary"])
} : void 0;
const useUtilityClasses$O = (ownerState) => {
  const {
    classes,
    disableUnderline,
    startAdornment,
    endAdornment,
    size,
    hiddenLabel,
    multiline
  } = ownerState;
  const slots = {
    root: ["root", !disableUnderline && "underline", startAdornment && "adornedStart", endAdornment && "adornedEnd", size === "small" && `size${capitalize$2(size)}`, hiddenLabel && "hiddenLabel", multiline && "multiline"],
    input: ["input"]
  };
  const composedClasses = composeClasses(slots, getFilledInputUtilityClass, classes);
  return {
    ...classes,
    // forward classes to the InputBase
    ...composedClasses
  };
};
const FilledInputRoot = styled(InputBaseRoot, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [...rootOverridesResolver(props, styles2), !ownerState.disableUnderline && styles2.underline];
  }
})(memoTheme(({
  theme
}) => {
  const light2 = theme.palette.mode === "light";
  const bottomLineColor = light2 ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  const backgroundColor2 = light2 ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
  const hoverBackground = light2 ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
  const disabledBackground = light2 ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor2,
    borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
    borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create("background-color", {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor2
      }
    },
    [`&.${filledInputClasses.focused}`]: {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor2
    },
    [`&.${filledInputClasses.disabled}`]: {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
    },
    variants: [{
      props: ({
        ownerState
      }) => !ownerState.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${filledInputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${filledInputClasses.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (theme.vars || theme).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline) : bottomLineColor}`,
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transition: theme.transitions.create("border-bottom-color", {
            duration: theme.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${filledInputClasses.disabled}, .${filledInputClasses.error}):before`]: {
          borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${filledInputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color2]) => ({
      props: {
        disableUnderline: false,
        color: color2
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(theme.vars || theme).palette[color2]?.main}`
        }
      }
    })), {
      props: ({
        ownerState
      }) => ownerState.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState,
        size
      }) => ownerState.multiline && size === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.multiline && ownerState.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.multiline && ownerState.hiddenLabel && ownerState.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
}));
const FilledInputInput = styled(InputBaseInput, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(memoTheme(({
  theme
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!theme.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
      caretColor: theme.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...theme.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [theme.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.hiddenLabel && ownerState.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
})));
const FilledInput = /* @__PURE__ */ reactExports.forwardRef(function FilledInput2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiFilledInput"
  });
  const {
    disableUnderline = false,
    components = {},
    componentsProps: componentsPropsProp,
    fullWidth = false,
    hiddenLabel,
    // declare here to prevent spreading to DOM
    inputComponent = "input",
    multiline = false,
    slotProps,
    slots = {},
    type = "text",
    ...other
  } = props;
  const ownerState = {
    ...props,
    disableUnderline,
    fullWidth,
    inputComponent,
    multiline,
    type
  };
  const classes = useUtilityClasses$O(props);
  const filledInputComponentsProps = {
    root: {
      ownerState
    },
    input: {
      ownerState
    }
  };
  const componentsProps = slotProps ?? componentsPropsProp ? deepmerge(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
  const RootSlot = slots.root ?? components.Root ?? FilledInputRoot;
  const InputSlot = slots.input ?? components.Input ?? FilledInputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, {
    slots: {
      root: RootSlot,
      input: InputSlot
    },
    slotProps: componentsProps,
    fullWidth,
    inputComponent,
    multiline,
    ref: ref2,
    type,
    ...other,
    classes
  });
});
process.env.NODE_ENV !== "production" ? FilledInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
FilledInput.muiName = "Input";
function getFormControlUtilityClasses(slot) {
  return generateUtilityClass("MuiFormControl", slot);
}
generateUtilityClasses("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const useUtilityClasses$N = (ownerState) => {
  const {
    classes,
    margin: margin2,
    fullWidth
  } = ownerState;
  const slots = {
    root: ["root", margin2 !== "none" && `margin${capitalize$2(margin2)}`, fullWidth && "fullWidth"]
  };
  return composeClasses(slots, getFormControlUtilityClasses, classes);
};
const FormControlRoot = styled("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, styles2[`margin${capitalize$2(ownerState.margin)}`], ownerState.fullWidth && styles2.fullWidth];
  }
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: true
    },
    style: {
      width: "100%"
    }
  }]
});
const FormControl = /* @__PURE__ */ reactExports.forwardRef(function FormControl2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiFormControl"
  });
  const {
    children,
    className,
    color: color2 = "primary",
    component = "div",
    disabled = false,
    error = false,
    focused: visuallyFocused,
    fullWidth = false,
    hiddenLabel = false,
    margin: margin2 = "none",
    required = false,
    size = "medium",
    variant = "outlined",
    ...other
  } = props;
  const ownerState = {
    ...props,
    color: color2,
    component,
    disabled,
    error,
    fullWidth,
    hiddenLabel,
    margin: margin2,
    required,
    size,
    variant
  };
  const classes = useUtilityClasses$N(ownerState);
  const [adornedStart, setAdornedStart] = reactExports.useState(() => {
    let initialAdornedStart = false;
    if (children) {
      reactExports.Children.forEach(children, (child) => {
        if (!isMuiElement(child, ["Input", "Select"])) {
          return;
        }
        const input = isMuiElement(child, ["Select"]) ? child.props.input : child;
        if (input && isAdornedStart(input.props)) {
          initialAdornedStart = true;
        }
      });
    }
    return initialAdornedStart;
  });
  const [filled, setFilled] = reactExports.useState(() => {
    let initialFilled = false;
    if (children) {
      reactExports.Children.forEach(children, (child) => {
        if (!isMuiElement(child, ["Input", "Select"])) {
          return;
        }
        if (isFilled(child.props, true) || isFilled(child.props.inputProps, true)) {
          initialFilled = true;
        }
      });
    }
    return initialFilled;
  });
  const [focusedState, setFocused] = reactExports.useState(false);
  if (disabled && focusedState) {
    setFocused(false);
  }
  const focused = visuallyFocused !== void 0 && !disabled ? visuallyFocused : focusedState;
  let registerEffect;
  const registeredInput = reactExports.useRef(false);
  if (process.env.NODE_ENV !== "production") {
    registerEffect = () => {
      if (registeredInput.current) {
        console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join("\n"));
      }
      registeredInput.current = true;
      return () => {
        registeredInput.current = false;
      };
    };
  }
  const onFilled = reactExports.useCallback(() => {
    setFilled(true);
  }, []);
  const onEmpty = reactExports.useCallback(() => {
    setFilled(false);
  }, []);
  const childContext = reactExports.useMemo(() => {
    return {
      adornedStart,
      setAdornedStart,
      color: color2,
      disabled,
      error,
      filled,
      focused,
      fullWidth,
      hiddenLabel,
      size,
      onBlur: () => {
        setFocused(false);
      },
      onFocus: () => {
        setFocused(true);
      },
      onEmpty,
      onFilled,
      registerEffect,
      required,
      variant
    };
  }, [adornedStart, color2, disabled, error, filled, focused, fullWidth, hiddenLabel, registerEffect, onEmpty, onFilled, required, size, variant]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
    value: childContext,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlRoot, {
      as: component,
      ownerState,
      className: clsx(classes.root, className),
      ref: ref2,
      ...other,
      children
    })
  });
});
process.env.NODE_ENV !== "production" ? FormControl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
} : void 0;
function getFormControlLabelUtilityClasses(slot) {
  return generateUtilityClass("MuiFormControlLabel", slot);
}
const formControlLabelClasses = generateUtilityClasses("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]);
const useUtilityClasses$M = (ownerState) => {
  const {
    classes,
    disabled,
    labelPlacement,
    error,
    required
  } = ownerState;
  const slots = {
    root: ["root", disabled && "disabled", `labelPlacement${capitalize$2(labelPlacement)}`, error && "error", required && "required"],
    label: ["label", disabled && "disabled"],
    asterisk: ["asterisk", error && "error"]
  };
  return composeClasses(slots, getFormControlLabelUtilityClasses, classes);
};
const FormControlLabelRoot = styled("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${formControlLabelClasses.label}`]: styles2.label
    }, styles2.root, styles2[`labelPlacement${capitalize$2(ownerState.labelPlacement)}`]];
  }
})(memoTheme(({
  theme
}) => ({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${formControlLabelClasses.disabled}`]: {
    cursor: "default"
  },
  [`& .${formControlLabelClasses.label}`]: {
    [`&.${formControlLabelClasses.disabled}`]: {
      color: (theme.vars || theme).palette.text.disabled
    }
  },
  variants: [{
    props: {
      labelPlacement: "start"
    },
    style: {
      flexDirection: "row-reverse",
      marginRight: -11
    }
  }, {
    props: {
      labelPlacement: "top"
    },
    style: {
      flexDirection: "column-reverse"
    }
  }, {
    props: {
      labelPlacement: "bottom"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      labelPlacement
    }) => labelPlacement === "start" || labelPlacement === "top" || labelPlacement === "bottom",
    style: {
      marginLeft: 16
      // used for row presentation of radio/checkbox
    }
  }]
})));
const AsteriskComponent$1 = styled("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk"
})(memoTheme(({
  theme
}) => ({
  [`&.${formControlLabelClasses.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
})));
const FormControlLabel = /* @__PURE__ */ reactExports.forwardRef(function FormControlLabel2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiFormControlLabel"
  });
  const {
    checked: checked2,
    className,
    componentsProps = {},
    control,
    disabled: disabledProp,
    disableTypography,
    inputRef,
    label: labelProp,
    labelPlacement = "end",
    name,
    onChange,
    required: requiredProp,
    slots = {},
    slotProps = {},
    value,
    ...other
  } = props;
  const muiFormControl = useFormControl();
  const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
  const required = requiredProp ?? control.props.required;
  const controlProps = {
    disabled,
    required
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((key) => {
    if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") {
      controlProps[key] = props[key];
    }
  });
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ["error"]
  });
  const ownerState = {
    ...props,
    disabled,
    labelPlacement,
    required,
    error: fcs.error
  };
  const classes = useUtilityClasses$M(ownerState);
  const externalForwardedProps = {
    slots,
    slotProps: {
      ...componentsProps,
      ...slotProps
    }
  };
  const [TypographySlot, typographySlotProps] = useSlot("typography", {
    elementType: Typography$1,
    externalForwardedProps,
    ownerState
  });
  let label = labelProp;
  if (label != null && label.type !== Typography$1 && !disableTypography) {
    label = /* @__PURE__ */ jsxRuntimeExports.jsx(TypographySlot, {
      component: "span",
      ...typographySlotProps,
      className: clsx(classes.label, typographySlotProps?.className),
      children: label
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControlLabelRoot, {
    className: clsx(classes.root, className),
    ownerState,
    ref: ref2,
    ...other,
    children: [/* @__PURE__ */ reactExports.cloneElement(control, controlProps), required ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      children: [label, /* @__PURE__ */ jsxRuntimeExports.jsxs(AsteriskComponent$1, {
        ownerState,
        "aria-hidden": true,
        className: classes.asterisk,
        children: [" ", "*"]
      })]
    }) : label]
  });
});
process.env.NODE_ENV !== "production" ? FormControlLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: PropTypes.shape({
    typography: PropTypes.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: PropTypes.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: PropTypes.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: PropTypes.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: PropTypes.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: PropTypes.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    typography: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    typography: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
function getFormHelperTextUtilityClasses(slot) {
  return generateUtilityClass("MuiFormHelperText", slot);
}
const formHelperTextClasses = generateUtilityClasses("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var _span$3;
const useUtilityClasses$L = (ownerState) => {
  const {
    classes,
    contained,
    size,
    disabled,
    error,
    filled,
    focused,
    required
  } = ownerState;
  const slots = {
    root: ["root", disabled && "disabled", error && "error", size && `size${capitalize$2(size)}`, contained && "contained", focused && "focused", filled && "filled", required && "required"]
  };
  return composeClasses(slots, getFormHelperTextUtilityClasses, classes);
};
const FormHelperTextRoot = styled("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.size && styles2[`size${capitalize$2(ownerState.size)}`], ownerState.contained && styles2.contained, ownerState.filled && styles2.filled];
  }
})(memoTheme(({
  theme
}) => ({
  color: (theme.vars || theme).palette.text.secondary,
  ...theme.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${formHelperTextClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${formHelperTextClasses.error}`]: {
    color: (theme.vars || theme).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.contained,
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
})));
const FormHelperText = /* @__PURE__ */ reactExports.forwardRef(function FormHelperText2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiFormHelperText"
  });
  const {
    children,
    className,
    component = "p",
    disabled,
    error,
    filled,
    focused,
    margin: margin2,
    required,
    variant,
    ...other
  } = props;
  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  });
  const ownerState = {
    ...props,
    component,
    contained: fcs.variant === "filled" || fcs.variant === "outlined",
    variant: fcs.variant,
    size: fcs.size,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  };
  delete ownerState.ownerState;
  const classes = useUtilityClasses$L(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperTextRoot, {
    as: component,
    className: clsx(classes.root, className),
    ref: ref2,
    ...other,
    ownerState,
    children: children === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      _span$3 || (_span$3 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: "notranslate",
        "aria-hidden": true,
        children: "​"
      }))
    ) : children
  });
});
process.env.NODE_ENV !== "production" ? FormHelperText.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["filled", "outlined", "standard"]), PropTypes.string])
} : void 0;
function getFormLabelUtilityClasses(slot) {
  return generateUtilityClass("MuiFormLabel", slot);
}
const formLabelClasses = generateUtilityClasses("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]);
const useUtilityClasses$K = (ownerState) => {
  const {
    classes,
    color: color2,
    focused,
    disabled,
    error,
    filled,
    required
  } = ownerState;
  const slots = {
    root: ["root", `color${capitalize$2(color2)}`, disabled && "disabled", error && "error", filled && "filled", focused && "focused", required && "required"],
    asterisk: ["asterisk", error && "error"]
  };
  return composeClasses(slots, getFormLabelUtilityClasses, classes);
};
const FormLabelRoot = styled("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.color === "secondary" && styles2.colorSecondary, ownerState.filled && styles2.filled];
  }
})(memoTheme(({
  theme
}) => ({
  color: (theme.vars || theme).palette.text.secondary,
  ...theme.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color2]) => ({
    props: {
      color: color2
    },
    style: {
      [`&.${formLabelClasses.focused}`]: {
        color: (theme.vars || theme).palette[color2].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${formLabelClasses.disabled}`]: {
        color: (theme.vars || theme).palette.text.disabled
      },
      [`&.${formLabelClasses.error}`]: {
        color: (theme.vars || theme).palette.error.main
      }
    }
  }]
})));
const AsteriskComponent = styled("span", {
  name: "MuiFormLabel",
  slot: "Asterisk"
})(memoTheme(({
  theme
}) => ({
  [`&.${formLabelClasses.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
})));
const FormLabel = /* @__PURE__ */ reactExports.forwardRef(function FormLabel2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiFormLabel"
  });
  const {
    children,
    className,
    color: color2,
    component = "label",
    disabled,
    error,
    filled,
    focused,
    required,
    ...other
  } = props;
  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  });
  const ownerState = {
    ...props,
    color: fcs.color || "primary",
    component,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  };
  const classes = useUtilityClasses$K(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormLabelRoot, {
    as: component,
    ownerState,
    className: clsx(classes.root, className),
    ref: ref2,
    ...other,
    children: [children, fcs.required && /* @__PURE__ */ jsxRuntimeExports.jsxs(AsteriskComponent, {
      ownerState,
      "aria-hidden": true,
      className: classes.asterisk,
      children: [" ", "*"]
    })]
  });
});
process.env.NODE_ENV !== "production" ? FormLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getScale(value) {
  return `scale(${value}, ${value ** 2})`;
}
const styles$1 = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  },
  exiting: {
    opacity: 0,
    transform: getScale(0.75)
  },
  exited: {
    opacity: 0,
    transform: getScale(0.75)
  }
};
const hiddenStyles = {
  opacity: 0,
  transform: getScale(0.75),
  visibility: "hidden"
};
const Grow = /* @__PURE__ */ reactExports.forwardRef(function Grow2(props, ref2) {
  const {
    addEndListener,
    appear = true,
    children,
    easing: easing2,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style: style2,
    timeout: timeout2 = "auto",
    ...other
  } = props;
  const timer = useTimeout();
  const autoTimeout = reactExports.useRef();
  const theme = useTheme();
  const nodeRef = reactExports.useRef(null);
  const handleRef = useForkRef(nodeRef, getReactElementRef(children), ref2);
  const handleEntering = normalizedTransitionCallback(nodeRef, onEntering);
  const handleEnter = normalizedTransitionCallback(nodeRef, (node2, isAppearing) => {
    reflow(node2);
    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style: style2,
      timeout: timeout2,
      easing: easing2
    }, {
      mode: "enter"
    });
    let duration2;
    if (timeout2 === "auto") {
      duration2 = theme.transitions.getAutoHeightDuration(node2.clientHeight);
      autoTimeout.current = duration2;
    } else {
      duration2 = transitionDuration;
    }
    node2.style.transition = [theme.transitions.create("opacity", {
      duration: duration2,
      delay
    }), theme.transitions.create("transform", {
      duration: duration2 * 0.666,
      delay,
      easing: transitionTimingFunction
    })].join(",");
    if (onEnter) {
      onEnter(node2, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(nodeRef, onEntered);
  const handleExiting = normalizedTransitionCallback(nodeRef, onExiting);
  const handleExit = normalizedTransitionCallback(nodeRef, (node2) => {
    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style: style2,
      timeout: timeout2,
      easing: easing2
    }, {
      mode: "exit"
    });
    let duration2;
    if (timeout2 === "auto") {
      duration2 = theme.transitions.getAutoHeightDuration(node2.clientHeight);
      autoTimeout.current = duration2;
    } else {
      duration2 = transitionDuration;
    }
    node2.style.transition = [theme.transitions.create("opacity", {
      duration: duration2,
      delay
    }), theme.transitions.create("transform", {
      duration: duration2 * 0.666,
      delay: delay || duration2 * 0.333,
      easing: transitionTimingFunction
    })].join(",");
    node2.style.opacity = 0;
    node2.style.transform = getScale(0.75);
    if (onExit) {
      onExit(node2);
    }
  });
  const handleExited = normalizedTransitionCallback(nodeRef, (node2) => {
    node2.style.transition = "";
    if (onExited) {
      onExited(node2);
    }
  });
  const handleAddEndListener = (next2) => {
    if (timeout2 === "auto") {
      timer.start(autoTimeout.current || 0, next2);
    }
    if (addEndListener) {
      addEndListener(nodeRef.current, next2);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Transition$1, {
    appear,
    in: inProp,
    nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout2 === "auto" ? null : timeout2,
    ...other,
    children: (state, {
      ownerState,
      ...restChildProps
    }) => {
      const childStyle = getTransitionChildStyle(state, inProp, styles$1, hiddenStyles, style2, children.props.style);
      return /* @__PURE__ */ reactExports.cloneElement(children, {
        style: childStyle,
        ref: handleRef,
        ...restChildProps
      });
    }
  });
});
process.env.NODE_ENV !== "production" ? Grow.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
if (Grow) {
  Grow.muiSupportAuto = true;
}
const useUtilityClasses$J = (ownerState) => {
  const {
    classes,
    disableUnderline
  } = ownerState;
  const slots = {
    root: ["root", !disableUnderline && "underline"],
    input: ["input"]
  };
  const composedClasses = composeClasses(slots, getInputUtilityClass, classes);
  return {
    ...classes,
    // forward classes to the InputBase
    ...composedClasses
  };
};
const InputRoot = styled(InputBaseRoot, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [...rootOverridesResolver(props, styles2), !ownerState.disableUnderline && styles2.underline];
  }
})(memoTheme(({
  theme
}) => {
  const light2 = theme.palette.mode === "light";
  let bottomLineColor = light2 ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  if (theme.vars) {
    bottomLineColor = theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline);
  }
  return {
    position: "relative",
    variants: [{
      props: ({
        ownerState
      }) => ownerState.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState
      }) => !ownerState.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${inputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${inputClasses.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (theme.vars || theme).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${bottomLineColor}`,
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transition: theme.transitions.create("border-bottom-color", {
            duration: theme.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${inputClasses.disabled}, .${inputClasses.error}):before`]: {
          borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${bottomLineColor}`
          }
        },
        [`&.${inputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color2]) => ({
      props: {
        color: color2,
        disableUnderline: false
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(theme.vars || theme).palette[color2].main}`
        }
      }
    }))]
  };
}));
const InputInput = styled(InputBaseInput, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})({});
const Input = /* @__PURE__ */ reactExports.forwardRef(function Input2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiInput"
  });
  const {
    disableUnderline = false,
    components = {},
    componentsProps: componentsPropsProp,
    fullWidth = false,
    inputComponent = "input",
    multiline = false,
    slotProps,
    slots = {},
    type = "text",
    ...other
  } = props;
  const classes = useUtilityClasses$J(props);
  const ownerState = {
    disableUnderline
  };
  const inputComponentsProps = {
    root: {
      ownerState
    }
  };
  const componentsProps = slotProps ?? componentsPropsProp ? deepmerge(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
  const RootSlot = slots.root ?? components.Root ?? InputRoot;
  const InputSlot = slots.input ?? components.Input ?? InputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, {
    slots: {
      root: RootSlot,
      input: InputSlot
    },
    slotProps: componentsProps,
    fullWidth,
    inputComponent,
    multiline,
    ref: ref2,
    type,
    ...other,
    classes
  });
});
process.env.NODE_ENV !== "production" ? Input.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
Input.muiName = "Input";
function getInputAdornmentUtilityClass(slot) {
  return generateUtilityClass("MuiInputAdornment", slot);
}
const inputAdornmentClasses = generateUtilityClasses("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var _span$2;
const overridesResolver$4 = (props, styles2) => {
  const {
    ownerState
  } = props;
  return [styles2.root, styles2[`position${capitalize$2(ownerState.position)}`], ownerState.disablePointerEvents === true && styles2.disablePointerEvents, styles2[ownerState.variant]];
};
const useUtilityClasses$I = (ownerState) => {
  const {
    classes,
    disablePointerEvents,
    hiddenLabel,
    position: position2,
    size,
    variant
  } = ownerState;
  const slots = {
    root: ["root", disablePointerEvents && "disablePointerEvents", position2 && `position${capitalize$2(position2)}`, variant, hiddenLabel && "hiddenLabel", size && `size${capitalize$2(size)}`]
  };
  return composeClasses(slots, getInputAdornmentUtilityClass, classes);
};
const InputAdornmentRoot = styled("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: overridesResolver$4
})(memoTheme(({
  theme
}) => ({
  display: "flex",
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (theme.vars || theme).palette.action.active,
  variants: [{
    props: {
      variant: "filled"
    },
    style: {
      [`&.${inputAdornmentClasses.positionStart}&:not(.${inputAdornmentClasses.hiddenLabel})`]: {
        marginTop: 16
      }
    }
  }, {
    props: {
      position: "start"
    },
    style: {
      marginRight: 8
    }
  }, {
    props: {
      position: "end"
    },
    style: {
      marginLeft: 8
    }
  }, {
    props: {
      disablePointerEvents: true
    },
    style: {
      pointerEvents: "none"
    }
  }]
})));
const InputAdornment = /* @__PURE__ */ reactExports.forwardRef(function InputAdornment2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiInputAdornment"
  });
  const {
    children,
    className,
    component = "div",
    disablePointerEvents = false,
    disableTypography = false,
    position: position2,
    variant: variantProp,
    ...other
  } = props;
  const muiFormControl = useFormControl() || {};
  let variant = variantProp;
  if (variantProp && muiFormControl.variant) {
    if (process.env.NODE_ENV !== "production") {
      if (variantProp === muiFormControl.variant) {
        console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one.");
      }
    }
  }
  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }
  const ownerState = {
    ...props,
    hiddenLabel: muiFormControl.hiddenLabel,
    size: muiFormControl.size,
    disablePointerEvents,
    position: position2,
    variant
  };
  const classes = useUtilityClasses$I(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
    value: null,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornmentRoot, {
      as: component,
      ownerState,
      className: clsx(classes.root, className),
      ref: ref2,
      ...other,
      children: typeof children === "string" && !disableTypography ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, {
        color: "textSecondary",
        children
      }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
        children: [position2 === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          _span$2 || (_span$2 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "​"
          }))
        ) : null, children]
      })
    })
  });
});
process.env.NODE_ENV !== "production" ? InputAdornment.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: PropTypes.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
} : void 0;
function getInputLabelUtilityClasses(slot) {
  return generateUtilityClass("MuiInputLabel", slot);
}
generateUtilityClasses("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const useUtilityClasses$H = (ownerState) => {
  const {
    classes,
    formControl,
    size,
    shrink,
    disableAnimation,
    variant,
    required
  } = ownerState;
  const slots = {
    root: ["root", formControl && "formControl", !disableAnimation && "animated", shrink && "shrink", size && size !== "medium" && `size${capitalize$2(size)}`, variant],
    asterisk: [required && "asterisk"]
  };
  const composedClasses = composeClasses(slots, getInputLabelUtilityClasses, classes);
  return {
    ...classes,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...composedClasses
  };
};
const InputLabelRoot = styled(FormLabel, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${formLabelClasses.asterisk}`]: styles2.asterisk
    }, styles2.root, ownerState.formControl && styles2.formControl, ownerState.size === "small" && styles2.sizeSmall, ownerState.shrink && styles2.shrink, !ownerState.disableAnimation && styles2.animated, ownerState.focused && styles2.focused, styles2[ownerState.variant]];
  }
})(memoTheme(({
  theme
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: ({
      ownerState
    }) => ownerState.formControl,
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.shrink,
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: ({
      ownerState
    }) => !ownerState.disableAnimation,
    style: {
      transition: theme.transitions.create(["color", "transform", "max-width"], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: ({
      variant,
      ownerState
    }) => variant === "filled" && ownerState.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: ({
      variant,
      ownerState,
      size
    }) => variant === "filled" && ownerState.shrink && size === "small",
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: ({
      variant,
      ownerState
    }) => variant === "outlined" && ownerState.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
})));
const InputLabel = /* @__PURE__ */ reactExports.forwardRef(function InputLabel2(inProps, ref2) {
  const props = useDefaultProps({
    name: "MuiInputLabel",
    props: inProps
  });
  const {
    disableAnimation = false,
    margin: margin2,
    shrink: shrinkProp,
    variant,
    className,
    ...other
  } = props;
  const muiFormControl = useFormControl();
  let shrink = shrinkProp;
  if (typeof shrink === "undefined" && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ["size", "variant", "required", "focused"]
  });
  const ownerState = {
    ...props,
    disableAnimation,
    formControl: muiFormControl,
    shrink,
    size: fcs.size,
    variant: fcs.variant,
    required: fcs.required,
    focused: fcs.focused
  };
  const classes = useUtilityClasses$H(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabelRoot, {
    "data-shrink": shrink,
    ref: ref2,
    className: clsx(classes.root, className),
    ...other,
    ownerState,
    classes
  });
});
process.env.NODE_ENV !== "production" ? InputLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
} : void 0;
function getLinkUtilityClass(slot) {
  return generateUtilityClass("MuiLink", slot);
}
const linkClasses = generateUtilityClasses("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]);
const getTextDecoration = ({
  theme,
  ownerState
}) => {
  const transformedColor = ownerState.color;
  if ("colorSpace" in theme && theme.colorSpace) {
    const color3 = getPath(theme, `palette.${transformedColor}.main`) || getPath(theme, `palette.${transformedColor}`) || ownerState.color;
    return theme.alpha(color3, 0.4);
  }
  const color2 = getPath(theme, `palette.${transformedColor}.main`, false) || getPath(theme, `palette.${transformedColor}`, false) || ownerState.color;
  const channelColor = getPath(theme, `palette.${transformedColor}.mainChannel`) || getPath(theme, `palette.${transformedColor}Channel`);
  if ("vars" in theme && channelColor) {
    return `rgba(${channelColor} / 0.4)`;
  }
  return alpha(color2, 0.4);
};
const v6Colors = {
  primary: true,
  secondary: true,
  error: true,
  info: true,
  success: true,
  warning: true,
  textPrimary: true,
  textSecondary: true,
  textDisabled: true
};
const useUtilityClasses$G = (ownerState) => {
  const {
    classes,
    component,
    focusVisible,
    underline
  } = ownerState;
  const slots = {
    root: ["root", `underline${capitalize$2(underline)}`, component === "button" && "button", focusVisible && "focusVisible"]
  };
  return composeClasses(slots, getLinkUtilityClass, classes);
};
const LinkRoot = styled(Typography$1, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, styles2[`underline${capitalize$2(ownerState.underline)}`], ownerState.component === "button" && styles2.button];
  }
})(memoTheme(({
  theme
}) => {
  return {
    variants: [{
      props: {
        underline: "none"
      },
      style: {
        textDecoration: "none"
      }
    }, {
      props: {
        underline: "hover"
      },
      style: {
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline"
        }
      }
    }, {
      props: {
        underline: "always"
      },
      style: {
        textDecoration: "underline",
        "&:hover": {
          textDecorationColor: "inherit"
        }
      }
    }, {
      props: ({
        underline,
        ownerState
      }) => underline === "always" && ownerState.color !== "inherit",
      style: {
        textDecorationColor: "var(--Link-underlineColor)"
      }
    }, {
      props: ({
        underline,
        ownerState
      }) => underline === "always" && ownerState.color === "inherit",
      style: theme.colorSpace ? {
        textDecorationColor: theme.alpha("currentColor", 0.4)
      } : null
    }, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color2]) => ({
      props: {
        underline: "always",
        color: color2
      },
      style: {
        "--Link-underlineColor": theme.alpha((theme.vars || theme).palette[color2].main, 0.4)
      }
    })), {
      props: {
        underline: "always",
        color: "textPrimary"
      },
      style: {
        "--Link-underlineColor": theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
      }
    }, {
      props: {
        underline: "always",
        color: "textSecondary"
      },
      style: {
        "--Link-underlineColor": theme.alpha((theme.vars || theme).palette.text.secondary, 0.4)
      }
    }, {
      props: {
        underline: "always",
        color: "textDisabled"
      },
      style: {
        "--Link-underlineColor": (theme.vars || theme).palette.text.disabled
      }
    }, {
      props: {
        component: "button"
      },
      style: {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
          borderStyle: "none"
          // Remove Firefox dotted outline.
        },
        [`&.${linkClasses.focusVisible}`]: {
          outline: "auto"
        }
      }
    }]
  };
}));
const Link$1 = /* @__PURE__ */ reactExports.forwardRef(function Link(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiLink"
  });
  const theme = useTheme();
  const {
    className,
    color: color2 = "primary",
    component = "a",
    onBlur,
    onFocus,
    TypographyClasses,
    underline = "always",
    variant = "inherit",
    sx: sx2,
    ...other
  } = props;
  const [focusVisible, setFocusVisible] = reactExports.useState(false);
  const handleBlur = (event2) => {
    if (!isFocusVisible(event2.target)) {
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event2);
    }
  };
  const handleFocus = (event2) => {
    if (isFocusVisible(event2.target)) {
      setFocusVisible(true);
    }
    if (onFocus) {
      onFocus(event2);
    }
  };
  const ownerState = {
    ...props,
    color: color2,
    component,
    focusVisible,
    underline,
    variant
  };
  const classes = useUtilityClasses$G(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(LinkRoot, {
    color: color2,
    className: clsx(classes.root, className),
    classes: TypographyClasses,
    component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: ref2,
    ownerState,
    variant,
    ...other,
    sx: [...v6Colors[color2] === void 0 ? [{
      color: color2
    }] : [], ...Array.isArray(sx2) ? sx2 : [sx2]],
    style: {
      ...other.style,
      ...underline === "always" && color2 !== "inherit" && !v6Colors[color2] && {
        "--Link-underlineColor": getTextDecoration({
          theme,
          ownerState
        })
      }
    }
  });
});
process.env.NODE_ENV !== "production" ? Link$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the link.
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * `classes` prop applied to the [`Typography`](https://mui.com/material-ui/api/typography/) element.
   */
  TypographyClasses: PropTypes.object,
  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: PropTypes.oneOf(["always", "hover", "none"]),
  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), PropTypes.string])
} : void 0;
const ListContext = /* @__PURE__ */ reactExports.createContext({});
if (process.env.NODE_ENV !== "production") {
  ListContext.displayName = "ListContext";
}
function getListUtilityClass(slot) {
  return generateUtilityClass("MuiList", slot);
}
generateUtilityClasses("MuiList", ["root", "padding", "dense", "subheader"]);
const useUtilityClasses$F = (ownerState) => {
  const {
    classes,
    disablePadding,
    dense,
    subheader
  } = ownerState;
  const slots = {
    root: ["root", !disablePadding && "padding", dense && "dense", subheader && "subheader"]
  };
  return composeClasses(slots, getListUtilityClass, classes);
};
const ListRoot = styled("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, !ownerState.disablePadding && styles2.padding, ownerState.dense && styles2.dense, ownerState.subheader && styles2.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState
    }) => !ownerState.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.subheader,
    style: {
      paddingTop: 0
    }
  }]
});
const List$1 = /* @__PURE__ */ reactExports.forwardRef(function List(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiList"
  });
  const {
    children,
    className,
    component = "ul",
    dense = false,
    disablePadding = false,
    subheader,
    ...other
  } = props;
  const context2 = reactExports.useMemo(() => ({
    dense
  }), [dense]);
  const ownerState = {
    ...props,
    component,
    dense,
    disablePadding
  };
  const classes = useUtilityClasses$F(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: context2,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ListRoot, {
      as: component,
      className: clsx(classes.root, className),
      ref: ref2,
      ownerState,
      ...other,
      children: [subheader, children]
    })
  });
});
process.env.NODE_ENV !== "production" ? List$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getListItemUtilityClass(slot) {
  return generateUtilityClass("MuiListItem", slot);
}
generateUtilityClasses("MuiListItem", ["root", "container", "dense", "alignItemsFlexStart", "divider", "gutters", "padding", "secondaryAction"]);
function getListItemButtonUtilityClass(slot) {
  return generateUtilityClass("MuiListItemButton", slot);
}
const listItemButtonClasses = generateUtilityClasses("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
const overridesResolver$3 = (props, styles2) => {
  const {
    ownerState
  } = props;
  return [styles2.root, ownerState.dense && styles2.dense, ownerState.alignItems === "flex-start" && styles2.alignItemsFlexStart, ownerState.divider && styles2.divider, !ownerState.disableGutters && styles2.gutters];
};
const useUtilityClasses$E = (ownerState) => {
  const {
    alignItems,
    classes,
    dense,
    disabled,
    disableGutters,
    divider: divider2,
    selected
  } = ownerState;
  const slots = {
    root: ["root", dense && "dense", !disableGutters && "gutters", divider2 && "divider", disabled && "disabled", alignItems === "flex-start" && "alignItemsFlexStart", selected && "selected"]
  };
  const composedClasses = composeClasses(slots, getListItemButtonUtilityClass, classes);
  return {
    ...classes,
    ...composedClasses
  };
};
const ListItemButtonRoot = styled(ButtonBase, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: overridesResolver$3
})(memoTheme(({
  theme
}) => ({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: theme.transitions.create("background-color", {
    duration: theme.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${listItemButtonClasses.selected}`]: {
    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
    [`&.${listItemButtonClasses.focusVisible}`]: {
      backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
    }
  },
  [`&.${listItemButtonClasses.selected}:hover`]: {
    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
    }
  },
  [`&.${listItemButtonClasses.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${listItemButtonClasses.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  },
  variants: [{
    props: ({
      ownerState
    }) => ownerState.divider,
    style: {
      borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState
    }) => !ownerState.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }]
})));
const ListItemButton = /* @__PURE__ */ reactExports.forwardRef(function ListItemButton2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiListItemButton"
  });
  const {
    alignItems = "center",
    autoFocus = false,
    component = "div",
    children,
    dense = false,
    disableGutters = false,
    divider: divider2 = false,
    focusVisibleClassName,
    selected = false,
    className,
    ...other
  } = props;
  const context2 = reactExports.useContext(ListContext);
  const childContext = reactExports.useMemo(() => ({
    dense: dense || context2.dense || false,
    alignItems,
    disableGutters
  }), [alignItems, context2.dense, dense, disableGutters]);
  const listItemRef = reactExports.useRef(null);
  useEnhancedEffect(() => {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (process.env.NODE_ENV !== "production") {
        console.error("MUI: Unable to set focus to a ListItemButton whose component has not been rendered.");
      }
    }
  }, [autoFocus]);
  const ownerState = {
    ...props,
    alignItems,
    dense: childContext.dense,
    disableGutters,
    divider: divider2,
    selected
  };
  const classes = useUtilityClasses$E(ownerState);
  const {
    root: root2,
    ...forwardedClasses
  } = classes;
  const handleRef = useForkRef(listItemRef, ref2);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: childContext,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemButtonRoot, {
      ref: handleRef,
      href: other.href || other.to,
      component: (other.href || other.to) && component === "div" ? "button" : component,
      focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
      ownerState,
      className: clsx(classes.root, className),
      ...other,
      classes: forwardedClasses,
      children
    })
  });
});
process.env.NODE_ENV !== "production" ? ListItemButton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: PropTypes.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  href: PropTypes.string,
  /**
   * Use to apply selected styling.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getListItemSecondaryActionClassesUtilityClass(slot) {
  return generateUtilityClass("MuiListItemSecondaryAction", slot);
}
generateUtilityClasses("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const useUtilityClasses$D = (ownerState) => {
  const {
    disableGutters,
    classes
  } = ownerState;
  const slots = {
    root: ["root", disableGutters && "disableGutters"]
  };
  return composeClasses(slots, getListItemSecondaryActionClassesUtilityClass, classes);
};
const ListItemSecondaryActionRoot = styled("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.disableGutters && styles2.disableGutters];
  }
})({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  variants: [{
    props: ({
      ownerState
    }) => ownerState.disableGutters,
    style: {
      right: 0
    }
  }]
});
const ListItemSecondaryAction = /* @__PURE__ */ reactExports.forwardRef(function ListItemSecondaryAction2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiListItemSecondaryAction"
  });
  const {
    className,
    ...other
  } = props;
  const context2 = reactExports.useContext(ListContext);
  const ownerState = {
    ...props,
    disableGutters: context2.disableGutters
  };
  const classes = useUtilityClasses$D(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemSecondaryActionRoot, {
    className: clsx(classes.root, className),
    ownerState,
    ref: ref2,
    ...other
  });
});
process.env.NODE_ENV !== "production" ? ListItemSecondaryAction.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
const overridesResolver$2 = (props, styles2) => {
  const {
    ownerState
  } = props;
  return [styles2.root, ownerState.dense && styles2.dense, ownerState.alignItems === "flex-start" && styles2.alignItemsFlexStart, ownerState.divider && styles2.divider, !ownerState.disableGutters && styles2.gutters, !ownerState.disablePadding && styles2.padding, ownerState.hasSecondaryAction && styles2.secondaryAction];
};
const useUtilityClasses$C = (ownerState) => {
  const {
    alignItems,
    classes,
    dense,
    disableGutters,
    disablePadding,
    divider: divider2,
    hasSecondaryAction
  } = ownerState;
  const slots = {
    root: ["root", dense && "dense", !disableGutters && "gutters", !disablePadding && "padding", divider2 && "divider", alignItems === "flex-start" && "alignItemsFlexStart", hasSecondaryAction && "secondaryAction"],
    container: ["container"],
    secondaryAction: ["secondaryAction"]
  };
  return composeClasses(slots, getListItemUtilityClass, classes);
};
const ListItemRoot = styled("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: overridesResolver$2
})(memoTheme(({
  theme
}) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left",
  variants: [{
    props: ({
      ownerState
    }) => !ownerState.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState
    }) => !ownerState.disablePadding && ownerState.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState
    }) => !ownerState.disablePadding && !ownerState.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState
    }) => !ownerState.disablePadding && !!ownerState.secondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }, {
    props: ({
      ownerState
    }) => !!ownerState.secondaryAction,
    style: {
      [`& > .${listItemButtonClasses.root}`]: {
        paddingRight: 48
      }
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.divider,
    style: {
      borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.button,
    style: {
      transition: theme.transitions.create("background-color", {
        duration: theme.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: (theme.vars || theme).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.hasSecondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }]
})));
const ListItemContainer = styled("li", {
  name: "MuiListItem",
  slot: "Container"
})({
  position: "relative"
});
const ListItem = /* @__PURE__ */ reactExports.forwardRef(function ListItem2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiListItem"
  });
  const {
    alignItems = "center",
    children: childrenProp,
    className,
    component: componentProp,
    components = {},
    componentsProps = {},
    ContainerComponent = "li",
    ContainerProps: {
      className: ContainerClassName,
      ...ContainerProps
    } = {},
    dense = false,
    disableGutters = false,
    disablePadding = false,
    divider: divider2 = false,
    secondaryAction,
    slotProps = {},
    slots = {},
    ...other
  } = props;
  const context2 = reactExports.useContext(ListContext);
  const childContext = reactExports.useMemo(() => ({
    dense: dense || context2.dense || false,
    alignItems,
    disableGutters
  }), [alignItems, context2.dense, dense, disableGutters]);
  const listItemRef = reactExports.useRef(null);
  const children = reactExports.Children.toArray(childrenProp);
  const hasSecondaryAction = children.length && isMuiElement(children[children.length - 1], ["ListItemSecondaryAction"]);
  const ownerState = {
    ...props,
    alignItems,
    dense: childContext.dense,
    disableGutters,
    disablePadding,
    divider: divider2,
    hasSecondaryAction
  };
  const classes = useUtilityClasses$C(ownerState);
  const handleRef = useForkRef(listItemRef, ref2);
  const externalForwardedProps = {
    slots,
    slotProps
  };
  const [SecondaryActionSlot, secondaryActionSlotProps] = useSlot("secondaryAction", {
    elementType: ListItemSecondaryAction,
    externalForwardedProps,
    ownerState,
    className: classes.secondaryAction
  });
  const Root = slots.root || components.Root || ListItemRoot;
  const rootProps = slotProps.root || componentsProps.root || {};
  const componentProps = {
    className: clsx(classes.root, rootProps.className, className),
    ...other
  };
  let Component = componentProp || "li";
  if (hasSecondaryAction) {
    Component = !componentProps.component && !componentProp ? "div" : Component;
    if (ContainerComponent === "li") {
      if (Component === "li") {
        Component = "div";
      } else if (componentProps.component === "li") {
        componentProps.component = "div";
      }
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
      value: childContext,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItemContainer, {
        as: ContainerComponent,
        className: clsx(classes.container, ContainerClassName),
        ref: handleRef,
        ownerState,
        ...ContainerProps,
        children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Root, {
          ...rootProps,
          ...!isHostComponent(Root) && {
            as: Component,
            ownerState: {
              ...ownerState,
              ...rootProps.ownerState
            }
          },
          ...componentProps,
          children
        }), children.pop()]
      })
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: childContext,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Root, {
      ...rootProps,
      as: Component,
      ref: handleRef,
      ...!isHostComponent(Root) && {
        ownerState: {
          ...ownerState,
          ...rootProps.ownerState
        }
      },
      ...componentProps,
      children: [children, secondaryAction && /* @__PURE__ */ jsxRuntimeExports.jsx(SecondaryActionSlot, {
        ...secondaryActionSlotProps,
        children: secondaryAction
      })]
    })
  });
});
process.env.NODE_ENV !== "production" ? ListItem.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: PropTypes.oneOf(["center", "flex-start"]),
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(PropTypes.node, (props) => {
    const children = reactExports.Children.toArray(props.children);
    let secondaryActionIndex = -1;
    for (let i = children.length - 1; i >= 0; i -= 1) {
      const child = children[i];
      if (isMuiElement(child, ["ListItemSecondaryAction"])) {
        secondaryActionIndex = i;
        break;
      }
    }
    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.");
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated Use the `component` or `slots.root` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerComponent: elementTypeAcceptingRef$1,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated Use the `slotProps.root` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerProps: PropTypes.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: PropTypes.node,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.object,
    secondaryAction: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType,
    secondaryAction: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getListItemIconUtilityClass(slot) {
  return generateUtilityClass("MuiListItemIcon", slot);
}
const listItemIconClasses = generateUtilityClasses("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
const useUtilityClasses$B = (ownerState) => {
  const {
    alignItems,
    classes
  } = ownerState;
  const slots = {
    root: ["root", alignItems === "flex-start" && "alignItemsFlexStart"]
  };
  return composeClasses(slots, getListItemIconUtilityClass, classes);
};
const ListItemIconRoot = styled("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.alignItems === "flex-start" && styles2.alignItemsFlexStart];
  }
})(memoTheme(({
  theme
}) => ({
  minWidth: 56,
  color: (theme.vars || theme).palette.action.active,
  flexShrink: 0,
  display: "inline-flex",
  variants: [{
    props: {
      alignItems: "flex-start"
    },
    style: {
      marginTop: 8
    }
  }]
})));
const ListItemIcon = /* @__PURE__ */ reactExports.forwardRef(function ListItemIcon2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiListItemIcon"
  });
  const {
    className,
    ...other
  } = props;
  const context2 = reactExports.useContext(ListContext);
  const ownerState = {
    ...props,
    alignItems: context2.alignItems
  };
  const classes = useUtilityClasses$B(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIconRoot, {
    className: clsx(classes.root, className),
    ownerState,
    ref: ref2,
    ...other
  });
});
process.env.NODE_ENV !== "production" ? ListItemIcon.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getListItemTextUtilityClass(slot) {
  return generateUtilityClass("MuiListItemText", slot);
}
const listItemTextClasses = generateUtilityClasses("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]);
const useUtilityClasses$A = (ownerState) => {
  const {
    classes,
    inset,
    primary,
    secondary,
    dense
  } = ownerState;
  const slots = {
    root: ["root", inset && "inset", dense && "dense", primary && secondary && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  };
  return composeClasses(slots, getListItemTextUtilityClass, classes);
};
const ListItemTextRoot = styled("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${listItemTextClasses.primary}`]: styles2.primary
    }, {
      [`& .${listItemTextClasses.secondary}`]: styles2.secondary
    }, styles2.root, ownerState.inset && styles2.inset, ownerState.primary && ownerState.secondary && styles2.multiline, ownerState.dense && styles2.dense];
  }
})({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4,
  // Combine this and the below selector once https://github.com/emotion-js/emotion/issues/3366 is solved
  [`.${typographyClasses.root}:where(& .${listItemTextClasses.primary})`]: {
    display: "block"
  },
  [`.${typographyClasses.root}:where(& .${listItemTextClasses.secondary})`]: {
    display: "block"
  },
  variants: [{
    props: ({
      ownerState
    }) => ownerState.primary && ownerState.secondary,
    style: {
      marginTop: 6,
      marginBottom: 6
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.inset,
    style: {
      paddingLeft: 56
    }
  }]
});
const ListItemText = /* @__PURE__ */ reactExports.forwardRef(function ListItemText2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiListItemText"
  });
  const {
    children,
    className,
    disableTypography = false,
    inset = false,
    primary: primaryProp,
    primaryTypographyProps,
    secondary: secondaryProp,
    secondaryTypographyProps,
    slots = {},
    slotProps = {},
    ...other
  } = props;
  const {
    dense
  } = reactExports.useContext(ListContext);
  let primary = primaryProp != null ? primaryProp : children;
  let secondary = secondaryProp;
  const ownerState = {
    ...props,
    disableTypography,
    inset,
    primary: !!primary,
    secondary: !!secondary,
    dense
  };
  const classes = useUtilityClasses$A(ownerState);
  const externalForwardedProps = {
    slots,
    slotProps: {
      primary: primaryTypographyProps,
      secondary: secondaryTypographyProps,
      ...slotProps
    }
  };
  const [RootSlot, rootSlotProps] = useSlot("root", {
    className: clsx(classes.root, className),
    elementType: ListItemTextRoot,
    externalForwardedProps: {
      ...externalForwardedProps,
      ...other
    },
    ownerState,
    ref: ref2
  });
  const [PrimarySlot, primarySlotProps] = useSlot("primary", {
    className: classes.primary,
    elementType: Typography$1,
    externalForwardedProps,
    ownerState
  });
  const [SecondarySlot, secondarySlotProps] = useSlot("secondary", {
    className: classes.secondary,
    elementType: Typography$1,
    externalForwardedProps,
    ownerState
  });
  if (primary != null && primary.type !== Typography$1 && !disableTypography) {
    primary = /* @__PURE__ */ jsxRuntimeExports.jsx(PrimarySlot, {
      variant: dense ? "body2" : "body1",
      component: primarySlotProps?.variant ? void 0 : "span",
      ...primarySlotProps,
      children: primary
    });
  }
  if (secondary != null && secondary.type !== Typography$1 && !disableTypography) {
    secondary = /* @__PURE__ */ jsxRuntimeExports.jsx(SecondarySlot, {
      variant: "body2",
      color: "textSecondary",
      ...secondarySlotProps,
      children: secondary
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(RootSlot, {
    ...rootSlotProps,
    children: [primary, secondary]
  });
});
process.env.NODE_ENV !== "production" ? ListItemText.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: PropTypes.bool,
  /**
   * The main content element.
   */
  primary: PropTypes.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.primary` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  primaryTypographyProps: PropTypes.object,
  /**
   * The secondary content element.
   */
  secondary: PropTypes.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.secondary` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  secondaryTypographyProps: PropTypes.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    primary: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    secondary: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    primary: PropTypes.elementType,
    root: PropTypes.elementType,
    secondary: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function nextItem$1(list2, item, disableListWrap) {
  if (list2 === item) {
    return list2.firstChild;
  }
  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }
  return disableListWrap ? null : list2.firstChild;
}
function previousItem$1(list2, item, disableListWrap) {
  if (list2 === item) {
    return disableListWrap ? list2.firstChild : list2.lastChild;
  }
  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }
  return disableListWrap ? null : list2.lastChild;
}
function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === void 0) {
    return true;
  }
  let text = nextFocus.innerText;
  if (text === void 0) {
    text = nextFocus.textContent;
  }
  text = text.trim().toLowerCase();
  if (text.length === 0) {
    return false;
  }
  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }
  return text.startsWith(textCriteria.keys.join(""));
}
function moveFocus$1(list2, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  let wrappedOnce = false;
  let nextFocus = traversalFunction(list2, currentFocus, currentFocus ? disableListWrap : false);
  while (nextFocus) {
    if (nextFocus === list2.firstChild) {
      if (wrappedOnce) {
        return false;
      }
      wrappedOnce = true;
    }
    const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
    if (!nextFocus.hasAttribute("tabindex") || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      nextFocus = traversalFunction(list2, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return true;
    }
  }
  return false;
}
const MenuList$1 = /* @__PURE__ */ reactExports.forwardRef(function MenuList(props, ref2) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions,
    autoFocus = false,
    autoFocusItem = false,
    children,
    className,
    disabledItemsFocusable = false,
    disableListWrap = false,
    onKeyDown,
    variant = "selectedMenu",
    ...other
  } = props;
  const listRef = reactExports.useRef(null);
  const textCriteriaRef = reactExports.useRef({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect(() => {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  reactExports.useImperativeHandle(actions, () => ({
    adjustStyleForScrollbar: (containerElement, {
      direction
    }) => {
      const noExplicitWidth = !listRef.current.style.width;
      if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
        const scrollbarSize = `${getScrollbarSize(ownerWindow(containerElement))}px`;
        listRef.current.style[direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
        listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
      }
      return listRef.current;
    }
  }), []);
  const handleKeyDown = (event2) => {
    const list2 = listRef.current;
    const key = event2.key;
    const isModifierKeyPressed = event2.ctrlKey || event2.metaKey || event2.altKey;
    if (isModifierKeyPressed) {
      if (onKeyDown) {
        onKeyDown(event2);
      }
      return;
    }
    const currentFocus = activeElement(ownerDocument(list2));
    if (key === "ArrowDown") {
      event2.preventDefault();
      moveFocus$1(list2, currentFocus, disableListWrap, disabledItemsFocusable, nextItem$1);
    } else if (key === "ArrowUp") {
      event2.preventDefault();
      moveFocus$1(list2, currentFocus, disableListWrap, disabledItemsFocusable, previousItem$1);
    } else if (key === "Home") {
      event2.preventDefault();
      moveFocus$1(list2, null, disableListWrap, disabledItemsFocusable, nextItem$1);
    } else if (key === "End") {
      event2.preventDefault();
      moveFocus$1(list2, null, disableListWrap, disabledItemsFocusable, previousItem$1);
    } else if (key.length === 1) {
      const criteria = textCriteriaRef.current;
      const lowerKey = key.toLowerCase();
      const currTime = performance.now();
      if (criteria.keys.length > 0) {
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }
      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      const keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus$1(list2, currentFocus, false, disabledItemsFocusable, nextItem$1, criteria))) {
        event2.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }
    if (onKeyDown) {
      onKeyDown(event2);
    }
  };
  const handleRef = useForkRef(listRef, ref2);
  let activeItemIndex = -1;
  reactExports.Children.forEach(children, (child, index2) => {
    if (!/* @__PURE__ */ reactExports.isValidElement(child)) {
      if (activeItemIndex === index2) {
        activeItemIndex += 1;
        if (activeItemIndex >= children.length) {
          activeItemIndex = -1;
        }
      }
      return;
    }
    if (process.env.NODE_ENV !== "production") {
      if (reactIsExports.isFragment(child)) {
        console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join("\n"));
      }
    }
    if (!child.props.disabled) {
      if (variant === "selectedMenu" && child.props.selected) {
        activeItemIndex = index2;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index2;
      }
    }
    if (activeItemIndex === index2 && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
      activeItemIndex += 1;
      if (activeItemIndex >= children.length) {
        activeItemIndex = -1;
      }
    }
  });
  const items = reactExports.Children.map(children, (child, index2) => {
    if (index2 === activeItemIndex) {
      const newChildProps = {};
      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }
      if (child.props.tabIndex === void 0 && variant === "selectedMenu") {
        newChildProps.tabIndex = 0;
      }
      return /* @__PURE__ */ reactExports.cloneElement(child, newChildProps);
    }
    return child;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(List$1, {
    role: "menu",
    ref: handleRef,
    className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1,
    ...other,
    children: items
  });
});
process.env.NODE_ENV !== "production" ? MenuList$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: PropTypes.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
} : void 0;
function getPopoverUtilityClass(slot) {
  return generateUtilityClass("MuiPopover", slot);
}
generateUtilityClasses("MuiPopover", ["root", "paper"]);
function getOffsetTop(rect, vertical) {
  let offset2 = 0;
  if (typeof vertical === "number") {
    offset2 = vertical;
  } else if (vertical === "center") {
    offset2 = rect.height / 2;
  } else if (vertical === "bottom") {
    offset2 = rect.height;
  }
  return offset2;
}
function getOffsetLeft(rect, horizontal) {
  let offset2 = 0;
  if (typeof horizontal === "number") {
    offset2 = horizontal;
  } else if (horizontal === "center") {
    offset2 = rect.width / 2;
  } else if (horizontal === "right") {
    offset2 = rect.width;
  }
  return offset2;
}
function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map((n12) => typeof n12 === "number" ? `${n12}px` : n12).join(" ");
}
function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const useUtilityClasses$z = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    paper: ["paper"]
  };
  return composeClasses(slots, getPopoverUtilityClass, classes);
};
const PopoverRoot = styled(Modal, {
  name: "MuiPopover",
  slot: "Root"
})({});
const PopoverPaper = styled(Paper, {
  name: "MuiPopover",
  slot: "Paper"
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Popover = /* @__PURE__ */ reactExports.forwardRef(function Popover2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiPopover"
  });
  const {
    action,
    anchorEl,
    anchorOrigin = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition,
    anchorReference = "anchorEl",
    children,
    className,
    container: containerProp,
    elevation = 8,
    marginThreshold = 16,
    open: open2,
    PaperProps: PaperPropsProp = {},
    // TODO: remove in v7
    slots = {},
    slotProps = {},
    transformOrigin = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent,
    // TODO: remove in v7
    transitionDuration: transitionDurationProp = "auto",
    TransitionProps = {},
    // TODO: remove in v7
    disableScrollLock = false,
    ...other
  } = props;
  const paperRef = reactExports.useRef();
  const ownerState = {
    ...props,
    anchorOrigin,
    anchorReference,
    elevation,
    marginThreshold,
    transformOrigin,
    TransitionComponent,
    transitionDuration: transitionDurationProp,
    TransitionProps
  };
  const classes = useUtilityClasses$z(ownerState);
  const getAnchorOffset = reactExports.useCallback(() => {
    if (anchorReference === "anchorPosition") {
      if (process.env.NODE_ENV !== "production") {
        if (!anchorPosition) {
          console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.');
        }
      }
      return anchorPosition;
    }
    const resolvedAnchorEl = resolveAnchorEl(anchorEl);
    const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : ownerDocument(paperRef.current).body;
    const anchorRect = anchorElement.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const box = anchorElement.getBoundingClientRect();
      if (isLayoutSupported() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
        console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join("\n"));
      }
    }
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]);
  const getTransformOrigin = reactExports.useCallback((elemRect) => {
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical),
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  const getPositioningStyle = reactExports.useCallback((element) => {
    const elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    };
    const elemTransformOrigin = getTransformOrigin(elemRect);
    if (anchorReference === "none") {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    }
    const anchorOffset = getAnchorOffset();
    let top2 = anchorOffset.top - elemTransformOrigin.vertical;
    let left2 = anchorOffset.left - elemTransformOrigin.horizontal;
    const bottom2 = top2 + elemRect.height;
    const right2 = left2 + elemRect.width;
    const containerWindow = ownerWindow(resolveAnchorEl(anchorEl));
    const heightThreshold = containerWindow.innerHeight - marginThreshold;
    const widthThreshold = containerWindow.innerWidth - marginThreshold;
    if (marginThreshold !== null && top2 < marginThreshold) {
      const diff2 = top2 - marginThreshold;
      top2 -= diff2;
      elemTransformOrigin.vertical += diff2;
    } else if (marginThreshold !== null && bottom2 > heightThreshold) {
      const diff2 = bottom2 - heightThreshold;
      top2 -= diff2;
      elemTransformOrigin.vertical += diff2;
    }
    if (process.env.NODE_ENV !== "production") {
      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
        console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${elemRect.height - heightThreshold}px).`, "Please consider adding a `max-height` to improve the user-experience."].join("\n"));
      }
    }
    if (marginThreshold !== null && left2 < marginThreshold) {
      const diff2 = left2 - marginThreshold;
      left2 -= diff2;
      elemTransformOrigin.horizontal += diff2;
    } else if (right2 > widthThreshold) {
      const diff2 = right2 - widthThreshold;
      left2 -= diff2;
      elemTransformOrigin.horizontal += diff2;
    }
    return {
      top: `${Math.round(top2)}px`,
      left: `${Math.round(left2)}px`,
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getTransformOrigin, marginThreshold]);
  const [isPositioned, setIsPositioned] = reactExports.useState(open2);
  const setPositioningStyles = reactExports.useCallback(() => {
    const element = paperRef.current;
    if (!element) {
      return;
    }
    const positioning = getPositioningStyle(element);
    if (positioning.top !== null) {
      element.style.setProperty("top", positioning.top);
    }
    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }
    element.style.transformOrigin = positioning.transformOrigin;
    setIsPositioned(true);
  }, [getPositioningStyle]);
  reactExports.useEffect(() => {
    if (disableScrollLock) {
      window.addEventListener("scroll", setPositioningStyles);
    }
    return () => window.removeEventListener("scroll", setPositioningStyles);
  }, [anchorEl, disableScrollLock, setPositioningStyles]);
  const handleEntering = () => {
    setPositioningStyles();
  };
  const handleExited = () => {
    setIsPositioned(false);
  };
  reactExports.useEffect(() => {
    if (open2) {
      setPositioningStyles();
    }
  });
  reactExports.useImperativeHandle(action, () => open2 ? {
    updatePosition: () => {
      setPositioningStyles();
    }
  } : null, [open2, setPositioningStyles]);
  reactExports.useEffect(() => {
    if (!open2) {
      return void 0;
    }
    const handleResize = debounce$2(() => {
      setPositioningStyles();
    });
    const containerWindow = ownerWindow(resolveAnchorEl(anchorEl));
    containerWindow.addEventListener("resize", handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener("resize", handleResize);
    };
  }, [anchorEl, open2, setPositioningStyles]);
  let transitionDuration = transitionDurationProp;
  const externalForwardedProps = {
    slots: {
      transition: TransitionComponent,
      ...slots
    },
    slotProps: {
      transition: TransitionProps,
      paper: PaperPropsProp,
      ...slotProps
    }
  };
  const [TransitionSlot, transitionSlotProps] = useSlot("transition", {
    elementType: Grow,
    externalForwardedProps,
    ownerState,
    getSlotProps: (handlers) => ({
      ...handlers,
      onEntering: (element, isAppearing) => {
        handlers.onEntering?.(element, isAppearing);
        handleEntering();
      },
      onExited: (element) => {
        handlers.onExited?.(element);
        handleExited();
      }
    }),
    additionalProps: {
      appear: true,
      in: open2
    }
  });
  if (transitionDurationProp === "auto" && !TransitionSlot.muiSupportAuto) {
    transitionDuration = void 0;
  }
  const container = containerProp || (anchorEl ? ownerDocument(resolveAnchorEl(anchorEl)).body : void 0);
  const [RootSlot, {
    slots: rootSlotsProp,
    slotProps: rootSlotPropsProp,
    ...rootProps
  }] = useSlot("root", {
    ref: ref2,
    elementType: PopoverRoot,
    externalForwardedProps: {
      ...externalForwardedProps,
      ...other
    },
    shouldForwardComponentProp: true,
    additionalProps: {
      slots: {
        backdrop: slots.backdrop
      },
      slotProps: {
        backdrop: mergeSlotProps$2(typeof slotProps.backdrop === "function" ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
          invisible: true
        })
      },
      container,
      open: open2
    },
    ownerState,
    className: clsx(classes.root, className)
  });
  const [PaperSlot, paperProps] = useSlot("paper", {
    ref: paperRef,
    className: classes.paper,
    elementType: PopoverPaper,
    externalForwardedProps,
    shouldForwardComponentProp: true,
    additionalProps: {
      elevation,
      style: isPositioned ? void 0 : {
        opacity: 0
      }
    },
    ownerState
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RootSlot, {
    ...rootProps,
    ...!isHostComponent(RootSlot) && {
      slots: rootSlotsProp,
      slotProps: rootSlotPropsProp,
      disableScrollLock
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionSlot, {
      ...transitionSlotProps,
      timeout: transitionDuration,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(PaperSlot, {
        ...paperProps,
        children
      })
    })
  });
});
process.env.NODE_ENV !== "production" ? Popover.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), (props) => {
    if (props.open && (!props.anchorReference || props.anchorReference === "anchorEl")) {
      const resolvedAnchorEl = resolveAnchorEl(props.anchorEl);
      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        const box = resolvedAnchorEl.getBoundingClientRect();
        if (process.env.NODE_ENV !== "production") {
          if (isLayoutSupported() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
            return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join("\n"));
          }
        }
      } else {
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${resolvedAnchorEl}\` instead.`].join("\n"));
      }
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: PropTypes.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  BackdropProps: PropTypes.object,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: integerPropType,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overridden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef$1
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    paper: PropTypes.elementType,
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: PropTypes.object
} : void 0;
function getMenuUtilityClass(slot) {
  return generateUtilityClass("MuiMenu", slot);
}
generateUtilityClasses("MuiMenu", ["root", "paper", "list"]);
const RTL_ORIGIN = {
  vertical: "top",
  horizontal: "right"
};
const LTR_ORIGIN = {
  vertical: "top",
  horizontal: "left"
};
const useUtilityClasses$y = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  };
  return composeClasses(slots, getMenuUtilityClass, classes);
};
const MenuRoot = styled(Popover, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "MuiMenu",
  slot: "Root"
})({});
const MenuPaper = styled(PopoverPaper, {
  name: "MuiMenu",
  slot: "Paper"
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
});
const MenuMenuList = styled(MenuList$1, {
  name: "MuiMenu",
  slot: "List"
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Menu$1 = /* @__PURE__ */ reactExports.forwardRef(function Menu(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiMenu"
  });
  const {
    autoFocus = true,
    children,
    className,
    disableAutoFocusItem = false,
    MenuListProps = {},
    onClose,
    open: open2,
    PaperProps = {},
    PopoverClasses,
    transitionDuration = "auto",
    TransitionProps: {
      onEntering,
      ...TransitionProps
    } = {},
    variant = "selectedMenu",
    slots = {},
    slotProps = {},
    ...other
  } = props;
  const isRtl = useRtl();
  const ownerState = {
    ...props,
    autoFocus,
    disableAutoFocusItem,
    MenuListProps,
    onEntering,
    PaperProps,
    transitionDuration,
    TransitionProps,
    variant
  };
  const classes = useUtilityClasses$y(ownerState);
  const autoFocusItem = autoFocus && !disableAutoFocusItem && open2;
  const menuListActionsRef = reactExports.useRef(null);
  const handleEntering = (element, isAppearing) => {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, {
        direction: isRtl ? "rtl" : "ltr"
      });
    }
    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };
  const handleListKeyDown = (event2) => {
    if (event2.key === "Tab") {
      event2.preventDefault();
      if (onClose) {
        onClose(event2, "tabKeyDown");
      }
    }
  };
  let activeItemIndex = -1;
  reactExports.Children.map(children, (child, index2) => {
    if (!/* @__PURE__ */ reactExports.isValidElement(child)) {
      return;
    }
    if (process.env.NODE_ENV !== "production") {
      if (reactIsExports.isFragment(child)) {
        console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join("\n"));
      }
    }
    if (!child.props.disabled) {
      if (variant === "selectedMenu" && child.props.selected) {
        activeItemIndex = index2;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index2;
      }
    }
  });
  const externalForwardedProps = {
    slots,
    slotProps: {
      list: MenuListProps,
      transition: TransitionProps,
      paper: PaperProps,
      ...slotProps
    }
  };
  const rootSlotProps = useSlotProps({
    elementType: slots.root,
    externalSlotProps: slotProps.root,
    ownerState,
    className: [classes.root, className]
  });
  const [PaperSlot, paperSlotProps] = useSlot("paper", {
    className: classes.paper,
    elementType: MenuPaper,
    externalForwardedProps,
    shouldForwardComponentProp: true,
    ownerState
  });
  const [ListSlot, listSlotProps] = useSlot("list", {
    className: clsx(classes.list, MenuListProps.className),
    elementType: MenuMenuList,
    shouldForwardComponentProp: true,
    externalForwardedProps,
    getSlotProps: (handlers) => ({
      ...handlers,
      onKeyDown: (event2) => {
        handleListKeyDown(event2);
        handlers.onKeyDown?.(event2);
      }
    }),
    ownerState
  });
  const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === "function" ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuRoot, {
    onClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: isRtl ? "right" : "left"
    },
    transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
    slots: {
      root: slots.root,
      paper: PaperSlot,
      backdrop: slots.backdrop,
      ...slots.transition && {
        // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
        transition: slots.transition
      }
    },
    slotProps: {
      root: rootSlotProps,
      paper: paperSlotProps,
      backdrop: typeof slotProps.backdrop === "function" ? slotProps.backdrop(ownerState) : slotProps.backdrop,
      transition: {
        ...resolvedTransitionProps,
        onEntering: (...args) => {
          handleEntering(...args);
          resolvedTransitionProps?.onEntering?.(...args);
        }
      }
    },
    open: open2,
    ref: ref2,
    transitionDuration,
    ownerState,
    ...other,
    classes: PopoverClasses,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListSlot, {
      actions: menuListActionsRef,
      autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
      autoFocusItem,
      variant,
      ...listSlotProps,
      children
    })
  });
});
process.env.NODE_ENV !== "production" ? Menu$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: PropTypes.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: PropTypes.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  MenuListProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: PropTypes.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    list: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    list: PropTypes.elementType,
    paper: PropTypes.elementType,
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: PropTypes.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
} : void 0;
function getMenuItemUtilityClass(slot) {
  return generateUtilityClass("MuiMenuItem", slot);
}
const menuItemClasses = generateUtilityClasses("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]);
function getNativeSelectUtilityClasses(slot) {
  return generateUtilityClass("MuiNativeSelect", slot);
}
const nativeSelectClasses = generateUtilityClasses("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
const useUtilityClasses$x = (ownerState) => {
  const {
    classes,
    variant,
    disabled,
    multiple,
    open: open2,
    error
  } = ownerState;
  const slots = {
    select: ["select", variant, disabled && "disabled", multiple && "multiple", error && "error"],
    icon: ["icon", `icon${capitalize$2(variant)}`, open2 && "iconOpen", disabled && "disabled"]
  };
  return composeClasses(slots, getNativeSelectUtilityClasses, classes);
};
const StyledSelectSelect = styled("select", {
  name: "MuiNativeSelect"
})(({
  theme
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${nativeSelectClasses.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (theme.vars || theme).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState
    }) => ownerState.variant !== "filled" && ownerState.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (theme.vars || theme).shape.borderRadius,
      "&:focus": {
        borderRadius: (theme.vars || theme).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
}));
const NativeSelectSelect = styled(StyledSelectSelect, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: rootShouldForwardProp,
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.select, styles2[ownerState.variant], ownerState.error && styles2.error, {
      [`&.${nativeSelectClasses.multiple}`]: styles2.multiple
    }];
  }
})({});
const StyledSelectIcon = styled("svg", {
  name: "MuiNativeSelect"
})(({
  theme
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (theme.vars || theme).palette.action.active,
  [`&.${nativeSelectClasses.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState
    }) => ownerState.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
}));
const NativeSelectIcon = styled(StyledSelectIcon, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.icon, ownerState.variant && styles2[`icon${capitalize$2(ownerState.variant)}`], ownerState.open && styles2.iconOpen];
  }
})({});
const NativeSelectInput = /* @__PURE__ */ reactExports.forwardRef(function NativeSelectInput2(props, ref2) {
  const {
    className,
    disabled,
    error,
    IconComponent,
    inputRef,
    variant = "standard",
    ...other
  } = props;
  const ownerState = {
    ...props,
    disabled,
    variant,
    error
  };
  const classes = useUtilityClasses$x(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectSelect, {
      ownerState,
      className: clsx(classes.select, className),
      disabled,
      ref: inputRef || ref2,
      ...other
    }), props.multiple ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectIcon, {
      as: IconComponent,
      ownerState,
      className: classes.icon
    })]
  });
});
process.env.NODE_ENV !== "production" ? NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType,
  /**
   * @ignore
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
} : void 0;
function getSelectUtilityClasses(slot) {
  return generateUtilityClass("MuiSelect", slot);
}
const selectClasses = generateUtilityClasses("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
function getOpenInteractionType(event2) {
  if (!event2) {
    return null;
  }
  if (event2.type === "mousedown" || event2.type === "pointerdown" || event2.type === "touchstart") {
    return "pointer";
  }
  if (event2.type === "keydown" || event2.type === "click" && event2.detail === 0) {
    return "keyboard";
  }
  return null;
}
function isEmpty(display) {
  return display == null || typeof display === "string" && !display.trim();
}
function areEqualValues(a, b) {
  if (typeof b === "object" && b !== null) {
    return a === b;
  }
  return String(a) === String(b);
}
const SelectFocusSourceContext = /* @__PURE__ */ reactExports.createContext(null);
if (process.env.NODE_ENV !== "production") {
  SelectFocusSourceContext.displayName = "SelectFocusSourceContext";
}
function useSelectFocusSource() {
  const context2 = reactExports.useContext(SelectFocusSourceContext);
  return context2;
}
const SelectFocusSourceProvider = SelectFocusSourceContext.Provider;
var _span$1;
const SelectSelect = styled(StyledSelectSelect, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [
      // Win specificity over the input base
      {
        [`&.${selectClasses.select}`]: styles2.select
      },
      {
        [`&.${selectClasses.select}`]: styles2[ownerState.variant]
      },
      {
        [`&.${selectClasses.error}`]: styles2.error
      },
      {
        [`&.${selectClasses.multiple}`]: styles2.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${selectClasses.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
});
const SelectIcon = styled(StyledSelectIcon, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.icon, ownerState.variant && styles2[`icon${capitalize$2(ownerState.variant)}`], ownerState.open && styles2.iconOpen];
  }
})({});
const SelectNativeInput = styled("input", {
  shouldForwardProp: (prop) => slotShouldForwardProp(prop) && prop !== "classes",
  name: "MuiSelect",
  slot: "NativeInput"
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
const useUtilityClasses$w = (ownerState) => {
  const {
    classes,
    variant,
    disabled,
    multiple,
    open: open2,
    error
  } = ownerState;
  const slots = {
    select: ["select", variant, disabled && "disabled", multiple && "multiple", error && "error"],
    icon: ["icon", `icon${capitalize$2(variant)}`, open2 && "iconOpen", disabled && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return composeClasses(slots, getSelectUtilityClasses, classes);
};
const SelectInput = /* @__PURE__ */ reactExports.forwardRef(function SelectInput2(props, ref2) {
  const {
    "aria-describedby": ariaDescribedby,
    "aria-label": ariaLabel,
    autoFocus,
    autoWidth,
    children,
    className,
    defaultOpen,
    defaultValue,
    disabled,
    displayEmpty,
    error = false,
    IconComponent,
    inputRef: inputRefProp,
    labelId,
    MenuProps = {},
    multiple,
    name,
    onBlur,
    onChange,
    onClose,
    onFocus,
    // eslint-disable-next-line react/prop-types
    onKeyDown,
    // eslint-disable-next-line react/prop-types
    onMouseDown,
    onOpen,
    open: openProp,
    readOnly,
    renderValue,
    required,
    SelectDisplayProps = {},
    tabIndex: tabIndexProp,
    // catching `type` from Input which makes no sense for SelectInput
    type,
    value: valueProp,
    variant = "standard",
    ...other
  } = props;
  const [value, setValueState] = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: "Select"
  });
  const [openState, setOpenState] = useControlled({
    controlled: openProp,
    default: defaultOpen,
    name: "Select"
  });
  const inputRef = reactExports.useRef(null);
  const displayRef = reactExports.useRef(null);
  const [displayNode, setDisplayNode] = reactExports.useState(null);
  const {
    current: isOpenControlled
  } = reactExports.useRef(openProp != null);
  const [menuMinWidthState, setMenuMinWidthState] = reactExports.useState();
  const [openInteractionType, setOpenInteractionType] = reactExports.useState(null);
  const handleRef = useForkRef(ref2, inputRefProp);
  const handleDisplayRef = reactExports.useCallback((node2) => {
    displayRef.current = node2;
    if (node2) {
      setDisplayNode(node2);
    }
  }, []);
  const anchorElement = displayNode?.parentNode;
  reactExports.useImperativeHandle(handleRef, () => ({
    focus: () => {
      displayRef.current.focus();
    },
    node: inputRef.current,
    value
  }), [value]);
  const open2 = displayNode !== null && openState;
  reactExports.useEffect(() => {
    if (!open2 || !anchorElement || autoWidth) {
      return void 0;
    }
    if (typeof ResizeObserver === "undefined") {
      return void 0;
    }
    const observer = new ResizeObserver(() => {
      setMenuMinWidthState(anchorElement.clientWidth);
    });
    observer.observe(anchorElement);
    return () => {
      observer.disconnect();
    };
  }, [open2, anchorElement, autoWidth]);
  reactExports.useEffect(() => {
    if (defaultOpen && openState && displayNode && !isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
      displayRef.current.focus();
    }
  }, [displayNode, autoWidth]);
  reactExports.useEffect(() => {
    if (autoFocus) {
      displayRef.current.focus();
    }
  }, [autoFocus]);
  reactExports.useEffect(() => {
    if (!labelId) {
      return void 0;
    }
    const label = ownerDocument(displayRef.current).getElementById(labelId);
    if (label) {
      const handler = () => {
        if (getSelection().isCollapsed) {
          displayRef.current.focus();
        }
      };
      label.addEventListener("click", handler);
      return () => {
        label.removeEventListener("click", handler);
      };
    }
    return void 0;
  }, [labelId]);
  const update = (openParam, event2) => {
    if (openParam) {
      setOpenInteractionType(getOpenInteractionType(event2));
      if (onOpen) {
        onOpen(event2);
      }
    } else {
      setOpenInteractionType(null);
      if (onClose) {
        onClose(event2);
      }
    }
    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
      setOpenState(openParam);
    }
  };
  const handleMouseDown = (event2) => {
    onMouseDown?.(event2);
    if (event2.button !== 0) {
      return;
    }
    event2.preventDefault();
    displayRef.current.focus();
    update(true, event2);
  };
  const handleClose = (event2) => {
    update(false, event2);
  };
  const childrenArray = reactExports.Children.toArray(children);
  const handleChange = (event2) => {
    const child = childrenArray.find((childItem) => childItem.props.value === event2.target.value);
    if (child === void 0) {
      return;
    }
    setValueState(child.props.value);
    if (onChange) {
      onChange(event2, child);
    }
  };
  const handleItemClick = (child) => (event2) => {
    let newValue;
    if (!event2.currentTarget.hasAttribute("tabindex")) {
      return;
    }
    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];
      const itemIndex = value.indexOf(child.props.value);
      if (itemIndex === -1) {
        newValue.push(child.props.value);
      } else {
        newValue.splice(itemIndex, 1);
      }
    } else {
      newValue = child.props.value;
    }
    if (child.props.onClick) {
      child.props.onClick(event2);
    }
    if (value !== newValue) {
      setValueState(newValue);
      if (onChange) {
        const nativeEvent = event2.nativeEvent || event2;
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, "target", {
          writable: true,
          value: {
            value: newValue,
            name
          }
        });
        onChange(clonedEvent, child);
      }
    }
    if (!multiple) {
      update(false, event2);
    }
  };
  const handleKeyDown = (event2) => {
    if (!readOnly) {
      const validKeys = [
        " ",
        "ArrowUp",
        "ArrowDown",
        // The native select doesn't respond to enter on macOS, but it's recommended by
        // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
        "Enter"
      ];
      if (validKeys.includes(event2.key)) {
        event2.preventDefault();
        update(true, event2);
      }
      onKeyDown?.(event2);
    }
  };
  const handleBlur = (event2) => {
    if (!open2 && onBlur) {
      Object.defineProperty(event2, "target", {
        writable: true,
        value: {
          value,
          name
        }
      });
      onBlur(event2);
    }
  };
  delete other["aria-invalid"];
  let display;
  let displaySingle;
  const displayMultiple = [];
  let computeDisplay = false;
  let foundMatch = false;
  if (isFilled({
    value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }
  const items = childrenArray.map((child) => {
    if (!/* @__PURE__ */ reactExports.isValidElement(child)) {
      return null;
    }
    if (process.env.NODE_ENV !== "production") {
      if (reactIsExports.isFragment(child)) {
        console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join("\n"));
      }
    }
    let selected;
    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : formatMuiErrorMessage(2));
      }
      selected = value.some((v) => areEqualValues(v, child.props.value));
      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);
      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }
    if (selected) {
      foundMatch = true;
    }
    return /* @__PURE__ */ reactExports.cloneElement(child, {
      "aria-selected": selected ? "true" : "false",
      onClick: handleItemClick(child),
      onKeyUp: (event2) => {
        if (event2.key === " ") {
          event2.preventDefault();
        }
        if (child.props.onKeyUp) {
          child.props.onKeyUp(event2);
        }
      },
      role: "option",
      selected,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": child.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  if (process.env.NODE_ENV !== "production") {
    reactExports.useEffect(() => {
      if (!foundMatch && !multiple && value !== "") {
        const values2 = childrenArray.map((child) => child.props.value);
        console.warn([`MUI: You have provided an out-of-range value \`${value}\` for the select ${name ? `(name="${name}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${values2.filter((x) => x != null).map((x) => `\`${x}\``).join(", ") || '""'}.`].join("\n"));
      }
    }, [foundMatch, childrenArray, multiple, name, value]);
  }
  if (computeDisplay) {
    if (multiple) {
      if (displayMultiple.length === 0) {
        display = null;
      } else {
        display = displayMultiple.reduce((output, child, index2) => {
          output.push(child);
          if (index2 < displayMultiple.length - 1) {
            output.push(", ");
          }
          return output;
        }, []);
      }
    } else {
      display = displaySingle;
    }
  }
  let menuMinWidth = menuMinWidthState;
  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = anchorElement.clientWidth;
  }
  let tabIndex;
  if (typeof tabIndexProp !== "undefined") {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }
  const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : void 0);
  const ownerState = {
    ...props,
    variant,
    value,
    open: open2,
    error
  };
  const classes = useUtilityClasses$w(ownerState);
  const paperProps = {
    ...MenuProps.PaperProps,
    ...typeof MenuProps.slotProps?.paper === "function" ? MenuProps.slotProps.paper(ownerState) : MenuProps.slotProps?.paper
  };
  const listProps = {
    ...MenuProps.MenuListProps,
    ...typeof MenuProps.slotProps?.list === "function" ? MenuProps.slotProps.list(ownerState) : MenuProps.slotProps?.list
  };
  const listboxId = useId();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SelectSelect, {
      as: "div",
      ref: handleDisplayRef,
      tabIndex,
      role: "combobox",
      "aria-controls": open2 ? listboxId : void 0,
      "aria-disabled": disabled ? "true" : void 0,
      "aria-expanded": open2 ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": ariaLabel,
      "aria-labelledby": [labelId, buttonId].filter(Boolean).join(" ") || void 0,
      "aria-describedby": ariaDescribedby,
      "aria-required": required ? "true" : void 0,
      "aria-invalid": error ? "true" : void 0,
      onKeyDown: handleKeyDown,
      onMouseDown: disabled || readOnly ? null : handleMouseDown,
      onBlur: handleBlur,
      onFocus,
      ...SelectDisplayProps,
      ownerState,
      className: clsx(SelectDisplayProps.className, classes.select, className),
      id: buttonId,
      children: isEmpty(display) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span$1 || (_span$1 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          "aria-hidden": true,
          children: "​"
        }))
      ) : display
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectNativeInput, {
      "aria-invalid": error,
      value: Array.isArray(value) ? value.join(",") : value,
      name,
      ref: inputRef,
      "aria-hidden": true,
      onChange: handleChange,
      tabIndex: -1,
      disabled,
      className: classes.nativeInput,
      autoFocus,
      required,
      ...other,
      ownerState
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectIcon, {
      as: IconComponent,
      className: classes.icon,
      ownerState
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectFocusSourceProvider, {
      value: openInteractionType,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Menu$1, {
        id: `menu-${name || ""}`,
        anchorEl: anchorElement,
        open: open2,
        onClose: handleClose,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        ...MenuProps,
        slotProps: {
          ...MenuProps.slotProps,
          list: {
            "aria-labelledby": labelId,
            role: "listbox",
            "aria-multiselectable": multiple ? "true" : void 0,
            disableListWrap: true,
            id: listboxId,
            ...listProps
          },
          paper: {
            ...paperProps,
            style: {
              minWidth: menuMinWidth,
              ...paperProps != null ? paperProps.style : null
            }
          }
        },
        children: items
      })
    })]
  });
});
process.env.NODE_ENV !== "production" ? SelectInput.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * @ignore
   */
  "aria-label": PropTypes.string,
  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * @ignore
   */
  readOnly: PropTypes.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * If `true`, the component is required.
   */
  required: PropTypes.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  type: PropTypes.any,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
} : void 0;
var _span;
const NotchedOutlineRoot$1 = styled("fieldset", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: rootShouldForwardProp
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
});
const NotchedOutlineLegend = styled("legend", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: rootShouldForwardProp
})(memoTheme(({
  theme
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState
    }) => !ownerState.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: theme.transitions.create("width", {
        duration: 150,
        easing: theme.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: theme.transitions.create("max-width", {
        duration: 50,
        easing: theme.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.withLabel && ownerState.notched,
    style: {
      maxWidth: "100%",
      transition: theme.transitions.create("max-width", {
        duration: 100,
        easing: theme.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function NotchedOutline(props) {
  const {
    children,
    classes,
    className,
    label,
    notched,
    ...other
  } = props;
  const withLabel = label != null && label !== "";
  const ownerState = {
    ...props,
    notched,
    withLabel
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineRoot$1, {
    "aria-hidden": true,
    className,
    ownerState,
    ...other,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineLegend, {
      ownerState,
      children: withLabel ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        children: label
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span || (_span = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          "aria-hidden": true,
          children: "​"
        }))
      )
    })
  });
}
process.env.NODE_ENV !== "production" ? NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The label.
   */
  label: PropTypes.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
const useUtilityClasses$v = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  };
  const composedClasses = composeClasses(slots, getOutlinedInputUtilityClass, classes);
  return {
    ...classes,
    // forward classes to the InputBase
    ...composedClasses
  };
};
const OutlinedInputRoot = styled(InputBaseRoot, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(memoTheme(({
  theme
}) => {
  const borderColor2 = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (theme.vars || theme).shape.borderRadius,
    [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor2
      }
    },
    [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color2]) => ({
      props: {
        color: color2
      },
      style: {
        [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: (theme.vars || theme).palette[color2].main
        }
      }
    })), {
      props: {},
      // to override the above style
      style: {
        [`&.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: (theme.vars || theme).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState,
        size
      }) => ownerState.multiline && size === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
}));
const NotchedOutlineRoot = styled(NotchedOutline, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline"
})(memoTheme(({
  theme
}) => {
  const borderColor2 = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor2
  };
}));
const OutlinedInputInput = styled(InputBaseInput, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(memoTheme(({
  theme
}) => ({
  padding: "16.5px 14px",
  ...!theme.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
      caretColor: theme.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...theme.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [theme.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
})));
const OutlinedInput = /* @__PURE__ */ reactExports.forwardRef(function OutlinedInput2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiOutlinedInput"
  });
  const {
    components = {},
    fullWidth = false,
    inputComponent = "input",
    label,
    multiline = false,
    notched,
    slots = {},
    slotProps = {},
    type = "text",
    ...other
  } = props;
  const classes = useUtilityClasses$v(props);
  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  });
  const ownerState = {
    ...props,
    color: fcs.color || "primary",
    disabled: fcs.disabled,
    error: fcs.error,
    focused: fcs.focused,
    formControl: muiFormControl,
    fullWidth,
    hiddenLabel: fcs.hiddenLabel,
    multiline,
    size: fcs.size,
    type
  };
  const RootSlot = slots.root ?? components.Root ?? OutlinedInputRoot;
  const InputSlot = slots.input ?? components.Input ?? OutlinedInputInput;
  const [NotchedSlot, notchedProps] = useSlot("notchedOutline", {
    elementType: NotchedOutlineRoot,
    className: classes.notchedOutline,
    shouldForwardComponentProp: true,
    ownerState,
    externalForwardedProps: {
      slots,
      slotProps
    },
    additionalProps: {
      label: label != null && label !== "" && fcs.required ? /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
        children: [label, " ", "*"]
      }) : label
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, {
    slots: {
      root: RootSlot,
      input: InputSlot
    },
    slotProps,
    renderSuffix: (state) => /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedSlot, {
      ...notchedProps,
      notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
    }),
    fullWidth,
    inputComponent,
    multiline,
    ref: ref2,
    type,
    ...other,
    classes: {
      ...classes,
      notchedOutline: null
    }
  });
});
process.env.NODE_ENV !== "production" ? OutlinedInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: PropTypes.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    notchedOutline: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    notchedOutline: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
OutlinedInput.muiName = "Input";
const useUtilityClasses$u = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  const composedClasses = composeClasses(slots, getSelectUtilityClasses, classes);
  return {
    ...classes,
    ...composedClasses
  };
};
const styledRootConfig = {
  name: "MuiSelect",
  slot: "Root",
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) && prop !== "variant"
};
const StyledInput = styled(Input, styledRootConfig)("");
const StyledOutlinedInput = styled(OutlinedInput, styledRootConfig)("");
const StyledFilledInput = styled(FilledInput, styledRootConfig)("");
const Select = /* @__PURE__ */ reactExports.forwardRef(function Select2(inProps, ref2) {
  const props = useDefaultProps({
    name: "MuiSelect",
    props: inProps
  });
  const {
    autoWidth = false,
    children,
    classes: classesProp = {},
    className,
    defaultOpen = false,
    displayEmpty = false,
    IconComponent = ArrowDropDownIcon$1,
    id,
    input,
    inputProps,
    label,
    labelId,
    MenuProps,
    multiple = false,
    native = false,
    onClose,
    onOpen,
    open: open2,
    renderValue,
    SelectDisplayProps,
    variant: variantProp = "outlined",
    ...other
  } = props;
  const inputComponent = native ? NativeSelectInput : SelectInput;
  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ["variant", "error"]
  });
  const variant = fcs.variant || variantProp;
  const ownerState = {
    ...props,
    variant,
    classes: classesProp
  };
  const classes = useUtilityClasses$u(ownerState);
  const {
    root: root2,
    ...restOfClasses
  } = classes;
  const InputComponent = input || {
    standard: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInput, {
      ownerState
    }),
    outlined: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOutlinedInput, {
      label,
      ownerState
    }),
    filled: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFilledInput, {
      ownerState
    })
  }[variant];
  const inputComponentRef = useForkRef(ref2, getReactElementRef(InputComponent));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(reactExports.Fragment, {
    children: /* @__PURE__ */ reactExports.cloneElement(InputComponent, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent,
      inputProps: {
        children,
        error: fcs.error,
        IconComponent,
        variant,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple,
        ...native ? {
          id
        } : {
          autoWidth,
          defaultOpen,
          displayEmpty,
          labelId,
          MenuProps,
          onClose,
          onOpen,
          open: open2,
          renderValue,
          SelectDisplayProps: {
            id,
            ...SelectDisplayProps
          }
        },
        ...inputProps,
        classes: inputProps ? deepmerge(restOfClasses, inputProps.classes) : restOfClasses,
        ...input ? input.props.inputProps : {}
      },
      ...(multiple && native || displayEmpty) && variant === "outlined" ? {
        notched: true
      } : {},
      ref: inputComponentRef,
      className: clsx(InputComponent.props.className, className, classes.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!input && {
        variant
      },
      ...other
    })
  });
});
process.env.NODE_ENV !== "production" ? Select.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: PropTypes.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: PropTypes.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: PropTypes.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.oneOfType([PropTypes.oneOf([""]), PropTypes.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
} : void 0;
Select.muiName = "Select";
function focusWithVisible(element, focusSource) {
  if (focusSource == null) {
    element.focus();
    return;
  }
  try {
    element.focus({
      focusVisible: focusSource === "keyboard"
    });
  } catch (error) {
    element.focus();
  }
}
const overridesResolver$1 = (props, styles2) => {
  const {
    ownerState
  } = props;
  return [styles2.root, ownerState.dense && styles2.dense, ownerState.divider && styles2.divider, !ownerState.disableGutters && styles2.gutters];
};
const useUtilityClasses$t = (ownerState) => {
  const {
    disabled,
    dense,
    divider: divider2,
    disableGutters,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ["root", dense && "dense", disabled && "disabled", !disableGutters && "gutters", divider2 && "divider", selected && "selected"]
  };
  const composedClasses = composeClasses(slots, getMenuItemUtilityClass, classes);
  return {
    ...classes,
    ...composedClasses
  };
};
const MenuItemRoot = styled(ButtonBase, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: overridesResolver$1
})(memoTheme(({
  theme
}) => ({
  ...theme.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${menuItemClasses.selected}`]: {
    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
    [`&.${menuItemClasses.focusVisible}`]: {
      backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
    }
  },
  [`&.${menuItemClasses.selected}:hover`]: {
    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
    }
  },
  [`&.${menuItemClasses.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${menuItemClasses.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  },
  [`& + .${dividerClasses.root}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  [`& + .${dividerClasses.inset}`]: {
    marginLeft: 52
  },
  [`& .${listItemTextClasses.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${listItemTextClasses.inset}`]: {
    paddingLeft: 36
  },
  [`& .${listItemIconClasses.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState
    }) => !ownerState.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.divider,
    style: {
      borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState
    }) => !ownerState.dense,
    style: {
      [theme.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.dense,
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...theme.typography.body2,
      [`& .${listItemIconClasses.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
})));
const MenuItem$1 = /* @__PURE__ */ reactExports.forwardRef(function MenuItem(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiMenuItem"
  });
  const {
    autoFocus = false,
    component = "li",
    dense = false,
    divider: divider2 = false,
    disableGutters = false,
    focusVisibleClassName,
    role = "menuitem",
    tabIndex: tabIndexProp,
    className,
    ...other
  } = props;
  const focusSource = useSelectFocusSource();
  const context2 = reactExports.useContext(ListContext);
  const childContext = reactExports.useMemo(() => ({
    dense: dense || context2.dense || false,
    disableGutters
  }), [context2.dense, dense, disableGutters]);
  const menuItemRef = reactExports.useRef(null);
  useEnhancedEffect(() => {
    if (autoFocus) {
      if (menuItemRef.current) {
        focusWithVisible(menuItemRef.current, focusSource);
      } else if (process.env.NODE_ENV !== "production") {
        console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered.");
      }
    }
  }, [autoFocus]);
  const ownerState = {
    ...props,
    dense: childContext.dense,
    divider: divider2,
    disableGutters
  };
  const classes = useUtilityClasses$t(props);
  const handleRef = useForkRef(menuItemRef, ref2);
  const {
    root: root2,
    ...forwardedClasses
  } = classes;
  let tabIndex;
  if (!props.disabled) {
    tabIndex = tabIndexProp !== void 0 ? tabIndexProp : -1;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: childContext,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItemRoot, {
      ref: handleRef,
      role,
      tabIndex,
      component,
      focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
      className: clsx(classes.root, className),
      ...other,
      ownerState,
      classes: forwardedClasses
    })
  });
});
process.env.NODE_ENV !== "production" ? MenuItem$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * @ignore
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  role: PropTypes.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number
} : void 0;
const radioClasses = generateUtilityClasses("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]);
const radioGroupClasses = generateUtilityClasses("MuiRadioGroup", ["root", "row", "error"]);
const visuallyHidden = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function getSkeletonUtilityClass(slot) {
  return generateUtilityClass("MuiSkeleton", slot);
}
generateUtilityClasses("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const useUtilityClasses$s = (ownerState) => {
  const {
    classes,
    variant,
    animation,
    hasChildren,
    width: width2,
    height: height2
  } = ownerState;
  const slots = {
    root: ["root", variant, animation, hasChildren && "withChildren", hasChildren && !width2 && "fitContent", hasChildren && !height2 && "heightAuto"]
  };
  return composeClasses(slots, getSkeletonUtilityClass, classes);
};
const pulseKeyframe = keyframes`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const waveKeyframe = keyframes`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
const pulseAnimation = typeof pulseKeyframe !== "string" ? css`
        animation: ${pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const waveAnimation = typeof waveKeyframe !== "string" ? css`
        &::after {
          animation: ${waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const SkeletonRoot = styled("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, styles2[ownerState.variant], ownerState.animation !== false && styles2[ownerState.animation], ownerState.hasChildren && styles2.withChildren, ownerState.hasChildren && !ownerState.width && styles2.fitContent, ownerState.hasChildren && !ownerState.height && styles2.heightAuto];
  }
})(memoTheme(({
  theme
}) => {
  const radiusUnit = getUnit(theme.shape.borderRadius) || "px";
  const radiusValue = toUnitless(theme.shape.borderRadius);
  return {
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : theme.alpha(theme.palette.text.primary, theme.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em",
    variants: [{
      props: {
        variant: "text"
      },
      style: {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        "&:empty:before": {
          content: '"\\00a0"'
        }
      }
    }, {
      props: {
        variant: "circular"
      },
      style: {
        borderRadius: "50%"
      }
    }, {
      props: {
        variant: "rounded"
      },
      style: {
        borderRadius: (theme.vars || theme).shape.borderRadius
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.hasChildren,
      style: {
        "& > *": {
          visibility: "hidden"
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.hasChildren && !ownerState.width,
      style: {
        maxWidth: "fit-content"
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.hasChildren && !ownerState.height,
      style: {
        height: "auto"
      }
    }, {
      props: {
        animation: "pulse"
      },
      style: pulseAnimation || {
        animation: `${pulseKeyframe} 2s ease-in-out 0.5s infinite`
      }
    }, {
      props: {
        animation: "wave"
      },
      style: {
        position: "relative",
        overflow: "hidden",
        /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
        WebkitMaskImage: "-webkit-radial-gradient(white, black)",
        "&::after": {
          background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
          content: '""',
          position: "absolute",
          transform: "translateX(-100%)",
          bottom: 0,
          left: 0,
          right: 0,
          top: 0
        }
      }
    }, {
      props: {
        animation: "wave"
      },
      style: waveAnimation || {
        "&::after": {
          animation: `${waveKeyframe} 2s linear 0.5s infinite`
        }
      }
    }]
  };
}));
const Skeleton = /* @__PURE__ */ reactExports.forwardRef(function Skeleton2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiSkeleton"
  });
  const {
    animation = "pulse",
    className,
    component = "span",
    height: height2,
    style: style2,
    variant = "text",
    width: width2,
    ...other
  } = props;
  const ownerState = {
    ...props,
    animation,
    component,
    variant,
    hasChildren: Boolean(other.children)
  };
  const classes = useUtilityClasses$s(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SkeletonRoot, {
    as: component,
    ref: ref2,
    className: clsx(classes.root, className),
    ownerState,
    ...other,
    style: {
      width: width2,
      height: height2,
      ...style2
    }
  });
});
process.env.NODE_ENV !== "production" ? Skeleton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: PropTypes.oneOf(["pulse", "wave", false]),
  /**
   * Optional children to infer width and height from.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["circular", "rectangular", "rounded", "text"]), PropTypes.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : void 0;
function getTooltipUtilityClass(slot) {
  return generateUtilityClass("MuiTooltip", slot);
}
const tooltipClasses = generateUtilityClasses("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]);
function round$1(value) {
  return Math.round(value * 1e5) / 1e5;
}
const useUtilityClasses$r = (ownerState) => {
  const {
    classes,
    disableInteractive,
    arrow: arrow2,
    touch,
    placement
  } = ownerState;
  const slots = {
    popper: ["popper", !disableInteractive && "popperInteractive", arrow2 && "popperArrow"],
    tooltip: ["tooltip", arrow2 && "tooltipArrow", touch && "touch", `tooltipPlacement${capitalize$2(placement.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return composeClasses(slots, getTooltipUtilityClass, classes);
};
const TooltipPopper = styled(Popper2, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.popper, !ownerState.disableInteractive && styles2.popperInteractive, ownerState.arrow && styles2.popperArrow, !ownerState.open && styles2.popperClose];
  }
})(memoTheme(({
  theme
}) => ({
  zIndex: (theme.vars || theme).zIndex.tooltip,
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState
    }) => !ownerState.disableInteractive,
    style: {
      pointerEvents: "auto"
    }
  }, {
    props: ({
      open: open2
    }) => !open2,
    style: {
      pointerEvents: "none"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.arrow,
    style: {
      [`&[data-popper-placement*="bottom"] .${tooltipClasses.arrow}`]: {
        top: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${tooltipClasses.arrow}`]: {
        bottom: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${tooltipClasses.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${tooltipClasses.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.arrow && !ownerState.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${tooltipClasses.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.arrow && !!ownerState.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${tooltipClasses.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.arrow && !ownerState.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${tooltipClasses.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.arrow && !!ownerState.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${tooltipClasses.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }]
})));
const TooltipTooltip = styled("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.tooltip, ownerState.touch && styles2.touch, ownerState.arrow && styles2.tooltipArrow, styles2[`tooltipPlacement${capitalize$2(ownerState.placement.split("-")[0])}`]];
  }
})(memoTheme(({
  theme
}) => ({
  backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.92),
  borderRadius: (theme.vars || theme).shape.borderRadius,
  color: (theme.vars || theme).palette.common.white,
  fontFamily: theme.typography.fontFamily,
  padding: "4px 8px",
  fontSize: theme.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: theme.typography.fontWeightMedium,
  [`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: {
    transformOrigin: "right center"
  },
  [`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: {
    transformOrigin: "left center"
  },
  [`.${tooltipClasses.popper}[data-popper-placement*="top"] &`]: {
    transformOrigin: "center bottom",
    marginBottom: "14px"
  },
  [`.${tooltipClasses.popper}[data-popper-placement*="bottom"] &`]: {
    transformOrigin: "center top",
    marginTop: "14px"
  },
  variants: [{
    props: ({
      ownerState
    }) => ownerState.arrow,
    style: {
      position: "relative",
      margin: 0
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.touch,
    style: {
      padding: "8px 16px",
      fontSize: theme.typography.pxToRem(14),
      lineHeight: `${round$1(16 / 14)}em`,
      fontWeight: theme.typography.fontWeightRegular
    }
  }, {
    props: ({
      ownerState
    }) => !ownerState.isRtl,
    style: {
      [`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "14px"
      },
      [`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "14px"
      }
    }
  }, {
    props: ({
      ownerState
    }) => !ownerState.isRtl && ownerState.touch,
    style: {
      [`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "24px"
      },
      [`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "24px"
      }
    }
  }, {
    props: ({
      ownerState
    }) => !!ownerState.isRtl,
    style: {
      [`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "14px"
      },
      [`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "14px"
      }
    }
  }, {
    props: ({
      ownerState
    }) => !!ownerState.isRtl && ownerState.touch,
    style: {
      [`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "24px"
      },
      [`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "24px"
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.touch,
    style: {
      [`.${tooltipClasses.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: "24px"
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.touch,
    style: {
      [`.${tooltipClasses.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: "24px"
      }
    }
  }]
})));
const TooltipArrow = styled("span", {
  name: "MuiTooltip",
  slot: "Arrow"
})(memoTheme(({
  theme
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
})));
let hystersisOpen = false;
const hystersisTimer = new Timeout();
let cursorPosition = {
  x: 0,
  y: 0
};
function composeEventHandler(handler, eventHandler) {
  return (event2, ...params) => {
    if (eventHandler) {
      eventHandler(event2, ...params);
    }
    handler(event2, ...params);
  };
}
const Tooltip$1 = /* @__PURE__ */ reactExports.forwardRef(function Tooltip(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiTooltip"
  });
  const {
    arrow: arrow2 = false,
    children: childrenProp,
    classes: classesProp,
    components = {},
    componentsProps = {},
    describeChild = false,
    disableFocusListener = false,
    disableHoverListener = false,
    disableInteractive: disableInteractiveProp = false,
    disableTouchListener = false,
    enterDelay = 100,
    enterNextDelay = 0,
    enterTouchDelay = 700,
    followCursor = false,
    id: idProp,
    leaveDelay = 0,
    leaveTouchDelay = 1500,
    onClose,
    onOpen,
    open: openProp,
    placement = "bottom",
    PopperComponent: PopperComponentProp,
    PopperProps = {},
    slotProps = {},
    slots = {},
    title,
    TransitionComponent: TransitionComponentProp,
    TransitionProps,
    ...other
  } = props;
  const children = /* @__PURE__ */ reactExports.isValidElement(childrenProp) ? childrenProp : /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    children: childrenProp
  });
  const theme = useTheme();
  const isRtl = useRtl();
  const [childNode, setChildNode] = reactExports.useState();
  const [arrowRef, setArrowRef] = reactExports.useState(null);
  const ignoreNonTouchEvents = reactExports.useRef(false);
  const disableInteractive = disableInteractiveProp || followCursor;
  const closeTimer = useTimeout();
  const enterTimer = useTimeout();
  const leaveTimer = useTimeout();
  const touchTimer = useTimeout();
  const [openState, setOpenState] = useControlled({
    controlled: openProp,
    default: false,
    name: "Tooltip",
    state: "open"
  });
  let open2 = openState;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: isControlled
    } = reactExports.useRef(openProp !== void 0);
    reactExports.useEffect(() => {
      if (childNode && childNode.disabled && !isControlled && title !== "" && childNode.tagName.toLowerCase() === "button") {
        console.warn(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join("\n"));
      }
    }, [title, childNode, isControlled]);
  }
  const id = useId(idProp);
  const prevUserSelect = reactExports.useRef();
  const stopTouchInteraction = useEventCallback(() => {
    if (prevUserSelect.current !== void 0) {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      prevUserSelect.current = void 0;
    }
    touchTimer.clear();
  });
  reactExports.useEffect(() => stopTouchInteraction, [stopTouchInteraction]);
  const handleOpen = (event2) => {
    hystersisTimer.clear();
    hystersisOpen = true;
    setOpenState(true);
    if (onOpen && !open2) {
      onOpen(event2);
    }
  };
  const handleClose = useEventCallback(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (event2) => {
      hystersisTimer.start(800 + leaveDelay, () => {
        hystersisOpen = false;
      });
      setOpenState(false);
      if (onClose && open2) {
        onClose(event2);
      }
      closeTimer.start(theme.transitions.duration.shortest, () => {
        ignoreNonTouchEvents.current = false;
      });
    }
  );
  const handleMouseOver = (event2) => {
    if (ignoreNonTouchEvents.current && event2.type !== "touchstart") {
      return;
    }
    if (childNode) {
      childNode.removeAttribute("title");
    }
    enterTimer.clear();
    leaveTimer.clear();
    if (enterDelay || hystersisOpen && enterNextDelay) {
      enterTimer.start(hystersisOpen ? enterNextDelay : enterDelay, () => {
        handleOpen(event2);
      });
    } else {
      handleOpen(event2);
    }
  };
  const handleMouseLeave = (event2) => {
    enterTimer.clear();
    leaveTimer.start(leaveDelay, () => {
      handleClose(event2);
    });
  };
  const [, setChildIsFocusVisible] = reactExports.useState(false);
  const handleBlur = (event2) => {
    const target = event2?.target ?? childNode;
    if (!target || !isFocusVisible(target)) {
      setChildIsFocusVisible(false);
      const closeEvent = event2 ?? new Event("blur");
      if (!event2 && target) {
        Object.defineProperty(closeEvent, "target", {
          value: target
        });
        Object.defineProperty(closeEvent, "currentTarget", {
          value: target
        });
      }
      handleMouseLeave(closeEvent);
    }
  };
  const handleFocus = (event2) => {
    if (!childNode) {
      setChildNode(event2.currentTarget);
    }
    if (isFocusVisible(event2.target)) {
      setChildIsFocusVisible(true);
      handleMouseOver(event2);
    }
  };
  const detectTouchStart = (event2) => {
    ignoreNonTouchEvents.current = true;
    const childrenProps2 = children.props;
    if (childrenProps2.onTouchStart) {
      childrenProps2.onTouchStart(event2);
    }
  };
  const handleTouchStart = (event2) => {
    detectTouchStart(event2);
    leaveTimer.clear();
    closeTimer.clear();
    stopTouchInteraction();
    prevUserSelect.current = document.body.style.WebkitUserSelect;
    document.body.style.WebkitUserSelect = "none";
    touchTimer.start(enterTouchDelay, () => {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      handleMouseOver(event2);
    });
  };
  const handleTouchEnd = (event2) => {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event2);
    }
    stopTouchInteraction();
    leaveTimer.start(leaveTouchDelay, () => {
      handleClose(event2);
    });
  };
  reactExports.useEffect(() => {
    if (!open2) {
      return void 0;
    }
    function handleKeyDown(nativeEvent) {
      if (nativeEvent.key === "Escape") {
        handleClose(nativeEvent);
      }
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleClose, open2]);
  const handleRef = useForkRef(getReactElementRef(children), setChildNode, ref2);
  if (!title && title !== 0) {
    open2 = false;
  }
  const popperRef = reactExports.useRef();
  const handleMouseMove = (event2) => {
    const childrenProps2 = children.props;
    if (childrenProps2.onMouseMove) {
      childrenProps2.onMouseMove(event2);
    }
    cursorPosition = {
      x: event2.clientX,
      y: event2.clientY
    };
    if (popperRef.current) {
      popperRef.current.update();
    }
  };
  const nameOrDescProps = {};
  const titleIsString = typeof title === "string";
  if (describeChild) {
    nameOrDescProps.title = !open2 && titleIsString && !disableHoverListener ? title : null;
    nameOrDescProps["aria-describedby"] = open2 ? id : null;
  } else {
    nameOrDescProps["aria-label"] = titleIsString ? title : null;
    nameOrDescProps["aria-labelledby"] = open2 && !titleIsString ? id : null;
  }
  const childrenProps = {
    ...nameOrDescProps,
    ...other,
    ...children.props,
    className: clsx(other.className, children.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef,
    ...followCursor ? {
      onMouseMove: handleMouseMove
    } : {}
  };
  if (process.env.NODE_ENV !== "production") {
    childrenProps["data-mui-internal-clone-element"] = true;
    reactExports.useEffect(() => {
      if (childNode && !childNode.getAttribute("data-mui-internal-clone-element")) {
        console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join("\n"));
      }
    }, [childNode]);
  }
  const interactiveWrapperListeners = {};
  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }
  if (!disableHoverListener) {
    childrenProps.onMouseOver = composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
    childrenProps.onMouseLeave = composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
    if (!disableInteractive) {
      interactiveWrapperListeners.onMouseOver = handleMouseOver;
      interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
    }
  }
  if (!disableFocusListener) {
    childrenProps.onFocus = composeEventHandler(handleFocus, childrenProps.onFocus);
    childrenProps.onBlur = composeEventHandler(handleBlur, childrenProps.onBlur);
    if (!disableInteractive) {
      interactiveWrapperListeners.onFocus = handleFocus;
      interactiveWrapperListeners.onBlur = handleBlur;
    }
  }
  if (process.env.NODE_ENV !== "production") {
    if (children.props.title) {
      console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${children.props.title}\` or the Tooltip component.`].join("\n"));
    }
  }
  const ownerState = {
    ...props,
    isRtl,
    arrow: arrow2,
    disableInteractive,
    placement,
    PopperComponentProp,
    touch: ignoreNonTouchEvents.current
  };
  const resolvedPopperProps = typeof slotProps.popper === "function" ? slotProps.popper(ownerState) : slotProps.popper;
  const popperOptions = reactExports.useMemo(() => {
    let tooltipModifiers = [{
      name: "arrow",
      enabled: Boolean(arrowRef),
      options: {
        element: arrowRef,
        padding: 4
      }
    }];
    if (PopperProps.popperOptions?.modifiers) {
      tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
    }
    if (resolvedPopperProps?.popperOptions?.modifiers) {
      tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
    }
    return {
      ...PopperProps.popperOptions,
      ...resolvedPopperProps?.popperOptions,
      modifiers: tooltipModifiers
    };
  }, [arrowRef, PopperProps.popperOptions, resolvedPopperProps?.popperOptions]);
  const classes = useUtilityClasses$r(ownerState);
  const resolvedTransitionProps = typeof slotProps.transition === "function" ? slotProps.transition(ownerState) : slotProps.transition;
  const externalForwardedProps = {
    slots: {
      popper: components.Popper,
      transition: components.Transition ?? TransitionComponentProp,
      tooltip: components.Tooltip,
      arrow: components.Arrow,
      ...slots
    },
    slotProps: {
      arrow: slotProps.arrow ?? componentsProps.arrow,
      popper: {
        ...PopperProps,
        ...resolvedPopperProps ?? componentsProps.popper
      },
      // resolvedPopperProps can be spread because it's already an object
      tooltip: slotProps.tooltip ?? componentsProps.tooltip,
      transition: {
        ...TransitionProps,
        ...resolvedTransitionProps ?? componentsProps.transition
      }
    }
  };
  const [PopperSlot, popperSlotProps] = useSlot("popper", {
    elementType: TooltipPopper,
    externalForwardedProps,
    ownerState,
    className: clsx(classes.popper, PopperProps?.className)
  });
  const [TransitionSlot, transitionSlotProps] = useSlot("transition", {
    elementType: Grow,
    externalForwardedProps,
    ownerState
  });
  const [TooltipSlot, tooltipSlotProps] = useSlot("tooltip", {
    elementType: TooltipTooltip,
    className: classes.tooltip,
    externalForwardedProps,
    ownerState
  });
  const [ArrowSlot, arrowSlotProps] = useSlot("arrow", {
    elementType: TooltipArrow,
    className: classes.arrow,
    externalForwardedProps,
    ownerState,
    ref: setArrowRef
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
    children: [/* @__PURE__ */ reactExports.cloneElement(children, childrenProps), /* @__PURE__ */ jsxRuntimeExports.jsx(PopperSlot, {
      as: PopperComponentProp ?? Popper2,
      placement,
      anchorEl: followCursor ? {
        getBoundingClientRect: () => ({
          top: cursorPosition.y,
          left: cursorPosition.x,
          right: cursorPosition.x,
          bottom: cursorPosition.y,
          width: 0,
          height: 0
        })
      } : childNode,
      popperRef,
      open: childNode ? open2 : false,
      id,
      transition: true,
      ...interactiveWrapperListeners,
      ...popperSlotProps,
      popperOptions,
      children: ({
        TransitionProps: TransitionPropsInner
      }) => /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionSlot, {
        timeout: theme.transitions.duration.shorter,
        ...TransitionPropsInner,
        ...transitionSlotProps,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(TooltipSlot, {
          ...tooltipSlotProps,
          children: [title, arrow2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowSlot, {
            ...arrowSlotProps
          }) : null]
        })
      })
    })]
  });
});
process.env.NODE_ENV !== "production" ? Tooltip$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: PropTypes.bool,
  /**
   * Tooltip reference element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Arrow: PropTypes.elementType,
    Popper: PropTypes.elementType,
    Tooltip: PropTypes.elementType,
    Transition: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    arrow: PropTypes.object,
    popper: PropTypes.object,
    tooltip: PropTypes.object,
    transition: PropTypes.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: PropTypes.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: PropTypes.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: PropTypes.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: PropTypes.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: PropTypes.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: PropTypes.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: PropTypes.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: PropTypes.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: PropTypes.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: PropTypes.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PopperProps: PropTypes.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    arrow: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    popper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    tooltip: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    arrow: PropTypes.elementType,
    popper: PropTypes.elementType,
    tooltip: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: PropTypes.node,
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: PropTypes.object
} : void 0;
function getSwitchUtilityClass(slot) {
  return generateUtilityClass("MuiSwitch", slot);
}
const switchClasses = generateUtilityClasses("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]);
const useUtilityClasses$q = (ownerState) => {
  const {
    classes,
    edge,
    size,
    color: color2,
    checked: checked2,
    disabled
  } = ownerState;
  const slots = {
    root: ["root", edge && `edge${capitalize$2(edge)}`, `size${capitalize$2(size)}`],
    switchBase: ["switchBase", `color${capitalize$2(color2)}`, checked2 && "checked", disabled && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  };
  const composedClasses = composeClasses(slots, getSwitchUtilityClass, classes);
  return {
    ...classes,
    // forward the disabled and checked classes to the SwitchBase
    ...composedClasses
  };
};
const SwitchRoot = styled("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.edge && styles2[`edge${capitalize$2(ownerState.edge)}`], styles2[`size${capitalize$2(ownerState.size)}`]];
  }
})({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [{
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${switchClasses.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${switchClasses.switchBase}`]: {
        padding: 4,
        [`&.${switchClasses.checked}`]: {
          transform: "translateX(16px)"
        }
      }
    }
  }]
});
const SwitchSwitchBase = styled(SwitchBase, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.switchBase, {
      [`& .${switchClasses.input}`]: styles2.input
    }, ownerState.color !== "default" && styles2[`color${capitalize$2(ownerState.color)}`]];
  }
})(memoTheme(({
  theme
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
  transition: theme.transitions.create(["left", "transform"], {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${switchClasses.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${switchClasses.disabled}`]: {
    color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}`
  },
  [`&.${switchClasses.checked} + .${switchClasses.track}`]: {
    opacity: 0.5
  },
  [`&.${switchClasses.disabled} + .${switchClasses.track}`]: {
    opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${switchClasses.input}`]: {
    left: "-100%",
    width: "300%"
  }
})), memoTheme(({
  theme
}) => ({
  "&:hover": {
    backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["light"])).map(([color2]) => ({
    props: {
      color: color2
    },
    style: {
      [`&.${switchClasses.checked}`]: {
        color: (theme.vars || theme).palette[color2].main,
        "&:hover": {
          backgroundColor: theme.alpha((theme.vars || theme).palette[color2].main, (theme.vars || theme).palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${switchClasses.disabled}`]: {
          color: theme.vars ? theme.vars.palette.Switch[`${color2}DisabledColor`] : `${theme.palette.mode === "light" ? theme.lighten(theme.palette[color2].main, 0.62) : theme.darken(theme.palette[color2].main, 0.55)}`
        }
      },
      [`&.${switchClasses.checked} + .${switchClasses.track}`]: {
        backgroundColor: (theme.vars || theme).palette[color2].main
      }
    }
  }))]
})));
const SwitchTrack = styled("span", {
  name: "MuiSwitch",
  slot: "Track"
})(memoTheme(({
  theme
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  boxSizing: "border-box",
  border: "1px solid transparent",
  zIndex: -1,
  transition: theme.transitions.create(["opacity", "background-color"], {
    duration: theme.transitions.duration.shortest
  }),
  backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
  opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? 0.38 : 0.3}`
})));
const SwitchThumb = styled("span", {
  name: "MuiSwitch",
  slot: "Thumb"
})(memoTheme(({
  theme
}) => ({
  boxShadow: (theme.vars || theme).shadows[1],
  backgroundColor: "currentColor",
  boxSizing: "border-box",
  border: "1px solid transparent",
  width: 20,
  height: 20,
  borderRadius: "50%"
})));
const Switch = /* @__PURE__ */ reactExports.forwardRef(function Switch2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiSwitch"
  });
  const {
    className,
    color: color2 = "primary",
    edge = false,
    size = "medium",
    sx: sx2,
    slots = {},
    slotProps = {},
    ...other
  } = props;
  const ownerState = {
    ...props,
    color: color2,
    edge,
    size
  };
  const classes = useUtilityClasses$q(ownerState);
  const externalInputProps = slotProps.input;
  const externalForwardedProps = {
    slots,
    slotProps
  };
  const [RootSlot, rootSlotProps] = useSlot("root", {
    className: clsx(classes.root, className),
    elementType: SwitchRoot,
    externalForwardedProps,
    ownerState,
    additionalProps: {
      sx: sx2
    }
  });
  const [ThumbSlot, thumbSlotProps] = useSlot("thumb", {
    className: classes.thumb,
    elementType: SwitchThumb,
    externalForwardedProps,
    ownerState
  });
  const icon = /* @__PURE__ */ jsxRuntimeExports.jsx(ThumbSlot, {
    ...thumbSlotProps
  });
  const [TrackSlot, trackSlotProps] = useSlot("track", {
    className: classes.track,
    elementType: SwitchTrack,
    externalForwardedProps,
    ownerState
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(RootSlot, {
    ...rootSlotProps,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SwitchSwitchBase, {
      type: "checkbox",
      icon,
      checkedIcon: icon,
      ref: ref2,
      ownerState,
      ...other,
      classes: {
        ...classes,
        root: classes.switchBase
      },
      slots: {
        ...slots.switchBase && {
          root: slots.switchBase
        },
        ...slots.input && {
          input: slots.input
        }
      },
      slotProps: {
        ...slotProps.switchBase && {
          root: typeof slotProps.switchBase === "function" ? slotProps.switchBase(ownerState) : slotProps.switchBase
        },
        input: mergeSlotProps$2(typeof externalInputProps === "function" ? externalInputProps(ownerState) : externalInputProps, {
          role: "switch"
        })
      }
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(TrackSlot, {
      ...trackSlotProps
    })]
  });
});
process.env.NODE_ENV !== "production" ? Switch.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", false]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   * @deprecated Use `slotProps.input.ref` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputRef: refType,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    switchBase: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    thumb: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    track: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType,
    switchBase: PropTypes.elementType,
    thumb: PropTypes.elementType,
    track: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
} : void 0;
function getTabUtilityClass(slot) {
  return generateUtilityClass("MuiTab", slot);
}
const tabClasses = generateUtilityClasses("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper", "icon"]);
const useUtilityClasses$p = (ownerState) => {
  const {
    classes,
    textColor,
    fullWidth,
    wrapped,
    icon,
    label,
    selected,
    disabled
  } = ownerState;
  const slots = {
    root: ["root", icon && label && "labelIcon", `textColor${capitalize$2(textColor)}`, fullWidth && "fullWidth", wrapped && "wrapped", selected && "selected", disabled && "disabled"],
    icon: ["iconWrapper", "icon"]
  };
  return composeClasses(slots, getTabUtilityClass, classes);
};
const TabRoot = styled(ButtonBase, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.label && ownerState.icon && styles2.labelIcon, styles2[`textColor${capitalize$2(ownerState.textColor)}`], ownerState.fullWidth && styles2.fullWidth, ownerState.wrapped && styles2.wrapped, {
      [`& .${tabClasses.iconWrapper}`]: styles2.iconWrapper
    }, {
      [`& .${tabClasses.icon}`]: styles2.icon
    }];
  }
})(memoTheme(({
  theme
}) => ({
  ...theme.typography.button,
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center",
  lineHeight: 1.25,
  variants: [{
    props: ({
      ownerState
    }) => ownerState.label && (ownerState.iconPosition === "top" || ownerState.iconPosition === "bottom"),
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.label && ownerState.iconPosition !== "top" && ownerState.iconPosition !== "bottom",
    style: {
      flexDirection: "row"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.icon && ownerState.label,
    style: {
      minHeight: 72,
      paddingTop: 9,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState,
      iconPosition
    }) => ownerState.icon && ownerState.label && iconPosition === "top",
    style: {
      [`& > .${tabClasses.icon}`]: {
        marginBottom: 6
      }
    }
  }, {
    props: ({
      ownerState,
      iconPosition
    }) => ownerState.icon && ownerState.label && iconPosition === "bottom",
    style: {
      [`& > .${tabClasses.icon}`]: {
        marginTop: 6
      }
    }
  }, {
    props: ({
      ownerState,
      iconPosition
    }) => ownerState.icon && ownerState.label && iconPosition === "start",
    style: {
      [`& > .${tabClasses.icon}`]: {
        marginRight: theme.spacing(1)
      }
    }
  }, {
    props: ({
      ownerState,
      iconPosition
    }) => ownerState.icon && ownerState.label && iconPosition === "end",
    style: {
      [`& > .${tabClasses.icon}`]: {
        marginLeft: theme.spacing(1)
      }
    }
  }, {
    props: {
      textColor: "inherit"
    },
    style: {
      color: "inherit",
      opacity: 0.6,
      // same opacity as theme.palette.text.secondary
      [`&.${tabClasses.selected}`]: {
        opacity: 1
      },
      [`&.${tabClasses.disabled}`]: {
        opacity: (theme.vars || theme).palette.action.disabledOpacity
      }
    }
  }, {
    props: {
      textColor: "primary"
    },
    style: {
      color: (theme.vars || theme).palette.text.secondary,
      [`&.${tabClasses.selected}`]: {
        color: (theme.vars || theme).palette.primary.main
      },
      [`&.${tabClasses.disabled}`]: {
        color: (theme.vars || theme).palette.text.disabled
      }
    }
  }, {
    props: {
      textColor: "secondary"
    },
    style: {
      color: (theme.vars || theme).palette.text.secondary,
      [`&.${tabClasses.selected}`]: {
        color: (theme.vars || theme).palette.secondary.main
      },
      [`&.${tabClasses.disabled}`]: {
        color: (theme.vars || theme).palette.text.disabled
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.fullWidth,
    style: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: "none"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.wrapped,
    style: {
      fontSize: theme.typography.pxToRem(12)
    }
  }]
})));
const Tab$1 = /* @__PURE__ */ reactExports.forwardRef(function Tab(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiTab"
  });
  const {
    className,
    disabled = false,
    disableFocusRipple = false,
    // eslint-disable-next-line react/prop-types
    fullWidth,
    icon: iconProp,
    iconPosition = "top",
    // eslint-disable-next-line react/prop-types
    indicator,
    label,
    onChange,
    onClick,
    onFocus,
    // eslint-disable-next-line react/prop-types
    selected,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus,
    // eslint-disable-next-line react/prop-types
    textColor = "inherit",
    value,
    wrapped = false,
    ...other
  } = props;
  const ownerState = {
    ...props,
    disabled,
    disableFocusRipple,
    selected,
    icon: !!iconProp,
    iconPosition,
    label: !!label,
    fullWidth,
    textColor,
    wrapped
  };
  const classes = useUtilityClasses$p(ownerState);
  const icon = iconProp && label && /* @__PURE__ */ reactExports.isValidElement(iconProp) ? /* @__PURE__ */ reactExports.cloneElement(iconProp, {
    className: clsx(classes.icon, iconProp.props.className)
  }) : iconProp;
  const handleClick = (event2) => {
    if (!selected && onChange) {
      onChange(event2, value);
    }
    if (onClick) {
      onClick(event2);
    }
  };
  const handleFocus = (event2) => {
    if (selectionFollowsFocus && !selected && onChange) {
      onChange(event2, value);
    }
    if (onFocus) {
      onFocus(event2);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TabRoot, {
    focusRipple: !disableFocusRipple,
    className: clsx(classes.root, className),
    ref: ref2,
    role: "tab",
    "aria-selected": selected,
    disabled,
    onClick: handleClick,
    onFocus: handleFocus,
    ownerState,
    tabIndex: selected ? 0 : -1,
    ...other,
    children: [iconPosition === "top" || iconPosition === "start" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
      children: [icon, label]
    }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
      children: [label, icon]
    }), indicator]
  });
});
process.env.NODE_ENV !== "production" ? Tab$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * The icon to display.
   */
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: PropTypes.oneOf(["bottom", "end", "start", "top"]),
  /**
   * The label element.
   */
  label: PropTypes.node,
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: PropTypes.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: PropTypes.bool
} : void 0;
const KeyboardArrowLeft = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");
const KeyboardArrowRight = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
function easeInOutSin(time2) {
  return (1 + Math.sin(Math.PI * time2 - Math.PI / 2)) / 2;
}
function animate(property2, element, to2, options = {}, cb2 = () => {
}) {
  const {
    ease = easeInOutSin,
    duration: duration2 = 300
    // standard
  } = options;
  let start2 = null;
  const from2 = element[property2];
  let cancelled = false;
  const cancel = () => {
    cancelled = true;
  };
  const step = (timestamp) => {
    if (cancelled) {
      cb2(new Error("Animation cancelled"));
      return;
    }
    if (start2 === null) {
      start2 = timestamp;
    }
    const time2 = Math.min(1, (timestamp - start2) / duration2);
    element[property2] = ease(time2) * (to2 - from2) + from2;
    if (time2 >= 1) {
      requestAnimationFrame(() => {
        cb2(null);
      });
      return;
    }
    requestAnimationFrame(step);
  };
  if (from2 === to2) {
    cb2(new Error("Element already at target position"));
    return cancel;
  }
  requestAnimationFrame(step);
  return cancel;
}
const styles = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function ScrollbarSize(props) {
  const {
    onChange,
    ...other
  } = props;
  const scrollbarHeight = reactExports.useRef();
  const nodeRef = reactExports.useRef(null);
  const setMeasurements = () => {
    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
  };
  useEnhancedEffect(() => {
    const handleResize = debounce$2(() => {
      const prevHeight = scrollbarHeight.current;
      setMeasurements();
      if (prevHeight !== scrollbarHeight.current) {
        onChange(scrollbarHeight.current);
      }
    });
    const containerWindow = ownerWindow(nodeRef.current);
    containerWindow.addEventListener("resize", handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener("resize", handleResize);
    };
  }, [onChange]);
  reactExports.useEffect(() => {
    setMeasurements();
    onChange(scrollbarHeight.current);
  }, [onChange]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    style: styles,
    ...other,
    ref: nodeRef
  });
}
process.env.NODE_ENV !== "production" ? ScrollbarSize.propTypes = {
  onChange: PropTypes.func.isRequired
} : void 0;
function getTabScrollButtonUtilityClass(slot) {
  return generateUtilityClass("MuiTabScrollButton", slot);
}
const tabScrollButtonClasses = generateUtilityClasses("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]);
const useUtilityClasses$o = (ownerState) => {
  const {
    classes,
    orientation,
    disabled
  } = ownerState;
  const slots = {
    root: ["root", orientation, disabled && "disabled"]
  };
  return composeClasses(slots, getTabScrollButtonUtilityClass, classes);
};
const TabScrollButtonRoot = styled(ButtonBase, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.orientation && styles2[ownerState.orientation]];
  }
})({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${tabScrollButtonClasses.disabled}`]: {
    opacity: 0
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      width: "100%",
      height: 40,
      "& svg": {
        transform: "var(--TabScrollButton-svgRotate)"
      }
    }
  }]
});
const TabScrollButton = /* @__PURE__ */ reactExports.forwardRef(function TabScrollButton2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiTabScrollButton"
  });
  const {
    className,
    slots = {},
    slotProps = {},
    direction,
    orientation,
    disabled,
    ...other
  } = props;
  const isRtl = useRtl();
  const ownerState = {
    isRtl,
    ...props
  };
  const classes = useUtilityClasses$o(ownerState);
  const StartButtonIcon = slots.StartScrollButtonIcon ?? KeyboardArrowLeft;
  const EndButtonIcon = slots.EndScrollButtonIcon ?? KeyboardArrowRight;
  const startButtonIconProps = useSlotProps({
    elementType: StartButtonIcon,
    externalSlotProps: slotProps.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState
  });
  const endButtonIconProps = useSlotProps({
    elementType: EndButtonIcon,
    externalSlotProps: slotProps.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TabScrollButtonRoot, {
    component: "div",
    className: clsx(classes.root, className),
    ref: ref2,
    role: null,
    ownerState,
    tabIndex: null,
    ...other,
    style: {
      ...other.style,
      ...orientation === "vertical" && {
        "--TabScrollButton-svgRotate": `rotate(${isRtl ? -90 : 90}deg)`
      }
    },
    children: direction === "left" ? /* @__PURE__ */ jsxRuntimeExports.jsx(StartButtonIcon, {
      ...startButtonIconProps
    }) : /* @__PURE__ */ jsxRuntimeExports.jsx(EndButtonIcon, {
      ...endButtonIconProps
    })
  });
});
process.env.NODE_ENV !== "production" ? TabScrollButton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The direction the button should indicate.
   */
  direction: PropTypes.oneOf(["left", "right"]).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: PropTypes.shape({
    endScrollButtonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    startScrollButtonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    EndScrollButtonIcon: PropTypes.elementType,
    StartScrollButtonIcon: PropTypes.elementType
  }),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getTabsUtilityClass(slot) {
  return generateUtilityClass("MuiTabs", slot);
}
const tabsClasses = generateUtilityClasses("MuiTabs", ["root", "vertical", "list", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]);
const nextItem = (list2, item) => {
  if (list2 === item) {
    return list2.firstChild;
  }
  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }
  return list2.firstChild;
};
const previousItem = (list2, item) => {
  if (list2 === item) {
    return list2.lastChild;
  }
  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }
  return list2.lastChild;
};
const moveFocus = (list2, currentFocus, traversalFunction) => {
  let wrappedOnce = false;
  let nextFocus = traversalFunction(list2, currentFocus);
  while (nextFocus) {
    if (nextFocus === list2.firstChild) {
      if (wrappedOnce) {
        return;
      }
      wrappedOnce = true;
    }
    const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
    if (!nextFocus.hasAttribute("tabindex") || nextFocusDisabled) {
      nextFocus = traversalFunction(list2, nextFocus);
    } else {
      nextFocus.focus();
      return;
    }
  }
};
const useUtilityClasses$n = (ownerState) => {
  const {
    vertical,
    fixed,
    hideScrollbar,
    scrollableX,
    scrollableY,
    centered,
    scrollButtonsHideMobile,
    classes
  } = ownerState;
  const slots = {
    root: ["root", vertical && "vertical"],
    scroller: ["scroller", fixed && "fixed", hideScrollbar && "hideScrollbar", scrollableX && "scrollableX", scrollableY && "scrollableY"],
    list: ["list", "flexContainer", vertical && "flexContainerVertical", vertical && "vertical", centered && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", scrollButtonsHideMobile && "scrollButtonsHideMobile"],
    scrollableX: [scrollableX && "scrollableX"],
    hideScrollbar: [hideScrollbar && "hideScrollbar"]
  };
  return composeClasses(slots, getTabsUtilityClass, classes);
};
const TabsRoot = styled("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${tabsClasses.scrollButtons}`]: styles2.scrollButtons
    }, {
      [`& .${tabsClasses.scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles2.scrollButtonsHideMobile
    }, styles2.root, ownerState.vertical && styles2.vertical];
  }
})(memoTheme(({
  theme
}) => ({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex",
  variants: [{
    props: ({
      ownerState
    }) => ownerState.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.scrollButtonsHideMobile,
    style: {
      [`& .${tabsClasses.scrollButtons}`]: {
        [theme.breakpoints.down("sm")]: {
          display: "none"
        }
      }
    }
  }]
})));
const TabsScroller = styled("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.scroller, ownerState.fixed && styles2.fixed, ownerState.hideScrollbar && styles2.hideScrollbar, ownerState.scrollableX && styles2.scrollableX, ownerState.scrollableY && styles2.scrollableY];
  }
})({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap",
  variants: [{
    props: ({
      ownerState
    }) => ownerState.fixed,
    style: {
      overflowX: "hidden",
      width: "100%"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.hideScrollbar,
    style: {
      // Hide dimensionless scrollbar on macOS
      scrollbarWidth: "none",
      // Firefox
      "&::-webkit-scrollbar": {
        display: "none"
        // Safari + Chrome
      }
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.scrollableX,
    style: {
      overflowX: "auto",
      overflowY: "hidden"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.scrollableY,
    style: {
      overflowY: "auto",
      overflowX: "hidden"
    }
  }]
});
const List2 = styled("div", {
  name: "MuiTabs",
  slot: "List",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.list, styles2.flexContainer, ownerState.vertical && styles2.flexContainerVertical, ownerState.centered && styles2.centered];
  }
})({
  display: "flex",
  variants: [{
    props: ({
      ownerState
    }) => ownerState.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.centered,
    style: {
      justifyContent: "center"
    }
  }]
});
const TabsIndicator = styled("span", {
  name: "MuiTabs",
  slot: "Indicator"
})(memoTheme(({
  theme
}) => ({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: theme.transitions.create(),
  variants: [{
    props: {
      indicatorColor: "primary"
    },
    style: {
      backgroundColor: (theme.vars || theme).palette.primary.main
    }
  }, {
    props: {
      indicatorColor: "secondary"
    },
    style: {
      backgroundColor: (theme.vars || theme).palette.secondary.main
    }
  }, {
    props: ({
      ownerState
    }) => ownerState.vertical,
    style: {
      height: "100%",
      width: 2,
      right: 0
    }
  }]
})));
const TabsScrollbarSize = styled(ScrollbarSize)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
});
const defaultIndicatorStyle = {};
let warnedOnceTabPresent = false;
const Tabs = /* @__PURE__ */ reactExports.forwardRef(function Tabs2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiTabs"
  });
  const theme = useTheme();
  const isRtl = useRtl();
  const {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    action,
    centered = false,
    children: childrenProp,
    className,
    component = "div",
    allowScrollButtonsMobile = false,
    indicatorColor = "primary",
    onChange,
    orientation = "horizontal",
    ScrollButtonComponent,
    // TODO: remove in v7 (deprecated in v6)
    scrollButtons = "auto",
    selectionFollowsFocus,
    slots = {},
    slotProps = {},
    TabIndicatorProps = {},
    // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps = {},
    // TODO: remove in v7 (deprecated in v6)
    textColor = "primary",
    value,
    variant = "standard",
    visibleScrollbar = false,
    ...other
  } = props;
  const scrollable = variant === "scrollable";
  const vertical = orientation === "vertical";
  const scrollStart = vertical ? "scrollTop" : "scrollLeft";
  const start2 = vertical ? "top" : "left";
  const end2 = vertical ? "bottom" : "right";
  const clientSize = vertical ? "clientHeight" : "clientWidth";
  const size = vertical ? "height" : "width";
  const ownerState = {
    ...props,
    component,
    allowScrollButtonsMobile,
    indicatorColor,
    orientation,
    vertical,
    scrollButtons,
    textColor,
    variant,
    visibleScrollbar,
    fixed: !scrollable,
    hideScrollbar: scrollable && !visibleScrollbar,
    scrollableX: scrollable && !vertical,
    scrollableY: scrollable && vertical,
    centered: centered && !scrollable,
    scrollButtonsHideMobile: !allowScrollButtonsMobile
  };
  const classes = useUtilityClasses$n(ownerState);
  const startScrollButtonIconProps = useSlotProps({
    elementType: slots.StartScrollButtonIcon,
    externalSlotProps: slotProps.startScrollButtonIcon,
    ownerState
  });
  const endScrollButtonIconProps = useSlotProps({
    elementType: slots.EndScrollButtonIcon,
    externalSlotProps: slotProps.endScrollButtonIcon,
    ownerState
  });
  if (process.env.NODE_ENV !== "production") {
    if (centered && scrollable) {
      console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
    }
  }
  const [mounted, setMounted] = reactExports.useState(false);
  const [indicatorStyle, setIndicatorStyle] = reactExports.useState(defaultIndicatorStyle);
  const [displayStartScroll, setDisplayStartScroll] = reactExports.useState(false);
  const [displayEndScroll, setDisplayEndScroll] = reactExports.useState(false);
  const [updateScrollObserver, setUpdateScrollObserver] = reactExports.useState(false);
  const [scrollerStyle, setScrollerStyle] = reactExports.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  });
  const valueToIndex = /* @__PURE__ */ new Map();
  const tabsRef = reactExports.useRef(null);
  const tabListRef = reactExports.useRef(null);
  const externalForwardedProps = {
    slots,
    slotProps: {
      indicator: TabIndicatorProps,
      scrollButtons: TabScrollButtonProps,
      ...slotProps
    }
  };
  const getTabsMeta = () => {
    const tabsNode = tabsRef.current;
    let tabsMeta;
    if (tabsNode) {
      const rect = tabsNode.getBoundingClientRect();
      tabsMeta = {
        clientWidth: tabsNode.clientWidth,
        scrollLeft: tabsNode.scrollLeft,
        scrollTop: tabsNode.scrollTop,
        scrollWidth: tabsNode.scrollWidth,
        top: rect.top,
        bottom: rect.bottom,
        left: rect.left,
        right: rect.right
      };
    }
    let tabMeta;
    if (tabsNode && value !== false) {
      const children2 = tabListRef.current.children;
      if (children2.length > 0) {
        const tab2 = children2[valueToIndex.get(value)];
        if (process.env.NODE_ENV !== "production") {
          if (!tab2) {
            console.error([`MUI: The \`value\` provided to the Tabs component is invalid.`, `None of the Tabs' children match with "${value}".`, valueToIndex.keys ? `You can provide one of the following values: ${Array.from(valueToIndex.keys()).join(", ")}.` : null].join("\n"));
          }
        }
        tabMeta = tab2 ? tab2.getBoundingClientRect() : null;
        if (process.env.NODE_ENV !== "production") {
          if (isLayoutSupported() && !warnedOnceTabPresent && tabMeta && tabMeta.width === 0 && tabMeta.height === 0 && // if the whole Tabs component is hidden, don't warn
          tabsMeta.clientWidth !== 0) {
            tabsMeta = null;
            console.error(["MUI: The `value` provided to the Tabs component is invalid.", `The Tab with this \`value\` ("${value}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join("\n"));
            warnedOnceTabPresent = true;
          }
        }
      }
    }
    return {
      tabsMeta,
      tabMeta
    };
  };
  const updateIndicatorState = useEventCallback(() => {
    const {
      tabsMeta,
      tabMeta
    } = getTabsMeta();
    let startValue = 0;
    let startIndicator;
    if (vertical) {
      startIndicator = "top";
      if (tabMeta && tabsMeta) {
        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
      }
    } else {
      startIndicator = isRtl ? "right" : "left";
      if (tabMeta && tabsMeta) {
        startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
      }
    }
    const newIndicatorStyle = {
      [startIndicator]: startValue,
      // May be wrong until the font is loaded.
      [size]: tabMeta ? tabMeta[size] : 0
    };
    if (typeof indicatorStyle[startIndicator] !== "number" || typeof indicatorStyle[size] !== "number") {
      setIndicatorStyle(newIndicatorStyle);
    } else {
      const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
      const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
      if (dStart >= 1 || dSize >= 1) {
        setIndicatorStyle(newIndicatorStyle);
      }
    }
  });
  const scroll = (scrollValue, {
    animation = true
  } = {}) => {
    if (animation) {
      animate(scrollStart, tabsRef.current, scrollValue, {
        duration: theme.transitions.duration.standard
      });
    } else {
      tabsRef.current[scrollStart] = scrollValue;
    }
  };
  const moveTabsScroll = (delta) => {
    let scrollValue = tabsRef.current[scrollStart];
    if (vertical) {
      scrollValue += delta;
    } else {
      scrollValue += delta * (isRtl ? -1 : 1);
    }
    scroll(scrollValue);
  };
  const getScrollSize = () => {
    const containerSize = tabsRef.current[clientSize];
    let totalSize = 0;
    const children2 = Array.from(tabListRef.current.children);
    for (let i = 0; i < children2.length; i += 1) {
      const tab2 = children2[i];
      if (totalSize + tab2[clientSize] > containerSize) {
        if (i === 0) {
          totalSize = containerSize;
        }
        break;
      }
      totalSize += tab2[clientSize];
    }
    return totalSize;
  };
  const handleStartScrollClick = () => {
    moveTabsScroll(-1 * getScrollSize());
  };
  const handleEndScrollClick = () => {
    moveTabsScroll(getScrollSize());
  };
  const [ScrollbarSlot, {
    onChange: scrollbarOnChange,
    ...scrollbarSlotProps
  }] = useSlot("scrollbar", {
    className: clsx(classes.scrollableX, classes.hideScrollbar),
    elementType: TabsScrollbarSize,
    shouldForwardComponentProp: true,
    externalForwardedProps,
    ownerState
  });
  const handleScrollbarSizeChange = reactExports.useCallback((scrollbarWidth) => {
    scrollbarOnChange?.(scrollbarWidth);
    setScrollerStyle({
      overflow: null,
      scrollbarWidth
    });
  }, [scrollbarOnChange]);
  const [ScrollButtonsSlot, scrollButtonSlotProps] = useSlot("scrollButtons", {
    className: clsx(classes.scrollButtons, TabScrollButtonProps.className),
    elementType: TabScrollButton,
    externalForwardedProps,
    ownerState,
    additionalProps: {
      orientation,
      slots: {
        StartScrollButtonIcon: slots.startScrollButtonIcon || slots.StartScrollButtonIcon,
        EndScrollButtonIcon: slots.endScrollButtonIcon || slots.EndScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: startScrollButtonIconProps,
        endScrollButtonIcon: endScrollButtonIconProps
      }
    }
  });
  const getConditionalElements = () => {
    const conditionalElements2 = {};
    conditionalElements2.scrollbarSizeListener = scrollable ? /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollbarSlot, {
      ...scrollbarSlotProps,
      onChange: handleScrollbarSizeChange
    }) : null;
    const scrollButtonsActive = displayStartScroll || displayEndScroll;
    const showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === true);
    conditionalElements2.scrollButtonStart = showScrollButtons ? /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollButtonsSlot, {
      direction: isRtl ? "right" : "left",
      onClick: handleStartScrollClick,
      disabled: !displayStartScroll,
      ...scrollButtonSlotProps
    }) : null;
    conditionalElements2.scrollButtonEnd = showScrollButtons ? /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollButtonsSlot, {
      direction: isRtl ? "left" : "right",
      onClick: handleEndScrollClick,
      disabled: !displayEndScroll,
      ...scrollButtonSlotProps
    }) : null;
    return conditionalElements2;
  };
  const scrollSelectedIntoView = useEventCallback((animation) => {
    const {
      tabsMeta,
      tabMeta
    } = getTabsMeta();
    if (!tabMeta || !tabsMeta) {
      return;
    }
    if (tabMeta[start2] < tabsMeta[start2]) {
      const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start2] - tabsMeta[start2]);
      scroll(nextScrollStart, {
        animation
      });
    } else if (tabMeta[end2] > tabsMeta[end2]) {
      const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end2] - tabsMeta[end2]);
      scroll(nextScrollStart, {
        animation
      });
    }
  });
  const updateScrollButtonState = useEventCallback(() => {
    if (scrollable && scrollButtons !== false) {
      setUpdateScrollObserver(!updateScrollObserver);
    }
  });
  reactExports.useEffect(() => {
    const handleResize = debounce$2(() => {
      if (tabsRef.current) {
        updateIndicatorState();
      }
    });
    let resizeObserver;
    const handleMutation = (records) => {
      records.forEach((record) => {
        record.removedNodes.forEach((item) => {
          resizeObserver?.unobserve(item);
        });
        record.addedNodes.forEach((item) => {
          resizeObserver?.observe(item);
        });
      });
      handleResize();
      updateScrollButtonState();
    };
    const win = ownerWindow(tabsRef.current);
    win.addEventListener("resize", handleResize);
    let mutationObserver;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(handleResize);
      Array.from(tabListRef.current.children).forEach((child) => {
        resizeObserver.observe(child);
      });
    }
    if (typeof MutationObserver !== "undefined") {
      mutationObserver = new MutationObserver(handleMutation);
      mutationObserver.observe(tabListRef.current, {
        childList: true
      });
    }
    return () => {
      handleResize.clear();
      win.removeEventListener("resize", handleResize);
      mutationObserver?.disconnect();
      resizeObserver?.disconnect();
    };
  }, [updateIndicatorState, updateScrollButtonState]);
  reactExports.useEffect(() => {
    const tabListChildren = Array.from(tabListRef.current.children);
    const length2 = tabListChildren.length;
    if (typeof IntersectionObserver !== "undefined" && length2 > 0 && scrollable && scrollButtons !== false) {
      const firstTab = tabListChildren[0];
      const lastTab = tabListChildren[length2 - 1];
      const observerOptions = {
        root: tabsRef.current,
        threshold: 0.99
      };
      const handleScrollButtonStart = (entries2) => {
        setDisplayStartScroll(!entries2[0].isIntersecting);
      };
      const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
      firstObserver.observe(firstTab);
      const handleScrollButtonEnd = (entries2) => {
        setDisplayEndScroll(!entries2[0].isIntersecting);
      };
      const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
      lastObserver.observe(lastTab);
      return () => {
        firstObserver.disconnect();
        lastObserver.disconnect();
      };
    }
    return void 0;
  }, [scrollable, scrollButtons, updateScrollObserver, childrenProp?.length]);
  reactExports.useEffect(() => {
    setMounted(true);
  }, []);
  reactExports.useEffect(() => {
    updateIndicatorState();
  });
  reactExports.useEffect(() => {
    scrollSelectedIntoView(defaultIndicatorStyle !== indicatorStyle);
  }, [scrollSelectedIntoView, indicatorStyle]);
  reactExports.useImperativeHandle(action, () => ({
    updateIndicator: updateIndicatorState,
    updateScrollButtons: updateScrollButtonState
  }), [updateIndicatorState, updateScrollButtonState]);
  const [IndicatorSlot, indicatorSlotProps] = useSlot("indicator", {
    className: clsx(classes.indicator, TabIndicatorProps.className),
    elementType: TabsIndicator,
    externalForwardedProps,
    ownerState,
    additionalProps: {
      style: indicatorStyle
    }
  });
  const indicator = /* @__PURE__ */ jsxRuntimeExports.jsx(IndicatorSlot, {
    ...indicatorSlotProps
  });
  let childIndex = 0;
  const children = reactExports.Children.map(childrenProp, (child) => {
    if (!/* @__PURE__ */ reactExports.isValidElement(child)) {
      return null;
    }
    if (process.env.NODE_ENV !== "production") {
      if (reactIsExports.isFragment(child)) {
        console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join("\n"));
      }
    }
    const childValue = child.props.value === void 0 ? childIndex : child.props.value;
    valueToIndex.set(childValue, childIndex);
    const selected = childValue === value;
    childIndex += 1;
    return /* @__PURE__ */ reactExports.cloneElement(child, {
      fullWidth: variant === "fullWidth",
      indicator: selected && !mounted && indicator,
      selected,
      selectionFollowsFocus,
      onChange,
      textColor,
      value: childValue,
      ...childIndex === 1 && value === false && !child.props.tabIndex ? {
        tabIndex: 0
      } : {}
    });
  });
  const handleKeyDown = (event2) => {
    if (event2.altKey || event2.shiftKey || event2.ctrlKey || event2.metaKey) {
      return;
    }
    const list2 = tabListRef.current;
    const currentFocus = activeElement(ownerDocument(list2));
    const role = currentFocus?.getAttribute("role");
    if (role !== "tab") {
      return;
    }
    let previousItemKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
    let nextItemKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
    if (orientation === "horizontal" && isRtl) {
      previousItemKey = "ArrowRight";
      nextItemKey = "ArrowLeft";
    }
    switch (event2.key) {
      case previousItemKey:
        event2.preventDefault();
        moveFocus(list2, currentFocus, previousItem);
        break;
      case nextItemKey:
        event2.preventDefault();
        moveFocus(list2, currentFocus, nextItem);
        break;
      case "Home":
        event2.preventDefault();
        moveFocus(list2, null, nextItem);
        break;
      case "End":
        event2.preventDefault();
        moveFocus(list2, null, previousItem);
        break;
    }
  };
  const conditionalElements = getConditionalElements();
  const [RootSlot, rootSlotProps] = useSlot("root", {
    ref: ref2,
    className: clsx(classes.root, className),
    elementType: TabsRoot,
    externalForwardedProps: {
      ...externalForwardedProps,
      ...other,
      component
    },
    ownerState
  });
  const [ScrollerSlot, scrollerSlotProps] = useSlot("scroller", {
    ref: tabsRef,
    className: classes.scroller,
    elementType: TabsScroller,
    externalForwardedProps,
    ownerState,
    additionalProps: {
      style: {
        overflow: scrollerStyle.overflow,
        [vertical ? `margin${isRtl ? "Left" : "Right"}` : "marginBottom"]: visibleScrollbar ? void 0 : -scrollerStyle.scrollbarWidth
      }
    }
  });
  const [ListSlot, listSlotProps] = useSlot("list", {
    ref: tabListRef,
    className: clsx(classes.list, classes.flexContainer),
    elementType: List2,
    externalForwardedProps,
    ownerState,
    getSlotProps: (handlers) => ({
      ...handlers,
      onKeyDown: (event2) => {
        handleKeyDown(event2);
        handlers.onKeyDown?.(event2);
      }
    })
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(RootSlot, {
    ...rootSlotProps,
    children: [conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /* @__PURE__ */ jsxRuntimeExports.jsxs(ScrollerSlot, {
      ...scrollerSlotProps,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ListSlot, {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-orientation": orientation === "vertical" ? "vertical" : null,
        role: "tablist",
        ...listSlotProps,
        children
      }), mounted && indicator]
    }), conditionalElements.scrollButtonEnd]
  });
});
process.env.NODE_ENV !== "production" ? Tabs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: refType,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: PropTypes.bool,
  /**
   * The label for the Tabs as a string.
   */
  "aria-label": PropTypes.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  "aria-labelledby": PropTypes.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: PropTypes.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * The component used to render the scroll buttons.
   * @deprecated use the `slots.scrollButtons` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default TabScrollButton
   */
  ScrollButtonComponent: PropTypes.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: PropTypes.oneOf(["auto", false, true]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    endScrollButtonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    indicator: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    list: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    scrollbar: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    scrollButtons: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    scroller: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    startScrollButtonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    endScrollButtonIcon: PropTypes.elementType,
    EndScrollButtonIcon: PropTypes.elementType,
    indicator: PropTypes.elementType,
    list: PropTypes.elementType,
    root: PropTypes.elementType,
    scrollbar: PropTypes.elementType,
    scrollButtons: PropTypes.elementType,
    scroller: PropTypes.elementType,
    startScrollButtonIcon: PropTypes.elementType,
    StartScrollButtonIcon: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Props applied to the tab indicator element.
   * @deprecated use the `slotProps.indicator` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default  {}
   */
  TabIndicatorProps: PropTypes.object,
  /**
   * Props applied to the [`TabScrollButton`](https://mui.com/material-ui/api/tab-scroll-button/) element.
   * @deprecated use the `slotProps.scrollButtons` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TabScrollButtonProps: PropTypes.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: PropTypes.oneOf(["inherit", "primary", "secondary"]),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: PropTypes.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: PropTypes.oneOf(["fullWidth", "scrollable", "standard"]),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: PropTypes.bool
} : void 0;
function getTextFieldUtilityClass(slot) {
  return generateUtilityClass("MuiTextField", slot);
}
generateUtilityClasses("MuiTextField", ["root"]);
const variantComponent = {
  standard: Input,
  filled: FilledInput,
  outlined: OutlinedInput
};
const useUtilityClasses$m = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getTextFieldUtilityClass, classes);
};
const TextFieldRoot = styled(FormControl, {
  name: "MuiTextField",
  slot: "Root"
})({});
const TextField = /* @__PURE__ */ reactExports.forwardRef(function TextField2(inProps, ref2) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiTextField"
  });
  const {
    autoComplete,
    autoFocus = false,
    children,
    className,
    color: color2 = "primary",
    defaultValue,
    disabled = false,
    error = false,
    FormHelperTextProps: FormHelperTextPropsProp,
    fullWidth = false,
    helperText,
    id: idOverride,
    InputLabelProps: InputLabelPropsProp,
    inputProps: inputPropsProp,
    InputProps: InputPropsProp,
    inputRef,
    label,
    maxRows,
    minRows,
    multiline = false,
    name,
    onBlur,
    onChange,
    onFocus,
    placeholder,
    required = false,
    rows,
    select: select2 = false,
    SelectProps: SelectPropsProp,
    slots = {},
    slotProps = {},
    type,
    value,
    variant = "outlined",
    ...other
  } = props;
  const ownerState = {
    ...props,
    autoFocus,
    color: color2,
    disabled,
    error,
    fullWidth,
    multiline,
    required,
    select: select2,
    variant
  };
  const classes = useUtilityClasses$m(ownerState);
  if (process.env.NODE_ENV !== "production") {
    if (select2 && !children) {
      console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
    }
  }
  const id = useId(idOverride);
  const helperTextId = helperText && id ? `${id}-helper-text` : void 0;
  const inputLabelId = label && id ? `${id}-label` : void 0;
  const InputComponent = variantComponent[variant];
  const externalForwardedProps = {
    slots,
    slotProps: {
      input: InputPropsProp,
      inputLabel: InputLabelPropsProp,
      htmlInput: inputPropsProp,
      formHelperText: FormHelperTextPropsProp,
      select: SelectPropsProp,
      ...slotProps
    }
  };
  const inputAdditionalProps = {};
  const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
  if (variant === "outlined") {
    if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== "undefined") {
      inputAdditionalProps.notched = inputLabelSlotProps.shrink;
    }
    inputAdditionalProps.label = label;
  }
  if (select2) {
    if (!SelectPropsProp || !SelectPropsProp.native) {
      inputAdditionalProps.id = void 0;
    }
    inputAdditionalProps["aria-describedby"] = void 0;
  }
  const [RootSlot, rootProps] = useSlot("root", {
    elementType: TextFieldRoot,
    shouldForwardComponentProp: true,
    externalForwardedProps: {
      ...externalForwardedProps,
      ...other
    },
    ownerState,
    className: clsx(classes.root, className),
    ref: ref2,
    additionalProps: {
      disabled,
      error,
      fullWidth,
      required,
      color: color2,
      variant
    }
  });
  const [InputSlot, inputProps] = useSlot("input", {
    elementType: InputComponent,
    externalForwardedProps,
    additionalProps: inputAdditionalProps,
    ownerState
  });
  const [InputLabelSlot, inputLabelProps] = useSlot("inputLabel", {
    elementType: InputLabel,
    externalForwardedProps,
    ownerState
  });
  const [HtmlInputSlot, htmlInputProps] = useSlot("htmlInput", {
    elementType: "input",
    externalForwardedProps,
    ownerState
  });
  const [FormHelperTextSlot, formHelperTextProps] = useSlot("formHelperText", {
    elementType: FormHelperText,
    externalForwardedProps,
    ownerState
  });
  const [SelectSlot, selectProps] = useSlot("select", {
    elementType: Select,
    externalForwardedProps,
    ownerState
  });
  const InputElement = /* @__PURE__ */ jsxRuntimeExports.jsx(InputSlot, {
    "aria-describedby": helperTextId,
    autoComplete,
    autoFocus,
    defaultValue,
    fullWidth,
    multiline,
    name,
    rows,
    maxRows,
    minRows,
    type,
    value,
    id,
    inputRef,
    onBlur,
    onChange,
    onFocus,
    placeholder,
    inputProps: htmlInputProps,
    slots: {
      input: slots.htmlInput ? HtmlInputSlot : void 0
    },
    ...inputProps
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(RootSlot, {
    ...rootProps,
    children: [label != null && label !== "" && /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabelSlot, {
      htmlFor: id,
      id: inputLabelId,
      ...inputLabelProps,
      children: label
    }), select2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(SelectSlot, {
      "aria-describedby": helperTextId,
      id,
      labelId: inputLabelId,
      value,
      input: InputElement,
      ...selectProps,
      children
    }) : InputElement, helperText && /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperTextSlot, {
      id: helperTextId,
      ...formHelperTextProps,
      children: helperText
    })]
  });
});
process.env.NODE_ENV !== "production" ? TextField.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: PropTypes.bool,
  /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SelectProps: PropTypes.object,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    formHelperText: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    htmlInput: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    inputLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    select: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    formHelperText: PropTypes.elementType,
    htmlInput: PropTypes.elementType,
    input: PropTypes.elementType,
    inputLabel: PropTypes.elementType,
    root: PropTypes.elementType,
    select: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
} : void 0;
const useMediaQuery = unstable_createUseMediaQuery({
  themeId: THEME_ID
});
const major = Number("7");
const Add = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add");
const Check = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
const Close = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
const ExpandLess = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess");
const ExpandMore = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
const NavigateNext = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");
const objectFromEntries = !Object.fromEntries ? (entries2) => {
  if (!entries2 || !entries2[Symbol.iterator]) {
    throw new Error("Object.fromEntries() requires a single iterable argument");
  }
  const o = {};
  Object.keys(entries2).forEach((key) => {
    const [k, v] = entries2[key];
    o[k] = v;
  });
  return o;
} : Object.fromEntries;
function objectKeys(o) {
  return Object.keys(o);
}
function assert(condition, msg) {
  if (!condition) {
    throw new Error(msg);
  }
}
function typeGuard(_value, isMatched) {
  return isMatched;
}
const classnames = (args) => {
  const len = args.length;
  let i = 0;
  let cls = "";
  for (; i < len; i++) {
    const arg2 = args[i];
    if (arg2 == null)
      continue;
    let toAdd;
    switch (typeof arg2) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(arg2)) {
          toAdd = classnames(arg2);
        } else {
          assert(!typeGuard(arg2, false));
          if (process.env.NODE_ENV !== "production" && arg2.styles !== void 0 && arg2.name !== void 0) {
            console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.");
          }
          toAdd = "";
          for (const k in arg2) {
            if (arg2[k] && k) {
              toAdd && (toAdd += " ");
              toAdd += k;
            }
          }
        }
        break;
      }
      default: {
        toAdd = arg2;
      }
    }
    if (toAdd) {
      cls && (cls += " ");
      cls += toAdd;
    }
  }
  return cls;
};
function useGuaranteedMemo(fn3, deps) {
  var _a2;
  const ref2 = reactExports.useRef();
  if (!ref2.current || deps.length !== ((_a2 = ref2.current.prevDeps) === null || _a2 === void 0 ? void 0 : _a2.length) || ref2.current.prevDeps.map((v, i) => v === deps[i]).indexOf(false) >= 0) {
    ref2.current = {
      "v": fn3(),
      "prevDeps": [...deps]
    };
  }
  return ref2.current.v;
}
function matchCSSObject(arg2) {
  return arg2 instanceof Object && !("styles" in arg2) && !("length" in arg2) && !("__emotion_styles" in arg2);
}
const { createCssAndCx } = /* @__PURE__ */ (() => {
  function merge2(registered, css2, className) {
    const registeredStyles = [];
    const rawClassName = getRegisteredStyles(registered, registeredStyles, className);
    if (registeredStyles.length < 2) {
      return className;
    }
    return rawClassName + css2(registeredStyles);
  }
  function createCssAndCx2(params) {
    const { cache: cache2 } = params;
    const css2 = (...args) => {
      const serialized = serializeStyles(args, cache2.registered);
      insertStyles(cache2, serialized, false);
      const className = `${cache2.key}-${serialized.name}`;
      scope: {
        const arg2 = args[0];
        if (!matchCSSObject(arg2)) {
          break scope;
        }
        increaseSpecificityToTakePrecedenceOverMediaQueries.saveClassNameCSSObjectMapping(cache2, className, arg2);
      }
      return className;
    };
    const cx2 = (...args) => {
      const className = classnames(args);
      const feat27FixedClassnames = increaseSpecificityToTakePrecedenceOverMediaQueries.fixClassName(cache2, className, css2);
      return merge2(cache2.registered, css2, feat27FixedClassnames);
    };
    return { css: css2, cx: cx2 };
  }
  return { createCssAndCx: createCssAndCx2 };
})();
function createUseCssAndCx(params) {
  const { useCache } = params;
  function useCssAndCx() {
    const cache2 = useCache();
    const { css: css2, cx: cx2 } = useGuaranteedMemo(() => createCssAndCx({ cache: cache2 }), [cache2]);
    return { css: css2, cx: cx2 };
  }
  return { useCssAndCx };
}
const increaseSpecificityToTakePrecedenceOverMediaQueries = /* @__PURE__ */ (() => {
  const cssObjectMapByCache = /* @__PURE__ */ new WeakMap();
  return {
    "saveClassNameCSSObjectMapping": (cache2, className, cssObject) => {
      let cssObjectMap = cssObjectMapByCache.get(cache2);
      if (cssObjectMap === void 0) {
        cssObjectMap = /* @__PURE__ */ new Map();
        cssObjectMapByCache.set(cache2, cssObjectMap);
      }
      cssObjectMap.set(className, cssObject);
    },
    "fixClassName": /* @__PURE__ */ (() => {
      function fix(classNameCSSObjects) {
        let isThereAnyMediaQueriesInPreviousClasses = false;
        return classNameCSSObjects.map(([className, cssObject]) => {
          if (cssObject === void 0) {
            return className;
          }
          let out;
          if (!isThereAnyMediaQueriesInPreviousClasses) {
            out = className;
            for (const key in cssObject) {
              if (key.startsWith("@media")) {
                isThereAnyMediaQueriesInPreviousClasses = true;
                break;
              }
            }
          } else {
            out = {
              "&&": cssObject
            };
          }
          return out;
        });
      }
      return (cache2, className, css2) => {
        const cssObjectMap = cssObjectMapByCache.get(cache2);
        return classnames(fix(className.split(" ").map((className2) => [
          className2,
          cssObjectMap === null || cssObjectMap === void 0 ? void 0 : cssObjectMap.get(className2)
        ])).map((classNameOrCSSObject) => typeof classNameOrCSSObject === "string" ? classNameOrCSSObject : css2(classNameOrCSSObject)));
      };
    })()
  };
})();
function getDependencyArrayRef(obj) {
  if (!(obj instanceof Object) || typeof obj === "function") {
    return obj;
  }
  const arr = [];
  for (const key in obj) {
    const value = obj[key];
    const typeofValue = typeof value;
    if (!(typeofValue === "string" || typeofValue === "number" && !isNaN(value) || typeofValue === "boolean" || value === void 0 || value === null)) {
      return obj;
    }
    arr.push(`${key}:${typeofValue}_${value}`);
  }
  return "xSqLiJdLMd9s" + arr.join("|");
}
function mergeClasses(classesFromUseStyles, classesOverrides, cx2) {
  if (!(classesOverrides instanceof Object)) {
    return classesFromUseStyles;
  }
  const out = {};
  objectKeys(classesFromUseStyles).forEach((ruleName) => out[ruleName] = cx2(classesFromUseStyles[ruleName], classesOverrides[ruleName]));
  objectKeys(classesOverrides).forEach((ruleName) => {
    if (ruleName in classesFromUseStyles) {
      return;
    }
    const className = classesOverrides[ruleName];
    if (typeof className !== "string") {
      return;
    }
    out[ruleName] = className;
  });
  return out;
}
const useMuiThemeStyleOverridesPlugin = ({ classes, theme, muiStyleOverridesParams, css: css2, cx: cx2, name }) => {
  var _a2, _b2;
  require_named: {
    if (name === "makeStyle no name") {
      name = void 0;
      break require_named;
    }
    if (muiStyleOverridesParams !== void 0 && name === void 0) {
      throw new Error("To use muiStyleOverridesParams, you must specify a name using .withName('MyComponent')");
    }
  }
  let styleOverrides = void 0;
  try {
    styleOverrides = name === void 0 ? void 0 : ((_b2 = (_a2 = theme.components) === null || _a2 === void 0 ? void 0 : _a2[
      name
      /*example*/
    ]) === null || _b2 === void 0 ? void 0 : _b2.styleOverrides) || void 0;
  } catch (_c2) {
  }
  const classesFromThemeStyleOverrides = reactExports.useMemo(() => {
    if (styleOverrides === void 0) {
      return void 0;
    }
    const themeClasses = {};
    for (const ruleName in styleOverrides) {
      const cssObjectOrGetCssObject = styleOverrides[ruleName];
      if (!(cssObjectOrGetCssObject instanceof Object)) {
        continue;
      }
      themeClasses[ruleName] = css2(typeof cssObjectOrGetCssObject === "function" ? cssObjectOrGetCssObject({
        theme,
        "ownerState": muiStyleOverridesParams === null || muiStyleOverridesParams === void 0 ? void 0 : muiStyleOverridesParams.ownerState,
        ...muiStyleOverridesParams === null || muiStyleOverridesParams === void 0 ? void 0 : muiStyleOverridesParams.props
      }) : cssObjectOrGetCssObject);
    }
    return themeClasses;
  }, [
    styleOverrides,
    getDependencyArrayRef(muiStyleOverridesParams === null || muiStyleOverridesParams === void 0 ? void 0 : muiStyleOverridesParams.props),
    getDependencyArrayRef(muiStyleOverridesParams === null || muiStyleOverridesParams === void 0 ? void 0 : muiStyleOverridesParams.ownerState),
    css2
  ]);
  classes = reactExports.useMemo(() => mergeClasses(classes, classesFromThemeStyleOverrides, cx2), [classes, classesFromThemeStyleOverrides, cx2]);
  return { classes };
};
const useContextualCache = __unsafe_useEmotionCache;
let counter$1 = 0;
function createMakeStyles(params) {
  const { useTheme: useTheme2, cache: cacheProvidedAtInception } = params;
  const { useCache } = createUseCache({ cacheProvidedAtInception });
  const { useCssAndCx } = createUseCssAndCx({ useCache });
  function makeStyles2(params2) {
    const { name: nameOrWrappedName, uniqId = `${counter$1++}` } = params2 !== null && params2 !== void 0 ? params2 : {};
    const name = typeof nameOrWrappedName !== "object" ? nameOrWrappedName : Object.keys(nameOrWrappedName)[0];
    return function(cssObjectByRuleNameOrGetCssObjectByRuleName) {
      const getCssObjectByRuleName = typeof cssObjectByRuleNameOrGetCssObjectByRuleName === "function" ? cssObjectByRuleNameOrGetCssObjectByRuleName : () => cssObjectByRuleNameOrGetCssObjectByRuleName;
      return function useStyles3(params3, muiStyleOverridesParams) {
        const theme = useTheme2();
        let { css: css2, cx: cx2 } = useCssAndCx();
        const cache2 = useCache();
        let classes = reactExports.useMemo(() => {
          const refClassesCache = {};
          const refClasses = typeof Proxy !== "undefined" && new Proxy({}, {
            "get": (_target, propertyKey) => {
              if (typeof propertyKey === "symbol") {
                assert(false);
              }
              return refClassesCache[propertyKey] = `${cache2.key}-${uniqId}${name !== void 0 ? `-${name}` : ""}-${propertyKey}-ref`;
            }
          });
          const cssObjectByRuleName = getCssObjectByRuleName(theme, params3, refClasses || {});
          const classes2 = objectFromEntries(objectKeys(cssObjectByRuleName).map((ruleName) => {
            const cssObject = cssObjectByRuleName[ruleName];
            if (!cssObject.label) {
              cssObject.label = `${name !== void 0 ? `${name}-` : ""}${ruleName}`;
            }
            return [
              ruleName,
              `${css2(cssObject)}${typeGuard(ruleName, ruleName in refClassesCache) ? ` ${refClassesCache[ruleName]}` : ""}`
            ];
          }));
          objectKeys(refClassesCache).forEach((ruleName) => {
            if (ruleName in classes2) {
              return;
            }
            classes2[ruleName] = refClassesCache[ruleName];
          });
          return classes2;
        }, [cache2, css2, cx2, theme, getDependencyArrayRef(params3)]);
        {
          const propsClasses = muiStyleOverridesParams === null || muiStyleOverridesParams === void 0 ? void 0 : muiStyleOverridesParams.props.classes;
          classes = reactExports.useMemo(() => mergeClasses(classes, propsClasses, cx2), [classes, getDependencyArrayRef(propsClasses), cx2]);
        }
        {
          const pluginResultWrap = useMuiThemeStyleOverridesPlugin({
            classes,
            css: css2,
            cx: cx2,
            "name": name !== null && name !== void 0 ? name : "makeStyle no name",
            muiStyleOverridesParams,
            // NOTE: If it's not a Mui Theme the plugin is resilient, it will not crash
            "theme": theme
          });
          if (pluginResultWrap.classes !== void 0) {
            classes = pluginResultWrap.classes;
          }
          if (pluginResultWrap.css !== void 0) {
            css2 = pluginResultWrap.css;
          }
          if (pluginResultWrap.cx !== void 0) {
            cx2 = pluginResultWrap.cx;
          }
        }
        return {
          classes,
          theme,
          css: css2,
          cx: cx2
        };
      };
    };
  }
  function useStyles2() {
    const theme = useTheme2();
    const { css: css2, cx: cx2 } = useCssAndCx();
    return { theme, css: css2, cx: cx2 };
  }
  return { makeStyles: makeStyles2, useStyles: useStyles2 };
}
const reactContext = reactExports.createContext(void 0);
const { createUseCache } = /* @__PURE__ */ (() => {
  function useCacheProvidedByProvider() {
    const cacheExplicitlyProvidedForTss = reactExports.useContext(reactContext);
    return cacheExplicitlyProvidedForTss;
  }
  function createUseCache2(params) {
    const { cacheProvidedAtInception } = params;
    function useCache() {
      var _a2;
      const contextualCache = useContextualCache();
      const cacheExplicitlyProvidedForTss = useCacheProvidedByProvider();
      const cacheToBeUsed = (_a2 = cacheProvidedAtInception !== null && cacheProvidedAtInception !== void 0 ? cacheProvidedAtInception : cacheExplicitlyProvidedForTss) !== null && _a2 !== void 0 ? _a2 : contextualCache;
      if (cacheToBeUsed === null) {
        throw new Error([
          "In order to get SSR working with tss-react you need to explicitly provide an Emotion cache.",
          "MUI users be aware: This is not an error strictly related to tss-react, with or without tss-react,",
          "MUI needs an Emotion cache to be provided for SSR to work.",
          "Here is the MUI documentation related to SSR setup: https://mui.com/material-ui/guides/server-rendering/",
          "TSS provides helper that makes the process of setting up SSR easier: https://docs.tss-react.dev/ssr"
        ].join("\n"));
      }
      return cacheToBeUsed;
    }
    return { useCache };
  }
  return { createUseCache: createUseCache2 };
})();
function capitalize$1(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
function createWithStyles(params) {
  const { useTheme: useTheme2, cache: cache2 } = params;
  const { makeStyles: makeStyles2 } = createMakeStyles({ useTheme: useTheme2, cache: cache2 });
  function withStyles(Component, cssObjectByRuleNameOrGetCssObjectByRuleName, params2) {
    const Component_ = typeof Component === "string" ? (() => {
      const tag = Component;
      const Out2 = function({ children, ...props }) {
        return reactExports.createElement(tag, props, children);
      };
      Object.defineProperty(Out2, "name", {
        "value": capitalize$1(tag)
      });
      return Out2;
    })() : Component;
    const name = (() => {
      {
        const { name: nameOrWrappedName } = params2 !== null && params2 !== void 0 ? params2 : {};
        if (nameOrWrappedName !== void 0) {
          return typeof nameOrWrappedName !== "object" ? nameOrWrappedName : Object.keys(nameOrWrappedName)[0];
        }
      }
      let name2 = void 0;
      displayName: {
        const displayName = Component_.displayName;
        if (typeof displayName !== "string" || displayName === "") {
          break displayName;
        }
        name2 = displayName;
      }
      functionName: {
        if (name2 !== void 0) {
          break functionName;
        }
        const functionName = Component_.name;
        if (typeof functionName !== "string" || functionName === "") {
          break functionName;
        }
        name2 = functionName;
      }
      if (name2 === void 0) {
        return void 0;
      }
      name2 = name2.replace(/\$/g, "usd");
      name2 = name2.replace(/\(/g, "_").replace(/\)/g, "_");
      name2 = name2.replace(/[^a-zA-Z0-9-_]/g, "_");
      return name2;
    })();
    const useStyles2 = makeStyles2({ ...params2, name })(typeof cssObjectByRuleNameOrGetCssObjectByRuleName === "function" ? (theme, props, classes) => incorporateMediaQueries(cssObjectByRuleNameOrGetCssObjectByRuleName(theme, props, classes)) : incorporateMediaQueries(cssObjectByRuleNameOrGetCssObjectByRuleName));
    function getHasNonRootClasses(classes) {
      for (const name2 in classes) {
        if (name2 === "root") {
          continue;
        }
        return true;
      }
      return false;
    }
    const Out = reactExports.forwardRef(function(props, ref2) {
      const { className, classes: _classes, ...rest } = props;
      const { classes, cx: cx2 } = useStyles2(props, { props });
      const rootClassName = cx2(classes.root, className);
      fixedClassesByClasses.set(classes, {
        ...classes,
        "root": rootClassName
      });
      return React.createElement(Component_, { ref: ref2, className: getHasNonRootClasses(classes) ? className : rootClassName, ...typeof Component === "string" ? {} : { classes }, ...rest });
    });
    if (name !== void 0) {
      Out.displayName = `${capitalize$1(name)}WithStyles`;
      Object.defineProperty(Out, "name", { "value": Out.displayName });
    }
    return Out;
  }
  withStyles.getClasses = getClasses;
  return { withStyles };
}
const fixedClassesByClasses = /* @__PURE__ */ new WeakMap();
const errorMessageGetClasses = "getClasses should only be used in conjunction with withStyles";
function getClasses(props) {
  const classesIn = props.classes;
  if (classesIn === void 0) {
    throw new Error(errorMessageGetClasses);
  }
  const classes = fixedClassesByClasses.get(classesIn);
  if (classes === void 0) {
    throw new Error(errorMessageGetClasses);
  }
  return classes;
}
function incorporateMediaQueries(cssObjectByRuleNameWithMediaQueries) {
  const cssObjectByRuleName = {};
  const cssObjectByRuleNameWithMediaQueriesByMediaQuery = {};
  Object.keys(cssObjectByRuleNameWithMediaQueries).forEach((ruleNameOrMediaQuery) => (ruleNameOrMediaQuery.startsWith("@media") ? cssObjectByRuleNameWithMediaQueriesByMediaQuery : cssObjectByRuleName)[ruleNameOrMediaQuery] = cssObjectByRuleNameWithMediaQueries[ruleNameOrMediaQuery]);
  Object.keys(cssObjectByRuleNameWithMediaQueriesByMediaQuery).forEach((mediaQuery) => {
    const cssObjectByRuleNameBis = cssObjectByRuleNameWithMediaQueriesByMediaQuery[mediaQuery];
    Object.keys(cssObjectByRuleNameBis).forEach((ruleName) => {
      var _a2;
      return cssObjectByRuleName[ruleName] = {
        ...(_a2 = cssObjectByRuleName[ruleName]) !== null && _a2 !== void 0 ? _a2 : {},
        [mediaQuery]: cssObjectByRuleNameBis[ruleName]
      };
    });
  });
  return cssObjectByRuleName;
}
const isSSR = (() => {
  const isBrowser2 = typeof document === "object" && typeof (document === null || document === void 0 ? void 0 : document.getElementById) === "function";
  const isJest = typeof jest !== "undefined";
  const isMocha = typeof mocha !== "undefined";
  const isVitest = typeof __vitest_worker__ !== "undefined";
  return !isBrowser2 && !isJest && !isMocha && !isVitest;
})();
function createTss(params) {
  counter = 0;
  nestedSelectorUsageTrackRecord.splice(0, nestedSelectorUsageTrackRecord.length);
  const { useContext: useContext2, usePlugin, cache: cacheProvidedAtInception } = params;
  const { useCache } = createUseCache({ cacheProvidedAtInception });
  const { useCssAndCx } = createUseCssAndCx({ useCache });
  const usePluginDefault = ({ classes, cx: cx2, css: css2 }) => ({ classes, cx: cx2, css: css2 });
  const tss2 = createTss_internal({
    useContext: useContext2,
    useCache,
    useCssAndCx,
    "usePlugin": usePlugin !== null && usePlugin !== void 0 ? usePlugin : usePluginDefault,
    "name": void 0,
    "doesUseNestedSelectors": false
  });
  return { tss: tss2 };
}
let counter = 0;
const nestedSelectorUsageTrackRecord = [];
function createTss_internal(params) {
  const { useContext: useContext2, useCache, useCssAndCx, usePlugin, name, doesUseNestedSelectors } = params;
  return {
    "withParams": () => createTss_internal({ ...params }),
    "withName": (nameOrWrappedName) => createTss_internal({
      ...params,
      "name": typeof nameOrWrappedName !== "object" ? nameOrWrappedName : Object.keys(nameOrWrappedName)[0]
    }),
    "withNestedSelectors": () => createTss_internal({
      ...params,
      "doesUseNestedSelectors": true
    }),
    "create": (cssObjectByRuleNameOrGetCssObjectByRuleName) => {
      const idOfUseStyles = `x${counter++}`;
      if (name !== void 0) {
        while (true) {
          const wrap = nestedSelectorUsageTrackRecord.find((wrap2) => wrap2.name === name);
          if (wrap === void 0) {
            break;
          }
          nestedSelectorUsageTrackRecord.splice(nestedSelectorUsageTrackRecord.indexOf(wrap), 1);
        }
      }
      const getCssObjectByRuleName = typeof cssObjectByRuleNameOrGetCssObjectByRuleName === "function" ? cssObjectByRuleNameOrGetCssObjectByRuleName : () => cssObjectByRuleNameOrGetCssObjectByRuleName;
      return function useStyles2(params2) {
        var _a2, _b2, _c2;
        const { classesOverrides, ...paramsAndPluginParams } = params2 !== null && params2 !== void 0 ? params2 : {};
        const context2 = useContext2();
        const { css: css2, cx: cx2 } = useCssAndCx();
        const cache2 = useCache();
        const getClasses2 = () => {
          const refClassesCache = {};
          const cssObjectByRuleName = getCssObjectByRuleName({
            ...params2,
            ...context2,
            ...!doesUseNestedSelectors ? {} : {
              "classes": typeof Proxy === "undefined" ? {} : new Proxy({}, {
                "get": (_target, ruleName) => {
                  if (typeof ruleName === "symbol") {
                    assert(false);
                  }
                  if (isSSR && name === void 0) {
                    throw new Error([
                      `tss-react: In SSR setups, in order to use nested selectors, you must also give a unique name to the useStyle function.`,
                      `Solution: Use tss.withName("ComponentName").withNestedSelectors<...>()... to set a name.`
                    ].join("\n"));
                  }
                  update_nested_selector_usage_track_record: {
                    if (name === void 0) {
                      break update_nested_selector_usage_track_record;
                    }
                    let wrap = nestedSelectorUsageTrackRecord.find((wrap2) => wrap2.name === name && wrap2.idOfUseStyles === idOfUseStyles);
                    if (wrap === void 0) {
                      wrap = { name, idOfUseStyles, "nestedSelectorRuleNames": /* @__PURE__ */ new Set() };
                      nestedSelectorUsageTrackRecord.push(wrap);
                    }
                    wrap.nestedSelectorRuleNames.add(ruleName);
                  }
                  detect_potential_conflicts: {
                    if (name === void 0) {
                      break detect_potential_conflicts;
                    }
                    const hasPotentialConflict = nestedSelectorUsageTrackRecord.find((wrap) => wrap.name === name && wrap.idOfUseStyles !== idOfUseStyles && wrap.nestedSelectorRuleNames.has(ruleName)) !== void 0;
                    if (!hasPotentialConflict) {
                      break detect_potential_conflicts;
                    }
                    throw new Error([
                      `tss-react: There are in your codebase two different useStyles named "${name}" that`,
                      `both use use the nested selector ${ruleName}.
`,
                      `This may lead to CSS class name collisions, causing nested selectors to target elements outside of the intended scope.
`,
                      `Solution: Ensure each useStyles using nested selectors has a unique name.
`,
                      `Use: tss.withName("UniqueName").withNestedSelectors<...>()...`
                    ].join(" "));
                  }
                  return refClassesCache[ruleName] = `${cache2.key}-${name !== void 0 ? name : idOfUseStyles}-${ruleName}-ref`;
                }
              })
            }
          });
          let classes2 = objectFromEntries(objectKeys(cssObjectByRuleName).map((ruleName) => {
            const cssObject = cssObjectByRuleName[ruleName];
            if (!cssObject.label) {
              cssObject.label = `${name !== void 0 ? `${name}-` : ""}${ruleName}`;
            }
            return [
              ruleName,
              `${css2(cssObject)}${typeGuard(ruleName, ruleName in refClassesCache) ? ` ${refClassesCache[ruleName]}` : ""}`
            ];
          }));
          objectKeys(refClassesCache).forEach((ruleName) => {
            if (ruleName in classes2) {
              return;
            }
            classes2[ruleName] = refClassesCache[ruleName];
          });
          classes2 = mergeClasses(classes2, classesOverrides, cx2);
          return classes2;
        };
        const classes = runGetClassesOrUseCache({
          cache: cache2,
          cssObjectByRuleNameOrGetCssObjectByRuleName,
          "classesOverridesRef": getDependencyArrayRef(classesOverrides),
          "paramsAndPluginParamsRef": getDependencyArrayRef(paramsAndPluginParams),
          idOfUseStyles,
          context: context2,
          getClasses: getClasses2
        });
        const pluginResultWrap = usePlugin({
          classes,
          css: css2,
          cx: cx2,
          idOfUseStyles,
          name,
          ...context2,
          ...paramsAndPluginParams
        });
        return {
          "classes": (_a2 = pluginResultWrap.classes) !== null && _a2 !== void 0 ? _a2 : classes,
          "css": (_b2 = pluginResultWrap.css) !== null && _b2 !== void 0 ? _b2 : css2,
          "cx": (_c2 = pluginResultWrap.cx) !== null && _c2 !== void 0 ? _c2 : cx2,
          ...context2
        };
      };
    }
  };
}
const mapCache = /* @__PURE__ */ new WeakMap();
function runGetClassesOrUseCache(params) {
  const { cache: cache2, cssObjectByRuleNameOrGetCssObjectByRuleName, classesOverridesRef, paramsAndPluginParamsRef, idOfUseStyles, context: context2, getClasses: getClasses2 } = params;
  use_cache: {
    const mapCache_in = mapCache.get(cache2);
    if (mapCache_in === void 0) {
      break use_cache;
    }
    const mapCache_in_in = mapCache_in.get(cssObjectByRuleNameOrGetCssObjectByRuleName);
    if (mapCache_in_in === void 0) {
      break use_cache;
    }
    const mapCache_in_in_in = mapCache_in_in.get(classesOverridesRef);
    if (mapCache_in_in_in === void 0) {
      break use_cache;
    }
    const arr = mapCache_in_in_in.get(paramsAndPluginParamsRef);
    if (arr === void 0) {
      break use_cache;
    }
    const entry = arr.find(({ context: context_i }) => {
      if (context_i === context2) {
        return true;
      }
      if (objectKeys(context_i).length !== objectKeys(context2).length) {
        return false;
      }
      for (const key in context_i) {
        if (getDependencyArrayRef(context_i[key]) !== getDependencyArrayRef(context2[key])) {
          return false;
        }
      }
      return true;
    });
    if (entry === void 0) {
      break use_cache;
    }
    if ((entry === null || entry === void 0 ? void 0 : entry.idOfUseStyles) !== idOfUseStyles) {
      arr.splice(arr.indexOf(entry), 1);
      break use_cache;
    }
    return entry.result;
  }
  const result = getClasses2();
  {
    if (!mapCache.has(cache2)) {
      mapCache.set(cache2, /* @__PURE__ */ new WeakMap());
    }
    const mapCache_in = mapCache.get(cache2);
    assert(mapCache_in !== void 0);
    if (!mapCache_in.has(cssObjectByRuleNameOrGetCssObjectByRuleName)) {
      mapCache_in.set(cssObjectByRuleNameOrGetCssObjectByRuleName, /* @__PURE__ */ new Map());
    }
    const mapCache_in_in = mapCache_in.get(cssObjectByRuleNameOrGetCssObjectByRuleName);
    assert(mapCache_in_in !== void 0);
    if (!mapCache_in_in.has(classesOverridesRef)) {
      if (mapCache_in_in.size > 200) {
        mapCache_in_in.clear();
      }
      mapCache_in_in.set(classesOverridesRef, /* @__PURE__ */ new Map());
    }
    const mapCache_in_in_in = mapCache_in_in.get(classesOverridesRef);
    assert(mapCache_in_in_in !== void 0);
    if (!mapCache_in_in_in.has(paramsAndPluginParamsRef)) {
      clear_cache: {
        const threshold = typeof paramsAndPluginParamsRef === "string" ? 257 : 5;
        if (mapCache_in_in_in.size < threshold) {
          break clear_cache;
        }
        mapCache_in_in_in.clear();
      }
      mapCache_in_in_in.set(paramsAndPluginParamsRef, []);
    }
    let arr = mapCache_in_in_in.get(paramsAndPluginParamsRef);
    assert(arr !== void 0);
    if (arr.length > 5) {
      arr = [];
    }
    arr.push({ idOfUseStyles, context: context2, result });
  }
  return result;
}
function createMakeAndWithStyles(params) {
  return {
    ...createMakeStyles(params),
    ...createWithStyles(params)
  };
}
const { tss: tss$1 } = createTss({
  "useContext": () => ({})
});
tss$1.create({});
const { makeStyles } = createMakeAndWithStyles({
  useTheme
});
const { tss } = createTss({
  "useContext": function useContext() {
    const theme = useTheme();
    return { theme };
  },
  "usePlugin": useMuiThemeStyleOverridesPlugin
});
const useStyles = tss.create({});
const getPickersLocalization = (pickersTranslations) => {
  return {
    components: {
      MuiLocalizationProvider: {
        defaultProps: {
          localeText: _extends({}, pickersTranslations)
        }
      }
    }
  };
};
const enUSPickers = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "Open previous view",
  openNextView: "Open next view",
  calendarViewSwitchingButtonAriaLabel: (view) => view === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange labels
  start: "Start",
  end: "End",
  startDate: "Start date",
  startTime: "Start time",
  endDate: "End date",
  endTime: "End time",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  nextStepButtonLabel: "Next",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  timeRangePickerToolbarTitle: "Select time range",
  // Clock labels
  clockLabelText: (view, formattedTime) => `Select ${view}. ${!formattedTime ? "No time selected" : `Selected time is ${formattedTime}`}`,
  hoursClockNumberText: (hours) => `${hours} hours`,
  minutesClockNumberText: (minutes) => `${minutes} minutes`,
  secondsClockNumberText: (seconds) => `${seconds} seconds`,
  // Digital clock labels
  selectViewText: (view) => `Select ${view}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (weekNumber) => `Week ${weekNumber}`,
  calendarWeekNumberText: (weekNumber) => `${weekNumber}`,
  // Open Picker labels
  openDatePickerDialogue: (formattedDate) => formattedDate ? `Choose date, selected date is ${formattedDate}` : "Choose date",
  openTimePickerDialogue: (formattedTime) => formattedTime ? `Choose time, selected time is ${formattedTime}` : "Choose time",
  openRangePickerDialogue: (formattedRange) => formattedRange ? `Choose range, selected range is ${formattedRange}` : "Choose range",
  fieldClearLabel: "Clear",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (params) => "Y".repeat(params.digitAmount),
  fieldMonthPlaceholder: (params) => params.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (params) => params.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa",
  // View names
  year: "Year",
  month: "Month",
  day: "Day",
  weekDay: "Week day",
  hours: "Hours",
  minutes: "Minutes",
  seconds: "Seconds",
  meridiem: "Meridiem",
  // Common
  empty: "Empty"
};
const DEFAULT_LOCALE = enUSPickers;
getPickersLocalization(enUSPickers);
const _excluded$v = ["localeText"];
const PickerAdapterContext = /* @__PURE__ */ reactExports.createContext(null);
if (process.env.NODE_ENV !== "production") PickerAdapterContext.displayName = "PickerAdapterContext";
const LocalizationProvider = function LocalizationProvider2(inProps) {
  const {
    localeText: inLocaleText
  } = inProps, otherInProps = _objectWithoutPropertiesLoose(inProps, _excluded$v);
  const {
    adapter: parentAdapter,
    localeText: parentLocaleText
  } = reactExports.useContext(PickerAdapterContext) ?? {
    adapter: void 0,
    localeText: void 0
  };
  const props = useThemeProps({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: otherInProps,
    name: "MuiLocalizationProvider"
  });
  const {
    children,
    dateAdapter: DateAdapter,
    dateFormats,
    dateLibInstance,
    adapterLocale,
    localeText: themeLocaleText
  } = props;
  const localeText = reactExports.useMemo(() => _extends({}, themeLocaleText, parentLocaleText, inLocaleText), [themeLocaleText, parentLocaleText, inLocaleText]);
  const adapter = reactExports.useMemo(() => {
    if (!DateAdapter) {
      if (parentAdapter) {
        return parentAdapter;
      }
      return null;
    }
    const dateAdapter = new DateAdapter({
      locale: adapterLocale,
      formats: dateFormats,
      instance: dateLibInstance
    });
    if (!dateAdapter.isMUIAdapter) {
      throw new Error(["MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/quickstart/#installation"].join(`
`));
    }
    return dateAdapter;
  }, [DateAdapter, adapterLocale, dateFormats, dateLibInstance, parentAdapter]);
  const defaultDates = reactExports.useMemo(() => {
    if (!adapter) {
      return null;
    }
    return {
      minDate: adapter.date("1900-01-01T00:00:00.000"),
      maxDate: adapter.date("2099-12-31T00:00:00.000")
    };
  }, [adapter]);
  const contextValue = reactExports.useMemo(() => {
    return {
      utils: adapter,
      adapter,
      defaultDates,
      localeText
    };
  }, [defaultDates, adapter, localeText]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickerAdapterContext.Provider, {
    value: contextValue,
    children
  });
};
if (process.env.NODE_ENV !== "production") LocalizationProvider.displayName = "LocalizationProvider";
process.env.NODE_ENV !== "production" ? LocalizationProvider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: PropTypes.any,
  children: PropTypes.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/quickstart/#integrate-provider-and-adapter date adapter setup section} for more details.
   */
  dateAdapter: PropTypes.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: PropTypes.shape({
    dayOfMonth: PropTypes.string,
    dayOfMonthFull: PropTypes.string,
    fullDate: PropTypes.string,
    fullTime12h: PropTypes.string,
    fullTime24h: PropTypes.string,
    hours12h: PropTypes.string,
    hours24h: PropTypes.string,
    keyboardDate: PropTypes.string,
    keyboardDateTime12h: PropTypes.string,
    keyboardDateTime24h: PropTypes.string,
    meridiem: PropTypes.string,
    minutes: PropTypes.string,
    month: PropTypes.string,
    monthShort: PropTypes.string,
    normalDate: PropTypes.string,
    normalDateWithWeekday: PropTypes.string,
    seconds: PropTypes.string,
    shortDate: PropTypes.string,
    weekday: PropTypes.string,
    weekdayShort: PropTypes.string,
    year: PropTypes.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: PropTypes.any,
  /**
   * Locale for components texts
   */
  localeText: PropTypes.object
} : void 0;
const useLocalizationContext = () => {
  const localization = reactExports.useContext(PickerAdapterContext);
  if (localization === null) {
    throw new Error(["MUI X: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join("\n"));
  }
  if (localization.adapter === null) {
    throw new Error(["MUI X: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join("\n"));
  }
  const localeText = reactExports.useMemo(() => _extends({}, DEFAULT_LOCALE, localization.localeText), [localization.localeText]);
  return reactExports.useMemo(() => _extends({}, localization, {
    localeText
  }), [localization, localeText]);
};
const usePickerAdapter = () => useLocalizationContext().adapter;
const usePickerTranslations = () => useLocalizationContext().localeText;
const DATE_VALIDATION_PROP_NAMES = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"];
const TIME_VALIDATION_PROP_NAMES = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"];
const DATE_TIME_VALIDATION_PROP_NAMES = ["minDateTime", "maxDateTime"];
const VALIDATION_PROP_NAMES = [...DATE_VALIDATION_PROP_NAMES, ...TIME_VALIDATION_PROP_NAMES, ...DATE_TIME_VALIDATION_PROP_NAMES];
const extractValidationProps = (props) => VALIDATION_PROP_NAMES.reduce((extractedProps, propName) => {
  if (props.hasOwnProperty(propName)) {
    extractedProps[propName] = props[propName];
  }
  return extractedProps;
}, {});
const SHARED_FIELD_INTERNAL_PROP_NAMES = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef", "unstableStartFieldRef", "unstableEndFieldRef", "enableAccessibleFieldDOMStructure", "disabled", "readOnly", "dateSeparator", "autoFocus", "focused"];
const useSplitFieldProps = (props, valueType) => {
  return reactExports.useMemo(() => {
    const forwardedProps = _extends({}, props);
    const internalProps = {};
    const extractProp = (propName) => {
      if (forwardedProps.hasOwnProperty(propName)) {
        internalProps[propName] = forwardedProps[propName];
        delete forwardedProps[propName];
      }
    };
    SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
    if (valueType === "date") {
      DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
    } else if (valueType === "time") {
      TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
    } else if (valueType === "date-time") {
      DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
      TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
      DATE_TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
    }
    return {
      forwardedProps,
      internalProps
    };
  }, [props, valueType]);
};
const areViewsEqual = (views, expectedViews) => {
  if (views.length !== expectedViews.length) {
    return false;
  }
  return expectedViews.every((expectedView) => views.includes(expectedView));
};
const applyDefaultViewProps = ({
  openTo,
  defaultOpenTo,
  views,
  defaultViews
}) => {
  const viewsWithDefault = views ?? defaultViews;
  let openToWithDefault;
  if (openTo != null) {
    openToWithDefault = openTo;
  } else if (viewsWithDefault.includes(defaultOpenTo)) {
    openToWithDefault = defaultOpenTo;
  } else if (viewsWithDefault.length > 0) {
    openToWithDefault = viewsWithDefault[0];
  } else {
    throw new Error("MUI X: The `views` prop must contain at least one view.");
  }
  return {
    views: viewsWithDefault,
    openTo: openToWithDefault
  };
};
const mergeDateAndTime = (adapter, dateParam, timeParam) => {
  let mergedDate = dateParam;
  mergedDate = adapter.setHours(mergedDate, adapter.getHours(timeParam));
  mergedDate = adapter.setMinutes(mergedDate, adapter.getMinutes(timeParam));
  mergedDate = adapter.setSeconds(mergedDate, adapter.getSeconds(timeParam));
  mergedDate = adapter.setMilliseconds(mergedDate, adapter.getMilliseconds(timeParam));
  return mergedDate;
};
const findClosestEnabledDate = ({
  date,
  disableFuture,
  disablePast,
  maxDate,
  minDate,
  isDateDisabled,
  adapter,
  timezone
}) => {
  const today2 = mergeDateAndTime(adapter, adapter.date(void 0, timezone), date);
  if (disablePast && adapter.isBefore(minDate, today2)) {
    minDate = today2;
  }
  if (disableFuture && adapter.isAfter(maxDate, today2)) {
    maxDate = today2;
  }
  let forward = date;
  let backward = date;
  if (adapter.isBefore(date, minDate)) {
    forward = minDate;
    backward = null;
  }
  if (adapter.isAfter(date, maxDate)) {
    if (backward) {
      backward = maxDate;
    }
    forward = null;
  }
  while (forward || backward) {
    if (forward && adapter.isAfter(forward, maxDate)) {
      forward = null;
    }
    if (backward && adapter.isBefore(backward, minDate)) {
      backward = null;
    }
    if (forward) {
      if (!isDateDisabled(forward)) {
        return forward;
      }
      forward = adapter.addDays(forward, 1);
    }
    if (backward) {
      if (!isDateDisabled(backward)) {
        return backward;
      }
      backward = adapter.addDays(backward, -1);
    }
  }
  return null;
};
const replaceInvalidDateByNull = (adapter, value) => !adapter.isValid(value) ? null : value;
const applyDefaultDate = (adapter, value, defaultValue) => {
  if (value == null || !adapter.isValid(value)) {
    return defaultValue;
  }
  return value;
};
const areDatesEqual = (adapter, a, b) => {
  if (!adapter.isValid(a) && a != null && !adapter.isValid(b) && b != null) {
    return true;
  }
  return adapter.isEqual(a, b);
};
const getMonthsInYear = (adapter, year) => {
  const firstMonth = adapter.startOfYear(year);
  const months2 = [firstMonth];
  while (months2.length < 12) {
    const prevMonth = months2[months2.length - 1];
    months2.push(adapter.addMonths(prevMonth, 1));
  }
  return months2;
};
const getTodayDate = (adapter, timezone, valueType) => valueType === "date" ? adapter.startOfDay(adapter.date(void 0, timezone)) : adapter.date(void 0, timezone);
const DATE_VIEWS = ["year", "month", "day"];
const isDatePickerView = (view) => DATE_VIEWS.includes(view);
const resolveDateFormat = (adapter, {
  format: format2,
  views
}, isInToolbar) => {
  if (format2 != null) {
    return format2;
  }
  const formats = adapter.formats;
  if (areViewsEqual(views, ["year"])) {
    return formats.year;
  }
  if (areViewsEqual(views, ["month"])) {
    return formats.month;
  }
  if (areViewsEqual(views, ["day"])) {
    return formats.dayOfMonth;
  }
  if (areViewsEqual(views, ["month", "year"])) {
    return `${formats.month} ${formats.year}`;
  }
  if (areViewsEqual(views, ["day", "month"])) {
    return `${formats.month} ${formats.dayOfMonth}`;
  }
  if (isInToolbar) {
    return /en/.test(adapter.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
  }
  return formats.keyboardDate;
};
const getWeekdays = (adapter, date) => {
  const start2 = adapter.startOfWeek(date);
  return [0, 1, 2, 3, 4, 5, 6].map((diff2) => adapter.addDays(start2, diff2));
};
const EXPORTED_TIME_VIEWS = ["hours", "minutes", "seconds"];
const isTimeView = (view) => EXPORTED_TIME_VIEWS.includes(view);
const convertValueToMeridiem = (value, meridiem, ampm) => {
  {
    const currentMeridiem = value >= 12 ? "pm" : "am";
    if (currentMeridiem !== meridiem) {
      return meridiem === "am" ? value - 12 : value + 12;
    }
  }
  return value;
};
const convertToMeridiem = (time2, meridiem, ampm, adapter) => {
  const newHoursAmount = convertValueToMeridiem(adapter.getHours(time2), meridiem);
  return adapter.setHours(time2, newHoursAmount);
};
const getSecondsInDay = (date, adapter) => {
  return adapter.getHours(date) * 3600 + adapter.getMinutes(date) * 60 + adapter.getSeconds(date);
};
const createIsAfterIgnoreDatePart = (disableIgnoringDatePartForTimeValidation, adapter) => (dateLeft, dateRight) => {
  if (disableIgnoringDatePartForTimeValidation) {
    return adapter.isAfter(dateLeft, dateRight);
  }
  return getSecondsInDay(dateLeft, adapter) > getSecondsInDay(dateRight, adapter);
};
const getDateSectionConfigFromFormatToken = (adapter, formatToken) => {
  const config2 = adapter.formatTokenMap[formatToken];
  if (config2 == null) {
    throw new Error([`MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join("\n"));
  }
  if (typeof config2 === "string") {
    return {
      type: config2,
      contentType: config2 === "meridiem" ? "letter" : "digit",
      maxLength: void 0
    };
  }
  return {
    type: config2.sectionType,
    contentType: config2.contentType,
    maxLength: config2.maxLength
  };
};
const getDaysInWeekStr = (adapter, format2) => {
  const elements = [];
  const now2 = adapter.date(void 0, "default");
  const startDate = adapter.startOfWeek(now2);
  const endDate = adapter.endOfWeek(now2);
  let current = startDate;
  while (adapter.isBefore(current, endDate)) {
    elements.push(current);
    current = adapter.addDays(current, 1);
  }
  return elements.map((weekDay) => adapter.formatByString(weekDay, format2));
};
const getLetterEditingOptions = (adapter, timezone, sectionType, format2) => {
  switch (sectionType) {
    case "month": {
      return getMonthsInYear(adapter, adapter.date(void 0, timezone)).map((month) => adapter.formatByString(month, format2));
    }
    case "weekDay": {
      return getDaysInWeekStr(adapter, format2);
    }
    case "meridiem": {
      const now2 = adapter.date(void 0, timezone);
      return [adapter.startOfDay(now2), adapter.endOfDay(now2)].map((date) => adapter.formatByString(date, format2));
    }
    default: {
      return [];
    }
  }
};
const FORMAT_SECONDS_NO_LEADING_ZEROS = "s";
const NON_LOCALIZED_DIGITS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
const getLocalizedDigits = (adapter) => {
  const today2 = adapter.date(void 0);
  const formattedZero = adapter.formatByString(adapter.setSeconds(today2, 0), FORMAT_SECONDS_NO_LEADING_ZEROS);
  if (formattedZero === "0") {
    return NON_LOCALIZED_DIGITS;
  }
  return Array.from({
    length: 10
  }).map((_, index2) => adapter.formatByString(adapter.setSeconds(today2, index2), FORMAT_SECONDS_NO_LEADING_ZEROS));
};
const removeLocalizedDigits = (valueStr, localizedDigits) => {
  if (localizedDigits[0] === "0") {
    return valueStr;
  }
  const digits = [];
  let currentFormattedDigit = "";
  for (let i = 0; i < valueStr.length; i += 1) {
    currentFormattedDigit += valueStr[i];
    const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
    if (matchingDigitIndex > -1) {
      digits.push(matchingDigitIndex.toString());
      currentFormattedDigit = "";
    }
  }
  return digits.join("");
};
const applyLocalizedDigits = (valueStr, localizedDigits) => {
  if (localizedDigits[0] === "0") {
    return valueStr;
  }
  return valueStr.split("").map((char2) => localizedDigits[Number(char2)]).join("");
};
const isStringNumber = (valueStr, localizedDigits) => {
  const nonLocalizedValueStr = removeLocalizedDigits(valueStr, localizedDigits);
  return nonLocalizedValueStr !== " " && !Number.isNaN(Number(nonLocalizedValueStr));
};
const cleanLeadingZeros = (valueStr, size) => {
  return Number(valueStr).toString().padStart(size, "0");
};
const cleanDigitSectionValue = (adapter, value, sectionBoundaries, localizedDigits, section) => {
  if (process.env.NODE_ENV !== "production") {
    if (section.type !== "day" && section.contentType === "digit-with-letter") {
      throw new Error([`MUI X: The token "${section.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join("\n"));
    }
  }
  if (section.type === "day" && section.contentType === "digit-with-letter") {
    const date = adapter.setDate(sectionBoundaries.longestMonth, value);
    return adapter.formatByString(date, section.format);
  }
  let valueStr = value.toString();
  if (section.hasLeadingZerosInInput) {
    valueStr = cleanLeadingZeros(valueStr, section.maxLength);
  }
  return applyLocalizedDigits(valueStr, localizedDigits);
};
const getSectionVisibleValue = (section, target, localizedDigits) => {
  let value = section.value || section.placeholder;
  const hasLeadingZeros = target === "non-input" ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
  if (target === "non-input" && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) {
    value = Number(removeLocalizedDigits(value, localizedDigits)).toString();
  }
  const shouldAddInvisibleSpace = ["input-rtl", "input-ltr"].includes(target) && section.contentType === "digit" && !hasLeadingZeros && value.length === 1;
  if (shouldAddInvisibleSpace) {
    value = `${value}‎`;
  }
  if (target === "input-rtl") {
    value = `⁨${value}⁩`;
  }
  return value;
};
const changeSectionValueFormat = (adapter, valueStr, currentFormat, newFormat) => {
  if (process.env.NODE_ENV !== "production") {
    if (getDateSectionConfigFromFormatToken(adapter, currentFormat).type === "weekDay") {
      throw new Error("changeSectionValueFormat doesn't support week day formats");
    }
  }
  return adapter.formatByString(adapter.parse(valueStr, currentFormat), newFormat);
};
const isFourDigitYearFormat = (adapter, format2) => adapter.formatByString(adapter.date(void 0, "system"), format2).length === 4;
const doesSectionFormatHaveLeadingZeros = (adapter, contentType, sectionType, format2) => {
  if (contentType !== "digit") {
    return false;
  }
  const now2 = adapter.date(void 0, "default");
  switch (sectionType) {
    // We can't use `changeSectionValueFormat`, because  `adapter.parse('1', 'YYYY')` returns `1971` instead of `1`.
    case "year": {
      if (adapter.lib === "dayjs" && format2 === "YY") {
        return true;
      }
      return adapter.formatByString(adapter.setYear(now2, 1), format2).startsWith("0");
    }
    case "month": {
      return adapter.formatByString(adapter.startOfYear(now2), format2).length > 1;
    }
    case "day": {
      return adapter.formatByString(adapter.startOfMonth(now2), format2).length > 1;
    }
    case "weekDay": {
      return adapter.formatByString(adapter.startOfWeek(now2), format2).length > 1;
    }
    case "hours": {
      return adapter.formatByString(adapter.setHours(now2, 1), format2).length > 1;
    }
    case "minutes": {
      return adapter.formatByString(adapter.setMinutes(now2, 1), format2).length > 1;
    }
    case "seconds": {
      return adapter.formatByString(adapter.setSeconds(now2, 1), format2).length > 1;
    }
    default: {
      throw new Error("Invalid section type");
    }
  }
};
const getDateFromDateSections = (adapter, sections, localizedDigits) => {
  const shouldSkipWeekDays = sections.some((section) => section.type === "day");
  const sectionFormats = [];
  const sectionValues = [];
  for (let i = 0; i < sections.length; i += 1) {
    const section = sections[i];
    const shouldSkip = shouldSkipWeekDays && section.type === "weekDay";
    if (!shouldSkip) {
      sectionFormats.push(section.format);
      sectionValues.push(getSectionVisibleValue(section, "non-input", localizedDigits));
    }
  }
  const formatWithoutSeparator = sectionFormats.join(" ");
  const dateWithoutSeparatorStr = sectionValues.join(" ");
  return adapter.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const createDateStrForV7HiddenInputFromSections = (sections) => sections.map((section) => {
  return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
}).join("");
const createDateStrForV6InputFromSections = (sections, localizedDigits, isRtl) => {
  const formattedSections = sections.map((section) => {
    const dateValue = getSectionVisibleValue(section, isRtl ? "input-rtl" : "input-ltr", localizedDigits);
    return `${section.startSeparator}${dateValue}${section.endSeparator}`;
  });
  const dateStr = formattedSections.join("");
  if (!isRtl) {
    return dateStr;
  }
  return `⁦${dateStr}⁩`;
};
const getSectionsBoundaries = (adapter, localizedDigits, timezone) => {
  const today2 = adapter.date(void 0, timezone);
  const endOfYear = adapter.endOfYear(today2);
  const endOfDay = adapter.endOfDay(today2);
  const {
    maxDaysInMonth,
    longestMonth
  } = getMonthsInYear(adapter, today2).reduce((acc, month) => {
    const daysInMonth2 = adapter.getDaysInMonth(month);
    if (daysInMonth2 > acc.maxDaysInMonth) {
      return {
        maxDaysInMonth: daysInMonth2,
        longestMonth: month
      };
    }
    return acc;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: format2
    }) => ({
      minimum: 0,
      maximum: isFourDigitYearFormat(adapter, format2) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: adapter.getMonth(endOfYear) + 1
    }),
    day: ({
      currentDate
    }) => ({
      minimum: 1,
      maximum: adapter.isValid(currentDate) ? adapter.getDaysInMonth(currentDate) : maxDaysInMonth,
      longestMonth
    }),
    weekDay: ({
      format: format2,
      contentType
    }) => {
      if (contentType === "digit") {
        const daysInWeek = getDaysInWeekStr(adapter, format2).map(Number);
        return {
          minimum: Math.min(...daysInWeek),
          maximum: Math.max(...daysInWeek)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: format2
    }) => {
      const lastHourInDay = adapter.getHours(endOfDay);
      const hasMeridiem = removeLocalizedDigits(adapter.formatByString(adapter.endOfDay(today2), format2), localizedDigits) !== lastHourInDay.toString();
      if (hasMeridiem) {
        return {
          minimum: 1,
          maximum: Number(removeLocalizedDigits(adapter.formatByString(adapter.startOfDay(today2), format2), localizedDigits))
        };
      }
      return {
        minimum: 0,
        maximum: lastHourInDay
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: adapter.getMinutes(endOfDay)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: adapter.getSeconds(endOfDay)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 1
    }),
    empty: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let warnedOnceInvalidSection = false;
const validateSections = (sections, valueType) => {
  if (process.env.NODE_ENV !== "production") {
    if (!warnedOnceInvalidSection) {
      const supportedSections = ["empty"];
      if (["date", "date-time"].includes(valueType)) {
        supportedSections.push("weekDay", "day", "month", "year");
      }
      if (["time", "date-time"].includes(valueType)) {
        supportedSections.push("hours", "minutes", "seconds", "meridiem");
      }
      const invalidSection = sections.find((section) => !supportedSections.includes(section.type));
      if (invalidSection) {
        console.warn(`MUI X: The field component you are using is not compatible with the "${invalidSection.type}" date section.`, `The supported date sections are ["${supportedSections.join('", "')}"]\`.`);
        warnedOnceInvalidSection = true;
      }
    }
  }
};
const transferDateSectionValue = (adapter, section, dateToTransferFrom, dateToTransferTo) => {
  switch (section.type) {
    case "year": {
      return adapter.setYear(dateToTransferTo, adapter.getYear(dateToTransferFrom));
    }
    case "month": {
      return adapter.setMonth(dateToTransferTo, adapter.getMonth(dateToTransferFrom));
    }
    case "weekDay": {
      let dayInWeekStrOfActiveDate = adapter.formatByString(dateToTransferFrom, section.format);
      if (section.hasLeadingZerosInInput) {
        dayInWeekStrOfActiveDate = cleanLeadingZeros(dayInWeekStrOfActiveDate, section.maxLength);
      }
      const formattedDaysInWeek = getDaysInWeekStr(adapter, section.format);
      const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
      const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
      const diff2 = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
      return adapter.addDays(dateToTransferFrom, diff2);
    }
    case "day": {
      return adapter.setDate(dateToTransferTo, adapter.getDate(dateToTransferFrom));
    }
    case "meridiem": {
      const meridiem = adapter.getHours(dateToTransferFrom) < 12 ? "am" : "pm";
      return convertToMeridiem(dateToTransferTo, meridiem, true, adapter);
    }
    case "hours": {
      return adapter.setHours(dateToTransferTo, adapter.getHours(dateToTransferFrom));
    }
    case "minutes": {
      return adapter.setMinutes(dateToTransferTo, adapter.getMinutes(dateToTransferFrom));
    }
    case "seconds": {
      return adapter.setSeconds(dateToTransferTo, adapter.getSeconds(dateToTransferFrom));
    }
    default: {
      return dateToTransferTo;
    }
  }
};
const reliableSectionModificationOrder = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8,
  empty: 9
};
const mergeDateIntoReferenceDate = (adapter, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections) => (
  // cloning sections before sort to avoid mutating it
  [...sections].sort((a, b) => reliableSectionModificationOrder[a.type] - reliableSectionModificationOrder[b.type]).reduce((mergedDate, section) => {
    if (!shouldLimitToEditedSections || section.modified) {
      return transferDateSectionValue(adapter, section, dateToTransferFrom, mergedDate);
    }
    return mergedDate;
  }, referenceDate)
);
const isAndroid = () => navigator.userAgent.toLowerCase().includes("android");
const getSectionOrder = (sections, shouldApplyRTL) => {
  const neighbors = {};
  if (!shouldApplyRTL) {
    sections.forEach((_, index2) => {
      const leftIndex = index2 === 0 ? null : index2 - 1;
      const rightIndex = index2 === sections.length - 1 ? null : index2 + 1;
      neighbors[index2] = {
        leftIndex,
        rightIndex
      };
    });
    return {
      neighbors,
      startIndex: 0,
      endIndex: sections.length - 1
    };
  }
  const rtl2ltr = {};
  const ltr2rtl = {};
  let groupedSectionsStart = 0;
  let groupedSectionsEnd = 0;
  let RTLIndex = sections.length - 1;
  while (RTLIndex >= 0) {
    groupedSectionsEnd = sections.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (section, index2) => index2 >= groupedSectionsStart && section.endSeparator?.includes(" ") && // Special case where the spaces were not there in the initial input
      section.endSeparator !== " / "
    );
    if (groupedSectionsEnd === -1) {
      groupedSectionsEnd = sections.length - 1;
    }
    for (let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1) {
      ltr2rtl[i] = RTLIndex;
      rtl2ltr[RTLIndex] = i;
      RTLIndex -= 1;
    }
    groupedSectionsStart = groupedSectionsEnd + 1;
  }
  sections.forEach((_, index2) => {
    const rtlIndex = ltr2rtl[index2];
    const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
    const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
    neighbors[index2] = {
      leftIndex,
      rightIndex
    };
  });
  return {
    neighbors,
    startIndex: rtl2ltr[0],
    endIndex: rtl2ltr[sections.length - 1]
  };
};
const parseSelectedSections = (selectedSections, sections) => {
  if (selectedSections == null) {
    return null;
  }
  if (selectedSections === "all") {
    return "all";
  }
  if (typeof selectedSections === "string") {
    const index2 = sections.findIndex((section) => section.type === selectedSections);
    return index2 === -1 ? null : index2;
  }
  return selectedSections;
};
const expandFormat = ({
  adapter,
  format: format2
}) => {
  let formatExpansionOverflow = 10;
  let prevFormat = format2;
  let nextFormat = adapter.expandFormat(format2);
  while (nextFormat !== prevFormat) {
    prevFormat = nextFormat;
    nextFormat = adapter.expandFormat(prevFormat);
    formatExpansionOverflow -= 1;
    if (formatExpansionOverflow < 0) {
      throw new Error("MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the component.");
    }
  }
  return nextFormat;
};
const getEscapedPartsFromFormat = ({
  adapter,
  expandedFormat
}) => {
  const escapedParts = [];
  const {
    start: startChar,
    end: endChar
  } = adapter.escapedCharacters;
  const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, "g");
  let match2 = null;
  while (match2 = regExp.exec(expandedFormat)) {
    escapedParts.push({
      start: match2.index,
      end: regExp.lastIndex - 1
    });
  }
  return escapedParts;
};
const getSectionPlaceholder = (adapter, localeText, sectionConfig, sectionFormat) => {
  switch (sectionConfig.type) {
    case "year": {
      return localeText.fieldYearPlaceholder({
        digitAmount: adapter.formatByString(adapter.date(void 0, "default"), sectionFormat).length,
        format: sectionFormat
      });
    }
    case "month": {
      return localeText.fieldMonthPlaceholder({
        contentType: sectionConfig.contentType,
        format: sectionFormat
      });
    }
    case "day": {
      return localeText.fieldDayPlaceholder({
        format: sectionFormat
      });
    }
    case "weekDay": {
      return localeText.fieldWeekDayPlaceholder({
        contentType: sectionConfig.contentType,
        format: sectionFormat
      });
    }
    case "hours": {
      return localeText.fieldHoursPlaceholder({
        format: sectionFormat
      });
    }
    case "minutes": {
      return localeText.fieldMinutesPlaceholder({
        format: sectionFormat
      });
    }
    case "seconds": {
      return localeText.fieldSecondsPlaceholder({
        format: sectionFormat
      });
    }
    case "meridiem": {
      return localeText.fieldMeridiemPlaceholder({
        format: sectionFormat
      });
    }
    default: {
      return sectionFormat;
    }
  }
};
const createSection = ({
  adapter,
  date,
  shouldRespectLeadingZeros,
  localeText,
  localizedDigits,
  now: now2,
  token: token2,
  startSeparator
}) => {
  if (token2 === "") {
    throw new Error("MUI X: Should not call `commitToken` with an empty token");
  }
  const sectionConfig = getDateSectionConfigFromFormatToken(adapter, token2);
  const hasLeadingZerosInFormat = doesSectionFormatHaveLeadingZeros(adapter, sectionConfig.contentType, sectionConfig.type, token2);
  const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === "digit";
  const isValidDate = adapter.isValid(date);
  let sectionValue = isValidDate ? adapter.formatByString(date, token2) : "";
  let maxLength = null;
  if (hasLeadingZerosInInput) {
    if (hasLeadingZerosInFormat) {
      maxLength = sectionValue === "" ? adapter.formatByString(now2, token2).length : sectionValue.length;
    } else {
      if (sectionConfig.maxLength == null) {
        throw new Error(`MUI X: The token ${token2} should have a 'maxLength' property on it's adapter`);
      }
      maxLength = sectionConfig.maxLength;
      if (isValidDate) {
        sectionValue = applyLocalizedDigits(cleanLeadingZeros(removeLocalizedDigits(sectionValue, localizedDigits), maxLength), localizedDigits);
      }
    }
  }
  return _extends({}, sectionConfig, {
    format: token2,
    maxLength,
    value: sectionValue,
    placeholder: getSectionPlaceholder(adapter, localeText, sectionConfig, token2),
    hasLeadingZerosInFormat,
    hasLeadingZerosInInput,
    startSeparator,
    endSeparator: "",
    modified: false
  });
};
const buildSections = (parameters) => {
  const {
    adapter,
    expandedFormat,
    escapedParts
  } = parameters;
  const now2 = adapter.date(void 0);
  const sections = [];
  let startSeparator = "";
  const validTokens = Object.keys(adapter.formatTokenMap).sort((a, b) => b.length - a.length);
  const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
  const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join("|")})*$`);
  const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join("|")})`);
  const getEscapedPartOfCurrentChar = (i12) => escapedParts.find((escapeIndex) => escapeIndex.start <= i12 && escapeIndex.end >= i12);
  let i = 0;
  while (i < expandedFormat.length) {
    const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
    const isEscapedChar = escapedPartOfCurrentChar != null;
    const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
    if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
      let word = firstWordInFormat;
      while (word.length > 0) {
        const firstWord = regExpFirstTokenInWord.exec(word)[1];
        word = word.slice(firstWord.length);
        sections.push(createSection(_extends({}, parameters, {
          now: now2,
          token: firstWord,
          startSeparator
        })));
        startSeparator = "";
      }
      i += firstWordInFormat.length;
    } else {
      const char2 = expandedFormat[i];
      const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
      if (!isEscapeBoundary) {
        if (sections.length === 0) {
          startSeparator += char2;
        } else {
          sections[sections.length - 1].endSeparator += char2;
          sections[sections.length - 1].isEndFormatSeparator = true;
        }
      }
      i += 1;
    }
  }
  if (sections.length === 0 && startSeparator.length > 0) {
    sections.push({
      type: "empty",
      contentType: "letter",
      maxLength: null,
      format: "",
      value: "",
      placeholder: "",
      hasLeadingZerosInFormat: false,
      hasLeadingZerosInInput: false,
      startSeparator,
      endSeparator: "",
      modified: false
    });
  }
  return sections;
};
const postProcessSections = ({
  isRtl,
  formatDensity,
  sections
}) => {
  return sections.map((section) => {
    const cleanSeparator = (separator) => {
      let cleanedSeparator = separator;
      if (isRtl && cleanedSeparator !== null && cleanedSeparator.includes(" ")) {
        cleanedSeparator = `⁩${cleanedSeparator}⁦`;
      }
      if (formatDensity === "spacious" && ["/", ".", "-"].includes(cleanedSeparator)) {
        cleanedSeparator = ` ${cleanedSeparator} `;
      }
      return cleanedSeparator;
    };
    section.startSeparator = cleanSeparator(section.startSeparator);
    section.endSeparator = cleanSeparator(section.endSeparator);
    return section;
  });
};
const buildSectionsFromFormat = (parameters) => {
  let expandedFormat = expandFormat(parameters);
  if (parameters.isRtl && parameters.enableAccessibleFieldDOMStructure) {
    expandedFormat = expandedFormat.split(" ").reverse().join(" ");
  }
  const escapedParts = getEscapedPartsFromFormat(_extends({}, parameters, {
    expandedFormat
  }));
  const sections = buildSections(_extends({}, parameters, {
    expandedFormat,
    escapedParts
  }));
  return postProcessSections(_extends({}, parameters, {
    sections
  }));
};
const PickerContext = /* @__PURE__ */ reactExports.createContext(null);
if (process.env.NODE_ENV !== "production") PickerContext.displayName = "PickerContext";
const usePickerContext = () => {
  const value = reactExports.useContext(PickerContext);
  if (value == null) {
    throw new Error("MUI X: The `usePickerContext` hook can only be called inside the context of a Picker component");
  }
  return value;
};
const useNullablePickerContext = () => reactExports.useContext(PickerContext);
const IsValidValueContext = /* @__PURE__ */ reactExports.createContext(() => true);
if (process.env.NODE_ENV !== "production") IsValidValueContext.displayName = "IsValidValueContext";
function useIsValidValue() {
  return reactExports.useContext(IsValidValueContext);
}
const PickerFieldPrivateContext = /* @__PURE__ */ reactExports.createContext(null);
if (process.env.NODE_ENV !== "production") PickerFieldPrivateContext.displayName = "PickerFieldPrivateContext";
function useNullableFieldPrivateContext() {
  return reactExports.useContext(PickerFieldPrivateContext);
}
const PickerActionsContext = /* @__PURE__ */ reactExports.createContext(null);
if (process.env.NODE_ENV !== "production") PickerActionsContext.displayName = "PickerActionsContext";
const PickerPrivateContext = /* @__PURE__ */ reactExports.createContext({
  ownerState: {
    isPickerDisabled: false,
    isPickerReadOnly: false,
    isPickerValueEmpty: false,
    isPickerOpen: false,
    pickerVariant: "desktop",
    pickerOrientation: "portrait"
  },
  rootRefObject: {
    current: null
  },
  labelId: void 0,
  dismissViews: () => {
  },
  hasUIView: true,
  getCurrentViewMode: () => "UI",
  triggerElement: null,
  viewContainerRole: null,
  defaultActionBarActions: [],
  onPopperExited: void 0
});
if (process.env.NODE_ENV !== "production") PickerPrivateContext.displayName = "PickerPrivateContext";
function PickerProvider(props) {
  const {
    contextValue,
    actionsContextValue,
    privateContextValue,
    fieldPrivateContextValue,
    isValidContextValue,
    localeText,
    children
  } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickerContext.Provider, {
    value: contextValue,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickerActionsContext.Provider, {
      value: actionsContextValue,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickerPrivateContext.Provider, {
        value: privateContextValue,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickerFieldPrivateContext.Provider, {
          value: fieldPrivateContextValue,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(IsValidValueContext.Provider, {
            value: isValidContextValue,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(LocalizationProvider, {
              localeText,
              children
            })
          })
        })
      })
    })
  });
}
const usePickerActionsContext = () => {
  const value = reactExports.useContext(PickerActionsContext);
  if (value == null) {
    throw new Error(["MUI X: The `usePickerActionsContext` can only be called in fields that are used as a slot of a Picker component"].join("\n"));
  }
  return value;
};
const useDefaultDates = () => useLocalizationContext().defaultDates;
const useNow = (timezone) => {
  const adapter = usePickerAdapter();
  const now2 = reactExports.useRef(void 0);
  if (now2.current === void 0) {
    now2.current = adapter.date(void 0, timezone);
  }
  return now2.current;
};
const ArrowDropDownIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
const ArrowLeftIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft");
const ArrowRightIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight");
const CalendarIcon$1 = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
  children: [/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock");
createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
  children: [/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time");
const ClearIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
function getPickersArrowSwitcherUtilityClass(slot) {
  return generateUtilityClass("MuiPickersArrowSwitcher", slot);
}
generateUtilityClasses("MuiPickersArrowSwitcher", ["root", "spacer", "button", "previousIconButton", "nextIconButton", "leftArrowIcon", "rightArrowIcon"]);
const usePickerPrivateContext = () => reactExports.useContext(PickerPrivateContext);
const _excluded$u = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel", "labelId", "classes"], _excluded2$6 = ["ownerState"], _excluded3$1 = ["ownerState"];
const PickersArrowSwitcherRoot = styled("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root"
})({
  display: "flex"
});
const PickersArrowSwitcherSpacer = styled("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer"
})(({
  theme
}) => ({
  width: theme.spacing(3)
}));
const PickersArrowSwitcherButton = styled(IconButton, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button"
})({
  variants: [{
    props: {
      isButtonHidden: true
    },
    style: {
      visibility: "hidden"
    }
  }]
});
const useUtilityClasses$l = (classes) => {
  const slots = {
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"],
    previousIconButton: ["previousIconButton"],
    nextIconButton: ["nextIconButton"],
    leftArrowIcon: ["leftArrowIcon"],
    rightArrowIcon: ["rightArrowIcon"]
  };
  return composeClasses(slots, getPickersArrowSwitcherUtilityClass, classes);
};
const PickersArrowSwitcher = /* @__PURE__ */ reactExports.forwardRef(function PickersArrowSwitcher2(inProps, ref2) {
  const isRtl = useRtl();
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersArrowSwitcher"
  });
  const {
    children,
    className,
    slots,
    slotProps,
    isNextDisabled,
    isNextHidden,
    onGoToNext,
    nextLabel,
    isPreviousDisabled,
    isPreviousHidden,
    onGoToPrevious,
    previousLabel,
    labelId,
    classes: classesProp
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$u);
  const {
    ownerState
  } = usePickerPrivateContext();
  const classes = useUtilityClasses$l(classesProp);
  const nextProps = {
    isDisabled: isNextDisabled,
    isHidden: isNextHidden,
    goTo: onGoToNext,
    label: nextLabel
  };
  const previousProps = {
    isDisabled: isPreviousDisabled,
    isHidden: isPreviousHidden,
    goTo: onGoToPrevious,
    label: previousLabel
  };
  const PreviousIconButton = slots?.previousIconButton ?? PickersArrowSwitcherButton;
  const previousIconButtonProps = useSlotProps({
    elementType: PreviousIconButton,
    externalSlotProps: slotProps?.previousIconButton,
    additionalProps: {
      size: "medium",
      title: previousProps.label,
      "aria-label": previousProps.label,
      disabled: previousProps.isDisabled,
      edge: "end",
      onClick: previousProps.goTo
    },
    ownerState: _extends({}, ownerState, {
      isButtonHidden: previousProps.isHidden ?? false
    }),
    className: clsx(classes.button, classes.previousIconButton)
  });
  const NextIconButton = slots?.nextIconButton ?? PickersArrowSwitcherButton;
  const nextIconButtonProps = useSlotProps({
    elementType: NextIconButton,
    externalSlotProps: slotProps?.nextIconButton,
    additionalProps: {
      size: "medium",
      title: nextProps.label,
      "aria-label": nextProps.label,
      disabled: nextProps.isDisabled,
      edge: "start",
      onClick: nextProps.goTo
    },
    ownerState: _extends({}, ownerState, {
      isButtonHidden: nextProps.isHidden ?? false
    }),
    className: clsx(classes.button, classes.nextIconButton)
  });
  const LeftArrowIcon = slots?.leftArrowIcon ?? ArrowLeftIcon;
  const _useSlotProps = useSlotProps({
    elementType: LeftArrowIcon,
    externalSlotProps: slotProps?.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState,
    className: classes.leftArrowIcon
  }), leftArrowIconProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded2$6);
  const RightArrowIcon = slots?.rightArrowIcon ?? ArrowRightIcon;
  const _useSlotProps2 = useSlotProps({
    elementType: RightArrowIcon,
    externalSlotProps: slotProps?.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState,
    className: classes.rightArrowIcon
  }), rightArrowIconProps = _objectWithoutPropertiesLoose(_useSlotProps2, _excluded3$1);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersArrowSwitcherRoot, _extends({
    ref: ref2,
    className: clsx(classes.root, className),
    ownerState
  }, other, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(PreviousIconButton, _extends({}, previousIconButtonProps, {
      children: isRtl ? /* @__PURE__ */ jsxRuntimeExports.jsx(RightArrowIcon, _extends({}, rightArrowIconProps)) : /* @__PURE__ */ jsxRuntimeExports.jsx(LeftArrowIcon, _extends({}, leftArrowIconProps))
    })), children ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, {
      variant: "subtitle1",
      component: "span",
      id: labelId,
      children
    }) : /* @__PURE__ */ jsxRuntimeExports.jsx(PickersArrowSwitcherSpacer, {
      className: classes.spacer,
      ownerState
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(NextIconButton, _extends({}, nextIconButtonProps, {
      children: isRtl ? /* @__PURE__ */ jsxRuntimeExports.jsx(LeftArrowIcon, _extends({}, leftArrowIconProps)) : /* @__PURE__ */ jsxRuntimeExports.jsx(RightArrowIcon, _extends({}, rightArrowIconProps))
    }))]
  }));
});
if (process.env.NODE_ENV !== "production") PickersArrowSwitcher.displayName = "PickersArrowSwitcher";
const DEFAULT_STEP_NAVIGATION = {
  hasNextStep: false,
  hasSeveralSteps: false,
  goToNextStep: () => {
  },
  areViewsInSameStep: () => true
};
function createStepNavigation(parameters) {
  const {
    steps,
    isViewMatchingStep,
    onStepChange
  } = parameters;
  return (parametersBis) => {
    if (steps == null) {
      return DEFAULT_STEP_NAVIGATION;
    }
    const currentStepIndex = steps.findIndex((step) => isViewMatchingStep(parametersBis.view, step));
    const nextStep = currentStepIndex === -1 || currentStepIndex === steps.length - 1 ? null : steps[currentStepIndex + 1];
    return {
      hasNextStep: nextStep != null,
      hasSeveralSteps: steps.length > 1,
      goToNextStep: () => {
        if (nextStep == null) {
          return;
        }
        onStepChange(_extends({}, parametersBis, {
          step: nextStep
        }));
      },
      areViewsInSameStep: (viewA, viewB) => {
        const stepA = steps.find((step) => isViewMatchingStep(viewA, step));
        const stepB = steps.find((step) => isViewMatchingStep(viewB, step));
        return stepA === stepB;
      }
    };
  };
}
let warnedOnceNotValidView = false;
function useViews({
  onChange,
  onViewChange,
  openTo,
  view: inView,
  views,
  autoFocus,
  focusedView: inFocusedView,
  onFocusedViewChange,
  getStepNavigation
}) {
  if (process.env.NODE_ENV !== "production") {
    if (!warnedOnceNotValidView) {
      if (inView != null && !views.includes(inView)) {
        console.warn(`MUI X: \`view="${inView}"\` is not a valid prop.`, `It must be an element of \`views=["${views.join('", "')}"]\`.`);
        warnedOnceNotValidView = true;
      }
      if (inView == null && openTo != null && !views.includes(openTo)) {
        console.warn(`MUI X: \`openTo="${openTo}"\` is not a valid prop.`, `It must be an element of \`views=["${views.join('", "')}"]\`.`);
        warnedOnceNotValidView = true;
      }
    }
  }
  const previousOpenTo = reactExports.useRef(openTo);
  const previousViews = reactExports.useRef(views);
  const defaultView = reactExports.useRef(views.includes(openTo) ? openTo : views[0]);
  const [view, setView] = useControlled({
    name: "useViews",
    state: "view",
    controlled: inView,
    default: defaultView.current
  });
  const defaultFocusedView = reactExports.useRef(autoFocus ? view : null);
  const [focusedView, setFocusedView] = useControlled({
    name: "useViews",
    state: "focusedView",
    controlled: inFocusedView,
    default: defaultFocusedView.current
  });
  const stepNavigation = getStepNavigation ? getStepNavigation({
    setView,
    view,
    defaultView: defaultView.current,
    views
  }) : DEFAULT_STEP_NAVIGATION;
  reactExports.useEffect(() => {
    if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView2) => !views.includes(previousView2))) {
      setView(views.includes(openTo) ? openTo : views[0]);
      previousViews.current = views;
      previousOpenTo.current = openTo;
    }
  }, [openTo, setView, view, views]);
  const viewIndex = views.indexOf(view);
  const previousView = views[viewIndex - 1] ?? null;
  const nextView = views[viewIndex + 1] ?? null;
  const handleFocusedViewChange = useEventCallback((viewToFocus, hasFocus) => {
    if (hasFocus) {
      setFocusedView(viewToFocus);
    } else {
      setFocusedView(
        (prevFocusedView) => viewToFocus === prevFocusedView ? null : prevFocusedView
        // If false the blur is due to view switching
      );
    }
    onFocusedViewChange?.(viewToFocus, hasFocus);
  });
  const handleChangeView = useEventCallback((newView) => {
    handleFocusedViewChange(newView, true);
    if (newView === view) {
      return;
    }
    setView(newView);
    if (onViewChange) {
      onViewChange(newView);
    }
  });
  const goToNextView = useEventCallback(() => {
    if (nextView) {
      handleChangeView(nextView);
    }
  });
  const setValueAndGoToNextView = useEventCallback((value, currentViewSelectionState, selectedView) => {
    const isSelectionFinishedOnCurrentView = currentViewSelectionState === "finish";
    const hasMoreViews = selectedView ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but when it's not the final view given all `views` -> overall selection state should be `partial`.
      views.indexOf(selectedView) < views.length - 1
    ) : Boolean(nextView);
    const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? "partial" : currentViewSelectionState;
    onChange(value, globalSelectionState, selectedView);
    let currentView = null;
    if (selectedView != null && selectedView !== view) {
      currentView = selectedView;
    } else if (isSelectionFinishedOnCurrentView) {
      currentView = view;
    }
    if (currentView == null) {
      return;
    }
    const viewToNavigateTo = views[views.indexOf(currentView) + 1];
    if (viewToNavigateTo == null || !stepNavigation.areViewsInSameStep(currentView, viewToNavigateTo)) {
      return;
    }
    handleChangeView(viewToNavigateTo);
  });
  return _extends({}, stepNavigation, {
    view,
    setView: handleChangeView,
    focusedView,
    setFocusedView: handleFocusedViewChange,
    nextView,
    previousView,
    // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
    defaultView: views.includes(openTo) ? openTo : views[0],
    goToNextView,
    setValueAndGoToNextView
  });
}
function useNextMonthDisabled(month, {
  disableFuture,
  maxDate,
  timezone
}) {
  const adapter = usePickerAdapter();
  return reactExports.useMemo(() => {
    const now2 = adapter.date(void 0, timezone);
    const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now2, maxDate) ? now2 : maxDate);
    return !adapter.isAfter(lastEnabledMonth, month);
  }, [disableFuture, maxDate, month, adapter, timezone]);
}
function usePreviousMonthDisabled(month, {
  disablePast,
  minDate,
  timezone
}) {
  const adapter = usePickerAdapter();
  return reactExports.useMemo(() => {
    const now2 = adapter.date(void 0, timezone);
    const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now2, minDate) ? now2 : minDate);
    return !adapter.isBefore(firstEnabledMonth, month);
  }, [disablePast, minDate, month, adapter, timezone]);
}
const DAY_SIZE = 36;
const DAY_MARGIN = 2;
const DIALOG_WIDTH = 320;
const MAX_CALENDAR_HEIGHT = 280;
const VIEW_HEIGHT = 336;
const PickerViewRoot = styled("div", {
  slot: "internal",
  shouldForwardProp: void 0
})({
  overflow: "hidden",
  width: DIALOG_WIDTH,
  maxHeight: VIEW_HEIGHT,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
});
const useControlledValue = ({
  name,
  timezone: timezoneProp,
  value: valueProp,
  defaultValue,
  referenceDate,
  onChange: onChangeProp,
  valueManager
}) => {
  const adapter = usePickerAdapter();
  const [valueWithInputTimezone, setValue] = useControlled({
    name,
    state: "value",
    controlled: valueProp,
    default: defaultValue ?? valueManager.emptyValue
  });
  const inputTimezone = reactExports.useMemo(() => valueManager.getTimezone(adapter, valueWithInputTimezone), [adapter, valueManager, valueWithInputTimezone]);
  const setInputTimezone = useEventCallback((newValue) => {
    if (inputTimezone == null) {
      return newValue;
    }
    return valueManager.setTimezone(adapter, inputTimezone, newValue);
  });
  const timezoneToRender = reactExports.useMemo(() => {
    if (timezoneProp) {
      return timezoneProp;
    }
    if (inputTimezone) {
      return inputTimezone;
    }
    if (referenceDate) {
      return adapter.getTimezone(Array.isArray(referenceDate) ? referenceDate[0] : referenceDate);
    }
    return "default";
  }, [timezoneProp, inputTimezone, referenceDate, adapter]);
  const valueWithTimezoneToRender = reactExports.useMemo(() => valueManager.setTimezone(adapter, timezoneToRender, valueWithInputTimezone), [valueManager, adapter, timezoneToRender, valueWithInputTimezone]);
  const handleValueChange = useEventCallback((newValue, ...otherParams) => {
    const newValueWithInputTimezone = setInputTimezone(newValue);
    setValue(newValueWithInputTimezone);
    onChangeProp?.(newValueWithInputTimezone, ...otherParams);
  });
  return {
    value: valueWithTimezoneToRender,
    handleValueChange,
    timezone: timezoneToRender
  };
};
const SECTION_TYPE_GRANULARITY = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
};
const getSectionTypeGranularity = (sections) => Math.max(...sections.map((section) => SECTION_TYPE_GRANULARITY[section.type] ?? 1));
const roundDate = (adapter, granularity, date) => {
  if (granularity === SECTION_TYPE_GRANULARITY.year) {
    return adapter.startOfYear(date);
  }
  if (granularity === SECTION_TYPE_GRANULARITY.month) {
    return adapter.startOfMonth(date);
  }
  if (granularity === SECTION_TYPE_GRANULARITY.day) {
    return adapter.startOfDay(date);
  }
  let roundedDate = date;
  if (granularity < SECTION_TYPE_GRANULARITY.minutes) {
    roundedDate = adapter.setMinutes(roundedDate, 0);
  }
  if (granularity < SECTION_TYPE_GRANULARITY.seconds) {
    roundedDate = adapter.setSeconds(roundedDate, 0);
  }
  if (granularity < SECTION_TYPE_GRANULARITY.milliseconds) {
    roundedDate = adapter.setMilliseconds(roundedDate, 0);
  }
  return roundedDate;
};
const getDefaultReferenceDate = ({
  props,
  adapter,
  granularity,
  timezone,
  getTodayDate: inGetTodayDate
}) => {
  let referenceDate = inGetTodayDate ? inGetTodayDate() : roundDate(adapter, granularity, getTodayDate(adapter, timezone));
  if (props.minDate != null && adapter.isAfterDay(props.minDate, referenceDate)) {
    referenceDate = roundDate(adapter, granularity, props.minDate);
  }
  if (props.maxDate != null && adapter.isBeforeDay(props.maxDate, referenceDate)) {
    referenceDate = roundDate(adapter, granularity, props.maxDate);
  }
  const isAfter = createIsAfterIgnoreDatePart(props.disableIgnoringDatePartForTimeValidation ?? false, adapter);
  if (props.minTime != null && isAfter(props.minTime, referenceDate)) {
    referenceDate = roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : mergeDateAndTime(adapter, referenceDate, props.minTime));
  }
  if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) {
    referenceDate = roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : mergeDateAndTime(adapter, referenceDate, props.maxTime));
  }
  return referenceDate;
};
const _excluded$t = ["value", "referenceDate"];
const singleItemValueManager = {
  emptyValue: null,
  getTodayValue: getTodayDate,
  getInitialReferenceValue: (_ref) => {
    let {
      value,
      referenceDate
    } = _ref, params = _objectWithoutPropertiesLoose(_ref, _excluded$t);
    if (params.adapter.isValid(value)) {
      return value;
    }
    if (referenceDate != null) {
      return referenceDate;
    }
    return getDefaultReferenceDate(params);
  },
  cleanValue: replaceInvalidDateByNull,
  areValuesEqual: areDatesEqual,
  isSameError: (a, b) => a === b,
  hasError: (error) => error != null,
  defaultErrorState: null,
  getTimezone: (adapter, value) => adapter.isValid(value) ? adapter.getTimezone(value) : null,
  setTimezone: (adapter, timezone, value) => value == null ? null : adapter.setTimezone(value, timezone)
};
const singleItemFieldValueManager = {
  updateReferenceValue: (adapter, value, prevReferenceValue) => adapter.isValid(value) ? value : prevReferenceValue,
  getSectionsFromValue: (date, getSectionsFromDate) => getSectionsFromDate(date),
  getV7HiddenInputValueFromSections: createDateStrForV7HiddenInputFromSections,
  getV6InputValueFromSections: createDateStrForV6InputFromSections,
  parseValueStr: (valueStr, referenceValue, parseDate2) => parseDate2(valueStr.trim(), referenceValue),
  getDateFromSection: (value) => value,
  getDateSectionsFromValue: (sections) => sections,
  updateDateInValue: (value, activeSection, activeDate) => activeDate,
  clearDateSections: (sections) => sections.map((section) => _extends({}, section, {
    value: ""
  }))
};
function arrayIncludes(array, itemOrItems) {
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every((item) => array.indexOf(item) !== -1);
  }
  return array.indexOf(itemOrItems) !== -1;
}
const executeInTheNextEventLoopTick = (fn3) => {
  setTimeout(fn3, 0);
};
const getActiveElementInternal = (root2 = document) => {
  const activeEl = root2.activeElement;
  if (!activeEl) {
    return null;
  }
  if (activeEl.shadowRoot) {
    return getActiveElementInternal(activeEl.shadowRoot);
  }
  return activeEl;
};
const getActiveElement = (node2) => {
  return getActiveElementInternal(ownerDocument(node2));
};
const DEFAULT_DESKTOP_MODE_MEDIA_QUERY = "@media (pointer: fine)";
function getPickersDayUtilityClass(slot) {
  return generateUtilityClass("MuiPickersDay", slot);
}
const pickersDayClasses = generateUtilityClasses("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]);
function usePickerDayOwnerState(parameters) {
  const {
    disabled,
    selected,
    today: today2,
    outsideCurrentMonth,
    day,
    disableMargin,
    disableHighlightToday,
    showDaysOutsideCurrentMonth
  } = parameters;
  const adapter = usePickerAdapter();
  const {
    ownerState: pickerOwnerState
  } = usePickerPrivateContext();
  return reactExports.useMemo(() => _extends({}, pickerOwnerState, {
    day,
    isDaySelected: selected ?? false,
    isDayDisabled: disabled ?? false,
    isDayCurrent: today2 ?? false,
    isDayOutsideMonth: outsideCurrentMonth ?? false,
    isDayStartOfWeek: adapter.isSameDay(day, adapter.startOfWeek(day)),
    isDayEndOfWeek: adapter.isSameDay(day, adapter.endOfWeek(day)),
    disableMargin: disableMargin ?? false,
    disableHighlightToday: disableHighlightToday ?? false,
    showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth ?? false
  }), [adapter, pickerOwnerState, day, selected, disabled, today2, outsideCurrentMonth, disableMargin, disableHighlightToday, showDaysOutsideCurrentMonth]);
}
const _excluded$s = ["autoFocus", "className", "classes", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "children", "isFirstVisibleCell", "isLastVisibleCell", "day", "selected", "disabled", "today", "outsideCurrentMonth", "disableMargin", "disableHighlightToday", "showDaysOutsideCurrentMonth"];
const useUtilityClasses$k = (classes, ownerState) => {
  const {
    isDaySelected,
    isDayDisabled,
    isDayCurrent,
    isDayOutsideMonth,
    disableMargin,
    disableHighlightToday,
    showDaysOutsideCurrentMonth
  } = ownerState;
  const isHiddenDaySpacingFiller = isDayOutsideMonth && !showDaysOutsideCurrentMonth;
  const slots = {
    root: ["root", isDaySelected && !isHiddenDaySpacingFiller && "selected", isDayDisabled && "disabled", !disableMargin && "dayWithMargin", !disableHighlightToday && isDayCurrent && "today", isDayOutsideMonth && showDaysOutsideCurrentMonth && "dayOutsideMonth", isHiddenDaySpacingFiller && "hiddenDaySpacingFiller"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  };
  return composeClasses(slots, getPickersDayUtilityClass, classes);
};
const styleArg = ({
  theme
}) => _extends({}, theme.typography.caption, {
  display: "flex",
  lineHeight: 1,
  width: DAY_SIZE,
  height: DAY_SIZE,
  borderRadius: "50%",
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: "transparent",
  transition: theme.transitions.create("background-color", {
    duration: theme.transitions.duration.short
  }),
  color: (theme.vars || theme).palette.text.primary,
  "@media (pointer: fine)": {
    "&:hover": {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity)
    }
  },
  "&:focus": {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
    [`&.${pickersDayClasses.selected}`]: {
      willChange: "background-color",
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    "&:hover": {
      willChange: "background-color",
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.disabled}:not(.${pickersDayClasses.selected})`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${pickersDayClasses.disabled}&.${pickersDayClasses.selected}`]: {
    opacity: 0.6
  },
  variants: [{
    props: {
      disableMargin: false
    },
    style: {
      margin: `0 ${DAY_MARGIN}px`
    }
  }, {
    props: {
      isDayOutsideMonth: true,
      showDaysOutsideCurrentMonth: true
    },
    style: {
      color: (theme.vars || theme).palette.text.secondary
    }
  }, {
    props: {
      disableHighlightToday: false,
      isDayCurrent: true
    },
    style: {
      [`&:not(.${pickersDayClasses.selected})`]: {
        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
      }
    }
  }]
});
const overridesResolver = (props, styles2) => {
  const {
    ownerState
  } = props;
  return [styles2.root, !ownerState.disableMargin && styles2.dayWithMargin, !ownerState.disableHighlightToday && ownerState.isDayCurrent && styles2.today, ownerState.isDayOutsideMonth && ownerState.showDaysOutsideCurrentMonth && styles2.dayOutsideMonth, ownerState.isDayOutsideMonth && !ownerState.showDaysOutsideCurrentMonth && styles2.hiddenDaySpacingFiller];
};
const PickersDayRoot = styled(ButtonBase, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver
})(styleArg);
const PickersDayFiller = styled("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver
})(({
  theme
}) => _extends({}, styleArg({
  theme
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: "none"
}));
const noop$2 = () => {
};
const PickersDayRaw = /* @__PURE__ */ reactExports.forwardRef(function PickersDay(inProps, forwardedRef) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersDay"
  });
  const {
    autoFocus = false,
    className,
    classes: classesProp,
    isAnimating,
    onClick,
    onDaySelect,
    onFocus = noop$2,
    onBlur = noop$2,
    onKeyDown = noop$2,
    onMouseDown = noop$2,
    onMouseEnter = noop$2,
    children,
    day,
    selected,
    disabled,
    today: today2,
    outsideCurrentMonth,
    disableMargin,
    disableHighlightToday,
    showDaysOutsideCurrentMonth
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$s);
  const ownerState = usePickerDayOwnerState({
    day,
    selected,
    disabled,
    today: today2,
    outsideCurrentMonth,
    disableMargin,
    disableHighlightToday,
    showDaysOutsideCurrentMonth
  });
  const classes = useUtilityClasses$k(classesProp, ownerState);
  const adapter = usePickerAdapter();
  const ref2 = reactExports.useRef(null);
  const handleRef = useForkRef(ref2, forwardedRef);
  useEnhancedEffect(() => {
    if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) {
      ref2.current.focus();
    }
  }, [autoFocus, disabled, isAnimating, outsideCurrentMonth]);
  const handleMouseDown = (event2) => {
    onMouseDown(event2);
    if (outsideCurrentMonth) {
      event2.preventDefault();
    }
  };
  const handleClick = (event2) => {
    event2.defaultMuiPrevented = true;
    if (!disabled) {
      onDaySelect(day);
    }
    if (outsideCurrentMonth) {
      event2.currentTarget.focus();
    }
    if (onClick) {
      onClick(event2);
    }
  };
  if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersDayFiller, {
      className: clsx(classes.root, classes.hiddenDaySpacingFiller, className),
      ownerState,
      role: other.role
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersDayRoot, _extends({
    className: clsx(classes.root, className),
    ref: handleRef,
    centerRipple: true,
    disabled,
    tabIndex: selected ? 0 : -1,
    onKeyDown: (event2) => onKeyDown(event2, day),
    onFocus: (event2) => onFocus(event2, day),
    onBlur: (event2) => onBlur(event2, day),
    onMouseEnter: (event2) => onMouseEnter(event2, day),
    onClick: handleClick,
    onMouseDown: handleMouseDown
  }, other, {
    ownerState,
    children: children ?? adapter.format(day, "dayOfMonth")
  }));
});
if (process.env.NODE_ENV !== "production") PickersDayRaw.displayName = "PickersDayRaw";
process.env.NODE_ENV !== "production" ? PickersDayRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focusVisible: PropTypes.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * The date to show.
   */
  day: PropTypes.object.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  isAnimating: PropTypes.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: PropTypes.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: PropTypes.bool.isRequired,
  onBlur: PropTypes.func,
  onDaySelect: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: PropTypes.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: PropTypes.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })])
} : void 0;
const PickersDay2 = /* @__PURE__ */ reactExports.memo(PickersDayRaw);
if (process.env.NODE_ENV !== "production") PickersDay2.displayName = "PickersDay";
const isQueryResponseWithoutValue = (response) => response.saveQuery != null;
const useFieldCharacterEditing = ({
  stateResponse: {
    // States and derived states
    localizedDigits,
    sectionsValueBoundaries,
    state,
    timezone,
    // Methods to update the states
    setCharacterQuery,
    setTempAndroidValueStr,
    updateSectionValue
  }
}) => {
  const adapter = usePickerAdapter();
  const applyQuery = ({
    keyPressed,
    sectionIndex
  }, getFirstSectionValueMatchingWithQuery, isValidQueryValue) => {
    const cleanKeyPressed = keyPressed.toLowerCase();
    const activeSection = state.sections[sectionIndex];
    if (state.characterQuery != null && (!isValidQueryValue || isValidQueryValue(state.characterQuery.value)) && state.characterQuery.sectionIndex === sectionIndex) {
      const concatenatedQueryValue = `${state.characterQuery.value}${cleanKeyPressed}`;
      const queryResponse2 = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
      if (!isQueryResponseWithoutValue(queryResponse2)) {
        setCharacterQuery({
          sectionIndex,
          value: concatenatedQueryValue,
          sectionType: activeSection.type
        });
        return queryResponse2;
      }
    }
    const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
    if (isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
      setCharacterQuery(null);
      return null;
    }
    setCharacterQuery({
      sectionIndex,
      value: cleanKeyPressed,
      sectionType: activeSection.type
    });
    if (isQueryResponseWithoutValue(queryResponse)) {
      return null;
    }
    return queryResponse;
  };
  const applyLetterEditing = (params) => {
    const findMatchingOptions = (format2, options, queryValue) => {
      const matchingValues = options.filter((option) => option.toLowerCase().startsWith(queryValue));
      if (matchingValues.length === 0) {
        return {
          saveQuery: false
        };
      }
      return {
        sectionValue: matchingValues[0],
        shouldGoToNextSection: matchingValues.length === 1
      };
    };
    const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue) => {
      const getOptions = (format2) => getLetterEditingOptions(adapter, timezone, activeSection.type, format2);
      if (activeSection.contentType === "letter") {
        return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
      }
      if (fallbackFormat && formatFallbackValue != null && getDateSectionConfigFromFormatToken(adapter, fallbackFormat).contentType === "letter") {
        const fallbackOptions = getOptions(fallbackFormat);
        const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
        if (isQueryResponseWithoutValue(response)) {
          return {
            saveQuery: false
          };
        }
        return _extends({}, response, {
          sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
        });
      }
      return {
        saveQuery: false
      };
    };
    const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection) => {
      switch (activeSection.type) {
        case "month": {
          const formatFallbackValue = (fallbackValue) => changeSectionValueFormat(adapter, fallbackValue, adapter.formats.month, activeSection.format);
          return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.month, formatFallbackValue);
        }
        case "weekDay": {
          const formatFallbackValue = (fallbackValue, fallbackOptions) => fallbackOptions.indexOf(fallbackValue).toString();
          return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.weekday, formatFallbackValue);
        }
        case "meridiem": {
          return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
        }
        default: {
          return {
            saveQuery: false
          };
        }
      }
    };
    return applyQuery(params, getFirstSectionValueMatchingWithQuery);
  };
  const applyNumericEditing = (params) => {
    const getNewSectionValue = ({
      queryValue,
      skipIfBelowMinimum,
      section
    }) => {
      const cleanQueryValue = removeLocalizedDigits(queryValue, localizedDigits);
      const queryValueNumber = Number(cleanQueryValue);
      const sectionBoundaries = sectionsValueBoundaries[section.type]({
        currentDate: null,
        format: section.format,
        contentType: section.contentType
      });
      if (queryValueNumber > sectionBoundaries.maximum) {
        return {
          saveQuery: false
        };
      }
      if (skipIfBelowMinimum && queryValueNumber < sectionBoundaries.minimum) {
        return {
          saveQuery: true
        };
      }
      const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
      const newSectionValue = cleanDigitSectionValue(adapter, queryValueNumber, sectionBoundaries, localizedDigits, section);
      return {
        sectionValue: newSectionValue,
        shouldGoToNextSection
      };
    };
    const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection) => {
      if (activeSection.contentType === "digit" || activeSection.contentType === "digit-with-letter") {
        return getNewSectionValue({
          queryValue,
          skipIfBelowMinimum: false,
          section: activeSection
        });
      }
      if (activeSection.type === "month") {
        doesSectionFormatHaveLeadingZeros(adapter, "digit", "month", "MM");
        const response = getNewSectionValue({
          queryValue,
          skipIfBelowMinimum: true,
          section: {
            type: activeSection.type,
            format: "MM",
            hasLeadingZerosInInput: true,
            contentType: "digit",
            maxLength: 2
          }
        });
        if (isQueryResponseWithoutValue(response)) {
          return response;
        }
        const formattedValue = changeSectionValueFormat(adapter, response.sectionValue, "MM", activeSection.format);
        return _extends({}, response, {
          sectionValue: formattedValue
        });
      }
      if (activeSection.type === "weekDay") {
        const response = getNewSectionValue({
          queryValue,
          skipIfBelowMinimum: true,
          section: activeSection
        });
        if (isQueryResponseWithoutValue(response)) {
          return response;
        }
        const formattedValue = getDaysInWeekStr(adapter, activeSection.format)[Number(response.sectionValue) - 1];
        return _extends({}, response, {
          sectionValue: formattedValue
        });
      }
      return {
        saveQuery: false
      };
    };
    return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue) => isStringNumber(queryValue, localizedDigits));
  };
  return useEventCallback((params) => {
    const section = state.sections[params.sectionIndex];
    const isNumericEditing = isStringNumber(params.keyPressed, localizedDigits);
    const response = isNumericEditing ? applyNumericEditing(_extends({}, params, {
      keyPressed: applyLocalizedDigits(params.keyPressed, localizedDigits)
    })) : applyLetterEditing(params);
    if (response == null) {
      setTempAndroidValueStr(null);
      return;
    }
    updateSectionValue({
      section,
      newSectionValue: response.sectionValue,
      shouldGoToNextSection: response.shouldGoToNextSection
    });
  });
};
const validateDate = ({
  props,
  value,
  timezone,
  adapter
}) => {
  if (value === null) {
    return null;
  }
  const {
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    disablePast,
    disableFuture,
    minDate,
    maxDate
  } = props;
  const now2 = adapter.date(void 0, timezone);
  switch (true) {
    case !adapter.isValid(value):
      return "invalidDate";
    case Boolean(shouldDisableDate && shouldDisableDate(value)):
      return "shouldDisableDate";
    case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
      return "shouldDisableMonth";
    case Boolean(shouldDisableYear && shouldDisableYear(value)):
      return "shouldDisableYear";
    case Boolean(disableFuture && adapter.isAfterDay(value, now2)):
      return "disableFuture";
    case Boolean(disablePast && adapter.isBeforeDay(value, now2)):
      return "disablePast";
    case Boolean(minDate && adapter.isBeforeDay(value, minDate)):
      return "minDate";
    case Boolean(maxDate && adapter.isAfterDay(value, maxDate)):
      return "maxDate";
    default:
      return null;
  }
};
validateDate.valueManager = singleItemValueManager;
function useValidation(options) {
  const {
    props,
    validator: validator2,
    value,
    timezone,
    onError
  } = options;
  const adapter = usePickerAdapter();
  const previousValidationErrorRef = reactExports.useRef(validator2.valueManager.defaultErrorState);
  const validationError = validator2({
    adapter,
    value,
    timezone,
    props
  });
  const hasValidationError = validator2.valueManager.hasError(validationError);
  reactExports.useEffect(() => {
    if (onError && !validator2.valueManager.isSameError(validationError, previousValidationErrorRef.current)) {
      onError(validationError, value);
    }
    previousValidationErrorRef.current = validationError;
  }, [validator2, onError, validationError, value]);
  const getValidationErrorForNewValue = useEventCallback((newValue) => {
    return validator2({
      adapter,
      value: newValue,
      timezone,
      props
    });
  });
  return {
    validationError,
    hasValidationError,
    getValidationErrorForNewValue
  };
}
const QUERY_LIFE_DURATION_MS = 5e3;
const useFieldState = (parameters) => {
  const adapter = usePickerAdapter();
  const translations = usePickerTranslations();
  const isRtl = useRtl();
  const {
    manager: {
      validator: validator2,
      valueType,
      internal_valueManager: valueManager,
      internal_fieldValueManager: fieldValueManager
    },
    internalPropsWithDefaults,
    internalPropsWithDefaults: {
      value: valueProp,
      defaultValue,
      referenceDate: referenceDateProp,
      onChange,
      format: format2,
      formatDensity = "dense",
      selectedSections: selectedSectionsProp,
      onSelectedSectionsChange,
      shouldRespectLeadingZeros = false,
      timezone: timezoneProp,
      enableAccessibleFieldDOMStructure = true
    },
    forwardedProps: {
      error: errorProp
    }
  } = parameters;
  const {
    value,
    handleValueChange,
    timezone
  } = useControlledValue({
    name: "a field component",
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    referenceDate: referenceDateProp,
    onChange,
    valueManager
  });
  const valueRef = reactExports.useRef(value);
  reactExports.useEffect(() => {
    valueRef.current = value;
  }, [value]);
  const {
    hasValidationError
  } = useValidation({
    props: internalPropsWithDefaults,
    validator: validator2,
    timezone,
    value,
    onError: internalPropsWithDefaults.onError
  });
  const localizedDigits = reactExports.useMemo(() => getLocalizedDigits(adapter), [adapter]);
  const sectionsValueBoundaries = reactExports.useMemo(() => getSectionsBoundaries(adapter, localizedDigits, timezone), [adapter, localizedDigits, timezone]);
  const getSectionsFromValue = reactExports.useCallback((valueToAnalyze) => fieldValueManager.getSectionsFromValue(valueToAnalyze, (date) => buildSectionsFromFormat({
    adapter,
    localeText: translations,
    localizedDigits,
    format: format2,
    date,
    formatDensity,
    shouldRespectLeadingZeros,
    enableAccessibleFieldDOMStructure,
    isRtl
  })), [fieldValueManager, format2, translations, localizedDigits, isRtl, shouldRespectLeadingZeros, adapter, formatDensity, enableAccessibleFieldDOMStructure]);
  const [state, setState] = reactExports.useState(() => {
    const sections = getSectionsFromValue(value);
    validateSections(sections, valueType);
    const stateWithoutReferenceDate = {
      sections,
      lastExternalValue: value,
      lastSectionsDependencies: {
        format: format2,
        isRtl,
        locale: adapter.locale
      },
      tempValueStrAndroid: null,
      characterQuery: null
    };
    const granularity = getSectionTypeGranularity(sections);
    const referenceValue = valueManager.getInitialReferenceValue({
      referenceDate: referenceDateProp,
      value,
      adapter,
      props: internalPropsWithDefaults,
      granularity,
      timezone
    });
    return _extends({}, stateWithoutReferenceDate, {
      referenceValue
    });
  });
  const [selectedSections, innerSetSelectedSections] = useControlled({
    controlled: selectedSectionsProp,
    default: null,
    name: "useField",
    state: "selectedSections"
  });
  const setSelectedSections = (newSelectedSections) => {
    innerSetSelectedSections(newSelectedSections);
    onSelectedSectionsChange?.(newSelectedSections);
  };
  const parsedSelectedSections = reactExports.useMemo(() => parseSelectedSections(selectedSections, state.sections), [selectedSections, state.sections]);
  const activeSectionIndex = parsedSelectedSections === "all" ? 0 : parsedSelectedSections;
  const sectionOrder = reactExports.useMemo(() => getSectionOrder(state.sections, isRtl && !enableAccessibleFieldDOMStructure), [state.sections, isRtl, enableAccessibleFieldDOMStructure]);
  const areAllSectionsEmpty = reactExports.useMemo(() => state.sections.every((section) => section.value === ""), [state.sections]);
  const hasPartiallyFilledSectionsOnBlur = reactExports.useMemo(() => {
    if (activeSectionIndex != null) {
      return false;
    }
    const filledSections = state.sections.filter((s12) => s12.value !== "");
    return filledSections.length > 0 && state.sections.length - filledSections.length > 0;
  }, [state.sections, activeSectionIndex]);
  const error = reactExports.useMemo(() => {
    if (errorProp !== void 0) {
      return errorProp;
    }
    return hasValidationError || hasPartiallyFilledSectionsOnBlur;
  }, [hasValidationError, hasPartiallyFilledSectionsOnBlur, errorProp]);
  const publishValue = (newValue) => {
    const context2 = {
      validationError: validator2({
        adapter,
        value: newValue,
        timezone,
        props: internalPropsWithDefaults
      })
    };
    handleValueChange(newValue, context2);
  };
  const setSectionValue = (sectionIndex, newSectionValue) => {
    const newSections = [...state.sections];
    newSections[sectionIndex] = _extends({}, newSections[sectionIndex], {
      value: newSectionValue,
      modified: true
    });
    return newSections;
  };
  const sectionToUpdateOnNextInvalidDateRef = reactExports.useRef(null);
  const updateSectionValueOnNextInvalidDateTimeout = useTimeout();
  const setSectionUpdateToApplyOnNextInvalidDate = (newSectionValue) => {
    if (activeSectionIndex == null) {
      return;
    }
    sectionToUpdateOnNextInvalidDateRef.current = {
      sectionIndex: activeSectionIndex,
      value: newSectionValue
    };
    updateSectionValueOnNextInvalidDateTimeout.start(0, () => {
      sectionToUpdateOnNextInvalidDateRef.current = null;
    });
  };
  const clearValue = () => {
    if (valueManager.areValuesEqual(adapter, value, valueManager.emptyValue)) {
      setState((prevState) => _extends({}, prevState, {
        sections: prevState.sections.map((section) => _extends({}, section, {
          value: ""
        })),
        tempValueStrAndroid: null,
        characterQuery: null
      }));
    } else {
      setState((prevState) => _extends({}, prevState, {
        characterQuery: null
      }));
      publishValue(valueManager.emptyValue);
    }
  };
  const clearActiveSection = () => {
    if (activeSectionIndex == null) {
      return;
    }
    const activeSection = state.sections[activeSectionIndex];
    if (activeSection.value === "") {
      return;
    }
    setSectionUpdateToApplyOnNextInvalidDate("");
    if (fieldValueManager.getDateFromSection(value, activeSection) === null) {
      setState((prevState) => _extends({}, prevState, {
        sections: setSectionValue(activeSectionIndex, ""),
        tempValueStrAndroid: null,
        characterQuery: null
      }));
    } else {
      setState((prevState) => _extends({}, prevState, {
        characterQuery: null
      }));
      publishValue(fieldValueManager.updateDateInValue(value, activeSection, null));
    }
  };
  const updateValueFromValueStr = (valueStr) => {
    const parseDateStr = (dateStr, referenceDate) => {
      const date = adapter.parse(dateStr, format2);
      if (!adapter.isValid(date)) {
        return null;
      }
      const sections = buildSectionsFromFormat({
        adapter,
        localeText: translations,
        localizedDigits,
        format: format2,
        date,
        formatDensity,
        shouldRespectLeadingZeros,
        enableAccessibleFieldDOMStructure,
        isRtl
      });
      return mergeDateIntoReferenceDate(adapter, date, sections, referenceDate, false);
    };
    const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
    publishValue(newValue);
  };
  const cleanActiveDateSectionsIfValueNullTimeout = useTimeout();
  const updateSectionValue = ({
    section,
    newSectionValue,
    shouldGoToNextSection
  }) => {
    updateSectionValueOnNextInvalidDateTimeout.clear();
    cleanActiveDateSectionsIfValueNullTimeout.clear();
    const activeDate = fieldValueManager.getDateFromSection(value, section);
    if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) {
      setSelectedSections(activeSectionIndex + 1);
    }
    const newSections = setSectionValue(activeSectionIndex, newSectionValue);
    const newActiveDateSections = fieldValueManager.getDateSectionsFromValue(newSections, section);
    const newActiveDate = getDateFromDateSections(adapter, newActiveDateSections, localizedDigits);
    if (adapter.isValid(newActiveDate)) {
      const mergedDate = mergeDateIntoReferenceDate(adapter, newActiveDate, newActiveDateSections, fieldValueManager.getDateFromSection(state.referenceValue, section), true);
      if (activeDate == null) {
        cleanActiveDateSectionsIfValueNullTimeout.start(0, () => {
          if (valueRef.current === value) {
            setState((prevState) => _extends({}, prevState, {
              sections: fieldValueManager.clearDateSections(state.sections, section),
              tempValueStrAndroid: null
            }));
          }
        });
      }
      return publishValue(fieldValueManager.updateDateInValue(value, section, mergedDate));
    }
    if (newActiveDateSections.every((sectionBis) => sectionBis.value !== "") && (activeDate == null || adapter.isValid(activeDate))) {
      setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
      return publishValue(fieldValueManager.updateDateInValue(value, section, newActiveDate));
    }
    if (activeDate != null) {
      setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
      publishValue(fieldValueManager.updateDateInValue(value, section, newActiveDate));
    }
    return setState((prevState) => _extends({}, prevState, {
      sections: newSections,
      tempValueStrAndroid: null
    }));
  };
  const setTempAndroidValueStr = (tempValueStrAndroid) => setState((prevState) => _extends({}, prevState, {
    tempValueStrAndroid
  }));
  const setCharacterQuery = useEventCallback((newCharacterQuery) => {
    setState((prevState) => _extends({}, prevState, {
      characterQuery: newCharacterQuery
    }));
  });
  if (value !== state.lastExternalValue) {
    const isActiveDateInvalid = sectionToUpdateOnNextInvalidDateRef.current != null && !adapter.isValid(fieldValueManager.getDateFromSection(value, state.sections[sectionToUpdateOnNextInvalidDateRef.current.sectionIndex]));
    let sections;
    if (isActiveDateInvalid) {
      sections = setSectionValue(sectionToUpdateOnNextInvalidDateRef.current.sectionIndex, sectionToUpdateOnNextInvalidDateRef.current.value);
    } else {
      sections = getSectionsFromValue(value);
    }
    setState((prevState) => _extends({}, prevState, {
      lastExternalValue: value,
      sections,
      sectionsDependencies: {
        format: format2,
        isRtl,
        locale: adapter.locale
      },
      referenceValue: isActiveDateInvalid ? prevState.referenceValue : fieldValueManager.updateReferenceValue(adapter, value, prevState.referenceValue),
      tempValueStrAndroid: null
    }));
  }
  if (isRtl !== state.lastSectionsDependencies.isRtl || format2 !== state.lastSectionsDependencies.format || adapter.locale !== state.lastSectionsDependencies.locale) {
    const sections = getSectionsFromValue(value);
    validateSections(sections, valueType);
    setState((prevState) => _extends({}, prevState, {
      lastSectionsDependencies: {
        format: format2,
        isRtl,
        locale: adapter.locale
      },
      sections,
      tempValueStrAndroid: null,
      characterQuery: null
    }));
  }
  if (state.characterQuery != null && !error && activeSectionIndex == null) {
    setCharacterQuery(null);
  }
  if (state.characterQuery != null && state.sections[state.characterQuery.sectionIndex]?.type !== state.characterQuery.sectionType) {
    setCharacterQuery(null);
  }
  reactExports.useEffect(() => {
    if (sectionToUpdateOnNextInvalidDateRef.current != null) {
      sectionToUpdateOnNextInvalidDateRef.current = null;
    }
  });
  const cleanCharacterQueryTimeout = useTimeout();
  reactExports.useEffect(() => {
    if (state.characterQuery != null) {
      cleanCharacterQueryTimeout.start(QUERY_LIFE_DURATION_MS, () => setCharacterQuery(null));
    }
    return () => {
    };
  }, [state.characterQuery, setCharacterQuery, cleanCharacterQueryTimeout]);
  reactExports.useEffect(() => {
    if (state.tempValueStrAndroid != null && activeSectionIndex != null) {
      clearActiveSection();
    }
  }, [state.sections]);
  return {
    // States and derived states
    activeSectionIndex,
    areAllSectionsEmpty,
    error,
    localizedDigits,
    parsedSelectedSections,
    sectionOrder,
    sectionsValueBoundaries,
    state,
    timezone,
    value,
    // Methods to update the states
    clearValue,
    clearActiveSection,
    setCharacterQuery,
    setSelectedSections,
    setTempAndroidValueStr,
    updateSectionValue,
    updateValueFromValueStr,
    // Utilities methods
    getSectionsFromValue
  };
};
function useFieldInternalPropsWithDefaults(parameters) {
  const {
    manager: {
      internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToFieldInternalProps
    },
    internalProps,
    skipContextFieldRefAssignment
  } = parameters;
  const pickerContext = useNullablePickerContext();
  const fieldPrivateContext = useNullableFieldPrivateContext();
  const handleFieldRef = useForkRef(internalProps.unstableFieldRef, skipContextFieldRefAssignment ? null : fieldPrivateContext?.fieldRef);
  const setValue = pickerContext?.setValue;
  const handleChangeFromPicker = reactExports.useCallback((newValue, ctx) => {
    return setValue?.(newValue, {
      validationError: ctx.validationError,
      shouldClose: false
    });
  }, [setValue]);
  const internalPropsWithDefaultsFromContext = reactExports.useMemo(() => {
    if (fieldPrivateContext != null && pickerContext != null) {
      return _extends({
        value: pickerContext.value,
        onChange: handleChangeFromPicker,
        timezone: pickerContext.timezone,
        disabled: pickerContext.disabled,
        readOnly: pickerContext.readOnly,
        autoFocus: pickerContext.autoFocus && !pickerContext.open,
        focused: pickerContext.open ? true : void 0,
        format: pickerContext.fieldFormat,
        formatDensity: fieldPrivateContext.formatDensity,
        enableAccessibleFieldDOMStructure: fieldPrivateContext.enableAccessibleFieldDOMStructure,
        selectedSections: fieldPrivateContext.selectedSections,
        onSelectedSectionsChange: fieldPrivateContext.onSelectedSectionsChange,
        unstableFieldRef: handleFieldRef
      }, internalProps);
    }
    return internalProps;
  }, [pickerContext, fieldPrivateContext, internalProps, handleChangeFromPicker, handleFieldRef]);
  return useApplyDefaultValuesToFieldInternalProps(internalPropsWithDefaultsFromContext);
}
function syncSelectionToDOM(parameters) {
  const {
    focused,
    domGetters,
    stateResponse: {
      // States and derived states
      parsedSelectedSections,
      state
    }
  } = parameters;
  if (!domGetters.isReady()) {
    return;
  }
  const selection = ownerDocument(domGetters.getRoot()).getSelection();
  if (!selection) {
    return;
  }
  if (parsedSelectedSections == null) {
    if (selection.rangeCount > 0 && // Firefox can return a Restricted object here
    selection.getRangeAt(0).startContainer instanceof Node && domGetters.getRoot().contains(selection.getRangeAt(0).startContainer)) {
      selection.removeAllRanges();
    }
    if (focused) {
      domGetters.getRoot().blur();
    }
    return;
  }
  if (!domGetters.getRoot().contains(getActiveElement(domGetters.getRoot()))) {
    return;
  }
  const range = new window.Range();
  let target;
  if (parsedSelectedSections === "all") {
    target = domGetters.getRoot();
  } else {
    const section = state.sections[parsedSelectedSections];
    if (section.type === "empty") {
      target = domGetters.getSectionContainer(parsedSelectedSections);
    } else {
      target = domGetters.getSectionContent(parsedSelectedSections);
    }
  }
  range.selectNodeContents(target);
  target.focus();
  selection.removeAllRanges();
  selection.addRange(range);
}
function useFieldRootHandleKeyDown(parameters) {
  const adapter = usePickerAdapter();
  const {
    manager: {
      internal_fieldValueManager: fieldValueManager
    },
    internalPropsWithDefaults: {
      minutesStep,
      disabled,
      readOnly
    },
    stateResponse: {
      // States and derived states
      state,
      value,
      activeSectionIndex,
      parsedSelectedSections,
      sectionsValueBoundaries,
      localizedDigits,
      timezone,
      sectionOrder,
      // Methods to update the states
      clearValue,
      clearActiveSection,
      setSelectedSections,
      updateSectionValue
    }
  } = parameters;
  return useEventCallback((event2) => {
    if (disabled) {
      return;
    }
    switch (true) {
      // Select all
      case ((event2.ctrlKey || event2.metaKey) && String.fromCharCode(event2.keyCode) === "A" && !event2.shiftKey && !event2.altKey): {
        event2.preventDefault();
        setSelectedSections("all");
        break;
      }
      // Move selection to next section
      case event2.key === "ArrowRight": {
        event2.preventDefault();
        if (parsedSelectedSections == null) {
          setSelectedSections(sectionOrder.startIndex);
        } else if (parsedSelectedSections === "all") {
          setSelectedSections(sectionOrder.endIndex);
        } else {
          const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
          if (nextSectionIndex !== null) {
            setSelectedSections(nextSectionIndex);
          }
        }
        break;
      }
      // Move selection to previous section
      case event2.key === "ArrowLeft": {
        event2.preventDefault();
        if (parsedSelectedSections == null) {
          setSelectedSections(sectionOrder.endIndex);
        } else if (parsedSelectedSections === "all") {
          setSelectedSections(sectionOrder.startIndex);
        } else {
          const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
          if (nextSectionIndex !== null) {
            setSelectedSections(nextSectionIndex);
          }
        }
        break;
      }
      // Reset the value of the selected section
      case event2.key === "Delete": {
        event2.preventDefault();
        if (readOnly) {
          break;
        }
        if (parsedSelectedSections == null || parsedSelectedSections === "all") {
          clearValue();
        } else {
          clearActiveSection();
        }
        break;
      }
      // Increment / decrement the selected section value
      case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(event2.key): {
        event2.preventDefault();
        if (readOnly || activeSectionIndex == null) {
          break;
        }
        if (parsedSelectedSections === "all") {
          setSelectedSections(activeSectionIndex);
        }
        const activeSection = state.sections[activeSectionIndex];
        const newSectionValue = adjustSectionValue(adapter, timezone, activeSection, event2.key, sectionsValueBoundaries, localizedDigits, fieldValueManager.getDateFromSection(value, activeSection), {
          minutesStep
        });
        updateSectionValue({
          section: activeSection,
          newSectionValue,
          shouldGoToNextSection: false
        });
        break;
      }
    }
  });
}
function getDeltaFromKeyCode(keyCode) {
  switch (keyCode) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}
function adjustSectionValue(adapter, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes) {
  const delta = getDeltaFromKeyCode(keyCode);
  const isStart = keyCode === "Home";
  const isEnd = keyCode === "End";
  const shouldSetAbsolute = section.value === "" || isStart || isEnd;
  const adjustDigitSection = () => {
    const sectionBoundaries = sectionsValueBoundaries[section.type]({
      currentDate: activeDate,
      format: section.format,
      contentType: section.contentType
    });
    const getCleanValue = (value) => cleanDigitSectionValue(adapter, value, sectionBoundaries, localizedDigits, section);
    const step = section.type === "minutes" && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
    let newSectionValueNumber;
    if (shouldSetAbsolute) {
      if (section.type === "year" && !isEnd && !isStart) {
        return adapter.formatByString(adapter.date(void 0, timezone), section.format);
      }
      if (delta > 0 || isStart) {
        newSectionValueNumber = sectionBoundaries.minimum;
      } else {
        newSectionValueNumber = sectionBoundaries.maximum;
      }
    } else {
      const currentSectionValue = parseInt(removeLocalizedDigits(section.value, localizedDigits), 10);
      newSectionValueNumber = currentSectionValue + delta * step;
    }
    if (newSectionValueNumber % step !== 0) {
      if (delta < 0 || isStart) {
        newSectionValueNumber += step - (step + newSectionValueNumber) % step;
      }
      if (delta > 0 || isEnd) {
        newSectionValueNumber -= newSectionValueNumber % step;
      }
    }
    if (newSectionValueNumber > sectionBoundaries.maximum) {
      return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
    }
    if (newSectionValueNumber < sectionBoundaries.minimum) {
      return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
    }
    return getCleanValue(newSectionValueNumber);
  };
  const adjustLetterSection = () => {
    const options = getLetterEditingOptions(adapter, timezone, section.type, section.format);
    if (options.length === 0) {
      return section.value;
    }
    if (shouldSetAbsolute) {
      if (delta > 0 || isStart) {
        return options[0];
      }
      return options[options.length - 1];
    }
    const currentOptionIndex = options.indexOf(section.value);
    const newOptionIndex = (currentOptionIndex + delta) % options.length;
    const clampedIndex = (newOptionIndex + options.length) % options.length;
    return options[clampedIndex];
  };
  if (section.contentType === "digit" || section.contentType === "digit-with-letter") {
    return adjustDigitSection();
  }
  return adjustLetterSection();
}
function useFieldRootProps(parameters) {
  const {
    manager: manager2,
    focused,
    setFocused,
    domGetters,
    stateResponse,
    applyCharacterEditing,
    internalPropsWithDefaults,
    stateResponse: {
      // States and derived states
      parsedSelectedSections,
      sectionOrder,
      state,
      // Methods to update the states
      clearValue,
      setCharacterQuery,
      setSelectedSections,
      updateValueFromValueStr
    },
    internalPropsWithDefaults: {
      disabled = false,
      readOnly = false
    }
  } = parameters;
  const handleKeyDown = useFieldRootHandleKeyDown({
    manager: manager2,
    internalPropsWithDefaults,
    stateResponse
  });
  const containerClickTimeout = useTimeout();
  const handleClick = useEventCallback(() => {
    if (disabled || !domGetters.isReady()) {
      return;
    }
    if (parsedSelectedSections === "all") {
      setFocused(true);
      containerClickTimeout.start(0, () => {
        const selection = document.getSelection();
        if (!selection || selection.rangeCount === 0) {
          setSelectedSections(sectionOrder.startIndex);
          return;
        }
        const cursorPosition2 = selection.getRangeAt(0).startOffset;
        if (cursorPosition2 === 0) {
          setSelectedSections(sectionOrder.startIndex);
          return;
        }
        let sectionIndex = 0;
        let cursorOnStartOfSection = 0;
        while (cursorOnStartOfSection < cursorPosition2 && sectionIndex < state.sections.length) {
          const section = state.sections[sectionIndex];
          sectionIndex += 1;
          cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
        }
        setSelectedSections(sectionIndex - 1);
      });
      return;
    }
    if (!focused) {
      setFocused(true);
      if (parsedSelectedSections == null) {
        setSelectedSections(sectionOrder.startIndex);
      }
    }
  });
  const handleMouseDown = useEventCallback((event2) => {
    if (disabled || !domGetters.isReady() || parsedSelectedSections === "all") {
      return;
    }
    if (event2.button !== 0) {
      return;
    }
    const target = event2.target;
    const sectionListRoot = domGetters.getRoot();
    const isInsideSectionList = sectionListRoot.contains(target);
    if (!isInsideSectionList && target !== event2.currentTarget) {
      return;
    }
    const sectionElement = isInsideSectionList ? target.closest("[data-sectionindex]") : null;
    const isBlankSpaceClick = sectionElement == null && (!isInsideSectionList || isPointOutsideSections(sectionListRoot, event2.clientX));
    if (isBlankSpaceClick) {
      event2.preventDefault();
      if (!focused) {
        setFocused(true);
        setSelectedSections(sectionOrder.startIndex);
      }
      return;
    }
    const parsedIndex = sectionElement ? Number(sectionElement.dataset.sectionindex) : findClosestSectionIndexToPoint(sectionListRoot, event2.clientX);
    if (parsedIndex == null || !Number.isInteger(parsedIndex)) {
      return;
    }
    event2.preventDefault();
    setFocused(true);
    setSelectedSections(parsedIndex);
  });
  const handleInput = useEventCallback((event2) => {
    if (!domGetters.isReady() || parsedSelectedSections !== "all") {
      return;
    }
    const target = event2.target;
    const keyPressed = target.textContent ?? "";
    domGetters.getRoot().innerHTML = state.sections.map((section) => `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join("");
    syncSelectionToDOM({
      focused,
      domGetters,
      stateResponse
    });
    if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
      clearValue();
      setSelectedSections("all");
    } else if (keyPressed.length > 1) {
      updateValueFromValueStr(keyPressed);
    } else {
      if (parsedSelectedSections === "all") {
        setSelectedSections(0);
      }
      applyCharacterEditing({
        keyPressed,
        sectionIndex: 0
      });
    }
  });
  const handlePaste = useEventCallback((event2) => {
    if (readOnly || parsedSelectedSections !== "all") {
      event2.preventDefault();
      return;
    }
    const pastedValue = event2.clipboardData.getData("text");
    event2.preventDefault();
    setCharacterQuery(null);
    updateValueFromValueStr(pastedValue);
  });
  const handleFocus = useEventCallback(() => {
    if (focused || disabled || !domGetters.isReady()) {
      return;
    }
    const activeElement2 = getActiveElement(domGetters.getRoot());
    setFocused(true);
    const isFocusInsideASection = domGetters.getSectionIndexFromDOMElement(activeElement2) != null;
    if (!isFocusInsideASection) {
      setSelectedSections(sectionOrder.startIndex);
    }
  });
  const handleBlur = useEventCallback(() => {
    setTimeout(() => {
      if (!domGetters.isReady()) {
        return;
      }
      const activeElement2 = getActiveElement(domGetters.getRoot());
      const shouldBlur = !domGetters.getRoot().contains(activeElement2);
      if (shouldBlur) {
        setFocused(false);
        setSelectedSections(null);
      }
    });
  });
  return {
    // Event handlers
    onKeyDown: handleKeyDown,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    onPaste: handlePaste,
    onInput: handleInput,
    // Other
    contentEditable: parsedSelectedSections === "all",
    tabIndex: internalPropsWithDefaults.disabled || parsedSelectedSections === 0 ? -1 : 0
    // TODO: Try to set to undefined when there is a section selected.
  };
}
const BLANK_SPACE_TOLERANCE = 4;
function isPointOutsideSections(root2, clientX) {
  const sections = root2.querySelectorAll("[data-sectionindex]");
  if (sections.length === 0) {
    return false;
  }
  let left2 = Infinity;
  let right2 = -Infinity;
  for (let i = 0; i < sections.length; i += 1) {
    const rect = sections[i].getBoundingClientRect();
    left2 = Math.min(left2, rect.left);
    right2 = Math.max(right2, rect.right);
  }
  return clientX < left2 - BLANK_SPACE_TOLERANCE || clientX > right2 + BLANK_SPACE_TOLERANCE;
}
function findClosestSectionIndexToPoint(root2, clientX) {
  const sections = root2.querySelectorAll('[role="spinbutton"]');
  if (sections.length === 0) {
    return null;
  }
  let closestIndex = 0;
  let closestDistance = Infinity;
  for (let i = 0; i < sections.length; i += 1) {
    const rect = sections[i].getBoundingClientRect();
    const center = (rect.left + rect.right) / 2;
    const distance = Math.abs(clientX - center);
    if (distance < closestDistance) {
      closestDistance = distance;
      closestIndex = i;
    }
  }
  return closestIndex;
}
function useFieldHiddenInputProps(parameters) {
  const {
    manager: {
      internal_fieldValueManager: fieldValueManager
    },
    stateResponse: {
      // States and derived states
      areAllSectionsEmpty,
      state,
      // Methods to update the states
      updateValueFromValueStr
    }
  } = parameters;
  const handleChange = useEventCallback((event2) => {
    updateValueFromValueStr(event2.target.value);
  });
  const valueStr = reactExports.useMemo(() => areAllSectionsEmpty ? "" : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [areAllSectionsEmpty, state.sections, fieldValueManager]);
  return {
    value: valueStr,
    onChange: handleChange
  };
}
function useFieldSectionContainerProps(parameters) {
  const {
    stateResponse: {
      // States and derived states
      parsedSelectedSections,
      // Methods to update the states
      setSelectedSections
    },
    internalPropsWithDefaults: {
      disabled = false
    }
  } = parameters;
  const handleClick = useEventCallback((event2) => {
    if (disabled || event2.isDefaultPrevented()) {
      return;
    }
    const sectionIndex = Number(event2.currentTarget.dataset.sectionindex);
    if (!Number.isInteger(sectionIndex)) {
      return;
    }
    if (parsedSelectedSections === sectionIndex) {
      return;
    }
    setSelectedSections(sectionIndex);
  });
  return reactExports.useCallback((sectionIndex) => ({
    "data-sectionindex": sectionIndex,
    onClick: handleClick
  }), [handleClick]);
}
function useFieldSectionContentProps(parameters) {
  const adapter = usePickerAdapter();
  const translations = usePickerTranslations();
  const {
    focused,
    domGetters,
    stateResponse,
    applyCharacterEditing,
    manager: {
      internal_fieldValueManager: fieldValueManager
    },
    stateResponse: {
      // States and derived states
      parsedSelectedSections,
      sectionsValueBoundaries,
      state,
      value,
      localizedDigits,
      // Methods to update the states
      clearActiveSection,
      setCharacterQuery,
      setSelectedSections,
      updateSectionValue,
      updateValueFromValueStr
    },
    internalPropsWithDefaults: {
      disabled = false,
      readOnly = false
    }
  } = parameters;
  const isContainerEditable = parsedSelectedSections === "all";
  const isEditable = !isContainerEditable && !disabled && !readOnly;
  const revertDOMSectionChange = useEventCallback((sectionIndex) => {
    if (!domGetters.isReady()) {
      return;
    }
    const section = state.sections[sectionIndex];
    domGetters.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
    syncSelectionToDOM({
      focused,
      domGetters,
      stateResponse
    });
  });
  const handleInput = useEventCallback((event2) => {
    if (!domGetters.isReady()) {
      return;
    }
    const target = event2.target;
    const keyPressed = target.textContent ?? "";
    const sectionIndex = domGetters.getSectionIndexFromDOMElement(target);
    const section = state.sections[sectionIndex];
    if (readOnly) {
      revertDOMSectionChange(sectionIndex);
      return;
    }
    if (keyPressed.length === 0) {
      if (section.value === "") {
        revertDOMSectionChange(sectionIndex);
        return;
      }
      const inputType = event2.nativeEvent.inputType;
      if (inputType === "insertParagraph" || inputType === "insertLineBreak") {
        revertDOMSectionChange(sectionIndex);
        return;
      }
      revertDOMSectionChange(sectionIndex);
      clearActiveSection();
      return;
    }
    applyCharacterEditing({
      keyPressed,
      sectionIndex
    });
    revertDOMSectionChange(sectionIndex);
  });
  const handleMouseUp = useEventCallback((event2) => {
    event2.preventDefault();
  });
  const handlePaste = useEventCallback((event2) => {
    event2.preventDefault();
    if (readOnly || disabled || typeof parsedSelectedSections !== "number") {
      return;
    }
    const activeSection = state.sections[parsedSelectedSections];
    const pastedValue = event2.clipboardData.getData("text");
    const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
    const digitsOnly = /^[0-9]+$/.test(pastedValue);
    const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
    const isValidPastedValue = activeSection.contentType === "letter" && lettersOnly || activeSection.contentType === "digit" && digitsOnly || activeSection.contentType === "digit-with-letter" && digitsAndLetterOnly;
    if (isValidPastedValue) {
      setCharacterQuery(null);
      updateSectionValue({
        section: activeSection,
        newSectionValue: pastedValue,
        shouldGoToNextSection: true
      });
    } else if (!lettersOnly && !digitsOnly) {
      setCharacterQuery(null);
      updateValueFromValueStr(pastedValue);
    }
  });
  const handleDragOver = useEventCallback((event2) => {
    event2.preventDefault();
    event2.dataTransfer.dropEffect = "none";
  });
  const createFocusHandler = reactExports.useCallback((sectionIndex) => () => {
    if (disabled) {
      return;
    }
    setSelectedSections(sectionIndex);
  }, [disabled, setSelectedSections]);
  return reactExports.useCallback((section, sectionIndex) => {
    const sectionBoundaries = sectionsValueBoundaries[section.type]({
      currentDate: fieldValueManager.getDateFromSection(value, section),
      contentType: section.contentType,
      format: section.format
    });
    return {
      // Event handlers
      onInput: handleInput,
      onPaste: handlePaste,
      onMouseUp: handleMouseUp,
      onDragOver: handleDragOver,
      onFocus: createFocusHandler(sectionIndex),
      // Aria attributes
      "aria-readonly": readOnly,
      "aria-valuenow": getSectionValueNow(section, adapter, localizedDigits),
      "aria-valuemin": sectionBoundaries.minimum,
      "aria-valuemax": sectionBoundaries.maximum,
      "aria-valuetext": section.value ? getSectionValueText(section, adapter, localizedDigits) : translations.empty,
      "aria-label": translations[section.type],
      "aria-disabled": disabled,
      // Other
      tabIndex: !isEditable || isContainerEditable || sectionIndex > 0 ? -1 : 0,
      contentEditable: !isContainerEditable && !disabled && !readOnly,
      role: "spinbutton",
      "data-range-position": section.dateName || void 0,
      spellCheck: isEditable ? false : void 0,
      // Firefox hydrates this as `'none`' instead of `'off'`. No problems in chromium with both values.
      // For reference https://github.com/mui/mui-x/issues/19012
      autoCapitalize: isEditable ? "none" : void 0,
      autoCorrect: isEditable ? "off" : void 0,
      children: section.value || section.placeholder,
      inputMode: section.contentType === "letter" ? "text" : "numeric"
    };
  }, [sectionsValueBoundaries, isContainerEditable, disabled, readOnly, isEditable, translations, adapter, localizedDigits, handleInput, handlePaste, handleMouseUp, handleDragOver, createFocusHandler, fieldValueManager, value]);
}
function getSectionValueText(section, adapter, localizedDigits) {
  if (!section.value) {
    return void 0;
  }
  switch (section.type) {
    case "month": {
      if (section.contentType === "digit") {
        const dateWithMonth = adapter.setMonth(adapter.date(), Number(removeLocalizedDigits(section.value, localizedDigits)) - 1);
        return adapter.isValid(dateWithMonth) ? adapter.format(dateWithMonth, "month") : "";
      }
      const parsedDate = adapter.parse(section.value, section.format);
      return parsedDate && adapter.isValid(parsedDate) ? adapter.format(parsedDate, "month") : void 0;
    }
    case "day":
      if (section.contentType === "digit") {
        const dateWithDay = adapter.setDate(adapter.startOfYear(adapter.date()), Number(removeLocalizedDigits(section.value, localizedDigits)));
        return adapter.isValid(dateWithDay) ? adapter.format(dateWithDay, "dayOfMonthFull") : "";
      }
      return section.value;
    case "weekDay":
      return void 0;
    default:
      return void 0;
  }
}
function getSectionValueNow(section, adapter, localizedDigits) {
  if (!section.value) {
    return void 0;
  }
  const nonLocalizedValue = removeLocalizedDigits(section.value, localizedDigits);
  switch (section.type) {
    case "weekDay": {
      if (section.contentType === "letter") {
        return void 0;
      }
      return Number(nonLocalizedValue);
    }
    case "meridiem": {
      const parsedDate = adapter.parse(`01:00 ${section.value}`, `${adapter.formats.hours12h}:${adapter.formats.minutes} ${section.format}`);
      if (parsedDate) {
        return adapter.getHours(parsedDate) >= 12 ? 1 : 0;
      }
      return void 0;
    }
    case "day":
      return section.contentType === "digit-with-letter" ? parseInt(nonLocalizedValue, 10) : Number(nonLocalizedValue);
    case "month": {
      if (section.contentType === "digit") {
        return Number(nonLocalizedValue);
      }
      const parsedDate = adapter.parse(section.value, section.format);
      return parsedDate ? adapter.getMonth(parsedDate) + 1 : void 0;
    }
    default:
      return section.contentType !== "letter" ? Number(nonLocalizedValue) : void 0;
  }
}
const useFieldV7TextField = (parameters) => {
  const {
    props,
    manager: manager2,
    skipContextFieldRefAssignment,
    manager: {
      valueType,
      internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel2
    }
  } = parameters;
  const {
    internalProps,
    forwardedProps
  } = useSplitFieldProps(props, valueType);
  const internalPropsWithDefaults = useFieldInternalPropsWithDefaults({
    manager: manager2,
    internalProps,
    skipContextFieldRefAssignment
  });
  const {
    sectionListRef: sectionListRefProp,
    onBlur,
    onClick,
    onMouseDown,
    onFocus,
    onInput,
    onPaste,
    onKeyDown,
    onClear,
    clearable
  } = forwardedProps;
  const {
    disabled = false,
    readOnly = false,
    autoFocus = false,
    focused: focusedProp,
    unstableFieldRef
  } = internalPropsWithDefaults;
  const sectionListRef = reactExports.useRef(null);
  const handleSectionListRef = useForkRef(sectionListRefProp, sectionListRef);
  const domGetters = reactExports.useMemo(() => ({
    isReady: () => sectionListRef.current != null,
    getRoot: () => sectionListRef.current.getRoot(),
    getSectionContainer: (sectionIndex) => sectionListRef.current.getSectionContainer(sectionIndex),
    getSectionContent: (sectionIndex) => sectionListRef.current.getSectionContent(sectionIndex),
    getSectionIndexFromDOMElement: (element) => sectionListRef.current.getSectionIndexFromDOMElement(element)
  }), [sectionListRef]);
  const stateResponse = useFieldState({
    manager: manager2,
    internalPropsWithDefaults,
    forwardedProps
  });
  const {
    // States and derived states
    areAllSectionsEmpty,
    error,
    parsedSelectedSections,
    sectionOrder,
    state,
    value,
    // Methods to update the states
    clearValue,
    setSelectedSections
  } = stateResponse;
  const applyCharacterEditing = useFieldCharacterEditing({
    stateResponse
  });
  const openPickerAriaLabel = useOpenPickerButtonAriaLabel2(value);
  const [focused, setFocused] = reactExports.useState(false);
  function focusField(newSelectedSections = 0) {
    if (disabled || !sectionListRef.current || // if the field is already focused, we don't need to focus it again
    getActiveSectionIndex(sectionListRef) != null) {
      return;
    }
    const newParsedSelectedSections = parseSelectedSections(newSelectedSections, state.sections);
    setFocused(true);
    sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
  }
  const rootProps = useFieldRootProps({
    manager: manager2,
    internalPropsWithDefaults,
    stateResponse,
    applyCharacterEditing,
    focused,
    setFocused,
    domGetters
  });
  const hiddenInputProps = useFieldHiddenInputProps({
    manager: manager2,
    stateResponse
  });
  const createSectionContainerProps = useFieldSectionContainerProps({
    stateResponse,
    internalPropsWithDefaults
  });
  const createSectionContentProps = useFieldSectionContentProps({
    manager: manager2,
    stateResponse,
    applyCharacterEditing,
    internalPropsWithDefaults,
    domGetters,
    focused
  });
  const handleRootKeyDown = useEventCallback((event2) => {
    onKeyDown?.(event2);
    rootProps.onKeyDown(event2);
  });
  const handleRootBlur = useEventCallback((event2) => {
    onBlur?.(event2);
    rootProps.onBlur(event2);
  });
  const handleRootFocus = useEventCallback((event2) => {
    onFocus?.(event2);
    rootProps.onFocus(event2);
  });
  const handleRootClick = useEventCallback((event2) => {
    if (event2.isDefaultPrevented()) {
      return;
    }
    onClick?.(event2);
    rootProps.onClick(event2);
  });
  const handleRootMouseDown = useEventCallback((event2) => {
    if (event2.isDefaultPrevented()) {
      return;
    }
    onMouseDown?.(event2);
    rootProps.onMouseDown(event2);
  });
  const handleRootPaste = useEventCallback((event2) => {
    onPaste?.(event2);
    rootProps.onPaste(event2);
  });
  const handleRootInput = useEventCallback((event2) => {
    onInput?.(event2);
    rootProps.onInput(event2);
  });
  const handleClear = useEventCallback((event2, ...args) => {
    event2.preventDefault();
    onClear?.(event2, ...args);
    clearValue();
    if (!isFieldFocused$1(sectionListRef)) {
      focusField(0);
    } else {
      setSelectedSections(sectionOrder.startIndex);
    }
  });
  const elements = reactExports.useMemo(() => {
    return state.sections.map((section, sectionIndex) => {
      const content = createSectionContentProps(section, sectionIndex);
      return {
        container: createSectionContainerProps(sectionIndex),
        content: createSectionContentProps(section, sectionIndex),
        before: {
          children: section.startSeparator
        },
        after: {
          children: section.endSeparator,
          "data-range-position": section.isEndFormatSeparator ? content["data-range-position"] : void 0
        }
      };
    });
  }, [state.sections, createSectionContainerProps, createSectionContentProps]);
  reactExports.useEffect(() => {
    if (sectionListRef.current == null) {
      throw new Error(["MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`", "You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.", "", "If you want to keep using an `<input />` HTML element for the editing, please add the `enableAccessibleFieldDOMStructure={false}` prop to your Picker or Field component:", "", "<DatePicker enableAccessibleFieldDOMStructure={false} slots={{ textField: MyCustomTextField }} />", "", "Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element"].join("\n"));
    }
    if (autoFocus && !disabled && sectionListRef.current) {
      sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }
  }, []);
  useEnhancedEffect(() => {
    if (!focused || !sectionListRef.current) {
      return;
    }
    if (parsedSelectedSections === "all") {
      sectionListRef.current.getRoot().focus();
    } else if (typeof parsedSelectedSections === "number") {
      const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
      if (domElement) {
        domElement.focus();
      }
    }
  }, [parsedSelectedSections, focused]);
  useEnhancedEffect(() => {
    syncSelectionToDOM({
      focused,
      domGetters,
      stateResponse
    });
  });
  reactExports.useImperativeHandle(unstableFieldRef, () => ({
    getSections: () => state.sections,
    getActiveSectionIndex: () => getActiveSectionIndex(sectionListRef),
    setSelectedSections: (newSelectedSections) => {
      if (disabled || !sectionListRef.current) {
        return;
      }
      const newParsedSelectedSections = parseSelectedSections(newSelectedSections, state.sections);
      const newActiveSectionIndex = newParsedSelectedSections === "all" ? 0 : newParsedSelectedSections;
      setFocused(newActiveSectionIndex !== null);
      setSelectedSections(newSelectedSections);
    },
    focusField,
    isFieldFocused: () => isFieldFocused$1(sectionListRef)
  }));
  return _extends({}, forwardedProps, rootProps, {
    onBlur: handleRootBlur,
    onClick: handleRootClick,
    onMouseDown: handleRootMouseDown,
    onFocus: handleRootFocus,
    onInput: handleRootInput,
    onPaste: handleRootPaste,
    onKeyDown: handleRootKeyDown,
    onClear: handleClear
  }, hiddenInputProps, {
    error,
    clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
    focused: focusedProp ?? focused,
    sectionListRef: handleSectionListRef,
    // Additional
    enableAccessibleFieldDOMStructure: true,
    elements,
    areAllSectionsEmpty,
    disabled,
    readOnly,
    autoFocus,
    openPickerAriaLabel
  });
};
function getActiveSectionIndex(sectionListRef) {
  const activeElement2 = getActiveElement(sectionListRef.current?.getRoot());
  if (!activeElement2 || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement2)) {
    return null;
  }
  return sectionListRef.current.getSectionIndexFromDOMElement(activeElement2);
}
function isFieldFocused$1(sectionListRef) {
  const activeElement2 = getActiveElement(sectionListRef.current?.getRoot());
  return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement2);
}
const cleanString = (dirtyString) => dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, "");
const addPositionPropertiesToSections = (sections, localizedDigits, isRtl) => {
  let position2 = 0;
  let positionInInput = isRtl ? 1 : 0;
  const newSections = [];
  for (let i = 0; i < sections.length; i += 1) {
    const section = sections[i];
    const renderedValue = getSectionVisibleValue(section, isRtl ? "input-rtl" : "input-ltr", localizedDigits);
    const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
    const sectionLength = cleanString(sectionStr).length;
    const sectionLengthInInput = sectionStr.length;
    const cleanedValue = cleanString(renderedValue);
    const startInInput = positionInInput + (cleanedValue === "" ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
    const endInInput = startInInput + cleanedValue.length;
    newSections.push(_extends({}, section, {
      start: position2,
      end: position2 + sectionLength,
      startInInput,
      endInInput
    }));
    position2 += sectionLength;
    positionInInput += sectionLengthInInput;
  }
  return newSections;
};
const useFieldV6TextField = (parameters) => {
  const isRtl = useRtl();
  const focusTimeout = useTimeout();
  const selectionSyncTimeout = useTimeout();
  const {
    props,
    manager: manager2,
    skipContextFieldRefAssignment,
    manager: {
      valueType,
      internal_valueManager: valueManager,
      internal_fieldValueManager: fieldValueManager,
      internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel2
    }
  } = parameters;
  const {
    internalProps,
    forwardedProps
  } = useSplitFieldProps(props, valueType);
  const internalPropsWithDefaults = useFieldInternalPropsWithDefaults({
    manager: manager2,
    internalProps,
    skipContextFieldRefAssignment
  });
  const {
    onFocus,
    onClick,
    onPaste,
    onBlur,
    onKeyDown,
    onClear,
    clearable,
    inputRef: inputRefProp,
    placeholder: inPlaceholder
  } = forwardedProps;
  const {
    readOnly = false,
    disabled = false,
    autoFocus = false,
    focused,
    unstableFieldRef
  } = internalPropsWithDefaults;
  const inputRef = reactExports.useRef(null);
  const handleRef = useForkRef(inputRefProp, inputRef);
  const stateResponse = useFieldState({
    manager: manager2,
    internalPropsWithDefaults,
    forwardedProps
  });
  const {
    // States and derived states
    activeSectionIndex,
    areAllSectionsEmpty,
    error,
    localizedDigits,
    parsedSelectedSections,
    sectionOrder,
    state,
    value,
    // Methods to update the states
    clearValue,
    clearActiveSection,
    setCharacterQuery,
    setSelectedSections,
    setTempAndroidValueStr,
    updateSectionValue,
    updateValueFromValueStr,
    // Utilities methods
    getSectionsFromValue
  } = stateResponse;
  const applyCharacterEditing = useFieldCharacterEditing({
    stateResponse
  });
  const openPickerAriaLabel = useOpenPickerButtonAriaLabel2(value);
  const sections = reactExports.useMemo(() => addPositionPropertiesToSections(state.sections, localizedDigits, isRtl), [state.sections, localizedDigits, isRtl]);
  function syncSelectionFromDOM() {
    const browserStartIndex = inputRef.current.selectionStart ?? 0;
    let nextSectionIndex;
    if (browserStartIndex <= sections[0].startInInput) {
      nextSectionIndex = 1;
    } else if (browserStartIndex >= sections[sections.length - 1].endInInput) {
      nextSectionIndex = 1;
    } else {
      nextSectionIndex = sections.findIndex((section) => section.startInInput - section.startSeparator.length > browserStartIndex);
    }
    const sectionIndex = nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
    setSelectedSections(sectionIndex);
  }
  function focusField(newSelectedSection = 0) {
    if (getActiveElement(inputRef.current) === inputRef.current) {
      return;
    }
    inputRef.current?.focus();
    setSelectedSections(newSelectedSection);
  }
  const handleInputFocus = useEventCallback((event2) => {
    onFocus?.(event2);
    const input = inputRef.current;
    focusTimeout.start(0, () => {
      if (!input || input !== inputRef.current) {
        return;
      }
      if (activeSectionIndex != null) {
        return;
      }
      if (
        // avoid selecting all sections when focusing empty field without value
        input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length
      ) {
        setSelectedSections("all");
      } else {
        syncSelectionFromDOM();
      }
    });
  });
  const handleInputClick = useEventCallback((event2, ...args) => {
    if (event2.isDefaultPrevented()) {
      return;
    }
    onClick?.(event2, ...args);
    syncSelectionFromDOM();
  });
  const handleInputPaste = useEventCallback((event2) => {
    onPaste?.(event2);
    event2.preventDefault();
    if (readOnly || disabled) {
      return;
    }
    const pastedValue = event2.clipboardData.getData("text");
    if (typeof parsedSelectedSections === "number") {
      const activeSection = state.sections[parsedSelectedSections];
      const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
      const digitsOnly = /^[0-9]+$/.test(pastedValue);
      const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
      const isValidPastedValue = activeSection.contentType === "letter" && lettersOnly || activeSection.contentType === "digit" && digitsOnly || activeSection.contentType === "digit-with-letter" && digitsAndLetterOnly;
      if (isValidPastedValue) {
        setCharacterQuery(null);
        updateSectionValue({
          section: activeSection,
          newSectionValue: pastedValue,
          shouldGoToNextSection: true
        });
        return;
      }
      if (lettersOnly || digitsOnly) {
        return;
      }
    }
    setCharacterQuery(null);
    updateValueFromValueStr(pastedValue);
  });
  const handleContainerBlur = useEventCallback((event2) => {
    onBlur?.(event2);
    setSelectedSections(null);
  });
  const handleInputChange = useEventCallback((event2) => {
    if (readOnly) {
      return;
    }
    const targetValue = event2.target.value;
    if (targetValue === "") {
      clearValue();
      return;
    }
    const eventData = event2.nativeEvent.data;
    const shouldUseEventData = eventData && eventData.length > 1;
    const valueStr2 = shouldUseEventData ? eventData : targetValue;
    const cleanValueStr = cleanString(valueStr2);
    if (parsedSelectedSections === "all") {
      setSelectedSections(activeSectionIndex);
    }
    if (activeSectionIndex == null || shouldUseEventData) {
      updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
      return;
    }
    let keyPressed;
    if (parsedSelectedSections === "all" && cleanValueStr.length === 1) {
      keyPressed = cleanValueStr;
    } else {
      const prevValueStr = cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRtl));
      let startOfDiffIndex = -1;
      let endOfDiffIndex = -1;
      for (let i = 0; i < prevValueStr.length; i += 1) {
        if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) {
          startOfDiffIndex = i;
        }
        if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) {
          endOfDiffIndex = i;
        }
      }
      const activeSection = sections[activeSectionIndex];
      const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
      if (hasDiffOutsideOfActiveSection) {
        return;
      }
      const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - cleanString(activeSection.endSeparator || "").length;
      keyPressed = cleanValueStr.slice(activeSection.start + cleanString(activeSection.startSeparator || "").length, activeSectionEndRelativeToNewValue);
    }
    if (keyPressed.length === 0) {
      if (isAndroid()) {
        setTempAndroidValueStr(valueStr2);
      }
      clearActiveSection();
      return;
    }
    applyCharacterEditing({
      keyPressed,
      sectionIndex: activeSectionIndex
    });
  });
  const handleClear = useEventCallback((event2, ...args) => {
    event2.preventDefault();
    onClear?.(event2, ...args);
    clearValue();
    if (!isFieldFocused(inputRef)) {
      focusField(0);
    } else {
      setSelectedSections(sectionOrder.startIndex);
    }
  });
  const handleContainerKeyDown = useFieldRootHandleKeyDown({
    manager: manager2,
    internalPropsWithDefaults,
    stateResponse
  });
  const wrappedHandleContainerKeyDown = useEventCallback((event2) => {
    onKeyDown?.(event2);
    handleContainerKeyDown(event2);
  });
  const placeholder = reactExports.useMemo(() => {
    if (inPlaceholder !== void 0) {
      return inPlaceholder;
    }
    return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRtl);
  }, [inPlaceholder, fieldValueManager, getSectionsFromValue, valueManager.emptyValue, localizedDigits, isRtl]);
  const valueStr = reactExports.useMemo(() => state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRtl), [state.sections, fieldValueManager, state.tempValueStrAndroid, localizedDigits, isRtl]);
  reactExports.useEffect(() => {
    if (inputRef.current && inputRef.current === getActiveElement(inputRef.current)) {
      setSelectedSections("all");
    }
  }, []);
  useEnhancedEffect(() => {
    function syncSelectionToDOM2() {
      if (!inputRef.current) {
        return;
      }
      if (parsedSelectedSections == null) {
        if (inputRef.current.scrollLeft) {
          inputRef.current.scrollLeft = 0;
        }
        return;
      }
      if (inputRef.current !== getActiveElement(inputRef.current)) {
        return;
      }
      const currentScrollTop = inputRef.current.scrollTop;
      if (parsedSelectedSections === "all") {
        inputRef.current.select();
      } else {
        const selectedSection = sections[parsedSelectedSections];
        const selectionStart = selectedSection.type === "empty" ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
        const selectionEnd = selectedSection.type === "empty" ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
        if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
          if (inputRef.current === getActiveElement(inputRef.current)) {
            inputRef.current.setSelectionRange(selectionStart, selectionEnd);
          }
        }
        selectionSyncTimeout.start(0, () => {
          if (inputRef.current && inputRef.current === getActiveElement(inputRef.current) && // The section might loose all selection, where `selectionStart === selectionEnd`
          // https://github.com/mui/mui-x/pull/13652
          inputRef.current.selectionStart === inputRef.current.selectionEnd && (inputRef.current.selectionStart !== selectionStart || inputRef.current.selectionEnd !== selectionEnd)) {
            syncSelectionToDOM2();
          }
        });
      }
      inputRef.current.scrollTop = currentScrollTop;
    }
    syncSelectionToDOM2();
  });
  const inputMode = reactExports.useMemo(() => {
    if (activeSectionIndex == null) {
      return "text";
    }
    if (state.sections[activeSectionIndex].contentType === "letter") {
      return "text";
    }
    return "numeric";
  }, [activeSectionIndex, state.sections]);
  const inputHasFocus = inputRef.current && inputRef.current === getActiveElement(inputRef.current);
  const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
  reactExports.useImperativeHandle(unstableFieldRef, () => ({
    getSections: () => state.sections,
    getActiveSectionIndex: () => {
      const browserStartIndex = inputRef.current.selectionStart ?? 0;
      const browserEndIndex = inputRef.current.selectionEnd ?? 0;
      if (browserStartIndex === 0 && browserEndIndex === 0) {
        return null;
      }
      const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 : sections.findIndex((section) => section.startInInput - section.startSeparator.length > browserStartIndex);
      return nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
    },
    setSelectedSections: (newSelectedSections) => setSelectedSections(newSelectedSections),
    focusField,
    isFieldFocused: () => isFieldFocused(inputRef)
  }));
  return _extends({}, forwardedProps, {
    error,
    "aria-invalid": error,
    clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
    onBlur: handleContainerBlur,
    onClick: handleInputClick,
    onFocus: handleInputFocus,
    onPaste: handleInputPaste,
    onKeyDown: wrappedHandleContainerKeyDown,
    onClear: handleClear,
    inputRef: handleRef,
    // Additional
    enableAccessibleFieldDOMStructure: false,
    placeholder,
    inputMode,
    autoComplete: "off",
    value: shouldShowPlaceholder ? "" : valueStr,
    onChange: handleInputChange,
    focused,
    disabled,
    readOnly,
    autoFocus,
    openPickerAriaLabel
  });
};
function isFieldFocused(inputRef) {
  return inputRef.current === getActiveElement(inputRef.current);
}
const useField = (parameters) => {
  const fieldPrivateContext = useNullableFieldPrivateContext();
  const enableAccessibleFieldDOMStructure = parameters.props.enableAccessibleFieldDOMStructure ?? fieldPrivateContext?.enableAccessibleFieldDOMStructure ?? true;
  const useFieldTextField = enableAccessibleFieldDOMStructure ? useFieldV7TextField : useFieldV6TextField;
  return useFieldTextField(parameters);
};
function useDateManager(parameters = {}) {
  const {
    enableAccessibleFieldDOMStructure = true
  } = parameters;
  return reactExports.useMemo(() => ({
    valueType: "date",
    validator: validateDate,
    internal_valueManager: singleItemValueManager,
    internal_fieldValueManager: singleItemFieldValueManager,
    internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
    internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToDateFieldInternalProps,
    internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel
  }), [enableAccessibleFieldDOMStructure]);
}
function useOpenPickerButtonAriaLabel(value) {
  const adapter = usePickerAdapter();
  const translations = usePickerTranslations();
  return reactExports.useMemo(() => {
    const formattedValue = adapter.isValid(value) ? adapter.format(value, "fullDate") : null;
    return translations.openDatePickerDialogue(formattedValue);
  }, [value, translations, adapter]);
}
function useApplyDefaultValuesToDateFieldInternalProps(internalProps) {
  const adapter = usePickerAdapter();
  const validationProps = useApplyDefaultValuesToDateValidationProps(internalProps);
  return reactExports.useMemo(() => _extends({}, internalProps, validationProps, {
    format: internalProps.format ?? adapter.formats.keyboardDate
  }), [internalProps, validationProps, adapter]);
}
function useApplyDefaultValuesToDateValidationProps(props) {
  const adapter = usePickerAdapter();
  const defaultDates = useDefaultDates();
  return reactExports.useMemo(() => ({
    disablePast: props.disablePast ?? false,
    disableFuture: props.disableFuture ?? false,
    minDate: applyDefaultDate(adapter, props.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(adapter, props.maxDate, defaultDates.maxDate)
  }), [props.minDate, props.maxDate, props.disableFuture, props.disablePast, adapter, defaultDates]);
}
const useDateField = (props) => {
  const manager2 = useDateManager(props);
  return useField({
    manager: manager2,
    props
  });
};
function useFieldOwnerState(parameters) {
  const {
    ownerState: pickerOwnerState
  } = usePickerPrivateContext();
  const isRtl = useRtl();
  return reactExports.useMemo(() => _extends({}, pickerOwnerState, {
    isFieldDisabled: parameters.disabled ?? false,
    isFieldReadOnly: parameters.readOnly ?? false,
    isFieldRequired: parameters.required ?? false,
    fieldDirection: isRtl ? "rtl" : "ltr"
  }), [pickerOwnerState, parameters.disabled, parameters.readOnly, parameters.required, isRtl]);
}
function getPickersTextFieldUtilityClass(slot) {
  return generateUtilityClass("MuiPickersTextField", slot);
}
generateUtilityClasses("MuiPickersTextField", ["root", "focused", "disabled", "error", "required"]);
function getPickersInputBaseUtilityClass(slot) {
  return generateUtilityClass("MuiPickersInputBase", slot);
}
const pickersInputBaseClasses = generateUtilityClasses("MuiPickersInputBase", ["root", "focused", "disabled", "readOnly", "error", "notchedOutline", "sectionsContainer", "sectionContent", "sectionBefore", "sectionAfter", "adornedStart", "adornedEnd", "input", "inputSizeSmall", "activeBar"]);
function getPickersSectionListUtilityClass(slot) {
  return generateUtilityClass("MuiPickersSectionList", slot);
}
const pickersSectionListClasses = generateUtilityClasses("MuiPickersSectionList", ["root", "section", "sectionContent"]);
const _excluded$r = ["slots", "slotProps", "elements", "sectionListRef", "classes"];
const PickersSectionListRoot = styled("div", {
  name: "MuiPickersSectionList",
  slot: "Root"
})({
  direction: "ltr /*! @noflip */",
  outline: "none"
});
const PickersSectionListSection = styled("span", {
  name: "MuiPickersSectionList",
  slot: "Section"
})({});
const PickersSectionListSectionSeparator = styled("span", {
  name: "MuiPickersSectionList",
  slot: "SectionSeparator"
})({
  whiteSpace: "pre"
});
const PickersSectionListSectionContent = styled("span", {
  name: "MuiPickersSectionList",
  slot: "SectionContent"
})({
  outline: "none"
});
const useUtilityClasses$j = (classes) => {
  const slots = {
    root: ["root"],
    section: ["section"],
    sectionContent: ["sectionContent"]
  };
  return composeClasses(slots, getPickersSectionListUtilityClass, classes);
};
function PickersSection(props) {
  const {
    slots,
    slotProps,
    element,
    classes
  } = props;
  const {
    ownerState
  } = usePickerPrivateContext();
  const Section = slots?.section ?? PickersSectionListSection;
  const sectionProps = useSlotProps({
    elementType: Section,
    externalSlotProps: slotProps?.section,
    externalForwardedProps: element.container,
    className: classes.section,
    ownerState
  });
  const SectionContent = slots?.sectionContent ?? PickersSectionListSectionContent;
  const sectionContentProps = useSlotProps({
    elementType: SectionContent,
    externalSlotProps: slotProps?.sectionContent,
    externalForwardedProps: element.content,
    additionalProps: {
      suppressContentEditableWarning: true
    },
    className: classes.sectionContent,
    ownerState
  });
  const SectionSeparator = slots?.sectionSeparator ?? PickersSectionListSectionSeparator;
  const sectionSeparatorBeforeProps = useSlotProps({
    elementType: SectionSeparator,
    externalSlotProps: slotProps?.sectionSeparator,
    externalForwardedProps: element.before,
    ownerState: _extends({}, ownerState, {
      separatorPosition: "before"
    })
  });
  const sectionSeparatorAfterProps = useSlotProps({
    elementType: SectionSeparator,
    externalSlotProps: slotProps?.sectionSeparator,
    externalForwardedProps: element.after,
    ownerState: _extends({}, ownerState, {
      separatorPosition: "after"
    })
  });
  const sectionContentRef = reactExports.useRef(null);
  const handleSectionContentRef = useForkRef(sectionContentProps.ref, sectionContentRef);
  const handleContentBlur = (event2) => {
    const next2 = event2.relatedTarget;
    const root2 = event2.currentTarget.closest(`.${pickersSectionListClasses.root}`);
    if (root2 && next2 instanceof Node && root2.contains(next2)) {
      event2.stopPropagation();
      return;
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Section, _extends({}, sectionProps, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SectionSeparator, _extends({}, sectionSeparatorBeforeProps)), /* @__PURE__ */ jsxRuntimeExports.jsx(SectionContent, _extends({}, sectionContentProps, {
      ref: handleSectionContentRef,
      onBlur: handleContentBlur
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(SectionSeparator, _extends({}, sectionSeparatorAfterProps))]
  }));
}
process.env.NODE_ENV !== "production" ? PickersSection.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object.isRequired,
  element: PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  }).isRequired,
  /**
   * The props used for each component slot.
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   */
  slots: PropTypes.object
} : void 0;
const PickersSectionList = /* @__PURE__ */ reactExports.forwardRef(function PickersSectionList2(inProps, ref2) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersSectionList"
  });
  const {
    slots,
    slotProps,
    elements,
    sectionListRef,
    classes: classesProp
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$r);
  const classes = useUtilityClasses$j(classesProp);
  const {
    ownerState
  } = usePickerPrivateContext();
  const rootRef = reactExports.useRef(null);
  const handleRootRef = useForkRef(ref2, rootRef);
  const getRoot = (methodName) => {
    if (!rootRef.current) {
      throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
    }
    return rootRef.current;
  };
  reactExports.useImperativeHandle(sectionListRef, () => ({
    getRoot() {
      return getRoot("getRoot");
    },
    getSectionContainer(index2) {
      const root2 = getRoot("getSectionContainer");
      return root2.querySelector(`.${pickersSectionListClasses.section}[data-sectionindex="${index2}"]`);
    },
    getSectionContent(index2) {
      const root2 = getRoot("getSectionContent");
      return root2.querySelector(`.${pickersSectionListClasses.section}[data-sectionindex="${index2}"] .${pickersSectionListClasses.sectionContent}`);
    },
    getSectionIndexFromDOMElement(element) {
      const root2 = getRoot("getSectionIndexFromDOMElement");
      if (element == null || !root2.contains(element)) {
        return null;
      }
      let sectionContainer = null;
      if (element.classList.contains(pickersSectionListClasses.section)) {
        sectionContainer = element;
      } else if (element.classList.contains(pickersSectionListClasses.sectionContent)) {
        sectionContainer = element.parentElement;
      }
      if (sectionContainer == null) {
        return null;
      }
      return Number(sectionContainer.dataset.sectionindex);
    }
  }));
  const Root = slots?.root ?? PickersSectionListRoot;
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    additionalProps: {
      ref: handleRootRef,
      suppressContentEditableWarning: true
    },
    className: classes.root,
    ownerState
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Root, _extends({}, rootProps, {
    children: rootProps.contentEditable ? elements.map(({
      content,
      before,
      after
    }) => `${before.children}${content.children}${after.children}`).join("") : /* @__PURE__ */ jsxRuntimeExports.jsx(reactExports.Fragment, {
      children: elements.map((element, elementIndex) => /* @__PURE__ */ jsxRuntimeExports.jsx(PickersSection, {
        slots,
        slotProps,
        element,
        classes
      }, elementIndex))
    })
  }));
});
if (process.env.NODE_ENV !== "production") PickersSectionList.displayName = "PickersSectionList";
process.env.NODE_ENV !== "production" ? PickersSectionList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   */
  slots: PropTypes.object
} : void 0;
const PickerTextFieldOwnerStateContext = /* @__PURE__ */ reactExports.createContext(null);
if (process.env.NODE_ENV !== "production") PickerTextFieldOwnerStateContext.displayName = "PickerTextFieldOwnerStateContext";
const usePickerTextFieldOwnerState = () => {
  const value = reactExports.useContext(PickerTextFieldOwnerStateContext);
  if (value == null) {
    throw new Error(["MUI X: The `usePickerTextFieldOwnerState` can only be called in components that are used inside a PickerTextField component"].join("\n"));
  }
  return value;
};
const _excluded$q = ["elements", "areAllSectionsEmpty", "defaultValue", "label", "value", "onChange", "id", "autoFocus", "endAdornment", "startAdornment", "renderSuffix", "slots", "slotProps", "contentEditable", "tabIndex", "onInput", "onPaste", "onKeyDown", "fullWidth", "name", "readOnly", "inputProps", "inputRef", "sectionListRef", "onFocus", "onBlur", "classes", "ownerState"];
const round = (value) => Math.round(value * 1e5) / 1e5;
const PickersInputBaseRoot = styled("div", {
  name: "MuiPickersInputBase",
  slot: "Root"
})(({
  theme
}) => _extends({}, theme.typography.body1, {
  color: (theme.vars || theme).palette.text.primary,
  cursor: "text",
  padding: 0,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  letterSpacing: `${round(0.15 / 16)}em`,
  [`&.${pickersInputBaseClasses.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled,
    cursor: "default"
  },
  variants: [{
    props: {
      isInputInFullWidth: true
    },
    style: {
      width: "100%"
    }
  }]
}));
const PickersInputBaseSectionsContainer = styled(PickersSectionListRoot, {
  name: "MuiPickersInputBase",
  slot: "SectionsContainer"
})(({
  theme
}) => ({
  padding: "4px 0 5px",
  fontFamily: theme.typography.fontFamily,
  fontSize: "inherit",
  lineHeight: "1.4375em",
  // 23px
  flexGrow: 1,
  outline: "none",
  display: "flex",
  flexWrap: "nowrap",
  overflow: "hidden",
  letterSpacing: "inherit",
  // Baseline behavior
  width: "182px",
  variants: [{
    props: {
      fieldDirection: "rtl"
    },
    style: {
      justifyContent: "end"
    }
  }, {
    props: {
      inputSize: "small"
    },
    style: {
      paddingTop: 1
    }
  }, {
    // While the field is empty and blurred, the format is shown as a placeholder.
    props: {
      isFieldFocused: false,
      isFieldValueEmpty: true
    },
    style: theme.vars ? {
      opacity: theme.vars.opacity.inputPlaceholder
    } : {
      opacity: theme.palette.mode === "light" ? 0.42 : 0.5
    }
  }, {
    // ...except when a non-shrunk label sits in the notch, where the format would overlap it.
    // A start adornment always shrinks the label, so it never triggers this case.
    props: {
      isFieldFocused: false,
      isFieldValueEmpty: true,
      hasStartAdornment: false,
      inputHasLabel: true,
      isLabelShrunk: false
    },
    style: {
      opacity: 0
    }
  }]
}));
const PickersInputBaseSection = styled(PickersSectionListSection, {
  name: "MuiPickersInputBase",
  slot: "Section"
})(({
  theme
}) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: "inherit",
  letterSpacing: "inherit",
  lineHeight: "1.4375em",
  // 23px
  display: "inline-block",
  whiteSpace: "nowrap"
}));
const PickersInputBaseSectionContent = styled(PickersSectionListSectionContent, {
  name: "MuiPickersInputBase",
  slot: "SectionContent",
  overridesResolver: (props, styles2) => styles2.content
  // FIXME: Inconsistent naming with slot
})(({
  theme
}) => ({
  fontFamily: theme.typography.fontFamily,
  lineHeight: "1.4375em",
  // 23px
  letterSpacing: "inherit",
  width: "fit-content",
  outline: "none",
  // Disables Chromium's focus-delegation onto contenteditable descendants
  // while the field is not focused. Gated to Chromium via a Blink-only
  // property, because the rule breaks Playwright's `fill()` on WebKit.
  "@supports (-webkit-app-region: drag)": {
    [`.${pickersInputBaseClasses.root}:not(:focus-within) &`]: {
      WebkitUserModify: "read-only",
      userSelect: "none"
    }
  }
}));
const PickersInputBaseSectionSeparator = styled(PickersSectionListSectionSeparator, {
  name: "MuiPickersInputBase",
  slot: "Separator"
})(() => ({
  whiteSpace: "pre",
  letterSpacing: "inherit"
}));
const PickersInputBaseInput = styled("input", {
  name: "MuiPickersInputBase",
  slot: "Input",
  overridesResolver: (props, styles2) => styles2.hiddenInput
  // FIXME: Inconsistent naming with slot
})(_extends({}, visuallyHidden));
const PickersInputBaseActiveBar = styled("div", {
  name: "MuiPickersInputBase",
  slot: "ActiveBar"
})(({
  theme,
  ownerState
}) => ({
  display: "none",
  position: "absolute",
  height: 2,
  bottom: 2,
  borderTopLeftRadius: 2,
  borderTopRightRadius: 2,
  transition: theme.transitions.create(["width", "left"], {
    duration: theme.transitions.duration.shortest
  }),
  backgroundColor: (theme.vars || theme).palette.primary.main,
  '[data-active-range-position="start"] &, [data-active-range-position="end"] &': {
    display: "block"
  },
  '[data-active-range-position="start"] &': {
    left: ownerState.sectionOffsets[0]
  },
  '[data-active-range-position="end"] &': {
    left: ownerState.sectionOffsets[1]
  }
}));
const useUtilityClasses$i = (classes, ownerState) => {
  const {
    isFieldFocused: isFieldFocused2,
    isFieldDisabled,
    isFieldReadOnly,
    hasFieldError,
    inputSize,
    isInputInFullWidth,
    inputColor,
    hasStartAdornment,
    hasEndAdornment
  } = ownerState;
  const slots = {
    root: ["root", isFieldFocused2 && !isFieldDisabled && "focused", isFieldDisabled && "disabled", isFieldReadOnly && "readOnly", hasFieldError && "error", isInputInFullWidth && "fullWidth", `color${capitalize$2(inputColor)}`, inputSize === "small" && "inputSizeSmall", hasStartAdornment && "adornedStart", hasEndAdornment && "adornedEnd"],
    notchedOutline: ["notchedOutline"],
    input: ["input"],
    sectionsContainer: ["sectionsContainer"],
    sectionContent: ["sectionContent"],
    sectionBefore: ["sectionBefore"],
    sectionAfter: ["sectionAfter"],
    activeBar: ["activeBar"]
  };
  return composeClasses(slots, getPickersInputBaseUtilityClass, classes);
};
function resolveSectionElementWidth(sectionElement, rootRef, index2, dateRangePosition) {
  if (sectionElement.content["data-range-position"] !== void 0) {
    const activeSectionElements = rootRef.current?.querySelectorAll(`[data-sectionindex="${index2}"] [data-range-position="${dateRangePosition}"]`);
    if (activeSectionElements) {
      return Array.from(activeSectionElements).reduce((currentActiveBarWidth, element) => {
        return currentActiveBarWidth + element.offsetWidth;
      }, 0);
    }
  }
  return 0;
}
function resolveSectionWidthAndOffsets(elements, rootRef) {
  let activeBarWidth = 0;
  const activeRangePosition = rootRef.current?.getAttribute("data-active-range-position");
  if (activeRangePosition === "end") {
    for (let i = elements.length - 1; i >= elements.length / 2; i -= 1) {
      activeBarWidth += resolveSectionElementWidth(elements[i], rootRef, i, "end");
    }
  } else {
    for (let i = 0; i < elements.length / 2; i += 1) {
      activeBarWidth += resolveSectionElementWidth(elements[i], rootRef, i, "start");
    }
  }
  return {
    activeBarWidth,
    sectionOffsets: [rootRef.current?.querySelector(`[data-sectionindex="0"]`)?.offsetLeft || 0, rootRef.current?.querySelector(`[data-sectionindex="${elements.length / 2}"]`)?.offsetLeft || 0]
  };
}
const PickersInputBase = /* @__PURE__ */ reactExports.forwardRef(function PickersInputBase2(inProps, ref2) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersInputBase"
  });
  const {
    elements,
    areAllSectionsEmpty,
    value,
    onChange,
    id,
    endAdornment,
    startAdornment,
    renderSuffix,
    slots,
    slotProps,
    contentEditable,
    tabIndex,
    onInput,
    onPaste,
    onKeyDown,
    name,
    readOnly,
    inputProps,
    inputRef,
    sectionListRef,
    onFocus,
    onBlur,
    classes: classesProp,
    ownerState: ownerStateProp
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$q);
  const ownerStateContext = usePickerTextFieldOwnerState();
  const rootRef = reactExports.useRef(null);
  const activeBarRef = reactExports.useRef(null);
  const sectionOffsetsRef = reactExports.useRef([]);
  const handleRootRef = useForkRef(ref2, rootRef);
  const handleInputRef = useForkRef(inputProps?.ref, inputRef);
  const muiFormControl = useFormControl();
  if (!muiFormControl) {
    throw new Error("MUI X: PickersInputBase should always be used inside a PickersTextField component");
  }
  const ownerState = ownerStateProp ?? ownerStateContext;
  const handleInputFocus = (event2) => {
    muiFormControl.onFocus?.(event2);
    onFocus?.(event2);
  };
  const handleHiddenInputFocus = (event2) => {
    handleInputFocus(event2);
  };
  const handleKeyDown = (event2) => {
    onKeyDown?.(event2);
    if (event2.key === "Enter" && !event2.defaultMuiPrevented) {
      if (rootRef.current?.dataset.multiInput) {
        return;
      }
      const closestForm = rootRef.current?.closest("form");
      const submitTrigger = closestForm?.querySelector('[type="submit"]');
      if (!closestForm || !submitTrigger) {
        return;
      }
      event2.preventDefault();
      closestForm.requestSubmit(submitTrigger);
    }
  };
  const handleInputBlur = (event2) => {
    muiFormControl.onBlur?.(event2);
    onBlur?.(event2);
  };
  reactExports.useEffect(() => {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  reactExports.useEffect(() => {
    if (!muiFormControl) {
      return;
    }
    if (areAllSectionsEmpty) {
      muiFormControl.onEmpty();
    } else {
      muiFormControl.onFilled();
    }
  }, [muiFormControl, areAllSectionsEmpty]);
  const classes = useUtilityClasses$i(classesProp, ownerState);
  const InputRoot2 = slots?.root || PickersInputBaseRoot;
  const inputRootProps = useSlotProps({
    elementType: InputRoot2,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    additionalProps: {
      "aria-invalid": muiFormControl.error,
      ref: handleRootRef
    },
    className: classes.root,
    ownerState
  });
  const InputSectionsContainer = slots?.input || PickersInputBaseSectionsContainer;
  const isSingleInputRange = elements.some((element) => element.content["data-range-position"] !== void 0);
  reactExports.useEffect(() => {
    if (!isSingleInputRange || !ownerState.isPickerOpen) {
      return;
    }
    const {
      activeBarWidth,
      sectionOffsets
    } = resolveSectionWidthAndOffsets(elements, rootRef);
    sectionOffsetsRef.current = [sectionOffsets[0], sectionOffsets[1]];
    if (activeBarRef.current) {
      activeBarRef.current.style.width = `${activeBarWidth}px`;
    }
  }, [elements, isSingleInputRange, ownerState.isPickerOpen]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(InputRoot2, _extends({}, inputRootProps, {
    children: [startAdornment, /* @__PURE__ */ jsxRuntimeExports.jsx(PickersSectionList, {
      sectionListRef,
      elements,
      contentEditable,
      tabIndex,
      className: classes.sectionsContainer,
      onFocus: handleInputFocus,
      onBlur: handleInputBlur,
      onInput,
      onPaste,
      onKeyDown: handleKeyDown,
      slots: {
        root: InputSectionsContainer,
        section: PickersInputBaseSection,
        sectionContent: PickersInputBaseSectionContent,
        sectionSeparator: PickersInputBaseSectionSeparator
      },
      slotProps: {
        root: _extends({}, slotProps?.input, {
          ownerState
        }),
        sectionContent: {
          className: pickersInputBaseClasses.sectionContent
        },
        sectionSeparator: ({
          separatorPosition
        }) => ({
          className: separatorPosition === "before" ? pickersInputBaseClasses.sectionBefore : pickersInputBaseClasses.sectionAfter
        })
      }
    }), endAdornment, renderSuffix ? renderSuffix(_extends({}, muiFormControl)) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBaseInput, _extends({
      name,
      className: classes.input,
      value,
      onChange,
      id,
      "aria-hidden": "true",
      tabIndex: -1,
      readOnly,
      required: muiFormControl.required,
      disabled: muiFormControl.disabled,
      onFocus: handleHiddenInputFocus
    }, inputProps, {
      ref: handleInputRef
    })), isSingleInputRange && /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBaseActiveBar, {
      className: classes.activeBar,
      ref: activeBarRef,
      ownerState: {
        sectionOffsets: sectionOffsetsRef.current
      }
    })]
  }));
});
if (process.env.NODE_ENV !== "production") PickersInputBase.displayName = "PickersInputBase";
process.env.NODE_ENV !== "production" ? PickersInputBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  "data-multi-input": PropTypes.string,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  ownerState: PropTypes.any,
  readOnly: PropTypes.bool,
  renderSuffix: PropTypes.func,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.object,
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired
} : void 0;
function getPickersOutlinedInputUtilityClass(slot) {
  return generateUtilityClass("MuiPickersOutlinedInput", slot);
}
const pickersOutlinedInputClasses = _extends({}, pickersInputBaseClasses, generateUtilityClasses("MuiPickersOutlinedInput", ["root", "notchedOutline", "input"]));
const _excluded$p = ["children", "className", "label", "notched", "shrink"];
const OutlineRoot = styled("fieldset", {
  name: "MuiPickersOutlinedInput",
  slot: "NotchedOutline"
})(({
  theme
}) => {
  const borderColor2 = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%",
    borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor2
  };
});
const OutlineLabel = styled("span", {
  slot: "internal",
  shouldForwardProp: void 0
})(({
  theme
}) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: "inherit"
}));
const OutlineLegend = styled("legend", {
  slot: "internal",
  shouldForwardProp: (prop) => shouldForwardProp(prop) && prop !== "notched"
})(({
  theme
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: {
      inputHasLabel: false
    },
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: theme.transitions.create("width", {
        duration: 150,
        easing: theme.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      inputHasLabel: true
    },
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: theme.transitions.create("max-width", {
        duration: 50,
        easing: theme.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: {
      inputHasLabel: true,
      notched: true
    },
    style: {
      maxWidth: "100%",
      transition: theme.transitions.create("max-width", {
        duration: 100,
        easing: theme.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
}));
function Outline(props) {
  const {
    className,
    label,
    notched
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$p);
  const ownerState = usePickerTextFieldOwnerState();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(OutlineRoot, _extends({
    "aria-hidden": true,
    className
  }, other, {
    ownerState,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(OutlineLegend, {
      ownerState,
      notched,
      children: label ? /* @__PURE__ */ jsxRuntimeExports.jsx(OutlineLabel, {
        children: label
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        /* @__PURE__ */ jsxRuntimeExports.jsx(OutlineLabel, {
          className: "notranslate",
          children: "​"
        })
      )
    })
  }));
}
const _excluded$o = ["label", "autoFocus", "ownerState", "classes", "notched"];
const PickersOutlinedInputRoot = styled(PickersInputBaseRoot, {
  name: "MuiPickersOutlinedInput",
  slot: "Root"
})(({
  theme
}) => {
  const borderColor2 = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    padding: "0 14px",
    borderRadius: (theme.vars || theme).shape.borderRadius,
    [`&:hover .${pickersOutlinedInputClasses.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${pickersOutlinedInputClasses.notchedOutline}`]: {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor2
      }
    },
    [`&.${pickersOutlinedInputClasses.focused} .${pickersOutlinedInputClasses.notchedOutline}`]: {
      borderStyle: "solid",
      borderWidth: 2
    },
    [`&.${pickersOutlinedInputClasses.error} .${pickersOutlinedInputClasses.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.error.main
    },
    [`&.${pickersOutlinedInputClasses.disabled}`]: {
      [`& .${pickersOutlinedInputClasses.notchedOutline}`]: {
        borderColor: (theme.vars || theme).palette.action.disabled
      }
    },
    variants: Object.keys((theme.vars ?? theme).palette).filter((key) => (theme.vars ?? theme).palette[key]?.main ?? false).map((color2) => ({
      props: {
        inputColor: color2
      },
      style: {
        [`&.${pickersOutlinedInputClasses.focused}:not(.${pickersOutlinedInputClasses.error}) .${pickersOutlinedInputClasses.notchedOutline}`]: {
          // @ts-ignore
          borderColor: (theme.vars || theme).palette[color2].main
        }
      }
    }))
  };
});
const PickersOutlinedInputSectionsContainer = styled(PickersInputBaseSectionsContainer, {
  name: "MuiPickersOutlinedInput",
  slot: "SectionsContainer"
})({
  padding: "16.5px 0",
  variants: [{
    props: {
      inputSize: "small"
    },
    style: {
      padding: "8.5px 0"
    }
  }]
});
const useUtilityClasses$h = (classes) => {
  const slots = {
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  };
  const composedClasses = composeClasses(slots, getPickersOutlinedInputUtilityClass, classes);
  return _extends({}, classes, composedClasses);
};
const PickersOutlinedInput = /* @__PURE__ */ reactExports.forwardRef(function PickersOutlinedInput2(inProps, ref2) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersOutlinedInput"
  });
  const {
    label,
    classes: classesProp,
    notched
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$o);
  const muiFormControl = useFormControl();
  const classes = useUtilityClasses$h(classesProp);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBase, _extends({
    slots: {
      root: PickersOutlinedInputRoot,
      input: PickersOutlinedInputSectionsContainer
    },
    renderSuffix: (state) => {
      const isNotched = typeof notched !== "undefined" ? notched : Boolean(state.adornedStart || state.focused || state.filled);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Outline, {
        shrink: isNotched,
        notched: isNotched,
        className: classes.notchedOutline,
        label: label != null && label !== "" && muiFormControl?.required ? /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
          children: [label, " ", "*"]
        }) : label
      });
    }
  }, other, {
    label,
    classes,
    ref: ref2
  }));
});
if (process.env.NODE_ENV !== "production") PickersOutlinedInput.displayName = "PickersOutlinedInput";
process.env.NODE_ENV !== "production" ? PickersOutlinedInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  "data-multi-input": PropTypes.string,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  notched: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  ownerState: PropTypes.any,
  readOnly: PropTypes.bool,
  renderSuffix: PropTypes.func,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.object,
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired
} : void 0;
PickersOutlinedInput.muiName = "Input";
function getPickersFilledInputUtilityClass(slot) {
  return generateUtilityClass("MuiPickersFilledInput", slot);
}
const pickersFilledInputClasses = _extends({}, pickersInputBaseClasses, generateUtilityClasses("MuiPickersFilledInput", ["root", "underline", "input"]));
const _excluded$n = ["label", "autoFocus", "disableUnderline", "hiddenLabel", "classes"];
const PickersFilledInputRoot = styled(PickersInputBaseRoot, {
  name: "MuiPickersFilledInput",
  slot: "Root",
  shouldForwardProp: (prop) => shouldForwardProp(prop) && prop !== "disableUnderline"
})(({
  theme
}) => {
  const light2 = theme.palette.mode === "light";
  const bottomLineColor = light2 ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  const backgroundColor2 = light2 ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
  const hoverBackground = light2 ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
  const disabledBackground = light2 ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor2,
    borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
    borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create("background-color", {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor2
      }
    },
    [`&.${pickersFilledInputClasses.focused}`]: {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor2
    },
    [`&.${pickersFilledInputClasses.disabled}`]: {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
    },
    variants: [...Object.keys((theme.vars ?? theme).palette).filter((key) => (theme.vars ?? theme).palette[key].main).map((color2) => ({
      props: {
        inputColor: color2,
        disableUnderline: false
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(theme.vars || theme).palette[color2]?.main}`
        }
      }
    })), {
      props: {
        disableUnderline: false
      },
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${pickersFilledInputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${pickersFilledInputClasses.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (theme.vars || theme).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: theme.transitions.create("border-bottom-color", {
            duration: theme.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${pickersFilledInputClasses.disabled}, .${pickersFilledInputClasses.error}):before`]: {
          borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${pickersFilledInputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, {
      props: {
        hasStartAdornment: true
      },
      style: {
        paddingLeft: 12
      }
    }, {
      props: {
        hasEndAdornment: true
      },
      style: {
        paddingRight: 12
      }
    }]
  };
});
const PickersFilledSectionsContainer = styled(PickersInputBaseSectionsContainer, {
  name: "MuiPickersFilledInput",
  slot: "sectionsContainer",
  shouldForwardProp: (prop) => shouldForwardProp(prop) && prop !== "hiddenLabel"
})({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  variants: [{
    props: {
      inputSize: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: {
      hasStartAdornment: true
    },
    style: {
      paddingLeft: 0
    }
  }, {
    props: {
      hasEndAdornment: true
    },
    style: {
      paddingRight: 0
    }
  }, {
    props: {
      hiddenLabel: true
    },
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: {
      hiddenLabel: true,
      inputSize: "small"
    },
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }]
});
const useUtilityClasses$g = (classes, ownerState) => {
  const {
    inputHasUnderline
  } = ownerState;
  const slots = {
    root: ["root", inputHasUnderline && "underline"],
    input: ["input"]
  };
  const composedClasses = composeClasses(slots, getPickersFilledInputUtilityClass, classes);
  return _extends({}, classes, composedClasses);
};
const PickersFilledInput = /* @__PURE__ */ reactExports.forwardRef(function PickersFilledInput2(inProps, ref2) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersFilledInput"
  });
  const {
    label,
    disableUnderline = false,
    hiddenLabel = false,
    classes: classesProp
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$n);
  const pickerTextFieldOwnerState = usePickerTextFieldOwnerState();
  const ownerState = _extends({}, pickerTextFieldOwnerState, {
    inputHasUnderline: !disableUnderline
  });
  const classes = useUtilityClasses$g(classesProp, ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBase, _extends({
    slots: {
      root: PickersFilledInputRoot,
      input: PickersFilledSectionsContainer
    },
    slotProps: {
      root: {
        disableUnderline
      },
      input: {
        hiddenLabel
      }
    }
  }, other, {
    label,
    classes,
    ref: ref2,
    ownerState
  }));
});
if (process.env.NODE_ENV !== "production") PickersFilledInput.displayName = "PickersFilledInput";
process.env.NODE_ENV !== "production" ? PickersFilledInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  "data-multi-input": PropTypes.string,
  disableUnderline: PropTypes.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  fullWidth: PropTypes.bool,
  hiddenLabel: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  ownerState: PropTypes.any,
  readOnly: PropTypes.bool,
  renderSuffix: PropTypes.func,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.object,
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired
} : void 0;
PickersFilledInput.muiName = "Input";
function getPickersInputUtilityClass(slot) {
  return generateUtilityClass("MuiPickersFilledInput", slot);
}
const pickersInputClasses = _extends({}, pickersInputBaseClasses, generateUtilityClasses("MuiPickersInput", ["root", "underline", "input"]));
const _excluded$m = ["label", "autoFocus", "disableUnderline", "ownerState", "classes"];
const PickersInputRoot = styled(PickersInputBaseRoot, {
  name: "MuiPickersInput",
  slot: "Root",
  shouldForwardProp: (prop) => shouldForwardProp(prop) && prop !== "disableUnderline"
})(({
  theme
}) => {
  const light2 = theme.palette.mode === "light";
  let bottomLineColor = light2 ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  if (theme.vars) {
    bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
  }
  return {
    "label + &": {
      marginTop: 16
    },
    variants: [...Object.keys((theme.vars ?? theme).palette).filter((key) => (theme.vars ?? theme).palette[key].main).map((color2) => ({
      props: {
        inputColor: color2,
        inputHasUnderline: true
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(theme.vars || theme).palette[color2].main}`
        }
      }
    })), {
      props: {
        inputHasUnderline: true
      },
      style: {
        "&::after": {
          background: "red",
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${pickersInputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${pickersInputClasses.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (theme.vars || theme).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${bottomLineColor}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: theme.transitions.create("border-bottom-color", {
            duration: theme.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${pickersInputClasses.disabled}, .${pickersInputClasses.error}):before`]: {
          borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${bottomLineColor}`
          }
        },
        [`&.${pickersInputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }]
  };
});
const useUtilityClasses$f = (classes, ownerState) => {
  const {
    inputHasUnderline
  } = ownerState;
  const slots = {
    root: ["root", !inputHasUnderline && "underline"],
    input: ["input"]
  };
  const composedClasses = composeClasses(slots, getPickersInputUtilityClass, classes);
  return _extends({}, classes, composedClasses);
};
const PickersInput = /* @__PURE__ */ reactExports.forwardRef(function PickersInput2(inProps, ref2) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersInput"
  });
  const {
    label,
    disableUnderline = false,
    classes: classesProp
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$m);
  const pickerTextFieldOwnerState = usePickerTextFieldOwnerState();
  const ownerState = _extends({}, pickerTextFieldOwnerState, {
    inputHasUnderline: !disableUnderline
  });
  const classes = useUtilityClasses$f(classesProp, ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBase, _extends({
    slots: {
      root: PickersInputRoot
    },
    slotProps: {
      root: {
        disableUnderline
      }
    }
  }, other, {
    ownerState,
    label,
    classes,
    ref: ref2
  }));
});
if (process.env.NODE_ENV !== "production") PickersInput.displayName = "PickersInput";
process.env.NODE_ENV !== "production" ? PickersInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  "data-multi-input": PropTypes.string,
  disableUnderline: PropTypes.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  ownerState: PropTypes.any,
  readOnly: PropTypes.bool,
  renderSuffix: PropTypes.func,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.object,
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired
} : void 0;
PickersInput.muiName = "Input";
const _excluded$l = ["onFocus", "onBlur", "className", "classes", "color", "disabled", "error", "variant", "required", "hiddenLabel", "InputProps", "inputProps", "inputRef", "sectionListRef", "elements", "areAllSectionsEmpty", "onClick", "onMouseDown", "onKeyDown", "onKeyUp", "onPaste", "onInput", "endAdornment", "startAdornment", "tabIndex", "contentEditable", "focused", "value", "onChange", "fullWidth", "id", "name", "helperText", "FormHelperTextProps", "label", "InputLabelProps", "data-active-range-position"];
const VARIANT_COMPONENT = {
  standard: PickersInput,
  filled: PickersFilledInput,
  outlined: PickersOutlinedInput
};
const PickersTextFieldRoot = styled(FormControl, {
  name: "MuiPickersTextField",
  slot: "Root"
})({
  maxWidth: "100%"
});
const useUtilityClasses$e = (classes, ownerState) => {
  const {
    isFieldFocused: isFieldFocused2,
    isFieldDisabled,
    isFieldRequired
  } = ownerState;
  const slots = {
    root: ["root", isFieldFocused2 && !isFieldDisabled && "focused", isFieldDisabled && "disabled", isFieldRequired && "required"]
  };
  return composeClasses(slots, getPickersTextFieldUtilityClass, classes);
};
const PickersTextField = /* @__PURE__ */ reactExports.forwardRef(function PickersTextField2(inProps, ref2) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersTextField"
  });
  const {
    // Props used by FormControl
    onFocus,
    onBlur,
    className,
    classes: classesProp,
    color: color2 = "primary",
    disabled = false,
    error = false,
    variant = "outlined",
    required = false,
    hiddenLabel = false,
    // Props used by PickersInput
    InputProps,
    inputProps,
    inputRef,
    sectionListRef,
    elements,
    areAllSectionsEmpty,
    onClick,
    onMouseDown,
    onKeyDown,
    onKeyUp,
    onPaste,
    onInput,
    endAdornment,
    startAdornment,
    tabIndex,
    contentEditable,
    focused,
    value,
    onChange,
    fullWidth,
    id: idProp,
    name,
    // Props used by FormHelperText
    helperText,
    FormHelperTextProps,
    // Props used by InputLabel
    label,
    InputLabelProps,
    // @ts-ignore
    "data-active-range-position": dataActiveRangePosition
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$l);
  const rootRef = reactExports.useRef(null);
  const handleRootRef = useForkRef(ref2, rootRef);
  const id = useId(idProp);
  const helperTextId = helperText && id ? `${id}-helper-text` : void 0;
  const inputLabelId = label && id ? `${id}-label` : void 0;
  const fieldOwnerState = useFieldOwnerState({
    disabled: props.disabled,
    required: props.required,
    readOnly: InputProps?.readOnly
  });
  const ownerState = reactExports.useMemo(() => _extends({}, fieldOwnerState, {
    isFieldValueEmpty: areAllSectionsEmpty,
    isFieldFocused: focused ?? false,
    hasFieldError: error ?? false,
    inputSize: props.size ?? "medium",
    inputColor: color2 ?? "primary",
    isInputInFullWidth: fullWidth ?? false,
    hasStartAdornment: Boolean(startAdornment ?? InputProps?.startAdornment),
    hasEndAdornment: Boolean(endAdornment ?? InputProps?.endAdornment),
    inputHasLabel: !!label,
    isLabelShrunk: Boolean(InputLabelProps?.shrink)
  }), [fieldOwnerState, areAllSectionsEmpty, focused, error, props.size, color2, fullWidth, startAdornment, endAdornment, InputProps?.startAdornment, InputProps?.endAdornment, label, InputLabelProps?.shrink]);
  const classes = useUtilityClasses$e(classesProp, ownerState);
  const PickersInputComponent = VARIANT_COMPONENT[variant];
  const inputAdditionalProps = {};
  if (variant === "outlined") {
    if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") {
      inputAdditionalProps.notched = InputLabelProps.shrink;
    }
    inputAdditionalProps.label = label;
  } else if (variant === "filled") {
    inputAdditionalProps.hiddenLabel = hiddenLabel;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickerTextFieldOwnerStateContext.Provider, {
    value: ownerState,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersTextFieldRoot, _extends({
      className: clsx(classes.root, className),
      ref: handleRootRef,
      focused,
      disabled,
      variant,
      error,
      color: color2,
      fullWidth,
      required,
      ownerState
    }, other, {
      children: [label != null && label !== "" && /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, _extends({
        htmlFor: id,
        id: inputLabelId
      }, InputLabelProps, {
        children: label
      })), /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputComponent, _extends({
        elements,
        areAllSectionsEmpty,
        onClick,
        onMouseDown,
        onKeyDown,
        onKeyUp,
        onInput,
        onPaste,
        onFocus,
        onBlur,
        endAdornment,
        startAdornment,
        tabIndex,
        contentEditable,
        value,
        onChange,
        id,
        fullWidth,
        inputProps,
        inputRef,
        sectionListRef,
        label,
        name,
        role: "group",
        "aria-labelledby": inputLabelId,
        "aria-describedby": helperTextId,
        "aria-live": helperTextId ? "polite" : void 0,
        "data-active-range-position": dataActiveRangePosition
      }, inputAdditionalProps, InputProps)), helperText && /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, _extends({
        id: helperTextId
      }, FormHelperTextProps, {
        children: helperText
      }))]
    }))
  });
});
if (process.env.NODE_ENV !== "production") PickersTextField.displayName = "PickersTextField";
process.env.NODE_ENV !== "production" ? PickersTextField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  error: PropTypes.bool.isRequired,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  FormHelperTextProps: PropTypes.object,
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  id: PropTypes.string,
  InputLabelProps: PropTypes.object,
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: PropTypes.bool,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOf(["medium", "small"]),
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
} : void 0;
const _excluded$k = ["enableAccessibleFieldDOMStructure"], _excluded2$5 = ["InputProps", "readOnly", "onClear", "clearable", "clearButtonPosition", "openPickerButtonPosition", "openPickerAriaLabel"], _excluded3 = ["onPaste", "onKeyDown", "inputMode", "readOnly", "InputProps", "inputProps", "inputRef", "onClear", "clearable", "clearButtonPosition", "openPickerButtonPosition", "openPickerAriaLabel"], _excluded4 = ["ownerState"], _excluded5 = ["ownerState"], _excluded6 = ["ownerState"], _excluded7 = ["ownerState"], _excluded8 = ["InputProps", "inputProps"];
const noop$1 = () => {
};
const cleanFieldResponse = (_ref) => {
  let {
    enableAccessibleFieldDOMStructure
  } = _ref, fieldResponse = _objectWithoutPropertiesLoose(_ref, _excluded$k);
  if (enableAccessibleFieldDOMStructure) {
    const {
      InputProps: InputProps2,
      readOnly: readOnly2,
      onClear: onClear2,
      clearable: clearable2,
      clearButtonPosition: clearButtonPosition2,
      openPickerButtonPosition: openPickerButtonPosition2,
      openPickerAriaLabel: openPickerAriaLabel2
    } = fieldResponse, other2 = _objectWithoutPropertiesLoose(fieldResponse, _excluded2$5);
    const mergedInputProps2 = major >= 6 && other2?.slotProps?.input ? mergeSlotProps(other2?.slotProps?.input, InputProps2) : noop$1;
    return {
      clearable: clearable2,
      onClear: onClear2,
      clearButtonPosition: clearButtonPosition2,
      openPickerButtonPosition: openPickerButtonPosition2,
      openPickerAriaLabel: openPickerAriaLabel2,
      textFieldProps: _extends({}, other2, major >= 6 && other2?.slotProps?.input ? {
        slotProps: _extends({}, other2?.slotProps, {
          input: (ownerState) => _extends({}, resolveComponentProps(mergedInputProps2, ownerState), {
            readOnly: readOnly2
          })
        })
      } : {
        InputProps: _extends({}, InputProps2 ?? {}, {
          readOnly: readOnly2
        })
      })
    };
  }
  const {
    onPaste,
    onKeyDown,
    inputMode,
    readOnly,
    InputProps,
    inputProps,
    inputRef,
    onClear,
    clearable,
    clearButtonPosition,
    openPickerButtonPosition,
    openPickerAriaLabel
  } = fieldResponse, other = _objectWithoutPropertiesLoose(fieldResponse, _excluded3);
  const mergedInputProps = major >= 6 && other?.slotProps?.input ? mergeSlotProps(other?.slotProps?.input, InputProps) : noop$1;
  const mergedHtmlInputProps = major >= 6 && other?.slotProps?.htmlInput ? mergeSlotProps(other?.slotProps?.htmlInput, inputProps) : noop$1;
  return {
    clearable,
    onClear,
    clearButtonPosition,
    openPickerButtonPosition,
    openPickerAriaLabel,
    textFieldProps: _extends({}, other, major >= 6 && (other?.slotProps?.input || other?.slotProps?.htmlInput) ? {
      slotProps: _extends({}, other?.slotProps, {
        input: (ownerState) => _extends({}, resolveComponentProps(mergedInputProps, ownerState), {
          readOnly
        }),
        htmlInput: (ownerState) => _extends({}, resolveComponentProps(mergedHtmlInputProps, ownerState), {
          inputMode,
          onPaste,
          onKeyDown,
          ref: inputRef
        })
      })
    } : {
      InputProps: _extends({}, InputProps ?? {}, {
        readOnly
      }),
      inputProps: _extends({}, inputProps ?? {}, {
        inputMode,
        onPaste,
        onKeyDown,
        ref: inputRef
      })
    })
  };
};
const PickerFieldUIContext = /* @__PURE__ */ reactExports.createContext({
  slots: {},
  slotProps: {},
  inputRef: void 0
});
if (process.env.NODE_ENV !== "production") PickerFieldUIContext.displayName = "PickerFieldUIContext";
function PickerFieldUI(props) {
  const {
    fieldResponse,
    defaultOpenPickerIcon
  } = props;
  const translations = usePickerTranslations();
  const pickerContext = useNullablePickerContext();
  const pickerFieldUIContext = reactExports.useContext(PickerFieldUIContext);
  const {
    textFieldProps,
    onClear,
    clearable,
    openPickerAriaLabel,
    clearButtonPosition: clearButtonPositionProp = "end",
    openPickerButtonPosition: openPickerButtonPositionProp = "end"
  } = cleanFieldResponse(fieldResponse);
  const ownerState = useFieldOwnerState(textFieldProps);
  const handleClickOpeningButton = useEventCallback((event2) => {
    event2.preventDefault();
    pickerContext?.setOpen((prev2) => !prev2);
  });
  const triggerStatus = pickerContext ? pickerContext.triggerStatus : "hidden";
  const clearButtonPosition = clearable ? clearButtonPositionProp : null;
  const openPickerButtonPosition = triggerStatus !== "hidden" ? openPickerButtonPositionProp : null;
  const TextField$1 = pickerFieldUIContext.slots.textField ?? (fieldResponse.enableAccessibleFieldDOMStructure === false ? TextField : PickersTextField);
  const InputAdornment$1 = pickerFieldUIContext.slots.inputAdornment ?? InputAdornment;
  const _useSlotProps = useSlotProps({
    elementType: InputAdornment$1,
    externalSlotProps: pickerFieldUIContext.slotProps.inputAdornment,
    additionalProps: {
      position: "start"
    },
    ownerState: _extends({}, ownerState, {
      position: "start"
    })
  }), startInputAdornmentProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded4);
  const _useSlotProps2 = useSlotProps({
    elementType: InputAdornment$1,
    externalSlotProps: pickerFieldUIContext.slotProps.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: _extends({}, ownerState, {
      position: "end"
    })
  }), endInputAdornmentProps = _objectWithoutPropertiesLoose(_useSlotProps2, _excluded5);
  const OpenPickerButton = pickerFieldUIContext.slots.openPickerButton ?? IconButton;
  const _useSlotProps3 = useSlotProps({
    elementType: OpenPickerButton,
    externalSlotProps: pickerFieldUIContext.slotProps.openPickerButton,
    additionalProps: {
      disabled: triggerStatus === "disabled",
      onClick: handleClickOpeningButton,
      "aria-label": openPickerAriaLabel,
      edge: (
        // open button is always rendered at the edge
        textFieldProps.variant !== "standard" ? openPickerButtonPosition : false
      )
    },
    ownerState
  }), openPickerButtonProps = _objectWithoutPropertiesLoose(_useSlotProps3, _excluded6);
  const OpenPickerIcon = pickerFieldUIContext.slots.openPickerIcon ?? defaultOpenPickerIcon;
  const openPickerIconProps = useSlotProps({
    elementType: OpenPickerIcon,
    externalSlotProps: pickerFieldUIContext.slotProps.openPickerIcon,
    ownerState
  });
  const ClearButton = pickerFieldUIContext.slots.clearButton ?? IconButton;
  const _useSlotProps4 = useSlotProps({
    elementType: ClearButton,
    externalSlotProps: pickerFieldUIContext.slotProps.clearButton,
    className: "clearButton",
    additionalProps: {
      title: translations.fieldClearLabel,
      tabIndex: -1,
      onClick: onClear,
      disabled: fieldResponse.disabled || fieldResponse.readOnly,
      edge: (
        // clear button can only be at the edge if it's position differs from the open button
        textFieldProps.variant !== "standard" && clearButtonPosition !== openPickerButtonPosition ? clearButtonPosition : false
      )
    },
    ownerState
  }), clearButtonProps = _objectWithoutPropertiesLoose(_useSlotProps4, _excluded7);
  const ClearIcon$12 = pickerFieldUIContext.slots.clearIcon ?? ClearIcon;
  const clearIconProps = useSlotProps({
    elementType: ClearIcon$12,
    externalSlotProps: pickerFieldUIContext.slotProps.clearIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState
  });
  textFieldProps.ref = useForkRef(textFieldProps.ref, pickerContext?.rootRef);
  const additionalTextFieldInputProps = {};
  const textFieldInputProps = resolveComponentProps((major >= 6 && textFieldProps?.slotProps?.input) ?? textFieldProps.InputProps, ownerState);
  if (pickerContext) {
    additionalTextFieldInputProps.ref = pickerContext.triggerRef;
  }
  if (!textFieldInputProps?.startAdornment && (clearButtonPosition === "start" || openPickerButtonPosition === "start")) {
    additionalTextFieldInputProps.startAdornment = /* @__PURE__ */ jsxRuntimeExports.jsxs(InputAdornment$1, _extends({}, startInputAdornmentProps, {
      children: [openPickerButtonPosition === "start" && /* @__PURE__ */ jsxRuntimeExports.jsx(OpenPickerButton, _extends({}, openPickerButtonProps, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(OpenPickerIcon, _extends({}, openPickerIconProps))
      })), clearButtonPosition === "start" && /* @__PURE__ */ jsxRuntimeExports.jsx(ClearButton, _extends({}, clearButtonProps, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ClearIcon$12, _extends({}, clearIconProps))
      }))]
    }));
  }
  if (!textFieldInputProps?.endAdornment && (clearButtonPosition === "end" || openPickerButtonPosition === "end")) {
    additionalTextFieldInputProps.endAdornment = /* @__PURE__ */ jsxRuntimeExports.jsxs(InputAdornment$1, _extends({}, endInputAdornmentProps, {
      children: [clearButtonPosition === "end" && /* @__PURE__ */ jsxRuntimeExports.jsx(ClearButton, _extends({}, clearButtonProps, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ClearIcon$12, _extends({}, clearIconProps))
      })), openPickerButtonPosition === "end" && /* @__PURE__ */ jsxRuntimeExports.jsx(OpenPickerButton, _extends({}, openPickerButtonProps, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(OpenPickerIcon, _extends({}, openPickerIconProps))
      }))]
    }));
  }
  if (!additionalTextFieldInputProps?.endAdornment && !additionalTextFieldInputProps?.startAdornment && pickerFieldUIContext.slots.inputAdornment) {
    additionalTextFieldInputProps.endAdornment = /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornment$1, _extends({}, endInputAdornmentProps));
  }
  if (clearButtonPosition != null) {
    textFieldProps.sx = [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(textFieldProps.sx) ? textFieldProps.sx : [textFieldProps.sx]];
  }
  const resolvedTextFieldInputProps = major >= 6 && textFieldProps?.slotProps?.input ? resolveComponentProps(mergeSlotProps(textFieldInputProps, additionalTextFieldInputProps), ownerState) : _extends({}, textFieldInputProps, additionalTextFieldInputProps);
  textFieldProps.inputProps = major >= 6 && textFieldProps?.slotProps?.htmlInput ? resolveComponentProps(textFieldProps.slotProps.htmlInput, ownerState) : textFieldProps.inputProps;
  delete textFieldProps?.slotProps?.input;
  if (fieldResponse.enableAccessibleFieldDOMStructure) {
    delete textFieldProps?.slotProps;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TextField$1, _extends({}, textFieldProps, {
    InputProps: resolvedTextFieldInputProps
  }));
}
function mergeSlotProps(slotPropsA, slotPropsB) {
  if (!slotPropsA) {
    return slotPropsB;
  }
  if (!slotPropsB) {
    return slotPropsA;
  }
  return (ownerState) => {
    return _extends({}, resolveComponentProps(slotPropsB, ownerState), resolveComponentProps(slotPropsA, ownerState));
  };
}
function useFieldTextFieldProps(parameters) {
  const {
    ref: ref2,
    externalForwardedProps,
    slotProps
  } = parameters;
  const pickerFieldUIContext = reactExports.useContext(PickerFieldUIContext);
  const pickerContext = useNullablePickerContext();
  const ownerState = useFieldOwnerState(externalForwardedProps);
  const {
    InputProps,
    inputProps
  } = externalForwardedProps, otherExternalForwardedProps = _objectWithoutPropertiesLoose(externalForwardedProps, _excluded8);
  const textFieldProps = useSlotProps({
    elementType: PickersTextField,
    externalSlotProps: mergeSlotProps(pickerFieldUIContext.slotProps.textField, slotProps?.textField),
    externalForwardedProps: otherExternalForwardedProps,
    additionalProps: {
      ref: ref2,
      sx: pickerContext?.rootSx,
      label: pickerContext?.label,
      name: pickerContext?.name,
      className: pickerContext?.rootClassName,
      inputRef: pickerFieldUIContext.inputRef
    },
    ownerState
  });
  textFieldProps.inputProps = _extends({}, inputProps, textFieldProps.inputProps);
  textFieldProps.InputProps = _extends({}, InputProps, textFieldProps.InputProps);
  return textFieldProps;
}
function PickerFieldUIContextProvider(props) {
  const {
    slots = {},
    slotProps = {},
    inputRef,
    children
  } = props;
  const contextValue = reactExports.useMemo(() => ({
    inputRef,
    slots: {
      openPickerButton: slots.openPickerButton,
      openPickerIcon: slots.openPickerIcon,
      textField: slots.textField,
      inputAdornment: slots.inputAdornment,
      clearIcon: slots.clearIcon,
      clearButton: slots.clearButton
    },
    slotProps: {
      openPickerButton: slotProps.openPickerButton,
      openPickerIcon: slotProps.openPickerIcon,
      textField: slotProps.textField,
      inputAdornment: slotProps.inputAdornment,
      clearIcon: slotProps.clearIcon,
      clearButton: slotProps.clearButton
    }
  }), [inputRef, slots.openPickerButton, slots.openPickerIcon, slots.textField, slots.inputAdornment, slots.clearIcon, slots.clearButton, slotProps.openPickerButton, slotProps.openPickerIcon, slotProps.textField, slotProps.inputAdornment, slotProps.clearIcon, slotProps.clearButton]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickerFieldUIContext.Provider, {
    value: contextValue,
    children
  });
}
const _excluded$j = ["slots", "slotProps"];
const DateField = /* @__PURE__ */ reactExports.forwardRef(function DateField2(inProps, inRef) {
  const themeProps = useThemeProps({
    props: inProps,
    name: "MuiDateField"
  });
  const {
    slots,
    slotProps
  } = themeProps, other = _objectWithoutPropertiesLoose(themeProps, _excluded$j);
  const textFieldProps = useFieldTextFieldProps({
    slotProps,
    ref: inRef,
    externalForwardedProps: other
  });
  const fieldResponse = useDateField(textFieldProps);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickerFieldUIContextProvider, {
    slots,
    slotProps,
    inputRef: other.inputRef,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickerFieldUI, {
      fieldResponse,
      defaultOpenPickerIcon: CalendarIcon$1
    })
  });
});
if (process.env.NODE_ENV !== "production") DateField.displayName = "DateField";
process.env.NODE_ENV !== "production" ? DateField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: PropTypes.bool,
  /**
   * The position at which the clear button is placed.
   * If the field is not clearable, the button is not rendered.
   * @default 'end'
   */
  clearButtonPosition: PropTypes.oneOf(["end", "start"]),
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: PropTypes.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * @default true
   */
  enableAccessibleFieldDOMStructure: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: PropTypes.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: PropTypes.func,
  onFocus: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * The position at which the opening button is placed.
   * If there is no Picker to open, the button is not rendered
   * @default 'end'
   */
  openPickerButtonPosition: PropTypes.oneOf(["end", "start"]),
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: PropTypes.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, the format will respect the leading zeroes (for example on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (for example on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (for example "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
} : void 0;
const useIsDateDisabled = ({
  shouldDisableDate,
  shouldDisableMonth,
  shouldDisableYear,
  minDate,
  maxDate,
  disableFuture,
  disablePast,
  timezone
}) => {
  const adapter = usePickerAdapter();
  return reactExports.useCallback((day) => validateDate({
    adapter,
    value: day,
    timezone,
    props: {
      shouldDisableDate,
      shouldDisableMonth,
      shouldDisableYear,
      minDate,
      maxDate,
      disableFuture,
      disablePast
    }
  }) !== null, [adapter, shouldDisableDate, shouldDisableMonth, shouldDisableYear, minDate, maxDate, disableFuture, disablePast, timezone]);
};
const createCalendarStateReducer = (reduceAnimations, adapter) => (state, action) => {
  switch (action.type) {
    case "setVisibleDate":
      return _extends({}, state, {
        slideDirection: action.direction,
        currentMonth: action.month,
        isMonthSwitchingAnimating: !adapter.isSameMonth(action.month, state.currentMonth) && !reduceAnimations && !action.skipAnimation,
        focusedDay: action.focusedDay
      });
    case "changeMonthTimezone": {
      const newTimezone = action.newTimezone;
      if (adapter.getTimezone(state.currentMonth) === newTimezone) {
        return state;
      }
      let newCurrentMonth = adapter.setTimezone(state.currentMonth, newTimezone);
      if (adapter.getMonth(newCurrentMonth) !== adapter.getMonth(state.currentMonth)) {
        newCurrentMonth = adapter.setMonth(newCurrentMonth, adapter.getMonth(state.currentMonth));
      }
      return _extends({}, state, {
        currentMonth: newCurrentMonth
      });
    }
    case "finishMonthSwitchingAnimation":
      return _extends({}, state, {
        isMonthSwitchingAnimating: false
      });
    default:
      throw new Error("missing support");
  }
};
const useCalendarState = (params) => {
  const {
    value,
    referenceDate: referenceDateProp,
    disableFuture,
    disablePast,
    maxDate,
    minDate,
    onMonthChange,
    onYearChange,
    reduceAnimations,
    shouldDisableDate,
    timezone,
    getCurrentMonthFromVisibleDate
  } = params;
  const adapter = usePickerAdapter();
  const reducerFn = reactExports.useRef(createCalendarStateReducer(Boolean(reduceAnimations), adapter)).current;
  const referenceDate = reactExports.useMemo(
    () => {
      return singleItemValueManager.getInitialReferenceValue({
        value,
        adapter,
        timezone,
        props: params,
        referenceDate: referenceDateProp,
        granularity: SECTION_TYPE_GRANULARITY.day
      });
    },
    // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [referenceDateProp, timezone]
  );
  const [calendarState, dispatch] = reactExports.useReducer(reducerFn, {
    isMonthSwitchingAnimating: false,
    focusedDay: referenceDate,
    // Keep the time from the reference date when computing the current month anchor.
    // Using startOfMonth would reset the time to 00:00 which breaks expectations
    // that month selections preserve the referenceDate time when no value is provided.
    // See tests: "should use `referenceDate` when no value defined".
    currentMonth: adapter.setDate(referenceDate, 1),
    slideDirection: "left"
  });
  const isDateDisabled = useIsDateDisabled({
    shouldDisableDate,
    minDate,
    maxDate,
    disableFuture,
    disablePast,
    timezone
  });
  reactExports.useEffect(() => {
    dispatch({
      type: "changeMonthTimezone",
      newTimezone: adapter.getTimezone(referenceDate)
    });
  }, [referenceDate, adapter]);
  const setVisibleDate = useEventCallback(({
    target,
    reason
  }) => {
    if (reason === "cell-interaction" && calendarState.focusedDay != null && adapter.isSameDay(target, calendarState.focusedDay)) {
      return;
    }
    const skipAnimation = reason === "cell-interaction";
    let month;
    let focusedDay;
    if (reason === "cell-interaction") {
      month = getCurrentMonthFromVisibleDate(target, calendarState.currentMonth);
      focusedDay = target;
    } else {
      month = adapter.isSameMonth(target, calendarState.currentMonth) ? calendarState.currentMonth : adapter.startOfMonth(target);
      focusedDay = target;
      if (isDateDisabled(focusedDay)) {
        const startOfMonth = adapter.startOfMonth(target);
        const endOfMonth = adapter.endOfMonth(target);
        focusedDay = findClosestEnabledDate({
          adapter,
          date: focusedDay,
          minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
          maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
          disablePast,
          disableFuture,
          isDateDisabled,
          timezone
        });
      }
    }
    const hasChangedMonth = !adapter.isSameMonth(calendarState.currentMonth, month);
    const hasChangedYear = !adapter.isSameYear(calendarState.currentMonth, month);
    if (hasChangedMonth) {
      onMonthChange?.(month);
    }
    if (hasChangedYear) {
      onYearChange?.(adapter.startOfYear(month));
    }
    dispatch({
      type: "setVisibleDate",
      month,
      direction: adapter.isAfterDay(month, calendarState.currentMonth) ? "left" : "right",
      focusedDay: calendarState.focusedDay != null && focusedDay != null && adapter.isSameDay(focusedDay, calendarState.focusedDay) ? calendarState.focusedDay : focusedDay,
      skipAnimation
    });
  });
  const onMonthSwitchingAnimationEnd = reactExports.useCallback(() => {
    dispatch({
      type: "finishMonthSwitchingAnimation"
    });
  }, []);
  return {
    referenceDate,
    calendarState,
    setVisibleDate,
    isDateDisabled,
    onMonthSwitchingAnimationEnd
  };
};
const getPickersFadeTransitionGroupUtilityClass = (slot) => generateUtilityClass("MuiPickersFadeTransitionGroup", slot);
generateUtilityClasses("MuiPickersFadeTransitionGroup", ["root"]);
const _excluded$i = ["children"];
const useUtilityClasses$d = (classes) => {
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getPickersFadeTransitionGroupUtilityClass, classes);
};
const PickersFadeTransitionGroupRoot = styled(TransitionGroup, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root"
})({
  display: "block",
  position: "relative"
});
function PickersFadeTransitionGroup(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersFadeTransitionGroup"
  });
  const {
    className,
    reduceAnimations,
    transKey,
    classes: classesProp
  } = props;
  const {
    children
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$i);
  const classes = useUtilityClasses$d(classesProp);
  const theme = useTheme();
  if (reduceAnimations) {
    return children;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersFadeTransitionGroupRoot, {
    className: clsx(classes.root, className),
    ownerState: other,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Fade, {
      appear: false,
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: {
        appear: theme.transitions.duration.enteringScreen,
        enter: theme.transitions.duration.enteringScreen,
        exit: 0
      },
      children
    }, transKey)
  });
}
const getPickersSlideTransitionUtilityClass = (slot) => generateUtilityClass("MuiPickersSlideTransition", slot);
const pickersSlideTransitionClasses = generateUtilityClasses("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]);
const _excluded$h = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"];
const useUtilityClasses$c = (classes, ownerState) => {
  const {
    slideDirection
  } = ownerState;
  const slots = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${slideDirection}`],
    exitActive: [`slideExitActiveLeft-${slideDirection}`]
  };
  return composeClasses(slots, getPickersSlideTransitionUtilityClass, classes);
};
const PickersSlideTransitionRoot = styled(TransitionGroup, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (_, styles2) => [styles2.root, {
    [`.${pickersSlideTransitionClasses["slideEnter-left"]}`]: styles2["slideEnter-left"]
  }, {
    [`.${pickersSlideTransitionClasses["slideEnter-right"]}`]: styles2["slideEnter-right"]
  }, {
    [`.${pickersSlideTransitionClasses.slideEnterActive}`]: styles2.slideEnterActive
  }, {
    [`.${pickersSlideTransitionClasses.slideExit}`]: styles2.slideExit
  }, {
    [`.${pickersSlideTransitionClasses["slideExitActiveLeft-left"]}`]: styles2["slideExitActiveLeft-left"]
  }, {
    [`.${pickersSlideTransitionClasses["slideExitActiveLeft-right"]}`]: styles2["slideExitActiveLeft-right"]
  }]
})(({
  theme
}) => {
  const slideTransition = theme.transitions.create("transform", {
    duration: theme.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${pickersSlideTransitionClasses["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: slideTransition
    },
    [`& .${pickersSlideTransitionClasses.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${pickersSlideTransitionClasses["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: slideTransition,
      zIndex: 0
    },
    [`& .${pickersSlideTransitionClasses["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: slideTransition,
      zIndex: 0
    }
  };
});
function PickersSlideTransition(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersSlideTransition"
  });
  const {
    children,
    className,
    reduceAnimations,
    slideDirection,
    transKey,
    classes: classesProp
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$h);
  const {
    ownerState: pickerOwnerState
  } = usePickerPrivateContext();
  const ownerState = _extends({}, pickerOwnerState, {
    slideDirection
  });
  const classes = useUtilityClasses$c(classesProp, ownerState);
  const theme = useTheme();
  if (reduceAnimations) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: clsx(classes.root, className),
      children
    });
  }
  const transitionClasses = {
    exit: classes.exit,
    enterActive: classes.enterActive,
    enter: classes.enter,
    exitActive: classes.exitActive
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersSlideTransitionRoot, {
    className: clsx(classes.root, className),
    childFactory: (element) => /* @__PURE__ */ reactExports.cloneElement(element, {
      classNames: transitionClasses
    }),
    role: "presentation",
    ownerState,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(CSSTransition, _extends({
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: theme.transitions.duration.complex,
      classNames: transitionClasses
    }, other, {
      children
    }), transKey)
  });
}
const getDayCalendarUtilityClass = (slot) => generateUtilityClass("MuiDayCalendar", slot);
generateUtilityClasses("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
const _excluded$g = ["parentProps", "day", "focusedDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"], _excluded2$4 = ["ownerState"];
const useUtilityClasses$b = (classes) => {
  const slots = {
    root: ["root"],
    header: ["header"],
    weekDayLabel: ["weekDayLabel"],
    loadingContainer: ["loadingContainer"],
    slideTransition: ["slideTransition"],
    monthContainer: ["monthContainer"],
    weekContainer: ["weekContainer"],
    weekNumberLabel: ["weekNumberLabel"],
    weekNumber: ["weekNumber"]
  };
  return composeClasses(slots, getDayCalendarUtilityClass, classes);
};
const weeksContainerHeight = (DAY_SIZE + DAY_MARGIN * 2) * 6;
const PickersCalendarDayRoot = styled("div", {
  name: "MuiDayCalendar",
  slot: "Root"
})({});
const PickersCalendarDayHeader = styled("div", {
  name: "MuiDayCalendar",
  slot: "Header"
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});
const PickersCalendarWeekDayLabel = styled(Typography$1, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel"
})(({
  theme
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (theme.vars || theme).palette.text.secondary
}));
const PickersCalendarWeekNumberLabel = styled(Typography$1, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel"
})(({
  theme
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (theme.vars || theme).palette.text.disabled
}));
const PickersCalendarWeekNumber = styled(Typography$1, {
  name: "MuiDayCalendar",
  slot: "WeekNumber"
})(({
  theme
}) => _extends({}, theme.typography.caption, {
  width: DAY_SIZE,
  height: DAY_SIZE,
  padding: 0,
  margin: `0 ${DAY_MARGIN}px`,
  color: (theme.vars || theme).palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
}));
const PickersCalendarLoadingContainer = styled("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer"
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: weeksContainerHeight
});
const PickersCalendarSlideTransition = styled(PickersSlideTransition, {
  name: "MuiDayCalendar",
  slot: "SlideTransition"
})({
  minHeight: weeksContainerHeight
});
const PickersCalendarWeekContainer = styled("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer"
})({
  overflow: "hidden"
});
const PickersCalendarWeek = styled("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer"
})({
  margin: `${DAY_MARGIN}px 0`,
  display: "flex",
  justifyContent: "center"
});
function WrappedDay(_ref) {
  let {
    parentProps,
    day,
    focusedDay,
    selectedDays,
    isDateDisabled,
    currentMonthNumber,
    isViewFocused
  } = _ref, other = _objectWithoutPropertiesLoose(_ref, _excluded$g);
  const {
    disabled,
    disableHighlightToday,
    isMonthSwitchingAnimating,
    showDaysOutsideCurrentMonth,
    slots,
    slotProps,
    timezone
  } = parentProps;
  const adapter = usePickerAdapter();
  const now2 = useNow(timezone);
  const isFocusableDay = focusedDay != null && adapter.isSameDay(day, focusedDay);
  const isFocusedDay = isViewFocused && isFocusableDay;
  const isSelected = selectedDays.some((selectedDay) => adapter.isSameDay(selectedDay, day));
  const isToday = adapter.isSameDay(day, now2);
  const isDisabled = reactExports.useMemo(() => disabled || isDateDisabled(day), [disabled, isDateDisabled, day]);
  const isOutsideCurrentMonth = reactExports.useMemo(() => adapter.getMonth(day) !== currentMonthNumber, [adapter, day, currentMonthNumber]);
  const ownerState = usePickerDayOwnerState({
    day,
    selected: isSelected,
    disabled: isDisabled,
    today: isToday,
    outsideCurrentMonth: isOutsideCurrentMonth,
    disableMargin: void 0,
    // This prop can only be defined using slotProps.day so the ownerState for useSlotProps cannot have its value.
    disableHighlightToday,
    showDaysOutsideCurrentMonth
  });
  const Day = slots?.day ?? PickersDay2;
  const _useSlotProps = useSlotProps({
    elementType: Day,
    externalSlotProps: slotProps?.day,
    additionalProps: _extends({
      disableHighlightToday,
      showDaysOutsideCurrentMonth,
      role: "gridcell",
      isAnimating: isMonthSwitchingAnimating,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": adapter.toJsDate(day).valueOf()
    }, other),
    ownerState: _extends({}, ownerState, {
      day,
      isDayDisabled: isDisabled,
      isDaySelected: isSelected
    })
  }), dayProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded2$4);
  const isFirstVisibleCell = reactExports.useMemo(() => {
    const startOfMonth = adapter.startOfMonth(adapter.setMonth(day, currentMonthNumber));
    if (!showDaysOutsideCurrentMonth) {
      return adapter.isSameDay(day, startOfMonth);
    }
    return adapter.isSameDay(day, adapter.startOfWeek(startOfMonth));
  }, [currentMonthNumber, day, showDaysOutsideCurrentMonth, adapter]);
  const isLastVisibleCell = reactExports.useMemo(() => {
    const endOfMonth = adapter.endOfMonth(adapter.setMonth(day, currentMonthNumber));
    if (!showDaysOutsideCurrentMonth) {
      return adapter.isSameDay(day, endOfMonth);
    }
    return adapter.isSameDay(day, adapter.endOfWeek(endOfMonth));
  }, [currentMonthNumber, day, showDaysOutsideCurrentMonth, adapter]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Day, _extends({}, dayProps, {
    day,
    disabled: isDisabled,
    autoFocus: !isOutsideCurrentMonth && isFocusedDay,
    today: isToday,
    outsideCurrentMonth: isOutsideCurrentMonth,
    isFirstVisibleCell,
    isLastVisibleCell,
    selected: isSelected,
    tabIndex: isFocusableDay ? 0 : -1,
    "aria-selected": isSelected,
    "aria-current": isToday ? "date" : void 0
  }));
}
function DayCalendar(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiDayCalendar"
  });
  const adapter = usePickerAdapter();
  const {
    onFocusedDayChange,
    className,
    classes: classesProp,
    currentMonth,
    selectedDays,
    focusedDay,
    loading,
    onSelectedDaysChange,
    onMonthSwitchingAnimationEnd,
    readOnly,
    reduceAnimations,
    renderLoading = () => /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      children: "..."
    }),
    slideDirection,
    TransitionProps,
    disablePast,
    disableFuture,
    minDate,
    maxDate,
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    dayOfWeekFormatter = (date) => adapter.format(date, "weekdayShort").charAt(0).toUpperCase(),
    hasFocus,
    onFocusedViewChange,
    gridLabelId,
    displayWeekNumber,
    fixedWeekNumber,
    timezone
  } = props;
  const now2 = useNow(timezone);
  const classes = useUtilityClasses$b(classesProp);
  const isRtl = useRtl();
  const isDateDisabled = useIsDateDisabled({
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    minDate,
    maxDate,
    disablePast,
    disableFuture,
    timezone
  });
  const translations = usePickerTranslations();
  const handleDaySelect = useEventCallback((day) => {
    if (readOnly) {
      return;
    }
    onSelectedDaysChange(day);
  });
  const focusDay = (day) => {
    if (!isDateDisabled(day)) {
      onFocusedDayChange(day);
      onFocusedViewChange?.(true);
    }
  };
  const handleKeyDown = useEventCallback((event2, day) => {
    switch (event2.key) {
      case "ArrowUp":
        focusDay(adapter.addDays(day, -7));
        event2.preventDefault();
        break;
      case "ArrowDown":
        focusDay(adapter.addDays(day, 7));
        event2.preventDefault();
        break;
      case "ArrowLeft": {
        const newFocusedDayDefault = adapter.addDays(day, isRtl ? 1 : -1);
        const nextAvailableMonth = adapter.addMonths(day, isRtl ? 1 : -1);
        const closestDayToFocus = findClosestEnabledDate({
          adapter,
          date: newFocusedDayDefault,
          minDate: isRtl ? newFocusedDayDefault : adapter.startOfMonth(nextAvailableMonth),
          maxDate: isRtl ? adapter.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
          isDateDisabled,
          timezone
        });
        focusDay(closestDayToFocus || newFocusedDayDefault);
        event2.preventDefault();
        break;
      }
      case "ArrowRight": {
        const newFocusedDayDefault = adapter.addDays(day, isRtl ? -1 : 1);
        const nextAvailableMonth = adapter.addMonths(day, isRtl ? -1 : 1);
        const closestDayToFocus = findClosestEnabledDate({
          adapter,
          date: newFocusedDayDefault,
          minDate: isRtl ? adapter.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
          maxDate: isRtl ? newFocusedDayDefault : adapter.endOfMonth(nextAvailableMonth),
          isDateDisabled,
          timezone
        });
        focusDay(closestDayToFocus || newFocusedDayDefault);
        event2.preventDefault();
        break;
      }
      case "Home":
        focusDay(adapter.startOfWeek(day));
        event2.preventDefault();
        break;
      case "End":
        focusDay(adapter.endOfWeek(day));
        event2.preventDefault();
        break;
      case "PageUp":
        focusDay(adapter.addMonths(day, 1));
        event2.preventDefault();
        break;
      case "PageDown":
        focusDay(adapter.addMonths(day, -1));
        event2.preventDefault();
        break;
      case "Enter":
      case " ":
        handleDaySelect(day);
        event2.preventDefault();
        break;
    }
  });
  const handleFocus = useEventCallback((event2, day) => focusDay(day));
  const handleBlur = useEventCallback((event2, day) => {
    if (focusedDay != null && adapter.isSameDay(focusedDay, day)) {
      onFocusedViewChange?.(false);
    }
  });
  const currentMonthNumber = adapter.getMonth(currentMonth);
  const currentYearNumber = adapter.getYear(currentMonth);
  const validSelectedDays = reactExports.useMemo(() => selectedDays.filter((day) => !!day).map((day) => adapter.startOfDay(day)), [adapter, selectedDays]);
  const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
  const slideNodeRef = reactExports.useMemo(() => /* @__PURE__ */ reactExports.createRef(), [transitionKey]);
  const weeksToDisplay = reactExports.useMemo(() => {
    const toDisplay = adapter.getWeekArray(currentMonth);
    let nextMonth = adapter.addMonths(currentMonth, 1);
    while (fixedWeekNumber && toDisplay.length < fixedWeekNumber) {
      const additionalWeeks = adapter.getWeekArray(nextMonth);
      const hasCommonWeek = adapter.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
      additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week) => {
        if (toDisplay.length < fixedWeekNumber) {
          toDisplay.push(week);
        }
      });
      nextMonth = adapter.addMonths(nextMonth, 1);
    }
    return toDisplay;
  }, [currentMonth, fixedWeekNumber, adapter]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarDayRoot, {
    role: "grid",
    "aria-labelledby": gridLabelId,
    className: classes.root,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarDayHeader, {
      role: "row",
      className: classes.header,
      children: [displayWeekNumber && /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarWeekNumberLabel, {
        variant: "caption",
        role: "columnheader",
        "aria-label": translations.calendarWeekNumberHeaderLabel,
        className: classes.weekNumberLabel,
        children: translations.calendarWeekNumberHeaderText
      }), getWeekdays(adapter, now2).map((weekday, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarWeekDayLabel, {
        variant: "caption",
        role: "columnheader",
        "aria-label": adapter.format(weekday, "weekday"),
        className: classes.weekDayLabel,
        children: dayOfWeekFormatter(weekday)
      }, i.toString()))]
    }), loading ? /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarLoadingContainer, {
      className: classes.loadingContainer,
      children: renderLoading()
    }) : /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarSlideTransition, _extends({
      transKey: transitionKey,
      onExited: onMonthSwitchingAnimationEnd,
      reduceAnimations,
      slideDirection,
      className: clsx(className, classes.slideTransition)
    }, TransitionProps, {
      nodeRef: slideNodeRef,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarWeekContainer, {
        ref: slideNodeRef,
        role: "rowgroup",
        className: classes.monthContainer,
        children: weeksToDisplay.map((week, index2) => /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarWeek, {
          role: "row",
          className: classes.weekContainer,
          "aria-rowindex": index2 + 1,
          children: [displayWeekNumber && /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarWeekNumber, {
            className: classes.weekNumber,
            role: "rowheader",
            "aria-label": translations.calendarWeekNumberAriaLabelText(adapter.getWeekNumber(week[0])),
            children: translations.calendarWeekNumberText(adapter.getWeekNumber(week[0]))
          }), week.map((day, dayIndex) => /* @__PURE__ */ jsxRuntimeExports.jsx(WrappedDay, {
            parentProps: props,
            day,
            selectedDays: validSelectedDays,
            isViewFocused: hasFocus,
            focusedDay,
            onKeyDown: handleKeyDown,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onDaySelect: handleDaySelect,
            isDateDisabled,
            currentMonthNumber,
            "aria-colindex": dayIndex + 1
          }, day.toString()))]
        }, `week-${week[0]}`))
      })
    }))]
  });
}
function getMonthCalendarUtilityClass(slot) {
  return generateUtilityClass("MuiMonthCalendar", slot);
}
const monthCalendarClasses = generateUtilityClasses("MuiMonthCalendar", ["root", "button", "disabled", "selected"]);
const _excluded$f = ["autoFocus", "classes", "disabled", "selected", "value", "onClick", "onKeyDown", "onFocus", "onBlur", "slots", "slotProps"];
const useUtilityClasses$a = (classes, ownerState) => {
  const slots = {
    button: ["button", ownerState.isMonthDisabled && "disabled", ownerState.isMonthSelected && "selected"]
  };
  return composeClasses(slots, getMonthCalendarUtilityClass, classes);
};
const DefaultMonthButton = styled("button", {
  name: "MuiMonthCalendar",
  slot: "Button",
  overridesResolver: (_, styles2) => [styles2.button, {
    [`&.${monthCalendarClasses.disabled}`]: styles2.disabled
  }, {
    [`&.${monthCalendarClasses.selected}`]: styles2.selected
  }]
})(({
  theme
}) => _extends({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, theme.typography.subtitle1, {
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  "&:hover": {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${monthCalendarClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.secondary
  },
  [`&.${monthCalendarClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  }
}));
const MonthCalendarButton = /* @__PURE__ */ reactExports.memo(function MonthCalendarButton2(props) {
  const {
    autoFocus,
    classes: classesProp,
    disabled,
    selected,
    value,
    onClick,
    onKeyDown,
    onFocus,
    onBlur,
    slots,
    slotProps
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$f);
  const ref2 = reactExports.useRef(null);
  const {
    ownerState: pickerOwnerState
  } = usePickerPrivateContext();
  const ownerState = _extends({}, pickerOwnerState, {
    isMonthDisabled: disabled,
    isMonthSelected: selected
  });
  const classes = useUtilityClasses$a(classesProp, ownerState);
  useEnhancedEffect(() => {
    if (autoFocus) {
      ref2.current?.focus();
    }
  }, [autoFocus]);
  const MonthButton = slots?.monthButton ?? DefaultMonthButton;
  const monthButtonProps = useSlotProps({
    elementType: MonthButton,
    externalSlotProps: slotProps?.monthButton,
    externalForwardedProps: other,
    additionalProps: {
      disabled,
      ref: ref2,
      type: "button",
      role: "radio",
      "aria-checked": selected,
      onClick: (event2) => onClick(event2, value),
      onKeyDown: (event2) => onKeyDown(event2, value),
      onFocus: (event2) => onFocus(event2, value),
      onBlur: (event2) => onBlur(event2, value)
    },
    ownerState,
    className: classes.button
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MonthButton, _extends({}, monthButtonProps));
});
if (process.env.NODE_ENV !== "production") MonthCalendarButton.displayName = "MonthCalendarButton";
const _excluded$e = ["autoFocus", "className", "currentMonth", "classes", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId", "slots", "slotProps"];
const useUtilityClasses$9 = (classes) => {
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getMonthCalendarUtilityClass, classes);
};
function useMonthCalendarDefaultizedProps(props, name) {
  const themeProps = useThemeProps({
    props,
    name
  });
  const validationProps = useApplyDefaultValuesToDateValidationProps(themeProps);
  return _extends({}, themeProps, validationProps, {
    monthsPerRow: themeProps.monthsPerRow ?? 3
  });
}
const isSameMonth = (monthA, monthB, yearA, yearB, adapter) => Boolean(monthA === monthB && yearB && adapter.isSameYear(yearA, yearB));
const MonthCalendarRoot = styled("div", {
  name: "MuiMonthCalendar",
  slot: "Root",
  shouldForwardProp: (prop) => shouldForwardProp(prop) && prop !== "monthsPerRow"
})({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-evenly",
  rowGap: 16,
  padding: "8px 0",
  width: DIALOG_WIDTH,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  variants: [{
    props: {
      monthsPerRow: 3
    },
    style: {
      columnGap: 24
    }
  }, {
    props: {
      monthsPerRow: 4
    },
    style: {
      columnGap: 0
    }
  }]
});
const MonthCalendar = /* @__PURE__ */ reactExports.forwardRef(function MonthCalendar2(inProps, ref2) {
  const props = useMonthCalendarDefaultizedProps(inProps, "MuiMonthCalendar");
  const {
    autoFocus,
    className,
    currentMonth,
    classes: classesProp,
    value: valueProp,
    defaultValue,
    referenceDate: referenceDateProp,
    disabled,
    disableFuture,
    disablePast,
    maxDate,
    minDate,
    onChange,
    shouldDisableMonth,
    readOnly,
    onMonthFocus,
    hasFocus,
    onFocusedViewChange,
    monthsPerRow,
    timezone: timezoneProp,
    gridLabelId,
    slots,
    slotProps
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$e);
  const {
    value,
    handleValueChange,
    timezone
  } = useControlledValue({
    name: "MonthCalendar",
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    referenceDate: referenceDateProp,
    onChange,
    valueManager: singleItemValueManager
  });
  const now2 = useNow(timezone);
  const isRtl = useRtl();
  const adapter = usePickerAdapter();
  const {
    ownerState
  } = usePickerPrivateContext();
  const referenceDate = reactExports.useMemo(
    () => singleItemValueManager.getInitialReferenceValue({
      value,
      adapter,
      props,
      timezone,
      referenceDate: referenceDateProp,
      granularity: SECTION_TYPE_GRANULARITY.month
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  const classes = useUtilityClasses$9(classesProp);
  const todayMonth = reactExports.useMemo(() => adapter.getMonth(now2), [adapter, now2]);
  const selectedMonth = reactExports.useMemo(() => {
    if (value != null) {
      return adapter.getMonth(value);
    }
    return null;
  }, [value, adapter]);
  const [focusedMonth, setFocusedMonth] = reactExports.useState(() => selectedMonth || adapter.getMonth(referenceDate));
  const [internalHasFocus, setInternalHasFocus] = useControlled({
    name: "MonthCalendar",
    state: "hasFocus",
    controlled: hasFocus,
    default: autoFocus ?? false
  });
  const changeHasFocus = useEventCallback((newHasFocus) => {
    setInternalHasFocus(newHasFocus);
    if (onFocusedViewChange) {
      onFocusedViewChange(newHasFocus);
    }
  });
  const isMonthDisabled = reactExports.useCallback((dateToValidate) => {
    const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now2, minDate) ? now2 : minDate);
    const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now2, maxDate) ? now2 : maxDate);
    const monthToValidate = adapter.startOfMonth(dateToValidate);
    if (adapter.isBefore(monthToValidate, firstEnabledMonth)) {
      return true;
    }
    if (adapter.isAfter(monthToValidate, lastEnabledMonth)) {
      return true;
    }
    if (!shouldDisableMonth) {
      return false;
    }
    return shouldDisableMonth(monthToValidate);
  }, [disableFuture, disablePast, maxDate, minDate, now2, shouldDisableMonth, adapter]);
  const handleMonthSelection = useEventCallback((_event, month) => {
    if (readOnly) {
      return;
    }
    const currentValue = value && currentMonth && !adapter.isSameYear(value, currentMonth) ? adapter.setYear(value, adapter.getYear(currentMonth)) : value;
    const baseDateForMonth = currentValue ?? currentMonth ?? referenceDate;
    const newDate = adapter.setMonth(baseDateForMonth, month);
    handleValueChange(newDate);
  });
  const focusMonth = useEventCallback((month) => {
    if (!isMonthDisabled(adapter.setMonth(value ?? currentMonth ?? referenceDate, month))) {
      setFocusedMonth(month);
      changeHasFocus(true);
      if (onMonthFocus) {
        onMonthFocus(month);
      }
    }
  });
  reactExports.useEffect(() => {
    setFocusedMonth((prevFocusedMonth) => selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
  }, [selectedMonth]);
  const handleKeyDown = useEventCallback((event2, month) => {
    const monthsInYear = 12;
    const monthsInRow = 3;
    switch (event2.key) {
      case "ArrowUp":
        focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
        event2.preventDefault();
        break;
      case "ArrowDown":
        focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
        event2.preventDefault();
        break;
      case "ArrowLeft":
        focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
        event2.preventDefault();
        break;
      case "ArrowRight":
        focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
        event2.preventDefault();
        break;
      case "Enter":
      case " ":
        handleMonthSelection(event2, month);
        event2.preventDefault();
        break;
    }
  });
  const handleMonthFocus = useEventCallback((event2, month) => {
    focusMonth(month);
  });
  const handleMonthBlur = useEventCallback((event2, month) => {
    if (focusedMonth === month) {
      changeHasFocus(false);
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MonthCalendarRoot, _extends({
    ref: ref2,
    className: clsx(classes.root, className),
    ownerState,
    role: "radiogroup",
    "aria-labelledby": gridLabelId,
    monthsPerRow
  }, other, {
    children: getMonthsInYear(adapter, currentMonth ?? value ?? referenceDate).map((month) => {
      const monthNumber = adapter.getMonth(month);
      const monthText = adapter.format(month, "monthShort");
      const monthLabel = adapter.format(month, "month");
      const isSelected = isSameMonth(monthNumber, selectedMonth, month, value, adapter);
      const isDisabled = disabled || isMonthDisabled(month);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(MonthCalendarButton, {
        selected: isSelected,
        value: monthNumber,
        onClick: handleMonthSelection,
        onKeyDown: handleKeyDown,
        autoFocus: internalHasFocus && monthNumber === focusedMonth,
        disabled: isDisabled,
        tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
        onFocus: handleMonthFocus,
        onBlur: handleMonthBlur,
        "aria-current": isSameMonth(monthNumber, todayMonth, month, now2, adapter) ? "date" : void 0,
        "aria-label": monthLabel,
        slots,
        slotProps,
        classes: classesProp,
        children: monthText
      }, monthText);
    })
  }));
});
if (process.env.NODE_ENV !== "production") MonthCalendar.displayName = "MonthCalendar";
process.env.NODE_ENV !== "production" ? MonthCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  currentMonth: PropTypes.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  gridLabelId: PropTypes.string,
  hasFocus: PropTypes.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @param {PickerValidDate} value The new value.
   */
  onChange: PropTypes.func,
  onFocusedViewChange: PropTypes.func,
  onMonthFocus: PropTypes.func,
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: PropTypes.object,
  /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object
} : void 0;
function getYearCalendarUtilityClass(slot) {
  return generateUtilityClass("MuiYearCalendar", slot);
}
const yearCalendarClasses = generateUtilityClasses("MuiYearCalendar", ["root", "button", "disabled", "selected"]);
const _excluded$d = ["autoFocus", "classes", "disabled", "selected", "value", "onClick", "onKeyDown", "onFocus", "onBlur", "slots", "slotProps"];
const useUtilityClasses$8 = (classes, ownerState) => {
  const slots = {
    button: ["button", ownerState.isYearDisabled && "disabled", ownerState.isYearSelected && "selected"]
  };
  return composeClasses(slots, getYearCalendarUtilityClass, classes);
};
const DefaultYearButton = styled("button", {
  name: "MuiYearCalendar",
  slot: "Button",
  overridesResolver: (_, styles2) => [styles2.button, {
    [`&.${yearCalendarClasses.disabled}`]: styles2.disabled
  }, {
    [`&.${yearCalendarClasses.selected}`]: styles2.selected
  }]
})(({
  theme
}) => _extends({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, theme.typography.subtitle1, {
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : alpha(theme.palette.action.active, theme.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${yearCalendarClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.secondary
  },
  [`&.${yearCalendarClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  }
}));
const YearCalendarButton = /* @__PURE__ */ reactExports.memo(function YearCalendarButton2(props) {
  const {
    autoFocus,
    classes: classesProp,
    disabled,
    selected,
    value,
    onClick,
    onKeyDown,
    onFocus,
    onBlur,
    slots,
    slotProps
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$d);
  const ref2 = reactExports.useRef(null);
  const {
    ownerState: pickerOwnerState
  } = usePickerPrivateContext();
  const ownerState = _extends({}, pickerOwnerState, {
    isYearDisabled: disabled,
    isYearSelected: selected
  });
  const classes = useUtilityClasses$8(classesProp, ownerState);
  useEnhancedEffect(() => {
    if (autoFocus) {
      ref2.current?.focus();
    }
  }, [autoFocus]);
  const YearButton = slots?.yearButton ?? DefaultYearButton;
  const yearButtonProps = useSlotProps({
    elementType: YearButton,
    externalSlotProps: slotProps?.yearButton,
    externalForwardedProps: other,
    additionalProps: {
      disabled,
      ref: ref2,
      type: "button",
      role: "radio",
      "aria-checked": selected,
      onClick: (event2) => onClick(event2, value),
      onKeyDown: (event2) => onKeyDown(event2, value),
      onFocus: (event2) => onFocus(event2, value),
      onBlur: (event2) => onBlur(event2, value)
    },
    ownerState,
    className: classes.button
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(YearButton, _extends({}, yearButtonProps));
});
if (process.env.NODE_ENV !== "production") YearCalendarButton.displayName = "YearCalendarButton";
const _excluded$c = ["autoFocus", "className", "classes", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsOrder", "yearsPerRow", "timezone", "gridLabelId", "slots", "slotProps"];
const useUtilityClasses$7 = (classes) => {
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getYearCalendarUtilityClass, classes);
};
function useYearCalendarDefaultizedProps(props, name) {
  const themeProps = useThemeProps({
    props,
    name
  });
  const validationProps = useApplyDefaultValuesToDateValidationProps(themeProps);
  return _extends({}, themeProps, validationProps, {
    yearsPerRow: themeProps.yearsPerRow ?? 3,
    yearsOrder: themeProps.yearsOrder ?? "asc"
  });
}
const YearCalendarRoot = styled("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  shouldForwardProp: (prop) => shouldForwardProp(prop) && prop !== "yearsPerRow"
})({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-evenly",
  rowGap: 12,
  padding: "6px 0",
  overflowY: "auto",
  height: "100%",
  width: DIALOG_WIDTH,
  maxHeight: MAX_CALENDAR_HEIGHT,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative",
  variants: [{
    props: {
      yearsPerRow: 3
    },
    style: {
      columnGap: 24
    }
  }, {
    props: {
      yearsPerRow: 4
    },
    style: {
      columnGap: 0,
      padding: "0 2px"
    }
  }]
});
const YearCalendarButtonFiller = styled("div", {
  name: "MuiYearCalendar",
  slot: "ButtonFiller"
})({
  height: 36,
  width: 72
});
const YearCalendar = /* @__PURE__ */ reactExports.forwardRef(function YearCalendar2(inProps, ref2) {
  const props = useYearCalendarDefaultizedProps(inProps, "MuiYearCalendar");
  const {
    autoFocus,
    className,
    classes: classesProp,
    value: valueProp,
    defaultValue,
    referenceDate: referenceDateProp,
    disabled,
    disableFuture,
    disablePast,
    maxDate,
    minDate,
    onChange,
    readOnly,
    shouldDisableYear,
    onYearFocus,
    hasFocus,
    onFocusedViewChange,
    yearsOrder,
    yearsPerRow,
    timezone: timezoneProp,
    gridLabelId,
    slots,
    slotProps
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$c);
  const {
    value,
    handleValueChange,
    timezone
  } = useControlledValue({
    name: "YearCalendar",
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    referenceDate: referenceDateProp,
    onChange,
    valueManager: singleItemValueManager
  });
  const now2 = useNow(timezone);
  const isRtl = useRtl();
  const adapter = usePickerAdapter();
  const {
    ownerState
  } = usePickerPrivateContext();
  const referenceDate = reactExports.useMemo(
    () => singleItemValueManager.getInitialReferenceValue({
      value,
      adapter,
      props,
      timezone,
      referenceDate: referenceDateProp,
      granularity: SECTION_TYPE_GRANULARITY.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  const classes = useUtilityClasses$7(classesProp);
  const todayYear = reactExports.useMemo(() => adapter.getYear(now2), [adapter, now2]);
  const selectedYear = reactExports.useMemo(() => {
    if (value != null) {
      return adapter.getYear(value);
    }
    return null;
  }, [value, adapter]);
  const [focusedYear, setFocusedYear] = reactExports.useState(() => selectedYear || adapter.getYear(referenceDate));
  const [internalHasFocus, setInternalHasFocus] = useControlled({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: hasFocus,
    default: autoFocus ?? false
  });
  const changeHasFocus = useEventCallback((newHasFocus) => {
    setInternalHasFocus(newHasFocus);
    if (onFocusedViewChange) {
      onFocusedViewChange(newHasFocus);
    }
  });
  const isYearDisabled = reactExports.useCallback((dateToValidate) => {
    if (disablePast && adapter.isBeforeYear(dateToValidate, now2)) {
      return true;
    }
    if (disableFuture && adapter.isAfterYear(dateToValidate, now2)) {
      return true;
    }
    if (minDate && adapter.isBeforeYear(dateToValidate, minDate)) {
      return true;
    }
    if (maxDate && adapter.isAfterYear(dateToValidate, maxDate)) {
      return true;
    }
    if (!shouldDisableYear) {
      return false;
    }
    const yearToValidate = adapter.startOfYear(dateToValidate);
    return shouldDisableYear(yearToValidate);
  }, [disableFuture, disablePast, maxDate, minDate, now2, shouldDisableYear, adapter]);
  const handleYearSelection = useEventCallback((_event, year) => {
    if (readOnly) {
      return;
    }
    const newDate = adapter.setYear(value ?? referenceDate, year);
    handleValueChange(newDate);
  });
  const focusYear = useEventCallback((year) => {
    if (!isYearDisabled(adapter.setYear(value ?? referenceDate, year))) {
      setFocusedYear(year);
      changeHasFocus(true);
      onYearFocus?.(year);
    }
  });
  reactExports.useEffect(() => {
    setFocusedYear((prevFocusedYear) => selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
  }, [selectedYear]);
  const verticalDirection = yearsOrder !== "desc" ? yearsPerRow * 1 : yearsPerRow * -1;
  const horizontalDirection = isRtl && yearsOrder === "asc" || !isRtl && yearsOrder === "desc" ? -1 : 1;
  const handleKeyDown = useEventCallback((event2, year) => {
    switch (event2.key) {
      case "ArrowUp":
        focusYear(year - verticalDirection);
        event2.preventDefault();
        break;
      case "ArrowDown":
        focusYear(year + verticalDirection);
        event2.preventDefault();
        break;
      case "ArrowLeft":
        focusYear(year - horizontalDirection);
        event2.preventDefault();
        break;
      case "ArrowRight":
        focusYear(year + horizontalDirection);
        event2.preventDefault();
        break;
      case "Enter":
      case " ":
        handleYearSelection(event2, year);
        event2.preventDefault();
        break;
    }
  });
  const handleYearFocus = useEventCallback((event2, year) => {
    focusYear(year);
  });
  const handleYearBlur = useEventCallback((event2, year) => {
    if (focusedYear === year) {
      changeHasFocus(false);
    }
  });
  const scrollerRef = reactExports.useRef(null);
  const handleRef = useForkRef(ref2, scrollerRef);
  reactExports.useEffect(() => {
    if (autoFocus || scrollerRef.current === null) {
      return;
    }
    const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
    if (!tabbableButton) {
      return;
    }
    const offsetHeight = tabbableButton.offsetHeight;
    const offsetTop = tabbableButton.offsetTop;
    const clientHeight = scrollerRef.current.clientHeight;
    const scrollTop = scrollerRef.current.scrollTop;
    const elementBottom = offsetTop + offsetHeight;
    if (offsetHeight > clientHeight || offsetTop < scrollTop) {
      return;
    }
    scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
  }, [autoFocus]);
  const yearRange = adapter.getYearRange([minDate, maxDate]);
  if (yearsOrder === "desc") {
    yearRange.reverse();
  }
  let fillerAmount = yearsPerRow - yearRange.length % yearsPerRow;
  if (fillerAmount === yearsPerRow) {
    fillerAmount = 0;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(YearCalendarRoot, _extends({
    ref: handleRef,
    className: clsx(classes.root, className),
    ownerState,
    role: "radiogroup",
    "aria-labelledby": gridLabelId,
    yearsPerRow
  }, other, {
    children: [yearRange.map((year) => {
      const yearNumber = adapter.getYear(year);
      const isSelected = yearNumber === selectedYear;
      const isDisabled = disabled || isYearDisabled(year);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(YearCalendarButton, {
        selected: isSelected,
        value: yearNumber,
        onClick: handleYearSelection,
        onKeyDown: handleKeyDown,
        autoFocus: internalHasFocus && yearNumber === focusedYear,
        disabled: isDisabled,
        tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
        onFocus: handleYearFocus,
        onBlur: handleYearBlur,
        "aria-current": todayYear === yearNumber ? "date" : void 0,
        slots,
        slotProps,
        classes: classesProp,
        children: adapter.format(year, "year")
      }, adapter.format(year, "year"));
    }), Array.from({
      length: fillerAmount
    }, (_, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(YearCalendarButtonFiller, {}, index2))]
  }));
});
if (process.env.NODE_ENV !== "production") YearCalendar.displayName = "YearCalendar";
process.env.NODE_ENV !== "production" ? YearCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  gridLabelId: PropTypes.string,
  hasFocus: PropTypes.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Callback fired when the value changes.
   * @param {PickerValidDate} value The new value.
   */
  onChange: PropTypes.func,
  onFocusedViewChange: PropTypes.func,
  onYearFocus: PropTypes.func,
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: PropTypes.object,
  /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: PropTypes.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
} : void 0;
const getPickersCalendarHeaderUtilityClass = (slot) => generateUtilityClass("MuiPickersCalendarHeader", slot);
const pickersCalendarHeaderClasses = generateUtilityClasses("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]);
const _excluded$b = ["slots", "slotProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "classes", "timezone", "format"], _excluded2$3 = ["ownerState"];
const useUtilityClasses$6 = (classes) => {
  const slots = {
    root: ["root"],
    labelContainer: ["labelContainer"],
    label: ["label"],
    switchViewButton: ["switchViewButton"],
    switchViewIcon: ["switchViewIcon"]
  };
  return composeClasses(slots, getPickersCalendarHeaderUtilityClass, classes);
};
const PickersCalendarHeaderRoot = styled("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root"
})({
  display: "flex",
  alignItems: "center",
  marginTop: 12,
  marginBottom: 4,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 40,
  minHeight: 40
});
const PickersCalendarHeaderLabelContainer = styled("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer"
})(({
  theme
}) => _extends({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, theme.typography.body1, {
  fontWeight: theme.typography.fontWeightMedium
}));
const PickersCalendarHeaderLabel = styled("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label"
})({
  marginRight: 6
});
const PickersCalendarHeaderSwitchViewButton = styled(IconButton, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton"
})({
  marginRight: "auto",
  variants: [{
    props: {
      view: "year"
    },
    style: {
      [`.${pickersCalendarHeaderClasses.switchViewIcon}`]: {
        transform: "rotate(180deg)"
      }
    }
  }]
});
const PickersCalendarHeaderSwitchViewIcon = styled(ArrowDropDownIcon, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon"
})(({
  theme
}) => ({
  willChange: "transform",
  transition: theme.transitions.create("transform"),
  transform: "rotate(0deg)"
}));
const PickersCalendarHeader = /* @__PURE__ */ reactExports.forwardRef(function PickersCalendarHeader2(inProps, ref2) {
  const translations = usePickerTranslations();
  const adapter = usePickerAdapter();
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersCalendarHeader"
  });
  const {
    slots,
    slotProps,
    currentMonth: month,
    disabled,
    disableFuture,
    disablePast,
    maxDate,
    minDate,
    onMonthChange,
    onViewChange,
    view,
    reduceAnimations,
    views,
    labelId,
    className,
    classes: classesProp,
    timezone,
    format: format2 = `${adapter.formats.month} ${adapter.formats.year}`
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$b);
  const {
    ownerState
  } = usePickerPrivateContext();
  const classes = useUtilityClasses$6(classesProp);
  const SwitchViewButton = slots?.switchViewButton ?? PickersCalendarHeaderSwitchViewButton;
  const switchViewButtonProps = useSlotProps({
    elementType: SwitchViewButton,
    externalSlotProps: slotProps?.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": translations.calendarViewSwitchingButtonAriaLabel(view)
    },
    ownerState: _extends({}, ownerState, {
      view
    }),
    className: classes.switchViewButton
  });
  const SwitchViewIcon = slots?.switchViewIcon ?? PickersCalendarHeaderSwitchViewIcon;
  const _useSlotProps = useSlotProps({
    elementType: SwitchViewIcon,
    externalSlotProps: slotProps?.switchViewIcon,
    ownerState,
    className: classes.switchViewIcon
  }), switchViewIconProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded2$3);
  const selectNextMonth = () => onMonthChange(adapter.addMonths(month, 1));
  const selectPreviousMonth = () => onMonthChange(adapter.addMonths(month, -1));
  const isNextMonthDisabled = useNextMonthDisabled(month, {
    disableFuture,
    maxDate,
    timezone
  });
  const isPreviousMonthDisabled = usePreviousMonthDisabled(month, {
    disablePast,
    minDate,
    timezone
  });
  const handleToggleView = () => {
    if (views.length === 1 || !onViewChange || disabled) {
      return;
    }
    if (views.length === 2) {
      onViewChange(views.find((el) => el !== view) || views[0]);
    } else {
      const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
      onViewChange(views[nextIndexToOpen]);
    }
  };
  if (views.length === 1 && views[0] === "year") {
    return null;
  }
  const label = adapter.formatByString(month, format2);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarHeaderRoot, _extends({}, other, {
    ownerState,
    className: clsx(classes.root, className),
    ref: ref2,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarHeaderLabelContainer, {
      role: "presentation",
      onClick: handleToggleView,
      ownerState,
      "aria-live": "polite",
      className: classes.labelContainer,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(PickersFadeTransitionGroup, {
        reduceAnimations,
        transKey: label,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarHeaderLabel, {
          id: labelId,
          ownerState,
          className: classes.label,
          children: label
        })
      }), views.length > 1 && !disabled && /* @__PURE__ */ jsxRuntimeExports.jsx(SwitchViewButton, _extends({}, switchViewButtonProps, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(SwitchViewIcon, _extends({}, switchViewIconProps))
      }))]
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Fade, {
      in: view === "day",
      appear: !reduceAnimations,
      enter: !reduceAnimations,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersArrowSwitcher, {
        slots,
        slotProps,
        onGoToPrevious: selectPreviousMonth,
        isPreviousDisabled: isPreviousMonthDisabled,
        previousLabel: translations.previousMonth,
        onGoToNext: selectNextMonth,
        isNextDisabled: isNextMonthDisabled,
        nextLabel: translations.nextMonth
      })
    })]
  }));
});
if (process.env.NODE_ENV !== "production") PickersCalendarHeader.displayName = "PickersCalendarHeader";
process.env.NODE_ENV !== "production" ? PickersCalendarHeader.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  currentMonth: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  /**
   * Format used to display the date.
   * @default `${adapter.formats.month} ${adapter.formats.year}`
   */
  format: PropTypes.string,
  /**
   * Id of the calendar text element.
   * It is used to establish an `aria-labelledby` relationship with the calendar `grid` element.
   */
  labelId: PropTypes.string,
  maxDate: PropTypes.object.isRequired,
  minDate: PropTypes.object.isRequired,
  onMonthChange: PropTypes.func.isRequired,
  onViewChange: PropTypes.func,
  reduceAnimations: PropTypes.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  timezone: PropTypes.string.isRequired,
  view: PropTypes.oneOf(["day", "month", "year"]).isRequired,
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired).isRequired
} : void 0;
const PREFERS_REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)";
const mobileVersionMatches = typeof navigator !== "undefined" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const androidVersion = mobileVersionMatches && mobileVersionMatches[1] ? parseInt(mobileVersionMatches[1], 10) : null;
const iOSVersion = mobileVersionMatches && mobileVersionMatches[2] ? parseInt(mobileVersionMatches[2], 10) : null;
const slowAnimationDevices = androidVersion && androidVersion < 10 || iOSVersion && iOSVersion < 13 || false;
function useReduceAnimations(customReduceAnimations) {
  const prefersReduced = useMediaQuery(PREFERS_REDUCED_MOTION, {
    defaultMatches: false
  });
  if (customReduceAnimations != null) {
    return customReduceAnimations;
  }
  return prefersReduced || slowAnimationDevices;
}
const getDateCalendarUtilityClass = (slot) => generateUtilityClass("MuiDateCalendar", slot);
generateUtilityClasses("MuiDateCalendar", ["root", "viewTransitionContainer"]);
const _excluded$a = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "classes", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsOrder", "yearsPerRow", "monthsPerRow", "timezone"];
const useUtilityClasses$5 = (classes) => {
  const slots = {
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  };
  return composeClasses(slots, getDateCalendarUtilityClass, classes);
};
function useDateCalendarDefaultizedProps(props, name) {
  const themeProps = useThemeProps({
    props,
    name
  });
  const reduceAnimations = useReduceAnimations(themeProps.reduceAnimations);
  const validationProps = useApplyDefaultValuesToDateValidationProps(themeProps);
  return _extends({}, themeProps, validationProps, {
    loading: themeProps.loading ?? false,
    openTo: themeProps.openTo ?? "day",
    views: themeProps.views ?? ["year", "day"],
    reduceAnimations,
    renderLoading: themeProps.renderLoading ?? (() => /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      children: "..."
    }))
  });
}
const DateCalendarRoot = styled(PickerViewRoot, {
  name: "MuiDateCalendar",
  slot: "Root"
})({
  display: "flex",
  flexDirection: "column",
  height: VIEW_HEIGHT
});
const DateCalendarViewTransitionContainer = styled(PickersFadeTransitionGroup, {
  name: "MuiDateCalendar",
  slot: "ViewTransitionContainer"
})({});
const DateCalendar = /* @__PURE__ */ reactExports.forwardRef(function DateCalendar2(inProps, ref2) {
  const adapter = usePickerAdapter();
  const {
    ownerState
  } = usePickerPrivateContext();
  const id = useId();
  const props = useDateCalendarDefaultizedProps(inProps, "MuiDateCalendar");
  const {
    autoFocus,
    onViewChange,
    value: valueProp,
    defaultValue,
    referenceDate: referenceDateProp,
    disableFuture,
    disablePast,
    onChange,
    onMonthChange,
    reduceAnimations,
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    view: inView,
    views,
    openTo,
    className,
    classes: classesProp,
    disabled,
    readOnly,
    minDate,
    maxDate,
    disableHighlightToday,
    focusedView: focusedViewProp,
    onFocusedViewChange,
    showDaysOutsideCurrentMonth,
    fixedWeekNumber,
    dayOfWeekFormatter,
    slots,
    slotProps,
    loading,
    renderLoading,
    displayWeekNumber,
    yearsOrder,
    yearsPerRow,
    monthsPerRow,
    timezone: timezoneProp
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$a);
  const {
    value,
    handleValueChange,
    timezone
  } = useControlledValue({
    name: "DateCalendar",
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    referenceDate: referenceDateProp,
    onChange,
    valueManager: singleItemValueManager
  });
  const {
    view,
    setView,
    focusedView,
    setFocusedView,
    goToNextView,
    setValueAndGoToNextView
  } = useViews({
    view: inView,
    views,
    openTo,
    onChange: handleValueChange,
    onViewChange,
    autoFocus,
    focusedView: focusedViewProp,
    onFocusedViewChange
  });
  const {
    referenceDate,
    calendarState,
    setVisibleDate,
    isDateDisabled,
    onMonthSwitchingAnimationEnd
  } = useCalendarState({
    value,
    referenceDate: referenceDateProp,
    reduceAnimations,
    onMonthChange,
    minDate,
    maxDate,
    shouldDisableDate,
    disablePast,
    disableFuture,
    timezone,
    getCurrentMonthFromVisibleDate: (visibleDate, prevMonth) => {
      if (adapter.isSameMonth(visibleDate, prevMonth)) {
        return prevMonth;
      }
      return adapter.startOfMonth(visibleDate);
    }
  });
  const minDateWithDisabled = disabled && value || minDate;
  const maxDateWithDisabled = disabled && value || maxDate;
  const gridLabelId = `${id}-grid-label`;
  const hasFocus = focusedView !== null;
  const CalendarHeader2 = slots?.calendarHeader ?? PickersCalendarHeader;
  const calendarHeaderProps = useSlotProps({
    elementType: CalendarHeader2,
    externalSlotProps: slotProps?.calendarHeader,
    additionalProps: {
      views,
      view,
      currentMonth: calendarState.currentMonth,
      onViewChange: setView,
      onMonthChange: (month) => setVisibleDate({
        target: month,
        reason: "header-navigation"
      }),
      minDate: minDateWithDisabled,
      maxDate: maxDateWithDisabled,
      disabled,
      disablePast,
      disableFuture,
      reduceAnimations,
      timezone,
      labelId: gridLabelId
    },
    ownerState
  });
  const handleDateMonthChange = useEventCallback((newDate) => {
    const startOfMonth = adapter.startOfMonth(newDate);
    const endOfMonth = adapter.endOfMonth(newDate);
    const closestEnabledDate = isDateDisabled(newDate) ? findClosestEnabledDate({
      adapter,
      date: newDate,
      minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
      maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
      disablePast,
      disableFuture,
      isDateDisabled,
      timezone
    }) : newDate;
    if (closestEnabledDate) {
      setValueAndGoToNextView(closestEnabledDate, "finish");
      setVisibleDate({
        target: closestEnabledDate,
        reason: "cell-interaction"
      });
    } else {
      goToNextView();
      setVisibleDate({
        target: startOfMonth,
        reason: "cell-interaction"
      });
    }
  });
  const handleDateYearChange = useEventCallback((newDate) => {
    const startOfYear = adapter.startOfYear(newDate);
    const endOfYear = adapter.endOfYear(newDate);
    const closestEnabledDate = isDateDisabled(newDate) ? findClosestEnabledDate({
      adapter,
      date: newDate,
      minDate: adapter.isBefore(minDate, startOfYear) ? startOfYear : minDate,
      maxDate: adapter.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
      disablePast,
      disableFuture,
      isDateDisabled,
      timezone
    }) : newDate;
    if (closestEnabledDate) {
      setValueAndGoToNextView(closestEnabledDate, "finish");
      setVisibleDate({
        target: closestEnabledDate,
        reason: "cell-interaction"
      });
    } else {
      goToNextView();
      setVisibleDate({
        target: startOfYear,
        reason: "cell-interaction"
      });
    }
  });
  const handleSelectedDayChange = useEventCallback((day) => {
    if (day) {
      return handleValueChange(mergeDateAndTime(adapter, day, value ?? referenceDate), "finish", view);
    }
    return handleValueChange(day, "finish", view);
  });
  reactExports.useEffect(() => {
    if (adapter.isValid(value)) {
      setVisibleDate({
        target: value,
        reason: "controlled-value-change"
      });
    }
  }, [value]);
  const classes = useUtilityClasses$5(classesProp);
  const baseDateValidationProps = {
    disablePast,
    disableFuture,
    maxDate,
    minDate
  };
  const commonViewProps = {
    disableHighlightToday,
    readOnly,
    disabled,
    timezone,
    gridLabelId,
    slots,
    slotProps
  };
  const prevOpenViewRef = reactExports.useRef(view);
  reactExports.useEffect(() => {
    if (prevOpenViewRef.current === view) {
      return;
    }
    if (focusedView === prevOpenViewRef.current) {
      setFocusedView(view, true);
    }
    prevOpenViewRef.current = view;
  }, [focusedView, setFocusedView, view]);
  const selectedDays = reactExports.useMemo(() => [value], [value]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(DateCalendarRoot, _extends({
    ref: ref2,
    className: clsx(classes.root, className),
    ownerState
  }, other, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(CalendarHeader2, _extends({}, calendarHeaderProps, {
      slots,
      slotProps
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(DateCalendarViewTransitionContainer, {
      reduceAnimations,
      className: classes.viewTransitionContainer,
      transKey: view,
      ownerState,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
        children: [view === "year" && /* @__PURE__ */ jsxRuntimeExports.jsx(YearCalendar, _extends({}, baseDateValidationProps, commonViewProps, {
          value,
          onChange: handleDateYearChange,
          shouldDisableYear,
          hasFocus,
          onFocusedViewChange: (isViewFocused) => setFocusedView("year", isViewFocused),
          yearsOrder,
          yearsPerRow,
          referenceDate
        })), view === "month" && /* @__PURE__ */ jsxRuntimeExports.jsx(MonthCalendar, _extends({}, baseDateValidationProps, commonViewProps, {
          currentMonth: calendarState.currentMonth,
          hasFocus,
          className,
          value,
          onChange: handleDateMonthChange,
          shouldDisableMonth,
          onFocusedViewChange: (isViewFocused) => setFocusedView("month", isViewFocused),
          monthsPerRow,
          referenceDate
        })), view === "day" && /* @__PURE__ */ jsxRuntimeExports.jsx(DayCalendar, _extends({}, calendarState, baseDateValidationProps, commonViewProps, {
          onMonthSwitchingAnimationEnd,
          hasFocus,
          onFocusedDayChange: (focusedDate) => setVisibleDate({
            target: focusedDate,
            reason: "cell-interaction"
          }),
          reduceAnimations,
          selectedDays,
          onSelectedDaysChange: handleSelectedDayChange,
          shouldDisableDate,
          shouldDisableMonth,
          shouldDisableYear,
          onFocusedViewChange: (isViewFocused) => setFocusedView("day", isViewFocused),
          showDaysOutsideCurrentMonth,
          fixedWeekNumber,
          dayOfWeekFormatter,
          displayWeekNumber,
          loading,
          renderLoading
        }))]
      })
    })]
  }));
});
if (process.env.NODE_ENV !== "production") DateCalendar.displayName = "DateCalendar";
process.env.NODE_ENV !== "production" ? DateCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Controlled focused view.
   */
  focusedView: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired on focused view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: PropTypes.func,
  /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: PropTypes.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: PropTypes.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
} : void 0;
function getPickersToolbarUtilityClass(slot) {
  return generateUtilityClass("MuiPickersToolbar", slot);
}
generateUtilityClasses("MuiPickersToolbar", ["root", "title", "content"]);
function useToolbarOwnerState() {
  const {
    ownerState: pickerOwnerState
  } = usePickerPrivateContext();
  const isRtl = useRtl();
  return reactExports.useMemo(() => _extends({}, pickerOwnerState, {
    toolbarDirection: isRtl ? "rtl" : "ltr"
  }), [pickerOwnerState, isRtl]);
}
const _excluded$9 = ["children", "className", "classes", "toolbarTitle", "hidden", "titleId", "classes", "landscapeDirection"];
const useUtilityClasses$4 = (classes) => {
  const slots = {
    root: ["root"],
    title: ["title"],
    content: ["content"]
  };
  return composeClasses(slots, getPickersToolbarUtilityClass, classes);
};
const PickersToolbarRoot = styled("div", {
  name: "MuiPickersToolbar",
  slot: "Root"
})(({
  theme
}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: theme.spacing(2, 3),
  variants: [{
    props: {
      pickerOrientation: "landscape"
    },
    style: {
      height: "auto",
      maxWidth: 160,
      padding: 16,
      justifyContent: "flex-start",
      flexWrap: "wrap"
    }
  }]
}));
const PickersToolbarContent = styled("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  shouldForwardProp: (prop) => shouldForwardProp(prop) && prop !== "landscapeDirection"
})({
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  flex: 1,
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  variants: [{
    props: {
      pickerOrientation: "landscape"
    },
    style: {
      justifyContent: "flex-start",
      alignItems: "flex-start",
      flexDirection: "column"
    }
  }, {
    props: {
      pickerOrientation: "landscape",
      landscapeDirection: "row"
    },
    style: {
      flexDirection: "row"
    }
  }]
});
const PickersToolbar = /* @__PURE__ */ reactExports.forwardRef(function PickersToolbar2(inProps, ref2) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersToolbar"
  });
  const {
    children,
    className,
    classes: classesProp,
    toolbarTitle,
    hidden,
    titleId,
    landscapeDirection
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$9);
  const ownerState = useToolbarOwnerState();
  const classes = useUtilityClasses$4(classesProp);
  if (hidden) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersToolbarRoot, _extends({
    ref: ref2,
    className: clsx(classes.root, className),
    ownerState
  }, other, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, {
      color: "text.secondary",
      variant: "overline",
      id: titleId,
      className: classes.title,
      children: toolbarTitle
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(PickersToolbarContent, {
      className: classes.content,
      ownerState,
      landscapeDirection,
      children
    })]
  }));
});
if (process.env.NODE_ENV !== "production") PickersToolbar.displayName = "PickersToolbar";
function getDatePickerToolbarUtilityClass(slot) {
  return generateUtilityClass("MuiDatePickerToolbar", slot);
}
generateUtilityClasses("MuiDatePickerToolbar", ["root", "title"]);
const _excluded$8 = ["toolbarFormat", "toolbarPlaceholder", "className", "classes"];
const useUtilityClasses$3 = (classes) => {
  const slots = {
    root: ["root"],
    title: ["title"]
  };
  return composeClasses(slots, getDatePickerToolbarUtilityClass, classes);
};
const DatePickerToolbarRoot = styled(PickersToolbar, {
  name: "MuiDatePickerToolbar",
  slot: "Root"
})({});
const DatePickerToolbarTitle = styled(Typography$1, {
  name: "MuiDatePickerToolbar",
  slot: "Title"
})({
  variants: [{
    props: {
      pickerOrientation: "landscape"
    },
    style: {
      margin: "auto 16px auto auto"
    }
  }]
});
const DatePickerToolbar = /* @__PURE__ */ reactExports.forwardRef(function DatePickerToolbar2(inProps, ref2) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiDatePickerToolbar"
  });
  const {
    toolbarFormat,
    toolbarPlaceholder = "––",
    className,
    classes: classesProp
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$8);
  const adapter = usePickerAdapter();
  const {
    value,
    views,
    orientation
  } = usePickerContext();
  const translations = usePickerTranslations();
  const ownerState = useToolbarOwnerState();
  const classes = useUtilityClasses$3(classesProp);
  const dateText = reactExports.useMemo(() => {
    if (!adapter.isValid(value)) {
      return toolbarPlaceholder;
    }
    const formatFromViews = resolveDateFormat(adapter, {
      format: toolbarFormat,
      views
    }, true);
    return adapter.formatByString(value, formatFromViews);
  }, [value, toolbarFormat, toolbarPlaceholder, adapter, views]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DatePickerToolbarRoot, _extends({
    ref: ref2,
    toolbarTitle: translations.datePickerToolbarTitle,
    className: clsx(classes.root, className)
  }, other, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(DatePickerToolbarTitle, {
      variant: "h4",
      align: orientation === "landscape" ? "left" : "center",
      ownerState,
      className: classes.title,
      children: dateText
    })
  }));
});
if (process.env.NODE_ENV !== "production") DatePickerToolbar.displayName = "DatePickerToolbar";
process.env.NODE_ENV !== "production" ? DatePickerToolbar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  titleId: PropTypes.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: PropTypes.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: PropTypes.node
} : void 0;
function useDatePickerDefaultizedProps(props, name) {
  const themeProps = useThemeProps({
    props,
    name
  });
  const validationProps = useApplyDefaultValuesToDateValidationProps(themeProps);
  const localeText = reactExports.useMemo(() => {
    if (themeProps.localeText?.toolbarTitle == null) {
      return themeProps.localeText;
    }
    return _extends({}, themeProps.localeText, {
      datePickerToolbarTitle: themeProps.localeText.toolbarTitle
    });
  }, [themeProps.localeText]);
  return _extends({}, themeProps, validationProps, {
    localeText
  }, applyDefaultViewProps({
    views: themeProps.views,
    openTo: themeProps.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    slots: _extends({
      toolbar: DatePickerToolbar
    }, themeProps.slots)
  });
}
function getPickerPopperUtilityClass(slot) {
  return generateUtilityClass("MuiPickerPopper", slot);
}
generateUtilityClasses("MuiPickerPopper", ["root", "paper"]);
const _excluded$7 = ["PaperComponent", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"];
const useUtilityClasses$2 = (classes) => {
  const slots = {
    root: ["root"],
    paper: ["paper"]
  };
  return composeClasses(slots, getPickerPopperUtilityClass, classes);
};
const PickerPopperRoot = styled(Popper2, {
  name: "MuiPickerPopper",
  slot: "Root"
})(({
  theme
}) => ({
  zIndex: theme.zIndex.modal
}));
const PickerPopperPaper = styled(Paper, {
  name: "MuiPickerPopper",
  slot: "Paper"
})({
  outline: 0,
  transformOrigin: "top center",
  variants: [{
    props: ({
      popperPlacement
    }) => (/* @__PURE__ */ new Set(["top", "top-start", "top-end"])).has(popperPlacement),
    style: {
      transformOrigin: "bottom center"
    }
  }]
});
function clickedRootScrollbar(event2, doc) {
  return doc.documentElement.clientWidth < event2.clientX || doc.documentElement.clientHeight < event2.clientY;
}
function useClickAwayListener(active, onClickAway) {
  const movedRef = reactExports.useRef(false);
  const syntheticEventRef = reactExports.useRef(false);
  const nodeRef = reactExports.useRef(null);
  const activatedRef = reactExports.useRef(false);
  reactExports.useEffect(() => {
    if (!active) {
      return void 0;
    }
    function armClickAwayListener() {
      activatedRef.current = true;
    }
    document.addEventListener("mousedown", armClickAwayListener, true);
    document.addEventListener("touchstart", armClickAwayListener, true);
    return () => {
      document.removeEventListener("mousedown", armClickAwayListener, true);
      document.removeEventListener("touchstart", armClickAwayListener, true);
      activatedRef.current = false;
    };
  }, [active]);
  const handleClickAway = useEventCallback((event2) => {
    if (!activatedRef.current) {
      return;
    }
    const insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    const doc = ownerDocument(nodeRef.current);
    if (!nodeRef.current || // is a TouchEvent?
    "clientX" in event2 && clickedRootScrollbar(event2, doc)) {
      return;
    }
    if (movedRef.current) {
      movedRef.current = false;
      return;
    }
    let insideDOM;
    if (event2.composedPath) {
      insideDOM = event2.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains(event2.target) || nodeRef.current.contains(event2.target);
    }
    if (!insideDOM && !insideReactTree) {
      onClickAway(event2);
    }
  });
  const handleSynthetic = (event2) => {
    if (!event2.defaultMuiPrevented) {
      syntheticEventRef.current = true;
    }
  };
  reactExports.useEffect(() => {
    if (active) {
      const doc = ownerDocument(nodeRef.current);
      const handleTouchMove = () => {
        movedRef.current = true;
      };
      doc.addEventListener("touchstart", handleClickAway);
      doc.addEventListener("touchmove", handleTouchMove);
      return () => {
        doc.removeEventListener("touchstart", handleClickAway);
        doc.removeEventListener("touchmove", handleTouchMove);
      };
    }
    return void 0;
  }, [active, handleClickAway]);
  reactExports.useEffect(() => {
    if (active) {
      const doc = ownerDocument(nodeRef.current);
      doc.addEventListener("click", handleClickAway);
      return () => {
        doc.removeEventListener("click", handleClickAway);
        syntheticEventRef.current = false;
      };
    }
    return void 0;
  }, [active, handleClickAway]);
  return [nodeRef, handleSynthetic, handleSynthetic];
}
const PickerPopperPaperWrapper = /* @__PURE__ */ reactExports.forwardRef((props, ref2) => {
  const {
    PaperComponent,
    ownerState,
    children,
    paperSlotProps,
    paperClasses,
    onPaperClick,
    onPaperTouchStart
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$7);
  const paperProps = useSlotProps({
    elementType: PaperComponent,
    externalSlotProps: paperSlotProps,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: ref2
    },
    className: paperClasses,
    ownerState
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PaperComponent, _extends({}, other, paperProps, {
    onClick: (event2) => {
      onPaperClick(event2);
      paperProps.onClick?.(event2);
    },
    onTouchStart: (event2) => {
      onPaperTouchStart(event2);
      paperProps.onTouchStart?.(event2);
    },
    ownerState,
    children
  }));
});
if (process.env.NODE_ENV !== "production") PickerPopperPaperWrapper.displayName = "PickerPopperPaperWrapper";
function PickerPopper(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickerPopper"
  });
  const {
    children,
    placement = "bottom-start",
    slots,
    slotProps,
    classes: classesProp
  } = props;
  const {
    open: open2,
    popupRef,
    reduceAnimations
  } = usePickerContext();
  const {
    ownerState: pickerOwnerState,
    rootRefObject
  } = usePickerPrivateContext();
  const {
    dismissViews,
    getCurrentViewMode,
    onPopperExited,
    triggerElement,
    viewContainerRole
  } = usePickerPrivateContext();
  reactExports.useEffect(() => {
    function handleKeyDown2(nativeEvent) {
      if (open2 && nativeEvent.key === "Escape") {
        dismissViews();
      }
    }
    document.addEventListener("keydown", handleKeyDown2);
    return () => {
      document.removeEventListener("keydown", handleKeyDown2);
    };
  }, [dismissViews, open2]);
  const lastFocusedElementRef = reactExports.useRef(null);
  reactExports.useEffect(() => {
    if (viewContainerRole === "tooltip" || getCurrentViewMode() === "field") {
      return;
    }
    if (open2) {
      lastFocusedElementRef.current = getActiveElement(rootRefObject.current);
    } else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) {
      setTimeout(() => {
        if (lastFocusedElementRef.current instanceof HTMLElement) {
          lastFocusedElementRef.current.focus();
        }
      });
    }
  }, [open2, viewContainerRole, getCurrentViewMode, rootRefObject]);
  const classes = useUtilityClasses$2(classesProp);
  const handleClickAway = useEventCallback(() => {
    if (viewContainerRole === "tooltip") {
      executeInTheNextEventLoopTick(() => {
        if (rootRefObject.current?.contains(getActiveElement(rootRefObject.current)) || popupRef.current?.contains(getActiveElement(popupRef.current))) {
          return;
        }
        dismissViews();
      });
    } else {
      dismissViews();
    }
  });
  const [clickAwayRef, onPaperClick, onPaperTouchStart] = useClickAwayListener(open2, handleClickAway);
  const paperRef = reactExports.useRef(null);
  const handleRef = useForkRef(paperRef, popupRef);
  const handlePaperRef = useForkRef(handleRef, clickAwayRef);
  const handleKeyDown = (event2) => {
    if (event2.key === "Escape") {
      event2.stopPropagation();
      dismissViews();
    }
  };
  const Transition2 = slots?.desktopTransition ?? reduceAnimations ? Fade : Grow;
  const FocusTrap$1 = slots?.desktopTrapFocus ?? FocusTrap;
  const Paper3 = slots?.desktopPaper ?? PickerPopperPaper;
  const Popper4 = slots?.popper ?? PickerPopperRoot;
  const popperProps = useSlotProps({
    elementType: Popper4,
    externalSlotProps: slotProps?.popper,
    additionalProps: {
      transition: true,
      role: viewContainerRole == null ? void 0 : viewContainerRole,
      open: open2,
      placement,
      anchorEl: triggerElement,
      onKeyDown: handleKeyDown
    },
    className: classes.root,
    ownerState: pickerOwnerState
  });
  const ownerState = reactExports.useMemo(() => _extends({}, pickerOwnerState, {
    popperPlacement: popperProps.placement
  }), [pickerOwnerState, popperProps.placement]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Popper4, _extends({}, popperProps, {
    children: ({
      TransitionProps
    }) => /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap$1, _extends({
      open: open2,
      disableAutoFocus: true,
      disableRestoreFocus: true,
      disableEnforceFocus: viewContainerRole === "tooltip",
      isEnabled: () => true
    }, slotProps?.desktopTrapFocus, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Transition2, _extends({}, TransitionProps, slotProps?.desktopTransition, {
        onExited: (event2) => {
          onPopperExited?.();
          slotProps?.desktopTransition?.onExited?.(event2);
          TransitionProps?.onExited?.();
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickerPopperPaperWrapper, {
          PaperComponent: Paper3,
          ownerState,
          ref: handlePaperRef,
          onPaperClick,
          onPaperTouchStart,
          paperClasses: classes.paper,
          paperSlotProps: slotProps?.desktopPaper,
          children
        })
      }))
    }))
  }));
}
function getOrientation() {
  if (typeof window === "undefined") {
    return "portrait";
  }
  if (window.screen && window.screen.orientation && window.screen.orientation.angle) {
    return Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait";
  }
  if (window.orientation) {
    return Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
  }
  return "portrait";
}
function useOrientation(views, customOrientation) {
  const [orientation, setOrientation] = reactExports.useState(getOrientation);
  useEnhancedEffect(() => {
    const eventHandler = () => {
      setOrientation(getOrientation());
    };
    window.addEventListener("orientationchange", eventHandler);
    return () => {
      window.removeEventListener("orientationchange", eventHandler);
    };
  }, []);
  if (arrayIncludes(views, ["hours", "minutes", "seconds"])) {
    return "portrait";
  }
  return customOrientation ?? orientation;
}
const warnedOnceCache = /* @__PURE__ */ new Set();
function warnOnce(message, gravity = "warning") {
  if (process.env.NODE_ENV === "production") {
    return;
  }
  const cleanMessage = Array.isArray(message) ? message.join("\n") : message;
  if (!warnedOnceCache.has(cleanMessage)) {
    warnedOnceCache.add(cleanMessage);
    if (gravity === "error") {
      console.error(cleanMessage);
    } else {
      console.warn(cleanMessage);
    }
  }
}
function useValueAndOpenStates(parameters) {
  const {
    props,
    valueManager,
    validator: validator2
  } = parameters;
  const {
    value: valueProp,
    defaultValue: defaultValueProp,
    onChange,
    referenceDate,
    timezone: timezoneProp,
    onAccept,
    closeOnSelect,
    open: openProp,
    onOpen,
    onClose
  } = props;
  const {
    current: defaultValue
  } = reactExports.useRef(defaultValueProp);
  const {
    current: isValueControlled
  } = reactExports.useRef(valueProp !== void 0);
  const {
    current: isOpenControlled
  } = reactExports.useRef(openProp !== void 0);
  const adapter = usePickerAdapter();
  if (process.env.NODE_ENV !== "production") {
    if (props.renderInput != null) {
      warnOnce(["MUI X: The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]);
    }
  }
  if (process.env.NODE_ENV !== "production") {
    reactExports.useEffect(() => {
      if (isValueControlled !== (valueProp !== void 0)) {
        console.error([`MUI X: A component is changing the ${isValueControlled ? "" : "un"}controlled value of a Picker to be ${isValueControlled ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled valuefor the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join("\n"));
      }
    }, [valueProp]);
    reactExports.useEffect(() => {
      if (!isValueControlled && defaultValue !== defaultValueProp) {
        console.error([`MUI X: A component is changing the defaultValue of an uncontrolled Picker after being initialized. To suppress this warning opt to use a controlled value.`].join("\n"));
      }
    }, [JSON.stringify(defaultValue)]);
  }
  const {
    timezone,
    value,
    handleValueChange
  } = useControlledValue({
    name: "a picker component",
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    referenceDate,
    onChange,
    valueManager
  });
  const [state, setState] = reactExports.useState(() => ({
    open: false,
    lastExternalValue: value,
    clockShallowValue: void 0,
    lastCommittedValue: value,
    hasBeenModifiedSinceMount: false
  }));
  const {
    getValidationErrorForNewValue
  } = useValidation({
    props,
    validator: validator2,
    timezone,
    value,
    onError: props.onError
  });
  const setOpen = useEventCallback((action) => {
    const newOpen = typeof action === "function" ? action(state.open) : action;
    if (!isOpenControlled) {
      setState((prevState) => _extends({}, prevState, {
        open: newOpen
      }));
    }
    if (newOpen && onOpen) {
      onOpen();
    }
    if (!newOpen) {
      onClose?.();
    }
  });
  const setValue = useEventCallback((newValue, options) => {
    const {
      changeImportance = "accept",
      skipPublicationIfPristine = false,
      validationError,
      shortcut,
      source,
      shouldClose = changeImportance === "accept"
    } = options ?? {};
    let shouldFireOnChange;
    let shouldFireOnAccept;
    if (!skipPublicationIfPristine && !isValueControlled && !state.hasBeenModifiedSinceMount) {
      shouldFireOnChange = true;
      shouldFireOnAccept = changeImportance === "accept";
    } else {
      shouldFireOnChange = !valueManager.areValuesEqual(adapter, newValue, value);
      shouldFireOnAccept = changeImportance === "accept" && !valueManager.areValuesEqual(adapter, newValue, state.lastCommittedValue);
    }
    setState((prevState) => _extends({}, prevState, {
      // We reset the shallow value whenever we fire onChange.
      clockShallowValue: shouldFireOnChange ? void 0 : prevState.clockShallowValue,
      lastCommittedValue: shouldFireOnAccept ? newValue : prevState.lastCommittedValue,
      hasBeenModifiedSinceMount: true
    }));
    let cachedContext = null;
    const getContext2 = () => {
      if (!cachedContext) {
        let inferredSource;
        if (source) {
          inferredSource = source;
        } else if (shortcut) {
          inferredSource = "view";
        } else {
          inferredSource = "unknown";
        }
        cachedContext = {
          validationError: validationError == null ? getValidationErrorForNewValue(newValue) : validationError,
          source: inferredSource
        };
        if (shortcut) {
          cachedContext.shortcut = shortcut;
        }
      }
      return cachedContext;
    };
    if (shouldFireOnChange) {
      handleValueChange(newValue, getContext2());
    }
    if (shouldFireOnAccept && onAccept) {
      onAccept(newValue, getContext2());
    }
    if (shouldClose) {
      setOpen(false);
    }
  });
  if (value !== state.lastExternalValue) {
    setState((prevState) => _extends({}, prevState, {
      lastExternalValue: value,
      clockShallowValue: void 0,
      hasBeenModifiedSinceMount: true
    }));
  }
  const setValueFromView = useEventCallback((newValue, selectionState = "partial") => {
    if (selectionState === "shallow") {
      setState((prev2) => _extends({}, prev2, {
        clockShallowValue: newValue,
        hasBeenModifiedSinceMount: true
      }));
      return;
    }
    setValue(newValue, {
      changeImportance: selectionState === "finish" && closeOnSelect ? "accept" : "set",
      source: "view"
    });
  });
  reactExports.useEffect(() => {
    if (isOpenControlled) {
      if (openProp === void 0) {
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      }
      setState((prevState) => _extends({}, prevState, {
        open: openProp
      }));
    }
  }, [isOpenControlled, openProp]);
  const viewValue = reactExports.useMemo(() => valueManager.cleanValue(adapter, state.clockShallowValue === void 0 ? value : state.clockShallowValue), [adapter, valueManager, state.clockShallowValue, value]);
  return {
    timezone,
    state,
    setValue,
    setValueFromView,
    setOpen,
    value,
    viewValue
  };
}
const _excluded$6 = ["className", "sx"];
const usePicker = ({
  ref: ref2,
  props,
  valueManager,
  valueType,
  variant,
  validator: validator2,
  onPopperExited,
  autoFocusView,
  rendererInterceptor: RendererInterceptor,
  localeText,
  viewContainerRole,
  getStepNavigation
}) => {
  const {
    // View props
    views,
    view: viewProp,
    openTo,
    onViewChange,
    viewRenderers,
    reduceAnimations: reduceAnimationsProp,
    orientation: orientationProp,
    disableOpenPicker,
    closeOnSelect,
    // Form props
    disabled,
    readOnly,
    // Field props
    formatDensity,
    enableAccessibleFieldDOMStructure,
    selectedSections,
    onSelectedSectionsChange,
    format: format2,
    label,
    // Other props
    autoFocus,
    name
  } = props;
  const {
    className,
    sx: sx2
  } = props, propsToForwardToView = _objectWithoutPropertiesLoose(props, _excluded$6);
  const labelId = useId();
  const adapter = usePickerAdapter();
  const reduceAnimations = useReduceAnimations(reduceAnimationsProp);
  const orientation = useOrientation(views, orientationProp);
  const {
    current: initialView
  } = reactExports.useRef(openTo ?? null);
  const [triggerElement, triggerRef] = reactExports.useState(null);
  const popupRef = reactExports.useRef(null);
  const fieldRef = reactExports.useRef(null);
  const rootRefObject = reactExports.useRef(null);
  const rootRef = useForkRef(ref2, rootRefObject);
  const {
    timezone,
    state,
    setOpen,
    setValue,
    setValueFromView,
    value,
    viewValue
  } = useValueAndOpenStates({
    props,
    valueManager,
    validator: validator2
  });
  const {
    view,
    setView,
    defaultView,
    focusedView,
    setFocusedView,
    setValueAndGoToNextView,
    goToNextStep,
    hasNextStep,
    hasSeveralSteps
  } = useViews({
    view: viewProp,
    views,
    openTo,
    onChange: setValueFromView,
    onViewChange,
    autoFocus: autoFocusView,
    getStepNavigation
  });
  const clearValue = useEventCallback(() => setValue(valueManager.emptyValue, {
    source: "view"
  }));
  const setValueToToday = useEventCallback(() => setValue(valueManager.getTodayValue(adapter, timezone, valueType), {
    source: "view"
  }));
  const acceptValueChanges = useEventCallback(() => setValue(value, {
    source: "view"
  }));
  const cancelValueChanges = useEventCallback(() => setValue(state.lastCommittedValue, {
    skipPublicationIfPristine: true,
    source: "view"
  }));
  const dismissViews = useEventCallback(() => {
    setValue(value, {
      skipPublicationIfPristine: true,
      source: "view"
    });
  });
  const {
    hasUIView,
    viewModeLookup,
    timeViewsCount
  } = reactExports.useMemo(() => views.reduce((acc, viewForReduce) => {
    const viewMode = viewRenderers[viewForReduce] == null ? "field" : "UI";
    acc.viewModeLookup[viewForReduce] = viewMode;
    if (viewMode === "UI") {
      acc.hasUIView = true;
      if (isTimeView(viewForReduce)) {
        acc.timeViewsCount += 1;
      }
    }
    return acc;
  }, {
    hasUIView: false,
    viewModeLookup: {},
    timeViewsCount: 0
  }), [viewRenderers, views]);
  const currentViewMode = viewModeLookup[view];
  const getCurrentViewMode = useEventCallback(() => currentViewMode);
  const [popperView, setPopperView] = reactExports.useState(currentViewMode === "UI" ? view : null);
  if (popperView !== view && viewModeLookup[view] === "UI") {
    setPopperView(view);
  }
  useEnhancedEffect(() => {
    if (currentViewMode === "field" && state.open) {
      setOpen(false);
      setTimeout(() => {
        fieldRef?.current?.setSelectedSections(view);
        fieldRef?.current?.focusField(view);
      });
    }
  }, [view]);
  useEnhancedEffect(() => {
    if (!state.open) {
      return;
    }
    let newView = view;
    if (currentViewMode === "field" && popperView != null) {
      newView = popperView;
    }
    if (newView !== defaultView && viewModeLookup[newView] === "UI" && viewModeLookup[defaultView] === "UI") {
      newView = defaultView;
    }
    if (newView !== view) {
      setView(newView);
    }
    setFocusedView(newView, true);
  }, [state.open]);
  const ownerState = reactExports.useMemo(() => ({
    isPickerValueEmpty: valueManager.areValuesEqual(adapter, value, valueManager.emptyValue),
    isPickerOpen: state.open,
    isPickerDisabled: props.disabled ?? false,
    isPickerReadOnly: props.readOnly ?? false,
    pickerOrientation: orientation,
    pickerVariant: variant
  }), [adapter, valueManager, value, state.open, orientation, variant, props.disabled, props.readOnly]);
  const triggerStatus = reactExports.useMemo(() => {
    if (disableOpenPicker || !hasUIView) {
      return "hidden";
    }
    if (disabled || readOnly) {
      return "disabled";
    }
    return "enabled";
  }, [disableOpenPicker, hasUIView, disabled, readOnly]);
  const wrappedGoToNextStep = useEventCallback(goToNextStep);
  const defaultActionBarActions = reactExports.useMemo(() => {
    if (closeOnSelect && !hasSeveralSteps) {
      return [];
    }
    return ["cancel", "nextOrAccept"];
  }, [closeOnSelect, hasSeveralSteps]);
  const actionsContextValue = reactExports.useMemo(() => ({
    setValue,
    setOpen,
    clearValue,
    setValueToToday,
    acceptValueChanges,
    cancelValueChanges,
    setView,
    goToNextStep: wrappedGoToNextStep
  }), [setValue, setOpen, clearValue, setValueToToday, acceptValueChanges, cancelValueChanges, setView, wrappedGoToNextStep]);
  const contextValue = reactExports.useMemo(() => _extends({}, actionsContextValue, {
    value,
    timezone,
    open: state.open,
    views,
    view: popperView,
    initialView,
    disabled: disabled ?? false,
    readOnly: readOnly ?? false,
    autoFocus: autoFocus ?? false,
    variant,
    orientation,
    popupRef,
    reduceAnimations,
    triggerRef,
    triggerStatus,
    hasNextStep,
    fieldFormat: format2 ?? "",
    name,
    label,
    rootSx: sx2,
    rootRef,
    rootClassName: className
  }), [actionsContextValue, value, rootRef, variant, orientation, reduceAnimations, disabled, readOnly, format2, className, name, label, sx2, triggerStatus, hasNextStep, timezone, state.open, popperView, views, initialView, autoFocus]);
  const privateContextValue = reactExports.useMemo(() => ({
    dismissViews,
    ownerState,
    hasUIView,
    getCurrentViewMode,
    rootRefObject,
    labelId,
    triggerElement,
    viewContainerRole,
    defaultActionBarActions,
    onPopperExited
  }), [dismissViews, ownerState, hasUIView, getCurrentViewMode, labelId, triggerElement, viewContainerRole, defaultActionBarActions, onPopperExited]);
  const fieldPrivateContextValue = reactExports.useMemo(() => ({
    formatDensity,
    enableAccessibleFieldDOMStructure,
    selectedSections,
    onSelectedSectionsChange,
    fieldRef
  }), [formatDensity, enableAccessibleFieldDOMStructure, selectedSections, onSelectedSectionsChange, fieldRef]);
  const isValidContextValue = (testedValue) => {
    const error = validator2({
      adapter,
      value: testedValue,
      timezone,
      props
    });
    return !valueManager.hasError(error);
  };
  const renderCurrentView = () => {
    if (popperView == null) {
      return null;
    }
    const renderer = viewRenderers[popperView];
    if (renderer == null) {
      return null;
    }
    const rendererProps = _extends({}, propsToForwardToView, {
      views,
      timezone,
      value: viewValue,
      onChange: setValueAndGoToNextView,
      view: popperView,
      onViewChange: setView,
      showViewSwitcher: timeViewsCount > 1,
      timeViewsCount
    }, viewContainerRole === "tooltip" ? {
      focusedView: null,
      onFocusedViewChange: () => {
      }
    } : {
      focusedView,
      onFocusedViewChange: setFocusedView
    });
    if (RendererInterceptor) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(RendererInterceptor, {
        viewRenderers,
        popperView,
        rendererProps
      });
    }
    return renderer(rendererProps);
  };
  return {
    providerProps: {
      localeText,
      contextValue,
      privateContextValue,
      actionsContextValue,
      fieldPrivateContextValue,
      isValidContextValue
    },
    renderCurrentView,
    ownerState
  };
};
function getPickersLayoutUtilityClass(slot) {
  return generateUtilityClass("MuiPickersLayout", slot);
}
const pickersLayoutClasses = generateUtilityClasses("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]);
const _excluded$5 = ["actions"];
const PickersActionBarRoot = styled(DialogActions, {
  name: "MuiPickersLayout",
  slot: "ActionBar"
})({});
function PickersActionBarComponent(props) {
  const {
    actions
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$5);
  const translations = usePickerTranslations();
  const {
    clearValue,
    setValueToToday,
    acceptValueChanges,
    cancelValueChanges,
    goToNextStep,
    hasNextStep
  } = usePickerContext();
  if (actions == null || actions.length === 0) {
    return null;
  }
  const buttons = actions?.map((actionType) => {
    switch (actionType) {
      case "clear":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, {
          onClick: clearValue,
          children: translations.clearButtonLabel
        }, actionType);
      case "cancel":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, {
          onClick: cancelValueChanges,
          children: translations.cancelButtonLabel
        }, actionType);
      case "accept":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, {
          onClick: acceptValueChanges,
          children: translations.okButtonLabel
        }, actionType);
      case "today":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, {
          onClick: setValueToToday,
          children: translations.todayButtonLabel
        }, actionType);
      case "next":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, {
          onClick: goToNextStep,
          children: translations.nextStepButtonLabel
        }, actionType);
      case "nextOrAccept":
        if (hasNextStep) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, {
            onClick: goToNextStep,
            children: translations.nextStepButtonLabel
          }, actionType);
        }
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, {
          onClick: acceptValueChanges,
          children: translations.okButtonLabel
        }, actionType);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersActionBarRoot, _extends({}, other, {
    children: buttons
  }));
}
process.env.NODE_ENV !== "production" ? PickersActionBarComponent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default
   * - `[]` for Pickers with one selection step which `closeOnSelect`.
   * - `['cancel', 'nextOrAccept']` for all other Pickers.
   */
  actions: PropTypes.arrayOf(PropTypes.oneOf(["accept", "cancel", "clear", "next", "nextOrAccept", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
const PickersActionBar = /* @__PURE__ */ reactExports.memo(PickersActionBarComponent);
if (process.env.NODE_ENV !== "production") PickersActionBar.displayName = "PickersActionBar";
const _excluded$4 = ["items", "changeImportance"], _excluded2$2 = ["getValue"];
const PickersShortcutsRoot = styled(List$1, {
  name: "MuiPickersLayout",
  slot: "Shortcuts"
})({});
function PickersShortcuts(props) {
  const {
    items,
    changeImportance = "accept"
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$4);
  const {
    setValue
  } = usePickerActionsContext();
  const isValidValue = useIsValidValue();
  if (items == null || items.length === 0) {
    return null;
  }
  const resolvedItems = items.map((_ref) => {
    let {
      getValue: getValue2
    } = _ref, item = _objectWithoutPropertiesLoose(_ref, _excluded2$2);
    const newValue = getValue2({
      isValid: isValidValue
    });
    return _extends({}, item, {
      label: item.label,
      onClick: () => {
        setValue(newValue, {
          changeImportance,
          shortcut: item,
          source: "view"
        });
      },
      disabled: !isValidValue(newValue)
    });
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersShortcutsRoot, _extends({
    dense: true,
    sx: [{
      maxHeight: VIEW_HEIGHT,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(other.sx) ? other.sx : [other.sx]]
  }, other, {
    children: resolvedItems.map((item) => {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Chip, _extends({}, item))
      }, item.id ?? item.label);
    })
  }));
}
process.env.NODE_ENV !== "production" ? PickersShortcuts.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the Picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the Picker.
   * @default "accept"
   */
  changeImportance: PropTypes.oneOf(["accept", "set"]),
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default []
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    getValue: PropTypes.func.isRequired,
    id: PropTypes.string,
    label: PropTypes.string.isRequired
  })),
  style: PropTypes.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
const _excluded$3 = ["ownerState"];
function toolbarHasView(toolbarProps) {
  return toolbarProps.view !== null;
}
const useUtilityClasses$1 = (classes, ownerState) => {
  const {
    pickerOrientation
  } = ownerState;
  const slots = {
    root: ["root", pickerOrientation === "landscape" && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  };
  return composeClasses(slots, getPickersLayoutUtilityClass, classes);
};
const usePickerLayout = (props) => {
  const {
    ownerState: pickerOwnerState,
    defaultActionBarActions
  } = usePickerPrivateContext();
  const {
    view
  } = usePickerContext();
  const isRtl = useRtl();
  const {
    children,
    slots,
    slotProps,
    classes: classesProp
  } = props;
  const ownerState = reactExports.useMemo(() => _extends({}, pickerOwnerState, {
    layoutDirection: isRtl ? "rtl" : "ltr",
    hasShortcuts: false
  }), [pickerOwnerState, isRtl]);
  const classes = useUtilityClasses$1(classesProp, ownerState);
  const ActionBar = slots?.actionBar ?? PickersActionBar;
  const _useSlotProps = useSlotProps({
    elementType: ActionBar,
    externalSlotProps: slotProps?.actionBar,
    additionalProps: {
      actions: defaultActionBarActions
    },
    className: classes.actionBar,
    ownerState
  }), actionBarProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded$3);
  const actionBar = /* @__PURE__ */ jsxRuntimeExports.jsx(ActionBar, _extends({}, actionBarProps));
  const Toolbar = slots?.toolbar;
  const toolbarProps = useSlotProps({
    elementType: Toolbar,
    externalSlotProps: slotProps?.toolbar,
    className: classes.toolbar,
    ownerState
  });
  const toolbar = toolbarHasView(toolbarProps) && !!Toolbar ? /* @__PURE__ */ jsxRuntimeExports.jsx(Toolbar, _extends({}, toolbarProps)) : null;
  const content = children;
  const Tabs3 = slots?.tabs;
  const tabs2 = view && Tabs3 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Tabs3, _extends({
    className: classes.tabs
  }, slotProps?.tabs)) : null;
  const Shortcuts = slots?.shortcuts ?? PickersShortcuts;
  const shortcutsProps = useSlotProps({
    elementType: Shortcuts,
    externalSlotProps: slotProps?.shortcuts,
    className: classes.shortcuts,
    ownerState
  });
  const hasShortcuts = Array.isArray(shortcutsProps?.items) && shortcutsProps.items.length > 0;
  const shortcuts = view && !!Shortcuts ? /* @__PURE__ */ jsxRuntimeExports.jsx(Shortcuts, _extends({}, shortcutsProps)) : null;
  return {
    toolbar,
    content,
    tabs: tabs2,
    actionBar,
    shortcuts,
    ownerState: _extends({}, ownerState, {
      hasShortcuts
    })
  };
};
const useUtilityClasses = (classes, ownerState) => {
  const {
    pickerOrientation
  } = ownerState;
  const slots = {
    root: ["root", pickerOrientation === "landscape" && "landscape"],
    contentWrapper: ["contentWrapper"]
  };
  return composeClasses(slots, getPickersLayoutUtilityClass, classes);
};
const PickersLayoutRoot = styled("div", {
  name: "MuiPickersLayout",
  slot: "Root"
})({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${pickersLayoutClasses.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  },
  variants: [{
    props: {
      pickerOrientation: "landscape",
      hasShortcuts: false
    },
    style: {
      [`& .${pickersLayoutClasses.toolbar}`]: {
        gridColumn: 1,
        gridRow: "1 / 3"
      }
    }
  }, {
    props: {
      pickerOrientation: "landscape",
      hasShortcuts: true
    },
    style: {
      [`& .${pickersLayoutClasses.toolbar}`]: {
        gridColumn: "2 / 4",
        gridRow: 1,
        maxWidth: "max-content"
      },
      [`& .${pickersLayoutClasses.shortcuts}`]: {
        gridColumn: 1,
        gridRow: 2
      }
    }
  }, {
    props: {
      pickerOrientation: "portrait"
    },
    style: {
      [`& .${pickersLayoutClasses.toolbar}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      },
      [`& .${pickersLayoutClasses.shortcuts}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      }
    }
  }, {
    props: {
      hasShortcuts: true,
      layoutDirection: "rtl"
    },
    style: {
      [`& .${pickersLayoutClasses.shortcuts}`]: {
        gridColumn: 4
      }
    }
  }]
});
const PickersLayoutContentWrapper = styled("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper"
})({
  gridColumn: "2 / 4",
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
});
const PickersLayout = /* @__PURE__ */ reactExports.forwardRef(function PickersLayout2(inProps, ref2) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersLayout"
  });
  const {
    toolbar,
    content,
    tabs: tabs2,
    actionBar,
    shortcuts,
    ownerState
  } = usePickerLayout(props);
  const {
    orientation,
    variant
  } = usePickerContext();
  const {
    sx: sx2,
    className,
    classes: classesProp
  } = props;
  const classes = useUtilityClasses(classesProp, ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersLayoutRoot, {
    ref: ref2,
    sx: sx2,
    className: clsx(classes.root, className),
    ownerState,
    children: [orientation === "landscape" ? shortcuts : toolbar, orientation === "landscape" ? toolbar : shortcuts, /* @__PURE__ */ jsxRuntimeExports.jsx(PickersLayoutContentWrapper, {
      className: classes.contentWrapper,
      ownerState,
      children: variant === "desktop" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
        children: [content, tabs2]
      }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
        children: [tabs2, content]
      })
    }), actionBar]
  });
});
if (process.env.NODE_ENV !== "production") PickersLayout.displayName = "PickersLayout";
process.env.NODE_ENV !== "production" ? PickersLayout.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function createNonRangePickerStepNavigation(parameters) {
  const {
    steps
  } = parameters;
  return createStepNavigation({
    steps,
    isViewMatchingStep: (view, step) => {
      return step.views == null || step.views.includes(view);
    },
    onStepChange: ({
      step,
      defaultView,
      setView,
      view,
      views
    }) => {
      const targetView = step.views == null ? defaultView : step.views.find((viewBis) => views.includes(viewBis));
      if (targetView !== view) {
        setView(targetView);
      }
    }
  });
}
const _excluded$2 = ["props", "steps"], _excluded2$1 = ["ownerState"];
const useDesktopPicker = (_ref) => {
  let {
    props,
    steps
  } = _ref, pickerParams = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  const {
    slots,
    slotProps: innerSlotProps,
    label,
    inputRef,
    localeText
  } = props;
  const getStepNavigation = createNonRangePickerStepNavigation({
    steps
  });
  const {
    providerProps,
    renderCurrentView,
    ownerState
  } = usePicker(_extends({}, pickerParams, {
    props,
    localeText,
    autoFocusView: true,
    viewContainerRole: "dialog",
    variant: "desktop",
    getStepNavigation
  }));
  const labelId = providerProps.privateContextValue.labelId;
  const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
  const Field = slots.field;
  const _useSlotProps = useSlotProps({
    elementType: Field,
    externalSlotProps: innerSlotProps?.field,
    additionalProps: _extends({}, isToolbarHidden && {
      id: labelId
    }),
    ownerState
  }), fieldProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded2$1);
  const Layout = slots.layout ?? PickersLayout;
  let labelledById = labelId;
  if (isToolbarHidden) {
    if (label) {
      labelledById = `${labelId}-label`;
    } else {
      labelledById = void 0;
    }
  }
  const slotProps = _extends({}, innerSlotProps, {
    toolbar: _extends({}, innerSlotProps?.toolbar, {
      titleId: labelId
    }),
    popper: _extends({
      "aria-labelledby": labelledById
    }, innerSlotProps?.popper)
  });
  const renderPicker = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(PickerProvider, _extends({}, providerProps, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Field, _extends({}, fieldProps, {
      slots: _extends({}, slots, fieldProps.slots),
      slotProps: _extends({}, slotProps, fieldProps.slotProps),
      inputRef
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(PickerPopper, {
      slots,
      slotProps,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Layout, _extends({}, slotProps?.layout, {
        slots,
        slotProps,
        children: renderCurrentView()
      }))
    })]
  }));
  if (process.env.NODE_ENV !== "production") renderPicker.displayName = "renderPicker";
  return {
    renderPicker
  };
};
const renderDateViewCalendar = ({
  view,
  onViewChange,
  views,
  focusedView,
  onFocusedViewChange,
  value,
  defaultValue,
  referenceDate,
  onChange,
  className,
  classes,
  disableFuture,
  disablePast,
  minDate,
  maxDate,
  shouldDisableDate,
  shouldDisableMonth,
  shouldDisableYear,
  reduceAnimations,
  onMonthChange,
  monthsPerRow,
  onYearChange,
  yearsOrder,
  yearsPerRow,
  slots,
  slotProps,
  loading,
  renderLoading,
  disableHighlightToday,
  readOnly,
  disabled,
  showDaysOutsideCurrentMonth,
  dayOfWeekFormatter,
  sx: sx2,
  autoFocus,
  fixedWeekNumber,
  displayWeekNumber,
  timezone
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(DateCalendar, {
  view,
  onViewChange,
  views: views.filter(isDatePickerView),
  focusedView: focusedView && isDatePickerView(focusedView) ? focusedView : null,
  onFocusedViewChange,
  value,
  defaultValue,
  referenceDate,
  onChange,
  className,
  classes,
  disableFuture,
  disablePast,
  minDate,
  maxDate,
  shouldDisableDate,
  shouldDisableMonth,
  shouldDisableYear,
  reduceAnimations,
  onMonthChange,
  monthsPerRow,
  onYearChange,
  yearsOrder,
  yearsPerRow,
  slots,
  slotProps,
  loading,
  renderLoading,
  disableHighlightToday,
  readOnly,
  disabled,
  showDaysOutsideCurrentMonth,
  dayOfWeekFormatter,
  sx: sx2,
  autoFocus,
  fixedWeekNumber,
  displayWeekNumber,
  timezone
});
if (process.env.NODE_ENV !== "production") renderDateViewCalendar.displayName = "renderDateViewCalendar";
const DesktopDatePicker = /* @__PURE__ */ reactExports.forwardRef(function DesktopDatePicker2(inProps, ref2) {
  const adapter = usePickerAdapter();
  const defaultizedProps = useDatePickerDefaultizedProps(inProps, "MuiDesktopDatePicker");
  const viewRenderers = _extends({
    day: renderDateViewCalendar,
    month: renderDateViewCalendar,
    year: renderDateViewCalendar
  }, defaultizedProps.viewRenderers);
  const props = _extends({}, defaultizedProps, {
    closeOnSelect: defaultizedProps.closeOnSelect ?? true,
    viewRenderers,
    format: resolveDateFormat(adapter, defaultizedProps, false),
    yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
    slots: _extends({
      field: DateField
    }, defaultizedProps.slots),
    slotProps: _extends({}, defaultizedProps.slotProps, {
      field: (ownerState) => _extends({}, resolveComponentProps(defaultizedProps.slotProps?.field, ownerState), extractValidationProps(defaultizedProps)),
      toolbar: _extends({
        hidden: true
      }, defaultizedProps.slotProps?.toolbar)
    })
  });
  const {
    renderPicker
  } = useDesktopPicker({
    ref: ref2,
    props,
    valueManager: singleItemValueManager,
    valueType: "date",
    validator: validateDate,
    steps: null
  });
  return renderPicker();
});
if (process.env.NODE_ENV !== "production") DesktopDatePicker.displayName = "DesktopDatePicker";
DesktopDatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, the Picker will close after submitting the full date.
   * @default true
   */
  closeOnSelect: PropTypes.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */
  disableOpenPicker: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * @default true
   */
  enableAccessibleFieldDOMStructure: PropTypes.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: PropTypes.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context Context about this acceptance:
   * - `validationError`: validation result of the current value
   * - `source`: source of the acceptance. One of 'field' | 'view' | 'unknown'
   * - `shortcut` (optional): the shortcut metadata if the value was accepted via a shortcut selection
   */
  onAccept: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context Context about this change:
   * - `validationError`: validation result of the current value
   * - `source`: source of the change. One of 'field' | 'view' | 'unknown'
   * - `shortcut` (optional): the shortcut metadata if the change was triggered by a shortcut selection
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: PropTypes.func,
  /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: PropTypes.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: PropTypes.shape({
    day: PropTypes.func,
    month: PropTypes.func,
    year: PropTypes.func
  }),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: PropTypes.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
};
const PickersModalDialogRoot = styled(Dialog, {
  slot: "internal"
})({
  [`& .${dialogClasses.container}`]: {
    outline: 0
  },
  [`& .${dialogClasses.paper}`]: {
    outline: 0,
    minWidth: DIALOG_WIDTH
  }
});
const PickersModalDialogContent = styled(DialogContent, {
  slot: "internal"
})({
  "&:first-of-type": {
    padding: 0
  }
});
function PickersModalDialog(props) {
  const {
    children,
    slots,
    slotProps
  } = props;
  const {
    open: open2
  } = usePickerContext();
  const {
    dismissViews,
    onPopperExited
  } = usePickerPrivateContext();
  const Dialog3 = slots?.dialog ?? PickersModalDialogRoot;
  const Transition2 = slots?.mobileTransition ?? Fade;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog3, _extends({
    open: open2,
    onClose: () => {
      dismissViews();
      onPopperExited?.();
    }
  }, slotProps?.dialog, {
    TransitionComponent: Transition2,
    TransitionProps: slotProps?.mobileTransition,
    PaperComponent: slots?.mobilePaper,
    PaperProps: slotProps?.mobilePaper,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersModalDialogContent, {
      children
    })
  }));
}
const _excluded$1 = ["props", "steps"], _excluded2 = ["ownerState"];
const useMobilePicker = (_ref) => {
  let {
    props,
    steps
  } = _ref, pickerParams = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  const {
    slots,
    slotProps: innerSlotProps,
    label,
    inputRef,
    localeText
  } = props;
  const getStepNavigation = createNonRangePickerStepNavigation({
    steps
  });
  const {
    providerProps,
    renderCurrentView,
    ownerState
  } = usePicker(_extends({}, pickerParams, {
    props,
    localeText,
    autoFocusView: true,
    viewContainerRole: "dialog",
    variant: "mobile",
    getStepNavigation
  }));
  const labelId = providerProps.privateContextValue.labelId;
  const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
  const Field = slots.field;
  const _useSlotProps = useSlotProps({
    elementType: Field,
    externalSlotProps: innerSlotProps?.field,
    additionalProps: _extends({}, isToolbarHidden && {
      id: labelId
    }),
    ownerState
  }), fieldProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded2);
  const Layout = slots.layout ?? PickersLayout;
  let labelledById = labelId;
  if (isToolbarHidden) {
    if (label) {
      labelledById = `${labelId}-label`;
    } else {
      labelledById = void 0;
    }
  }
  const slotProps = _extends({}, innerSlotProps, {
    toolbar: _extends({}, innerSlotProps?.toolbar, {
      titleId: labelId
    }),
    mobilePaper: _extends({
      "aria-labelledby": labelledById
    }, innerSlotProps?.mobilePaper)
  });
  const renderPicker = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(PickerProvider, _extends({}, providerProps, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Field, _extends({}, fieldProps, {
      slots: _extends({}, slots, fieldProps.slots),
      slotProps: _extends({}, slotProps, fieldProps.slotProps),
      inputRef
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(PickersModalDialog, {
      slots,
      slotProps,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Layout, _extends({}, slotProps?.layout, {
        slots,
        slotProps,
        children: renderCurrentView()
      }))
    })]
  }));
  if (process.env.NODE_ENV !== "production") renderPicker.displayName = "renderPicker";
  return {
    renderPicker
  };
};
const MobileDatePicker = /* @__PURE__ */ reactExports.forwardRef(function MobileDatePicker2(inProps, ref2) {
  const adapter = usePickerAdapter();
  const defaultizedProps = useDatePickerDefaultizedProps(inProps, "MuiMobileDatePicker");
  const viewRenderers = _extends({
    day: renderDateViewCalendar,
    month: renderDateViewCalendar,
    year: renderDateViewCalendar
  }, defaultizedProps.viewRenderers);
  const props = _extends({}, defaultizedProps, {
    viewRenderers,
    format: resolveDateFormat(adapter, defaultizedProps, false),
    slots: _extends({
      field: DateField
    }, defaultizedProps.slots),
    slotProps: _extends({}, defaultizedProps.slotProps, {
      field: (ownerState) => _extends({}, resolveComponentProps(defaultizedProps.slotProps?.field, ownerState), extractValidationProps(defaultizedProps)),
      toolbar: _extends({
        hidden: false
      }, defaultizedProps.slotProps?.toolbar)
    })
  });
  const {
    renderPicker
  } = useMobilePicker({
    ref: ref2,
    props,
    valueManager: singleItemValueManager,
    valueType: "date",
    validator: validateDate,
    steps: null
  });
  return renderPicker();
});
if (process.env.NODE_ENV !== "production") MobileDatePicker.displayName = "MobileDatePicker";
MobileDatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */
  closeOnSelect: PropTypes.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */
  disableOpenPicker: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * @default true
   */
  enableAccessibleFieldDOMStructure: PropTypes.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: PropTypes.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context Context about this acceptance:
   * - `validationError`: validation result of the current value
   * - `source`: source of the acceptance. One of 'field' | 'view' | 'unknown'
   * - `shortcut` (optional): the shortcut metadata if the value was accepted via a shortcut selection
   */
  onAccept: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context Context about this change:
   * - `validationError`: validation result of the current value
   * - `source`: source of the change. One of 'field' | 'view' | 'unknown'
   * - `shortcut` (optional): the shortcut metadata if the change was triggered by a shortcut selection
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: PropTypes.func,
  /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: PropTypes.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: PropTypes.shape({
    day: PropTypes.func,
    month: PropTypes.func,
    year: PropTypes.func
  }),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: PropTypes.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
};
const _excluded = ["desktopModeMediaQuery"];
const DatePicker$1 = /* @__PURE__ */ reactExports.forwardRef(function DatePicker(inProps, ref2) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiDatePicker"
  });
  const {
    desktopModeMediaQuery = DEFAULT_DESKTOP_MODE_MEDIA_QUERY
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded);
  const isDesktop = useMediaQuery(desktopModeMediaQuery, {
    defaultMatches: true
  });
  if (isDesktop) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopDatePicker, _extends({
      ref: ref2
    }, other));
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MobileDatePicker, _extends({
    ref: ref2
  }, other));
});
if (process.env.NODE_ENV !== "production") DatePicker$1.displayName = "DatePicker";
process.env.NODE_ENV !== "production" ? DatePicker$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, the Picker will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: PropTypes.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: PropTypes.string,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */
  disableOpenPicker: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * @default true
   */
  enableAccessibleFieldDOMStructure: PropTypes.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: PropTypes.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context Context about this acceptance:
   * - `validationError`: validation result of the current value
   * - `source`: source of the acceptance. One of 'field' | 'view' | 'unknown'
   * - `shortcut` (optional): the shortcut metadata if the value was accepted via a shortcut selection
   */
  onAccept: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context Context about this change:
   * - `validationError`: validation result of the current value
   * - `source`: source of the change. One of 'field' | 'view' | 'unknown'
   * - `shortcut` (optional): the shortcut metadata if the change was triggered by a shortcut selection
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: PropTypes.func,
  /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: PropTypes.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: PropTypes.shape({
    day: PropTypes.func,
    month: PropTypes.func,
    year: PropTypes.func
  }),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: PropTypes.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
} : void 0;
const formatTokenMap = {
  // Year
  y: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yy: "year",
  yyyy: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  // Month
  L: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  LL: "month",
  LLL: {
    sectionType: "month",
    contentType: "letter"
  },
  LLLL: {
    sectionType: "month",
    contentType: "letter"
  },
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  d: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  dd: "day",
  // Day of the week
  c: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  E: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 2
  },
  EEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  a: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
};
const defaultFormats = {
  year: "yyyy",
  month: "LLLL",
  monthShort: "MMM",
  dayOfMonth: "d",
  // Full day of the month format (i.e. 3rd) is not supported
  // Falling back to regular format
  dayOfMonthFull: "d",
  weekday: "cccc",
  weekdayShort: "ccccc",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "a",
  minutes: "mm",
  seconds: "ss",
  fullDate: "DD",
  keyboardDate: "D",
  shortDate: "MMM d",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  fullTime12h: "hh:mm a",
  fullTime24h: "HH:mm",
  keyboardDateTime12h: "D hh:mm a",
  keyboardDateTime24h: "D T"
};
class AdapterLuxon {
  isMUIAdapter = true;
  isTimezoneCompatible = true;
  lib = "luxon";
  escapedCharacters = {
    start: "'",
    end: "'"
  };
  formatTokenMap = /* @__PURE__ */ (() => formatTokenMap)();
  constructor({
    locale,
    formats
  } = {}) {
    this.locale = locale || "en-US";
    this.formats = _extends({}, defaultFormats, formats);
  }
  setLocaleToValue = (value) => {
    const expectedLocale = this.getCurrentLocaleCode();
    if (expectedLocale === value.locale) {
      return value;
    }
    return value.setLocale(expectedLocale);
  };
  date = (value, timezone = "default") => {
    if (value === null) {
      return null;
    }
    if (typeof value === "undefined") {
      return DateTime.fromJSDate(/* @__PURE__ */ new Date(), {
        locale: this.locale,
        zone: timezone
      });
    }
    return DateTime.fromISO(value, {
      locale: this.locale,
      zone: timezone
    });
  };
  getInvalidDate = () => DateTime.fromJSDate(/* @__PURE__ */ new Date("Invalid Date"));
  getTimezone = (value) => {
    if (value.zone.type === "system") {
      return "system";
    }
    return value.zoneName;
  };
  setTimezone = (value, timezone) => {
    if (!value.zone.equals(Info.normalizeZone(timezone))) {
      return value.setZone(timezone);
    }
    return value;
  };
  toJsDate = (value) => {
    return value.toJSDate();
  };
  parse = (value, formatString) => {
    if (value === "") {
      return null;
    }
    return DateTime.fromFormat(value, formatString, {
      locale: this.locale
    });
  };
  getCurrentLocaleCode = () => {
    return this.locale;
  };
  /* v8 ignore start */
  is12HourCycleInCurrentLocale = () => {
    if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined") {
      return true;
    }
    return Boolean(new Intl.DateTimeFormat(this.locale, {
      hour: "numeric"
    })?.resolvedOptions()?.hour12);
  };
  /* v8 ignore stop */
  expandFormat = (format2) => {
    const catchEscapedSectionsRegexp = /''|'(''|[^'])+('|$)|[^']*/g;
    const validTokens = [...Object.keys(this.formatTokenMap), "yyyyy"];
    const isWordComposedOfTokens = new RegExp(`^(${validTokens.join("|")})+$`);
    const catchWordsRegexp = /(?:^|[^a-z])([a-z]+)(?:[^a-z]|$)|([a-z]+)/gi;
    return format2.match(catchEscapedSectionsRegexp).map((token2) => {
      const firstCharacter = token2[0];
      if (firstCharacter === "'") {
        return token2;
      }
      const expandedToken = DateTime.expandFormat(token2, {
        locale: this.locale
      });
      return expandedToken.replace(catchWordsRegexp, (substring, g12, g22) => {
        const word = g12 || g22;
        if (isWordComposedOfTokens.test(word)) {
          return substring;
        }
        return `'${substring}'`;
      });
    }).join("").replace("yyyyy", "yyyy");
  };
  isValid = (value) => {
    if (value === null) {
      return false;
    }
    return value.isValid;
  };
  format = (value, formatKey) => {
    return this.formatByString(value, this.formats[formatKey]);
  };
  formatByString = (value, format2) => {
    return value.setLocale(this.locale).toFormat(format2);
  };
  formatNumber = (numberToFormat) => {
    return numberToFormat;
  };
  isEqual = (value, comparing) => {
    if (value === null && comparing === null) {
      return true;
    }
    if (value === null || comparing === null) {
      return false;
    }
    return +value === +comparing;
  };
  isSameYear = (value, comparing) => {
    const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
    return value.hasSame(comparingInValueTimezone, "year");
  };
  isSameMonth = (value, comparing) => {
    const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
    return value.hasSame(comparingInValueTimezone, "month");
  };
  isSameDay = (value, comparing) => {
    const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
    return value.hasSame(comparingInValueTimezone, "day");
  };
  isSameHour = (value, comparing) => {
    const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
    return value.hasSame(comparingInValueTimezone, "hour");
  };
  isAfter = (value, comparing) => {
    return value > comparing;
  };
  isAfterYear = (value, comparing) => {
    const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
    const diff2 = value.diff(this.endOfYear(comparingInValueTimezone), "years").toObject();
    return diff2.years > 0;
  };
  isAfterDay = (value, comparing) => {
    const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
    const diff2 = value.diff(this.endOfDay(comparingInValueTimezone), "days").toObject();
    return diff2.days > 0;
  };
  isBefore = (value, comparing) => {
    return value < comparing;
  };
  isBeforeYear = (value, comparing) => {
    const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
    const diff2 = value.diff(this.startOfYear(comparingInValueTimezone), "years").toObject();
    return diff2.years < 0;
  };
  isBeforeDay = (value, comparing) => {
    const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
    const diff2 = value.diff(this.startOfDay(comparingInValueTimezone), "days").toObject();
    return diff2.days < 0;
  };
  isWithinRange = (value, [start2, end2]) => {
    return this.isEqual(value, start2) || this.isEqual(value, end2) || this.isAfter(value, start2) && this.isBefore(value, end2);
  };
  startOfYear = (value) => {
    return value.startOf("year");
  };
  startOfMonth = (value) => {
    return value.startOf("month");
  };
  startOfWeek = (value) => {
    return this.setLocaleToValue(value).startOf("week", {
      useLocaleWeeks: true
    });
  };
  startOfDay = (value) => {
    return value.startOf("day");
  };
  endOfYear = (value) => {
    return value.endOf("year");
  };
  endOfMonth = (value) => {
    return value.endOf("month");
  };
  endOfWeek = (value) => {
    return this.setLocaleToValue(value).endOf("week", {
      useLocaleWeeks: true
    });
  };
  endOfDay = (value) => {
    return value.endOf("day");
  };
  addYears = (value, amount) => {
    return value.plus({
      years: amount
    });
  };
  addMonths = (value, amount) => {
    return value.plus({
      months: amount
    });
  };
  addWeeks = (value, amount) => {
    return value.plus({
      weeks: amount
    });
  };
  addDays = (value, amount) => {
    return value.plus({
      days: amount
    });
  };
  addHours = (value, amount) => {
    return value.plus({
      hours: amount
    });
  };
  addMinutes = (value, amount) => {
    return value.plus({
      minutes: amount
    });
  };
  addSeconds = (value, amount) => {
    return value.plus({
      seconds: amount
    });
  };
  getYear = (value) => {
    return value.get("year");
  };
  getMonth = (value) => {
    return value.get("month") - 1;
  };
  getDate = (value) => {
    return value.get("day");
  };
  getHours = (value) => {
    return value.get("hour");
  };
  getMinutes = (value) => {
    return value.get("minute");
  };
  getSeconds = (value) => {
    return value.get("second");
  };
  getMilliseconds = (value) => {
    return value.get("millisecond");
  };
  setYear = (value, year) => {
    return value.set({
      year
    });
  };
  setMonth = (value, month) => {
    return value.set({
      month: month + 1
    });
  };
  setDate = (value, date) => {
    return value.set({
      day: date
    });
  };
  setHours = (value, hours) => {
    return value.set({
      hour: hours
    });
  };
  setMinutes = (value, minutes) => {
    return value.set({
      minute: minutes
    });
  };
  setSeconds = (value, seconds) => {
    return value.set({
      second: seconds
    });
  };
  setMilliseconds = (value, milliseconds) => {
    return value.set({
      millisecond: milliseconds
    });
  };
  getDaysInMonth = (value) => {
    return value.daysInMonth;
  };
  getWeekArray = (value) => {
    const firstDay = this.startOfWeek(this.startOfMonth(value));
    const lastDay = this.endOfWeek(this.endOfMonth(value));
    const {
      days
    } = lastDay.diff(firstDay, "days").toObject();
    const weeks = [];
    new Array(Math.round(days)).fill(0).map((_, i) => i).map((day) => firstDay.plus({
      days: day
    })).forEach((v, i) => {
      if (i === 0 || i % 7 === 0 && i > 6) {
        weeks.push([v]);
        return;
      }
      weeks[weeks.length - 1].push(v);
    });
    return weeks;
  };
  getWeekNumber = (value) => {
    return value.localWeekNumber ?? value.weekNumber;
  };
  getDayOfWeek = (value) => {
    return value.localWeekday ?? value.weekday;
  };
  getYearRange = ([start2, end2]) => {
    const startDate = this.startOfYear(start2);
    const endDate = this.endOfYear(end2);
    const years = [];
    let current = startDate;
    while (this.isBefore(current, endDate)) {
      years.push(current);
      current = this.addYears(current, 1);
    }
    return years;
  };
}
function getMeasurementKey(item) {
  return typeof item === "object" ? item.key : item;
}
function createLazyMeasurementsView(cache2, flat) {
  const count2 = cache2.length;
  return new Proxy(cache2, {
    get(target, prop, receiver) {
      if (typeof prop === "string") {
        const c = prop.charCodeAt(0);
        if (c >= 48 && c <= 57) {
          const i = +prop;
          if (Number.isInteger(i) && i >= 0 && i < count2) {
            let v = target[i];
            if (typeof v !== "object") {
              const s12 = flat[i * 2];
              v = target[i] = {
                index: i,
                key: v,
                start: s12,
                size: flat[i * 2 + 1],
                end: s12 + flat[i * 2 + 1],
                lane: 0
              };
            }
            return v;
          }
        }
        if (prop === "length") return count2;
      }
      return Reflect.get(target, prop, receiver);
    }
  });
}
function memo(getDeps, fn3, opts) {
  let deps = opts.initialDeps ?? [];
  let result;
  let isInitial = true;
  function memoizedFunction() {
    var _a2;
    const debugEnabled = process.env.NODE_ENV !== "production" && !!opts.key && !!((_a2 = opts.debug) == null ? void 0 : _a2.call(opts));
    let depTime = 0;
    if (debugEnabled) depTime = Date.now();
    const newDeps = getDeps();
    const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index2) => deps[index2] !== dep);
    if (!depsChanged) {
      return result;
    }
    deps = newDeps;
    let resultTime = 0;
    if (debugEnabled) resultTime = Date.now();
    result = fn3(...newDeps);
    if (debugEnabled) {
      const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
      const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
      const resultFpsPercentage = resultEndTime / 16;
      const pad = (str, num) => {
        str = String(str);
        while (str.length < num) {
          str = " " + str;
        }
        return str;
      };
      console.info(
        `%c⏱ ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * resultFpsPercentage, 120)
        )}deg 100% 31%);`,
        opts == null ? void 0 : opts.key
      );
    }
    if ((opts == null ? void 0 : opts.onChange) && !(isInitial && opts.skipInitialOnChange)) {
      opts.onChange(result);
    }
    isInitial = false;
    return result;
  }
  memoizedFunction.updateDeps = (newDeps) => {
    deps = newDeps;
  };
  return memoizedFunction;
}
function notUndefined(value, msg) {
  if (value === void 0) {
    throw new Error(`Unexpected undefined${""}`);
  } else {
    return value;
  }
}
const approxEqual = (a, b) => Math.abs(a - b) < 1.01;
const debounce = (targetWindow, fn3, ms2) => {
  let timeoutId;
  return Object.assign(
    function(...args) {
      targetWindow.clearTimeout(timeoutId);
      timeoutId = targetWindow.setTimeout(() => fn3.apply(this, args), ms2);
    },
    {
      // The handle is closure-local, so a caller that has already
      // unsubscribed has no way to stop a queued call. Teardown paths use
      // this to drop the pending invocation instead of letting it land.
      cancel: () => {
        targetWindow.clearTimeout(timeoutId);
      }
    }
  );
};
let _isIOSResult;
const isIOSWebKit = () => {
  if (_isIOSResult !== void 0) return _isIOSResult;
  if (typeof navigator === "undefined") return _isIOSResult = false;
  if (/iP(hone|od|ad)/.test(navigator.userAgent)) return _isIOSResult = true;
  const mtp = navigator.maxTouchPoints;
  return _isIOSResult = navigator.platform === "MacIntel" && mtp !== void 0 && mtp > 0;
};
const getRect = (element) => {
  const { offsetWidth, offsetHeight } = element;
  return { width: offsetWidth, height: offsetHeight };
};
const defaultKeyExtractor = (index2) => index2;
const defaultRangeExtractor = (range) => {
  const start2 = Math.max(range.startIndex - range.overscan, 0);
  const end2 = Math.min(range.endIndex + range.overscan, range.count - 1);
  const len = end2 - start2 + 1;
  const arr = new Array(len);
  for (let i = 0; i < len; i++) {
    arr[i] = start2 + i;
  }
  return arr;
};
const observeElementRect = (instance, cb2) => {
  const element = instance.scrollElement;
  if (!element) {
    return;
  }
  const targetWindow = instance.targetWindow;
  if (!targetWindow) {
    return;
  }
  const handler = (rect) => {
    const { width: width2, height: height2 } = rect;
    cb2({ width: Math.round(width2), height: Math.round(height2) });
  };
  handler(getRect(element));
  if (!targetWindow.ResizeObserver) {
    return () => {
    };
  }
  const observer = new targetWindow.ResizeObserver((entries2) => {
    const run = () => {
      const entry = entries2[0];
      if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
          handler({ width: box.inlineSize, height: box.blockSize });
          return;
        }
      }
      handler(getRect(element));
    };
    instance.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
  });
  observer.observe(element, { box: "border-box" });
  return () => {
    observer.unobserve(element);
  };
};
const addEventListenerOptions = {
  passive: true
};
const supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const observeOffset = (instance, cb2, readOffset) => {
  const element = instance.scrollElement;
  if (!element) {
    return;
  }
  const targetWindow = instance.targetWindow;
  if (!targetWindow) {
    return;
  }
  const registerScrollendEvent = instance.options.useScrollendEvent && supportsScrollend;
  let offset2 = 0;
  const fallback = registerScrollendEvent ? null : debounce(
    targetWindow,
    () => cb2(readOffset(element), false),
    instance.options.isScrollingResetDelay
  );
  const createHandler = (isScrolling) => () => {
    offset2 = readOffset(element);
    fallback == null ? void 0 : fallback();
    cb2(offset2, isScrolling);
  };
  const handler = createHandler(true);
  const endHandler = createHandler(false);
  element.addEventListener("scroll", handler, addEventListenerOptions);
  if (registerScrollendEvent) {
    element.addEventListener("scrollend", endHandler, addEventListenerOptions);
  }
  return () => {
    element.removeEventListener("scroll", handler);
    if (registerScrollendEvent) {
      element.removeEventListener("scrollend", endHandler);
    }
    fallback == null ? void 0 : fallback.cancel();
  };
};
const observeElementOffset = (instance, cb2) => observeOffset(instance, cb2, (el) => {
  const { horizontal, isRtl } = instance.options;
  return horizontal ? el.scrollLeft * (isRtl && -1 || 1) : el.scrollTop;
});
const measureElement = (element, entry, instance) => {
  if (instance.options.useCachedMeasurements) {
    const index2 = instance.indexFromElement(element);
    const key = instance.options.getItemKey(index2);
    return instance.itemSizeCache.get(key) ?? instance.options.estimateSize(index2);
  }
  if (entry == null ? void 0 : entry.borderBoxSize) {
    const box = entry.borderBoxSize[0];
    if (box) {
      const size = Math.round(
        box[instance.options.horizontal ? "inlineSize" : "blockSize"]
      );
      return size;
    }
  }
  if (!entry) {
    const index2 = instance.indexFromElement(element);
    const key = instance.options.getItemKey(index2);
    const cachedSize = instance.itemSizeCache.get(key);
    if (cachedSize !== void 0) {
      return cachedSize;
    }
  }
  return element[instance.options.horizontal ? "offsetWidth" : "offsetHeight"];
};
const scrollWithAdjustments = (offset2, {
  adjustments = 0,
  behavior
}, instance) => {
  var _a2, _b2;
  (_b2 = (_a2 = instance.scrollElement) == null ? void 0 : _a2.scrollTo) == null ? void 0 : _b2.call(_a2, {
    [instance.options.horizontal ? "left" : "top"]: offset2 + adjustments,
    behavior
  });
};
const elementScroll = scrollWithAdjustments;
function isAppendWithTrim(prevCount, nextCount, getPreviousKey, getNextKey) {
  if (nextCount === 0) return false;
  const firstKey = getNextKey(0);
  const removedKeys = /* @__PURE__ */ new Set();
  let removedCount = 0;
  while (removedCount < prevCount) {
    const key = getPreviousKey(removedCount);
    if (key === firstKey) break;
    removedKeys.add(key);
    removedCount++;
  }
  const retainedCount = prevCount - removedCount;
  if (retainedCount === 0 || retainedCount >= nextCount) return false;
  for (let i = 0; i < retainedCount; i++) {
    if (getNextKey(i) !== getPreviousKey(removedCount + i)) return false;
  }
  for (let i = retainedCount; i < nextCount; i++) {
    if (removedKeys.has(getNextKey(i))) return false;
  }
  return true;
}
class Virtualizer {
  constructor(opts) {
    this.unsubs = [];
    this.scrollElement = null;
    this.targetWindow = null;
    this.isScrolling = false;
    this.scrollState = null;
    this.measurementsCache = [];
    this._singleLaneMeasurements = null;
    this.itemSizeCache = /* @__PURE__ */ new Map();
    this.itemSizeCacheVersion = 0;
    this.laneAssignments = /* @__PURE__ */ new Map();
    this.pendingMin = null;
    this.prevLanes = void 0;
    this.lanesChangedFlag = false;
    this.lanesSettling = false;
    this.pendingScrollAnchor = null;
    this.scrollRect = null;
    this.scrollOffset = null;
    this.scrollDirection = null;
    this.scrollAdjustments = 0;
    this._iosDeferredAdjustment = 0;
    this._iosTouching = false;
    this._iosJustTouchEnded = false;
    this._iosTouchEndTimerId = null;
    this._intendedScrollOffset = null;
    this._clampedAdjustment = null;
    this.elementsCache = /* @__PURE__ */ new Map();
    this.now = () => {
      var _a2, _b2, _c2;
      return ((_c2 = (_b2 = (_a2 = this.targetWindow) == null ? void 0 : _a2.performance) == null ? void 0 : _b2.now) == null ? void 0 : _c2.call(_b2)) ?? Date.now();
    };
    this.observer = /* @__PURE__ */ (() => {
      let _ro = null;
      const get2 = () => {
        if (_ro) {
          return _ro;
        }
        if (!this.targetWindow || !this.targetWindow.ResizeObserver) {
          return null;
        }
        return _ro = new this.targetWindow.ResizeObserver((entries2) => {
          entries2.forEach((entry) => {
            const run = () => {
              const node2 = entry.target;
              const index2 = this.indexFromElement(node2);
              if (!node2.isConnected) {
                this.observer.unobserve(node2);
                for (const [cacheKey, cachedNode] of this.elementsCache) {
                  if (cachedNode === node2) {
                    this.elementsCache.delete(cacheKey);
                    break;
                  }
                }
                return;
              }
              if (!this.isIndexInRange(index2)) return;
              if (this.shouldMeasureDuringScroll(index2)) {
                this.resizeItem(
                  index2,
                  this.options.measureElement(node2, entry, this)
                );
              }
            };
            this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
          });
        });
      };
      return {
        disconnect: () => {
          var _a2;
          (_a2 = get2()) == null ? void 0 : _a2.disconnect();
          _ro = null;
        },
        observe: (target) => {
          var _a2;
          return (_a2 = get2()) == null ? void 0 : _a2.observe(target, { box: "border-box" });
        },
        unobserve: (target) => {
          var _a2;
          return (_a2 = get2()) == null ? void 0 : _a2.unobserve(target);
        }
      };
    })();
    this.range = null;
    this.setOptions = (opts2) => {
      var _a2;
      const merged = {
        debug: false,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: false,
        getItemKey: defaultKeyExtractor,
        rangeExtractor: defaultRangeExtractor,
        onChange: () => {
        },
        measureElement,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        anchorTo: "start",
        followOnAppend: false,
        scrollEndThreshold: 1,
        isScrollingResetDelay: 150,
        enabled: true,
        isRtl: false,
        useScrollendEvent: false,
        useAnimationFrameWithResizeObserver: false,
        laneAssignmentMode: "estimate",
        useCachedMeasurements: false
      };
      for (const key in opts2) {
        const v = opts2[key];
        if (v !== void 0) merged[key] = v;
      }
      const prevOptions = this.options;
      let anchor = null;
      let followOnAppend = null;
      let edgeKeysChanged = false;
      if (prevOptions !== void 0 && prevOptions.enabled && merged.enabled && merged.anchorTo === "end" && this.scrollElement !== null) {
        const prevCount = prevOptions.count;
        const nextCount = merged.count;
        const measurements = this.getMeasurements();
        const previousItems = ((_a2 = this._singleLaneMeasurements) == null ? void 0 : _a2.items) ?? measurements;
        const getPreviousKey = (index2) => getMeasurementKey(previousItems[index2]);
        const prevFirstKey = prevCount > 0 ? getPreviousKey(0) : null;
        const prevLastKey = prevCount > 0 ? getPreviousKey(prevCount - 1) : null;
        const didCountChange = nextCount !== prevCount;
        const didEdgeKeysChange = didCountChange || prevCount > 0 && nextCount > 0 && (merged.getItemKey(0) !== prevFirstKey || merged.getItemKey(nextCount - 1) !== prevLastKey);
        if (didEdgeKeysChange) {
          edgeKeysChanged = true;
          const item = prevCount > 0 ? this.getVirtualItemForOffset(this.getScrollOffset()) ?? measurements[0] : null;
          if (item) {
            anchor = [item.key, this.getScrollOffset() - item.start];
          }
          const behavior = merged.followOnAppend === true ? "auto" : merged.followOnAppend || null;
          if (behavior && nextCount > 0 && this.isAtEnd(prevOptions.scrollEndThreshold) && (prevCount === 0 || merged.getItemKey(nextCount - 1) !== prevLastKey)) {
            if (nextCount > prevCount || isAppendWithTrim(
              prevCount,
              nextCount,
              getPreviousKey,
              merged.getItemKey
            )) {
              followOnAppend = behavior;
            }
          }
        }
      }
      this.options = merged;
      if (edgeKeysChanged) {
        this.pendingMin = 0;
        this.itemSizeCacheVersion++;
      }
      let anchorResolved = false;
      let anchorDelta = 0;
      if (anchor && this.scrollOffset !== null) {
        const [anchorKey, anchorOffset] = anchor;
        const newMeasurements = this.getMeasurements();
        const { count: count2, getItemKey } = this.options;
        let idx = 0;
        while (idx < count2 && getItemKey(idx) !== anchorKey) {
          idx++;
        }
        if (idx < count2) {
          const anchorItem = newMeasurements[idx];
          if (anchorItem) {
            const newOffset = Math.max(0, anchorItem.start + anchorOffset);
            if (!followOnAppend && newOffset !== this.scrollOffset) {
              anchorDelta = newOffset - this.scrollOffset;
              this.scrollOffset = newOffset;
              anchorResolved = true;
            }
          }
        }
      }
      if (anchorResolved || followOnAppend) {
        this.pendingScrollAnchor = [
          anchorResolved ? anchor[0] : null,
          anchorResolved ? anchor[1] : 0,
          followOnAppend,
          anchorDelta
        ];
      }
    };
    this.notify = (sync) => {
      var _a2, _b2;
      (_b2 = (_a2 = this.options).onChange) == null ? void 0 : _b2.call(_a2, this, sync);
    };
    this.maybeNotify = memo(
      () => {
        this.calculateRange();
        return [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ];
      },
      (isScrolling) => {
        this.notify(isScrolling);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    );
    this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((d) => d());
      this.unsubs = [];
      this.observer.disconnect();
      if (this.rafId != null && this.targetWindow) {
        this.targetWindow.cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
      this.scrollState = null;
      this.isScrolling = false;
      this.scrollDirection = null;
      this._iosDeferredAdjustment = 0;
      this._iosTouching = false;
      this._iosJustTouchEnded = false;
      this._clampedAdjustment = null;
      this.scrollElement = null;
      this.targetWindow = null;
    };
    this._didMount = () => {
      return () => {
        this.cleanup();
      };
    };
    this._willUpdate = () => {
      var _a2, _b2;
      const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== scrollElement) {
        this.cleanup();
        if (!scrollElement) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = scrollElement;
        if (this.scrollElement && "ownerDocument" in this.scrollElement) {
          this.targetWindow = this.scrollElement.ownerDocument.defaultView;
        } else {
          this.targetWindow = ((_a2 = this.scrollElement) == null ? void 0 : _a2.window) ?? null;
        }
        this.elementsCache.forEach((cached2) => {
          this.observer.observe(cached2);
        });
        this.unsubs.push(
          this.options.observeElementRect(this, (rect) => {
            this.scrollRect = rect;
            this.maybeNotify();
          })
        );
        this.unsubs.push(
          this.options.observeElementOffset(this, (offset2, isScrolling) => {
            if (isScrolling && this._intendedScrollOffset === null && offset2 === this.scrollOffset) {
              return;
            }
            if (this._intendedScrollOffset !== null && Math.abs(offset2 - this._intendedScrollOffset) < 1.5) {
              offset2 = this._intendedScrollOffset;
            }
            this._intendedScrollOffset = null;
            if (this._clampedAdjustment !== null && Math.abs(offset2 - this._clampedAdjustment.maxAtWrite) >= 1.5) {
              this._clampedAdjustment = null;
            }
            this.scrollAdjustments = 0;
            const prevOffset = this.getScrollOffset();
            this.scrollDirection = isScrolling ? prevOffset === offset2 ? this.scrollDirection : prevOffset < offset2 ? "forward" : "backward" : null;
            this.scrollOffset = offset2;
            this.isScrolling = isScrolling;
            this._flushIosDeferredIfReady();
            if (this.scrollState) {
              this.scheduleScrollReconcile();
            }
            this.maybeNotify();
          })
        );
        if ("addEventListener" in this.scrollElement) {
          const scrollEl = this.scrollElement;
          const onTouchStart = () => {
            this._iosTouching = true;
            this._iosJustTouchEnded = false;
            if (this._iosTouchEndTimerId !== null && this.targetWindow != null) {
              this.targetWindow.clearTimeout(this._iosTouchEndTimerId);
              this._iosTouchEndTimerId = null;
            }
          };
          const onTouchEnd = () => {
            this._iosTouching = false;
            if (!isIOSWebKit() || this.targetWindow == null) {
              return;
            }
            this._iosJustTouchEnded = true;
            this._iosTouchEndTimerId = this.targetWindow.setTimeout(() => {
              this._iosJustTouchEnded = false;
              this._iosTouchEndTimerId = null;
              this._flushIosDeferredIfReady();
            }, 150);
          };
          scrollEl.addEventListener(
            "touchstart",
            onTouchStart,
            addEventListenerOptions
          );
          scrollEl.addEventListener(
            "touchend",
            onTouchEnd,
            addEventListenerOptions
          );
          this.unsubs.push(() => {
            scrollEl.removeEventListener("touchstart", onTouchStart);
            scrollEl.removeEventListener("touchend", onTouchEnd);
            if (this._iosTouchEndTimerId !== null && this.targetWindow != null) {
              this.targetWindow.clearTimeout(this._iosTouchEndTimerId);
              this._iosTouchEndTimerId = null;
            }
          });
        }
        this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
      }
      const anchor = this.pendingScrollAnchor;
      this.pendingScrollAnchor = null;
      if (anchor && this.scrollElement && this.options.enabled) {
        const [key, _offset, followOnAppend, anchorDelta] = anchor;
        if (key !== null && !followOnAppend) {
          if (isIOSWebKit() && (this.isScrolling || this._iosTouching || this._iosJustTouchEnded)) {
            if (anchorDelta !== 0) {
              this._iosDeferredAdjustment += anchorDelta;
            }
          } else if (((_b2 = this.scrollState) == null ? void 0 : _b2.behavior) === "smooth" && !approxEqual(
            this.getScrollOffset() - anchorDelta,
            this.scrollState.lastTargetOffset
          )) ;
          else {
            this._scrollToOffset(this.getScrollOffset(), {
              adjustments: void 0,
              behavior: void 0
            });
          }
        }
        if (followOnAppend) {
          this.scrollToEnd({ behavior: followOnAppend });
        }
      }
      this._retryClampedAdjustment();
    };
    this._retryClampedAdjustment = () => {
      if (this._clampedAdjustment === null || !this.scrollElement || !this.options.enabled) {
        return;
      }
      const { target, maxAtWrite } = this._clampedAdjustment;
      const max2 = this.getMaxScrollOffset();
      if (max2 > maxAtWrite + 0.5) {
        this._clampedAdjustment = target > max2 + 0.5 ? { target, maxAtWrite: max2 } : null;
        this._scrollToOffset(target, {
          adjustments: void 0,
          behavior: void 0
        });
      }
    };
    this._flushIosDeferredIfReady = () => {
      if (this._iosDeferredAdjustment === 0) return;
      if (this.isScrolling) return;
      if (this._iosTouching) return;
      if (this._iosJustTouchEnded) return;
      const cur = this.getScrollOffset();
      const max2 = this.getMaxScrollOffset();
      if (cur < 0 || cur > max2) return;
      if (this._iosDeferredAdjustment < 0 && cur >= max2 - 1) {
        this._iosDeferredAdjustment = 0;
        return;
      }
      const delta = this._iosDeferredAdjustment;
      this._iosDeferredAdjustment = 0;
      this._scrollToOffset(cur, {
        adjustments: this.scrollAdjustments += delta,
        behavior: void 0
      });
    };
    this.rafId = null;
    this.getSize = () => {
      if (!this.options.enabled) {
        this.scrollRect = null;
        return 0;
      }
      this.scrollRect = this.scrollRect ?? this.options.initialRect;
      return this.scrollRect[this.options.horizontal ? "width" : "height"];
    };
    this.getScrollOffset = () => {
      if (!this.options.enabled) {
        this.scrollOffset = null;
        return 0;
      }
      this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
      return this.scrollOffset;
    };
    this.getMeasurementOptions = memo(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled,
        this.options.lanes,
        this.options.laneAssignmentMode,
        this.options.gap
      ],
      (count2, paddingStart, scrollMargin, getItemKey, enabled, lanes, laneAssignmentMode, gap2) => {
        const lanesChanged = this.prevLanes !== void 0 && this.prevLanes !== lanes;
        if (lanesChanged) {
          this.lanesChangedFlag = true;
        }
        this.prevLanes = lanes;
        this.pendingMin = null;
        return {
          count: count2,
          paddingStart,
          scrollMargin,
          getItemKey,
          enabled,
          lanes,
          laneAssignmentMode,
          gap: gap2
        };
      },
      {
        key: false
      }
    );
    this.isIndexInRange = (index2) => index2 >= 0 && index2 < this.options.count;
    this.getMeasurements = memo(
      () => [this.getMeasurementOptions(), this.itemSizeCacheVersion],
      ({
        count: count2,
        paddingStart,
        scrollMargin,
        getItemKey,
        enabled,
        lanes,
        laneAssignmentMode,
        gap: gap2
      }, _itemSizeCacheVersion) => {
        var _a2;
        const itemSizeCache = this.itemSizeCache;
        if (!enabled) {
          this.measurementsCache = [];
          this._singleLaneMeasurements = null;
          this.itemSizeCache.clear();
          this.laneAssignments.clear();
          return [];
        }
        if (this.laneAssignments.size > count2) {
          for (const index2 of this.laneAssignments.keys()) {
            if (index2 >= count2) {
              this.laneAssignments.delete(index2);
            }
          }
        }
        if (this.lanesChangedFlag) {
          this.lanesChangedFlag = false;
          this.lanesSettling = true;
          this.measurementsCache = [];
          this._singleLaneMeasurements = null;
          this.itemSizeCache.clear();
          this.laneAssignments.clear();
          this.pendingMin = null;
        }
        if (this.measurementsCache.length === 0 && !this.lanesSettling) {
          this.measurementsCache = this.options.initialMeasurementsCache;
          this.measurementsCache.forEach((item) => {
            this.itemSizeCache.set(item.key, item.size);
          });
        }
        const min2 = this.lanesSettling ? 0 : this.pendingMin ?? 0;
        this.pendingMin = null;
        if (this.lanesSettling && this.measurementsCache.length === count2) {
          this.lanesSettling = false;
        }
        if (lanes === 1) {
          const need = count2 * 2;
          let flat = (_a2 = this._singleLaneMeasurements) == null ? void 0 : _a2.flat;
          if (!flat || flat.length < need) {
            const next2 = new Float64Array(need);
            if (flat && min2 > 0) next2.set(flat.subarray(0, min2 * 2));
            flat = next2;
          }
          const items = min2 === 0 ? new Array(count2) : this._singleLaneMeasurements.items.slice();
          let runningStart;
          if (min2 === 0) {
            runningStart = paddingStart + scrollMargin;
          } else {
            const prevIdx = min2 - 1;
            runningStart = flat[prevIdx * 2] + flat[prevIdx * 2 + 1] + gap2;
          }
          for (let i = min2; i < count2; i++) {
            const key = getItemKey(i);
            items[i] = key;
            const measuredSize = itemSizeCache.get(key);
            const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
            flat[i * 2] = runningStart;
            flat[i * 2 + 1] = size;
            runningStart += size + gap2;
          }
          this._singleLaneMeasurements = { flat, items };
          const view = createLazyMeasurementsView(items, flat);
          this.measurementsCache = view;
          return view;
        }
        const measurements = this.measurementsCache.slice(0, min2);
        const laneLastIndex = new Array(lanes).fill(
          void 0
        );
        const laneEnds = new Float64Array(lanes);
        let filledLanes = 0;
        for (let m = 0; m < min2; m++) {
          const item = measurements[m];
          if (item) {
            if (laneLastIndex[item.lane] === void 0) filledLanes++;
            laneLastIndex[item.lane] = m;
            laneEnds[item.lane] = item.end;
          }
        }
        for (let i = min2; i < count2; i++) {
          const key = getItemKey(i);
          const cachedLane = this.laneAssignments.get(i);
          let lane;
          let start2;
          const shouldCacheLane = laneAssignmentMode === "estimate" || itemSizeCache.has(key);
          if (cachedLane !== void 0 && this.options.lanes > 1) {
            lane = cachedLane;
            const prevIndex = laneLastIndex[lane];
            const prevInLane = prevIndex !== void 0 ? measurements[prevIndex] : void 0;
            start2 = prevInLane ? prevInLane.end + gap2 : paddingStart + scrollMargin;
          } else if (filledLanes === lanes) {
            let bestLane = 0;
            let bestEnd = laneEnds[0];
            let bestIdx = laneLastIndex[0];
            for (let l2 = 1; l2 < lanes; l2++) {
              const e = laneEnds[l2];
              if (e < bestEnd || e === bestEnd && laneLastIndex[l2] < bestIdx) {
                bestLane = l2;
                bestEnd = e;
                bestIdx = laneLastIndex[l2];
              }
            }
            lane = bestLane;
            start2 = bestEnd + gap2;
            if (shouldCacheLane) {
              this.laneAssignments.set(i, lane);
            }
          } else {
            lane = i % this.options.lanes;
            start2 = paddingStart + scrollMargin;
            if (shouldCacheLane) {
              this.laneAssignments.set(i, lane);
            }
          }
          const measuredSize = itemSizeCache.get(key);
          const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
          const end2 = start2 + size;
          measurements[i] = {
            index: i,
            start: start2,
            size,
            end: end2,
            key,
            lane
          };
          if (laneLastIndex[lane] === void 0) filledLanes++;
          laneLastIndex[lane] = i;
          laneEnds[lane] = end2;
        }
        this.measurementsCache = measurements;
        return measurements;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    );
    this.calculateRange = memo(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (measurements, outerSize, scrollOffset, lanes) => {
        if (measurements.length === 0 || outerSize === 0) {
          this.range = null;
          return null;
        }
        this.range = calculateRangeImpl(
          measurements,
          outerSize,
          scrollOffset,
          lanes,
          // Pass the typed array so binary search + forward-walk can read
          // start/end directly from Float64Array, skipping the Proxy traps.
          lanes === 1 && this._singleLaneMeasurements !== null ? this._singleLaneMeasurements.flat : null
        );
        return this.range;
      },
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    );
    this.getVirtualIndexes = memo(
      () => {
        let startIndex = null;
        let endIndex = null;
        const range = this.calculateRange();
        if (range) {
          startIndex = range.startIndex;
          endIndex = range.endIndex;
        }
        this.maybeNotify.updateDeps([this.isScrolling, startIndex, endIndex]);
        return [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          startIndex,
          endIndex
        ];
      },
      (rangeExtractor, overscan, count2, startIndex, endIndex) => {
        return startIndex === null || endIndex === null ? [] : rangeExtractor({
          startIndex,
          endIndex,
          overscan,
          count: count2
        });
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    );
    this.indexFromElement = (node2) => {
      const attributeName = this.options.indexAttribute;
      const indexStr = node2.getAttribute(attributeName);
      if (!indexStr) {
        console.warn(
          `Missing attribute name '${attributeName}={index}' on measured element.`
        );
        return -1;
      }
      return parseInt(indexStr, 10);
    };
    this.shouldMeasureDuringScroll = (index2) => {
      var _a2;
      if (!this.scrollState || this.scrollState.behavior !== "smooth") {
        return true;
      }
      const scrollIndex = this.scrollState.index ?? ((_a2 = this.getVirtualItemForOffset(this.scrollState.lastTargetOffset)) == null ? void 0 : _a2.index);
      if (scrollIndex !== void 0 && this.range) {
        const bufferSize = Math.max(
          this.options.overscan,
          Math.ceil((this.range.endIndex - this.range.startIndex) / 2)
        );
        const minIndex = Math.max(0, scrollIndex - bufferSize);
        const maxIndex = Math.min(
          this.options.count - 1,
          scrollIndex + bufferSize
        );
        return index2 >= minIndex && index2 <= maxIndex;
      }
      return true;
    };
    this.measureElement = (node2) => {
      if (!node2) {
        this.elementsCache.forEach((cached2, key2) => {
          if (!cached2.isConnected) {
            this.observer.unobserve(cached2);
            this.elementsCache.delete(key2);
          }
        });
        return;
      }
      const index2 = this.indexFromElement(node2);
      if (!this.isIndexInRange(index2)) return;
      const key = this.options.getItemKey(index2);
      const prevNode = this.elementsCache.get(key);
      if (prevNode !== node2) {
        if (prevNode) {
          this.observer.unobserve(prevNode);
        }
        this.observer.observe(node2);
        this.elementsCache.set(key, node2);
      }
      if ((!this.isScrolling || this.scrollState) && this.shouldMeasureDuringScroll(index2)) {
        this.resizeItem(index2, this.options.measureElement(node2, void 0, this));
      }
    };
    this.resizeItem = (index2, size) => {
      var _a2, _b2, _c2;
      if (!this.isIndexInRange(index2)) return;
      let cachedSize;
      let itemStart;
      let key;
      const flat = (_a2 = this._singleLaneMeasurements) == null ? void 0 : _a2.flat;
      if (this.options.lanes === 1 && flat != null) {
        key = this.options.getItemKey(index2);
        itemStart = flat[index2 * 2];
        cachedSize = flat[index2 * 2 + 1];
      } else {
        const item = this.measurementsCache[index2];
        if (!item) return;
        key = item.key;
        itemStart = item.start;
        cachedSize = item.size;
      }
      const itemSize = this.itemSizeCache.get(key) ?? cachedSize;
      const delta = size - itemSize;
      if (delta !== 0) {
        const wasAtEnd = this.options.anchorTo === "end" && ((_b2 = this.scrollState) == null ? void 0 : _b2.behavior) !== "smooth" && this.getVirtualDistanceFromEnd() <= this.options.scrollEndThreshold;
        const prevTotalSize = wasAtEnd ? this.getTotalSize() : 0;
        const scrollOffsetWithAdj = this.getScrollOffset() + this.scrollAdjustments;
        const isFirstMeasure = !this.itemSizeCache.has(key);
        const defaultShouldAdjust = isFirstMeasure ? (
          // First measurement: compensate any item whose top sits above the
          // fold — the estimate→actual delta must be corrected regardless of
          // scroll direction, since the whole estimated block was above it.
          itemStart < scrollOffsetWithAdj
        ) : (
          // Re-measurement: only compensate an item that is ENTIRELY above the
          // fold. An item that merely *spans* the fold (top above, bottom
          // below — e.g. a streaming chat message growing at its bottom)
          // changes size *below* the anchor point, so shifting scrollTop by the
          // delta would drag the viewport downward on every growth (#1218).
          // Also skip during backward scroll to avoid the "items jump while
          // scrolling up" cascade.
          itemStart + itemSize <= scrollOffsetWithAdj && this.scrollDirection !== "backward"
        );
        const shouldAdjustScroll = ((_c2 = this.scrollState) == null ? void 0 : _c2.behavior) !== "smooth" && (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(
          // The callback expects a VirtualItem; build one lazily only
          // when the consumer actually supplied a custom predicate.
          this.measurementsCache[index2] ?? {
            index: index2,
            key,
            start: itemStart,
            size: cachedSize,
            end: itemStart + cachedSize,
            lane: 0
          },
          delta,
          this
        ) : defaultShouldAdjust);
        if (this.pendingMin === null || index2 < this.pendingMin) {
          this.pendingMin = index2;
        }
        this.itemSizeCache.set(key, size);
        this.itemSizeCacheVersion++;
        let adjustedSync = false;
        if (wasAtEnd) {
          adjustedSync = this.applyScrollAdjustment(
            this.getTotalSize() - prevTotalSize
          );
        } else if (shouldAdjustScroll) {
          adjustedSync = this.applyScrollAdjustment(delta);
        }
        this.notify(adjustedSync);
        this._retryClampedAdjustment();
      }
    };
    this.getVirtualItems = memo(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (indexes, measurements) => {
        const virtualItems = [];
        for (let k = 0, len = indexes.length; k < len; k++) {
          const i = indexes[k];
          const measurement = measurements[i];
          virtualItems.push(measurement);
        }
        return virtualItems;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    );
    this.getVirtualItemForOffset = (offset2) => {
      var _a2;
      const measurements = this.getMeasurements();
      if (measurements.length === 0) {
        return void 0;
      }
      const flat = (_a2 = this._singleLaneMeasurements) == null ? void 0 : _a2.flat;
      const useFlat = this.options.lanes === 1 && flat != null;
      const idx = findNearestBinarySearch(
        0,
        measurements.length - 1,
        useFlat ? (i) => flat[i * 2] : (i) => notUndefined(measurements[i]).start,
        offset2
      );
      return notUndefined(measurements[idx]);
    };
    this.getMaxScrollOffset = () => {
      if (!this.scrollElement) return 0;
      if ("scrollHeight" in this.scrollElement) {
        return this.options.horizontal ? this.scrollElement.scrollWidth - this.scrollElement.clientWidth : this.scrollElement.scrollHeight - this.scrollElement.clientHeight;
      } else {
        const doc = this.scrollElement.document.documentElement;
        return this.options.horizontal ? doc.scrollWidth - this.scrollElement.innerWidth : doc.scrollHeight - this.scrollElement.innerHeight;
      }
    };
    this.getVirtualDistanceFromEnd = () => {
      return Math.max(
        this.getTotalSize() - this.getSize() - this.getScrollOffset(),
        0
      );
    };
    this.getDistanceFromEnd = () => {
      return Math.max(this.getMaxScrollOffset() - this.getScrollOffset(), 0);
    };
    this.isAtEnd = (threshold = this.options.scrollEndThreshold) => {
      return this.getDistanceFromEnd() <= threshold;
    };
    this.getOffsetForAlignment = (toOffset, align, itemSize = 0) => {
      if (!this.scrollElement) return 0;
      const size = this.getSize();
      const scrollOffset = this.getScrollOffset();
      if (align === "auto") {
        align = toOffset >= scrollOffset + size ? "end" : "start";
      }
      if (align === "center") {
        toOffset += (itemSize - size) / 2;
      } else if (align === "end") {
        toOffset -= size;
      }
      const maxOffset = this.getMaxScrollOffset();
      return Math.max(Math.min(maxOffset, toOffset), 0);
    };
    this.getOffsetForIndex = (index2, align = "auto") => {
      index2 = Math.max(0, Math.min(index2, this.options.count - 1));
      const size = this.getSize();
      const scrollOffset = this.getScrollOffset();
      const item = this.measurementsCache[index2];
      if (!item) return;
      if (align === "auto") {
        if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) {
          align = "end";
        } else if (item.start <= scrollOffset + this.options.scrollPaddingStart) {
          align = "start";
        } else {
          return [scrollOffset, align];
        }
      }
      if (align === "end" && index2 === this.options.count - 1) {
        return [this.getMaxScrollOffset(), align];
      }
      const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(toOffset, align, item.size),
        align
      ];
    };
    this.scrollToOffset = (toOffset, { align = "start", behavior = "auto" } = {}) => {
      this._iosDeferredAdjustment = 0;
      const offset2 = this.getOffsetForAlignment(toOffset, align);
      const now2 = this.now();
      this.scrollState = {
        index: null,
        align,
        behavior,
        startedAt: now2,
        lastTargetOffset: offset2,
        stableFrames: 0
      };
      this._scrollToOffset(offset2, { adjustments: void 0, behavior });
      this.scheduleScrollReconcile();
    };
    this.scrollToIndex = (index2, {
      align: initialAlign = "auto",
      behavior = "auto"
    } = {}) => {
      this._iosDeferredAdjustment = 0;
      index2 = Math.max(0, Math.min(index2, this.options.count - 1));
      const offsetInfo = this.getOffsetForIndex(index2, initialAlign);
      if (!offsetInfo) {
        return;
      }
      const [offset2, align] = offsetInfo;
      const now2 = this.now();
      this.scrollState = {
        index: index2,
        align,
        behavior,
        startedAt: now2,
        lastTargetOffset: offset2,
        stableFrames: 0
      };
      this._scrollToOffset(offset2, { adjustments: void 0, behavior });
      this.scheduleScrollReconcile();
    };
    this.scrollBy = (delta, { behavior = "auto" } = {}) => {
      const offset2 = this.getScrollOffset() + delta;
      const now2 = this.now();
      this.scrollState = {
        index: null,
        align: "start",
        behavior,
        startedAt: now2,
        lastTargetOffset: offset2,
        stableFrames: 0
      };
      this._scrollToOffset(offset2, { adjustments: void 0, behavior });
      this.scheduleScrollReconcile();
    };
    this.scrollToEnd = ({ behavior = "auto" } = {}) => {
      if (this.options.count > 0) {
        this.scrollToIndex(this.options.count - 1, {
          align: "end",
          behavior
        });
        return;
      }
      this.scrollToOffset(Math.max(this.getTotalSize() - this.getSize(), 0), {
        behavior
      });
    };
    this.getTotalSize = () => {
      var _a2, _b2;
      const measurements = this.getMeasurements();
      let end2;
      if (measurements.length === 0) {
        end2 = this.options.paddingStart;
      } else if (this.options.lanes === 1) {
        const lastIdx = measurements.length - 1;
        const flat = (_a2 = this._singleLaneMeasurements) == null ? void 0 : _a2.flat;
        if (flat != null) {
          end2 = flat[lastIdx * 2] + flat[lastIdx * 2 + 1];
        } else {
          end2 = ((_b2 = measurements[lastIdx]) == null ? void 0 : _b2.end) ?? 0;
        }
      } else {
        const endByLane = Array(this.options.lanes).fill(null);
        let endIndex = measurements.length - 1;
        while (endIndex >= 0 && endByLane.some((val) => val === null)) {
          const item = measurements[endIndex];
          if (endByLane[item.lane] === null) {
            endByLane[item.lane] = item.end;
          }
          endIndex--;
        }
        end2 = Math.max(...endByLane.filter((val) => val !== null));
      }
      return Math.max(
        end2 - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    };
    this.takeSnapshot = () => {
      const snapshot = [];
      if (this.itemSizeCache.size === 0) return snapshot;
      const m = this.getMeasurements();
      for (const item of m) {
        if (item && this.itemSizeCache.has(item.key)) {
          snapshot.push({
            index: item.index,
            key: item.key,
            start: item.start,
            size: item.size,
            end: item.end,
            lane: item.lane
          });
        }
      }
      return snapshot;
    };
    this._scrollToOffset = (offset2, {
      adjustments,
      behavior
    }) => {
      this._intendedScrollOffset = offset2 + (adjustments ?? 0);
      this.options.scrollToFn(offset2, { behavior, adjustments }, this);
    };
    this.measure = () => {
      this.pendingMin = null;
      this.itemSizeCache.clear();
      this.laneAssignments.clear();
      this.itemSizeCacheVersion++;
      this.notify(false);
    };
    this.setOptions(opts);
  }
  // Returns `true` when it performed a synchronous `scrollTop` write this
  // tick, `false` when the delta was zero or the write was deferred (iOS).
  // `resizeItem` uses that to decide whether the follow-up `notify` must be
  // synchronous so the grown transforms commit in the same paint (#1227).
  applyScrollAdjustment(delta, behavior) {
    if (delta === 0) return false;
    if (process.env.NODE_ENV !== "production" && this.options.debug) {
      console.info("correction", delta);
    }
    if (isIOSWebKit() && (this.isScrolling || this._iosTouching || this._iosJustTouchEnded)) {
      this._iosDeferredAdjustment += delta;
      return false;
    } else {
      const target = this.getScrollOffset() + this.scrollAdjustments + delta;
      const el = this.scrollElement;
      const maxAtWrite = el !== null && ("scrollHeight" in el || "document" in el) ? this.getMaxScrollOffset() : null;
      this._clampedAdjustment = maxAtWrite !== null && target > maxAtWrite + 0.5 ? { target, maxAtWrite } : null;
      this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += delta,
        behavior
      });
      if (this.scrollOffset !== null) {
        this.scrollOffset += this.scrollAdjustments;
        if (this.scrollOffset < 0) this.scrollOffset = 0;
        this.scrollAdjustments = 0;
      }
      return true;
    }
  }
  scheduleScrollReconcile() {
    if (!this.targetWindow) {
      this.scrollState = null;
      return;
    }
    if (this.rafId != null) return;
    this.rafId = this.targetWindow.requestAnimationFrame(() => {
      this.rafId = null;
      this.reconcileScroll();
    });
  }
  reconcileScroll() {
    if (!this.scrollState) return;
    const el = this.scrollElement;
    if (!el) return;
    const MAX_RECONCILE_MS = 5e3;
    if (this.now() - this.scrollState.startedAt > MAX_RECONCILE_MS) {
      this.scrollState = null;
      return;
    }
    const offsetInfo = this.scrollState.index != null ? this.getOffsetForIndex(this.scrollState.index, this.scrollState.align) : void 0;
    const targetOffset = offsetInfo ? offsetInfo[0] : this.scrollState.lastTargetOffset;
    const STABLE_FRAMES = 1;
    const targetChanged = targetOffset !== this.scrollState.lastTargetOffset;
    if (!targetChanged && approxEqual(targetOffset, this.getScrollOffset())) {
      this.scrollState.stableFrames++;
      if (this.scrollState.stableFrames >= STABLE_FRAMES) {
        if (this.getScrollOffset() !== targetOffset) {
          this._scrollToOffset(targetOffset, {
            adjustments: void 0,
            behavior: "auto"
          });
        }
        this.scrollState = null;
        return;
      }
    } else {
      this.scrollState.stableFrames = 0;
      if (targetChanged) {
        const viewport2 = this.getSize() || 600;
        const distance = Math.abs(targetOffset - this.getScrollOffset());
        const keepSmooth = this.scrollState.behavior === "smooth" && distance > viewport2;
        this.scrollState.lastTargetOffset = targetOffset;
        if (!keepSmooth) {
          this.scrollState.behavior = "auto";
        }
        this._scrollToOffset(targetOffset, {
          adjustments: void 0,
          behavior: keepSmooth ? "smooth" : "auto"
        });
      }
    }
    this.scheduleScrollReconcile();
  }
}
const findNearestBinarySearch = (low, high, getCurrentValue, value) => {
  while (low <= high) {
    const middle = (low + high) / 2 | 0;
    const currentValue = getCurrentValue(middle);
    if (currentValue < value) {
      low = middle + 1;
    } else if (currentValue > value) {
      high = middle - 1;
    } else {
      return middle;
    }
  }
  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};
function findNearestBinarySearchFlat(flat, high, value) {
  let low = 0;
  while (low <= high) {
    const middle = (low + high) / 2 | 0;
    const currentValue = flat[middle * 2];
    if (currentValue < value) {
      low = middle + 1;
    } else if (currentValue > value) {
      high = middle - 1;
    } else {
      return middle;
    }
  }
  return low > 0 ? low - 1 : 0;
}
function calculateRangeImpl(measurements, outerSize, scrollOffset, lanes, flat) {
  const lastIndex = measurements.length - 1;
  if (measurements.length <= lanes) {
    return { startIndex: 0, endIndex: lastIndex };
  }
  if (lanes === 1 && flat !== null) {
    const startIndex2 = findNearestBinarySearchFlat(
      flat,
      lastIndex,
      scrollOffset
    );
    let endIndex2 = startIndex2;
    const limit = scrollOffset + outerSize;
    while (endIndex2 < lastIndex && flat[endIndex2 * 2] + flat[endIndex2 * 2 + 1] < limit) {
      endIndex2++;
    }
    return { startIndex: startIndex2, endIndex: endIndex2 };
  }
  const getStart = (index2) => measurements[index2].start;
  let startIndex = findNearestBinarySearch(0, lastIndex, getStart, scrollOffset);
  let endIndex = startIndex;
  if (lanes === 1) {
    while (endIndex < lastIndex && measurements[endIndex].end < scrollOffset + outerSize) {
      endIndex++;
    }
  } else if (lanes > 1) {
    const endPerLane = Array(lanes).fill(0);
    while (endIndex < lastIndex && endPerLane.some((pos) => pos < scrollOffset + outerSize)) {
      const item = measurements[endIndex];
      endPerLane[item.lane] = item.end;
      endIndex++;
    }
    const startPerLane = Array(lanes).fill(scrollOffset + outerSize);
    while (startIndex >= 0 && startPerLane.some((pos) => pos >= scrollOffset)) {
      const item = measurements[startIndex];
      startPerLane[item.lane] = item.start;
      startIndex--;
    }
    startIndex = Math.max(0, startIndex - startIndex % lanes);
    endIndex = Math.min(lastIndex, endIndex + (lanes - 1 - endIndex % lanes));
  }
  return { startIndex, endIndex };
}
const useIsomorphicLayoutEffect = typeof document !== "undefined" ? reactExports.useLayoutEffect : reactExports.useEffect;
function useVirtualizerBase({
  useFlushSync = true,
  directDomUpdates = false,
  directDomUpdatesMode = "transform",
  ...options
}) {
  const rerender2 = reactExports.useReducer((x) => x + 1, 0)[1];
  const directRef = reactExports.useRef({
    enabled: directDomUpdates,
    mode: directDomUpdatesMode,
    container: null,
    lastSize: null,
    // Keyed by the element itself so a remounted node (same key, new DOM
    // node — e.g. when `enabled` is toggled off then on) is treated as fresh
    // and gets its style written.
    lastPositions: /* @__PURE__ */ new WeakMap(),
    prevRange: null
  });
  directRef.current.enabled = directDomUpdates;
  directRef.current.mode = directDomUpdatesMode;
  const measuringFromRef = reactExports.useRef(false);
  const applyContainerSize = (instance2) => {
    const state = directRef.current;
    if (!state.enabled || !state.container) return;
    const totalSize = instance2.getTotalSize();
    if (totalSize !== state.lastSize) {
      state.lastSize = totalSize;
      const sizeAxis = instance2.options.horizontal ? "width" : "height";
      state.container.style[sizeAxis] = `${totalSize}px`;
    }
  };
  const applyDirectStyles = (instance2) => {
    const state = directRef.current;
    if (!state.enabled || !state.container) return;
    applyContainerSize(instance2);
    const horizontal = !!instance2.options.horizontal;
    const useTransform = state.mode === "transform";
    const posAxis = horizontal ? "left" : "top";
    const scrollMargin = instance2.options.scrollMargin;
    const items = instance2.getVirtualItems();
    for (const item of items) {
      const next2 = item.start - scrollMargin;
      const el = instance2.elementsCache.get(item.key);
      if (!el) continue;
      if (state.lastPositions.get(el) === next2) continue;
      state.lastPositions.set(el, next2);
      if (useTransform) {
        el.style.transform = horizontal ? `translate3d(${next2}px, 0, 0)` : `translate3d(0, ${next2}px, 0)`;
      } else {
        el.style[posAxis] = `${next2}px`;
      }
    }
  };
  const resolvedOptions = {
    ...options,
    onChange: (instance2, sync) => {
      var _a2;
      const state = directRef.current;
      let shouldRerender = true;
      if (state.enabled) {
        applyDirectStyles(instance2);
        const range = instance2.range;
        const prev2 = state.prevRange;
        shouldRerender = !prev2 || prev2.isScrolling !== instance2.isScrolling || prev2.startIndex !== (range == null ? void 0 : range.startIndex) || prev2.endIndex !== (range == null ? void 0 : range.endIndex);
        if (shouldRerender) {
          state.prevRange = range ? {
            startIndex: range.startIndex,
            endIndex: range.endIndex,
            isScrolling: instance2.isScrolling
          } : null;
        }
      }
      if (shouldRerender) {
        if (useFlushSync && sync && !measuringFromRef.current) {
          reactDomExports.flushSync(rerender2);
        } else {
          rerender2();
        }
      }
      (_a2 = options.onChange) == null ? void 0 : _a2.call(options, instance2, sync);
    }
  };
  const [instance] = reactExports.useState(() => {
    const v = new Virtualizer(resolvedOptions);
    const measureElement2 = v.measureElement;
    v.measureElement = (node2) => {
      measuringFromRef.current = true;
      try {
        measureElement2(node2);
      } finally {
        measuringFromRef.current = false;
      }
    };
    return Object.assign(v, {
      containerRef: (node2) => {
        const state = directRef.current;
        state.container = node2;
        state.lastSize = null;
        if (node2 && state.enabled) {
          const total = v.getTotalSize();
          state.lastSize = total;
          const axis = v.options.horizontal ? "width" : "height";
          node2.style[axis] = `${total}px`;
        }
      }
    });
  });
  instance.setOptions(resolvedOptions);
  useIsomorphicLayoutEffect(() => {
    return instance._didMount();
  }, []);
  useIsomorphicLayoutEffect(() => {
    applyContainerSize(instance);
    return instance._willUpdate();
  });
  useIsomorphicLayoutEffect(() => {
    applyDirectStyles(instance);
  });
  return instance;
}
function useVirtualizer(options) {
  return useVirtualizerBase({
    observeElementRect,
    observeElementOffset,
    scrollToFn: elementScroll,
    ...options
  });
}
const Context = /* @__PURE__ */ reactExports.createContext(null);
if (process.env.NODE_ENV !== "production") {
  Context.displayName = "TabContext";
}
function useUniquePrefix() {
  const [id, setId] = reactExports.useState(null);
  reactExports.useEffect(() => {
    setId(`mui-p-${Math.round(Math.random() * 1e5)}`);
  }, []);
  return id;
}
function TabContext$1(props) {
  const {
    children,
    value
  } = props;
  const idPrefix = useUniquePrefix();
  const context2 = reactExports.useMemo(() => {
    return {
      idPrefix,
      value
    };
  }, [idPrefix, value]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context.Provider, {
    value: context2,
    children
  });
}
process.env.NODE_ENV !== "production" ? TabContext$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * The value of the currently selected `Tab`.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
} : void 0;
function useTabContext() {
  return reactExports.useContext(Context);
}
function getPanelId(context2, value) {
  const {
    idPrefix
  } = context2;
  if (idPrefix === null) {
    return null;
  }
  return `${context2.idPrefix}-P-${value}`;
}
function getTabId(context2, value) {
  const {
    idPrefix
  } = context2;
  if (idPrefix === null) {
    return null;
  }
  return `${context2.idPrefix}-T-${value}`;
}
const TabList$1 = /* @__PURE__ */ reactExports.forwardRef(function TabList(props, ref2) {
  const {
    children: childrenProp,
    ...other
  } = props;
  const context2 = useTabContext();
  if (context2 === null) {
    throw new TypeError("No TabContext provided");
  }
  const children = reactExports.Children.map(childrenProp, (child) => {
    if (!/* @__PURE__ */ reactExports.isValidElement(child)) {
      return null;
    }
    return /* @__PURE__ */ reactExports.cloneElement(child, {
      // SOMEDAY: `Tabs` will set those themselves
      "aria-controls": getPanelId(context2, child.props.value),
      id: getTabId(context2, child.props.value)
    });
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Tabs, {
    ...other,
    ref: ref2,
    value: context2.value,
    children
  });
});
process.env.NODE_ENV !== "production" ? TabList$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A list of `<Tab />` elements.
   */
  children: PropTypes.node
} : void 0;
function flexRender(Comp, props) {
  return !Comp ? null : isReactComponent(Comp) ? /* @__PURE__ */ reactExports.createElement(Comp, props) : Comp;
}
function isReactComponent(component) {
  return isClassComponent$1(component) || typeof component === "function" || isExoticComponent(component);
}
function isClassComponent$1(component) {
  return typeof component === "function" && (() => {
    const proto = Object.getPrototypeOf(component);
    return proto.prototype && proto.prototype.isReactComponent;
  })();
}
function isExoticComponent(component) {
  return typeof component === "object" && typeof component.$$typeof === "symbol" && ["react.memo", "react.forward_ref"].includes(component.$$typeof.description);
}
const STATUS = [
  "preEnter",
  "entering",
  "entered",
  "preExit",
  "exiting",
  "exited",
  "unmounted"
];
const getState = (status) => ({
  $: status,
  status: STATUS[status],
  isEnter: status < 3,
  isMounted: status !== 6,
  isResolved: status === 2 || status > 4
});
const startOrEnd = (unmounted) => unmounted ? 6 : 5;
const getEndStatus = (status, unmountOnExit) => {
  switch (status) {
    case 1:
    case 0:
      return 2;
    case 4:
    case 3:
      return startOrEnd(unmountOnExit);
  }
};
const getTimeout$1 = (timeout2) => typeof timeout2 === "object" ? [timeout2.enter, timeout2.exit] : [timeout2, timeout2];
const nextTick$1 = (callback, config2) => {
  config2.r = requestAnimationFrame(() => {
    config2.r = requestAnimationFrame(callback);
  });
};
const updateState = (status, setState, ref2, onChange) => {
  clearTimeout(ref2.t);
  cancelAnimationFrame(ref2.r);
  const state = getState(status);
  setState(state);
  ref2.s = state;
  onChange?.({ current: state });
};
const useTransitionState$1 = ({ enter = true, exit = true, preEnter, preExit, timeout: timeout2, initialEntered, mountOnEnter, unmountOnExit, onStateChange: onChange } = {}) => {
  const [state, setState] = reactExports.useState(() => getState(initialEntered ? 2 : startOrEnd(mountOnEnter)));
  const [ref2] = reactExports.useState({
    s: state,
    r: 0
  });
  const [enterTimeout, exitTimeout] = getTimeout$1(timeout2);
  const endTransition = reactExports.useCallback(() => {
    const status = getEndStatus(ref2.s.$, unmountOnExit);
    if (status) updateState(status, setState, ref2, onChange);
  }, [
    onChange,
    unmountOnExit,
    ref2
  ]);
  return [
    state,
    reactExports.useCallback((toEnter) => {
      const transitState = (status) => {
        updateState(status, setState, ref2, onChange);
        switch (status) {
          case 1:
            if (enterTimeout >= 0) ref2.t = setTimeout(endTransition, enterTimeout);
            break;
          case 4:
            if (exitTimeout >= 0) ref2.t = setTimeout(endTransition, exitTimeout);
            break;
          case 0:
          case 3:
            nextTick$1(() => transitState(status + 1), ref2);
            break;
        }
      };
      const enterStage = ref2.s.isEnter;
      if (typeof toEnter !== "boolean") toEnter = !enterStage;
      if (toEnter) !enterStage && transitState(enter ? preEnter ? 0 : 1 : 2);
      else enterStage && transitState(exit ? preExit ? 3 : 4 : startOrEnd(unmountOnExit));
    }, [
      ref2,
      endTransition,
      onChange,
      enter,
      exit,
      preEnter,
      preExit,
      enterTimeout,
      exitTimeout,
      unmountOnExit
    ]),
    endTransition
  ];
};
makeStyles()((_defaultTheme, theme) => {
  return {
    menu: {
      "&:before": { display: "none" }
    },
    menuItem: {
      fontWeight: theme.typography.fontWeightMedium,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    menuItemUrl: {
      fontWeight: theme.typography.fontWeightMedium,
      overflow: "hidden",
      padding: "4px 0",
      textAlign: "left"
    },
    skeleton: {
      width: "100%",
      fontSize: theme.typography.h3.fontSize
    }
  };
});
const Badge = (props) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Chip, { ...props });
};
reactExports.memo(function BreadcrumbRenderer({
  breadcrumbs,
  onClick
}) {
  const theme = useTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Breadcrumbs,
    {
      "aria-label": "breadcrumb",
      separator: /* @__PURE__ */ jsxRuntimeExports.jsx(
        NavigateNext,
        {
          "aria-hidden": true,
          fontSize: "small",
          style: { color: theme.palette.grey[500] }
        }
      ),
      sx: { display: "flex", alignItems: "center" },
      children: breadcrumbs?.map((item, index2) => {
        const ariaCurrent = item.currentPage ? "page" : void 0;
        const color2 = item.link ? theme.palette.blue[800] : theme.palette.grey[700];
        const content = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          item.icon && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "span",
            {
              style: {
                alignItems: "center",
                display: "flex",
                height: "100%",
                paddingRight: item.name ? "8px" : "0px"
              },
              children: item.icon
            }
          ),
          item.name && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Typography$1,
            {
              "aria-current": ariaCurrent,
              style: {
                color: color2,
                fontWeight: theme.typography.fontWeightMedium
              },
              variant: "body2",
              children: item.name.charAt(0).toUpperCase() + item.name.slice(1)
            }
          )
        ] });
        if (!item.link) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            "span",
            {
              "aria-label": item.altText,
              style: { display: "flex" },
              children: content
            },
            index2
          );
        }
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link$1,
          {
            "aria-label": item.altText,
            color: color2,
            display: "flex",
            href: item.link,
            onClick: (event2) => onClick?.(event2, item),
            underline: "none",
            children: content
          },
          index2
        );
      })
    }
  );
});
const useButtonStyles = makeStyles()((_defaultTheme, theme) => {
  const iconSize = 40;
  return {
    iconOnlyRoot: {
      maxHeight: iconSize,
      maxWidth: iconSize,
      minHeight: iconSize,
      minWidth: iconSize,
      padding: 14
    },
    iconOnlyStartIcon: {
      margin: 0
    },
    condensed: {
      background: 0,
      margin: 0,
      minHeight: 0,
      minWidth: 0,
      padding: "8px 0",
      "&:hover, &:active": {
        background: 0
      }
    }
  };
});
const variantMap = {
  primary: "contained",
  secondary: "outlined",
  tertiary: "text",
  // Condensed is just a slight modification of the text
  condensed: "text"
};
const Button2 = reactExports.forwardRef(
  ({ classes, iconOnly, id, variant = "primary", ...props }, ref2) => {
    const theme = useTheme();
    const { classes: styles2 } = useButtonStyles(theme);
    const _variant = variantMap[variant] ?? variantMap.primary;
    const condensed = variant === "condensed";
    let rootClass = classes?.root;
    if (condensed) {
      rootClass = styles2.condensed + " " + rootClass;
    } else if (iconOnly) {
      rootClass = styles2.iconOnlyRoot + " " + rootClass;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        classes: {
          root: rootClass,
          startIcon: !condensed && iconOnly ? `${styles2.iconOnlyStartIcon} ${classes?.startIcon}` : classes?.startIcon
        },
        "data-test": id,
        disableRipple: condensed,
        id,
        ref: ref2,
        variant: _variant,
        ...props
      }
    );
  }
);
makeStyles()((_defaultTheme, theme) => {
  return {
    root: { borderRadius: 30, padding: "12px 16px" },
    iconOnlyRoot: { borderRadius: 30, padding: 12, minWidth: 44 }
  };
});
const useButtonDropdownStyles = makeStyles()(() => {
  return {
    popover: {
      marginLeft: "45px",
      marginTop: "10px"
    }
  };
});
const _popoverAnchorOrigin$1 = {
  vertical: "bottom",
  horizontal: "right"
};
const _popoverTransformOrigin$1 = {
  vertical: "top",
  horizontal: "right"
};
const ButtonDropdown = reactExports.memo(function ButtonDropdownRenderer({
  children,
  disabled,
  id,
  label,
  onClose,
  onOpen,
  open: open2,
  popoverProps,
  variant = "secondary",
  ...props
}) {
  const theme = useTheme();
  const ref2 = reactExports.useRef(null);
  const { classes } = useButtonDropdownStyles(theme);
  const clickHandler = reactExports.useCallback(
    (e) => {
      open2 ? onClose() : onOpen();
    },
    [onClose, onOpen, open2]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button2,
      {
        "aria-controls": open2 ? "basic-menu" : void 0,
        "aria-describedby": id,
        "aria-expanded": open2,
        "aria-haspopup": "true",
        disabled,
        endIcon: open2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(ExpandLess, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(ExpandMore, {}),
        id: `${id}-menu-button`,
        onClick: clickHandler,
        variant,
        ...props,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Typography$1,
          {
            fontWeight: theme.typography.fontWeightMedium,
            ref: ref2,
            variant: "body2",
            children: label
          }
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Popover,
      {
        anchorEl: ref2.current,
        anchorOrigin: _popoverAnchorOrigin$1,
        className: classes.popover,
        id,
        keepMounted: true,
        onClose,
        open: open2,
        transformOrigin: _popoverTransformOrigin$1,
        ...popoverProps,
        children
      }
    )
  ] });
});
const CardHeader2 = reactExports.memo(function CardHeaderRenderer({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CardHeader$1, { ...props, children });
});
const CardContent2 = reactExports.memo(function CardContentRenderer({ children }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CardContent$1, { children });
});
const CardActions2 = reactExports.memo(function CardActionsRenderer({
  children
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CardActions$1, { children });
});
reactExports.memo(function CardRenderer({
  children,
  icon,
  id,
  footer,
  title,
  ...props
}) {
  const contentId = `${id}-content`;
  const headerId = `${id}-header`;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Card,
    {
      "aria-describedby": contentId,
      "aria-labelledby": headerId,
      "data-test": id,
      id,
      ...props,
      children: [
        (!!title || !!icon) && /* @__PURE__ */ jsxRuntimeExports.jsx(
          CardHeader2,
          {
            avatar: icon,
            "data-test": headerId,
            id: headerId,
            title
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(CardContent2, { "data-test": contentId, id: contentId, children }),
        !!footer && /* @__PURE__ */ jsxRuntimeExports.jsx(CardActions2, { "data-test": `${id}-footer`, id: `${id}-footer`, children: footer })
      ]
    }
  );
});
const SvgAutofill = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("g", { id: "autofill", clipPath: "url(#clip0_9156_3714)" }, /* @__PURE__ */ reactExports.createElement("g", { id: "Icon" }, /* @__PURE__ */ reactExports.createElement("path", { d: "M6.41671 12.2502L5.4051 9.61999C5.2406 9.19228 5.15834 8.97842 5.03043 8.79853C4.91707 8.6391 4.77777 8.4998 4.61834 8.38644C4.43845 8.25853 4.2246 8.17627 3.79688 8.01177L1.16671 7.00016L3.79688 5.98856C4.22459 5.82405 4.43845 5.7418 4.61834 5.61389C4.77777 5.50052 4.91707 5.36123 5.03043 5.2018C5.15834 5.02191 5.2406 4.80805 5.4051 4.38033L6.41671 1.75016L7.42831 4.38033C7.59282 4.80805 7.67507 5.02191 7.80298 5.2018C7.91635 5.36123 8.05564 5.50052 8.21507 5.61389C8.39496 5.7418 8.60882 5.82405 9.03654 5.98856L11.6667 7.00016L9.03654 8.01177C8.60882 8.17627 8.39496 8.25853 8.21507 8.38644C8.05564 8.4998 7.91635 8.6391 7.80298 8.79853C7.67507 8.97842 7.59282 9.19228 7.42831 9.61999L6.41671 12.2502Z", fill: "currentColor" }), /* @__PURE__ */ reactExports.createElement("path", { d: "M11.375 1.16683L11.375 4.0835M11.375 9.91683L11.375 12.8335M12.8334 11.3752L9.91671 11.3752M12.8334 2.62516L9.91671 2.62516M6.41671 12.2502L7.42831 9.61999C7.59282 9.19228 7.67507 8.97842 7.80298 8.79853C7.91635 8.6391 8.05564 8.4998 8.21507 8.38644C8.39496 8.25853 8.60882 8.17627 9.03654 8.01177L11.6667 7.00016L9.03654 5.98856C8.60882 5.82405 8.39496 5.7418 8.21507 5.61389C8.05564 5.50052 7.91635 5.36123 7.80298 5.2018C7.67507 5.02191 7.59282 4.80805 7.42831 4.38033L6.41671 1.75016L5.4051 4.38033C5.2406 4.80805 5.15834 5.02191 5.03043 5.2018C4.91707 5.36123 4.77777 5.50052 4.61834 5.61389C4.43845 5.7418 4.22459 5.82405 3.79688 5.98856L1.16671 7.00016L3.79688 8.01177C4.2246 8.17627 4.43845 8.25853 4.61834 8.38644C4.77777 8.4998 4.91707 8.6391 5.03043 8.79853C5.15834 8.97842 5.2406 9.19228 5.4051 9.61999L6.41671 12.2502Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }))), /* @__PURE__ */ reactExports.createElement("defs", null, /* @__PURE__ */ reactExports.createElement("clipPath", { id: "clip0_9156_3714" }, /* @__PURE__ */ reactExports.createElement("rect", { width: 14, height: 14, fill: "white" }))));
const SvgCalendar = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 18, height: 20, viewBox: "0 0 18 20", stroke: "currentColor", fill: "currentcolor", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("path", { d: "M16.5 8.33334H1.5M12.3333 1.66667V5.00001M5.66667 1.66667V5.00001M5.5 18.3333H12.5C13.9001 18.3333 14.6002 18.3333 15.135 18.0609C15.6054 17.8212 15.9878 17.4387 16.2275 16.9683C16.5 16.4335 16.5 15.7335 16.5 14.3333V7.33334C16.5 5.93321 16.5 5.23314 16.2275 4.69836C15.9878 4.22796 15.6054 3.84551 15.135 3.60582C14.6002 3.33334 13.9001 3.33334 12.5 3.33334H5.5C4.09987 3.33334 3.3998 3.33334 2.86502 3.60582C2.39462 3.84551 2.01217 4.22796 1.77248 4.69836C1.5 5.23314 1.5 5.93321 1.5 7.33334V14.3333C1.5 15.7335 1.5 16.4335 1.77248 16.9683C2.01217 17.4387 2.39462 17.8212 2.86502 18.0609C3.3998 18.3333 4.09987 18.3333 5.5 18.3333Z", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgCheckIcon = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 10, height: 8, viewBox: "0 0 10 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("path", { d: "M9 1L3.5 6.5L1 4", stroke: "currentColor", strokeWidth: 1.6666, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgChevronLeft = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("path", { d: "M15 18L9 12L15 6", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgChevronRight = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("path", { d: "M9 18L15 12L9 6", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgColumns = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("path", { d: "M10 2.5V17.5M6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5Z", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgCommentCompleted = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("g", { id: "comment-completed" }, /* @__PURE__ */ reactExports.createElement("g", { id: "Icon" }, /* @__PURE__ */ reactExports.createElement("path", { d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.5C21 14.8978 21 15.5967 20.7716 16.1481C20.4672 16.8831 19.8831 17.4672 19.1481 17.7716C18.5967 18 17.8978 18 16.5 18C16.0114 18 15.7671 18 15.5405 18.0535C15.2383 18.1248 14.9569 18.2656 14.7185 18.4645C14.5397 18.6137 14.3931 18.8091 14.1 19.2L12.64 21.1467C12.4229 21.4362 12.3143 21.5809 12.1812 21.6327C12.0647 21.678 11.9353 21.678 11.8188 21.6327C11.6857 21.5809 11.5771 21.4362 11.36 21.1467L9.9 19.2C9.60685 18.8091 9.46028 18.6137 9.2815 18.4645C9.04312 18.2656 8.76169 18.1248 8.45951 18.0535C8.23287 18 7.98858 18 7.5 18C6.10218 18 5.40326 18 4.85195 17.7716C4.11687 17.4672 3.53284 16.8831 3.22836 16.1481C3 15.5967 3 14.8978 3 13.5V7.8Z", fill: "currentColor" }), /* @__PURE__ */ reactExports.createElement("path", { d: "M7 9H13.5M7 11.9167H16.5M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }))));
const SvgCommentRequired = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("g", { id: "comment-required", clipPath: "url(#clip0_326_24361)" }, /* @__PURE__ */ reactExports.createElement("path", { id: "Icon", d: "M12 13.5V7.5M9 10.5H15M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ reactExports.createElement("path", { id: "*", d: "M15.7177 6.75276L15.3491 7.19145L15.8336 7.49722L17.1956 8.35673L17.5875 8.604L17.8638 8.2321L19.4341 6.11887L21.0486 8.29769L21.3286 8.67553L21.7229 8.4192L23.074 7.5408L23.5474 7.23301L23.1846 6.80033L21.548 4.84876L24.1244 4.18675L24.6503 4.05162L24.4724 3.53864L23.9712 2.09354L23.8108 1.63121L23.3452 1.78157L20.775 2.61145L20.8605 0.0164711L20.8775 -0.5H20.3608H18.7046H18.1893L18.2048 0.0150839L18.2816 2.55833L15.6639 1.7243L15.2054 1.57824L15.0419 2.03074L14.5298 3.44751L14.343 3.96417L14.8749 4.10158L17.3975 4.75324L15.7177 6.75276Z", fill: "#D32F2F", stroke: "white" })), /* @__PURE__ */ reactExports.createElement("defs", null, /* @__PURE__ */ reactExports.createElement("clipPath", { id: "clip0_326_24361" }, /* @__PURE__ */ reactExports.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgCommentPlus = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("g", { id: "comment-plus" }, /* @__PURE__ */ reactExports.createElement("path", { id: "Icon", d: "M12 13.5V7.5M9 10.5H15M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const SvgDownArrow = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("path", { d: "M6.00016 1.33325V10.6666M6.00016 10.6666L10.6668 5.99992M6.00016 10.6666L1.3335 5.99992", stroke: "currentColor", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgErrorExclamationRing = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 16, height: 20, viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("g", { clipPath: "url(#clip0_714_1960)" }, /* @__PURE__ */ reactExports.createElement("path", { d: "M7.99992 7.33337V10M7.99992 12.6667H8.00659M14.6666 10C14.6666 13.6819 11.6818 16.6667 7.99992 16.6667C4.31802 16.6667 1.33325 13.6819 1.33325 10C1.33325 6.31814 4.31802 3.33337 7.99992 3.33337C11.6818 3.33337 14.6666 6.31814 14.6666 10Z", stroke: "currentColor", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ reactExports.createElement("defs", null, /* @__PURE__ */ reactExports.createElement("clipPath", { id: "clip0_714_1960" }, /* @__PURE__ */ reactExports.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 2)" }))));
const SvgGear = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("path", { d: "M9.99999 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61931 11.3807 7.50002 9.99999 7.50002C8.61928 7.50002 7.49999 8.61931 7.49999 10C7.49999 11.3807 8.61928 12.5 9.99999 12.5Z", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ reactExports.createElement("path", { d: "M15.6061 12.2727C15.5052 12.5012 15.4751 12.7547 15.5197 13.0005C15.5642 13.2462 15.6814 13.473 15.8561 13.6515L15.9015 13.697C16.0424 13.8377 16.1541 14.0048 16.2304 14.1887C16.3066 14.3727 16.3459 14.5698 16.3459 14.769C16.3459 14.9681 16.3066 15.1652 16.2304 15.3492C16.1541 15.5331 16.0424 15.7002 15.9015 15.8409C15.7608 15.9818 15.5937 16.0936 15.4097 16.1698C15.2258 16.2461 15.0287 16.2853 14.8295 16.2853C14.6304 16.2853 14.4333 16.2461 14.2493 16.1698C14.0654 16.0936 13.8983 15.9818 13.7576 15.8409L13.7121 15.7955C13.5336 15.6208 13.3068 15.5037 13.061 15.4591C12.8153 15.4145 12.5618 15.4446 12.3333 15.5455C12.1093 15.6415 11.9182 15.801 11.7836 16.0042C11.649 16.2075 11.5767 16.4456 11.5757 16.6894V16.8182C11.5757 17.22 11.4161 17.6054 11.132 17.8896C10.8478 18.1737 10.4624 18.3334 10.0606 18.3334C9.65875 18.3334 9.27337 18.1737 8.98922 17.8896C8.70508 17.6054 8.54544 17.22 8.54544 16.8182V16.75C8.53958 16.4993 8.45841 16.2561 8.3125 16.0521C8.16658 15.8481 7.96267 15.6927 7.72726 15.6061C7.49877 15.5052 7.2453 15.4752 6.99954 15.5197C6.75379 15.5643 6.52702 15.6814 6.34847 15.8561L6.30302 15.9015C6.1623 16.0424 5.9952 16.1542 5.81126 16.2304C5.62733 16.3067 5.43016 16.3459 5.23105 16.3459C5.03194 16.3459 4.83477 16.3067 4.65084 16.2304C4.4669 16.1542 4.2998 16.0424 4.15908 15.9015C4.01821 15.7608 3.90645 15.5937 3.8302 15.4098C3.75395 15.2258 3.71471 15.0287 3.71471 14.8296C3.71471 14.6305 3.75395 14.4333 3.8302 14.2494C3.90645 14.0654 4.01821 13.8983 4.15908 13.7576L4.20454 13.7121C4.37918 13.5336 4.49634 13.3068 4.5409 13.0611C4.58546 12.8153 4.55538 12.5619 4.45454 12.3334C4.3585 12.1093 4.19905 11.9182 3.9958 11.7836C3.79255 11.649 3.55437 11.5768 3.3106 11.5758H3.18181C2.77996 11.5758 2.39458 11.4161 2.11043 11.132C1.82629 10.8479 1.66666 10.4625 1.66666 10.0606C1.66666 9.65878 1.82629 9.2734 2.11043 8.98925C2.39458 8.70511 2.77996 8.54548 3.18181 8.54548H3.24999C3.50074 8.53961 3.74393 8.45844 3.94794 8.31253C4.15195 8.16661 4.30735 7.9627 4.39393 7.72729C4.49477 7.4988 4.52486 7.24533 4.4803 6.99957C4.43574 6.75382 4.31858 6.52705 4.14393 6.34851L4.09847 6.30305C3.9576 6.16233 3.84585 5.99523 3.7696 5.81129C3.69335 5.62736 3.6541 5.4302 3.6541 5.23108C3.6541 5.03197 3.69335 4.83481 3.7696 4.65087C3.84585 4.46693 3.9576 4.29983 4.09847 4.15911C4.23919 4.01824 4.4063 3.90648 4.59023 3.83023C4.77417 3.75398 4.97133 3.71474 5.17044 3.71474C5.36956 3.71474 5.56672 3.75398 5.75066 3.83023C5.93459 3.90648 6.1017 4.01824 6.24241 4.15911L6.28787 4.20457C6.46641 4.37922 6.69318 4.49637 6.93894 4.54093C7.18469 4.58549 7.43816 4.55541 7.66666 4.45457H7.72726C7.95133 4.35853 8.14243 4.19908 8.27703 3.99583C8.41163 3.79258 8.48387 3.5544 8.48484 3.31063V3.18184C8.48484 2.78 8.64447 2.39461 8.92862 2.11046C9.21276 1.82632 9.59815 1.66669 9.99999 1.66669C10.4018 1.66669 10.7872 1.82632 11.0714 2.11046C11.3555 2.39461 11.5151 2.78 11.5151 3.18184V3.25002C11.5161 3.4938 11.5883 3.73197 11.723 3.93522C11.8576 4.13847 12.0487 4.29793 12.2727 4.39396C12.5012 4.4948 12.7547 4.52489 13.0004 4.48033C13.2462 4.43577 13.473 4.31861 13.6515 4.14396L13.697 4.09851C13.8377 3.95763 14.0048 3.84588 14.1887 3.76963C14.3727 3.69338 14.5698 3.65413 14.7689 3.65413C14.968 3.65413 15.1652 3.69338 15.3491 3.76963C15.5331 3.84588 15.7002 3.95763 15.8409 4.09851C15.9818 4.23922 16.0935 4.40633 16.1698 4.59026C16.246 4.7742 16.2853 4.97136 16.2853 5.17048C16.2853 5.36959 16.246 5.56675 16.1698 5.75069C16.0935 5.93462 15.9818 6.10173 15.8409 6.24244L15.7954 6.2879C15.6208 6.46644 15.5036 6.69321 15.4591 6.93897C15.4145 7.18472 15.4446 7.43819 15.5454 7.66669V7.72729C15.6415 7.95136 15.8009 8.14246 16.0042 8.27706C16.2074 8.41166 16.4456 8.4839 16.6894 8.48487H16.8182C17.22 8.48487 17.6054 8.6445 17.8895 8.92865C18.1737 9.21279 18.3333 9.59818 18.3333 10C18.3333 10.4019 18.1737 10.7872 17.8895 11.0714C17.6054 11.3555 17.22 11.5152 16.8182 11.5152H16.75C16.5062 11.5161 16.268 11.5884 16.0648 11.723C15.8615 11.8576 15.7021 12.0487 15.6061 12.2727Z", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgIndeterminate = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 10, height: 2, viewBox: "0 0 10 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("path", { d: "M1.5 1H8.5", stroke: "currentColor", strokeWidth: 1.66666, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgInfoCircle = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("g", { id: "info-circle", clipPath: "url(#clip0_660_308)" }, /* @__PURE__ */ reactExports.createElement("path", { id: "Icon", d: "M10 13.3333V9.99999M10 6.66666H10.0084M18.3334 9.99999C18.3334 14.6024 14.6024 18.3333 10 18.3333C5.39765 18.3333 1.66669 14.6024 1.66669 9.99999C1.66669 5.39762 5.39765 1.66666 10 1.66666C14.6024 1.66666 18.3334 5.39762 18.3334 9.99999Z", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ reactExports.createElement("defs", null, /* @__PURE__ */ reactExports.createElement("clipPath", { id: "clip0_660_308" }, /* @__PURE__ */ reactExports.createElement("rect", { width: 20, height: 20, fill: "white" }))));
const SvgKabob = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 4, height: 16, viewBox: "0 0 4 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("path", { d: "M1.99999 8.83325C2.46023 8.83325 2.83332 8.46016 2.83332 7.99992C2.83332 7.53968 2.46023 7.16659 1.99999 7.16659C1.53975 7.16659 1.16666 7.53968 1.16666 7.99992C1.16666 8.46016 1.53975 8.83325 1.99999 8.83325Z", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ reactExports.createElement("path", { d: "M1.99999 2.99992C2.46023 2.99992 2.83332 2.62682 2.83332 2.16659C2.83332 1.70635 2.46023 1.33325 1.99999 1.33325C1.53975 1.33325 1.16666 1.70635 1.16666 2.16659C1.16666 2.62682 1.53975 2.99992 1.99999 2.99992Z", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ reactExports.createElement("path", { d: "M1.99999 14.6666C2.46023 14.6666 2.83332 14.2935 2.83332 13.8333C2.83332 13.373 2.46023 12.9999 1.99999 12.9999C1.53975 12.9999 1.16666 13.373 1.16666 13.8333C1.16666 14.2935 1.53975 14.6666 1.99999 14.6666Z", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgLeadingColumn = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("g", { id: "Leading icon" }, /* @__PURE__ */ reactExports.createElement("path", { id: "Icon", d: "M7.5 2.5V17.5M6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5Z", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" })));
const SvgPlus = (props) => /* @__PURE__ */ reactExports.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ reactExports.createElement("path", { d: "M10.0001 4.16669V15.8334M4.16675 10H15.8334", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgSpacingHeight = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("path", { d: "M10 15L10 5M10 15L7.5 13.3333M10 15L12.5 13.3333M10 5L7.5 6.66667M10 5L12.5 6.66667M17.5 2.5H2.5M17.5 17.5H2.5", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgTrash = (props) => /* @__PURE__ */ reactExports.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ reactExports.createElement("g", { id: "trash" }, /* @__PURE__ */ reactExports.createElement("path", { id: "Icon", d: "M13.3333 4.99999V4.33332C13.3333 3.3999 13.3333 2.93319 13.1517 2.57667C12.9919 2.26307 12.7369 2.0081 12.4233 1.84831C12.0668 1.66666 11.6001 1.66666 10.6667 1.66666H9.33333C8.39991 1.66666 7.9332 1.66666 7.57668 1.84831C7.26308 2.0081 7.00811 2.26307 6.84832 2.57667C6.66667 2.93319 6.66667 3.3999 6.66667 4.33332V4.99999M8.33333 9.58332V13.75M11.6667 9.58332V13.75M2.5 4.99999H17.5M15.8333 4.99999V14.3333C15.8333 15.7335 15.8333 16.4335 15.5608 16.9683C15.3212 17.4387 14.9387 17.8212 14.4683 18.0608C13.9335 18.3333 13.2335 18.3333 11.8333 18.3333H8.16667C6.76654 18.3333 6.06647 18.3333 5.53169 18.0608C5.06129 17.8212 4.67883 17.4387 4.43915 16.9683C4.16667 16.4335 4.16667 15.7335 4.16667 14.3333V4.99999", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" })));
const AutofillIcon = ({ style: style2, ...props }) => {
  const theme = useTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SvgIcon,
    {
      component: SvgAutofill,
      style: { color: theme.palette.success[800], ...style2 },
      viewBox: "0 0 14 14",
      ...props
    }
  );
};
const CalendarIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgCalendar,
    style: { fill: "none", ...style2 },
    viewBox: "0 0 18 20",
    ...props
  }
);
const CheckIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgCheckIcon,
    style: { fill: "none", ...style2 },
    viewBox: "0 0 10 8",
    ...props
  }
);
const ChevronLeftIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgChevronLeft,
    style: { fill: "none", ...style2 },
    viewBox: "0 0 24 24",
    ...props
  }
);
const ChevronRightIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgChevronRight,
    style: { fill: "none", ...style2 },
    viewBox: "0 0 24 24",
    ...props
  }
);
const ColumnIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgColumns,
    style: { fill: "none", ...style2 },
    viewBox: "0 0 20 20",
    ...props
  }
);
const CommentCompletedIcon = ({ style: style2, ...props }) => {
  const theme = useTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SvgIcon,
    {
      component: SvgCommentCompleted,
      style: {
        fill: theme.palette.success[100],
        color: theme.palette.success[900],
        ...style2
      },
      viewBox: "0 0 24 24",
      ...props
    }
  );
};
const CommentIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgCommentPlus,
    style: { fill: "none", ...style2 },
    viewBox: "0 0 24 24",
    ...props
  }
);
const CommentRequiredIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgCommentRequired,
    style: { fill: "none", ...style2 },
    viewBox: "0 0 24 24",
    ...props
  }
);
const DownArrowIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon, { component: SvgDownArrow, viewBox: "0 0 12 12", ...props });
const ErrorExclamationRingIcon = ({ sx: sx2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgErrorExclamationRing,
    sx: { fill: "none", ...sx2 },
    viewBox: "0 0 16 20",
    ...props
  }
);
const GearIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgGear,
    style: { fill: "none", ...style2 },
    viewBox: "0 0 20 20",
    ...props
  }
);
const IndeterminateIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgIndeterminate,
    style: { fill: "none", ...style2 },
    viewBox: "0 0 10 2",
    ...props
  }
);
const InfoCircleIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgInfoCircle,
    style: { fill: "none", ...style2 },
    viewBox: "0 0 20 20",
    ...props
  }
);
const KabobIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgKabob,
    style: { fill: "none", ...style2 },
    viewBox: "0 0 4 16",
    ...props
  }
);
const LeadingColumnIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgLeadingColumn,
    style: { fill: "none", ...style2 },
    viewBox: "0 0 20 20",
    ...props
  }
);
const PlusIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon, { component: SvgPlus, viewBox: "0 0 20 20", ...props });
const SpacingHeightIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon, { component: SvgSpacingHeight, viewBox: "0 0 20 20", ...props });
const TrashIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: SvgTrash,
    style: { fill: "none", ...style2 },
    viewBox: "0 0 20 20",
    ...props
  }
);
const UpArrowIcon = ({ style: style2, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SvgIcon,
  {
    component: DownArrowIcon,
    style: { transform: "rotate(180deg)" },
    viewBox: "0 0 12 12",
    ...props
  }
);
const useCheckboxStyles = tss$1.withParams().create(({ theme }) => {
  return {
    root: {
      "& .MuiCheckbox-root.Mui-checked.Mui-disabled": {
        backgroundColor: theme.palette.grey[100],
        borderColor: theme.palette.grey[300]
      }
    },
    checkIcon: {
      color: theme.palette.primary[600]
    },
    checkIconDisabled: {
      color: theme.palette.grey[300]
    }
  };
});
const Checkbox2 = ({
  disabled,
  helperText,
  id,
  label,
  required,
  ...props
}) => {
  const theme = useTheme();
  const { classes } = useCheckboxStyles({ theme });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { display: "flex", flexDirection: "column" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormControlLabel,
      {
        control: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Checkbox$1,
          {
            ...props,
            checkedIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(
              CheckIcon,
              {
                className: disabled ? classes.checkIconDisabled : classes.checkIcon,
                style: { height: 8 }
              }
            ),
            className: classes.root,
            "data-test": id,
            disabled,
            disableFocusRipple: true,
            disableRipple: true,
            disableTouchRipple: true,
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
            id,
            indeterminateIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(IndeterminateIcon, { style: { height: 2, width: 10 } })
          }
        ),
        label: typeof label === "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          Typography$1,
          {
            style: {
              fontWeight: helperText ? theme.typography.fontWeightMedium : theme.typography.fontWeightRegular
            },
            variant: "body1",
            children: label
          }
        ) : label,
        required
      }
    ),
    helperText && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Typography$1,
      {
        color: theme.palette.grey[500],
        fontWeight: theme.typography.fontWeightRegular,
        style: { marginLeft: "15px" },
        variant: "body1",
        children: helperText
      }
    )
  ] });
};
makeStyles()((_defaultTheme, theme) => {
  return {
    pickerItem: {
      border: `1px solid ${theme.palette.grey[200]}`,
      justifyContent: "flex-start",
      maxHeight: "300px",
      paddingBottom: "12px",
      paddingLeft: "25px",
      paddingTop: "12px",
      width: "100%",
      zIndex: 0,
      "&:active": {
        background: theme.palette.common?.white,
        color: theme.palette.common?.white,
        border: `1px solid ${theme.palette.primary[500]}`
      },
      "&:hover": {
        border: `1px solid ${theme.palette.primary[300]}`,
        background: theme.palette.common?.white
      },
      "&.Mui-disabled": {
        background: theme.palette.grey[100],
        border: `1px solid ${theme.palette.grey[300]}`
      },
      "&.Mui-focusVisible": {
        border: `1px solid ${theme.palette.primary[300]}`
      }
    },
    pickerItemChecked: {
      background: theme.palette.primary[25],
      border: `1px solid ${theme.palette.primary[600]}`,
      "&:active": {
        background: theme.palette.primary[50],
        color: theme.palette.primary[50],
        border: `1px solid ${theme.palette.primary[900]}`
      }
    }
  };
});
const useContentDrawerStyles = makeStyles()((_defaultTheme, theme) => {
  return {
    container: {
      color: theme.palette.grey[900],
      display: "flex",
      flexDirection: "column",
      height: "100%",
      overflow: "hidden",
      position: "relative"
    },
    header: {
      display: "flex",
      gap: 16,
      justifyContent: "space-between",
      padding: "16px 24px",
      borderBottom: `1px solid ${theme.palette.grey[200]}`
    },
    content: {
      flex: 1,
      overflow: "auto",
      padding: 24,
      scrollbarGutter: "stable"
    },
    closeIcon: {
      // Prevents the button from stretching to match the title block height, which would make the hover background oval
      alignSelf: "flex-start",
      color: theme.palette.grey[700]
    }
  };
});
reactExports.memo(function ContentDrawerRenderer({
  children,
  footer,
  id,
  onClose,
  open: open2,
  title,
  subtitle,
  ...props
}) {
  const theme = useTheme();
  const { classes } = useContentDrawerStyles(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Drawer,
    {
      anchor: "right",
      "data-test": id,
      id,
      onClose,
      open: open2,
      transitionDuration: 100,
      ...props,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { className: classes.container, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { className: classes.header, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { variant: "h3", children: title }),
            subtitle && /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { color: theme.palette.grey[700], variant: "body2", children: subtitle })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              className: classes.closeIcon,
              id: `${id}-close-button`,
              onClick: onClose,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(Close, { fontSize: "small" })
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { className: classes.content, children }),
        footer
      ] })
    }
  );
});
const useStyles$b = tss$1.withParams().create(({ theme, disabled }) => {
  return {
    popper: {
      "& .MuiPickersLayout-root": {
        padding: 24
      },
      "& .MuiDateCalendar-root": {
        maxHeight: "initial",
        height: "initial",
        width: 280
      },
      "& .MuiPickersSlideTransition-root.MuiDayCalendar-slideTransition": {
        overflowX: "inherit",
        minHeight: 252
      },
      "& .MuiButtonBase-root.MuiPickersDay-root": {
        color: theme.palette.grey[900],
        fontSize: theme.typography.body2.fontSize,
        height: 40,
        margin: 0,
        width: 40,
        ":hover": {
          backgroundColor: theme.palette.grey[50],
          fontWeight: theme.typography.fontWeightMedium
        },
        "&.MuiPickersDay-dayOutsideMonth": {
          color: theme.palette.grey[500]
        },
        "&.MuiPickersDay-today": {
          backgroundColor: theme.palette.success[100],
          border: "inherit",
          color: theme.palette.grey[700],
          fontWeight: theme.typography.fontWeightMedium,
          ":hover": {
            fontWeight: theme.typography.fontWeightBold
          }
        },
        "&.Mui-selected": {
          backgroundColor: theme.palette.blue[800],
          color: "white",
          fontWeight: theme.typography.fontWeightMedium,
          ":hover": {
            fontWeight: theme.typography.fontWeightBold
          }
        }
      },
      "& .MuiTypography-root.MuiDayCalendar-weekDayLabel": {
        color: theme.palette.grey[900],
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.body2.fontSize,
        margin: 0,
        width: 40
      }
    },
    calendarHeader: {
      display: "flex",
      justifyContent: "space-between",
      padding: "0 0 12px 0",
      alignItems: "center",
      "& .MuiSvgIcon-root": {
        height: 20,
        width: 20,
        color: theme.palette.grey[700]
      }
    },
    calendarIcon: {
      fill: "white",
      stroke: theme.palette.grey[disabled ? 500 : 900],
      viewBox: "0 0 18 20"
    },
    monthYearButton: {
      margin: 0,
      width: 180,
      "& .MuiTypography-root": {
        color: theme.palette.primary[600],
        fontWeight: theme.typography.fontWeightMedium
      }
    }
  };
});
const formatDayOfWeek = (date) => {
  return date.toFormat("ccc").substring(0, 2);
};
const INVALID_DATE = { date: null, isValid: false };
const BOTKey = "1900-01-01";
const EOTKey = "2099-12-31";
const BOT$1 = DateTime.fromISO(BOTKey);
const EOT$1 = DateTime.fromISO(EOTKey);
const BOT_STR = "BOT";
const EOT_STR = "EOT";
const parseDate = ({
  date,
  locale,
  maxDate,
  minDate,
  botLabel = BOT_STR,
  eotLabel = EOT_STR
}) => {
  const dateString = date.trim();
  if (!dateString) {
    return INVALID_DATE;
  }
  const upperDateString = dateString.toUpperCase();
  if (upperDateString === botLabel.toUpperCase()) {
    return { date: BOT$1, isValid: true };
  }
  if (upperDateString === eotLabel.toUpperCase()) {
    return { date: EOT$1, isValid: true };
  }
  let isValid = false;
  for (const sep of ["/", "\\.", " ", "-"]) {
    const regex = new RegExp(
      `^(\\d{1,2}|\\d{1,2}${sep}\\d{1,2}|\\d{1,2}${sep}\\d{1,2}${sep}\\d{4})$`
    );
    if (regex.test(dateString)) {
      isValid = true;
      break;
    }
  }
  if (!isValid) {
    return INVALID_DATE;
  }
  const monthIndex = getPlaceholderDateFormat(locale).startsWith("mm") ? 0 : 1;
  const today2 = DateTime.now();
  let year = today2.year;
  let month = today2.month;
  let day = today2.day;
  const parts = dateString.split(/[\\/\\. \\-]/);
  if (parts.length < 1 || parts.length > 3) {
    return INVALID_DATE;
  }
  month = Number.parseInt(parts[monthIndex]);
  if (parts.length >= 2) {
    day = Number.parseInt(parts[1 - monthIndex]);
    if (parts.length >= 3) {
      year = Number.parseInt(parts[2]);
    }
  }
  if (!isValidYearMonthDay({ year, month, day })) {
    return INVALID_DATE;
  }
  const targetDate = DateTime.now().startOf("day").set({ year, month, day });
  const minDateEarliest = minDate.startOf("day");
  const maxDateLatest = maxDate.endOf("day");
  if (targetDate < minDateEarliest || targetDate > maxDateLatest) {
    return INVALID_DATE;
  }
  return { date: targetDate, isValid: true };
};
const getPlaceholderDateFormat = (locale) => {
  return new Intl.DateTimeFormat(locale).formatToParts(/* @__PURE__ */ new Date("2000-01-15")).map(getPlaceholderPatternForPart).join("");
};
const getPlaceholderPatternForPart = (part) => {
  switch (part.type) {
    case "day":
      return "dd";
    case "month":
      return "mm";
    case "year":
      return "yyyy";
    case "literal":
      return part.value;
    default:
      throw Error(`Unsupported date part: ${part}`);
  }
};
const getLuxonDateFormat = (locale) => {
  return new Intl.DateTimeFormat(locale).formatToParts(/* @__PURE__ */ new Date("2000-01-15")).map(getLuxonPatternForPart).join("");
};
const getLuxonPatternForPart = (part) => {
  switch (part.type) {
    case "day":
      return "dd";
    case "month":
      return "MM";
    case "year":
      return "yyyy";
    case "literal":
      return part.value;
    default:
      throw Error(`Unsupported date part: ${part}`);
  }
};
const getMonthName = (month, locale) => {
  const date = Date.UTC(2e3, month - 1, 15);
  return new Intl.DateTimeFormat(locale, { month: "long" }).format(date);
};
const isValidYearMonthDay = (date) => {
  return DateTime.fromObject(date).isValid;
};
const formatDateForDisplay = ({
  botLabel,
  date,
  eotLabel,
  luxonDateFormat
}) => {
  if (!date) {
    return "";
  }
  const dateDay = date.startOf("day");
  if (dateDay.equals(BOT$1)) {
    return botLabel;
  }
  if (dateDay.equals(EOT$1)) {
    return eotLabel;
  }
  return date.toFormat(luxonDateFormat);
};
const useStyles$a = tss$1.withParams().create(({ theme, listHeight }) => {
  const borderRadius2 = 20;
  return {
    listItemButton: {
      borderRadius: borderRadius2,
      "&.Mui-selected": {
        backgroundColor: theme.palette.blue[800],
        borderRadius: borderRadius2,
        color: "white",
        "&:hover": {
          backgroundColor: theme.palette.blue[800],
          borderRadius: borderRadius2,
          color: "white"
        }
      },
      "&:hover": {
        backgroundColor: theme.palette.grey[50],
        borderRadius: borderRadius2
      }
    },
    list: {
      maxHeight: listHeight,
      overflow: "auto",
      padding: "0 4px",
      scrollbarWidth: "none"
    },
    listContainer: {
      display: "flex",
      paddingBottom: 16
    },
    listItemText: {
      "& .MuiTypography-root": {
        fontWeight: theme.typography.fontWeightMedium,
        textAlign: "center"
      }
    }
  };
});
const MonthYearPicker = ({
  cancelButtonLabel,
  date,
  id,
  locale,
  maxDate,
  minDate,
  onCancelMonthYear,
  onSelectMonthYear,
  selectButtonLabel
}) => {
  const minYear = minDate.year;
  const maxYear = maxDate.year;
  const year = date.year;
  const month = date.month;
  const [selectedMonth, setSelectedMonth] = reactExports.useState(month);
  const [selectedYear, setSelectedYear] = reactExports.useState(year);
  const theme = useTheme();
  const listRowHeight = 40;
  const { classes } = useStyles$a({ theme, listHeight: 7 * listRowHeight });
  const yearsListRef = reactExports.useRef(null);
  const getItemKey = reactExports.useCallback((index2) => maxYear - index2, [maxYear]);
  const getScrollElement = reactExports.useCallback(() => yearsListRef.current, []);
  const estimateSize = reactExports.useCallback(() => listRowHeight, []);
  const yearsRowVirtualizer = useVirtualizer({
    count: maxYear - minYear + 1,
    getItemKey,
    getScrollElement,
    estimateSize
  });
  const monthNames = reactExports.useMemo(
    () => [...Array(12).keys()].map(
      (monthIndex) => getMonthName(monthIndex + 1, locale)
    ),
    [locale]
  );
  reactExports.useEffect(
    function scrollToYear() {
      yearsRowVirtualizer.scrollToIndex(maxYear - year, { align: "center" });
    },
    [maxYear, year, yearsRowVirtualizer]
  );
  const selectedMonthName = getMonthName(selectedMonth, locale);
  const handleMonthClick = (e) => {
    const monthName = e.target.innerText;
    setSelectedMonth(monthNames.indexOf(monthName) + 1);
  };
  const handleYearClick = (e) => {
    const year2 = Number(e.target.innerText);
    setSelectedYear(year2);
  };
  const handleCancelMonthYear = () => {
    setSelectedMonth(date.month);
    setSelectedYear(date.year);
    onCancelMonthYear();
  };
  const handleSelectMonthYear = () => {
    onSelectMonthYear(selectedMonth, selectedYear);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      alignItems: "center",
      display: "flex",
      id,
      justifyContent: "space-between",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { display: "flex", flexDirection: "column", flexGrow: 1, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { className: classes.listContainer, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { width: "65%", children: /* @__PURE__ */ jsxRuntimeExports.jsx(List$1, { className: classes.list, children: monthNames.map((m) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            ListItemButton,
            {
              autoFocus: m === selectedMonthName,
              className: classes.listItemButton,
              onClick: handleMonthClick,
              selected: m === selectedMonthName,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, { className: classes.listItemText, primary: m })
            },
            m
          )) }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { width: "35%", children: /* @__PURE__ */ jsxRuntimeExports.jsx(List$1, { className: classes.list, ref: yearsListRef, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              style: {
                height: `${yearsRowVirtualizer.getTotalSize()}px`,
                position: "relative",
                width: "100%"
              },
              children: yearsRowVirtualizer.getVirtualItems().map((item) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                ListItemButton,
                {
                  className: classes.listItemButton,
                  onClick: handleYearClick,
                  selected: item.key === selectedYear,
                  style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: `${item.size}px`,
                    transform: `translateY(${item.start}px)`
                  },
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    ListItemText,
                    {
                      className: classes.listItemText,
                      primary: item.key
                    }
                  )
                },
                item.key
              ))
            }
          ) }) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { sx: { margin: "0 -24px" } }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Box,
          {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "-16px",
            paddingTop: "8px",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Button2,
                {
                  fullWidth: true,
                  id: `${id}-cancel-btn`,
                  onClick: handleCancelMonthYear,
                  variant: "secondary",
                  children: cancelButtonLabel
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Button2,
                {
                  fullWidth: true,
                  id: `${id}-select-btn`,
                  onClick: handleSelectMonthYear,
                  children: selectButtonLabel
                }
              )
            ]
          }
        )
      ] })
    }
  );
};
const CalendarHeader = ({
  currentMonth: date,
  id,
  locale,
  maxDate,
  minDate,
  onMonthChange: onDateChange,
  monthYearCancelLabel,
  monthYearSelectLabel
}) => {
  const [showYearMonthPicker, setShowYearMonthPicker] = reactExports.useState(false);
  const ref2 = reactExports.useRef(null);
  const theme = useTheme();
  const { classes } = useStyles$b({ theme });
  const buttonLabel = date.setLocale(locale).toFormat("MMMM yyyy") ?? "";
  const selectNextMonth = () => {
    onDateChange?.(date.plus({ month: 1 }));
  };
  const selectPreviousMonth = () => {
    onDateChange?.(date.minus({ month: 1 }));
  };
  const handleCloseMonthYearPicker = () => {
    setShowYearMonthPicker(false);
  };
  const handleOpenMonthYearPicker = () => {
    setShowYearMonthPicker(true);
  };
  const handleSelectMonthYear = (month, year) => {
    onDateChange?.(date.set({ month, year }));
    setShowYearMonthPicker(false);
  };
  const containerBoundingRect = ref2.current?.getBoundingClientRect();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classes.calendarHeader, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, { onClick: selectPreviousMonth, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronLeftIcon, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ButtonDropdown,
      {
        className: classes.monthYearButton,
        id: `${id}-month-year-dropdown-btn`,
        label: buttonLabel,
        onClose: handleCloseMonthYearPicker,
        onOpen: handleOpenMonthYearPicker,
        open: showYearMonthPicker,
        popoverProps: {
          anchorPosition: {
            left: containerBoundingRect ? containerBoundingRect.x - (45 + 24) : 0,
            top: containerBoundingRect ? containerBoundingRect.y + containerBoundingRect.height : 0
          },
          anchorReference: "anchorPosition",
          slotProps: {
            paper: {
              style: {
                padding: "24px 16px",
                scrollbarWidth: "none",
                width: 328
              }
            }
          },
          transformOrigin: {
            horizontal: "left",
            vertical: "top"
          }
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          MonthYearPicker,
          {
            cancelButtonLabel: monthYearCancelLabel,
            date,
            id: `${id}-month-year-picker`,
            locale,
            maxDate,
            minDate,
            onCancelMonthYear: handleCloseMonthYearPicker,
            onSelectMonthYear: handleSelectMonthYear,
            selectButtonLabel: monthYearSelectLabel
          }
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, { onClick: selectNextMonth, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronRightIcon, {}) })
  ] });
};
const useStyles$9 = tss$1.withParams().create(({ theme }) => {
  return {
    root: {
      padding: 0
    },
    selectToday: {
      margin: "16px 0 0 0"
    }
  };
});
const ActionBar$1 = ({
  className,
  id,
  onSetToday,
  selectTodayButtonLabel
}) => {
  const theme = useTheme();
  const { classes } = useStyles$9({ theme });
  const { setOpen } = usePickerContext();
  const onSelectToday = () => {
    onSetToday();
    setOpen(false);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { className: `${className} ${classes.root}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button2,
    {
      className: classes.selectToday,
      fullWidth: true,
      id: `${id}-select-today`,
      onClick: onSelectToday,
      variant: "secondary",
      children: selectTodayButtonLabel
    }
  ) });
};
const CharacterCount = reactExports.memo(function CharacterCountRenderer({
  characterCountDisplayThreshold,
  characterLimit,
  count: count2 = 0
}) {
  return characterLimit && characterLimit > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Typography$1,
    {
      style: {
        alignSelf: "flex-start",
        display: characterLimit && characterLimit - count2 <= characterCountDisplayThreshold ? "flex" : "none"
      },
      variant: "body2",
      children: `${count2}/${characterLimit}`
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
});
const _helperTextSuffix$1 = "helper-text";
const _buildHelperTextId$1 = (inputId) => `${inputId}-${_helperTextSuffix$1}`;
const HelperText = reactExports.memo(function HelperTextRenderer({
  autofillText,
  characterCountDisplayThreshold,
  characterLimit,
  count: count2,
  error,
  helperText,
  hideErrorIcon,
  inputId
}) {
  const theme = useTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    FormHelperText,
    {
      component: "div",
      error,
      id: _buildHelperTextId$1(inputId),
      style: { display: "flex", alignItems: "top" },
      children: [
        error && !hideErrorIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(
          ErrorExclamationRingIcon,
          {
            sx: {
              height: 20,
              width: 16,
              paddingTop: "2px"
            }
          }
        ),
        autofillText && !error ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          Typography$1,
          {
            component: "span",
            style: {
              color: theme.palette.success[800],
              display: "block",
              flex: 1,
              paddingLeft: 5,
              overflowWrap: "break-word",
              maxWidth: "100%"
            },
            variant: "body2",
            children: autofillText
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          Typography$1,
          {
            component: "span",
            style: {
              display: "block",
              flex: 1,
              paddingLeft: 5,
              overflowWrap: "break-word",
              maxWidth: "100%"
            },
            variant: "body2",
            children: helperText
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CharacterCount,
          {
            characterCountDisplayThreshold,
            characterLimit,
            count: count2
          }
        )
      ]
    }
  );
});
const useStyles$8 = tss$1.withParams().create(({ theme, disabled }) => {
  return {
    root: {
      "fieldset[aria-hidden=true]": {
        display: "none"
      },
      ".MuiInputBase-input.MuiOutlinedInput-input": {
        padding: "8px 12px"
      },
      ".MuiInputBase-root.MuiOutlinedInput-root": {
        borderRadius: 8,
        paddingRight: 12
      },
      ".MuiFormLabel-root.MuiInputLabel-root": {
        "&.Mui-error": {
          color: "inherit",
          // don't show label in red when in error state
          "&.Mui-disabled": {
            color: theme.palette.grey[500]
            // show label disabled when in error state and disabled
          }
        }
      },
      ".MuiFormHelperText-root": {
        margin: "3px 0 0 0"
      }
    },
    calendarIcon: {
      cursor: "pointer",
      "& *": { cursor: "inherit" },
      pointerEvents: disabled ? "none" : "initial"
    }
  };
});
const InputField = ({
  disabled,
  error,
  helperText,
  id,
  label,
  locale,
  placeholderText,
  required,
  botLabel,
  eotLabel,
  ...props
}) => {
  const { internalProps, forwardedProps } = useSplitFieldProps(props, "date");
  const theme = useTheme();
  const { classes } = useStyles$8({ theme, disabled });
  const { format: internalFormat, maxDate, minDate } = internalProps;
  const format2 = internalFormat ?? getLuxonDateFormat(locale);
  const [text, setText] = reactExports.useState("");
  const {
    InputProps,
    inputProps,
    slotProps: _unused1,
    slots: _unused2,
    ...otherProps
  } = forwardedProps;
  const pickerContext = usePickerContext();
  const value = pickerContext.value;
  const togglePopper = () => {
    pickerContext.setOpen((prev2) => !prev2);
  };
  const formatDateInInput = reactExports.useCallback(
    (date) => {
      const formattedDate = formatDateForDisplay({
        date,
        luxonDateFormat: format2,
        botLabel,
        eotLabel
      });
      setText(formattedDate);
    },
    [format2, botLabel, eotLabel]
  );
  reactExports.useEffect(
    function setFormattedDateInInput() {
      formatDateInInput(value);
    },
    [format2, formatDateInInput, value]
  );
  const commitValue = () => {
    const { date, isValid } = parseDate({
      date: text,
      locale,
      maxDate,
      minDate,
      botLabel,
      eotLabel
    });
    if (!isValid) {
      setText("");
    }
    pickerContext.setValue(isValid ? date : null, { source: "field" });
  };
  const handleBlur = () => {
    commitValue();
  };
  const handleChange = (e) => {
    setText(e.target.value);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      commitValue();
    } else if (e.key === "Escape") {
      formatDateInInput(value);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TextField,
    {
      ...otherProps,
      className: classes.root,
      disabled,
      error,
      fullWidth: true,
      helperText: /* @__PURE__ */ jsxRuntimeExports.jsx(
        HelperText,
        {
          characterCountDisplayThreshold: 0,
          characterLimit: 0,
          count: 0,
          error,
          helperText,
          inputId: `${id}-helper-text`
        }
      ),
      id,
      label,
      onBlur: handleBlur,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      placeholder: placeholderText,
      required,
      slotProps: {
        input: {
          ...InputProps,
          ref: pickerContext.triggerRef,
          endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(
            CalendarIcon,
            {
              className: classes.calendarIcon,
              htmlColor: theme.palette.grey[disabled ? 500 : 900],
              onClick: togglePopper
            }
          )
        },
        htmlInput: {
          ...inputProps,
          maxLength: 10
        }
      },
      value: text
    }
  );
};
Settings.defaultWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
const DatePicker2 = ({
  calendarSelectTodayButtonLabel,
  disabled,
  disablePortal = true,
  error,
  helperText,
  id,
  inputLabel: inputLabel2,
  locale,
  // e.g. `en-US`
  maxDate = DateTime.fromObject({ year: 2099, month: 12, day: 31 }),
  minDate = DateTime.fromObject({ year: 1900, month: 1, day: 1 }),
  monthYearPickerCancelButtonLabel,
  monthYearPickerSelectButtonLabel,
  onChange,
  required,
  value,
  botLabel = "BOT",
  eotLabel = "EOT",
  ...otherProps
}) => {
  const theme = useTheme();
  const { classes } = useStyles$b({
    theme,
    disabled,
    isMonthYearDropdownOpen: false
  });
  const commitValue = (date, source) => {
    onChange?.(date ? date.startOf("day") : null, {
      validationError: null,
      source
    });
  };
  const handleChange = (date, context2) => {
    commitValue(date, context2.source);
  };
  const handleSelectToday = () => {
    commitValue(DateTime.now(), "view");
  };
  const placeholderDateFormatPattern = getPlaceholderDateFormat(locale);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(LocalizationProvider, { adapterLocale: locale, dateAdapter: AdapterLuxon, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    DatePicker$1,
    {
      ...otherProps,
      dayOfWeekFormatter: formatDayOfWeek,
      disabled,
      label: inputLabel2,
      maxDate,
      minDate,
      onAccept: handleChange,
      showDaysOutsideCurrentMonth: true,
      slotProps: {
        ...otherProps.slotProps,
        actionBar: {
          ...otherProps.slotProps?.actionBar,
          actions: ["today"],
          id: `${id}-action-bar`,
          onSetToday: handleSelectToday,
          selectTodayButtonLabel: calendarSelectTodayButtonLabel
        },
        calendarHeader: {
          ...otherProps.slotProps?.calendarHeader,
          id: `${id}-calendar-header`,
          locale,
          monthYearCancelLabel: monthYearPickerCancelButtonLabel,
          monthYearSelectLabel: monthYearPickerSelectButtonLabel
        },
        field: {
          ...otherProps.slotProps?.field,
          disabled,
          error,
          helperText,
          id: `${id}-input`,
          label: inputLabel2,
          locale,
          placeholderText: placeholderDateFormatPattern,
          required,
          botLabel,
          eotLabel
        },
        openPickerIcon: {
          ...otherProps.slotProps?.openPickerIcon,
          className: classes.calendarIcon,
          viewBox: "0 0 18 20"
        },
        popper: {
          ...otherProps.slotProps?.popper,
          className: classes.popper,
          disablePortal,
          popperOptions: {
            // see https://popper.js.org/docs/v2/modifiers/offset/
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, 4]
                }
              }
            ]
          }
        }
      },
      slots: {
        ...otherProps.slots,
        actionBar: ActionBar$1,
        calendarHeader: CalendarHeader,
        field: InputField,
        openPickerIcon: CalendarIcon
      },
      value
    }
  ) });
};
const DROP_DOWN_MAX_TAGS = 3;
var UNANET_DROPDOWN_OPTIONS = /* @__PURE__ */ ((UNANET_DROPDOWN_OPTIONS2) => {
  UNANET_DROPDOWN_OPTIONS2[UNANET_DROPDOWN_OPTIONS2["SELECT_ALL_KEY"] = -99] = "SELECT_ALL_KEY";
  UNANET_DROPDOWN_OPTIONS2[UNANET_DROPDOWN_OPTIONS2["NO_OPTIONS_KEY"] = -98] = "NO_OPTIONS_KEY";
  UNANET_DROPDOWN_OPTIONS2[UNANET_DROPDOWN_OPTIONS2["UNKNOWN_KEY"] = -97] = "UNKNOWN_KEY";
  UNANET_DROPDOWN_OPTIONS2[UNANET_DROPDOWN_OPTIONS2["NEW_KEY"] = -96] = "NEW_KEY";
  return UNANET_DROPDOWN_OPTIONS2;
})(UNANET_DROPDOWN_OPTIONS || {});
const ListItemElement = ({
  children,
  ...listElemenentProps
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { ...listElemenentProps, children });
const _DropdownOption = ({
  addOptionText,
  allSelected,
  getOptionKey,
  getOptionLabel,
  getOptionSupportingLabel,
  id,
  listElementProps: { className, ...listElementPropsRest },
  multiple,
  option,
  renderOptionState: { selected, index: index2 },
  selectedCount,
  selectedAtTop
}) => {
  const { NEW_KEY, NO_OPTIONS_KEY, SELECT_ALL_KEY } = UNANET_DROPDOWN_OPTIONS;
  const key = getOptionKey(option);
  const displayName = getOptionLabel(option);
  const displaySupportingName = getOptionSupportingLabel(option);
  const isNoOptionsFoundOption = key === NO_OPTIONS_KEY;
  const isSelectAllOption = key === SELECT_ALL_KEY;
  const isNewOption = key === NEW_KEY;
  const isLastSelectedItem = selectedAtTop && selected && index2 + 1 === selectedCount;
  const optionBorderClass = isSelectAllOption || isLastSelectedItem ? "option-border" : "";
  const noOptionsClass = isNoOptionsFoundOption ? autocompleteClasses.noOptions : "";
  const newOptionClass = isNewOption ? "add-option" : "";
  const listClassName = [
    className,
    optionBorderClass,
    noOptionsClass,
    newOptionClass
  ].join(" ").replace(/\s\s+/g, " ");
  const showCheckbox = multiple && !isNoOptionsFoundOption;
  const showChecked = !multiple && selected;
  const isChecked = isSelectAllOption ? allSelected : selected || allSelected;
  const elementProps = { className: listClassName, ...listElementPropsRest };
  if (isNewOption) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItemElement, { ...elementProps, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Add, {}),
      `${addOptionText} ${displayName}`
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItemElement, { ...elementProps, children: [
    showCheckbox && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox2,
      {
        checked: isChecked,
        id: `${id}-option-checkbox`,
        sx: { width: 16 }
      },
      `${index2}-${key}`
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: displayName }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "unanet-ui-dropdown-option-item-supporting-text", children: displaySupportingName }),
    showChecked && /* @__PURE__ */ jsxRuntimeExports.jsx(Check, {})
  ] });
};
const DropdownOption = reactExports.memo(_DropdownOption);
const LimitTagsBadge = reactExports.memo(function LimitTagsBadgeRenderer({
  id,
  more,
  onShowMoreToggle,
  showText
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Badge,
    {
      className: "unanet-ui-dropdown-show-more-text",
      clickable: true,
      id,
      label: `${more ?? ""} ${showText}`.trim(),
      onClick: onShowMoreToggle,
      size: "medium",
      tabIndex: -1,
      variant: "tag"
    },
    id
  );
});
const _helperTextSuffix = "helper-text";
const _buildHelperTextId = (inputId) => `${inputId}-${_helperTextSuffix}`;
const InputLabelComponent = reactExports.memo(
  function InputLabelComponentRenderer({
    htmlFor,
    label
  }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, { htmlFor, shrink: true, style: { display: "flex" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { fontWeight: 500, variant: "body2", children: label }) });
  },
  (prevProps, nextProps) => prevProps.label === nextProps.label && prevProps.error === nextProps.error
);
const Text$1 = reactExports.memo(
  reactExports.forwardRef(
    ({
      autoCompleteProps,
      autofillText,
      autoFocus,
      baseInputProps,
      characterCountDisplayThreshold = 20,
      characterLimit = 0,
      disabled,
      disableInputRef,
      endAdornment,
      error,
      helperText = " ",
      id,
      label,
      multiline,
      name,
      onChange,
      onClear,
      placeholder,
      required,
      showCharacterCount = true,
      startAdornment,
      type = "text",
      value,
      ...props
    }, ref2) => {
      const count2 = value?.length ?? 0;
      const showClear = count2 > 0 && onClear && !multiline;
      const theme = useTheme();
      const inputRef = reactExports.useRef(null);
      reactExports.useImperativeHandle(ref2, () => inputRef.current, []);
      const setCursor = reactExports.useCallback(() => {
        if (inputRef?.current) {
          inputRef.current.select = () => void 0;
        }
        if (value) {
          inputRef.current?.setSelectionRange(value.length, value?.length);
        }
      }, [value]);
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(
        FormControl,
        {
          ...props,
          disabled: disabled || autoCompleteProps?.disabled,
          fullWidth: true,
          required,
          variant: "standard",
          children: [
            label && /* @__PURE__ */ jsxRuntimeExports.jsx(
              InputLabelComponent,
              {
                htmlFor: id,
                label,
                ...autoCompleteProps?.InputLabelProps
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              InputBase,
              {
                "aria-describedby": _buildHelperTextId(id),
                autoComplete: "off",
                autoFocus,
                endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                  showClear && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    InputAdornment,
                    {
                      position: "end",
                      sx: {
                        flex: 0,
                        justifyContent: "flex-start",
                        margin: "0px 3px"
                      },
                      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                        IconButton,
                        {
                          disabled,
                          onClick: onClear,
                          size: "small",
                          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                            Close,
                            {
                              sx: {
                                color: theme.palette.grey[900],
                                fontSize: "1.3rem"
                              }
                            }
                          )
                        }
                      )
                    }
                  ),
                  endAdornment && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    InputAdornment,
                    {
                      position: "end",
                      sx: {
                        flex: 0,
                        justifyContent: "flex-start",
                        margin: "4px 3px 0 3px"
                      },
                      children: endAdornment
                    }
                  )
                ] }),
                error,
                id,
                inputProps: {
                  "data-test": `${id}-text-input`,
                  sx: showClear ? { paddingRight: 0, flex: 1 } : {},
                  ...autoCompleteProps?.inputProps,
                  maxLength: characterLimit > 0 ? characterLimit : void 0
                },
                inputRef: disableInputRef ? void 0 : inputRef,
                maxRows: 5,
                minRows: 5,
                multiline,
                name: name ?? id,
                onChange,
                onFocus: setCursor,
                placeholder,
                ref: ref2,
                startAdornment,
                type,
                value: value ?? "",
                ...autoCompleteProps?.InputProps,
                ...baseInputProps
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              HelperText,
              {
                autofillText,
                characterCountDisplayThreshold,
                characterLimit: showCharacterCount ? characterLimit : 0,
                count: count2,
                error,
                helperText,
                inputId: id
              }
            )
          ]
        }
      );
    }
  )
);
const inputAllowedKeys = (allowNegative) => [
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "Backspace",
  "Delete",
  "Enter",
  "Escape",
  "Tab",
  ...allowNegative ? ["-"] : []
];
const MAXIMUM_FRACTION_DIGITS = 3;
const NumberInputBase = reactExports.memo(
  reactExports.forwardRef(
    ({
      autofillText,
      baseInputProps,
      maxLength,
      onBlur,
      onChange,
      parser,
      startAdornment,
      stripIfInteger,
      value,
      ...props
    }, ref2) => {
      const inputRef = reactExports.useRef(null);
      const allowNegative = parser.options.signDisplay === "negative";
      reactExports.useImperativeHandle(ref2, () => inputRef.current, []);
      const [cursorPos, setCursorPos] = reactExports.useState(null);
      const formattedValue = _formatValueProp({ parser, value });
      reactExports.useLayoutEffect(() => {
        if (cursorPos !== null) {
          inputRef.current?.setSelectionRange(cursorPos, cursorPos);
          setCursorPos(null);
        }
      }, [inputRef, cursorPos, value]);
      const keyDownHandler = reactExports.useCallback(
        (event2) => {
          const { key, target } = event2;
          const {
            selectionEnd,
            selectionStart: _selectionStart,
            value: currentValue
          } = target;
          const selectionStart = _selectionStart ?? 1;
          if (!_isValidInputKey({
            allowNegative,
            currentValue,
            event: event2,
            key,
            parser,
            selectionStart: _selectionStart
          })) {
            event2.preventDefault();
            return;
          }
          if (allowNegative && inputRef.current && key === "-" && (currentValue === "" || selectionStart !== selectionEnd)) {
            inputRef.current.value = "-";
            event2.preventDefault();
            return;
          }
          const parserFraction = parser.parts.all.find(
            (p) => p.type === "fraction"
          );
          const parserMaxFractionDigits = parser.options.maximumFractionDigits;
          const numberOfDigits = parserFraction?.value.length ?? parserMaxFractionDigits;
          const moreThanOneDigitExists = numberOfDigits && numberOfDigits > 0;
          if (allowNegative && key === "-" && inputRef.current && Number(currentValue) === 0 && moreThanOneDigitExists && selectionStart === selectionEnd && selectionStart === 0 && !stripIfInteger) {
            inputRef.current.value = "-" + currentValue;
            inputRef.current.setSelectionRange(1, 1);
            event2.preventDefault();
            return;
          }
          if (inputRef.current && (key === "0" || key === parser.parts.decimal) && currentValue.startsWith("-") && Number(currentValue) === 0 && !stripIfInteger) {
            inputRef.current.value = currentValue;
            if (inputRef.current.selectionStart && inputRef.current.selectionEnd) {
              if (currentValue[selectionStart] === parser.parts.decimal && key === parser.parts.decimal || key === "0")
                inputRef.current.setSelectionRange(
                  inputRef?.current?.selectionStart + 1,
                  inputRef?.current?.selectionEnd + 1
                );
            }
            event2.preventDefault();
            return;
          }
          if (key === "0" && inputRef.current && currentValue === "-" && moreThanOneDigitExists && !stripIfInteger) {
            const baseZeroValue = "-0.";
            let zeroes = "";
            for (let i = 0; i < numberOfDigits; i++) {
              zeroes += "0";
            }
            inputRef.current.value = baseZeroValue + zeroes;
            inputRef.current.setSelectionRange(3, 3);
            event2.preventDefault();
            return;
          }
          const decimalsAllowMultipleZeroes = inputRef?.current?.value.split(parser.parts.decimal)[1] && key === "0" && stripIfInteger && inputRef?.current?.value.split(parser.parts.decimal)[1]?.length < _numberOfDigits({ parser });
          const secondDecimalTyped = inputRef?.current?.value.includes(parser.parts.decimal) && key === parser.parts.decimal && stripIfInteger;
          const allowZeroAfterDecimal = (key === parser.parts.decimal || inputRef?.current?.value.endsWith(parser.parts.decimal) && key === "0") && stripIfInteger;
          if (inputRef.current && (allowZeroAfterDecimal || decimalsAllowMultipleZeroes) && !secondDecimalTyped) {
            inputRef.current.value += key;
            event2.preventDefault();
            return;
          }
          const prevChar = currentValue.substring(
            selectionStart - 1,
            selectionStart
          );
          const nextChar = currentValue.substring(
            selectionStart,
            selectionStart + 1
          );
          const prevCharIsPart = prevChar === parser.parts.decimal || prevChar === parser.parts.group;
          if (prevCharIsPart && key === "Backspace") {
            event2.preventDefault();
            inputRef.current?.setSelectionRange(
              selectionStart - 1,
              selectionStart - 1
            );
            return;
          }
          const nextCharIsPart = nextChar === parser.parts.decimal || nextChar === parser.parts.group;
          if (nextCharIsPart && key === "Delete") {
            event2.preventDefault();
            inputRef.current?.setSelectionRange(
              selectionStart + 1,
              selectionStart + 1
            );
            return;
          }
        },
        [parser]
      );
      const changeHandler = reactExports.useCallback(
        (event2) => {
          if (!onChange) {
            return;
          }
          event2.preventDefault();
          const { selectionStart, value: newValue } = event2.target;
          if (newValue === "") {
            onChange({
              event: event2,
              values: {
                currency: parser.format(0),
                formatted: newValue,
                number: 0,
                untouched: newValue
              }
            });
            return;
          }
          let cleanedValue = newValue;
          let cursorStart = selectionStart ?? 0;
          if (value?.startsWith("0") && !newValue.startsWith("0")) {
            cleanedValue = newValue.replace("0", "");
          }
          if (newValue === parser.parts.decimal) {
            cleanedValue = "0";
            cursorStart += 1;
          }
          if (newValue.startsWith(parser.parts.decimal) && newValue.length > 1) {
            cleanedValue = "0" + newValue;
            cursorStart = newValue.length + 1;
          }
          try {
            const parsed = parser.parse(cleanedValue);
            const formatted = parser.formatWithoutSymbol(parsed);
            const currency = parser.format(parsed);
            const currentGroupParts = cleanedValue.split(parser.parts.group).length - 1;
            const nextGroupParts = formatted.split(parser.parts.group).length - 1;
            setCursorPos(cursorStart + (nextGroupParts - currentGroupParts));
            onChange({
              event: event2,
              values: {
                currency,
                formatted,
                number: parsed,
                untouched: newValue
              }
            });
          } catch (e) {
            const prevValue = value ?? "";
            const prevParsed = parser.parse(prevValue);
            onChange({
              event: event2,
              values: {
                currency: parser.format(prevParsed),
                formatted: parser.formatWithoutSymbol(prevParsed),
                number: prevParsed,
                untouched: prevValue
              }
            });
            const cursorStart2 = selectionStart ?? 0;
            setCursorPos(cursorStart2);
          }
        },
        [onChange, parser, setCursorPos, value]
      );
      const blurHandler = reactExports.useCallback(
        (event2) => {
          if (!onBlur) {
            return;
          }
          const { value: value2 } = event2.target;
          const parsed = parser.parse(value2);
          onBlur({
            event: event2,
            values: {
              currency: parser.format(parsed),
              formatted: parser.formatWithoutSymbol(parsed),
              number: parsed,
              untouched: value2
            }
          });
        },
        [parser, onBlur]
      );
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Text$1,
        {
          ...props,
          autofillText,
          baseInputProps: {
            ...baseInputProps,
            inputProps: { style: { textAlign: "right" }, maxLength },
            inputRef,
            onBlur: blurHandler,
            onKeyDown: keyDownHandler
          },
          characterLimit: maxLength,
          onChange: changeHandler,
          startAdornment,
          value: formattedValue
        }
      );
    }
  )
);
function _formatValueProp({
  parser,
  value = ""
}) {
  try {
    const parsedValue = parser.parse(value);
    const isNotANumber = Number.isNaN(parsedValue);
    if (value === "" || isNotANumber) {
      return "";
    }
    return parser.formatWithoutSymbol(parsedValue);
  } catch (e) {
    return "";
  }
}
function _numberOfDigits({ parser }) {
  const parserFraction = parser.parts.all.find((p) => p.type === "fraction");
  if (parser.options?.maximumFractionDigits) {
    return parser.options?.maximumFractionDigits;
  } else if (parserFraction) {
    return parserFraction.value.length;
  }
  return MAXIMUM_FRACTION_DIGITS;
}
function _isValidInputKey({
  allowNegative,
  currentValue,
  event: event2,
  key,
  parser,
  selectionStart
}) {
  const isAllowedKey = inputAllowedKeys(allowNegative).includes(key);
  const isValidCharacter = parser.validateCharacter(key);
  const { ctrlKey, shiftKey, metaKey } = event2;
  const decimalLengthLongerThanFractionDigits = (currentValue.split(parser.parts.decimal)[1]?.length ?? -1) >= _numberOfDigits({ parser });
  const isInvalidKey = !isAllowedKey && !isValidCharacter && !ctrlKey && !shiftKey && !metaKey;
  const cursorAtEndOfInput = isValidCharacter && !!selectionStart && selectionStart === currentValue.length && decimalLengthLongerThanFractionDigits;
  return !isInvalidKey && !cursorAtEndOfInput;
}
class UnanetNumberFormatter {
  #formatter;
  #regExps;
  constructor({
    currency = "USD",
    locale = "en-US",
    ...options
  }) {
    this.currencyCode = currency;
    this.locale = locale;
    this.options = options;
    this.#formatter = this.#initFormatter();
    this.parts = this.#initParts();
    this.#regExps = this.#initRegExps();
  }
  #initFormatter() {
    const { currencyCode: currency, locale, options } = this;
    return new Intl.NumberFormat(locale, {
      currency,
      ...options
    });
  }
  #initParts() {
    const parts = this.#formatter.formatToParts(12345.6789);
    const nonNumberParts = parts.filter((part) => part.type !== "integer" && part.type !== "fraction").reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {}
    );
    return {
      all: parts,
      currency: nonNumberParts.currency ?? "$",
      decimal: nonNumberParts.decimal ?? ".",
      group: nonNumberParts.group ?? ","
    };
  }
  #initRegExps() {
    return {
      currency: new RegExp(`\\${this.parts.currency}`, "g"),
      decimal: new RegExp(`\\${this.parts.decimal}`, "g"),
      group: new RegExp(`\\${this.parts.group}`, "g"),
      validator: new RegExp(
        `^[0-9 \\${this.parts.currency} \\${this.parts.group} \\${this.parts.decimal}]+$`
      )
    };
  }
  #numberInvalid(number) {
    return number == null || Number.isNaN(number) || !Number.isFinite(number);
  }
  parse(toParse) {
    if (!this.#numberInvalid(toParse)) {
      return Number(toParse);
    }
    const { currency, decimal, group } = this.#regExps;
    const parsed = toParse.toString().trim().replace(currency, "").replace(group, "").replace(decimal, ".");
    return Number(parsed);
  }
  format(number) {
    if (this.#numberInvalid(number)) {
      throw new RangeError("Unable to format: Invalid Number");
    }
    return this.#formatter.format(number);
  }
  /**
   * Checks if a format part at the given index is adjacent to a currency part.
   * Used to identify whitespace literals that exist solely to separate the
   * currency symbol from the number (e.g., "€ 1,234" or "1,234 €").
   */
  #isPartAdjacentToCurrency(index2, parts) {
    const next2 = parts[index2 + 1];
    const prev2 = parts[index2 - 1];
    return next2?.type === "currency" || prev2?.type === "currency";
  }
  /**
   * Formats a number using the configured locale and currency settings,
   * but excludes the currency symbol from the output.
   *
   * When using currencySign: 'accounting', locales may insert whitespace
   * between the currency symbol and the number. This method removes those
   * whitespace literals while preserving other literals like parentheses.
   */
  formatWithoutSymbol(toStringify) {
    const parts = this.#formatter.formatToParts(toStringify);
    return parts.filter((part, index2, arr) => {
      if (part.type === "currency") {
        return false;
      }
      if (part.type === "literal" && part.value.trim() === "") {
        return !this.#isPartAdjacentToCurrency(index2, arr);
      }
      return true;
    }).map((p) => p.value).join("").trim();
  }
  validateCharacter(character2) {
    const { validator: validator2 } = this.#regExps;
    return validator2.test(character2);
  }
  /**
   * Converts an amount from minor units (e.g., cents) to major units (e.g., dollars).
   * Uses Intl.NumberFormat to determine the correct decimal places for the currency.
   * Uses big.js for the division and rounds to the currency's decimal precision to
   * avoid floating-point artifacts from plain JS division.
   *
   * Examples:
   * - USD: 1000 cents → 10.00 dollars (2 decimal places)
   * - JPY: 1000 → 1000 yen (0 decimal places)
   * - BHD: 1000 fils → 1.000 dinars (3 decimal places)
   */
  convertFromMinorUnits(amount) {
    if (this.#numberInvalid(amount)) {
      return amount;
    }
    const decimals = this.#formatter.resolvedOptions().maximumFractionDigits ?? 2;
    return new Big(amount).div(Math.pow(10, decimals)).round(decimals).toNumber();
  }
  /**
   * Rounds a number to the decimal precision configured for this formatter's
   * currency (e.g., 2 for USD, 0 for JPY, 3 for BHD).
   *
   * Uses big.js to avoid floating-point arithmetic errors that arise with plain
   * JS rounding (e.g., 0.1 + 0.2 - 0.3 correctly rounds to 0 instead of a
   * near-zero residual).
   *
   * Returns the value unchanged for NaN or Infinity (non-finite inputs cannot
   * be represented by Big and are passed through as-is).
   */
  round(value) {
    if (this.#numberInvalid(value)) {
      return value;
    }
    const decimals = this.#formatter.resolvedOptions().maximumFractionDigits ?? 2;
    return new Big(value).round(decimals).toNumber();
  }
}
const NumberInput = reactExports.memo(
  reactExports.forwardRef(
    ({
      allowNegative,
      decimalScale,
      locale,
      maxLength,
      minimumFractionDigits,
      onBlur,
      onChange,
      onClear,
      trailingZeroDisplay = "stripIfInteger",
      value,
      ...props
    }, ref2) => {
      const parser = reactExports.useMemo(
        () => new UnanetNumberFormatter({
          style: "decimal",
          locale,
          signDisplay: allowNegative ? "negative" : "never",
          minimumFractionDigits,
          maximumFractionDigits: decimalScale ?? minimumFractionDigits,
          trailingZeroDisplay
        }),
        [locale]
      );
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        NumberInputBase,
        {
          ...props,
          locale,
          maxLength,
          onBlur,
          onChange,
          onClear,
          parser,
          ref: ref2,
          stripIfInteger: true,
          value
        }
      );
    }
  )
);
const StartAdornment = reactExports.memo(function StartAdornmentRenderer({
  currencyCode,
  parser,
  showCurrencySymbol
}) {
  const theme = useTheme();
  return currencyCode ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Typography$1,
      {
        style: {
          color: theme.palette.grey[500],
          paddingLeft: "12px"
        },
        children: currencyCode
      }
    ),
    showCurrencySymbol && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Typography$1,
      {
        style: {
          color: theme.palette.grey[500],
          paddingLeft: "12px"
        },
        children: parser.parts.currency
      }
    )
  ] }) : null;
});
reactExports.memo(function CurrencyInputRenderer({
  allowNegative = true,
  currencyCode = "USD",
  locale = "en-US",
  onBlur,
  onChange,
  showCurrencySymbol = false,
  value,
  ...props
}) {
  const parser = reactExports.useMemo(
    () => new UnanetNumberFormatter({
      currency: currencyCode,
      style: "currency",
      locale,
      signDisplay: allowNegative ? "negative" : "never"
    }),
    [allowNegative, currencyCode, locale]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    NumberInputBase,
    {
      ...props,
      locale,
      onBlur,
      onChange,
      parser,
      startAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(
        StartAdornment,
        {
          currencyCode,
          parser,
          showCurrencySymbol
        }
      ),
      value
    }
  );
});
const useDropdown = ({
  addOptions,
  addOptionText,
  allSelectedText,
  error,
  getOptionKey: getOptionKeyProp,
  getOptionLabel: getOptionLabelProp,
  getOptionSupportingLabel: getOptionSupportingLabelProp,
  helperText,
  id,
  label,
  limitTags = DROP_DOWN_MAX_TAGS,
  multiple,
  noOptionsText,
  onBlur: onBlurProp,
  onChange,
  options,
  optionsItemMap,
  placeholder,
  required,
  selectAll,
  selectAllText,
  selectedAtTop,
  showLessText,
  showMoreText,
  value
}) => {
  const { SELECT_ALL_KEY, NO_OPTIONS_KEY, NEW_KEY } = UNANET_DROPDOWN_OPTIONS;
  const _singleValue = !multiple && value ? value : buildOption(optionsItemMap);
  const _multipleValue = multiple && value ? value : [];
  const getOptionLabel = reactExports.useCallback(
    (option) => getOptionLabelProp ? getOptionLabelProp(option) : option ? option[optionsItemMap?.name ?? "name"] : "",
    [getOptionLabelProp, optionsItemMap?.name]
  );
  const getOptionKey = reactExports.useCallback(
    (option) => getOptionKeyProp ? getOptionKeyProp(option) : option ? option[optionsItemMap?.key ?? "key"] : "",
    [getOptionKeyProp, optionsItemMap?.key]
  );
  const getOptionSupportingLabel = reactExports.useCallback(
    (option) => getOptionSupportingLabelProp ? getOptionSupportingLabelProp(option) : option ? option[optionsItemMap?.supportingName ?? "supportingName"] : "",
    [getOptionSupportingLabelProp, optionsItemMap?.supportingName]
  );
  const isSelected = reactExports.useCallback(
    (opt, val) => getOptionKey(opt) === getOptionKey(val),
    [getOptionKey]
  );
  const [_limitTags, setLimitTags] = reactExports.useState(limitTags);
  const [inputValue, setInputValue] = reactExports.useState(
    getOptionLabel(_singleValue) ?? ""
  );
  const tagLimit = multiple && _multipleValue.length > limitTags ? 1 : limitTags;
  const optionsString = options.map(getOptionKey).join("|");
  const singleValueString = getOptionLabel(_singleValue);
  const multipleValueString = _multipleValue.map(getOptionKey).join("|");
  const showPlaceHolder = singleValueString === "" && multipleValueString === "";
  reactExports.useEffect(
    function syncStateAfterValueChange() {
      if (!multiple && singleValueString !== inputValue) {
        setInputValue(singleValueString);
      }
      if (multiple && tagLimit === 1) {
        setLimitTags(tagLimit);
      }
      if (multiple && tagLimit === limitTags && _limitTags !== tagLimit) {
        setLimitTags(limitTags);
      }
    },
    //do not add _limitTags to the dependency array, it will cause double render loops after
    //we call setLimit in each of the above cases. _limitTags will not be stale because we have
    //setLimit tags and tagLimit in the dependency array.
    [multiple, singleValueString, tagLimit, setLimitTags]
  );
  const filter = createFilterOptions();
  const filteredOptions = reactExports.useMemo(
    () => filter(options, {
      inputValue: inputValue === singleValueString ? "" : inputValue,
      getOptionLabel
    }),
    [
      getOptionLabel,
      inputValue,
      singleValueString,
      multipleValueString,
      optionsString
    ]
  );
  const filterOptions = reactExports.useCallback(
    (options2, { inputValue: inputValue2 }) => {
      const hasResults = filteredOptions.length;
      const notFoundOption = addOptions ? buildOption(optionsItemMap, inputValue2, NEW_KEY) : buildOption(optionsItemMap, noOptionsText, NO_OPTIONS_KEY);
      if (!hasResults && !selectedAtTop) {
        return [notFoundOption];
      }
      if (!multiple || !selectAll && !selectedAtTop) {
        return filteredOptions;
      }
      if (selectAll) {
        return [
          buildOption(optionsItemMap, selectAllText, SELECT_ALL_KEY),
          ...filteredOptions
        ];
      }
      const currentSelectedKeys = _multipleValue.map(getOptionKey);
      const cleanedOptions = filteredOptions.filter(
        (o) => !currentSelectedKeys.includes(getOptionKey(o))
      );
      return !hasResults ? [..._multipleValue, notFoundOption] : [..._multipleValue, ...cleanedOptions];
    },
    [
      addOptions,
      optionsItemMap?.key,
      optionsItemMap?.name,
      filteredOptions,
      getOptionKey,
      multipleValueString,
      noOptionsText,
      selectAll,
      selectAllText,
      selectedAtTop
    ]
  );
  const allSelected = reactExports.useMemo(() => {
    if (!selectAll) {
      return false;
    }
    const valueKeys = _multipleValue.map(getOptionKey).filter((key) => key !== SELECT_ALL_KEY);
    const filteredOptionsKeys = filteredOptions.map(getOptionKey);
    if (isEqual(filteredOptions, options)) {
      return xor(valueKeys, filteredOptionsKeys).length === 0;
    }
    return filteredOptionsKeys.every((key) => valueKeys.includes(key));
  }, [filteredOptions, getOptionKey, multipleValueString, options, selectAll]);
  const onBlur = reactExports.useCallback(
    (event2) => {
      setInputValue(singleValueString ?? "");
      setLimitTags(tagLimit);
      if (onBlurProp) {
        onBlurProp(event2);
      }
    },
    [
      multiple,
      multipleValueString,
      limitTags,
      tagLimit,
      setLimitTags,
      setInputValue,
      singleValueString
    ]
  );
  const onShowMoreToggle = reactExports.useCallback(
    (event2) => {
      event2.preventDefault();
      event2.stopPropagation();
      if (_limitTags === tagLimit) {
        setLimitTags(-1);
      } else {
        setLimitTags(tagLimit);
      }
    },
    [_limitTags, limitTags, setLimitTags, tagLimit]
  );
  const onInputChanged = reactExports.useCallback(
    (_event, value2, reason) => {
      if (reason === "reset") {
        return;
      }
      setInputValue(value2);
    },
    [setInputValue]
  );
  const onOptionsChanged = reactExports.useCallback(
    (event2, selectedOptions, reason, modifiedOption) => {
      const hasModifiedOption = !!modifiedOption?.option;
      const modifiedOptionKey = hasModifiedOption ? getOptionKey(modifiedOption.option) : -1;
      if (modifiedOptionKey === NO_OPTIONS_KEY) {
        event2.preventDefault();
        event2.stopPropagation();
        return;
      }
      if (hasModifiedOption && modifiedOptionKey === NEW_KEY) {
        setInputValue(multiple ? "" : getOptionLabel(modifiedOption.option));
        const currentOption = multiple ? selectedOptions : [selectedOptions];
        onChange({
          details: modifiedOption,
          event: event2,
          reason: "createOption",
          value: !multiple ? selectedOptions : null,
          values: currentOption.filter(
            (so2) => getOptionKey(so2) !== getOptionKey(modifiedOption.option)
          )
        });
        return;
      }
      if (modifiedOptionKey === SELECT_ALL_KEY && reason === "selectOption" && !allSelected) {
        onChange({
          details: modifiedOption,
          event: event2,
          reason,
          value: null,
          values: filteredOptions
        });
        return;
      }
      if (modifiedOptionKey === SELECT_ALL_KEY && (reason === "removeOption" || allSelected)) {
        const filteredOptionsKeys = filteredOptions.map(getOptionKey);
        onChange({
          details: modifiedOption,
          event: event2,
          reason,
          value: null,
          values: _multipleValue.filter((mv2) => {
            const optionKey = getOptionKey(mv2);
            return optionKey !== SELECT_ALL_KEY && !filteredOptionsKeys.includes(optionKey);
          })
        });
        return;
      }
      if (!multiple) {
        const singleSelectOption = selectedOptions;
        setInputValue(getOptionLabel(singleSelectOption) ?? "");
      }
      onChange({
        details: modifiedOption,
        event: event2,
        reason,
        value: !multiple ? selectedOptions : null,
        values: multiple ? selectedOptions : []
      });
    },
    [
      allSelected,
      optionsItemMap?.key,
      filteredOptions,
      multiple,
      multipleValueString,
      onChange,
      setLimitTags,
      singleValueString
    ]
  );
  const getLimitTagsText = reactExports.useCallback(
    (more) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      LimitTagsBadge,
      {
        id: `${id}-show-more-badge`,
        more,
        onShowMoreToggle,
        showText: showMoreText
      }
    ),
    [id, showMoreText, onShowMoreToggle]
  );
  const renderInput = reactExports.useCallback(
    (autoCompleteProps) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      Text$1,
      {
        autoCompleteProps,
        error: Boolean(error),
        helperText,
        id: `${id}-dropdown-text-input`,
        label,
        placeholder: showPlaceHolder ? placeholder : "",
        required
      }
    ),
    [error, helperText, id, label, placeholder, required, showPlaceHolder]
  );
  const renderOption = reactExports.useCallback(
    (listElementProps, option, renderOptionState) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      DropdownOption,
      {
        addOptionText,
        allSelected,
        getOptionKey,
        getOptionLabel,
        getOptionSupportingLabel,
        id,
        listElementProps,
        multiple,
        option,
        renderOptionState,
        selectedAtTop,
        selectedCount: _multipleValue.length
      },
      `${id}-${getOptionKey(option)}-option-parent`
    ),
    [
      addOptionText,
      allSelected,
      getOptionKey,
      getOptionLabel,
      getOptionSupportingLabel,
      id,
      multiple,
      selectedAtTop,
      multipleValueString
    ]
  );
  const renderTags = reactExports.useCallback(
    (value2, getTagProps, { focused, limitTags: _limitTags2 = 3 }) => {
      if (allSelected && allSelectedText) {
        return [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Badge,
            {
              clickable: true,
              label: allSelectedText,
              size: "medium",
              variant: "tag"
            },
            "all-selected-badge"
          )
        ];
      }
      const badges = value2.filter((v) => getOptionKey(v) !== SELECT_ALL_KEY).map((option, index2) => {
        const { key, ...props } = getTagProps({ index: index2 });
        const name = getOptionLabel(option);
        return /* @__PURE__ */ reactExports.createElement(
          Badge,
          {
            ...props,
            clickable: true,
            deleteIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(Close, {}),
            key,
            label: name,
            size: "medium",
            variant: "tag"
          }
        );
      });
      if (_limitTags2 === -1 && !focused) {
        badges.push(
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            LimitTagsBadge,
            {
              id: `${id}-show-less-badge`,
              onShowMoreToggle,
              showText: showLessText
            },
            `${id}-show-less-badge`
          )
        );
      }
      return badges;
    },
    [allSelected, optionsItemMap?.key, id, showLessText, onShowMoreToggle]
  );
  return {
    _limitTags,
    disableCloseOnSelect: multiple,
    filterOptions,
    filterSelectedOptions: selectedAtTop,
    getLimitTagsText: multiple ? getLimitTagsText : void 0,
    getOptionKey,
    getOptionLabel,
    inputValue,
    isSelected,
    onBlur,
    onInputChanged,
    onOptionsChanged,
    renderInput,
    renderOption,
    renderTags: multiple ? renderTags : void 0
  };
};
const buildOption = (optionsItemMap, name = "", key = UNANET_DROPDOWN_OPTIONS.UNKNOWN_KEY) => ({
  [optionsItemMap?.name ?? "name"]: name,
  [optionsItemMap?.key ?? "key"]: key
});
const useDropdownStyles = makeStyles()(() => ({
  hideClear: {
    [`& .${autocompleteClasses.clearIndicator}`]: {
      display: "none !important"
    }
  }
}));
const Dropdown_ = ({
  addOptions,
  addOptionText,
  allSelectedText,
  clearIcon,
  error,
  getOptionKey: getOptionKeyProp,
  getOptionLabel: getOptionLabelProp,
  getOptionSupportingLabel,
  helperText,
  hideClearIcon,
  id,
  label,
  limitTags,
  loading,
  multiple,
  noOptionsText,
  onBlur: onBlurProp,
  onChange: onChangeProp,
  options,
  optionsItemMap,
  placeholder,
  required,
  selectAll,
  selectAllText,
  selectedAtTop,
  showLessText,
  showMoreText,
  value,
  ...props
}) => {
  const {
    _limitTags,
    disableCloseOnSelect,
    filterOptions,
    filterSelectedOptions,
    getLimitTagsText,
    getOptionKey,
    getOptionLabel,
    inputValue,
    isSelected,
    onBlur,
    onInputChanged,
    onOptionsChanged,
    renderInput,
    renderOption,
    renderTags
  } = useDropdown({
    addOptions,
    addOptionText,
    allSelectedText,
    error,
    getOptionKey: getOptionKeyProp,
    getOptionLabel: getOptionLabelProp,
    getOptionSupportingLabel,
    helperText,
    id,
    label,
    limitTags,
    multiple,
    noOptionsText,
    onBlur: onBlurProp,
    onChange: onChangeProp,
    options,
    optionsItemMap,
    placeholder,
    required,
    selectAll,
    selectAllText,
    selectedAtTop,
    showLessText,
    showMoreText,
    value
  });
  const fallbackValue = multiple ? [] : null;
  const popupIcon = reactExports.useMemo(
    () => loading ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, { size: 20, sx: { marginRight: "8px" } }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ExpandMore, {}),
    [loading]
  );
  const { classes } = useDropdownStyles();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Autocomplete,
    {
      ...props,
      classes: hideClearIcon ? { hasClearIcon: classes.hideClear } : {},
      clearIcon: hideClearIcon ? null : clearIcon,
      disableCloseOnSelect,
      filterOptions,
      filterSelectedOptions,
      getLimitTagsText,
      getOptionKey,
      getOptionLabel,
      id,
      inputValue,
      isOptionEqualToValue: isSelected,
      limitTags: _limitTags,
      multiple,
      onBlur,
      onChange: onOptionsChanged,
      onInputChange: onInputChanged,
      openOnFocus: true,
      options,
      popupIcon,
      renderInput,
      renderOption,
      renderTags,
      selectOnFocus: true,
      value: value ?? fallbackValue
    }
  );
};
const Dropdown = reactExports.memo(Dropdown_);
const useFooterStyles = makeStyles()((_defaultTheme, theme) => {
  return {
    actions: { justifyContent: "flex-end" },
    buttonContainer: {
      display: "flex",
      flex: 1
    },
    destructive: { justifyContent: "flex-start" },
    root: {
      alignItems: "center",
      background: theme.palette.common?.white ?? "white",
      borderTop: `1px solid ${theme.palette.grey[200]}`,
      bottom: 0,
      display: "flex",
      height: 72,
      padding: "16px 24px",
      position: "sticky"
    }
  };
});
reactExports.memo(function FooterRenderer({
  actions,
  destructive
}) {
  const theme = useTheme();
  const { classes } = useFooterStyles(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classes.root, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${classes.buttonContainer} ${classes.destructive}`, children: destructive }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${classes.buttonContainer} ${classes.actions}`, children: actions })
  ] });
});
const HeaderTitle = reactExports.memo(function HeaderTitleRenderer({
  title,
  buttons,
  badge: badge2,
  description,
  section
}) {
  const theme = useTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { display: "flex", flexDirection: "column", width: "100%", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box,
      {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            Box,
            {
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { color: theme.palette.grey[900], variant: "h1", children: title }),
                !!badge2 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { paddingLeft: "10px" }, children: badge2 })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { display: "flex", justifyContent: "flex-end", children: buttons })
        ]
      }
    ),
    !!description && /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { color: theme.palette.grey[700], variant: "body1", children: description })
  ] });
});
const HeaderContent = reactExports.memo(function HeaderContentRenderer({
  children,
  tabs: tabs2,
  theme
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    !!tabs2 && tabs2,
    !!children && children,
    !tabs2 && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "hr",
      {
        style: {
          width: "100%",
          height: "1px",
          border: 0,
          backgroundColor: theme.palette.grey[200]
        }
      }
    )
  ] });
});
const Toggle = reactExports.memo(
  ({ formControlLabelProps, label, ...props }) => {
    const theme = useTheme();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormControlLabel,
      {
        ...formControlLabelProps,
        control: /* @__PURE__ */ jsxRuntimeExports.jsx(Switch, { ...props, disableRipple: true }),
        label: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Typography$1,
          {
            fontWeight: theme.typography.fontWeightMedium,
            variant: "body2",
            children: label
          }
        )
      }
    );
  }
);
reactExports.memo(function HeaderRenderer({
  badge: badge2,
  breadCrumbs,
  buttons,
  children,
  description,
  onToggleChange,
  section,
  tabs: tabs2,
  title,
  toggleChecked,
  toggleLabel
}) {
  const theme = useTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { display: "flex", flexDirection: "column", width: "100%", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box,
      {
        display: "flex",
        flexDirection: "row",
        justifyContent: toggleChecked !== void 0 ? "space-between" : "flex-start",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: breadCrumbs }),
          toggleChecked !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Toggle,
            {
              checked: toggleChecked,
              id: "header-toggle",
              label: toggleLabel,
              onChange: onToggleChange
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      HeaderTitle,
      {
        badge: badge2,
        buttons,
        description,
        section,
        title
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderContent, { tabs: tabs2, theme, children })
  ] });
});
const useSectionStyles = makeStyles()((_defaultTheme, theme) => {
  return {
    accordionSummary: {
      flexDirection: "row-reverse",
      padding: "0px",
      // the accordion "expand more" icon
      [`&:first-child > :last-child`]: {
        marginRight: "10px"
      }
    }
  };
});
reactExports.memo(function SectionRenderer({
  accordion,
  title,
  buttons,
  children,
  description,
  tabs: tabs2,
  badge: badge2,
  expanded,
  onChange
}) {
  const theme = useTheme();
  const { classes } = useSectionStyles(theme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { display: "flex", flexDirection: "column", width: "100%", children: accordion ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Accordion,
    {
      disableGutters: true,
      elevation: 0,
      expanded,
      onChange,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { display: "flex", flexDirection: "column", width: "100%", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            AccordionSummary,
            {
              className: classes.accordionSummary,
              expandIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(ExpandMore, {}),
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                HeaderTitle,
                {
                  badge: badge2,
                  buttons,
                  description,
                  section: true,
                  title
                }
              )
            }
          ),
          !expanded && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "hr",
            {
              style: {
                width: "100%",
                height: "1px",
                border: 0,
                backgroundColor: theme.palette.grey[200]
              }
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionDetails, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderContent, { tabs: tabs2, theme, children }) })
      ]
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { display: "flex", flexDirection: "column", width: "100%", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      HeaderTitle,
      {
        badge: badge2,
        buttons,
        description,
        section: true,
        title
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderContent, { tabs: tabs2, theme, children })
  ] }) });
});
const useLinkStyles = tss$1.withParams().create(({ theme }) => ({
  link: {
    color: theme.palette.blue["800"],
    textDecorationLine: "underline",
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary["800"],
      textDecorationLine: "none"
    },
    "&[disabled]": {
      color: theme.palette.grey["500"],
      pointerEvents: "none"
    },
    "&:focus": {
      color: theme.palette.blue["900"]
    }
  }
}));
reactExports.forwardRef(
  ({ children, classes, ...props }, ref2) => {
    const theme = useTheme();
    const { classes: linkClasses2, cx: cx2 } = useLinkStyles({ theme });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Link$1,
      {
        ref: ref2,
        ...props,
        classes: { ...classes, root: cx2(linkClasses2.link, classes?.root) },
        children
      }
    );
  }
);
const backgrounds = {
  primary: "#fff"
};
const _mainColors = {
  blue: "#45A6F2",
  disabled: "#667085",
  error: "#D32F2F",
  grey: "#98A2B3",
  info: "#0D2642",
  primary: "#10365A",
  success: "#2DB231",
  warning: "#D25F2A"
};
const unanetThemePalette = {
  blue: {
    25: "#F2FAFF",
    50: "#E4F3FD",
    100: "#BDE1FC",
    200: "#B2DDFF",
    300: "#7AC6FF",
    400: "#4CADF7",
    500: "#45A6F2",
    600: "#308DDB",
    700: "#237FD5",
    800: "#1E6EC3",
    900: "#1350A4",
    contrastText: "#fff",
    main: _mainColors.blue
  },
  error: {
    25: "#F9F2F2",
    50: "#FFEBEE",
    100: "#FFD3D8",
    200: "#F5AAAA",
    300: "#F27D7D",
    400: "#EF5350",
    500: "#F44336",
    600: "#E53935",
    700: "#D32F2F",
    800: "#C62828",
    900: "#A72222",
    light: "#FFD3D8",
    main: _mainColors.error
  },
  grey: {
    25: "#FCFCFD",
    50: "#F9FAFB",
    100: "#F2F4F7",
    200: "#EAECF0",
    300: "#D0D5DD",
    310: "#D0D0CC",
    400: "#98A2B3",
    500: "#667085",
    600: "#475467",
    700: "#344054",
    710: "#333333",
    800: "#1D2939",
    900: "#101828",
    contrastText: "#fff",
    main: _mainColors.grey
  },
  info: {
    main: _mainColors.info
  },
  primary: {
    25: "#F6F9FC",
    50: "#E0E9F1",
    100: "#BCC8D5",
    200: "#92A5B9",
    250: "#6692CD",
    300: "#49688A",
    400: "#1E4972",
    500: "#10365A",
    600: "#0B2F52",
    700: "#143049",
    800: "#092640",
    900: "#061C30",
    main: _mainColors.primary
  },
  success: {
    25: "#F2FAF2",
    50: "#E8F8E8",
    100: "#D1FADF",
    200: "#AAE7A7",
    300: "#7CD67B",
    400: "#5CCC5B",
    500: "#3AC33A",
    600: "#2DB231",
    700: "#1BA424",
    800: "#038015",
    900: "#015A01",
    main: _mainColors.success
  },
  text: {
    disabled: _mainColors.disabled
  },
  warning: {
    25: "#FFFBF4",
    50: "#FDF3E3",
    100: "#FBE0B9",
    200: "#F9CC8D",
    300: "#F6B862",
    400: "#F4A947",
    500: "#F29C38",
    600: "#ED9034",
    700: "#D0762B",
    800: "#B2591E",
    900: "#A64417",
    light: "#FBE0B9",
    main: _mainColors.warning
  }
};
const _titleColorMap = {
  error: (theme) => theme.palette.error[700],
  primary: (theme) => theme.palette.primary[700],
  success: (theme) => theme.palette.success[900],
  warning: (theme) => theme.palette.warning[900]
};
const alert = {
  defaultProps: {
    color: "success",
    variant: "inline"
  },
  styleOverrides: {
    global: ({ ownerState: { color: color2 = "success" }, theme }) => ({
      background: theme.palette[color2][900],
      borderRadius: 0,
      color: theme.palette.common?.white ?? "#fff"
    }),
    globalPrimary: () => ({
      [`.${svgIconClasses.root}`]: {
        transform: "rotate(180deg)"
      }
    }),
    icon: ({ ownerState: { color: color2 = "success", variant }, theme }) => ({
      color: variant === "global" ? theme.palette[color2][900] : theme.palette.common?.white ?? "#fff",
      padding: 0
    }),
    inline: ({ ownerState: { color: color2 = "success" }, theme }) => ({
      background: theme.palette[color2][25],
      border: `1px solid ${theme.palette[color2][300]}`,
      borderRadius: 8,
      color: theme.palette.grey[700],
      [`.${alertTitleClasses.root}`]: {
        color: _titleColorMap[color2](theme) ?? theme.palette.grey[700]
      }
    }),
    inlinePrimary: () => ({
      [`.${svgIconClasses.root}`]: {
        transform: "rotate(180deg)"
      }
    }),
    //Wrapper around the alert content. This includes the title, message, and action buttons
    message: ({ theme }) => ({
      display: "flex",
      flex: 1,
      flexDirection: "column",
      fontWeight: theme.typography.fontWeightRegular,
      padding: 0
    }),
    root: ({ ownerState: { color: color2 = "success", variant }, theme }) => ({
      [`.icon-bubble`]: {
        alignItems: "center",
        backgroundColor: variant === "global" ? theme.palette[color2][100] : theme.palette[color2][600],
        borderRadius: "50%",
        display: "flex",
        height: "32px",
        justifyContent: "center",
        width: "32px"
      },
      [`.${svgIconClasses.root}`]: {
        width: 16
      },
      padding: 16
    }),
    toast: ({ ownerState: { color: color2 = "success" }, theme }) => {
      return {
        background: theme.palette[color2][900],
        borderRadius: 8,
        color: theme.palette.common?.white ?? "#fff",
        [`.${svgIconClasses.root}`]: {
          marginTop: 3,
          width: 20
        }
      };
    },
    toastPrimary: () => ({
      [`.${svgIconClasses.root}`]: {
        transform: "rotate(180deg)"
      }
    })
  }
};
const alertTitle = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.body1,
      fontWeight: theme.typography.fontWeightMedium,
      flex: 1,
      margin: 0,
      marginTop: 3
    })
  }
};
const autocomplete = {
  defaultProps: {
    //per UX guidelines this should always be on
    clearOnEscape: true,
    slotProps: {
      popper: {
        //this makes the dropdown menu render below the blue border;
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 4]
            }
          }
        ]
      }
    },
    //max tags visible per UX
    limitTags: 3
  },
  styleOverrides: {
    endAdornment: {
      right: 5
    },
    hasClearIcon: ({ ownerState }) => ({
      [`& .${autocompleteClasses.inputRoot}`]: {
        paddingRight: ownerState.clearIcon !== null ? 56 : "30px !important"
      }
    }),
    input: { paddingLeft: 3 },
    inputRoot: { paddingLeft: 9 },
    listbox: ({ theme }) => ({
      ".add-option": { color: theme.palette.blue[800] },
      ".option-border": {
        borderBottom: `1px solid ${theme.palette.grey[200]}`
      },
      [`.${autocompleteClasses.noOptions}`]: {
        color: theme.palette.grey[500],
        cursor: "unset"
      },
      [`.${autocompleteClasses.noOptions}.${autocompleteClasses.focused}`]: {
        background: "none"
      },
      //disable the selected styling per UX
      [`.${autocompleteClasses.option}[aria-selected="true"]`]: {
        background: "none"
      },
      [`.${autocompleteClasses.option}[aria-selected="true"] > .unanet-ui-dropdown-option-item-supporting-text`]: {
        color: theme.palette.grey[500]
      },
      //Show the standard hover styling for selected items
      [`.${autocompleteClasses.option}[aria-selected="true"].${autocompleteClasses.focused}`]: {
        background: theme.palette.grey[50]
      }
    }),
    option: ({ theme }) => ({
      display: "flex",
      justifyContent: "space-between",
      ".unanet-ui-dropdown-option-item-supporting-text": {
        color: theme.palette.grey[500],
        display: "flex",
        flex: 1,
        justifyContent: "flex-end",
        marginRight: 5
      },
      //regular option hover styling
      "&:hover": {
        background: theme.palette.grey[50]
      }
    }),
    popupIndicator: ({ theme }) => ({
      color: theme.palette.grey[900]
    }),
    root: ({ theme }) => ({
      pointerEvents: "none",
      [`.${autocompleteClasses.tag}`]: {
        marginLeft: 3
      },
      [`.${formLabelClasses.root}`]: {
        pointerEvents: "auto"
      },
      [`.${formHelperTextClasses.root}`]: {
        pointerEvents: "auto"
      },
      [`.${inputBaseClasses.root}`]: {
        pointerEvents: "auto"
      },
      ".unanet-ui-dropdown-show-more-text": {
        color: theme.palette.blue[800],
        marginLeft: 3
      }
    })
  }
};
const badge = {
  defaultProps: {
    size: "small",
    color: "primary"
  },
  styleOverrides: {
    deleteIcon: ({ ownerState, theme }) => {
      if (ownerState.variant !== "tag") {
        return;
      }
      return {
        color: theme.palette.grey[900],
        height: 16,
        width: 16
      };
    },
    label: ({ ownerState }) => {
      if (!ownerState.label && !!ownerState.icon) {
        return {
          paddingRight: 0
        };
      }
    },
    root: ({ ownerState, theme }) => {
      const { color: color2 = "primary" } = ownerState;
      if (ownerState.variant === "tag") {
        return {
          "&.Mui-focusVisible, &:hover": {
            background: theme.palette.primary[25]
          }
        };
      }
      return {
        backgroundColor: theme.palette[color2][50],
        color: theme.palette[color2][900],
        fontWeight: theme.typography.fontWeightMedium
      };
    }
  },
  variants: [
    {
      props: { variant: "tag" },
      style: ({ theme }) => {
        return {
          ...theme.typography.body2,
          border: `1px solid ${theme.palette.grey[300]}`,
          borderRadius: 6,
          backgroundColor: "white",
          color: theme.palette.grey[700],
          fontWeight: theme.typography.fontWeightMedium,
          height: 24
        };
      }
    }
  ]
};
const button = {
  defaultProps: {
    disableFocusRipple: true,
    variant: "contained",
    color: "primary"
  },
  styleOverrides: {
    //Primary Styles
    contained: ({ ownerState, theme }) => {
      const isError = ownerState.color == "error";
      return {
        backgroundColor: isError ? theme.palette.error[700] : theme.palette.primary[600],
        "&:hover, &:active": {
          backgroundColor: isError ? theme.palette.error[800] : theme.palette.primary[800]
        },
        border: `1px solid ${isError ? theme.palette.error[700] : theme.palette.primary[600]}`
      };
    },
    //Secondary Styles
    outlined: ({ ownerState, theme }) => {
      const isError = ownerState.color == "error";
      const boxShadow = `${alpha("#101828", 0.05)} 0 1px 2px 0px`;
      return {
        background: "#fff",
        borderColor: isError ? theme.palette.error[700] : theme.palette.primary[600],
        color: isError ? theme.palette.error[700] : theme.palette.primary[600],
        [`&.${buttonClasses.disabled}`]: {
          boxShadow,
          borderColor: theme.palette.grey[500]
        },
        "&:hover, &:active": {
          boxShadow,
          backgroundColor: isError ? theme.palette.error[50] : theme.palette.primary[25]
        }
      };
    },
    //Base / Common styles
    root: ({ ownerState, theme }) => {
      const boxShadow = `${alpha("#101828", 0.05)} 0 1px 2px 0px`;
      const isError = ownerState.color == "error";
      const focusShadowHex = isError ? theme.palette.error[100] : `${alpha(theme.palette.blue[700], 0.5)}`;
      const focusBorder = isError ? theme.palette.error[500] : theme.palette.primary[300];
      return {
        borderRadius: 8,
        boxShadow,
        fontSize: theme.typography.body2.fontSize,
        margin: 8,
        maxHeight: 40,
        overflow: "hidden",
        padding: "12px 20px",
        textOverflow: "ellipsis",
        textTransform: "none",
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
          "border-color",
          "background-color",
          "box-shadow",
          "outline"
        ]),
        [`&.${buttonClasses.disabled}`]: {
          backgroundColor: theme.palette.grey[100],
          boxShadow,
          color: theme.palette.grey[500]
        },
        [`&.${buttonClasses.focusVisible}`]: {
          outline: `4px solid ${focusShadowHex}`,
          borderColor: focusBorder
        },
        "&:hover, &:active": {
          boxShadow
        }
      };
    },
    //Tertiary Styles
    text: ({ ownerState, theme }) => {
      const boxShadow = "none";
      const isError = ownerState.color === "error";
      return {
        boxShadow,
        color: isError ? theme.palette.error[700] : theme.palette.blue[800],
        "&:hover, &:active": {
          boxShadow,
          backgroundColor: isError ? theme.palette.error[50] : theme.palette.primary[25],
          color: isError ? theme.palette.error[800] : theme.palette.primary[800]
        },
        [`&.${buttonClasses.disabled}`]: {
          background: "rgba(0,0,0,0)",
          boxShadow
        },
        [`&.${buttonClasses.focusVisible}`]: {
          borderColor: "rgba(0,0,0,0)",
          color: isError ? theme.palette.error[700] : theme.palette.blue[900],
          outline: "none"
        }
      };
    }
  }
};
const buttonGroup = {
  styleOverrides: {
    root: {
      margin: 8
    },
    grouped: {
      margin: 0,
      [`&.${buttonClasses.focusVisible}`]: {
        zIndex: 1
      }
    }
  }
};
const card = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 8,
      boxShadow: "0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)",
      border: `1px solid ${theme.palette.grey[200]}`
    })
  }
};
const cardActions = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderTop: `1px solid ${theme.palette.grey[200]}`,
      padding: "8px 16px"
    })
  }
};
const cardContent = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: "24px"
    })
  }
};
const cardHeader = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
      padding: "16px 24px",
      position: "relative"
    }),
    avatar: () => ({
      width: 40,
      height: 40,
      overflow: "hidden",
      position: "absolute"
    }),
    title: ({ ownerState, theme }) => ({
      ...theme.typography.h4,
      position: "relative",
      left: ownerState.avatar ? 48 : 0
    })
  }
};
const checkbox = {
  styleOverrides: {
    root: ({ theme }) => ({
      border: `1px solid ${theme.palette.grey[500]}`,
      borderRadius: "4px",
      height: "16px",
      minHeight: "16px",
      margin: "0px",
      marginRight: "10px",
      padding: "0px",
      width: "16px",
      minWidth: "16px",
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
        "outline"
      ]),
      "&:active": {
        background: theme.palette.primary[50]
      },
      "&:hover": {
        background: theme.palette.primary[25],
        border: `1px solid ${theme.palette.primary[600]}`
      },
      [`&.${checkboxClasses.disabled}`]: {
        background: `${theme.palette.grey[100]}`,
        border: `1px solid ${theme.palette.grey[300]}`
      },
      "&.Mui-focusVisible": {
        border: `1px solid ${theme.palette.primary[600]}`,
        outline: `4px solid ${alpha(theme.palette.blue[700], 0.5)}}`
      },
      [`&.${checkboxClasses.root}.${checkboxClasses.checked}`]: {
        background: theme.palette.primary[50],
        border: `1px solid ${theme.palette.primary[600]}`
      },
      [`&.${formControlLabelClasses.root}`]: {
        color: theme.palette.grey[700],
        marginLeft: 0,
        marginRight: 0,
        [`&.${formControlLabelClasses.disabled}`]: {
          color: theme.palette.grey[500]
        }
      }
    })
  }
};
const dialog = {
  defaultProps: { fullWidth: true },
  styleOverrides: {
    root: () => {
      return {
        [`.${dialogClasses.paper}`]: {
          borderRadius: 12
        }
      };
    }
  }
};
const dialogActions = {
  styleOverrides: {
    root: () => ({
      padding: "0px 24px 24px"
    })
  }
};
const dialogContent = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.body1,
      color: theme.palette.grey[900],
      paddingBottom: 30,
      paddingLeft: 24,
      paddingRight: 24,
      paddingTop: 15
    })
  }
};
const dialogTitle = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.grey[900],
      flex: 1,
      padding: "0 15px"
    })
  }
};
const divider = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: theme.palette.grey[200],
      //These can safely be removed once we stop injecting MUI5 component in MUI4 with
      //conflicting styles.
      background: "unset",
      height: "unset"
    })
  }
};
const formGroup = {
  styleOverrides: {
    root: () => {
      return {
        [`&.${radioGroupClasses.root}`]: {
          marginLeft: "8px",
          [`& .unanet-ui-radio-button`]: {
            padding: "8px"
          }
        }
      };
    }
  }
};
const formHelperText = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: theme.typography.body2.fontSize,
      marginTop: 5
    })
  }
};
const inputBase = {
  styleOverrides: {
    input: ({ theme }) => ({
      ...theme.typography.body1,
      padding: "8px 12px"
    }),
    root: ({ theme, ownerState }) => {
      const _baseStyles = {
        backgroundColor: theme.backgrounds.primary,
        borderRadius: 8,
        border: `1px solid ${theme.palette.grey[300]}`,
        transition: theme.transitions.create([
          "border-color",
          "background-color",
          "box-shadow"
        ]),
        "label + &": {
          marginTop: 25
        },
        // the below 3 styles remove the up/down arrows for "number" textfields
        "& input[type=number]": {
          MozAppearance: "textfield"
        },
        "& input[type=number]::-webkit-outer-spin-button": {
          WebkitAppearance: "none",
          margin: 0
        },
        "& input[type=number]::-webkit-inner-spin-button": {
          WebkitAppearance: "none",
          margin: 0
        }
        //GG: commenting this out because it breaks TextArea (multiline Text component) scrolling
        // [`& .${inputBaseClasses.input}`]: {
        //   overflow: 'hidden',
        //   textOverflow: 'ellipsis',
        // },
      };
      if (ownerState.focused) {
        return {
          ..._baseStyles,
          boxShadow: ownerState.error ? `${alpha("#FEE4E2", 0.5)} 0 0 0 4px` : `${alpha(theme.palette.blue[700], 0.5)} 0 0 0 4px`,
          borderColor: ownerState.error ? theme.palette.error[500] : theme.palette.primary[300]
        };
      }
      if (ownerState.disabled) {
        return {
          ..._baseStyles,
          backgroundColor: theme.palette.grey[100],
          color: theme.palette.grey[500]
        };
      }
      if (ownerState.error) {
        return {
          ..._baseStyles,
          "&:focus": {
            boxShadow: `${alpha("#FEE4E2", 0.5)} 0 0 0 4px`
          },
          borderColor: theme.palette.error[500]
        };
      }
      return _baseStyles;
    }
  }
};
const inputLabel = {
  styleOverrides: {
    asterisk: ({ theme, ownerState }) => ({
      color: ownerState.formControl.disabled ? alpha("#000", 0) : theme.palette.error[700]
    }),
    root: ({ theme }) => ({
      ...theme.typography.body2,
      color: theme.palette.grey[700],
      fontWeight: theme.typography.fontWeightMedium,
      transform: "none"
    })
  }
};
const list = {
  defaultProps: {
    dense: true
  }
};
const listItemIcon = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.grey[500],
      marginRight: 10,
      minWidth: "unset",
      [`.${svgIconClasses.root}`]: {
        fontSize: theme.typography.h4.fontSize
      }
    })
  }
};
const listSubHeader = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.grey[700],
      display: "flex",
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.fontWeightBold
    })
  }
};
const popover = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        [`.MuiPaper-root`]: {
          color: theme.palette.grey[700]
        },
        [`.MuiPaper-root > li`]: {
          ...theme.typography.body2,
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "10px",
          paddingBottom: "10px",
          minWidth: "80px"
        },
        [`.MuiPaper-root > li:last-child`]: {
          borderBottom: "none"
        }
      };
    }
  }
};
const radio = {
  styleOverrides: {
    root: ({ theme }) => ({
      height: "16px",
      margin: "0px",
      marginRight: "10px",
      padding: "0px",
      width: "16px",
      borderRadius: "100%",
      // need to wrap around this or else entire page background will bleed
      [`&.${radioClasses.root}`]: {
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        "&:hover": {
          background: theme.palette.primary[25],
          color: theme.palette.primary[500]
        },
        "&:active": {
          background: theme.palette.primary[50],
          color: theme.palette.primary[500]
        }
      },
      "&.Mui-focusVisible": {
        outline: `6px solid ${alpha(theme.palette.blue[700], 0.5)}}`
      },
      [`&.${radioClasses.checked}, `]: {
        background: theme.palette.primary[50]
      },
      [`&.${formControlLabelClasses.root}`]: {
        color: theme.palette.grey[700],
        [`&.${formControlLabelClasses.disabled}`]: {
          color: theme.palette.grey[500]
        }
      }
    })
  }
};
const select = {
  defaultProps: { variant: "standard" },
  styleOverrides: {
    root: ({ theme }) => ({
      "&:after, &:before, &:hover:not(.Mui-disabled, .Mui-error):before": {
        border: "none"
      },
      "label + &": {
        marginTop: 25
      },
      color: theme.palette.primary[600],
      "& .MuiSelect-icon": {
        color: theme.palette.primary[600],
        right: 12
      },
      "& .MuiSelect-select": {
        paddingRight: `46px !important`
      }
    })
  }
};
const tabPanel = {
  styleOverrides: {
    root: ({ theme }) => ({
      height: "100%",
      padding: theme.spacing(0)
    })
  }
};
const tabs = {
  styleOverrides: {
    indicator: ({ theme }) => ({
      backgroundColor: theme.palette.primary[700]
    })
  }
};
const toggle = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: 36,
      height: 20,
      padding: 0,
      transition: theme.transitions.create(["outline"]),
      "&:has(.Mui-focusVisible)": {
        outline: `3px solid ${alpha(theme.palette.blue[700], 0.5)}`,
        borderRadius: 26 / 2,
        borderColor: theme.palette.primary[300]
      },
      marginRight: 8
    }),
    switchBase: ({ theme }) => ({
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      [`&.${switchClasses.checked}`]: {
        transform: "translateX(16px)",
        color: theme.palette.common?.white ?? "#fff",
        [`& + .${switchClasses.track}`]: {
          backgroundColor: theme.palette.success[500],
          opacity: 1,
          borders: 0
        },
        [`&.${switchClasses.disabled} + .${switchClasses.track}`]: {
          opacity: 0.5
        },
        [`&:hover + .${switchClasses.track}`]: {
          background: theme.palette.success[700]
        }
      },
      [`&:hover + .${switchClasses.track}`]: {
        background: theme.palette.primary[100]
      },
      [`&.${switchClasses.disabled} + .${switchClasses.thumb}`]: {
        color: theme.palette.grey[100]
      },
      [`&.${switchClasses.disabled} + .${switchClasses.track}`]: {
        background: theme.palette.grey[500]
      }
    }),
    thumb: {
      boxSizing: "border-box",
      width: 16,
      height: 16
    },
    track: ({ theme }) => ({
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.primary[50],
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500
      })
    })
  }
};
const tooltip = {
  styleOverrides: {
    arrow: ({ theme }) => ({
      "&:before": {
        backgroundColor: theme.palette.grey[900]
      }
    }),
    tooltip: ({ theme }) => ({
      backgroundColor: theme.palette.grey[900],
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: 12,
      lineHeight: "18px",
      borderRadius: 8
    })
  }
};
const fontFamily = [
  "Roboto",
  "Arial",
  "Verdana",
  "Helvetica",
  "sans-serif"
].join(",");
const unanetThemeTypography = (palette) => ({
  button: {
    fontSize: 16,
    lineHeight: "24px"
  },
  fontFamily,
  h1: {
    /* Display md/Medium */
    fontFamily,
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "44px",
    letterSpacing: "-0.72px"
  },
  h2: {
    /* Display sm/Medium */
    fontFamily,
    fontSize: "30px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "38px"
  },
  h3: {
    /* Display xs/Medium */
    fontFamily,
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "32px"
  },
  h4: {
    /* Text xl/Medium */
    fontFamily,
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "30px"
  },
  h5: {
    fontFamily,
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px"
  },
  body1: {
    /* Text md/Normal */
    fontFamily,
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px"
  },
  body2: {
    /* Text sm/Normal */
    fontFamily,
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px"
    // needs to be 20
  }
});
const listItemButton = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.body1,
      color: theme.palette.grey[700],
      display: "flex",
      fontWeight: theme.typography.fontWeightMedium,
      height: 40,
      transition: theme.transitions.create(["background-color"]),
      [`.${listItemButtonClasses.selected}`]: {
        backgroundColor: theme.palette.primary[50]
      }
    })
  }
};
const unanetUITheme = createTheme({
  direction: "ltr",
  backgrounds,
  components: {
    MuiAlert: alert,
    MuiAlertTitle: alertTitle,
    MuiAutocomplete: autocomplete,
    MuiButton: button,
    MuiButtonGroup: buttonGroup,
    MuiCard: card,
    MuiCardActions: cardActions,
    MuiCardContent: cardContent,
    MuiCardHeader: cardHeader,
    MuiCheckbox: checkbox,
    MuiChip: badge,
    MuiDialog: dialog,
    MuiDialogActions: dialogActions,
    MuiDialogContent: dialogContent,
    MuiDialogTitle: dialogTitle,
    MuiDivider: divider,
    MuiFormGroup: formGroup,
    MuiFormHelperText: formHelperText,
    MuiInputBase: inputBase,
    MuiInputLabel: inputLabel,
    MuiList: list,
    MuiListItemButton: listItemButton,
    MuiListItemIcon: listItemIcon,
    MuiListSubheader: listSubHeader,
    MuiPopover: popover,
    MuiRadio: radio,
    MuiSelect: select,
    MuiSwitch: toggle,
    MuiTabPanel: tabPanel,
    MuiTabs: tabs,
    MuiTooltip: tooltip
  },
  footer: {
    height: 42
  },
  palette: unanetThemePalette,
  spacing: (a) => `${a}px`,
  typography: unanetThemeTypography()
});
makeStyles()((_defaultTheme, theme) => ({
  page: {
    background: theme.palette.grey[50],
    fontFamily: theme.typography.fontFamily,
    height: `calc(100% - ${theme.footer.height}px)`,
    overflow: "auto",
    width: "100%"
  }
}));
const Typography2 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { ...props });
tss$1.create(() => {
  return {
    hideInput: {
      'input[type="text"]': {
        color: "transparent",
        "-webkit-text-fill-color": "transparent"
      }
    },
    loadingContainer: {
      alignItems: "center",
      display: "flex",
      gap: "8px",
      justifyContent: "center",
      padding: "16px"
    },
    noOptionsContainer: {
      padding: "16px",
      textAlign: "center"
    },
    noOptionsError: {
      alignItems: "center",
      display: "flex",
      gap: "8px",
      justifyContent: "center"
    },
    popupProgress: {
      marginRight: "8px"
    }
  };
});
const defaultState$1 = {
  error: null,
  loading: false,
  preloadedOptions: void 0,
  results: void 0,
  setError: () => {
  },
  setLoading: () => {
  },
  setPreloadedOptions: () => {
  },
  setResults: () => {
  }
};
reactExports.createContext(defaultState$1);
const useSegmentedButtonStyles = makeStyles()((_defaultTheme, theme) => {
  return {
    active: {
      backgroundColor: theme.palette.primary[50]
    }
  };
});
const Button__ = ({
  activeItemKey,
  id,
  index: index2,
  item,
  onItemClicked,
  variant
}) => {
  const theme = useTheme();
  const { classes, cx: cx2 } = useSegmentedButtonStyles(theme);
  const buttonClickHandler = reactExports.useCallback(() => {
    onItemClicked(item);
  }, [item.key, onItemClicked]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button2,
    {
      className: cx2({
        [classes.active]: activeItemKey === item.key
      }),
      disabled: item.disabled,
      disableFocusRipple: true,
      id: `${id}-btn-${index2}`,
      onClick: buttonClickHandler,
      variant,
      children: item.name
    },
    `${item.key}-${index2}`
  );
};
const Button_ = reactExports.memo(Button__);
const SegmentedButton_ = ({
  activeItemKey,
  id,
  items,
  onItemClicked,
  variant = "secondary",
  ...props
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroup, { "data-test": id, id, ...props, children: items.map((item, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button_,
    {
      activeItemKey,
      id: `${id}-btn-${index2}`,
      index: index2,
      item,
      onItemClicked,
      variant
    },
    `${item.key}-${index2}`
  )) });
};
reactExports.memo(function SegmentedButtonRenderer({
  divider: divider2 = false,
  ...props
}) {
  return divider2 ? (
    //aria-hidden because the divider is for styling only:
    //https://mui.com/material-ui/react-divider/#accessibility
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { "aria-hidden": "true", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SegmentedButton_, { ...props }) })
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(SegmentedButton_, { ...props });
});
const useSplitButtonStyles = tss$1.withParams().create(({ theme }) => {
  return {
    buttonGroup: {
      display: "inline-flex",
      alignItems: "stretch",
      gap: 0
    },
    mainButton: {
      "&&": {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        height: 40,
        minHeight: 40,
        margin: 0,
        boxShadow: "none"
      },
      "&:hover": {
        boxShadow: "none"
      }
    },
    mainButtonPrimary: {},
    mainButtonSecondary: {
      borderRight: "none"
    },
    dropdownToggle: {
      "&&": {
        borderRadius: "0 8px 8px 0",
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        minWidth: 40,
        width: 40,
        height: 40,
        padding: 0,
        margin: 0
      }
    },
    dropdownTogglePrimary: {
      backgroundColor: theme.palette.primary[600],
      borderLeft: `1px solid ${theme.palette.common.white}`,
      color: theme.palette.common.white,
      "&:hover": {
        backgroundColor: theme.palette.primary[800]
      },
      "&.Mui-disabled": {
        backgroundColor: theme.palette.grey[200],
        color: theme.palette.grey[400]
      }
    },
    dropdownToggleSecondary: {
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.primary[600]}`,
      borderLeft: `1px solid ${theme.palette.primary[700]}`,
      color: theme.palette.primary[800],
      "&:hover": {
        backgroundColor: theme.palette.primary[25]
      },
      "&.Mui-disabled": {
        backgroundColor: theme.palette.grey[50],
        borderColor: theme.palette.grey[300],
        color: theme.palette.grey[400]
      }
    },
    popoverPaper: {
      borderRadius: 8,
      border: `1px solid ${theme.palette.grey[200]}`,
      boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
      "& .MuiList-root": {
        padding: 0
      }
    },
    menuItem: {
      padding: "8px 12px",
      fontSize: 16,
      color: theme.palette.grey[900]
    },
    menuItemIcon: {
      "&&": {
        minWidth: "auto",
        marginRight: 8
      },
      "& svg": {
        width: 20,
        height: 20
      }
    }
  };
});
const _popoverAnchorOrigin = {
  vertical: "bottom",
  horizontal: "right"
};
const _popoverTransformOrigin = {
  vertical: "top",
  horizontal: "right"
};
reactExports.memo(function SplitButtonRenderer({
  disabled,
  id,
  label,
  menuItems,
  onClick,
  onClose,
  onOpen,
  open: open2,
  variant = "primary",
  ...props
}) {
  const theme = useTheme();
  const anchorRef = reactExports.useRef(null);
  const [anchorEl, setAnchorEl] = reactExports.useState(null);
  const [minMenuWidth, setMinMenuWidth] = reactExports.useState(
    void 0
  );
  const { classes, cx: cx2 } = useSplitButtonStyles({ theme });
  const toggleClickHandler = reactExports.useCallback(
    (e) => {
      e.stopPropagation();
      if (open2) {
        onClose();
      } else {
        setAnchorEl(anchorRef.current);
        setMinMenuWidth(anchorRef.current?.offsetWidth);
        onOpen();
      }
    },
    [onClose, onOpen, open2]
  );
  const mainClickHandler = reactExports.useCallback(
    (e) => {
      onClick?.();
    },
    [onClick]
  );
  const handleMenuItemClick = reactExports.useCallback(
    (item) => () => {
      item.onClick?.();
      onClose();
    },
    [onClose]
  );
  const isPrimary = variant === "primary";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box,
      {
        "aria-label": "split button",
        className: classes.buttonGroup,
        "data-test": id,
        id,
        ref: anchorRef,
        ...props,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button2,
            {
              className: cx2(classes.mainButton, {
                [classes.mainButtonPrimary]: isPrimary,
                [classes.mainButtonSecondary]: !isPrimary
              }),
              disabled,
              id: `${id}-main`,
              onClick: mainClickHandler,
              variant,
              children: label
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button2,
            {
              "aria-controls": open2 ? `${id}-menu` : void 0,
              "aria-expanded": open2,
              "aria-haspopup": "menu",
              "aria-label": "open menu",
              className: cx2(classes.dropdownToggle, {
                [classes.dropdownTogglePrimary]: isPrimary,
                [classes.dropdownToggleSecondary]: !isPrimary
              }),
              disabled,
              iconOnly: true,
              id: `${id}-toggle`,
              onClick: toggleClickHandler,
              startIcon: open2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(ExpandLess, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(ExpandMore, {}),
              variant
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Menu$1,
      {
        anchorEl,
        anchorOrigin: _popoverAnchorOrigin,
        id: `${id}-menu`,
        onClose,
        open: open2,
        slotProps: {
          paper: {
            className: classes.popoverPaper,
            sx: { minWidth: minMenuWidth }
          }
        },
        transformOrigin: _popoverTransformOrigin,
        children: menuItems.map((item) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
          MenuItem$1,
          {
            className: classes.menuItem,
            disabled: item.disabled,
            onClick: handleMenuItemClick(item),
            tabIndex: 0,
            children: [
              item.icon && /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, { className: classes.menuItemIcon, children: item.icon }),
              item.label
            ]
          },
          item.id
        ))
      }
    )
  ] });
});
const useTabStyles = makeStyles()((_defaultTheme, theme) => {
  return {
    root: {
      // styling when tab is not selected:
      color: theme.palette.grey[900],
      fontSize: theme.typography.body1.fontSize,
      borderBottom: `2px solid rgba(0,0,0,0)`,
      transition: theme.transitions.create(["border-bottom"]),
      // styling when tab is selected:
      "&.Mui-selected": {
        color: theme.palette.primary[700],
        borderBottom: `2px solid ${theme.palette.primary[700]}`
      },
      // styling when in focus
      "&.Mui-focusVisible": {
        color: theme.palette.blue[800],
        "&.Mui-selected": {
          borderBottom: `2px solid ${theme.palette.blue[800]}`
        },
        "&:hover": {
          borderBottom: `2px solid ${theme.palette.primary[700]}`
        }
      },
      // styling when hovered
      "&:hover": {
        color: theme.palette.primary[700],
        borderBottom: `2px solid ${theme.palette.primary[700]}`
      },
      // badge styling when tab is selected:
      "&.Mui-selected .MuiBadge-badge": {
        backgroundColor: theme.palette.primary[50],
        color: theme.palette.primary[900]
      },
      // badge styling when tab is not selected:
      "& .MuiBadge-badge": {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[900]
      },
      // badge styling when tab is disabled (not specified in NDS as of 2023-10-05):
      "&.Mui-disabled .MuiBadge-badge": {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[400]
      },
      textTransform: "none"
    }
  };
});
const LabelWithBadge = ({ badgeCount, label }) => {
  const theme2 = useTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { display: "flex", gap: "7px", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: label }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Badge,
      {
        "aria-label": badgeCount.toString(),
        label: badgeCount > 99 ? "99+" : badgeCount,
        size: "small",
        sx: {
          background: theme2.palette.primary[50],
          color: theme2.palette.primary[900]
        }
      }
    )
  ] });
};
const Tab2 = ({
  label,
  showBadge,
  badgeCount,
  badgeCountMax = 99,
  ...otherProps
}) => {
  const { classes } = useTabStyles(unanetUITheme);
  const fullLabel = showBadge && badgeCount !== void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    LabelWithBadge,
    {
      badgeCount,
      badgeCountMax,
      label
    }
  ) : label;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tab$1,
    {
      classes: { root: classes.root },
      disableFocusRipple: true,
      label: fullLabel,
      role: "tab",
      ...otherProps
    }
  );
};
const TabContext = (props) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TabContext$1, { ...props });
};
const TabList_ = ({ classes, ...props }) => {
  const { css: css2 } = useStyles(unanetUITheme);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TabList$1,
    {
      classes: {
        indicator: css2({
          display: "none"
        }),
        ...classes
      },
      role: "tablist",
      ...props
    }
  );
};
const TabList2 = ({ variant, ...props }) => {
  return variant === "scrollable" ? /* @__PURE__ */ jsxRuntimeExports.jsx(TabList_, { variant, ...props }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { borderBottom: 1, borderColor: unanetUITheme.palette.grey[200] }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(TabList_, { variant, ...props }) });
};
var UnanetTableColumnType = /* @__PURE__ */ ((UnanetTableColumnType2) => {
  UnanetTableColumnType2["ACTION"] = "action";
  UnanetTableColumnType2["CUSTOM"] = "custom";
  UnanetTableColumnType2["DATE"] = "date";
  UnanetTableColumnType2["DISPLAY"] = "display";
  UnanetTableColumnType2["DROPDOWN"] = "drop-down";
  UnanetTableColumnType2["NUMBER"] = "number";
  UnanetTableColumnType2["SELECTION"] = "selection";
  UnanetTableColumnType2["TEXT"] = "text";
  return UnanetTableColumnType2;
})(UnanetTableColumnType || {});
var UnanetTableDensity = /* @__PURE__ */ ((UnanetTableDensity2) => {
  UnanetTableDensity2["SMALL"] = "sm";
  UnanetTableDensity2["MEDIUM"] = "md";
  UnanetTableDensity2["LARGE"] = "lg";
  return UnanetTableDensity2;
})(UnanetTableDensity || {});
var UnanetTableCellStatus = /* @__PURE__ */ ((UnanetTableCellStatus2) => {
  UnanetTableCellStatus2["AUTOFILLED"] = "auto-filled";
  UnanetTableCellStatus2["LOADING"] = "loading";
  UnanetTableCellStatus2["STANDARD"] = "standard";
  return UnanetTableCellStatus2;
})(UnanetTableCellStatus || {});
tss$1.withParams().create(({ theme, totalWidthLessThanClientWidth }) => {
  return {
    table: {
      borderCollapse: "collapse",
      borderSpacing: 0,
      border: "none",
      display: "grid",
      minHeight: 100,
      overflow: "auto",
      overflowX: totalWidthLessThanClientWidth ? "hidden" : "auto"
    },
    wrapper: {
      background: theme.palette.common?.white,
      border: `1px solid ${theme.palette.grey[200]}`,
      borderRadius: "8px",
      //1A is 10% opacity in Hexadecimal color code
      boxShadow: `0px 1px 3px 0px ${theme.palette.grey[900]}1A`,
      overflow: "hidden",
      position: "relative",
      width: "100%"
    },
    subheader: {
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
      display: "flex",
      padding: "16px 24px",
      position: "relative"
    }
  };
});
makeStyles()(
  (_defaultTheme, theme) => ({
    autofill: {
      backgroundColor: theme.palette.success[25]
    },
    autofillIcon: {
      height: 18,
      position: "absolute",
      right: 2,
      top: 2,
      width: 18
    },
    base: _base$1(theme),
    cell: {
      ..._base$1(theme),
      "&:hover, &:focus": {
        ..._inputVisible$1(theme)
      }
    },
    disabled: {
      // ...disabledRowCell(theme),
      ..._inputVisible$1(theme)
    },
    innerWrapper: {
      alignItems: "center",
      display: "flex",
      height: "100%",
      justifyContent: "center",
      padding: "8px 16px",
      position: "relative",
      width: "100%"
    },
    input: {
      "& .MuiAutocomplete-inputRoot, & .MuiInputBase-root, & .MuiOutlinedInput-root": {
        backgroundColor: "rgba(0,0,0,0)"
      }
    },
    leftPin: {
      borderRight: `1px solid ${theme.palette.grey[200]}`,
      boxShadow: "rgba(0,0,0,.25) 1px 0px 4px 1px",
      clipPath: "inset(1px -4px 0 0)",
      position: "sticky",
      zIndex: 1
    },
    rightPin: {
      borderLeft: `1px solid ${theme.palette.grey[200]}`,
      boxShadow: "rgba(0,0,0,.25) -1px 0px 4px 1px",
      clipPath: "inset(1px 0 0 -4px)",
      position: "sticky"
    },
    // last: lastItem(theme),
    // pinned: pinnedItem(),
    // standard: standardRow(),
    // tito: titoRow(),
    unselectedProject: {
      "& .MuiAutocomplete-inputRoot": { borderColor: theme.palette.grey[200] },
      "& .MuiAutocomplete-popupIndicator": {
        opacity: 1
      }
    }
  })
);
const _base$1 = (theme) => ({
  alignItems: "center",
  background: "white",
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  display: "flex",
  fontSize: 16,
  height: "100%",
  padding: 0,
  position: "absolute",
  "& .MuiIconButton-root": {
    opacity: 0
  },
  "& .MuiFormHelperText-root": {
    display: "none !important"
  },
  "& .MuiAutocomplete-inputRoot, & .MuiInputBase-root, & .MuiInputBase-input": {
    transition: theme.transitions.create(["border-color", "padding-left"], {
      duration: 150
    }),
    borderColor: "rgba(0,0,0,0)",
    paddingRight: "0px",
    paddingLeft: "0px !important"
  }
});
const _inputVisible$1 = (theme) => ({
  "& .MuiAutocomplete-inputRoot, & .MuiInputBase-root, & .MuiInputBase-input": {
    borderColor: theme.palette.grey[200],
    paddingRight: "20px",
    paddingLeft: "9px !important"
  },
  "& .MuiIconButton-root": {
    opacity: 1
  }
});
tss$1.withParams().create(({ height: height2, theme, width: width2 }) => ({
  body: {
    display: "grid",
    height: height2 - 56 - 68,
    position: "relative",
    transition: "height 0.2s",
    width: width2
  },
  cell: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    height: "100%",
    padding: "16px 20px",
    position: "absolute",
    verticalAlign: "middle"
  },
  row: {
    position: "absolute"
  },
  cellStriped: {
    backgroundColor: theme.palette.grey[50]
  },
  skeleton: { borderRadius: "4px" }
}));
const getPinnedColumnLeft = ({
  containerWidth,
  isPinnedLeftAction,
  isPinnedRightAction,
  size,
  start: start2
}) => {
  if (isPinnedRightAction) {
    return containerWidth - size;
  }
  if (isPinnedLeftAction) {
    return 0;
  }
  return start2;
};
const isLoadingCell = (cellValue) => {
  if (_isNotCellValueObject(cellValue)) {
    return false;
  }
  const cell = cellValue;
  return cell.status === UnanetTableCellStatus.LOADING;
};
const extractCellValue = (cellValue) => {
  if (_isNotCellValueObject(cellValue)) {
    return cellValue;
  }
  const cell = cellValue;
  const hasStatus = "status" in cell;
  const hasValue2 = "value" in cell;
  const isCellValueWrapper = hasStatus || hasValue2;
  if (isCellValueWrapper) {
    return cell.value;
  }
  return cellValue;
};
const _areCellPropsEqual = (prevProps, nextProps) => {
  if (prevProps.id !== nextProps.id) {
    return false;
  }
  const prevLoading = isLoadingCell(prevProps.value);
  const nextLoading = isLoadingCell(nextProps.value);
  if (prevLoading !== nextLoading) {
    return false;
  }
  return extractCellValue(prevProps.value) === extractCellValue(nextProps.value);
};
const _isNotCellValueObject = (value) => {
  const isNullish = value === null || value === void 0;
  const isNotObject = typeof value !== "object";
  return isNullish || isNotObject;
};
const _nodeHandlers = [
  {
    check: (node2) => node2 == null || typeof node2 === "boolean",
    handle: () => ""
  },
  {
    check: (node2) => typeof node2 === "string",
    handle: (node2) => node2
  },
  {
    check: (node2) => typeof node2 === "number",
    handle: (node2) => String(node2)
  },
  {
    check: (node2) => Array.isArray(node2),
    handle: (node2) => node2.map(extractTextFromReactNode).filter(Boolean).join("")
  },
  {
    check: (node2) => typeof node2 === "object" && node2 !== null && "props" in node2 && node2.props && typeof node2.props === "object" && "children" in node2.props,
    handle: (node2) => extractTextFromReactNode(node2.props.children)
  }
];
const extractTextFromReactNode = (node2) => {
  const handler = _nodeHandlers.find((h12) => h12.check(node2));
  return handler ? handler.handle(node2) : "";
};
tss$1.withParams().create(({ height: height2, theme, width: width2 }) => ({
  body: {
    display: "grid",
    height: height2 - 56 - 68,
    position: "relative",
    width: width2,
    transition: "height 0.2s"
  },
  hoverRow: {
    left: 0,
    position: "sticky",
    zIndex: 1,
    opacity: 0,
    "&:hover, &:focus": {
      opacity: 1,
      "& ~ td": {
        background: `${theme.palette.primary[25]} !important`
      }
    },
    transition: theme.transitions.create(["background", "opacity"], {
      duration: 150
    })
  },
  row: {
    display: "flex",
    position: "absolute",
    transition: "transform 0.2s",
    width: "100%",
    "&:hover, &:focus": {
      backgroundColor: theme.palette.primary[25]
    }
  }
}));
const ActionCell_ = ({
  cell
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: cell.column.columnDef.cell && flexRender(cell.column.columnDef.cell, cell.getContext()) });
reactExports.memo(ActionCell_);
const DatePickerCell_ = ({
  cell,
  id,
  value
}) => {
  const handleChange = reactExports.useCallback(
    (date, context2) => {
      cell.onCellChange({
        cell,
        event: { context: context2, date }
      });
    },
    [cell.id]
  );
  if (isLoadingCell(value)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { flex: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { animation: "wave", variant: "text" }) });
  }
  const dateValue = extractCellValue(value);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DatePicker2,
    {
      calendarSelectTodayButtonLabel: "Select today",
      disablePortal: false,
      id,
      locale: "US-en",
      monthYearPickerCancelButtonLabel: "cancel",
      monthYearPickerSelectButtonLabel: "select",
      onChange: handleChange,
      sx: {
        width: "100%"
      },
      value: dateValue
    }
  );
};
reactExports.memo(DatePickerCell_, (prevProps, nextProps) => {
  const prevLoading = isLoadingCell(prevProps.value);
  const nextLoading = isLoadingCell(nextProps.value);
  if (prevLoading !== nextLoading) {
    return false;
  }
  const prevValue = extractCellValue(prevProps.value);
  const nextValue = extractCellValue(nextProps.value);
  return prevValue?.toMillis() === nextValue?.toMillis() && prevProps.id === nextProps.id;
});
const DropdownCell_ = ({
  cell,
  className,
  id,
  value
}) => {
  const handleBlur = reactExports.useCallback(
    (event2) => cell.onCellBlur({ cell, event: event2 }),
    [cell.id]
  );
  const handleChange = reactExports.useCallback(
    (event2) => cell.onCellChange({ cell, event: event2 }),
    [cell.id]
  );
  if (isLoadingCell(value)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { flex: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { animation: "wave", variant: "text" }) });
  }
  const dropdownValue = extractCellValue(value);
  const options = cell.getColumnDropdownOptions();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { flex: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Dropdown,
    {
      className,
      fullWidth: true,
      id,
      onBlur: handleBlur,
      onChange: handleChange,
      options,
      value: dropdownValue
    }
  ) });
};
reactExports.memo(
  DropdownCell_,
  _areCellPropsEqual
);
const ExpandCell_ = ({
  row,
  isExpanded
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: row.getCanExpand() ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    IconButton,
    {
      color: "primary",
      onClick: row.getToggleExpandedHandler(),
      style: { opacity: 1 },
      children: isExpanded ? /* @__PURE__ */ jsxRuntimeExports.jsx(ExpandLess, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(ExpandMore, {})
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { width: 40 } }) });
};
reactExports.memo(ExpandCell_);
const NumberCell_ = ({
  cell,
  className,
  id,
  value
}) => {
  const handleBlur = reactExports.useCallback(
    (event2) => cell.onCellBlur({ cell, event: event2 }),
    [cell]
  );
  const handleChange = reactExports.useCallback(
    (event2) => cell.onCellChange({ cell, event: event2 }),
    [cell]
  );
  if (isLoadingCell(value)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { flex: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { animation: "wave", variant: "text" }) });
  }
  const numberValue = extractCellValue(value);
  const stringValue = numberValue != null ? String(numberValue) : "";
  const settings = cell.column.getNumberSettings();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { flex: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    NumberInput,
    {
      allowNegative: settings.allowNegative,
      className,
      decimalScale: settings.decimalScale,
      id,
      maxLength: settings.maxLength,
      minimumFractionDigits: settings.minimumFractionDigits,
      onBlur: handleBlur,
      onChange: handleChange,
      trailingZeroDisplay: settings.trailingZeroDisplay,
      value: stringValue
    }
  ) });
};
reactExports.memo(
  NumberCell_,
  _areCellPropsEqual
);
const TextCell_ = ({
  cell,
  className,
  id,
  value
}) => {
  const handleBlur = reactExports.useCallback(
    (event2) => cell.onCellBlur({ cell, event: event2 }),
    [cell.id]
  );
  const handleChange = reactExports.useCallback(
    (event2) => cell.onCellChange({ cell, event: event2 }),
    [cell.id]
  );
  if (isLoadingCell(value)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { flex: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { animation: "wave", variant: "text" }) });
  }
  const textValue = extractCellValue(value) ?? "";
  const settings = cell.column.getTextSettings();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { flex: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text$1,
    {
      characterLimit: settings.characterLimit,
      className,
      id,
      onBlur: handleBlur,
      onChange: handleChange,
      value: textValue
    }
  ) });
};
reactExports.memo(TextCell_, _areCellPropsEqual);
const Tooltip2 = reactExports.memo((props) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { ...props });
});
const useStyles$5 = tss$1.create({
  wrapper: {
    display: "flex",
    flex: 1,
    minWidth: 0,
    overflow: "hidden"
  }
});
const getTooltipContent = ({
  cellValue,
  children,
  row,
  tooltipContentFn
}) => {
  if (tooltipContentFn) {
    return tooltipContentFn(row) ?? "";
  }
  if (cellValue !== void 0 && cellValue !== null) {
    if (typeof cellValue === "string" || typeof cellValue === "number") {
      return String(cellValue);
    }
  }
  return extractTextFromReactNode(children);
};
const TruncatedTableCellInner = ({
  cellId,
  cellValue,
  children,
  row,
  tooltipContent: tooltipContentFn
}) => {
  const { classes } = useStyles$5();
  const ref2 = reactExports.useRef(null);
  const [isTruncated, setIsTruncated] = reactExports.useState(false);
  const handleMouseEnter = reactExports.useCallback(() => {
    const element = ref2.current;
    if (!element) {
      return;
    }
    const isElementTruncated = element.scrollWidth > element.clientWidth;
    const firstChild = element.firstElementChild;
    const isChildTruncated = firstChild ? firstChild.scrollWidth > firstChild.clientWidth : false;
    setIsTruncated(isElementTruncated || isChildTruncated);
  }, []);
  const tooltipText = getTooltipContent({
    cellValue,
    children,
    row,
    tooltipContentFn
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip2, { id: cellId, title: isTruncated ? tooltipText : "", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      className: classes.wrapper,
      onMouseEnter: handleMouseEnter,
      ref: ref2,
      children
    }
  ) });
};
const arePropsEqual = (prev2, next2) => {
  if (prev2.cellId !== next2.cellId) {
    return false;
  }
  if (prev2.cellValue !== next2.cellValue) {
    return false;
  }
  if (prev2.tooltipContent !== next2.tooltipContent) {
    return false;
  }
  return true;
};
const TruncatedTableCell = reactExports.memo(
  TruncatedTableCellInner,
  arePropsEqual
);
const DisplayCell_ = ({
  cell,
  id,
  value
}) => {
  const tooltip2 = cell.column.columnDef.meta?.unanetTable?.tooltip;
  const tooltipContent = cell.column.columnDef.meta?.unanetTable?.tooltipContent;
  const { row } = cell.getContext();
  const content = /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      id,
      style: {
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      },
      children: {
        currency: /* @__PURE__ */ jsxRuntimeExports.jsx(CurrencyDisplay_, { cell, value }),
        default: /* @__PURE__ */ jsxRuntimeExports.jsx(DefaultDisplay_, { cell, value }),
        number: /* @__PURE__ */ jsxRuntimeExports.jsx(NumberDisplay_, { cell, value })
      }[cell.column.columnDef.meta?.unanetTable?.display?.format ?? "default"]
    }
  );
  if (tooltip2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      TruncatedTableCell,
      {
        cellId: id,
        cellValue: value,
        row: row.original,
        tooltipContent,
        children: content
      }
    );
  }
  return content;
};
const NumberDisplay_ = ({
  cell,
  value
}) => {
  if (isLoadingCell(value)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { display: "flex", justifyContent: "flex-end", flex: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { animation: "wave", variant: "text", width: 60 }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { display: "flex", justifyContent: "flex-end" }, children: flexRender(cell.column.columnDef.cell, cell.getContext()) });
};
const DefaultDisplay_ = ({
  cell,
  value
}) => {
  if (isLoadingCell(value)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { animation: "wave", variant: "text" });
  }
  return flexRender(cell.column.columnDef.cell, cell.getContext());
};
const CurrencyDisplay_ = ({
  cell,
  value
}) => {
  const theme = useTheme();
  if (isLoadingCell(value)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { display: "flex", justifyContent: "flex-end", flex: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { animation: "wave", variant: "text", width: 80 }) });
  }
  const { currencyCode: currency, locale } = cell.column.getFormatSettings();
  const formatter = new UnanetNumberFormatter({
    currency,
    locale,
    signDisplay: "never",
    style: "currency"
  });
  const numericValue = Number(extractCellValue(value) ?? 0);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { style: { display: "flex", justifyContent: "space-between" }, children: [
    numericValue >= 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { color: theme.palette.text.disabled }, children: currency }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: formatter.formatWithoutSymbol(numericValue) })
    ] }),
    numericValue < 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { color: theme.palette.text.disabled }, children: currency }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "span",
        {
          style: { color: theme.palette.error.main },
          children: `(${formatter.formatWithoutSymbol(numericValue)})`
        }
      )
    ] })
  ] });
};
reactExports.memo(
  DisplayCell_,
  _areCellPropsEqual
);
tss$1.withParams().create(({ height: height2, theme }) => ({
  header: {
    backgroundColor: theme.palette.grey[100],
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    height: `${height2}px`,
    transition: "height 0.2s",
    position: "sticky",
    top: 0,
    zIndex: 2
  },
  row: {
    display: "flex",
    width: "100%"
  }
}));
const useCellStyles = tss$1.withParams().create(({ isCurrencyColumn, theme }) => ({
  cell: {
    alignItems: "center",
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.grey[700],
    display: "grid",
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    height: 56,
    lineHeight: theme.typography.body2.lineHeight,
    padding: "8px 16px",
    position: "absolute",
    transition: theme.transitions.create(["background", "opacity"], {
      duration: 200
    }),
    "&:hover, &:focus": {
      background: theme.palette.primary[25],
      "& > .testing": {
        opacity: 1
      }
    }
  },
  innerWrapper: {
    display: "flex",
    justifyContent: isCurrencyColumn ? "flex-end" : "flex-start"
  },
  leftPin: {
    borderRight: `1px solid ${theme.palette.grey[200]}`,
    boxShadow: "rgba(0,0,0,.25) 1px 0px 4px 1px",
    clipPath: "inset(1px -4px 0 0)",
    position: "sticky",
    zIndex: 1
  },
  rightPin: {
    borderLeft: `1px solid ${theme.palette.grey[200]}`,
    boxShadow: "rgba(0,0,0,.25) -1px 0px 4px 1px",
    clipPath: "inset(1px 0 0 -4px)",
    position: "sticky"
  },
  sorting: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-end",
    paddingLeft: "8px"
  }
}));
const TableHeaderCell_ = ({
  canSort,
  containerWidth,
  header: { column: column2, id, getContext: getContext2 },
  sorted,
  virtualColumn
}) => {
  const theme = useTheme();
  const isCurrencyColumn = column2.getIsCurrencyDisplay();
  const isPinnedLeftAction = column2.getIsActionPinned() && column2.getIsLeftAction();
  const isPinnedRightAction = column2.getIsActionPinned() && column2.getIsRightAction();
  const cellLeft = getPinnedColumnLeft({
    containerWidth,
    isPinnedLeftAction,
    isPinnedRightAction,
    size: virtualColumn.size,
    start: virtualColumn.start
  });
  const { classes, cx: cx2 } = useCellStyles({
    isCurrencyColumn,
    theme
  });
  const headerClassName = column2.columnDef.meta?.unanetTable?.headerClassName;
  const headerStyle = column2.columnDef.meta?.unanetTable?.headerStyle;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "th",
    {
      className: cx2({
        [classes.cell]: true,
        [classes.leftPin]: isPinnedLeftAction,
        [classes.rightPin]: isPinnedRightAction,
        ...headerClassName ? { [headerClassName]: true } : {}
      }),
      style: {
        ...headerStyle,
        // Layout-critical properties always win to prevent misalignment
        left: cellLeft,
        width: virtualColumn.size
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          className: classes.innerWrapper,
          onClick: canSort ? column2.getToggleSortingHandler() : void 0,
          style: { cursor: canSort ? "pointer" : "default" },
          children: [
            flexRender(column2.columnDef.header, getContext2()),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classes.sorting, children: {
              asc: /* @__PURE__ */ jsxRuntimeExports.jsx(UpArrowIcon, { sx: { height: "14px", width: "14px" } }),
              desc: /* @__PURE__ */ jsxRuntimeExports.jsx(DownArrowIcon, { sx: { height: "14px", width: "14px" } })
            }[sorted.toString()] ?? null })
          ]
        }
      )
    },
    id
  );
};
const tableHeaderCellPropsAreEqual = (prevProps, nextProps) => {
  if (nextProps.isSelectionColumn) {
    return false;
  }
  return prevProps.canSort === nextProps.canSort && prevProps.containerWidth === nextProps.containerWidth && prevProps.sorted === nextProps.sorted && prevProps.virtualColumn === nextProps.virtualColumn && prevProps.header === nextProps.header;
};
reactExports.memo(
  TableHeaderCell_,
  tableHeaderCellPropsAreEqual
);
tss$1.withParams().create(({ theme }) => ({
  wrapper: {
    background: theme.palette.common?.white ?? "white",
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    bottom: 1,
    height: 68,
    position: "sticky"
  },
  fetchingWrapper: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: 4
  },
  innerWrapper: {
    display: "flex",
    padding: "12px 24px",
    width: "100%",
    height: 68,
    alignItems: "center"
  },
  pagingInfo: {
    color: theme.palette.grey[900],
    fontWeight: theme.typography.fontWeightMedium,
    marginRight: 24
  },
  pagingControls: {
    color: theme.palette.grey[900],
    fontWeight: theme.typography.fontWeightMedium,
    marginLeft: 8
  },
  pagingInfoWrapper: {
    alignItems: "center",
    display: "flex",
    height: 40
  },
  pagingControlsWrapper: {
    alignItems: "center",
    display: "flex",
    flex: 1,
    height: 40,
    justifyContent: "flex-end"
  },
  pagingSelect: {
    border: `1px solid ${theme.palette.primary[600]}`,
    height: 40,
    "& ~ .MuiFormHelperText-root": { display: "none" }
  }
}));
const isMenuOpen = (state) => !!state && state[0] === "o";
const batchedUpdates = reactDomExports.unstable_batchedUpdates;
const getTransition = (transition, name) => transition === true || !!(transition && transition[name]);
const safeCall = (fn3, arg2) => typeof fn3 === "function" ? fn3(arg2) : fn3;
const internalKey = "_szhsinMenu";
const getName = (component) => component[internalKey];
const mergeProps$1 = (target, source) => {
  source && Object.keys(source).forEach((key) => {
    const targetProp = target[key];
    const sourceProp = source[key];
    if (typeof sourceProp === "function" && targetProp) {
      target[key] = (...arg2) => {
        sourceProp(...arg2);
        targetProp(...arg2);
      };
    } else {
      target[key] = sourceProp;
    }
  });
  return target;
};
const parsePadding = (paddingStr) => {
  if (typeof paddingStr !== "string") return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  const padding2 = paddingStr.trim().split(/\s+/, 4).map(parseFloat);
  const top2 = !isNaN(padding2[0]) ? padding2[0] : 0;
  const right2 = !isNaN(padding2[1]) ? padding2[1] : top2;
  return {
    top: top2,
    right: right2,
    bottom: !isNaN(padding2[2]) ? padding2[2] : top2,
    left: !isNaN(padding2[3]) ? padding2[3] : right2
  };
};
const getScrollAncestor = (node2) => {
  while (node2) {
    node2 = node2.parentNode;
    if (!node2 || node2 === document.body || !node2.parentNode) return;
    const {
      overflow,
      overflowX,
      overflowY
    } = getComputedStyle(node2);
    if (/auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX)) return node2;
  }
};
function commonProps(isDisabled, isHovering) {
  return {
    "aria-disabled": isDisabled || void 0,
    tabIndex: isHovering ? 0 : -1
  };
}
function indexOfNode(nodeList, node2) {
  for (let i = 0; i < nodeList.length; i++) {
    if (nodeList[i] === node2) return i;
  }
  return -1;
}
const useBEM = ({
  block,
  element,
  modifiers,
  className
}) => reactExports.useMemo(() => {
  const blockElement = element ? `${block}__${element}` : block;
  let classString = blockElement;
  modifiers && Object.keys(modifiers).forEach((name) => {
    const value = modifiers[name];
    if (value) classString += ` ${blockElement}--${value === true ? name : `${name}-${value}`}`;
  });
  let expandedClassName = typeof className === "function" ? className(modifiers) : className;
  if (typeof expandedClassName === "string") {
    expandedClassName = expandedClassName.trim();
    if (expandedClassName) classString += ` ${expandedClassName}`;
  }
  return classString;
}, [block, element, modifiers, className]);
const menuContainerClass = "szh-menu-container";
const menuClass = "szh-menu";
const menuArrowClass = "arrow";
const menuItemClass = "item";
const subMenuClass = "submenu";
const HoverItemContext = /* @__PURE__ */ reactExports.createContext();
const MenuListItemContext = /* @__PURE__ */ reactExports.createContext({});
const MenuListContext = /* @__PURE__ */ reactExports.createContext({});
const EventHandlersContext = /* @__PURE__ */ reactExports.createContext({});
const RadioGroupContext = /* @__PURE__ */ reactExports.createContext({});
const SettingsContext = /* @__PURE__ */ reactExports.createContext({});
const Keys = /* @__PURE__ */ Object.freeze({
  ENTER: "Enter",
  ESC: "Escape",
  SPACE: " ",
  HOME: "Home",
  END: "End",
  LEFT: "ArrowLeft",
  RIGHT: "ArrowRight",
  UP: "ArrowUp",
  DOWN: "ArrowDown"
});
const HoverActionTypes = /* @__PURE__ */ Object.freeze({
  RESET: 0,
  SET: 1,
  UNSET: 2,
  INCREASE: 3,
  DECREASE: 4,
  FIRST: 5,
  LAST: 6,
  SET_INDEX: 7
});
const CloseReason = /* @__PURE__ */ Object.freeze({
  CLICK: "click",
  CANCEL: "cancel",
  BLUR: "blur",
  SCROLL: "scroll"
});
const FocusPositions = /* @__PURE__ */ Object.freeze({
  FIRST: "first",
  LAST: "last"
});
const MenuStateMap = /* @__PURE__ */ Object.freeze({
  entering: "opening",
  entered: "open",
  exiting: "closing",
  exited: "closed"
});
const positionAbsolute = "absolute";
const roleNone = "none";
const roleMenuitem = "menuitem";
const noScrollFocus = {
  preventScroll: true
};
const MenuContainer = ({
  className,
  containerRef,
  containerProps,
  children,
  isOpen,
  theming,
  transition,
  onClose
}) => {
  const itemTransition = getTransition(transition, "item");
  const onKeyDown = ({
    key
  }) => {
    switch (key) {
      case Keys.ESC:
        safeCall(onClose, {
          key,
          reason: CloseReason.CANCEL
        });
        break;
    }
  };
  const onBlur = (e) => {
    if (isOpen && !e.currentTarget.contains(e.relatedTarget)) {
      safeCall(onClose, {
        reason: CloseReason.BLUR
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    ...mergeProps$1({
      onKeyDown,
      onBlur
    }, containerProps),
    className: useBEM({
      block: menuContainerClass,
      modifiers: reactExports.useMemo(() => ({
        theme: theming,
        itemTransition
      }), [theming, itemTransition]),
      className
    }),
    style: {
      position: "absolute",
      ...containerProps?.style
    },
    ref: containerRef,
    children
  });
};
const createSubmenuCtx = () => {
  let timer, count2 = 0;
  return {
    toggle: (isOpen) => {
      isOpen ? count2++ : count2--;
      count2 = Math.max(count2, 0);
    },
    on: (closeDelay, pending, settled) => {
      if (count2) {
        if (!timer) timer = setTimeout(() => {
          timer = 0;
          pending();
        }, closeDelay);
      } else {
        settled?.();
      }
    },
    off: () => {
      if (timer) {
        clearTimeout(timer);
        timer = 0;
      }
    }
  };
};
const useItems = (menuRef) => {
  const [hoverItem, setHoverItem] = reactExports.useState();
  const stateRef = reactExports.useRef({
    items: [],
    hoverIndex: -1,
    sorted: false
  });
  const mutableState = stateRef.current;
  const updateItems = reactExports.useCallback((item, isMounted) => {
    const {
      items
    } = mutableState;
    if (!item) {
      mutableState.items = [];
    } else if (isMounted) {
      items.push(item);
    } else {
      const index2 = items.indexOf(item);
      if (index2 > -1) {
        items.splice(index2, 1);
        if (item.contains(document.activeElement)) {
          menuRef.current.focus(noScrollFocus);
          setHoverItem();
        }
      }
    }
    mutableState.hoverIndex = -1;
    mutableState.sorted = false;
  }, [mutableState, menuRef]);
  const dispatch = reactExports.useCallback((actionType, item, nextIndex) => {
    const {
      items,
      hoverIndex
    } = mutableState;
    const sortItems = () => {
      if (mutableState.sorted) return;
      const orderedNodes = menuRef.current.querySelectorAll(".szh-menu__item");
      items.sort((a, b) => indexOfNode(orderedNodes, a) - indexOfNode(orderedNodes, b));
      mutableState.sorted = true;
    };
    let index2 = -1, newItem = void 0;
    switch (actionType) {
      case HoverActionTypes.RESET:
        break;
      case HoverActionTypes.SET:
        newItem = item;
        break;
      case HoverActionTypes.UNSET:
        newItem = (prevItem) => prevItem === item ? void 0 : prevItem;
        break;
      case HoverActionTypes.FIRST:
        sortItems();
        index2 = 0;
        newItem = items[index2];
        break;
      case HoverActionTypes.LAST:
        sortItems();
        index2 = items.length - 1;
        newItem = items[index2];
        break;
      case HoverActionTypes.SET_INDEX:
        sortItems();
        index2 = nextIndex;
        newItem = items[index2];
        break;
      case HoverActionTypes.INCREASE:
        sortItems();
        index2 = hoverIndex;
        if (index2 < 0) index2 = items.indexOf(item);
        index2++;
        if (index2 >= items.length) index2 = 0;
        newItem = items[index2];
        break;
      case HoverActionTypes.DECREASE:
        sortItems();
        index2 = hoverIndex;
        if (index2 < 0) index2 = items.indexOf(item);
        index2--;
        if (index2 < 0) index2 = items.length - 1;
        newItem = items[index2];
        break;
      default:
        if (process.env.NODE_ENV !== "production") throw new Error(`[React-Menu] Unknown hover action type: ${actionType}`);
    }
    if (!newItem) index2 = -1;
    setHoverItem(newItem);
    mutableState.hoverIndex = index2;
  }, [menuRef, mutableState]);
  return {
    hoverItem,
    dispatch,
    updateItems
  };
};
const getNativeDimension = (transformed, untransformed) => Math.round(transformed) === untransformed ? transformed : untransformed;
const getNormalizedClientRect = (element) => {
  const rect = element.getBoundingClientRect();
  rect.width = getNativeDimension(rect.width, element.offsetWidth);
  rect.height = getNativeDimension(rect.height, element.offsetHeight);
  return rect;
};
const getPositionHelpers = (containerElt, menuElt, menuScroll, boundingBoxPadding) => {
  const menuRect = getNormalizedClientRect(menuElt);
  const containerRect = containerElt.getBoundingClientRect();
  const boundingRect = menuScroll === window ? {
    left: 0,
    top: 0,
    right: document.documentElement.clientWidth,
    bottom: window.innerHeight
  } : menuScroll.getBoundingClientRect();
  const padding2 = parsePadding(boundingBoxPadding);
  const getLeftOverflow = (x) => x + containerRect.left - boundingRect.left - padding2.left;
  const getRightOverflow = (x) => x + containerRect.left + menuRect.width - boundingRect.right + padding2.right;
  const getTopOverflow = (y) => y + containerRect.top - boundingRect.top - padding2.top;
  const getBottomOverflow = (y) => y + containerRect.top + menuRect.height - boundingRect.bottom + padding2.bottom;
  const confineHorizontally = (x) => {
    let leftOverflow = getLeftOverflow(x);
    if (leftOverflow < 0) {
      x -= leftOverflow;
    } else {
      const rightOverflow = getRightOverflow(x);
      if (rightOverflow > 0) {
        x -= rightOverflow;
        leftOverflow = getLeftOverflow(x);
        if (leftOverflow < 0) x -= leftOverflow;
      }
    }
    return x;
  };
  const confineVertically = (y) => {
    let topOverflow = getTopOverflow(y);
    if (topOverflow < 0) {
      y -= topOverflow;
    } else {
      const bottomOverflow = getBottomOverflow(y);
      if (bottomOverflow > 0) {
        y -= bottomOverflow;
        topOverflow = getTopOverflow(y);
        if (topOverflow < 0) y -= topOverflow;
      }
    }
    return y;
  };
  return {
    menuRect,
    containerRect,
    getLeftOverflow,
    getRightOverflow,
    getTopOverflow,
    getBottomOverflow,
    confineHorizontally,
    confineVertically
  };
};
const placeArrowVertical = ({
  arrowRef,
  menuY,
  anchorRect,
  containerRect,
  menuRect
}) => {
  let y = anchorRect.top - containerRect.top - menuY + anchorRect.height / 2;
  const offset2 = arrowRef.current.offsetHeight * 1.25;
  y = Math.max(offset2, y);
  y = Math.min(y, menuRect.height - offset2);
  return y;
};
const placeLeftorRight = ({
  anchorRect,
  containerRect,
  menuRect,
  placeLeftorRightY,
  placeLeftX,
  placeRightX,
  getLeftOverflow,
  getRightOverflow,
  confineHorizontally,
  confineVertically,
  arrowRef,
  arrow: arrow2,
  direction,
  position: position2
}) => {
  let computedDirection = direction;
  let y = placeLeftorRightY;
  if (position2 !== "initial") {
    y = confineVertically(y);
    if (position2 === "anchor") {
      y = Math.min(y, anchorRect.bottom - containerRect.top);
      y = Math.max(y, anchorRect.top - containerRect.top - menuRect.height);
    }
  }
  let x, leftOverflow, rightOverflow;
  if (computedDirection === "left") {
    x = placeLeftX;
    if (position2 !== "initial") {
      leftOverflow = getLeftOverflow(x);
      if (leftOverflow < 0) {
        rightOverflow = getRightOverflow(placeRightX);
        if (rightOverflow <= 0 || -leftOverflow > rightOverflow) {
          x = placeRightX;
          computedDirection = "right";
        }
      }
    }
  } else {
    x = placeRightX;
    if (position2 !== "initial") {
      rightOverflow = getRightOverflow(x);
      if (rightOverflow > 0) {
        leftOverflow = getLeftOverflow(placeLeftX);
        if (leftOverflow >= 0 || -leftOverflow < rightOverflow) {
          x = placeLeftX;
          computedDirection = "left";
        }
      }
    }
  }
  if (position2 === "auto") x = confineHorizontally(x);
  const arrowY = arrow2 ? placeArrowVertical({
    menuY: y,
    arrowRef,
    anchorRect,
    containerRect,
    menuRect
  }) : void 0;
  return {
    arrowY,
    x,
    y,
    computedDirection
  };
};
const placeArrowHorizontal = ({
  arrowRef,
  menuX,
  anchorRect,
  containerRect,
  menuRect
}) => {
  let x = anchorRect.left - containerRect.left - menuX + anchorRect.width / 2;
  const offset2 = arrowRef.current.offsetWidth * 1.25;
  x = Math.max(offset2, x);
  x = Math.min(x, menuRect.width - offset2);
  return x;
};
const placeToporBottom = ({
  anchorRect,
  containerRect,
  menuRect,
  placeToporBottomX,
  placeTopY,
  placeBottomY,
  getTopOverflow,
  getBottomOverflow,
  confineHorizontally,
  confineVertically,
  arrowRef,
  arrow: arrow2,
  direction,
  position: position2
}) => {
  let computedDirection = direction === "top" ? "top" : "bottom";
  let x = placeToporBottomX;
  if (position2 !== "initial") {
    x = confineHorizontally(x);
    if (position2 === "anchor") {
      x = Math.min(x, anchorRect.right - containerRect.left);
      x = Math.max(x, anchorRect.left - containerRect.left - menuRect.width);
    }
  }
  let y, topOverflow, bottomOverflow;
  if (computedDirection === "top") {
    y = placeTopY;
    if (position2 !== "initial") {
      topOverflow = getTopOverflow(y);
      if (topOverflow < 0) {
        bottomOverflow = getBottomOverflow(placeBottomY);
        if (bottomOverflow <= 0 || -topOverflow > bottomOverflow) {
          y = placeBottomY;
          computedDirection = "bottom";
        }
      }
    }
  } else {
    y = placeBottomY;
    if (position2 !== "initial") {
      bottomOverflow = getBottomOverflow(y);
      if (bottomOverflow > 0) {
        topOverflow = getTopOverflow(placeTopY);
        if (topOverflow >= 0 || -topOverflow < bottomOverflow) {
          y = placeTopY;
          computedDirection = "top";
        }
      }
    }
  }
  if (position2 === "auto") y = confineVertically(y);
  const arrowX = arrow2 ? placeArrowHorizontal({
    menuX: x,
    arrowRef,
    anchorRect,
    containerRect,
    menuRect
  }) : void 0;
  return {
    arrowX,
    x,
    y,
    computedDirection
  };
};
const positionMenu = ({
  arrow: arrow2,
  align,
  direction,
  gap: gap2,
  shift,
  position: position2,
  anchorRect,
  arrowRef,
  positionHelpers
}) => {
  const {
    menuRect,
    containerRect
  } = positionHelpers;
  const isHorizontal2 = direction === "left" || direction === "right";
  let horizontalOffset = isHorizontal2 ? gap2 : shift;
  let verticalOffset = isHorizontal2 ? shift : gap2;
  if (arrow2) {
    const arrowElt = arrowRef.current;
    if (isHorizontal2) {
      horizontalOffset += arrowElt.offsetWidth;
    } else {
      verticalOffset += arrowElt.offsetHeight;
    }
  }
  const placeLeftX = anchorRect.left - containerRect.left - menuRect.width - horizontalOffset;
  const placeRightX = anchorRect.right - containerRect.left + horizontalOffset;
  const placeTopY = anchorRect.top - containerRect.top - menuRect.height - verticalOffset;
  const placeBottomY = anchorRect.bottom - containerRect.top + verticalOffset;
  let placeToporBottomX, placeLeftorRightY;
  if (align === "end") {
    placeToporBottomX = anchorRect.right - containerRect.left - menuRect.width;
    placeLeftorRightY = anchorRect.bottom - containerRect.top - menuRect.height;
  } else if (align === "center") {
    placeToporBottomX = anchorRect.left - containerRect.left - (menuRect.width - anchorRect.width) / 2;
    placeLeftorRightY = anchorRect.top - containerRect.top - (menuRect.height - anchorRect.height) / 2;
  } else {
    placeToporBottomX = anchorRect.left - containerRect.left;
    placeLeftorRightY = anchorRect.top - containerRect.top;
  }
  placeToporBottomX += horizontalOffset;
  placeLeftorRightY += verticalOffset;
  const options = {
    ...positionHelpers,
    anchorRect,
    placeLeftX,
    placeRightX,
    placeLeftorRightY,
    placeTopY,
    placeBottomY,
    placeToporBottomX,
    arrowRef,
    arrow: arrow2,
    direction,
    position: position2
  };
  switch (direction) {
    case "left":
    case "right":
      return placeLeftorRight(options);
    case "top":
    case "bottom":
    default:
      return placeToporBottom(options);
  }
};
const useIsomorphicLayoutEffect$1 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? reactExports.useLayoutEffect : reactExports.useEffect;
function setRef(ref2, instance) {
  typeof ref2 === "function" ? ref2(instance) : ref2.current = instance;
}
const useCombinedRef = (refA, refB) => reactExports.useMemo(() => {
  if (!refA) return refB;
  if (!refB) return refA;
  return (instance) => {
    setRef(refA, instance);
    setRef(refB, instance);
  };
}, [refA, refB]);
const offScreen = -9999;
const MenuList2 = ({
  ariaLabel,
  menuClassName,
  menuStyle,
  arrow: arrow2,
  arrowProps = {},
  anchorPoint,
  anchorRef,
  containerRef,
  containerProps,
  externalRef,
  parentScrollingRef,
  align = "start",
  direction = "bottom",
  position: position2 = "auto",
  overflow = "visible",
  setDownOverflow,
  repositionFlag,
  captureFocus = true,
  state,
  endTransition,
  isDisabled,
  menuItemFocus,
  gap: gap2 = 0,
  shift = 0,
  children,
  onClose,
  focusProps: _12,
  ...restProps
}) => {
  const [menuPosition, setMenuPosition] = reactExports.useState({
    x: offScreen,
    y: offScreen
  });
  const [arrowPosition, setArrowPosition] = reactExports.useState({});
  const [overflowData, setOverflowData] = reactExports.useState();
  const [expandedDirection, setExpandedDirection] = reactExports.useState(direction);
  const [submenuCtx] = reactExports.useState(createSubmenuCtx);
  const [reposSubmenu, forceReposSubmenu] = reactExports.useReducer((c) => c + 1, 1);
  const {
    transition,
    boundingBoxRef,
    boundingBoxPadding,
    rootMenuRef,
    rootAnchorRef,
    scrollNodesRef,
    reposition,
    viewScroll,
    submenuCloseDelay
  } = reactExports.useContext(SettingsContext);
  const {
    submenuCtx: parentSubmenuCtx,
    reposSubmenu: reposFlag = repositionFlag
  } = reactExports.useContext(MenuListContext);
  const menuRef = reactExports.useRef();
  const arrowRef = reactExports.useRef();
  const prevOpen = reactExports.useRef(false);
  const {
    hoverItem,
    dispatch,
    updateItems
  } = useItems(menuRef);
  const isOpen = isMenuOpen(state);
  const openTransition = getTransition(transition, "open");
  const closeTransition = getTransition(transition, "close");
  const scrollNodes = scrollNodesRef.current;
  const onKeyDown = (e) => {
    switch (e.key) {
      case Keys.HOME:
        dispatch(HoverActionTypes.FIRST);
        break;
      case Keys.END:
        dispatch(HoverActionTypes.LAST);
        break;
      case Keys.UP:
        dispatch(HoverActionTypes.DECREASE, hoverItem);
        break;
      case Keys.DOWN:
        dispatch(HoverActionTypes.INCREASE, hoverItem);
        break;
      case Keys.SPACE:
        if (e.target && e.target.className.indexOf(menuClass) !== -1) {
          e.preventDefault();
        }
        return;
      default:
        return;
    }
    e.preventDefault();
    e.stopPropagation();
  };
  const onAnimationEnd = () => {
    if (state === "closing") {
      setOverflowData();
    }
    safeCall(endTransition);
  };
  const onPointerMove = (e) => {
    e.stopPropagation();
    submenuCtx.on(submenuCloseDelay, () => {
      dispatch(HoverActionTypes.RESET);
      menuRef.current.focus(noScrollFocus);
    });
  };
  const onPointerLeave = (e) => {
    if (e.target === e.currentTarget) submenuCtx.off();
  };
  const handlePosition = reactExports.useCallback((noOverflowCheck) => {
    const menuElt = menuRef.current;
    const containerElt = containerRef.current;
    if (!menuElt || !containerElt) return;
    const anchorRect = anchorRef ? anchorRef.current?.getBoundingClientRect() : anchorPoint ? {
      left: anchorPoint.x,
      right: anchorPoint.x,
      top: anchorPoint.y,
      bottom: anchorPoint.y,
      width: 0,
      height: 0
    } : null;
    if (!anchorRect) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("[React-Menu] Menu might not be positioned properly as one of the anchorRef or anchorPoint prop should be provided. If `anchorRef` is provided, the anchor must be mounted before menu is open.");
      }
      return;
    }
    if (!scrollNodes.menu) {
      scrollNodes.menu = (boundingBoxRef ? boundingBoxRef.current : getScrollAncestor(rootMenuRef.current)) || window;
    }
    const positionHelpers = getPositionHelpers(containerElt, menuElt, scrollNodes.menu, boundingBoxPadding);
    let {
      arrowX,
      arrowY,
      x,
      y,
      computedDirection
    } = positionMenu({
      arrow: arrow2,
      align,
      direction,
      gap: gap2,
      shift,
      position: position2,
      anchorRect,
      arrowRef,
      positionHelpers
    });
    const {
      menuRect
    } = positionHelpers;
    const menuHeight = menuRect.height;
    if (!noOverflowCheck && overflow !== "visible") {
      const {
        getTopOverflow,
        getBottomOverflow
      } = positionHelpers;
      let height2, overflowAmt2;
      const bottomOverflow = getBottomOverflow(y);
      if (bottomOverflow > 0) {
        height2 = menuHeight - bottomOverflow;
        overflowAmt2 = bottomOverflow;
      } else {
        const topOverflow = getTopOverflow(y);
        if (topOverflow < 0) {
          height2 = menuHeight + topOverflow;
          overflowAmt2 = 0 - topOverflow;
          if (height2 >= 0) y -= topOverflow;
        }
      }
      if (height2 >= 0) {
        setOverflowData({
          height: height2,
          overflowAmt: overflowAmt2
        });
      }
    }
    if (arrow2) setArrowPosition({
      x: arrowX,
      y: arrowY
    });
    setMenuPosition({
      x,
      y
    });
    setExpandedDirection(computedDirection);
  }, [arrow2, align, boundingBoxPadding, direction, gap2, shift, position2, overflow, anchorPoint, anchorRef, containerRef, boundingBoxRef, rootMenuRef, scrollNodes]);
  useIsomorphicLayoutEffect$1(() => {
    if (isOpen) {
      handlePosition();
      if (prevOpen.current) forceReposSubmenu();
    }
    prevOpen.current = isOpen;
  }, [isOpen, handlePosition, reposFlag]);
  useIsomorphicLayoutEffect$1(() => {
    if (overflowData && !setDownOverflow) menuRef.current.scrollTop = 0;
  }, [overflowData, setDownOverflow]);
  useIsomorphicLayoutEffect$1(() => updateItems, [updateItems]);
  reactExports.useEffect(() => {
    let {
      menu: menuScroll
    } = scrollNodes;
    if (!isOpen || !menuScroll) return;
    menuScroll = menuScroll.addEventListener ? menuScroll : window;
    if (!scrollNodes.anchors) {
      scrollNodes.anchors = [];
      let anchorScroll = getScrollAncestor(rootAnchorRef && rootAnchorRef.current);
      while (anchorScroll && anchorScroll !== menuScroll) {
        scrollNodes.anchors.push(anchorScroll);
        anchorScroll = getScrollAncestor(anchorScroll);
      }
    }
    let scroll = viewScroll;
    if (scrollNodes.anchors.length && scroll === "initial") scroll = "auto";
    if (scroll === "initial") return;
    const handleScroll = () => {
      if (scroll === "auto") {
        batchedUpdates(() => handlePosition(true));
      } else {
        safeCall(onClose, {
          reason: CloseReason.SCROLL
        });
      }
    };
    const scrollObservers = scrollNodes.anchors.concat(viewScroll !== "initial" ? menuScroll : []);
    scrollObservers.forEach((o) => o.addEventListener("scroll", handleScroll));
    return () => scrollObservers.forEach((o) => o.removeEventListener("scroll", handleScroll));
  }, [rootAnchorRef, scrollNodes, isOpen, onClose, viewScroll, handlePosition]);
  const hasOverflow = !!overflowData && overflowData.overflowAmt > 0;
  reactExports.useEffect(() => {
    if (hasOverflow || !isOpen || !parentScrollingRef) return;
    const handleScroll = () => batchedUpdates(handlePosition);
    const parentScroll = parentScrollingRef.current;
    parentScroll.addEventListener("scroll", handleScroll);
    return () => parentScroll.removeEventListener("scroll", handleScroll);
  }, [isOpen, hasOverflow, parentScrollingRef, handlePosition]);
  reactExports.useEffect(() => {
    if (!isOpen || typeof ResizeObserver !== "function" || reposition === "initial") return;
    const targetList = [];
    const resizeObserver = new ResizeObserver((entries2) => entries2.forEach(({
      target
    }) => {
      if (targetList.indexOf(target) < 0) {
        targetList.push(target);
      } else {
        reactDomExports.flushSync(() => {
          handlePosition();
          forceReposSubmenu();
        });
      }
    }));
    const resizeObserverOptions = {
      box: "border-box"
    };
    resizeObserver.observe(menuRef.current, resizeObserverOptions);
    const anchor = anchorRef?.current;
    anchor && resizeObserver.observe(anchor, resizeObserverOptions);
    return () => resizeObserver.disconnect();
  }, [isOpen, reposition, anchorRef, handlePosition]);
  reactExports.useEffect(() => {
    if (!isOpen) {
      dispatch(HoverActionTypes.RESET);
      if (!closeTransition) setOverflowData();
      return;
    }
    const {
      position: position22,
      alwaysUpdate
    } = menuItemFocus || {};
    const setItemFocus = () => {
      if (position22 === FocusPositions.FIRST) {
        dispatch(HoverActionTypes.FIRST);
      } else if (position22 === FocusPositions.LAST) {
        dispatch(HoverActionTypes.LAST);
      } else if (position22 >= -1) {
        dispatch(HoverActionTypes.SET_INDEX, void 0, position22);
      }
    };
    if (alwaysUpdate) {
      setItemFocus();
    } else if (captureFocus) {
      const id = setTimeout(() => {
        const menuElt = menuRef.current;
        if (menuElt && !menuElt.contains(document.activeElement)) {
          menuElt.focus(noScrollFocus);
          setItemFocus();
        }
      }, openTransition ? 170 : 100);
      return () => clearTimeout(id);
    }
  }, [isOpen, openTransition, closeTransition, captureFocus, menuItemFocus, dispatch]);
  const itemContext = reactExports.useMemo(() => ({
    isParentOpen: isOpen,
    submenuCtx,
    dispatch,
    updateItems
  }), [isOpen, submenuCtx, dispatch, updateItems]);
  let maxHeight2, overflowAmt;
  if (overflowData) {
    setDownOverflow ? overflowAmt = overflowData.overflowAmt : maxHeight2 = overflowData.height;
  }
  const listContext = reactExports.useMemo(() => ({
    reposSubmenu,
    submenuCtx,
    overflow,
    overflowAmt,
    parentMenuRef: menuRef,
    parentDir: expandedDirection
  }), [reposSubmenu, submenuCtx, overflow, overflowAmt, expandedDirection]);
  const overflowStyle = maxHeight2 >= 0 ? {
    maxHeight: maxHeight2,
    overflow
  } : void 0;
  const modifiers = reactExports.useMemo(() => ({
    state,
    align,
    dir: expandedDirection
  }), [state, align, expandedDirection]);
  const arrowModifiers = reactExports.useMemo(() => ({
    dir: expandedDirection
  }), [expandedDirection]);
  const _arrowClassName = useBEM({
    block: menuClass,
    element: menuArrowClass,
    modifiers: arrowModifiers,
    className: arrowProps.className
  });
  const menu = /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", {
    role: "menu",
    "aria-label": ariaLabel,
    ...commonProps(isDisabled),
    ...mergeProps$1({
      onPointerEnter: parentSubmenuCtx?.off,
      onPointerMove,
      onPointerLeave,
      onKeyDown,
      onAnimationEnd
    }, restProps),
    ref: useCombinedRef(externalRef, menuRef),
    className: useBEM({
      block: menuClass,
      modifiers,
      className: menuClassName
    }),
    style: {
      ...menuStyle,
      ...overflowStyle,
      margin: 0,
      display: state === "closed" ? "none" : void 0,
      position: positionAbsolute,
      left: menuPosition.x,
      top: menuPosition.y
    },
    children: [arrow2 && /* @__PURE__ */ jsxRuntimeExports.jsx("li", {
      "aria-hidden": true,
      ...arrowProps,
      className: _arrowClassName,
      style: {
        display: "block",
        position: positionAbsolute,
        left: arrowPosition.x,
        top: arrowPosition.y,
        ...arrowProps.style
      },
      ref: arrowRef
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(MenuListContext.Provider, {
      value: listContext,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuListItemContext.Provider, {
        value: itemContext,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(HoverItemContext.Provider, {
          value: hoverItem,
          children: safeCall(children, modifiers)
        })
      })
    })]
  });
  return containerProps ? /* @__PURE__ */ jsxRuntimeExports.jsx(MenuContainer, {
    ...containerProps,
    isOpen,
    children: menu
  }) : menu;
};
const ControlledMenu = /* @__PURE__ */ reactExports.forwardRef(function ControlledMenu2({
  "aria-label": ariaLabel,
  className,
  containerProps,
  initialMounted,
  unmountOnClose,
  transition,
  transitionTimeout,
  boundingBoxRef,
  boundingBoxPadding,
  reposition = "auto",
  submenuOpenDelay = 300,
  submenuCloseDelay = 150,
  viewScroll = "initial",
  portal,
  theming,
  onItemClick,
  ...restProps
}, externalRef) {
  const containerRef = reactExports.useRef(null);
  const scrollNodesRef = reactExports.useRef({});
  const {
    anchorRef,
    state,
    onClose
  } = restProps;
  const settings = reactExports.useMemo(() => ({
    initialMounted,
    unmountOnClose,
    transition,
    transitionTimeout,
    boundingBoxRef,
    boundingBoxPadding,
    rootMenuRef: containerRef,
    rootAnchorRef: anchorRef,
    scrollNodesRef,
    reposition,
    viewScroll,
    submenuOpenDelay,
    submenuCloseDelay
  }), [initialMounted, unmountOnClose, transition, transitionTimeout, anchorRef, boundingBoxRef, boundingBoxPadding, reposition, viewScroll, submenuOpenDelay, submenuCloseDelay]);
  const eventHandlers = reactExports.useMemo(() => ({
    handleClick(event2, isCheckorRadio) {
      if (!event2.stopPropagation) safeCall(onItemClick, event2);
      let keepOpen = event2.keepOpen;
      if (keepOpen === void 0) {
        keepOpen = isCheckorRadio && event2.key === Keys.SPACE;
      }
      if (!keepOpen) {
        safeCall(onClose, {
          value: event2.value,
          key: event2.key,
          reason: CloseReason.CLICK
        });
      }
    },
    handleClose(key) {
      safeCall(onClose, {
        key,
        reason: CloseReason.CLICK
      });
    }
  }), [onItemClick, onClose]);
  if (!state) return null;
  const menuList = /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsContext.Provider, {
    value: settings,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(EventHandlersContext.Provider, {
      value: eventHandlers,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuList2, {
        ...restProps,
        ariaLabel: ariaLabel || "Menu",
        externalRef,
        containerRef,
        containerProps: {
          className,
          containerRef,
          containerProps,
          theming,
          transition,
          onClose
        }
      })
    })
  });
  if (portal === true && typeof document !== "undefined") {
    return /* @__PURE__ */ reactDomExports.createPortal(menuList, document.body);
  } else if (portal) {
    return portal.target ? /* @__PURE__ */ reactDomExports.createPortal(menuList, portal.target) : portal.stablePosition ? null : menuList;
  }
  return menuList;
});
const useMenuState = ({
  initialOpen,
  initialMounted,
  unmountOnClose,
  transition,
  transitionTimeout = 500,
  onMenuChange
} = {}) => {
  const enter = getTransition(transition, "open");
  const exit = getTransition(transition, "close");
  const [{
    status
  }, toggleMenu, endTransition] = useTransitionState$1({
    initialEntered: initialOpen,
    mountOnEnter: !initialMounted,
    unmountOnExit: unmountOnClose,
    timeout: transitionTimeout,
    enter,
    exit,
    onStateChange: reactExports.useCallback(({
      current: {
        isEnter,
        isResolved
      }
    }) => {
      if (!onMenuChange || isEnter && enter && isResolved || !isEnter && exit && isResolved) {
        return;
      }
      onMenuChange({
        open: isEnter
      });
    }, [onMenuChange, enter, exit])
  });
  return [{
    state: MenuStateMap[status],
    endTransition
  }, toggleMenu];
};
const useMenuStateAndFocus = (options) => {
  const [menuProps, toggleMenu] = useMenuState(options);
  const [menuItemFocus, setMenuItemFocus] = reactExports.useState();
  const openMenu = (position2, alwaysUpdate) => {
    setMenuItemFocus({
      position: position2,
      alwaysUpdate
    });
    toggleMenu(true);
  };
  return [{
    menuItemFocus,
    ...menuProps
  }, toggleMenu, openMenu];
};
const useClick = (state, onToggle) => {
  if (process.env.NODE_ENV !== "production" && typeof onToggle !== "function") {
    throw new Error("[React-Menu] useClick/useHover requires a function in the second parameter.");
  }
  const [skipOpen] = reactExports.useState({});
  return {
    onMouseDown: () => {
      skipOpen.v = state && state !== "closed";
    },
    onClick: (e) => skipOpen.v ? skipOpen.v = false : onToggle(true, e)
  };
};
const isLegacyReact = parseInt(reactExports.version) < 19;
const Menu2 = /* @__PURE__ */ reactExports.forwardRef(function Menu22({
  "aria-label": ariaLabel,
  captureFocus: _,
  initialOpen: _12,
  menuButton,
  instanceRef,
  onMenuChange,
  ...restProps
}, externalRef) {
  const [stateProps, toggleMenu, openMenu] = useMenuStateAndFocus({
    ...restProps,
    onMenuChange
  });
  const {
    state
  } = stateProps;
  const isOpen = isMenuOpen(state);
  const buttonRef = reactExports.useRef(null);
  const anchorProps = useClick(state, (_22, e) => openMenu(!e.detail ? FocusPositions.FIRST : void 0));
  const handleClose = reactExports.useCallback((e) => {
    toggleMenu(false);
    if (e.key) buttonRef.current.focus();
  }, [toggleMenu]);
  const onKeyDown = (e) => {
    switch (e.key) {
      case Keys.UP:
        openMenu(FocusPositions.LAST);
        break;
      case Keys.DOWN:
        openMenu(FocusPositions.FIRST);
        break;
      default:
        return;
    }
    e.preventDefault();
  };
  const button2 = safeCall(menuButton, {
    open: isOpen
  });
  if (!button2 || !button2.type) throw new Error("Menu requires a menuButton prop.");
  const buttonProps = {
    ...mergeProps$1({
      onKeyDown,
      ...anchorProps
    }, button2.props),
    ref: useCombinedRef(isLegacyReact ? button2.ref : button2.props.ref, buttonRef)
  };
  if (getName(button2.type) === "MenuButton") {
    buttonProps.isOpen = isOpen;
  }
  const renderButton = /* @__PURE__ */ reactExports.cloneElement(button2, buttonProps);
  reactExports.useImperativeHandle(instanceRef, () => ({
    openMenu,
    closeMenu: () => toggleMenu(false)
  }));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
    children: [renderButton, /* @__PURE__ */ jsxRuntimeExports.jsx(ControlledMenu, {
      ...restProps,
      ...stateProps,
      "aria-label": ariaLabel || (typeof button2.props.children === "string" ? button2.props.children : "Menu"),
      anchorRef: buttonRef,
      ref: externalRef,
      onClose: handleClose
    })]
  });
});
const withHovering = (name, WrappedComponent) => {
  const Component = /* @__PURE__ */ reactExports.memo(WrappedComponent);
  const WithHovering = /* @__PURE__ */ reactExports.forwardRef((props, ref2) => {
    const itemRef = reactExports.useRef(null);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Component, {
      ...props,
      itemRef,
      externalRef: ref2,
      isHovering: reactExports.useContext(HoverItemContext) === itemRef.current
    });
  });
  WithHovering.displayName = `WithHovering(${name})`;
  return WithHovering;
};
const useMouseOver = (isHovering) => {
  const [mouseOver, setMouseOver] = reactExports.useState(false);
  reactExports.useEffect(() => {
    !isHovering && setMouseOver(false);
  }, [isHovering]);
  return [mouseOver, () => !mouseOver && setMouseOver(true), () => setMouseOver(false)];
};
const useItemEffect = (isDisabled, itemRef, updateItems) => {
  useIsomorphicLayoutEffect$1(() => {
    if (process.env.NODE_ENV !== "production" && !updateItems) {
      throw new Error(`[React-Menu] This menu item or submenu should be rendered under a menu: ${itemRef.current.outerHTML}`);
    }
    if (isDisabled) return;
    const item = itemRef.current;
    updateItems(item, true);
    return () => {
      updateItems(item);
    };
  }, [isDisabled, itemRef, updateItems]);
};
const SubMenu = /* @__PURE__ */ withHovering("SubMenu", function SubMenu2({
  "aria-label": ariaLabel,
  className,
  disabled,
  direction,
  label,
  openTrigger,
  onMenuChange,
  isHovering,
  instanceRef,
  itemRef,
  captureFocus: _12,
  repositionFlag: _22,
  itemProps = {},
  portal = false,
  ...restProps
}) {
  const settings = reactExports.useContext(SettingsContext);
  const {
    rootMenuRef,
    submenuOpenDelay,
    submenuCloseDelay
  } = settings;
  const {
    parentMenuRef,
    parentDir,
    overflow: parentOverflow
  } = reactExports.useContext(MenuListContext);
  const {
    isParentOpen,
    submenuCtx,
    dispatch,
    updateItems
  } = reactExports.useContext(MenuListItemContext);
  const isPortal = portal || parentOverflow !== "visible";
  const [stateProps, toggleMenu, _openMenu] = useMenuStateAndFocus({
    ...settings,
    onMenuChange
  });
  const [mouseOver, mouseOverStart, mouseOverEnd] = useMouseOver(isHovering);
  const {
    state
  } = stateProps;
  const isDisabled = !!disabled;
  const isOpen = isMenuOpen(state);
  const containerRef = reactExports.useRef(null);
  const [timerId] = reactExports.useState({
    v: 0
  });
  const stopTimer = () => {
    submenuCtx.off();
    if (timerId.v) {
      clearTimeout(timerId.v);
      timerId.v = 0;
    }
  };
  const openMenu = (...args) => {
    stopTimer();
    setHover();
    !isDisabled && _openMenu(...args);
  };
  const setHover = () => !isHovering && !isDisabled && dispatch(HoverActionTypes.SET, itemRef.current);
  const delayOpen = (delay) => {
    setHover();
    if (!openTrigger) timerId.v = setTimeout(() => batchedUpdates(openMenu), Math.max(delay, 0));
  };
  const onPointerMove = (e) => {
    if (isDisabled) return;
    e.stopPropagation();
    mouseOverStart();
    if (timerId.v || isOpen) return;
    submenuCtx.on(submenuCloseDelay, () => delayOpen(submenuOpenDelay - submenuCloseDelay), () => delayOpen(submenuOpenDelay));
  };
  const onPointerLeave = () => {
    mouseOverEnd();
    stopTimer();
    if (!isOpen) dispatch(HoverActionTypes.UNSET, itemRef.current);
  };
  const onKeyDown = (e) => {
    if (!isHovering) return;
    switch (e.key) {
      case Keys.ENTER:
        e.preventDefault();
      case Keys.SPACE:
      case Keys.RIGHT:
        openTrigger !== "none" && openMenu(FocusPositions.FIRST);
    }
  };
  const onKeyDownOfRoot = (e) => {
    let handled = false;
    switch (e.key) {
      case Keys.LEFT:
        if (isOpen) {
          itemRef.current.focus();
          toggleMenu(false);
          handled = true;
        }
        break;
      case Keys.RIGHT:
        if (!isOpen) handled = true;
        break;
    }
    if (handled) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  useItemEffect(isDisabled, itemRef, updateItems);
  reactExports.useEffect(() => submenuCtx.toggle(isOpen), [submenuCtx, isOpen]);
  reactExports.useEffect(() => () => {
    clearTimeout(timerId.v);
    submenuCtx.toggle(false);
  }, [timerId, submenuCtx]);
  reactExports.useEffect(() => {
    if (isHovering && isParentOpen) {
      itemRef.current.focus();
    } else {
      toggleMenu(false);
    }
  }, [isHovering, isParentOpen, toggleMenu, itemRef]);
  reactExports.useImperativeHandle(instanceRef, () => ({
    openMenu: (...args) => {
      isParentOpen && openMenu(...args);
    },
    closeMenu: () => {
      if (isOpen) {
        itemRef.current.focus();
        toggleMenu(false);
      }
    }
  }));
  const modifiers = reactExports.useMemo(() => ({
    open: isOpen,
    hover: mouseOver || isHovering,
    disabled: isDisabled,
    submenu: true
  }), [isOpen, isHovering, isDisabled, mouseOver]);
  const {
    ref: externalItemRef,
    className: itemClassName,
    ...restItemProps
  } = itemProps;
  const mergedItemProps = mergeProps$1({
    onPointerEnter: submenuCtx.off,
    onPointerMove,
    onPointerLeave,
    onKeyDown,
    onClick: () => openTrigger !== "none" && openMenu()
  }, restItemProps);
  const getMenuList = () => {
    const menuList = /* @__PURE__ */ jsxRuntimeExports.jsx(MenuList2, {
      ...restProps,
      ...stateProps,
      ariaLabel: ariaLabel || (typeof label === "string" ? label : "Submenu"),
      anchorRef: itemRef,
      containerRef: isPortal ? rootMenuRef : containerRef,
      direction: direction || (parentDir === "right" || parentDir === "left" ? parentDir : "right"),
      parentScrollingRef: isPortal && parentMenuRef,
      isDisabled
    });
    const container = rootMenuRef.current;
    return isPortal && container ? /* @__PURE__ */ reactDomExports.createPortal(menuList, container) : menuList;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("li", {
    className: useBEM({
      block: menuClass,
      element: subMenuClass,
      className
    }),
    style: {
      position: "relative"
    },
    role: roleNone,
    ref: containerRef,
    onKeyDown: onKeyDownOfRoot,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      role: roleMenuitem,
      "aria-haspopup": true,
      "aria-expanded": isOpen,
      ...commonProps(isDisabled, isHovering),
      ...mergedItemProps,
      ref: useCombinedRef(externalItemRef, itemRef),
      className: useBEM({
        block: menuClass,
        element: menuItemClass,
        modifiers,
        className: itemClassName
      }),
      children: reactExports.useMemo(() => safeCall(label, modifiers), [label, modifiers])
    }), state && getMenuList()]
  });
});
const useItemState = (itemRef, focusRef, isHovering, isDisabled) => {
  const [mouseOver, mouseOverStart, mouseOverEnd] = useMouseOver(isHovering);
  const {
    submenuCloseDelay
  } = reactExports.useContext(SettingsContext);
  const {
    isParentOpen,
    submenuCtx,
    dispatch,
    updateItems
  } = reactExports.useContext(MenuListItemContext);
  const setHover = () => {
    !isHovering && !isDisabled && dispatch(HoverActionTypes.SET, itemRef.current);
  };
  const unsetHover = () => {
    !isDisabled && dispatch(HoverActionTypes.UNSET, itemRef.current);
  };
  const onBlur = (e) => {
    if (isHovering && !e.currentTarget.contains(e.relatedTarget)) unsetHover();
  };
  const onPointerMove = (e) => {
    if (!isDisabled) {
      e.stopPropagation();
      mouseOverStart();
      submenuCtx.on(submenuCloseDelay, setHover, setHover);
    }
  };
  const onPointerLeave = (_, keepHover) => {
    mouseOverEnd();
    submenuCtx.off();
    !keepHover && unsetHover();
  };
  useItemEffect(isDisabled, itemRef, updateItems);
  reactExports.useEffect(() => {
    if (isHovering && isParentOpen) {
      focusRef.current && focusRef.current.focus();
    }
  }, [focusRef, isHovering, isParentOpen]);
  return {
    mouseOver,
    setHover,
    onBlur,
    onPointerMove,
    onPointerLeave
  };
};
const MenuItem2 = /* @__PURE__ */ withHovering("MenuItem", function MenuItem22({
  className,
  value,
  href,
  type,
  checked: checked2,
  disabled,
  children,
  onClick,
  isHovering,
  itemRef,
  externalRef,
  ...restProps
}) {
  const isDisabled = !!disabled;
  const {
    mouseOver,
    setHover,
    ...restStateProps
  } = useItemState(itemRef, itemRef, isHovering, isDisabled);
  const eventHandlers = reactExports.useContext(EventHandlersContext);
  const radioGroup = reactExports.useContext(RadioGroupContext);
  const isRadio = type === "radio";
  const isCheckBox = type === "checkbox";
  const isAnchor = !!href && !isDisabled && !isRadio && !isCheckBox;
  const isChecked = isRadio ? radioGroup.value === value : isCheckBox ? !!checked2 : false;
  const handleClick = (e) => {
    if (isDisabled) {
      e.stopPropagation();
      e.preventDefault();
      return;
    }
    const event2 = {
      value,
      syntheticEvent: e
    };
    if (e.key !== void 0) event2.key = e.key;
    if (isCheckBox) event2.checked = !isChecked;
    if (isRadio) event2.name = radioGroup.name;
    safeCall(onClick, event2);
    if (isRadio) safeCall(radioGroup.onRadioChange, event2);
    eventHandlers.handleClick(event2, isCheckBox || isRadio);
  };
  const handleKeyDown = (e) => {
    if (!isHovering) return;
    switch (e.key) {
      case Keys.ENTER:
        e.preventDefault();
      case Keys.SPACE:
        isAnchor ? itemRef.current.click() : handleClick(e);
    }
  };
  const modifiers = reactExports.useMemo(() => ({
    type,
    disabled: isDisabled,
    hover: mouseOver || isHovering,
    checked: isChecked,
    anchor: isAnchor
  }), [type, isDisabled, mouseOver, isHovering, isChecked, isAnchor]);
  const mergedProps = mergeProps$1({
    ...restStateProps,
    onPointerDown: setHover,
    onKeyDown: handleKeyDown,
    onClick: handleClick
  }, restProps);
  const menuItemProps = {
    role: isRadio ? "menuitemradio" : isCheckBox ? "menuitemcheckbox" : roleMenuitem,
    "aria-checked": isRadio || isCheckBox ? isChecked : void 0,
    ...commonProps(isDisabled, isHovering),
    ...mergedProps,
    ref: useCombinedRef(externalRef, itemRef),
    className: useBEM({
      block: menuClass,
      element: menuItemClass,
      modifiers,
      className
    }),
    children: reactExports.useMemo(() => safeCall(children, modifiers), [children, modifiers])
  };
  return isAnchor ? /* @__PURE__ */ jsxRuntimeExports.jsx("li", {
    role: roleNone,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", {
      href,
      ...menuItemProps
    })
  }) : /* @__PURE__ */ jsxRuntimeExports.jsx("li", {
    ...menuItemProps
  });
});
const useStyles$2 = tss$1.withParams().create(({ theme }) => ({
  gear: {
    color: theme.palette.primary[600]
  },
  divider: {
    borderTop: `1px solid ${theme.palette.grey[200]}`
  },
  dividerBottom: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`
  },
  menu: {
    backgroundColor: "white",
    border: `1px solid rgba(0, 0, 0, 0.1)`,
    borderRadius: "6px",
    boxShadow: `1px 1px 20px 1px rgba(0, 0, 0, 0.1)`,
    boxSizing: "border-box",
    fontSize: "0.925rem",
    listStyle: "none",
    minWidth: "10rem",
    padding: "6px",
    userSelect: "none",
    zIndex: 100,
    top: 10
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    width: "100%"
  },
  menuCheckbox: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    width: "100%"
  },
  subMenuItem: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  wrapper: {
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    display: "flex",
    padding: "16px 24px",
    position: "sticky",
    top: 0,
    left: 0
  },
  columnMenuItem: {
    "&:hover": {
      backgroundColor: theme.palette.grey[50]
    }
  },
  icon: {
    height: 16,
    width: 16
  }
}));
const TableHeader_ = ({
  hideHeader,
  headerActions,
  hideHeaderMenu,
  id,
  labels,
  table
}) => {
  const gearRef = reactExports.useRef(null);
  const theme = useTheme();
  const { classes } = useStyles$2({ theme });
  const allColumns = table.getAllLeafColumns();
  const columnIds = allColumns.map((c) => c.id).join("|");
  const hideableColumns = reactExports.useMemo(
    () => allColumns.filter(
      (c) => c.getCanHide() && c.columnDef.meta?.unanetTable?.type !== UnanetTableColumnType.SELECTION
    ),
    [columnIds]
  );
  if (hideHeader) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classes.wrapper, ref: gearRef, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { flex: 1, gap: 16 }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography2, { variant: "h4", children: labels?.title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography2, { variant: "body2", children: labels?.subtitle })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { display: "flex" }, children: [
      headerActions?.(table),
      !hideHeaderMenu && /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Menu2,
        {
          align: "end",
          menuButton: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button2,
            {
              className: classes.gear,
              disableElevation: true,
              disableFocusRipple: true,
              disableRipple: true,
              disableTouchRipple: true,
              iconOnly: true,
              id: `${id}-table-header-settings-icon-btn`,
              startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(
                GearIcon,
                {
                  sx: {
                    height: "19px",
                    width: "19px"
                  }
                }
              ),
              variant: "tertiary"
            }
          ),
          menuClassName: `${classes.menu} unanet-menu`,
          portal: true,
          position: "anchor",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              SubMenu,
              {
                label: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classes.subMenuItem, children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(ColumnIcon, { className: classes.icon }),
                  labels?.menu?.manageColumns ?? "Manage Columns"
                ] }),
                menuClassName: classes.menu,
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    MenuItem2,
                    {
                      className: classes.dividerBottom,
                      onClick: (e) => {
                        e.keepOpen = true;
                        const allVisible = hideableColumns.every(
                          (column2) => column2.getIsVisible()
                        );
                        hideableColumns.forEach((column2) => {
                          column2.toggleVisibility(!allVisible);
                        });
                      },
                      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classes.menuCheckbox, children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(
                          Checkbox2,
                          {
                            checked: hideableColumns.every(
                              (column2) => column2.getIsVisible()
                            ),
                            id: "all-columns",
                            indeterminate: (() => {
                              const visibleCount = hideableColumns.filter(
                                (col) => col.getIsVisible()
                              ).length;
                              return visibleCount > 0 && visibleCount < hideableColumns.length;
                            })(),
                            readOnly: true
                          }
                        ),
                        labels?.menu?.allColumns ?? "All Columns"
                      ] })
                    },
                    "all-columns"
                  ),
                  hideableColumns.map((column2) => {
                    return /* @__PURE__ */ jsxRuntimeExports.jsx(
                      MenuItem2,
                      {
                        onClick: (e) => {
                          e.keepOpen = true;
                          column2.toggleVisibility();
                        },
                        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classes.menuCheckbox, children: [
                          /* @__PURE__ */ jsxRuntimeExports.jsx(
                            Checkbox2,
                            {
                              checked: column2.getIsVisible(),
                              id: column2.id,
                              readOnly: true
                            }
                          ),
                          column2.columnDef.meta?.unanetTable?.columnMenuLabel ?? (typeof column2.columnDef.header === "string" ? column2.columnDef.header : "")
                        ] })
                      },
                      column2.id
                    );
                  })
                ]
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              SubMenu,
              {
                label: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classes.subMenuItem, children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(SpacingHeightIcon, { className: classes.icon }),
                  labels?.menu?.rowHeight?.title ?? "Row Height"
                ] }),
                menuClassName: classes.menu,
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    MenuItem2,
                    {
                      className: classes.menuItem,
                      onClick: () => table.setDensity(UnanetTableDensity.MEDIUM),
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { flex: 1 }, children: labels?.menu?.rowHeight?.default ?? "Default" }),
                        table.getState().density === UnanetTableDensity.MEDIUM && /* @__PURE__ */ jsxRuntimeExports.jsx(CheckIcon, { className: classes.icon })
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    MenuItem2,
                    {
                      className: classes.menuItem,
                      onClick: () => table.setDensity(UnanetTableDensity.LARGE),
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { flex: 1 }, children: labels?.menu?.rowHeight?.comfortable ?? "Comfortable" }),
                        table.getState().density === UnanetTableDensity.LARGE && /* @__PURE__ */ jsxRuntimeExports.jsx(CheckIcon, { className: classes.icon })
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    MenuItem2,
                    {
                      className: classes.menuItem,
                      onClick: () => table.setDensity(UnanetTableDensity.SMALL),
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { flex: 1 }, children: labels?.menu?.rowHeight?.condensed ?? "Condensed" }),
                        table.getState().density === UnanetTableDensity.SMALL && /* @__PURE__ */ jsxRuntimeExports.jsx(CheckIcon, { className: classes.icon })
                      ]
                    }
                  )
                ]
              }
            ),
            table.getCanSomeRowsExpand() && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                MenuItem2,
                {
                  className: classes.divider,
                  onClick: () => table.toggleAllRowsExpanded(true),
                  children: labels?.menu?.expandAllRows ?? "Expand all rows"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem2, { onClick: () => table.toggleAllRowsExpanded(false), children: labels?.menu?.collapseAllRows ?? "Collapse all rows" })
            ] })
          ]
        }
      )
    ] })
  ] });
};
reactExports.memo(TableHeader_);
tss$1.withParams().create(({ theme, is12HourCycle: is12HourCycle2 }) => {
  const colCount = is12HourCycle2 ? 3 : 2;
  const colGap = 12;
  const colWidth = (280 - (colCount - 1) * colGap) / colCount;
  return {
    popper: {
      "section[role=action-bar]": {
        marginTop: -16
      },
      ".MuiList-root.MuiMultiSectionDigitalClockSection-root": {
        borderLeft: 0,
        maxHeight: 256,
        scrollbarWidth: "none",
        width: colWidth
      },
      ".MuiButtonBase-root.MuiMenuItem-root.MuiMultiSectionDigitalClockSection-item": {
        borderRadius: 20,
        color: theme.palette.grey[900],
        height: 40,
        margin: "2px 0",
        width: colWidth,
        "&.Mui-selected": {
          backgroundColor: theme.palette.blue[800],
          color: "white",
          ":hover": {
            backgroundColor: theme.palette.blue[800],
            color: "white",
            fontWeight: theme.typography.fontWeightMedium
          }
        },
        ":hover": {
          backgroundColor: theme.palette.grey[50],
          fontWeight: theme.typography.fontWeightMedium
        }
      },
      ".MuiMultiSectionDigitalClock-root": {
        borderBottom: "none",
        gap: colGap,
        padding: "24px 24px 12px 24px"
      },
      ".cancel-select-time": {
        borderTop: `1px solid ${theme.palette.grey[200]}`,
        margin: "0 -8px",
        paddingTop: 8
      }
    }
  };
});
tss$1.withParams().create(({ disabled }) => {
  return {
    root: {
      ".MuiFormHelperText-root": {
        margin: "3px 0 0 0"
      },
      ".MuiFormLabel-root.MuiInputLabel-root.Mui-error": {
        color: "inherit"
      },
      ".MuiInputBase-root.MuiOutlinedInput-root": {
        borderRadius: 8,
        paddingRight: 12
      },
      ".MuiInputBase-input.MuiOutlinedInput-input": {
        padding: "8px 12px"
      },
      ".MuiInputAdornment-root": {
        marginLeft: 0
      },
      fieldset: {
        display: "none"
      }
    },
    clockIcon: {
      cursor: "pointer",
      "& *": { cursor: "inherit" },
      pointerEvents: disabled ? "none" : "initial"
    }
  };
});
var TimesheetDetailCellStatus = /* @__PURE__ */ ((TimesheetDetailCellStatus2) => {
  TimesheetDetailCellStatus2["AUTOFILLED"] = "auto-filled";
  TimesheetDetailCellStatus2["LOADING"] = "loading";
  TimesheetDetailCellStatus2["STANDARD"] = "standard";
  return TimesheetDetailCellStatus2;
})(TimesheetDetailCellStatus || {});
var TimesheetTableColumnAccessorKey = /* @__PURE__ */ ((TimesheetTableColumnAccessorKey2) => {
  TimesheetTableColumnAccessorKey2["ACTION"] = "action";
  TimesheetTableColumnAccessorKey2["PROJECT"] = "project";
  TimesheetTableColumnAccessorKey2["TASK"] = "task";
  TimesheetTableColumnAccessorKey2["LABOR_CATEGORY"] = "laborCategory";
  TimesheetTableColumnAccessorKey2["LOCATION"] = "location";
  TimesheetTableColumnAccessorKey2["PROJECT_TYPE"] = "projectType";
  TimesheetTableColumnAccessorKey2["PAY_CODE"] = "payCode";
  TimesheetTableColumnAccessorKey2["TIME_CELLS"] = "timeCells";
  TimesheetTableColumnAccessorKey2["TOTAL"] = "total";
  return TimesheetTableColumnAccessorKey2;
})(TimesheetTableColumnAccessorKey || {});
var TimesheetTableColumnType = /* @__PURE__ */ ((TimesheetTableColumnType2) => {
  TimesheetTableColumnType2["ACTION"] = "action";
  TimesheetTableColumnType2["TIME"] = "time";
  TimesheetTableColumnType2["TIMESLIP"] = "timeslip";
  TimesheetTableColumnType2["TOTAL"] = "total";
  return TimesheetTableColumnType2;
})(TimesheetTableColumnType || {});
const DEFAULT_STICKY_ZINDEX = 2;
const STANDARD_ROW_HEIGHT = 48;
const TITO_ROW_HEIGHT = 88;
const disabledRowCell = (theme) => ({
  background: theme.palette.primary[25]
});
const lastItem = (theme) => ({
  borderRight: `1px solid ${theme.palette.grey[200]}`,
  boxShadow: "rgba(0,0,0,.25) -1px 0px 4px 1px",
  clipPath: "inset(1px -4px 0 0)"
});
const pinnedItem = () => ({
  position: "sticky",
  zIndex: DEFAULT_STICKY_ZINDEX
});
const standardRow = (theme) => ({
  height: STANDARD_ROW_HEIGHT,
  transition: theme.transitions.create("height")
});
const titoRow = (theme) => ({
  height: TITO_ROW_HEIGHT,
  transition: theme.transitions.create("height")
});
tss$1.withParams().create(({ theme }) => ({
  row: {
    display: "flex",
    overflow: "clip",
    position: "absolute",
    top: 0,
    transition: theme.transitions.create(["height"]),
    "&:last-child > td": {
      borderBottom: "none"
    }
  },
  standard: standardRow(theme),
  tito: titoRow(theme),
  last: lastItem(theme),
  pinned: pinnedItem(),
  instructionCell: {
    borderWidth: 0,
    height: "100%",
    left: 0,
    overflow: "visible",
    padding: 0,
    whiteSpace: "nowrap",
    width: 0,
    zIndex: 3
  },
  instructionLabel: {
    color: theme.palette.grey[700],
    fontSize: theme.typography.body2.fontSize,
    paddingLeft: 8,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)"
  },
  emptyCell: {
    background: "white"
  }
}));
const useTitoButtonState = (timeslip, timeInLabel, timeOutLabel) => {
  return reactExports.useMemo(() => {
    const titoEntries = timeslip?.titos ?? [];
    const missingTimeOuts = titoEntries.some((te) => !te.stopTime);
    return {
      color: missingTimeOuts ? "error" : "primary",
      label: missingTimeOuts ? timeOutLabel : timeInLabel
    };
  }, [timeslip?.titos, timeInLabel, timeOutLabel]);
};
var CommentStatus = /* @__PURE__ */ ((CommentStatus2) => {
  CommentStatus2["FILLED"] = "filled";
  CommentStatus2["REQUIRED"] = "required";
  CommentStatus2["STANDARD"] = "standard";
  return CommentStatus2;
})(CommentStatus || {});
const COMMENT_ICON_MAP = {
  [
    "filled"
    /* FILLED */
  ]: /* @__PURE__ */ jsxRuntimeExports.jsx(CommentCompletedIcon, {}),
  [
    "required"
    /* REQUIRED */
  ]: /* @__PURE__ */ jsxRuntimeExports.jsx(CommentRequiredIcon, {}),
  [
    "standard"
    /* STANDARD */
  ]: /* @__PURE__ */ jsxRuntimeExports.jsx(CommentIcon, {})
};
function getCommentIcon(status) {
  return COMMENT_ICON_MAP[status];
}
function isTimeslipCommentFilled(value) {
  if (!value) {
    return false;
  }
  return Boolean(
    value.comment || value.titos.length > 0 && value.titos.every((t16) => t16.comments)
  );
}
const useTimeCellStyles = tss$1.withParams().create(({ theme }) => ({
  cell: {
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    display: "flex",
    flexDirection: "column",
    padding: "3px 8px",
    position: "absolute",
    transition: theme.transitions.create(["background"], {
      duration: 150
    }),
    zIndex: 0,
    "&:hover, &:focus": {
      background: `${theme.palette.grey[50]} !important`
    }
  },
  standard: standardRow(theme),
  tito: titoRow(theme),
  // Daily tito input styling: The input displays a read-only hours total but
  // must allow the comment icon to remain clickable. We use readOnly instead of
  // disabled to prevent the entire input from blocking pointer events, then:
  // - pointerEvents: 'none' on the root disables clicking/focusing the input
  // - pointerEvents: 'auto' on IconButton re-enables the comment icon
  // - tabIndex: -1 removes the input from tab order (only icon is tabbable)
  // - WebkitTextFillColor: 'unset' overrides browser disabled text color
  dailyTitoCell: {
    borderBottom: "none"
  },
  dailyTitoInput: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.primary,
    pointerEvents: "none",
    "& .MuiInputBase-input": {
      color: theme.palette.text.disabled,
      WebkitTextFillColor: "unset"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.action.disabled
    },
    "& .MuiIconButton-root": {
      pointerEvents: "auto"
    }
  },
  dailyTitoInputInner: {
    paddingRight: 0,
    pointerEvents: "none"
  }
}));
reactExports.memo(function DailyTitoTimeCellRenderer({
  commentsVisible = true,
  id,
  isWeekend,
  minimumFractionDigits = 2,
  onCommentClicked,
  onDailyTitoButtonClick,
  showTitoButton = true,
  timeInLabel,
  timeOutLabel,
  value,
  virtualColumn,
  workDate
}) {
  const theme = useTheme();
  const { classes, cx: cx2 } = useTimeCellStyles({ theme });
  const { color: btnColor, label: btnLabel } = useTitoButtonState(
    value,
    timeInLabel,
    timeOutLabel
  );
  const hoursWorked = value?.hoursWorked ?? 0;
  const displayValue = hoursWorked > 0 ? hoursWorked.toString() : "";
  const commentStatus = isTimeslipCommentFilled(value) ? CommentStatus.FILLED : CommentStatus.STANDARD;
  const commentIcon = getCommentIcon(commentStatus);
  const _onTitoButtonClick = reactExports.useCallback(
    (event2) => {
      if (onDailyTitoButtonClick) {
        onDailyTitoButtonClick({
          buttonEvent: event2,
          timeslip: value,
          workDate
        });
      }
    },
    [onDailyTitoButtonClick, value, workDate]
  );
  const _onCommentClicked = reactExports.useCallback(() => {
    if (onCommentClicked) {
      onCommentClicked({ timeslip: value, workDate });
    }
  }, [onCommentClicked, value, workDate]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "td",
    {
      className: cx2(classes.cell, classes.dailyTitoCell, {
        [classes.standard]: !showTitoButton,
        [classes.tito]: showTitoButton
      }),
      id,
      style: {
        background: isWeekend ? theme.palette.grey[50] : "white",
        left: virtualColumn.start,
        width: virtualColumn.size
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          NumberInput,
          {
            baseInputProps: {
              className: classes.dailyTitoInput,
              endAdornment: commentsVisible ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                IconButton,
                {
                  onClick: _onCommentClicked,
                  sx: { color: "currentColor" },
                  children: commentIcon
                }
              ) : void 0,
              readOnly: true,
              slotProps: {
                input: {
                  className: classes.dailyTitoInputInner,
                  tabIndex: -1
                }
              }
            },
            id: `${id}-time-input`,
            minimumFractionDigits,
            trailingZeroDisplay: "auto",
            value: displayValue
          }
        ),
        showTitoButton && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button2,
          {
            color: btnColor,
            id: `${id}-time-tito-btn`,
            onClick: _onTitoButtonClick,
            startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(PlusIcon, { sx: { height: "14px", width: "15px" } }),
            variant: "tertiary",
            children: btnLabel
          }
        )
      ]
    }
  );
});
const useTotalCellStyles = tss$1.withParams().create(({ theme }) => ({
  cell: {
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    display: "flex",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: theme.typography.fontWeightMedium,
    justifyContent: "flex-end",
    lineHeight: "24px",
    padding: "4px 8px",
    position: "absolute",
    zIndex: 0
  },
  standard: {
    height: STANDARD_ROW_HEIGHT
  },
  tito: {
    height: TITO_ROW_HEIGHT
  }
}));
reactExports.memo(function DailyTitoTotalCellRenderer({
  id,
  showDailyTitoButtons,
  value,
  virtualColumn
}) {
  const theme = useTheme();
  const { classes, cx: cx2 } = useTotalCellStyles({ theme });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "td",
    {
      className: cx2(classes.cell, {
        [classes.standard]: !showDailyTitoButtons,
        [classes.tito]: showDailyTitoButtons
      }),
      id,
      style: {
        background: "white",
        left: virtualColumn.start,
        width: virtualColumn.size
      },
      children: value
    }
  );
});
const useActionCellStyles = tss$1.withParams().create(({ theme }) => ({
  cell: {
    background: theme.palette.common?.white ?? "white",
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    position: "absolute",
    zIndex: 1
  },
  deleteIcon: {
    color: theme.palette.error[800],
    height: 20,
    width: 20
  },
  disabled: disabledRowCell(theme),
  hide: { visibility: "hidden" },
  icon: {
    height: 30,
    width: 30
  },
  innerWrapper: {
    display: "flex",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "space-around"
  },
  last: lastItem(theme),
  pinned: pinnedItem(),
  standard: standardRow(theme),
  tito: titoRow(theme),
  tooltipContent: {
    whiteSpace: "pre-line"
  }
}));
reactExports.memo(
  function ActionCellRenderer({
    cell,
    hideDelete,
    id,
    isLast,
    isPinned,
    isRowProjectSelected,
    titoEnabled,
    virtualColumn
  }) {
    const { row, table } = cell.getContext();
    const tableMeta = table.options.meta?.timesheetTable;
    const theme = useTheme();
    const { classes, cx: cx2 } = useActionCellStyles({ theme });
    const handleDeleteRow = reactExports.useCallback(() => {
      const onDeleteRow = tableMeta?.handlers.onDeleteRow;
      if (onDeleteRow) {
        onDeleteRow(row);
      }
    }, [row.id, cell.id]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "td",
      {
        className: cx2({
          [classes.cell]: true,
          [classes.disabled]: !isRowProjectSelected,
          [classes.last]: isLast,
          [classes.pinned]: isPinned,
          [classes.standard]: !titoEnabled,
          [classes.tito]: titoEnabled
        }),
        id,
        style: {
          left: virtualColumn.start,
          width: virtualColumn.size
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classes.innerWrapper, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              className: cx2({
                [classes.icon]: true,
                [classes.hide]: hideDelete
              }),
              "data-test": `${id}-delete`,
              id: `${id}-delete`,
              onClick: handleDeleteRow,
              size: "small",
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(TrashIcon, { className: classes.deleteIcon })
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Tooltip2,
            {
              id: `timesheet-table-action-cell-project-info-icon-${cell.id}`,
              placement: "bottom-start",
              slotProps: {
                tooltip: {
                  style: { maxWidth: "unset", width: "fit-content" }
                },
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [47, 0]
                      }
                    }
                  ]
                }
              },
              title: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classes.tooltipContent, children: tableMeta?.labels.disabledInfoIcon }),
              children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                IconButton,
                {
                  className: classes.icon,
                  "data-test": `${id}-info`,
                  disabled: true,
                  id: `${id}-info`,
                  size: "small",
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoCircleIcon, {})
                }
              ) })
            }
          )
        ] })
      }
    );
  },
  (prevProps, nextProps) => {
    return prevProps.titoEnabled === nextProps.titoEnabled && prevProps.isLast === nextProps.isLast && prevProps.isPinned === nextProps.isPinned && prevProps.hideDelete === nextProps.hideDelete && prevProps.isRowProjectSelected === nextProps.isRowProjectSelected && prevProps.virtualColumn.start === nextProps.virtualColumn.start && prevProps.cell.id === nextProps.cell.id && prevProps.cell.row.original.key === nextProps.cell.row.original.key;
  }
);
const useDetailsCellStyles = tss$1.withParams().create(({ theme }) => ({
  autofill: {
    backgroundColor: theme.palette.success[25]
  },
  autofillIcon: {
    height: 18,
    position: "absolute",
    right: 2,
    top: 2,
    width: 18
  },
  base: {
    ..._base(theme),
    transition: "height 5s"
  },
  cell: {
    ..._base(theme),
    "&:hover, &:focus": {
      ..._inputVisible(theme)
    }
  },
  disabled: {
    ...disabledRowCell(theme),
    ..._inputVisible(theme)
  },
  innerWrapper: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    padding: "3px",
    position: "relative",
    width: "100%"
  },
  input: {
    "& .MuiAutocomplete-inputRoot": { backgroundColor: "rgba(0,0,0,0)" }
  },
  last: lastItem(theme),
  loading: {
    "& .MuiAutocomplete-popupIndicator": {
      opacity: 1
    }
  },
  pinned: pinnedItem(),
  standard: standardRow(theme),
  tito: titoRow(theme),
  unselectedProject: {
    "& .MuiAutocomplete-inputRoot": { borderColor: theme.palette.grey[200] },
    "& .MuiAutocomplete-popupIndicator": {
      opacity: 1
    }
  }
}));
const _base = (theme) => ({
  alignItems: "center",
  background: "white",
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  display: "flex",
  fontSize: 16,
  padding: 0,
  position: "absolute",
  "& .MuiAutocomplete-popupIndicator": {
    opacity: 0
  },
  "& .MuiFormHelperText-root": {
    display: "none !important"
  },
  "& .MuiAutocomplete-inputRoot": {
    transition: theme.transitions.create(["border-color", "padding-left"], {
      duration: 150
    }),
    borderColor: "rgba(0,0,0,0)",
    paddingRight: "0px !important",
    paddingLeft: "0px !important"
  }
});
const _inputVisible = (theme) => ({
  "& .MuiAutocomplete-inputRoot": {
    borderColor: theme.palette.grey[200],
    paddingRight: "20px !important",
    paddingLeft: "9px !important"
  },
  "& .MuiAutocomplete-popupIndicator": {
    opacity: 1
  }
});
reactExports.memo(
  function DetailsCellRenderer({
    cell,
    id,
    isLast,
    isPinned,
    isRowProjectSelected,
    status,
    titoEnabled,
    virtualColumn
  }) {
    const theme = useTheme();
    const { classes, cx: cx2 } = useDetailsCellStyles({ theme });
    const { column: column2, row, table } = cell.getContext();
    const { value } = cell.getValue() ?? null;
    const isAutofilled = status === TimesheetDetailCellStatus.AUTOFILLED;
    const isLoading = status === TimesheetDetailCellStatus.LOADING;
    const isProject = column2.id === TimesheetTableColumnAccessorKey.PROJECT;
    const tableMeta = table.options.meta?.timesheetTable;
    const options = _optionsBuilder({
      options: tableMeta?.timeslipOptions[column2.id],
      optionType: column2.id,
      row
    });
    const handleChange = reactExports.useCallback(
      (change) => {
        if (tableMeta?.handlers.onDetailChange) {
          tableMeta?.handlers.onDetailChange({ cell, change });
        }
      },
      [cell.id, tableMeta?.handlers.onDetailChange]
    );
    const inputDisabled = !isProject && !isRowProjectSelected;
    const hasOptions = options.length > 0;
    const renderInput = hasOptions || inputDisabled || isLoading;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "td",
      {
        className: cx2({
          [classes.base]: true,
          [classes.cell]: !inputDisabled,
          [classes.standard]: !titoEnabled,
          [classes.tito]: titoEnabled,
          [classes.disabled]: !isRowProjectSelected,
          [classes.last]: isLast,
          [classes.pinned]: isPinned,
          [classes.autofill]: isAutofilled,
          [classes.loading]: isLoading
        }),
        id,
        style: {
          left: virtualColumn?.start,
          width: virtualColumn?.size
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classes.innerWrapper, children: renderInput && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Dropdown,
            {
              className: !isRowProjectSelected ? classes.unselectedProject : classes.input,
              disabled: inputDisabled,
              fullWidth: true,
              hideClearIcon: true,
              id: `${id}-dropdown-input`,
              loading: isLoading,
              noOptionsText: isLoading ? tableMeta?.labels.detailColumnLoading : tableMeta?.labels.detailColumnNoOptions,
              onChange: handleChange,
              options,
              slotProps: {
                popper: {
                  style: {
                    maxWidth: 444,
                    minWidth: (virtualColumn?.size ?? 100) - 16,
                    width: "fit-content"
                  },
                  placement: "bottom-start"
                }
              },
              value
            }
          ) }),
          isAutofilled && /* @__PURE__ */ jsxRuntimeExports.jsx(AutofillIcon, { className: classes.autofillIcon })
        ]
      },
      cell.id
    );
  },
  (prevProps, nextProps) => {
    const prevValue = prevProps.cell.getValue();
    const nextValue = nextProps.cell.getValue();
    return prevProps.isLast === nextProps.isLast && prevProps.isPinned === nextProps.isPinned && prevProps.isRowProjectSelected === nextProps.isRowProjectSelected && prevProps.status === nextProps.status && prevProps.titoEnabled === nextProps.titoEnabled && prevProps.virtualColumn?.start === nextProps.virtualColumn?.start && prevValue?.value?.key === nextValue?.value?.key && prevProps.virtualColumn?.size === nextProps.virtualColumn?.size;
  }
);
const _buildLaborCatAndLocation = ({
  options,
  row
}) => {
  if (options instanceof Array) {
    return options;
  }
  if (options instanceof Map) {
    const rowKey = _getSelectedRowItem({ column: TimesheetTableColumnAccessorKey.TASK, row }) > -1 ? `${_getSelectedRowItem({ column: TimesheetTableColumnAccessorKey.TASK, row })}-${TimesheetTableColumnAccessorKey.TASK}` : `${_getSelectedRowItem({ column: TimesheetTableColumnAccessorKey.PROJECT, row })}-${TimesheetTableColumnAccessorKey.PROJECT}`;
    const castedOptions = options;
    return castedOptions?.get(rowKey) ?? [];
  }
  return [];
};
const _buildTaskAndPayCode = ({
  options,
  row
}) => {
  if (options instanceof Array) {
    return options;
  }
  if (options instanceof Map) {
    const projectKey = _getSelectedRowItem({ column: TimesheetTableColumnAccessorKey.PROJECT, row });
    const castedOptions = options;
    return castedOptions?.get(projectKey) ?? [];
  }
  return [];
};
const _getSelectedRowItem = ({
  column: column2,
  row
}) => row?.original[column2]?.value?.key ?? -1;
const _optionsBuilder = ({
  options,
  optionType,
  row
}) => {
  switch (optionType) {
    case TimesheetTableColumnAccessorKey.PROJECT:
    case TimesheetTableColumnAccessorKey.PROJECT_TYPE:
      return options instanceof Array ? options : [];
    case TimesheetTableColumnAccessorKey.TASK:
    case TimesheetTableColumnAccessorKey.PAY_CODE:
      return _buildTaskAndPayCode({ options, row });
    case TimesheetTableColumnAccessorKey.LABOR_CATEGORY:
    case TimesheetTableColumnAccessorKey.LOCATION:
      return _buildLaborCatAndLocation({ options, row });
    default:
      return [];
  }
};
reactExports.memo(
  function TimeCellRenderer({
    cell,
    columnTotal,
    commentsRequired,
    id,
    isRowProjectSelected,
    isWeekend,
    titoEnabled,
    value,
    virtualColumn
  }) {
    const theme = useTheme();
    const { classes, cx: cx2 } = useTimeCellStyles({ theme });
    const { table } = cell.getContext();
    const tableMeta = table.options.meta?.timesheetTable;
    const {
      onCellDoubleClick,
      onCommentClicked,
      onHoursBlur,
      onHoursChange,
      onTitoButtonClick
    } = tableMeta?.handlers ?? {};
    const { timeIn: timeInLabel, timeOut: timeOutLabel } = tableMeta?.labels ?? {};
    const commentsVisible = tableMeta?.commentsVisible;
    const minimumFractionDigits = tableMeta?.timeCellDecimalScale ?? 0;
    const { color: btnColor, label: btnLabel } = useTitoButtonState(
      value,
      timeInLabel,
      timeOutLabel
    );
    const titoEntries = value?.titos ?? [];
    const numberHoursWorked = value?.hoursWorked ?? 0;
    const hasWorkedHours = numberHoursWorked > 0;
    const hoursWorked = hasWorkedHours ? value?.hoursWorked.toString() : "";
    const showRequiredIcon = isRowProjectSelected && commentsRequired && hasWorkedHours;
    const commentStatus = isTimeslipCommentFilled(value) ? CommentStatus.FILLED : showRequiredIcon ? CommentStatus.REQUIRED : CommentStatus.STANDARD;
    const onBlur = reactExports.useCallback(
      (inputEvent) => {
        if (onHoursBlur) {
          onHoursBlur({
            cell,
            columnTotal,
            inputEvent
          });
        }
      },
      [cell.id, columnTotal, hoursWorked, onHoursBlur]
    );
    const onChange = reactExports.useCallback(
      (inputEvent) => {
        if (onHoursChange) {
          const changeDiff = Number(hoursWorked) - inputEvent.values.number;
          const updatedColumnTotal = columnTotal - changeDiff;
          onHoursChange({
            cell,
            columnTotal: updatedColumnTotal,
            inputEvent
          });
        }
      },
      [cell.id, columnTotal, hoursWorked, onHoursChange]
    );
    const _onCommentClicked = reactExports.useCallback(() => {
      if (onCommentClicked) {
        onCommentClicked(cell);
      }
    }, [cell.id, onCommentClicked]);
    const _onCellDoubleClick = reactExports.useCallback(() => {
      if (onCellDoubleClick) {
        onCellDoubleClick(cell);
      }
    }, [cell.id, onCellDoubleClick]);
    const _onTitoButtonClick = reactExports.useCallback(
      (event2) => {
        if (onTitoButtonClick) {
          onTitoButtonClick({ buttonEvent: event2, cell });
        }
      },
      [cell.id, onTitoButtonClick]
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "td",
      {
        className: cx2({
          [classes.cell]: true,
          [classes.standard]: !titoEnabled,
          [classes.tito]: titoEnabled
        }),
        id,
        onDoubleClick: isRowProjectSelected ? _onCellDoubleClick : void 0,
        style: {
          background: isWeekend ? theme.palette.grey[50] : !isRowProjectSelected ? theme.palette.primary[25] : "white",
          left: virtualColumn.start,
          width: virtualColumn.size
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            NumberInput,
            {
              baseInputProps: {
                endAdornment: commentsVisible ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                  IconButton,
                  {
                    disabled: !isRowProjectSelected,
                    onClick: _onCommentClicked,
                    sx: { color: "currentColor" },
                    children: getCommentIcon(commentStatus)
                  }
                ) : void 0,
                slotProps: {
                  input: {
                    sx: {
                      paddingRight: commentsVisible ? 0 : "12px",
                      pointerEvents: titoEntries.length > 0 ? "none" : "auto"
                    }
                  }
                }
              },
              disabled: !isRowProjectSelected || titoEntries.length > 0,
              id: `${id}-time-input`,
              minimumFractionDigits,
              onBlur,
              onChange,
              trailingZeroDisplay: "auto",
              value: hoursWorked
            }
          ),
          titoEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button2,
            {
              color: btnColor,
              disabled: !isRowProjectSelected,
              id: `${id}-time-tito-btn`,
              onClick: _onTitoButtonClick,
              startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(PlusIcon, { sx: { height: "14px", width: "15px" } }),
              variant: "tertiary",
              children: btnLabel
            }
          )
        ]
      },
      cell.id
    );
  },
  (prevProps, nextProps) => {
    const prev2 = prevProps.value;
    const next2 = nextProps.value;
    const titosEqual = prev2?.titos?.length === next2?.titos?.length && JSON.stringify(prev2?.titos) === JSON.stringify(next2?.titos);
    const valuesEqual = prev2?.hoursWorked === next2?.hoursWorked && prev2?.comment === next2?.comment && titosEqual;
    return prevProps.commentsRequired === nextProps.commentsRequired && prevProps.isRowProjectSelected === nextProps.isRowProjectSelected && prevProps.titoEnabled === nextProps.titoEnabled && prevProps.virtualColumn.start === nextProps.virtualColumn.start && valuesEqual;
  }
);
reactExports.memo(function TimeCellRenderer2({
  cell,
  id,
  virtualColumn,
  titoEnabled
}) {
  const theme = useTheme();
  const { classes, cx: cx2 } = useTotalCellStyles({ theme });
  const { row, table } = cell.getContext();
  const tableMeta = table.options.meta?.timesheetTable;
  const value = tableMeta?.totalMap.get(row.original.key);
  const { value: projectSelected } = row.original.project;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "td",
    {
      className: cx2(classes.cell, {
        [classes.standard]: !titoEnabled,
        [classes.tito]: titoEnabled
      }),
      id,
      style: {
        background: projectSelected ? "white" : theme.palette.primary[25],
        left: virtualColumn.start,
        width: virtualColumn.size
      },
      children: value ?? ""
    },
    cell.id
  );
});
const useTableHeaderStyles = tss$1.withParams().create(({ theme }) => ({
  cell: {
    alignItems: "center",
    backgroundColor: theme.palette.grey[100],
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    color: theme.palette.grey[700],
    display: "flex",
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    height: STANDARD_ROW_HEIGHT,
    lineHeight: theme.typography.body2.lineHeight,
    padding: "4px 8px",
    position: "absolute"
  },
  header: {
    backgroundColor: theme.palette.grey[100],
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    display: "flex",
    height: STANDARD_ROW_HEIGHT,
    position: "sticky",
    top: 0,
    zIndex: 1,
    "& th:first-of-type": {
      borderLeft: `1px solid ${theme.palette.grey[200]}`
    },
    "& th:last-child": {
      borderRight: `1px solid ${theme.palette.grey[200]}`
    }
  },
  hover: {
    transition: theme.transitions.create(["background", "opacity"], {
      duration: 200
    }),
    "&:hover, &:focus": {
      background: theme.palette.primary[25],
      "& > .unanet-column-options-btn": {
        opacity: 1
      }
    }
  },
  kabob: {
    opacity: 0,
    transition: theme.transitions.create(["background", "opacity"], {
      duration: 200
    }),
    "&:hover, &:focus": {
      background: theme.palette.grey[50],
      opacity: 1
    }
  },
  last: lastItem(theme),
  menuItem: {
    backgroundColor: theme.palette.common?.white,
    height: "44px",
    padding: "10px 14px",
    [`&.${menuItemClasses.focusVisible}`]: {
      backgroundColor: theme.palette.primary[25]
    },
    "&:hover": {
      background: theme.palette.primary[25]
    }
  },
  pinned: pinnedItem(),
  scrollPadding: { display: "flex" },
  cellContent: {
    flex: 1
  },
  cellContentLeft: {
    textAlign: "left"
  },
  cellContentRight: {
    textAlign: "right"
  },
  kabobButton: {
    borderRadius: 30,
    margin: 0,
    padding: 0
  },
  menuListProps: {
    backgroundColor: theme.palette.common?.white,
    padding: 0
  },
  menuPaper: {
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: "8px",
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    pointerEvents: "auto",
    width: 240
  },
  menuRoot: {
    pointerEvents: "none"
  },
  menuItemContent: {
    display: "flex",
    width: "100%"
  },
  menuItemLabel: {
    alignItems: "center",
    display: "flex",
    flex: 1,
    fontSize: 16,
    lineHeight: "24px"
  },
  menuItemIcon: {
    height: 20,
    marginRight: 8,
    width: 20
  },
  menuItemCheck: {
    alignItems: "center",
    display: "flex",
    flex: 1,
    justifyContent: "flex-end"
  },
  checkIcon: {
    height: 20,
    width: 20
  }
}));
const HeaderCell = reactExports.memo(function HeaderCellRenderer({
  header,
  id,
  isTimeslipCol,
  virtualColumn
}) {
  const theme = useTheme();
  const { classes, cx: cx2 } = useTableHeaderStyles({ theme });
  const [anchorEl, setAnchorEl] = reactExports.useState(null);
  const handlePopoverOpen = reactExports.useCallback(
    (event2) => {
      setAnchorEl(event2.currentTarget);
    },
    [setAnchorEl]
  );
  const handlePopoverClose = reactExports.useCallback(
    (event2) => {
      if (event2?.type === "keydown") {
        setTimeout(() => {
          document.getElementById(`${id}-kabob`)?.focus();
        }, 0);
      }
      setAnchorEl(null);
    },
    [setAnchorEl]
  );
  const isLast = header.column.getIsLastColumn("left");
  const { table } = header.getContext();
  const tableMeta = table.options.meta?.timesheetTable;
  const freezeLabel = tableMeta?.labels.headerFreeze;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "th",
    {
      className: cx2({
        [classes.cell]: true,
        [classes.hover]: true,
        [classes.last]: isLast,
        [classes.pinned]: Boolean(header?.column.getIsPinned())
      }),
      id,
      onMouseLeave: handlePopoverClose,
      style: {
        left: virtualColumn?.start ?? header.getStart(),
        width: virtualColumn?.size ?? header.getSize()
      },
      tabIndex: 0,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: cx2(classes.cellContent, {
              [classes.cellContentLeft]: isTimeslipCol,
              [classes.cellContentRight]: !isTimeslipCol
            }),
            children: flexRender(header.column.columnDef.header, header.getContext())
          }
        ),
        header.column.getCanPin() && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button2,
          {
            "aria-label": "Column options",
            className: cx2(
              classes.kabob,
              classes.kabobButton,
              "unanet-column-options-btn"
            ),
            disableElevation: true,
            disableFocusRipple: true,
            disableRipple: true,
            disableTouchRipple: true,
            iconOnly: true,
            id: `${id}-kabob`,
            onClick: handlePopoverOpen,
            onMouseEnter: handlePopoverOpen,
            startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(KabobIcon, {}),
            style: anchorEl ? { opacity: 1 } : void 0,
            tabIndex: 0,
            variant: "tertiary"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Menu$1,
          {
            anchorEl,
            anchorOrigin: {
              vertical: 40,
              horizontal: -190
            },
            disableRestoreFocus: true,
            id: `${id}-menu`,
            MenuListProps: { className: classes.menuListProps },
            onClose: handlePopoverClose,
            open: Boolean(anchorEl),
            slotProps: {
              root: {
                className: classes.menuRoot
              },
              paper: {
                className: classes.menuPaper,
                onMouseLeave: handlePopoverClose
              }
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              MenuItem$1,
              {
                className: classes.menuItem,
                id: `${id}-menu-freeze-item`,
                onClick: (event2) => {
                  handlePopoverClose(event2);
                  const val = header.column.getIsPinned() ? false : "left";
                  header.column.pin(val);
                },
                children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classes.menuItemContent, children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: classes.menuItemLabel, children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(LeadingColumnIcon, { className: classes.menuItemIcon }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: freezeLabel })
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classes.menuItemCheck, children: header.column.getIsPinned() && /* @__PURE__ */ jsxRuntimeExports.jsx(Check, { className: classes.checkIcon }) })
                ] })
              }
            )
          }
        )
      ]
    }
  );
});
reactExports.memo(function TableHeaderRenderer({
  headers,
  id,
  isSticky,
  start: start2,
  virtualColumns,
  width: width2
}) {
  const theme = useTheme();
  const { classes } = useTableHeaderStyles({ theme });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "tr",
    {
      className: classes.header,
      id: `${id}-row`,
      style: isSticky ? { position: "sticky", width: width2 } : {
        //this should always be a `style` as it changes on scroll
        position: "absolute",
        transform: `translateY(${start2}px)`,
        width: width2
      },
      children: virtualColumns.map((vc2) => {
        const header = headers[vc2.index];
        const isTimeslipCol = header.column.columnDef.meta?.timesheetTable?.type === TimesheetTableColumnType.TIMESLIP;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          HeaderCell,
          {
            header,
            id: `${id}-cell-${header.column.id}`,
            isTimeslipCol,
            virtualColumn: vc2
          },
          header.id
        );
      })
    }
  );
});
reactExports.memo(function DailyTitoTableHeaderRenderer({
  dailyHoursLabel,
  headers,
  id,
  virtualColumns,
  width: width2
}) {
  const theme = useTheme();
  const { classes, cx: cx2 } = useTableHeaderStyles({ theme });
  const firstTimeslipIndex = virtualColumns.findIndex((vc2) => {
    const columnType = headers[vc2.index].column.columnDef.meta?.timesheetTable?.type;
    return columnType === TimesheetTableColumnType.TIMESLIP;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { className: classes.header, id, style: { width: width2 }, children: virtualColumns.map((vc2, index2) => {
    const header = headers[vc2.index];
    const isLast = header.column.getIsLastColumn("left");
    const columnType = header.column.columnDef.meta?.timesheetTable?.type;
    const isTimeslipCol = columnType === TimesheetTableColumnType.TIMESLIP;
    const isTimeCol = columnType === TimesheetTableColumnType.TIME;
    let cellContent = null;
    if (isTimeslipCol && index2 === firstTimeslipIndex) {
      cellContent = dailyHoursLabel;
    } else if (isTimeCol) {
      cellContent = flexRender(
        header.column.columnDef.header,
        header.getContext()
      );
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "th",
      {
        className: cx2({
          [classes.cell]: true,
          [classes.last]: isLast,
          [classes.pinned]: Boolean(header?.column.getIsPinned())
        }),
        id: `${id}-tito-cell-${header.column.id}`,
        style: {
          left: vc2?.start ?? header.getStart(),
          width: vc2?.size ?? header.getSize()
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: cx2(classes.cellContent, {
              [classes.cellContentLeft]: isTimeslipCol,
              [classes.cellContentRight]: !isTimeslipCol
            }),
            children: cellContent
          }
        )
      },
      header.id
    );
  }) });
});
tss$1.withParams().create(({ theme }) => ({
  cell: {
    alignItems: "center",
    justifyContent: "flex-end",
    backgroundColor: "white",
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    color: theme.palette.grey[700],
    display: "flex",
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    height: STANDARD_ROW_HEIGHT,
    lineHeight: theme.typography.body1.lineHeight,
    padding: "8px 16px",
    paddingRight: 21,
    position: "absolute",
    transition: theme.transitions.create(["background", "opacity"], {
      duration: 200
    })
  },
  commentsVisible: {
    paddingRight: 47
  },
  footer: {
    bottom: 0,
    height: STANDARD_ROW_HEIGHT,
    position: "sticky"
  },
  last: { ...lastItem(theme), clipPath: "inset(0px -4px 0 0)" },
  pinned: pinnedItem(),
  row: {
    display: "flex",
    overflow: "clip"
  },
  total: {
    paddingRight: 8
  }
}));
reactExports.memo(function FooterCellRenderer({
  className,
  decimalScale,
  id,
  size,
  start: start2,
  value
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "th",
    {
      className,
      id,
      style: {
        left: start2,
        width: size
      },
      children: value ? value.toFixed(decimalScale) : ""
    }
  );
});
tss$1.create(() => ({
  emptyComponentWrapper: {
    position: "sticky",
    left: 0
  },
  table: {
    borderCollapse: "collapse",
    borderSpacing: 0
  },
  wrapper: {
    position: "relative",
    width: "100%",
    overflow: "auto"
  }
}));
DateTime.fromISO("1900-01-01");
DateTime.fromISO("2099-12-31");
const useVerticalTabStyles = tss$1.withParams().create(({ tabListWidth, theme }) => ({
  tab: {
    borderRadius: "6px",
    color: theme.palette.grey[900],
    height: 40,
    margin: "2px 8px",
    minHeight: 40,
    transition: theme.transitions.create(["background"]),
    "&:hover": {
      background: theme.palette.primary[25]
    },
    [`&.${buttonClasses.focusVisible}`]: {
      background: theme.palette.primary[25],
      color: theme.palette.blue[800]
    }
  },
  tabDisabled: {
    background: theme.palette.grey[100],
    color: theme.palette.grey[500]
  },
  tabInnerWrapper: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    width: "100%"
  },
  tabLabel: {
    ...theme.typography.body2,
    fontWeight: theme.typography.fontWeightMedium,
    marginRight: 8,
    overflow: "hidden",
    textOverflow: "ellipsis",
    textTransform: "none",
    whiteSpace: "nowrap"
  },
  tabList: {
    background: theme.palette.common?.white,
    borderRight: `1px solid ${theme.palette.grey[200]}`,
    width: tabListWidth
  },
  tabSelected: {
    background: theme.palette.primary[50]
  },
  wrapper: {
    flexGrow: 1,
    display: "flex",
    height: "100%"
  }
}));
reactExports.memo(
  function VerticalTabsRenderer({
    children,
    id,
    items,
    onChange,
    tabListAriaLabel,
    tabWidth = 240,
    value
  }) {
    const theme = useTheme();
    const { classes } = useVerticalTabStyles({ tabListWidth: tabWidth, theme });
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classes.wrapper, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(TabContext, { value, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TabList2,
        {
          "aria-label": tabListAriaLabel,
          classes: {
            root: classes.tabList
          },
          id: `${id}-tab-list`,
          onChange,
          orientation: "vertical",
          variant: "scrollable",
          children: items.map(({ badge: badge2, disabled, label, value: value2 }, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            Tab2,
            {
              classes: {
                disabled: classes.tabDisabled,
                root: classes.tab,
                selected: classes.tabSelected
              },
              disabled,
              id: `${id}-tab-${index2}`,
              label: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classes.tabInnerWrapper, children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classes.tabLabel, children: label }),
                !disabled && badge2
              ] }),
              value: value2
            },
            `${id}-tab-${index2}`
          ))
        }
      ),
      children
    ] }) });
  }
);
var HubTransactionStatus = /* @__PURE__ */ ((HubTransactionStatus2) => {
  HubTransactionStatus2["UNMATCHED"] = "UNMATCHED";
  HubTransactionStatus2["MATCHED"] = "MATCHED";
  HubTransactionStatus2["RECONCILED"] = "RECONCILED";
  return HubTransactionStatus2;
})(HubTransactionStatus || {});
var BankFeedStatus = /* @__PURE__ */ ((BankFeedStatus2) => {
  BankFeedStatus2["AUTO_MATCHED"] = "autoMatched";
  BankFeedStatus2["EXCLUDED"] = "excluded";
  BankFeedStatus2["IN_PROGRESS"] = "inProgress";
  BankFeedStatus2["MATCHED"] = "matched";
  BankFeedStatus2["UNMATCHED"] = "unmatched";
  return BankFeedStatus2;
})(BankFeedStatus || {});
const FinDocumentStatus = {
  APPROVED: "APPROVED",
  APPROVING: "APPROVING",
  DISAPPROVED: "DISAPPROVED",
  INUSE: "INUSE",
  POSTED: "POSTED",
  SUBMITTED: "SUBMITTED"
};
const FinDocumentType = {
  CP: "CP",
  D: "D",
  ICJE: "ICJE",
  ICVI: "ICVI",
  JE: "JE",
  VI: "VI",
  VP: "VP"
};
var TransactionType = /* @__PURE__ */ ((TransactionType2) => {
  TransactionType2["CREDITS"] = "CREDITS";
  TransactionType2["DEBITS"] = "DEBITS";
  return TransactionType2;
})(TransactionType || {});
const documentTypeToPostingFeature = {
  AL: "COST_POOL_POST",
  APR: "AP_REVALUATION",
  ARR: "AR_REVALUATION",
  BR: "BILLING_POST",
  CI: "INVOICE_POST",
  CMT: "COMMITMENT",
  CP: "CUSTOMER_PAYMENT_POST",
  D: "DEPOSIT_POST",
  EC: "EXPENSE_COST_POST",
  FA: "FIXED_ASSET_POST",
  FY: "GL_CLOSING",
  IC: "INTERCOMPANY_POST",
  JE: "JOURNAL_ENTRY_POST",
  LC: "LABOR_COST_POST",
  PILOB: "PILOB",
  SD: "STATISTICAL_DOCUMENT_POST",
  VI: "VENDOR_INVOICE_POST",
  VP: "VENDOR_PAYMENT_POST"
};
const convertAmountFromMinorUnits = ({
  amount,
  currency
}) => {
  const formatter = new UnanetNumberFormatter({
    currency: currency.toUpperCase(),
    style: "currency"
  });
  return formatter.convertFromMinorUnits(amount);
};
const getTransactionTypeDisplayName = ({
  pf: pf2,
  translate
}) => {
  const postingFeature = pf2 && documentTypeToPostingFeature[pf2] ? documentTypeToPostingFeature[pf2] : pf2;
  switch (postingFeature) {
    case PostingFeature.APREVALUATION:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.apRevaluation"
      );
    case PostingFeature.ARREVALUATION:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.arRevaluation"
      );
    case PostingFeature.BILLINGPOST:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.billingPost"
      );
    case PostingFeature.COMMITMENT:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.commitment"
      );
    case PostingFeature.COSTPOOLPOST:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.costPoolPost"
      );
    case PostingFeature.CUSTOMERPAYMENTPOST:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.customerPaymentPost"
      );
    case PostingFeature.DEPOSITPOST:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.depositPost"
      );
    case PostingFeature.EXPENSECOSTPOST:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.expenseCostPost"
      );
    case PostingFeature.FIXEDASSETPOST:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.fixedAssetPost"
      );
    case PostingFeature.GLCLOSING:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.glClosing"
      );
    case PostingFeature.INTERCOMPANYPOST:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.intercompanyPost"
      );
    case PostingFeature.INVOICEPOST:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.invoicePost"
      );
    case PostingFeature.JOURNALENTRYPOST:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.journalEntryPost"
      );
    case PostingFeature.LABORCOSTPOST:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.laborCostPost"
      );
    case PostingFeature.PILOB:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.pilob"
      );
    case PostingFeature.STATISTICALDOCUMENTPOST:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.statisticalDocumentPost"
      );
    case PostingFeature.VENDORINVOICEPOST:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.vendorInvoicePost"
      );
    case PostingFeature.VENDORPAYMENTPOST:
      return translate(
        "generalLedger.bankFeeds.postingFeature.displayName.vendorPaymentPost"
      );
  }
  return "";
};
const ADD_TRANSACTION_POSTING_FEATURES = [
  // TODO: Re-enable once document linking and auto-matching are implemented for these types
  // PostingFeature.CUSTOMERPAYMENTPOST,
  PostingFeature.DEPOSITPOST
  // PostingFeature.JOURNALENTRYPOST,
  // PostingFeature.VENDORINVOICEPOST,
  // PostingFeature.VENDORPAYMENTPOST,
];
const POSTING_FEATURE_PERMISSIONS = {
  [PostingFeature.CUSTOMERPAYMENTPOST]: [
    Role.Administrator,
    Role.ARPoster,
    Role.ARUser
  ],
  [PostingFeature.DEPOSITPOST]: [
    Role.Administrator,
    Role.ARPoster,
    Role.ARUser
  ],
  [PostingFeature.JOURNALENTRYPOST]: [
    Role.Administrator,
    Role.GLPoster,
    Role.GLUser
  ],
  [PostingFeature.VENDORINVOICEPOST]: [
    Role.Administrator,
    Role.APPoster,
    Role.APUser,
    Role.ViUser
  ],
  [PostingFeature.VENDORPAYMENTPOST]: [
    Role.Administrator,
    Role.APPoster,
    Role.APUser
  ]
};
const isPostingFeaturePermitted = ({
  me: me2,
  postingFeature
}) => {
  const allowedRoles = POSTING_FEATURE_PERMISSIONS[postingFeature];
  if (!allowedRoles) {
    return true;
  }
  if (!me2) {
    return false;
  }
  return allowedRoles.some((role) => hasRole(me2, role));
};
const getPermittedPostingFeatures = ({
  me: me2
}) => ADD_TRANSACTION_POSTING_FEATURES.filter(
  (postingFeature) => isPostingFeaturePermitted({ me: me2, postingFeature })
);
const getTransactionAddUrl = ({
  postingFeature,
  subdomain
}) => {
  switch (postingFeature) {
    case PostingFeature.JOURNALENTRYPOST:
      return `/${subdomain}/action/general_ledger/journal_entry/add`;
    case PostingFeature.VENDORINVOICEPOST:
      return `/${subdomain}/action/accounts_payable/vendor_invoice/add`;
    case PostingFeature.VENDORPAYMENTPOST:
      return `/${subdomain}/action/accounts_payable/vendor_payment/add`;
    case PostingFeature.CUSTOMERPAYMENTPOST:
      return `/${subdomain}/action/accounts_receivable/customer_payment/add`;
    case PostingFeature.DEPOSITPOST:
      return `/${subdomain}/action/accounts_receivable/deposit/add`;
  }
  return "";
};
const getTransactionTypeList = ({
  translate
}) => {
  return Object.values(PostingFeature).map((pf2, idx) => ({
    key: idx,
    // required for 'selected' state (checkmark) to be displayed accurately in dropdown
    name: getTransactionTypeDisplayName({ pf: pf2, translate }),
    type: pf2
  }));
};
const getTransactionViewUrl = ({
  subDomain,
  transaction
}) => {
  const postingFeature = transaction.documentType ? documentTypeToPostingFeature[transaction.documentType] ?? transaction.documentType : void 0;
  const finDocumentKey = transaction.finDocumentKey;
  if (finDocumentKey == null) {
    return "";
  }
  switch (postingFeature) {
    case "VENDOR_INVOICE_POST": {
      return `/${subDomain}/action/accounts_payable/vendor_invoice/view?viKey=${finDocumentKey}`;
    }
    case "VENDOR_PAYMENT_POST": {
      return `/${subDomain}/action/accounts_payable/vendor_payment/view?vpKey=${finDocumentKey}`;
    }
    case "CUSTOMER_PAYMENT_POST": {
      return `/${subDomain}/action/accounts_receivable/customer_payment/view?cpKey=${finDocumentKey}`;
    }
    case "DEPOSIT_POST": {
      return `/${subDomain}/action/accounts_receivable/deposit/view?dKey=${finDocumentKey}`;
    }
    case "JOURNAL_ENTRY_POST": {
      return `/${subDomain}/action/general_ledger/journal_entry/view?jeKey=${finDocumentKey}`;
    }
    default: {
      return "";
    }
  }
};
const getDocumentLinkViewUrl = ({
  documentLink,
  subDomain
}) => {
  const { documentType, finDocumentKey } = documentLink;
  if (finDocumentKey == null) {
    return "";
  }
  switch (documentType) {
    case FinDocumentType.VI:
      return `/${subDomain}/action/accounts_payable/vendor_invoice/view?viKey=${finDocumentKey}`;
    case FinDocumentType.VP:
      return `/${subDomain}/action/accounts_payable/vendor_payment/view?vpKey=${finDocumentKey}`;
    case FinDocumentType.CP:
      return `/${subDomain}/action/accounts_receivable/customer_payment/view?cpKey=${finDocumentKey}`;
    case FinDocumentType.D:
      return `/${subDomain}/action/accounts_receivable/deposit/view?dKey=${finDocumentKey}`;
    case FinDocumentType.JE:
      return `/${subDomain}/action/general_ledger/journal_entry/view?jeKey=${finDocumentKey}`;
    case FinDocumentType.ICJE:
      return `/${subDomain}/action/general_ledger/intercompany_journal_entry/view?jeKey=${finDocumentKey}`;
    case FinDocumentType.ICVI:
      return `/${subDomain}/action/accounts_payable/intercompany_vendor_invoice/view?icviKey=${finDocumentKey}`;
    default:
      return "";
  }
};
const getFinDocumentTypeDisplayName = ({
  documentType,
  translate
}) => {
  switch (documentType) {
    case FinDocumentType.CP:
      return translate("generalLedger.finDocumentType.displayName.cp");
    case FinDocumentType.D:
      return translate("generalLedger.finDocumentType.displayName.d");
    case FinDocumentType.ICJE:
      return translate("generalLedger.finDocumentType.displayName.icje");
    case FinDocumentType.ICVI:
      return translate("generalLedger.finDocumentType.displayName.icvi");
    case FinDocumentType.JE:
      return translate("generalLedger.finDocumentType.displayName.je");
    case FinDocumentType.VI:
      return translate("generalLedger.finDocumentType.displayName.vi");
    case FinDocumentType.VP:
      return translate("generalLedger.finDocumentType.displayName.vp");
  }
  return documentType ?? "";
};
const getFinDocumentStatusDisplayName = ({
  status,
  translate
}) => {
  switch (status) {
    case FinDocumentStatus.APPROVED:
      return translate("generalLedger.finDocumentStatus.displayName.approved");
    case FinDocumentStatus.APPROVING:
      return translate("generalLedger.finDocumentStatus.displayName.approving");
    case FinDocumentStatus.DISAPPROVED:
      return translate(
        "generalLedger.finDocumentStatus.displayName.disapproved"
      );
    case FinDocumentStatus.INUSE:
      return translate("generalLedger.finDocumentStatus.displayName.inuse");
    case FinDocumentStatus.POSTED:
      return translate("generalLedger.finDocumentStatus.displayName.posted");
    case FinDocumentStatus.SUBMITTED:
      return translate("generalLedger.finDocumentStatus.displayName.submitted");
  }
  return "";
};
const fetchBankTransaction = async ({
  hubURL,
  platformToken,
  transactionID
}) => {
  try {
    const bankTransaction = await getBankTransaction({
      hubURL,
      platformToken,
      transactionID
    });
    return {
      ...bankTransaction,
      amount: convertAmountFromMinorUnits({
        amount: bankTransaction.amount,
        currency: bankTransaction.currency
      })
    };
  } catch (e) {
    log.warn({
      msg: `Fetching bank transaction with ID ${transactionID} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const getBankFeedTransaction = async ({
  accountID,
  bankAccountKey,
  hubURL,
  platformToken,
  transactionID
}) => {
  try {
    const transaction = await getBankFeedTransaction$1({
      accountID,
      bankAccountKey,
      hubURL,
      platformToken,
      transactionID
    });
    return {
      ...transaction,
      amount: convertAmountFromMinorUnits({
        amount: transaction.amount,
        currency: transaction.currency
      })
    };
  } catch (e) {
    log.warn({
      msg: `Fetching bank feed transaction with ID ${transactionID} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchHubTransactions = async ({
  hubURL,
  platformToken,
  query
}) => {
  try {
    const response = await searchHubTransactions({
      hubURL,
      platformToken,
      query
    });
    return {
      ...response,
      transactions: response.transactions.map((transaction) => ({
        ...transaction,
        amount: convertAmountFromMinorUnits({
          amount: transaction.amount,
          currency: transaction.currency
        })
      }))
    };
  } catch (e) {
    log.warn({
      msg: `Fetching hub transactions for account ${query.accountID} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const refreshHubTransactions = async ({
  accountID,
  hubURL,
  platformToken
}) => {
  try {
    await refreshBankAccountTransactions({
      accountID,
      hubURL,
      platformToken
    });
  } catch (e) {
    log.warn({
      msg: `Refreshing hub transactions for account ${accountID} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const getBankFeedsIntegrationUser = async () => {
  try {
    const users = await searchIntegrationUsers(
      {
        integrationUserType: IntegrationUserType.BANKFEEDSINTEGRATIONUSER
      },
      1,
      1
    );
    return users.resultCount > 0 ? users.items[0] : null;
  } catch (e) {
    log.warn({
      msg: "Fetching Bank Feeds integration user failed",
      error: `${e}`
    });
    throw e;
  }
};
const createBankFeedsIntegrationUser = async (orgKey) => {
  try {
    return await createIntegrationUser({
      integrationUserType: IntegrationUserType.BANKFEEDSINTEGRATIONUSER,
      orgKey
    });
  } catch (e) {
    log.warn({
      msg: "Creating Bank Feeds integration user failed",
      error: `${e}`
    });
    throw e;
  }
};
const resetBankFeedsIntegrationUser = async ({
  integrationUserKey,
  orgKey
}) => {
  try {
    const person = await getPerson$1(integrationUserKey);
    await updatePerson(integrationUserKey, {
      ...person,
      organization: { ...person.organization, key: orgKey }
    });
    await resetIntegrationUser(integrationUserKey);
  } catch (e) {
    log.warn({
      msg: "Resetting Bank Feeds integration user failed",
      error: `${e}`
    });
    throw e;
  }
};
const fetchBankFeedTransactions = async ({
  accountID,
  hubURL,
  limit,
  next: next2,
  platformToken,
  request: request2
}) => {
  try {
    const response = await searchBankFeedTransactions({
      accountID,
      hubURL,
      limit,
      next: next2,
      platformToken,
      request: request2
    });
    return {
      ...response,
      transactions: (response.transactions ?? []).map((transaction) => ({
        ...transaction,
        amount: convertAmountFromMinorUnits({
          amount: transaction.amount,
          currency: transaction.currency
        }),
        match: transaction.match ?? void 0
      }))
    };
  } catch (e) {
    log.warn({
      msg: `Fetching bank feed transactions for account ${accountID} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const aggregateBankFeedsMatchData = ({
  glDataMap,
  glKeys
}) => glKeys.reduce(
  (acc, key) => {
    const glData = glDataMap.get(key);
    if (!glData) {
      return acc;
    }
    acc.totalAmount += glData.amount;
    if (glData.documentNumber) {
      acc.documentNumbers.add(glData.documentNumber);
    }
    if (glData.documentType) {
      acc.documentTypes.add(glData.documentType);
    }
    return acc;
  },
  {
    documentNumbers: /* @__PURE__ */ new Set(),
    documentTypes: /* @__PURE__ */ new Set(),
    totalAmount: 0
  }
);
const buildMatchedTransaction = ({
  glDataMap,
  transaction
}) => {
  const hasHubMatchData = transaction.row.match?.glTransactions?.length || transaction.row.match?.matchedAmount;
  if (hasHubMatchData) {
    return transaction;
  }
  const glKeys = transaction.row.match?.glTransactions?.map((gl2) => gl2.generalLedgerKey) ?? [];
  if (glKeys.length === 0) {
    return transaction;
  }
  const { documentNumbers, documentTypes, totalAmount } = aggregateBankFeedsMatchData({ glDataMap, glKeys });
  if (documentNumbers.size === 0 && documentTypes.size === 0 && totalAmount === 0) {
    return transaction;
  }
  return {
    ...transaction,
    row: {
      ...transaction.row,
      match: {
        ...transaction.row.match,
        createdTimestamp: transaction.row.match?.createdTimestamp ?? "",
        glTransactions: transaction.row.match?.glTransactions?.map((gl2) => ({
          ...gl2,
          documentNumber: gl2.documentNumber ?? (documentNumbers.size > 0 ? [...documentNumbers][0] : void 0),
          documentType: gl2.documentType ?? (documentTypes.size > 0 ? [...documentTypes][0] : void 0)
        })) ?? [],
        key: transaction.row.match?.key ?? 0,
        matchedAmount: totalAmount
      }
    }
  };
};
const fetchLegalEntities = async () => {
  try {
    const legalEntities = await fetchLegalEntities$1();
    return legalEntities;
  } catch (e) {
    log.warn({
      msg: `fetching legal entities failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchBankAccountsByLegalEntity = async ({
  legalEntityKey
}) => {
  if (legalEntityKey) {
    try {
      const bankAccount2 = await fetchBankAccountsByLegalEntity$1({
        legalEntityKey
      });
      return bankAccount2;
    } catch (e) {
      log.warn({
        msg: `fetching bank accounts by legal entity legal entity key ${legalEntityKey} failed`,
        error: `${e}`
      });
      throw e;
    }
  }
};
const createBankReconciliation = async ({
  bankAccountKey,
  endingBalance,
  legalEntityKey,
  statementDate
}) => {
  try {
    const { key } = await createBankReconciliation$1({
      bankAccountKey,
      endingBalance,
      legalEntityKey,
      statementDate
    });
    return key;
  } catch (e) {
    log.warn({
      msg: `Creating bank reconciliation failed`,
      error: `${e}`
    });
    throw e;
  }
};
const updateBankReconciliationDetails = async ({
  bankReconciliationKey,
  generalLedgerKeys
}) => {
  try {
    await updateBankReconciliationDetails$1({
      bankReconciliationKey,
      generalLedgerKeys
    });
  } catch (e) {
    log.warn({
      msg: `Updating bank reconciliation details for ${bankReconciliationKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteBankReconciliation = async ({ key }) => {
  try {
    await deleteBankReconciliation$1(key);
    return key;
  } catch (e) {
    log.warn({ msg: "Deleting bank reconciliation failed", error: `${e}` });
    throw e;
  }
};
const fetchBankAccounts = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  name,
  bankAccountNumber
}) => {
  try {
    const bankAccounts$1 = await fetchBankAccounts$1({
      page,
      pageSize: pageSize2,
      name,
      bankAccountNumber
    });
    return bankAccounts$1.items;
  } catch (e) {
    log.warn({
      msg: `Fetching bank accounts failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchBankReconciliationVendors = async ({
  page = 1,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  name,
  code,
  active = true,
  legalEntityKeys
}) => {
  try {
    const transactions = await getAvailableVendors$1({
      page,
      pageSize: pageSize2,
      name,
      code,
      active,
      legalEntityKeys
    });
    return transactions;
  } catch (e) {
    log.warn({
      msg: `Searching bank reconciliation available vendors failed`,
      error: `${e}`
    });
    throw e;
  }
};
const searchBankReconciliationTransactions = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  query
}) => {
  try {
    const transactions = await searchTransactions({
      page,
      pageSize: pageSize2,
      query
    });
    return transactions;
  } catch (e) {
    log.warn({
      msg: `Searching bank reconciliation transactions failed`,
      error: `${e}`
    });
    throw e;
  }
};
const searchBankReconciliations = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  query
}) => {
  try {
    const reconciliations = await searchBankReconciliations$1({
      page,
      pageSize: pageSize2,
      query
    });
    return reconciliations;
  } catch (e) {
    log.warn({
      msg: `Searching bank reconciliations failed`,
      error: `${e}`
    });
    throw e;
  }
};
const matchTransaction = async ({
  bankAccountKey,
  matchedTransaction
}) => {
  try {
    const { key } = await createMatchedTransactions({
      bankAccountKey,
      matchedTransaction
    });
    return key;
  } catch (e) {
    log.warn({
      msg: `Matching transactions failed`,
      error: `${e}`
    });
    throw e;
  }
};
const updateMatchedTransaction = async ({
  bankAccountKey,
  matchedTransaction,
  matchedTransactionKey
}) => {
  try {
    await updateMatchedTransaction$1({
      bankAccountKey,
      matchedTransaction,
      matchedTransactionKey
    });
  } catch (e) {
    log.warn({
      msg: `Updating matched transaction ${matchedTransactionKey} for bank account ${bankAccountKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchLatestBankRec = async ({
  bankAccountKey,
  legalEntityKey
}) => {
  try {
    const result = await fetchLatestBankRec$1({
      bankAccountKey,
      legalEntityKey
    });
    return result;
  } catch (e) {
    log.warn({
      msg: `Fetching latest bank rec for bank account ${bankAccountKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const updateBankReconciliation = async ({
  bankReconciliationKey,
  body
}) => {
  try {
    await updateBankReconciliation$1({
      bankReconciliationKey,
      body
    });
  } catch (e) {
    log.warn({
      msg: `Updating bank reconciliation ${bankReconciliationKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const reconcileBankReconciliation = async ({
  bankReconciliationKey
}) => {
  try {
    await reconcileBankReconciliation$1({
      bankReconciliationKey
    });
  } catch (e) {
    log.warn({
      msg: `Reconciling bank reconciliation ${bankReconciliationKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const unreconcileBankReconciliation = async ({
  bankReconciliationKey
}) => {
  try {
    await unreconcileBankReconciliation$1({
      bankReconciliationKey
    });
  } catch (e) {
    log.warn({
      msg: `Unreconciling bank reconciliation ${bankReconciliationKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchMatchedTransactions = async ({
  bankAccountKey,
  page = 1,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  try {
    const result = await fetchMatchedTransactions$1({
      bankAccountKey,
      page,
      pageSize: pageSize2
    });
    return result;
  } catch (e) {
    log.warn({
      msg: `Fetching matched transactions for bank account ${bankAccountKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchMatchedTransactionDetail = async ({
  bankAccountKey,
  matchedTransactionKey
}) => {
  try {
    const result = await fetchMatchedTransactionDetail$1({
      bankAccountKey,
      matchedTransactionKey
    });
    return result;
  } catch (e) {
    log.warn({
      msg: `Fetching matched transaction detail ${matchedTransactionKey} for bank account ${bankAccountKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteMatchedTransaction = async ({
  bankAccountKey,
  matchedTransactionKey
}) => {
  try {
    await deleteMatchedTransaction$1({
      bankAccountKey,
      matchedTransactionKey
    });
  } catch (e) {
    log.warn({
      msg: `Deleting matched transaction ${matchedTransactionKey} for bank account ${bankAccountKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const excludeMatchedTransactions = async ({
  bankAccountKey,
  transactions
}) => {
  try {
    await excludeMatchedTransactions$1({
      bankAccountKey,
      body: {
        transactions: transactions.map((t16) => ({
          ...t16,
          // Convert empty strings to undefined so the field is omitted from the
          // request body — the platform API rejects blank exclusion reasons via
          // @NullOrNotBlank but allows the field to be absent.
          exclusionReason: t16.exclusionReason || void 0
        }))
      }
    });
  } catch (e) {
    log.warn({
      msg: `Excluding matched transactions for bank account ${bankAccountKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const restoreMatchedTransactions = async ({
  bankAccountKey,
  transactionKeys
}) => {
  try {
    await restoreMatchedTransactions$1({
      bankAccountKey,
      body: {
        transactionKeys
      }
    });
  } catch (e) {
    log.warn({
      msg: `Restoring matched transactions for bank account ${bankAccountKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteBankReconciliationAttachment = async ({
  attachmentKey,
  bankReconciliationKey
}) => {
  try {
    await deleteBankReconciliationAttachment$1({
      attachmentKey,
      bankReconciliationKey
    });
  } catch (e) {
    log.warn({
      msg: `Deleting attachment ${attachmentKey} for bank reconciliation ${bankReconciliationKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchBankReconciliation = async ({
  bankReconciliationKey
}) => {
  try {
    const result = await fetchBankReconciliation$1({
      bankReconciliationKey
    });
    return result;
  } catch (e) {
    log.warn({
      msg: `Fetching bank reconciliation for ${bankReconciliationKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchBankReconciliationDetails = async ({
  bankReconciliationKey,
  documentType,
  page = 1,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  throughDate,
  transactionEndDate,
  transactionStartDate,
  transactionType
}) => {
  try {
    const result = await fetchBankReconciliationDetails$1({
      bankReconciliationKey,
      documentType,
      page,
      pageSize: pageSize2,
      throughDate,
      transactionEndDate,
      transactionStartDate,
      transactionType
    });
    return result;
  } catch (e) {
    log.warn({
      msg: `Fetching bank reconciliation details for ${bankReconciliationKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchAllBankReconciliationDetails = async ({
  bankReconciliationKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  fetch: (page) => () => fetchBankReconciliationDetails$1({
    bankReconciliationKey,
    page,
    pageSize: pageSize2
  })
});
const fetchBankReconciliationAvailableCredits = async ({
  bankReconciliationKey,
  documentType,
  page = 1,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  throughDate,
  transactionEndDate,
  transactionStartDate
}) => {
  try {
    const result = await fetchBankReconciliationAvailableCredits$1({
      bankReconciliationKey,
      documentType,
      page,
      pageSize: pageSize2,
      throughDate,
      transactionEndDate,
      transactionStartDate
    });
    return result;
  } catch (e) {
    log.warn({
      msg: `Fetching bank reconciliation available credits for ${bankReconciliationKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchBankReconciliationAttachments = async ({
  bankReconciliationKey,
  page,
  pageSize: pageSize2
}) => {
  try {
    const result = await fetchBankReconciliationAttachments$1({
      bankReconciliationKey,
      page,
      pageSize: pageSize2
    });
    return result;
  } catch (e) {
    log.warn({
      msg: `Fetching attachments for bank reconciliation ${bankReconciliationKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchBankReconciliationAvailableDebits = async ({
  bankReconciliationKey,
  documentType,
  page = 1,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  throughDate,
  transactionEndDate,
  transactionStartDate
}) => {
  try {
    const result = await fetchBankReconciliationAvailableDebits$1({
      bankReconciliationKey,
      documentType,
      page,
      pageSize: pageSize2,
      throughDate,
      transactionEndDate,
      transactionStartDate
    });
    return result;
  } catch (e) {
    log.warn({
      msg: `Fetching bank reconciliation available debits for ${bankReconciliationKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchBankReconciliationAttachment = async ({
  attachmentKey,
  bankReconciliationKey
}) => {
  try {
    const result = await fetchBankReconciliationAttachment$1({
      attachmentKey,
      bankReconciliationKey
    });
    return result;
  } catch (e) {
    log.warn({
      msg: "Fetching attachment for bank reconciliation failed",
      attachmentKey,
      bankReconciliationKey,
      error: `${e}`
    });
    throw e;
  }
};
const createBankReconciliationAttachments = async ({
  bankReconciliationKey,
  files
}) => {
  const promises = files.map(async (file) => {
    const attachment = await fileToAttachment(file);
    return uploadBankReconciliationAttachment({
      bankReconciliationKey,
      attachment
    });
  });
  const results = await Promise.allSettled(promises);
  log.info({
    msg: "Bank reconciliation attachments uploaded",
    bankReconciliationKey,
    fileCount: files.length,
    rejected: results.filter((r12) => r12.status === "rejected").length
  });
  if (results.some((r12) => r12.status === "rejected")) {
    throw new AppError(
      "Error uploading bank reconciliation attachments",
      ErrorCode.None
    );
  }
  return results.map((r12) => r12.status === "fulfilled" ? r12.value.key : -1);
};
const ENTITY_TYPE = "ORGANIZATION";
const RULE_TYPE = "ORGANIZATION_ALIAS";
const toOrganizationAlias = ({
  rule,
  ruleValue
}) => {
  if (!rule.key || !rule.entityKey) {
    return void 0;
  }
  let aliases2 = [];
  if (ruleValue?.value) {
    try {
      aliases2 = JSON.parse(ruleValue.value);
    } catch {
      log.warn({
        msg: `Failed to parse aliases for workflow rule ${rule.key}`
      });
    }
  }
  return {
    active: rule.active ?? false,
    aliases: aliases2,
    orgKey: rule.entityKey,
    orgName: rule.description ?? "",
    ruleKey: rule.key,
    valueKey: ruleValue?.key
  };
};
const toWorkflowRuleModel = (alias) => ({
  active: alias.active,
  description: alias.orgName,
  entityKey: alias.orgKey,
  entityType: ENTITY_TYPE,
  ruleType: RULE_TYPE
});
const toWorkflowRuleValueModel = (aliases2) => ({
  value: JSON.stringify(aliases2)
});
const fetchOrganizationAliases = async ({
  page,
  pageSize: pageSize2
} = {}) => {
  try {
    const rulesResponse = await fetchWorkflowRules({
      page,
      pageSize: pageSize2,
      ruleType: RULE_TYPE
    });
    const rules = rulesResponse.items ?? [];
    const aliases2 = await Promise.all(
      rules.map(async (rule) => {
        let ruleValue;
        if (rule.key) {
          try {
            const valuesResponse = await fetchWorkflowRuleValues({
              pageSize: 1,
              ruleKey: rule.key
            });
            ruleValue = valuesResponse.items?.[0];
          } catch (e) {
            log.warn({
              msg: `Failed to fetch workflow rule values for ruleKey ${rule.key}`,
              error: `${e}`
            });
          }
        }
        return toOrganizationAlias({ rule, ruleValue });
      })
    );
    return {
      // Filter out any rules that couldn't be mapped (missing required fields)
      items: aliases2.filter(
        (alias) => alias !== void 0
      ),
      resultCount: rulesResponse.resultCount
    };
  } catch (e) {
    log.warn({
      msg: "Fetching organization aliases failed",
      error: `${e}`
    });
    throw e;
  }
};
const createOrganizationAlias = async (alias) => {
  try {
    const ruleResponse = await createWorkflowRule(
      toWorkflowRuleModel(alias)
    );
    const ruleKey = ruleResponse.key;
    await createWorkflowRuleValue({
      body: toWorkflowRuleValueModel(alias.aliases),
      ruleKey
    });
    return ruleKey;
  } catch (e) {
    log.warn({
      msg: "Creating organization alias failed",
      error: `${e}`
    });
    throw e;
  }
};
const deleteOrganizationAlias = async (ruleKey) => {
  try {
    await deleteWorkflowRule({ ruleKey });
  } catch (e) {
    log.warn({
      msg: `Deleting organization alias with ruleKey ${ruleKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const toggleOrganizationAliasActiveStatus = async (alias) => {
  if (!alias.ruleKey) {
    const msg = "Cannot toggle organization alias active status: ruleKey is required";
    log.error({ msg });
    throw new Error(msg);
  }
  try {
    await updateWorkflowRule({
      body: toWorkflowRuleModel({ ...alias, active: !alias.active }),
      ruleKey: alias.ruleKey
    });
  } catch (e) {
    log.warn({
      msg: `Toggling active status for organization alias with ruleKey ${alias.ruleKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const updateOrganizationAlias = async (alias) => {
  if (!alias.ruleKey) {
    const msg = "Cannot update organization alias: ruleKey is required";
    log.error({ msg });
    throw new Error(msg);
  }
  let { valueKey } = alias;
  if (!valueKey) {
    try {
      const valuesResponse = await fetchWorkflowRuleValues({
        pageSize: 1,
        ruleKey: alias.ruleKey
      });
      valueKey = valuesResponse.items?.[0]?.key;
    } catch (e) {
      log.warn({
        msg: `Failed to fetch workflow rule values for ruleKey ${alias.ruleKey}`,
        error: `${e}`
      });
      throw e;
    }
  }
  try {
    const updateRule = updateWorkflowRule({
      body: toWorkflowRuleModel(alias),
      ruleKey: alias.ruleKey
    });
    if (valueKey) {
      await Promise.all([
        updateRule,
        updateWorkflowRuleValue({
          body: toWorkflowRuleValueModel(alias.aliases),
          ruleKey: alias.ruleKey,
          valueKey
        })
      ]);
    } else {
      log.warn({
        msg: `No workflow rule value found for ruleKey ${alias.ruleKey}, creating one`
      });
      await updateRule;
      await createWorkflowRuleValue({
        body: toWorkflowRuleValueModel(alias.aliases),
        ruleKey: alias.ruleKey
      });
    }
  } catch (e) {
    log.warn({
      msg: `Updating organization alias with ruleKey ${alias.ruleKey} failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchIndustries = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    const results = await fetchIndustries$1({ page, pageSize: pageSize2 });
    return results;
  } catch (e) {
    log.warn({
      msg: "Fetching industries failed",
      error: `${e}`
    });
    throw e;
  }
};
const forecast = async (params, signal) => {
  return request({
    url: "/inference/infer/strategy/forecast",
    method: "POST",
    body: params,
    options: { signal }
  });
};
const detectAnomalies = async (params, signal) => {
  return request({
    url: "/inference/infer/strategy/anomaly-detection",
    method: "POST",
    body: params,
    options: signal ? { signal } : void 0
  });
};
const optimizeCashFlow = async (params, signal) => {
  return request({
    url: "/inference/infer/strategy/cash-flow-optimization",
    method: "POST",
    body: params,
    options: signal ? { signal } : void 0
  });
};
const generateSummary = async (params, signal) => {
  return request({
    url: "/inference/infer/strategy/natural-language-summary",
    method: "POST",
    body: params,
    options: signal ? { signal } : void 0
  });
};
const detectRisks = async (params, signal) => {
  return request({
    url: "/inference/infer/strategy/risk-detection",
    method: "POST",
    body: params,
    options: signal ? { signal } : void 0
  });
};
const explainReport = async (params) => {
  return request({
    url: "/inference/infer/strategy/explain-report",
    method: "POST",
    body: params
  });
};
const explainReportSimplified = async (params, signal) => {
  return request({
    url: "/inference/infer/strategy/explain-report-simplified",
    method: "POST",
    body: params,
    options: signal ? { signal } : void 0
  });
};
var LeaveRequestSortByColumns = /* @__PURE__ */ ((LeaveRequestSortByColumns2) => {
  LeaveRequestSortByColumns2["BeginDate"] = "BEGIN_DATE";
  LeaveRequestSortByColumns2["Hours"] = "HOURS";
  LeaveRequestSortByColumns2["Status"] = "STATUS";
  LeaveRequestSortByColumns2["Comments"] = "COMMENTS";
  return LeaveRequestSortByColumns2;
})(LeaveRequestSortByColumns || {});
const getMyLeaveRequests = async ({
  endsAfter,
  page = 1,
  pageSize: pageSize2 = 10,
  sortBy: sortBy2 = LeaveRequestSortByColumns.BeginDate,
  sortOrder = "DESC",
  start: start2,
  statuses,
  ownerKey
}) => {
  try {
    const response = await getMyLeaveRequests$1({
      endsAfter,
      page,
      pageSize: pageSize2,
      sortBy: sortBy2,
      sortOrder,
      start: start2,
      statuses,
      ownerKey
    });
    return {
      page: response.page ?? page,
      pageSize: response.pageSize ?? pageSize2,
      resultCount: response.resultCount ?? 0,
      pageCount: response.pageCount ?? 0,
      items: response.items ?? []
    };
  } catch (e) {
    log.warn({
      msg: `Error fetching my leave requests: page: ${page} page size: ${pageSize2}`,
      error: `${e}`
    });
    throw e;
  }
};
const cancelMyLeaveRequest = async ({
  leaveRequestKey
}) => {
  try {
    await cancelMyLeaveRequest$1({ leaveRequestKey });
  } catch (e) {
    log.warn({
      msg: `Error canceling my leave request for key: ${leaveRequestKey}`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteMyLeaveRequest = async ({
  leaveRequestKey
}) => {
  try {
    await deleteMyLeaveRequest$1({ leaveRequestKey });
  } catch (e) {
    log.warn({
      msg: `Error deleting my leave request for key: ${leaveRequestKey}`,
      error: `${e}`
    });
    throw e;
  }
};
const getLeaveRequests = async ({
  page = 1,
  pageSize: pageSize2 = 10,
  sortBy: sortBy2 = LeaveRequestSortByColumns.BeginDate,
  sortOrder = "DESC",
  start: start2,
  end: end2,
  peopleKeys,
  statuses,
  statusStart,
  statusEnd
}) => {
  try {
    const response = await getLeaveRequests$1({
      page,
      pageSize: pageSize2,
      sortBy: sortBy2,
      sortOrder,
      start: start2,
      end: end2,
      peopleKeys,
      statuses,
      statusStart,
      statusEnd
    });
    return {
      page: response.page ?? page,
      pageSize: response.pageSize ?? pageSize2,
      resultCount: response.resultCount ?? 0,
      pageCount: response.pageCount ?? 0,
      items: response.items ?? []
    };
  } catch (e) {
    log.warn({
      msg: `Error fetching leave requests: page: ${page} page size: ${pageSize2}`,
      error: `${e}`
    });
    throw e;
  }
};
const cancelLeaveRequest = async ({
  leaveRequestKey
}) => {
  try {
    await cancelLeaveRequest$1({ leaveRequestKey });
  } catch (e) {
    log.warn({
      msg: `Error canceling leave request for key: ${leaveRequestKey}`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteLeaveRequest = async ({
  leaveRequestKey
}) => {
  try {
    await deleteLeaveRequest$1({ leaveRequestKey });
  } catch (e) {
    log.warn({
      msg: `Error deleting leave request for key: ${leaveRequestKey}`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchLocations = async (query) => fetchLocations$1(query);
const fetchAllLocations = async ({
  active,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  try {
    return await fetchAllItems({
      fetch: (page) => () => fetchLocations$1({ active, page, pageSize: pageSize2 })
    });
  } catch (e) {
    log.warn({
      msg: "Fetching all locations failed.",
      error: `${e}`
    });
    throw e;
  }
};
const getCoreUserInfo = async () => {
  try {
    const { user } = await getCoreUserInfo$1();
    const coreUser = {
      user: { ...user, platformToken: user.platformToken.split("") }
    };
    return coreUser;
  } catch (e) {
    log.warn({ msg: `Error getting core me`, error: `${e}` });
    throw e;
  }
};
const getMe = async () => {
  try {
    const _me2 = await getMe$1();
    return _me2;
  } catch (e) {
    log.warn({ msg: `Error getting me`, error: `${e}` });
    throw e;
  }
};
const getMeAlternatesFor = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    const myAlternates = await getMeAlternatesFor$1({ page, pageSize: pageSize2 });
    return myAlternates;
  } catch (e) {
    log.warn({ msg: `Error getting my alternates`, error: `${e}` });
    throw e;
  }
};
const getAllMeAlternatesFor = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  fetch: (page) => () => getMeAlternatesFor$1({ page, pageSize: pageSize2 }),
  errorMessage: `Fetching all people that I'm an alternate for failed`
});
const getMyMenu = async () => {
  try {
    const myMenu = await getMyMenu$1();
    return myMenu;
  } catch (e) {
    log.warn({ msg: "Error getting my menu from unanet core" });
    throw e;
  }
};
const fetchAllNaicsCodes = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  fetch: (page) => () => fetchNaicsCodes({ page, pageSize: pageSize2 }),
  errorMessage: `Fetching all NAICS codes failed.`
});
const fetchList = async ({ page = 1, pageSize: pageSize2 = 50 } = {}) => get$1(
  url("/organizations", { page, pageSize: pageSize2 })
);
const searchOrganizations = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  params = {}
}) => searchOrganizations$1(page, pageSize2, params);
const getOrganizationVendorProfiles = async ({
  page = 1,
  pageSize: pageSize2 = 50,
  id
}) => {
  const results = await getOrganizationVendorProfiles$1(
    page,
    pageSize2,
    id
  );
  return mapListPage(results, (o) => ({
    key: o.key,
    code: o.legalEntity.code,
    name: o.legalEntity.name
  }));
};
const getAllOrganizationsVendorProfilesBatch = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  orgIds = []
}) => {
  try {
    const vendorPromises = orgIds.map(
      (id) => fetchAllItems({
        fetch: (page) => () => getOrganizationVendorProfiles$1(page, pageSize2, id)
      })
    );
    const results = await Promise.all(vendorPromises);
    return results.flat();
  } catch (e) {
    log.warn({
      msg: "Returning all organization vendor profiles failed",
      error: `${e}`
    });
    throw e;
  }
};
const getOrganizationList = async ({
  active = true,
  financialOrg
}) => {
  try {
    return await listOrganizations({
      active,
      // only utilize financial org filter when feature is enabled
      financialOrg: helpers.bool("unanet.financials.use_financial_orgs") ? financialOrg : void 0
    });
  } catch (e) {
    log.warn({
      msg: "Getting all Basic Organizations (List) failed",
      error: `${e}`
    });
    throw e;
  }
};
const getOrganization = async ({
  key
}) => {
  try {
    return await getOrganization$1({
      key
    });
  } catch (e) {
    log.warn({
      msg: `Getting Organization Model failed for key: ${key}`,
      error: `${e}`
    });
    throw e;
  }
};
const getOrganizationContacts = async ({
  page = 1,
  pageSize: pageSize2 = 500,
  id
}) => {
  try {
    return await getOrganizationContacts$1(page, pageSize2, id);
  } catch (e) {
    log.warn({
      msg: `Getting Organization Contacts failed for key: ${id}`,
      error: `${e}`
    });
    throw e;
  }
};
var __create$1 = Object.create;
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __knownSymbol$1 = (name, symbol) => (symbol = Symbol[name]) ? symbol : /* @__PURE__ */ Symbol.for("Symbol." + name);
var __typeError$1 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __decoratorStart$1 = (base) => [, , , __create$1(null)];
var __decoratorStrings$1 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$1 = (fn3) => fn3 !== void 0 && typeof fn3 !== "function" ? __typeError$1("Function expected") : fn3;
var __decoratorContext$1 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$1[kind], name, metadata, addInitializer: (fn3) => done._ ? __typeError$1("Already initialized") : fns.push(__expectFn$1(fn3 || null)) });
var __decoratorMetadata$1 = (array, target) => __defNormalProp$1(target, __knownSymbol$1("metadata"), array[3]);
var __runInitializers$1 = (array, flags, self2, value) => {
  for (var i = 0, fns = array[flags >> 1], n12 = fns && fns.length; i < n12; i++) fns[i].call(self2);
  return value;
};
var __decorateElement$1 = (array, flags, name, decorators, target, extra) => {
  var it, done, ctx, access, k = flags & 7, s12 = false, p = false;
  var j = 2, key = __decoratorStrings$1[k + 5];
  var extraInitializers = array[j] || (array[j] = []);
  var desc = (target = target.prototype, __getOwnPropDesc$1(target, name));
  for (var i = decorators.length - 1; i >= 0; i--) {
    ctx = __decoratorContext$1(k, name, done = {}, array[3], extraInitializers);
    {
      ctx.static = s12, ctx.private = p, access = ctx.access = { has: (x) => name in x };
      access.get = (x) => x[name];
    }
    it = (0, decorators[i])(desc[key], ctx), done._ = 1;
    __expectFn$1(it) && (desc[key] = it);
  }
  return desc && __defProp$1(target, name, desc), target;
};
var _getOrganizationList_dec, _init$1;
_getOrganizationList_dec = [cached("Organizations")];
class OrganizationsCachedApi {
  constructor() {
    __runInitializers$1(_init$1, 5, this);
  }
  async getOrganizationList(arg2) {
    return getOrganizationList(arg2);
  }
}
_init$1 = __decoratorStart$1();
__decorateElement$1(_init$1, 1, "getOrganizationList", _getOrganizationList_dec, OrganizationsCachedApi);
__decoratorMetadata$1(_init$1, OrganizationsCachedApi);
const organizationsCachedApi = new OrganizationsCachedApi();
class Organization {
  constructor(values2) {
    this.name = "";
    this.code = "";
    this.requiresActivation = false;
    this.assign(values2);
  }
  assign(values2) {
    if (!values2) {
      return;
    }
    Object.assign(this, values2);
  }
}
const organizationDisplayName = (o) => {
  if (!o) {
    return "";
  }
  const code = o.code?.trim();
  const name = o.name?.trim();
  if (code && name) {
    return `${code} – ${name}`;
  }
  return code || name || "";
};
const organizationVendorProfileSummaryDisplayName = (o) => o ? `${o.code} – ${o.name}` : "";
const organizationVendorProfileDisplayName = (o) => o ? `${o?.code} – ${o?.name}` : "";
const index$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Organization,
  fetchList,
  getAllOrganizationsVendorProfilesBatch,
  getOrganization,
  getOrganizationContacts,
  getOrganizationList,
  getOrganizationVendorProfiles,
  organizationDisplayName,
  organizationVendorProfileDisplayName,
  organizationVendorProfileSummaryDisplayName,
  organizationsCachedApi,
  searchOrganizations
}, Symbol.toStringTag, { value: "Module" }));
const getAllPayCodes = async ({
  active = true,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  return fetchAllItems({
    fetch: (page) => () => fetchPayCodes({ page, pageSize: pageSize2, active }),
    errorMessage: "Fetching all pay codes failed"
  });
};
const createPaymentMethod = async (body) => {
  try {
    const { key } = await createPaymentMethod$1({ body });
    return key;
  } catch (e) {
    log.warn({
      msg: "Creating payment method failed",
      error: `${e}`
    });
    throw e;
  }
};
const deletePaymentMethod = async ({
  key
}) => {
  try {
    await deletePaymentMethod$1({ key });
  } catch (e) {
    log.warn({
      msg: "Deleting payment method failed",
      key,
      error: `${e}`
    });
    throw e;
  }
};
const fetchAllPaymentMethods = async ({
  activeOnly,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  errorMessage: "Fetching payment methods failed",
  fetch: (page) => () => fetchPaymentMethods$1({ activeOnly, page, pageSize: pageSize2 })
});
const fetchPaymentMethod = async ({
  key
}) => {
  try {
    return await fetchPaymentMethod$1({ key });
  } catch (e) {
    log.warn({
      msg: `Getting payment method of key ${key} failed`,
      error: `${e}`
    });
    return void 0;
  }
};
const fetchPaymentMethods = async ({
  activeOnly,
  page,
  pageSize: pageSize2 = 100
}) => {
  try {
    return await fetchPaymentMethods$1({
      activeOnly,
      page,
      pageSize: pageSize2
    });
  } catch (e) {
    log.warn({
      msg: "Fetching payment methods failed",
      error: `${e}`
    });
    throw e;
  }
};
const updatePaymentMethod = async (method) => {
  try {
    await updatePaymentMethod$1(method);
  } catch (e) {
    log.warn({
      msg: "Updating payment method failed",
      key: method.key,
      error: `${e}`
    });
    throw e;
  }
};
const fetchPaymentMethodAccountCategories = async () => {
  try {
    return await fetchPaymentMethodAccountCategories$1();
  } catch (e) {
    log.warn({
      msg: "Fetching payment method account categories failed",
      error: `${e}`
    });
    return [];
  }
};
const fetchPaymentMethodAccounts = async ({
  key
}) => {
  try {
    return await fetchPaymentMethodAccounts$1({ key });
  } catch (e) {
    log.warn({
      msg: `Getting payment method accounts for key ${key} failed`,
      error: `${e}`
    });
    return [];
  }
};
const updatePaymentMethodAccounts = async ({
  accounts: accounts2,
  key
}) => {
  try {
    await updatePaymentMethodAccounts$1({ accounts: accounts2, key });
  } catch (e) {
    log.warn({
      msg: "Updating payment method accounts failed",
      key,
      error: `${e}`
    });
    throw e;
  }
};
const createPaymentTerm = async (body) => {
  try {
    const { key } = await createPaymentTerm$1({ body });
    return key;
  } catch (e) {
    log.warn({
      msg: "Creating payment term failed",
      error: `${e}`
    });
    throw e;
  }
};
const deletePaymentTerm = async ({
  key
}) => {
  try {
    await deletePaymentTerm$1({ key });
  } catch (e) {
    log.warn({
      msg: "Deleting payment term failed",
      key,
      error: `${e}`
    });
    throw e;
  }
};
const fetchAllPaymentTerms = async ({
  active,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  errorMessage: "Fetching payment terms failed",
  fetch: (page) => () => fetchPaymentTerms$1({ active, page, pageSize: pageSize2 })
});
const fetchPaymentTerm = async ({
  key
}) => {
  try {
    return await fetchPaymentTerm$1({ key });
  } catch (e) {
    log.warn({
      msg: `Getting payment term of key ${key} failed`,
      error: `${e}`
    });
    return void 0;
  }
};
const fetchPaymentTerms = async ({
  active,
  page,
  pageSize: pageSize2 = 100
}) => {
  try {
    return await fetchPaymentTerms$1({ active, page, pageSize: pageSize2 });
  } catch (e) {
    log.warn({
      msg: "Fetching payment terms failed",
      error: `${e}`
    });
    throw e;
  }
};
const updatePaymentTerm = async (term) => {
  try {
    await updatePaymentTerm$1(term);
  } catch (e) {
    log.warn({
      msg: "Updating payment term failed",
      key: term.key,
      error: `${e}`
    });
    throw e;
  }
};
const PAYMENT_TERM_DEFAULT_STATE = {
  active: true,
  code: "",
  days: "",
  defaultSelected: false,
  description: "",
  discountDays: "",
  discountPercent: "",
  payWhenPaid: false
};
const fromPaymentTermModel = (term) => ({
  active: term.active ?? true,
  code: term.code,
  days: isNil(term.days) ? "" : String(term.days),
  defaultSelected: term.defaultSelected ?? false,
  description: term.description ?? "",
  discountDays: isNil(term.discountDays) ? "" : String(term.discountDays),
  discountPercent: isNil(term.discountPercent) ? "" : String(term.discountPercent),
  payWhenPaid: term.payWhenPaid ?? false
});
const toPaymentTermCreateModel = (state) => ({
  active: state.active,
  code: state.code.trim(),
  days: state.days !== "" ? Number(state.days) : void 0,
  defaultSelected: state.defaultSelected,
  description: state.description.trim() || void 0,
  discountDays: state.discountDays !== "" ? Number(state.discountDays) : void 0,
  discountPercent: state.discountPercent !== "" ? Number(state.discountPercent) : void 0,
  payWhenPaid: state.payWhenPaid
});
const toPaymentTermModel = (state, key) => ({
  key,
  ...toPaymentTermCreateModel(state)
});
const validatePaymentTermForm = (state) => {
  if (!state.code.trim()) {
    return "admin.accounting.paymentTerms.form.error.nameRequired";
  }
  const hasDiscountDays = state.discountDays !== "";
  const hasDiscountPercent = state.discountPercent !== "";
  if (hasDiscountPercent && Number(state.discountPercent) > 100) {
    return "admin.accounting.paymentTerms.form.error.discountPercentInvalid";
  }
  if (hasDiscountDays && !hasDiscountPercent) {
    return "admin.accounting.paymentTerms.form.error.discountPercentRequired";
  }
  if (!hasDiscountDays && hasDiscountPercent) {
    return "admin.accounting.paymentTerms.form.error.discountDaysRequired";
  }
  return null;
};
const toPropertyTemplateModelSDK = (templateForm) => {
  return {
    key: templateForm.key,
    name: templateForm.templateName,
    active: templateForm.active,
    properties: toPropertyTemplatePropertiesModelSDK(
      templateForm.propertiesTemplate
    )
  };
};
const toPropertyTemplatePropertiesModelSDK = (propertiesForm) => {
  return {
    enableTimesheetAuditTrail: propertiesForm.enableTimeSheetAudit,
    includeOtherAuditTrailChangeReason: propertiesForm.allowOtherChangeReasonAudit,
    enableEndUserAdjustment: propertiesForm.enableEndUserAdjustment,
    allowEndUserToDeleteTimesheet: propertiesForm.allowTimeSheetDelete,
    requireUserReviewTimesheet: propertiesForm.requireTimeSheetUserReview,
    requireCommentsWhenTimesheetSubmittedByNonOwner: propertiesForm.requireNonOwnerTimeSheetSubmissionComments,
    timesheetLockedUponCompletion: propertiesForm.lockTimeSheetOnComplete,
    includeOtherAdjustmentChangeReason: propertiesForm.allowOtherChangeReasonAdjustment,
    enableSpecialSituation: propertiesForm.enableExpenseSpecialSituation,
    specialSituationFactor: propertiesForm.expenseSpecialSituationFactor,
    requireUserReviewExpenseReport: propertiesForm.requireExpenseUserReview,
    expenseReportsLockedUponCompletion: propertiesForm.lockExpenseOnComplete
  };
};
const fromPropertyTemplateModelSDK = (templateModel) => {
  return {
    key: templateModel.key,
    templateName: templateModel.name,
    active: templateModel.active || false,
    propertiesTemplate: fromPropertyTemplatePropertiesModelSDK(
      templateModel.properties
    )
  };
};
const fromPropertyTemplatePropertiesModelSDK = (propertiesModel) => {
  return {
    enableTimeSheetAudit: propertiesModel.enableTimesheetAuditTrail || false,
    allowOtherChangeReasonAudit: propertiesModel.includeOtherAuditTrailChangeReason || false,
    enableEndUserAdjustment: propertiesModel.enableEndUserAdjustment || false,
    allowTimeSheetDelete: propertiesModel.allowEndUserToDeleteTimesheet || false,
    requireTimeSheetUserReview: propertiesModel.requireUserReviewTimesheet || false,
    requireNonOwnerTimeSheetSubmissionComments: propertiesModel.requireCommentsWhenTimesheetSubmittedByNonOwner || false,
    lockTimeSheetOnComplete: propertiesModel.timesheetLockedUponCompletion || false,
    allowOtherChangeReasonAdjustment: propertiesModel.includeOtherAdjustmentChangeReason || false,
    enableExpenseSpecialSituation: propertiesModel.enableSpecialSituation || false,
    expenseSpecialSituationFactor: propertiesModel.specialSituationFactor ?? 1,
    requireExpenseUserReview: propertiesModel.requireUserReviewExpenseReport || false,
    lockExpenseOnComplete: propertiesModel.expenseReportsLockedUponCompletion || false
  };
};
const createPropertyTemplate = async (model) => {
  try {
    const { key } = await createPropertyTemplate$1(
      toPropertyTemplateModelSDK(model)
    );
    return key;
  } catch (e) {
    log.warn({
      msg: "Creating Property template failed",
      ...model,
      error: `${e}`
    });
    throw e;
  }
};
const updatePropertyTemplate = async (model) => {
  try {
    await updatePropertyTemplate$1(
      toPropertyTemplateModelSDK(model)
    );
  } catch (e) {
    log.warn({
      msg: "Updating template settings failed",
      templateKey: model.key,
      error: `${e}`
    });
    throw e;
  }
};
const getPropertyTemplateDetails = async (templateKey) => {
  try {
    const response = await getPropertyTemplate(templateKey);
    return fromPropertyTemplateModelSDK(response);
  } catch (e) {
    log.warn({
      msg: "Fetching template settings failed",
      templateKey,
      error: `${e}`
    });
    throw e;
  }
};
const fetchAllPropertyTemplates = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  return fetchAllItems({
    fetch: (page) => () => fetchPropertyTemplatesList({
      page,
      pageSize: pageSize2
    }),
    errorMessage: "Fetching property template list failed"
  });
};
const fetchAllPropertyTemplateAuditDetails = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  templateKey
}) => {
  return fetchAllItems({
    fetch: (page) => () => getPropertyTemplateHistory({
      templateKey,
      page,
      pageSize: pageSize2
    }),
    errorMessage: "Fetching property template history failed"
  });
};
const hasPropertyTemplateAudit = async (templateKey) => {
  try {
    const results = await getPropertyTemplateHistory({
      templateKey
    });
    return results.resultCount > 0;
  } catch (e) {
    log.warn({
      msg: "Cannot determine if template has audit details",
      templateKey,
      error: `${e}`
    });
    throw e;
  }
};
const deletePropertyTemplate = async (templateKey) => {
  try {
    await deletePropertyTemplate$1({ templateKey });
  } catch (e) {
    log.warn({
      msg: "Deleting template failed",
      templateKey,
      error: `${e}`
    });
    throw e;
  }
};
const fetchAllTemplateOrgHistory = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  templateKey
}) => {
  return fetchAllItems({
    fetch: (page) => () => getTemplateOrgHistory({
      templateKey,
      page,
      pageSize: pageSize2
    }),
    errorMessage: "Fetching property template org history failed"
  });
};
const fetchAllTemplateOrgAuditHistory = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  templateList
}) => {
  const results = await Promise.all(
    templateList.map(
      (templateKey) => fetchAllTemplateOrgHistory({ templateKey, pageSize: pageSize2 })
    )
  );
  return results.flat();
};
const hasTemplateOrgAuditInfo = async (templateList) => {
  try {
    let index2 = 0;
    let hasResults = false;
    do {
      const templateKey = templateList[index2];
      const results = await getTemplateOrgHistory({
        templateKey
      });
      hasResults = results.resultCount > 0;
      if (hasResults) {
        break;
      }
      index2++;
    } while (index2 < templateList.length);
    return hasResults;
  } catch (e) {
    log.warn({
      msg: "Cannot determine if template has org audit details",
      error: `${e}`
    });
    throw e;
  }
};
const getAllLegalEntities = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  return fetchAllItems({
    fetch: (page) => () => searchOrganizations$1(page, pageSize2, {
      legalEntity: true
    }),
    errorMessage: "Fetching all legal entities failed"
  });
};
const fromPurchaseOrderSearch = (query) => {
  const queryModel = omit$1(query, [
    "dateRangeStart",
    "dateRangeEnd"
  ]);
  queryModel.poDateRange = {
    rangeStart: query.dateRangeStart ?? BOTKey$1,
    rangeEnd: query.dateRangeEnd ?? EOTKey$1
  };
  return queryModel;
};
const fromPurchaseOrderSummaryModel = (o) => {
  return {
    amount: o.amount,
    balance: o.balance,
    beginDate: DateTime.fromISO(o.beginDate),
    currency: o.currency,
    description: o.description,
    documentNumber: o.documentNumber,
    documentStatus: o.documentStatus,
    endDate: DateTime.fromISO(o.endDate),
    expenseAssignmentCount: o.expenseAssignmentCount,
    key: o.key,
    laborAssignmentCount: o.laborAssignmentCount,
    organization: o.organization,
    originalDocumentKey: o.originalDocumentKey,
    project: o.project,
    status: o.status,
    vendorOrg: o.vendorOrg
  };
};
const fromPurchaseOrderModel = (o) => {
  return {
    key: o.key,
    legalEntity: o.legalEntity,
    documentNumber: o.documentNumber,
    owningOrg: o.owningOrg,
    amount: o.amount,
    expectedValue: o.expectedValue,
    reference: o.reference,
    description: o.description,
    documentDate: o.documentNumber ? DateTime.fromISO(o.documentNumber) : null,
    requiredByDate: o.requiredByDate ? DateTime.fromISO(o.requiredByDate) : null,
    vendorOrg: o.vendorOrg,
    purchaser: o.purchaser,
    project: o.project,
    task: o.task,
    controller: o.controller,
    internalComments: o.internalComments,
    externalComments: o.externalComments,
    status: o.status ?? null,
    statusTimestamp: o.statusTimestamp ? DateTime.fromISO(o.statusTimestamp) : null,
    originalDocumentKey: o.originalDocumentKey,
    modNumber: o.modNumber,
    udfs: o.udfs?.values,
    purchaseRequestKey: o.purchaseRequestKey,
    closedDate: o.closedDate ? DateTime.fromISO(o.closedDate) : null,
    commitmentDate: o.commitmentDate ? DateTime.fromISO(o.commitmentDate) : null,
    beginDate: o.beginDate ? DateTime.fromISO(o.beginDate) : null,
    endDate: o.endDate ? DateTime.fromISO(o.endDate) : null,
    paymentTerm: o.paymentTerm,
    receiver: o.receiver,
    emailedByKey: o.emailedByKey,
    emailedTimestamp: o.emailedTimestamp ? DateTime.fromISO(o.emailedTimestamp) : null,
    printedByKey: o.printedByKey,
    printedTimestamp: o.printedTimestamp ? DateTime.fromISO(o.printedTimestamp) : null,
    viOverage: o.viOverage,
    owner: o.owner
  };
};
const LINE_ITEM_INITIAL = {
  LABOR: "L",
  EXPENSE: "E",
  ITEM: "I"
};
const getLineItemNumber = (row) => {
  return `${LINE_ITEM_INITIAL[row.lineType]}${row?.descriptor?.lineId}`;
};
const getPurchaseOrderAssignmentType = (assignment) => "laborCategory" in assignment ? "LABOR" : "EXPENSE";
const searchPurchaseOrders = async (page = 1, pageSize2 = 50, filter) => {
  const listPage = await searchPurchaseOrders$1(
    page,
    pageSize2,
    fromPurchaseOrderSearch(filter)
  );
  return mapListPage(listPage, fromPurchaseOrderSummaryModel);
};
const searchAllPurchaseOrders = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  filter
}) => {
  const items = await fetchAllItems({
    errorMessage: "Searching and returning all purchase orders failed",
    fetch: (page) => () => searchPurchaseOrders$1(page, pageSize2, filter)
  });
  return items.map(fromPurchaseOrderSummaryModel);
};
const purchaseOrderAccess = async (purchaseOrderKey) => {
  try {
    await get$1(`/purchase-orders/${purchaseOrderKey}`);
    return true;
  } catch (e) {
    return false;
  }
};
const getPurchaseOrder = async (purchaseOrderKey) => {
  try {
    const purchaseOrder = await with404(
      () => getPurchaseOrder$1(purchaseOrderKey),
      null
    );
    return purchaseOrder !== null ? fromPurchaseOrderModel(purchaseOrder) : null;
  } catch (e) {
    if (e instanceof HttpError && e.statusCode === 400) {
      return null;
    }
    throw e;
  }
};
const getPurchaseOrderBalances = async (purchaseOrderKey) => {
  try {
    const balances = await with404(
      () => getPurchaseOrderBalances$1(purchaseOrderKey),
      null
    );
    return balances !== null ? balances : null;
  } catch (e) {
    if (e instanceof HttpError && e.statusCode === 400) {
      return null;
    }
    throw e;
  }
};
const getPurchaseOrderVIBalances = async (purchaseOrderKey) => {
  try {
    const balances = await with404(
      () => getPurchaseOrderVIBalances$1(purchaseOrderKey),
      null
    );
    return balances !== null ? balances : null;
  } catch (e) {
    if (e instanceof HttpError && e.statusCode === 400) {
      return null;
    }
    throw e;
  }
};
const filterLineIds = (page, filter, lineType) => {
  if (page === null) {
    return page;
  }
  const items = page.items?.filter((item) => {
    let lineIds;
    {
      lineIds = filter?.laborLineIds;
    }
    return !lineIds || lineIds.includes(item?.descriptor?.lineId ?? -1);
  });
  return { ...page, items, resultCount: items?.length };
};
const getPurchaseOrderExpenses = async (request2) => {
  try {
    const poExpenses = await getPurchaseOrderExpenses$1(request2);
    return poExpenses;
  } catch (e) {
    log.warn({
      msg: `Error getting expense lines for purchase order: ${request2.purchaseOrderKey}`
    });
    throw e;
  }
};
const getPurchaseOrderItems = async (request2) => {
  try {
    const poItems = await getPurchaseOrderItems$1(request2);
    return poItems;
  } catch (e) {
    log.warn({
      msg: `Error getting item lines for purchase order: ${request2.purchaseOrderKey}`
    });
    throw e;
  }
};
const getPurchaseOrderLabor = async ({
  filter,
  page,
  pageSize: pageSize2,
  purchaseOrderKey
}) => {
  try {
    const { state, personName, name: laborCategoryName } = filter;
    const labor = await with404(
      () => getPurchaseOrderLabor$1({
        laborCategoryName,
        page,
        pageSize: pageSize2,
        personName,
        purchaseOrderKey,
        state
      }),
      null
    );
    return filterLineIds(labor, filter, "LABOR");
  } catch (e) {
    if (e instanceof HttpError && e.statusCode === 400) {
      return null;
    }
    throw e;
  }
};
const getAllPurchaseOrderAttachments = async ({
  purchaseOrderKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  try {
    const attachments = await with404(
      () => getPurchaseOrderAttachments({
        purchaseOrderKey,
        page: 1,
        pageSize: 1
      }),
      null
    );
    if (attachments == null) {
      return null;
    }
    return await fetchAllItems({
      fetch: (page) => () => getPurchaseOrderAttachments({
        purchaseOrderKey,
        page,
        pageSize: pageSize2
      })
    });
  } catch (e) {
    if (e instanceof HttpError && e.statusCode === 400) {
      return null;
    }
    throw e;
  }
};
const getPurchaseOrderLaborAssignments = async ({
  purchaseOrderKey,
  laborLineKey,
  page,
  pageSize: pageSize2 = 100
}) => {
  try {
    const assignments = await with404(
      () => getPurchaseOrderLaborAssignments$1({
        purchaseOrderKey,
        laborLineKey,
        page,
        pageSize: pageSize2
      }),
      null
    );
    return assignments !== null ? assignments : null;
  } catch (e) {
    if (e instanceof HttpError && e.statusCode === 400) {
      return null;
    }
    throw e;
  }
};
const getAllPurchaseOrderLaborAssignments = async ({
  purchaseOrderKey,
  laborLineKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const listPage = emptyListPage();
  for (let page = 1, pageCount = page; page <= pageCount; ++page) {
    try {
      const { items, ...pagingInfo } = await getPurchaseOrderLaborAssignments$1({
        purchaseOrderKey,
        laborLineKey,
        page,
        pageSize: pageSize2
      });
      pageCount = pagingInfo.pageCount;
      listPage.items.push(...items);
      Object.assign(listPage, pagingInfo);
    } catch (e) {
      if (e instanceof HttpError && [404, 400].includes(e.statusCode)) {
        return null;
      }
      throw e;
    }
  }
  return listPage;
};
const getPurchaseOrderExpenseAssignments = async (purchaseOrderKey) => {
  try {
    const assignments = await with404(
      () => getPurchaseOrderExpenseAssignments$1(purchaseOrderKey),
      null
    );
    return assignments !== null ? assignments : null;
  } catch (e) {
    if (e instanceof HttpError && e.statusCode === 400) {
      return null;
    }
    throw e;
  }
};
const getPurchaseOrderAvailableVendors = async ({
  page = 1,
  pageSize: pageSize2 = 100,
  name = "",
  code = "",
  active = true,
  legalEntityKeys
}) => {
  try {
    const vendors = await getAvailableVendors({
      page,
      pageSize: pageSize2,
      name,
      code,
      active,
      legalEntityKeys
    });
    return vendors.items ?? [];
  } catch (e) {
    if (e instanceof HttpError && e.statusCode === 400) {
      return [];
    }
    throw e;
  }
};
const getAllPurchaseOrderLegalEntities = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  active = true
} = {}) => {
  try {
    return await fetchAllItems({
      fetch: (page) => () => getLegalEntities({ active, page, pageSize: pageSize2 })
    });
  } catch (e) {
    if (e instanceof HttpError && e.statusCode === 400) {
      return [];
    }
    throw e;
  }
};
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __knownSymbol = (name, symbol) => (symbol = Symbol[name]) ? symbol : /* @__PURE__ */ Symbol.for("Symbol." + name);
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __decoratorStart = (base) => [, , , __create(null)];
var __decoratorStrings = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn = (fn3) => fn3 !== void 0 && typeof fn3 !== "function" ? __typeError("Function expected") : fn3;
var __decoratorContext = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings[kind], name, metadata, addInitializer: (fn3) => done._ ? __typeError("Already initialized") : fns.push(__expectFn(fn3 || null)) });
var __decoratorMetadata = (array, target) => __defNormalProp(target, __knownSymbol("metadata"), array[3]);
var __runInitializers = (array, flags, self2, value) => {
  for (var i = 0, fns = array[flags >> 1], n12 = fns && fns.length; i < n12; i++) fns[i].call(self2);
  return value;
};
var __decorateElement = (array, flags, name, decorators, target, extra) => {
  var it, done, ctx, access, k = flags & 7, s12 = false, p = false;
  var j = 2, key = __decoratorStrings[k + 5];
  var extraInitializers = array[j] || (array[j] = []);
  var desc = (target = target.prototype, __getOwnPropDesc(target, name));
  for (var i = decorators.length - 1; i >= 0; i--) {
    ctx = __decoratorContext(k, name, done = {}, array[3], extraInitializers);
    {
      ctx.static = s12, ctx.private = p, access = ctx.access = { has: (x) => name in x };
      access.get = (x) => x[name];
    }
    it = (0, decorators[i])(desc[key], ctx), done._ = 1;
    __expectFn(it) && (desc[key] = it);
  }
  return desc && __defProp(target, name, desc), target;
};
var _getPurchaseOrderAvailableVendors_dec, _searchAllPurchaseOrders_dec, _getAllPurchaseOrderLegalEntities_dec, _getPurchaseOrderLabor_dec, _getAllPurchaseOrderLaborAssignments_dec, _getPurchaseOrderLaborAssignments_dec, _init;
_getPurchaseOrderLaborAssignments_dec = [cached("PurchaseOrders")], _getAllPurchaseOrderLaborAssignments_dec = [cached("PurchaseOrders")], _getPurchaseOrderLabor_dec = [cached("PurchaseOrders")], _getAllPurchaseOrderLegalEntities_dec = [cached("PurchaseOrders")], _searchAllPurchaseOrders_dec = [cached("PurchaseOrders")], _getPurchaseOrderAvailableVendors_dec = [cached("PurchaseOrders")];
class PurchaseOrdersCachedApi {
  constructor() {
    __runInitializers(_init, 5, this);
  }
  async getPurchaseOrderLaborAssignments(arg2) {
    return getPurchaseOrderLaborAssignments(arg2);
  }
  async getAllPurchaseOrderLaborAssignments(arg2) {
    return getAllPurchaseOrderLaborAssignments(arg2);
  }
  async getPurchaseOrderLabor(arg2) {
    return getPurchaseOrderLabor(arg2);
  }
  async getAllPurchaseOrderLegalEntities(arg2 = {}) {
    return getAllPurchaseOrderLegalEntities(arg2);
  }
  async searchAllPurchaseOrders(arg2) {
    return searchAllPurchaseOrders(arg2);
  }
  async getPurchaseOrderAvailableVendors(arg2) {
    return getPurchaseOrderAvailableVendors(arg2);
  }
}
_init = __decoratorStart();
__decorateElement(_init, 1, "getPurchaseOrderLaborAssignments", _getPurchaseOrderLaborAssignments_dec, PurchaseOrdersCachedApi);
__decorateElement(_init, 1, "getAllPurchaseOrderLaborAssignments", _getAllPurchaseOrderLaborAssignments_dec, PurchaseOrdersCachedApi);
__decorateElement(_init, 1, "getPurchaseOrderLabor", _getPurchaseOrderLabor_dec, PurchaseOrdersCachedApi);
__decorateElement(_init, 1, "getAllPurchaseOrderLegalEntities", _getAllPurchaseOrderLegalEntities_dec, PurchaseOrdersCachedApi);
__decorateElement(_init, 1, "searchAllPurchaseOrders", _searchAllPurchaseOrders_dec, PurchaseOrdersCachedApi);
__decorateElement(_init, 1, "getPurchaseOrderAvailableVendors", _getPurchaseOrderAvailableVendors_dec, PurchaseOrdersCachedApi);
__decoratorMetadata(_init, PurchaseOrdersCachedApi);
const purchaseOrdersCachedApi = new PurchaseOrdersCachedApi();
const RECEIVING_DOCUMENT_KEY_NAME_STATUSES = [
  { key: 1, name: "INUSE" },
  { key: 2, name: "COMPLETED" },
  { key: 3, name: "RETRACTED" }
];
const toReceivingDocument = (receipt) => {
  const {
    completedTimestamp,
    created,
    documentDate,
    lastModified,
    retractedTimestamp
  } = receipt;
  return {
    ...receipt,
    completedTimestamp: completedTimestamp ? DateTime.fromISO(completedTimestamp) : void 0,
    created: created ? DateTime.fromISO(created) : void 0,
    documentDate: DateTime.fromISO(documentDate),
    lastModified: lastModified ? DateTime.fromISO(lastModified) : void 0,
    retractedTimestamp: retractedTimestamp ? DateTime.fromISO(retractedTimestamp) : void 0
  };
};
const fromReceivingDocument = (receipt) => {
  const {
    completedTimestamp,
    created,
    documentDate,
    lastModified,
    retractedTimestamp
  } = receipt;
  return {
    ...receipt,
    completedTimestamp: completedTimestamp ? completedTimestamp.toUTC().toISO() ?? void 0 : void 0,
    created: created ? created.toUTC().toISO() ?? void 0 : void 0,
    // removed UTC on purpose so saved dates don't convert to one day prior/next on save
    documentDate: documentDate.toISODate() ?? "",
    lastModified: lastModified ? lastModified.toUTC().toISO() ?? void 0 : void 0,
    retractedTimestamp: retractedTimestamp ? retractedTimestamp.toUTC().toISO() ?? void 0 : void 0
  };
};
const toAttachmentList = (attachment) => {
  const { created } = attachment;
  return {
    ...attachment,
    created: created ? DateTime.fromISO(created) : void 0
  };
};
const toReceivingDocumentItem = (model) => {
  const { createdTimestamp, lastUpdatedTimestamp, purchaseOrderItemLine } = model;
  return {
    ...model,
    createdTimestamp: createdTimestamp ? DateTime.fromISO(createdTimestamp) : void 0,
    lastUpdatedTimestamp: lastUpdatedTimestamp ? DateTime.fromISO(lastUpdatedTimestamp) : void 0,
    purchaseOrderItemLine: purchaseOrderItemLine ? {
      ...purchaseOrderItemLine,
      poItemLineDescriptorKey: model.poItemLineDescriptorKey,
      remainingQuantity: 0
    } : void 0
  };
};
const fromReceivingDocumentItem = (item) => {
  const {
    createdTimestamp,
    lastUpdatedTimestamp,
    purchaseOrderItemLine,
    ...rest
  } = item;
  return {
    ...rest,
    createdTimestamp: createdTimestamp ? createdTimestamp.toUTC().toISO() ?? void 0 : void 0,
    lastUpdatedTimestamp: lastUpdatedTimestamp ? lastUpdatedTimestamp.toUTC().toISO() ?? void 0 : void 0,
    purchaseOrderItemLine: purchaseOrderItemLine ? omit$1(purchaseOrderItemLine, [
      "poItemLineDescriptorKey",
      "poLineDescription",
      "poLineId",
      "remainingQuantity"
    ]) : void 0
  };
};
const toReceivingPurchaseOrder = (model) => {
  const { documentDate, requiredByDate } = model;
  return {
    ...model,
    documentDate: DateTime.fromISO(documentDate),
    requiredByDate: requiredByDate ? DateTime.fromISO(requiredByDate) : void 0
  };
};
const createReceipt = async (receipt) => {
  const model = {
    purchaseOrderKey: receipt.purchaseOrder.key ?? -1,
    documentNumber: receipt.documentNumber,
    // removed UTC on purpose so saved dates don't convert to one day prior/next on save
    documentDate: receipt.documentDate ? receipt.documentDate.toISODate() ?? "" : ""
  };
  try {
    const { key } = await createReceipt$1(model);
    return key;
  } catch (e) {
    log.warn({
      msg: "Creating receipt failed",
      ...model,
      error: `${e}`
    });
    throw e;
  }
};
const getReceipt = async (receiptKey) => {
  try {
    return toReceivingDocument(await getReceipt$1(receiptKey));
  } catch (e) {
    log.warn({
      msg: "Fetching receipt data failed",
      receiptKey,
      error: `${e}`
    });
    throw e;
  }
};
const updateReceipt = async (receipt) => {
  try {
    await updateReceipt$1(fromReceivingDocument(receipt));
  } catch (e) {
    log.warn({
      msg: "Updating receipt failed",
      receiptKey: receipt.key,
      error: `${e}`
    });
    throw e;
  }
};
const deleteReceipt = async ({
  receiptKey
}) => {
  try {
    await deleteReceipt$1({ receiptKey });
  } catch (e) {
    log.warn({
      msg: "Deleting receipt failed",
      receiptKey,
      error: `${e}`
    });
    throw e;
  }
};
const getReceiptAttachments = async ({
  receiptKey,
  page,
  pageSize: pageSize2 = 50
}) => {
  try {
    const listPage = await getReceiptAttachments$1({
      receiptKey,
      page,
      pageSize: pageSize2
    });
    return { ...listPage, items: listPage.items.map(toAttachmentList) };
  } catch (e) {
    log.warn({
      msg: `Fetching receipt attachments page failed`,
      receiptKey,
      page,
      pageSize: pageSize2,
      error: `${e}`
    });
    throw e;
  }
};
const getAllReceiptAttachments = async ({
  receiptKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  errorMessage: "Fetching all receipt attachments failed",
  fetch: (page) => () => getReceiptAttachments({ receiptKey, page, pageSize: pageSize2 })
});
const getReceiptAttachment = async ({
  receiptKey,
  attachmentKey
}) => {
  try {
    const attachment = await getReceiptAttachment$1({
      receiptKey,
      attachmentKey
    });
    return attachment;
  } catch (e) {
    log.warn({
      msg: `Fetching Receipt Attachment failed`,
      error: `${e}`
    });
    throw e;
  }
};
const createReceiptAttachments = async (receiptKey, files) => {
  const promises = files.map(async (file) => {
    const attachment = await fileToAttachment(file);
    return createReceiptAttachment({
      receiptKey,
      attachment
    });
  });
  const results = await Promise.allSettled(promises);
  log.info({
    msg: "Receipt attachments uploaded",
    receiptKey,
    fileCount: files.length,
    rejected: results.filter((r12) => r12.status === "rejected").length
  });
  if (results.some((r12) => r12.status === "rejected")) {
    throw new AppError("Error uploading receipt attachments", ErrorCode.None);
  } else {
    return results.map((r12) => r12.status === "fulfilled" ? r12.value.key : -1);
  }
};
const deleteReceiptAttachment = async ({
  receiptKey,
  attachmentKey
}) => {
  try {
    await deleteReceiptAttachment$1({
      receiptKey,
      attachmentKey
    });
  } catch (e) {
    log.warn({
      msg: `Deleting receipt attachment failed`,
      receiptKey,
      attachmentKey,
      error: `${e}`
    });
    throw e;
  }
};
const getAllReceiptItems = async ({
  purchaseOrderKey,
  receiptKey,
  viewOnly,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  try {
    const rawItems = await fetchAllItems({
      errorMessage: "Fetching all receipt items failed",
      fetch: (page) => () => getReceiptItems({ receiptKey, page, pageSize: pageSize2 })
    });
    const receiptItems = rawItems.map(toReceivingDocumentItem);
    const items = [];
    if (viewOnly) {
      for (const receiptItem of receiptItems) {
        const { purchaseOrderItemLine, ...rest } = receiptItem;
        if (purchaseOrderItemLine) {
          items.push({
            ...rest,
            purchaseOrderItemLine: {
              ...purchaseOrderItemLine,
              poItemLineDescriptorKey: receiptItem.poItemLineDescriptorKey,
              remainingQuantity: 0
            }
          });
        } else {
          items.push(receiptItem);
        }
      }
    } else {
      const poItems = await getAllReceiptPurchaseOrderItems({
        purchaseOrderKey,
        pageSize: pageSize2
      });
      for (const poItem of poItems) {
        const receiptItem = receiptItems.find(
          (item) => item.poItemLineDescriptorKey === poItem.poItemLineDescriptorKey
        );
        items.push({
          comments: receiptItem?.comments,
          createdBy: receiptItem?.createdBy,
          createdTimestamp: receiptItem?.createdTimestamp,
          key: receiptItem?.key ?? -1,
          lastUpdatedBy: receiptItem?.lastUpdatedBy,
          lastUpdatedTimestamp: receiptItem?.lastUpdatedTimestamp,
          poItemLineDescriptorKey: poItem.poItemLineDescriptorKey,
          poLineDescription: poItem.poLineDescription,
          poLineId: poItem.poLineId,
          purchaseOrderItemLine: poItem,
          quantity: receiptItem?.quantity ?? 0,
          vendorInvoiceKey: receiptItem?.vendorInvoiceKey
        });
      }
    }
    const sortedItems = sortBy(items, "poLineId");
    return sortedItems;
  } catch (e) {
    log.warn({
      msg: "Fetching all receipt items failed",
      purchaseOrderKey,
      receiptKey,
      pageSize: pageSize2,
      error: `${e}`
    });
    throw e;
  }
};
const createReceiptItem = async ({
  receiptKey,
  model
}) => {
  try {
    const { key } = await createReceiptItem$1({ receiptKey, model });
    return key;
  } catch (e) {
    log.warn({
      msg: "Creating receipt item failed",
      receiptKey,
      ...model,
      error: `${e}`
    });
    throw e;
  }
};
const getReceiptItem = async ({
  receiptKey,
  itemKey
}) => {
  try {
    const item = await getReceiptItem$1({ receiptKey, itemKey });
    return toReceivingDocumentItem(item);
  } catch (e) {
    log.warn({
      msg: "Fetching receipt item failed",
      receiptKey,
      itemKey,
      error: `${e}`
    });
    throw e;
  }
};
const updateReceiptItem = async ({
  receiptKey,
  item
}) => {
  try {
    await updateReceiptItem$1({
      receiptKey,
      item: fromReceivingDocumentItem(item)
    });
  } catch (e) {
    log.warn({
      msg: `Updating receipt item failed`,
      receiptKey,
      itemKey: item.key,
      error: `${e}`
    });
    throw e;
  }
};
const deleteReceiptItem = async ({
  receiptKey,
  itemKey
}) => {
  try {
    await deleteReceiptItem$1({ receiptKey, itemKey });
  } catch (e) {
    log.warn({
      msg: `Deleting receipt item failed`,
      receiptKey,
      itemKey,
      error: `${e}`
    });
    throw e;
  }
};
const searchAllReceipts = async ({
  params = {},
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const items = await fetchAllItems({
    errorMessage: "Searching all receipts failed",
    fetch: (page) => () => searchReceipts$1({ params, page, pageSize: pageSize2 })
  });
  return items.map(toReceivingDocument);
};
const searchReceipts = async ({
  params = {},
  page,
  pageSize: pageSize2 = 50
}) => {
  try {
    const listPage = await searchReceipts$1({
      params,
      page,
      pageSize: pageSize2
    });
    return { ...listPage, items: listPage.items.map(toReceivingDocument) };
  } catch (e) {
    log.warn({
      msg: "Searching receipts failed",
      error: `${e}`
    });
    throw e;
  }
};
const getAllReceiptPurchaseOrderItems = async ({
  purchaseOrderKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const items = await fetchAllItems({
    fetch: (page) => () => getReceiptPurchaseOrderItems({
      purchaseOrderKey,
      page,
      pageSize: pageSize2
    }),
    errorMessage: `Fetching all receipt purchase order items failed (purchaseOrderKey: ${purchaseOrderKey}`
  });
  const sortedItems = sortBy(items, "poLineId");
  return sortedItems;
};
const searchAllReceiptPurchaseOrders = async ({
  params = {},
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const items = await fetchAllItems({
    errorMessage: "Fetching all receipt purchase orders failed",
    fetch: (page) => () => searchReceiptPurchaseOrders$1({ params, page, pageSize: pageSize2 })
  });
  return items.map(toReceivingPurchaseOrder);
};
const searchReceiptPurchaseOrders = async ({
  params = {},
  page,
  pageSize: pageSize2 = 50
}) => {
  try {
    const listPage = await searchReceiptPurchaseOrders$1({
      params,
      page,
      pageSize: pageSize2
    });
    return { ...listPage, items: listPage.items.map(toReceivingPurchaseOrder) };
  } catch (e) {
    log.warn({
      msg: "Searching receipt purchase orders failed",
      error: `${e}`
    });
    throw e;
  }
};
const getAllReceiptLegalEntities = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  fetch: (page) => () => getReceiptLegalEntities({ page, pageSize: pageSize2 }),
  errorMessage: "Returning all receipt legal entities failed"
});
const getAllReceiptOwningOrgs = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  fetch: (page) => () => getReceiptOwningOrgs({ page, pageSize: pageSize2 }),
  errorMessage: "Returning all receipt owning orgs failed"
});
const getAllReceiptProjects = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  fetch: (page) => () => getReceiptProjects({ page, pageSize: pageSize2 }),
  errorMessage: "Returning all receipt projects failed"
});
const getAllReceiptVendors = async ({
  legalEntityKeys,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  fetch: (page) => () => getReceiptVendors({
    legalEntityKeys,
    page,
    pageSize: pageSize2
  }),
  errorMessage: "Returning all receipt vendors failed"
});
const searchAllReceiptPeople = async ({
  name,
  role,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  fetch: (page) => () => getReceiptPeople({ name, role, page, pageSize: pageSize2 }),
  errorMessage: "Returning all receipt people failed"
});
const completeReceipt = async (receiptKey) => {
  try {
    await completeReceipt$1(receiptKey);
  } catch (e) {
    log.warn({
      msg: "Completing receipt failed",
      receiptKey,
      error: `${e}`
    });
    throw e;
  }
};
const retractReceipt = async ({
  receiptKey
}) => {
  try {
    await retractReceipt$1({ receiptKey });
  } catch (e) {
    log.warn({
      msg: "Retracting receipt failed",
      receiptKey,
      error: `${e}`
    });
    throw e;
  }
};
const getReceiptsImportDefinition = async () => {
  try {
    return await getReceiptsImportDefinition$1();
  } catch (e) {
    log.warn({
      msg: "Fetching receipts import template failed",
      error: `${e}`
    });
    throw e;
  }
};
const importReceipts = async (file, {
  dryRun,
  enableProgressFeedback
}) => {
  try {
    return await importReceipts$1(file, {
      dryRun,
      enableProgressFeedback
    });
  } catch (e) {
    log.warn({
      msg: `Importing receipts file failed`,
      error: `${e}`
    });
    throw e;
  }
};
var ReceiptColumn = /* @__PURE__ */ ((ReceiptColumn2) => {
  ReceiptColumn2["RECEIPT_NUMBER"] = "*receipt_number";
  ReceiptColumn2["DOCUMENT_DATE"] = "document_date";
  ReceiptColumn2["STATUS"] = "status";
  ReceiptColumn2["PO_NUMBER"] = "po_number";
  ReceiptColumn2["VENDOR"] = "vendor";
  ReceiptColumn2["OWNING_ORG"] = "owning_org";
  ReceiptColumn2["LEGAL_ENTITY"] = "legal_entity";
  return ReceiptColumn2;
})(ReceiptColumn || {});
var ItemColumn = /* @__PURE__ */ ((ItemColumn2) => {
  ItemColumn2["PO_LINE_DETAIL_NUMBER"] = "po_line_detail_number";
  ItemColumn2["ITEM"] = "item";
  ItemColumn2["UNIT_OF_MEASURE"] = "unit_of_measure";
  ItemColumn2["PROJECT"] = "project";
  ItemColumn2["TASK"] = "task";
  ItemColumn2["QUANTITY_REMAINING"] = "quantity_remaining";
  ItemColumn2["ITEM_PRICE"] = "item_price";
  ItemColumn2["QUANTITY_RECEIVED"] = "quantity_received";
  ItemColumn2["AMOUNT_RECEIVED"] = "amount_received";
  ItemColumn2["COMMENT"] = "comment";
  return ItemColumn2;
})(ItemColumn || {});
var CommonColumn = /* @__PURE__ */ ((CommonColumn2) => {
  CommonColumn2["LAST_MODIFIED_BY"] = "last_modified_by";
  CommonColumn2["LAST_MODIFIED_ON"] = "last_modified_on";
  CommonColumn2["CURRENCY"] = "currency";
  return CommonColumn2;
})(CommonColumn || {});
const HEADER_ROW = Object.values({
  ...ReceiptColumn,
  ...ItemColumn,
  ...CommonColumn
});
const _generateReceiptData = ({
  receipt
}) => ({
  [
    "*receipt_number"
    /* RECEIPT_NUMBER */
  ]: receipt.documentNumber,
  [
    "document_date"
    /* DOCUMENT_DATE */
  ]: receipt.created?.toISODate() ?? "",
  [
    "status"
    /* STATUS */
  ]: receipt.status ?? "",
  [
    "po_number"
    /* PO_NUMBER */
  ]: receipt.purchaseOrder.documentNumber ?? "",
  [
    "vendor"
    /* VENDOR */
  ]: receipt.purchaseOrder.vendorOrg?.name ?? "",
  [
    "owning_org"
    /* OWNING_ORG */
  ]: receipt.purchaseOrder.owningOrg?.name ?? "",
  [
    "legal_entity"
    /* LEGAL_ENTITY */
  ]: receipt.purchaseOrder.legalEntity?.name ?? ""
});
const _generateEmptyItemData = () => ({
  [
    "po_line_detail_number"
    /* PO_LINE_DETAIL_NUMBER */
  ]: "",
  [
    "item"
    /* ITEM */
  ]: "",
  [
    "unit_of_measure"
    /* UNIT_OF_MEASURE */
  ]: "",
  [
    "project"
    /* PROJECT */
  ]: "",
  [
    "task"
    /* TASK */
  ]: "",
  [
    "quantity_remaining"
    /* QUANTITY_REMAINING */
  ]: "",
  [
    "item_price"
    /* ITEM_PRICE */
  ]: "",
  [
    "quantity_received"
    /* QUANTITY_RECEIVED */
  ]: "",
  [
    "amount_received"
    /* AMOUNT_RECEIVED */
  ]: "",
  [
    "comment"
    /* COMMENT */
  ]: ""
});
const _getItemDisplay = ({ item }) => {
  const code = item?.code ?? "";
  const name = item?.name ?? "";
  if (code && name) {
    return `${code} - ${name}`;
  } else {
    return code ? code : name;
  }
};
const _getItemRemainingQuantityDislpay = ({
  receipt,
  item
}) => {
  return receipt.status === ReceivingDocumentModel.StatusEnum.INUSE ? item.purchaseOrderItemLine?.remainingQuantity.toString() ?? "" : "";
};
const _generateItemData = ({
  receipt,
  item
}) => {
  const currencyCode = item.purchaseOrderItemLine?.currency?.code ?? "";
  const locale = getUnanetLocale();
  return {
    [
      "po_line_detail_number"
      /* PO_LINE_DETAIL_NUMBER */
    ]: item.poItemLineDescriptorKey.toString(),
    [
      "item"
      /* ITEM */
    ]: _getItemDisplay({
      item: item.purchaseOrderItemLine?.item
    }),
    [
      "unit_of_measure"
      /* UNIT_OF_MEASURE */
    ]: item.purchaseOrderItemLine?.uom.name ?? "",
    [
      "project"
      /* PROJECT */
    ]: item.purchaseOrderItemLine?.project?.name ?? "",
    [
      "task"
      /* TASK */
    ]: item.purchaseOrderItemLine?.task?.name ?? "",
    [
      "quantity_remaining"
      /* QUANTITY_REMAINING */
    ]: _getItemRemainingQuantityDislpay({
      receipt,
      item
    }),
    [
      "item_price"
      /* ITEM_PRICE */
    ]: formatAmount({
      amount: item.purchaseOrderItemLine?.rate,
      currencyCode,
      currencySign: "none",
      locale,
      negativeIndicator: "negative-sign"
      // don't show parentheses in CSV files
    }),
    [
      "quantity_received"
      /* QUANTITY_RECEIVED */
    ]: item.quantity.toString(),
    [
      "amount_received"
      /* AMOUNT_RECEIVED */
    ]: item.purchaseOrderItemLine?.rate ? formatAmount({
      amount: item.purchaseOrderItemLine.rate * item.quantity,
      currencyCode,
      currencySign: "none",
      locale,
      negativeIndicator: "negative-sign"
      // don't show parentheses in CSV files
    }) : "",
    [
      "comment"
      /* COMMENT */
    ]: item.comments ?? ""
  };
};
const _generateCommonData = ({
  receipt,
  item
}) => {
  let lastModifiedBy = "";
  let lastModifiedOn = "";
  let currency = "";
  if (receipt) {
    lastModifiedBy = receipt.lastModifiedBy ? Person.fullName(receipt.lastModifiedBy) : "";
    lastModifiedOn = receipt.lastModified?.toISO() ?? "";
    currency = receipt.purchaseOrder.currency?.code ?? "";
  } else if (item) {
    lastModifiedBy = item.lastUpdatedBy ? Person.fullName(item.lastUpdatedBy) : "";
    lastModifiedOn = item.lastUpdatedTimestamp?.toISO() ?? "";
    currency = item.purchaseOrderItemLine?.currency?.code ?? "";
  }
  return {
    [
      "last_modified_by"
      /* LAST_MODIFIED_BY */
    ]: lastModifiedBy,
    [
      "last_modified_on"
      /* LAST_MODIFIED_ON */
    ]: lastModifiedOn,
    [
      "currency"
      /* CURRENCY */
    ]: currency
  };
};
const getReceiptsCsv = async ({
  receipts: receipts2,
  viewOnly
}) => {
  const rows = [HEADER_ROW];
  for (const receipt of receipts2) {
    if (!receipt.purchaseOrder.key) {
      continue;
    }
    const onlyFetchSavedItems = viewOnly || receipt.status !== ReceivingDocumentModel.StatusEnum.INUSE;
    let items = await getAllReceiptItems({
      purchaseOrderKey: receipt.purchaseOrder.key,
      receiptKey: receipt.key,
      viewOnly: onlyFetchSavedItems
    });
    if (!onlyFetchSavedItems) {
      items = items.filter(
        (i) => i.quantity !== 0 || i.quantity === 0 && i.comments
      );
    }
    if (!items.length) {
      const row = [
        ...Object.values(_generateReceiptData({ receipt })),
        ...Object.values(_generateEmptyItemData()),
        ...Object.values(_generateCommonData({ receipt }))
      ];
      rows.push(row);
    } else {
      for (const item of items) {
        const row = [
          ...Object.values(_generateReceiptData({ receipt })),
          ...Object.values(_generateItemData({ receipt, item })),
          ...Object.values(_generateCommonData({ item }))
        ];
        rows.push(row);
      }
    }
  }
  return stringify$1(rows);
};
const fetchRoles = async () => get$1("/config/roles");
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchRoles
}, Symbol.toStringTag, { value: "Module" }));
const fetchSocioeconomicStatuses = async ({
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    const results = await fetchSocioeconomicStatuses$1({
      page,
      pageSize: pageSize2
    });
    return results;
  } catch (e) {
    log.warn({
      msg: "Fetching Socioeconomic statuses failed",
      error: `${e}`
    });
    throw e;
  }
};
const fetchAllStatisticalAccounts = async ({
  entryAllowed = true,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  fetch: (page) => () => fetchStatisticalAccounts({
    entryAllowed,
    page,
    pageSize: pageSize2
  })
});
const searchStatisticalJournals = async ({
  searchQuery = {},
  page,
  pageSize: pageSize2 = 50
}) => {
  try {
    const listPage = await searchStatisticalJournals$1(
      {
        searchQuery,
        page,
        pageSize: pageSize2
      }
    );
    return listPage;
  } catch (e) {
    log.error({
      msg: "Searching statistical journals failed",
      page,
      pageSize: pageSize2,
      error: `${e}`
    });
    throw e;
  }
};
const fetchAllStatisticalAccountJournalLegalEntities = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => fetchAllItems({
  fetch: (page) => () => fetchStatisticalJournalLegalEntities({
    page,
    pageSize: pageSize2
  }),
  errorMessage: "Fetching statistical journal legal entities failed"
});
const fetchAllStatisticalAccountOrgs = async ({
  legalEntityKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  fetch: (page) => () => fetchStatisticalJournalOrganizations({
    legalEntityKey,
    page,
    pageSize: pageSize2
  }),
  errorMessage: "Fetching statistical journal orgs failed"
});
const fetchAllStatisticalAccountJournalFiscalPeriods = async ({
  includeClosedPeriods,
  legalEntityKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  fetch: (page) => () => fetchStatisticalJournalLegalEntityFiscalPeriods(
    {
      legalEntityKey,
      page,
      pageSize: pageSize2,
      includeClosedPeriods
    }
  ),
  errorMessage: "Fetching fiscal periods for statistical journals failed"
});
const getStatisticalJournalEntry = async ({
  key
}) => {
  try {
    return await getStatisticalJournalEntry$1({ key });
  } catch (e) {
    log.error({
      msg: "Fetching statistical journal entry failed",
      key,
      error: `${e}`
    });
    throw e;
  }
};
const createStatisticalJournalEntry = async ({
  requestBody
}) => {
  try {
    return await createStatisticalJournalEntry$1({
      requestBody
    });
  } catch (e) {
    log.error({
      msg: "Creating new statistical journal entry failed",
      requestBody,
      error: `${e}`
    });
    throw e;
  }
};
const updateStatisticalJournalEntry = async ({
  key,
  requestBody
}) => {
  try {
    return await updateStatisticalJournalEntry$1({
      key,
      requestBody
    });
  } catch (e) {
    log.error({
      msg: "Updating statistical journal entry failed",
      key,
      requestBody,
      error: `${e}`
    });
    throw e;
  }
};
const getStatisticalJournalEntryDetails = async ({
  key,
  page,
  pageSize: pageSize2 = 50
}) => {
  try {
    return await getStatisticalJournalEntryDetails$1({
      key,
      page,
      pageSize: pageSize2
    });
  } catch (e) {
    log.error({
      msg: "Fetching statistical journal entry details failed",
      key,
      page,
      pageSize: pageSize2,
      error: `${e}`
    });
    throw e;
  }
};
const getAllStatisticalJournalEntryDetails = async ({
  key,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  return fetchAllItems({
    fetch: (page) => () => getStatisticalJournalEntryDetails$1({
      key,
      page,
      pageSize: pageSize2
    }),
    errorMessage: "Fetching all detail lines for statistical journal failed"
  });
};
const createStatisticalJournalEntryDetails = async ({
  key,
  requestBody
}) => {
  try {
    return await createStatisticalJournalEntryDetails$1(
      {
        key,
        requestBody
      }
    );
  } catch (e) {
    log.error({
      msg: "Creating statistical journal entry details failed",
      key,
      requestBody,
      error: `${e}`
    });
    throw e;
  }
};
const updateStatisticalJournalEntryDetails = async ({
  key,
  requestBody
}) => {
  try {
    return await updateStatisticalJournalEntryDetails$1(
      {
        key,
        requestBody
      }
    );
  } catch (e) {
    log.error({
      msg: "Updating statistical journal entry details failed",
      key,
      requestBody,
      error: `${e}`
    });
    throw e;
  }
};
const putStatisticalJournalEntryInUse = async ({
  key
}) => {
  try {
    return await putStatisticalJournalEntryInUse$1({
      key
    });
  } catch (e) {
    log.error({
      msg: "Putting statistical journal entry in use failed",
      key,
      error: `${e}`
    });
    throw e;
  }
};
const submitStatisticalJournalEntry = async ({
  key
}) => {
  try {
    return await submitStatisticalJournalEntry$1({
      key
    });
  } catch (e) {
    log.error({
      msg: "Submitting statistical journal entry failed",
      key,
      error: `${e}`
    });
    throw e;
  }
};
const postStatisticalJournalEntry = async ({
  key
}) => {
  try {
    return await postStatisticalJournalEntry$1({
      key
    });
  } catch (e) {
    log.error({
      msg: "Posting statistical journal entry failed",
      key,
      error: `${e}`
    });
    throw e;
  }
};
const voidStatisticalJournalEntry = async ({
  key,
  requestBody
}) => {
  try {
    return await voidStatisticalJournalEntry$1({
      key,
      requestBody
    });
  } catch (e) {
    log.error({
      msg: "Voiding statistical journal entry failed",
      key,
      requestBody,
      error: `${e}`
    });
    throw e;
  }
};
const validateForSubmit = async ({
  documentKey
}) => {
  try {
    return await validateForSubmit$1({ documentKey });
  } catch (e) {
    log.error({
      msg: "Validating statistical journal entry for submit failed",
      documentKey,
      error: `${e}`
    });
    throw e;
  }
};
const validateForPost = async ({
  documentKey
}) => {
  try {
    return await validateForPost$1({ documentKey });
  } catch (e) {
    log.error({
      msg: "Validating statistical journal entry for post failed",
      documentKey,
      error: `${e}`
    });
    throw e;
  }
};
const deleteStatisticalJournalEntry = async ({
  key
}) => {
  try {
    return await deleteStatisticalJournalEntry$1({
      key
    });
  } catch (e) {
    log.error({
      msg: "Deleting statistical journal entry failed",
      key,
      error: `${e}`
    });
    throw e;
  }
};
const deleteStatisticalJournalEntryDetail = async ({
  key,
  lineId
}) => {
  try {
    return await deleteStatisticalJournalEntryDetail$1(
      {
        key,
        lineId
      }
    );
  } catch (e) {
    log.error({
      msg: "Deleting statistical journal entry detail failed",
      key,
      lineId,
      error: `${e}`
    });
    throw e;
  }
};
const fetchStatisticalJournalAttachments = async ({
  documentKey,
  page,
  pageSize: pageSize2
}) => {
  try {
    return await fetchStatisticalJournalAttachments$1({
      documentKey,
      page,
      pageSize: pageSize2
    });
  } catch (e) {
    log.error({
      msg: "Fetching statistical journal attachments failed",
      documentKey,
      error: `${e}`
    });
    throw e;
  }
};
const fetchStatisticalJournalAttachment = async ({
  attachmentKey,
  documentKey
}) => {
  try {
    return await fetchStatisticalJournalAttachment$1({
      attachmentKey,
      documentKey
    });
  } catch (e) {
    log.error({
      msg: "Fetching statistical journal attachment failed",
      attachmentKey,
      documentKey,
      error: `${e}`
    });
    throw e;
  }
};
const createStatisticalJournalAttachments = async ({
  documentKey,
  files
}) => {
  const promises = files.map(async (file) => {
    const attachment = await fileToAttachment(file);
    return createStatisticalJournalAttachment({
      attachment,
      documentKey
    });
  });
  const results = await Promise.allSettled(promises);
  const failures = results.filter((r12) => r12.status === "rejected");
  if (failures.length > 0) {
    log.error({
      msg: "One or more statistical journal attachments failed to upload",
      documentKey,
      failureCount: failures.length
    });
    throw new Error("One or more attachments failed to upload");
  }
};
const deleteStatisticalJournalAttachment = async ({
  attachmentKey,
  documentKey
}) => {
  try {
    return await deleteStatisticalJournalAttachment$1({
      attachmentKey,
      documentKey
    });
  } catch (e) {
    log.error({
      msg: "Deleting statistical journal attachment failed",
      attachmentKey,
      documentKey,
      error: `${e}`
    });
    throw e;
  }
};
var TimesheetAdjustmentType = /* @__PURE__ */ ((TimesheetAdjustmentType2) => {
  TimesheetAdjustmentType2["Pending"] = "PENDING";
  TimesheetAdjustmentType2["Completed"] = "COMPLETED";
  TimesheetAdjustmentType2["CompletedUnextracted"] = "COMPLETED_UNEXTRACTED";
  return TimesheetAdjustmentType2;
})(TimesheetAdjustmentType || {});
var TimesheetSortByColumns = /* @__PURE__ */ ((TimesheetSortByColumns2) => {
  TimesheetSortByColumns2["BeginDate"] = "BEGIN_DATE";
  TimesheetSortByColumns2["Hours"] = "HOURS";
  TimesheetSortByColumns2["Status"] = "STATUS";
  TimesheetSortByColumns2["Controller"] = "CONTROLLER";
  TimesheetSortByColumns2["Comments"] = "COMMENTS";
  TimesheetSortByColumns2["ItemQuantity"] = "ITEM_QUANTITY";
  return TimesheetSortByColumns2;
})(TimesheetSortByColumns || {});
const TimeListView = {
  User: "USER",
  MyPeople: "MY_PEOPLE",
  AdminPeople: "ADMIN_PEOPLE"
};
const approveTimesheetAsManager = async ({
  timesheetKey,
  projectKey,
  comment: comment2
}) => {
  try {
    await approveTimesheetAsManager$1({
      timesheetKey,
      projectKey,
      comment: comment2
    });
  } catch (e) {
    log.warn({
      msg: "Approving timesheet failed",
      error: `${e}`
    });
    throw e;
  }
};
const createTimesheet = async ({
  date,
  ownerKey
}) => {
  try {
    const timesheet = await createTimesheet$1({ date, ownerKey });
    return timesheet;
  } catch (e) {
    log.warn({
      msg: "Creating timesheet failed",
      error: `${e}`
    });
    throw e;
  }
};
const createMyTimesheet = async ({
  date,
  ownerKey
}) => {
  try {
    const { key } = await createMyTimesheet$1({ date, ownerKey });
    return key;
  } catch (e) {
    log.warn({
      msg: "Creating my timesheet failed",
      error: `${e}`
    });
    throw e;
  }
};
const deleteMyTimesheet = async ({
  timesheetKey
}) => {
  try {
    await deleteMyTimesheet$1({ timesheetKey });
  } catch (e) {
    log.warn({
      msg: "Deleting my timesheet failed",
      error: `${e}`
    });
    throw e;
  }
};
const deleteTimesheet = async ({
  timesheetKey
}) => {
  try {
    await deleteTimesheet$1({ timesheetKey });
  } catch (e) {
    log.warn({
      msg: "Deleting timesheet failed",
      error: `${e}`
    });
    throw e;
  }
};
const disapproveTimesheetAsManager = async ({
  timesheetKey,
  disapproveInfo
}) => {
  try {
    await disapproveTimesheetAsManager$1({ timesheetKey, disapproveInfo });
  } catch (e) {
    log.warn({
      msg: "Disapproving timesheet failed",
      error: `${e}`
    });
    throw e;
  }
};
const reviewMyTimesheet = async ({
  comment: comment2,
  timesheetKey
}) => {
  try {
    await reviewMyTimesheet$1({ comment: comment2, timesheetKey });
  } catch (e) {
    log.warn({ msg: "Reviewing timesheet failed", error: `${e}` });
    throw e;
  }
};
const getCurrentTimesheet = async () => {
  const withTodays = await searchMyTimesheets(1, 15, {
    workDate: DateTime.local().toISODate()
  });
  if (withTodays.items.length !== 1) {
    log.warn({
      msg: `Expected 1 timesheet for today, found ${withTodays.items.length}`
    });
    return { timesheet: null };
  }
  const timesheet = await getMyTimesheet(withTodays.items[0].key);
  return {
    timesheet
  };
};
const getTimesheet = async (id) => {
  try {
    const plannedTime = await getTimesheet$1(id);
    return plannedTime;
  } catch (e) {
    log.warn({
      msg: "Fetching timesheet data failed",
      key: id,
      error: `${e}`
    });
    throw e;
  }
};
const getMyTimesheet = async (id) => {
  try {
    const plannedTime = await getMyTimesheet$1(id);
    return plannedTime;
  } catch (e) {
    log.warn({
      msg: "Fetching timesheet data failed",
      key: id,
      error: `${e}`
    });
    throw e;
  }
};
const getMyTimesheets = async ({
  active,
  page = 1,
  pageSize: pageSize2 = 10,
  sortBy: sortBy2 = TimesheetSortByColumns.BeginDate,
  sortOrder = "DESC"
}) => {
  try {
    const response = await getMyTimesheets$1({
      active,
      page,
      pageSize: pageSize2,
      sortBy: sortBy2,
      sortOrder
    });
    return {
      page: response.page ?? page,
      pageSize: response.pageSize ?? pageSize2,
      resultCount: response.resultCount ?? 0,
      pageCount: response.pageCount ?? 0,
      items: response.items ?? []
    };
  } catch (e) {
    log.warn({
      msg: `Error fetching my timesheets: page:${page} page size:${pageSize2}`,
      error: `${e}`
    });
    throw e;
  }
};
const getTimesheets = async ({
  personKey,
  active,
  page = 1,
  pageSize: pageSize2 = 10,
  sortBy: sortBy2 = TimesheetSortByColumns.BeginDate,
  sortOrder = "DESC",
  statuses
}) => {
  try {
    const response = await searchTimesheets(page, pageSize2, {
      personKeys: [personKey],
      active,
      sortBy: sortBy2,
      sortOrder,
      statuses
    });
    return {
      page: response.page ?? page,
      pageSize: response.pageSize ?? pageSize2,
      resultCount: response.resultCount ?? 0,
      pageCount: response.pageCount ?? 0,
      items: response.items ?? []
    };
  } catch (e) {
    log.warn({
      msg: `Error fetching timesheets for person ${personKey}: page:${page} page size:${pageSize2}`,
      error: `${e}`
    });
    throw e;
  }
};
const getTimesheetHistory = async ({
  timesheetKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    const results = await getTimesheetHistory$1({
      timesheetKey,
      page,
      pageSize: pageSize2
    });
    return mapListPage(results, toTimeStatusHistory);
  } catch (e) {
    log.warn({
      msg: "Fetching timesheet history page failed",
      error: `${e}`
    });
    throw e;
  }
};
const getMyTimesheetHistory = async ({
  timesheetKey,
  page = 1,
  pageSize: pageSize2 = 50
}) => {
  try {
    const results = await getMyTimesheetHistory$1({
      timesheetKey,
      page,
      pageSize: pageSize2
    });
    return mapListPage(results, toTimeStatusHistory);
  } catch (e) {
    log.warn({
      msg: "Fetching timesheet history page failed",
      error: `${e}`
    });
    throw e;
  }
};
const getAllMyTimesheetHistory = async ({
  timesheetKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const allItems = await fetchAllItems({
    fetch: (page) => () => getMyTimesheetHistory$1({ timesheetKey, page, pageSize: pageSize2 }),
    errorMessage: `Fetching all history for timesheet: ${timesheetKey} failed.`
  });
  return allItems.map(toTimeStatusHistory);
};
const getAllTimesheetAudits = async ({
  timesheet,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  try {
    const adjustments = await getTimesheetAdjustments({
      timesheetKey: timesheet.key,
      adjustmentTypes: [
        TimesheetAdjustmentType.Pending,
        TimesheetAdjustmentType.Completed
      ]
    });
    const items = await fetchAllItems({
      errorMessage: "Fetching all timesheet audits failed",
      fetch: (page) => () => getTimesheetAudits({
        timesheetKey: timesheet.key,
        page,
        pageSize: pageSize2
      })
    });
    const audits = items.map((item) => toTimeslipAudit(item));
    return hydrateAudits({
      audits,
      timesheet,
      adjustments
    });
  } catch (e) {
    log.warn({
      msg: "Fetching all timesheet audits failed",
      error: `${e}`
    });
    throw e;
  }
};
const getTimesheetAdjustments = async ({
  timesheetKey,
  projectKey,
  adjustmentTypes
}) => {
  try {
    const results = await getTimesheetAdjustments$1({
      timesheetKey,
      projectKey,
      adjustmentTypes
    });
    const adjustments = [
      ...results.timeslipAdjustmentsPending ?? [],
      ...results.timeslipAdjustmentsCompleted ?? [],
      ...results.timeslipAdjustmentsCompletedUnextracted ?? []
    ];
    return combineAdjustments(adjustments.map(toTimeslipAdjustment));
  } catch (e) {
    log.warn({
      msg: "Fetching timesheet adjustments failed",
      error: `${e}`
    });
    throw e;
  }
};
const getAllTimesheetHistory = async ({
  timesheetKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const items = await fetchAllItems({
    errorMessage: "Fetching all timesheet history failed",
    fetch: (page) => () => getTimesheetHistory$1({ timesheetKey, page, pageSize: pageSize2 })
  });
  return items.map(toTimeStatusHistory);
};
const getAllTimesheetProjectLaborCategories = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  projectKey,
  timesheetKey
}) => {
  return fetchAllItems({
    fetch: (page) => () => getTimesheetProjectLaborCategories({
      page,
      pageSize: pageSize2,
      projectKey,
      timesheetKey
    }),
    errorMessage: "Fetching all timesheet project labor categories failed"
  });
};
const getAllTimesheetTaskLaborCategories = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  taskKey,
  timesheetKey
}) => {
  return fetchAllItems({
    fetch: (page) => () => getTimesheetTaskLaborCategories({
      page,
      pageSize: pageSize2,
      taskKey,
      timesheetKey
    }),
    errorMessage: "Fetching all timesheet task labor categories failed"
  });
};
const getAllTimesheetProjectLocations = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  projectKey,
  timesheetKey
}) => {
  return fetchAllItems({
    fetch: (page) => () => getTimesheetProjectLocations({
      page,
      pageSize: pageSize2,
      projectKey,
      timesheetKey
    }),
    errorMessage: "Fetching all timesheet project locations failed"
  });
};
const getAllTimesheetTaskLocations = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  taskKey,
  timesheetKey
}) => {
  return fetchAllItems({
    fetch: (page) => () => getTimesheetTaskLocations({
      page,
      pageSize: pageSize2,
      taskKey,
      timesheetKey
    }),
    errorMessage: "Fetching all timesheet task locations failed"
  });
};
const searchAllTimesheets = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  params = {}
} = {}) => fetchAllItems({
  errorMessage: "Searching and returning all timesheets failed",
  fetch: (page) => () => searchTimesheets(page, pageSize2, params)
});
const getAllTimesheetProjects = async ({
  timesheetKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => {
  const items = await fetchAllItems({
    errorMessage: "Fetching timesheet projects failed",
    fetch: (page) => () => getTimesheetProjects({ timesheetKey, page, pageSize: pageSize2 })
  });
  return items.map(fromTimesheetProjectModel);
};
const getAllTimesheetProjectTypes = async ({
  timesheetKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  errorMessage: "Fetching timesheet project types failed",
  fetch: (page) => () => getTimesheetProjectTypes({ timesheetKey, page, pageSize: pageSize2 })
});
const getAllTimesheetsForApproval = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
} = {}) => {
  const items = await fetchAllItems({
    errorMessage: "Fetching all timesheets for approval failed",
    fetch: (page) => () => getTimesheetsForApproval(page, pageSize2)
  });
  return items.map(toTimeApprovalQueue);
};
const searchAllMyTimesheets = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  params = {}
}) => fetchAllItems({
  errorMessage: "Searching and returning all timesheets failed",
  fetch: (page) => () => searchMyTimesheets(page, pageSize2, params)
});
const submitTimesheet = async ({
  timesheetKey,
  submitInfo
}) => {
  try {
    await submitTimesheet$1({ timesheetKey, submitInfo });
  } catch (e) {
    log.warn({
      msg: "Submitting timesheet failed",
      error: `${e}`
    });
    throw e;
  }
};
const submitMyTimesheet = async ({
  timesheetKey,
  submitInfo
}) => {
  try {
    await submitMyTimesheet$1({ timesheetKey, submitInfo });
  } catch (e) {
    log.warn({
      msg: "Submitting timesheet failed",
      error: `${e}`
    });
    throw e;
  }
};
const updateTimesheet = async (timesheet) => {
  try {
    return await updateTimesheet$1(timesheet);
  } catch (e) {
    log.warn({
      msg: "Updating timesheet data failed",
      key: timesheet.key,
      error: `${e}`
    });
    throw e;
  }
};
const updateMyTimesheet = async ({
  timesheet
}) => {
  try {
    return await updateMyTimesheet$1({ timesheet });
  } catch (e) {
    log.warn({ msg: "Error updating timesheet", error: `${e}` });
    throw e;
  }
};
const validateMyTimesheet = async ({
  key,
  submitValidation = false
}) => {
  try {
    return await validateMyTimesheet$1({ key, submitValidation });
  } catch (e) {
    log.warn({ msg: `Error validating timesheet ${key}`, error: `${e}` });
    throw e;
  }
};
const getAllTimesheetAttachments = async ({
  timesheetKey,
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE
}) => fetchAllItems({
  errorMessage: "Fetching timesheet attachments failed",
  fetch: (page) => () => getTimeAttachments({ timesheetKey, page, pageSize: pageSize2 })
});
const getAllTimesheetAutofillRows = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  timesheetKey
}) => {
  return fetchAllItems({
    fetch: (page) => () => getTimesheetAutofillRows({
      page,
      pageSize: pageSize2,
      timesheetKey
    }),
    errorMessage: "Fetching timesheet autofill rows failed"
  });
};
const getAllDeletedTimesheetAutofillRows = async ({
  pageSize: pageSize2 = MAX_PLATFORM_PAGE_SIZE,
  timesheetKey
}) => {
  return fetchAllItems({
    fetch: (page) => () => getDeletedTimesheetAutofillRows({
      page,
      pageSize: pageSize2,
      timesheetKey
    }),
    errorMessage: "Fetching deleted timesheet autofill rows failed"
  });
};
const deleteTimesheetAutofillRow = async ({
  autofillRow,
  timesheetKey
}) => {
  try {
    const model = {
      projectKey: autofillRow.project?.key,
      taskKey: autofillRow.task?.key,
      projectTypeKey: autofillRow.projectType?.key,
      payCodeKey: autofillRow.payCode?.key,
      laborCategoryKey: autofillRow.laborCategory?.key,
      locationKey: autofillRow.location?.key
    };
    await deleteTimesheetAutofillRow$1({
      autofillRow: model,
      timesheetKey
    });
  } catch (e) {
    log.warn({
      msg: "Deleting timesheet autofill row failed",
      error: `${e}`
    });
    throw e;
  }
};
const validateTimesheet = async ({
  key,
  submitValidation = false
}) => {
  try {
    return await validateTimesheet$1({ key, submitValidation });
  } catch (e) {
    log.warn({ msg: `Error validating timesheet ${key}`, error: `${e}` });
    throw e;
  }
};
const HOURS_SCALE = 2;
const DEFAULT_SERVER_TIMEZONE = "US/Eastern";
const convertDateTimeToServerTz = (dateTime, timezone = DEFAULT_SERVER_TIMEZONE) => dateTime.setZone(timezone, { keepLocalTime: true });
const convertDateTimeToEastern = convertDateTimeToServerTz;
const toTimesheetDateTime = (date, timezone = DEFAULT_SERVER_TIMEZONE) => convertDateTimeToServerTz(date, timezone).set({ millisecond: 0, second: 0 }).toUTC().toISO({ suppressMilliseconds: true });
const toDatabaseTime = (date, timezone = DEFAULT_SERVER_TIMEZONE) => {
  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const convertedDate = date.setZone(timezone).setZone(clientTimeZone, { keepLocalTime: true }).set({ millisecond: 0, second: 0 }).toISO({ suppressMilliseconds: true });
  return convertedDate;
};
const toTimesheetUpdateModel = (timesheet) => {
  return {
    key: timesheet.key,
    itemEntries: timesheet.itemEntries?.map((e) => toItemEntryUpdateModel(e)),
    timeslips: timesheet.timeslips?.map((t16) => toTimeslipUpdateModel(t16)),
    dailyTito: timesheet.dailyTito?.map((t16) => toTimesheetDayUpdateModel(t16))
  };
};
const toTimesheetUpdateModelFromVisualTimeRows = ({
  visualTimeRows,
  timesheet
}) => {
  let timeslips = [];
  for (const row of visualTimeRows) {
    const details = {
      projectKey: row.project?.value?.key ?? -1,
      taskKey: row.task?.value?.key === -1 ? void 0 : row.task?.value?.key,
      laborCategoryKey: row.laborCategory?.value?.key === -1 ? void 0 : row.laborCategory?.value?.key,
      locationKey: row.location?.value?.key === -1 ? void 0 : row.location?.value?.key,
      projectTypeKey: row.projectType?.value?.key ?? -1,
      payCodeKey: row.payCode?.value?.key ?? -1
    };
    const timeCells = row.timeCells ?? [];
    const auditEnabled = timesheet?.properties?.enableTimesheetAuditTrail || false;
    const slips = timeCells.filter(
      (tc) => auditEnabled && tc.key > 0 || tc.hoursWorked > 0 || (tc.titos?.length ?? -1 > 0) || (tc.comment?.trim().length ?? 0) > 0
    ).map(({ comment: comment2, key, titos, ...slip }) => {
      const mappedTitos = titos.map((tito) => {
        const { workHours: _workHours, ...rest } = tito;
        return {
          ...rest,
          startTime: toTimesheetDateTime(
            DateTime.fromISO(tito.startTime ?? "")
          ),
          stopTime: toTimesheetDateTime(
            DateTime.fromISO(tito.stopTime ?? "")
          ),
          key: (tito.key ?? 0) > 0 ? tito.key : void 0
        };
      }).filter((tito) => tito.startTime);
      return {
        ...details,
        ...slip,
        titos: mappedTitos.length > 0 ? mappedTitos : void 0,
        comments: comment2,
        key: key > 0 ? key : void 0
      };
    });
    timeslips = [...timeslips, ...slips];
  }
  const dailyTito = timesheet?.dailyTito?.map((dt2) => {
    const mappedDailyTitos = dt2.titos?.map((t16) => {
      return {
        ...t16,
        key: (t16.key ?? 0) > 0 ? t16.key : void 0,
        startTime: toTimesheetDateTime(DateTime.fromISO(t16.startTime ?? "")) ?? "",
        stopTime: toTimesheetDateTime(DateTime.fromISO(t16.stopTime ?? "")) ?? ""
      };
    });
    return {
      key: dt2.key > 0 ? dt2.key : void 0,
      workDate: dt2.workDate,
      titos: mappedDailyTitos
    };
  });
  return timesheet?.key ? {
    key: timesheet.key,
    timeslips,
    lastDrawerState: timesheet.lastDrawerState,
    dailyTito,
    itemEntries: timesheet.itemEntries?.map(toItemEntryUpdateModel)
  } : null;
};
const toItemEntryUpdateModel = (entry) => {
  const {
    project,
    task,
    item,
    unitOfMeasure,
    projectType,
    workDate,
    quantity,
    ...rest
  } = entry;
  return {
    ...rest,
    projectKey: project.key ?? -1,
    taskKey: task?.key,
    itemKey: item.key ?? -1,
    unitOfMeasureKey: unitOfMeasure.key ?? -1,
    projectTypeKey: projectType.key ?? -1,
    workDate: workDate ?? "",
    quantity: quantity ?? 0
  };
};
const toTitoUpdateModel = (tito) => ({
  key: tito.key,
  startTime: tito.startTime,
  stopTime: tito.stopTime,
  nonworkHours: tito.nonworkHours,
  comments: tito.comments
});
const toTimeslipUpdateModel = (timeslip) => {
  return {
    key: timeslip.key,
    projectKey: timeslip.project.key ?? -1,
    taskKey: timeslip.task?.key,
    laborCategoryKey: timeslip.laborCategory?.key,
    locationKey: timeslip.location?.key,
    projectTypeKey: timeslip.projectType.key ?? -1,
    payCodeKey: timeslip.payCode.key ?? -1,
    workDate: timeslip.workDate ?? "",
    hoursWorked: timeslip.hoursWorked ?? 0,
    comments: timeslip.comments,
    titos: timeslip.titos?.map(toTitoUpdateModel)
  };
};
const toTimesheetDayUpdateModel = (tito) => {
  return {
    key: tito.key,
    workDate: tito.workDate,
    titos: tito.titos?.map(toTitoUpdateModel)
  };
};
const toTimeStatusHistory = (model) => {
  return {
    ...model,
    actionTimestamp: DateTime.fromISO(model.actionTimestamp),
    reviewTimestamp: model.reviewTimestamp ? DateTime.fromISO(model.reviewTimestamp) : void 0
  };
};
const toTimeslipAudit = (model) => {
  return {
    ...model,
    workDate: DateTime.fromISO(model.workDate),
    modifiedDate: model.modifiedDate ? DateTime.fromISO(model.modifiedDate) : void 0,
    from: 0,
    to: 0
  };
};
const toTimeslipAdjustment = (model) => {
  return {
    ...model,
    workDate: model.workDate ? DateTime.fromISO(model.workDate) : void 0,
    postDate: model.postDate ? DateTime.fromISO(model.postDate) : void 0,
    lastUpdate: model.lastUpdate ? DateTime.fromISO(model.lastUpdate) : void 0,
    from: 0,
    to: 0
  };
};
const toTimeApprovalQueue = (model) => {
  return {
    ...model,
    beginDate: model.beginDate ? DateTime.fromISO(model.beginDate) : void 0,
    endDate: model.endDate ? DateTime.fromISO(model.endDate) : void 0,
    adjustmentDate: model.adjustmentDate ? DateTime.fromISO(model.adjustmentDate) : void 0,
    statusDate: model.statusDate ? DateTime.fromISO(model.statusDate) : void 0
  };
};
const isSameTimesheetRow = (audit2, timeslip) => {
  return (audit2.projectKey ?? null) === (timeslip.project.key ?? null) && (audit2.taskKey ?? null) === (timeslip.task?.key ?? null) && (audit2.locationKey ?? null) === (timeslip.location?.key ?? null) && (audit2.projectTypeKey ?? null) === (timeslip.projectType.key ?? null) && (audit2.payCodeKey ?? null) === (timeslip.payCode.key ?? null);
};
const mergeCurrent = (audit2, current) => {
  if (current) {
    return {
      ...audit2,
      project: current.project,
      task: current.task,
      laborCategory: current.laborCategory,
      location: current.location,
      payCode: current.payCode,
      projectType: current.projectType
    };
  } else {
    return { ...audit2 };
  }
};
const hydrateAudits = ({
  audits,
  timesheet,
  adjustments
}) => {
  const hydrated = [];
  audits.forEach((audit2, i) => {
    const nextAudit = i + 1 < audits.length ? audits[i + 1] : null;
    const wentToCurrentOrAdjustments = nextAudit?.key !== audit2.key;
    const current = timesheet.timeslips?.find((s12) => s12.key === audit2.key);
    const adjustment = adjustments.find((a) => a.key === audit2.key);
    if (wentToCurrentOrAdjustments && (current || adjustment)) {
      const sameTimesheetRow = isSameTimesheetRow(
        audit2,
        current ?? adjustment
      );
      hydrated.push({
        ...audit2,
        key: hydrated.length,
        from: audit2.hoursWorked,
        to: sameTimesheetRow ? current?.hoursWorked ?? 0 : 0
      });
      if (!sameTimesheetRow) {
        hydrated.push({
          ...mergeCurrent(audit2, current ?? adjustment),
          key: hydrated.length,
          from: 0,
          to: (current ?? adjustment)?.hoursWorked ?? 0
        });
      }
    } else {
      if (!nextAudit || !isSameTimesheetRow(audit2, nextAudit)) {
        hydrated.push({
          ...audit2,
          key: hydrated.length,
          from: audit2.hoursWorked,
          to: 0
        });
        hydrated.push({
          ...audit2,
          key: hydrated.length,
          from: 0,
          to: nextAudit?.hoursWorked ?? 0
        });
      } else {
        hydrated.push({
          ...audit2,
          key: hydrated.length,
          from: audit2.hoursWorked,
          to: nextAudit?.hoursWorked ?? 0
        });
      }
    }
  });
  return hydrated.sort((a, b) => a.workDate.toMillis() - b.workDate.toMillis());
};
const projectRowKey = (row) => {
  const kv2 = (k, v) => `${k}=${v?.key ?? "x"}`;
  return [
    kv2("p", row.project),
    kv2("t", row.task),
    kv2("lc", row.laborCategory),
    kv2("l", row.location),
    kv2("pt", row.projectType),
    kv2("pc", row.payCode)
  ].join("|");
};
const combineAdjustments = (adjustments) => {
  const map2 = /* @__PURE__ */ new Map();
  adjustments.forEach((a) => {
    const key = `${a.workDate?.toISODate()}|${projectRowKey(a)}`;
    map2.set(
      key,
      uniqBy(
        [...map2.get(key) ?? [], a].sort((a22, b) => a22.key - b.key),
        (x) => x.key
      )
    );
  });
  const matches = [];
  map2.forEach((adjustments2) => matches.push(...combine(adjustments2)));
  return matches.sort((a, b) => {
    const aDate = a.workDate;
    const bDate = b.workDate;
    const sameDay = aDate.hasSame(bDate, "day");
    return sameDay ? a.key - b.key : aDate.toMillis() - bDate.toMillis();
  });
};
const combine = (adjustments) => {
  const pairs = chunk(adjustments, 2);
  const matches = pairs.map((pair, i) => {
    const next2 = i + 1 < pairs.length ? pairs[i + 1] : null;
    const toZero = !next2 && pair.length === 2;
    const fromZero = !next2 && i === 0 && pair.length === 1;
    const toNext = next2 && pair.length === 2;
    if (toZero) {
      return { ...pair[1] ?? pair[0], from: pair[0].hoursWorked, to: 0 };
    } else if (fromZero) {
      return { ...pair[0], from: 0, to: pair[0].hoursWorked };
    } else if (toNext) {
      return { ...next2[0], from: pair[0].hoursWorked, to: next2[0].hoursWorked };
    } else {
      return void 0;
    }
  });
  return matches.filter((m) => !!m);
};
const roundHours = (hours, increment) => {
  switch (increment) {
    case TimeEntryIncrementHours.Hundredth:
      return new Big(hours).round(2).toNumber();
    case TimeEntryIncrementHours.Twentieth:
      return new Big(hours).times(20).round().div(20).toNumber();
    case TimeEntryIncrementHours.Tenth:
      return new Big(hours).round(1).toNumber();
    default:
      return Math.round(parseFloat(hours) / increment) * increment;
  }
};
const getTimeEntryIncrementDecimalScale = (increment) => {
  const incrementStr = increment.toString();
  const decimalIndex = incrementStr.indexOf(".");
  return decimalIndex === -1 ? 0 : incrementStr.length - decimalIndex - 1;
};
const timesheetEffectiveStatus = (timesheet) => {
  return timesheet.adjustmentStatus ?? timesheet.status;
};
const hasTimesheetValidationErrorMessages = (timesheetValidation) => {
  return !!timesheetValidation && (!!timesheetValidation.errors?.length || !!timesheetValidation.itemEntryErrors?.length || !!timesheetValidation.timesheetTITOMissingStops?.length || !!timesheetValidation.timesheetTITOOverlaps?.length || !!timesheetValidation.timeslipErrors?.length || !!timesheetValidation.timeslipTITOMissingStops?.length || !!timesheetValidation.timeslipTITOOverlaps?.length || !!timesheetValidation.titoHourMismatches?.length);
};
const hasTimesheetValidationWarningMessages = (timesheetValidation) => {
  return !!timesheetValidation && (timesheetValidation.warnings?.length ?? 0) > 0;
};
const auditComments = (updatedTimesheet, button2, ignoreWarnings, isPeopleTimesheet, subdomain) => {
  const uri = isPeopleTimesheet ? `/${subdomain}/action/people/time/audit/comments?timesheetkey=${updatedTimesheet.key}&submitButton=${button2}&ignore_warnings=${ignoreWarnings}` : `/${subdomain}/action/time/audit/comments?timesheetkey=${updatedTimesheet.key}&submitButton=${button2}&ignore_warnings=${ignoreWarnings}`;
  open(uri, "_self");
};
const adjustmentComments = (updatedTimesheet, button2, comments, ignoreWarnings, isPeopleTimesheet, subdomain) => {
  const uri = isPeopleTimesheet ? `/${subdomain}/action/people/time/adjustment/comments?timesheetkey=${updatedTimesheet.key}&submitButton=${button2}&submitComments=${comments}&ignore_warnings=${ignoreWarnings}` : `/${subdomain}/action/time/adjustment/comments?timesheetkey=${updatedTimesheet.key}&submitButton=${button2}&submitComments=${comments}&ignore_warnings=${ignoreWarnings}`;
  open(uri, "_self");
};
const hoursBetween = (startTime, stopTime) => {
  const roundedHours = round$5(
    stopTime.diff(startTime, "hours").hours,
    HOURS_SCALE
  );
  return roundedHours < 0 ? 0 : roundedHours;
};
const formatTitoTimeRange = (tito) => {
  if (!tito.startTime) {
    return "";
  }
  const start2 = DateTime.fromISO(tito.startTime);
  if (!start2.isValid) {
    return "";
  }
  const startStr = start2.toLocaleString(DateTime.TIME_SIMPLE);
  if (!tito.stopTime) {
    return startStr;
  }
  const stop = DateTime.fromISO(tito.stopTime);
  if (!stop.isValid) {
    return startStr;
  }
  return `${startStr} – ${stop.toLocaleString(DateTime.TIME_SIMPLE)}`;
};
const richTito = ({
  startTime: rawStart,
  stopTime: rawStop,
  ...t16
}) => {
  const parsedStart = rawStart ? DateTime.fromISO(rawStart) : false;
  const parsedStop = rawStop ? DateTime.fromISO(rawStop) : void 0;
  if (parsedStart && !parsedStart.isValid) {
    throw new Error(`Invalid start time: ${rawStart}`);
  }
  if (parsedStop && !parsedStop.isValid) {
    throw new Error(`Invalid stop time: ${rawStop}`);
  }
  return {
    ...t16,
    startTime: parsedStart,
    stopTime: parsedStop
  };
};
const datesWithinDays = (isoDateA, isoDateB, days) => {
  const dateA = DateTime.fromISO(isoDateA);
  const dateB = DateTime.fromISO(isoDateB);
  if (!dateA.isValid || !dateB.isValid) {
    return false;
  }
  const daysDiff = Math.abs(
    dateB.startOf("day").diff(dateA.startOf("day"), "days").days
  );
  return daysDiff <= days;
};
function mergeTitos({
  activeTitos,
  dailyTito,
  isEditing,
  workDate,
  includeAdjacentDates
}) {
  if (!workDate) {
    return [];
  }
  const savedTitos = (dailyTito ?? []).filter(
    (dt2) => includeAdjacentDates ? datesWithinDays(workDate, dt2.workDate, 1) : dt2.workDate === workDate
  ).flatMap((dt2) => dt2.titos ?? []);
  return isEditing ? (() => {
    const activeTitoKeys = new Set(
      activeTitos.map((t16) => t16.key).filter((k) => k !== null)
    );
    const savedNotBeingEdited = savedTitos.filter(
      (t16) => !activeTitoKeys.has(t16.key)
    );
    return [
      ...savedNotBeingEdited,
      ...activeTitos.map((t16) => ({
        ...t16,
        editing: false,
        error: false,
        startTime: t16.startTime ?? "",
        stopTime: t16.stopTime ?? void 0
      }))
    ];
  })() : savedTitos;
}
function mergeProjectTitos({
  activeProjectKey,
  activeTitos,
  timeslips,
  workDate,
  includeAdjacentDates
}) {
  if (!timeslips) {
    return [];
  }
  return timeslips.filter(
    (timeslip) => includeAdjacentDates ? datesWithinDays(workDate, timeslip.workDate ?? "", 1) : timeslip.workDate === workDate
  ).flatMap((timeslip) => {
    const projectKey = timeslip.project?.key;
    const isActiveProject = projectKey !== void 0 && activeProjectKey !== void 0 && projectKey === activeProjectKey && timeslip.workDate === workDate;
    const titos = isActiveProject ? activeTitos : timeslip.titos ?? [];
    return titos.map((tito) => ({
      ...tito,
      projectKey: timeslip.project?.key,
      projectName: timeslip.project?.name
    }));
  });
}
const calcTitoWorkHours = (tito, hoursIncrement) => {
  const { startTime, stopTime, nonworkHours = 0 } = tito;
  if (startTime === null || startTime === false || stopTime == null) {
    return 0;
  }
  const enforce = helpers.bool("unatime.tito.enforce.user_time_increment");
  if (enforce) {
    return roundHours(
      stopTime > startTime ? String(hoursBetween(startTime, stopTime) - nonworkHours) : "0",
      hoursIncrement
    );
  } else {
    return hoursBetween(startTime, stopTime) - nonworkHours;
  }
};
const calcTotalTitoWorkHours = (titos, hoursIncrement) => {
  return titos.reduce(
    (runningTotal, tito) => round$5(
      runningTotal + calcTitoWorkHours(tito, hoursIncrement),
      HOURS_SCALE
    ),
    0
  );
};
const getTitoTimeIncrementSetting = (increment) => {
  return increment === TimeEntryIncrementHours.Hundredth ? TimeEntryIncrementHours.Twentieth : increment;
};
const hasAdministrativeRoles = (user) => [Role.Administrator, Role.HRAdmin, Role.PRAdministrator].some(
  (role) => hasRole(user, role)
);
const hasTimeManagerRoles = (user) => [Role.Manager, Role.ManagerAlternate].some((role) => hasRole(user, role));
const hasTimesheetRoles = (user) => [Role.Timesheet, Role.TimesheetUserAlternate].some(
  (role) => hasRole(user, role)
);
const hasAdminEditPermission = (user) => user.roles?.some((r12) => r12 === Role.TimesheetSpecialist) || helpers.bool("unatime.admin.edit") && hasAdministrativeRoles(user);
const hasManagerEditPermission = (user) => helpers.bool("unatime.manager.edit") && hasTimeManagerRoles(user);
const hasUserEditPermission = (user) => hasTimesheetRoles(user);
const hasTimeListEditPermission = ({
  pageView,
  authUser
}) => {
  if (!authUser) {
    return false;
  }
  switch (pageView) {
    case TimeListView.AdminPeople:
      return hasAdminEditPermission(authUser);
    case TimeListView.MyPeople:
      return hasManagerEditPermission(authUser);
    default:
      return hasUserEditPermission(authUser);
  }
};
const canEditTimesheet = (timesheet, user) => {
  const { status, timePeriod, historical } = timesheet;
  if (historical) {
    return false;
  }
  const isTimesheetInEditableStatus = ![
    TimesheetListModel.StatusEnum.LOCKED,
    TimesheetListModel.StatusEnum.EXTRACTED
  ].includes(status);
  const doesTimePeriodAllowsEdit = hasAdministrativeRoles(user) || user.roles?.some((r12) => r12 === Role.TimesheetSpecialist) || !timePeriod.adminOnlyAccess;
  return !historical && isTimesheetInEditableStatus && doesTimePeriodAllowsEdit;
};
const canAdjustTimesheet = (timesheet, user) => {
  const { status, adjustmentStatus, timePeriod, historical, properties: properties2 } = timesheet;
  if (historical) {
    return false;
  }
  const isTimesheetInAdjustableStatus = [
    TimesheetListModel.StatusEnum.LOCKED,
    TimesheetListModel.StatusEnum.EXTRACTED
  ].includes(status);
  const allowEndUserAdjustment = Boolean(properties2?.enableEndUserAdjustment);
  const doesTimePeriodAllowsEdit = hasAdministrativeRoles(user) || !timePeriod.adminOnlyAccess;
  const doesTimePeriodAllowsAdjustment = adjustmentStatus !== null || timePeriod.allowUserAdjustments;
  return !historical && isTimesheetInAdjustableStatus && allowEndUserAdjustment && doesTimePeriodAllowsEdit && doesTimePeriodAllowsAdjustment;
};
const allowTimesheetEdit = (timesheet, user) => {
  if (!user) {
    return false;
  }
  return canEditTimesheet(timesheet, user) || canAdjustTimesheet(timesheet, user);
};
const canDeleteTimesheetAsAdmin = (timesheet, user) => {
  if (timesheet.historical) {
    return false;
  }
  const { status, adjustmentStatus } = timesheet;
  if (hasAdminEditPermission(user)) {
    if (adjustmentStatus) {
      return adjustmentStatus === TimesheetListModel.AdjustmentStatusEnum.INUSE || canAdjustTimesheet(timesheet, user);
    } else {
      return [
        TimesheetListModel.StatusEnum.INUSE,
        TimesheetListModel.StatusEnum.DISAPPROVED
      ].includes(status) && canEditTimesheet(timesheet, user);
    }
  } else {
    return false;
  }
};
const canDeleteTimesheet = (timesheet, user, _viewContext) => {
  if (!user) {
    return false;
  }
  const { status, adjustmentStatus } = timesheet;
  if ([Role.Administrator, Role.PRAdministrator].some((r12) => hasRole(user, r12))) {
    return canDeleteTimesheetAsAdmin(timesheet, user);
  } else {
    if (adjustmentStatus) {
      return adjustmentStatus === TimesheetListModel.AdjustmentStatusEnum.INUSE || canAdjustTimesheet(timesheet, user);
    } else {
      return [
        TimesheetListModel.StatusEnum.INUSE,
        TimesheetListModel.StatusEnum.DISAPPROVED
      ].includes(status) && Boolean(timesheet.properties?.allowEndUserToDeleteTimesheet) && Boolean(!timesheet.properties?.enableTimesheetAuditTrail) && canEditTimesheet(timesheet, user);
    }
  }
};
const canAdminAdjustTimesheet = (timesheet, user) => {
  if (!user) {
    return false;
  }
  const { status, adjustmentStatus, historical } = timesheet;
  if (historical) {
    return false;
  }
  const lockedOrExtractedStatus = [
    TimesheetListModel.StatusEnum.LOCKED,
    TimesheetListModel.StatusEnum.EXTRACTED
  ].includes(status);
  const rightRole = hasAdministrativeRoles(user) || hasRole(user, Role.TimesheetAdmin);
  return rightRole && lockedOrExtractedStatus && !adjustmentStatus;
};
var DashboardLeftMenuId = /* @__PURE__ */ ((DashboardLeftMenuId2) => {
  DashboardLeftMenuId2["AccountsPayable"] = "/accounts_payable";
  DashboardLeftMenuId2["AccountsReceivable"] = "/accounts_receivable";
  DashboardLeftMenuId2["Admin"] = "/admin";
  DashboardLeftMenuId2["Billing"] = "/billing";
  DashboardLeftMenuId2["Contract"] = "/contract";
  DashboardLeftMenuId2["Contracts"] = "/contracts";
  DashboardLeftMenuId2["Documents"] = "/shareddocs";
  DashboardLeftMenuId2["Expense"] = "/expense";
  DashboardLeftMenuId2["Financials"] = "/financials";
  DashboardLeftMenuId2["FixedAssets"] = "/fixed_assets";
  DashboardLeftMenuId2["Forecast"] = "/forecast";
  DashboardLeftMenuId2["GeneralLedger"] = "/general_ledger";
  DashboardLeftMenuId2["Home"] = "/home";
  DashboardLeftMenuId2["Organizations"] = "/organizations";
  DashboardLeftMenuId2["People"] = "/people";
  DashboardLeftMenuId2["Projects"] = "/projects";
  DashboardLeftMenuId2["Purchasing"] = "/purchasing";
  DashboardLeftMenuId2["Reports"] = "/reports";
  DashboardLeftMenuId2["Time"] = "/time";
  return DashboardLeftMenuId2;
})(DashboardLeftMenuId || {});
const DASHBOARD_MENU_IDS = /* @__PURE__ */ new Map([
  [
    DashboardMenuId.AccountsReceivable,
    "/accounts_receivable"
    /* AccountsReceivable */
  ],
  [
    DashboardMenuId.AccountsPayable,
    "/accounts_payable"
    /* AccountsPayable */
  ],
  [
    DashboardMenuId.Admin,
    "/admin"
    /* Admin */
  ],
  [
    DashboardMenuId.Billing,
    "/billing"
    /* Billing */
  ],
  [
    DashboardMenuId.Contracts,
    "/contracts"
    /* Contracts */
  ],
  [
    DashboardMenuId.ContractsContracts,
    "/contract"
    /* Contract */
  ],
  [
    DashboardMenuId.Documents,
    "/shareddocs"
    /* Documents */
  ],
  [
    DashboardMenuId.Expense,
    "/expense"
    /* Expense */
  ],
  [
    DashboardMenuId.Financials,
    "/financials"
    /* Financials */
  ],
  [
    DashboardMenuId.FixedAssets,
    "/fixed_assets"
    /* FixedAssets */
  ],
  [
    DashboardMenuId.Forecast,
    "/forecast"
    /* Forecast */
  ],
  [
    DashboardMenuId.GeneralLedger,
    "/general_ledger"
    /* GeneralLedger */
  ],
  [
    DashboardMenuId.Home,
    "/home"
    /* Home */
  ],
  [
    DashboardMenuId.Organizations,
    "/organizations"
    /* Organizations */
  ],
  [
    DashboardMenuId.People,
    "/people"
    /* People */
  ],
  [
    DashboardMenuId.Projects,
    "/projects"
    /* Projects */
  ],
  [
    DashboardMenuId.Purchasing,
    "/purchasing"
    /* Purchasing */
  ],
  [
    DashboardMenuId.Reports,
    "/reports"
    /* Reports */
  ],
  [
    DashboardMenuId.Time,
    "/time"
    /* Time */
  ]
]);
const getMyLeftMenuBar = async (dashboard) => {
  const action = `leftDashboardMenu?${queryString.stringify({
    dashboardId: dashboard
  })}`;
  const leftMenu = await request({
    action,
    method: "GET",
    url: "/" + action
  });
  const dashboardMenuId = Object.keys(leftMenu)[0];
  const menus = leftMenu[dashboardMenuId];
  const menuBar = [];
  for (const [label, items] of Object.entries(menus)) {
    const unescapedItems = items.map(({ source, title, ...rest }) => ({
      ...rest,
      source: unescape$1(source),
      title: title ? unescape$1(title) : null
    }));
    menuBar.push({ label, items: unescapedItems });
  }
  return menuBar;
};
const getCurrentPageDashboardMenuId = (appMenu) => {
  if (!appMenu) {
    return null;
  }
  if (window.location.pathname.endsWith("/action/home")) {
    return DashboardMenuId.Home;
  }
  const menu = findMenuByUrl(appMenu.menu);
  if (!menu) {
    return null;
  }
  const dashboardMenuId = menu.id.replace("menu.top", "gc") + ".dashboard";
  for (const [_key, value] of Object.entries(DashboardMenuId)) {
    if (value === dashboardMenuId) {
      return value;
    }
  }
  return null;
};
const normalize = (url2) => url2.replace("spa_action", "action");
const findMenuByUrl = (menus) => {
  const currentPagePathname = normalize(window.location.pathname);
  for (const menu of menus) {
    if (normalize(menu.uri) === currentPagePathname) {
      return menu;
    }
    const nestedMenu = findMenuByUrl(menu.menu);
    if (nestedMenu) {
      return nestedMenu;
    }
  }
  return void 0;
};
const getCurrentPageDashboardLeftMenuId = (appMenu) => {
  const menuId = getCurrentPageDashboardMenuId(appMenu);
  return menuId ? DASHBOARD_MENU_IDS.get(menuId) ?? null : null;
};
const experienceCenterUrlDefault = `https://support.unanet.com/s/`;
const buildUrl = (kcHint, passportUrl, encodedUrl) => {
  const kcParts = kcHint.split("/");
  return passportUrl + "?kc_idp_hint=" + kcParts[kcParts.length - 1] + "&RelayState=" + encodedUrl;
};
const buildExperienceCenterLink = (urlName) => {
  const kcHint = helpers.string("unanet.sso.oauth.issuer");
  const passportEnabled = helpers.bool("passport.enabled");
  const passportUrl = helpers.string("unanet.idp.host.url");
  const defaultUrl = experienceCenterUrlDefault + `article/${urlName}`;
  if (passportUrl !== "" && kcHint !== "" && passportEnabled) {
    const encodedUrl = encodeURIComponent(defaultUrl);
    return buildUrl(kcHint, passportUrl, encodedUrl);
  }
  return defaultUrl;
};
const buildDefaultExperienceCenterLink = () => {
  const kcHint = helpers.string("unanet.sso.oauth.issuer");
  const passportEnabled = helpers.bool("passport.enabled");
  const passportUrl = helpers.string("unanet.idp.host.url");
  if (passportUrl !== "" && kcHint !== "" && passportEnabled) {
    const encodedUrl = encodeURIComponent(experienceCenterUrlDefault);
    return buildUrl(kcHint, passportUrl, encodedUrl);
  }
  return experienceCenterUrlDefault;
};
var StagingRecordPurchaseOrderLineKey = /* @__PURE__ */ ((StagingRecordPurchaseOrderLineKey2) => {
  StagingRecordPurchaseOrderLineKey2["Expense"] = "E";
  StagingRecordPurchaseOrderLineKey2["Item"] = "I";
  StagingRecordPurchaseOrderLineKey2["Labor"] = "L";
  return StagingRecordPurchaseOrderLineKey2;
})(StagingRecordPurchaseOrderLineKey || {});
var StagingRecordInvoiceProperties = /* @__PURE__ */ ((StagingRecordInvoiceProperties2) => {
  StagingRecordInvoiceProperties2["LegalEntity"] = "legalEntity";
  StagingRecordInvoiceProperties2["Vendor"] = "vendorName";
  StagingRecordInvoiceProperties2["PurchaseOrderNumber"] = "purchaseOrderNumber";
  StagingRecordInvoiceProperties2["InvoiceAmount"] = "total";
  StagingRecordInvoiceProperties2["InvoiceNumber"] = "invoiceNumber";
  StagingRecordInvoiceProperties2["InvoiceDate"] = "invoiceDate";
  StagingRecordInvoiceProperties2["Description"] = "description";
  StagingRecordInvoiceProperties2["Organization"] = "apOrganization";
  StagingRecordInvoiceProperties2["Account"] = "apAccount";
  StagingRecordInvoiceProperties2["DocumentDate"] = "documentDate";
  StagingRecordInvoiceProperties2["PostDate"] = "postDate";
  StagingRecordInvoiceProperties2["FiscalPeriod"] = "fiscalPeriod";
  StagingRecordInvoiceProperties2["PaymentTerms"] = "paymentTerms";
  StagingRecordInvoiceProperties2["DueDate"] = "dueDate";
  StagingRecordInvoiceProperties2["DiscountDate"] = "discountDate";
  StagingRecordInvoiceProperties2["DiscountAmount"] = "discountAmount";
  StagingRecordInvoiceProperties2["Currency"] = "currency";
  return StagingRecordInvoiceProperties2;
})(StagingRecordInvoiceProperties || {});
var LineItemPropertyNames = /* @__PURE__ */ ((LineItemPropertyNames2) => {
  LineItemPropertyNames2["Account"] = "Account";
  LineItemPropertyNames2["Amount"] = "Amount";
  LineItemPropertyNames2["Date"] = "Date";
  LineItemPropertyNames2["Description"] = "Description";
  LineItemPropertyNames2["ExpenseType"] = "ExpenseType";
  LineItemPropertyNames2["Hours"] = "Hours";
  LineItemPropertyNames2["Item"] = "Item";
  LineItemPropertyNames2["LaborCategory"] = "LaborCategory";
  LineItemPropertyNames2["Organization"] = "Organization";
  LineItemPropertyNames2["Person"] = "Person";
  LineItemPropertyNames2["Project"] = "Project";
  LineItemPropertyNames2["ProjectType"] = "ProjectType";
  LineItemPropertyNames2["Quantity"] = "Quantity";
  LineItemPropertyNames2["Rate"] = "Rate";
  LineItemPropertyNames2["Reference"] = "Reference";
  LineItemPropertyNames2["RelatesTo"] = "RelatesTo";
  LineItemPropertyNames2["Task"] = "Task";
  LineItemPropertyNames2["UOM"] = "UOM";
  return LineItemPropertyNames2;
})(LineItemPropertyNames || {});
var StagingRecordLineProperties = /* @__PURE__ */ ((StagingRecordLineProperties2) => {
  StagingRecordLineProperties2["Account"] = "lineAccount";
  StagingRecordLineProperties2["Amount"] = "lineAmount";
  StagingRecordLineProperties2["Date"] = "lineDate";
  StagingRecordLineProperties2["Description"] = "lineDescription";
  StagingRecordLineProperties2["ExpenseType"] = "lineExpenseType";
  StagingRecordLineProperties2["Hours"] = "lineHours";
  StagingRecordLineProperties2["Item"] = "lineItem";
  StagingRecordLineProperties2["LaborCategory"] = "lineLaborCategory";
  StagingRecordLineProperties2["Organization"] = "lineOrganization";
  StagingRecordLineProperties2["Person"] = "linePerson";
  StagingRecordLineProperties2["Project"] = "lineProject";
  StagingRecordLineProperties2["ProjectType"] = "lineProjectType";
  StagingRecordLineProperties2["Quantity"] = "lineQuantity";
  StagingRecordLineProperties2["Rate"] = "lineRate";
  StagingRecordLineProperties2["Reference"] = "lineReference";
  StagingRecordLineProperties2["RelatesTo"] = "lineRelatesTo";
  StagingRecordLineProperties2["Task"] = "lineTask";
  StagingRecordLineProperties2["UOM"] = "lineUOM";
  return StagingRecordLineProperties2;
})(StagingRecordLineProperties || {});
var StagingRecordLaborProperties = /* @__PURE__ */ ((StagingRecordLaborProperties2) => {
  StagingRecordLaborProperties2["Account"] = "laborLineAccount";
  StagingRecordLaborProperties2["Amount"] = "laborLineAmount";
  StagingRecordLaborProperties2["Date"] = "laborLineDate";
  StagingRecordLaborProperties2["Description"] = "laborLineDescription";
  StagingRecordLaborProperties2["ExpenseType"] = "laborLineExpenseType";
  StagingRecordLaborProperties2["Hours"] = "laborLineHours";
  StagingRecordLaborProperties2["Item"] = "laborLineItem";
  StagingRecordLaborProperties2["LaborCategory"] = "laborLineLaborCategory";
  StagingRecordLaborProperties2["Organization"] = "laborLineOrganization";
  StagingRecordLaborProperties2["Person"] = "laborLinePerson";
  StagingRecordLaborProperties2["Project"] = "laborLineProject";
  StagingRecordLaborProperties2["ProjectType"] = "laborLineProjectType";
  StagingRecordLaborProperties2["Quantity"] = "laborLineQuantity";
  StagingRecordLaborProperties2["Rate"] = "laborLineRate";
  StagingRecordLaborProperties2["Reference"] = "laborLineReference";
  StagingRecordLaborProperties2["RelatesTo"] = "laborLineRelatesTo";
  StagingRecordLaborProperties2["Task"] = "laborLineTask";
  StagingRecordLaborProperties2["UOM"] = "laborLineUOM";
  return StagingRecordLaborProperties2;
})(StagingRecordLaborProperties || {});
var StagingRecordExpenseProperties = /* @__PURE__ */ ((StagingRecordExpenseProperties2) => {
  StagingRecordExpenseProperties2["Account"] = "expenseLineAccount";
  StagingRecordExpenseProperties2["Amount"] = "expenseLineAmount";
  StagingRecordExpenseProperties2["Date"] = "expenseLineDate";
  StagingRecordExpenseProperties2["Description"] = "expenseLineDescription";
  StagingRecordExpenseProperties2["ExpenseType"] = "expenseLineExpenseType";
  StagingRecordExpenseProperties2["Hours"] = "expenseLineHours";
  StagingRecordExpenseProperties2["Item"] = "expenseLineItem";
  StagingRecordExpenseProperties2["LaborCategory"] = "expenseLineLaborCategory";
  StagingRecordExpenseProperties2["Organization"] = "expenseLineOrganization";
  StagingRecordExpenseProperties2["Person"] = "expenseLinePerson";
  StagingRecordExpenseProperties2["Project"] = "expenseLineProject";
  StagingRecordExpenseProperties2["ProjectType"] = "expenseLineProjectType";
  StagingRecordExpenseProperties2["Quantity"] = "expenseLineQuantity";
  StagingRecordExpenseProperties2["Rate"] = "expenseLineRate";
  StagingRecordExpenseProperties2["Reference"] = "expenseLineReference";
  StagingRecordExpenseProperties2["RelatesTo"] = "expenseLineRelatesTo";
  StagingRecordExpenseProperties2["Task"] = "expenseLineTask";
  StagingRecordExpenseProperties2["UOM"] = "expenseLineUOM";
  return StagingRecordExpenseProperties2;
})(StagingRecordExpenseProperties || {});
var StagingRecordItemProperties = /* @__PURE__ */ ((StagingRecordItemProperties2) => {
  StagingRecordItemProperties2["Account"] = "itemLineAccount";
  StagingRecordItemProperties2["Amount"] = "itemLineAmount";
  StagingRecordItemProperties2["Date"] = "itemLineDate";
  StagingRecordItemProperties2["Description"] = "itemLineDescription";
  StagingRecordItemProperties2["ExpenseType"] = "itemLineExpenseType";
  StagingRecordItemProperties2["Hours"] = "itemLineHours";
  StagingRecordItemProperties2["Item"] = "itemLineItem";
  StagingRecordItemProperties2["LaborCategory"] = "itemLineLaborCategory";
  StagingRecordItemProperties2["Organization"] = "itemLineOrganization";
  StagingRecordItemProperties2["Person"] = "itemLinePerson";
  StagingRecordItemProperties2["Project"] = "itemLineProject";
  StagingRecordItemProperties2["ProjectType"] = "itemLineProjectType";
  StagingRecordItemProperties2["Quantity"] = "itemLineQuantity";
  StagingRecordItemProperties2["Rate"] = "itemLineRate";
  StagingRecordItemProperties2["Reference"] = "itemLineReference";
  StagingRecordItemProperties2["RelatesTo"] = "itemLineRelatesTo";
  StagingRecordItemProperties2["Task"] = "itemLineTask";
  StagingRecordItemProperties2["UOM"] = "itemLineUOM";
  return StagingRecordItemProperties2;
})(StagingRecordItemProperties || {});
// @__NO_SIDE_EFFECTS__
function makeMap(str) {
  const map2 = /* @__PURE__ */ Object.create(null);
  for (const key of str.split(",")) map2[key] = 1;
  return (val) => val in map2;
}
const EMPTY_OBJ = !!(process.env.NODE_ENV !== "production") ? Object.freeze({}) : {};
const EMPTY_ARR = !!(process.env.NODE_ENV !== "production") ? Object.freeze([]) : [];
const NOOP = () => {
};
const isOn = (key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
(key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const isModelListener = (key) => key.startsWith("onUpdate:");
const extend = Object.assign;
const remove = (arr, el) => {
  const i = arr.indexOf(el);
  if (i > -1) {
    arr.splice(i, 1);
  }
};
const hasOwnProperty$1 = Object.prototype.hasOwnProperty;
const hasOwn = (val, key) => hasOwnProperty$1.call(val, key);
const isArray = Array.isArray;
const isMap = (val) => toTypeString(val) === "[object Map]";
const isSet = (val) => toTypeString(val) === "[object Set]";
const isDate = (val) => toTypeString(val) === "[object Date]";
const isFunction = (val) => typeof val === "function";
const isString = (val) => typeof val === "string";
const isSymbol = (val) => typeof val === "symbol";
const isObject = (val) => val !== null && typeof val === "object";
const isPromise = (val) => {
  return (isObject(val) || isFunction(val)) && isFunction(val.then) && isFunction(val.catch);
};
const objectToString = Object.prototype.toString;
const toTypeString = (value) => objectToString.call(value);
const toRawType = (value) => {
  return toTypeString(value).slice(8, -1);
};
const isPlainObject$1 = (val) => toTypeString(val) === "[object Object]";
const isIntegerKey = (key) => isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const cacheStringFunction = (fn3) => {
  const cache2 = /* @__PURE__ */ Object.create(null);
  return ((str) => {
    const hit = cache2[str];
    return hit || (cache2[str] = fn3(str));
  });
};
const camelizeRE = /-\w/g;
const camelize = cacheStringFunction(
  (str) => {
    return str.replace(camelizeRE, (c) => c.slice(1).toUpperCase());
  }
);
const capitalize = cacheStringFunction((str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
});
const toHandlerKey = cacheStringFunction(
  (str) => {
    const s12 = str ? `on${capitalize(str)}` : ``;
    return s12;
  }
);
const hasChanged = (value, oldValue) => !Object.is(value, oldValue);
const invokeArrayFns = (fns, ...arg2) => {
  for (let i = 0; i < fns.length; i++) {
    fns[i](...arg2);
  }
};
const def = (obj, key, value, writable = false) => {
  Object.defineProperty(obj, key, {
    configurable: true,
    enumerable: false,
    writable,
    value
  });
};
const looseToNumber = (val) => {
  const n12 = parseFloat(val);
  return isNaN(n12) ? val : n12;
};
const toNumber = (val) => {
  const n12 = isString(val) ? Number(val) : NaN;
  return isNaN(n12) ? val : n12;
};
let _globalThis;
const getGlobalThis = () => {
  return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
function normalizeStyle(value) {
  if (isArray(value)) {
    const res = {};
    for (let i = 0; i < value.length; i++) {
      const item = value[i];
      const normalized = isString(item) ? parseStringStyle(item) : normalizeStyle(item);
      if (normalized) {
        for (const key in normalized) {
          res[key] = normalized[key];
        }
      }
    }
    return res;
  } else if (isString(value) || isObject(value)) {
    return value;
  }
}
const listDelimiterRE = /;(?![^(]*\))/g;
const propertyDelimiterRE = /:([^]+)/;
const styleCommentRE = /"(?:[^"\\]|\\[^])*"|'(?:[^'\\]|\\[^])*'|\\[^]|\/\*[^]*?\*\//g;
function parseStringStyle(cssText) {
  const ret = {};
  cssText.replace(styleCommentRE, (match2) => match2.startsWith("/*") ? "" : match2).split(listDelimiterRE).forEach((item) => {
    if (item) {
      const tmp = item.split(propertyDelimiterRE);
      tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return ret;
}
function normalizeClass(value) {
  let res = "";
  if (isString(value)) {
    res = value;
  } else if (isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      const normalized = normalizeClass(value[i]);
      if (normalized) {
        res += normalized + " ";
      }
    }
  } else if (isObject(value)) {
    for (const name in value) {
      if (value[name]) {
        res += name + " ";
      }
    }
  }
  return res.trim();
}
function normalizeProps(props) {
  if (!props) return null;
  let { class: klass, style: style2 } = props;
  if (klass && !isString(klass)) {
    props.class = normalizeClass(klass);
  }
  if (style2) {
    props.style = normalizeStyle(style2);
  }
  return props;
}
function looseCompareArrays(a, b, seen) {
  if (a.length !== b.length) return false;
  let equal = true;
  for (let i = 0; equal && i < a.length; i++) {
    equal = looseEqual(a[i], b[i], seen);
  }
  return equal;
}
function looseCompareCollections(a, b, seen) {
  if (a.size !== b.size) return false;
  const candidates = Array.from(b);
  const matched = new Uint8Array(candidates.length);
  for (const item of a) {
    let index2 = -1;
    for (let i = 0; i < candidates.length; i++) {
      if (!matched[i] && looseEqual(item, candidates[i], seen)) {
        index2 = i;
        break;
      }
    }
    if (index2 < 0) return false;
    matched[index2] = 1;
  }
  return true;
}
function looseCompareObjects(a, b, seen) {
  let aValidType = isMap(a);
  let bValidType = isMap(b);
  if (aValidType || bValidType) {
    return aValidType && bValidType ? looseCompareCollections(a, b, seen) : false;
  }
  aValidType = isSet(a);
  bValidType = isSet(b);
  if (aValidType || bValidType) {
    return aValidType && bValidType ? looseCompareCollections(a, b, seen) : false;
  }
  const aKeysCount = Object.keys(a).length;
  const bKeysCount = Object.keys(b).length;
  if (aKeysCount !== bKeysCount) {
    return false;
  }
  for (const key in a) {
    const aHasKey = a.hasOwnProperty(key);
    const bHasKey = b.hasOwnProperty(key);
    if (aHasKey && !bHasKey || !aHasKey && bHasKey || !looseEqual(a[key], b[key], seen)) {
      return false;
    }
  }
  return String(a) === String(b);
}
function looseCompareNested(a, b, seen, compare5) {
  if (!seen) {
    seen = [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map()];
  }
  const [seenA, seenB] = seen;
  if (seenA.has(a) || seenB.has(b)) {
    return seenA.get(a) === b && seenB.get(b) === a;
  }
  seenA.set(a, b);
  seenB.set(b, a);
  const equal = compare5(a, b, seen);
  seenA.delete(a);
  seenB.delete(b);
  return equal;
}
function looseEqual(a, b, seen) {
  if (a === b) return true;
  let aValidType = isDate(a);
  let bValidType = isDate(b);
  if (aValidType || bValidType) {
    return aValidType && bValidType ? a.getTime() === b.getTime() : false;
  }
  aValidType = isSymbol(a);
  bValidType = isSymbol(b);
  if (aValidType || bValidType) {
    return a === b;
  }
  aValidType = isArray(a);
  bValidType = isArray(b);
  if (aValidType || bValidType) {
    return aValidType && bValidType ? looseCompareNested(a, b, seen, looseCompareArrays) : false;
  }
  aValidType = isObject(a);
  bValidType = isObject(b);
  if (aValidType || bValidType) {
    if (!aValidType || !bValidType) {
      return false;
    }
    return looseCompareNested(a, b, seen, looseCompareObjects);
  }
  return String(a) === String(b);
}
function looseIndexOf(arr, val) {
  return arr.findIndex((item) => looseEqual(item, val));
}
const isRef$1 = (val) => {
  return !!(val && val["__v_isRef"] === true);
};
const toDisplayString = (val) => {
  return isString(val) ? val : val == null ? "" : isArray(val) || isObject(val) && (val.toString === objectToString || !isFunction(val.toString)) ? isRef$1(val) ? toDisplayString(val.value) : JSON.stringify(val, replacer, 2) : String(val);
};
const replacer = (_key, val) => {
  if (isRef$1(val)) {
    return replacer(_key, val.value);
  } else if (isMap(val)) {
    return {
      [`Map(${val.size})`]: [...val.entries()].reduce(
        (entries2, [key, val2], i) => {
          entries2[stringifySymbol(key, i) + " =>"] = val2;
          return entries2;
        },
        {}
      )
    };
  } else if (isSet(val)) {
    return {
      [`Set(${val.size})`]: [...val.values()].map((v) => stringifySymbol(v))
    };
  } else if (isSymbol(val)) {
    return stringifySymbol(val);
  } else if (isObject(val) && !isArray(val) && !isPlainObject$1(val)) {
    return String(val);
  }
  return val;
};
const stringifySymbol = (v, i = "") => {
  var _a2;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    isSymbol(v) ? `Symbol(${(_a2 = v.description) != null ? _a2 : i})` : v
  );
};
function warn$2(msg, ...args) {
  console.warn(`[Vue warn] ${msg}`, ...args);
}
let activeEffectScope;
class EffectScope {
  // TODO isolatedDeclarations "__v_skip"
  constructor(detached = false) {
    this.detached = detached;
    this._active = true;
    this._on = 0;
    this.effects = [];
    this.cleanups = [];
    this._isPaused = false;
    this._warnOnRun = true;
    this.__v_skip = true;
    if (!detached && activeEffectScope) {
      if (activeEffectScope.active) {
        this.parent = activeEffectScope;
        this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(
          this
        ) - 1;
      } else {
        this._active = false;
        this._warnOnRun = false;
      }
    }
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = true;
      let i, l2;
      if (this.scopes) {
        const scopes = this.scopes.slice();
        for (i = 0, l2 = scopes.length; i < l2; i++) {
          scopes[i].pause();
        }
      }
      for (i = 0, l2 = this.effects.length; i < l2; i++) {
        this.effects[i].pause();
      }
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active) {
      if (this._isPaused) {
        this._isPaused = false;
        let i, l2;
        if (this.scopes) {
          const scopes = this.scopes.slice();
          for (i = 0, l2 = scopes.length; i < l2; i++) {
            scopes[i].resume();
          }
        }
        const effects = this.effects.slice();
        for (i = 0, l2 = effects.length; i < l2; i++) {
          effects[i].resume();
        }
      }
    }
  }
  run(fn3) {
    if (this._active) {
      const currentEffectScope = activeEffectScope;
      try {
        activeEffectScope = this;
        return fn3();
      } finally {
        activeEffectScope = currentEffectScope;
      }
    } else if (!!(process.env.NODE_ENV !== "production") && this._warnOnRun) {
      warn$2(`cannot run an inactive effect scope.`);
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    if (++this._on === 1) {
      this.prevScope = activeEffectScope;
      activeEffectScope = this;
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    if (this._on > 0 && --this._on === 0) {
      if (activeEffectScope === this) {
        activeEffectScope = this.prevScope;
      } else {
        let current = activeEffectScope;
        while (current) {
          if (current.prevScope === this) {
            current.prevScope = this.prevScope;
            break;
          }
          current = current.prevScope;
        }
      }
      this.prevScope = void 0;
    }
  }
  stop(fromParent) {
    if (this._active) {
      this._active = false;
      let i, l2;
      for (i = 0, l2 = this.effects.length; i < l2; i++) {
        this.effects[i].stop();
      }
      this.effects.length = 0;
      for (i = 0, l2 = this.cleanups.length; i < l2; i++) {
        this.cleanups[i]();
      }
      this.cleanups.length = 0;
      if (this.scopes) {
        const scopes = this.scopes.slice();
        for (i = 0, l2 = scopes.length; i < l2; i++) {
          scopes[i].stop(true);
        }
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !fromParent) {
        const last2 = this.parent.scopes.pop();
        if (last2 && last2 !== this) {
          this.parent.scopes[this.index] = last2;
          last2.index = this.index;
        }
      }
      this.parent = void 0;
    }
  }
}
function effectScope(detached) {
  return new EffectScope(detached);
}
function getCurrentScope() {
  return activeEffectScope;
}
function onScopeDispose(fn3, failSilently = false) {
  if (activeEffectScope) {
    activeEffectScope.cleanups.push(fn3);
  } else if (!!(process.env.NODE_ENV !== "production") && !failSilently) {
    warn$2(
      `onScopeDispose() is called when there is no active effect scope to be associated with.`
    );
  }
}
let activeSub;
const pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class ReactiveEffect {
  constructor(fn3) {
    this.fn = fn3;
    this.deps = void 0;
    this.depsTail = void 0;
    this.flags = 1 | 4;
    this.next = void 0;
    this.cleanup = void 0;
    this.scheduler = void 0;
    if (activeEffectScope) {
      if (activeEffectScope.active) {
        activeEffectScope.effects.push(this);
      } else {
        this.flags &= -2;
      }
    }
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    if (this.flags & 64) {
      this.flags &= -65;
      if (pausedQueueEffects.has(this)) {
        pausedQueueEffects.delete(this);
        this.trigger();
      }
    }
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags & 2 && !(this.flags & 32)) {
      return;
    }
    if (!(this.flags & 8)) {
      batch(this);
    }
  }
  run() {
    if (!(this.flags & 1)) {
      return this.fn();
    }
    this.flags |= 2;
    cleanupEffect(this);
    prepareDeps(this);
    const prevEffect = activeSub;
    const prevShouldTrack = shouldTrack;
    activeSub = this;
    shouldTrack = true;
    try {
      return this.fn();
    } finally {
      if (!!(process.env.NODE_ENV !== "production") && activeSub !== this) {
        warn$2(
          "Active effect was not restored correctly - this is likely a Vue internal bug."
        );
      }
      cleanupDeps(this);
      activeSub = prevEffect;
      shouldTrack = prevShouldTrack;
      this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let link = this.deps; link; link = link.nextDep) {
        removeSub(link);
      }
      this.deps = this.depsTail = void 0;
      cleanupEffect(this);
      this.onStop && this.onStop();
      this.flags &= -2;
    }
  }
  trigger() {
    if (this.flags & 64) {
      pausedQueueEffects.add(this);
    } else if (this.scheduler) {
      this.scheduler();
    } else {
      this.runIfDirty();
    }
  }
  /**
   * @internal
   */
  runIfDirty() {
    if (isDirty(this)) {
      this.run();
    }
  }
  get dirty() {
    return isDirty(this);
  }
}
let batchDepth = 0;
let batchedSub;
let batchedComputed;
function batch(sub, isComputed2 = false) {
  sub.flags |= 8;
  if (isComputed2) {
    sub.next = batchedComputed;
    batchedComputed = sub;
    return;
  }
  sub.next = batchedSub;
  batchedSub = sub;
}
function startBatch() {
  batchDepth++;
}
function endBatch() {
  if (--batchDepth > 0) {
    return;
  }
  if (batchedComputed) {
    let e = batchedComputed;
    batchedComputed = void 0;
    while (e) {
      const next2 = e.next;
      e.next = void 0;
      e.flags &= -9;
      e = next2;
    }
  }
  let error;
  while (batchedSub) {
    let e = batchedSub;
    batchedSub = void 0;
    while (e) {
      const next2 = e.next;
      e.next = void 0;
      e.flags &= -9;
      if (e.flags & 1) {
        try {
          ;
          e.trigger();
        } catch (err) {
          if (!error) error = err;
        }
      }
      e = next2;
    }
  }
  if (error) throw error;
}
function prepareDeps(sub) {
  for (let link = sub.deps; link; link = link.nextDep) {
    link.version = -1;
    link.prevActiveLink = link.dep.activeLink;
    link.dep.activeLink = link;
  }
}
function cleanupDeps(sub) {
  let head;
  let tail = sub.depsTail;
  let link = tail;
  while (link) {
    const prev2 = link.prevDep;
    if (link.version === -1) {
      if (link === tail) tail = prev2;
      removeSub(link);
      removeDep(link);
    } else {
      head = link;
    }
    link.dep.activeLink = link.prevActiveLink;
    link.prevActiveLink = void 0;
    link = prev2;
  }
  sub.deps = head;
  sub.depsTail = tail;
}
function isDirty(sub) {
  for (let link = sub.deps; link; link = link.nextDep) {
    if (link.dep.version !== link.version || link.dep.computed && (refreshComputed(link.dep.computed) || link.dep.version !== link.version)) {
      return true;
    }
  }
  if (sub._dirty) {
    return true;
  }
  return false;
}
function refreshComputed(computed2) {
  if (computed2.flags & 4 && !(computed2.flags & 16)) {
    return;
  }
  computed2.flags &= -17;
  if (computed2.globalVersion === globalVersion) {
    return;
  }
  computed2.globalVersion = globalVersion;
  if (!computed2.isSSR && computed2.flags & 128 && (!computed2.deps && !computed2._dirty || !isDirty(computed2))) {
    return;
  }
  computed2.flags |= 2;
  const dep = computed2.dep;
  const prevSub = activeSub;
  const prevShouldTrack = shouldTrack;
  activeSub = computed2;
  shouldTrack = true;
  try {
    prepareDeps(computed2);
    const value = computed2.fn(computed2._value);
    if (dep.version === 0 || hasChanged(value, computed2._value)) {
      computed2.flags |= 128;
      computed2._value = value;
      dep.version++;
    }
  } catch (err) {
    dep.version++;
    throw err;
  } finally {
    activeSub = prevSub;
    shouldTrack = prevShouldTrack;
    cleanupDeps(computed2);
    computed2.flags &= -3;
  }
}
function removeSub(link, soft = false) {
  const { dep, prevSub, nextSub } = link;
  if (prevSub) {
    prevSub.nextSub = nextSub;
    link.prevSub = void 0;
  }
  if (nextSub) {
    nextSub.prevSub = prevSub;
    link.nextSub = void 0;
  }
  if (!!(process.env.NODE_ENV !== "production") && dep.subsHead === link) {
    dep.subsHead = nextSub;
  }
  if (dep.subs === link) {
    dep.subs = prevSub;
    if (!prevSub && dep.computed) {
      dep.computed.flags &= -5;
      for (let l2 = dep.computed.deps; l2; l2 = l2.nextDep) {
        removeSub(l2, true);
      }
    }
  }
  if (!soft && !--dep.sc && dep.map) {
    dep.map.delete(dep.key);
  }
}
function removeDep(link) {
  const { prevDep, nextDep } = link;
  if (prevDep) {
    prevDep.nextDep = nextDep;
    link.prevDep = void 0;
  }
  if (nextDep) {
    nextDep.prevDep = prevDep;
    link.nextDep = void 0;
  }
}
let shouldTrack = true;
const trackStack = [];
function pauseTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = false;
}
function resetTracking() {
  const last2 = trackStack.pop();
  shouldTrack = last2 === void 0 ? true : last2;
}
function cleanupEffect(e) {
  const { cleanup: cleanup2 } = e;
  e.cleanup = void 0;
  if (cleanup2) {
    const prevSub = activeSub;
    activeSub = void 0;
    try {
      cleanup2();
    } finally {
      activeSub = prevSub;
    }
  }
}
let globalVersion = 0;
class Link2 {
  constructor(sub, dep) {
    this.sub = sub;
    this.dep = dep;
    this.version = dep.version;
    this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class Dep {
  // TODO isolatedDeclarations "__v_skip"
  constructor(computed2) {
    this.computed = computed2;
    this.version = 0;
    this.activeLink = void 0;
    this.subs = void 0;
    this.map = void 0;
    this.key = void 0;
    this.sc = 0;
    this.__v_skip = true;
    if (!!(process.env.NODE_ENV !== "production")) {
      this.subsHead = void 0;
    }
  }
  track(debugInfo) {
    if (!activeSub || !shouldTrack || activeSub === this.computed) {
      return;
    }
    let link = this.activeLink;
    if (link === void 0 || link.sub !== activeSub) {
      link = this.activeLink = new Link2(activeSub, this);
      if (!activeSub.deps) {
        activeSub.deps = activeSub.depsTail = link;
      } else {
        link.prevDep = activeSub.depsTail;
        activeSub.depsTail.nextDep = link;
        activeSub.depsTail = link;
      }
      addSub(link);
    } else if (link.version === -1) {
      link.version = this.version;
      if (link.nextDep) {
        const next2 = link.nextDep;
        next2.prevDep = link.prevDep;
        if (link.prevDep) {
          link.prevDep.nextDep = next2;
        }
        link.prevDep = activeSub.depsTail;
        link.nextDep = void 0;
        activeSub.depsTail.nextDep = link;
        activeSub.depsTail = link;
        if (activeSub.deps === link) {
          activeSub.deps = next2;
        }
      }
    }
    if (!!(process.env.NODE_ENV !== "production") && activeSub.onTrack) {
      activeSub.onTrack(
        extend(
          {
            effect: activeSub
          },
          debugInfo
        )
      );
    }
    return link;
  }
  trigger(debugInfo) {
    this.version++;
    globalVersion++;
    this.notify(debugInfo);
  }
  notify(debugInfo) {
    startBatch();
    try {
      if (!!(process.env.NODE_ENV !== "production")) {
        for (let head = this.subsHead; head; head = head.nextSub) {
          if (head.sub.onTrigger && !(head.sub.flags & 8)) {
            head.sub.onTrigger(
              extend(
                {
                  effect: head.sub
                },
                debugInfo
              )
            );
          }
        }
      }
      for (let link = this.subs; link; link = link.prevSub) {
        if (link.sub.notify()) {
          ;
          link.sub.dep.notify();
        }
      }
    } finally {
      endBatch();
    }
  }
}
function addSub(link) {
  link.dep.sc++;
  if (link.sub.flags & 4) {
    const computed2 = link.dep.computed;
    if (computed2 && !link.dep.subs) {
      computed2.flags |= 4 | 16;
      for (let l2 = computed2.deps; l2; l2 = l2.nextDep) {
        addSub(l2);
      }
    }
    const currentTail = link.dep.subs;
    if (currentTail !== link) {
      link.prevSub = currentTail;
      if (currentTail) currentTail.nextSub = link;
    }
    if (!!(process.env.NODE_ENV !== "production") && link.dep.subsHead === void 0) {
      link.dep.subsHead = link;
    }
    link.dep.subs = link;
  }
}
const targetMap = /* @__PURE__ */ new WeakMap();
const ITERATE_KEY = /* @__PURE__ */ Symbol(
  !!(process.env.NODE_ENV !== "production") ? "Object iterate" : ""
);
const MAP_KEY_ITERATE_KEY = /* @__PURE__ */ Symbol(
  !!(process.env.NODE_ENV !== "production") ? "Map keys iterate" : ""
);
const ARRAY_ITERATE_KEY = /* @__PURE__ */ Symbol(
  !!(process.env.NODE_ENV !== "production") ? "Array iterate" : ""
);
function track(target, type, key) {
  if (shouldTrack && activeSub) {
    let depsMap = targetMap.get(target);
    if (!depsMap) {
      targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    }
    let dep = depsMap.get(key);
    if (!dep) {
      depsMap.set(key, dep = new Dep());
      dep.map = depsMap;
      dep.key = key;
    }
    if (!!(process.env.NODE_ENV !== "production")) {
      dep.track({
        target,
        type,
        key
      });
    } else {
      dep.track();
    }
  }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
  const depsMap = targetMap.get(target);
  if (!depsMap) {
    globalVersion++;
    return;
  }
  const run = (dep) => {
    if (dep) {
      if (!!(process.env.NODE_ENV !== "production")) {
        dep.trigger({
          target,
          type,
          key,
          newValue,
          oldValue,
          oldTarget
        });
      } else {
        dep.trigger();
      }
    }
  };
  startBatch();
  if (type === "clear") {
    depsMap.forEach(run);
  } else {
    const targetIsArray = isArray(target);
    const isArrayIndex = targetIsArray && isIntegerKey(key);
    if (targetIsArray && key === "length") {
      const newLength = Number(newValue);
      depsMap.forEach((dep, key2) => {
        if (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !isSymbol(key2) && key2 >= newLength) {
          run(dep);
        }
      });
    } else {
      if (key !== void 0 || depsMap.has(void 0)) {
        run(depsMap.get(key));
      }
      if (isArrayIndex) {
        run(depsMap.get(ARRAY_ITERATE_KEY));
      }
      switch (type) {
        case "add":
          if (!targetIsArray) {
            run(depsMap.get(ITERATE_KEY));
            if (isMap(target)) {
              run(depsMap.get(MAP_KEY_ITERATE_KEY));
            }
          } else if (isArrayIndex) {
            run(depsMap.get("length"));
          }
          break;
        case "delete":
          if (!targetIsArray) {
            run(depsMap.get(ITERATE_KEY));
            if (isMap(target)) {
              run(depsMap.get(MAP_KEY_ITERATE_KEY));
            }
          }
          break;
        case "set":
          if (isMap(target)) {
            run(depsMap.get(ITERATE_KEY));
          }
          break;
      }
    }
  }
  endBatch();
}
function getDepFromReactive(object, key) {
  const depMap = targetMap.get(object);
  return depMap && depMap.get(key);
}
function reactiveReadArray(array) {
  const raw = /* @__PURE__ */ toRaw(array);
  if (raw === array) return raw;
  track(raw, "iterate", ARRAY_ITERATE_KEY);
  if (/* @__PURE__ */ isShallow(array)) return raw;
  if (!/* @__PURE__ */ isReadonly(array)) return raw.map(toReactive);
  return /* @__PURE__ */ isReactive(array) ? raw.map((item) => toReadonly(toReactive(item))) : raw.map(toReadonly);
}
function shallowReadArray(arr) {
  track(arr = /* @__PURE__ */ toRaw(arr), "iterate", ARRAY_ITERATE_KEY);
  return arr;
}
function toWrapped(target, item) {
  if (/* @__PURE__ */ isReadonly(target)) {
    return /* @__PURE__ */ isReactive(target) ? toReadonly(toReactive(item)) : toReadonly(item);
  }
  return toReactive(item);
}
const arrayInstrumentations = {
  __proto__: null,
  [Symbol.iterator]() {
    return iterator(this, Symbol.iterator, (item) => toWrapped(this, item));
  },
  concat(...args) {
    return reactiveReadArray(this).concat(
      ...args.map((x) => isArray(x) ? reactiveReadArray(x) : x)
    );
  },
  entries() {
    return iterator(this, "entries", (value) => {
      value[1] = toWrapped(this, value[1]);
      return value;
    });
  },
  every(fn3, thisArg) {
    return apply(this, "every", fn3, thisArg, void 0, arguments);
  },
  filter(fn3, thisArg) {
    return apply(
      this,
      "filter",
      fn3,
      thisArg,
      (v) => v.map((item) => toWrapped(this, item)),
      arguments
    );
  },
  find(fn3, thisArg) {
    return apply(
      this,
      "find",
      fn3,
      thisArg,
      (item) => toWrapped(this, item),
      arguments
    );
  },
  findIndex(fn3, thisArg) {
    return apply(this, "findIndex", fn3, thisArg, void 0, arguments);
  },
  findLast(fn3, thisArg) {
    return apply(
      this,
      "findLast",
      fn3,
      thisArg,
      (item) => toWrapped(this, item),
      arguments
    );
  },
  findLastIndex(fn3, thisArg) {
    return apply(this, "findLastIndex", fn3, thisArg, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(fn3, thisArg) {
    return apply(this, "forEach", fn3, thisArg, void 0, arguments);
  },
  includes(...args) {
    return searchProxy(this, "includes", args);
  },
  indexOf(...args) {
    return searchProxy(this, "indexOf", args);
  },
  join(separator) {
    return reactiveReadArray(this).join(separator);
  },
  // keys() iterator only reads `length`, no optimization required
  lastIndexOf(...args) {
    return searchProxy(this, "lastIndexOf", args);
  },
  map(fn3, thisArg) {
    return apply(this, "map", fn3, thisArg, void 0, arguments);
  },
  pop() {
    return noTracking(this, "pop");
  },
  push(...args) {
    return noTracking(this, "push", args);
  },
  reduce(fn3, ...args) {
    return reduce(this, "reduce", fn3, args);
  },
  reduceRight(fn3, ...args) {
    return reduce(this, "reduceRight", fn3, args);
  },
  shift() {
    return noTracking(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(fn3, thisArg) {
    return apply(this, "some", fn3, thisArg, void 0, arguments);
  },
  splice(...args) {
    return noTracking(this, "splice", args);
  },
  toReversed() {
    return reactiveReadArray(this).toReversed();
  },
  toSorted(comparer) {
    return reactiveReadArray(this).toSorted(comparer);
  },
  toSpliced(...args) {
    return reactiveReadArray(this).toSpliced(...args);
  },
  unshift(...args) {
    return noTracking(this, "unshift", args);
  },
  values() {
    return iterator(this, "values", (item) => toWrapped(this, item));
  }
};
function iterator(self2, method, wrapValue) {
  const arr = shallowReadArray(self2);
  const iter = arr[method]();
  if (arr !== self2 && !/* @__PURE__ */ isShallow(self2)) {
    iter._next = iter.next;
    iter.next = () => {
      const result = iter._next();
      if (!result.done) {
        result.value = wrapValue(result.value);
      }
      return result;
    };
  }
  return iter;
}
const arrayProto = Array.prototype;
function apply(self2, method, fn3, thisArg, wrappedRetFn, args) {
  const arr = shallowReadArray(self2);
  const needsWrap = arr !== self2 && !/* @__PURE__ */ isShallow(self2);
  const methodFn = arr[method];
  if (methodFn !== arrayProto[method]) {
    const result2 = methodFn.apply(self2, args);
    return needsWrap ? toReactive(result2) : result2;
  }
  let wrappedFn = fn3;
  if (arr !== self2) {
    if (needsWrap) {
      wrappedFn = function(item, index2) {
        return fn3.call(this, toWrapped(self2, item), index2, self2);
      };
    } else if (fn3.length > 2) {
      wrappedFn = function(item, index2) {
        return fn3.call(this, item, index2, self2);
      };
    }
  }
  const result = methodFn.call(arr, wrappedFn, thisArg);
  return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function reduce(self2, method, fn3, args) {
  const arr = shallowReadArray(self2);
  const needsWrap = arr !== self2 && !/* @__PURE__ */ isShallow(self2);
  let wrappedFn = fn3;
  let wrapInitialAccumulator = false;
  if (arr !== self2) {
    if (needsWrap) {
      wrapInitialAccumulator = args.length === 0;
      wrappedFn = function(acc, item, index2) {
        if (wrapInitialAccumulator) {
          wrapInitialAccumulator = false;
          acc = toWrapped(self2, acc);
        }
        return fn3.call(this, acc, toWrapped(self2, item), index2, self2);
      };
    } else if (fn3.length > 3) {
      wrappedFn = function(acc, item, index2) {
        return fn3.call(this, acc, item, index2, self2);
      };
    }
  }
  const result = arr[method](wrappedFn, ...args);
  return wrapInitialAccumulator ? toWrapped(self2, result) : result;
}
function searchProxy(self2, method, args) {
  const arr = /* @__PURE__ */ toRaw(self2);
  track(arr, "iterate", ARRAY_ITERATE_KEY);
  const res = arr[method](...args);
  if ((res === -1 || res === false) && /* @__PURE__ */ isProxy(args[0])) {
    args[0] = /* @__PURE__ */ toRaw(args[0]);
    return arr[method](...args);
  }
  return res;
}
function noTracking(self2, method, args = []) {
  pauseTracking();
  startBatch();
  const res = (/* @__PURE__ */ toRaw(self2))[method].apply(self2, args);
  endBatch();
  resetTracking();
  return res;
}
const isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
const builtInSymbols = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key) => key !== "arguments" && key !== "caller").map((key) => Symbol[key]).filter(isSymbol)
);
function hasOwnProperty(key) {
  if (!isSymbol(key)) key = String(key);
  const obj = /* @__PURE__ */ toRaw(this);
  track(obj, "has", key);
  return obj.hasOwnProperty(key);
}
class BaseReactiveHandler {
  constructor(_isReadonly = false, _isShallow = false) {
    this._isReadonly = _isReadonly;
    this._isShallow = _isShallow;
  }
  get(target, key, receiver) {
    if (key === "__v_skip") return target["__v_skip"];
    const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
    if (key === "__v_isReactive") {
      return !isReadonly2;
    } else if (key === "__v_isReadonly") {
      return isReadonly2;
    } else if (key === "__v_isShallow") {
      return isShallow2;
    } else if (key === "__v_raw") {
      if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) {
        return target;
      }
      return;
    }
    const targetIsArray = isArray(target);
    if (!isReadonly2) {
      let fn3;
      if (targetIsArray && (fn3 = arrayInstrumentations[key])) {
        return fn3;
      }
      if (key === "hasOwnProperty") {
        return hasOwnProperty;
      }
    }
    const res = Reflect.get(
      target,
      key,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      /* @__PURE__ */ isRef(target) ? target : receiver
    );
    if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
      return res;
    }
    if (!isReadonly2) {
      track(target, "get", key);
    }
    if (isShallow2) {
      return res;
    }
    if (/* @__PURE__ */ isRef(res)) {
      const value = targetIsArray && isIntegerKey(key) ? res : res.value;
      return isReadonly2 && isObject(value) ? /* @__PURE__ */ readonly(value) : value;
    }
    if (isObject(res)) {
      return isReadonly2 ? /* @__PURE__ */ readonly(res) : /* @__PURE__ */ reactive(res);
    }
    return res;
  }
}
class MutableReactiveHandler extends BaseReactiveHandler {
  constructor(isShallow2 = false) {
    super(false, isShallow2);
  }
  set(target, key, value, receiver) {
    let oldValue = target[key];
    const isArrayWithIntegerKey = isArray(target) && isIntegerKey(key);
    if (!this._isShallow) {
      const isOldValueReadonly = /* @__PURE__ */ isReadonly(oldValue);
      if (!/* @__PURE__ */ isShallow(value) && !/* @__PURE__ */ isReadonly(value)) {
        oldValue = /* @__PURE__ */ toRaw(oldValue);
        value = /* @__PURE__ */ toRaw(value);
      }
      if (!isArrayWithIntegerKey && /* @__PURE__ */ isRef(oldValue) && !/* @__PURE__ */ isRef(value)) {
        if (isOldValueReadonly) {
          if (!!(process.env.NODE_ENV !== "production")) {
            warn$2(
              `Set operation on key "${String(key)}" failed: target is readonly.`,
              target[key]
            );
          }
          return true;
        } else {
          oldValue.value = value;
          return true;
        }
      }
    }
    const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : hasOwn(target, key);
    const result = Reflect.set(
      target,
      key,
      value,
      /* @__PURE__ */ isRef(target) ? target : receiver
    );
    if (target === /* @__PURE__ */ toRaw(receiver) && result) {
      if (!hadKey) {
        trigger(target, "add", key, value);
      } else if (hasChanged(value, oldValue)) {
        trigger(target, "set", key, value, oldValue);
      }
    }
    return result;
  }
  deleteProperty(target, key) {
    const hadKey = hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) {
      trigger(target, "delete", key, void 0, oldValue);
    }
    return result;
  }
  has(target, key) {
    const result = Reflect.has(target, key);
    if (!isSymbol(key) || !builtInSymbols.has(key)) {
      track(target, "has", key);
    }
    return result;
  }
  ownKeys(target) {
    track(
      target,
      "iterate",
      isArray(target) ? "length" : ITERATE_KEY
    );
    return Reflect.ownKeys(target);
  }
}
class ReadonlyReactiveHandler extends BaseReactiveHandler {
  constructor(isShallow2 = false) {
    super(true, isShallow2);
  }
  set(target, key) {
    if (!!(process.env.NODE_ENV !== "production")) {
      warn$2(
        `Set operation on key "${String(key)}" failed: target is readonly.`,
        target
      );
    }
    return true;
  }
  deleteProperty(target, key) {
    if (!!(process.env.NODE_ENV !== "production")) {
      warn$2(
        `Delete operation on key "${String(key)}" failed: target is readonly.`,
        target
      );
    }
    return true;
  }
}
const mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
const readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
const shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
const toShallow = (value) => value;
const getProto = (v) => Reflect.getPrototypeOf(v);
function createIterableMethod(method, isReadonly2, isShallow2) {
  return function(...args) {
    const target = this["__v_raw"];
    const rawTarget = /* @__PURE__ */ toRaw(target);
    const targetIsMap = isMap(rawTarget);
    const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
    const isKeyOnly = method === "keys" && targetIsMap;
    const innerIterator = target[method](...args);
    const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
    !isReadonly2 && track(
      rawTarget,
      "iterate",
      isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY
    );
    return extend(
      // inheriting all iterator properties
      Object.create(innerIterator),
      {
        // iterator protocol
        next() {
          const { value, done } = innerIterator.next();
          return done ? { value, done } : {
            value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
            done
          };
        }
      }
    );
  };
}
function createReadonlyMethod(type) {
  return function(...args) {
    if (!!(process.env.NODE_ENV !== "production")) {
      const key = args[0] ? `on key "${args[0]}" ` : ``;
      warn$2(
        `${capitalize(type)} operation ${key}failed: target is readonly.`,
        /* @__PURE__ */ toRaw(this)
      );
    }
    return type === "delete" ? false : type === "clear" ? void 0 : this;
  };
}
function createInstrumentations(readonly2, shallow) {
  const instrumentations = {
    get(key) {
      const target = this["__v_raw"];
      const rawTarget = /* @__PURE__ */ toRaw(target);
      const rawKey = /* @__PURE__ */ toRaw(key);
      if (!readonly2) {
        if (hasChanged(key, rawKey)) {
          track(rawTarget, "get", key);
        }
        track(rawTarget, "get", rawKey);
      }
      const { has: has2 } = getProto(rawTarget);
      const wrap = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
      if (has2.call(rawTarget, key)) {
        return wrap(target.get(key));
      } else if (has2.call(rawTarget, rawKey)) {
        return wrap(target.get(rawKey));
      } else if (target !== rawTarget) {
        target.get(key);
      }
    },
    get size() {
      const target = this["__v_raw"];
      !readonly2 && track(/* @__PURE__ */ toRaw(target), "iterate", ITERATE_KEY);
      return target.size;
    },
    has(key) {
      const target = this["__v_raw"];
      const rawTarget = /* @__PURE__ */ toRaw(target);
      const rawKey = /* @__PURE__ */ toRaw(key);
      if (!readonly2) {
        if (hasChanged(key, rawKey)) {
          track(rawTarget, "has", key);
        }
        track(rawTarget, "has", rawKey);
      }
      return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
    },
    forEach(callback, thisArg) {
      const observed = this;
      const target = observed["__v_raw"];
      const rawTarget = /* @__PURE__ */ toRaw(target);
      const wrap = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
      !readonly2 && track(rawTarget, "iterate", ITERATE_KEY);
      return target.forEach((value, key) => {
        return callback.call(thisArg, wrap(value), wrap(key), observed);
      });
    }
  };
  extend(
    instrumentations,
    readonly2 ? {
      add: createReadonlyMethod("add"),
      set: createReadonlyMethod("set"),
      delete: createReadonlyMethod("delete"),
      clear: createReadonlyMethod("clear")
    } : {
      add(value) {
        const target = /* @__PURE__ */ toRaw(this);
        const proto = getProto(target);
        const rawValue = /* @__PURE__ */ toRaw(value);
        const valueToAdd = !shallow && !/* @__PURE__ */ isShallow(value) && !/* @__PURE__ */ isReadonly(value) ? rawValue : value;
        const hadKey = proto.has.call(target, valueToAdd) || hasChanged(value, valueToAdd) && proto.has.call(target, value) || hasChanged(rawValue, valueToAdd) && proto.has.call(target, rawValue);
        if (!hadKey) {
          target.add(valueToAdd);
          trigger(target, "add", valueToAdd, valueToAdd);
        }
        return this;
      },
      set(key, value) {
        if (!shallow && !/* @__PURE__ */ isShallow(value) && !/* @__PURE__ */ isReadonly(value)) {
          value = /* @__PURE__ */ toRaw(value);
        }
        const target = /* @__PURE__ */ toRaw(this);
        const { has: has2, get: get2 } = getProto(target);
        let hadKey = has2.call(target, key);
        if (!hadKey) {
          key = /* @__PURE__ */ toRaw(key);
          hadKey = has2.call(target, key);
        } else if (!!(process.env.NODE_ENV !== "production")) {
          checkIdentityKeys(target, has2, key);
        }
        const oldValue = get2.call(target, key);
        target.set(key, value);
        if (!hadKey) {
          trigger(target, "add", key, value);
        } else if (hasChanged(value, oldValue)) {
          trigger(target, "set", key, value, oldValue);
        }
        return this;
      },
      delete(key) {
        const target = /* @__PURE__ */ toRaw(this);
        const { has: has2, get: get2 } = getProto(target);
        let hadKey = has2.call(target, key);
        if (!hadKey) {
          key = /* @__PURE__ */ toRaw(key);
          hadKey = has2.call(target, key);
        } else if (!!(process.env.NODE_ENV !== "production")) {
          checkIdentityKeys(target, has2, key);
        }
        const oldValue = get2 ? get2.call(target, key) : void 0;
        const result = target.delete(key);
        if (hadKey) {
          trigger(target, "delete", key, void 0, oldValue);
        }
        return result;
      },
      clear() {
        const target = /* @__PURE__ */ toRaw(this);
        const hadItems = target.size !== 0;
        const oldTarget = !!(process.env.NODE_ENV !== "production") ? isMap(target) ? new Map(target) : new Set(target) : void 0;
        const result = target.clear();
        if (hadItems) {
          trigger(
            target,
            "clear",
            void 0,
            void 0,
            oldTarget
          );
        }
        return result;
      }
    }
  );
  const iteratorMethods = [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ];
  iteratorMethods.forEach((method) => {
    instrumentations[method] = createIterableMethod(method, readonly2, shallow);
  });
  return instrumentations;
}
function createInstrumentationGetter(isReadonly2, shallow) {
  const instrumentations = createInstrumentations(isReadonly2, shallow);
  return (target, key, receiver) => {
    if (key === "__v_isReactive") {
      return !isReadonly2;
    } else if (key === "__v_isReadonly") {
      return isReadonly2;
    } else if (key === "__v_raw") {
      return target;
    }
    return Reflect.get(
      hasOwn(instrumentations, key) && key in target ? instrumentations : target,
      key,
      receiver
    );
  };
}
const mutableCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
const readonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
const shallowReadonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(true, true)
};
function checkIdentityKeys(target, has2, key) {
  const rawKey = /* @__PURE__ */ toRaw(key);
  if (rawKey !== key && has2.call(target, rawKey)) {
    const type = toRawType(target);
    warn$2(
      `Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const reactiveMap = /* @__PURE__ */ new WeakMap();
const shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const readonlyMap = /* @__PURE__ */ new WeakMap();
const shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
  switch (rawType) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
// @__NO_SIDE_EFFECTS__
function reactive(target) {
  if (/* @__PURE__ */ isReadonly(target)) {
    return target;
  }
  return createReactiveObject(
    target,
    false,
    mutableHandlers,
    mutableCollectionHandlers,
    reactiveMap
  );
}
// @__NO_SIDE_EFFECTS__
function readonly(target) {
  return createReactiveObject(
    target,
    true,
    readonlyHandlers,
    readonlyCollectionHandlers,
    readonlyMap
  );
}
// @__NO_SIDE_EFFECTS__
function shallowReadonly(target) {
  return createReactiveObject(
    target,
    true,
    shallowReadonlyHandlers,
    shallowReadonlyCollectionHandlers,
    shallowReadonlyMap
  );
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
  if (!isObject(target)) {
    if (!!(process.env.NODE_ENV !== "production")) {
      warn$2(
        `value cannot be made ${isReadonly2 ? "readonly" : "reactive"}: ${String(
          target
        )}`
      );
    }
    return target;
  }
  if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) {
    return target;
  }
  if (target["__v_skip"] || !Object.isExtensible(target)) {
    return target;
  }
  const existingProxy = proxyMap.get(target);
  if (existingProxy) {
    return existingProxy;
  }
  const targetType = targetTypeMap(toRawType(target));
  if (targetType === 0) {
    return target;
  }
  const proxy = new Proxy(
    target,
    targetType === 2 ? collectionHandlers : baseHandlers
  );
  proxyMap.set(target, proxy);
  return proxy;
}
// @__NO_SIDE_EFFECTS__
function isReactive(value) {
  if (/* @__PURE__ */ isReadonly(value)) {
    return /* @__PURE__ */ isReactive(value["__v_raw"]);
  }
  return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function isReadonly(value) {
  return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function isShallow(value) {
  return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function isProxy(value) {
  return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function toRaw(observed) {
  const raw = observed && observed["__v_raw"];
  return raw ? /* @__PURE__ */ toRaw(raw) : observed;
}
function markRaw(value) {
  if (!hasOwn(value, "__v_skip") && Object.isExtensible(value)) {
    def(value, "__v_skip", true);
  }
  return value;
}
const toReactive = (value) => isObject(value) ? /* @__PURE__ */ reactive(value) : value;
const toReadonly = (value) => isObject(value) ? /* @__PURE__ */ readonly(value) : value;
// @__NO_SIDE_EFFECTS__
function isRef(r12) {
  return r12 ? r12["__v_isRef"] === true : false;
}
// @__NO_SIDE_EFFECTS__
function ref(value) {
  return createRef(value, false);
}
// @__NO_SIDE_EFFECTS__
function shallowRef(value) {
  return createRef(value, true);
}
function createRef(rawValue, shallow) {
  if (/* @__PURE__ */ isRef(rawValue)) {
    return rawValue;
  }
  return new RefImpl(rawValue, shallow);
}
class RefImpl {
  constructor(value, isShallow2) {
    this.dep = new Dep();
    this["__v_isRef"] = true;
    this["__v_isShallow"] = false;
    this._rawValue = isShallow2 ? value : /* @__PURE__ */ toRaw(value);
    this._value = isShallow2 ? value : toReactive(value);
    this["__v_isShallow"] = isShallow2;
  }
  get value() {
    if (!!(process.env.NODE_ENV !== "production")) {
      this.dep.track({
        target: this,
        type: "get",
        key: "value"
      });
    } else {
      this.dep.track();
    }
    return this._value;
  }
  set value(newValue) {
    const oldValue = this._rawValue;
    const useDirectValue = this["__v_isShallow"] || /* @__PURE__ */ isShallow(newValue) || /* @__PURE__ */ isReadonly(newValue);
    newValue = useDirectValue ? newValue : /* @__PURE__ */ toRaw(newValue);
    if (hasChanged(newValue, oldValue)) {
      this._rawValue = newValue;
      this._value = useDirectValue ? newValue : toReactive(newValue);
      if (!!(process.env.NODE_ENV !== "production")) {
        this.dep.trigger({
          target: this,
          type: "set",
          key: "value",
          newValue,
          oldValue
        });
      } else {
        this.dep.trigger();
      }
    }
  }
}
function unref(ref2) {
  return /* @__PURE__ */ isRef(ref2) ? ref2.value : ref2;
}
const shallowUnwrapHandlers = {
  get: (target, key, receiver) => key === "__v_raw" ? target : unref(Reflect.get(target, key, receiver)),
  set: (target, key, value, receiver) => {
    const oldValue = target[key];
    if (/* @__PURE__ */ isRef(oldValue) && !/* @__PURE__ */ isRef(value)) {
      oldValue.value = value;
      return true;
    } else {
      return Reflect.set(target, key, value, receiver);
    }
  }
};
function proxyRefs(objectWithRefs) {
  return /* @__PURE__ */ isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
// @__NO_SIDE_EFFECTS__
function toRefs(object) {
  if (!!(process.env.NODE_ENV !== "production") && !/* @__PURE__ */ isProxy(object)) {
    warn$2(`toRefs() expects a reactive object but received a plain one.`);
  }
  const ret = isArray(object) ? new Array(object.length) : {};
  for (const key in object) {
    ret[key] = propertyToRef(object, key);
  }
  return ret;
}
class ObjectRefImpl {
  constructor(_object, key, _defaultValue) {
    this._object = _object;
    this._defaultValue = _defaultValue;
    this["__v_isRef"] = true;
    this._value = void 0;
    this._key = isSymbol(key) ? key : String(key);
    this._raw = /* @__PURE__ */ toRaw(_object);
    let shallow = true;
    let obj = _object;
    if (!isArray(_object) || isSymbol(this._key) || !isIntegerKey(this._key)) {
      do {
        shallow = !/* @__PURE__ */ isProxy(obj) || /* @__PURE__ */ isShallow(obj);
      } while (shallow && (obj = obj["__v_raw"]));
    }
    this._shallow = shallow;
  }
  get value() {
    let val = this._object[this._key];
    if (this._shallow) {
      val = unref(val);
    }
    return this._value = val === void 0 ? this._defaultValue : val;
  }
  set value(newVal) {
    if (this._shallow && /* @__PURE__ */ isRef(this._raw[this._key])) {
      const nestedRef = this._object[this._key];
      if (/* @__PURE__ */ isRef(nestedRef)) {
        nestedRef.value = newVal;
        return;
      }
    }
    this._object[this._key] = newVal;
  }
  get dep() {
    return getDepFromReactive(this._raw, this._key);
  }
}
class GetterRefImpl {
  constructor(_getter) {
    this._getter = _getter;
    this["__v_isRef"] = true;
    this["__v_isReadonly"] = true;
    this._value = void 0;
  }
  get value() {
    return this._value = this._getter();
  }
}
// @__NO_SIDE_EFFECTS__
function toRef(source, key, defaultValue) {
  if (/* @__PURE__ */ isRef(source)) {
    return source;
  } else if (isFunction(source)) {
    return new GetterRefImpl(source);
  } else if (isObject(source) && arguments.length > 1) {
    return propertyToRef(source, key, defaultValue);
  } else {
    return /* @__PURE__ */ ref(source);
  }
}
function propertyToRef(source, key, defaultValue) {
  return new ObjectRefImpl(source, key, defaultValue);
}
class ComputedRefImpl {
  constructor(fn3, setter, isSSR2) {
    this.fn = fn3;
    this.setter = setter;
    this._value = void 0;
    this.dep = new Dep(this);
    this.__v_isRef = true;
    this.deps = void 0;
    this.depsTail = void 0;
    this.flags = 16;
    this.globalVersion = globalVersion - 1;
    this.next = void 0;
    this.effect = this;
    this["__v_isReadonly"] = !setter;
    this.isSSR = isSSR2;
  }
  /**
   * @internal
   */
  notify() {
    this.flags |= 16;
    if (!(this.flags & 8) && // avoid infinite self recursion
    activeSub !== this) {
      batch(this, true);
      return true;
    } else if (!!(process.env.NODE_ENV !== "production")) ;
  }
  get value() {
    const link = !!(process.env.NODE_ENV !== "production") ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    refreshComputed(this);
    if (link) {
      link.version = this.dep.version;
    }
    return this._value;
  }
  set value(newValue) {
    if (this.setter) {
      this.setter(newValue);
    } else if (!!(process.env.NODE_ENV !== "production")) {
      warn$2("Write operation failed: computed value is readonly");
    }
  }
}
// @__NO_SIDE_EFFECTS__
function computed$1(getterOrOptions, debugOptions, isSSR2 = false) {
  let getter;
  let setter;
  if (isFunction(getterOrOptions)) {
    getter = getterOrOptions;
  } else {
    getter = getterOrOptions.get;
    setter = getterOrOptions.set;
  }
  const cRef = new ComputedRefImpl(getter, setter, isSSR2);
  if (!!(process.env.NODE_ENV !== "production") && debugOptions) ;
  return cRef;
}
const INITIAL_WATCHER_VALUE = {};
const cleanupMap = /* @__PURE__ */ new WeakMap();
let activeWatcher = void 0;
function onWatcherCleanup(cleanupFn, failSilently = false, owner = activeWatcher) {
  if (owner) {
    let cleanups = cleanupMap.get(owner);
    if (!cleanups) cleanupMap.set(owner, cleanups = []);
    cleanups.push(cleanupFn);
  } else if (!!(process.env.NODE_ENV !== "production") && !failSilently) {
    warn$2(
      `onWatcherCleanup() was called when there was no active watcher to associate with.`
    );
  }
}
function watch$1(source, cb2, options = EMPTY_OBJ) {
  const { immediate, deep, once, scheduler, augmentJob, call } = options;
  const warnInvalidSource = (s12) => {
    (options.onWarn || warn$2)(
      `Invalid watch source: `,
      s12,
      `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`
    );
  };
  const reactiveGetter = (source2) => {
    if (deep) return source2;
    if (/* @__PURE__ */ isShallow(source2) || deep === false || deep === 0)
      return traverse(source2, 1);
    return traverse(source2);
  };
  let effect2;
  let getter;
  let cleanup2;
  let boundCleanup;
  let forceTrigger = false;
  let isMultiSource = false;
  if (/* @__PURE__ */ isRef(source)) {
    getter = () => source.value;
    forceTrigger = /* @__PURE__ */ isShallow(source);
  } else if (/* @__PURE__ */ isReactive(source)) {
    getter = () => reactiveGetter(source);
    forceTrigger = true;
  } else if (isArray(source)) {
    isMultiSource = true;
    forceTrigger = source.some((s12) => /* @__PURE__ */ isReactive(s12) || /* @__PURE__ */ isShallow(s12));
    getter = () => source.map((s12) => {
      if (/* @__PURE__ */ isRef(s12)) {
        return s12.value;
      } else if (/* @__PURE__ */ isReactive(s12)) {
        return reactiveGetter(s12);
      } else if (isFunction(s12)) {
        return call ? call(s12, 2) : s12();
      } else {
        !!(process.env.NODE_ENV !== "production") && warnInvalidSource(s12);
      }
    });
  } else if (isFunction(source)) {
    if (cb2) {
      getter = call ? () => call(source, 2) : source;
    } else {
      getter = () => {
        if (cleanup2) {
          pauseTracking();
          try {
            cleanup2();
          } finally {
            resetTracking();
          }
        }
        const currentEffect = activeWatcher;
        activeWatcher = effect2;
        try {
          return call ? call(source, 3, [boundCleanup]) : source(boundCleanup);
        } finally {
          activeWatcher = currentEffect;
        }
      };
    }
  } else {
    getter = NOOP;
    !!(process.env.NODE_ENV !== "production") && warnInvalidSource(source);
  }
  if (cb2 && deep) {
    const baseGetter = getter;
    const depth = deep === true ? Infinity : deep;
    getter = () => traverse(baseGetter(), depth);
  }
  const scope = getCurrentScope();
  const watchHandle = () => {
    effect2.stop();
    if (scope && scope.active) {
      remove(scope.effects, effect2);
    }
  };
  if (once && cb2) {
    const _cb = cb2;
    cb2 = (...args) => {
      const res = _cb(...args);
      watchHandle();
      return res;
    };
  }
  let oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
  const job = (immediateFirstRun) => {
    if (!(effect2.flags & 1) || !effect2.dirty && !immediateFirstRun) {
      return;
    }
    if (cb2) {
      const newValue = effect2.run();
      if (immediateFirstRun || deep || forceTrigger || (isMultiSource ? newValue.some((v, i) => hasChanged(v, oldValue[i])) : hasChanged(newValue, oldValue))) {
        if (cleanup2) {
          cleanup2();
        }
        const currentWatcher = activeWatcher;
        activeWatcher = effect2;
        try {
          const args = [
            newValue,
            // pass undefined as the old value when it's changed for the first time
            oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
            boundCleanup
          ];
          oldValue = newValue;
          call ? call(cb2, 3, args) : (
            // @ts-expect-error
            cb2(...args)
          );
        } finally {
          activeWatcher = currentWatcher;
        }
      }
    } else {
      effect2.run();
    }
  };
  if (augmentJob) {
    augmentJob(job);
  }
  effect2 = new ReactiveEffect(getter);
  effect2.scheduler = scheduler ? () => scheduler(job, false) : job;
  boundCleanup = (fn3) => onWatcherCleanup(fn3, false, effect2);
  cleanup2 = effect2.onStop = () => {
    const cleanups = cleanupMap.get(effect2);
    if (cleanups) {
      if (call) {
        call(cleanups, 4);
      } else {
        for (const cleanup22 of cleanups) cleanup22();
      }
      cleanupMap.delete(effect2);
    }
  };
  if (!!(process.env.NODE_ENV !== "production")) {
    effect2.onTrack = options.onTrack;
    effect2.onTrigger = options.onTrigger;
  }
  if (cb2) {
    if (immediate) {
      job(true);
    } else {
      oldValue = effect2.run();
    }
  } else if (scheduler) {
    scheduler(job.bind(null, true), true);
  } else {
    effect2.run();
  }
  watchHandle.pause = effect2.pause.bind(effect2);
  watchHandle.resume = effect2.resume.bind(effect2);
  watchHandle.stop = watchHandle;
  return watchHandle;
}
function traverse(value, depth = Infinity, seen) {
  if (depth <= 0 || !isObject(value) || value["__v_skip"]) {
    return value;
  }
  seen = seen || /* @__PURE__ */ new Map();
  if ((seen.get(value) || 0) >= depth) {
    return value;
  }
  seen.set(value, depth);
  depth--;
  if (/* @__PURE__ */ isRef(value)) {
    traverse(value.value, depth, seen);
  } else if (isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      traverse(value[i], depth, seen);
    }
  } else if (isSet(value) || isMap(value)) {
    value.forEach((v) => {
      traverse(v, depth, seen);
    });
  } else if (isPlainObject$1(value)) {
    for (const key in value) {
      traverse(value[key], depth, seen);
    }
    for (const key of Object.getOwnPropertySymbols(value)) {
      if (Object.prototype.propertyIsEnumerable.call(value, key)) {
        traverse(value[key], depth, seen);
      }
    }
  }
  return value;
}
const stack = [];
function pushWarningContext(vnode) {
  stack.push(vnode);
}
function popWarningContext() {
  stack.pop();
}
let isWarning = false;
function warn$1(msg, ...args) {
  if (isWarning) return;
  isWarning = true;
  pauseTracking();
  const instance = stack.length ? stack[stack.length - 1].component : null;
  const appWarnHandler = instance && instance.appContext.config.warnHandler;
  const trace = getComponentTrace();
  if (appWarnHandler) {
    callWithErrorHandling(
      appWarnHandler,
      instance,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a) => {
          var _a2, _b2;
          return (_b2 = (_a2 = a.toString) == null ? void 0 : _a2.call(a)) != null ? _b2 : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(
          ({ vnode }) => `at <${formatComponentName(instance, vnode.type)}>`
        ).join("\n"),
        trace
      ]
    );
  } else {
    const warnArgs = [`[Vue warn]: ${msg}`, ...args];
    if (trace.length && // avoid spamming console during tests
    true) {
      warnArgs.push(`
`, ...formatTrace(trace));
    }
    console.warn(...warnArgs);
  }
  resetTracking();
  isWarning = false;
}
function getComponentTrace() {
  let currentVNode = stack[stack.length - 1];
  if (!currentVNode) {
    return [];
  }
  const normalizedStack = [];
  while (currentVNode) {
    const last2 = normalizedStack[0];
    if (last2 && last2.vnode === currentVNode) {
      last2.recurseCount++;
    } else {
      normalizedStack.push({
        vnode: currentVNode,
        recurseCount: 0
      });
    }
    const parentInstance = currentVNode.component && currentVNode.component.parent;
    currentVNode = parentInstance && parentInstance.vnode;
  }
  return normalizedStack;
}
function formatTrace(trace) {
  const logs = [];
  trace.forEach((entry, i) => {
    logs.push(...i === 0 ? [] : [`
`], ...formatTraceEntry(entry));
  });
  return logs;
}
function formatTraceEntry({ vnode, recurseCount }) {
  const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
  const isRoot = vnode.component ? vnode.component.parent == null : false;
  const open2 = ` at <${formatComponentName(
    vnode.component,
    vnode.type,
    isRoot
  )}`;
  const close = `>` + postfix;
  return vnode.props ? [open2, ...formatProps(vnode.props), close] : [open2 + close];
}
function formatProps(props) {
  const res = [];
  const keys2 = Object.keys(props);
  keys2.slice(0, 3).forEach((key) => {
    res.push(...formatProp(key, props[key]));
  });
  if (keys2.length > 3) {
    res.push(` ...`);
  }
  return res;
}
function formatProp(key, value, raw) {
  if (isString(value)) {
    value = JSON.stringify(value);
    return raw ? value : [`${key}=${value}`];
  } else if (typeof value === "number" || typeof value === "boolean" || value == null) {
    return raw ? value : [`${key}=${value}`];
  } else if (/* @__PURE__ */ isRef(value)) {
    value = formatProp(key, /* @__PURE__ */ toRaw(value.value), true);
    return raw ? value : [`${key}=Ref<`, value, `>`];
  } else if (isFunction(value)) {
    return [`${key}=fn${value.name ? `<${value.name}>` : ``}`];
  } else {
    value = /* @__PURE__ */ toRaw(value);
    return raw ? value : [`${key}=`, value];
  }
}
function assertNumber(val, type) {
  if (!!!(process.env.NODE_ENV !== "production")) return;
  if (val === void 0) {
    return;
  } else if (typeof val !== "number") {
    warn$1(`${type} is not a valid number - got ${JSON.stringify(val)}.`);
  } else if (isNaN(val)) {
    warn$1(`${type} is NaN - the duration expression might be incorrect.`);
  }
}
const ErrorTypeStrings$1 = {
  ["sp"]: "serverPrefetch hook",
  ["bc"]: "beforeCreate hook",
  ["c"]: "created hook",
  ["bm"]: "beforeMount hook",
  ["m"]: "mounted hook",
  ["bu"]: "beforeUpdate hook",
  ["u"]: "updated",
  ["bum"]: "beforeUnmount hook",
  ["um"]: "unmounted hook",
  ["a"]: "activated hook",
  ["da"]: "deactivated hook",
  ["ec"]: "errorCaptured hook",
  ["rtc"]: "renderTracked hook",
  ["rtg"]: "renderTriggered hook",
  [0]: "setup function",
  [1]: "render function",
  [2]: "watcher getter",
  [3]: "watcher callback",
  [4]: "watcher cleanup function",
  [5]: "native event handler",
  [6]: "component event handler",
  [7]: "vnode hook",
  [8]: "directive hook",
  [9]: "transition hook",
  [10]: "app errorHandler",
  [11]: "app warnHandler",
  [12]: "ref function",
  [13]: "async component loader",
  [14]: "scheduler flush",
  [15]: "component update",
  [16]: "app unmount cleanup function"
};
function callWithErrorHandling(fn3, instance, type, args) {
  try {
    return args ? fn3(...args) : fn3();
  } catch (err) {
    handleError(err, instance, type);
  }
}
function callWithAsyncErrorHandling(fn3, instance, type, args) {
  if (isFunction(fn3)) {
    const res = callWithErrorHandling(fn3, instance, type, args);
    if (res && isPromise(res)) {
      res.catch((err) => {
        handleError(err, instance, type);
      });
    }
    return res;
  }
  if (isArray(fn3)) {
    const values2 = [];
    for (let i = 0; i < fn3.length; i++) {
      values2.push(callWithAsyncErrorHandling(fn3[i], instance, type, args));
    }
    return values2;
  } else if (!!(process.env.NODE_ENV !== "production")) {
    warn$1(
      `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof fn3}`
    );
  }
}
function handleError(err, instance, type, throwInDev = true) {
  const contextVNode = instance ? instance.vnode : null;
  const { errorHandler, throwUnhandledErrorInProduction } = instance && instance.appContext.config || EMPTY_OBJ;
  if (instance) {
    let cur = instance.parent;
    const exposedInstance = instance.proxy;
    const errorInfo = !!(process.env.NODE_ENV !== "production") ? ErrorTypeStrings$1[type] : `https://vuejs.org/error-reference/#runtime-${type}`;
    while (cur) {
      const errorCapturedHooks = cur.ec;
      if (errorCapturedHooks) {
        for (let i = 0; i < errorCapturedHooks.length; i++) {
          if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) {
            return;
          }
        }
      }
      cur = cur.parent;
    }
    if (errorHandler) {
      pauseTracking();
      callWithErrorHandling(errorHandler, null, 10, [
        err,
        exposedInstance,
        errorInfo
      ]);
      resetTracking();
      return;
    }
  }
  logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
  if (!!(process.env.NODE_ENV !== "production")) {
    const info = ErrorTypeStrings$1[type];
    if (contextVNode) {
      pushWarningContext(contextVNode);
    }
    warn$1(`Unhandled error${info ? ` during execution of ${info}` : ``}`);
    if (contextVNode) {
      popWarningContext();
    }
    if (throwInDev) {
      throw err;
    } else {
      console.error(err);
    }
  } else if (throwInProd) {
    throw err;
  } else {
    console.error(err);
  }
}
const queue = [];
let flushIndex = -1;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null;
let postFlushIndex = 0;
const resolvedPromise = /* @__PURE__ */ Promise.resolve();
let currentFlushPromise = null;
const RECURSION_LIMIT = 100;
function nextTick(fn3) {
  const p = currentFlushPromise || resolvedPromise;
  return fn3 ? p.then(this ? fn3.bind(this) : fn3) : p;
}
function findInsertionIndex(id) {
  let start2 = flushIndex + 1;
  let end2 = queue.length;
  while (start2 < end2) {
    const middle = start2 + end2 >>> 1;
    const middleJob = queue[middle];
    const middleJobId = getId(middleJob);
    if (middleJobId < id || middleJobId === id && middleJob.flags & 2) {
      start2 = middle + 1;
    } else {
      end2 = middle;
    }
  }
  return start2;
}
function queueJob(job) {
  if (!(job.flags & 1)) {
    const jobId = getId(job);
    const lastJob = queue[queue.length - 1];
    if (!lastJob || // fast path when the job id is larger than the tail
    !(job.flags & 2) && jobId >= getId(lastJob)) {
      queue.push(job);
    } else {
      queue.splice(findInsertionIndex(jobId), 0, job);
    }
    job.flags |= 1;
    queueFlush();
  }
}
function queueFlush() {
  if (!currentFlushPromise) {
    currentFlushPromise = resolvedPromise.then(flushJobs);
  }
}
function queuePostFlushCb(cb2) {
  if (!isArray(cb2)) {
    if (activePostFlushCbs && cb2.id === -1) {
      activePostFlushCbs.splice(postFlushIndex + 1, 0, cb2);
    } else if (!(cb2.flags & 1)) {
      pendingPostFlushCbs.push(cb2);
      cb2.flags |= 1;
    }
  } else {
    for (let i = 0; i < cb2.length; i++) {
      pendingPostFlushCbs.push(cb2[i]);
    }
  }
  queueFlush();
}
function flushPostFlushCbs(seen) {
  if (pendingPostFlushCbs.length) {
    const deduped = [...new Set(pendingPostFlushCbs)].sort(
      (a, b) => getId(a) - getId(b)
    );
    pendingPostFlushCbs.length = 0;
    if (activePostFlushCbs) {
      for (let i = 0; i < deduped.length; i++) {
        activePostFlushCbs.push(deduped[i]);
      }
      return;
    }
    activePostFlushCbs = deduped;
    if (!!(process.env.NODE_ENV !== "production")) {
      seen = seen || /* @__PURE__ */ new Map();
    }
    for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
      const cb2 = activePostFlushCbs[postFlushIndex];
      if (!!(process.env.NODE_ENV !== "production") && checkRecursiveUpdates(seen, cb2)) {
        continue;
      }
      if (cb2.flags & 4) {
        cb2.flags &= -2;
      }
      if (!(cb2.flags & 8)) cb2();
      cb2.flags &= -2;
    }
    activePostFlushCbs = null;
    postFlushIndex = 0;
  }
}
const getId = (job) => job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function flushJobs(seen) {
  if (!!(process.env.NODE_ENV !== "production")) {
    seen = seen || /* @__PURE__ */ new Map();
  }
  const check = !!(process.env.NODE_ENV !== "production") ? (job) => checkRecursiveUpdates(seen, job) : NOOP;
  try {
    for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
      const job = queue[flushIndex];
      if (job && !(job.flags & 8)) {
        if (!!(process.env.NODE_ENV !== "production") && check(job)) {
          continue;
        }
        if (job.flags & 4) {
          job.flags &= ~1;
        }
        callWithErrorHandling(
          job,
          job.i,
          job.i ? 15 : 14
        );
        if (!(job.flags & 4)) {
          job.flags &= ~1;
        }
      }
    }
  } finally {
    for (; flushIndex < queue.length; flushIndex++) {
      const job = queue[flushIndex];
      if (job) {
        job.flags &= -2;
      }
    }
    flushIndex = -1;
    queue.length = 0;
    flushPostFlushCbs(seen);
    currentFlushPromise = null;
    if (queue.length || pendingPostFlushCbs.length) {
      flushJobs(seen);
    }
  }
}
function checkRecursiveUpdates(seen, fn3) {
  const count2 = seen.get(fn3) || 0;
  if (count2 > RECURSION_LIMIT) {
    const instance = fn3.i;
    const componentName = instance && getComponentName(instance.type);
    handleError(
      `Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    );
    return true;
  }
  seen.set(fn3, count2 + 1);
  return false;
}
let isHmrUpdating = false;
const hmrDirtyComponents = /* @__PURE__ */ new Map();
if (!!(process.env.NODE_ENV !== "production")) {
  getGlobalThis().__VUE_HMR_RUNTIME__ = {
    createRecord: tryWrap(createRecord),
    rerender: tryWrap(rerender),
    reload: tryWrap(reload)
  };
}
const map = /* @__PURE__ */ new Map();
function createRecord(id, initialDef) {
  if (map.has(id)) {
    return false;
  }
  map.set(id, {
    initialDef: normalizeClassComponent(initialDef),
    instances: /* @__PURE__ */ new Set()
  });
  return true;
}
function normalizeClassComponent(component) {
  return isClassComponent(component) ? component.__vccOpts : component;
}
function rerender(id, newRender) {
  const record = map.get(id);
  if (!record) {
    return;
  }
  record.initialDef.render = newRender;
  [...record.instances].forEach((instance) => {
    if (newRender) {
      instance.render = newRender;
      normalizeClassComponent(instance.type).render = newRender;
    }
    instance.renderCache = [];
    isHmrUpdating = true;
    if (!(instance.job.flags & 8)) {
      instance.update();
    }
    isHmrUpdating = false;
  });
}
function reload(id, newComp) {
  const record = map.get(id);
  if (!record) return;
  newComp = normalizeClassComponent(newComp);
  updateComponentDef(record.initialDef, newComp);
  const instances = [...record.instances];
  for (let i = 0; i < instances.length; i++) {
    const instance = instances[i];
    const oldComp = normalizeClassComponent(instance.type);
    let dirtyInstances = hmrDirtyComponents.get(oldComp);
    if (!dirtyInstances) {
      if (oldComp !== record.initialDef) {
        updateComponentDef(oldComp, newComp);
      }
      hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
    }
    dirtyInstances.add(instance);
    instance.appContext.propsCache.delete(instance.type);
    instance.appContext.emitsCache.delete(instance.type);
    instance.appContext.optionsCache.delete(instance.type);
    if (instance.ceReload) {
      dirtyInstances.add(instance);
      instance.ceReload(newComp.styles);
      dirtyInstances.delete(instance);
    } else if (instance.parent) {
      queueJob(() => {
        if (!(instance.job.flags & 8)) {
          isHmrUpdating = true;
          instance.parent.update();
          isHmrUpdating = false;
          dirtyInstances.delete(instance);
        }
      });
    } else if (instance.appContext.reload) {
      instance.appContext.reload();
    } else if (typeof window !== "undefined") {
      window.location.reload();
    } else {
      console.warn(
        "[HMR] Root or manually mounted instance modified. Full reload required."
      );
    }
    if (instance.root.ce && instance !== instance.root) {
      instance.root.ce._removeChildStyle(oldComp);
    }
  }
  queuePostFlushCb(() => {
    hmrDirtyComponents.clear();
  });
}
function updateComponentDef(oldComp, newComp) {
  extend(oldComp, newComp);
  for (const key in oldComp) {
    if (key !== "__file" && !(key in newComp)) {
      delete oldComp[key];
    }
  }
}
function tryWrap(fn3) {
  return (id, arg2) => {
    try {
      return fn3(id, arg2);
    } catch (e) {
      console.error(e);
      console.warn(
        `[HMR] Something went wrong during Vue component hot-reload. Full reload required.`
      );
    }
  };
}
let devtools$1;
let buffer = [];
let devtoolsNotInstalled = false;
function emit$1(event2, ...args) {
  if (devtools$1) {
    devtools$1.emit(event2, ...args);
  } else if (!devtoolsNotInstalled) {
    buffer.push({ event: event2, args });
  }
}
function setDevtoolsHook$1(hook, target) {
  var _a2, _b2;
  devtools$1 = hook;
  if (devtools$1) {
    devtools$1.enabled = true;
    buffer.forEach(({ event: event2, args }) => devtools$1.emit(event2, ...args));
    buffer = [];
  } else if (
    // handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b2 = (_a2 = window.navigator) == null ? void 0 : _a2.userAgent) == null ? void 0 : _b2.includes("jsdom"))
  ) {
    const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
    replay.push((newHook) => {
      setDevtoolsHook$1(newHook, target);
    });
    setTimeout(() => {
      if (!devtools$1) {
        target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
        devtoolsNotInstalled = true;
        buffer = [];
      }
    }, 3e3);
  } else {
    devtoolsNotInstalled = true;
    buffer = [];
  }
}
const devtoolsComponentUpdated = /* @__PURE__ */ createDevtoolsComponentHook(
  "component:updated"
  /* COMPONENT_UPDATED */
);
// @__NO_SIDE_EFFECTS__
function createDevtoolsComponentHook(hook) {
  return (component) => {
    emit$1(
      hook,
      component.appContext.app,
      component.uid,
      component.parent ? component.parent.uid : void 0,
      component
    );
  };
}
let currentRenderingInstance = null;
let currentScopeId = null;
function setCurrentRenderingInstance(instance) {
  const prev2 = currentRenderingInstance;
  currentRenderingInstance = instance;
  currentScopeId = instance && instance.type.__scopeId || null;
  return prev2;
}
function pushScopeId(id) {
  currentScopeId = id;
}
function popScopeId() {
  currentScopeId = null;
}
function withCtx(fn3, ctx = currentRenderingInstance, isNonScopedSlot) {
  if (!ctx) return fn3;
  if (fn3._n) {
    return fn3;
  }
  const renderFnWithContext = (...args) => {
    if (renderFnWithContext._d) {
      setBlockTracking(-1);
    }
    const prevInstance = setCurrentRenderingInstance(ctx);
    const prevStackSize = blockStack.length;
    let res;
    try {
      res = fn3(...args);
    } finally {
      for (let i = blockStack.length; i > prevStackSize; i--) closeBlock();
      setCurrentRenderingInstance(prevInstance);
      if (renderFnWithContext._d) {
        setBlockTracking(1);
      }
    }
    if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
      devtoolsComponentUpdated(ctx);
    }
    return res;
  };
  renderFnWithContext._n = true;
  renderFnWithContext._c = true;
  renderFnWithContext._d = true;
  return renderFnWithContext;
}
function withDirectives(vnode, directives) {
  if (currentRenderingInstance === null) {
    !!(process.env.NODE_ENV !== "production") && warn$1(`withDirectives can only be used inside render functions.`);
    return vnode;
  }
  const instance = getComponentPublicInstance(currentRenderingInstance);
  const bindings = vnode.dirs || (vnode.dirs = []);
  for (let i = 0; i < directives.length; i++) {
    let [dir, value, arg2, modifiers = EMPTY_OBJ] = directives[i];
    if (dir) {
      if (isFunction(dir)) {
        dir = {
          mounted: dir,
          updated: dir
        };
      }
      if (dir.deep) {
        traverse(value);
      }
      bindings.push({
        dir,
        instance,
        value,
        oldValue: void 0,
        arg: arg2,
        modifiers
      });
    }
  }
  return vnode;
}
function provide(key, value) {
  if (!!(process.env.NODE_ENV !== "production")) {
    if (!currentInstance || currentInstance.isMounted) {
      warn$1(`provide() can only be used inside setup().`);
    }
  }
  if (currentInstance) {
    let provides = currentInstance.provides;
    const parentProvides = currentInstance.parent && currentInstance.parent.provides;
    if (parentProvides === provides) {
      provides = currentInstance.provides = Object.create(parentProvides);
    }
    provides[key] = value;
  }
}
function inject(key, defaultValue, treatDefaultAsFactory = false) {
  const instance = getCurrentInstance();
  if (instance || currentApp) {
    let provides = instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
    if (provides && key in provides) {
      return provides[key];
    } else if (arguments.length > 1) {
      return treatDefaultAsFactory && isFunction(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    } else if (!!(process.env.NODE_ENV !== "production")) {
      warn$1(`injection "${String(key)}" not found.`);
    }
  } else if (!!(process.env.NODE_ENV !== "production")) {
    warn$1(`inject() can only be used inside setup() or functional components.`);
  }
}
function hasInjectionContext() {
  return !!(getCurrentInstance() || currentApp);
}
const ssrContextKey = /* @__PURE__ */ Symbol.for("v-scx");
const useSSRContext = () => {
  {
    const ctx = inject(ssrContextKey);
    if (!ctx) {
      !!(process.env.NODE_ENV !== "production") && warn$1(
        `Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build.`
      );
    }
    return ctx;
  }
};
function watch(source, cb2, options) {
  if (!!(process.env.NODE_ENV !== "production") && !isFunction(cb2)) {
    warn$1(
      `\`watch(fn, options?)\` signature has been moved to a separate API. Use \`watchEffect(fn, options?)\` instead. \`watch\` now only supports \`watch(source, cb, options?) signature.`
    );
  }
  return doWatch(source, cb2, options);
}
function doWatch(source, cb2, options = EMPTY_OBJ) {
  const { immediate, deep, flush, once } = options;
  if (!!(process.env.NODE_ENV !== "production") && !cb2) {
    if (immediate !== void 0) {
      warn$1(
        `watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.`
      );
    }
    if (deep !== void 0) {
      warn$1(
        `watch() "deep" option is only respected when using the watch(source, callback, options?) signature.`
      );
    }
    if (once !== void 0) {
      warn$1(
        `watch() "once" option is only respected when using the watch(source, callback, options?) signature.`
      );
    }
  }
  const baseWatchOptions = extend({}, options);
  if (!!(process.env.NODE_ENV !== "production")) baseWatchOptions.onWarn = warn$1;
  const runsImmediately = cb2 && immediate || !cb2 && flush !== "post";
  let ssrCleanup;
  if (isInSSRComponentSetup) {
    if (flush === "sync") {
      const ctx = useSSRContext();
      ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
    } else if (!runsImmediately) {
      const watchStopHandle = () => {
      };
      watchStopHandle.stop = NOOP;
      watchStopHandle.resume = NOOP;
      watchStopHandle.pause = NOOP;
      return watchStopHandle;
    }
  }
  const instance = currentInstance;
  baseWatchOptions.call = (fn3, type, args) => callWithAsyncErrorHandling(fn3, instance, type, args);
  let isPre = false;
  if (flush === "post") {
    baseWatchOptions.scheduler = (job) => {
      queuePostRenderEffect(job, instance && instance.suspense);
    };
  } else if (flush !== "sync") {
    isPre = true;
    baseWatchOptions.scheduler = (job, isFirstRun) => {
      if (isFirstRun) {
        job();
      } else {
        queueJob(job);
      }
    };
  }
  baseWatchOptions.augmentJob = (job) => {
    if (cb2) {
      job.flags |= 4;
    }
    if (isPre) {
      job.flags |= 2;
      if (instance) {
        job.id = instance.uid;
        job.i = instance;
      }
    }
  };
  const watchHandle = watch$1(source, cb2, baseWatchOptions);
  if (isInSSRComponentSetup) {
    if (ssrCleanup) {
      ssrCleanup.push(watchHandle);
    } else if (runsImmediately) {
      watchHandle();
    }
  }
  return watchHandle;
}
function instanceWatch(source, value, options) {
  const publicThis = this.proxy;
  const getter = isString(source) ? source.includes(".") ? createPathGetter(publicThis, source) : () => publicThis[source] : source.bind(publicThis, publicThis);
  let cb2;
  if (isFunction(value)) {
    cb2 = value;
  } else {
    cb2 = value.handler;
    options = value;
  }
  const reset = setCurrentInstance(this);
  const res = doWatch(getter, cb2.bind(publicThis), options);
  reset();
  return res;
}
function createPathGetter(ctx, path) {
  const segments = path.split(".");
  return () => {
    let cur = ctx;
    for (let i = 0; i < segments.length && cur; i++) {
      cur = cur[segments[i]];
    }
    return cur;
  };
}
const pendingMounts = /* @__PURE__ */ new WeakMap();
const TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
const isTeleport = (type) => type.__isTeleport;
const isTeleportDisabled = (props) => props && (props.disabled || props.disabled === "");
const isTeleportDeferred = (props) => props && (props.defer || props.defer === "");
const isTargetSVG = (target) => typeof SVGElement !== "undefined" && target instanceof SVGElement;
const isTargetMathML = (target) => typeof MathMLElement === "function" && target instanceof MathMLElement;
const resolveTarget = (props, select2) => {
  const targetSelector = props && props.to;
  if (isString(targetSelector)) {
    if (!select2) {
      !!(process.env.NODE_ENV !== "production") && warn$1(
        `Current renderer does not support string target for Teleports. (missing querySelector renderer option)`
      );
      return null;
    } else {
      const target = select2(targetSelector);
      if (!!(process.env.NODE_ENV !== "production") && !target && !isTeleportDisabled(props)) {
        warn$1(
          `Failed to locate Teleport target with selector "${targetSelector}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`
        );
      }
      return target;
    }
  } else {
    if (!!(process.env.NODE_ENV !== "production") && !targetSelector && !isTeleportDisabled(props)) {
      warn$1(`Invalid Teleport target: ${targetSelector}`);
    }
    return targetSelector;
  }
};
const TeleportImpl = {
  name: "Teleport",
  __isTeleport: true,
  process(n12, n22, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
    const {
      mc: mountChildren,
      pc: patchChildren,
      pbc: patchBlockChildren,
      o: { insert, querySelector, createText, createComment, parentNode }
    } = internals;
    const disabled = isTeleportDisabled(n22.props);
    let { dynamicChildren } = n22;
    if (!!(process.env.NODE_ENV !== "production") && isHmrUpdating) {
      optimized = false;
      dynamicChildren = null;
    }
    const mount = (vnode, container2, anchor2) => {
      if (vnode.shapeFlag & 16) {
        mountChildren(
          vnode.children,
          container2,
          anchor2,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      }
    };
    const mountToTarget = (vnode = n22) => {
      const disabled2 = isTeleportDisabled(vnode.props);
      const target = vnode.target = resolveTarget(vnode.props, querySelector);
      const targetAnchor = prepareAnchor(target, vnode, createText, insert);
      if (target) {
        if (namespace !== "svg" && isTargetSVG(target)) {
          namespace = "svg";
        } else if (namespace !== "mathml" && isTargetMathML(target)) {
          namespace = "mathml";
        }
        if (parentComponent && parentComponent.isCE) {
          (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
        }
        if (!disabled2) {
          mount(vnode, target, targetAnchor);
          updateCssVars(vnode, false);
        }
      } else if (!!(process.env.NODE_ENV !== "production") && !disabled2) {
        warn$1("Invalid Teleport target on mount:", target, `(${typeof target})`);
      }
    };
    const queuePendingMount = (vnode) => {
      const mountJob = () => {
        if (pendingMounts.get(vnode) !== mountJob) return;
        pendingMounts.delete(vnode);
        if (isTeleportDisabled(vnode.props)) {
          const mountContainer = parentNode(vnode.el) || container;
          mount(vnode, mountContainer, vnode.anchor);
          updateCssVars(vnode, true);
        }
        mountToTarget(vnode);
      };
      pendingMounts.set(vnode, mountJob);
      queuePostRenderEffect(mountJob, parentSuspense);
    };
    if (n12 == null) {
      const placeholder = n22.el = !!(process.env.NODE_ENV !== "production") ? createComment("teleport start") : createText("");
      const mainAnchor = n22.anchor = !!(process.env.NODE_ENV !== "production") ? createComment("teleport end") : createText("");
      insert(placeholder, container, anchor);
      insert(mainAnchor, container, anchor);
      if (isTeleportDeferred(n22.props) || parentSuspense && parentSuspense.pendingBranch) {
        queuePendingMount(n22);
        return;
      }
      if (disabled) {
        mount(n22, container, mainAnchor);
        updateCssVars(n22, true);
      }
      mountToTarget();
    } else {
      n22.el = n12.el;
      const mainAnchor = n22.anchor = n12.anchor;
      const pendingMount = pendingMounts.get(n12);
      if (pendingMount) {
        pendingMount.flags |= 8;
        pendingMounts.delete(n12);
        queuePendingMount(n22);
        return;
      }
      n22.targetStart = n12.targetStart;
      const target = n22.target = n12.target;
      const targetAnchor = n22.targetAnchor = n12.targetAnchor;
      const wasDisabled = isTeleportDisabled(n12.props);
      const currentContainer = wasDisabled ? container : target;
      const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
      if (namespace === "svg" || isTargetSVG(target)) {
        namespace = "svg";
      } else if (namespace === "mathml" || isTargetMathML(target)) {
        namespace = "mathml";
      }
      if (dynamicChildren) {
        patchBlockChildren(
          n12.dynamicChildren,
          dynamicChildren,
          currentContainer,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds
        );
        traverseStaticChildren(n12, n22, !!!(process.env.NODE_ENV !== "production"));
      } else if (!optimized) {
        patchChildren(
          n12,
          n22,
          currentContainer,
          currentAnchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          false
        );
      }
      if (disabled) {
        if (!wasDisabled) {
          moveTeleport(
            n22,
            container,
            mainAnchor,
            internals,
            1
          );
        } else {
          if (n22.props && n12.props && n22.props.to !== n12.props.to) {
            n22.props.to = n12.props.to;
          }
        }
      } else {
        if ((n22.props && n22.props.to) !== (n12.props && n12.props.to)) {
          const nextTarget = resolveTarget(n22.props, querySelector);
          if (nextTarget) {
            n22.target = nextTarget;
            moveTeleport(
              n22,
              nextTarget,
              null,
              internals,
              0
            );
          } else if (!!(process.env.NODE_ENV !== "production")) {
            warn$1(
              "Invalid Teleport target on update:",
              target,
              `(${typeof target})`
            );
          }
        } else if (wasDisabled) {
          moveTeleport(
            n22,
            target,
            targetAnchor,
            internals,
            1
          );
        }
      }
      updateCssVars(n22, disabled);
    }
  },
  remove(vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
    const {
      shapeFlag,
      children,
      anchor,
      targetStart,
      targetAnchor,
      target,
      props
    } = vnode;
    const disabled = isTeleportDisabled(props);
    const shouldRemove = doRemove || !disabled;
    const pendingMount = pendingMounts.get(vnode);
    if (pendingMount) {
      pendingMount.flags |= 8;
      pendingMounts.delete(vnode);
    }
    if (target) {
      hostRemove(targetStart);
      hostRemove(targetAnchor);
    }
    doRemove && hostRemove(anchor);
    if (!pendingMount && (disabled || target) && shapeFlag & 16) {
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        unmount(
          child,
          parentComponent,
          parentSuspense,
          shouldRemove,
          !!child.dynamicChildren
        );
      }
    }
  },
  move: moveTeleport,
  hydrate: hydrateTeleport
};
function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2) {
  if (moveType === 0) {
    insert(vnode.targetAnchor, container, parentAnchor);
  }
  const { el, anchor, shapeFlag, children, props } = vnode;
  const isReorder = moveType === 2;
  if (isReorder) {
    insert(el, container, parentAnchor);
  }
  if (!pendingMounts.has(vnode) && (!isReorder || isTeleportDisabled(props))) {
    if (shapeFlag & 16) {
      for (let i = 0; i < children.length; i++) {
        move(
          children[i],
          container,
          parentAnchor,
          2
        );
      }
    }
  }
  if (isReorder) {
    insert(anchor, container, parentAnchor);
  }
}
function hydrateTeleport(node2, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, {
  o: { nextSibling, parentNode, querySelector, insert, createText }
}, hydrateChildren) {
  function hydrateAnchor(target2, targetNode) {
    let targetAnchor = targetNode;
    while (targetAnchor) {
      if (targetAnchor && targetAnchor.nodeType === 8) {
        if (targetAnchor.data === "teleport start anchor") {
          vnode.targetStart = targetAnchor;
        } else if (targetAnchor.data === "teleport anchor") {
          vnode.targetAnchor = targetAnchor;
          target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
          break;
        }
      }
      targetAnchor = nextSibling(targetAnchor);
    }
  }
  function hydrateDisabledTeleport(node22, vnode2) {
    vnode2.anchor = hydrateChildren(
      nextSibling(node22),
      vnode2,
      parentNode(node22),
      parentComponent,
      parentSuspense,
      slotScopeIds,
      optimized
    );
  }
  const target = vnode.target = resolveTarget(
    vnode.props,
    querySelector
  );
  const disabled = isTeleportDisabled(vnode.props);
  if (target) {
    const targetNode = target._lpa || target.firstChild;
    if (vnode.shapeFlag & 16) {
      if (disabled) {
        hydrateDisabledTeleport(node2, vnode);
        hydrateAnchor(target, targetNode);
        if (!vnode.targetAnchor) {
          prepareAnchor(
            target,
            vnode,
            createText,
            insert,
            // if target is the same as the main view, insert anchors before current node
            // to avoid hydrating mismatch
            parentNode(node2) === target ? node2 : null
          );
        }
      } else {
        vnode.anchor = nextSibling(node2);
        hydrateAnchor(target, targetNode);
        if (!vnode.targetAnchor) {
          prepareAnchor(target, vnode, createText, insert);
        }
        hydrateChildren(
          targetNode && nextSibling(targetNode),
          vnode,
          target,
          parentComponent,
          parentSuspense,
          slotScopeIds,
          optimized
        );
      }
    }
    updateCssVars(vnode, disabled);
  } else if (disabled) {
    if (vnode.shapeFlag & 16) {
      hydrateDisabledTeleport(node2, vnode);
      vnode.targetStart = node2;
      vnode.targetAnchor = nextSibling(node2);
    }
  }
  return vnode.anchor && nextSibling(vnode.anchor);
}
const Teleport = TeleportImpl;
function updateCssVars(vnode, isDisabled) {
  const ctx = vnode.ctx;
  if (ctx && ctx.ut) {
    let node2, anchor;
    if (isDisabled) {
      node2 = vnode.el;
      anchor = vnode.anchor;
    } else {
      node2 = vnode.targetStart;
      anchor = vnode.targetAnchor;
    }
    while (node2 && node2 !== anchor) {
      if (node2.nodeType === 1) node2.setAttribute("data-v-owner", ctx.uid);
      node2 = node2.nextSibling;
    }
    ctx.ut();
  }
}
function prepareAnchor(target, vnode, createText, insert, anchor = null) {
  const targetStart = vnode.targetStart = createText("");
  const targetAnchor = vnode.targetAnchor = createText("");
  targetStart[TeleportEndKey] = targetAnchor;
  if (target) {
    insert(targetStart, target, anchor);
    insert(targetAnchor, target, anchor);
  }
  return targetAnchor;
}
const leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
const enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
function useTransitionState() {
  const state = {
    isMounted: false,
    isLeaving: false,
    isUnmounting: false,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  onMounted(() => {
    state.isMounted = true;
  });
  onBeforeUnmount(() => {
    state.isUnmounting = true;
  });
  return state;
}
const TransitionHookValidator = [Function, Array];
const BaseTransitionPropsValidators = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: TransitionHookValidator,
  onEnter: TransitionHookValidator,
  onAfterEnter: TransitionHookValidator,
  onEnterCancelled: TransitionHookValidator,
  // leave
  onBeforeLeave: TransitionHookValidator,
  onLeave: TransitionHookValidator,
  onAfterLeave: TransitionHookValidator,
  onLeaveCancelled: TransitionHookValidator,
  // appear
  onBeforeAppear: TransitionHookValidator,
  onAppear: TransitionHookValidator,
  onAfterAppear: TransitionHookValidator,
  onAppearCancelled: TransitionHookValidator
};
const recursiveGetSubtree = (instance) => {
  const subTree = instance.subTree;
  return subTree.component ? recursiveGetSubtree(subTree.component) : subTree;
};
const BaseTransitionImpl = {
  name: `BaseTransition`,
  props: BaseTransitionPropsValidators,
  setup(props, { slots }) {
    const instance = getCurrentInstance();
    const state = useTransitionState();
    return () => {
      const children = slots.default && getTransitionRawChildren(slots.default(), true);
      const child = children && children.length ? findNonCommentChild(children) : (
        // Keep explicit default-slot conditionals on the same transition path
        // as regular v-if branches, which render a comment placeholder.
        instance.subTree ? createCommentVNode() : void 0
      );
      if (!child) {
        return;
      }
      const rawProps = /* @__PURE__ */ toRaw(props);
      const { mode } = rawProps;
      if (!!(process.env.NODE_ENV !== "production") && mode && mode !== "in-out" && mode !== "out-in" && mode !== "default") {
        warn$1(`invalid <transition> mode: ${mode}`);
      }
      if (state.isLeaving) {
        return emptyPlaceholder(child);
      }
      const innerChild = getInnerChild$1(child);
      if (!innerChild) {
        return emptyPlaceholder(child);
      }
      let enterHooks = resolveTransitionHooks(
        innerChild,
        rawProps,
        state,
        instance,
        // #11061, ensure enterHooks is fresh after clone
        (hooks) => enterHooks = hooks
      );
      if (innerChild.type !== Comment) {
        setTransitionHooks(innerChild, enterHooks);
      }
      let oldInnerChild = instance.subTree && getInnerChild$1(instance.subTree);
      if (oldInnerChild && oldInnerChild.type !== Comment && !isSameVNodeType(oldInnerChild, innerChild) && recursiveGetSubtree(instance).type !== Comment) {
        let leavingHooks = resolveTransitionHooks(
          oldInnerChild,
          rawProps,
          state,
          instance
        );
        setTransitionHooks(oldInnerChild, leavingHooks);
        if (mode === "out-in" && innerChild.type !== Comment) {
          state.isLeaving = true;
          leavingHooks.afterLeave = () => {
            state.isLeaving = false;
            if (!(instance.job.flags & 8)) {
              instance.update();
            }
            delete leavingHooks.afterLeave;
            oldInnerChild = void 0;
          };
          return emptyPlaceholder(child);
        } else if (mode === "in-out" && innerChild.type !== Comment) {
          leavingHooks.delayLeave = (el, earlyRemove, delayedLeave) => {
            const leavingVNodesCache = getLeavingNodesForType(
              state,
              oldInnerChild
            );
            leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
            el[leaveCbKey] = () => {
              earlyRemove();
              el[leaveCbKey] = void 0;
              delete enterHooks.delayedLeave;
              oldInnerChild = void 0;
            };
            enterHooks.delayedLeave = () => {
              delayedLeave();
              delete enterHooks.delayedLeave;
              oldInnerChild = void 0;
            };
          };
        } else {
          oldInnerChild = void 0;
        }
      } else if (oldInnerChild) {
        oldInnerChild = void 0;
      }
      return child;
    };
  }
};
function findNonCommentChild(children) {
  let child = children[0];
  if (children.length > 1) {
    let hasFound = false;
    for (const c of children) {
      if (c.type !== Comment) {
        if (!!(process.env.NODE_ENV !== "production") && hasFound) {
          warn$1(
            "<transition> can only be used on a single element or component. Use <transition-group> for lists."
          );
          break;
        }
        child = c;
        hasFound = true;
        if (!!!(process.env.NODE_ENV !== "production")) break;
      }
    }
  }
  return child;
}
const BaseTransition = BaseTransitionImpl;
function getLeavingNodesForType(state, vnode) {
  const { leavingVNodes } = state;
  let leavingVNodesCache = leavingVNodes.get(vnode.type);
  if (!leavingVNodesCache) {
    leavingVNodesCache = /* @__PURE__ */ Object.create(null);
    leavingVNodes.set(vnode.type, leavingVNodesCache);
  }
  return leavingVNodesCache;
}
function resolveTransitionHooks(vnode, props, state, instance, postClone) {
  const {
    appear,
    mode,
    persisted = false,
    onBeforeEnter,
    onEnter,
    onAfterEnter,
    onEnterCancelled,
    onBeforeLeave,
    onLeave,
    onAfterLeave,
    onLeaveCancelled,
    onBeforeAppear,
    onAppear,
    onAfterAppear,
    onAppearCancelled
  } = props;
  const key = String(vnode.key);
  const leavingVNodesCache = getLeavingNodesForType(state, vnode);
  const callHook2 = (hook, args) => {
    hook && callWithAsyncErrorHandling(
      hook,
      instance,
      9,
      args
    );
  };
  const callAsyncHook = (hook, args) => {
    const done = args[1];
    callHook2(hook, args);
    if (isArray(hook)) {
      if (hook.every((hook2) => hook2.length <= 1)) done();
    } else if (hook.length <= 1) {
      done();
    }
  };
  const hooks = {
    mode,
    persisted,
    beforeEnter(el) {
      let hook = onBeforeEnter;
      if (!state.isMounted) {
        if (appear) {
          hook = onBeforeAppear || onBeforeEnter;
        } else {
          return;
        }
      }
      if (el[leaveCbKey]) {
        el[leaveCbKey](
          true
          /* cancelled */
        );
      }
      const leavingVNode = leavingVNodesCache[key];
      if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[leaveCbKey]) {
        leavingVNode.el[leaveCbKey]();
      }
      callHook2(hook, [el]);
    },
    enter(el) {
      if (!isHmrUpdating && leavingVNodesCache[key] === vnode) return;
      let hook = onEnter;
      let afterHook = onAfterEnter;
      let cancelHook = onEnterCancelled;
      if (!state.isMounted) {
        if (appear) {
          hook = onAppear || onEnter;
          afterHook = onAfterAppear || onAfterEnter;
          cancelHook = onAppearCancelled || onEnterCancelled;
        } else {
          return;
        }
      }
      let called = false;
      el[enterCbKey] = (cancelled) => {
        if (called) return;
        called = true;
        if (cancelled) {
          callHook2(cancelHook, [el]);
        } else {
          callHook2(afterHook, [el]);
        }
        if (hooks.delayedLeave) {
          hooks.delayedLeave();
        }
        el[enterCbKey] = void 0;
      };
      const done = el[enterCbKey].bind(null, false);
      if (hook) {
        callAsyncHook(hook, [el, done]);
      } else {
        done();
      }
    },
    leave(el, remove2) {
      const key2 = String(vnode.key);
      if (el[enterCbKey]) {
        el[enterCbKey](
          true
          /* cancelled */
        );
      }
      if (state.isUnmounting) {
        return remove2();
      }
      callHook2(onBeforeLeave, [el]);
      let called = false;
      el[leaveCbKey] = (cancelled) => {
        if (called) return;
        called = true;
        remove2();
        if (cancelled) {
          callHook2(onLeaveCancelled, [el]);
        } else {
          callHook2(onAfterLeave, [el]);
        }
        el[leaveCbKey] = void 0;
        if (leavingVNodesCache[key2] === vnode) {
          delete leavingVNodesCache[key2];
        }
      };
      const done = el[leaveCbKey].bind(null, false);
      leavingVNodesCache[key2] = vnode;
      if (onLeave) {
        callAsyncHook(onLeave, [el, done]);
      } else {
        done();
      }
    },
    clone(vnode2) {
      const hooks2 = resolveTransitionHooks(
        vnode2,
        props,
        state,
        instance,
        postClone
      );
      if (postClone) postClone(hooks2);
      return hooks2;
    }
  };
  return hooks;
}
function emptyPlaceholder(vnode) {
  if (isKeepAlive(vnode)) {
    vnode = cloneVNode(vnode);
    vnode.children = null;
    return vnode;
  }
}
function getInnerChild$1(vnode) {
  if (!isKeepAlive(vnode)) {
    if (isTeleport(vnode.type) && vnode.children) {
      return findNonCommentChild(vnode.children);
    }
    return vnode;
  }
  if (vnode.component) {
    return vnode.component.subTree;
  }
  const { shapeFlag, children } = vnode;
  if (children) {
    if (shapeFlag & 16) {
      return children[0];
    }
    if (shapeFlag & 32 && isFunction(children.default)) {
      return children.default();
    }
  }
}
function setTransitionHooks(vnode, hooks) {
  if (vnode.shapeFlag & 6 && vnode.component) {
    vnode.transition = hooks;
    const subTree = vnode.component.subTree;
    setTransitionHooks(
      isTeleport(subTree.type) ? getInnerChild$1(subTree) || subTree : subTree,
      hooks
    );
  } else if (vnode.shapeFlag & 128) {
    vnode.ssContent.transition = hooks.clone(vnode.ssContent);
    vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
  } else {
    vnode.transition = hooks;
  }
}
function getTransitionRawChildren(children, keepComment = false, parentKey) {
  let ret = [];
  let keyedFragmentCount = 0;
  for (let i = 0; i < children.length; i++) {
    let child = children[i];
    const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
    if (child.type === Fragment) {
      if (child.patchFlag & 128) keyedFragmentCount++;
      ret = ret.concat(
        getTransitionRawChildren(child.children, keepComment, key)
      );
    } else if (keepComment || child.type !== Comment) {
      ret.push(key != null ? cloneVNode(child, { key }) : child);
    }
  }
  if (keyedFragmentCount > 1) {
    for (let i = 0; i < ret.length; i++) {
      ret[i].patchFlag = -2;
    }
  }
  return ret;
}
// @__NO_SIDE_EFFECTS__
function defineComponent(options, extraOptions) {
  return isFunction(options) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (() => extend({ name: options.name }, extraOptions, { setup: options }))()
  ) : options;
}
getGlobalThis().requestIdleCallback || ((cb2) => setTimeout(cb2, 1));
getGlobalThis().cancelIdleCallback || ((id) => clearTimeout(id));
const isAsyncWrapper = (i) => !!i.type.__asyncLoader;
const isKeepAlive = (vnode) => vnode.type.__isKeepAlive;
function injectHook(type, hook, target = currentInstance, prepend = false) {
  if (target) {
    const hooks = target[type] || (target[type] = []);
    const wrappedHook = hook.__weh || (hook.__weh = (...args) => {
      pauseTracking();
      const reset = setCurrentInstance(target);
      const res = callWithAsyncErrorHandling(hook, target, type, args);
      reset();
      resetTracking();
      return res;
    });
    if (prepend) {
      hooks.unshift(wrappedHook);
    } else {
      hooks.push(wrappedHook);
    }
    return wrappedHook;
  } else if (!!(process.env.NODE_ENV !== "production")) {
    const apiName = toHandlerKey(ErrorTypeStrings$1[type].replace(/ hook$/, ""));
    warn$1(
      `${apiName} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const createHook = (lifecycle) => (hook, target = currentInstance) => {
  if (!isInSSRComponentSetup || lifecycle === "sp") {
    injectHook(lifecycle, (...args) => hook(...args), target);
  }
};
const onMounted = createHook("m");
const onBeforeUnmount = createHook(
  "bum"
);
const COMPONENTS = "components";
const NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function resolveDynamicComponent(component) {
  if (isString(component)) {
    return resolveAsset(COMPONENTS, component, false) || component;
  } else {
    return component || NULL_DYNAMIC_COMPONENT;
  }
}
function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
  const instance = currentRenderingInstance || currentInstance;
  if (instance) {
    const Component = instance.type;
    {
      const selfName = getComponentName(
        Component,
        false
      );
      if (selfName && (selfName === name || selfName === camelize(name) || selfName === capitalize(camelize(name)))) {
        return Component;
      }
    }
    const res = (
      // local registration
      // check instance[type] first which is resolved for options API
      resolve(instance[type] || Component[type], name) || // global registration
      resolve(instance.appContext[type], name)
    );
    if (!res && maybeSelfReference) {
      return Component;
    }
    if (!!(process.env.NODE_ENV !== "production") && warnMissing && !res) {
      const extra = `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.`;
      warn$1(`Failed to resolve ${type.slice(0, -1)}: ${name}${extra}`);
    }
    return res;
  } else if (!!(process.env.NODE_ENV !== "production")) {
    warn$1(
      `resolve${capitalize(type.slice(0, -1))} can only be used in render() or setup().`
    );
  }
}
function resolve(registry, name) {
  return registry && (registry[name] || registry[camelize(name)] || registry[capitalize(camelize(name))]);
}
function renderList(source, renderItem, cache2, index2) {
  let ret;
  const cached2 = cache2;
  const sourceIsArray = isArray(source);
  if (sourceIsArray || isString(source)) {
    const sourceIsReactiveArray = sourceIsArray && /* @__PURE__ */ isReactive(source);
    let needsWrap = false;
    let isReadonlySource = false;
    if (sourceIsReactiveArray) {
      needsWrap = !/* @__PURE__ */ isShallow(source);
      isReadonlySource = /* @__PURE__ */ isReadonly(source);
      source = shallowReadArray(source);
    }
    ret = new Array(source.length);
    for (let i = 0, l2 = source.length; i < l2; i++) {
      ret[i] = renderItem(
        needsWrap ? isReadonlySource ? toReadonly(toReactive(source[i])) : toReactive(source[i]) : source[i],
        i,
        void 0,
        cached2
      );
    }
  } else if (typeof source === "number") {
    if (!!(process.env.NODE_ENV !== "production") && (!Number.isInteger(source) || source < 0)) {
      warn$1(
        `The v-for range expects a positive integer value but got ${source}.`
      );
      ret = [];
    } else {
      ret = new Array(source);
      for (let i = 0; i < source; i++) {
        ret[i] = renderItem(i + 1, i, void 0, cached2);
      }
    }
  } else if (isObject(source)) {
    if (source[Symbol.iterator]) {
      ret = Array.from(
        source,
        (item, i) => renderItem(item, i, void 0, cached2)
      );
    } else {
      const keys2 = Object.keys(source);
      ret = new Array(keys2.length);
      for (let i = 0, l2 = keys2.length; i < l2; i++) {
        const key = keys2[i];
        ret[i] = renderItem(source[key], key, i, cached2);
      }
    }
  } else {
    ret = [];
  }
  return ret;
}
function renderSlot(slots, name, props, fallback, noSlotted, branchKey) {
  if (props == null) props = {};
  if (currentRenderingInstance.ce || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.ce) {
    const slotProps = props;
    const hasProps = Object.keys(slotProps).length > 0;
    if (name !== "default") slotProps.name = name;
    return openBlock(), createBlock(
      Fragment,
      null,
      [createVNode("slot", slotProps, fallback && fallback())],
      hasProps ? -2 : 64
    );
  }
  let slot = slots[name];
  if (!!(process.env.NODE_ENV !== "production") && slot && slot.length > 1) {
    warn$1(
      `SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template.`
    );
    slot = () => [];
  }
  if (slot && slot._c) {
    slot._d = false;
  }
  const prevStackSize = blockStack.length;
  openBlock();
  let rendered;
  try {
    const validSlotContent = slot && ensureValidVNode(slot(props));
    const slotKey = props.key || branchKey || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    rendered = createBlock(
      Fragment,
      {
        key: (slotKey && !isSymbol(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
      },
      validSlotContent || (fallback ? fallback() : []),
      validSlotContent && slots._ === 1 ? 64 : -2
    );
  } catch (err) {
    for (let i = blockStack.length; i > prevStackSize; i--) closeBlock();
    throw err;
  } finally {
    if (slot && slot._c) {
      slot._d = true;
    }
  }
  if (!noSlotted && rendered.scopeId) {
    rendered.slotScopeIds = [rendered.scopeId + "-s"];
  }
  return rendered;
}
function ensureValidVNode(vnodes) {
  return vnodes.some((child) => {
    if (!isVNode(child)) return true;
    if (child.type === Comment) return false;
    if (child.type === Fragment && !ensureValidVNode(child.children))
      return false;
    return true;
  }) ? vnodes : null;
}
function toHandlers(obj, preserveCaseIfNecessary) {
  const ret = {};
  if (!!(process.env.NODE_ENV !== "production") && !isObject(obj)) {
    warn$1(`v-on with no argument expects an object value.`);
    return ret;
  }
  for (const key in obj) {
    ret[/[A-Z]/.test(key) ? `on:${key}` : toHandlerKey(key)] = obj[key];
  }
  return ret;
}
const getPublicInstance = (i) => {
  if (!i) return null;
  if (isStatefulComponent(i)) return getComponentPublicInstance(i);
  return getPublicInstance(i.parent);
};
const resolveDevRootEl = (vnode) => {
  let found = false;
  while (true) {
    if (vnode.patchFlag > 0 && vnode.patchFlag & 2048) {
      const root2 = filterSingleRoot(vnode.children);
      if (!root2) {
        return;
      }
      vnode = root2;
      found = true;
      continue;
    }
    const component = vnode.component;
    if (component && component.subTree) {
      vnode = component.subTree;
      continue;
    }
    const suspense = vnode.suspense;
    if (suspense && suspense.activeBranch) {
      vnode = suspense.activeBranch;
      continue;
    }
    return found ? vnode.el : void 0;
  }
};
const getDevRootFragmentEl = (i) => {
  const el = i.subTree && resolveDevRootEl(i.subTree);
  return el === void 0 ? i.vnode.el : el;
};
const publicPropertiesMap = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ extend(/* @__PURE__ */ Object.create(null), {
    $: (i) => i,
    $el: (i) => !!(process.env.NODE_ENV !== "production") ? getDevRootFragmentEl(i) : i.vnode.el,
    $data: (i) => i.data,
    $props: (i) => !!(process.env.NODE_ENV !== "production") ? /* @__PURE__ */ shallowReadonly(i.props) : i.props,
    $attrs: (i) => !!(process.env.NODE_ENV !== "production") ? /* @__PURE__ */ shallowReadonly(i.attrs) : i.attrs,
    $slots: (i) => !!(process.env.NODE_ENV !== "production") ? /* @__PURE__ */ shallowReadonly(i.slots) : i.slots,
    $refs: (i) => !!(process.env.NODE_ENV !== "production") ? /* @__PURE__ */ shallowReadonly(i.refs) : i.refs,
    $parent: (i) => getPublicInstance(i.parent),
    $root: (i) => getPublicInstance(i.root),
    $host: (i) => i.ce,
    $emit: (i) => i.emit,
    $options: (i) => __VUE_OPTIONS_API__ ? resolveMergedOptions(i) : i.type,
    $forceUpdate: (i) => i.f || (i.f = () => {
      queueJob(i.update);
    }),
    $nextTick: (i) => i.n || (i.n = nextTick.bind(i.proxy)),
    $watch: (i) => __VUE_OPTIONS_API__ ? instanceWatch.bind(i) : NOOP
  })
);
const PublicInstanceProxyHandlers = {};
if (!!(process.env.NODE_ENV !== "production") && true) {
  PublicInstanceProxyHandlers.ownKeys = (target) => {
    warn$1(
      `Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.`
    );
    return Reflect.ownKeys(target);
  };
}
function useSlots() {
  return getContext("useSlots").slots;
}
function useAttrs() {
  return getContext("useAttrs").attrs;
}
function getContext(calledFunctionName) {
  const i = getCurrentInstance();
  if (!!(process.env.NODE_ENV !== "production") && !i) {
    warn$1(`${calledFunctionName}() called without active instance.`);
  }
  return i.setupContext || (i.setupContext = createSetupContext(i));
}
function normalizePropsOrEmits(props) {
  return isArray(props) ? props.reduce(
    (normalized, p) => (normalized[p] = null, normalized),
    {}
  ) : props;
}
function mergeDefaults(raw, defaults) {
  const props = normalizePropsOrEmits(raw);
  for (const key in defaults) {
    if (key.startsWith("__skip")) continue;
    let opt = props[key];
    if (opt) {
      if (isArray(opt) || isFunction(opt)) {
        opt = props[key] = { type: opt, default: defaults[key] };
      } else {
        opt.default = defaults[key];
      }
    } else if (opt === null) {
      opt = props[key] = { default: defaults[key] };
    } else if (!!(process.env.NODE_ENV !== "production")) {
      warn$1(`props default key "${key}" has no corresponding declaration.`);
    }
    if (opt && defaults[`__skip_${key}`]) {
      opt.skipFactory = true;
    }
  }
  return props;
}
function resolveMergedOptions(instance) {
  const base = instance.type;
  const { mixins, extends: extendsOptions } = base;
  const {
    mixins: globalMixins,
    optionsCache: cache2,
    config: { optionMergeStrategies }
  } = instance.appContext;
  const cached2 = cache2.get(base);
  let resolved;
  if (cached2) {
    resolved = cached2;
  } else if (!globalMixins.length && !mixins && !extendsOptions) {
    {
      resolved = base;
    }
  } else {
    resolved = {};
    if (globalMixins.length) {
      globalMixins.forEach(
        (m) => mergeOptions(resolved, m, optionMergeStrategies, true)
      );
    }
    mergeOptions(resolved, base, optionMergeStrategies);
  }
  if (isObject(base)) {
    cache2.set(base, resolved);
  }
  return resolved;
}
function mergeOptions(to2, from2, strats, asMixin = false) {
  const { mixins, extends: extendsOptions } = from2;
  if (extendsOptions) {
    mergeOptions(to2, extendsOptions, strats, true);
  }
  if (mixins) {
    mixins.forEach(
      (m) => mergeOptions(to2, m, strats, true)
    );
  }
  for (const key in from2) {
    if (asMixin && key === "expose") {
      !!(process.env.NODE_ENV !== "production") && warn$1(
        `"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.`
      );
    } else {
      const strat = internalOptionMergeStrats[key] || strats && strats[key];
      to2[key] = strat ? strat(to2[key], from2[key]) : from2[key];
    }
  }
  return to2;
}
const internalOptionMergeStrats = {
  data: mergeDataFn,
  props: mergeEmitsOrPropsOptions,
  emits: mergeEmitsOrPropsOptions,
  // objects
  methods: mergeObjectOptions,
  computed: mergeObjectOptions,
  // lifecycle
  beforeCreate: mergeAsArray,
  created: mergeAsArray,
  beforeMount: mergeAsArray,
  mounted: mergeAsArray,
  beforeUpdate: mergeAsArray,
  updated: mergeAsArray,
  beforeDestroy: mergeAsArray,
  beforeUnmount: mergeAsArray,
  destroyed: mergeAsArray,
  unmounted: mergeAsArray,
  activated: mergeAsArray,
  deactivated: mergeAsArray,
  errorCaptured: mergeAsArray,
  serverPrefetch: mergeAsArray,
  // assets
  components: mergeObjectOptions,
  directives: mergeObjectOptions,
  // watch
  watch: mergeWatchOptions,
  // provide / inject
  provide: mergeDataFn,
  inject: mergeInject
};
function mergeDataFn(to2, from2) {
  if (!from2) {
    return to2;
  }
  if (!to2) {
    return from2;
  }
  return function mergedDataFn() {
    return extend(
      isFunction(to2) ? to2.call(this, this) : to2,
      isFunction(from2) ? from2.call(this, this) : from2
    );
  };
}
function mergeInject(to2, from2) {
  return mergeObjectOptions(normalizeInject(to2), normalizeInject(from2));
}
function normalizeInject(raw) {
  if (isArray(raw)) {
    const res = {};
    for (let i = 0; i < raw.length; i++) {
      res[raw[i]] = raw[i];
    }
    return res;
  }
  return raw;
}
function mergeAsArray(to2, from2) {
  return to2 ? [...new Set([].concat(to2, from2))] : from2;
}
function mergeObjectOptions(to2, from2) {
  return to2 ? extend(/* @__PURE__ */ Object.create(null), to2, from2) : from2;
}
function mergeEmitsOrPropsOptions(to2, from2) {
  if (to2) {
    if (isArray(to2) && isArray(from2)) {
      return [.../* @__PURE__ */ new Set([...to2, ...from2])];
    }
    return extend(
      /* @__PURE__ */ Object.create(null),
      normalizePropsOrEmits(to2),
      normalizePropsOrEmits(from2 != null ? from2 : {})
    );
  } else {
    return from2;
  }
}
function mergeWatchOptions(to2, from2) {
  if (!to2) return from2;
  if (!from2) return to2;
  const merged = extend(/* @__PURE__ */ Object.create(null), to2);
  for (const key in from2) {
    merged[key] = mergeAsArray(to2[key], from2[key]);
  }
  return merged;
}
let currentApp = null;
function filterSingleRoot(children, recurse = true) {
  let singleRoot;
  for (let i = 0; i < children.length; i++) {
    const child = children[i];
    if (isVNode(child)) {
      if (child.type !== Comment || child.children === "v-if") {
        if (singleRoot) {
          return;
        } else {
          singleRoot = child;
          if (!!(process.env.NODE_ENV !== "production") && recurse && singleRoot.patchFlag > 0 && singleRoot.patchFlag & 2048) {
            return filterSingleRoot(singleRoot.children);
          }
        }
      }
    } else {
      return;
    }
  }
  return singleRoot;
}
const internalObjectProto = {};
const isInternalObject = (obj) => Object.getPrototypeOf(obj) === internalObjectProto;
const queuePostRenderEffect = queueEffectWithSuspense;
function traverseStaticChildren(n12, n22, shallow = false) {
  const ch1 = n12.children;
  const ch2 = n22.children;
  if (isArray(ch1) && isArray(ch2)) {
    for (let i = 0; i < ch1.length; i++) {
      const c1 = ch1[i];
      let c22 = ch2[i];
      if (c22.shapeFlag & 1 && !c22.dynamicChildren) {
        if (c22.patchFlag <= 0 || c22.patchFlag === 32) {
          c22 = ch2[i] = cloneIfMounted(ch2[i]);
          c22.el = c1.el;
        }
        if (!shallow && c22.patchFlag !== -2)
          traverseStaticChildren(c1, c22);
      }
      if (c22.type === Text) {
        if (c22.patchFlag === -1) {
          c22 = ch2[i] = cloneIfMounted(c22);
        }
        c22.el = c1.el;
      }
      if (c22.type === Comment && !c22.el) {
        c22.el = c1.el;
      }
      if (!!(process.env.NODE_ENV !== "production")) {
        c22.el && (c22.el.__vnode = c22);
      }
    }
  }
}
const isSuspense = (type) => type.__isSuspense;
function queueEffectWithSuspense(fn3, suspense) {
  if (suspense && suspense.pendingBranch) {
    if (isArray(fn3)) {
      suspense.effects.push(...fn3);
    } else {
      suspense.effects.push(fn3);
    }
  } else {
    queuePostFlushCb(fn3);
  }
}
const Fragment = /* @__PURE__ */ Symbol.for("v-fgt");
const Text = /* @__PURE__ */ Symbol.for("v-txt");
const Comment = /* @__PURE__ */ Symbol.for("v-cmt");
const blockStack = [];
let currentBlock = null;
function openBlock(disableTracking = false) {
  blockStack.push(currentBlock = disableTracking ? null : []);
}
function closeBlock() {
  blockStack.pop();
  currentBlock = blockStack[blockStack.length - 1] || null;
}
let isBlockTreeEnabled = 1;
function setBlockTracking(value, inVOnce = false) {
  isBlockTreeEnabled += value;
  if (value < 0 && currentBlock && inVOnce) {
    currentBlock.hasOnce = true;
  }
}
function setupBlock(vnode) {
  vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || EMPTY_ARR : null;
  closeBlock();
  if (isBlockTreeEnabled > 0 && currentBlock) {
    currentBlock.push(vnode);
  }
  return vnode;
}
function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
  return setupBlock(
    createBaseVNode(
      type,
      props,
      children,
      patchFlag,
      dynamicProps,
      shapeFlag,
      true
    )
  );
}
function createBlock(type, props, children, patchFlag, dynamicProps) {
  return setupBlock(
    createVNode(
      type,
      props,
      children,
      patchFlag,
      dynamicProps,
      true
    )
  );
}
function isVNode(value) {
  return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n12, n22) {
  if (!!(process.env.NODE_ENV !== "production") && n22.shapeFlag & 6 && n12.component) {
    const dirtyInstances = hmrDirtyComponents.get(n22.type);
    if (dirtyInstances && dirtyInstances.has(n12.component)) {
      n12.shapeFlag &= -257;
      n22.shapeFlag &= -513;
      return false;
    }
  }
  return n12.type === n22.type && n12.key === n22.key;
}
const createVNodeWithArgsTransform = (...args) => {
  return _createVNode(
    ...args
  );
};
const normalizeKey = ({ key }) => key != null ? key : null;
const normalizeRef = ({
  ref: ref2,
  ref_key,
  ref_for
}) => {
  if (typeof ref2 === "number") {
    ref2 = "" + ref2;
  }
  return ref2 != null ? isString(ref2) || /* @__PURE__ */ isRef(ref2) || isFunction(ref2) ? { i: currentRenderingInstance, r: ref2, k: ref_key, f: !!ref_for } : ref2 : null;
};
function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
  const vnode = {
    __v_isVNode: true,
    __v_skip: true,
    type,
    props,
    key: props && normalizeKey(props),
    ref: props && normalizeRef(props),
    scopeId: currentScopeId,
    slotScopeIds: null,
    children,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag,
    patchFlag,
    dynamicProps,
    dynamicChildren: null,
    appContext: null,
    ctx: currentRenderingInstance
  };
  if (needFullChildrenNormalization) {
    normalizeChildren(vnode, children);
    if (shapeFlag & 128) {
      type.normalize(vnode);
    }
  } else if (children) {
    vnode.shapeFlag |= isString(children) ? 8 : 16;
  }
  if (!!(process.env.NODE_ENV !== "production") && vnode.key !== vnode.key) {
    warn$1(`VNode created with invalid key (NaN). VNode type:`, vnode.type);
  }
  if (!!(process.env.NODE_ENV !== "production") && props && vnode.shapeFlag & 1) {
    const overwritingProp = props.innerHTML != null ? "innerHTML" : props.textContent != null ? "textContent" : null;
    if (overwritingProp && hasContentChildren(vnode.children)) {
      warn$1(
        `The \`${overwritingProp}\` prop on <${vnode.type}> will override its children. Remove either the \`${overwritingProp}\` prop or the children.`
      );
    }
  }
  if (isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
  !isBlockNode && // has current parent block
  currentBlock && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  vnode.patchFlag !== 32) {
    currentBlock.push(vnode);
  }
  return vnode;
}
function hasContentChildren(children) {
  if (isString(children)) return children !== "";
  if (isArray(children)) return children.length > 0;
  return false;
}
const createVNode = !!(process.env.NODE_ENV !== "production") ? createVNodeWithArgsTransform : _createVNode;
function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
  if (!type || type === NULL_DYNAMIC_COMPONENT) {
    if (!!(process.env.NODE_ENV !== "production") && !type) {
      warn$1(`Invalid vnode type when creating vnode: ${type}.`);
    }
    type = Comment;
  }
  if (isVNode(type)) {
    const cloned = cloneVNode(
      type,
      props,
      true
      /* mergeRef: true */
    );
    if (children) {
      normalizeChildren(cloned, children);
    }
    if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
      if (cloned.shapeFlag & 6) {
        currentBlock[currentBlock.indexOf(type)] = cloned;
      } else {
        currentBlock.push(cloned);
      }
    }
    cloned.patchFlag = -2;
    return cloned;
  }
  if (isClassComponent(type)) {
    type = type.__vccOpts;
  }
  if (props) {
    props = guardReactiveProps(props);
    let { class: klass, style: style2 } = props;
    if (klass && !isString(klass)) {
      props.class = normalizeClass(klass);
    }
    if (isObject(style2)) {
      if (/* @__PURE__ */ isProxy(style2) && !isArray(style2)) {
        style2 = extend({}, style2);
      }
      props.style = normalizeStyle(style2);
    }
  }
  const shapeFlag = isString(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : isObject(type) ? 4 : isFunction(type) ? 2 : 0;
  if (!!(process.env.NODE_ENV !== "production") && shapeFlag & 4 && /* @__PURE__ */ isProxy(type)) {
    type = /* @__PURE__ */ toRaw(type);
    warn$1(
      `Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with \`markRaw\` or using \`shallowRef\` instead of \`ref\`.`,
      `
Component that was made reactive: `,
      type
    );
  }
  return createBaseVNode(
    type,
    props,
    children,
    patchFlag,
    dynamicProps,
    shapeFlag,
    isBlockNode,
    true
  );
}
function guardReactiveProps(props) {
  if (!props) return null;
  return /* @__PURE__ */ isProxy(props) || isInternalObject(props) ? extend({}, props) : props;
}
function cloneVNode(vnode, extraProps, mergeRef = false, cloneTransition = false) {
  const { props, ref: ref2, patchFlag, children, transition } = vnode;
  const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
  const cloned = {
    __v_isVNode: true,
    __v_skip: true,
    type: vnode.type,
    props: mergedProps,
    key: mergedProps && normalizeKey(mergedProps),
    ref: extraProps && extraProps.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      mergeRef && ref2 ? isArray(ref2) ? ref2.concat(normalizeRef(extraProps)) : [ref2, normalizeRef(extraProps)] : normalizeRef(extraProps)
    ) : ref2,
    scopeId: vnode.scopeId,
    slotScopeIds: vnode.slotScopeIds,
    children: !!(process.env.NODE_ENV !== "production") && patchFlag === -1 && isArray(children) ? children.map(deepCloneVNode) : children,
    target: vnode.target,
    targetStart: vnode.targetStart,
    targetAnchor: vnode.targetAnchor,
    staticCount: vnode.staticCount,
    shapeFlag: vnode.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
    dynamicProps: vnode.dynamicProps,
    dynamicChildren: vnode.dynamicChildren,
    appContext: vnode.appContext,
    dirs: vnode.dirs,
    transition,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: vnode.component,
    suspense: vnode.suspense,
    ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
    ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
    placeholder: vnode.placeholder,
    el: vnode.el,
    anchor: vnode.anchor,
    ctx: vnode.ctx,
    ce: vnode.ce,
    cacheIndex: vnode.cacheIndex
  };
  if (transition && cloneTransition) {
    setTransitionHooks(
      cloned,
      transition.clone(cloned)
    );
  }
  return cloned;
}
function deepCloneVNode(vnode) {
  const cloned = cloneVNode(vnode);
  if (isArray(vnode.children)) {
    cloned.children = vnode.children.map(deepCloneVNode);
  }
  return cloned;
}
function createTextVNode(text = " ", flag = 0) {
  return createVNode(Text, null, text, flag);
}
function createCommentVNode(text = "", asBlock = false) {
  return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
}
function cloneIfMounted(child) {
  return child.el === null && child.patchFlag !== -1 || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
  let type = 0;
  const { shapeFlag } = vnode;
  if (children == null) {
    children = null;
  } else if (isArray(children)) {
    type = 16;
  } else if (typeof children === "object") {
    if (shapeFlag & (1 | 64)) {
      const slot = children.default;
      if (slot) {
        slot._c && (slot._d = false);
        normalizeChildren(vnode, slot());
        slot._c && (slot._d = true);
      }
      return;
    } else {
      type = 32;
      const slotFlag = children._;
      if (!slotFlag && !isInternalObject(children)) {
        children._ctx = currentRenderingInstance;
      } else if (slotFlag === 3 && currentRenderingInstance) {
        if (currentRenderingInstance.slots._ === 1) {
          children._ = 1;
        } else {
          children._ = 2;
          vnode.patchFlag |= 1024;
        }
      }
    }
  } else if (isFunction(children)) {
    if (shapeFlag & (1 | 64)) {
      normalizeChildren(vnode, { default: children });
      return;
    }
    children = { default: children, _ctx: currentRenderingInstance };
    type = 32;
  } else {
    children = String(children);
    if (shapeFlag & 64) {
      type = 16;
      children = [createTextVNode(children)];
    } else {
      type = 8;
    }
  }
  vnode.children = children;
  vnode.shapeFlag |= type;
}
function mergeProps(...args) {
  const ret = {};
  for (let i = 0; i < args.length; i++) {
    const toMerge = args[i];
    for (const key in toMerge) {
      if (key === "class") {
        if (ret.class !== toMerge.class) {
          ret.class = normalizeClass([ret.class, toMerge.class]);
        }
      } else if (key === "style") {
        ret.style = normalizeStyle([ret.style, toMerge.style]);
      } else if (isOn(key)) {
        const existing = ret[key];
        const incoming = toMerge[key];
        if (incoming && existing !== incoming && !(isArray(existing) && existing.includes(incoming))) {
          ret[key] = existing ? [].concat(existing, incoming) : incoming;
        } else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
        // the model listener.
        !isModelListener(key)) {
          ret[key] = incoming;
        }
      } else if (key !== "") {
        ret[key] = toMerge[key];
      }
    }
  }
  return ret;
}
let currentInstance = null;
const getCurrentInstance = () => currentInstance || currentRenderingInstance;
let internalSetCurrentInstance;
{
  const g = getGlobalThis();
  const registerGlobalSetter = (key, setter) => {
    let setters;
    if (!(setters = g[key])) setters = g[key] = [];
    setters.push(setter);
    return (v) => {
      if (setters.length > 1) setters.forEach((set) => set(v));
      else setters[0](v);
    };
  };
  internalSetCurrentInstance = registerGlobalSetter(
    `__VUE_INSTANCE_SETTERS__`,
    (v) => currentInstance = v
  );
  registerGlobalSetter(
    `__VUE_SSR_SETTERS__`,
    (v) => isInSSRComponentSetup = v
  );
}
const setCurrentInstance = (instance) => {
  const prev2 = currentInstance;
  internalSetCurrentInstance(instance);
  instance.scope.on();
  return () => {
    instance.scope.off();
    internalSetCurrentInstance(prev2);
  };
};
function isStatefulComponent(instance) {
  return instance.vnode.shapeFlag & 4;
}
let isInSSRComponentSetup = false;
const attrsProxyHandlers = !!(process.env.NODE_ENV !== "production") ? {
  get(target, key) {
    track(target, "get", "");
    return target[key];
  },
  set() {
    warn$1(`setupContext.attrs is readonly.`);
    return false;
  },
  deleteProperty() {
    warn$1(`setupContext.attrs is readonly.`);
    return false;
  }
} : {
  get(target, key) {
    track(target, "get", "");
    return target[key];
  }
};
function getSlotsProxy(instance) {
  return new Proxy(instance.slots, {
    get(target, key) {
      track(instance, "get", "$slots");
      return target[key];
    }
  });
}
function createSetupContext(instance) {
  const expose = (exposed) => {
    if (!!(process.env.NODE_ENV !== "production")) {
      if (instance.exposed) {
        warn$1(`expose() should be called only once per setup().`);
      }
      if (exposed != null) {
        let exposedType = typeof exposed;
        if (exposedType === "object") {
          if (isArray(exposed)) {
            exposedType = "array";
          } else if (/* @__PURE__ */ isRef(exposed)) {
            exposedType = "ref";
          }
        }
        if (exposedType !== "object") {
          warn$1(
            `expose() should be passed a plain object, received ${exposedType}.`
          );
        }
      }
    }
    instance.exposed = exposed || {};
  };
  if (!!(process.env.NODE_ENV !== "production")) {
    let attrsProxy;
    let slotsProxy;
    return Object.freeze({
      get attrs() {
        return attrsProxy || (attrsProxy = new Proxy(instance.attrs, attrsProxyHandlers));
      },
      get slots() {
        return slotsProxy || (slotsProxy = getSlotsProxy(instance));
      },
      get emit() {
        return (event2, ...args) => instance.emit(event2, ...args);
      },
      expose
    });
  } else {
    return {
      attrs: new Proxy(instance.attrs, attrsProxyHandlers),
      slots: instance.slots,
      emit: instance.emit,
      expose
    };
  }
}
function getComponentPublicInstance(instance) {
  if (instance.exposed) {
    return instance.exposeProxy || (instance.exposeProxy = new Proxy(proxyRefs(markRaw(instance.exposed)), {
      get(target, key) {
        if (key in target) {
          return target[key];
        } else if (key in publicPropertiesMap) {
          return publicPropertiesMap[key](instance);
        }
      },
      has(target, key) {
        return key in target || key in publicPropertiesMap;
      }
    }));
  } else {
    return instance.proxy;
  }
}
const classifyRE = /(?:^|[-_])\w/g;
const classify = (str) => str.replace(classifyRE, (c) => c.toUpperCase()).replace(/[-_]/g, "");
function getComponentName(Component, includeInferred = true) {
  return isFunction(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function formatComponentName(instance, Component, isRoot = false) {
  let name = getComponentName(Component);
  if (!name && Component.__file) {
    const match2 = Component.__file.match(/([^/\\]+)\.\w+$/);
    if (match2) {
      name = match2[1];
    }
  }
  if (!name && instance) {
    const inferFromRegistry = (registry) => {
      for (const key in registry) {
        if (registry[key] === Component) {
          return key;
        }
      }
    };
    name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(
      instance.parent.type.components
    ) || inferFromRegistry(instance.appContext.components);
  }
  return name ? classify(name) : isRoot ? `App` : `Anonymous`;
}
function isClassComponent(value) {
  return isFunction(value) && "__vccOpts" in value;
}
const computed = (getterOrOptions, debugOptions) => {
  const c = /* @__PURE__ */ computed$1(getterOrOptions, debugOptions, isInSSRComponentSetup);
  if (!!(process.env.NODE_ENV !== "production")) {
    const i = getCurrentInstance();
    if (i && i.appContext.config.warnRecursiveComputed) {
      c._warnRecursive = true;
    }
  }
  return c;
};
function h(type, propsOrChildren, children) {
  try {
    setBlockTracking(-1);
    const l2 = arguments.length;
    if (l2 === 2) {
      if (isObject(propsOrChildren) && !isArray(propsOrChildren)) {
        if (isVNode(propsOrChildren)) {
          return createVNode(type, null, [propsOrChildren]);
        }
        return createVNode(type, propsOrChildren);
      } else {
        return createVNode(type, null, propsOrChildren);
      }
    } else {
      if (l2 > 3) {
        children = Array.prototype.slice.call(arguments, 2);
      } else if (l2 === 3 && isVNode(children)) {
        children = [children];
      }
      return createVNode(type, propsOrChildren, children);
    }
  } finally {
    setBlockTracking(1);
  }
}
function initCustomFormatter() {
  if (!!!(process.env.NODE_ENV !== "production") || typeof window === "undefined") {
    return;
  }
  const vueStyle = { style: "color:#3ba776" };
  const numberStyle = { style: "color:#1677ff" };
  const stringStyle = { style: "color:#f5222d" };
  const keywordStyle = { style: "color:#eb2f96" };
  const formatter = {
    __vue_custom_formatter: true,
    header(obj) {
      if (!isObject(obj)) {
        return null;
      }
      if (obj.__isVue) {
        return ["div", vueStyle, `VueInstance`];
      } else if (/* @__PURE__ */ isRef(obj)) {
        pauseTracking();
        const value = obj.value;
        resetTracking();
        return [
          "div",
          {},
          ["span", vueStyle, genRefFlag(obj)],
          "<",
          formatValue(value),
          `>`
        ];
      } else if (/* @__PURE__ */ isReactive(obj)) {
        return [
          "div",
          {},
          ["span", vueStyle, /* @__PURE__ */ isShallow(obj) ? "ShallowReactive" : "Reactive"],
          "<",
          formatValue(obj),
          `>${/* @__PURE__ */ isReadonly(obj) ? ` (readonly)` : ``}`
        ];
      } else if (/* @__PURE__ */ isReadonly(obj)) {
        return [
          "div",
          {},
          ["span", vueStyle, /* @__PURE__ */ isShallow(obj) ? "ShallowReadonly" : "Readonly"],
          "<",
          formatValue(obj),
          ">"
        ];
      }
      return null;
    },
    hasBody(obj) {
      return obj && obj.__isVue;
    },
    body(obj) {
      if (obj && obj.__isVue) {
        return [
          "div",
          {},
          ...formatInstance(obj.$)
        ];
      }
    }
  };
  function formatInstance(instance) {
    const blocks = [];
    if (instance.type.props && instance.props) {
      blocks.push(createInstanceBlock("props", /* @__PURE__ */ toRaw(instance.props)));
    }
    if (instance.setupState !== EMPTY_OBJ) {
      blocks.push(createInstanceBlock("setup", instance.setupState));
    }
    if (instance.data !== EMPTY_OBJ) {
      blocks.push(createInstanceBlock("data", /* @__PURE__ */ toRaw(instance.data)));
    }
    const computed2 = extractKeys(instance, "computed");
    if (computed2) {
      blocks.push(createInstanceBlock("computed", computed2));
    }
    const injected = extractKeys(instance, "inject");
    if (injected) {
      blocks.push(createInstanceBlock("injected", injected));
    }
    blocks.push([
      "div",
      {},
      [
        "span",
        {
          style: keywordStyle.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: instance }]
    ]);
    return blocks;
  }
  function createInstanceBlock(type, target) {
    target = extend({}, target);
    if (!Object.keys(target).length) {
      return ["span", {}];
    }
    return [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        type
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(target).map((key) => {
          return [
            "div",
            {},
            ["span", keywordStyle, key + ": "],
            formatValue(target[key], false)
          ];
        })
      ]
    ];
  }
  function formatValue(v, asRaw = true) {
    if (typeof v === "number") {
      return ["span", numberStyle, v];
    } else if (typeof v === "string") {
      return ["span", stringStyle, JSON.stringify(v)];
    } else if (typeof v === "boolean") {
      return ["span", keywordStyle, v];
    } else if (isObject(v)) {
      return ["object", { object: asRaw ? /* @__PURE__ */ toRaw(v) : v }];
    } else {
      return ["span", stringStyle, String(v)];
    }
  }
  function extractKeys(instance, type) {
    const Comp = instance.type;
    if (isFunction(Comp)) {
      return;
    }
    const extracted = {};
    for (const key in instance.ctx) {
      if (isKeyOfType(Comp, key, type)) {
        extracted[key] = instance.ctx[key];
      }
    }
    return extracted;
  }
  function isKeyOfType(Comp, key, type) {
    const opts = Comp[type];
    if (isArray(opts) && opts.includes(key) || isObject(opts) && key in opts) {
      return true;
    }
    if (Comp.extends && isKeyOfType(Comp.extends, key, type)) {
      return true;
    }
    if (Comp.mixins && Comp.mixins.some((m) => isKeyOfType(m, key, type))) {
      return true;
    }
  }
  function genRefFlag(v) {
    if (/* @__PURE__ */ isShallow(v)) {
      return `ShallowRef`;
    }
    if (v.effect) {
      return `ComputedRef`;
    }
    return `Ref`;
  }
  if (window.devtoolsFormatters) {
    window.devtoolsFormatters.push(formatter);
  } else {
    window.devtoolsFormatters = [formatter];
  }
}
const warn = !!(process.env.NODE_ENV !== "production") ? warn$1 : NOOP;
!!(process.env.NODE_ENV !== "production") || true ? devtools$1 : void 0;
!!(process.env.NODE_ENV !== "production") || true ? setDevtoolsHook$1 : NOOP;
let policy = void 0;
const tt = typeof window !== "undefined" && window.trustedTypes;
if (tt) {
  try {
    policy = /* @__PURE__ */ tt.createPolicy("vue", {
      createHTML: (val) => val
    });
  } catch (e) {
    !!(process.env.NODE_ENV !== "production") && warn(`Error creating trusted types policy: ${e}`);
  }
}
const TRANSITION = "transition";
const ANIMATION = "animation";
const vtcKey = /* @__PURE__ */ Symbol("_vtc");
const DOMTransitionPropsValidators = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: true
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
};
const TransitionPropsValidators = /* @__PURE__ */ extend(
  {},
  BaseTransitionPropsValidators,
  DOMTransitionPropsValidators
);
const decorate$1 = (t16) => {
  t16.displayName = "Transition";
  t16.props = TransitionPropsValidators;
  return t16;
};
const Transition = /* @__PURE__ */ decorate$1(
  (props, { slots }) => h(BaseTransition, resolveTransitionProps(props), slots)
);
const callHook = (hook, args = []) => {
  if (isArray(hook)) {
    hook.forEach((h22) => h22(...args));
  } else if (hook) {
    hook(...args);
  }
};
const hasExplicitCallback = (hook) => {
  return hook ? isArray(hook) ? hook.some((h22) => h22.length > 1) : hook.length > 1 : false;
};
function resolveTransitionProps(rawProps) {
  const baseProps = {};
  for (const key in rawProps) {
    if (!(key in DOMTransitionPropsValidators)) {
      baseProps[key] = rawProps[key];
    }
  }
  if (rawProps.css === false) {
    return baseProps;
  }
  const {
    name = "v",
    type,
    duration: duration2,
    enterFromClass = `${name}-enter-from`,
    enterActiveClass = `${name}-enter-active`,
    enterToClass = `${name}-enter-to`,
    appearFromClass = enterFromClass,
    appearActiveClass = enterActiveClass,
    appearToClass = enterToClass,
    leaveFromClass = `${name}-leave-from`,
    leaveActiveClass = `${name}-leave-active`,
    leaveToClass = `${name}-leave-to`
  } = rawProps;
  const durations = normalizeDuration(duration2);
  const enterDuration = durations && durations[0];
  const leaveDuration = durations && durations[1];
  const {
    onBeforeEnter,
    onEnter,
    onEnterCancelled,
    onLeave,
    onLeaveCancelled,
    onBeforeAppear = onBeforeEnter,
    onAppear = onEnter,
    onAppearCancelled = onEnterCancelled
  } = baseProps;
  const finishEnter = (el, isAppear, done, isCancelled) => {
    el._enterCancelled = isCancelled;
    removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
    removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
    done && done();
  };
  const finishLeave = (el, done) => {
    el._isLeaving = false;
    removeTransitionClass(el, leaveFromClass);
    removeTransitionClass(el, leaveToClass);
    removeTransitionClass(el, leaveActiveClass);
    done && done();
  };
  const makeEnterHook = (isAppear) => {
    return (el, done) => {
      const hook = isAppear ? onAppear : onEnter;
      const resolve2 = () => finishEnter(el, isAppear, done);
      callHook(hook, [el, resolve2]);
      nextFrame(() => {
        removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
        addTransitionClass(el, isAppear ? appearToClass : enterToClass);
        if (!hasExplicitCallback(hook)) {
          whenTransitionEnds(el, type, enterDuration, resolve2);
        }
      });
    };
  };
  return extend(baseProps, {
    onBeforeEnter(el) {
      callHook(onBeforeEnter, [el]);
      addTransitionClass(el, enterFromClass);
      addTransitionClass(el, enterActiveClass);
    },
    onBeforeAppear(el) {
      callHook(onBeforeAppear, [el]);
      addTransitionClass(el, appearFromClass);
      addTransitionClass(el, appearActiveClass);
    },
    onEnter: makeEnterHook(false),
    onAppear: makeEnterHook(true),
    onLeave(el, done) {
      el._isLeaving = true;
      const resolve2 = () => finishLeave(el, done);
      addTransitionClass(el, leaveFromClass);
      if (!el._enterCancelled) {
        forceReflow2(el);
        addTransitionClass(el, leaveActiveClass);
      } else {
        addTransitionClass(el, leaveActiveClass);
        forceReflow2(el);
      }
      nextFrame(() => {
        if (!el._isLeaving) {
          return;
        }
        removeTransitionClass(el, leaveFromClass);
        addTransitionClass(el, leaveToClass);
        if (!hasExplicitCallback(onLeave)) {
          whenTransitionEnds(el, type, leaveDuration, resolve2);
        }
      });
      callHook(onLeave, [el, resolve2]);
    },
    onEnterCancelled(el) {
      finishEnter(el, false, void 0, true);
      callHook(onEnterCancelled, [el]);
    },
    onAppearCancelled(el) {
      finishEnter(el, true, void 0, true);
      callHook(onAppearCancelled, [el]);
    },
    onLeaveCancelled(el) {
      finishLeave(el);
      callHook(onLeaveCancelled, [el]);
    }
  });
}
function normalizeDuration(duration2) {
  if (duration2 == null) {
    return null;
  } else if (isObject(duration2)) {
    return [NumberOf(duration2.enter), NumberOf(duration2.leave)];
  } else {
    const n12 = NumberOf(duration2);
    return [n12, n12];
  }
}
function NumberOf(val) {
  const res = toNumber(val);
  if (!!(process.env.NODE_ENV !== "production")) {
    assertNumber(res, "<transition> explicit duration");
  }
  return res;
}
function addTransitionClass(el, cls) {
  cls.split(/\s+/).forEach((c) => c && el.classList.add(c));
  (el[vtcKey] || (el[vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function removeTransitionClass(el, cls) {
  cls.split(/\s+/).forEach((c) => c && el.classList.remove(c));
  const _vtc = el[vtcKey];
  if (_vtc) {
    _vtc.delete(cls);
    if (!_vtc.size) {
      el[vtcKey] = void 0;
    }
  }
}
function nextFrame(cb2) {
  requestAnimationFrame(() => {
    requestAnimationFrame(cb2);
  });
}
let endId = 0;
function whenTransitionEnds(el, expectedType, explicitTimeout, resolve2) {
  const id = el._endId = ++endId;
  const resolveIfNotStale = () => {
    if (id === el._endId) {
      resolve2();
    }
  };
  if (explicitTimeout != null) {
    return setTimeout(resolveIfNotStale, explicitTimeout);
  }
  const { type, timeout: timeout2, propCount } = getTransitionInfo(el, expectedType);
  if (!type) {
    return resolve2();
  }
  const endEvent = type + "end";
  let ended = 0;
  const end2 = () => {
    el.removeEventListener(endEvent, onEnd);
    resolveIfNotStale();
  };
  const onEnd = (e) => {
    if (e.target === el && ++ended >= propCount) {
      end2();
    }
  };
  setTimeout(() => {
    if (ended < propCount) {
      end2();
    }
  }, timeout2 + 1);
  el.addEventListener(endEvent, onEnd);
}
function getTransitionInfo(el, expectedType) {
  const styles2 = window.getComputedStyle(el);
  const getStyleProperties = (key) => (styles2[key] || "").split(", ");
  const transitionDelays = getStyleProperties(`${TRANSITION}Delay`);
  const transitionDurations = getStyleProperties(`${TRANSITION}Duration`);
  const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  const animationDelays = getStyleProperties(`${ANIMATION}Delay`);
  const animationDurations = getStyleProperties(`${ANIMATION}Duration`);
  const animationTimeout = getTimeout(animationDelays, animationDurations);
  let type = null;
  let timeout2 = 0;
  let propCount = 0;
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout2 = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout2 = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout2 = Math.max(transitionTimeout, animationTimeout);
    type = timeout2 > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
    propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
  }
  const hasTransform = type === TRANSITION && /\b(?:transform|all)(?:,|$)/.test(
    getStyleProperties(`${TRANSITION}Property`).toString()
  );
  return {
    type,
    timeout: timeout2,
    propCount,
    hasTransform
  };
}
function getTimeout(delays, durations) {
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }
  return Math.max(...durations.map((d, i) => toMs(d) + toMs(delays[i])));
}
function toMs(s12) {
  if (s12 === "auto") return 0;
  return Number(s12.slice(0, -1).replace(",", ".")) * 1e3;
}
function forceReflow2(el) {
  const targetDocument = el ? el.ownerDocument : document;
  return targetDocument.body.offsetHeight;
}
/* @__PURE__ */ Symbol(!!(process.env.NODE_ENV !== "production") ? "CSS_VAR_TEXT" : "");
function addEventListener(el, event2, handler, options) {
  el.addEventListener(event2, handler, options);
}
const getModelAssigner = (vnode) => {
  const fn3 = vnode.props["onUpdate:modelValue"] || false;
  return isArray(fn3) ? (value) => invokeArrayFns(fn3, value) : fn3;
};
function onCompositionStart(e) {
  e.target.composing = true;
}
function onCompositionEnd(e) {
  const target = e.target;
  if (target.composing) {
    target.composing = false;
    target.dispatchEvent(new Event("input"));
  }
}
const assignKey = /* @__PURE__ */ Symbol("_assign");
const initialValueKey = /* @__PURE__ */ Symbol("_initialValue");
function castValue(value, trim2, number) {
  if (trim2) value = value.trim();
  if (number) value = looseToNumber(value);
  return value;
}
const vModelText = {
  created(el, { modifiers: { lazy, trim: trim2, number } }, vnode) {
    if (el.parentNode) {
      if (el.type === "text") {
        el[initialValueKey] = el.defaultValue.replace(/[\r\n]/g, "");
      } else if (el.type === "textarea") {
        el[initialValueKey] = el.defaultValue.replace(/\r\n?/g, "\n");
      }
    }
    el[assignKey] = getModelAssigner(vnode);
    const castToNumber = number || vnode.props && vnode.props.type === "number";
    addEventListener(el, lazy ? "change" : "input", (e) => {
      if (e.target.composing) return;
      el[assignKey](castValue(el.value, trim2, castToNumber));
    });
    if (trim2 || castToNumber) {
      addEventListener(el, "change", () => {
        el.value = castValue(el.value, trim2, castToNumber);
      });
    }
    if (!lazy) {
      addEventListener(el, "compositionstart", onCompositionStart);
      addEventListener(el, "compositionend", onCompositionEnd);
      addEventListener(el, "change", onCompositionEnd);
    }
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(el, { value, modifiers: { trim: trim2, number } }) {
    const newValue = value == null ? "" : value;
    const initialValue = el[initialValueKey];
    delete el[initialValueKey];
    if (initialValue !== void 0 && (el.type === "text" || el.type === "textarea") && el.value !== initialValue) {
      el[assignKey](castValue(el.value, trim2, number));
    } else {
      el.value = newValue;
    }
  },
  beforeUpdate(el, { value, oldValue, modifiers: { lazy, trim: trim2, number } }, vnode) {
    el[assignKey] = getModelAssigner(vnode);
    if (el.composing) return;
    const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? looseToNumber(el.value) : el.value;
    const newValue = value == null ? "" : value;
    if (elValue === newValue) {
      return;
    }
    const rootNode = el.getRootNode();
    if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
      if (lazy && value === oldValue) {
        return;
      }
      if (trim2 && el.value.trim() === newValue) {
        return;
      }
    }
    el.value = newValue;
  }
};
const vModelCheckbox = {
  // #4096 array checkboxes need to be deep traversed
  deep: true,
  created(el, _, vnode) {
    el[assignKey] = getModelAssigner(vnode);
    addEventListener(el, "change", () => {
      const modelValue = el._modelValue;
      const elementValue = getValue(el);
      const checked2 = el.checked;
      const assign2 = el[assignKey];
      if (isArray(modelValue)) {
        const index2 = looseIndexOf(modelValue, elementValue);
        const found = index2 !== -1;
        if (checked2 && !found) {
          assign2(modelValue.concat(elementValue));
        } else if (!checked2 && found) {
          const filtered = [...modelValue];
          filtered.splice(index2, 1);
          assign2(filtered);
        }
      } else if (isSet(modelValue)) {
        const cloned = new Set(modelValue);
        if (checked2) {
          cloned.add(elementValue);
        } else {
          cloned.delete(elementValue);
        }
        assign2(cloned);
      } else {
        assign2(getCheckboxValue(el, checked2));
      }
    });
  },
  // set initial checked on mount to wait for true-value/false-value
  mounted: setChecked,
  beforeUpdate(el, binding, vnode) {
    el[assignKey] = getModelAssigner(vnode);
    setChecked(el, binding, vnode);
  }
};
function setChecked(el, { value, oldValue }, vnode) {
  el._modelValue = value;
  let checked2;
  if (isArray(value)) {
    checked2 = looseIndexOf(value, vnode.props.value) > -1;
  } else if (isSet(value)) {
    checked2 = value.has(vnode.props.value);
  } else {
    if (value === oldValue) return;
    checked2 = looseEqual(value, getCheckboxValue(el, true));
  }
  if (el.checked !== checked2) {
    el.checked = checked2;
  }
}
const vModelRadio = {
  created(el, { value }, vnode) {
    el.checked = looseEqual(value, vnode.props.value);
    el[assignKey] = getModelAssigner(vnode);
    addEventListener(el, "change", () => {
      el[assignKey](getValue(el));
    });
  },
  beforeUpdate(el, { value, oldValue }, vnode) {
    el[assignKey] = getModelAssigner(vnode);
    if (value !== oldValue) {
      el.checked = looseEqual(value, vnode.props.value);
    }
  }
};
function getValue(el) {
  return "_value" in el ? el._value : el.value;
}
function getCheckboxValue(el, checked2) {
  const key = checked2 ? "_trueValue" : "_falseValue";
  return key in el ? el[key] : checked2;
}
const systemModifiers = ["ctrl", "shift", "alt", "meta"];
const modifierGuards = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, modifiers) => systemModifiers.some((m) => e[`${m}Key`] && !modifiers.includes(m))
};
const withModifiers = (fn3, modifiers) => {
  if (!fn3) return fn3;
  const cache2 = fn3._withMods || (fn3._withMods = {});
  const cacheKey = modifiers.join(".");
  return cache2[cacheKey] || (cache2[cacheKey] = ((event2, ...args) => {
    for (let i = 0; i < modifiers.length; i++) {
      const guard = modifierGuards[modifiers[i]];
      if (guard && guard(event2, modifiers)) return;
    }
    return fn3(event2, ...args);
  }));
};
function initDev() {
  {
    initCustomFormatter();
  }
}
if (!!(process.env.NODE_ENV !== "production")) {
  initDev();
}
const IS_CLIENT = typeof window !== "undefined";
let activePinia;
const setActivePinia = (pinia) => activePinia = pinia;
process.env.NODE_ENV !== "production" ? () => {
  const pinia = hasInjectionContext() && inject(piniaSymbol);
  if (!pinia && !IS_CLIENT) {
    console.error(`[🍍]: Pinia instance not found in context. This falls back to the global activePinia which exposes you to cross-request pollution on the server. Most of the time, it means you are calling "useStore()" in the wrong place.
Read https://vuejs.org/guide/reusability/composables.html to learn more`);
  }
  return pinia || activePinia;
} : () => hasInjectionContext() && inject(piniaSymbol) || activePinia;
const piniaSymbol = process.env.NODE_ENV !== "production" ? /* @__PURE__ */ Symbol("pinia") : (
  /* istanbul ignore next */
  /* @__PURE__ */ Symbol()
);
function isPlainObject(o) {
  return o && typeof o === "object" && Object.prototype.toString.call(o) === "[object Object]" && typeof o.toJSON !== "function";
}
var MutationType;
(function(MutationType2) {
  MutationType2["direct"] = "direct";
  MutationType2["patchObject"] = "patch object";
  MutationType2["patchFunction"] = "patch function";
})(MutationType || (MutationType = {}));
function patchObject(newState, oldState) {
  for (const key in oldState) {
    const subPatch = oldState[key];
    if (!(key in newState)) {
      continue;
    }
    const targetValue = newState[key];
    if (isPlainObject(targetValue) && isPlainObject(subPatch) && !/* @__PURE__ */ isRef(subPatch) && !/* @__PURE__ */ isReactive(subPatch)) {
      newState[key] = patchObject(targetValue, subPatch);
    } else {
      newState[key] = subPatch;
    }
  }
  return newState;
}
const noop = () => {
};
function addSubscription(subscriptions, callback, detached, onCleanup = noop) {
  subscriptions.add(callback);
  const removeSubscription = () => {
    const isDel = subscriptions.delete(callback);
    isDel && onCleanup();
  };
  if (!detached && getCurrentScope()) {
    onScopeDispose(removeSubscription);
  }
  return removeSubscription;
}
function triggerSubscriptions(subscriptions, ...args) {
  subscriptions.forEach((callback) => {
    callback(...args);
  });
}
const fallbackRunWithContext = (fn3) => fn3();
const ACTION_MARKER = /* @__PURE__ */ Symbol();
const ACTION_NAME = /* @__PURE__ */ Symbol();
function mergeReactiveObjects(target, patchToApply) {
  if (target instanceof Map && patchToApply instanceof Map) {
    patchToApply.forEach((value, key) => target.set(key, value));
  } else if (target instanceof Set && patchToApply instanceof Set) {
    patchToApply.forEach(target.add, target);
  }
  for (const key in patchToApply) {
    if (!patchToApply.hasOwnProperty(key))
      continue;
    const subPatch = patchToApply[key];
    const targetValue = target[key];
    if (isPlainObject(targetValue) && isPlainObject(subPatch) && target.hasOwnProperty(key) && !/* @__PURE__ */ isRef(subPatch) && !/* @__PURE__ */ isReactive(subPatch)) {
      target[key] = mergeReactiveObjects(targetValue, subPatch);
    } else {
      target[key] = subPatch;
    }
  }
  return target;
}
const skipHydrateSymbol = process.env.NODE_ENV !== "production" ? /* @__PURE__ */ Symbol("pinia:skipHydration") : (
  /* istanbul ignore next */
  /* @__PURE__ */ Symbol()
);
function shouldHydrate(obj) {
  return !isPlainObject(obj) || !Object.prototype.hasOwnProperty.call(obj, skipHydrateSymbol);
}
const { assign } = Object;
function isComputed(o) {
  return !!(/* @__PURE__ */ isRef(o) && o.effect);
}
function createOptionsStore(id, options, pinia, hot) {
  const { state, actions, getters } = options;
  const initialState = pinia.state.value[id];
  let store2;
  function setup() {
    if (!initialState && (!(process.env.NODE_ENV !== "production") || !hot)) {
      pinia.state.value[id] = state ? state() : {};
    }
    const localState = process.env.NODE_ENV !== "production" && hot ? (
      // use ref() to unwrap refs inside state TODO: check if this is still necessary
      /* @__PURE__ */ toRefs((/* @__PURE__ */ ref(state ? state() : {})).value)
    ) : /* @__PURE__ */ toRefs(pinia.state.value[id]);
    return assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name) => {
      if (process.env.NODE_ENV !== "production" && name in localState) {
        console.warn(`[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${name}" in store "${id}".`);
      }
      computedGetters[name] = markRaw(computed(() => {
        setActivePinia(pinia);
        const store22 = pinia._s.get(id);
        return getters[name].call(store22, store22);
      }));
      return computedGetters;
    }, {}));
  }
  store2 = createSetupStore(id, setup, options, pinia, hot, true);
  return store2;
}
function createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
  let scope;
  const optionsForPlugin = assign({ actions: {} }, options);
  if (process.env.NODE_ENV !== "production" && !pinia._e.active) {
    throw new Error("Pinia destroyed");
  }
  const $subscribeOptions = { deep: true };
  if (process.env.NODE_ENV !== "production") {
    $subscribeOptions.onTrigger = (event2) => {
      if (isListening) {
        debuggerEvents = event2;
      } else if (isListening == false && !store2._hotUpdating) {
        if (Array.isArray(debuggerEvents)) {
          debuggerEvents.push(event2);
        } else {
          console.error("🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug.");
        }
      }
    };
  }
  let isListening;
  let isSyncListening;
  let subscriptions = /* @__PURE__ */ new Set();
  let actionSubscriptions = /* @__PURE__ */ new Set();
  let debuggerEvents;
  const initialState = pinia.state.value[$id];
  if (!isOptionsStore && !initialState && (!(process.env.NODE_ENV !== "production") || !hot)) {
    pinia.state.value[$id] = {};
  }
  const hotState = /* @__PURE__ */ ref({});
  let activeListener;
  function $patch(partialStateOrMutator) {
    let subscriptionMutation;
    isListening = isSyncListening = false;
    if (process.env.NODE_ENV !== "production") {
      debuggerEvents = [];
    }
    if (typeof partialStateOrMutator === "function") {
      partialStateOrMutator(pinia.state.value[$id]);
      subscriptionMutation = {
        type: MutationType.patchFunction,
        storeId: $id,
        events: debuggerEvents
      };
    } else {
      mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
      subscriptionMutation = {
        type: MutationType.patchObject,
        payload: partialStateOrMutator,
        storeId: $id,
        events: debuggerEvents
      };
    }
    const myListenerId = activeListener = /* @__PURE__ */ Symbol();
    nextTick().then(() => {
      if (activeListener === myListenerId) {
        isListening = true;
      }
    });
    isSyncListening = true;
    triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
  }
  const $reset = isOptionsStore ? function $reset2() {
    const { state } = options;
    const newState = state ? state() : {};
    this.$patch(($state) => {
      assign($state, newState);
    });
  } : (
    /* istanbul ignore next */
    process.env.NODE_ENV !== "production" ? () => {
      throw new Error(`🍍: Store "${$id}" is built using the setup syntax and does not implement $reset().`);
    } : noop
  );
  function $dispose() {
    scope.stop();
    subscriptions.clear();
    actionSubscriptions.clear();
    pinia._s.delete($id);
  }
  const action = (fn3, name = "") => {
    if (ACTION_MARKER in fn3) {
      fn3[ACTION_NAME] = name;
      return fn3;
    }
    const wrappedAction = function() {
      setActivePinia(pinia);
      const args = Array.from(arguments);
      const afterCallbackSet = /* @__PURE__ */ new Set();
      const onErrorCallbackSet = /* @__PURE__ */ new Set();
      function after(callback) {
        afterCallbackSet.add(callback);
      }
      function onError(callback) {
        onErrorCallbackSet.add(callback);
      }
      triggerSubscriptions(actionSubscriptions, {
        args,
        name: wrappedAction[ACTION_NAME],
        store: store2,
        after,
        onError
      });
      let ret;
      try {
        ret = fn3.apply(this && this.$id === $id ? this : store2, args);
      } catch (error) {
        triggerSubscriptions(onErrorCallbackSet, error);
        throw error;
      }
      if (ret instanceof Promise) {
        return ret.then((value) => {
          triggerSubscriptions(afterCallbackSet, value);
          return value;
        }).catch((error) => {
          triggerSubscriptions(onErrorCallbackSet, error);
          return Promise.reject(error);
        });
      }
      triggerSubscriptions(afterCallbackSet, ret);
      return ret;
    };
    wrappedAction[ACTION_MARKER] = true;
    wrappedAction[ACTION_NAME] = name;
    return wrappedAction;
  };
  const _hmrPayload = /* @__PURE__ */ markRaw({
    actions: {},
    getters: {},
    state: [],
    hotState
  });
  const partialStore = {
    _p: pinia,
    // _s: scope,
    $id,
    $onAction: addSubscription.bind(null, actionSubscriptions),
    $patch,
    $reset,
    $subscribe(callback, options2 = {}) {
      const removeSubscription = addSubscription(subscriptions, callback, options2.detached, () => stopWatcher());
      const stopWatcher = scope.run(() => watch(() => pinia.state.value[$id], (state) => {
        if (options2.flush === "sync" ? isSyncListening : isListening) {
          callback({
            storeId: $id,
            type: MutationType.direct,
            events: debuggerEvents
          }, state);
        }
      }, assign({}, $subscribeOptions, options2)));
      return removeSubscription;
    },
    $dispose
  };
  const store2 = /* @__PURE__ */ reactive(process.env.NODE_ENV !== "production" || (process.env.NODE_ENV !== "production" || typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__) && !(process.env.NODE_ENV === "test") && IS_CLIENT ? assign(
    {
      _hmrPayload,
      _customProperties: markRaw(/* @__PURE__ */ new Set())
      // devtools custom properties
    },
    partialStore
    // must be added later
    // setupStore
  ) : partialStore);
  pinia._s.set($id, store2);
  const runWithContext = pinia._a && pinia._a.runWithContext || fallbackRunWithContext;
  const setupStore = runWithContext(() => pinia._e.run(() => (scope = effectScope()).run(() => setup({ action }))));
  for (const key in setupStore) {
    const prop = setupStore[key];
    if (/* @__PURE__ */ isRef(prop) && !isComputed(prop) || /* @__PURE__ */ isReactive(prop)) {
      if (process.env.NODE_ENV !== "production" && hot) {
        hotState.value[key] = /* @__PURE__ */ toRef(setupStore, key);
      } else if (!isOptionsStore) {
        if (initialState && shouldHydrate(prop)) {
          if (/* @__PURE__ */ isRef(prop)) {
            prop.value = initialState[key];
          } else {
            mergeReactiveObjects(prop, initialState[key]);
          }
        }
        pinia.state.value[$id][key] = prop;
      }
      if (process.env.NODE_ENV !== "production") {
        _hmrPayload.state.push(key);
      }
    } else if (typeof prop === "function") {
      const actionValue = process.env.NODE_ENV !== "production" && hot ? prop : action(prop, key);
      setupStore[key] = actionValue;
      if (process.env.NODE_ENV !== "production") {
        _hmrPayload.actions[key] = prop;
      }
      optionsForPlugin.actions[key] = prop;
    } else if (process.env.NODE_ENV !== "production") {
      if (isComputed(prop)) {
        _hmrPayload.getters[key] = isOptionsStore ? (
          // @ts-expect-error
          options.getters[key]
        ) : prop;
        if (IS_CLIENT) {
          const getters = setupStore._getters || // @ts-expect-error: same
          (setupStore._getters = markRaw([]));
          getters.push(key);
        }
      }
    }
  }
  assign(store2, setupStore);
  assign(/* @__PURE__ */ toRaw(store2), setupStore);
  Object.defineProperty(store2, "$state", {
    get: () => process.env.NODE_ENV !== "production" && hot ? hotState.value : pinia.state.value[$id],
    set: (state) => {
      if (process.env.NODE_ENV !== "production" && hot) {
        throw new Error("cannot set hotState");
      }
      $patch(($state) => {
        assign($state, state);
      });
    }
  });
  if (process.env.NODE_ENV !== "production") {
    store2._hotUpdate = markRaw((newStore) => {
      store2._hotUpdating = true;
      newStore._hmrPayload.state.forEach((stateKey) => {
        if (stateKey in store2.$state) {
          const newStateTarget = newStore.$state[stateKey];
          const oldStateSource = store2.$state[stateKey];
          if (typeof newStateTarget === "object" && isPlainObject(newStateTarget) && isPlainObject(oldStateSource)) {
            patchObject(newStateTarget, oldStateSource);
          } else {
            newStore.$state[stateKey] = oldStateSource;
          }
        }
        store2[stateKey] = /* @__PURE__ */ toRef(newStore.$state, stateKey);
      });
      Object.keys(store2.$state).forEach((stateKey) => {
        if (!(stateKey in newStore.$state)) {
          delete store2[stateKey];
        }
      });
      isListening = false;
      isSyncListening = false;
      pinia.state.value[$id] = /* @__PURE__ */ toRef(newStore._hmrPayload, "hotState");
      isSyncListening = true;
      nextTick().then(() => {
        isListening = true;
      });
      for (const actionName in newStore._hmrPayload.actions) {
        const actionFn = newStore[actionName];
        store2[actionName] = //
        action(actionFn, actionName);
      }
      for (const getterName in newStore._hmrPayload.getters) {
        const getter = newStore._hmrPayload.getters[getterName];
        const getterValue = isOptionsStore ? (
          // special handling of options api
          computed(() => {
            setActivePinia(pinia);
            return getter.call(store2, store2);
          })
        ) : getter;
        store2[getterName] = //
        getterValue;
      }
      Object.keys(store2._hmrPayload.getters).forEach((key) => {
        if (!(key in newStore._hmrPayload.getters)) {
          delete store2[key];
        }
      });
      Object.keys(store2._hmrPayload.actions).forEach((key) => {
        if (!(key in newStore._hmrPayload.actions)) {
          delete store2[key];
        }
      });
      store2._hmrPayload = newStore._hmrPayload;
      store2._getters = newStore._getters;
      store2._hotUpdating = false;
    });
  }
  if ((process.env.NODE_ENV !== "production" || typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__) && !(process.env.NODE_ENV === "test") && IS_CLIENT) {
    const nonEnumerable = {
      writable: true,
      configurable: true,
      // avoid warning on devtools trying to display this property
      enumerable: false
    };
    ["_p", "_hmrPayload", "_getters", "_customProperties"].forEach((p) => {
      Object.defineProperty(store2, p, assign({ value: store2[p] }, nonEnumerable));
    });
  }
  pinia._p.forEach((extender) => {
    if ((process.env.NODE_ENV !== "production" || typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__) && !(process.env.NODE_ENV === "test") && IS_CLIENT) {
      const extensions = scope.run(() => extender({
        store: store2,
        app: pinia._a,
        pinia,
        options: optionsForPlugin
      }));
      Object.keys(extensions || {}).forEach((key) => store2._customProperties.add(key));
      assign(store2, extensions);
    } else {
      assign(store2, scope.run(() => extender({
        store: store2,
        app: pinia._a,
        pinia,
        options: optionsForPlugin
      })));
    }
  });
  if (process.env.NODE_ENV !== "production" && store2.$state && typeof store2.$state === "object" && typeof store2.$state.constructor === "function" && !store2.$state.constructor.toString().includes("[native code]")) {
    console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${store2.$id}".`);
  }
  if (initialState && isOptionsStore && options.hydrate) {
    options.hydrate(store2.$state, initialState);
  }
  isListening = true;
  isSyncListening = true;
  return store2;
}
// @__NO_SIDE_EFFECTS__
function defineStore(id, setup, setupOptions) {
  let options;
  const isSetupStore = typeof setup === "function";
  options = isSetupStore ? setupOptions : setup;
  function useStore(pinia, hot) {
    const hasContext = hasInjectionContext();
    pinia = // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    (process.env.NODE_ENV === "test" && activePinia && activePinia._testing ? null : pinia) || (hasContext ? inject(piniaSymbol, null) : null);
    if (pinia)
      setActivePinia(pinia);
    if (process.env.NODE_ENV !== "production" && !activePinia) {
      throw new Error(`[🍍]: "getActivePinia()" was called but there was no active Pinia. Are you trying to use a store before calling "app.use(pinia)"?
See https://pinia.vuejs.org/core-concepts/outside-component-usage.html for help.
This will fail in production.`);
    }
    pinia = activePinia;
    if (!pinia._s.has(id)) {
      if (isSetupStore) {
        createSetupStore(id, setup, options, pinia);
      } else {
        createOptionsStore(id, options, pinia);
      }
      if (process.env.NODE_ENV !== "production") {
        useStore._pinia = pinia;
      }
    }
    const store2 = pinia._s.get(id);
    if (process.env.NODE_ENV !== "production" && hot) {
      const hotId = "__hot:" + id;
      const newStore = isSetupStore ? createSetupStore(hotId, setup, options, pinia, true) : createOptionsStore(hotId, assign({}, options), pinia, true);
      hot._hotUpdate(newStore);
      delete pinia.state.value[hotId];
      pinia._s.delete(hotId);
    }
    if (process.env.NODE_ENV !== "production" && IS_CLIENT) {
      const currentInstance2 = getCurrentInstance();
      if (currentInstance2 && currentInstance2.proxy && // avoid adding stores that are just built for hot module replacement
      !hot) {
        const vm2 = currentInstance2.proxy;
        const cache2 = "_pStores" in vm2 ? vm2._pStores : vm2._pStores = {};
        cache2[id] = store2;
      }
    }
    return store2;
  }
  useStore.$id = id;
  return useStore;
}
var mZe = Object.defineProperty;
var RZe = (t16, e, r12) => e in t16 ? mZe(t16, e, { enumerable: true, configurable: true, writable: true, value: r12 }) : t16[e] = r12;
var q0 = (t16, e, r12) => (RZe(t16, typeof e != "symbol" ? e + "" : e, r12), r12);
function iVe(t16, e) {
  return function() {
    return t16.apply(e, arguments);
  };
}
const { toString: LZe } = Object.prototype, { getPrototypeOf: mee } = Object, ap = /* @__PURE__ */ ((t16) => (e) => {
  const r12 = LZe.call(e);
  return t16[r12] || (t16[r12] = r12.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), qn = (t16) => (t16 = t16.toLowerCase(), (e) => ap(e) === t16), op = (t16) => (e) => typeof e === t16, { isArray: Pi } = Array, Ss = op("undefined");
function PZe(t16) {
  return t16 !== null && !Ss(t16) && t16.constructor !== null && !Ss(t16.constructor) && vr(t16.constructor.isBuffer) && t16.constructor.isBuffer(t16);
}
const uVe = qn("ArrayBuffer");
function DZe(t16) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t16) : e = t16 && t16.buffer && uVe(t16.buffer), e;
}
const WZe = op("string"), vr = op("function"), sVe = op("number"), ip = (t16) => t16 !== null && typeof t16 == "object", NZe = (t16) => t16 === true || t16 === false, Ul = (t16) => {
  if (ap(t16) !== "object")
    return false;
  const e = mee(t16);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t16) && !(Symbol.iterator in t16);
}, wZe = qn("Date"), BZe = qn("File"), xZe = qn("Blob"), UZe = qn("FileList"), kZe = (t16) => ip(t16) && vr(t16.pipe), jZe = (t16) => {
  let e;
  return t16 && (typeof FormData == "function" && t16 instanceof FormData || vr(t16.append) && ((e = ap(t16)) === "formdata" || // detect form-data instance
  e === "object" && vr(t16.toString) && t16.toString() === "[object FormData]"));
}, FZe = qn("URLSearchParams"), VZe = (t16) => t16.trim ? t16.trim() : t16.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ic(t16, e, { allOwnKeys: r12 = false } = {}) {
  if (t16 === null || typeof t16 > "u")
    return;
  let n12, a;
  if (typeof t16 != "object" && (t16 = [t16]), Pi(t16))
    for (n12 = 0, a = t16.length; n12 < a; n12++)
      e.call(null, t16[n12], n12, t16);
  else {
    const o = r12 ? Object.getOwnPropertyNames(t16) : Object.keys(t16), i = o.length;
    let u;
    for (n12 = 0; n12 < i; n12++)
      u = o[n12], e.call(null, t16[u], u, t16);
  }
}
function cVe(t16, e) {
  e = e.toLowerCase();
  const r12 = Object.keys(t16);
  let n12 = r12.length, a;
  for (; n12-- > 0; )
    if (a = r12[n12], e === a.toLowerCase())
      return a;
  return null;
}
const lVe = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, pVe = (t16) => !Ss(t16) && t16 !== lVe;
function wQ() {
  const { caseless: t16 } = pVe(this) && this || {}, e = {}, r12 = (n12, a) => {
    const o = t16 && cVe(e, a) || a;
    Ul(e[o]) && Ul(n12) ? e[o] = wQ(e[o], n12) : Ul(n12) ? e[o] = wQ({}, n12) : Pi(n12) ? e[o] = n12.slice() : e[o] = n12;
  };
  for (let n12 = 0, a = arguments.length; n12 < a; n12++)
    arguments[n12] && ic(arguments[n12], r12);
  return e;
}
const HZe = (t16, e, r12, { allOwnKeys: n12 } = {}) => (ic(e, (a, o) => {
  r12 && vr(a) ? t16[o] = iVe(a, r12) : t16[o] = a;
}, { allOwnKeys: n12 }), t16), XZe = (t16) => (t16.charCodeAt(0) === 65279 && (t16 = t16.slice(1)), t16), $Ze = (t16, e, r12, n12) => {
  t16.prototype = Object.create(e.prototype, n12), t16.prototype.constructor = t16, Object.defineProperty(t16, "super", {
    value: e.prototype
  }), r12 && Object.assign(t16.prototype, r12);
}, GZe = (t16, e, r12, n12) => {
  let a, o, i;
  const u = {};
  if (e = e || {}, t16 == null)
    return e;
  do {
    for (a = Object.getOwnPropertyNames(t16), o = a.length; o-- > 0; )
      i = a[o], (!n12 || n12(i, t16, e)) && !u[i] && (e[i] = t16[i], u[i] = true);
    t16 = r12 !== false && mee(t16);
  } while (t16 && (!r12 || r12(t16, e)) && t16 !== Object.prototype);
  return e;
}, YZe = (t16, e, r12) => {
  t16 = String(t16), (r12 === void 0 || r12 > t16.length) && (r12 = t16.length), r12 -= e.length;
  const n12 = t16.indexOf(e, r12);
  return n12 !== -1 && n12 === r12;
}, JZe = (t16) => {
  if (!t16)
    return null;
  if (Pi(t16))
    return t16;
  let e = t16.length;
  if (!sVe(e))
    return null;
  const r12 = new Array(e);
  for (; e-- > 0; )
    r12[e] = t16[e];
  return r12;
}, KZe = /* @__PURE__ */ ((t16) => (e) => t16 && e instanceof t16)(typeof Uint8Array < "u" && mee(Uint8Array)), QZe = (t16, e) => {
  const n12 = (t16 && t16[Symbol.iterator]).call(t16);
  let a;
  for (; (a = n12.next()) && !a.done; ) {
    const o = a.value;
    e.call(t16, o[0], o[1]);
  }
}, ZZe = (t16, e) => {
  let r12;
  const n12 = [];
  for (; (r12 = t16.exec(e)) !== null; )
    n12.push(r12);
  return n12;
}, ee0 = qn("HTMLFormElement"), te0 = (t16) => t16.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r12, n12, a) {
    return n12.toUpperCase() + a;
  }
), Ste = (({ hasOwnProperty: t16 }) => (e, r12) => t16.call(e, r12))(Object.prototype), re0 = qn("RegExp"), dVe = (t16, e) => {
  const r12 = Object.getOwnPropertyDescriptors(t16), n12 = {};
  ic(r12, (a, o) => {
    let i;
    (i = e(a, o, t16)) !== false && (n12[o] = i || a);
  }), Object.defineProperties(t16, n12);
}, ne0 = (t16) => {
  dVe(t16, (e, r12) => {
    if (vr(t16) && ["arguments", "caller", "callee"].indexOf(r12) !== -1)
      return false;
    const n12 = t16[r12];
    if (vr(n12)) {
      if (e.enumerable = false, "writable" in e) {
        e.writable = false;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + r12 + "'");
      });
    }
  });
}, ae0 = (t16, e) => {
  const r12 = {}, n12 = (a) => {
    a.forEach((o) => {
      r12[o] = true;
    });
  };
  return Pi(t16) ? n12(t16) : n12(String(t16).split(e)), r12;
}, oe0 = () => {
}, ie0 = (t16, e) => (t16 = +t16, Number.isFinite(t16) ? t16 : e), gd = "abcdefghijklmnopqrstuvwxyz", Cte = "0123456789", fVe = {
  DIGIT: Cte,
  ALPHA: gd,
  ALPHA_DIGIT: gd + gd.toUpperCase() + Cte
}, ue0 = (t16 = 16, e = fVe.ALPHA_DIGIT) => {
  let r12 = "";
  const { length: n12 } = e;
  for (; t16--; )
    r12 += e[Math.random() * n12 | 0];
  return r12;
};
function se0(t16) {
  return !!(t16 && vr(t16.append) && t16[Symbol.toStringTag] === "FormData" && t16[Symbol.iterator]);
}
const ce0 = (t16) => {
  const e = new Array(10), r12 = (n12, a) => {
    if (ip(n12)) {
      if (e.indexOf(n12) >= 0)
        return;
      if (!("toJSON" in n12)) {
        e[a] = n12;
        const o = Pi(n12) ? [] : {};
        return ic(n12, (i, u) => {
          const s12 = r12(i, a + 1);
          !Ss(s12) && (o[u] = s12);
        }), e[a] = void 0, o;
      }
    }
    return n12;
  };
  return r12(t16, 0);
}, le0 = qn("AsyncFunction"), pe0 = (t16) => t16 && (ip(t16) || vr(t16)) && vr(t16.then) && vr(t16.catch), me = {
  isArray: Pi,
  isArrayBuffer: uVe,
  isBuffer: PZe,
  isFormData: jZe,
  isArrayBufferView: DZe,
  isString: WZe,
  isNumber: sVe,
  isBoolean: NZe,
  isObject: ip,
  isPlainObject: Ul,
  isUndefined: Ss,
  isDate: wZe,
  isFile: BZe,
  isBlob: xZe,
  isRegExp: re0,
  isFunction: vr,
  isStream: kZe,
  isURLSearchParams: FZe,
  isTypedArray: KZe,
  isFileList: UZe,
  forEach: ic,
  merge: wQ,
  extend: HZe,
  trim: VZe,
  stripBOM: XZe,
  inherits: $Ze,
  toFlatObject: GZe,
  kindOf: ap,
  kindOfTest: qn,
  endsWith: YZe,
  toArray: JZe,
  forEachEntry: QZe,
  matchAll: ZZe,
  isHTMLForm: ee0,
  hasOwnProperty: Ste,
  hasOwnProp: Ste,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: dVe,
  freezeMethods: ne0,
  toObjectSet: ae0,
  toCamelCase: te0,
  noop: oe0,
  toFiniteNumber: ie0,
  findKey: cVe,
  global: lVe,
  isContextDefined: pVe,
  ALPHABET: fVe,
  generateString: ue0,
  isSpecCompliantForm: se0,
  toJSONObject: ce0,
  isAsyncFn: le0,
  isThenable: pe0
};
function V0(t16, e, r12, n12, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t16, this.name = "AxiosError", e && (this.code = e), r12 && (this.config = r12), n12 && (this.request = n12), a && (this.response = a);
}
me.inherits(V0, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: me.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const bVe = V0.prototype, MVe = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t16) => {
  MVe[t16] = { value: t16 };
});
Object.defineProperties(V0, MVe);
Object.defineProperty(bVe, "isAxiosError", { value: true });
V0.from = (t16, e, r12, n12, a, o) => {
  const i = Object.create(bVe);
  return me.toFlatObject(t16, i, function(s12) {
    return s12 !== Error.prototype;
  }, (u) => u !== "isAxiosError"), V0.call(i, t16.message, e, r12, n12, a), i.cause = t16, i.name = t16.name, o && Object.assign(i, o), i;
};
const de0 = null;
function BQ(t16) {
  return me.isPlainObject(t16) || me.isArray(t16);
}
function OVe(t16) {
  return me.endsWith(t16, "[]") ? t16.slice(0, -2) : t16;
}
function gte(t16, e, r12) {
  return t16 ? t16.concat(e).map(function(a, o) {
    return a = OVe(a), !r12 && o ? "[" + a + "]" : a;
  }).join(r12 ? "." : "") : e;
}
function fe0(t16) {
  return me.isArray(t16) && !t16.some(BQ);
}
const be0 = me.toFlatObject(me, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function up(t16, e, r12) {
  if (!me.isObject(t16))
    throw new TypeError("target must be an object");
  e = e || new FormData(), r12 = me.toFlatObject(r12, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function(z, _) {
    return !me.isUndefined(_[z]);
  });
  const n12 = r12.metaTokens, a = r12.visitor || l2, o = r12.dots, i = r12.indexes, s12 = (r12.Blob || typeof Blob < "u" && Blob) && me.isSpecCompliantForm(e);
  if (!me.isFunction(a))
    throw new TypeError("visitor must be a function");
  function c(b) {
    if (b === null)
      return "";
    if (me.isDate(b))
      return b.toISOString();
    if (!s12 && me.isBlob(b))
      throw new V0("Blob is not supported. Use a Buffer instead.");
    return me.isArrayBuffer(b) || me.isTypedArray(b) ? s12 && typeof Blob == "function" ? new Blob([b]) : Buffer.from(b) : b;
  }
  function l2(b, z, _) {
    let q = b;
    if (b && !_ && typeof b == "object") {
      if (me.endsWith(z, "{}"))
        z = n12 ? z : z.slice(0, -2), b = JSON.stringify(b);
      else if (me.isArray(b) && fe0(b) || (me.isFileList(b) || me.endsWith(z, "[]")) && (q = me.toArray(b)))
        return z = OVe(z), q.forEach(function(N, v) {
          !(me.isUndefined(N) || N === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            i === true ? gte([z], v, o) : i === null ? z : z + "[]",
            c(N)
          );
        }), false;
    }
    return BQ(b) ? true : (e.append(gte(_, z, o), c(b)), false);
  }
  const f = [], p = Object.assign(be0, {
    defaultVisitor: l2,
    convertValue: c,
    isVisitable: BQ
  });
  function d(b, z) {
    if (!me.isUndefined(b)) {
      if (f.indexOf(b) !== -1)
        throw Error("Circular reference detected in " + z.join("."));
      f.push(b), me.forEach(b, function(q, S) {
        (!(me.isUndefined(q) || q === null) && a.call(
          e,
          q,
          me.isString(S) ? S.trim() : S,
          z,
          p
        )) === true && d(q, z ? z.concat(S) : [S]);
      }), f.pop();
    }
  }
  if (!me.isObject(t16))
    throw new TypeError("data must be an object");
  return d(t16), e;
}
function Ite(t16) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t16).replace(/[!'()~]|%20|%00/g, function(n12) {
    return e[n12];
  });
}
function Ree(t16, e) {
  this._pairs = [], t16 && up(t16, this, e);
}
const zVe = Ree.prototype;
zVe.append = function(e, r12) {
  this._pairs.push([e, r12]);
};
zVe.toString = function(e) {
  const r12 = e ? function(n12) {
    return e.call(this, n12, Ite);
  } : Ite;
  return this._pairs.map(function(a) {
    return r12(a[0]) + "=" + r12(a[1]);
  }, "").join("&");
};
function Me0(t16) {
  return encodeURIComponent(t16).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function AVe(t16, e, r12) {
  if (!e)
    return t16;
  const n12 = r12 && r12.encode || Me0, a = r12 && r12.serialize;
  let o;
  if (a ? o = a(e, r12) : o = me.isURLSearchParams(e) ? e.toString() : new Ree(e, r12).toString(n12), o) {
    const i = t16.indexOf("#");
    i !== -1 && (t16 = t16.slice(0, i)), t16 += (t16.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return t16;
}
class Ete {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, r12, n12) {
    return this.handlers.push({
      fulfilled: e,
      rejected: r12,
      synchronous: n12 ? n12.synchronous : false,
      runWhen: n12 ? n12.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    me.forEach(this.handlers, function(n12) {
      n12 !== null && e(n12);
    });
  }
}
const _Ve = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
}, Oe0 = typeof URLSearchParams < "u" ? URLSearchParams : Ree, ze0 = typeof FormData < "u" ? FormData : null, Ae0 = typeof Blob < "u" ? Blob : null, _e0 = {
  isBrowser: true,
  classes: {
    URLSearchParams: Oe0,
    FormData: ze0,
    Blob: Ae0
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, hVe = typeof window < "u" && typeof document < "u", he0 = ((t16) => hVe && ["ReactNative", "NativeScript", "NS"].indexOf(t16) < 0)(typeof navigator < "u" && navigator.product), ve0 = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", me0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: hVe,
  hasStandardBrowserEnv: he0,
  hasStandardBrowserWebWorkerEnv: ve0
}, Symbol.toStringTag, { value: "Module" })), fn2 = {
  ...me0,
  ..._e0
};
function Re0(t16, e) {
  return up(t16, new fn2.classes.URLSearchParams(), Object.assign({
    visitor: function(r12, n12, a, o) {
      return fn2.isNode && me.isBuffer(r12) ? (this.append(n12, r12.toString("base64")), false) : o.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function qe0(t16) {
  return me.matchAll(/\w+|\[(\w*)]/g, t16).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function Te0(t16) {
  const e = {}, r12 = Object.keys(t16);
  let n12;
  const a = r12.length;
  let o;
  for (n12 = 0; n12 < a; n12++)
    o = r12[n12], e[o] = t16[o];
  return e;
}
function vVe(t16) {
  function e(r12, n12, a, o) {
    let i = r12[o++];
    if (i === "__proto__")
      return true;
    const u = Number.isFinite(+i), s12 = o >= r12.length;
    return i = !i && me.isArray(a) ? a.length : i, s12 ? (me.hasOwnProp(a, i) ? a[i] = [a[i], n12] : a[i] = n12, !u) : ((!a[i] || !me.isObject(a[i])) && (a[i] = []), e(r12, n12, a[i], o) && me.isArray(a[i]) && (a[i] = Te0(a[i])), !u);
  }
  if (me.isFormData(t16) && me.isFunction(t16.entries)) {
    const r12 = {};
    return me.forEachEntry(t16, (n12, a) => {
      e(qe0(n12), a, r12, 0);
    }), r12;
  }
  return null;
}
function ye0(t16, e, r12) {
  if (me.isString(t16))
    try {
      return (e || JSON.parse)(t16), me.trim(t16);
    } catch (n12) {
      if (n12.name !== "SyntaxError")
        throw n12;
    }
  return (r12 || JSON.stringify)(t16);
}
const qee = {
  transitional: _Ve,
  adapter: ["xhr", "http"],
  transformRequest: [function(e, r12) {
    const n12 = r12.getContentType() || "", a = n12.indexOf("application/json") > -1, o = me.isObject(e);
    if (o && me.isHTMLForm(e) && (e = new FormData(e)), me.isFormData(e))
      return a && a ? JSON.stringify(vVe(e)) : e;
    if (me.isArrayBuffer(e) || me.isBuffer(e) || me.isStream(e) || me.isFile(e) || me.isBlob(e))
      return e;
    if (me.isArrayBufferView(e))
      return e.buffer;
    if (me.isURLSearchParams(e))
      return r12.setContentType("application/x-www-form-urlencoded;charset=utf-8", false), e.toString();
    let u;
    if (o) {
      if (n12.indexOf("application/x-www-form-urlencoded") > -1)
        return Re0(e, this.formSerializer).toString();
      if ((u = me.isFileList(e)) || n12.indexOf("multipart/form-data") > -1) {
        const s12 = this.env && this.env.FormData;
        return up(
          u ? { "files[]": e } : e,
          s12 && new s12(),
          this.formSerializer
        );
      }
    }
    return o || a ? (r12.setContentType("application/json", false), ye0(e)) : e;
  }],
  transformResponse: [function(e) {
    const r12 = this.transitional || qee.transitional, n12 = r12 && r12.forcedJSONParsing, a = this.responseType === "json";
    if (e && me.isString(e) && (n12 && !this.responseType || a)) {
      const i = !(r12 && r12.silentJSONParsing) && a;
      try {
        return JSON.parse(e);
      } catch (u) {
        if (i)
          throw u.name === "SyntaxError" ? V0.from(u, V0.ERR_BAD_RESPONSE, this, null, this.response) : u;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: fn2.classes.FormData,
    Blob: fn2.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
me.forEach(["delete", "get", "head", "post", "put", "patch"], (t16) => {
  qee.headers[t16] = {};
});
const Tee = qee, Se0 = me.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Ce0 = (t16) => {
  const e = {};
  let r12, n12, a;
  return t16 && t16.split(`
`).forEach(function(i) {
    a = i.indexOf(":"), r12 = i.substring(0, a).trim().toLowerCase(), n12 = i.substring(a + 1).trim(), !(!r12 || e[r12] && Se0[r12]) && (r12 === "set-cookie" ? e[r12] ? e[r12].push(n12) : e[r12] = [n12] : e[r12] = e[r12] ? e[r12] + ", " + n12 : n12);
  }), e;
}, Lte = /* @__PURE__ */ Symbol("internals");
function uu(t16) {
  return t16 && String(t16).trim().toLowerCase();
}
function kl(t16) {
  return t16 === false || t16 == null ? t16 : me.isArray(t16) ? t16.map(kl) : String(t16);
}
function ge0(t16) {
  const e = /* @__PURE__ */ Object.create(null), r12 = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n12;
  for (; n12 = r12.exec(t16); )
    e[n12[1]] = n12[2];
  return e;
}
const Ie0 = (t16) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t16.trim());
function Id(t16, e, r12, n12, a) {
  if (me.isFunction(n12))
    return n12.call(this, e, r12);
  if (a && (e = r12), !!me.isString(e)) {
    if (me.isString(n12))
      return e.indexOf(n12) !== -1;
    if (me.isRegExp(n12))
      return n12.test(e);
  }
}
function Ee0(t16) {
  return t16.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, r12, n12) => r12.toUpperCase() + n12);
}
function Le0(t16, e) {
  const r12 = me.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((n12) => {
    Object.defineProperty(t16, n12 + r12, {
      value: function(a, o, i) {
        return this[n12].call(this, e, a, o, i);
      },
      configurable: true
    });
  });
}
class sp {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r12, n12) {
    const a = this;
    function o(u, s12, c) {
      const l2 = uu(s12);
      if (!l2)
        throw new Error("header name must be a non-empty string");
      const f = me.findKey(a, l2);
      (!f || a[f] === void 0 || c === true || c === void 0 && a[f] !== false) && (a[f || s12] = kl(u));
    }
    const i = (u, s12) => me.forEach(u, (c, l2) => o(c, l2, s12));
    return me.isPlainObject(e) || e instanceof this.constructor ? i(e, r12) : me.isString(e) && (e = e.trim()) && !Ie0(e) ? i(Ce0(e), r12) : e != null && o(r12, e, n12), this;
  }
  get(e, r12) {
    if (e = uu(e), e) {
      const n12 = me.findKey(this, e);
      if (n12) {
        const a = this[n12];
        if (!r12)
          return a;
        if (r12 === true)
          return ge0(a);
        if (me.isFunction(r12))
          return r12.call(this, a, n12);
        if (me.isRegExp(r12))
          return r12.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r12) {
    if (e = uu(e), e) {
      const n12 = me.findKey(this, e);
      return !!(n12 && this[n12] !== void 0 && (!r12 || Id(this, this[n12], n12, r12)));
    }
    return false;
  }
  delete(e, r12) {
    const n12 = this;
    let a = false;
    function o(i) {
      if (i = uu(i), i) {
        const u = me.findKey(n12, i);
        u && (!r12 || Id(n12, n12[u], u, r12)) && (delete n12[u], a = true);
      }
    }
    return me.isArray(e) ? e.forEach(o) : o(e), a;
  }
  clear(e) {
    const r12 = Object.keys(this);
    let n12 = r12.length, a = false;
    for (; n12--; ) {
      const o = r12[n12];
      (!e || Id(this, this[o], o, e, true)) && (delete this[o], a = true);
    }
    return a;
  }
  normalize(e) {
    const r12 = this, n12 = {};
    return me.forEach(this, (a, o) => {
      const i = me.findKey(n12, o);
      if (i) {
        r12[i] = kl(a), delete r12[o];
        return;
      }
      const u = e ? Ee0(o) : String(o).trim();
      u !== o && delete r12[o], r12[u] = kl(a), n12[u] = true;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r12 = /* @__PURE__ */ Object.create(null);
    return me.forEach(this, (n12, a) => {
      n12 != null && n12 !== false && (r12[a] = e && me.isArray(n12) ? n12.join(", ") : n12);
    }), r12;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r12]) => e + ": " + r12).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r12) {
    const n12 = new this(e);
    return r12.forEach((a) => n12.set(a)), n12;
  }
  static accessor(e) {
    const n12 = (this[Lte] = this[Lte] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(i) {
      const u = uu(i);
      n12[u] || (Le0(a, i), n12[u] = true);
    }
    return me.isArray(e) ? e.forEach(o) : o(e), this;
  }
}
sp.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
me.reduceDescriptors(sp.prototype, ({ value: t16 }, e) => {
  let r12 = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t16,
    set(n12) {
      this[r12] = n12;
    }
  };
});
me.freezeMethods(sp);
const Jn = sp;
function Ed(t16, e) {
  const r12 = this || Tee, n12 = e || r12, a = Jn.from(n12.headers);
  let o = n12.data;
  return me.forEach(t16, function(u) {
    o = u.call(r12, o, a.normalize(), e ? e.status : void 0);
  }), a.normalize(), o;
}
function mVe(t16) {
  return !!(t16 && t16.__CANCEL__);
}
function uc(t16, e, r12) {
  V0.call(this, t16 ?? "canceled", V0.ERR_CANCELED, e, r12), this.name = "CanceledError";
}
me.inherits(uc, V0, {
  __CANCEL__: true
});
function Pe0(t16, e, r12) {
  const n12 = r12.config.validateStatus;
  !r12.status || !n12 || n12(r12.status) ? t16(r12) : e(new V0(
    "Request failed with status code " + r12.status,
    [V0.ERR_BAD_REQUEST, V0.ERR_BAD_RESPONSE][Math.floor(r12.status / 100) - 4],
    r12.config,
    r12.request,
    r12
  ));
}
const De0 = fn2.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t16, e, r12, n12, a, o) {
      const i = [t16 + "=" + encodeURIComponent(e)];
      me.isNumber(r12) && i.push("expires=" + new Date(r12).toGMTString()), me.isString(n12) && i.push("path=" + n12), me.isString(a) && i.push("domain=" + a), o === true && i.push("secure"), document.cookie = i.join("; ");
    },
    read(t16) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t16 + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t16) {
      this.write(t16, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function We0(t16) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t16);
}
function Ne0(t16, e) {
  return e ? t16.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t16;
}
function RVe(t16, e) {
  return t16 && !We0(e) ? Ne0(t16, e) : e;
}
const we0 = fn2.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), r12 = document.createElement("a");
    let n12;
    function a(o) {
      let i = o;
      return e && (r12.setAttribute("href", i), i = r12.href), r12.setAttribute("href", i), {
        href: r12.href,
        protocol: r12.protocol ? r12.protocol.replace(/:$/, "") : "",
        host: r12.host,
        search: r12.search ? r12.search.replace(/^\?/, "") : "",
        hash: r12.hash ? r12.hash.replace(/^#/, "") : "",
        hostname: r12.hostname,
        port: r12.port,
        pathname: r12.pathname.charAt(0) === "/" ? r12.pathname : "/" + r12.pathname
      };
    }
    return n12 = a(window.location.href), function(i) {
      const u = me.isString(i) ? a(i) : i;
      return u.protocol === n12.protocol && u.host === n12.host;
    };
  })()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ (function() {
    return function() {
      return true;
    };
  })()
);
function Be0(t16) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t16);
  return e && e[1] || "";
}
function xe0(t16, e) {
  t16 = t16 || 10;
  const r12 = new Array(t16), n12 = new Array(t16);
  let a = 0, o = 0, i;
  return e = e !== void 0 ? e : 1e3, function(s12) {
    const c = Date.now(), l2 = n12[o];
    i || (i = c), r12[a] = s12, n12[a] = c;
    let f = o, p = 0;
    for (; f !== a; )
      p += r12[f++], f = f % t16;
    if (a = (a + 1) % t16, a === o && (o = (o + 1) % t16), c - i < e)
      return;
    const d = l2 && c - l2;
    return d ? Math.round(p * 1e3 / d) : void 0;
  };
}
function Pte(t16, e) {
  let r12 = 0;
  const n12 = xe0(50, 250);
  return (a) => {
    const o = a.loaded, i = a.lengthComputable ? a.total : void 0, u = o - r12, s12 = n12(u), c = o <= i;
    r12 = o;
    const l2 = {
      loaded: o,
      total: i,
      progress: i ? o / i : void 0,
      bytes: u,
      rate: s12 || void 0,
      estimated: s12 && i && c ? (i - o) / s12 : void 0,
      event: a
    };
    l2[e ? "download" : "upload"] = true, t16(l2);
  };
}
const Ue0 = typeof XMLHttpRequest < "u", ke0 = Ue0 && function(t16) {
  return new Promise(function(r12, n12) {
    let a = t16.data;
    const o = Jn.from(t16.headers).normalize();
    let { responseType: i, withXSRFToken: u } = t16, s12;
    function c() {
      t16.cancelToken && t16.cancelToken.unsubscribe(s12), t16.signal && t16.signal.removeEventListener("abort", s12);
    }
    let l2;
    if (me.isFormData(a)) {
      if (fn2.hasStandardBrowserEnv || fn2.hasStandardBrowserWebWorkerEnv)
        o.setContentType(false);
      else if ((l2 = o.getContentType()) !== false) {
        const [z, ..._] = l2 ? l2.split(";").map((q) => q.trim()).filter(Boolean) : [];
        o.setContentType([z || "multipart/form-data", ..._].join("; "));
      }
    }
    let f = new XMLHttpRequest();
    if (t16.auth) {
      const z = t16.auth.username || "", _ = t16.auth.password ? unescape(encodeURIComponent(t16.auth.password)) : "";
      o.set("Authorization", "Basic " + btoa(z + ":" + _));
    }
    const p = RVe(t16.baseURL, t16.url);
    f.open(t16.method.toUpperCase(), AVe(p, t16.params, t16.paramsSerializer), true), f.timeout = t16.timeout;
    function d() {
      if (!f)
        return;
      const z = Jn.from(
        "getAllResponseHeaders" in f && f.getAllResponseHeaders()
      ), q = {
        data: !i || i === "text" || i === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: z,
        config: t16,
        request: f
      };
      Pe0(function(N) {
        r12(N), c();
      }, function(N) {
        n12(N), c();
      }, q), f = null;
    }
    if ("onloadend" in f ? f.onloadend = d : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(d);
    }, f.onabort = function() {
      f && (n12(new V0("Request aborted", V0.ECONNABORTED, t16, f)), f = null);
    }, f.onerror = function() {
      n12(new V0("Network Error", V0.ERR_NETWORK, t16, f)), f = null;
    }, f.ontimeout = function() {
      let _ = t16.timeout ? "timeout of " + t16.timeout + "ms exceeded" : "timeout exceeded";
      const q = t16.transitional || _Ve;
      t16.timeoutErrorMessage && (_ = t16.timeoutErrorMessage), n12(new V0(
        _,
        q.clarifyTimeoutError ? V0.ETIMEDOUT : V0.ECONNABORTED,
        t16,
        f
      )), f = null;
    }, fn2.hasStandardBrowserEnv && (u && me.isFunction(u) && (u = u(t16)), u || u !== false && we0(p))) {
      const z = t16.xsrfHeaderName && t16.xsrfCookieName && De0.read(t16.xsrfCookieName);
      z && o.set(t16.xsrfHeaderName, z);
    }
    a === void 0 && o.setContentType(null), "setRequestHeader" in f && me.forEach(o.toJSON(), function(_, q) {
      f.setRequestHeader(q, _);
    }), me.isUndefined(t16.withCredentials) || (f.withCredentials = !!t16.withCredentials), i && i !== "json" && (f.responseType = t16.responseType), typeof t16.onDownloadProgress == "function" && f.addEventListener("progress", Pte(t16.onDownloadProgress, true)), typeof t16.onUploadProgress == "function" && f.upload && f.upload.addEventListener("progress", Pte(t16.onUploadProgress)), (t16.cancelToken || t16.signal) && (s12 = (z) => {
      f && (n12(!z || z.type ? new uc(null, t16, f) : z), f.abort(), f = null);
    }, t16.cancelToken && t16.cancelToken.subscribe(s12), t16.signal && (t16.signal.aborted ? s12() : t16.signal.addEventListener("abort", s12)));
    const b = Be0(p);
    if (b && fn2.protocols.indexOf(b) === -1) {
      n12(new V0("Unsupported protocol " + b + ":", V0.ERR_BAD_REQUEST, t16));
      return;
    }
    f.send(a || null);
  });
}, xQ = {
  http: de0,
  xhr: ke0
};
me.forEach(xQ, (t16, e) => {
  if (t16) {
    try {
      Object.defineProperty(t16, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t16, "adapterName", { value: e });
  }
});
const Dte = (t16) => `- ${t16}`, je0 = (t16) => me.isFunction(t16) || t16 === null || t16 === false, qVe = {
  getAdapter: (t16) => {
    t16 = me.isArray(t16) ? t16 : [t16];
    const { length: e } = t16;
    let r12, n12;
    const a = {};
    for (let o = 0; o < e; o++) {
      r12 = t16[o];
      let i;
      if (n12 = r12, !je0(r12) && (n12 = xQ[(i = String(r12)).toLowerCase()], n12 === void 0))
        throw new V0(`Unknown adapter '${i}'`);
      if (n12)
        break;
      a[i || "#" + o] = n12;
    }
    if (!n12) {
      const o = Object.entries(a).map(
        ([u, s12]) => `adapter ${u} ` + (s12 === false ? "is not supported by the environment" : "is not available in the build")
      );
      let i = e ? o.length > 1 ? `since :
` + o.map(Dte).join(`
`) : " " + Dte(o[0]) : "as no adapter specified";
      throw new V0(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return n12;
  },
  adapters: xQ
};
function Ld(t16) {
  if (t16.cancelToken && t16.cancelToken.throwIfRequested(), t16.signal && t16.signal.aborted)
    throw new uc(null, t16);
}
function Wte(t16) {
  return Ld(t16), t16.headers = Jn.from(t16.headers), t16.data = Ed.call(
    t16,
    t16.transformRequest
  ), ["post", "put", "patch"].indexOf(t16.method) !== -1 && t16.headers.setContentType("application/x-www-form-urlencoded", false), qVe.getAdapter(t16.adapter || Tee.adapter)(t16).then(function(n12) {
    return Ld(t16), n12.data = Ed.call(
      t16,
      t16.transformResponse,
      n12
    ), n12.headers = Jn.from(n12.headers), n12;
  }, function(n12) {
    return mVe(n12) || (Ld(t16), n12 && n12.response && (n12.response.data = Ed.call(
      t16,
      t16.transformResponse,
      n12.response
    ), n12.response.headers = Jn.from(n12.response.headers))), Promise.reject(n12);
  });
}
const Nte = (t16) => t16 instanceof Jn ? t16.toJSON() : t16;
function zi(t16, e) {
  e = e || {};
  const r12 = {};
  function n12(c, l2, f) {
    return me.isPlainObject(c) && me.isPlainObject(l2) ? me.merge.call({ caseless: f }, c, l2) : me.isPlainObject(l2) ? me.merge({}, l2) : me.isArray(l2) ? l2.slice() : l2;
  }
  function a(c, l2, f) {
    if (me.isUndefined(l2)) {
      if (!me.isUndefined(c))
        return n12(void 0, c, f);
    } else
      return n12(c, l2, f);
  }
  function o(c, l2) {
    if (!me.isUndefined(l2))
      return n12(void 0, l2);
  }
  function i(c, l2) {
    if (me.isUndefined(l2)) {
      if (!me.isUndefined(c))
        return n12(void 0, c);
    } else
      return n12(void 0, l2);
  }
  function u(c, l2, f) {
    if (f in e)
      return n12(c, l2);
    if (f in t16)
      return n12(void 0, c);
  }
  const s12 = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: u,
    headers: (c, l2) => a(Nte(c), Nte(l2), true)
  };
  return me.forEach(Object.keys(Object.assign({}, t16, e)), function(l2) {
    const f = s12[l2] || a, p = f(t16[l2], e[l2], l2);
    me.isUndefined(p) && f !== u || (r12[l2] = p);
  }), r12;
}
const TVe = "1.6.5", yee = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t16, e) => {
  yee[t16] = function(n12) {
    return typeof n12 === t16 || "a" + (e < 1 ? "n " : " ") + t16;
  };
});
const wte = {};
yee.transitional = function(e, r12, n12) {
  function a(o, i) {
    return "[Axios v" + TVe + "] Transitional option '" + o + "'" + i + (n12 ? ". " + n12 : "");
  }
  return (o, i, u) => {
    if (e === false)
      throw new V0(
        a(i, " has been removed" + (r12 ? " in " + r12 : "")),
        V0.ERR_DEPRECATED
      );
    return r12 && !wte[i] && (wte[i] = true, console.warn(
      a(
        i,
        " has been deprecated since v" + r12 + " and will be removed in the near future"
      )
    )), e ? e(o, i, u) : true;
  };
};
function Fe0(t16, e, r12) {
  if (typeof t16 != "object")
    throw new V0("options must be an object", V0.ERR_BAD_OPTION_VALUE);
  const n12 = Object.keys(t16);
  let a = n12.length;
  for (; a-- > 0; ) {
    const o = n12[a], i = e[o];
    if (i) {
      const u = t16[o], s12 = u === void 0 || i(u, o, t16);
      if (s12 !== true)
        throw new V0("option " + o + " must be " + s12, V0.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r12 !== true)
      throw new V0("Unknown option " + o, V0.ERR_BAD_OPTION);
  }
}
const UQ = {
  assertOptions: Fe0,
  validators: yee
}, Aa = UQ.validators;
class M2 {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new Ete(),
      response: new Ete()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(e, r12) {
    typeof e == "string" ? (r12 = r12 || {}, r12.url = e) : r12 = e || {}, r12 = zi(this.defaults, r12);
    const { transitional: n12, paramsSerializer: a, headers: o } = r12;
    n12 !== void 0 && UQ.assertOptions(n12, {
      silentJSONParsing: Aa.transitional(Aa.boolean),
      forcedJSONParsing: Aa.transitional(Aa.boolean),
      clarifyTimeoutError: Aa.transitional(Aa.boolean)
    }, false), a != null && (me.isFunction(a) ? r12.paramsSerializer = {
      serialize: a
    } : UQ.assertOptions(a, {
      encode: Aa.function,
      serialize: Aa.function
    }, true)), r12.method = (r12.method || this.defaults.method || "get").toLowerCase();
    let i = o && me.merge(
      o.common,
      o[r12.method]
    );
    o && me.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (b) => {
        delete o[b];
      }
    ), r12.headers = Jn.concat(i, o);
    const u = [];
    let s12 = true;
    this.interceptors.request.forEach(function(z) {
      typeof z.runWhen == "function" && z.runWhen(r12) === false || (s12 = s12 && z.synchronous, u.unshift(z.fulfilled, z.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(z) {
      c.push(z.fulfilled, z.rejected);
    });
    let l2, f = 0, p;
    if (!s12) {
      const b = [Wte.bind(this), void 0];
      for (b.unshift.apply(b, u), b.push.apply(b, c), p = b.length, l2 = Promise.resolve(r12); f < p; )
        l2 = l2.then(b[f++], b[f++]);
      return l2;
    }
    p = u.length;
    let d = r12;
    for (f = 0; f < p; ) {
      const b = u[f++], z = u[f++];
      try {
        d = b(d);
      } catch (_) {
        z.call(this, _);
        break;
      }
    }
    try {
      l2 = Wte.call(this, d);
    } catch (b) {
      return Promise.reject(b);
    }
    for (f = 0, p = c.length; f < p; )
      l2 = l2.then(c[f++], c[f++]);
    return l2;
  }
  getUri(e) {
    e = zi(this.defaults, e);
    const r12 = RVe(e.baseURL, e.url);
    return AVe(r12, e.params, e.paramsSerializer);
  }
}
me.forEach(["delete", "get", "head", "options"], function(e) {
  M2.prototype[e] = function(r12, n12) {
    return this.request(zi(n12 || {}, {
      method: e,
      url: r12,
      data: (n12 || {}).data
    }));
  };
});
me.forEach(["post", "put", "patch"], function(e) {
  function r12(n12) {
    return function(o, i, u) {
      return this.request(zi(u || {}, {
        method: e,
        headers: n12 ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: i
      }));
    };
  }
  M2.prototype[e] = r12(), M2.prototype[e + "Form"] = r12(true);
});
const jl = M2;
class See {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let r12;
    this.promise = new Promise(function(o) {
      r12 = o;
    });
    const n12 = this;
    this.promise.then((a) => {
      if (!n12._listeners)
        return;
      let o = n12._listeners.length;
      for (; o-- > 0; )
        n12._listeners[o](a);
      n12._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const i = new Promise((u) => {
        n12.subscribe(u), o = u;
      }).then(a);
      return i.cancel = function() {
        n12.unsubscribe(o);
      }, i;
    }, e(function(o, i, u) {
      n12.reason || (n12.reason = new uc(o, i, u), r12(n12.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const r12 = this._listeners.indexOf(e);
    r12 !== -1 && this._listeners.splice(r12, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new See(function(a) {
        e = a;
      }),
      cancel: e
    };
  }
}
const Ve0 = See;
function He0(t16) {
  return function(r12) {
    return t16.apply(null, r12);
  };
}
function Xe0(t16) {
  return me.isObject(t16) && t16.isAxiosError === true;
}
const kQ = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(kQ).forEach(([t16, e]) => {
  kQ[e] = t16;
});
const $e0 = kQ;
function yVe(t16) {
  const e = new jl(t16), r12 = iVe(jl.prototype.request, e);
  return me.extend(r12, jl.prototype, e, { allOwnKeys: true }), me.extend(r12, e, null, { allOwnKeys: true }), r12.create = function(a) {
    return yVe(zi(t16, a));
  }, r12;
}
const V1 = yVe(Tee);
V1.Axios = jl;
V1.CanceledError = uc;
V1.CancelToken = Ve0;
V1.isCancel = mVe;
V1.VERSION = TVe;
V1.toFormData = up;
V1.AxiosError = V0;
V1.Cancel = V1.CanceledError;
V1.all = function(e) {
  return Promise.all(e);
};
V1.spread = He0;
V1.isAxiosError = Xe0;
V1.mergeConfig = zi;
V1.AxiosHeaders = Jn;
V1.formToJSON = (t16) => vVe(me.isHTMLForm(t16) ? new FormData(t16) : t16);
V1.getAdapter = qVe.getAdapter;
V1.HttpStatusCode = $e0;
V1.default = V1;
const Ge0 = {
  UNAUTHORIZED: 401
};
function tl(t16) {
  return Array.isArray(t16);
}
function Bte(t16) {
  return typeof t16 == "object" && t16 !== null && !Array.isArray(t16);
}
const a1 = {
  token: "",
  root: "hub.unanet.com/hub/",
  requestId: "",
  requestIdReset: true,
  globalHeaders: {},
  globalParams: {},
  additionalConfig: {},
  overrideConfig: {},
  endpoints: [],
  onRequest: (t16) => {
  },
  onResponse: (t16, e) => {
  },
  onTokenExpired: (t16, e) => {
  },
  onNotAuthorized: (t16, e) => {
  },
  inject: (t16) => {
    if (t16.cache === void 0 && (t16.cache = false), t16.method || (t16.method = "GET"), t16.headers || (t16.headers = {}), a1.globalHeaders && Object.assign(t16.headers, a1.globalHeaders), !t16.headers.Authorization && a1.token && (t16.headers.Authorization = `Bearer ${a1.token}`), t16.dataType || (t16.data instanceof FormData ? t16.headers["Content-Type"] = "multipart/form-data" : t16.dataType = "json"), t16.expects || (t16.expects = [200]), t16.params || (t16.params = {}), a1.globalParams && Object.assign(t16.params, a1.globalParams), a1.requestId && (t16.headers["X-Request-Id"] = a1.requestId, a1.requestIdReset && (a1.requestId = "")), t16.url = a1.root + (t16.base || "") + t16.url, t16.url = t16.url.replace(/([^/]+\/\.\.\/)/g, ""), t16.params) {
      const e = t16.params, n12 = t16.url.split(/(:[^/:0-9]+)/).map((o, i) => {
        if (i % 2 === 0)
          return o;
        const u = o.substring(1);
        if (u in e) {
          const s12 = e[u];
          return delete e[u], s12 === void 0 ? "" : encodeURIComponent(s12);
        }
        return "";
      });
      t16.url = n12.join("");
      const a = a1.getParameterPairs(t16.params);
      a.length > 0 && (t16.url += "?" + a.map(([o, i]) => `${o}=${i}`).join("&"));
    }
  },
  getParameterPairs(t16, e = [], r12 = "") {
    const n12 = (a, o) => {
      if (a === void 0)
        return;
      const i = r12 ? `${r12}[${o}]` : o;
      Bte(a) && !(a instanceof Date) || tl(a) ? this.getParameterPairs(a, e, i) : e.push([i, encodeURIComponent(a)]);
    };
    if (Bte(t16))
      for (const a in t16) {
        const o = t16[a], i = encodeURIComponent(a);
        n12(o, i);
      }
    if (tl(t16))
      for (let a = 0; a < t16.length; a++) {
        const o = t16[a];
        n12(o, String(a));
      }
    return e;
  },
  isAuthTokenExpired(t16) {
    var e, r12;
    return ((r12 = (e = t16 == null ? void 0 : t16.errors) == null ? void 0 : e[0]) == null ? void 0 : r12.message) === "Token is expired";
  },
  /**
   * The API restricts the number of results you can return, so if you need to return all the results no matter
   * how many you can use this function which will call the API as many times as needed to get all the results.
   *
   * ```ts
   * const projects = await API.allNext((batch) => Projects.search(request, batch));
   * ```
   *
   * @param getBatch Returns a promise to a paginated response.
   * @param options Custom limit, if any. A max number of calls can be specified to be safe. If this value is less than zero its interpreted as infinite.
   * @returns All the records at the requested call.
   */
  async allNext(t16, e) {
    const r12 = (e == null ? void 0 : e.maxCalls) ?? 0, n12 = {
      next: void 0,
      limit: 2e3,
      ...e || {}
    };
    let a = [], o = false, i = 0;
    for (; !o; ) {
      const u = await t16(n12);
      let s12 = 0;
      tl(u.results) && (a = a.concat(u.results), s12 = u.results.length), i++, n12.next = u.next, o = s12 === 0 || s12 < n12.limit || i === r12;
    }
    return a;
  },
  /**
   * The API restricts the number of results you can return, so if you need to return all the results no matter
   * how many you can use this function which will call the API as many times as needed to get all the results.
   *
   * ```ts
   * const projects = await API.all((batch) => Projects.search(request, batch));
   * const projectsOffset = await API.all((batch) => Projects.search(request, batch), { offset: 100 });
   * ```
   *
   * @param getBatch Returns a promise to a paginated response.
   * @param options Initial offset and custom limit, if any. A max number of calls can be specified to be safe. If this value is less than zero its interpreted as infinite.
   * @returns All the records at the requested call.
   */
  async all(t16, e) {
    const r12 = (e == null ? void 0 : e.maxCalls) ?? 0, n12 = {
      offset: 0,
      limit: 2e3,
      ...e || {}
    };
    let a = [], o = false, i = 0;
    for (; !o; ) {
      const u = await t16(n12);
      let s12 = 0;
      tl(u.results) && (a = a.concat(u.results), s12 = u.results.length), i++, n12.offset += n12.limit, o = s12 === 0 || u.offset + s12 >= u.total || i === r12;
    }
    return a;
  },
  getUrl(t16) {
    return a1.inject(t16), t16.url;
  },
  async call(t16, e) {
    a1.inject(t16);
    const r12 = {
      ...a1.additionalConfig,
      url: t16.url,
      method: t16.method,
      data: t16.data,
      responseType: t16.dataType,
      headers: t16.headers,
      onUploadProgress: t16.onUploadProgress,
      validateStatus: () => true,
      signal: e,
      ...a1.overrideConfig
    };
    let n12;
    this.onRequest(t16);
    try {
      n12 = await V1.request(r12);
    } catch (a) {
      if (n12 = a.response, !n12)
        throw a;
    }
    if (this.onResponse(n12, t16), !t16.expects || t16.expects.indexOf(n12.status) !== -1)
      return n12.data;
    throw this.isAuthTokenExpired(n12.data) && this.onTokenExpired(t16, n12), n12.status === Ge0.UNAUTHORIZED && this.onNotAuthorized(t16, n12), typeof n12.data == "object" ? n12.data : typeof n12.data == "string" ? new Error(n12.data) : new Error(n12.statusText);
  }
};
function xte(t16, e) {
  var r12 = Object.keys(t16);
  if (Object.getOwnPropertySymbols) {
    var n12 = Object.getOwnPropertySymbols(t16);
    e && (n12 = n12.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t16, a).enumerable;
    })), r12.push.apply(r12, n12);
  }
  return r12;
}
function He(t16) {
  for (var e = 1; e < arguments.length; e++) {
    var r12 = arguments[e] != null ? arguments[e] : {};
    e % 2 ? xte(Object(r12), true).forEach(function(n12) {
      Z1(t16, n12, r12[n12]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t16, Object.getOwnPropertyDescriptors(r12)) : xte(Object(r12)).forEach(function(n12) {
      Object.defineProperty(t16, n12, Object.getOwnPropertyDescriptor(r12, n12));
    });
  }
  return t16;
}
function O2(t16) {
  "@babel/helpers - typeof";
  return O2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, O2(t16);
}
function Ye0(t16, e) {
  if (!(t16 instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ute(t16, e) {
  for (var r12 = 0; r12 < e.length; r12++) {
    var n12 = e[r12];
    n12.enumerable = n12.enumerable || false, n12.configurable = true, "value" in n12 && (n12.writable = true), Object.defineProperty(t16, n12.key, n12);
  }
}
function Je0(t16, e, r12) {
  return e && Ute(t16.prototype, e), Object.defineProperty(t16, "prototype", {
    writable: false
  }), t16;
}
function Z1(t16, e, r12) {
  return e in t16 ? Object.defineProperty(t16, e, {
    value: r12,
    enumerable: true,
    configurable: true,
    writable: true
  }) : t16[e] = r12, t16;
}
function Cee(t16, e) {
  return Qe0(t16) || e00(t16, e) || SVe(t16, e) || r00();
}
function sc(t16) {
  return Ke0(t16) || Ze0(t16) || SVe(t16) || t00();
}
function Ke0(t16) {
  if (Array.isArray(t16))
    return jQ(t16);
}
function Qe0(t16) {
  if (Array.isArray(t16))
    return t16;
}
function Ze0(t16) {
  if (typeof Symbol < "u" && t16[Symbol.iterator] != null || t16["@@iterator"] != null)
    return Array.from(t16);
}
function e00(t16, e) {
  var r12 = t16 == null ? null : typeof Symbol < "u" && t16[Symbol.iterator] || t16["@@iterator"];
  if (r12 != null) {
    var n12 = [], a = true, o = false, i, u;
    try {
      for (r12 = r12.call(t16); !(a = (i = r12.next()).done) && (n12.push(i.value), !(e && n12.length === e)); a = true)
        ;
    } catch (s12) {
      o = true, u = s12;
    } finally {
      try {
        !a && r12.return != null && r12.return();
      } finally {
        if (o)
          throw u;
      }
    }
    return n12;
  }
}
function SVe(t16, e) {
  if (t16) {
    if (typeof t16 == "string")
      return jQ(t16, e);
    var r12 = Object.prototype.toString.call(t16).slice(8, -1);
    if (r12 === "Object" && t16.constructor && (r12 = t16.constructor.name), r12 === "Map" || r12 === "Set")
      return Array.from(t16);
    if (r12 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r12))
      return jQ(t16, e);
  }
}
function jQ(t16, e) {
  (e == null || e > t16.length) && (e = t16.length);
  for (var r12 = 0, n12 = new Array(e); r12 < e; r12++)
    n12[r12] = t16[r12];
  return n12;
}
function t00() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function r00() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var kte = function() {
}, gee = {}, CVe = {}, gVe = null, IVe = {
  mark: kte,
  measure: kte
};
try {
  typeof window < "u" && (gee = window), typeof document < "u" && (CVe = document), typeof MutationObserver < "u" && (gVe = MutationObserver), typeof performance < "u" && (IVe = performance);
} catch {
}
var n00 = gee.navigator || {}, jte = n00.userAgent, Fte = jte === void 0 ? "" : jte, xa = gee, O1 = CVe, Vte = gVe, rl = IVe;
xa.document;
var la = !!O1.documentElement && !!O1.head && typeof O1.addEventListener == "function" && typeof O1.createElement == "function", EVe = ~Fte.indexOf("MSIE") || ~Fte.indexOf("Trident/"), nl, al, ol, il, ul, ta = "___FONT_AWESOME___", FQ = 16, LVe = "fa", PVe = "svg-inline--fa", Ro = "data-fa-i2svg", VQ = "data-fa-pseudo-element", a00 = "data-fa-pseudo-element-pending", Iee = "data-prefix", Eee = "data-icon", Hte = "fontawesome-i2svg", o00 = "async", i00 = ["HTML", "HEAD", "STYLE", "SCRIPT"], DVe = (function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return false;
  }
})(), M1 = "classic", E1 = "sharp", Lee = [M1, E1];
function cc(t16) {
  return new Proxy(t16, {
    get: function(r12, n12) {
      return n12 in r12 ? r12[n12] : r12[M1];
    }
  });
}
var Cs = cc((nl = {}, Z1(nl, M1, {
  fa: "solid",
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  "fa-kit": "kit"
}), Z1(nl, E1, {
  fa: "solid",
  fass: "solid",
  "fa-solid": "solid",
  fasr: "regular",
  "fa-regular": "regular",
  fasl: "light",
  "fa-light": "light"
}), nl)), gs = cc((al = {}, Z1(al, M1, {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}), Z1(al, E1, {
  solid: "fass",
  regular: "fasr",
  light: "fasl"
}), al)), Is = cc((ol = {}, Z1(ol, M1, {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}), Z1(ol, E1, {
  fass: "fa-solid",
  fasr: "fa-regular",
  fasl: "fa-light"
}), ol)), u00 = cc((il = {}, Z1(il, M1, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), Z1(il, E1, {
  "fa-solid": "fass",
  "fa-regular": "fasr",
  "fa-light": "fasl"
}), il)), s00 = /fa(s|r|l|t|d|b|k|ss|sr|sl)?[\-\ ]/, WVe = "fa-layers-text", c00 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i, l00 = cc((ul = {}, Z1(ul, M1, {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}), Z1(ul, E1, {
  900: "fass",
  400: "fasr",
  300: "fasl"
}), ul)), NVe = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], p00 = NVe.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), d00 = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], po = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Es = /* @__PURE__ */ new Set();
Object.keys(gs[M1]).map(Es.add.bind(Es));
Object.keys(gs[E1]).map(Es.add.bind(Es));
var f00 = [].concat(Lee, sc(Es), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", po.GROUP, po.SWAP_OPACITY, po.PRIMARY, po.SECONDARY]).concat(NVe.map(function(t16) {
  return "".concat(t16, "x");
})).concat(p00.map(function(t16) {
  return "w-".concat(t16);
})), ls = xa.FontAwesomeConfig || {};
function b00(t16) {
  var e = O1.querySelector("script[" + t16 + "]");
  if (e)
    return e.getAttribute(t16);
}
function M00(t16) {
  return t16 === "" ? true : t16 === "false" ? false : t16 === "true" ? true : t16;
}
if (O1 && typeof O1.querySelector == "function") {
  var O00 = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  O00.forEach(function(t16) {
    var e = Cee(t16, 2), r12 = e[0], n12 = e[1], a = M00(b00(r12));
    a != null && (ls[n12] = a);
  });
}
var wVe = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: LVe,
  replacementClass: PVe,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: "async",
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};
ls.familyPrefix && (ls.cssPrefix = ls.familyPrefix);
var Ai = He(He({}, wVe), ls);
Ai.autoReplaceSvg || (Ai.observeMutations = false);
var t0 = {};
Object.keys(wVe).forEach(function(t16) {
  Object.defineProperty(t0, t16, {
    enumerable: true,
    set: function(r12) {
      Ai[t16] = r12, ps.forEach(function(n12) {
        return n12(t0);
      });
    },
    get: function() {
      return Ai[t16];
    }
  });
});
Object.defineProperty(t0, "familyPrefix", {
  enumerable: true,
  set: function(e) {
    Ai.cssPrefix = e, ps.forEach(function(r12) {
      return r12(t0);
    });
  },
  get: function() {
    return Ai.cssPrefix;
  }
});
xa.FontAwesomeConfig = t0;
var ps = [];
function z00(t16) {
  return ps.push(t16), function() {
    ps.splice(ps.indexOf(t16), 1);
  };
}
var _a = FQ, bn = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function A00(t16) {
  if (!(!t16 || !la)) {
    var e = O1.createElement("style");
    e.setAttribute("type", "text/css"), e.innerHTML = t16;
    for (var r12 = O1.head.childNodes, n12 = null, a = r12.length - 1; a > -1; a--) {
      var o = r12[a], i = (o.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(i) > -1 && (n12 = o);
    }
    return O1.head.insertBefore(e, n12), t16;
  }
}
var _00 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Ls() {
  for (var t16 = 12, e = ""; t16-- > 0; )
    e += _00[Math.random() * 62 | 0];
  return e;
}
function Di(t16) {
  for (var e = [], r12 = (t16 || []).length >>> 0; r12--; )
    e[r12] = t16[r12];
  return e;
}
function Pee(t16) {
  return t16.classList ? Di(t16.classList) : (t16.getAttribute("class") || "").split(" ").filter(function(e) {
    return e;
  });
}
function BVe(t16) {
  return "".concat(t16).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function h00(t16) {
  return Object.keys(t16 || {}).reduce(function(e, r12) {
    return e + "".concat(r12, '="').concat(BVe(t16[r12]), '" ');
  }, "").trim();
}
function cp(t16) {
  return Object.keys(t16 || {}).reduce(function(e, r12) {
    return e + "".concat(r12, ": ").concat(t16[r12].trim(), ";");
  }, "");
}
function Dee(t16) {
  return t16.size !== bn.size || t16.x !== bn.x || t16.y !== bn.y || t16.rotate !== bn.rotate || t16.flipX || t16.flipY;
}
function v00(t16) {
  var e = t16.transform, r12 = t16.containerWidth, n12 = t16.iconWidth, a = {
    transform: "translate(".concat(r12 / 2, " 256)")
  }, o = "translate(".concat(e.x * 32, ", ").concat(e.y * 32, ") "), i = "scale(".concat(e.size / 16 * (e.flipX ? -1 : 1), ", ").concat(e.size / 16 * (e.flipY ? -1 : 1), ") "), u = "rotate(".concat(e.rotate, " 0 0)"), s12 = {
    transform: "".concat(o, " ").concat(i, " ").concat(u)
  }, c = {
    transform: "translate(".concat(n12 / 2 * -1, " -256)")
  };
  return {
    outer: a,
    inner: s12,
    path: c
  };
}
function m00(t16) {
  var e = t16.transform, r12 = t16.width, n12 = r12 === void 0 ? FQ : r12, a = t16.height, o = a === void 0 ? FQ : a, s12 = "";
  return EVe ? s12 += "translate(".concat(e.x / _a - n12 / 2, "em, ").concat(e.y / _a - o / 2, "em) ") : s12 += "translate(calc(-50% + ".concat(e.x / _a, "em), calc(-50% + ").concat(e.y / _a, "em)) "), s12 += "scale(".concat(e.size / _a * (e.flipX ? -1 : 1), ", ").concat(e.size / _a * (e.flipY ? -1 : 1), ") "), s12 += "rotate(".concat(e.rotate, "deg) "), s12;
}
var R00 = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
            transition-delay: 0s;
    -webkit-transition-duration: 0s;
            transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, none));
          transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function xVe() {
  var t16 = LVe, e = PVe, r12 = t0.cssPrefix, n12 = t0.replacementClass, a = R00;
  if (r12 !== t16 || n12 !== e) {
    var o = new RegExp("\\.".concat(t16, "\\-"), "g"), i = new RegExp("\\--".concat(t16, "\\-"), "g"), u = new RegExp("\\.".concat(e), "g");
    a = a.replace(o, ".".concat(r12, "-")).replace(i, "--".concat(r12, "-")).replace(u, ".".concat(n12));
  }
  return a;
}
var Xte = false;
function Pd() {
  t0.autoAddCss && !Xte && (A00(xVe()), Xte = true);
}
var q00 = {
  mixout: function() {
    return {
      dom: {
        css: xVe,
        insertCss: Pd
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        Pd();
      },
      beforeI2svg: function() {
        Pd();
      }
    };
  }
}, ra = xa || {};
ra[ta] || (ra[ta] = {});
ra[ta].styles || (ra[ta].styles = {});
ra[ta].hooks || (ra[ta].hooks = {});
ra[ta].shims || (ra[ta].shims = []);
var Xr = ra[ta], UVe = [], T00 = function t() {
  O1.removeEventListener("DOMContentLoaded", t), z2 = 1, UVe.map(function(e) {
    return e();
  });
}, z2 = false;
la && (z2 = (O1.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(O1.readyState), z2 || O1.addEventListener("DOMContentLoaded", T00));
function y00(t16) {
  la && (z2 ? setTimeout(t16, 0) : UVe.push(t16));
}
function lc(t16) {
  var e = t16.tag, r12 = t16.attributes, n12 = r12 === void 0 ? {} : r12, a = t16.children, o = a === void 0 ? [] : a;
  return typeof t16 == "string" ? BVe(t16) : "<".concat(e, " ").concat(h00(n12), ">").concat(o.map(lc).join(""), "</").concat(e, ">");
}
function $te(t16, e, r12) {
  if (t16 && t16[e] && t16[e][r12])
    return {
      prefix: e,
      iconName: r12,
      icon: t16[e][r12]
    };
}
var Dd = function(e, r12, n12, a) {
  var o = Object.keys(e), i = o.length, u = r12, s12, c, l2;
  for (n12 === void 0 ? (s12 = 1, l2 = e[o[0]]) : (s12 = 0, l2 = n12); s12 < i; s12++)
    c = o[s12], l2 = u(l2, e[c], c, e);
  return l2;
};
function C00(t16) {
  for (var e = [], r12 = 0, n12 = t16.length; r12 < n12; ) {
    var a = t16.charCodeAt(r12++);
    if (a >= 55296 && a <= 56319 && r12 < n12) {
      var o = t16.charCodeAt(r12++);
      (o & 64512) == 56320 ? e.push(((a & 1023) << 10) + (o & 1023) + 65536) : (e.push(a), r12--);
    } else
      e.push(a);
  }
  return e;
}
function HQ(t16) {
  var e = C00(t16);
  return e.length === 1 ? e[0].toString(16) : null;
}
function g00(t16, e) {
  var r12 = t16.length, n12 = t16.charCodeAt(e), a;
  return n12 >= 55296 && n12 <= 56319 && r12 > e + 1 && (a = t16.charCodeAt(e + 1), a >= 56320 && a <= 57343) ? (n12 - 55296) * 1024 + a - 56320 + 65536 : n12;
}
function Gte(t16) {
  return Object.keys(t16).reduce(function(e, r12) {
    var n12 = t16[r12], a = !!n12.icon;
    return a ? e[n12.iconName] = n12.icon : e[r12] = n12, e;
  }, {});
}
function XQ(t16, e) {
  var r12 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n12 = r12.skipHooks, a = n12 === void 0 ? false : n12, o = Gte(e);
  typeof Xr.hooks.addPack == "function" && !a ? Xr.hooks.addPack(t16, Gte(e)) : Xr.styles[t16] = He(He({}, Xr.styles[t16] || {}), o), t16 === "fas" && XQ("fa", e);
}
var sl, cl, ll, ei = Xr.styles, I00 = Xr.shims, E00 = (sl = {}, Z1(sl, M1, Object.values(Is[M1])), Z1(sl, E1, Object.values(Is[E1])), sl), Wee = null, kVe = {}, jVe = {}, FVe = {}, VVe = {}, HVe = {}, L00 = (cl = {}, Z1(cl, M1, Object.keys(Cs[M1])), Z1(cl, E1, Object.keys(Cs[E1])), cl);
function P00(t16) {
  return ~f00.indexOf(t16);
}
function D00(t16, e) {
  var r12 = e.split("-"), n12 = r12[0], a = r12.slice(1).join("-");
  return n12 === t16 && a !== "" && !P00(a) ? a : null;
}
var XVe = function() {
  var e = function(o) {
    return Dd(ei, function(i, u, s12) {
      return i[s12] = Dd(u, o, {}), i;
    }, {});
  };
  kVe = e(function(a, o, i) {
    if (o[3] && (a[o[3]] = i), o[2]) {
      var u = o[2].filter(function(s12) {
        return typeof s12 == "number";
      });
      u.forEach(function(s12) {
        a[s12.toString(16)] = i;
      });
    }
    return a;
  }), jVe = e(function(a, o, i) {
    if (a[i] = i, o[2]) {
      var u = o[2].filter(function(s12) {
        return typeof s12 == "string";
      });
      u.forEach(function(s12) {
        a[s12] = i;
      });
    }
    return a;
  }), HVe = e(function(a, o, i) {
    var u = o[2];
    return a[i] = i, u.forEach(function(s12) {
      a[s12] = i;
    }), a;
  });
  var r12 = "far" in ei || t0.autoFetchSvg, n12 = Dd(I00, function(a, o) {
    var i = o[0], u = o[1], s12 = o[2];
    return u === "far" && !r12 && (u = "fas"), typeof i == "string" && (a.names[i] = {
      prefix: u,
      iconName: s12
    }), typeof i == "number" && (a.unicodes[i.toString(16)] = {
      prefix: u,
      iconName: s12
    }), a;
  }, {
    names: {},
    unicodes: {}
  });
  FVe = n12.names, VVe = n12.unicodes, Wee = lp(t0.styleDefault, {
    family: t0.familyDefault
  });
};
z00(function(t16) {
  Wee = lp(t16.styleDefault, {
    family: t0.familyDefault
  });
});
XVe();
function Nee(t16, e) {
  return (kVe[t16] || {})[e];
}
function W00(t16, e) {
  return (jVe[t16] || {})[e];
}
function fo(t16, e) {
  return (HVe[t16] || {})[e];
}
function $Ve(t16) {
  return FVe[t16] || {
    prefix: null,
    iconName: null
  };
}
function N00(t16) {
  var e = VVe[t16], r12 = Nee("fas", t16);
  return e || (r12 ? {
    prefix: "fas",
    iconName: r12
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Ua() {
  return Wee;
}
var wee = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function lp(t16) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r12 = e.family, n12 = r12 === void 0 ? M1 : r12, a = Cs[n12][t16], o = gs[n12][t16] || gs[n12][a], i = t16 in Xr.styles ? t16 : null;
  return o || i || null;
}
var Yte = (ll = {}, Z1(ll, M1, Object.keys(Is[M1])), Z1(ll, E1, Object.keys(Is[E1])), ll);
function pp(t16) {
  var e, r12 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n12 = r12.skipLookups, a = n12 === void 0 ? false : n12, o = (e = {}, Z1(e, M1, "".concat(t0.cssPrefix, "-").concat(M1)), Z1(e, E1, "".concat(t0.cssPrefix, "-").concat(E1)), e), i = null, u = M1;
  (t16.includes(o[M1]) || t16.some(function(c) {
    return Yte[M1].includes(c);
  })) && (u = M1), (t16.includes(o[E1]) || t16.some(function(c) {
    return Yte[E1].includes(c);
  })) && (u = E1);
  var s12 = t16.reduce(function(c, l2) {
    var f = D00(t0.cssPrefix, l2);
    if (ei[l2] ? (l2 = E00[u].includes(l2) ? u00[u][l2] : l2, i = l2, c.prefix = l2) : L00[u].indexOf(l2) > -1 ? (i = l2, c.prefix = lp(l2, {
      family: u
    })) : f ? c.iconName = f : l2 !== t0.replacementClass && l2 !== o[M1] && l2 !== o[E1] && c.rest.push(l2), !a && c.prefix && c.iconName) {
      var p = i === "fa" ? $Ve(c.iconName) : {}, d = fo(c.prefix, c.iconName);
      p.prefix && (i = null), c.iconName = p.iconName || d || c.iconName, c.prefix = p.prefix || c.prefix, c.prefix === "far" && !ei.far && ei.fas && !t0.autoFetchSvg && (c.prefix = "fas");
    }
    return c;
  }, wee());
  return (t16.includes("fa-brands") || t16.includes("fab")) && (s12.prefix = "fab"), (t16.includes("fa-duotone") || t16.includes("fad")) && (s12.prefix = "fad"), !s12.prefix && u === E1 && (ei.fass || t0.autoFetchSvg) && (s12.prefix = "fass", s12.iconName = fo(s12.prefix, s12.iconName) || s12.iconName), (s12.prefix === "fa" || i === "fa") && (s12.prefix = Ua() || "fas"), s12;
}
var w00 = /* @__PURE__ */ (function() {
  function t16() {
    Ye0(this, t16), this.definitions = {};
  }
  return Je0(t16, [{
    key: "add",
    value: function() {
      for (var r12 = this, n12 = arguments.length, a = new Array(n12), o = 0; o < n12; o++)
        a[o] = arguments[o];
      var i = a.reduce(this._pullDefinitions, {});
      Object.keys(i).forEach(function(u) {
        r12.definitions[u] = He(He({}, r12.definitions[u] || {}), i[u]), XQ(u, i[u]);
        var s12 = Is[M1][u];
        s12 && XQ(s12, i[u]), XVe();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(r12, n12) {
      var a = n12.prefix && n12.iconName && n12.icon ? {
        0: n12
      } : n12;
      return Object.keys(a).map(function(o) {
        var i = a[o], u = i.prefix, s12 = i.iconName, c = i.icon, l2 = c[2];
        r12[u] || (r12[u] = {}), l2.length > 0 && l2.forEach(function(f) {
          typeof f == "string" && (r12[u][f] = c);
        }), r12[u][s12] = c;
      }), r12;
    }
  }]), t16;
})(), Jte = [], ti = {}, si = {}, B00 = Object.keys(si);
function x00(t16, e) {
  var r12 = e.mixoutsTo;
  return Jte = t16, ti = {}, Object.keys(si).forEach(function(n12) {
    B00.indexOf(n12) === -1 && delete si[n12];
  }), Jte.forEach(function(n12) {
    var a = n12.mixout ? n12.mixout() : {};
    if (Object.keys(a).forEach(function(i) {
      typeof a[i] == "function" && (r12[i] = a[i]), O2(a[i]) === "object" && Object.keys(a[i]).forEach(function(u) {
        r12[i] || (r12[i] = {}), r12[i][u] = a[i][u];
      });
    }), n12.hooks) {
      var o = n12.hooks();
      Object.keys(o).forEach(function(i) {
        ti[i] || (ti[i] = []), ti[i].push(o[i]);
      });
    }
    n12.provides && n12.provides(si);
  }), r12;
}
function $Q(t16, e) {
  for (var r12 = arguments.length, n12 = new Array(r12 > 2 ? r12 - 2 : 0), a = 2; a < r12; a++)
    n12[a - 2] = arguments[a];
  var o = ti[t16] || [];
  return o.forEach(function(i) {
    e = i.apply(null, [e].concat(n12));
  }), e;
}
function qo(t16) {
  for (var e = arguments.length, r12 = new Array(e > 1 ? e - 1 : 0), n12 = 1; n12 < e; n12++)
    r12[n12 - 1] = arguments[n12];
  var a = ti[t16] || [];
  a.forEach(function(o) {
    o.apply(null, r12);
  });
}
function na() {
  var t16 = arguments[0], e = Array.prototype.slice.call(arguments, 1);
  return si[t16] ? si[t16].apply(null, e) : void 0;
}
function GQ(t16) {
  t16.prefix === "fa" && (t16.prefix = "fas");
  var e = t16.iconName, r12 = t16.prefix || Ua();
  if (e)
    return e = fo(r12, e) || e, $te(GVe.definitions, r12, e) || $te(Xr.styles, r12, e);
}
var GVe = new w00(), U00 = function() {
  t0.autoReplaceSvg = false, t0.observeMutations = false, qo("noAuto");
}, k00 = {
  i2svg: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return la ? (qo("beforeI2svg", e), na("pseudoElements2svg", e), na("i2svg", e)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r12 = e.autoReplaceSvgRoot;
    t0.autoReplaceSvg === false && (t0.autoReplaceSvg = true), t0.observeMutations = true, y00(function() {
      F00({
        autoReplaceSvgRoot: r12
      }), qo("watch", e);
    });
  }
}, j00 = {
  icon: function(e) {
    if (e === null)
      return null;
    if (O2(e) === "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: fo(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      var r12 = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], n12 = lp(e[0]);
      return {
        prefix: n12,
        iconName: fo(n12, r12) || r12
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(t0.cssPrefix, "-")) > -1 || e.match(s00))) {
      var a = pp(e.split(" "), {
        skipLookups: true
      });
      return {
        prefix: a.prefix || Ua(),
        iconName: fo(a.prefix, a.iconName) || a.iconName
      };
    }
    if (typeof e == "string") {
      var o = Ua();
      return {
        prefix: o,
        iconName: fo(o, e) || e
      };
    }
  }
}, sr = {
  noAuto: U00,
  config: t0,
  dom: k00,
  parse: j00,
  library: GVe,
  findIconDefinition: GQ,
  toHtml: lc
}, F00 = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r12 = e.autoReplaceSvgRoot, n12 = r12 === void 0 ? O1 : r12;
  (Object.keys(Xr.styles).length > 0 || t0.autoFetchSvg) && la && t0.autoReplaceSvg && sr.dom.i2svg({
    node: n12
  });
};
function dp(t16, e) {
  return Object.defineProperty(t16, "abstract", {
    get: e
  }), Object.defineProperty(t16, "html", {
    get: function() {
      return t16.abstract.map(function(n12) {
        return lc(n12);
      });
    }
  }), Object.defineProperty(t16, "node", {
    get: function() {
      if (la) {
        var n12 = O1.createElement("div");
        return n12.innerHTML = t16.html, n12.children;
      }
    }
  }), t16;
}
function V00(t16) {
  var e = t16.children, r12 = t16.main, n12 = t16.mask, a = t16.attributes, o = t16.styles, i = t16.transform;
  if (Dee(i) && r12.found && !n12.found) {
    var u = r12.width, s12 = r12.height, c = {
      x: u / s12 / 2,
      y: 0.5
    };
    a.style = cp(He(He({}, o), {}, {
      "transform-origin": "".concat(c.x + i.x / 16, "em ").concat(c.y + i.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: a,
    children: e
  }];
}
function H00(t16) {
  var e = t16.prefix, r12 = t16.iconName, n12 = t16.children, a = t16.attributes, o = t16.symbol, i = o === true ? "".concat(e, "-").concat(t0.cssPrefix, "-").concat(r12) : o;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: He(He({}, a), {}, {
        id: i
      }),
      children: n12
    }]
  }];
}
function Bee(t16) {
  var e = t16.icons, r12 = e.main, n12 = e.mask, a = t16.prefix, o = t16.iconName, i = t16.transform, u = t16.symbol, s12 = t16.title, c = t16.maskId, l2 = t16.titleId, f = t16.extra, p = t16.watchable, d = p === void 0 ? false : p, b = n12.found ? n12 : r12, z = b.width, _ = b.height, q = a === "fak", S = [t0.replacementClass, o ? "".concat(t0.cssPrefix, "-").concat(o) : ""].filter(function(j) {
    return f.classes.indexOf(j) === -1;
  }).filter(function(j) {
    return j !== "" || !!j;
  }).concat(f.classes).join(" "), N = {
    children: [],
    attributes: He(He({}, f.attributes), {}, {
      "data-prefix": a,
      "data-icon": o,
      class: S,
      role: f.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(z, " ").concat(_)
    })
  }, v = q && !~f.classes.indexOf("fa-fw") ? {
    width: "".concat(z / _ * 16 * 0.0625, "em")
  } : {};
  d && (N.attributes[Ro] = ""), s12 && (N.children.push({
    tag: "title",
    attributes: {
      id: N.attributes["aria-labelledby"] || "title-".concat(l2 || Ls())
    },
    children: [s12]
  }), delete N.attributes.title);
  var C = He(He({}, N), {}, {
    prefix: a,
    iconName: o,
    main: r12,
    mask: n12,
    maskId: c,
    transform: i,
    symbol: u,
    styles: He(He({}, v), f.styles)
  }), L = n12.found && r12.found ? na("generateAbstractMask", C) || {
    children: [],
    attributes: {}
  } : na("generateAbstractIcon", C) || {
    children: [],
    attributes: {}
  }, B = L.children, P12 = L.attributes;
  return C.children = B, C.attributes = P12, u ? H00(C) : V00(C);
}
function Kte(t16) {
  var e = t16.content, r12 = t16.width, n12 = t16.height, a = t16.transform, o = t16.title, i = t16.extra, u = t16.watchable, s12 = u === void 0 ? false : u, c = He(He(He({}, i.attributes), o ? {
    title: o
  } : {}), {}, {
    class: i.classes.join(" ")
  });
  s12 && (c[Ro] = "");
  var l2 = He({}, i.styles);
  Dee(a) && (l2.transform = m00({
    transform: a,
    width: r12,
    height: n12
  }), l2["-webkit-transform"] = l2.transform);
  var f = cp(l2);
  f.length > 0 && (c.style = f);
  var p = [];
  return p.push({
    tag: "span",
    attributes: c,
    children: [e]
  }), o && p.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [o]
  }), p;
}
function X00(t16) {
  var e = t16.content, r12 = t16.title, n12 = t16.extra, a = He(He(He({}, n12.attributes), r12 ? {
    title: r12
  } : {}), {}, {
    class: n12.classes.join(" ")
  }), o = cp(n12.styles);
  o.length > 0 && (a.style = o);
  var i = [];
  return i.push({
    tag: "span",
    attributes: a,
    children: [e]
  }), r12 && i.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [r12]
  }), i;
}
var Wd = Xr.styles;
function YQ(t16) {
  var e = t16[0], r12 = t16[1], n12 = t16.slice(4), a = Cee(n12, 1), o = a[0], i = null;
  return Array.isArray(o) ? i = {
    tag: "g",
    attributes: {
      class: "".concat(t0.cssPrefix, "-").concat(po.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(t0.cssPrefix, "-").concat(po.SECONDARY),
        fill: "currentColor",
        d: o[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(t0.cssPrefix, "-").concat(po.PRIMARY),
        fill: "currentColor",
        d: o[1]
      }
    }]
  } : i = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: o
    }
  }, {
    found: true,
    width: e,
    height: r12,
    icon: i
  };
}
var $00 = {
  found: false,
  width: 512,
  height: 512
};
function G00(t16, e) {
  !DVe && !t0.showMissingIcons && t16 && console.error('Icon with name "'.concat(t16, '" and prefix "').concat(e, '" is missing.'));
}
function JQ(t16, e) {
  var r12 = e;
  return e === "fa" && t0.styleDefault !== null && (e = Ua()), new Promise(function(n12, a) {
    if (na("missingIconAbstract"), r12 === "fa") {
      var o = $Ve(t16) || {};
      t16 = o.iconName || t16, e = o.prefix || e;
    }
    if (t16 && e && Wd[e] && Wd[e][t16]) {
      var i = Wd[e][t16];
      return n12(YQ(i));
    }
    G00(t16, e), n12(He(He({}, $00), {}, {
      icon: t0.showMissingIcons && t16 ? na("missingIconAbstract") || {} : {}
    }));
  });
}
var Qte = function() {
}, KQ = t0.measurePerformance && rl && rl.mark && rl.measure ? rl : {
  mark: Qte,
  measure: Qte
}, es = 'FA "6.4.2"', Y00 = function(e) {
  return KQ.mark("".concat(es, " ").concat(e, " begins")), function() {
    return YVe(e);
  };
}, YVe = function(e) {
  KQ.mark("".concat(es, " ").concat(e, " ends")), KQ.measure("".concat(es, " ").concat(e), "".concat(es, " ").concat(e, " begins"), "".concat(es, " ").concat(e, " ends"));
}, xee = {
  begin: Y00,
  end: YVe
}, Fl = function() {
};
function Zte(t16) {
  var e = t16.getAttribute ? t16.getAttribute(Ro) : null;
  return typeof e == "string";
}
function J00(t16) {
  var e = t16.getAttribute ? t16.getAttribute(Iee) : null, r12 = t16.getAttribute ? t16.getAttribute(Eee) : null;
  return e && r12;
}
function K00(t16) {
  return t16 && t16.classList && t16.classList.contains && t16.classList.contains(t0.replacementClass);
}
function Q00() {
  if (t0.autoReplaceSvg === true)
    return Vl.replace;
  var t16 = Vl[t0.autoReplaceSvg];
  return t16 || Vl.replace;
}
function Z00(t16) {
  return O1.createElementNS("http://www.w3.org/2000/svg", t16);
}
function e10(t16) {
  return O1.createElement(t16);
}
function JVe(t16) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r12 = e.ceFn, n12 = r12 === void 0 ? t16.tag === "svg" ? Z00 : e10 : r12;
  if (typeof t16 == "string")
    return O1.createTextNode(t16);
  var a = n12(t16.tag);
  Object.keys(t16.attributes || []).forEach(function(i) {
    a.setAttribute(i, t16.attributes[i]);
  });
  var o = t16.children || [];
  return o.forEach(function(i) {
    a.appendChild(JVe(i, {
      ceFn: n12
    }));
  }), a;
}
function t10(t16) {
  var e = " ".concat(t16.outerHTML, " ");
  return e = "".concat(e, "Font Awesome fontawesome.com "), e;
}
var Vl = {
  replace: function(e) {
    var r12 = e[0];
    if (r12.parentNode)
      if (e[1].forEach(function(a) {
        r12.parentNode.insertBefore(JVe(a), r12);
      }), r12.getAttribute(Ro) === null && t0.keepOriginalSource) {
        var n12 = O1.createComment(t10(r12));
        r12.parentNode.replaceChild(n12, r12);
      } else
        r12.remove();
  },
  nest: function(e) {
    var r12 = e[0], n12 = e[1];
    if (~Pee(r12).indexOf(t0.replacementClass))
      return Vl.replace(e);
    var a = new RegExp("".concat(t0.cssPrefix, "-.*"));
    if (delete n12[0].attributes.id, n12[0].attributes.class) {
      var o = n12[0].attributes.class.split(" ").reduce(function(u, s12) {
        return s12 === t0.replacementClass || s12.match(a) ? u.toSvg.push(s12) : u.toNode.push(s12), u;
      }, {
        toNode: [],
        toSvg: []
      });
      n12[0].attributes.class = o.toSvg.join(" "), o.toNode.length === 0 ? r12.removeAttribute("class") : r12.setAttribute("class", o.toNode.join(" "));
    }
    var i = n12.map(function(u) {
      return lc(u);
    }).join(`
`);
    r12.setAttribute(Ro, ""), r12.innerHTML = i;
  }
};
function ere(t16) {
  t16();
}
function KVe(t16, e) {
  var r12 = typeof e == "function" ? e : Fl;
  if (t16.length === 0)
    r12();
  else {
    var n12 = ere;
    t0.mutateApproach === o00 && (n12 = xa.requestAnimationFrame || ere), n12(function() {
      var a = Q00(), o = xee.begin("mutate");
      t16.map(a), o(), r12();
    });
  }
}
var Uee = false;
function QVe() {
  Uee = true;
}
function QQ() {
  Uee = false;
}
var A2 = null;
function tre(t16) {
  if (Vte && t0.observeMutations) {
    var e = t16.treeCallback, r12 = e === void 0 ? Fl : e, n12 = t16.nodeCallback, a = n12 === void 0 ? Fl : n12, o = t16.pseudoElementsCallback, i = o === void 0 ? Fl : o, u = t16.observeMutationsRoot, s12 = u === void 0 ? O1 : u;
    A2 = new Vte(function(c) {
      if (!Uee) {
        var l2 = Ua();
        Di(c).forEach(function(f) {
          if (f.type === "childList" && f.addedNodes.length > 0 && !Zte(f.addedNodes[0]) && (t0.searchPseudoElements && i(f.target), r12(f.target)), f.type === "attributes" && f.target.parentNode && t0.searchPseudoElements && i(f.target.parentNode), f.type === "attributes" && Zte(f.target) && ~d00.indexOf(f.attributeName))
            if (f.attributeName === "class" && J00(f.target)) {
              var p = pp(Pee(f.target)), d = p.prefix, b = p.iconName;
              f.target.setAttribute(Iee, d || l2), b && f.target.setAttribute(Eee, b);
            } else
              K00(f.target) && a(f.target);
        });
      }
    }), la && A2.observe(s12, {
      childList: true,
      attributes: true,
      characterData: true,
      subtree: true
    });
  }
}
function r10() {
  A2 && A2.disconnect();
}
function n10(t16) {
  var e = t16.getAttribute("style"), r12 = [];
  return e && (r12 = e.split(";").reduce(function(n12, a) {
    var o = a.split(":"), i = o[0], u = o.slice(1);
    return i && u.length > 0 && (n12[i] = u.join(":").trim()), n12;
  }, {})), r12;
}
function a10(t16) {
  var e = t16.getAttribute("data-prefix"), r12 = t16.getAttribute("data-icon"), n12 = t16.innerText !== void 0 ? t16.innerText.trim() : "", a = pp(Pee(t16));
  return a.prefix || (a.prefix = Ua()), e && r12 && (a.prefix = e, a.iconName = r12), a.iconName && a.prefix || (a.prefix && n12.length > 0 && (a.iconName = W00(a.prefix, t16.innerText) || Nee(a.prefix, HQ(t16.innerText))), !a.iconName && t0.autoFetchSvg && t16.firstChild && t16.firstChild.nodeType === Node.TEXT_NODE && (a.iconName = t16.firstChild.data)), a;
}
function o10(t16) {
  var e = Di(t16.attributes).reduce(function(a, o) {
    return a.name !== "class" && a.name !== "style" && (a[o.name] = o.value), a;
  }, {}), r12 = t16.getAttribute("title"), n12 = t16.getAttribute("data-fa-title-id");
  return t0.autoA11y && (r12 ? e["aria-labelledby"] = "".concat(t0.replacementClass, "-title-").concat(n12 || Ls()) : (e["aria-hidden"] = "true", e.focusable = "false")), e;
}
function i10() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: bn,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function rre(t16) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: true
  }, r12 = a10(t16), n12 = r12.iconName, a = r12.prefix, o = r12.rest, i = o10(t16), u = $Q("parseNodeAttributes", {}, t16), s12 = e.styleParser ? n10(t16) : [];
  return He({
    iconName: n12,
    title: t16.getAttribute("title"),
    titleId: t16.getAttribute("data-fa-title-id"),
    prefix: a,
    transform: bn,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: o,
      styles: s12,
      attributes: i
    }
  }, u);
}
var u10 = Xr.styles;
function ZVe(t16) {
  var e = t0.autoReplaceSvg === "nest" ? rre(t16, {
    styleParser: false
  }) : rre(t16);
  return ~e.extra.classes.indexOf(WVe) ? na("generateLayersText", t16, e) : na("generateSvgReplacementMutation", t16, e);
}
var ka = /* @__PURE__ */ new Set();
Lee.map(function(t16) {
  ka.add("fa-".concat(t16));
});
Object.keys(Cs[M1]).map(ka.add.bind(ka));
Object.keys(Cs[E1]).map(ka.add.bind(ka));
ka = sc(ka);
function nre(t16) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!la)
    return Promise.resolve();
  var r12 = O1.documentElement.classList, n12 = function(f) {
    return r12.add("".concat(Hte, "-").concat(f));
  }, a = function(f) {
    return r12.remove("".concat(Hte, "-").concat(f));
  }, o = t0.autoFetchSvg ? ka : Lee.map(function(l2) {
    return "fa-".concat(l2);
  }).concat(Object.keys(u10));
  o.includes("fa") || o.push("fa");
  var i = [".".concat(WVe, ":not([").concat(Ro, "])")].concat(o.map(function(l2) {
    return ".".concat(l2, ":not([").concat(Ro, "])");
  })).join(", ");
  if (i.length === 0)
    return Promise.resolve();
  var u = [];
  try {
    u = Di(t16.querySelectorAll(i));
  } catch {
  }
  if (u.length > 0)
    n12("pending"), a("complete");
  else
    return Promise.resolve();
  var s12 = xee.begin("onTree"), c = u.reduce(function(l2, f) {
    try {
      var p = ZVe(f);
      p && l2.push(p);
    } catch (d) {
      DVe || d.name === "MissingIcon" && console.error(d);
    }
    return l2;
  }, []);
  return new Promise(function(l2, f) {
    Promise.all(c).then(function(p) {
      KVe(p, function() {
        n12("active"), n12("complete"), a("pending"), typeof e == "function" && e(), s12(), l2();
      });
    }).catch(function(p) {
      s12(), f(p);
    });
  });
}
function s10(t16) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  ZVe(t16).then(function(r12) {
    r12 && KVe([r12], e);
  });
}
function c10(t16) {
  return function(e) {
    var r12 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n12 = (e || {}).icon ? e : GQ(e || {}), a = r12.mask;
    return a && (a = (a || {}).icon ? a : GQ(a || {})), t16(n12, He(He({}, r12), {}, {
      mask: a
    }));
  };
}
var l10 = function(e) {
  var r12 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n12 = r12.transform, a = n12 === void 0 ? bn : n12, o = r12.symbol, i = o === void 0 ? false : o, u = r12.mask, s12 = u === void 0 ? null : u, c = r12.maskId, l2 = c === void 0 ? null : c, f = r12.title, p = f === void 0 ? null : f, d = r12.titleId, b = d === void 0 ? null : d, z = r12.classes, _ = z === void 0 ? [] : z, q = r12.attributes, S = q === void 0 ? {} : q, N = r12.styles, v = N === void 0 ? {} : N;
  if (e) {
    var C = e.prefix, L = e.iconName, B = e.icon;
    return dp(He({
      type: "icon"
    }, e), function() {
      return qo("beforeDOMElementCreation", {
        iconDefinition: e,
        params: r12
      }), t0.autoA11y && (p ? S["aria-labelledby"] = "".concat(t0.replacementClass, "-title-").concat(b || Ls()) : (S["aria-hidden"] = "true", S.focusable = "false")), Bee({
        icons: {
          main: YQ(B),
          mask: s12 ? YQ(s12.icon) : {
            found: false,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: C,
        iconName: L,
        transform: He(He({}, bn), a),
        symbol: i,
        title: p,
        maskId: l2,
        titleId: b,
        extra: {
          attributes: S,
          styles: v,
          classes: _
        }
      });
    });
  }
}, p10 = {
  mixout: function() {
    return {
      icon: c10(l10)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(r12) {
        return r12.treeCallback = nre, r12.nodeCallback = s10, r12;
      }
    };
  },
  provides: function(e) {
    e.i2svg = function(r12) {
      var n12 = r12.node, a = n12 === void 0 ? O1 : n12, o = r12.callback, i = o === void 0 ? function() {
      } : o;
      return nre(a, i);
    }, e.generateSvgReplacementMutation = function(r12, n12) {
      var a = n12.iconName, o = n12.title, i = n12.titleId, u = n12.prefix, s12 = n12.transform, c = n12.symbol, l2 = n12.mask, f = n12.maskId, p = n12.extra;
      return new Promise(function(d, b) {
        Promise.all([JQ(a, u), l2.iconName ? JQ(l2.iconName, l2.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(z) {
          var _ = Cee(z, 2), q = _[0], S = _[1];
          d([r12, Bee({
            icons: {
              main: q,
              mask: S
            },
            prefix: u,
            iconName: a,
            transform: s12,
            symbol: c,
            maskId: f,
            title: o,
            titleId: i,
            extra: p,
            watchable: true
          })]);
        }).catch(b);
      });
    }, e.generateAbstractIcon = function(r12) {
      var n12 = r12.children, a = r12.attributes, o = r12.main, i = r12.transform, u = r12.styles, s12 = cp(u);
      s12.length > 0 && (a.style = s12);
      var c;
      return Dee(i) && (c = na("generateAbstractTransformGrouping", {
        main: o,
        transform: i,
        containerWidth: o.width,
        iconWidth: o.width
      })), n12.push(c || o.icon), {
        children: n12,
        attributes: a
      };
    };
  }
}, d10 = {
  mixout: function() {
    return {
      layer: function(r12) {
        var n12 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n12.classes, o = a === void 0 ? [] : a;
        return dp({
          type: "layer"
        }, function() {
          qo("beforeDOMElementCreation", {
            assembler: r12,
            params: n12
          });
          var i = [];
          return r12(function(u) {
            Array.isArray(u) ? u.map(function(s12) {
              i = i.concat(s12.abstract);
            }) : i = i.concat(u.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(t0.cssPrefix, "-layers")].concat(sc(o)).join(" ")
            },
            children: i
          }];
        });
      }
    };
  }
}, f10 = {
  mixout: function() {
    return {
      counter: function(r12) {
        var n12 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n12.title, o = a === void 0 ? null : a, i = n12.classes, u = i === void 0 ? [] : i, s12 = n12.attributes, c = s12 === void 0 ? {} : s12, l2 = n12.styles, f = l2 === void 0 ? {} : l2;
        return dp({
          type: "counter",
          content: r12
        }, function() {
          return qo("beforeDOMElementCreation", {
            content: r12,
            params: n12
          }), X00({
            content: r12.toString(),
            title: o,
            extra: {
              attributes: c,
              styles: f,
              classes: ["".concat(t0.cssPrefix, "-layers-counter")].concat(sc(u))
            }
          });
        });
      }
    };
  }
}, b10 = {
  mixout: function() {
    return {
      text: function(r12) {
        var n12 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n12.transform, o = a === void 0 ? bn : a, i = n12.title, u = i === void 0 ? null : i, s12 = n12.classes, c = s12 === void 0 ? [] : s12, l2 = n12.attributes, f = l2 === void 0 ? {} : l2, p = n12.styles, d = p === void 0 ? {} : p;
        return dp({
          type: "text",
          content: r12
        }, function() {
          return qo("beforeDOMElementCreation", {
            content: r12,
            params: n12
          }), Kte({
            content: r12,
            transform: He(He({}, bn), o),
            title: u,
            extra: {
              attributes: f,
              styles: d,
              classes: ["".concat(t0.cssPrefix, "-layers-text")].concat(sc(c))
            }
          });
        });
      }
    };
  },
  provides: function(e) {
    e.generateLayersText = function(r12, n12) {
      var a = n12.title, o = n12.transform, i = n12.extra, u = null, s12 = null;
      if (EVe) {
        var c = parseInt(getComputedStyle(r12).fontSize, 10), l2 = r12.getBoundingClientRect();
        u = l2.width / c, s12 = l2.height / c;
      }
      return t0.autoA11y && !a && (i.attributes["aria-hidden"] = "true"), Promise.resolve([r12, Kte({
        content: r12.innerHTML,
        width: u,
        height: s12,
        transform: o,
        title: a,
        extra: i,
        watchable: true
      })]);
    };
  }
}, M10 = new RegExp('"', "ug"), are = [1105920, 1112319];
function O10(t16) {
  var e = t16.replace(M10, ""), r12 = g00(e, 0), n12 = r12 >= are[0] && r12 <= are[1], a = e.length === 2 ? e[0] === e[1] : false;
  return {
    value: HQ(a ? e[0] : e),
    isSecondary: n12 || a
  };
}
function ore(t16, e) {
  var r12 = "".concat(a00).concat(e.replace(":", "-"));
  return new Promise(function(n12, a) {
    if (t16.getAttribute(r12) !== null)
      return n12();
    var o = Di(t16.children), i = o.filter(function(B) {
      return B.getAttribute(VQ) === e;
    })[0], u = xa.getComputedStyle(t16, e), s12 = u.getPropertyValue("font-family").match(c00), c = u.getPropertyValue("font-weight"), l2 = u.getPropertyValue("content");
    if (i && !s12)
      return t16.removeChild(i), n12();
    if (s12 && l2 !== "none" && l2 !== "") {
      var f = u.getPropertyValue("content"), p = ~["Sharp"].indexOf(s12[2]) ? E1 : M1, d = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(s12[2]) ? gs[p][s12[2].toLowerCase()] : l00[p][c], b = O10(f), z = b.value, _ = b.isSecondary, q = s12[0].startsWith("FontAwesome"), S = Nee(d, z), N = S;
      if (q) {
        var v = N00(z);
        v.iconName && v.prefix && (S = v.iconName, d = v.prefix);
      }
      if (S && !_ && (!i || i.getAttribute(Iee) !== d || i.getAttribute(Eee) !== N)) {
        t16.setAttribute(r12, N), i && t16.removeChild(i);
        var C = i10(), L = C.extra;
        L.attributes[VQ] = e, JQ(S, d).then(function(B) {
          var P12 = Bee(He(He({}, C), {}, {
            icons: {
              main: B,
              mask: wee()
            },
            prefix: d,
            iconName: N,
            extra: L,
            watchable: true
          })), j = O1.createElementNS("http://www.w3.org/2000/svg", "svg");
          e === "::before" ? t16.insertBefore(j, t16.firstChild) : t16.appendChild(j), j.outerHTML = P12.map(function($) {
            return lc($);
          }).join(`
`), t16.removeAttribute(r12), n12();
        }).catch(a);
      } else
        n12();
    } else
      n12();
  });
}
function z10(t16) {
  return Promise.all([ore(t16, "::before"), ore(t16, "::after")]);
}
function A10(t16) {
  return t16.parentNode !== document.head && !~i00.indexOf(t16.tagName.toUpperCase()) && !t16.getAttribute(VQ) && (!t16.parentNode || t16.parentNode.tagName !== "svg");
}
function ire(t16) {
  if (la)
    return new Promise(function(e, r12) {
      var n12 = Di(t16.querySelectorAll("*")).filter(A10).map(z10), a = xee.begin("searchPseudoElements");
      QVe(), Promise.all(n12).then(function() {
        a(), QQ(), e();
      }).catch(function() {
        a(), QQ(), r12();
      });
    });
}
var _10 = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(r12) {
        return r12.pseudoElementsCallback = ire, r12;
      }
    };
  },
  provides: function(e) {
    e.pseudoElements2svg = function(r12) {
      var n12 = r12.node, a = n12 === void 0 ? O1 : n12;
      t0.searchPseudoElements && ire(a);
    };
  }
}, ure = false, h10 = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          QVe(), ure = true;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        tre($Q("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        r10();
      },
      watch: function(r12) {
        var n12 = r12.observeMutationsRoot;
        ure ? QQ() : tre($Q("mutationObserverCallbacks", {
          observeMutationsRoot: n12
        }));
      }
    };
  }
}, sre = function(e) {
  var r12 = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce(function(n12, a) {
    var o = a.toLowerCase().split("-"), i = o[0], u = o.slice(1).join("-");
    if (i && u === "h")
      return n12.flipX = true, n12;
    if (i && u === "v")
      return n12.flipY = true, n12;
    if (u = parseFloat(u), isNaN(u))
      return n12;
    switch (i) {
      case "grow":
        n12.size = n12.size + u;
        break;
      case "shrink":
        n12.size = n12.size - u;
        break;
      case "left":
        n12.x = n12.x - u;
        break;
      case "right":
        n12.x = n12.x + u;
        break;
      case "up":
        n12.y = n12.y - u;
        break;
      case "down":
        n12.y = n12.y + u;
        break;
      case "rotate":
        n12.rotate = n12.rotate + u;
        break;
    }
    return n12;
  }, r12);
}, v10 = {
  mixout: function() {
    return {
      parse: {
        transform: function(r12) {
          return sre(r12);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(r12, n12) {
        var a = n12.getAttribute("data-fa-transform");
        return a && (r12.transform = sre(a)), r12;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractTransformGrouping = function(r12) {
      var n12 = r12.main, a = r12.transform, o = r12.containerWidth, i = r12.iconWidth, u = {
        transform: "translate(".concat(o / 2, " 256)")
      }, s12 = "translate(".concat(a.x * 32, ", ").concat(a.y * 32, ") "), c = "scale(".concat(a.size / 16 * (a.flipX ? -1 : 1), ", ").concat(a.size / 16 * (a.flipY ? -1 : 1), ") "), l2 = "rotate(".concat(a.rotate, " 0 0)"), f = {
        transform: "".concat(s12, " ").concat(c, " ").concat(l2)
      }, p = {
        transform: "translate(".concat(i / 2 * -1, " -256)")
      }, d = {
        outer: u,
        inner: f,
        path: p
      };
      return {
        tag: "g",
        attributes: He({}, d.outer),
        children: [{
          tag: "g",
          attributes: He({}, d.inner),
          children: [{
            tag: n12.icon.tag,
            children: n12.icon.children,
            attributes: He(He({}, n12.icon.attributes), d.path)
          }]
        }]
      };
    };
  }
}, Nd = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function cre(t16) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  return t16.attributes && (t16.attributes.fill || e) && (t16.attributes.fill = "black"), t16;
}
function m10(t16) {
  return t16.tag === "g" ? t16.children : [t16];
}
var R10 = {
  hooks: function() {
    return {
      parseNodeAttributes: function(r12, n12) {
        var a = n12.getAttribute("data-fa-mask"), o = a ? pp(a.split(" ").map(function(i) {
          return i.trim();
        })) : wee();
        return o.prefix || (o.prefix = Ua()), r12.mask = o, r12.maskId = n12.getAttribute("data-fa-mask-id"), r12;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractMask = function(r12) {
      var n12 = r12.children, a = r12.attributes, o = r12.main, i = r12.mask, u = r12.maskId, s12 = r12.transform, c = o.width, l2 = o.icon, f = i.width, p = i.icon, d = v00({
        transform: s12,
        containerWidth: f,
        iconWidth: c
      }), b = {
        tag: "rect",
        attributes: He(He({}, Nd), {}, {
          fill: "white"
        })
      }, z = l2.children ? {
        children: l2.children.map(cre)
      } : {}, _ = {
        tag: "g",
        attributes: He({}, d.inner),
        children: [cre(He({
          tag: l2.tag,
          attributes: He(He({}, l2.attributes), d.path)
        }, z))]
      }, q = {
        tag: "g",
        attributes: He({}, d.outer),
        children: [_]
      }, S = "mask-".concat(u || Ls()), N = "clip-".concat(u || Ls()), v = {
        tag: "mask",
        attributes: He(He({}, Nd), {}, {
          id: S,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [b, q]
      }, C = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: N
          },
          children: m10(p)
        }, v]
      };
      return n12.push(C, {
        tag: "rect",
        attributes: He({
          fill: "currentColor",
          "clip-path": "url(#".concat(N, ")"),
          mask: "url(#".concat(S, ")")
        }, Nd)
      }), {
        children: n12,
        attributes: a
      };
    };
  }
}, q10 = {
  provides: function(e) {
    var r12 = false;
    xa.matchMedia && (r12 = xa.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      var n12 = [], a = {
        fill: "currentColor"
      }, o = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n12.push({
        tag: "path",
        attributes: He(He({}, a), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var i = He(He({}, o), {}, {
        attributeName: "opacity"
      }), u = {
        tag: "circle",
        attributes: He(He({}, a), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return r12 || u.children.push({
        tag: "animate",
        attributes: He(He({}, o), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: He(He({}, i), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), n12.push(u), n12.push({
        tag: "path",
        attributes: He(He({}, a), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: r12 ? [] : [{
          tag: "animate",
          attributes: He(He({}, i), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), r12 || n12.push({
        tag: "path",
        attributes: He(He({}, a), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: He(He({}, i), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n12
      };
    };
  }
}, T10 = {
  hooks: function() {
    return {
      parseNodeAttributes: function(r12, n12) {
        var a = n12.getAttribute("data-fa-symbol"), o = a === null ? false : a === "" ? true : a;
        return r12.symbol = o, r12;
      }
    };
  }
}, y10 = [q00, p10, d10, f10, b10, _10, h10, v10, R10, q10, T10];
x00(y10, {
  mixoutsTo: sr
});
sr.noAuto;
var eHe = sr.config, N0 = sr.library;
sr.dom;
var _2 = sr.parse;
sr.findIconDefinition;
sr.toHtml;
var S10 = sr.icon;
sr.layer;
sr.text;
sr.counter;
function lre(t16, e) {
  var r12 = Object.keys(t16);
  if (Object.getOwnPropertySymbols) {
    var n12 = Object.getOwnPropertySymbols(t16);
    e && (n12 = n12.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t16, a).enumerable;
    })), r12.push.apply(r12, n12);
  }
  return r12;
}
function Hr(t16) {
  for (var e = 1; e < arguments.length; e++) {
    var r12 = arguments[e] != null ? arguments[e] : {};
    e % 2 ? lre(Object(r12), true).forEach(function(n12) {
      Ut(t16, n12, r12[n12]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t16, Object.getOwnPropertyDescriptors(r12)) : lre(Object(r12)).forEach(function(n12) {
      Object.defineProperty(t16, n12, Object.getOwnPropertyDescriptor(r12, n12));
    });
  }
  return t16;
}
function h2(t16) {
  "@babel/helpers - typeof";
  return h2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, h2(t16);
}
function Ut(t16, e, r12) {
  return e = N10(e), e in t16 ? Object.defineProperty(t16, e, {
    value: r12,
    enumerable: true,
    configurable: true,
    writable: true
  }) : t16[e] = r12, t16;
}
function g10(t16, e) {
  if (t16 == null)
    return {};
  var r12 = {}, n12 = Object.keys(t16), a, o;
  for (o = 0; o < n12.length; o++)
    a = n12[o], !(e.indexOf(a) >= 0) && (r12[a] = t16[a]);
  return r12;
}
function I10(t16, e) {
  if (t16 == null)
    return {};
  var r12 = g10(t16, e), n12, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t16);
    for (a = 0; a < o.length; a++)
      n12 = o[a], !(e.indexOf(n12) >= 0) && Object.prototype.propertyIsEnumerable.call(t16, n12) && (r12[n12] = t16[n12]);
  }
  return r12;
}
function ZQ(t16) {
  return E10(t16) || L10(t16) || P10(t16) || D10();
}
function E10(t16) {
  if (Array.isArray(t16))
    return eZ(t16);
}
function L10(t16) {
  if (typeof Symbol < "u" && t16[Symbol.iterator] != null || t16["@@iterator"] != null)
    return Array.from(t16);
}
function P10(t16, e) {
  if (t16) {
    if (typeof t16 == "string")
      return eZ(t16, e);
    var r12 = Object.prototype.toString.call(t16).slice(8, -1);
    if (r12 === "Object" && t16.constructor && (r12 = t16.constructor.name), r12 === "Map" || r12 === "Set")
      return Array.from(t16);
    if (r12 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r12))
      return eZ(t16, e);
  }
}
function eZ(t16, e) {
  (e == null || e > t16.length) && (e = t16.length);
  for (var r12 = 0, n12 = new Array(e); r12 < e; r12++)
    n12[r12] = t16[r12];
  return n12;
}
function D10() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function W10(t16, e) {
  if (typeof t16 != "object" || t16 === null)
    return t16;
  var r12 = t16[Symbol.toPrimitive];
  if (r12 !== void 0) {
    var n12 = r12.call(t16, e);
    if (typeof n12 != "object")
      return n12;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t16);
}
function N10(t16) {
  var e = W10(t16, "string");
  return typeof e == "symbol" ? e : String(e);
}
var w10 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, tHe = { exports: {} };
(function(t16) {
  (function(e) {
    var r12 = function(q, S, N) {
      if (!c(S) || f(S) || p(S) || d(S) || s12(S))
        return S;
      var v, C = 0, L = 0;
      if (l2(S))
        for (v = [], L = S.length; C < L; C++)
          v.push(r12(q, S[C], N));
      else {
        v = {};
        for (var B in S)
          Object.prototype.hasOwnProperty.call(S, B) && (v[q(B, N)] = r12(q, S[B], N));
      }
      return v;
    }, n12 = function(q, S) {
      S = S || {};
      var N = S.separator || "_", v = S.split || /(?=[A-Z])/;
      return q.split(v).join(N);
    }, a = function(q) {
      return b(q) ? q : (q = q.replace(/[\-_\s]+(.)?/g, function(S, N) {
        return N ? N.toUpperCase() : "";
      }), q.substr(0, 1).toLowerCase() + q.substr(1));
    }, o = function(q) {
      var S = a(q);
      return S.substr(0, 1).toUpperCase() + S.substr(1);
    }, i = function(q, S) {
      return n12(q, S).toLowerCase();
    }, u = Object.prototype.toString, s12 = function(q) {
      return typeof q == "function";
    }, c = function(q) {
      return q === Object(q);
    }, l2 = function(q) {
      return u.call(q) == "[object Array]";
    }, f = function(q) {
      return u.call(q) == "[object Date]";
    }, p = function(q) {
      return u.call(q) == "[object RegExp]";
    }, d = function(q) {
      return u.call(q) == "[object Boolean]";
    }, b = function(q) {
      return q = q - 0, q === q;
    }, z = function(q, S) {
      var N = S && "process" in S ? S.process : S;
      return typeof N != "function" ? q : function(v, C) {
        return N(v, q, C);
      };
    }, _ = {
      camelize: a,
      decamelize: i,
      pascalize: o,
      depascalize: i,
      camelizeKeys: function(q, S) {
        return r12(z(a, S), q);
      },
      decamelizeKeys: function(q, S) {
        return r12(z(i, S), q, S);
      },
      pascalizeKeys: function(q, S) {
        return r12(z(o, S), q);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    t16.exports ? t16.exports = _ : e.humps = _;
  })(w10);
})(tHe);
var B10 = tHe.exports, x10 = ["class", "style"];
function U10(t16) {
  return t16.split(";").map(function(e) {
    return e.trim();
  }).filter(function(e) {
    return e;
  }).reduce(function(e, r12) {
    var n12 = r12.indexOf(":"), a = B10.camelize(r12.slice(0, n12)), o = r12.slice(n12 + 1).trim();
    return e[a] = o, e;
  }, {});
}
function k10(t16) {
  return t16.split(/\s+/).reduce(function(e, r12) {
    return e[r12] = true, e;
  }, {});
}
function kee(t16) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r12 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t16 == "string")
    return t16;
  var n12 = (t16.children || []).map(function(s12) {
    return kee(s12);
  }), a = Object.keys(t16.attributes || {}).reduce(function(s12, c) {
    var l2 = t16.attributes[c];
    switch (c) {
      case "class":
        s12.class = k10(l2);
        break;
      case "style":
        s12.style = U10(l2);
        break;
      default:
        s12.attrs[c] = l2;
    }
    return s12;
  }, {
    attrs: {},
    class: {},
    style: {}
  });
  r12.class;
  var o = r12.style, i = o === void 0 ? {} : o, u = I10(r12, x10);
  return h(t16.tag, Hr(Hr(Hr({}, e), {}, {
    class: a.class,
    style: Hr(Hr({}, a.style), i)
  }, a.attrs), u), n12);
}
var rHe = false;
try {
  rHe = process.env.NODE_ENV === "production";
} catch {
}
function j10() {
  if (!rHe && console && typeof console.error == "function") {
    var t16;
    (t16 = console).error.apply(t16, arguments);
  }
}
function ds(t16, e) {
  return Array.isArray(e) && e.length > 0 || !Array.isArray(e) && e ? Ut({}, t16, e) : {};
}
function F10(t16) {
  var e, r12 = (e = {
    "fa-spin": t16.spin,
    "fa-pulse": t16.pulse,
    "fa-fw": t16.fixedWidth,
    "fa-border": t16.border,
    "fa-li": t16.listItem,
    "fa-inverse": t16.inverse,
    "fa-flip": t16.flip === true,
    "fa-flip-horizontal": t16.flip === "horizontal" || t16.flip === "both",
    "fa-flip-vertical": t16.flip === "vertical" || t16.flip === "both"
  }, Ut(e, "fa-".concat(t16.size), t16.size !== null), Ut(e, "fa-rotate-".concat(t16.rotation), t16.rotation !== null), Ut(e, "fa-pull-".concat(t16.pull), t16.pull !== null), Ut(e, "fa-swap-opacity", t16.swapOpacity), Ut(e, "fa-bounce", t16.bounce), Ut(e, "fa-shake", t16.shake), Ut(e, "fa-beat", t16.beat), Ut(e, "fa-fade", t16.fade), Ut(e, "fa-beat-fade", t16.beatFade), Ut(e, "fa-flash", t16.flash), Ut(e, "fa-spin-pulse", t16.spinPulse), Ut(e, "fa-spin-reverse", t16.spinReverse), e);
  return Object.keys(r12).map(function(n12) {
    return r12[n12] ? n12 : null;
  }).filter(function(n12) {
    return n12;
  });
}
function pre(t16) {
  if (t16 && h2(t16) === "object" && t16.prefix && t16.iconName && t16.icon)
    return t16;
  if (_2.icon)
    return _2.icon(t16);
  if (t16 === null)
    return null;
  if (h2(t16) === "object" && t16.prefix && t16.iconName)
    return t16;
  if (Array.isArray(t16) && t16.length === 2)
    return {
      prefix: t16[0],
      iconName: t16[1]
    };
  if (typeof t16 == "string")
    return {
      prefix: "fas",
      iconName: t16
    };
}
var Wi = /* @__PURE__ */ defineComponent({
  name: "FontAwesomeIcon",
  props: {
    border: {
      type: Boolean,
      default: false
    },
    fixedWidth: {
      type: Boolean,
      default: false
    },
    flip: {
      type: [Boolean, String],
      default: false,
      validator: function(e) {
        return [true, false, "horizontal", "vertical", "both"].indexOf(e) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: true
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    maskId: {
      type: String,
      default: null
    },
    listItem: {
      type: Boolean,
      default: false
    },
    pull: {
      type: String,
      default: null,
      validator: function(e) {
        return ["right", "left"].indexOf(e) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: false
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(e) {
        return [90, 180, 270].indexOf(Number.parseInt(e, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: null,
      validator: function(e) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(e) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: false
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: false
    },
    title: {
      type: String,
      default: null
    },
    titleId: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: false
    },
    bounce: {
      type: Boolean,
      default: false
    },
    shake: {
      type: Boolean,
      default: false
    },
    beat: {
      type: Boolean,
      default: false
    },
    fade: {
      type: Boolean,
      default: false
    },
    beatFade: {
      type: Boolean,
      default: false
    },
    flash: {
      type: Boolean,
      default: false
    },
    spinPulse: {
      type: Boolean,
      default: false
    },
    spinReverse: {
      type: Boolean,
      default: false
    }
  },
  setup: function(e, r12) {
    var n12 = r12.attrs, a = computed(function() {
      return pre(e.icon);
    }), o = computed(function() {
      return ds("classes", F10(e));
    }), i = computed(function() {
      return ds("transform", typeof e.transform == "string" ? _2.transform(e.transform) : e.transform);
    }), u = computed(function() {
      return ds("mask", pre(e.mask));
    }), s12 = computed(function() {
      return S10(a.value, Hr(Hr(Hr(Hr({}, o.value), i.value), u.value), {}, {
        symbol: e.symbol,
        title: e.title,
        titleId: e.titleId,
        maskId: e.maskId
      }));
    });
    watch(s12, function(l2) {
      if (!l2)
        return j10("Could not find one or more icon(s)", a.value, u.value);
    }, {
      immediate: true
    });
    var c = computed(function() {
      return s12.value ? kee(s12.value.abstract[0], {}, n12) : null;
    });
    return function() {
      return c.value;
    };
  }
}), jee = /* @__PURE__ */ defineComponent({
  name: "FontAwesomeLayers",
  props: {
    fixedWidth: {
      type: Boolean,
      default: false
    }
  },
  setup: function(e, r12) {
    var n12 = r12.slots, a = eHe.familyPrefix, o = computed(function() {
      return ["".concat(a, "-layers")].concat(ZQ(e.fixedWidth ? ["".concat(a, "-fw")] : []));
    });
    return function() {
      return h("div", {
        class: o.value
      }, n12.default ? n12.default() : []);
    };
  }
});
const H10 = { class: "una-icon-container" }, X10 = ["innerHTML"], R0 = /* @__PURE__ */ defineComponent({
  name: "UnaIcon",
  __name: "icon",
  props: {
    svg: { type: Boolean },
    border: { type: Boolean },
    fixedWidth: { type: Boolean },
    flip: {},
    icon: {},
    mask: {},
    listItem: { type: Boolean },
    pull: {},
    pulse: { type: Boolean },
    rotation: {},
    swapOpacity: { type: Boolean },
    size: {},
    spin: { type: Boolean },
    transform: {},
    inverse: { type: Boolean },
    bounce: { type: Boolean },
    shake: { type: Boolean },
    beat: { type: Boolean },
    fade: { type: Boolean },
    beatFade: { type: Boolean },
    spinPulse: { type: Boolean },
    spinReverse: { type: Boolean }
  },
  setup(t16) {
    return (e, r12) => (openBlock(), createElementBlock("div", H10, [
      e.svg ? (openBlock(), createElementBlock("div", {
        key: 1,
        innerHTML: e.icon
      }, null, 8, X10)) : (openBlock(), createBlock(unref(Wi), normalizeProps(mergeProps({ key: 0 }, { ...e.$props, ...e.$attrs })), null, 16))
    ]));
  }
});
var dt = /* @__PURE__ */ ((t16) => (t16.Inline = "inline", t16.Global = "global", t16.Toast = "toast", t16))(dt || {}), l1 = /* @__PURE__ */ ((t16) => (t16.Informational = "informational", t16.Error = "error", t16.Warning = "warning", t16.Success = "success", t16))(l1 || {});
var $10 = {
  prefix: "fal",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
}, G10 = $10, J10 = {
  prefix: "fal",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
}, K10 = J10, Z10 = {
  prefix: "fal",
  iconName: "arrows-left-right",
  icon: [512, 512, ["arrows-h"], "f07e", "M503.3 271.3c6.1-6.1 6.3-15.9 .4-22.2l-96-104c-6-6.5-16.1-6.9-22.6-.9s-6.9 16.1-.9 22.6L455.5 244 50.6 244l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L50.6 276l402.7 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z"]
}, et0 = {
  prefix: "fal",
  iconName: "square",
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
}, tt0 = {
  prefix: "fal",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V240c0-8.8-7.2-16-16-16H216c-8.8 0-16 7.2-16 16s7.2 16 16 16h24v96H208zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
}, rt0 = tt0, nHe = {
  prefix: "fal",
  iconName: "arrow-down",
  icon: [384, 512, [8595], "f063", "M180.7 475.3c6.2 6.2 16.4 6.2 22.6 0l176-176c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 425.4 208 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 377.4L27.3 276.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l176 176z"]
}, at0 = {
  prefix: "fal",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z"]
}, aHe = {
  prefix: "fal",
  iconName: "arrow-up",
  icon: [384, 512, [8593], "f062", "M203.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-176 176c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6L356.7 235.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-176-176z"]
}, ot0 = {
  prefix: "fal",
  iconName: "sidebar",
  icon: [512, 512, [], "e24e", "M448 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H224V64H448zM64 64H192V448H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm0-32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM80 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zM64 176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
}, it0 = {
  prefix: "fal",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"]
}, ut0 = it0, st0 = {
  prefix: "fal",
  iconName: "calendar",
  icon: [448, 512, [128197, 128198], "f133", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H32V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32z"]
}, ct0 = {
  prefix: "fal",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M34.5 420.4c-1.6 2.8-2.5 6-2.5 9.3c0 10.2 8.2 18.4 18.4 18.4H461.6c10.2 0 18.4-8.2 18.4-18.4c0-3.3-.9-6.4-2.5-9.3L276.5 75.8C272.2 68.5 264.4 64 256 64s-16.2 4.5-20.5 11.8L34.5 420.4zM6.9 404.2l201-344.6C217.9 42.5 236.2 32 256 32s38.1 10.5 48.1 27.6l201 344.6c4.5 7.7 6.9 16.5 6.9 25.4c0 27.8-22.6 50.4-50.4 50.4H50.4C22.6 480 0 457.4 0 429.6c0-8.9 2.4-17.7 6.9-25.4zM256 160c8.8 0 16 7.2 16 16V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM232 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
}, lt0 = ct0;
N0.add(rt0, G10, lt0, K10);
function oHe(t16) {
  return { icon: computed(() => {
    if (!t16.value)
      return { iconProps: ["fal", "info-circle"], colorClass: "bg-primary-600" };
    switch (t16.value) {
      case l1.Informational:
        return { iconProps: ["fal", "info-circle"], colorClass: "bg-primary-600" };
      case l1.Error:
        return { iconProps: ["fal", "exclamation-circle"], colorClass: "bg-error-600" };
      case l1.Warning:
        return { iconProps: ["fal", "exclamation-triangle"], colorClass: "bg-warning-600" };
      case l1.Success:
        return { iconProps: ["fal", "check-circle"], colorClass: "bg-success-600" };
      default:
        return { iconProps: ["fal", "info-circle"], colorClass: "bg-primary-600" };
    }
  }) };
}
const pt0 = {
  id: "alert-headline",
  class: "flex items-center gap-3 self-stretch"
}, dt0 = { class: "featured-icon-container flex items-center justify-center rounded-full p-2" }, ft0 = { class: "headline-text grow text-base font-medium" }, bt0 = { key: 0 }, Mt0 = {
  key: 0,
  class: "flex flex-row items-center gap-6"
}, Ot0 = ["onClick"], zt0 = {
  key: 0,
  class: "content-container flex flex-col gap-3 self-stretch pl-[44px]"
}, At0 = {
  key: 0,
  class: "content-message text-sm font-normal"
}, _t0 = { key: 0 }, ht0 = { key: 1 };
/* @__PURE__ */ defineComponent({
  __name: "alert",
  props: {
    /** If the alert can be closed */
    dismissible: {
      type: Boolean,
      default: false
    },
    /** The main text of the alert */
    headline: {
      type: String,
      default: ""
    },
    /** If the action items are inline with the headline or under*/
    inlineActionContent: {
      type: Boolean,
      default: false
    },
    /** The supporting text of the alert*/
    message: {
      type: String,
      default: ""
    },
    /** Sets the base styles*/
    alertType: {
      type: String,
      default: dt.Toast,
      validator: (t16) => Object.values(dt).includes(t16)
    },
    /** Set the variant of the component to adjust styles based on status */
    variant: {
      type: String,
      default: l1.Informational,
      validator: (t16) => Object.values(l1).includes(t16)
    },
    /** Array of optional actions*/
    actions: {
      type: Array,
      default: () => []
    }
  },
  emits: ["close"],
  setup(t16, { emit: e }) {
    N0.add(ut0);
    const r12 = t16, { icon: n12 } = oHe(/* @__PURE__ */ toRef(() => r12.variant)), a = useSlots(), o = e, i = computed(() => {
      const p = [];
      p.push(`type-${r12.alertType}`);
      const d = `variant-${r12.variant}`;
      return p.push(d), p;
    }), u = computed(() => r12.alertType !== dt.Toast ? "flex h-[16px] w-[16px]" : "flex h-[24px] w-[24px]"), s12 = computed(() => {
      var p;
      return r12.message || ((p = a.messageContent) == null ? void 0 : p.call(a));
    }), c = computed(() => {
      var p, d;
      return ((p = r12.actions) == null ? void 0 : p.length) || ((d = a.actionContent) == null ? void 0 : d.call(a));
    }), l2 = computed(() => !r12.inlineActionContent && s12.value || c.value), f = () => {
      o("close");
    };
    return (p, d) => (openBlock(), createElementBlock("div", {
      role: "alert",
      class: normalizeClass([unref(i), "una-alert"])
    }, [
      createBaseVNode("div", pt0, [
        createBaseVNode("div", dt0, [
          createVNode(R0, {
            icon: unref(n12).iconProps,
            class: normalizeClass(unref(u))
          }, null, 8, ["icon", "class"])
        ]),
        createBaseVNode("div", ft0, [
          renderSlot(p.$slots, "headlineContent", {}, () => [
            r12.headline ? (openBlock(), createElementBlock("span", bt0, toDisplayString(r12.headline), 1)) : createCommentVNode("", true)
          ], true)
        ]),
        r12.dismissible || r12.inlineActionContent && unref(c) ? (openBlock(), createElementBlock("div", Mt0, [
          r12.inlineActionContent && unref(c) ? renderSlot(p.$slots, "actionContent", {
            key: 0,
            class: "ml-3"
          }, () => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(r12.actions, (b, z) => (openBlock(), createElementBlock("button", mergeProps({
              type: "button",
              class: "action-button",
              key: z
            }, b), toDisplayString(b.text), 17))), 128))
          ], true) : createCommentVNode("", true),
          r12.dismissible && p.$props.alertType === unref(dt).Toast ? (openBlock(), createElementBlock("button", {
            key: 1,
            type: "button",
            class: "action-button",
            onClick: withModifiers(f, ["stop"])
          }, " DISMISS ", 8, Ot0)) : r12.dismissible && p.$props.alertType !== unref(dt).Toast ? (openBlock(), createBlock(R0, {
            key: 2,
            onClick: withModifiers(f, ["stop"]),
            icon: ["fal", "times"],
            class: "close-icon flex h-[24px] w-[24px] cursor-pointer"
          }, null, 8, ["onClick"])) : createCommentVNode("", true)
        ])) : createCommentVNode("", true)
      ]),
      unref(l2) ? (openBlock(), createElementBlock("div", zt0, [
        unref(s12) ? (openBlock(), createElementBlock("div", At0, [
          renderSlot(p.$slots, "messageContent", {}, () => [
            r12.message ? (openBlock(), createElementBlock("span", _t0, toDisplayString(r12.message), 1)) : createCommentVNode("", true)
          ], true)
        ])) : createCommentVNode("", true),
        !r12.inlineActionContent && unref(c) ? (openBlock(), createElementBlock("div", ht0, [
          renderSlot(p.$slots, "actionContent", {}, () => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(r12.actions, (b, z) => (openBlock(), createElementBlock("button", mergeProps({
              type: "button",
              class: "action-button mr-4",
              key: z
            }, b), toDisplayString(b.text), 17))), 128))
          ], true)
        ])) : createCommentVNode("", true)
      ])) : createCommentVNode("", true)
    ], 2));
  }
});
const Je = (t16, e) => {
  const r12 = t16.__vccOpts || t16;
  for (const [n12, a] of e)
    r12[n12] = a;
  return r12;
};
const dre = {
  top: {
    anchorX: 0.5,
    anchorY: 0,
    alignX: 0.5,
    alignY: 1
  },
  "top-left": {
    anchorX: 0,
    anchorY: 0,
    alignX: 0,
    alignY: 1
  },
  "top-right": {
    anchorX: 1,
    anchorY: 0,
    alignX: 1,
    alignY: 1
  },
  left: {
    anchorX: 0,
    anchorY: 0.5,
    alignX: 1,
    alignY: 0.5
  },
  "left-top": {
    anchorX: 0,
    anchorY: 0,
    alignX: 1,
    alignY: 0
  },
  "left-bottom": {
    anchorX: 0,
    anchorY: 1,
    alignX: 1,
    alignY: 1
  },
  bottom: {
    anchorX: 0.5,
    anchorY: 1,
    alignX: 0.5,
    alignY: 0
  },
  "bottom-left": {
    anchorX: 0,
    anchorY: 1,
    alignX: 0,
    alignY: 0
  },
  "bottom-right": {
    anchorX: 1,
    anchorY: 1,
    alignX: 1,
    alignY: 0
  },
  right: {
    anchorX: 1,
    anchorY: 0.5,
    alignX: 0,
    alignY: 0.5
  },
  "right-top": {
    anchorX: 1,
    anchorY: 0,
    alignX: 0,
    alignY: 0
  },
  "right-bottom": {
    anchorX: 1,
    anchorY: 1,
    alignX: 0,
    alignY: 1
  }
}, ts = {
  stack: [],
  id: 0
}, Rt0 = (t16) => {
  var r12;
  let e = t16;
  for (; e; ) {
    if ((r12 = e.dataset) != null && r12.popid)
      return parseInt(e.dataset.popid, 10);
    e = e.parentElement;
  }
}, qt0 = (t16) => {
  const e = Rt0(t16);
  return e !== void 0 && ts.stack.includes(e);
}, bo = /* @__PURE__ */ new Map();
let Tt0 = 0;
const fre = (t16) => {
  const e = t16.target;
  let r12 = null, n12 = -1;
  bo.forEach((a, o) => {
    a.contains(e) && (r12 = o, n12 = a._stackLevel);
  }), r12 === null && qt0(e) && (n12 = Math.max(...Array.from(bo.values()).map((o) => o._stackLevel)), r12 = "teleported-content"), bo.forEach((a, o) => {
    o !== r12 && (n12 === -1 || a._stackLevel >= n12) && a._closeCallback(t16);
  });
}, uHe = {
  mounted: (t16, e) => {
    const r12 = `scoped-outside-${++Tt0}`, n12 = typeof e.value == "function" ? e.value : e.value.callback, a = typeof e.value == "function" ? 0 : e.value.stackLevel ?? 0;
    t16._scopedId = r12, t16._closeCallback = n12, t16._stackLevel = a, bo.set(r12, t16), bo.size === 1 && document.addEventListener("click", fre, true), t16._outsideClick = (o) => {
      const i = o.target;
      !t16.contains(i) && n12(o);
    };
  },
  unmounted: (t16) => {
    t16._scopedId && bo.delete(t16._scopedId), bo.size === 0 && document.removeEventListener("click", fre, true);
  }
}, yt0 = {
  beforeMount: (t16, e) => {
    (e.modifiers.self ? t16 : document).addEventListener("scroll", e.value, {
      capture: !e.modifiers.bubble,
      passive: !!e.modifiers.passive
    });
  },
  mounted: (t16, e) => {
    e.modifiers.lazy || e.value();
  },
  updated: (t16, e) => {
    if (e.value !== e.oldValue) {
      const r12 = e.modifiers.self ? t16 : document;
      r12.removeEventListener("scroll", e.oldValue), r12.addEventListener("scroll", e.value, {
        capture: !e.modifiers.bubble,
        passive: !!e.modifiers.passive
      });
    }
  },
  unmounted: (t16, e) => {
    (e.modifiers.self ? t16 : document).removeEventListener("scroll", e.value);
  }
};
class no {
  constructor(e, r12, n12, a = () => {
    const o = {
      width: this.getWidth(),
      height: this.getHeight()
    };
    this.el.parentElement && this.mode === "self" && (o.parentWidth = this.el.parentElement.offsetWidth, o.parentHeight = this.el.parentElement.offsetHeight), typeof this.value == "function" ? this.value(o) : (this.value.width = o.width, this.value.height = o.height, o.parentWidth !== void 0 && (this.value.parentWidth = o.parentWidth, this.value.parentHeight = o.parentHeight));
  }) {
    q0(this, "observer");
    q0(this, "intersection");
    this.el = e, this.value = r12, this.mode = n12, this.handler = a;
  }
  getWidth() {
    switch (this.mode) {
      case "body":
        return document.body.offsetWidth;
      case "window":
        return window.innerWidth;
      default:
        return this.el.offsetWidth;
    }
  }
  getHeight() {
    switch (this.mode) {
      case "body":
        return document.body.offsetHeight;
      case "window":
        return window.innerHeight;
      default:
        return this.el.offsetHeight;
    }
  }
}
q0(no, "PROP", "_v_size");
const wd = {
  beforeMount: (t16, e) => {
    const r12 = new no(t16, e.value, e.modifiers.window ? "window" : e.modifiers.body ? "body" : "self");
    (!window.ResizeObserver || !e.modifiers.observe || r12.mode !== "self") && window.addEventListener("resize", r12.handler), t16[no.PROP] = r12, window.ResizeObserver && e.modifiers.observe ? (r12.observer = new ResizeObserver(() => r12.handler()), r12.observer.observe(t16)) : window.MutationObserver && e.modifiers.observe && (r12.observer = new MutationObserver(() => r12.handler()), r12.observer.observe(t16, {
      childList: true,
      subtree: true
    })), window.IntersectionObserver && e.modifiers.intersection && (r12.intersection = new IntersectionObserver((n12) => {
      n12.forEach((a) => {
        a.intersectionRatio > 0 && r12.handler();
      });
    }, {
      root: document.documentElement
    }), r12.intersection.observe(t16)), e.modifiers.delay && !e.modifiers.lazy && setTimeout(() => setTimeout(() => setTimeout(() => setTimeout(r12.handler))));
  },
  mounted: (t16, e) => {
    const r12 = t16[no.PROP];
    e.modifiers.lazy || r12.handler();
  },
  updated: (t16, e) => {
    if (e.value !== e.oldValue) {
      const r12 = t16[no.PROP];
      r12.value = e.value, r12.handler();
    }
  },
  unmounted: (t16) => {
    const e = t16[no.PROP];
    window.removeEventListener("resize", e.handler), e.observer && e.observer.disconnect(), e.intersection && e.intersection.disconnect(), delete t16[no.PROP];
  }
}, St0 = /* @__PURE__ */ defineComponent({
  __name: "relative",
  props: {
    /**
     *  'top'
    | 'top-left'
    | 'top-right'
    | 'left'
    | 'left-top'
    | 'left-bottom'
    | 'bottom'
    | 'bottom-left'
    | 'bottom-right'
    | 'right'
    | 'right-top'
    | 'right-bottom'
     */
    position: {
      type: String,
      validator(t16) {
        return t16 in dre;
      },
      default: "bottom-left"
    },
    /** Whether or not showing the relative content is enabled. */
    enabled: {
      type: Boolean,
      default: true
    },
    /** Whether or not the relative component is visible. */
    visible: {
      type: Boolean,
      default: false
    },
    /**
     * Array of
    'mouseenter'
    | 'mouseleave'
    | 'focus'
    | 'blur'
    | 'click'
    | 'escape'
    | 'enter'
    | 'space'
    | 'outside'
    | 'keydown'
     */
    showOn: {
      type: Array,
      default: () => []
    },
    /**
     * Array of
    'mouseenter'
    | 'mouseleave'
    | 'focus'
    | 'blur'
    | 'click'
    | 'escape'
    | 'enter'
    | 'space'
    | 'outside'
    | 'keydown'
     */
    hideOn: {
      type: Array,
      default: () => []
    },
    /**
     * Array of
    'mouseenter'
    | 'mouseleave'
    | 'focus'
    | 'blur'
    | 'click'
    | 'escape'
    | 'enter'
    | 'space'
    | 'outside'
    | 'keydown'
     */
    toggleOn: {
      type: Array,
      default: () => []
    },
    /**
     * If the relative should be relatively positioned.
     * By default it's fixed so it exists outside any scrollable areas.
     * If it's not fixed and in a scrollable area, it will affect the scroll area.
     * This is not a responsive property - the initial value is used and is expected
     * not to change.
     */
    relative: {
      type: Boolean,
      default: false
    },
    transition: {
      type: String,
      default: "grow-down"
    },
    anchorX: {
      type: Number
    },
    anchorY: {
      type: Number
    },
    alignX: {
      type: Number
    },
    alignY: {
      type: Number
    },
    offsetX: {
      type: Number,
      default: 0
    },
    offsetY: {
      type: Number,
      default: 0
    },
    distance: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: void 0
    },
    height: {
      type: Number,
      default: void 0
    },
    matchWidth: {
      type: Boolean,
      default: false
    },
    matchHeight: {
      type: Boolean,
      default: false
    },
    trigger: {
      type: String,
      default: ""
    },
    boundsSelector: {
      type: String,
      default: ""
    },
    paddingLeft: {
      type: Number,
      default: 0
    },
    paddingTop: {
      type: Number,
      default: 0
    },
    paddingBottom: {
      type: Number,
      default: 0
    },
    paddingRight: {
      type: Number,
      default: 0
    },
    contentClasses: {
      type: String,
      default: ""
    },
    outsideStackLevel: {
      type: Number,
      default: -1
    }
  },
  emits: ["update:visible"],
  setup(t16, { emit: e }) {
    const r12 = inject("popoverLevel", 0), n12 = inject(
      "popoverContainer",
      document.documentElement
    ), a = ++ts.id;
    provide("popoverLevel", r12 + 1);
    const o = t16, i = e, u = /* @__PURE__ */ ref(null), s12 = /* @__PURE__ */ ref(), c = computed(() => {
      var I;
      return n12 instanceof HTMLElement ? n12 : (I = n12.$el) != null && I.querySelector ? n12.$el.querySelector(".una-popover-container") : null;
    }), l2 = computed(
      () => o.position ? dre[o.position] : {
        anchorX: o.anchorX || 0,
        anchorY: o.anchorY || 0,
        alignX: o.alignX || 0,
        alignY: o.alignY || 0
      }
    ), f = /* @__PURE__ */ ref({ left: "", top: "", marginLeft: "", marginTop: "" });
    let p = () => {
    };
    const d = /* @__PURE__ */ ref({
      transform: "",
      width: "",
      height: "",
      padding: "",
      position: void 0,
      left: "",
      top: ""
    }), b = computed(() => ({
      "una-relative-full-width": o.matchWidth,
      "una-relative-full-height": o.matchHeight
    })), z = /* @__PURE__ */ ref(false), _ = /* @__PURE__ */ ref({ width: 0, height: 0 }), q = /* @__PURE__ */ ref({ width: 0, height: 0 });
    if (watch(
      () => ts.stack,
      (I) => {
        o.hideOn.includes("mouseleave") && z.value && !I.includes(a) && v(false);
      },
      { deep: true }
    ), o.relative)
      watch(
        () => ({
          left: `${l2.value.anchorX * 100}%`,
          top: `${l2.value.anchorY * 100}%`,
          marginLeft: `${o.offsetX - (l2.value.alignX - l2.value.anchorX) * o.distance}px`,
          marginTop: `${o.offsetY - (l2.value.alignY - l2.value.anchorY) * o.distance}px`
        }),
        (I) => {
          f.value = I;
        },
        { immediate: true }
      ), watch(
        () => ({
          transform: `translate(-${l2.value.alignX * 100}%, -${l2.value.alignY * 100}%)`,
          width: "",
          height: "",
          padding: "",
          position: void 0,
          left: "",
          top: ""
        }),
        (I) => {
          d.value = I;
        },
        { immediate: true }
      );
    else {
      const I = (se) => typeof se == "number" && isFinite(se), Y = /* @__PURE__ */ ref({ left: 0, top: 0, width: 0, height: 0 }), oe = () => {
        let se = o.trigger || s12.value;
        if (typeof se == "string" && (se = document.querySelector(se)), typeof se == "object" && se != null) {
          if (typeof se.getBoundingClientRect == "function")
            return se.getBoundingClientRect();
          if (I(se.pageX) && I(se.pageY))
            return {
              left: se.pageX,
              top: se.pageY,
              height: 0,
              width: 0
            };
          if (Array.isArray(se.touches) && Array.isArray(se.changedTouches)) {
            const Ie = se.touches[0] || se.changedTouches[0];
            return Ie ? {
              left: Ie.pageX,
              top: Ie.pageY,
              height: 0,
              width: 0
            } : void 0;
          }
        }
      }, Z = /* @__PURE__ */ ref();
      p = () => {
        var I0, b0, P1;
        const se = oe();
        if (!se || !u.value || !s12.value || !o.enabled)
          return;
        const {
          boundsSelector: Ie,
          paddingLeft: ie,
          paddingTop: ye,
          paddingBottom: ne,
          paddingRight: k,
          offsetX: K,
          offsetY: G
        } = o, Q = Ie && u.value.querySelector(Ie) || u.value;
        if (!Q)
          return;
        const { anchorX: ce, anchorY: ve, alignX: Re, alignY: le } = l2.value, { width: Ae, height: H } = q.value, re = se.left + ce * se.width, ue = se.top + ve * se.height, Me = Q.getBoundingClientRect();
        o.matchWidth && !Z.value && (Z.value = Me);
        const Se = (o.height ?? 0) > ((I0 = Z.value) == null ? void 0 : I0.height) ? 0 : 10, $e = o.matchWidth ? Math.max(se.width, ((b0 = Z.value) == null ? void 0 : b0.width) + Se) : Me.width, a0 = o.height || Me.height, Ne = -$e * Re + K, Ye = -a0 * le + G, $0 = Math.min($e, Ae - ie - k), Be = Math.min(
          (P1 = Z.value) == null ? void 0 : P1.height,
          a0,
          H - ye - ne
        ), o0 = Math.min(
          Math.max(ie, re + Ne),
          Ae - $e - k
        );
        let Ke = Math.min(
          Math.max(ye, ue + Ye),
          H - a0 - ne
        );
        Math.max(ye, ue + Ye) > // Bottom of the trigger
        H - a0 - ne && (Ke = Math.max(se.top - Ye - a0, ye)), Y.value = { left: o0, top: Ke, width: $0, height: Be };
      }, watch(
        () => {
          const { paddingLeft: se, paddingTop: Ie, paddingBottom: ie, paddingRight: ye } = o, { left: ne, top: k, width: K, height: G } = Y.value, { width: Q, height: ce } = o, ve = Q || K, Re = ce || G, le = I(ve) && ve > 0 ? `${ve}px` : ve ? String(ve) : "auto", Ae = I(Re) && Re > 0 ? `${Re}px` : Re ? String(Re) : "auto";
          let H = k, re = ne;
          if (c.value) {
            const ue = c.value.getBoundingClientRect();
            I(k) && I(G) && (k + G > ue.height && (H = ue.height - G), H = Math.max(k, ue.top)), I(ne) && I(K) && (ne + K > ue.width && (re = ue.width - K), re = Math.max(ne, ue.left));
          }
          return {
            left: isFinite(re) ? `${re}px` : "auto",
            top: isFinite(H) ? `${H}px` : "auto",
            width: le,
            height: Ae,
            padding: `${Ie}px ${ye}px ${ie}px ${se}px`
          };
        },
        (se) => {
          f.value = {
            left: "",
            // popoverStyle.left,
            top: "",
            // popoverStyle.top,
            marginLeft: "",
            marginTop: ""
          }, d.value = {
            transform: "",
            width: se.width,
            height: se.height,
            padding: se.padding,
            position: "fixed",
            left: se.left,
            top: se.top
          };
        },
        { immediate: true }
      ), watch(_, p, { deep: true }), watch(q, p, { deep: true }), watch(l2, p, { deep: true }), watch(() => o.enabled, p), watch(
        () => ({ visible: o.visible, height: o.height }),
        async (se) => {
          se.visible && (await nextTick(), p());
        }
      ), onMounted(p);
    }
    const S = (I) => {
      let Y = I.target;
      for (; Y; ) {
        if (Y.dataset.popid)
          return parseInt(Y.dataset.popid, 10);
        Y = Y.parentElement;
      }
    }, N = (I) => {
      const Y = S(I);
      return Y !== void 0 && ts.stack.includes(Y);
    }, v = (I) => {
      I && !o.enabled || I != z.value && (z.value = I, I && (ts.stack[r12] = a), nextTick(p), i("update:visible", I));
    }, C = () => v(true), L = () => v(false), B = () => {
      v(!z.value);
    }, P12 = { show: C, hide: L, toggle: B }, j = (I) => {
      if (o.showOn.includes(I))
        C();
      else if (o.hideOn.includes(I))
        L();
      else if (o.toggleOn.includes(I))
        B();
      else
        return false;
      return true;
    }, $ = computed(() => (o.visible || z.value) && o.enabled), W = (I) => {
      N(I) || j("outside");
    }, x = () => {
      j("scroll") || p();
    }, D = (I) => {
      j("inside") && I.stopPropagation();
    }, w = {
      keydown: (I) => {
        switch (I.key) {
          case "Enter":
            return j("enter");
          case "Escape":
            return j("escape");
          case "Space":
            return j("space");
        }
        j("keydown");
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      mouseenter: (I) => {
        j("mouseenter");
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      mouseleave: (I) => {
        j("mouseleave");
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      click: (I) => {
        j("click");
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      focus: (I) => {
        j("focus");
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      blur: (I) => {
        j("blur");
      }
    };
    return (I, Y) => withDirectives((openBlock(), createElementBlock("div", mergeProps({
      ref_key: "container",
      ref: s12,
      class: ["una-relative", unref(b)]
    }, toHandlers(w)), [
      renderSlot(I.$slots, "default", normalizeProps(guardReactiveProps(P12)), void 0, true),
      createVNode(Transition, { name: t16.transition }, {
        default: withCtx(() => [
          unref($) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            t16.relative ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "una-relative-point",
              style: normalizeStyle(unref(f))
            }, [
              withDirectives((openBlock(), createElementBlock("div", {
                ref_key: "popover",
                ref: u,
                class: normalizeClass(["una-relative-content", o.contentClasses]),
                style: normalizeStyle(unref(d)),
                onClick: D
              }, [
                renderSlot(I.$slots, "content", normalizeProps(guardReactiveProps(P12)), void 0, true)
              ], 6)), [
                [
                  unref(wd),
                  unref(_),
                  void 0,
                  { passive: true }
                ]
              ])
            ], 4)) : (openBlock(), createBlock(Teleport, {
              key: 1,
              to: "body"
            }, [
              withDirectives((openBlock(), createElementBlock("div", {
                ref_key: "popover",
                ref: u,
                class: normalizeClass(["una-relative-content una-vue-base", o.contentClasses]),
                style: normalizeStyle(unref(d)),
                "data-popid": a,
                onClick: D
              }, [
                renderSlot(I.$slots, "content", normalizeProps(guardReactiveProps(P12)), void 0, true)
              ], 6)), [
                [
                  unref(wd),
                  unref(_),
                  void 0,
                  { passive: true }
                ]
              ])
            ]))
          ], 64)) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["name"])
    ], 16)), [
      [
        unref(wd),
        unref(q),
        void 0,
        {
          window: true,
          passive: true
        }
      ],
      [unref(uHe), { callback: W, stackLevel: o.outsideStackLevel }],
      [
        unref(yt0),
        x,
        void 0,
        { lazy: true }
      ]
    ]);
  }
}), pc = /* @__PURE__ */ Je(St0, [["__scopeId", "data-v-14e326ae"]]);
var gt0 = {
  prefix: "fad",
  iconName: "square-check",
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M337 175c9.4 9.4 9.4 24.6 0 33.9L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0z"]]
}, sHe = {
  prefix: "fad",
  iconName: "spinner-third",
  icon: [512, 512, [], "f3f4", ["M256 64C150 64 64 150 64 256s86 192 192 192c70.1 0 131.3-37.5 164.9-93.6l.1 .1c-6.9 14.9-1.5 32.8 13 41.2c15.3 8.9 34.9 3.6 43.7-11.7c.2-.3 .4-.6 .5-.9l0 0C434.1 460.1 351.1 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0c-17.7 0-32 14.3-32 32s14.3 32 32 32z", "M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z"]]
}, cHe = {
  prefix: "fad",
  iconName: "loader",
  icon: [512, 512, [], "e1d4", ["M346.5 120.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L437 120.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-45.3 45.3zM384 256c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H416c-17.7 0-32 14.3-32 32zM256 384c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416c0-17.7-14.3-32-32-32zm135.8-37.5c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L391.8 437c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-45.3-45.3zM75 437c12.5 12.5 32.8 12.5 45.3 0l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L75 391.8c-12.5 12.5-12.5 32.8 0 45.3z", "M256 0c-17.7 0-32 14.3-32 32V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32zM0 256c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l45.3 45.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L120.2 75z"]]
};
var Pt0 = {
  prefix: "fas",
  iconName: "pen-to-square",
  icon: [512, 512, ["edit"], "f044", "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"]
}, Dt0 = Pt0, lHe = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, kt0 = {
  prefix: "fas",
  iconName: "circle",
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
}, jt0 = {
  prefix: "fas",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"]
}, Ht0 = {
  prefix: "fas",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
}, Xt0 = Ht0, $t0 = {
  prefix: "fas",
  iconName: "grip-vertical",
  icon: [320, 512, [], "f58e", "M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"]
}, Gt0 = {
  prefix: "fas",
  iconName: "ellipsis-vertical",
  icon: [128, 512, ["ellipsis-v"], "f142", "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"]
}, Jt0 = {
  prefix: "fas",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
}, Kt0 = Jt0, dc = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, pHe = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, dHe = pHe, bp = pHe, Mp = {
  prefix: "fas",
  iconName: "chevron-left",
  icon: [320, 512, [9001], "f053", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
}, fc = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
}, rr0 = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, nr0 = rr0;
var An = /* @__PURE__ */ ((t16) => (t16.Normal = "normal", t16.Pill = "pill", t16.None = "none", t16))(An || {}), D0 = /* @__PURE__ */ ((t16) => (t16.Primary = "primary", t16.Secondary = "secondary", t16.Tertiary = "tertiary", t16.Link = "link", t16.Floating = "floating", t16))(D0 || {});
({
  rounded: {
    default: An.Normal
  }
});
const Yr0 = { class: "relative flex-1" }, Jr0 = { key: 0 }, Kr0 = {
  key: 0,
  class: "una-btn-split-separator"
}, Qr0 = ["onClick"], Zr0 = { class: "una-btn-split-menu" }, en0 = ["disabled", "onClick"], tn0 = /* @__PURE__ */ defineComponent({
  name: "UnaButton",
  __name: "button",
  props: {
    label: {},
    icon: {},
    leadingIcon: {},
    trailingIcon: {},
    loading: { type: Boolean },
    loadingIcon: {},
    stacked: { type: Boolean },
    rounded: {},
    variant: {},
    destructive: { type: Boolean },
    splitButtonOptions: {},
    primary: { type: Boolean },
    secondary: { type: Boolean },
    tertiary: { type: Boolean },
    link: { type: Boolean },
    floating: { type: Boolean }
  },
  emits: {
    click: (t16) => true,
    "split-option-selected": (t16) => true
  },
  setup(t16, { emit: e }) {
    N0.add(cHe, sHe, dc);
    const r12 = useAttrs(), n12 = t16, a = e, o = (q) => {
      f.value || a("click", q);
    }, i = (q, S) => {
      q.stopPropagation(), f.value || S();
    }, u = (q, S) => {
      S(), a("split-option-selected", q);
    }, s12 = ["fad", "spinner-third"], c = computed(() => [_(), ...z()]), l2 = computed(() => [n12.stacked && "flex-col"]), f = computed(() => !!r12.disabled || r12.disabled === "" || n12.loading), p = computed(() => {
      var q;
      return (((q = n12.label) == null ? void 0 : q.trim()) || "").length > 0;
    }), d = computed(() => n12.splitButtonOptions && n12.splitButtonOptions.length > 0), b = computed(() => {
      if (n12.variant)
        return n12.variant;
      switch (true) {
        case n12.primary:
          return D0.Primary;
        case n12.secondary:
          return D0.Secondary;
        case n12.tertiary:
          return D0.Tertiary;
        case n12.link:
          return D0.Link;
        case n12.floating:
          return D0.Floating;
        default:
          return D0.Secondary;
      }
    });
    function z() {
      switch (b.value) {
        case D0.Primary:
          return ["primary", n12.destructive && "destructive"];
        case D0.Tertiary:
          return ["tertiary", n12.destructive && "destructive"];
        case D0.Link:
          return ["link", !p.value && "icon-only", n12.destructive && "destructive"];
        case D0.Floating:
          return ["floating", !p.value && "icon-only", f.value && "disabled"];
        case D0.Secondary:
        default:
          return ["secondary", n12.destructive && "destructive"];
      }
    }
    function _() {
      return n12.rounded === An.Pill || n12.variant === D0.Floating ? "rounded-full" : n12.rounded === An.None ? "" : "rounded-lg";
    }
    return (q, S) => (openBlock(), createElementBlock("button", {
      class: normalizeClass(["una-btn", [unref(c), { "una-btn-split": unref(d) }]]),
      onClick: o
    }, [
      createBaseVNode("div", {
        class: normalizeClass([unref(l2), "flex items-center gap-2", { "una-btn-split-main": unref(d) }])
      }, [
        renderSlot(q.$slots, "leading", {}, () => [
          q.leadingIcon ? (openBlock(), createBlock(R0, mergeProps({ key: 0 }, q.leadingIcon, { class: "flex-none" }), null, 16)) : createCommentVNode("", true)
        ], true),
        createBaseVNode("div", Yr0, [
          renderSlot(q.$slots, "default", {}, () => [
            q.loading ? renderSlot(q.$slots, "loadingicon", { key: 0 }, () => [
              q.loadingIcon ? (openBlock(), createElementBlock("span", Jr0)) : (openBlock(), createBlock(R0, {
                key: 1,
                icon: s12,
                "spin-pulse": "",
                class: "absolute left-[calc(50%-4px)] top-[calc(50%-4px)]"
              }))
            ], true) : renderSlot(q.$slots, "icon", { key: 1 }, () => [
              q.icon ? (openBlock(), createBlock(R0, mergeProps({ key: 0 }, q.icon, { class: "align-middle" }), null, 16)) : createCommentVNode("", true)
            ], true),
            unref(p) ? (openBlock(), createElementBlock("span", {
              key: 2,
              class: normalizeClass({ invisible: q.loading })
            }, toDisplayString(q.label), 3)) : createCommentVNode("", true)
          ], true)
        ]),
        renderSlot(q.$slots, "trailing", {}, () => [
          q.trailingIcon ? (openBlock(), createBlock(R0, mergeProps({ key: 0 }, q.trailingIcon, { class: "flex-none" }), null, 16)) : createCommentVNode("", true)
        ], true)
      ], 2),
      unref(d) ? (openBlock(), createElementBlock("div", Kr0)) : createCommentVNode("", true),
      unref(d) ? (openBlock(), createBlock(pc, {
        key: 1,
        "hide-on": ["outside", "escape"],
        position: "bottom-right",
        "match-width": ""
      }, {
        default: withCtx(({ toggle: N }) => [
          createBaseVNode("div", {
            class: normalizeClass(["una-btn-split-dropdown", { disabled: unref(f) }]),
            onClick: withModifiers((v) => i(v, N), ["stop"])
          }, [
            createVNode(R0, {
              icon: ["fas", "chevron-down"],
              class: "w-3"
            })
          ], 10, Qr0)
        ]),
        content: withCtx(({ hide: N }) => [
          createBaseVNode("div", Zr0, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(q.splitButtonOptions, (v) => (openBlock(), createElementBlock("button", {
              key: v.value,
              type: "button",
              class: "una-btn-split-option",
              disabled: v.disabled,
              onClick: (C) => u(v, N)
            }, [
              v.slot ? renderSlot(q.$slots, v.slot, {
                key: 0,
                option: v
              }, void 0, true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(v.label), 1)
              ], 64))
            ], 8, en0))), 128))
          ])
        ]),
        _: 3
      })) : createCommentVNode("", true)
    ], 2));
  }
}), h0 = /* @__PURE__ */ Je(tn0, [["__scopeId", "data-v-b569bff2"]]);
var Or = /* @__PURE__ */ ((t16) => (t16.Default = "default", t16.Plain = "plain", t16.Switch = "switch", t16))(Or || {}), Hl = /* @__PURE__ */ ((t16) => (t16.Default = "default", t16.Outlined = "outlined", t16))(Hl || {});
const sn0 = ["disabled", "true-value", "false-value", "value", ".indeterminate"], cn0 = {
  key: 0,
  class: "slider"
}, ln0 = /* @__PURE__ */ defineComponent({
  __name: "checkbox-button",
  props: {
    /** The model value of the input */
    modelValue: {
      type: [Boolean, String, Number, Object, Array],
      default: false
    },
    /** Value to return if true */
    trueValue: {
      type: [Boolean, String, Number, Object, Array],
      default: true
    },
    /** Value to return if false */
    falseValue: {
      type: [Boolean, String, Number, Object, Array],
      default: false
    },
    /** The value of the input, used when modelValue is an array */
    value: {
      type: [Boolean, String, Number, Object, Array],
      default: null
    },
    /** The indeterminate of the input */
    indeterminate: {
      type: Boolean,
      default: false,
      description: "The indeterminate of the input"
    },
    /** Disable the component and make it unclickable  */
    disabled: {
      type: Boolean,
      default: false
    },
    /** Set the variant of the component */
    variant: {
      type: String,
      default: Or.Default,
      validator: (t16) => Object.values(Or).includes(t16)
    }
  },
  emits: ["change", "update:modelValue", "update:indeterminate"],
  setup(t16, { emit: e }) {
    const r12 = t16, n12 = e, a = computed({
      get() {
        return r12.modelValue;
      },
      set(s12) {
        n12("update:modelValue", s12);
      }
    }), o = computed({
      get() {
        return r12.indeterminate;
      },
      set(s12) {
        n12("update:indeterminate", s12);
      }
    }), i = computed(() => {
      switch (r12.variant) {
        case Or.Plain:
          return "focus:ring-0";
        case Or.Switch:
          return "switch-checkbox";
        case Or.Default:
          return "focus:ring-4";
        default:
          return "focus:ring-4";
      }
    }), u = () => {
      r12.indeterminate && (o.value = false), n12("change", a.value);
    };
    return (s12, c) => (openBlock(), createElementBlock("label", {
      class: normalizeClass(r12.variant === unref(Or).Switch && "switch")
    }, [
      withDirectives(createBaseVNode("input", {
        "onUpdate:modelValue": c[0] || (c[0] = (l2) => a.value = l2),
        type: "checkbox",
        tabindex: "0",
        class: normalizeClass(["form-checkbox", i.value]),
        disabled: r12.disabled,
        "true-value": r12.trueValue,
        "false-value": r12.falseValue,
        value: r12.value,
        ".indeterminate": o.value,
        onChange: u
      }, null, 42, sn0), [
        [vModelCheckbox, a.value]
      ]),
      r12.variant === unref(Or).Switch ? (openBlock(), createElementBlock("span", cn0)) : createCommentVNode("", true)
    ], 2));
  }
}), Tn = /* @__PURE__ */ Je(ln0, [["__scopeId", "data-v-b486f100"]]), pn0 = {
  key: 0,
  class: "ml-[12px] flex flex-col"
}, dn0 = { key: 0 }, fn0 = { class: "text-gray-500" }, bn0 = { key: 0 };
/* @__PURE__ */ defineComponent({
  __name: "checkbox",
  props: {
    /** The model value of the input */
    modelValue: {
      type: [Boolean, String, Number, Object, Array],
      default: false
    },
    /** Value to return if true */
    trueValue: {
      type: [Boolean, String, Number, Object, Array],
      default: true
    },
    /** Value to return if false */
    falseValue: {
      type: [Boolean, String, Number, Object, Array],
      default: false
    },
    /** The value of the input, used when modelValue is an array */
    value: {
      type: [Boolean, String, Number, Object, Array],
      default: null
    },
    /** The indeterminate of the input */
    indeterminate: {
      type: Boolean,
      default: false,
      description: "The indeterminate of the input"
    },
    /** Disable the component and make it unclickable  */
    disabled: {
      type: Boolean,
      default: false
    },
    /** Set the variant of the component */
    variant: {
      type: String,
      default: Hl.Default,
      validator: (t16) => Object.values(Hl).includes(t16)
    },
    /** The label of the input */
    label: {
      type: String,
      default: ""
    },
    /** Supporting text below the main label */
    message: {
      type: String,
      default: ""
    },
    /** Vertical alignment for the checkbox (top or middle) */
    verticalAlignment: {
      type: String,
      default: "top"
    }
  },
  emits: ["change", "update:modelValue", "update:indeterminate"],
  setup(t16, { emit: e }) {
    const r12 = t16, n12 = useSlots(), a = e, o = computed({
      get() {
        return r12.modelValue;
      },
      set(l2) {
        a("update:modelValue", l2);
      }
    }), i = computed(
      () => r12.variant === Hl.Outlined ? Or.Plain : Or.Default
    ), u = computed(() => {
      const l2 = [];
      return l2.push("leading-[19px]"), (n12.messageContent && n12.messageContent() || r12.message) && l2.push("font-medium"), r12.disabled ? l2.push("text-gray-500") : l2.push("text-gray-700"), l2;
    }), s12 = computed(() => {
      const l2 = [], f = `variant-${r12.variant}`;
      return l2.push(f), r12.disabled && l2.push(`${f}-disabled`), r12.verticalAlignment == "center" && l2.push("items-center"), l2;
    }), c = () => {
      a("change", o.value);
    };
    return (l2, f) => (openBlock(), createElementBlock("label", {
      class: normalizeClass(["una-checkbox", unref(s12)])
    }, [
      createVNode(Tn, mergeProps({
        modelValue: unref(o),
        "onUpdate:modelValue": f[0] || (f[0] = (p) => /* @__PURE__ */ isRef(o) ? o.value = p : null)
      }, l2.$props, {
        variant: unref(i),
        onChange: c
      }), null, 16, ["modelValue", "variant"]),
      l2.$slots.labelContent && l2.$slots.labelContent() || l2.$props.label || l2.$slots.messageContent && l2.$slots.messageContent() || l2.$props.message ? (openBlock(), createElementBlock("span", pn0, [
        createBaseVNode("span", {
          class: normalizeClass(unref(u))
        }, [
          renderSlot(l2.$slots, "labelContent", {}, () => [
            t16.label ? (openBlock(), createElementBlock("span", dn0, toDisplayString(t16.label), 1)) : createCommentVNode("", true)
          ], true)
        ], 2),
        createBaseVNode("span", fn0, [
          renderSlot(l2.$slots, "messageContent", {}, () => [
            t16.message ? (openBlock(), createElementBlock("div", bn0, toDisplayString(t16.message), 1)) : createCommentVNode("", true)
          ], true)
        ])
      ])) : createCommentVNode("", true)
    ], 2));
  }
});
const Hn = {
  editorContainerClasses: "",
  label: "",
  message: "",
  messageRight: "",
  required: false,
  isDisabled: false
};
var OHe = {
  prefix: "far",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, On0 = OHe, zn0 = {
  prefix: "far",
  iconName: "eye-slash",
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"]
}, vn0 = {
  prefix: "far",
  iconName: "filter",
  icon: [512, 512, [], "f0b0", "M0 73.7C0 50.7 18.7 32 41.7 32H470.3c23 0 41.7 18.7 41.7 41.7c0 9.6-3.3 18.9-9.4 26.3L336 304.5V447.7c0 17.8-14.5 32.3-32.3 32.3c-7.3 0-14.4-2.5-20.1-7l-92.5-73.4c-9.6-7.6-15.1-19.1-15.1-31.3V304.5L9.4 100C3.3 92.6 0 83.3 0 73.7zM55 80L218.6 280.8c3.5 4.3 5.4 9.6 5.4 15.2v68.4l64 50.8V296c0-5.5 1.9-10.9 5.4-15.2L457 80H55z"]
}, Cn0 = {
  prefix: "far",
  iconName: "angle-down",
  icon: [448, 512, [8964], "f107", "M241 337c-9.4 9.4-24.6 9.4-33.9 0L47 177c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 337z"]
}, _He = {
  prefix: "far",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"]
};
const In0 = { class: "una-input-wrapper" }, En0 = { class: "una-label-section" }, Ln0 = { key: 0 }, Pn0 = {
  key: 0,
  class: "text-error-700"
}, Dn0 = ["tabindex", "onFocus"], Wn0 = { key: 0 }, Nn0 = {
  key: 0,
  class: "ml-auto"
}, wn0 = /* @__PURE__ */ defineComponent({
  __name: "input-wrapper",
  props: mergeDefaults({
    valid: { type: Boolean },
    label: {},
    message: {},
    messageRight: {},
    required: { type: Boolean },
    isDisabled: { type: Boolean },
    messageClasses: {},
    editorContainerClasses: {}
  }, {
    ...Hn,
    valid: true
  }),
  setup(t16, { expose: e }) {
    N0.add(On0);
    const r12 = t16, n12 = computed(() => {
      const u = [];
      return r12.valid ? u.push("text-gray-500") : u.push("!text-error-700"), r12.messageClasses && u.push(r12.messageClasses), u;
    }), a = computed(() => {
      const u = [];
      return r12.label && u.push("mt-[6px]"), r12.isDisabled ? u.push("una-input-wrapper-disabled") : r12.valid ? u.push("una-input-wrapper-valid") : u.push("una-input-wrapper-invalid"), r12.editorContainerClasses && u.push(r12.editorContainerClasses), u;
    }), o = /* @__PURE__ */ ref(0), i = () => {
      o.value++;
    };
    return e({ onFocus: i }), (u, s12) => (openBlock(), createElementBlock("div", In0, [
      createBaseVNode("div", En0, [
        renderSlot(u.$slots, "labelContent", {}, () => [
          u.label ? (openBlock(), createElementBlock("div", Ln0, [
            createTextVNode(toDisplayString(u.label) + " ", 1),
            u.required ? (openBlock(), createElementBlock("span", Pn0, "*")) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ], true)
      ]),
      createBaseVNode("div", {
        class: normalizeClass(["una-input-section", a.value]),
        tabindex: u.isDisabled ? -1 : 0,
        onFocus: withModifiers(i, ["stop"])
      }, [
        renderSlot(u.$slots, "default", { focused: unref(o) }, void 0, true)
      ], 42, Dn0),
      u.message || u.messageRight || !u.valid ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["una-message-section", n12.value])
      }, [
        u.valid ? createCommentVNode("", true) : (openBlock(), createBlock(unref(Wi), {
          key: 0,
          icon: ["far", "exclamation-circle"],
          class: "mr-[4px] text-error-700"
        })),
        renderSlot(u.$slots, "messageContent", {}, () => [
          u.message ? (openBlock(), createElementBlock("div", Wn0, toDisplayString(u.message), 1)) : createCommentVNode("", true)
        ], true),
        renderSlot(u.$slots, "messageRightContent", {}, () => [
          u.messageRight ? (openBlock(), createElementBlock("div", Nn0, toDisplayString(u.messageRight), 1)) : createCommentVNode("", true)
        ], true)
      ], 2)) : createCommentVNode("", true)
    ]));
  }
}), bc = /* @__PURE__ */ Je(wn0, [["__scopeId", "data-v-e6d63501"]]), Bn0 = { class: "una-calendar-years" }, xn0 = /* @__PURE__ */ defineComponent({
  __name: "calendar-years",
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    nextYearsTrigger: {
      type: Number,
      required: true,
      default: 0
    },
    previousYearsTrigger: {
      type: Number,
      required: true,
      default: 0
    }
  },
  emits: ["update:modelValue"],
  setup(t16, { emit: e }) {
    const r12 = t16, n12 = e, a = /* @__PURE__ */ ref(0), o = computed({
      get() {
        return r12.modelValue;
      },
      set(s12) {
        n12("update:modelValue", s12);
      }
    }), i = computed(() => {
      a.value || (a.value = o.value - 4);
      const s12 = a.value + 15, c = [];
      for (let l2 = a.value; l2 <= s12; l2++)
        c.push(l2);
      return c;
    });
    watch(
      () => r12.previousYearsTrigger,
      () => {
        a.value = a.value - 16;
      }
    ), watch(
      () => r12.nextYearsTrigger,
      () => {
        a.value = a.value + 16;
      }
    );
    const u = (s12) => {
      o.value = s12;
    };
    return (s12, c) => (openBlock(), createElementBlock("div", Bn0, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(unref(i), (l2) => (openBlock(), createBlock(h0, {
        key: l2,
        variant: unref(D0).Link,
        class: normalizeClass(["!text-gray-700 !no-underline", { "!bg-gray-300": unref(o) === l2 }]),
        onClickCapture: withModifiers((f) => u(l2), ["stop"])
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(l2), 1)
        ]),
        _: 2
      }, 1032, ["variant", "class", "onClickCapture"]))), 128))
    ]));
  }
}), Un0 = /* @__PURE__ */ Je(xn0, [["__scopeId", "data-v-ff9022a4"]]), kn0 = { class: "una-calendar-months" }, jn0 = /* @__PURE__ */ defineComponent({
  __name: "calendar-months",
  props: {
    modelValue: { default: 1 }
  },
  emits: ["update:modelValue"],
  setup(t16, { emit: e }) {
    const r12 = t16, n12 = e, a = computed({
      get() {
        return r12.modelValue;
      },
      set(u) {
        n12("update:modelValue", u);
      }
    }), o = computed(() => Array.from({ length: 12 }, (u, s12) => ({
      monthAbbreviation: new Date(2e3, s12, 1).toLocaleString("default", { month: "short" }),
      monthNumber: s12 + 1
    }))), i = (u) => {
      a.value = u.monthNumber;
    };
    return (u, s12) => (openBlock(), createElementBlock("div", kn0, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(unref(o), (c) => (openBlock(), createBlock(h0, {
        key: c.monthNumber,
        variant: unref(D0).Link,
        class: normalizeClass(["!text-gray-700 !no-underline", { "!bg-gray-300": unref(a) === c.monthNumber }]),
        onClickCapture: withModifiers((l2) => i(c), ["stop"])
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(c.monthAbbreviation), 1)
        ]),
        _: 2
      }, 1032, ["variant", "class", "onClickCapture"]))), 128))
    ]));
  }
}), Fn0 = /* @__PURE__ */ Je(jn0, [["__scopeId", "data-v-0e7abb84"]]);
class Dn {
  constructor(e, r12) {
    q0(this, "month");
    q0(this, "year");
    q0(this, "numberOfDays");
    q0(this, "firstDayOfMonth");
    q0(this, "lastDayOfMonth");
    this.month = e, this.year = r12;
    const n12 = new Date(this.year, this.month - 1, 1), a = new Date(this.year, this.month, 0);
    this.firstDayOfMonth = n12.getDay() + 1, this.lastDayOfMonth = a.getDay() + 1, this.numberOfDays = a.getDate();
  }
  getMonthName() {
    return [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ][this.month - 1];
  }
}
const Vn0 = { class: "una-calendar" }, Hn0 = { class: "una-calendar-actions" }, Xn0 = { class: "mt-[22px] px-[24px]" }, $n0 = {
  key: 2,
  class: "una-calendar-month"
}, Gn0 = ["onClick"], Yn0 = /* @__PURE__ */ defineComponent({
  __name: "calendar",
  props: {
    modelValue: { default: "" },
    minDate: {},
    maxDate: {}
  },
  emits: ["update:modelValue"],
  setup(t16, { emit: e }) {
    N0.add(Mp, fc);
    const r12 = t16, n12 = e, a = /* @__PURE__ */ ref(new Dn(11, 2023)), o = /* @__PURE__ */ ref(
      "calendar"
      /* Calendar */
    ), i = /* @__PURE__ */ ref(0), u = /* @__PURE__ */ ref(0), s12 = computed({
      get() {
        return r12.modelValue;
      },
      set(P12) {
        n12("update:modelValue", P12);
      }
    }), c = computed(() => ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]), l2 = computed(() => {
      const P12 = [], j = a.value.firstDayOfMonth - 1;
      for (let W = p.value.numberOfDays - (j - 1); W <= p.value.numberOfDays; W++)
        P12.push({
          dateIso: new Date(
            Date.UTC(p.value.year, p.value.month - 1, W)
          ).toISOString(),
          day: W,
          isInSelectedMonth: false,
          month: p.value.month
        });
      for (let W = 1; W <= a.value.numberOfDays; W++)
        P12.push({
          dateIso: new Date(
            Date.UTC(a.value.year, a.value.month - 1, W)
          ).toISOString(),
          day: W,
          isInSelectedMonth: true,
          month: a.value.month
        });
      const $ = 42 - j - a.value.numberOfDays;
      for (let W = 1; W <= $; W++)
        P12.push({
          dateIso: new Date(
            Date.UTC(f.value.year, f.value.month - 1, W)
          ).toISOString(),
          day: W,
          isInSelectedMonth: false,
          month: f.value.month
        });
      return P12;
    }), f = computed(() => a.value.month === 12 ? new Dn(1, a.value.year + 1) : new Dn(
      Number(a.value.month) + 1,
      a.value.year
    )), p = computed(() => a.value.month === 1 ? new Dn(12, a.value.year - 1) : new Dn(
      Number(a.value.month) - 1,
      a.value.year
    )), d = computed(() => {
      const P12 = new Date(s12.value);
      if (!isNaN(P12.getDate()))
        return P12;
    }), b = computed(() => /* @__PURE__ */ new Date());
    onMounted(() => {
      z();
    }), watch(d, () => {
      d.value && z();
    });
    const z = () => {
      d.value ? a.value = new Dn(
        d.value.getUTCMonth() + 1,
        d.value.getUTCFullYear()
      ) : a.value = new Dn(
        b.value.getUTCMonth() + 1,
        b.value.getUTCFullYear()
      );
    }, _ = () => {
      o.value === "calendar" ? a.value = p.value : o.value === "yearPicker" && u.value++;
    }, q = () => {
      o.value === "calendar" ? a.value = f.value : o.value === "yearPicker" && i.value++;
    }, S = () => {
      o.value = o.value === "monthPicker" ? "calendar" : "monthPicker";
    }, N = (P12) => {
      a.value = new Dn(P12, a.value.year), o.value = "calendar";
    }, v = (P12) => {
      a.value = new Dn(a.value.month, P12), o.value = "calendar";
    }, C = () => {
      o.value = o.value === "yearPicker" ? "calendar" : "yearPicker";
    }, L = (P12) => {
      const j = [];
      return (r12.minDate && new Date(P12.dateIso.replace("Z", "")) < new Date(r12.minDate) || r12.maxDate && new Date(P12.dateIso.replace("Z", "")) > new Date(r12.maxDate)) && j.push("!text-gray-300", "disabled"), P12.isInSelectedMonth || j.push("text-gray-400"), d.value && d.value.getUTCFullYear() === a.value.year && d.value.getUTCDate() === P12.day && d.value.getUTCMonth() + 1 === P12.month ? j.push("una-calendar-selected") : b.value.getUTCFullYear() === a.value.year && b.value.getUTCDate() === P12.day && b.value.getUTCMonth() + 1 === P12.month && j.push("una-calendar-today"), j;
    }, B = (P12) => {
      r12.minDate && new Date(P12.dateIso.replace("Z", "")) < new Date(r12.minDate) || r12.maxDate && new Date(P12.dateIso.replace("Z", "")) > new Date(r12.maxDate) || (s12.value = P12.dateIso);
    };
    return (P12, j) => {
      const $ = Fn0, W = Un0;
      return openBlock(), createElementBlock("div", Vn0, [
        createBaseVNode("div", Hn0, [
          unref(o) !== "monthPicker" ? (openBlock(), createBlock(h0, {
            key: 0,
            variant: unref(D0).Link,
            rounded: unref(An).Pill,
            class: "!text-gray-500",
            icon: { icon: ["fas", "chevron-left"] },
            onClick: withModifiers(_, ["stop"])
          }, null, 8, ["variant", "rounded", "onClick"])) : createCommentVNode("", true),
          createVNode(h0, {
            variant: unref(D0).Secondary,
            class: "w-[120px]",
            onClick: withModifiers(S, ["stop"])
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(a).getMonthName()), 1)
            ]),
            _: 1
          }, 8, ["variant", "onClick"]),
          createVNode(h0, {
            variant: unref(D0).Secondary,
            onClick: withModifiers(C, ["stop"])
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(a).year), 1)
            ]),
            _: 1
          }, 8, ["variant", "onClick"]),
          unref(o) !== "monthPicker" ? (openBlock(), createBlock(h0, {
            key: 1,
            variant: unref(D0).Link,
            rounded: unref(An).Pill,
            class: "!text-gray-500",
            icon: { icon: ["fas", "chevron-right"] },
            onClick: withModifiers(q, ["stop"])
          }, null, 8, ["variant", "rounded", "onClick"])) : createCommentVNode("", true)
        ]),
        createBaseVNode("div", Xn0, [
          unref(o) === "monthPicker" ? (openBlock(), createBlock($, {
            key: 0,
            "model-value": unref(a).month,
            "onUpdate:modelValue": N
          }, null, 8, ["model-value"])) : createCommentVNode("", true),
          unref(o) === "yearPicker" ? (openBlock(), createBlock(W, {
            key: 1,
            "model-value": unref(a).year,
            "previous-years-trigger": unref(u),
            "next-years-trigger": unref(i),
            "onUpdate:modelValue": v
          }, null, 8, ["model-value", "previous-years-trigger", "next-years-trigger"])) : createCommentVNode("", true),
          unref(o) === "calendar" ? (openBlock(), createElementBlock("div", $n0, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(c), (x) => (openBlock(), createElementBlock("div", {
              key: x,
              class: "mb-[10px] font-medium leading-5"
            }, toDisplayString(x), 1))), 128)),
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(l2), (x) => (openBlock(), createElementBlock("div", {
              key: x.dateIso,
              class: normalizeClass(["una-calendar-day", L(x)]),
              onClick: withModifiers((D) => B(x), ["stop"])
            }, toDisplayString(x.day), 11, Gn0))), 128))
          ])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
}), Jn0 = /* @__PURE__ */ Je(Yn0, [["__scopeId", "data-v-2e2cb7dd"]]), Kn0 = {
  modelValue: "",
  placeholder: "",
  valid: true,
  triggerValidation: 0,
  required: false,
  isDisabled: false,
  focused: 0,
  popupStackLevel: -1
}, Qn0 = { class: "flex h-[40px] flex-1 items-center" }, Zn0 = ["placeholder", "disabled"], ea0 = {
  key: 0,
  class: "ml-[8px] w-[20px] cursor-pointer"
};
/* @__PURE__ */ defineComponent({
  __name: "date-time-editor",
  props: mergeDefaults({
    modelValue: {},
    placeholder: {},
    valid: { type: [Boolean, Function] },
    triggerValidation: {},
    required: { type: Boolean },
    isDisabled: { type: Boolean },
    focused: {},
    minDate: {},
    maxDate: {},
    popupStackLevel: {}
  }, Kn0),
  emits: ["validated", "update:modelValue"],
  setup(t16, { emit: e }) {
    N0.add(st0);
    const r12 = t16, n12 = e, a = /* @__PURE__ */ ref(""), o = computed({
      get() {
        return r12.modelValue;
      },
      set(p) {
        n12("update:modelValue", p);
      }
    });
    watch(
      () => r12.valid,
      () => {
        c();
      }
    ), watch(
      () => r12.modelValue,
      () => {
        c();
      },
      { immediate: false }
    );
    const i = /* @__PURE__ */ ref(null);
    watch(
      () => r12.focused,
      () => {
        i.value && i.value.focus();
      }
    );
    const u = (p = false) => {
      if (!a.value)
        return "";
      let d = new Date(a.value);
      if (isNaN(d.getDate()))
        return p && (a.value = ""), "";
      {
        d = new Date(
          Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())
        );
        const b = d.toISOString();
        return r12.minDate && new Date(b.replace("Z", "")) < new Date(r12.minDate) ? (a.value = l2(r12.minDate), r12.minDate) : r12.maxDate && new Date(b.replace("Z", "")) > new Date(r12.maxDate) ? (a.value = l2(r12.maxDate), r12.maxDate) : (p && (a.value = l2(b)), b);
      }
    }, s12 = () => {
      const p = u();
      o.value !== p && (o.value = p), c();
    };
    watch(
      () => r12.triggerValidation,
      () => {
        c();
      }
    );
    const c = () => {
      if (!r12.isDisabled) {
        if (r12.required && !r12.modelValue) {
          n12("validated", {
            isValid: false,
            invalidReason: "required"
          });
          return;
        }
        n12("validated", { isValid: true });
      }
    }, l2 = (p) => {
      if (p) {
        const d = p.split("T")[0].split("-"), b = d[1], z = d[2], _ = d[0];
        return `${b}/${z}/${_}`;
      } else
        return "";
    }, f = (p, d) => {
      a.value = l2(p), o.value = u(), d();
    };
    return watch(
      () => r12.modelValue,
      () => {
        a.value = l2(o.value) || "", u(true);
      },
      { immediate: true }
    ), (p, d) => {
      const b = Jn0;
      return openBlock(), createElementBlock("div", Qn0, [
        withDirectives(createBaseVNode("input", {
          "onUpdate:modelValue": d[0] || (d[0] = (z) => /* @__PURE__ */ isRef(a) ? a.value = z : null),
          ref_key: "input",
          ref: i,
          class: "una-date-time-editor",
          type: "text",
          placeholder: p.placeholder,
          disabled: p.isDisabled,
          autocomplete: "new-password",
          onBlur: s12
        }, null, 40, Zn0), [
          [vModelText, unref(a)]
        ]),
        p.isDisabled ? createCommentVNode("", true) : (openBlock(), createElementBlock("div", ea0, [
          createVNode(pc, {
            position: "bottom-right",
            "offset-y": 13,
            hideOn: ["outside", "escape"],
            "outside-stack-level": r12.popupStackLevel
          }, {
            default: withCtx(({ toggle: z }) => [
              createVNode(unref(Wi), {
                icon: ["fal", "calendar"],
                class: "calendar-icon",
                onClick: z
              }, null, 8, ["onClick"])
            ]),
            content: withCtx(({ toggle: z }) => [
              createVNode(b, {
                class: "text-center",
                "model-value": unref(o),
                minDate: r12.minDate,
                maxDate: r12.maxDate,
                "onUpdate:modelValue": (_) => f(_, z)
              }, null, 8, ["model-value", "minDate", "maxDate", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["outside-stack-level"])
        ]))
      ]);
    };
  }
});
const Fa0 = {}, Hee = (t16) => (pushScopeId("data-v-2db0d0a2"), t16 = t16(), popScopeId(), t16), Va0 = { class: "progress" }, Ha0 = /* @__PURE__ */ Hee(() => /* @__PURE__ */ createBaseVNode("div", { class: "line" }, null, -1)), Xa0 = /* @__PURE__ */ Hee(() => /* @__PURE__ */ createBaseVNode("div", { class: "subline inc" }, null, -1)), $a0 = /* @__PURE__ */ Hee(() => /* @__PURE__ */ createBaseVNode("div", { class: "subline dec" }, null, -1)), Ga0 = [
  Ha0,
  Xa0,
  $a0
];
function Ya0(t16, e) {
  return openBlock(), createElementBlock("div", Va0, Ga0);
}
const _n = /* @__PURE__ */ Je(Fa0, [["render", Ya0], ["__scopeId", "data-v-2db0d0a2"]]);
var Ds = /* @__PURE__ */ ((t16) => (t16.Default = "default", t16.Outlined = "outlined", t16))(Ds || {});
const eo0 = ["disabled", "value"], to0 = /* @__PURE__ */ defineComponent({
  __name: "radio-button",
  props: {
    /** The model value of the input */
    modelValue: {
      type: [Boolean, String, Number, Object, Array],
      default: false
    },
    /** The value of the input, used when modelValue is an array */
    value: {
      type: [Boolean, String, Number, Object, Array],
      default: null
    },
    /** Disable the component and make it unclickable  */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["change", "update:modelValue"],
  setup(t16, { emit: e }) {
    const r12 = t16, n12 = e, a = computed({
      get() {
        return r12.modelValue;
      },
      set(i) {
        n12("update:modelValue", i);
      }
    }), o = () => {
      n12("change", a.value);
    };
    return (i, u) => withDirectives((openBlock(), createElementBlock("input", {
      "onUpdate:modelValue": u[0] || (u[0] = (s12) => /* @__PURE__ */ isRef(a) ? a.value = s12 : null),
      type: "radio",
      tabindex: "0",
      class: "",
      disabled: r12.disabled,
      value: r12.value,
      onChange: o
    }, null, 40, eo0)), [
      [vModelRadio, unref(a)]
    ]);
  }
}), Xee = /* @__PURE__ */ Je(to0, [["__scopeId", "data-v-5e65b14a"]]), ro0 = {
  key: 0,
  class: "ml-[12px] flex flex-col"
}, no0 = { key: 0 }, ao0 = { class: "text-gray-500" }, oo0 = { key: 0 };
/* @__PURE__ */ defineComponent({
  __name: "radio",
  props: {
    /** The model value of the input */
    modelValue: {
      type: [Boolean, String, Number, Object, Array],
      default: false
    },
    /** The value of the input, used when modelValue is an array */
    value: {
      type: [Boolean, String, Number, Object, Array],
      default: void 0
    },
    /** Disable the component and make it unclickable  */
    disabled: {
      type: Boolean,
      default: false
    },
    /** Set the variant of the component */
    variant: {
      type: String,
      default: Ds.Default,
      validator: (t16) => Object.values(Ds).includes(t16)
    },
    /** The label of the input */
    label: {
      type: String,
      default: ""
    },
    /** Supporting text below the main label */
    message: {
      type: String,
      default: ""
    },
    /** Vertical alignment for the radio button (top or center) */
    verticalAlignment: {
      type: String,
      default: "top"
    }
  },
  emits: ["change", "update:modelValue", "update:indeterminate"],
  setup(t16, { emit: e }) {
    const r12 = t16, n12 = useSlots(), a = e, o = computed({
      get() {
        return r12.modelValue;
      },
      set(c) {
        a("update:modelValue", c);
      }
    }), i = computed(() => {
      const c = [];
      return c.push("leading-[19px]"), (n12.messageContent && n12.messageContent() || r12.message) && c.push("font-medium"), r12.disabled ? c.push("text-gray-500") : c.push("text-gray-700"), c;
    }), u = computed(() => {
      const c = [], l2 = `variant-${r12.variant}`;
      return c.push(l2), r12.disabled && c.push(`${l2}-disabled`), r12.verticalAlignment == "center" && c.push("items-center"), c;
    }), s12 = () => {
      a("change", o.value);
    };
    return (c, l2) => (openBlock(), createElementBlock("label", {
      class: normalizeClass(["una-radio", unref(u)])
    }, [
      createVNode(Xee, mergeProps({
        modelValue: unref(o),
        "onUpdate:modelValue": l2[0] || (l2[0] = (f) => /* @__PURE__ */ isRef(o) ? o.value = f : null)
      }, { ...c.$props, ...c.$attrs }, { onChange: s12 }), null, 16, ["modelValue"]),
      c.$slots.labelContent && c.$slots.labelContent() || c.$props.label || c.$slots.messageContent && c.$slots.messageContent() || c.$props.message ? (openBlock(), createElementBlock("span", ro0, [
        createBaseVNode("span", {
          class: normalizeClass(unref(i))
        }, [
          renderSlot(c.$slots, "labelContent", {}, () => [
            t16.label ? (openBlock(), createElementBlock("span", no0, toDisplayString(t16.label), 1)) : createCommentVNode("", true)
          ], true)
        ], 2),
        createBaseVNode("span", ao0, [
          renderSlot(c.$slots, "messageContent", {}, () => [
            t16.message ? (openBlock(), createElementBlock("div", oo0, toDisplayString(t16.message), 1)) : createCommentVNode("", true)
          ], true)
        ])
      ])) : createCommentVNode("", true)
    ], 2));
  }
});
function ja(t16, e) {
  if (t16 === e)
    return true;
  if (t16 instanceof Date && e instanceof Date && t16.getTime() !== e.getTime() || t16 !== Object(t16) || e !== Object(e))
    return false;
  const r12 = Object.keys(t16);
  return r12.length !== Object.keys(e).length ? false : r12.every((n12) => ja(t16[n12], e[n12]));
}
function uo0(t16) {
  return t16 == null ? [] : Array.isArray(t16) ? t16 : [t16];
}
function so0(t16, e) {
  return t16 ? e ? Array.from(new Map(t16.map((r12) => [r12[e], r12])).values()) : [...new Set(t16)] : [];
}
const S0 = {
  animateMenuIcon: true,
  clearable: false,
  filterable: false,
  filterMode: "local",
  focused: 0,
  getOptionById: void 0,
  isDisabled: false,
  loading: false,
  menuHeight: 300,
  menuIcon: () => ["fal", "chevron-down"],
  menuOffsetX: 0,
  menuOffsetY: 3,
  multiple: false,
  modelValue: () => S0.multiple ? [] : null,
  noOptionsText: "No options found.",
  optionLabelField: "label",
  options: () => [],
  optionValueField: "value",
  placeholder: "",
  required: false,
  reset: 0,
  selectionMax: -1,
  selectionMin: -1,
  selectionMaxDisplayed: void 0,
  triggerValidation: 0,
  valid: void 0,
  valueComparator: ja,
  returnValue: false
};
function $ee(t16) {
  return getCurrentScope() ? (onScopeDispose(t16), true) : false;
}
function fs(t16) {
  return typeof t16 == "function" ? t16() : unref(t16);
}
const mHe = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const co0 = Object.prototype.toString, lo0 = (t16) => co0.call(t16) === "[object Object]", v2 = () => {
}, rZ = /* @__PURE__ */ po0();
function po0() {
  var t16, e;
  return mHe && ((t16 = window == null ? void 0 : window.navigator) == null ? void 0 : t16.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
const nZ = {
  mounted: "mounted",
  unmounted: "unmounted"
};
function $r(t16) {
  var e;
  const r12 = fs(t16);
  return (e = r12 == null ? void 0 : r12.$el) != null ? e : r12;
}
const _p = mHe ? window : void 0;
function Xl(...t16) {
  let e, r12, n12, a;
  if (typeof t16[0] == "string" || Array.isArray(t16[0]) ? ([r12, n12, a] = t16, e = _p) : [e, r12, n12, a] = t16, !e)
    return v2;
  Array.isArray(r12) || (r12 = [r12]), Array.isArray(n12) || (n12 = [n12]);
  const o = [], i = () => {
    o.forEach((l2) => l2()), o.length = 0;
  }, u = (l2, f, p, d) => (l2.addEventListener(f, p, d), () => l2.removeEventListener(f, p, d)), s12 = watch(
    () => [$r(e), fs(a)],
    ([l2, f]) => {
      if (i(), !l2)
        return;
      const p = lo0(f) ? { ...f } : f;
      o.push(
        ...r12.flatMap((d) => n12.map((b) => u(l2, d, b, p)))
      );
    },
    { immediate: true, flush: "post" }
  ), c = () => {
    s12(), i();
  };
  return $ee(c), c;
}
let bre = false;
function Mre(t16, e, r12 = {}) {
  const { window: n12 = _p, ignore: a = [], capture: o = true, detectIframe: i = false } = r12;
  if (!n12)
    return;
  rZ && !bre && (bre = true, Array.from(n12.document.body.children).forEach((p) => p.addEventListener("click", v2)), n12.document.documentElement.addEventListener("click", v2));
  let u = true;
  const s12 = (p) => a.some((d) => {
    if (typeof d == "string")
      return Array.from(n12.document.querySelectorAll(d)).some((b) => b === p.target || p.composedPath().includes(b));
    {
      const b = $r(d);
      return b && (p.target === b || p.composedPath().includes(b));
    }
  }), l2 = [
    Xl(n12, "click", (p) => {
      const d = $r(t16);
      if (!(!d || d === p.target || p.composedPath().includes(d))) {
        if (p.detail === 0 && (u = !s12(p)), !u) {
          u = true;
          return;
        }
        e(p);
      }
    }, { passive: true, capture: o }),
    Xl(n12, "pointerdown", (p) => {
      const d = $r(t16);
      u = !s12(p) && !!(d && !p.composedPath().includes(d));
    }, { passive: true }),
    i && Xl(n12, "blur", (p) => {
      setTimeout(() => {
        var d;
        const b = $r(t16);
        ((d = n12.document.activeElement) == null ? void 0 : d.tagName) === "IFRAME" && !(b != null && b.contains(n12.document.activeElement)) && e(p);
      }, 0);
    })
  ].filter(Boolean);
  return () => l2.forEach((p) => p());
}
const Mo0 = {
  [nZ.mounted](t16, e) {
    const r12 = !e.modifiers.bubble;
    if (typeof e.value == "function")
      t16.__onClickOutside_stop = Mre(t16, e.value, { capture: r12 });
    else {
      const [n12, a] = e.value;
      t16.__onClickOutside_stop = Mre(t16, n12, Object.assign({ capture: r12 }, a));
    }
  },
  [nZ.unmounted](t16) {
    t16.__onClickOutside_stop();
  }
};
function qHe(t16) {
  return getCurrentScope() ? (onScopeDispose(t16), true) : false;
}
function Ws(t16) {
  return typeof t16 == "function" ? t16() : unref(t16);
}
const THe = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function yo0(t16) {
  return getCurrentInstance();
}
function yHe(t16, e = true, r12) {
  yo0() ? onMounted(t16, r12) : e ? t16() : nextTick(t16);
}
function Mo(t16) {
  var e;
  const r12 = Ws(t16);
  return (e = r12 == null ? void 0 : r12.$el) != null ? e : r12;
}
const SHe = THe ? window : void 0;
function go0() {
  const t16 = /* @__PURE__ */ ref(false), e = getCurrentInstance();
  return e && onMounted(() => {
    t16.value = true;
  }, e), t16;
}
function Io0(t16) {
  const e = go0();
  return computed(() => (e.value, !!t16()));
}
function Eo0(t16, e, r12 = {}) {
  const { window: n12 = SHe, ...a } = r12;
  let o;
  const i = Io0(() => n12 && "ResizeObserver" in n12), u = () => {
    o && (o.disconnect(), o = void 0);
  }, s12 = computed(() => Array.isArray(t16) ? t16.map((f) => Mo(f)) : [Mo(t16)]), c = watch(
    s12,
    (f) => {
      if (u(), i.value && n12) {
        o = new ResizeObserver(e);
        for (const p of f)
          p && o.observe(p, a);
      }
    },
    { immediate: true, flush: "post" }
  ), l2 = () => {
    u(), c();
  };
  return qHe(l2), {
    isSupported: i,
    stop: l2
  };
}
function Lo0(t16, e = { width: 0, height: 0 }, r12 = {}) {
  const { window: n12 = SHe, box: a = "content-box" } = r12, o = computed(() => {
    var f, p;
    return (p = (f = Mo(t16)) == null ? void 0 : f.namespaceURI) == null ? void 0 : p.includes("svg");
  }), i = /* @__PURE__ */ ref(e.width), u = /* @__PURE__ */ ref(e.height), { stop: s12 } = Eo0(
    t16,
    ([f]) => {
      const p = a === "border-box" ? f.borderBoxSize : a === "content-box" ? f.contentBoxSize : f.devicePixelContentBoxSize;
      if (n12 && o.value) {
        const d = Mo(t16);
        if (d) {
          const b = d.getBoundingClientRect();
          i.value = b.width, u.value = b.height;
        }
      } else if (p) {
        const d = Array.isArray(p) ? p : [p];
        i.value = d.reduce((b, { inlineSize: z }) => b + z, 0), u.value = d.reduce((b, { blockSize: z }) => b + z, 0);
      } else
        i.value = f.contentRect.width, u.value = f.contentRect.height;
    },
    r12
  );
  yHe(() => {
    const f = Mo(t16);
    f && (i.value = "offsetWidth" in f ? f.offsetWidth : e.width, u.value = "offsetHeight" in f ? f.offsetHeight : e.height);
  });
  const c = watch(
    () => Mo(t16),
    (f) => {
      i.value = f ? e.width : 0, u.value = f ? e.height : 0;
    }
  );
  function l2() {
    s12(), c();
  }
  return {
    width: i,
    height: u,
    stop: l2
  };
}
const CHe = () => {
  function t16() {
    return crypto && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
      const r12 = Math.random() * 16 | 0;
      return (e === "x" ? r12 : r12 & 3 | 8).toString(16);
    });
  }
  return {
    getUUID: t16
  };
}, Gee = () => {
  const t16 = /* @__PURE__ */ ref(0), e = computed(() => t16.value > 0);
  async function r12(n12) {
    try {
      return t16.value++, await n12;
    } finally {
      nextTick(() => t16.value--);
    }
  }
  return {
    asyncsLoading: e,
    loadAsync: r12
  };
}, Po0 = ["id"], Do0 = { class: "flex min-h-[40px] items-center justify-between gap-2" }, Wo0 = { class: "my-[8px] w-full truncate" }, No0 = {
  class: "una-select-placeholder truncate text-gray-500",
  "aria-hidden": "true"
}, wo0 = { class: "una-select-selections flex flex-wrap gap-[6px] truncate" }, Bo0 = ["title"], xo0 = { class: "truncate" }, Uo0 = {
  key: 1,
  class: "una-select-input flex flex-grow items-center"
}, ko0 = ["placeholder", "disabled"], jo0 = { class: "flex items-center gap-2" }, Fo0 = ["onClick"], Vo0 = ["onClick"], Ho0 = {
  key: 0,
  class: "relative w-[100%]"
}, Xo0 = ["onClick", "onKeydown"], $o0 = { class: "flex items-center space-x-2" }, Go0 = { class: "flex w-full items-center justify-between" }, Yo0 = {
  key: 0,
  class: "min-w-[30px]"
}, Jo0 = {
  key: 0,
  class: "una-select-option is-disabled px-[14px] py-[10px] focus-visible:border-none focus-visible:bg-gray-50 focus-visible:outline-none",
  role: "option"
}, Ko0 = /* @__PURE__ */ defineComponent({
  __name: "select-editor",
  props: mergeDefaults({
    animateMenuIcon: { type: Boolean },
    clearable: { type: Boolean },
    filterable: { type: Boolean },
    filterMode: {},
    focused: {},
    getOptionById: { type: Function },
    isDisabled: { type: Boolean },
    loading: { type: Boolean },
    menuHeight: {},
    menuIcon: {},
    menuOffsetX: {},
    menuOffsetY: {},
    modelValue: {},
    multiple: { type: Boolean },
    noOptionsText: {},
    optionLabelField: {},
    options: {},
    optionValueField: {},
    placeholder: {},
    required: { type: Boolean },
    returnValue: { type: Boolean },
    valid: { type: [Boolean, Function] },
    triggerValidation: {},
    selectionMax: {},
    selectionMin: {},
    selectionMaxDisplayed: {},
    valueComparator: { type: Function },
    reset: {}
  }, S0),
  emits: ["click:clear", "select:count", "update:modelValue", "input:filter", "validated"],
  setup(t16, { emit: e }) {
    const { getUUID: r12 } = CHe();
    N0.add(at0, bp, _He, et0, gt0);
    const n12 = t16;
    useSlots();
    const a = e, o = r12();
    function i(G) {
      return typeof G == "object" && G != null && !Array.isArray(G) ? {
        label: G[n12.optionLabelField],
        value: G[n12.optionValueField],
        raw: G
      } : {
        label: G,
        value: G,
        raw: G
      };
    }
    const u = computed(() => {
      if (n12.filterMode === "local" && n12.filterable && L.value) {
        let G = n12.options.map(i), Q = v.value;
        return G.filter((ce) => {
          let ve = false;
          return ce.raw.sublabel && (ve = ce.raw.sublabel.toLowerCase().indexOf(Q.toLowerCase()) !== -1), ve || ce.label.toLowerCase().indexOf(Q.toLowerCase()) !== -1;
        });
      }
      return n12.options.map(i);
    }), s12 = computed({
      get() {
        const G = n12.modelValue === null ? [] : uo0(n12.modelValue);
        let Q;
        return n12.returnValue ? Q = G.map((ce) => u.value.find((ve) => ve.value === ce)) : Q = G.map((ce) => u.value.find((ve) => n12.valueComparator(ce, ve.raw)) || i(ce)), Q;
      },
      set(G) {
        var Q;
        if (n12.returnValue) {
          const ce = n12.multiple ? G.map((ve) => ve.value) : ((Q = G[0]) == null ? void 0 : Q.value) ?? null;
          if (ja(s12.value, G))
            return;
          a("update:modelValue", ce);
        } else {
          const ce = G.map((Re) => Re.raw), ve = n12.multiple ? [...ce] : ce[0] ?? null;
          if (ja(s12.value, ve))
            return;
          a("update:modelValue", ve);
        }
      }
    });
    watch(
      () => n12.reset,
      async () => {
        await ye();
      }
    );
    const c = computed(() => Array.isArray(n12.modelValue) ? n12.modelValue.length > 0 : !!n12.modelValue), l2 = computed(() => n12.selectionMax < 0 || se.value < n12.selectionMax), f = /* @__PURE__ */ ref(false), p = computed(() => n12.multiple && n12.selectionMaxDisplayed && !f.value ? s12.value.slice(0, n12.selectionMaxDisplayed) : s12.value), d = (G) => {
      if (!(G.raw.isDisabled || !l2.value && !b(G)))
        if (n12.multiple) {
          const Q = s12.value.findIndex(
            (ce) => n12.valueComparator(ce.value, G.value)
          );
          if (Q === -1)
            s12.value = [...s12.value, G];
          else {
            const ce = [...s12.value];
            ce.splice(Q, 1), s12.value = ce;
          }
        } else
          n12.filterable && (v.value = G.label, C.value = JSON.parse(JSON.stringify(v.value))), s12.value = [G], I.value = false;
    }, b = (G) => s12.value.find((Q) => n12.valueComparator(G, Q)), z = computed(() => n12.placeholder && !c.value && !v.value), _ = computed(() => !n12.isDisabled && n12.clearable && (c.value || v.value)), q = () => {
      C.value = "", v.value = "", s12.value = [], a("click:clear", "");
    }, S = computed(() => n12.filterable ? n12.multiple ? !n12.isDisabled : true : false), N = /* @__PURE__ */ ref(), v = /* @__PURE__ */ ref("");
    let C = /* @__PURE__ */ ref(JSON.parse(JSON.stringify(v.value)));
    const L = computed(() => C.value !== v.value), B = (G) => {
      if (v.value.trim() === "" && !n12.multiple) {
        q();
        return;
      }
      const Q = G.target;
      a("input:filter", Q.value), I.value = true;
    }, P12 = () => {
      var G;
      C.value = JSON.parse(JSON.stringify(v.value)), (G = N.value) == null || G.focus();
    }, j = async () => {
      n12.multiple && (C.value = ""), JSON.parse(JSON.stringify(C.value)) !== v.value && (v.value = JSON.parse(JSON.stringify(C.value)), a("input:filter", v.value));
    }, $ = /* @__PURE__ */ ref();
    watch(
      () => n12.focused,
      () => {
        var G;
        n12.filterable ? P12() : (G = $.value) == null || G.focus();
      }
    );
    const W = /* @__PURE__ */ ref(), x = Lo0(W), D = computed(() => x.height.value ? Math.min(n12.menuHeight, x.height.value) : n12.menuHeight), w = computed(() => !n12.isDisabled), I = /* @__PURE__ */ ref(false), Y = () => {
      I.value = !I.value;
    }, oe = () => {
      L && v.value ? I.value = true : Y();
    };
    function Z(G) {
      var Q, ce;
      if (!(n12.multiple && ((Q = W.value) != null && Q.contains(G.target)))) {
        if (G.target && ((ce = G.target.closest(".una-select-option")) != null && ce.classList.contains("is-disabled")))
          return;
        I.value && (G.target && G.target.closest(".una-select-option") || j()), I.value = false;
      }
    }
    const se = computed(() => {
      var G;
      return ((G = s12.value) == null ? void 0 : G.length) ?? 0;
    });
    watch(se, () => a("select:count", se.value), { immediate: true });
    const Ie = (G) => {
      var Q;
      (Q = W.value) != null && Q.contains(G.relatedTarget) || ie(s12.value);
    };
    watch(
      () => n12.triggerValidation,
      () => {
        ie(s12.value);
      }
    );
    const ie = async (G) => {
      if (n12.isDisabled)
        return;
      const Q = G;
      if (n12.required && !(Q != null && Q.length)) {
        a("validated", {
          isValid: false,
          invalidReason: "required"
        });
        return;
      }
      if (n12.selectionMin > 0 && se.value < n12.selectionMin) {
        a("validated", {
          isValid: false,
          invalidReason: "min"
        });
        return;
      }
      if (n12.selectionMax > 0 && se.value > n12.selectionMax) {
        a("validated", {
          isValid: false,
          invalidReason: "max"
        });
        return;
      }
      a("validated", { isValid: true });
    };
    watch(
      () => n12.valid,
      () => {
        ie(s12.value);
      }
    );
    const ye = async () => {
      if (!c.value) {
        v.value = "", C.value = JSON.parse(JSON.stringify(v.value));
        return;
      }
      if (S.value && !n12.multiple)
        if (n12.returnValue && n12.getOptionById) {
          let G = u.value.find((Q) => Q.value === n12.modelValue);
          G || (G = i(await n12.getOptionById(n12.modelValue))), v.value = G.label, C.value = JSON.parse(JSON.stringify(v.value));
        } else
          v.value = s12.value[0].label, C.value = JSON.parse(JSON.stringify(v.value));
    };
    watch(
      () => n12.modelValue,
      async () => {
        await ye(), ie(s12.value);
      },
      { immediate: false }
    );
    const ne = /* @__PURE__ */ shallowRef();
    function k(G, Q) {
      var ve;
      switch (((ve = G.key) == null ? void 0 : ve.trim()) || G.code) {
        case "Tab":
          P12();
          break;
        case "Space":
        case "Enter":
          if (!w.value)
            return;
          I.value = true, Q >= 0 && nextTick(() => {
            d(u.value[Q]);
          });
          break;
        case "Backspace":
          n12.clearable && n12.multiple && !v.value && se.value && d(s12.value[se.value - 1]);
          break;
        case "ArrowDown":
          if (!w.value)
            return;
          I.value = true, nextTick(() => {
            setTimeout(() => {
              K(Q >= 0 ? Math.min(++Q, u.value.length) : 0);
            }, 1);
          });
          break;
        case "ArrowUp":
          if (!w.value)
            return;
          I.value = true, nextTick(() => {
            setTimeout(() => {
              K(Q >= 0 ? Math.max(--Q, 0) : 0);
            }, 1);
          });
          break;
        case "Escape":
          n12.clearable && q(), I.value = false;
          break;
      }
    }
    function K(G) {
      var Q;
      (Q = ne.value[G]) == null || Q.focus();
    }
    return onMounted(() => {
      ye();
    }), (G, Q) => {
      const ce = R0, ve = pc;
      return openBlock(), createElementBlock(Fragment, null, [
        withDirectives((openBlock(), createElementBlock("div", mergeProps({
          ref_key: "selectEditorRef",
          ref: $,
          id: `una-select-editor-${unref(o)}`,
          class: "una-select-editor min-h-[40px] w-full min-w-[35px] cursor-pointer outline-none"
        }, G.$attrs, {
          onClick: oe,
          tabindex: "0",
          onFocusout: Ie,
          onKeydown: Q[2] || (Q[2] = withModifiers((Re) => k(Re, -1), ["stop"]))
        }), [
          createBaseVNode("div", Do0, [
            createBaseVNode("div", Wo0, [
              unref(z) && !unref(S) ? renderSlot(G.$slots, "placeholder", { key: 0 }, () => [
                createBaseVNode("div", No0, toDisplayString(G.placeholder), 1)
              ], true) : createCommentVNode("", true),
              createBaseVNode("div", wo0, [
                unref(u).length && unref(c) && (n12.multiple || !n12.multiple && !n12.filterable) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(p), (Re, le) => (openBlock(), createElementBlock("div", {
                    key: `${Re.label}-${le}`,
                    class: normalizeClass(["flex items-center truncate text-inherit", [
                      n12.multiple ? "text-gray-700" : "text-gray-900",
                      {
                        "rounded-md border border-gray-300 px-[4px] py-[2px]": n12.multiple
                      }
                    ]]),
                    title: Re.label
                  }, [
                    createBaseVNode("div", xo0, toDisplayString(Re.label), 1),
                    n12.multiple && !n12.isDisabled && n12.clearable ? (openBlock(), createBlock(ce, {
                      key: 0,
                      class: "ml-[3px] text-gray-900",
                      icon: "times",
                      size: "sm",
                      onClick: withModifiers((Ae) => d(Re), ["stop"])
                    }, null, 8, ["onClick"])) : createCommentVNode("", true)
                  ], 10, Bo0))), 128)),
                  n12.multiple && n12.selectionMaxDisplayed && unref(s12).length > n12.selectionMaxDisplayed ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: "flex items-center truncate rounded-md border border-gray-300 px-[4px] py-[2px] text-inherit text-sky-600",
                    onClick: Q[0] || (Q[0] = withModifiers((Re) => f.value = !unref(f), ["stop"]))
                  }, [
                    createBaseVNode("div", null, toDisplayString(unref(f) ? "Show less" : `${unref(s12).length - n12.selectionMaxDisplayed} more`), 1)
                  ])) : createCommentVNode("", true)
                ], 64)) : createCommentVNode("", true),
                unref(S) ? (openBlock(), createElementBlock("div", Uo0, [
                  withDirectives(createBaseVNode("input", {
                    ref_key: "filterInputRef",
                    ref: N,
                    "onUpdate:modelValue": Q[1] || (Q[1] = (Re) => /* @__PURE__ */ isRef(v) ? v.value = Re : null),
                    type: "text",
                    class: "flex-grow bg-inherit outline-none",
                    placeholder: unref(c) ? "" : n12.placeholder,
                    disabled: n12.isDisabled,
                    onInput: B
                  }, null, 40, ko0), [
                    [vModelText, unref(v)]
                  ])
                ])) : createCommentVNode("", true)
              ])
            ]),
            createBaseVNode("div", jo0, [
              unref(_) ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: "cursor-pointer",
                onClick: withModifiers(q, ["stop"])
              }, [
                createVNode(ce, {
                  class: "text-gray-900",
                  icon: "times"
                })
              ], 8, Fo0)) : createCommentVNode("", true),
              unref(w) ? (openBlock(), createElementBlock("div", {
                key: 1,
                class: "menu-icon-content cursor-pointer text-gray-900",
                onClick: withModifiers(Y, ["stop"])
              }, [
                createVNode(ce, {
                  icon: n12.menuIcon,
                  class: normalizeClass(["transition-all", { "rotate-90": unref(I) && n12.animateMenuIcon }]),
                  "fixed-width": ""
                }, null, 8, ["icon", "class"])
              ], 8, Vo0)) : createCommentVNode("", true)
            ])
          ]),
          G.loading ? (openBlock(), createElementBlock("div", Ho0, [
            createVNode(unref(_n), { class: "top-[-6px]" })
          ])) : createCommentVNode("", true)
        ], 16, Po0)), [
          [unref(Mo0), Z]
        ]),
        unref(w) ? (openBlock(), createBlock(ve, {
          key: 0,
          visible: unref(I),
          position: "bottom-left",
          "offset-x": n12.menuOffsetX,
          "offset-y": n12.menuOffsetY,
          trigger: `#una-select-editor-${unref(o)}`,
          "match-width": "",
          height: unref(D),
          class: "!block",
          contentClasses: "box-content rounded-lg border border-solid border-gray-100"
        }, {
          content: withCtx(() => [
            createBaseVNode("ul", {
              ref_key: "menuContentRef",
              ref: W,
              class: "una-select-menu-list flex w-full list-none flex-col overflow-y-auto rounded-b bg-white",
              role: "listbox"
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(u), (Re, le) => (openBlock(), createElementBlock("li", {
                ref_for: true,
                ref_key: "optionsRef",
                ref: ne,
                key: le,
                class: normalizeClass(["una-select-option flex-1 cursor-pointer px-[14px] py-[10px] hover:bg-gray-50 focus-visible:border-none focus-visible:bg-gray-50 focus-visible:outline-none", {
                  "is-selected": b(Re),
                  "is-disabled": Re.raw.isDisabled || !unref(l2) && !b(Re)
                }]),
                role: "option",
                tabindex: "-1",
                onClick: withModifiers((Ae) => d(Re), ["stop"]),
                onKeydown: withModifiers((Ae) => k(Ae, le), ["stop", "prevent"])
              }, [
                createBaseVNode("div", $o0, [
                  n12.multiple ? (openBlock(), createBlock(unref(jee), {
                    key: 0,
                    class: "una-select-option-checkbox"
                  }, {
                    default: withCtx(() => [
                      b(Re) ? (openBlock(), createBlock(ce, {
                        key: 0,
                        icon: ["fad", "square-check"]
                      })) : createCommentVNode("", true),
                      createVNode(ce, {
                        class: "una-select-option-checkbox-border",
                        icon: ["fal", "square"]
                      })
                    ]),
                    _: 2
                  }, 1024)) : createCommentVNode("", true),
                  createBaseVNode("div", Go0, [
                    renderSlot(G.$slots, "option", normalizeProps(guardReactiveProps({ option: Re, idx: le })), () => [
                      createTextVNode(toDisplayString(Re.label), 1)
                    ], true),
                    n12.multiple ? createCommentVNode("", true) : (openBlock(), createElementBlock("div", Yo0, [
                      b(Re) ? (openBlock(), createBlock(ce, {
                        key: 0,
                        class: "una-select-option-icon self-center pl-2",
                        icon: ["far", "check"]
                      })) : createCommentVNode("", true)
                    ]))
                  ])
                ])
              ], 42, Xo0))), 128)),
              unref(u).length === 0 ? (openBlock(), createElementBlock("li", Jo0, [
                renderSlot(G.$slots, "noOptions", {}, () => [
                  createBaseVNode("span", null, toDisplayString(n12.noOptionsText), 1)
                ], true)
              ])) : createCommentVNode("", true)
            ], 512)
          ]),
          _: 3
        }, 8, ["visible", "offset-x", "offset-y", "trigger", "height"])) : createCommentVNode("", true)
      ], 64);
    };
  }
}), gHe = /* @__PURE__ */ Je(Ko0, [["__scopeId", "data-v-4a672fe2"]]), Oc = /* @__PURE__ */ defineComponent({
  __name: "select",
  props: {
    label: { default: Hn.label },
    message: { default: Hn.message },
    messageRight: { default: Hn.messageRight },
    required: { type: Boolean, default: Hn.required },
    isDisabled: { type: Boolean, default: S0.isDisabled },
    messageClasses: {},
    editorContainerClasses: {},
    animateMenuIcon: { type: Boolean, default: S0.animateMenuIcon },
    clearable: { type: Boolean, default: S0.clearable },
    filterable: { type: Boolean, default: S0.filterable },
    filterMode: { default: "local" },
    focused: { default: S0.focused },
    getOptionById: { type: Function, default: S0.getOptionById },
    loading: { type: Boolean },
    menuHeight: { default: S0.menuHeight },
    menuIcon: { default: S0.menuIcon },
    menuOffsetX: { default: -10 },
    menuOffsetY: { default: 6 },
    modelValue: { default: S0.modelValue },
    multiple: { type: Boolean, default: S0.multiple },
    noOptionsText: { default: S0.noOptionsText },
    optionLabelField: { default: S0.optionLabelField },
    options: { default: S0.options },
    optionValueField: { default: S0.optionValueField },
    placeholder: { default: S0.placeholder },
    returnValue: { type: Boolean, default: S0.returnValue },
    valid: { type: [Boolean, Function], default: S0.valid },
    triggerValidation: {},
    selectionMax: { default: S0.selectionMax },
    selectionMin: { default: S0.selectionMin },
    selectionMaxDisplayed: { default: S0.selectionMaxDisplayed },
    valueComparator: { type: Function, default: S0.valueComparator },
    reset: {}
  },
  emits: ["clear", "select:count", "update:modelValue", "input:filter", "validated"],
  setup(t16, { emit: e }) {
    const r12 = t16, n12 = e, a = /* @__PURE__ */ ref(true), o = /* @__PURE__ */ ref(""), i = computed({
      get() {
        return r12.modelValue;
      },
      set(b) {
        n12("update:modelValue", b);
      }
    }), u = computed(() => typeof r12.valid == "function" ? r12.valid(i.value).isValid : typeof r12.valid == "boolean" ? r12.valid : a.value), s12 = computed(() => r12.message || o.value), c = computed(() => r12.messageRight ? r12.messageRight : r12.multiple && r12.selectionMax > 0 || r12.selectionMin > 0 ? `${f.value}/${r12.selectionMax}` : ""), l2 = (b) => {
      a.value = b.isValid, b.isValid ? o.value = "" : b.message ? o.value = b.message : b.invalidReason === "required" ? o.value = r12.label ? `Enter ${r12.label}` : "Required" : b.invalidReason === "min" ? o.value = `Please select at least ${r12.selectionMin} option${r12.selectionMin > 1 ? "s" : ""}` : b.invalidReason === "max" ? o.value = `Please select no more than ${r12.selectionMax} option${r12.selectionMax > 1 ? "s" : ""}` : o.value = "", n12("validated", { ...b, message: o.value });
    }, f = /* @__PURE__ */ ref(0), p = (b) => (f.value = b) && n12("select:count", b), d = (b) => n12("clear", b);
    return (b, z) => {
      const _ = bc;
      return openBlock(), createBlock(_, mergeProps(b.$props, {
        message: unref(s12),
        "message-right": unref(c),
        valid: unref(u)
      }), {
        default: withCtx(({ focused: q }) => [
          createVNode(gHe, mergeProps(b.$props, {
            modelValue: unref(i),
            "onUpdate:modelValue": z[0] || (z[0] = (S) => /* @__PURE__ */ isRef(i) ? i.value = S : null),
            focused: q,
            "onClick:clear": d,
            "onSelect:count": p,
            onValidated: l2,
            "onInput:filter": z[1] || (z[1] = (S) => b.$emit("input:filter", S))
          }), {
            placeholder: withCtx(() => [
              renderSlot(b.$slots, "placeholder")
            ]),
            option: withCtx((S) => [
              renderSlot(b.$slots, "option", normalizeProps(guardReactiveProps(S)))
            ]),
            noOptions: withCtx(() => [
              renderSlot(b.$slots, "noOptions")
            ]),
            _: 2
          }, 1040, ["modelValue", "focused"])
        ]),
        labelContent: withCtx(() => [
          renderSlot(b.$slots, "labelContent")
        ]),
        messageContent: withCtx(() => [
          renderSlot(b.$slots, "messageContent")
        ]),
        messageRightContent: withCtx(() => [
          renderSlot(b.$slots, "messageRightContent")
        ]),
        _: 3
      }, 16, ["message", "message-right", "valid"]);
    };
  }
});
var l0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ni(t16) {
  return t16 && t16.__esModule && Object.prototype.hasOwnProperty.call(t16, "default") ? t16.default : t16;
}
function hp(t16) {
  if (t16.__esModule)
    return t16;
  var e = t16.default;
  if (typeof e == "function") {
    var r12 = function n12() {
      return this instanceof n12 ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r12.prototype = e.prototype;
  } else
    r12 = {};
  return Object.defineProperty(r12, "__esModule", { value: true }), Object.keys(t16).forEach(function(n12) {
    var a = Object.getOwnPropertyDescriptor(t16, n12);
    Object.defineProperty(r12, n12, a.get ? a : {
      enumerable: true,
      get: function() {
        return t16[n12];
      }
    });
  }), r12;
}
var fe = {}, aZ = function(t16, e) {
  return aZ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r12, n12) {
    r12.__proto__ = n12;
  } || function(r12, n12) {
    for (var a in n12)
      Object.prototype.hasOwnProperty.call(n12, a) && (r12[a] = n12[a]);
  }, aZ(t16, e);
};
function LHe(t16, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  aZ(t16, e);
  function r12() {
    this.constructor = t16;
  }
  t16.prototype = e === null ? Object.create(e) : (r12.prototype = e.prototype, new r12());
}
var R2 = function() {
  return R2 = Object.assign || function(e) {
    for (var r12, n12 = 1, a = arguments.length; n12 < a; n12++) {
      r12 = arguments[n12];
      for (var o in r12)
        Object.prototype.hasOwnProperty.call(r12, o) && (e[o] = r12[o]);
    }
    return e;
  }, R2.apply(this, arguments);
};
function PHe(t16, e) {
  var r12 = {};
  for (var n12 in t16)
    Object.prototype.hasOwnProperty.call(t16, n12) && e.indexOf(n12) < 0 && (r12[n12] = t16[n12]);
  if (t16 != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n12 = Object.getOwnPropertySymbols(t16); a < n12.length; a++)
      e.indexOf(n12[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t16, n12[a]) && (r12[n12[a]] = t16[n12[a]]);
  return r12;
}
function DHe(t16, e, r12, n12) {
  var a = arguments.length, o = a < 3 ? e : n12 === null ? n12 = Object.getOwnPropertyDescriptor(e, r12) : n12, i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    o = Reflect.decorate(t16, e, r12, n12);
  else
    for (var u = t16.length - 1; u >= 0; u--)
      (i = t16[u]) && (o = (a < 3 ? i(o) : a > 3 ? i(e, r12, o) : i(e, r12)) || o);
  return a > 3 && o && Object.defineProperty(e, r12, o), o;
}
function WHe(t16, e) {
  return function(r12, n12) {
    e(r12, n12, t16);
  };
}
function ii0(t16, e, r12, n12, a, o) {
  function i(q) {
    if (q !== void 0 && typeof q != "function")
      throw new TypeError("Function expected");
    return q;
  }
  for (var u = n12.kind, s12 = u === "getter" ? "get" : u === "setter" ? "set" : "value", c = !e && t16 ? n12.static ? t16 : t16.prototype : null, l2 = e || (c ? Object.getOwnPropertyDescriptor(c, n12.name) : {}), f, p = false, d = r12.length - 1; d >= 0; d--) {
    var b = {};
    for (var z in n12)
      b[z] = z === "access" ? {} : n12[z];
    for (var z in n12.access)
      b.access[z] = n12.access[z];
    b.addInitializer = function(q) {
      if (p)
        throw new TypeError("Cannot add initializers after decoration has completed");
      o.push(i(q || null));
    };
    var _ = (0, r12[d])(u === "accessor" ? { get: l2.get, set: l2.set } : l2[s12], b);
    if (u === "accessor") {
      if (_ === void 0)
        continue;
      if (_ === null || typeof _ != "object")
        throw new TypeError("Object expected");
      (f = i(_.get)) && (l2.get = f), (f = i(_.set)) && (l2.set = f), (f = i(_.init)) && a.unshift(f);
    } else
      (f = i(_)) && (u === "field" ? a.unshift(f) : l2[s12] = f);
  }
  c && Object.defineProperty(c, n12.name, l2), p = true;
}
function ui0(t16, e, r12) {
  for (var n12 = arguments.length > 2, a = 0; a < e.length; a++)
    r12 = n12 ? e[a].call(t16, r12) : e[a].call(t16);
  return n12 ? r12 : void 0;
}
function si0(t16) {
  return typeof t16 == "symbol" ? t16 : "".concat(t16);
}
function ci0(t16, e, r12) {
  return typeof e == "symbol" && (e = e.description ? "[".concat(e.description, "]") : ""), Object.defineProperty(t16, "name", { configurable: true, value: r12 ? "".concat(r12, " ", e) : e });
}
function NHe(t16, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(t16, e);
}
function wHe(t16, e, r12, n12) {
  function a(o) {
    return o instanceof r12 ? o : new r12(function(i) {
      i(o);
    });
  }
  return new (r12 || (r12 = Promise))(function(o, i) {
    function u(l2) {
      try {
        c(n12.next(l2));
      } catch (f) {
        i(f);
      }
    }
    function s12(l2) {
      try {
        c(n12.throw(l2));
      } catch (f) {
        i(f);
      }
    }
    function c(l2) {
      l2.done ? o(l2.value) : a(l2.value).then(u, s12);
    }
    c((n12 = n12.apply(t16, e || [])).next());
  });
}
function BHe(t16, e) {
  var r12 = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n12, a, o, i;
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l2) {
      return s12([c, l2]);
    };
  }
  function s12(c) {
    if (n12)
      throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, c[0] && (r12 = 0)), r12; )
      try {
        if (n12 = 1, a && (o = c[0] & 2 ? a.return : c[0] ? a.throw || ((o = a.return) && o.call(a), 0) : a.next) && !(o = o.call(a, c[1])).done)
          return o;
        switch (a = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
          case 0:
          case 1:
            o = c;
            break;
          case 4:
            return r12.label++, { value: c[1], done: false };
          case 5:
            r12.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r12.ops.pop(), r12.trys.pop();
            continue;
          default:
            if (o = r12.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r12 = 0;
              continue;
            }
            if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
              r12.label = c[1];
              break;
            }
            if (c[0] === 6 && r12.label < o[1]) {
              r12.label = o[1], o = c;
              break;
            }
            if (o && r12.label < o[2]) {
              r12.label = o[2], r12.ops.push(c);
              break;
            }
            o[2] && r12.ops.pop(), r12.trys.pop();
            continue;
        }
        c = e.call(t16, r12);
      } catch (l2) {
        c = [6, l2], a = 0;
      } finally {
        n12 = o = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: true };
  }
}
var vp = Object.create ? function(t16, e, r12, n12) {
  n12 === void 0 && (n12 = r12);
  var a = Object.getOwnPropertyDescriptor(e, r12);
  (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = { enumerable: true, get: function() {
    return e[r12];
  } }), Object.defineProperty(t16, n12, a);
} : function(t16, e, r12, n12) {
  n12 === void 0 && (n12 = r12), t16[n12] = e[r12];
};
function xHe(t16, e) {
  for (var r12 in t16)
    r12 !== "default" && !Object.prototype.hasOwnProperty.call(e, r12) && vp(e, t16, r12);
}
function q2(t16) {
  var e = typeof Symbol == "function" && Symbol.iterator, r12 = e && t16[e], n12 = 0;
  if (r12)
    return r12.call(t16);
  if (t16 && typeof t16.length == "number")
    return {
      next: function() {
        return t16 && n12 >= t16.length && (t16 = void 0), { value: t16 && t16[n12++], done: !t16 };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Kee(t16, e) {
  var r12 = typeof Symbol == "function" && t16[Symbol.iterator];
  if (!r12)
    return t16;
  var n12 = r12.call(t16), a, o = [], i;
  try {
    for (; (e === void 0 || e-- > 0) && !(a = n12.next()).done; )
      o.push(a.value);
  } catch (u) {
    i = { error: u };
  } finally {
    try {
      a && !a.done && (r12 = n12.return) && r12.call(n12);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return o;
}
function UHe() {
  for (var t16 = [], e = 0; e < arguments.length; e++)
    t16 = t16.concat(Kee(arguments[e]));
  return t16;
}
function kHe() {
  for (var t16 = 0, e = 0, r12 = arguments.length; e < r12; e++)
    t16 += arguments[e].length;
  for (var n12 = Array(t16), a = 0, e = 0; e < r12; e++)
    for (var o = arguments[e], i = 0, u = o.length; i < u; i++, a++)
      n12[a] = o[i];
  return n12;
}
function jHe(t16, e, r12) {
  if (r12 || arguments.length === 2)
    for (var n12 = 0, a = e.length, o; n12 < a; n12++)
      (o || !(n12 in e)) && (o || (o = Array.prototype.slice.call(e, 0, n12)), o[n12] = e[n12]);
  return t16.concat(o || Array.prototype.slice.call(e));
}
function _i(t16) {
  return this instanceof _i ? (this.v = t16, this) : new _i(t16);
}
function FHe(t16, e, r12) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var n12 = r12.apply(t16, e || []), a, o = [];
  return a = {}, i("next"), i("throw"), i("return"), a[Symbol.asyncIterator] = function() {
    return this;
  }, a;
  function i(p) {
    n12[p] && (a[p] = function(d) {
      return new Promise(function(b, z) {
        o.push([p, d, b, z]) > 1 || u(p, d);
      });
    });
  }
  function u(p, d) {
    try {
      s12(n12[p](d));
    } catch (b) {
      f(o[0][3], b);
    }
  }
  function s12(p) {
    p.value instanceof _i ? Promise.resolve(p.value.v).then(c, l2) : f(o[0][2], p);
  }
  function c(p) {
    u("next", p);
  }
  function l2(p) {
    u("throw", p);
  }
  function f(p, d) {
    p(d), o.shift(), o.length && u(o[0][0], o[0][1]);
  }
}
function VHe(t16) {
  var e, r12;
  return e = {}, n12("next"), n12("throw", function(a) {
    throw a;
  }), n12("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function n12(a, o) {
    e[a] = t16[a] ? function(i) {
      return (r12 = !r12) ? { value: _i(t16[a](i)), done: false } : o ? o(i) : i;
    } : o;
  }
}
function HHe(t16) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t16[Symbol.asyncIterator], r12;
  return e ? e.call(t16) : (t16 = typeof q2 == "function" ? q2(t16) : t16[Symbol.iterator](), r12 = {}, n12("next"), n12("throw"), n12("return"), r12[Symbol.asyncIterator] = function() {
    return this;
  }, r12);
  function n12(o) {
    r12[o] = t16[o] && function(i) {
      return new Promise(function(u, s12) {
        i = t16[o](i), a(u, s12, i.done, i.value);
      });
    };
  }
  function a(o, i, u, s12) {
    Promise.resolve(s12).then(function(c) {
      o({ value: c, done: u });
    }, i);
  }
}
function XHe(t16, e) {
  return Object.defineProperty ? Object.defineProperty(t16, "raw", { value: e }) : t16.raw = e, t16;
}
var li0 = Object.create ? function(t16, e) {
  Object.defineProperty(t16, "default", { enumerable: true, value: e });
} : function(t16, e) {
  t16.default = e;
};
function $He(t16) {
  if (t16 && t16.__esModule)
    return t16;
  var e = {};
  if (t16 != null)
    for (var r12 in t16)
      r12 !== "default" && Object.prototype.hasOwnProperty.call(t16, r12) && vp(e, t16, r12);
  return li0(e, t16), e;
}
function GHe(t16) {
  return t16 && t16.__esModule ? t16 : { default: t16 };
}
function YHe(t16, e, r12, n12) {
  if (r12 === "a" && !n12)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t16 !== e || !n12 : !e.has(t16))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r12 === "m" ? n12 : r12 === "a" ? n12.call(t16) : n12 ? n12.value : e.get(t16);
}
function JHe(t16, e, r12, n12, a) {
  if (n12 === "m")
    throw new TypeError("Private method is not writable");
  if (n12 === "a" && !a)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t16 !== e || !a : !e.has(t16))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n12 === "a" ? a.call(t16, r12) : a ? a.value = r12 : e.set(t16, r12), r12;
}
function KHe(t16, e) {
  if (e === null || typeof e != "object" && typeof e != "function")
    throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof t16 == "function" ? e === t16 : t16.has(e);
}
function QHe(t16, e, r12) {
  if (e != null) {
    if (typeof e != "object" && typeof e != "function")
      throw new TypeError("Object expected.");
    var n12;
    if (r12) {
      if (!Symbol.asyncDispose)
        throw new TypeError("Symbol.asyncDispose is not defined.");
      n12 = e[Symbol.asyncDispose];
    }
    if (n12 === void 0) {
      if (!Symbol.dispose)
        throw new TypeError("Symbol.dispose is not defined.");
      n12 = e[Symbol.dispose];
    }
    if (typeof n12 != "function")
      throw new TypeError("Object not disposable.");
    t16.stack.push({ value: e, dispose: n12, async: r12 });
  } else
    r12 && t16.stack.push({ async: true });
  return e;
}
var pi0 = typeof SuppressedError == "function" ? SuppressedError : function(t16, e, r12) {
  var n12 = new Error(r12);
  return n12.name = "SuppressedError", n12.error = t16, n12.suppressed = e, n12;
};
function ZHe(t16) {
  function e(n12) {
    t16.error = t16.hasError ? new pi0(n12, t16.error, "An error was suppressed during disposal.") : n12, t16.hasError = true;
  }
  function r12() {
    for (; t16.stack.length; ) {
      var n12 = t16.stack.pop();
      try {
        var a = n12.dispose && n12.dispose.call(n12.value);
        if (n12.async)
          return Promise.resolve(a).then(r12, function(o) {
            return e(o), r12();
          });
      } catch (o) {
        e(o);
      }
    }
    if (t16.hasError)
      throw t16.error;
  }
  return r12();
}
const di0 = {
  __extends: LHe,
  __assign: R2,
  __rest: PHe,
  __decorate: DHe,
  __param: WHe,
  __metadata: NHe,
  __awaiter: wHe,
  __generator: BHe,
  __createBinding: vp,
  __exportStar: xHe,
  __values: q2,
  __read: Kee,
  __spread: UHe,
  __spreadArrays: kHe,
  __spreadArray: jHe,
  __await: _i,
  __asyncGenerator: FHe,
  __asyncDelegator: VHe,
  __asyncValues: HHe,
  __makeTemplateObject: XHe,
  __importStar: $He,
  __importDefault: GHe,
  __classPrivateFieldGet: YHe,
  __classPrivateFieldSet: JHe,
  __classPrivateFieldIn: KHe,
  __addDisposableResource: QHe,
  __disposeResources: ZHe
}, fi0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource: QHe,
  get __assign() {
    return R2;
  },
  __asyncDelegator: VHe,
  __asyncGenerator: FHe,
  __asyncValues: HHe,
  __await: _i,
  __awaiter: wHe,
  __classPrivateFieldGet: YHe,
  __classPrivateFieldIn: KHe,
  __classPrivateFieldSet: JHe,
  __createBinding: vp,
  __decorate: DHe,
  __disposeResources: ZHe,
  __esDecorate: ii0,
  __exportStar: xHe,
  __extends: LHe,
  __generator: BHe,
  __importDefault: GHe,
  __importStar: $He,
  __makeTemplateObject: XHe,
  __metadata: NHe,
  __param: WHe,
  __propKey: si0,
  __read: Kee,
  __rest: PHe,
  __runInitializers: ui0,
  __setFunctionName: ci0,
  __spread: UHe,
  __spreadArray: jHe,
  __spreadArrays: kHe,
  __values: q2,
  default: di0
}, Symbol.toStringTag, { value: "Module" })), Z0 = /* @__PURE__ */ hp(fi0);
var Ud = {}, kd = {}, su = {}, zre;
function wi() {
  return zre || (zre = 1, Object.defineProperty(su, "__esModule", { value: true }), su.ERRORS = void 0, su.ERRORS = {
    /**
     * An error occurred because a value was null.
     */
    NULL: new Error("#NULL!"),
    /**
     * A number is divided either by zero (0)
     */
    DIV0: new Error("#DIV/0!"),
    /**
     * Incompatible data types.
     */
    VALUE: new Error("#VALUE!"),
    /**
     * A variable is not valid.
     */
    REF: new Error("#REF!"),
    /**
     * A function used does not exist.
     */
    NAME: new Error("#NAME?"),
    /**
     * The formula or function contains invalid numeric values.
     */
    NUM: new Error("#NUM!"),
    /**
     * Some unknown problem.
     */
    NA: new Error("#N/A"),
    /**
     * An error occurred.
     */
    ERROR: new Error("#ERROR!"),
    /**
     * An error occurred getting data.
     */
    DATA: new Error("#GETTING_DATA")
  }), su;
}
var K0 = {}, Are;
function Va() {
  if (Are)
    return K0;
  Are = 1, Object.defineProperty(K0, "__esModule", { value: true }), K0.isNotEmpty = K0.isEmpty = K0.isPlainObject = K0.isObject = K0.isArray = K0.isDate = K0.isDefined = K0.isWholeNumber = K0.isFiniteNumber = K0.isNumber = K0.isBoolean = K0.isString = K0.isEntryResultObject = K0.isFunction = void 0;
  function t16(b) {
    return typeof b == "function";
  }
  K0.isFunction = t16;
  function e(b) {
    return typeof b == "object" && typeof b.key == "string";
  }
  K0.isEntryResultObject = e;
  function r12(b) {
    return typeof b == "string";
  }
  K0.isString = r12;
  function n12(b) {
    return typeof b == "boolean";
  }
  K0.isBoolean = n12;
  function a(b) {
    return typeof b == "number";
  }
  K0.isNumber = a;
  function o(b) {
    return typeof b == "number" && isFinite(b);
  }
  K0.isFiniteNumber = o;
  function i(b) {
    return o(b) && (b < 0 ? Math.ceil(b) : Math.floor(b)) === b;
  }
  K0.isWholeNumber = i;
  function u(b) {
    return b != null;
  }
  K0.isDefined = u;
  function s12(b) {
    return b instanceof Date;
  }
  K0.isDate = s12;
  function c(b) {
    return Array.isArray(b);
  }
  K0.isArray = c;
  function l2(b) {
    return typeof b == "object" && b !== null && !Array.isArray(b);
  }
  K0.isObject = l2;
  function f(b) {
    return l2(b) && (!b.constructor || b.constructor === Object);
  }
  K0.isPlainObject = f;
  function p(b) {
    if (b == null || b === "")
      return true;
    if (c(b))
      return b.length === 0 ? true : b.every(p);
    if (f(b)) {
      for (var z in b)
        if (!p(b[z]))
          return false;
      return true;
    }
    return false;
  }
  K0.isEmpty = p;
  function d(b) {
    return !p(b);
  }
  return K0.isNotEmpty = d, K0;
}
var Wn = {}, _re;
function bi0() {
  if (_re)
    return Wn;
  _re = 1, Object.defineProperty(Wn, "__esModule", { value: true }), Wn.setProperty = Wn.getProperty = Wn.correctPropertyName = void 0;
  var t16 = Z0, e = Va();
  function r12(o, i) {
    if (typeof o != "object" || i in o)
      return i;
    var u = i.toLowerCase().trim();
    for (var s12 in o)
      if (String(s12).toLowerCase().trim() === u)
        return s12;
    return i;
  }
  Wn.correctPropertyName = r12;
  function n12(o, i, u) {
    var s12, c;
    if (u === void 0 && (u = true), e.isString(i))
      return o[u ? r12(o, i) : i];
    if (e.isArray(i)) {
      try {
        for (var l2 = t16.__values(i), f = l2.next(); !f.done; f = l2.next()) {
          var p = f.value;
          if (o = o[u ? r12(o, p) : p], !o)
            break;
        }
      } catch (d) {
        s12 = { error: d };
      } finally {
        try {
          f && !f.done && (c = l2.return) && c.call(l2);
        } finally {
          if (s12)
            throw s12.error;
        }
      }
      return o;
    }
  }
  Wn.getProperty = n12;
  function a(o, i, u, s12) {
    if (s12 === void 0 && (s12 = true), e.isString(i))
      o[s12 ? r12(o, i) : i] = u;
    else if (e.isArray(i)) {
      for (var c = i.length - 1, l2 = i[c], f = 0; f < c; f++) {
        var p = s12 ? r12(o, i[f]) : i[f];
        o[p] || (o[p] = {}), o = o[p];
      }
      o[s12 ? r12(o, l2) : l2] = u;
    } else
      return false;
    return true;
  }
  return Wn.setProperty = a, Wn;
}
var Wr = {}, hre;
function Mi0() {
  if (hre)
    return Wr;
  hre = 1, Object.defineProperty(Wr, "__esModule", { value: true }), Wr.booleansCompare = Wr.booleansStats = Wr.booleansMatch = Wr.booleansParse = void 0;
  var t16 = Z0, e = A1(), r12 = Va();
  function n12(u) {
    return !!/^(true|1|y|yes|x)$/i.exec(u);
  }
  Wr.booleansParse = n12;
  function a(u, s12) {
    var c = n12(u);
    return r12.isBoolean(s12.min) && c < s12.min || r12.isBoolean(s12.max) && c > s12.max ? false : r12.isBoolean(s12.value) ? s12.value === c : e.isArray(s12.values) && s12.values.length > 0 ? s12.values.some(function(l2) {
      return n12(l2) === c;
    }) : true;
  }
  Wr.booleansMatch = a;
  function o(u) {
    var s12, c;
    if (u.length === 0)
      return {};
    var l2 = 0, f = 0, p = 0;
    try {
      for (var d = t16.__values(u), b = d.next(); !b.done; b = d.next()) {
        var z = b.value;
        r12.isDefined(z) ? n12(z) ? f++ : p++ : l2++;
      }
    } catch (q) {
      s12 = { error: q };
    } finally {
      try {
        b && !b.done && (c = d.return) && c.call(d);
      } finally {
        if (s12)
          throw s12.error;
      }
    }
    var _ = { nulls: l2, values: [] };
    return f > 0 && _.values.push({
      count: f,
      value: true
    }), p > 0 && _.values.push({
      count: p,
      value: false
    }), l2 > 0 && _.values.push({
      count: l2
    }), _;
  }
  Wr.booleansStats = o;
  function i(u, s12) {
    return (u ? 1 : 0) - (s12 ? 1 : 0);
  }
  return Wr.booleansCompare = i, Wr;
}
var st = {}, vre;
function eXe() {
  if (vre)
    return st;
  vre = 1, Object.defineProperty(st, "__esModule", { value: true }), st.textPad = st.textParse = st.textCompare = st.textStats = st.textMatch = st.textNormalize = st.textTo = void 0;
  var t16 = Z0, e = Va(), r12 = wi();
  function n12(l2) {
    return e.isDefined(l2) ? String(l2) : "";
  }
  st.textTo = n12;
  function a(l2) {
    return n12(l2).trim().toLowerCase();
  }
  st.textNormalize = a;
  function o(l2, f) {
    var p = a(l2);
    return e.isString(f.min) && p.localeCompare(a(f.min)) < 0 || e.isString(f.max) && p.localeCompare(a(f.max)) > 0 ? false : e.isString(f.value) ? a(f.value) === p : e.isString(f.like) ? !!new RegExp("^" + f.like.replace(/%/g, ".*") + "$", "i").exec(p) : e.isArray(f.values) && f.values.length > 0 ? f.values.some(function(d) {
      return a(d) === p;
    }) : true;
  }
  st.textMatch = o;
  function i(l2) {
    var f, p;
    if (l2.length === 0)
      return {};
    var d = [], b = {}, z, _, q = 0;
    try {
      for (var S = t16.__values(l2), N = S.next(); !N.done; N = S.next()) {
        var v = N.value, C = n12(v).trim();
        if (!C)
          q++;
        else {
          var L = C.toLowerCase(), B = b[L];
          B || (B = b[L] = { value: C, count: 0 }), B.count++, z = z === void 0 || C.localeCompare(z) < 0 ? C : z, _ = _ === void 0 || C.localeCompare(_) > 0 ? C : _;
        }
      }
    } catch (W) {
      f = { error: W };
    } finally {
      try {
        N && !N.done && (p = S.return) && p.call(S);
      } finally {
        if (f)
          throw f.error;
      }
    }
    for (var L in b) {
      var P12 = b[L], v = P12.value, j = P12.count;
      d.push({ value: v, count: j });
    }
    d.sort(function(W, x) {
      return W.value.localeCompare(x.value);
    }), q > 0 && d.unshift({
      count: q
    });
    var $ = { nulls: q, values: d };
    return z !== void 0 && ($.min = z), _ !== void 0 && ($.max = _), $;
  }
  st.textStats = i;
  function u(l2, f) {
    return l2.localeCompare(f);
  }
  st.textCompare = u;
  function s12(l2, f, p) {
    if (f === void 0 && (f = true), p === void 0 && (p = ""), e.isNumber(l2) || e.isString(l2) || e.isBoolean(l2))
      return String(l2);
    if (f)
      throw r12.ERRORS.VALUE;
    return p;
  }
  st.textParse = s12;
  function c(l2, f, p, d, b) {
    if (d === void 0 && (d = true), b === void 0 && (b = false), l2.length >= p)
      return b ? d ? l2.substring(p - l2.length) : l2.substring(0, p) : l2;
    for (; l2.length <= p; )
      d ? l2 = f + l2 : l2 = l2 + f;
    return l2.substring(0, p);
  }
  return st.textPad = c, st;
}
var jd = {}, Bt = {}, mre;
function zc() {
  if (mre)
    return Bt;
  mre = 1, Object.defineProperty(Bt, "__esModule", { value: true });
  function t16(O, m) {
    for (var A = 0; A < m.length; A++) {
      var M = m[A];
      M.enumerable = M.enumerable || false, M.configurable = true, "value" in M && (M.writable = true), Object.defineProperty(O, M.key, M);
    }
  }
  function e(O, m, A) {
    return m && t16(O.prototype, m), A && t16(O, A), O;
  }
  function r12() {
    return r12 = Object.assign || function(O) {
      for (var m = 1; m < arguments.length; m++) {
        var A = arguments[m];
        for (var M in A)
          Object.prototype.hasOwnProperty.call(A, M) && (O[M] = A[M]);
      }
      return O;
    }, r12.apply(this, arguments);
  }
  function n12(O, m) {
    O.prototype = Object.create(m.prototype), O.prototype.constructor = O, o(O, m);
  }
  function a(O) {
    return a = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
      return A.__proto__ || Object.getPrototypeOf(A);
    }, a(O);
  }
  function o(O, m) {
    return o = Object.setPrototypeOf || function(M, h12) {
      return M.__proto__ = h12, M;
    }, o(O, m);
  }
  function i() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return false;
    if (typeof Proxy == "function")
      return true;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), true;
    } catch {
      return false;
    }
  }
  function u(O, m, A) {
    return i() ? u = Reflect.construct : u = function(h12, y, U) {
      var V = [null];
      V.push.apply(V, y);
      var J = Function.bind.apply(h12, V), pe = new J();
      return U && o(pe, U.prototype), pe;
    }, u.apply(null, arguments);
  }
  function s12(O) {
    return Function.toString.call(O).indexOf("[native code]") !== -1;
  }
  function c(O) {
    var m = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return c = function(M) {
      if (M === null || !s12(M))
        return M;
      if (typeof M != "function")
        throw new TypeError("Super expression must either be null or a function");
      if (typeof m < "u") {
        if (m.has(M))
          return m.get(M);
        m.set(M, h12);
      }
      function h12() {
        return u(M, arguments, a(this).constructor);
      }
      return h12.prototype = Object.create(M.prototype, {
        constructor: {
          value: h12,
          enumerable: false,
          writable: true,
          configurable: true
        }
      }), o(h12, M);
    }, c(O);
  }
  function l2(O, m) {
    if (O == null)
      return {};
    var A = {}, M = Object.keys(O), h12, y;
    for (y = 0; y < M.length; y++)
      h12 = M[y], !(m.indexOf(h12) >= 0) && (A[h12] = O[h12]);
    return A;
  }
  function f(O, m) {
    if (O) {
      if (typeof O == "string")
        return p(O, m);
      var A = Object.prototype.toString.call(O).slice(8, -1);
      if (A === "Object" && O.constructor && (A = O.constructor.name), A === "Map" || A === "Set")
        return Array.from(O);
      if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A))
        return p(O, m);
    }
  }
  function p(O, m) {
    (m == null || m > O.length) && (m = O.length);
    for (var A = 0, M = new Array(m); A < m; A++)
      M[A] = O[A];
    return M;
  }
  function d(O, m) {
    var A = typeof Symbol < "u" && O[Symbol.iterator] || O["@@iterator"];
    if (A)
      return (A = A.call(O)).next.bind(A);
    if (Array.isArray(O) || (A = f(O)) || m) {
      A && (O = A);
      var M = 0;
      return function() {
        return M >= O.length ? {
          done: true
        } : {
          done: false,
          value: O[M++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var b = /* @__PURE__ */ (function(O) {
    n12(m, O);
    function m() {
      return O.apply(this, arguments) || this;
    }
    return m;
  })(/* @__PURE__ */ c(Error)), z = /* @__PURE__ */ (function(O) {
    n12(m, O);
    function m(A) {
      return O.call(this, "Invalid DateTime: " + A.toMessage()) || this;
    }
    return m;
  })(b), _ = /* @__PURE__ */ (function(O) {
    n12(m, O);
    function m(A) {
      return O.call(this, "Invalid Interval: " + A.toMessage()) || this;
    }
    return m;
  })(b), q = /* @__PURE__ */ (function(O) {
    n12(m, O);
    function m(A) {
      return O.call(this, "Invalid Duration: " + A.toMessage()) || this;
    }
    return m;
  })(b), S = /* @__PURE__ */ (function(O) {
    n12(m, O);
    function m() {
      return O.apply(this, arguments) || this;
    }
    return m;
  })(b), N = /* @__PURE__ */ (function(O) {
    n12(m, O);
    function m(A) {
      return O.call(this, "Invalid unit " + A) || this;
    }
    return m;
  })(b), v = /* @__PURE__ */ (function(O) {
    n12(m, O);
    function m() {
      return O.apply(this, arguments) || this;
    }
    return m;
  })(b), C = /* @__PURE__ */ (function(O) {
    n12(m, O);
    function m() {
      return O.call(this, "Zone is an abstract class") || this;
    }
    return m;
  })(b), L = "numeric", B = "short", P12 = "long", j = {
    year: L,
    month: L,
    day: L
  }, $ = {
    year: L,
    month: B,
    day: L
  }, W = {
    year: L,
    month: B,
    day: L,
    weekday: B
  }, x = {
    year: L,
    month: P12,
    day: L
  }, D = {
    year: L,
    month: P12,
    day: L,
    weekday: P12
  }, w = {
    hour: L,
    minute: L
  }, I = {
    hour: L,
    minute: L,
    second: L
  }, Y = {
    hour: L,
    minute: L,
    second: L,
    timeZoneName: B
  }, oe = {
    hour: L,
    minute: L,
    second: L,
    timeZoneName: P12
  }, Z = {
    hour: L,
    minute: L,
    hourCycle: "h23"
  }, se = {
    hour: L,
    minute: L,
    second: L,
    hourCycle: "h23"
  }, Ie = {
    hour: L,
    minute: L,
    second: L,
    hourCycle: "h23",
    timeZoneName: B
  }, ie = {
    hour: L,
    minute: L,
    second: L,
    hourCycle: "h23",
    timeZoneName: P12
  }, ye = {
    year: L,
    month: L,
    day: L,
    hour: L,
    minute: L
  }, ne = {
    year: L,
    month: L,
    day: L,
    hour: L,
    minute: L,
    second: L
  }, k = {
    year: L,
    month: B,
    day: L,
    hour: L,
    minute: L
  }, K = {
    year: L,
    month: B,
    day: L,
    hour: L,
    minute: L,
    second: L
  }, G = {
    year: L,
    month: B,
    day: L,
    weekday: B,
    hour: L,
    minute: L
  }, Q = {
    year: L,
    month: P12,
    day: L,
    hour: L,
    minute: L,
    timeZoneName: B
  }, ce = {
    year: L,
    month: P12,
    day: L,
    hour: L,
    minute: L,
    second: L,
    timeZoneName: B
  }, ve = {
    year: L,
    month: P12,
    day: L,
    weekday: P12,
    hour: L,
    minute: L,
    timeZoneName: P12
  }, Re = {
    year: L,
    month: P12,
    day: L,
    weekday: P12,
    hour: L,
    minute: L,
    second: L,
    timeZoneName: P12
  };
  function le(O) {
    return typeof O > "u";
  }
  function Ae(O) {
    return typeof O == "number";
  }
  function H(O) {
    return typeof O == "number" && O % 1 === 0;
  }
  function re(O) {
    return typeof O == "string";
  }
  function ue(O) {
    return Object.prototype.toString.call(O) === "[object Date]";
  }
  function Me() {
    try {
      return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
    } catch {
      return false;
    }
  }
  function Se(O) {
    return Array.isArray(O) ? O : [O];
  }
  function $e(O, m, A) {
    if (O.length !== 0)
      return O.reduce(function(M, h12) {
        var y = [m(h12), h12];
        return M && A(M[0], y[0]) === M[0] ? M : y;
      }, null)[1];
  }
  function a0(O, m) {
    return m.reduce(function(A, M) {
      return A[M] = O[M], A;
    }, {});
  }
  function Ne(O, m) {
    return Object.prototype.hasOwnProperty.call(O, m);
  }
  function Ye(O, m, A) {
    return H(O) && O >= m && O <= A;
  }
  function $0(O, m) {
    return O - m * Math.floor(O / m);
  }
  function Be(O, m) {
    m === void 0 && (m = 2);
    var A = O < 0, M;
    return A ? M = "-" + ("" + -O).padStart(m, "0") : M = ("" + O).padStart(m, "0"), M;
  }
  function o0(O) {
    if (!(le(O) || O === null || O === ""))
      return parseInt(O, 10);
  }
  function Ke(O) {
    if (!(le(O) || O === null || O === ""))
      return parseFloat(O);
  }
  function I0(O) {
    if (!(le(O) || O === null || O === "")) {
      var m = parseFloat("0." + O) * 1e3;
      return Math.floor(m);
    }
  }
  function b0(O, m, A) {
    A === void 0 && (A = false);
    var M = Math.pow(10, m), h12 = A ? Math.trunc : Math.round;
    return h12(O * M) / M;
  }
  function P1(O) {
    return O % 4 === 0 && (O % 100 !== 0 || O % 400 === 0);
  }
  function x0(O) {
    return P1(O) ? 366 : 365;
  }
  function Mt(O, m) {
    var A = $0(m - 1, 12) + 1, M = O + (m - A) / 12;
    return A === 2 ? P1(M) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][A - 1];
  }
  function H1(O) {
    var m = Date.UTC(O.year, O.month - 1, O.day, O.hour, O.minute, O.second, O.millisecond);
    return O.year < 100 && O.year >= 0 && (m = new Date(m), m.setUTCFullYear(m.getUTCFullYear() - 1900)), +m;
  }
  function Wt(O) {
    var m = (O + Math.floor(O / 4) - Math.floor(O / 100) + Math.floor(O / 400)) % 7, A = O - 1, M = (A + Math.floor(A / 4) - Math.floor(A / 100) + Math.floor(A / 400)) % 7;
    return m === 4 || M === 3 ? 53 : 52;
  }
  function Zt(O) {
    return O > 99 ? O : O > 60 ? 1900 + O : 2e3 + O;
  }
  function be(O, m, A, M) {
    M === void 0 && (M = null);
    var h12 = new Date(O), y = {
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    };
    M && (y.timeZone = M);
    var U = r12({
      timeZoneName: m
    }, y), V = new Intl.DateTimeFormat(A, U).formatToParts(h12).find(function(J) {
      return J.type.toLowerCase() === "timezonename";
    });
    return V ? V.value : null;
  }
  function Ue(O, m) {
    var A = parseInt(O, 10);
    Number.isNaN(A) && (A = 0);
    var M = parseInt(m, 10) || 0, h12 = A < 0 || Object.is(A, -0) ? -M : M;
    return A * 60 + h12;
  }
  function d0(O) {
    var m = Number(O);
    if (typeof O == "boolean" || O === "" || Number.isNaN(m))
      throw new v("Invalid unit value " + O);
    return m;
  }
  function W0(O, m) {
    var A = {};
    for (var M in O)
      if (Ne(O, M)) {
        var h12 = O[M];
        if (h12 == null)
          continue;
        A[m(M)] = d0(h12);
      }
    return A;
  }
  function E0(O, m) {
    var A = Math.trunc(Math.abs(O / 60)), M = Math.trunc(Math.abs(O % 60)), h12 = O >= 0 ? "+" : "-";
    switch (m) {
      case "short":
        return "" + h12 + Be(A, 2) + ":" + Be(M, 2);
      case "narrow":
        return "" + h12 + A + (M > 0 ? ":" + M : "");
      case "techie":
        return "" + h12 + Be(A, 2) + Be(M, 2);
      default:
        throw new RangeError("Value format " + m + " is out of range for property format");
    }
  }
  function s1(O) {
    return a0(O, ["hour", "minute", "second", "millisecond"]);
  }
  var Ot = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z0-9_+-]{1,256}(\/[A-Za-z0-9_+-]{1,256})?)?/, sn = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], h1 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], zt = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
  function za(O) {
    switch (O) {
      case "narrow":
        return [].concat(zt);
      case "short":
        return [].concat(h1);
      case "long":
        return [].concat(sn);
      case "numeric":
        return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
      case "2-digit":
        return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
      default:
        return null;
    }
  }
  var cn = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"], er = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], No = ["M", "T", "W", "T", "F", "S", "S"];
  function En(O) {
    switch (O) {
      case "narrow":
        return [].concat(No);
      case "short":
        return [].concat(er);
      case "long":
        return [].concat(cn);
      case "numeric":
        return ["1", "2", "3", "4", "5", "6", "7"];
      default:
        return null;
    }
  }
  var Ln = ["AM", "PM"], Fc = ["Before Christ", "Anno Domini"], Vc = ["BC", "AD"], pd = ["B", "A"];
  function tr(O) {
    switch (O) {
      case "narrow":
        return [].concat(pd);
      case "short":
        return [].concat(Vc);
      case "long":
        return [].concat(Fc);
      default:
        return null;
    }
  }
  function wo(O) {
    return Ln[O.hour < 12 ? 0 : 1];
  }
  function Hc(O, m) {
    return En(m)[O.weekday - 1];
  }
  function Xc(O, m) {
    return za(m)[O.month - 1];
  }
  function $c(O, m) {
    return tr(m)[O.year < 0 ? 0 : 1];
  }
  function Gc(O, m, A, M) {
    A === void 0 && (A = "always"), M === void 0 && (M = false);
    var h12 = {
      years: ["year", "yr."],
      quarters: ["quarter", "qtr."],
      months: ["month", "mo."],
      weeks: ["week", "wk."],
      days: ["day", "day", "days"],
      hours: ["hour", "hr."],
      minutes: ["minute", "min."],
      seconds: ["second", "sec."]
    }, y = ["hours", "minutes", "seconds"].indexOf(O) === -1;
    if (A === "auto" && y) {
      var U = O === "days";
      switch (m) {
        case 1:
          return U ? "tomorrow" : "next " + h12[O][0];
        case -1:
          return U ? "yesterday" : "last " + h12[O][0];
        case 0:
          return U ? "today" : "this " + h12[O][0];
      }
    }
    var V = Object.is(m, -0) || m < 0, J = Math.abs(m), pe = J === 1, ge = h12[O], qe = M ? pe ? ge[1] : ge[2] || ge[1] : pe ? h12[O][0] : O;
    return V ? J + " " + qe + " ago" : "in " + J + " " + qe;
  }
  function lr(O, m) {
    for (var A = "", M = d(O), h12; !(h12 = M()).done; ) {
      var y = h12.value;
      y.literal ? A += y.val : A += m(y.val);
    }
    return A;
  }
  var Yc = {
    D: j,
    DD: $,
    DDD: x,
    DDDD: D,
    t: w,
    tt: I,
    ttt: Y,
    tttt: oe,
    T: Z,
    TT: se,
    TTT: Ie,
    TTTT: ie,
    f: ye,
    ff: k,
    fff: Q,
    ffff: ve,
    F: ne,
    FF: K,
    FFF: ce,
    FFFF: Re
  }, pr = /* @__PURE__ */ (function() {
    O.create = function(M, h12) {
      return h12 === void 0 && (h12 = {}), new O(M, h12);
    }, O.parseFormat = function(M) {
      for (var h12 = null, y = "", U = false, V = [], J = 0; J < M.length; J++) {
        var pe = M.charAt(J);
        pe === "'" ? (y.length > 0 && V.push({
          literal: U,
          val: y
        }), h12 = null, y = "", U = !U) : U || pe === h12 ? y += pe : (y.length > 0 && V.push({
          literal: false,
          val: y
        }), y = pe, h12 = pe);
      }
      return y.length > 0 && V.push({
        literal: U,
        val: y
      }), V;
    }, O.macroTokenToFormatOpts = function(M) {
      return Yc[M];
    };
    function O(A, M) {
      this.opts = M, this.loc = A, this.systemLoc = null;
    }
    var m = O.prototype;
    return m.formatWithSystemDefault = function(M, h12) {
      this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem());
      var y = this.systemLoc.dtFormatter(M, r12({}, this.opts, h12));
      return y.format();
    }, m.formatDateTime = function(M, h12) {
      h12 === void 0 && (h12 = {});
      var y = this.loc.dtFormatter(M, r12({}, this.opts, h12));
      return y.format();
    }, m.formatDateTimeParts = function(M, h12) {
      h12 === void 0 && (h12 = {});
      var y = this.loc.dtFormatter(M, r12({}, this.opts, h12));
      return y.formatToParts();
    }, m.resolvedOptions = function(M, h12) {
      h12 === void 0 && (h12 = {});
      var y = this.loc.dtFormatter(M, r12({}, this.opts, h12));
      return y.resolvedOptions();
    }, m.num = function(M, h12) {
      if (h12 === void 0 && (h12 = 0), this.opts.forceSimple)
        return Be(M, h12);
      var y = r12({}, this.opts);
      return h12 > 0 && (y.padTo = h12), this.loc.numberFormatter(y).format(M);
    }, m.formatDateTimeFromString = function(M, h12) {
      var y = this, U = this.loc.listingMode() === "en", V = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", J = function(M0, D1) {
        return y.loc.extract(M, M0, D1);
      }, pe = function(M0) {
        return M.isOffsetFixed && M.offset === 0 && M0.allowZ ? "Z" : M.isValid ? M.zone.formatOffset(M.ts, M0.format) : "";
      }, ge = function() {
        return U ? wo(M) : J({
          hour: "numeric",
          hourCycle: "h12"
        }, "dayperiod");
      }, qe = function(M0, D1) {
        return U ? Xc(M, M0) : J(D1 ? {
          month: M0
        } : {
          month: M0,
          day: "numeric"
        }, "month");
      }, Ce = function(M0, D1) {
        return U ? Hc(M, M0) : J(D1 ? {
          weekday: M0
        } : {
          weekday: M0,
          month: "long",
          day: "numeric"
        }, "weekday");
      }, Ze = function(M0) {
        var D1 = O.macroTokenToFormatOpts(M0);
        return D1 ? y.formatWithSystemDefault(M, D1) : M0;
      }, O0 = function(M0) {
        return U ? $c(M, M0) : J({
          era: M0
        }, "era");
      }, F0 = function(M0) {
        switch (M0) {
          case "S":
            return y.num(M.millisecond);
          case "u":
          case "SSS":
            return y.num(M.millisecond, 3);
          case "s":
            return y.num(M.second);
          case "ss":
            return y.num(M.second, 2);
          case "uu":
            return y.num(Math.floor(M.millisecond / 10), 2);
          case "uuu":
            return y.num(Math.floor(M.millisecond / 100));
          case "m":
            return y.num(M.minute);
          case "mm":
            return y.num(M.minute, 2);
          case "h":
            return y.num(M.hour % 12 === 0 ? 12 : M.hour % 12);
          case "hh":
            return y.num(M.hour % 12 === 0 ? 12 : M.hour % 12, 2);
          case "H":
            return y.num(M.hour);
          case "HH":
            return y.num(M.hour, 2);
          case "Z":
            return pe({
              format: "narrow",
              allowZ: y.opts.allowZ
            });
          case "ZZ":
            return pe({
              format: "short",
              allowZ: y.opts.allowZ
            });
          case "ZZZ":
            return pe({
              format: "techie",
              allowZ: y.opts.allowZ
            });
          case "ZZZZ":
            return M.zone.offsetName(M.ts, {
              format: "short",
              locale: y.loc.locale
            });
          case "ZZZZZ":
            return M.zone.offsetName(M.ts, {
              format: "long",
              locale: y.loc.locale
            });
          case "z":
            return M.zoneName;
          case "a":
            return ge();
          case "d":
            return V ? J({
              day: "numeric"
            }, "day") : y.num(M.day);
          case "dd":
            return V ? J({
              day: "2-digit"
            }, "day") : y.num(M.day, 2);
          case "c":
            return y.num(M.weekday);
          case "ccc":
            return Ce("short", true);
          case "cccc":
            return Ce("long", true);
          case "ccccc":
            return Ce("narrow", true);
          case "E":
            return y.num(M.weekday);
          case "EEE":
            return Ce("short", false);
          case "EEEE":
            return Ce("long", false);
          case "EEEEE":
            return Ce("narrow", false);
          case "L":
            return V ? J({
              month: "numeric",
              day: "numeric"
            }, "month") : y.num(M.month);
          case "LL":
            return V ? J({
              month: "2-digit",
              day: "numeric"
            }, "month") : y.num(M.month, 2);
          case "LLL":
            return qe("short", true);
          case "LLLL":
            return qe("long", true);
          case "LLLLL":
            return qe("narrow", true);
          case "M":
            return V ? J({
              month: "numeric"
            }, "month") : y.num(M.month);
          case "MM":
            return V ? J({
              month: "2-digit"
            }, "month") : y.num(M.month, 2);
          case "MMM":
            return qe("short", false);
          case "MMMM":
            return qe("long", false);
          case "MMMMM":
            return qe("narrow", false);
          case "y":
            return V ? J({
              year: "numeric"
            }, "year") : y.num(M.year);
          case "yy":
            return V ? J({
              year: "2-digit"
            }, "year") : y.num(M.year.toString().slice(-2), 2);
          case "yyyy":
            return V ? J({
              year: "numeric"
            }, "year") : y.num(M.year, 4);
          case "yyyyyy":
            return V ? J({
              year: "numeric"
            }, "year") : y.num(M.year, 6);
          case "G":
            return O0("short");
          case "GG":
            return O0("long");
          case "GGGGG":
            return O0("narrow");
          case "kk":
            return y.num(M.weekYear.toString().slice(-2), 2);
          case "kkkk":
            return y.num(M.weekYear, 4);
          case "W":
            return y.num(M.weekNumber);
          case "WW":
            return y.num(M.weekNumber, 2);
          case "o":
            return y.num(M.ordinal);
          case "ooo":
            return y.num(M.ordinal, 3);
          case "q":
            return y.num(M.quarter);
          case "qq":
            return y.num(M.quarter, 2);
          case "X":
            return y.num(Math.floor(M.ts / 1e3));
          case "x":
            return y.num(M.ts);
          default:
            return Ze(M0);
        }
      };
      return lr(O.parseFormat(h12), F0);
    }, m.formatDurationFromString = function(M, h12) {
      var y = this, U = function(Ce) {
        switch (Ce[0]) {
          case "S":
            return "millisecond";
          case "s":
            return "second";
          case "m":
            return "minute";
          case "h":
            return "hour";
          case "d":
            return "day";
          case "w":
            return "week";
          case "M":
            return "month";
          case "y":
            return "year";
          default:
            return null;
        }
      }, V = function(Ce) {
        return function(Ze) {
          var O0 = U(Ze);
          return O0 ? y.num(Ce.get(O0), Ze.length) : Ze;
        };
      }, J = O.parseFormat(h12), pe = J.reduce(function(qe, Ce) {
        var Ze = Ce.literal, O0 = Ce.val;
        return Ze ? qe : qe.concat(O0);
      }, []), ge = M.shiftTo.apply(M, pe.map(U).filter(function(qe) {
        return qe;
      }));
      return lr(J, V(ge));
    }, O;
  })(), Nt = /* @__PURE__ */ (function() {
    function O(A, M) {
      this.reason = A, this.explanation = M;
    }
    var m = O.prototype;
    return m.toMessage = function() {
      return this.explanation ? this.reason + ": " + this.explanation : this.reason;
    }, O;
  })(), Pn = /* @__PURE__ */ (function() {
    function O() {
    }
    var m = O.prototype;
    return m.offsetName = function(M, h12) {
      throw new C();
    }, m.formatOffset = function(M, h12) {
      throw new C();
    }, m.offset = function(M) {
      throw new C();
    }, m.equals = function(M) {
      throw new C();
    }, e(O, [{
      key: "type",
      get: (
        /**
         * The type of zone
         * @abstract
         * @type {string}
         */
        (function() {
          throw new C();
        })
      )
      /**
       * The name of this zone.
       * @abstract
       * @type {string}
       */
    }, {
      key: "name",
      get: function() {
        throw new C();
      }
      /**
       * Returns whether the offset is known to be fixed for the whole year.
       * @abstract
       * @type {boolean}
       */
    }, {
      key: "isUniversal",
      get: function() {
        throw new C();
      }
    }, {
      key: "isValid",
      get: function() {
        throw new C();
      }
    }]), O;
  })(), Ki = null, r0 = /* @__PURE__ */ (function(O) {
    n12(m, O);
    function m() {
      return O.apply(this, arguments) || this;
    }
    var A = m.prototype;
    return A.offsetName = function(h12, y) {
      var U = y.format, V = y.locale;
      return be(h12, U, V);
    }, A.formatOffset = function(h12, y) {
      return E0(this.offset(h12), y);
    }, A.offset = function(h12) {
      return -new Date(h12).getTimezoneOffset();
    }, A.equals = function(h12) {
      return h12.type === "system";
    }, e(m, [{
      key: "type",
      get: (
        /** @override **/
        (function() {
          return "system";
        })
      )
      /** @override **/
    }, {
      key: "name",
      get: function() {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
      /** @override **/
    }, {
      key: "isUniversal",
      get: function() {
        return false;
      }
    }, {
      key: "isValid",
      get: function() {
        return true;
      }
    }], [{
      key: "instance",
      get: (
        /**
         * Get a singleton instance of the local zone
         * @return {SystemZone}
         */
        (function() {
          return Ki === null && (Ki = new m()), Ki;
        })
      )
    }]), m;
  })(Pn), ee = {};
  function Le(O) {
    return ee[O] || (ee[O] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: O,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    })), ee[O];
  }
  var Qe = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
  };
  function r1(O, m) {
    var A = O.format(m).replace(/\u200E/g, ""), M = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(A), h12 = M[1], y = M[2], U = M[3], V = M[4], J = M[5], pe = M[6], ge = M[7];
    return [U, h12, y, V, J, pe, ge];
  }
  function et(O, m) {
    for (var A = O.formatToParts(m), M = [], h12 = 0; h12 < A.length; h12++) {
      var y = A[h12], U = y.type, V = y.value, J = Qe[U];
      U === "era" ? M[J] = V : le(J) || (M[J] = parseInt(V, 10));
    }
    return M;
  }
  var y1 = {}, S1 = /* @__PURE__ */ (function(O) {
    n12(m, O), m.create = function(h12) {
      return y1[h12] || (y1[h12] = new m(h12)), y1[h12];
    }, m.resetCache = function() {
      y1 = {}, ee = {};
    }, m.isValidSpecifier = function(h12) {
      return this.isValidZone(h12);
    }, m.isValidZone = function(h12) {
      if (!h12)
        return false;
      try {
        return new Intl.DateTimeFormat("en-US", {
          timeZone: h12
        }).format(), true;
      } catch {
        return false;
      }
    };
    function m(M) {
      var h12;
      return h12 = O.call(this) || this, h12.zoneName = M, h12.valid = m.isValidZone(M), h12;
    }
    var A = m.prototype;
    return A.offsetName = function(h12, y) {
      var U = y.format, V = y.locale;
      return be(h12, U, V, this.name);
    }, A.formatOffset = function(h12, y) {
      return E0(this.offset(h12), y);
    }, A.offset = function(h12) {
      var y = new Date(h12);
      if (isNaN(y))
        return NaN;
      var U = Le(this.name), V = U.formatToParts ? et(U, y) : r1(U, y), J = V[0], pe = V[1], ge = V[2], qe = V[3], Ce = V[4], Ze = V[5], O0 = V[6];
      qe === "BC" && (J = -Math.abs(J) + 1);
      var F0 = Ce === 24 ? 0 : Ce, X0 = H1({
        year: J,
        month: pe,
        day: ge,
        hour: F0,
        minute: Ze,
        second: O0,
        millisecond: 0
      }), M0 = +y, D1 = M0 % 1e3;
      return M0 -= D1 >= 0 ? D1 : 1e3 + D1, (X0 - M0) / (60 * 1e3);
    }, A.equals = function(h12) {
      return h12.type === "iana" && h12.name === this.name;
    }, e(m, [{
      key: "type",
      get: function() {
        return "iana";
      }
      /** @override **/
    }, {
      key: "name",
      get: function() {
        return this.zoneName;
      }
      /** @override **/
    }, {
      key: "isUniversal",
      get: function() {
        return false;
      }
    }, {
      key: "isValid",
      get: function() {
        return this.valid;
      }
    }]), m;
  })(Pn), wt = null, it = /* @__PURE__ */ (function(O) {
    n12(m, O), m.instance = function(h12) {
      return h12 === 0 ? m.utcInstance : new m(h12);
    }, m.parseSpecifier = function(h12) {
      if (h12) {
        var y = h12.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
        if (y)
          return new m(Ue(y[1], y[2]));
      }
      return null;
    };
    function m(M) {
      var h12;
      return h12 = O.call(this) || this, h12.fixed = M, h12;
    }
    var A = m.prototype;
    return A.offsetName = function() {
      return this.name;
    }, A.formatOffset = function(h12, y) {
      return E0(this.fixed, y);
    }, A.offset = function() {
      return this.fixed;
    }, A.equals = function(h12) {
      return h12.type === "fixed" && h12.fixed === this.fixed;
    }, e(m, [{
      key: "type",
      get: function() {
        return "fixed";
      }
      /** @override **/
    }, {
      key: "name",
      get: function() {
        return this.fixed === 0 ? "UTC" : "UTC" + E0(this.fixed, "narrow");
      }
    }, {
      key: "isUniversal",
      get: function() {
        return true;
      }
    }, {
      key: "isValid",
      get: function() {
        return true;
      }
    }], [{
      key: "utcInstance",
      get: (
        /**
         * Get a singleton instance of UTC
         * @return {FixedOffsetZone}
         */
        (function() {
          return wt === null && (wt = new m(0)), wt;
        })
      )
    }]), m;
  })(Pn), tt2 = /* @__PURE__ */ (function(O) {
    n12(m, O);
    function m(M) {
      var h12;
      return h12 = O.call(this) || this, h12.zoneName = M, h12;
    }
    var A = m.prototype;
    return A.offsetName = function() {
      return null;
    }, A.formatOffset = function() {
      return "";
    }, A.offset = function() {
      return NaN;
    }, A.equals = function() {
      return false;
    }, e(m, [{
      key: "type",
      get: function() {
        return "invalid";
      }
      /** @override **/
    }, {
      key: "name",
      get: function() {
        return this.zoneName;
      }
      /** @override **/
    }, {
      key: "isUniversal",
      get: function() {
        return false;
      }
    }, {
      key: "isValid",
      get: function() {
        return false;
      }
    }]), m;
  })(Pn);
  function Lr(O, m) {
    if (le(O) || O === null)
      return m;
    if (O instanceof Pn)
      return O;
    if (re(O)) {
      var A = O.toLowerCase();
      return A === "local" || A === "system" ? m : A === "utc" || A === "gmt" ? it.utcInstance : it.parseSpecifier(A) || S1.create(O);
    } else
      return Ae(O) ? it.instance(O) : typeof O == "object" && O.offset && typeof O.offset == "number" ? O : new tt2(O);
  }
  var Qi = function() {
    return Date.now();
  }, P1e = "system", D1e = null, W1e = null, N1e = null, w1e, N1 = /* @__PURE__ */ (function() {
    function O() {
    }
    return O.resetCaches = function() {
      rt.resetCache(), S1.resetCache();
    }, e(O, null, [{
      key: "now",
      get: (
        /**
         * Get the callback for returning the current timestamp.
         * @type {function}
         */
        (function() {
          return Qi;
        })
      ),
      set: function(A) {
        Qi = A;
      }
      /**
       * Set the default time zone to create DateTimes in. Does not affect existing instances.
       * Use the value "system" to reset this value to the system's time zone.
       * @type {string}
       */
    }, {
      key: "defaultZone",
      get: (
        /**
         * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
         * The default value is the system's time zone (the one set on the machine that runs this code).
         * @type {Zone}
         */
        (function() {
          return Lr(P1e, r0.instance);
        })
      ),
      set: function(A) {
        P1e = A;
      }
    }, {
      key: "defaultLocale",
      get: function() {
        return D1e;
      },
      set: function(A) {
        D1e = A;
      }
      /**
       * Get the default numbering system to create DateTimes with. Does not affect existing instances.
       * @type {string}
       */
    }, {
      key: "defaultNumberingSystem",
      get: function() {
        return W1e;
      },
      set: function(A) {
        W1e = A;
      }
      /**
       * Get the default output calendar to create DateTimes with. Does not affect existing instances.
       * @type {string}
       */
    }, {
      key: "defaultOutputCalendar",
      get: function() {
        return N1e;
      },
      set: function(A) {
        N1e = A;
      }
      /**
       * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
       * @type {boolean}
       */
    }, {
      key: "throwOnInvalid",
      get: function() {
        return w1e;
      },
      set: function(A) {
        w1e = A;
      }
    }]), O;
  })(), jKe = ["base"], FKe = ["padTo", "floor"], B1e = {};
  function VKe(O, m) {
    m === void 0 && (m = {});
    var A = JSON.stringify([O, m]), M = B1e[A];
    return M || (M = new Intl.ListFormat(O, m), B1e[A] = M), M;
  }
  var dd = {};
  function fd(O, m) {
    m === void 0 && (m = {});
    var A = JSON.stringify([O, m]), M = dd[A];
    return M || (M = new Intl.DateTimeFormat(O, m), dd[A] = M), M;
  }
  var bd = {};
  function HKe(O, m) {
    m === void 0 && (m = {});
    var A = JSON.stringify([O, m]), M = bd[A];
    return M || (M = new Intl.NumberFormat(O, m), bd[A] = M), M;
  }
  var Md = {};
  function XKe(O, m) {
    m === void 0 && (m = {});
    var A = m;
    A.base;
    var M = l2(A, jKe), h12 = JSON.stringify([O, M]), y = Md[h12];
    return y || (y = new Intl.RelativeTimeFormat(O, m), Md[h12] = y), y;
  }
  var Zi = null;
  function $Ke() {
    return Zi || (Zi = new Intl.DateTimeFormat().resolvedOptions().locale, Zi);
  }
  function GKe(O) {
    var m = O.indexOf("-u-");
    if (m === -1)
      return [O];
    var A, M = O.substring(0, m);
    try {
      A = fd(O).resolvedOptions();
    } catch {
      A = fd(M).resolvedOptions();
    }
    var h12 = A, y = h12.numberingSystem, U = h12.calendar;
    return [M, y, U];
  }
  function YKe(O, m, A) {
    return (A || m) && (O += "-u", A && (O += "-ca-" + A), m && (O += "-nu-" + m)), O;
  }
  function JKe(O) {
    for (var m = [], A = 1; A <= 12; A++) {
      var M = w1.utc(2016, A, 1);
      m.push(O(M));
    }
    return m;
  }
  function KKe(O) {
    for (var m = [], A = 1; A <= 7; A++) {
      var M = w1.utc(2016, 11, 13 + A);
      m.push(O(M));
    }
    return m;
  }
  function Jc(O, m, A, M, h12) {
    var y = O.listingMode(A);
    return y === "error" ? null : y === "en" ? M(m) : h12(m);
  }
  function QKe(O) {
    return O.numberingSystem && O.numberingSystem !== "latn" ? false : O.numberingSystem === "latn" || !O.locale || O.locale.startsWith("en") || new Intl.DateTimeFormat(O.intl).resolvedOptions().numberingSystem === "latn";
  }
  var ZKe = /* @__PURE__ */ (function() {
    function O(A, M, h12) {
      this.padTo = h12.padTo || 0, this.floor = h12.floor || false, h12.padTo, h12.floor;
      var y = l2(h12, FKe);
      if (!M || Object.keys(y).length > 0) {
        var U = r12({
          useGrouping: false
        }, h12);
        h12.padTo > 0 && (U.minimumIntegerDigits = h12.padTo), this.inf = HKe(A, U);
      }
    }
    var m = O.prototype;
    return m.format = function(M) {
      if (this.inf) {
        var h12 = this.floor ? Math.floor(M) : M;
        return this.inf.format(h12);
      } else {
        var y = this.floor ? Math.floor(M) : b0(M, 3);
        return Be(y, this.padTo);
      }
    }, O;
  })(), eQe = /* @__PURE__ */ (function() {
    function O(A, M, h12) {
      this.opts = h12;
      var y;
      if (A.zone.isUniversal) {
        var U = -1 * (A.offset / 60), V = U >= 0 ? "Etc/GMT+" + U : "Etc/GMT" + U;
        A.offset !== 0 && S1.create(V).valid ? (y = V, this.dt = A) : (y = "UTC", h12.timeZoneName ? this.dt = A : this.dt = A.offset === 0 ? A : w1.fromMillis(A.ts + A.offset * 60 * 1e3));
      } else
        A.zone.type === "system" ? this.dt = A : (this.dt = A, y = A.zone.name);
      var J = r12({}, this.opts);
      y && (J.timeZone = y), this.dtf = fd(M, J);
    }
    var m = O.prototype;
    return m.format = function() {
      return this.dtf.format(this.dt.toJSDate());
    }, m.formatToParts = function() {
      return this.dtf.formatToParts(this.dt.toJSDate());
    }, m.resolvedOptions = function() {
      return this.dtf.resolvedOptions();
    }, O;
  })(), tQe = /* @__PURE__ */ (function() {
    function O(A, M, h12) {
      this.opts = r12({
        style: "long"
      }, h12), !M && Me() && (this.rtf = XKe(A, h12));
    }
    var m = O.prototype;
    return m.format = function(M, h12) {
      return this.rtf ? this.rtf.format(M, h12) : Gc(h12, M, this.opts.numeric, this.opts.style !== "long");
    }, m.formatToParts = function(M, h12) {
      return this.rtf ? this.rtf.formatToParts(M, h12) : [];
    }, O;
  })(), rt = /* @__PURE__ */ (function() {
    O.fromOpts = function(M) {
      return O.create(M.locale, M.numberingSystem, M.outputCalendar, M.defaultToEN);
    }, O.create = function(M, h12, y, U) {
      U === void 0 && (U = false);
      var V = M || N1.defaultLocale, J = V || (U ? "en-US" : $Ke()), pe = h12 || N1.defaultNumberingSystem, ge = y || N1.defaultOutputCalendar;
      return new O(J, pe, ge, V);
    }, O.resetCache = function() {
      Zi = null, dd = {}, bd = {}, Md = {};
    }, O.fromObject = function(M) {
      var h12 = M === void 0 ? {} : M, y = h12.locale, U = h12.numberingSystem, V = h12.outputCalendar;
      return O.create(y, U, V);
    };
    function O(A, M, h12, y) {
      var U = GKe(A), V = U[0], J = U[1], pe = U[2];
      this.locale = V, this.numberingSystem = M || J || null, this.outputCalendar = h12 || pe || null, this.intl = YKe(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = {
        format: {},
        standalone: {}
      }, this.monthsCache = {
        format: {},
        standalone: {}
      }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = y, this.fastNumbersCached = null;
    }
    var m = O.prototype;
    return m.listingMode = function() {
      var M = this.isEnglish(), h12 = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
      return M && h12 ? "en" : "intl";
    }, m.clone = function(M) {
      return !M || Object.getOwnPropertyNames(M).length === 0 ? this : O.create(M.locale || this.specifiedLocale, M.numberingSystem || this.numberingSystem, M.outputCalendar || this.outputCalendar, M.defaultToEN || false);
    }, m.redefaultToEN = function(M) {
      return M === void 0 && (M = {}), this.clone(r12({}, M, {
        defaultToEN: true
      }));
    }, m.redefaultToSystem = function(M) {
      return M === void 0 && (M = {}), this.clone(r12({}, M, {
        defaultToEN: false
      }));
    }, m.months = function(M, h12, y) {
      var U = this;
      return h12 === void 0 && (h12 = false), y === void 0 && (y = true), Jc(this, M, y, za, function() {
        var V = h12 ? {
          month: M,
          day: "numeric"
        } : {
          month: M
        }, J = h12 ? "format" : "standalone";
        return U.monthsCache[J][M] || (U.monthsCache[J][M] = JKe(function(pe) {
          return U.extract(pe, V, "month");
        })), U.monthsCache[J][M];
      });
    }, m.weekdays = function(M, h12, y) {
      var U = this;
      return h12 === void 0 && (h12 = false), y === void 0 && (y = true), Jc(this, M, y, En, function() {
        var V = h12 ? {
          weekday: M,
          year: "numeric",
          month: "long",
          day: "numeric"
        } : {
          weekday: M
        }, J = h12 ? "format" : "standalone";
        return U.weekdaysCache[J][M] || (U.weekdaysCache[J][M] = KKe(function(pe) {
          return U.extract(pe, V, "weekday");
        })), U.weekdaysCache[J][M];
      });
    }, m.meridiems = function(M) {
      var h12 = this;
      return M === void 0 && (M = true), Jc(this, void 0, M, function() {
        return Ln;
      }, function() {
        if (!h12.meridiemCache) {
          var y = {
            hour: "numeric",
            hourCycle: "h12"
          };
          h12.meridiemCache = [w1.utc(2016, 11, 13, 9), w1.utc(2016, 11, 13, 19)].map(function(U) {
            return h12.extract(U, y, "dayperiod");
          });
        }
        return h12.meridiemCache;
      });
    }, m.eras = function(M, h12) {
      var y = this;
      return h12 === void 0 && (h12 = true), Jc(this, M, h12, tr, function() {
        var U = {
          era: M
        };
        return y.eraCache[M] || (y.eraCache[M] = [w1.utc(-40, 1, 1), w1.utc(2017, 1, 1)].map(function(V) {
          return y.extract(V, U, "era");
        })), y.eraCache[M];
      });
    }, m.extract = function(M, h12, y) {
      var U = this.dtFormatter(M, h12), V = U.formatToParts(), J = V.find(function(pe) {
        return pe.type.toLowerCase() === y;
      });
      return J ? J.value : null;
    }, m.numberFormatter = function(M) {
      return M === void 0 && (M = {}), new ZKe(this.intl, M.forceSimple || this.fastNumbers, M);
    }, m.dtFormatter = function(M, h12) {
      return h12 === void 0 && (h12 = {}), new eQe(M, this.intl, h12);
    }, m.relFormatter = function(M) {
      return M === void 0 && (M = {}), new tQe(this.intl, this.isEnglish(), M);
    }, m.listFormatter = function(M) {
      return M === void 0 && (M = {}), VKe(this.intl, M);
    }, m.isEnglish = function() {
      return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    }, m.equals = function(M) {
      return this.locale === M.locale && this.numberingSystem === M.numberingSystem && this.outputCalendar === M.outputCalendar;
    }, e(O, [{
      key: "fastNumbers",
      get: function() {
        return this.fastNumbersCached == null && (this.fastNumbersCached = QKe(this)), this.fastNumbersCached;
      }
    }]), O;
  })();
  function Bo() {
    for (var O = arguments.length, m = new Array(O), A = 0; A < O; A++)
      m[A] = arguments[A];
    var M = m.reduce(function(h12, y) {
      return h12 + y.source;
    }, "");
    return RegExp("^" + M + "$");
  }
  function $a() {
    for (var O = arguments.length, m = new Array(O), A = 0; A < O; A++)
      m[A] = arguments[A];
    return function(M) {
      return m.reduce(function(h12, y) {
        var U = h12[0], V = h12[1], J = h12[2], pe = y(M, J), ge = pe[0], qe = pe[1], Ce = pe[2];
        return [r12({}, U, ge), V || qe, Ce];
      }, [{}, null, 1]).slice(0, 2);
    };
  }
  function xo(O) {
    if (O == null)
      return [null, null];
    for (var m = arguments.length, A = new Array(m > 1 ? m - 1 : 0), M = 1; M < m; M++)
      A[M - 1] = arguments[M];
    for (var h12 = 0, y = A; h12 < y.length; h12++) {
      var U = y[h12], V = U[0], J = U[1], pe = V.exec(O);
      if (pe)
        return J(pe);
    }
    return [null, null];
  }
  function x1e() {
    for (var O = arguments.length, m = new Array(O), A = 0; A < O; A++)
      m[A] = arguments[A];
    return function(M, h12) {
      var y = {}, U;
      for (U = 0; U < m.length; U++)
        y[m[U]] = o0(M[h12 + U]);
      return [y, null, h12 + U];
    };
  }
  var U1e = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, Od = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, k1e = RegExp("" + Od.source + U1e.source + "?"), zd = RegExp("(?:T" + k1e.source + ")?"), rQe = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, nQe = /(\d{4})-?W(\d\d)(?:-?(\d))?/, aQe = /(\d{4})-?(\d{3})/, oQe = x1e("weekYear", "weekNumber", "weekDay"), iQe = x1e("year", "ordinal"), uQe = /(\d{4})-(\d\d)-(\d\d)/, j1e = RegExp(Od.source + " ?(?:" + U1e.source + "|(" + Ot.source + "))?"), sQe = RegExp("(?: " + j1e.source + ")?");
  function Uo(O, m, A) {
    var M = O[m];
    return le(M) ? A : o0(M);
  }
  function F1e(O, m) {
    var A = {
      year: Uo(O, m),
      month: Uo(O, m + 1, 1),
      day: Uo(O, m + 2, 1)
    };
    return [A, null, m + 3];
  }
  function Ga(O, m) {
    var A = {
      hours: Uo(O, m, 0),
      minutes: Uo(O, m + 1, 0),
      seconds: Uo(O, m + 2, 0),
      milliseconds: I0(O[m + 3])
    };
    return [A, null, m + 4];
  }
  function ko(O, m) {
    var A = !O[m] && !O[m + 1], M = Ue(O[m + 1], O[m + 2]), h12 = A ? null : it.instance(M);
    return [{}, h12, m + 3];
  }
  function V1e(O, m) {
    var A = O[m] ? S1.create(O[m]) : null;
    return [{}, A, m + 1];
  }
  var cQe = RegExp("^T?" + Od.source + "$"), lQe = /^-?P(?:(?:(-?\d{1,9}(?:\.\d{1,9})?)Y)?(?:(-?\d{1,9}(?:\.\d{1,9})?)M)?(?:(-?\d{1,9}(?:\.\d{1,9})?)W)?(?:(-?\d{1,9}(?:\.\d{1,9})?)D)?(?:T(?:(-?\d{1,9}(?:\.\d{1,9})?)H)?(?:(-?\d{1,9}(?:\.\d{1,9})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,9}))?S)?)?)$/;
  function pQe(O) {
    var m = O[0], A = O[1], M = O[2], h12 = O[3], y = O[4], U = O[5], V = O[6], J = O[7], pe = O[8], ge = m[0] === "-", qe = J && J[0] === "-", Ce = function(O0, F0) {
      return F0 === void 0 && (F0 = false), O0 !== void 0 && (F0 || O0 && ge) ? -O0 : O0;
    };
    return [{
      years: Ce(Ke(A)),
      months: Ce(Ke(M)),
      weeks: Ce(Ke(h12)),
      days: Ce(Ke(y)),
      hours: Ce(Ke(U)),
      minutes: Ce(Ke(V)),
      seconds: Ce(Ke(J), J === "-0"),
      milliseconds: Ce(I0(pe), qe)
    }];
  }
  var dQe = {
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
  };
  function Ad(O, m, A, M, h12, y, U) {
    var V = {
      year: m.length === 2 ? Zt(o0(m)) : o0(m),
      month: h1.indexOf(A) + 1,
      day: o0(M),
      hour: o0(h12),
      minute: o0(y)
    };
    return U && (V.second = o0(U)), O && (V.weekday = O.length > 3 ? cn.indexOf(O) + 1 : er.indexOf(O) + 1), V;
  }
  var fQe = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
  function bQe(O) {
    var m = O[1], A = O[2], M = O[3], h12 = O[4], y = O[5], U = O[6], V = O[7], J = O[8], pe = O[9], ge = O[10], qe = O[11], Ce = Ad(m, h12, M, A, y, U, V), Ze;
    return J ? Ze = dQe[J] : pe ? Ze = 0 : Ze = Ue(ge, qe), [Ce, new it(Ze)];
  }
  function MQe(O) {
    return O.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
  }
  var OQe = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, zQe = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, AQe = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
  function H1e(O) {
    var m = O[1], A = O[2], M = O[3], h12 = O[4], y = O[5], U = O[6], V = O[7], J = Ad(m, h12, M, A, y, U, V);
    return [J, it.utcInstance];
  }
  function _Qe(O) {
    var m = O[1], A = O[2], M = O[3], h12 = O[4], y = O[5], U = O[6], V = O[7], J = Ad(m, V, A, M, h12, y, U);
    return [J, it.utcInstance];
  }
  var hQe = Bo(rQe, zd), vQe = Bo(nQe, zd), mQe = Bo(aQe, zd), RQe = Bo(k1e), qQe = $a(F1e, Ga, ko), TQe = $a(oQe, Ga, ko), yQe = $a(iQe, Ga, ko), SQe = $a(Ga, ko);
  function CQe(O) {
    return xo(O, [hQe, qQe], [vQe, TQe], [mQe, yQe], [RQe, SQe]);
  }
  function gQe(O) {
    return xo(MQe(O), [fQe, bQe]);
  }
  function IQe(O) {
    return xo(O, [OQe, H1e], [zQe, H1e], [AQe, _Qe]);
  }
  function EQe(O) {
    return xo(O, [lQe, pQe]);
  }
  var LQe = $a(Ga);
  function PQe(O) {
    return xo(O, [cQe, LQe]);
  }
  var DQe = Bo(uQe, sQe), WQe = Bo(j1e), NQe = $a(F1e, Ga, ko, V1e), wQe = $a(Ga, ko, V1e);
  function BQe(O) {
    return xo(O, [DQe, NQe], [WQe, wQe]);
  }
  var xQe = "Invalid Duration", X1e = {
    weeks: {
      days: 7,
      hours: 7 * 24,
      minutes: 7 * 24 * 60,
      seconds: 7 * 24 * 60 * 60,
      milliseconds: 7 * 24 * 60 * 60 * 1e3
    },
    days: {
      hours: 24,
      minutes: 24 * 60,
      seconds: 24 * 60 * 60,
      milliseconds: 24 * 60 * 60 * 1e3
    },
    hours: {
      minutes: 60,
      seconds: 60 * 60,
      milliseconds: 60 * 60 * 1e3
    },
    minutes: {
      seconds: 60,
      milliseconds: 60 * 1e3
    },
    seconds: {
      milliseconds: 1e3
    }
  }, UQe = r12({
    years: {
      quarters: 4,
      months: 12,
      weeks: 52,
      days: 365,
      hours: 365 * 24,
      minutes: 365 * 24 * 60,
      seconds: 365 * 24 * 60 * 60,
      milliseconds: 365 * 24 * 60 * 60 * 1e3
    },
    quarters: {
      months: 3,
      weeks: 13,
      days: 91,
      hours: 91 * 24,
      minutes: 91 * 24 * 60,
      seconds: 91 * 24 * 60 * 60,
      milliseconds: 91 * 24 * 60 * 60 * 1e3
    },
    months: {
      weeks: 4,
      days: 30,
      hours: 30 * 24,
      minutes: 30 * 24 * 60,
      seconds: 30 * 24 * 60 * 60,
      milliseconds: 30 * 24 * 60 * 60 * 1e3
    }
  }, X1e), dr = 146097 / 400, jo = 146097 / 4800, kQe = r12({
    years: {
      quarters: 4,
      months: 12,
      weeks: dr / 7,
      days: dr,
      hours: dr * 24,
      minutes: dr * 24 * 60,
      seconds: dr * 24 * 60 * 60,
      milliseconds: dr * 24 * 60 * 60 * 1e3
    },
    quarters: {
      months: 3,
      weeks: dr / 28,
      days: dr / 4,
      hours: dr * 24 / 4,
      minutes: dr * 24 * 60 / 4,
      seconds: dr * 24 * 60 * 60 / 4,
      milliseconds: dr * 24 * 60 * 60 * 1e3 / 4
    },
    months: {
      weeks: jo / 7,
      days: jo,
      hours: jo * 24,
      minutes: jo * 24 * 60,
      seconds: jo * 24 * 60 * 60,
      milliseconds: jo * 24 * 60 * 60 * 1e3
    }
  }, X1e), Ya = ["years", "quarters", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds"], jQe = Ya.slice(0).reverse();
  function Ja(O, m, A) {
    A === void 0 && (A = false);
    var M = {
      values: A ? m.values : r12({}, O.values, m.values || {}),
      loc: O.loc.clone(m.loc),
      conversionAccuracy: m.conversionAccuracy || O.conversionAccuracy
    };
    return new ut(M);
  }
  function FQe(O) {
    return O < 0 ? Math.floor(O) : Math.ceil(O);
  }
  function $1e(O, m, A, M, h12) {
    var y = O[h12][A], U = m[A] / y, V = Math.sign(U) === Math.sign(M[h12]), J = !V && M[h12] !== 0 && Math.abs(U) <= 1 ? FQe(U) : Math.trunc(U);
    M[h12] += J, m[A] -= J * y;
  }
  function VQe(O, m) {
    jQe.reduce(function(A, M) {
      return le(m[M]) ? A : (A && $1e(O, m, A, m, M), M);
    }, null);
  }
  var ut = /* @__PURE__ */ (function() {
    function O(A) {
      var M = A.conversionAccuracy === "longterm" || false;
      this.values = A.values, this.loc = A.loc || rt.create(), this.conversionAccuracy = M ? "longterm" : "casual", this.invalid = A.invalid || null, this.matrix = M ? kQe : UQe, this.isLuxonDuration = true;
    }
    O.fromMillis = function(M, h12) {
      return O.fromObject({
        milliseconds: M
      }, h12);
    }, O.fromObject = function(M, h12) {
      if (h12 === void 0 && (h12 = {}), M == null || typeof M != "object")
        throw new v("Duration.fromObject: argument expected to be an object, got " + (M === null ? "null" : typeof M));
      return new O({
        values: W0(M, O.normalizeUnit),
        loc: rt.fromObject(h12),
        conversionAccuracy: h12.conversionAccuracy
      });
    }, O.fromDurationLike = function(M) {
      if (Ae(M))
        return O.fromMillis(M);
      if (O.isDuration(M))
        return M;
      if (typeof M == "object")
        return O.fromObject(M);
      throw new v("Unknown duration argument " + M + " of type " + typeof M);
    }, O.fromISO = function(M, h12) {
      var y = EQe(M), U = y[0];
      return U ? O.fromObject(U, h12) : O.invalid("unparsable", 'the input "' + M + `" can't be parsed as ISO 8601`);
    }, O.fromISOTime = function(M, h12) {
      var y = PQe(M), U = y[0];
      return U ? O.fromObject(U, h12) : O.invalid("unparsable", 'the input "' + M + `" can't be parsed as ISO 8601`);
    }, O.invalid = function(M, h12) {
      if (h12 === void 0 && (h12 = null), !M)
        throw new v("need to specify a reason the Duration is invalid");
      var y = M instanceof Nt ? M : new Nt(M, h12);
      if (N1.throwOnInvalid)
        throw new q(y);
      return new O({
        invalid: y
      });
    }, O.normalizeUnit = function(M) {
      var h12 = {
        year: "years",
        years: "years",
        quarter: "quarters",
        quarters: "quarters",
        month: "months",
        months: "months",
        week: "weeks",
        weeks: "weeks",
        day: "days",
        days: "days",
        hour: "hours",
        hours: "hours",
        minute: "minutes",
        minutes: "minutes",
        second: "seconds",
        seconds: "seconds",
        millisecond: "milliseconds",
        milliseconds: "milliseconds"
      }[M && M.toLowerCase()];
      if (!h12)
        throw new N(M);
      return h12;
    }, O.isDuration = function(M) {
      return M && M.isLuxonDuration || false;
    };
    var m = O.prototype;
    return m.toFormat = function(M, h12) {
      h12 === void 0 && (h12 = {});
      var y = r12({}, h12, {
        floor: h12.round !== false && h12.floor !== false
      });
      return this.isValid ? pr.create(this.loc, y).formatDurationFromString(this, M) : xQe;
    }, m.toHuman = function(M) {
      var h12 = this;
      M === void 0 && (M = {});
      var y = Ya.map(function(U) {
        var V = h12.values[U];
        return le(V) ? null : h12.loc.numberFormatter(r12({
          style: "unit",
          unitDisplay: "long"
        }, M, {
          unit: U.slice(0, -1)
        })).format(V);
      }).filter(function(U) {
        return U;
      });
      return this.loc.listFormatter(r12({
        type: "conjunction",
        style: M.listStyle || "narrow"
      }, M)).format(y);
    }, m.toObject = function() {
      return this.isValid ? r12({}, this.values) : {};
    }, m.toISO = function() {
      if (!this.isValid)
        return null;
      var M = "P";
      return this.years !== 0 && (M += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (M += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (M += this.weeks + "W"), this.days !== 0 && (M += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (M += "T"), this.hours !== 0 && (M += this.hours + "H"), this.minutes !== 0 && (M += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (M += b0(this.seconds + this.milliseconds / 1e3, 3) + "S"), M === "P" && (M += "T0S"), M;
    }, m.toISOTime = function(M) {
      if (M === void 0 && (M = {}), !this.isValid)
        return null;
      var h12 = this.toMillis();
      if (h12 < 0 || h12 >= 864e5)
        return null;
      M = r12({
        suppressMilliseconds: false,
        suppressSeconds: false,
        includePrefix: false,
        format: "extended"
      }, M);
      var y = this.shiftTo("hours", "minutes", "seconds", "milliseconds"), U = M.format === "basic" ? "hhmm" : "hh:mm";
      (!M.suppressSeconds || y.seconds !== 0 || y.milliseconds !== 0) && (U += M.format === "basic" ? "ss" : ":ss", (!M.suppressMilliseconds || y.milliseconds !== 0) && (U += ".SSS"));
      var V = y.toFormat(U);
      return M.includePrefix && (V = "T" + V), V;
    }, m.toJSON = function() {
      return this.toISO();
    }, m.toString = function() {
      return this.toISO();
    }, m.toMillis = function() {
      return this.as("milliseconds");
    }, m.valueOf = function() {
      return this.toMillis();
    }, m.plus = function(M) {
      if (!this.isValid)
        return this;
      for (var h12 = O.fromDurationLike(M), y = {}, U = d(Ya), V; !(V = U()).done; ) {
        var J = V.value;
        (Ne(h12.values, J) || Ne(this.values, J)) && (y[J] = h12.get(J) + this.get(J));
      }
      return Ja(this, {
        values: y
      }, true);
    }, m.minus = function(M) {
      if (!this.isValid)
        return this;
      var h12 = O.fromDurationLike(M);
      return this.plus(h12.negate());
    }, m.mapUnits = function(M) {
      if (!this.isValid)
        return this;
      for (var h12 = {}, y = 0, U = Object.keys(this.values); y < U.length; y++) {
        var V = U[y];
        h12[V] = d0(M(this.values[V], V));
      }
      return Ja(this, {
        values: h12
      }, true);
    }, m.get = function(M) {
      return this[O.normalizeUnit(M)];
    }, m.set = function(M) {
      if (!this.isValid)
        return this;
      var h12 = r12({}, this.values, W0(M, O.normalizeUnit));
      return Ja(this, {
        values: h12
      });
    }, m.reconfigure = function(M) {
      var h12 = M === void 0 ? {} : M, y = h12.locale, U = h12.numberingSystem, V = h12.conversionAccuracy, J = this.loc.clone({
        locale: y,
        numberingSystem: U
      }), pe = {
        loc: J
      };
      return V && (pe.conversionAccuracy = V), Ja(this, pe);
    }, m.as = function(M) {
      return this.isValid ? this.shiftTo(M).get(M) : NaN;
    }, m.normalize = function() {
      if (!this.isValid)
        return this;
      var M = this.toObject();
      return VQe(this.matrix, M), Ja(this, {
        values: M
      }, true);
    }, m.shiftTo = function() {
      for (var M = arguments.length, h12 = new Array(M), y = 0; y < M; y++)
        h12[y] = arguments[y];
      if (!this.isValid)
        return this;
      if (h12.length === 0)
        return this;
      h12 = h12.map(function(D1) {
        return O.normalizeUnit(D1);
      });
      for (var U = {}, V = {}, J = this.toObject(), pe, ge = d(Ya), qe; !(qe = ge()).done; ) {
        var Ce = qe.value;
        if (h12.indexOf(Ce) >= 0) {
          pe = Ce;
          var Ze = 0;
          for (var O0 in V)
            Ze += this.matrix[O0][Ce] * V[O0], V[O0] = 0;
          Ae(J[Ce]) && (Ze += J[Ce]);
          var F0 = Math.trunc(Ze);
          U[Ce] = F0, V[Ce] = (Ze * 1e3 - F0 * 1e3) / 1e3;
          for (var X0 in J)
            Ya.indexOf(X0) > Ya.indexOf(Ce) && $1e(this.matrix, J, X0, U, Ce);
        } else
          Ae(J[Ce]) && (V[Ce] = J[Ce]);
      }
      for (var M0 in V)
        V[M0] !== 0 && (U[pe] += M0 === pe ? V[M0] : V[M0] / this.matrix[pe][M0]);
      return Ja(this, {
        values: U
      }, true).normalize();
    }, m.negate = function() {
      if (!this.isValid)
        return this;
      for (var M = {}, h12 = 0, y = Object.keys(this.values); h12 < y.length; h12++) {
        var U = y[h12];
        M[U] = this.values[U] === 0 ? 0 : -this.values[U];
      }
      return Ja(this, {
        values: M
      }, true);
    }, m.equals = function(M) {
      if (!this.isValid || !M.isValid || !this.loc.equals(M.loc))
        return false;
      function h12(J, pe) {
        return J === void 0 || J === 0 ? pe === void 0 || pe === 0 : J === pe;
      }
      for (var y = d(Ya), U; !(U = y()).done; ) {
        var V = U.value;
        if (!h12(this.values[V], M.values[V]))
          return false;
      }
      return true;
    }, e(O, [{
      key: "locale",
      get: function() {
        return this.isValid ? this.loc.locale : null;
      }
      /**
       * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
       *
       * @type {string}
       */
    }, {
      key: "numberingSystem",
      get: function() {
        return this.isValid ? this.loc.numberingSystem : null;
      }
    }, {
      key: "years",
      get: function() {
        return this.isValid ? this.values.years || 0 : NaN;
      }
      /**
       * Get the quarters.
       * @type {number}
       */
    }, {
      key: "quarters",
      get: function() {
        return this.isValid ? this.values.quarters || 0 : NaN;
      }
      /**
       * Get the months.
       * @type {number}
       */
    }, {
      key: "months",
      get: function() {
        return this.isValid ? this.values.months || 0 : NaN;
      }
      /**
       * Get the weeks
       * @type {number}
       */
    }, {
      key: "weeks",
      get: function() {
        return this.isValid ? this.values.weeks || 0 : NaN;
      }
      /**
       * Get the days.
       * @type {number}
       */
    }, {
      key: "days",
      get: function() {
        return this.isValid ? this.values.days || 0 : NaN;
      }
      /**
       * Get the hours.
       * @type {number}
       */
    }, {
      key: "hours",
      get: function() {
        return this.isValid ? this.values.hours || 0 : NaN;
      }
      /**
       * Get the minutes.
       * @type {number}
       */
    }, {
      key: "minutes",
      get: function() {
        return this.isValid ? this.values.minutes || 0 : NaN;
      }
      /**
       * Get the seconds.
       * @return {number}
       */
    }, {
      key: "seconds",
      get: function() {
        return this.isValid ? this.values.seconds || 0 : NaN;
      }
      /**
       * Get the milliseconds.
       * @return {number}
       */
    }, {
      key: "milliseconds",
      get: function() {
        return this.isValid ? this.values.milliseconds || 0 : NaN;
      }
      /**
       * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
       * on invalid DateTimes or Intervals.
       * @return {boolean}
       */
    }, {
      key: "isValid",
      get: function() {
        return this.invalid === null;
      }
      /**
       * Returns an error code if this Duration became invalid, or null if the Duration is valid
       * @return {string}
       */
    }, {
      key: "invalidReason",
      get: function() {
        return this.invalid ? this.invalid.reason : null;
      }
      /**
       * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
       * @type {string}
       */
    }, {
      key: "invalidExplanation",
      get: function() {
        return this.invalid ? this.invalid.explanation : null;
      }
    }]), O;
  })(), eu = "Invalid Interval";
  function HQe(O, m) {
    return !O || !O.isValid ? tu.invalid("missing or invalid start") : !m || !m.isValid ? tu.invalid("missing or invalid end") : m < O ? tu.invalid("end before start", "The end of an interval must be after its start, but you had start=" + O.toISO() + " and end=" + m.toISO()) : null;
  }
  var tu = /* @__PURE__ */ (function() {
    function O(A) {
      this.s = A.start, this.e = A.end, this.invalid = A.invalid || null, this.isLuxonInterval = true;
    }
    O.invalid = function(M, h12) {
      if (h12 === void 0 && (h12 = null), !M)
        throw new v("need to specify a reason the Interval is invalid");
      var y = M instanceof Nt ? M : new Nt(M, h12);
      if (N1.throwOnInvalid)
        throw new _(y);
      return new O({
        invalid: y
      });
    }, O.fromDateTimes = function(M, h12) {
      var y = ou(M), U = ou(h12), V = HQe(y, U);
      return V ?? new O({
        start: y,
        end: U
      });
    }, O.after = function(M, h12) {
      var y = ut.fromDurationLike(h12), U = ou(M);
      return O.fromDateTimes(U, U.plus(y));
    }, O.before = function(M, h12) {
      var y = ut.fromDurationLike(h12), U = ou(M);
      return O.fromDateTimes(U.minus(y), U);
    }, O.fromISO = function(M, h12) {
      var y = (M || "").split("/", 2), U = y[0], V = y[1];
      if (U && V) {
        var J, pe;
        try {
          J = w1.fromISO(U, h12), pe = J.isValid;
        } catch {
          pe = false;
        }
        var ge, qe;
        try {
          ge = w1.fromISO(V, h12), qe = ge.isValid;
        } catch {
          qe = false;
        }
        if (pe && qe)
          return O.fromDateTimes(J, ge);
        if (pe) {
          var Ce = ut.fromISO(V, h12);
          if (Ce.isValid)
            return O.after(J, Ce);
        } else if (qe) {
          var Ze = ut.fromISO(U, h12);
          if (Ze.isValid)
            return O.before(ge, Ze);
        }
      }
      return O.invalid("unparsable", 'the input "' + M + `" can't be parsed as ISO 8601`);
    }, O.isInterval = function(M) {
      return M && M.isLuxonInterval || false;
    };
    var m = O.prototype;
    return m.length = function(M) {
      return M === void 0 && (M = "milliseconds"), this.isValid ? this.toDuration.apply(this, [M]).get(M) : NaN;
    }, m.count = function(M) {
      if (M === void 0 && (M = "milliseconds"), !this.isValid)
        return NaN;
      var h12 = this.start.startOf(M), y = this.end.startOf(M);
      return Math.floor(y.diff(h12, M).get(M)) + 1;
    }, m.hasSame = function(M) {
      return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, M) : false;
    }, m.isEmpty = function() {
      return this.s.valueOf() === this.e.valueOf();
    }, m.isAfter = function(M) {
      return this.isValid ? this.s > M : false;
    }, m.isBefore = function(M) {
      return this.isValid ? this.e <= M : false;
    }, m.contains = function(M) {
      return this.isValid ? this.s <= M && this.e > M : false;
    }, m.set = function(M) {
      var h12 = M === void 0 ? {} : M, y = h12.start, U = h12.end;
      return this.isValid ? O.fromDateTimes(y || this.s, U || this.e) : this;
    }, m.splitAt = function() {
      var M = this;
      if (!this.isValid)
        return [];
      for (var h12 = arguments.length, y = new Array(h12), U = 0; U < h12; U++)
        y[U] = arguments[U];
      for (var V = y.map(ou).filter(function(Ze) {
        return M.contains(Ze);
      }).sort(), J = [], pe = this.s, ge = 0; pe < this.e; ) {
        var qe = V[ge] || this.e, Ce = +qe > +this.e ? this.e : qe;
        J.push(O.fromDateTimes(pe, Ce)), pe = Ce, ge += 1;
      }
      return J;
    }, m.splitBy = function(M) {
      var h12 = ut.fromDurationLike(M);
      if (!this.isValid || !h12.isValid || h12.as("milliseconds") === 0)
        return [];
      for (var y = this.s, U = 1, V, J = []; y < this.e; ) {
        var pe = this.start.plus(h12.mapUnits(function(ge) {
          return ge * U;
        }));
        V = +pe > +this.e ? this.e : pe, J.push(O.fromDateTimes(y, V)), y = V, U += 1;
      }
      return J;
    }, m.divideEqually = function(M) {
      return this.isValid ? this.splitBy(this.length() / M).slice(0, M) : [];
    }, m.overlaps = function(M) {
      return this.e > M.s && this.s < M.e;
    }, m.abutsStart = function(M) {
      return this.isValid ? +this.e == +M.s : false;
    }, m.abutsEnd = function(M) {
      return this.isValid ? +M.e == +this.s : false;
    }, m.engulfs = function(M) {
      return this.isValid ? this.s <= M.s && this.e >= M.e : false;
    }, m.equals = function(M) {
      return !this.isValid || !M.isValid ? false : this.s.equals(M.s) && this.e.equals(M.e);
    }, m.intersection = function(M) {
      if (!this.isValid)
        return this;
      var h12 = this.s > M.s ? this.s : M.s, y = this.e < M.e ? this.e : M.e;
      return h12 >= y ? null : O.fromDateTimes(h12, y);
    }, m.union = function(M) {
      if (!this.isValid)
        return this;
      var h12 = this.s < M.s ? this.s : M.s, y = this.e > M.e ? this.e : M.e;
      return O.fromDateTimes(h12, y);
    }, O.merge = function(M) {
      var h12 = M.sort(function(V, J) {
        return V.s - J.s;
      }).reduce(function(V, J) {
        var pe = V[0], ge = V[1];
        return ge ? ge.overlaps(J) || ge.abutsStart(J) ? [pe, ge.union(J)] : [pe.concat([ge]), J] : [pe, J];
      }, [[], null]), y = h12[0], U = h12[1];
      return U && y.push(U), y;
    }, O.xor = function(M) {
      for (var h12, y = null, U = 0, V = [], J = M.map(function(O0) {
        return [{
          time: O0.s,
          type: "s"
        }, {
          time: O0.e,
          type: "e"
        }];
      }), pe = (h12 = Array.prototype).concat.apply(h12, J), ge = pe.sort(function(O0, F0) {
        return O0.time - F0.time;
      }), qe = d(ge), Ce; !(Ce = qe()).done; ) {
        var Ze = Ce.value;
        U += Ze.type === "s" ? 1 : -1, U === 1 ? y = Ze.time : (y && +y != +Ze.time && V.push(O.fromDateTimes(y, Ze.time)), y = null);
      }
      return O.merge(V);
    }, m.difference = function() {
      for (var M = this, h12 = arguments.length, y = new Array(h12), U = 0; U < h12; U++)
        y[U] = arguments[U];
      return O.xor([this].concat(y)).map(function(V) {
        return M.intersection(V);
      }).filter(function(V) {
        return V && !V.isEmpty();
      });
    }, m.toString = function() {
      return this.isValid ? "[" + this.s.toISO() + " – " + this.e.toISO() + ")" : eu;
    }, m.toISO = function(M) {
      return this.isValid ? this.s.toISO(M) + "/" + this.e.toISO(M) : eu;
    }, m.toISODate = function() {
      return this.isValid ? this.s.toISODate() + "/" + this.e.toISODate() : eu;
    }, m.toISOTime = function(M) {
      return this.isValid ? this.s.toISOTime(M) + "/" + this.e.toISOTime(M) : eu;
    }, m.toFormat = function(M, h12) {
      var y = h12 === void 0 ? {} : h12, U = y.separator, V = U === void 0 ? " – " : U;
      return this.isValid ? "" + this.s.toFormat(M) + V + this.e.toFormat(M) : eu;
    }, m.toDuration = function(M, h12) {
      return this.isValid ? this.e.diff(this.s, M, h12) : ut.invalid(this.invalidReason);
    }, m.mapEndpoints = function(M) {
      return O.fromDateTimes(M(this.s), M(this.e));
    }, e(O, [{
      key: "start",
      get: function() {
        return this.isValid ? this.s : null;
      }
      /**
       * Returns the end of the Interval
       * @type {DateTime}
       */
    }, {
      key: "end",
      get: function() {
        return this.isValid ? this.e : null;
      }
      /**
       * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
       * @type {boolean}
       */
    }, {
      key: "isValid",
      get: function() {
        return this.invalidReason === null;
      }
      /**
       * Returns an error code if this Interval is invalid, or null if the Interval is valid
       * @type {string}
       */
    }, {
      key: "invalidReason",
      get: function() {
        return this.invalid ? this.invalid.reason : null;
      }
      /**
       * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
       * @type {string}
       */
    }, {
      key: "invalidExplanation",
      get: function() {
        return this.invalid ? this.invalid.explanation : null;
      }
    }]), O;
  })(), ru = /* @__PURE__ */ (function() {
    function O() {
    }
    return O.hasDST = function(A) {
      A === void 0 && (A = N1.defaultZone);
      var M = w1.now().setZone(A).set({
        month: 12
      });
      return !A.isUniversal && M.offset !== M.set({
        month: 6
      }).offset;
    }, O.isValidIANAZone = function(A) {
      return S1.isValidZone(A);
    }, O.normalizeZone = function(A) {
      return Lr(A, N1.defaultZone);
    }, O.months = function(A, M) {
      A === void 0 && (A = "long");
      var h12 = M === void 0 ? {} : M, y = h12.locale, U = y === void 0 ? null : y, V = h12.numberingSystem, J = V === void 0 ? null : V, pe = h12.locObj, ge = pe === void 0 ? null : pe, qe = h12.outputCalendar, Ce = qe === void 0 ? "gregory" : qe;
      return (ge || rt.create(U, J, Ce)).months(A);
    }, O.monthsFormat = function(A, M) {
      A === void 0 && (A = "long");
      var h12 = M === void 0 ? {} : M, y = h12.locale, U = y === void 0 ? null : y, V = h12.numberingSystem, J = V === void 0 ? null : V, pe = h12.locObj, ge = pe === void 0 ? null : pe, qe = h12.outputCalendar, Ce = qe === void 0 ? "gregory" : qe;
      return (ge || rt.create(U, J, Ce)).months(A, true);
    }, O.weekdays = function(A, M) {
      A === void 0 && (A = "long");
      var h12 = M === void 0 ? {} : M, y = h12.locale, U = y === void 0 ? null : y, V = h12.numberingSystem, J = V === void 0 ? null : V, pe = h12.locObj, ge = pe === void 0 ? null : pe;
      return (ge || rt.create(U, J, null)).weekdays(A);
    }, O.weekdaysFormat = function(A, M) {
      A === void 0 && (A = "long");
      var h12 = M === void 0 ? {} : M, y = h12.locale, U = y === void 0 ? null : y, V = h12.numberingSystem, J = V === void 0 ? null : V, pe = h12.locObj, ge = pe === void 0 ? null : pe;
      return (ge || rt.create(U, J, null)).weekdays(A, true);
    }, O.meridiems = function(A) {
      var M = A === void 0 ? {} : A, h12 = M.locale, y = h12 === void 0 ? null : h12;
      return rt.create(y).meridiems();
    }, O.eras = function(A, M) {
      A === void 0 && (A = "short");
      var h12 = M === void 0 ? {} : M, y = h12.locale, U = y === void 0 ? null : y;
      return rt.create(U, null, "gregory").eras(A);
    }, O.features = function() {
      return {
        relative: Me()
      };
    }, O;
  })();
  function G1e(O, m) {
    var A = function(y) {
      return y.toUTC(0, {
        keepLocalTime: true
      }).startOf("day").valueOf();
    }, M = A(m) - A(O);
    return Math.floor(ut.fromMillis(M).as("days"));
  }
  function XQe(O, m, A) {
    for (var M = [["years", function(F0, X0) {
      return X0.year - F0.year;
    }], ["quarters", function(F0, X0) {
      return X0.quarter - F0.quarter;
    }], ["months", function(F0, X0) {
      return X0.month - F0.month + (X0.year - F0.year) * 12;
    }], ["weeks", function(F0, X0) {
      var M0 = G1e(F0, X0);
      return (M0 - M0 % 7) / 7;
    }], ["days", G1e]], h12 = {}, y, U, V = 0, J = M; V < J.length; V++) {
      var pe = J[V], ge = pe[0], qe = pe[1];
      if (A.indexOf(ge) >= 0) {
        var Ce;
        y = ge;
        var Ze = qe(O, m);
        if (U = O.plus((Ce = {}, Ce[ge] = Ze, Ce)), U > m) {
          var O0;
          O = O.plus((O0 = {}, O0[ge] = Ze - 1, O0)), Ze -= 1;
        } else
          O = U;
        h12[ge] = Ze;
      }
    }
    return [O, h12, U, y];
  }
  function $Qe(O, m, A, M) {
    var h12 = XQe(O, m, A), y = h12[0], U = h12[1], V = h12[2], J = h12[3], pe = m - y, ge = A.filter(function(O0) {
      return ["hours", "minutes", "seconds", "milliseconds"].indexOf(O0) >= 0;
    });
    if (ge.length === 0) {
      if (V < m) {
        var qe;
        V = y.plus((qe = {}, qe[J] = 1, qe));
      }
      V !== y && (U[J] = (U[J] || 0) + pe / (V - y));
    }
    var Ce = ut.fromObject(U, M);
    if (ge.length > 0) {
      var Ze;
      return (Ze = ut.fromMillis(pe, M)).shiftTo.apply(Ze, ge).plus(Ce);
    } else
      return Ce;
  }
  var _d = {
    arab: "[٠-٩]",
    arabext: "[۰-۹]",
    bali: "[᭐-᭙]",
    beng: "[০-৯]",
    deva: "[०-९]",
    fullwide: "[０-９]",
    gujr: "[૦-૯]",
    hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
    khmr: "[០-៩]",
    knda: "[೦-೯]",
    laoo: "[໐-໙]",
    limb: "[᥆-᥏]",
    mlym: "[൦-൯]",
    mong: "[᠐-᠙]",
    mymr: "[၀-၉]",
    orya: "[୦-୯]",
    tamldec: "[௦-௯]",
    telu: "[౦-౯]",
    thai: "[๐-๙]",
    tibt: "[༠-༩]",
    latn: "\\d"
  }, Y1e = {
    arab: [1632, 1641],
    arabext: [1776, 1785],
    bali: [6992, 7001],
    beng: [2534, 2543],
    deva: [2406, 2415],
    fullwide: [65296, 65303],
    gujr: [2790, 2799],
    khmr: [6112, 6121],
    knda: [3302, 3311],
    laoo: [3792, 3801],
    limb: [6470, 6479],
    mlym: [3430, 3439],
    mong: [6160, 6169],
    mymr: [4160, 4169],
    orya: [2918, 2927],
    tamldec: [3046, 3055],
    telu: [3174, 3183],
    thai: [3664, 3673],
    tibt: [3872, 3881]
  }, GQe = _d.hanidec.replace(/[\[|\]]/g, "").split("");
  function YQe(O) {
    var m = parseInt(O, 10);
    if (isNaN(m)) {
      m = "";
      for (var A = 0; A < O.length; A++) {
        var M = O.charCodeAt(A);
        if (O[A].search(_d.hanidec) !== -1)
          m += GQe.indexOf(O[A]);
        else
          for (var h12 in Y1e) {
            var y = Y1e[h12], U = y[0], V = y[1];
            M >= U && M <= V && (m += M - U);
          }
      }
      return parseInt(m, 10);
    } else
      return m;
  }
  function Pr(O, m) {
    var A = O.numberingSystem;
    return m === void 0 && (m = ""), new RegExp("" + _d[A || "latn"] + m);
  }
  var JQe = "missing Intl.DateTimeFormat.formatToParts support";
  function J0(O, m) {
    return m === void 0 && (m = function(M) {
      return M;
    }), {
      regex: O,
      deser: function(M) {
        var h12 = M[0];
        return m(YQe(h12));
      }
    };
  }
  var KQe = " ", J1e = "( |" + KQe + ")", K1e = new RegExp(J1e, "g");
  function QQe(O) {
    return O.replace(/\./g, "\\.?").replace(K1e, J1e);
  }
  function Q1e(O) {
    return O.replace(/\./g, "").replace(K1e, " ").toLowerCase();
  }
  function Dr(O, m) {
    return O === null ? null : {
      regex: RegExp(O.map(QQe).join("|")),
      deser: function(M) {
        var h12 = M[0];
        return O.findIndex(function(y) {
          return Q1e(h12) === Q1e(y);
        }) + m;
      }
    };
  }
  function Z1e(O, m) {
    return {
      regex: O,
      deser: function(M) {
        var h12 = M[1], y = M[2];
        return Ue(h12, y);
      },
      groups: m
    };
  }
  function hd(O) {
    return {
      regex: O,
      deser: function(A) {
        var M = A[0];
        return M;
      }
    };
  }
  function ZQe(O) {
    return O.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
  }
  function eZe(O, m) {
    var A = Pr(m), M = Pr(m, "{2}"), h12 = Pr(m, "{3}"), y = Pr(m, "{4}"), U = Pr(m, "{6}"), V = Pr(m, "{1,2}"), J = Pr(m, "{1,3}"), pe = Pr(m, "{1,6}"), ge = Pr(m, "{1,9}"), qe = Pr(m, "{2,4}"), Ce = Pr(m, "{4,6}"), Ze = function(M0) {
      return {
        regex: RegExp(ZQe(M0.val)),
        deser: function(el) {
          var Sd = el[0];
          return Sd;
        },
        literal: true
      };
    }, O0 = function(M0) {
      if (O.literal)
        return Ze(M0);
      switch (M0.val) {
        case "G":
          return Dr(m.eras("short", false), 0);
        case "GG":
          return Dr(m.eras("long", false), 0);
        case "y":
          return J0(pe);
        case "yy":
          return J0(qe, Zt);
        case "yyyy":
          return J0(y);
        case "yyyyy":
          return J0(Ce);
        case "yyyyyy":
          return J0(U);
        case "M":
          return J0(V);
        case "MM":
          return J0(M);
        case "MMM":
          return Dr(m.months("short", true, false), 1);
        case "MMMM":
          return Dr(m.months("long", true, false), 1);
        case "L":
          return J0(V);
        case "LL":
          return J0(M);
        case "LLL":
          return Dr(m.months("short", false, false), 1);
        case "LLLL":
          return Dr(m.months("long", false, false), 1);
        case "d":
          return J0(V);
        case "dd":
          return J0(M);
        case "o":
          return J0(J);
        case "ooo":
          return J0(h12);
        case "HH":
          return J0(M);
        case "H":
          return J0(V);
        case "hh":
          return J0(M);
        case "h":
          return J0(V);
        case "mm":
          return J0(M);
        case "m":
          return J0(V);
        case "q":
          return J0(V);
        case "qq":
          return J0(M);
        case "s":
          return J0(V);
        case "ss":
          return J0(M);
        case "S":
          return J0(J);
        case "SSS":
          return J0(h12);
        case "u":
          return hd(ge);
        case "uu":
          return hd(V);
        case "uuu":
          return J0(A);
        case "a":
          return Dr(m.meridiems(), 0);
        case "kkkk":
          return J0(y);
        case "kk":
          return J0(qe, Zt);
        case "W":
          return J0(V);
        case "WW":
          return J0(M);
        case "E":
        case "c":
          return J0(A);
        case "EEE":
          return Dr(m.weekdays("short", false, false), 1);
        case "EEEE":
          return Dr(m.weekdays("long", false, false), 1);
        case "ccc":
          return Dr(m.weekdays("short", true, false), 1);
        case "cccc":
          return Dr(m.weekdays("long", true, false), 1);
        case "Z":
        case "ZZ":
          return Z1e(new RegExp("([+-]" + V.source + ")(?::(" + M.source + "))?"), 2);
        case "ZZZ":
          return Z1e(new RegExp("([+-]" + V.source + ")(" + M.source + ")?"), 2);
        case "z":
          return hd(/[a-z_+-/]{1,256}?/i);
        default:
          return Ze(M0);
      }
    }, F0 = O0(O) || {
      invalidReason: JQe
    };
    return F0.token = O, F0;
  }
  var tZe = {
    year: {
      "2-digit": "yy",
      numeric: "yyyyy"
    },
    month: {
      numeric: "M",
      "2-digit": "MM",
      short: "MMM",
      long: "MMMM"
    },
    day: {
      numeric: "d",
      "2-digit": "dd"
    },
    weekday: {
      short: "EEE",
      long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour: {
      numeric: "h",
      "2-digit": "hh"
    },
    minute: {
      numeric: "m",
      "2-digit": "mm"
    },
    second: {
      numeric: "s",
      "2-digit": "ss"
    }
  };
  function rZe(O, m, A) {
    var M = O.type, h12 = O.value;
    if (M === "literal")
      return {
        literal: true,
        val: h12
      };
    var y = A[M], U = tZe[M];
    if (typeof U == "object" && (U = U[y]), U)
      return {
        literal: false,
        val: U
      };
  }
  function nZe(O) {
    var m = O.map(function(A) {
      return A.regex;
    }).reduce(function(A, M) {
      return A + "(" + M.source + ")";
    }, "");
    return ["^" + m + "$", O];
  }
  function aZe(O, m, A) {
    var M = O.match(m);
    if (M) {
      var h12 = {}, y = 1;
      for (var U in A)
        if (Ne(A, U)) {
          var V = A[U], J = V.groups ? V.groups + 1 : 1;
          !V.literal && V.token && (h12[V.token.val[0]] = V.deser(M.slice(y, y + J))), y += J;
        }
      return [M, h12];
    } else
      return [M, {}];
  }
  function oZe(O) {
    var m = function(U) {
      switch (U) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
        case "H":
          return "hour";
        case "d":
          return "day";
        case "o":
          return "ordinal";
        case "L":
        case "M":
          return "month";
        case "y":
          return "year";
        case "E":
        case "c":
          return "weekday";
        case "W":
          return "weekNumber";
        case "k":
          return "weekYear";
        case "q":
          return "quarter";
        default:
          return null;
      }
    }, A = null, M;
    le(O.z) || (A = S1.create(O.z)), le(O.Z) || (A || (A = new it(O.Z)), M = O.Z), le(O.q) || (O.M = (O.q - 1) * 3 + 1), le(O.h) || (O.h < 12 && O.a === 1 ? O.h += 12 : O.h === 12 && O.a === 0 && (O.h = 0)), O.G === 0 && O.y && (O.y = -O.y), le(O.u) || (O.S = I0(O.u));
    var h12 = Object.keys(O).reduce(function(y, U) {
      var V = m(U);
      return V && (y[V] = O[U]), y;
    }, {});
    return [h12, A, M];
  }
  var vd = null;
  function iZe() {
    return vd || (vd = w1.fromMillis(1555555555555)), vd;
  }
  function uZe(O, m) {
    if (O.literal)
      return O;
    var A = pr.macroTokenToFormatOpts(O.val);
    if (!A)
      return O;
    var M = pr.create(m, A), h12 = M.formatDateTimeParts(iZe()), y = h12.map(function(U) {
      return rZe(U, m, A);
    });
    return y.includes(void 0) ? O : y;
  }
  function sZe(O, m) {
    var A;
    return (A = Array.prototype).concat.apply(A, O.map(function(M) {
      return uZe(M, m);
    }));
  }
  function ete(O, m, A) {
    var M = sZe(pr.parseFormat(A), O), h12 = M.map(function(M0) {
      return eZe(M0, O);
    }), y = h12.find(function(M0) {
      return M0.invalidReason;
    });
    if (y)
      return {
        input: m,
        tokens: M,
        invalidReason: y.invalidReason
      };
    var U = nZe(h12), V = U[0], J = U[1], pe = RegExp(V, "i"), ge = aZe(m, pe, J), qe = ge[0], Ce = ge[1], Ze = Ce ? oZe(Ce) : [null, null, void 0], O0 = Ze[0], F0 = Ze[1], X0 = Ze[2];
    if (Ne(Ce, "a") && Ne(Ce, "H"))
      throw new S("Can't include meridiem when specifying 24-hour format");
    return {
      input: m,
      tokens: M,
      regex: pe,
      rawMatches: qe,
      matches: Ce,
      result: O0,
      zone: F0,
      specificOffset: X0
    };
  }
  function cZe(O, m, A) {
    var M = ete(O, m, A), h12 = M.result, y = M.zone, U = M.specificOffset, V = M.invalidReason;
    return [h12, y, U, V];
  }
  var tte = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], rte = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
  function fr(O, m) {
    return new Nt("unit out of range", "you specified " + m + " (of type " + typeof m + ") as a " + O + ", which is invalid");
  }
  function nte(O, m, A) {
    var M = new Date(Date.UTC(O, m - 1, A));
    O < 100 && O >= 0 && M.setUTCFullYear(M.getUTCFullYear() - 1900);
    var h12 = M.getUTCDay();
    return h12 === 0 ? 7 : h12;
  }
  function ate(O, m, A) {
    return A + (P1(O) ? rte : tte)[m - 1];
  }
  function ote(O, m) {
    var A = P1(O) ? rte : tte, M = A.findIndex(function(y) {
      return y < m;
    }), h12 = m - A[M];
    return {
      month: M + 1,
      day: h12
    };
  }
  function md(O) {
    var m = O.year, A = O.month, M = O.day, h12 = ate(m, A, M), y = nte(m, A, M), U = Math.floor((h12 - y + 10) / 7), V;
    return U < 1 ? (V = m - 1, U = Wt(V)) : U > Wt(m) ? (V = m + 1, U = 1) : V = m, r12({
      weekYear: V,
      weekNumber: U,
      weekday: y
    }, s1(O));
  }
  function ite(O) {
    var m = O.weekYear, A = O.weekNumber, M = O.weekday, h12 = nte(m, 1, 4), y = x0(m), U = A * 7 + M - h12 - 3, V;
    U < 1 ? (V = m - 1, U += x0(V)) : U > y ? (V = m + 1, U -= x0(m)) : V = m;
    var J = ote(V, U), pe = J.month, ge = J.day;
    return r12({
      year: V,
      month: pe,
      day: ge
    }, s1(O));
  }
  function Rd(O) {
    var m = O.year, A = O.month, M = O.day, h12 = ate(m, A, M);
    return r12({
      year: m,
      ordinal: h12
    }, s1(O));
  }
  function ute(O) {
    var m = O.year, A = O.ordinal, M = ote(m, A), h12 = M.month, y = M.day;
    return r12({
      year: m,
      month: h12,
      day: y
    }, s1(O));
  }
  function lZe(O) {
    var m = H(O.weekYear), A = Ye(O.weekNumber, 1, Wt(O.weekYear)), M = Ye(O.weekday, 1, 7);
    return m ? A ? M ? false : fr("weekday", O.weekday) : fr("week", O.week) : fr("weekYear", O.weekYear);
  }
  function pZe(O) {
    var m = H(O.year), A = Ye(O.ordinal, 1, x0(O.year));
    return m ? A ? false : fr("ordinal", O.ordinal) : fr("year", O.year);
  }
  function ste(O) {
    var m = H(O.year), A = Ye(O.month, 1, 12), M = Ye(O.day, 1, Mt(O.year, O.month));
    return m ? A ? M ? false : fr("day", O.day) : fr("month", O.month) : fr("year", O.year);
  }
  function cte(O) {
    var m = O.hour, A = O.minute, M = O.second, h12 = O.millisecond, y = Ye(m, 0, 23) || m === 24 && A === 0 && M === 0 && h12 === 0, U = Ye(A, 0, 59), V = Ye(M, 0, 59), J = Ye(h12, 0, 999);
    return y ? U ? V ? J ? false : fr("millisecond", h12) : fr("second", M) : fr("minute", A) : fr("hour", m);
  }
  var qd = "Invalid DateTime", lte = 864e13;
  function Kc(O) {
    return new Nt("unsupported zone", 'the zone "' + O.name + '" is not supported');
  }
  function Td(O) {
    return O.weekData === null && (O.weekData = md(O.c)), O.weekData;
  }
  function nu(O, m) {
    var A = {
      ts: O.ts,
      zone: O.zone,
      c: O.c,
      o: O.o,
      loc: O.loc,
      invalid: O.invalid
    };
    return new w1(r12({}, A, m, {
      old: A
    }));
  }
  function pte(O, m, A) {
    var M = O - m * 60 * 1e3, h12 = A.offset(M);
    if (m === h12)
      return [M, m];
    M -= (h12 - m) * 60 * 1e3;
    var y = A.offset(M);
    return h12 === y ? [M, h12] : [O - Math.min(h12, y) * 60 * 1e3, Math.max(h12, y)];
  }
  function dte(O, m) {
    O += m * 60 * 1e3;
    var A = new Date(O);
    return {
      year: A.getUTCFullYear(),
      month: A.getUTCMonth() + 1,
      day: A.getUTCDate(),
      hour: A.getUTCHours(),
      minute: A.getUTCMinutes(),
      second: A.getUTCSeconds(),
      millisecond: A.getUTCMilliseconds()
    };
  }
  function Qc(O, m, A) {
    return pte(H1(O), m, A);
  }
  function fte(O, m) {
    var A = O.o, M = O.c.year + Math.trunc(m.years), h12 = O.c.month + Math.trunc(m.months) + Math.trunc(m.quarters) * 3, y = r12({}, O.c, {
      year: M,
      month: h12,
      day: Math.min(O.c.day, Mt(M, h12)) + Math.trunc(m.days) + Math.trunc(m.weeks) * 7
    }), U = ut.fromObject({
      years: m.years - Math.trunc(m.years),
      quarters: m.quarters - Math.trunc(m.quarters),
      months: m.months - Math.trunc(m.months),
      weeks: m.weeks - Math.trunc(m.weeks),
      days: m.days - Math.trunc(m.days),
      hours: m.hours,
      minutes: m.minutes,
      seconds: m.seconds,
      milliseconds: m.milliseconds
    }).as("milliseconds"), V = H1(y), J = pte(V, A, O.zone), pe = J[0], ge = J[1];
    return U !== 0 && (pe += U, ge = O.zone.offset(pe)), {
      ts: pe,
      o: ge
    };
  }
  function au(O, m, A, M, h12, y) {
    var U = A.setZone, V = A.zone;
    if (O && Object.keys(O).length !== 0) {
      var J = m || V, pe = w1.fromObject(O, r12({}, A, {
        zone: J,
        specificOffset: y
      }));
      return U ? pe : pe.setZone(V);
    } else
      return w1.invalid(new Nt("unparsable", 'the input "' + h12 + `" can't be parsed as ` + M));
  }
  function Zc(O, m, A) {
    return A === void 0 && (A = true), O.isValid ? pr.create(rt.create("en-US"), {
      allowZ: A,
      forceSimple: true
    }).formatDateTimeFromString(O, m) : null;
  }
  function yd(O, m) {
    var A = O.c.year > 9999 || O.c.year < 0, M = "";
    return A && O.c.year >= 0 && (M += "+"), M += Be(O.c.year, A ? 6 : 4), m ? (M += "-", M += Be(O.c.month), M += "-", M += Be(O.c.day)) : (M += Be(O.c.month), M += Be(O.c.day)), M;
  }
  function bte(O, m, A, M, h12) {
    var y = Be(O.c.hour);
    return m ? (y += ":", y += Be(O.c.minute), (O.c.second !== 0 || !A) && (y += ":")) : y += Be(O.c.minute), (O.c.second !== 0 || !A) && (y += Be(O.c.second), (O.c.millisecond !== 0 || !M) && (y += ".", y += Be(O.c.millisecond, 3))), h12 && (O.isOffsetFixed && O.offset === 0 ? y += "Z" : O.o < 0 ? (y += "-", y += Be(Math.trunc(-O.o / 60)), y += ":", y += Be(Math.trunc(-O.o % 60))) : (y += "+", y += Be(Math.trunc(O.o / 60)), y += ":", y += Be(Math.trunc(O.o % 60)))), y;
  }
  var Mte = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  }, dZe = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  }, fZe = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  }, Ote = ["year", "month", "day", "hour", "minute", "second", "millisecond"], bZe = ["weekYear", "weekNumber", "weekday", "hour", "minute", "second", "millisecond"], MZe = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
  function zte(O) {
    var m = {
      year: "year",
      years: "year",
      month: "month",
      months: "month",
      day: "day",
      days: "day",
      hour: "hour",
      hours: "hour",
      minute: "minute",
      minutes: "minute",
      quarter: "quarter",
      quarters: "quarter",
      second: "second",
      seconds: "second",
      millisecond: "millisecond",
      milliseconds: "millisecond",
      weekday: "weekday",
      weekdays: "weekday",
      weeknumber: "weekNumber",
      weeksnumber: "weekNumber",
      weeknumbers: "weekNumber",
      weekyear: "weekYear",
      weekyears: "weekYear",
      ordinal: "ordinal"
    }[O.toLowerCase()];
    if (!m)
      throw new N(O);
    return m;
  }
  function Ate(O, m) {
    var A = Lr(m.zone, N1.defaultZone), M = rt.fromObject(m), h12 = N1.now(), y, U;
    if (le(O.year))
      y = h12;
    else {
      for (var V = d(Ote), J; !(J = V()).done; ) {
        var pe = J.value;
        le(O[pe]) && (O[pe] = Mte[pe]);
      }
      var ge = ste(O) || cte(O);
      if (ge)
        return w1.invalid(ge);
      var qe = A.offset(h12), Ce = Qc(O, qe, A);
      y = Ce[0], U = Ce[1];
    }
    return new w1({
      ts: y,
      zone: A,
      loc: M,
      o: U
    });
  }
  function _te(O, m, A) {
    var M = le(A.round) ? true : A.round, h12 = function(qe, Ce) {
      qe = b0(qe, M || A.calendary ? 0 : 2, true);
      var Ze = m.loc.clone(A).relFormatter(A);
      return Ze.format(qe, Ce);
    }, y = function(qe) {
      return A.calendary ? m.hasSame(O, qe) ? 0 : m.startOf(qe).diff(O.startOf(qe), qe).get(qe) : m.diff(O, qe).get(qe);
    };
    if (A.unit)
      return h12(y(A.unit), A.unit);
    for (var U = d(A.units), V; !(V = U()).done; ) {
      var J = V.value, pe = y(J);
      if (Math.abs(pe) >= 1)
        return h12(pe, J);
    }
    return h12(O > m ? -0 : 0, A.units[A.units.length - 1]);
  }
  function hte(O) {
    var m = {}, A;
    return O.length > 0 && typeof O[O.length - 1] == "object" ? (m = O[O.length - 1], A = Array.from(O).slice(0, O.length - 1)) : A = Array.from(O), [m, A];
  }
  var w1 = /* @__PURE__ */ (function() {
    function O(A) {
      var M = A.zone || N1.defaultZone, h12 = A.invalid || (Number.isNaN(A.ts) ? new Nt("invalid input") : null) || (M.isValid ? null : Kc(M));
      this.ts = le(A.ts) ? N1.now() : A.ts;
      var y = null, U = null;
      if (!h12) {
        var V = A.old && A.old.ts === this.ts && A.old.zone.equals(M);
        if (V) {
          var J = [A.old.c, A.old.o];
          y = J[0], U = J[1];
        } else {
          var pe = M.offset(this.ts);
          y = dte(this.ts, pe), h12 = Number.isNaN(y.year) ? new Nt("invalid input") : null, y = h12 ? null : y, U = h12 ? null : pe;
        }
      }
      this._zone = M, this.loc = A.loc || rt.create(), this.invalid = h12, this.weekData = null, this.c = y, this.o = U, this.isLuxonDateTime = true;
    }
    O.now = function() {
      return new O({});
    }, O.local = function() {
      var M = hte(arguments), h12 = M[0], y = M[1], U = y[0], V = y[1], J = y[2], pe = y[3], ge = y[4], qe = y[5], Ce = y[6];
      return Ate({
        year: U,
        month: V,
        day: J,
        hour: pe,
        minute: ge,
        second: qe,
        millisecond: Ce
      }, h12);
    }, O.utc = function() {
      var M = hte(arguments), h12 = M[0], y = M[1], U = y[0], V = y[1], J = y[2], pe = y[3], ge = y[4], qe = y[5], Ce = y[6];
      return h12.zone = it.utcInstance, Ate({
        year: U,
        month: V,
        day: J,
        hour: pe,
        minute: ge,
        second: qe,
        millisecond: Ce
      }, h12);
    }, O.fromJSDate = function(M, h12) {
      h12 === void 0 && (h12 = {});
      var y = ue(M) ? M.valueOf() : NaN;
      if (Number.isNaN(y))
        return O.invalid("invalid input");
      var U = Lr(h12.zone, N1.defaultZone);
      return U.isValid ? new O({
        ts: y,
        zone: U,
        loc: rt.fromObject(h12)
      }) : O.invalid(Kc(U));
    }, O.fromMillis = function(M, h12) {
      if (h12 === void 0 && (h12 = {}), Ae(M))
        return M < -lte || M > lte ? O.invalid("Timestamp out of range") : new O({
          ts: M,
          zone: Lr(h12.zone, N1.defaultZone),
          loc: rt.fromObject(h12)
        });
      throw new v("fromMillis requires a numerical input, but received a " + typeof M + " with value " + M);
    }, O.fromSeconds = function(M, h12) {
      if (h12 === void 0 && (h12 = {}), Ae(M))
        return new O({
          ts: M * 1e3,
          zone: Lr(h12.zone, N1.defaultZone),
          loc: rt.fromObject(h12)
        });
      throw new v("fromSeconds requires a numerical input");
    }, O.fromObject = function(M, h12) {
      h12 === void 0 && (h12 = {}), M = M || {};
      var y = Lr(h12.zone, N1.defaultZone);
      if (!y.isValid)
        return O.invalid(Kc(y));
      var U = N1.now(), V = le(h12.specificOffset) ? y.offset(U) : h12.specificOffset, J = W0(M, zte), pe = !le(J.ordinal), ge = !le(J.year), qe = !le(J.month) || !le(J.day), Ce = ge || qe, Ze = J.weekYear || J.weekNumber, O0 = rt.fromObject(h12);
      if ((Ce || pe) && Ze)
        throw new S("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
      if (qe && pe)
        throw new S("Can't mix ordinal dates with month/day");
      var F0 = Ze || J.weekday && !Ce, X0, M0, D1 = dte(U, V);
      F0 ? (X0 = bZe, M0 = dZe, D1 = md(D1)) : pe ? (X0 = MZe, M0 = fZe, D1 = Rd(D1)) : (X0 = Ote, M0 = Mte);
      for (var el = false, Sd = d(X0), vte; !(vte = Sd()).done; ) {
        var iu = vte.value, zZe = J[iu];
        le(zZe) ? el ? J[iu] = M0[iu] : J[iu] = D1[iu] : el = true;
      }
      var AZe = F0 ? lZe(J) : pe ? pZe(J) : ste(J), mte = AZe || cte(J);
      if (mte)
        return O.invalid(mte);
      var _Ze = F0 ? ite(J) : pe ? ute(J) : J, Rte = Qc(_Ze, V, y), hZe = Rte[0];
      Rte[1];
      var Cd = new O({
        ts: hZe,
        zone: y,
        loc: O0
      });
      return J.weekday && Ce && M.weekday !== Cd.weekday ? O.invalid("mismatched weekday", "you can't specify both a weekday of " + J.weekday + " and a date of " + Cd.toISO()) : Cd;
    }, O.fromISO = function(M, h12) {
      h12 === void 0 && (h12 = {});
      var y = CQe(M), U = y[0], V = y[1];
      return au(U, V, h12, "ISO 8601", M);
    }, O.fromRFC2822 = function(M, h12) {
      h12 === void 0 && (h12 = {});
      var y = gQe(M), U = y[0], V = y[1];
      return au(U, V, h12, "RFC 2822", M);
    }, O.fromHTTP = function(M, h12) {
      h12 === void 0 && (h12 = {});
      var y = IQe(M), U = y[0], V = y[1];
      return au(U, V, h12, "HTTP", h12);
    }, O.fromFormat = function(M, h12, y) {
      if (y === void 0 && (y = {}), le(M) || le(h12))
        throw new v("fromFormat requires an input string and a format");
      var U = y, V = U.locale, J = V === void 0 ? null : V, pe = U.numberingSystem, ge = pe === void 0 ? null : pe, qe = rt.fromOpts({
        locale: J,
        numberingSystem: ge,
        defaultToEN: true
      }), Ce = cZe(qe, M, h12), Ze = Ce[0], O0 = Ce[1], F0 = Ce[2], X0 = Ce[3];
      return X0 ? O.invalid(X0) : au(Ze, O0, y, "format " + h12, M, F0);
    }, O.fromString = function(M, h12, y) {
      return y === void 0 && (y = {}), O.fromFormat(M, h12, y);
    }, O.fromSQL = function(M, h12) {
      h12 === void 0 && (h12 = {});
      var y = BQe(M), U = y[0], V = y[1];
      return au(U, V, h12, "SQL", M);
    }, O.invalid = function(M, h12) {
      if (h12 === void 0 && (h12 = null), !M)
        throw new v("need to specify a reason the DateTime is invalid");
      var y = M instanceof Nt ? M : new Nt(M, h12);
      if (N1.throwOnInvalid)
        throw new z(y);
      return new O({
        invalid: y
      });
    }, O.isDateTime = function(M) {
      return M && M.isLuxonDateTime || false;
    };
    var m = O.prototype;
    return m.get = function(M) {
      return this[M];
    }, m.resolvedLocaleOptions = function(M) {
      M === void 0 && (M = {});
      var h12 = pr.create(this.loc.clone(M), M).resolvedOptions(this), y = h12.locale, U = h12.numberingSystem, V = h12.calendar;
      return {
        locale: y,
        numberingSystem: U,
        outputCalendar: V
      };
    }, m.toUTC = function(M, h12) {
      return M === void 0 && (M = 0), h12 === void 0 && (h12 = {}), this.setZone(it.instance(M), h12);
    }, m.toLocal = function() {
      return this.setZone(N1.defaultZone);
    }, m.setZone = function(M, h12) {
      var y = h12 === void 0 ? {} : h12, U = y.keepLocalTime, V = U === void 0 ? false : U, J = y.keepCalendarTime, pe = J === void 0 ? false : J;
      if (M = Lr(M, N1.defaultZone), M.equals(this.zone))
        return this;
      if (M.isValid) {
        var ge = this.ts;
        if (V || pe) {
          var qe = M.offset(this.ts), Ce = this.toObject(), Ze = Qc(Ce, qe, M);
          ge = Ze[0];
        }
        return nu(this, {
          ts: ge,
          zone: M
        });
      } else
        return O.invalid(Kc(M));
    }, m.reconfigure = function(M) {
      var h12 = M === void 0 ? {} : M, y = h12.locale, U = h12.numberingSystem, V = h12.outputCalendar, J = this.loc.clone({
        locale: y,
        numberingSystem: U,
        outputCalendar: V
      });
      return nu(this, {
        loc: J
      });
    }, m.setLocale = function(M) {
      return this.reconfigure({
        locale: M
      });
    }, m.set = function(M) {
      if (!this.isValid)
        return this;
      var h12 = W0(M, zte), y = !le(h12.weekYear) || !le(h12.weekNumber) || !le(h12.weekday), U = !le(h12.ordinal), V = !le(h12.year), J = !le(h12.month) || !le(h12.day), pe = V || J, ge = h12.weekYear || h12.weekNumber;
      if ((pe || U) && ge)
        throw new S("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
      if (J && U)
        throw new S("Can't mix ordinal dates with month/day");
      var qe;
      y ? qe = ite(r12({}, md(this.c), h12)) : le(h12.ordinal) ? (qe = r12({}, this.toObject(), h12), le(h12.day) && (qe.day = Math.min(Mt(qe.year, qe.month), qe.day))) : qe = ute(r12({}, Rd(this.c), h12));
      var Ce = Qc(qe, this.o, this.zone), Ze = Ce[0], O0 = Ce[1];
      return nu(this, {
        ts: Ze,
        o: O0
      });
    }, m.plus = function(M) {
      if (!this.isValid)
        return this;
      var h12 = ut.fromDurationLike(M);
      return nu(this, fte(this, h12));
    }, m.minus = function(M) {
      if (!this.isValid)
        return this;
      var h12 = ut.fromDurationLike(M).negate();
      return nu(this, fte(this, h12));
    }, m.startOf = function(M) {
      if (!this.isValid)
        return this;
      var h12 = {}, y = ut.normalizeUnit(M);
      switch (y) {
        case "years":
          h12.month = 1;
        case "quarters":
        case "months":
          h12.day = 1;
        case "weeks":
        case "days":
          h12.hour = 0;
        case "hours":
          h12.minute = 0;
        case "minutes":
          h12.second = 0;
        case "seconds":
          h12.millisecond = 0;
          break;
      }
      if (y === "weeks" && (h12.weekday = 1), y === "quarters") {
        var U = Math.ceil(this.month / 3);
        h12.month = (U - 1) * 3 + 1;
      }
      return this.set(h12);
    }, m.endOf = function(M) {
      var h12;
      return this.isValid ? this.plus((h12 = {}, h12[M] = 1, h12)).startOf(M).minus(1) : this;
    }, m.toFormat = function(M, h12) {
      return h12 === void 0 && (h12 = {}), this.isValid ? pr.create(this.loc.redefaultToEN(h12)).formatDateTimeFromString(this, M) : qd;
    }, m.toLocaleString = function(M, h12) {
      return M === void 0 && (M = j), h12 === void 0 && (h12 = {}), this.isValid ? pr.create(this.loc.clone(h12), M).formatDateTime(this) : qd;
    }, m.toLocaleParts = function(M) {
      return M === void 0 && (M = {}), this.isValid ? pr.create(this.loc.clone(M), M).formatDateTimeParts(this) : [];
    }, m.toISO = function(M) {
      var h12 = M === void 0 ? {} : M, y = h12.format, U = y === void 0 ? "extended" : y, V = h12.suppressSeconds, J = V === void 0 ? false : V, pe = h12.suppressMilliseconds, ge = pe === void 0 ? false : pe, qe = h12.includeOffset, Ce = qe === void 0 ? true : qe;
      if (!this.isValid)
        return null;
      var Ze = U === "extended", O0 = yd(this, Ze);
      return O0 += "T", O0 += bte(this, Ze, J, ge, Ce), O0;
    }, m.toISODate = function(M) {
      var h12 = M === void 0 ? {} : M, y = h12.format, U = y === void 0 ? "extended" : y;
      return this.isValid ? yd(this, U === "extended") : null;
    }, m.toISOWeekDate = function() {
      return Zc(this, "kkkk-'W'WW-c");
    }, m.toISOTime = function(M) {
      var h12 = M === void 0 ? {} : M, y = h12.suppressMilliseconds, U = y === void 0 ? false : y, V = h12.suppressSeconds, J = V === void 0 ? false : V, pe = h12.includeOffset, ge = pe === void 0 ? true : pe, qe = h12.includePrefix, Ce = qe === void 0 ? false : qe, Ze = h12.format, O0 = Ze === void 0 ? "extended" : Ze;
      if (!this.isValid)
        return null;
      var F0 = Ce ? "T" : "";
      return F0 + bte(this, O0 === "extended", J, U, ge);
    }, m.toRFC2822 = function() {
      return Zc(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    }, m.toHTTP = function() {
      return Zc(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    }, m.toSQLDate = function() {
      return this.isValid ? yd(this, true) : null;
    }, m.toSQLTime = function(M) {
      var h12 = M === void 0 ? {} : M, y = h12.includeOffset, U = y === void 0 ? true : y, V = h12.includeZone, J = V === void 0 ? false : V, pe = h12.includeOffsetSpace, ge = pe === void 0 ? true : pe, qe = "HH:mm:ss.SSS";
      return (J || U) && (ge && (qe += " "), J ? qe += "z" : U && (qe += "ZZ")), Zc(this, qe, true);
    }, m.toSQL = function(M) {
      return M === void 0 && (M = {}), this.isValid ? this.toSQLDate() + " " + this.toSQLTime(M) : null;
    }, m.toString = function() {
      return this.isValid ? this.toISO() : qd;
    }, m.valueOf = function() {
      return this.toMillis();
    }, m.toMillis = function() {
      return this.isValid ? this.ts : NaN;
    }, m.toSeconds = function() {
      return this.isValid ? this.ts / 1e3 : NaN;
    }, m.toUnixInteger = function() {
      return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
    }, m.toJSON = function() {
      return this.toISO();
    }, m.toBSON = function() {
      return this.toJSDate();
    }, m.toObject = function(M) {
      if (M === void 0 && (M = {}), !this.isValid)
        return {};
      var h12 = r12({}, this.c);
      return M.includeConfig && (h12.outputCalendar = this.outputCalendar, h12.numberingSystem = this.loc.numberingSystem, h12.locale = this.loc.locale), h12;
    }, m.toJSDate = function() {
      return new Date(this.isValid ? this.ts : NaN);
    }, m.diff = function(M, h12, y) {
      if (h12 === void 0 && (h12 = "milliseconds"), y === void 0 && (y = {}), !this.isValid || !M.isValid)
        return ut.invalid("created by diffing an invalid DateTime");
      var U = r12({
        locale: this.locale,
        numberingSystem: this.numberingSystem
      }, y), V = Se(h12).map(ut.normalizeUnit), J = M.valueOf() > this.valueOf(), pe = J ? this : M, ge = J ? M : this, qe = $Qe(pe, ge, V, U);
      return J ? qe.negate() : qe;
    }, m.diffNow = function(M, h12) {
      return M === void 0 && (M = "milliseconds"), h12 === void 0 && (h12 = {}), this.diff(O.now(), M, h12);
    }, m.until = function(M) {
      return this.isValid ? tu.fromDateTimes(this, M) : this;
    }, m.hasSame = function(M, h12) {
      if (!this.isValid)
        return false;
      var y = M.valueOf(), U = this.setZone(M.zone, {
        keepLocalTime: true
      });
      return U.startOf(h12) <= y && y <= U.endOf(h12);
    }, m.equals = function(M) {
      return this.isValid && M.isValid && this.valueOf() === M.valueOf() && this.zone.equals(M.zone) && this.loc.equals(M.loc);
    }, m.toRelative = function(M) {
      if (M === void 0 && (M = {}), !this.isValid)
        return null;
      var h12 = M.base || O.fromObject({}, {
        zone: this.zone
      }), y = M.padding ? this < h12 ? -M.padding : M.padding : 0, U = ["years", "months", "days", "hours", "minutes", "seconds"], V = M.unit;
      return Array.isArray(M.unit) && (U = M.unit, V = void 0), _te(h12, this.plus(y), r12({}, M, {
        numeric: "always",
        units: U,
        unit: V
      }));
    }, m.toRelativeCalendar = function(M) {
      return M === void 0 && (M = {}), this.isValid ? _te(M.base || O.fromObject({}, {
        zone: this.zone
      }), this, r12({}, M, {
        numeric: "auto",
        units: ["years", "months", "days"],
        calendary: true
      })) : null;
    }, O.min = function() {
      for (var M = arguments.length, h12 = new Array(M), y = 0; y < M; y++)
        h12[y] = arguments[y];
      if (!h12.every(O.isDateTime))
        throw new v("min requires all arguments be DateTimes");
      return $e(h12, function(U) {
        return U.valueOf();
      }, Math.min);
    }, O.max = function() {
      for (var M = arguments.length, h12 = new Array(M), y = 0; y < M; y++)
        h12[y] = arguments[y];
      if (!h12.every(O.isDateTime))
        throw new v("max requires all arguments be DateTimes");
      return $e(h12, function(U) {
        return U.valueOf();
      }, Math.max);
    }, O.fromFormatExplain = function(M, h12, y) {
      y === void 0 && (y = {});
      var U = y, V = U.locale, J = V === void 0 ? null : V, pe = U.numberingSystem, ge = pe === void 0 ? null : pe, qe = rt.fromOpts({
        locale: J,
        numberingSystem: ge,
        defaultToEN: true
      });
      return ete(qe, M, h12);
    }, O.fromStringExplain = function(M, h12, y) {
      return y === void 0 && (y = {}), O.fromFormatExplain(M, h12, y);
    }, e(O, [{
      key: "isValid",
      get: function() {
        return this.invalid === null;
      }
      /**
       * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
       * @type {string}
       */
    }, {
      key: "invalidReason",
      get: function() {
        return this.invalid ? this.invalid.reason : null;
      }
      /**
       * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
       * @type {string}
       */
    }, {
      key: "invalidExplanation",
      get: function() {
        return this.invalid ? this.invalid.explanation : null;
      }
      /**
       * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
       *
       * @type {string}
       */
    }, {
      key: "locale",
      get: function() {
        return this.isValid ? this.loc.locale : null;
      }
      /**
       * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
       *
       * @type {string}
       */
    }, {
      key: "numberingSystem",
      get: function() {
        return this.isValid ? this.loc.numberingSystem : null;
      }
      /**
       * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
       *
       * @type {string}
       */
    }, {
      key: "outputCalendar",
      get: function() {
        return this.isValid ? this.loc.outputCalendar : null;
      }
      /**
       * Get the time zone associated with this DateTime.
       * @type {Zone}
       */
    }, {
      key: "zone",
      get: function() {
        return this._zone;
      }
      /**
       * Get the name of the time zone.
       * @type {string}
       */
    }, {
      key: "zoneName",
      get: function() {
        return this.isValid ? this.zone.name : null;
      }
      /**
       * Get the year
       * @example DateTime.local(2017, 5, 25).year //=> 2017
       * @type {number}
       */
    }, {
      key: "year",
      get: function() {
        return this.isValid ? this.c.year : NaN;
      }
      /**
       * Get the quarter
       * @example DateTime.local(2017, 5, 25).quarter //=> 2
       * @type {number}
       */
    }, {
      key: "quarter",
      get: function() {
        return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
      }
      /**
       * Get the month (1-12).
       * @example DateTime.local(2017, 5, 25).month //=> 5
       * @type {number}
       */
    }, {
      key: "month",
      get: function() {
        return this.isValid ? this.c.month : NaN;
      }
      /**
       * Get the day of the month (1-30ish).
       * @example DateTime.local(2017, 5, 25).day //=> 25
       * @type {number}
       */
    }, {
      key: "day",
      get: function() {
        return this.isValid ? this.c.day : NaN;
      }
      /**
       * Get the hour of the day (0-23).
       * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
       * @type {number}
       */
    }, {
      key: "hour",
      get: function() {
        return this.isValid ? this.c.hour : NaN;
      }
      /**
       * Get the minute of the hour (0-59).
       * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
       * @type {number}
       */
    }, {
      key: "minute",
      get: function() {
        return this.isValid ? this.c.minute : NaN;
      }
      /**
       * Get the second of the minute (0-59).
       * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
       * @type {number}
       */
    }, {
      key: "second",
      get: function() {
        return this.isValid ? this.c.second : NaN;
      }
      /**
       * Get the millisecond of the second (0-999).
       * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
       * @type {number}
       */
    }, {
      key: "millisecond",
      get: function() {
        return this.isValid ? this.c.millisecond : NaN;
      }
      /**
       * Get the week year
       * @see https://en.wikipedia.org/wiki/ISO_week_date
       * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
       * @type {number}
       */
    }, {
      key: "weekYear",
      get: function() {
        return this.isValid ? Td(this).weekYear : NaN;
      }
      /**
       * Get the week number of the week year (1-52ish).
       * @see https://en.wikipedia.org/wiki/ISO_week_date
       * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
       * @type {number}
       */
    }, {
      key: "weekNumber",
      get: function() {
        return this.isValid ? Td(this).weekNumber : NaN;
      }
      /**
       * Get the day of the week.
       * 1 is Monday and 7 is Sunday
       * @see https://en.wikipedia.org/wiki/ISO_week_date
       * @example DateTime.local(2014, 11, 31).weekday //=> 4
       * @type {number}
       */
    }, {
      key: "weekday",
      get: function() {
        return this.isValid ? Td(this).weekday : NaN;
      }
      /**
       * Get the ordinal (meaning the day of the year)
       * @example DateTime.local(2017, 5, 25).ordinal //=> 145
       * @type {number|DateTime}
       */
    }, {
      key: "ordinal",
      get: function() {
        return this.isValid ? Rd(this.c).ordinal : NaN;
      }
      /**
       * Get the human readable short month name, such as 'Oct'.
       * Defaults to the system's locale if no locale has been specified
       * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
       * @type {string}
       */
    }, {
      key: "monthShort",
      get: function() {
        return this.isValid ? ru.months("short", {
          locObj: this.loc
        })[this.month - 1] : null;
      }
      /**
       * Get the human readable long month name, such as 'October'.
       * Defaults to the system's locale if no locale has been specified
       * @example DateTime.local(2017, 10, 30).monthLong //=> October
       * @type {string}
       */
    }, {
      key: "monthLong",
      get: function() {
        return this.isValid ? ru.months("long", {
          locObj: this.loc
        })[this.month - 1] : null;
      }
      /**
       * Get the human readable short weekday, such as 'Mon'.
       * Defaults to the system's locale if no locale has been specified
       * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
       * @type {string}
       */
    }, {
      key: "weekdayShort",
      get: function() {
        return this.isValid ? ru.weekdays("short", {
          locObj: this.loc
        })[this.weekday - 1] : null;
      }
      /**
       * Get the human readable long weekday, such as 'Monday'.
       * Defaults to the system's locale if no locale has been specified
       * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
       * @type {string}
       */
    }, {
      key: "weekdayLong",
      get: function() {
        return this.isValid ? ru.weekdays("long", {
          locObj: this.loc
        })[this.weekday - 1] : null;
      }
      /**
       * Get the UTC offset of this DateTime in minutes
       * @example DateTime.now().offset //=> -240
       * @example DateTime.utc().offset //=> 0
       * @type {number}
       */
    }, {
      key: "offset",
      get: function() {
        return this.isValid ? +this.o : NaN;
      }
      /**
       * Get the short human name for the zone's current offset, for example "EST" or "EDT".
       * Defaults to the system's locale if no locale has been specified
       * @type {string}
       */
    }, {
      key: "offsetNameShort",
      get: function() {
        return this.isValid ? this.zone.offsetName(this.ts, {
          format: "short",
          locale: this.locale
        }) : null;
      }
      /**
       * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
       * Defaults to the system's locale if no locale has been specified
       * @type {string}
       */
    }, {
      key: "offsetNameLong",
      get: function() {
        return this.isValid ? this.zone.offsetName(this.ts, {
          format: "long",
          locale: this.locale
        }) : null;
      }
      /**
       * Get whether this zone's offset ever changes, as in a DST.
       * @type {boolean}
       */
    }, {
      key: "isOffsetFixed",
      get: function() {
        return this.isValid ? this.zone.isUniversal : null;
      }
      /**
       * Get whether the DateTime is in a DST.
       * @type {boolean}
       */
    }, {
      key: "isInDST",
      get: function() {
        return this.isOffsetFixed ? false : this.offset > this.set({
          month: 1
        }).offset || this.offset > this.set({
          month: 5
        }).offset;
      }
      /**
       * Returns true if this DateTime is in a leap year, false otherwise
       * @example DateTime.local(2016).isInLeapYear //=> true
       * @example DateTime.local(2013).isInLeapYear //=> false
       * @type {boolean}
       */
    }, {
      key: "isInLeapYear",
      get: function() {
        return P1(this.year);
      }
      /**
       * Returns the number of days in this DateTime's month
       * @example DateTime.local(2016, 2).daysInMonth //=> 29
       * @example DateTime.local(2016, 3).daysInMonth //=> 31
       * @type {number}
       */
    }, {
      key: "daysInMonth",
      get: function() {
        return Mt(this.year, this.month);
      }
      /**
       * Returns the number of days in this DateTime's year
       * @example DateTime.local(2016).daysInYear //=> 366
       * @example DateTime.local(2013).daysInYear //=> 365
       * @type {number}
       */
    }, {
      key: "daysInYear",
      get: function() {
        return this.isValid ? x0(this.year) : NaN;
      }
      /**
       * Returns the number of weeks in this DateTime's year
       * @see https://en.wikipedia.org/wiki/ISO_week_date
       * @example DateTime.local(2004).weeksInWeekYear //=> 53
       * @example DateTime.local(2013).weeksInWeekYear //=> 52
       * @type {number}
       */
    }, {
      key: "weeksInWeekYear",
      get: function() {
        return this.isValid ? Wt(this.weekYear) : NaN;
      }
    }], [{
      key: "DATE_SHORT",
      get: function() {
        return j;
      }
      /**
       * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
       * @type {Object}
       */
    }, {
      key: "DATE_MED",
      get: function() {
        return $;
      }
      /**
       * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
       * @type {Object}
       */
    }, {
      key: "DATE_MED_WITH_WEEKDAY",
      get: function() {
        return W;
      }
      /**
       * {@link DateTime#toLocaleString} format like 'October 14, 1983'
       * @type {Object}
       */
    }, {
      key: "DATE_FULL",
      get: function() {
        return x;
      }
      /**
       * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
       * @type {Object}
       */
    }, {
      key: "DATE_HUGE",
      get: function() {
        return D;
      }
      /**
       * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
       * @type {Object}
       */
    }, {
      key: "TIME_SIMPLE",
      get: function() {
        return w;
      }
      /**
       * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
       * @type {Object}
       */
    }, {
      key: "TIME_WITH_SECONDS",
      get: function() {
        return I;
      }
      /**
       * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
       * @type {Object}
       */
    }, {
      key: "TIME_WITH_SHORT_OFFSET",
      get: function() {
        return Y;
      }
      /**
       * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
       * @type {Object}
       */
    }, {
      key: "TIME_WITH_LONG_OFFSET",
      get: function() {
        return oe;
      }
      /**
       * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
       * @type {Object}
       */
    }, {
      key: "TIME_24_SIMPLE",
      get: function() {
        return Z;
      }
      /**
       * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
       * @type {Object}
       */
    }, {
      key: "TIME_24_WITH_SECONDS",
      get: function() {
        return se;
      }
      /**
       * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
       * @type {Object}
       */
    }, {
      key: "TIME_24_WITH_SHORT_OFFSET",
      get: function() {
        return Ie;
      }
      /**
       * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
       * @type {Object}
       */
    }, {
      key: "TIME_24_WITH_LONG_OFFSET",
      get: function() {
        return ie;
      }
      /**
       * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
       * @type {Object}
       */
    }, {
      key: "DATETIME_SHORT",
      get: function() {
        return ye;
      }
      /**
       * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
       * @type {Object}
       */
    }, {
      key: "DATETIME_SHORT_WITH_SECONDS",
      get: function() {
        return ne;
      }
      /**
       * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
       * @type {Object}
       */
    }, {
      key: "DATETIME_MED",
      get: function() {
        return k;
      }
      /**
       * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
       * @type {Object}
       */
    }, {
      key: "DATETIME_MED_WITH_SECONDS",
      get: function() {
        return K;
      }
      /**
       * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
       * @type {Object}
       */
    }, {
      key: "DATETIME_MED_WITH_WEEKDAY",
      get: function() {
        return G;
      }
      /**
       * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
       * @type {Object}
       */
    }, {
      key: "DATETIME_FULL",
      get: function() {
        return Q;
      }
      /**
       * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
       * @type {Object}
       */
    }, {
      key: "DATETIME_FULL_WITH_SECONDS",
      get: function() {
        return ce;
      }
      /**
       * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
       * @type {Object}
       */
    }, {
      key: "DATETIME_HUGE",
      get: function() {
        return ve;
      }
      /**
       * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
       * @type {Object}
       */
    }, {
      key: "DATETIME_HUGE_WITH_SECONDS",
      get: function() {
        return Re;
      }
    }]), O;
  })();
  function ou(O) {
    if (w1.isDateTime(O))
      return O;
    if (O && O.valueOf && Ae(O.valueOf()))
      return w1.fromJSDate(O);
    if (O && typeof O == "object")
      return w1.fromObject(O);
    throw new v("Unknown datetime argument: " + O + ", of type " + typeof O);
  }
  var OZe = "2.3.2";
  return Bt.DateTime = w1, Bt.Duration = ut, Bt.FixedOffsetZone = it, Bt.IANAZone = S1, Bt.Info = ru, Bt.Interval = tu, Bt.InvalidZone = tt2, Bt.Settings = N1, Bt.SystemZone = r0, Bt.VERSION = OZe, Bt.Zone = Pn, Bt;
}
var Rre;
function Oi0() {
  return Rre || (Rre = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.dateCompare = t16.dateStats = t16.dateMatch = t16.dateIntervalParse = t16.timeParse = t16.dateParse = t16.DATE_FORMATS = void 0;
    var e = Z0, r12 = zc(), n12 = wi(), a = Va();
    t16.DATE_FORMATS = [
      "MM/dd/yyyy HH:mm:ss:SSS",
      "M/d/yyyy HH:mm:ss:SSS",
      "M/d/yyyy HH:mm:ss",
      "M/d/yyyy HH:mm",
      "MM/dd/yyyy",
      "M/d/yyyy",
      "yyyy-MM-dd",
      "yyyy-M-d"
    ];
    function o(d, b, z) {
      if (b === void 0 && (b = true), d instanceof r12.DateTime)
        return d;
      if (d instanceof Date)
        return r12.DateTime.fromJSDate(d);
      if (a.isString(d)) {
        for (var _ = r12.DateTime.fromISO("" + d + (d.endsWith("Z") ? "" : "Z"), z), q = 0; q < t16.DATE_FORMATS.length && !_.isValid; q++)
          _ = r12.DateTime.fromFormat(d, t16.DATE_FORMATS[q]);
        if (_.isValid || (_ = r12.DateTime.fromSQL(d)), _.isValid)
          return _;
      }
      if (typeof d == "number")
        return r12.DateTime.fromMillis(d);
      if (b)
        throw n12.ERRORS.VALUE;
      return null;
    }
    t16.dateParse = o;
    var i = [
      "HH:mm:ss:SSS",
      "HH:mm:ss.SSS",
      "HH:mm:ss",
      "HH:mm"
    ];
    function u(d, b) {
      var z, _;
      if (b === void 0 && (b = true), d instanceof r12.DateTime)
        return d;
      if (d instanceof Date)
        return r12.DateTime.fromJSDate(d);
      if (a.isString(d))
        try {
          for (var q = e.__values(i), S = q.next(); !S.done; S = q.next()) {
            var N = S.value, v = r12.DateTime.fromFormat(d, N);
            if (v.isValid)
              return v;
          }
        } catch (C) {
          z = { error: C };
        } finally {
          try {
            S && !S.done && (_ = q.return) && _.call(q);
          } finally {
            if (z)
              throw z.error;
          }
        }
      if (b)
        throw n12.ERRORS.VALUE;
      return null;
    }
    t16.timeParse = u;
    var s12 = {
      d: 1,
      y: 1,
      h: 1,
      n: 1,
      m: 1,
      q: 1,
      s: 1,
      w: 1,
      ww: 1,
      yyyy: 1
    };
    function c(d, b) {
      b === void 0 && (b = true);
      var z = String(d).toLowerCase();
      if (!(z in s12) && b)
        throw n12.ERRORS.VALUE;
      return z;
    }
    t16.dateIntervalParse = c;
    function l2(d, b) {
      var z = o(d, false);
      if (z === null)
        return false;
      if (a.isDefined(b.min)) {
        var _ = o(b.min, false);
        if (_ === null || z.toMillis() < _.toMillis())
          return false;
      }
      if (a.isDefined(b.max)) {
        var q = o(b.max, false);
        if (q === null || z.toMillis() > q.toMillis())
          return false;
      }
      if (a.isDefined(b.value)) {
        var S = o(b.value, false);
        return S === null ? false : S.toMillis() === z.toMillis();
      }
      if (a.isString(b.like)) {
        var N = z.toISO();
        return !!new RegExp("^" + b.like.replace(/%/g, ".*") + "$", "i").exec(N);
      }
      return a.isArray(b.values) && b.values.length > 0 ? b.values.some(function(v) {
        return String(o(v, false)) === String(z);
      }) : true;
    }
    t16.dateMatch = l2;
    function f(d) {
      var b, z;
      if (d.length === 0)
        return {};
      var _, q, S = 0;
      try {
        for (var N = e.__values(d), v = N.next(); !v.done; v = N.next()) {
          var C = v.value, L = o(C, false);
          a.isDefined(L) ? (_ = _ === void 0 || L.toMillis() < _.toMillis() ? L : _, q = q === void 0 || L.toMillis() > q.toMillis() ? L : q) : S++;
        }
      } catch (P12) {
        b = { error: P12 };
      } finally {
        try {
          v && !v.done && (z = N.return) && z.call(N);
        } finally {
          if (b)
            throw b.error;
        }
      }
      var B = { nulls: S };
      return _ !== void 0 && (B.min = _), q !== void 0 && (B.max = q), B;
    }
    t16.dateStats = f;
    function p(d, b) {
      return d.toMillis() - b.toMillis();
    }
    t16.dateCompare = p;
  })(jd)), jd;
}
var f0 = {}, qre;
function Qee() {
  if (qre)
    return f0;
  qre = 1, Object.defineProperty(f0, "__esModule", { value: true }), f0.numbersCompare = f0.numbersStats = f0.numbersMatch = f0.numbersFrom = f0.numbersMedian = f0.numbersStandardDeviation = f0.numbersVariance = f0.numbersProduct = f0.numbersAverage = f0.numbersSum = f0.numbersMin = f0.numbersMax = f0.numbersSign = f0.numbersFloor = f0.numbersCeiling = f0.numbersCombinatorial = f0.numbersFactorialDouble = f0.numbersFactorial = f0.numbersRoundScaled = f0.numbersRound = f0.numbersEqual = f0.numbersFormatted = f0.numbersUp = f0.numbersTruncate = f0.numbersParse = void 0;
  var t16 = Z0, e = wi(), r12 = Va();
  function n12(D, w, I) {
    w === void 0 && (w = true), I === void 0 && (I = Number.NaN);
    var Y = D;
    if (r12.isString(D) && (Y = parseFloat(D)), typeof Y == "number" && !isNaN(Y)) {
      if (!isFinite(Y)) {
        if (w)
          throw e.ERRORS.DIV0;
        return I;
      }
      return Y;
    }
    if (w)
      throw e.ERRORS.NUM;
    return I;
  }
  f0.numbersParse = n12;
  function a(D) {
    return D < 0 ? Math.ceil(D) : Math.floor(D);
  }
  f0.numbersTruncate = a;
  function o(D) {
    return D < 0 ? Math.floor(D) : Math.ceil(D);
  }
  f0.numbersUp = o;
  function i(D, w, I) {
    var Y = D.toFixed(w);
    if (r12.isNumber(I) && Y.includes(".")) {
      for (var oe = Math.max(0, w - I); --oe >= 0 && Y.endsWith("0"); )
        Y = Y.substring(0, Y.length - 1);
      Y.endsWith(".") && (Y = Y.substring(0, Y.length - 1));
    }
    return Y;
  }
  f0.numbersFormatted = i;
  function u(D, w, I) {
    return I === void 0 && (I = 1e-6), Math.abs(D - w) < I;
  }
  f0.numbersEqual = u;
  function s12(D, w) {
    var I = Math.round(D * Math.pow(10, w));
    return I / Math.pow(10, w);
  }
  f0.numbersRound = s12;
  function c(D, w) {
    var I = Math.round(D * Math.pow(10, w));
    return I;
  }
  f0.numbersRoundScaled = c;
  var l2 = [];
  function f(D) {
    var w = Math.floor(D);
    return w === 0 || w === 1 ? 1 : (l2[w] > 0 || (l2[w] = f(w - 1) * w), l2[w]);
  }
  f0.numbersFactorial = f;
  function p(D) {
    var w = Math.floor(D);
    return w <= 0 ? 1 : w * p(w - 2);
  }
  f0.numbersFactorialDouble = p;
  function d(D, w) {
    return f(D) / (f(w) * f(D - w));
  }
  f0.numbersCombinatorial = d;
  function b(D, w, I) {
    w === void 0 && (w = 1), I === void 0 && (I = 0);
    var Y = Math.abs(w);
    if (Y === 0)
      return 0;
    var oe = -Math.floor(Math.log(Y) / Math.log(10));
    return D >= 0 ? s12(Math.ceil(D / Y) * Y, oe) : I === 0 ? -s12(Math.floor(Math.abs(D) / Y) * Y, oe) : -s12(Math.ceil(Math.abs(D) / Y) * Y, oe);
  }
  f0.numbersCeiling = b;
  function z(D, w) {
    if (w === 0)
      return 0;
    if (!(D > 0 && w > 0) && !(D < 0 && w < 0))
      throw e.ERRORS.NUM;
    var I = Math.abs(w), Y = -Math.floor(Math.log(I) / Math.log(10));
    return D >= 0 ? s12(Math.floor(D / I) * I, Y) : -s12(Math.ceil(Math.abs(D) / I), Y);
  }
  f0.numbersFloor = z;
  function _(D, w) {
    return w === void 0 && (w = 1e-5), D > w ? 1 : D < -w ? -1 : 0;
  }
  f0.numbersSign = _;
  function q(D) {
    return D.reduce(function(w, I) {
      return Math.max(w, I);
    });
  }
  f0.numbersMax = q;
  function S(D) {
    return D.reduce(function(w, I) {
      return Math.min(w, I);
    });
  }
  f0.numbersMin = S;
  function N(D) {
    return D.reduce(function(w, I) {
      return w + I;
    });
  }
  f0.numbersSum = N;
  function v(D) {
    return D.reduce(function(w, I) {
      return w + I;
    }) / D.length;
  }
  f0.numbersAverage = v;
  function C(D) {
    return D.reduce(function(w, I) {
      return w * I;
    });
  }
  f0.numbersProduct = C;
  function L(D) {
    var w = v(D), I = D.map(function(oe) {
      return (oe - w) * (oe - w);
    }), Y = v(I);
    return Y;
  }
  f0.numbersVariance = L;
  function B(D) {
    return Math.sqrt(L(D));
  }
  f0.numbersStandardDeviation = B;
  function P12(D) {
    var w = D.slice().sort(), I = Math.floor(w.length / 2);
    return w.length % 2 === 0 ? (w[I - 1] + w[I]) / 2 : w[I | 0];
  }
  f0.numbersMedian = P12;
  function j(D) {
    return D.map(function(w) {
      return n12(w, false);
    }).filter(function(w) {
      return isFinite(w);
    });
  }
  f0.numbersFrom = j;
  function $(D, w) {
    var I = n12(D);
    return r12.isNumber(w.min) && I < w.min || r12.isNumber(w.max) && I > w.max ? false : r12.isNumber(w.value) ? u(w.value, I) : r12.isArray(w.values) && w.values.length > 0 ? w.values.some(function(Y) {
      return u(Y, I);
    }) : true;
  }
  f0.numbersMatch = $;
  function W(D) {
    var w, I;
    if (D.length === 0)
      return {};
    var Y, oe, Z = 0, se = 0;
    try {
      for (var Ie = t16.__values(D), ie = Ie.next(); !ie.done; ie = Ie.next()) {
        var ye = ie.value, ne = n12(ye, false);
        isNaN(ne) ? se++ : (Z += ne, Y = Y === void 0 || ne < Y ? ne : Y, oe = oe === void 0 || ne > oe ? ne : oe);
      }
    } catch (K) {
      w = { error: K };
    } finally {
      try {
        ie && !ie.done && (I = Ie.return) && I.call(Ie);
      } finally {
        if (w)
          throw w.error;
      }
    }
    var k = { nulls: se };
    return D.length > se && (k.sum = Z), Y !== void 0 && (k.min = Y), oe !== void 0 && (k.max = oe), k;
  }
  f0.numbersStats = W;
  function x(D, w) {
    return D - w;
  }
  return f0.numbersCompare = x, f0;
}
var Ka = {}, Tre;
function zi0() {
  if (Tre)
    return Ka;
  Tre = 1, Object.defineProperty(Ka, "__esModule", { value: true }), Ka.integersBaseChange = Ka.integersParse = void 0;
  var t16 = wi(), e = Va(), r12 = Qee(), n12 = eXe();
  function a(i, u, s12, c) {
    u === void 0 && (u = true), c === void 0 && (c = Number.NaN);
    var l2 = i;
    if (e.isString(i) && (l2 = parseInt(i, s12)), typeof l2 == "number" && !isNaN(l2)) {
      if (!isFinite(l2))
        throw t16.ERRORS.DIV0;
      return r12.numbersTruncate(l2);
    }
    if (u)
      throw t16.ERRORS.NUM;
    return c;
  }
  Ka.integersParse = a;
  function o(i, u, s12, c) {
    var l2 = a(s12, true, i), f = l2.toString(u), p = c ? f.length : a(c);
    return n12.textPad(f, "0", p);
  }
  return Ka.integersBaseChange = o, Ka;
}
var Ct = {}, yre;
function Ai0() {
  if (yre)
    return Ct;
  yre = 1, Object.defineProperty(Ct, "__esModule", { value: true }), Ct.complexArgument = Ct.complexCreate = Ct.complexAbs = Ct.complexImaginary = Ct.complexReal = Ct.complexUnit = void 0;
  var t16 = Va(), e = wi();
  function r12(s12, c) {
    c === void 0 && (c = "i");
    var l2 = s12.substring(s12.length - 1);
    return l2 === "i" || l2 === "j" ? l2 : c;
  }
  Ct.complexUnit = r12;
  function n12(s12) {
    if (s12 === void 0 || s12 === true || s12 === false)
      throw e.ERRORS.VALUE;
    if (s12 === 0 || s12 === "0")
      return 0;
    if (!t16.isString(s12))
      throw e.ERRORS.VALUE;
    if (["i", "+i", "1i", "+1i", "-i", "-1i", "j", "+j", "1j", "+1j", "-j", "-1j"].includes(s12))
      return 0;
    var c = s12.indexOf("+"), l2 = s12.indexOf("-");
    c === 0 && (c = s12.indexOf("+", 1)), l2 === 0 && (l2 = s12.indexOf("-", 1));
    var f = r12(s12, void 0);
    if (c >= 0 || l2 >= 0) {
      if (!f)
        throw e.ERRORS.NUM;
      if (c >= 0) {
        var p = parseFloat(s12.substring(0, c)), d = parseFloat(s12.substring(c + 1, s12.length - 1));
        if (isNaN(p) || isNaN(d))
          throw e.ERRORS.NUM;
        return p;
      }
      var b = parseFloat(s12.substring(0, l2)), z = parseFloat(s12.substring(l2 + 1, s12.length - 1));
      if (isNaN(b) || isNaN(z))
        throw e.ERRORS.NUM;
      return b;
    }
    if (f) {
      var p = parseFloat(s12.substring(0, s12.length - 1));
      if (isNaN(p))
        throw e.ERRORS.NUM;
      return 0;
    }
    var _ = parseFloat(s12);
    if (isNaN(_))
      throw e.ERRORS.NUM;
    return _;
  }
  Ct.complexReal = n12;
  function a(s12) {
    if (s12 === void 0 || s12 === true || s12 === false)
      throw e.ERRORS.VALUE;
    if (s12 === 0 || s12 === "0")
      return 0;
    if (!t16.isString(s12))
      throw e.ERRORS.VALUE;
    if (["i", "j"].includes(s12))
      return 1;
    s12 = s12.replace("+i", "+1i").replace("-i", "-1i").replace("+j", "+1j").replace("-j", "-1j");
    var c = s12.indexOf("+"), l2 = s12.indexOf("-");
    c === 0 && (c = s12.indexOf("+", 1)), l2 === 0 && (l2 = s12.indexOf("-", 1));
    var f = r12(s12, void 0);
    if (c >= 0 || l2 >= 0) {
      if (!f)
        throw e.ERRORS.NUM;
      if (c >= 0) {
        var p = parseFloat(s12.substring(0, c)), d = parseFloat(s12.substring(c + 1, s12.length - 1));
        if (isNaN(p) || isNaN(d))
          throw e.ERRORS.NUM;
        return d;
      }
      var b = parseFloat(s12.substring(0, l2)), z = parseFloat(s12.substring(l2 + 1, s12.length - 1));
      if (isNaN(b) || isNaN(z))
        throw e.ERRORS.NUM;
      return -z;
    }
    if (f) {
      var p = parseFloat(s12.substring(0, s12.length - 1));
      if (isNaN(p))
        throw e.ERRORS.NUM;
      return p;
    }
    var _ = parseFloat(s12);
    if (isNaN(_))
      throw e.ERRORS.NUM;
    return 0;
  }
  Ct.complexImaginary = a;
  function o(s12) {
    var c = n12(s12), l2 = a(s12);
    return Math.sqrt(Math.pow(c, 2) + Math.pow(l2, 2));
  }
  Ct.complexAbs = o;
  function i(s12, c, l2) {
    if (l2 === void 0 && (l2 = "i"), l2 !== "i" && l2 !== "j")
      throw e.ERRORS.VALUE;
    if (s12 === 0 && c === 0)
      return 0;
    if (s12 === 0)
      return c === 1 ? l2 : c.toString() + l2;
    if (c === 0)
      return s12.toString();
    var f = c > 0 ? "+" : "";
    return s12.toString() + f + (c === 1 ? l2 : c.toString() + l2);
  }
  Ct.complexCreate = i;
  function u(s12) {
    var c = n12(s12), l2 = a(s12);
    if (c === 0 && l2 === 0)
      throw e.ERRORS.DIV0;
    return c === 0 && l2 > 0 ? Math.PI / 2 : c === 0 && l2 < 0 ? -Math.PI / 2 : l2 === 0 && c > 0 ? 0 : l2 === 0 && c < 0 ? -Math.PI : c > 0 ? Math.atan(l2 / c) : c < 0 && l2 >= 0 ? Math.atan(l2 / c) + Math.PI : Math.atan(l2 / c) - Math.PI;
  }
  return Ct.complexArgument = u, Ct;
}
var Nr = {}, Sre;
function _i0() {
  if (Sre)
    return Nr;
  Sre = 1, Object.defineProperty(Nr, "__esModule", { value: true }), Nr.financialInterestPayment = Nr.financialLoanPayment = Nr.financialPresent = Nr.financialFuture = void 0;
  function t16(a, o, i, u, s12) {
    u === void 0 && (u = 0), s12 === void 0 && (s12 = 0);
    var c;
    if (a === 0)
      c = u + i * o;
    else {
      var l2 = Math.pow(1 + a, o);
      s12 === 1 ? c = u * l2 + i * (1 + a) * (l2 - 1) / a : c = u * l2 + i * (l2 - 1) / a;
    }
    return -c;
  }
  Nr.financialFuture = t16;
  function e(a, o, i, u, s12) {
    return u === void 0 && (u = 0), s12 === void 0 && (s12 = 0), a === 0 ? -i * o - u : ((1 - Math.pow(1 + a, o)) / a * i * (1 + a * s12) - u) / Math.pow(1 + a, o);
  }
  Nr.financialPresent = e;
  function r12(a, o, i, u, s12) {
    u === void 0 && (u = 0), s12 === void 0 && (s12 = 0);
    var c;
    if (a === 0)
      c = (i + u) / o;
    else {
      var l2 = Math.pow(1 + a, o);
      s12 === 1 ? c = (u * a / (l2 - 1) + i * a / (1 - 1 / l2)) / (1 + a) : c = u * a / (l2 - 1) + i * a / (1 - 1 / l2);
    }
    return -c;
  }
  Nr.financialLoanPayment = r12;
  function n12(a, o, i, u, s12, c) {
    s12 === void 0 && (s12 = 0), c === void 0 && (c = 0);
    var l2 = r12(a, i, u, s12, c), f;
    return o === 1 ? c === 1 ? f = 0 : f = -u : c === 1 ? f = t16(a, o - 2, l2, u, 1) - l2 : f = t16(a, o - 1, l2, u, 0), f * a;
  }
  return Nr.financialInterestPayment = n12, Nr;
}
var i1 = {}, Cre;
function hi0() {
  if (Cre)
    return i1;
  Cre = 1, Object.defineProperty(i1, "__esModule", { value: true }), i1.BETA_CURVES = i1.statsBetaCumulative = i1.statsBetaProbability = i1.statsBinomialProbability = i1.statsBinomialCumulative = i1.statsBetaContinuedFraction = i1.statsBetaIncomplete = i1.statsBetaLn = i1.statsBetaFn = i1.statsGammaLn = i1.statsGammaFn = i1.statsBinomialDistribution = void 0;
  var t16 = Qee();
  function e(p, d, b, z) {
    for (var _ = 0, q = 1, S = 1, N = 1, v = 0, C = 0, L; Math.abs((S - C) / S) > z; )
      C = S, L = -(d + v) * (d + b + v) * p / (d + 2 * v) / (d + 2 * v + 1), _ = S + L * _, q = N + L * q, v = v + 1, L = v * (b - v) * p / (d + 2 * v - 1) / (d + 2 * v), S = _ + L * S, N = q + L * N, _ = _ / N, q = q / N, S = S / N, N = 1;
    return S / d;
  }
  i1.statsBinomialDistribution = e;
  function r12(p) {
    var d = [
      -1.716185138865495,
      24.76565080557592,
      -379.80425647094563,
      629.3311553128184,
      866.9662027904133,
      -31451.272968848367,
      -36144.413418691176,
      66456.14382024054
    ], b = [
      -30.8402300119739,
      315.35062697960416,
      -1015.1563674902192,
      -3107.771671572311,
      22538.11842098015,
      4755.846277527881,
      -134659.9598649693,
      -115132.2596755535
    ], z = 0, _ = 0, q = 0, S = 0, N = p, v, C, L, B;
    if (p > 171.6243769536076)
      return 1 / 0;
    if (N <= 0)
      if (B = N % 1 + 36e-17, B)
        z = (N & 1 ? -1 : 1) * Math.PI / Math.sin(Math.PI * B), N = 1 - N;
      else
        return 1 / 0;
    for (L = N, N < 1 ? C = N++ : C = (N -= _ = (N | 0) - 1) - 1, v = 0; v < 8; ++v)
      S = (S + d[v]) * C, q = q * C + b[v];
    if (B = S / q + 1, L < N)
      B /= L;
    else if (L > N)
      for (v = 0; v < _; ++v)
        B *= N, N++;
    return z && (B = z / B), B;
  }
  i1.statsGammaFn = r12;
  function n12(p) {
    var d = 0, b = [
      76.18009172947146,
      -86.50532032941678,
      24.01409824083091,
      -1.231739572450155,
      0.001208650973866179,
      -5395239384953e-18
    ], z = 1.000000000190015, _, q, S;
    for (S = (q = _ = p) + 5.5, S -= (_ + 0.5) * Math.log(S); d < 6; d++)
      z += b[d] / ++q;
    return Math.log(2.5066282746310007 * z / _) - S;
  }
  i1.statsGammaLn = n12;
  function a(p, d) {
    if (!(p <= 0 || d <= 0))
      return p + d > 170 ? Math.exp(o(p, d)) : r12(p) * r12(d) / r12(p + d);
  }
  i1.statsBetaFn = a;
  function o(p, d) {
    return n12(p) + n12(d) - n12(p + d);
  }
  i1.statsBetaLn = o;
  function i(p, d, b) {
    var z = p === 0 || p === 1 ? 0 : Math.exp(n12(d + b) - n12(d) - n12(b) + d * Math.log(p) + b * Math.log(1 - p));
    if (!(p < 0 || p > 1))
      return p < (d + 1) / (d + b + 2) ? z * u(p, d, b) / d : 1 - z * u(1 - p, b, d) / b;
  }
  i1.statsBetaIncomplete = i;
  function u(p, d, b) {
    var z = 1e-30, _ = 1, q = d + b, S = d + 1, N = d - 1, v = 1, C = 1 - q * p / S, L, B, P12, j;
    for (Math.abs(C) < z && (C = z), C = 1 / C, j = C; _ <= 100 && (L = 2 * _, B = _ * (b - _) * p / ((N + L) * (d + L)), C = 1 + B * C, Math.abs(C) < z && (C = z), v = 1 + B / v, Math.abs(v) < z && (v = z), C = 1 / C, j *= C * v, B = -(d + _) * (q + _) * p / ((d + L) * (S + L)), C = 1 + B * C, Math.abs(C) < z && (C = z), v = 1 + B / v, Math.abs(v) < z && (v = z), C = 1 / C, P12 = C * v, j *= P12, !(Math.abs(P12 - 1) < 3e-7)); _++)
      ;
    return j;
  }
  i1.statsBetaContinuedFraction = u;
  function s12(p, d, b) {
    var z, _ = 1e-10;
    if (p < 0)
      return 0;
    if (p >= d)
      return 1;
    if (b < 0 || b > 1 || d <= 0)
      return NaN;
    p = Math.floor(p);
    var q = b, S = p + 1, N = d - p, v = S + N, C = Math.exp(n12(v) - n12(N) - n12(S) + S * Math.log(q) + N * Math.log(1 - q));
    return q < (S + 1) / (v + 2) ? z = C * e(q, S, N, _) : z = 1 - C * e(1 - q, N, S, _), Math.round((1 - z) * (1 / _)) / (1 / _);
  }
  i1.statsBinomialCumulative = s12;
  function c(p, d, b) {
    return b === 0 || b === 1 ? d * b === p ? 1 : 0 : t16.numbersCombinatorial(d, p) * Math.pow(b, p) * Math.pow(1 - b, d - p);
  }
  i1.statsBinomialProbability = c;
  function l2(p, d, b) {
    if (p > 1 || p < 0)
      return 0;
    if (d == 1 && b == 1)
      return 1;
    if (d < 512 && b < 512) {
      var z = a(d, b);
      return typeof z > "u" ? 0 : Math.pow(p, d - 1) * Math.pow(1 - p, b - 1) / z;
    } else
      return Math.exp((d - 1) * Math.log(p) + (b - 1) * Math.log(1 - p) - o(d, b));
  }
  i1.statsBetaProbability = l2;
  function f(p, d, b) {
    var z = i(p, d, b);
    return typeof z > "u" ? 0 : p > 1 || p < 0 ? p > 1 ? 1 : 0 : z;
  }
  return i1.statsBetaCumulative = f, i1.BETA_CURVES = {
    /** Will hit 50% distribution when x = 0.3689 */
    FRONT_LOAD: { alpha: 2, beta: 3.2 },
    /** Will hit 50% distribution when x = 0.5 */
    MIDDLE_LOAD: { alpha: 2.4, beta: 2.4 },
    /** Will hit 50% distribution when x = 0.6312 */
    BACK_LOAD: { alpha: 3.2, beta: 2 }
  }, i1;
}
var Fd = {}, vi0 = {
  defaultAmount: 0,
  defaultCurrency: "USD",
  defaultPrecision: 2
}, mi0 = {
  globalLocale: "en-US",
  globalFormat: "$0,0.00",
  globalRoundingMode: "HALF_EVEN",
  globalFormatRoundingMode: "HALF_AWAY_FROM_ZERO",
  globalExchangeRatesApi: {
    endpoint: void 0,
    headers: void 0,
    propertyPath: void 0
  }
};
function bs(t16) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? bs = function(e) {
    return typeof e;
  } : bs = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, bs(t16);
}
function gre(t16) {
  return Ri0(t16) || qi0(t16) || Ti0(t16) || yi0();
}
function Ri0(t16) {
  if (Array.isArray(t16))
    return t16;
}
function qi0(t16) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t16))
    return Array.from(t16);
}
function Ti0(t16, e) {
  if (t16) {
    if (typeof t16 == "string")
      return Ire(t16, e);
    var r12 = Object.prototype.toString.call(t16).slice(8, -1);
    if (r12 === "Object" && t16.constructor && (r12 = t16.constructor.name), r12 === "Map" || r12 === "Set")
      return Array.from(t16);
    if (r12 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r12))
      return Ire(t16, e);
  }
}
function Ire(t16, e) {
  (e == null || e > t16.length) && (e = t16.length);
  for (var r12 = 0, n12 = new Array(e); r12 < e; r12++)
    n12[r12] = t16[r12];
  return n12;
}
function yi0() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Si0 = {
  /**
   * Returns an array of Dinero objects, normalized to the same precision (the highest).
   *
   * @memberof module:Dinero
   * @method
   *
   * @param {Dinero[]} objects - An array of Dinero objects
   *
   * @example
   * // returns an array of Dinero objects
   * // both with a precision of 3
   * // and an amount of 1000
   * Dinero.normalizePrecision([
   *   Dinero({ amount: 100, precision: 2 }),
   *   Dinero({ amount: 1000, precision: 3 })
   * ])
   *
   * @return {Dinero[]}
   */
  normalizePrecision: function(e) {
    var r12 = e.reduce(function(n12, a) {
      return Math.max(n12.getPrecision(), a.getPrecision());
    });
    return e.map(function(n12) {
      return n12.getPrecision() !== r12 ? n12.convertPrecision(r12) : n12;
    });
  },
  /**
   * Returns the smallest Dinero object from an array of Dinero objects
   *
   * @memberof module:Dinero
   * @method
   *
   * @param {Dinero[]} objects - An array of Dinero objects
   *
   * @example
   * // returns the smallest Dinero object with amount of 500 from an array of Dinero objects with different precisions
   * Dinero.minimum([
   *   Dinero({ amount: 500, precision: 3 }),
   *   Dinero({ amount: 100, precision: 2 })
   * ])
   * @example
   * // returns the smallest Dinero object with amount of 50 from an array of Dinero objects
   * Dinero.minimum([
   *   Dinero({ amount: 50 }),
   *   Dinero({ amount: 100 })
   * ])
   *
   * @return {Dinero[]}
   */
  minimum: function(e) {
    var r12 = gre(e), n12 = r12[0], a = r12.slice(1), o = n12;
    return a.forEach(function(i) {
      o = o.lessThan(i) ? o : i;
    }), o;
  },
  /**
   * Returns the biggest Dinero object from an array of Dinero objects
   *
   * @memberof module:Dinero
   * @method
   *
   * @param {Dinero[]} objects - An array of Dinero objects
   *
   * @example
   * // returns the biggest Dinero object with amount of 20, from an array of Dinero objects with different precisions
   * Dinero.maximum([
   *   Dinero({ amount: 20, precision: 2 }),
   *   Dinero({ amount: 150, precision: 3 })
   * ])
   * @example
   * // returns the biggest Dinero object with amount of 100, from an array of Dinero objects
   * Dinero.maximum([
   *   Dinero({ amount: 100 }),
   *   Dinero({ amount: 50 })
   * ])
   *
   * @return {Dinero[]}
   */
  maximum: function(e) {
    var r12 = gre(e), n12 = r12[0], a = r12.slice(1), o = n12;
    return a.forEach(function(i) {
      o = o.greaterThan(i) ? o : i;
    }), o;
  }
};
function tXe(t16) {
  return !isNaN(parseInt(t16)) && isFinite(t16);
}
function Ci0(t16) {
  return tXe(t16) && t16 <= 100 && t16 >= 0;
}
function gi0(t16) {
  return t16.length > 0 && t16.every(function(e) {
    return e >= 0;
  }) && t16.some(function(e) {
    return e > 0;
  });
}
function Ere(t16) {
  return t16 % 2 === 0;
}
function Lre(t16) {
  return tXe(t16) && !Number.isInteger(t16);
}
function Ii0() {
  var t16 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = t16.toString();
  if (e.indexOf("e-") > 0)
    return parseInt(e.split("e-")[1]);
  var r12 = e.split(".")[1];
  return r12 ? r12.length : 0;
}
function cu(t16) {
  return Math.abs(t16) % 1 === 0.5;
}
function Ei0(t16) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise(function(r12, n12) {
    var a = Object.assign(new XMLHttpRequest(), {
      onreadystatechange: function() {
        a.readyState === 4 && (a.status >= 200 && a.status < 400 ? r12(JSON.parse(a.responseText)) : n12(new Error(a.statusText)));
      },
      onerror: function() {
        n12(new Error("Network error"));
      }
    });
    a.open("GET", t16, true), Li0(a, e.headers), a.send();
  });
}
function Li0(t16) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  for (var r12 in e)
    t16.setRequestHeader(r12, e[r12]);
  return t16;
}
function rs(t16) {
  return typeof t16 > "u";
}
function rXe(t16) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ".", r12 = {};
  return Object.entries(t16).forEach(function(n12) {
    if (bs(n12[1]) === "object") {
      var a = rXe(n12[1]);
      Object.entries(a).forEach(function(o) {
        r12[n12[0] + e + o[0]] = o[1];
      });
    } else
      r12[n12[0]] = n12[1];
  }), r12;
}
function Pi0(t16) {
  return !!t16 && (bs(t16) === "object" || typeof t16 == "function") && typeof t16.then == "function";
}
function nXe() {
  var t16 = function(n12, a) {
    var o = function(s12) {
      return Math.pow(10, Ii0(s12));
    }, i = Math.max(o(n12), o(a));
    return Math.round(n12 * i) * Math.round(a * i) / (i * i);
  }, e = {
    HALF_ODD: function(n12) {
      var a = Math.round(n12);
      return cu(n12) && Ere(a) ? a - 1 : a;
    },
    HALF_EVEN: function(n12) {
      var a = Math.round(n12);
      return cu(n12) ? Ere(a) ? a : a - 1 : a;
    },
    HALF_UP: function(n12) {
      return Math.round(n12);
    },
    HALF_DOWN: function(n12) {
      return cu(n12) ? Math.floor(n12) : Math.round(n12);
    },
    HALF_TOWARDS_ZERO: function(n12) {
      return cu(n12) ? Math.sign(n12) * Math.floor(Math.abs(n12)) : Math.round(n12);
    },
    HALF_AWAY_FROM_ZERO: function(n12) {
      return cu(n12) ? Math.sign(n12) * Math.ceil(Math.abs(n12)) : Math.round(n12);
    },
    DOWN: function(n12) {
      return Math.floor(n12);
    }
  };
  return {
    /**
     * Returns the sum of two numbers.
     * @ignore
     *
     * @param {Number} a - The first number to add.
     * @param {Number} b - The second number to add.
     *
     * @return {Number}
     */
    add: function(n12, a) {
      return n12 + a;
    },
    /**
     * Returns the difference of two numbers.
     * @ignore
     *
     * @param {Number} a - The first number to subtract.
     * @param {Number} b - The second number to subtract.
     *
     * @return {Number}
     */
    subtract: function(n12, a) {
      return n12 - a;
    },
    /**
     * Returns the product of two numbers.
     * @ignore
     *
     * @param {Number} a - The first number to multiply.
     * @param {Number} b - The second number to multiply.
     *
     * @return {Number}
     */
    multiply: function(n12, a) {
      return Lre(n12) || Lre(a) ? t16(n12, a) : n12 * a;
    },
    /**
     * Returns the quotient of two numbers.
     * @ignore
     *
     * @param {Number} a - The first number to divide.
     * @param {Number} b - The second number to divide.
     *
     * @return {Number}
     */
    divide: function(n12, a) {
      return n12 / a;
    },
    /**
     * Returns the remainder of two numbers.
     * @ignore
     *
     * @param  {Number} a - The first number to divide.
     * @param  {Number} b - The second number to divide.
     *
     * @return {Number}
     */
    modulo: function(n12, a) {
      return n12 % a;
    },
    /**
     * Returns a rounded number based off a specific rounding mode.
     * @ignore
     *
     * @param {Number} number - The number to round.
     * @param {String} [roundingMode='HALF_EVEN'] - The rounding mode to use.
     *
     * @returns {Number}
     */
    round: function(n12) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "HALF_EVEN";
      return e[a](n12);
    }
  };
}
var Di0 = nXe();
function Wi0(t16) {
  var e = /^(?:(\$|USD)?0(?:(,)0)?(\.)?(0+)?|0(?:(,)0)?(\.)?(0+)?\s?(dollar)?)$/gm.exec(t16);
  return {
    /**
     * Returns the matches.
     * @ignore
     *
     * @return {Array}
     */
    getMatches: function() {
      return e !== null ? e.slice(1).filter(function(n12) {
        return !rs(n12);
      }) : [];
    },
    /**
     * Returns the amount of fraction digits to display.
     * @ignore
     *
     * @return {Number}
     */
    getMinimumFractionDigits: function() {
      var n12 = function(o) {
        return o === ".";
      };
      return rs(this.getMatches().find(n12)) ? 0 : this.getMatches()[Di0.add(this.getMatches().findIndex(n12), 1)].split("").length;
    },
    /**
     * Returns the currency display mode.
     * @ignore
     *
     * @return {String}
     */
    getCurrencyDisplay: function() {
      var n12 = {
        USD: "code",
        dollar: "name",
        $: "symbol"
      };
      return n12[this.getMatches().find(function(a) {
        return a === "USD" || a === "dollar" || a === "$";
      })];
    },
    /**
     * Returns the formatting style.
     * @ignore
     *
     * @return {String}
     */
    getStyle: function() {
      return rs(this.getCurrencyDisplay(this.getMatches())) ? "decimal" : "currency";
    },
    /**
     * Returns whether grouping should be used or not.
     * @ignore
     *
     * @return {Boolean}
     */
    getUseGrouping: function() {
      return !rs(this.getMatches().find(function(n12) {
        return n12 === ",";
      }));
    }
  };
}
function Ni0(t16) {
  var e = function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", o = arguments.length > 1 ? arguments[1] : void 0;
    for (var i in o)
      a = a.replace("{{".concat(i, "}}"), o[i]);
    return a;
  }, r12 = function(a, o) {
    return Ei0(e(t16.endpoint, {
      from: a,
      to: o
    }), {
      headers: t16.headers
    });
  };
  return {
    /**
     * Returns the exchange rate.
     * @ignore
     *
     * @param  {String} from - The base currency.
     * @param  {String} to   - The destination currency.
     *
     * @return {Promise}
     */
    getExchangeRate: function(a, o) {
      return (Pi0(t16.endpoint) ? t16.endpoint : r12(a, o)).then(function(i) {
        return rXe(i)[e(t16.propertyPath, {
          from: a,
          to: o
        })];
      });
    }
  };
}
function Ns(t16, e) {
  var r12 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Error;
  if (!t16)
    throw new r12(e);
}
function wi0(t16) {
  Ns(Ci0(t16), "You must provide a numeric value between 0 and 100.", RangeError);
}
function Bi0(t16) {
  Ns(gi0(t16), "You must provide a non-empty array of numeric values greater than 0.", TypeError);
}
function Vd(t16) {
  Ns(Number.isInteger(t16), "You must provide an integer.", TypeError);
}
var p1 = nXe(), xi0 = function t2(e) {
  var r12 = Object.assign({}, {
    amount: t2.defaultAmount,
    currency: t2.defaultCurrency,
    precision: t2.defaultPrecision
  }, e), n12 = r12.amount, a = r12.currency, o = r12.precision;
  Vd(n12), Vd(o);
  var i = t2.globalLocale, u = t2.globalFormat, s12 = t2.globalRoundingMode, c = t2.globalFormatRoundingMode, l2 = Object.assign({}, t2.globalExchangeRatesApi), f = function(b) {
    var z = Object.assign({}, Object.assign({}, {
      amount: n12,
      currency: a,
      precision: o
    }, b), Object.assign({}, {
      locale: this.locale
    }, b));
    return Object.assign(t2({
      amount: z.amount,
      currency: z.currency,
      precision: z.precision
    }), {
      locale: z.locale
    });
  }, p = function(b) {
    Ns(this.hasSameCurrency(b), "You must provide a Dinero instance with the same currency.", TypeError);
  };
  return {
    /**
     * Returns the amount.
     *
     * @example
     * // returns 500
     * Dinero({ amount: 500 }).getAmount()
     *
     * @return {Number}
     */
    getAmount: function() {
      return n12;
    },
    /**
     * Returns the currency.
     *
     * @example
     * // returns 'EUR'
     * Dinero({ currency: 'EUR' }).getCurrency()
     *
     * @return {String}
     */
    getCurrency: function() {
      return a;
    },
    /**
     * Returns the locale.
     *
     * @example
     * // returns 'fr-FR'
     * Dinero().setLocale('fr-FR').getLocale()
     *
     * @return {String}
     */
    getLocale: function() {
      return this.locale || i;
    },
    /**
     * Returns a new Dinero object with an embedded locale.
     *
     * @param {String} newLocale - The new locale as an {@link http://tools.ietf.org/html/rfc5646 BCP 47 language tag}.
     *
     * @example
     * // Returns a Dinero object with locale 'ja-JP'
     * Dinero().setLocale('ja-JP')
     *
     * @return {Dinero}
     */
    setLocale: function(b) {
      return f.call(this, {
        locale: b
      });
    },
    /**
     * Returns the precision.
     *
     * @example
     * // returns 3
     * Dinero({ precision: 3 }).getPrecision()
     *
     * @return {Number}
     */
    getPrecision: function() {
      return o;
    },
    /**
     * Returns a new Dinero object with a new precision and a converted amount.
     *
     * By default, fractional minor currency units are rounded using the **half to even** rule ([banker's rounding](http://wiki.c2.com/?BankersRounding)).
     * This can be necessary when you need to convert objects to a smaller precision.
     *
     * Rounding *can* lead to accuracy issues as you chain many times. Consider a minimal amount of subsequent conversions for safer results.
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * @param {Number} newPrecision - The new precision.
     * @param {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // Returns a Dinero object with precision 3 and amount 1000
     * Dinero({ amount: 100, precision: 2 }).convertPrecision(3)
     *
     * @throws {TypeError} If `newPrecision` is invalid.
     *
     * @return {Dinero}
     */
    convertPrecision: function(b) {
      var z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c;
      Vd(b);
      var _ = this.getPrecision(), q = b > _, S = q ? p1.multiply : p1.divide, N = q ? [b, _] : [_, b], v = Math.pow(10, p1.subtract.apply(p1, N));
      return f.call(this, {
        amount: p1.round(S(this.getAmount(), v), z),
        precision: b
      });
    },
    /**
     * Returns a new Dinero object that represents the sum of this and an other Dinero object.
     *
     * If Dinero objects have a different `precision`, they will be first converted to the highest.
     *
     * @param {Dinero} addend - The Dinero object to add.
     *
     * @example
     * // returns a Dinero object with amount 600
     * Dinero({ amount: 400 }).add(Dinero({ amount: 200 }))
     * @example
     * // returns a Dinero object with amount 144545 and precision 4
     * Dinero({ amount: 400 }).add(Dinero({ amount: 104545, precision: 4 }))
     *
     * @throws {TypeError} If `addend` has a different currency.
     *
     * @return {Dinero}
     */
    add: function(b) {
      p.call(this, b);
      var z = t2.normalizePrecision([this, b]);
      return f.call(this, {
        amount: p1.add(z[0].getAmount(), z[1].getAmount()),
        precision: z[0].getPrecision()
      });
    },
    /**
     * Returns a new Dinero object that represents the difference of this and an other Dinero object.
     *
     * If Dinero objects have a different `precision`, they will be first converted to the highest.
     *
     * @param  {Dinero} subtrahend - The Dinero object to subtract.
     *
     * @example
     * // returns a Dinero object with amount 200
     * Dinero({ amount: 400 }).subtract(Dinero({ amount: 200 }))
     * @example
     * // returns a Dinero object with amount 64545 and precision 4
     * Dinero({ amount: 104545, precision: 4 }).subtract(Dinero({ amount: 400 }))
     *
     * @throws {TypeError} If `subtrahend` has a different currency.
     *
     * @return {Dinero}
     */
    subtract: function(b) {
      p.call(this, b);
      var z = t2.normalizePrecision([this, b]);
      return f.call(this, {
        amount: p1.subtract(z[0].getAmount(), z[1].getAmount()),
        precision: z[0].getPrecision()
      });
    },
    /**
     * Returns a new Dinero object that represents the multiplied value by the given factor.
     *
     * By default, fractional minor currency units are rounded using the **half to even** rule ([banker's rounding](http://wiki.c2.com/?BankersRounding)).
     *
     * Rounding *can* lead to accuracy issues as you chain many times. Consider a minimal amount of subsequent calculations for safer results.
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * @param  {Number} multiplier - The factor to multiply by.
     * @param  {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // returns a Dinero object with amount 1600
     * Dinero({ amount: 400 }).multiply(4)
     * @example
     * // returns a Dinero object with amount 800
     * Dinero({ amount: 400 }).multiply(2.001)
     * @example
     * // returns a Dinero object with amount 801
     * Dinero({ amount: 400 }).multiply(2.00125, 'HALF_UP')
     *
     * @return {Dinero}
     */
    multiply: function(b) {
      var z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s12;
      return f.call(this, {
        amount: p1.round(p1.multiply(this.getAmount(), b), z)
      });
    },
    /**
     * Returns a new Dinero object that represents the divided value by the given factor.
     *
     * By default, fractional minor currency units are rounded using the **half to even** rule ([banker's rounding](http://wiki.c2.com/?BankersRounding)).
     *
     * Rounding *can* lead to accuracy issues as you chain many times. Consider a minimal amount of subsequent calculations for safer results.
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * As rounding is applied, precision may be lost in the process. If you want to accurately split a Dinero object, use {@link module:Dinero~allocate allocate} instead.
     *
     * @param  {Number} divisor - The factor to divide by.
     * @param  {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // returns a Dinero object with amount 100
     * Dinero({ amount: 400 }).divide(4)
     * @example
     * // returns a Dinero object with amount 52
     * Dinero({ amount: 105 }).divide(2)
     * @example
     * // returns a Dinero object with amount 53
     * Dinero({ amount: 105 }).divide(2, 'HALF_UP')
     *
     * @return {Dinero}
     */
    divide: function(b) {
      var z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s12;
      return f.call(this, {
        amount: p1.round(p1.divide(this.getAmount(), b), z)
      });
    },
    /**
     * Returns a new Dinero object that represents a percentage of this.
     *
     * As rounding is applied, precision may be lost in the process. If you want to accurately split a Dinero object, use {@link module:Dinero~allocate allocate} instead.
     *
     * @param  {Number} percentage - The percentage to extract (between 0 and 100).
     * @param  {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // returns a Dinero object with amount 5000
     * Dinero({ amount: 10000 }).percentage(50)
     * @example
     * // returns a Dinero object with amount 29
     * Dinero({ amount: 57 }).percentage(50, "HALF_ODD")
     *
     * @throws {RangeError} If `percentage` is out of range.
     *
     * @return {Dinero}
     */
    percentage: function(b) {
      var z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s12;
      return wi0(b), this.multiply(p1.divide(b, 100), z);
    },
    /**
     * Allocates the amount of a Dinero object according to a list of ratios.
     *
     * Sometimes you need to split monetary values but percentages can't cut it without adding or losing pennies.
     * A good example is invoicing: let's say you need to bill $1,000.03 and you want a 50% downpayment.
     * If you use {@link module:Dinero~percentage percentage}, you'll get an accurate Dinero object but the amount won't be billable: you can't split a penny.
     * If you round it, you'll bill a penny extra.
     * With {@link module:Dinero~allocate allocate}, you can split a monetary amount then distribute the remainder as evenly as possible.
     *
     * You can use percentage style or ratio style for `ratios`: `[25, 75]` and `[1, 3]` will do the same thing.
     *
     * Since v1.8.0, you can use zero ratios (such as [0, 50, 50]). If there's a remainder to distribute, zero ratios are skipped and return a Dinero object with amount zero.
     *
     * @param  {Number[]} ratios - The ratios to allocate the money to.
     *
     * @example
     * // returns an array of two Dinero objects
     * // the first one with an amount of 502
     * // the second one with an amount of 501
     * Dinero({ amount: 1003 }).allocate([50, 50])
     * @example
     * // returns an array of two Dinero objects
     * // the first one with an amount of 25
     * // the second one with an amount of 75
     * Dinero({ amount: 100 }).allocate([1, 3])
     * @example
     * // since version 1.8.0
     * // returns an array of three Dinero objects
     * // the first one with an amount of 0
     * // the second one with an amount of 502
     * // the third one with an amount of 501
     * Dinero({ amount: 1003 }).allocate([0, 50, 50])
     *
     * @throws {TypeError} If ratios are invalid.
     *
     * @return {Dinero[]}
     */
    allocate: function(b) {
      var z = this;
      Bi0(b);
      for (var _ = b.reduce(function(v, C) {
        return p1.add(v, C);
      }), q = this.getAmount(), S = b.map(function(v) {
        var C = Math.floor(p1.divide(p1.multiply(z.getAmount(), v), _));
        return q = p1.subtract(q, C), f.call(z, {
          amount: C
        });
      }), N = 0; q > 0; )
        b[N] > 0 && (S[N] = S[N].add(f.call(this, {
          amount: 1
        })), q = p1.subtract(q, 1)), N += 1;
      return S;
    },
    /**
     * Returns a Promise containing a new Dinero object converted to another currency.
     *
     * You have two options to provide the exchange rates:
     *
     * 1. **Use an exchange rate REST API, and let Dinero handle the fetching and conversion.**
     *   This is a simple option if you have access to an exchange rate REST API and want Dinero to do the rest.
     * 2. **Fetch the exchange rates on your own and provide them directly.**
     *   This is useful if you're fetching your rates from somewhere else (a file, a database), use a different protocol or query language than REST (SOAP, GraphQL) or want to fetch rates once and cache them instead of making new requests every time.
     *
     * **If you want to use a REST API**, you must provide a third-party endpoint yourself. Dinero doesn't come bundled with an exchange rates endpoint.
     *
     * Here are some exchange rate APIs you can use:
     *
     * * [Fixer](https://fixer.io)
     * * [Open Exchange Rates](https://openexchangerates.org)
     * * [Coinbase](https://api.coinbase.com/v2/exchange-rates)
     * * More [foreign](https://github.com/toddmotto/public-apis#currency-exchange) and [crypto](https://github.com/toddmotto/public-apis#cryptocurrency) exchange rate APIs.
     *
     * **If you want to fetch your own rates and provide them directly**, you need to pass a promise that resolves to the exchanges rates.
     *
     * In both cases, you need to specify at least:
     *
     * * a **destination currency**: the currency in which you want to convert your Dinero object. You can specify it with `currency`.
     * * an **endpoint**: the API URL to query exchange rates, with parameters, or a promise that resolves to the exchange rates. You can specify it with `options.endpoint`.
     * * a **property path**: the path to access the wanted rate in your API's JSON response (or the custom promise's payload). For example, with a response of:
     * ```json
     * {
     *     "data": {
     *       "base": "USD",
     *       "destination": "EUR",
     *       "rate": "0.827728919"
     *     }
     * }
     * ```
     * Then the property path is `'data.rate'`. You can specify it with `options.propertyPath`.
     *
     * The base currency (the one of your Dinero object) and the destination currency can be used as "merge tags" with the mustache syntax, respectively `{{from}}` and `{{to}}`.
     * You can use these tags to refer to these values in `options.endpoint` and `options.propertyPath`.
     *
     * For example, if you need to specify the base currency as a query parameter, you can do the following:
     *
     * ```js
     * {
     *   endpoint: 'https://yourexchangerates.api/latest?base={{from}}'
     * }
     * ```
     *
     * @param  {String} currency - The destination currency, expressed as an {@link https://en.wikipedia.org/wiki/ISO_4217#Active_codes ISO 4217 currency code}.
     * @param  {(String|Promise)} options.endpoint - The API endpoint to retrieve exchange rates. You can substitute this with a promise that resolves to the exchanges rates if you already have them.
     * @param  {String} [options.propertyPath='rates.{{to}}'] - The property path to the rate.
     * @param  {Object} [options.headers] - The HTTP headers to provide, if needed.
     * @param  {String} [options.roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // your global API parameters
     * Dinero.globalExchangeRatesApi = { ... }
     *
     * // returns a Promise containing a Dinero object with the destination currency
     * // and the initial amount converted to the new currency.
     * Dinero({ amount: 500 }).convert('EUR')
     * @example
     * // returns a Promise containing a Dinero object,
     * // with specific API parameters and rounding mode for this specific instance.
     * Dinero({ amount: 500 })
     *   .convert('XBT', {
     *     endpoint: 'https://yourexchangerates.api/latest?base={{from}}',
     *     propertyPath: 'data.rates.{{to}}',
     *     headers: {
     *       'user-key': 'xxxxxxxxx'
     *     },
     *     roundingMode: 'HALF_UP'
     *   })
     * @example
     * // usage with exchange rates provided as a custom promise
     * // using the default `propertyPath` format (so it doesn't have to be specified)
     * const rates = {
     *   rates: {
     *     EUR: 0.81162
     *   }
     * }
     *
     * Dinero({ amount: 500 })
     *   .convert('EUR', {
     *     endpoint: new Promise(resolve => resolve(rates))
     *   })
     * @example
     * // usage with Promise.prototype.then and Promise.prototype.catch
     * Dinero({ amount: 500 })
     *   .convert('EUR')
     *   .then(dinero => {
     *     dinero.getCurrency() // returns 'EUR'
     *   })
     *   .catch(err => {
     *     // handle errors
     *   })
     * @example
     * // usage with async/await
     * (async () => {
     *   const price = await Dinero({ amount: 500 }).convert('EUR')
     *   price.getCurrency() // returns 'EUR'
     * })()
     *
     * @return {Promise}
     */
    convert: function(b) {
      var z = this, _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, q = _.endpoint, S = q === void 0 ? l2.endpoint : q, N = _.propertyPath, v = N === void 0 ? l2.propertyPath || "rates.{{to}}" : N, C = _.headers, L = C === void 0 ? l2.headers : C, B = _.roundingMode, P12 = B === void 0 ? s12 : B, j = Object.assign({}, {
        endpoint: S,
        propertyPath: v,
        headers: L,
        roundingMode: P12
      });
      return Ni0(j).getExchangeRate(this.getCurrency(), b).then(function($) {
        return Ns(!rs($), 'No rate was found for the destination currency "'.concat(b, '".'), TypeError), f.call(z, {
          amount: p1.round(p1.multiply(z.getAmount(), parseFloat($)), j.roundingMode),
          currency: b
        });
      });
    },
    /**
     * Checks whether the value represented by this object equals to the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 500, currency: 'EUR' }).equalsTo(Dinero({ amount: 500, currency: 'EUR' }))
     * @example
     * // returns false
     * Dinero({ amount: 500, currency: 'EUR' }).equalsTo(Dinero({ amount: 800, currency: 'EUR' }))
     * @example
     * // returns false
     * Dinero({ amount: 500, currency: 'USD' }).equalsTo(Dinero({ amount: 500, currency: 'EUR' }))
     * @example
     * // returns false
     * Dinero({ amount: 500, currency: 'USD' }).equalsTo(Dinero({ amount: 800, currency: 'EUR' }))
     * @example
     * // returns true
     * Dinero({ amount: 1000, currency: 'EUR', precision: 2 }).equalsTo(Dinero({ amount: 10000, currency: 'EUR', precision: 3 }))
     * @example
     * // returns false
     * Dinero({ amount: 10000, currency: 'EUR', precision: 2 }).equalsTo(Dinero({ amount: 10000, currency: 'EUR', precision: 3 }))
     *
     * @return {Boolean}
     */
    equalsTo: function(b) {
      return this.hasSameAmount(b) && this.hasSameCurrency(b);
    },
    /**
     * Checks whether the value represented by this object is less than the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 500 }).lessThan(Dinero({ amount: 800 }))
     * @example
     * // returns false
     * Dinero({ amount: 800 }).lessThan(Dinero({ amount: 500 }))
     * @example
     * // returns true
     * Dinero({ amount: 5000, precision: 3 }).lessThan(Dinero({ amount: 800 }))
     * @example
     * // returns false
     * Dinero({ amount: 800 }).lessThan(Dinero({ amount: 5000, precision: 3 }))
     *
     * @throws {TypeError} If `comparator` has a different currency.
     *
     * @return {Boolean}
     */
    lessThan: function(b) {
      p.call(this, b);
      var z = t2.normalizePrecision([this, b]);
      return z[0].getAmount() < z[1].getAmount();
    },
    /**
     * Checks whether the value represented by this object is less than or equal to the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 500 }).lessThanOrEqual(Dinero({ amount: 800 }))
     * @example
     * // returns true
     * Dinero({ amount: 500 }).lessThanOrEqual(Dinero({ amount: 500 }))
     * @example
     * // returns false
     * Dinero({ amount: 500 }).lessThanOrEqual(Dinero({ amount: 300 }))
     * @example
     * // returns true
     * Dinero({ amount: 5000, precision: 3 }).lessThanOrEqual(Dinero({ amount: 800 }))
     * @example
     * // returns true
     * Dinero({ amount: 5000, precision: 3 }).lessThanOrEqual(Dinero({ amount: 500 }))
     * @example
     * // returns false
     * Dinero({ amount: 800 }).lessThanOrEqual(Dinero({ amount: 5000, precision: 3 }))
     *
     * @throws {TypeError} If `comparator` has a different currency.
     *
     * @return {Boolean}
     */
    lessThanOrEqual: function(b) {
      p.call(this, b);
      var z = t2.normalizePrecision([this, b]);
      return z[0].getAmount() <= z[1].getAmount();
    },
    /**
     * Checks whether the value represented by this object is greater than the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns false
     * Dinero({ amount: 500 }).greaterThan(Dinero({ amount: 800 }))
     * @example
     * // returns true
     * Dinero({ amount: 800 }).greaterThan(Dinero({ amount: 500 }))
     * @example
     * // returns true
     * Dinero({ amount: 800 }).greaterThan(Dinero({ amount: 5000, precision: 3 }))
     * @example
     * // returns false
     * Dinero({ amount: 5000, precision: 3 }).greaterThan(Dinero({ amount: 800 }))
     *
     * @throws {TypeError} If `comparator` has a different currency.
     *
     * @return {Boolean}
     */
    greaterThan: function(b) {
      p.call(this, b);
      var z = t2.normalizePrecision([this, b]);
      return z[0].getAmount() > z[1].getAmount();
    },
    /**
     * Checks whether the value represented by this object is greater than or equal to the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 300 }))
     * @example
     * // returns true
     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 500 }))
     * @example
     * // returns false
     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 800 }))
     * @example
     * // returns true
     * Dinero({ amount: 800 }).greaterThanOrEqual(Dinero({ amount: 5000, precision: 3 }))
     * @example
     * // returns true
     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 5000, precision: 3 }))
     * @example
     * // returns false
     * Dinero({ amount: 5000, precision: 3 }).greaterThanOrEqual(Dinero({ amount: 800 }))
     *
     * @throws {TypeError} If `comparator` has a different currency.
     *
     * @return {Boolean}
     */
    greaterThanOrEqual: function(b) {
      p.call(this, b);
      var z = t2.normalizePrecision([this, b]);
      return z[0].getAmount() >= z[1].getAmount();
    },
    /**
     * Checks if the value represented by this object is zero.
     *
     * @example
     * // returns true
     * Dinero({ amount: 0 }).isZero()
     * @example
     * // returns false
     * Dinero({ amount: 100 }).isZero()
     *
     * @return {Boolean}
     */
    isZero: function() {
      return this.getAmount() === 0;
    },
    /**
     * Checks if the value represented by this object is positive.
     *
     * @example
     * // returns false
     * Dinero({ amount: -10 }).isPositive()
     * @example
     * // returns true
     * Dinero({ amount: 10 }).isPositive()
     * @example
     * // returns true
     * Dinero({ amount: 0 }).isPositive()
     *
     * @return {Boolean}
     */
    isPositive: function() {
      return this.getAmount() >= 0;
    },
    /**
     * Checks if the value represented by this object is negative.
     *
     * @example
     * // returns true
     * Dinero({ amount: -10 }).isNegative()
     * @example
     * // returns false
     * Dinero({ amount: 10 }).isNegative()
     * @example
     * // returns false
     * Dinero({ amount: 0 }).isNegative()
     *
     * @return {Boolean}
     */
    isNegative: function() {
      return this.getAmount() < 0;
    },
    /**
     * Checks if this has minor currency units.
     * Deprecates {@link module:Dinero~hasCents hasCents}.
     *
     * @example
     * // returns false
     * Dinero({ amount: 1100 }).hasSubUnits()
     * @example
     * // returns true
     * Dinero({ amount: 1150 }).hasSubUnits()
     *
     * @return {Boolean}
     */
    hasSubUnits: function() {
      return p1.modulo(this.getAmount(), Math.pow(10, o)) !== 0;
    },
    /**
     * Checks if this has minor currency units.
     *
     * @deprecated since version 1.4.0, will be removed in 2.0.0
     * Use {@link module:Dinero~hasSubUnits hasSubUnits} instead.
     *
     * @example
     * // returns false
     * Dinero({ amount: 1100 }).hasCents()
     * @example
     * // returns true
     * Dinero({ amount: 1150 }).hasCents()
     *
     * @return {Boolean}
     */
    hasCents: function() {
      return p1.modulo(this.getAmount(), Math.pow(10, o)) !== 0;
    },
    /**
     * Checks whether the currency represented by this object equals to the other.
     *
     * @param  {Dinero}  comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 2000, currency: 'EUR' }).hasSameCurrency(Dinero({ amount: 1000, currency: 'EUR' }))
     * @example
     * // returns false
     * Dinero({ amount: 1000, currency: 'EUR' }).hasSameCurrency(Dinero({ amount: 1000, currency: 'USD' }))
     *
     * @return {Boolean}
     */
    hasSameCurrency: function(b) {
      return this.getCurrency() === b.getCurrency();
    },
    /**
     * Checks whether the amount represented by this object equals to the other.
     *
     * @param  {Dinero}  comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 1000, currency: 'EUR' }).hasSameAmount(Dinero({ amount: 1000 }))
     * @example
     * // returns false
     * Dinero({ amount: 2000, currency: 'EUR' }).hasSameAmount(Dinero({ amount: 1000, currency: 'EUR' }))
     * @example
     * // returns true
     * Dinero({ amount: 1000, currency: 'EUR', precision: 2 }).hasSameAmount(Dinero({ amount: 10000, precision: 3 }))
     * @example
     * // returns false
     * Dinero({ amount: 10000, currency: 'EUR', precision: 2 }).hasSameAmount(Dinero({ amount: 10000, precision: 3 }))
     *
     * @return {Boolean}
     */
    hasSameAmount: function(b) {
      var z = t2.normalizePrecision([this, b]);
      return z[0].getAmount() === z[1].getAmount();
    },
    /**
     * Returns this object formatted as a string.
     *
     * The format is a mask which defines how the output string will be formatted.
     * It defines whether to display a currency, in what format, how many fraction digits to display and whether to use grouping separators.
     * The output is formatted according to the applying locale.
     *
     * Object                       | Format            | String
     * :--------------------------- | :---------------- | :---
     * `Dinero({ amount: 500050 })` | `'$0,0.00'`       | $5,000.50
     * `Dinero({ amount: 500050 })` | `'$0,0'`          | $5,001
     * `Dinero({ amount: 500050 })` | `'$0'`            | $5001
     * `Dinero({ amount: 500050 })` | `'$0.0'`          | $5000.5
     * `Dinero({ amount: 500050 })` | `'USD0,0.0'`      | USD5,000.5
     * `Dinero({ amount: 500050 })` | `'0,0.0 dollar'`  | 5,000.5 dollars
     *
     * Don't try to substitute the `$` sign or the `USD` code with your target currency, nor adapt the format string to the exact format you want.
     * The format is a mask which defines a pattern and returns a valid, localized currency string.
     * If you want to display the object in a custom way, either use {@link module:Dinero~getAmount getAmount}, {@link module:Dinero~toUnit toUnit} or {@link module:Dinero~toRoundedUnit toRoundedUnit} and manipulate the output string as you wish.
     *
     * {@link module:Dinero~toFormat toFormat} wraps around `Number.prototype.toLocaleString`. For that reason, **format will vary depending on how it's implemented in the end user's environment**.
     *
     * You can also use `toLocaleString` directly:
     * `Dinero().toRoundedUnit(digits, roundingMode).toLocaleString(locale, options)`.
     *
     * By default, amounts are rounded using the **half away from zero** rule ([commercial rounding](https://en.wikipedia.org/wiki/Rounding#Round_half_away_from_zero)).
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * @param  {String} [format='$0,0.00'] - The format mask to format to.
     * @param  {String} [roundingMode='HALF_AWAY_FROM_ZERO'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // returns $2,000
     * Dinero({ amount: 200000 }).toFormat('$0,0')
     * @example
     * // returns €50.5
     * Dinero({ amount: 5050, currency: 'EUR' }).toFormat('$0,0.0')
     * @example
     * // returns 100 euros
     * Dinero({ amount: 10000, currency: 'EUR' }).setLocale('fr-FR').toFormat('0,0 dollar')
     * @example
     * // returns 2000
     * Dinero({ amount: 200000, currency: 'EUR' }).toFormat()
     * @example
     * // returns $10
     * Dinero({ amount: 1050 }).toFormat('$0', 'HALF_EVEN')
     *
     * @return {String}
     */
    toFormat: function() {
      var b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : u, z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c, _ = Wi0(b);
      return this.toRoundedUnit(_.getMinimumFractionDigits(), z).toLocaleString(this.getLocale(), {
        currencyDisplay: _.getCurrencyDisplay(),
        useGrouping: _.getUseGrouping(),
        minimumFractionDigits: _.getMinimumFractionDigits(),
        style: _.getStyle(),
        currency: this.getCurrency()
      });
    },
    /**
     * Returns the amount represented by this object in units.
     *
     * @example
     * // returns 10.5
     * Dinero({ amount: 1050 }).toUnit()
     * @example
     * // returns 10.545
     * Dinero({ amount: 10545, precision: 3 }).toUnit()
     *
     * @return {Number}
     */
    toUnit: function() {
      return p1.divide(this.getAmount(), Math.pow(10, o));
    },
    /**
     * Returns the amount represented by this object in rounded units.
     *
     * By default, the method uses the **half away from zero** rule ([commercial rounding](https://en.wikipedia.org/wiki/Rounding#Round_half_away_from_zero)).
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * @example
     * // returns 10.6
     * Dinero({ amount: 1055 }).toRoundedUnit(1)
     * @example
     * // returns 10
     * Dinero({ amount: 1050 }).toRoundedUnit(0, 'HALF_EVEN')
     *
     * @param  {Number} digits - The number of fraction digits to round to.
     * @param  {String} [roundingMode='HALF_AWAY_FROM_ZERO'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @return {Number}
     */
    toRoundedUnit: function(b) {
      var z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c, _ = Math.pow(10, b);
      return p1.divide(p1.round(p1.multiply(this.toUnit(), _), z), _);
    },
    /**
     * Returns the object's data as an object literal.
     *
     * @example
     * // returns { amount: 500, currency: 'EUR', precision: 2 }
     * Dinero({ amount: 500, currency: 'EUR', precision: 2 }).toObject()
     *
     * @return {Object}
     */
    toObject: function() {
      return {
        amount: n12,
        currency: a,
        precision: o
      };
    },
    /**
     * Returns the object's data as an object literal.
     *
     * Alias of {@link module:Dinero~toObject toObject}.
     * It is defined so that calling `JSON.stringify` on a Dinero object will automatically extract the relevant data.
     *
     * @example
     * // returns '{"amount":500,"currency":"EUR","precision":2}'
     * JSON.stringify(Dinero({ amount: 500, currency: 'EUR', precision: 2 }))
     *
     * @return {Object}
     */
    toJSON: function() {
      return this.toObject();
    }
  };
}, Ui0 = Object.assign(xi0, vi0, mi0, Si0);
const ki0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ui0
}, Symbol.toStringTag, { value: "Module" })), ji0 = /* @__PURE__ */ hp(ki0);
var Pre;
function Fi0() {
  return Pre || (Pre = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.currencyFormat = t16.DataCurrencies = void 0;
    var e = Z0, r12 = ji0, n12 = Ac();
    t16.DataCurrencies = [{
      id: 1,
      isActive: true,
      isBaseCurrency: true,
      code: "USD",
      precision: 2,
      cultureCode: "en-US",
      symbol: "$"
    }];
    function a(o, i) {
      var u = e.__assign(e.__assign({}, t16.DataCurrencies.find(function(f) {
        return f.isBaseCurrency;
      })), (i == null ? void 0 : i.currency) || {}), s12 = n12.numbersRoundScaled(o, u.precision), c = "";
      try {
        c = r12.default({
          amount: Math.abs(s12),
          currency: u.code,
          precision: u.precision
        }).setLocale(u.cultureCode).toFormat((i != null && i.showCurrencyCode ? "USD" : "$") + "0,0" + (u.precision > 0 ? "." + "0".repeat(u.precision) : ""));
      } catch {
        var l2 = Math.abs(s12).toLocaleString(u.cultureCode || "en-US", {
          minimumFractionDigits: u.precision,
          maximumFractionDigits: u.precision
        });
        c = "" + (i != null && i.showCurrencyCode ? u.code + " " : u.symbol) + l2;
      }
      return s12 >= 0 ? c : i != null && i.showNegatives ? "-" + c : "(" + c + ")";
    }
    t16.currencyFormat = a;
  })(Fd)), Fd;
}
var Dre;
function A1() {
  return Dre || (Dre = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true });
    var e = Z0;
    e.__exportStar(wi(), t16), e.__exportStar(Va(), t16), e.__exportStar(bi0(), t16), e.__exportStar(Mi0(), t16), e.__exportStar(eXe(), t16), e.__exportStar(Oi0(), t16), e.__exportStar(Qee(), t16), e.__exportStar(zi0(), t16), e.__exportStar(Ai0(), t16), e.__exportStar(_i0(), t16), e.__exportStar(hi0(), t16), e.__exportStar(Fi0(), t16);
  })(kd)), kd;
}
var Hd = {}, lu = {}, pu = {}, Wre;
function mp() {
  if (Wre)
    return pu;
  Wre = 1, Object.defineProperty(pu, "__esModule", { value: true }), pu.PromiseObject = void 0;
  var t16 = (
    /** @class */
    /* @__PURE__ */ (function() {
      function e() {
        var r12 = this;
        this.resolved = false, this.rejected = false, this.finished = false, this.promise = new Promise(function(n12, a) {
          r12.resolve = function(o) {
            if (!r12.finished)
              return r12.resolved = true, r12.finished = true, n12(o);
          }, r12.reject = function(o) {
            if (!r12.finished)
              return r12.rejected = true, r12.finished = true, a(o);
          };
        });
      }
      return e;
    })()
  );
  return pu.PromiseObject = t16, pu;
}
var Nre;
function Vi0() {
  if (Nre)
    return lu;
  Nre = 1, Object.defineProperty(lu, "__esModule", { value: true }), lu.Debouncer = void 0;
  var t16 = Z0, e = mp(), r12 = (
    /** @class */
    (function() {
      function n12(a) {
        this.timeout = a, this.handle = -1, this.promise = new e.PromiseObject();
      }
      return n12.prototype.run = function(a) {
        return t16.__awaiter(this, void 0, void 0, function() {
          var o = this;
          return t16.__generator(this, function(i) {
            return window.clearTimeout(this.handle), this.handle = window.setTimeout(function() {
              return t16.__awaiter(o, void 0, void 0, function() {
                var u, s12, c;
                return t16.__generator(this, function(l2) {
                  switch (l2.label) {
                    case 0:
                      return l2.trys.push([0, 2, 3, 4]), s12 = (u = this.promise).resolve, [4, a()];
                    case 1:
                      return s12.apply(u, [l2.sent()]), [3, 4];
                    case 2:
                      return c = l2.sent(), this.promise.reject(c), [3, 4];
                    case 3:
                      return this.promise = new e.PromiseObject(), [
                        7
                        /*endfinally*/
                      ];
                    case 4:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, this.timeout), [2, this.promise.promise];
          });
        });
      }, n12;
    })()
  );
  return lu.Debouncer = r12, lu;
}
var du = {}, wre;
function aXe() {
  if (wre)
    return du;
  wre = 1, Object.defineProperty(du, "__esModule", { value: true }), du.GateLock = void 0;
  var t16 = mp(), e = (
    /** @class */
    (function() {
      function r12() {
        this.promise = new t16.PromiseObject(), this.promise.resolve(void 0);
      }
      return r12.prototype.close = function() {
        return this.promise = new t16.PromiseObject(), this.wait();
      }, r12.prototype.isClosed = function() {
        return !this.promise.finished;
      }, r12.prototype.wait = function() {
        return this.promise.promise;
      }, r12.prototype.open = function(n12) {
        this.promise.resolve(n12);
      }, r12;
    })()
  );
  return du.GateLock = e, du;
}
var fu = {}, Bre;
function Hi0() {
  if (Bre)
    return fu;
  Bre = 1, Object.defineProperty(fu, "__esModule", { value: true }), fu.PromiseQueue = void 0;
  var t16 = Z0, e = mp(), r12 = (
    /** @class */
    (function() {
      function n12(a, o, i) {
        a === void 0 && (a = true), o === void 0 && (o = function() {
        }), i === void 0 && (i = function() {
        }), this.clearOnError = a, this.onEmpty = o, this.onClear = i, this.queue = [];
      }
      return n12.prototype.run = function(a, o) {
        var i = new e.PromiseObject(), u = {
          provider: a,
          object: i,
          data: o
        };
        return this.queue.push(u), this.queue.length === 1 && this.dequeue(), i.promise;
      }, n12.prototype.length = function() {
        return this.queue.length;
      }, n12.prototype.dequeue = function() {
        return t16.__awaiter(this, void 0, void 0, function() {
          var a, o, i, u;
          return t16.__generator(this, function(s12) {
            switch (s12.label) {
              case 0:
                if (a = this.queue[0], !a)
                  return this.onEmpty(), [2, false];
                s12.label = 1;
              case 1:
                return s12.trys.push([1, 3, 4, 5]), [4, a.provider()];
              case 2:
                return o = s12.sent(), a.object.resolve(o), [3, 5];
              case 3:
                return i = s12.sent(), a.object.reject(i), this.clearOnError && (u = this.queue.slice(1), this.queue = [], this.onClear(u)), [3, 5];
              case 4:
                return this.queue.shift(), this.dequeue(), [
                  7
                  /*endfinally*/
                ];
              case 5:
                return [2, true];
            }
          });
        });
      }, n12;
    })()
  );
  return fu.PromiseQueue = r12, fu;
}
var bu = {}, xre;
function Xi0() {
  if (xre)
    return bu;
  xre = 1, Object.defineProperty(bu, "__esModule", { value: true }), bu.ReentrantLock = void 0;
  var t16 = Z0, e = aXe(), r12 = (
    /** @class */
    (function() {
      function n12() {
        this.gate = new e.GateLock();
      }
      return n12.prototype.lock = function(a) {
        return t16.__awaiter(this, void 0, void 0, function() {
          var o;
          return t16.__generator(this, function(i) {
            switch (i.label) {
              case 0:
                return this.gate.isClosed() ? [4, this.gate.wait()] : [3, 2];
              case 1:
                return i.sent(), [3, 0];
              case 2:
                return this.gate.close(), [4, a()];
              case 3:
                return o = i.sent(), this.gate.open(), [2, o];
            }
          });
        });
      }, n12;
    })()
  );
  return bu.ReentrantLock = r12, bu;
}
var Mu = {}, Ure;
function $i0() {
  if (Ure)
    return Mu;
  Ure = 1, Object.defineProperty(Mu, "__esModule", { value: true }), Mu.Throttle = void 0;
  var t16 = (
    /** @class */
    (function() {
      function e(r12) {
        this.frequency = r12, this.lastRun = 0, this.handle = -1, this.nextRun = function() {
        };
      }
      return e.prototype.completeNext = function() {
        this.nextRun(), this.nextRun = function() {
        }, this.handle = -1, this.lastRun = Date.now();
      }, e.prototype.run = function(r12) {
        var n12 = this, a = Date.now(), o = a - this.lastRun;
        o >= this.frequency ? (r12(), this.lastRun = a) : (this.handle === -1 && (this.handle = window.setTimeout(function() {
          return n12.completeNext();
        }, this.frequency)), this.nextRun = r12);
      }, e;
    })()
  );
  return Mu.Throttle = t16, Mu;
}
var Ou = {}, kre;
function Gi0() {
  if (kre)
    return Ou;
  kre = 1, Object.defineProperty(Ou, "__esModule", { value: true }), Ou.wait = void 0;
  function t16(e) {
    return new Promise(function(r12) {
      setTimeout(r12, e);
    });
  }
  return Ou.wait = t16, Ou;
}
var jre;
function Yi0() {
  return jre || (jre = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true });
    var e = Z0;
    e.__exportStar(Vi0(), t16), e.__exportStar(aXe(), t16), e.__exportStar(mp(), t16), e.__exportStar(Hi0(), t16), e.__exportStar(Xi0(), t16), e.__exportStar($i0(), t16), e.__exportStar(Gi0(), t16);
  })(Hd)), Hd;
}
var Xd = {}, zu = {}, Fre;
function Ji0() {
  if (Fre)
    return zu;
  Fre = 1, Object.defineProperty(zu, "__esModule", { value: true }), zu.Node = void 0;
  var t16 = (
    /** @class */
    (function() {
      function e(r12) {
        this.value = r12, this.next = this.prev = this;
      }
      return e.prototype.forEach = function(r12) {
        for (var n12 = this.next, a = 0; n12 !== this; ) {
          var o = n12.next;
          r12(n12.value, n12, a), n12 = o, a++;
        }
        return a;
      }, e.prototype.toArray = function() {
        var r12 = [];
        return this.forEach(function(n12) {
          return r12.push(n12);
        }), r12;
      }, e.prototype.insertAfter = function(r12) {
        this.next = r12.next, this.prev = r12, this.prev.next = this.next.prev = this;
      }, e.prototype.push = function(r12) {
        r12.insertAfter(this.prev);
      }, e.prototype.remove = function() {
        this.isEmpty() || (this.next.prev = this.prev, this.prev.next = this.next, this.prev = this.next = this);
      }, e.prototype.isEmpty = function() {
        return this.next === this;
      }, e.head = function() {
        return new e(null);
      }, e;
    })()
  );
  return zu.Node = t16, zu;
}
var Vre;
function Ki0() {
  return Vre || (Vre = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true });
    var e = Z0;
    e.__exportStar(Ji0(), t16);
  })(Xd)), Xd;
}
var $d = {}, Gd = {}, Hre;
function Qi0() {
  return Hre || (Hre = 1, Object.defineProperty(Gd, "__esModule", { value: true })), Gd;
}
var Au = {}, Xre;
function Sn() {
  if (Xre)
    return Au;
  Xre = 1, Object.defineProperty(Au, "__esModule", { value: true }), Au.fixFormat = void 0;
  function t16(e, r12) {
    return r12 != null && r12.prefix && (e = r12.prefix + e), r12 != null && r12.suffix && (e = e + r12.suffix), e;
  }
  return Au.fixFormat = t16, Au;
}
var _u = {}, hu = {}, $re;
function Zi0() {
  if ($re)
    return hu;
  $re = 1, Object.defineProperty(hu, "__esModule", { value: true }), hu.boolean = void 0;
  var t16 = A1();
  return hu.boolean = {
    label: "Boolean",
    description: "A True/False or Yes/No value. A boolean constant is true() or false()",
    compatible: ["boolean"],
    aggregate: false,
    baseType: "boolean",
    defaultAlignment: "center",
    defaultHeaderAlignment: "center",
    detectPriority: 4,
    statsSupported: ["nulls", "values"],
    stats: t16.booleansStats,
    matches: t16.booleansMatch,
    compare: t16.booleansCompare,
    detect: function(e) {
      return t16.isBoolean(e);
    },
    parse: function(e) {
      return t16.booleansParse(e);
    },
    format: function(e, r12, n12) {
      return e ? (n12 == null ? void 0 : n12.trueLabel) || "Yes" : (n12 == null ? void 0 : n12.falseLabel) || "No";
    }
  }, hu;
}
var vu = {}, Gre;
function eu0() {
  if (Gre)
    return vu;
  Gre = 1, Object.defineProperty(vu, "__esModule", { value: true }), vu.character = void 0;
  var t16 = A1(), e = Sn();
  return vu.character = {
    label: "Character",
    description: 'A text value. A character constant is surrounded by double quotes, like "Hello World"',
    compatible: ["character"],
    aggregate: false,
    baseType: "character",
    defaultAlignment: "left",
    defaultHeaderAlignment: "left",
    detectPriority: 5,
    statsSupported: ["min", "max", "nulls", "values"],
    stats: t16.textStats,
    matches: t16.textMatch,
    compare: t16.textCompare,
    detect: function(r12) {
      return t16.isString(r12);
    },
    parse: function(r12) {
      return t16.textTo(r12);
    },
    format: function(r12, n12, a) {
      return e.fixFormat(t16.textTo(r12), a);
    }
  }, vu;
}
var mu = {}, Yre;
function tu0() {
  if (Yre)
    return mu;
  Yre = 1, Object.defineProperty(mu, "__esModule", { value: true }), mu.currency = void 0;
  var t16 = A1(), e = Sn();
  return mu.currency = {
    label: "Currency",
    description: "A monetary value. A constant value should not have monetary symbols.",
    compatible: ["integer", "currency", "numeric", "quantity", "percent", "rate"],
    aggregate: true,
    baseType: "numeric",
    defaultAlignment: "right",
    defaultHeaderAlignment: "center",
    statsSupported: ["min", "max", "sum", "nulls"],
    stats: t16.numbersStats,
    matches: t16.numbersMatch,
    compare: t16.numbersCompare,
    parse: function(r12) {
      return t16.numbersParse(r12, false);
    },
    format: function(r12, n12, a) {
      if (!t16.isNumber(r12) || !isFinite(r12))
        return "";
      var o;
      if (n12 && a && a.currencyProperty) {
        var i = t16.getProperty(n12, a.currencyProperty);
        i && (o = t16.DataCurrencies.find(function(u) {
          return u.id === i;
        }));
      }
      return a && a.currency && (o = t16.DataCurrencies.find(function(u) {
        return u.id === a.currency;
      })), o || (o = t16.DataCurrencies.find(function(u) {
        return u.isBaseCurrency && u.isActive;
      })), o ? e.fixFormat(t16.currencyFormat(r12, {
        currency: o,
        showNegatives: a == null ? void 0 : a.showNegatives,
        showCurrencyCode: a == null ? void 0 : a.showCurrencyCode
      }), a) : e.fixFormat(String(r12), a);
    }
  }, mu;
}
var Ru = {}, Jre;
function ru0() {
  if (Jre)
    return Ru;
  Jre = 1, Object.defineProperty(Ru, "__esModule", { value: true }), Ru.date = void 0;
  var t16 = zc(), e = A1(), r12 = Sn();
  return Ru.date = {
    label: "Date",
    description: "A date & optionally time value.",
    compatible: ["date"],
    aggregate: false,
    baseType: "date",
    defaultAlignment: "left",
    defaultHeaderAlignment: "left",
    detectPriority: 3,
    statsSupported: ["max", "min", "nulls"],
    stats: e.dateStats,
    matches: e.dateMatch,
    compare: e.dateCompare,
    detect: function(n12) {
      return e.isString(n12) || n12 instanceof Date ? e.dateParse(n12) !== null : false;
    },
    parse: function(n12, a) {
      return e.dateParse(n12, false, a == null ? void 0 : a.dateOptions);
    },
    format: function(n12, a, o) {
      var i = e.dateParse(n12, false, o == null ? void 0 : o.dateOptions);
      if (!i)
        return "";
      var u = o && o.dateFormat ? o.dateFormat : i.hour === 0 && i.minute === 0 && i.second === 0 ? t16.DateTime.DATE_SHORT : t16.DateTime.DATETIME_SHORT;
      return r12.fixFormat(i.toLocaleString(u), o);
    }
  }, Ru;
}
var qu = {}, Kre;
function nu0() {
  if (Kre)
    return qu;
  Kre = 1, Object.defineProperty(qu, "__esModule", { value: true }), qu.daterange = void 0;
  var t16 = Z0, e = zc(), r12 = A1();
  function n12(a, o) {
    if (a) {
      var i = r12.getProperty(a, (o == null ? void 0 : o.dateStartProperty) || "start"), u = r12.getProperty(a, (o == null ? void 0 : o.dateEndProperty) || "end"), s12 = r12.dateParse(i, false, o == null ? void 0 : o.dateOptions), c = r12.dateParse(u, false, o == null ? void 0 : o.dateOptions);
      if (s12 && c) {
        var l2 = s12.toMillis() < c.toMillis(), f = l2 ? s12 : c, p = l2 ? c : s12;
        return [f, p];
      }
    }
    return [];
  }
  return qu.daterange = {
    label: "Date Range",
    description: "A range made of two dates & optional time values.",
    compatible: ["daterange"],
    aggregate: false,
    baseType: "daterange",
    defaultAlignment: "left",
    defaultHeaderAlignment: "left",
    detectPriority: 3,
    statsSupported: ["min", "max"],
    stats: function(a, o) {
      var i = a.map(function(s12) {
        return n12(s12, o);
      }), u = i.map(function(s12) {
        return s12[0];
      }).concat(i.map(function(s12) {
        return s12[1];
      }));
      return r12.dateStats(u);
    },
    matches: function(a, o, i) {
      var u = t16.__read(n12(a, i), 2), s12 = u[0], c = u[1];
      return !s12 || !c ? true : !(o.min instanceof e.DateTime && c.toMillis() < o.min.toMillis() || o.max instanceof e.DateTime && s12.toMillis() > o.max.toMillis());
    },
    compare: function(a, o, i) {
      var u = t16.__read(n12(a, i), 2), s12 = u[0], c = u[1], l2 = t16.__read(n12(o, i), 2), f = l2[0], p = l2[1];
      return !s12 || !c || !f || !p ? 0 : c.toMillis() < f.toMillis() ? -1 : s12.toMillis() > p.toMillis() ? 1 : 0;
    },
    detect: function(a) {
      return a instanceof Object ? Object.keys(a).every(function(o) {
        return r12.dateParse(a[o]) !== null;
      }) : false;
    },
    parse: n12,
    format: function(a, o, i) {
      var u = t16.__read(n12(a, i), 2), s12 = u[0], c = u[1];
      if (!s12 || !c)
        return "";
      var l2 = i != null && i.dateFormat ? i == null ? void 0 : i.dateFormat : s12.hour > 0 || s12.minute > 0 || s12.second > 0 ? e.DateTime.DATETIME_SHORT : e.DateTime.DATE_SHORT, f = i != null && i.dateFormat ? i == null ? void 0 : i.dateFormat : c.hour > 0 || c.minute > 0 || c.second > 0 ? e.DateTime.DATETIME_SHORT : e.DateTime.DATE_SHORT;
      return s12.toLocaleString(l2) + " - " + c.toLocaleString(f);
    }
  }, qu;
}
var Tu = {}, Qre;
function au0() {
  if (Qre)
    return Tu;
  Qre = 1, Object.defineProperty(Tu, "__esModule", { value: true }), Tu.dateinterval = void 0;
  var t16 = A1();
  return Tu.dateinterval = {
    label: "DateInterval",
    description: [
      "A text expression representing an interval of time. Possible values:",
      '- "d" = Day',
      '- "y" = Day',
      '- "h" = Hour',
      '- "n" = Minute',
      '- "m" = Month',
      '- "q" = Quarter',
      '- "s" = Second',
      '- "w" = Week',
      '- "ww" = Calendar Week',
      '- "yyyy" = Year'
    ].join(`
`),
    compatible: ["dateinterval"],
    aggregate: false,
    baseType: "character",
    defaultAlignment: "left",
    defaultHeaderAlignment: "left",
    statsSupported: ["min", "max", "nulls", "values"],
    stats: t16.textStats,
    matches: t16.textMatch,
    compare: t16.textCompare,
    parse: function(e) {
      return t16.dateIntervalParse(e, false);
    },
    format: function(e) {
      return String(e);
    }
  }, Tu;
}
var yu = {}, Zre;
function ou0() {
  if (Zre)
    return yu;
  Zre = 1, Object.defineProperty(yu, "__esModule", { value: true }), yu.integer = void 0;
  var t16 = A1(), e = Sn();
  return yu.integer = {
    label: "Integer",
    description: "A whole number value.",
    compatible: ["integer", "currency", "numeric", "quantity", "percent", "rate"],
    aggregate: true,
    baseType: "numeric",
    defaultAlignment: "right",
    defaultHeaderAlignment: "center",
    detectPriority: 1,
    statsSupported: ["min", "max", "sum", "nulls"],
    stats: t16.numbersStats,
    matches: t16.numbersMatch,
    compare: t16.numbersCompare,
    detect: function(r12) {
      return t16.isNumber(r12) && t16.numbersEqual(r12, t16.numbersTruncate(r12));
    },
    parse: function(r12) {
      return t16.integersParse(r12, false);
    },
    format: function(r12, n12, a) {
      return !t16.isNumber(r12) || !isFinite(r12) ? "" : e.fixFormat(parseInt(r12, 10).toFixed(0), a);
    }
  }, yu;
}
var Su = {}, ene;
function iu0() {
  if (ene)
    return Su;
  ene = 1, Object.defineProperty(Su, "__esModule", { value: true }), Su.markup = void 0;
  var t16 = A1(), e = Sn();
  return Su.markup = {
    label: "Markup",
    description: "A markup value.",
    compatible: ["integer", "currency", "numeric", "quantity", "percent", "rate"],
    aggregate: false,
    baseType: "numeric",
    defaultAlignment: "right",
    defaultHeaderAlignment: "center",
    statsSupported: ["min", "max", "nulls", "values"],
    stats: t16.textStats,
    matches: t16.textMatch,
    compare: t16.textCompare,
    parse: function(r12) {
      return t16.textTo(r12);
    },
    format: function(r12, n12, a) {
      return e.fixFormat(t16.textTo(r12), a);
    }
  }, Su;
}
var Cu = {}, tne;
function uu0() {
  if (tne)
    return Cu;
  tne = 1, Object.defineProperty(Cu, "__esModule", { value: true }), Cu.numeric = void 0;
  var t16 = Z0, e = A1(), r12 = Sn();
  return Cu.numeric = {
    label: "Numeric",
    description: "A number value.",
    compatible: ["integer", "currency", "numeric", "quantity", "percent", "rate"],
    aggregate: true,
    baseType: "numeric",
    defaultAlignment: "right",
    defaultHeaderAlignment: "center",
    detectPriority: 2,
    statsSupported: ["min", "max", "sum", "nulls"],
    stats: e.numbersStats,
    matches: e.numbersMatch,
    compare: e.numbersCompare,
    detect: function(n12) {
      return e.isNumber(n12);
    },
    parse: function(n12) {
      return e.numbersParse(n12, false);
    },
    format: function(n12, a, o) {
      if (!e.isNumber(n12) || !isFinite(n12))
        return "";
      var i = "";
      if (o && e.isNumber(o.decimalPlaces) ? i = e.numbersFormatted(n12, o.decimalPlaces, o.decimalPlacesMinimum) : i = e.numbersFormatted(n12, 4, 0), o != null && o.commaless)
        return r12.fixFormat(i, o);
      var u = t16.__read(i.split("."), 2), s12 = u[0], c = u[1], l2 = s12.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (c ? "." + c : "");
      return r12.fixFormat(l2, o);
    }
  }, Cu;
}
var gu = {}, rne;
function su0() {
  if (rne)
    return gu;
  rne = 1, Object.defineProperty(gu, "__esModule", { value: true }), gu.percent = void 0;
  var t16 = Z0, e = A1(), r12 = Sn();
  return gu.percent = {
    label: "Percent",
    description: "A quantity value.",
    compatible: ["integer", "currency", "numeric", "quantity", "percent", "rate"],
    aggregate: false,
    baseType: "numeric",
    defaultAlignment: "right",
    defaultHeaderAlignment: "center",
    statsSupported: ["min", "max", "sum", "nulls"],
    stats: e.numbersStats,
    matches: e.numbersMatch,
    compare: e.numbersCompare,
    parse: function(n12) {
      return e.numbersParse(n12, false);
    },
    format: function(n12, a, o) {
      if (!e.isNumber(n12) || !isFinite(n12))
        return "";
      o != null && o.percentScaled || (n12 *= 100);
      var i = o && e.isNumber(o.decimalPlaces) ? o.decimalPlaces : 2, u = e.numbersFormatted(n12, i, o == null ? void 0 : o.decimalPlacesMinimum);
      return r12.fixFormat(u, t16.__assign({ suffix: "%" }, o || {}));
    }
  }, gu;
}
var Iu = {}, nne;
function cu0() {
  if (nne)
    return Iu;
  nne = 1, Object.defineProperty(Iu, "__esModule", { value: true }), Iu.quantity = void 0;
  var t16 = A1(), e = Sn();
  return Iu.quantity = {
    label: "Quantity",
    description: "A quantity value.",
    compatible: ["integer", "currency", "numeric", "quantity", "percent", "rate"],
    aggregate: true,
    baseType: "numeric",
    defaultAlignment: "right",
    defaultHeaderAlignment: "center",
    statsSupported: ["min", "max", "sum", "nulls"],
    stats: t16.numbersStats,
    matches: t16.numbersMatch,
    compare: t16.numbersCompare,
    parse: function(r12) {
      return t16.numbersParse(r12, false);
    },
    format: function(r12, n12, a) {
      if (!t16.isNumber(r12) || !isFinite(r12))
        return "";
      var o = a && t16.isNumber(a.decimalPlaces) ? a.decimalPlaces : 0, i = t16.numbersFormatted(r12, o, a == null ? void 0 : a.decimalPlacesMinimum);
      return e.fixFormat(i, a);
    }
  }, Iu;
}
var Eu = {}, ane;
function lu0() {
  if (ane)
    return Eu;
  ane = 1, Object.defineProperty(Eu, "__esModule", { value: true }), Eu.rate = void 0;
  var t16 = Z0, e = A1(), r12 = Sn();
  return Eu.rate = {
    label: "Rate",
    description: "A monetary value with 4 decimal places.",
    compatible: ["integer", "currency", "numeric", "quantity", "percent", "rate"],
    aggregate: true,
    baseType: "numeric",
    defaultAlignment: "right",
    defaultHeaderAlignment: "center",
    statsSupported: ["min", "max", "sum", "nulls"],
    stats: e.numbersStats,
    matches: e.numbersMatch,
    compare: e.numbersCompare,
    parse: function(n12) {
      return e.numbersParse(n12, false);
    },
    format: function(n12, a, o) {
      if (!e.isNumber(n12) || !isFinite(n12))
        return "";
      var i;
      if (a && o && o.currencyProperty) {
        var u = e.getProperty(a, o.currencyProperty);
        u && (i = e.DataCurrencies.find(function(s12) {
          return s12.id === u;
        }));
      }
      return o && o.currency && (i = e.DataCurrencies.find(function(s12) {
        return s12.id === o.currency;
      })), i || (i = e.DataCurrencies.find(function(s12) {
        return s12.isBaseCurrency && s12.isActive;
      })), i ? i = t16.__assign({}, i) : i = {}, i.precision = 4, r12.fixFormat(e.currencyFormat(n12, {
        currency: i,
        showCurrencyCode: o == null ? void 0 : o.showCurrencyCode,
        showNegatives: o == null ? void 0 : o.showNegatives
      }), o);
    }
  }, Eu;
}
var one;
function Zee() {
  if (one)
    return _u;
  one = 1, Object.defineProperty(_u, "__esModule", { value: true }), _u.DataTypes = void 0;
  var t16 = Zi0(), e = eu0(), r12 = tu0(), n12 = ru0(), a = nu0(), o = au0(), i = ou0(), u = iu0(), s12 = uu0(), c = su0(), l2 = cu0(), f = lu0();
  return _u.DataTypes = {
    boolean: t16.boolean,
    character: e.character,
    currency: r12.currency,
    date: n12.date,
    daterange: a.daterange,
    dateinterval: o.dateinterval,
    integer: i.integer,
    markup: u.markup,
    numeric: s12.numeric,
    percent: c.percent,
    quantity: l2.quantity,
    rate: f.rate
  }, _u;
}
var Yd = {}, ine;
function oXe() {
  return ine || (ine = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.detectTypeFromValues = t16.detectType = t16.DataTypeDetectors = void 0;
    var e = Z0, r12 = A1(), n12 = Zee();
    t16.DataTypeDetectors = Object.entries(n12.DataTypes).filter(function(i) {
      var u = e.__read(i, 2), s12 = u[1];
      return s12.detect && r12.isNumber(s12.detectPriority);
    }).sort(function(i, u) {
      var s12 = e.__read(i, 2), c = s12[1], l2 = e.__read(u, 2), f = l2[1];
      return (c.detectPriority || 0) - (f.detectPriority || 0);
    });
    function a(i) {
      var u = t16.DataTypeDetectors.find(function(s12) {
        var c = e.__read(s12, 2), l2 = c[1];
        return l2.detect && l2.detect(i);
      });
      return u ? u[0] : false;
    }
    t16.detectType = a;
    function o(i) {
      var u, s12, c = {};
      try {
        for (var l2 = e.__values(i), f = l2.next(); !f.done; f = l2.next()) {
          var p = f.value, d = a(p);
          d !== false && (c[d] = true);
        }
      } catch (q) {
        u = { error: q };
      } finally {
        try {
          f && !f.done && (s12 = l2.return) && s12.call(l2);
        } finally {
          if (u)
            throw u.error;
        }
      }
      var b = Object.keys(c);
      if (b.length === 0)
        return false;
      if (b.length === 1)
        return b[0];
      var z = b.map(function(q) {
        return n12.DataTypes[q].baseType;
      }), _ = e.__spread(new Set(z));
      return _.length === 1 ? _[0] : false;
    }
    t16.detectTypeFromValues = o;
  })(Yd)), Yd;
}
var Lu = {}, une;
function pu0() {
  if (une)
    return Lu;
  une = 1, Object.defineProperty(Lu, "__esModule", { value: true }), Lu.isValueMatch = void 0;
  var t16 = A1(), e = oXe(), r12 = Zee();
  function n12(a, o, i, u, s12) {
    if (u === void 0 && (u = false), !i) {
      var c = e.detectType(a);
      if (c === false)
        return u;
      i = c;
    }
    var l2 = r12.DataTypes[i];
    return t16.isDefined(a) ? l2.matches(a, o, s12) : t16.isDefined(o.min) || t16.isDefined(o.max) || t16.isDefined(o.like) ? false : o.value === null ? true : t16.isArray(o.values) && o.values.length > 0 ? o.values.some(function(f) {
      return !t16.isDefined(f);
    }) : false;
  }
  return Lu.isValueMatch = n12, Lu;
}
var sne;
function du0() {
  return sne || (sne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true });
    var e = Z0;
    e.__exportStar(Qi0(), t16), e.__exportStar(Sn(), t16), e.__exportStar(Zee(), t16), e.__exportStar(oXe(), t16), e.__exportStar(pu0(), t16);
  })($d)), $d;
}
var Jd = {}, Pu = {}, Kd = {}, cne;
function Cr() {
  return cne || (cne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.FormulaGlobalFunctions = t16.addFormulaFunction = t16.FormulaFunctions = void 0;
    var e = Z0, r12 = A1();
    t16.FormulaFunctions = {};
    function n12(a) {
      var o = a.name.toLowerCase(), i = a.suite ? a.suite + ":" + o : o;
      t16.FormulaFunctions[i] = a;
    }
    t16.addFormulaFunction = n12, t16.FormulaGlobalFunctions = {}, t16.FormulaGlobalFunctions._get = r12.getProperty, t16.FormulaGlobalFunctions._sum = function(a, o) {
      var i, u, s12 = 0;
      if (r12.isArray(a))
        try {
          for (var c = e.__values(a), l2 = c.next(); !l2.done; l2 = c.next()) {
            var f = l2.value, p = parseFloat(r12.getProperty(f, o));
            r12.isNumber(p) && (s12 += p);
          }
        } catch (d) {
          i = { error: d };
        } finally {
          try {
            l2 && !l2.done && (u = c.return) && u.call(c);
          } finally {
            if (i)
              throw i.error;
          }
        }
      return s12;
    };
  })(Kd)), Kd;
}
var lne;
function iXe() {
  if (lne)
    return Pu;
  lne = 1, Object.defineProperty(Pu, "__esModule", { value: true }), Pu.Formula = void 0;
  var t16 = Z0, e = Cr(), r12 = (
    /** @class */
    (function() {
      function n12(a, o, i) {
        var u = n12.tokenize(a, i), s12 = [], c = [], l2 = [], f = [], p = t16.__assign({}, e.FormulaGlobalFunctions), d = {};
        if (o)
          for (var b in o)
            d[b.toLowerCase()] = o[b];
        var z = u.map(function(q) {
          var S = t16.__read(q, 2), N = S[0], v = S[1];
          switch (N) {
            case "append":
            case "comparison":
            case "boolean":
              return n12.TOKEN_TRANSLATION[v.toUpperCase()] || v;
            case "var":
              var C = n12.parseVariable(v), L = C.name, B = C.summed, P12 = L.toLowerCase(), j = d[P12] || L;
              return (B ? c : s12).push(L), B ? "fns._sum(rows, " + JSON.stringify(j) + ")" : "fns._get(row, " + JSON.stringify(j) + ")";
            case "func":
              var $ = v.substring(0, v.length - 1).toLowerCase(), W = i ? i + ":" + $ : $, x = e.FormulaFunctions[W];
              if ((x ? l2 : f).push($), x)
                return p[x.name] = x.call, "fns." + x.name + "(";
              break;
          }
          return v;
        }).join(""), _;
        try {
          _ = new Function("row", "rows", "fns", "return " + z);
        } catch {
        }
        this.valid = !!_ && f.length === 0, this.formula = a, this.code = z, this.references = s12, this.summations = c, this.functions = l2, this.unsupported = f, this.exec = function(q, S) {
          try {
            return _ ? { result: _(q, S || [q], p) } : { result: "#error" };
          } catch (N) {
            return N;
          }
        };
      }
      return n12.tokenize = function(a, o) {
        var i, u;
        o === void 0 && (o = "");
        var s12 = this.TOKEN_SPLITTERS[o] || this.TOKEN_SPLITTER_DEFAULT, c = [["raw", a]], l2 = function(_, q) {
          var S, N, v = [];
          try {
            for (var C = (S = void 0, t16.__values(c)), L = C.next(); !L.done; L = C.next()) {
              var B = t16.__read(L.value, 2), P12 = B[0], j = B[1];
              if (P12 === "raw") {
                if (!j)
                  continue;
                var $ = j.split(q);
                $.forEach(function(W, x) {
                  x % 2 === 0 ? v.push(["raw", W]) : v.push([_, W]);
                });
              } else
                v.push([P12, j]);
            }
          } catch (W) {
            S = { error: W };
          } finally {
            try {
              L && !L.done && (N = C.return) && N.call(C);
            } finally {
              if (S)
                throw S.error;
            }
          }
          c = v;
        };
        try {
          for (var f = t16.__values(s12), p = f.next(); !p.done; p = f.next()) {
            var d = t16.__read(p.value, 2), b = d[0], z = d[1];
            l2(b, z);
          }
        } catch (_) {
          i = { error: _ };
        } finally {
          try {
            p && !p.done && (u = f.return) && u.call(f);
          } finally {
            if (i)
              throw i.error;
          }
        }
        return c = c.filter(function(_) {
          return !!_[1];
        }), c;
      }, n12.parseVariable = function(a) {
        var o = /\[([^([]+)(\(\)|)\]/.exec(a);
        if (!o)
          return { name: "", summed: false };
        var i = t16.__read(o, 3), u = i[1], s12 = i[2];
        return { name: u, summed: !!s12 };
      }, n12.variableMap = function(a, o) {
        var i = this, u = this.tokenize(a), s12 = u.map(function(c) {
          var l2 = t16.__read(c, 2), f = l2[0], p = l2[1];
          if (f === "var") {
            var d = i.parseVariable(p), b = d.name, z = d.summed;
            if (b in o)
              return "[" + o[b] + (z ? "()" : "") + "]";
          }
          return p;
        });
        return s12.join("");
      }, n12.execute = function(a, o, i, u) {
        return i === void 0 && (i = [o]), new n12(a, u).exec(o, i);
      }, n12.TOKEN_SPLITTER_DEFAULT = [
        ["var", /(\[[^\]]+\])/],
        ["func", /([a-z][a-z\d]+\s*\()/i],
        ["text", /('[^']*')/],
        ["text", /("[^"]*")/],
        ["append", /(&)/],
        ["comparison", /(=|>=|<=|<|>|!=|<>|×|÷)/]
      ], n12.TOKEN_SPLITTERS = {}, n12.TOKEN_TRANSLATION = {
        "=": "==",
        "<>": "!=",
        "÷": "/",
        "×": "*",
        "&": "+"
      }, n12.OPERATORS_DEFAULT = [
        { value: "+", label: "+", description: "Add two numbers together" },
        { value: "-", label: "-", description: "Subtract a number from another" },
        { value: "/", label: "÷", description: "Divide a number from another (use /)" },
        { value: "*", label: "×", description: "Multiply a number by another (use *)" },
        { value: "%", label: "%", description: "Compute the remainder between the division of two numbers" },
        { value: "&", label: "&", description: "Append two character strings together" },
        { value: "=", label: "=", description: "Compare two values for equality. If they are equal the result is true, otherwise false." },
        { value: ">", label: ">", description: "The greater than comparison. If the value on the left is after the value on the right the result is true, otherwise false." },
        { value: ">=", label: "≥", description: "The greater than or equal to comparison. If the value on the left is after or equal to the value on the right the result is true, otherwise false." },
        { value: "<", label: "<", description: "The less than comparison. If the value on the left is before the value on the right the result is true, otherwise false." },
        { value: "<=", label: "≤", description: "The less than or equal to comparison. If the value on the left is before or equal to the value on the right the result is true, otherwise false." },
        { value: "<>", label: "<>", description: "Compare two values for inequality. If the are NOT equal the result is true, otherwise false." },
        { value: "(", label: "(", description: "A left parenthesis to control the order of operations. Every left parenthesis needs a right one." },
        { value: ")", label: ")", description: "A right parenthesis to control the order of operations. Every right parenthesis needs a left one." }
      ], n12.OPERATORS = {}, n12;
    })()
  );
  return Pu.Formula = r12, Pu;
}
var Qd = {}, pne;
function fu0() {
  if (pne)
    return Qd;
  pne = 1, Object.defineProperty(Qd, "__esModule", { value: true });
  var t16 = zc(), e = Cr(), r12 = A1(), n12 = "Date & Time";
  return e.addFormulaFunction({
    name: "date",
    category: n12,
    description: "Returns the sequential serial number that represents a particular date.",
    parameters: ["year", "month", "day"],
    parameterDefinitions: {
      year: {
        description: "A number representing the year.",
        dataType: "numeric"
      },
      month: {
        description: "A number representing the month of the year.",
        dataType: "numeric"
      },
      day: {
        description: "A number representing the day of the month.",
        dataType: "numeric"
      }
    },
    call: function(a, o, i) {
      var u = r12.numbersParse(a), s12 = r12.numbersParse(o), c = r12.numbersParse(i);
      if (u < 0 || s12 < 0 || c < 0)
        throw r12.ERRORS.NUM;
      return t16.DateTime.fromObject({ year: u, month: s12, day: c });
    }
  }), e.addFormulaFunction({
    name: "dateadd",
    category: n12,
    description: "Returns a date to which the specified interval has been added.",
    parameters: ["interval", "number", "date"],
    parameterDefinitions: {
      interval: {
        description: "A text expression representing the time interval to add.",
        dataType: "dateinterval"
      },
      number: {
        description: "The number of intervals to add. This value can be positive (to get a DateTime in the future) or negative (to get a DateTime in the past). It can contain a fractional part when Interval specifies hours, minutes, or seconds. For other values of Interval, any fractional part of Number is ignored.",
        dataType: "numeric"
      },
      date: {
        description: "The date to which the interval is to be added.",
        dataType: "date"
      }
    },
    call: function(a, o, i) {
      var u = r12.dateIntervalParse(a), s12 = r12.dateParse(i), c = r12.numbersParse(o);
      if (c === 0)
        return s12;
      switch (u) {
        case "d":
        case "y":
          return s12.plus({ days: c });
        case "h":
          return s12.plus({ hours: c });
        case "n":
          return s12.plus({ minutes: c });
        case "m":
          return s12.plus({ months: c });
        case "q":
          return s12.plus({ quarters: c });
        case "s":
          return s12.plus({ seconds: c });
        case "w":
        case "ww":
          return s12.plus({ weeks: c });
        case "yyyy":
          return s12.plus({ years: c });
        default:
          return s12;
      }
    }
  }), e.addFormulaFunction({
    name: "datediff",
    category: n12,
    description: "Returns a value indicating the number of intervals between two DateTime values.",
    parameters: ["interval", "date1", "date2"],
    parameterDefinitions: {
      interval: {
        description: "A text expression representing the time interval to use as the unit of difference between date1 and date2.",
        dataType: "dateinterval"
      },
      date1: {
        description: "The first date to use in the difference calculation.",
        dataType: "date"
      },
      date2: {
        description: "The second date to use in the difference calculation.",
        dataType: "date"
      }
    },
    call: function(a, o, i) {
      var u = r12.dateIntervalParse(a), s12 = r12.dateParse(o), c = r12.dateParse(i);
      switch (u) {
        case "d":
        case "y":
          return s12.diff(c, "days").days;
        case "h":
          return s12.diff(c, "hours").hours;
        case "n":
          return s12.diff(c, "minutes").minutes;
        case "m":
          return s12.diff(c, "months").months;
        case "q":
          return s12.diff(c, "quarters").quarters;
        case "s":
          return s12.diff(c, "seconds").seconds;
        case "w":
        case "ww":
          return s12.diff(c, "weeks").weeks;
        case "yyyy":
          return s12.diff(c, "years").years;
        default:
          return 0;
      }
    }
  }), e.addFormulaFunction({
    name: "datevalue",
    category: n12,
    description: "Returns the day of month of a date value.",
    parameters: ["input"],
    parameterDefinitions: {
      input: {
        description: "A date value from which to get the day."
      }
    },
    call: function(a) {
      return r12.dateParse(a);
    }
  }), e.addFormulaFunction({
    name: "day",
    category: n12,
    description: "Returns the day of month of a date value.",
    parameters: ["date"],
    parameterDefinitions: {
      date: {
        description: "A date value from which to get the day.",
        dataType: "date"
      }
    },
    call: function(a) {
      return r12.dateParse(a).day;
    }
  }), e.addFormulaFunction({
    name: "days360",
    category: n12,
    description: "Returns the number of days between two dates based on a 360-day year.",
    parameters: ["start", "end", "method"],
    parameterDefinitions: {
      start: {
        description: "The start date of the range of days. If this is after the end date, the function will return a negative number.",
        dataType: "date"
      },
      end: {
        description: "The start date of the range of days. If this is after the end date, the function will return a negative number.",
        dataType: "date"
      },
      method: {
        description: "A logical value that specifies whether to use the U.S. (false) or European (true) method in the calculation.",
        dataType: "boolean",
        defaultValue: "FALSE"
      }
    },
    call: function(a, o, i) {
      var u = r12.dateParse(a), s12 = r12.dateParse(o), c = u.day, l2 = u.month, f = u.year, p = s12.day, d = s12.month, b = s12.year;
      if (i)
        c = c === 31 ? 30 : c, p = p === 31 ? 30 : p;
      else {
        var z = new Date(f, l2 + 1, 0).getDate(), _ = new Date(b, d + 1, 0).getDate();
        c = c === z ? 30 : c, p === _ && (c < 30 ? (d++, p = 1) : p = 30);
      }
      return 360 * (b - f) + 30 * (d - l2) + (p - c);
    }
  }), e.addFormulaFunction({
    name: "edate",
    category: n12,
    description: "Returns a date that is the specified number of months before or after the start date.",
    parameters: ["date", "numberOfMonths"],
    parameterDefinitions: {
      date: {
        description: "The starting date.",
        dataType: "date"
      },
      numberOfMonths: {
        description: "The number of months to shift the date. A positive number means a date after the start date. A negative number indicates a date prior to the start date.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      return r12.dateParse(a).plus({ months: r12.numbersParse(o) });
    }
  }), e.addFormulaFunction({
    name: "eomonth",
    category: n12,
    description: "Returns a date that is at the end of the month which is the specified number of months before or after the start date.",
    parameters: ["date", "numberOfMonths"],
    parameterDefinitions: {
      date: {
        description: "The starting date.",
        dataType: "date"
      },
      numberOfMonths: {
        description: "The number of months to shift the date. A positive number means a date after the start date. A negative number indicates a date prior to the start date.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      return r12.dateParse(a).plus({ months: r12.numbersParse(o) }).endOf("month");
    }
  }), e.addFormulaFunction({
    name: "hour",
    category: n12,
    description: "Returns the hour of a time value.",
    parameters: ["timeValue"],
    parameterDefinitions: {
      timeValue: {
        description: "A time value from which to get the hour.",
        dataType: "date"
      }
    },
    call: function(a) {
      return r12.dateParse(a).hour;
    }
  }), e.addFormulaFunction({
    name: "minute",
    category: n12,
    description: "Returns the minute of a time value.",
    parameters: ["timeValue"],
    parameterDefinitions: {
      timeValue: {
        description: "A time value from which to get the minute.",
        dataType: "date"
      }
    },
    call: function(a) {
      return r12.dateParse(a).minute;
    }
  }), e.addFormulaFunction({
    name: "month",
    category: n12,
    description: "Returns the month of a date value.",
    parameters: ["dateValue"],
    parameterDefinitions: {
      dateValue: {
        description: "A date value from which to get the month.",
        dataType: "date"
      }
    },
    call: function(a) {
      return r12.dateParse(a).month + 1;
    }
  }), e.addFormulaFunction({
    name: "now",
    category: n12,
    description: "Returns a value representing the current date and time.",
    parameters: [],
    parameterDefinitions: {},
    call: function() {
      return t16.DateTime.fromJSDate(/* @__PURE__ */ new Date());
    }
  }), e.addFormulaFunction({
    name: "second",
    category: n12,
    description: "Returns the second of a time value.",
    parameters: ["timeValue"],
    parameterDefinitions: {
      timeValue: {
        description: "A time value from which to get the second.",
        dataType: "date"
      }
    },
    call: function(a) {
      return r12.dateParse(a).second;
    }
  }), e.addFormulaFunction({
    name: "time",
    category: n12,
    description: "Returns a number that represents a particular time value.",
    parameters: ["hour", "minute", "second"],
    parameterDefinitions: {
      hour: {
        description: "A number representing the time's hour.",
        dataType: "numeric"
      },
      minute: {
        description: "A number representing the time's minute.",
        dataType: "numeric"
      },
      second: {
        description: "A number representing the time's second.",
        dataType: "numeric"
      }
    },
    call: function(a, o, i) {
      var u = r12.numbersParse(a), s12 = r12.numbersParse(o), c = r12.numbersParse(i);
      return t16.DateTime.fromObject({ hour: u, minute: s12, second: c });
    }
  }), e.addFormulaFunction({
    name: "timevalue",
    category: n12,
    description: "Converts a text expression representing a time to its equivalent time value.",
    parameters: ["input"],
    parameterDefinitions: {
      input: {
        description: "A text expression representing a time.",
        dataType: "character"
      }
    },
    call: function(a) {
      return r12.timeParse(a);
    }
  }), e.addFormulaFunction({
    name: "today",
    category: n12,
    description: "Returns the current date.",
    parameters: [],
    parameterDefinitions: {},
    call: function() {
      return t16.DateTime.fromJSDate(/* @__PURE__ */ new Date()).startOf("day");
    }
  }), e.addFormulaFunction({
    name: "weekday",
    category: n12,
    description: "Returns a number representing the day of the week of the specified date.",
    parameters: ["date", "returnType"],
    parameterDefinitions: {
      date: {
        description: "The date of which to find the day of week number.",
        dataType: "date"
      },
      returnType: {
        description: `Determines which numbering scheme is used for the days of the week.
1 (default) = Sunday (1) through Saturday (7)
2 = Monday (1) through Sunday (7)
3 = Monday (0) through Sunday (6)`,
        dataType: "numeric",
        defaultValue: "1"
      }
    },
    call: function(a, o) {
      var i = r12.dateParse(a), u = r12.numbersParse(o || 1);
      if (u < 1 || u > 3)
        throw r12.ERRORS.VALUE;
      switch (u) {
        case 2:
          return i.weekday;
        case 3:
          return i.weekday - 1;
        case 1:
        default:
          return (i.weekday + 1) % 7;
      }
    }
  }), e.addFormulaFunction({
    name: "weeknum",
    category: n12,
    description: "Returns the number of the week into which the specified date falls.",
    parameters: ["date", "returnType"],
    parameterDefinitions: {
      date: {
        description: "The date of which to find the week number.",
        dataType: "date"
      },
      returnType: {
        description: `Determines which day begins the week.
1 (default) = Sunday is the first day of the week.
2 = Monday is the first day of the week.`,
        dataType: "numeric",
        defaultValue: "1"
      }
    },
    call: function(a, o) {
      var i = r12.dateParse(a), u = r12.numbersParse(o || 1);
      if (u < 1 || u > 2)
        throw r12.ERRORS.VALUE;
      return i.weekNumber;
    }
  }), e.addFormulaFunction({
    name: "year",
    category: n12,
    description: "Returns the year of a date value.",
    parameters: ["dateValue"],
    parameterDefinitions: {
      dateValue: {
        description: "A date time value from which to get the year.",
        dataType: "date"
      }
    },
    call: function(a) {
      return r12.dateParse(a).year;
    }
  }), Qd;
}
var Zd = {}, dne;
function bu0() {
  if (dne)
    return Zd;
  dne = 1, Object.defineProperty(Zd, "__esModule", { value: true });
  var t16 = Z0, e = Cr(), r12 = A1(), n12 = "Engineering";
  return e.addFormulaFunction({
    name: "bin2dec",
    category: n12,
    description: "Returns the decimal value of a text representation of a number in the binary number system.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "A text expression represeting a binary number.",
        dataType: "character"
      }
    },
    call: function(a) {
      return r12.integersParse(a, true, 2);
    }
  }), e.addFormulaFunction({
    name: "bin2hex",
    category: n12,
    description: "Converts a text expression representing a binary number to a text expression representing the same number in the hexadecimal number system.",
    parameters: ["value", "places"],
    parameterDefinitions: {
      value: {
        description: "A text expression represeting a binary number.",
        dataType: "character"
      },
      places: {
        description: "The number of characters to use in representing the value. If this is not specified, the minimum number of characters neccessary to represent the value will be used. This allows you to specify leading zeros.",
        dataType: "numeric",
        defaultValue: "The minimum number of characters neccessary to represent the value."
      }
    },
    call: function(a, o) {
      return r12.integersBaseChange(2, 16, a, o);
    }
  }), e.addFormulaFunction({
    name: "bin2oct",
    category: n12,
    description: "Converts a text expression representing a binary number to a text expression representing the same number in the octal number system.",
    parameters: ["value", "places"],
    parameterDefinitions: {
      value: {
        description: "A text expression represeting a binary number.",
        dataType: "character"
      },
      places: {
        description: "The number of characters to use in representing the value. If this is not specified, the minimum number of characters neccessary to represent the value will be used. This allows you to specify leading zeros.",
        dataType: "numeric",
        defaultValue: "The minimum number of characters neccessary to represent the value."
      }
    },
    call: function(a, o) {
      return r12.integersBaseChange(2, 8, a, o);
    }
  }), e.addFormulaFunction({
    name: "complex",
    category: n12,
    description: 'Returns a complex number represented as a text expression in the format "x + yi" or "x + yj" by combining a real and imaginary number.',
    parameters: ["real", "imaginary", "suffix"],
    parameterDefinitions: {
      real: {
        description: "The real coefficient of the complex number.",
        dataType: "numeric"
      },
      imaginary: {
        description: "The imaginary coefficient of the number.",
        dataType: "numeric"
      },
      suffix: {
        description: 'Specifies the suffix to use. The acceptable values are "i" or "j". If omitted, "i" is used. Note that the suffix is case-sensitive; upper case "I" and "J" are not allowed and will result in a #VALUE error.',
        dataType: "character",
        defaultValue: "i"
      }
    },
    call: function(a, o, i) {
      return r12.complexCreate(r12.numbersParse(a), r12.numbersParse(o), i);
    }
  }), e.addFormulaFunction({
    name: "convert",
    category: n12,
    description: "Converts a value from one system of measurement to another, such as meters to inches or hours to seconds.",
    parameters: ["value", "from", "to"],
    parameterDefinitions: {
      value: {
        description: "A text expression represeting a binary number.",
        dataType: "character"
      },
      from: {
        description: `The unit in which the number is given.

Weight and mass units: "g" = gram; "sg" = slug; "lbm" = pound mass (avoirdupois); "u" = U (atomic mass unit); "ozm" = Ounce mass (avoirdupois)
Distance units: "m" = Meter; "mi" = Statute mile; "Nmi" = Nautical mile; "in" = Inch; "ft" = Foot; "yd" = Yard; "ang" = Angstrom; "Pica" = Pica (1/72 in.)
Time units: "yr" = Year; "day" = Day; "hr" = Hour; "mn" = Minute; "sec" = Second
Pressure units: "Pa" (or "p") = Pascal; "atm" (or "at") = Atmosphere; "mmHg" = mm of Mercury
Force units: "N" = Newton; "dyn" (or "dy") = Dyne; "lbf" = Pound force
Energy units: "J" = Joule; "e" = Erg; "c" = Thermodynamic calorie; "cal" = IT calorie; "eV" (or "ev") = Electron volt; "HPh" (or "hh") = Horsepower-hour; "Wh" (or "wh") = Watt-hour; "flb" = Foot-pound; "BTU" (or "btu") = BTU
Power units: "HP" (or "h") = Horsepower; "W" (or "w") = Watt
Magentism units: "T" = Tesla; "ga" = Gauss
Temperature units: "C" (or "cel") = Degree Celsius; "F" (or "fah") = Degree Fahrenheit; "K" (or "kel") = Kelvin
Liquid measure units: "tsp" = Teaspoon; "tbs" = Tablespoon; "oz" = Fluid ounce; "cup" = Cup; "pt" (or "us_pt") = U.S. pint; "uk_pt" = U.K. pint; "qt" = Quart; "gal" = Gallon; "l" (or "lt") = Liter

Any metric unit may be prefixed with one of the following: exa ("E") = 1E+18; peta ("P") = 1E+15; tera ("T") = 1E+12; giga ("G") = 1E+09; mega ("M") = 1E+06; kilo ("k") = 1E+03; hecto ("h") = 1E+02; dekao ("e") = 1E+01; deci ("d") = 1E-01; centi ("c") = 1E-02; milli ("m") = 1E-03; micro ("u") = 1E-06; nano ("n") = 1E-09; pico ("p") = 1E-12; femto ("f") = 1E-15; atto ("a") = 1E-18`,
        dataType: "character"
      },
      to: {
        description: `The units in which to return the converted value.

Weight and mass units: "g" = gram; "sg" = slug; "lbm" = pound mass (avoirdupois); "u" = U (atomic mass unit); "ozm" = Ounce mass (avoirdupois)
Distance units: "m" = Meter; "mi" = Statute mile; "Nmi" = Nautical mile; "in" = Inch; "ft" = Foot; "yd" = Yard; "ang" = Angstrom; "Pica" = Pica (1/72 in.)
Time units: "yr" = Year; "day" = Day; "hr" = Hour; "mn" = Minute; "sec" = Second
Pressure units: "Pa" (or "p") = Pascal; "atm" (or "at") = Atmosphere; "mmHg" = mm of Mercury
Force units: "N" = Newton; "dyn" (or "dy") = Dyne; "lbf" = Pound force
Energy units: "J" = Joule; "e" = Erg; "c" = Thermodynamic calorie; "cal" = IT calorie; "eV" (or "ev") = Electron volt; "HPh" (or "hh") = Horsepower-hour; "Wh" (or "wh") = Watt-hour; "flb" = Foot-pound; "BTU" (or "btu") = BTU
Power units: "HP" (or "h") = Horsepower; "W" (or "w") = Watt
Magentism units: "T" = Tesla; "ga" = Gauss
Temperature units: "C" (or "cel") = Degree Celsius; "F" (or "fah") = Degree Fahrenheit; "K" (or "kel") = Kelvin
Liquid measure units: "tsp" = Teaspoon; "tbs" = Tablespoon; "oz" = Fluid ounce; "cup" = Cup; "pt" (or "us_pt") = U.S. pint; "uk_pt" = U.K. pint; "qt" = Quart; "gal" = Gallon; "l" (or "lt") = Liter

Any metric unit may be prefixed with one of the following: exa ("E") = 1E+18; peta ("P") = 1E+15; tera ("T") = 1E+12; giga ("G") = 1E+09; mega ("M") = 1E+06; kilo ("k") = 1E+03; hecto ("h") = 1E+02; dekao ("e") = 1E+01; deci ("d") = 1E-01; centi ("c") = 1E-02; milli ("m") = 1E-03; micro ("u") = 1E-06; nano ("n") = 1E-09; pico ("p") = 1E-12; femto ("f") = 1E-15; atto ("a") = 1E-18`,
        dataType: "character"
      }
    },
    call: function(a, o, i) {
      for (var u = r12.numbersParse(a), s12 = [
        ["a.u. of action", "?", null, "action", false, false, 105457168181818e-48],
        ["a.u. of charge", "e", null, "electric_charge", false, false, 160217653141414e-33],
        ["a.u. of energy", "Eh", null, "energy", false, false, 435974417757576e-32],
        ["a.u. of length", "a?", null, "length", false, false, 529177210818182e-25],
        ["a.u. of mass", "m?", null, "mass", false, false, 910938261616162e-45],
        ["a.u. of time", "?/Eh", null, "time", false, false, 241888432650516e-31],
        ["admiralty knot", "admkn", null, "speed", false, true, 0.514773333],
        ["ampere", "A", null, "electric_current", true, false, 1],
        ["ampere per meter", "A/m", null, "magnetic_field_intensity", true, false, 1],
        ["ångström", "Å", ["ang"], "length", false, true, 1e-10],
        ["are", "ar", null, "area", false, true, 100],
        ["astronomical unit", "ua", null, "length", false, false, 149597870691667e-25],
        ["bar", "bar", null, "pressure", false, false, 1e5],
        ["barn", "b", null, "area", false, false, 1e-28],
        ["becquerel", "Bq", null, "radioactivity", true, false, 1],
        ["bit", "bit", ["b"], "information", false, true, 1],
        ["btu", "BTU", ["btu"], "energy", false, true, 1055.05585262],
        ["byte", "byte", null, "information", false, true, 8],
        ["candela", "cd", null, "luminous_intensity", true, false, 1],
        ["candela per square metre", "cd/m?", null, "luminance", true, false, 1],
        ["coulomb", "C", null, "electric_charge", true, false, 1],
        ["cubic ångström", "ang3", ["ang^3"], "volume", false, true, 1e-30],
        ["cubic foot", "ft3", ["ft^3"], "volume", false, true, 0.028316846592],
        ["cubic inch", "in3", ["in^3"], "volume", false, true, 16387064e-12],
        ["cubic light-year", "ly3", ["ly^3"], "volume", false, true, 846786664623715e-61],
        ["cubic metre", "m?", null, "volume", true, true, 1],
        ["cubic mile", "mi3", ["mi^3"], "volume", false, true, 416818182544058e-5],
        ["cubic nautical mile", "Nmi3", ["Nmi^3"], "volume", false, true, 6352182208],
        ["cubic Pica", "Pica3", ["Picapt3", "Pica^3", "Picapt^3"], "volume", false, true, 758660370370369e-22],
        ["cubic yard", "yd3", ["yd^3"], "volume", false, true, 0.764554857984],
        ["cup", "cup", null, "volume", false, true, 2365882365e-13],
        ["dalton", "Da", ["u"], "mass", false, false, 166053886282828e-41],
        ["day", "d", ["day"], "time", false, true, 86400],
        ["degree", "°", null, "angle", false, false, 0.0174532925199433],
        ["degrees Rankine", "Rank", null, "temperature", false, true, 0.555555555555556],
        ["dyne", "dyn", ["dy"], "force", false, true, 1e-5],
        ["electronvolt", "eV", ["ev"], "energy", false, true, 1.60217656514141],
        ["ell", "ell", null, "length", false, true, 1.143],
        ["erg", "erg", ["e"], "energy", false, true, 1e-7],
        ["farad", "F", null, "electric_capacitance", true, false, 1],
        ["fluid ounce", "oz", null, "volume", false, true, 295735295625e-16],
        ["foot", "ft", null, "length", false, true, 0.3048],
        ["foot-pound", "flb", null, "energy", false, true, 1.3558179483314],
        ["gal", "Gal", null, "acceleration", false, false, 0.01],
        ["gallon", "gal", null, "volume", false, true, 0.003785411784],
        ["gauss", "G", ["ga"], "magnetic_flux_density", false, true, 1],
        ["grain", "grain", null, "mass", false, true, 647989e-10],
        ["gram", "g", null, "mass", false, true, 1e-3],
        ["gray", "Gy", null, "absorbed_dose", true, false, 1],
        ["gross registered ton", "GRT", ["regton"], "volume", false, true, 2.8316846592],
        ["hectare", "ha", null, "area", false, true, 1e4],
        ["henry", "H", null, "inductance", true, false, 1],
        ["hertz", "Hz", null, "frequency", true, false, 1],
        ["horsepower", "HP", ["h"], "power", false, true, 745.69987158227],
        ["horsepower-hour", "HPh", ["hh", "hph"], "energy", false, true, 2684519538e-3],
        ["hour", "h", ["hr"], "time", false, true, 3600],
        ["imperial gallon (U.K.)", "uk_gal", null, "volume", false, true, 454609e-8],
        ["imperial hundredweight", "lcwt", ["uk_cwt", "hweight"], "mass", false, true, 50.802345],
        ["imperial quart (U.K)", "uk_qt", null, "volume", false, true, 0.0011365225],
        ["imperial ton", "brton", ["uk_ton", "LTON"], "mass", false, true, 1016.046909],
        ["inch", "in", null, "length", false, true, 0.0254],
        ["international acre", "uk_acre", null, "area", false, true, 4046.8564224],
        ["IT calorie", "cal", null, "energy", false, true, 4.1868],
        ["joule", "J", null, "energy", true, true, 1],
        ["katal", "kat", null, "catalytic_activity", true, false, 1],
        ["kelvin", "K", ["kel"], "temperature", true, true, 1],
        ["kilogram", "kg", null, "mass", true, true, 1],
        ["knot", "kn", null, "speed", false, true, 0.514444444444444],
        ["light-year", "ly", null, "length", false, true, 9460730472580800],
        ["litre", "L", ["l", "lt"], "volume", false, true, 1e-3],
        ["lumen", "lm", null, "luminous_flux", true, false, 1],
        ["lux", "lx", null, "illuminance", true, false, 1],
        ["maxwell", "Mx", null, "magnetic_flux", false, false, 1e-18],
        ["measurement ton", "MTON", null, "volume", false, true, 1.13267386368],
        ["meter per hour", "m/h", ["m/hr"], "speed", false, true, 27777777777778e-17],
        ["meter per second", "m/s", ["m/sec"], "speed", true, true, 1],
        ["meter per second squared", "m?s??", null, "acceleration", true, false, 1],
        ["parsec", "pc", ["parsec"], "length", false, true, 30856775814671900],
        ["meter squared per second", "m?/s", null, "kinematic_viscosity", true, false, 1],
        ["metre", "m", null, "length", true, true, 1],
        ["miles per hour", "mph", null, "speed", false, true, 0.44704],
        ["millimetre of mercury", "mmHg", null, "pressure", false, false, 133.322],
        ["minute", "?", null, "angle", false, false, 290888208665722e-18],
        ["minute", "min", ["mn"], "time", false, true, 60],
        ["modern teaspoon", "tspm", null, "volume", false, true, 5e-6],
        ["mole", "mol", null, "amount_of_substance", true, false, 1],
        ["morgen", "Morgen", null, "area", false, true, 2500],
        ["n.u. of action", "?", null, "action", false, false, 105457168181818e-48],
        ["n.u. of mass", "m?", null, "mass", false, false, 910938261616162e-45],
        ["n.u. of speed", "c?", null, "speed", false, false, 299792458],
        ["n.u. of time", "?/(me?c??)", null, "time", false, false, 128808866778687e-35],
        ["nautical mile", "M", ["Nmi"], "length", false, true, 1852],
        ["newton", "N", null, "force", true, true, 1],
        ["œrsted", "Oe ", null, "magnetic_field_intensity", false, false, 79.5774715459477],
        ["ohm", "Ω", null, "electric_resistance", true, false, 1],
        ["ounce mass", "ozm", null, "mass", false, true, 0.028349523125],
        ["pascal", "Pa", null, "pressure", true, false, 1],
        ["pascal second", "Pa?s", null, "dynamic_viscosity", true, false, 1],
        ["pferdestärke", "PS", null, "power", false, true, 735.49875],
        ["phot", "ph", null, "illuminance", false, false, 1e-4],
        ["pica (1/6 inch)", "pica", null, "length", false, true, 35277777777778e-17],
        ["pica (1/72 inch)", "Pica", ["Picapt"], "length", false, true, 0.00423333333333333],
        ["poise", "P", null, "dynamic_viscosity", false, false, 0.1],
        ["pond", "pond", null, "force", false, true, 980665e-8],
        ["pound force", "lbf", null, "force", false, true, 4.4482216152605],
        ["pound mass", "lbm", null, "mass", false, true, 0.45359237],
        ["quart", "qt", null, "volume", false, true, 946352946e-12],
        ["radian", "rad", null, "angle", true, false, 1],
        ["second", "?", null, "angle", false, false, 484813681109536e-20],
        ["second", "s", ["sec"], "time", true, true, 1],
        ["short hundredweight", "cwt", ["shweight"], "mass", false, true, 45.359237],
        ["siemens", "S", null, "electrical_conductance", true, false, 1],
        ["sievert", "Sv", null, "equivalent_dose", true, false, 1],
        ["slug", "sg", null, "mass", false, true, 14.59390294],
        ["square ångström", "ang2", ["ang^2"], "area", false, true, 1e-20],
        ["square foot", "ft2", ["ft^2"], "area", false, true, 0.09290304],
        ["square inch", "in2", ["in^2"], "area", false, true, 64516e-8],
        ["square light-year", "ly2", ["ly^2"], "area", false, true, 895054210748189e17],
        ["square meter", "m?", null, "area", true, true, 1],
        ["square mile", "mi2", ["mi^2"], "area", false, true, 2589988110336e-6],
        ["square nautical mile", "Nmi2", ["Nmi^2"], "area", false, true, 3429904],
        ["square Pica", "Pica2", ["Picapt2", "Pica^2", "Picapt^2"], "area", false, true, 1792111111111e-17],
        ["square yard", "yd2", ["yd^2"], "area", false, true, 0.83612736],
        ["statute mile", "mi", null, "length", false, true, 1609.344],
        ["steradian", "sr", null, "solid_angle", true, false, 1],
        ["stilb", "sb", null, "luminance", false, false, 1e-4],
        ["stokes", "St", null, "kinematic_viscosity", false, false, 1e-4],
        ["stone", "stone", null, "mass", false, true, 6.35029318],
        ["tablespoon", "tbs", null, "volume", false, true, 147868e-10],
        ["teaspoon", "tsp", null, "volume", false, true, 492892e-11],
        ["tesla", "T", null, "magnetic_flux_density", true, true, 1],
        ["thermodynamic calorie", "c", null, "energy", false, true, 4.184],
        ["ton", "ton", null, "mass", false, true, 907.18474],
        ["tonne", "t", null, "mass", false, false, 1e3],
        ["U.K. pint", "uk_pt", null, "volume", false, true, 56826125e-11],
        ["U.S. bushel", "bushel", null, "volume", false, true, 0.03523907],
        ["U.S. oil barrel", "barrel", null, "volume", false, true, 0.158987295],
        ["U.S. pint", "pt", ["us_pt"], "volume", false, true, 473176473e-12],
        ["U.S. survey mile", "survey_mi", null, "length", false, true, 1609.347219],
        ["U.S. survey/statute acre", "us_acre", null, "area", false, true, 4046.87261],
        ["volt", "V", null, "voltage", true, false, 1],
        ["watt", "W", null, "power", true, true, 1],
        ["watt-hour", "Wh", ["wh"], "energy", false, true, 3600],
        ["weber", "Wb", null, "magnetic_flux", true, false, 1],
        ["yard", "yd", null, "length", false, true, 0.9144],
        ["year", "yr", null, "time", false, true, 31557600]
      ], c = {
        Yi: ["yobi", 80, 12089258196146292e8, "Yi", "yotta"],
        Zi: ["zebi", 70, 11805916207174113e5, "Zi", "zetta"],
        Ei: ["exbi", 60, 1152921504606847e3, "Ei", "exa"],
        Pi: ["pebi", 50, 1125899906842624, "Pi", "peta"],
        Ti: ["tebi", 40, 1099511627776, "Ti", "tera"],
        Gi: ["gibi", 30, 1073741824, "Gi", "giga"],
        Mi: ["mebi", 20, 1048576, "Mi", "mega"],
        ki: ["kibi", 10, 1024, "ki", "kilo"]
      }, l2 = {
        Y: ["yotta", 1e24, "Y"],
        Z: ["zetta", 1e21, "Z"],
        E: ["exa", 1e18, "E"],
        P: ["peta", 1e15, "P"],
        T: ["tera", 1e12, "T"],
        G: ["giga", 1e9, "G"],
        M: ["mega", 1e6, "M"],
        k: ["kilo", 1e3, "k"],
        h: ["hecto", 100, "h"],
        e: ["dekao", 10, "e"],
        d: ["deci", 0.1, "d"],
        c: ["centi", 0.01, "c"],
        m: ["milli", 1e-3, "m"],
        u: ["micro", 1e-6, "u"],
        n: ["nano", 1e-9, "n"],
        p: ["pico", 1e-12, "p"],
        f: ["femto", 1e-15, "f"],
        a: ["atto", 1e-18, "a"],
        z: ["zepto", 1e-21, "z"],
        y: ["yocto", 1e-24, "y"]
      }, f = null, p = null, d = o, b = i, z = 1, _ = 1, q, S = 0; S < s12.length; S++) {
        var N = t16.__read(s12[S], 3), v = N[1], C = N[2];
        q = C === null ? [] : C, (v === d || q.includes(d)) && (f = s12[S]), (v === b || q.includes(b)) && (p = s12[S]);
      }
      if (f === null) {
        var L = c[o.substring(0, 2)], B = l2[o.substring(0, 1)];
        o.startsWith("da") && (B = ["dekao", 10, "da"]), L ? (z = L[2], d = o.substring(2)) : B && (z = B[1], d = o.substring(B[2].length));
        for (var P12 = 0; P12 < s12.length; P12++) {
          var j = t16.__read(s12[P12], 3), v = j[1], C = j[2];
          q = C === null ? [] : C, (v === d || q.includes(d)) && (f = s12[P12]);
        }
      }
      if (p === null) {
        var $ = c[i.substring(0, 2)], W = l2[i.substring(0, 1)];
        i.startsWith("da") && (W = ["dekao", 10, "da"]), $ ? (_ = $[2], b = i.substring(2)) : W && (_ = W[1], b = i.substring(W[2].length));
        for (var x = 0; x < s12.length; x++) {
          var D = t16.__read(s12[x], 3), v = D[1], C = D[2];
          q = C === null ? [] : C, (v === b || q.includes(b)) && (p = s12[x]);
        }
      }
      if (f === null || p === null || f[3] !== p[3])
        throw r12.ERRORS.NA;
      return u * f[6] * z / (p[6] * _);
    }
  }), e.addFormulaFunction({
    name: "dec2bin",
    category: n12,
    description: "Returns a text expression representing the specified decimal value as a binary number.",
    parameters: ["value", "places"],
    parameterDefinitions: {
      value: {
        description: "The decimal value to be converted.",
        dataType: "numeric"
      },
      places: {
        description: "The number of characters to use in representing the value. If places is not specified, the minimum number of characters neccessary to represent the value will be used. This allows you to specify leading zeros.",
        dataType: "numeric",
        defaultValue: "The minimum number of characters neccessary to represent the value."
      }
    },
    call: function(a, o) {
      return r12.integersBaseChange(10, 2, a, o);
    }
  }), e.addFormulaFunction({
    name: "dec2hex",
    category: n12,
    description: "Returns a text expression representing the specified decimal value as a hexadecimal number.",
    parameters: ["value", "places"],
    parameterDefinitions: {
      value: {
        description: "The decimal value to be converted.",
        dataType: "numeric"
      },
      places: {
        description: "The number of characters to use in representing the value. If places is not specified, the minimum number of characters neccessary to represent the value will be used. This allows you to specify leading zeros.",
        dataType: "numeric",
        defaultValue: "The minimum number of characters neccessary to represent the value."
      }
    },
    call: function(a, o) {
      return r12.integersBaseChange(10, 16, a, o);
    }
  }), e.addFormulaFunction({
    name: "dec2oct",
    category: n12,
    description: "Returns a text expression representing the specified decimal value as an octal number.",
    parameters: ["value", "places"],
    parameterDefinitions: {
      value: {
        description: "The decimal value to be converted.",
        dataType: "numeric"
      },
      places: {
        description: "The number of characters to use in representing the value. If places is not specified, the minimum number of characters neccessary to represent the value will be used. This allows you to specify leading zeros.",
        dataType: "numeric",
        defaultValue: "The minimum number of characters neccessary to represent the value."
      }
    },
    call: function(a, o) {
      return r12.integersBaseChange(10, 8, a, o);
    }
  }), e.addFormulaFunction({
    name: "delta",
    category: n12,
    description: "Compares two numbers and returns one if they are equal or zero if they are not.",
    parameters: ["first", "second"],
    parameterDefinitions: {
      first: {
        description: "The first number to compare.",
        dataType: "numeric"
      },
      second: {
        description: "The second number to compare. If not specified, it will be assumed to be zero.",
        dataType: "numeric",
        defaultValue: "0"
      }
    },
    call: function(a, o) {
      var i = r12.integersParse(a), u = r12.integersParse(o || 0);
      return i === u ? 1 : 0;
    }
  }), e.addFormulaFunction({
    name: "gestep",
    category: n12,
    description: "Compares two numbers and returns one if the first number is greater than or equal to the second or returns zero if not.",
    parameters: ["first", "second"],
    parameterDefinitions: {
      first: {
        description: "The first number to compare.",
        dataType: "numeric"
      },
      second: {
        description: "The second number to compare. If not specified, it will be assumed to be zero.",
        dataType: "numeric",
        defaultValue: "0"
      }
    },
    call: function(a, o) {
      var i = r12.integersParse(a), u = r12.integersParse(o || 0);
      return i >= u ? 1 : 0;
    }
  }), e.addFormulaFunction({
    name: "hex2bin",
    category: n12,
    description: "Converts a text expression representing a hexadecimal number to a text expression representing the same number in the binary number system.",
    parameters: ["value", "places"],
    parameterDefinitions: {
      value: {
        description: "A text expression represeting a hexadecimal number.",
        dataType: "character"
      },
      places: {
        description: "The number of characters to use in representing the value. If this is not specified, the minimum number of characters neccessary to represent the value will be used. This allows you to specify leading zeros.",
        dataType: "numeric",
        defaultValue: "The minimum number of characters neccessary to represent the value."
      }
    },
    call: function(a, o) {
      return r12.integersBaseChange(16, 2, a, o);
    }
  }), e.addFormulaFunction({
    name: "hex2dec",
    category: n12,
    description: "Returns the decimal value of a text representation of a number in the hexadecimal number system.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "A text expression represeting a hexadecimal number.",
        dataType: "character"
      }
    },
    call: function(a) {
      return r12.integersParse(a, true, 16).toString(10);
    }
  }), e.addFormulaFunction({
    name: "hex2oct",
    category: n12,
    description: "Converts a text expression representing a hexadecimal number to a text expression representing the same number in the octal number system.",
    parameters: ["value", "places"],
    parameterDefinitions: {
      value: {
        description: "A text expression represeting a hexadecimal number.",
        dataType: "character"
      },
      places: {
        description: "The number of characters to use in representing the value. If this is not specified, the minimum number of characters neccessary to represent the value will be used. This allows you to specify leading zeros.",
        dataType: "numeric",
        defaultValue: "The minimum number of characters neccessary to represent the value."
      }
    },
    call: function(a, o) {
      return r12.integersBaseChange(16, 8, a, o);
    }
  }), e.addFormulaFunction({
    name: "imabs",
    category: n12,
    description: "Returns the absolute value of a complex number.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      }
    },
    call: function(a) {
      return r12.complexAbs(a);
    }
  }), e.addFormulaFunction({
    name: "imaginary",
    category: n12,
    description: "Returns the imaginary coefficient of a complex number.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      }
    },
    call: function(a) {
      return r12.complexImaginary(a);
    }
  }), e.addFormulaFunction({
    name: "imargument",
    category: n12,
    description: "Returns the argument theta, an angle expressed in radians.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      }
    },
    call: function(a) {
      return r12.complexArgument(a);
    }
  }), e.addFormulaFunction({
    name: "imconjugate",
    category: n12,
    description: "Returns the conjugate of a complex number.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      }
    },
    call: function(a) {
      var o = r12.complexReal(a), i = r12.complexImaginary(a), u = r12.complexUnit(a);
      return i === 0 ? a : r12.complexCreate(o, -i, u);
    }
  }), e.addFormulaFunction({
    name: "imcos",
    category: n12,
    description: "Returns the cosine of a complex number.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      }
    },
    call: function(a) {
      var o = r12.complexReal(a), i = r12.complexImaginary(a), u = r12.complexUnit(a);
      return r12.complexCreate(Math.cos(o) * (Math.exp(i) + Math.exp(-i)) / 2, -Math.sin(o) * (Math.exp(i) - Math.exp(-i)) / 2, u);
    }
  }), e.addFormulaFunction({
    name: "imdiv",
    category: n12,
    description: "Returns the quotient of two complex numbers (Dividend / Divisor).",
    parameters: ["dividend", "divisor"],
    parameterDefinitions: {
      dividend: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      },
      divisor: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      }
    },
    call: function(a, o) {
      var i = r12.complexReal(a), u = r12.complexImaginary(a), s12 = r12.complexReal(o), c = r12.complexImaginary(o), l2 = a.substring(a.length - 1), f = o.substring(o.length - 1), p = l2 === "j" || f === "j" ? "j" : "i";
      if (s12 === 0 && c === 0)
        throw r12.ERRORS.NUM;
      var d = s12 * s12 + c * c;
      return r12.complexCreate((i * s12 + u * c) / d, (u * s12 - i * c) / d, p);
    }
  }), e.addFormulaFunction({
    name: "imexp",
    category: n12,
    description: "Returns the exponential of a complex number.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      }
    },
    call: function(a) {
      var o = r12.complexReal(a), i = r12.complexImaginary(a), u = r12.complexUnit(a), s12 = Math.exp(o);
      return r12.complexCreate(s12 * Math.cos(i), s12 * Math.sin(i), u);
    }
  }), e.addFormulaFunction({
    name: "imln",
    category: n12,
    description: "Returns the natural logarithm of a complex number.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      }
    },
    call: function(a) {
      var o = r12.complexReal(a), i = r12.complexImaginary(a), u = r12.complexUnit(a);
      return r12.complexCreate(Math.log(Math.sqrt(o * o + i * i)), Math.atan(i / o), u);
    }
  }), e.addFormulaFunction({
    name: "imlog10",
    category: n12,
    description: "Returns the base-10 logarithm of a complex number.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      }
    },
    call: function(a) {
      var o = r12.complexReal(a), i = r12.complexImaginary(a), u = r12.complexUnit(a);
      return r12.complexCreate(Math.log(Math.sqrt(o * o + i * i)) / Math.log(10), Math.atan(i / o) / Math.log(10), u);
    }
  }), e.addFormulaFunction({
    name: "imlog2",
    category: n12,
    description: "Returns the base-2 logarithm of a complex number.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      }
    },
    call: function(a) {
      var o = r12.complexReal(a), i = r12.complexImaginary(a), u = r12.complexUnit(a);
      return r12.complexCreate(Math.log(Math.sqrt(o * o + i * i)) / Math.log(2), Math.atan(i / o) / Math.log(2), u);
    }
  }), e.addFormulaFunction({
    name: "impower",
    category: n12,
    description: "Returns the complex number raised to the specified power.",
    parameters: ["complex", "power"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      },
      power: {
        description: "The power to which ComplexNumber will be raised.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      var i = r12.complexUnit(a), u = r12.numbersParse(o), s12 = Math.pow(r12.complexAbs(a), u), c = r12.complexArgument(a);
      return r12.complexCreate(s12 * Math.cos(u * c), s12 * Math.sin(u * c), i);
    }
  }), e.addFormulaFunction({
    name: "improduct",
    category: n12,
    description: "Returns the product of one or more complex numbers.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character",
        multiple: true
      }
    },
    call: function() {
      for (var a = [], o = 0; o < arguments.length; o++)
        a[o] = arguments[o];
      if (a.length === 0)
        throw r12.ERRORS.VALUE;
      for (var i = a[0], u = 1; u < a.length; u++) {
        var s12 = r12.complexReal(i), c = r12.complexImaginary(i), l2 = r12.complexReal(a[u]), f = r12.complexImaginary(a[u]);
        i = r12.complexCreate(s12 * l2 - c * f, s12 * f + c * l2);
      }
      return i;
    }
  }), e.addFormulaFunction({
    name: "imreal",
    category: n12,
    description: "Returns the real coefficient of a complex number.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      }
    },
    call: function(a) {
      return r12.complexReal(a);
    }
  }), e.addFormulaFunction({
    name: "imsin",
    category: n12,
    description: "Returns the sine of a complex number.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      }
    },
    call: function(a) {
      var o = r12.complexReal(a), i = r12.complexImaginary(a), u = r12.complexUnit(a);
      return r12.complexCreate(Math.sin(o) * (Math.exp(i) + Math.exp(-i)) / 2, Math.cos(o) * (Math.exp(i) - Math.exp(-i)) / 2, u);
    }
  }), e.addFormulaFunction({
    name: "imsqrt",
    category: n12,
    description: "Returns the square root of a complex number.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character"
      }
    },
    call: function(a) {
      var o = r12.complexUnit(a), i = Math.sqrt(r12.complexAbs(a)), u = r12.complexArgument(a);
      return r12.complexCreate(i * Math.cos(u / 2), i * Math.sin(u / 2), o);
    }
  }), e.addFormulaFunction({
    name: "imsub",
    category: n12,
    description: "Returns the difference between two complex numbers.",
    parameters: ["first", "second"],
    parameterDefinitions: {
      first: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj" from which second will be subtracted.',
        dataType: "character"
      },
      second: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj" which will be subtracted from first.',
        dataType: "character"
      }
    },
    call: function(a, o) {
      var i = r12.complexReal(a), u = r12.complexImaginary(a), s12 = r12.complexReal(o), c = r12.complexImaginary(o), l2 = a.substring(a.length - 1), f = o.substring(o.length - 1), p = l2 === "j" || f === "j" ? "j" : "i";
      return r12.complexCreate(i - s12, u - c, p);
    }
  }), e.addFormulaFunction({
    name: "imsum",
    category: n12,
    description: "Returns the sum of one or more complex numbers.",
    parameters: ["complex"],
    parameterDefinitions: {
      complex: {
        description: 'The text representation of a complex number in the format: "x + yi" or "x + yj".',
        dataType: "character",
        multiple: true
      }
    },
    call: function() {
      for (var a = [], o = 0; o < arguments.length; o++)
        a[o] = arguments[o];
      if (a.length === 0)
        throw r12.ERRORS.VALUE;
      for (var i = a[0], u = 1; u < a.length; u++) {
        var s12 = r12.complexReal(i), c = r12.complexImaginary(i), l2 = r12.complexReal(a[u]), f = r12.complexImaginary(a[u]);
        i = r12.complexCreate(s12 + l2, c + f);
      }
      return i;
    }
  }), e.addFormulaFunction({
    name: "oct2bin",
    category: n12,
    description: "Converts a text expression representing an octal number to a text expression representing the same number in the binary number system.",
    parameters: ["value", "places"],
    parameterDefinitions: {
      value: {
        description: "A text expression represeting an octal number.",
        dataType: "character"
      },
      places: {
        description: "The number of characters to use in representing the value. If this is not specified, the minimum number of characters neccessary to represent the value will be used. This allows you to specify leading zeros.",
        dataType: "numeric",
        defaultValue: "The minimum number of characters neccessary to represent the value."
      }
    },
    call: function(a, o) {
      return r12.integersBaseChange(8, 2, a, o);
    }
  }), e.addFormulaFunction({
    name: "oct2dec",
    category: n12,
    description: "Returns the decimal value of a text representation of a number in the octal number system.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "A text expression represeting an octal number.",
        dataType: "character"
      }
    },
    call: function(a) {
      return r12.integersParse(a, true, 8);
    }
  }), e.addFormulaFunction({
    name: "oct2hex",
    category: n12,
    description: "Converts a text expression representing an octal number to a text expression representing the same number in the hexadecimal number system.",
    parameters: ["value", "places"],
    parameterDefinitions: {
      value: {
        description: "A text expression represeting an octal number.",
        dataType: "character"
      },
      places: {
        description: "The number of characters to use in representing the value. If this is not specified, the minimum number of characters neccessary to represent the value will be used. This allows you to specify leading zeros.",
        dataType: "numeric",
        defaultValue: "The minimum number of characters neccessary to represent the value."
      }
    },
    call: function(a, o) {
      return r12.integersBaseChange(8, 16, a, o);
    }
  }), Zd;
}
var ef = {}, fne;
function Mu0() {
  if (fne)
    return ef;
  fne = 1, Object.defineProperty(ef, "__esModule", { value: true });
  var t16 = Cr(), e = A1(), r12 = "Financial";
  return t16.addFormulaFunction({
    name: "db",
    category: r12,
    description: "Returns the depreciation of an asset for a specified period using the fixed-declining balance method.",
    parameters: ["cost", "salvage", "life", "period", "month"],
    parameterDefinitions: {
      cost: {
        description: "The initial cost of the asset.",
        dataType: "numeric"
      },
      salvage: {
        description: "The value at the end of the depreciation (sometimes called the salvage value of the asset).",
        dataType: "numeric"
      },
      life: {
        description: "The number of periods over which the asset is being depreciated (sometimes called the useful life of the asset).",
        dataType: "numeric"
      },
      period: {
        description: "The period for which to calculate the depreciation. Period must use the same units as life.",
        dataType: "numeric"
      },
      month: {
        description: "The number of months in the first year. If month is omitted, it is assumed to be 12.",
        dataType: "numeric",
        defaultValue: "12"
      }
    },
    call: function(n12, a, o, i, u) {
      var s12 = e.numbersParse(n12), c = e.numbersParse(a), l2 = e.numbersParse(o), f = e.numbersParse(i), p = u === void 0 ? 12 : e.numbersParse(u);
      if (s12 < 0 || c < 0 || l2 < 0 || f < 0 || ![1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].includes(p) || f > l2)
        throw e.ERRORS.NUM;
      if (c >= s12)
        return 0;
      for (var d = parseFloat((1 - Math.pow(c / s12, 1 / l2)).toFixed(3)), b = s12 * d * p / 12, z = b, _ = 0, q = f === l2 ? l2 - 1 : f, S = 2; S <= q; S++)
        _ = (s12 - z) * d, z += _;
      return f === 1 ? b : f === l2 ? (s12 - z) * d : _;
    }
  }), t16.addFormulaFunction({
    name: "ddb",
    category: r12,
    description: "Returns the depreciation of an asset for a specified period using the double-declining balance method or some other method specified.",
    parameters: ["cost", "salvage", "life", "period", "factor"],
    parameterDefinitions: {
      cost: {
        description: "The initial cost of the asset.",
        dataType: "numeric"
      },
      salvage: {
        description: "The value at the end of the depreciation (sometimes called the salvage value of the asset).",
        dataType: "numeric"
      },
      life: {
        description: "The number of periods over which the asset is being depreciated (sometimes called the useful life of the asset).",
        dataType: "numeric"
      },
      period: {
        description: "The period for which to calculate the depreciation. Period must use the same units as life.",
        dataType: "numeric"
      },
      factor: {
        description: "The rate at which the balance declines. If factor is omitted, it is assumed to be 2 (the double-declining balance method).",
        dataType: "numeric",
        defaultValue: "2"
      }
    },
    call: function(n12, a, o, i, u) {
      var s12 = e.numbersParse(n12), c = e.numbersParse(a), l2 = e.numbersParse(o), f = e.numbersParse(i), p = u === void 0 ? 2 : e.numbersParse(u);
      if (s12 < 0 || c < 0 || l2 < 0 || f < 0 || p <= 0 || f > l2)
        throw e.ERRORS.NUM;
      if (c >= s12)
        return 0;
      for (var d = 0, b = 0, z = 1; z <= f; z++)
        b = Math.min((s12 - d) * (p / l2), s12 - c - d), d += b;
      return b;
    }
  }), t16.addFormulaFunction({
    name: "dollarde",
    category: r12,
    description: "Converts a dollar amount expressed as a fraction into a dollar amount expressed as a decimal.",
    parameters: ["dollar", "fraction"],
    parameterDefinitions: {
      dollar: {
        description: "The dollar amount expressed as a fraction.",
        dataType: "numeric"
      },
      fraction: {
        description: "The value used as the denominator of the fraction. If this value is not an integer, it will be truncated.",
        dataType: "numeric"
      }
    },
    call: function(n12, a) {
      var o = e.numbersParse(n12), i = e.numbersParse(a);
      if (i < 0)
        throw e.ERRORS.NUM;
      if (i >= 0 && i < 1)
        throw e.ERRORS.DIV0;
      i = e.numbersTruncate(i);
      var u = e.numbersTruncate(o);
      u += o % 1 * Math.pow(10, Math.ceil(Math.log(i) / Math.LN10)) / i;
      var s12 = Math.pow(10, Math.ceil(Math.log(i) / Math.LN2) + 1);
      return u = Math.round(u * s12) / s12, u;
    }
  }), t16.addFormulaFunction({
    name: "dollarfr",
    category: r12,
    description: "Converts a dollar amount expressed as a decimal into a dollar amount expressed as a fraction.",
    parameters: ["dollar", "fraction"],
    parameterDefinitions: {
      dollar: {
        description: "The dollar amount expressed as a decimal.",
        dataType: "numeric"
      },
      fraction: {
        description: "The value used as the denominator of the fraction. If this value is not an integer, it will be truncated.",
        dataType: "numeric"
      }
    },
    call: function(n12, a) {
      var o = e.numbersParse(n12), i = e.numbersParse(a);
      if (i < 0)
        throw e.ERRORS.NUM;
      if (i >= 0 && i < 1)
        throw e.ERRORS.DIV0;
      i = e.numbersTruncate(i);
      var u = e.numbersTruncate(o);
      return u += o % 1 * Math.pow(10, -Math.ceil(Math.log(i) / Math.LN10)) * i, u;
    }
  }), t16.addFormulaFunction({
    name: "fv",
    category: r12,
    description: "Returns the future value of an investment based on periodic.",
    parameters: ["rate", "periods", "payment", "value", "type"],
    parameterDefinitions: {
      rate: {
        description: "The interest rate per period.",
        dataType: "numeric"
      },
      periods: {
        description: "Returns the future value of an investment based on periodic.",
        dataType: "numeric"
      },
      payment: {
        description: "The payment made each period, which cannot change over the life of the annuity.",
        dataType: "numeric"
      },
      value: {
        description: "The present value, or the lump-sum amount that a series of future payments is worth right now. If ommitted, it is assumed to be zero.",
        dataType: "numeric",
        defaultValue: "0"
      },
      type: {
        description: "The number zero or one which indicates whether payments are due at the end of the period (zero, the default value) or the beginning (one).",
        dataType: "numeric",
        defaultValue: "0"
      }
    },
    call: function(n12, a, o, i, u) {
      var s12 = e.numbersParse(n12), c = e.numbersParse(a), l2 = e.numbersParse(o), f = e.numbersParse(i || 0), p = e.numbersParse(u || 0);
      return e.financialFuture(s12, c, l2, f, p);
    }
  }), t16.addFormulaFunction({
    name: "impt",
    category: r12,
    description: "Returns the interest payment for a given period for an investment, based on periodic, constant payments and a constant interest rate.",
    parameters: ["rate", "period", "periods", "present", "future", "type"],
    parameterDefinitions: {
      rate: {
        description: "The interest rate per period.",
        dataType: "numeric"
      },
      period: {
        description: "The period, which must be in the range of one to periods.",
        dataType: "numeric"
      },
      periods: {
        description: "The total number of payment periods in an annuity.",
        dataType: "numeric"
      },
      present: {
        description: "The present value, or the lump-sum amount that a series of future payments is worth now.",
        dataType: "numeric"
      },
      future: {
        description: "The future value, or a cash balance you want to attain after the last payment is made. If ommitted, it is assumed to be zero.",
        dataType: "numeric",
        defaultValue: "0"
      },
      type: {
        description: "The number zero or one which indicates whether payments are due at the end of the period (zero, the default value) or the beginning (one).",
        dataType: "numeric",
        defaultValue: "0"
      }
    },
    call: function(n12, a, o, i, u, s12) {
      var c = e.numbersParse(n12), l2 = e.numbersParse(a), f = e.numbersParse(o), p = e.numbersParse(i), d = e.numbersParse(u || 0), b = e.numbersParse(s12 || 0);
      return e.financialInterestPayment(c, l2, f, p, d, b);
    }
  }), t16.addFormulaFunction({
    name: "irr",
    category: r12,
    description: "Returns the internal rate of return for a series of cash flows.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "A collection of payment (negative values) and income (positive values) values that occur at regular intervals.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var n12 = [], a = 0; a < arguments.length; a++)
        n12[a] = arguments[a];
      for (var o = e.numbersFrom(n12), i = function(q, S, N) {
        for (var v = N + 1, C = q[0], L = 1; L < q.length; L++)
          C += q[L] / Math.pow(v, (S[L] - S[0]) / 365);
        return C;
      }, u = function(q, S, N) {
        for (var v = N + 1, C = 0, L = 1; L < q.length; L++) {
          var B = (S[L] - S[0]) / 365;
          C -= B * q[L] / Math.pow(v, B + 1);
        }
        return C;
      }, s12 = [], c = false, l2 = false, f = 0; f < o.length; f++)
        s12[f] = f === 0 ? 0 : s12[f - 1] + 365, o[f] > 0 && (c = true), o[f] < 0 && (l2 = true);
      if (!c || !l2)
        throw e.ERRORS.NUM;
      var p = 0.1, d = 1e-10, b, z, _;
      do
        _ = i(o, s12, p), b = p - _ / u(o, s12, p), z = Math.abs(b - p), p = b;
      while (z > d && Math.abs(_) > d);
      return p;
    }
  }), t16.addFormulaFunction({
    name: "nper",
    category: r12,
    description: "Returns the number of periods for an investment based on periodic, constant payments and a constant interest rate.",
    parameters: ["rate", "payment", "present", "future", "type"],
    parameterDefinitions: {
      rate: {
        description: "The interest rate per period.",
        dataType: "numeric"
      },
      payment: {
        description: "Returns the number of periods for an investment based on periodic, constant payments and a constant interest rate.",
        dataType: "numeric"
      },
      present: {
        description: "The present value, or the lump-sum amount that a series of future payments is worth right now.",
        dataType: "numeric"
      },
      future: {
        description: "The future value, or a cash balance you want to attain after the last payment is made.",
        dataType: "numeric",
        defaultValue: "0"
      },
      type: {
        description: "The number zero or one which indicates whether payments are due at the end of the period (zero, the default value) or the beginning (one).",
        dataType: "numeric",
        defaultValue: "0"
      }
    },
    call: function(n12, a, o, i, u) {
      var s12 = e.numbersParse(n12), c = e.numbersParse(a), l2 = e.numbersParse(o), f = e.numbersParse(i || 0), p = e.numbersParse(u || 0);
      if (s12 === 0)
        return -(l2 + f) / c;
      var d = c * (1 + s12 * p) - f * s12, b = l2 * s12 + c * (1 + s12 * p);
      return Math.log(d / b) / Math.log(1 + s12);
    }
  }), t16.addFormulaFunction({
    name: "npv",
    category: r12,
    description: "Calculates the net present value of an investment by using a discount rate and a series of future payments (negative values) and income (positive value).",
    parameters: ["rate", "values"],
    parameterDefinitions: {
      rate: {
        description: "The rate of discount over the length of one period.",
        dataType: "numeric"
      },
      values: {
        description: "A payment (negative value) or income (positive value).",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function(n12) {
      for (var a = [], o = 1; o < arguments.length; o++)
        a[o - 1] = arguments[o];
      for (var i = e.numbersParse(n12), u = e.numbersFrom(a), s12 = 0, c = 0; c < u.length; c++)
        s12 += u[c] / Math.pow(1 + i, c);
      return s12;
    }
  }), t16.addFormulaFunction({
    name: "pmt",
    category: r12,
    description: "Calculates the payment for a loan based on constant payments and a constant interest rate.",
    parameters: ["rate", "periods", "present", "future", "type"],
    parameterDefinitions: {
      rate: {
        description: "The interest rate for the loan.",
        dataType: "numeric"
      },
      periods: {
        description: "The total number of payments for the loan.",
        dataType: "numeric"
      },
      present: {
        description: "The present value, or the total amount that a series of future payments is worth now; also known as the principal.",
        dataType: "numeric"
      },
      future: {
        description: "The future value, or a cash balance you want to attain after the last payment is made.",
        dataType: "numeric",
        defaultValue: "0"
      },
      type: {
        description: "The number zero or one which indicates whether payments are due at the end of the period (zero, the default value) or the beginning (one).",
        dataType: "numeric",
        defaultValue: "0"
      }
    },
    call: function(n12, a, o, i, u) {
      var s12 = e.numbersParse(n12), c = e.numbersParse(a), l2 = e.numbersParse(o), f = e.numbersParse(i || 0), p = e.numbersParse(u || 0);
      return e.financialLoanPayment(s12, c, l2, f || 0, p || 0);
    }
  }), t16.addFormulaFunction({
    name: "ppmt",
    category: r12,
    description: "Returns the payment on the principal for a given period for an investment based on periodic, constant payments and a constant interest rate.",
    parameters: ["rate", "period", "periods", "present", "future", "type"],
    parameterDefinitions: {
      rate: {
        description: "The interest rate per period.",
        dataType: "numeric"
      },
      period: {
        description: "The period, which must be in the range of one to periods.",
        dataType: "numeric"
      },
      periods: {
        description: "The total number of payment periods in an annuity.",
        dataType: "numeric"
      },
      present: {
        description: "The present value, or the total amount that a series of future payments is worth now.",
        dataType: "numeric"
      },
      future: {
        description: "The future value, or a cash balance you want to attain after the last payment is made.",
        dataType: "numeric",
        defaultValue: "0"
      },
      type: {
        description: "The number zero or one which indicates whether payments are due at the end of the period (zero, the default value) or the beginning (one).",
        dataType: "numeric",
        defaultValue: "0"
      }
    },
    call: function(n12, a, o, i, u, s12) {
      var c = e.numbersParse(n12), l2 = e.numbersParse(a), f = e.numbersParse(o), p = e.numbersParse(i), d = e.numbersParse(u || 0), b = e.numbersParse(s12 || 0);
      return e.financialLoanPayment(c, f, p, d, b) - e.financialInterestPayment(c, l2, f, p, d, b);
    }
  }), t16.addFormulaFunction({
    name: "pv",
    category: r12,
    description: "Returns the present value of an investment.",
    parameters: ["rate", "periods", "payment", "future", "type"],
    parameterDefinitions: {
      rate: {
        description: "The interest rate per period.",
        dataType: "numeric"
      },
      periods: {
        description: "The total number of payment periods in an annuity.",
        dataType: "numeric"
      },
      payment: {
        description: "The payment made each period, which cannot change over the life of the annuity.",
        dataType: "numeric"
      },
      future: {
        description: "The future value, or a cash balance you want to attain after the last payment is made.",
        dataType: "numeric",
        defaultValue: "0"
      },
      type: {
        description: "The number zero or one which indicates whether payments are due at the end of the period (zero, the default value) or the beginning (one).",
        dataType: "numeric",
        defaultValue: "0"
      }
    },
    call: function(n12, a, o, i, u) {
      var s12 = e.numbersParse(n12), c = e.numbersParse(a), l2 = e.numbersParse(o), f = e.numbersParse(i || 0), p = e.numbersParse(u || 0);
      return e.financialPresent(s12, c, l2, f, p);
    }
  }), t16.addFormulaFunction({
    name: "rate",
    category: r12,
    description: "Returns the interest rate per period of an annuity.",
    parameters: ["periods", "payment", "present", "future", "type", "guess"],
    parameterDefinitions: {
      periods: {
        description: "The total number of payment periods in an annuity.",
        dataType: "numeric"
      },
      payment: {
        description: "The payment made each period and cannot change over the life of the annuity.",
        dataType: "numeric"
      },
      present: {
        description: "The present value, or the total amount that a series of future payments is worth now.",
        dataType: "numeric"
      },
      future: {
        description: "The future value, or a cash balance you want to attain after the last payment is made. If fv is omitted, it is assumed to be 0 (the future value of a loan, for example, is 0). For example, if you want to save $50,000 to pay for a special project in 18 years, then $50,000 is the future value. You could then make a conservative guess at an interest rate and determine how much you must save each month. If fv is omitted, you must include the payment argument. The default value for future is zero.",
        dataType: "numeric",
        defaultValue: "0"
      },
      type: {
        description: "The number zero or one which indicates whether payments are due at the end of the period (zero, the default value) or the beginning (one).",
        dataType: "numeric",
        defaultValue: "0"
      },
      guess: {
        description: "A number that you guess is close to the result. If ommitted, it is assumed to be 0.1 (10%).",
        dataType: "numeric",
        defaultValue: "0.1"
      }
    },
    call: function(n12, a, o, i, u, s12) {
      for (var c = e.numbersParse(n12), l2 = e.numbersParse(a), f = e.numbersParse(i || 0), p = e.numbersParse(i || 0), d = e.numbersParse(u || 0) ? 1 : 0, b = s12 === void 0 ? 0.1 : e.numbersParse(s12), z = 1e-10, _ = 20, q = b, S = 0; S < _; S++) {
        if (q <= -1)
          throw e.ERRORS.NUM;
        var N = void 0, v = void 0;
        if (Math.abs(q) < z ? N = f * (1 + c * q) + l2 * (1 + q * d) * c + p : (v = Math.pow(1 + q, c), N = f * v + l2 * (1 / q + d) * (v - 1) + p), Math.abs(N) < z)
          return q;
        var C = void 0;
        if (Math.abs(q) < z)
          C = f * c + l2 * d * c;
        else {
          v = Math.pow(1 + q, c);
          var L = c * Math.pow(1 + q, c - 1);
          C = f * L + l2 * (1 / q + d) * L + l2 * (-1 / (q * q)) * (v - 1);
        }
        q -= N / C;
      }
      return q;
    }
  }), t16.addFormulaFunction({
    name: "sln",
    category: r12,
    description: "Returns the straight-line depreciation of an asset for one period.",
    parameters: ["cost", "salvage", "life"],
    parameterDefinitions: {
      cost: {
        description: "The initial cost of the asset.",
        dataType: "numeric"
      },
      salvage: {
        description: "The value at the end of the depreciation (sometimes called the salvage value of the asset).",
        dataType: "numeric"
      },
      life: {
        description: "The number of periods over which the asset is depreciated.",
        dataType: "numeric"
      }
    },
    call: function(n12, a, o) {
      var i = e.numbersParse(n12), u = e.numbersParse(a), s12 = e.numbersParse(o);
      if (s12 === 0)
        throw e.ERRORS.NUM;
      return (i - u) / s12;
    }
  }), t16.addFormulaFunction({
    name: "syd",
    category: r12,
    description: "Returns the sum-of-years' digits depreciation of an asset for a specified period.",
    parameters: ["cost", "salvage", "life", "period"],
    parameterDefinitions: {
      cost: {
        description: "The initial cost of the asset.",
        dataType: "numeric"
      },
      salvage: {
        description: "The value at the end of the depreciation (sometimes called the salvage value of the asset).",
        dataType: "numeric"
      },
      life: {
        description: "The number of periods over which the asset is depreciated.",
        dataType: "numeric"
      },
      period: {
        description: "The period, which must use the same units as life.",
        dataType: "numeric"
      }
    },
    call: function(n12, a, o, i) {
      var u = e.numbersParse(n12), s12 = e.numbersParse(a), c = e.numbersParse(o), l2 = e.numbersParse(i);
      if (c === 0 || l2 < 1 || l2 > c)
        throw e.ERRORS.NUM;
      return l2 = e.numbersTruncate(l2), (u - s12) * (c - l2 + 1) * 2 / (c * (c + 1));
    }
  }), ef;
}
var tf = {}, bne;
function Ou0() {
  if (bne)
    return tf;
  bne = 1, Object.defineProperty(tf, "__esModule", { value: true });
  var t16 = zc(), e = A1(), r12 = Cr(), n12 = "Information";
  return r12.addFormulaFunction({
    name: "dbnull",
    category: n12,
    description: "Returns something that represents a non-existent value.",
    parameters: [],
    parameterDefinitions: {},
    call: function() {
      return null;
    }
  }), r12.addFormulaFunction({
    name: "isblank",
    category: n12,
    description: "Returns true if the value is blank.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The value to test."
      }
    },
    call: function(a) {
      return a == null || a === "";
    }
  }), r12.addFormulaFunction({
    name: "isdbnull",
    category: n12,
    description: "Returns true if the value represents a non-existent value.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The value to test."
      }
    },
    call: function(a) {
      return a == null;
    }
  }), r12.addFormulaFunction({
    name: "iseven",
    category: n12,
    description: "Returns true if the value is an even number, else returns false.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The value to test."
      }
    },
    call: function(a) {
      return e.isNumber(a) && a % 2 === 0;
    }
  }), r12.addFormulaFunction({
    name: "islogical",
    category: n12,
    description: "Returns true if the value is a logical value (true or false).",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The value to test."
      }
    },
    call: function(a) {
      return e.isNumber(a) && a % 2 === 0;
    }
  }), r12.addFormulaFunction({
    name: "isnontext",
    category: n12,
    description: "Returns true if the value is any item that is not text.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The value to test."
      }
    },
    call: function(a) {
      return !e.isString(a);
    }
  }), r12.addFormulaFunction({
    name: "isnull",
    category: n12,
    description: "Returns true if the value is non-existent.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The value to test."
      }
    },
    call: function(a) {
      return a == null;
    }
  }), r12.addFormulaFunction({
    name: "isnumber",
    category: n12,
    description: "Returns true if the value is a number.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The value to test."
      }
    },
    call: function(a) {
      return e.isNumber(a);
    }
  }), r12.addFormulaFunction({
    name: "isodd",
    category: n12,
    description: "Returns true if the value is an odd number, else returns false.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The value to test."
      }
    },
    call: function(a) {
      return e.isNumber(a) && a % 2 === 1;
    }
  }), r12.addFormulaFunction({
    name: "istext",
    category: n12,
    description: "Returns true if the value is a text value.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The value to test."
      }
    },
    call: function(a) {
      return e.isString(a);
    }
  }), r12.addFormulaFunction({
    name: "n",
    category: n12,
    description: "Converts a value to a number.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: `The value to be converted to a number. The following are acceptable values:
A number - returns the number.
A date - returns the date.
True - returns 1.
False - returns 0.
An error value - returns the error value.
Any other value - returns 0.`
      }
    },
    call: function(a) {
      return e.isNumber(a) || a instanceof Date || a instanceof t16.DateTime ? a : e.isBoolean(a) && a ? 1 : 0;
    }
  }), r12.addFormulaFunction({
    name: "null",
    category: n12,
    description: "Returns a non-existent value.",
    parameters: [],
    parameterDefinitions: {},
    call: function() {
      return null;
    }
  }), r12.addFormulaFunction({
    name: "type",
    category: n12,
    description: "Returns a number representing the type of value: number = 1; text = 2; logical value (true or false) = 4; error value = 16; array = 64.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The value of which to get the type."
      }
    },
    call: function(a) {
      return e.isNumber(a) || a instanceof Date || a instanceof t16.DateTime ? 1 : e.isString(a) ? 2 : e.isBoolean(a) ? 4 : e.isArray(a) ? 64 : 16;
    }
  }), tf;
}
var rf = {}, Mne;
function zu0() {
  if (Mne)
    return rf;
  Mne = 1, Object.defineProperty(rf, "__esModule", { value: true });
  var t16 = Cr(), e = "Logical";
  return t16.addFormulaFunction({
    name: "and",
    category: e,
    description: "Returns true if all values are true or returns false if one or more values are false.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "A logical value (true or false).",
        multiple: true
      }
    },
    call: function() {
      for (var r12 = [], n12 = 0; n12 < arguments.length; n12++)
        r12[n12] = arguments[n12];
      return !r12.some(function(a) {
        return !a;
      });
    }
  }), t16.addFormulaFunction({
    name: "false",
    category: e,
    description: "Returns the logical value false.",
    parameters: [],
    parameterDefinitions: {},
    call: function() {
      return false;
    }
  }), t16.addFormulaFunction({
    name: "if",
    category: e,
    description: "Returns one value if the specified condition evaluates to true and another value if it evaluates to false.",
    parameters: ["test", "truthy", "falsy"],
    parameterDefinitions: {
      test: {
        description: "The condition to test.",
        dataType: "boolean"
      },
      truthy: {
        description: "The result if the condition evaluates to true."
      },
      falsy: {
        description: "The result if the condition evaluates to false."
      }
    },
    call: function(r12, n12, a) {
      return r12 ? n12 : a;
    }
  }), t16.addFormulaFunction({
    name: "not",
    category: e,
    description: "Reverses a logical value (changes true to false and false to true).",
    parameters: ["test"],
    parameterDefinitions: {
      test: {
        description: "A logical value (true or false).",
        dataType: "boolean"
      }
    },
    call: function(r12) {
      return !r12;
    }
  }), t16.addFormulaFunction({
    name: "or",
    category: e,
    description: "Returns true if one or more values are true; returns false if all values are false.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "A logical value (true or false).",
        multiple: true
      }
    },
    call: function() {
      for (var r12 = [], n12 = 0; n12 < arguments.length; n12++)
        r12[n12] = arguments[n12];
      return r12.some(function(a) {
        return !!a;
      });
    }
  }), t16.addFormulaFunction({
    name: "true",
    category: e,
    description: "Returns the logical value true.",
    parameters: [],
    parameterDefinitions: {},
    call: function() {
      return true;
    }
  }), rf;
}
var nf = {}, One;
function Au0() {
  if (One)
    return nf;
  One = 1, Object.defineProperty(nf, "__esModule", { value: true });
  var t16 = Cr(), e = "Lookup & Reference";
  return t16.addFormulaFunction({
    name: "choose",
    category: e,
    description: "Returns one of the values provided in its arguments based on the number in the first argument.",
    parameters: ["index", "values"],
    parameterDefinitions: {
      index: {
        description: "The 1-based index into the rest of the arguments for the value to use.",
        dataType: "numeric"
      },
      values: {
        description: "A value which may be chosen depending on the index value.",
        multiple: true
      }
    },
    call: function(r12) {
      for (var n12 = [], a = 1; a < arguments.length; a++)
        n12[a - 1] = arguments[a];
      return n12[r12 - 1];
    }
  }), nf;
}
var af = {}, zne;
function _u0() {
  if (zne)
    return af;
  zne = 1, Object.defineProperty(af, "__esModule", { value: true });
  var t16 = Z0, e = Cr(), r12 = A1(), n12 = "Math";
  return e.addFormulaFunction({
    name: "abs",
    category: n12,
    description: "Returns the absolute value of a number. The absolute value of a number is the number without its sign.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The real number of which to get the absolute value.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      var o = r12.numbersParse(a);
      return o < 0 ? -o : o;
    }
  }), e.addFormulaFunction({
    name: "acos",
    category: n12,
    description: "Returns the arccosine, or inverse cosine, of a number. The arccosine is the angle whose cosine is specified number. The returned angle is given in radians in the range zero to pi. To convert the result from radians to degrees, multiply by 180/PI().",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The cosine of the angle to get, which must be from -1 to 1.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.acos(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "acosh",
    category: n12,
    description: "Returns the inverse hyperbolic cosine of the given number. The inverse hyperbolic cosine is the angle whose hyperbolic cosine is specified number.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "A real number greater than 1 for which to find the inverse hyperbolic cosine.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.acosh(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "acosh",
    category: n12,
    description: "Returns the inverse hyperbolic cosine of the given number. The inverse hyperbolic cosine is the angle whose hyperbolic cosine is specified number.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "A real number greater than 1 for which to find the inverse hyperbolic cosine.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.acosh(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "asin",
    category: n12,
    description: "Returns the arcsine, or inverse sine, of a number. The arcsine is the angle whose sine is the specified number. The returned angle is given in radians in the range -pi/2 to pi/2. To express the arcsine in degrees, multiply the result by 180/PI().",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The sine of the angle to get, which must be from -1 to 1 radians.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.asin(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "asinh",
    category: n12,
    description: "Returns the inverse hyperbolic sine of the given number. The inverse hyperbolic sine is the angle whose hyperbolic sine is specified number.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "A real number for which to find the inverse hyperbolic sine.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.asinh(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "atan",
    category: n12,
    description: "Returns the arctangent, or inverse tangent, of a number. The arctangent is the angle whose tangent is the specified number. The returned angle is given in radians in the range -pi/2 to pi/2. To express the arctangent in degrees, multiply the result by 180/PI().",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The tangent of the angle to get.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.atan(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "atan2",
    category: n12,
    description: "Returns the arctangent, or inverse tangent, of the specified x and y-coordinates. The arctangent is the angle from the x-axis to a line containing the origin (0, 0) and a point with coordinates (x_num, y_num). The angle is given in radians between -pi and pi, excluding -pi.",
    parameters: ["x", "y"],
    parameterDefinitions: {
      x: {
        description: "The x-coordinate of the point.",
        dataType: "numeric"
      },
      y: {
        description: "The y-coordinate of the point.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      return Math.atan2(r12.numbersParse(o), r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "atanh",
    category: n12,
    description: "Returns the inverse hyperbolic tangent of the given number. The inverse hyperbolic tangent is the angle whose hyperbolic tangent is specified number.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "A real number between -1 and 1 for which to get the inverse hyperbolic tangent.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.atanh(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "ceiling",
    category: n12,
    description: "Returns the smallest multiple of the significance (defaults to 1) greater than or equal to the specified number.",
    parameters: ["value", "significance"],
    parameterDefinitions: {
      value: {
        description: "The number to round.",
        dataType: "numeric"
      },
      significance: {
        description: "The multiple to which to round. If omitted, this is assumed to be one.",
        dataType: "numeric",
        defaultValue: "1"
      }
    },
    call: function(a, o) {
      return r12.numbersCeiling(r12.numbersParse(a), o === void 0 ? 1 : r12.numbersParse(o));
    }
  }), e.addFormulaFunction({
    name: "combin",
    category: n12,
    description: "Returns the number of possible combinations given a set of items and a number of chosen items from that set.",
    parameters: ["value", "choose"],
    parameterDefinitions: {
      value: {
        description: "The number of items.",
        dataType: "numeric"
      },
      choose: {
        description: "The number of items chosen in each combination.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      return r12.numbersCombinatorial(r12.numbersParse(a), r12.numbersParse(o));
    }
  }), e.addFormulaFunction({
    name: "combina",
    category: n12,
    description: "Returns the number of possible combinations (with repetitions) given a set of items and a number of chosen items from that set.",
    parameters: ["value", "choose"],
    parameterDefinitions: {
      value: {
        description: "The number of items.",
        dataType: "numeric"
      },
      choose: {
        description: "The number of items chosen in each combination.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      var i = r12.numbersParse(a), u = r12.numbersParse(o);
      return i === 0 && u === 0 ? 1 : r12.numbersCombinatorial(i + u - 1, i - 1);
    }
  }), e.addFormulaFunction({
    name: "cos",
    category: n12,
    description: "Returns the cosine of the given angle.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The angle in radians for which to get the cosine.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.cos(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "cosh",
    category: n12,
    description: "Returns the hyperbolic cosine of a number.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "A real number for which to find the hyperbolic cosine.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.cosh(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "degrees",
    category: n12,
    description: "Converts radians to degrees.",
    parameters: ["radians"],
    parameterDefinitions: {
      radians: {
        description: "A value in radians which will be converted to degrees.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return r12.numbersParse(a) * 180 / Math.PI;
    }
  }), e.addFormulaFunction({
    name: "even",
    category: n12,
    description: "Rounds a positive number up and a negative number down to nearest even integer.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The value to round.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return r12.numbersCeiling(a, -2, -1);
    }
  }), e.addFormulaFunction({
    name: "exp",
    category: n12,
    description: "Returns e raised to the power of the specified number. The constant e equals 2.71828182845904.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The exponent applied to which to raise e.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.exp(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "fact",
    category: n12,
    description: "Returns the factorial of a number.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "A positive number for which the factorial will be calculated.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return r12.numbersFactorial(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "factdouble",
    category: n12,
    description: "Returns the double factorial of a number.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "A positive number for which the double factorial will be calculated.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return r12.numbersFactorialDouble(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "floor",
    category: n12,
    description: "Returns the largest multiple of the significance (defaults to 1) less than or equal to the given number.",
    parameters: ["value", "significance"],
    parameterDefinitions: {
      value: {
        description: "The number to round.",
        dataType: "numeric"
      },
      significance: {
        description: "The multiple to which to round. If omitted, this is assumed to be one.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      return r12.numbersFloor(r12.numbersParse(a), r12.numbersParse(o));
    }
  }), e.addFormulaFunction({
    name: "gcd",
    category: n12,
    description: "Returns the greatest common divisor of one or more integer values.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "An integer value. A non-integer value will be truncated.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var a = [], o = 0; o < arguments.length; o++)
        a[o] = arguments[o];
      for (var i = a.length, u = r12.numbersParse(a[0]), s12 = u < 0 ? -u : u, c = 1; c < i; c++) {
        for (var l2 = r12.numbersParse(a[c]), f = l2 < 0 ? -l2 : l2; s12 && f; )
          s12 > f ? s12 %= f : f %= s12;
        s12 += f;
      }
      return s12;
    }
  }), e.addFormulaFunction({
    name: "int",
    category: n12,
    description: "Rounds a number down to the nearest integer.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The real number to round down to an integer.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.floor(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "lcm",
    category: n12,
    description: "Returns the least common multiple of one or more integer values.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "An integer value. A non-integer value will be truncated.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var a = [], o = 0; o < arguments.length; o++)
        a[o] = arguments[o];
      for (var i = r12.numbersFrom(a), u = 1, s12 = void 0, c = void 0, l2 = void 0, f = void 0; (l2 = i.pop()) !== void 0; )
        for (; l2 > 1; ) {
          if (l2 % 2) {
            for (s12 = 3, c = Math.floor(Math.sqrt(l2)); s12 <= c && l2 % s12; s12 += 2)
              ;
            f = s12 <= c ? s12 : l2;
          } else
            f = 2;
          for (l2 /= f, u *= f, s12 = i.length; s12; i[--s12] % f === 0 && (i[s12] /= f) === 1 && i.splice(s12, 1))
            ;
        }
      return u;
    }
  }), e.addFormulaFunction({
    name: "ln",
    category: n12,
    description: "Returns the natural logarithm of a number.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The positive real number for which to get the natural logarithm.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.log(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "log",
    category: n12,
    description: "Returns the logarithm of a number to the base specified.",
    parameters: ["value", "base"],
    parameterDefinitions: {
      value: {
        description: "The positive real number for which to get the logarithm.",
        dataType: "numeric"
      },
      base: {
        description: "The base of the logarithm.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      return Math.log(r12.numbersParse(a)) / Math.log(o === void 0 ? 10 : r12.numbersParse(o));
    }
  }), e.addFormulaFunction({
    name: "log10",
    category: n12,
    description: "Returns the base-10 logarithm of a number.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The positive real number for which to get the base-10 logarithm.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.log(r12.numbersParse(a)) / Math.log(10);
    }
  }), e.addFormulaFunction({
    name: "mod",
    category: n12,
    description: "Returns the remainder after a number is divided by a divisor. The result has the same sign as the divisor.",
    parameters: ["dividend", "divisor"],
    parameterDefinitions: {
      dividend: {
        description: "The number for which to find the remainder.",
        dataType: "numeric"
      },
      divisor: {
        description: "The value by which to divide the number.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      var i = r12.numbersParse(a), u = r12.numbersParse(o);
      if (u === 0)
        throw r12.ERRORS.DIV0;
      var s12 = Math.abs(i % u);
      return s12 = i < 0 ? u - s12 : s12, u > 0 ? s12 : -s12;
    }
  }), e.addFormulaFunction({
    name: "mod",
    category: n12,
    description: "Returns the remainder after a number is divided by a divisor. The result has the same sign as the divisor.",
    parameters: ["dividend", "divisor"],
    parameterDefinitions: {
      dividend: {
        description: "The number for which to find the remainder.",
        dataType: "numeric"
      },
      divisor: {
        description: "The value by which to divide the number.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      var i = r12.numbersParse(a), u = r12.numbersParse(o);
      if (u === 0)
        throw r12.ERRORS.DIV0;
      var s12 = Math.abs(i % u);
      return s12 = i < 0 ? u - s12 : s12, u > 0 ? s12 : -s12;
    }
  }), e.addFormulaFunction({
    name: "mround",
    category: n12,
    description: "Rounds a number to the nearest multiple of another number.",
    parameters: ["value", "multiple"],
    parameterDefinitions: {
      value: {
        description: "The number to be rounded.",
        dataType: "numeric"
      },
      multiple: {
        description: "A number indicating the multiple to which to round.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      var i = r12.numbersParse(a), u = r12.numbersParse(o);
      if (i * u < 0)
        throw r12.ERRORS.NUM;
      return Math.round(i / u) * u;
    }
  }), e.addFormulaFunction({
    name: "multinomial",
    category: n12,
    description: "Returns the multinomial of a set of numbers. The multinomial is the ratio of the factorial of a sum of values to the product of their factorials.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "One of the numbers for which to get the multinomial.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var a, o, i = [], u = 0; u < arguments.length; u++)
        i[u] = arguments[u];
      var s12 = r12.numbersFrom(i), c = 0, l2 = 1;
      try {
        for (var f = t16.__values(s12), p = f.next(); !p.done; p = f.next()) {
          var d = p.value;
          c += d, l2 *= r12.numbersFactorial(d);
        }
      } catch (b) {
        a = { error: b };
      } finally {
        try {
          p && !p.done && (o = f.return) && o.call(f);
        } finally {
          if (a)
            throw a.error;
        }
      }
      return r12.numbersFactorial(c) / l2;
    }
  }), e.addFormulaFunction({
    name: "odd",
    category: n12,
    description: "Rounds a positive number up and a negative number down to the nearest odd integer.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The value to round.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      var o = r12.numbersParse(a), i = Math.ceil(Math.abs(o));
      return i = i & 1 ? i : i + 1, o > 0 ? i : -i;
    }
  }), e.addFormulaFunction({
    name: "pi",
    category: n12,
    description: "Returns the constant pi, which is 3.14159265358979.",
    parameters: [],
    parameterDefinitions: {},
    call: function() {
      return Math.PI;
    }
  }), e.addFormulaFunction({
    name: "power",
    category: n12,
    description: "Returns the result of a number raised to a power.",
    parameters: ["value", "power"],
    parameterDefinitions: {
      value: {
        description: "The base number to raise to a power.",
        dataType: "numeric"
      },
      power: {
        description: "The exponent to which the base number is raised.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      var i = r12.numbersParse(a), u = r12.numbersParse(o), s12 = Math.pow(i, u);
      if (isNaN(s12))
        throw r12.ERRORS.NUM;
      return s12;
    }
  }), e.addFormulaFunction({
    name: "product",
    category: n12,
    description: "Multiplies all the numbers given as arguments and returns the product.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "A number to multiply to the other numbers.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var a = [], o = 0; o < arguments.length; o++)
        a[o] = arguments[o];
      return r12.numbersProduct(r12.numbersFrom(a));
    }
  }), e.addFormulaFunction({
    name: "quotient",
    category: n12,
    description: "Returns the integer portion of a division. This will discard the remainder of the division.",
    parameters: ["numerator", "denominator"],
    parameterDefinitions: {
      numerator: {
        description: "Returns the integer portion of a division. This will discard the remainder of the division.",
        dataType: "numeric"
      },
      denominator: {
        description: "The divisor of the division operation.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      return r12.numbersTruncate(r12.numbersParse(a) / r12.numbersParse(o));
    }
  }), e.addFormulaFunction({
    name: "radians",
    category: n12,
    description: "Converts degrees to radians.",
    parameters: ["degrees"],
    parameterDefinitions: {
      degrees: {
        description: "A value in degrees which will be converted to radians.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return r12.numbersParse(a) * Math.PI / 180;
    }
  }), e.addFormulaFunction({
    name: "rand",
    category: n12,
    description: "Returns an evenly distributed random number greater than or equal to 0 and less than 1",
    parameters: [],
    parameterDefinitions: {},
    call: function() {
      return Math.random();
    }
  }), e.addFormulaFunction({
    name: "randbetween",
    category: n12,
    description: "Generates a pseudorandom integer between two specified numbers.",
    parameters: ["bottom", "top"],
    parameterDefinitions: {
      bottom: {
        description: "The minumum value that will be returned.",
        dataType: "numeric"
      },
      top: {
        description: "The maximum value that will be returned.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      var i = r12.numbersParse(a), u = r12.numbersParse(o);
      return Math.floor((u - i + 1) * Math.random()) + i;
    }
  }), e.addFormulaFunction({
    name: "round",
    category: n12,
    description: "Rounds a number to a specified number of digits.",
    parameters: ["value", "digits", "style"],
    parameterDefinitions: {
      value: {
        description: "The number to round.",
        dataType: "numeric"
      },
      digits: {
        description: "The number of digits to which to round number.",
        dataType: "numeric"
      },
      style: {
        description: `A number indicating the style of rounding to use.
0 - Arithmetic Rounding (default) - If the last significant digit in the rounding is a 5, the number is rounded up.
1 - Banker's Rounding - When the last significant digit is a 5, the preceding digit is used to determine whether to round up or down. If the digit is even, the number is rounded down. If it is odd, then the number is rounded up.`,
        dataType: "numeric",
        defaultValue: "0"
      }
    },
    call: function(a, o, i) {
      var u = r12.numbersParse(a), s12 = r12.numbersParse(o || 0), c = r12.numbersParse(i || 0);
      if (c < 0 || c > 1)
        throw r12.ERRORS.NUM;
      if (c === 0)
        return r12.numbersRound(u, s12);
      var l2 = Math.pow(10, s12), f = Number((s12 ? u * l2 : u).toFixed(8)), p = Math.floor(f), d = f - p, b = 1e-8, z = d > 0.5 - b && d < 0.5 + b ? p % 2 === 0 ? p : p + 1 : Math.round(f);
      return s12 ? z / l2 : z;
    }
  }), e.addFormulaFunction({
    name: "rounddown",
    category: n12,
    description: "Rounds a number to down to the specified number of digits.",
    parameters: ["value", "digits"],
    parameterDefinitions: {
      value: {
        description: "The number to be rounded down.",
        dataType: "numeric"
      },
      digits: {
        description: "The number of decimal places to round. Positive numbers indicates places after the decimal point, negative numbers indicate places before the decimal point.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      var i = r12.numbersParse(a), u = r12.numbersParse(o), s12 = i > 0 ? 1 : -1;
      return s12 * Math.floor(Math.abs(i) * Math.pow(10, u)) / Math.pow(10, u);
    }
  }), e.addFormulaFunction({
    name: "roundup",
    category: n12,
    description: "Rounds a number to up to the specified number of digits.",
    parameters: ["value", "digits"],
    parameterDefinitions: {
      value: {
        description: "The number to be rounded up.",
        dataType: "numeric"
      },
      digits: {
        description: "The number of decimal places to round. Positive numbers indicates places after the decimal point, negative numbers indicate places before the decimal point.",
        dataType: "numeric"
      }
    },
    call: function(a, o) {
      var i = r12.numbersParse(a), u = r12.numbersParse(o), s12 = i > 0 ? 1 : -1;
      return s12 * Math.ceil(Math.abs(i) * Math.pow(10, u)) / Math.pow(10, u);
    }
  }), e.addFormulaFunction({
    name: "sign",
    category: n12,
    description: "Returns the sign of a number (-1, 0, or 1).",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The number whose sign will be returned.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      var o = r12.numbersParse(a);
      return o === 0 ? 0 : o < 0 ? -1 : 1;
    }
  }), e.addFormulaFunction({
    name: "sin",
    category: n12,
    description: "Returns the sine of the given angle.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The angle in radians for which to get the sine.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.sin(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "sinh",
    category: n12,
    description: "Returns the hyperbolic sine of the given angle.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "A real number of which to get the hyperbolic sine.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.sinh(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "sqrt",
    category: n12,
    description: "Returns a positive square root of a number.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The number for which to get the square root.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.sqrt(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "sqrtpi",
    category: n12,
    description: "Multiplies the specified number by pi and returns the square root of the result.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The number to multiply by pi.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.sqrt(r12.numbersParse(a) * Math.PI);
    }
  }), e.addFormulaFunction({
    name: "subtotal",
    category: n12,
    description: "Calculates the subtotal in one of more references.",
    parameters: ["type", "values"],
    parameterDefinitions: {
      type: {
        description: `A number representing the function to be calculated. Add 100 to the value to ignore hidden values.
1 (or 101) - AVERAGE
2 (or 102) - COUNT
4 (or 104) - MAX
5 (or 105) - MIN
6 (or 106) - PRODUCT
7 (or 107) - STDEV
9 (or 109) - SUM
10 (or 110) - VAR`,
        dataType: "numeric"
      },
      values: {
        description: "The values to calculate a result from.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function(a) {
      for (var o = [], i = 1; i < arguments.length; i++)
        o[i - 1] = arguments[i];
      var u = r12.numbersParse(a), s12 = r12.numbersFrom(o);
      switch (u) {
        case 1:
        case 101:
          return r12.numbersAverage(s12);
        case 2:
        case 102:
          return s12.length;
        case 4:
        case 104:
          return r12.numbersMax(s12);
        case 5:
        case 105:
          return r12.numbersMin(s12);
        case 6:
        case 106:
          return r12.numbersProduct(s12);
        case 7:
        case 107:
          return r12.numbersStandardDeviation(s12);
        case 9:
        case 109:
          return r12.numbersSum(s12);
        case 10:
        case 110:
          return r12.numbersVariance(s12);
        default:
          throw r12.ERRORS.NUM;
      }
    }
  }), e.addFormulaFunction({
    name: "sum",
    category: n12,
    description: "Sums all the numbers given as arguments and returns the sum.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "The values to calculate the sum of.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var a = [], o = 0; o < arguments.length; o++)
        a[o] = arguments[o];
      return r12.numbersSum(r12.numbersFrom(a));
    }
  }), e.addFormulaFunction({
    name: "tan",
    category: n12,
    description: "Returns the tangent of the specified angle.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The angle, in radians, for which to get the tangent.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.tan(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "tanh",
    category: n12,
    description: "Returns the hyperbolic tangent of the specified angle.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The angle, in radians, for which to get the hyperbolic tangent.",
        dataType: "numeric"
      }
    },
    call: function(a) {
      return Math.tanh(r12.numbersParse(a));
    }
  }), e.addFormulaFunction({
    name: "trunc",
    category: n12,
    description: "Truncates a number to an integer by removing the fractional part of the number.",
    parameters: ["value", "digits"],
    parameterDefinitions: {
      value: {
        description: "The number to truncate.",
        dataType: "numeric"
      },
      digits: {
        description: "A number specifying the precision of the truncation. The default value is zero.",
        dataType: "numeric",
        defaultValue: "0"
      }
    },
    call: function(a, o) {
      var i = r12.numbersParse(a), u = r12.numbersParse(o || 0), s12 = i > 0 ? 1 : -1;
      return s12 * Math.floor(Math.abs(i) * Math.pow(10, u)) / Math.pow(10, u);
    }
  }), af;
}
var of = {}, Ane;
function hu0() {
  if (Ane)
    return of;
  Ane = 1, Object.defineProperty(of, "__esModule", { value: true });
  var t16 = Cr(), e = A1(), r12 = "Statistical";
  return t16.addFormulaFunction({
    name: "avedev",
    category: r12,
    description: "Returns the average deviation from the average of all numeric values.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "One or more numeric values or references to numeric values.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var n12 = [], a = 0; a < arguments.length; a++)
        n12[a] = arguments[a];
      var o = e.numbersFrom(n12), i = e.numbersAverage(o), u = o.map(function(c) {
        return Math.abs(c - i);
      }), s12 = e.numbersAverage(u);
      return s12;
    }
  }), t16.addFormulaFunction({
    name: "average",
    category: r12,
    description: "Returns the average (arithmetic mean) of one or more values.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "A number or range of numbers for which to find the average with the other arguments.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var n12 = [], a = 0; a < arguments.length; a++)
        n12[a] = arguments[a];
      var o = e.numbersFrom(n12), i = e.numbersAverage(o);
      return i;
    }
  }), t16.addFormulaFunction({
    name: "binomdist",
    category: r12,
    description: "Returns the number of possible combinations (with repetitions) given a set of items and a number of chosen items from that set.",
    parameters: ["successes", "trials", "probability", "cumulitive"],
    parameterDefinitions: {
      successes: {
        description: "The number of successes in trials.",
        dataType: "numeric"
      },
      trials: {
        description: "The number of independent trials.",
        dataType: "numeric"
      },
      probability: {
        description: "The probability of success on each trial.",
        dataType: "numeric"
      },
      cumulitive: {
        description: "A logical value that determines the form of the function. If true, the function will return the cumulative distribution which is the probability that there are at most 'value' successes otherwise it will return the probability mass which is the probability that there are 'value' successes.",
        dataType: "boolean"
      }
    },
    call: function(n12, a, o, i) {
      var u = e.numbersParse(n12), s12 = e.numbersParse(a), c = e.numbersParse(o);
      return i ? e.statsBinomialCumulative(u, s12, c) : e.statsBinomialProbability(u, s12, c);
    }
  }), t16.addFormulaFunction({
    name: "count",
    category: r12,
    description: "Counts the number of references that contain numbers.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "A reference or range of references that may contain numbers.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var n12 = [], a = 0; a < arguments.length; a++)
        n12[a] = arguments[a];
      var o = e.numbersFrom(n12);
      return o.length;
    }
  }), t16.addFormulaFunction({
    name: "counta",
    category: r12,
    description: "Counts the number of references that are not blank.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "A reference or range of references that may contain numbers.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var n12 = [], a = 0; a < arguments.length; a++)
        n12[a] = arguments[a];
      return n12.reduce(function(o, i) {
        return i == null || i === "" ? o : o + 1;
      }, 0);
    }
  }), t16.addFormulaFunction({
    name: "max",
    category: r12,
    description: "Returns the largest number in a set of numbers.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "A number or range of numbers.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var n12 = [], a = 0; a < arguments.length; a++)
        n12[a] = arguments[a];
      var o = e.numbersFrom(n12);
      return e.numbersMax(o);
    }
  }), t16.addFormulaFunction({
    name: "median",
    category: r12,
    description: "Returns the median of a set of numbers. The median is the middle number when the numbers are sorted or the average of the two middle numbers if there are an even number of specified numbers.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "A number or range of numbers.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var n12 = [], a = 0; a < arguments.length; a++)
        n12[a] = arguments[a];
      var o = e.numbersFrom(n12);
      return e.numbersMedian(o);
    }
  }), t16.addFormulaFunction({
    name: "min",
    category: r12,
    description: "Returns the smallest number in a set of numbers.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "A number or range of numbers.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var n12 = [], a = 0; a < arguments.length; a++)
        n12[a] = arguments[a];
      var o = e.numbersFrom(n12);
      return e.numbersMin(o);
    }
  }), t16.addFormulaFunction({
    name: "stdev",
    category: r12,
    description: "Returns the standard deviation of a population sample.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "A number or range of numbers specifying a sample of a population.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var n12 = [], a = 0; a < arguments.length; a++)
        n12[a] = arguments[a];
      var o = e.numbersFrom(n12);
      return e.numbersStandardDeviation(o);
    }
  }), t16.addFormulaFunction({
    name: "var",
    category: r12,
    description: "Returns the variance of a population sample.",
    parameters: ["values"],
    parameterDefinitions: {
      values: {
        description: "A number or range of numbers specifying a sample of a population.",
        dataType: "numeric",
        multiple: true
      }
    },
    call: function() {
      for (var n12 = [], a = 0; a < arguments.length; a++)
        n12[a] = arguments[a];
      var o = e.numbersFrom(n12);
      return e.numbersVariance(o);
    }
  }), of;
}
var uf = {}, _ne;
function vu0() {
  if (_ne)
    return uf;
  _ne = 1, Object.defineProperty(uf, "__esModule", { value: true });
  var t16 = Cr(), e = A1(), r12 = "Text";
  return t16.addFormulaFunction({
    name: "char",
    category: r12,
    description: "Returns the character specified by the code number from the character set for your computer.",
    parameters: ["code"],
    parameterDefinitions: {
      code: {
        description: "The number to be converted to a character.",
        dataType: "numeric"
      }
    },
    call: function(n12) {
      var a = e.integersParse(n12);
      return String.fromCharCode(a);
    }
  }), t16.addFormulaFunction({
    name: "code",
    category: r12,
    description: "Returns a numeric code for the first character in a text expression using the character set used by your computer.",
    parameters: ["text"],
    parameterDefinitions: {
      text: {
        description: "The text expression which will have its first character evaluated.",
        dataType: "character"
      }
    },
    call: function(n12) {
      n12 === void 0 && (n12 = "");
      var a = e.textParse(n12).charCodeAt(0);
      if (isNaN(a))
        throw e.ERRORS.NA;
      return a;
    }
  }), t16.addFormulaFunction({
    name: "concatenate",
    category: r12,
    description: "Joins all the arguments into one text expression.",
    parameters: ["texts"],
    parameterDefinitions: {
      texts: {
        description: "A text expression or range of text expressions to be joined into a single text expression.",
        dataType: "character",
        multiple: true
      }
    },
    call: function() {
      for (var n12 = [], a = 0; a < arguments.length; a++)
        n12[a] = arguments[a];
      return n12.reduce(function(o, i) {
        return e.textParse(o, false) + e.textParse(i, false);
      });
    }
  }), t16.addFormulaFunction({
    name: "find",
    category: r12,
    description: "Returns the the starting position of one text expression within another, case sensitively.",
    parameters: ["find", "within", "start"],
    parameterDefinitions: {
      find: {
        description: "The text to find.",
        dataType: "character"
      },
      within: {
        description: "The text containing the text to find.",
        dataType: "character"
      },
      start: {
        description: "The 1-based index character at which to start the search. If omitted, it is assumed to be one.",
        dataType: "numeric",
        defaultValue: "1"
      }
    },
    call: function(n12, a, o) {
      var i = e.textParse(n12), u = e.textParse(a), s12 = e.integersParse(o, false, 10, 1);
      return u.indexOf(i, s12 - 1) + 1;
    }
  }), t16.addFormulaFunction({
    name: "fixed",
    category: r12,
    description: "Rounds a number to the specified number of decimals and returns the result as text with or without commas.",
    parameters: ["value", "decimals", "nocomma"],
    parameterDefinitions: {
      value: {
        description: "The number to round and convert to text.",
        dataType: "numeric"
      },
      decimals: {
        description: "The number of digits to the right of the decimal point in the return value. If this value is negative, 'number' is rounded to the left of the decimal point. The default value is 2.",
        dataType: "numeric",
        defaultValue: "2"
      },
      nocomma: {
        description: "True if commas should not be in the return value. If omitted, it is assumed to be false.",
        dataType: "boolean",
        defaultValue: "false"
      }
    },
    call: function(n12, a, o) {
      a === void 0 && (a = 2), o === void 0 && (o = false);
      var i = e.numbersParse(n12), u = e.integersParse(a, false, 10, 2), s12 = i.toString(u);
      return o ? s12 : s12.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }), t16.addFormulaFunction({
    name: "left",
    category: r12,
    description: "Returns the first character or characters in a text expression.",
    parameters: ["value", "count"],
    parameterDefinitions: {
      value: {
        description: "The text expression containing the characters to extract.",
        dataType: "character"
      },
      count: {
        description: "The number of characters to extract.",
        dataType: "numeric",
        defaultValue: "1"
      }
    },
    call: function(n12, a) {
      var o = e.textParse(n12), i = e.integersParse(a, false, 10, 1);
      return o.substring(0, i);
    }
  }), t16.addFormulaFunction({
    name: "len",
    category: r12,
    description: "Returns the number of characters in a text expression.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The text expression whose length to find. Spaces count as characters.",
        dataType: "character"
      }
    },
    call: function(n12) {
      var a = e.textParse(n12);
      return a.length;
    }
  }), t16.addFormulaFunction({
    name: "lower",
    category: r12,
    description: "Converts all uppercase letters in a text expression to lowercase.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The text to convert to lowercase.",
        dataType: "character"
      }
    },
    call: function(n12) {
      var a = e.textParse(n12);
      return a.toLowerCase();
    }
  }), t16.addFormulaFunction({
    name: "mid",
    category: r12,
    description: "Returns a specific number of characters from a text expression.",
    parameters: ["value", "start", "count"],
    parameterDefinitions: {
      value: {
        description: "The text expression containing the characters to extract.",
        dataType: "character"
      },
      start: {
        description: "The 1-based index of the first character to extract.",
        dataType: "numeric",
        defaultValue: "1"
      },
      count: {
        description: "The number of characters to extract.",
        dataType: "numeric",
        defaultValue: "all remaining from start"
      }
    },
    call: function(n12, a, o) {
      var i = e.textParse(n12), u = e.integersParse(a, false, 10, 1) - 1, s12 = e.integersParse(o, false, 10, i.length);
      return i.substring(u, u + s12);
    }
  }), t16.addFormulaFunction({
    name: "replace",
    category: r12,
    description: "Replaces part of a text expression.",
    parameters: ["value", "start", "count", "replaceWith"],
    parameterDefinitions: {
      value: {
        description: "The text expression in which to replace some characters.",
        dataType: "character"
      },
      start: {
        description: "The 1-based index of the character in value to replace with replaceWith.",
        dataType: "numeric"
      },
      count: {
        description: "The number of characters in value to replace with replaceWith.",
        dataType: "numeric"
      },
      replaceWith: {
        description: "The text that will replace the characters in value.",
        dataType: "character"
      }
    },
    call: function(n12, a, o, i) {
      var u = e.textParse(n12), s12 = e.integersParse(a) - 1, c = e.integersParse(o), l2 = e.textParse(i);
      return u.substring(0, s12 - 1) + l2 + u.substring(s12 - 1 + c);
    }
  }), t16.addFormulaFunction({
    name: "repeat",
    category: r12,
    description: "Repeats text a specific number of times.",
    parameters: ["value", "count"],
    parameterDefinitions: {
      value: {
        description: "The text to repeat.",
        dataType: "character"
      },
      count: {
        description: "The positive number of times to repeat the text.",
        dataType: "numeric"
      }
    },
    call: function(n12, a) {
      for (var o = e.textParse(n12), i = e.integersParse(a), u = "", s12 = 0; s12 < i; s12++)
        u += o;
      return u;
    }
  }), t16.addFormulaFunction({
    name: "right",
    category: r12,
    description: "Returns the last character or characters in a text expression.",
    parameters: ["value", "count"],
    parameterDefinitions: {
      value: {
        description: "The text expression containing the characters to extract.",
        dataType: "character"
      },
      count: {
        description: "The number of characters to extract.",
        dataType: "numeric",
        defaultValue: "1"
      }
    },
    call: function(n12, a) {
      a === void 0 && (a = 2);
      var o = e.textParse(n12), i = e.integersParse(a, false, 10, 1);
      return o.substring(o.length - i);
    }
  }), t16.addFormulaFunction({
    name: "search",
    category: r12,
    description: "Returns the 1-based index of one string within another, searching case insensitively.",
    parameters: ["find", "within", "start"],
    parameterDefinitions: {
      find: {
        description: "The text to find in within.",
        dataType: "character"
      },
      within: {
        description: "The text in which to find find.",
        dataType: "character"
      },
      start: {
        description: "The 1-based index in which to start the search (if omitted, the start_index is 1).",
        dataType: "numeric",
        defaultValue: "1"
      }
    },
    call: function(n12, a, o) {
      var i = e.textParse(n12), u = e.textParse(a), s12 = e.integersParse(o, false, 10, 1), c = u.toLowerCase().indexOf(i.toLowerCase(), s12 - 1) + 1;
      if (c === 0)
        throw e.ERRORS.VALUE;
      return c;
    }
  }), t16.addFormulaFunction({
    name: "searchb",
    category: r12,
    description: "Returns the 1-based index of one string within another, searching case insensitively.",
    parameters: ["find", "within", "start"],
    parameterDefinitions: {
      find: {
        description: "The text to find in within.",
        dataType: "character"
      },
      within: {
        description: "The text in which to find find.",
        dataType: "character"
      },
      start: {
        description: "The 1-based index in which to start the search (if omitted, the start_index is 1).",
        dataType: "numeric",
        defaultValue: "1"
      }
    },
    call: function(n12, a, o) {
      var i = e.textParse(n12), u = e.textParse(a), s12 = e.integersParse(o, false, 10, 1), c = u.toLowerCase().indexOf(i.toLowerCase(), s12 - 1) + 1;
      if (c === 0)
        throw e.ERRORS.VALUE;
      return c;
    }
  }), t16.addFormulaFunction({
    name: "trim",
    category: r12,
    description: "Removes all spaces from text except for single spaces between words.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The text from which to remove extra spaces.",
        dataType: "character"
      }
    },
    call: function(n12) {
      var a = e.textParse(n12);
      return a.replace(/\s+/g, " ").replace(/^\s+/, "").replace(/\s+$/, "");
    }
  }), t16.addFormulaFunction({
    name: "upper",
    category: r12,
    description: "Converts all lowercase letters in a text expression to uppercase.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The text to convert to uppercase.",
        dataType: "character"
      }
    },
    call: function(n12) {
      var a = e.textParse(n12);
      return a.toUpperCase();
    }
  }), t16.addFormulaFunction({
    name: "value",
    category: r12,
    description: "Converts a text expression that represents a number to a number.",
    parameters: ["value"],
    parameterDefinitions: {
      value: {
        description: "The text expression to convert.",
        dataType: "character"
      }
    },
    call: function(n12) {
      return e.numbersParse(n12, false, n12);
    }
  }), uf;
}
var sf = {}, hne;
function mu0() {
  if (hne)
    return sf;
  hne = 1, Object.defineProperty(sf, "__esModule", { value: true });
  var t16 = iXe(), e = Cr(), r12 = A1(), n12 = "General", a = "Expression";
  return t16.Formula.TOKEN_SPLITTERS[a] = [
    ["var", /(\[[^\]]+\])/],
    ["func", /([a-z][a-z\d]+\s*\()/i],
    ["text", /('[^']*')/],
    ["text", /("[^"]*")/],
    ["boolean", /(and|or|not|true|false)/i],
    ["append", /(&)/],
    ["comparison", /(=|>=|<=|<|>|<>|×|÷)/]
  ], t16.Formula.OPERATORS[a] = [
    { value: "+", label: "+", description: "Add two numbers together or concatenate two strings" },
    { value: "-", label: "-", description: "Subtract a number from another" },
    { value: "/", label: "÷", description: "Divide a number from another (use /)" },
    { value: "*", label: "×", description: "Multiply a number by another (use *)" },
    { value: "%", label: "%", description: "Compute the remainder between the division of two numbers" },
    { value: "=", label: "=", description: "Compare two values for equality. If they are equal the result is true, otherwise false." },
    { value: ">", label: ">", description: "The greater than comparison. If the value on the left is after the value on the right the result is true, otherwise false." },
    { value: ">=", label: "≥", description: "The greater than or equal to comparison. If the value on the left is after or equal to the value on the right the result is true, otherwise false." },
    { value: "<", label: "<", description: "The less than comparison. If the value on the left is before the value on the right the result is true, otherwise false." },
    { value: "<=", label: "≤", description: "The less than or equal to comparison. If the value on the left is before or equal to the value on the right the result is true, otherwise false." },
    { value: "<>", label: "<>", description: "Compare two values for inequality. If the are NOT equal the result is true, otherwise false." },
    { value: "(", label: "(", description: "A left parenthesis to control the order of operations. Every left parenthesis needs a right one." },
    { value: ")", label: ")", description: "A right parenthesis to control the order of operations. Every right parenthesis needs a left one." },
    { value: " AND ", label: "AND", description: "A boolean operator that returns true if `x AND y` are both true." },
    { value: " OR ", label: "OR", description: "A boolean operator that returns true if `x or y` are true." },
    { value: " NOT ", label: "NOT", description: "A boolean operator that returns true if `NOT x` is true." },
    { value: "TRUE", label: "TRUE", description: "A true boolean value." },
    { value: "FALSE", label: "FALSE", description: "A false boolean value." }
  ], t16.Formula.TOKEN_TRANSLATION.AND = "&&", t16.Formula.TOKEN_TRANSLATION.OR = "||", t16.Formula.TOKEN_TRANSLATION.NOT = "!", t16.Formula.TOKEN_TRANSLATION.TRUE = "true", t16.Formula.TOKEN_TRANSLATION.FALSE = "false", e.addFormulaFunction({
    name: "convert",
    suite: a,
    category: n12,
    description: "Converts particular expression to a specified .NET Framework Type.",
    parameters: ["expression", "type"],
    parameterDefinitions: {
      expression: {
        description: "The expression to convert."
      },
      type: {
        description: `.NET type to which the value will be converted. One of:
- 'System.Boolean'
- 'System.Byte'
- 'System.SByte'
- 'System.Int16'
- 'System.Int32'
- 'System.Int64'
- 'System.UInt16'
- 'System.UInt32'
- 'System.UInt64'
- 'System.String'
- 'System.Char'
- 'System.DateTime'
- 'System.TimeSpan'`,
        dataType: "character"
      }
    },
    call: function(o, i) {
      switch (i.toLowerCase()) {
        case "system.boolean":
          return !!/^(1|true|yes)$/.exec(o);
        case "system.byte":
          return Math.max(0, Math.min(255, r12.integersParse(o)));
        case "system.sbyte":
          return Math.max(-128, Math.min(127, r12.integersParse(o)));
        case "system.int16":
          return Math.max(-32768, Math.min(32767, r12.integersParse(o)));
        case "system.int32":
          return Math.max(-2147483648, Math.min(2147483647, r12.integersParse(o)));
        case "system.int64":
          return Math.max(-9223372036854776e3, Math.min(9223372036854776e3, r12.integersParse(o)));
        case "system.uint16":
          return Math.max(0, Math.min(65535, r12.integersParse(o)));
        case "system.uint32":
          return Math.max(0, Math.min(4294967295, r12.integersParse(o)));
        case "system.string":
          return String(o);
        case "system.char":
          return String(o).charAt(0);
        case "system.datetime":
        case "system.timespan":
          return r12.dateParse(o);
        default:
          return o;
      }
    }
  }), e.addFormulaFunction({
    name: "len",
    suite: a,
    category: n12,
    description: "Gets the length of a string",
    parameters: ["expression"],
    parameterDefinitions: {
      expression: {
        description: "The string to be evaluated.",
        dataType: "character"
      }
    },
    call: function(o) {
      return String(o).length;
    }
  }), e.addFormulaFunction({
    name: "isnull",
    suite: a,
    category: n12,
    description: "Checks an expression and either returns the checked expression or a replacement value.",
    parameters: ["expression", "replacementValue"],
    parameterDefinitions: {
      expression: {
        description: "The expression to check."
      },
      replacementValue: {
        description: "If expression is null, replacementvalue is returned."
      }
    },
    call: function(o, i) {
      return o ?? i;
    }
  }), e.addFormulaFunction({
    name: "iif",
    suite: a,
    category: n12,
    description: "Gets one of two values depending on the result of a logical expression.",
    parameters: ["expr", "truePart", "falsePart"],
    parameterDefinitions: {
      expr: {
        description: "The expression to evaluate.",
        dataType: "boolean"
      },
      truePart: {
        description: "The value to return if the expression is true."
      },
      falsePart: {
        description: "The value to return if the expression is false."
      }
    },
    call: function(o, i, u) {
      return o ? i : u;
    }
  }), e.addFormulaFunction({
    name: "trim",
    suite: a,
    category: n12,
    description: "Removes all leading and trailing blank characters like newline, tab, and space.",
    parameters: ["expression"],
    parameterDefinitions: {
      expression: {
        description: "The expression to evaluate.",
        dataType: "boolean"
      }
    },
    call: function(o) {
      return String(o).trim();
    }
  }), e.addFormulaFunction({
    name: "substring",
    suite: a,
    category: n12,
    description: "Gets a sub-string of a specified length, starting at a specified point in the string.",
    parameters: ["expression", "start", "length"],
    parameterDefinitions: {
      expression: {
        description: "The source string for the substring.",
        dataType: "boolean"
      },
      start: {
        description: " Integer that specifies where the substring starts.",
        dataType: "integer"
      },
      length: {
        description: "Integer that specifies the length of the substring.",
        dataType: "integer"
      }
    },
    call: function(o, i, u) {
      var s12 = String(o), c = r12.integersParse(i) - 1, l2 = r12.integersParse(u);
      return s12.substring(c, c + l2);
    }
  }), sf;
}
var vne;
function Ru0() {
  return vne || (vne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true });
    var e = Z0;
    e.__exportStar(iXe(), t16), e.__exportStar(Cr(), t16), fu0(), bu0(), Mu0(), Ou0(), zu0(), Au0(), _u0(), hu0(), vu0(), mu0();
  })(Jd)), Jd;
}
var cf = {}, mne;
function qu0() {
  return mne || (mne = 1, Object.defineProperty(cf, "__esModule", { value: true })), cf;
}
var lf = {}, Rne;
function uXe() {
  return Rne || (Rne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.Status = void 0, (function(e) {
      e[e.UNKNOWN = -1] = "UNKNOWN", e[e.OK = 200] = "OK", e[e.CREATED = 201] = "CREATED", e[e.ACCEPTED = 202] = "ACCEPTED", e[e.BAD = 400] = "BAD", e[e.UNAUTHORIZED = 401] = "UNAUTHORIZED", e[e.PAYMENT = 402] = "PAYMENT", e[e.FORBIDDEN = 403] = "FORBIDDEN", e[e.NOT_FOUND = 404] = "NOT_FOUND", e[e.NOT_ALLOWED = 405] = "NOT_ALLOWED", e[e.CONFLICT = 409] = "CONFLICT", e[e.TEAPOT = 418] = "TEAPOT", e[e.UPGRADE = 426] = "UPGRADE", e[e.TOO_MANY_REQUESTS = 429] = "TOO_MANY_REQUESTS", e[e.ERROR = 500] = "ERROR", e[e.NOT_IMPLEMENTED = 501] = "NOT_IMPLEMENTED", e[e.UNAVAILABLE = 503] = "UNAVAILABLE";
    })(t16.Status || (t16.Status = {}));
  })(lf)), lf;
}
var Du = {}, qne;
function Tu0() {
  if (qne)
    return Du;
  qne = 1, Object.defineProperty(Du, "__esModule", { value: true }), Du.Exception = void 0;
  var t16 = Z0, e = uXe(), r12 = (
    /** @class */
    (function(n12) {
      t16.__extends(a, n12);
      function a(o, i) {
        i === void 0 && (i = e.Status.UNKNOWN);
        var u = n12.call(this, o) || this;
        return u.status = i, u;
      }
      return a;
    })(Error)
  );
  return Du.Exception = r12, Du;
}
var pf = {}, Tne;
function yu0() {
  return Tne || (Tne = 1, Object.defineProperty(pf, "__esModule", { value: true })), pf;
}
var df = {}, yne;
function Su0() {
  return yne || (yne = 1, Object.defineProperty(df, "__esModule", { value: true })), df;
}
var Wu = {}, Sne;
function Cu0() {
  if (Sne)
    return Wu;
  Sne = 1, Object.defineProperty(Wu, "__esModule", { value: true }), Wu.Locale = void 0;
  var t16 = Ac(), e = (
    /** @class */
    (function() {
      function r12(n12, a, o) {
        o === void 0 && (o = /* @__PURE__ */ Object.create(null)), this.options = n12, this.current = a, this.locales = o;
      }
      return r12.prototype.get = function(n12, a) {
        if (!this.current || !a)
          return { key: n12, params: a };
        var o = this.locales[this.current][n12];
        return t16.isFunction(o) ? o(this.options, a) : o;
      }, r12.prototype.resolve = function(n12) {
        if (t16.isEntryResultObject(n12) && this.current) {
          var a = n12.key, o = n12.params, i = this.locales[this.current][a];
          return t16.isFunction(i) ? i(this.options, o) : i;
        } else
          return n12;
      }, r12;
    })()
  );
  return Wu.Locale = e, Wu;
}
var Nu = {}, Cne;
function gu0() {
  if (Cne)
    return Nu;
  Cne = 1, Object.defineProperty(Nu, "__esModule", { value: true }), Nu.LocaleException = void 0;
  var t16 = Z0, e = Ac(), r12 = (
    /** @class */
    (function(n12) {
      t16.__extends(a, n12);
      function a(o, i, u) {
        var s12 = n12.call(this, String(i), o) || this;
        return s12.key = i, s12.params = u, s12;
      }
      return a.create = function(o, i, u) {
        return new a(o, i, u);
      }, a;
    })(e.Exception)
  );
  return Nu.LocaleException = r12, Nu;
}
var ff = {}, gne;
function Iu0() {
  return gne || (gne = 1, Object.defineProperty(ff, "__esModule", { value: true })), ff;
}
var bf = {}, Ine;
function Eu0() {
  return Ine || (Ine = 1, Object.defineProperty(bf, "__esModule", { value: true })), bf;
}
var wu = {}, Ene;
function Lu0() {
  if (Ene)
    return wu;
  Ene = 1, Object.defineProperty(wu, "__esModule", { value: true }), wu.AppException = void 0;
  var t16 = Z0, e = Ac(), r12 = (
    /** @class */
    (function(n12) {
      t16.__extends(a, n12);
      function a() {
        return n12 !== null && n12.apply(this, arguments) || this;
      }
      return a.create = function(o, i, u) {
        return new a(o, i, u);
      }, a;
    })(e.LocaleException)
  );
  return wu.AppException = r12, wu;
}
var Mf = {}, Of = {}, Lne;
function Pu0() {
  return Lne || (Lne = 1, Object.defineProperty(Of, "__esModule", { value: true })), Of;
}
var zf = {}, Pne;
function Du0() {
  return Pne || (Pne = 1, Object.defineProperty(zf, "__esModule", { value: true })), zf;
}
var Af = {}, Dne;
function Wu0() {
  return Dne || (Dne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.BillReviewView = void 0, (function(e) {
      e.DEFAULT = "default", e.ALL = "all";
    })(t16.BillReviewView || (t16.BillReviewView = {}));
  })(Af)), Af;
}
var _f = {}, Wne;
function Nu0() {
  return Wne || (Wne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.BillReviewItemView = t16.BillReviewItemRelations = void 0, (function(e) {
      e.BILL_REVIEW_ITEM = "billReviewItem", e.DISBURSEMENT_LINE = "disbursementLine", e.EMPLOYEE_REIMBURSABLE_LINE = "employeeReimbursableLine", e.PURCHASE_LINE = "purchaseLine", e.TIME_LINE = "timeLine", e.TRANSACTION = "transaction";
    })(t16.BillReviewItemRelations || (t16.BillReviewItemRelations = {})), (function(e) {
      e.DEFAULT = "default", e.RELATED = "related", e.TRANSACTION = "transaction";
    })(t16.BillReviewItemView || (t16.BillReviewItemView = {}));
  })(_f)), _f;
}
var hf = {}, Nne;
function wu0() {
  return Nne || (Nne = 1, Object.defineProperty(hf, "__esModule", { value: true })), hf;
}
var vf = {}, wne;
function Bu0() {
  return wne || (wne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.GeneralLedgerPeriodView = void 0, (function(e) {
      e.DEFAULT = "default", e.ALL = "all";
    })(t16.GeneralLedgerPeriodView || (t16.GeneralLedgerPeriodView = {}));
  })(vf)), vf;
}
var mf = {}, Bne;
function xu0() {
  return Bne || (Bne = 1, Object.defineProperty(mf, "__esModule", { value: true })), mf;
}
var Rf = {}, xne;
function Uu0() {
  return xne || (xne = 1, Object.defineProperty(Rf, "__esModule", { value: true })), Rf;
}
var qf = {}, Une;
function ku0() {
  return Une || (Une = 1, Object.defineProperty(qf, "__esModule", { value: true })), qf;
}
var Tf = {}, kne;
function ju0() {
  return kne || (kne = 1, Object.defineProperty(Tf, "__esModule", { value: true })), Tf;
}
var yf = {}, jne;
function Fu0() {
  return jne || (jne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectFactView = void 0, (function(e) {
      e.DEFAULT = "default", e.MODIFIED = "modify";
    })(t16.ProjectFactView || (t16.ProjectFactView = {}));
  })(yf)), yf;
}
var Sf = {}, Fne;
function Vu0() {
  return Fne || (Fne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectLabelView = void 0, (function(e) {
      e.DEFAULT = "default", e.ALL = "all";
    })(t16.ProjectLabelView || (t16.ProjectLabelView = {}));
  })(Sf)), Sf;
}
var Cf = {}, Vne;
function Hu0() {
  return Vne || (Vne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectView = t16.ProjectResultRelations = void 0, (function(e) {
      e.PROJECT = "project", e.BILL_TERM = "billTerm", e.BILL_REVIEW = "currentBillReview", e.BILL_RATE = "billRate", e.FACT = "fact", e.CHARGE_TYPE = "chargeType", e.FIRM = "firm", e.INVOICE_CURRENCY = "invoiceCurrency", e.PROJECT_CURRENCY = "projectCurrency", e.CONTRACT_TYPE = "contractType", e.REPORT_TYPE = "reportType", e.ORGANIZATION = "organization", e.PROJECT_ACCOUNTANT_EMPLOYEE = "projectAccountantEmployee", e.PRINCIPAL_IN_CHARGE_EMPLOYEE = "principalInChargeEmployee", e.PROJECT_MANAGE_EMPLOYEE = "projectManageEmployee", e.MAIN_SYSTEM_INVOICE_DESIGN = "mainSystemInvoiceDesign", e.MAIN_CUSTOM_INVOICE_DESIGN = "mainCustomInvoiceDesign", e.METRICS = "metrics", e.CONTRACT = "contract", e.FIXED = "fixed", e.PLANNING = "planning";
    })(t16.ProjectResultRelations || (t16.ProjectResultRelations = {})), (function(e) {
      e.DEFAULT = "default", e.OPTION = "option", e.OPTION_BILL_REVIEW = "option-bill-review", e.MODIFIED = "modify", e.BUDGET = "budget", e.CHARGES = "charges", e.FIXED_FEE = "fixed", e.METRICS = "metrics", e.CONTRACT = "contract", e.GANTT = "gantt", e.PLANNING = "planning";
    })(t16.ProjectView || (t16.ProjectView = {}));
  })(Cf)), Cf;
}
var gf = {}, Hne;
function Xu0() {
  return Hne || (Hne = 1, Object.defineProperty(gf, "__esModule", { value: true })), gf;
}
var If = {}, Xne;
function $u0() {
  return Xne || (Xne = 1, Object.defineProperty(If, "__esModule", { value: true })), If;
}
var $ne;
function Gu0() {
  return $ne || ($ne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true });
    var e = Z0;
    e.__exportStar(Pu0(), t16), e.__exportStar(Du0(), t16), e.__exportStar(Wu0(), t16), e.__exportStar(Nu0(), t16), e.__exportStar(wu0(), t16), e.__exportStar(Bu0(), t16), e.__exportStar(xu0(), t16), e.__exportStar(Uu0(), t16), e.__exportStar(ku0(), t16), e.__exportStar(ju0(), t16), e.__exportStar(Fu0(), t16), e.__exportStar(Vu0(), t16), e.__exportStar(Hu0(), t16), e.__exportStar(Xu0(), t16), e.__exportStar($u0(), t16);
  })(Mf)), Mf;
}
var Gne;
function Ac() {
  return Gne || (Gne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true });
    var e = Z0;
    e.__exportStar(A1(), t16), e.__exportStar(Yi0(), t16), e.__exportStar(Ki0(), t16), e.__exportStar(du0(), t16), e.__exportStar(Ru0(), t16), e.__exportStar(qu0(), t16), e.__exportStar(uXe(), t16), e.__exportStar(Tu0(), t16), e.__exportStar(yu0(), t16), e.__exportStar(Su0(), t16), e.__exportStar(Cu0(), t16), e.__exportStar(gu0(), t16), e.__exportStar(Iu0(), t16), e.__exportStar(Eu0(), t16), e.__exportStar(Lu0(), t16), e.__exportStar(Gu0(), t16);
  })(Ud)), Ud;
}
var Ef = {}, Lf = {}, Yne;
function Yu0() {
  return Yne || (Yne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.AccessControlTypeEnum = void 0, (function(e) {
      e[e.USER = 1] = "USER", e[e.GROUP = 2] = "GROUP", e[e.ACTIVE_DIRECTORY_GROUP = 3] = "ACTIVE_DIRECTORY_GROUP";
    })(t16.AccessControlTypeEnum || (t16.AccessControlTypeEnum = {}));
  })(Lf)), Lf;
}
var Pf = {}, Jne;
function Ju0() {
  return Jne || (Jne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ActionAppletTypeEnum = void 0, (function(e) {
      e[e.TOOLBAR = 3] = "TOOLBAR", e[e.ON_CREATE = 4] = "ON_CREATE", e[e.ON_SAVE = 2] = "ON_SAVE", e[e.ON_DELETE = 1] = "ON_DELETE", e[e.ON_LOAD = 5] = "ON_LOAD", e[e.ON_DEACTIVATE = 6] = "ON_DEACTIVATE", e[e.ON_SUBMIT = 8] = "ON_SUBMIT", e[e.ON_REJECT = 7] = "ON_REJECT", e[e.ON_APPROVE = 9] = "ON_APPROVE";
    })(t16.ActionAppletTypeEnum || (t16.ActionAppletTypeEnum = {}));
  })(Pf)), Pf;
}
var Df = {}, Kne;
function Ku0() {
  return Kne || (Kne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ActivityTypeEnum = void 0, (function(e) {
      e[e.PHONE_CALL = 1] = "PHONE_CALL", e[e.MEETING = 2] = "MEETING", e[e.EMAIL = 3] = "EMAIL", e[e.APPOINTMENT = 4] = "APPOINTMENT", e[e.LUNCH = 5] = "LUNCH", e[e.DINNER = 6] = "DINNER";
    })(t16.ActivityTypeEnum || (t16.ActivityTypeEnum = {}));
  })(Df)), Df;
}
var Wf = {}, Qne;
function Qu0() {
  return Qne || (Qne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.AddressCategoryEnum = void 0, (function(e) {
      e[e.COMPANY_OFFICES = 1] = "COMPANY_OFFICES", e[e.EMPLOYEE = 2] = "EMPLOYEE", e[e.CLIENT = 3] = "CLIENT", e[e.FIRM = 4] = "FIRM", e[e.PROJECT = 5] = "PROJECT", e[e.PROJECT_CONTACT = 6] = "PROJECT_CONTACT", e[e.CONTACT = 7] = "CONTACT", e[e.SPECIFIC = 8] = "SPECIFIC";
    })(t16.AddressCategoryEnum || (t16.AddressCategoryEnum = {}));
  })(Wf)), Wf;
}
var Nf = {}, Zne;
function Zu0() {
  return Zne || (Zne = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.AROverpayAgeMethodEnum = void 0, (function(e) {
      e[e.KEEP_IN_CURRENT = 1] = "KEEP_IN_CURRENT", e[e.LAST_CHECK_DATE = 2] = "LAST_CHECK_DATE", e[e.INVOICE_DATE = 3] = "INVOICE_DATE";
    })(t16.AROverpayAgeMethodEnum || (t16.AROverpayAgeMethodEnum = {}));
  })(Nf)), Nf;
}
var wf = {}, eae;
function es0() {
  return eae || (eae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.AutoCodeTypeEnum = void 0, (function(e) {
      e[e.EMPLOYEE = 1] = "EMPLOYEE", e[e.FIRM = 2] = "FIRM", e[e.OPPORTUNITY = 3] = "OPPORTUNITY", e[e.PROJECT = 4] = "PROJECT", e[e.PURCHASE_ORDER = 5] = "PURCHASE_ORDER";
    })(t16.AutoCodeTypeEnum || (t16.AutoCodeTypeEnum = {}));
  })(wf)), wf;
}
var Bf = {}, tae;
function ts0() {
  return tae || (tae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.BillingGroupEnum = void 0, (function(e) {
      e[e._1ST_WEEK = 1] = "_1ST_WEEK", e[e._2ND_WEEK = 2] = "_2ND_WEEK", e[e._3RD_WEEK = 3] = "_3RD_WEEK", e[e._4TH_WEEK = 4] = "_4TH_WEEK";
    })(t16.BillingGroupEnum || (t16.BillingGroupEnum = {}));
  })(Bf)), Bf;
}
var xf = {}, rae;
function rs0() {
  return rae || (rae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.BillingTermEnum = void 0, (function(e) {
      e[e.REG = 1] = "REG", e[e.COD = 2] = "COD", e[e.NHA = 3] = "NHA";
    })(t16.BillingTermEnum || (t16.BillingTermEnum = {}));
  })(xf)), xf;
}
var Uf = {}, nae;
function ns0() {
  return nae || (nae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.BillStatusEnum = void 0, (function(e) {
      e[e.NEVER_BILL = 2] = "NEVER_BILL", e[e.READY_TO_BILL = 1] = "READY_TO_BILL", e[e.BILLED = 3] = "BILLED", e[e.WRITE_OFF = 4] = "WRITE_OFF", e[e.HOLD = 5] = "HOLD";
    })(t16.BillStatusEnum || (t16.BillStatusEnum = {}));
  })(Uf)), Uf;
}
var kf = {}, aae;
function as0() {
  return aae || (aae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.BorderTypeEnum = void 0, (function(e) {
      e[e.NONE = 1] = "NONE", e[e.SOLID = 2] = "SOLID", e[e.DOTTED = 3] = "DOTTED", e[e.DASHED = 4] = "DASHED", e[e.DOUBLE = 5] = "DOUBLE", e[e.GROOVE = 6] = "GROOVE", e[e.RIDGE = 7] = "RIDGE", e[e.INSET = 8] = "INSET", e[e.WINDOW_INSET = 9] = "WINDOW_INSET", e[e.OUTSET = 10] = "OUTSET";
    })(t16.BorderTypeEnum || (t16.BorderTypeEnum = {}));
  })(kf)), kf;
}
var jf = {}, oae;
function os0() {
  return oae || (oae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.BuilderDataSetTypeEnum = void 0, (function(e) {
      e[e.EMPLOYEES = 1] = "EMPLOYEES", e[e.TIME_SHEETS = 2] = "TIME_SHEETS", e[e.PROJECTS = 3] = "PROJECTS", e[e.CLIENTS = 4] = "CLIENTS", e[e.VENDORS = 5] = "VENDORS", e[e.PURCHASE_JOURNAL = 6] = "PURCHASE_JOURNAL", e[e.SALES_JOURNAL = 7] = "SALES_JOURNAL", e[e.RECEIPT_JOURNAL = 8] = "RECEIPT_JOURNAL", e[e.DISBURSEMENT_JOURNAL = 9] = "DISBURSEMENT_JOURNAL", e[e.GENERAL_JOURNAL = 10] = "GENERAL_JOURNAL", e[e.EMPLOYEE_REIMBURSABLE_JOURNAL = 11] = "EMPLOYEE_REIMBURSABLE_JOURNAL", e[e.GENERAL_LEDGER = 12] = "GENERAL_LEDGER", e[e.EXPENSE_SHEETS = 13] = "EXPENSE_SHEETS", e[e.CONTACTS = 14] = "CONTACTS";
    })(t16.BuilderDataSetTypeEnum || (t16.BuilderDataSetTypeEnum = {}));
  })(jf)), jf;
}
var Ff = {}, iae;
function is0() {
  return iae || (iae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.CashAccrualTypeEnum = void 0, (function(e) {
      e[e.CASH = 1] = "CASH", e[e.ACCRUAL = 2] = "ACCRUAL", e[e.BOTH = 3] = "BOTH";
    })(t16.CashAccrualTypeEnum || (t16.CashAccrualTypeEnum = {}));
  })(Ff)), Ff;
}
var Vf = {}, uae;
function us0() {
  return uae || (uae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ChargeLevelEnum = void 0, (function(e) {
      e[e.THIS_NODE = 1] = "THIS_NODE", e[e.BOTTOM_NODES = 3] = "BOTTOM_NODES", e[e.ONE_LEVEL_DOWN = 2] = "ONE_LEVEL_DOWN";
    })(t16.ChargeLevelEnum || (t16.ChargeLevelEnum = {}));
  })(Vf)), Vf;
}
var Hf = {}, sae;
function ss0() {
  return sae || (sae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ClientQueryTypeEnum = void 0, (function(e) {
      e[e.PRIVATE = 2] = "PRIVATE", e[e.PERSONAL = 3] = "PERSONAL", e[e.PUBLIC = 4] = "PUBLIC";
    })(t16.ClientQueryTypeEnum || (t16.ClientQueryTypeEnum = {}));
  })(Hf)), Hf;
}
var Xf = {}, cae;
function cs0() {
  return cae || (cae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ClientSpecialtyEnum = void 0, (function(e) {
      e[e.TRANSPORTATION = 1] = "TRANSPORTATION", e[e.ROADS_AND_BRIDGES = 2] = "ROADS_AND_BRIDGES", e[e.GRAPHIC_DESIGN = 3] = "GRAPHIC_DESIGN", e[e.ARCHITECTURE = 4] = "ARCHITECTURE", e[e.ENGINEERING = 5] = "ENGINEERING", e[e.GEOTECHNICAL_ENGINEERS = 6] = "GEOTECHNICAL_ENGINEERS", e[e.ENVIRONMENTAL_ENGINEERS = 7] = "ENVIRONMENTAL_ENGINEERS", e[e.ELECTRICAL_ENGINEERS = 8] = "ELECTRICAL_ENGINEERS";
    })(t16.ClientSpecialtyEnum || (t16.ClientSpecialtyEnum = {}));
  })(Xf)), Xf;
}
var $f = {}, lae;
function ls0() {
  return lae || (lae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ClientTypeEnum = void 0, (function(e) {
      e[e.FEDERAL_GOVERNMENT = 1] = "FEDERAL_GOVERNMENT", e[e.STATE_GOVERNMENT = 2] = "STATE_GOVERNMENT", e[e.LOCAL_GOVERNMENT = 3] = "LOCAL_GOVERNMENT", e[e.NON_PROFIT = 4] = "NON_PROFIT", e[e.HEALTH_CARE = 5] = "HEALTH_CARE", e[e.EDUCATION = 6] = "EDUCATION", e[e.COMMERCIAL = 7] = "COMMERCIAL", e[e.RESIDENTIAL = 8] = "RESIDENTIAL";
    })(t16.ClientTypeEnum || (t16.ClientTypeEnum = {}));
  })($f)), $f;
}
var Gf = {}, pae;
function ps0() {
  return pae || (pae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.COACostTypeEnum = void 0, (function(e) {
      e[e.DIRECT = 1] = "DIRECT", e[e.INDIRECT = 2] = "INDIRECT";
    })(t16.COACostTypeEnum || (t16.COACostTypeEnum = {}));
  })(Gf)), Gf;
}
var Yf = {}, dae;
function ds0() {
  return dae || (dae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.COAFinancialTypeEnum = void 0, (function(e) {
      e[e.ASSET = 1] = "ASSET", e[e.LIABILITY = 2] = "LIABILITY", e[e.CAPITAL = 3] = "CAPITAL", e[e.INCOME = 4] = "INCOME", e[e.EXPENSE = 5] = "EXPENSE";
    })(t16.COAFinancialTypeEnum || (t16.COAFinancialTypeEnum = {}));
  })(Yf)), Yf;
}
var Jf = {}, fae;
function fs0() {
  return fae || (fae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.COAMetricTypeEnum = void 0, (function(e) {
      e[e.COST = 1] = "COST", e[e.BILLED_REVENUE = 2] = "BILLED_REVENUE", e[e.WORK_IN_PROGRESS = 3] = "WORK_IN_PROGRESS", e[e.BAD_DEBT = 4] = "BAD_DEBT", e[e.LATE_FEE = 5] = "LATE_FEE", e[e.RETAINER = 6] = "RETAINER", e[e.RETAINAGE = 7] = "RETAINAGE", e[e.UNBILLED_REVENUE = 8] = "UNBILLED_REVENUE", e[e.OTHER_REVENUE = 9] = "OTHER_REVENUE", e[e.INTERCOMPANY_REVENUE = 10] = "INTERCOMPANY_REVENUE", e[e.INTERCOMPANY_EXPENSE = 11] = "INTERCOMPANY_EXPENSE";
    })(t16.COAMetricTypeEnum || (t16.COAMetricTypeEnum = {}));
  })(Jf)), Jf;
}
var Kf = {}, bae;
function bs0() {
  return bae || (bae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.COAPMTypeEnum = void 0, (function(e) {
      e[e.LABOR = 1] = "LABOR", e[e.OTHER_DIRECT_CHARGES = 2] = "OTHER_DIRECT_CHARGES", e[e.IN_CONTRACT_CONSULTANTS = 3] = "IN_CONTRACT_CONSULTANTS", e[e.OUT_OF_CONTRACT_CONSULTANTS = 4] = "OUT_OF_CONTRACT_CONSULTANTS";
    })(t16.COAPMTypeEnum || (t16.COAPMTypeEnum = {}));
  })(Kf)), Kf;
}
var Qf = {}, Mae;
function Ms0() {
  return Mae || (Mae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.CombinedCapEnum = void 0, (function(e) {
      e[e.LABOR_ODC_OCC = 1] = "LABOR_ODC_OCC", e[e.LABOR_ODC = 2] = "LABOR_ODC", e[e.LABOR_OCC = 3] = "LABOR_OCC", e[e.ODC_OCC = 4] = "ODC_OCC";
    })(t16.CombinedCapEnum || (t16.CombinedCapEnum = {}));
  })(Qf)), Qf;
}
var Zf = {}, Oae;
function Os0() {
  return Oae || (Oae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ContactEmployeeTypeEnum = void 0, (function(e) {
      e[e.CONTACT_EMP_TYPE = 3] = "CONTACT_EMP_TYPE";
    })(t16.ContactEmployeeTypeEnum || (t16.ContactEmployeeTypeEnum = {}));
  })(Zf)), Zf;
}
var eb = {}, zae;
function zs0() {
  return zae || (zae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ContactQueryTypeEnum = void 0, (function(e) {
      e[e.PRIVATE = 3] = "PRIVATE", e[e.PERSONAL = 4] = "PERSONAL", e[e.PUBLIC = 5] = "PUBLIC";
    })(t16.ContactQueryTypeEnum || (t16.ContactQueryTypeEnum = {}));
  })(eb)), eb;
}
var tb = {}, Aae;
function As0() {
  return Aae || (Aae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ContactTypeEnum = void 0, (function(e) {
      e[e.FIRM = 1] = "FIRM", e[e.PROJECT = 2] = "PROJECT", e[e.EMPLOYEE = 3] = "EMPLOYEE";
    })(t16.ContactTypeEnum || (t16.ContactTypeEnum = {}));
  })(tb)), tb;
}
var rb = {}, _ae;
function _s0() {
  return _ae || (_ae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ContractTypeEnum = void 0, (function(e) {
      e[e.TIME_AND_MATERIALS = 1] = "TIME_AND_MATERIALS", e[e.TIME_AND_MATERIALS_TO_MAX = 2] = "TIME_AND_MATERIALS_TO_MAX", e[e.COST_PLUS = 3] = "COST_PLUS", e[e.COST_PLUS_TO_MAX = 4] = "COST_PLUS_TO_MAX", e[e.FIXED_FEE = 5] = "FIXED_FEE", e[e.PHASED_FIXED_FEE = 6] = "PHASED_FIXED_FEE", e[e.PERCENT_OF_CONSTRUCTION = 7] = "PERCENT_OF_CONSTRUCTION";
    })(t16.ContractTypeEnum || (t16.ContractTypeEnum = {}));
  })(rb)), rb;
}
var nb = {}, hae;
function hs0() {
  return hae || (hae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.CurrencyMethodEnum = void 0, (function(e) {
      e[e.TRANSACTION_DATE = 1] = "TRANSACTION_DATE", e[e.PERIOD_END_DATE = 2] = "PERIOD_END_DATE", e[e.PERIOD_START_DATE = 3] = "PERIOD_START_DATE", e[e.TODAY = 4] = "TODAY";
    })(t16.CurrencyMethodEnum || (t16.CurrencyMethodEnum = {}));
  })(nb)), nb;
}
var ab = {}, vae;
function vs0() {
  return vae || (vae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.DashboardTypeEnum = void 0, (function(e) {
      e[e.CLASSIC_DASHBOARD = 1] = "CLASSIC_DASHBOARD", e[e.ANALYTIC_DASHBOARD = 2] = "ANALYTIC_DASHBOARD";
    })(t16.DashboardTypeEnum || (t16.DashboardTypeEnum = {}));
  })(ab)), ab;
}
var ob = {}, mae;
function ms0() {
  return mae || (mae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.DocumentAppletTypeEnum = void 0, (function(e) {
      e[e.FIRMS = 3] = "FIRMS", e[e.CLIENTS = 1] = "CLIENTS", e[e.VENDORS = 2] = "VENDORS", e[e.EMPLOYEES = 4] = "EMPLOYEES", e[e.PROJECTS = 5] = "PROJECTS", e[e.TIMESHEETS = 8] = "TIMESHEETS", e[e.EXPENSE_SHEET = 9] = "EXPENSE_SHEET", e[e.SALES_JOURNAL = 10] = "SALES_JOURNAL", e[e.PURCHASE_JOURNAL = 11] = "PURCHASE_JOURNAL", e[e.RECEIPT_JOURNAL = 12] = "RECEIPT_JOURNAL", e[e.DISBURSEMENT_JOURNAL = 13] = "DISBURSEMENT_JOURNAL", e[e.GENERAL_JOURNAL = 14] = "GENERAL_JOURNAL", e[e.EMPLOYEE_REIMBURSABLE_JOURNAL = 15] = "EMPLOYEE_REIMBURSABLE_JOURNAL", e[e.BANK_RECONCILIATION = 16] = "BANK_RECONCILIATION", e[e.PURCHASE_ORDERS = 17] = "PURCHASE_ORDERS", e[e.WORK_ORDERS = 18] = "WORK_ORDERS", e[e.ACTIVITIES = 19] = "ACTIVITIES";
    })(t16.DocumentAppletTypeEnum || (t16.DocumentAppletTypeEnum = {}));
  })(ob)), ob;
}
var ib = {}, Rae;
function Rs0() {
  return Rae || (Rae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.EFTEntryTypeEnum = void 0, (function(e) {
      e[e.PREARRANGED_PAYMENTS_AND_DISBURSEMENTS = 1] = "PREARRANGED_PAYMENTS_AND_DISBURSEMENTS", e[e.CASH_CONCENTRATION_AND_DISBURSEMENTS = 2] = "CASH_CONCENTRATION_AND_DISBURSEMENTS", e[e.CORPORATE_TRADE_EXCHANGE = 3] = "CORPORATE_TRADE_EXCHANGE";
    })(t16.EFTEntryTypeEnum || (t16.EFTEntryTypeEnum = {}));
  })(ib)), ib;
}
var ub = {}, qae;
function qs0() {
  return qae || (qae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.EFTFileItemTypeEnum = void 0, (function(e) {
      e[e.FIRM = 1] = "FIRM", e[e.EMPLOYEE = 2] = "EMPLOYEE";
    })(t16.EFTFileItemTypeEnum || (t16.EFTFileItemTypeEnum = {}));
  })(ub)), ub;
}
var sb = {}, Tae;
function Ts0() {
  return Tae || (Tae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.EmployeeContactTypeEnum = void 0, (function(e) {
      e[e.FRIEND = 1] = "FRIEND", e[e.ASSOCIATE = 2] = "ASSOCIATE", e[e.FORMER_CO_WORKER = 3] = "FORMER_CO_WORKER", e[e.RELATIVE = 4] = "RELATIVE", e[e.BUSINESS_ASSOCIATE = 5] = "BUSINESS_ASSOCIATE", e[e.FELLOW_BOARD_MEMBER = 6] = "FELLOW_BOARD_MEMBER";
    })(t16.EmployeeContactTypeEnum || (t16.EmployeeContactTypeEnum = {}));
  })(sb)), sb;
}
var cb = {}, yae;
function ys0() {
  return yae || (yae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.EmployeeJobTypeEnum = void 0, (function(e) {
      e[e.PRINCIPAL_IN_CHARGE = 1] = "PRINCIPAL_IN_CHARGE", e[e.PROJECT_MANAGER = 2] = "PROJECT_MANAGER", e[e.PROJECT_ACCOUNTANT = 3] = "PROJECT_ACCOUNTANT";
    })(t16.EmployeeJobTypeEnum || (t16.EmployeeJobTypeEnum = {}));
  })(cb)), cb;
}
var lb = {}, Sae;
function Ss0() {
  return Sae || (Sae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.EmployeeQueryTypeEnum = void 0, (function(e) {
      e[e.PRIVATE = 2] = "PRIVATE", e[e.PERSONAL = 3] = "PERSONAL", e[e.PUBLIC = 4] = "PUBLIC";
    })(t16.EmployeeQueryTypeEnum || (t16.EmployeeQueryTypeEnum = {}));
  })(lb)), lb;
}
var pb = {}, Cae;
function Cs0() {
  return Cae || (Cae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.EstimatedToCompensationMethodEnum = void 0, (function(e) {
      e[e.ESTIMATE_AMOUNT_LEFT = 1] = "ESTIMATE_AMOUNT_LEFT", e[e.PERCENT_COMPLETE = 2] = "PERCENT_COMPLETE";
    })(t16.EstimatedToCompensationMethodEnum || (t16.EstimatedToCompensationMethodEnum = {}));
  })(pb)), pb;
}
var db = {}, gae;
function gs0() {
  return gae || (gae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ExpenseCapTypeEnum = void 0, (function(e) {
      e[e.DIRECT_EXPENSE = 1] = "DIRECT_EXPENSE", e[e.MARKUP = 2] = "MARKUP";
    })(t16.ExpenseCapTypeEnum || (t16.ExpenseCapTypeEnum = {}));
  })(db)), db;
}
var fb = {}, Iae;
function Is0() {
  return Iae || (Iae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ExpenseCodeTypeEnum = void 0, (function(e) {
      e[e.OTHER_DIRECT_CHARGE = 1] = "OTHER_DIRECT_CHARGE", e[e.CONSULTANT = 2] = "CONSULTANT", e[e.IN_CONTRACT_CONSULTANT = 3] = "IN_CONTRACT_CONSULTANT", e[e.OUT_OF_CONTRACT_CONSULTANT = 4] = "OUT_OF_CONTRACT_CONSULTANT", e[e.ANY_TYPE = 5] = "ANY_TYPE";
    })(t16.ExpenseCodeTypeEnum || (t16.ExpenseCodeTypeEnum = {}));
  })(fb)), fb;
}
var bb = {}, Eae;
function Es0() {
  return Eae || (Eae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ExpenseMarkupTypeEnum = void 0, (function(e) {
      e[e.MARKUP = 1] = "MARKUP", e[e.FLAT_AMOUNT = 2] = "FLAT_AMOUNT", e[e.ADD_ON = 3] = "ADD_ON";
    })(t16.ExpenseMarkupTypeEnum || (t16.ExpenseMarkupTypeEnum = {}));
  })(bb)), bb;
}
var Mb = {}, Lae;
function Ls0() {
  return Lae || (Lae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ExpenseRevenueTypeEnum = void 0, (function(e) {
      e[e.DIRECT = 1] = "DIRECT", e[e.MARKUP = 2] = "MARKUP";
    })(t16.ExpenseRevenueTypeEnum || (t16.ExpenseRevenueTypeEnum = {}));
  })(Mb)), Mb;
}
var Ob = {}, Pae;
function Ps0() {
  return Pae || (Pae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.FirmContactTypeEnum = void 0, (function(e) {
      e[e.CONTACT = 3] = "CONTACT", e[e.MAIN = 4] = "MAIN", e[e.BILLING = 5] = "BILLING";
    })(t16.FirmContactTypeEnum || (t16.FirmContactTypeEnum = {}));
  })(Ob)), Ob;
}
var zb = {}, Dae;
function Ds0() {
  return Dae || (Dae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.FiscalYearTypeEnum = void 0, (function(e) {
      e[e.CALENDAR_12 = 1] = "CALENDAR_12", e[e.NON_CALENDAR_12 = 2] = "NON_CALENDAR_12", e[e._13_PERIODS = 3] = "_13_PERIODS", e[e._5_X_4_X_4 = 4] = "_5_X_4_X_4", e[e._4_X_5_X_4 = 5] = "_4_X_5_X_4", e[e._4_X_4_X_5 = 6] = "_4_X_4_X_5";
    })(t16.FiscalYearTypeEnum || (t16.FiscalYearTypeEnum = {}));
  })(zb)), zb;
}
var Ab = {}, Wae;
function Ws0() {
  return Wae || (Wae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.FOBTermEnum = void 0, (function(e) {
      e[e.DEMO_FOB = 1] = "DEMO_FOB";
    })(t16.FOBTermEnum || (t16.FOBTermEnum = {}));
  })(Ab)), Ab;
}
var _b = {}, Nae;
function Ns0() {
  return Nae || (Nae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.FinancialStatementColumnCalcTypeEnum = void 0, (function(e) {
      e[e.TRANSACTIONS = 1] = "TRANSACTIONS", e[e.BUDGETS = 2] = "BUDGETS", e[e.VARIANCE = 3] = "VARIANCE", e[e.PERCENT_VARIANCE = 4] = "PERCENT_VARIANCE", e[e.PERCENT_OF_BUDGET = 5] = "PERCENT_OF_BUDGET", e[e.INVERSE_VARIANCE = 6] = "INVERSE_VARIANCE", e[e.INVERSE_PERCENT_VARIANCE = 7] = "INVERSE_PERCENT_VARIANCE";
    })(t16.FinancialStatementColumnCalcTypeEnum || (t16.FinancialStatementColumnCalcTypeEnum = {}));
  })(_b)), _b;
}
var hb = {}, wae;
function ws0() {
  return wae || (wae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.FinancialStatementLineTypeEnum = void 0, (function(e) {
      e[e.ITEMIZE = 1] = "ITEMIZE", e[e.SUMMARIZE = 2] = "SUMMARIZE", e[e.TEXT = 3] = "TEXT", e[e.CONSOLIDATE = 4] = "CONSOLIDATE";
    })(t16.FinancialStatementLineTypeEnum || (t16.FinancialStatementLineTypeEnum = {}));
  })(hb)), hb;
}
var vb = {}, Bae;
function Bs0() {
  return Bae || (Bae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.FinancialStatementPeriodTypeEnum = void 0, (function(e) {
      e[e.CURRENT_PERIOD = 1] = "CURRENT_PERIOD", e[e.PRIOR_PERIOD = 2] = "PRIOR_PERIOD", e[e.CURRENT_FISCAL_YEAR_PERIOD_1 = 3] = "CURRENT_FISCAL_YEAR_PERIOD_1", e[e.CURRENT_FISCAL_YEAR_PERIOD_2 = 4] = "CURRENT_FISCAL_YEAR_PERIOD_2", e[e.CURRENT_FISCAL_YEAR_PERIOD_3 = 5] = "CURRENT_FISCAL_YEAR_PERIOD_3", e[e.CURRENT_FISCAL_YEAR_PERIOD_4 = 6] = "CURRENT_FISCAL_YEAR_PERIOD_4", e[e.CURRENT_FISCAL_YEAR_PERIOD_5 = 7] = "CURRENT_FISCAL_YEAR_PERIOD_5", e[e.CURRENT_FISCAL_YEAR_PERIOD_6 = 8] = "CURRENT_FISCAL_YEAR_PERIOD_6", e[e.CURRENT_FISCAL_YEAR_PERIOD_7 = 9] = "CURRENT_FISCAL_YEAR_PERIOD_7", e[e.CURRENT_FISCAL_YEAR_PERIOD_8 = 10] = "CURRENT_FISCAL_YEAR_PERIOD_8", e[e.CURRENT_FISCAL_YEAR_PERIOD_9 = 11] = "CURRENT_FISCAL_YEAR_PERIOD_9", e[e.CURRENT_FISCAL_YEAR_PERIOD_10 = 12] = "CURRENT_FISCAL_YEAR_PERIOD_10", e[e.CURRENT_FISCAL_YEAR_PERIOD_11 = 13] = "CURRENT_FISCAL_YEAR_PERIOD_11", e[e.CURRENT_FISCAL_YEAR_PERIOD_12 = 14] = "CURRENT_FISCAL_YEAR_PERIOD_12", e[e.CURRENT_FISCAL_YEAR_PERIOD_13 = 15] = "CURRENT_FISCAL_YEAR_PERIOD_13", e[e.PRIOR_FISCAL_YEAR = 16] = "PRIOR_FISCAL_YEAR", e[e.PRIOR_FISCAL_YEAR_CURRENT_PERIOD = 17] = "PRIOR_FISCAL_YEAR_CURRENT_PERIOD", e[e.PRIOR_FISCAL_YEAR_PRIOR_PERIOD = 18] = "PRIOR_FISCAL_YEAR_PRIOR_PERIOD", e[e.PRIOR_FISCAL_YEAR_PERIOD_1 = 19] = "PRIOR_FISCAL_YEAR_PERIOD_1", e[e.PRIOR_FISCAL_YEAR_PERIOD_2 = 20] = "PRIOR_FISCAL_YEAR_PERIOD_2", e[e.PRIOR_FISCAL_YEAR_PERIOD_3 = 21] = "PRIOR_FISCAL_YEAR_PERIOD_3", e[e.PRIOR_FISCAL_YEAR_PERIOD_4 = 22] = "PRIOR_FISCAL_YEAR_PERIOD_4", e[e.PRIOR_FISCAL_YEAR_PERIOD_5 = 23] = "PRIOR_FISCAL_YEAR_PERIOD_5", e[e.PRIOR_FISCAL_YEAR_PERIOD_6 = 24] = "PRIOR_FISCAL_YEAR_PERIOD_6", e[e.PRIOR_FISCAL_YEAR_PERIOD_7 = 25] = "PRIOR_FISCAL_YEAR_PERIOD_7", e[e.PRIOR_FISCAL_YEAR_PERIOD_8 = 26] = "PRIOR_FISCAL_YEAR_PERIOD_8", e[e.PRIOR_FISCAL_YEAR_PERIOD_9 = 27] = "PRIOR_FISCAL_YEAR_PERIOD_9", e[e.PRIOR_FISCAL_YEAR_PERIOD_10 = 28] = "PRIOR_FISCAL_YEAR_PERIOD_10", e[e.PRIOR_FISCAL_YEAR_PERIOD_11 = 29] = "PRIOR_FISCAL_YEAR_PERIOD_11", e[e.PRIOR_FISCAL_YEAR_PERIOD_12 = 30] = "PRIOR_FISCAL_YEAR_PERIOD_12", e[e.PRIOR_FISCAL_YEAR_PERIOD_13 = 31] = "PRIOR_FISCAL_YEAR_PERIOD_13", e[e.CURRENT_FISCAL_YEAR = 32] = "CURRENT_FISCAL_YEAR", e[e.CURRENT_QUARTER = 34] = "CURRENT_QUARTER", e[e.CURRENT_1ST_QUARTER = 35] = "CURRENT_1ST_QUARTER", e[e.CURRENT_2ND_QUARTER = 36] = "CURRENT_2ND_QUARTER", e[e.CURRENT_3RD_QUARTER = 37] = "CURRENT_3RD_QUARTER", e[e.CURRENT_4TH_QUARTER = 38] = "CURRENT_4TH_QUARTER", e[e.PRIOR_FISCAL_YEAR_CURRENT_QUARTER = 39] = "PRIOR_FISCAL_YEAR_CURRENT_QUARTER", e[e.PRIOR_FISCAL_YEAR_1ST_QUARTER = 40] = "PRIOR_FISCAL_YEAR_1ST_QUARTER", e[e.PRIOR_FISCAL_YEAR_2ND_QUARTER = 41] = "PRIOR_FISCAL_YEAR_2ND_QUARTER", e[e.PRIOR_FISCAL_YEAR_3RD_QUARTER = 42] = "PRIOR_FISCAL_YEAR_3RD_QUARTER", e[e.PRIOR_FISCAL_YEAR_4TH_QUARTER = 43] = "PRIOR_FISCAL_YEAR_4TH_QUARTER", e[e.CURRENT_FISCAL_YEAR_TO_DATE = 44] = "CURRENT_FISCAL_YEAR_TO_DATE", e[e.PRIOR_FISCAL_YEAR_TO_DATE = 45] = "PRIOR_FISCAL_YEAR_TO_DATE", e[e.CURRENT_QUARTER_TO_DATE = 46] = "CURRENT_QUARTER_TO_DATE", e[e.PRIOR_FISCAL_YEAR_CURRENT_QUARTER_TO_DATE = 47] = "PRIOR_FISCAL_YEAR_CURRENT_QUARTER_TO_DATE", e[e.PRIOR_QUARTER = 48] = "PRIOR_QUARTER", e[e.LAST_12_PERIODS_INCLUSIVE = 49] = "LAST_12_PERIODS_INCLUSIVE", e[e.LAST_13_PERIODS_INCLUSIVE = 50] = "LAST_13_PERIODS_INCLUSIVE", e[e.LAST_12_PERIODS_EXCLUSIVE = 51] = "LAST_12_PERIODS_EXCLUSIVE", e[e.LAST_13_PERIODS_EXCLUSIVE = 52] = "LAST_13_PERIODS_EXCLUSIVE", e[e.INCEPTION_TO_DATE = 53] = "INCEPTION_TO_DATE", e[e.PRIOR_FISCAL_YEAR_INCEPTION_TO_DATE = 54] = "PRIOR_FISCAL_YEAR_INCEPTION_TO_DATE", e[e.PRIOR_FISCAL_YEAR_CALCULATED_FROM_INCEPTION = 55] = "PRIOR_FISCAL_YEAR_CALCULATED_FROM_INCEPTION", e[e.CURRENT_FISCAL_YEAR_CALCULATED_FROM_INCEPTION = 57] = "CURRENT_FISCAL_YEAR_CALCULATED_FROM_INCEPTION", e[e.PRIOR_PERIOD_INCEPTION_TO_DATE = 58] = "PRIOR_PERIOD_INCEPTION_TO_DATE", e[e.CURRENT_PERIOD_MINUS_1 = 59] = "CURRENT_PERIOD_MINUS_1", e[e.CURRENT_PERIOD_MINUS_2 = 60] = "CURRENT_PERIOD_MINUS_2", e[e.CURRENT_PERIOD_MINUS_3 = 61] = "CURRENT_PERIOD_MINUS_3", e[e.CURRENT_PERIOD_MINUS_4 = 62] = "CURRENT_PERIOD_MINUS_4", e[e.CURRENT_PERIOD_MINUS_5 = 63] = "CURRENT_PERIOD_MINUS_5", e[e.CURRENT_PERIOD_MINUS_6 = 64] = "CURRENT_PERIOD_MINUS_6", e[e.CURRENT_PERIOD_MINUS_7 = 65] = "CURRENT_PERIOD_MINUS_7", e[e.CURRENT_PERIOD_MINUS_8 = 66] = "CURRENT_PERIOD_MINUS_8", e[e.CURRENT_PERIOD_MINUS_9 = 67] = "CURRENT_PERIOD_MINUS_9", e[e.CURRENT_PERIOD_MINUS_10 = 68] = "CURRENT_PERIOD_MINUS_10", e[e.CURRENT_PERIOD_MINUS_11 = 69] = "CURRENT_PERIOD_MINUS_11", e[e.CURRENT_PERIOD_MINUS_12 = 70] = "CURRENT_PERIOD_MINUS_12", e[e.CURRENT_PERIOD_MINUS_13 = 71] = "CURRENT_PERIOD_MINUS_13", e[e.CURRENT_PERIOD_MINUS_14 = 72] = "CURRENT_PERIOD_MINUS_14", e[e.CURRENT_PERIOD_MINUS_15 = 73] = "CURRENT_PERIOD_MINUS_15", e[e.CURRENT_PERIOD_MINUS_16 = 74] = "CURRENT_PERIOD_MINUS_16", e[e.CURRENT_PERIOD_MINUS_17 = 75] = "CURRENT_PERIOD_MINUS_17", e[e.CURRENT_PERIOD_MINUS_18 = 76] = "CURRENT_PERIOD_MINUS_18", e[e.CURRENT_PERIOD_MINUS_19 = 77] = "CURRENT_PERIOD_MINUS_19", e[e.CURRENT_PERIOD_MINUS_20 = 78] = "CURRENT_PERIOD_MINUS_20", e[e.CURRENT_PERIOD_MINUS_21 = 79] = "CURRENT_PERIOD_MINUS_21", e[e.CURRENT_PERIOD_MINUS_22 = 80] = "CURRENT_PERIOD_MINUS_22", e[e.CURRENT_PERIOD_MINUS_23 = 81] = "CURRENT_PERIOD_MINUS_23", e[e.CURRENT_PERIOD_MINUS_24 = 82] = "CURRENT_PERIOD_MINUS_24", e[e.CURRENT_PERIOD_MINUS_25 = 83] = "CURRENT_PERIOD_MINUS_25";
    })(t16.FinancialStatementPeriodTypeEnum || (t16.FinancialStatementPeriodTypeEnum = {}));
  })(vb)), vb;
}
var mb = {}, xae;
function xs0() {
  return xae || (xae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.GenderTypeEnum = void 0, (function(e) {
      e[e.FEMALE = 2] = "FEMALE", e[e.MALE = 1] = "MALE";
    })(t16.GenderTypeEnum || (t16.GenderTypeEnum = {}));
  })(mb)), mb;
}
var Rb = {}, Uae;
function Us0() {
  return Uae || (Uae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.InContractConsultantOwnerMethodEnum = void 0, (function(e) {
      e[e.COST_AMOUNT_WITH_NO_CAP = 1] = "COST_AMOUNT_WITH_NO_CAP", e[e.BILL_AMOUNT_WITH_NO_CAP = 2] = "BILL_AMOUNT_WITH_NO_CAP", e[e.COST_AMOUNT_WITH_CAP = 3] = "COST_AMOUNT_WITH_CAP", e[e.BILL_AMOUNT_WITH_CAP = 4] = "BILL_AMOUNT_WITH_CAP", e[e.PERECENT_COMPLETE = 8] = "PERECENT_COMPLETE", e[e.CAP_AMOUNT = 10] = "CAP_AMOUNT";
    })(t16.InContractConsultantOwnerMethodEnum || (t16.InContractConsultantOwnerMethodEnum = {}));
  })(Rb)), Rb;
}
var qb = {}, kae;
function ks0() {
  return kae || (kae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.InContractConsultantShareMethodEnum = void 0, (function(e) {
      e[e.COST_AMOUNT_WITH_NO_CAP = 1] = "COST_AMOUNT_WITH_NO_CAP", e[e.BILL_AMOUNT_WITH_NO_CAP = 2] = "BILL_AMOUNT_WITH_NO_CAP", e[e.COST_AMOUNT_WITH_CAP = 3] = "COST_AMOUNT_WITH_CAP", e[e.BILL_AMOUNT_WITH_CAP = 4] = "BILL_AMOUNT_WITH_CAP", e[e.PERCENT_COMPLETE = 5] = "PERCENT_COMPLETE", e[e.CAP_AMOUNT = 6] = "CAP_AMOUNT";
    })(t16.InContractConsultantShareMethodEnum || (t16.InContractConsultantShareMethodEnum = {}));
  })(qb)), qb;
}
var Tb = {}, jae;
function js0() {
  return jae || (jae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.InterCompanyICCMethodEnum = void 0, (function(e) {
      e[e.COST = 1] = "COST", e[e.MARKUP = 2] = "MARKUP", e[e.PERCENT_OF_REVENUE_BASED_ON_COST = 3] = "PERCENT_OF_REVENUE_BASED_ON_COST", e[e.PERCENT_OF_REVENUE_BASED_ON_MARKUP = 4] = "PERCENT_OF_REVENUE_BASED_ON_MARKUP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT = 5] = "PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE = 6] = "PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_COST_FOR_NO_CAP = 7] = "PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_COST_FOR_NO_CAP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_COST_FOR_NO_CAP = 8] = "PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_COST_FOR_NO_CAP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_MARKUP_FOR_NO_CAP = 9] = "PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_MARKUP_FOR_NO_CAP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_MARKUP_FOR_NO_CAP = 10] = "PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_MARKUP_FOR_NO_CAP";
    })(t16.InterCompanyICCMethodEnum || (t16.InterCompanyICCMethodEnum = {}));
  })(Tb)), Tb;
}
var yb = {}, Fae;
function Fs0() {
  return Fae || (Fae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.InterCompanyLaborMethodEnum = void 0, (function(e) {
      e[e.HOURLY_AT_JOB_COST_RATE = 1] = "HOURLY_AT_JOB_COST_RATE", e[e.HOURLY_AT_BILL_RATE = 2] = "HOURLY_AT_BILL_RATE", e[e.PERCENT_OF_REVENUE_BASED_ON_JOB_COST_RATE = 3] = "PERCENT_OF_REVENUE_BASED_ON_JOB_COST_RATE", e[e.PERCENT_OF_REVENUE_BASED_ON_BILL_RATE = 4] = "PERCENT_OF_REVENUE_BASED_ON_BILL_RATE", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT = 5] = "PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE = 6] = "PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_JOB_COST_RATE_FOR_NO_CAP = 7] = "PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_JOB_COST_RATE_FOR_NO_CAP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_JOB_COST_RATE_FOR_NO_CAP = 8] = "PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_JOB_COST_RATE_FOR_NO_CAP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_BILL_RATE_FOR_NO_CAP = 9] = "PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_BILL_RATE_FOR_NO_CAP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_BILL_RATE_FOR_NO_CAP = 10] = "PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_BILL_RATE_FOR_NO_CAP";
    })(t16.InterCompanyLaborMethodEnum || (t16.InterCompanyLaborMethodEnum = {}));
  })(yb)), yb;
}
var Sb = {}, Vae;
function Vs0() {
  return Vae || (Vae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.InterCompanyOutOfContractConsultantMethodEnum = void 0, (function(e) {
      e[e.COST = 1] = "COST", e[e.MARKUP = 2] = "MARKUP", e[e.PERCENT_OF_REVENUE_BASED_ON_COST = 3] = "PERCENT_OF_REVENUE_BASED_ON_COST", e[e.PERCENT_OF_REVENUE_BASED_ON_MARKUP = 4] = "PERCENT_OF_REVENUE_BASED_ON_MARKUP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT = 5] = "PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE = 6] = "PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_COST_FOR_NO_CAP = 7] = "PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_COST_FOR_NO_CAP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_COST_FOR_NO_CAP = 8] = "PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_COST_FOR_NO_CAP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_MARKUP_FOR_NO_CAP = 9] = "PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_MARKUP_FOR_NO_CAP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_MARKUP_FOR_NO_CAP = 10] = "PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_MARKUP_FOR_NO_CAP";
    })(t16.InterCompanyOutOfContractConsultantMethodEnum || (t16.InterCompanyOutOfContractConsultantMethodEnum = {}));
  })(Sb)), Sb;
}
var Cb = {}, Hae;
function Hs0() {
  return Hae || (Hae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.InterCompanyOtherDirectChargeMethodEnum = void 0, (function(e) {
      e[e.COST = 1] = "COST", e[e.MARKUP = 2] = "MARKUP", e[e.PERCENT_OF_REVENUE_BASED_ON_COST = 3] = "PERCENT_OF_REVENUE_BASED_ON_COST", e[e.PERCENT_OF_REVENUE_BASED_ON_MARKUP = 4] = "PERCENT_OF_REVENUE_BASED_ON_MARKUP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT = 5] = "PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE = 6] = "PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_COST_FOR_NO_CAP = 7] = "PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_COST_FOR_NO_CAP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_COST_FOR_NO_CAP = 8] = "PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_COST_FOR_NO_CAP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_MARKUP_FOR_NO_CAP = 9] = "PERCENT_OF_REVENUE_BASED_ON_CAP_AMOUNT_PLUS_MARKUP_FOR_NO_CAP", e[e.PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_MARKUP_FOR_NO_CAP = 10] = "PERCENT_OF_REVENUE_BASED_ON_CAP_PERCENTAGE_PLUS_MARKUP_FOR_NO_CAP";
    })(t16.InterCompanyOtherDirectChargeMethodEnum || (t16.InterCompanyOtherDirectChargeMethodEnum = {}));
  })(Cb)), Cb;
}
var gb = {}, Xae;
function Xs0() {
  return Xae || (Xae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.InFocusEventTypeEnum = void 0, (function(e) {
      e[e.ACCOUNTS_PAYABLE = 2] = "ACCOUNTS_PAYABLE", e[e.ACCOUNTS_RECEIVABLE = 3] = "ACCOUNTS_RECEIVABLE", e[e.PROJECTS = 4] = "PROJECTS", e[e.HR = 5] = "HR", e[e.PURCHASING = 14] = "PURCHASING", e[e.PERSONAL = 13] = "PERSONAL", e[e.GENERAL_ACCOUNTING = 9] = "GENERAL_ACCOUNTING", e[e.MARKETING = 12] = "MARKETING", e[e.SYSTEM = 1] = "SYSTEM", e[e.WORK_ORDERS = 15] = "WORK_ORDERS";
    })(t16.InFocusEventTypeEnum || (t16.InFocusEventTypeEnum = {}));
  })(gb)), gb;
}
var Ib = {}, $ae;
function $s0() {
  return $ae || ($ae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.InvoiceByMethodEnum = void 0, (function(e) {
      e[e.AR_ACCOUNT = 1] = "AR_ACCOUNT", e[e.PROJECT = 2] = "PROJECT", e[e.CLIENT = 3] = "CLIENT", e[e.COMPANY = 4] = "COMPANY";
    })(t16.InvoiceByMethodEnum || (t16.InvoiceByMethodEnum = {}));
  })(Ib)), Ib;
}
var Eb = {}, Gae;
function Gs0() {
  return Gae || (Gae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.InvoiceExpenseColumnEnum = void 0, (function(e) {
      e[e.EXP_CODE = 1] = "EXP_CODE", e[e.EXP_NAME = 2] = "EXP_NAME", e[e.PAYEE_CODE = 3] = "PAYEE_CODE", e[e.PAYEE_NAME = 4] = "PAYEE_NAME", e[e.TRANS_DATE = 5] = "TRANS_DATE", e[e.TRACK_NUM = 6] = "TRACK_NUM", e[e.QTY = 7] = "QTY", e[e.UNIT_RATE = 8] = "UNIT_RATE", e[e.MARKUP = 9] = "MARKUP", e[e.MARKUP_TYPE = 16] = "MARKUP_TYPE", e[e.P_M_COMMENTS = 15] = "P_M_COMMENTS", e[e.ORG_CODE = 17] = "ORG_CODE", e[e.ORG_PATH = 19] = "ORG_PATH", e[e.ORG_NAME = 18] = "ORG_NAME", e[e.ORG_LONG_NAME = 20] = "ORG_LONG_NAME", e[e.LINE_I_D = 21] = "LINE_I_D", e[e.TRANS_I_D = 22] = "TRANS_I_D", e[e.G_L_BASE_CODE = 23] = "G_L_BASE_CODE", e[e.G_L_BASE_NAME = 24] = "G_L_BASE_NAME";
    })(t16.InvoiceExpenseColumnEnum || (t16.InvoiceExpenseColumnEnum = {}));
  })(Eb)), Eb;
}
var Lb = {}, Yae;
function Ys0() {
  return Yae || (Yae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.InvoiceLaborColumnEnum = void 0, (function(e) {
      e[e.EMP_CODE = 1] = "EMP_CODE", e[e.EMP_NAME = 2] = "EMP_NAME", e[e.JOB_TITLE_CODE = 3] = "JOB_TITLE_CODE", e[e.JOB_TITLE_NAME = 4] = "JOB_TITLE_NAME", e[e.LABOR_CODE = 28] = "LABOR_CODE", e[e.LABOR_NAME = 29] = "LABOR_NAME", e[e.WORK_DATE = 5] = "WORK_DATE", e[e.BILL_HRS = 6] = "BILL_HRS", e[e.BILL_BASE_RATE = 7] = "BILL_BASE_RATE", e[e.BILL_BASE_PREM_M_U = 27] = "BILL_BASE_PREM_M_U", e[e.BILL_RATE = 9] = "BILL_RATE", e[e.BILL_D_P_E_MULT = 18] = "BILL_D_P_E_MULT", e[e.BILL_O_H_MULT = 19] = "BILL_O_H_MULT", e[e.BILL_P_R_MULT = 20] = "BILL_P_R_MULT", e[e.IS_HOURLY = 24] = "IS_HOURLY", e[e.IS_PREMIUM = 26] = "IS_PREMIUM", e[e.P_M_COMMENTS = 25] = "P_M_COMMENTS", e[e.HOME_ORG_CODE = 30] = "HOME_ORG_CODE", e[e.HOME_ORG_PATH = 31] = "HOME_ORG_PATH", e[e.HOME_ORG_NAME = 32] = "HOME_ORG_NAME", e[e.HOME_ORG_LONG_NAME = 33] = "HOME_ORG_LONG_NAME", e[e.CHARGE_ORG_CODE = 34] = "CHARGE_ORG_CODE", e[e.CHARGE_ORG_PATH = 35] = "CHARGE_ORG_PATH", e[e.CHARGE_ORG_NAME = 36] = "CHARGE_ORG_NAME", e[e.CHARGE_ORG_LONG_NAME = 37] = "CHARGE_ORG_LONG_NAME", e[e.LOC_CODE = 38] = "LOC_CODE", e[e.LOC_NAME = 39] = "LOC_NAME", e[e.P_E_DATE = 40] = "P_E_DATE", e[e.LINE_I_D = 41] = "LINE_I_D", e[e.TRANS_I_D = 42] = "TRANS_I_D";
    })(t16.InvoiceLaborColumnEnum || (t16.InvoiceLaborColumnEnum = {}));
  })(Lb)), Lb;
}
var Pb = {}, Jae;
function Js0() {
  return Jae || (Jae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.LaborCapTypeEnum = void 0, (function(e) {
      e[e.DIRECT_LABOR = 1] = "DIRECT_LABOR", e[e.DIRECT_LABOR_DPE_OVERHEAD = 2] = "DIRECT_LABOR_DPE_OVERHEAD", e[e.DIRECT_LABOR_DPE_OVERHEAD_PROFIT = 3] = "DIRECT_LABOR_DPE_OVERHEAD_PROFIT", e[e.BILL_AMOUNT = 4] = "BILL_AMOUNT";
    })(t16.LaborCapTypeEnum || (t16.LaborCapTypeEnum = {}));
  })(Pb)), Pb;
}
var Db = {}, Kae;
function Ks0() {
  return Kae || (Kae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.LaborCodeTypeEnum = void 0, (function(e) {
      e[e.INDIRECT = 2] = "INDIRECT", e[e.DIRECT = 1] = "DIRECT", e[e.BOTH = 3] = "BOTH";
    })(t16.LaborCodeTypeEnum || (t16.LaborCodeTypeEnum = {}));
  })(Db)), Db;
}
var Wb = {}, Qae;
function Qs0() {
  return Qae || (Qae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.LaborDistribMethodEnum = void 0, (function(e) {
      e[e.PAY_RATE = 1] = "PAY_RATE", e[e.JOB_COST_RATE = 2] = "JOB_COST_RATE", e[e.BILL_RATE = 3] = "BILL_RATE", e[e.PAY_RATE_X_SUPPILED_MULTIPLIER = 4] = "PAY_RATE_X_SUPPILED_MULTIPLIER";
    })(t16.LaborDistribMethodEnum || (t16.LaborDistribMethodEnum = {}));
  })(Wb)), Wb;
}
var Nb = {}, Zae;
function Zs0() {
  return Zae || (Zae = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.LaborOwnerMethodEnum = void 0, (function(e) {
      e[e.PAY_RATE_WITH_NO_CAP = 1] = "PAY_RATE_WITH_NO_CAP", e[e.JOB_COST_RATE_WITH_NO_CAP = 2] = "JOB_COST_RATE_WITH_NO_CAP", e[e.BILL_RATE_WITH_NO_CAP = 3] = "BILL_RATE_WITH_NO_CAP", e[e.PAY_RATE_WITH_CAP = 4] = "PAY_RATE_WITH_CAP", e[e.JOB_COST_RATE_WITH_CAP = 5] = "JOB_COST_RATE_WITH_CAP", e[e.BILL_RATE_WITH_CAP = 6] = "BILL_RATE_WITH_CAP", e[e.PERCENT_COMPLETE = 11] = "PERCENT_COMPLETE", e[e.CAP_AMOUNT = 13] = "CAP_AMOUNT";
    })(t16.LaborOwnerMethodEnum || (t16.LaborOwnerMethodEnum = {}));
  })(Nb)), Nb;
}
var wb = {}, eoe;
function ec0() {
  return eoe || (eoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.LaborRateTypeEnum = void 0, (function(e) {
      e[e.PAY = 1] = "PAY", e[e.JOB_COST = 2] = "JOB_COST", e[e.BILL = 3] = "BILL";
    })(t16.LaborRateTypeEnum || (t16.LaborRateTypeEnum = {}));
  })(wb)), wb;
}
var Bb = {}, toe;
function tc0() {
  return toe || (toe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.LaborRevenueTypeEnum = void 0, (function(e) {
      e[e.DIRECT = 1] = "DIRECT", e[e.DPE_OVERHEAD = 2] = "DPE_OVERHEAD", e[e.PROFIT = 3] = "PROFIT", e[e.FIXED_FEE = 4] = "FIXED_FEE";
    })(t16.LaborRevenueTypeEnum || (t16.LaborRevenueTypeEnum = {}));
  })(Bb)), Bb;
}
var xb = {}, roe;
function rc0() {
  return roe || (roe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.LaborShareMethodEnum = void 0, (function(e) {
      e[e.PAY_RATE_WITH_NO_CAP = 1] = "PAY_RATE_WITH_NO_CAP", e[e.JOB_COST_RATE_WITH_NO_CAP = 2] = "JOB_COST_RATE_WITH_NO_CAP", e[e.BILL_RATE_WITH_NO_CAP = 3] = "BILL_RATE_WITH_NO_CAP", e[e.PAY_RATE_WITH_CAP = 4] = "PAY_RATE_WITH_CAP", e[e.JOB_COST_RATE_WITH_CAP = 5] = "JOB_COST_RATE_WITH_CAP", e[e.BILL_RATE_WITH_CAP = 6] = "BILL_RATE_WITH_CAP", e[e.PERCENT_COMPLETE = 7] = "PERCENT_COMPLETE", e[e.CAP_AMOUNT = 8] = "CAP_AMOUNT";
    })(t16.LaborShareMethodEnum || (t16.LaborShareMethodEnum = {}));
  })(xb)), xb;
}
var Ub = {}, noe;
function nc0() {
  return noe || (noe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.LateChargeTypeEnum = void 0, (function(e) {
      e[e.PERCENT_OF_BALANCE_DUE = 1] = "PERCENT_OF_BALANCE_DUE", e[e.FLAT_AMOUNT = 2] = "FLAT_AMOUNT";
    })(t16.LateChargeTypeEnum || (t16.LateChargeTypeEnum = {}));
  })(Ub)), Ub;
}
var kb = {}, aoe;
function ac0() {
  return aoe || (aoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.LeadSourceEnum = void 0, (function(e) {
      e[e.MAILING = 1] = "MAILING", e[e.ADVERTISING = 2] = "ADVERTISING", e[e.TRADE_SHOW = 3] = "TRADE_SHOW", e[e.PERSONAL_CONTACT = 4] = "PERSONAL_CONTACT", e[e.CLIENT_REFERRAL = 5] = "CLIENT_REFERRAL", e[e.ASSOCIATIONS = 6] = "ASSOCIATIONS";
    })(t16.LeadSourceEnum || (t16.LeadSourceEnum = {}));
  })(kb)), kb;
}
var jb = {}, ooe;
function oc0() {
  return ooe || (ooe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.LeadStageEnum = void 0, (function(e) {
      e[e.LEAD = 1] = "LEAD", e[e.PROPOSAL = 2] = "PROPOSAL", e[e.PENDING = 3] = "PENDING", e[e.SHORT_LISTED = 4] = "SHORT_LISTED", e[e.WON = 5] = "WON", e[e.LOST = 6] = "LOST", e[e.IN_NEGOTIATION = 9] = "IN_NEGOTIATION", e[e.AWARDED_SIGNED_CONTRACT = 10] = "AWARDED_SIGNED_CONTRACT";
    })(t16.LeadStageEnum || (t16.LeadStageEnum = {}));
  })(jb)), jb;
}
var Fb = {}, ioe;
function ic0() {
  return ioe || (ioe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.MarketListTypeEnum = void 0, (function(e) {
      e[e.CONTACTS = 1] = "CONTACTS", e[e.FIRMS = 2] = "FIRMS", e[e.OPPORTUNITIES = 3] = "OPPORTUNITIES";
    })(t16.MarketListTypeEnum || (t16.MarketListTypeEnum = {}));
  })(Fb)), Fb;
}
var Vb = {}, uoe;
function uc0() {
  return uoe || (uoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.MarketSectorTypeEnum = void 0, (function(e) {
      e[e.FEDERAL_GOVERNMENT = 1] = "FEDERAL_GOVERNMENT", e[e.STATE_GOVERNMENT = 2] = "STATE_GOVERNMENT", e[e.LOCAL_GOVERNMENT = 3] = "LOCAL_GOVERNMENT", e[e.NON_PROFIT = 4] = "NON_PROFIT", e[e.HEALTH_CARE = 5] = "HEALTH_CARE", e[e.EDUCATION = 6] = "EDUCATION", e[e.COMMERCIAL = 7] = "COMMERCIAL", e[e.RESIDENTIAL = 8] = "RESIDENTIAL", e[e.NEW_ITEM = 9] = "NEW_ITEM", e[e.ES1_ENVIRONMENTAL = 1010] = "ES1_ENVIRONMENTAL", e[e.XCXCXCXC = 1011] = "XCXCXCXC", e[e.NEW_CONSTRUCTION = 2011] = "NEW_CONSTRUCTION", e[e.A01_SLDFJSLDKFJ = 2012] = "A01_SLDFJSLDKFJ";
    })(t16.MarketSectorTypeEnum || (t16.MarketSectorTypeEnum = {}));
  })(Vb)), Vb;
}
var Hb = {}, soe;
function sc0() {
  return soe || (soe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.MarkupsUsedTypeEnum = void 0, (function(e) {
      e[e.OH = 2] = "OH", e[e.DPE = 1] = "DPE", e[e.DPE_X_OH = 3] = "DPE_X_OH", e[e.DPE_X_OH_X_PROFIT = 4] = "DPE_X_OH_X_PROFIT";
    })(t16.MarkupsUsedTypeEnum || (t16.MarkupsUsedTypeEnum = {}));
  })(Hb)), Hb;
}
var Xb = {}, coe;
function cc0() {
  return coe || (coe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.MultiCurrencyCheckTypeEnum = void 0, (function(e) {
      e[e.ALLOW = 1] = "ALLOW", e[e.DISALLOW = 2] = "DISALLOW", e[e.WARN = 3] = "WARN";
    })(t16.MultiCurrencyCheckTypeEnum || (t16.MultiCurrencyCheckTypeEnum = {}));
  })(Xb)), Xb;
}
var $b = {}, loe;
function lc0() {
  return loe || (loe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.MessageTypeEnum = void 0, (function(e) {
      e[e.EMAIL = 1] = "EMAIL", e[e.WEBHOOK = 2] = "WEBHOOK";
    })(t16.MessageTypeEnum || (t16.MessageTypeEnum = {}));
  })($b)), $b;
}
var Gb = {}, poe;
function pc0() {
  return poe || (poe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.NamePrefixeEnum = void 0, (function(e) {
      e[e.MR = 1] = "MR", e[e.MS = 2] = "MS", e[e.MRS = 3] = "MRS", e[e.MISS = 4] = "MISS", e[e.DR = 5] = "DR", e[e.COL = 6] = "COL", e[e.GEN = 7] = "GEN";
    })(t16.NamePrefixeEnum || (t16.NamePrefixeEnum = {}));
  })(Gb)), Gb;
}
var Yb = {}, doe;
function dc0() {
  return doe || (doe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.NameSuffixeEnum = void 0, (function(e) {
      e[e.JR = 1] = "JR", e[e.SR = 2] = "SR", e[e.III = 3] = "III", e[e.AIA = 4] = "AIA", e[e.PE = 5] = "PE", e[e.CPA = 6] = "CPA", e[e.CFA = 7] = "CFA", e[e.PH_D = 8] = "PH_D";
    })(t16.NameSuffixeEnum || (t16.NameSuffixeEnum = {}));
  })(Yb)), Yb;
}
var Jb = {}, foe;
function fc0() {
  return foe || (foe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.NoteTypeEnum = void 0, (function(e) {
      e[e.PHONE_CALL = 1] = "PHONE_CALL", e[e.MEETING = 2] = "MEETING", e[e.EMAIL = 3] = "EMAIL", e[e.APPOINTMENT = 4] = "APPOINTMENT", e[e.LUNCH = 5] = "LUNCH", e[e.DINNER = 6] = "DINNER";
    })(t16.NoteTypeEnum || (t16.NoteTypeEnum = {}));
  })(Jb)), Jb;
}
var Kb = {}, boe;
function bc0() {
  return boe || (boe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.OutOfContractConsultantOwnerMethodEnum = void 0, (function(e) {
      e[e.CAP_AMOUNT = 10] = "CAP_AMOUNT", e[e.PERCENT_COMPLETE = 8] = "PERCENT_COMPLETE", e[e.BILL_AMOUNT_WITH_CAP = 4] = "BILL_AMOUNT_WITH_CAP", e[e.COST_AMOUNT_WITH_CAP = 3] = "COST_AMOUNT_WITH_CAP", e[e.BILL_AMOUNT_WITH_NO_CAP = 2] = "BILL_AMOUNT_WITH_NO_CAP", e[e.COST_AMOUNT_WITH_NO_CAP = 1] = "COST_AMOUNT_WITH_NO_CAP";
    })(t16.OutOfContractConsultantOwnerMethodEnum || (t16.OutOfContractConsultantOwnerMethodEnum = {}));
  })(Kb)), Kb;
}
var Qb = {}, Moe;
function Mc0() {
  return Moe || (Moe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.OutOfContractConsultantShareMethodEnum = void 0, (function(e) {
      e[e.BILL_AMOUNT_WITH_NO_CAP = 2] = "BILL_AMOUNT_WITH_NO_CAP", e[e.COST_AMOUNT_WITH_CAP = 3] = "COST_AMOUNT_WITH_CAP", e[e.BILL_AMOUNT_WITH_CAP = 4] = "BILL_AMOUNT_WITH_CAP", e[e.PERCENT_COMPLETE = 5] = "PERCENT_COMPLETE", e[e.CAP_AMOUNT = 6] = "CAP_AMOUNT", e[e.COST_AMOUNT_WITH_NO_CAP = 1] = "COST_AMOUNT_WITH_NO_CAP";
    })(t16.OutOfContractConsultantShareMethodEnum || (t16.OutOfContractConsultantShareMethodEnum = {}));
  })(Qb)), Qb;
}
var Zb = {}, Ooe;
function Oc0() {
  return Ooe || (Ooe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.OtherDirectChargeOwnerMethodEnum = void 0, (function(e) {
      e[e.COST_AMOUNT_WITH_NO_CAP = 1] = "COST_AMOUNT_WITH_NO_CAP", e[e.BILL_AMOUNT_WITH_NO_CAP = 2] = "BILL_AMOUNT_WITH_NO_CAP", e[e.COST_AMOUNT_WITH_CAP = 3] = "COST_AMOUNT_WITH_CAP", e[e.BILL_AMOUNT_WITH_CAP = 4] = "BILL_AMOUNT_WITH_CAP", e[e.PERCENT_COMPLETE = 8] = "PERCENT_COMPLETE", e[e.CAP_AMOUNT = 10] = "CAP_AMOUNT";
    })(t16.OtherDirectChargeOwnerMethodEnum || (t16.OtherDirectChargeOwnerMethodEnum = {}));
  })(Zb)), Zb;
}
var eM = {}, zoe;
function zc0() {
  return zoe || (zoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.OtherDirectChargeShareMethodEnum = void 0, (function(e) {
      e[e.COST_AMOUNT_WITH_NO_CAP = 1] = "COST_AMOUNT_WITH_NO_CAP", e[e.BILL_AMOUNT_WITH_NO_CAP = 2] = "BILL_AMOUNT_WITH_NO_CAP", e[e.COST_AMOUNT_WITH_CAP = 3] = "COST_AMOUNT_WITH_CAP", e[e.BILL_AMOUNT_WITH_CAP = 4] = "BILL_AMOUNT_WITH_CAP", e[e.PERCENT_COMPLETE = 5] = "PERCENT_COMPLETE", e[e.CAP_AMOUNT = 6] = "CAP_AMOUNT";
    })(t16.OtherDirectChargeShareMethodEnum || (t16.OtherDirectChargeShareMethodEnum = {}));
  })(eM)), eM;
}
var tM = {}, Aoe;
function Ac0() {
  return Aoe || (Aoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.OverheadCalcTypeEnum = void 0, (function(e) {
      e[e.SINGLE_PERIOD = 1] = "SINGLE_PERIOD", e[e.MULTI_PERIOD = 2] = "MULTI_PERIOD", e[e.BALANCE_FORWARD = 3] = "BALANCE_FORWARD";
    })(t16.OverheadCalcTypeEnum || (t16.OverheadCalcTypeEnum = {}));
  })(tM)), tM;
}
var rM = {}, _oe;
function _c0() {
  return _oe || (_oe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.OverheadMethodEnum = void 0, (function(e) {
      e[e.DIRECT_LABOR = 1] = "DIRECT_LABOR", e[e.TOTAL_LABOR = 2] = "TOTAL_LABOR";
    })(t16.OverheadMethodEnum || (t16.OverheadMethodEnum = {}));
  })(rM)), rM;
}
var nM = {}, hoe;
function hc0() {
  return hoe || (hoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.OverheadTypeEnum = void 0, (function(e) {
      e[e.JOB_COST_LESS_PAY = 1] = "JOB_COST_LESS_PAY", e[e.OVERHEAD_ALLOCATION = 2] = "OVERHEAD_ALLOCATION", e[e.NONE = 3] = "NONE";
    })(t16.OverheadTypeEnum || (t16.OverheadTypeEnum = {}));
  })(nM)), nM;
}
var aM = {}, voe;
function vc0() {
  return voe || (voe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.PayeeTypeEnum = void 0, (function(e) {
      e[e.VENDOR = 1] = "VENDOR", e[e.EMPLOYEE = 2] = "EMPLOYEE", e[e.CLIENT = 3] = "CLIENT";
    })(t16.PayeeTypeEnum || (t16.PayeeTypeEnum = {}));
  })(aM)), aM;
}
var oM = {}, moe;
function mc0() {
  return moe || (moe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.PayerTypeEnum = void 0, (function(e) {
      e[e.CLIENT = 1] = "CLIENT", e[e.EMPLOYEE = 2] = "EMPLOYEE", e[e.VENDOR = 3] = "VENDOR";
    })(t16.PayerTypeEnum || (t16.PayerTypeEnum = {}));
  })(oM)), oM;
}
var iM = {}, Roe;
function Rc0() {
  return Roe || (Roe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.PaymentTermEnum = void 0, (function(e) {
      e[e._15_DAYS = 1] = "_15_DAYS", e[e._30_DAYS = 2] = "_30_DAYS", e[e._45_DAYS = 3] = "_45_DAYS", e[e._60_DAYS = 4] = "_60_DAYS", e[e.NEXT = 5] = "NEXT", e[e.HOLD = 6] = "HOLD", e[e.PWP = 7] = "PWP";
    })(t16.PaymentTermEnum || (t16.PaymentTermEnum = {}));
  })(iM)), iM;
}
var uM = {}, qoe;
function qc0() {
  return qoe || (qoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.PayrolGroupEnum = void 0, (function(e) {
      e[e.BI_WEEKLY = 2] = "BI_WEEKLY";
    })(t16.PayrolGroupEnum || (t16.PayrolGroupEnum = {}));
  })(uM)), uM;
}
var sM = {}, Toe;
function Tc0() {
  return Toe || (Toe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectManagePeriodTypeEnum = void 0, (function(e) {
      e[e.CUSTOM = 4] = "CUSTOM", e[e.CALENDAR_YEAR_TO_DATE = 1] = "CALENDAR_YEAR_TO_DATE", e[e.FISCAL_YEAR_TO_DATE = 2] = "FISCAL_YEAR_TO_DATE", e[e.PROJECT_TO_DATE = 3] = "PROJECT_TO_DATE";
    })(t16.ProjectManagePeriodTypeEnum || (t16.ProjectManagePeriodTypeEnum = {}));
  })(sM)), sM;
}
var cM = {}, yoe;
function yc0() {
  return yoe || (yoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectManageReportColumnTypeEnum = void 0, (function(e) {
      e[e.AGGREGATE = 1] = "AGGREGATE", e[e.NONAGGREGATE = 2] = "NONAGGREGATE", e[e.PROJECT = 3] = "PROJECT", e[e.PROJECT_U_D_F = 4] = "PROJECT_U_D_F", e[e.PROJECT_FACT = 5] = "PROJECT_FACT";
    })(t16.ProjectManageReportColumnTypeEnum || (t16.ProjectManageReportColumnTypeEnum = {}));
  })(cM)), cM;
}
var lM = {}, Soe;
function Sc0() {
  return Soe || (Soe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectOwnerApprovalSourceTypeEnum = void 0, (function(e) {
      e[e.GLOBAL = 4] = "GLOBAL", e[e.ITEM = 1] = "ITEM", e[e.VENDOR = 2] = "VENDOR", e[e.EMPLOYEE = 3] = "EMPLOYEE";
    })(t16.ProjectOwnerApprovalSourceTypeEnum || (t16.ProjectOwnerApprovalSourceTypeEnum = {}));
  })(lM)), lM;
}
var pM = {}, Coe;
function Cc0() {
  return Coe || (Coe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectOwnerApprovalStatuEnum = void 0, (function(e) {
      e[e.UNSUBMITTED = 1] = "UNSUBMITTED", e[e.SUBMITTED = 2] = "SUBMITTED", e[e.APPROVED = 3] = "APPROVED", e[e.REJECTED = 4] = "REJECTED";
    })(t16.ProjectOwnerApprovalStatuEnum || (t16.ProjectOwnerApprovalStatuEnum = {}));
  })(pM)), pM;
}
var dM = {}, goe;
function gc0() {
  return goe || (goe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectOwnerItemApprovalStatuEnum = void 0, (function(e) {
      e[e.UNSUBMITTED = 1] = "UNSUBMITTED", e[e.SUBMITTED = 2] = "SUBMITTED", e[e.APPROVED = 3] = "APPROVED", e[e.REJECTED = 4] = "REJECTED";
    })(t16.ProjectOwnerItemApprovalStatuEnum || (t16.ProjectOwnerItemApprovalStatuEnum = {}));
  })(dM)), dM;
}
var fM = {}, Ioe;
function Ic0() {
  return Ioe || (Ioe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectOwnerItemReceiptStatuEnum = void 0, (function(e) {
      e[e.RECEIVED = 1] = "RECEIVED", e[e.NOT_RECEIVED = 2] = "NOT_RECEIVED", e[e.RETURNED = 3] = "RETURNED";
    })(t16.ProjectOwnerItemReceiptStatuEnum || (t16.ProjectOwnerItemReceiptStatuEnum = {}));
  })(fM)), fM;
}
var bM = {}, Eoe;
function Ec0() {
  return Eoe || (Eoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectOwnerPurchaseStatuEnum = void 0, (function(e) {
      e[e.IN_PROGRESS = 1] = "IN_PROGRESS", e[e.OPEN = 2] = "OPEN", e[e.CLOSED = 3] = "CLOSED";
    })(t16.ProjectOwnerPurchaseStatuEnum || (t16.ProjectOwnerPurchaseStatuEnum = {}));
  })(bM)), bM;
}
var MM = {}, Loe;
function Lc0() {
  return Loe || (Loe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectOwnerReceiptStatuEnum = void 0, (function(e) {
      e[e.UNAVAILABLE = 1] = "UNAVAILABLE", e[e.NONE = 2] = "NONE", e[e.PARTIAL = 3] = "PARTIAL", e[e.COMPLETE = 4] = "COMPLETE";
    })(t16.ProjectOwnerReceiptStatuEnum || (t16.ProjectOwnerReceiptStatuEnum = {}));
  })(MM)), MM;
}
var OM = {}, Poe;
function Pc0() {
  return Poe || (Poe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.PostalStateEnum = void 0, (function(e) {
      e[e.ALABAMA = 1] = "ALABAMA", e[e.ALASKA = 2] = "ALASKA", e[e.ARIZONA = 3] = "ARIZONA", e[e.ARKANSAS = 4] = "ARKANSAS", e[e.CALIFORNIA = 5] = "CALIFORNIA", e[e.COLORADO = 6] = "COLORADO", e[e.CONNECTICUT = 7] = "CONNECTICUT", e[e.DELEWARE = 8] = "DELEWARE", e[e.FLORIDA = 9] = "FLORIDA", e[e.GEORGIA = 10] = "GEORGIA", e[e.HAWAII = 11] = "HAWAII", e[e.IDAHO = 12] = "IDAHO", e[e.ILLINOIS = 13] = "ILLINOIS", e[e.INDIANA = 14] = "INDIANA", e[e.IOWA = 15] = "IOWA", e[e.KANSAS = 16] = "KANSAS", e[e.KENTUCKY = 17] = "KENTUCKY", e[e.LOUISIANA = 18] = "LOUISIANA", e[e.MAINE = 19] = "MAINE", e[e.MARYLAND = 20] = "MARYLAND", e[e.MASSACHUSETTS = 21] = "MASSACHUSETTS", e[e.MICHIGAN = 22] = "MICHIGAN", e[e.MINNESOTA = 23] = "MINNESOTA", e[e.MISSISSIPPI = 24] = "MISSISSIPPI", e[e.MISSOURI = 25] = "MISSOURI", e[e.MONTANA = 26] = "MONTANA", e[e.NEBRASKA = 27] = "NEBRASKA", e[e.NEVADA = 28] = "NEVADA", e[e.NEW_HAMPSHIRE = 29] = "NEW_HAMPSHIRE", e[e.NEW_JERSEY = 30] = "NEW_JERSEY", e[e.NEW_MEXICO = 31] = "NEW_MEXICO", e[e.NEW_YORK = 32] = "NEW_YORK", e[e.NORTH_CAROLINA = 33] = "NORTH_CAROLINA", e[e.NORTH_DAKOTA = 34] = "NORTH_DAKOTA", e[e.OHIO = 35] = "OHIO", e[e.OKLAHOMA = 36] = "OKLAHOMA", e[e.OREGON = 37] = "OREGON", e[e.PENNSYLVANIA = 38] = "PENNSYLVANIA", e[e.RHODE_ISLAND = 39] = "RHODE_ISLAND", e[e.SOUTH_CAROLINA = 40] = "SOUTH_CAROLINA", e[e.SOUTH_DAKOTA = 41] = "SOUTH_DAKOTA", e[e.TENNESSEE = 42] = "TENNESSEE", e[e.TEXAS = 43] = "TEXAS", e[e.UTAH = 44] = "UTAH", e[e.VERMONT = 45] = "VERMONT", e[e.VIRGINIA = 46] = "VIRGINIA", e[e.WASHINGTON = 47] = "WASHINGTON", e[e.WEST_VIRGINIA = 48] = "WEST_VIRGINIA", e[e.WISCONSIN = 49] = "WISCONSIN", e[e.WYOMING = 50] = "WYOMING";
    })(t16.PostalStateEnum || (t16.PostalStateEnum = {}));
  })(OM)), OM;
}
var zM = {}, Doe;
function Dc0() {
  return Doe || (Doe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProcessInstanceStageOwnerTypeEnum = void 0, (function(e) {
      e[e.CREATOR = 6] = "CREATOR", e[e.CURRENTLY_ASSIGNED = 1] = "CURRENTLY_ASSIGNED", e[e.TEAM_MEMBER = 5] = "TEAM_MEMBER", e[e.ROLE = 3] = "ROLE", e[e.PROMPT = 2] = "PROMPT", e[e.QUERY = 4] = "QUERY";
    })(t16.ProcessInstanceStageOwnerTypeEnum || (t16.ProcessInstanceStageOwnerTypeEnum = {}));
  })(zM)), zM;
}
var AM = {}, Woe;
function Wc0() {
  return Woe || (Woe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectChargeTypeEnum = void 0, (function(e) {
      e[e.BILLABLE = 1] = "BILLABLE", e[e.INDIRECT = 2] = "INDIRECT", e[e.PROJECTION = 3] = "PROJECTION", e[e.OPPORTUNITY = 4] = "OPPORTUNITY", e[e.PLAN = 5] = "PLAN";
    })(t16.ProjectChargeTypeEnum || (t16.ProjectChargeTypeEnum = {}));
  })(AM)), AM;
}
var _M = {}, Noe;
function Nc0() {
  return Noe || (Noe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectContactTypeEnum = void 0, (function(e) {
      e[e.MAIN = 1] = "MAIN", e[e.SECONDARY = 2] = "SECONDARY";
    })(t16.ProjectContactTypeEnum || (t16.ProjectContactTypeEnum = {}));
  })(_M)), _M;
}
var hM = {}, woe;
function wc0() {
  return woe || (woe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectQueryTypeEnum = void 0, (function(e) {
      e[e.PRIVATE = 3] = "PRIVATE", e[e.PERSONAL = 4] = "PERSONAL", e[e.PUBLIC = 5] = "PUBLIC";
    })(t16.ProjectQueryTypeEnum || (t16.ProjectQueryTypeEnum = {}));
  })(hM)), hM;
}
var vM = {}, Boe;
function Bc0() {
  return Boe || (Boe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectReportAggregateEnum = void 0, (function(e) {
      e[e.ALLOC_AMOUNT = 557] = "ALLOC_AMOUNT", e[e.BAD_DEBT = 337] = "BAD_DEBT", e[e.BILLED = 333] = "BILLED", e[e.B_L_HOURS_BUDGET = 562] = "B_L_HOURS_BUDGET", e[e.B_L_I_C_C_BUDGET = 569] = "B_L_I_C_C_BUDGET", e[e.B_L_I_C_C_BUDGET_P_A = 579] = "B_L_I_C_C_BUDGET_P_A", e[e.B_L_LABOR_BUDGET = 563] = "B_L_LABOR_BUDGET", e[e.B_L_LABOR_BUDGET_P_A = 575] = "B_L_LABOR_BUDGET_P_A", e[e.B_L_O_C_C_BUDGET = 567] = "B_L_O_C_C_BUDGET", e[e.B_L_O_C_C_BUDGET_P_A = 581] = "B_L_O_C_C_BUDGET_P_A", e[e.B_L_O_D_C_BUDGET = 565] = "B_L_O_D_C_BUDGET", e[e.B_L_O_D_C_BUDGET_P_A = 577] = "B_L_O_D_C_BUDGET_P_A", e[e.BUDGET = 573] = "BUDGET", e[e.BUDGET_P_A = 582] = "BUDGET_P_A", e[e.CONTRACT_FIXED_FEE = 627] = "CONTRACT_FIXED_FEE", e[e.CONTRACT_I_C_C = 630] = "CONTRACT_I_C_C", e[e.CONTRACT_LABOR = 626] = "CONTRACT_LABOR", e[e.CONTRACT_O_C_C = 629] = "CONTRACT_O_C_C", e[e.CONTRACT_O_D_C = 628] = "CONTRACT_O_D_C", e[e.COST = 311] = "COST", e[e.COST_A = 490] = "COST_A", e[e.COST_B = 314] = "COST_B", e[e.COST_H = 586] = "COST_H", e[e.COST_M_U = 321] = "COST_M_U", e[e.COST_M_U_A = 488] = "COST_M_U_A", e[e.COST_M_U_B = 324] = "COST_M_U_B", e[e.COST_M_U_H = 584] = "COST_M_U_H", e[e.COST_M_U_N = 322] = "COST_M_U_N", e[e.COST_M_U_R = 323] = "COST_M_U_R", e[e.COST_M_U_RND = 326] = "COST_M_U_RND", e[e.COST_M_U_RND_A = 487] = "COST_M_U_RND_A", e[e.COST_M_U_RND_B = 329] = "COST_M_U_RND_B", e[e.COST_M_U_RND_H = 583] = "COST_M_U_RND_H", e[e.COST_M_U_RND_N = 327] = "COST_M_U_RND_N", e[e.COST_M_U_RND_R = 328] = "COST_M_U_RND_R", e[e.COST_M_U_RND_W = 330] = "COST_M_U_RND_W", e[e.COST_M_U_W = 325] = "COST_M_U_W", e[e.COST_N = 312] = "COST_N", e[e.COST_R = 313] = "COST_R", e[e.COST_RND = 316] = "COST_RND", e[e.COST_RND_A = 489] = "COST_RND_A", e[e.COST_RND_B = 319] = "COST_RND_B", e[e.COST_RND_H = 585] = "COST_RND_H", e[e.COST_RND_N = 317] = "COST_RND_N", e[e.COST_RND_R = 318] = "COST_RND_R", e[e.COST_RND_W = 320] = "COST_RND_W", e[e.COST_W = 315] = "COST_W", e[e.EARNED = 331] = "EARNED", e[e.E_T_C_AMOUNT = 558] = "E_T_C_AMOUNT", e[e.HOURS_BUDGET = 559] = "HOURS_BUDGET", e[e.HOURS_SCHED = 613] = "HOURS_SCHED", e[e.I_C_C_ALLOC_AMOUNT = 550] = "I_C_C_ALLOC_AMOUNT", e[e.I_C_C_ALLOC_QTY = 549] = "I_C_C_ALLOC_QTY", e[e.I_C_C_BILLED = 450] = "I_C_C_BILLED", e[e.I_C_C_BUDGET = 568] = "I_C_C_BUDGET", e[e.I_C_C_BUDGET_P_A = 578] = "I_C_C_BUDGET_P_A", e[e.I_C_C_BUDGET_P_C = 572] = "I_C_C_BUDGET_P_C", e[e.I_C_C_CHANGE_ORDER_AMOUNT = 625] = "I_C_C_CHANGE_ORDER_AMOUNT", e[e.I_C_C_COST = 428] = "I_C_C_COST", e[e.I_C_C_COST_A = 494] = "I_C_C_COST_A", e[e.I_C_C_COST_B = 431] = "I_C_C_COST_B", e[e.I_C_C_COST_H = 590] = "I_C_C_COST_H", e[e.I_C_C_COST_M_U = 438] = "I_C_C_COST_M_U", e[e.I_C_C_COST_M_U_A = 492] = "I_C_C_COST_M_U_A", e[e.I_C_C_COST_M_U_B = 441] = "I_C_C_COST_M_U_B", e[e.I_C_C_COST_M_U_H = 588] = "I_C_C_COST_M_U_H", e[e.I_C_C_COST_M_U_N = 439] = "I_C_C_COST_M_U_N", e[e.I_C_C_COST_M_U_R = 440] = "I_C_C_COST_M_U_R", e[e.I_C_C_COST_M_U_RND = 443] = "I_C_C_COST_M_U_RND", e[e.I_C_C_COST_M_U_RND_A = 491] = "I_C_C_COST_M_U_RND_A", e[e.I_C_C_COST_M_U_RND_B = 446] = "I_C_C_COST_M_U_RND_B", e[e.I_C_C_COST_M_U_RND_H = 587] = "I_C_C_COST_M_U_RND_H", e[e.I_C_C_COST_M_U_RND_N = 444] = "I_C_C_COST_M_U_RND_N", e[e.I_C_C_COST_M_U_RND_R = 445] = "I_C_C_COST_M_U_RND_R", e[e.I_C_C_COST_M_U_RND_W = 447] = "I_C_C_COST_M_U_RND_W", e[e.I_C_C_COST_M_U_W = 442] = "I_C_C_COST_M_U_W", e[e.I_C_C_COST_N = 429] = "I_C_C_COST_N", e[e.I_C_C_COST_R = 430] = "I_C_C_COST_R", e[e.I_C_C_COST_RND = 433] = "I_C_C_COST_RND", e[e.I_C_C_COST_RND_A = 493] = "I_C_C_COST_RND_A", e[e.I_C_C_COST_RND_B = 436] = "I_C_C_COST_RND_B", e[e.I_C_C_COST_RND_H = 589] = "I_C_C_COST_RND_H", e[e.I_C_C_COST_RND_N = 434] = "I_C_C_COST_RND_N", e[e.I_C_C_COST_RND_R = 435] = "I_C_C_COST_RND_R", e[e.I_C_C_COST_RND_W = 437] = "I_C_C_COST_RND_W", e[e.I_C_C_COST_W = 432] = "I_C_C_COST_W", e[e.I_C_C_EARNED = 448] = "I_C_C_EARNED", e[e.I_C_C_E_T_C_AMOUNT = 552] = "I_C_C_E_T_C_AMOUNT", e[e.I_C_C_E_T_C_QTY = 551] = "I_C_C_E_T_C_QTY", e[e.I_C_C_QTY = 423] = "I_C_C_QTY", e[e.I_C_C_QTY_A = 495] = "I_C_C_QTY_A", e[e.I_C_C_QTY_B = 426] = "I_C_C_QTY_B", e[e.I_C_C_QTY_H = 591] = "I_C_C_QTY_H", e[e.I_C_C_QTY_N = 424] = "I_C_C_QTY_N", e[e.I_C_C_QTY_R = 425] = "I_C_C_QTY_R", e[e.I_C_C_QTY_W = 427] = "I_C_C_QTY_W", e[e.I_C_C_SCHED_AMOUNT = 617] = "I_C_C_SCHED_AMOUNT", e[e.I_C_C_SCHED_QTY = 618] = "I_C_C_SCHED_QTY", e[e.I_C_C_UNBILLED = 451] = "I_C_C_UNBILLED", e[e.I_C_C_WIP = 449] = "I_C_C_WIP", e[e.LABOR_ALLOC_AMOUNT = 526] = "LABOR_ALLOC_AMOUNT", e[e.LABOR_ALLOC_HRS = 525] = "LABOR_ALLOC_HRS", e[e.LABOR_BILLED = 392] = "LABOR_BILLED", e[e.LABOR_BILLED_DIRECT = 516] = "LABOR_BILLED_DIRECT", e[e.LABOR_BILLED_D_P_E_O_H = 517] = "LABOR_BILLED_D_P_E_O_H", e[e.LABOR_BILLED_FIXED_FEE = 519] = "LABOR_BILLED_FIXED_FEE", e[e.LABOR_BILLED_PROFIT = 518] = "LABOR_BILLED_PROFIT", e[e.LABOR_BUDGET = 560] = "LABOR_BUDGET", e[e.LABOR_BUDGET_P_A = 574] = "LABOR_BUDGET_P_A", e[e.LABOR_BUDGET_P_C = 561] = "LABOR_BUDGET_P_C", e[e.LABOR_CHANGE_ORDER_AMOUNT = 622] = "LABOR_CHANGE_ORDER_AMOUNT", e[e.LABOR_CHANGE_ORDER_HOURS = 621] = "LABOR_CHANGE_ORDER_HOURS", e[e.LABOR_COST_B_R = 362] = "LABOR_COST_B_R", e[e.LABOR_COST_B_R_A = 497] = "LABOR_COST_B_R_A", e[e.LABOR_COST_B_R_B = 380] = "LABOR_COST_B_R_B", e[e.LABOR_COST_B_R_H = 593] = "LABOR_COST_B_R_H", e[e.LABOR_COST_B_R_N = 368] = "LABOR_COST_B_R_N", e[e.LABOR_COST_B_R_R = 374] = "LABOR_COST_B_R_R", e[e.LABOR_COST_B_R_RND = 365] = "LABOR_COST_B_R_RND", e[e.LABOR_COST_B_R_RND_A = 496] = "LABOR_COST_B_R_RND_A", e[e.LABOR_COST_B_R_RND_B = 383] = "LABOR_COST_B_R_RND_B", e[e.LABOR_COST_B_R_RND_H = 592] = "LABOR_COST_B_R_RND_H", e[e.LABOR_COST_B_R_RND_N = 371] = "LABOR_COST_B_R_RND_N", e[e.LABOR_COST_B_R_RND_R = 377] = "LABOR_COST_B_R_RND_R", e[e.LABOR_COST_B_R_RND_W = 389] = "LABOR_COST_B_R_RND_W", e[e.LABOR_COST_B_R_W = 386] = "LABOR_COST_B_R_W", e[e.LABOR_COST_J_C = 361] = "LABOR_COST_J_C", e[e.LABOR_COST_J_C_A = 499] = "LABOR_COST_J_C_A", e[e.LABOR_COST_J_C_B = 379] = "LABOR_COST_J_C_B", e[e.LABOR_COST_J_C_H = 595] = "LABOR_COST_J_C_H", e[e.LABOR_COST_J_C_N = 367] = "LABOR_COST_J_C_N", e[e.LABOR_COST_J_C_R = 373] = "LABOR_COST_J_C_R", e[e.LABOR_COST_J_C_RND = 364] = "LABOR_COST_J_C_RND", e[e.LABOR_COST_J_C_RND_A = 498] = "LABOR_COST_J_C_RND_A", e[e.LABOR_COST_J_C_RND_B = 382] = "LABOR_COST_J_C_RND_B", e[e.LABOR_COST_J_C_RND_H = 594] = "LABOR_COST_J_C_RND_H", e[e.LABOR_COST_J_C_RND_N = 370] = "LABOR_COST_J_C_RND_N", e[e.LABOR_COST_J_C_RND_R = 376] = "LABOR_COST_J_C_RND_R", e[e.LABOR_COST_J_C_RND_W = 388] = "LABOR_COST_J_C_RND_W", e[e.LABOR_COST_J_C_W = 385] = "LABOR_COST_J_C_W", e[e.LABOR_COST_PAY = 360] = "LABOR_COST_PAY", e[e.LABOR_COST_PAY_A = 501] = "LABOR_COST_PAY_A", e[e.LABOR_COST_PAY_B = 378] = "LABOR_COST_PAY_B", e[e.LABOR_COST_PAY_H = 597] = "LABOR_COST_PAY_H", e[e.LABOR_COST_PAY_N = 366] = "LABOR_COST_PAY_N", e[e.LABOR_COST_PAY_R = 372] = "LABOR_COST_PAY_R", e[e.LABOR_COST_PAY_RND = 363] = "LABOR_COST_PAY_RND", e[e.LABOR_COST_PAY_RND_A = 500] = "LABOR_COST_PAY_RND_A", e[e.LABOR_COST_PAY_RND_B = 381] = "LABOR_COST_PAY_RND_B", e[e.LABOR_COST_PAY_RND_H = 596] = "LABOR_COST_PAY_RND_H", e[e.LABOR_COST_PAY_RND_N = 369] = "LABOR_COST_PAY_RND_N", e[e.LABOR_COST_PAY_RND_R = 375] = "LABOR_COST_PAY_RND_R", e[e.LABOR_COST_PAY_RND_W = 387] = "LABOR_COST_PAY_RND_W", e[e.LABOR_COST_PAY_W = 384] = "LABOR_COST_PAY_W", e[e.LABOR_EARNED = 390] = "LABOR_EARNED", e[e.LABOR_E_T_C_AMOUNT = 528] = "LABOR_E_T_C_AMOUNT", e[e.LABOR_E_T_C_HRS = 527] = "LABOR_E_T_C_HRS", e[e.LABOR_O_T_HRS_BILL = 343] = "LABOR_O_T_HRS_BILL", e[e.LABOR_O_T_HRS_BILL_A = 502] = "LABOR_O_T_HRS_BILL_A", e[e.LABOR_O_T_HRS_BILL_B = 355] = "LABOR_O_T_HRS_BILL_B", e[e.LABOR_O_T_HRS_BILL_H = 598] = "LABOR_O_T_HRS_BILL_H", e[e.LABOR_O_T_HRS_BILL_N = 347] = "LABOR_O_T_HRS_BILL_N", e[e.LABOR_O_T_HRS_BILL_R = 351] = "LABOR_O_T_HRS_BILL_R", e[e.LABOR_O_T_HRS_BILL_W = 359] = "LABOR_O_T_HRS_BILL_W", e[e.LABOR_O_T_HRS_WORK = 341] = "LABOR_O_T_HRS_WORK", e[e.LABOR_O_T_HRS_WORK_A = 503] = "LABOR_O_T_HRS_WORK_A", e[e.LABOR_O_T_HRS_WORK_B = 353] = "LABOR_O_T_HRS_WORK_B", e[e.LABOR_O_T_HRS_WORK_H = 599] = "LABOR_O_T_HRS_WORK_H", e[e.LABOR_O_T_HRS_WORK_N = 345] = "LABOR_O_T_HRS_WORK_N", e[e.LABOR_O_T_HRS_WORK_R = 349] = "LABOR_O_T_HRS_WORK_R", e[e.LABOR_O_T_HRS_WORK_W = 357] = "LABOR_O_T_HRS_WORK_W", e[e.LABOR_REG_HRS_BILL = 342] = "LABOR_REG_HRS_BILL", e[e.LABOR_REG_HRS_BILL_A = 504] = "LABOR_REG_HRS_BILL_A", e[e.LABOR_REG_HRS_BILL_B = 354] = "LABOR_REG_HRS_BILL_B", e[e.LABOR_REG_HRS_BILL_H = 600] = "LABOR_REG_HRS_BILL_H", e[e.LABOR_REG_HRS_BILL_N = 346] = "LABOR_REG_HRS_BILL_N", e[e.LABOR_REG_HRS_BILL_R = 350] = "LABOR_REG_HRS_BILL_R", e[e.LABOR_REG_HRS_BILL_W = 358] = "LABOR_REG_HRS_BILL_W", e[e.LABOR_REG_HRS_WORK = 340] = "LABOR_REG_HRS_WORK", e[e.LABOR_REG_HRS_WORK_A = 505] = "LABOR_REG_HRS_WORK_A", e[e.LABOR_REG_HRS_WORK_B = 352] = "LABOR_REG_HRS_WORK_B", e[e.LABOR_REG_HRS_WORK_H = 601] = "LABOR_REG_HRS_WORK_H", e[e.LABOR_REG_HRS_WORK_N = 344] = "LABOR_REG_HRS_WORK_N", e[e.LABOR_REG_HRS_WORK_R = 348] = "LABOR_REG_HRS_WORK_R", e[e.LABOR_REG_HRS_WORK_W = 356] = "LABOR_REG_HRS_WORK_W", e[e.LABOR_SCHED_AMOUNT = 614] = "LABOR_SCHED_AMOUNT", e[e.LABOR_UNBILLED = 393] = "LABOR_UNBILLED", e[e.LABOR_WIP = 391] = "LABOR_WIP", e[e.LATE_FEE = 336] = "LATE_FEE", e[e.O_C_C_ALLOC_AMOUNT = 542] = "O_C_C_ALLOC_AMOUNT", e[e.O_C_C_ALLOC_QTY = 541] = "O_C_C_ALLOC_QTY", e[e.O_C_C_BILLED = 479] = "O_C_C_BILLED", e[e.O_C_C_BILLED_DIRECT = 522] = "O_C_C_BILLED_DIRECT", e[e.O_C_C_BILLED_MARKUP = 523] = "O_C_C_BILLED_MARKUP", e[e.O_C_C_BUDGET = 566] = "O_C_C_BUDGET", e[e.O_C_C_BUDGET_P_A = 580] = "O_C_C_BUDGET_P_A", e[e.O_C_C_BUDGET_P_C = 571] = "O_C_C_BUDGET_P_C", e[e.O_C_C_CHANGE_ORDER_AMOUNT = 624] = "O_C_C_CHANGE_ORDER_AMOUNT", e[e.O_C_C_COST = 457] = "O_C_C_COST", e[e.O_C_C_COST_A = 509] = "O_C_C_COST_A", e[e.O_C_C_COST_B = 460] = "O_C_C_COST_B", e[e.O_C_C_COST_H = 605] = "O_C_C_COST_H", e[e.O_C_C_COST_M_U = 467] = "O_C_C_COST_M_U", e[e.O_C_C_COST_M_U_A = 507] = "O_C_C_COST_M_U_A", e[e.O_C_C_COST_M_U_B = 470] = "O_C_C_COST_M_U_B", e[e.O_C_C_COST_M_U_H = 603] = "O_C_C_COST_M_U_H", e[e.O_C_C_COST_M_U_N = 468] = "O_C_C_COST_M_U_N", e[e.O_C_C_COST_M_U_R = 469] = "O_C_C_COST_M_U_R", e[e.O_C_C_COST_M_U_RND = 472] = "O_C_C_COST_M_U_RND", e[e.O_C_C_COST_M_U_RND_A = 506] = "O_C_C_COST_M_U_RND_A", e[e.O_C_C_COST_M_U_RND_B = 475] = "O_C_C_COST_M_U_RND_B", e[e.O_C_C_COST_M_U_RND_H = 602] = "O_C_C_COST_M_U_RND_H", e[e.O_C_C_COST_M_U_RND_N = 473] = "O_C_C_COST_M_U_RND_N", e[e.O_C_C_COST_M_U_RND_R = 474] = "O_C_C_COST_M_U_RND_R", e[e.O_C_C_COST_M_U_RND_W = 476] = "O_C_C_COST_M_U_RND_W", e[e.O_C_C_COST_M_U_W = 471] = "O_C_C_COST_M_U_W", e[e.O_C_C_COST_N = 458] = "O_C_C_COST_N", e[e.O_C_C_COST_R = 459] = "O_C_C_COST_R", e[e.O_C_C_COST_RND = 462] = "O_C_C_COST_RND", e[e.O_C_C_COST_RND_A = 508] = "O_C_C_COST_RND_A", e[e.O_C_C_COST_RND_B = 465] = "O_C_C_COST_RND_B", e[e.O_C_C_COST_RND_H = 604] = "O_C_C_COST_RND_H", e[e.O_C_C_COST_RND_N = 463] = "O_C_C_COST_RND_N", e[e.O_C_C_COST_RND_R = 464] = "O_C_C_COST_RND_R", e[e.O_C_C_COST_RND_W = 466] = "O_C_C_COST_RND_W", e[e.O_C_C_COST_W = 461] = "O_C_C_COST_W", e[e.O_C_C_EARNED = 477] = "O_C_C_EARNED", e[e.O_C_C_E_T_C_AMOUNT = 544] = "O_C_C_E_T_C_AMOUNT", e[e.O_C_C_E_T_C_QTY = 543] = "O_C_C_E_T_C_QTY", e[e.O_C_C_QTY = 452] = "O_C_C_QTY", e[e.O_C_C_QTY_A = 510] = "O_C_C_QTY_A", e[e.O_C_C_QTY_B = 455] = "O_C_C_QTY_B", e[e.O_C_C_QTY_H = 606] = "O_C_C_QTY_H", e[e.O_C_C_QTY_N = 453] = "O_C_C_QTY_N", e[e.O_C_C_QTY_R = 454] = "O_C_C_QTY_R", e[e.O_C_C_QTY_W = 456] = "O_C_C_QTY_W", e[e.O_C_C_SCHED_AMOUNT = 616] = "O_C_C_SCHED_AMOUNT", e[e.O_C_C_SCHED_QTY = 619] = "O_C_C_SCHED_QTY", e[e.O_C_C_UNBILLED = 480] = "O_C_C_UNBILLED", e[e.O_C_C_WIP = 478] = "O_C_C_WIP", e[e.O_D_C_ALLOC_AMOUNT = 534] = "O_D_C_ALLOC_AMOUNT", e[e.O_D_C_ALLOC_QTY = 533] = "O_D_C_ALLOC_QTY", e[e.O_D_C_BILLED = 421] = "O_D_C_BILLED", e[e.O_D_C_BILLED_DIRECT = 520] = "O_D_C_BILLED_DIRECT", e[e.O_D_C_BILLED_MARKUP = 521] = "O_D_C_BILLED_MARKUP", e[e.O_D_C_BUDGET = 564] = "O_D_C_BUDGET", e[e.O_D_C_BUDGET_P_A = 576] = "O_D_C_BUDGET_P_A", e[e.O_D_C_BUDGET_P_C = 570] = "O_D_C_BUDGET_P_C", e[e.O_D_C_CHANGE_ORDER_AMOUNT = 623] = "O_D_C_CHANGE_ORDER_AMOUNT", e[e.O_D_C_COST = 399] = "O_D_C_COST", e[e.O_D_C_COST_A = 514] = "O_D_C_COST_A", e[e.O_D_C_COST_B = 402] = "O_D_C_COST_B", e[e.O_D_C_COST_H = 610] = "O_D_C_COST_H", e[e.O_D_C_COST_M_U = 409] = "O_D_C_COST_M_U", e[e.O_D_C_COST_M_U_A = 512] = "O_D_C_COST_M_U_A", e[e.O_D_C_COST_M_U_B = 412] = "O_D_C_COST_M_U_B", e[e.O_D_C_COST_M_U_H = 608] = "O_D_C_COST_M_U_H", e[e.O_D_C_COST_M_U_N = 410] = "O_D_C_COST_M_U_N", e[e.O_D_C_COST_M_U_R = 411] = "O_D_C_COST_M_U_R", e[e.O_D_C_COST_M_U_RND = 414] = "O_D_C_COST_M_U_RND", e[e.O_D_C_COST_M_U_RND_A = 511] = "O_D_C_COST_M_U_RND_A", e[e.O_D_C_COST_M_U_RND_B = 417] = "O_D_C_COST_M_U_RND_B", e[e.O_D_C_COST_M_U_RND_H = 607] = "O_D_C_COST_M_U_RND_H", e[e.O_D_C_COST_M_U_RND_N = 415] = "O_D_C_COST_M_U_RND_N", e[e.O_D_C_COST_M_U_RND_R = 416] = "O_D_C_COST_M_U_RND_R", e[e.O_D_C_COST_M_U_RND_W = 418] = "O_D_C_COST_M_U_RND_W", e[e.O_D_C_COST_M_U_W = 413] = "O_D_C_COST_M_U_W", e[e.O_D_C_COST_N = 400] = "O_D_C_COST_N", e[e.O_D_C_COST_R = 401] = "O_D_C_COST_R", e[e.O_D_C_COST_RND = 404] = "O_D_C_COST_RND", e[e.O_D_C_COST_RND_A = 513] = "O_D_C_COST_RND_A", e[e.O_D_C_COST_RND_B = 407] = "O_D_C_COST_RND_B", e[e.O_D_C_COST_RND_H = 609] = "O_D_C_COST_RND_H", e[e.O_D_C_COST_RND_N = 405] = "O_D_C_COST_RND_N", e[e.O_D_C_COST_RND_R = 406] = "O_D_C_COST_RND_R", e[e.O_D_C_COST_RND_W = 408] = "O_D_C_COST_RND_W", e[e.O_D_C_COST_W = 403] = "O_D_C_COST_W", e[e.O_D_C_EARNED = 419] = "O_D_C_EARNED", e[e.O_D_C_E_T_C_AMOUNT = 536] = "O_D_C_E_T_C_AMOUNT", e[e.O_D_C_E_T_C_QTY = 535] = "O_D_C_E_T_C_QTY", e[e.O_D_C_QTY = 394] = "O_D_C_QTY", e[e.O_D_C_QTY_A = 515] = "O_D_C_QTY_A", e[e.O_D_C_QTY_B = 397] = "O_D_C_QTY_B", e[e.O_D_C_QTY_H = 611] = "O_D_C_QTY_H", e[e.O_D_C_QTY_N = 395] = "O_D_C_QTY_N", e[e.O_D_C_QTY_R = 396] = "O_D_C_QTY_R", e[e.O_D_C_QTY_W = 398] = "O_D_C_QTY_W", e[e.O_D_C_SCHED_AMOUNT = 615] = "O_D_C_SCHED_AMOUNT", e[e.O_D_C_SCHED_QTY = 620] = "O_D_C_SCHED_QTY", e[e.O_D_C_UNBILLED = 422] = "O_D_C_UNBILLED", e[e.O_D_C_WIP = 420] = "O_D_C_WIP", e[e.OTHER_BILLED = 631] = "OTHER_BILLED", e[e.PROJECT_D_P_E = 485] = "PROJECT_D_P_E", e[e.PROJECT_O_H = 486] = "PROJECT_O_H", e[e.RECVD = 335] = "RECVD", e[e.RETAINAGE = 339] = "RETAINAGE", e[e.RETAINER = 338] = "RETAINER", e[e.UNBILLED = 334] = "UNBILLED", e[e.WIP = 332] = "WIP";
    })(t16.ProjectReportAggregateEnum || (t16.ProjectReportAggregateEnum = {}));
  })(vM)), vM;
}
var mM = {}, xoe;
function xc0() {
  return xoe || (xoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectReportNonAggregateEnum = void 0, (function(e) {
      e[e.BILL_D_P_E_MULT = 2] = "BILL_D_P_E_MULT", e[e.BILL_O_H_MULT = 3] = "BILL_O_H_MULT", e[e.BILL_PR_MULT = 4] = "BILL_PR_MULT", e[e.BILL_RATE = 5] = "BILL_RATE", e[e.BILL_STATUS = 6] = "BILL_STATUS", e[e.CHARGE_ORG_CODE = 8] = "CHARGE_ORG_CODE", e[e.CHARGE_ORG_LONG_NAME = 7] = "CHARGE_ORG_LONG_NAME", e[e.CHARGE_ORG_NAME = 9] = "CHARGE_ORG_NAME", e[e.CHARGE_ORG_PATH = 10] = "CHARGE_ORG_PATH", e[e.CLIENT_CODE = 11] = "CLIENT_CODE", e[e.CLIENT_NAME = 12] = "CLIENT_NAME", e[e.COST_RATE = 13] = "COST_RATE", e[e.EXPENSE_CODE = 14] = "EXPENSE_CODE", e[e.EXPENSE_NAME = 15] = "EXPENSE_NAME", e[e.G_L_CODE = 16] = "G_L_CODE", e[e.G_L_NAME = 17] = "G_L_NAME", e[e.HOME_ORG_CODE = 51] = "HOME_ORG_CODE", e[e.HOME_ORG_LONG_NAME = 54] = "HOME_ORG_LONG_NAME", e[e.HOME_ORG_NAME = 52] = "HOME_ORG_NAME", e[e.HOME_ORG_PATH = 53] = "HOME_ORG_PATH", e[e.J_C_D_P_E_MULT = 19] = "J_C_D_P_E_MULT", e[e.J_C_O_H_MULT = 20] = "J_C_O_H_MULT", e[e.J_C_PR_MULT = 21] = "J_C_PR_MULT", e[e.JOB_COST_RATE = 22] = "JOB_COST_RATE", e[e.JOB_TITLE_CODE = 23] = "JOB_TITLE_CODE", e[e.JOB_TITLE_NAME = 24] = "JOB_TITLE_NAME", e[e.LABOR_CODE = 25] = "LABOR_CODE", e[e.LABOR_IS_HOURLY = 55] = "LABOR_IS_HOURLY", e[e.LABOR_NAME = 26] = "LABOR_NAME", e[e.LINE_I_D = 27] = "LINE_I_D", e[e.MASTER_CODE = 56] = "MASTER_CODE", e[e.MASTER_NAME = 28] = "MASTER_NAME", e[e.METRIC_TYPE = 29] = "METRIC_TYPE", e[e.ORG_CODE = 30] = "ORG_CODE", e[e.ORG_LONG_NAME = 31] = "ORG_LONG_NAME", e[e.ORG_NAME = 32] = "ORG_NAME", e[e.ORG_PATH = 33] = "ORG_PATH", e[e.P_E_DATE = 57] = "P_E_DATE", e[e.PERIODCODE = 35] = "PERIODCODE", e[e.P_M_COMMENTS = 36] = "P_M_COMMENTS", e[e.P_M_TYPECODE = 37] = "P_M_TYPECODE", e[e.P_M_TYPENAME = 38] = "P_M_TYPENAME", e[e.P_M_TYPE_ORDER = 39] = "P_M_TYPE_ORDER", e[e.PRINCIPAL = 40] = "PRINCIPAL", e[e.PRJ_ACCT = 41] = "PRJ_ACCT", e[e.PRJ_MGR = 42] = "PRJ_MGR", e[e.SOURCE = 43] = "SOURCE", e[e.TIME_P_E_DATE = 59] = "TIME_P_E_DATE", e[e.TIME_P_S_DATE = 58] = "TIME_P_S_DATE", e[e.TRANS_CODE = 44] = "TRANS_CODE", e[e.TRANSDATE = 45] = "TRANSDATE", e[e.TRANS_I_D = 46] = "TRANS_I_D", e[e.UNIT_BILL = 47] = "UNIT_BILL", e[e.UNIT_COST = 48] = "UNIT_COST", e[e.UNIT_MARKUP = 49] = "UNIT_MARKUP";
    })(t16.ProjectReportNonAggregateEnum || (t16.ProjectReportNonAggregateEnum = {}));
  })(mM)), mM;
}
var RM = {}, Uoe;
function Uc0() {
  return Uoe || (Uoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectReportTypeEnum = void 0, (function(e) {
      e[e.COMMERICAL = 1] = "COMMERICAL", e[e.RESIDENTIAL = 2] = "RESIDENTIAL", e[e.ENVIRONMENTAL = 3] = "ENVIRONMENTAL", e[e.MEDICAL = 4] = "MEDICAL", e[e.OFFICE_BUILDING = 5] = "OFFICE_BUILDING", e[e.SPORTS_AND_RECREATION = 6] = "SPORTS_AND_RECREATION", e[e.TRANSPORTATION = 7] = "TRANSPORTATION", e[e.GOVERNMENT = 8] = "GOVERNMENT";
    })(t16.ProjectReportTypeEnum || (t16.ProjectReportTypeEnum = {}));
  })(RM)), RM;
}
var qM = {}, koe;
function kc0() {
  return koe || (koe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ProjectRoleEnum = void 0, (function(e) {
      e[e.ENGINEER = 2] = "ENGINEER", e[e.DESIGNER = 3] = "DESIGNER", e[e.BILLING_MANAGER = 4] = "BILLING_MANAGER";
    })(t16.ProjectRoleEnum || (t16.ProjectRoleEnum = {}));
  })(qM)), qM;
}
var TM = {}, joe;
function jc0() {
  return joe || (joe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ReportTypeEnum = void 0, (function(e) {
      e[e.SIMPLE = 1] = "SIMPLE", e[e.INTERMEDIATE = 2] = "INTERMEDIATE", e[e.ADVANCED = 3] = "ADVANCED";
    })(t16.ReportTypeEnum || (t16.ReportTypeEnum = {}));
  })(TM)), TM;
}
var yM = {}, Foe;
function Fc0() {
  return Foe || (Foe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.RevenueLevelEnum = void 0, (function(e) {
      e[e.THIS_NODE = 1] = "THIS_NODE", e[e.ONE_LEVEL_DOWN = 2] = "ONE_LEVEL_DOWN", e[e.BOTTOM_NODES = 3] = "BOTTOM_NODES";
    })(t16.RevenueLevelEnum || (t16.RevenueLevelEnum = {}));
  })(yM)), yM;
}
var SM = {}, Voe;
function Vc0() {
  return Voe || (Voe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.RevenueTypeEnum = void 0, (function(e) {
      e[e.FIXED_FEE = 1] = "FIXED_FEE", e[e.LABOR = 2] = "LABOR", e[e.OTHER_DIRECT_CHARGES = 3] = "OTHER_DIRECT_CHARGES", e[e.OUT_OF_CONTRACT_CONSULTANTS = 4] = "OUT_OF_CONTRACT_CONSULTANTS", e[e.IN_CONTRACT_CONSULTANTS = 5] = "IN_CONTRACT_CONSULTANTS", e[e.RETAINER = 6] = "RETAINER", e[e.RETAINAGE = 7] = "RETAINAGE", e[e.BAD_DEBT = 8] = "BAD_DEBT", e[e.OTHER_REVENUE = 9] = "OTHER_REVENUE", e[e.LATE_FEE = 10] = "LATE_FEE";
    })(t16.RevenueTypeEnum || (t16.RevenueTypeEnum = {}));
  })(SM)), SM;
}
var CM = {}, Hoe;
function Hc0() {
  return Hoe || (Hoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.SchedulingLoadMethodEnum = void 0, (function(e) {
      e[e.FRONT_LOAD = 1] = "FRONT_LOAD", e[e.BACK_LOAD = 2] = "BACK_LOAD", e[e.STRAIGHT_LINE = 3] = "STRAIGHT_LINE", e[e.BELL = 4] = "BELL", e[e.INVERSE_BELL = 5] = "INVERSE_BELL";
    })(t16.SchedulingLoadMethodEnum || (t16.SchedulingLoadMethodEnum = {}));
  })(CM)), CM;
}
var gM = {}, Xoe;
function Xc0() {
  return Xoe || (Xoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.SocialTypeEnum = void 0, (function(e) {
      e[e.DANCING = 1] = "DANCING", e[e.WINE_TASTING = 2] = "WINE_TASTING", e[e.BRIDGE = 3] = "BRIDGE";
    })(t16.SocialTypeEnum || (t16.SocialTypeEnum = {}));
  })(gM)), gM;
}
var IM = {}, $oe;
function $c0() {
  return $oe || ($oe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.SportTypeEnum = void 0, (function(e) {
      e[e.BASEBALL = 1] = "BASEBALL", e[e.BASKETBALL = 2] = "BASKETBALL", e[e.SOCCER = 3] = "SOCCER", e[e.FOOTBALL = 4] = "FOOTBALL", e[e.TENNIS = 5] = "TENNIS", e[e.GOLF = 6] = "GOLF", e[e.WATER_POLO = 7] = "WATER_POLO";
    })(t16.SportTypeEnum || (t16.SportTypeEnum = {}));
  })(IM)), IM;
}
var EM = {}, Goe;
function Gc0() {
  return Goe || (Goe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.StandardReportTypeEnum = void 0, (function(e) {
      e[e.ACCOUNTS_RECEIVABLE_REPORTS = 1] = "ACCOUNTS_RECEIVABLE_REPORTS", e[e.BANK_RECONCILIATION = 39] = "BANK_RECONCILIATION", e[e.VENDOR_LIST = 33] = "VENDOR_LIST", e[e.PROJECT_LIST = 34] = "PROJECT_LIST", e[e.CHART_OF_ACCOUNT = 35] = "CHART_OF_ACCOUNT", e[e.CREDIT_CARD_RECONCILIATION = 51] = "CREDIT_CARD_RECONCILIATION", e[e.AP_EFT = 52] = "AP_EFT", e[e.ER_EFT = 53] = "ER_EFT", e[e.ACCOUNTS_PAYABLE_REPORTS = 2] = "ACCOUNTS_PAYABLE_REPORTS", e[e.GENERAL_LEDGER_REPORTS = 3] = "GENERAL_LEDGER_REPORTS", e[e.PURCHASE_JOURNAL_REPORTS = 4] = "PURCHASE_JOURNAL_REPORTS", e[e.DISBURSEMENT_JOURNAL_REPORTS = 5] = "DISBURSEMENT_JOURNAL_REPORTS", e[e.SALES_JOURNAL_REPORTS = 6] = "SALES_JOURNAL_REPORTS", e[e.RECEIPT_JOURNAL_REPORTS = 7] = "RECEIPT_JOURNAL_REPORTS", e[e.EMPLOYEE_REIMBURSABLE_JOURNAL_REPORTS = 8] = "EMPLOYEE_REIMBURSABLE_JOURNAL_REPORTS", e[e.GENERAL_JOURNAL_REPORTS = 10] = "GENERAL_JOURNAL_REPORTS", e[e.AP_CHECK = 11] = "AP_CHECK", e[e.ER_CHECK = 12] = "ER_CHECK", e[e.AP_CHECK_LABELS = 13] = "AP_CHECK_LABELS", e[e.AP_LONG_STUBS = 14] = "AP_LONG_STUBS", e[e.ER_CHECK_LABELS = 15] = "ER_CHECK_LABELS", e[e.ER_LONG_STUBS = 16] = "ER_LONG_STUBS", e[e.INVOICE_LABELS = 17] = "INVOICE_LABELS", e[e.TIME_UTILIZATION_REPORTS_HOURS = 18] = "TIME_UTILIZATION_REPORTS_HOURS", e[e.TIME_UTILIZATION_REPORTS_DOLLARS = 23] = "TIME_UTILIZATION_REPORTS_DOLLARS", e[e.FORM1099 = 24] = "FORM1099", e[e.FORM1099_LABELS = 25] = "FORM1099_LABELS", e[e.TRIAL_BALANCE_REPORTS = 22] = "TRIAL_BALANCE_REPORTS", e[e.MANUAL_CHECK = 27] = "MANUAL_CHECK", e[e.TIME_SHEET = 28] = "TIME_SHEET", e[e.EXPENSE_SHEET = 29] = "EXPENSE_SHEET", e[e.DATA_DICTIONARY = 30] = "DATA_DICTIONARY", e[e.WORK_ORDER_REPORTS = 36] = "WORK_ORDER_REPORTS", e[e.TIME_TRANSACTIONS_HOURS = 37] = "TIME_TRANSACTIONS_HOURS", e[e.TIME_TRANSACTIONS_DOLLARS = 38] = "TIME_TRANSACTIONS_DOLLARS", e[e.EMPLOYEE_LIST = 31] = "EMPLOYEE_LIST", e[e.CLIENT_LIST = 32] = "CLIENT_LIST", e[e.CROSS_CHARGE_REPORTS = 40] = "CROSS_CHARGE_REPORTS", e[e.OH_SCRIPT_RESULTS = 41] = "OH_SCRIPT_RESULTS", e[e.BALANCE_SHEETS = 44] = "BALANCE_SHEETS", e[e.INCOME_STATEMENTS = 45] = "INCOME_STATEMENTS", e[e.LABOR_POSTINGS = 46] = "LABOR_POSTINGS", e[e.LINKED_TRANSACTIONS = 47] = "LINKED_TRANSACTIONS", e[e.EMPLOYEE_REIMBURSABLE_REPORTS = 48] = "EMPLOYEE_REIMBURSABLE_REPORTS", e[e.PREBILL = 49] = "PREBILL", e[e.PROJECT_PLANNING = 50] = "PROJECT_PLANNING", e[e.PURCHASE_ORDER = 54] = "PURCHASE_ORDER";
    })(t16.StandardReportTypeEnum || (t16.StandardReportTypeEnum = {}));
  })(EM)), EM;
}
var LM = {}, Yoe;
function Yc0() {
  return Yoe || (Yoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.SubLedgerTypeEnum = void 0, (function(e) {
      e[e.BANK = 1] = "BANK", e[e.ACCOUNTS_RECEIVABLE = 2] = "ACCOUNTS_RECEIVABLE", e[e.ACCOUNTS_PAYABLE = 3] = "ACCOUNTS_PAYABLE", e[e.EMPLOYEE_REIMBURSABLE = 4] = "EMPLOYEE_REIMBURSABLE";
    })(t16.SubLedgerTypeEnum || (t16.SubLedgerTypeEnum = {}));
  })(LM)), LM;
}
var PM = {}, Joe;
function Jc0() {
  return Joe || (Joe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.TimesheetCycleTypeEnum = void 0, (function(e) {
      e[e.WEEKLY = 1] = "WEEKLY", e[e.BI_WEEKLY = 2] = "BI_WEEKLY", e[e.SEMI_MONTHLY = 3] = "SEMI_MONTHLY", e[e.DAILY = 4] = "DAILY";
    })(t16.TimesheetCycleTypeEnum || (t16.TimesheetCycleTypeEnum = {}));
  })(PM)), PM;
}
var DM = {}, Koe;
function Kc0() {
  return Koe || (Koe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.UDFFieldTypeEnum = void 0, (function(e) {
      e[e.CHARACTER = 1] = "CHARACTER", e[e.INTEGER = 2] = "INTEGER", e[e.NUMERIC = 3] = "NUMERIC", e[e.BOOLEAN = 4] = "BOOLEAN", e[e.DATE = 5] = "DATE", e[e.DATE_TIME = 6] = "DATE_TIME", e[e.LONG_TEXT = 20] = "LONG_TEXT", e[e.BILL_STATUS = 15] = "BILL_STATUS", e[e.CLIENT = 12] = "CLIENT", e[e.EMPLOYEE = 11] = "EMPLOYEE", e[e.EXPENSE_CODE = 18] = "EXPENSE_CODE", e[e.GL_BASE_CODE = 14] = "GL_BASE_CODE", e[e.LABOR_CODE = 17] = "LABOR_CODE", e[e.ORG_UNIT = 16] = "ORG_UNIT", e[e.PROJECT = 10] = "PROJECT", e[e.VENDOR = 13] = "VENDOR", e[e.GRIDGET = 21] = "GRIDGET";
    })(t16.UDFFieldTypeEnum || (t16.UDFFieldTypeEnum = {}));
  })(DM)), DM;
}
var WM = {}, Qoe;
function Qc0() {
  return Qoe || (Qoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.UDFTableTypeEnum = void 0, (function(e) {
      e[e.CLIENTS = 1] = "CLIENTS", e[e.PROJECTS = 2] = "PROJECTS", e[e.PROJECT_LEVEL2 = 12] = "PROJECT_LEVEL2", e[e.EMPLOYEES = 6] = "EMPLOYEES", e[e.VENDORS = 7] = "VENDORS", e[e.CONTACTS = 8] = "CONTACTS";
    })(t16.UDFTableTypeEnum || (t16.UDFTableTypeEnum = {}));
  })(WM)), WM;
}
var NM = {}, Zoe;
function Zc0() {
  return Zoe || (Zoe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.UnitTypeEnum = void 0, (function(e) {
      e[e.EACH = 1] = "EACH", e[e.PER_DAY = 2] = "PER_DAY";
    })(t16.UnitTypeEnum || (t16.UnitTypeEnum = {}));
  })(NM)), NM;
}
var wM = {}, eie;
function el0() {
  return eie || (eie = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.UserTypeEnum = void 0, (function(e) {
      e[e.EMPLOYEE = 1] = "EMPLOYEE";
    })(t16.UserTypeEnum || (t16.UserTypeEnum = {}));
  })(wM)), wM;
}
var BM = {}, tie;
function tl0() {
  return tie || (tie = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.VendorQueryTypeEnum = void 0, (function(e) {
      e[e.PRIVATE = 2] = "PRIVATE", e[e.PERSONAL = 3] = "PERSONAL", e[e.PUBLIC = 4] = "PUBLIC";
    })(t16.VendorQueryTypeEnum || (t16.VendorQueryTypeEnum = {}));
  })(BM)), BM;
}
var xM = {}, rie;
function rl0() {
  return rie || (rie = 1, Object.defineProperty(xM, "__esModule", { value: true })), xM;
}
var UM = {}, nie;
function nl0() {
  return nie || (nie = 1, Object.defineProperty(UM, "__esModule", { value: true })), UM;
}
var kM = {}, aie;
function al0() {
  return aie || (aie = 1, Object.defineProperty(kM, "__esModule", { value: true })), kM;
}
var jM = {}, oie;
function ol0() {
  return oie || (oie = 1, Object.defineProperty(jM, "__esModule", { value: true })), jM;
}
var FM = {}, iie;
function il0() {
  return iie || (iie = 1, Object.defineProperty(FM, "__esModule", { value: true })), FM;
}
var VM = {}, uie;
function ul0() {
  return uie || (uie = 1, Object.defineProperty(VM, "__esModule", { value: true })), VM;
}
var HM = {}, sie;
function sl0() {
  return sie || (sie = 1, Object.defineProperty(HM, "__esModule", { value: true })), HM;
}
var XM = {}, cie;
function cl0() {
  return cie || (cie = 1, Object.defineProperty(XM, "__esModule", { value: true })), XM;
}
var $M = {}, lie;
function ll0() {
  return lie || (lie = 1, Object.defineProperty($M, "__esModule", { value: true })), $M;
}
var GM = {}, pie;
function pl0() {
  return pie || (pie = 1, Object.defineProperty(GM, "__esModule", { value: true })), GM;
}
var YM = {}, die;
function dl0() {
  return die || (die = 1, Object.defineProperty(YM, "__esModule", { value: true })), YM;
}
var JM = {}, fie;
function fl0() {
  return fie || (fie = 1, Object.defineProperty(JM, "__esModule", { value: true })), JM;
}
var KM = {}, bie;
function bl0() {
  return bie || (bie = 1, Object.defineProperty(KM, "__esModule", { value: true })), KM;
}
var QM = {}, Mie;
function Ml0() {
  return Mie || (Mie = 1, Object.defineProperty(QM, "__esModule", { value: true })), QM;
}
var ZM = {}, Oie;
function Ol0() {
  return Oie || (Oie = 1, Object.defineProperty(ZM, "__esModule", { value: true })), ZM;
}
var eO = {}, zie;
function zl0() {
  return zie || (zie = 1, Object.defineProperty(eO, "__esModule", { value: true })), eO;
}
var tO = {}, Aie;
function Al0() {
  return Aie || (Aie = 1, Object.defineProperty(tO, "__esModule", { value: true })), tO;
}
var rO = {}, _ie;
function _l0() {
  return _ie || (_ie = 1, Object.defineProperty(rO, "__esModule", { value: true })), rO;
}
var nO = {}, hie;
function hl0() {
  return hie || (hie = 1, Object.defineProperty(nO, "__esModule", { value: true })), nO;
}
var aO = {}, vie;
function vl0() {
  return vie || (vie = 1, Object.defineProperty(aO, "__esModule", { value: true })), aO;
}
var oO = {}, mie;
function ml0() {
  return mie || (mie = 1, Object.defineProperty(oO, "__esModule", { value: true })), oO;
}
var iO = {}, Rie;
function Rl0() {
  return Rie || (Rie = 1, Object.defineProperty(iO, "__esModule", { value: true })), iO;
}
var uO = {}, qie;
function ql0() {
  return qie || (qie = 1, Object.defineProperty(uO, "__esModule", { value: true })), uO;
}
var sO = {}, Tie;
function Tl0() {
  return Tie || (Tie = 1, Object.defineProperty(sO, "__esModule", { value: true })), sO;
}
var cO = {}, yie;
function yl0() {
  return yie || (yie = 1, Object.defineProperty(cO, "__esModule", { value: true })), cO;
}
var lO = {}, Sie;
function Sl0() {
  return Sie || (Sie = 1, Object.defineProperty(lO, "__esModule", { value: true })), lO;
}
var pO = {}, Cie;
function Cl0() {
  return Cie || (Cie = 1, Object.defineProperty(pO, "__esModule", { value: true })), pO;
}
var dO = {}, gie;
function gl0() {
  return gie || (gie = 1, Object.defineProperty(dO, "__esModule", { value: true })), dO;
}
var fO = {}, Iie;
function Il0() {
  return Iie || (Iie = 1, Object.defineProperty(fO, "__esModule", { value: true })), fO;
}
var bO = {}, Eie;
function El0() {
  return Eie || (Eie = 1, Object.defineProperty(bO, "__esModule", { value: true })), bO;
}
var MO = {}, Lie;
function Ll0() {
  return Lie || (Lie = 1, Object.defineProperty(MO, "__esModule", { value: true })), MO;
}
var OO = {}, Pie;
function Pl0() {
  return Pie || (Pie = 1, Object.defineProperty(OO, "__esModule", { value: true })), OO;
}
var zO = {}, Die;
function Dl0() {
  return Die || (Die = 1, Object.defineProperty(zO, "__esModule", { value: true })), zO;
}
var AO = {}, Wie;
function Wl0() {
  return Wie || (Wie = 1, Object.defineProperty(AO, "__esModule", { value: true })), AO;
}
var _O = {}, Nie;
function Nl0() {
  return Nie || (Nie = 1, Object.defineProperty(_O, "__esModule", { value: true })), _O;
}
var hO = {}, wie;
function wl0() {
  return wie || (wie = 1, Object.defineProperty(hO, "__esModule", { value: true })), hO;
}
var vO = {}, Bie;
function Bl0() {
  return Bie || (Bie = 1, Object.defineProperty(vO, "__esModule", { value: true })), vO;
}
var mO = {}, xie;
function xl0() {
  return xie || (xie = 1, Object.defineProperty(mO, "__esModule", { value: true })), mO;
}
var RO = {}, Uie;
function Ul0() {
  return Uie || (Uie = 1, Object.defineProperty(RO, "__esModule", { value: true })), RO;
}
var qO = {}, kie;
function kl0() {
  return kie || (kie = 1, Object.defineProperty(qO, "__esModule", { value: true })), qO;
}
var TO = {}, jie;
function jl0() {
  return jie || (jie = 1, Object.defineProperty(TO, "__esModule", { value: true })), TO;
}
var yO = {}, Fie;
function Fl0() {
  return Fie || (Fie = 1, Object.defineProperty(yO, "__esModule", { value: true })), yO;
}
var SO = {}, Vie;
function Vl0() {
  return Vie || (Vie = 1, Object.defineProperty(SO, "__esModule", { value: true })), SO;
}
var CO = {}, Hie;
function Hl0() {
  return Hie || (Hie = 1, Object.defineProperty(CO, "__esModule", { value: true })), CO;
}
var gO = {}, Xie;
function Xl0() {
  return Xie || (Xie = 1, Object.defineProperty(gO, "__esModule", { value: true })), gO;
}
var IO = {}, $ie;
function $l0() {
  return $ie || ($ie = 1, Object.defineProperty(IO, "__esModule", { value: true })), IO;
}
var EO = {}, Gie;
function Gl0() {
  return Gie || (Gie = 1, Object.defineProperty(EO, "__esModule", { value: true })), EO;
}
var LO = {}, Yie;
function Yl0() {
  return Yie || (Yie = 1, Object.defineProperty(LO, "__esModule", { value: true })), LO;
}
var PO = {}, Jie;
function Jl0() {
  return Jie || (Jie = 1, Object.defineProperty(PO, "__esModule", { value: true })), PO;
}
var DO = {}, Kie;
function Kl0() {
  return Kie || (Kie = 1, Object.defineProperty(DO, "__esModule", { value: true })), DO;
}
var WO = {}, Qie;
function Ql0() {
  return Qie || (Qie = 1, Object.defineProperty(WO, "__esModule", { value: true })), WO;
}
var NO = {}, Zie;
function Zl0() {
  return Zie || (Zie = 1, Object.defineProperty(NO, "__esModule", { value: true })), NO;
}
var wO = {}, eue;
function e20() {
  return eue || (eue = 1, Object.defineProperty(wO, "__esModule", { value: true })), wO;
}
var BO = {}, tue;
function t20() {
  return tue || (tue = 1, Object.defineProperty(BO, "__esModule", { value: true })), BO;
}
var xO = {}, rue;
function r20() {
  return rue || (rue = 1, Object.defineProperty(xO, "__esModule", { value: true })), xO;
}
var UO = {}, nue;
function n20() {
  return nue || (nue = 1, Object.defineProperty(UO, "__esModule", { value: true })), UO;
}
var kO = {}, aue;
function a20() {
  return aue || (aue = 1, Object.defineProperty(kO, "__esModule", { value: true })), kO;
}
var jO = {}, oue;
function o20() {
  return oue || (oue = 1, Object.defineProperty(jO, "__esModule", { value: true })), jO;
}
var FO = {}, iue;
function i20() {
  return iue || (iue = 1, Object.defineProperty(FO, "__esModule", { value: true })), FO;
}
var VO = {}, uue;
function u20() {
  return uue || (uue = 1, Object.defineProperty(VO, "__esModule", { value: true })), VO;
}
var HO = {}, sue;
function s20() {
  return sue || (sue = 1, Object.defineProperty(HO, "__esModule", { value: true })), HO;
}
var XO = {}, cue;
function c20() {
  return cue || (cue = 1, Object.defineProperty(XO, "__esModule", { value: true })), XO;
}
var $O = {}, lue;
function l20() {
  return lue || (lue = 1, Object.defineProperty($O, "__esModule", { value: true })), $O;
}
var GO = {}, pue;
function p20() {
  return pue || (pue = 1, Object.defineProperty(GO, "__esModule", { value: true })), GO;
}
var YO = {}, due;
function d20() {
  return due || (due = 1, Object.defineProperty(YO, "__esModule", { value: true })), YO;
}
var JO = {}, fue;
function f20() {
  return fue || (fue = 1, Object.defineProperty(JO, "__esModule", { value: true })), JO;
}
var KO = {}, bue;
function b20() {
  return bue || (bue = 1, Object.defineProperty(KO, "__esModule", { value: true })), KO;
}
var QO = {}, Mue;
function M20() {
  return Mue || (Mue = 1, Object.defineProperty(QO, "__esModule", { value: true })), QO;
}
var ZO = {}, Oue;
function O20() {
  return Oue || (Oue = 1, Object.defineProperty(ZO, "__esModule", { value: true })), ZO;
}
var e3 = {}, zue;
function z20() {
  return zue || (zue = 1, Object.defineProperty(e3, "__esModule", { value: true })), e3;
}
var t3 = {}, Aue;
function A20() {
  return Aue || (Aue = 1, Object.defineProperty(t3, "__esModule", { value: true })), t3;
}
var r3 = {}, _ue;
function _20() {
  return _ue || (_ue = 1, Object.defineProperty(r3, "__esModule", { value: true })), r3;
}
var n3 = {}, hue;
function h20() {
  return hue || (hue = 1, Object.defineProperty(n3, "__esModule", { value: true })), n3;
}
var a3 = {}, vue;
function v20() {
  return vue || (vue = 1, Object.defineProperty(a3, "__esModule", { value: true })), a3;
}
var o3 = {}, mue;
function m20() {
  return mue || (mue = 1, Object.defineProperty(o3, "__esModule", { value: true })), o3;
}
var i3 = {}, Rue;
function R20() {
  return Rue || (Rue = 1, Object.defineProperty(i3, "__esModule", { value: true })), i3;
}
var u3 = {}, que;
function q20() {
  return que || (que = 1, Object.defineProperty(u3, "__esModule", { value: true })), u3;
}
var s3 = {}, Tue;
function T20() {
  return Tue || (Tue = 1, Object.defineProperty(s3, "__esModule", { value: true })), s3;
}
var c3 = {}, yue;
function y20() {
  return yue || (yue = 1, Object.defineProperty(c3, "__esModule", { value: true })), c3;
}
var l3 = {}, Sue;
function S20() {
  return Sue || (Sue = 1, Object.defineProperty(l3, "__esModule", { value: true })), l3;
}
var p3 = {}, Cue;
function C20() {
  return Cue || (Cue = 1, Object.defineProperty(p3, "__esModule", { value: true })), p3;
}
var d3 = {}, gue;
function g20() {
  return gue || (gue = 1, Object.defineProperty(d3, "__esModule", { value: true })), d3;
}
var f3 = {}, Iue;
function I20() {
  return Iue || (Iue = 1, Object.defineProperty(f3, "__esModule", { value: true })), f3;
}
var b3 = {}, Eue;
function E20() {
  return Eue || (Eue = 1, Object.defineProperty(b3, "__esModule", { value: true })), b3;
}
var M3 = {}, Lue;
function L20() {
  return Lue || (Lue = 1, Object.defineProperty(M3, "__esModule", { value: true })), M3;
}
var O3 = {}, Pue;
function P20() {
  return Pue || (Pue = 1, Object.defineProperty(O3, "__esModule", { value: true })), O3;
}
var z3 = {}, Due;
function D20() {
  return Due || (Due = 1, Object.defineProperty(z3, "__esModule", { value: true })), z3;
}
var A3 = {}, Wue;
function W20() {
  return Wue || (Wue = 1, Object.defineProperty(A3, "__esModule", { value: true })), A3;
}
var _3 = {}, Nue;
function N20() {
  return Nue || (Nue = 1, Object.defineProperty(_3, "__esModule", { value: true })), _3;
}
var h3 = {}, wue;
function w20() {
  return wue || (wue = 1, Object.defineProperty(h3, "__esModule", { value: true })), h3;
}
var v3 = {}, Bue;
function B20() {
  return Bue || (Bue = 1, Object.defineProperty(v3, "__esModule", { value: true })), v3;
}
var m3 = {}, xue;
function x20() {
  return xue || (xue = 1, Object.defineProperty(m3, "__esModule", { value: true })), m3;
}
var R3 = {}, Uue;
function U20() {
  return Uue || (Uue = 1, Object.defineProperty(R3, "__esModule", { value: true })), R3;
}
var q3 = {}, kue;
function k20() {
  return kue || (kue = 1, Object.defineProperty(q3, "__esModule", { value: true })), q3;
}
var T3 = {}, jue;
function j20() {
  return jue || (jue = 1, Object.defineProperty(T3, "__esModule", { value: true })), T3;
}
var y3 = {}, Fue;
function F20() {
  return Fue || (Fue = 1, Object.defineProperty(y3, "__esModule", { value: true })), y3;
}
var S3 = {}, Vue;
function V20() {
  return Vue || (Vue = 1, Object.defineProperty(S3, "__esModule", { value: true })), S3;
}
var C3 = {}, Hue;
function H20() {
  return Hue || (Hue = 1, Object.defineProperty(C3, "__esModule", { value: true })), C3;
}
var g3 = {}, Xue;
function X20() {
  return Xue || (Xue = 1, Object.defineProperty(g3, "__esModule", { value: true })), g3;
}
var I3 = {}, $ue;
function $20() {
  return $ue || ($ue = 1, Object.defineProperty(I3, "__esModule", { value: true })), I3;
}
var E3 = {}, Gue;
function G20() {
  return Gue || (Gue = 1, Object.defineProperty(E3, "__esModule", { value: true })), E3;
}
var L3 = {}, Yue;
function Y20() {
  return Yue || (Yue = 1, Object.defineProperty(L3, "__esModule", { value: true })), L3;
}
var P3 = {}, Jue;
function J20() {
  return Jue || (Jue = 1, Object.defineProperty(P3, "__esModule", { value: true })), P3;
}
var D3 = {}, Kue;
function K20() {
  return Kue || (Kue = 1, Object.defineProperty(D3, "__esModule", { value: true })), D3;
}
var W3 = {}, Que;
function Q20() {
  return Que || (Que = 1, Object.defineProperty(W3, "__esModule", { value: true })), W3;
}
var N3 = {}, Zue;
function Z20() {
  return Zue || (Zue = 1, Object.defineProperty(N3, "__esModule", { value: true })), N3;
}
var w3 = {}, ese;
function ep0() {
  return ese || (ese = 1, Object.defineProperty(w3, "__esModule", { value: true })), w3;
}
var B3 = {}, tse;
function tp0() {
  return tse || (tse = 1, Object.defineProperty(B3, "__esModule", { value: true })), B3;
}
var x3 = {}, rse;
function rp0() {
  return rse || (rse = 1, Object.defineProperty(x3, "__esModule", { value: true })), x3;
}
var U3 = {}, nse;
function np0() {
  return nse || (nse = 1, Object.defineProperty(U3, "__esModule", { value: true })), U3;
}
var k3 = {}, ase;
function ap0() {
  return ase || (ase = 1, Object.defineProperty(k3, "__esModule", { value: true })), k3;
}
var j3 = {}, ose;
function op0() {
  return ose || (ose = 1, Object.defineProperty(j3, "__esModule", { value: true })), j3;
}
var F3 = {}, ise;
function ip0() {
  return ise || (ise = 1, Object.defineProperty(F3, "__esModule", { value: true })), F3;
}
var V3 = {}, use;
function up0() {
  return use || (use = 1, Object.defineProperty(V3, "__esModule", { value: true })), V3;
}
var H3 = {}, sse;
function sp0() {
  return sse || (sse = 1, Object.defineProperty(H3, "__esModule", { value: true })), H3;
}
var X3 = {}, cse;
function cp0() {
  return cse || (cse = 1, Object.defineProperty(X3, "__esModule", { value: true })), X3;
}
var $3 = {}, lse;
function lp0() {
  return lse || (lse = 1, Object.defineProperty($3, "__esModule", { value: true })), $3;
}
var G3 = {}, pse;
function pp0() {
  return pse || (pse = 1, Object.defineProperty(G3, "__esModule", { value: true })), G3;
}
var Y3 = {}, dse;
function dp0() {
  return dse || (dse = 1, Object.defineProperty(Y3, "__esModule", { value: true })), Y3;
}
var J3 = {}, fse;
function fp0() {
  return fse || (fse = 1, Object.defineProperty(J3, "__esModule", { value: true })), J3;
}
var K3 = {}, bse;
function bp0() {
  return bse || (bse = 1, Object.defineProperty(K3, "__esModule", { value: true })), K3;
}
var Q3 = {}, Mse;
function Mp0() {
  return Mse || (Mse = 1, Object.defineProperty(Q3, "__esModule", { value: true })), Q3;
}
var Z3 = {}, Ose;
function Op0() {
  return Ose || (Ose = 1, Object.defineProperty(Z3, "__esModule", { value: true })), Z3;
}
var ez = {}, zse;
function zp0() {
  return zse || (zse = 1, Object.defineProperty(ez, "__esModule", { value: true })), ez;
}
var tz = {}, Ase;
function Ap0() {
  return Ase || (Ase = 1, Object.defineProperty(tz, "__esModule", { value: true })), tz;
}
var rz = {}, _se;
function _p0() {
  return _se || (_se = 1, Object.defineProperty(rz, "__esModule", { value: true })), rz;
}
var nz = {}, hse;
function hp0() {
  return hse || (hse = 1, Object.defineProperty(nz, "__esModule", { value: true })), nz;
}
var az = {}, vse;
function vp0() {
  return vse || (vse = 1, Object.defineProperty(az, "__esModule", { value: true })), az;
}
var oz = {}, mse;
function mp0() {
  return mse || (mse = 1, Object.defineProperty(oz, "__esModule", { value: true })), oz;
}
var iz = {}, Rse;
function Rp0() {
  return Rse || (Rse = 1, Object.defineProperty(iz, "__esModule", { value: true })), iz;
}
var uz = {}, qse;
function qp0() {
  return qse || (qse = 1, Object.defineProperty(uz, "__esModule", { value: true })), uz;
}
var sz = {}, Tse;
function Tp0() {
  return Tse || (Tse = 1, Object.defineProperty(sz, "__esModule", { value: true })), sz;
}
var cz = {}, yse;
function yp0() {
  return yse || (yse = 1, Object.defineProperty(cz, "__esModule", { value: true })), cz;
}
var lz = {}, Sse;
function Sp0() {
  return Sse || (Sse = 1, Object.defineProperty(lz, "__esModule", { value: true })), lz;
}
var pz = {}, Cse;
function Cp0() {
  return Cse || (Cse = 1, Object.defineProperty(pz, "__esModule", { value: true })), pz;
}
var dz = {}, gse;
function gp0() {
  return gse || (gse = 1, Object.defineProperty(dz, "__esModule", { value: true })), dz;
}
var fz = {}, Ise;
function Ip0() {
  return Ise || (Ise = 1, Object.defineProperty(fz, "__esModule", { value: true })), fz;
}
var bz = {}, Ese;
function Ep0() {
  return Ese || (Ese = 1, Object.defineProperty(bz, "__esModule", { value: true })), bz;
}
var Mz = {}, Lse;
function Lp0() {
  return Lse || (Lse = 1, Object.defineProperty(Mz, "__esModule", { value: true })), Mz;
}
var Oz = {}, Pse;
function Pp0() {
  return Pse || (Pse = 1, Object.defineProperty(Oz, "__esModule", { value: true })), Oz;
}
var zz = {}, Dse;
function Dp0() {
  return Dse || (Dse = 1, Object.defineProperty(zz, "__esModule", { value: true })), zz;
}
var Az = {}, Wse;
function Wp0() {
  return Wse || (Wse = 1, Object.defineProperty(Az, "__esModule", { value: true })), Az;
}
var _z = {}, Nse;
function Np0() {
  return Nse || (Nse = 1, Object.defineProperty(_z, "__esModule", { value: true })), _z;
}
var hz = {}, wse;
function wp0() {
  return wse || (wse = 1, Object.defineProperty(hz, "__esModule", { value: true })), hz;
}
var vz = {}, Bse;
function Bp0() {
  return Bse || (Bse = 1, Object.defineProperty(vz, "__esModule", { value: true })), vz;
}
var mz = {}, xse;
function xp0() {
  return xse || (xse = 1, Object.defineProperty(mz, "__esModule", { value: true })), mz;
}
var Rz = {}, Use;
function Up0() {
  return Use || (Use = 1, Object.defineProperty(Rz, "__esModule", { value: true })), Rz;
}
var qz = {}, kse;
function kp0() {
  return kse || (kse = 1, Object.defineProperty(qz, "__esModule", { value: true })), qz;
}
var Tz = {}, jse;
function jp0() {
  return jse || (jse = 1, Object.defineProperty(Tz, "__esModule", { value: true })), Tz;
}
var yz = {}, Fse;
function Fp0() {
  return Fse || (Fse = 1, Object.defineProperty(yz, "__esModule", { value: true })), yz;
}
var Sz = {}, Vse;
function Vp0() {
  return Vse || (Vse = 1, Object.defineProperty(Sz, "__esModule", { value: true })), Sz;
}
var Cz = {}, Hse;
function Hp0() {
  return Hse || (Hse = 1, Object.defineProperty(Cz, "__esModule", { value: true })), Cz;
}
var gz = {}, Xse;
function Xp0() {
  return Xse || (Xse = 1, Object.defineProperty(gz, "__esModule", { value: true })), gz;
}
var Iz = {}, $se;
function $p0() {
  return $se || ($se = 1, Object.defineProperty(Iz, "__esModule", { value: true })), Iz;
}
var Ez = {}, Gse;
function Gp0() {
  return Gse || (Gse = 1, Object.defineProperty(Ez, "__esModule", { value: true })), Ez;
}
var Lz = {}, Yse;
function Yp0() {
  return Yse || (Yse = 1, Object.defineProperty(Lz, "__esModule", { value: true })), Lz;
}
var Pz = {}, Jse;
function Jp0() {
  return Jse || (Jse = 1, Object.defineProperty(Pz, "__esModule", { value: true })), Pz;
}
var Dz = {}, Kse;
function Kp0() {
  return Kse || (Kse = 1, Object.defineProperty(Dz, "__esModule", { value: true })), Dz;
}
var Wz = {}, Qse;
function Qp0() {
  return Qse || (Qse = 1, Object.defineProperty(Wz, "__esModule", { value: true })), Wz;
}
var Nz = {}, Zse;
function Zp0() {
  return Zse || (Zse = 1, Object.defineProperty(Nz, "__esModule", { value: true })), Nz;
}
var wz = {}, ece;
function ed0() {
  return ece || (ece = 1, Object.defineProperty(wz, "__esModule", { value: true })), wz;
}
var Bz = {}, tce;
function td0() {
  return tce || (tce = 1, Object.defineProperty(Bz, "__esModule", { value: true })), Bz;
}
var xz = {}, rce;
function rd0() {
  return rce || (rce = 1, Object.defineProperty(xz, "__esModule", { value: true })), xz;
}
var Uz = {}, nce;
function nd0() {
  return nce || (nce = 1, Object.defineProperty(Uz, "__esModule", { value: true })), Uz;
}
var kz = {}, ace;
function ad0() {
  return ace || (ace = 1, Object.defineProperty(kz, "__esModule", { value: true })), kz;
}
var jz = {}, oce;
function od0() {
  return oce || (oce = 1, Object.defineProperty(jz, "__esModule", { value: true })), jz;
}
var Fz = {}, ice;
function id0() {
  return ice || (ice = 1, Object.defineProperty(Fz, "__esModule", { value: true })), Fz;
}
var Vz = {}, uce;
function ud0() {
  return uce || (uce = 1, Object.defineProperty(Vz, "__esModule", { value: true })), Vz;
}
var Hz = {}, sce;
function sd0() {
  return sce || (sce = 1, Object.defineProperty(Hz, "__esModule", { value: true })), Hz;
}
var Xz = {}, cce;
function cd0() {
  return cce || (cce = 1, Object.defineProperty(Xz, "__esModule", { value: true })), Xz;
}
var $z = {}, lce;
function ld0() {
  return lce || (lce = 1, Object.defineProperty($z, "__esModule", { value: true })), $z;
}
var Gz = {}, pce;
function pd0() {
  return pce || (pce = 1, Object.defineProperty(Gz, "__esModule", { value: true })), Gz;
}
var Yz = {}, dce;
function dd0() {
  return dce || (dce = 1, Object.defineProperty(Yz, "__esModule", { value: true })), Yz;
}
var Jz = {}, fce;
function fd0() {
  return fce || (fce = 1, Object.defineProperty(Jz, "__esModule", { value: true })), Jz;
}
var Kz = {}, bce;
function bd0() {
  return bce || (bce = 1, Object.defineProperty(Kz, "__esModule", { value: true })), Kz;
}
var Qz = {}, Mce;
function Md0() {
  return Mce || (Mce = 1, Object.defineProperty(Qz, "__esModule", { value: true })), Qz;
}
var Zz = {}, Oce;
function Od0() {
  return Oce || (Oce = 1, Object.defineProperty(Zz, "__esModule", { value: true })), Zz;
}
var eA = {}, zce;
function zd0() {
  return zce || (zce = 1, Object.defineProperty(eA, "__esModule", { value: true })), eA;
}
var tA = {}, Ace;
function Ad0() {
  return Ace || (Ace = 1, Object.defineProperty(tA, "__esModule", { value: true })), tA;
}
var rA = {}, _ce;
function _d0() {
  return _ce || (_ce = 1, Object.defineProperty(rA, "__esModule", { value: true })), rA;
}
var nA = {}, hce;
function hd0() {
  return hce || (hce = 1, Object.defineProperty(nA, "__esModule", { value: true })), nA;
}
var aA = {}, vce;
function vd0() {
  return vce || (vce = 1, Object.defineProperty(aA, "__esModule", { value: true })), aA;
}
var oA = {}, mce;
function md0() {
  return mce || (mce = 1, Object.defineProperty(oA, "__esModule", { value: true })), oA;
}
var iA = {}, Rce;
function Rd0() {
  return Rce || (Rce = 1, Object.defineProperty(iA, "__esModule", { value: true })), iA;
}
var uA = {}, qce;
function qd0() {
  return qce || (qce = 1, Object.defineProperty(uA, "__esModule", { value: true })), uA;
}
var sA = {}, Tce;
function Td0() {
  return Tce || (Tce = 1, Object.defineProperty(sA, "__esModule", { value: true })), sA;
}
var cA = {}, yce;
function yd0() {
  return yce || (yce = 1, Object.defineProperty(cA, "__esModule", { value: true })), cA;
}
var lA = {}, Sce;
function Sd0() {
  return Sce || (Sce = 1, Object.defineProperty(lA, "__esModule", { value: true })), lA;
}
var pA = {}, Cce;
function Cd0() {
  return Cce || (Cce = 1, Object.defineProperty(pA, "__esModule", { value: true })), pA;
}
var dA = {}, gce;
function gd0() {
  return gce || (gce = 1, Object.defineProperty(dA, "__esModule", { value: true })), dA;
}
var fA = {}, Ice;
function Id0() {
  return Ice || (Ice = 1, Object.defineProperty(fA, "__esModule", { value: true })), fA;
}
var bA = {}, Ece;
function Ed0() {
  return Ece || (Ece = 1, Object.defineProperty(bA, "__esModule", { value: true })), bA;
}
var MA = {}, Lce;
function Ld0() {
  return Lce || (Lce = 1, Object.defineProperty(MA, "__esModule", { value: true })), MA;
}
var OA = {}, Pce;
function Pd0() {
  return Pce || (Pce = 1, Object.defineProperty(OA, "__esModule", { value: true })), OA;
}
var zA = {}, Dce;
function Dd0() {
  return Dce || (Dce = 1, Object.defineProperty(zA, "__esModule", { value: true })), zA;
}
var AA = {}, Wce;
function Wd0() {
  return Wce || (Wce = 1, Object.defineProperty(AA, "__esModule", { value: true })), AA;
}
var _A = {}, Nce;
function Nd0() {
  return Nce || (Nce = 1, Object.defineProperty(_A, "__esModule", { value: true })), _A;
}
var hA = {}, wce;
function wd0() {
  return wce || (wce = 1, Object.defineProperty(hA, "__esModule", { value: true })), hA;
}
var vA = {}, Bce;
function Bd0() {
  return Bce || (Bce = 1, Object.defineProperty(vA, "__esModule", { value: true })), vA;
}
var mA = {}, xce;
function xd0() {
  return xce || (xce = 1, Object.defineProperty(mA, "__esModule", { value: true })), mA;
}
var RA = {}, Uce;
function Ud0() {
  return Uce || (Uce = 1, Object.defineProperty(RA, "__esModule", { value: true })), RA;
}
var qA = {}, kce;
function kd0() {
  return kce || (kce = 1, Object.defineProperty(qA, "__esModule", { value: true })), qA;
}
var TA = {}, jce;
function jd0() {
  return jce || (jce = 1, Object.defineProperty(TA, "__esModule", { value: true })), TA;
}
var yA = {}, Fce;
function Fd0() {
  return Fce || (Fce = 1, Object.defineProperty(yA, "__esModule", { value: true })), yA;
}
var SA = {}, Vce;
function Vd0() {
  return Vce || (Vce = 1, Object.defineProperty(SA, "__esModule", { value: true })), SA;
}
var CA = {}, Hce;
function Hd0() {
  return Hce || (Hce = 1, Object.defineProperty(CA, "__esModule", { value: true })), CA;
}
var gA = {}, Xce;
function Xd0() {
  return Xce || (Xce = 1, Object.defineProperty(gA, "__esModule", { value: true })), gA;
}
var IA = {}, $ce;
function $d0() {
  return $ce || ($ce = 1, Object.defineProperty(IA, "__esModule", { value: true })), IA;
}
var EA = {}, Gce;
function Gd0() {
  return Gce || (Gce = 1, Object.defineProperty(EA, "__esModule", { value: true })), EA;
}
var LA = {}, Yce;
function Yd0() {
  return Yce || (Yce = 1, Object.defineProperty(LA, "__esModule", { value: true })), LA;
}
var PA = {}, Jce;
function Jd0() {
  return Jce || (Jce = 1, Object.defineProperty(PA, "__esModule", { value: true })), PA;
}
var DA = {}, Kce;
function Kd0() {
  return Kce || (Kce = 1, Object.defineProperty(DA, "__esModule", { value: true })), DA;
}
var WA = {}, Qce;
function Qd0() {
  return Qce || (Qce = 1, Object.defineProperty(WA, "__esModule", { value: true })), WA;
}
var NA = {}, Zce;
function Zd0() {
  return Zce || (Zce = 1, Object.defineProperty(NA, "__esModule", { value: true })), NA;
}
var wA = {}, ele;
function ef0() {
  return ele || (ele = 1, Object.defineProperty(wA, "__esModule", { value: true })), wA;
}
var BA = {}, tle;
function tf0() {
  return tle || (tle = 1, Object.defineProperty(BA, "__esModule", { value: true })), BA;
}
var xA = {}, rle;
function rf0() {
  return rle || (rle = 1, Object.defineProperty(xA, "__esModule", { value: true })), xA;
}
var UA = {}, nle;
function nf0() {
  return nle || (nle = 1, Object.defineProperty(UA, "__esModule", { value: true })), UA;
}
var kA = {}, ale;
function af0() {
  return ale || (ale = 1, Object.defineProperty(kA, "__esModule", { value: true })), kA;
}
var jA = {}, ole;
function of0() {
  return ole || (ole = 1, Object.defineProperty(jA, "__esModule", { value: true })), jA;
}
var FA = {}, ile;
function if0() {
  return ile || (ile = 1, Object.defineProperty(FA, "__esModule", { value: true })), FA;
}
var VA = {}, ule;
function uf0() {
  return ule || (ule = 1, Object.defineProperty(VA, "__esModule", { value: true })), VA;
}
var HA = {}, sle;
function sf0() {
  return sle || (sle = 1, Object.defineProperty(HA, "__esModule", { value: true })), HA;
}
var XA = {}, cle;
function cf0() {
  return cle || (cle = 1, Object.defineProperty(XA, "__esModule", { value: true })), XA;
}
var $A = {}, lle;
function lf0() {
  return lle || (lle = 1, Object.defineProperty($A, "__esModule", { value: true })), $A;
}
var GA = {}, ple;
function pf0() {
  return ple || (ple = 1, Object.defineProperty(GA, "__esModule", { value: true })), GA;
}
var YA = {}, dle;
function df0() {
  return dle || (dle = 1, Object.defineProperty(YA, "__esModule", { value: true })), YA;
}
var JA = {}, fle;
function ff0() {
  return fle || (fle = 1, Object.defineProperty(JA, "__esModule", { value: true })), JA;
}
var KA = {}, ble;
function bf0() {
  return ble || (ble = 1, Object.defineProperty(KA, "__esModule", { value: true })), KA;
}
var QA = {}, Mle;
function Mf0() {
  return Mle || (Mle = 1, Object.defineProperty(QA, "__esModule", { value: true })), QA;
}
var ZA = {}, Ole;
function Of0() {
  return Ole || (Ole = 1, Object.defineProperty(ZA, "__esModule", { value: true })), ZA;
}
var e_ = {}, zle;
function zf0() {
  return zle || (zle = 1, Object.defineProperty(e_, "__esModule", { value: true })), e_;
}
var t_ = {}, Ale;
function Af0() {
  return Ale || (Ale = 1, Object.defineProperty(t_, "__esModule", { value: true })), t_;
}
var r_ = {}, _le;
function _f0() {
  return _le || (_le = 1, Object.defineProperty(r_, "__esModule", { value: true })), r_;
}
var n_ = {}, hle;
function hf0() {
  return hle || (hle = 1, Object.defineProperty(n_, "__esModule", { value: true })), n_;
}
var a_ = {}, vle;
function vf0() {
  return vle || (vle = 1, Object.defineProperty(a_, "__esModule", { value: true })), a_;
}
var o_ = {}, mle;
function mf0() {
  return mle || (mle = 1, Object.defineProperty(o_, "__esModule", { value: true })), o_;
}
var i_ = {}, Rle;
function Rf0() {
  return Rle || (Rle = 1, Object.defineProperty(i_, "__esModule", { value: true })), i_;
}
var u_ = {}, qle;
function qf0() {
  return qle || (qle = 1, Object.defineProperty(u_, "__esModule", { value: true })), u_;
}
var s_ = {}, Tle;
function Tf0() {
  return Tle || (Tle = 1, Object.defineProperty(s_, "__esModule", { value: true })), s_;
}
var c_ = {}, yle;
function yf0() {
  return yle || (yle = 1, Object.defineProperty(c_, "__esModule", { value: true })), c_;
}
var l_ = {}, Sle;
function Sf0() {
  return Sle || (Sle = 1, Object.defineProperty(l_, "__esModule", { value: true })), l_;
}
var p_ = {}, Cle;
function Cf0() {
  return Cle || (Cle = 1, Object.defineProperty(p_, "__esModule", { value: true })), p_;
}
var d_ = {}, gle;
function gf0() {
  return gle || (gle = 1, Object.defineProperty(d_, "__esModule", { value: true })), d_;
}
var f_ = {}, Ile;
function If0() {
  return Ile || (Ile = 1, Object.defineProperty(f_, "__esModule", { value: true })), f_;
}
var b_ = {}, Ele;
function Ef0() {
  return Ele || (Ele = 1, Object.defineProperty(b_, "__esModule", { value: true })), b_;
}
var M_ = {}, Lle;
function Lf0() {
  return Lle || (Lle = 1, Object.defineProperty(M_, "__esModule", { value: true })), M_;
}
var O_ = {}, Ple;
function Pf0() {
  return Ple || (Ple = 1, Object.defineProperty(O_, "__esModule", { value: true })), O_;
}
var z_ = {}, Dle;
function Df0() {
  return Dle || (Dle = 1, Object.defineProperty(z_, "__esModule", { value: true })), z_;
}
var A_ = {}, Wle;
function Wf0() {
  return Wle || (Wle = 1, Object.defineProperty(A_, "__esModule", { value: true })), A_;
}
var __ = {}, Nle;
function Nf0() {
  return Nle || (Nle = 1, Object.defineProperty(__, "__esModule", { value: true })), __;
}
var h_ = {}, wle;
function wf0() {
  return wle || (wle = 1, Object.defineProperty(h_, "__esModule", { value: true })), h_;
}
var v_ = {}, Ble;
function Bf0() {
  return Ble || (Ble = 1, Object.defineProperty(v_, "__esModule", { value: true })), v_;
}
var m_ = {}, xle;
function xf0() {
  return xle || (xle = 1, Object.defineProperty(m_, "__esModule", { value: true })), m_;
}
var R_ = {}, Ule;
function Uf0() {
  return Ule || (Ule = 1, Object.defineProperty(R_, "__esModule", { value: true })), R_;
}
var q_ = {}, kle;
function kf0() {
  return kle || (kle = 1, Object.defineProperty(q_, "__esModule", { value: true })), q_;
}
var T_ = {}, jle;
function jf0() {
  return jle || (jle = 1, Object.defineProperty(T_, "__esModule", { value: true })), T_;
}
var y_ = {}, Fle;
function Ff0() {
  return Fle || (Fle = 1, Object.defineProperty(y_, "__esModule", { value: true })), y_;
}
var S_ = {}, Vle;
function Vf0() {
  return Vle || (Vle = 1, Object.defineProperty(S_, "__esModule", { value: true })), S_;
}
var C_ = {}, Hle;
function Hf0() {
  return Hle || (Hle = 1, Object.defineProperty(C_, "__esModule", { value: true })), C_;
}
var g_ = {}, Xle;
function Xf0() {
  return Xle || (Xle = 1, Object.defineProperty(g_, "__esModule", { value: true })), g_;
}
var I_ = {}, $le;
function $f0() {
  return $le || ($le = 1, Object.defineProperty(I_, "__esModule", { value: true })), I_;
}
var E_ = {}, Gle;
function Gf0() {
  return Gle || (Gle = 1, Object.defineProperty(E_, "__esModule", { value: true })), E_;
}
var L_ = {}, Yle;
function Yf0() {
  return Yle || (Yle = 1, Object.defineProperty(L_, "__esModule", { value: true })), L_;
}
var P_ = {}, Jle;
function Jf0() {
  return Jle || (Jle = 1, Object.defineProperty(P_, "__esModule", { value: true })), P_;
}
var D_ = {}, Kle;
function Kf0() {
  return Kle || (Kle = 1, Object.defineProperty(D_, "__esModule", { value: true })), D_;
}
var W_ = {}, Qle;
function Qf0() {
  return Qle || (Qle = 1, Object.defineProperty(W_, "__esModule", { value: true })), W_;
}
var N_ = {}, Zle;
function Zf0() {
  return Zle || (Zle = 1, Object.defineProperty(N_, "__esModule", { value: true })), N_;
}
var w_ = {}, e2e;
function eb0() {
  return e2e || (e2e = 1, Object.defineProperty(w_, "__esModule", { value: true })), w_;
}
var B_ = {}, t2e;
function tb0() {
  return t2e || (t2e = 1, Object.defineProperty(B_, "__esModule", { value: true })), B_;
}
var x_ = {}, r2e;
function rb0() {
  return r2e || (r2e = 1, Object.defineProperty(x_, "__esModule", { value: true })), x_;
}
var U_ = {}, n2e;
function nb0() {
  return n2e || (n2e = 1, Object.defineProperty(U_, "__esModule", { value: true })), U_;
}
var k_ = {}, a2e;
function ab0() {
  return a2e || (a2e = 1, Object.defineProperty(k_, "__esModule", { value: true })), k_;
}
var j_ = {}, o2e;
function ob0() {
  return o2e || (o2e = 1, Object.defineProperty(j_, "__esModule", { value: true })), j_;
}
var F_ = {}, i2e;
function ib0() {
  return i2e || (i2e = 1, Object.defineProperty(F_, "__esModule", { value: true })), F_;
}
var V_ = {}, u2e;
function ub0() {
  return u2e || (u2e = 1, Object.defineProperty(V_, "__esModule", { value: true })), V_;
}
var H_ = {}, s2e;
function sb0() {
  return s2e || (s2e = 1, Object.defineProperty(H_, "__esModule", { value: true })), H_;
}
var X_ = {}, c2e;
function cb0() {
  return c2e || (c2e = 1, Object.defineProperty(X_, "__esModule", { value: true })), X_;
}
var $_ = {}, l2e;
function lb0() {
  return l2e || (l2e = 1, Object.defineProperty($_, "__esModule", { value: true })), $_;
}
var G_ = {}, p2e;
function pb0() {
  return p2e || (p2e = 1, Object.defineProperty(G_, "__esModule", { value: true })), G_;
}
var Y_ = {}, d2e;
function db0() {
  return d2e || (d2e = 1, Object.defineProperty(Y_, "__esModule", { value: true })), Y_;
}
var J_ = {}, f2e;
function fb0() {
  return f2e || (f2e = 1, Object.defineProperty(J_, "__esModule", { value: true })), J_;
}
var K_ = {}, b2e;
function bb0() {
  return b2e || (b2e = 1, Object.defineProperty(K_, "__esModule", { value: true })), K_;
}
var Q_ = {}, M2e;
function Mb0() {
  return M2e || (M2e = 1, Object.defineProperty(Q_, "__esModule", { value: true })), Q_;
}
var Z_ = {}, O2e;
function Ob0() {
  return O2e || (O2e = 1, Object.defineProperty(Z_, "__esModule", { value: true })), Z_;
}
var eh = {}, z2e;
function zb0() {
  return z2e || (z2e = 1, Object.defineProperty(eh, "__esModule", { value: true })), eh;
}
var th = {}, A2e;
function Ab0() {
  return A2e || (A2e = 1, Object.defineProperty(th, "__esModule", { value: true })), th;
}
var rh = {}, _2e;
function _b0() {
  return _2e || (_2e = 1, Object.defineProperty(rh, "__esModule", { value: true })), rh;
}
var nh = {}, h2e;
function hb0() {
  return h2e || (h2e = 1, Object.defineProperty(nh, "__esModule", { value: true })), nh;
}
var ah = {}, v2e;
function vb0() {
  return v2e || (v2e = 1, Object.defineProperty(ah, "__esModule", { value: true })), ah;
}
var oh = {}, m2e;
function mb0() {
  return m2e || (m2e = 1, Object.defineProperty(oh, "__esModule", { value: true })), oh;
}
var ih = {}, R2e;
function Rb0() {
  return R2e || (R2e = 1, Object.defineProperty(ih, "__esModule", { value: true })), ih;
}
var uh = {}, q2e;
function qb0() {
  return q2e || (q2e = 1, Object.defineProperty(uh, "__esModule", { value: true })), uh;
}
var sh = {}, T2e;
function Tb0() {
  return T2e || (T2e = 1, Object.defineProperty(sh, "__esModule", { value: true })), sh;
}
var ch = {}, y2e;
function yb0() {
  return y2e || (y2e = 1, Object.defineProperty(ch, "__esModule", { value: true })), ch;
}
var lh = {}, S2e;
function Sb0() {
  return S2e || (S2e = 1, Object.defineProperty(lh, "__esModule", { value: true })), lh;
}
var ph = {}, C2e;
function Cb0() {
  return C2e || (C2e = 1, Object.defineProperty(ph, "__esModule", { value: true })), ph;
}
var dh = {}, g2e;
function gb0() {
  return g2e || (g2e = 1, Object.defineProperty(dh, "__esModule", { value: true })), dh;
}
var fh = {}, I2e;
function Ib0() {
  return I2e || (I2e = 1, Object.defineProperty(fh, "__esModule", { value: true })), fh;
}
var bh = {}, E2e;
function Eb0() {
  return E2e || (E2e = 1, Object.defineProperty(bh, "__esModule", { value: true })), bh;
}
var Mh = {}, L2e;
function Lb0() {
  return L2e || (L2e = 1, Object.defineProperty(Mh, "__esModule", { value: true })), Mh;
}
var Oh = {}, P2e;
function Pb0() {
  return P2e || (P2e = 1, Object.defineProperty(Oh, "__esModule", { value: true })), Oh;
}
var zh = {}, D2e;
function Db0() {
  return D2e || (D2e = 1, Object.defineProperty(zh, "__esModule", { value: true })), zh;
}
var Ah = {}, W2e;
function Wb0() {
  return W2e || (W2e = 1, Object.defineProperty(Ah, "__esModule", { value: true })), Ah;
}
var _h = {}, N2e;
function Nb0() {
  return N2e || (N2e = 1, Object.defineProperty(_h, "__esModule", { value: true })), _h;
}
var hh = {}, w2e;
function wb0() {
  return w2e || (w2e = 1, Object.defineProperty(hh, "__esModule", { value: true })), hh;
}
var vh = {}, B2e;
function Bb0() {
  return B2e || (B2e = 1, Object.defineProperty(vh, "__esModule", { value: true })), vh;
}
var mh = {}, x2e;
function xb0() {
  return x2e || (x2e = 1, Object.defineProperty(mh, "__esModule", { value: true })), mh;
}
var Rh = {}, U2e;
function Ub0() {
  return U2e || (U2e = 1, Object.defineProperty(Rh, "__esModule", { value: true })), Rh;
}
var qh = {}, k2e;
function kb0() {
  return k2e || (k2e = 1, Object.defineProperty(qh, "__esModule", { value: true })), qh;
}
var Th = {}, j2e;
function jb0() {
  return j2e || (j2e = 1, Object.defineProperty(Th, "__esModule", { value: true })), Th;
}
var yh = {}, F2e;
function Fb0() {
  return F2e || (F2e = 1, Object.defineProperty(yh, "__esModule", { value: true })), yh;
}
var Sh = {}, V2e;
function Vb0() {
  return V2e || (V2e = 1, Object.defineProperty(Sh, "__esModule", { value: true })), Sh;
}
var Ch = {}, H2e;
function Hb0() {
  return H2e || (H2e = 1, Object.defineProperty(Ch, "__esModule", { value: true })), Ch;
}
var gh = {}, X2e;
function Xb0() {
  return X2e || (X2e = 1, Object.defineProperty(gh, "__esModule", { value: true })), gh;
}
var Ih = {}, $2e;
function $b0() {
  return $2e || ($2e = 1, Object.defineProperty(Ih, "__esModule", { value: true })), Ih;
}
var Eh = {}, G2e;
function Gb0() {
  return G2e || (G2e = 1, Object.defineProperty(Eh, "__esModule", { value: true })), Eh;
}
var Lh = {}, Y2e;
function Yb0() {
  return Y2e || (Y2e = 1, Object.defineProperty(Lh, "__esModule", { value: true })), Lh;
}
var Ph = {}, J2e;
function Jb0() {
  return J2e || (J2e = 1, Object.defineProperty(Ph, "__esModule", { value: true })), Ph;
}
var Dh = {}, K2e;
function Kb0() {
  return K2e || (K2e = 1, Object.defineProperty(Dh, "__esModule", { value: true })), Dh;
}
var Wh = {}, Q2e;
function Qb0() {
  return Q2e || (Q2e = 1, Object.defineProperty(Wh, "__esModule", { value: true })), Wh;
}
var Nh = {}, Z2e;
function Zb0() {
  return Z2e || (Z2e = 1, Object.defineProperty(Nh, "__esModule", { value: true })), Nh;
}
var wh = {}, epe;
function eM0() {
  return epe || (epe = 1, Object.defineProperty(wh, "__esModule", { value: true })), wh;
}
var Bh = {}, tpe;
function tM0() {
  return tpe || (tpe = 1, Object.defineProperty(Bh, "__esModule", { value: true })), Bh;
}
var xh = {}, rpe;
function rM0() {
  return rpe || (rpe = 1, Object.defineProperty(xh, "__esModule", { value: true })), xh;
}
var Uh = {}, npe;
function nM0() {
  return npe || (npe = 1, Object.defineProperty(Uh, "__esModule", { value: true })), Uh;
}
var kh = {}, ape;
function aM0() {
  return ape || (ape = 1, Object.defineProperty(kh, "__esModule", { value: true })), kh;
}
var jh = {}, ope;
function oM0() {
  return ope || (ope = 1, Object.defineProperty(jh, "__esModule", { value: true })), jh;
}
var Fh = {}, ipe;
function iM0() {
  return ipe || (ipe = 1, Object.defineProperty(Fh, "__esModule", { value: true })), Fh;
}
var Vh = {}, upe;
function uM0() {
  return upe || (upe = 1, Object.defineProperty(Vh, "__esModule", { value: true })), Vh;
}
var Hh = {}, spe;
function sM0() {
  return spe || (spe = 1, Object.defineProperty(Hh, "__esModule", { value: true })), Hh;
}
var Xh = {}, cpe;
function cM0() {
  return cpe || (cpe = 1, Object.defineProperty(Xh, "__esModule", { value: true })), Xh;
}
var $h = {}, lpe;
function lM0() {
  return lpe || (lpe = 1, Object.defineProperty($h, "__esModule", { value: true })), $h;
}
var Gh = {}, ppe;
function pM0() {
  return ppe || (ppe = 1, Object.defineProperty(Gh, "__esModule", { value: true })), Gh;
}
var Yh = {}, dpe;
function dM0() {
  return dpe || (dpe = 1, Object.defineProperty(Yh, "__esModule", { value: true })), Yh;
}
var Jh = {}, fpe;
function fM0() {
  return fpe || (fpe = 1, Object.defineProperty(Jh, "__esModule", { value: true })), Jh;
}
var Kh = {}, bpe;
function bM0() {
  return bpe || (bpe = 1, Object.defineProperty(Kh, "__esModule", { value: true })), Kh;
}
var Qh = {}, Mpe;
function MM0() {
  return Mpe || (Mpe = 1, Object.defineProperty(Qh, "__esModule", { value: true })), Qh;
}
var Zh = {}, Ope;
function OM0() {
  return Ope || (Ope = 1, Object.defineProperty(Zh, "__esModule", { value: true })), Zh;
}
var ev = {}, zpe;
function zM0() {
  return zpe || (zpe = 1, Object.defineProperty(ev, "__esModule", { value: true })), ev;
}
var tv = {}, Ape;
function AM0() {
  return Ape || (Ape = 1, Object.defineProperty(tv, "__esModule", { value: true })), tv;
}
var rv = {}, _pe;
function _M0() {
  return _pe || (_pe = 1, Object.defineProperty(rv, "__esModule", { value: true })), rv;
}
var nv = {}, hpe;
function hM0() {
  return hpe || (hpe = 1, Object.defineProperty(nv, "__esModule", { value: true })), nv;
}
var av = {}, vpe;
function vM0() {
  return vpe || (vpe = 1, Object.defineProperty(av, "__esModule", { value: true })), av;
}
var ov = {}, mpe;
function mM0() {
  return mpe || (mpe = 1, Object.defineProperty(ov, "__esModule", { value: true })), ov;
}
var iv = {}, Rpe;
function RM0() {
  return Rpe || (Rpe = 1, Object.defineProperty(iv, "__esModule", { value: true })), iv;
}
var uv = {}, qpe;
function qM0() {
  return qpe || (qpe = 1, Object.defineProperty(uv, "__esModule", { value: true })), uv;
}
var sv = {}, Tpe;
function TM0() {
  return Tpe || (Tpe = 1, Object.defineProperty(sv, "__esModule", { value: true })), sv;
}
var cv = {}, ype;
function yM0() {
  return ype || (ype = 1, Object.defineProperty(cv, "__esModule", { value: true })), cv;
}
var lv = {}, Spe;
function SM0() {
  return Spe || (Spe = 1, Object.defineProperty(lv, "__esModule", { value: true })), lv;
}
var pv = {}, Cpe;
function CM0() {
  return Cpe || (Cpe = 1, Object.defineProperty(pv, "__esModule", { value: true })), pv;
}
var dv = {}, gpe;
function gM0() {
  return gpe || (gpe = 1, Object.defineProperty(dv, "__esModule", { value: true })), dv;
}
var fv = {}, Ipe;
function IM0() {
  return Ipe || (Ipe = 1, Object.defineProperty(fv, "__esModule", { value: true })), fv;
}
var bv = {}, Epe;
function EM0() {
  return Epe || (Epe = 1, Object.defineProperty(bv, "__esModule", { value: true })), bv;
}
var Mv = {}, Lpe;
function LM0() {
  return Lpe || (Lpe = 1, Object.defineProperty(Mv, "__esModule", { value: true })), Mv;
}
var Ov = {}, Ppe;
function PM0() {
  return Ppe || (Ppe = 1, Object.defineProperty(Ov, "__esModule", { value: true })), Ov;
}
var zv = {}, Dpe;
function DM0() {
  return Dpe || (Dpe = 1, Object.defineProperty(zv, "__esModule", { value: true })), zv;
}
var Av = {}, Wpe;
function WM0() {
  return Wpe || (Wpe = 1, Object.defineProperty(Av, "__esModule", { value: true })), Av;
}
var _v = {}, Npe;
function NM0() {
  return Npe || (Npe = 1, Object.defineProperty(_v, "__esModule", { value: true })), _v;
}
var hv = {}, wpe;
function wM0() {
  return wpe || (wpe = 1, Object.defineProperty(hv, "__esModule", { value: true })), hv;
}
var vv = {}, Bpe;
function BM0() {
  return Bpe || (Bpe = 1, Object.defineProperty(vv, "__esModule", { value: true })), vv;
}
var mv = {}, xpe;
function xM0() {
  return xpe || (xpe = 1, Object.defineProperty(mv, "__esModule", { value: true })), mv;
}
var Rv = {}, Upe;
function UM0() {
  return Upe || (Upe = 1, Object.defineProperty(Rv, "__esModule", { value: true })), Rv;
}
var qv = {}, kpe;
function kM0() {
  return kpe || (kpe = 1, Object.defineProperty(qv, "__esModule", { value: true })), qv;
}
var Tv = {}, jpe;
function jM0() {
  return jpe || (jpe = 1, Object.defineProperty(Tv, "__esModule", { value: true })), Tv;
}
var yv = {}, Fpe;
function FM0() {
  return Fpe || (Fpe = 1, Object.defineProperty(yv, "__esModule", { value: true })), yv;
}
var Sv = {}, Vpe;
function VM0() {
  return Vpe || (Vpe = 1, Object.defineProperty(Sv, "__esModule", { value: true })), Sv;
}
var Cv = {}, Hpe;
function HM0() {
  return Hpe || (Hpe = 1, Object.defineProperty(Cv, "__esModule", { value: true })), Cv;
}
var gv = {}, Xpe;
function XM0() {
  return Xpe || (Xpe = 1, Object.defineProperty(gv, "__esModule", { value: true })), gv;
}
var Iv = {}, $pe;
function $M0() {
  return $pe || ($pe = 1, Object.defineProperty(Iv, "__esModule", { value: true })), Iv;
}
var Ev = {}, Gpe;
function GM0() {
  return Gpe || (Gpe = 1, Object.defineProperty(Ev, "__esModule", { value: true })), Ev;
}
var Lv = {}, Ype;
function YM0() {
  return Ype || (Ype = 1, Object.defineProperty(Lv, "__esModule", { value: true })), Lv;
}
var Pv = {}, Jpe;
function JM0() {
  return Jpe || (Jpe = 1, Object.defineProperty(Pv, "__esModule", { value: true })), Pv;
}
var Dv = {}, Kpe;
function KM0() {
  return Kpe || (Kpe = 1, Object.defineProperty(Dv, "__esModule", { value: true })), Dv;
}
var Wv = {}, Qpe;
function QM0() {
  return Qpe || (Qpe = 1, Object.defineProperty(Wv, "__esModule", { value: true })), Wv;
}
var Nv = {}, Zpe;
function ZM0() {
  return Zpe || (Zpe = 1, Object.defineProperty(Nv, "__esModule", { value: true })), Nv;
}
var wv = {}, ede;
function eO0() {
  return ede || (ede = 1, Object.defineProperty(wv, "__esModule", { value: true })), wv;
}
var Bv = {}, tde;
function tO0() {
  return tde || (tde = 1, Object.defineProperty(Bv, "__esModule", { value: true })), Bv;
}
var xv = {}, rde;
function rO0() {
  return rde || (rde = 1, Object.defineProperty(xv, "__esModule", { value: true })), xv;
}
var Uv = {}, nde;
function nO0() {
  return nde || (nde = 1, Object.defineProperty(Uv, "__esModule", { value: true })), Uv;
}
var kv = {}, ade;
function aO0() {
  return ade || (ade = 1, Object.defineProperty(kv, "__esModule", { value: true })), kv;
}
var jv = {}, ode;
function oO0() {
  return ode || (ode = 1, Object.defineProperty(jv, "__esModule", { value: true })), jv;
}
var Fv = {}, ide;
function iO0() {
  return ide || (ide = 1, Object.defineProperty(Fv, "__esModule", { value: true })), Fv;
}
var Vv = {}, ude;
function uO0() {
  return ude || (ude = 1, Object.defineProperty(Vv, "__esModule", { value: true })), Vv;
}
var Hv = {}, sde;
function sO0() {
  return sde || (sde = 1, Object.defineProperty(Hv, "__esModule", { value: true })), Hv;
}
var Xv = {}, cde;
function cO0() {
  return cde || (cde = 1, Object.defineProperty(Xv, "__esModule", { value: true })), Xv;
}
var $v = {}, lde;
function lO0() {
  return lde || (lde = 1, Object.defineProperty($v, "__esModule", { value: true })), $v;
}
var Gv = {}, pde;
function pO0() {
  return pde || (pde = 1, Object.defineProperty(Gv, "__esModule", { value: true })), Gv;
}
var Yv = {}, dde;
function dO0() {
  return dde || (dde = 1, Object.defineProperty(Yv, "__esModule", { value: true })), Yv;
}
var Jv = {}, fde;
function fO0() {
  return fde || (fde = 1, Object.defineProperty(Jv, "__esModule", { value: true })), Jv;
}
var Kv = {}, bde;
function bO0() {
  return bde || (bde = 1, Object.defineProperty(Kv, "__esModule", { value: true })), Kv;
}
var Qv = {}, Mde;
function MO0() {
  return Mde || (Mde = 1, Object.defineProperty(Qv, "__esModule", { value: true })), Qv;
}
var Zv = {}, Ode;
function OO0() {
  return Ode || (Ode = 1, Object.defineProperty(Zv, "__esModule", { value: true })), Zv;
}
var em = {}, zde;
function zO0() {
  return zde || (zde = 1, Object.defineProperty(em, "__esModule", { value: true })), em;
}
var tm = {}, Ade;
function AO0() {
  return Ade || (Ade = 1, Object.defineProperty(tm, "__esModule", { value: true })), tm;
}
var rm = {}, _de;
function _O0() {
  return _de || (_de = 1, Object.defineProperty(rm, "__esModule", { value: true })), rm;
}
var nm = {}, hde;
function hO0() {
  return hde || (hde = 1, Object.defineProperty(nm, "__esModule", { value: true })), nm;
}
var am = {}, vde;
function vO0() {
  return vde || (vde = 1, Object.defineProperty(am, "__esModule", { value: true })), am;
}
var om = {}, mde;
function mO0() {
  return mde || (mde = 1, Object.defineProperty(om, "__esModule", { value: true })), om;
}
var im = {}, Rde;
function RO0() {
  return Rde || (Rde = 1, Object.defineProperty(im, "__esModule", { value: true })), im;
}
var um = {}, qde;
function qO0() {
  return qde || (qde = 1, Object.defineProperty(um, "__esModule", { value: true })), um;
}
var sm = {}, Tde;
function TO0() {
  return Tde || (Tde = 1, Object.defineProperty(sm, "__esModule", { value: true })), sm;
}
var cm = {}, yde;
function yO0() {
  return yde || (yde = 1, Object.defineProperty(cm, "__esModule", { value: true })), cm;
}
var lm = {}, Sde;
function SO0() {
  return Sde || (Sde = 1, Object.defineProperty(lm, "__esModule", { value: true })), lm;
}
var pm = {}, Cde;
function CO0() {
  return Cde || (Cde = 1, Object.defineProperty(pm, "__esModule", { value: true })), pm;
}
var dm = {}, gde;
function gO0() {
  return gde || (gde = 1, Object.defineProperty(dm, "__esModule", { value: true })), dm;
}
var fm = {}, Ide;
function IO0() {
  return Ide || (Ide = 1, Object.defineProperty(fm, "__esModule", { value: true })), fm;
}
var bm = {}, Ede;
function EO0() {
  return Ede || (Ede = 1, Object.defineProperty(bm, "__esModule", { value: true })), bm;
}
var Mm = {}, Lde;
function LO0() {
  return Lde || (Lde = 1, Object.defineProperty(Mm, "__esModule", { value: true })), Mm;
}
var Om = {}, Pde;
function PO0() {
  return Pde || (Pde = 1, Object.defineProperty(Om, "__esModule", { value: true })), Om;
}
var zm = {}, Dde;
function DO0() {
  return Dde || (Dde = 1, Object.defineProperty(zm, "__esModule", { value: true })), zm;
}
var Am = {}, Wde;
function WO0() {
  return Wde || (Wde = 1, Object.defineProperty(Am, "__esModule", { value: true })), Am;
}
var _m = {}, Nde;
function NO0() {
  return Nde || (Nde = 1, Object.defineProperty(_m, "__esModule", { value: true })), _m;
}
var hm = {}, wde;
function wO0() {
  return wde || (wde = 1, Object.defineProperty(hm, "__esModule", { value: true })), hm;
}
var vm = {}, Bde;
function BO0() {
  return Bde || (Bde = 1, Object.defineProperty(vm, "__esModule", { value: true })), vm;
}
var mm = {}, xde;
function xO0() {
  return xde || (xde = 1, Object.defineProperty(mm, "__esModule", { value: true })), mm;
}
var Rm = {}, Ude;
function UO0() {
  return Ude || (Ude = 1, Object.defineProperty(Rm, "__esModule", { value: true })), Rm;
}
var qm = {}, kde;
function kO0() {
  return kde || (kde = 1, Object.defineProperty(qm, "__esModule", { value: true })), qm;
}
var Tm = {}, jde;
function jO0() {
  return jde || (jde = 1, Object.defineProperty(Tm, "__esModule", { value: true })), Tm;
}
var ym = {}, Fde;
function FO0() {
  return Fde || (Fde = 1, Object.defineProperty(ym, "__esModule", { value: true })), ym;
}
var Sm = {}, Vde;
function VO0() {
  return Vde || (Vde = 1, Object.defineProperty(Sm, "__esModule", { value: true })), Sm;
}
var Cm = {}, Hde;
function HO0() {
  return Hde || (Hde = 1, Object.defineProperty(Cm, "__esModule", { value: true })), Cm;
}
var gm = {}, Xde;
function XO0() {
  return Xde || (Xde = 1, Object.defineProperty(gm, "__esModule", { value: true })), gm;
}
var Im = {}, $de;
function $O0() {
  return $de || ($de = 1, Object.defineProperty(Im, "__esModule", { value: true })), Im;
}
var Em = {}, Gde;
function GO0() {
  return Gde || (Gde = 1, Object.defineProperty(Em, "__esModule", { value: true })), Em;
}
var Lm = {}, Yde;
function YO0() {
  return Yde || (Yde = 1, Object.defineProperty(Lm, "__esModule", { value: true })), Lm;
}
var Pm = {}, Jde;
function JO0() {
  return Jde || (Jde = 1, Object.defineProperty(Pm, "__esModule", { value: true })), Pm;
}
var Dm = {}, Kde;
function KO0() {
  return Kde || (Kde = 1, Object.defineProperty(Dm, "__esModule", { value: true })), Dm;
}
var Wm = {}, Qde;
function QO0() {
  return Qde || (Qde = 1, Object.defineProperty(Wm, "__esModule", { value: true })), Wm;
}
var Nm = {}, Zde;
function ZO0() {
  return Zde || (Zde = 1, Object.defineProperty(Nm, "__esModule", { value: true })), Nm;
}
var wm = {}, efe;
function e30() {
  return efe || (efe = 1, Object.defineProperty(wm, "__esModule", { value: true })), wm;
}
var Bm = {}, tfe;
function t30() {
  return tfe || (tfe = 1, Object.defineProperty(Bm, "__esModule", { value: true })), Bm;
}
var xm = {}, rfe;
function r30() {
  return rfe || (rfe = 1, Object.defineProperty(xm, "__esModule", { value: true })), xm;
}
var Um = {}, nfe;
function n30() {
  return nfe || (nfe = 1, Object.defineProperty(Um, "__esModule", { value: true })), Um;
}
var km = {}, afe;
function a30() {
  return afe || (afe = 1, Object.defineProperty(km, "__esModule", { value: true })), km;
}
var jm = {}, ofe;
function o30() {
  return ofe || (ofe = 1, Object.defineProperty(jm, "__esModule", { value: true })), jm;
}
var Fm = {}, ife;
function i30() {
  return ife || (ife = 1, Object.defineProperty(Fm, "__esModule", { value: true })), Fm;
}
var Vm = {}, ufe;
function u30() {
  return ufe || (ufe = 1, Object.defineProperty(Vm, "__esModule", { value: true })), Vm;
}
var Hm = {}, sfe;
function s30() {
  return sfe || (sfe = 1, Object.defineProperty(Hm, "__esModule", { value: true })), Hm;
}
var Xm = {}, cfe;
function c30() {
  return cfe || (cfe = 1, Object.defineProperty(Xm, "__esModule", { value: true })), Xm;
}
var $m = {}, lfe;
function l30() {
  return lfe || (lfe = 1, Object.defineProperty($m, "__esModule", { value: true })), $m;
}
var Gm = {}, pfe;
function p30() {
  return pfe || (pfe = 1, Object.defineProperty(Gm, "__esModule", { value: true })), Gm;
}
var Ym = {}, dfe;
function d30() {
  return dfe || (dfe = 1, Object.defineProperty(Ym, "__esModule", { value: true })), Ym;
}
var Jm = {}, ffe;
function f30() {
  return ffe || (ffe = 1, Object.defineProperty(Jm, "__esModule", { value: true })), Jm;
}
var Km = {}, bfe;
function b30() {
  return bfe || (bfe = 1, Object.defineProperty(Km, "__esModule", { value: true })), Km;
}
var Qm = {}, Mfe;
function M30() {
  return Mfe || (Mfe = 1, Object.defineProperty(Qm, "__esModule", { value: true })), Qm;
}
var Zm = {}, Ofe;
function O30() {
  return Ofe || (Ofe = 1, Object.defineProperty(Zm, "__esModule", { value: true })), Zm;
}
var eR = {}, zfe;
function z30() {
  return zfe || (zfe = 1, Object.defineProperty(eR, "__esModule", { value: true })), eR;
}
var tR = {}, Afe;
function A30() {
  return Afe || (Afe = 1, Object.defineProperty(tR, "__esModule", { value: true })), tR;
}
var rR = {}, _fe;
function _30() {
  return _fe || (_fe = 1, Object.defineProperty(rR, "__esModule", { value: true })), rR;
}
var nR = {}, hfe;
function h30() {
  return hfe || (hfe = 1, Object.defineProperty(nR, "__esModule", { value: true })), nR;
}
var aR = {}, vfe;
function v30() {
  return vfe || (vfe = 1, Object.defineProperty(aR, "__esModule", { value: true })), aR;
}
var oR = {}, mfe;
function m30() {
  return mfe || (mfe = 1, Object.defineProperty(oR, "__esModule", { value: true })), oR;
}
var iR = {}, Rfe;
function R30() {
  return Rfe || (Rfe = 1, Object.defineProperty(iR, "__esModule", { value: true })), iR;
}
var uR = {}, qfe;
function q30() {
  return qfe || (qfe = 1, Object.defineProperty(uR, "__esModule", { value: true })), uR;
}
var sR = {}, Tfe;
function T30() {
  return Tfe || (Tfe = 1, Object.defineProperty(sR, "__esModule", { value: true })), sR;
}
var cR = {}, yfe;
function y30() {
  return yfe || (yfe = 1, Object.defineProperty(cR, "__esModule", { value: true })), cR;
}
var lR = {}, Sfe;
function S30() {
  return Sfe || (Sfe = 1, Object.defineProperty(lR, "__esModule", { value: true })), lR;
}
var pR = {}, Cfe;
function C30() {
  return Cfe || (Cfe = 1, Object.defineProperty(pR, "__esModule", { value: true })), pR;
}
var dR = {}, gfe;
function g30() {
  return gfe || (gfe = 1, Object.defineProperty(dR, "__esModule", { value: true })), dR;
}
var fR = {}, Ife;
function I30() {
  return Ife || (Ife = 1, Object.defineProperty(fR, "__esModule", { value: true })), fR;
}
var bR = {}, Efe;
function E30() {
  return Efe || (Efe = 1, Object.defineProperty(bR, "__esModule", { value: true })), bR;
}
var MR = {}, Lfe;
function L30() {
  return Lfe || (Lfe = 1, Object.defineProperty(MR, "__esModule", { value: true })), MR;
}
var OR = {}, Pfe;
function P30() {
  return Pfe || (Pfe = 1, Object.defineProperty(OR, "__esModule", { value: true })), OR;
}
var zR = {}, Dfe;
function D30() {
  return Dfe || (Dfe = 1, Object.defineProperty(zR, "__esModule", { value: true })), zR;
}
var AR = {}, Wfe;
function W30() {
  return Wfe || (Wfe = 1, Object.defineProperty(AR, "__esModule", { value: true })), AR;
}
var _R = {}, Nfe;
function N30() {
  return Nfe || (Nfe = 1, Object.defineProperty(_R, "__esModule", { value: true })), _R;
}
var hR = {}, wfe;
function w30() {
  return wfe || (wfe = 1, Object.defineProperty(hR, "__esModule", { value: true })), hR;
}
var vR = {}, Bfe;
function B30() {
  return Bfe || (Bfe = 1, Object.defineProperty(vR, "__esModule", { value: true })), vR;
}
var mR = {}, xfe;
function x30() {
  return xfe || (xfe = 1, Object.defineProperty(mR, "__esModule", { value: true })), mR;
}
var RR = {}, Ufe;
function U30() {
  return Ufe || (Ufe = 1, Object.defineProperty(RR, "__esModule", { value: true })), RR;
}
var qR = {}, kfe;
function k30() {
  return kfe || (kfe = 1, Object.defineProperty(qR, "__esModule", { value: true })), qR;
}
var TR = {}, jfe;
function j30() {
  return jfe || (jfe = 1, Object.defineProperty(TR, "__esModule", { value: true })), TR;
}
var yR = {}, Ffe;
function F30() {
  return Ffe || (Ffe = 1, Object.defineProperty(yR, "__esModule", { value: true })), yR;
}
var SR = {}, Vfe;
function V30() {
  return Vfe || (Vfe = 1, Object.defineProperty(SR, "__esModule", { value: true })), SR;
}
var CR = {}, Hfe;
function H30() {
  return Hfe || (Hfe = 1, Object.defineProperty(CR, "__esModule", { value: true })), CR;
}
var gR = {}, Xfe;
function X30() {
  return Xfe || (Xfe = 1, Object.defineProperty(gR, "__esModule", { value: true })), gR;
}
var IR = {}, $fe;
function $30() {
  return $fe || ($fe = 1, Object.defineProperty(IR, "__esModule", { value: true })), IR;
}
var ER = {}, Gfe;
function G30() {
  return Gfe || (Gfe = 1, Object.defineProperty(ER, "__esModule", { value: true })), ER;
}
var LR = {}, Yfe;
function Y30() {
  return Yfe || (Yfe = 1, Object.defineProperty(LR, "__esModule", { value: true })), LR;
}
var PR = {}, Jfe;
function J30() {
  return Jfe || (Jfe = 1, Object.defineProperty(PR, "__esModule", { value: true })), PR;
}
var DR = {}, Kfe;
function K30() {
  return Kfe || (Kfe = 1, Object.defineProperty(DR, "__esModule", { value: true })), DR;
}
var WR = {}, Qfe;
function Q30() {
  return Qfe || (Qfe = 1, Object.defineProperty(WR, "__esModule", { value: true })), WR;
}
var NR = {}, Zfe;
function Z30() {
  return Zfe || (Zfe = 1, Object.defineProperty(NR, "__esModule", { value: true })), NR;
}
var wR = {}, ebe;
function ez0() {
  return ebe || (ebe = 1, Object.defineProperty(wR, "__esModule", { value: true })), wR;
}
var BR = {}, tbe;
function tz0() {
  return tbe || (tbe = 1, Object.defineProperty(BR, "__esModule", { value: true })), BR;
}
var xR = {}, rbe;
function rz0() {
  return rbe || (rbe = 1, Object.defineProperty(xR, "__esModule", { value: true })), xR;
}
var UR = {}, nbe;
function nz0() {
  return nbe || (nbe = 1, Object.defineProperty(UR, "__esModule", { value: true })), UR;
}
var kR = {}, abe;
function az0() {
  return abe || (abe = 1, Object.defineProperty(kR, "__esModule", { value: true })), kR;
}
var jR = {}, obe;
function oz0() {
  return obe || (obe = 1, Object.defineProperty(jR, "__esModule", { value: true })), jR;
}
var FR = {}, ibe;
function iz0() {
  return ibe || (ibe = 1, Object.defineProperty(FR, "__esModule", { value: true })), FR;
}
var VR = {}, ube;
function uz0() {
  return ube || (ube = 1, Object.defineProperty(VR, "__esModule", { value: true })), VR;
}
var HR = {}, sbe;
function sz0() {
  return sbe || (sbe = 1, Object.defineProperty(HR, "__esModule", { value: true })), HR;
}
var XR = {}, cbe;
function cz0() {
  return cbe || (cbe = 1, Object.defineProperty(XR, "__esModule", { value: true })), XR;
}
var $R = {}, lbe;
function lz0() {
  return lbe || (lbe = 1, Object.defineProperty($R, "__esModule", { value: true })), $R;
}
var GR = {}, pbe;
function pz0() {
  return pbe || (pbe = 1, Object.defineProperty(GR, "__esModule", { value: true })), GR;
}
var YR = {}, dbe;
function dz0() {
  return dbe || (dbe = 1, Object.defineProperty(YR, "__esModule", { value: true })), YR;
}
var JR = {}, fbe;
function fz0() {
  return fbe || (fbe = 1, Object.defineProperty(JR, "__esModule", { value: true })), JR;
}
var KR = {}, bbe;
function bz0() {
  return bbe || (bbe = 1, Object.defineProperty(KR, "__esModule", { value: true })), KR;
}
var QR = {}, Mbe;
function Mz0() {
  return Mbe || (Mbe = 1, Object.defineProperty(QR, "__esModule", { value: true })), QR;
}
var ZR = {}, Obe;
function Oz0() {
  return Obe || (Obe = 1, Object.defineProperty(ZR, "__esModule", { value: true })), ZR;
}
var e4 = {}, zbe;
function zz0() {
  return zbe || (zbe = 1, Object.defineProperty(e4, "__esModule", { value: true })), e4;
}
var t4 = {}, Abe;
function Az0() {
  return Abe || (Abe = 1, Object.defineProperty(t4, "__esModule", { value: true })), t4;
}
var r4 = {}, _be;
function _z0() {
  return _be || (_be = 1, Object.defineProperty(r4, "__esModule", { value: true })), r4;
}
var n4 = {}, hbe;
function hz0() {
  return hbe || (hbe = 1, Object.defineProperty(n4, "__esModule", { value: true })), n4;
}
var a4 = {}, vbe;
function vz0() {
  return vbe || (vbe = 1, Object.defineProperty(a4, "__esModule", { value: true })), a4;
}
var o4 = {}, mbe;
function mz0() {
  return mbe || (mbe = 1, Object.defineProperty(o4, "__esModule", { value: true })), o4;
}
var i4 = {}, Rbe;
function Rz0() {
  return Rbe || (Rbe = 1, Object.defineProperty(i4, "__esModule", { value: true })), i4;
}
var u4 = {}, qbe;
function qz0() {
  return qbe || (qbe = 1, Object.defineProperty(u4, "__esModule", { value: true })), u4;
}
var s4 = {}, Tbe;
function Tz0() {
  return Tbe || (Tbe = 1, Object.defineProperty(s4, "__esModule", { value: true })), s4;
}
var c4 = {}, ybe;
function yz0() {
  return ybe || (ybe = 1, Object.defineProperty(c4, "__esModule", { value: true })), c4;
}
var l4 = {}, Sbe;
function Sz0() {
  return Sbe || (Sbe = 1, Object.defineProperty(l4, "__esModule", { value: true })), l4;
}
var p4 = {}, Cbe;
function Cz0() {
  return Cbe || (Cbe = 1, Object.defineProperty(p4, "__esModule", { value: true })), p4;
}
var d4 = {}, gbe;
function gz0() {
  return gbe || (gbe = 1, Object.defineProperty(d4, "__esModule", { value: true })), d4;
}
var f4 = {}, Ibe;
function Iz0() {
  return Ibe || (Ibe = 1, Object.defineProperty(f4, "__esModule", { value: true })), f4;
}
var b4 = {}, Ebe;
function Ez0() {
  return Ebe || (Ebe = 1, Object.defineProperty(b4, "__esModule", { value: true })), b4;
}
var M4 = {}, Lbe;
function Lz0() {
  return Lbe || (Lbe = 1, Object.defineProperty(M4, "__esModule", { value: true })), M4;
}
var O4 = {}, Pbe;
function Pz0() {
  return Pbe || (Pbe = 1, Object.defineProperty(O4, "__esModule", { value: true })), O4;
}
var z4 = {}, Dbe;
function Dz0() {
  return Dbe || (Dbe = 1, Object.defineProperty(z4, "__esModule", { value: true })), z4;
}
var A4 = {}, Wbe;
function Wz0() {
  return Wbe || (Wbe = 1, Object.defineProperty(A4, "__esModule", { value: true })), A4;
}
var _4 = {}, Nbe;
function Nz0() {
  return Nbe || (Nbe = 1, Object.defineProperty(_4, "__esModule", { value: true })), _4;
}
var h4 = {}, wbe;
function wz0() {
  return wbe || (wbe = 1, Object.defineProperty(h4, "__esModule", { value: true })), h4;
}
var v4 = {}, Bbe;
function Bz0() {
  return Bbe || (Bbe = 1, Object.defineProperty(v4, "__esModule", { value: true })), v4;
}
var m4 = {}, xbe;
function xz0() {
  return xbe || (xbe = 1, Object.defineProperty(m4, "__esModule", { value: true })), m4;
}
var R4 = {}, Ube;
function Uz0() {
  return Ube || (Ube = 1, Object.defineProperty(R4, "__esModule", { value: true })), R4;
}
var q4 = {}, kbe;
function kz0() {
  return kbe || (kbe = 1, Object.defineProperty(q4, "__esModule", { value: true })), q4;
}
var T4 = {}, jbe;
function jz0() {
  return jbe || (jbe = 1, Object.defineProperty(T4, "__esModule", { value: true })), T4;
}
var y4 = {}, Fbe;
function Fz0() {
  return Fbe || (Fbe = 1, Object.defineProperty(y4, "__esModule", { value: true })), y4;
}
var S4 = {}, Vbe;
function Vz0() {
  return Vbe || (Vbe = 1, Object.defineProperty(S4, "__esModule", { value: true })), S4;
}
var C4 = {}, Hbe;
function Hz0() {
  return Hbe || (Hbe = 1, Object.defineProperty(C4, "__esModule", { value: true })), C4;
}
var g4 = {}, Xbe;
function Xz0() {
  return Xbe || (Xbe = 1, Object.defineProperty(g4, "__esModule", { value: true })), g4;
}
var I4 = {}, $be;
function $z0() {
  return $be || ($be = 1, Object.defineProperty(I4, "__esModule", { value: true })), I4;
}
var E4 = {}, Gbe;
function Gz0() {
  return Gbe || (Gbe = 1, Object.defineProperty(E4, "__esModule", { value: true })), E4;
}
var L4 = {}, Ybe;
function Yz0() {
  return Ybe || (Ybe = 1, Object.defineProperty(L4, "__esModule", { value: true })), L4;
}
var P4 = {}, Jbe;
function Jz0() {
  return Jbe || (Jbe = 1, Object.defineProperty(P4, "__esModule", { value: true })), P4;
}
var D4 = {}, Kbe;
function Kz0() {
  return Kbe || (Kbe = 1, Object.defineProperty(D4, "__esModule", { value: true })), D4;
}
var W4 = {}, Qbe;
function Qz0() {
  return Qbe || (Qbe = 1, Object.defineProperty(W4, "__esModule", { value: true })), W4;
}
var N4 = {}, Zbe;
function Zz0() {
  return Zbe || (Zbe = 1, Object.defineProperty(N4, "__esModule", { value: true })), N4;
}
var w4 = {}, eMe;
function eA0() {
  return eMe || (eMe = 1, Object.defineProperty(w4, "__esModule", { value: true })), w4;
}
var B4 = {}, tMe;
function tA0() {
  return tMe || (tMe = 1, Object.defineProperty(B4, "__esModule", { value: true })), B4;
}
var x4 = {}, rMe;
function rA0() {
  return rMe || (rMe = 1, Object.defineProperty(x4, "__esModule", { value: true })), x4;
}
var U4 = {}, nMe;
function nA0() {
  return nMe || (nMe = 1, Object.defineProperty(U4, "__esModule", { value: true })), U4;
}
var k4 = {}, aMe;
function aA0() {
  return aMe || (aMe = 1, Object.defineProperty(k4, "__esModule", { value: true })), k4;
}
var j4 = {}, oMe;
function oA0() {
  return oMe || (oMe = 1, Object.defineProperty(j4, "__esModule", { value: true })), j4;
}
var F4 = {}, iMe;
function iA0() {
  return iMe || (iMe = 1, Object.defineProperty(F4, "__esModule", { value: true })), F4;
}
var V4 = {}, uMe;
function uA0() {
  return uMe || (uMe = 1, Object.defineProperty(V4, "__esModule", { value: true })), V4;
}
var H4 = {}, sMe;
function sA0() {
  return sMe || (sMe = 1, Object.defineProperty(H4, "__esModule", { value: true })), H4;
}
var X4 = {}, cMe;
function cA0() {
  return cMe || (cMe = 1, Object.defineProperty(X4, "__esModule", { value: true })), X4;
}
var $4 = {}, lMe;
function lA0() {
  return lMe || (lMe = 1, Object.defineProperty($4, "__esModule", { value: true })), $4;
}
var G4 = {}, pMe;
function pA0() {
  return pMe || (pMe = 1, Object.defineProperty(G4, "__esModule", { value: true })), G4;
}
var Y4 = {}, dMe;
function dA0() {
  return dMe || (dMe = 1, Object.defineProperty(Y4, "__esModule", { value: true })), Y4;
}
var J4 = {}, fMe;
function fA0() {
  return fMe || (fMe = 1, Object.defineProperty(J4, "__esModule", { value: true })), J4;
}
var K4 = {}, bMe;
function bA0() {
  return bMe || (bMe = 1, Object.defineProperty(K4, "__esModule", { value: true })), K4;
}
var Q4 = {}, MMe;
function MA0() {
  return MMe || (MMe = 1, Object.defineProperty(Q4, "__esModule", { value: true })), Q4;
}
var Z4 = {}, OMe;
function OA0() {
  return OMe || (OMe = 1, Object.defineProperty(Z4, "__esModule", { value: true })), Z4;
}
var eq = {}, zMe;
function zA0() {
  return zMe || (zMe = 1, Object.defineProperty(eq, "__esModule", { value: true })), eq;
}
var tq = {}, AMe;
function AA0() {
  return AMe || (AMe = 1, Object.defineProperty(tq, "__esModule", { value: true })), tq;
}
var rq = {}, _Me;
function _A0() {
  return _Me || (_Me = 1, Object.defineProperty(rq, "__esModule", { value: true })), rq;
}
var nq = {}, hMe;
function hA0() {
  return hMe || (hMe = 1, Object.defineProperty(nq, "__esModule", { value: true })), nq;
}
var aq = {}, vMe;
function vA0() {
  return vMe || (vMe = 1, Object.defineProperty(aq, "__esModule", { value: true })), aq;
}
var oq = {}, mMe;
function mA0() {
  return mMe || (mMe = 1, Object.defineProperty(oq, "__esModule", { value: true })), oq;
}
var iq = {}, RMe;
function RA0() {
  return RMe || (RMe = 1, Object.defineProperty(iq, "__esModule", { value: true })), iq;
}
var uq = {}, qMe;
function qA0() {
  return qMe || (qMe = 1, Object.defineProperty(uq, "__esModule", { value: true })), uq;
}
var sq = {}, TMe;
function TA0() {
  return TMe || (TMe = 1, Object.defineProperty(sq, "__esModule", { value: true })), sq;
}
var cq = {}, yMe;
function yA0() {
  return yMe || (yMe = 1, Object.defineProperty(cq, "__esModule", { value: true })), cq;
}
var lq = {}, SMe;
function SA0() {
  return SMe || (SMe = 1, Object.defineProperty(lq, "__esModule", { value: true })), lq;
}
var pq = {}, CMe;
function CA0() {
  return CMe || (CMe = 1, Object.defineProperty(pq, "__esModule", { value: true })), pq;
}
var dq = {}, gMe;
function gA0() {
  return gMe || (gMe = 1, Object.defineProperty(dq, "__esModule", { value: true })), dq;
}
var fq = {}, IMe;
function IA0() {
  return IMe || (IMe = 1, Object.defineProperty(fq, "__esModule", { value: true })), fq;
}
var bq = {}, EMe;
function EA0() {
  return EMe || (EMe = 1, Object.defineProperty(bq, "__esModule", { value: true })), bq;
}
var Mq = {}, LMe;
function LA0() {
  return LMe || (LMe = 1, Object.defineProperty(Mq, "__esModule", { value: true })), Mq;
}
var Oq = {}, PMe;
function PA0() {
  return PMe || (PMe = 1, Object.defineProperty(Oq, "__esModule", { value: true })), Oq;
}
var zq = {}, DMe;
function DA0() {
  return DMe || (DMe = 1, Object.defineProperty(zq, "__esModule", { value: true })), zq;
}
var Aq = {}, WMe;
function WA0() {
  return WMe || (WMe = 1, Object.defineProperty(Aq, "__esModule", { value: true })), Aq;
}
var _q = {}, NMe;
function NA0() {
  return NMe || (NMe = 1, Object.defineProperty(_q, "__esModule", { value: true })), _q;
}
var hq = {}, wMe;
function wA0() {
  return wMe || (wMe = 1, Object.defineProperty(hq, "__esModule", { value: true })), hq;
}
var vq = {}, BMe;
function BA0() {
  return BMe || (BMe = 1, Object.defineProperty(vq, "__esModule", { value: true })), vq;
}
var mq = {}, xMe;
function xA0() {
  return xMe || (xMe = 1, Object.defineProperty(mq, "__esModule", { value: true })), mq;
}
var Rq = {}, UMe;
function UA0() {
  return UMe || (UMe = 1, Object.defineProperty(Rq, "__esModule", { value: true })), Rq;
}
var qq = {}, kMe;
function kA0() {
  return kMe || (kMe = 1, Object.defineProperty(qq, "__esModule", { value: true })), qq;
}
var Tq = {}, jMe;
function jA0() {
  return jMe || (jMe = 1, Object.defineProperty(Tq, "__esModule", { value: true })), Tq;
}
var yq = {}, FMe;
function FA0() {
  return FMe || (FMe = 1, Object.defineProperty(yq, "__esModule", { value: true })), yq;
}
var Sq = {}, VMe;
function VA0() {
  return VMe || (VMe = 1, Object.defineProperty(Sq, "__esModule", { value: true })), Sq;
}
var Cq = {}, HMe;
function HA0() {
  return HMe || (HMe = 1, Object.defineProperty(Cq, "__esModule", { value: true })), Cq;
}
var gq = {}, XMe;
function XA0() {
  return XMe || (XMe = 1, Object.defineProperty(gq, "__esModule", { value: true })), gq;
}
var Iq = {}, $Me;
function $A0() {
  return $Me || ($Me = 1, Object.defineProperty(Iq, "__esModule", { value: true })), Iq;
}
var Eq = {}, GMe;
function GA0() {
  return GMe || (GMe = 1, Object.defineProperty(Eq, "__esModule", { value: true })), Eq;
}
var Lq = {}, YMe;
function YA0() {
  return YMe || (YMe = 1, Object.defineProperty(Lq, "__esModule", { value: true })), Lq;
}
var Pq = {}, JMe;
function JA0() {
  return JMe || (JMe = 1, Object.defineProperty(Pq, "__esModule", { value: true })), Pq;
}
var Dq = {}, KMe;
function KA0() {
  return KMe || (KMe = 1, Object.defineProperty(Dq, "__esModule", { value: true })), Dq;
}
var Wq = {}, QMe;
function QA0() {
  return QMe || (QMe = 1, Object.defineProperty(Wq, "__esModule", { value: true })), Wq;
}
var Nq = {}, ZMe;
function ZA0() {
  return ZMe || (ZMe = 1, Object.defineProperty(Nq, "__esModule", { value: true })), Nq;
}
var wq = {}, eOe;
function e_0() {
  return eOe || (eOe = 1, Object.defineProperty(wq, "__esModule", { value: true })), wq;
}
var Bq = {}, tOe;
function t_0() {
  return tOe || (tOe = 1, Object.defineProperty(Bq, "__esModule", { value: true })), Bq;
}
var xq = {}, rOe;
function r_0() {
  return rOe || (rOe = 1, Object.defineProperty(xq, "__esModule", { value: true })), xq;
}
var Uq = {}, nOe;
function n_0() {
  return nOe || (nOe = 1, Object.defineProperty(Uq, "__esModule", { value: true })), Uq;
}
var kq = {}, aOe;
function a_0() {
  return aOe || (aOe = 1, Object.defineProperty(kq, "__esModule", { value: true })), kq;
}
var jq = {}, oOe;
function o_0() {
  return oOe || (oOe = 1, Object.defineProperty(jq, "__esModule", { value: true })), jq;
}
var Fq = {}, iOe;
function i_0() {
  return iOe || (iOe = 1, Object.defineProperty(Fq, "__esModule", { value: true })), Fq;
}
var Vq = {}, uOe;
function u_0() {
  return uOe || (uOe = 1, Object.defineProperty(Vq, "__esModule", { value: true })), Vq;
}
var Hq = {}, sOe;
function s_0() {
  return sOe || (sOe = 1, Object.defineProperty(Hq, "__esModule", { value: true })), Hq;
}
var Xq = {}, cOe;
function c_0() {
  return cOe || (cOe = 1, Object.defineProperty(Xq, "__esModule", { value: true })), Xq;
}
var $q = {}, lOe;
function l_0() {
  return lOe || (lOe = 1, Object.defineProperty($q, "__esModule", { value: true })), $q;
}
var Gq = {}, pOe;
function p_0() {
  return pOe || (pOe = 1, Object.defineProperty(Gq, "__esModule", { value: true })), Gq;
}
var Yq = {}, dOe;
function d_0() {
  return dOe || (dOe = 1, Object.defineProperty(Yq, "__esModule", { value: true })), Yq;
}
var Jq = {}, fOe;
function f_0() {
  return fOe || (fOe = 1, Object.defineProperty(Jq, "__esModule", { value: true })), Jq;
}
var Kq = {}, bOe;
function b_0() {
  return bOe || (bOe = 1, Object.defineProperty(Kq, "__esModule", { value: true })), Kq;
}
var Qq = {}, MOe;
function M_0() {
  return MOe || (MOe = 1, Object.defineProperty(Qq, "__esModule", { value: true })), Qq;
}
var Zq = {}, OOe;
function O_0() {
  return OOe || (OOe = 1, Object.defineProperty(Zq, "__esModule", { value: true })), Zq;
}
var eT = {}, zOe;
function z_0() {
  return zOe || (zOe = 1, Object.defineProperty(eT, "__esModule", { value: true })), eT;
}
var tT = {}, AOe;
function A_0() {
  return AOe || (AOe = 1, Object.defineProperty(tT, "__esModule", { value: true })), tT;
}
var rT = {}, _Oe;
function __0() {
  return _Oe || (_Oe = 1, Object.defineProperty(rT, "__esModule", { value: true })), rT;
}
var nT = {}, hOe;
function h_0() {
  return hOe || (hOe = 1, Object.defineProperty(nT, "__esModule", { value: true })), nT;
}
var aT = {}, vOe;
function v_0() {
  return vOe || (vOe = 1, Object.defineProperty(aT, "__esModule", { value: true })), aT;
}
var oT = {}, mOe;
function m_0() {
  return mOe || (mOe = 1, Object.defineProperty(oT, "__esModule", { value: true })), oT;
}
var iT = {}, ROe;
function R_0() {
  return ROe || (ROe = 1, Object.defineProperty(iT, "__esModule", { value: true })), iT;
}
var uT = {}, qOe;
function q_0() {
  return qOe || (qOe = 1, Object.defineProperty(uT, "__esModule", { value: true })), uT;
}
var sT = {}, TOe;
function T_0() {
  return TOe || (TOe = 1, Object.defineProperty(sT, "__esModule", { value: true })), sT;
}
var cT = {}, yOe;
function y_0() {
  return yOe || (yOe = 1, Object.defineProperty(cT, "__esModule", { value: true })), cT;
}
var lT = {}, SOe;
function S_0() {
  return SOe || (SOe = 1, Object.defineProperty(lT, "__esModule", { value: true })), lT;
}
var pT = {}, COe;
function C_0() {
  return COe || (COe = 1, Object.defineProperty(pT, "__esModule", { value: true })), pT;
}
var dT = {}, gOe;
function g_0() {
  return gOe || (gOe = 1, Object.defineProperty(dT, "__esModule", { value: true })), dT;
}
var fT = {}, IOe;
function I_0() {
  return IOe || (IOe = 1, Object.defineProperty(fT, "__esModule", { value: true })), fT;
}
var bT = {}, EOe;
function E_0() {
  return EOe || (EOe = 1, Object.defineProperty(bT, "__esModule", { value: true })), bT;
}
var MT = {}, LOe;
function L_0() {
  return LOe || (LOe = 1, Object.defineProperty(MT, "__esModule", { value: true })), MT;
}
var OT = {}, POe;
function P_0() {
  return POe || (POe = 1, Object.defineProperty(OT, "__esModule", { value: true })), OT;
}
var zT = {}, DOe;
function D_0() {
  return DOe || (DOe = 1, Object.defineProperty(zT, "__esModule", { value: true })), zT;
}
var AT = {}, WOe;
function W_0() {
  return WOe || (WOe = 1, Object.defineProperty(AT, "__esModule", { value: true })), AT;
}
var _T = {}, NOe;
function N_0() {
  return NOe || (NOe = 1, Object.defineProperty(_T, "__esModule", { value: true })), _T;
}
var hT = {}, wOe;
function w_0() {
  return wOe || (wOe = 1, Object.defineProperty(hT, "__esModule", { value: true })), hT;
}
var vT = {}, BOe;
function B_0() {
  return BOe || (BOe = 1, Object.defineProperty(vT, "__esModule", { value: true })), vT;
}
var mT = {}, xOe;
function x_0() {
  return xOe || (xOe = 1, Object.defineProperty(mT, "__esModule", { value: true })), mT;
}
var RT = {}, UOe;
function U_0() {
  return UOe || (UOe = 1, Object.defineProperty(RT, "__esModule", { value: true })), RT;
}
var qT = {}, kOe;
function k_0() {
  return kOe || (kOe = 1, Object.defineProperty(qT, "__esModule", { value: true })), qT;
}
var TT = {}, jOe;
function j_0() {
  return jOe || (jOe = 1, Object.defineProperty(TT, "__esModule", { value: true })), TT;
}
var yT = {}, FOe;
function F_0() {
  return FOe || (FOe = 1, Object.defineProperty(yT, "__esModule", { value: true })), yT;
}
var ST = {}, VOe;
function V_0() {
  return VOe || (VOe = 1, Object.defineProperty(ST, "__esModule", { value: true })), ST;
}
var CT = {}, HOe;
function H_0() {
  return HOe || (HOe = 1, Object.defineProperty(CT, "__esModule", { value: true })), CT;
}
var gT = {}, XOe;
function X_0() {
  return XOe || (XOe = 1, Object.defineProperty(gT, "__esModule", { value: true })), gT;
}
var IT = {}, $Oe;
function $_0() {
  return $Oe || ($Oe = 1, Object.defineProperty(IT, "__esModule", { value: true })), IT;
}
var ET = {}, GOe;
function G_0() {
  return GOe || (GOe = 1, Object.defineProperty(ET, "__esModule", { value: true })), ET;
}
var LT = {}, YOe;
function Y_0() {
  return YOe || (YOe = 1, Object.defineProperty(LT, "__esModule", { value: true })), LT;
}
var PT = {}, JOe;
function J_0() {
  return JOe || (JOe = 1, Object.defineProperty(PT, "__esModule", { value: true })), PT;
}
var DT = {}, KOe;
function K_0() {
  return KOe || (KOe = 1, Object.defineProperty(DT, "__esModule", { value: true })), DT;
}
var WT = {}, QOe;
function Q_0() {
  return QOe || (QOe = 1, Object.defineProperty(WT, "__esModule", { value: true })), WT;
}
var NT = {}, ZOe;
function Z_0() {
  return ZOe || (ZOe = 1, Object.defineProperty(NT, "__esModule", { value: true })), NT;
}
var wT = {}, e3e;
function eh0() {
  return e3e || (e3e = 1, Object.defineProperty(wT, "__esModule", { value: true })), wT;
}
var BT = {}, t3e;
function th0() {
  return t3e || (t3e = 1, Object.defineProperty(BT, "__esModule", { value: true })), BT;
}
var xT = {}, r3e;
function rh0() {
  return r3e || (r3e = 1, Object.defineProperty(xT, "__esModule", { value: true })), xT;
}
var UT = {}, n3e;
function nh0() {
  return n3e || (n3e = 1, Object.defineProperty(UT, "__esModule", { value: true })), UT;
}
var kT = {}, a3e;
function ah0() {
  return a3e || (a3e = 1, Object.defineProperty(kT, "__esModule", { value: true })), kT;
}
var jT = {}, o3e;
function oh0() {
  return o3e || (o3e = 1, Object.defineProperty(jT, "__esModule", { value: true })), jT;
}
var FT = {}, i3e;
function ih0() {
  return i3e || (i3e = 1, Object.defineProperty(FT, "__esModule", { value: true })), FT;
}
var VT = {}, u3e;
function uh0() {
  return u3e || (u3e = 1, Object.defineProperty(VT, "__esModule", { value: true })), VT;
}
var HT = {}, s3e;
function sh0() {
  return s3e || (s3e = 1, Object.defineProperty(HT, "__esModule", { value: true })), HT;
}
var XT = {}, c3e;
function ch0() {
  return c3e || (c3e = 1, Object.defineProperty(XT, "__esModule", { value: true })), XT;
}
var $T = {}, l3e;
function lh0() {
  return l3e || (l3e = 1, Object.defineProperty($T, "__esModule", { value: true })), $T;
}
var GT = {}, p3e;
function ph0() {
  return p3e || (p3e = 1, Object.defineProperty(GT, "__esModule", { value: true })), GT;
}
var YT = {}, d3e;
function dh0() {
  return d3e || (d3e = 1, Object.defineProperty(YT, "__esModule", { value: true })), YT;
}
var JT = {}, f3e;
function fh0() {
  return f3e || (f3e = 1, Object.defineProperty(JT, "__esModule", { value: true })), JT;
}
var KT = {}, b3e;
function bh0() {
  return b3e || (b3e = 1, Object.defineProperty(KT, "__esModule", { value: true })), KT;
}
var QT = {}, M3e;
function Mh0() {
  return M3e || (M3e = 1, Object.defineProperty(QT, "__esModule", { value: true })), QT;
}
var ZT = {}, O3e;
function Oh0() {
  return O3e || (O3e = 1, Object.defineProperty(ZT, "__esModule", { value: true })), ZT;
}
var ey = {}, z3e;
function zh0() {
  return z3e || (z3e = 1, Object.defineProperty(ey, "__esModule", { value: true })), ey;
}
var ty = {}, A3e;
function Ah0() {
  return A3e || (A3e = 1, Object.defineProperty(ty, "__esModule", { value: true })), ty;
}
var ry = {}, _3e;
function _h0() {
  return _3e || (_3e = 1, Object.defineProperty(ry, "__esModule", { value: true })), ry;
}
var ny = {}, h3e;
function hh0() {
  return h3e || (h3e = 1, Object.defineProperty(ny, "__esModule", { value: true })), ny;
}
var ay = {}, v3e;
function vh0() {
  return v3e || (v3e = 1, Object.defineProperty(ay, "__esModule", { value: true })), ay;
}
var oy = {}, m3e;
function mh0() {
  return m3e || (m3e = 1, Object.defineProperty(oy, "__esModule", { value: true })), oy;
}
var iy = {}, R3e;
function Rh0() {
  return R3e || (R3e = 1, Object.defineProperty(iy, "__esModule", { value: true })), iy;
}
var uy = {}, q3e;
function qh0() {
  return q3e || (q3e = 1, Object.defineProperty(uy, "__esModule", { value: true })), uy;
}
var sy = {}, T3e;
function Th0() {
  return T3e || (T3e = 1, Object.defineProperty(sy, "__esModule", { value: true })), sy;
}
var cy = {}, y3e;
function yh0() {
  return y3e || (y3e = 1, Object.defineProperty(cy, "__esModule", { value: true })), cy;
}
var ly = {}, S3e;
function Sh0() {
  return S3e || (S3e = 1, Object.defineProperty(ly, "__esModule", { value: true })), ly;
}
var py = {}, C3e;
function Ch0() {
  return C3e || (C3e = 1, Object.defineProperty(py, "__esModule", { value: true })), py;
}
var dy = {}, g3e;
function gh0() {
  return g3e || (g3e = 1, Object.defineProperty(dy, "__esModule", { value: true })), dy;
}
var fy = {}, I3e;
function Ih0() {
  return I3e || (I3e = 1, Object.defineProperty(fy, "__esModule", { value: true })), fy;
}
var by = {}, E3e;
function Eh0() {
  return E3e || (E3e = 1, Object.defineProperty(by, "__esModule", { value: true })), by;
}
var My = {}, L3e;
function Lh0() {
  return L3e || (L3e = 1, Object.defineProperty(My, "__esModule", { value: true })), My;
}
var Oy = {}, P3e;
function Ph0() {
  return P3e || (P3e = 1, Object.defineProperty(Oy, "__esModule", { value: true })), Oy;
}
var zy = {}, D3e;
function Dh0() {
  return D3e || (D3e = 1, Object.defineProperty(zy, "__esModule", { value: true })), zy;
}
var Ay = {}, W3e;
function Wh0() {
  return W3e || (W3e = 1, Object.defineProperty(Ay, "__esModule", { value: true })), Ay;
}
var _y = {}, N3e;
function Nh0() {
  return N3e || (N3e = 1, Object.defineProperty(_y, "__esModule", { value: true })), _y;
}
var hy = {}, w3e;
function wh0() {
  return w3e || (w3e = 1, Object.defineProperty(hy, "__esModule", { value: true })), hy;
}
var vy = {}, B3e;
function Bh0() {
  return B3e || (B3e = 1, Object.defineProperty(vy, "__esModule", { value: true })), vy;
}
var my = {}, x3e;
function xh0() {
  return x3e || (x3e = 1, Object.defineProperty(my, "__esModule", { value: true })), my;
}
var Ry = {}, U3e;
function Uh0() {
  return U3e || (U3e = 1, Object.defineProperty(Ry, "__esModule", { value: true })), Ry;
}
var qy = {}, k3e;
function kh0() {
  return k3e || (k3e = 1, Object.defineProperty(qy, "__esModule", { value: true })), qy;
}
var Ty = {}, j3e;
function jh0() {
  return j3e || (j3e = 1, Object.defineProperty(Ty, "__esModule", { value: true })), Ty;
}
var yy = {}, F3e;
function Fh0() {
  return F3e || (F3e = 1, Object.defineProperty(yy, "__esModule", { value: true })), yy;
}
var Sy = {}, V3e;
function Vh0() {
  return V3e || (V3e = 1, Object.defineProperty(Sy, "__esModule", { value: true })), Sy;
}
var Cy = {}, H3e;
function Hh0() {
  return H3e || (H3e = 1, Object.defineProperty(Cy, "__esModule", { value: true })), Cy;
}
var gy = {}, X3e;
function Xh0() {
  return X3e || (X3e = 1, Object.defineProperty(gy, "__esModule", { value: true })), gy;
}
var Iy = {}, $3e;
function $h0() {
  return $3e || ($3e = 1, Object.defineProperty(Iy, "__esModule", { value: true })), Iy;
}
var Ey = {}, G3e;
function Gh0() {
  return G3e || (G3e = 1, Object.defineProperty(Ey, "__esModule", { value: true })), Ey;
}
var Ly = {}, Y3e;
function Yh0() {
  return Y3e || (Y3e = 1, Object.defineProperty(Ly, "__esModule", { value: true })), Ly;
}
var Py = {}, J3e;
function Jh0() {
  return J3e || (J3e = 1, Object.defineProperty(Py, "__esModule", { value: true })), Py;
}
var Dy = {}, K3e;
function Kh0() {
  return K3e || (K3e = 1, Object.defineProperty(Dy, "__esModule", { value: true })), Dy;
}
var Wy = {}, Q3e;
function Qh0() {
  return Q3e || (Q3e = 1, Object.defineProperty(Wy, "__esModule", { value: true })), Wy;
}
var Ny = {}, Z3e;
function Zh0() {
  return Z3e || (Z3e = 1, Object.defineProperty(Ny, "__esModule", { value: true })), Ny;
}
var wy = {}, eze;
function ev0() {
  return eze || (eze = 1, Object.defineProperty(wy, "__esModule", { value: true })), wy;
}
var By = {}, tze;
function tv0() {
  return tze || (tze = 1, Object.defineProperty(By, "__esModule", { value: true })), By;
}
var xy = {}, rze;
function rv0() {
  return rze || (rze = 1, Object.defineProperty(xy, "__esModule", { value: true })), xy;
}
var Uy = {}, nze;
function nv0() {
  return nze || (nze = 1, Object.defineProperty(Uy, "__esModule", { value: true })), Uy;
}
var ky = {}, aze;
function av0() {
  return aze || (aze = 1, Object.defineProperty(ky, "__esModule", { value: true })), ky;
}
var jy = {}, oze;
function ov0() {
  return oze || (oze = 1, Object.defineProperty(jy, "__esModule", { value: true })), jy;
}
var Fy = {}, ize;
function iv0() {
  return ize || (ize = 1, Object.defineProperty(Fy, "__esModule", { value: true })), Fy;
}
var Vy = {}, uze;
function uv0() {
  return uze || (uze = 1, Object.defineProperty(Vy, "__esModule", { value: true })), Vy;
}
var Hy = {}, sze;
function sv0() {
  return sze || (sze = 1, Object.defineProperty(Hy, "__esModule", { value: true })), Hy;
}
var Xy = {}, cze;
function cv0() {
  return cze || (cze = 1, Object.defineProperty(Xy, "__esModule", { value: true })), Xy;
}
var $y = {}, lze;
function lv0() {
  return lze || (lze = 1, Object.defineProperty($y, "__esModule", { value: true })), $y;
}
var Gy = {}, pze;
function pv0() {
  return pze || (pze = 1, Object.defineProperty(Gy, "__esModule", { value: true })), Gy;
}
var Yy = {}, dze;
function dv0() {
  return dze || (dze = 1, Object.defineProperty(Yy, "__esModule", { value: true })), Yy;
}
var Jy = {}, fze;
function fv0() {
  return fze || (fze = 1, Object.defineProperty(Jy, "__esModule", { value: true })), Jy;
}
var Ky = {}, bze;
function bv0() {
  return bze || (bze = 1, Object.defineProperty(Ky, "__esModule", { value: true })), Ky;
}
var Qy = {}, Mze;
function Mv0() {
  return Mze || (Mze = 1, Object.defineProperty(Qy, "__esModule", { value: true })), Qy;
}
var Zy = {}, Oze;
function Ov0() {
  return Oze || (Oze = 1, Object.defineProperty(Zy, "__esModule", { value: true })), Zy;
}
var e5 = {}, zze;
function zv0() {
  return zze || (zze = 1, Object.defineProperty(e5, "__esModule", { value: true })), e5;
}
var t5 = {}, Aze;
function Av0() {
  return Aze || (Aze = 1, Object.defineProperty(t5, "__esModule", { value: true })), t5;
}
var r5 = {}, _ze;
function _v0() {
  return _ze || (_ze = 1, Object.defineProperty(r5, "__esModule", { value: true })), r5;
}
var n5 = {}, hze;
function hv0() {
  return hze || (hze = 1, Object.defineProperty(n5, "__esModule", { value: true })), n5;
}
var a5 = {}, vze;
function vv0() {
  return vze || (vze = 1, Object.defineProperty(a5, "__esModule", { value: true })), a5;
}
var o5 = {}, mze;
function mv0() {
  return mze || (mze = 1, Object.defineProperty(o5, "__esModule", { value: true })), o5;
}
var i5 = {}, Rze;
function Rv0() {
  return Rze || (Rze = 1, Object.defineProperty(i5, "__esModule", { value: true })), i5;
}
var u5 = {}, qze;
function qv0() {
  return qze || (qze = 1, Object.defineProperty(u5, "__esModule", { value: true })), u5;
}
var s5 = {}, Tze;
function Tv0() {
  return Tze || (Tze = 1, Object.defineProperty(s5, "__esModule", { value: true })), s5;
}
var c5 = {}, yze;
function yv0() {
  return yze || (yze = 1, Object.defineProperty(c5, "__esModule", { value: true })), c5;
}
var l5 = {}, Sze;
function Sv0() {
  return Sze || (Sze = 1, Object.defineProperty(l5, "__esModule", { value: true })), l5;
}
var p5 = {}, Cze;
function Cv0() {
  return Cze || (Cze = 1, Object.defineProperty(p5, "__esModule", { value: true })), p5;
}
var d5 = {}, gze;
function gv0() {
  return gze || (gze = 1, Object.defineProperty(d5, "__esModule", { value: true })), d5;
}
var f5 = {}, Ize;
function Iv0() {
  return Ize || (Ize = 1, Object.defineProperty(f5, "__esModule", { value: true })), f5;
}
var b5 = {}, Eze;
function Ev0() {
  return Eze || (Eze = 1, Object.defineProperty(b5, "__esModule", { value: true })), b5;
}
var M5 = {}, Lze;
function Lv0() {
  return Lze || (Lze = 1, Object.defineProperty(M5, "__esModule", { value: true })), M5;
}
var O5 = {}, Pze;
function Pv0() {
  return Pze || (Pze = 1, Object.defineProperty(O5, "__esModule", { value: true })), O5;
}
var z5 = {}, Dze;
function Dv0() {
  return Dze || (Dze = 1, Object.defineProperty(z5, "__esModule", { value: true })), z5;
}
var A5 = {}, Wze;
function Wv0() {
  return Wze || (Wze = 1, Object.defineProperty(A5, "__esModule", { value: true })), A5;
}
var _5 = {}, Nze;
function Nv0() {
  return Nze || (Nze = 1, Object.defineProperty(_5, "__esModule", { value: true })), _5;
}
var h5 = {}, wze;
function wv0() {
  return wze || (wze = 1, Object.defineProperty(h5, "__esModule", { value: true })), h5;
}
var v5 = {}, Bze;
function Bv0() {
  return Bze || (Bze = 1, Object.defineProperty(v5, "__esModule", { value: true })), v5;
}
var m5 = {}, xze;
function xv0() {
  return xze || (xze = 1, Object.defineProperty(m5, "__esModule", { value: true })), m5;
}
var R5 = {}, Uze;
function Uv0() {
  return Uze || (Uze = 1, Object.defineProperty(R5, "__esModule", { value: true })), R5;
}
var q5 = {}, kze;
function kv0() {
  return kze || (kze = 1, Object.defineProperty(q5, "__esModule", { value: true })), q5;
}
var T5 = {}, jze;
function jv0() {
  return jze || (jze = 1, Object.defineProperty(T5, "__esModule", { value: true })), T5;
}
var y5 = {}, Fze;
function Fv0() {
  return Fze || (Fze = 1, Object.defineProperty(y5, "__esModule", { value: true })), y5;
}
var S5 = {}, Vze;
function Vv0() {
  return Vze || (Vze = 1, Object.defineProperty(S5, "__esModule", { value: true })), S5;
}
var C5 = {}, Hze;
function Hv0() {
  return Hze || (Hze = 1, Object.defineProperty(C5, "__esModule", { value: true })), C5;
}
var g5 = {}, Xze;
function Xv0() {
  return Xze || (Xze = 1, Object.defineProperty(g5, "__esModule", { value: true })), g5;
}
var I5 = {}, $ze;
function $v0() {
  return $ze || ($ze = 1, Object.defineProperty(I5, "__esModule", { value: true })), I5;
}
var E5 = {}, Gze;
function Gv0() {
  return Gze || (Gze = 1, Object.defineProperty(E5, "__esModule", { value: true })), E5;
}
var L5 = {}, Yze;
function Yv0() {
  return Yze || (Yze = 1, Object.defineProperty(L5, "__esModule", { value: true })), L5;
}
var P5 = {}, Jze;
function Jv0() {
  return Jze || (Jze = 1, Object.defineProperty(P5, "__esModule", { value: true })), P5;
}
var D5 = {}, Kze;
function Kv0() {
  return Kze || (Kze = 1, Object.defineProperty(D5, "__esModule", { value: true })), D5;
}
var W5 = {}, Qze;
function Qv0() {
  return Qze || (Qze = 1, Object.defineProperty(W5, "__esModule", { value: true })), W5;
}
var N5 = {}, Zze;
function Zv0() {
  return Zze || (Zze = 1, Object.defineProperty(N5, "__esModule", { value: true })), N5;
}
var w5 = {}, eAe;
function em0() {
  return eAe || (eAe = 1, Object.defineProperty(w5, "__esModule", { value: true })), w5;
}
var B5 = {}, tAe;
function tm0() {
  return tAe || (tAe = 1, Object.defineProperty(B5, "__esModule", { value: true })), B5;
}
var x5 = {}, rAe;
function rm0() {
  return rAe || (rAe = 1, Object.defineProperty(x5, "__esModule", { value: true })), x5;
}
var U5 = {}, nAe;
function nm0() {
  return nAe || (nAe = 1, Object.defineProperty(U5, "__esModule", { value: true })), U5;
}
var k5 = {}, aAe;
function am0() {
  return aAe || (aAe = 1, Object.defineProperty(k5, "__esModule", { value: true })), k5;
}
var j5 = {}, oAe;
function om0() {
  return oAe || (oAe = 1, Object.defineProperty(j5, "__esModule", { value: true })), j5;
}
var F5 = {}, iAe;
function im0() {
  return iAe || (iAe = 1, Object.defineProperty(F5, "__esModule", { value: true })), F5;
}
var V5 = {}, uAe;
function um0() {
  return uAe || (uAe = 1, Object.defineProperty(V5, "__esModule", { value: true })), V5;
}
var H5 = {}, sAe;
function sm0() {
  return sAe || (sAe = 1, Object.defineProperty(H5, "__esModule", { value: true })), H5;
}
var X5 = {}, cAe;
function cm0() {
  return cAe || (cAe = 1, Object.defineProperty(X5, "__esModule", { value: true })), X5;
}
var $5 = {}, lAe;
function lm0() {
  return lAe || (lAe = 1, Object.defineProperty($5, "__esModule", { value: true })), $5;
}
var G5 = {}, pAe;
function pm0() {
  return pAe || (pAe = 1, Object.defineProperty(G5, "__esModule", { value: true })), G5;
}
var Y5 = {}, dAe;
function dm0() {
  return dAe || (dAe = 1, Object.defineProperty(Y5, "__esModule", { value: true })), Y5;
}
var J5 = {}, fAe;
function fm0() {
  return fAe || (fAe = 1, Object.defineProperty(J5, "__esModule", { value: true })), J5;
}
var K5 = {}, bAe;
function bm0() {
  return bAe || (bAe = 1, Object.defineProperty(K5, "__esModule", { value: true })), K5;
}
var Q5 = {}, MAe;
function Mm0() {
  return MAe || (MAe = 1, Object.defineProperty(Q5, "__esModule", { value: true })), Q5;
}
var Z5 = {}, OAe;
function Om0() {
  return OAe || (OAe = 1, Object.defineProperty(Z5, "__esModule", { value: true })), Z5;
}
var eS = {}, zAe;
function zm0() {
  return zAe || (zAe = 1, Object.defineProperty(eS, "__esModule", { value: true })), eS;
}
var tS = {}, AAe;
function Am0() {
  return AAe || (AAe = 1, Object.defineProperty(tS, "__esModule", { value: true })), tS;
}
var rS = {}, _Ae;
function _m0() {
  return _Ae || (_Ae = 1, Object.defineProperty(rS, "__esModule", { value: true })), rS;
}
var nS = {}, hAe;
function hm0() {
  return hAe || (hAe = 1, Object.defineProperty(nS, "__esModule", { value: true })), nS;
}
var aS = {}, vAe;
function vm0() {
  return vAe || (vAe = 1, Object.defineProperty(aS, "__esModule", { value: true })), aS;
}
var oS = {}, mAe;
function mm0() {
  return mAe || (mAe = 1, Object.defineProperty(oS, "__esModule", { value: true })), oS;
}
var iS = {}, RAe;
function Rm0() {
  return RAe || (RAe = 1, Object.defineProperty(iS, "__esModule", { value: true })), iS;
}
var uS = {}, qAe;
function qm0() {
  return qAe || (qAe = 1, Object.defineProperty(uS, "__esModule", { value: true })), uS;
}
var sS = {}, TAe;
function Tm0() {
  return TAe || (TAe = 1, Object.defineProperty(sS, "__esModule", { value: true })), sS;
}
var cS = {}, yAe;
function ym0() {
  return yAe || (yAe = 1, Object.defineProperty(cS, "__esModule", { value: true })), cS;
}
var lS = {}, SAe;
function Sm0() {
  return SAe || (SAe = 1, Object.defineProperty(lS, "__esModule", { value: true })), lS;
}
var pS = {}, CAe;
function Cm0() {
  return CAe || (CAe = 1, Object.defineProperty(pS, "__esModule", { value: true })), pS;
}
var dS = {}, gAe;
function gm0() {
  return gAe || (gAe = 1, Object.defineProperty(dS, "__esModule", { value: true })), dS;
}
var fS = {}, IAe;
function Im0() {
  return IAe || (IAe = 1, Object.defineProperty(fS, "__esModule", { value: true })), fS;
}
var bS = {}, EAe;
function Em0() {
  return EAe || (EAe = 1, Object.defineProperty(bS, "__esModule", { value: true })), bS;
}
var MS = {}, LAe;
function Lm0() {
  return LAe || (LAe = 1, Object.defineProperty(MS, "__esModule", { value: true })), MS;
}
var OS = {}, PAe;
function Pm0() {
  return PAe || (PAe = 1, Object.defineProperty(OS, "__esModule", { value: true })), OS;
}
var zS = {}, DAe;
function Dm0() {
  return DAe || (DAe = 1, Object.defineProperty(zS, "__esModule", { value: true })), zS;
}
var AS = {}, WAe;
function Wm0() {
  return WAe || (WAe = 1, Object.defineProperty(AS, "__esModule", { value: true })), AS;
}
var _S = {}, NAe;
function Nm0() {
  return NAe || (NAe = 1, Object.defineProperty(_S, "__esModule", { value: true })), _S;
}
var hS = {}, wAe;
function wm0() {
  return wAe || (wAe = 1, Object.defineProperty(hS, "__esModule", { value: true })), hS;
}
var vS = {}, BAe;
function Bm0() {
  return BAe || (BAe = 1, Object.defineProperty(vS, "__esModule", { value: true })), vS;
}
var mS = {}, xAe;
function xm0() {
  return xAe || (xAe = 1, Object.defineProperty(mS, "__esModule", { value: true })), mS;
}
var RS = {}, UAe;
function Um0() {
  return UAe || (UAe = 1, Object.defineProperty(RS, "__esModule", { value: true })), RS;
}
var qS = {}, kAe;
function km0() {
  return kAe || (kAe = 1, Object.defineProperty(qS, "__esModule", { value: true })), qS;
}
var TS = {}, jAe;
function jm0() {
  return jAe || (jAe = 1, Object.defineProperty(TS, "__esModule", { value: true })), TS;
}
var yS = {}, FAe;
function Fm0() {
  return FAe || (FAe = 1, Object.defineProperty(yS, "__esModule", { value: true })), yS;
}
var SS = {}, VAe;
function Vm0() {
  return VAe || (VAe = 1, Object.defineProperty(SS, "__esModule", { value: true })), SS;
}
var CS = {}, HAe;
function Hm0() {
  return HAe || (HAe = 1, Object.defineProperty(CS, "__esModule", { value: true })), CS;
}
var gS = {}, XAe;
function Xm0() {
  return XAe || (XAe = 1, Object.defineProperty(gS, "__esModule", { value: true })), gS;
}
var IS = {}, $Ae;
function $m0() {
  return $Ae || ($Ae = 1, Object.defineProperty(IS, "__esModule", { value: true })), IS;
}
var ES = {}, GAe;
function Gm0() {
  return GAe || (GAe = 1, Object.defineProperty(ES, "__esModule", { value: true })), ES;
}
var LS = {}, YAe;
function Ym0() {
  return YAe || (YAe = 1, Object.defineProperty(LS, "__esModule", { value: true })), LS;
}
var PS = {}, JAe;
function Jm0() {
  return JAe || (JAe = 1, Object.defineProperty(PS, "__esModule", { value: true })), PS;
}
var DS = {}, KAe;
function Km0() {
  return KAe || (KAe = 1, Object.defineProperty(DS, "__esModule", { value: true })), DS;
}
var WS = {}, QAe;
function Qm0() {
  return QAe || (QAe = 1, Object.defineProperty(WS, "__esModule", { value: true })), WS;
}
var NS = {}, ZAe;
function Zm0() {
  return ZAe || (ZAe = 1, Object.defineProperty(NS, "__esModule", { value: true })), NS;
}
var wS = {}, e_e;
function eR0() {
  return e_e || (e_e = 1, Object.defineProperty(wS, "__esModule", { value: true })), wS;
}
var BS = {}, t_e;
function tR0() {
  return t_e || (t_e = 1, Object.defineProperty(BS, "__esModule", { value: true })), BS;
}
var xS = {}, r_e;
function rR0() {
  return r_e || (r_e = 1, Object.defineProperty(xS, "__esModule", { value: true })), xS;
}
var US = {}, n_e;
function nR0() {
  return n_e || (n_e = 1, Object.defineProperty(US, "__esModule", { value: true })), US;
}
var kS = {}, a_e;
function aR0() {
  return a_e || (a_e = 1, Object.defineProperty(kS, "__esModule", { value: true })), kS;
}
var jS = {}, o_e;
function oR0() {
  return o_e || (o_e = 1, Object.defineProperty(jS, "__esModule", { value: true })), jS;
}
var FS = {}, i_e;
function iR0() {
  return i_e || (i_e = 1, Object.defineProperty(FS, "__esModule", { value: true })), FS;
}
var VS = {}, u_e;
function uR0() {
  return u_e || (u_e = 1, Object.defineProperty(VS, "__esModule", { value: true })), VS;
}
var HS = {}, s_e;
function sR0() {
  return s_e || (s_e = 1, Object.defineProperty(HS, "__esModule", { value: true })), HS;
}
var XS = {}, c_e;
function cR0() {
  return c_e || (c_e = 1, Object.defineProperty(XS, "__esModule", { value: true })), XS;
}
var $S = {}, l_e;
function lR0() {
  return l_e || (l_e = 1, Object.defineProperty($S, "__esModule", { value: true })), $S;
}
var GS = {}, p_e;
function pR0() {
  return p_e || (p_e = 1, Object.defineProperty(GS, "__esModule", { value: true })), GS;
}
var YS = {}, d_e;
function dR0() {
  return d_e || (d_e = 1, Object.defineProperty(YS, "__esModule", { value: true })), YS;
}
var JS = {}, f_e;
function fR0() {
  return f_e || (f_e = 1, Object.defineProperty(JS, "__esModule", { value: true })), JS;
}
var KS = {}, b_e;
function bR0() {
  return b_e || (b_e = 1, Object.defineProperty(KS, "__esModule", { value: true })), KS;
}
var QS = {}, M_e;
function MR0() {
  return M_e || (M_e = 1, Object.defineProperty(QS, "__esModule", { value: true })), QS;
}
var ZS = {}, O_e;
function OR0() {
  return O_e || (O_e = 1, Object.defineProperty(ZS, "__esModule", { value: true })), ZS;
}
var e6 = {}, z_e;
function zR0() {
  return z_e || (z_e = 1, Object.defineProperty(e6, "__esModule", { value: true })), e6;
}
var t6 = {}, A_e;
function AR0() {
  return A_e || (A_e = 1, Object.defineProperty(t6, "__esModule", { value: true })), t6;
}
var r6 = {}, __e;
function _R0() {
  return __e || (__e = 1, Object.defineProperty(r6, "__esModule", { value: true })), r6;
}
var n6 = {}, h_e;
function hR0() {
  return h_e || (h_e = 1, Object.defineProperty(n6, "__esModule", { value: true })), n6;
}
var a6 = {}, v_e;
function vR0() {
  return v_e || (v_e = 1, Object.defineProperty(a6, "__esModule", { value: true })), a6;
}
var o6 = {}, m_e;
function mR0() {
  return m_e || (m_e = 1, Object.defineProperty(o6, "__esModule", { value: true })), o6;
}
var i6 = {}, R_e;
function RR0() {
  return R_e || (R_e = 1, Object.defineProperty(i6, "__esModule", { value: true })), i6;
}
var u6 = {}, q_e;
function qR0() {
  return q_e || (q_e = 1, Object.defineProperty(u6, "__esModule", { value: true })), u6;
}
var s6 = {}, T_e;
function TR0() {
  return T_e || (T_e = 1, Object.defineProperty(s6, "__esModule", { value: true })), s6;
}
var c6 = {}, y_e;
function yR0() {
  return y_e || (y_e = 1, Object.defineProperty(c6, "__esModule", { value: true })), c6;
}
var l6 = {}, S_e;
function SR0() {
  return S_e || (S_e = 1, Object.defineProperty(l6, "__esModule", { value: true })), l6;
}
var p6 = {}, C_e;
function CR0() {
  return C_e || (C_e = 1, Object.defineProperty(p6, "__esModule", { value: true })), p6;
}
var d6 = {}, g_e;
function gR0() {
  return g_e || (g_e = 1, Object.defineProperty(d6, "__esModule", { value: true })), d6;
}
var f6 = {}, I_e;
function IR0() {
  return I_e || (I_e = 1, Object.defineProperty(f6, "__esModule", { value: true })), f6;
}
var b6 = {}, E_e;
function ER0() {
  return E_e || (E_e = 1, Object.defineProperty(b6, "__esModule", { value: true })), b6;
}
var M6 = {}, L_e;
function LR0() {
  return L_e || (L_e = 1, Object.defineProperty(M6, "__esModule", { value: true })), M6;
}
var O6 = {}, P_e;
function PR0() {
  return P_e || (P_e = 1, Object.defineProperty(O6, "__esModule", { value: true })), O6;
}
var z6 = {}, D_e;
function DR0() {
  return D_e || (D_e = 1, Object.defineProperty(z6, "__esModule", { value: true })), z6;
}
var A6 = {}, W_e;
function WR0() {
  return W_e || (W_e = 1, Object.defineProperty(A6, "__esModule", { value: true })), A6;
}
var _6 = {}, N_e;
function NR0() {
  return N_e || (N_e = 1, Object.defineProperty(_6, "__esModule", { value: true })), _6;
}
var h6 = {}, w_e;
function wR0() {
  return w_e || (w_e = 1, Object.defineProperty(h6, "__esModule", { value: true })), h6;
}
var v6 = {}, B_e;
function BR0() {
  return B_e || (B_e = 1, Object.defineProperty(v6, "__esModule", { value: true })), v6;
}
var m6 = {}, x_e;
function xR0() {
  return x_e || (x_e = 1, Object.defineProperty(m6, "__esModule", { value: true })), m6;
}
var R6 = {}, U_e;
function UR0() {
  return U_e || (U_e = 1, Object.defineProperty(R6, "__esModule", { value: true })), R6;
}
var q6 = {}, k_e;
function kR0() {
  return k_e || (k_e = 1, Object.defineProperty(q6, "__esModule", { value: true })), q6;
}
var T6 = {}, j_e;
function jR0() {
  return j_e || (j_e = 1, Object.defineProperty(T6, "__esModule", { value: true })), T6;
}
var y6 = {}, F_e;
function FR0() {
  return F_e || (F_e = 1, Object.defineProperty(y6, "__esModule", { value: true })), y6;
}
var S6 = {}, V_e;
function VR0() {
  return V_e || (V_e = 1, Object.defineProperty(S6, "__esModule", { value: true })), S6;
}
var C6 = {}, H_e;
function HR0() {
  return H_e || (H_e = 1, Object.defineProperty(C6, "__esModule", { value: true })), C6;
}
var g6 = {}, X_e;
function XR0() {
  return X_e || (X_e = 1, Object.defineProperty(g6, "__esModule", { value: true })), g6;
}
var I6 = {}, $_e;
function $R0() {
  return $_e || ($_e = 1, Object.defineProperty(I6, "__esModule", { value: true })), I6;
}
var E6 = {}, G_e;
function GR0() {
  return G_e || (G_e = 1, Object.defineProperty(E6, "__esModule", { value: true })), E6;
}
var L6 = {}, Y_e;
function YR0() {
  return Y_e || (Y_e = 1, Object.defineProperty(L6, "__esModule", { value: true })), L6;
}
var P6 = {}, J_e;
function JR0() {
  return J_e || (J_e = 1, Object.defineProperty(P6, "__esModule", { value: true })), P6;
}
var D6 = {}, K_e;
function KR0() {
  return K_e || (K_e = 1, Object.defineProperty(D6, "__esModule", { value: true })), D6;
}
var W6 = {}, Q_e;
function QR0() {
  return Q_e || (Q_e = 1, Object.defineProperty(W6, "__esModule", { value: true })), W6;
}
var N6 = {}, Z_e;
function ZR0() {
  return Z_e || (Z_e = 1, Object.defineProperty(N6, "__esModule", { value: true })), N6;
}
var w6 = {}, ehe;
function e40() {
  return ehe || (ehe = 1, Object.defineProperty(w6, "__esModule", { value: true })), w6;
}
var B6 = {}, the;
function t40() {
  return the || (the = 1, Object.defineProperty(B6, "__esModule", { value: true })), B6;
}
var x6 = {}, rhe;
function r40() {
  return rhe || (rhe = 1, Object.defineProperty(x6, "__esModule", { value: true })), x6;
}
var U6 = {}, nhe;
function n40() {
  return nhe || (nhe = 1, Object.defineProperty(U6, "__esModule", { value: true })), U6;
}
var k6 = {}, ahe;
function a40() {
  return ahe || (ahe = 1, Object.defineProperty(k6, "__esModule", { value: true })), k6;
}
var j6 = {}, ohe;
function o40() {
  return ohe || (ohe = 1, Object.defineProperty(j6, "__esModule", { value: true })), j6;
}
var F6 = {}, ihe;
function i40() {
  return ihe || (ihe = 1, Object.defineProperty(F6, "__esModule", { value: true })), F6;
}
var V6 = {}, uhe;
function u40() {
  return uhe || (uhe = 1, Object.defineProperty(V6, "__esModule", { value: true })), V6;
}
var H6 = {}, she;
function s40() {
  return she || (she = 1, Object.defineProperty(H6, "__esModule", { value: true })), H6;
}
var X6 = {}, che;
function c40() {
  return che || (che = 1, Object.defineProperty(X6, "__esModule", { value: true })), X6;
}
var $6 = {}, lhe;
function l40() {
  return lhe || (lhe = 1, Object.defineProperty($6, "__esModule", { value: true })), $6;
}
var G6 = {}, phe;
function p40() {
  return phe || (phe = 1, Object.defineProperty(G6, "__esModule", { value: true })), G6;
}
var Y6 = {}, dhe;
function d40() {
  return dhe || (dhe = 1, Object.defineProperty(Y6, "__esModule", { value: true })), Y6;
}
var J6 = {}, fhe;
function f40() {
  return fhe || (fhe = 1, Object.defineProperty(J6, "__esModule", { value: true })), J6;
}
var K6 = {}, bhe;
function b40() {
  return bhe || (bhe = 1, Object.defineProperty(K6, "__esModule", { value: true })), K6;
}
var Q6 = {}, Mhe;
function M40() {
  return Mhe || (Mhe = 1, Object.defineProperty(Q6, "__esModule", { value: true })), Q6;
}
var Z6 = {}, Ohe;
function O40() {
  return Ohe || (Ohe = 1, Object.defineProperty(Z6, "__esModule", { value: true })), Z6;
}
var eC = {}, zhe;
function z40() {
  return zhe || (zhe = 1, Object.defineProperty(eC, "__esModule", { value: true })), eC;
}
var tC = {}, Ahe;
function A40() {
  return Ahe || (Ahe = 1, Object.defineProperty(tC, "__esModule", { value: true })), tC;
}
var rC = {}, _he;
function _40() {
  return _he || (_he = 1, Object.defineProperty(rC, "__esModule", { value: true })), rC;
}
var nC = {}, hhe;
function h40() {
  return hhe || (hhe = 1, Object.defineProperty(nC, "__esModule", { value: true })), nC;
}
var aC = {}, vhe;
function v40() {
  return vhe || (vhe = 1, Object.defineProperty(aC, "__esModule", { value: true })), aC;
}
var oC = {}, mhe;
function m40() {
  return mhe || (mhe = 1, Object.defineProperty(oC, "__esModule", { value: true })), oC;
}
var iC = {}, Rhe;
function R40() {
  return Rhe || (Rhe = 1, Object.defineProperty(iC, "__esModule", { value: true })), iC;
}
var uC = {}, qhe;
function q40() {
  return qhe || (qhe = 1, Object.defineProperty(uC, "__esModule", { value: true })), uC;
}
var sC = {}, The;
function T40() {
  return The || (The = 1, Object.defineProperty(sC, "__esModule", { value: true })), sC;
}
var cC = {}, yhe;
function y40() {
  return yhe || (yhe = 1, Object.defineProperty(cC, "__esModule", { value: true })), cC;
}
var lC = {}, She;
function S40() {
  return She || (She = 1, Object.defineProperty(lC, "__esModule", { value: true })), lC;
}
var pC = {}, Che;
function C40() {
  return Che || (Che = 1, Object.defineProperty(pC, "__esModule", { value: true })), pC;
}
var dC = {}, ghe;
function g40() {
  return ghe || (ghe = 1, Object.defineProperty(dC, "__esModule", { value: true })), dC;
}
var fC = {}, Ihe;
function I40() {
  return Ihe || (Ihe = 1, Object.defineProperty(fC, "__esModule", { value: true })), fC;
}
var bC = {}, Ehe;
function E40() {
  return Ehe || (Ehe = 1, Object.defineProperty(bC, "__esModule", { value: true })), bC;
}
var MC = {}, Lhe;
function L40() {
  return Lhe || (Lhe = 1, Object.defineProperty(MC, "__esModule", { value: true })), MC;
}
var OC = {}, Phe;
function P40() {
  return Phe || (Phe = 1, Object.defineProperty(OC, "__esModule", { value: true })), OC;
}
var zC = {}, Dhe;
function D40() {
  return Dhe || (Dhe = 1, Object.defineProperty(zC, "__esModule", { value: true })), zC;
}
var AC = {}, Whe;
function W40() {
  return Whe || (Whe = 1, Object.defineProperty(AC, "__esModule", { value: true })), AC;
}
var _C = {}, Nhe;
function N40() {
  return Nhe || (Nhe = 1, Object.defineProperty(_C, "__esModule", { value: true })), _C;
}
var hC = {}, whe;
function w40() {
  return whe || (whe = 1, Object.defineProperty(hC, "__esModule", { value: true })), hC;
}
var vC = {}, Bhe;
function B40() {
  return Bhe || (Bhe = 1, Object.defineProperty(vC, "__esModule", { value: true })), vC;
}
var mC = {}, xhe;
function x40() {
  return xhe || (xhe = 1, Object.defineProperty(mC, "__esModule", { value: true })), mC;
}
var RC = {}, Uhe;
function U40() {
  return Uhe || (Uhe = 1, Object.defineProperty(RC, "__esModule", { value: true })), RC;
}
var qC = {}, khe;
function k40() {
  return khe || (khe = 1, Object.defineProperty(qC, "__esModule", { value: true })), qC;
}
var TC = {}, jhe;
function j40() {
  return jhe || (jhe = 1, Object.defineProperty(TC, "__esModule", { value: true })), TC;
}
var yC = {}, Fhe;
function F40() {
  return Fhe || (Fhe = 1, Object.defineProperty(yC, "__esModule", { value: true })), yC;
}
var SC = {}, Vhe;
function V40() {
  return Vhe || (Vhe = 1, Object.defineProperty(SC, "__esModule", { value: true })), SC;
}
var CC = {}, Hhe;
function H40() {
  return Hhe || (Hhe = 1, Object.defineProperty(CC, "__esModule", { value: true })), CC;
}
var gC = {}, Xhe;
function X40() {
  return Xhe || (Xhe = 1, Object.defineProperty(gC, "__esModule", { value: true })), gC;
}
var IC = {}, $he;
function $40() {
  return $he || ($he = 1, Object.defineProperty(IC, "__esModule", { value: true })), IC;
}
var EC = {}, Ghe;
function G40() {
  return Ghe || (Ghe = 1, Object.defineProperty(EC, "__esModule", { value: true })), EC;
}
var LC = {}, Yhe;
function Y40() {
  return Yhe || (Yhe = 1, Object.defineProperty(LC, "__esModule", { value: true })), LC;
}
var PC = {}, Jhe;
function J40() {
  return Jhe || (Jhe = 1, Object.defineProperty(PC, "__esModule", { value: true })), PC;
}
var DC = {}, Khe;
function K40() {
  return Khe || (Khe = 1, Object.defineProperty(DC, "__esModule", { value: true })), DC;
}
var WC = {}, Qhe;
function Q40() {
  return Qhe || (Qhe = 1, Object.defineProperty(WC, "__esModule", { value: true })), WC;
}
var NC = {}, Zhe;
function Z40() {
  return Zhe || (Zhe = 1, Object.defineProperty(NC, "__esModule", { value: true })), NC;
}
var wC = {}, eve;
function eq0() {
  return eve || (eve = 1, Object.defineProperty(wC, "__esModule", { value: true })), wC;
}
var BC = {}, tve;
function tq0() {
  return tve || (tve = 1, Object.defineProperty(BC, "__esModule", { value: true })), BC;
}
var xC = {}, rve;
function rq0() {
  return rve || (rve = 1, Object.defineProperty(xC, "__esModule", { value: true })), xC;
}
var UC = {}, nve;
function nq0() {
  return nve || (nve = 1, Object.defineProperty(UC, "__esModule", { value: true })), UC;
}
var kC = {}, ave;
function aq0() {
  return ave || (ave = 1, Object.defineProperty(kC, "__esModule", { value: true })), kC;
}
var jC = {}, ove;
function oq0() {
  return ove || (ove = 1, Object.defineProperty(jC, "__esModule", { value: true })), jC;
}
var FC = {}, ive;
function iq0() {
  return ive || (ive = 1, Object.defineProperty(FC, "__esModule", { value: true })), FC;
}
var VC = {}, uve;
function uq0() {
  return uve || (uve = 1, Object.defineProperty(VC, "__esModule", { value: true })), VC;
}
var HC = {}, sve;
function sq0() {
  return sve || (sve = 1, Object.defineProperty(HC, "__esModule", { value: true })), HC;
}
var XC = {}, cve;
function cq0() {
  return cve || (cve = 1, Object.defineProperty(XC, "__esModule", { value: true })), XC;
}
var $C = {}, lve;
function lq0() {
  return lve || (lve = 1, Object.defineProperty($C, "__esModule", { value: true })), $C;
}
var GC = {}, pve;
function pq0() {
  return pve || (pve = 1, Object.defineProperty(GC, "__esModule", { value: true })), GC;
}
var YC = {}, dve;
function dq0() {
  return dve || (dve = 1, Object.defineProperty(YC, "__esModule", { value: true })), YC;
}
var JC = {}, fve;
function fq0() {
  return fve || (fve = 1, Object.defineProperty(JC, "__esModule", { value: true })), JC;
}
var KC = {}, bve;
function bq0() {
  return bve || (bve = 1, Object.defineProperty(KC, "__esModule", { value: true })), KC;
}
var QC = {}, Mve;
function Mq0() {
  return Mve || (Mve = 1, Object.defineProperty(QC, "__esModule", { value: true })), QC;
}
var ZC = {}, Ove;
function Oq0() {
  return Ove || (Ove = 1, Object.defineProperty(ZC, "__esModule", { value: true })), ZC;
}
var eg = {}, zve;
function zq0() {
  return zve || (zve = 1, Object.defineProperty(eg, "__esModule", { value: true })), eg;
}
var tg = {}, Ave;
function Aq0() {
  return Ave || (Ave = 1, Object.defineProperty(tg, "__esModule", { value: true })), tg;
}
var rg = {}, _ve;
function _q0() {
  return _ve || (_ve = 1, Object.defineProperty(rg, "__esModule", { value: true })), rg;
}
var ng = {}, hve;
function hq0() {
  return hve || (hve = 1, Object.defineProperty(ng, "__esModule", { value: true })), ng;
}
var ag = {}, vve;
function vq0() {
  return vve || (vve = 1, Object.defineProperty(ag, "__esModule", { value: true })), ag;
}
var og = {}, mve;
function mq0() {
  return mve || (mve = 1, Object.defineProperty(og, "__esModule", { value: true })), og;
}
var ig = {}, Rve;
function Rq0() {
  return Rve || (Rve = 1, Object.defineProperty(ig, "__esModule", { value: true })), ig;
}
var ug = {}, qve;
function qq0() {
  return qve || (qve = 1, Object.defineProperty(ug, "__esModule", { value: true })), ug;
}
var sg = {}, Tve;
function Tq0() {
  return Tve || (Tve = 1, Object.defineProperty(sg, "__esModule", { value: true })), sg;
}
var cg = {}, yve;
function yq0() {
  return yve || (yve = 1, Object.defineProperty(cg, "__esModule", { value: true })), cg;
}
var lg = {}, Sve;
function Sq0() {
  return Sve || (Sve = 1, Object.defineProperty(lg, "__esModule", { value: true })), lg;
}
var pg = {}, Cve;
function Cq0() {
  return Cve || (Cve = 1, Object.defineProperty(pg, "__esModule", { value: true })), pg;
}
var dg = {}, gve;
function gq0() {
  return gve || (gve = 1, Object.defineProperty(dg, "__esModule", { value: true })), dg;
}
var fg = {}, Ive;
function Iq0() {
  return Ive || (Ive = 1, Object.defineProperty(fg, "__esModule", { value: true })), fg;
}
var bg = {}, Eve;
function Eq0() {
  return Eve || (Eve = 1, Object.defineProperty(bg, "__esModule", { value: true })), bg;
}
var Mg = {}, Lve;
function Lq0() {
  return Lve || (Lve = 1, Object.defineProperty(Mg, "__esModule", { value: true })), Mg;
}
var Og = {}, Pve;
function Pq0() {
  return Pve || (Pve = 1, Object.defineProperty(Og, "__esModule", { value: true })), Og;
}
var zg = {}, Dve;
function Dq0() {
  return Dve || (Dve = 1, Object.defineProperty(zg, "__esModule", { value: true })), zg;
}
var Ag = {}, Wve;
function Wq0() {
  return Wve || (Wve = 1, Object.defineProperty(Ag, "__esModule", { value: true })), Ag;
}
var _g = {}, Nve;
function Nq0() {
  return Nve || (Nve = 1, Object.defineProperty(_g, "__esModule", { value: true })), _g;
}
var hg = {}, wve;
function wq0() {
  return wve || (wve = 1, Object.defineProperty(hg, "__esModule", { value: true })), hg;
}
var vg = {}, Bve;
function Bq0() {
  return Bve || (Bve = 1, Object.defineProperty(vg, "__esModule", { value: true })), vg;
}
var mg = {}, xve;
function xq0() {
  return xve || (xve = 1, Object.defineProperty(mg, "__esModule", { value: true })), mg;
}
var Rg = {}, Uve;
function Uq0() {
  return Uve || (Uve = 1, Object.defineProperty(Rg, "__esModule", { value: true })), Rg;
}
var qg = {}, kve;
function kq0() {
  return kve || (kve = 1, Object.defineProperty(qg, "__esModule", { value: true })), qg;
}
var Tg = {}, jve;
function jq0() {
  return jve || (jve = 1, Object.defineProperty(Tg, "__esModule", { value: true })), Tg;
}
var yg = {}, Fve;
function Fq0() {
  return Fve || (Fve = 1, Object.defineProperty(yg, "__esModule", { value: true })), yg;
}
var Sg = {}, Vve;
function Vq0() {
  return Vve || (Vve = 1, Object.defineProperty(Sg, "__esModule", { value: true })), Sg;
}
var Cg = {}, Hve;
function Hq0() {
  return Hve || (Hve = 1, Object.defineProperty(Cg, "__esModule", { value: true })), Cg;
}
var gg = {}, Xve;
function Xq0() {
  return Xve || (Xve = 1, Object.defineProperty(gg, "__esModule", { value: true })), gg;
}
var Ig = {}, $ve;
function $q0() {
  return $ve || ($ve = 1, Object.defineProperty(Ig, "__esModule", { value: true })), Ig;
}
var Eg = {}, Gve;
function Gq0() {
  return Gve || (Gve = 1, Object.defineProperty(Eg, "__esModule", { value: true })), Eg;
}
var Lg = {}, Yve;
function Yq0() {
  return Yve || (Yve = 1, Object.defineProperty(Lg, "__esModule", { value: true })), Lg;
}
var Pg = {}, Jve;
function Jq0() {
  return Jve || (Jve = 1, Object.defineProperty(Pg, "__esModule", { value: true })), Pg;
}
var Dg = {}, Kve;
function Kq0() {
  return Kve || (Kve = 1, Object.defineProperty(Dg, "__esModule", { value: true })), Dg;
}
var Wg = {}, Qve;
function Qq0() {
  return Qve || (Qve = 1, Object.defineProperty(Wg, "__esModule", { value: true })), Wg;
}
var Ng = {}, Zve;
function Zq0() {
  return Zve || (Zve = 1, Object.defineProperty(Ng, "__esModule", { value: true })), Ng;
}
var wg = {}, eme;
function eT0() {
  return eme || (eme = 1, Object.defineProperty(wg, "__esModule", { value: true })), wg;
}
var Bg = {}, tme;
function tT0() {
  return tme || (tme = 1, Object.defineProperty(Bg, "__esModule", { value: true })), Bg;
}
var xg = {}, rme;
function rT0() {
  return rme || (rme = 1, Object.defineProperty(xg, "__esModule", { value: true })), xg;
}
var Ug = {}, nme;
function nT0() {
  return nme || (nme = 1, Object.defineProperty(Ug, "__esModule", { value: true })), Ug;
}
var kg = {}, ame;
function aT0() {
  return ame || (ame = 1, Object.defineProperty(kg, "__esModule", { value: true })), kg;
}
var jg = {}, ome;
function oT0() {
  return ome || (ome = 1, Object.defineProperty(jg, "__esModule", { value: true })), jg;
}
var Fg = {}, ime;
function iT0() {
  return ime || (ime = 1, Object.defineProperty(Fg, "__esModule", { value: true })), Fg;
}
var Vg = {}, ume;
function uT0() {
  return ume || (ume = 1, Object.defineProperty(Vg, "__esModule", { value: true })), Vg;
}
var Hg = {}, sme;
function sT0() {
  return sme || (sme = 1, Object.defineProperty(Hg, "__esModule", { value: true })), Hg;
}
var Xg = {}, cme;
function cT0() {
  return cme || (cme = 1, Object.defineProperty(Xg, "__esModule", { value: true })), Xg;
}
var $g = {}, lme;
function lT0() {
  return lme || (lme = 1, Object.defineProperty($g, "__esModule", { value: true })), $g;
}
var Gg = {}, pme;
function pT0() {
  return pme || (pme = 1, Object.defineProperty(Gg, "__esModule", { value: true })), Gg;
}
var Yg = {}, dme;
function dT0() {
  return dme || (dme = 1, Object.defineProperty(Yg, "__esModule", { value: true })), Yg;
}
var Jg = {}, fme;
function fT0() {
  return fme || (fme = 1, Object.defineProperty(Jg, "__esModule", { value: true })), Jg;
}
var Kg = {}, bme;
function bT0() {
  return bme || (bme = 1, Object.defineProperty(Kg, "__esModule", { value: true })), Kg;
}
var Qg = {}, Mme;
function MT0() {
  return Mme || (Mme = 1, Object.defineProperty(Qg, "__esModule", { value: true })), Qg;
}
var Zg = {}, Ome;
function OT0() {
  return Ome || (Ome = 1, Object.defineProperty(Zg, "__esModule", { value: true })), Zg;
}
var eI = {}, zme;
function zT0() {
  return zme || (zme = 1, Object.defineProperty(eI, "__esModule", { value: true })), eI;
}
var tI = {}, Ame;
function AT0() {
  return Ame || (Ame = 1, Object.defineProperty(tI, "__esModule", { value: true })), tI;
}
var rI = {}, _me;
function _T0() {
  return _me || (_me = 1, Object.defineProperty(rI, "__esModule", { value: true })), rI;
}
var nI = {}, hme;
function hT0() {
  return hme || (hme = 1, Object.defineProperty(nI, "__esModule", { value: true })), nI;
}
var aI = {}, vme;
function vT0() {
  return vme || (vme = 1, Object.defineProperty(aI, "__esModule", { value: true })), aI;
}
var oI = {}, mme;
function mT0() {
  return mme || (mme = 1, Object.defineProperty(oI, "__esModule", { value: true })), oI;
}
var iI = {}, Rme;
function RT0() {
  return Rme || (Rme = 1, Object.defineProperty(iI, "__esModule", { value: true })), iI;
}
var uI = {}, qme;
function qT0() {
  return qme || (qme = 1, Object.defineProperty(uI, "__esModule", { value: true })), uI;
}
var sI = {}, Tme;
function TT0() {
  return Tme || (Tme = 1, Object.defineProperty(sI, "__esModule", { value: true })), sI;
}
var cI = {}, yme;
function yT0() {
  return yme || (yme = 1, Object.defineProperty(cI, "__esModule", { value: true })), cI;
}
var lI = {}, Sme;
function ST0() {
  return Sme || (Sme = 1, Object.defineProperty(lI, "__esModule", { value: true })), lI;
}
var pI = {}, Cme;
function CT0() {
  return Cme || (Cme = 1, Object.defineProperty(pI, "__esModule", { value: true })), pI;
}
var dI = {}, gme;
function gT0() {
  return gme || (gme = 1, Object.defineProperty(dI, "__esModule", { value: true })), dI;
}
var fI = {}, Ime;
function IT0() {
  return Ime || (Ime = 1, Object.defineProperty(fI, "__esModule", { value: true })), fI;
}
var bI = {}, Eme;
function ET0() {
  return Eme || (Eme = 1, Object.defineProperty(bI, "__esModule", { value: true })), bI;
}
var MI = {}, Lme;
function LT0() {
  return Lme || (Lme = 1, Object.defineProperty(MI, "__esModule", { value: true })), MI;
}
var OI = {}, Pme;
function PT0() {
  return Pme || (Pme = 1, Object.defineProperty(OI, "__esModule", { value: true })), OI;
}
var zI = {}, Dme;
function DT0() {
  return Dme || (Dme = 1, Object.defineProperty(zI, "__esModule", { value: true })), zI;
}
var AI = {}, Wme;
function WT0() {
  return Wme || (Wme = 1, Object.defineProperty(AI, "__esModule", { value: true })), AI;
}
var _I = {}, Nme;
function NT0() {
  return Nme || (Nme = 1, Object.defineProperty(_I, "__esModule", { value: true })), _I;
}
var hI = {}, wme;
function wT0() {
  return wme || (wme = 1, Object.defineProperty(hI, "__esModule", { value: true })), hI;
}
var vI = {}, Bme;
function BT0() {
  return Bme || (Bme = 1, Object.defineProperty(vI, "__esModule", { value: true })), vI;
}
var mI = {}, xme;
function xT0() {
  return xme || (xme = 1, Object.defineProperty(mI, "__esModule", { value: true })), mI;
}
var RI = {}, Ume;
function UT0() {
  return Ume || (Ume = 1, Object.defineProperty(RI, "__esModule", { value: true })), RI;
}
var qI = {}, kme;
function kT0() {
  return kme || (kme = 1, Object.defineProperty(qI, "__esModule", { value: true })), qI;
}
var TI = {}, jme;
function jT0() {
  return jme || (jme = 1, Object.defineProperty(TI, "__esModule", { value: true })), TI;
}
var yI = {}, Fme;
function FT0() {
  return Fme || (Fme = 1, Object.defineProperty(yI, "__esModule", { value: true })), yI;
}
var SI = {}, Vme;
function VT0() {
  return Vme || (Vme = 1, Object.defineProperty(SI, "__esModule", { value: true })), SI;
}
var CI = {}, Hme;
function HT0() {
  return Hme || (Hme = 1, Object.defineProperty(CI, "__esModule", { value: true })), CI;
}
var gI = {}, Xme;
function XT0() {
  return Xme || (Xme = 1, Object.defineProperty(gI, "__esModule", { value: true })), gI;
}
var II = {}, $me;
function $T0() {
  return $me || ($me = 1, Object.defineProperty(II, "__esModule", { value: true })), II;
}
var EI = {}, Gme;
function GT0() {
  return Gme || (Gme = 1, Object.defineProperty(EI, "__esModule", { value: true })), EI;
}
var LI = {}, Yme;
function YT0() {
  return Yme || (Yme = 1, Object.defineProperty(LI, "__esModule", { value: true })), LI;
}
var PI = {}, Jme;
function JT0() {
  return Jme || (Jme = 1, Object.defineProperty(PI, "__esModule", { value: true })), PI;
}
var DI = {}, Kme;
function KT0() {
  return Kme || (Kme = 1, Object.defineProperty(DI, "__esModule", { value: true })), DI;
}
var WI = {}, Qme;
function QT0() {
  return Qme || (Qme = 1, Object.defineProperty(WI, "__esModule", { value: true })), WI;
}
var NI = {}, Zme;
function ZT0() {
  return Zme || (Zme = 1, Object.defineProperty(NI, "__esModule", { value: true })), NI;
}
var wI = {}, eRe;
function ey0() {
  return eRe || (eRe = 1, Object.defineProperty(wI, "__esModule", { value: true })), wI;
}
var BI = {}, tRe;
function ty0() {
  return tRe || (tRe = 1, Object.defineProperty(BI, "__esModule", { value: true })), BI;
}
var xI = {}, rRe;
function ry0() {
  return rRe || (rRe = 1, Object.defineProperty(xI, "__esModule", { value: true })), xI;
}
var UI = {}, nRe;
function ny0() {
  return nRe || (nRe = 1, Object.defineProperty(UI, "__esModule", { value: true })), UI;
}
var kI = {}, aRe;
function ay0() {
  return aRe || (aRe = 1, Object.defineProperty(kI, "__esModule", { value: true })), kI;
}
var jI = {}, oRe;
function oy0() {
  return oRe || (oRe = 1, Object.defineProperty(jI, "__esModule", { value: true })), jI;
}
var FI = {}, iRe;
function iy0() {
  return iRe || (iRe = 1, Object.defineProperty(FI, "__esModule", { value: true })), FI;
}
var VI = {}, uRe;
function uy0() {
  return uRe || (uRe = 1, Object.defineProperty(VI, "__esModule", { value: true })), VI;
}
var HI = {}, sRe;
function sy0() {
  return sRe || (sRe = 1, Object.defineProperty(HI, "__esModule", { value: true })), HI;
}
var XI = {}, cRe;
function cy0() {
  return cRe || (cRe = 1, Object.defineProperty(XI, "__esModule", { value: true })), XI;
}
var $I = {}, lRe;
function ly0() {
  return lRe || (lRe = 1, Object.defineProperty($I, "__esModule", { value: true })), $I;
}
var GI = {}, pRe;
function py0() {
  return pRe || (pRe = 1, Object.defineProperty(GI, "__esModule", { value: true })), GI;
}
var YI = {}, dRe;
function dy0() {
  return dRe || (dRe = 1, Object.defineProperty(YI, "__esModule", { value: true })), YI;
}
var JI = {}, fRe;
function fy0() {
  return fRe || (fRe = 1, Object.defineProperty(JI, "__esModule", { value: true })), JI;
}
var KI = {}, bRe;
function by0() {
  return bRe || (bRe = 1, Object.defineProperty(KI, "__esModule", { value: true })), KI;
}
var QI = {}, MRe;
function My0() {
  return MRe || (MRe = 1, Object.defineProperty(QI, "__esModule", { value: true })), QI;
}
var ZI = {}, ORe;
function Oy0() {
  return ORe || (ORe = 1, Object.defineProperty(ZI, "__esModule", { value: true })), ZI;
}
var eE = {}, zRe;
function zy0() {
  return zRe || (zRe = 1, Object.defineProperty(eE, "__esModule", { value: true })), eE;
}
var tE = {}, ARe;
function Ay0() {
  return ARe || (ARe = 1, Object.defineProperty(tE, "__esModule", { value: true })), tE;
}
var rE = {}, _Re;
function _y0() {
  return _Re || (_Re = 1, Object.defineProperty(rE, "__esModule", { value: true })), rE;
}
var nE = {}, hRe;
function hy0() {
  return hRe || (hRe = 1, Object.defineProperty(nE, "__esModule", { value: true })), nE;
}
var aE = {}, vRe;
function vy0() {
  return vRe || (vRe = 1, Object.defineProperty(aE, "__esModule", { value: true })), aE;
}
var oE = {}, mRe;
function my0() {
  return mRe || (mRe = 1, Object.defineProperty(oE, "__esModule", { value: true })), oE;
}
var iE = {}, RRe;
function Ry0() {
  return RRe || (RRe = 1, Object.defineProperty(iE, "__esModule", { value: true })), iE;
}
var uE = {}, qRe;
function qy0() {
  return qRe || (qRe = 1, Object.defineProperty(uE, "__esModule", { value: true })), uE;
}
var sE = {}, TRe;
function Ty0() {
  return TRe || (TRe = 1, Object.defineProperty(sE, "__esModule", { value: true })), sE;
}
var cE = {}, yRe;
function yy0() {
  return yRe || (yRe = 1, Object.defineProperty(cE, "__esModule", { value: true })), cE;
}
var lE = {}, SRe;
function Sy0() {
  return SRe || (SRe = 1, Object.defineProperty(lE, "__esModule", { value: true })), lE;
}
var pE = {}, CRe;
function Cy0() {
  return CRe || (CRe = 1, Object.defineProperty(pE, "__esModule", { value: true })), pE;
}
var dE = {}, gRe;
function gy0() {
  return gRe || (gRe = 1, Object.defineProperty(dE, "__esModule", { value: true })), dE;
}
var fE = {}, IRe;
function Iy0() {
  return IRe || (IRe = 1, Object.defineProperty(fE, "__esModule", { value: true })), fE;
}
var bE = {}, ERe;
function Ey0() {
  return ERe || (ERe = 1, Object.defineProperty(bE, "__esModule", { value: true })), bE;
}
var ME = {}, LRe;
function Ly0() {
  return LRe || (LRe = 1, Object.defineProperty(ME, "__esModule", { value: true })), ME;
}
var OE = {}, PRe;
function Py0() {
  return PRe || (PRe = 1, Object.defineProperty(OE, "__esModule", { value: true })), OE;
}
var zE = {}, DRe;
function Dy0() {
  return DRe || (DRe = 1, Object.defineProperty(zE, "__esModule", { value: true })), zE;
}
var AE = {}, WRe;
function Wy0() {
  return WRe || (WRe = 1, Object.defineProperty(AE, "__esModule", { value: true })), AE;
}
var _E = {}, NRe;
function Ny0() {
  return NRe || (NRe = 1, Object.defineProperty(_E, "__esModule", { value: true })), _E;
}
var hE = {}, wRe;
function wy0() {
  return wRe || (wRe = 1, Object.defineProperty(hE, "__esModule", { value: true })), hE;
}
var vE = {}, BRe;
function By0() {
  return BRe || (BRe = 1, Object.defineProperty(vE, "__esModule", { value: true })), vE;
}
var mE = {}, xRe;
function xy0() {
  return xRe || (xRe = 1, Object.defineProperty(mE, "__esModule", { value: true })), mE;
}
var RE = {}, URe;
function Uy0() {
  return URe || (URe = 1, Object.defineProperty(RE, "__esModule", { value: true })), RE;
}
var qE = {}, kRe;
function ky0() {
  return kRe || (kRe = 1, Object.defineProperty(qE, "__esModule", { value: true })), qE;
}
var TE = {}, jRe;
function jy0() {
  return jRe || (jRe = 1, Object.defineProperty(TE, "__esModule", { value: true })), TE;
}
var yE = {}, FRe;
function Fy0() {
  return FRe || (FRe = 1, Object.defineProperty(yE, "__esModule", { value: true })), yE;
}
var SE = {}, VRe;
function Vy0() {
  return VRe || (VRe = 1, Object.defineProperty(SE, "__esModule", { value: true })), SE;
}
var CE = {}, HRe;
function Hy0() {
  return HRe || (HRe = 1, Object.defineProperty(CE, "__esModule", { value: true })), CE;
}
var gE = {}, XRe;
function Xy0() {
  return XRe || (XRe = 1, Object.defineProperty(gE, "__esModule", { value: true })), gE;
}
var IE = {}, $Re;
function $y0() {
  return $Re || ($Re = 1, Object.defineProperty(IE, "__esModule", { value: true })), IE;
}
var EE = {}, GRe;
function Gy0() {
  return GRe || (GRe = 1, Object.defineProperty(EE, "__esModule", { value: true })), EE;
}
var LE = {}, YRe;
function Yy0() {
  return YRe || (YRe = 1, Object.defineProperty(LE, "__esModule", { value: true })), LE;
}
var PE = {}, JRe;
function Jy0() {
  return JRe || (JRe = 1, Object.defineProperty(PE, "__esModule", { value: true })), PE;
}
var DE = {}, KRe;
function Ky0() {
  return KRe || (KRe = 1, Object.defineProperty(DE, "__esModule", { value: true })), DE;
}
var WE = {}, QRe;
function Qy0() {
  return QRe || (QRe = 1, Object.defineProperty(WE, "__esModule", { value: true })), WE;
}
var NE = {}, ZRe;
function Zy0() {
  return ZRe || (ZRe = 1, Object.defineProperty(NE, "__esModule", { value: true })), NE;
}
var wE = {}, e4e;
function e50() {
  return e4e || (e4e = 1, Object.defineProperty(wE, "__esModule", { value: true })), wE;
}
var BE = {}, t4e;
function t50() {
  return t4e || (t4e = 1, Object.defineProperty(BE, "__esModule", { value: true })), BE;
}
var xE = {}, r4e;
function r50() {
  return r4e || (r4e = 1, Object.defineProperty(xE, "__esModule", { value: true })), xE;
}
var UE = {}, n4e;
function n50() {
  return n4e || (n4e = 1, Object.defineProperty(UE, "__esModule", { value: true })), UE;
}
var kE = {}, a4e;
function a50() {
  return a4e || (a4e = 1, Object.defineProperty(kE, "__esModule", { value: true })), kE;
}
var jE = {}, o4e;
function o50() {
  return o4e || (o4e = 1, Object.defineProperty(jE, "__esModule", { value: true })), jE;
}
var FE = {}, i4e;
function i50() {
  return i4e || (i4e = 1, Object.defineProperty(FE, "__esModule", { value: true })), FE;
}
var VE = {}, u4e;
function u50() {
  return u4e || (u4e = 1, Object.defineProperty(VE, "__esModule", { value: true })), VE;
}
var HE = {}, s4e;
function s50() {
  return s4e || (s4e = 1, Object.defineProperty(HE, "__esModule", { value: true })), HE;
}
var XE = {}, c4e;
function c50() {
  return c4e || (c4e = 1, Object.defineProperty(XE, "__esModule", { value: true })), XE;
}
var $E = {}, l4e;
function l50() {
  return l4e || (l4e = 1, Object.defineProperty($E, "__esModule", { value: true })), $E;
}
var GE = {}, p4e;
function p50() {
  return p4e || (p4e = 1, Object.defineProperty(GE, "__esModule", { value: true })), GE;
}
var YE = {}, d4e;
function d50() {
  return d4e || (d4e = 1, Object.defineProperty(YE, "__esModule", { value: true })), YE;
}
var JE = {}, f4e;
function f50() {
  return f4e || (f4e = 1, Object.defineProperty(JE, "__esModule", { value: true })), JE;
}
var KE = {}, b4e;
function b50() {
  return b4e || (b4e = 1, Object.defineProperty(KE, "__esModule", { value: true })), KE;
}
var QE = {}, M4e;
function M50() {
  return M4e || (M4e = 1, Object.defineProperty(QE, "__esModule", { value: true })), QE;
}
var ZE = {}, O4e;
function O50() {
  return O4e || (O4e = 1, Object.defineProperty(ZE, "__esModule", { value: true })), ZE;
}
var eL = {}, z4e;
function z50() {
  return z4e || (z4e = 1, Object.defineProperty(eL, "__esModule", { value: true })), eL;
}
var tL = {}, A4e;
function A50() {
  return A4e || (A4e = 1, Object.defineProperty(tL, "__esModule", { value: true })), tL;
}
var rL = {}, _4e;
function _50() {
  return _4e || (_4e = 1, Object.defineProperty(rL, "__esModule", { value: true })), rL;
}
var nL = {}, h4e;
function h50() {
  return h4e || (h4e = 1, Object.defineProperty(nL, "__esModule", { value: true })), nL;
}
var aL = {}, v4e;
function v50() {
  return v4e || (v4e = 1, Object.defineProperty(aL, "__esModule", { value: true })), aL;
}
var oL = {}, m4e;
function m50() {
  return m4e || (m4e = 1, Object.defineProperty(oL, "__esModule", { value: true })), oL;
}
var iL = {}, R4e;
function R50() {
  return R4e || (R4e = 1, Object.defineProperty(iL, "__esModule", { value: true })), iL;
}
var uL = {}, q4e;
function q50() {
  return q4e || (q4e = 1, Object.defineProperty(uL, "__esModule", { value: true })), uL;
}
var sL = {}, T4e;
function T50() {
  return T4e || (T4e = 1, Object.defineProperty(sL, "__esModule", { value: true })), sL;
}
var cL = {}, y4e;
function y50() {
  return y4e || (y4e = 1, Object.defineProperty(cL, "__esModule", { value: true })), cL;
}
var lL = {}, S4e;
function S50() {
  return S4e || (S4e = 1, Object.defineProperty(lL, "__esModule", { value: true })), lL;
}
var pL = {}, C4e;
function C50() {
  return C4e || (C4e = 1, Object.defineProperty(pL, "__esModule", { value: true })), pL;
}
var dL = {}, g4e;
function g50() {
  return g4e || (g4e = 1, Object.defineProperty(dL, "__esModule", { value: true })), dL;
}
var fL = {}, I4e;
function I50() {
  return I4e || (I4e = 1, Object.defineProperty(fL, "__esModule", { value: true })), fL;
}
var bL = {}, E4e;
function E50() {
  return E4e || (E4e = 1, Object.defineProperty(bL, "__esModule", { value: true })), bL;
}
var ML = {}, L4e;
function L50() {
  return L4e || (L4e = 1, Object.defineProperty(ML, "__esModule", { value: true })), ML;
}
var OL = {}, P4e;
function P50() {
  return P4e || (P4e = 1, Object.defineProperty(OL, "__esModule", { value: true })), OL;
}
var zL = {}, D4e;
function D50() {
  return D4e || (D4e = 1, Object.defineProperty(zL, "__esModule", { value: true })), zL;
}
var AL = {}, W4e;
function W50() {
  return W4e || (W4e = 1, Object.defineProperty(AL, "__esModule", { value: true })), AL;
}
var _L = {}, N4e;
function N50() {
  return N4e || (N4e = 1, Object.defineProperty(_L, "__esModule", { value: true })), _L;
}
var hL = {}, w4e;
function w50() {
  return w4e || (w4e = 1, Object.defineProperty(hL, "__esModule", { value: true })), hL;
}
var vL = {}, B4e;
function B50() {
  return B4e || (B4e = 1, Object.defineProperty(vL, "__esModule", { value: true })), vL;
}
var mL = {}, x4e;
function x50() {
  return x4e || (x4e = 1, Object.defineProperty(mL, "__esModule", { value: true })), mL;
}
var RL = {}, U4e;
function U50() {
  return U4e || (U4e = 1, Object.defineProperty(RL, "__esModule", { value: true })), RL;
}
var qL = {}, k4e;
function k50() {
  return k4e || (k4e = 1, Object.defineProperty(qL, "__esModule", { value: true })), qL;
}
var TL = {}, j4e;
function j50() {
  return j4e || (j4e = 1, Object.defineProperty(TL, "__esModule", { value: true })), TL;
}
var yL = {}, F4e;
function F50() {
  return F4e || (F4e = 1, Object.defineProperty(yL, "__esModule", { value: true })), yL;
}
var SL = {}, V4e;
function V50() {
  return V4e || (V4e = 1, Object.defineProperty(SL, "__esModule", { value: true })), SL;
}
var CL = {}, H4e;
function H50() {
  return H4e || (H4e = 1, Object.defineProperty(CL, "__esModule", { value: true })), CL;
}
var gL = {}, X4e;
function X50() {
  return X4e || (X4e = 1, Object.defineProperty(gL, "__esModule", { value: true })), gL;
}
var IL = {}, $4e;
function $50() {
  return $4e || ($4e = 1, Object.defineProperty(IL, "__esModule", { value: true })), IL;
}
var EL = {}, G4e;
function G50() {
  return G4e || (G4e = 1, Object.defineProperty(EL, "__esModule", { value: true })), EL;
}
var LL = {}, Y4e;
function Y50() {
  return Y4e || (Y4e = 1, Object.defineProperty(LL, "__esModule", { value: true })), LL;
}
var PL = {}, J4e;
function J50() {
  return J4e || (J4e = 1, Object.defineProperty(PL, "__esModule", { value: true })), PL;
}
var DL = {}, K4e;
function K50() {
  return K4e || (K4e = 1, Object.defineProperty(DL, "__esModule", { value: true })), DL;
}
var WL = {}, Q4e;
function Q50() {
  return Q4e || (Q4e = 1, Object.defineProperty(WL, "__esModule", { value: true })), WL;
}
var NL = {}, Z4e;
function Z50() {
  return Z4e || (Z4e = 1, Object.defineProperty(NL, "__esModule", { value: true })), NL;
}
var wL = {}, eqe;
function eS0() {
  return eqe || (eqe = 1, Object.defineProperty(wL, "__esModule", { value: true })), wL;
}
var BL = {}, tqe;
function tS0() {
  return tqe || (tqe = 1, Object.defineProperty(BL, "__esModule", { value: true })), BL;
}
var xL = {}, rqe;
function rS0() {
  return rqe || (rqe = 1, Object.defineProperty(xL, "__esModule", { value: true })), xL;
}
var UL = {}, nqe;
function nS0() {
  return nqe || (nqe = 1, Object.defineProperty(UL, "__esModule", { value: true })), UL;
}
var kL = {}, aqe;
function aS0() {
  return aqe || (aqe = 1, Object.defineProperty(kL, "__esModule", { value: true })), kL;
}
var jL = {}, oqe;
function oS0() {
  return oqe || (oqe = 1, Object.defineProperty(jL, "__esModule", { value: true })), jL;
}
var FL = {}, iqe;
function iS0() {
  return iqe || (iqe = 1, Object.defineProperty(FL, "__esModule", { value: true })), FL;
}
var VL = {}, uqe;
function uS0() {
  return uqe || (uqe = 1, Object.defineProperty(VL, "__esModule", { value: true })), VL;
}
var HL = {}, sqe;
function sS0() {
  return sqe || (sqe = 1, Object.defineProperty(HL, "__esModule", { value: true })), HL;
}
var XL = {}, cqe;
function cS0() {
  return cqe || (cqe = 1, Object.defineProperty(XL, "__esModule", { value: true })), XL;
}
var $L = {}, lqe;
function lS0() {
  return lqe || (lqe = 1, Object.defineProperty($L, "__esModule", { value: true })), $L;
}
var GL = {}, pqe;
function pS0() {
  return pqe || (pqe = 1, Object.defineProperty(GL, "__esModule", { value: true })), GL;
}
var YL = {}, dqe;
function dS0() {
  return dqe || (dqe = 1, Object.defineProperty(YL, "__esModule", { value: true })), YL;
}
var JL = {}, fqe;
function fS0() {
  return fqe || (fqe = 1, Object.defineProperty(JL, "__esModule", { value: true })), JL;
}
var KL = {}, bqe;
function bS0() {
  return bqe || (bqe = 1, Object.defineProperty(KL, "__esModule", { value: true })), KL;
}
var QL = {}, Mqe;
function MS0() {
  return Mqe || (Mqe = 1, Object.defineProperty(QL, "__esModule", { value: true })), QL;
}
var ZL = {}, Oqe;
function OS0() {
  return Oqe || (Oqe = 1, Object.defineProperty(ZL, "__esModule", { value: true })), ZL;
}
var eP = {}, zqe;
function zS0() {
  return zqe || (zqe = 1, Object.defineProperty(eP, "__esModule", { value: true })), eP;
}
var tP = {}, Aqe;
function AS0() {
  return Aqe || (Aqe = 1, Object.defineProperty(tP, "__esModule", { value: true })), tP;
}
var rP = {}, _qe;
function _S0() {
  return _qe || (_qe = 1, Object.defineProperty(rP, "__esModule", { value: true })), rP;
}
var nP = {}, hqe;
function hS0() {
  return hqe || (hqe = 1, Object.defineProperty(nP, "__esModule", { value: true })), nP;
}
var aP = {}, vqe;
function vS0() {
  return vqe || (vqe = 1, Object.defineProperty(aP, "__esModule", { value: true })), aP;
}
var oP = {}, mqe;
function mS0() {
  return mqe || (mqe = 1, Object.defineProperty(oP, "__esModule", { value: true })), oP;
}
var iP = {}, Rqe;
function RS0() {
  return Rqe || (Rqe = 1, Object.defineProperty(iP, "__esModule", { value: true })), iP;
}
var uP = {}, qqe;
function qS0() {
  return qqe || (qqe = 1, Object.defineProperty(uP, "__esModule", { value: true })), uP;
}
var sP = {}, Tqe;
function TS0() {
  return Tqe || (Tqe = 1, Object.defineProperty(sP, "__esModule", { value: true })), sP;
}
var cP = {}, yqe;
function yS0() {
  return yqe || (yqe = 1, Object.defineProperty(cP, "__esModule", { value: true })), cP;
}
var lP = {}, Sqe;
function SS0() {
  return Sqe || (Sqe = 1, Object.defineProperty(lP, "__esModule", { value: true })), lP;
}
var pP = {}, Cqe;
function CS0() {
  return Cqe || (Cqe = 1, Object.defineProperty(pP, "__esModule", { value: true })), pP;
}
var dP = {}, gqe;
function gS0() {
  return gqe || (gqe = 1, Object.defineProperty(dP, "__esModule", { value: true })), dP;
}
var fP = {}, Iqe;
function IS0() {
  return Iqe || (Iqe = 1, Object.defineProperty(fP, "__esModule", { value: true })), fP;
}
var bP = {}, Eqe;
function ES0() {
  return Eqe || (Eqe = 1, Object.defineProperty(bP, "__esModule", { value: true })), bP;
}
var MP = {}, Lqe;
function LS0() {
  return Lqe || (Lqe = 1, Object.defineProperty(MP, "__esModule", { value: true })), MP;
}
var OP = {}, Pqe;
function PS0() {
  return Pqe || (Pqe = 1, Object.defineProperty(OP, "__esModule", { value: true })), OP;
}
var zP = {}, Dqe;
function DS0() {
  return Dqe || (Dqe = 1, Object.defineProperty(zP, "__esModule", { value: true })), zP;
}
var AP = {}, Wqe;
function WS0() {
  return Wqe || (Wqe = 1, Object.defineProperty(AP, "__esModule", { value: true })), AP;
}
var _P = {}, Nqe;
function NS0() {
  return Nqe || (Nqe = 1, Object.defineProperty(_P, "__esModule", { value: true })), _P;
}
var hP = {}, wqe;
function wS0() {
  return wqe || (wqe = 1, Object.defineProperty(hP, "__esModule", { value: true })), hP;
}
var vP = {}, Bqe;
function BS0() {
  return Bqe || (Bqe = 1, Object.defineProperty(vP, "__esModule", { value: true })), vP;
}
var mP = {}, xqe;
function xS0() {
  return xqe || (xqe = 1, Object.defineProperty(mP, "__esModule", { value: true })), mP;
}
var RP = {}, Uqe;
function US0() {
  return Uqe || (Uqe = 1, Object.defineProperty(RP, "__esModule", { value: true })), RP;
}
var qP = {}, kqe;
function kS0() {
  return kqe || (kqe = 1, Object.defineProperty(qP, "__esModule", { value: true })), qP;
}
var TP = {}, jqe;
function jS0() {
  return jqe || (jqe = 1, Object.defineProperty(TP, "__esModule", { value: true })), TP;
}
var yP = {}, Fqe;
function FS0() {
  return Fqe || (Fqe = 1, Object.defineProperty(yP, "__esModule", { value: true })), yP;
}
var SP = {}, Vqe;
function VS0() {
  return Vqe || (Vqe = 1, Object.defineProperty(SP, "__esModule", { value: true })), SP;
}
var CP = {}, Hqe;
function HS0() {
  return Hqe || (Hqe = 1, Object.defineProperty(CP, "__esModule", { value: true })), CP;
}
var gP = {}, Xqe;
function XS0() {
  return Xqe || (Xqe = 1, Object.defineProperty(gP, "__esModule", { value: true })), gP;
}
var IP = {}, $qe;
function $S0() {
  return $qe || ($qe = 1, Object.defineProperty(IP, "__esModule", { value: true })), IP;
}
var EP = {}, Gqe;
function GS0() {
  return Gqe || (Gqe = 1, Object.defineProperty(EP, "__esModule", { value: true })), EP;
}
var LP = {}, Yqe;
function YS0() {
  return Yqe || (Yqe = 1, Object.defineProperty(LP, "__esModule", { value: true })), LP;
}
var PP = {}, Jqe;
function JS0() {
  return Jqe || (Jqe = 1, Object.defineProperty(PP, "__esModule", { value: true })), PP;
}
var DP = {}, Kqe;
function KS0() {
  return Kqe || (Kqe = 1, Object.defineProperty(DP, "__esModule", { value: true })), DP;
}
var WP = {}, Qqe;
function QS0() {
  return Qqe || (Qqe = 1, Object.defineProperty(WP, "__esModule", { value: true })), WP;
}
var NP = {}, Zqe;
function ZS0() {
  return Zqe || (Zqe = 1, Object.defineProperty(NP, "__esModule", { value: true })), NP;
}
var wP = {}, eTe;
function e60() {
  return eTe || (eTe = 1, Object.defineProperty(wP, "__esModule", { value: true })), wP;
}
var BP = {}, tTe;
function t60() {
  return tTe || (tTe = 1, Object.defineProperty(BP, "__esModule", { value: true })), BP;
}
var xP = {}, rTe;
function r60() {
  return rTe || (rTe = 1, Object.defineProperty(xP, "__esModule", { value: true })), xP;
}
var UP = {}, nTe;
function n60() {
  return nTe || (nTe = 1, Object.defineProperty(UP, "__esModule", { value: true })), UP;
}
var kP = {}, aTe;
function a60() {
  return aTe || (aTe = 1, Object.defineProperty(kP, "__esModule", { value: true })), kP;
}
var jP = {}, oTe;
function o60() {
  return oTe || (oTe = 1, Object.defineProperty(jP, "__esModule", { value: true })), jP;
}
var FP = {}, iTe;
function i60() {
  return iTe || (iTe = 1, Object.defineProperty(FP, "__esModule", { value: true })), FP;
}
var VP = {}, uTe;
function u60() {
  return uTe || (uTe = 1, Object.defineProperty(VP, "__esModule", { value: true })), VP;
}
var HP = {}, sTe;
function s60() {
  return sTe || (sTe = 1, Object.defineProperty(HP, "__esModule", { value: true })), HP;
}
var XP = {}, cTe;
function c60() {
  return cTe || (cTe = 1, Object.defineProperty(XP, "__esModule", { value: true })), XP;
}
var $P = {}, lTe;
function l60() {
  return lTe || (lTe = 1, Object.defineProperty($P, "__esModule", { value: true })), $P;
}
var GP = {}, pTe;
function p60() {
  return pTe || (pTe = 1, Object.defineProperty(GP, "__esModule", { value: true })), GP;
}
var YP = {}, dTe;
function d60() {
  return dTe || (dTe = 1, Object.defineProperty(YP, "__esModule", { value: true })), YP;
}
var JP = {}, fTe;
function f60() {
  return fTe || (fTe = 1, Object.defineProperty(JP, "__esModule", { value: true })), JP;
}
var KP = {}, bTe;
function b60() {
  return bTe || (bTe = 1, Object.defineProperty(KP, "__esModule", { value: true })), KP;
}
var QP = {}, MTe;
function M60() {
  return MTe || (MTe = 1, Object.defineProperty(QP, "__esModule", { value: true })), QP;
}
var ZP = {}, OTe;
function O60() {
  return OTe || (OTe = 1, Object.defineProperty(ZP, "__esModule", { value: true })), ZP;
}
var eD = {}, zTe;
function z60() {
  return zTe || (zTe = 1, Object.defineProperty(eD, "__esModule", { value: true })), eD;
}
var tD = {}, ATe;
function A60() {
  return ATe || (ATe = 1, Object.defineProperty(tD, "__esModule", { value: true })), tD;
}
var rD = {}, _Te;
function _60() {
  return _Te || (_Te = 1, Object.defineProperty(rD, "__esModule", { value: true })), rD;
}
var nD = {}, hTe;
function h60() {
  return hTe || (hTe = 1, Object.defineProperty(nD, "__esModule", { value: true })), nD;
}
var aD = {}, vTe;
function v60() {
  return vTe || (vTe = 1, Object.defineProperty(aD, "__esModule", { value: true })), aD;
}
var oD = {}, mTe;
function m60() {
  return mTe || (mTe = 1, Object.defineProperty(oD, "__esModule", { value: true })), oD;
}
var iD = {}, RTe;
function R60() {
  return RTe || (RTe = 1, Object.defineProperty(iD, "__esModule", { value: true })), iD;
}
var uD = {}, qTe;
function q60() {
  return qTe || (qTe = 1, Object.defineProperty(uD, "__esModule", { value: true })), uD;
}
var sD = {}, TTe;
function T60() {
  return TTe || (TTe = 1, Object.defineProperty(sD, "__esModule", { value: true })), sD;
}
var cD = {}, yTe;
function y60() {
  return yTe || (yTe = 1, Object.defineProperty(cD, "__esModule", { value: true })), cD;
}
var lD = {}, STe;
function S60() {
  return STe || (STe = 1, Object.defineProperty(lD, "__esModule", { value: true })), lD;
}
var pD = {}, CTe;
function C60() {
  return CTe || (CTe = 1, Object.defineProperty(pD, "__esModule", { value: true })), pD;
}
var dD = {}, gTe;
function g60() {
  return gTe || (gTe = 1, Object.defineProperty(dD, "__esModule", { value: true })), dD;
}
var fD = {}, ITe;
function I60() {
  return ITe || (ITe = 1, Object.defineProperty(fD, "__esModule", { value: true })), fD;
}
var bD = {}, ETe;
function E60() {
  return ETe || (ETe = 1, Object.defineProperty(bD, "__esModule", { value: true })), bD;
}
var MD = {}, LTe;
function L60() {
  return LTe || (LTe = 1, Object.defineProperty(MD, "__esModule", { value: true })), MD;
}
var OD = {}, PTe;
function P60() {
  return PTe || (PTe = 1, Object.defineProperty(OD, "__esModule", { value: true })), OD;
}
var zD = {}, DTe;
function D60() {
  return DTe || (DTe = 1, Object.defineProperty(zD, "__esModule", { value: true })), zD;
}
var AD = {}, WTe;
function W60() {
  return WTe || (WTe = 1, Object.defineProperty(AD, "__esModule", { value: true })), AD;
}
var _D = {}, NTe;
function N60() {
  return NTe || (NTe = 1, Object.defineProperty(_D, "__esModule", { value: true })), _D;
}
var hD = {}, wTe;
function w60() {
  return wTe || (wTe = 1, Object.defineProperty(hD, "__esModule", { value: true })), hD;
}
var vD = {}, BTe;
function B60() {
  return BTe || (BTe = 1, Object.defineProperty(vD, "__esModule", { value: true })), vD;
}
var mD = {}, xTe;
function x60() {
  return xTe || (xTe = 1, Object.defineProperty(mD, "__esModule", { value: true })), mD;
}
var RD = {}, UTe;
function U60() {
  return UTe || (UTe = 1, Object.defineProperty(RD, "__esModule", { value: true })), RD;
}
var qD = {}, kTe;
function k60() {
  return kTe || (kTe = 1, Object.defineProperty(qD, "__esModule", { value: true })), qD;
}
var TD = {}, jTe;
function j60() {
  return jTe || (jTe = 1, Object.defineProperty(TD, "__esModule", { value: true })), TD;
}
var yD = {}, FTe;
function F60() {
  return FTe || (FTe = 1, Object.defineProperty(yD, "__esModule", { value: true })), yD;
}
var SD = {}, VTe;
function V60() {
  return VTe || (VTe = 1, Object.defineProperty(SD, "__esModule", { value: true })), SD;
}
var CD = {}, HTe;
function H60() {
  return HTe || (HTe = 1, Object.defineProperty(CD, "__esModule", { value: true })), CD;
}
var gD = {}, XTe;
function X60() {
  return XTe || (XTe = 1, Object.defineProperty(gD, "__esModule", { value: true })), gD;
}
var ID = {}, $Te;
function $60() {
  return $Te || ($Te = 1, Object.defineProperty(ID, "__esModule", { value: true })), ID;
}
var ED = {}, GTe;
function G60() {
  return GTe || (GTe = 1, Object.defineProperty(ED, "__esModule", { value: true })), ED;
}
var LD = {}, YTe;
function Y60() {
  return YTe || (YTe = 1, Object.defineProperty(LD, "__esModule", { value: true })), LD;
}
var PD = {}, JTe;
function J60() {
  return JTe || (JTe = 1, Object.defineProperty(PD, "__esModule", { value: true })), PD;
}
var DD = {}, KTe;
function K60() {
  return KTe || (KTe = 1, Object.defineProperty(DD, "__esModule", { value: true })), DD;
}
var WD = {}, QTe;
function Q60() {
  return QTe || (QTe = 1, Object.defineProperty(WD, "__esModule", { value: true })), WD;
}
var ND = {}, ZTe;
function Z60() {
  return ZTe || (ZTe = 1, Object.defineProperty(ND, "__esModule", { value: true })), ND;
}
var wD = {}, eye;
function eC0() {
  return eye || (eye = 1, Object.defineProperty(wD, "__esModule", { value: true })), wD;
}
var BD = {}, tye;
function tC0() {
  return tye || (tye = 1, Object.defineProperty(BD, "__esModule", { value: true })), BD;
}
var xD = {}, rye;
function rC0() {
  return rye || (rye = 1, Object.defineProperty(xD, "__esModule", { value: true })), xD;
}
var UD = {}, nye;
function nC0() {
  return nye || (nye = 1, Object.defineProperty(UD, "__esModule", { value: true })), UD;
}
var kD = {}, aye;
function aC0() {
  return aye || (aye = 1, Object.defineProperty(kD, "__esModule", { value: true })), kD;
}
var jD = {}, oye;
function oC0() {
  return oye || (oye = 1, Object.defineProperty(jD, "__esModule", { value: true })), jD;
}
var FD = {}, iye;
function iC0() {
  return iye || (iye = 1, Object.defineProperty(FD, "__esModule", { value: true })), FD;
}
var VD = {}, uye;
function uC0() {
  return uye || (uye = 1, Object.defineProperty(VD, "__esModule", { value: true })), VD;
}
var HD = {}, sye;
function sC0() {
  return sye || (sye = 1, Object.defineProperty(HD, "__esModule", { value: true })), HD;
}
var XD = {}, cye;
function cC0() {
  return cye || (cye = 1, Object.defineProperty(XD, "__esModule", { value: true })), XD;
}
var $D = {}, lye;
function lC0() {
  return lye || (lye = 1, Object.defineProperty($D, "__esModule", { value: true })), $D;
}
var GD = {}, pye;
function pC0() {
  return pye || (pye = 1, Object.defineProperty(GD, "__esModule", { value: true })), GD;
}
var YD = {}, dye;
function dC0() {
  return dye || (dye = 1, Object.defineProperty(YD, "__esModule", { value: true })), YD;
}
var JD = {}, fye;
function fC0() {
  return fye || (fye = 1, Object.defineProperty(JD, "__esModule", { value: true })), JD;
}
var KD = {}, bye;
function bC0() {
  return bye || (bye = 1, Object.defineProperty(KD, "__esModule", { value: true })), KD;
}
var QD = {}, Mye;
function MC0() {
  return Mye || (Mye = 1, Object.defineProperty(QD, "__esModule", { value: true })), QD;
}
var ZD = {}, Oye;
function OC0() {
  return Oye || (Oye = 1, Object.defineProperty(ZD, "__esModule", { value: true })), ZD;
}
var eW = {}, zye;
function zC0() {
  return zye || (zye = 1, Object.defineProperty(eW, "__esModule", { value: true })), eW;
}
var tW = {}, Aye;
function AC0() {
  return Aye || (Aye = 1, Object.defineProperty(tW, "__esModule", { value: true })), tW;
}
var rW = {}, _ye;
function _C0() {
  return _ye || (_ye = 1, Object.defineProperty(rW, "__esModule", { value: true })), rW;
}
var nW = {}, hye;
function hC0() {
  return hye || (hye = 1, Object.defineProperty(nW, "__esModule", { value: true })), nW;
}
var aW = {}, vye;
function vC0() {
  return vye || (vye = 1, Object.defineProperty(aW, "__esModule", { value: true })), aW;
}
var oW = {}, mye;
function mC0() {
  return mye || (mye = 1, Object.defineProperty(oW, "__esModule", { value: true })), oW;
}
var iW = {}, Rye;
function RC0() {
  return Rye || (Rye = 1, Object.defineProperty(iW, "__esModule", { value: true })), iW;
}
var uW = {}, qye;
function qC0() {
  return qye || (qye = 1, Object.defineProperty(uW, "__esModule", { value: true })), uW;
}
var sW = {}, Tye;
function TC0() {
  return Tye || (Tye = 1, Object.defineProperty(sW, "__esModule", { value: true })), sW;
}
var cW = {}, yye;
function yC0() {
  return yye || (yye = 1, Object.defineProperty(cW, "__esModule", { value: true })), cW;
}
var lW = {}, Sye;
function SC0() {
  return Sye || (Sye = 1, Object.defineProperty(lW, "__esModule", { value: true })), lW;
}
var pW = {}, Cye;
function CC0() {
  return Cye || (Cye = 1, Object.defineProperty(pW, "__esModule", { value: true })), pW;
}
var dW = {}, gye;
function gC0() {
  return gye || (gye = 1, Object.defineProperty(dW, "__esModule", { value: true })), dW;
}
var fW = {}, Iye;
function IC0() {
  return Iye || (Iye = 1, Object.defineProperty(fW, "__esModule", { value: true })), fW;
}
var bW = {}, Eye;
function EC0() {
  return Eye || (Eye = 1, Object.defineProperty(bW, "__esModule", { value: true })), bW;
}
var MW = {}, Lye;
function LC0() {
  return Lye || (Lye = 1, Object.defineProperty(MW, "__esModule", { value: true })), MW;
}
var OW = {}, Pye;
function PC0() {
  return Pye || (Pye = 1, Object.defineProperty(OW, "__esModule", { value: true })), OW;
}
var zW = {}, Dye;
function DC0() {
  return Dye || (Dye = 1, Object.defineProperty(zW, "__esModule", { value: true })), zW;
}
var AW = {}, Wye;
function WC0() {
  return Wye || (Wye = 1, Object.defineProperty(AW, "__esModule", { value: true })), AW;
}
var _W = {}, Nye;
function NC0() {
  return Nye || (Nye = 1, Object.defineProperty(_W, "__esModule", { value: true })), _W;
}
var hW = {}, wye;
function wC0() {
  return wye || (wye = 1, Object.defineProperty(hW, "__esModule", { value: true })), hW;
}
var vW = {}, Bye;
function BC0() {
  return Bye || (Bye = 1, Object.defineProperty(vW, "__esModule", { value: true })), vW;
}
var mW = {}, xye;
function xC0() {
  return xye || (xye = 1, Object.defineProperty(mW, "__esModule", { value: true })), mW;
}
var RW = {}, Uye;
function UC0() {
  return Uye || (Uye = 1, Object.defineProperty(RW, "__esModule", { value: true })), RW;
}
var qW = {}, kye;
function kC0() {
  return kye || (kye = 1, Object.defineProperty(qW, "__esModule", { value: true })), qW;
}
var TW = {}, jye;
function jC0() {
  return jye || (jye = 1, Object.defineProperty(TW, "__esModule", { value: true })), TW;
}
var yW = {}, Fye;
function FC0() {
  return Fye || (Fye = 1, Object.defineProperty(yW, "__esModule", { value: true })), yW;
}
var SW = {}, Vye;
function VC0() {
  return Vye || (Vye = 1, Object.defineProperty(SW, "__esModule", { value: true })), SW;
}
var CW = {}, Hye;
function HC0() {
  return Hye || (Hye = 1, Object.defineProperty(CW, "__esModule", { value: true })), CW;
}
var gW = {}, Xye;
function XC0() {
  return Xye || (Xye = 1, Object.defineProperty(gW, "__esModule", { value: true })), gW;
}
var IW = {}, $ye;
function $C0() {
  return $ye || ($ye = 1, Object.defineProperty(IW, "__esModule", { value: true })), IW;
}
var EW = {}, Gye;
function GC0() {
  return Gye || (Gye = 1, Object.defineProperty(EW, "__esModule", { value: true })), EW;
}
var LW = {}, Yye;
function YC0() {
  return Yye || (Yye = 1, Object.defineProperty(LW, "__esModule", { value: true })), LW;
}
var PW = {}, Jye;
function JC0() {
  return Jye || (Jye = 1, Object.defineProperty(PW, "__esModule", { value: true })), PW;
}
var DW = {}, Kye;
function KC0() {
  return Kye || (Kye = 1, Object.defineProperty(DW, "__esModule", { value: true })), DW;
}
var WW = {}, Qye;
function QC0() {
  return Qye || (Qye = 1, Object.defineProperty(WW, "__esModule", { value: true })), WW;
}
var NW = {}, Zye;
function ZC0() {
  return Zye || (Zye = 1, Object.defineProperty(NW, "__esModule", { value: true })), NW;
}
var wW = {}, e5e;
function eg0() {
  return e5e || (e5e = 1, Object.defineProperty(wW, "__esModule", { value: true })), wW;
}
var BW = {}, t5e;
function tg0() {
  return t5e || (t5e = 1, Object.defineProperty(BW, "__esModule", { value: true })), BW;
}
var xW = {}, r5e;
function rg0() {
  return r5e || (r5e = 1, Object.defineProperty(xW, "__esModule", { value: true })), xW;
}
var UW = {}, n5e;
function ng0() {
  return n5e || (n5e = 1, Object.defineProperty(UW, "__esModule", { value: true })), UW;
}
var kW = {}, a5e;
function ag0() {
  return a5e || (a5e = 1, Object.defineProperty(kW, "__esModule", { value: true })), kW;
}
var jW = {}, o5e;
function og0() {
  return o5e || (o5e = 1, Object.defineProperty(jW, "__esModule", { value: true })), jW;
}
var FW = {}, i5e;
function ig0() {
  return i5e || (i5e = 1, Object.defineProperty(FW, "__esModule", { value: true })), FW;
}
var VW = {}, u5e;
function ug0() {
  return u5e || (u5e = 1, Object.defineProperty(VW, "__esModule", { value: true })), VW;
}
var HW = {}, s5e;
function sg0() {
  return s5e || (s5e = 1, Object.defineProperty(HW, "__esModule", { value: true })), HW;
}
var XW = {}, c5e;
function cg0() {
  return c5e || (c5e = 1, Object.defineProperty(XW, "__esModule", { value: true })), XW;
}
var $W = {}, l5e;
function lg0() {
  return l5e || (l5e = 1, Object.defineProperty($W, "__esModule", { value: true })), $W;
}
var GW = {}, p5e;
function pg0() {
  return p5e || (p5e = 1, Object.defineProperty(GW, "__esModule", { value: true })), GW;
}
var YW = {}, d5e;
function dg0() {
  return d5e || (d5e = 1, Object.defineProperty(YW, "__esModule", { value: true })), YW;
}
var JW = {}, f5e;
function fg0() {
  return f5e || (f5e = 1, Object.defineProperty(JW, "__esModule", { value: true })), JW;
}
var KW = {}, b5e;
function bg0() {
  return b5e || (b5e = 1, Object.defineProperty(KW, "__esModule", { value: true })), KW;
}
var QW = {}, M5e;
function Mg0() {
  return M5e || (M5e = 1, Object.defineProperty(QW, "__esModule", { value: true })), QW;
}
var ZW = {}, O5e;
function Og0() {
  return O5e || (O5e = 1, Object.defineProperty(ZW, "__esModule", { value: true })), ZW;
}
var eN = {}, z5e;
function zg0() {
  return z5e || (z5e = 1, Object.defineProperty(eN, "__esModule", { value: true })), eN;
}
var tN = {}, A5e;
function Ag0() {
  return A5e || (A5e = 1, Object.defineProperty(tN, "__esModule", { value: true })), tN;
}
var rN = {}, _5e;
function _g0() {
  return _5e || (_5e = 1, Object.defineProperty(rN, "__esModule", { value: true })), rN;
}
var nN = {}, h5e;
function hg0() {
  return h5e || (h5e = 1, Object.defineProperty(nN, "__esModule", { value: true })), nN;
}
var aN = {}, v5e;
function vg0() {
  return v5e || (v5e = 1, Object.defineProperty(aN, "__esModule", { value: true })), aN;
}
var oN = {}, m5e;
function mg0() {
  return m5e || (m5e = 1, Object.defineProperty(oN, "__esModule", { value: true })), oN;
}
var iN = {}, R5e;
function Rg0() {
  return R5e || (R5e = 1, Object.defineProperty(iN, "__esModule", { value: true })), iN;
}
var uN = {}, q5e;
function qg0() {
  return q5e || (q5e = 1, Object.defineProperty(uN, "__esModule", { value: true })), uN;
}
var sN = {}, T5e;
function Tg0() {
  return T5e || (T5e = 1, Object.defineProperty(sN, "__esModule", { value: true })), sN;
}
var cN = {}, y5e;
function yg0() {
  return y5e || (y5e = 1, Object.defineProperty(cN, "__esModule", { value: true })), cN;
}
var lN = {}, S5e;
function Sg0() {
  return S5e || (S5e = 1, Object.defineProperty(lN, "__esModule", { value: true })), lN;
}
var pN = {}, C5e;
function Cg0() {
  return C5e || (C5e = 1, Object.defineProperty(pN, "__esModule", { value: true })), pN;
}
var dN = {}, g5e;
function gg0() {
  return g5e || (g5e = 1, Object.defineProperty(dN, "__esModule", { value: true })), dN;
}
var fN = {}, I5e;
function Ig0() {
  return I5e || (I5e = 1, Object.defineProperty(fN, "__esModule", { value: true })), fN;
}
var bN = {}, E5e;
function Eg0() {
  return E5e || (E5e = 1, Object.defineProperty(bN, "__esModule", { value: true })), bN;
}
var MN = {}, L5e;
function Lg0() {
  return L5e || (L5e = 1, Object.defineProperty(MN, "__esModule", { value: true })), MN;
}
var ON = {}, P5e;
function Pg0() {
  return P5e || (P5e = 1, Object.defineProperty(ON, "__esModule", { value: true })), ON;
}
var zN = {}, D5e;
function Dg0() {
  return D5e || (D5e = 1, Object.defineProperty(zN, "__esModule", { value: true })), zN;
}
var AN = {}, W5e;
function Wg0() {
  return W5e || (W5e = 1, Object.defineProperty(AN, "__esModule", { value: true })), AN;
}
var _N = {}, N5e;
function Ng0() {
  return N5e || (N5e = 1, Object.defineProperty(_N, "__esModule", { value: true })), _N;
}
var hN = {}, w5e;
function wg0() {
  return w5e || (w5e = 1, Object.defineProperty(hN, "__esModule", { value: true })), hN;
}
var vN = {}, B5e;
function Bg0() {
  return B5e || (B5e = 1, Object.defineProperty(vN, "__esModule", { value: true })), vN;
}
var mN = {}, x5e;
function xg0() {
  return x5e || (x5e = 1, Object.defineProperty(mN, "__esModule", { value: true })), mN;
}
var RN = {}, U5e;
function Ug0() {
  return U5e || (U5e = 1, Object.defineProperty(RN, "__esModule", { value: true })), RN;
}
var qN = {}, k5e;
function kg0() {
  return k5e || (k5e = 1, Object.defineProperty(qN, "__esModule", { value: true })), qN;
}
var TN = {}, j5e;
function jg0() {
  return j5e || (j5e = 1, Object.defineProperty(TN, "__esModule", { value: true })), TN;
}
var yN = {}, F5e;
function Fg0() {
  return F5e || (F5e = 1, Object.defineProperty(yN, "__esModule", { value: true })), yN;
}
var SN = {}, V5e;
function Vg0() {
  return V5e || (V5e = 1, Object.defineProperty(SN, "__esModule", { value: true })), SN;
}
var CN = {}, H5e;
function Hg0() {
  return H5e || (H5e = 1, Object.defineProperty(CN, "__esModule", { value: true })), CN;
}
var gN = {}, X5e;
function Xg0() {
  return X5e || (X5e = 1, Object.defineProperty(gN, "__esModule", { value: true })), gN;
}
var IN = {}, $5e;
function $g0() {
  return $5e || ($5e = 1, Object.defineProperty(IN, "__esModule", { value: true })), IN;
}
var EN = {}, G5e;
function Gg0() {
  return G5e || (G5e = 1, Object.defineProperty(EN, "__esModule", { value: true })), EN;
}
var LN = {}, Y5e;
function Yg0() {
  return Y5e || (Y5e = 1, Object.defineProperty(LN, "__esModule", { value: true })), LN;
}
var PN = {}, J5e;
function Jg0() {
  return J5e || (J5e = 1, Object.defineProperty(PN, "__esModule", { value: true })), PN;
}
var DN = {}, K5e;
function Kg0() {
  return K5e || (K5e = 1, Object.defineProperty(DN, "__esModule", { value: true })), DN;
}
var WN = {}, Q5e;
function Qg0() {
  return Q5e || (Q5e = 1, Object.defineProperty(WN, "__esModule", { value: true })), WN;
}
var NN = {}, Z5e;
function Zg0() {
  return Z5e || (Z5e = 1, Object.defineProperty(NN, "__esModule", { value: true })), NN;
}
var wN = {}, eSe;
function eI0() {
  return eSe || (eSe = 1, Object.defineProperty(wN, "__esModule", { value: true })), wN;
}
var BN = {}, tSe;
function tI0() {
  return tSe || (tSe = 1, Object.defineProperty(BN, "__esModule", { value: true })), BN;
}
var xN = {}, rSe;
function rI0() {
  return rSe || (rSe = 1, Object.defineProperty(xN, "__esModule", { value: true })), xN;
}
var UN = {}, nSe;
function nI0() {
  return nSe || (nSe = 1, Object.defineProperty(UN, "__esModule", { value: true })), UN;
}
var kN = {}, aSe;
function aI0() {
  return aSe || (aSe = 1, Object.defineProperty(kN, "__esModule", { value: true })), kN;
}
var jN = {}, oSe;
function oI0() {
  return oSe || (oSe = 1, Object.defineProperty(jN, "__esModule", { value: true })), jN;
}
var FN = {}, iSe;
function iI0() {
  return iSe || (iSe = 1, Object.defineProperty(FN, "__esModule", { value: true })), FN;
}
var VN = {}, uSe;
function uI0() {
  return uSe || (uSe = 1, Object.defineProperty(VN, "__esModule", { value: true })), VN;
}
var HN = {}, sSe;
function sI0() {
  return sSe || (sSe = 1, Object.defineProperty(HN, "__esModule", { value: true })), HN;
}
var XN = {}, cSe;
function cI0() {
  return cSe || (cSe = 1, Object.defineProperty(XN, "__esModule", { value: true })), XN;
}
var $N = {}, lSe;
function lI0() {
  return lSe || (lSe = 1, Object.defineProperty($N, "__esModule", { value: true })), $N;
}
var GN = {}, pSe;
function pI0() {
  return pSe || (pSe = 1, Object.defineProperty(GN, "__esModule", { value: true })), GN;
}
var YN = {}, dSe;
function dI0() {
  return dSe || (dSe = 1, Object.defineProperty(YN, "__esModule", { value: true })), YN;
}
var JN = {}, fSe;
function fI0() {
  return fSe || (fSe = 1, Object.defineProperty(JN, "__esModule", { value: true })), JN;
}
var KN = {}, bSe;
function bI0() {
  return bSe || (bSe = 1, Object.defineProperty(KN, "__esModule", { value: true })), KN;
}
var QN = {}, MSe;
function MI0() {
  return MSe || (MSe = 1, Object.defineProperty(QN, "__esModule", { value: true })), QN;
}
var ZN = {}, OSe;
function OI0() {
  return OSe || (OSe = 1, Object.defineProperty(ZN, "__esModule", { value: true })), ZN;
}
var e8 = {}, zSe;
function zI0() {
  return zSe || (zSe = 1, Object.defineProperty(e8, "__esModule", { value: true })), e8;
}
var t8 = {}, ASe;
function AI0() {
  return ASe || (ASe = 1, Object.defineProperty(t8, "__esModule", { value: true })), t8;
}
var r8 = {}, _Se;
function _I0() {
  return _Se || (_Se = 1, Object.defineProperty(r8, "__esModule", { value: true })), r8;
}
var n8 = {}, hSe;
function hI0() {
  return hSe || (hSe = 1, Object.defineProperty(n8, "__esModule", { value: true })), n8;
}
var a8 = {}, vSe;
function vI0() {
  return vSe || (vSe = 1, Object.defineProperty(a8, "__esModule", { value: true })), a8;
}
var o8 = {}, mSe;
function mI0() {
  return mSe || (mSe = 1, Object.defineProperty(o8, "__esModule", { value: true })), o8;
}
var i8 = {}, RSe;
function RI0() {
  return RSe || (RSe = 1, Object.defineProperty(i8, "__esModule", { value: true })), i8;
}
var u8 = {}, qSe;
function qI0() {
  return qSe || (qSe = 1, Object.defineProperty(u8, "__esModule", { value: true })), u8;
}
var s8 = {}, TSe;
function TI0() {
  return TSe || (TSe = 1, Object.defineProperty(s8, "__esModule", { value: true })), s8;
}
var c8 = {}, ySe;
function yI0() {
  return ySe || (ySe = 1, Object.defineProperty(c8, "__esModule", { value: true })), c8;
}
var l8 = {}, SSe;
function SI0() {
  return SSe || (SSe = 1, Object.defineProperty(l8, "__esModule", { value: true })), l8;
}
var p8 = {}, CSe;
function CI0() {
  return CSe || (CSe = 1, Object.defineProperty(p8, "__esModule", { value: true })), p8;
}
var d8 = {}, gSe;
function gI0() {
  return gSe || (gSe = 1, Object.defineProperty(d8, "__esModule", { value: true })), d8;
}
var f8 = {}, ISe;
function II0() {
  return ISe || (ISe = 1, Object.defineProperty(f8, "__esModule", { value: true })), f8;
}
var b8 = {}, ESe;
function EI0() {
  return ESe || (ESe = 1, Object.defineProperty(b8, "__esModule", { value: true })), b8;
}
var M8 = {}, LSe;
function LI0() {
  return LSe || (LSe = 1, Object.defineProperty(M8, "__esModule", { value: true })), M8;
}
var O8 = {}, PSe;
function PI0() {
  return PSe || (PSe = 1, Object.defineProperty(O8, "__esModule", { value: true })), O8;
}
var z8 = {}, DSe;
function DI0() {
  return DSe || (DSe = 1, Object.defineProperty(z8, "__esModule", { value: true })), z8;
}
var A8 = {}, WSe;
function WI0() {
  return WSe || (WSe = 1, Object.defineProperty(A8, "__esModule", { value: true })), A8;
}
var _8 = {}, NSe;
function NI0() {
  return NSe || (NSe = 1, Object.defineProperty(_8, "__esModule", { value: true })), _8;
}
var h8 = {}, wSe;
function wI0() {
  return wSe || (wSe = 1, Object.defineProperty(h8, "__esModule", { value: true })), h8;
}
var v8 = {}, BSe;
function BI0() {
  return BSe || (BSe = 1, Object.defineProperty(v8, "__esModule", { value: true })), v8;
}
var m8 = {}, xSe;
function xI0() {
  return xSe || (xSe = 1, Object.defineProperty(m8, "__esModule", { value: true })), m8;
}
var R8 = {}, USe;
function UI0() {
  return USe || (USe = 1, Object.defineProperty(R8, "__esModule", { value: true })), R8;
}
var q8 = {}, kSe;
function kI0() {
  return kSe || (kSe = 1, Object.defineProperty(q8, "__esModule", { value: true })), q8;
}
var T8 = {}, jSe;
function jI0() {
  return jSe || (jSe = 1, Object.defineProperty(T8, "__esModule", { value: true })), T8;
}
var y8 = {}, FSe;
function FI0() {
  return FSe || (FSe = 1, Object.defineProperty(y8, "__esModule", { value: true })), y8;
}
var S8 = {}, VSe;
function VI0() {
  return VSe || (VSe = 1, Object.defineProperty(S8, "__esModule", { value: true })), S8;
}
var C8 = {}, HSe;
function HI0() {
  return HSe || (HSe = 1, Object.defineProperty(C8, "__esModule", { value: true })), C8;
}
var g8 = {}, XSe;
function XI0() {
  return XSe || (XSe = 1, Object.defineProperty(g8, "__esModule", { value: true })), g8;
}
var I8 = {}, $Se;
function $I0() {
  return $Se || ($Se = 1, Object.defineProperty(I8, "__esModule", { value: true })), I8;
}
var E8 = {}, GSe;
function GI0() {
  return GSe || (GSe = 1, Object.defineProperty(E8, "__esModule", { value: true })), E8;
}
var L8 = {}, YSe;
function YI0() {
  return YSe || (YSe = 1, Object.defineProperty(L8, "__esModule", { value: true })), L8;
}
var P8 = {}, JSe;
function JI0() {
  return JSe || (JSe = 1, Object.defineProperty(P8, "__esModule", { value: true })), P8;
}
var D8 = {}, KSe;
function KI0() {
  return KSe || (KSe = 1, Object.defineProperty(D8, "__esModule", { value: true })), D8;
}
var W8 = {}, QSe;
function QI0() {
  return QSe || (QSe = 1, Object.defineProperty(W8, "__esModule", { value: true })), W8;
}
var N8 = {}, ZSe;
function ZI0() {
  return ZSe || (ZSe = 1, Object.defineProperty(N8, "__esModule", { value: true })), N8;
}
var w8 = {}, e6e;
function eE0() {
  return e6e || (e6e = 1, Object.defineProperty(w8, "__esModule", { value: true })), w8;
}
var B8 = {}, t6e;
function tE0() {
  return t6e || (t6e = 1, Object.defineProperty(B8, "__esModule", { value: true })), B8;
}
var x8 = {}, r6e;
function rE0() {
  return r6e || (r6e = 1, Object.defineProperty(x8, "__esModule", { value: true })), x8;
}
var U8 = {}, n6e;
function nE0() {
  return n6e || (n6e = 1, Object.defineProperty(U8, "__esModule", { value: true })), U8;
}
var k8 = {}, a6e;
function aE0() {
  return a6e || (a6e = 1, Object.defineProperty(k8, "__esModule", { value: true })), k8;
}
var j8 = {}, o6e;
function oE0() {
  return o6e || (o6e = 1, Object.defineProperty(j8, "__esModule", { value: true })), j8;
}
var F8 = {}, i6e;
function iE0() {
  return i6e || (i6e = 1, Object.defineProperty(F8, "__esModule", { value: true })), F8;
}
var V8 = {}, u6e;
function uE0() {
  return u6e || (u6e = 1, Object.defineProperty(V8, "__esModule", { value: true })), V8;
}
var H8 = {}, s6e;
function sE0() {
  return s6e || (s6e = 1, Object.defineProperty(H8, "__esModule", { value: true })), H8;
}
var X8 = {}, c6e;
function cE0() {
  return c6e || (c6e = 1, Object.defineProperty(X8, "__esModule", { value: true })), X8;
}
var $8 = {}, l6e;
function lE0() {
  return l6e || (l6e = 1, Object.defineProperty($8, "__esModule", { value: true })), $8;
}
var G8 = {}, p6e;
function pE0() {
  return p6e || (p6e = 1, Object.defineProperty(G8, "__esModule", { value: true })), G8;
}
var Y8 = {}, d6e;
function dE0() {
  return d6e || (d6e = 1, Object.defineProperty(Y8, "__esModule", { value: true })), Y8;
}
var J8 = {}, f6e;
function fE0() {
  return f6e || (f6e = 1, Object.defineProperty(J8, "__esModule", { value: true })), J8;
}
var K8 = {}, b6e;
function bE0() {
  return b6e || (b6e = 1, Object.defineProperty(K8, "__esModule", { value: true })), K8;
}
var Q8 = {}, M6e;
function ME0() {
  return M6e || (M6e = 1, Object.defineProperty(Q8, "__esModule", { value: true })), Q8;
}
var Z8 = {}, O6e;
function OE0() {
  return O6e || (O6e = 1, Object.defineProperty(Z8, "__esModule", { value: true })), Z8;
}
var e7 = {}, z6e;
function zE0() {
  return z6e || (z6e = 1, Object.defineProperty(e7, "__esModule", { value: true })), e7;
}
var t7 = {}, A6e;
function AE0() {
  return A6e || (A6e = 1, Object.defineProperty(t7, "__esModule", { value: true })), t7;
}
var r7 = {}, _6e;
function _E0() {
  return _6e || (_6e = 1, Object.defineProperty(r7, "__esModule", { value: true })), r7;
}
var n7 = {}, h6e;
function hE0() {
  return h6e || (h6e = 1, Object.defineProperty(n7, "__esModule", { value: true })), n7;
}
var a7 = {}, v6e;
function vE0() {
  return v6e || (v6e = 1, Object.defineProperty(a7, "__esModule", { value: true })), a7;
}
var o7 = {}, m6e;
function mE0() {
  return m6e || (m6e = 1, Object.defineProperty(o7, "__esModule", { value: true })), o7;
}
var i7 = {}, R6e;
function RE0() {
  return R6e || (R6e = 1, Object.defineProperty(i7, "__esModule", { value: true })), i7;
}
var u7 = {}, q6e;
function qE0() {
  return q6e || (q6e = 1, Object.defineProperty(u7, "__esModule", { value: true })), u7;
}
var s7 = {}, T6e;
function TE0() {
  return T6e || (T6e = 1, Object.defineProperty(s7, "__esModule", { value: true })), s7;
}
var c7 = {}, y6e;
function yE0() {
  return y6e || (y6e = 1, Object.defineProperty(c7, "__esModule", { value: true })), c7;
}
var l7 = {}, S6e;
function SE0() {
  return S6e || (S6e = 1, Object.defineProperty(l7, "__esModule", { value: true })), l7;
}
var p7 = {}, C6e;
function CE0() {
  return C6e || (C6e = 1, Object.defineProperty(p7, "__esModule", { value: true })), p7;
}
var d7 = {}, g6e;
function gE0() {
  return g6e || (g6e = 1, Object.defineProperty(d7, "__esModule", { value: true })), d7;
}
var f7 = {}, I6e;
function IE0() {
  return I6e || (I6e = 1, Object.defineProperty(f7, "__esModule", { value: true })), f7;
}
var b7 = {}, E6e;
function EE0() {
  return E6e || (E6e = 1, Object.defineProperty(b7, "__esModule", { value: true })), b7;
}
var M7 = {}, L6e;
function LE0() {
  return L6e || (L6e = 1, Object.defineProperty(M7, "__esModule", { value: true })), M7;
}
var O7 = {}, P6e;
function PE0() {
  return P6e || (P6e = 1, Object.defineProperty(O7, "__esModule", { value: true })), O7;
}
var z7 = {}, D6e;
function DE0() {
  return D6e || (D6e = 1, Object.defineProperty(z7, "__esModule", { value: true })), z7;
}
var A7 = {}, W6e;
function WE0() {
  return W6e || (W6e = 1, Object.defineProperty(A7, "__esModule", { value: true })), A7;
}
var _7 = {}, N6e;
function NE0() {
  return N6e || (N6e = 1, Object.defineProperty(_7, "__esModule", { value: true })), _7;
}
var h7 = {}, w6e;
function wE0() {
  return w6e || (w6e = 1, Object.defineProperty(h7, "__esModule", { value: true })), h7;
}
var v7 = {}, B6e;
function BE0() {
  return B6e || (B6e = 1, Object.defineProperty(v7, "__esModule", { value: true })), v7;
}
var m7 = {}, x6e;
function xE0() {
  return x6e || (x6e = 1, Object.defineProperty(m7, "__esModule", { value: true })), m7;
}
var R7 = {}, U6e;
function UE0() {
  return U6e || (U6e = 1, Object.defineProperty(R7, "__esModule", { value: true })), R7;
}
var q7 = {}, k6e;
function kE0() {
  return k6e || (k6e = 1, Object.defineProperty(q7, "__esModule", { value: true })), q7;
}
var T7 = {}, j6e;
function jE0() {
  return j6e || (j6e = 1, Object.defineProperty(T7, "__esModule", { value: true })), T7;
}
var y7 = {}, F6e;
function FE0() {
  return F6e || (F6e = 1, Object.defineProperty(y7, "__esModule", { value: true })), y7;
}
var S7 = {}, V6e;
function VE0() {
  return V6e || (V6e = 1, Object.defineProperty(S7, "__esModule", { value: true })), S7;
}
var C7 = {}, H6e;
function HE0() {
  return H6e || (H6e = 1, Object.defineProperty(C7, "__esModule", { value: true })), C7;
}
var g7 = {}, X6e;
function XE0() {
  return X6e || (X6e = 1, Object.defineProperty(g7, "__esModule", { value: true })), g7;
}
var I7 = {}, $6e;
function $E0() {
  return $6e || ($6e = 1, Object.defineProperty(I7, "__esModule", { value: true })), I7;
}
var E7 = {}, G6e;
function GE0() {
  return G6e || (G6e = 1, Object.defineProperty(E7, "__esModule", { value: true })), E7;
}
var L7 = {}, Y6e;
function YE0() {
  return Y6e || (Y6e = 1, Object.defineProperty(L7, "__esModule", { value: true })), L7;
}
var P7 = {}, J6e;
function JE0() {
  return J6e || (J6e = 1, Object.defineProperty(P7, "__esModule", { value: true })), P7;
}
var D7 = {}, K6e;
function KE0() {
  return K6e || (K6e = 1, Object.defineProperty(D7, "__esModule", { value: true })), D7;
}
var W7 = {}, Q6e;
function QE0() {
  return Q6e || (Q6e = 1, Object.defineProperty(W7, "__esModule", { value: true })), W7;
}
var N7 = {}, Z6e;
function ZE0() {
  return Z6e || (Z6e = 1, Object.defineProperty(N7, "__esModule", { value: true })), N7;
}
var w7 = {}, eCe;
function eL0() {
  return eCe || (eCe = 1, Object.defineProperty(w7, "__esModule", { value: true })), w7;
}
var B7 = {}, tCe;
function tL0() {
  return tCe || (tCe = 1, Object.defineProperty(B7, "__esModule", { value: true })), B7;
}
var x7 = {}, rCe;
function rL0() {
  return rCe || (rCe = 1, Object.defineProperty(x7, "__esModule", { value: true })), x7;
}
var U7 = {}, nCe;
function nL0() {
  return nCe || (nCe = 1, Object.defineProperty(U7, "__esModule", { value: true })), U7;
}
var k7 = {}, aCe;
function aL0() {
  return aCe || (aCe = 1, Object.defineProperty(k7, "__esModule", { value: true })), k7;
}
var j7 = {}, oCe;
function oL0() {
  return oCe || (oCe = 1, Object.defineProperty(j7, "__esModule", { value: true })), j7;
}
var F7 = {}, iCe;
function iL0() {
  return iCe || (iCe = 1, Object.defineProperty(F7, "__esModule", { value: true })), F7;
}
var V7 = {}, uCe;
function uL0() {
  return uCe || (uCe = 1, Object.defineProperty(V7, "__esModule", { value: true })), V7;
}
var H7 = {}, sCe;
function sL0() {
  return sCe || (sCe = 1, Object.defineProperty(H7, "__esModule", { value: true })), H7;
}
var X7 = {}, cCe;
function cL0() {
  return cCe || (cCe = 1, Object.defineProperty(X7, "__esModule", { value: true })), X7;
}
var $7 = {}, lCe;
function lL0() {
  return lCe || (lCe = 1, Object.defineProperty($7, "__esModule", { value: true })), $7;
}
var G7 = {}, pCe;
function pL0() {
  return pCe || (pCe = 1, Object.defineProperty(G7, "__esModule", { value: true })), G7;
}
var Y7 = {}, dCe;
function dL0() {
  return dCe || (dCe = 1, Object.defineProperty(Y7, "__esModule", { value: true })), Y7;
}
var J7 = {}, fCe;
function fL0() {
  return fCe || (fCe = 1, Object.defineProperty(J7, "__esModule", { value: true })), J7;
}
var K7 = {}, bCe;
function bL0() {
  return bCe || (bCe = 1, Object.defineProperty(K7, "__esModule", { value: true })), K7;
}
var Q7 = {}, MCe;
function ML0() {
  return MCe || (MCe = 1, Object.defineProperty(Q7, "__esModule", { value: true })), Q7;
}
var Z7 = {}, OCe;
function OL0() {
  return OCe || (OCe = 1, Object.defineProperty(Z7, "__esModule", { value: true })), Z7;
}
var ew = {}, zCe;
function zL0() {
  return zCe || (zCe = 1, Object.defineProperty(ew, "__esModule", { value: true })), ew;
}
var tw = {}, ACe;
function AL0() {
  return ACe || (ACe = 1, Object.defineProperty(tw, "__esModule", { value: true })), tw;
}
var rw = {}, _Ce;
function _L0() {
  return _Ce || (_Ce = 1, Object.defineProperty(rw, "__esModule", { value: true })), rw;
}
var nw = {}, hCe;
function hL0() {
  return hCe || (hCe = 1, Object.defineProperty(nw, "__esModule", { value: true })), nw;
}
var aw = {}, vCe;
function vL0() {
  return vCe || (vCe = 1, Object.defineProperty(aw, "__esModule", { value: true })), aw;
}
var ow = {}, mCe;
function mL0() {
  return mCe || (mCe = 1, Object.defineProperty(ow, "__esModule", { value: true })), ow;
}
var iw = {}, RCe;
function RL0() {
  return RCe || (RCe = 1, Object.defineProperty(iw, "__esModule", { value: true })), iw;
}
var uw = {}, qCe;
function qL0() {
  return qCe || (qCe = 1, Object.defineProperty(uw, "__esModule", { value: true })), uw;
}
var sw = {}, TCe;
function TL0() {
  return TCe || (TCe = 1, Object.defineProperty(sw, "__esModule", { value: true })), sw;
}
var cw = {}, yCe;
function yL0() {
  return yCe || (yCe = 1, Object.defineProperty(cw, "__esModule", { value: true })), cw;
}
var lw = {}, SCe;
function SL0() {
  return SCe || (SCe = 1, Object.defineProperty(lw, "__esModule", { value: true })), lw;
}
var pw = {}, CCe;
function CL0() {
  return CCe || (CCe = 1, Object.defineProperty(pw, "__esModule", { value: true })), pw;
}
var dw = {}, gCe;
function gL0() {
  return gCe || (gCe = 1, Object.defineProperty(dw, "__esModule", { value: true })), dw;
}
var fw = {}, ICe;
function IL0() {
  return ICe || (ICe = 1, Object.defineProperty(fw, "__esModule", { value: true })), fw;
}
var bw = {}, ECe;
function EL0() {
  return ECe || (ECe = 1, Object.defineProperty(bw, "__esModule", { value: true })), bw;
}
var Mw = {}, LCe;
function LL0() {
  return LCe || (LCe = 1, Object.defineProperty(Mw, "__esModule", { value: true })), Mw;
}
var Ow = {}, PCe;
function PL0() {
  return PCe || (PCe = 1, Object.defineProperty(Ow, "__esModule", { value: true })), Ow;
}
var zw = {}, DCe;
function DL0() {
  return DCe || (DCe = 1, Object.defineProperty(zw, "__esModule", { value: true })), zw;
}
var Aw = {}, WCe;
function WL0() {
  return WCe || (WCe = 1, Object.defineProperty(Aw, "__esModule", { value: true })), Aw;
}
var _w = {}, NCe;
function NL0() {
  return NCe || (NCe = 1, Object.defineProperty(_w, "__esModule", { value: true })), _w;
}
var hw = {}, wCe;
function wL0() {
  return wCe || (wCe = 1, Object.defineProperty(hw, "__esModule", { value: true })), hw;
}
var vw = {}, BCe;
function BL0() {
  return BCe || (BCe = 1, Object.defineProperty(vw, "__esModule", { value: true })), vw;
}
var mw = {}, xCe;
function xL0() {
  return xCe || (xCe = 1, Object.defineProperty(mw, "__esModule", { value: true })), mw;
}
var Rw = {}, UCe;
function UL0() {
  return UCe || (UCe = 1, Object.defineProperty(Rw, "__esModule", { value: true })), Rw;
}
var qw = {}, kCe;
function kL0() {
  return kCe || (kCe = 1, Object.defineProperty(qw, "__esModule", { value: true })), qw;
}
var Tw = {}, jCe;
function jL0() {
  return jCe || (jCe = 1, Object.defineProperty(Tw, "__esModule", { value: true })), Tw;
}
var yw = {}, FCe;
function FL0() {
  return FCe || (FCe = 1, Object.defineProperty(yw, "__esModule", { value: true })), yw;
}
var Sw = {}, VCe;
function VL0() {
  return VCe || (VCe = 1, Object.defineProperty(Sw, "__esModule", { value: true })), Sw;
}
var Cw = {}, HCe;
function HL0() {
  return HCe || (HCe = 1, Object.defineProperty(Cw, "__esModule", { value: true })), Cw;
}
var gw = {}, XCe;
function XL0() {
  return XCe || (XCe = 1, Object.defineProperty(gw, "__esModule", { value: true })), gw;
}
var Iw = {}, $Ce;
function $L0() {
  return $Ce || ($Ce = 1, Object.defineProperty(Iw, "__esModule", { value: true })), Iw;
}
var Ew = {}, GCe;
function GL0() {
  return GCe || (GCe = 1, Object.defineProperty(Ew, "__esModule", { value: true })), Ew;
}
var Lw = {}, YCe;
function YL0() {
  return YCe || (YCe = 1, Object.defineProperty(Lw, "__esModule", { value: true })), Lw;
}
var Pw = {}, JCe;
function JL0() {
  return JCe || (JCe = 1, Object.defineProperty(Pw, "__esModule", { value: true })), Pw;
}
var Dw = {}, KCe;
function KL0() {
  return KCe || (KCe = 1, Object.defineProperty(Dw, "__esModule", { value: true })), Dw;
}
var Ww = {}, QCe;
function QL0() {
  return QCe || (QCe = 1, Object.defineProperty(Ww, "__esModule", { value: true })), Ww;
}
var Nw = {}, ZCe;
function ZL0() {
  return ZCe || (ZCe = 1, Object.defineProperty(Nw, "__esModule", { value: true })), Nw;
}
var ww = {}, ege;
function eP0() {
  return ege || (ege = 1, Object.defineProperty(ww, "__esModule", { value: true })), ww;
}
var Bw = {}, tge;
function tP0() {
  return tge || (tge = 1, Object.defineProperty(Bw, "__esModule", { value: true })), Bw;
}
var xw = {}, rge;
function rP0() {
  return rge || (rge = 1, Object.defineProperty(xw, "__esModule", { value: true })), xw;
}
var Uw = {}, nge;
function nP0() {
  return nge || (nge = 1, Object.defineProperty(Uw, "__esModule", { value: true })), Uw;
}
var kw = {}, age;
function aP0() {
  return age || (age = 1, Object.defineProperty(kw, "__esModule", { value: true })), kw;
}
var jw = {}, oge;
function oP0() {
  return oge || (oge = 1, Object.defineProperty(jw, "__esModule", { value: true })), jw;
}
var Fw = {}, ige;
function iP0() {
  return ige || (ige = 1, Object.defineProperty(Fw, "__esModule", { value: true })), Fw;
}
var Vw = {}, uge;
function uP0() {
  return uge || (uge = 1, Object.defineProperty(Vw, "__esModule", { value: true })), Vw;
}
var Hw = {}, sge;
function sP0() {
  return sge || (sge = 1, Object.defineProperty(Hw, "__esModule", { value: true })), Hw;
}
var Xw = {}, cge;
function cP0() {
  return cge || (cge = 1, Object.defineProperty(Xw, "__esModule", { value: true })), Xw;
}
var $w = {}, lge;
function lP0() {
  return lge || (lge = 1, Object.defineProperty($w, "__esModule", { value: true })), $w;
}
var Gw = {}, pge;
function pP0() {
  return pge || (pge = 1, Object.defineProperty(Gw, "__esModule", { value: true })), Gw;
}
var Yw = {}, dge;
function dP0() {
  return dge || (dge = 1, Object.defineProperty(Yw, "__esModule", { value: true })), Yw;
}
var Jw = {}, fge;
function fP0() {
  return fge || (fge = 1, Object.defineProperty(Jw, "__esModule", { value: true })), Jw;
}
var Kw = {}, bge;
function bP0() {
  return bge || (bge = 1, Object.defineProperty(Kw, "__esModule", { value: true })), Kw;
}
var Qw = {}, Mge;
function MP0() {
  return Mge || (Mge = 1, Object.defineProperty(Qw, "__esModule", { value: true })), Qw;
}
var Zw = {}, Oge;
function OP0() {
  return Oge || (Oge = 1, Object.defineProperty(Zw, "__esModule", { value: true })), Zw;
}
var eB = {}, zge;
function zP0() {
  return zge || (zge = 1, Object.defineProperty(eB, "__esModule", { value: true })), eB;
}
var tB = {}, Age;
function AP0() {
  return Age || (Age = 1, Object.defineProperty(tB, "__esModule", { value: true })), tB;
}
var rB = {}, _ge;
function _P0() {
  return _ge || (_ge = 1, Object.defineProperty(rB, "__esModule", { value: true })), rB;
}
var nB = {}, hge;
function hP0() {
  return hge || (hge = 1, Object.defineProperty(nB, "__esModule", { value: true })), nB;
}
var aB = {}, vge;
function vP0() {
  return vge || (vge = 1, Object.defineProperty(aB, "__esModule", { value: true })), aB;
}
var oB = {}, mge;
function mP0() {
  return mge || (mge = 1, Object.defineProperty(oB, "__esModule", { value: true })), oB;
}
var iB = {}, Rge;
function RP0() {
  return Rge || (Rge = 1, Object.defineProperty(iB, "__esModule", { value: true })), iB;
}
var uB = {}, qge;
function qP0() {
  return qge || (qge = 1, Object.defineProperty(uB, "__esModule", { value: true })), uB;
}
var sB = {}, Tge;
function TP0() {
  return Tge || (Tge = 1, Object.defineProperty(sB, "__esModule", { value: true })), sB;
}
var cB = {}, yge;
function yP0() {
  return yge || (yge = 1, Object.defineProperty(cB, "__esModule", { value: true })), cB;
}
var lB = {}, Sge;
function SP0() {
  return Sge || (Sge = 1, Object.defineProperty(lB, "__esModule", { value: true })), lB;
}
var pB = {}, Cge;
function CP0() {
  return Cge || (Cge = 1, Object.defineProperty(pB, "__esModule", { value: true })), pB;
}
var dB = {}, gge;
function gP0() {
  return gge || (gge = 1, Object.defineProperty(dB, "__esModule", { value: true })), dB;
}
var fB = {}, Ige;
function IP0() {
  return Ige || (Ige = 1, Object.defineProperty(fB, "__esModule", { value: true })), fB;
}
var bB = {}, Ege;
function EP0() {
  return Ege || (Ege = 1, Object.defineProperty(bB, "__esModule", { value: true })), bB;
}
var MB = {}, Lge;
function LP0() {
  return Lge || (Lge = 1, Object.defineProperty(MB, "__esModule", { value: true })), MB;
}
var OB = {}, Pge;
function PP0() {
  return Pge || (Pge = 1, Object.defineProperty(OB, "__esModule", { value: true })), OB;
}
var zB = {}, Dge;
function DP0() {
  return Dge || (Dge = 1, Object.defineProperty(zB, "__esModule", { value: true })), zB;
}
var AB = {}, Wge;
function WP0() {
  return Wge || (Wge = 1, Object.defineProperty(AB, "__esModule", { value: true })), AB;
}
var _B = {}, Nge;
function NP0() {
  return Nge || (Nge = 1, Object.defineProperty(_B, "__esModule", { value: true })), _B;
}
var hB = {}, wge;
function wP0() {
  return wge || (wge = 1, Object.defineProperty(hB, "__esModule", { value: true })), hB;
}
var vB = {}, Bge;
function BP0() {
  return Bge || (Bge = 1, Object.defineProperty(vB, "__esModule", { value: true })), vB;
}
var mB = {}, xge;
function xP0() {
  return xge || (xge = 1, Object.defineProperty(mB, "__esModule", { value: true })), mB;
}
var RB = {}, Uge;
function UP0() {
  return Uge || (Uge = 1, Object.defineProperty(RB, "__esModule", { value: true })), RB;
}
var qB = {}, kge;
function kP0() {
  return kge || (kge = 1, Object.defineProperty(qB, "__esModule", { value: true })), qB;
}
var TB = {}, jge;
function jP0() {
  return jge || (jge = 1, Object.defineProperty(TB, "__esModule", { value: true })), TB;
}
var yB = {}, Fge;
function FP0() {
  return Fge || (Fge = 1, Object.defineProperty(yB, "__esModule", { value: true })), yB;
}
var SB = {}, Vge;
function VP0() {
  return Vge || (Vge = 1, Object.defineProperty(SB, "__esModule", { value: true })), SB;
}
var CB = {}, Hge;
function HP0() {
  return Hge || (Hge = 1, Object.defineProperty(CB, "__esModule", { value: true })), CB;
}
var gB = {}, Xge;
function XP0() {
  return Xge || (Xge = 1, Object.defineProperty(gB, "__esModule", { value: true })), gB;
}
var IB = {}, $ge;
function $P0() {
  return $ge || ($ge = 1, Object.defineProperty(IB, "__esModule", { value: true })), IB;
}
var EB = {}, Gge;
function GP0() {
  return Gge || (Gge = 1, Object.defineProperty(EB, "__esModule", { value: true })), EB;
}
var LB = {}, Yge;
function YP0() {
  return Yge || (Yge = 1, Object.defineProperty(LB, "__esModule", { value: true })), LB;
}
var PB = {}, Jge;
function JP0() {
  return Jge || (Jge = 1, Object.defineProperty(PB, "__esModule", { value: true })), PB;
}
var DB = {}, Kge;
function KP0() {
  return Kge || (Kge = 1, Object.defineProperty(DB, "__esModule", { value: true })), DB;
}
var WB = {}, Qge;
function QP0() {
  return Qge || (Qge = 1, Object.defineProperty(WB, "__esModule", { value: true })), WB;
}
var NB = {}, Zge;
function ZP0() {
  return Zge || (Zge = 1, Object.defineProperty(NB, "__esModule", { value: true })), NB;
}
var wB = {}, eIe;
function eD0() {
  return eIe || (eIe = 1, Object.defineProperty(wB, "__esModule", { value: true })), wB;
}
var BB = {}, tIe;
function tD0() {
  return tIe || (tIe = 1, Object.defineProperty(BB, "__esModule", { value: true })), BB;
}
var xB = {}, rIe;
function rD0() {
  return rIe || (rIe = 1, Object.defineProperty(xB, "__esModule", { value: true })), xB;
}
var UB = {}, nIe;
function nD0() {
  return nIe || (nIe = 1, Object.defineProperty(UB, "__esModule", { value: true })), UB;
}
var kB = {}, aIe;
function aD0() {
  return aIe || (aIe = 1, Object.defineProperty(kB, "__esModule", { value: true })), kB;
}
var jB = {}, oIe;
function oD0() {
  return oIe || (oIe = 1, Object.defineProperty(jB, "__esModule", { value: true })), jB;
}
var FB = {}, iIe;
function iD0() {
  return iIe || (iIe = 1, Object.defineProperty(FB, "__esModule", { value: true })), FB;
}
var VB = {}, uIe;
function uD0() {
  return uIe || (uIe = 1, Object.defineProperty(VB, "__esModule", { value: true })), VB;
}
var HB = {}, sIe;
function sD0() {
  return sIe || (sIe = 1, Object.defineProperty(HB, "__esModule", { value: true })), HB;
}
var XB = {}, cIe;
function cD0() {
  return cIe || (cIe = 1, Object.defineProperty(XB, "__esModule", { value: true })), XB;
}
var $B = {}, lIe;
function lD0() {
  return lIe || (lIe = 1, Object.defineProperty($B, "__esModule", { value: true })), $B;
}
var GB = {}, pIe;
function pD0() {
  return pIe || (pIe = 1, Object.defineProperty(GB, "__esModule", { value: true })), GB;
}
var YB = {}, dIe;
function dD0() {
  return dIe || (dIe = 1, Object.defineProperty(YB, "__esModule", { value: true })), YB;
}
var JB = {}, fIe;
function fD0() {
  return fIe || (fIe = 1, Object.defineProperty(JB, "__esModule", { value: true })), JB;
}
var KB = {}, bIe;
function bD0() {
  return bIe || (bIe = 1, Object.defineProperty(KB, "__esModule", { value: true })), KB;
}
var QB = {}, MIe;
function MD0() {
  return MIe || (MIe = 1, Object.defineProperty(QB, "__esModule", { value: true })), QB;
}
var ZB = {}, OIe;
function OD0() {
  return OIe || (OIe = 1, Object.defineProperty(ZB, "__esModule", { value: true })), ZB;
}
var e9 = {}, zIe;
function zD0() {
  return zIe || (zIe = 1, Object.defineProperty(e9, "__esModule", { value: true })), e9;
}
var t9 = {}, AIe;
function AD0() {
  return AIe || (AIe = 1, Object.defineProperty(t9, "__esModule", { value: true })), t9;
}
var r9 = {}, _Ie;
function _D0() {
  return _Ie || (_Ie = 1, Object.defineProperty(r9, "__esModule", { value: true })), r9;
}
var n9 = {}, hIe;
function hD0() {
  return hIe || (hIe = 1, Object.defineProperty(n9, "__esModule", { value: true })), n9;
}
var a9 = {}, vIe;
function vD0() {
  return vIe || (vIe = 1, Object.defineProperty(a9, "__esModule", { value: true })), a9;
}
var o9 = {}, mIe;
function mD0() {
  return mIe || (mIe = 1, Object.defineProperty(o9, "__esModule", { value: true })), o9;
}
var i9 = {}, RIe;
function RD0() {
  return RIe || (RIe = 1, Object.defineProperty(i9, "__esModule", { value: true })), i9;
}
var u9 = {}, qIe;
function qD0() {
  return qIe || (qIe = 1, Object.defineProperty(u9, "__esModule", { value: true })), u9;
}
var s9 = {}, TIe;
function TD0() {
  return TIe || (TIe = 1, Object.defineProperty(s9, "__esModule", { value: true })), s9;
}
var c9 = {}, yIe;
function yD0() {
  return yIe || (yIe = 1, Object.defineProperty(c9, "__esModule", { value: true })), c9;
}
var l9 = {}, SIe;
function SD0() {
  return SIe || (SIe = 1, Object.defineProperty(l9, "__esModule", { value: true })), l9;
}
var p9 = {}, CIe;
function CD0() {
  return CIe || (CIe = 1, Object.defineProperty(p9, "__esModule", { value: true })), p9;
}
var d9 = {}, gIe;
function gD0() {
  return gIe || (gIe = 1, Object.defineProperty(d9, "__esModule", { value: true })), d9;
}
var f9 = {}, IIe;
function ID0() {
  return IIe || (IIe = 1, Object.defineProperty(f9, "__esModule", { value: true })), f9;
}
var b9 = {}, EIe;
function ED0() {
  return EIe || (EIe = 1, Object.defineProperty(b9, "__esModule", { value: true })), b9;
}
var M9 = {}, LIe;
function LD0() {
  return LIe || (LIe = 1, Object.defineProperty(M9, "__esModule", { value: true })), M9;
}
var O9 = {}, PIe;
function PD0() {
  return PIe || (PIe = 1, Object.defineProperty(O9, "__esModule", { value: true })), O9;
}
var z9 = {}, DIe;
function DD0() {
  return DIe || (DIe = 1, Object.defineProperty(z9, "__esModule", { value: true })), z9;
}
var A9 = {}, WIe;
function WD0() {
  return WIe || (WIe = 1, Object.defineProperty(A9, "__esModule", { value: true })), A9;
}
var _9 = {}, NIe;
function ND0() {
  return NIe || (NIe = 1, Object.defineProperty(_9, "__esModule", { value: true })), _9;
}
var h9 = {}, wIe;
function wD0() {
  return wIe || (wIe = 1, Object.defineProperty(h9, "__esModule", { value: true })), h9;
}
var v9 = {}, BIe;
function BD0() {
  return BIe || (BIe = 1, Object.defineProperty(v9, "__esModule", { value: true })), v9;
}
var m9 = {}, xIe;
function xD0() {
  return xIe || (xIe = 1, Object.defineProperty(m9, "__esModule", { value: true })), m9;
}
var R9 = {}, UIe;
function UD0() {
  return UIe || (UIe = 1, Object.defineProperty(R9, "__esModule", { value: true })), R9;
}
var q9 = {}, kIe;
function kD0() {
  return kIe || (kIe = 1, Object.defineProperty(q9, "__esModule", { value: true })), q9;
}
var T9 = {}, jIe;
function jD0() {
  return jIe || (jIe = 1, Object.defineProperty(T9, "__esModule", { value: true })), T9;
}
var y9 = {}, FIe;
function FD0() {
  return FIe || (FIe = 1, Object.defineProperty(y9, "__esModule", { value: true })), y9;
}
var S9 = {}, VIe;
function VD0() {
  return VIe || (VIe = 1, Object.defineProperty(S9, "__esModule", { value: true })), S9;
}
var C9 = {}, HIe;
function HD0() {
  return HIe || (HIe = 1, Object.defineProperty(C9, "__esModule", { value: true })), C9;
}
var g9 = {}, XIe;
function XD0() {
  return XIe || (XIe = 1, Object.defineProperty(g9, "__esModule", { value: true })), g9;
}
var I9 = {}, $Ie;
function $D0() {
  return $Ie || ($Ie = 1, Object.defineProperty(I9, "__esModule", { value: true })), I9;
}
var E9 = {}, GIe;
function GD0() {
  return GIe || (GIe = 1, Object.defineProperty(E9, "__esModule", { value: true })), E9;
}
var L9 = {}, YIe;
function YD0() {
  return YIe || (YIe = 1, Object.defineProperty(L9, "__esModule", { value: true })), L9;
}
var P9 = {}, JIe;
function JD0() {
  return JIe || (JIe = 1, Object.defineProperty(P9, "__esModule", { value: true })), P9;
}
var D9 = {}, KIe;
function KD0() {
  return KIe || (KIe = 1, Object.defineProperty(D9, "__esModule", { value: true })), D9;
}
var W9 = {}, QIe;
function QD0() {
  return QIe || (QIe = 1, Object.defineProperty(W9, "__esModule", { value: true })), W9;
}
var N9 = {}, ZIe;
function ZD0() {
  return ZIe || (ZIe = 1, Object.defineProperty(N9, "__esModule", { value: true })), N9;
}
var w9 = {}, eEe;
function eW0() {
  return eEe || (eEe = 1, Object.defineProperty(w9, "__esModule", { value: true })), w9;
}
var B9 = {}, tEe;
function tW0() {
  return tEe || (tEe = 1, Object.defineProperty(B9, "__esModule", { value: true })), B9;
}
var x9 = {}, rEe;
function rW0() {
  return rEe || (rEe = 1, Object.defineProperty(x9, "__esModule", { value: true })), x9;
}
var U9 = {}, nEe;
function nW0() {
  return nEe || (nEe = 1, Object.defineProperty(U9, "__esModule", { value: true })), U9;
}
var k9 = {}, aEe;
function aW0() {
  return aEe || (aEe = 1, Object.defineProperty(k9, "__esModule", { value: true })), k9;
}
var j9 = {}, oEe;
function oW0() {
  return oEe || (oEe = 1, Object.defineProperty(j9, "__esModule", { value: true })), j9;
}
var F9 = {}, iEe;
function iW0() {
  return iEe || (iEe = 1, Object.defineProperty(F9, "__esModule", { value: true })), F9;
}
var V9 = {}, uEe;
function uW0() {
  return uEe || (uEe = 1, Object.defineProperty(V9, "__esModule", { value: true })), V9;
}
var H9 = {}, sEe;
function sW0() {
  return sEe || (sEe = 1, Object.defineProperty(H9, "__esModule", { value: true })), H9;
}
var X9 = {}, cEe;
function cW0() {
  return cEe || (cEe = 1, Object.defineProperty(X9, "__esModule", { value: true })), X9;
}
var $9 = {}, lEe;
function lW0() {
  return lEe || (lEe = 1, Object.defineProperty($9, "__esModule", { value: true })), $9;
}
var G9 = {}, pEe;
function pW0() {
  return pEe || (pEe = 1, Object.defineProperty(G9, "__esModule", { value: true })), G9;
}
var Y9 = {}, dEe;
function dW0() {
  return dEe || (dEe = 1, Object.defineProperty(Y9, "__esModule", { value: true })), Y9;
}
var J9 = {}, fEe;
function fW0() {
  return fEe || (fEe = 1, Object.defineProperty(J9, "__esModule", { value: true })), J9;
}
var K9 = {}, bEe;
function bW0() {
  return bEe || (bEe = 1, Object.defineProperty(K9, "__esModule", { value: true })), K9;
}
var Q9 = {}, MEe;
function MW0() {
  return MEe || (MEe = 1, Object.defineProperty(Q9, "__esModule", { value: true })), Q9;
}
var Z9 = {}, OEe;
function OW0() {
  return OEe || (OEe = 1, Object.defineProperty(Z9, "__esModule", { value: true })), Z9;
}
var ex = {}, zEe;
function zW0() {
  return zEe || (zEe = 1, Object.defineProperty(ex, "__esModule", { value: true })), ex;
}
var tx = {}, AEe;
function AW0() {
  return AEe || (AEe = 1, Object.defineProperty(tx, "__esModule", { value: true })), tx;
}
var rx = {}, _Ee;
function _W0() {
  return _Ee || (_Ee = 1, Object.defineProperty(rx, "__esModule", { value: true })), rx;
}
var nx = {}, hEe;
function hW0() {
  return hEe || (hEe = 1, Object.defineProperty(nx, "__esModule", { value: true })), nx;
}
var ax = {}, vEe;
function vW0() {
  return vEe || (vEe = 1, Object.defineProperty(ax, "__esModule", { value: true })), ax;
}
var ox = {}, mEe;
function mW0() {
  return mEe || (mEe = 1, Object.defineProperty(ox, "__esModule", { value: true })), ox;
}
var ix = {}, REe;
function RW0() {
  return REe || (REe = 1, Object.defineProperty(ix, "__esModule", { value: true })), ix;
}
var ux = {}, qEe;
function qW0() {
  return qEe || (qEe = 1, Object.defineProperty(ux, "__esModule", { value: true })), ux;
}
var sx = {}, TEe;
function TW0() {
  return TEe || (TEe = 1, Object.defineProperty(sx, "__esModule", { value: true })), sx;
}
var cx = {}, yEe;
function yW0() {
  return yEe || (yEe = 1, Object.defineProperty(cx, "__esModule", { value: true })), cx;
}
var lx = {}, SEe;
function SW0() {
  return SEe || (SEe = 1, Object.defineProperty(lx, "__esModule", { value: true })), lx;
}
var px = {}, CEe;
function CW0() {
  return CEe || (CEe = 1, Object.defineProperty(px, "__esModule", { value: true })), px;
}
var dx = {}, gEe;
function gW0() {
  return gEe || (gEe = 1, Object.defineProperty(dx, "__esModule", { value: true })), dx;
}
var fx = {}, IEe;
function IW0() {
  return IEe || (IEe = 1, Object.defineProperty(fx, "__esModule", { value: true })), fx;
}
var bx = {}, EEe;
function EW0() {
  return EEe || (EEe = 1, Object.defineProperty(bx, "__esModule", { value: true })), bx;
}
var Mx = {}, LEe;
function LW0() {
  return LEe || (LEe = 1, Object.defineProperty(Mx, "__esModule", { value: true })), Mx;
}
var Ox = {}, PEe;
function PW0() {
  return PEe || (PEe = 1, Object.defineProperty(Ox, "__esModule", { value: true })), Ox;
}
var zx = {}, DEe;
function DW0() {
  return DEe || (DEe = 1, Object.defineProperty(zx, "__esModule", { value: true })), zx;
}
var Ax = {}, WEe;
function WW0() {
  return WEe || (WEe = 1, Object.defineProperty(Ax, "__esModule", { value: true })), Ax;
}
var _x = {}, NEe;
function NW0() {
  return NEe || (NEe = 1, Object.defineProperty(_x, "__esModule", { value: true })), _x;
}
var hx = {}, wEe;
function wW0() {
  return wEe || (wEe = 1, Object.defineProperty(hx, "__esModule", { value: true })), hx;
}
var vx = {}, BEe;
function BW0() {
  return BEe || (BEe = 1, Object.defineProperty(vx, "__esModule", { value: true })), vx;
}
var mx = {}, xEe;
function xW0() {
  return xEe || (xEe = 1, Object.defineProperty(mx, "__esModule", { value: true })), mx;
}
var Rx = {}, UEe;
function UW0() {
  return UEe || (UEe = 1, Object.defineProperty(Rx, "__esModule", { value: true })), Rx;
}
var qx = {}, kEe;
function kW0() {
  return kEe || (kEe = 1, Object.defineProperty(qx, "__esModule", { value: true })), qx;
}
var Tx = {}, jEe;
function jW0() {
  return jEe || (jEe = 1, Object.defineProperty(Tx, "__esModule", { value: true })), Tx;
}
var yx = {}, FEe;
function FW0() {
  return FEe || (FEe = 1, Object.defineProperty(yx, "__esModule", { value: true })), yx;
}
var Sx = {}, VEe;
function VW0() {
  return VEe || (VEe = 1, Object.defineProperty(Sx, "__esModule", { value: true })), Sx;
}
var Cx = {}, HEe;
function HW0() {
  return HEe || (HEe = 1, Object.defineProperty(Cx, "__esModule", { value: true })), Cx;
}
var gx = {}, XEe;
function XW0() {
  return XEe || (XEe = 1, Object.defineProperty(gx, "__esModule", { value: true })), gx;
}
var Ix = {}, $Ee;
function $W0() {
  return $Ee || ($Ee = 1, Object.defineProperty(Ix, "__esModule", { value: true })), Ix;
}
var Ex = {}, GEe;
function GW0() {
  return GEe || (GEe = 1, Object.defineProperty(Ex, "__esModule", { value: true })), Ex;
}
var Lx = {}, YEe;
function YW0() {
  return YEe || (YEe = 1, Object.defineProperty(Lx, "__esModule", { value: true })), Lx;
}
var Px = {}, JEe;
function JW0() {
  return JEe || (JEe = 1, Object.defineProperty(Px, "__esModule", { value: true })), Px;
}
var Dx = {}, KEe;
function KW0() {
  return KEe || (KEe = 1, Object.defineProperty(Dx, "__esModule", { value: true })), Dx;
}
var Wx = {}, QEe;
function QW0() {
  return QEe || (QEe = 1, Object.defineProperty(Wx, "__esModule", { value: true })), Wx;
}
var Nx = {}, ZEe;
function ZW0() {
  return ZEe || (ZEe = 1, Object.defineProperty(Nx, "__esModule", { value: true })), Nx;
}
var wx = {}, eLe;
function eN0() {
  return eLe || (eLe = 1, Object.defineProperty(wx, "__esModule", { value: true })), wx;
}
var Bx = {}, tLe;
function tN0() {
  return tLe || (tLe = 1, Object.defineProperty(Bx, "__esModule", { value: true })), Bx;
}
var xx = {}, rLe;
function rN0() {
  return rLe || (rLe = 1, Object.defineProperty(xx, "__esModule", { value: true })), xx;
}
var Ux = {}, nLe;
function nN0() {
  return nLe || (nLe = 1, Object.defineProperty(Ux, "__esModule", { value: true })), Ux;
}
var kx = {}, aLe;
function aN0() {
  return aLe || (aLe = 1, Object.defineProperty(kx, "__esModule", { value: true })), kx;
}
var jx = {}, oLe;
function oN0() {
  return oLe || (oLe = 1, Object.defineProperty(jx, "__esModule", { value: true })), jx;
}
var Fx = {}, iLe;
function iN0() {
  return iLe || (iLe = 1, Object.defineProperty(Fx, "__esModule", { value: true })), Fx;
}
var Vx = {}, uLe;
function uN0() {
  return uLe || (uLe = 1, Object.defineProperty(Vx, "__esModule", { value: true })), Vx;
}
var Hx = {}, sLe;
function sN0() {
  return sLe || (sLe = 1, Object.defineProperty(Hx, "__esModule", { value: true })), Hx;
}
var Xx = {}, cLe;
function cN0() {
  return cLe || (cLe = 1, Object.defineProperty(Xx, "__esModule", { value: true })), Xx;
}
var $x = {}, lLe;
function lN0() {
  return lLe || (lLe = 1, Object.defineProperty($x, "__esModule", { value: true })), $x;
}
var Gx = {}, pLe;
function pN0() {
  return pLe || (pLe = 1, Object.defineProperty(Gx, "__esModule", { value: true })), Gx;
}
var Yx = {}, dLe;
function dN0() {
  return dLe || (dLe = 1, Object.defineProperty(Yx, "__esModule", { value: true })), Yx;
}
var Jx = {}, fLe;
function fN0() {
  return fLe || (fLe = 1, Object.defineProperty(Jx, "__esModule", { value: true })), Jx;
}
var Kx = {}, bLe;
function bN0() {
  return bLe || (bLe = 1, Object.defineProperty(Kx, "__esModule", { value: true })), Kx;
}
var Qx = {}, MLe;
function MN0() {
  return MLe || (MLe = 1, Object.defineProperty(Qx, "__esModule", { value: true })), Qx;
}
var Zx = {}, OLe;
function ON0() {
  return OLe || (OLe = 1, Object.defineProperty(Zx, "__esModule", { value: true })), Zx;
}
var eU = {}, zLe;
function zN0() {
  return zLe || (zLe = 1, Object.defineProperty(eU, "__esModule", { value: true })), eU;
}
var tU = {}, ALe;
function AN0() {
  return ALe || (ALe = 1, Object.defineProperty(tU, "__esModule", { value: true })), tU;
}
var rU = {}, _Le;
function _N0() {
  return _Le || (_Le = 1, Object.defineProperty(rU, "__esModule", { value: true })), rU;
}
var nU = {}, hLe;
function hN0() {
  return hLe || (hLe = 1, Object.defineProperty(nU, "__esModule", { value: true })), nU;
}
var aU = {}, vLe;
function vN0() {
  return vLe || (vLe = 1, Object.defineProperty(aU, "__esModule", { value: true })), aU;
}
var oU = {}, mLe;
function mN0() {
  return mLe || (mLe = 1, Object.defineProperty(oU, "__esModule", { value: true })), oU;
}
var iU = {}, RLe;
function RN0() {
  return RLe || (RLe = 1, Object.defineProperty(iU, "__esModule", { value: true })), iU;
}
var uU = {}, qLe;
function qN0() {
  return qLe || (qLe = 1, Object.defineProperty(uU, "__esModule", { value: true })), uU;
}
var sU = {}, TLe;
function TN0() {
  return TLe || (TLe = 1, Object.defineProperty(sU, "__esModule", { value: true })), sU;
}
var cU = {}, yLe;
function yN0() {
  return yLe || (yLe = 1, Object.defineProperty(cU, "__esModule", { value: true })), cU;
}
var lU = {}, SLe;
function SN0() {
  return SLe || (SLe = 1, Object.defineProperty(lU, "__esModule", { value: true })), lU;
}
var pU = {}, CLe;
function CN0() {
  return CLe || (CLe = 1, Object.defineProperty(pU, "__esModule", { value: true })), pU;
}
var dU = {}, gLe;
function gN0() {
  return gLe || (gLe = 1, Object.defineProperty(dU, "__esModule", { value: true })), dU;
}
var fU = {}, ILe;
function IN0() {
  return ILe || (ILe = 1, Object.defineProperty(fU, "__esModule", { value: true })), fU;
}
var bU = {}, ELe;
function EN0() {
  return ELe || (ELe = 1, Object.defineProperty(bU, "__esModule", { value: true })), bU;
}
var MU = {}, LLe;
function LN0() {
  return LLe || (LLe = 1, Object.defineProperty(MU, "__esModule", { value: true })), MU;
}
var OU = {}, PLe;
function PN0() {
  return PLe || (PLe = 1, Object.defineProperty(OU, "__esModule", { value: true })), OU;
}
var zU = {}, DLe;
function DN0() {
  return DLe || (DLe = 1, Object.defineProperty(zU, "__esModule", { value: true })), zU;
}
var AU = {}, WLe;
function WN0() {
  return WLe || (WLe = 1, Object.defineProperty(AU, "__esModule", { value: true })), AU;
}
var _U = {}, NLe;
function NN0() {
  return NLe || (NLe = 1, Object.defineProperty(_U, "__esModule", { value: true })), _U;
}
var hU = {}, wLe;
function wN0() {
  return wLe || (wLe = 1, Object.defineProperty(hU, "__esModule", { value: true })), hU;
}
var vU = {}, BLe;
function BN0() {
  return BLe || (BLe = 1, Object.defineProperty(vU, "__esModule", { value: true })), vU;
}
var mU = {}, xLe;
function xN0() {
  return xLe || (xLe = 1, Object.defineProperty(mU, "__esModule", { value: true })), mU;
}
var RU = {}, ULe;
function UN0() {
  return ULe || (ULe = 1, Object.defineProperty(RU, "__esModule", { value: true })), RU;
}
var qU = {}, kLe;
function kN0() {
  return kLe || (kLe = 1, Object.defineProperty(qU, "__esModule", { value: true })), qU;
}
var TU = {}, jLe;
function jN0() {
  return jLe || (jLe = 1, Object.defineProperty(TU, "__esModule", { value: true })), TU;
}
var yU = {}, FLe;
function FN0() {
  return FLe || (FLe = 1, Object.defineProperty(yU, "__esModule", { value: true })), yU;
}
var SU = {}, VLe;
function VN0() {
  return VLe || (VLe = 1, Object.defineProperty(SU, "__esModule", { value: true })), SU;
}
var CU = {}, HLe;
function HN0() {
  return HLe || (HLe = 1, Object.defineProperty(CU, "__esModule", { value: true })), CU;
}
var gU = {}, XLe;
function XN0() {
  return XLe || (XLe = 1, Object.defineProperty(gU, "__esModule", { value: true })), gU;
}
var IU = {}, $Le;
function $N0() {
  return $Le || ($Le = 1, Object.defineProperty(IU, "__esModule", { value: true })), IU;
}
var EU = {}, GLe;
function GN0() {
  return GLe || (GLe = 1, Object.defineProperty(EU, "__esModule", { value: true })), EU;
}
var LU = {}, YLe;
function YN0() {
  return YLe || (YLe = 1, Object.defineProperty(LU, "__esModule", { value: true })), LU;
}
var PU = {}, JLe;
function JN0() {
  return JLe || (JLe = 1, Object.defineProperty(PU, "__esModule", { value: true })), PU;
}
var DU = {}, KLe;
function KN0() {
  return KLe || (KLe = 1, Object.defineProperty(DU, "__esModule", { value: true })), DU;
}
var WU = {}, QLe;
function QN0() {
  return QLe || (QLe = 1, Object.defineProperty(WU, "__esModule", { value: true })), WU;
}
var NU = {}, ZLe;
function ZN0() {
  return ZLe || (ZLe = 1, Object.defineProperty(NU, "__esModule", { value: true })), NU;
}
var wU = {}, ePe;
function e80() {
  return ePe || (ePe = 1, Object.defineProperty(wU, "__esModule", { value: true })), wU;
}
var BU = {}, tPe;
function t80() {
  return tPe || (tPe = 1, Object.defineProperty(BU, "__esModule", { value: true })), BU;
}
var xU = {}, rPe;
function r80() {
  return rPe || (rPe = 1, Object.defineProperty(xU, "__esModule", { value: true })), xU;
}
var UU = {}, nPe;
function n80() {
  return nPe || (nPe = 1, Object.defineProperty(UU, "__esModule", { value: true })), UU;
}
var kU = {}, aPe;
function a80() {
  return aPe || (aPe = 1, Object.defineProperty(kU, "__esModule", { value: true })), kU;
}
var jU = {}, oPe;
function o80() {
  return oPe || (oPe = 1, Object.defineProperty(jU, "__esModule", { value: true })), jU;
}
var FU = {}, iPe;
function i80() {
  return iPe || (iPe = 1, Object.defineProperty(FU, "__esModule", { value: true })), FU;
}
var VU = {}, uPe;
function u80() {
  return uPe || (uPe = 1, Object.defineProperty(VU, "__esModule", { value: true })), VU;
}
var HU = {}, sPe;
function s80() {
  return sPe || (sPe = 1, Object.defineProperty(HU, "__esModule", { value: true })), HU;
}
var XU = {}, cPe;
function c80() {
  return cPe || (cPe = 1, Object.defineProperty(XU, "__esModule", { value: true })), XU;
}
var $U = {}, lPe;
function l80() {
  return lPe || (lPe = 1, Object.defineProperty($U, "__esModule", { value: true })), $U;
}
var GU = {}, pPe;
function p80() {
  return pPe || (pPe = 1, Object.defineProperty(GU, "__esModule", { value: true })), GU;
}
var YU = {}, dPe;
function d80() {
  return dPe || (dPe = 1, Object.defineProperty(YU, "__esModule", { value: true })), YU;
}
var JU = {}, fPe;
function f80() {
  return fPe || (fPe = 1, Object.defineProperty(JU, "__esModule", { value: true })), JU;
}
var KU = {}, bPe;
function b80() {
  return bPe || (bPe = 1, Object.defineProperty(KU, "__esModule", { value: true })), KU;
}
var QU = {}, MPe;
function M80() {
  return MPe || (MPe = 1, Object.defineProperty(QU, "__esModule", { value: true })), QU;
}
var ZU = {}, OPe;
function O80() {
  return OPe || (OPe = 1, Object.defineProperty(ZU, "__esModule", { value: true })), ZU;
}
var ek = {}, zPe;
function z80() {
  return zPe || (zPe = 1, Object.defineProperty(ek, "__esModule", { value: true })), ek;
}
var tk = {}, APe;
function A80() {
  return APe || (APe = 1, Object.defineProperty(tk, "__esModule", { value: true })), tk;
}
var rk = {}, _Pe;
function _80() {
  return _Pe || (_Pe = 1, Object.defineProperty(rk, "__esModule", { value: true })), rk;
}
var nk = {}, hPe;
function h80() {
  return hPe || (hPe = 1, Object.defineProperty(nk, "__esModule", { value: true })), nk;
}
var ak = {}, vPe;
function v80() {
  return vPe || (vPe = 1, Object.defineProperty(ak, "__esModule", { value: true })), ak;
}
var ok = {}, mPe;
function m80() {
  return mPe || (mPe = 1, Object.defineProperty(ok, "__esModule", { value: true })), ok;
}
var ik = {}, RPe;
function R80() {
  return RPe || (RPe = 1, Object.defineProperty(ik, "__esModule", { value: true })), ik;
}
var uk = {}, qPe;
function q80() {
  return qPe || (qPe = 1, Object.defineProperty(uk, "__esModule", { value: true })), uk;
}
var sk = {}, TPe;
function T80() {
  return TPe || (TPe = 1, Object.defineProperty(sk, "__esModule", { value: true })), sk;
}
var ck = {}, yPe;
function y80() {
  return yPe || (yPe = 1, Object.defineProperty(ck, "__esModule", { value: true })), ck;
}
var lk = {}, SPe;
function S80() {
  return SPe || (SPe = 1, Object.defineProperty(lk, "__esModule", { value: true })), lk;
}
var pk = {}, CPe;
function C80() {
  return CPe || (CPe = 1, Object.defineProperty(pk, "__esModule", { value: true })), pk;
}
var dk = {}, gPe;
function g80() {
  return gPe || (gPe = 1, Object.defineProperty(dk, "__esModule", { value: true })), dk;
}
var fk = {}, IPe;
function I80() {
  return IPe || (IPe = 1, Object.defineProperty(fk, "__esModule", { value: true })), fk;
}
var bk = {}, EPe;
function E80() {
  return EPe || (EPe = 1, Object.defineProperty(bk, "__esModule", { value: true })), bk;
}
var Mk = {}, LPe;
function L80() {
  return LPe || (LPe = 1, Object.defineProperty(Mk, "__esModule", { value: true })), Mk;
}
var Ok = {}, PPe;
function P80() {
  return PPe || (PPe = 1, Object.defineProperty(Ok, "__esModule", { value: true })), Ok;
}
var zk = {}, DPe;
function D80() {
  return DPe || (DPe = 1, Object.defineProperty(zk, "__esModule", { value: true })), zk;
}
var Ak = {}, WPe;
function W80() {
  return WPe || (WPe = 1, Object.defineProperty(Ak, "__esModule", { value: true })), Ak;
}
var _k = {}, NPe;
function N80() {
  return NPe || (NPe = 1, Object.defineProperty(_k, "__esModule", { value: true })), _k;
}
var hk = {}, wPe;
function w80() {
  return wPe || (wPe = 1, Object.defineProperty(hk, "__esModule", { value: true })), hk;
}
var vk = {}, BPe;
function B80() {
  return BPe || (BPe = 1, Object.defineProperty(vk, "__esModule", { value: true })), vk;
}
var mk = {}, xPe;
function x80() {
  return xPe || (xPe = 1, Object.defineProperty(mk, "__esModule", { value: true })), mk;
}
var Rk = {}, UPe;
function U80() {
  return UPe || (UPe = 1, Object.defineProperty(Rk, "__esModule", { value: true })), Rk;
}
var qk = {}, kPe;
function k80() {
  return kPe || (kPe = 1, Object.defineProperty(qk, "__esModule", { value: true })), qk;
}
var Tk = {}, jPe;
function j80() {
  return jPe || (jPe = 1, Object.defineProperty(Tk, "__esModule", { value: true })), Tk;
}
var yk = {}, FPe;
function F80() {
  return FPe || (FPe = 1, Object.defineProperty(yk, "__esModule", { value: true })), yk;
}
var Sk = {}, VPe;
function V80() {
  return VPe || (VPe = 1, Object.defineProperty(Sk, "__esModule", { value: true })), Sk;
}
var Ck = {}, HPe;
function H80() {
  return HPe || (HPe = 1, Object.defineProperty(Ck, "__esModule", { value: true })), Ck;
}
var gk = {}, XPe;
function X80() {
  return XPe || (XPe = 1, Object.defineProperty(gk, "__esModule", { value: true })), gk;
}
var Ik = {}, $Pe;
function $80() {
  return $Pe || ($Pe = 1, Object.defineProperty(Ik, "__esModule", { value: true })), Ik;
}
var Ek = {}, GPe;
function G80() {
  return GPe || (GPe = 1, Object.defineProperty(Ek, "__esModule", { value: true })), Ek;
}
var Lk = {}, YPe;
function Y80() {
  return YPe || (YPe = 1, Object.defineProperty(Lk, "__esModule", { value: true })), Lk;
}
var Pk = {}, JPe;
function J80() {
  return JPe || (JPe = 1, Object.defineProperty(Pk, "__esModule", { value: true })), Pk;
}
var Dk = {}, KPe;
function K80() {
  return KPe || (KPe = 1, Object.defineProperty(Dk, "__esModule", { value: true })), Dk;
}
var Wk = {}, QPe;
function Q80() {
  return QPe || (QPe = 1, Object.defineProperty(Wk, "__esModule", { value: true })), Wk;
}
var Nk = {}, ZPe;
function Z80() {
  return ZPe || (ZPe = 1, Object.defineProperty(Nk, "__esModule", { value: true })), Nk;
}
var wk = {}, eDe;
function e70() {
  return eDe || (eDe = 1, Object.defineProperty(wk, "__esModule", { value: true })), wk;
}
var Bk = {}, tDe;
function t70() {
  return tDe || (tDe = 1, Object.defineProperty(Bk, "__esModule", { value: true })), Bk;
}
var xk = {}, rDe;
function r70() {
  return rDe || (rDe = 1, Object.defineProperty(xk, "__esModule", { value: true })), xk;
}
var Uk = {}, nDe;
function n70() {
  return nDe || (nDe = 1, Object.defineProperty(Uk, "__esModule", { value: true })), Uk;
}
var kk = {}, aDe;
function a70() {
  return aDe || (aDe = 1, Object.defineProperty(kk, "__esModule", { value: true })), kk;
}
var jk = {}, oDe;
function o70() {
  return oDe || (oDe = 1, Object.defineProperty(jk, "__esModule", { value: true })), jk;
}
var Fk = {}, iDe;
function i70() {
  return iDe || (iDe = 1, Object.defineProperty(Fk, "__esModule", { value: true })), Fk;
}
var Vk = {}, uDe;
function u70() {
  return uDe || (uDe = 1, Object.defineProperty(Vk, "__esModule", { value: true })), Vk;
}
var Hk = {}, sDe;
function s70() {
  return sDe || (sDe = 1, Object.defineProperty(Hk, "__esModule", { value: true })), Hk;
}
var Xk = {}, cDe;
function c70() {
  return cDe || (cDe = 1, Object.defineProperty(Xk, "__esModule", { value: true })), Xk;
}
var $k = {}, lDe;
function l70() {
  return lDe || (lDe = 1, Object.defineProperty($k, "__esModule", { value: true })), $k;
}
var Gk = {}, pDe;
function p70() {
  return pDe || (pDe = 1, Object.defineProperty(Gk, "__esModule", { value: true })), Gk;
}
var Yk = {}, dDe;
function d70() {
  return dDe || (dDe = 1, Object.defineProperty(Yk, "__esModule", { value: true })), Yk;
}
var Jk = {}, fDe;
function f70() {
  return fDe || (fDe = 1, Object.defineProperty(Jk, "__esModule", { value: true })), Jk;
}
var Kk = {}, bDe;
function b70() {
  return bDe || (bDe = 1, Object.defineProperty(Kk, "__esModule", { value: true })), Kk;
}
var Qk = {}, MDe;
function M70() {
  return MDe || (MDe = 1, Object.defineProperty(Qk, "__esModule", { value: true })), Qk;
}
var Zk = {}, ODe;
function O70() {
  return ODe || (ODe = 1, Object.defineProperty(Zk, "__esModule", { value: true })), Zk;
}
var ej = {}, zDe;
function z70() {
  return zDe || (zDe = 1, Object.defineProperty(ej, "__esModule", { value: true })), ej;
}
var tj = {}, ADe;
function A70() {
  return ADe || (ADe = 1, Object.defineProperty(tj, "__esModule", { value: true })), tj;
}
var rj = {}, _De;
function _70() {
  return _De || (_De = 1, Object.defineProperty(rj, "__esModule", { value: true })), rj;
}
var nj = {}, hDe;
function h70() {
  return hDe || (hDe = 1, Object.defineProperty(nj, "__esModule", { value: true })), nj;
}
var aj = {}, vDe;
function v70() {
  return vDe || (vDe = 1, Object.defineProperty(aj, "__esModule", { value: true })), aj;
}
var oj = {}, mDe;
function m70() {
  return mDe || (mDe = 1, Object.defineProperty(oj, "__esModule", { value: true })), oj;
}
var ij = {}, RDe;
function R70() {
  return RDe || (RDe = 1, Object.defineProperty(ij, "__esModule", { value: true })), ij;
}
var uj = {}, qDe;
function q70() {
  return qDe || (qDe = 1, Object.defineProperty(uj, "__esModule", { value: true })), uj;
}
var sj = {}, TDe;
function T70() {
  return TDe || (TDe = 1, Object.defineProperty(sj, "__esModule", { value: true })), sj;
}
var cj = {}, yDe;
function y70() {
  return yDe || (yDe = 1, Object.defineProperty(cj, "__esModule", { value: true })), cj;
}
var lj = {}, SDe;
function S70() {
  return SDe || (SDe = 1, Object.defineProperty(lj, "__esModule", { value: true })), lj;
}
var pj = {}, CDe;
function C70() {
  return CDe || (CDe = 1, Object.defineProperty(pj, "__esModule", { value: true })), pj;
}
var dj = {}, gDe;
function g70() {
  return gDe || (gDe = 1, Object.defineProperty(dj, "__esModule", { value: true })), dj;
}
var fj = {}, IDe;
function I70() {
  return IDe || (IDe = 1, Object.defineProperty(fj, "__esModule", { value: true })), fj;
}
var bj = {}, EDe;
function E70() {
  return EDe || (EDe = 1, Object.defineProperty(bj, "__esModule", { value: true })), bj;
}
var Mj = {}, LDe;
function L70() {
  return LDe || (LDe = 1, Object.defineProperty(Mj, "__esModule", { value: true })), Mj;
}
var Oj = {}, PDe;
function P70() {
  return PDe || (PDe = 1, Object.defineProperty(Oj, "__esModule", { value: true })), Oj;
}
var zj = {}, DDe;
function D70() {
  return DDe || (DDe = 1, Object.defineProperty(zj, "__esModule", { value: true })), zj;
}
var Aj = {}, WDe;
function W70() {
  return WDe || (WDe = 1, Object.defineProperty(Aj, "__esModule", { value: true })), Aj;
}
var _j = {}, NDe;
function N70() {
  return NDe || (NDe = 1, Object.defineProperty(_j, "__esModule", { value: true })), _j;
}
var hj = {}, wDe;
function w70() {
  return wDe || (wDe = 1, Object.defineProperty(hj, "__esModule", { value: true })), hj;
}
var vj = {}, BDe;
function B70() {
  return BDe || (BDe = 1, Object.defineProperty(vj, "__esModule", { value: true })), vj;
}
var mj = {}, xDe;
function x70() {
  return xDe || (xDe = 1, Object.defineProperty(mj, "__esModule", { value: true })), mj;
}
var Rj = {}, UDe;
function U70() {
  return UDe || (UDe = 1, Object.defineProperty(Rj, "__esModule", { value: true })), Rj;
}
var qj = {}, kDe;
function k70() {
  return kDe || (kDe = 1, Object.defineProperty(qj, "__esModule", { value: true })), qj;
}
var Tj = {}, jDe;
function j70() {
  return jDe || (jDe = 1, Object.defineProperty(Tj, "__esModule", { value: true })), Tj;
}
var yj = {}, FDe;
function F70() {
  return FDe || (FDe = 1, Object.defineProperty(yj, "__esModule", { value: true })), yj;
}
var Sj = {}, VDe;
function V70() {
  return VDe || (VDe = 1, Object.defineProperty(Sj, "__esModule", { value: true })), Sj;
}
var Cj = {}, HDe;
function H70() {
  return HDe || (HDe = 1, Object.defineProperty(Cj, "__esModule", { value: true })), Cj;
}
var gj = {}, XDe;
function X70() {
  return XDe || (XDe = 1, Object.defineProperty(gj, "__esModule", { value: true })), gj;
}
var Ij = {}, $De;
function $70() {
  return $De || ($De = 1, Object.defineProperty(Ij, "__esModule", { value: true })), Ij;
}
var Ej = {}, GDe;
function G70() {
  return GDe || (GDe = 1, Object.defineProperty(Ej, "__esModule", { value: true })), Ej;
}
var Lj = {}, YDe;
function Y70() {
  return YDe || (YDe = 1, Object.defineProperty(Lj, "__esModule", { value: true })), Lj;
}
var Pj = {}, JDe;
function J70() {
  return JDe || (JDe = 1, Object.defineProperty(Pj, "__esModule", { value: true })), Pj;
}
var Dj = {}, KDe;
function K70() {
  return KDe || (KDe = 1, Object.defineProperty(Dj, "__esModule", { value: true })), Dj;
}
var Wj = {}, QDe;
function Q70() {
  return QDe || (QDe = 1, Object.defineProperty(Wj, "__esModule", { value: true })), Wj;
}
var Nj = {}, ZDe;
function Z70() {
  return ZDe || (ZDe = 1, Object.defineProperty(Nj, "__esModule", { value: true })), Nj;
}
var wj = {}, eWe;
function ew0() {
  return eWe || (eWe = 1, Object.defineProperty(wj, "__esModule", { value: true })), wj;
}
var Bj = {}, tWe;
function tw0() {
  return tWe || (tWe = 1, Object.defineProperty(Bj, "__esModule", { value: true })), Bj;
}
var xj = {}, rWe;
function rw0() {
  return rWe || (rWe = 1, Object.defineProperty(xj, "__esModule", { value: true })), xj;
}
var Uj = {}, nWe;
function nw0() {
  return nWe || (nWe = 1, Object.defineProperty(Uj, "__esModule", { value: true })), Uj;
}
var kj = {}, aWe;
function aw0() {
  return aWe || (aWe = 1, Object.defineProperty(kj, "__esModule", { value: true })), kj;
}
var jj = {}, oWe;
function ow0() {
  return oWe || (oWe = 1, Object.defineProperty(jj, "__esModule", { value: true })), jj;
}
var Fj = {}, iWe;
function iw0() {
  return iWe || (iWe = 1, Object.defineProperty(Fj, "__esModule", { value: true })), Fj;
}
var Vj = {}, uWe;
function uw0() {
  return uWe || (uWe = 1, Object.defineProperty(Vj, "__esModule", { value: true })), Vj;
}
var Hj = {}, sWe;
function sw0() {
  return sWe || (sWe = 1, Object.defineProperty(Hj, "__esModule", { value: true })), Hj;
}
var Xj = {}, cWe;
function cw0() {
  return cWe || (cWe = 1, Object.defineProperty(Xj, "__esModule", { value: true })), Xj;
}
var $j = {}, lWe;
function lw0() {
  return lWe || (lWe = 1, Object.defineProperty($j, "__esModule", { value: true })), $j;
}
var Gj = {}, pWe;
function pw0() {
  return pWe || (pWe = 1, Object.defineProperty(Gj, "__esModule", { value: true })), Gj;
}
var Yj = {}, dWe;
function dw0() {
  return dWe || (dWe = 1, Object.defineProperty(Yj, "__esModule", { value: true })), Yj;
}
var Jj = {}, fWe;
function fw0() {
  return fWe || (fWe = 1, Object.defineProperty(Jj, "__esModule", { value: true })), Jj;
}
var Kj = {}, bWe;
function bw0() {
  return bWe || (bWe = 1, Object.defineProperty(Kj, "__esModule", { value: true })), Kj;
}
var Qj = {}, MWe;
function Mw0() {
  return MWe || (MWe = 1, Object.defineProperty(Qj, "__esModule", { value: true })), Qj;
}
var Zj = {}, OWe;
function Ow0() {
  return OWe || (OWe = 1, Object.defineProperty(Zj, "__esModule", { value: true })), Zj;
}
var eF = {}, zWe;
function zw0() {
  return zWe || (zWe = 1, Object.defineProperty(eF, "__esModule", { value: true })), eF;
}
var tF = {}, AWe;
function Aw0() {
  return AWe || (AWe = 1, Object.defineProperty(tF, "__esModule", { value: true })), tF;
}
var rF = {}, _We;
function _w0() {
  return _We || (_We = 1, Object.defineProperty(rF, "__esModule", { value: true })), rF;
}
var nF = {}, hWe;
function hw0() {
  return hWe || (hWe = 1, Object.defineProperty(nF, "__esModule", { value: true })), nF;
}
var aF = {}, vWe;
function vw0() {
  return vWe || (vWe = 1, Object.defineProperty(aF, "__esModule", { value: true })), aF;
}
var oF = {}, mWe;
function mw0() {
  return mWe || (mWe = 1, Object.defineProperty(oF, "__esModule", { value: true })), oF;
}
var iF = {}, RWe;
function Rw0() {
  return RWe || (RWe = 1, Object.defineProperty(iF, "__esModule", { value: true })), iF;
}
var uF = {}, qWe;
function qw0() {
  return qWe || (qWe = 1, Object.defineProperty(uF, "__esModule", { value: true })), uF;
}
var sF = {}, TWe;
function Tw0() {
  return TWe || (TWe = 1, Object.defineProperty(sF, "__esModule", { value: true })), sF;
}
var cF = {}, yWe;
function yw0() {
  return yWe || (yWe = 1, Object.defineProperty(cF, "__esModule", { value: true })), cF;
}
var lF = {}, SWe;
function Sw0() {
  return SWe || (SWe = 1, Object.defineProperty(lF, "__esModule", { value: true })), lF;
}
var pF = {}, CWe;
function Cw0() {
  return CWe || (CWe = 1, Object.defineProperty(pF, "__esModule", { value: true })), pF;
}
var dF = {}, gWe;
function gw0() {
  return gWe || (gWe = 1, Object.defineProperty(dF, "__esModule", { value: true })), dF;
}
var fF = {}, IWe;
function Iw0() {
  return IWe || (IWe = 1, Object.defineProperty(fF, "__esModule", { value: true })), fF;
}
var bF = {}, EWe;
function Ew0() {
  return EWe || (EWe = 1, Object.defineProperty(bF, "__esModule", { value: true })), bF;
}
var MF = {}, LWe;
function Lw0() {
  return LWe || (LWe = 1, Object.defineProperty(MF, "__esModule", { value: true })), MF;
}
var OF = {}, PWe;
function Pw0() {
  return PWe || (PWe = 1, Object.defineProperty(OF, "__esModule", { value: true })), OF;
}
var zF = {}, DWe;
function Dw0() {
  return DWe || (DWe = 1, Object.defineProperty(zF, "__esModule", { value: true })), zF;
}
var AF = {}, WWe;
function Ww0() {
  return WWe || (WWe = 1, Object.defineProperty(AF, "__esModule", { value: true })), AF;
}
var _F = {}, NWe;
function Nw0() {
  return NWe || (NWe = 1, Object.defineProperty(_F, "__esModule", { value: true })), _F;
}
var hF = {}, wWe;
function ww0() {
  return wWe || (wWe = 1, Object.defineProperty(hF, "__esModule", { value: true })), hF;
}
var vF = {}, BWe;
function Bw0() {
  return BWe || (BWe = 1, Object.defineProperty(vF, "__esModule", { value: true })), vF;
}
var mF = {}, xWe;
function xw0() {
  return xWe || (xWe = 1, Object.defineProperty(mF, "__esModule", { value: true })), mF;
}
var RF = {}, UWe;
function Uw0() {
  return UWe || (UWe = 1, Object.defineProperty(RF, "__esModule", { value: true })), RF;
}
var qF = {}, kWe;
function kw0() {
  return kWe || (kWe = 1, Object.defineProperty(qF, "__esModule", { value: true })), qF;
}
var TF = {}, jWe;
function jw0() {
  return jWe || (jWe = 1, Object.defineProperty(TF, "__esModule", { value: true })), TF;
}
var yF = {}, FWe;
function Fw0() {
  return FWe || (FWe = 1, Object.defineProperty(yF, "__esModule", { value: true })), yF;
}
var SF = {}, VWe;
function Vw0() {
  return VWe || (VWe = 1, Object.defineProperty(SF, "__esModule", { value: true })), SF;
}
var CF = {}, HWe;
function Hw0() {
  return HWe || (HWe = 1, Object.defineProperty(CF, "__esModule", { value: true })), CF;
}
var gF = {}, XWe;
function Xw0() {
  return XWe || (XWe = 1, Object.defineProperty(gF, "__esModule", { value: true })), gF;
}
var IF = {}, $We;
function $w0() {
  return $We || ($We = 1, Object.defineProperty(IF, "__esModule", { value: true })), IF;
}
var EF = {}, GWe;
function Gw0() {
  return GWe || (GWe = 1, Object.defineProperty(EF, "__esModule", { value: true })), EF;
}
var LF = {}, YWe;
function Yw0() {
  return YWe || (YWe = 1, Object.defineProperty(LF, "__esModule", { value: true })), LF;
}
var PF = {}, JWe;
function Jw0() {
  return JWe || (JWe = 1, Object.defineProperty(PF, "__esModule", { value: true })), PF;
}
var DF = {}, KWe;
function Kw0() {
  return KWe || (KWe = 1, Object.defineProperty(DF, "__esModule", { value: true })), DF;
}
var WF = {}, QWe;
function Qw0() {
  return QWe || (QWe = 1, Object.defineProperty(WF, "__esModule", { value: true })), WF;
}
var NF = {}, ZWe;
function Zw0() {
  return ZWe || (ZWe = 1, Object.defineProperty(NF, "__esModule", { value: true })), NF;
}
var wF = {}, eNe;
function eB0() {
  return eNe || (eNe = 1, Object.defineProperty(wF, "__esModule", { value: true })), wF;
}
var BF = {}, tNe;
function tB0() {
  return tNe || (tNe = 1, Object.defineProperty(BF, "__esModule", { value: true })), BF;
}
var xF = {}, rNe;
function rB0() {
  return rNe || (rNe = 1, Object.defineProperty(xF, "__esModule", { value: true })), xF;
}
var UF = {}, nNe;
function nB0() {
  return nNe || (nNe = 1, Object.defineProperty(UF, "__esModule", { value: true })), UF;
}
var kF = {}, aNe;
function aB0() {
  return aNe || (aNe = 1, Object.defineProperty(kF, "__esModule", { value: true })), kF;
}
var jF = {}, oNe;
function oB0() {
  return oNe || (oNe = 1, Object.defineProperty(jF, "__esModule", { value: true })), jF;
}
var FF = {}, iNe;
function iB0() {
  return iNe || (iNe = 1, Object.defineProperty(FF, "__esModule", { value: true })), FF;
}
var VF = {}, uNe;
function uB0() {
  return uNe || (uNe = 1, Object.defineProperty(VF, "__esModule", { value: true })), VF;
}
var HF = {}, sNe;
function sB0() {
  return sNe || (sNe = 1, Object.defineProperty(HF, "__esModule", { value: true })), HF;
}
var XF = {}, cNe;
function cB0() {
  return cNe || (cNe = 1, Object.defineProperty(XF, "__esModule", { value: true })), XF;
}
var $F = {}, lNe;
function lB0() {
  return lNe || (lNe = 1, Object.defineProperty($F, "__esModule", { value: true })), $F;
}
var GF = {}, pNe;
function pB0() {
  return pNe || (pNe = 1, Object.defineProperty(GF, "__esModule", { value: true })), GF;
}
var YF = {}, dNe;
function dB0() {
  return dNe || (dNe = 1, Object.defineProperty(YF, "__esModule", { value: true })), YF;
}
var JF = {}, fNe;
function fB0() {
  return fNe || (fNe = 1, Object.defineProperty(JF, "__esModule", { value: true })), JF;
}
var KF = {}, bNe;
function bB0() {
  return bNe || (bNe = 1, Object.defineProperty(KF, "__esModule", { value: true })), KF;
}
var QF = {}, MNe;
function MB0() {
  return MNe || (MNe = 1, Object.defineProperty(QF, "__esModule", { value: true })), QF;
}
var ZF = {}, ONe;
function OB0() {
  return ONe || (ONe = 1, Object.defineProperty(ZF, "__esModule", { value: true })), ZF;
}
var eV = {}, zNe;
function zB0() {
  return zNe || (zNe = 1, Object.defineProperty(eV, "__esModule", { value: true })), eV;
}
var tV = {}, ANe;
function AB0() {
  return ANe || (ANe = 1, Object.defineProperty(tV, "__esModule", { value: true })), tV;
}
var rV = {}, _Ne;
function _B0() {
  return _Ne || (_Ne = 1, Object.defineProperty(rV, "__esModule", { value: true })), rV;
}
var nV = {}, hNe;
function hB0() {
  return hNe || (hNe = 1, Object.defineProperty(nV, "__esModule", { value: true })), nV;
}
var aV = {}, vNe;
function vB0() {
  return vNe || (vNe = 1, Object.defineProperty(aV, "__esModule", { value: true })), aV;
}
var oV = {}, mNe;
function mB0() {
  return mNe || (mNe = 1, Object.defineProperty(oV, "__esModule", { value: true })), oV;
}
var iV = {}, RNe;
function RB0() {
  return RNe || (RNe = 1, Object.defineProperty(iV, "__esModule", { value: true })), iV;
}
var uV = {}, qNe;
function qB0() {
  return qNe || (qNe = 1, Object.defineProperty(uV, "__esModule", { value: true })), uV;
}
var sV = {}, TNe;
function TB0() {
  return TNe || (TNe = 1, Object.defineProperty(sV, "__esModule", { value: true })), sV;
}
var cV = {}, yNe;
function yB0() {
  return yNe || (yNe = 1, Object.defineProperty(cV, "__esModule", { value: true })), cV;
}
var lV = {}, SNe;
function SB0() {
  return SNe || (SNe = 1, Object.defineProperty(lV, "__esModule", { value: true })), lV;
}
var pV = {}, CNe;
function CB0() {
  return CNe || (CNe = 1, Object.defineProperty(pV, "__esModule", { value: true })), pV;
}
var dV = {}, gNe;
function gB0() {
  return gNe || (gNe = 1, Object.defineProperty(dV, "__esModule", { value: true })), dV;
}
var fV = {}, INe;
function IB0() {
  return INe || (INe = 1, Object.defineProperty(fV, "__esModule", { value: true })), fV;
}
var bV = {}, ENe;
function EB0() {
  return ENe || (ENe = 1, Object.defineProperty(bV, "__esModule", { value: true })), bV;
}
var MV = {}, LNe;
function LB0() {
  return LNe || (LNe = 1, Object.defineProperty(MV, "__esModule", { value: true })), MV;
}
var OV = {}, PNe;
function PB0() {
  return PNe || (PNe = 1, Object.defineProperty(OV, "__esModule", { value: true })), OV;
}
var zV = {}, DNe;
function DB0() {
  return DNe || (DNe = 1, Object.defineProperty(zV, "__esModule", { value: true })), zV;
}
var AV = {}, WNe;
function WB0() {
  return WNe || (WNe = 1, Object.defineProperty(AV, "__esModule", { value: true })), AV;
}
var _V = {}, NNe;
function NB0() {
  return NNe || (NNe = 1, Object.defineProperty(_V, "__esModule", { value: true })), _V;
}
var hV = {}, wNe;
function wB0() {
  return wNe || (wNe = 1, Object.defineProperty(hV, "__esModule", { value: true })), hV;
}
var vV = {}, BNe;
function BB0() {
  return BNe || (BNe = 1, Object.defineProperty(vV, "__esModule", { value: true })), vV;
}
var mV = {}, xNe;
function xB0() {
  return xNe || (xNe = 1, Object.defineProperty(mV, "__esModule", { value: true })), mV;
}
var RV = {}, UNe;
function UB0() {
  return UNe || (UNe = 1, Object.defineProperty(RV, "__esModule", { value: true })), RV;
}
var qV = {}, kNe;
function kB0() {
  return kNe || (kNe = 1, Object.defineProperty(qV, "__esModule", { value: true })), qV;
}
var TV = {}, jNe;
function jB0() {
  return jNe || (jNe = 1, Object.defineProperty(TV, "__esModule", { value: true })), TV;
}
var yV = {}, FNe;
function FB0() {
  return FNe || (FNe = 1, Object.defineProperty(yV, "__esModule", { value: true })), yV;
}
var SV = {}, VNe;
function VB0() {
  return VNe || (VNe = 1, Object.defineProperty(SV, "__esModule", { value: true })), SV;
}
var CV = {}, HNe;
function HB0() {
  return HNe || (HNe = 1, Object.defineProperty(CV, "__esModule", { value: true })), CV;
}
var gV = {}, XNe;
function XB0() {
  return XNe || (XNe = 1, Object.defineProperty(gV, "__esModule", { value: true })), gV;
}
var IV = {}, $Ne;
function $B0() {
  return $Ne || ($Ne = 1, Object.defineProperty(IV, "__esModule", { value: true })), IV;
}
var EV = {}, GNe;
function GB0() {
  return GNe || (GNe = 1, Object.defineProperty(EV, "__esModule", { value: true })), EV;
}
var LV = {}, YNe;
function YB0() {
  return YNe || (YNe = 1, Object.defineProperty(LV, "__esModule", { value: true })), LV;
}
var PV = {}, JNe;
function JB0() {
  return JNe || (JNe = 1, Object.defineProperty(PV, "__esModule", { value: true })), PV;
}
var DV = {}, KNe;
function KB0() {
  return KNe || (KNe = 1, Object.defineProperty(DV, "__esModule", { value: true })), DV;
}
var WV = {}, QNe;
function QB0() {
  return QNe || (QNe = 1, Object.defineProperty(WV, "__esModule", { value: true })), WV;
}
var NV = {}, ZNe;
function ZB0() {
  return ZNe || (ZNe = 1, Object.defineProperty(NV, "__esModule", { value: true })), NV;
}
var wV = {}, e8e;
function e90() {
  return e8e || (e8e = 1, Object.defineProperty(wV, "__esModule", { value: true })), wV;
}
var BV = {}, t8e;
function t90() {
  return t8e || (t8e = 1, Object.defineProperty(BV, "__esModule", { value: true })), BV;
}
var xV = {}, r8e;
function r90() {
  return r8e || (r8e = 1, Object.defineProperty(xV, "__esModule", { value: true })), xV;
}
var UV = {}, n8e;
function n90() {
  return n8e || (n8e = 1, Object.defineProperty(UV, "__esModule", { value: true })), UV;
}
var kV = {}, a8e;
function a90() {
  return a8e || (a8e = 1, Object.defineProperty(kV, "__esModule", { value: true })), kV;
}
var jV = {}, o8e;
function o90() {
  return o8e || (o8e = 1, Object.defineProperty(jV, "__esModule", { value: true })), jV;
}
var FV = {}, i8e;
function i90() {
  return i8e || (i8e = 1, Object.defineProperty(FV, "__esModule", { value: true })), FV;
}
var VV = {}, u8e;
function u90() {
  return u8e || (u8e = 1, Object.defineProperty(VV, "__esModule", { value: true })), VV;
}
var HV = {}, s8e;
function s90() {
  return s8e || (s8e = 1, Object.defineProperty(HV, "__esModule", { value: true })), HV;
}
var XV = {}, c8e;
function c90() {
  return c8e || (c8e = 1, Object.defineProperty(XV, "__esModule", { value: true })), XV;
}
var $V = {}, l8e;
function l90() {
  return l8e || (l8e = 1, Object.defineProperty($V, "__esModule", { value: true })), $V;
}
var GV = {}, p8e;
function p90() {
  return p8e || (p8e = 1, Object.defineProperty(GV, "__esModule", { value: true })), GV;
}
var YV = {}, d8e;
function d90() {
  return d8e || (d8e = 1, Object.defineProperty(YV, "__esModule", { value: true })), YV;
}
var JV = {}, f8e;
function f90() {
  return f8e || (f8e = 1, Object.defineProperty(JV, "__esModule", { value: true })), JV;
}
var KV = {}, b8e;
function b90() {
  return b8e || (b8e = 1, Object.defineProperty(KV, "__esModule", { value: true })), KV;
}
var QV = {}, M8e;
function M90() {
  return M8e || (M8e = 1, Object.defineProperty(QV, "__esModule", { value: true })), QV;
}
var ZV = {}, O8e;
function O90() {
  return O8e || (O8e = 1, Object.defineProperty(ZV, "__esModule", { value: true })), ZV;
}
var eH = {}, z8e;
function z90() {
  return z8e || (z8e = 1, Object.defineProperty(eH, "__esModule", { value: true })), eH;
}
var tH = {}, A8e;
function A90() {
  return A8e || (A8e = 1, Object.defineProperty(tH, "__esModule", { value: true })), tH;
}
var rH = {}, _8e;
function _90() {
  return _8e || (_8e = 1, Object.defineProperty(rH, "__esModule", { value: true })), rH;
}
var nH = {}, h8e;
function h90() {
  return h8e || (h8e = 1, Object.defineProperty(nH, "__esModule", { value: true })), nH;
}
var aH = {}, v8e;
function v90() {
  return v8e || (v8e = 1, Object.defineProperty(aH, "__esModule", { value: true })), aH;
}
var oH = {}, m8e;
function m90() {
  return m8e || (m8e = 1, Object.defineProperty(oH, "__esModule", { value: true })), oH;
}
var iH = {}, R8e;
function R90() {
  return R8e || (R8e = 1, Object.defineProperty(iH, "__esModule", { value: true })), iH;
}
var uH = {}, q8e;
function q90() {
  return q8e || (q8e = 1, Object.defineProperty(uH, "__esModule", { value: true })), uH;
}
var sH = {}, T8e;
function T90() {
  return T8e || (T8e = 1, Object.defineProperty(sH, "__esModule", { value: true })), sH;
}
var cH = {}, y8e;
function y90() {
  return y8e || (y8e = 1, Object.defineProperty(cH, "__esModule", { value: true })), cH;
}
var lH = {}, S8e;
function S90() {
  return S8e || (S8e = 1, Object.defineProperty(lH, "__esModule", { value: true })), lH;
}
var pH = {}, C8e;
function C90() {
  return C8e || (C8e = 1, Object.defineProperty(pH, "__esModule", { value: true })), pH;
}
var dH = {}, g8e;
function g90() {
  return g8e || (g8e = 1, Object.defineProperty(dH, "__esModule", { value: true })), dH;
}
var fH = {}, I8e;
function I90() {
  return I8e || (I8e = 1, Object.defineProperty(fH, "__esModule", { value: true })), fH;
}
var bH = {}, E8e;
function E90() {
  return E8e || (E8e = 1, Object.defineProperty(bH, "__esModule", { value: true })), bH;
}
var MH = {}, L8e;
function L90() {
  return L8e || (L8e = 1, Object.defineProperty(MH, "__esModule", { value: true })), MH;
}
var OH = {}, P8e;
function P90() {
  return P8e || (P8e = 1, Object.defineProperty(OH, "__esModule", { value: true })), OH;
}
var zH = {}, D8e;
function D90() {
  return D8e || (D8e = 1, Object.defineProperty(zH, "__esModule", { value: true })), zH;
}
var AH = {}, W8e;
function W90() {
  return W8e || (W8e = 1, Object.defineProperty(AH, "__esModule", { value: true })), AH;
}
var _H = {}, N8e;
function N90() {
  return N8e || (N8e = 1, Object.defineProperty(_H, "__esModule", { value: true })), _H;
}
var hH = {}, w8e;
function w90() {
  return w8e || (w8e = 1, Object.defineProperty(hH, "__esModule", { value: true })), hH;
}
var vH = {}, B8e;
function B90() {
  return B8e || (B8e = 1, Object.defineProperty(vH, "__esModule", { value: true })), vH;
}
var mH = {}, x8e;
function x90() {
  return x8e || (x8e = 1, Object.defineProperty(mH, "__esModule", { value: true })), mH;
}
var RH = {}, U8e;
function U90() {
  return U8e || (U8e = 1, Object.defineProperty(RH, "__esModule", { value: true })), RH;
}
var qH = {}, k8e;
function k90() {
  return k8e || (k8e = 1, Object.defineProperty(qH, "__esModule", { value: true })), qH;
}
var TH = {}, j8e;
function j90() {
  return j8e || (j8e = 1, Object.defineProperty(TH, "__esModule", { value: true })), TH;
}
var yH = {}, F8e;
function F90() {
  return F8e || (F8e = 1, Object.defineProperty(yH, "__esModule", { value: true })), yH;
}
var SH = {}, V8e;
function V90() {
  return V8e || (V8e = 1, Object.defineProperty(SH, "__esModule", { value: true })), SH;
}
var CH = {}, H8e;
function H90() {
  return H8e || (H8e = 1, Object.defineProperty(CH, "__esModule", { value: true })), CH;
}
var gH = {}, X8e;
function X90() {
  return X8e || (X8e = 1, Object.defineProperty(gH, "__esModule", { value: true })), gH;
}
var IH = {}, $8e;
function $90() {
  return $8e || ($8e = 1, Object.defineProperty(IH, "__esModule", { value: true })), IH;
}
var EH = {}, G8e;
function G90() {
  return G8e || (G8e = 1, Object.defineProperty(EH, "__esModule", { value: true })), EH;
}
var LH = {}, Y8e;
function Y90() {
  return Y8e || (Y8e = 1, Object.defineProperty(LH, "__esModule", { value: true })), LH;
}
var PH = {}, J8e;
function J90() {
  return J8e || (J8e = 1, Object.defineProperty(PH, "__esModule", { value: true })), PH;
}
var DH = {}, K8e;
function K90() {
  return K8e || (K8e = 1, Object.defineProperty(DH, "__esModule", { value: true })), DH;
}
var WH = {}, Q8e;
function Q90() {
  return Q8e || (Q8e = 1, Object.defineProperty(WH, "__esModule", { value: true })), WH;
}
var NH = {}, Z8e;
function Z90() {
  return Z8e || (Z8e = 1, Object.defineProperty(NH, "__esModule", { value: true })), NH;
}
var wH = {}, e7e;
function ex0() {
  return e7e || (e7e = 1, Object.defineProperty(wH, "__esModule", { value: true })), wH;
}
var BH = {}, t7e;
function tx0() {
  return t7e || (t7e = 1, Object.defineProperty(BH, "__esModule", { value: true })), BH;
}
var xH = {}, r7e;
function rx0() {
  return r7e || (r7e = 1, Object.defineProperty(xH, "__esModule", { value: true })), xH;
}
var UH = {}, n7e;
function nx0() {
  return n7e || (n7e = 1, Object.defineProperty(UH, "__esModule", { value: true })), UH;
}
var kH = {}, a7e;
function ax0() {
  return a7e || (a7e = 1, Object.defineProperty(kH, "__esModule", { value: true })), kH;
}
var jH = {}, o7e;
function ox0() {
  return o7e || (o7e = 1, Object.defineProperty(jH, "__esModule", { value: true })), jH;
}
var FH = {}, i7e;
function ix0() {
  return i7e || (i7e = 1, Object.defineProperty(FH, "__esModule", { value: true })), FH;
}
var VH = {}, u7e;
function ux0() {
  return u7e || (u7e = 1, Object.defineProperty(VH, "__esModule", { value: true })), VH;
}
var HH = {}, s7e;
function sx0() {
  return s7e || (s7e = 1, Object.defineProperty(HH, "__esModule", { value: true })), HH;
}
var XH = {}, c7e;
function cx0() {
  return c7e || (c7e = 1, Object.defineProperty(XH, "__esModule", { value: true })), XH;
}
var $H = {}, l7e;
function lx0() {
  return l7e || (l7e = 1, Object.defineProperty($H, "__esModule", { value: true })), $H;
}
var GH = {}, p7e;
function px0() {
  return p7e || (p7e = 1, Object.defineProperty(GH, "__esModule", { value: true })), GH;
}
var YH = {}, d7e;
function dx0() {
  return d7e || (d7e = 1, Object.defineProperty(YH, "__esModule", { value: true })), YH;
}
var JH = {}, f7e;
function fx0() {
  return f7e || (f7e = 1, Object.defineProperty(JH, "__esModule", { value: true })), JH;
}
var KH = {}, b7e;
function bx0() {
  return b7e || (b7e = 1, Object.defineProperty(KH, "__esModule", { value: true })), KH;
}
var QH = {}, M7e;
function Mx0() {
  return M7e || (M7e = 1, Object.defineProperty(QH, "__esModule", { value: true })), QH;
}
var ZH = {}, O7e;
function Ox0() {
  return O7e || (O7e = 1, Object.defineProperty(ZH, "__esModule", { value: true })), ZH;
}
var eX = {}, z7e;
function zx0() {
  return z7e || (z7e = 1, Object.defineProperty(eX, "__esModule", { value: true })), eX;
}
var tX = {}, A7e;
function Ax0() {
  return A7e || (A7e = 1, Object.defineProperty(tX, "__esModule", { value: true })), tX;
}
var rX = {}, _7e;
function _x0() {
  return _7e || (_7e = 1, Object.defineProperty(rX, "__esModule", { value: true })), rX;
}
var nX = {}, h7e;
function hx0() {
  return h7e || (h7e = 1, Object.defineProperty(nX, "__esModule", { value: true })), nX;
}
var aX = {}, v7e;
function vx0() {
  return v7e || (v7e = 1, Object.defineProperty(aX, "__esModule", { value: true })), aX;
}
var oX = {}, m7e;
function mx0() {
  return m7e || (m7e = 1, Object.defineProperty(oX, "__esModule", { value: true })), oX;
}
var iX = {}, R7e;
function Rx0() {
  return R7e || (R7e = 1, Object.defineProperty(iX, "__esModule", { value: true })), iX;
}
var uX = {}, q7e;
function qx0() {
  return q7e || (q7e = 1, Object.defineProperty(uX, "__esModule", { value: true })), uX;
}
var sX = {}, T7e;
function Tx0() {
  return T7e || (T7e = 1, Object.defineProperty(sX, "__esModule", { value: true })), sX;
}
var cX = {}, y7e;
function yx0() {
  return y7e || (y7e = 1, Object.defineProperty(cX, "__esModule", { value: true })), cX;
}
var lX = {}, S7e;
function Sx0() {
  return S7e || (S7e = 1, Object.defineProperty(lX, "__esModule", { value: true })), lX;
}
var pX = {}, C7e;
function Cx0() {
  return C7e || (C7e = 1, Object.defineProperty(pX, "__esModule", { value: true })), pX;
}
var dX = {}, g7e;
function gx0() {
  return g7e || (g7e = 1, Object.defineProperty(dX, "__esModule", { value: true })), dX;
}
var fX = {}, I7e;
function Ix0() {
  return I7e || (I7e = 1, Object.defineProperty(fX, "__esModule", { value: true })), fX;
}
var bX = {}, E7e;
function Ex0() {
  return E7e || (E7e = 1, Object.defineProperty(bX, "__esModule", { value: true })), bX;
}
var MX = {}, L7e;
function Lx0() {
  return L7e || (L7e = 1, Object.defineProperty(MX, "__esModule", { value: true })), MX;
}
var OX = {}, P7e;
function Px0() {
  return P7e || (P7e = 1, Object.defineProperty(OX, "__esModule", { value: true })), OX;
}
var zX = {}, D7e;
function Dx0() {
  return D7e || (D7e = 1, Object.defineProperty(zX, "__esModule", { value: true })), zX;
}
var AX = {}, W7e;
function Wx0() {
  return W7e || (W7e = 1, Object.defineProperty(AX, "__esModule", { value: true })), AX;
}
var _X = {}, N7e;
function Nx0() {
  return N7e || (N7e = 1, Object.defineProperty(_X, "__esModule", { value: true })), _X;
}
var hX = {}, w7e;
function wx0() {
  return w7e || (w7e = 1, Object.defineProperty(hX, "__esModule", { value: true })), hX;
}
var vX = {}, B7e;
function Bx0() {
  return B7e || (B7e = 1, Object.defineProperty(vX, "__esModule", { value: true })), vX;
}
var mX = {}, x7e;
function xx0() {
  return x7e || (x7e = 1, Object.defineProperty(mX, "__esModule", { value: true })), mX;
}
var RX = {}, U7e;
function Ux0() {
  return U7e || (U7e = 1, Object.defineProperty(RX, "__esModule", { value: true })), RX;
}
var qX = {}, k7e;
function kx0() {
  return k7e || (k7e = 1, Object.defineProperty(qX, "__esModule", { value: true })), qX;
}
var TX = {}, j7e;
function jx0() {
  return j7e || (j7e = 1, Object.defineProperty(TX, "__esModule", { value: true })), TX;
}
var yX = {}, F7e;
function Fx0() {
  return F7e || (F7e = 1, Object.defineProperty(yX, "__esModule", { value: true })), yX;
}
var SX = {}, V7e;
function Vx0() {
  return V7e || (V7e = 1, Object.defineProperty(SX, "__esModule", { value: true })), SX;
}
var CX = {}, H7e;
function Hx0() {
  return H7e || (H7e = 1, Object.defineProperty(CX, "__esModule", { value: true })), CX;
}
var gX = {}, X7e;
function Xx0() {
  return X7e || (X7e = 1, Object.defineProperty(gX, "__esModule", { value: true })), gX;
}
var IX = {}, $7e;
function $x0() {
  return $7e || ($7e = 1, Object.defineProperty(IX, "__esModule", { value: true })), IX;
}
var EX = {}, G7e;
function Gx0() {
  return G7e || (G7e = 1, Object.defineProperty(EX, "__esModule", { value: true })), EX;
}
var LX = {}, Y7e;
function Yx0() {
  return Y7e || (Y7e = 1, Object.defineProperty(LX, "__esModule", { value: true })), LX;
}
var PX = {}, J7e;
function Jx0() {
  return J7e || (J7e = 1, Object.defineProperty(PX, "__esModule", { value: true })), PX;
}
var DX = {}, K7e;
function Kx0() {
  return K7e || (K7e = 1, Object.defineProperty(DX, "__esModule", { value: true })), DX;
}
var WX = {}, Q7e;
function Qx0() {
  return Q7e || (Q7e = 1, Object.defineProperty(WX, "__esModule", { value: true })), WX;
}
var NX = {}, Z7e;
function Zx0() {
  return Z7e || (Z7e = 1, Object.defineProperty(NX, "__esModule", { value: true })), NX;
}
var wX = {}, ewe;
function eU0() {
  return ewe || (ewe = 1, Object.defineProperty(wX, "__esModule", { value: true })), wX;
}
var BX = {}, twe;
function tU0() {
  return twe || (twe = 1, Object.defineProperty(BX, "__esModule", { value: true })), BX;
}
var xX = {}, rwe;
function rU0() {
  return rwe || (rwe = 1, Object.defineProperty(xX, "__esModule", { value: true })), xX;
}
var UX = {}, nwe;
function nU0() {
  return nwe || (nwe = 1, Object.defineProperty(UX, "__esModule", { value: true })), UX;
}
var kX = {}, awe;
function aU0() {
  return awe || (awe = 1, Object.defineProperty(kX, "__esModule", { value: true })), kX;
}
var jX = {}, owe;
function oU0() {
  return owe || (owe = 1, Object.defineProperty(jX, "__esModule", { value: true })), jX;
}
var FX = {}, iwe;
function iU0() {
  return iwe || (iwe = 1, Object.defineProperty(FX, "__esModule", { value: true })), FX;
}
var VX = {}, uwe;
function uU0() {
  return uwe || (uwe = 1, Object.defineProperty(VX, "__esModule", { value: true })), VX;
}
var HX = {}, swe;
function sU0() {
  return swe || (swe = 1, Object.defineProperty(HX, "__esModule", { value: true })), HX;
}
var XX = {}, cwe;
function cU0() {
  return cwe || (cwe = 1, Object.defineProperty(XX, "__esModule", { value: true })), XX;
}
var $X = {}, lwe;
function lU0() {
  return lwe || (lwe = 1, Object.defineProperty($X, "__esModule", { value: true })), $X;
}
var GX = {}, pwe;
function pU0() {
  return pwe || (pwe = 1, Object.defineProperty(GX, "__esModule", { value: true })), GX;
}
var YX = {}, dwe;
function dU0() {
  return dwe || (dwe = 1, Object.defineProperty(YX, "__esModule", { value: true })), YX;
}
var JX = {}, fwe;
function fU0() {
  return fwe || (fwe = 1, Object.defineProperty(JX, "__esModule", { value: true })), JX;
}
var KX = {}, bwe;
function bU0() {
  return bwe || (bwe = 1, Object.defineProperty(KX, "__esModule", { value: true })), KX;
}
var QX = {}, Mwe;
function MU0() {
  return Mwe || (Mwe = 1, Object.defineProperty(QX, "__esModule", { value: true })), QX;
}
var ZX = {}, Owe;
function OU0() {
  return Owe || (Owe = 1, Object.defineProperty(ZX, "__esModule", { value: true })), ZX;
}
var e$ = {}, zwe;
function zU0() {
  return zwe || (zwe = 1, Object.defineProperty(e$, "__esModule", { value: true })), e$;
}
var t$ = {}, Awe;
function AU0() {
  return Awe || (Awe = 1, Object.defineProperty(t$, "__esModule", { value: true })), t$;
}
var r$ = {}, _we;
function _U0() {
  return _we || (_we = 1, Object.defineProperty(r$, "__esModule", { value: true })), r$;
}
var n$ = {}, hwe;
function hU0() {
  return hwe || (hwe = 1, Object.defineProperty(n$, "__esModule", { value: true })), n$;
}
var a$ = {}, vwe;
function vU0() {
  return vwe || (vwe = 1, Object.defineProperty(a$, "__esModule", { value: true })), a$;
}
var o$ = {}, mwe;
function mU0() {
  return mwe || (mwe = 1, Object.defineProperty(o$, "__esModule", { value: true })), o$;
}
var i$ = {}, Rwe;
function RU0() {
  return Rwe || (Rwe = 1, Object.defineProperty(i$, "__esModule", { value: true })), i$;
}
var u$ = {}, qwe;
function qU0() {
  return qwe || (qwe = 1, Object.defineProperty(u$, "__esModule", { value: true })), u$;
}
var s$ = {}, Twe;
function TU0() {
  return Twe || (Twe = 1, Object.defineProperty(s$, "__esModule", { value: true })), s$;
}
var c$ = {}, ywe;
function yU0() {
  return ywe || (ywe = 1, Object.defineProperty(c$, "__esModule", { value: true })), c$;
}
var l$ = {}, Swe;
function SU0() {
  return Swe || (Swe = 1, Object.defineProperty(l$, "__esModule", { value: true })), l$;
}
var p$ = {}, Cwe;
function CU0() {
  return Cwe || (Cwe = 1, Object.defineProperty(p$, "__esModule", { value: true })), p$;
}
var d$ = {}, gwe;
function gU0() {
  return gwe || (gwe = 1, Object.defineProperty(d$, "__esModule", { value: true })), d$;
}
var f$ = {}, Iwe;
function IU0() {
  return Iwe || (Iwe = 1, Object.defineProperty(f$, "__esModule", { value: true })), f$;
}
var b$ = {}, Ewe;
function EU0() {
  return Ewe || (Ewe = 1, Object.defineProperty(b$, "__esModule", { value: true })), b$;
}
var M$ = {}, Lwe;
function LU0() {
  return Lwe || (Lwe = 1, Object.defineProperty(M$, "__esModule", { value: true })), M$;
}
var O$ = {}, Pwe;
function PU0() {
  return Pwe || (Pwe = 1, Object.defineProperty(O$, "__esModule", { value: true })), O$;
}
var z$ = {}, Dwe;
function DU0() {
  return Dwe || (Dwe = 1, Object.defineProperty(z$, "__esModule", { value: true })), z$;
}
var A$ = {}, Wwe;
function WU0() {
  return Wwe || (Wwe = 1, Object.defineProperty(A$, "__esModule", { value: true })), A$;
}
var _$ = {}, Nwe;
function NU0() {
  return Nwe || (Nwe = 1, Object.defineProperty(_$, "__esModule", { value: true })), _$;
}
var h$ = {}, wwe;
function wU0() {
  return wwe || (wwe = 1, Object.defineProperty(h$, "__esModule", { value: true })), h$;
}
var v$ = {}, Bwe;
function BU0() {
  return Bwe || (Bwe = 1, Object.defineProperty(v$, "__esModule", { value: true })), v$;
}
var m$ = {}, xwe;
function xU0() {
  return xwe || (xwe = 1, Object.defineProperty(m$, "__esModule", { value: true })), m$;
}
var R$ = {}, Uwe;
function UU0() {
  return Uwe || (Uwe = 1, Object.defineProperty(R$, "__esModule", { value: true })), R$;
}
var q$ = {}, kwe;
function kU0() {
  return kwe || (kwe = 1, Object.defineProperty(q$, "__esModule", { value: true })), q$;
}
var T$ = {}, jwe;
function jU0() {
  return jwe || (jwe = 1, Object.defineProperty(T$, "__esModule", { value: true })), T$;
}
var y$ = {}, Fwe;
function FU0() {
  return Fwe || (Fwe = 1, Object.defineProperty(y$, "__esModule", { value: true })), y$;
}
var S$ = {}, Vwe;
function VU0() {
  return Vwe || (Vwe = 1, Object.defineProperty(S$, "__esModule", { value: true })), S$;
}
var C$ = {}, Hwe;
function HU0() {
  return Hwe || (Hwe = 1, Object.defineProperty(C$, "__esModule", { value: true })), C$;
}
var g$ = {}, Xwe;
function XU0() {
  return Xwe || (Xwe = 1, Object.defineProperty(g$, "__esModule", { value: true })), g$;
}
var I$ = {}, $we;
function $U0() {
  return $we || ($we = 1, Object.defineProperty(I$, "__esModule", { value: true })), I$;
}
var E$ = {}, Gwe;
function GU0() {
  return Gwe || (Gwe = 1, Object.defineProperty(E$, "__esModule", { value: true })), E$;
}
var L$ = {}, Ywe;
function YU0() {
  return Ywe || (Ywe = 1, Object.defineProperty(L$, "__esModule", { value: true })), L$;
}
var P$ = {}, Jwe;
function JU0() {
  return Jwe || (Jwe = 1, Object.defineProperty(P$, "__esModule", { value: true })), P$;
}
var D$ = {}, Kwe;
function KU0() {
  return Kwe || (Kwe = 1, Object.defineProperty(D$, "__esModule", { value: true })), D$;
}
var W$ = {}, Qwe;
function QU0() {
  return Qwe || (Qwe = 1, Object.defineProperty(W$, "__esModule", { value: true })), W$;
}
var N$ = {}, Zwe;
function ZU0() {
  return Zwe || (Zwe = 1, Object.defineProperty(N$, "__esModule", { value: true })), N$;
}
var w$ = {}, eBe;
function ek0() {
  return eBe || (eBe = 1, Object.defineProperty(w$, "__esModule", { value: true })), w$;
}
var B$ = {}, tBe;
function tk0() {
  return tBe || (tBe = 1, Object.defineProperty(B$, "__esModule", { value: true })), B$;
}
var x$ = {}, rBe;
function rk0() {
  return rBe || (rBe = 1, Object.defineProperty(x$, "__esModule", { value: true })), x$;
}
var U$ = {}, nBe;
function nk0() {
  return nBe || (nBe = 1, Object.defineProperty(U$, "__esModule", { value: true })), U$;
}
var k$ = {}, aBe;
function ak0() {
  return aBe || (aBe = 1, Object.defineProperty(k$, "__esModule", { value: true })), k$;
}
var j$ = {}, oBe;
function ok0() {
  return oBe || (oBe = 1, Object.defineProperty(j$, "__esModule", { value: true })), j$;
}
var F$ = {}, iBe;
function ik0() {
  return iBe || (iBe = 1, Object.defineProperty(F$, "__esModule", { value: true })), F$;
}
var V$ = {}, uBe;
function uk0() {
  return uBe || (uBe = 1, Object.defineProperty(V$, "__esModule", { value: true })), V$;
}
var H$ = {}, sBe;
function sk0() {
  return sBe || (sBe = 1, Object.defineProperty(H$, "__esModule", { value: true })), H$;
}
var X$ = {}, cBe;
function ck0() {
  return cBe || (cBe = 1, Object.defineProperty(X$, "__esModule", { value: true })), X$;
}
var $$ = {}, lBe;
function lk0() {
  return lBe || (lBe = 1, Object.defineProperty($$, "__esModule", { value: true })), $$;
}
var G$ = {}, pBe;
function pk0() {
  return pBe || (pBe = 1, Object.defineProperty(G$, "__esModule", { value: true })), G$;
}
var Y$ = {}, dBe;
function dk0() {
  return dBe || (dBe = 1, Object.defineProperty(Y$, "__esModule", { value: true })), Y$;
}
var J$ = {}, fBe;
function fk0() {
  return fBe || (fBe = 1, Object.defineProperty(J$, "__esModule", { value: true })), J$;
}
var K$ = {}, bBe;
function bk0() {
  return bBe || (bBe = 1, Object.defineProperty(K$, "__esModule", { value: true })), K$;
}
var Q$ = {}, MBe;
function Mk0() {
  return MBe || (MBe = 1, Object.defineProperty(Q$, "__esModule", { value: true })), Q$;
}
var Z$ = {}, OBe;
function Ok0() {
  return OBe || (OBe = 1, Object.defineProperty(Z$, "__esModule", { value: true })), Z$;
}
var eG = {}, zBe;
function zk0() {
  return zBe || (zBe = 1, Object.defineProperty(eG, "__esModule", { value: true })), eG;
}
var tG = {}, ABe;
function Ak0() {
  return ABe || (ABe = 1, Object.defineProperty(tG, "__esModule", { value: true })), tG;
}
var rG = {}, _Be;
function _k0() {
  return _Be || (_Be = 1, Object.defineProperty(rG, "__esModule", { value: true })), rG;
}
var nG = {}, hBe;
function hk0() {
  return hBe || (hBe = 1, Object.defineProperty(nG, "__esModule", { value: true })), nG;
}
var aG = {}, vBe;
function vk0() {
  return vBe || (vBe = 1, Object.defineProperty(aG, "__esModule", { value: true })), aG;
}
var oG = {}, mBe;
function mk0() {
  return mBe || (mBe = 1, Object.defineProperty(oG, "__esModule", { value: true })), oG;
}
var iG = {}, RBe;
function Rk0() {
  return RBe || (RBe = 1, Object.defineProperty(iG, "__esModule", { value: true })), iG;
}
var uG = {}, qBe;
function qk0() {
  return qBe || (qBe = 1, Object.defineProperty(uG, "__esModule", { value: true })), uG;
}
var sG = {}, TBe;
function Tk0() {
  return TBe || (TBe = 1, Object.defineProperty(sG, "__esModule", { value: true })), sG;
}
var cG = {}, yBe;
function yk0() {
  return yBe || (yBe = 1, Object.defineProperty(cG, "__esModule", { value: true })), cG;
}
var lG = {}, SBe;
function Sk0() {
  return SBe || (SBe = 1, Object.defineProperty(lG, "__esModule", { value: true })), lG;
}
var pG = {}, CBe;
function Ck0() {
  return CBe || (CBe = 1, Object.defineProperty(pG, "__esModule", { value: true })), pG;
}
var dG = {}, gBe;
function gk0() {
  return gBe || (gBe = 1, Object.defineProperty(dG, "__esModule", { value: true })), dG;
}
var fG = {}, IBe;
function Ik0() {
  return IBe || (IBe = 1, Object.defineProperty(fG, "__esModule", { value: true })), fG;
}
var bG = {}, EBe;
function Ek0() {
  return EBe || (EBe = 1, Object.defineProperty(bG, "__esModule", { value: true })), bG;
}
var MG = {}, LBe;
function Lk0() {
  return LBe || (LBe = 1, Object.defineProperty(MG, "__esModule", { value: true })), MG;
}
var OG = {}, PBe;
function Pk0() {
  return PBe || (PBe = 1, Object.defineProperty(OG, "__esModule", { value: true })), OG;
}
var zG = {}, DBe;
function Dk0() {
  return DBe || (DBe = 1, Object.defineProperty(zG, "__esModule", { value: true })), zG;
}
var AG = {}, WBe;
function Wk0() {
  return WBe || (WBe = 1, Object.defineProperty(AG, "__esModule", { value: true })), AG;
}
var _G = {}, NBe;
function Nk0() {
  return NBe || (NBe = 1, Object.defineProperty(_G, "__esModule", { value: true })), _G;
}
var hG = {}, wBe;
function wk0() {
  return wBe || (wBe = 1, Object.defineProperty(hG, "__esModule", { value: true })), hG;
}
var vG = {}, BBe;
function Bk0() {
  return BBe || (BBe = 1, Object.defineProperty(vG, "__esModule", { value: true })), vG;
}
var mG = {}, xBe;
function xk0() {
  return xBe || (xBe = 1, Object.defineProperty(mG, "__esModule", { value: true })), mG;
}
var RG = {}, UBe;
function Uk0() {
  return UBe || (UBe = 1, Object.defineProperty(RG, "__esModule", { value: true })), RG;
}
var qG = {}, kBe;
function kk0() {
  return kBe || (kBe = 1, Object.defineProperty(qG, "__esModule", { value: true })), qG;
}
var TG = {}, jBe;
function jk0() {
  return jBe || (jBe = 1, Object.defineProperty(TG, "__esModule", { value: true })), TG;
}
var yG = {}, FBe;
function Fk0() {
  return FBe || (FBe = 1, Object.defineProperty(yG, "__esModule", { value: true })), yG;
}
var SG = {}, VBe;
function Vk0() {
  return VBe || (VBe = 1, Object.defineProperty(SG, "__esModule", { value: true })), SG;
}
var CG = {}, HBe;
function Hk0() {
  return HBe || (HBe = 1, Object.defineProperty(CG, "__esModule", { value: true })), CG;
}
var gG = {}, XBe;
function Xk0() {
  return XBe || (XBe = 1, Object.defineProperty(gG, "__esModule", { value: true })), gG;
}
var IG = {}, $Be;
function $k0() {
  return $Be || ($Be = 1, Object.defineProperty(IG, "__esModule", { value: true })), IG;
}
var EG = {}, GBe;
function Gk0() {
  return GBe || (GBe = 1, Object.defineProperty(EG, "__esModule", { value: true })), EG;
}
var LG = {}, YBe;
function Yk0() {
  return YBe || (YBe = 1, Object.defineProperty(LG, "__esModule", { value: true })), LG;
}
var PG = {}, JBe;
function Jk0() {
  return JBe || (JBe = 1, Object.defineProperty(PG, "__esModule", { value: true })), PG;
}
var DG = {}, KBe;
function Kk0() {
  return KBe || (KBe = 1, Object.defineProperty(DG, "__esModule", { value: true })), DG;
}
var WG = {}, QBe;
function Qk0() {
  return QBe || (QBe = 1, Object.defineProperty(WG, "__esModule", { value: true })), WG;
}
var NG = {}, ZBe;
function Zk0() {
  return ZBe || (ZBe = 1, Object.defineProperty(NG, "__esModule", { value: true })), NG;
}
var wG = {}, e9e;
function ej0() {
  return e9e || (e9e = 1, Object.defineProperty(wG, "__esModule", { value: true })), wG;
}
var BG = {}, t9e;
function tj0() {
  return t9e || (t9e = 1, Object.defineProperty(BG, "__esModule", { value: true })), BG;
}
var xG = {}, r9e;
function rj0() {
  return r9e || (r9e = 1, Object.defineProperty(xG, "__esModule", { value: true })), xG;
}
var UG = {}, n9e;
function nj0() {
  return n9e || (n9e = 1, Object.defineProperty(UG, "__esModule", { value: true })), UG;
}
var kG = {}, a9e;
function aj0() {
  return a9e || (a9e = 1, Object.defineProperty(kG, "__esModule", { value: true })), kG;
}
var jG = {}, o9e;
function oj0() {
  return o9e || (o9e = 1, Object.defineProperty(jG, "__esModule", { value: true })), jG;
}
var FG = {}, i9e;
function ij0() {
  return i9e || (i9e = 1, Object.defineProperty(FG, "__esModule", { value: true })), FG;
}
var VG = {}, u9e;
function uj0() {
  return u9e || (u9e = 1, Object.defineProperty(VG, "__esModule", { value: true })), VG;
}
var HG = {}, s9e;
function sj0() {
  return s9e || (s9e = 1, Object.defineProperty(HG, "__esModule", { value: true })), HG;
}
var XG = {}, c9e;
function cj0() {
  return c9e || (c9e = 1, Object.defineProperty(XG, "__esModule", { value: true })), XG;
}
var $G = {}, l9e;
function lj0() {
  return l9e || (l9e = 1, Object.defineProperty($G, "__esModule", { value: true })), $G;
}
var GG = {}, p9e;
function pj0() {
  return p9e || (p9e = 1, Object.defineProperty(GG, "__esModule", { value: true })), GG;
}
var YG = {}, d9e;
function dj0() {
  return d9e || (d9e = 1, Object.defineProperty(YG, "__esModule", { value: true })), YG;
}
var JG = {}, f9e;
function fj0() {
  return f9e || (f9e = 1, Object.defineProperty(JG, "__esModule", { value: true })), JG;
}
var KG = {}, b9e;
function bj0() {
  return b9e || (b9e = 1, Object.defineProperty(KG, "__esModule", { value: true })), KG;
}
var QG = {}, M9e;
function Mj0() {
  return M9e || (M9e = 1, Object.defineProperty(QG, "__esModule", { value: true })), QG;
}
var ZG = {}, O9e;
function Oj0() {
  return O9e || (O9e = 1, Object.defineProperty(ZG, "__esModule", { value: true })), ZG;
}
var eY = {}, z9e;
function zj0() {
  return z9e || (z9e = 1, Object.defineProperty(eY, "__esModule", { value: true })), eY;
}
var tY = {}, A9e;
function Aj0() {
  return A9e || (A9e = 1, Object.defineProperty(tY, "__esModule", { value: true })), tY;
}
var rY = {}, _9e;
function _j0() {
  return _9e || (_9e = 1, Object.defineProperty(rY, "__esModule", { value: true })), rY;
}
var nY = {}, h9e;
function hj0() {
  return h9e || (h9e = 1, Object.defineProperty(nY, "__esModule", { value: true })), nY;
}
var aY = {}, v9e;
function vj0() {
  return v9e || (v9e = 1, Object.defineProperty(aY, "__esModule", { value: true })), aY;
}
var oY = {}, m9e;
function mj0() {
  return m9e || (m9e = 1, Object.defineProperty(oY, "__esModule", { value: true })), oY;
}
var iY = {}, R9e;
function Rj0() {
  return R9e || (R9e = 1, Object.defineProperty(iY, "__esModule", { value: true })), iY;
}
var uY = {}, q9e;
function qj0() {
  return q9e || (q9e = 1, Object.defineProperty(uY, "__esModule", { value: true })), uY;
}
var sY = {}, T9e;
function Tj0() {
  return T9e || (T9e = 1, Object.defineProperty(sY, "__esModule", { value: true })), sY;
}
var cY = {}, y9e;
function yj0() {
  return y9e || (y9e = 1, Object.defineProperty(cY, "__esModule", { value: true })), cY;
}
var lY = {}, S9e;
function Sj0() {
  return S9e || (S9e = 1, Object.defineProperty(lY, "__esModule", { value: true })), lY;
}
var pY = {}, C9e;
function Cj0() {
  return C9e || (C9e = 1, Object.defineProperty(pY, "__esModule", { value: true })), pY;
}
var dY = {}, g9e;
function gj0() {
  return g9e || (g9e = 1, Object.defineProperty(dY, "__esModule", { value: true })), dY;
}
var fY = {}, I9e;
function Ij0() {
  return I9e || (I9e = 1, Object.defineProperty(fY, "__esModule", { value: true })), fY;
}
var bY = {}, E9e;
function Ej0() {
  return E9e || (E9e = 1, Object.defineProperty(bY, "__esModule", { value: true })), bY;
}
var MY = {}, L9e;
function Lj0() {
  return L9e || (L9e = 1, Object.defineProperty(MY, "__esModule", { value: true })), MY;
}
var OY = {}, P9e;
function Pj0() {
  return P9e || (P9e = 1, Object.defineProperty(OY, "__esModule", { value: true })), OY;
}
var zY = {}, D9e;
function Dj0() {
  return D9e || (D9e = 1, Object.defineProperty(zY, "__esModule", { value: true })), zY;
}
var AY = {}, W9e;
function Wj0() {
  return W9e || (W9e = 1, Object.defineProperty(AY, "__esModule", { value: true })), AY;
}
var _Y = {}, N9e;
function Nj0() {
  return N9e || (N9e = 1, Object.defineProperty(_Y, "__esModule", { value: true })), _Y;
}
var hY = {}, w9e;
function wj0() {
  return w9e || (w9e = 1, Object.defineProperty(hY, "__esModule", { value: true })), hY;
}
var vY = {}, B9e;
function Bj0() {
  return B9e || (B9e = 1, Object.defineProperty(vY, "__esModule", { value: true })), vY;
}
var mY = {}, x9e;
function xj0() {
  return x9e || (x9e = 1, Object.defineProperty(mY, "__esModule", { value: true })), mY;
}
var RY = {}, U9e;
function Uj0() {
  return U9e || (U9e = 1, Object.defineProperty(RY, "__esModule", { value: true })), RY;
}
var qY = {}, k9e;
function kj0() {
  return k9e || (k9e = 1, Object.defineProperty(qY, "__esModule", { value: true })), qY;
}
var TY = {}, j9e;
function jj0() {
  return j9e || (j9e = 1, Object.defineProperty(TY, "__esModule", { value: true })), TY;
}
var yY = {}, F9e;
function Fj0() {
  return F9e || (F9e = 1, Object.defineProperty(yY, "__esModule", { value: true })), yY;
}
var SY = {}, V9e;
function Vj0() {
  return V9e || (V9e = 1, Object.defineProperty(SY, "__esModule", { value: true })), SY;
}
var CY = {}, H9e;
function Hj0() {
  return H9e || (H9e = 1, Object.defineProperty(CY, "__esModule", { value: true })), CY;
}
var gY = {}, X9e;
function Xj0() {
  return X9e || (X9e = 1, Object.defineProperty(gY, "__esModule", { value: true })), gY;
}
var IY = {}, $9e;
function $j0() {
  return $9e || ($9e = 1, Object.defineProperty(IY, "__esModule", { value: true })), IY;
}
var EY = {}, G9e;
function Gj0() {
  return G9e || (G9e = 1, Object.defineProperty(EY, "__esModule", { value: true })), EY;
}
var LY = {}, Y9e;
function Yj0() {
  return Y9e || (Y9e = 1, Object.defineProperty(LY, "__esModule", { value: true })), LY;
}
var PY = {}, J9e;
function Jj0() {
  return J9e || (J9e = 1, Object.defineProperty(PY, "__esModule", { value: true })), PY;
}
var DY = {}, K9e;
function Kj0() {
  return K9e || (K9e = 1, Object.defineProperty(DY, "__esModule", { value: true })), DY;
}
var WY = {}, Q9e;
function Qj0() {
  return Q9e || (Q9e = 1, Object.defineProperty(WY, "__esModule", { value: true })), WY;
}
var NY = {}, Z9e;
function Zj0() {
  return Z9e || (Z9e = 1, Object.defineProperty(NY, "__esModule", { value: true })), NY;
}
var wY = {}, exe;
function eF0() {
  return exe || (exe = 1, Object.defineProperty(wY, "__esModule", { value: true })), wY;
}
var BY = {}, txe;
function tF0() {
  return txe || (txe = 1, Object.defineProperty(BY, "__esModule", { value: true })), BY;
}
var xY = {}, rxe;
function rF0() {
  return rxe || (rxe = 1, Object.defineProperty(xY, "__esModule", { value: true })), xY;
}
var UY = {}, nxe;
function nF0() {
  return nxe || (nxe = 1, Object.defineProperty(UY, "__esModule", { value: true })), UY;
}
var kY = {}, axe;
function aF0() {
  return axe || (axe = 1, Object.defineProperty(kY, "__esModule", { value: true })), kY;
}
var jY = {}, oxe;
function oF0() {
  return oxe || (oxe = 1, Object.defineProperty(jY, "__esModule", { value: true })), jY;
}
var FY = {}, ixe;
function iF0() {
  return ixe || (ixe = 1, Object.defineProperty(FY, "__esModule", { value: true })), FY;
}
var VY = {}, uxe;
function uF0() {
  return uxe || (uxe = 1, Object.defineProperty(VY, "__esModule", { value: true })), VY;
}
var HY = {}, sxe;
function sF0() {
  return sxe || (sxe = 1, Object.defineProperty(HY, "__esModule", { value: true })), HY;
}
var XY = {}, cxe;
function cF0() {
  return cxe || (cxe = 1, Object.defineProperty(XY, "__esModule", { value: true })), XY;
}
var $Y = {}, lxe;
function lF0() {
  return lxe || (lxe = 1, Object.defineProperty($Y, "__esModule", { value: true })), $Y;
}
var GY = {}, pxe;
function pF0() {
  return pxe || (pxe = 1, Object.defineProperty(GY, "__esModule", { value: true })), GY;
}
var YY = {}, dxe;
function dF0() {
  return dxe || (dxe = 1, Object.defineProperty(YY, "__esModule", { value: true })), YY;
}
var JY = {}, fxe;
function fF0() {
  return fxe || (fxe = 1, Object.defineProperty(JY, "__esModule", { value: true })), JY;
}
var KY = {}, bxe;
function bF0() {
  return bxe || (bxe = 1, Object.defineProperty(KY, "__esModule", { value: true })), KY;
}
var QY = {}, Mxe;
function MF0() {
  return Mxe || (Mxe = 1, Object.defineProperty(QY, "__esModule", { value: true })), QY;
}
var ZY = {}, Oxe;
function OF0() {
  return Oxe || (Oxe = 1, Object.defineProperty(ZY, "__esModule", { value: true })), ZY;
}
var eJ = {}, zxe;
function zF0() {
  return zxe || (zxe = 1, Object.defineProperty(eJ, "__esModule", { value: true })), eJ;
}
var tJ = {}, Axe;
function AF0() {
  return Axe || (Axe = 1, Object.defineProperty(tJ, "__esModule", { value: true })), tJ;
}
var rJ = {}, _xe;
function _F0() {
  return _xe || (_xe = 1, Object.defineProperty(rJ, "__esModule", { value: true })), rJ;
}
var nJ = {}, hxe;
function hF0() {
  return hxe || (hxe = 1, Object.defineProperty(nJ, "__esModule", { value: true })), nJ;
}
var aJ = {}, vxe;
function vF0() {
  return vxe || (vxe = 1, Object.defineProperty(aJ, "__esModule", { value: true })), aJ;
}
var oJ = {}, mxe;
function mF0() {
  return mxe || (mxe = 1, Object.defineProperty(oJ, "__esModule", { value: true })), oJ;
}
var iJ = {}, Rxe;
function RF0() {
  return Rxe || (Rxe = 1, Object.defineProperty(iJ, "__esModule", { value: true })), iJ;
}
var uJ = {}, qxe;
function qF0() {
  return qxe || (qxe = 1, Object.defineProperty(uJ, "__esModule", { value: true })), uJ;
}
var sJ = {}, Txe;
function TF0() {
  return Txe || (Txe = 1, Object.defineProperty(sJ, "__esModule", { value: true })), sJ;
}
var cJ = {}, yxe;
function yF0() {
  return yxe || (yxe = 1, Object.defineProperty(cJ, "__esModule", { value: true })), cJ;
}
var lJ = {}, Sxe;
function SF0() {
  return Sxe || (Sxe = 1, Object.defineProperty(lJ, "__esModule", { value: true })), lJ;
}
var pJ = {}, Cxe;
function CF0() {
  return Cxe || (Cxe = 1, Object.defineProperty(pJ, "__esModule", { value: true })), pJ;
}
var dJ = {}, gxe;
function gF0() {
  return gxe || (gxe = 1, Object.defineProperty(dJ, "__esModule", { value: true })), dJ;
}
var fJ = {}, Ixe;
function IF0() {
  return Ixe || (Ixe = 1, Object.defineProperty(fJ, "__esModule", { value: true })), fJ;
}
var bJ = {}, Exe;
function EF0() {
  return Exe || (Exe = 1, Object.defineProperty(bJ, "__esModule", { value: true })), bJ;
}
var MJ = {}, Lxe;
function LF0() {
  return Lxe || (Lxe = 1, Object.defineProperty(MJ, "__esModule", { value: true })), MJ;
}
var OJ = {}, Pxe;
function PF0() {
  return Pxe || (Pxe = 1, Object.defineProperty(OJ, "__esModule", { value: true })), OJ;
}
var zJ = {}, Dxe;
function DF0() {
  return Dxe || (Dxe = 1, Object.defineProperty(zJ, "__esModule", { value: true })), zJ;
}
var AJ = {}, Wxe;
function WF0() {
  return Wxe || (Wxe = 1, Object.defineProperty(AJ, "__esModule", { value: true })), AJ;
}
var _J = {}, Nxe;
function NF0() {
  return Nxe || (Nxe = 1, Object.defineProperty(_J, "__esModule", { value: true })), _J;
}
var hJ = {}, wxe;
function wF0() {
  return wxe || (wxe = 1, Object.defineProperty(hJ, "__esModule", { value: true })), hJ;
}
var vJ = {}, Bxe;
function BF0() {
  return Bxe || (Bxe = 1, Object.defineProperty(vJ, "__esModule", { value: true })), vJ;
}
var mJ = {}, xxe;
function xF0() {
  return xxe || (xxe = 1, Object.defineProperty(mJ, "__esModule", { value: true })), mJ;
}
var RJ = {}, Uxe;
function UF0() {
  return Uxe || (Uxe = 1, Object.defineProperty(RJ, "__esModule", { value: true })), RJ;
}
var qJ = {}, kxe;
function kF0() {
  return kxe || (kxe = 1, Object.defineProperty(qJ, "__esModule", { value: true })), qJ;
}
var TJ = {}, jxe;
function jF0() {
  return jxe || (jxe = 1, Object.defineProperty(TJ, "__esModule", { value: true })), TJ;
}
var yJ = {}, Fxe;
function FF0() {
  return Fxe || (Fxe = 1, Object.defineProperty(yJ, "__esModule", { value: true })), yJ;
}
var SJ = {}, Vxe;
function VF0() {
  return Vxe || (Vxe = 1, Object.defineProperty(SJ, "__esModule", { value: true })), SJ;
}
var CJ = {}, Hxe;
function HF0() {
  return Hxe || (Hxe = 1, Object.defineProperty(CJ, "__esModule", { value: true })), CJ;
}
var gJ = {}, Xxe;
function XF0() {
  return Xxe || (Xxe = 1, Object.defineProperty(gJ, "__esModule", { value: true })), gJ;
}
var IJ = {}, $xe;
function $F0() {
  return $xe || ($xe = 1, Object.defineProperty(IJ, "__esModule", { value: true })), IJ;
}
var EJ = {}, Gxe;
function GF0() {
  return Gxe || (Gxe = 1, Object.defineProperty(EJ, "__esModule", { value: true })), EJ;
}
var LJ = {}, Yxe;
function YF0() {
  return Yxe || (Yxe = 1, Object.defineProperty(LJ, "__esModule", { value: true })), LJ;
}
var PJ = {}, Jxe;
function JF0() {
  return Jxe || (Jxe = 1, Object.defineProperty(PJ, "__esModule", { value: true })), PJ;
}
var DJ = {}, Kxe;
function KF0() {
  return Kxe || (Kxe = 1, Object.defineProperty(DJ, "__esModule", { value: true })), DJ;
}
var WJ = {}, Qxe;
function QF0() {
  return Qxe || (Qxe = 1, Object.defineProperty(WJ, "__esModule", { value: true })), WJ;
}
var NJ = {}, Zxe;
function ZF0() {
  return Zxe || (Zxe = 1, Object.defineProperty(NJ, "__esModule", { value: true })), NJ;
}
var wJ = {}, eUe;
function eV0() {
  return eUe || (eUe = 1, Object.defineProperty(wJ, "__esModule", { value: true })), wJ;
}
var BJ = {}, tUe;
function tV0() {
  return tUe || (tUe = 1, Object.defineProperty(BJ, "__esModule", { value: true })), BJ;
}
var xJ = {}, rUe;
function rV0() {
  return rUe || (rUe = 1, Object.defineProperty(xJ, "__esModule", { value: true })), xJ;
}
var UJ = {}, nUe;
function nV0() {
  return nUe || (nUe = 1, Object.defineProperty(UJ, "__esModule", { value: true })), UJ;
}
var kJ = {}, aUe;
function aV0() {
  return aUe || (aUe = 1, Object.defineProperty(kJ, "__esModule", { value: true })), kJ;
}
var jJ = {}, oUe;
function oV0() {
  return oUe || (oUe = 1, Object.defineProperty(jJ, "__esModule", { value: true })), jJ;
}
var FJ = {}, iUe;
function iV0() {
  return iUe || (iUe = 1, Object.defineProperty(FJ, "__esModule", { value: true })), FJ;
}
var VJ = {}, uUe;
function uV0() {
  return uUe || (uUe = 1, Object.defineProperty(VJ, "__esModule", { value: true })), VJ;
}
var HJ = {}, sUe;
function sV0() {
  return sUe || (sUe = 1, Object.defineProperty(HJ, "__esModule", { value: true })), HJ;
}
var XJ = {}, cUe;
function cV0() {
  return cUe || (cUe = 1, Object.defineProperty(XJ, "__esModule", { value: true })), XJ;
}
var $J = {}, lUe;
function lV0() {
  return lUe || (lUe = 1, Object.defineProperty($J, "__esModule", { value: true })), $J;
}
var GJ = {}, pUe;
function pV0() {
  return pUe || (pUe = 1, Object.defineProperty(GJ, "__esModule", { value: true })), GJ;
}
var YJ = {}, dUe;
function dV0() {
  return dUe || (dUe = 1, Object.defineProperty(YJ, "__esModule", { value: true })), YJ;
}
var JJ = {}, fUe;
function fV0() {
  return fUe || (fUe = 1, Object.defineProperty(JJ, "__esModule", { value: true })), JJ;
}
var KJ = {}, bUe;
function bV0() {
  return bUe || (bUe = 1, Object.defineProperty(KJ, "__esModule", { value: true })), KJ;
}
var QJ = {}, MUe;
function MV0() {
  return MUe || (MUe = 1, Object.defineProperty(QJ, "__esModule", { value: true })), QJ;
}
var ZJ = {}, OUe;
function OV0() {
  return OUe || (OUe = 1, Object.defineProperty(ZJ, "__esModule", { value: true })), ZJ;
}
var eK = {}, zUe;
function zV0() {
  return zUe || (zUe = 1, Object.defineProperty(eK, "__esModule", { value: true })), eK;
}
var tK = {}, AUe;
function AV0() {
  return AUe || (AUe = 1, Object.defineProperty(tK, "__esModule", { value: true })), tK;
}
var rK = {}, _Ue;
function _V0() {
  return _Ue || (_Ue = 1, Object.defineProperty(rK, "__esModule", { value: true })), rK;
}
var nK = {}, hUe;
function hV0() {
  return hUe || (hUe = 1, Object.defineProperty(nK, "__esModule", { value: true })), nK;
}
var aK = {}, vUe;
function vV0() {
  return vUe || (vUe = 1, Object.defineProperty(aK, "__esModule", { value: true })), aK;
}
var oK = {}, mUe;
function mV0() {
  return mUe || (mUe = 1, Object.defineProperty(oK, "__esModule", { value: true })), oK;
}
var iK = {}, RUe;
function RV0() {
  return RUe || (RUe = 1, Object.defineProperty(iK, "__esModule", { value: true })), iK;
}
var uK = {}, qUe;
function qV0() {
  return qUe || (qUe = 1, Object.defineProperty(uK, "__esModule", { value: true })), uK;
}
var sK = {}, TUe;
function TV0() {
  return TUe || (TUe = 1, Object.defineProperty(sK, "__esModule", { value: true })), sK;
}
var cK = {}, yUe;
function yV0() {
  return yUe || (yUe = 1, Object.defineProperty(cK, "__esModule", { value: true })), cK;
}
var lK = {}, SUe;
function SV0() {
  return SUe || (SUe = 1, Object.defineProperty(lK, "__esModule", { value: true })), lK;
}
var pK = {}, CUe;
function CV0() {
  return CUe || (CUe = 1, Object.defineProperty(pK, "__esModule", { value: true })), pK;
}
var dK = {}, gUe;
function gV0() {
  return gUe || (gUe = 1, Object.defineProperty(dK, "__esModule", { value: true })), dK;
}
var fK = {}, IUe;
function IV0() {
  return IUe || (IUe = 1, Object.defineProperty(fK, "__esModule", { value: true })), fK;
}
var bK = {}, EUe;
function EV0() {
  return EUe || (EUe = 1, Object.defineProperty(bK, "__esModule", { value: true })), bK;
}
var MK = {}, LUe;
function LV0() {
  return LUe || (LUe = 1, Object.defineProperty(MK, "__esModule", { value: true })), MK;
}
var OK = {}, PUe;
function PV0() {
  return PUe || (PUe = 1, Object.defineProperty(OK, "__esModule", { value: true })), OK;
}
var zK = {}, DUe;
function DV0() {
  return DUe || (DUe = 1, Object.defineProperty(zK, "__esModule", { value: true })), zK;
}
var AK = {}, WUe;
function WV0() {
  return WUe || (WUe = 1, Object.defineProperty(AK, "__esModule", { value: true })), AK;
}
var _K = {}, NUe;
function NV0() {
  return NUe || (NUe = 1, Object.defineProperty(_K, "__esModule", { value: true })), _K;
}
var hK = {}, wUe;
function wV0() {
  return wUe || (wUe = 1, Object.defineProperty(hK, "__esModule", { value: true })), hK;
}
var vK = {}, BUe;
function BV0() {
  return BUe || (BUe = 1, Object.defineProperty(vK, "__esModule", { value: true })), vK;
}
var mK = {}, xUe;
function xV0() {
  return xUe || (xUe = 1, Object.defineProperty(mK, "__esModule", { value: true })), mK;
}
var RK = {}, UUe;
function UV0() {
  return UUe || (UUe = 1, Object.defineProperty(RK, "__esModule", { value: true })), RK;
}
var qK = {}, kUe;
function kV0() {
  return kUe || (kUe = 1, Object.defineProperty(qK, "__esModule", { value: true })), qK;
}
var TK = {}, jUe;
function jV0() {
  return jUe || (jUe = 1, Object.defineProperty(TK, "__esModule", { value: true })), TK;
}
var yK = {}, FUe;
function FV0() {
  return FUe || (FUe = 1, Object.defineProperty(yK, "__esModule", { value: true })), yK;
}
var SK = {}, VUe;
function VV0() {
  return VUe || (VUe = 1, Object.defineProperty(SK, "__esModule", { value: true })), SK;
}
var CK = {}, HUe;
function HV0() {
  return HUe || (HUe = 1, Object.defineProperty(CK, "__esModule", { value: true })), CK;
}
var gK = {}, XUe;
function XV0() {
  return XUe || (XUe = 1, Object.defineProperty(gK, "__esModule", { value: true })), gK;
}
var IK = {}, $Ue;
function $V0() {
  return $Ue || ($Ue = 1, Object.defineProperty(IK, "__esModule", { value: true })), IK;
}
var EK = {}, GUe;
function GV0() {
  return GUe || (GUe = 1, Object.defineProperty(EK, "__esModule", { value: true })), EK;
}
var LK = {}, YUe;
function YV0() {
  return YUe || (YUe = 1, Object.defineProperty(LK, "__esModule", { value: true })), LK;
}
var PK = {}, JUe;
function JV0() {
  return JUe || (JUe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.AccessPointEnum = void 0, (function(e) {
      e[e.DESKTOP = 1] = "DESKTOP", e[e.WEB = 2] = "WEB";
    })(t16.AccessPointEnum || (t16.AccessPointEnum = {}));
  })(PK)), PK;
}
var DK = {}, KUe;
function KV0() {
  return KUe || (KUe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.AccessPointCodeEnum = void 0, (function(e) {
      e.DESKTOP = "DESKTOP", e.WEB = "WEB";
    })(t16.AccessPointCodeEnum || (t16.AccessPointCodeEnum = {}));
  })(DK)), DK;
}
var WK = {}, QUe;
function QV0() {
  return QUe || (QUe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.AppletEnum = void 0, (function(e) {
      e[e.AP_CHECK_WRITING = 22] = "AP_CHECK_WRITING", e[e.AP_REPORTS = 28] = "AP_REPORTS", e[e.AR_COLLECTIONS = 86] = "AR_COLLECTIONS", e[e.AR_REPORTS = 27] = "AR_REPORTS", e[e.ACCOUNTING_PERIODS = 30] = "ACCOUNTING_PERIODS", e[e.ACTIVITIES = 56] = "ACTIVITIES", e[e.ANALYTIC_DASHBOARD_DESIGNER = 151] = "ANALYTIC_DASHBOARD_DESIGNER", e[e.ANALYTIC_DASHBOARDS = 154] = "ANALYTIC_DASHBOARDS", e[e.API_MANAGEMENT = 159] = "API_MANAGEMENT", e[e.APPROVER = 169] = "APPROVER", e[e.AUTOMATED_INVOICING = 19] = "AUTOMATED_INVOICING", e[e.BALANCE_SHEETS = 116] = "BALANCE_SHEETS", e[e.BANK_RECONCILIATION = 101] = "BANK_RECONCILIATION", e[e.BENEFIT_ACCRUAL = 125] = "BENEFIT_ACCRUAL", e[e.BILL_REVIEW = 57] = "BILL_REVIEW", e[e.CHART_OF_ACCOUNTS = 18] = "CHART_OF_ACCOUNTS", e[e.CLIENT_QUERIES = 88] = "CLIENT_QUERIES", e[e.CLIENTS = 12] = "CLIENTS", e[e.COMMENT_TEMPLATES = 133] = "COMMENT_TEMPLATES", e[e.CONTACT_QUERIES = 132] = "CONTACT_QUERIES", e[e.CONTACTS = 42] = "CONTACTS", e[e.CREDIT_CARD_CASH_POSTING = 134] = "CREDIT_CARD_CASH_POSTING", e[e.CREDIT_CARD_RECONCILIATION = 124] = "CREDIT_CARD_RECONCILIATION", e[e.CROSS_CHARGE_REPORTS = 111] = "CROSS_CHARGE_REPORTS", e[e.CUSTOM_REPORTS = 113] = "CUSTOM_REPORTS", e[e.DASHBOARD_GROUPS = 108] = "DASHBOARD_GROUPS", e[e.DASHBOARD_QUERIES_MANAGER = 152] = "DASHBOARD_QUERIES_MANAGER", e[e.DATA_DICTIONARY_REPORTS = 95] = "DATA_DICTIONARY_REPORTS", e[e.DATABASE_BACKUPS = 143] = "DATABASE_BACKUPS", e[e.DELIVERY_PAYMENTS = 170] = "DELIVERY_PAYMENTS", e[e.DILUTED_PAY_RATES = 106] = "DILUTED_PAY_RATES", e[e.DISBURSEMENT_JOURNAL = 6] = "DISBURSEMENT_JOURNAL", e[e.DISBURSEMENT_JOURNAL_REPORTS = 67] = "DISBURSEMENT_JOURNAL_REPORTS", e[e.DOCUMENT_MANAGER = 121] = "DOCUMENT_MANAGER", e[e.ER_CHECK_WRITING = 80] = "ER_CHECK_WRITING", e[e.ER_REPORTS = 119] = "ER_REPORTS", e[e.EFT_FILES = 126] = "EFT_FILES", e[e.EMP_REIMBUR_JOURNAL_REPORTS = 70] = "EMP_REIMBUR_JOURNAL_REPORTS", e[e.EMPLOYEE_QUERIES = 89] = "EMPLOYEE_QUERIES", e[e.EMPLOYEE_REIMBURSABLES = 11] = "EMPLOYEE_REIMBURSABLES", e[e.EMPLOYEES = 8] = "EMPLOYEES", e[e.END_OF_YEAR_CLOSING = 40] = "END_OF_YEAR_CLOSING", e[e.EVENT_MANAGER = 160] = "EVENT_MANAGER", e[e.EXCHANGE_SYNCHRONIZATION = 139] = "EXCHANGE_SYNCHRONIZATION", e[e.EXPENSE_CODES = 15] = "EXPENSE_CODES", e[e.EXPENSE_GROUPS = 47] = "EXPENSE_GROUPS", e[e.EXPENSE_SHEETS = 5] = "EXPENSE_SHEETS", e[e.FINANCIAL_STATEMENT_DSG = 76] = "FINANCIAL_STATEMENT_DSG", e[e.FINANCIAL_STATEMENTS = 31] = "FINANCIAL_STATEMENTS", e[e.FIRM_QUERIES = 130] = "FIRM_QUERIES", e[e.FIRMS = 46] = "FIRMS", e[e.FLAGS = 171] = "FLAGS", e[e.FORM_1099 = 41] = "FORM_1099", e[e.GL_BUDGETS = 78] = "GL_BUDGETS", e[e.GENERAL_JOURNAL = 10] = "GENERAL_JOURNAL", e[e.GENERAL_JOURNAL_REPORTS = 72] = "GENERAL_JOURNAL_REPORTS", e[e.GENERAL_LEDGER_REPORTS = 65] = "GENERAL_LEDGER_REPORTS", e[e.GLOBAL_SETTINGS = 9] = "GLOBAL_SETTINGS", e[e.HOLIDAY_CALENDARS = 142] = "HOLIDAY_CALENDARS", e[e.IMPORT_TOOLS = 98] = "IMPORT_TOOLS", e[e.INCOME_STATEMENTS = 117] = "INCOME_STATEMENTS", e[e.IN_FOCUS_JOBS = 156] = "IN_FOCUS_JOBS", e[e.INITIAL_PROJECT_LABOR_BALANCES = 38] = "INITIAL_PROJECT_LABOR_BALANCES", e[e.INVOICE_DESIGN = 64] = "INVOICE_DESIGN", e[e.INVOICE_POSTING_GROUPS = 123] = "INVOICE_POSTING_GROUPS", e[e.ITEM_SCRIPTER = 155] = "ITEM_SCRIPTER", e[e.ITEMS = 158] = "ITEMS", e[e.JOB_TITLES = 26] = "JOB_TITLES", e[e.LABOR_CODE_GROUPS = 140] = "LABOR_CODE_GROUPS", e[e.LABOR_CODES = 48] = "LABOR_CODES", e[e.LABOR_DISTRIBUTION = 23] = "LABOR_DISTRIBUTION", e[e.LAYOUT_MANAGER = 138] = "LAYOUT_MANAGER", e[e.LIST_MANAGEMENT = 44] = "LIST_MANAGEMENT", e[e.MAP_QUERIES = 136] = "MAP_QUERIES", e[e.MAP_VIEWER = 137] = "MAP_VIEWER", e[e.MARKETING_LISTS = 129] = "MARKETING_LISTS", e[e.MARKETPLACE_PURCHASES = 150] = "MARKETPLACE_PURCHASES", e[e.MC_REVALUATIONS = 145] = "MC_REVALUATIONS", e[e.MESSAGES_MANAGER = 167] = "MESSAGES_MANAGER", e[e.MOVE_PROJECT_TRANSACTIONS = 110] = "MOVE_PROJECT_TRANSACTIONS", e[e.MULTI_CURRENCY = 144] = "MULTI_CURRENCY", e[e.MY_NOTES = 54] = "MY_NOTES", e[e.MY_PURCHASE_ORDERS = 163] = "MY_PURCHASE_ORDERS", e[e.MY_WORK_ORDERS = 35] = "MY_WORK_ORDERS", e[e.NAVIGATOR_QUERIES = 122] = "NAVIGATOR_QUERIES", e[e.OH_ALLOCATION_SCRIPTS = 115] = "OH_ALLOCATION_SCRIPTS", e[e.OPPORTUNITIES = 53] = "OPPORTUNITIES", e[e.OPPORTUNITY_QUERIES = 131] = "OPPORTUNITY_QUERIES", e[e.ORGANIZATIONAL_UNITS = 17] = "ORGANIZATIONAL_UNITS", e[e.OVERHEAD_ALLOCATION = 33] = "OVERHEAD_ALLOCATION", e[e.OVERVIEW = 55] = "OVERVIEW", e[e.PA_BILL_REVIEW = 21] = "PA_BILL_REVIEW", e[e.PAYROLL_EXPORT = 97] = "PAYROLL_EXPORT", e[e.PERMISSIONS = 39] = "PERMISSIONS", e[e.PM_BILL_REVIEW = 20] = "PM_BILL_REVIEW", e[e.PM_REPORT_DESIGNER = 51] = "PM_REPORT_DESIGNER", e[e.PM_REPORTS = 52] = "PM_REPORTS", e[e.POST_EARNED_REVENUE = 82] = "POST_EARNED_REVENUE", e[e.PROCESS_TEMPLATES = 165] = "PROCESS_TEMPLATES", e[e.PROCUREMENT_END_OF_MONTH = 164] = "PROCUREMENT_END_OF_MONTH", e[e.PROFIT_SHARING = 103] = "PROFIT_SHARING", e[e.PROJECT_CENTRAL = 146] = "PROJECT_CENTRAL", e[e.PROJECT_HISTORY = 77] = "PROJECT_HISTORY", e[e.PROJECT_PLANNING = 49] = "PROJECT_PLANNING", e[e.PROJECT_QUERIES = 90] = "PROJECT_QUERIES", e[e.PROJECT_ROLES = 135] = "PROJECT_ROLES", e[e.PROJECT_TEMPLATES = 16] = "PROJECT_TEMPLATES", e[e.PROJECTS = 7] = "PROJECTS", e[e.PURCHASE_JOURNAL = 3] = "PURCHASE_JOURNAL", e[e.PURCHASE_JOURNAL_REPORTS = 66] = "PURCHASE_JOURNAL_REPORTS", e[e.PURCHASE_ORDER_MANAGEMENT = 161] = "PURCHASE_ORDER_MANAGEMENT", e[e.PURCHASE_ORDERS = 157] = "PURCHASE_ORDERS", e[e.QUERY_BUILDER = 153] = "QUERY_BUILDER", e[e.RATE_SCHEDULES = 14] = "RATE_SCHEDULES", e[e.RATE_TESTER = 104] = "RATE_TESTER", e[e.RECALCULATE_EXCHANGE_RATES = 147] = "RECALCULATE_EXCHANGE_RATES", e[e.RECALCULATE_MARKUPS = 109] = "RECALCULATE_MARKUPS", e[e.RECALCULATE_RATES = 85] = "RECALCULATE_RATES", e[e.RECEIPT_JOURNAL = 2] = "RECEIPT_JOURNAL", e[e.RECEIPT_JOURNAL_REPORTS = 69] = "RECEIPT_JOURNAL_REPORTS", e[e.RECEIPT_OF_GOODS = 162] = "RECEIPT_OF_GOODS", e[e.REPORT_MANAGEMENT = 73] = "REPORT_MANAGEMENT", e[e.REPORT_BUILDER = 148] = "REPORT_BUILDER", e[e.RESOURCE_GROUPS = 127] = "RESOURCE_GROUPS", e[e.RESOURCE_PROJECTIONS = 92] = "RESOURCE_PROJECTIONS", e[e.RESOURCE_SCHEDULER = 107] = "RESOURCE_SCHEDULER", e[e.SALES_JOURNAL = 74] = "SALES_JOURNAL", e[e.SALES_JOURNAL_REPORTS = 68] = "SALES_JOURNAL_REPORTS", e[e.SCHEDULING = 32] = "SCHEDULING", e[e.SEARCH_CENTER = 50] = "SEARCH_CENTER", e[e.SET_BILL_STATUS = 114] = "SET_BILL_STATUS", e[e.SNIPPET_MANAGER = 141] = "SNIPPET_MANAGER", e[e.SQL_QUERY = 93] = "SQL_QUERY", e[e.SQL_WATCHER = 94] = "SQL_WATCHER", e[e.TIME_EXPENSE_TEMPLATES = 96] = "TIME_EXPENSE_TEMPLATES", e[e.TIME_SHEETS = 4] = "TIME_SHEETS", e[e.TIME_TRANSACTIONS_DOLLARS = 100] = "TIME_TRANSACTIONS_DOLLARS", e[e.TIME_TRANSACTIONS_HOURS = 99] = "TIME_TRANSACTIONS_HOURS", e[e.TIMESHEET_ADJUSTMENTS = 75] = "TIMESHEET_ADJUSTMENTS", e[e.TRIAL_BALANCE_REPORTS = 81] = "TRIAL_BALANCE_REPORTS", e[e.UDF_DESIGNER = 45] = "UDF_DESIGNER", e[e.UDF_TABLE_MANAGER = 168] = "UDF_TABLE_MANAGER", e[e.UNIT_BILLING = 1171] = "UNIT_BILLING", e[e.UNIT_BILLING_PROFILES = 1172] = "UNIT_BILLING_PROFILES", e[e.UPDATES = 112] = "UPDATES", e[e.USER_SESSIONS = 149] = "USER_SESSIONS", e[e.UTILIZATION_REPORTS_DOLLARS = 84] = "UTILIZATION_REPORTS_DOLLARS", e[e.UTILIZATION_REPORTS_HOURS = 83] = "UTILIZATION_REPORTS_HOURS", e[e.VENDOR_QUERIES = 91] = "VENDOR_QUERIES", e[e.VENDORS = 13] = "VENDORS", e[e.WBS_TEMPLATES = 79] = "WBS_TEMPLATES", e[e.WORK_ORDERS = 59] = "WORK_ORDERS";
    })(t16.AppletEnum || (t16.AppletEnum = {}));
  })(WK)), WK;
}
var NK = {}, ZUe;
function ZV0() {
  return ZUe || (ZUe = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.AppletCodeEnum = void 0, (function(e) {
      e.RECEIPT_JOURNAL = "ReceiptJournal", e.PURCHASE_JOURNAL = "PJ", e.TIME_SHEETS = "Timesheets", e.EXPENSE_SHEETS = "ExpenseSheets", e.DISBURSEMENT_JOURNAL = "DisbursementJournal", e.PROJECTS = "ProjMaint", e.EMPLOYEES = "EmpMaint", e.GLOBAL_SETTINGS = "Globals", e.GENERAL_JOURNAL = "GeneralJournal", e.EMPLOYEE_REIMBURSABLES = "ER", e.CLIENTS = "Clients", e.VENDORS = "Vendors", e.RATE_SCHEDULES = "RateSchedules", e.EXPENSE_CODES = "ExpenseCodes", e.PROJECT_TEMPLATES = "ProjectTemplates", e.ORGANIZATIONAL_UNITS = "OrgUnits", e.CHART_OF_ACCOUNTS = "COA", e.AUTOMATED_INVOICING = "Invoicing", e.PM_BILL_REVIEW = "PMBillReview", e.PA_BILL_REVIEW = "PABillReview", e.AP_CHECK_WRITING = "APCHECK", e.LABOR_DISTRIBUTION = "LD", e.JOB_TITLES = "JT", e.AR_REPORTS = "ARReport", e.AP_REPORTS = "APReport", e.ACCOUNTING_PERIODS = "ACCTPeriod", e.FINANCIAL_STATEMENTS = "FS", e.SCHEDULING = "Sched", e.OVERHEAD_ALLOCATION = "Overhead", e.MY_WORK_ORDERS = "MyWorkOrder", e.INITIAL_PROJECT_LABOR_BALANCES = "InitProj", e.PERMISSIONS = "Permissions", e.END_OF_YEAR_CLOSING = "EOY", e.FORM_1099 = "1099", e.CONTACTS = "CM", e.LIST_MANAGEMENT = "LM", e.UDF_DESIGNER = "UDF", e.FIRMS = "Firms", e.EXPENSE_GROUPS = "ExpenseGroups", e.LABOR_CODES = "LaborCodes", e.PROJECT_PLANNING = "PP", e.SEARCH_CENTER = "SearchCenter", e.PM_REPORT_DESIGNER = "PMRPTDSG", e.PM_REPORTS = "pmreports", e.OPPORTUNITIES = "opps", e.MY_NOTES = "My Notes", e.OVERVIEW = "mktoverview", e.ACTIVITIES = "ACT", e.BILL_REVIEW = "BRVW", e.WORK_ORDERS = "WO", e.INVOICE_DESIGN = "invdesign", e.GENERAL_LEDGER_REPORTS = "GLREPORTS", e.PURCHASE_JOURNAL_REPORTS = "PJREPORTS", e.DISBURSEMENT_JOURNAL_REPORTS = "DJREPORTS", e.SALES_JOURNAL_REPORTS = "SJREPORTS", e.RECEIPT_JOURNAL_REPORTS = "RJREPORTS", e.EMP_REIMBUR_JOURNAL_REPORTS = "ERJREPORTS", e.GENERAL_JOURNAL_REPORTS = "GJREPORTS", e.REPORT_MANAGEMENT = "RCOPY", e.SALES_JOURNAL = "SJ", e.TIMESHEET_ADJUSTMENTS = "TSAdj", e.FINANCIAL_STATEMENT_DSG = "FSD", e.PROJECT_HISTORY = "PH", e.GL_BUDGETS = "glb", e.WBS_TEMPLATES = "wbst", e.ER_CHECK_WRITING = "ERCW", e.TRIAL_BALANCE_REPORTS = "tbr", e.POST_EARNED_REVENUE = "RRP", e.UTILIZATION_REPORTS_HOURS = "TSRH", e.UTILIZATION_REPORTS_DOLLARS = "TSRD", e.RECALCULATE_RATES = "RCR", e.AR_COLLECTIONS = "arcollections", e.CLIENT_QUERIES = "CQ", e.EMPLOYEE_QUERIES = "EQ", e.PROJECT_QUERIES = "PQ", e.VENDOR_QUERIES = "VQ", e.RESOURCE_PROJECTIONS = "RP", e.SQL_QUERY = "SQ", e.SQL_WATCHER = "SW", e.DATA_DICTIONARY_REPORTS = "DDReports", e.TIME_EXPENSE_TEMPLATES = "TETMP", e.PAYROLL_EXPORT = "PREX", e.IMPORT_TOOLS = "IMPORT", e.TIME_TRANSACTIONS_HOURS = "TTRH", e.TIME_TRANSACTIONS_DOLLARS = "TTRD", e.BANK_RECONCILIATION = "BANKREC", e.PROFIT_SHARING = "PShare", e.RATE_TESTER = "RT", e.DILUTED_PAY_RATES = "DPR", e.RESOURCE_SCHEDULER = "RS", e.DASHBOARD_GROUPS = "DG", e.RECALCULATE_MARKUPS = "RCM", e.MOVE_PROJECT_TRANSACTIONS = "MPT", e.CROSS_CHARGE_REPORTS = "CCR", e.UPDATES = "UPD", e.CUSTOM_REPORTS = "CSRPTS", e.SET_BILL_STATUS = "SBS", e.OH_ALLOCATION_SCRIPTS = "OHAS", e.BALANCE_SHEETS = "BALSHEET", e.INCOME_STATEMENTS = "PANDL", e.ER_REPORTS = "ERReports", e.DOCUMENT_MANAGER = "DOCMGR", e.NAVIGATOR_QUERIES = "NavQueries", e.INVOICE_POSTING_GROUPS = "IPG", e.CREDIT_CARD_RECONCILIATION = "CCClearing", e.BENEFIT_ACCRUAL = "ACCRUAL", e.EFT_FILES = "EFTFiles", e.RESOURCE_GROUPS = "ResourceGroups", e.MARKETING_LISTS = "MKL", e.FIRM_QUERIES = "FQry", e.OPPORTUNITY_QUERIES = "OQry", e.CONTACT_QUERIES = "CQry", e.COMMENT_TEMPLATES = "cmttemps", e.CREDIT_CARD_CASH_POSTING = "CCCashPost", e.PROJECT_ROLES = "prjroles", e.MAP_QUERIES = "MapQueries", e.MAP_VIEWER = "MapViewer", e.LAYOUT_MANAGER = "LayoutMgr", e.EXCHANGE_SYNCHRONIZATION = "ExSync", e.LABOR_CODE_GROUPS = "LCGroups", e.SNIPPET_MANAGER = "snips", e.HOLIDAY_CALENDARS = "HCals", e.DATABASE_BACKUPS = "DBBackup", e.MULTI_CURRENCY = "MC", e.MC_REVALUATIONS = "MCRevals", e.PROJECT_CENTRAL = "PMCentral", e.RECALCULATE_EXCHANGE_RATES = "REXR", e.REPORT_BUILDER = "RBLDR", e.USER_SESSIONS = "UserSessions", e.MARKETPLACE_PURCHASES = "MKTPUR", e.ANALYTIC_DASHBOARD_DESIGNER = "ALYDBDSG", e.DASHBOARD_QUERIES_MANAGER = "DQM", e.QUERY_BUILDER = "QRYBLD", e.ANALYTIC_DASHBOARDS = "ANYLDB", e.ITEM_SCRIPTER = "SCRIPT", e.IN_FOCUS_JOBS = "JOBS", e.PURCHASE_ORDERS = "PO", e.ITEMS = "ITMS", e.API_MANAGEMENT = "APIMGT", e.EVENT_MANAGER = "EVTMGR", e.PURCHASE_ORDER_MANAGEMENT = "POMANAGER", e.RECEIPT_OF_GOODS = "POROG", e.MY_PURCHASE_ORDERS = "MYPO", e.PROCUREMENT_END_OF_MONTH = "POEOMGLP", e.PROCESS_TEMPLATES = "PROTEMPLATES", e.MESSAGES_MANAGER = "MSGS", e.UDF_TABLE_MANAGER = "tblmgr", e.APPROVER = "APPROVER", e.DELIVERY_PAYMENTS = "PYMT", e.FLAGS = "FLAGS", e.UNIT_BILLING = "UB", e.UNIT_BILLING_PROFILES = "UBP";
    })(t16.AppletCodeEnum || (t16.AppletCodeEnum = {}));
  })(NK)), NK;
}
var wK = {}, eke;
function eH0() {
  return eke || (eke = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.SpecialRightEnum = void 0, (function(e) {
      e[e.RECEIPT_JOURNAL_ALLOW_POST_CLOSING_ADJUSTMENTS = 286] = "RECEIPT_JOURNAL_ALLOW_POST_CLOSING_ADJUSTMENTS", e[e.RECEIPT_JOURNAL_CAN_OVERRIDE_X_RATES = 197] = "RECEIPT_JOURNAL_CAN_OVERRIDE_X_RATES", e[e.RECEIPT_JOURNAL_CAN_POST_UNPOSTED_TRANSACTIONS = 307] = "RECEIPT_JOURNAL_CAN_POST_UNPOSTED_TRANSACTIONS", e[e.RECEIPT_JOURNAL_CHANGE_KEY_FIELDS = 192] = "RECEIPT_JOURNAL_CHANGE_KEY_FIELDS", e[e.RECEIPT_JOURNAL_CHANGE_PERIOD = 49] = "RECEIPT_JOURNAL_CHANGE_PERIOD", e[e.RECEIPT_JOURNAL_CHANGE_PERIOD_ALL_VERSIONS = 298] = "RECEIPT_JOURNAL_CHANGE_PERIOD_ALL_VERSIONS", e[e.RECEIPT_JOURNAL_SHOW_POST_UNPOSTED_TRANSACTIONS = 56] = "RECEIPT_JOURNAL_SHOW_POST_UNPOSTED_TRANSACTIONS", e[e.PURCHASE_JOURNAL_ALLOW_POST_CLOSING_ADJUSTMENTS = 285] = "PURCHASE_JOURNAL_ALLOW_POST_CLOSING_ADJUSTMENTS", e[e.PURCHASE_JOURNAL_CAN_OVERRIDE_EXPENSE_MARKUPS = 181] = "PURCHASE_JOURNAL_CAN_OVERRIDE_EXPENSE_MARKUPS", e[e.PURCHASE_JOURNAL_CAN_OVERRIDE_LINKED_INVOICE = 177] = "PURCHASE_JOURNAL_CAN_OVERRIDE_LINKED_INVOICE", e[e.PURCHASE_JOURNAL_CAN_OVERRIDE_X_RATES = 196] = "PURCHASE_JOURNAL_CAN_OVERRIDE_X_RATES", e[e.PURCHASE_JOURNAL_CAN_POST_UNPOSTED_TRANSACTIONS = 308] = "PURCHASE_JOURNAL_CAN_POST_UNPOSTED_TRANSACTIONS", e[e.PURCHASE_JOURNAL_CHANGE_KEY_FIELDS = 51] = "PURCHASE_JOURNAL_CHANGE_KEY_FIELDS", e[e.PURCHASE_JOURNAL_CHANGE_PERIOD = 48] = "PURCHASE_JOURNAL_CHANGE_PERIOD", e[e.PURCHASE_JOURNAL_CHANGE_PERIOD_ALL_VERSIONS = 299] = "PURCHASE_JOURNAL_CHANGE_PERIOD_ALL_VERSIONS", e[e.PURCHASE_JOURNAL_CREATE_RECURRING_ENTRIES = 105] = "PURCHASE_JOURNAL_CREATE_RECURRING_ENTRIES", e[e.PURCHASE_JOURNAL_EDIT_GRID = 29] = "PURCHASE_JOURNAL_EDIT_GRID", e[e.PURCHASE_JOURNAL_SHOW_POST_UNPOSTED_TRANSACTIONS = 55] = "PURCHASE_JOURNAL_SHOW_POST_UNPOSTED_TRANSACTIONS", e[e.TIME_SHEETS_CAN_VIEW_USED_HOURS = 157] = "TIME_SHEETS_CAN_VIEW_USED_HOURS", e[e.TIME_SHEETS_TIMESHEET_ADMINISTRATOR = 3] = "TIME_SHEETS_TIMESHEET_ADMINISTRATOR", e[e.TIME_SHEETS_VIEW_APPROVED_TIMESHEETS = 155] = "TIME_SHEETS_VIEW_APPROVED_TIMESHEETS", e[e.EXPENSE_SHEETS_EXPENSE_SHEET_ADMINISTRATOR = 111] = "EXPENSE_SHEETS_EXPENSE_SHEET_ADMINISTRATOR", e[e.DISBURSEMENT_JOURNAL_ALLOW_POST_CLOSING_ADJUSTMENTS = 283] = "DISBURSEMENT_JOURNAL_ALLOW_POST_CLOSING_ADJUSTMENTS", e[e.DISBURSEMENT_JOURNAL_CAN_OVERRIDE_EXPENSE_MARKUPS = 182] = "DISBURSEMENT_JOURNAL_CAN_OVERRIDE_EXPENSE_MARKUPS", e[e.DISBURSEMENT_JOURNAL_CAN_OVERRIDE_LINKED_INVOICE = 178] = "DISBURSEMENT_JOURNAL_CAN_OVERRIDE_LINKED_INVOICE", e[e.DISBURSEMENT_JOURNAL_CAN_OVERRIDE_X_RATES = 194] = "DISBURSEMENT_JOURNAL_CAN_OVERRIDE_X_RATES", e[e.DISBURSEMENT_JOURNAL_CAN_POST_UNPOSTED_TRANSACTIONS = 309] = "DISBURSEMENT_JOURNAL_CAN_POST_UNPOSTED_TRANSACTIONS", e[e.DISBURSEMENT_JOURNAL_CHANGE_KEY_FIELDS = 190] = "DISBURSEMENT_JOURNAL_CHANGE_KEY_FIELDS", e[e.DISBURSEMENT_JOURNAL_CHANGE_PERIOD = 46] = "DISBURSEMENT_JOURNAL_CHANGE_PERIOD", e[e.DISBURSEMENT_JOURNAL_CHANGE_PERIOD_ALL_VERSIONS = 300] = "DISBURSEMENT_JOURNAL_CHANGE_PERIOD_ALL_VERSIONS", e[e.DISBURSEMENT_JOURNAL_EDIT_GRID = 24] = "DISBURSEMENT_JOURNAL_EDIT_GRID", e[e.DISBURSEMENT_JOURNAL_SHOW_POST_UNPOSTED_TRANSACTIONS = 53] = "DISBURSEMENT_JOURNAL_SHOW_POST_UNPOSTED_TRANSACTIONS", e[e.PROJECTS_CAN_USE_PROJECT_MEMBERS_WIZARD = 166] = "PROJECTS_CAN_USE_PROJECT_MEMBERS_WIZARD", e[e.PROJECTS_DENY_ALLOWABLE_DATE_RANGES = 1344] = "PROJECTS_DENY_ALLOWABLE_DATE_RANGES", e[e.PROJECTS_DENY_CHARGE_LEVELS = 1345] = "PROJECTS_DENY_CHARGE_LEVELS", e[e.PROJECTS_DENY_CONTRACT_LEVELS_AND_CAPS = 1346] = "PROJECTS_DENY_CONTRACT_LEVELS_AND_CAPS", e[e.PROJECTS_DENY_DEFAULT_BILL_STATUS = 1347] = "PROJECTS_DENY_DEFAULT_BILL_STATUS", e[e.PROJECTS_DENY_EXPENSE_MARKUPS_CODES = 1348] = "PROJECTS_DENY_EXPENSE_MARKUPS_CODES", e[e.PROJECTS_DENY_INVOICE_DESCRIPTIONS = 1349] = "PROJECTS_DENY_INVOICE_DESCRIPTIONS", e[e.PROJECTS_DENY_INVOICE_FILTERS = 1350] = "PROJECTS_DENY_INVOICE_FILTERS", e[e.PROJECTS_DENY_INVOICE_POSTING_GROUP = 1351] = "PROJECTS_DENY_INVOICE_POSTING_GROUP", e[e.PROJECTS_DENY_LABOR_CODE_GROUPS = 1355] = "PROJECTS_DENY_LABOR_CODE_GROUPS", e[e.PROJECTS_DENY_RATE_SCHEDULES = 1352] = "PROJECTS_DENY_RATE_SCHEDULES", e[e.PROJECTS_DENY_REVENUE_RECOGNITION_PROFIT_CENTERS = 1353] = "PROJECTS_DENY_REVENUE_RECOGNITION_PROFIT_CENTERS", e[e.PROJECTS_DENY_TIME_SHEET_COMMENT_TEMPLATES = 1354] = "PROJECTS_DENY_TIME_SHEET_COMMENT_TEMPLATES", e[e.PROJECTS_EDIT_U_D_FS = 41] = "PROJECTS_EDIT_U_D_FS", e[e.PROJECTS_MODIFY_PROJECT_LEVEL_LABELS = 96] = "PROJECTS_MODIFY_PROJECT_LEVEL_LABELS", e[e.EMPLOYEES_EDIT_U_D_FS = 42] = "EMPLOYEES_EDIT_U_D_FS", e[e.EMPLOYEES_IS_HUMAN_RESOURCES = 1] = "EMPLOYEES_IS_HUMAN_RESOURCES", e[e.EMPLOYEES_VIEW_PAY_RATES = 128] = "EMPLOYEES_VIEW_PAY_RATES", e[e.GENERAL_JOURNAL_ALLOW_POST_CLOSING_ADJUSTMENTS = 284] = "GENERAL_JOURNAL_ALLOW_POST_CLOSING_ADJUSTMENTS", e[e.GENERAL_JOURNAL_CAN_OVERRIDE_X_RATES = 195] = "GENERAL_JOURNAL_CAN_OVERRIDE_X_RATES", e[e.GENERAL_JOURNAL_CAN_POST_UNPOSTED_TRANSACTIONS = 310] = "GENERAL_JOURNAL_CAN_POST_UNPOSTED_TRANSACTIONS", e[e.GENERAL_JOURNAL_CHANGE_PERIOD = 47] = "GENERAL_JOURNAL_CHANGE_PERIOD", e[e.GENERAL_JOURNAL_CHANGE_PERIOD_ALL_VERSIONS = 301] = "GENERAL_JOURNAL_CHANGE_PERIOD_ALL_VERSIONS", e[e.GENERAL_JOURNAL_CREATE_RECURRING_ENTRIES = 104] = "GENERAL_JOURNAL_CREATE_RECURRING_ENTRIES", e[e.GENERAL_JOURNAL_SHOW_POST_UNPOSTED_TRANSACTIONS = 54] = "GENERAL_JOURNAL_SHOW_POST_UNPOSTED_TRANSACTIONS", e[e.EMPLOYEE_REIMBURSABLES_ALLOW_POST_CLOSING_ADJUSTMENTS = 288] = "EMPLOYEE_REIMBURSABLES_ALLOW_POST_CLOSING_ADJUSTMENTS", e[e.EMPLOYEE_REIMBURSABLES_CAN_DELETE_CASH_POSTING_LINKED_ITEMS = 242] = "EMPLOYEE_REIMBURSABLES_CAN_DELETE_CASH_POSTING_LINKED_ITEMS", e[e.EMPLOYEE_REIMBURSABLES_CAN_OVERRIDE_EXPENSE_MARKUPS = 183] = "EMPLOYEE_REIMBURSABLES_CAN_OVERRIDE_EXPENSE_MARKUPS", e[e.EMPLOYEE_REIMBURSABLES_CAN_OVERRIDE_LINKED_INVOICE = 179] = "EMPLOYEE_REIMBURSABLES_CAN_OVERRIDE_LINKED_INVOICE", e[e.EMPLOYEE_REIMBURSABLES_CAN_POST_UNPOSTED_TRANSACTIONS = 311] = "EMPLOYEE_REIMBURSABLES_CAN_POST_UNPOSTED_TRANSACTIONS", e[e.EMPLOYEE_REIMBURSABLES_CHANGE_KEY_FIELDS = 191] = "EMPLOYEE_REIMBURSABLES_CHANGE_KEY_FIELDS", e[e.EMPLOYEE_REIMBURSABLES_CHANGE_PERIOD = 98] = "EMPLOYEE_REIMBURSABLES_CHANGE_PERIOD", e[e.EMPLOYEE_REIMBURSABLES_CHANGE_PERIOD_ALL_VERSIONS = 302] = "EMPLOYEE_REIMBURSABLES_CHANGE_PERIOD_ALL_VERSIONS", e[e.EMPLOYEE_REIMBURSABLES_CLEAR_ALL_PENDING_EXPENSE_SHEET_TRANSACTIONS = 97] = "EMPLOYEE_REIMBURSABLES_CLEAR_ALL_PENDING_EXPENSE_SHEET_TRANSACTIONS", e[e.EMPLOYEE_REIMBURSABLES_CREATE_RECURRING_ENTRIES = 106] = "EMPLOYEE_REIMBURSABLES_CREATE_RECURRING_ENTRIES", e[e.EMPLOYEE_REIMBURSABLES_EDIT_GRID = 27] = "EMPLOYEE_REIMBURSABLES_EDIT_GRID", e[e.EMPLOYEE_REIMBURSABLES_GENERATE_EXPENSE_SHEET_TRANSACTIONS = 99] = "EMPLOYEE_REIMBURSABLES_GENERATE_EXPENSE_SHEET_TRANSACTIONS", e[e.CLIENTS_EDIT_U_D_FS = 43] = "CLIENTS_EDIT_U_D_FS", e[e.CLIENTS_VIEW_RECENT = 100] = "CLIENTS_VIEW_RECENT", e[e.VENDORS_EDIT_U_D_FS = 44] = "VENDORS_EDIT_U_D_FS", e[e.VENDORS_VIEW_RECENT = 101] = "VENDORS_VIEW_RECENT", e[e.ORGANIZATIONAL_UNITS_MODIFY_ORG_LABELS = 95] = "ORGANIZATIONAL_UNITS_MODIFY_ORG_LABELS", e[e.CHART_OF_ACCOUNTS_EXECUTE_CASH_CONVERSION = 59] = "CHART_OF_ACCOUNTS_EXECUTE_CASH_CONVERSION", e[e.AUTOMATED_INVOICING_CAN_CLEAR_INVOICING_SESSIONS = 110] = "AUTOMATED_INVOICING_CAN_CLEAR_INVOICING_SESSIONS", e[e.PM_BILL_REVIEW_CAN_CHANGE_BILL_STATUS = 250] = "PM_BILL_REVIEW_CAN_CHANGE_BILL_STATUS", e[e.PM_BILL_REVIEW_CAN_MODIFY_INFO_TEMPLATE = 326] = "PM_BILL_REVIEW_CAN_MODIFY_INFO_TEMPLATE", e[e.PM_BILL_REVIEW_CAN_MODIFY_RETAINERS = 251] = "PM_BILL_REVIEW_CAN_MODIFY_RETAINERS", e[e.PM_BILL_REVIEW_CAN_MOVE_TRANSACTIONS = 249] = "PM_BILL_REVIEW_CAN_MOVE_TRANSACTIONS", e[e.PM_BILL_REVIEW_CAN_OVERRIDE_PROJECT_LEADER = 109] = "PM_BILL_REVIEW_CAN_OVERRIDE_PROJECT_LEADER", e[e.PA_BILL_REVIEW_CAN_CHANGE_BILL_STATUS = 246] = "PA_BILL_REVIEW_CAN_CHANGE_BILL_STATUS", e[e.PA_BILL_REVIEW_CAN_MODIFY_BILL_HOURS = 244] = "PA_BILL_REVIEW_CAN_MODIFY_BILL_HOURS", e[e.PA_BILL_REVIEW_CAN_MODIFY_INFO_TEMPLATE = 327] = "PA_BILL_REVIEW_CAN_MODIFY_INFO_TEMPLATE", e[e.PA_BILL_REVIEW_CAN_MODIFY_INSTRUCTIONS_TO_BILLER = 159] = "PA_BILL_REVIEW_CAN_MODIFY_INSTRUCTIONS_TO_BILLER", e[e.PA_BILL_REVIEW_CAN_MOVE_TRANSACTIONS = 245] = "PA_BILL_REVIEW_CAN_MOVE_TRANSACTIONS", e[e.PA_BILL_REVIEW_OVERRIDE_PROJECT_ACCOUNTANT_RESTRICTION = 108] = "PA_BILL_REVIEW_OVERRIDE_PROJECT_ACCOUNTANT_RESTRICTION", e[e.MY_WORK_ORDERS_CAN_PRINT_OTHER_EMPLOYEE_WORK_ORDERS = 120] = "MY_WORK_ORDERS_CAN_PRINT_OTHER_EMPLOYEE_WORK_ORDERS", e[e.CONTACTS_CAN_SET_GLOBAL_VIEW = 170] = "CONTACTS_CAN_SET_GLOBAL_VIEW", e[e.CONTACTS_EDIT_U_D_FS = 94] = "CONTACTS_EDIT_U_D_FS", e[e.FIRMS_CAN_SET_GLOBAL_VIEW = 171] = "FIRMS_CAN_SET_GLOBAL_VIEW", e[e.PROJECT_PLANNING_APPROVE_CHANGE_ORDERS = 64] = "PROJECT_PLANNING_APPROVE_CHANGE_ORDERS", e[e.PROJECT_PLANNING_CAN_EDIT_PROJECT_DETAILS_WHEN_NOT_PLAN = 151] = "PROJECT_PLANNING_CAN_EDIT_PROJECT_DETAILS_WHEN_NOT_PLAN", e[e.PROJECT_PLANNING_CAN_EDIT_PROJECT_DETAILS_WHEN_PLAN = 152] = "PROJECT_PLANNING_CAN_EDIT_PROJECT_DETAILS_WHEN_PLAN", e[e.PROJECT_PLANNING_CAN_OVERRIDE_PROJECT_LEADER_RESTRICTION = 145] = "PROJECT_PLANNING_CAN_OVERRIDE_PROJECT_LEADER_RESTRICTION", e[e.PROJECT_PLANNING_EDIT_BUDGETS_ON_ALL_PROJECT_TYPES = 103] = "PROJECT_PLANNING_EDIT_BUDGETS_ON_ALL_PROJECT_TYPES", e[e.PROJECT_PLANNING_ROLLUP_CONTRACT_FROM_BUDGET = 147] = "PROJECT_PLANNING_ROLLUP_CONTRACT_FROM_BUDGET", e[e.PROJECT_PLANNING_SAVE_BASELINE = 63] = "PROJECT_PLANNING_SAVE_BASELINE", e[e.PROJECT_PLANNING_VIEW_LABOR_COSTS_IN_PROJECT_FIGURES = 149] = "PROJECT_PLANNING_VIEW_LABOR_COSTS_IN_PROJECT_FIGURES", e[e.PM_REPORTS_CAN_OVERRIDE_PM_LEADER_RESTRICTION = 92] = "PM_REPORTS_CAN_OVERRIDE_PM_LEADER_RESTRICTION", e[e.PM_REPORTS_CAN_USE_VIEW_DATA = 160] = "PM_REPORTS_CAN_USE_VIEW_DATA", e[e.PM_REPORTS_CAN_VIEW_SENSITIVE_DATA = 62] = "PM_REPORTS_CAN_VIEW_SENSITIVE_DATA", e[e.OPPORTUNITIES_CAN_SET_GLOBAL_VIEW = 172] = "OPPORTUNITIES_CAN_SET_GLOBAL_VIEW", e[e.ACTIVITIES_CAN_ASSIGN_OTHER_EMPLOYEES = 289] = "ACTIVITIES_CAN_ASSIGN_OTHER_EMPLOYEES", e[e.WORK_ORDERS_CAN_ASSIGN_ANY_PROJECT = 168] = "WORK_ORDERS_CAN_ASSIGN_ANY_PROJECT", e[e.WORK_ORDERS_CAN_BULK_EDIT = 341] = "WORK_ORDERS_CAN_BULK_EDIT", e[e.WORK_ORDERS_CAN_DELETE_PROCESS = 338] = "WORK_ORDERS_CAN_DELETE_PROCESS", e[e.WORK_ORDERS_CAN_MODIFY_CLOSED_PROCESSES = 1343] = "WORK_ORDERS_CAN_MODIFY_CLOSED_PROCESSES", e[e.WORK_ORDERS_CAN_MOVE_BETWEEN_PROCESSES = 1339] = "WORK_ORDERS_CAN_MOVE_BETWEEN_PROCESSES", e[e.WORK_ORDERS_CAN_PRINT_OTHER_EMPLOYEE_WORK_ORDERS = 121] = "WORK_ORDERS_CAN_PRINT_OTHER_EMPLOYEE_WORK_ORDERS", e[e.WORK_ORDERS_CAN_VIEW_ALL_WORK_ORDERS = 340] = "WORK_ORDERS_CAN_VIEW_ALL_WORK_ORDERS", e[e.WORK_ORDERS_CAN_VIEW_CLOSED_PROCESSES = 1338] = "WORK_ORDERS_CAN_VIEW_CLOSED_PROCESSES", e[e.WORK_ORDERS_IS_ADMINISTRATOR = 339] = "WORK_ORDERS_IS_ADMINISTRATOR", e[e.REPORT_MANAGEMENT_AP_CHECK = 32] = "REPORT_MANAGEMENT_AP_CHECK", e[e.REPORT_MANAGEMENT_AP_CHECK_LABELS = 34] = "REPORT_MANAGEMENT_AP_CHECK_LABELS", e[e.REPORT_MANAGEMENT_AP_EFT = 175] = "REPORT_MANAGEMENT_AP_EFT", e[e.REPORT_MANAGEMENT_AP_LONG_STUBS = 36] = "REPORT_MANAGEMENT_AP_LONG_STUBS", e[e.REPORT_MANAGEMENT_ACCOUNTS_PAYABLE_REPORTS = 15] = "REPORT_MANAGEMENT_ACCOUNTS_PAYABLE_REPORTS", e[e.REPORT_MANAGEMENT_ACCOUNTS_RECEIVABLE_REPORTS = 16] = "REPORT_MANAGEMENT_ACCOUNTS_RECEIVABLE_REPORTS", e[e.REPORT_MANAGEMENT_BALANCE_SHEETS = 132] = "REPORT_MANAGEMENT_BALANCE_SHEETS", e[e.REPORT_MANAGEMENT_BANK_RECONCILIATION = 122] = "REPORT_MANAGEMENT_BANK_RECONCILIATION", e[e.REPORT_MANAGEMENT_CHART_OF_ACCOUNT = 116] = "REPORT_MANAGEMENT_CHART_OF_ACCOUNT", e[e.REPORT_MANAGEMENT_CLIENT_LIST = 113] = "REPORT_MANAGEMENT_CLIENT_LIST", e[e.REPORT_MANAGEMENT_CREDIT_CARD_RECONCILIATION = 153] = "REPORT_MANAGEMENT_CREDIT_CARD_RECONCILIATION", e[e.REPORT_MANAGEMENT_CROSS_CHARGE_REPORTS = 129] = "REPORT_MANAGEMENT_CROSS_CHARGE_REPORTS", e[e.REPORT_MANAGEMENT_DATA_DICTIONARY = 93] = "REPORT_MANAGEMENT_DATA_DICTIONARY", e[e.REPORT_MANAGEMENT_DISBURSEMENT_JOURNAL_REPORTS = 17] = "REPORT_MANAGEMENT_DISBURSEMENT_JOURNAL_REPORTS", e[e.REPORT_MANAGEMENT_ER_CHECK = 33] = "REPORT_MANAGEMENT_ER_CHECK", e[e.REPORT_MANAGEMENT_ER_CHECK_LABELS = 35] = "REPORT_MANAGEMENT_ER_CHECK_LABELS", e[e.REPORT_MANAGEMENT_ER_EFT = 176] = "REPORT_MANAGEMENT_ER_EFT", e[e.REPORT_MANAGEMENT_ER_LONG_STUBS = 38] = "REPORT_MANAGEMENT_ER_LONG_STUBS", e[e.REPORT_MANAGEMENT_EMPLOYEE_LIST = 112] = "REPORT_MANAGEMENT_EMPLOYEE_LIST", e[e.REPORT_MANAGEMENT_EMPLOYEE_REIMBURSABLE_JOURNAL_REPORTS = 18] = "REPORT_MANAGEMENT_EMPLOYEE_REIMBURSABLE_JOURNAL_REPORTS", e[e.REPORT_MANAGEMENT_EMPLOYEE_REIMBURSABLE_REPORTS = 139] = "REPORT_MANAGEMENT_EMPLOYEE_REIMBURSABLE_REPORTS", e[e.REPORT_MANAGEMENT_EXPENSE_SHEET = 90] = "REPORT_MANAGEMENT_EXPENSE_SHEET", e[e.REPORT_MANAGEMENT_FORM1099 = 60] = "REPORT_MANAGEMENT_FORM1099", e[e.REPORT_MANAGEMENT_FORM1099_LABELS = 61] = "REPORT_MANAGEMENT_FORM1099_LABELS", e[e.REPORT_MANAGEMENT_GENERAL_JOURNAL_REPORTS = 19] = "REPORT_MANAGEMENT_GENERAL_JOURNAL_REPORTS", e[e.REPORT_MANAGEMENT_GENERAL_LEDGER_REPORTS = 20] = "REPORT_MANAGEMENT_GENERAL_LEDGER_REPORTS", e[e.REPORT_MANAGEMENT_INCOME_STATEMENTS = 133] = "REPORT_MANAGEMENT_INCOME_STATEMENTS", e[e.REPORT_MANAGEMENT_INVOICE_LABELS = 40] = "REPORT_MANAGEMENT_INVOICE_LABELS", e[e.REPORT_MANAGEMENT_LABOR_POSTINGS = 134] = "REPORT_MANAGEMENT_LABOR_POSTINGS", e[e.REPORT_MANAGEMENT_LINKED_TRANSACTIONS = 137] = "REPORT_MANAGEMENT_LINKED_TRANSACTIONS", e[e.REPORT_MANAGEMENT_MANUAL_CHECK = 86] = "REPORT_MANAGEMENT_MANUAL_CHECK", e[e.REPORT_MANAGEMENT_OH_SCRIPT_RESULTS = 131] = "REPORT_MANAGEMENT_OH_SCRIPT_RESULTS", e[e.REPORT_MANAGEMENT_PAY_WHEN_PAID_REPORTS = 68] = "REPORT_MANAGEMENT_PAY_WHEN_PAID_REPORTS", e[e.REPORT_MANAGEMENT_PREBILL = 140] = "REPORT_MANAGEMENT_PREBILL", e[e.REPORT_MANAGEMENT_PROJECT_LIST = 115] = "REPORT_MANAGEMENT_PROJECT_LIST", e[e.REPORT_MANAGEMENT_PROJECT_PLANNING = 143] = "REPORT_MANAGEMENT_PROJECT_PLANNING", e[e.REPORT_MANAGEMENT_PURCHASE_JOURNAL_REPORTS = 21] = "REPORT_MANAGEMENT_PURCHASE_JOURNAL_REPORTS", e[e.REPORT_MANAGEMENT_PURCHASE_ORDER = 292] = "REPORT_MANAGEMENT_PURCHASE_ORDER", e[e.REPORT_MANAGEMENT_RECEIPT_JOURNAL_REPORTS = 22] = "REPORT_MANAGEMENT_RECEIPT_JOURNAL_REPORTS", e[e.REPORT_MANAGEMENT_SALES_JOURNAL_REPORTS = 23] = "REPORT_MANAGEMENT_SALES_JOURNAL_REPORTS", e[e.REPORT_MANAGEMENT_STATEMENTS_OF_ACCOUNT_LABELS = 142] = "REPORT_MANAGEMENT_STATEMENTS_OF_ACCOUNT_LABELS", e[e.REPORT_MANAGEMENT_TIME_SHEET = 89] = "REPORT_MANAGEMENT_TIME_SHEET", e[e.REPORT_MANAGEMENT_TIME_TRANSACTIONS_DOLLARS = 119] = "REPORT_MANAGEMENT_TIME_TRANSACTIONS_DOLLARS", e[e.REPORT_MANAGEMENT_TIME_TRANSACTIONS_HOURS = 118] = "REPORT_MANAGEMENT_TIME_TRANSACTIONS_HOURS", e[e.REPORT_MANAGEMENT_TIME_UTILIZATION_REPORTS_DOLLARS = 66] = "REPORT_MANAGEMENT_TIME_UTILIZATION_REPORTS_DOLLARS", e[e.REPORT_MANAGEMENT_TIME_UTILIZATION_REPORTS_HOURS = 67] = "REPORT_MANAGEMENT_TIME_UTILIZATION_REPORTS_HOURS", e[e.REPORT_MANAGEMENT_TRIAL_BALANCE_REPORTS = 65] = "REPORT_MANAGEMENT_TRIAL_BALANCE_REPORTS", e[e.REPORT_MANAGEMENT_VENDOR_LIST = 114] = "REPORT_MANAGEMENT_VENDOR_LIST", e[e.REPORT_MANAGEMENT_WORK_ORDER_REPORTS = 117] = "REPORT_MANAGEMENT_WORK_ORDER_REPORTS", e[e.SALES_JOURNAL_ALLOW_POST_CLOSING_ADJUSTMENTS = 287] = "SALES_JOURNAL_ALLOW_POST_CLOSING_ADJUSTMENTS", e[e.SALES_JOURNAL_CAN_ADD_LINKED_TRANSACTIONS = 135] = "SALES_JOURNAL_CAN_ADD_LINKED_TRANSACTIONS", e[e.SALES_JOURNAL_CAN_DELETE_LINKED_TRANSACTIONS = 136] = "SALES_JOURNAL_CAN_DELETE_LINKED_TRANSACTIONS", e[e.SALES_JOURNAL_CAN_OVERRIDE_X_RATES = 198] = "SALES_JOURNAL_CAN_OVERRIDE_X_RATES", e[e.SALES_JOURNAL_CAN_POST_UNPOSTED_TRANSACTIONS = 312] = "SALES_JOURNAL_CAN_POST_UNPOSTED_TRANSACTIONS", e[e.SALES_JOURNAL_CHANGE_KEY_FIELDS = 52] = "SALES_JOURNAL_CHANGE_KEY_FIELDS", e[e.SALES_JOURNAL_CHANGE_PERIOD = 50] = "SALES_JOURNAL_CHANGE_PERIOD", e[e.SALES_JOURNAL_CHANGE_PERIOD_ALL_VERSIONS = 303] = "SALES_JOURNAL_CHANGE_PERIOD_ALL_VERSIONS", e[e.SALES_JOURNAL_CREATE_RECURRING_ENTRIES = 107] = "SALES_JOURNAL_CREATE_RECURRING_ENTRIES", e[e.SALES_JOURNAL_SHOW_POST_UNPOSTED_TRANSACTIONS = 57] = "SALES_JOURNAL_SHOW_POST_UNPOSTED_TRANSACTIONS", e[e.TIMESHEET_ADJUSTMENTS_CAN_ACCESS_OVERRIDES = 88] = "TIMESHEET_ADJUSTMENTS_CAN_ACCESS_OVERRIDES", e[e.TIMESHEET_ADJUSTMENTS_CAN_MODIFY_ORIGINAL_TOTALS = 30] = "TIMESHEET_ADJUSTMENTS_CAN_MODIFY_ORIGINAL_TOTALS", e[e.TIMESHEET_ADJUSTMENTS_CAN_OVERRIDE_CURRENCY = 193] = "TIMESHEET_ADJUSTMENTS_CAN_OVERRIDE_CURRENCY", e[e.TIMESHEET_ADJUSTMENTS_CAN_OVERRIDE_LINKED_INVOICE = 180] = "TIMESHEET_ADJUSTMENTS_CAN_OVERRIDE_LINKED_INVOICE", e[e.TIMESHEET_ADJUSTMENTS_CAN_SEE_PAY_RATES = 87] = "TIMESHEET_ADJUSTMENTS_CAN_SEE_PAY_RATES", e[e.TIMESHEET_ADJUSTMENTS_DELETE_VERSION_1_TIMESHEETS = 91] = "TIMESHEET_ADJUSTMENTS_DELETE_VERSION_1_TIMESHEETS", e[e.AR_COLLECTIONS_CAN_OVERRIDE_PROJECT_LEADER = 141] = "AR_COLLECTIONS_CAN_OVERRIDE_PROJECT_LEADER", e[e.CLIENT_QUERIES_CAN_VIEW_PRIVATE_QUERIES = 69] = "CLIENT_QUERIES_CAN_VIEW_PRIVATE_QUERIES", e[e.CLIENT_QUERIES_IS_ADMINISTRATOR = 70] = "CLIENT_QUERIES_IS_ADMINISTRATOR", e[e.EMPLOYEE_QUERIES_CAN_VIEW_PRIVATE_QUERIES = 71] = "EMPLOYEE_QUERIES_CAN_VIEW_PRIVATE_QUERIES", e[e.EMPLOYEE_QUERIES_IS_ADMINISTRATOR = 72] = "EMPLOYEE_QUERIES_IS_ADMINISTRATOR", e[e.PROJECT_QUERIES_CAN_VIEW_PRIVATE_QUERIES = 77] = "PROJECT_QUERIES_CAN_VIEW_PRIVATE_QUERIES", e[e.PROJECT_QUERIES_IS_ADMINISTRATOR = 74] = "PROJECT_QUERIES_IS_ADMINISTRATOR", e[e.VENDOR_QUERIES_CAN_VIEW_PRIVATE_QUERIES = 73] = "VENDOR_QUERIES_CAN_VIEW_PRIVATE_QUERIES", e[e.VENDOR_QUERIES_IS_ADMINISTRATOR = 76] = "VENDOR_QUERIES_IS_ADMINISTRATOR", e[e.SQL_QUERY_CAN_PROCESS_SQL_QUERY_RESULTS_AS_ACTION = 278] = "SQL_QUERY_CAN_PROCESS_SQL_QUERY_RESULTS_AS_ACTION", e[e.SQL_QUERY_CAN_REPLACE_VARIABLES_FOR_QUERY_EXECUTION = 280] = "SQL_QUERY_CAN_REPLACE_VARIABLES_FOR_QUERY_EXECUTION", e[e.SQL_QUERY_CAN_USE_EXTERNAL_DATASOURCES = 281] = "SQL_QUERY_CAN_USE_EXTERNAL_DATASOURCES", e[e.IMPORT_TOOLS_CAN_IMPORT_DUPLICATE_DOCUMENTS = 243] = "IMPORT_TOOLS_CAN_IMPORT_DUPLICATE_DOCUMENTS", e[e.IMPORT_TOOLS_CAN_IMPORT_INTO_CLOSED_GL_PERIODS = 163] = "IMPORT_TOOLS_CAN_IMPORT_INTO_CLOSED_GL_PERIODS", e[e.BANK_RECONCILIATION_CAN_MODIFY_RECONCILED_STATEMENTS = 123] = "BANK_RECONCILIATION_CAN_MODIFY_RECONCILED_STATEMENTS", e[e.RATE_TESTER_VIEW_PAY_RATES = 124] = "RATE_TESTER_VIEW_PAY_RATES", e[e.DASHBOARD_GROUPS_CAN_SAVE_DEFAULT_LAYOUT = 276] = "DASHBOARD_GROUPS_CAN_SAVE_DEFAULT_LAYOUT", e[e.INVOICE_POSTING_GROUPS_CAN_VIEW_PRIVATE_QUERIES = 173] = "INVOICE_POSTING_GROUPS_CAN_VIEW_PRIVATE_QUERIES", e[e.INVOICE_POSTING_GROUPS_IS_ADMINISTRATOR = 174] = "INVOICE_POSTING_GROUPS_IS_ADMINISTRATOR", e[e.FIRM_QUERIES_IS_ADMINISTRATOR = 185] = "FIRM_QUERIES_IS_ADMINISTRATOR", e[e.OPPORTUNITY_QUERIES_IS_ADMINISTRATOR = 186] = "OPPORTUNITY_QUERIES_IS_ADMINISTRATOR", e[e.CONTACT_QUERIES_IS_ADMINISTRATOR = 187] = "CONTACT_QUERIES_IS_ADMINISTRATOR", e[e.PROJECT_CENTRAL_ADDRESSES_CAN_MODIFY = 239] = "PROJECT_CENTRAL_ADDRESSES_CAN_MODIFY", e[e.PROJECT_CENTRAL_BILL_REVIEW_CAN_CHANGE_BILL_STATUS = 231] = "PROJECT_CENTRAL_BILL_REVIEW_CAN_CHANGE_BILL_STATUS", e[e.PROJECT_CENTRAL_BILL_REVIEW_CAN_MOVE_TRANSACTIONS = 232] = "PROJECT_CENTRAL_BILL_REVIEW_CAN_MOVE_TRANSACTIONS", e[e.PROJECT_CENTRAL_BUDGET_SAVE_AS_BASELINE = 240] = "PROJECT_CENTRAL_BUDGET_SAVE_AS_BASELINE", e[e.PROJECT_CENTRAL_CAN_MANAGE_FIELDS_FORMULAS = 275] = "PROJECT_CENTRAL_CAN_MANAGE_FIELDS_FORMULAS", e[e.PROJECT_CENTRAL_CAN_MODIFY_INFO_TEMPLATE = 329] = "PROJECT_CENTRAL_CAN_MODIFY_INFO_TEMPLATE", e[e.PROJECT_CENTRAL_CAN_USE_SYSTEM_CHART_PACKS = 290] = "PROJECT_CENTRAL_CAN_USE_SYSTEM_CHART_PACKS", e[e.PROJECT_CENTRAL_CONTACTS_CAN_MODIFY = 238] = "PROJECT_CENTRAL_CONTACTS_CAN_MODIFY", e[e.PROJECT_CENTRAL_CONTRACT_CAN_SET_AMOUNT = 233] = "PROJECT_CENTRAL_CONTRACT_CAN_SET_AMOUNT", e[e.PROJECT_CENTRAL_CONTRACT_CAN_SET_CONTRACT_BUDGET = 234] = "PROJECT_CENTRAL_CONTRACT_CAN_SET_CONTRACT_BUDGET", e[e.PROJECT_CENTRAL_CONTRACT_CAN_SET_LEVEL = 235] = "PROJECT_CENTRAL_CONTRACT_CAN_SET_LEVEL", e[e.PROJECT_CENTRAL_CONTRACT_CAN_SET_PERCENT_COMPLETE = 236] = "PROJECT_CENTRAL_CONTRACT_CAN_SET_PERCENT_COMPLETE", e[e.PROJECT_CENTRAL_TEAM_MEMBERS_CAN_MODIFY = 237] = "PROJECT_CENTRAL_TEAM_MEMBERS_CAN_MODIFY", e[e.PURCHASE_ORDERS_CAN_CANCEL_A_PURCHASE_ORDER = 294] = "PURCHASE_ORDERS_CAN_CANCEL_A_PURCHASE_ORDER", e[e.PURCHASE_ORDERS_CAN_CREATE_PURCHASE_JOURNAL = 305] = "PURCHASE_ORDERS_CAN_CREATE_PURCHASE_JOURNAL", e[e.PURCHASE_ORDERS_CAN_EDIT_AFTER_ISSUED = 295] = "PURCHASE_ORDERS_CAN_EDIT_AFTER_ISSUED", e[e.PURCHASE_ORDERS_CAN_ISSUE_PURCHASE_ORDER = 325] = "PURCHASE_ORDERS_CAN_ISSUE_PURCHASE_ORDER", e[e.PURCHASE_ORDERS_CAN_OVERRIDE_X_RATES = 324] = "PURCHASE_ORDERS_CAN_OVERRIDE_X_RATES", e[e.PURCHASE_ORDERS_CAN_SET_NOT_RECEIVED = 323] = "PURCHASE_ORDERS_CAN_SET_NOT_RECEIVED", e[e.PURCHASE_ORDERS_CAN_SET_RECEIVED = 322] = "PURCHASE_ORDERS_CAN_SET_RECEIVED", e[e.PURCHASE_ORDERS_CHANGE_KEY_FIELDS = 296] = "PURCHASE_ORDERS_CHANGE_KEY_FIELDS", e[e.PURCHASE_ORDERS_EDIT_GRID = 304] = "PURCHASE_ORDERS_EDIT_GRID", e[e.PURCHASE_ORDER_MANAGEMENT_CAN_CREATE_PURCHASE_JOURNAL = 319] = "PURCHASE_ORDER_MANAGEMENT_CAN_CREATE_PURCHASE_JOURNAL", e[e.PURCHASE_ORDER_MANAGEMENT_CAN_ISSUE_PURCHASE_ORDER = 318] = "PURCHASE_ORDER_MANAGEMENT_CAN_ISSUE_PURCHASE_ORDER", e[e.PURCHASE_ORDER_MANAGEMENT_CAN_SET_NOT_RECEIVED = 320] = "PURCHASE_ORDER_MANAGEMENT_CAN_SET_NOT_RECEIVED", e[e.PURCHASE_ORDER_MANAGEMENT_CAN_SET_RECEIVED = 321] = "PURCHASE_ORDER_MANAGEMENT_CAN_SET_RECEIVED", e[e.RECEIPT_OF_GOODS_CAN_SET_NOT_RECEIVED = 306] = "RECEIPT_OF_GOODS_CAN_SET_NOT_RECEIVED", e[e.MY_PURCHASE_ORDERS_CAN_CREATE_PURCHASE_JOURNAL = 316] = "MY_PURCHASE_ORDERS_CAN_CREATE_PURCHASE_JOURNAL", e[e.MY_PURCHASE_ORDERS_CAN_ISSUE_PURCHASE_ORDER = 317] = "MY_PURCHASE_ORDERS_CAN_ISSUE_PURCHASE_ORDER", e[e.MY_PURCHASE_ORDERS_CAN_SET_NOT_RECEIVED = 314] = "MY_PURCHASE_ORDERS_CAN_SET_NOT_RECEIVED", e[e.MY_PURCHASE_ORDERS_CAN_SET_RECEIVED = 315] = "MY_PURCHASE_ORDERS_CAN_SET_RECEIVED", e[e.APPROVER_CAN_FORCE_APPROVE = 1342] = "APPROVER_CAN_FORCE_APPROVE", e[e.APPROVER_CAN_FORCE_REJECT = 1341] = "APPROVER_CAN_FORCE_REJECT", e[e.APPROVER_CAN_FORCE_SUBMIT = 1340] = "APPROVER_CAN_FORCE_SUBMIT", e[e.FLAGS_MAKE_FLAGS_PUBLIC = 1356] = "FLAGS_MAKE_FLAGS_PUBLIC";
    })(t16.SpecialRightEnum || (t16.SpecialRightEnum = {}));
  })(wK)), wK;
}
var BK = {}, tke;
function tH0() {
  return tke || (tke = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ModuleEnum = void 0, (function(e) {
      e[e.ACCOUNTS_PAYABLE = 1] = "ACCOUNTS_PAYABLE", e[e.ACCOUNTS_RECEIVABLE = 2] = "ACCOUNTS_RECEIVABLE", e[e.PROJECT_ADMINISTRATION = 3] = "PROJECT_ADMINISTRATION", e[e.PROJECT_MANAGEMENT = 14] = "PROJECT_MANAGEMENT", e[e.HUMAN_RESOURCES = 4] = "HUMAN_RESOURCES", e[e.PURCHASING = 15] = "PURCHASING", e[e.PERSONAL = 5] = "PERSONAL", e[e.GENERAL_ACCOUNTING = 6] = "GENERAL_ACCOUNTING", e[e.PROSPECT_MANAGEMENT = 7] = "PROSPECT_MANAGEMENT", e[e.UTILITIES = 8] = "UTILITIES", e[e.ADMINISTRATION = 9] = "ADMINISTRATION";
    })(t16.ModuleEnum || (t16.ModuleEnum = {}));
  })(BK)), BK;
}
var xK = {}, rke;
function rH0() {
  return rke || (rke = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.ModuleCodeEnum = void 0, (function(e) {
      e.ACCOUNTS_PAYABLE = "AP", e.ACCOUNTS_RECEIVABLE = "AR", e.PROJECT_ADMINISTRATION = "PA", e.PROJECT_MANAGEMENT = "PM", e.HUMAN_RESOURCES = "HR", e.PURCHASING = "PO", e.PERSONAL = "PE", e.GENERAL_ACCOUNTING = "GA", e.PROSPECT_MANAGEMENT = "PS", e.UTILITIES = "UT", e.ADMINISTRATION = "AD";
    })(t16.ModuleCodeEnum || (t16.ModuleCodeEnum = {}));
  })(xK)), xK;
}
var UK = {}, nke;
function nH0() {
  return nke || (nke = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.InFocusEventEnum = void 0, (function(e) {
      e[e.LOGIN_DESKTOP = 1] = "LOGIN_DESKTOP", e[e.LOGIN_MOBILE = 2] = "LOGIN_MOBILE", e[e.LOGOUT_DESKTOP = 3] = "LOGOUT_DESKTOP", e[e.LOGOUT_MOBILE = 4] = "LOGOUT_MOBILE", e[e.DISBURSEMENT_CREATED = 5] = "DISBURSEMENT_CREATED", e[e.DISBURSEMENT_SAVED = 6] = "DISBURSEMENT_SAVED", e[e.PURCHASE_CREATED = 7] = "PURCHASE_CREATED", e[e.PURCHASE_SAVED = 9] = "PURCHASE_SAVED", e[e.DISBURSEMENT_DELETED = 10] = "DISBURSEMENT_DELETED", e[e.PURCHASE_DELETED = 11] = "PURCHASE_DELETED", e[e.DISBURSEMENT_VOIDED = 12] = "DISBURSEMENT_VOIDED", e[e.PURCHASE_VOIDED = 13] = "PURCHASE_VOIDED", e[e.EMPLOYEE_REIMBURSABLE_CREATED = 14] = "EMPLOYEE_REIMBURSABLE_CREATED", e[e.EMPLOYEE_REIMBURSABLE_SAVED = 15] = "EMPLOYEE_REIMBURSABLE_SAVED", e[e.EMPLOYEE_REIMBURSABLE_DELETED = 16] = "EMPLOYEE_REIMBURSABLE_DELETED", e[e.EMPLOYEE_REIMBURSABLE_VOIDED = 17] = "EMPLOYEE_REIMBURSABLE_VOIDED", e[e.VENDOR_CREATED = 18] = "VENDOR_CREATED", e[e.VENDOR_SAVED = 19] = "VENDOR_SAVED", e[e.VENDOR_DELETED = 20] = "VENDOR_DELETED", e[e.INVOICE_POSTED = 21] = "INVOICE_POSTED", e[e.CLIENT_CREATED = 22] = "CLIENT_CREATED", e[e.CLIENT_SAVED = 23] = "CLIENT_SAVED", e[e.CLIENT_DELETED = 24] = "CLIENT_DELETED", e[e.CLIENT_DEACTIVATED = 25] = "CLIENT_DEACTIVATED", e[e.VENDOR_ACTIVATED = 26] = "VENDOR_ACTIVATED", e[e.VENDOR_DEACTIVATED = 27] = "VENDOR_DEACTIVATED", e[e.CLIENT_ACTIVATED = 28] = "CLIENT_ACTIVATED", e[e.PROJECT_CREATED = 29] = "PROJECT_CREATED", e[e.PROJECT_SAVED = 30] = "PROJECT_SAVED", e[e.PROJECT_DEACTIVATED = 31] = "PROJECT_DEACTIVATED", e[e.PROJECT_ACTIVATED = 32] = "PROJECT_ACTIVATED", e[e.PROJECT_DELETED = 33] = "PROJECT_DELETED", e[e.EMPLOYEE_CREATED = 34] = "EMPLOYEE_CREATED", e[e.EMPLOYEE_SAVED = 35] = "EMPLOYEE_SAVED", e[e.EMPLOYEE_DELETED = 36] = "EMPLOYEE_DELETED", e[e.EMPLOYEE_ACTIVATED = 37] = "EMPLOYEE_ACTIVATED", e[e.EMPLOYEE_DEACTIVATED = 38] = "EMPLOYEE_DEACTIVATED", e[e.TIME_SHEET_SAVED = 39] = "TIME_SHEET_SAVED", e[e.TIME_SHEET_SUBMITTED = 40] = "TIME_SHEET_SUBMITTED", e[e.TIME_SHEET_REJECTED = 41] = "TIME_SHEET_REJECTED", e[e.TIME_SHEET_APPROVED = 42] = "TIME_SHEET_APPROVED", e[e.EXPENSE_SHEET_CREATED = 43] = "EXPENSE_SHEET_CREATED", e[e.EXPENSE_SHEET_SAVED = 44] = "EXPENSE_SHEET_SAVED", e[e.EXPENSE_SHEET_DELETED = 45] = "EXPENSE_SHEET_DELETED", e[e.EXPENSE_SHEET_SUBMITTED = 46] = "EXPENSE_SHEET_SUBMITTED", e[e.EXPENSE_SHEET_REJECTED = 47] = "EXPENSE_SHEET_REJECTED", e[e.EXPENSE_SHEET_APPROVED = 48] = "EXPENSE_SHEET_APPROVED", e[e.SALE_CREATED = 49] = "SALE_CREATED", e[e.SALE_DELETED = 50] = "SALE_DELETED", e[e.SALE_VOIDED = 51] = "SALE_VOIDED", e[e.SALE_SAVED = 52] = "SALE_SAVED", e[e.RECEIPT_CREATED = 53] = "RECEIPT_CREATED", e[e.RECEIPT_DELETED = 54] = "RECEIPT_DELETED", e[e.RECEIPT_VOIDED = 55] = "RECEIPT_VOIDED", e[e.RECEIPT_SAVED = 56] = "RECEIPT_SAVED", e[e.ADJUSTMENT_CREATED = 57] = "ADJUSTMENT_CREATED", e[e.ADJUSTMENT_DELETED = 58] = "ADJUSTMENT_DELETED", e[e.ADJUSTMENT_VOIDED = 59] = "ADJUSTMENT_VOIDED", e[e.ADJUSTMENT_SAVED = 60] = "ADJUSTMENT_SAVED", e[e.GL_ACCOUNT_CREATED = 61] = "GL_ACCOUNT_CREATED", e[e.GL_ACCOUNT_DELETED = 62] = "GL_ACCOUNT_DELETED", e[e.GL_ACCOUNT_SAVED = 63] = "GL_ACCOUNT_SAVED", e[e.GL_ACCOUNT_DEACTIVATED = 64] = "GL_ACCOUNT_DEACTIVATED", e[e.GL_ACCOUNT_ACTIVATED = 65] = "GL_ACCOUNT_ACTIVATED", e[e.PROJECT_PM_REVIEWED = 66] = "PROJECT_PM_REVIEWED", e[e.PROJECT_PA_REVIEWED = 67] = "PROJECT_PA_REVIEWED", e[e.PROJECT_DO_NOT_BILL = 68] = "PROJECT_DO_NOT_BILL", e[e.GL_PERIOD_CHANGING = 69] = "GL_PERIOD_CHANGING", e[e.INVOICING_PERIOD_CHANGING = 70] = "INVOICING_PERIOD_CHANGING", e[e.GL_PERIOD_OPENING = 71] = "GL_PERIOD_OPENING", e[e.GL_PERIOD_CLOSING = 72] = "GL_PERIOD_CLOSING", e[e.TIME_SHEET_UNAPPROVED = 73] = "TIME_SHEET_UNAPPROVED", e[e.TIME_SHEET_UNSUBMITTED = 74] = "TIME_SHEET_UNSUBMITTED", e[e.ORG_UNIT_CREATED = 75] = "ORG_UNIT_CREATED", e[e.ORG_UNIT_DELETED = 76] = "ORG_UNIT_DELETED", e[e.ORG_UNIT_SAVED = 77] = "ORG_UNIT_SAVED", e[e.ORG_UNIT_DEACTIVATED = 78] = "ORG_UNIT_DEACTIVATED", e[e.ORG_UNIT_ACTIVATED = 79] = "ORG_UNIT_ACTIVATED", e[e.CURRENCY_RECALCULATION = 80] = "CURRENCY_RECALCULATION", e[e.ACTIVITY_CREATED = 82] = "ACTIVITY_CREATED", e[e.ACTIVITY_DELETED = 83] = "ACTIVITY_DELETED", e[e.ACTIVITY_CHANGED = 84] = "ACTIVITY_CHANGED", e[e.ACTIVITY_COMPLETED = 85] = "ACTIVITY_COMPLETED", e[e.CONTACT_CREATED = 86] = "CONTACT_CREATED", e[e.CONTACT_SAVED = 87] = "CONTACT_SAVED", e[e.CONTACT_DELETED = 88] = "CONTACT_DELETED", e[e.FIRM_CREATED = 89] = "FIRM_CREATED", e[e.FIRM_SAVED = 90] = "FIRM_SAVED", e[e.FIRM_DELETED = 91] = "FIRM_DELETED", e[e.FIRM_ACTIVATED = 92] = "FIRM_ACTIVATED", e[e.FIRM_DEACTIVATED = 93] = "FIRM_DEACTIVATED", e[e.OPPORTUNITY_CREATED = 94] = "OPPORTUNITY_CREATED", e[e.OPPORTUNITY_SAVED = 95] = "OPPORTUNITY_SAVED", e[e.OPPORTUNITY_DELETED = 96] = "OPPORTUNITY_DELETED", e[e.OPPORTUNITY_ACTIVATED = 97] = "OPPORTUNITY_ACTIVATED", e[e.OPPORTUNITY_DEACTIVATED = 98] = "OPPORTUNITY_DEACTIVATED", e[e.USER_CREATED = 99] = "USER_CREATED", e[e.USER_SAVED = 100] = "USER_SAVED", e[e.USER_DELETED = 101] = "USER_DELETED", e[e.GROUP_CREATED = 102] = "GROUP_CREATED", e[e.GROUP_SAVED = 103] = "GROUP_SAVED", e[e.GROUP_DELETED = 104] = "GROUP_DELETED", e[e.TIME_SHEET_ADJUSTED = 105] = "TIME_SHEET_ADJUSTED", e[e.DOCUMENT_UPLOADED = 106] = "DOCUMENT_UPLOADED", e[e.PURCHASE_ORDER_CREATED = 135] = "PURCHASE_ORDER_CREATED", e[e.PURCHASE_ORDER_SAVED = 136] = "PURCHASE_ORDER_SAVED", e[e.PURCHASE_ORDER_DELETED = 137] = "PURCHASE_ORDER_DELETED", e[e.PURCHASE_ORDER_SUBMITTED = 138] = "PURCHASE_ORDER_SUBMITTED", e[e.PURCHASE_ORDER_APPROVE_ALL = 139] = "PURCHASE_ORDER_APPROVE_ALL", e[e.PURCHASE_ORDER_REJECT_ALL = 140] = "PURCHASE_ORDER_REJECT_ALL", e[e.PURCHASE_ORDER_ISSUED = 141] = "PURCHASE_ORDER_ISSUED", e[e.PURCHASE_ORDER_CONVERT_TO_PJ = 142] = "PURCHASE_ORDER_CONVERT_TO_PJ", e[e.PO_MANAGEMENT_APPROVE = 143] = "PO_MANAGEMENT_APPROVE", e[e.PO_MANAGEMENT_REJECT = 144] = "PO_MANAGEMENT_REJECT", e[e.PO_MANAGEMENT_ISSUE = 145] = "PO_MANAGEMENT_ISSUE", e[e.PO_MANAGEMENT_RECEIVE = 146] = "PO_MANAGEMENT_RECEIVE", e[e.PO_MANAGEMENT_NOT_RECEIVE = 147] = "PO_MANAGEMENT_NOT_RECEIVE", e[e.PO_MANAGEMENT_CONVERT_TO_PJ = 148] = "PO_MANAGEMENT_CONVERT_TO_PJ", e[e.MY_PO_APPROVE = 149] = "MY_PO_APPROVE", e[e.MY_PO_REJECT = 150] = "MY_PO_REJECT", e[e.MY_PO_ISSUE = 151] = "MY_PO_ISSUE", e[e.MY_PO_RECEIVE = 152] = "MY_PO_RECEIVE", e[e.MY_PO_NOT_RECEIVE = 153] = "MY_PO_NOT_RECEIVE", e[e.MY_PO_CONVERT_TO_PJ = 154] = "MY_PO_CONVERT_TO_PJ", e[e.RECEIPT_OF_GOODS_RECEIVE = 155] = "RECEIPT_OF_GOODS_RECEIVE", e[e.RECEIPT_OF_GOODS_NOT_RECEIVE = 156] = "RECEIPT_OF_GOODS_NOT_RECEIVE", e[e.PURCHASE_PO_CONVERT_TO_PJ = 157] = "PURCHASE_PO_CONVERT_TO_PJ", e[e.PURCHASE_NEW_FOR_PO = 158] = "PURCHASE_NEW_FOR_PO", e[e.PURCHASE_LINK_PO = 159] = "PURCHASE_LINK_PO", e[e.PURCHASE_ADD_FROM_PO = 160] = "PURCHASE_ADD_FROM_PO", e[e.DISBURSEMENT_BATCH_POSTED = 161] = "DISBURSEMENT_BATCH_POSTED", e[e.EMPLOYEE_REIMBURSABLE_BATCH_POSTED = 162] = "EMPLOYEE_REIMBURSABLE_BATCH_POSTED", e[e.PURCHASE_BATCH_POSTED = 163] = "PURCHASE_BATCH_POSTED", e[e.RECEIPT_BATCH_POSTED = 164] = "RECEIPT_BATCH_POSTED", e[e.SALE_BATCH_POSTED = 165] = "SALE_BATCH_POSTED", e[e.PROJECT_BASELINE_CHANGED = 166] = "PROJECT_BASELINE_CHANGED", e[e.WORK_ORDER_CREATED = 167] = "WORK_ORDER_CREATED", e[e.WORK_ORDER_SAVED = 168] = "WORK_ORDER_SAVED", e[e.WORK_ORDER_DELETED = 169] = "WORK_ORDER_DELETED", e[e.WORK_ORDER_COMPLETED = 170] = "WORK_ORDER_COMPLETED", e[e.WORK_ORDER_STAGE_CHANGED = 171] = "WORK_ORDER_STAGE_CHANGED", e[e.WORK_ORDER_COMMENT_ADDED = 172] = "WORK_ORDER_COMMENT_ADDED";
    })(t16.InFocusEventEnum || (t16.InFocusEventEnum = {}));
  })(UK)), UK;
}
var kK = {}, ake;
function aH0() {
  return ake || (ake = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.InFocusEventCodeEnum = void 0, (function(e) {
      e.LOGIN_DESKTOP = "login-desktop", e.LOGIN_MOBILE = "login-mobile", e.LOGOUT_DESKTOP = "logout-desktop", e.LOGOUT_MOBILE = "logout-mobile", e.DISBURSEMENT_CREATED = "disbursement-created", e.DISBURSEMENT_SAVED = "disbursement-saved", e.PURCHASE_CREATED = "purchase-created", e.PURCHASE_SAVED = "purchase-saved", e.DISBURSEMENT_DELETED = "disbursement-deleted", e.PURCHASE_DELETED = "purchase-deleted", e.DISBURSEMENT_VOIDED = "disbursement-voided", e.PURCHASE_VOIDED = "purchase-voided", e.EMPLOYEE_REIMBURSABLE_CREATED = "empreim-created", e.EMPLOYEE_REIMBURSABLE_SAVED = "empreim-saved", e.EMPLOYEE_REIMBURSABLE_DELETED = "empreim-deleted", e.EMPLOYEE_REIMBURSABLE_VOIDED = "empreim-voided", e.VENDOR_CREATED = "vendor-created", e.VENDOR_SAVED = "vendor-saved", e.VENDOR_DELETED = "vendor-deleted", e.INVOICE_POSTED = "autoinv-posted", e.CLIENT_CREATED = "client-created", e.CLIENT_SAVED = "client-saved", e.CLIENT_DELETED = "client-deleted", e.CLIENT_DEACTIVATED = "client-deactivated", e.VENDOR_ACTIVATED = "vendor-activated", e.VENDOR_DEACTIVATED = "vendor-deactivated", e.CLIENT_ACTIVATED = "client-activated", e.PROJECT_CREATED = "project-created", e.PROJECT_SAVED = "project-saved", e.PROJECT_DEACTIVATED = "project-deactivated", e.PROJECT_ACTIVATED = "project-activated", e.PROJECT_DELETED = "project-deleted", e.EMPLOYEE_CREATED = "employee-created", e.EMPLOYEE_SAVED = "employee-saved", e.EMPLOYEE_DELETED = "employee-deleted", e.EMPLOYEE_ACTIVATED = "employee-activated", e.EMPLOYEE_DEACTIVATED = "employee-deactivated", e.TIME_SHEET_SAVED = "timesheet-saved", e.TIME_SHEET_SUBMITTED = "timesheet-submitted", e.TIME_SHEET_REJECTED = "timesheet-rejected", e.TIME_SHEET_APPROVED = "timesheet-approved", e.EXPENSE_SHEET_CREATED = "expensesheet-created", e.EXPENSE_SHEET_SAVED = "expensesheet-saved", e.EXPENSE_SHEET_DELETED = "expensesheet-deleted", e.EXPENSE_SHEET_SUBMITTED = "expensesheet-submitted", e.EXPENSE_SHEET_REJECTED = "expensesheet-rejected", e.EXPENSE_SHEET_APPROVED = "expensesheet-approved", e.SALE_CREATED = "sale-created", e.SALE_DELETED = "sale-deleted", e.SALE_VOIDED = "sale-voided", e.SALE_SAVED = "sale-saved", e.RECEIPT_CREATED = "receipt-created", e.RECEIPT_DELETED = "receipt-deleted", e.RECEIPT_VOIDED = "receipt-voided", e.RECEIPT_SAVED = "receipt-saved", e.ADJUSTMENT_CREATED = "adjustment-created", e.ADJUSTMENT_DELETED = "adjustment-deleted", e.ADJUSTMENT_VOIDED = "adjustment-voided", e.ADJUSTMENT_SAVED = "adjustment-saved", e.GL_ACCOUNT_CREATED = "coa-created", e.GL_ACCOUNT_DELETED = "coa-deleted", e.GL_ACCOUNT_SAVED = "coa-saved", e.GL_ACCOUNT_DEACTIVATED = "coa-deactivated", e.GL_ACCOUNT_ACTIVATED = "coa-activated", e.PROJECT_PM_REVIEWED = "projectpm-reviewed", e.PROJECT_PA_REVIEWED = "projectpa-reviewed", e.PROJECT_DO_NOT_BILL = "project-dnb", e.GL_PERIOD_CHANGING = "glperiod-changing", e.INVOICING_PERIOD_CHANGING = "invperiod-changing", e.GL_PERIOD_OPENING = "period-opening", e.GL_PERIOD_CLOSING = "period-closing", e.TIME_SHEET_UNAPPROVED = "timesheet-unapproved", e.TIME_SHEET_UNSUBMITTED = "timesheet-unsubmitted", e.ORG_UNIT_CREATED = "orgunit-created", e.ORG_UNIT_DELETED = "orgunit-deleted", e.ORG_UNIT_SAVED = "orgunit-saved", e.ORG_UNIT_DEACTIVATED = "orgunit-deactivated", e.ORG_UNIT_ACTIVATED = "orgunit-activated", e.CURRENCY_RECALCULATION = "mx-recalc", e.ACTIVITY_CREATED = "activity-created", e.ACTIVITY_DELETED = "activity-deletetd", e.ACTIVITY_CHANGED = "activity-changed", e.ACTIVITY_COMPLETED = "activity-completed", e.CONTACT_CREATED = "contact-created", e.CONTACT_SAVED = "contact-saved", e.CONTACT_DELETED = "contact-deleted", e.FIRM_CREATED = "firm-created", e.FIRM_SAVED = "firm-saved", e.FIRM_DELETED = "firm-deleted", e.FIRM_ACTIVATED = "firm-activated", e.FIRM_DEACTIVATED = "firm-deactivated", e.OPPORTUNITY_CREATED = "opportunity-created", e.OPPORTUNITY_SAVED = "opportunity-saved", e.OPPORTUNITY_DELETED = "opportunity-deleted", e.OPPORTUNITY_ACTIVATED = "opportunity-activated", e.OPPORTUNITY_DEACTIVATED = "opportunity-deactivated", e.USER_CREATED = "user-created", e.USER_SAVED = "user-saved", e.USER_DELETED = "user-deleted", e.GROUP_CREATED = "group-created", e.GROUP_SAVED = "group-saved", e.GROUP_DELETED = "group-deleted", e.TIME_SHEET_ADJUSTED = "timesheet-adjusted", e.DOCUMENT_UPLOADED = "document-uploaded", e.PURCHASE_ORDER_CREATED = "purchaseorder-created", e.PURCHASE_ORDER_SAVED = "purchaseorder-saved", e.PURCHASE_ORDER_DELETED = "purchaseorder-deleted", e.PURCHASE_ORDER_SUBMITTED = "purchaseorder-submitted", e.PURCHASE_ORDER_APPROVE_ALL = "purchaseorder-approveall", e.PURCHASE_ORDER_REJECT_ALL = "purchaseorder-rejectall", e.PURCHASE_ORDER_ISSUED = "purchaseorder-issued", e.PURCHASE_ORDER_CONVERT_TO_PJ = "purchaseorder-converttopj", e.PO_MANAGEMENT_APPROVE = "pomanagement-approve", e.PO_MANAGEMENT_REJECT = "pomanagement-reject", e.PO_MANAGEMENT_ISSUE = "pomanagement-issue", e.PO_MANAGEMENT_RECEIVE = "pomanagement-receive", e.PO_MANAGEMENT_NOT_RECEIVE = "pomanagement-notreceive", e.PO_MANAGEMENT_CONVERT_TO_PJ = "pomanagement-converttopj", e.MY_PO_APPROVE = "mypo-approve", e.MY_PO_REJECT = "mypo-reject", e.MY_PO_ISSUE = "mypo-issue", e.MY_PO_RECEIVE = "mypo-receive", e.MY_PO_NOT_RECEIVE = "mypo-notreceive", e.MY_PO_CONVERT_TO_PJ = "mypo-converttopj", e.RECEIPT_OF_GOODS_RECEIVE = "receiptofgoods-receive", e.RECEIPT_OF_GOODS_NOT_RECEIVE = "receiptofgoods-notreceive", e.PURCHASE_PO_CONVERT_TO_PJ = "purchase-poconverttopj", e.PURCHASE_NEW_FOR_PO = "purchase-newforpo", e.PURCHASE_LINK_PO = "purchase-linkpo", e.PURCHASE_ADD_FROM_PO = "purchase-addfrompo", e.DISBURSEMENT_BATCH_POSTED = "dj-batch-posted", e.EMPLOYEE_REIMBURSABLE_BATCH_POSTED = "er-batch-posted", e.PURCHASE_BATCH_POSTED = "pj-batch-posted", e.RECEIPT_BATCH_POSTED = "rj-batch-posted", e.SALE_BATCH_POSTED = "sj-batch-posted", e.PROJECT_BASELINE_CHANGED = "project-baseline", e.WORK_ORDER_CREATED = "workorder-created", e.WORK_ORDER_SAVED = "workorder-saved", e.WORK_ORDER_DELETED = "workorder-deleted", e.WORK_ORDER_COMPLETED = "workorder-completed", e.WORK_ORDER_STAGE_CHANGED = "workorder-stage-changed", e.WORK_ORDER_COMMENT_ADDED = "workorder-comment";
    })(t16.InFocusEventCodeEnum || (t16.InFocusEventCodeEnum = {}));
  })(kK)), kK;
}
var jK = {}, oke;
function oH0() {
  return oke || (oke = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.UserSettingFormEnum = void 0, (function(e) {
      e.AP_CHECK_WRITING = "A/P Check Writing", e.ACTIVITIES = "activities", e.ANALYTIC_DASHBOARDS = "Analytic Dashboards", e.API_MANAGEMENT = "API Management", e.APPROVER = "Approver", e.CLIENTS = "clients", e.CONTACTS = "contacts", e.CREDIT_CARD_CASH_POSTING = "Credit Card Cash Posting", e.CREDIT_CARD_RECONCILIATION = "Credit Card Reconciliation", e.CUSTOM_REPORTS = "Custom Reports", e.DASHBOARD = "Dashboard", e.DASHBOARD_GROUPS = "Dashboard Groups", e.DASHBOARD_QUERIES_MANAGER = "Dashboard Queries Manager", e.DATABASE_BACKUPS = "Database Backups", e.DISBURSEMENT_JOURNAL = "Disbursement Journal", e.DOCUMENT_SETTINGS = "DocumentSettings", e.ER_CHECK_WRITING = "E/R Check Writing", e.EFT_FILE = "eft file", e.EMPLOYEE_REIMBURSABLES = "Employee Reimbursables", e.EMPLOYEES = "employees", e.EVENT_MANAGER = "Event Manager", e.FIRMS = "firms", e.FRM_CONVERT_TO_PURCHASE_JOURNAL = "frmConvertToPurchaseJournal", e.FRM_PROJECT_PLANNING = "frmProjectPlanning", e.FRM_PURCHASE_ORDER_TRANSMIT = "frmPurchaseOrderTransmit", e.GENERAL_JOURNAL = "General Journal", e.GLOBAL_SETTINGS = "GlobalSettings", e.IN_FOCUS_JOBS = "InFocus Jobs", e.INVOICE_DESIGN = "Invoice Design", e.ITEM_SCRIPTER = "Item Scripter", e.ITEMS = "Items", e.LABOR_CODE_GROUPS = "labor code groups", e.MAIN = "Main", e.MAP_VIEWER = "Map Viewer", e.MARKETING_LISTS = "marketing lists", e.MESSAGES_MANAGER = "Messages Manager", e.NOTES = "notes", e.OPPORTUNITIES = "Opportunities", e.ORGANIZATIONAL_UNITS = "organizational units", e.PA_BILL_REVIEW = "pa bill review", e.PM_BILL_REVIEW = "pm bill review", e.PROJECT_CENTRAL = "Project Central", e.PROJECTS = "projects", e.P_U_FRM_ARCHIVE_P_U = "PU-frmArchivePU", e.P_U_FRM_E_V_M = "PU-frmEVM", e.P_U_FRM_E_V_M_V2 = "PU-frmEVMV2", e.P_U_FRM_GRID_VIEW = "PU-frmGridView", e.P_U_FRM_PLANNING_GANTT_V2 = "PU-frmPlanningGanttV2", e.P_U_FRM_P_U_LABOR_CODES = "PU-frmPULaborCodes", e.P_U_FRM_P_U_REV_REC = "PU-frmPURevRec", e.P_U_FRM_R_J_WIZARD = "PU-frmRJWizard", e.P_U_FRM_T_S_RECENT_PROJECTS = "PU-frmTSRecentProjects", e.PURCHASE_JOURNAL = "purchase journal", e.QUERY_BUILDER = "Query Builder", e.RECEIPT_JOURNAL = "Receipt Journal", e.RESOURCE_PROJECTIONS = "Resource Projections", e.RESOURCE_SCHEDULER = "Resource Scheduler", e.SALES_JOURNAL = "Sales Journal", e.TIME_SHEETS = "time sheets", e.TIMESHEET_ADJUSTMENTS = "Timesheet Adjustments", e.USER_SESSIONS = "User Sessions", e.VENDORS = "vendors", e.WORK_ORDERS = "Work Orders";
    })(t16.UserSettingFormEnum || (t16.UserSettingFormEnum = {}));
  })(jK)), jK;
}
var FK = {}, ike;
function iH0() {
  return ike || (ike = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.UserSettingNameEnum = void 0, (function(e) {
      e.ACTIVESTATUS = "activestatus", e.ALLOCPANELHEIGHT = "allocpanelheight", e.ALLOCSPLITCOL = "allocsplitcol", e.ALLOWNEGATIVECHECKS = "allownegativechecks", e.APGLID = "apglid", e.ARGLID = "arglid", e.AUTOBALANCE = "autobalance", e.BACKUPID = "backupid", e.BACKUPNAME = "backupname", e.BACKUPOVERRIDE = "backupoverride", e.BACKUPPASSWORD = "backuppassword", e.BACKUPPATH = "backuppath", e.BANKGLID = "bankglid", e.CHARGECOLS = "chargecols", e.CHARGETYPES = "chargetypes", e.CLEARINGGLID = "clearingglid", e.CODE_FIRST = "CodeFirst", e.DATEVIEW = "dateview", e.DAYS = "days", e.DTSTART = "dtstart", e.EMPID = "empid", e.ENDDATE = "enddate", e.ERGLID = "erglid", e.EVMBYDATES = "evmbydates", e.EVMWIDTH = "evmwidth", e.EXPORTSETTINGS = "exportsettings", e.FILTER_1 = "filter_1", e.GLACCTPATH = "glacctpath", e.GLPERIOD = "glperiod", e.GRIDWIDTH = "gridwidth", e.GROUPDETAIL = "groupdetail", e.HASFF = "hasff", e.HASWIP = "haswip", e.HEIGHT = "height", e.HOURSORDOLLARS = "hoursordollars", e.INCMINE = "incmine", e.INCPUBLIC = "incpublic", e.ISACTIVE = "isactive", e.ISMAXED = "ismaxed", e.JTFILTER = "jtfilter", e.LAST_A_P_DIRECTORY = "LastAPDirectory", e.LASTASOF = "lastasof", e.LASTASOFDATE = "lastasofdate", e.LASTCONTACTTAB = "lastcontacttab", e.LASTFIRMTAB = "lastfirmtab", e.LASTNOTETYPEID = "lastnotetypeid", e.LASTVIEW = "lastview", e.LIMITTOPA = "limittopa", e.LIMITTOPIC = "limittopic", e.LIMITTOPM = "limittopm", e.LOCCODE_SORT = "loccode_sort", e.LOCKDATES = "lockdates", e.LOCNAME_SORT = "locname_sort", e.MENUFAVORITES = "menufavorites", e.NEWENTRY = "newentry", e.ORGID = "orgid", e.PABILLREVIEW = "pabillreview", e.PEWIDTH = "pewidth", e.PICEMPID = "picempid", e.PINFILTER = "pinfilter", e.PMBILLREVIEW = "pmbillreview", e.PMCCHARTS = "pmccharts", e.PMCENTRALSETTINGS = "pmcentralsettings", e.PMREVIEWED = "pmreviewed", e.PROJECTOPTIONS = "projectoptions", e.PROJECTORGID = "projectorgid", e.PROJECTPANELWIDTH = "projectpanelwidth", e.PROJECTSPLITCOL = "projectsplitcol", e.RECSPERPAGE = "recsperpage", e.SCHEDEND = "schedend", e.SCHEDSTART = "schedstart", e.SETTINGS = "settings", e.SHOWALLVERSIONS = "showallversions", e.SHOWEMPS = "showemps", e.SHOWFIRMCONTACTS = "showfirmcontacts", e.SHOWGENERIC = "showgeneric", e.SHOWTIMER = "showtimer", e.SINCEDATE = "sincedate", e.SYSFILTER = "sysfilter", e.TARGETHIGH = "targethigh", e.TARGETLOW = "targetlow", e.TYPEFILTER = "typefilter", e.UNITS = "units", e.USECD = "usecd", e.USECR = "usecr", e.USEER = "useer", e.USEGJ = "usegj", e.USEPJ = "usepj", e.USESJ = "usesj", e.USETS = "usets", e.VIEWJOBCODE = "viewjobcode", e.VIEWJOBTITLE = "viewjobtitle", e.VIEWPROJECTNAME = "viewprojectname", e.VIEWSJID = "viewsjid", e.WIDTH = "width";
    })(t16.UserSettingNameEnum || (t16.UserSettingNameEnum = {}));
  })(FK)), FK;
}
var VK = {}, uke;
function uH0() {
  return uke || (uke = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.GridNameEnum = void 0, (function(e) {
      e.AD_GLOBALS_CURRENCIES = "AD.GLOBALS.Currencies", e.AD_GLOBALS_OFFICES = "AD.GLOBALS.Offices", e.AD_GLOBALS_SMTP = "AD.GLOBALS.SMTP", e.AD_GLOBALS_TAXES = "AD.GLOBALS.Taxes", e.AD_UDF_DEFINITIONS = "AD.UDF.Definitions", e.AP_1099_RECIPIENTS = "AP._1099.Recipients", e.AP_APCHECK_CHECKS = "AP.APCHECK.Checks", e.AP_APCHECK_INVOICEHEADER = "AP.APCHECK.InvoiceHeader", e.AP_APCHECK_INVOICELINES = "AP.APCHECK.InvoiceLines", e.AP_CCCASHPOST_ITEMS = "AP.CCCASHPOST.Items", e.AP_CCCLEARING_ITEMS = "AP.CCCLEARING.Items", e.AP_CCCLEARING_MISSING = "AP.CCCLEARING.Missing", e.AP_DJ_ITEMS = "AP.DJ.Items", e.AP_ER_ITEMS = "AP.ER.Items", e.AP_ERCHECK_CHECKS = "AP.ERCHECK.Checks", e.AP_ERCHECK_INVOICEHEADER = "AP.ERCHECK.InvoiceHeader", e.AP_ERCHECK_INVOICELINES = "AP.ERCHECK.InvoiceLines", e.AP_PJ_ITEMS = "AP.PJ.Items", e.AR_COLLECTIONS = "AR.Collections", e.AR_CR_EMPLOYEEITEMS = "AR.CR.EmployeeItems", e.AR_CR_ITEMS = "AR.CR.Items", e.AR_CR_OTHERITEMS = "AR.CR.OtherItems", e.AR_CR_VENDORITEMS = "AR.CR.VendorItems", e.AR_INVOICING_INVOICES = "AR.INVOICING.Invoices", e.AR_PABILLREVIEW_FIXEDFEE = "AR.PABILLREVIEW.FixedFee", e.AR_PABILLREVIEW_PROJECTS = "AR.PABILLREVIEW.Projects", e.AR_PABILLREVIEW_TRANSACTIONS = "AR.PABILLREVIEW.Transactions", e.AR_SJ_ITEMS = "AR.SJ.Items", e.FIRM_ADDRESSES = "FIRM.Addresses", e.FIRM_APHISTORY = "FIRM.APHistory", e.FIRM_ARHISTORY = "FIRM.ARHistory", e.FIRM_CONTACTS = "FIRM.Contacts", e.FIRM_NOTES = "FIRM.Notes", e.FIRM_OPPORTUNITIES = "FIRM.Opportunities", e.FIRM_PROJECTS = "FIRM.Projects", e.FIRM_TRANSACTIONS = "FIRM.Transactions", e.GA_BANKREC_ADJUSTMENTS = "GA.BANKREC.Adjustments", e.GA_BANKREC_DISBURSEMENTS = "GA.BANKREC.Disbursements", e.GA_BANKREC_RECEIPTS = "GA.BANKREC.Receipts", e.GA_COA_ASSOCIATIONS = "GA.COA.Associations", e.GA_COA_BALANCES = "GA.COA.Balances", e.GA_GJ_ITEMS = "GA.GJ.Items", e.HR_ACCRUAL_MEMBERS = "HR.ACCRUAL.Members", e.HR_ACCRUAL_TRANSACTIONS = "HR.ACCRUAL.Transactions", e.HR_EMPLOYEES_CURRENTJOBTITLES = "HR.EMPLOYEES.CurrentJobTitles", e.HR_EMPLOYEES_JOBTITLES = "HR.EMPLOYEES.JobTitles", e.HR_EMPLOYEES_PAYHISTORIES = "HR.EMPLOYEES.PayHistories", e.HR_EMPLOYEES_PROJECTS = "HR.EMPLOYEES.Projects", e.HR_EMPLOYEES_PROJECTTRANSACTIONS = "HR.EMPLOYEES.ProjectTransactions", e.LOOKUP_CLIENT_INVOICES = "LOOKUP.CLIENT.Invoices", e.LOOKUP_CR_RECEIPTS = "LOOKUP.CR.Receipts", e.LOOKUP_DJ_CHECKS = "LOOKUP.DJ.Checks", e.LOOKUP_EMPLOYEE_INVOICES = "LOOKUP.EMPLOYEE.Invoices", e.LOOKUP_ER_INVOICES = "LOOKUP.ER.Invoices", e.LOOKUP_GJ_ADJUSTMENTS = "LOOKUP.GJ.Adjustments", e.LOOKUP_PJ_INVOICES = "LOOKUP.PJ.Invoices", e.LOOKUP_PROJECT_INVOICES = "LOOKUP.PROJECT.Invoices", e.LOOKUP_SJ_INVOICES = "LOOKUP.SJ.Invoices", e.LOOKUP_VENDOR_INVOICES = "LOOKUP.VENDOR.Invoices", e.MA_NOTES_ITEMS = "MA.NOTES.Items", e.MA_NOTES_MYITEMS = "MA.NOTES.MyItems", e.PA_EXPENSECODES_ITEMS = "PA.EXPENSECODES.Items", e.PA_EXPENSEGROUPS_ITEMS = "PA.EXPENSEGROUPS.Items", e.PA_LABORCODES_ITEMS = "PA.LABORCODES.Items", e.PA_PROJECTS_ADDRESSES = "PA.PROJECTS.Addresses", e.PA_PROJECTS_CONTACTS = "PA.PROJECTS.Contacts", e.PA_PROJECTS_MEMBERS = "PA.PROJECTS.Members", e.PA_PROJECTS_NOTES = "PA.PROJECTS.Notes", e.PA_PROJECTS_TAXES = "PA.PROJECTS.Taxes", e.PA_PROJECTS_TRANSACTIONS = "PA.PROJECTS.Transactions", e.PA_RATESCHEDULES_ITEMS = "PA.RATESCHEDULES.Items", e.PE_ES_ITEMS = "PE.ES.Items", e.PE_MYWO_ITEMS = "PE.MYWO.Items", e.PM_WO_ITEMS = "PM.WO.Items", e.UT_FSD_COLUMNS = "UT.FSD.Columns", e.UT_FSD_LINES = "UT.FSD.Lines", e.AP_CCCLEARING_PURCHASELOOKUP = "AP.CCCLEARING.PurchaseLookup", e.AR_PABILLREVIEW_VALUES = "AR.PABILLREVIEW.Values", e.PM_PMBILLREVIEW_VALUES = "PM.PMBILLREVIEW.Values", e.PM_PMBILLREVIEW_PROJECTS = "PM.PMBILLREVIEW.Projects", e.PM_PMBILLREVIEW_FIXEDFEE = "PM.PMBILLREVIEW.FixedFee", e.PM_PMBILLREVIEW_TRANSACTIONS = "PM.PMBILLREVIEW.Transactions", e.VENDOR_ADDRESSES = "VENDOR.Addresses", e.CLIENT_ADDRESSES = "CLIENT.Addresses", e.VENDOR_CONTACTS = "VENDOR.Contacts", e.CLIENT_CONTACTS = "CLIENT.Contacts", e.VENDOR_NOTES = "VENDOR.Notes", e.CLIENT_NOTES = "CLIENT.Notes", e.VENDOR_TRANSACTIONS = "VENDOR.Transactions", e.VENDOR_PROJECTS = "VENDOR.Projects", e.VENDOR_APHISTORY = "VENDOR.APHistory", e.CLIENT_OPPORTUNITIES = "CLIENT.Opportunities", e.CLIENT_ARHISTORY = "CLIENT.ARHistory", e.CLIENT_PROJECTS = "CLIENT.Projects", e.CLIENT_TRANSACTIONS = "CLIENT.Transactions", e.PA_PROJECTS_CONTRACTS = "PA.PROJECTS.Contracts", e.PM_PP_ALLOCATIONS = "PM.PP.Allocations", e.PM_RESOURCE_PROJECTITEMS = "PM.RESOURCE.ProjectItems", e.PM_RESOURCE_EMPLOYEEITEMS = "PM.RESOURCE.EmployeeItems", e.PA_WORKORDERS = "PA.WorkOrders", e.HR_DILUTEDPAYRATES = "HR.DilutedPayRates", e.HR_TETMP_ITEMS = "HR.TETMP.Items", e.HR_TSADJ_ITEMS = "HR.TSADJ.Items", e.LOOKUP_BANKRECS = "LOOKUP.BankRecs", e.UT_EFTFILES = "UT.EFTFiles", e.UT_EFTFILEITEMS = "UT.EFTFileItems", e.GA_ACCOUNTINGPERIODS = "GA.AccountingPeriods", e.JOURNALS_BATCHES = "JOURNALS.Batches", e.AR_CR_FINDINVOICE = "AR.CR.FindInvoice", e.AP_ER_ESIMPORT = "AP.ER.ESImport", e.HR_EMPLOYEE_CONTACTS = "HR.EMPLOYEE.Contacts", e.PE_TIMESHEETS_ITEMS = "PE.TIMESHEETS.Items", e.GA_GL_BUDGETS = "GA.GL.Budgets", e.UT_CT_ITEMS = "UT.CT.Items", e.AR_CR_WIZARDINVOICES = "AR.CR.WizardInvoices", e.AR_CR_WIZARDPROJECTS = "AR.CR.WizardProjects", e.AR_SJ_TIMESHEETLINKS = "AR.SJ.TimesheetLinks", e.AR_SJ_ERLINKS = "AR.SJ.ERLinks", e.AR_SJ_PURCHASELINKS = "AR.SJ.PurchaseLinks", e.AR_SJ_DISBURSEMENTLINKS = "AR.SJ.DisbursementLinks", e.AR_SJ_UNLINKED = "AR.SJ.Unlinked", e.LOOKUP_AP_CCREC = "LOOKUP.AP.CCRec", e.PA_PROJECTS_MEMBERSWIZ = "PA.PROJECTS.MembersWiz", e.PA_LABORCODEGROUPS_ITEMS = "PA.LABORCODEGROUPS.Items", e.AD_LM_ITEMS = "AD.LM.Items", e.AD_PERMISSIONS_USERS = "AD.PERMISSIONS.Users", e.AD_PERMISSIONS_GROUPS = "AD.PERMISSIONS.Groups", e.PM_PP_NEWCHANGEORDER = "PM.PP.NewChangeOrder", e.AP_CCCLEARING_TOTALS = "AP.CCCLEARING.Totals", e.PE_TIMESHEETS_BENEFITS = "PE.TIMESHEETS.Benefits", e.PA_WBSTEMPLATE_ITEMS = "PA.WBSTemplate.Items", e.PE_TIMESHEETS_RECENT = "PE.TIMESHEETS.Recent", e.PE_TIMESHEETS_SCHEDULED = "PE.TIMESHEETS.Scheduled", e.PE_TIMESHEETS_BILLABLE = "PE.TIMESHEETS.Billable", e.AP_PJ_UNPOSTED = "AP.PJ.Unposted", e.AP_DJ_UNPOSTED = "AP.DJ.Unposted", e.AP_ER_UNPOSTED = "AP.ER.Unposted", e.AR_SJ_UNPOSTED = "AR.SJ.Unposted", e.AR_CR_UNPOSTED = "AR.CR.Unposted", e.GA_GJ_UNPOSTED = "GA.GJ.Unposted", e.PA_PROJECTS_LABELS = "PA.PROJECTS.Labels", e.GA_ORGUNITS_LABELS = "GA.ORGUNITS.Labels", e.PA_PROJECTS_MARKETSECTORS = "PA.PROJECTS.MarketSectors", e.LOOKUP_PJ_EXPCODES = "LOOKUP.PJ.ExpCodes", e.LOOKUP_PROJECTS_EXPENSETREE = "LOOKUP.PROJECTS.ExpenseTree", e.LOOKUP_PROJECTS_EXPENSE = "LOOKUP.PROJECTS.Expense", e.LOOKUP_PROJECTS_DJ = "LOOKUP.PROJECTS.DJ", e.LOOKUP_PROJECTS_DJTREE = "LOOKUP.PROJECTS.DJTree", e.LOOKUP_PROJECTS = "LOOKUP.PROJECTS", e.LOOKUP_PROJECTS_TE = "LOOKUP.PROJECTS.TE", e.LOOKUP_PROJECTS_TETREE = "LOOKUP.PROJECTS.TETree", e.LOOKUP_GA_BASECODES = "LOOKUP.GA.BaseCodes", e.LOOKUP_GENERIC = "LOOKUP.Generic", e.LOOKUP_GA_BASEACCOUNTS = "LOOKUP.GA.BaseAccounts", e.LOOKUP_GA_GLACCOUNTS = "LOOKUP.GA.GLAccounts", e.LOOKUP_FIRMS = "LOOKUP.FIRMS", e.LOOKUP_LABORCODES = "LOOKUP.LABORCODES", e.UDFS_DEFINITIONS = "UDFS.Definitions", e.PE_TIMESHEETS_MISSING = "PE.TIMESHEETS.Missing", e.HR_RESOURCE_PROJECTIONS = "HR.RESOURCE.Projections", e.LOOKUP_FIRM_CONTACTS = "LOOKUP.FIRM.Contacts", e.LOOKUP_CONTACTS = "LOOKUP.Contacts", e.UT_PH_ENTRIES = "UT.PH.Entries", e.UT_PH_TRANSACTIONS = "UT.PH.Transactions", e.DOCUMENTS = "Documents", e.LOOKUP_ACCRUAL_PROJECTS = "LOOKUP.ACCRUAL.Projects", e.HR_JT_EMPLOYEES = "HR.JT.Employees", e.LOOKUP_TS_JOBTITLE = "LOOKUP.TS.Jobtitle", e.PE_ES_OPEN = "PE.ES.Open", e.HR_EMPLOYEES_TSGROUPS = "HR.EMPLOYEES.TSGroups", e.PE_TIMESHEETS_OPEN = "PE.TIMESHEETS.Open", e.PA_PROJECTS_EXPMARKUPS = "PA.PROJECTS.ExpMarkups", e.PA_PROJECTS_EXPOVERRIDES = "PA.PROJECTS.ExpOverrides", e.FIRMS_ADDITIONALADDRESSES = "FIRMS.AdditionalAddresses", e.PA_REVREC_PROJECTS = "PA.REVREC.Projects", e.PA_REVREC_ORGS = "PA.REVREC.Orgs", e.PA_REVREC_OWNERS = "PA.REVREC.Owners", e.PA_PROJECTS_TIMEDATES = "PA.PROJECTS.TimeDates", e.PA_PROJECTS_EXPDATES = "PA.PROJECTS.ExpDates", e.PA_PROJECTS_INVPOSTGRPS = "PA.PROJECTS.InvPostGrps", e.PA_PROJECTS_CMTTEMPLATES = "PA.PROJECTS.CmtTemplates", e.PA_PROJECTS_RATES = "PA.PROJECTS.Rates", e.QUERY_RESULTS = "QUERY.Results", e.QUERY_PARAMETERS = "QUERY.Parameters", e.QUERY_INPUT = "QUERY.Input", e.QUERY_OUTPUT = "QUERY.Output", e.CONTACTS_PROJECTS = "CONTACTS.Projects", e.CONTACTS_NOTES = "CONTACTS.Notes", e.CONTACTS_EMPLOYEES = "CONTACTS.Employees", e.CONTACTS_MKTLIST = "CONTACTS.MktList", e.FIRM_MKTLIST = "FIRM.MktList", e.OPPORTUNITY_MARKETSECTORS = "OPPORTUNITY.MarketSectors", e.OPPORTUNITY_ADDRESSES = "OPPORTUNITY.Addresses", e.OPPORTUNITY_MKTLIST = "OPPORTUNITY.MktList", e.OPPORTUNITY_CONTACTS = "OPPORTUNITY.Contacts", e.OPPORTUNITY_NOTES = "OPPORTUNITY.Notes", e.LOOKUP_RS_PERIODS = "LOOKUP.RS.Periods", e.AD_GLOBALS_HOLIDAYS = "AD.GLOBALS.Holidays", e.PM_RESOURCEGROUPS_GROUPS = "PM.RESOURCEGROUPS.Groups", e.PM_RESOURCEGROUPS_MEMBERS = "PM.RESOURCEGROUPS.Members", e.UT_SNIPPETEDITOR = "UT.SnippetEditor", e.LOOKUP_RESGRP_MEMBERS = "LOOKUP.ResGrp.Members", e.PM_PP_RESGRPS_PROJECTS = "PM.PP.ResGrps.Projects", e.PM_PP_RESGRPS_PROJECTASSIGNMENTS = "PM.PP.ResGrps.ProjectAssignments", e.HR_HOLIDAYCALENDARS = "HR.HolidayCalendars", e.HR_HOLIDAYCALENDARITEMS = "HR.HolidayCalendarItems", e.AD_DBBACKUPS = "AD.DBBackups", e.LOOKUP_PROJTEMPS = "LOOKUP.PROJTEMPS", e.LOOKUP_RATESCHED_EMPLOYEES = "LOOKUP.RateSched.Employees", e.LOOKUP_EMPPROJECT_MEMBERS = "LOOKUP.EmpProject.Members", e.LOOKUP_RATESCHED_JOBTITLES = "LOOKUP.RateSched.JobTitles", e.LOOKUP_EXPGROUP_EXPCODES = "LOOKUP.ExpGroup.ExpCodes", e.PM_PP_SCHEDULES = "PM.PP.Schedules", e.LOOKUP_SCHEDMEMBERS_JOBTITLES = "LOOKUP.SchedMembers.JobTitles", e.GA_CURRENCIES = "GA.CURRENCIES", e.GA_CURRENCY_PAIRS = "GA.CURRENCY.PAIRS", e.GA_CURRENCIES_XRATES = "GA.CURRENCIES.XRATES", e.PA_PROJECTS_INVCURRENCIES = "PA.PROJECTS.InvCurrencies", e.PA_PROJECTS_PRJCURRENCIES = "PA.PROJECTS.PrjCurrencies", e.PA_PROJECTS_INVNLCURRENCIES = "PA.PROJECTS.InvNLCurrencies", e.PA_PROJECTS_PRJNLCURRENCIES = "PA.PROJECTS.PrjNLCurrencies", e.PA_PROJECTS_XRATES = "PA.PROJECTS.XRates", e.GA_MC_REVAL_JOURNAL = "GA.MC.REVAL.JOURNAL", e.GA_LOOKUP_MC_ITEMS = "GA.LOOKUP.MC.Items", e.PM_PMCENTRAL = "PM.PMCentral", e.PM_PMCENTRAL_AR = "PM.PMCentral.AR", e.PM_PMCENTRAL_BILLED = "PM.PMCentral.Billed", e.PM_PMCENTRAL_BUDGET = "PM.PMCentral.Budget", e.PM_PMCENTRAL_CONSEFFORT = "PM.PMCentral.ConsEffort", e.PM_PMCENTRAL_CONTRACT = "PM.PMCentral.Contract", e.PM_PMCENTRAL_COST = "PM.PMCentral.Cost", e.PM_PMCENTRAL_EFFORT = "PM.PMCentral.Effort", e.PM_PMCENTRAL_BADDEBT = "PM.PMCentral.BadDebt", e.PM_PMCENTRAL_HOURS = "PM.PMCentral.Hours", e.PM_PMCENTRAL_CORDERS = "PM.PMCentral.COrders", e.PM_PMCENTRAL_LABORSCHED = "PM.PMCentral.LaborSched", e.PM_PMCENTRAL_TEAMMEMBERS = "PM.PMCentral.TeamMembers", e.PM_PMCENTRAL_WBS = "PM.PMCentral.WBS", e.PM_PMCENTRAL_PROJECT_CONTRACTS = "PM.PMCentral.Project.Contracts", e.PM_PMCENTRAL_PROJECT_BUDGETS = "PM.PMCentral.Project.Budgets", e.PM_PMCENTRAL_PROJECT_PROFILE = "PM.PMCentral.Project.Profile", e.JOURNALS_PJBATCH_ITEMS = "JOURNALS.PJBatch.Items", e.JOURNALS_CDBATCH_ITEMS = "JOURNALS.CDBatch.Items", e.JOURNALS_ERBATCH_ITEMS = "JOURNALS.ERBatch.Items", e.JOURNALS_CRBATCH_ITEMS = "JOURNALS.CRBatch.Items", e.JOURNALS_SJBATCH_ITEMS = "JOURNALS.SJBatch.Items", e.UT_OVERHEAD_ITEMS = "UT.OVERHEAD.Items", e.PM_PMCENTRAL_PROFIT = "PM.PMCentral.Profit", e.PM_PMCENTRAL_NETBILLED = "PM.PMCentral.NetBilled", e.PM_PMCENTRAL_RECEIVED = "PM.PMCentral.Received", e.PM_PMCENTRAL_UNBILLED = "PM.PMCentral.Unbilled", e.PM_PMCENTRAL_RETAINAGE = "PM.PMCentral.Retainage", e.PM_PMCENTRAL_RETAINER = "PM.PMCentral.Retainer", e.PM_PMCENTRAL_WRITEOFF = "PM.PMCentral.WriteOff", e.PMCENTRAL_TEAM = "PMCentral.Team", e.PM_PMCENTRAL_BILLREVIEW = "PM.PMCentral.BillReview", e.HR_EMPLOYEES_LOCATIONS = "HR.EMPLOYEES.Locations", e.PM_PMCENTRAL_CONTACTS = "PM.PMCentral.Contacts", e.PM_PMCENTRAL_ADDRESSES = "PM.PMCentral.Addresses", e.PM_PMCENTRAL_OTHERBILLED = "PM.PMCentral.OtherBilled", e.PE_TIMESHEETS_ETC = "PE.TIMESHEETS.ETC", e.PE_TIMESHEETS_WOE = "PE.TIMESHEETS.WOE", e.PM_PROJECTPLANNING_PROJECT = "PM.PROJECTPLANNING.Project", e.PM_PROJECTPLANNING_ALLOCATIONS = "PM.PROJECTPLANNING.Allocations", e.PM_PROJECTPLANNING_SCHEDULES = "PM.PROJECTPLANNING.Schedules", e.AR_INVOICING_EMAIL = "AR.INVOICING.Email", e.HR_EMPLOYEES_TIMEAPPROVERS = "HR.EMPLOYEES.TimeApprovers", e.HR_EMPLOYEES_EXPAPPROVERS = "HR.EMPLOYEES.ExpApprovers", e.WIDGETS_REPORTS = "WIDGETS.Reports", e.HR_ACCRUAL_SCHEDULES = "HR.ACCRUAL.Schedules", e.HR_ACCRUAL_TIERS = "HR.ACCRUAL.Tiers", e.PA_PROJECTS_LCGRPS = "PA.PROJECTS.LCGrps", e.PM_PMCENTRAL_LABORPAY = "PM.PMCentral.LaborPay", e.PM_PMCENTRAL_LABORJC = "PM.PMCentral.LaborJC", e.AD_USERSESSIONS_USERS = "AD.USERSESSIONS.Users", e.AD_USERSESSIONS_SESSIONS = "AD.USERSESSIONS.Sessions", e.AD_USERSESSIONS_EVENTS = "AD.USERSESSIONS.Events", e.PE_TIMESHEETS_ALL = "PE.TIMESHEETS.All", e.PE_EXPENSESHEETS_ALL = "PE.EXPENSESHEETS.All", e.AR_SJ_PAYMENTS = "AR.SJ.Payments", e.EXT_ITEMS = "EXT.Items", e.ANALYTIC_DASHBOARDS = "Analytic Dashboards", e.UT_DASHBOARDQUERIES_ITEMS = "UT.DashboardQueries.Items", e.UT_DASHBOARDQUERIESMANAGER_PARAMS = "UT.DashboardQueriesManager.Params", e.UT_ANALYTICDASHBOARDS_MODELS = "UT.AnalyticDashboards.Models", e.UT_ANALYTICDASHBOARDS_LIST = "UT.AnalyticDashboards.List", e.AD_GLOBALS_XSOURCES = "AD.GLOBALS.XSources", e.UT_XSOURCES_LIST = "UT.XSources.List", e.UT_ANALYTICDASHBOARDS_ITEMS = "UT.AnalyticDashboards.Items", e.UT_DASHBOARDGROUPS_ANALYTICDASHBOARDS = "UT.DashboardGroups.AnalyticDashboards", e.UT_DASHBOARDGROUPS_LAYOUT_ANALYTICDASHBOARDS = "UT.DashboardGroups.Layout.AnalyticDashboards", e.DB_ANALYTICDASHBOARDS_LIST = "DB.AnalyticDashboards.List", e.UT_INFOCUSVARIABLES_LIST = "UT.InfocusVariables.List", e.AD_GLOBALS_VARS = "AD.GLOBALS.VARS", e.UT_ANALYTICDASHBOARD_SHARES = "UT.AnalyticDashboard.Shares", e.UT_ANALYTICDASHBOARDSHARES_PARAMOVERRIDES = "UT.AnalyticDashboardShares.ParamOverrides", e.UT_DASHBOARDQUERIESMANAGER_FIELDS = "UT.DashboardQueriesManager.Fields", e.UT_ITEMSCRIPTER_ITEMS = "UT.ItemScripter.Items", e.UT_DASHBOARDQUERIESMANAGER_FIELDS_READONLY = "UT.DashboardQueriesManager.Fields.ReadOnly", e.UT_FSD_RANGES = "UT.FSD.Ranges", e.ADMIN_INFOCUSJOBS_JOBS = "Admin.InFocusJobs.Jobs", e.ADMIN_INFOCUSJOBS_JOBSTEPS = "Admin.InFocusJobs.JobSteps", e.ADMIN_INFOCUSJOBS_JOBHISTORY = "Admin.InFocusJobs.JobHistory", e.AD_GLOBALS_ENCFIELDS = "AD.GLOBALS.ENCFIELDS", e.PO_PURCHASEORDERS_ITEMS = "PO.PurchaseOrders.Items", e.HR_EMPLOYEES_APPROVERDELEGATES = "HR.Employees.ApproverDelegates", e.HR_EMPLOYEES_SHIPTO = "HR.EMPLOYEES.ShipTo", e.HR_EMPLOYEES_APPROVALRULES = "HR.Employees.ApprovalRules", e.PO_ITEMS_ITEMS = "PO.Items.Items", e.PO_ITEMS_APPROVALRULES = "PO.Items.ApprovalRules", e.PO_PURCHASEORDERS_SHIPTOS = "PO.PurchaseOrders.ShipTos", e.PO_ITEMS_SELECT = "PO.Items.Select", e.LOOKUP_PO_PURCHASEORDERS = "LOOKUP.PO.PurchaseOrders", e.PO_ITEMS_APPROVERS = "PO.Items.Approvers", e.API_RESOURCEGROUPS_ITEMS = "API.ResourceGroups.Items", e.API_RESOURCES_LIST = "API.Resources.List", e.API_RESOURCES_METHODLIST = "API.Resources.MethodList", e.API_RESOURCES_QUERYPARAMS = "API.Resources.QueryParams", e.API_RESOURCES_METHODS = "API.Resources.Methods", e.API_KEYS_LIST = "API.Keys.List", e.API_RESOURCEGROUPKEYS_LIST = "API.ResourceGroupKeys.List", e.API_RESULTSETS_LIST = "API.ResultSets.List", e.API_RESULTSETS_COLUMNS = "API.ResultSets.Columns", e.API_RESOURCES_QUERYPARAMS_TEST = "API.Resources.QueryParams.Test", e.EVENTS_EVENTS_LIST = "Events.Events.List", e.EVENTS_WEBHOOKS_LIST = "Events.Webhooks.List", e.EVENTS_HISTORY_LIST = "Events.History.List", e.LOOKUP_PO_EXPCODES = "LOOKUP.PO.ExpCodes", e.PO_PURCHASEORDERMANAGEMENT_ITEMS = "PO.PurchaseOrderManagement.Items", e.UT_GLOBALSETTINGS_APPROVALRULES = "UT.GlobalSettings.ApprovalRules", e.PO_PURCHASEORDERS_VALIDATIONMESSAGES = "PO.PurchaseOrders.ValidationMessages", e.PO_ITEMS_ITEMSELECT = "PO.Items.ItemSelect", e.PO_PURCHASEORDERS_ITEM = "PO.PurchaseOrders.Item", e.PM_PROCESSTEMPLATES_LIST = "PM.ProcessTemplates.List", e.PM_PROCESSTEMPLATES_STAGES_LIST = "PM.ProcessTemplates.Stages.List", e.PM_PROCESSINSTANCES_LIST = "PM.ProcessInstances.List", e.PM_PROCESSTEMPLATE_CUSTOMFIELDS = "PM.ProcessTemplate.CustomFields", e.PM_PROCESSINSTANCETEAM_LIST = "PM.ProcessInstanceTeam.List", e.PM_PROCESSINSTANCE_STAGEASSIGNMENTS_STAGES = "PM.ProcessInstance.StageAssignments.Stages", e.PM_PROCESSINSTANCEWORKORDERS_ITEMS = "PM.ProcessInstanceWorkorders.Items", e.PM_PROCESSINSTANCE_WORKORDERHISTORY = "PM.ProcessInstance.WorkOrderHistory", e.WORKORDER_COMMENTS_LIST = "WorkOrder.Comments.List", e.PM_PROCESSTEMPLATE_TAGS = "PM.ProcessTemplate.Tags", e.PM_WORKORDER_TAGS = "PM.WorkOrder.Tags", e.PM_WORKORDER_TODOS = "PM.WorkOrder.ToDos", e.PM_PROCESSINSTANCE_WORKORDER_TIMEHISTORY = "PM.ProcessInstance.WorkOrder.TimeHistory", e.PM_WORKORDER_TAGS_FILTER = "PM.WorkOrder.Tags.Filter", e.PM_WORKORDER_SUBSCRIBERS = "PM.WorkOrder.Subscribers", e.EVENTS_MESSAGES_LIST = "Events.Messages.List", e.MESSAGES_LIST = "Messages.List", e.MESSAGE_VARIABLES = "Message.Variables", e.MESSAGE_HEADERS = "Message.Headers", e.PM_PROCESSTEMPLATES_ROLES = "PM.ProcessTemplates.Roles", e.MESSAGES_WRAPPERS = "Messages.Wrappers", e.PE_ES_LINE_DOCS = "PE.ES.Line.Docs", e.PM_WORKORDER_STAGES_FILTER = "PM.WorkOrder.Stages.Filter", e.PM_PROCESSINSTANCEMEMBERS_LIST = "PM.ProcessInstanceMembers.List", e.UT_DASHBOARDGROUPS_EMPLOYEES = "UT.DashboardGroups.Employees", e.PM_PMCENTRAL_ANALYTICDASHBOARDS = "PM.PMCentral.AnalyticDashboards", e.API_RESOURCEKEYS_LIST = "API.ResourceKeys.List", e.AD_GLOBALS_WEBHOOKS = "AD.GLOBALS.WEBHOOKS", e.UT_TABLEMANAGER_TABLES = "UT.TableManager.Tables", e.UT_TABLEMANAGER_COLUMNS = "UT.TableManager.Columns", e.AD_PROJECTROLES_PROCESSES = "AD.ProjectRoles.Processes", e.PE_APPROVER_TIMESHEETS = "PE.APPROVER.Timesheets", e.PE_APPROVER_TIMESHEET_DETAIL = "PE.APPROVER.TimeSheet.Detail", e.PE_APPROVER_TIMELIAPROJECTS = "PE.APPROVER.TimeLIAProjects", e.PE_APPROVER_TIMELIALINES = "PE.APPROVER.TimeLIALines", e.PE_APPROVER_EXPENSESHEETS = "PE.APPROVER.ExpenseSheets", e.PE_APPROVER_EXPENSESHEET_DETAIL = "PE.APPROVER.ExpenseSheet.Detail", e.PE_APPROVER_EXPENSELIAPROJECTS = "PE.APPROVER.ExpenseLIAProjects", e.PE_APPROVER_EXPENSELIALINES = "PE.APPROVER.ExpenseLIALines", e.PE_TIMESHEETS_WORKORDERS = "PE.Timesheets.WorkOrders", e.AR_COLLECTIONS_2 = "AR.Collections.2", e.AR_COLLECTIONS_TRANSACTIONS = "AR.Collections.Transactions", e.AR_EMAIL_HISTORY = "AR.Email.History", e.AD_GLOBALS_POAPPROVERLEVELS = "AD.Globals.POApproverLevels", e.HR_EMPLOYEES_POAPPROVERLEVELS = "HR.Employees.POApproverLevels";
    })(t16.GridNameEnum || (t16.GridNameEnum = {}));
  })(VK)), VK;
}
var HK = {}, ske;
function sH0() {
  return ske || (ske = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true }), t16.GridEnum = void 0, (function(e) {
      e[e.AD_GLOBALS_CURRENCIES = 1] = "AD_GLOBALS_CURRENCIES", e[e.AD_GLOBALS_OFFICES = 2] = "AD_GLOBALS_OFFICES", e[e.AD_GLOBALS_SMTP = 3] = "AD_GLOBALS_SMTP", e[e.AD_GLOBALS_TAXES = 4] = "AD_GLOBALS_TAXES", e[e.AD_UDF_DEFINITIONS = 5] = "AD_UDF_DEFINITIONS", e[e.AP_1099_RECIPIENTS = 6] = "AP_1099_RECIPIENTS", e[e.AP_APCHECK_CHECKS = 7] = "AP_APCHECK_CHECKS", e[e.AP_APCHECK_INVOICEHEADER = 8] = "AP_APCHECK_INVOICEHEADER", e[e.AP_APCHECK_INVOICELINES = 9] = "AP_APCHECK_INVOICELINES", e[e.AP_CCCASHPOST_ITEMS = 10] = "AP_CCCASHPOST_ITEMS", e[e.AP_CCCLEARING_ITEMS = 11] = "AP_CCCLEARING_ITEMS", e[e.AP_CCCLEARING_MISSING = 12] = "AP_CCCLEARING_MISSING", e[e.AP_DJ_ITEMS = 13] = "AP_DJ_ITEMS", e[e.AP_ER_ITEMS = 14] = "AP_ER_ITEMS", e[e.AP_ERCHECK_CHECKS = 15] = "AP_ERCHECK_CHECKS", e[e.AP_ERCHECK_INVOICEHEADER = 16] = "AP_ERCHECK_INVOICEHEADER", e[e.AP_ERCHECK_INVOICELINES = 17] = "AP_ERCHECK_INVOICELINES", e[e.AP_PJ_ITEMS = 18] = "AP_PJ_ITEMS", e[e.AR_COLLECTIONS = 19] = "AR_COLLECTIONS", e[e.AR_CR_EMPLOYEEITEMS = 20] = "AR_CR_EMPLOYEEITEMS", e[e.AR_CR_ITEMS = 21] = "AR_CR_ITEMS", e[e.AR_CR_OTHERITEMS = 22] = "AR_CR_OTHERITEMS", e[e.AR_CR_VENDORITEMS = 23] = "AR_CR_VENDORITEMS", e[e.AR_INVOICING_INVOICES = 24] = "AR_INVOICING_INVOICES", e[e.AR_PABILLREVIEW_FIXEDFEE = 25] = "AR_PABILLREVIEW_FIXEDFEE", e[e.AR_PABILLREVIEW_PROJECTS = 26] = "AR_PABILLREVIEW_PROJECTS", e[e.AR_PABILLREVIEW_TRANSACTIONS = 27] = "AR_PABILLREVIEW_TRANSACTIONS", e[e.AR_SJ_ITEMS = 28] = "AR_SJ_ITEMS", e[e.FIRM_ADDRESSES = 29] = "FIRM_ADDRESSES", e[e.FIRM_APHISTORY = 30] = "FIRM_APHISTORY", e[e.FIRM_ARHISTORY = 31] = "FIRM_ARHISTORY", e[e.FIRM_CONTACTS = 32] = "FIRM_CONTACTS", e[e.FIRM_NOTES = 33] = "FIRM_NOTES", e[e.FIRM_OPPORTUNITIES = 34] = "FIRM_OPPORTUNITIES", e[e.FIRM_PROJECTS = 35] = "FIRM_PROJECTS", e[e.FIRM_TRANSACTIONS = 36] = "FIRM_TRANSACTIONS", e[e.GA_BANKREC_ADJUSTMENTS = 37] = "GA_BANKREC_ADJUSTMENTS", e[e.GA_BANKREC_DISBURSEMENTS = 38] = "GA_BANKREC_DISBURSEMENTS", e[e.GA_BANKREC_RECEIPTS = 39] = "GA_BANKREC_RECEIPTS", e[e.GA_COA_ASSOCIATIONS = 40] = "GA_COA_ASSOCIATIONS", e[e.GA_COA_BALANCES = 41] = "GA_COA_BALANCES", e[e.GA_GJ_ITEMS = 42] = "GA_GJ_ITEMS", e[e.HR_ACCRUAL_MEMBERS = 43] = "HR_ACCRUAL_MEMBERS", e[e.HR_ACCRUAL_TRANSACTIONS = 44] = "HR_ACCRUAL_TRANSACTIONS", e[e.HR_EMPLOYEES_CURRENTJOBTITLES = 45] = "HR_EMPLOYEES_CURRENTJOBTITLES", e[e.HR_EMPLOYEES_JOBTITLES = 46] = "HR_EMPLOYEES_JOBTITLES", e[e.HR_EMPLOYEES_PAYHISTORIES = 47] = "HR_EMPLOYEES_PAYHISTORIES", e[e.HR_EMPLOYEES_PROJECTS = 48] = "HR_EMPLOYEES_PROJECTS", e[e.HR_EMPLOYEES_PROJECTTRANSACTIONS = 49] = "HR_EMPLOYEES_PROJECTTRANSACTIONS", e[e.LOOKUP_CLIENT_INVOICES = 52] = "LOOKUP_CLIENT_INVOICES", e[e.LOOKUP_CR_RECEIPTS = 53] = "LOOKUP_CR_RECEIPTS", e[e.LOOKUP_DJ_CHECKS = 54] = "LOOKUP_DJ_CHECKS", e[e.LOOKUP_EMPLOYEE_INVOICES = 55] = "LOOKUP_EMPLOYEE_INVOICES", e[e.LOOKUP_ER_INVOICES = 56] = "LOOKUP_ER_INVOICES", e[e.LOOKUP_GJ_ADJUSTMENTS = 57] = "LOOKUP_GJ_ADJUSTMENTS", e[e.LOOKUP_PJ_INVOICES = 58] = "LOOKUP_PJ_INVOICES", e[e.LOOKUP_PROJECT_INVOICES = 59] = "LOOKUP_PROJECT_INVOICES", e[e.LOOKUP_SJ_INVOICES = 60] = "LOOKUP_SJ_INVOICES", e[e.LOOKUP_VENDOR_INVOICES = 61] = "LOOKUP_VENDOR_INVOICES", e[e.MA_NOTES_ITEMS = 62] = "MA_NOTES_ITEMS", e[e.MA_NOTES_MYITEMS = 63] = "MA_NOTES_MYITEMS", e[e.PA_EXPENSECODES_ITEMS = 64] = "PA_EXPENSECODES_ITEMS", e[e.PA_EXPENSEGROUPS_ITEMS = 65] = "PA_EXPENSEGROUPS_ITEMS", e[e.PA_LABORCODES_ITEMS = 66] = "PA_LABORCODES_ITEMS", e[e.PA_PROJECTS_ADDRESSES = 67] = "PA_PROJECTS_ADDRESSES", e[e.PA_PROJECTS_CONTACTS = 68] = "PA_PROJECTS_CONTACTS", e[e.PA_PROJECTS_MEMBERS = 69] = "PA_PROJECTS_MEMBERS", e[e.PA_PROJECTS_NOTES = 70] = "PA_PROJECTS_NOTES", e[e.PA_PROJECTS_TAXES = 71] = "PA_PROJECTS_TAXES", e[e.PA_PROJECTS_TRANSACTIONS = 72] = "PA_PROJECTS_TRANSACTIONS", e[e.PA_RATESCHEDULES_ITEMS = 73] = "PA_RATESCHEDULES_ITEMS", e[e.PE_ES_ITEMS = 74] = "PE_ES_ITEMS", e[e.PE_MYWO_ITEMS = 75] = "PE_MYWO_ITEMS", e[e.PM_WO_ITEMS = 79] = "PM_WO_ITEMS", e[e.UT_FSD_COLUMNS = 81] = "UT_FSD_COLUMNS", e[e.UT_FSD_LINES = 82] = "UT_FSD_LINES", e[e.AP_CCCLEARING_PURCHASELOOKUP = 83] = "AP_CCCLEARING_PURCHASELOOKUP", e[e.AR_PABILLREVIEW_VALUES = 84] = "AR_PABILLREVIEW_VALUES", e[e.PM_PMBILLREVIEW_VALUES = 85] = "PM_PMBILLREVIEW_VALUES", e[e.PM_PMBILLREVIEW_PROJECTS = 86] = "PM_PMBILLREVIEW_PROJECTS", e[e.PM_PMBILLREVIEW_FIXEDFEE = 87] = "PM_PMBILLREVIEW_FIXEDFEE", e[e.PM_PMBILLREVIEW_TRANSACTIONS = 88] = "PM_PMBILLREVIEW_TRANSACTIONS", e[e.VENDOR_ADDRESSES = 89] = "VENDOR_ADDRESSES", e[e.CLIENT_ADDRESSES = 90] = "CLIENT_ADDRESSES", e[e.VENDOR_CONTACTS = 91] = "VENDOR_CONTACTS", e[e.CLIENT_CONTACTS = 92] = "CLIENT_CONTACTS", e[e.VENDOR_NOTES = 93] = "VENDOR_NOTES", e[e.CLIENT_NOTES = 94] = "CLIENT_NOTES", e[e.VENDOR_TRANSACTIONS = 95] = "VENDOR_TRANSACTIONS", e[e.VENDOR_PROJECTS = 96] = "VENDOR_PROJECTS", e[e.VENDOR_APHISTORY = 97] = "VENDOR_APHISTORY", e[e.CLIENT_OPPORTUNITIES = 98] = "CLIENT_OPPORTUNITIES", e[e.CLIENT_ARHISTORY = 99] = "CLIENT_ARHISTORY", e[e.CLIENT_PROJECTS = 100] = "CLIENT_PROJECTS", e[e.CLIENT_TRANSACTIONS = 101] = "CLIENT_TRANSACTIONS", e[e.PA_PROJECTS_CONTRACTS = 102] = "PA_PROJECTS_CONTRACTS", e[e.PM_PP_ALLOCATIONS = 103] = "PM_PP_ALLOCATIONS", e[e.PM_RESOURCE_PROJECTITEMS = 104] = "PM_RESOURCE_PROJECTITEMS", e[e.PM_RESOURCE_EMPLOYEEITEMS = 105] = "PM_RESOURCE_EMPLOYEEITEMS", e[e.PA_WORKORDERS = 106] = "PA_WORKORDERS", e[e.HR_DILUTEDPAYRATES = 107] = "HR_DILUTEDPAYRATES", e[e.HR_TETMP_ITEMS = 108] = "HR_TETMP_ITEMS", e[e.HR_TSADJ_ITEMS = 109] = "HR_TSADJ_ITEMS", e[e.LOOKUP_BANKRECS = 110] = "LOOKUP_BANKRECS", e[e.UT_EFTFILES = 111] = "UT_EFTFILES", e[e.UT_EFTFILEITEMS = 112] = "UT_EFTFILEITEMS", e[e.GA_ACCOUNTINGPERIODS = 113] = "GA_ACCOUNTINGPERIODS", e[e.JOURNALS_BATCHES = 114] = "JOURNALS_BATCHES", e[e.AR_CR_FINDINVOICE = 115] = "AR_CR_FINDINVOICE", e[e.AP_ER_ESIMPORT = 116] = "AP_ER_ESIMPORT", e[e.HR_EMPLOYEE_CONTACTS = 117] = "HR_EMPLOYEE_CONTACTS", e[e.PE_TIMESHEETS_ITEMS = 118] = "PE_TIMESHEETS_ITEMS", e[e.GA_GL_BUDGETS = 119] = "GA_GL_BUDGETS", e[e.UT_CT_ITEMS = 120] = "UT_CT_ITEMS", e[e.AR_CR_WIZARDINVOICES = 121] = "AR_CR_WIZARDINVOICES", e[e.AR_CR_WIZARDPROJECTS = 122] = "AR_CR_WIZARDPROJECTS", e[e.AR_SJ_TIMESHEETLINKS = 123] = "AR_SJ_TIMESHEETLINKS", e[e.AR_SJ_ERLINKS = 124] = "AR_SJ_ERLINKS", e[e.AR_SJ_PURCHASELINKS = 125] = "AR_SJ_PURCHASELINKS", e[e.AR_SJ_DISBURSEMENTLINKS = 126] = "AR_SJ_DISBURSEMENTLINKS", e[e.AR_SJ_UNLINKED = 127] = "AR_SJ_UNLINKED", e[e.LOOKUP_AP_CCREC = 128] = "LOOKUP_AP_CCREC", e[e.PA_PROJECTS_MEMBERSWIZ = 129] = "PA_PROJECTS_MEMBERSWIZ", e[e.PA_LABORCODEGROUPS_ITEMS = 130] = "PA_LABORCODEGROUPS_ITEMS", e[e.AD_LM_ITEMS = 131] = "AD_LM_ITEMS", e[e.AD_PERMISSIONS_USERS = 132] = "AD_PERMISSIONS_USERS", e[e.AD_PERMISSIONS_GROUPS = 133] = "AD_PERMISSIONS_GROUPS", e[e.PM_PP_NEWCHANGEORDER = 134] = "PM_PP_NEWCHANGEORDER", e[e.AP_CCCLEARING_TOTALS = 135] = "AP_CCCLEARING_TOTALS", e[e.PE_TIMESHEETS_BENEFITS = 137] = "PE_TIMESHEETS_BENEFITS", e[e.PA_WBSTEMPLATE_ITEMS = 138] = "PA_WBSTEMPLATE_ITEMS", e[e.PE_TIMESHEETS_RECENT = 139] = "PE_TIMESHEETS_RECENT", e[e.PE_TIMESHEETS_SCHEDULED = 140] = "PE_TIMESHEETS_SCHEDULED", e[e.PE_TIMESHEETS_BILLABLE = 141] = "PE_TIMESHEETS_BILLABLE", e[e.AP_PJ_UNPOSTED = 142] = "AP_PJ_UNPOSTED", e[e.AP_DJ_UNPOSTED = 143] = "AP_DJ_UNPOSTED", e[e.AP_ER_UNPOSTED = 144] = "AP_ER_UNPOSTED", e[e.AR_SJ_UNPOSTED = 145] = "AR_SJ_UNPOSTED", e[e.AR_CR_UNPOSTED = 146] = "AR_CR_UNPOSTED", e[e.GA_GJ_UNPOSTED = 147] = "GA_GJ_UNPOSTED", e[e.PA_PROJECTS_LABELS = 148] = "PA_PROJECTS_LABELS", e[e.GA_ORGUNITS_LABELS = 149] = "GA_ORGUNITS_LABELS", e[e.PA_PROJECTS_MARKETSECTORS = 150] = "PA_PROJECTS_MARKETSECTORS", e[e.LOOKUP_PJ_EXPCODES = 151] = "LOOKUP_PJ_EXPCODES", e[e.LOOKUP_PROJECTS_EXPENSETREE = 152] = "LOOKUP_PROJECTS_EXPENSETREE", e[e.LOOKUP_PROJECTS_EXPENSE = 153] = "LOOKUP_PROJECTS_EXPENSE", e[e.LOOKUP_PROJECTS_DJ = 154] = "LOOKUP_PROJECTS_DJ", e[e.LOOKUP_PROJECTS_DJTREE = 155] = "LOOKUP_PROJECTS_DJTREE", e[e.LOOKUP_PROJECTS = 156] = "LOOKUP_PROJECTS", e[e.LOOKUP_PROJECTS_TE = 157] = "LOOKUP_PROJECTS_TE", e[e.LOOKUP_PROJECTS_TETREE = 158] = "LOOKUP_PROJECTS_TETREE", e[e.LOOKUP_GA_BASECODES = 159] = "LOOKUP_GA_BASECODES", e[e.LOOKUP_GENERIC = 160] = "LOOKUP_GENERIC", e[e.LOOKUP_GA_BASEACCOUNTS = 161] = "LOOKUP_GA_BASEACCOUNTS", e[e.LOOKUP_GA_GLACCOUNTS = 162] = "LOOKUP_GA_GLACCOUNTS", e[e.LOOKUP_FIRMS = 163] = "LOOKUP_FIRMS", e[e.LOOKUP_LABORCODES = 164] = "LOOKUP_LABORCODES", e[e.UDFS_DEFINITIONS = 165] = "UDFS_DEFINITIONS", e[e.PE_TIMESHEETS_MISSING = 166] = "PE_TIMESHEETS_MISSING", e[e.HR_RESOURCE_PROJECTIONS = 167] = "HR_RESOURCE_PROJECTIONS", e[e.LOOKUP_FIRM_CONTACTS = 168] = "LOOKUP_FIRM_CONTACTS", e[e.LOOKUP_CONTACTS = 169] = "LOOKUP_CONTACTS", e[e.UT_PH_ENTRIES = 170] = "UT_PH_ENTRIES", e[e.UT_PH_TRANSACTIONS = 171] = "UT_PH_TRANSACTIONS", e[e.DOCUMENTS = 172] = "DOCUMENTS", e[e.LOOKUP_ACCRUAL_PROJECTS = 173] = "LOOKUP_ACCRUAL_PROJECTS", e[e.HR_JT_EMPLOYEES = 174] = "HR_JT_EMPLOYEES", e[e.LOOKUP_TS_JOBTITLE = 175] = "LOOKUP_TS_JOBTITLE", e[e.PE_ES_OPEN = 176] = "PE_ES_OPEN", e[e.HR_EMPLOYEES_TSGROUPS = 177] = "HR_EMPLOYEES_TSGROUPS", e[e.PE_TIMESHEETS_OPEN = 178] = "PE_TIMESHEETS_OPEN", e[e.PA_PROJECTS_EXPMARKUPS = 179] = "PA_PROJECTS_EXPMARKUPS", e[e.PA_PROJECTS_EXPOVERRIDES = 180] = "PA_PROJECTS_EXPOVERRIDES", e[e.FIRMS_ADDITIONALADDRESSES = 182] = "FIRMS_ADDITIONALADDRESSES", e[e.PA_REVREC_PROJECTS = 183] = "PA_REVREC_PROJECTS", e[e.PA_REVREC_ORGS = 184] = "PA_REVREC_ORGS", e[e.PA_REVREC_OWNERS = 185] = "PA_REVREC_OWNERS", e[e.PA_PROJECTS_TIMEDATES = 186] = "PA_PROJECTS_TIMEDATES", e[e.PA_PROJECTS_EXPDATES = 187] = "PA_PROJECTS_EXPDATES", e[e.PA_PROJECTS_INVPOSTGRPS = 188] = "PA_PROJECTS_INVPOSTGRPS", e[e.PA_PROJECTS_CMTTEMPLATES = 189] = "PA_PROJECTS_CMTTEMPLATES", e[e.PA_PROJECTS_RATES = 190] = "PA_PROJECTS_RATES", e[e.QUERY_RESULTS = 191] = "QUERY_RESULTS", e[e.QUERY_PARAMETERS = 192] = "QUERY_PARAMETERS", e[e.QUERY_INPUT = 193] = "QUERY_INPUT", e[e.QUERY_OUTPUT = 194] = "QUERY_OUTPUT", e[e.CONTACTS_PROJECTS = 195] = "CONTACTS_PROJECTS", e[e.CONTACTS_NOTES = 196] = "CONTACTS_NOTES", e[e.CONTACTS_EMPLOYEES = 197] = "CONTACTS_EMPLOYEES", e[e.CONTACTS_MKTLIST = 198] = "CONTACTS_MKTLIST", e[e.FIRM_MKTLIST = 199] = "FIRM_MKTLIST", e[e.OPPORTUNITY_MARKETSECTORS = 200] = "OPPORTUNITY_MARKETSECTORS", e[e.OPPORTUNITY_ADDRESSES = 201] = "OPPORTUNITY_ADDRESSES", e[e.OPPORTUNITY_MKTLIST = 202] = "OPPORTUNITY_MKTLIST", e[e.OPPORTUNITY_CONTACTS = 203] = "OPPORTUNITY_CONTACTS", e[e.OPPORTUNITY_NOTES = 204] = "OPPORTUNITY_NOTES", e[e.LOOKUP_RS_PERIODS = 205] = "LOOKUP_RS_PERIODS", e[e.AD_GLOBALS_HOLIDAYS = 206] = "AD_GLOBALS_HOLIDAYS", e[e.PM_RESOURCEGROUPS_GROUPS = 207] = "PM_RESOURCEGROUPS_GROUPS", e[e.PM_RESOURCEGROUPS_MEMBERS = 208] = "PM_RESOURCEGROUPS_MEMBERS", e[e.UT_SNIPPETEDITOR = 209] = "UT_SNIPPETEDITOR", e[e.LOOKUP_RESGRP_MEMBERS = 211] = "LOOKUP_RESGRP_MEMBERS", e[e.PM_PP_RESGRPS_PROJECTS = 212] = "PM_PP_RESGRPS_PROJECTS", e[e.PM_PP_RESGRPS_PROJECTASSIGNMENTS = 213] = "PM_PP_RESGRPS_PROJECTASSIGNMENTS", e[e.HR_HOLIDAYCALENDARS = 214] = "HR_HOLIDAYCALENDARS", e[e.HR_HOLIDAYCALENDARITEMS = 215] = "HR_HOLIDAYCALENDARITEMS", e[e.AD_DBBACKUPS = 216] = "AD_DBBACKUPS", e[e.LOOKUP_PROJTEMPS = 217] = "LOOKUP_PROJTEMPS", e[e.LOOKUP_RATESCHED_EMPLOYEES = 218] = "LOOKUP_RATESCHED_EMPLOYEES", e[e.LOOKUP_EMPPROJECT_MEMBERS = 219] = "LOOKUP_EMPPROJECT_MEMBERS", e[e.LOOKUP_RATESCHED_JOBTITLES = 220] = "LOOKUP_RATESCHED_JOBTITLES", e[e.LOOKUP_EXPGROUP_EXPCODES = 221] = "LOOKUP_EXPGROUP_EXPCODES", e[e.PM_PP_SCHEDULES = 222] = "PM_PP_SCHEDULES", e[e.LOOKUP_SCHEDMEMBERS_JOBTITLES = 223] = "LOOKUP_SCHEDMEMBERS_JOBTITLES", e[e.GA_CURRENCIES = 224] = "GA_CURRENCIES", e[e.GA_CURRENCY_PAIRS = 225] = "GA_CURRENCY_PAIRS", e[e.GA_CURRENCIES_XRATES = 226] = "GA_CURRENCIES_XRATES", e[e.PA_PROJECTS_INVCURRENCIES = 227] = "PA_PROJECTS_INVCURRENCIES", e[e.PA_PROJECTS_PRJCURRENCIES = 228] = "PA_PROJECTS_PRJCURRENCIES", e[e.PA_PROJECTS_INVNLCURRENCIES = 229] = "PA_PROJECTS_INVNLCURRENCIES", e[e.PA_PROJECTS_PRJNLCURRENCIES = 230] = "PA_PROJECTS_PRJNLCURRENCIES", e[e.PA_PROJECTS_XRATES = 231] = "PA_PROJECTS_XRATES", e[e.GA_MC_REVAL_JOURNAL = 232] = "GA_MC_REVAL_JOURNAL", e[e.GA_LOOKUP_MC_ITEMS = 233] = "GA_LOOKUP_MC_ITEMS", e[e.PM_PMCENTRAL = 236] = "PM_PMCENTRAL", e[e.PM_PMCENTRAL_AR = 237] = "PM_PMCENTRAL_AR", e[e.PM_PMCENTRAL_BILLED = 238] = "PM_PMCENTRAL_BILLED", e[e.PM_PMCENTRAL_BUDGET = 239] = "PM_PMCENTRAL_BUDGET", e[e.PM_PMCENTRAL_CONSEFFORT = 240] = "PM_PMCENTRAL_CONSEFFORT", e[e.PM_PMCENTRAL_CONTRACT = 241] = "PM_PMCENTRAL_CONTRACT", e[e.PM_PMCENTRAL_COST = 242] = "PM_PMCENTRAL_COST", e[e.PM_PMCENTRAL_EFFORT = 243] = "PM_PMCENTRAL_EFFORT", e[e.PM_PMCENTRAL_BADDEBT = 244] = "PM_PMCENTRAL_BADDEBT", e[e.PM_PMCENTRAL_HOURS = 245] = "PM_PMCENTRAL_HOURS", e[e.PM_PMCENTRAL_CORDERS = 246] = "PM_PMCENTRAL_CORDERS", e[e.PM_PMCENTRAL_LABORSCHED = 247] = "PM_PMCENTRAL_LABORSCHED", e[e.PM_PMCENTRAL_TEAMMEMBERS = 248] = "PM_PMCENTRAL_TEAMMEMBERS", e[e.PM_PMCENTRAL_WBS = 249] = "PM_PMCENTRAL_WBS", e[e.PM_PMCENTRAL_PROJECT_CONTRACTS = 250] = "PM_PMCENTRAL_PROJECT_CONTRACTS", e[e.PM_PMCENTRAL_PROJECT_BUDGETS = 251] = "PM_PMCENTRAL_PROJECT_BUDGETS", e[e.PM_PMCENTRAL_PROJECT_PROFILE = 252] = "PM_PMCENTRAL_PROJECT_PROFILE", e[e.JOURNALS_PJBATCH_ITEMS = 253] = "JOURNALS_PJBATCH_ITEMS", e[e.JOURNALS_CDBATCH_ITEMS = 254] = "JOURNALS_CDBATCH_ITEMS", e[e.JOURNALS_ERBATCH_ITEMS = 255] = "JOURNALS_ERBATCH_ITEMS", e[e.JOURNALS_CRBATCH_ITEMS = 256] = "JOURNALS_CRBATCH_ITEMS", e[e.JOURNALS_SJBATCH_ITEMS = 257] = "JOURNALS_SJBATCH_ITEMS", e[e.UT_OVERHEAD_ITEMS = 258] = "UT_OVERHEAD_ITEMS", e[e.PM_PMCENTRAL_PROFIT = 259] = "PM_PMCENTRAL_PROFIT", e[e.PM_PMCENTRAL_NETBILLED = 260] = "PM_PMCENTRAL_NETBILLED", e[e.PM_PMCENTRAL_RECEIVED = 261] = "PM_PMCENTRAL_RECEIVED", e[e.PM_PMCENTRAL_UNBILLED = 262] = "PM_PMCENTRAL_UNBILLED", e[e.PM_PMCENTRAL_RETAINAGE = 263] = "PM_PMCENTRAL_RETAINAGE", e[e.PM_PMCENTRAL_RETAINER = 264] = "PM_PMCENTRAL_RETAINER", e[e.PM_PMCENTRAL_WRITEOFF = 265] = "PM_PMCENTRAL_WRITEOFF", e[e.PMCENTRAL_TEAM = 266] = "PMCENTRAL_TEAM", e[e.PM_PMCENTRAL_BILLREVIEW = 267] = "PM_PMCENTRAL_BILLREVIEW", e[e.HR_EMPLOYEES_LOCATIONS = 268] = "HR_EMPLOYEES_LOCATIONS", e[e.PM_PMCENTRAL_CONTACTS = 269] = "PM_PMCENTRAL_CONTACTS", e[e.PM_PMCENTRAL_ADDRESSES = 270] = "PM_PMCENTRAL_ADDRESSES", e[e.PM_PMCENTRAL_OTHERBILLED = 271] = "PM_PMCENTRAL_OTHERBILLED", e[e.PE_TIMESHEETS_ETC = 272] = "PE_TIMESHEETS_ETC", e[e.PE_TIMESHEETS_WOE = 273] = "PE_TIMESHEETS_WOE", e[e.PM_PROJECTPLANNING_PROJECT = 274] = "PM_PROJECTPLANNING_PROJECT", e[e.PM_PROJECTPLANNING_ALLOCATIONS = 275] = "PM_PROJECTPLANNING_ALLOCATIONS", e[e.PM_PROJECTPLANNING_SCHEDULES = 276] = "PM_PROJECTPLANNING_SCHEDULES", e[e.AR_INVOICING_EMAIL = 277] = "AR_INVOICING_EMAIL", e[e.HR_EMPLOYEES_TIMEAPPROVERS = 278] = "HR_EMPLOYEES_TIMEAPPROVERS", e[e.HR_EMPLOYEES_EXPAPPROVERS = 279] = "HR_EMPLOYEES_EXPAPPROVERS", e[e.WIDGETS_REPORTS = 280] = "WIDGETS_REPORTS", e[e.HR_ACCRUAL_SCHEDULES = 281] = "HR_ACCRUAL_SCHEDULES", e[e.HR_ACCRUAL_TIERS = 282] = "HR_ACCRUAL_TIERS", e[e.PA_PROJECTS_LCGRPS = 283] = "PA_PROJECTS_LCGRPS", e[e.PM_PMCENTRAL_LABORPAY = 285] = "PM_PMCENTRAL_LABORPAY", e[e.PM_PMCENTRAL_LABORJC = 286] = "PM_PMCENTRAL_LABORJC", e[e.AD_USERSESSIONS_USERS = 287] = "AD_USERSESSIONS_USERS", e[e.AD_USERSESSIONS_SESSIONS = 288] = "AD_USERSESSIONS_SESSIONS", e[e.AD_USERSESSIONS_EVENTS = 289] = "AD_USERSESSIONS_EVENTS", e[e.PE_TIMESHEETS_ALL = 290] = "PE_TIMESHEETS_ALL", e[e.PE_EXPENSESHEETS_ALL = 291] = "PE_EXPENSESHEETS_ALL", e[e.AR_SJ_PAYMENTS = 292] = "AR_SJ_PAYMENTS", e[e.EXT_ITEMS = 293] = "EXT_ITEMS", e[e.ANALYTIC_DASHBOARDS = 294] = "ANALYTIC_DASHBOARDS", e[e.UT_DASHBOARDQUERIES_ITEMS = 295] = "UT_DASHBOARDQUERIES_ITEMS", e[e.UT_DASHBOARDQUERIESMANAGER_PARAMS = 296] = "UT_DASHBOARDQUERIESMANAGER_PARAMS", e[e.UT_ANALYTICDASHBOARDS_MODELS = 297] = "UT_ANALYTICDASHBOARDS_MODELS", e[e.UT_ANALYTICDASHBOARDS_LIST = 298] = "UT_ANALYTICDASHBOARDS_LIST", e[e.AD_GLOBALS_XSOURCES = 299] = "AD_GLOBALS_XSOURCES", e[e.UT_XSOURCES_LIST = 300] = "UT_XSOURCES_LIST", e[e.UT_ANALYTICDASHBOARDS_ITEMS = 301] = "UT_ANALYTICDASHBOARDS_ITEMS", e[e.UT_DASHBOARDGROUPS_ANALYTICDASHBOARDS = 302] = "UT_DASHBOARDGROUPS_ANALYTICDASHBOARDS", e[e.UT_DASHBOARDGROUPS_LAYOUT_ANALYTICDASHBOARDS = 303] = "UT_DASHBOARDGROUPS_LAYOUT_ANALYTICDASHBOARDS", e[e.DB_ANALYTICDASHBOARDS_LIST = 304] = "DB_ANALYTICDASHBOARDS_LIST", e[e.UT_INFOCUSVARIABLES_LIST = 305] = "UT_INFOCUSVARIABLES_LIST", e[e.AD_GLOBALS_VARS = 306] = "AD_GLOBALS_VARS", e[e.UT_ANALYTICDASHBOARD_SHARES = 307] = "UT_ANALYTICDASHBOARD_SHARES", e[e.UT_ANALYTICDASHBOARDSHARES_PARAMOVERRIDES = 308] = "UT_ANALYTICDASHBOARDSHARES_PARAMOVERRIDES", e[e.UT_DASHBOARDQUERIESMANAGER_FIELDS = 309] = "UT_DASHBOARDQUERIESMANAGER_FIELDS", e[e.UT_ITEMSCRIPTER_ITEMS = 310] = "UT_ITEMSCRIPTER_ITEMS", e[e.UT_DASHBOARDQUERIESMANAGER_FIELDS_READONLY = 311] = "UT_DASHBOARDQUERIESMANAGER_FIELDS_READONLY", e[e.UT_FSD_RANGES = 312] = "UT_FSD_RANGES", e[e.ADMIN_INFOCUSJOBS_JOBS = 313] = "ADMIN_INFOCUSJOBS_JOBS", e[e.ADMIN_INFOCUSJOBS_JOBSTEPS = 314] = "ADMIN_INFOCUSJOBS_JOBSTEPS", e[e.ADMIN_INFOCUSJOBS_JOBHISTORY = 315] = "ADMIN_INFOCUSJOBS_JOBHISTORY", e[e.AD_GLOBALS_ENCFIELDS = 316] = "AD_GLOBALS_ENCFIELDS", e[e.PO_PURCHASEORDERS_ITEMS = 317] = "PO_PURCHASEORDERS_ITEMS", e[e.HR_EMPLOYEES_APPROVERDELEGATES = 318] = "HR_EMPLOYEES_APPROVERDELEGATES", e[e.HR_EMPLOYEES_SHIPTO = 319] = "HR_EMPLOYEES_SHIPTO", e[e.HR_EMPLOYEES_APPROVALRULES = 320] = "HR_EMPLOYEES_APPROVALRULES", e[e.PO_ITEMS_ITEMS = 321] = "PO_ITEMS_ITEMS", e[e.PO_ITEMS_APPROVALRULES = 322] = "PO_ITEMS_APPROVALRULES", e[e.PO_PURCHASEORDERS_SHIPTOS = 323] = "PO_PURCHASEORDERS_SHIPTOS", e[e.PO_ITEMS_SELECT = 324] = "PO_ITEMS_SELECT", e[e.LOOKUP_PO_PURCHASEORDERS = 325] = "LOOKUP_PO_PURCHASEORDERS", e[e.PO_ITEMS_APPROVERS = 326] = "PO_ITEMS_APPROVERS", e[e.API_RESOURCEGROUPS_ITEMS = 327] = "API_RESOURCEGROUPS_ITEMS", e[e.API_RESOURCES_LIST = 328] = "API_RESOURCES_LIST", e[e.API_RESOURCES_METHODLIST = 329] = "API_RESOURCES_METHODLIST", e[e.API_RESOURCES_QUERYPARAMS = 330] = "API_RESOURCES_QUERYPARAMS", e[e.API_RESOURCES_METHODS = 331] = "API_RESOURCES_METHODS", e[e.API_KEYS_LIST = 332] = "API_KEYS_LIST", e[e.API_RESOURCEGROUPKEYS_LIST = 333] = "API_RESOURCEGROUPKEYS_LIST", e[e.API_RESULTSETS_LIST = 334] = "API_RESULTSETS_LIST", e[e.API_RESULTSETS_COLUMNS = 335] = "API_RESULTSETS_COLUMNS", e[e.API_RESOURCES_QUERYPARAMS_TEST = 336] = "API_RESOURCES_QUERYPARAMS_TEST", e[e.EVENTS_EVENTS_LIST = 337] = "EVENTS_EVENTS_LIST", e[e.EVENTS_WEBHOOKS_LIST = 338] = "EVENTS_WEBHOOKS_LIST", e[e.EVENTS_HISTORY_LIST = 339] = "EVENTS_HISTORY_LIST", e[e.LOOKUP_PO_EXPCODES = 340] = "LOOKUP_PO_EXPCODES", e[e.PO_PURCHASEORDERMANAGEMENT_ITEMS = 341] = "PO_PURCHASEORDERMANAGEMENT_ITEMS", e[e.UT_GLOBALSETTINGS_APPROVALRULES = 342] = "UT_GLOBALSETTINGS_APPROVALRULES", e[e.PO_PURCHASEORDERS_VALIDATIONMESSAGES = 343] = "PO_PURCHASEORDERS_VALIDATIONMESSAGES", e[e.PO_ITEMS_ITEMSELECT = 344] = "PO_ITEMS_ITEMSELECT", e[e.PO_PURCHASEORDERS_ITEM = 345] = "PO_PURCHASEORDERS_ITEM", e[e.PM_PROCESSTEMPLATES_LIST = 346] = "PM_PROCESSTEMPLATES_LIST", e[e.PM_PROCESSTEMPLATES_STAGES_LIST = 347] = "PM_PROCESSTEMPLATES_STAGES_LIST", e[e.PM_PROCESSINSTANCES_LIST = 348] = "PM_PROCESSINSTANCES_LIST", e[e.PM_PROCESSTEMPLATE_CUSTOMFIELDS = 349] = "PM_PROCESSTEMPLATE_CUSTOMFIELDS", e[e.PM_PROCESSINSTANCETEAM_LIST = 350] = "PM_PROCESSINSTANCETEAM_LIST", e[e.PM_PROCESSINSTANCE_STAGEASSIGNMENTS_STAGES = 351] = "PM_PROCESSINSTANCE_STAGEASSIGNMENTS_STAGES", e[e.PM_PROCESSINSTANCEWORKORDERS_ITEMS = 352] = "PM_PROCESSINSTANCEWORKORDERS_ITEMS", e[e.PM_PROCESSINSTANCE_WORKORDERHISTORY = 353] = "PM_PROCESSINSTANCE_WORKORDERHISTORY", e[e.WORKORDER_COMMENTS_LIST = 354] = "WORKORDER_COMMENTS_LIST", e[e.PM_PROCESSTEMPLATE_TAGS = 355] = "PM_PROCESSTEMPLATE_TAGS", e[e.PM_WORKORDER_TAGS = 356] = "PM_WORKORDER_TAGS", e[e.PM_WORKORDER_TODOS = 357] = "PM_WORKORDER_TODOS", e[e.PM_PROCESSINSTANCE_WORKORDER_TIMEHISTORY = 358] = "PM_PROCESSINSTANCE_WORKORDER_TIMEHISTORY", e[e.PM_WORKORDER_TAGS_FILTER = 359] = "PM_WORKORDER_TAGS_FILTER", e[e.PM_WORKORDER_SUBSCRIBERS = 360] = "PM_WORKORDER_SUBSCRIBERS", e[e.EVENTS_MESSAGES_LIST = 361] = "EVENTS_MESSAGES_LIST", e[e.MESSAGES_LIST = 362] = "MESSAGES_LIST", e[e.MESSAGE_VARIABLES = 363] = "MESSAGE_VARIABLES", e[e.MESSAGE_HEADERS = 364] = "MESSAGE_HEADERS", e[e.PM_PROCESSTEMPLATES_ROLES = 365] = "PM_PROCESSTEMPLATES_ROLES", e[e.MESSAGES_WRAPPERS = 366] = "MESSAGES_WRAPPERS", e[e.PE_ES_LINE_DOCS = 367] = "PE_ES_LINE_DOCS", e[e.PM_WORKORDER_STAGES_FILTER = 368] = "PM_WORKORDER_STAGES_FILTER", e[e.PM_PROCESSINSTANCEMEMBERS_LIST = 369] = "PM_PROCESSINSTANCEMEMBERS_LIST", e[e.UT_DASHBOARDGROUPS_EMPLOYEES = 370] = "UT_DASHBOARDGROUPS_EMPLOYEES", e[e.PM_PMCENTRAL_ANALYTICDASHBOARDS = 371] = "PM_PMCENTRAL_ANALYTICDASHBOARDS", e[e.API_RESOURCEKEYS_LIST = 372] = "API_RESOURCEKEYS_LIST", e[e.AD_GLOBALS_WEBHOOKS = 373] = "AD_GLOBALS_WEBHOOKS", e[e.UT_TABLEMANAGER_TABLES = 374] = "UT_TABLEMANAGER_TABLES", e[e.UT_TABLEMANAGER_COLUMNS = 375] = "UT_TABLEMANAGER_COLUMNS", e[e.AD_PROJECTROLES_PROCESSES = 376] = "AD_PROJECTROLES_PROCESSES", e[e.PE_APPROVER_TIMESHEETS = 377] = "PE_APPROVER_TIMESHEETS", e[e.PE_APPROVER_TIMESHEET_DETAIL = 378] = "PE_APPROVER_TIMESHEET_DETAIL", e[e.PE_APPROVER_TIMELIAPROJECTS = 379] = "PE_APPROVER_TIMELIAPROJECTS", e[e.PE_APPROVER_TIMELIALINES = 380] = "PE_APPROVER_TIMELIALINES", e[e.PE_APPROVER_EXPENSESHEETS = 381] = "PE_APPROVER_EXPENSESHEETS", e[e.PE_APPROVER_EXPENSESHEET_DETAIL = 382] = "PE_APPROVER_EXPENSESHEET_DETAIL", e[e.PE_APPROVER_EXPENSELIAPROJECTS = 383] = "PE_APPROVER_EXPENSELIAPROJECTS", e[e.PE_APPROVER_EXPENSELIALINES = 384] = "PE_APPROVER_EXPENSELIALINES", e[e.PE_TIMESHEETS_WORKORDERS = 1381] = "PE_TIMESHEETS_WORKORDERS", e[e.AR_COLLECTIONS_2 = 1382] = "AR_COLLECTIONS_2", e[e.AR_COLLECTIONS_TRANSACTIONS = 1383] = "AR_COLLECTIONS_TRANSACTIONS", e[e.AR_EMAIL_HISTORY = 1384] = "AR_EMAIL_HISTORY", e[e.AD_GLOBALS_POAPPROVERLEVELS = 1385] = "AD_GLOBALS_POAPPROVERLEVELS", e[e.HR_EMPLOYEES_POAPPROVERLEVELS = 1386] = "HR_EMPLOYEES_POAPPROVERLEVELS";
    })(t16.GridEnum || (t16.GridEnum = {}));
  })(HK)), HK;
}
var cke;
function cH0() {
  return cke || (cke = 1, (function(t16) {
    Object.defineProperty(t16, "__esModule", { value: true });
    var e = Z0;
    e.__exportStar(Yu0(), t16), e.__exportStar(Ju0(), t16), e.__exportStar(Ku0(), t16), e.__exportStar(Qu0(), t16), e.__exportStar(Zu0(), t16), e.__exportStar(es0(), t16), e.__exportStar(ts0(), t16), e.__exportStar(rs0(), t16), e.__exportStar(ns0(), t16), e.__exportStar(as0(), t16), e.__exportStar(os0(), t16), e.__exportStar(is0(), t16), e.__exportStar(us0(), t16), e.__exportStar(ss0(), t16), e.__exportStar(cs0(), t16), e.__exportStar(ls0(), t16), e.__exportStar(ps0(), t16), e.__exportStar(ds0(), t16), e.__exportStar(fs0(), t16), e.__exportStar(bs0(), t16), e.__exportStar(Ms0(), t16), e.__exportStar(Os0(), t16), e.__exportStar(zs0(), t16), e.__exportStar(As0(), t16), e.__exportStar(_s0(), t16), e.__exportStar(hs0(), t16), e.__exportStar(vs0(), t16), e.__exportStar(ms0(), t16), e.__exportStar(Rs0(), t16), e.__exportStar(qs0(), t16), e.__exportStar(Ts0(), t16), e.__exportStar(ys0(), t16), e.__exportStar(Ss0(), t16), e.__exportStar(Cs0(), t16), e.__exportStar(gs0(), t16), e.__exportStar(Is0(), t16), e.__exportStar(Es0(), t16), e.__exportStar(Ls0(), t16), e.__exportStar(Ps0(), t16), e.__exportStar(Ds0(), t16), e.__exportStar(Ws0(), t16), e.__exportStar(Ns0(), t16), e.__exportStar(ws0(), t16), e.__exportStar(Bs0(), t16), e.__exportStar(xs0(), t16), e.__exportStar(Us0(), t16), e.__exportStar(ks0(), t16), e.__exportStar(js0(), t16), e.__exportStar(Fs0(), t16), e.__exportStar(Vs0(), t16), e.__exportStar(Hs0(), t16), e.__exportStar(Xs0(), t16), e.__exportStar($s0(), t16), e.__exportStar(Gs0(), t16), e.__exportStar(Ys0(), t16), e.__exportStar(Js0(), t16), e.__exportStar(Ks0(), t16), e.__exportStar(Qs0(), t16), e.__exportStar(Zs0(), t16), e.__exportStar(ec0(), t16), e.__exportStar(tc0(), t16), e.__exportStar(rc0(), t16), e.__exportStar(nc0(), t16), e.__exportStar(ac0(), t16), e.__exportStar(oc0(), t16), e.__exportStar(ic0(), t16), e.__exportStar(uc0(), t16), e.__exportStar(sc0(), t16), e.__exportStar(cc0(), t16), e.__exportStar(lc0(), t16), e.__exportStar(pc0(), t16), e.__exportStar(dc0(), t16), e.__exportStar(fc0(), t16), e.__exportStar(bc0(), t16), e.__exportStar(Mc0(), t16), e.__exportStar(Oc0(), t16), e.__exportStar(zc0(), t16), e.__exportStar(Ac0(), t16), e.__exportStar(_c0(), t16), e.__exportStar(hc0(), t16), e.__exportStar(vc0(), t16), e.__exportStar(mc0(), t16), e.__exportStar(Rc0(), t16), e.__exportStar(qc0(), t16), e.__exportStar(Tc0(), t16), e.__exportStar(yc0(), t16), e.__exportStar(Sc0(), t16), e.__exportStar(Cc0(), t16), e.__exportStar(gc0(), t16), e.__exportStar(Ic0(), t16), e.__exportStar(Ec0(), t16), e.__exportStar(Lc0(), t16), e.__exportStar(Pc0(), t16), e.__exportStar(Dc0(), t16), e.__exportStar(Wc0(), t16), e.__exportStar(Nc0(), t16), e.__exportStar(wc0(), t16), e.__exportStar(Bc0(), t16), e.__exportStar(xc0(), t16), e.__exportStar(Uc0(), t16), e.__exportStar(kc0(), t16), e.__exportStar(jc0(), t16), e.__exportStar(Fc0(), t16), e.__exportStar(Vc0(), t16), e.__exportStar(Hc0(), t16), e.__exportStar(Xc0(), t16), e.__exportStar($c0(), t16), e.__exportStar(Gc0(), t16), e.__exportStar(Yc0(), t16), e.__exportStar(Jc0(), t16), e.__exportStar(Kc0(), t16), e.__exportStar(Qc0(), t16), e.__exportStar(Zc0(), t16), e.__exportStar(el0(), t16), e.__exportStar(tl0(), t16), e.__exportStar(rl0(), t16), e.__exportStar(nl0(), t16), e.__exportStar(al0(), t16), e.__exportStar(ol0(), t16), e.__exportStar(il0(), t16), e.__exportStar(ul0(), t16), e.__exportStar(sl0(), t16), e.__exportStar(cl0(), t16), e.__exportStar(ll0(), t16), e.__exportStar(pl0(), t16), e.__exportStar(dl0(), t16), e.__exportStar(fl0(), t16), e.__exportStar(bl0(), t16), e.__exportStar(Ml0(), t16), e.__exportStar(Ol0(), t16), e.__exportStar(zl0(), t16), e.__exportStar(Al0(), t16), e.__exportStar(_l0(), t16), e.__exportStar(hl0(), t16), e.__exportStar(vl0(), t16), e.__exportStar(ml0(), t16), e.__exportStar(Rl0(), t16), e.__exportStar(ql0(), t16), e.__exportStar(Tl0(), t16), e.__exportStar(yl0(), t16), e.__exportStar(Sl0(), t16), e.__exportStar(Cl0(), t16), e.__exportStar(gl0(), t16), e.__exportStar(Il0(), t16), e.__exportStar(El0(), t16), e.__exportStar(Ll0(), t16), e.__exportStar(Pl0(), t16), e.__exportStar(Dl0(), t16), e.__exportStar(Wl0(), t16), e.__exportStar(Nl0(), t16), e.__exportStar(wl0(), t16), e.__exportStar(Bl0(), t16), e.__exportStar(xl0(), t16), e.__exportStar(Ul0(), t16), e.__exportStar(kl0(), t16), e.__exportStar(jl0(), t16), e.__exportStar(Fl0(), t16), e.__exportStar(Vl0(), t16), e.__exportStar(Hl0(), t16), e.__exportStar(Xl0(), t16), e.__exportStar($l0(), t16), e.__exportStar(Gl0(), t16), e.__exportStar(Yl0(), t16), e.__exportStar(Jl0(), t16), e.__exportStar(Kl0(), t16), e.__exportStar(Ql0(), t16), e.__exportStar(Zl0(), t16), e.__exportStar(e20(), t16), e.__exportStar(t20(), t16), e.__exportStar(r20(), t16), e.__exportStar(n20(), t16), e.__exportStar(a20(), t16), e.__exportStar(o20(), t16), e.__exportStar(i20(), t16), e.__exportStar(u20(), t16), e.__exportStar(s20(), t16), e.__exportStar(c20(), t16), e.__exportStar(l20(), t16), e.__exportStar(p20(), t16), e.__exportStar(d20(), t16), e.__exportStar(f20(), t16), e.__exportStar(b20(), t16), e.__exportStar(M20(), t16), e.__exportStar(O20(), t16), e.__exportStar(z20(), t16), e.__exportStar(A20(), t16), e.__exportStar(_20(), t16), e.__exportStar(h20(), t16), e.__exportStar(v20(), t16), e.__exportStar(m20(), t16), e.__exportStar(R20(), t16), e.__exportStar(q20(), t16), e.__exportStar(T20(), t16), e.__exportStar(y20(), t16), e.__exportStar(S20(), t16), e.__exportStar(C20(), t16), e.__exportStar(g20(), t16), e.__exportStar(I20(), t16), e.__exportStar(E20(), t16), e.__exportStar(L20(), t16), e.__exportStar(P20(), t16), e.__exportStar(D20(), t16), e.__exportStar(W20(), t16), e.__exportStar(N20(), t16), e.__exportStar(w20(), t16), e.__exportStar(B20(), t16), e.__exportStar(x20(), t16), e.__exportStar(U20(), t16), e.__exportStar(k20(), t16), e.__exportStar(j20(), t16), e.__exportStar(F20(), t16), e.__exportStar(V20(), t16), e.__exportStar(H20(), t16), e.__exportStar(X20(), t16), e.__exportStar($20(), t16), e.__exportStar(G20(), t16), e.__exportStar(Y20(), t16), e.__exportStar(J20(), t16), e.__exportStar(K20(), t16), e.__exportStar(Q20(), t16), e.__exportStar(Z20(), t16), e.__exportStar(ep0(), t16), e.__exportStar(tp0(), t16), e.__exportStar(rp0(), t16), e.__exportStar(np0(), t16), e.__exportStar(ap0(), t16), e.__exportStar(op0(), t16), e.__exportStar(ip0(), t16), e.__exportStar(up0(), t16), e.__exportStar(sp0(), t16), e.__exportStar(cp0(), t16), e.__exportStar(lp0(), t16), e.__exportStar(pp0(), t16), e.__exportStar(dp0(), t16), e.__exportStar(fp0(), t16), e.__exportStar(bp0(), t16), e.__exportStar(Mp0(), t16), e.__exportStar(Op0(), t16), e.__exportStar(zp0(), t16), e.__exportStar(Ap0(), t16), e.__exportStar(_p0(), t16), e.__exportStar(hp0(), t16), e.__exportStar(vp0(), t16), e.__exportStar(mp0(), t16), e.__exportStar(Rp0(), t16), e.__exportStar(qp0(), t16), e.__exportStar(Tp0(), t16), e.__exportStar(yp0(), t16), e.__exportStar(Sp0(), t16), e.__exportStar(Cp0(), t16), e.__exportStar(gp0(), t16), e.__exportStar(Ip0(), t16), e.__exportStar(Ep0(), t16), e.__exportStar(Lp0(), t16), e.__exportStar(Pp0(), t16), e.__exportStar(Dp0(), t16), e.__exportStar(Wp0(), t16), e.__exportStar(Np0(), t16), e.__exportStar(wp0(), t16), e.__exportStar(Bp0(), t16), e.__exportStar(xp0(), t16), e.__exportStar(Up0(), t16), e.__exportStar(kp0(), t16), e.__exportStar(jp0(), t16), e.__exportStar(Fp0(), t16), e.__exportStar(Vp0(), t16), e.__exportStar(Hp0(), t16), e.__exportStar(Xp0(), t16), e.__exportStar($p0(), t16), e.__exportStar(Gp0(), t16), e.__exportStar(Yp0(), t16), e.__exportStar(Jp0(), t16), e.__exportStar(Kp0(), t16), e.__exportStar(Qp0(), t16), e.__exportStar(Zp0(), t16), e.__exportStar(ed0(), t16), e.__exportStar(td0(), t16), e.__exportStar(rd0(), t16), e.__exportStar(nd0(), t16), e.__exportStar(ad0(), t16), e.__exportStar(od0(), t16), e.__exportStar(id0(), t16), e.__exportStar(ud0(), t16), e.__exportStar(sd0(), t16), e.__exportStar(cd0(), t16), e.__exportStar(ld0(), t16), e.__exportStar(pd0(), t16), e.__exportStar(dd0(), t16), e.__exportStar(fd0(), t16), e.__exportStar(bd0(), t16), e.__exportStar(Md0(), t16), e.__exportStar(Od0(), t16), e.__exportStar(zd0(), t16), e.__exportStar(Ad0(), t16), e.__exportStar(_d0(), t16), e.__exportStar(hd0(), t16), e.__exportStar(vd0(), t16), e.__exportStar(md0(), t16), e.__exportStar(Rd0(), t16), e.__exportStar(qd0(), t16), e.__exportStar(Td0(), t16), e.__exportStar(yd0(), t16), e.__exportStar(Sd0(), t16), e.__exportStar(Cd0(), t16), e.__exportStar(gd0(), t16), e.__exportStar(Id0(), t16), e.__exportStar(Ed0(), t16), e.__exportStar(Ld0(), t16), e.__exportStar(Pd0(), t16), e.__exportStar(Dd0(), t16), e.__exportStar(Wd0(), t16), e.__exportStar(Nd0(), t16), e.__exportStar(wd0(), t16), e.__exportStar(Bd0(), t16), e.__exportStar(xd0(), t16), e.__exportStar(Ud0(), t16), e.__exportStar(kd0(), t16), e.__exportStar(jd0(), t16), e.__exportStar(Fd0(), t16), e.__exportStar(Vd0(), t16), e.__exportStar(Hd0(), t16), e.__exportStar(Xd0(), t16), e.__exportStar($d0(), t16), e.__exportStar(Gd0(), t16), e.__exportStar(Yd0(), t16), e.__exportStar(Jd0(), t16), e.__exportStar(Kd0(), t16), e.__exportStar(Qd0(), t16), e.__exportStar(Zd0(), t16), e.__exportStar(ef0(), t16), e.__exportStar(tf0(), t16), e.__exportStar(rf0(), t16), e.__exportStar(nf0(), t16), e.__exportStar(af0(), t16), e.__exportStar(of0(), t16), e.__exportStar(if0(), t16), e.__exportStar(uf0(), t16), e.__exportStar(sf0(), t16), e.__exportStar(cf0(), t16), e.__exportStar(lf0(), t16), e.__exportStar(pf0(), t16), e.__exportStar(df0(), t16), e.__exportStar(ff0(), t16), e.__exportStar(bf0(), t16), e.__exportStar(Mf0(), t16), e.__exportStar(Of0(), t16), e.__exportStar(zf0(), t16), e.__exportStar(Af0(), t16), e.__exportStar(_f0(), t16), e.__exportStar(hf0(), t16), e.__exportStar(vf0(), t16), e.__exportStar(mf0(), t16), e.__exportStar(Rf0(), t16), e.__exportStar(qf0(), t16), e.__exportStar(Tf0(), t16), e.__exportStar(yf0(), t16), e.__exportStar(Sf0(), t16), e.__exportStar(Cf0(), t16), e.__exportStar(gf0(), t16), e.__exportStar(If0(), t16), e.__exportStar(Ef0(), t16), e.__exportStar(Lf0(), t16), e.__exportStar(Pf0(), t16), e.__exportStar(Df0(), t16), e.__exportStar(Wf0(), t16), e.__exportStar(Nf0(), t16), e.__exportStar(wf0(), t16), e.__exportStar(Bf0(), t16), e.__exportStar(xf0(), t16), e.__exportStar(Uf0(), t16), e.__exportStar(kf0(), t16), e.__exportStar(jf0(), t16), e.__exportStar(Ff0(), t16), e.__exportStar(Vf0(), t16), e.__exportStar(Hf0(), t16), e.__exportStar(Xf0(), t16), e.__exportStar($f0(), t16), e.__exportStar(Gf0(), t16), e.__exportStar(Yf0(), t16), e.__exportStar(Jf0(), t16), e.__exportStar(Kf0(), t16), e.__exportStar(Qf0(), t16), e.__exportStar(Zf0(), t16), e.__exportStar(eb0(), t16), e.__exportStar(tb0(), t16), e.__exportStar(rb0(), t16), e.__exportStar(nb0(), t16), e.__exportStar(ab0(), t16), e.__exportStar(ob0(), t16), e.__exportStar(ib0(), t16), e.__exportStar(ub0(), t16), e.__exportStar(sb0(), t16), e.__exportStar(cb0(), t16), e.__exportStar(lb0(), t16), e.__exportStar(pb0(), t16), e.__exportStar(db0(), t16), e.__exportStar(fb0(), t16), e.__exportStar(bb0(), t16), e.__exportStar(Mb0(), t16), e.__exportStar(Ob0(), t16), e.__exportStar(zb0(), t16), e.__exportStar(Ab0(), t16), e.__exportStar(_b0(), t16), e.__exportStar(hb0(), t16), e.__exportStar(vb0(), t16), e.__exportStar(mb0(), t16), e.__exportStar(Rb0(), t16), e.__exportStar(qb0(), t16), e.__exportStar(Tb0(), t16), e.__exportStar(yb0(), t16), e.__exportStar(Sb0(), t16), e.__exportStar(Cb0(), t16), e.__exportStar(gb0(), t16), e.__exportStar(Ib0(), t16), e.__exportStar(Eb0(), t16), e.__exportStar(Lb0(), t16), e.__exportStar(Pb0(), t16), e.__exportStar(Db0(), t16), e.__exportStar(Wb0(), t16), e.__exportStar(Nb0(), t16), e.__exportStar(wb0(), t16), e.__exportStar(Bb0(), t16), e.__exportStar(xb0(), t16), e.__exportStar(Ub0(), t16), e.__exportStar(kb0(), t16), e.__exportStar(jb0(), t16), e.__exportStar(Fb0(), t16), e.__exportStar(Vb0(), t16), e.__exportStar(Hb0(), t16), e.__exportStar(Xb0(), t16), e.__exportStar($b0(), t16), e.__exportStar(Gb0(), t16), e.__exportStar(Yb0(), t16), e.__exportStar(Jb0(), t16), e.__exportStar(Kb0(), t16), e.__exportStar(Qb0(), t16), e.__exportStar(Zb0(), t16), e.__exportStar(eM0(), t16), e.__exportStar(tM0(), t16), e.__exportStar(rM0(), t16), e.__exportStar(nM0(), t16), e.__exportStar(aM0(), t16), e.__exportStar(oM0(), t16), e.__exportStar(iM0(), t16), e.__exportStar(uM0(), t16), e.__exportStar(sM0(), t16), e.__exportStar(cM0(), t16), e.__exportStar(lM0(), t16), e.__exportStar(pM0(), t16), e.__exportStar(dM0(), t16), e.__exportStar(fM0(), t16), e.__exportStar(bM0(), t16), e.__exportStar(MM0(), t16), e.__exportStar(OM0(), t16), e.__exportStar(zM0(), t16), e.__exportStar(AM0(), t16), e.__exportStar(_M0(), t16), e.__exportStar(hM0(), t16), e.__exportStar(vM0(), t16), e.__exportStar(mM0(), t16), e.__exportStar(RM0(), t16), e.__exportStar(qM0(), t16), e.__exportStar(TM0(), t16), e.__exportStar(yM0(), t16), e.__exportStar(SM0(), t16), e.__exportStar(CM0(), t16), e.__exportStar(gM0(), t16), e.__exportStar(IM0(), t16), e.__exportStar(EM0(), t16), e.__exportStar(LM0(), t16), e.__exportStar(PM0(), t16), e.__exportStar(DM0(), t16), e.__exportStar(WM0(), t16), e.__exportStar(NM0(), t16), e.__exportStar(wM0(), t16), e.__exportStar(BM0(), t16), e.__exportStar(xM0(), t16), e.__exportStar(UM0(), t16), e.__exportStar(kM0(), t16), e.__exportStar(jM0(), t16), e.__exportStar(FM0(), t16), e.__exportStar(VM0(), t16), e.__exportStar(HM0(), t16), e.__exportStar(XM0(), t16), e.__exportStar($M0(), t16), e.__exportStar(GM0(), t16), e.__exportStar(YM0(), t16), e.__exportStar(JM0(), t16), e.__exportStar(KM0(), t16), e.__exportStar(QM0(), t16), e.__exportStar(ZM0(), t16), e.__exportStar(eO0(), t16), e.__exportStar(tO0(), t16), e.__exportStar(rO0(), t16), e.__exportStar(nO0(), t16), e.__exportStar(aO0(), t16), e.__exportStar(oO0(), t16), e.__exportStar(iO0(), t16), e.__exportStar(uO0(), t16), e.__exportStar(sO0(), t16), e.__exportStar(cO0(), t16), e.__exportStar(lO0(), t16), e.__exportStar(pO0(), t16), e.__exportStar(dO0(), t16), e.__exportStar(fO0(), t16), e.__exportStar(bO0(), t16), e.__exportStar(MO0(), t16), e.__exportStar(OO0(), t16), e.__exportStar(zO0(), t16), e.__exportStar(AO0(), t16), e.__exportStar(_O0(), t16), e.__exportStar(hO0(), t16), e.__exportStar(vO0(), t16), e.__exportStar(mO0(), t16), e.__exportStar(RO0(), t16), e.__exportStar(qO0(), t16), e.__exportStar(TO0(), t16), e.__exportStar(yO0(), t16), e.__exportStar(SO0(), t16), e.__exportStar(CO0(), t16), e.__exportStar(gO0(), t16), e.__exportStar(IO0(), t16), e.__exportStar(EO0(), t16), e.__exportStar(LO0(), t16), e.__exportStar(PO0(), t16), e.__exportStar(DO0(), t16), e.__exportStar(WO0(), t16), e.__exportStar(NO0(), t16), e.__exportStar(wO0(), t16), e.__exportStar(BO0(), t16), e.__exportStar(xO0(), t16), e.__exportStar(UO0(), t16), e.__exportStar(kO0(), t16), e.__exportStar(jO0(), t16), e.__exportStar(FO0(), t16), e.__exportStar(VO0(), t16), e.__exportStar(HO0(), t16), e.__exportStar(XO0(), t16), e.__exportStar($O0(), t16), e.__exportStar(GO0(), t16), e.__exportStar(YO0(), t16), e.__exportStar(JO0(), t16), e.__exportStar(KO0(), t16), e.__exportStar(QO0(), t16), e.__exportStar(ZO0(), t16), e.__exportStar(e30(), t16), e.__exportStar(t30(), t16), e.__exportStar(r30(), t16), e.__exportStar(n30(), t16), e.__exportStar(a30(), t16), e.__exportStar(o30(), t16), e.__exportStar(i30(), t16), e.__exportStar(u30(), t16), e.__exportStar(s30(), t16), e.__exportStar(c30(), t16), e.__exportStar(l30(), t16), e.__exportStar(p30(), t16), e.__exportStar(d30(), t16), e.__exportStar(f30(), t16), e.__exportStar(b30(), t16), e.__exportStar(M30(), t16), e.__exportStar(O30(), t16), e.__exportStar(z30(), t16), e.__exportStar(A30(), t16), e.__exportStar(_30(), t16), e.__exportStar(h30(), t16), e.__exportStar(v30(), t16), e.__exportStar(m30(), t16), e.__exportStar(R30(), t16), e.__exportStar(q30(), t16), e.__exportStar(T30(), t16), e.__exportStar(y30(), t16), e.__exportStar(S30(), t16), e.__exportStar(C30(), t16), e.__exportStar(g30(), t16), e.__exportStar(I30(), t16), e.__exportStar(E30(), t16), e.__exportStar(L30(), t16), e.__exportStar(P30(), t16), e.__exportStar(D30(), t16), e.__exportStar(W30(), t16), e.__exportStar(N30(), t16), e.__exportStar(w30(), t16), e.__exportStar(B30(), t16), e.__exportStar(x30(), t16), e.__exportStar(U30(), t16), e.__exportStar(k30(), t16), e.__exportStar(j30(), t16), e.__exportStar(F30(), t16), e.__exportStar(V30(), t16), e.__exportStar(H30(), t16), e.__exportStar(X30(), t16), e.__exportStar($30(), t16), e.__exportStar(G30(), t16), e.__exportStar(Y30(), t16), e.__exportStar(J30(), t16), e.__exportStar(K30(), t16), e.__exportStar(Q30(), t16), e.__exportStar(Z30(), t16), e.__exportStar(ez0(), t16), e.__exportStar(tz0(), t16), e.__exportStar(rz0(), t16), e.__exportStar(nz0(), t16), e.__exportStar(az0(), t16), e.__exportStar(oz0(), t16), e.__exportStar(iz0(), t16), e.__exportStar(uz0(), t16), e.__exportStar(sz0(), t16), e.__exportStar(cz0(), t16), e.__exportStar(lz0(), t16), e.__exportStar(pz0(), t16), e.__exportStar(dz0(), t16), e.__exportStar(fz0(), t16), e.__exportStar(bz0(), t16), e.__exportStar(Mz0(), t16), e.__exportStar(Oz0(), t16), e.__exportStar(zz0(), t16), e.__exportStar(Az0(), t16), e.__exportStar(_z0(), t16), e.__exportStar(hz0(), t16), e.__exportStar(vz0(), t16), e.__exportStar(mz0(), t16), e.__exportStar(Rz0(), t16), e.__exportStar(qz0(), t16), e.__exportStar(Tz0(), t16), e.__exportStar(yz0(), t16), e.__exportStar(Sz0(), t16), e.__exportStar(Cz0(), t16), e.__exportStar(gz0(), t16), e.__exportStar(Iz0(), t16), e.__exportStar(Ez0(), t16), e.__exportStar(Lz0(), t16), e.__exportStar(Pz0(), t16), e.__exportStar(Dz0(), t16), e.__exportStar(Wz0(), t16), e.__exportStar(Nz0(), t16), e.__exportStar(wz0(), t16), e.__exportStar(Bz0(), t16), e.__exportStar(xz0(), t16), e.__exportStar(Uz0(), t16), e.__exportStar(kz0(), t16), e.__exportStar(jz0(), t16), e.__exportStar(Fz0(), t16), e.__exportStar(Vz0(), t16), e.__exportStar(Hz0(), t16), e.__exportStar(Xz0(), t16), e.__exportStar($z0(), t16), e.__exportStar(Gz0(), t16), e.__exportStar(Yz0(), t16), e.__exportStar(Jz0(), t16), e.__exportStar(Kz0(), t16), e.__exportStar(Qz0(), t16), e.__exportStar(Zz0(), t16), e.__exportStar(eA0(), t16), e.__exportStar(tA0(), t16), e.__exportStar(rA0(), t16), e.__exportStar(nA0(), t16), e.__exportStar(aA0(), t16), e.__exportStar(oA0(), t16), e.__exportStar(iA0(), t16), e.__exportStar(uA0(), t16), e.__exportStar(sA0(), t16), e.__exportStar(cA0(), t16), e.__exportStar(lA0(), t16), e.__exportStar(pA0(), t16), e.__exportStar(dA0(), t16), e.__exportStar(fA0(), t16), e.__exportStar(bA0(), t16), e.__exportStar(MA0(), t16), e.__exportStar(OA0(), t16), e.__exportStar(zA0(), t16), e.__exportStar(AA0(), t16), e.__exportStar(_A0(), t16), e.__exportStar(hA0(), t16), e.__exportStar(vA0(), t16), e.__exportStar(mA0(), t16), e.__exportStar(RA0(), t16), e.__exportStar(qA0(), t16), e.__exportStar(TA0(), t16), e.__exportStar(yA0(), t16), e.__exportStar(SA0(), t16), e.__exportStar(CA0(), t16), e.__exportStar(gA0(), t16), e.__exportStar(IA0(), t16), e.__exportStar(EA0(), t16), e.__exportStar(LA0(), t16), e.__exportStar(PA0(), t16), e.__exportStar(DA0(), t16), e.__exportStar(WA0(), t16), e.__exportStar(NA0(), t16), e.__exportStar(wA0(), t16), e.__exportStar(BA0(), t16), e.__exportStar(xA0(), t16), e.__exportStar(UA0(), t16), e.__exportStar(kA0(), t16), e.__exportStar(jA0(), t16), e.__exportStar(FA0(), t16), e.__exportStar(VA0(), t16), e.__exportStar(HA0(), t16), e.__exportStar(XA0(), t16), e.__exportStar($A0(), t16), e.__exportStar(GA0(), t16), e.__exportStar(YA0(), t16), e.__exportStar(JA0(), t16), e.__exportStar(KA0(), t16), e.__exportStar(QA0(), t16), e.__exportStar(ZA0(), t16), e.__exportStar(e_0(), t16), e.__exportStar(t_0(), t16), e.__exportStar(r_0(), t16), e.__exportStar(n_0(), t16), e.__exportStar(a_0(), t16), e.__exportStar(o_0(), t16), e.__exportStar(i_0(), t16), e.__exportStar(u_0(), t16), e.__exportStar(s_0(), t16), e.__exportStar(c_0(), t16), e.__exportStar(l_0(), t16), e.__exportStar(p_0(), t16), e.__exportStar(d_0(), t16), e.__exportStar(f_0(), t16), e.__exportStar(b_0(), t16), e.__exportStar(M_0(), t16), e.__exportStar(O_0(), t16), e.__exportStar(z_0(), t16), e.__exportStar(A_0(), t16), e.__exportStar(__0(), t16), e.__exportStar(h_0(), t16), e.__exportStar(v_0(), t16), e.__exportStar(m_0(), t16), e.__exportStar(R_0(), t16), e.__exportStar(q_0(), t16), e.__exportStar(T_0(), t16), e.__exportStar(y_0(), t16), e.__exportStar(S_0(), t16), e.__exportStar(C_0(), t16), e.__exportStar(g_0(), t16), e.__exportStar(I_0(), t16), e.__exportStar(E_0(), t16), e.__exportStar(L_0(), t16), e.__exportStar(P_0(), t16), e.__exportStar(D_0(), t16), e.__exportStar(W_0(), t16), e.__exportStar(N_0(), t16), e.__exportStar(w_0(), t16), e.__exportStar(B_0(), t16), e.__exportStar(x_0(), t16), e.__exportStar(U_0(), t16), e.__exportStar(k_0(), t16), e.__exportStar(j_0(), t16), e.__exportStar(F_0(), t16), e.__exportStar(V_0(), t16), e.__exportStar(H_0(), t16), e.__exportStar(X_0(), t16), e.__exportStar($_0(), t16), e.__exportStar(G_0(), t16), e.__exportStar(Y_0(), t16), e.__exportStar(J_0(), t16), e.__exportStar(K_0(), t16), e.__exportStar(Q_0(), t16), e.__exportStar(Z_0(), t16), e.__exportStar(eh0(), t16), e.__exportStar(th0(), t16), e.__exportStar(rh0(), t16), e.__exportStar(nh0(), t16), e.__exportStar(ah0(), t16), e.__exportStar(oh0(), t16), e.__exportStar(ih0(), t16), e.__exportStar(uh0(), t16), e.__exportStar(sh0(), t16), e.__exportStar(ch0(), t16), e.__exportStar(lh0(), t16), e.__exportStar(ph0(), t16), e.__exportStar(dh0(), t16), e.__exportStar(fh0(), t16), e.__exportStar(bh0(), t16), e.__exportStar(Mh0(), t16), e.__exportStar(Oh0(), t16), e.__exportStar(zh0(), t16), e.__exportStar(Ah0(), t16), e.__exportStar(_h0(), t16), e.__exportStar(hh0(), t16), e.__exportStar(vh0(), t16), e.__exportStar(mh0(), t16), e.__exportStar(Rh0(), t16), e.__exportStar(qh0(), t16), e.__exportStar(Th0(), t16), e.__exportStar(yh0(), t16), e.__exportStar(Sh0(), t16), e.__exportStar(Ch0(), t16), e.__exportStar(gh0(), t16), e.__exportStar(Ih0(), t16), e.__exportStar(Eh0(), t16), e.__exportStar(Lh0(), t16), e.__exportStar(Ph0(), t16), e.__exportStar(Dh0(), t16), e.__exportStar(Wh0(), t16), e.__exportStar(Nh0(), t16), e.__exportStar(wh0(), t16), e.__exportStar(Bh0(), t16), e.__exportStar(xh0(), t16), e.__exportStar(Uh0(), t16), e.__exportStar(kh0(), t16), e.__exportStar(jh0(), t16), e.__exportStar(Fh0(), t16), e.__exportStar(Vh0(), t16), e.__exportStar(Hh0(), t16), e.__exportStar(Xh0(), t16), e.__exportStar($h0(), t16), e.__exportStar(Gh0(), t16), e.__exportStar(Yh0(), t16), e.__exportStar(Jh0(), t16), e.__exportStar(Kh0(), t16), e.__exportStar(Qh0(), t16), e.__exportStar(Zh0(), t16), e.__exportStar(ev0(), t16), e.__exportStar(tv0(), t16), e.__exportStar(rv0(), t16), e.__exportStar(nv0(), t16), e.__exportStar(av0(), t16), e.__exportStar(ov0(), t16), e.__exportStar(iv0(), t16), e.__exportStar(uv0(), t16), e.__exportStar(sv0(), t16), e.__exportStar(cv0(), t16), e.__exportStar(lv0(), t16), e.__exportStar(pv0(), t16), e.__exportStar(dv0(), t16), e.__exportStar(fv0(), t16), e.__exportStar(bv0(), t16), e.__exportStar(Mv0(), t16), e.__exportStar(Ov0(), t16), e.__exportStar(zv0(), t16), e.__exportStar(Av0(), t16), e.__exportStar(_v0(), t16), e.__exportStar(hv0(), t16), e.__exportStar(vv0(), t16), e.__exportStar(mv0(), t16), e.__exportStar(Rv0(), t16), e.__exportStar(qv0(), t16), e.__exportStar(Tv0(), t16), e.__exportStar(yv0(), t16), e.__exportStar(Sv0(), t16), e.__exportStar(Cv0(), t16), e.__exportStar(gv0(), t16), e.__exportStar(Iv0(), t16), e.__exportStar(Ev0(), t16), e.__exportStar(Lv0(), t16), e.__exportStar(Pv0(), t16), e.__exportStar(Dv0(), t16), e.__exportStar(Wv0(), t16), e.__exportStar(Nv0(), t16), e.__exportStar(wv0(), t16), e.__exportStar(Bv0(), t16), e.__exportStar(xv0(), t16), e.__exportStar(Uv0(), t16), e.__exportStar(kv0(), t16), e.__exportStar(jv0(), t16), e.__exportStar(Fv0(), t16), e.__exportStar(Vv0(), t16), e.__exportStar(Hv0(), t16), e.__exportStar(Xv0(), t16), e.__exportStar($v0(), t16), e.__exportStar(Gv0(), t16), e.__exportStar(Yv0(), t16), e.__exportStar(Jv0(), t16), e.__exportStar(Kv0(), t16), e.__exportStar(Qv0(), t16), e.__exportStar(Zv0(), t16), e.__exportStar(em0(), t16), e.__exportStar(tm0(), t16), e.__exportStar(rm0(), t16), e.__exportStar(nm0(), t16), e.__exportStar(am0(), t16), e.__exportStar(om0(), t16), e.__exportStar(im0(), t16), e.__exportStar(um0(), t16), e.__exportStar(sm0(), t16), e.__exportStar(cm0(), t16), e.__exportStar(lm0(), t16), e.__exportStar(pm0(), t16), e.__exportStar(dm0(), t16), e.__exportStar(fm0(), t16), e.__exportStar(bm0(), t16), e.__exportStar(Mm0(), t16), e.__exportStar(Om0(), t16), e.__exportStar(zm0(), t16), e.__exportStar(Am0(), t16), e.__exportStar(_m0(), t16), e.__exportStar(hm0(), t16), e.__exportStar(vm0(), t16), e.__exportStar(mm0(), t16), e.__exportStar(Rm0(), t16), e.__exportStar(qm0(), t16), e.__exportStar(Tm0(), t16), e.__exportStar(ym0(), t16), e.__exportStar(Sm0(), t16), e.__exportStar(Cm0(), t16), e.__exportStar(gm0(), t16), e.__exportStar(Im0(), t16), e.__exportStar(Em0(), t16), e.__exportStar(Lm0(), t16), e.__exportStar(Pm0(), t16), e.__exportStar(Dm0(), t16), e.__exportStar(Wm0(), t16), e.__exportStar(Nm0(), t16), e.__exportStar(wm0(), t16), e.__exportStar(Bm0(), t16), e.__exportStar(xm0(), t16), e.__exportStar(Um0(), t16), e.__exportStar(km0(), t16), e.__exportStar(jm0(), t16), e.__exportStar(Fm0(), t16), e.__exportStar(Vm0(), t16), e.__exportStar(Hm0(), t16), e.__exportStar(Xm0(), t16), e.__exportStar($m0(), t16), e.__exportStar(Gm0(), t16), e.__exportStar(Ym0(), t16), e.__exportStar(Jm0(), t16), e.__exportStar(Km0(), t16), e.__exportStar(Qm0(), t16), e.__exportStar(Zm0(), t16), e.__exportStar(eR0(), t16), e.__exportStar(tR0(), t16), e.__exportStar(rR0(), t16), e.__exportStar(nR0(), t16), e.__exportStar(aR0(), t16), e.__exportStar(oR0(), t16), e.__exportStar(iR0(), t16), e.__exportStar(uR0(), t16), e.__exportStar(sR0(), t16), e.__exportStar(cR0(), t16), e.__exportStar(lR0(), t16), e.__exportStar(pR0(), t16), e.__exportStar(dR0(), t16), e.__exportStar(fR0(), t16), e.__exportStar(bR0(), t16), e.__exportStar(MR0(), t16), e.__exportStar(OR0(), t16), e.__exportStar(zR0(), t16), e.__exportStar(AR0(), t16), e.__exportStar(_R0(), t16), e.__exportStar(hR0(), t16), e.__exportStar(vR0(), t16), e.__exportStar(mR0(), t16), e.__exportStar(RR0(), t16), e.__exportStar(qR0(), t16), e.__exportStar(TR0(), t16), e.__exportStar(yR0(), t16), e.__exportStar(SR0(), t16), e.__exportStar(CR0(), t16), e.__exportStar(gR0(), t16), e.__exportStar(IR0(), t16), e.__exportStar(ER0(), t16), e.__exportStar(LR0(), t16), e.__exportStar(PR0(), t16), e.__exportStar(DR0(), t16), e.__exportStar(WR0(), t16), e.__exportStar(NR0(), t16), e.__exportStar(wR0(), t16), e.__exportStar(BR0(), t16), e.__exportStar(xR0(), t16), e.__exportStar(UR0(), t16), e.__exportStar(kR0(), t16), e.__exportStar(jR0(), t16), e.__exportStar(FR0(), t16), e.__exportStar(VR0(), t16), e.__exportStar(HR0(), t16), e.__exportStar(XR0(), t16), e.__exportStar($R0(), t16), e.__exportStar(GR0(), t16), e.__exportStar(YR0(), t16), e.__exportStar(JR0(), t16), e.__exportStar(KR0(), t16), e.__exportStar(QR0(), t16), e.__exportStar(ZR0(), t16), e.__exportStar(e40(), t16), e.__exportStar(t40(), t16), e.__exportStar(r40(), t16), e.__exportStar(n40(), t16), e.__exportStar(a40(), t16), e.__exportStar(o40(), t16), e.__exportStar(i40(), t16), e.__exportStar(u40(), t16), e.__exportStar(s40(), t16), e.__exportStar(c40(), t16), e.__exportStar(l40(), t16), e.__exportStar(p40(), t16), e.__exportStar(d40(), t16), e.__exportStar(f40(), t16), e.__exportStar(b40(), t16), e.__exportStar(M40(), t16), e.__exportStar(O40(), t16), e.__exportStar(z40(), t16), e.__exportStar(A40(), t16), e.__exportStar(_40(), t16), e.__exportStar(h40(), t16), e.__exportStar(v40(), t16), e.__exportStar(m40(), t16), e.__exportStar(R40(), t16), e.__exportStar(q40(), t16), e.__exportStar(T40(), t16), e.__exportStar(y40(), t16), e.__exportStar(S40(), t16), e.__exportStar(C40(), t16), e.__exportStar(g40(), t16), e.__exportStar(I40(), t16), e.__exportStar(E40(), t16), e.__exportStar(L40(), t16), e.__exportStar(P40(), t16), e.__exportStar(D40(), t16), e.__exportStar(W40(), t16), e.__exportStar(N40(), t16), e.__exportStar(w40(), t16), e.__exportStar(B40(), t16), e.__exportStar(x40(), t16), e.__exportStar(U40(), t16), e.__exportStar(k40(), t16), e.__exportStar(j40(), t16), e.__exportStar(F40(), t16), e.__exportStar(V40(), t16), e.__exportStar(H40(), t16), e.__exportStar(X40(), t16), e.__exportStar($40(), t16), e.__exportStar(G40(), t16), e.__exportStar(Y40(), t16), e.__exportStar(J40(), t16), e.__exportStar(K40(), t16), e.__exportStar(Q40(), t16), e.__exportStar(Z40(), t16), e.__exportStar(eq0(), t16), e.__exportStar(tq0(), t16), e.__exportStar(rq0(), t16), e.__exportStar(nq0(), t16), e.__exportStar(aq0(), t16), e.__exportStar(oq0(), t16), e.__exportStar(iq0(), t16), e.__exportStar(uq0(), t16), e.__exportStar(sq0(), t16), e.__exportStar(cq0(), t16), e.__exportStar(lq0(), t16), e.__exportStar(pq0(), t16), e.__exportStar(dq0(), t16), e.__exportStar(fq0(), t16), e.__exportStar(bq0(), t16), e.__exportStar(Mq0(), t16), e.__exportStar(Oq0(), t16), e.__exportStar(zq0(), t16), e.__exportStar(Aq0(), t16), e.__exportStar(_q0(), t16), e.__exportStar(hq0(), t16), e.__exportStar(vq0(), t16), e.__exportStar(mq0(), t16), e.__exportStar(Rq0(), t16), e.__exportStar(qq0(), t16), e.__exportStar(Tq0(), t16), e.__exportStar(yq0(), t16), e.__exportStar(Sq0(), t16), e.__exportStar(Cq0(), t16), e.__exportStar(gq0(), t16), e.__exportStar(Iq0(), t16), e.__exportStar(Eq0(), t16), e.__exportStar(Lq0(), t16), e.__exportStar(Pq0(), t16), e.__exportStar(Dq0(), t16), e.__exportStar(Wq0(), t16), e.__exportStar(Nq0(), t16), e.__exportStar(wq0(), t16), e.__exportStar(Bq0(), t16), e.__exportStar(xq0(), t16), e.__exportStar(Uq0(), t16), e.__exportStar(kq0(), t16), e.__exportStar(jq0(), t16), e.__exportStar(Fq0(), t16), e.__exportStar(Vq0(), t16), e.__exportStar(Hq0(), t16), e.__exportStar(Xq0(), t16), e.__exportStar($q0(), t16), e.__exportStar(Gq0(), t16), e.__exportStar(Yq0(), t16), e.__exportStar(Jq0(), t16), e.__exportStar(Kq0(), t16), e.__exportStar(Qq0(), t16), e.__exportStar(Zq0(), t16), e.__exportStar(eT0(), t16), e.__exportStar(tT0(), t16), e.__exportStar(rT0(), t16), e.__exportStar(nT0(), t16), e.__exportStar(aT0(), t16), e.__exportStar(oT0(), t16), e.__exportStar(iT0(), t16), e.__exportStar(uT0(), t16), e.__exportStar(sT0(), t16), e.__exportStar(cT0(), t16), e.__exportStar(lT0(), t16), e.__exportStar(pT0(), t16), e.__exportStar(dT0(), t16), e.__exportStar(fT0(), t16), e.__exportStar(bT0(), t16), e.__exportStar(MT0(), t16), e.__exportStar(OT0(), t16), e.__exportStar(zT0(), t16), e.__exportStar(AT0(), t16), e.__exportStar(_T0(), t16), e.__exportStar(hT0(), t16), e.__exportStar(vT0(), t16), e.__exportStar(mT0(), t16), e.__exportStar(RT0(), t16), e.__exportStar(qT0(), t16), e.__exportStar(TT0(), t16), e.__exportStar(yT0(), t16), e.__exportStar(ST0(), t16), e.__exportStar(CT0(), t16), e.__exportStar(gT0(), t16), e.__exportStar(IT0(), t16), e.__exportStar(ET0(), t16), e.__exportStar(LT0(), t16), e.__exportStar(PT0(), t16), e.__exportStar(DT0(), t16), e.__exportStar(WT0(), t16), e.__exportStar(NT0(), t16), e.__exportStar(wT0(), t16), e.__exportStar(BT0(), t16), e.__exportStar(xT0(), t16), e.__exportStar(UT0(), t16), e.__exportStar(kT0(), t16), e.__exportStar(jT0(), t16), e.__exportStar(FT0(), t16), e.__exportStar(VT0(), t16), e.__exportStar(HT0(), t16), e.__exportStar(XT0(), t16), e.__exportStar($T0(), t16), e.__exportStar(GT0(), t16), e.__exportStar(YT0(), t16), e.__exportStar(JT0(), t16), e.__exportStar(KT0(), t16), e.__exportStar(QT0(), t16), e.__exportStar(ZT0(), t16), e.__exportStar(ey0(), t16), e.__exportStar(ty0(), t16), e.__exportStar(ry0(), t16), e.__exportStar(ny0(), t16), e.__exportStar(ay0(), t16), e.__exportStar(oy0(), t16), e.__exportStar(iy0(), t16), e.__exportStar(uy0(), t16), e.__exportStar(sy0(), t16), e.__exportStar(cy0(), t16), e.__exportStar(ly0(), t16), e.__exportStar(py0(), t16), e.__exportStar(dy0(), t16), e.__exportStar(fy0(), t16), e.__exportStar(by0(), t16), e.__exportStar(My0(), t16), e.__exportStar(Oy0(), t16), e.__exportStar(zy0(), t16), e.__exportStar(Ay0(), t16), e.__exportStar(_y0(), t16), e.__exportStar(hy0(), t16), e.__exportStar(vy0(), t16), e.__exportStar(my0(), t16), e.__exportStar(Ry0(), t16), e.__exportStar(qy0(), t16), e.__exportStar(Ty0(), t16), e.__exportStar(yy0(), t16), e.__exportStar(Sy0(), t16), e.__exportStar(Cy0(), t16), e.__exportStar(gy0(), t16), e.__exportStar(Iy0(), t16), e.__exportStar(Ey0(), t16), e.__exportStar(Ly0(), t16), e.__exportStar(Py0(), t16), e.__exportStar(Dy0(), t16), e.__exportStar(Wy0(), t16), e.__exportStar(Ny0(), t16), e.__exportStar(wy0(), t16), e.__exportStar(By0(), t16), e.__exportStar(xy0(), t16), e.__exportStar(Uy0(), t16), e.__exportStar(ky0(), t16), e.__exportStar(jy0(), t16), e.__exportStar(Fy0(), t16), e.__exportStar(Vy0(), t16), e.__exportStar(Hy0(), t16), e.__exportStar(Xy0(), t16), e.__exportStar($y0(), t16), e.__exportStar(Gy0(), t16), e.__exportStar(Yy0(), t16), e.__exportStar(Jy0(), t16), e.__exportStar(Ky0(), t16), e.__exportStar(Qy0(), t16), e.__exportStar(Zy0(), t16), e.__exportStar(e50(), t16), e.__exportStar(t50(), t16), e.__exportStar(r50(), t16), e.__exportStar(n50(), t16), e.__exportStar(a50(), t16), e.__exportStar(o50(), t16), e.__exportStar(i50(), t16), e.__exportStar(u50(), t16), e.__exportStar(s50(), t16), e.__exportStar(c50(), t16), e.__exportStar(l50(), t16), e.__exportStar(p50(), t16), e.__exportStar(d50(), t16), e.__exportStar(f50(), t16), e.__exportStar(b50(), t16), e.__exportStar(M50(), t16), e.__exportStar(O50(), t16), e.__exportStar(z50(), t16), e.__exportStar(A50(), t16), e.__exportStar(_50(), t16), e.__exportStar(h50(), t16), e.__exportStar(v50(), t16), e.__exportStar(m50(), t16), e.__exportStar(R50(), t16), e.__exportStar(q50(), t16), e.__exportStar(T50(), t16), e.__exportStar(y50(), t16), e.__exportStar(S50(), t16), e.__exportStar(C50(), t16), e.__exportStar(g50(), t16), e.__exportStar(I50(), t16), e.__exportStar(E50(), t16), e.__exportStar(L50(), t16), e.__exportStar(P50(), t16), e.__exportStar(D50(), t16), e.__exportStar(W50(), t16), e.__exportStar(N50(), t16), e.__exportStar(w50(), t16), e.__exportStar(B50(), t16), e.__exportStar(x50(), t16), e.__exportStar(U50(), t16), e.__exportStar(k50(), t16), e.__exportStar(j50(), t16), e.__exportStar(F50(), t16), e.__exportStar(V50(), t16), e.__exportStar(H50(), t16), e.__exportStar(X50(), t16), e.__exportStar($50(), t16), e.__exportStar(G50(), t16), e.__exportStar(Y50(), t16), e.__exportStar(J50(), t16), e.__exportStar(K50(), t16), e.__exportStar(Q50(), t16), e.__exportStar(Z50(), t16), e.__exportStar(eS0(), t16), e.__exportStar(tS0(), t16), e.__exportStar(rS0(), t16), e.__exportStar(nS0(), t16), e.__exportStar(aS0(), t16), e.__exportStar(oS0(), t16), e.__exportStar(iS0(), t16), e.__exportStar(uS0(), t16), e.__exportStar(sS0(), t16), e.__exportStar(cS0(), t16), e.__exportStar(lS0(), t16), e.__exportStar(pS0(), t16), e.__exportStar(dS0(), t16), e.__exportStar(fS0(), t16), e.__exportStar(bS0(), t16), e.__exportStar(MS0(), t16), e.__exportStar(OS0(), t16), e.__exportStar(zS0(), t16), e.__exportStar(AS0(), t16), e.__exportStar(_S0(), t16), e.__exportStar(hS0(), t16), e.__exportStar(vS0(), t16), e.__exportStar(mS0(), t16), e.__exportStar(RS0(), t16), e.__exportStar(qS0(), t16), e.__exportStar(TS0(), t16), e.__exportStar(yS0(), t16), e.__exportStar(SS0(), t16), e.__exportStar(CS0(), t16), e.__exportStar(gS0(), t16), e.__exportStar(IS0(), t16), e.__exportStar(ES0(), t16), e.__exportStar(LS0(), t16), e.__exportStar(PS0(), t16), e.__exportStar(DS0(), t16), e.__exportStar(WS0(), t16), e.__exportStar(NS0(), t16), e.__exportStar(wS0(), t16), e.__exportStar(BS0(), t16), e.__exportStar(xS0(), t16), e.__exportStar(US0(), t16), e.__exportStar(kS0(), t16), e.__exportStar(jS0(), t16), e.__exportStar(FS0(), t16), e.__exportStar(VS0(), t16), e.__exportStar(HS0(), t16), e.__exportStar(XS0(), t16), e.__exportStar($S0(), t16), e.__exportStar(GS0(), t16), e.__exportStar(YS0(), t16), e.__exportStar(JS0(), t16), e.__exportStar(KS0(), t16), e.__exportStar(QS0(), t16), e.__exportStar(ZS0(), t16), e.__exportStar(e60(), t16), e.__exportStar(t60(), t16), e.__exportStar(r60(), t16), e.__exportStar(n60(), t16), e.__exportStar(a60(), t16), e.__exportStar(o60(), t16), e.__exportStar(i60(), t16), e.__exportStar(u60(), t16), e.__exportStar(s60(), t16), e.__exportStar(c60(), t16), e.__exportStar(l60(), t16), e.__exportStar(p60(), t16), e.__exportStar(d60(), t16), e.__exportStar(f60(), t16), e.__exportStar(b60(), t16), e.__exportStar(M60(), t16), e.__exportStar(O60(), t16), e.__exportStar(z60(), t16), e.__exportStar(A60(), t16), e.__exportStar(_60(), t16), e.__exportStar(h60(), t16), e.__exportStar(v60(), t16), e.__exportStar(m60(), t16), e.__exportStar(R60(), t16), e.__exportStar(q60(), t16), e.__exportStar(T60(), t16), e.__exportStar(y60(), t16), e.__exportStar(S60(), t16), e.__exportStar(C60(), t16), e.__exportStar(g60(), t16), e.__exportStar(I60(), t16), e.__exportStar(E60(), t16), e.__exportStar(L60(), t16), e.__exportStar(P60(), t16), e.__exportStar(D60(), t16), e.__exportStar(W60(), t16), e.__exportStar(N60(), t16), e.__exportStar(w60(), t16), e.__exportStar(B60(), t16), e.__exportStar(x60(), t16), e.__exportStar(U60(), t16), e.__exportStar(k60(), t16), e.__exportStar(j60(), t16), e.__exportStar(F60(), t16), e.__exportStar(V60(), t16), e.__exportStar(H60(), t16), e.__exportStar(X60(), t16), e.__exportStar($60(), t16), e.__exportStar(G60(), t16), e.__exportStar(Y60(), t16), e.__exportStar(J60(), t16), e.__exportStar(K60(), t16), e.__exportStar(Q60(), t16), e.__exportStar(Z60(), t16), e.__exportStar(eC0(), t16), e.__exportStar(tC0(), t16), e.__exportStar(rC0(), t16), e.__exportStar(nC0(), t16), e.__exportStar(aC0(), t16), e.__exportStar(oC0(), t16), e.__exportStar(iC0(), t16), e.__exportStar(uC0(), t16), e.__exportStar(sC0(), t16), e.__exportStar(cC0(), t16), e.__exportStar(lC0(), t16), e.__exportStar(pC0(), t16), e.__exportStar(dC0(), t16), e.__exportStar(fC0(), t16), e.__exportStar(bC0(), t16), e.__exportStar(MC0(), t16), e.__exportStar(OC0(), t16), e.__exportStar(zC0(), t16), e.__exportStar(AC0(), t16), e.__exportStar(_C0(), t16), e.__exportStar(hC0(), t16), e.__exportStar(vC0(), t16), e.__exportStar(mC0(), t16), e.__exportStar(RC0(), t16), e.__exportStar(qC0(), t16), e.__exportStar(TC0(), t16), e.__exportStar(yC0(), t16), e.__exportStar(SC0(), t16), e.__exportStar(CC0(), t16), e.__exportStar(gC0(), t16), e.__exportStar(IC0(), t16), e.__exportStar(EC0(), t16), e.__exportStar(LC0(), t16), e.__exportStar(PC0(), t16), e.__exportStar(DC0(), t16), e.__exportStar(WC0(), t16), e.__exportStar(NC0(), t16), e.__exportStar(wC0(), t16), e.__exportStar(BC0(), t16), e.__exportStar(xC0(), t16), e.__exportStar(UC0(), t16), e.__exportStar(kC0(), t16), e.__exportStar(jC0(), t16), e.__exportStar(FC0(), t16), e.__exportStar(VC0(), t16), e.__exportStar(HC0(), t16), e.__exportStar(XC0(), t16), e.__exportStar($C0(), t16), e.__exportStar(GC0(), t16), e.__exportStar(YC0(), t16), e.__exportStar(JC0(), t16), e.__exportStar(KC0(), t16), e.__exportStar(QC0(), t16), e.__exportStar(ZC0(), t16), e.__exportStar(eg0(), t16), e.__exportStar(tg0(), t16), e.__exportStar(rg0(), t16), e.__exportStar(ng0(), t16), e.__exportStar(ag0(), t16), e.__exportStar(og0(), t16), e.__exportStar(ig0(), t16), e.__exportStar(ug0(), t16), e.__exportStar(sg0(), t16), e.__exportStar(cg0(), t16), e.__exportStar(lg0(), t16), e.__exportStar(pg0(), t16), e.__exportStar(dg0(), t16), e.__exportStar(fg0(), t16), e.__exportStar(bg0(), t16), e.__exportStar(Mg0(), t16), e.__exportStar(Og0(), t16), e.__exportStar(zg0(), t16), e.__exportStar(Ag0(), t16), e.__exportStar(_g0(), t16), e.__exportStar(hg0(), t16), e.__exportStar(vg0(), t16), e.__exportStar(mg0(), t16), e.__exportStar(Rg0(), t16), e.__exportStar(qg0(), t16), e.__exportStar(Tg0(), t16), e.__exportStar(yg0(), t16), e.__exportStar(Sg0(), t16), e.__exportStar(Cg0(), t16), e.__exportStar(gg0(), t16), e.__exportStar(Ig0(), t16), e.__exportStar(Eg0(), t16), e.__exportStar(Lg0(), t16), e.__exportStar(Pg0(), t16), e.__exportStar(Dg0(), t16), e.__exportStar(Wg0(), t16), e.__exportStar(Ng0(), t16), e.__exportStar(wg0(), t16), e.__exportStar(Bg0(), t16), e.__exportStar(xg0(), t16), e.__exportStar(Ug0(), t16), e.__exportStar(kg0(), t16), e.__exportStar(jg0(), t16), e.__exportStar(Fg0(), t16), e.__exportStar(Vg0(), t16), e.__exportStar(Hg0(), t16), e.__exportStar(Xg0(), t16), e.__exportStar($g0(), t16), e.__exportStar(Gg0(), t16), e.__exportStar(Yg0(), t16), e.__exportStar(Jg0(), t16), e.__exportStar(Kg0(), t16), e.__exportStar(Qg0(), t16), e.__exportStar(Zg0(), t16), e.__exportStar(eI0(), t16), e.__exportStar(tI0(), t16), e.__exportStar(rI0(), t16), e.__exportStar(nI0(), t16), e.__exportStar(aI0(), t16), e.__exportStar(oI0(), t16), e.__exportStar(iI0(), t16), e.__exportStar(uI0(), t16), e.__exportStar(sI0(), t16), e.__exportStar(cI0(), t16), e.__exportStar(lI0(), t16), e.__exportStar(pI0(), t16), e.__exportStar(dI0(), t16), e.__exportStar(fI0(), t16), e.__exportStar(bI0(), t16), e.__exportStar(MI0(), t16), e.__exportStar(OI0(), t16), e.__exportStar(zI0(), t16), e.__exportStar(AI0(), t16), e.__exportStar(_I0(), t16), e.__exportStar(hI0(), t16), e.__exportStar(vI0(), t16), e.__exportStar(mI0(), t16), e.__exportStar(RI0(), t16), e.__exportStar(qI0(), t16), e.__exportStar(TI0(), t16), e.__exportStar(yI0(), t16), e.__exportStar(SI0(), t16), e.__exportStar(CI0(), t16), e.__exportStar(gI0(), t16), e.__exportStar(II0(), t16), e.__exportStar(EI0(), t16), e.__exportStar(LI0(), t16), e.__exportStar(PI0(), t16), e.__exportStar(DI0(), t16), e.__exportStar(WI0(), t16), e.__exportStar(NI0(), t16), e.__exportStar(wI0(), t16), e.__exportStar(BI0(), t16), e.__exportStar(xI0(), t16), e.__exportStar(UI0(), t16), e.__exportStar(kI0(), t16), e.__exportStar(jI0(), t16), e.__exportStar(FI0(), t16), e.__exportStar(VI0(), t16), e.__exportStar(HI0(), t16), e.__exportStar(XI0(), t16), e.__exportStar($I0(), t16), e.__exportStar(GI0(), t16), e.__exportStar(YI0(), t16), e.__exportStar(JI0(), t16), e.__exportStar(KI0(), t16), e.__exportStar(QI0(), t16), e.__exportStar(ZI0(), t16), e.__exportStar(eE0(), t16), e.__exportStar(tE0(), t16), e.__exportStar(rE0(), t16), e.__exportStar(nE0(), t16), e.__exportStar(aE0(), t16), e.__exportStar(oE0(), t16), e.__exportStar(iE0(), t16), e.__exportStar(uE0(), t16), e.__exportStar(sE0(), t16), e.__exportStar(cE0(), t16), e.__exportStar(lE0(), t16), e.__exportStar(pE0(), t16), e.__exportStar(dE0(), t16), e.__exportStar(fE0(), t16), e.__exportStar(bE0(), t16), e.__exportStar(ME0(), t16), e.__exportStar(OE0(), t16), e.__exportStar(zE0(), t16), e.__exportStar(AE0(), t16), e.__exportStar(_E0(), t16), e.__exportStar(hE0(), t16), e.__exportStar(vE0(), t16), e.__exportStar(mE0(), t16), e.__exportStar(RE0(), t16), e.__exportStar(qE0(), t16), e.__exportStar(TE0(), t16), e.__exportStar(yE0(), t16), e.__exportStar(SE0(), t16), e.__exportStar(CE0(), t16), e.__exportStar(gE0(), t16), e.__exportStar(IE0(), t16), e.__exportStar(EE0(), t16), e.__exportStar(LE0(), t16), e.__exportStar(PE0(), t16), e.__exportStar(DE0(), t16), e.__exportStar(WE0(), t16), e.__exportStar(NE0(), t16), e.__exportStar(wE0(), t16), e.__exportStar(BE0(), t16), e.__exportStar(xE0(), t16), e.__exportStar(UE0(), t16), e.__exportStar(kE0(), t16), e.__exportStar(jE0(), t16), e.__exportStar(FE0(), t16), e.__exportStar(VE0(), t16), e.__exportStar(HE0(), t16), e.__exportStar(XE0(), t16), e.__exportStar($E0(), t16), e.__exportStar(GE0(), t16), e.__exportStar(YE0(), t16), e.__exportStar(JE0(), t16), e.__exportStar(KE0(), t16), e.__exportStar(QE0(), t16), e.__exportStar(ZE0(), t16), e.__exportStar(eL0(), t16), e.__exportStar(tL0(), t16), e.__exportStar(rL0(), t16), e.__exportStar(nL0(), t16), e.__exportStar(aL0(), t16), e.__exportStar(oL0(), t16), e.__exportStar(iL0(), t16), e.__exportStar(uL0(), t16), e.__exportStar(sL0(), t16), e.__exportStar(cL0(), t16), e.__exportStar(lL0(), t16), e.__exportStar(pL0(), t16), e.__exportStar(dL0(), t16), e.__exportStar(fL0(), t16), e.__exportStar(bL0(), t16), e.__exportStar(ML0(), t16), e.__exportStar(OL0(), t16), e.__exportStar(zL0(), t16), e.__exportStar(AL0(), t16), e.__exportStar(_L0(), t16), e.__exportStar(hL0(), t16), e.__exportStar(vL0(), t16), e.__exportStar(mL0(), t16), e.__exportStar(RL0(), t16), e.__exportStar(qL0(), t16), e.__exportStar(TL0(), t16), e.__exportStar(yL0(), t16), e.__exportStar(SL0(), t16), e.__exportStar(CL0(), t16), e.__exportStar(gL0(), t16), e.__exportStar(IL0(), t16), e.__exportStar(EL0(), t16), e.__exportStar(LL0(), t16), e.__exportStar(PL0(), t16), e.__exportStar(DL0(), t16), e.__exportStar(WL0(), t16), e.__exportStar(NL0(), t16), e.__exportStar(wL0(), t16), e.__exportStar(BL0(), t16), e.__exportStar(xL0(), t16), e.__exportStar(UL0(), t16), e.__exportStar(kL0(), t16), e.__exportStar(jL0(), t16), e.__exportStar(FL0(), t16), e.__exportStar(VL0(), t16), e.__exportStar(HL0(), t16), e.__exportStar(XL0(), t16), e.__exportStar($L0(), t16), e.__exportStar(GL0(), t16), e.__exportStar(YL0(), t16), e.__exportStar(JL0(), t16), e.__exportStar(KL0(), t16), e.__exportStar(QL0(), t16), e.__exportStar(ZL0(), t16), e.__exportStar(eP0(), t16), e.__exportStar(tP0(), t16), e.__exportStar(rP0(), t16), e.__exportStar(nP0(), t16), e.__exportStar(aP0(), t16), e.__exportStar(oP0(), t16), e.__exportStar(iP0(), t16), e.__exportStar(uP0(), t16), e.__exportStar(sP0(), t16), e.__exportStar(cP0(), t16), e.__exportStar(lP0(), t16), e.__exportStar(pP0(), t16), e.__exportStar(dP0(), t16), e.__exportStar(fP0(), t16), e.__exportStar(bP0(), t16), e.__exportStar(MP0(), t16), e.__exportStar(OP0(), t16), e.__exportStar(zP0(), t16), e.__exportStar(AP0(), t16), e.__exportStar(_P0(), t16), e.__exportStar(hP0(), t16), e.__exportStar(vP0(), t16), e.__exportStar(mP0(), t16), e.__exportStar(RP0(), t16), e.__exportStar(qP0(), t16), e.__exportStar(TP0(), t16), e.__exportStar(yP0(), t16), e.__exportStar(SP0(), t16), e.__exportStar(CP0(), t16), e.__exportStar(gP0(), t16), e.__exportStar(IP0(), t16), e.__exportStar(EP0(), t16), e.__exportStar(LP0(), t16), e.__exportStar(PP0(), t16), e.__exportStar(DP0(), t16), e.__exportStar(WP0(), t16), e.__exportStar(NP0(), t16), e.__exportStar(wP0(), t16), e.__exportStar(BP0(), t16), e.__exportStar(xP0(), t16), e.__exportStar(UP0(), t16), e.__exportStar(kP0(), t16), e.__exportStar(jP0(), t16), e.__exportStar(FP0(), t16), e.__exportStar(VP0(), t16), e.__exportStar(HP0(), t16), e.__exportStar(XP0(), t16), e.__exportStar($P0(), t16), e.__exportStar(GP0(), t16), e.__exportStar(YP0(), t16), e.__exportStar(JP0(), t16), e.__exportStar(KP0(), t16), e.__exportStar(QP0(), t16), e.__exportStar(ZP0(), t16), e.__exportStar(eD0(), t16), e.__exportStar(tD0(), t16), e.__exportStar(rD0(), t16), e.__exportStar(nD0(), t16), e.__exportStar(aD0(), t16), e.__exportStar(oD0(), t16), e.__exportStar(iD0(), t16), e.__exportStar(uD0(), t16), e.__exportStar(sD0(), t16), e.__exportStar(cD0(), t16), e.__exportStar(lD0(), t16), e.__exportStar(pD0(), t16), e.__exportStar(dD0(), t16), e.__exportStar(fD0(), t16), e.__exportStar(bD0(), t16), e.__exportStar(MD0(), t16), e.__exportStar(OD0(), t16), e.__exportStar(zD0(), t16), e.__exportStar(AD0(), t16), e.__exportStar(_D0(), t16), e.__exportStar(hD0(), t16), e.__exportStar(vD0(), t16), e.__exportStar(mD0(), t16), e.__exportStar(RD0(), t16), e.__exportStar(qD0(), t16), e.__exportStar(TD0(), t16), e.__exportStar(yD0(), t16), e.__exportStar(SD0(), t16), e.__exportStar(CD0(), t16), e.__exportStar(gD0(), t16), e.__exportStar(ID0(), t16), e.__exportStar(ED0(), t16), e.__exportStar(LD0(), t16), e.__exportStar(PD0(), t16), e.__exportStar(DD0(), t16), e.__exportStar(WD0(), t16), e.__exportStar(ND0(), t16), e.__exportStar(wD0(), t16), e.__exportStar(BD0(), t16), e.__exportStar(xD0(), t16), e.__exportStar(UD0(), t16), e.__exportStar(kD0(), t16), e.__exportStar(jD0(), t16), e.__exportStar(FD0(), t16), e.__exportStar(VD0(), t16), e.__exportStar(HD0(), t16), e.__exportStar(XD0(), t16), e.__exportStar($D0(), t16), e.__exportStar(GD0(), t16), e.__exportStar(YD0(), t16), e.__exportStar(JD0(), t16), e.__exportStar(KD0(), t16), e.__exportStar(QD0(), t16), e.__exportStar(ZD0(), t16), e.__exportStar(eW0(), t16), e.__exportStar(tW0(), t16), e.__exportStar(rW0(), t16), e.__exportStar(nW0(), t16), e.__exportStar(aW0(), t16), e.__exportStar(oW0(), t16), e.__exportStar(iW0(), t16), e.__exportStar(uW0(), t16), e.__exportStar(sW0(), t16), e.__exportStar(cW0(), t16), e.__exportStar(lW0(), t16), e.__exportStar(pW0(), t16), e.__exportStar(dW0(), t16), e.__exportStar(fW0(), t16), e.__exportStar(bW0(), t16), e.__exportStar(MW0(), t16), e.__exportStar(OW0(), t16), e.__exportStar(zW0(), t16), e.__exportStar(AW0(), t16), e.__exportStar(_W0(), t16), e.__exportStar(hW0(), t16), e.__exportStar(vW0(), t16), e.__exportStar(mW0(), t16), e.__exportStar(RW0(), t16), e.__exportStar(qW0(), t16), e.__exportStar(TW0(), t16), e.__exportStar(yW0(), t16), e.__exportStar(SW0(), t16), e.__exportStar(CW0(), t16), e.__exportStar(gW0(), t16), e.__exportStar(IW0(), t16), e.__exportStar(EW0(), t16), e.__exportStar(LW0(), t16), e.__exportStar(PW0(), t16), e.__exportStar(DW0(), t16), e.__exportStar(WW0(), t16), e.__exportStar(NW0(), t16), e.__exportStar(wW0(), t16), e.__exportStar(BW0(), t16), e.__exportStar(xW0(), t16), e.__exportStar(UW0(), t16), e.__exportStar(kW0(), t16), e.__exportStar(jW0(), t16), e.__exportStar(FW0(), t16), e.__exportStar(VW0(), t16), e.__exportStar(HW0(), t16), e.__exportStar(XW0(), t16), e.__exportStar($W0(), t16), e.__exportStar(GW0(), t16), e.__exportStar(YW0(), t16), e.__exportStar(JW0(), t16), e.__exportStar(KW0(), t16), e.__exportStar(QW0(), t16), e.__exportStar(ZW0(), t16), e.__exportStar(eN0(), t16), e.__exportStar(tN0(), t16), e.__exportStar(rN0(), t16), e.__exportStar(nN0(), t16), e.__exportStar(aN0(), t16), e.__exportStar(oN0(), t16), e.__exportStar(iN0(), t16), e.__exportStar(uN0(), t16), e.__exportStar(sN0(), t16), e.__exportStar(cN0(), t16), e.__exportStar(lN0(), t16), e.__exportStar(pN0(), t16), e.__exportStar(dN0(), t16), e.__exportStar(fN0(), t16), e.__exportStar(bN0(), t16), e.__exportStar(MN0(), t16), e.__exportStar(ON0(), t16), e.__exportStar(zN0(), t16), e.__exportStar(AN0(), t16), e.__exportStar(_N0(), t16), e.__exportStar(hN0(), t16), e.__exportStar(vN0(), t16), e.__exportStar(mN0(), t16), e.__exportStar(RN0(), t16), e.__exportStar(qN0(), t16), e.__exportStar(TN0(), t16), e.__exportStar(yN0(), t16), e.__exportStar(SN0(), t16), e.__exportStar(CN0(), t16), e.__exportStar(gN0(), t16), e.__exportStar(IN0(), t16), e.__exportStar(EN0(), t16), e.__exportStar(LN0(), t16), e.__exportStar(PN0(), t16), e.__exportStar(DN0(), t16), e.__exportStar(WN0(), t16), e.__exportStar(NN0(), t16), e.__exportStar(wN0(), t16), e.__exportStar(BN0(), t16), e.__exportStar(xN0(), t16), e.__exportStar(UN0(), t16), e.__exportStar(kN0(), t16), e.__exportStar(jN0(), t16), e.__exportStar(FN0(), t16), e.__exportStar(VN0(), t16), e.__exportStar(HN0(), t16), e.__exportStar(XN0(), t16), e.__exportStar($N0(), t16), e.__exportStar(GN0(), t16), e.__exportStar(YN0(), t16), e.__exportStar(JN0(), t16), e.__exportStar(KN0(), t16), e.__exportStar(QN0(), t16), e.__exportStar(ZN0(), t16), e.__exportStar(e80(), t16), e.__exportStar(t80(), t16), e.__exportStar(r80(), t16), e.__exportStar(n80(), t16), e.__exportStar(a80(), t16), e.__exportStar(o80(), t16), e.__exportStar(i80(), t16), e.__exportStar(u80(), t16), e.__exportStar(s80(), t16), e.__exportStar(c80(), t16), e.__exportStar(l80(), t16), e.__exportStar(p80(), t16), e.__exportStar(d80(), t16), e.__exportStar(f80(), t16), e.__exportStar(b80(), t16), e.__exportStar(M80(), t16), e.__exportStar(O80(), t16), e.__exportStar(z80(), t16), e.__exportStar(A80(), t16), e.__exportStar(_80(), t16), e.__exportStar(h80(), t16), e.__exportStar(v80(), t16), e.__exportStar(m80(), t16), e.__exportStar(R80(), t16), e.__exportStar(q80(), t16), e.__exportStar(T80(), t16), e.__exportStar(y80(), t16), e.__exportStar(S80(), t16), e.__exportStar(C80(), t16), e.__exportStar(g80(), t16), e.__exportStar(I80(), t16), e.__exportStar(E80(), t16), e.__exportStar(L80(), t16), e.__exportStar(P80(), t16), e.__exportStar(D80(), t16), e.__exportStar(W80(), t16), e.__exportStar(N80(), t16), e.__exportStar(w80(), t16), e.__exportStar(B80(), t16), e.__exportStar(x80(), t16), e.__exportStar(U80(), t16), e.__exportStar(k80(), t16), e.__exportStar(j80(), t16), e.__exportStar(F80(), t16), e.__exportStar(V80(), t16), e.__exportStar(H80(), t16), e.__exportStar(X80(), t16), e.__exportStar($80(), t16), e.__exportStar(G80(), t16), e.__exportStar(Y80(), t16), e.__exportStar(J80(), t16), e.__exportStar(K80(), t16), e.__exportStar(Q80(), t16), e.__exportStar(Z80(), t16), e.__exportStar(e70(), t16), e.__exportStar(t70(), t16), e.__exportStar(r70(), t16), e.__exportStar(n70(), t16), e.__exportStar(a70(), t16), e.__exportStar(o70(), t16), e.__exportStar(i70(), t16), e.__exportStar(u70(), t16), e.__exportStar(s70(), t16), e.__exportStar(c70(), t16), e.__exportStar(l70(), t16), e.__exportStar(p70(), t16), e.__exportStar(d70(), t16), e.__exportStar(f70(), t16), e.__exportStar(b70(), t16), e.__exportStar(M70(), t16), e.__exportStar(O70(), t16), e.__exportStar(z70(), t16), e.__exportStar(A70(), t16), e.__exportStar(_70(), t16), e.__exportStar(h70(), t16), e.__exportStar(v70(), t16), e.__exportStar(m70(), t16), e.__exportStar(R70(), t16), e.__exportStar(q70(), t16), e.__exportStar(T70(), t16), e.__exportStar(y70(), t16), e.__exportStar(S70(), t16), e.__exportStar(C70(), t16), e.__exportStar(g70(), t16), e.__exportStar(I70(), t16), e.__exportStar(E70(), t16), e.__exportStar(L70(), t16), e.__exportStar(P70(), t16), e.__exportStar(D70(), t16), e.__exportStar(W70(), t16), e.__exportStar(N70(), t16), e.__exportStar(w70(), t16), e.__exportStar(B70(), t16), e.__exportStar(x70(), t16), e.__exportStar(U70(), t16), e.__exportStar(k70(), t16), e.__exportStar(j70(), t16), e.__exportStar(F70(), t16), e.__exportStar(V70(), t16), e.__exportStar(H70(), t16), e.__exportStar(X70(), t16), e.__exportStar($70(), t16), e.__exportStar(G70(), t16), e.__exportStar(Y70(), t16), e.__exportStar(J70(), t16), e.__exportStar(K70(), t16), e.__exportStar(Q70(), t16), e.__exportStar(Z70(), t16), e.__exportStar(ew0(), t16), e.__exportStar(tw0(), t16), e.__exportStar(rw0(), t16), e.__exportStar(nw0(), t16), e.__exportStar(aw0(), t16), e.__exportStar(ow0(), t16), e.__exportStar(iw0(), t16), e.__exportStar(uw0(), t16), e.__exportStar(sw0(), t16), e.__exportStar(cw0(), t16), e.__exportStar(lw0(), t16), e.__exportStar(pw0(), t16), e.__exportStar(dw0(), t16), e.__exportStar(fw0(), t16), e.__exportStar(bw0(), t16), e.__exportStar(Mw0(), t16), e.__exportStar(Ow0(), t16), e.__exportStar(zw0(), t16), e.__exportStar(Aw0(), t16), e.__exportStar(_w0(), t16), e.__exportStar(hw0(), t16), e.__exportStar(vw0(), t16), e.__exportStar(mw0(), t16), e.__exportStar(Rw0(), t16), e.__exportStar(qw0(), t16), e.__exportStar(Tw0(), t16), e.__exportStar(yw0(), t16), e.__exportStar(Sw0(), t16), e.__exportStar(Cw0(), t16), e.__exportStar(gw0(), t16), e.__exportStar(Iw0(), t16), e.__exportStar(Ew0(), t16), e.__exportStar(Lw0(), t16), e.__exportStar(Pw0(), t16), e.__exportStar(Dw0(), t16), e.__exportStar(Ww0(), t16), e.__exportStar(Nw0(), t16), e.__exportStar(ww0(), t16), e.__exportStar(Bw0(), t16), e.__exportStar(xw0(), t16), e.__exportStar(Uw0(), t16), e.__exportStar(kw0(), t16), e.__exportStar(jw0(), t16), e.__exportStar(Fw0(), t16), e.__exportStar(Vw0(), t16), e.__exportStar(Hw0(), t16), e.__exportStar(Xw0(), t16), e.__exportStar($w0(), t16), e.__exportStar(Gw0(), t16), e.__exportStar(Yw0(), t16), e.__exportStar(Jw0(), t16), e.__exportStar(Kw0(), t16), e.__exportStar(Qw0(), t16), e.__exportStar(Zw0(), t16), e.__exportStar(eB0(), t16), e.__exportStar(tB0(), t16), e.__exportStar(rB0(), t16), e.__exportStar(nB0(), t16), e.__exportStar(aB0(), t16), e.__exportStar(oB0(), t16), e.__exportStar(iB0(), t16), e.__exportStar(uB0(), t16), e.__exportStar(sB0(), t16), e.__exportStar(cB0(), t16), e.__exportStar(lB0(), t16), e.__exportStar(pB0(), t16), e.__exportStar(dB0(), t16), e.__exportStar(fB0(), t16), e.__exportStar(bB0(), t16), e.__exportStar(MB0(), t16), e.__exportStar(OB0(), t16), e.__exportStar(zB0(), t16), e.__exportStar(AB0(), t16), e.__exportStar(_B0(), t16), e.__exportStar(hB0(), t16), e.__exportStar(vB0(), t16), e.__exportStar(mB0(), t16), e.__exportStar(RB0(), t16), e.__exportStar(qB0(), t16), e.__exportStar(TB0(), t16), e.__exportStar(yB0(), t16), e.__exportStar(SB0(), t16), e.__exportStar(CB0(), t16), e.__exportStar(gB0(), t16), e.__exportStar(IB0(), t16), e.__exportStar(EB0(), t16), e.__exportStar(LB0(), t16), e.__exportStar(PB0(), t16), e.__exportStar(DB0(), t16), e.__exportStar(WB0(), t16), e.__exportStar(NB0(), t16), e.__exportStar(wB0(), t16), e.__exportStar(BB0(), t16), e.__exportStar(xB0(), t16), e.__exportStar(UB0(), t16), e.__exportStar(kB0(), t16), e.__exportStar(jB0(), t16), e.__exportStar(FB0(), t16), e.__exportStar(VB0(), t16), e.__exportStar(HB0(), t16), e.__exportStar(XB0(), t16), e.__exportStar($B0(), t16), e.__exportStar(GB0(), t16), e.__exportStar(YB0(), t16), e.__exportStar(JB0(), t16), e.__exportStar(KB0(), t16), e.__exportStar(QB0(), t16), e.__exportStar(ZB0(), t16), e.__exportStar(e90(), t16), e.__exportStar(t90(), t16), e.__exportStar(r90(), t16), e.__exportStar(n90(), t16), e.__exportStar(a90(), t16), e.__exportStar(o90(), t16), e.__exportStar(i90(), t16), e.__exportStar(u90(), t16), e.__exportStar(s90(), t16), e.__exportStar(c90(), t16), e.__exportStar(l90(), t16), e.__exportStar(p90(), t16), e.__exportStar(d90(), t16), e.__exportStar(f90(), t16), e.__exportStar(b90(), t16), e.__exportStar(M90(), t16), e.__exportStar(O90(), t16), e.__exportStar(z90(), t16), e.__exportStar(A90(), t16), e.__exportStar(_90(), t16), e.__exportStar(h90(), t16), e.__exportStar(v90(), t16), e.__exportStar(m90(), t16), e.__exportStar(R90(), t16), e.__exportStar(q90(), t16), e.__exportStar(T90(), t16), e.__exportStar(y90(), t16), e.__exportStar(S90(), t16), e.__exportStar(C90(), t16), e.__exportStar(g90(), t16), e.__exportStar(I90(), t16), e.__exportStar(E90(), t16), e.__exportStar(L90(), t16), e.__exportStar(P90(), t16), e.__exportStar(D90(), t16), e.__exportStar(W90(), t16), e.__exportStar(N90(), t16), e.__exportStar(w90(), t16), e.__exportStar(B90(), t16), e.__exportStar(x90(), t16), e.__exportStar(U90(), t16), e.__exportStar(k90(), t16), e.__exportStar(j90(), t16), e.__exportStar(F90(), t16), e.__exportStar(V90(), t16), e.__exportStar(H90(), t16), e.__exportStar(X90(), t16), e.__exportStar($90(), t16), e.__exportStar(G90(), t16), e.__exportStar(Y90(), t16), e.__exportStar(J90(), t16), e.__exportStar(K90(), t16), e.__exportStar(Q90(), t16), e.__exportStar(Z90(), t16), e.__exportStar(ex0(), t16), e.__exportStar(tx0(), t16), e.__exportStar(rx0(), t16), e.__exportStar(nx0(), t16), e.__exportStar(ax0(), t16), e.__exportStar(ox0(), t16), e.__exportStar(ix0(), t16), e.__exportStar(ux0(), t16), e.__exportStar(sx0(), t16), e.__exportStar(cx0(), t16), e.__exportStar(lx0(), t16), e.__exportStar(px0(), t16), e.__exportStar(dx0(), t16), e.__exportStar(fx0(), t16), e.__exportStar(bx0(), t16), e.__exportStar(Mx0(), t16), e.__exportStar(Ox0(), t16), e.__exportStar(zx0(), t16), e.__exportStar(Ax0(), t16), e.__exportStar(_x0(), t16), e.__exportStar(hx0(), t16), e.__exportStar(vx0(), t16), e.__exportStar(mx0(), t16), e.__exportStar(Rx0(), t16), e.__exportStar(qx0(), t16), e.__exportStar(Tx0(), t16), e.__exportStar(yx0(), t16), e.__exportStar(Sx0(), t16), e.__exportStar(Cx0(), t16), e.__exportStar(gx0(), t16), e.__exportStar(Ix0(), t16), e.__exportStar(Ex0(), t16), e.__exportStar(Lx0(), t16), e.__exportStar(Px0(), t16), e.__exportStar(Dx0(), t16), e.__exportStar(Wx0(), t16), e.__exportStar(Nx0(), t16), e.__exportStar(wx0(), t16), e.__exportStar(Bx0(), t16), e.__exportStar(xx0(), t16), e.__exportStar(Ux0(), t16), e.__exportStar(kx0(), t16), e.__exportStar(jx0(), t16), e.__exportStar(Fx0(), t16), e.__exportStar(Vx0(), t16), e.__exportStar(Hx0(), t16), e.__exportStar(Xx0(), t16), e.__exportStar($x0(), t16), e.__exportStar(Gx0(), t16), e.__exportStar(Yx0(), t16), e.__exportStar(Jx0(), t16), e.__exportStar(Kx0(), t16), e.__exportStar(Qx0(), t16), e.__exportStar(Zx0(), t16), e.__exportStar(eU0(), t16), e.__exportStar(tU0(), t16), e.__exportStar(rU0(), t16), e.__exportStar(nU0(), t16), e.__exportStar(aU0(), t16), e.__exportStar(oU0(), t16), e.__exportStar(iU0(), t16), e.__exportStar(uU0(), t16), e.__exportStar(sU0(), t16), e.__exportStar(cU0(), t16), e.__exportStar(lU0(), t16), e.__exportStar(pU0(), t16), e.__exportStar(dU0(), t16), e.__exportStar(fU0(), t16), e.__exportStar(bU0(), t16), e.__exportStar(MU0(), t16), e.__exportStar(OU0(), t16), e.__exportStar(zU0(), t16), e.__exportStar(AU0(), t16), e.__exportStar(_U0(), t16), e.__exportStar(hU0(), t16), e.__exportStar(vU0(), t16), e.__exportStar(mU0(), t16), e.__exportStar(RU0(), t16), e.__exportStar(qU0(), t16), e.__exportStar(TU0(), t16), e.__exportStar(yU0(), t16), e.__exportStar(SU0(), t16), e.__exportStar(CU0(), t16), e.__exportStar(gU0(), t16), e.__exportStar(IU0(), t16), e.__exportStar(EU0(), t16), e.__exportStar(LU0(), t16), e.__exportStar(PU0(), t16), e.__exportStar(DU0(), t16), e.__exportStar(WU0(), t16), e.__exportStar(NU0(), t16), e.__exportStar(wU0(), t16), e.__exportStar(BU0(), t16), e.__exportStar(xU0(), t16), e.__exportStar(UU0(), t16), e.__exportStar(kU0(), t16), e.__exportStar(jU0(), t16), e.__exportStar(FU0(), t16), e.__exportStar(VU0(), t16), e.__exportStar(HU0(), t16), e.__exportStar(XU0(), t16), e.__exportStar($U0(), t16), e.__exportStar(GU0(), t16), e.__exportStar(YU0(), t16), e.__exportStar(JU0(), t16), e.__exportStar(KU0(), t16), e.__exportStar(QU0(), t16), e.__exportStar(ZU0(), t16), e.__exportStar(ek0(), t16), e.__exportStar(tk0(), t16), e.__exportStar(rk0(), t16), e.__exportStar(nk0(), t16), e.__exportStar(ak0(), t16), e.__exportStar(ok0(), t16), e.__exportStar(ik0(), t16), e.__exportStar(uk0(), t16), e.__exportStar(sk0(), t16), e.__exportStar(ck0(), t16), e.__exportStar(lk0(), t16), e.__exportStar(pk0(), t16), e.__exportStar(dk0(), t16), e.__exportStar(fk0(), t16), e.__exportStar(bk0(), t16), e.__exportStar(Mk0(), t16), e.__exportStar(Ok0(), t16), e.__exportStar(zk0(), t16), e.__exportStar(Ak0(), t16), e.__exportStar(_k0(), t16), e.__exportStar(hk0(), t16), e.__exportStar(vk0(), t16), e.__exportStar(mk0(), t16), e.__exportStar(Rk0(), t16), e.__exportStar(qk0(), t16), e.__exportStar(Tk0(), t16), e.__exportStar(yk0(), t16), e.__exportStar(Sk0(), t16), e.__exportStar(Ck0(), t16), e.__exportStar(gk0(), t16), e.__exportStar(Ik0(), t16), e.__exportStar(Ek0(), t16), e.__exportStar(Lk0(), t16), e.__exportStar(Pk0(), t16), e.__exportStar(Dk0(), t16), e.__exportStar(Wk0(), t16), e.__exportStar(Nk0(), t16), e.__exportStar(wk0(), t16), e.__exportStar(Bk0(), t16), e.__exportStar(xk0(), t16), e.__exportStar(Uk0(), t16), e.__exportStar(kk0(), t16), e.__exportStar(jk0(), t16), e.__exportStar(Fk0(), t16), e.__exportStar(Vk0(), t16), e.__exportStar(Hk0(), t16), e.__exportStar(Xk0(), t16), e.__exportStar($k0(), t16), e.__exportStar(Gk0(), t16), e.__exportStar(Yk0(), t16), e.__exportStar(Jk0(), t16), e.__exportStar(Kk0(), t16), e.__exportStar(Qk0(), t16), e.__exportStar(Zk0(), t16), e.__exportStar(ej0(), t16), e.__exportStar(tj0(), t16), e.__exportStar(rj0(), t16), e.__exportStar(nj0(), t16), e.__exportStar(aj0(), t16), e.__exportStar(oj0(), t16), e.__exportStar(ij0(), t16), e.__exportStar(uj0(), t16), e.__exportStar(sj0(), t16), e.__exportStar(cj0(), t16), e.__exportStar(lj0(), t16), e.__exportStar(pj0(), t16), e.__exportStar(dj0(), t16), e.__exportStar(fj0(), t16), e.__exportStar(bj0(), t16), e.__exportStar(Mj0(), t16), e.__exportStar(Oj0(), t16), e.__exportStar(zj0(), t16), e.__exportStar(Aj0(), t16), e.__exportStar(_j0(), t16), e.__exportStar(hj0(), t16), e.__exportStar(vj0(), t16), e.__exportStar(mj0(), t16), e.__exportStar(Rj0(), t16), e.__exportStar(qj0(), t16), e.__exportStar(Tj0(), t16), e.__exportStar(yj0(), t16), e.__exportStar(Sj0(), t16), e.__exportStar(Cj0(), t16), e.__exportStar(gj0(), t16), e.__exportStar(Ij0(), t16), e.__exportStar(Ej0(), t16), e.__exportStar(Lj0(), t16), e.__exportStar(Pj0(), t16), e.__exportStar(Dj0(), t16), e.__exportStar(Wj0(), t16), e.__exportStar(Nj0(), t16), e.__exportStar(wj0(), t16), e.__exportStar(Bj0(), t16), e.__exportStar(xj0(), t16), e.__exportStar(Uj0(), t16), e.__exportStar(kj0(), t16), e.__exportStar(jj0(), t16), e.__exportStar(Fj0(), t16), e.__exportStar(Vj0(), t16), e.__exportStar(Hj0(), t16), e.__exportStar(Xj0(), t16), e.__exportStar($j0(), t16), e.__exportStar(Gj0(), t16), e.__exportStar(Yj0(), t16), e.__exportStar(Jj0(), t16), e.__exportStar(Kj0(), t16), e.__exportStar(Qj0(), t16), e.__exportStar(Zj0(), t16), e.__exportStar(eF0(), t16), e.__exportStar(tF0(), t16), e.__exportStar(rF0(), t16), e.__exportStar(nF0(), t16), e.__exportStar(aF0(), t16), e.__exportStar(oF0(), t16), e.__exportStar(iF0(), t16), e.__exportStar(uF0(), t16), e.__exportStar(sF0(), t16), e.__exportStar(cF0(), t16), e.__exportStar(lF0(), t16), e.__exportStar(pF0(), t16), e.__exportStar(dF0(), t16), e.__exportStar(fF0(), t16), e.__exportStar(bF0(), t16), e.__exportStar(MF0(), t16), e.__exportStar(OF0(), t16), e.__exportStar(zF0(), t16), e.__exportStar(AF0(), t16), e.__exportStar(_F0(), t16), e.__exportStar(hF0(), t16), e.__exportStar(vF0(), t16), e.__exportStar(mF0(), t16), e.__exportStar(RF0(), t16), e.__exportStar(qF0(), t16), e.__exportStar(TF0(), t16), e.__exportStar(yF0(), t16), e.__exportStar(SF0(), t16), e.__exportStar(CF0(), t16), e.__exportStar(gF0(), t16), e.__exportStar(IF0(), t16), e.__exportStar(EF0(), t16), e.__exportStar(LF0(), t16), e.__exportStar(PF0(), t16), e.__exportStar(DF0(), t16), e.__exportStar(WF0(), t16), e.__exportStar(NF0(), t16), e.__exportStar(wF0(), t16), e.__exportStar(BF0(), t16), e.__exportStar(xF0(), t16), e.__exportStar(UF0(), t16), e.__exportStar(kF0(), t16), e.__exportStar(jF0(), t16), e.__exportStar(FF0(), t16), e.__exportStar(VF0(), t16), e.__exportStar(HF0(), t16), e.__exportStar(XF0(), t16), e.__exportStar($F0(), t16), e.__exportStar(GF0(), t16), e.__exportStar(YF0(), t16), e.__exportStar(JF0(), t16), e.__exportStar(KF0(), t16), e.__exportStar(QF0(), t16), e.__exportStar(ZF0(), t16), e.__exportStar(eV0(), t16), e.__exportStar(tV0(), t16), e.__exportStar(rV0(), t16), e.__exportStar(nV0(), t16), e.__exportStar(aV0(), t16), e.__exportStar(oV0(), t16), e.__exportStar(iV0(), t16), e.__exportStar(uV0(), t16), e.__exportStar(sV0(), t16), e.__exportStar(cV0(), t16), e.__exportStar(lV0(), t16), e.__exportStar(pV0(), t16), e.__exportStar(dV0(), t16), e.__exportStar(fV0(), t16), e.__exportStar(bV0(), t16), e.__exportStar(MV0(), t16), e.__exportStar(OV0(), t16), e.__exportStar(zV0(), t16), e.__exportStar(AV0(), t16), e.__exportStar(_V0(), t16), e.__exportStar(hV0(), t16), e.__exportStar(vV0(), t16), e.__exportStar(mV0(), t16), e.__exportStar(RV0(), t16), e.__exportStar(qV0(), t16), e.__exportStar(TV0(), t16), e.__exportStar(yV0(), t16), e.__exportStar(SV0(), t16), e.__exportStar(CV0(), t16), e.__exportStar(gV0(), t16), e.__exportStar(IV0(), t16), e.__exportStar(EV0(), t16), e.__exportStar(LV0(), t16), e.__exportStar(PV0(), t16), e.__exportStar(DV0(), t16), e.__exportStar(WV0(), t16), e.__exportStar(NV0(), t16), e.__exportStar(wV0(), t16), e.__exportStar(BV0(), t16), e.__exportStar(xV0(), t16), e.__exportStar(UV0(), t16), e.__exportStar(kV0(), t16), e.__exportStar(jV0(), t16), e.__exportStar(FV0(), t16), e.__exportStar(VV0(), t16), e.__exportStar(HV0(), t16), e.__exportStar(XV0(), t16), e.__exportStar($V0(), t16), e.__exportStar(GV0(), t16), e.__exportStar(YV0(), t16), e.__exportStar(JV0(), t16), e.__exportStar(KV0(), t16), e.__exportStar(QV0(), t16), e.__exportStar(ZV0(), t16), e.__exportStar(eH0(), t16), e.__exportStar(tH0(), t16), e.__exportStar(rH0(), t16), e.__exportStar(nH0(), t16), e.__exportStar(aH0(), t16), e.__exportStar(oH0(), t16), e.__exportStar(iH0(), t16), e.__exportStar(uH0(), t16), e.__exportStar(sH0(), t16);
  })(Ef)), Ef;
}
(function(t16) {
  Object.defineProperty(t16, "__esModule", { value: true });
  var e = Z0;
  e.__exportStar(Ac(), t16), e.__exportStar(cH0(), t16);
})(fe);
class Co extends Error {
}
class ha extends Co {
  constructor() {
    super("Zone is an abstract class");
  }
}
class _c {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ha();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ha();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ha();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, r12) {
    throw new ha();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, r12) {
    throw new ha();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    throw new ha();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    throw new ha();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ha();
  }
}
const oZ = /* @__PURE__ */ new Map();
function MH0(t16) {
  let e = oZ.get(t16);
  return e === void 0 && (e = new Intl.DateTimeFormat("en-US", {
    hour12: false,
    timeZone: t16,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  }), oZ.set(t16, e)), e;
}
const OH0 = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function zH0(t16, e) {
  const r12 = t16.format(e).replace(/\u200E/g, ""), n12 = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(r12), [, a, o, i, u, s12, c, l2] = n12;
  return [i, a, o, u, s12, c, l2];
}
function AH0(t16, e) {
  const r12 = t16.formatToParts(e), n12 = [];
  for (let a = 0; a < r12.length; a++) {
    const { type: o, value: i } = r12[a], u = OH0[o];
    o === "era" ? n12[u] = i : v0(u) || (n12[u] = parseInt(i, 10));
  }
  return n12;
}
const $K = /* @__PURE__ */ new Map();
class aa extends _c {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(e) {
    let r12 = $K.get(e);
    return r12 === void 0 && $K.set(e, r12 = new aa(e)), r12;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    $K.clear(), oZ.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(e) {
    return this.isValidZone(e);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(e) {
    if (!e)
      return false;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: e }).format(), true;
    } catch {
      return false;
    }
  }
  constructor(e) {
    super(), this.zoneName = e, this.valid = aa.isValidZone(e);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return false;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, { format: r12, locale: n12 }) {
    return BXe(e, r12, n12, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, r12) {
    return Ms(this.offset(e), r12);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    if (!this.valid)
      return NaN;
    const r12 = new Date(e);
    if (isNaN(r12))
      return NaN;
    const n12 = MH0(this.name);
    let [a, o, i, u, s12, c, l2] = n12.formatToParts ? AH0(n12, r12) : zH0(n12, r12);
    u === "BC" && (a = -Math.abs(a) + 1);
    const p = Tp({
      year: a,
      month: o,
      day: i,
      hour: s12 === 24 ? 0 : s12,
      minute: c,
      second: l2,
      millisecond: 0
    });
    let d = +r12;
    const b = d % 1e3;
    return d -= b >= 0 ? b : 1e3 + b, (p - d) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    return e.type === "iana" && e.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let GK = null;
class Pt extends _c {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return GK === null && (GK = new Pt(0)), GK;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(e) {
    return e === 0 ? Pt.utcInstance : new Pt(e);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(e) {
    if (e) {
      const r12 = e.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r12)
        return new Pt(yp(r12[1], r12[2]));
    }
    return null;
  }
  constructor(e) {
    super(), this.fixed = e;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Ms(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Ms(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, r12) {
    return Ms(this.fixed, r12);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return true;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    return e.type === "fixed" && e.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return true;
  }
}
function v0(t16) {
  return typeof t16 > "u";
}
function U1(t16, e = 2) {
  const r12 = t16 < 0;
  let n12;
  return r12 ? n12 = "-" + ("" + -t16).padStart(e, "0") : n12 = ("" + t16).padStart(e, "0"), n12;
}
function Ra(t16) {
  if (!(v0(t16) || t16 === null || t16 === ""))
    return parseInt(t16, 10);
}
function n0e(t16) {
  if (!(v0(t16) || t16 === null || t16 === "")) {
    const e = parseFloat("0." + t16) * 1e3;
    return Math.floor(e);
  }
}
function Tp(t16) {
  let e = Date.UTC(
    t16.year,
    t16.month - 1,
    t16.day,
    t16.hour,
    t16.minute,
    t16.second,
    t16.millisecond
  );
  return t16.year < 100 && t16.year >= 0 && (e = new Date(e), e.setUTCFullYear(t16.year, t16.month - 1, t16.day)), +e;
}
function BXe(t16, e, r12, n12 = null) {
  const a = new Date(t16), o = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  n12 && (o.timeZone = n12);
  const i = { timeZoneName: e, ...o }, u = new Intl.DateTimeFormat(r12, i).formatToParts(a).find((s12) => s12.type.toLowerCase() === "timezonename");
  return u ? u.value : null;
}
function yp(t16, e) {
  let r12 = parseInt(t16, 10);
  Number.isNaN(r12) && (r12 = 0);
  const n12 = parseInt(e, 10) || 0, a = r12 < 0 || Object.is(r12, -0) ? -n12 : n12;
  return r12 * 60 + a;
}
function Ms(t16, e) {
  const r12 = Math.trunc(Math.abs(t16 / 60)), n12 = Math.trunc(Math.abs(t16 % 60)), a = t16 >= 0 ? "+" : "-";
  switch (e) {
    case "short":
      return `${a}${U1(r12, 2)}:${U1(n12, 2)}`;
    case "narrow":
      return `${a}${r12}${n12 > 0 ? `:${n12}` : ""}`;
    case "techie":
      return `${a}${U1(r12, 2)}${U1(n12, 2)}`;
    default:
      throw new RangeError(`Value format ${e} is out of range for property format`);
  }
}
const $Xe = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function Bi(...t16) {
  const e = t16.reduce((r12, n12) => r12 + n12.source, "");
  return RegExp(`^${e}$`);
}
function xi(...t16) {
  return (e) => t16.reduce(
    ([r12, n12, a], o) => {
      const [i, u, s12] = o(e, a);
      return [{ ...r12, ...i }, u || n12, s12];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function GXe(...t16) {
  return (e, r12) => {
    const n12 = {};
    let a;
    for (a = 0; a < t16.length; a++)
      n12[t16[a]] = Ra(e[r12 + a]);
    return [n12, null, r12 + a];
  };
}
const YXe = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/, tX0 = `(?:${YXe.source}?(?:\\[(${$Xe.source})\\])?)?`, o0e = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, JXe = RegExp(`${o0e.source}${tX0}`), i0e = RegExp(`(?:[Tt]${JXe.source})?`), rX0 = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, nX0 = /(\d{4})-?W(\d\d)(?:-?(\d))?/, aX0 = /(\d{4})-?(\d{3})/, oX0 = GXe("weekYear", "weekNumber", "weekDay"), iX0 = GXe("year", "ordinal"), uX0 = /(\d{4})-(\d\d)-(\d\d)/, KXe = RegExp(
  `${o0e.source} ?(?:${YXe.source}|(${$Xe.source}))?`
), sX0 = RegExp(`(?: ${KXe.source})?`);
function li(t16, e, r12) {
  const n12 = t16[e];
  return v0(n12) ? r12 : Ra(n12);
}
function cX0(t16, e) {
  return [{
    year: li(t16, e),
    month: li(t16, e + 1, 1),
    day: li(t16, e + 2, 1)
  }, null, e + 3];
}
function ki(t16, e) {
  return [{
    hours: li(t16, e, 0),
    minutes: li(t16, e + 1, 0),
    seconds: li(t16, e + 2, 0),
    milliseconds: n0e(t16[e + 3])
  }, null, e + 4];
}
function vc(t16, e) {
  const r12 = !t16[e] && !t16[e + 1], n12 = yp(t16[e + 1], t16[e + 2]), a = r12 ? null : Pt.instance(n12);
  return [{}, a, e + 3];
}
function mc(t16, e) {
  const r12 = t16[e] ? aa.create(t16[e]) : null;
  return [{}, r12, e + 1];
}
Bi(rX0, i0e);
Bi(nX0, i0e);
Bi(aX0, i0e);
Bi(JXe);
xi(
  cX0,
  ki,
  vc,
  mc
);
xi(
  oX0,
  ki,
  vc,
  mc
);
xi(
  iX0,
  ki,
  vc,
  mc
);
xi(
  ki,
  vc,
  mc
);
xi(ki);
Bi(uX0, sX0);
Bi(KXe);
xi(
  ki,
  vc,
  mc
);
class c$e {
  constructor(e) {
    q0(this, "_wm");
    e ? this._wm = new WeakMap(e) : this._wm = /* @__PURE__ */ new WeakMap();
  }
  clear() {
    return this._wm = /* @__PURE__ */ new WeakMap(), this;
  }
  delete(e) {
    return this._wm.delete(e);
  }
  get(e) {
    return this._wm.get(e);
  }
  has(e) {
    return this._wm.has(e);
  }
  set(e, r12) {
    return this._wm.set(e, r12), this;
  }
}
function l$e(t16, e) {
  return go(t16) ? false : Object.prototype.hasOwnProperty.call(t16, e);
}
function Bs(t16, e, r12 = false) {
  return go(t16) ? false : !J1(t16, "object") || !r12 ? l$e(t16, e) : e in t16;
}
function d$e(t16, e, r12) {
  Object.defineProperty(t16, e, r12);
}
function f$e(t16, e) {
  d$e(t16, Symbol.toStringTag, {
    value: e
  });
}
function b$e(t16) {
  return O$e(t16) && Array.isArray(t16);
}
function M$e(t16) {
  return (
    // object isn't nothing
    !go(t16) && // but it's not a function
    !J1(t16, "function") && // and it owns an iterator function
    Bs(t16, Symbol.iterator, true) && J1(t16[Symbol.iterator], "function") && // and it has a numerical length property with a positive, integer value
    Bs(t16, "length") && J1(t16.length, "number") && t16.length >= 0 && t16.length % 1 === 0
  );
}
function J1(t16, e) {
  var n12;
  if (typeof e > "u")
    throw new Error("A type or name is required when calling isTypeof.");
  const r12 = e;
  return typeof r12 == "string" ? r12 === "array" ? Array.isArray(t16) : typeof t16 === r12.toLowerCase() || ((n12 = t16 == null ? void 0 : t16.constructor) == null ? void 0 : n12.name) === r12.toLowerCase : t16 instanceof r12 || (t16 == null ? void 0 : t16.constructor) === r12;
}
function A$0(t16, ...e) {
  if (e.length === 0)
    throw new Error("At least one type or name is required when calling isAnyTypeof.");
  return [e].flat().some((r12) => J1(t16, r12));
}
function go(t16) {
  return typeof t16 > "u" || t16 === null;
}
function O$e(t16) {
  return !go(t16);
}
function z$e(t16) {
  return go(t16) ? true : J1(t16, "number") ? false : M$e(t16) || J1(t16, "string") ? !t16.length : (t16 instanceof Set || t16 instanceof Map) && Bs(t16, "size") && J1(t16.size, "number") && t16.size >= 0 && t16.size % 1 === 0 ? !t16.size : J1(t16, "object") ? !Object.keys(t16).length && (t16 == null ? void 0 : t16.constructor) === Object : false;
}
function Jl(t16) {
  return go(t16) || z$e(t16);
}
function s0e(t16) {
  return Jl(t16) ? true : b$e(t16) ? t16.every((e) => Jl(J1(e, "string") ? e.trim() : e)) : J1(t16, "string") ? Jl(t16.trim()) : J1(t16, "number") ? false : Object.keys(t16).every((e) => Object.hasOwnProperty.call(t16, e) ? s0e(t16[e]) : true);
}
function _$0(t16, e) {
  try {
    if (e(t16))
      return;
  } catch {
  }
  return t16;
}
function h$0(t16, e) {
  try {
    if (e(t16))
      return null;
  } catch {
  }
  return t16;
}
function v$0(t16, e = void 0) {
  try {
    return t16();
  } catch {
    return e;
  }
}
function m$0(t16, e = [], r12 = ["0", "false", "no", "n"], n12 = true) {
  const a = ((t16 == null ? void 0 : t16.toString()) ?? "").toLowerCase().trim();
  let o = n12 ? !!t16 : false;
  return (e == null ? void 0 : e.length) > 0 && (o = o || e.map((i) => typeof i == "string" ? i.toLowerCase() : i).some((i) => a === i || t16 === i)), o = o && !r12.map((i) => typeof i == "string" ? i.toLowerCase() : i).some((i) => a === i || t16 === i), o;
}
function R$0() {
}
let Uke = 0;
const zl = new c$e();
function OZ(t16, e) {
  const r12 = {
    undefined: { type: 683831609 },
    boolean: { type: 866975723, value: 452614237 },
    number: { type: 843517583 },
    iterable: { type: 1, value: 31 },
    string: { type: 737245463 },
    object: { type: 2066111009, value: 397 },
    null: 3630146161
    // special guy
  }, n12 = (l2) => Math.imul(r12.boolean.value + Number(l2), r12.boolean.type), a = (l2) => parseInt(`${(parseInt(`${l2}`, 10) || 0) + r12.number.type}`, 10) || 0, o = (l2, f, p) => [...l2].reduce(
    (d, b) => Math.imul(d, r12.iterable.value) + p(b, f),
    r12.iterable.type
  ), i = (l2) => l2.length === 0 ? r12.string.type : l2.split("").reduce(
    (f, p) => parseInt(`${(f << 5) - f + p.charCodeAt(0)}`, 10) || 0,
    r12.string.type
  ), u = (l2, f, p) => {
    const d = (b, z) => b < z ? -1 : b > z ? 1 : 0;
    return Object.entries(l2).sort(([b], [z]) => d(b, z)).reduce(
      // eslint-disable-next-line no-bitwise
      (b, [z, _]) => Math.imul(Math.imul(b, r12.object.value) ^ i(z), r12.object.value) ^ p(_, f),
      r12.object.type
    );
  }, s12 = e || /* @__PURE__ */ new Set(), c = () => {
    e || (zl.clear(), Uke = 0);
  };
  if (J1(t16, "string"))
    return i(t16);
  if (J1(t16, "number"))
    return a(t16);
  if (J1(t16, "boolean"))
    return n12(t16);
  if (J1(t16, "undefined"))
    return r12.undefined.type;
  if (J1(t16, "object")) {
    if (t16 === null)
      return r12.null;
    zl.has(t16) || zl.set(t16, Uke++);
    const l2 = zl.get(t16);
    if (s12.has(l2))
      return 0;
    if (s12.add(l2), Bs(t16, Symbol.iterator)) {
      const p = o(t16, s12, OZ);
      return c(), p;
    }
    const f = u(t16, s12, OZ);
    return c(), f;
  }
  throw new Error(`Hashing of ${typeof t16} variables is not implemented yet.`);
}
const q$0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hashCode: OZ,
  isAnyTypeof: A$0,
  isDefined: O$e,
  isEmpty: z$e,
  isNullOrEmpty: Jl,
  isNullOrUndefined: go,
  isNullOrWhitespace: s0e,
  isTypeof: J1,
  noOp: R$0,
  nullIf: h$0,
  parseBoolean: m$0,
  safeEval: v$0,
  undefinedIf: _$0
}, Symbol.toStringTag, { value: "Module" }));
function AZ(t16, e = false, r12 = [], n12 = [" ", "/"]) {
  const a = [
    "a",
    "an",
    "the",
    "and",
    "but",
    "or",
    "for",
    "nor",
    "as",
    "at",
    "by",
    "for",
    "from",
    "in",
    "into",
    "near",
    "of",
    "on",
    "onto",
    "to",
    "with"
  ], o = [...r12, ...e ? a : []];
  let i = "";
  const u = t16.toLowerCase();
  for (let s12 = 0, c = u[s12], l2 = "", f = false; s12 < u.length; s12++, c = u[s12], f = n12.includes(c))
    if (f || (l2 += l2.length === 0 ? c.toUpperCase() : c), s12 === u.length - 1 || f) {
      const p = i.length || f;
      i += p && o.includes(l2.toLowerCase()) ? l2.toLowerCase() : l2, f && (i += c), l2 = "";
    }
  return i;
}
var h$e = { exports: {} };
var v$e;
function ke() {
  return v$e.apply(null, arguments);
}
function w$0(t16) {
  v$e = t16;
}
function tn(t16) {
  return t16 instanceof Array || Object.prototype.toString.call(t16) === "[object Array]";
}
function Ao(t16) {
  return t16 != null && Object.prototype.toString.call(t16) === "[object Object]";
}
function G0(t16, e) {
  return Object.prototype.hasOwnProperty.call(t16, e);
}
function l0e(t16) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(t16).length === 0;
  var e;
  for (e in t16)
    if (G0(t16, e))
      return false;
  return true;
}
function kt(t16) {
  return t16 === void 0;
}
function oa(t16) {
  return typeof t16 == "number" || Object.prototype.toString.call(t16) === "[object Number]";
}
function Rc(t16) {
  return t16 instanceof Date || Object.prototype.toString.call(t16) === "[object Date]";
}
function m$e(t16, e) {
  var r12 = [], n12, a = t16.length;
  for (n12 = 0; n12 < a; ++n12)
    r12.push(e(t16[n12], n12));
  return r12;
}
function Ia(t16, e) {
  for (var r12 in e)
    G0(e, r12) && (t16[r12] = e[r12]);
  return G0(e, "toString") && (t16.toString = e.toString), G0(e, "valueOf") && (t16.valueOf = e.valueOf), t16;
}
function Cn(t16, e, r12, n12) {
  return H$e(t16, e, r12, n12, true).utc();
}
function B$0() {
  return {
    empty: false,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: false,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: false,
    userInvalidated: false,
    iso: false,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: false,
    weekdayMismatch: false
  };
}
function g0(t16) {
  return t16._pf == null && (t16._pf = B$0()), t16._pf;
}
var hZ;
Array.prototype.some ? hZ = Array.prototype.some : hZ = function(t16) {
  var e = Object(this), r12 = e.length >>> 0, n12;
  for (n12 = 0; n12 < r12; n12++)
    if (n12 in e && t16.call(this, e[n12], n12, e))
      return true;
  return false;
};
function p0e(t16) {
  var e = null, r12 = false, n12 = t16._d && !isNaN(t16._d.getTime());
  if (n12 && (e = g0(t16), r12 = hZ.call(e.parsedDateParts, function(a) {
    return a != null;
  }), n12 = e.overflow < 0 && !e.empty && !e.invalidEra && !e.invalidMonth && !e.invalidWeekday && !e.weekdayMismatch && !e.nullInput && !e.invalidFormat && !e.userInvalidated && (!e.meridiem || e.meridiem && r12), t16._strict && (n12 = n12 && e.charsLeftOver === 0 && e.unusedTokens.length === 0 && e.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(t16))
    t16._isValid = n12;
  else
    return n12;
  return t16._isValid;
}
function gp(t16) {
  var e = Cn(NaN);
  return t16 != null ? Ia(g0(e), t16) : g0(e).userInvalidated = true, e;
}
var kke = ke.momentProperties = [], tQ = false;
function d0e(t16, e) {
  var r12, n12, a, o = kke.length;
  if (kt(e._isAMomentObject) || (t16._isAMomentObject = e._isAMomentObject), kt(e._i) || (t16._i = e._i), kt(e._f) || (t16._f = e._f), kt(e._l) || (t16._l = e._l), kt(e._strict) || (t16._strict = e._strict), kt(e._tzm) || (t16._tzm = e._tzm), kt(e._isUTC) || (t16._isUTC = e._isUTC), kt(e._offset) || (t16._offset = e._offset), kt(e._pf) || (t16._pf = g0(e)), kt(e._locale) || (t16._locale = e._locale), o > 0)
    for (r12 = 0; r12 < o; r12++)
      n12 = kke[r12], a = e[n12], kt(a) || (t16[n12] = a);
  return t16;
}
function qc(t16) {
  d0e(this, t16), this._d = new Date(t16._d != null ? t16._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), tQ === false && (tQ = true, ke.updateOffset(this), tQ = false);
}
function rn(t16) {
  return t16 instanceof qc || t16 != null && t16._isAMomentObject != null;
}
function R$e(t16) {
  ke.suppressDeprecationWarnings === false && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + t16);
}
function gr(t16, e) {
  var r12 = true;
  return Ia(function() {
    if (ke.deprecationHandler != null && ke.deprecationHandler(null, t16), r12) {
      var n12 = [], a, o, i, u = arguments.length;
      for (o = 0; o < u; o++) {
        if (a = "", typeof arguments[o] == "object") {
          a += `
[` + o + "] ";
          for (i in arguments[0])
            G0(arguments[0], i) && (a += i + ": " + arguments[0][i] + ", ");
          a = a.slice(0, -2);
        } else
          a = arguments[o];
        n12.push(a);
      }
      R$e(
        t16 + `
Arguments: ` + Array.prototype.slice.call(n12).join("") + `
` + new Error().stack
      ), r12 = false;
    }
    return e.apply(this, arguments);
  }, e);
}
var jke = {};
function q$e(t16, e) {
  ke.deprecationHandler != null && ke.deprecationHandler(t16, e), jke[t16] || (R$e(e), jke[t16] = true);
}
ke.suppressDeprecationWarnings = false;
ke.deprecationHandler = null;
function gn(t16) {
  return typeof Function < "u" && t16 instanceof Function || Object.prototype.toString.call(t16) === "[object Function]";
}
function x$0(t16) {
  var e, r12;
  for (r12 in t16)
    G0(t16, r12) && (e = t16[r12], gn(e) ? this[r12] = e : this["_" + r12] = e);
  this._config = t16, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function vZ(t16, e) {
  var r12 = Ia({}, t16), n12;
  for (n12 in e)
    G0(e, n12) && (Ao(t16[n12]) && Ao(e[n12]) ? (r12[n12] = {}, Ia(r12[n12], t16[n12]), Ia(r12[n12], e[n12])) : e[n12] != null ? r12[n12] = e[n12] : delete r12[n12]);
  for (n12 in t16)
    G0(t16, n12) && !G0(e, n12) && Ao(t16[n12]) && (r12[n12] = Ia({}, r12[n12]));
  return r12;
}
function f0e(t16) {
  t16 != null && this.set(t16);
}
var mZ;
Object.keys ? mZ = Object.keys : mZ = function(t16) {
  var e, r12 = [];
  for (e in t16)
    G0(t16, e) && r12.push(e);
  return r12;
};
var U$0 = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function k$0(t16, e, r12) {
  var n12 = this._calendar[t16] || this._calendar.sameElse;
  return gn(n12) ? n12.call(e, r12) : n12;
}
function hn(t16, e, r12) {
  var n12 = "" + Math.abs(t16), a = e - n12.length, o = t16 >= 0;
  return (o ? r12 ? "+" : "" : "-") + Math.pow(10, Math.max(0, a)).toString().substr(1) + n12;
}
var b0e = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Al = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, rQ = {}, pi = {};
function c0(t16, e, r12, n12) {
  var a = n12;
  typeof n12 == "string" && (a = function() {
    return this[n12]();
  }), t16 && (pi[t16] = a), e && (pi[e[0]] = function() {
    return hn(a.apply(this, arguments), e[1], e[2]);
  }), r12 && (pi[r12] = function() {
    return this.localeData().ordinal(
      a.apply(this, arguments),
      t16
    );
  });
}
function j$0(t16) {
  return t16.match(/\[[\s\S]/) ? t16.replace(/^\[|\]$/g, "") : t16.replace(/\\/g, "");
}
function F$0(t16) {
  var e = t16.match(b0e), r12, n12;
  for (r12 = 0, n12 = e.length; r12 < n12; r12++)
    pi[e[r12]] ? e[r12] = pi[e[r12]] : e[r12] = j$0(e[r12]);
  return function(a) {
    var o = "", i;
    for (i = 0; i < n12; i++)
      o += gn(e[i]) ? e[i].call(a, t16) : e[i];
    return o;
  };
}
function Kl(t16, e) {
  return t16.isValid() ? (e = T$e(e, t16.localeData()), rQ[e] = rQ[e] || F$0(e), rQ[e](t16)) : t16.localeData().invalidDate();
}
function T$e(t16, e) {
  var r12 = 5;
  function n12(a) {
    return e.longDateFormat(a) || a;
  }
  for (Al.lastIndex = 0; r12 >= 0 && Al.test(t16); )
    t16 = t16.replace(
      Al,
      n12
    ), Al.lastIndex = 0, r12 -= 1;
  return t16;
}
var V$0 = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function H$0(t16) {
  var e = this._longDateFormat[t16], r12 = this._longDateFormat[t16.toUpperCase()];
  return e || !r12 ? e : (this._longDateFormat[t16] = r12.match(b0e).map(function(n12) {
    return n12 === "MMMM" || n12 === "MM" || n12 === "DD" || n12 === "dddd" ? n12.slice(1) : n12;
  }).join(""), this._longDateFormat[t16]);
}
var X$0 = "Invalid date";
function $$0() {
  return this._invalidDate;
}
var G$0 = "%d", Y$0 = /\d{1,2}/;
function J$0(t16) {
  return this._ordinal.replace("%d", t16);
}
var K$0 = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Q$0(t16, e, r12, n12) {
  var a = this._relativeTime[r12];
  return gn(a) ? a(t16, e, r12, n12) : a.replace(/%d/i, t16);
}
function Z$0(t16, e) {
  var r12 = this._relativeTime[t16 > 0 ? "future" : "past"];
  return gn(r12) ? r12(e) : r12.replace(/%s/i, e);
}
var Fke = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function Ir(t16) {
  return typeof t16 == "string" ? Fke[t16] || Fke[t16.toLowerCase()] : void 0;
}
function M0e(t16) {
  var e = {}, r12, n12;
  for (n12 in t16)
    G0(t16, n12) && (r12 = Ir(n12), r12 && (e[r12] = t16[n12]));
  return e;
}
var eG0 = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function tG0(t16) {
  var e = [], r12;
  for (r12 in t16)
    G0(t16, r12) && e.push({ unit: r12, priority: eG0[r12] });
  return e.sort(function(n12, a) {
    return n12.priority - a.priority;
  }), e;
}
var y$e = /\d/, cr = /\d\d/, S$e = /\d{3}/, O0e = /\d{4}/, Ip = /[+-]?\d{6}/, _1 = /\d\d?/, C$e = /\d\d\d\d?/, g$e = /\d\d\d\d\d\d?/, Ep = /\d{1,3}/, z0e = /\d{1,4}/, Lp = /[+-]?\d{1,6}/, ji = /\d+/, Pp = /[+-]?\d+/, rG0 = /Z|[+-]\d\d:?\d\d/gi, Dp = /Z|[+-]\d\d(?::?\d\d)?/gi, nG0 = /[+-]?\d+(\.\d{1,3})?/, Tc = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Fi = /^[1-9]\d?/, A0e = /^([1-9]\d|\d)/, g2;
g2 = {};
function Xe(t16, e, r12) {
  g2[t16] = gn(e) ? e : function(n12, a) {
    return n12 && r12 ? r12 : e;
  };
}
function aG0(t16, e) {
  return G0(g2, t16) ? g2[t16](e._strict, e._locale) : new RegExp(oG0(t16));
}
function oG0(t16) {
  return Kn(
    t16.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(e, r12, n12, a, o) {
        return r12 || n12 || a || o;
      }
    )
  );
}
function Kn(t16) {
  return t16.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function zr(t16) {
  return t16 < 0 ? Math.ceil(t16) || 0 : Math.floor(t16);
}
function k0(t16) {
  var e = +t16, r12 = 0;
  return e !== 0 && isFinite(e) && (r12 = zr(e)), r12;
}
var RZ = {};
function o1(t16, e) {
  var r12, n12 = e, a;
  for (typeof t16 == "string" && (t16 = [t16]), oa(e) && (n12 = function(o, i) {
    i[e] = k0(o);
  }), a = t16.length, r12 = 0; r12 < a; r12++)
    RZ[t16[r12]] = n12;
}
function yc(t16, e) {
  o1(t16, function(r12, n12, a, o) {
    a._w = a._w || {}, e(r12, a._w, a, o);
  });
}
function iG0(t16, e, r12) {
  e != null && G0(RZ, t16) && RZ[t16](e, r12._a, r12, t16);
}
function Wp(t16) {
  return t16 % 4 === 0 && t16 % 100 !== 0 || t16 % 400 === 0;
}
var Tt = 0, Xn = 1, dn = 2, K1 = 3, Yr = 4, $n = 5, zo = 6, uG0 = 7, sG0 = 8;
c0("Y", 0, 0, function() {
  var t16 = this.year();
  return t16 <= 9999 ? hn(t16, 4) : "+" + t16;
});
c0(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
c0(0, ["YYYY", 4], 0, "year");
c0(0, ["YYYYY", 5], 0, "year");
c0(0, ["YYYYYY", 6, true], 0, "year");
Xe("Y", Pp);
Xe("YY", _1, cr);
Xe("YYYY", z0e, O0e);
Xe("YYYYY", Lp, Ip);
Xe("YYYYYY", Lp, Ip);
o1(["YYYYY", "YYYYYY"], Tt);
o1("YYYY", function(t16, e) {
  e[Tt] = t16.length === 2 ? ke.parseTwoDigitYear(t16) : k0(t16);
});
o1("YY", function(t16, e) {
  e[Tt] = ke.parseTwoDigitYear(t16);
});
o1("Y", function(t16, e) {
  e[Tt] = parseInt(t16, 10);
});
function Os(t16) {
  return Wp(t16) ? 366 : 365;
}
ke.parseTwoDigitYear = function(t16) {
  return k0(t16) + (k0(t16) > 68 ? 1900 : 2e3);
};
var I$e = Vi("FullYear", true);
function cG0() {
  return Wp(this.year());
}
function Vi(t16, e) {
  return function(r12) {
    return r12 != null ? (E$e(this, t16, r12), ke.updateOffset(this, e), this) : xs(this, t16);
  };
}
function xs(t16, e) {
  if (!t16.isValid())
    return NaN;
  var r12 = t16._d, n12 = t16._isUTC;
  switch (e) {
    case "Milliseconds":
      return n12 ? r12.getUTCMilliseconds() : r12.getMilliseconds();
    case "Seconds":
      return n12 ? r12.getUTCSeconds() : r12.getSeconds();
    case "Minutes":
      return n12 ? r12.getUTCMinutes() : r12.getMinutes();
    case "Hours":
      return n12 ? r12.getUTCHours() : r12.getHours();
    case "Date":
      return n12 ? r12.getUTCDate() : r12.getDate();
    case "Day":
      return n12 ? r12.getUTCDay() : r12.getDay();
    case "Month":
      return n12 ? r12.getUTCMonth() : r12.getMonth();
    case "FullYear":
      return n12 ? r12.getUTCFullYear() : r12.getFullYear();
    default:
      return NaN;
  }
}
function E$e(t16, e, r12) {
  var n12, a, o, i, u;
  if (!(!t16.isValid() || isNaN(r12))) {
    switch (n12 = t16._d, a = t16._isUTC, e) {
      case "Milliseconds":
        return void (a ? n12.setUTCMilliseconds(r12) : n12.setMilliseconds(r12));
      case "Seconds":
        return void (a ? n12.setUTCSeconds(r12) : n12.setSeconds(r12));
      case "Minutes":
        return void (a ? n12.setUTCMinutes(r12) : n12.setMinutes(r12));
      case "Hours":
        return void (a ? n12.setUTCHours(r12) : n12.setHours(r12));
      case "Date":
        return void (a ? n12.setUTCDate(r12) : n12.setDate(r12));
      case "FullYear":
        break;
      default:
        return;
    }
    o = r12, i = t16.month(), u = t16.date(), u = u === 29 && i === 1 && !Wp(o) ? 28 : u, a ? n12.setUTCFullYear(o, i, u) : n12.setFullYear(o, i, u);
  }
}
function lG0(t16) {
  return t16 = Ir(t16), gn(this[t16]) ? this[t16]() : this;
}
function pG0(t16, e) {
  if (typeof t16 == "object") {
    t16 = M0e(t16);
    var r12 = tG0(t16), n12, a = r12.length;
    for (n12 = 0; n12 < a; n12++)
      this[r12[n12].unit](t16[r12[n12].unit]);
  } else if (t16 = Ir(t16), gn(this[t16]))
    return this[t16](e);
  return this;
}
function dG0(t16, e) {
  return (t16 % e + e) % e;
}
var W1;
Array.prototype.indexOf ? W1 = Array.prototype.indexOf : W1 = function(t16) {
  var e;
  for (e = 0; e < this.length; ++e)
    if (this[e] === t16)
      return e;
  return -1;
};
function _0e(t16, e) {
  if (isNaN(t16) || isNaN(e))
    return NaN;
  var r12 = dG0(e, 12);
  return t16 += (e - r12) / 12, r12 === 1 ? Wp(t16) ? 29 : 28 : 31 - r12 % 7 % 2;
}
c0("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
c0("MMM", 0, 0, function(t16) {
  return this.localeData().monthsShort(this, t16);
});
c0("MMMM", 0, 0, function(t16) {
  return this.localeData().months(this, t16);
});
Xe("M", _1, Fi);
Xe("MM", _1, cr);
Xe("MMM", function(t16, e) {
  return e.monthsShortRegex(t16);
});
Xe("MMMM", function(t16, e) {
  return e.monthsRegex(t16);
});
o1(["M", "MM"], function(t16, e) {
  e[Xn] = k0(t16) - 1;
});
o1(["MMM", "MMMM"], function(t16, e, r12, n12) {
  var a = r12._locale.monthsParse(t16, n12, r12._strict);
  a != null ? e[Xn] = a : g0(r12).invalidMonth = t16;
});
var fG0 = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), L$e = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), P$e = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, bG0 = Tc, MG0 = Tc;
function OG0(t16, e) {
  return t16 ? tn(this._months) ? this._months[t16.month()] : this._months[(this._months.isFormat || P$e).test(e) ? "format" : "standalone"][t16.month()] : tn(this._months) ? this._months : this._months.standalone;
}
function zG0(t16, e) {
  return t16 ? tn(this._monthsShort) ? this._monthsShort[t16.month()] : this._monthsShort[P$e.test(e) ? "format" : "standalone"][t16.month()] : tn(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function AG0(t16, e, r12) {
  var n12, a, o, i = t16.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n12 = 0; n12 < 12; ++n12)
      o = Cn([2e3, n12]), this._shortMonthsParse[n12] = this.monthsShort(
        o,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[n12] = this.months(o, "").toLocaleLowerCase();
  return r12 ? e === "MMM" ? (a = W1.call(this._shortMonthsParse, i), a !== -1 ? a : null) : (a = W1.call(this._longMonthsParse, i), a !== -1 ? a : null) : e === "MMM" ? (a = W1.call(this._shortMonthsParse, i), a !== -1 ? a : (a = W1.call(this._longMonthsParse, i), a !== -1 ? a : null)) : (a = W1.call(this._longMonthsParse, i), a !== -1 ? a : (a = W1.call(this._shortMonthsParse, i), a !== -1 ? a : null));
}
function _G0(t16, e, r12) {
  var n12, a, o;
  if (this._monthsParseExact)
    return AG0.call(this, t16, e, r12);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n12 = 0; n12 < 12; n12++) {
    if (a = Cn([2e3, n12]), r12 && !this._longMonthsParse[n12] && (this._longMonthsParse[n12] = new RegExp(
      "^" + this.months(a, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[n12] = new RegExp(
      "^" + this.monthsShort(a, "").replace(".", "") + "$",
      "i"
    )), !r12 && !this._monthsParse[n12] && (o = "^" + this.months(a, "") + "|^" + this.monthsShort(a, ""), this._monthsParse[n12] = new RegExp(o.replace(".", ""), "i")), r12 && e === "MMMM" && this._longMonthsParse[n12].test(t16))
      return n12;
    if (r12 && e === "MMM" && this._shortMonthsParse[n12].test(t16))
      return n12;
    if (!r12 && this._monthsParse[n12].test(t16))
      return n12;
  }
}
function D$e(t16, e) {
  if (!t16.isValid())
    return t16;
  if (typeof e == "string") {
    if (/^\d+$/.test(e))
      e = k0(e);
    else if (e = t16.localeData().monthsParse(e), !oa(e))
      return t16;
  }
  var r12 = e, n12 = t16.date();
  return n12 = n12 < 29 ? n12 : Math.min(n12, _0e(t16.year(), r12)), t16._isUTC ? t16._d.setUTCMonth(r12, n12) : t16._d.setMonth(r12, n12), t16;
}
function W$e(t16) {
  return t16 != null ? (D$e(this, t16), ke.updateOffset(this, true), this) : xs(this, "Month");
}
function hG0() {
  return _0e(this.year(), this.month());
}
function vG0(t16) {
  return this._monthsParseExact ? (G0(this, "_monthsRegex") || N$e.call(this), t16 ? this._monthsShortStrictRegex : this._monthsShortRegex) : (G0(this, "_monthsShortRegex") || (this._monthsShortRegex = bG0), this._monthsShortStrictRegex && t16 ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function mG0(t16) {
  return this._monthsParseExact ? (G0(this, "_monthsRegex") || N$e.call(this), t16 ? this._monthsStrictRegex : this._monthsRegex) : (G0(this, "_monthsRegex") || (this._monthsRegex = MG0), this._monthsStrictRegex && t16 ? this._monthsStrictRegex : this._monthsRegex);
}
function N$e() {
  function t16(s12, c) {
    return c.length - s12.length;
  }
  var e = [], r12 = [], n12 = [], a, o, i, u;
  for (a = 0; a < 12; a++)
    o = Cn([2e3, a]), i = Kn(this.monthsShort(o, "")), u = Kn(this.months(o, "")), e.push(i), r12.push(u), n12.push(u), n12.push(i);
  e.sort(t16), r12.sort(t16), n12.sort(t16), this._monthsRegex = new RegExp("^(" + n12.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r12.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  );
}
function RG0(t16, e, r12, n12, a, o, i) {
  var u;
  return t16 < 100 && t16 >= 0 ? (u = new Date(t16 + 400, e, r12, n12, a, o, i), isFinite(u.getFullYear()) && u.setFullYear(t16)) : u = new Date(t16, e, r12, n12, a, o, i), u;
}
function Us(t16) {
  var e, r12;
  return t16 < 100 && t16 >= 0 ? (r12 = Array.prototype.slice.call(arguments), r12[0] = t16 + 400, e = new Date(Date.UTC.apply(null, r12)), isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t16)) : e = new Date(Date.UTC.apply(null, arguments)), e;
}
function I2(t16, e, r12) {
  var n12 = 7 + e - r12, a = (7 + Us(t16, 0, n12).getUTCDay() - e) % 7;
  return -a + n12 - 1;
}
function w$e(t16, e, r12, n12, a) {
  var o = (7 + r12 - n12) % 7, i = I2(t16, n12, a), u = 1 + 7 * (e - 1) + o + i, s12, c;
  return u <= 0 ? (s12 = t16 - 1, c = Os(s12) + u) : u > Os(t16) ? (s12 = t16 + 1, c = u - Os(t16)) : (s12 = t16, c = u), {
    year: s12,
    dayOfYear: c
  };
}
function ks(t16, e, r12) {
  var n12 = I2(t16.year(), e, r12), a = Math.floor((t16.dayOfYear() - n12 - 1) / 7) + 1, o, i;
  return a < 1 ? (i = t16.year() - 1, o = a + Qn(i, e, r12)) : a > Qn(t16.year(), e, r12) ? (o = a - Qn(t16.year(), e, r12), i = t16.year() + 1) : (i = t16.year(), o = a), {
    week: o,
    year: i
  };
}
function Qn(t16, e, r12) {
  var n12 = I2(t16, e, r12), a = I2(t16 + 1, e, r12);
  return (Os(t16) - n12 + a) / 7;
}
c0("w", ["ww", 2], "wo", "week");
c0("W", ["WW", 2], "Wo", "isoWeek");
Xe("w", _1, Fi);
Xe("ww", _1, cr);
Xe("W", _1, Fi);
Xe("WW", _1, cr);
yc(
  ["w", "ww", "W", "WW"],
  function(t16, e, r12, n12) {
    e[n12.substr(0, 1)] = k0(t16);
  }
);
function qG0(t16) {
  return ks(t16, this._week.dow, this._week.doy).week;
}
var TG0 = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function yG0() {
  return this._week.dow;
}
function SG0() {
  return this._week.doy;
}
function CG0(t16) {
  var e = this.localeData().week(this);
  return t16 == null ? e : this.add((t16 - e) * 7, "d");
}
function gG0(t16) {
  var e = ks(this, 1, 4).week;
  return t16 == null ? e : this.add((t16 - e) * 7, "d");
}
c0("d", 0, "do", "day");
c0("dd", 0, 0, function(t16) {
  return this.localeData().weekdaysMin(this, t16);
});
c0("ddd", 0, 0, function(t16) {
  return this.localeData().weekdaysShort(this, t16);
});
c0("dddd", 0, 0, function(t16) {
  return this.localeData().weekdays(this, t16);
});
c0("e", 0, 0, "weekday");
c0("E", 0, 0, "isoWeekday");
Xe("d", _1);
Xe("e", _1);
Xe("E", _1);
Xe("dd", function(t16, e) {
  return e.weekdaysMinRegex(t16);
});
Xe("ddd", function(t16, e) {
  return e.weekdaysShortRegex(t16);
});
Xe("dddd", function(t16, e) {
  return e.weekdaysRegex(t16);
});
yc(["dd", "ddd", "dddd"], function(t16, e, r12, n12) {
  var a = r12._locale.weekdaysParse(t16, n12, r12._strict);
  a != null ? e.d = a : g0(r12).invalidWeekday = t16;
});
yc(["d", "e", "E"], function(t16, e, r12, n12) {
  e[n12] = k0(t16);
});
function IG0(t16, e) {
  return typeof t16 != "string" ? t16 : isNaN(t16) ? (t16 = e.weekdaysParse(t16), typeof t16 == "number" ? t16 : null) : parseInt(t16, 10);
}
function EG0(t16, e) {
  return typeof t16 == "string" ? e.weekdaysParse(t16) % 7 || 7 : isNaN(t16) ? null : t16;
}
function h0e(t16, e) {
  return t16.slice(e, 7).concat(t16.slice(0, e));
}
var LG0 = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), B$e = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), PG0 = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), DG0 = Tc, WG0 = Tc, NG0 = Tc;
function wG0(t16, e) {
  var r12 = tn(this._weekdays) ? this._weekdays : this._weekdays[t16 && t16 !== true && this._weekdays.isFormat.test(e) ? "format" : "standalone"];
  return t16 === true ? h0e(r12, this._week.dow) : t16 ? r12[t16.day()] : r12;
}
function BG0(t16) {
  return t16 === true ? h0e(this._weekdaysShort, this._week.dow) : t16 ? this._weekdaysShort[t16.day()] : this._weekdaysShort;
}
function xG0(t16) {
  return t16 === true ? h0e(this._weekdaysMin, this._week.dow) : t16 ? this._weekdaysMin[t16.day()] : this._weekdaysMin;
}
function UG0(t16, e, r12) {
  var n12, a, o, i = t16.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n12 = 0; n12 < 7; ++n12)
      o = Cn([2e3, 1]).day(n12), this._minWeekdaysParse[n12] = this.weekdaysMin(
        o,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[n12] = this.weekdaysShort(
        o,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[n12] = this.weekdays(o, "").toLocaleLowerCase();
  return r12 ? e === "dddd" ? (a = W1.call(this._weekdaysParse, i), a !== -1 ? a : null) : e === "ddd" ? (a = W1.call(this._shortWeekdaysParse, i), a !== -1 ? a : null) : (a = W1.call(this._minWeekdaysParse, i), a !== -1 ? a : null) : e === "dddd" ? (a = W1.call(this._weekdaysParse, i), a !== -1 || (a = W1.call(this._shortWeekdaysParse, i), a !== -1) ? a : (a = W1.call(this._minWeekdaysParse, i), a !== -1 ? a : null)) : e === "ddd" ? (a = W1.call(this._shortWeekdaysParse, i), a !== -1 || (a = W1.call(this._weekdaysParse, i), a !== -1) ? a : (a = W1.call(this._minWeekdaysParse, i), a !== -1 ? a : null)) : (a = W1.call(this._minWeekdaysParse, i), a !== -1 || (a = W1.call(this._weekdaysParse, i), a !== -1) ? a : (a = W1.call(this._shortWeekdaysParse, i), a !== -1 ? a : null));
}
function kG0(t16, e, r12) {
  var n12, a, o;
  if (this._weekdaysParseExact)
    return UG0.call(this, t16, e, r12);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n12 = 0; n12 < 7; n12++) {
    if (a = Cn([2e3, 1]).day(n12), r12 && !this._fullWeekdaysParse[n12] && (this._fullWeekdaysParse[n12] = new RegExp(
      "^" + this.weekdays(a, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[n12] = new RegExp(
      "^" + this.weekdaysShort(a, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[n12] = new RegExp(
      "^" + this.weekdaysMin(a, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[n12] || (o = "^" + this.weekdays(a, "") + "|^" + this.weekdaysShort(a, "") + "|^" + this.weekdaysMin(a, ""), this._weekdaysParse[n12] = new RegExp(o.replace(".", ""), "i")), r12 && e === "dddd" && this._fullWeekdaysParse[n12].test(t16))
      return n12;
    if (r12 && e === "ddd" && this._shortWeekdaysParse[n12].test(t16))
      return n12;
    if (r12 && e === "dd" && this._minWeekdaysParse[n12].test(t16))
      return n12;
    if (!r12 && this._weekdaysParse[n12].test(t16))
      return n12;
  }
}
function jG0(t16) {
  if (!this.isValid())
    return t16 != null ? this : NaN;
  var e = xs(this, "Day");
  return t16 != null ? (t16 = IG0(t16, this.localeData()), this.add(t16 - e, "d")) : e;
}
function FG0(t16) {
  if (!this.isValid())
    return t16 != null ? this : NaN;
  var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return t16 == null ? e : this.add(t16 - e, "d");
}
function VG0(t16) {
  if (!this.isValid())
    return t16 != null ? this : NaN;
  if (t16 != null) {
    var e = EG0(t16, this.localeData());
    return this.day(this.day() % 7 ? e : e - 7);
  } else
    return this.day() || 7;
}
function HG0(t16) {
  return this._weekdaysParseExact ? (G0(this, "_weekdaysRegex") || v0e.call(this), t16 ? this._weekdaysStrictRegex : this._weekdaysRegex) : (G0(this, "_weekdaysRegex") || (this._weekdaysRegex = DG0), this._weekdaysStrictRegex && t16 ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function XG0(t16) {
  return this._weekdaysParseExact ? (G0(this, "_weekdaysRegex") || v0e.call(this), t16 ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (G0(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = WG0), this._weekdaysShortStrictRegex && t16 ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function $G0(t16) {
  return this._weekdaysParseExact ? (G0(this, "_weekdaysRegex") || v0e.call(this), t16 ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (G0(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = NG0), this._weekdaysMinStrictRegex && t16 ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function v0e() {
  function t16(l2, f) {
    return f.length - l2.length;
  }
  var e = [], r12 = [], n12 = [], a = [], o, i, u, s12, c;
  for (o = 0; o < 7; o++)
    i = Cn([2e3, 1]).day(o), u = Kn(this.weekdaysMin(i, "")), s12 = Kn(this.weekdaysShort(i, "")), c = Kn(this.weekdays(i, "")), e.push(u), r12.push(s12), n12.push(c), a.push(u), a.push(s12), a.push(c);
  e.sort(t16), r12.sort(t16), n12.sort(t16), a.sort(t16), this._weekdaysRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + n12.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r12.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  );
}
function m0e() {
  return this.hours() % 12 || 12;
}
function GG0() {
  return this.hours() || 24;
}
c0("H", ["HH", 2], 0, "hour");
c0("h", ["hh", 2], 0, m0e);
c0("k", ["kk", 2], 0, GG0);
c0("hmm", 0, 0, function() {
  return "" + m0e.apply(this) + hn(this.minutes(), 2);
});
c0("hmmss", 0, 0, function() {
  return "" + m0e.apply(this) + hn(this.minutes(), 2) + hn(this.seconds(), 2);
});
c0("Hmm", 0, 0, function() {
  return "" + this.hours() + hn(this.minutes(), 2);
});
c0("Hmmss", 0, 0, function() {
  return "" + this.hours() + hn(this.minutes(), 2) + hn(this.seconds(), 2);
});
function x$e(t16, e) {
  c0(t16, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      e
    );
  });
}
x$e("a", true);
x$e("A", false);
function U$e(t16, e) {
  return e._meridiemParse;
}
Xe("a", U$e);
Xe("A", U$e);
Xe("H", _1, A0e);
Xe("h", _1, Fi);
Xe("k", _1, Fi);
Xe("HH", _1, cr);
Xe("hh", _1, cr);
Xe("kk", _1, cr);
Xe("hmm", C$e);
Xe("hmmss", g$e);
Xe("Hmm", C$e);
Xe("Hmmss", g$e);
o1(["H", "HH"], K1);
o1(["k", "kk"], function(t16, e, r12) {
  var n12 = k0(t16);
  e[K1] = n12 === 24 ? 0 : n12;
});
o1(["a", "A"], function(t16, e, r12) {
  r12._isPm = r12._locale.isPM(t16), r12._meridiem = t16;
});
o1(["h", "hh"], function(t16, e, r12) {
  e[K1] = k0(t16), g0(r12).bigHour = true;
});
o1("hmm", function(t16, e, r12) {
  var n12 = t16.length - 2;
  e[K1] = k0(t16.substr(0, n12)), e[Yr] = k0(t16.substr(n12)), g0(r12).bigHour = true;
});
o1("hmmss", function(t16, e, r12) {
  var n12 = t16.length - 4, a = t16.length - 2;
  e[K1] = k0(t16.substr(0, n12)), e[Yr] = k0(t16.substr(n12, 2)), e[$n] = k0(t16.substr(a)), g0(r12).bigHour = true;
});
o1("Hmm", function(t16, e, r12) {
  var n12 = t16.length - 2;
  e[K1] = k0(t16.substr(0, n12)), e[Yr] = k0(t16.substr(n12));
});
o1("Hmmss", function(t16, e, r12) {
  var n12 = t16.length - 4, a = t16.length - 2;
  e[K1] = k0(t16.substr(0, n12)), e[Yr] = k0(t16.substr(n12, 2)), e[$n] = k0(t16.substr(a));
});
function YG0(t16) {
  return (t16 + "").toLowerCase().charAt(0) === "p";
}
var JG0 = /[ap]\.?m?\.?/i, KG0 = Vi("Hours", true);
function QG0(t16, e, r12) {
  return t16 > 11 ? r12 ? "pm" : "PM" : r12 ? "am" : "AM";
}
var k$e = {
  calendar: U$0,
  longDateFormat: V$0,
  invalidDate: X$0,
  ordinal: G$0,
  dayOfMonthOrdinalParse: Y$0,
  relativeTime: K$0,
  months: fG0,
  monthsShort: L$e,
  week: TG0,
  weekdays: LG0,
  weekdaysMin: PG0,
  weekdaysShort: B$e,
  meridiemParse: JG0
}, R1 = {}, xu = {}, js;
function ZG0(t16, e) {
  var r12, n12 = Math.min(t16.length, e.length);
  for (r12 = 0; r12 < n12; r12 += 1)
    if (t16[r12] !== e[r12])
      return r12;
  return n12;
}
function Vke(t16) {
  return t16 && t16.toLowerCase().replace("_", "-");
}
function eY0(t16) {
  for (var e = 0, r12, n12, a, o; e < t16.length; ) {
    for (o = Vke(t16[e]).split("-"), r12 = o.length, n12 = Vke(t16[e + 1]), n12 = n12 ? n12.split("-") : null; r12 > 0; ) {
      if (a = Np(o.slice(0, r12).join("-")), a)
        return a;
      if (n12 && n12.length >= r12 && ZG0(o, n12) >= r12 - 1)
        break;
      r12--;
    }
    e++;
  }
  return js;
}
function tY0(t16) {
  return !!(t16 && t16.match("^[^/\\\\]*$"));
}
function Np(t16) {
  var e = null, r12;
  if (R1[t16] === void 0 && typeof module < "u" && module && module.exports && tY0(t16))
    try {
      e = js._abbr, r12 = require, r12("./locale/" + t16), wa(e);
    } catch {
      R1[t16] = null;
    }
  return R1[t16];
}
function wa(t16, e) {
  var r12;
  return t16 && (kt(e) ? r12 = da(t16) : r12 = R0e(t16, e), r12 ? js = r12 : typeof console < "u" && console.warn && console.warn(
    "Locale " + t16 + " not found. Did you forget to load it?"
  )), js._abbr;
}
function R0e(t16, e) {
  if (e !== null) {
    var r12, n12 = k$e;
    if (e.abbr = t16, R1[t16] != null)
      q$e(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), n12 = R1[t16]._config;
    else if (e.parentLocale != null)
      if (R1[e.parentLocale] != null)
        n12 = R1[e.parentLocale]._config;
      else if (r12 = Np(e.parentLocale), r12 != null)
        n12 = r12._config;
      else
        return xu[e.parentLocale] || (xu[e.parentLocale] = []), xu[e.parentLocale].push({
          name: t16,
          config: e
        }), null;
    return R1[t16] = new f0e(vZ(n12, e)), xu[t16] && xu[t16].forEach(function(a) {
      R0e(a.name, a.config);
    }), wa(t16), R1[t16];
  } else
    return delete R1[t16], null;
}
function rY0(t16, e) {
  if (e != null) {
    var r12, n12, a = k$e;
    R1[t16] != null && R1[t16].parentLocale != null ? R1[t16].set(vZ(R1[t16]._config, e)) : (n12 = Np(t16), n12 != null && (a = n12._config), e = vZ(a, e), n12 == null && (e.abbr = t16), r12 = new f0e(e), r12.parentLocale = R1[t16], R1[t16] = r12), wa(t16);
  } else
    R1[t16] != null && (R1[t16].parentLocale != null ? (R1[t16] = R1[t16].parentLocale, t16 === wa() && wa(t16)) : R1[t16] != null && delete R1[t16]);
  return R1[t16];
}
function da(t16) {
  var e;
  if (t16 && t16._locale && t16._locale._abbr && (t16 = t16._locale._abbr), !t16)
    return js;
  if (!tn(t16)) {
    if (e = Np(t16), e)
      return e;
    t16 = [t16];
  }
  return eY0(t16);
}
function nY0() {
  return mZ(R1);
}
function q0e(t16) {
  var e, r12 = t16._a;
  return r12 && g0(t16).overflow === -2 && (e = r12[Xn] < 0 || r12[Xn] > 11 ? Xn : r12[dn] < 1 || r12[dn] > _0e(r12[Tt], r12[Xn]) ? dn : r12[K1] < 0 || r12[K1] > 24 || r12[K1] === 24 && (r12[Yr] !== 0 || r12[$n] !== 0 || r12[zo] !== 0) ? K1 : r12[Yr] < 0 || r12[Yr] > 59 ? Yr : r12[$n] < 0 || r12[$n] > 59 ? $n : r12[zo] < 0 || r12[zo] > 999 ? zo : -1, g0(t16)._overflowDayOfYear && (e < Tt || e > dn) && (e = dn), g0(t16)._overflowWeeks && e === -1 && (e = uG0), g0(t16)._overflowWeekday && e === -1 && (e = sG0), g0(t16).overflow = e), t16;
}
var aY0 = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, oY0 = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, iY0 = /Z|[+-]\d\d(?::?\d\d)?/, _l = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, false],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, false],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, false],
  ["YYYY", /\d{4}/, false]
], nQ = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], uY0 = /^\/?Date\((-?\d+)/i, sY0 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, cY0 = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function j$e(t16) {
  var e, r12, n12 = t16._i, a = aY0.exec(n12) || oY0.exec(n12), o, i, u, s12, c = _l.length, l2 = nQ.length;
  if (a) {
    for (g0(t16).iso = true, e = 0, r12 = c; e < r12; e++)
      if (_l[e][1].exec(a[1])) {
        i = _l[e][0], o = _l[e][2] !== false;
        break;
      }
    if (i == null) {
      t16._isValid = false;
      return;
    }
    if (a[3]) {
      for (e = 0, r12 = l2; e < r12; e++)
        if (nQ[e][1].exec(a[3])) {
          u = (a[2] || " ") + nQ[e][0];
          break;
        }
      if (u == null) {
        t16._isValid = false;
        return;
      }
    }
    if (!o && u != null) {
      t16._isValid = false;
      return;
    }
    if (a[4])
      if (iY0.exec(a[4]))
        s12 = "Z";
      else {
        t16._isValid = false;
        return;
      }
    t16._f = i + (u || "") + (s12 || ""), y0e(t16);
  } else
    t16._isValid = false;
}
function lY0(t16, e, r12, n12, a, o) {
  var i = [
    pY0(t16),
    L$e.indexOf(e),
    parseInt(r12, 10),
    parseInt(n12, 10),
    parseInt(a, 10)
  ];
  return o && i.push(parseInt(o, 10)), i;
}
function pY0(t16) {
  var e = parseInt(t16, 10);
  return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e;
}
function dY0(t16) {
  return t16.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function fY0(t16, e, r12) {
  if (t16) {
    var n12 = B$e.indexOf(t16), a = new Date(
      e[0],
      e[1],
      e[2]
    ).getDay();
    if (n12 !== a)
      return g0(r12).weekdayMismatch = true, r12._isValid = false, false;
  }
  return true;
}
function bY0(t16, e, r12) {
  if (t16)
    return cY0[t16];
  if (e)
    return 0;
  var n12 = parseInt(r12, 10), a = n12 % 100, o = (n12 - a) / 100;
  return o * 60 + a;
}
function F$e(t16) {
  var e = sY0.exec(dY0(t16._i)), r12;
  if (e) {
    if (r12 = lY0(
      e[4],
      e[3],
      e[2],
      e[5],
      e[6],
      e[7]
    ), !fY0(e[1], r12, t16))
      return;
    t16._a = r12, t16._tzm = bY0(e[8], e[9], e[10]), t16._d = Us.apply(null, t16._a), t16._d.setUTCMinutes(t16._d.getUTCMinutes() - t16._tzm), g0(t16).rfc2822 = true;
  } else
    t16._isValid = false;
}
function MY0(t16) {
  var e = uY0.exec(t16._i);
  if (e !== null) {
    t16._d = /* @__PURE__ */ new Date(+e[1]);
    return;
  }
  if (j$e(t16), t16._isValid === false)
    delete t16._isValid;
  else
    return;
  if (F$e(t16), t16._isValid === false)
    delete t16._isValid;
  else
    return;
  t16._strict ? t16._isValid = false : ke.createFromInputFallback(t16);
}
ke.createFromInputFallback = gr(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(t16) {
    t16._d = /* @__PURE__ */ new Date(t16._i + (t16._useUTC ? " UTC" : ""));
  }
);
function Ko(t16, e, r12) {
  return t16 ?? e ?? r12;
}
function OY0(t16) {
  var e = new Date(ke.now());
  return t16._useUTC ? [
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate()
  ] : [e.getFullYear(), e.getMonth(), e.getDate()];
}
function T0e(t16) {
  var e, r12, n12 = [], a, o, i;
  if (!t16._d) {
    for (a = OY0(t16), t16._w && t16._a[dn] == null && t16._a[Xn] == null && zY0(t16), t16._dayOfYear != null && (i = Ko(t16._a[Tt], a[Tt]), (t16._dayOfYear > Os(i) || t16._dayOfYear === 0) && (g0(t16)._overflowDayOfYear = true), r12 = Us(i, 0, t16._dayOfYear), t16._a[Xn] = r12.getUTCMonth(), t16._a[dn] = r12.getUTCDate()), e = 0; e < 3 && t16._a[e] == null; ++e)
      t16._a[e] = n12[e] = a[e];
    for (; e < 7; e++)
      t16._a[e] = n12[e] = t16._a[e] == null ? e === 2 ? 1 : 0 : t16._a[e];
    t16._a[K1] === 24 && t16._a[Yr] === 0 && t16._a[$n] === 0 && t16._a[zo] === 0 && (t16._nextDay = true, t16._a[K1] = 0), t16._d = (t16._useUTC ? Us : RG0).apply(
      null,
      n12
    ), o = t16._useUTC ? t16._d.getUTCDay() : t16._d.getDay(), t16._tzm != null && t16._d.setUTCMinutes(t16._d.getUTCMinutes() - t16._tzm), t16._nextDay && (t16._a[K1] = 24), t16._w && typeof t16._w.d < "u" && t16._w.d !== o && (g0(t16).weekdayMismatch = true);
  }
}
function zY0(t16) {
  var e, r12, n12, a, o, i, u, s12, c;
  e = t16._w, e.GG != null || e.W != null || e.E != null ? (o = 1, i = 4, r12 = Ko(
    e.GG,
    t16._a[Tt],
    ks(z1(), 1, 4).year
  ), n12 = Ko(e.W, 1), a = Ko(e.E, 1), (a < 1 || a > 7) && (s12 = true)) : (o = t16._locale._week.dow, i = t16._locale._week.doy, c = ks(z1(), o, i), r12 = Ko(e.gg, t16._a[Tt], c.year), n12 = Ko(e.w, c.week), e.d != null ? (a = e.d, (a < 0 || a > 6) && (s12 = true)) : e.e != null ? (a = e.e + o, (e.e < 0 || e.e > 6) && (s12 = true)) : a = o), n12 < 1 || n12 > Qn(r12, o, i) ? g0(t16)._overflowWeeks = true : s12 != null ? g0(t16)._overflowWeekday = true : (u = w$e(r12, n12, a, o, i), t16._a[Tt] = u.year, t16._dayOfYear = u.dayOfYear);
}
ke.ISO_8601 = function() {
};
ke.RFC_2822 = function() {
};
function y0e(t16) {
  if (t16._f === ke.ISO_8601) {
    j$e(t16);
    return;
  }
  if (t16._f === ke.RFC_2822) {
    F$e(t16);
    return;
  }
  t16._a = [], g0(t16).empty = true;
  var e = "" + t16._i, r12, n12, a, o, i, u = e.length, s12 = 0, c, l2;
  for (a = T$e(t16._f, t16._locale).match(b0e) || [], l2 = a.length, r12 = 0; r12 < l2; r12++)
    o = a[r12], n12 = (e.match(aG0(o, t16)) || [])[0], n12 && (i = e.substr(0, e.indexOf(n12)), i.length > 0 && g0(t16).unusedInput.push(i), e = e.slice(
      e.indexOf(n12) + n12.length
    ), s12 += n12.length), pi[o] ? (n12 ? g0(t16).empty = false : g0(t16).unusedTokens.push(o), iG0(o, n12, t16)) : t16._strict && !n12 && g0(t16).unusedTokens.push(o);
  g0(t16).charsLeftOver = u - s12, e.length > 0 && g0(t16).unusedInput.push(e), t16._a[K1] <= 12 && g0(t16).bigHour === true && t16._a[K1] > 0 && (g0(t16).bigHour = void 0), g0(t16).parsedDateParts = t16._a.slice(0), g0(t16).meridiem = t16._meridiem, t16._a[K1] = AY0(
    t16._locale,
    t16._a[K1],
    t16._meridiem
  ), c = g0(t16).era, c !== null && (t16._a[Tt] = t16._locale.erasConvertYear(c, t16._a[Tt])), T0e(t16), q0e(t16);
}
function AY0(t16, e, r12) {
  var n12;
  return r12 == null ? e : t16.meridiemHour != null ? t16.meridiemHour(e, r12) : (t16.isPM != null && (n12 = t16.isPM(r12), n12 && e < 12 && (e += 12), !n12 && e === 12 && (e = 0)), e);
}
function _Y0(t16) {
  var e, r12, n12, a, o, i, u = false, s12 = t16._f.length;
  if (s12 === 0) {
    g0(t16).invalidFormat = true, t16._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (a = 0; a < s12; a++)
    o = 0, i = false, e = d0e({}, t16), t16._useUTC != null && (e._useUTC = t16._useUTC), e._f = t16._f[a], y0e(e), p0e(e) && (i = true), o += g0(e).charsLeftOver, o += g0(e).unusedTokens.length * 10, g0(e).score = o, u ? o < n12 && (n12 = o, r12 = e) : (n12 == null || o < n12 || i) && (n12 = o, r12 = e, i && (u = true));
  Ia(t16, r12 || e);
}
function hY0(t16) {
  if (!t16._d) {
    var e = M0e(t16._i), r12 = e.day === void 0 ? e.date : e.day;
    t16._a = m$e(
      [e.year, e.month, r12, e.hour, e.minute, e.second, e.millisecond],
      function(n12) {
        return n12 && parseInt(n12, 10);
      }
    ), T0e(t16);
  }
}
function vY0(t16) {
  var e = new qc(q0e(V$e(t16)));
  return e._nextDay && (e.add(1, "d"), e._nextDay = void 0), e;
}
function V$e(t16) {
  var e = t16._i, r12 = t16._f;
  return t16._locale = t16._locale || da(t16._l), e === null || r12 === void 0 && e === "" ? gp({ nullInput: true }) : (typeof e == "string" && (t16._i = e = t16._locale.preparse(e)), rn(e) ? new qc(q0e(e)) : (Rc(e) ? t16._d = e : tn(r12) ? _Y0(t16) : r12 ? y0e(t16) : mY0(t16), p0e(t16) || (t16._d = null), t16));
}
function mY0(t16) {
  var e = t16._i;
  kt(e) ? t16._d = new Date(ke.now()) : Rc(e) ? t16._d = new Date(e.valueOf()) : typeof e == "string" ? MY0(t16) : tn(e) ? (t16._a = m$e(e.slice(0), function(r12) {
    return parseInt(r12, 10);
  }), T0e(t16)) : Ao(e) ? hY0(t16) : oa(e) ? t16._d = new Date(e) : ke.createFromInputFallback(t16);
}
function H$e(t16, e, r12, n12, a) {
  var o = {};
  return (e === true || e === false) && (n12 = e, e = void 0), (r12 === true || r12 === false) && (n12 = r12, r12 = void 0), (Ao(t16) && l0e(t16) || tn(t16) && t16.length === 0) && (t16 = void 0), o._isAMomentObject = true, o._useUTC = o._isUTC = a, o._l = r12, o._i = t16, o._f = e, o._strict = n12, vY0(o);
}
function z1(t16, e, r12, n12) {
  return H$e(t16, e, r12, n12, false);
}
var RY0 = gr(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var t16 = z1.apply(null, arguments);
    return this.isValid() && t16.isValid() ? t16 < this ? this : t16 : gp();
  }
), qY0 = gr(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var t16 = z1.apply(null, arguments);
    return this.isValid() && t16.isValid() ? t16 > this ? this : t16 : gp();
  }
);
function X$e(t16, e) {
  var r12, n12;
  if (e.length === 1 && tn(e[0]) && (e = e[0]), !e.length)
    return z1();
  for (r12 = e[0], n12 = 1; n12 < e.length; ++n12)
    (!e[n12].isValid() || e[n12][t16](r12)) && (r12 = e[n12]);
  return r12;
}
function TY0() {
  var t16 = [].slice.call(arguments, 0);
  return X$e("isBefore", t16);
}
function yY0() {
  var t16 = [].slice.call(arguments, 0);
  return X$e("isAfter", t16);
}
var SY0 = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Uu = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function CY0(t16) {
  var e, r12 = false, n12, a = Uu.length;
  for (e in t16)
    if (G0(t16, e) && !(W1.call(Uu, e) !== -1 && (t16[e] == null || !isNaN(t16[e]))))
      return false;
  for (n12 = 0; n12 < a; ++n12)
    if (t16[Uu[n12]]) {
      if (r12)
        return false;
      parseFloat(t16[Uu[n12]]) !== k0(t16[Uu[n12]]) && (r12 = true);
    }
  return true;
}
function gY0() {
  return this._isValid;
}
function IY0() {
  return an(NaN);
}
function wp(t16) {
  var e = M0e(t16), r12 = e.year || 0, n12 = e.quarter || 0, a = e.month || 0, o = e.week || e.isoWeek || 0, i = e.day || 0, u = e.hour || 0, s12 = e.minute || 0, c = e.second || 0, l2 = e.millisecond || 0;
  this._isValid = CY0(e), this._milliseconds = +l2 + c * 1e3 + // 1000
  s12 * 6e4 + // 1000 * 60
  u * 1e3 * 60 * 60, this._days = +i + o * 7, this._months = +a + n12 * 3 + r12 * 12, this._data = {}, this._locale = da(), this._bubble();
}
function Ql(t16) {
  return t16 instanceof wp;
}
function qZ(t16) {
  return t16 < 0 ? Math.round(-1 * t16) * -1 : Math.round(t16);
}
function EY0(t16, e, r12) {
  var n12 = Math.min(t16.length, e.length), a = Math.abs(t16.length - e.length), o = 0, i;
  for (i = 0; i < n12; i++)
    k0(t16[i]) !== k0(e[i]) && o++;
  return o + a;
}
function $$e(t16, e) {
  c0(t16, 0, 0, function() {
    var r12 = this.utcOffset(), n12 = "+";
    return r12 < 0 && (r12 = -r12, n12 = "-"), n12 + hn(~~(r12 / 60), 2) + e + hn(~~r12 % 60, 2);
  });
}
$$e("Z", ":");
$$e("ZZ", "");
Xe("Z", Dp);
Xe("ZZ", Dp);
o1(["Z", "ZZ"], function(t16, e, r12) {
  r12._useUTC = true, r12._tzm = S0e(Dp, t16);
});
var LY0 = /([\+\-]|\d\d)/gi;
function S0e(t16, e) {
  var r12 = (e || "").match(t16), n12, a, o;
  return r12 === null ? null : (n12 = r12[r12.length - 1] || [], a = (n12 + "").match(LY0) || ["-", 0, 0], o = +(a[1] * 60) + k0(a[2]), o === 0 ? 0 : a[0] === "+" ? o : -o);
}
function C0e(t16, e) {
  var r12, n12;
  return e._isUTC ? (r12 = e.clone(), n12 = (rn(t16) || Rc(t16) ? t16.valueOf() : z1(t16).valueOf()) - r12.valueOf(), r12._d.setTime(r12._d.valueOf() + n12), ke.updateOffset(r12, false), r12) : z1(t16).local();
}
function TZ(t16) {
  return -Math.round(t16._d.getTimezoneOffset());
}
ke.updateOffset = function() {
};
function PY0(t16, e, r12) {
  var n12 = this._offset || 0, a;
  if (!this.isValid())
    return t16 != null ? this : NaN;
  if (t16 != null) {
    if (typeof t16 == "string") {
      if (t16 = S0e(Dp, t16), t16 === null)
        return this;
    } else
      Math.abs(t16) < 16 && !r12 && (t16 = t16 * 60);
    return !this._isUTC && e && (a = TZ(this)), this._offset = t16, this._isUTC = true, a != null && this.add(a, "m"), n12 !== t16 && (!e || this._changeInProgress ? J$e(
      this,
      an(t16 - n12, "m"),
      1,
      false
    ) : this._changeInProgress || (this._changeInProgress = true, ke.updateOffset(this, true), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? n12 : TZ(this);
}
function DY0(t16, e) {
  return t16 != null ? (typeof t16 != "string" && (t16 = -t16), this.utcOffset(t16, e), this) : -this.utcOffset();
}
function WY0(t16) {
  return this.utcOffset(0, t16);
}
function NY0(t16) {
  return this._isUTC && (this.utcOffset(0, t16), this._isUTC = false, t16 && this.subtract(TZ(this), "m")), this;
}
function wY0() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, false, true);
  else if (typeof this._i == "string") {
    var t16 = S0e(rG0, this._i);
    t16 != null ? this.utcOffset(t16) : this.utcOffset(0, true);
  }
  return this;
}
function BY0(t16) {
  return this.isValid() ? (t16 = t16 ? z1(t16).utcOffset() : 0, (this.utcOffset() - t16) % 60 === 0) : false;
}
function xY0() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function UY0() {
  if (!kt(this._isDSTShifted))
    return this._isDSTShifted;
  var t16 = {}, e;
  return d0e(t16, this), t16 = V$e(t16), t16._a ? (e = t16._isUTC ? Cn(t16._a) : z1(t16._a), this._isDSTShifted = this.isValid() && EY0(t16._a, e.toArray()) > 0) : this._isDSTShifted = false, this._isDSTShifted;
}
function kY0() {
  return this.isValid() ? !this._isUTC : false;
}
function jY0() {
  return this.isValid() ? this._isUTC : false;
}
function G$e() {
  return this.isValid() ? this._isUTC && this._offset === 0 : false;
}
var FY0 = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, VY0 = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function an(t16, e) {
  var r12 = t16, n12 = null, a, o, i;
  return Ql(t16) ? r12 = {
    ms: t16._milliseconds,
    d: t16._days,
    M: t16._months
  } : oa(t16) || !isNaN(+t16) ? (r12 = {}, e ? r12[e] = +t16 : r12.milliseconds = +t16) : (n12 = FY0.exec(t16)) ? (a = n12[1] === "-" ? -1 : 1, r12 = {
    y: 0,
    d: k0(n12[dn]) * a,
    h: k0(n12[K1]) * a,
    m: k0(n12[Yr]) * a,
    s: k0(n12[$n]) * a,
    ms: k0(qZ(n12[zo] * 1e3)) * a
    // the millisecond decimal point is included in the match
  }) : (n12 = VY0.exec(t16)) ? (a = n12[1] === "-" ? -1 : 1, r12 = {
    y: eo(n12[2], a),
    M: eo(n12[3], a),
    w: eo(n12[4], a),
    d: eo(n12[5], a),
    h: eo(n12[6], a),
    m: eo(n12[7], a),
    s: eo(n12[8], a)
  }) : r12 == null ? r12 = {} : typeof r12 == "object" && ("from" in r12 || "to" in r12) && (i = HY0(
    z1(r12.from),
    z1(r12.to)
  ), r12 = {}, r12.ms = i.milliseconds, r12.M = i.months), o = new wp(r12), Ql(t16) && G0(t16, "_locale") && (o._locale = t16._locale), Ql(t16) && G0(t16, "_isValid") && (o._isValid = t16._isValid), o;
}
an.fn = wp.prototype;
an.invalid = IY0;
function eo(t16, e) {
  var r12 = t16 && parseFloat(t16.replace(",", "."));
  return (isNaN(r12) ? 0 : r12) * e;
}
function Hke(t16, e) {
  var r12 = {};
  return r12.months = e.month() - t16.month() + (e.year() - t16.year()) * 12, t16.clone().add(r12.months, "M").isAfter(e) && --r12.months, r12.milliseconds = +e - +t16.clone().add(r12.months, "M"), r12;
}
function HY0(t16, e) {
  var r12;
  return t16.isValid() && e.isValid() ? (e = C0e(e, t16), t16.isBefore(e) ? r12 = Hke(t16, e) : (r12 = Hke(e, t16), r12.milliseconds = -r12.milliseconds, r12.months = -r12.months), r12) : { milliseconds: 0, months: 0 };
}
function Y$e(t16, e) {
  return function(r12, n12) {
    var a, o;
    return n12 !== null && !isNaN(+n12) && (q$e(
      e,
      "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), o = r12, r12 = n12, n12 = o), a = an(r12, n12), J$e(this, a, t16), this;
  };
}
function J$e(t16, e, r12, n12) {
  var a = e._milliseconds, o = qZ(e._days), i = qZ(e._months);
  t16.isValid() && (n12 = n12 ?? true, i && D$e(t16, xs(t16, "Month") + i * r12), o && E$e(t16, "Date", xs(t16, "Date") + o * r12), a && t16._d.setTime(t16._d.valueOf() + a * r12), n12 && ke.updateOffset(t16, o || i));
}
var XY0 = Y$e(1, "add"), $Y0 = Y$e(-1, "subtract");
function K$e(t16) {
  return typeof t16 == "string" || t16 instanceof String;
}
function GY0(t16) {
  return rn(t16) || Rc(t16) || K$e(t16) || oa(t16) || JY0(t16) || YY0(t16) || t16 === null || t16 === void 0;
}
function YY0(t16) {
  var e = Ao(t16) && !l0e(t16), r12 = false, n12 = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], a, o, i = n12.length;
  for (a = 0; a < i; a += 1)
    o = n12[a], r12 = r12 || G0(t16, o);
  return e && r12;
}
function JY0(t16) {
  var e = tn(t16), r12 = false;
  return e && (r12 = t16.filter(function(n12) {
    return !oa(n12) && K$e(t16);
  }).length === 0), e && r12;
}
function KY0(t16) {
  var e = Ao(t16) && !l0e(t16), r12 = false, n12 = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], a, o;
  for (a = 0; a < n12.length; a += 1)
    o = n12[a], r12 = r12 || G0(t16, o);
  return e && r12;
}
function QY0(t16, e) {
  var r12 = t16.diff(e, "days", true);
  return r12 < -6 ? "sameElse" : r12 < -1 ? "lastWeek" : r12 < 0 ? "lastDay" : r12 < 1 ? "sameDay" : r12 < 2 ? "nextDay" : r12 < 7 ? "nextWeek" : "sameElse";
}
function ZY0(t16, e) {
  arguments.length === 1 && (arguments[0] ? GY0(arguments[0]) ? (t16 = arguments[0], e = void 0) : KY0(arguments[0]) && (e = arguments[0], t16 = void 0) : (t16 = void 0, e = void 0));
  var r12 = t16 || z1(), n12 = C0e(r12, this).startOf("day"), a = ke.calendarFormat(this, n12) || "sameElse", o = e && (gn(e[a]) ? e[a].call(this, r12) : e[a]);
  return this.format(
    o || this.localeData().calendar(a, this, z1(r12))
  );
}
function eJ0() {
  return new qc(this);
}
function tJ0(t16, e) {
  var r12 = rn(t16) ? t16 : z1(t16);
  return this.isValid() && r12.isValid() ? (e = Ir(e) || "millisecond", e === "millisecond" ? this.valueOf() > r12.valueOf() : r12.valueOf() < this.clone().startOf(e).valueOf()) : false;
}
function rJ0(t16, e) {
  var r12 = rn(t16) ? t16 : z1(t16);
  return this.isValid() && r12.isValid() ? (e = Ir(e) || "millisecond", e === "millisecond" ? this.valueOf() < r12.valueOf() : this.clone().endOf(e).valueOf() < r12.valueOf()) : false;
}
function nJ0(t16, e, r12, n12) {
  var a = rn(t16) ? t16 : z1(t16), o = rn(e) ? e : z1(e);
  return this.isValid() && a.isValid() && o.isValid() ? (n12 = n12 || "()", (n12[0] === "(" ? this.isAfter(a, r12) : !this.isBefore(a, r12)) && (n12[1] === ")" ? this.isBefore(o, r12) : !this.isAfter(o, r12))) : false;
}
function aJ0(t16, e) {
  var r12 = rn(t16) ? t16 : z1(t16), n12;
  return this.isValid() && r12.isValid() ? (e = Ir(e) || "millisecond", e === "millisecond" ? this.valueOf() === r12.valueOf() : (n12 = r12.valueOf(), this.clone().startOf(e).valueOf() <= n12 && n12 <= this.clone().endOf(e).valueOf())) : false;
}
function oJ0(t16, e) {
  return this.isSame(t16, e) || this.isAfter(t16, e);
}
function iJ0(t16, e) {
  return this.isSame(t16, e) || this.isBefore(t16, e);
}
function uJ0(t16, e, r12) {
  var n12, a, o;
  if (!this.isValid())
    return NaN;
  if (n12 = C0e(t16, this), !n12.isValid())
    return NaN;
  switch (a = (n12.utcOffset() - this.utcOffset()) * 6e4, e = Ir(e), e) {
    case "year":
      o = Zl(this, n12) / 12;
      break;
    case "month":
      o = Zl(this, n12);
      break;
    case "quarter":
      o = Zl(this, n12) / 3;
      break;
    case "second":
      o = (this - n12) / 1e3;
      break;
    case "minute":
      o = (this - n12) / 6e4;
      break;
    case "hour":
      o = (this - n12) / 36e5;
      break;
    case "day":
      o = (this - n12 - a) / 864e5;
      break;
    case "week":
      o = (this - n12 - a) / 6048e5;
      break;
    default:
      o = this - n12;
  }
  return r12 ? o : zr(o);
}
function Zl(t16, e) {
  if (t16.date() < e.date())
    return -Zl(e, t16);
  var r12 = (e.year() - t16.year()) * 12 + (e.month() - t16.month()), n12 = t16.clone().add(r12, "months"), a, o;
  return e - n12 < 0 ? (a = t16.clone().add(r12 - 1, "months"), o = (e - n12) / (n12 - a)) : (a = t16.clone().add(r12 + 1, "months"), o = (e - n12) / (a - n12)), -(r12 + o) || 0;
}
ke.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
ke.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function sJ0() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function cJ0(t16) {
  if (!this.isValid())
    return null;
  var e = t16 !== true, r12 = e ? this.clone().utc() : this;
  return r12.year() < 0 || r12.year() > 9999 ? Kl(
    r12,
    e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : gn(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Kl(r12, "Z")) : Kl(
    r12,
    e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function lJ0() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var t16 = "moment", e = "", r12, n12, a, o;
  return this.isLocal() || (t16 = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", e = "Z"), r12 = "[" + t16 + '("]', n12 = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", a = "-MM-DD[T]HH:mm:ss.SSS", o = e + '[")]', this.format(r12 + n12 + a + o);
}
function pJ0(t16) {
  t16 || (t16 = this.isUtc() ? ke.defaultFormatUtc : ke.defaultFormat);
  var e = Kl(this, t16);
  return this.localeData().postformat(e);
}
function dJ0(t16, e) {
  return this.isValid() && (rn(t16) && t16.isValid() || z1(t16).isValid()) ? an({ to: this, from: t16 }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
}
function fJ0(t16) {
  return this.from(z1(), t16);
}
function bJ0(t16, e) {
  return this.isValid() && (rn(t16) && t16.isValid() || z1(t16).isValid()) ? an({ from: this, to: t16 }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
}
function MJ0(t16) {
  return this.to(z1(), t16);
}
function Q$e(t16) {
  var e;
  return t16 === void 0 ? this._locale._abbr : (e = da(t16), e != null && (this._locale = e), this);
}
var Z$e = gr(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(t16) {
    return t16 === void 0 ? this.localeData() : this.locale(t16);
  }
);
function eGe() {
  return this._locale;
}
var E2 = 1e3, di = 60 * E2, L2 = 60 * di, tGe = (365 * 400 + 97) * 24 * L2;
function fi(t16, e) {
  return (t16 % e + e) % e;
}
function rGe(t16, e, r12) {
  return t16 < 100 && t16 >= 0 ? new Date(t16 + 400, e, r12) - tGe : new Date(t16, e, r12).valueOf();
}
function nGe(t16, e, r12) {
  return t16 < 100 && t16 >= 0 ? Date.UTC(t16 + 400, e, r12) - tGe : Date.UTC(t16, e, r12);
}
function OJ0(t16) {
  var e, r12;
  if (t16 = Ir(t16), t16 === void 0 || t16 === "millisecond" || !this.isValid())
    return this;
  switch (r12 = this._isUTC ? nGe : rGe, t16) {
    case "year":
      e = r12(this.year(), 0, 1);
      break;
    case "quarter":
      e = r12(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      e = r12(this.year(), this.month(), 1);
      break;
    case "week":
      e = r12(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      e = r12(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      e = r12(this.year(), this.month(), this.date());
      break;
    case "hour":
      e = this._d.valueOf(), e -= fi(
        e + (this._isUTC ? 0 : this.utcOffset() * di),
        L2
      );
      break;
    case "minute":
      e = this._d.valueOf(), e -= fi(e, di);
      break;
    case "second":
      e = this._d.valueOf(), e -= fi(e, E2);
      break;
  }
  return this._d.setTime(e), ke.updateOffset(this, true), this;
}
function zJ0(t16) {
  var e, r12;
  if (t16 = Ir(t16), t16 === void 0 || t16 === "millisecond" || !this.isValid())
    return this;
  switch (r12 = this._isUTC ? nGe : rGe, t16) {
    case "year":
      e = r12(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      e = r12(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      e = r12(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      e = r12(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      e = r12(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      e = r12(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      e = this._d.valueOf(), e += L2 - fi(
        e + (this._isUTC ? 0 : this.utcOffset() * di),
        L2
      ) - 1;
      break;
    case "minute":
      e = this._d.valueOf(), e += di - fi(e, di) - 1;
      break;
    case "second":
      e = this._d.valueOf(), e += E2 - fi(e, E2) - 1;
      break;
  }
  return this._d.setTime(e), ke.updateOffset(this, true), this;
}
function AJ0() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function _J0() {
  return Math.floor(this.valueOf() / 1e3);
}
function hJ0() {
  return new Date(this.valueOf());
}
function vJ0() {
  var t16 = this;
  return [
    t16.year(),
    t16.month(),
    t16.date(),
    t16.hour(),
    t16.minute(),
    t16.second(),
    t16.millisecond()
  ];
}
function mJ0() {
  var t16 = this;
  return {
    years: t16.year(),
    months: t16.month(),
    date: t16.date(),
    hours: t16.hours(),
    minutes: t16.minutes(),
    seconds: t16.seconds(),
    milliseconds: t16.milliseconds()
  };
}
function RJ0() {
  return this.isValid() ? this.toISOString() : null;
}
function qJ0() {
  return p0e(this);
}
function TJ0() {
  return Ia({}, g0(this));
}
function yJ0() {
  return g0(this).overflow;
}
function SJ0() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
c0("N", 0, 0, "eraAbbr");
c0("NN", 0, 0, "eraAbbr");
c0("NNN", 0, 0, "eraAbbr");
c0("NNNN", 0, 0, "eraName");
c0("NNNNN", 0, 0, "eraNarrow");
c0("y", ["y", 1], "yo", "eraYear");
c0("y", ["yy", 2], 0, "eraYear");
c0("y", ["yyy", 3], 0, "eraYear");
c0("y", ["yyyy", 4], 0, "eraYear");
Xe("N", g0e);
Xe("NN", g0e);
Xe("NNN", g0e);
Xe("NNNN", BJ0);
Xe("NNNNN", xJ0);
o1(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(t16, e, r12, n12) {
    var a = r12._locale.erasParse(t16, n12, r12._strict);
    a ? g0(r12).era = a : g0(r12).invalidEra = t16;
  }
);
Xe("y", ji);
Xe("yy", ji);
Xe("yyy", ji);
Xe("yyyy", ji);
Xe("yo", UJ0);
o1(["y", "yy", "yyy", "yyyy"], Tt);
o1(["yo"], function(t16, e, r12, n12) {
  var a;
  r12._locale._eraYearOrdinalRegex && (a = t16.match(r12._locale._eraYearOrdinalRegex)), r12._locale.eraYearOrdinalParse ? e[Tt] = r12._locale.eraYearOrdinalParse(t16, a) : e[Tt] = parseInt(t16, 10);
});
function CJ0(t16, e) {
  var r12, n12, a, o = this._eras || da("en")._eras;
  for (r12 = 0, n12 = o.length; r12 < n12; ++r12) {
    switch (typeof o[r12].since) {
      case "string":
        a = ke(o[r12].since).startOf("day"), o[r12].since = a.valueOf();
        break;
    }
    switch (typeof o[r12].until) {
      case "undefined":
        o[r12].until = 1 / 0;
        break;
      case "string":
        a = ke(o[r12].until).startOf("day").valueOf(), o[r12].until = a.valueOf();
        break;
    }
  }
  return o;
}
function gJ0(t16, e, r12) {
  var n12, a, o = this.eras(), i, u, s12;
  for (t16 = t16.toUpperCase(), n12 = 0, a = o.length; n12 < a; ++n12)
    if (i = o[n12].name.toUpperCase(), u = o[n12].abbr.toUpperCase(), s12 = o[n12].narrow.toUpperCase(), r12)
      switch (e) {
        case "N":
        case "NN":
        case "NNN":
          if (u === t16)
            return o[n12];
          break;
        case "NNNN":
          if (i === t16)
            return o[n12];
          break;
        case "NNNNN":
          if (s12 === t16)
            return o[n12];
          break;
      }
    else if ([i, u, s12].indexOf(t16) >= 0)
      return o[n12];
}
function IJ0(t16, e) {
  var r12 = t16.since <= t16.until ? 1 : -1;
  return e === void 0 ? ke(t16.since).year() : ke(t16.since).year() + (e - t16.offset) * r12;
}
function EJ0() {
  var t16, e, r12, n12 = this.localeData().eras();
  for (t16 = 0, e = n12.length; t16 < e; ++t16)
    if (r12 = this.clone().startOf("day").valueOf(), n12[t16].since <= r12 && r12 <= n12[t16].until || n12[t16].until <= r12 && r12 <= n12[t16].since)
      return n12[t16].name;
  return "";
}
function LJ0() {
  var t16, e, r12, n12 = this.localeData().eras();
  for (t16 = 0, e = n12.length; t16 < e; ++t16)
    if (r12 = this.clone().startOf("day").valueOf(), n12[t16].since <= r12 && r12 <= n12[t16].until || n12[t16].until <= r12 && r12 <= n12[t16].since)
      return n12[t16].narrow;
  return "";
}
function PJ0() {
  var t16, e, r12, n12 = this.localeData().eras();
  for (t16 = 0, e = n12.length; t16 < e; ++t16)
    if (r12 = this.clone().startOf("day").valueOf(), n12[t16].since <= r12 && r12 <= n12[t16].until || n12[t16].until <= r12 && r12 <= n12[t16].since)
      return n12[t16].abbr;
  return "";
}
function DJ0() {
  var t16, e, r12, n12, a = this.localeData().eras();
  for (t16 = 0, e = a.length; t16 < e; ++t16)
    if (r12 = a[t16].since <= a[t16].until ? 1 : -1, n12 = this.clone().startOf("day").valueOf(), a[t16].since <= n12 && n12 <= a[t16].until || a[t16].until <= n12 && n12 <= a[t16].since)
      return (this.year() - ke(a[t16].since).year()) * r12 + a[t16].offset;
  return this.year();
}
function WJ0(t16) {
  return G0(this, "_erasNameRegex") || I0e.call(this), t16 ? this._erasNameRegex : this._erasRegex;
}
function NJ0(t16) {
  return G0(this, "_erasAbbrRegex") || I0e.call(this), t16 ? this._erasAbbrRegex : this._erasRegex;
}
function wJ0(t16) {
  return G0(this, "_erasNarrowRegex") || I0e.call(this), t16 ? this._erasNarrowRegex : this._erasRegex;
}
function g0e(t16, e) {
  return e.erasAbbrRegex(t16);
}
function BJ0(t16, e) {
  return e.erasNameRegex(t16);
}
function xJ0(t16, e) {
  return e.erasNarrowRegex(t16);
}
function UJ0(t16, e) {
  return e._eraYearOrdinalRegex || ji;
}
function I0e() {
  var t16 = [], e = [], r12 = [], n12 = [], a, o, i, u, s12, c = this.eras();
  for (a = 0, o = c.length; a < o; ++a)
    i = Kn(c[a].name), u = Kn(c[a].abbr), s12 = Kn(c[a].narrow), e.push(i), t16.push(u), r12.push(s12), n12.push(i), n12.push(u), n12.push(s12);
  this._erasRegex = new RegExp("^(" + n12.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + t16.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r12.join("|") + ")",
    "i"
  );
}
c0(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
c0(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Bp(t16, e) {
  c0(0, [t16, t16.length], 0, e);
}
Bp("gggg", "weekYear");
Bp("ggggg", "weekYear");
Bp("GGGG", "isoWeekYear");
Bp("GGGGG", "isoWeekYear");
Xe("G", Pp);
Xe("g", Pp);
Xe("GG", _1, cr);
Xe("gg", _1, cr);
Xe("GGGG", z0e, O0e);
Xe("gggg", z0e, O0e);
Xe("GGGGG", Lp, Ip);
Xe("ggggg", Lp, Ip);
yc(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(t16, e, r12, n12) {
    e[n12.substr(0, 2)] = k0(t16);
  }
);
yc(["gg", "GG"], function(t16, e, r12, n12) {
  e[n12] = ke.parseTwoDigitYear(t16);
});
function kJ0(t16) {
  return aGe.call(
    this,
    t16,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function jJ0(t16) {
  return aGe.call(
    this,
    t16,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function FJ0() {
  return Qn(this.year(), 1, 4);
}
function VJ0() {
  return Qn(this.isoWeekYear(), 1, 4);
}
function HJ0() {
  var t16 = this.localeData()._week;
  return Qn(this.year(), t16.dow, t16.doy);
}
function XJ0() {
  var t16 = this.localeData()._week;
  return Qn(this.weekYear(), t16.dow, t16.doy);
}
function aGe(t16, e, r12, n12, a) {
  var o;
  return t16 == null ? ks(this, n12, a).year : (o = Qn(t16, n12, a), e > o && (e = o), $J0.call(this, t16, e, r12, n12, a));
}
function $J0(t16, e, r12, n12, a) {
  var o = w$e(t16, e, r12, n12, a), i = Us(o.year, 0, o.dayOfYear);
  return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
}
c0("Q", 0, "Qo", "quarter");
Xe("Q", y$e);
o1("Q", function(t16, e) {
  e[Xn] = (k0(t16) - 1) * 3;
});
function GJ0(t16) {
  return t16 == null ? Math.ceil((this.month() + 1) / 3) : this.month((t16 - 1) * 3 + this.month() % 3);
}
c0("D", ["DD", 2], "Do", "date");
Xe("D", _1, Fi);
Xe("DD", _1, cr);
Xe("Do", function(t16, e) {
  return t16 ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient;
});
o1(["D", "DD"], dn);
o1("Do", function(t16, e) {
  e[dn] = k0(t16.match(_1)[0]);
});
var oGe = Vi("Date", true);
c0("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
Xe("DDD", Ep);
Xe("DDDD", S$e);
o1(["DDD", "DDDD"], function(t16, e, r12) {
  r12._dayOfYear = k0(t16);
});
function YJ0(t16) {
  var e = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return t16 == null ? e : this.add(t16 - e, "d");
}
c0("m", ["mm", 2], 0, "minute");
Xe("m", _1, A0e);
Xe("mm", _1, cr);
o1(["m", "mm"], Yr);
var JJ0 = Vi("Minutes", false);
c0("s", ["ss", 2], 0, "second");
Xe("s", _1, A0e);
Xe("ss", _1, cr);
o1(["s", "ss"], $n);
var KJ0 = Vi("Seconds", false);
c0("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
c0(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
c0(0, ["SSS", 3], 0, "millisecond");
c0(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
c0(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
c0(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
c0(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
c0(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
c0(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
Xe("S", Ep, y$e);
Xe("SS", Ep, cr);
Xe("SSS", Ep, S$e);
var Ea, iGe;
for (Ea = "SSSS"; Ea.length <= 9; Ea += "S")
  Xe(Ea, ji);
function QJ0(t16, e) {
  e[zo] = k0(("0." + t16) * 1e3);
}
for (Ea = "S"; Ea.length <= 9; Ea += "S")
  o1(Ea, QJ0);
iGe = Vi("Milliseconds", false);
c0("z", 0, 0, "zoneAbbr");
c0("zz", 0, 0, "zoneName");
function ZJ0() {
  return this._isUTC ? "UTC" : "";
}
function eK0() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var Ee = qc.prototype;
Ee.add = XY0;
Ee.calendar = ZY0;
Ee.clone = eJ0;
Ee.diff = uJ0;
Ee.endOf = zJ0;
Ee.format = pJ0;
Ee.from = dJ0;
Ee.fromNow = fJ0;
Ee.to = bJ0;
Ee.toNow = MJ0;
Ee.get = lG0;
Ee.invalidAt = yJ0;
Ee.isAfter = tJ0;
Ee.isBefore = rJ0;
Ee.isBetween = nJ0;
Ee.isSame = aJ0;
Ee.isSameOrAfter = oJ0;
Ee.isSameOrBefore = iJ0;
Ee.isValid = qJ0;
Ee.lang = Z$e;
Ee.locale = Q$e;
Ee.localeData = eGe;
Ee.max = qY0;
Ee.min = RY0;
Ee.parsingFlags = TJ0;
Ee.set = pG0;
Ee.startOf = OJ0;
Ee.subtract = $Y0;
Ee.toArray = vJ0;
Ee.toObject = mJ0;
Ee.toDate = hJ0;
Ee.toISOString = cJ0;
Ee.inspect = lJ0;
typeof Symbol < "u" && Symbol.for != null && (Ee[/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
Ee.toJSON = RJ0;
Ee.toString = sJ0;
Ee.unix = _J0;
Ee.valueOf = AJ0;
Ee.creationData = SJ0;
Ee.eraName = EJ0;
Ee.eraNarrow = LJ0;
Ee.eraAbbr = PJ0;
Ee.eraYear = DJ0;
Ee.year = I$e;
Ee.isLeapYear = cG0;
Ee.weekYear = kJ0;
Ee.isoWeekYear = jJ0;
Ee.quarter = Ee.quarters = GJ0;
Ee.month = W$e;
Ee.daysInMonth = hG0;
Ee.week = Ee.weeks = CG0;
Ee.isoWeek = Ee.isoWeeks = gG0;
Ee.weeksInYear = HJ0;
Ee.weeksInWeekYear = XJ0;
Ee.isoWeeksInYear = FJ0;
Ee.isoWeeksInISOWeekYear = VJ0;
Ee.date = oGe;
Ee.day = Ee.days = jG0;
Ee.weekday = FG0;
Ee.isoWeekday = VG0;
Ee.dayOfYear = YJ0;
Ee.hour = Ee.hours = KG0;
Ee.minute = Ee.minutes = JJ0;
Ee.second = Ee.seconds = KJ0;
Ee.millisecond = Ee.milliseconds = iGe;
Ee.utcOffset = PY0;
Ee.utc = WY0;
Ee.local = NY0;
Ee.parseZone = wY0;
Ee.hasAlignedHourOffset = BY0;
Ee.isDST = xY0;
Ee.isLocal = kY0;
Ee.isUtcOffset = jY0;
Ee.isUtc = G$e;
Ee.isUTC = G$e;
Ee.zoneAbbr = ZJ0;
Ee.zoneName = eK0;
Ee.dates = gr(
  "dates accessor is deprecated. Use date instead.",
  oGe
);
Ee.months = gr(
  "months accessor is deprecated. Use month instead",
  W$e
);
Ee.years = gr(
  "years accessor is deprecated. Use year instead",
  I$e
);
Ee.zone = gr(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  DY0
);
Ee.isDSTShifted = gr(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  UY0
);
function tK0(t16) {
  return z1(t16 * 1e3);
}
function rK0() {
  return z1.apply(null, arguments).parseZone();
}
function uGe(t16) {
  return t16;
}
var Y0 = f0e.prototype;
Y0.calendar = k$0;
Y0.longDateFormat = H$0;
Y0.invalidDate = $$0;
Y0.ordinal = J$0;
Y0.preparse = uGe;
Y0.postformat = uGe;
Y0.relativeTime = Q$0;
Y0.pastFuture = Z$0;
Y0.set = x$0;
Y0.eras = CJ0;
Y0.erasParse = gJ0;
Y0.erasConvertYear = IJ0;
Y0.erasAbbrRegex = NJ0;
Y0.erasNameRegex = WJ0;
Y0.erasNarrowRegex = wJ0;
Y0.months = OG0;
Y0.monthsShort = zG0;
Y0.monthsParse = _G0;
Y0.monthsRegex = mG0;
Y0.monthsShortRegex = vG0;
Y0.week = qG0;
Y0.firstDayOfYear = SG0;
Y0.firstDayOfWeek = yG0;
Y0.weekdays = wG0;
Y0.weekdaysMin = xG0;
Y0.weekdaysShort = BG0;
Y0.weekdaysParse = kG0;
Y0.weekdaysRegex = HG0;
Y0.weekdaysShortRegex = XG0;
Y0.weekdaysMinRegex = $G0;
Y0.isPM = YG0;
Y0.meridiem = QG0;
function P2(t16, e, r12, n12) {
  var a = da(), o = Cn().set(n12, e);
  return a[r12](o, t16);
}
function sGe(t16, e, r12) {
  if (oa(t16) && (e = t16, t16 = void 0), t16 = t16 || "", e != null)
    return P2(t16, e, r12, "month");
  var n12, a = [];
  for (n12 = 0; n12 < 12; n12++)
    a[n12] = P2(t16, n12, r12, "month");
  return a;
}
function E0e(t16, e, r12, n12) {
  typeof t16 == "boolean" ? (oa(e) && (r12 = e, e = void 0), e = e || "") : (e = t16, r12 = e, t16 = false, oa(e) && (r12 = e, e = void 0), e = e || "");
  var a = da(), o = t16 ? a._week.dow : 0, i, u = [];
  if (r12 != null)
    return P2(e, (r12 + o) % 7, n12, "day");
  for (i = 0; i < 7; i++)
    u[i] = P2(e, (i + o) % 7, n12, "day");
  return u;
}
function nK0(t16, e) {
  return sGe(t16, e, "months");
}
function aK0(t16, e) {
  return sGe(t16, e, "monthsShort");
}
function oK0(t16, e, r12) {
  return E0e(t16, e, r12, "weekdays");
}
function iK0(t16, e, r12) {
  return E0e(t16, e, r12, "weekdaysShort");
}
function uK0(t16, e, r12) {
  return E0e(t16, e, r12, "weekdaysMin");
}
wa("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(t16) {
    var e = t16 % 10, r12 = k0(t16 % 100 / 10) === 1 ? "th" : e === 1 ? "st" : e === 2 ? "nd" : e === 3 ? "rd" : "th";
    return t16 + r12;
  }
});
ke.lang = gr(
  "moment.lang is deprecated. Use moment.locale instead.",
  wa
);
ke.langData = gr(
  "moment.langData is deprecated. Use moment.localeData instead.",
  da
);
var wn = Math.abs;
function sK0() {
  var t16 = this._data;
  return this._milliseconds = wn(this._milliseconds), this._days = wn(this._days), this._months = wn(this._months), t16.milliseconds = wn(t16.milliseconds), t16.seconds = wn(t16.seconds), t16.minutes = wn(t16.minutes), t16.hours = wn(t16.hours), t16.months = wn(t16.months), t16.years = wn(t16.years), this;
}
function cGe(t16, e, r12, n12) {
  var a = an(e, r12);
  return t16._milliseconds += n12 * a._milliseconds, t16._days += n12 * a._days, t16._months += n12 * a._months, t16._bubble();
}
function cK0(t16, e) {
  return cGe(this, t16, e, 1);
}
function lK0(t16, e) {
  return cGe(this, t16, e, -1);
}
function Xke(t16) {
  return t16 < 0 ? Math.floor(t16) : Math.ceil(t16);
}
function pK0() {
  var t16 = this._milliseconds, e = this._days, r12 = this._months, n12 = this._data, a, o, i, u, s12;
  return t16 >= 0 && e >= 0 && r12 >= 0 || t16 <= 0 && e <= 0 && r12 <= 0 || (t16 += Xke(yZ(r12) + e) * 864e5, e = 0, r12 = 0), n12.milliseconds = t16 % 1e3, a = zr(t16 / 1e3), n12.seconds = a % 60, o = zr(a / 60), n12.minutes = o % 60, i = zr(o / 60), n12.hours = i % 24, e += zr(i / 24), s12 = zr(lGe(e)), r12 += s12, e -= Xke(yZ(s12)), u = zr(r12 / 12), r12 %= 12, n12.days = e, n12.months = r12, n12.years = u, this;
}
function lGe(t16) {
  return t16 * 4800 / 146097;
}
function yZ(t16) {
  return t16 * 146097 / 4800;
}
function dK0(t16) {
  if (!this.isValid())
    return NaN;
  var e, r12, n12 = this._milliseconds;
  if (t16 = Ir(t16), t16 === "month" || t16 === "quarter" || t16 === "year")
    switch (e = this._days + n12 / 864e5, r12 = this._months + lGe(e), t16) {
      case "month":
        return r12;
      case "quarter":
        return r12 / 3;
      case "year":
        return r12 / 12;
    }
  else
    switch (e = this._days + Math.round(yZ(this._months)), t16) {
      case "week":
        return e / 7 + n12 / 6048e5;
      case "day":
        return e + n12 / 864e5;
      case "hour":
        return e * 24 + n12 / 36e5;
      case "minute":
        return e * 1440 + n12 / 6e4;
      case "second":
        return e * 86400 + n12 / 1e3;
      case "millisecond":
        return Math.floor(e * 864e5) + n12;
      default:
        throw new Error("Unknown unit " + t16);
    }
}
function fa(t16) {
  return function() {
    return this.as(t16);
  };
}
var pGe = fa("ms"), fK0 = fa("s"), bK0 = fa("m"), MK0 = fa("h"), OK0 = fa("d"), zK0 = fa("w"), AK0 = fa("M"), _K0 = fa("Q"), hK0 = fa("y"), vK0 = pGe;
function mK0() {
  return an(this);
}
function RK0(t16) {
  return t16 = Ir(t16), this.isValid() ? this[t16 + "s"]() : NaN;
}
function Io(t16) {
  return function() {
    return this.isValid() ? this._data[t16] : NaN;
  };
}
var qK0 = Io("milliseconds"), TK0 = Io("seconds"), yK0 = Io("minutes"), SK0 = Io("hours"), CK0 = Io("days"), gK0 = Io("months"), IK0 = Io("years");
function EK0() {
  return zr(this.days() / 7);
}
var Fn = Math.round, ni = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function LK0(t16, e, r12, n12, a) {
  return a.relativeTime(e || 1, !!r12, t16, n12);
}
function PK0(t16, e, r12, n12) {
  var a = an(t16).abs(), o = Fn(a.as("s")), i = Fn(a.as("m")), u = Fn(a.as("h")), s12 = Fn(a.as("d")), c = Fn(a.as("M")), l2 = Fn(a.as("w")), f = Fn(a.as("y")), p = o <= r12.ss && ["s", o] || o < r12.s && ["ss", o] || i <= 1 && ["m"] || i < r12.m && ["mm", i] || u <= 1 && ["h"] || u < r12.h && ["hh", u] || s12 <= 1 && ["d"] || s12 < r12.d && ["dd", s12];
  return r12.w != null && (p = p || l2 <= 1 && ["w"] || l2 < r12.w && ["ww", l2]), p = p || c <= 1 && ["M"] || c < r12.M && ["MM", c] || f <= 1 && ["y"] || ["yy", f], p[2] = e, p[3] = +t16 > 0, p[4] = n12, LK0.apply(null, p);
}
function DK0(t16) {
  return t16 === void 0 ? Fn : typeof t16 == "function" ? (Fn = t16, true) : false;
}
function WK0(t16, e) {
  return ni[t16] === void 0 ? false : e === void 0 ? ni[t16] : (ni[t16] = e, t16 === "s" && (ni.ss = e - 1), true);
}
function NK0(t16, e) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r12 = false, n12 = ni, a, o;
  return typeof t16 == "object" && (e = t16, t16 = false), typeof t16 == "boolean" && (r12 = t16), typeof e == "object" && (n12 = Object.assign({}, ni, e), e.s != null && e.ss == null && (n12.ss = e.s - 1)), a = this.localeData(), o = PK0(this, !r12, n12, a), r12 && (o = a.pastFuture(+this, o)), a.postformat(o);
}
var aQ = Math.abs;
function Xo(t16) {
  return (t16 > 0) - (t16 < 0) || +t16;
}
function xp() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var t16 = aQ(this._milliseconds) / 1e3, e = aQ(this._days), r12 = aQ(this._months), n12, a, o, i, u = this.asSeconds(), s12, c, l2, f;
  return u ? (n12 = zr(t16 / 60), a = zr(n12 / 60), t16 %= 60, n12 %= 60, o = zr(r12 / 12), r12 %= 12, i = t16 ? t16.toFixed(3).replace(/\.?0+$/, "") : "", s12 = u < 0 ? "-" : "", c = Xo(this._months) !== Xo(u) ? "-" : "", l2 = Xo(this._days) !== Xo(u) ? "-" : "", f = Xo(this._milliseconds) !== Xo(u) ? "-" : "", s12 + "P" + (o ? c + o + "Y" : "") + (r12 ? c + r12 + "M" : "") + (e ? l2 + e + "D" : "") + (a || n12 || t16 ? "T" : "") + (a ? f + a + "H" : "") + (n12 ? f + n12 + "M" : "") + (t16 ? f + i + "S" : "")) : "P0D";
}
var H0 = wp.prototype;
H0.isValid = gY0;
H0.abs = sK0;
H0.add = cK0;
H0.subtract = lK0;
H0.as = dK0;
H0.asMilliseconds = pGe;
H0.asSeconds = fK0;
H0.asMinutes = bK0;
H0.asHours = MK0;
H0.asDays = OK0;
H0.asWeeks = zK0;
H0.asMonths = AK0;
H0.asQuarters = _K0;
H0.asYears = hK0;
H0.valueOf = vK0;
H0._bubble = pK0;
H0.clone = mK0;
H0.get = RK0;
H0.milliseconds = qK0;
H0.seconds = TK0;
H0.minutes = yK0;
H0.hours = SK0;
H0.days = CK0;
H0.weeks = EK0;
H0.months = gK0;
H0.years = IK0;
H0.humanize = NK0;
H0.toISOString = xp;
H0.toString = xp;
H0.toJSON = xp;
H0.locale = Q$e;
H0.localeData = eGe;
H0.toIsoString = gr(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  xp
);
H0.lang = Z$e;
c0("X", 0, 0, "unix");
c0("x", 0, 0, "valueOf");
Xe("x", Pp);
Xe("X", nG0);
o1("X", function(t16, e, r12) {
  r12._d = new Date(parseFloat(t16) * 1e3);
});
o1("x", function(t16, e, r12) {
  r12._d = new Date(k0(t16));
});
ke.version = "2.30.1";
w$0(z1);
ke.fn = Ee;
ke.min = TY0;
ke.max = yY0;
ke.now = SY0;
ke.utc = Cn;
ke.unix = tK0;
ke.months = nK0;
ke.isDate = Rc;
ke.locale = wa;
ke.invalid = gp;
ke.duration = an;
ke.isMoment = rn;
ke.weekdays = oK0;
ke.parseZone = rK0;
ke.localeData = da;
ke.isDuration = Ql;
ke.monthsShort = aK0;
ke.weekdaysMin = uK0;
ke.defineLocale = R0e;
ke.updateLocale = rY0;
ke.locales = nY0;
ke.weekdaysShort = iK0;
ke.normalizeUnits = Ir;
ke.relativeTimeRounding = DK0;
ke.relativeTimeThreshold = WK0;
ke.calendarFormat = QY0;
ke.prototype = Ee;
ke.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const wK0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ke
}, Symbol.toStringTag, { value: "Module" })), BK0 = /* @__PURE__ */ hp(wK0);
(function(t16) {
  (function(e, r12) {
    t16.exports ? t16.exports = r12(BK0) : r12(e.moment);
  })(l0, function(e) {
    e.version === void 0 && e.default && (e = e.default);
    var r12 = "0.5.48", n12 = {}, a = {}, o = {}, i = {}, u = {}, s12;
    (!e || typeof e.version != "string") && G("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
    var c = e.version.split("."), l2 = +c[0], f = +c[1];
    (l2 < 2 || l2 === 2 && f < 6) && G("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + e.version + ". See momentjs.com");
    function p(H) {
      return H > 96 ? H - 87 : H > 64 ? H - 29 : H - 48;
    }
    function d(H) {
      var re = 0, ue = H.split("."), Me = ue[0], Se = ue[1] || "", $e = 1, a0, Ne = 0, Ye = 1;
      for (H.charCodeAt(0) === 45 && (re = 1, Ye = -1), re; re < Me.length; re++)
        a0 = p(Me.charCodeAt(re)), Ne = 60 * Ne + a0;
      for (re = 0; re < Se.length; re++)
        $e = $e / 60, a0 = p(Se.charCodeAt(re)), Ne += a0 * $e;
      return Ne * Ye;
    }
    function b(H) {
      for (var re = 0; re < H.length; re++)
        H[re] = d(H[re]);
    }
    function z(H, re) {
      for (var ue = 0; ue < re; ue++)
        H[ue] = Math.round((H[ue - 1] || 0) + H[ue] * 6e4);
      H[re - 1] = 1 / 0;
    }
    function _(H, re) {
      var ue = [], Me;
      for (Me = 0; Me < re.length; Me++)
        ue[Me] = H[re[Me]];
      return ue;
    }
    function q(H) {
      var re = H.split("|"), ue = re[2].split(" "), Me = re[3].split(""), Se = re[4].split(" ");
      return b(ue), b(Me), b(Se), z(Se, Me.length), {
        name: re[0],
        abbrs: _(re[1].split(" "), Me),
        offsets: _(ue, Me),
        untils: Se,
        population: re[5] | 0
      };
    }
    function S(H) {
      H && this._set(q(H));
    }
    function N(H, re) {
      var ue = re.length;
      if (H < re[0])
        return 0;
      if (ue > 1 && re[ue - 1] === 1 / 0 && H >= re[ue - 2])
        return ue - 1;
      if (H >= re[ue - 1])
        return -1;
      for (var Me, Se = 0, $e = ue - 1; $e - Se > 1; )
        Me = Math.floor((Se + $e) / 2), re[Me] <= H ? Se = Me : $e = Me;
      return $e;
    }
    S.prototype = {
      _set: function(H) {
        this.name = H.name, this.abbrs = H.abbrs, this.untils = H.untils, this.offsets = H.offsets, this.population = H.population;
      },
      _index: function(H) {
        var re = +H, ue = this.untils, Me;
        if (Me = N(re, ue), Me >= 0)
          return Me;
      },
      countries: function() {
        var H = this.name;
        return Object.keys(o).filter(function(re) {
          return o[re].zones.indexOf(H) !== -1;
        });
      },
      parse: function(H) {
        var re = +H, ue = this.offsets, Me = this.untils, Se = Me.length - 1, $e, a0, Ne, Ye;
        for (Ye = 0; Ye < Se; Ye++)
          if ($e = ue[Ye], a0 = ue[Ye + 1], Ne = ue[Ye && Ye - 1], $e < a0 && Q.moveAmbiguousForward ? $e = a0 : $e > Ne && Q.moveInvalidForward && ($e = Ne), re < Me[Ye] - $e * 6e4)
            return ue[Ye];
        return ue[Se];
      },
      abbr: function(H) {
        return this.abbrs[this._index(H)];
      },
      offset: function(H) {
        return G("zone.offset has been deprecated in favor of zone.utcOffset"), this.offsets[this._index(H)];
      },
      utcOffset: function(H) {
        return this.offsets[this._index(H)];
      }
    };
    function v(H, re) {
      this.name = H, this.zones = re;
    }
    function C(H) {
      var re = H.toTimeString(), ue = re.match(/\([a-z ]+\)/i);
      ue && ue[0] ? (ue = ue[0].match(/[A-Z]/g), ue = ue ? ue.join("") : void 0) : (ue = re.match(/[A-Z]{3,5}/g), ue = ue ? ue[0] : void 0), ue === "GMT" && (ue = void 0), this.at = +H, this.abbr = ue, this.offset = H.getTimezoneOffset();
    }
    function L(H) {
      this.zone = H, this.offsetScore = 0, this.abbrScore = 0;
    }
    L.prototype.scoreOffsetAt = function(H) {
      this.offsetScore += Math.abs(this.zone.utcOffset(H.at) - H.offset), this.zone.abbr(H.at).replace(/[^A-Z]/g, "") !== H.abbr && this.abbrScore++;
    };
    function B(H, re) {
      for (var ue, Me; Me = ((re.at - H.at) / 12e4 | 0) * 6e4; )
        ue = new C(new Date(H.at + Me)), ue.offset === H.offset ? H = ue : re = ue;
      return H;
    }
    function P12() {
      var H = (/* @__PURE__ */ new Date()).getFullYear() - 2, re = new C(new Date(H, 0, 1)), ue = re.offset, Me = [re], Se, $e, a0, Ne;
      for (Ne = 1; Ne < 48; Ne++)
        a0 = new Date(H, Ne, 1).getTimezoneOffset(), a0 !== ue && ($e = new C(new Date(H, Ne, 1)), Se = B(re, $e), Me.push(Se), Me.push(new C(new Date(Se.at + 6e4))), re = $e, ue = a0);
      for (Ne = 0; Ne < 4; Ne++)
        Me.push(new C(new Date(H + Ne, 0, 1))), Me.push(new C(new Date(H + Ne, 6, 1)));
      return Me;
    }
    function j(H, re) {
      return H.offsetScore !== re.offsetScore ? H.offsetScore - re.offsetScore : H.abbrScore !== re.abbrScore ? H.abbrScore - re.abbrScore : H.zone.population !== re.zone.population ? re.zone.population - H.zone.population : re.zone.name.localeCompare(H.zone.name);
    }
    function $(H, re) {
      var ue, Me;
      for (b(re), ue = 0; ue < re.length; ue++)
        Me = re[ue], u[Me] = u[Me] || {}, u[Me][H] = true;
    }
    function W(H) {
      var re = H.length, ue = {}, Me = [], Se = {}, $e, a0, Ne, Ye;
      for ($e = 0; $e < re; $e++)
        if (Ne = H[$e].offset, !Se.hasOwnProperty(Ne)) {
          Ye = u[Ne] || {};
          for (a0 in Ye)
            Ye.hasOwnProperty(a0) && (ue[a0] = true);
          Se[Ne] = true;
        }
      for ($e in ue)
        ue.hasOwnProperty($e) && Me.push(i[$e]);
      return Me;
    }
    function x() {
      try {
        var H = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (H && H.length > 3) {
          var re = i[w(H)];
          if (re)
            return re;
          G("Moment Timezone found " + H + " from the Intl api, but did not have that data loaded.");
        }
      } catch {
      }
      var ue = P12(), Me = ue.length, Se = W(ue), $e = [], a0, Ne, Ye;
      for (Ne = 0; Ne < Se.length; Ne++) {
        for (a0 = new L(Y(Se[Ne])), Ye = 0; Ye < Me; Ye++)
          a0.scoreOffsetAt(ue[Ye]);
        $e.push(a0);
      }
      return $e.sort(j), $e.length > 0 ? $e[0].zone.name : void 0;
    }
    function D(H) {
      return (!s12 || H) && (s12 = x()), s12;
    }
    function w(H) {
      return (H || "").toLowerCase().replace(/\//g, "_");
    }
    function I(H) {
      var re, ue, Me, Se;
      for (typeof H == "string" && (H = [H]), re = 0; re < H.length; re++)
        Me = H[re].split("|"), ue = Me[0], Se = w(ue), n12[Se] = H[re], i[Se] = ue, $(Se, Me[2].split(" "));
    }
    function Y(H, re) {
      H = w(H);
      var ue = n12[H], Me;
      return ue instanceof S ? ue : typeof ue == "string" ? (ue = new S(ue), n12[H] = ue, ue) : a[H] && re !== Y && (Me = Y(a[H], Y)) ? (ue = n12[H] = new S(), ue._set(Me), ue.name = i[H], ue) : null;
    }
    function oe() {
      var H, re = [];
      for (H in i)
        i.hasOwnProperty(H) && (n12[H] || n12[a[H]]) && i[H] && re.push(i[H]);
      return re.sort();
    }
    function Z() {
      return Object.keys(o);
    }
    function se(H) {
      var re, ue, Me, Se;
      for (typeof H == "string" && (H = [H]), re = 0; re < H.length; re++)
        ue = H[re].split("|"), Me = w(ue[0]), Se = w(ue[1]), a[Me] = Se, i[Me] = ue[0], a[Se] = Me, i[Se] = ue[1];
    }
    function Ie(H) {
      var re, ue, Me, Se;
      if (!(!H || !H.length))
        for (re = 0; re < H.length; re++)
          Se = H[re].split("|"), ue = Se[0].toUpperCase(), Me = Se[1].split(" "), o[ue] = new v(
            ue,
            Me
          );
    }
    function ie(H) {
      return H = H.toUpperCase(), o[H] || null;
    }
    function ye(H, re) {
      if (H = ie(H), !H)
        return null;
      var ue = H.zones.sort();
      return re ? ue.map(function(Me) {
        var Se = Y(Me);
        return {
          name: Me,
          offset: Se.utcOffset(/* @__PURE__ */ new Date())
        };
      }) : ue;
    }
    function ne(H) {
      I(H.zones), se(H.links), Ie(H.countries), Q.dataVersion = H.version;
    }
    function k(H) {
      return k.didShowError || (k.didShowError = true, G("moment.tz.zoneExists('" + H + "') has been deprecated in favor of !moment.tz.zone('" + H + "')")), !!Y(H);
    }
    function K(H) {
      var re = H._f === "X" || H._f === "x";
      return !!(H._a && H._tzm === void 0 && !re);
    }
    function G(H) {
      typeof console < "u" && typeof console.error == "function" && console.error(H);
    }
    function Q(H) {
      var re = Array.prototype.slice.call(arguments, 0, -1), ue = arguments[arguments.length - 1], Me = e.utc.apply(null, re), Se;
      return !e.isMoment(H) && K(Me) && (Se = Y(ue)) && Me.add(Se.parse(Me), "minutes"), Me.tz(ue), Me;
    }
    Q.version = r12, Q.dataVersion = "", Q._zones = n12, Q._links = a, Q._names = i, Q._countries = o, Q.add = I, Q.link = se, Q.load = ne, Q.zone = Y, Q.zoneExists = k, Q.guess = D, Q.names = oe, Q.Zone = S, Q.unpack = q, Q.unpackBase60 = d, Q.needsOffset = K, Q.moveInvalidForward = true, Q.moveAmbiguousForward = false, Q.countries = Z, Q.zonesForCountry = ye;
    var ce = e.fn;
    e.tz = Q, e.defaultZone = null, e.updateOffset = function(H, re) {
      var ue = e.defaultZone, Me;
      if (H._z === void 0 && (ue && K(H) && !H._isUTC && H.isValid() && (H._d = e.utc(H._a)._d, H.utc().add(ue.parse(H), "minutes")), H._z = ue), H._z)
        if (Me = H._z.utcOffset(H), Math.abs(Me) < 16 && (Me = Me / 60), H.utcOffset !== void 0) {
          var Se = H._z;
          H.utcOffset(-Me, re), H._z = Se;
        } else
          H.zone(Me, re);
    }, ce.tz = function(H, re) {
      if (H) {
        if (typeof H != "string")
          throw new Error("Time zone name must be a string, got " + H + " [" + typeof H + "]");
        return this._z = Y(H), this._z ? e.updateOffset(this, re) : G("Moment Timezone has no data for " + H + ". See http://momentjs.com/timezone/docs/#/data-loading/."), this;
      }
      if (this._z)
        return this._z.name;
    };
    function ve(H) {
      return function() {
        return this._z ? this._z.abbr(this) : H.call(this);
      };
    }
    function Re(H) {
      return function() {
        return this._z = null, H.apply(this, arguments);
      };
    }
    function le(H) {
      return function() {
        return arguments.length > 0 && (this._z = null), H.apply(this, arguments);
      };
    }
    ce.zoneName = ve(ce.zoneName), ce.zoneAbbr = ve(ce.zoneAbbr), ce.utc = Re(ce.utc), ce.local = Re(ce.local), ce.utcOffset = le(ce.utcOffset), e.tz.setDefault = function(H) {
      return (l2 < 2 || l2 === 2 && f < 9) && G("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + e.version + "."), e.defaultZone = H ? Y(H) : null, e;
    };
    var Ae = e.momentProperties;
    return Object.prototype.toString.call(Ae) === "[object Array]" ? (Ae.push("_z"), Ae.push("_a")) : Ae && (Ae._z = null), e;
  });
})(h$e);
var xK0 = h$e.exports;
const UK0 = "2025b", kK0 = [
  "Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
  "Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5",
  "Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
  "Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6",
  "Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
  "Africa/Maputo|LMT CAT|-2a.i -20|01|-2sw2a.i|26e5",
  "Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6",
  "Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5",
  "Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3",
  "Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4",
  "Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5",
  "Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|",
  "Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
  "Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5",
  "Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
  "Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|",
  "Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
  "Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
  "Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
  "America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
  "America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
  "America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5",
  "America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
  "America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
  "America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
  "America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
  "America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
  "America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
  "America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
  "America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
  "America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
  "America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
  "America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5",
  "America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5",
  "America/Bahia_Banderas|LMT MST CST MDT CDT|71 70 60 60 50|01213121313131313131313131313131313142424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3",
  "America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
  "America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
  "America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
  "America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3",
  "America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
  "America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5",
  "America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
  "America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
  "America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
  "America/Cancun|LMT CST EST CDT EDT|5L.4 60 50 50 40|01213132431313131313131313131313131313131312|-1UQG0 2q3C0 2tx0 wgP0 1lb0 14p0 1lb0 14o0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
  "America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5",
  "America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
  "America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
  "America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
  "America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
  "America/Coyhaique|LMT SMT -05 -04 -03|4M.g 4G.J 50 40 30|012131323232323232323434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvb.I MJbS.t fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0|",
  "America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
  "America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
  "America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
  "America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
  "America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
  "America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
  "America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
  "America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
  "America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
  "America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
  "America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mp0 8lz0 SN0 1cL0 pHB0 83r0 AU0 5MN0 1Rz0 38N0 Wn0 1qP0 11z0 1o10 11z0 3NA0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
  "America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
  "America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
  "America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
  "America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3",
  "America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
  "America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
  "America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
  "America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5",
  "America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4",
  "America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
  "America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
  "America/Hermosillo|LMT MST CST MDT|7n.Q 70 60 60|01213121313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
  "America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
  "America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
  "America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
  "America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
  "America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5",
  "America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
  "America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
  "America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
  "America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
  "America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
  "America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4",
  "America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
  "America/Mazatlan|LMT MST CST MDT|75.E 70 60 60|01213121313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4",
  "America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
  "America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q3C0 24n0 wG10 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5",
  "America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
  "America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
  "America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
  "America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
  "America/Monterrey|LMT MST CST MDT CDT|6F.g 70 60 60 50|012131242424242424242424242424242424242424242424242424242424242|-1UQG0 dep0 8lz0 16p0 11z0 1dd0 2gmp0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5",
  "America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
  "America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
  "America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
  "America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
  "America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
  "America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
  "America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
  "America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
  "America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
  "America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
  "America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
  "America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
  "America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
  "America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
  "America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
  "America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
  "America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
  "America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5",
  "America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
  "America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
  "America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452",
  "America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
  "America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
  "America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
  "America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
  "America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
  "America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
  "America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
  "America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
  "Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10",
  "Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
  "Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4",
  "Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
  "Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
  "Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
  "Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
  "Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
  "Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
  "Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40",
  "Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25",
  "Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5",
  "Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5",
  "Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5",
  "Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
  "Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
  "Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
  "Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
  "Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
  "Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
  "Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
  "Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
  "Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6",
  "Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
  "Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5",
  "Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
  "Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4",
  "Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6",
  "Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
  "Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
  "Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
  "Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
  "Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
  "Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
  "Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le80 1dnX0 1nfA0 Xld0|19e4",
  "Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
  "Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
  "Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
  "Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5",
  "Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4",
  "Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5",
  "Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
  "Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
  "Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
  "Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
  "Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
  "Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
  "Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4",
  "Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5",
  "Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
  "Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
  "Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
  "Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
  "Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
  "Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
  "Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5",
  "Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
  "Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
  "Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
  "Asia/Manila|LMT LMT PST PDT JST|fU.8 -83.Q -80 -90 -90|012323432323232|-54m83.Q 2d8A3.Q 1urM0 un0 bW10 nb0 7qo0 1MM0 klB0 lz0 TwN0 1bb0 uNB0 rz0|24e6",
  "Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4",
  "Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
  "Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
  "Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
  "Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
  "Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
  "Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
  "Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|",
  "Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
  "Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5",
  "Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
  "Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
  "Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
  "Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
  "Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
  "Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
  "Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
  "Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 Dc0 1iMu JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
  "Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
  "Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
  "Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
  "Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
  "Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
  "Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
  "Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
  "Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
  "Atlantic/Azores|LMT HMT -02 -01 +00 WET WEST|1G.E 1S.w 20 10 0 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232323434343434343434343434356434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 CT90 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 Ap0 An0 wo0 Eo0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4",
  "Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
  "Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
  "Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
  "Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3",
  "Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 BJ90 1a00 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4",
  "Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30",
  "Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
  "Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
  "Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
  "Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
  "Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3",
  "Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4",
  "Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4",
  "Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
  "Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
  "Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
  "Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5",
  "Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
  "Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5",
  "Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2",
  "Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5",
  "Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
  "Etc/GMT-0|GMT|0|0||",
  "Etc/GMT-1|+01|-10|0||",
  "Etc/GMT-10|+10|-a0|0||",
  "Etc/GMT-11|+11|-b0|0||",
  "Etc/GMT-12|+12|-c0|0||",
  "Etc/GMT-13|+13|-d0|0||",
  "Etc/GMT-14|+14|-e0|0||",
  "Etc/GMT-2|+02|-20|0||",
  "Etc/GMT-3|+03|-30|0||",
  "Etc/GMT-4|+04|-40|0||",
  "Etc/GMT-5|+05|-50|0||",
  "Etc/GMT-6|+06|-60|0||",
  "Etc/GMT-7|+07|-70|0||",
  "Etc/GMT-8|+08|-80|0||",
  "Etc/GMT-9|+09|-90|0||",
  "Etc/GMT+1|-01|10|0||",
  "Etc/GMT+10|-10|a0|0||",
  "Etc/GMT+11|-11|b0|0||",
  "Etc/GMT+12|-12|c0|0||",
  "Etc/GMT+2|-02|20|0||",
  "Etc/GMT+3|-03|30|0||",
  "Etc/GMT+4|-04|40|0||",
  "Etc/GMT+5|-05|50|0||",
  "Etc/GMT+6|-06|60|0||",
  "Etc/GMT+7|-07|70|0||",
  "Etc/GMT+8|-08|80|0||",
  "Etc/GMT+9|-09|90|0||",
  "Etc/UTC|UTC|0|0||",
  "Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3",
  "Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
  "Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6",
  "Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
  "Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5",
  "Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5",
  "Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
  "Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4",
  "Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4",
  "Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3",
  "Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
  "Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
  "Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5",
  "Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
  "Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212124121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 oiK0 1cM0 1cM0 1fB0 1cM0 1cM0 1cM0 1fA0 1a00 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
  "Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5",
  "Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
  "Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
  "Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6",
  "Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
  "Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4",
  "Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5",
  "Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
  "Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
  "Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
  "Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
  "Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4",
  "Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
  "Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
  "Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5",
  "Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
  "Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5",
  "Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
  "Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4",
  "Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
  "Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4",
  "Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
  "Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3",
  "Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
  "Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
  "Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4",
  "Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
  "Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1",
  "Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483",
  "Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4",
  "Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3",
  "Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
  "Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
  "Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
  "Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
  "Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2",
  "Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
  "Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
  "Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2",
  "Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
  "Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2",
  "Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4",
  "Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
  "Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3",
  "Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56",
  "Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
  "Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
  "Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3"
], jK0 = [
  "Africa/Abidjan|Africa/Accra",
  "Africa/Abidjan|Africa/Bamako",
  "Africa/Abidjan|Africa/Banjul",
  "Africa/Abidjan|Africa/Conakry",
  "Africa/Abidjan|Africa/Dakar",
  "Africa/Abidjan|Africa/Freetown",
  "Africa/Abidjan|Africa/Lome",
  "Africa/Abidjan|Africa/Nouakchott",
  "Africa/Abidjan|Africa/Ouagadougou",
  "Africa/Abidjan|Africa/Timbuktu",
  "Africa/Abidjan|Atlantic/Reykjavik",
  "Africa/Abidjan|Atlantic/St_Helena",
  "Africa/Abidjan|Iceland",
  "Africa/Cairo|Egypt",
  "Africa/Johannesburg|Africa/Maseru",
  "Africa/Johannesburg|Africa/Mbabane",
  "Africa/Lagos|Africa/Bangui",
  "Africa/Lagos|Africa/Brazzaville",
  "Africa/Lagos|Africa/Douala",
  "Africa/Lagos|Africa/Kinshasa",
  "Africa/Lagos|Africa/Libreville",
  "Africa/Lagos|Africa/Luanda",
  "Africa/Lagos|Africa/Malabo",
  "Africa/Lagos|Africa/Niamey",
  "Africa/Lagos|Africa/Porto-Novo",
  "Africa/Maputo|Africa/Blantyre",
  "Africa/Maputo|Africa/Bujumbura",
  "Africa/Maputo|Africa/Gaborone",
  "Africa/Maputo|Africa/Harare",
  "Africa/Maputo|Africa/Kigali",
  "Africa/Maputo|Africa/Lubumbashi",
  "Africa/Maputo|Africa/Lusaka",
  "Africa/Nairobi|Africa/Addis_Ababa",
  "Africa/Nairobi|Africa/Asmara",
  "Africa/Nairobi|Africa/Asmera",
  "Africa/Nairobi|Africa/Dar_es_Salaam",
  "Africa/Nairobi|Africa/Djibouti",
  "Africa/Nairobi|Africa/Kampala",
  "Africa/Nairobi|Africa/Mogadishu",
  "Africa/Nairobi|Indian/Antananarivo",
  "Africa/Nairobi|Indian/Comoro",
  "Africa/Nairobi|Indian/Mayotte",
  "Africa/Tripoli|Libya",
  "America/Adak|America/Atka",
  "America/Adak|US/Aleutian",
  "America/Anchorage|US/Alaska",
  "America/Argentina/Buenos_Aires|America/Buenos_Aires",
  "America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
  "America/Argentina/Catamarca|America/Catamarca",
  "America/Argentina/Cordoba|America/Cordoba",
  "America/Argentina/Cordoba|America/Rosario",
  "America/Argentina/Jujuy|America/Jujuy",
  "America/Argentina/Mendoza|America/Mendoza",
  "America/Chicago|CST6CDT",
  "America/Chicago|US/Central",
  "America/Denver|America/Shiprock",
  "America/Denver|MST7MDT",
  "America/Denver|Navajo",
  "America/Denver|US/Mountain",
  "America/Detroit|US/Michigan",
  "America/Edmonton|America/Yellowknife",
  "America/Edmonton|Canada/Mountain",
  "America/Fort_Wayne|America/Indiana/Indianapolis",
  "America/Fort_Wayne|America/Indianapolis",
  "America/Fort_Wayne|US/East-Indiana",
  "America/Godthab|America/Nuuk",
  "America/Halifax|Canada/Atlantic",
  "America/Havana|Cuba",
  "America/Indiana/Knox|America/Knox_IN",
  "America/Indiana/Knox|US/Indiana-Starke",
  "America/Iqaluit|America/Pangnirtung",
  "America/Jamaica|Jamaica",
  "America/Kentucky/Louisville|America/Louisville",
  "America/Los_Angeles|PST8PDT",
  "America/Los_Angeles|US/Pacific",
  "America/Manaus|Brazil/West",
  "America/Mazatlan|Mexico/BajaSur",
  "America/Mexico_City|Mexico/General",
  "America/New_York|EST5EDT",
  "America/New_York|US/Eastern",
  "America/Noronha|Brazil/DeNoronha",
  "America/Panama|America/Atikokan",
  "America/Panama|America/Cayman",
  "America/Panama|America/Coral_Harbour",
  "America/Panama|EST",
  "America/Phoenix|America/Creston",
  "America/Phoenix|MST",
  "America/Phoenix|US/Arizona",
  "America/Puerto_Rico|America/Anguilla",
  "America/Puerto_Rico|America/Antigua",
  "America/Puerto_Rico|America/Aruba",
  "America/Puerto_Rico|America/Blanc-Sablon",
  "America/Puerto_Rico|America/Curacao",
  "America/Puerto_Rico|America/Dominica",
  "America/Puerto_Rico|America/Grenada",
  "America/Puerto_Rico|America/Guadeloupe",
  "America/Puerto_Rico|America/Kralendijk",
  "America/Puerto_Rico|America/Lower_Princes",
  "America/Puerto_Rico|America/Marigot",
  "America/Puerto_Rico|America/Montserrat",
  "America/Puerto_Rico|America/Port_of_Spain",
  "America/Puerto_Rico|America/St_Barthelemy",
  "America/Puerto_Rico|America/St_Kitts",
  "America/Puerto_Rico|America/St_Lucia",
  "America/Puerto_Rico|America/St_Thomas",
  "America/Puerto_Rico|America/St_Vincent",
  "America/Puerto_Rico|America/Tortola",
  "America/Puerto_Rico|America/Virgin",
  "America/Regina|Canada/Saskatchewan",
  "America/Rio_Branco|America/Porto_Acre",
  "America/Rio_Branco|Brazil/Acre",
  "America/Santiago|Chile/Continental",
  "America/Sao_Paulo|Brazil/East",
  "America/St_Johns|Canada/Newfoundland",
  "America/Tijuana|America/Ensenada",
  "America/Tijuana|America/Santa_Isabel",
  "America/Tijuana|Mexico/BajaNorte",
  "America/Toronto|America/Montreal",
  "America/Toronto|America/Nassau",
  "America/Toronto|America/Nipigon",
  "America/Toronto|America/Thunder_Bay",
  "America/Toronto|Canada/Eastern",
  "America/Vancouver|Canada/Pacific",
  "America/Whitehorse|Canada/Yukon",
  "America/Winnipeg|America/Rainy_River",
  "America/Winnipeg|Canada/Central",
  "Asia/Ashgabat|Asia/Ashkhabad",
  "Asia/Bangkok|Asia/Phnom_Penh",
  "Asia/Bangkok|Asia/Vientiane",
  "Asia/Bangkok|Indian/Christmas",
  "Asia/Brunei|Asia/Kuching",
  "Asia/Dhaka|Asia/Dacca",
  "Asia/Dubai|Asia/Muscat",
  "Asia/Dubai|Indian/Mahe",
  "Asia/Dubai|Indian/Reunion",
  "Asia/Ho_Chi_Minh|Asia/Saigon",
  "Asia/Hong_Kong|Hongkong",
  "Asia/Jerusalem|Asia/Tel_Aviv",
  "Asia/Jerusalem|Israel",
  "Asia/Kathmandu|Asia/Katmandu",
  "Asia/Kolkata|Asia/Calcutta",
  "Asia/Kuala_Lumpur|Asia/Singapore",
  "Asia/Kuala_Lumpur|Singapore",
  "Asia/Macau|Asia/Macao",
  "Asia/Makassar|Asia/Ujung_Pandang",
  "Asia/Nicosia|Europe/Nicosia",
  "Asia/Qatar|Asia/Bahrain",
  "Asia/Rangoon|Asia/Yangon",
  "Asia/Rangoon|Indian/Cocos",
  "Asia/Riyadh|Antarctica/Syowa",
  "Asia/Riyadh|Asia/Aden",
  "Asia/Riyadh|Asia/Kuwait",
  "Asia/Seoul|ROK",
  "Asia/Shanghai|Asia/Chongqing",
  "Asia/Shanghai|Asia/Chungking",
  "Asia/Shanghai|Asia/Harbin",
  "Asia/Shanghai|PRC",
  "Asia/Taipei|ROC",
  "Asia/Tehran|Iran",
  "Asia/Thimphu|Asia/Thimbu",
  "Asia/Tokyo|Japan",
  "Asia/Ulaanbaatar|Asia/Choibalsan",
  "Asia/Ulaanbaatar|Asia/Ulan_Bator",
  "Asia/Urumqi|Asia/Kashgar",
  "Atlantic/Faroe|Atlantic/Faeroe",
  "Australia/Adelaide|Australia/South",
  "Australia/Brisbane|Australia/Queensland",
  "Australia/Broken_Hill|Australia/Yancowinna",
  "Australia/Darwin|Australia/North",
  "Australia/Hobart|Australia/Currie",
  "Australia/Hobart|Australia/Tasmania",
  "Australia/Lord_Howe|Australia/LHI",
  "Australia/Melbourne|Australia/Victoria",
  "Australia/Perth|Australia/West",
  "Australia/Sydney|Australia/ACT",
  "Australia/Sydney|Australia/Canberra",
  "Australia/Sydney|Australia/NSW",
  "Etc/GMT-0|Etc/GMT",
  "Etc/GMT-0|Etc/GMT+0",
  "Etc/GMT-0|Etc/GMT0",
  "Etc/GMT-0|Etc/Greenwich",
  "Etc/GMT-0|GMT",
  "Etc/GMT-0|GMT+0",
  "Etc/GMT-0|GMT-0",
  "Etc/GMT-0|GMT0",
  "Etc/GMT-0|Greenwich",
  "Etc/UTC|Etc/UCT",
  "Etc/UTC|Etc/Universal",
  "Etc/UTC|Etc/Zulu",
  "Etc/UTC|UCT",
  "Etc/UTC|UTC",
  "Etc/UTC|Universal",
  "Etc/UTC|Zulu",
  "Europe/Athens|EET",
  "Europe/Belgrade|Europe/Ljubljana",
  "Europe/Belgrade|Europe/Podgorica",
  "Europe/Belgrade|Europe/Sarajevo",
  "Europe/Belgrade|Europe/Skopje",
  "Europe/Belgrade|Europe/Zagreb",
  "Europe/Berlin|Arctic/Longyearbyen",
  "Europe/Berlin|Atlantic/Jan_Mayen",
  "Europe/Berlin|Europe/Copenhagen",
  "Europe/Berlin|Europe/Oslo",
  "Europe/Berlin|Europe/Stockholm",
  "Europe/Brussels|CET",
  "Europe/Brussels|Europe/Amsterdam",
  "Europe/Brussels|Europe/Luxembourg",
  "Europe/Brussels|MET",
  "Europe/Chisinau|Europe/Tiraspol",
  "Europe/Dublin|Eire",
  "Europe/Helsinki|Europe/Mariehamn",
  "Europe/Istanbul|Asia/Istanbul",
  "Europe/Istanbul|Turkey",
  "Europe/Kiev|Europe/Kyiv",
  "Europe/Kiev|Europe/Uzhgorod",
  "Europe/Kiev|Europe/Zaporozhye",
  "Europe/Lisbon|Portugal",
  "Europe/Lisbon|WET",
  "Europe/London|Europe/Belfast",
  "Europe/London|Europe/Guernsey",
  "Europe/London|Europe/Isle_of_Man",
  "Europe/London|Europe/Jersey",
  "Europe/London|GB",
  "Europe/London|GB-Eire",
  "Europe/Moscow|W-SU",
  "Europe/Paris|Europe/Monaco",
  "Europe/Prague|Europe/Bratislava",
  "Europe/Rome|Europe/San_Marino",
  "Europe/Rome|Europe/Vatican",
  "Europe/Warsaw|Poland",
  "Europe/Zurich|Europe/Busingen",
  "Europe/Zurich|Europe/Vaduz",
  "Indian/Maldives|Indian/Kerguelen",
  "Pacific/Auckland|Antarctica/McMurdo",
  "Pacific/Auckland|Antarctica/South_Pole",
  "Pacific/Auckland|NZ",
  "Pacific/Chatham|NZ-CHAT",
  "Pacific/Easter|Chile/EasterIsland",
  "Pacific/Enderbury|Pacific/Kanton",
  "Pacific/Guadalcanal|Pacific/Pohnpei",
  "Pacific/Guadalcanal|Pacific/Ponape",
  "Pacific/Guam|Pacific/Saipan",
  "Pacific/Honolulu|HST",
  "Pacific/Honolulu|Pacific/Johnston",
  "Pacific/Honolulu|US/Hawaii",
  "Pacific/Kwajalein|Kwajalein",
  "Pacific/Pago_Pago|Pacific/Midway",
  "Pacific/Pago_Pago|Pacific/Samoa",
  "Pacific/Pago_Pago|US/Samoa",
  "Pacific/Port_Moresby|Antarctica/DumontDUrville",
  "Pacific/Port_Moresby|Pacific/Chuuk",
  "Pacific/Port_Moresby|Pacific/Truk",
  "Pacific/Port_Moresby|Pacific/Yap",
  "Pacific/Tarawa|Pacific/Funafuti",
  "Pacific/Tarawa|Pacific/Majuro",
  "Pacific/Tarawa|Pacific/Wake",
  "Pacific/Tarawa|Pacific/Wallis"
], FK0 = [
  "AD|Europe/Andorra",
  "AE|Asia/Dubai",
  "AF|Asia/Kabul",
  "AG|America/Puerto_Rico America/Antigua",
  "AI|America/Puerto_Rico America/Anguilla",
  "AL|Europe/Tirane",
  "AM|Asia/Yerevan",
  "AO|Africa/Lagos Africa/Luanda",
  "AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Asia/Singapore Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa",
  "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
  "AS|Pacific/Pago_Pago",
  "AT|Europe/Vienna",
  "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla Asia/Tokyo",
  "AW|America/Puerto_Rico America/Aruba",
  "AX|Europe/Helsinki Europe/Mariehamn",
  "AZ|Asia/Baku",
  "BA|Europe/Belgrade Europe/Sarajevo",
  "BB|America/Barbados",
  "BD|Asia/Dhaka",
  "BE|Europe/Brussels",
  "BF|Africa/Abidjan Africa/Ouagadougou",
  "BG|Europe/Sofia",
  "BH|Asia/Qatar Asia/Bahrain",
  "BI|Africa/Maputo Africa/Bujumbura",
  "BJ|Africa/Lagos Africa/Porto-Novo",
  "BL|America/Puerto_Rico America/St_Barthelemy",
  "BM|Atlantic/Bermuda",
  "BN|Asia/Kuching Asia/Brunei",
  "BO|America/La_Paz",
  "BQ|America/Puerto_Rico America/Kralendijk",
  "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
  "BS|America/Toronto America/Nassau",
  "BT|Asia/Thimphu",
  "BW|Africa/Maputo Africa/Gaborone",
  "BY|Europe/Minsk",
  "BZ|America/Belize",
  "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston",
  "CC|Asia/Yangon Indian/Cocos",
  "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
  "CF|Africa/Lagos Africa/Bangui",
  "CG|Africa/Lagos Africa/Brazzaville",
  "CH|Europe/Zurich",
  "CI|Africa/Abidjan",
  "CK|Pacific/Rarotonga",
  "CL|America/Santiago America/Coyhaique America/Punta_Arenas Pacific/Easter",
  "CM|Africa/Lagos Africa/Douala",
  "CN|Asia/Shanghai Asia/Urumqi",
  "CO|America/Bogota",
  "CR|America/Costa_Rica",
  "CU|America/Havana",
  "CV|Atlantic/Cape_Verde",
  "CW|America/Puerto_Rico America/Curacao",
  "CX|Asia/Bangkok Indian/Christmas",
  "CY|Asia/Nicosia Asia/Famagusta",
  "CZ|Europe/Prague",
  "DE|Europe/Zurich Europe/Berlin Europe/Busingen",
  "DJ|Africa/Nairobi Africa/Djibouti",
  "DK|Europe/Berlin Europe/Copenhagen",
  "DM|America/Puerto_Rico America/Dominica",
  "DO|America/Santo_Domingo",
  "DZ|Africa/Algiers",
  "EC|America/Guayaquil Pacific/Galapagos",
  "EE|Europe/Tallinn",
  "EG|Africa/Cairo",
  "EH|Africa/El_Aaiun",
  "ER|Africa/Nairobi Africa/Asmara",
  "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
  "ET|Africa/Nairobi Africa/Addis_Ababa",
  "FI|Europe/Helsinki",
  "FJ|Pacific/Fiji",
  "FK|Atlantic/Stanley",
  "FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei",
  "FO|Atlantic/Faroe",
  "FR|Europe/Paris",
  "GA|Africa/Lagos Africa/Libreville",
  "GB|Europe/London",
  "GD|America/Puerto_Rico America/Grenada",
  "GE|Asia/Tbilisi",
  "GF|America/Cayenne",
  "GG|Europe/London Europe/Guernsey",
  "GH|Africa/Abidjan Africa/Accra",
  "GI|Europe/Gibraltar",
  "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
  "GM|Africa/Abidjan Africa/Banjul",
  "GN|Africa/Abidjan Africa/Conakry",
  "GP|America/Puerto_Rico America/Guadeloupe",
  "GQ|Africa/Lagos Africa/Malabo",
  "GR|Europe/Athens",
  "GS|Atlantic/South_Georgia",
  "GT|America/Guatemala",
  "GU|Pacific/Guam",
  "GW|Africa/Bissau",
  "GY|America/Guyana",
  "HK|Asia/Hong_Kong",
  "HN|America/Tegucigalpa",
  "HR|Europe/Belgrade Europe/Zagreb",
  "HT|America/Port-au-Prince",
  "HU|Europe/Budapest",
  "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
  "IE|Europe/Dublin",
  "IL|Asia/Jerusalem",
  "IM|Europe/London Europe/Isle_of_Man",
  "IN|Asia/Kolkata",
  "IO|Indian/Chagos",
  "IQ|Asia/Baghdad",
  "IR|Asia/Tehran",
  "IS|Africa/Abidjan Atlantic/Reykjavik",
  "IT|Europe/Rome",
  "JE|Europe/London Europe/Jersey",
  "JM|America/Jamaica",
  "JO|Asia/Amman",
  "JP|Asia/Tokyo",
  "KE|Africa/Nairobi",
  "KG|Asia/Bishkek",
  "KH|Asia/Bangkok Asia/Phnom_Penh",
  "KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati",
  "KM|Africa/Nairobi Indian/Comoro",
  "KN|America/Puerto_Rico America/St_Kitts",
  "KP|Asia/Pyongyang",
  "KR|Asia/Seoul",
  "KW|Asia/Riyadh Asia/Kuwait",
  "KY|America/Panama America/Cayman",
  "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
  "LA|Asia/Bangkok Asia/Vientiane",
  "LB|Asia/Beirut",
  "LC|America/Puerto_Rico America/St_Lucia",
  "LI|Europe/Zurich Europe/Vaduz",
  "LK|Asia/Colombo",
  "LR|Africa/Monrovia",
  "LS|Africa/Johannesburg Africa/Maseru",
  "LT|Europe/Vilnius",
  "LU|Europe/Brussels Europe/Luxembourg",
  "LV|Europe/Riga",
  "LY|Africa/Tripoli",
  "MA|Africa/Casablanca",
  "MC|Europe/Paris Europe/Monaco",
  "MD|Europe/Chisinau",
  "ME|Europe/Belgrade Europe/Podgorica",
  "MF|America/Puerto_Rico America/Marigot",
  "MG|Africa/Nairobi Indian/Antananarivo",
  "MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro",
  "MK|Europe/Belgrade Europe/Skopje",
  "ML|Africa/Abidjan Africa/Bamako",
  "MM|Asia/Yangon",
  "MN|Asia/Ulaanbaatar Asia/Hovd",
  "MO|Asia/Macau",
  "MP|Pacific/Guam Pacific/Saipan",
  "MQ|America/Martinique",
  "MR|Africa/Abidjan Africa/Nouakchott",
  "MS|America/Puerto_Rico America/Montserrat",
  "MT|Europe/Malta",
  "MU|Indian/Mauritius",
  "MV|Indian/Maldives",
  "MW|Africa/Maputo Africa/Blantyre",
  "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana",
  "MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur",
  "MZ|Africa/Maputo",
  "NA|Africa/Windhoek",
  "NC|Pacific/Noumea",
  "NE|Africa/Lagos Africa/Niamey",
  "NF|Pacific/Norfolk",
  "NG|Africa/Lagos",
  "NI|America/Managua",
  "NL|Europe/Brussels Europe/Amsterdam",
  "NO|Europe/Berlin Europe/Oslo",
  "NP|Asia/Kathmandu",
  "NR|Pacific/Nauru",
  "NU|Pacific/Niue",
  "NZ|Pacific/Auckland Pacific/Chatham",
  "OM|Asia/Dubai Asia/Muscat",
  "PA|America/Panama",
  "PE|America/Lima",
  "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
  "PG|Pacific/Port_Moresby Pacific/Bougainville",
  "PH|Asia/Manila",
  "PK|Asia/Karachi",
  "PL|Europe/Warsaw",
  "PM|America/Miquelon",
  "PN|Pacific/Pitcairn",
  "PR|America/Puerto_Rico",
  "PS|Asia/Gaza Asia/Hebron",
  "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
  "PW|Pacific/Palau",
  "PY|America/Asuncion",
  "QA|Asia/Qatar",
  "RE|Asia/Dubai Indian/Reunion",
  "RO|Europe/Bucharest",
  "RS|Europe/Belgrade",
  "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
  "RW|Africa/Maputo Africa/Kigali",
  "SA|Asia/Riyadh",
  "SB|Pacific/Guadalcanal",
  "SC|Asia/Dubai Indian/Mahe",
  "SD|Africa/Khartoum",
  "SE|Europe/Berlin Europe/Stockholm",
  "SG|Asia/Singapore",
  "SH|Africa/Abidjan Atlantic/St_Helena",
  "SI|Europe/Belgrade Europe/Ljubljana",
  "SJ|Europe/Berlin Arctic/Longyearbyen",
  "SK|Europe/Prague Europe/Bratislava",
  "SL|Africa/Abidjan Africa/Freetown",
  "SM|Europe/Rome Europe/San_Marino",
  "SN|Africa/Abidjan Africa/Dakar",
  "SO|Africa/Nairobi Africa/Mogadishu",
  "SR|America/Paramaribo",
  "SS|Africa/Juba",
  "ST|Africa/Sao_Tome",
  "SV|America/El_Salvador",
  "SX|America/Puerto_Rico America/Lower_Princes",
  "SY|Asia/Damascus",
  "SZ|Africa/Johannesburg Africa/Mbabane",
  "TC|America/Grand_Turk",
  "TD|Africa/Ndjamena",
  "TF|Asia/Dubai Indian/Maldives Indian/Kerguelen",
  "TG|Africa/Abidjan Africa/Lome",
  "TH|Asia/Bangkok",
  "TJ|Asia/Dushanbe",
  "TK|Pacific/Fakaofo",
  "TL|Asia/Dili",
  "TM|Asia/Ashgabat",
  "TN|Africa/Tunis",
  "TO|Pacific/Tongatapu",
  "TR|Europe/Istanbul",
  "TT|America/Puerto_Rico America/Port_of_Spain",
  "TV|Pacific/Tarawa Pacific/Funafuti",
  "TW|Asia/Taipei",
  "TZ|Africa/Nairobi Africa/Dar_es_Salaam",
  "UA|Europe/Simferopol Europe/Kyiv",
  "UG|Africa/Nairobi Africa/Kampala",
  "UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake",
  "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
  "UY|America/Montevideo",
  "UZ|Asia/Samarkand Asia/Tashkent",
  "VA|Europe/Rome Europe/Vatican",
  "VC|America/Puerto_Rico America/St_Vincent",
  "VE|America/Caracas",
  "VG|America/Puerto_Rico America/Tortola",
  "VI|America/Puerto_Rico America/St_Thomas",
  "VN|Asia/Bangkok Asia/Ho_Chi_Minh",
  "VU|Pacific/Efate",
  "WF|Pacific/Tarawa Pacific/Wallis",
  "WS|Pacific/Apia",
  "YE|Asia/Riyadh Asia/Aden",
  "YT|Africa/Nairobi Indian/Mayotte",
  "ZA|Africa/Johannesburg",
  "ZM|Africa/Maputo Africa/Lusaka",
  "ZW|Africa/Maputo Africa/Harare"
], VK0 = {
  version: UK0,
  zones: kK0,
  links: jK0,
  countries: FK0
};
var HK0 = xK0;
HK0.tz.load(VK0);
var GK0 = {
  en: "US",
  zh: "CN",
  zh_hans: "CN",
  hans: "CN",
  wuu: "CN",
  hsn: "CN",
  hak: "CN",
  nan: "CN",
  gan: "CN",
  ii: "CN",
  ug: "CN",
  ug_arab: "CN",
  za: "CN",
  mn_mong: "CN",
  bo: "CN",
  kk_arab: "CN",
  lis: "CN",
  ky_arab: "CN",
  nxq: "CN",
  tdd: "CN",
  khb: "CN",
  lcp: "CN",
  hi: "IN",
  te: "IN",
  mr: "IN",
  ta: "IN",
  gu: "IN",
  kn: "IN",
  or: "IN",
  ml: "IN",
  pa_guru: "IN",
  bho: "IN",
  awa: "IN",
  as: "IN",
  mwr: "IN",
  mai: "IN",
  mag: "IN",
  bgc: "IN",
  hne: "IN",
  dcc: "IN",
  bjj: "IN",
  sat: "IN",
  wtm: "IN",
  ks: "IN",
  ks_arab: "IN",
  kok: "IN",
  gom: "IN",
  swv: "IN",
  lmn: "IN",
  gbm: "IN",
  gon: "IN",
  gon_telu: "IN",
  kfy: "IN",
  kru: "IN",
  doi: "IN",
  wbq: "IN",
  sck: "IN",
  xnr: "IN",
  wbr: "IN",
  tcy: "IN",
  khn: "IN",
  brx: "IN",
  noe: "IN",
  bhb: "IN",
  mni: "IN",
  raj: "IN",
  hoc: "IN",
  mtr: "IN",
  unr: "IN",
  unr_beng: "IN",
  bhi: "IN",
  hoj: "IN",
  kha: "IN",
  kfr: "IN",
  grt: "IN",
  unx: "IN",
  unx_beng: "IN",
  bfy: "IN",
  srx: "IN",
  saz: "IN",
  sd_deva: "IN",
  njo: "IN",
  bjq: "IN",
  ria: "IN",
  bpy: "IN",
  bra: "IN",
  lep: "IN",
  sa: "IN",
  kht: "IN",
  kgp: "BR",
  gub: "BR",
  yrl: "BR",
  xav: "BR",
  dz: "BT",
  tn: "BW",
  pdt: "CA",
  crk: "CA",
  cr: "CA",
  cr_cans: "CA",
  iu: "CA",
  iu_cans: "CA",
  iu_latn: "CA",
  moe: "CA",
  crj: "CA",
  atj: "CA",
  crl: "CA",
  csw: "CA",
  crm: "CA",
  ikt: "CA",
  moh: "CA",
  dgr: "CA",
  den: "CA",
  scs: "CA",
  nsk: "CA",
  chp: "CA",
  gwi: "CA",
  guc: "CO",
  am: "ET",
  om: "ET",
  ti: "ET",
  sid: "ET",
  wal: "ET",
  aa: "ET",
  quc: "GT",
  ch: "GU",
  id: "ID",
  jv: "ID",
  su: "ID",
  mad: "ID",
  ms_arab: "ID",
  min: "ID",
  bew: "ID",
  ban: "ID",
  bug: "ID",
  bjn: "ID",
  ace: "ID",
  sas: "ID",
  bbc: "ID",
  mak: "ID",
  ljp: "ID",
  rej: "ID",
  gor: "ID",
  nij: "ID",
  kge: "ID",
  aoz: "ID",
  kvr: "ID",
  lbw: "ID",
  gay: "ID",
  rob: "ID",
  sxn: "ID",
  mdr: "ID",
  sly: "ID",
  mwv: "ID",
  ga: "IE",
  he: "IL",
  lad: "IL",
  jam: "JM",
  ja: "JP",
  ryu: "JP",
  ki: "KE",
  luy: "KE",
  luo: "KE",
  kln: "KE",
  kam: "KE",
  guz: "KE",
  mer: "KE",
  ebu: "KE",
  dav: "KE",
  pko: "KE",
  saq: "KE",
  km: "KH",
  cja: "KH",
  ko: "KR",
  lo: "LA",
  kjg: "LA",
  mh: "MH",
  my: "MM",
  shn: "MM",
  kac: "MM",
  mnw: "MM",
  mt: "MT",
  yua: "MX",
  nhe: "MX",
  nhw: "MX",
  maz: "MX",
  nch: "MX",
  sei: "MX",
  vmw: "MZ",
  ndc: "MZ",
  ngl: "MZ",
  seh: "MZ",
  mgh: "MZ",
  rng: "MZ",
  yao: "MZ",
  ne: "NP",
  new: "NP",
  jml: "NP",
  taj: "NP",
  thl: "NP",
  bap: "NP",
  tdg: "NP",
  thr: "NP",
  mgp: "NP",
  lif: "NP",
  lif_deva: "NP",
  thq: "NP",
  mrd: "NP",
  xsr: "NP",
  rjs: "NP",
  tsf: "NP",
  ggn: "NP",
  gvr: "NP",
  tkt: "NP",
  tdh: "NP",
  unr_deva: "NP",
  mi: "NZ",
  qu: "PE",
  fil: "PH",
  ceb: "PH",
  ilo: "PH",
  hil: "PH",
  bik: "PH",
  war: "PH",
  pam: "PH",
  bhk: "PH",
  pag: "PH",
  mdh: "PH",
  tsg: "PH",
  cps: "PH",
  krj: "PH",
  bto: "PH",
  hnn: "PH",
  tbw: "PH",
  bku: "PH",
  ur: "PK",
  pa: "PK",
  pa_arab: "PK",
  arab: "PK",
  lah: "PK",
  ps: "PK",
  sd: "PK",
  sd_arab: "PK",
  skr: "PK",
  bal: "PK",
  brh: "PK",
  hno: "PK",
  bgn: "PK",
  hnd: "PK",
  tg_arab: "PK",
  gju: "PK",
  bft: "PK",
  kvx: "PK",
  khw: "PK",
  mvy: "PK",
  kxp: "PK",
  gjk: "PK",
  btv: "PK",
  gn: "PY",
  th: "TH",
  tts: "TH",
  nod: "TH",
  sou: "TH",
  mfa: "TH",
  kxm: "TH",
  kdt: "TH",
  lwl: "TH",
  aeb: "TN",
  zh_hant: "TW",
  hant: "TW",
  trv: "TW",
  nv: "US",
  pdc: "US",
  haw: "US",
  frc: "US",
  chr: "US",
  esu: "US",
  dak: "US",
  cho: "US",
  lkt: "US",
  ik: "US",
  mus: "US",
  sm: "WS",
  zu: "ZA",
  xh: "ZA",
  af: "ZA",
  nso: "ZA",
  st: "ZA",
  ts: "ZA",
  ss: "ZA",
  ve: "ZA",
  nr: "ZA",
  sn: "ZW",
  nd: "ZW",
  mxc: "ZW",
  kck: "ZW",
  haz: "AF",
  uz_arab: "AF",
  arq: "DZ",
  kab: "DZ",
  ar: "EG",
  arz: "EG",
  ckb: "IQ",
  syr: "IQ",
  fa: "IR",
  az_arab: "IR",
  mzn: "IR",
  glk: "IR",
  sdh: "IR",
  lrc: "IR",
  rmt: "IR",
  bqi: "IR",
  luz: "IR",
  lki: "IR",
  prd: "IR",
  gbz: "IR",
  ary: "MA",
  zgh: "MA",
  tzm: "MA",
  tzm_latn: "MA",
  shi: "MA",
  shi_latn: "MA",
  shi_tfng: "MA",
  tfng: "MA",
  rif: "MA",
  rif_latn: "MA",
  rif_tfng: "MA",
  bej: "SD",
  fvr: "SD",
  mls: "SD",
  fia: "SD",
  zag: "SD",
  bn: "BD",
  rkt: "BD",
  syl: "BD",
  ccp: "BD",
  dv: "MV"
}, YK0 = GK0, JK0 = {
  AG: 0,
  ATG: 0,
  28: 0,
  AR: 0,
  ARG: 0,
  32: 0,
  AS: 0,
  ASM: 0,
  16: 0,
  AU: 0,
  AUS: 0,
  36: 0,
  BR: 0,
  BRA: 0,
  76: 0,
  BS: 0,
  BHS: 0,
  44: 0,
  BT: 0,
  BTN: 0,
  64: 0,
  BW: 0,
  BWA: 0,
  72: 0,
  BZ: 0,
  BLZ: 0,
  84: 0,
  CA: 0,
  CAN: 0,
  124: 0,
  CN: 0,
  CHN: 0,
  156: 0,
  CO: 0,
  COL: 0,
  170: 0,
  DM: 0,
  DMA: 0,
  212: 0,
  DO: 0,
  DOM: 0,
  214: 0,
  ET: 0,
  ETH: 0,
  231: 0,
  GT: 0,
  GTM: 0,
  320: 0,
  GU: 0,
  GUM: 0,
  316: 0,
  HK: 0,
  HKG: 0,
  344: 0,
  HN: 0,
  HND: 0,
  340: 0,
  ID: 0,
  IDN: 0,
  360: 0,
  IE: 0,
  IRL: 0,
  372: 0,
  IL: 0,
  ISR: 0,
  376: 0,
  IN: 0,
  IND: 0,
  356: 0,
  JM: 0,
  JAM: 0,
  388: 0,
  JP: 0,
  JPN: 0,
  392: 0,
  KE: 0,
  KEN: 0,
  404: 0,
  KH: 0,
  KHM: 0,
  116: 0,
  KR: 0,
  KOR: 0,
  410: 0,
  LA: 0,
  LA0: 0,
  418: 0,
  MH: 0,
  MHL: 0,
  584: 0,
  MM: 0,
  MMR: 0,
  104: 0,
  MO: 0,
  MAC: 0,
  446: 0,
  MT: 0,
  MLT: 0,
  470: 0,
  MX: 0,
  MEX: 0,
  484: 0,
  MZ: 0,
  MOZ: 0,
  508: 0,
  NI: 0,
  NIC: 0,
  558: 0,
  NP: 0,
  NPL: 0,
  524: 0,
  NZ: 0,
  NZL: 0,
  554: 0,
  PA: 0,
  PAN: 0,
  591: 0,
  PE: 0,
  PER: 0,
  604: 0,
  PH: 0,
  PHL: 0,
  608: 0,
  PK: 0,
  PAK: 0,
  586: 0,
  PR: 0,
  PRI: 0,
  630: 0,
  PY: 0,
  PRY: 0,
  600: 0,
  SA: 0,
  SAU: 0,
  682: 0,
  SG: 0,
  SGP: 0,
  702: 0,
  SV: 0,
  SLV: 0,
  222: 0,
  TH: 0,
  THA: 0,
  764: 0,
  TN: 0,
  TUN: 0,
  788: 0,
  TT: 0,
  TTO: 0,
  780: 0,
  TW: 0,
  TWN: 0,
  158: 0,
  UM: 0,
  UMI: 0,
  581: 0,
  US: 0,
  USA: 0,
  840: 0,
  VE: 0,
  VEN: 0,
  862: 0,
  VI: 0,
  VIR: 0,
  850: 0,
  WS: 0,
  WSM: 0,
  882: 0,
  YE: 0,
  YEM: 0,
  887: 0,
  ZA: 0,
  ZAF: 0,
  710: 0,
  ZW: 0,
  ZWE: 0,
  716: 0,
  AE: 6,
  ARE: 6,
  784: 6,
  AF: 6,
  AFG: 6,
  4: 6,
  BH: 6,
  BHR: 6,
  48: 6,
  DJ: 6,
  DJI: 6,
  262: 6,
  DZ: 6,
  DZA: 6,
  12: 6,
  EG: 6,
  EGY: 6,
  818: 6,
  IQ: 6,
  IRQ: 6,
  368: 6,
  IR: 6,
  IRN: 6,
  364: 6,
  JO: 6,
  JOR: 6,
  400: 6,
  KW: 6,
  KWT: 6,
  414: 6,
  LY: 6,
  LBY: 6,
  434: 6,
  MA: 6,
  MAR: 6,
  504: 6,
  OM: 6,
  OMN: 6,
  512: 6,
  QA: 6,
  QAT: 6,
  634: 6,
  SD: 6,
  SDN: 6,
  729: 6,
  SY: 6,
  SYR: 6,
  760: 6,
  BD: 5,
  BGD: 5,
  50: 5,
  MV: 5,
  MDV: 5,
  462: 5
}, KK0 = JK0;
function fGe(t16) {
  return t16 && typeof t16 == "object" && "default" in t16 ? t16.default : t16;
}
fGe(YK0);
fGe(KK0);
const rQ0 = /[-_]/g;
class Gn {
  constructor(e, r12, n12, a) {
    q0(this, "_language");
    q0(this, "_script");
    q0(this, "_region");
    q0(this, "_variants");
    q0(this, "_delimiter", "-");
    if (typeof e == "string") {
      if (rQ0.test(e)) {
        const o = Gn.parse(e);
        if (!o)
          throw new Error("Invalid locale.");
        return o;
      }
      this._language = e, this._script = n12, this._region = r12, this._variants = [...new Set(a ?? [])];
    } else
      return e;
  }
  get [Symbol.toStringTag]() {
    return "Locale";
  }
  get language() {
    return this._language.toLowerCase();
  }
  get script() {
    return this._script && AZ(this._script);
  }
  get region() {
    var e;
    return (e = this._region) == null ? void 0 : e.toUpperCase();
  }
  get variants() {
    return this._variants.sort((e, r12) => {
      const n12 = e.toLowerCase(), a = r12.toLowerCase();
      return n12.toLowerCase() < a.toLowerCase() ? -1 : n12.toLowerCase() > a.toLowerCase() ? 1 : 0;
    });
  }
  get baseName() {
    let e = this.language;
    return this.script && (e += `${this._delimiter}${this.script}`), this.region && (e += `${this._delimiter}${this.region}`), e;
  }
  static parse(e) {
    if (!e || e.trim() === "")
      return;
    const r12 = Math.min(...["-t-", "-u-", "-x-"].map((c) => e.indexOf(c))), a = e.substring(0, r12 > 0 ? r12 : void 0).trim().split(/[-_]/).map((c) => c.trim()).filter((c) => c.length > 0);
    let o = "", i, u;
    const s12 = [];
    return a.map((c, l2) => {
      l2 === 0 ? o = c.toLowerCase() : c.length === 4 && !/^[0-9]/.test(c) ? i = AZ(c) : /^([a-z]{2}|\d{3})$/i.test(c) ? u = c.toUpperCase() : s12.push(c);
    }), new this(o, u, i, s12);
  }
  static prepareSupported(e) {
    const r12 = {};
    return e.forEach((n12) => {
      const a = Gn.parse(n12);
      if (!a)
        throw new Error(`Locale ${n12} is not parsable`);
      Object.hasOwnProperty.call(r12, a.language) || (r12[a.language] = {
        regions: {},
        firstRegion: void 0,
        main: void 0
      });
      const o = r12[a.language];
      a.region ? (o.regions[a.region] = n12, o.firstRegion || (o.firstRegion = n12)) : o.main = n12;
    }), r12;
  }
  getBest(e, r12, n12 = false) {
    const a = Array.isArray(e) ? Gn.prepareSupported(e) : e, o = r12 ? Gn.parse(r12) : void 0;
    if (!a[this.language])
      return window.console.log(`Locale ${this.baseName} is not supported`), o ? this.language === o.language && this.region === o.region ? void 0 : o.getBest(e, void 0, n12) : void 0;
    const { regions: i, main: u = r12, firstRegion: s12 } = a[this.language];
    return !i || !this.region ? n12 && s12 ? s12 : u : n12 && s12 ? i[this.region] ? i[this.region] : s12 : i[this.region] ? i[this.region] : u;
  }
}
f$e(Gn.prototype, "Locale");
new Gn("en-US");
({
  ...q$0
});
const MZ0 = {
  modelValue: "",
  clearable: false,
  placeholder: "",
  rows: 1,
  searchIcon: false,
  valid: true,
  triggerValidation: 0,
  required: false,
  isDisabled: false,
  isReadonly: false,
  type: "text",
  autocomplete: "new-password",
  focused: 0,
  haltUpdatesOnInput: false
}, OZ0 = { class: "una-text-editor" }, zZ0 = {
  key: 0,
  class: "una-text-editor-search-icon"
}, AZ0 = ["value", "type", "placeholder", "maxLength", "disabled", "readonly", "autocomplete"], _Z0 = ["value", "placeholder", "maxLength", "disabled", "readonly", "autocomplete"], hZ0 = {
  key: 3,
  class: "flex w-[20px] items-center"
};
/* @__PURE__ */ defineComponent({
  __name: "text-editor",
  props: mergeDefaults({
    modelValue: {},
    clearable: { type: Boolean },
    placeholder: {},
    maxLength: {},
    rows: {},
    searchIcon: { type: Boolean },
    valid: { type: [Boolean, Function] },
    triggerValidation: {},
    required: { type: Boolean },
    isDisabled: { type: Boolean },
    isReadonly: { type: Boolean },
    type: {},
    autocomplete: {},
    focused: {},
    haltUpdatesOnInput: { type: Boolean }
  }, MZ0),
  emits: ["validated", "update:modelValue", "clear"],
  setup(t16, { expose: e, emit: r12 }) {
    N0.add(Kt0, bp);
    const n12 = t16, a = r12, o = computed(() => ({
      height: `${n12.rows * 24}px`
    })), i = computed({
      get() {
        return n12.modelValue;
      },
      set(b) {
        a("update:modelValue", b);
      }
    });
    watch(
      () => n12.valid,
      () => {
        d();
      }
    );
    const u = computed(() => n12.rows <= 1), s12 = () => {
      i.value = "", a("clear", "");
    }, c = /* @__PURE__ */ ref(null), l2 = () => {
      var b;
      (b = c.value) == null || b.focus();
    };
    watch(
      () => n12.focused,
      () => {
        c.value && l2();
      }
    );
    const f = (b) => {
      n12.haltUpdatesOnInput || a("update:modelValue", b.target.value);
    }, p = (b) => {
      d(), b.target.value != n12.modelValue && a("update:modelValue", b.target.value);
    };
    watch(
      () => n12.triggerValidation,
      () => {
        d();
      }
    );
    const d = () => {
      if (!n12.isDisabled) {
        if (n12.required && !n12.modelValue) {
          a("validated", {
            isValid: false,
            invalidReason: "required"
          });
          return;
        }
        if (a("validated", { isValid: true }), typeof n12.valid == "function")
          a("validated", n12.valid(n12.modelValue));
        else {
          a("validated", {
            isValid: n12.valid,
            invalidReason: n12.valid ? void 0 : "unknown"
          });
          return;
        }
      }
    };
    return watch(
      () => n12.modelValue,
      () => {
        d();
      },
      { immediate: false }
    ), e({
      focusInput: l2
    }), (b, z) => (openBlock(), createElementBlock("div", OZ0, [
      b.searchIcon ? (openBlock(), createElementBlock("div", zZ0, [
        createVNode(R0, { icon: "search" })
      ])) : createCommentVNode("", true),
      unref(u) ? (openBlock(), createElementBlock("input", mergeProps({ key: 1 }, b.$attrs, {
        value: n12.modelValue,
        ref_key: "input",
        ref: c,
        type: b.type,
        placeholder: b.placeholder,
        maxLength: b.maxLength,
        disabled: b.isDisabled,
        readonly: b.isReadonly,
        autocomplete: b.autocomplete,
        class: b.type === "number" ? "text-right" : "",
        onBlur: p,
        onInput: f
      }), null, 16, AZ0)) : (openBlock(), createElementBlock("textarea", mergeProps({ key: 2 }, b.$attrs, {
        value: n12.modelValue,
        ref_key: "input",
        ref: c,
        style: unref(o),
        placeholder: b.placeholder,
        maxLength: b.maxLength,
        disabled: b.isDisabled,
        readonly: b.isReadonly,
        autocomplete: b.autocomplete,
        onBlur: p,
        onInput: f
      }), null, 16, _Z0)),
      b.clearable && !b.isDisabled ? (openBlock(), createElementBlock("div", hZ0, [
        n12.modelValue ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "una-text-clear",
          onClick: s12
        }, [
          createVNode(R0, { icon: "times" })
        ])) : createCommentVNode("", true)
      ])) : createCommentVNode("", true)
    ]));
  }
});
var RGe = {}, Fs = {}, W0e = {}, Vs = {}, N0e = {};
Object.defineProperty(N0e, "__esModule", { value: true });
N0e.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(t16) {
    return t16.charCodeAt(0);
  })
);
var w0e = {};
Object.defineProperty(w0e, "__esModule", { value: true });
w0e.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(t16) {
    return t16.charCodeAt(0);
  })
);
var CZ = {};
(function(t16) {
  var e;
  Object.defineProperty(t16, "__esModule", { value: true }), t16.replaceCodePoint = t16.fromCodePoint = void 0;
  var r12 = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  t16.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (e = String.fromCodePoint) !== null && e !== void 0 ? e : function(o) {
    var i = "";
    return o > 65535 && (o -= 65536, i += String.fromCharCode(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), i += String.fromCharCode(o), i;
  };
  function n12(o) {
    var i;
    return o >= 55296 && o <= 57343 || o > 1114111 ? 65533 : (i = r12.get(o)) !== null && i !== void 0 ? i : o;
  }
  t16.replaceCodePoint = n12;
  function a(o) {
    return (0, t16.fromCodePoint)(n12(o));
  }
  t16.default = a;
})(CZ);
(function(t16) {
  var e = l0 && l0.__createBinding || (Object.create ? function(W, x, D, w) {
    w === void 0 && (w = D);
    var I = Object.getOwnPropertyDescriptor(x, D);
    (!I || ("get" in I ? !x.__esModule : I.writable || I.configurable)) && (I = { enumerable: true, get: function() {
      return x[D];
    } }), Object.defineProperty(W, w, I);
  } : function(W, x, D, w) {
    w === void 0 && (w = D), W[w] = x[D];
  }), r12 = l0 && l0.__setModuleDefault || (Object.create ? function(W, x) {
    Object.defineProperty(W, "default", { enumerable: true, value: x });
  } : function(W, x) {
    W.default = x;
  }), n12 = l0 && l0.__importStar || function(W) {
    if (W && W.__esModule)
      return W;
    var x = {};
    if (W != null)
      for (var D in W)
        D !== "default" && Object.prototype.hasOwnProperty.call(W, D) && e(x, W, D);
    return r12(x, W), x;
  }, a = l0 && l0.__importDefault || function(W) {
    return W && W.__esModule ? W : { default: W };
  };
  Object.defineProperty(t16, "__esModule", { value: true }), t16.decodeXML = t16.decodeHTMLStrict = t16.decodeHTMLAttribute = t16.decodeHTML = t16.determineBranch = t16.EntityDecoder = t16.DecodingMode = t16.BinTrieFlags = t16.fromCodePoint = t16.replaceCodePoint = t16.decodeCodePoint = t16.xmlDecodeTree = t16.htmlDecodeTree = void 0;
  var o = a(N0e);
  t16.htmlDecodeTree = o.default;
  var i = a(w0e);
  t16.xmlDecodeTree = i.default;
  var u = n12(CZ);
  t16.decodeCodePoint = u.default;
  var s12 = CZ;
  Object.defineProperty(t16, "replaceCodePoint", { enumerable: true, get: function() {
    return s12.replaceCodePoint;
  } }), Object.defineProperty(t16, "fromCodePoint", { enumerable: true, get: function() {
    return s12.fromCodePoint;
  } });
  var c;
  (function(W) {
    W[W.NUM = 35] = "NUM", W[W.SEMI = 59] = "SEMI", W[W.EQUALS = 61] = "EQUALS", W[W.ZERO = 48] = "ZERO", W[W.NINE = 57] = "NINE", W[W.LOWER_A = 97] = "LOWER_A", W[W.LOWER_F = 102] = "LOWER_F", W[W.LOWER_X = 120] = "LOWER_X", W[W.LOWER_Z = 122] = "LOWER_Z", W[W.UPPER_A = 65] = "UPPER_A", W[W.UPPER_F = 70] = "UPPER_F", W[W.UPPER_Z = 90] = "UPPER_Z";
  })(c || (c = {}));
  var l2 = 32, f;
  (function(W) {
    W[W.VALUE_LENGTH = 49152] = "VALUE_LENGTH", W[W.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", W[W.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(f = t16.BinTrieFlags || (t16.BinTrieFlags = {}));
  function p(W) {
    return W >= c.ZERO && W <= c.NINE;
  }
  function d(W) {
    return W >= c.UPPER_A && W <= c.UPPER_F || W >= c.LOWER_A && W <= c.LOWER_F;
  }
  function b(W) {
    return W >= c.UPPER_A && W <= c.UPPER_Z || W >= c.LOWER_A && W <= c.LOWER_Z || p(W);
  }
  function z(W) {
    return W === c.EQUALS || b(W);
  }
  var _;
  (function(W) {
    W[W.EntityStart = 0] = "EntityStart", W[W.NumericStart = 1] = "NumericStart", W[W.NumericDecimal = 2] = "NumericDecimal", W[W.NumericHex = 3] = "NumericHex", W[W.NamedEntity = 4] = "NamedEntity";
  })(_ || (_ = {}));
  var q;
  (function(W) {
    W[W.Legacy = 0] = "Legacy", W[W.Strict = 1] = "Strict", W[W.Attribute = 2] = "Attribute";
  })(q = t16.DecodingMode || (t16.DecodingMode = {}));
  var S = (
    /** @class */
    (function() {
      function W(x, D, w) {
        this.decodeTree = x, this.emitCodePoint = D, this.errors = w, this.state = _.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = q.Strict;
      }
      return W.prototype.startEntity = function(x) {
        this.decodeMode = x, this.state = _.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, W.prototype.write = function(x, D) {
        switch (this.state) {
          case _.EntityStart:
            return x.charCodeAt(D) === c.NUM ? (this.state = _.NumericStart, this.consumed += 1, this.stateNumericStart(x, D + 1)) : (this.state = _.NamedEntity, this.stateNamedEntity(x, D));
          case _.NumericStart:
            return this.stateNumericStart(x, D);
          case _.NumericDecimal:
            return this.stateNumericDecimal(x, D);
          case _.NumericHex:
            return this.stateNumericHex(x, D);
          case _.NamedEntity:
            return this.stateNamedEntity(x, D);
        }
      }, W.prototype.stateNumericStart = function(x, D) {
        return D >= x.length ? -1 : (x.charCodeAt(D) | l2) === c.LOWER_X ? (this.state = _.NumericHex, this.consumed += 1, this.stateNumericHex(x, D + 1)) : (this.state = _.NumericDecimal, this.stateNumericDecimal(x, D));
      }, W.prototype.addToNumericResult = function(x, D, w, I) {
        if (D !== w) {
          var Y = w - D;
          this.result = this.result * Math.pow(I, Y) + parseInt(x.substr(D, Y), I), this.consumed += Y;
        }
      }, W.prototype.stateNumericHex = function(x, D) {
        for (var w = D; D < x.length; ) {
          var I = x.charCodeAt(D);
          if (p(I) || d(I))
            D += 1;
          else
            return this.addToNumericResult(x, w, D, 16), this.emitNumericEntity(I, 3);
        }
        return this.addToNumericResult(x, w, D, 16), -1;
      }, W.prototype.stateNumericDecimal = function(x, D) {
        for (var w = D; D < x.length; ) {
          var I = x.charCodeAt(D);
          if (p(I))
            D += 1;
          else
            return this.addToNumericResult(x, w, D, 10), this.emitNumericEntity(I, 2);
        }
        return this.addToNumericResult(x, w, D, 10), -1;
      }, W.prototype.emitNumericEntity = function(x, D) {
        var w;
        if (this.consumed <= D)
          return (w = this.errors) === null || w === void 0 || w.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (x === c.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === q.Strict)
          return 0;
        return this.emitCodePoint((0, u.replaceCodePoint)(this.result), this.consumed), this.errors && (x !== c.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, W.prototype.stateNamedEntity = function(x, D) {
        for (var w = this.decodeTree, I = w[this.treeIndex], Y = (I & f.VALUE_LENGTH) >> 14; D < x.length; D++, this.excess++) {
          var oe = x.charCodeAt(D);
          if (this.treeIndex = v(w, I, this.treeIndex + Math.max(1, Y), oe), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === q.Attribute && // We shouldn't have consumed any characters after the entity,
            (Y === 0 || // And there should be no invalid characters.
            z(oe)) ? 0 : this.emitNotTerminatedNamedEntity();
          if (I = w[this.treeIndex], Y = (I & f.VALUE_LENGTH) >> 14, Y !== 0) {
            if (oe === c.SEMI)
              return this.emitNamedEntityData(this.treeIndex, Y, this.consumed + this.excess);
            this.decodeMode !== q.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, W.prototype.emitNotTerminatedNamedEntity = function() {
        var x, D = this, w = D.result, I = D.decodeTree, Y = (I[w] & f.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(w, Y, this.consumed), (x = this.errors) === null || x === void 0 || x.missingSemicolonAfterCharacterReference(), this.consumed;
      }, W.prototype.emitNamedEntityData = function(x, D, w) {
        var I = this.decodeTree;
        return this.emitCodePoint(D === 1 ? I[x] & ~f.VALUE_LENGTH : I[x + 1], w), D === 3 && this.emitCodePoint(I[x + 2], w), w;
      }, W.prototype.end = function() {
        var x;
        switch (this.state) {
          case _.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== q.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          case _.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case _.NumericHex:
            return this.emitNumericEntity(0, 3);
          case _.NumericStart:
            return (x = this.errors) === null || x === void 0 || x.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case _.EntityStart:
            return 0;
        }
      }, W;
    })()
  );
  t16.EntityDecoder = S;
  function N(W) {
    var x = "", D = new S(W, function(w) {
      return x += (0, u.fromCodePoint)(w);
    });
    return function(I, Y) {
      for (var oe = 0, Z = 0; (Z = I.indexOf("&", Z)) >= 0; ) {
        x += I.slice(oe, Z), D.startEntity(Y);
        var se = D.write(
          I,
          // Skip the "&"
          Z + 1
        );
        if (se < 0) {
          oe = Z + D.end();
          break;
        }
        oe = Z + se, Z = se === 0 ? oe + 1 : oe;
      }
      var Ie = x + I.slice(oe);
      return x = "", Ie;
    };
  }
  function v(W, x, D, w) {
    var I = (x & f.BRANCH_LENGTH) >> 7, Y = x & f.JUMP_TABLE;
    if (I === 0)
      return Y !== 0 && w === Y ? D : -1;
    if (Y) {
      var oe = w - Y;
      return oe < 0 || oe >= I ? -1 : W[D + oe] - 1;
    }
    for (var Z = D, se = Z + I - 1; Z <= se; ) {
      var Ie = Z + se >>> 1, ie = W[Ie];
      if (ie < w)
        Z = Ie + 1;
      else if (ie > w)
        se = Ie - 1;
      else
        return W[Ie + I];
    }
    return -1;
  }
  t16.determineBranch = v;
  var C = N(o.default), L = N(i.default);
  function B(W, x) {
    return x === void 0 && (x = q.Legacy), C(W, x);
  }
  t16.decodeHTML = B;
  function P12(W) {
    return C(W, q.Attribute);
  }
  t16.decodeHTMLAttribute = P12;
  function j(W) {
    return C(W, q.Strict);
  }
  t16.decodeHTMLStrict = j;
  function $(W) {
    return L(W, q.Strict);
  }
  t16.decodeXML = $;
})(Vs);
(function(t16) {
  Object.defineProperty(t16, "__esModule", { value: true }), t16.QuoteType = void 0;
  var e = Vs, r12;
  (function(p) {
    p[p.Tab = 9] = "Tab", p[p.NewLine = 10] = "NewLine", p[p.FormFeed = 12] = "FormFeed", p[p.CarriageReturn = 13] = "CarriageReturn", p[p.Space = 32] = "Space", p[p.ExclamationMark = 33] = "ExclamationMark", p[p.Number = 35] = "Number", p[p.Amp = 38] = "Amp", p[p.SingleQuote = 39] = "SingleQuote", p[p.DoubleQuote = 34] = "DoubleQuote", p[p.Dash = 45] = "Dash", p[p.Slash = 47] = "Slash", p[p.Zero = 48] = "Zero", p[p.Nine = 57] = "Nine", p[p.Semi = 59] = "Semi", p[p.Lt = 60] = "Lt", p[p.Eq = 61] = "Eq", p[p.Gt = 62] = "Gt", p[p.Questionmark = 63] = "Questionmark", p[p.UpperA = 65] = "UpperA", p[p.LowerA = 97] = "LowerA", p[p.UpperF = 70] = "UpperF", p[p.LowerF = 102] = "LowerF", p[p.UpperZ = 90] = "UpperZ", p[p.LowerZ = 122] = "LowerZ", p[p.LowerX = 120] = "LowerX", p[p.OpeningSquareBracket = 91] = "OpeningSquareBracket";
  })(r12 || (r12 = {}));
  var n12;
  (function(p) {
    p[p.Text = 1] = "Text", p[p.BeforeTagName = 2] = "BeforeTagName", p[p.InTagName = 3] = "InTagName", p[p.InSelfClosingTag = 4] = "InSelfClosingTag", p[p.BeforeClosingTagName = 5] = "BeforeClosingTagName", p[p.InClosingTagName = 6] = "InClosingTagName", p[p.AfterClosingTagName = 7] = "AfterClosingTagName", p[p.BeforeAttributeName = 8] = "BeforeAttributeName", p[p.InAttributeName = 9] = "InAttributeName", p[p.AfterAttributeName = 10] = "AfterAttributeName", p[p.BeforeAttributeValue = 11] = "BeforeAttributeValue", p[p.InAttributeValueDq = 12] = "InAttributeValueDq", p[p.InAttributeValueSq = 13] = "InAttributeValueSq", p[p.InAttributeValueNq = 14] = "InAttributeValueNq", p[p.BeforeDeclaration = 15] = "BeforeDeclaration", p[p.InDeclaration = 16] = "InDeclaration", p[p.InProcessingInstruction = 17] = "InProcessingInstruction", p[p.BeforeComment = 18] = "BeforeComment", p[p.CDATASequence = 19] = "CDATASequence", p[p.InSpecialComment = 20] = "InSpecialComment", p[p.InCommentLike = 21] = "InCommentLike", p[p.BeforeSpecialS = 22] = "BeforeSpecialS", p[p.SpecialStartSequence = 23] = "SpecialStartSequence", p[p.InSpecialTag = 24] = "InSpecialTag", p[p.BeforeEntity = 25] = "BeforeEntity", p[p.BeforeNumericEntity = 26] = "BeforeNumericEntity", p[p.InNamedEntity = 27] = "InNamedEntity", p[p.InNumericEntity = 28] = "InNumericEntity", p[p.InHexEntity = 29] = "InHexEntity";
  })(n12 || (n12 = {}));
  function a(p) {
    return p === r12.Space || p === r12.NewLine || p === r12.Tab || p === r12.FormFeed || p === r12.CarriageReturn;
  }
  function o(p) {
    return p === r12.Slash || p === r12.Gt || a(p);
  }
  function i(p) {
    return p >= r12.Zero && p <= r12.Nine;
  }
  function u(p) {
    return p >= r12.LowerA && p <= r12.LowerZ || p >= r12.UpperA && p <= r12.UpperZ;
  }
  function s12(p) {
    return p >= r12.UpperA && p <= r12.UpperF || p >= r12.LowerA && p <= r12.LowerF;
  }
  var c;
  (function(p) {
    p[p.NoValue = 0] = "NoValue", p[p.Unquoted = 1] = "Unquoted", p[p.Single = 2] = "Single", p[p.Double = 3] = "Double";
  })(c = t16.QuoteType || (t16.QuoteType = {}));
  var l2 = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    CdataEnd: new Uint8Array([93, 93, 62]),
    CommentEnd: new Uint8Array([45, 45, 62]),
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
    // `</title`
  }, f = (
    /** @class */
    (function() {
      function p(d, b) {
        var z = d.xmlMode, _ = z === void 0 ? false : z, q = d.decodeEntities, S = q === void 0 ? true : q;
        this.cbs = b, this.state = n12.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = n12.Text, this.isSpecial = false, this.running = true, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = _, this.decodeEntities = S, this.entityTrie = _ ? e.xmlDecodeTree : e.htmlDecodeTree;
      }
      return p.prototype.reset = function() {
        this.state = n12.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = n12.Text, this.currentSequence = void 0, this.running = true, this.offset = 0;
      }, p.prototype.write = function(d) {
        this.offset += this.buffer.length, this.buffer = d, this.parse();
      }, p.prototype.end = function() {
        this.running && this.finish();
      }, p.prototype.pause = function() {
        this.running = false;
      }, p.prototype.resume = function() {
        this.running = true, this.index < this.buffer.length + this.offset && this.parse();
      }, p.prototype.getIndex = function() {
        return this.index;
      }, p.prototype.getSectionStart = function() {
        return this.sectionStart;
      }, p.prototype.stateText = function(d) {
        d === r12.Lt || !this.decodeEntities && this.fastForwardTo(r12.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = n12.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && d === r12.Amp && (this.state = n12.BeforeEntity);
      }, p.prototype.stateSpecialStartSequence = function(d) {
        var b = this.sequenceIndex === this.currentSequence.length, z = b ? (
          // If we are at the end of the sequence, make sure the tag name has ended
          o(d)
        ) : (
          // Otherwise, do a case-insensitive comparison
          (d | 32) === this.currentSequence[this.sequenceIndex]
        );
        if (!z)
          this.isSpecial = false;
        else if (!b) {
          this.sequenceIndex++;
          return;
        }
        this.sequenceIndex = 0, this.state = n12.InTagName, this.stateInTagName(d);
      }, p.prototype.stateInSpecialTag = function(d) {
        if (this.sequenceIndex === this.currentSequence.length) {
          if (d === r12.Gt || a(d)) {
            var b = this.index - this.currentSequence.length;
            if (this.sectionStart < b) {
              var z = this.index;
              this.index = b, this.cbs.ontext(this.sectionStart, b), this.index = z;
            }
            this.isSpecial = false, this.sectionStart = b + 2, this.stateInClosingTagName(d);
            return;
          }
          this.sequenceIndex = 0;
        }
        (d | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === l2.TitleEnd ? this.decodeEntities && d === r12.Amp && (this.state = n12.BeforeEntity) : this.fastForwardTo(r12.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(d === r12.Lt);
      }, p.prototype.stateCDATASequence = function(d) {
        d === l2.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === l2.Cdata.length && (this.state = n12.InCommentLike, this.currentSequence = l2.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = n12.InDeclaration, this.stateInDeclaration(d));
      }, p.prototype.fastForwardTo = function(d) {
        for (; ++this.index < this.buffer.length + this.offset; )
          if (this.buffer.charCodeAt(this.index - this.offset) === d)
            return true;
        return this.index = this.buffer.length + this.offset - 1, false;
      }, p.prototype.stateInCommentLike = function(d) {
        d === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === l2.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = n12.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : d !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
      }, p.prototype.isTagStartChar = function(d) {
        return this.xmlMode ? !o(d) : u(d);
      }, p.prototype.startSpecial = function(d, b) {
        this.isSpecial = true, this.currentSequence = d, this.sequenceIndex = b, this.state = n12.SpecialStartSequence;
      }, p.prototype.stateBeforeTagName = function(d) {
        if (d === r12.ExclamationMark)
          this.state = n12.BeforeDeclaration, this.sectionStart = this.index + 1;
        else if (d === r12.Questionmark)
          this.state = n12.InProcessingInstruction, this.sectionStart = this.index + 1;
        else if (this.isTagStartChar(d)) {
          var b = d | 32;
          this.sectionStart = this.index, !this.xmlMode && b === l2.TitleEnd[2] ? this.startSpecial(l2.TitleEnd, 3) : this.state = !this.xmlMode && b === l2.ScriptEnd[2] ? n12.BeforeSpecialS : n12.InTagName;
        } else
          d === r12.Slash ? this.state = n12.BeforeClosingTagName : (this.state = n12.Text, this.stateText(d));
      }, p.prototype.stateInTagName = function(d) {
        o(d) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = n12.BeforeAttributeName, this.stateBeforeAttributeName(d));
      }, p.prototype.stateBeforeClosingTagName = function(d) {
        a(d) || (d === r12.Gt ? this.state = n12.Text : (this.state = this.isTagStartChar(d) ? n12.InClosingTagName : n12.InSpecialComment, this.sectionStart = this.index));
      }, p.prototype.stateInClosingTagName = function(d) {
        (d === r12.Gt || a(d)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = n12.AfterClosingTagName, this.stateAfterClosingTagName(d));
      }, p.prototype.stateAfterClosingTagName = function(d) {
        (d === r12.Gt || this.fastForwardTo(r12.Gt)) && (this.state = n12.Text, this.baseState = n12.Text, this.sectionStart = this.index + 1);
      }, p.prototype.stateBeforeAttributeName = function(d) {
        d === r12.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = n12.InSpecialTag, this.sequenceIndex = 0) : this.state = n12.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : d === r12.Slash ? this.state = n12.InSelfClosingTag : a(d) || (this.state = n12.InAttributeName, this.sectionStart = this.index);
      }, p.prototype.stateInSelfClosingTag = function(d) {
        d === r12.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = n12.Text, this.baseState = n12.Text, this.sectionStart = this.index + 1, this.isSpecial = false) : a(d) || (this.state = n12.BeforeAttributeName, this.stateBeforeAttributeName(d));
      }, p.prototype.stateInAttributeName = function(d) {
        (d === r12.Eq || o(d)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = n12.AfterAttributeName, this.stateAfterAttributeName(d));
      }, p.prototype.stateAfterAttributeName = function(d) {
        d === r12.Eq ? this.state = n12.BeforeAttributeValue : d === r12.Slash || d === r12.Gt ? (this.cbs.onattribend(c.NoValue, this.index), this.state = n12.BeforeAttributeName, this.stateBeforeAttributeName(d)) : a(d) || (this.cbs.onattribend(c.NoValue, this.index), this.state = n12.InAttributeName, this.sectionStart = this.index);
      }, p.prototype.stateBeforeAttributeValue = function(d) {
        d === r12.DoubleQuote ? (this.state = n12.InAttributeValueDq, this.sectionStart = this.index + 1) : d === r12.SingleQuote ? (this.state = n12.InAttributeValueSq, this.sectionStart = this.index + 1) : a(d) || (this.sectionStart = this.index, this.state = n12.InAttributeValueNq, this.stateInAttributeValueNoQuotes(d));
      }, p.prototype.handleInAttributeValue = function(d, b) {
        d === b || !this.decodeEntities && this.fastForwardTo(b) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(b === r12.DoubleQuote ? c.Double : c.Single, this.index), this.state = n12.BeforeAttributeName) : this.decodeEntities && d === r12.Amp && (this.baseState = this.state, this.state = n12.BeforeEntity);
      }, p.prototype.stateInAttributeValueDoubleQuotes = function(d) {
        this.handleInAttributeValue(d, r12.DoubleQuote);
      }, p.prototype.stateInAttributeValueSingleQuotes = function(d) {
        this.handleInAttributeValue(d, r12.SingleQuote);
      }, p.prototype.stateInAttributeValueNoQuotes = function(d) {
        a(d) || d === r12.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(c.Unquoted, this.index), this.state = n12.BeforeAttributeName, this.stateBeforeAttributeName(d)) : this.decodeEntities && d === r12.Amp && (this.baseState = this.state, this.state = n12.BeforeEntity);
      }, p.prototype.stateBeforeDeclaration = function(d) {
        d === r12.OpeningSquareBracket ? (this.state = n12.CDATASequence, this.sequenceIndex = 0) : this.state = d === r12.Dash ? n12.BeforeComment : n12.InDeclaration;
      }, p.prototype.stateInDeclaration = function(d) {
        (d === r12.Gt || this.fastForwardTo(r12.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = n12.Text, this.sectionStart = this.index + 1);
      }, p.prototype.stateInProcessingInstruction = function(d) {
        (d === r12.Gt || this.fastForwardTo(r12.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = n12.Text, this.sectionStart = this.index + 1);
      }, p.prototype.stateBeforeComment = function(d) {
        d === r12.Dash ? (this.state = n12.InCommentLike, this.currentSequence = l2.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = n12.InDeclaration;
      }, p.prototype.stateInSpecialComment = function(d) {
        (d === r12.Gt || this.fastForwardTo(r12.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = n12.Text, this.sectionStart = this.index + 1);
      }, p.prototype.stateBeforeSpecialS = function(d) {
        var b = d | 32;
        b === l2.ScriptEnd[3] ? this.startSpecial(l2.ScriptEnd, 4) : b === l2.StyleEnd[3] ? this.startSpecial(l2.StyleEnd, 4) : (this.state = n12.InTagName, this.stateInTagName(d));
      }, p.prototype.stateBeforeEntity = function(d) {
        this.entityExcess = 1, this.entityResult = 0, d === r12.Number ? this.state = n12.BeforeNumericEntity : d === r12.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = n12.InNamedEntity, this.stateInNamedEntity(d));
      }, p.prototype.stateInNamedEntity = function(d) {
        if (this.entityExcess += 1, this.trieIndex = (0, e.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, d), this.trieIndex < 0) {
          this.emitNamedEntity(), this.index--;
          return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var b = this.trieCurrent & e.BinTrieFlags.VALUE_LENGTH;
        if (b) {
          var z = (b >> 14) - 1;
          if (!this.allowLegacyEntity() && d !== r12.Semi)
            this.trieIndex += z;
          else {
            var _ = this.index - this.entityExcess + 1;
            _ > this.sectionStart && this.emitPartial(this.sectionStart, _), this.entityResult = this.trieIndex, this.trieIndex += z, this.entityExcess = 0, this.sectionStart = this.index + 1, z === 0 && this.emitNamedEntity();
          }
        }
      }, p.prototype.emitNamedEntity = function() {
        if (this.state = this.baseState, this.entityResult !== 0) {
          var d = (this.entityTrie[this.entityResult] & e.BinTrieFlags.VALUE_LENGTH) >> 14;
          switch (d) {
            case 1: {
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~e.BinTrieFlags.VALUE_LENGTH);
              break;
            }
            case 2: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            }
            case 3:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        }
      }, p.prototype.stateBeforeNumericEntity = function(d) {
        (d | 32) === r12.LowerX ? (this.entityExcess++, this.state = n12.InHexEntity) : (this.state = n12.InNumericEntity, this.stateInNumericEntity(d));
      }, p.prototype.emitNumericEntity = function(d) {
        var b = this.index - this.entityExcess - 1, z = b + 2 + +(this.state === n12.InHexEntity);
        z !== this.index && (b > this.sectionStart && this.emitPartial(this.sectionStart, b), this.sectionStart = this.index + Number(d), this.emitCodePoint((0, e.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
      }, p.prototype.stateInNumericEntity = function(d) {
        d === r12.Semi ? this.emitNumericEntity(true) : i(d) ? (this.entityResult = this.entityResult * 10 + (d - r12.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(false) : this.state = this.baseState, this.index--);
      }, p.prototype.stateInHexEntity = function(d) {
        d === r12.Semi ? this.emitNumericEntity(true) : i(d) ? (this.entityResult = this.entityResult * 16 + (d - r12.Zero), this.entityExcess++) : s12(d) ? (this.entityResult = this.entityResult * 16 + ((d | 32) - r12.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(false) : this.state = this.baseState, this.index--);
      }, p.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === n12.Text || this.baseState === n12.InSpecialTag);
      }, p.prototype.cleanup = function() {
        this.running && this.sectionStart !== this.index && (this.state === n12.Text || this.state === n12.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === n12.InAttributeValueDq || this.state === n12.InAttributeValueSq || this.state === n12.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
      }, p.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
      }, p.prototype.parse = function() {
        for (; this.shouldContinue(); ) {
          var d = this.buffer.charCodeAt(this.index - this.offset);
          switch (this.state) {
            case n12.Text: {
              this.stateText(d);
              break;
            }
            case n12.SpecialStartSequence: {
              this.stateSpecialStartSequence(d);
              break;
            }
            case n12.InSpecialTag: {
              this.stateInSpecialTag(d);
              break;
            }
            case n12.CDATASequence: {
              this.stateCDATASequence(d);
              break;
            }
            case n12.InAttributeValueDq: {
              this.stateInAttributeValueDoubleQuotes(d);
              break;
            }
            case n12.InAttributeName: {
              this.stateInAttributeName(d);
              break;
            }
            case n12.InCommentLike: {
              this.stateInCommentLike(d);
              break;
            }
            case n12.InSpecialComment: {
              this.stateInSpecialComment(d);
              break;
            }
            case n12.BeforeAttributeName: {
              this.stateBeforeAttributeName(d);
              break;
            }
            case n12.InTagName: {
              this.stateInTagName(d);
              break;
            }
            case n12.InClosingTagName: {
              this.stateInClosingTagName(d);
              break;
            }
            case n12.BeforeTagName: {
              this.stateBeforeTagName(d);
              break;
            }
            case n12.AfterAttributeName: {
              this.stateAfterAttributeName(d);
              break;
            }
            case n12.InAttributeValueSq: {
              this.stateInAttributeValueSingleQuotes(d);
              break;
            }
            case n12.BeforeAttributeValue: {
              this.stateBeforeAttributeValue(d);
              break;
            }
            case n12.BeforeClosingTagName: {
              this.stateBeforeClosingTagName(d);
              break;
            }
            case n12.AfterClosingTagName: {
              this.stateAfterClosingTagName(d);
              break;
            }
            case n12.BeforeSpecialS: {
              this.stateBeforeSpecialS(d);
              break;
            }
            case n12.InAttributeValueNq: {
              this.stateInAttributeValueNoQuotes(d);
              break;
            }
            case n12.InSelfClosingTag: {
              this.stateInSelfClosingTag(d);
              break;
            }
            case n12.InDeclaration: {
              this.stateInDeclaration(d);
              break;
            }
            case n12.BeforeDeclaration: {
              this.stateBeforeDeclaration(d);
              break;
            }
            case n12.BeforeComment: {
              this.stateBeforeComment(d);
              break;
            }
            case n12.InProcessingInstruction: {
              this.stateInProcessingInstruction(d);
              break;
            }
            case n12.InNamedEntity: {
              this.stateInNamedEntity(d);
              break;
            }
            case n12.BeforeEntity: {
              this.stateBeforeEntity(d);
              break;
            }
            case n12.InHexEntity: {
              this.stateInHexEntity(d);
              break;
            }
            case n12.InNumericEntity: {
              this.stateInNumericEntity(d);
              break;
            }
            default:
              this.stateBeforeNumericEntity(d);
          }
          this.index++;
        }
        this.cleanup();
      }, p.prototype.finish = function() {
        this.state === n12.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
      }, p.prototype.handleTrailingData = function() {
        var d = this.buffer.length + this.offset;
        this.state === n12.InCommentLike ? this.currentSequence === l2.CdataEnd ? this.cbs.oncdata(this.sectionStart, d, 0) : this.cbs.oncomment(this.sectionStart, d, 0) : this.state === n12.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(false) : this.state === n12.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(false) : this.state === n12.InTagName || this.state === n12.BeforeAttributeName || this.state === n12.BeforeAttributeValue || this.state === n12.AfterAttributeName || this.state === n12.InAttributeName || this.state === n12.InAttributeValueSq || this.state === n12.InAttributeValueDq || this.state === n12.InAttributeValueNq || this.state === n12.InClosingTagName || this.cbs.ontext(this.sectionStart, d);
      }, p.prototype.emitPartial = function(d, b) {
        this.baseState !== n12.Text && this.baseState !== n12.InSpecialTag ? this.cbs.onattribdata(d, b) : this.cbs.ontext(d, b);
      }, p.prototype.emitCodePoint = function(d) {
        this.baseState !== n12.Text && this.baseState !== n12.InSpecialTag ? this.cbs.onattribentity(d) : this.cbs.ontextentity(d);
      }, p;
    })()
  );
  t16.default = f;
})(W0e);
var NZ0 = l0 && l0.__createBinding || (Object.create ? function(t16, e, r12, n12) {
  n12 === void 0 && (n12 = r12);
  var a = Object.getOwnPropertyDescriptor(e, r12);
  (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = { enumerable: true, get: function() {
    return e[r12];
  } }), Object.defineProperty(t16, n12, a);
} : function(t16, e, r12, n12) {
  n12 === void 0 && (n12 = r12), t16[n12] = e[r12];
}), wZ0 = l0 && l0.__setModuleDefault || (Object.create ? function(t16, e) {
  Object.defineProperty(t16, "default", { enumerable: true, value: e });
} : function(t16, e) {
  t16.default = e;
}), BZ0 = l0 && l0.__importStar || function(t16) {
  if (t16 && t16.__esModule)
    return t16;
  var e = {};
  if (t16 != null)
    for (var r12 in t16)
      r12 !== "default" && Object.prototype.hasOwnProperty.call(t16, r12) && NZ0(e, t16, r12);
  return wZ0(e, t16), e;
};
Object.defineProperty(Fs, "__esModule", { value: true });
Fs.Parser = void 0;
var hl = BZ0(W0e), Gke = Vs, $o = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), n1 = /* @__PURE__ */ new Set(["p"]), Yke = /* @__PURE__ */ new Set(["thead", "tbody"]), Jke = /* @__PURE__ */ new Set(["dd", "dt"]), Kke = /* @__PURE__ */ new Set(["rt", "rp"]), xZ0 = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", n1],
  ["h1", n1],
  ["h2", n1],
  ["h3", n1],
  ["h4", n1],
  ["h5", n1],
  ["h6", n1],
  ["select", $o],
  ["input", $o],
  ["output", $o],
  ["button", $o],
  ["datalist", $o],
  ["textarea", $o],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", Jke],
  ["dt", Jke],
  ["address", n1],
  ["article", n1],
  ["aside", n1],
  ["blockquote", n1],
  ["details", n1],
  ["div", n1],
  ["dl", n1],
  ["fieldset", n1],
  ["figcaption", n1],
  ["figure", n1],
  ["footer", n1],
  ["form", n1],
  ["header", n1],
  ["hr", n1],
  ["main", n1],
  ["nav", n1],
  ["ol", n1],
  ["pre", n1],
  ["section", n1],
  ["table", n1],
  ["ul", n1],
  ["rt", Kke],
  ["rp", Kke],
  ["tbody", Yke],
  ["tfoot", Yke]
]), UZ0 = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), Qke = /* @__PURE__ */ new Set(["math", "svg"]), Zke = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), kZ0 = /\s|\//, jZ0 = (
  /** @class */
  (function() {
    function t16(e, r12) {
      r12 === void 0 && (r12 = {});
      var n12, a, o, i, u;
      this.options = r12, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = false, this.cbs = e ?? {}, this.lowerCaseTagNames = (n12 = r12.lowerCaseTags) !== null && n12 !== void 0 ? n12 : !r12.xmlMode, this.lowerCaseAttributeNames = (a = r12.lowerCaseAttributeNames) !== null && a !== void 0 ? a : !r12.xmlMode, this.tokenizer = new ((o = r12.Tokenizer) !== null && o !== void 0 ? o : hl.default)(this.options, this), (u = (i = this.cbs).onparserinit) === null || u === void 0 || u.call(i, this);
    }
    return t16.prototype.ontext = function(e, r12) {
      var n12, a, o = this.getSlice(e, r12);
      this.endIndex = r12 - 1, (a = (n12 = this.cbs).ontext) === null || a === void 0 || a.call(n12, o), this.startIndex = r12;
    }, t16.prototype.ontextentity = function(e) {
      var r12, n12, a = this.tokenizer.getSectionStart();
      this.endIndex = a - 1, (n12 = (r12 = this.cbs).ontext) === null || n12 === void 0 || n12.call(r12, (0, Gke.fromCodePoint)(e)), this.startIndex = a;
    }, t16.prototype.isVoidElement = function(e) {
      return !this.options.xmlMode && UZ0.has(e);
    }, t16.prototype.onopentagname = function(e, r12) {
      this.endIndex = r12;
      var n12 = this.getSlice(e, r12);
      this.lowerCaseTagNames && (n12 = n12.toLowerCase()), this.emitOpenTag(n12);
    }, t16.prototype.emitOpenTag = function(e) {
      var r12, n12, a, o;
      this.openTagStart = this.startIndex, this.tagname = e;
      var i = !this.options.xmlMode && xZ0.get(e);
      if (i)
        for (; this.stack.length > 0 && i.has(this.stack[this.stack.length - 1]); ) {
          var u = this.stack.pop();
          (n12 = (r12 = this.cbs).onclosetag) === null || n12 === void 0 || n12.call(r12, u, true);
        }
      this.isVoidElement(e) || (this.stack.push(e), Qke.has(e) ? this.foreignContext.push(true) : Zke.has(e) && this.foreignContext.push(false)), (o = (a = this.cbs).onopentagname) === null || o === void 0 || o.call(a, e), this.cbs.onopentag && (this.attribs = {});
    }, t16.prototype.endOpenTag = function(e) {
      var r12, n12;
      this.startIndex = this.openTagStart, this.attribs && ((n12 = (r12 = this.cbs).onopentag) === null || n12 === void 0 || n12.call(r12, this.tagname, this.attribs, e), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, true), this.tagname = "";
    }, t16.prototype.onopentagend = function(e) {
      this.endIndex = e, this.endOpenTag(false), this.startIndex = e + 1;
    }, t16.prototype.onclosetag = function(e, r12) {
      var n12, a, o, i, u, s12;
      this.endIndex = r12;
      var c = this.getSlice(e, r12);
      if (this.lowerCaseTagNames && (c = c.toLowerCase()), (Qke.has(c) || Zke.has(c)) && this.foreignContext.pop(), this.isVoidElement(c))
        !this.options.xmlMode && c === "br" && ((a = (n12 = this.cbs).onopentagname) === null || a === void 0 || a.call(n12, "br"), (i = (o = this.cbs).onopentag) === null || i === void 0 || i.call(o, "br", {}, true), (s12 = (u = this.cbs).onclosetag) === null || s12 === void 0 || s12.call(u, "br", false));
      else {
        var l2 = this.stack.lastIndexOf(c);
        if (l2 !== -1)
          if (this.cbs.onclosetag)
            for (var f = this.stack.length - l2; f--; )
              this.cbs.onclosetag(this.stack.pop(), f !== 0);
          else
            this.stack.length = l2;
        else
          !this.options.xmlMode && c === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(true));
      }
      this.startIndex = r12 + 1;
    }, t16.prototype.onselfclosingtag = function(e) {
      this.endIndex = e, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(false), this.startIndex = e + 1) : this.onopentagend(e);
    }, t16.prototype.closeCurrentTag = function(e) {
      var r12, n12, a = this.tagname;
      this.endOpenTag(e), this.stack[this.stack.length - 1] === a && ((n12 = (r12 = this.cbs).onclosetag) === null || n12 === void 0 || n12.call(r12, a, !e), this.stack.pop());
    }, t16.prototype.onattribname = function(e, r12) {
      this.startIndex = e;
      var n12 = this.getSlice(e, r12);
      this.attribname = this.lowerCaseAttributeNames ? n12.toLowerCase() : n12;
    }, t16.prototype.onattribdata = function(e, r12) {
      this.attribvalue += this.getSlice(e, r12);
    }, t16.prototype.onattribentity = function(e) {
      this.attribvalue += (0, Gke.fromCodePoint)(e);
    }, t16.prototype.onattribend = function(e, r12) {
      var n12, a;
      this.endIndex = r12, (a = (n12 = this.cbs).onattribute) === null || a === void 0 || a.call(n12, this.attribname, this.attribvalue, e === hl.QuoteType.Double ? '"' : e === hl.QuoteType.Single ? "'" : e === hl.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
    }, t16.prototype.getInstructionName = function(e) {
      var r12 = e.search(kZ0), n12 = r12 < 0 ? e : e.substr(0, r12);
      return this.lowerCaseTagNames && (n12 = n12.toLowerCase()), n12;
    }, t16.prototype.ondeclaration = function(e, r12) {
      this.endIndex = r12;
      var n12 = this.getSlice(e, r12);
      if (this.cbs.onprocessinginstruction) {
        var a = this.getInstructionName(n12);
        this.cbs.onprocessinginstruction("!".concat(a), "!".concat(n12));
      }
      this.startIndex = r12 + 1;
    }, t16.prototype.onprocessinginstruction = function(e, r12) {
      this.endIndex = r12;
      var n12 = this.getSlice(e, r12);
      if (this.cbs.onprocessinginstruction) {
        var a = this.getInstructionName(n12);
        this.cbs.onprocessinginstruction("?".concat(a), "?".concat(n12));
      }
      this.startIndex = r12 + 1;
    }, t16.prototype.oncomment = function(e, r12, n12) {
      var a, o, i, u;
      this.endIndex = r12, (o = (a = this.cbs).oncomment) === null || o === void 0 || o.call(a, this.getSlice(e, r12 - n12)), (u = (i = this.cbs).oncommentend) === null || u === void 0 || u.call(i), this.startIndex = r12 + 1;
    }, t16.prototype.oncdata = function(e, r12, n12) {
      var a, o, i, u, s12, c, l2, f, p, d;
      this.endIndex = r12;
      var b = this.getSlice(e, r12 - n12);
      this.options.xmlMode || this.options.recognizeCDATA ? ((o = (a = this.cbs).oncdatastart) === null || o === void 0 || o.call(a), (u = (i = this.cbs).ontext) === null || u === void 0 || u.call(i, b), (c = (s12 = this.cbs).oncdataend) === null || c === void 0 || c.call(s12)) : ((f = (l2 = this.cbs).oncomment) === null || f === void 0 || f.call(l2, "[CDATA[".concat(b, "]]")), (d = (p = this.cbs).oncommentend) === null || d === void 0 || d.call(p)), this.startIndex = r12 + 1;
    }, t16.prototype.onend = function() {
      var e, r12;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var n12 = this.stack.length; n12 > 0; this.cbs.onclosetag(this.stack[--n12], true))
          ;
      }
      (r12 = (e = this.cbs).onend) === null || r12 === void 0 || r12.call(e);
    }, t16.prototype.reset = function() {
      var e, r12, n12, a;
      (r12 = (e = this.cbs).onreset) === null || r12 === void 0 || r12.call(e), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (a = (n12 = this.cbs).onparserinit) === null || a === void 0 || a.call(n12, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = false;
    }, t16.prototype.parseComplete = function(e) {
      this.reset(), this.end(e);
    }, t16.prototype.getSlice = function(e, r12) {
      for (; e - this.bufferOffset >= this.buffers[0].length; )
        this.shiftBuffer();
      for (var n12 = this.buffers[0].slice(e - this.bufferOffset, r12 - this.bufferOffset); r12 - this.bufferOffset > this.buffers[0].length; )
        this.shiftBuffer(), n12 += this.buffers[0].slice(0, r12 - this.bufferOffset);
      return n12;
    }, t16.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
    }, t16.prototype.write = function(e) {
      var r12, n12;
      if (this.ended) {
        (n12 = (r12 = this.cbs).onerror) === null || n12 === void 0 || n12.call(r12, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(e), this.tokenizer.running && (this.tokenizer.write(e), this.writeIndex++);
    }, t16.prototype.end = function(e) {
      var r12, n12;
      if (this.ended) {
        (n12 = (r12 = this.cbs).onerror) === null || n12 === void 0 || n12.call(r12, new Error(".end() after done!"));
        return;
      }
      e && this.write(e), this.ended = true, this.tokenizer.end();
    }, t16.prototype.pause = function() {
      this.tokenizer.pause();
    }, t16.prototype.resume = function() {
      for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      this.ended && this.tokenizer.end();
    }, t16.prototype.parseChunk = function(e) {
      this.write(e);
    }, t16.prototype.done = function(e) {
      this.end(e);
    }, t16;
  })()
);
Fs.Parser = jZ0;
var ia = {}, Hi = {};
(function(t16) {
  Object.defineProperty(t16, "__esModule", { value: true }), t16.Doctype = t16.CDATA = t16.Tag = t16.Style = t16.Script = t16.Comment = t16.Directive = t16.Text = t16.Root = t16.isTag = t16.ElementType = void 0;
  var e;
  (function(n12) {
    n12.Root = "root", n12.Text = "text", n12.Directive = "directive", n12.Comment = "comment", n12.Script = "script", n12.Style = "style", n12.Tag = "tag", n12.CDATA = "cdata", n12.Doctype = "doctype";
  })(e = t16.ElementType || (t16.ElementType = {}));
  function r12(n12) {
    return n12.type === e.Tag || n12.type === e.Script || n12.type === e.Style;
  }
  t16.isTag = r12, t16.Root = e.Root, t16.Text = e.Text, t16.Directive = e.Directive, t16.Comment = e.Comment, t16.Script = e.Script, t16.Style = e.Style, t16.Tag = e.Tag, t16.CDATA = e.CDATA, t16.Doctype = e.Doctype;
})(Hi);
var B0 = {}, Ha = l0 && l0.__extends || /* @__PURE__ */ (function() {
  var t16 = function(e, r12) {
    return t16 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n12, a) {
      n12.__proto__ = a;
    } || function(n12, a) {
      for (var o in a)
        Object.prototype.hasOwnProperty.call(a, o) && (n12[o] = a[o]);
    }, t16(e, r12);
  };
  return function(e, r12) {
    if (typeof r12 != "function" && r12 !== null)
      throw new TypeError("Class extends value " + String(r12) + " is not a constructor or null");
    t16(e, r12);
    function n12() {
      this.constructor = e;
    }
    e.prototype = r12 === null ? Object.create(r12) : (n12.prototype = r12.prototype, new n12());
  };
})(), zs = l0 && l0.__assign || function() {
  return zs = Object.assign || function(t16) {
    for (var e, r12 = 1, n12 = arguments.length; r12 < n12; r12++) {
      e = arguments[r12];
      for (var a in e)
        Object.prototype.hasOwnProperty.call(e, a) && (t16[a] = e[a]);
    }
    return t16;
  }, zs.apply(this, arguments);
};
Object.defineProperty(B0, "__esModule", { value: true });
B0.cloneNode = B0.hasChildren = B0.isDocument = B0.isDirective = B0.isComment = B0.isText = B0.isCDATA = B0.isTag = B0.Element = B0.Document = B0.CDATA = B0.NodeWithChildren = B0.ProcessingInstruction = B0.Comment = B0.Text = B0.DataNode = B0.Node = void 0;
var Yt = Hi, B0e = (
  /** @class */
  (function() {
    function t16() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(t16.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(e) {
        this.parent = e;
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t16.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(e) {
        this.prev = e;
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t16.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(e) {
        this.next = e;
      },
      enumerable: false,
      configurable: true
    }), t16.prototype.cloneNode = function(e) {
      return e === void 0 && (e = false), x0e(this, e);
    }, t16;
  })()
);
B0.Node = B0e;
var Up = (
  /** @class */
  (function(t16) {
    Ha(e, t16);
    function e(r12) {
      var n12 = t16.call(this) || this;
      return n12.data = r12, n12;
    }
    return Object.defineProperty(e.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(r12) {
        this.data = r12;
      },
      enumerable: false,
      configurable: true
    }), e;
  })(B0e)
);
B0.DataNode = Up;
var qGe = (
  /** @class */
  (function(t16) {
    Ha(e, t16);
    function e() {
      var r12 = t16 !== null && t16.apply(this, arguments) || this;
      return r12.type = Yt.ElementType.Text, r12;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: false,
      configurable: true
    }), e;
  })(Up)
);
B0.Text = qGe;
var TGe = (
  /** @class */
  (function(t16) {
    Ha(e, t16);
    function e() {
      var r12 = t16 !== null && t16.apply(this, arguments) || this;
      return r12.type = Yt.ElementType.Comment, r12;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: false,
      configurable: true
    }), e;
  })(Up)
);
B0.Comment = TGe;
var yGe = (
  /** @class */
  (function(t16) {
    Ha(e, t16);
    function e(r12, n12) {
      var a = t16.call(this, n12) || this;
      return a.name = r12, a.type = Yt.ElementType.Directive, a;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: false,
      configurable: true
    }), e;
  })(Up)
);
B0.ProcessingInstruction = yGe;
var kp = (
  /** @class */
  (function(t16) {
    Ha(e, t16);
    function e(r12) {
      var n12 = t16.call(this) || this;
      return n12.children = r12, n12;
    }
    return Object.defineProperty(e.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var r12;
        return (r12 = this.children[0]) !== null && r12 !== void 0 ? r12 : null;
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(e.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(e.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(r12) {
        this.children = r12;
      },
      enumerable: false,
      configurable: true
    }), e;
  })(B0e)
);
B0.NodeWithChildren = kp;
var SGe = (
  /** @class */
  (function(t16) {
    Ha(e, t16);
    function e() {
      var r12 = t16 !== null && t16.apply(this, arguments) || this;
      return r12.type = Yt.ElementType.CDATA, r12;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: false,
      configurable: true
    }), e;
  })(kp)
);
B0.CDATA = SGe;
var CGe = (
  /** @class */
  (function(t16) {
    Ha(e, t16);
    function e() {
      var r12 = t16 !== null && t16.apply(this, arguments) || this;
      return r12.type = Yt.ElementType.Root, r12;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: false,
      configurable: true
    }), e;
  })(kp)
);
B0.Document = CGe;
var gGe = (
  /** @class */
  (function(t16) {
    Ha(e, t16);
    function e(r12, n12, a, o) {
      a === void 0 && (a = []), o === void 0 && (o = r12 === "script" ? Yt.ElementType.Script : r12 === "style" ? Yt.ElementType.Style : Yt.ElementType.Tag);
      var i = t16.call(this, a) || this;
      return i.name = r12, i.attribs = n12, i.type = o, i;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(e.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(r12) {
        this.name = r12;
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var r12 = this;
        return Object.keys(this.attribs).map(function(n12) {
          var a, o;
          return {
            name: n12,
            value: r12.attribs[n12],
            namespace: (a = r12["x-attribsNamespace"]) === null || a === void 0 ? void 0 : a[n12],
            prefix: (o = r12["x-attribsPrefix"]) === null || o === void 0 ? void 0 : o[n12]
          };
        });
      },
      enumerable: false,
      configurable: true
    }), e;
  })(kp)
);
B0.Element = gGe;
function IGe(t16) {
  return (0, Yt.isTag)(t16);
}
B0.isTag = IGe;
function EGe(t16) {
  return t16.type === Yt.ElementType.CDATA;
}
B0.isCDATA = EGe;
function LGe(t16) {
  return t16.type === Yt.ElementType.Text;
}
B0.isText = LGe;
function PGe(t16) {
  return t16.type === Yt.ElementType.Comment;
}
B0.isComment = PGe;
function DGe(t16) {
  return t16.type === Yt.ElementType.Directive;
}
B0.isDirective = DGe;
function WGe(t16) {
  return t16.type === Yt.ElementType.Root;
}
B0.isDocument = WGe;
function FZ0(t16) {
  return Object.prototype.hasOwnProperty.call(t16, "children");
}
B0.hasChildren = FZ0;
function x0e(t16, e) {
  e === void 0 && (e = false);
  var r12;
  if (LGe(t16))
    r12 = new qGe(t16.data);
  else if (PGe(t16))
    r12 = new TGe(t16.data);
  else if (IGe(t16)) {
    var n12 = e ? oQ(t16.children) : [], a = new gGe(t16.name, zs({}, t16.attribs), n12);
    n12.forEach(function(s12) {
      return s12.parent = a;
    }), t16.namespace != null && (a.namespace = t16.namespace), t16["x-attribsNamespace"] && (a["x-attribsNamespace"] = zs({}, t16["x-attribsNamespace"])), t16["x-attribsPrefix"] && (a["x-attribsPrefix"] = zs({}, t16["x-attribsPrefix"])), r12 = a;
  } else if (EGe(t16)) {
    var n12 = e ? oQ(t16.children) : [], o = new SGe(n12);
    n12.forEach(function(c) {
      return c.parent = o;
    }), r12 = o;
  } else if (WGe(t16)) {
    var n12 = e ? oQ(t16.children) : [], i = new CGe(n12);
    n12.forEach(function(c) {
      return c.parent = i;
    }), t16["x-mode"] && (i["x-mode"] = t16["x-mode"]), r12 = i;
  } else if (DGe(t16)) {
    var u = new yGe(t16.name, t16.data);
    t16["x-name"] != null && (u["x-name"] = t16["x-name"], u["x-publicId"] = t16["x-publicId"], u["x-systemId"] = t16["x-systemId"]), r12 = u;
  } else
    throw new Error("Not implemented yet: ".concat(t16.type));
  return r12.startIndex = t16.startIndex, r12.endIndex = t16.endIndex, t16.sourceCodeLocation != null && (r12.sourceCodeLocation = t16.sourceCodeLocation), r12;
}
B0.cloneNode = x0e;
function oQ(t16) {
  for (var e = t16.map(function(n12) {
    return x0e(n12, true);
  }), r12 = 1; r12 < e.length; r12++)
    e[r12].prev = e[r12 - 1], e[r12 - 1].next = e[r12];
  return e;
}
(function(t16) {
  var e = l0 && l0.__createBinding || (Object.create ? function(u, s12, c, l2) {
    l2 === void 0 && (l2 = c);
    var f = Object.getOwnPropertyDescriptor(s12, c);
    (!f || ("get" in f ? !s12.__esModule : f.writable || f.configurable)) && (f = { enumerable: true, get: function() {
      return s12[c];
    } }), Object.defineProperty(u, l2, f);
  } : function(u, s12, c, l2) {
    l2 === void 0 && (l2 = c), u[l2] = s12[c];
  }), r12 = l0 && l0.__exportStar || function(u, s12) {
    for (var c in u)
      c !== "default" && !Object.prototype.hasOwnProperty.call(s12, c) && e(s12, u, c);
  };
  Object.defineProperty(t16, "__esModule", { value: true }), t16.DomHandler = void 0;
  var n12 = Hi, a = B0;
  r12(B0, t16);
  var o = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
  }, i = (
    /** @class */
    (function() {
      function u(s12, c, l2) {
        this.dom = [], this.root = new a.Document(this.dom), this.done = false, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof c == "function" && (l2 = c, c = o), typeof s12 == "object" && (c = s12, s12 = void 0), this.callback = s12 ?? null, this.options = c ?? o, this.elementCB = l2 ?? null;
      }
      return u.prototype.onparserinit = function(s12) {
        this.parser = s12;
      }, u.prototype.onreset = function() {
        this.dom = [], this.root = new a.Document(this.dom), this.done = false, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, u.prototype.onend = function() {
        this.done || (this.done = true, this.parser = null, this.handleCallback(null));
      }, u.prototype.onerror = function(s12) {
        this.handleCallback(s12);
      }, u.prototype.onclosetag = function() {
        this.lastNode = null;
        var s12 = this.tagStack.pop();
        this.options.withEndIndices && (s12.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(s12);
      }, u.prototype.onopentag = function(s12, c) {
        var l2 = this.options.xmlMode ? n12.ElementType.Tag : void 0, f = new a.Element(s12, c, void 0, l2);
        this.addNode(f), this.tagStack.push(f);
      }, u.prototype.ontext = function(s12) {
        var c = this.lastNode;
        if (c && c.type === n12.ElementType.Text)
          c.data += s12, this.options.withEndIndices && (c.endIndex = this.parser.endIndex);
        else {
          var l2 = new a.Text(s12);
          this.addNode(l2), this.lastNode = l2;
        }
      }, u.prototype.oncomment = function(s12) {
        if (this.lastNode && this.lastNode.type === n12.ElementType.Comment) {
          this.lastNode.data += s12;
          return;
        }
        var c = new a.Comment(s12);
        this.addNode(c), this.lastNode = c;
      }, u.prototype.oncommentend = function() {
        this.lastNode = null;
      }, u.prototype.oncdatastart = function() {
        var s12 = new a.Text(""), c = new a.CDATA([s12]);
        this.addNode(c), s12.parent = c, this.lastNode = s12;
      }, u.prototype.oncdataend = function() {
        this.lastNode = null;
      }, u.prototype.onprocessinginstruction = function(s12, c) {
        var l2 = new a.ProcessingInstruction(s12, c);
        this.addNode(l2);
      }, u.prototype.handleCallback = function(s12) {
        if (typeof this.callback == "function")
          this.callback(s12, this.dom);
        else if (s12)
          throw s12;
      }, u.prototype.addNode = function(s12) {
        var c = this.tagStack[this.tagStack.length - 1], l2 = c.children[c.children.length - 1];
        this.options.withStartIndices && (s12.startIndex = this.parser.startIndex), this.options.withEndIndices && (s12.endIndex = this.parser.endIndex), c.children.push(s12), l2 && (s12.prev = l2, l2.next = s12), s12.parent = c, this.lastNode = null;
      }, u;
    })()
  );
  t16.DomHandler = i, t16.default = i;
})(ia);
var e2 = {}, ar = {}, Sc = {}, NGe = {}, yo = {}, U0e = {};
Object.defineProperty(U0e, "__esModule", { value: true });
function vl(t16) {
  for (var e = 1; e < t16.length; e++)
    t16[e][0] += t16[e - 1][0] + 1;
  return t16;
}
U0e.default = new Map(/* @__PURE__ */ vl([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ vl([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ vl([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ vl([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var D2 = {};
(function(t16) {
  Object.defineProperty(t16, "__esModule", { value: true }), t16.escapeText = t16.escapeAttribute = t16.escapeUTF8 = t16.escape = t16.encodeXML = t16.getCodePoint = t16.xmlReplacer = void 0, t16.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var e = /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [39, "&apos;"],
    [60, "&lt;"],
    [62, "&gt;"]
  ]);
  t16.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? function(a, o) {
    return a.codePointAt(o);
  } : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    (function(a, o) {
      return (a.charCodeAt(o) & 64512) === 55296 ? (a.charCodeAt(o) - 55296) * 1024 + a.charCodeAt(o + 1) - 56320 + 65536 : a.charCodeAt(o);
    })
  );
  function r12(a) {
    for (var o = "", i = 0, u; (u = t16.xmlReplacer.exec(a)) !== null; ) {
      var s12 = u.index, c = a.charCodeAt(s12), l2 = e.get(c);
      l2 !== void 0 ? (o += a.substring(i, s12) + l2, i = s12 + 1) : (o += "".concat(a.substring(i, s12), "&#x").concat((0, t16.getCodePoint)(a, s12).toString(16), ";"), i = t16.xmlReplacer.lastIndex += +((c & 64512) === 55296));
    }
    return o + a.substr(i);
  }
  t16.encodeXML = r12, t16.escape = r12;
  function n12(a, o) {
    return function(u) {
      for (var s12, c = 0, l2 = ""; s12 = a.exec(u); )
        c !== s12.index && (l2 += u.substring(c, s12.index)), l2 += o.get(s12[0].charCodeAt(0)), c = s12.index + 1;
      return l2 + u.substring(c);
    };
  }
  t16.escapeUTF8 = n12(/[&<>'"]/g, e), t16.escapeAttribute = n12(/["&\u00A0]/g, /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [160, "&nbsp;"]
  ])), t16.escapeText = n12(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
    [38, "&amp;"],
    [60, "&lt;"],
    [62, "&gt;"],
    [160, "&nbsp;"]
  ]));
})(D2);
var VZ0 = l0 && l0.__importDefault || function(t16) {
  return t16 && t16.__esModule ? t16 : { default: t16 };
};
Object.defineProperty(yo, "__esModule", { value: true });
yo.encodeNonAsciiHTML = yo.encodeHTML = void 0;
var HZ0 = VZ0(U0e), wGe = D2, XZ0 = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $Z0(t16) {
  return BGe(XZ0, t16);
}
yo.encodeHTML = $Z0;
function GZ0(t16) {
  return BGe(wGe.xmlReplacer, t16);
}
yo.encodeNonAsciiHTML = GZ0;
function BGe(t16, e) {
  for (var r12 = "", n12 = 0, a; (a = t16.exec(e)) !== null; ) {
    var o = a.index;
    r12 += e.substring(n12, o);
    var i = e.charCodeAt(o), u = HZ0.default.get(i);
    if (typeof u == "object") {
      if (o + 1 < e.length) {
        var s12 = e.charCodeAt(o + 1), c = typeof u.n == "number" ? u.n === s12 ? u.o : void 0 : u.n.get(s12);
        if (c !== void 0) {
          r12 += c, n12 = t16.lastIndex += 1;
          continue;
        }
      }
      u = u.v;
    }
    if (u !== void 0)
      r12 += u, n12 = o + 1;
    else {
      var l2 = (0, wGe.getCodePoint)(e, o);
      r12 += "&#x".concat(l2.toString(16), ";"), n12 = t16.lastIndex += +(l2 !== i);
    }
  }
  return r12 + e.substr(n12);
}
(function(t16) {
  Object.defineProperty(t16, "__esModule", { value: true }), t16.decodeXMLStrict = t16.decodeHTML5Strict = t16.decodeHTML4Strict = t16.decodeHTML5 = t16.decodeHTML4 = t16.decodeHTMLAttribute = t16.decodeHTMLStrict = t16.decodeHTML = t16.decodeXML = t16.DecodingMode = t16.EntityDecoder = t16.encodeHTML5 = t16.encodeHTML4 = t16.encodeNonAsciiHTML = t16.encodeHTML = t16.escapeText = t16.escapeAttribute = t16.escapeUTF8 = t16.escape = t16.encodeXML = t16.encode = t16.decodeStrict = t16.decode = t16.EncodingMode = t16.EntityLevel = void 0;
  var e = Vs, r12 = yo, n12 = D2, a;
  (function(p) {
    p[p.XML = 0] = "XML", p[p.HTML = 1] = "HTML";
  })(a = t16.EntityLevel || (t16.EntityLevel = {}));
  var o;
  (function(p) {
    p[p.UTF8 = 0] = "UTF8", p[p.ASCII = 1] = "ASCII", p[p.Extensive = 2] = "Extensive", p[p.Attribute = 3] = "Attribute", p[p.Text = 4] = "Text";
  })(o = t16.EncodingMode || (t16.EncodingMode = {}));
  function i(p, d) {
    d === void 0 && (d = a.XML);
    var b = typeof d == "number" ? d : d.level;
    if (b === a.HTML) {
      var z = typeof d == "object" ? d.mode : void 0;
      return (0, e.decodeHTML)(p, z);
    }
    return (0, e.decodeXML)(p);
  }
  t16.decode = i;
  function u(p, d) {
    var b;
    d === void 0 && (d = a.XML);
    var z = typeof d == "number" ? { level: d } : d;
    return (b = z.mode) !== null && b !== void 0 || (z.mode = e.DecodingMode.Strict), i(p, z);
  }
  t16.decodeStrict = u;
  function s12(p, d) {
    d === void 0 && (d = a.XML);
    var b = typeof d == "number" ? { level: d } : d;
    return b.mode === o.UTF8 ? (0, n12.escapeUTF8)(p) : b.mode === o.Attribute ? (0, n12.escapeAttribute)(p) : b.mode === o.Text ? (0, n12.escapeText)(p) : b.level === a.HTML ? b.mode === o.ASCII ? (0, r12.encodeNonAsciiHTML)(p) : (0, r12.encodeHTML)(p) : (0, n12.encodeXML)(p);
  }
  t16.encode = s12;
  var c = D2;
  Object.defineProperty(t16, "encodeXML", { enumerable: true, get: function() {
    return c.encodeXML;
  } }), Object.defineProperty(t16, "escape", { enumerable: true, get: function() {
    return c.escape;
  } }), Object.defineProperty(t16, "escapeUTF8", { enumerable: true, get: function() {
    return c.escapeUTF8;
  } }), Object.defineProperty(t16, "escapeAttribute", { enumerable: true, get: function() {
    return c.escapeAttribute;
  } }), Object.defineProperty(t16, "escapeText", { enumerable: true, get: function() {
    return c.escapeText;
  } });
  var l2 = yo;
  Object.defineProperty(t16, "encodeHTML", { enumerable: true, get: function() {
    return l2.encodeHTML;
  } }), Object.defineProperty(t16, "encodeNonAsciiHTML", { enumerable: true, get: function() {
    return l2.encodeNonAsciiHTML;
  } }), Object.defineProperty(t16, "encodeHTML4", { enumerable: true, get: function() {
    return l2.encodeHTML;
  } }), Object.defineProperty(t16, "encodeHTML5", { enumerable: true, get: function() {
    return l2.encodeHTML;
  } });
  var f = Vs;
  Object.defineProperty(t16, "EntityDecoder", { enumerable: true, get: function() {
    return f.EntityDecoder;
  } }), Object.defineProperty(t16, "DecodingMode", { enumerable: true, get: function() {
    return f.DecodingMode;
  } }), Object.defineProperty(t16, "decodeXML", { enumerable: true, get: function() {
    return f.decodeXML;
  } }), Object.defineProperty(t16, "decodeHTML", { enumerable: true, get: function() {
    return f.decodeHTML;
  } }), Object.defineProperty(t16, "decodeHTMLStrict", { enumerable: true, get: function() {
    return f.decodeHTMLStrict;
  } }), Object.defineProperty(t16, "decodeHTMLAttribute", { enumerable: true, get: function() {
    return f.decodeHTMLAttribute;
  } }), Object.defineProperty(t16, "decodeHTML4", { enumerable: true, get: function() {
    return f.decodeHTML;
  } }), Object.defineProperty(t16, "decodeHTML5", { enumerable: true, get: function() {
    return f.decodeHTML;
  } }), Object.defineProperty(t16, "decodeHTML4Strict", { enumerable: true, get: function() {
    return f.decodeHTMLStrict;
  } }), Object.defineProperty(t16, "decodeHTML5Strict", { enumerable: true, get: function() {
    return f.decodeHTMLStrict;
  } }), Object.defineProperty(t16, "decodeXMLStrict", { enumerable: true, get: function() {
    return f.decodeXML;
  } });
})(NGe);
var vi = {};
Object.defineProperty(vi, "__esModule", { value: true });
vi.attributeNames = vi.elementNames = void 0;
vi.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(t16) {
  return [t16.toLowerCase(), t16];
}));
vi.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(t16) {
  return [t16.toLowerCase(), t16];
}));
var ai = l0 && l0.__assign || function() {
  return ai = Object.assign || function(t16) {
    for (var e, r12 = 1, n12 = arguments.length; r12 < n12; r12++) {
      e = arguments[r12];
      for (var a in e)
        Object.prototype.hasOwnProperty.call(e, a) && (t16[a] = e[a]);
    }
    return t16;
  }, ai.apply(this, arguments);
}, YZ0 = l0 && l0.__createBinding || (Object.create ? function(t16, e, r12, n12) {
  n12 === void 0 && (n12 = r12);
  var a = Object.getOwnPropertyDescriptor(e, r12);
  (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = { enumerable: true, get: function() {
    return e[r12];
  } }), Object.defineProperty(t16, n12, a);
} : function(t16, e, r12, n12) {
  n12 === void 0 && (n12 = r12), t16[n12] = e[r12];
}), JZ0 = l0 && l0.__setModuleDefault || (Object.create ? function(t16, e) {
  Object.defineProperty(t16, "default", { enumerable: true, value: e });
} : function(t16, e) {
  t16.default = e;
}), KZ0 = l0 && l0.__importStar || function(t16) {
  if (t16 && t16.__esModule)
    return t16;
  var e = {};
  if (t16 != null)
    for (var r12 in t16)
      r12 !== "default" && Object.prototype.hasOwnProperty.call(t16, r12) && YZ0(e, t16, r12);
  return JZ0(e, t16), e;
};
Object.defineProperty(Sc, "__esModule", { value: true });
Sc.render = void 0;
var Bn = KZ0(Hi), W2 = NGe, xGe = vi, QZ0 = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function ZZ0(t16) {
  return t16.replace(/"/g, "&quot;");
}
function ee1(t16, e) {
  var r12;
  if (t16) {
    var n12 = ((r12 = e.encodeEntities) !== null && r12 !== void 0 ? r12 : e.decodeEntities) === false ? ZZ0 : e.xmlMode || e.encodeEntities !== "utf8" ? W2.encodeXML : W2.escapeAttribute;
    return Object.keys(t16).map(function(a) {
      var o, i, u = (o = t16[a]) !== null && o !== void 0 ? o : "";
      return e.xmlMode === "foreign" && (a = (i = xGe.attributeNames.get(a)) !== null && i !== void 0 ? i : a), !e.emptyAttrs && !e.xmlMode && u === "" ? a : "".concat(a, '="').concat(n12(u), '"');
    }).join(" ");
  }
}
var eje = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function jp(t16, e) {
  e === void 0 && (e = {});
  for (var r12 = ("length" in t16) ? t16 : [t16], n12 = "", a = 0; a < r12.length; a++)
    n12 += te1(r12[a], e);
  return n12;
}
Sc.render = jp;
Sc.default = jp;
function te1(t16, e) {
  switch (t16.type) {
    case Bn.Root:
      return jp(t16.children, e);
    case Bn.Doctype:
    case Bn.Directive:
      return oe1(t16);
    case Bn.Comment:
      return se1(t16);
    case Bn.CDATA:
      return ue1(t16);
    case Bn.Script:
    case Bn.Style:
    case Bn.Tag:
      return ae1(t16, e);
    case Bn.Text:
      return ie1(t16, e);
  }
}
var re1 = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), ne1 = /* @__PURE__ */ new Set(["svg", "math"]);
function ae1(t16, e) {
  var r12;
  e.xmlMode === "foreign" && (t16.name = (r12 = xGe.elementNames.get(t16.name)) !== null && r12 !== void 0 ? r12 : t16.name, t16.parent && re1.has(t16.parent.name) && (e = ai(ai({}, e), { xmlMode: false }))), !e.xmlMode && ne1.has(t16.name) && (e = ai(ai({}, e), { xmlMode: "foreign" }));
  var n12 = "<".concat(t16.name), a = ee1(t16.attribs, e);
  return a && (n12 += " ".concat(a)), t16.children.length === 0 && (e.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    e.selfClosingTags !== false
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    e.selfClosingTags && eje.has(t16.name)
  )) ? (e.xmlMode || (n12 += " "), n12 += "/>") : (n12 += ">", t16.children.length > 0 && (n12 += jp(t16.children, e)), (e.xmlMode || !eje.has(t16.name)) && (n12 += "</".concat(t16.name, ">"))), n12;
}
function oe1(t16) {
  return "<".concat(t16.data, ">");
}
function ie1(t16, e) {
  var r12, n12 = t16.data || "";
  return ((r12 = e.encodeEntities) !== null && r12 !== void 0 ? r12 : e.decodeEntities) !== false && !(!e.xmlMode && t16.parent && QZ0.has(t16.parent.name)) && (n12 = e.xmlMode || e.encodeEntities !== "utf8" ? (0, W2.encodeXML)(n12) : (0, W2.escapeText)(n12)), n12;
}
function ue1(t16) {
  return "<![CDATA[".concat(t16.children[0].data, "]]>");
}
function se1(t16) {
  return "<!--".concat(t16.data, "-->");
}
var ce1 = l0 && l0.__importDefault || function(t16) {
  return t16 && t16.__esModule ? t16 : { default: t16 };
};
Object.defineProperty(ar, "__esModule", { value: true });
ar.innerText = ar.textContent = ar.getText = ar.getInnerHTML = ar.getOuterHTML = void 0;
var Mn = ia, le1 = ce1(Sc), pe1 = Hi;
function UGe(t16, e) {
  return (0, le1.default)(t16, e);
}
ar.getOuterHTML = UGe;
function de1(t16, e) {
  return (0, Mn.hasChildren)(t16) ? t16.children.map(function(r12) {
    return UGe(r12, e);
  }).join("") : "";
}
ar.getInnerHTML = de1;
function t22(t16) {
  return Array.isArray(t16) ? t16.map(t22).join("") : (0, Mn.isTag)(t16) ? t16.name === "br" ? `
` : t22(t16.children) : (0, Mn.isCDATA)(t16) ? t22(t16.children) : (0, Mn.isText)(t16) ? t16.data : "";
}
ar.getText = t22;
function gZ(t16) {
  return Array.isArray(t16) ? t16.map(gZ).join("") : (0, Mn.hasChildren)(t16) && !(0, Mn.isComment)(t16) ? gZ(t16.children) : (0, Mn.isText)(t16) ? t16.data : "";
}
ar.textContent = gZ;
function IZ(t16) {
  return Array.isArray(t16) ? t16.map(IZ).join("") : (0, Mn.hasChildren)(t16) && (t16.type === pe1.ElementType.Tag || (0, Mn.isCDATA)(t16)) ? IZ(t16.children) : (0, Mn.isText)(t16) ? t16.data : "";
}
ar.innerText = IZ;
var nt = {};
Object.defineProperty(nt, "__esModule", { value: true });
nt.prevElementSibling = nt.nextElementSibling = nt.getName = nt.hasAttrib = nt.getAttributeValue = nt.getSiblings = nt.getParent = nt.getChildren = void 0;
var k0e = ia;
function kGe(t16) {
  return (0, k0e.hasChildren)(t16) ? t16.children : [];
}
nt.getChildren = kGe;
function jGe(t16) {
  return t16.parent || null;
}
nt.getParent = jGe;
function fe1(t16) {
  var e, r12, n12 = jGe(t16);
  if (n12 != null)
    return kGe(n12);
  for (var a = [t16], o = t16.prev, i = t16.next; o != null; )
    a.unshift(o), e = o, o = e.prev;
  for (; i != null; )
    a.push(i), r12 = i, i = r12.next;
  return a;
}
nt.getSiblings = fe1;
function be1(t16, e) {
  var r12;
  return (r12 = t16.attribs) === null || r12 === void 0 ? void 0 : r12[e];
}
nt.getAttributeValue = be1;
function Me1(t16, e) {
  return t16.attribs != null && Object.prototype.hasOwnProperty.call(t16.attribs, e) && t16.attribs[e] != null;
}
nt.hasAttrib = Me1;
function Oe1(t16) {
  return t16.name;
}
nt.getName = Oe1;
function ze1(t16) {
  for (var e, r12 = t16.next; r12 !== null && !(0, k0e.isTag)(r12); )
    e = r12, r12 = e.next;
  return r12;
}
nt.nextElementSibling = ze1;
function Ae1(t16) {
  for (var e, r12 = t16.prev; r12 !== null && !(0, k0e.isTag)(r12); )
    e = r12, r12 = e.prev;
  return r12;
}
nt.prevElementSibling = Ae1;
var Xt = {};
Object.defineProperty(Xt, "__esModule", { value: true });
Xt.prepend = Xt.prependChild = Xt.append = Xt.appendChild = Xt.replaceElement = Xt.removeElement = void 0;
function Cc(t16) {
  if (t16.prev && (t16.prev.next = t16.next), t16.next && (t16.next.prev = t16.prev), t16.parent) {
    var e = t16.parent.children, r12 = e.lastIndexOf(t16);
    r12 >= 0 && e.splice(r12, 1);
  }
  t16.next = null, t16.prev = null, t16.parent = null;
}
Xt.removeElement = Cc;
function _e1(t16, e) {
  var r12 = e.prev = t16.prev;
  r12 && (r12.next = e);
  var n12 = e.next = t16.next;
  n12 && (n12.prev = e);
  var a = e.parent = t16.parent;
  if (a) {
    var o = a.children;
    o[o.lastIndexOf(t16)] = e, t16.parent = null;
  }
}
Xt.replaceElement = _e1;
function he1(t16, e) {
  if (Cc(e), e.next = null, e.parent = t16, t16.children.push(e) > 1) {
    var r12 = t16.children[t16.children.length - 2];
    r12.next = e, e.prev = r12;
  } else
    e.prev = null;
}
Xt.appendChild = he1;
function ve1(t16, e) {
  Cc(e);
  var r12 = t16.parent, n12 = t16.next;
  if (e.next = n12, e.prev = t16, t16.next = e, e.parent = r12, n12) {
    if (n12.prev = e, r12) {
      var a = r12.children;
      a.splice(a.lastIndexOf(n12), 0, e);
    }
  } else
    r12 && r12.children.push(e);
}
Xt.append = ve1;
function me1(t16, e) {
  if (Cc(e), e.parent = t16, e.prev = null, t16.children.unshift(e) !== 1) {
    var r12 = t16.children[1];
    r12.prev = e, e.next = r12;
  } else
    e.next = null;
}
Xt.prependChild = me1;
function Re1(t16, e) {
  Cc(e);
  var r12 = t16.parent;
  if (r12) {
    var n12 = r12.children;
    n12.splice(n12.indexOf(t16), 0, e);
  }
  t16.prev && (t16.prev.next = e), e.parent = r12, e.prev = t16.prev, e.next = t16, t16.prev = e;
}
Xt.prepend = Re1;
var Lt = {};
Object.defineProperty(Lt, "__esModule", { value: true });
Lt.findAll = Lt.existsOne = Lt.findOne = Lt.findOneChild = Lt.find = Lt.filter = void 0;
var Fp = ia;
function qe1(t16, e, r12, n12) {
  return r12 === void 0 && (r12 = true), n12 === void 0 && (n12 = 1 / 0), FGe(t16, Array.isArray(e) ? e : [e], r12, n12);
}
Lt.filter = qe1;
function FGe(t16, e, r12, n12) {
  for (var a = [], o = [e], i = [0]; ; ) {
    if (i[0] >= o[0].length) {
      if (i.length === 1)
        return a;
      o.shift(), i.shift();
      continue;
    }
    var u = o[0][i[0]++];
    if (t16(u) && (a.push(u), --n12 <= 0))
      return a;
    r12 && (0, Fp.hasChildren)(u) && u.children.length > 0 && (i.unshift(0), o.unshift(u.children));
  }
}
Lt.find = FGe;
function Te1(t16, e) {
  return e.find(t16);
}
Lt.findOneChild = Te1;
function VGe(t16, e, r12) {
  r12 === void 0 && (r12 = true);
  for (var n12 = null, a = 0; a < e.length && !n12; a++) {
    var o = e[a];
    if ((0, Fp.isTag)(o))
      t16(o) ? n12 = o : r12 && o.children.length > 0 && (n12 = VGe(t16, o.children, true));
    else
      continue;
  }
  return n12;
}
Lt.findOne = VGe;
function HGe(t16, e) {
  return e.some(function(r12) {
    return (0, Fp.isTag)(r12) && (t16(r12) || HGe(t16, r12.children));
  });
}
Lt.existsOne = HGe;
function ye1(t16, e) {
  for (var r12 = [], n12 = [e], a = [0]; ; ) {
    if (a[0] >= n12[0].length) {
      if (n12.length === 1)
        return r12;
      n12.shift(), a.shift();
      continue;
    }
    var o = n12[0][a[0]++];
    (0, Fp.isTag)(o) && (t16(o) && r12.push(o), o.children.length > 0 && (a.unshift(0), n12.unshift(o.children)));
  }
}
Lt.findAll = ye1;
var or = {};
Object.defineProperty(or, "__esModule", { value: true });
or.getElementsByTagType = or.getElementsByTagName = or.getElementById = or.getElements = or.testElement = void 0;
var co = ia, Vp = Lt, N2 = {
  tag_name: function(t16) {
    return typeof t16 == "function" ? function(e) {
      return (0, co.isTag)(e) && t16(e.name);
    } : t16 === "*" ? co.isTag : function(e) {
      return (0, co.isTag)(e) && e.name === t16;
    };
  },
  tag_type: function(t16) {
    return typeof t16 == "function" ? function(e) {
      return t16(e.type);
    } : function(e) {
      return e.type === t16;
    };
  },
  tag_contains: function(t16) {
    return typeof t16 == "function" ? function(e) {
      return (0, co.isText)(e) && t16(e.data);
    } : function(e) {
      return (0, co.isText)(e) && e.data === t16;
    };
  }
};
function XGe(t16, e) {
  return typeof e == "function" ? function(r12) {
    return (0, co.isTag)(r12) && e(r12.attribs[t16]);
  } : function(r12) {
    return (0, co.isTag)(r12) && r12.attribs[t16] === e;
  };
}
function Se1(t16, e) {
  return function(r12) {
    return t16(r12) || e(r12);
  };
}
function $Ge(t16) {
  var e = Object.keys(t16).map(function(r12) {
    var n12 = t16[r12];
    return Object.prototype.hasOwnProperty.call(N2, r12) ? N2[r12](n12) : XGe(r12, n12);
  });
  return e.length === 0 ? null : e.reduce(Se1);
}
function Ce1(t16, e) {
  var r12 = $Ge(t16);
  return r12 ? r12(e) : true;
}
or.testElement = Ce1;
function ge1(t16, e, r12, n12) {
  n12 === void 0 && (n12 = 1 / 0);
  var a = $Ge(t16);
  return a ? (0, Vp.filter)(a, e, r12, n12) : [];
}
or.getElements = ge1;
function Ie1(t16, e, r12) {
  return r12 === void 0 && (r12 = true), Array.isArray(e) || (e = [e]), (0, Vp.findOne)(XGe("id", t16), e, r12);
}
or.getElementById = Ie1;
function Ee1(t16, e, r12, n12) {
  return r12 === void 0 && (r12 = true), n12 === void 0 && (n12 = 1 / 0), (0, Vp.filter)(N2.tag_name(t16), e, r12, n12);
}
or.getElementsByTagName = Ee1;
function Le1(t16, e, r12, n12) {
  return r12 === void 0 && (r12 = true), n12 === void 0 && (n12 = 1 / 0), (0, Vp.filter)(N2.tag_type(t16), e, r12, n12);
}
or.getElementsByTagType = Le1;
var GGe = {};
(function(t16) {
  Object.defineProperty(t16, "__esModule", { value: true }), t16.uniqueSort = t16.compareDocumentPosition = t16.DocumentPosition = t16.removeSubsets = void 0;
  var e = ia;
  function r12(i) {
    for (var u = i.length; --u >= 0; ) {
      var s12 = i[u];
      if (u > 0 && i.lastIndexOf(s12, u - 1) >= 0) {
        i.splice(u, 1);
        continue;
      }
      for (var c = s12.parent; c; c = c.parent)
        if (i.includes(c)) {
          i.splice(u, 1);
          break;
        }
    }
    return i;
  }
  t16.removeSubsets = r12;
  var n12;
  (function(i) {
    i[i.DISCONNECTED = 1] = "DISCONNECTED", i[i.PRECEDING = 2] = "PRECEDING", i[i.FOLLOWING = 4] = "FOLLOWING", i[i.CONTAINS = 8] = "CONTAINS", i[i.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(n12 = t16.DocumentPosition || (t16.DocumentPosition = {}));
  function a(i, u) {
    var s12 = [], c = [];
    if (i === u)
      return 0;
    for (var l2 = (0, e.hasChildren)(i) ? i : i.parent; l2; )
      s12.unshift(l2), l2 = l2.parent;
    for (l2 = (0, e.hasChildren)(u) ? u : u.parent; l2; )
      c.unshift(l2), l2 = l2.parent;
    for (var f = Math.min(s12.length, c.length), p = 0; p < f && s12[p] === c[p]; )
      p++;
    if (p === 0)
      return n12.DISCONNECTED;
    var d = s12[p - 1], b = d.children, z = s12[p], _ = c[p];
    return b.indexOf(z) > b.indexOf(_) ? d === u ? n12.FOLLOWING | n12.CONTAINED_BY : n12.FOLLOWING : d === i ? n12.PRECEDING | n12.CONTAINS : n12.PRECEDING;
  }
  t16.compareDocumentPosition = a;
  function o(i) {
    return i = i.filter(function(u, s12, c) {
      return !c.includes(u, s12 + 1);
    }), i.sort(function(u, s12) {
      var c = a(u, s12);
      return c & n12.PRECEDING ? -1 : c & n12.FOLLOWING ? 1 : 0;
    }), i;
  }
  t16.uniqueSort = o;
})(GGe);
var Hp = {};
Object.defineProperty(Hp, "__esModule", { value: true });
Hp.getFeed = void 0;
var Pe1 = ar, gc = or;
function De1(t16) {
  var e = w2(xe1, t16);
  return e ? e.name === "feed" ? We1(e) : Ne1(e) : null;
}
Hp.getFeed = De1;
function We1(t16) {
  var e, r12 = t16.children, n12 = {
    type: "atom",
    items: (0, gc.getElementsByTagName)("entry", r12).map(function(i) {
      var u, s12 = i.children, c = { media: YGe(s12) };
      Ft(c, "id", "id", s12), Ft(c, "title", "title", s12);
      var l2 = (u = w2("link", s12)) === null || u === void 0 ? void 0 : u.attribs.href;
      l2 && (c.link = l2);
      var f = La("summary", s12) || La("content", s12);
      f && (c.description = f);
      var p = La("updated", s12);
      return p && (c.pubDate = new Date(p)), c;
    })
  };
  Ft(n12, "id", "id", r12), Ft(n12, "title", "title", r12);
  var a = (e = w2("link", r12)) === null || e === void 0 ? void 0 : e.attribs.href;
  a && (n12.link = a), Ft(n12, "description", "subtitle", r12);
  var o = La("updated", r12);
  return o && (n12.updated = new Date(o)), Ft(n12, "author", "email", r12, true), n12;
}
function Ne1(t16) {
  var e, r12, n12 = (r12 = (e = w2("channel", t16.children)) === null || e === void 0 ? void 0 : e.children) !== null && r12 !== void 0 ? r12 : [], a = {
    type: t16.name.substr(0, 3),
    id: "",
    items: (0, gc.getElementsByTagName)("item", t16.children).map(function(i) {
      var u = i.children, s12 = { media: YGe(u) };
      Ft(s12, "id", "guid", u), Ft(s12, "title", "title", u), Ft(s12, "link", "link", u), Ft(s12, "description", "description", u);
      var c = La("pubDate", u) || La("dc:date", u);
      return c && (s12.pubDate = new Date(c)), s12;
    })
  };
  Ft(a, "title", "title", n12), Ft(a, "link", "link", n12), Ft(a, "description", "description", n12);
  var o = La("lastBuildDate", n12);
  return o && (a.updated = new Date(o)), Ft(a, "author", "managingEditor", n12, true), a;
}
var we1 = ["url", "type", "lang"], Be1 = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function YGe(t16) {
  return (0, gc.getElementsByTagName)("media:content", t16).map(function(e) {
    for (var r12 = e.attribs, n12 = {
      medium: r12.medium,
      isDefault: !!r12.isDefault
    }, a = 0, o = we1; a < o.length; a++) {
      var i = o[a];
      r12[i] && (n12[i] = r12[i]);
    }
    for (var u = 0, s12 = Be1; u < s12.length; u++) {
      var i = s12[u];
      r12[i] && (n12[i] = parseInt(r12[i], 10));
    }
    return r12.expression && (n12.expression = r12.expression), n12;
  });
}
function w2(t16, e) {
  return (0, gc.getElementsByTagName)(t16, e, true, 1)[0];
}
function La(t16, e, r12) {
  return r12 === void 0 && (r12 = false), (0, Pe1.textContent)((0, gc.getElementsByTagName)(t16, e, r12, 1)).trim();
}
function Ft(t16, e, r12, n12, a) {
  a === void 0 && (a = false);
  var o = La(r12, n12, a);
  o && (t16[e] = o);
}
function xe1(t16) {
  return t16 === "rss" || t16 === "feed" || t16 === "rdf:RDF";
}
(function(t16) {
  var e = l0 && l0.__createBinding || (Object.create ? function(a, o, i, u) {
    u === void 0 && (u = i);
    var s12 = Object.getOwnPropertyDescriptor(o, i);
    (!s12 || ("get" in s12 ? !o.__esModule : s12.writable || s12.configurable)) && (s12 = { enumerable: true, get: function() {
      return o[i];
    } }), Object.defineProperty(a, u, s12);
  } : function(a, o, i, u) {
    u === void 0 && (u = i), a[u] = o[i];
  }), r12 = l0 && l0.__exportStar || function(a, o) {
    for (var i in a)
      i !== "default" && !Object.prototype.hasOwnProperty.call(o, i) && e(o, a, i);
  };
  Object.defineProperty(t16, "__esModule", { value: true }), t16.hasChildren = t16.isDocument = t16.isComment = t16.isText = t16.isCDATA = t16.isTag = void 0, r12(ar, t16), r12(nt, t16), r12(Xt, t16), r12(Lt, t16), r12(or, t16), r12(GGe, t16), r12(Hp, t16);
  var n12 = ia;
  Object.defineProperty(t16, "isTag", { enumerable: true, get: function() {
    return n12.isTag;
  } }), Object.defineProperty(t16, "isCDATA", { enumerable: true, get: function() {
    return n12.isCDATA;
  } }), Object.defineProperty(t16, "isText", { enumerable: true, get: function() {
    return n12.isText;
  } }), Object.defineProperty(t16, "isComment", { enumerable: true, get: function() {
    return n12.isComment;
  } }), Object.defineProperty(t16, "isDocument", { enumerable: true, get: function() {
    return n12.isDocument;
  } }), Object.defineProperty(t16, "hasChildren", { enumerable: true, get: function() {
    return n12.hasChildren;
  } });
})(e2);
(function(t16) {
  var e = l0 && l0.__createBinding || (Object.create ? function(q, S, N, v) {
    v === void 0 && (v = N);
    var C = Object.getOwnPropertyDescriptor(S, N);
    (!C || ("get" in C ? !S.__esModule : C.writable || C.configurable)) && (C = { enumerable: true, get: function() {
      return S[N];
    } }), Object.defineProperty(q, v, C);
  } : function(q, S, N, v) {
    v === void 0 && (v = N), q[v] = S[N];
  }), r12 = l0 && l0.__setModuleDefault || (Object.create ? function(q, S) {
    Object.defineProperty(q, "default", { enumerable: true, value: S });
  } : function(q, S) {
    q.default = S;
  }), n12 = l0 && l0.__importStar || function(q) {
    if (q && q.__esModule)
      return q;
    var S = {};
    if (q != null)
      for (var N in q)
        N !== "default" && Object.prototype.hasOwnProperty.call(q, N) && e(S, q, N);
    return r12(S, q), S;
  }, a = l0 && l0.__importDefault || function(q) {
    return q && q.__esModule ? q : { default: q };
  };
  Object.defineProperty(t16, "__esModule", { value: true }), t16.DomUtils = t16.parseFeed = t16.getFeed = t16.ElementType = t16.Tokenizer = t16.createDomStream = t16.parseDOM = t16.parseDocument = t16.DefaultHandler = t16.DomHandler = t16.Parser = void 0;
  var o = Fs, i = Fs;
  Object.defineProperty(t16, "Parser", { enumerable: true, get: function() {
    return i.Parser;
  } });
  var u = ia, s12 = ia;
  Object.defineProperty(t16, "DomHandler", { enumerable: true, get: function() {
    return s12.DomHandler;
  } }), Object.defineProperty(t16, "DefaultHandler", { enumerable: true, get: function() {
    return s12.DomHandler;
  } });
  function c(q, S) {
    var N = new u.DomHandler(void 0, S);
    return new o.Parser(N, S).end(q), N.root;
  }
  t16.parseDocument = c;
  function l2(q, S) {
    return c(q, S).children;
  }
  t16.parseDOM = l2;
  function f(q, S, N) {
    var v = new u.DomHandler(q, S, N);
    return new o.Parser(v, S);
  }
  t16.createDomStream = f;
  var p = W0e;
  Object.defineProperty(t16, "Tokenizer", { enumerable: true, get: function() {
    return a(p).default;
  } }), t16.ElementType = n12(Hi);
  var d = e2, b = e2;
  Object.defineProperty(t16, "getFeed", { enumerable: true, get: function() {
    return b.getFeed;
  } });
  var z = { xmlMode: true };
  function _(q, S) {
    return S === void 0 && (S = z), (0, d.getFeed)(l2(q, S));
  }
  t16.parseFeed = _, t16.DomUtils = n12(e2);
})(RGe);
var Ue1 = (t16) => {
  if (typeof t16 != "string")
    throw new TypeError("Expected a string");
  return t16.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}, j0e = {};
Object.defineProperty(j0e, "__esModule", { value: true });
function tje(t16) {
  return Object.prototype.toString.call(t16) === "[object Object]";
}
function ke1(t16) {
  var e, r12;
  return tje(t16) === false ? false : (e = t16.constructor, e === void 0 ? true : (r12 = e.prototype, !(tje(r12) === false || r12.hasOwnProperty("isPrototypeOf") === false)));
}
j0e.isPlainObject = ke1;
var je1 = function(e) {
  return Fe1(e) && !Ve1(e);
};
function Fe1(t16) {
  return !!t16 && typeof t16 == "object";
}
function Ve1(t16) {
  var e = Object.prototype.toString.call(t16);
  return e === "[object RegExp]" || e === "[object Date]" || $e1(t16);
}
var He1 = typeof Symbol == "function" && Symbol.for, Xe1 = He1 ? /* @__PURE__ */ Symbol.for("react.element") : 60103;
function $e1(t16) {
  return t16.$$typeof === Xe1;
}
function Ge1(t16) {
  return Array.isArray(t16) ? [] : {};
}
function Hs(t16, e) {
  return e.clone !== false && e.isMergeableObject(t16) ? mi(Ge1(t16), t16, e) : t16;
}
function Ye1(t16, e, r12) {
  return t16.concat(e).map(function(n12) {
    return Hs(n12, r12);
  });
}
function Je1(t16, e) {
  if (!e.customMerge)
    return mi;
  var r12 = e.customMerge(t16);
  return typeof r12 == "function" ? r12 : mi;
}
function Ke1(t16) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t16).filter(function(e) {
    return Object.propertyIsEnumerable.call(t16, e);
  }) : [];
}
function rje(t16) {
  return Object.keys(t16).concat(Ke1(t16));
}
function JGe(t16, e) {
  try {
    return e in t16;
  } catch {
    return false;
  }
}
function Qe1(t16, e) {
  return JGe(t16, e) && !(Object.hasOwnProperty.call(t16, e) && Object.propertyIsEnumerable.call(t16, e));
}
function Ze1(t16, e, r12) {
  var n12 = {};
  return r12.isMergeableObject(t16) && rje(t16).forEach(function(a) {
    n12[a] = Hs(t16[a], r12);
  }), rje(e).forEach(function(a) {
    Qe1(t16, a) || (JGe(t16, a) && r12.isMergeableObject(e[a]) ? n12[a] = Je1(a, r12)(t16[a], e[a], r12) : n12[a] = Hs(e[a], r12));
  }), n12;
}
function mi(t16, e, r12) {
  r12 = r12 || {}, r12.arrayMerge = r12.arrayMerge || Ye1, r12.isMergeableObject = r12.isMergeableObject || je1, r12.cloneUnlessOtherwiseSpecified = Hs;
  var n12 = Array.isArray(e), a = Array.isArray(t16), o = n12 === a;
  return o ? n12 ? r12.arrayMerge(t16, e, r12) : Ze1(t16, e, r12) : Hs(e, r12);
}
mi.all = function(e, r12) {
  if (!Array.isArray(e))
    throw new Error("first argument should be an array");
  return e.reduce(function(n12, a) {
    return mi(n12, a, r12);
  }, {});
};
var e01 = mi, t01 = e01, KGe = { exports: {} };
(function(t16) {
  (function(e, r12) {
    t16.exports ? t16.exports = r12() : e.parseSrcset = r12();
  })(l0, function() {
    return function(e) {
      function r12(v) {
        return v === " " || // space
        v === "	" || // horizontal tab
        v === `
` || // new line
        v === "\f" || // form feed
        v === "\r";
      }
      function n12(v) {
        var C, L = v.exec(e.substring(_));
        if (L)
          return C = L[0], _ += C.length, C;
      }
      for (var a = e.length, o = /^[ \t\n\r\u000c]+/, i = /^[, \t\n\r\u000c]+/, u = /^[^ \t\n\r\u000c]+/, s12 = /[,]+$/, c = /^\d+$/, l2 = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, f, p, d, b, z, _ = 0, q = []; ; ) {
        if (n12(i), _ >= a)
          return q;
        f = n12(u), p = [], f.slice(-1) === "," ? (f = f.replace(s12, ""), N()) : S();
      }
      function S() {
        for (n12(o), d = "", b = "in descriptor"; ; ) {
          if (z = e.charAt(_), b === "in descriptor")
            if (r12(z))
              d && (p.push(d), d = "", b = "after descriptor");
            else if (z === ",") {
              _ += 1, d && p.push(d), N();
              return;
            } else if (z === "(")
              d = d + z, b = "in parens";
            else if (z === "") {
              d && p.push(d), N();
              return;
            } else
              d = d + z;
          else if (b === "in parens")
            if (z === ")")
              d = d + z, b = "in descriptor";
            else if (z === "") {
              p.push(d), N();
              return;
            } else
              d = d + z;
          else if (b === "after descriptor" && !r12(z))
            if (z === "") {
              N();
              return;
            } else
              b = "in descriptor", _ -= 1;
          _ += 1;
        }
      }
      function N() {
        var v = false, C, L, B, P12, j = {}, $, W, x, D, w;
        for (P12 = 0; P12 < p.length; P12++)
          $ = p[P12], W = $[$.length - 1], x = $.substring(0, $.length - 1), D = parseInt(x, 10), w = parseFloat(x), c.test(x) && W === "w" ? ((C || L) && (v = true), D === 0 ? v = true : C = D) : l2.test(x) && W === "x" ? ((C || L || B) && (v = true), w < 0 ? v = true : L = w) : c.test(x) && W === "h" ? ((B || L) && (v = true), D === 0 ? v = true : B = D) : v = true;
        v ? console && console.log && console.log("Invalid srcset descriptor found in '" + e + "' at '" + $ + "'.") : (j.url = f, C && (j.w = C), L && (j.d = L), B && (j.h = B), q.push(j));
      }
    };
  });
})(KGe);
var r01 = KGe.exports, F0e = { exports: {} }, C0 = String, QGe = function() {
  return { isColorSupported: false, reset: C0, bold: C0, dim: C0, italic: C0, underline: C0, inverse: C0, hidden: C0, strikethrough: C0, black: C0, red: C0, green: C0, yellow: C0, blue: C0, magenta: C0, cyan: C0, white: C0, gray: C0, bgBlack: C0, bgRed: C0, bgGreen: C0, bgYellow: C0, bgBlue: C0, bgMagenta: C0, bgCyan: C0, bgWhite: C0, blackBright: C0, redBright: C0, greenBright: C0, yellowBright: C0, blueBright: C0, magentaBright: C0, cyanBright: C0, whiteBright: C0, bgBlackBright: C0, bgRedBright: C0, bgGreenBright: C0, bgYellowBright: C0, bgBlueBright: C0, bgMagentaBright: C0, bgCyanBright: C0, bgWhiteBright: C0 };
};
F0e.exports = QGe();
F0e.exports.createColors = QGe;
var n01 = F0e.exports;
const a01 = {}, o01 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: a01
}, Symbol.toStringTag, { value: "Module" })), on = /* @__PURE__ */ hp(o01);
let nje = n01, aje = on, EZ = class ZGe extends Error {
  constructor(e, r12, n12, a, o, i) {
    super(e), this.name = "CssSyntaxError", this.reason = e, o && (this.file = o), a && (this.source = a), i && (this.plugin = i), typeof r12 < "u" && typeof n12 < "u" && (typeof r12 == "number" ? (this.line = r12, this.column = n12) : (this.line = r12.line, this.column = r12.column, this.endLine = n12.line, this.endColumn = n12.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, ZGe);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(e) {
    if (!this.source)
      return "";
    let r12 = this.source;
    e == null && (e = nje.isColorSupported);
    let n12 = (l2) => l2, a = (l2) => l2, o = (l2) => l2;
    if (e) {
      let { bold: l2, gray: f, red: p } = nje.createColors(true);
      a = (d) => l2(p(d)), n12 = (d) => f(d), aje && (o = (d) => aje(d));
    }
    let i = r12.split(/\r?\n/), u = Math.max(this.line - 3, 0), s12 = Math.min(this.line + 2, i.length), c = String(s12).length;
    return i.slice(u, s12).map((l2, f) => {
      let p = u + 1 + f, d = " " + (" " + p).slice(-c) + " | ";
      if (p === this.line) {
        if (l2.length > 160) {
          let z = 20, _ = Math.max(0, this.column - z), q = Math.max(
            this.column + z,
            this.endColumn + z
          ), S = l2.slice(_, q), N = n12(d.replace(/\d/g, " ")) + l2.slice(0, Math.min(this.column - 1, z - 1)).replace(/[^\t]/g, " ");
          return a(">") + n12(d) + o(S) + `
 ` + N + a("^");
        }
        let b = n12(d.replace(/\d/g, " ")) + l2.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return a(">") + n12(d) + o(l2) + `
 ` + b + a("^");
      }
      return " " + n12(d) + o(l2);
    }).join(`
`);
  }
  toString() {
    let e = this.showSourceCode();
    return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
  }
};
var V0e = EZ;
EZ.default = EZ;
const i01 = /(<)(\/?style\b)/gi, u01 = /(<)(!--)/g;
function va(t16) {
  return typeof t16 != "string" || !t16.includes("<") ? t16 : t16.replace(i01, "\\3c $2").replace(u01, "\\3c $2");
}
const oje = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: false
};
function s01(t16) {
  return t16[0].toUpperCase() + t16.slice(1);
}
let LZ = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, r12) {
    let n12 = e.raws, a = "@" + e.name, o = e.params ? this.rawValue(e, "params") : "";
    if (typeof n12.afterName < "u" ? a += n12.afterName : o && (a += " "), e.nodes)
      this.block(e, a + o);
    else {
      let i = (n12.between || "") + (r12 ? ";" : "");
      this.builder(va(a + o + i), e);
    }
  }
  beforeAfter(e, r12) {
    let n12;
    e.type === "decl" ? n12 = this.raw(e, null, "beforeDecl") : e.type === "comment" ? n12 = this.raw(e, null, "beforeComment") : r12 === "before" ? n12 = this.raw(e, null, "beforeRule") : n12 = this.raw(e, null, "beforeClose");
    let a = e.parent, o = 0;
    for (; a && a.type !== "root"; )
      o += 1, a = a.parent;
    if (n12.includes(`
`)) {
      let i = this.raw(e, null, "indent");
      if (i.length)
        for (let u = 0; u < o; u++)
          n12 += i;
    }
    return n12;
  }
  block(e, r12) {
    let n12 = this.raw(e, "between", "beforeOpen");
    this.builder(va(r12 + n12) + "{", e, "start");
    let a;
    e.nodes && e.nodes.length ? (this.body(e), a = this.raw(e, "after")) : a = this.raw(e, "after", "emptyBody"), a && this.builder(va(a)), this.builder("}", e, "end");
  }
  body(e) {
    let r12 = e.nodes, n12 = r12.length - 1;
    for (; n12 > 0 && r12[n12].type === "comment"; )
      n12 -= 1;
    let a = this.raw(e, "semicolon"), o = e.type === "document";
    for (let i = 0; i < r12.length; i++) {
      let u = r12[i], s12 = this.raw(u, "before");
      s12 && this.builder(o ? s12 : va(s12)), this.stringify(u, n12 !== i || a);
    }
  }
  comment(e) {
    let r12 = this.raw(e, "left", "commentLeft"), n12 = this.raw(e, "right", "commentRight");
    this.builder(va("/*" + r12 + e.text + n12 + "*/"), e);
  }
  decl(e, r12) {
    let n12 = e.raws, a = this.raw(e, "between", "colon"), o = e.prop + a + this.rawValue(e, "value");
    e.important && (o += n12.important || " !important"), r12 && (o += ";"), this.builder(va(o), e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, r12, n12) {
    let a;
    if (n12 || (n12 = r12), r12 && (a = e.raws[r12], typeof a < "u"))
      return a;
    let o = e.parent;
    if (n12 === "before" && (!o || o.type === "root" && o.first === e || o && o.type === "document"))
      return "";
    if (!o)
      return oje[n12];
    let i = e.root(), u = i.rawCache || (i.rawCache = {});
    if (typeof u[n12] < "u")
      return u[n12];
    if (n12 === "before" || n12 === "after")
      return this.beforeAfter(e, n12);
    {
      let s12 = "raw" + s01(n12);
      this[s12] ? a = this[s12](i, e) : i.walk((c) => {
        if (a = c.raws[r12], typeof a < "u")
          return false;
      });
    }
    return typeof a > "u" && (a = oje[n12]), u[n12] = a, a;
  }
  rawBeforeClose(e) {
    let r12;
    return e.walk((n12) => {
      if (n12.nodes && n12.nodes.length > 0 && typeof n12.raws.after < "u")
        return r12 = n12.raws.after, r12.includes(`
`) && (r12 = r12.replace(/[^\n]+$/, "")), false;
    }), r12 && (r12 = r12.replace(/\S/g, "")), r12;
  }
  rawBeforeComment(e, r12) {
    let n12;
    return e.walkComments((a) => {
      if (typeof a.raws.before < "u")
        return n12 = a.raws.before, n12.includes(`
`) && (n12 = n12.replace(/[^\n]+$/, "")), false;
    }), typeof n12 > "u" ? n12 = this.raw(r12, null, "beforeDecl") : n12 && (n12 = n12.replace(/\S/g, "")), n12;
  }
  rawBeforeDecl(e, r12) {
    let n12;
    return e.walkDecls((a) => {
      if (typeof a.raws.before < "u")
        return n12 = a.raws.before, n12.includes(`
`) && (n12 = n12.replace(/[^\n]+$/, "")), false;
    }), typeof n12 > "u" ? n12 = this.raw(r12, null, "beforeRule") : n12 && (n12 = n12.replace(/\S/g, "")), n12;
  }
  rawBeforeOpen(e) {
    let r12;
    return e.walk((n12) => {
      if (n12.type !== "decl" && (r12 = n12.raws.between, typeof r12 < "u"))
        return false;
    }), r12;
  }
  rawBeforeRule(e) {
    let r12;
    return e.walk((n12) => {
      if (n12.nodes && (n12.parent !== e || e.first !== n12) && typeof n12.raws.before < "u")
        return r12 = n12.raws.before, r12.includes(`
`) && (r12 = r12.replace(/[^\n]+$/, "")), false;
    }), r12 && (r12 = r12.replace(/\S/g, "")), r12;
  }
  rawColon(e) {
    let r12;
    return e.walkDecls((n12) => {
      if (typeof n12.raws.between < "u")
        return r12 = n12.raws.between.replace(/[^\s:]/g, ""), false;
    }), r12;
  }
  rawEmptyBody(e) {
    let r12;
    return e.walk((n12) => {
      if (n12.nodes && n12.nodes.length === 0 && (r12 = n12.raws.after, typeof r12 < "u"))
        return false;
    }), r12;
  }
  rawIndent(e) {
    if (e.raws.indent)
      return e.raws.indent;
    let r12;
    return e.walk((n12) => {
      let a = n12.parent;
      if (a && a !== e && a.parent && a.parent === e && typeof n12.raws.before < "u") {
        let o = n12.raws.before.split(`
`);
        return r12 = o[o.length - 1], r12 = r12.replace(/\S/g, ""), false;
      }
    }), r12;
  }
  rawSemicolon(e) {
    let r12;
    return e.walk((n12) => {
      if (n12.nodes && n12.nodes.length && n12.last.type === "decl" && (r12 = n12.raws.semicolon, typeof r12 < "u"))
        return false;
    }), r12;
  }
  rawValue(e, r12) {
    let n12 = e[r12], a = e.raws[r12];
    return a && a.value === n12 ? a.raw : n12;
  }
  root(e) {
    if (this.body(e), e.raws.after) {
      let r12 = e.raws.after, n12 = e.parent && e.parent.type === "document";
      this.builder(n12 ? r12 : va(r12));
    }
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(va(e.raws.ownSemicolon), e, "end");
  }
  stringify(e, r12) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, r12);
  }
};
var eYe = LZ;
LZ.default = LZ;
let c01 = eYe;
function PZ(t16, e) {
  new c01(e).stringify(t16);
}
var Xp = PZ;
PZ.default = PZ;
var Ic = {};
Ic.isClean = /* @__PURE__ */ Symbol("isClean");
Ic.my = /* @__PURE__ */ Symbol("my");
let l01 = V0e, p01 = eYe, d01 = Xp, { isClean: ku, my: f01 } = Ic;
function DZ(t16, e) {
  let r12 = new t16.constructor();
  for (let n12 in t16) {
    if (!Object.prototype.hasOwnProperty.call(t16, n12) || n12 === "proxyCache")
      continue;
    let a = t16[n12], o = typeof a;
    n12 === "parent" && o === "object" ? e && (r12[n12] = e) : n12 === "source" ? r12[n12] = a : Array.isArray(a) ? r12[n12] = a.map((i) => DZ(i, r12)) : (o === "object" && a !== null && (a = DZ(a)), r12[n12] = a);
  }
  return r12;
}
function xn(t16, e) {
  if (e && typeof e.offset < "u")
    return e.offset;
  let r12 = 1, n12 = 1, a = 0;
  for (let o = 0; o < t16.length; o++) {
    if (n12 === e.line && r12 === e.column) {
      a = o;
      break;
    }
    t16[o] === `
` ? (r12 = 1, n12 += 1) : r12 += 1;
  }
  return a;
}
let WZ = class {
  get proxyOf() {
    return this;
  }
  constructor(e = {}) {
    this.raws = {}, this[ku] = false, this[f01] = true;
    for (let r12 in e)
      if (r12 === "nodes") {
        this.nodes = [];
        for (let n12 of e[r12])
          typeof n12.clone == "function" ? this.append(n12.clone()) : this.append(n12);
      } else
        this[r12] = e[r12];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let r12 = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${r12.input.from}:${r12.start.line}:${r12.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let r12 in e)
      this[r12] = e[r12];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let r12 = DZ(this);
    for (let n12 in e)
      r12[n12] = e[n12];
    return r12;
  }
  cloneAfter(e = {}) {
    let r12 = this.clone(e);
    return this.parent.insertAfter(this, r12), r12;
  }
  cloneBefore(e = {}) {
    let r12 = this.clone(e);
    return this.parent.insertBefore(this, r12), r12;
  }
  error(e, r12 = {}) {
    if (this.source) {
      let { end: n12, start: a } = this.rangeBy(r12);
      return this.source.input.error(
        e,
        { column: a.column, line: a.line },
        { column: n12.column, line: n12.line },
        r12
      );
    }
    return new l01(e);
  }
  getProxyProcessor() {
    return {
      get(e, r12) {
        return r12 === "proxyOf" ? e : r12 === "root" ? () => e.root().toProxy() : e[r12];
      },
      set(e, r12, n12) {
        return e[r12] === n12 || (e[r12] = n12, (r12 === "prop" || r12 === "value" || r12 === "name" || r12 === "params" || r12 === "important" || /* c8 ignore next */
        r12 === "text") && e.markDirty()), true;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[ku] = true;
  }
  markDirty() {
    if (this[ku]) {
      this[ku] = false;
      let e = this;
      for (; e = e.parent; )
        e[ku] = false;
    }
  }
  next() {
    if (!this.parent)
      return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e = {}) {
    let r12 = this.source.start;
    if (e.index)
      r12 = this.positionInside(e.index);
    else if (e.word) {
      let n12 = "document" in this.source.input ? this.source.input.document : this.source.input.css, o = n12.slice(
        xn(n12, this.source.start),
        xn(n12, this.source.end)
      ).indexOf(e.word);
      o !== -1 && (r12 = this.positionInside(o));
    }
    return r12;
  }
  positionInside(e) {
    let r12 = this.source.start.column, n12 = this.source.start.line, a = "document" in this.source.input ? this.source.input.document : this.source.input.css, o = xn(a, this.source.start), i = o + e;
    for (let u = o; u < i; u++)
      a[u] === `
` ? (r12 = 1, n12 += 1) : r12 += 1;
    return { column: r12, line: n12, offset: i };
  }
  prev() {
    if (!this.parent)
      return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e = {}) {
    let r12 = "document" in this.source.input ? this.source.input.document : this.source.input.css, n12 = {
      column: this.source.start.column,
      line: this.source.start.line,
      offset: xn(r12, this.source.start)
    }, a = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line,
      offset: typeof this.source.end.offset == "number" ? (
        // `source.end.offset` is exclusive, so we don't need to add 1
        this.source.end.offset
      ) : (
        // Since line/column in this.source.end is inclusive,
        // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
        // So, we add 1 to convert it to exclusive.
        xn(r12, this.source.end) + 1
      )
    } : {
      column: n12.column + 1,
      line: n12.line,
      offset: n12.offset + 1
    };
    if (e.word) {
      let i = r12.slice(
        xn(r12, this.source.start),
        xn(r12, this.source.end)
      ).indexOf(e.word);
      i !== -1 && (n12 = this.positionInside(i), a = this.positionInside(i + e.word.length));
    } else
      e.start ? n12 = {
        column: e.start.column,
        line: e.start.line,
        offset: xn(r12, e.start)
      } : e.index && (n12 = this.positionInside(e.index)), e.end ? a = {
        column: e.end.column,
        line: e.end.line,
        offset: xn(r12, e.end)
      } : typeof e.endIndex == "number" ? a = this.positionInside(e.endIndex) : e.index && (a = this.positionInside(e.index + 1));
    return (a.line < n12.line || a.line === n12.line && a.column <= n12.column) && (a = {
      column: n12.column + 1,
      line: n12.line,
      offset: n12.offset + 1
    }), { end: a, start: n12 };
  }
  raw(e, r12) {
    return new p01().raw(this, e, r12);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let r12 = this, n12 = false;
      for (let a of e)
        a === this ? n12 = true : n12 ? (this.parent.insertAfter(r12, a), r12 = a) : this.parent.insertBefore(r12, a);
      n12 || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, r12) {
    let n12 = {}, a = r12 == null;
    r12 = r12 || /* @__PURE__ */ new Map();
    let o = 0;
    for (let i in this) {
      if (!Object.prototype.hasOwnProperty.call(this, i) || i === "parent" || i === "proxyCache")
        continue;
      let u = this[i];
      if (Array.isArray(u))
        n12[i] = u.map((s12) => typeof s12 == "object" && s12.toJSON ? s12.toJSON(null, r12) : s12);
      else if (typeof u == "object" && u.toJSON)
        n12[i] = u.toJSON(null, r12);
      else if (i === "source") {
        if (u == null)
          continue;
        let s12 = r12.get(u.input);
        s12 == null && (s12 = o, r12.set(u.input, o), o++), n12[i] = {
          end: u.end,
          inputId: s12,
          start: u.start
        };
      } else
        n12[i] = u;
    }
    return a && (n12.inputs = [...r12.keys()].map((i) => i.toJSON())), n12;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = d01) {
    e.stringify && (e = e.stringify);
    let r12 = "";
    return e(this, (n12) => {
      r12 += n12;
    }), r12;
  }
  warn(e, r12, n12 = {}) {
    let a = { node: this };
    for (let o in n12)
      a[o] = n12[o];
    return e.warn(r12, a);
  }
};
var $p = WZ;
WZ.default = WZ;
let b01 = $p, NZ = class extends b01 {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var Gp = NZ;
NZ.default = NZ;
let M01 = $p, wZ = class extends M01 {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(e) {
    e && typeof e.value < "u" && typeof e.value != "string" && (e = { ...e, value: String(e.value) }), super(e), this.type = "decl";
  }
};
var Yp = wZ;
wZ.default = wZ;
let tYe = Gp, rYe = Yp, O01 = $p, { isClean: nYe, my: aYe } = Ic, H0e, oYe, iYe, X0e;
function uYe(t16) {
  return t16.map((e) => (e.nodes && (e.nodes = uYe(e.nodes)), delete e.source, e));
}
function sYe(t16) {
  if (t16[nYe] = false, t16.proxyOf.nodes)
    for (let e of t16.proxyOf.nodes)
      sYe(e);
}
let ua = class cYe extends O01 {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...e) {
    for (let r12 of e) {
      let n12 = this.normalize(r12, this.last);
      for (let a of n12)
        this.proxyOf.nodes.push(a);
    }
    return this.markDirty(), this;
  }
  cleanRaws(e) {
    if (super.cleanRaws(e), this.nodes)
      for (let r12 of this.nodes)
        r12.cleanRaws(e);
  }
  each(e) {
    if (!this.proxyOf.nodes)
      return;
    let r12 = this.getIterator(), n12, a;
    for (; this.indexes[r12] < this.proxyOf.nodes.length && (n12 = this.indexes[r12], a = e(this.proxyOf.nodes[n12], n12), a !== false); )
      this.indexes[r12] += 1;
    return delete this.indexes[r12], a;
  }
  every(e) {
    return this.nodes.every(e);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let e = this.lastEach;
    return this.indexes[e] = 0, e;
  }
  getProxyProcessor() {
    return {
      get(e, r12) {
        return r12 === "proxyOf" ? e : e[r12] ? r12 === "each" || typeof r12 == "string" && r12.startsWith("walk") ? (...n12) => e[r12](
          ...n12.map((a) => typeof a == "function" ? (o, i) => a(o.toProxy(), i) : a)
        ) : r12 === "every" || r12 === "some" ? (n12) => e[r12](
          (a, ...o) => n12(a.toProxy(), ...o)
        ) : r12 === "root" ? () => e.root().toProxy() : r12 === "nodes" ? e.nodes.map((n12) => n12.toProxy()) : r12 === "first" || r12 === "last" ? e[r12].toProxy() : e[r12] : e[r12];
      },
      set(e, r12, n12) {
        return e[r12] === n12 || (e[r12] = n12, (r12 === "name" || r12 === "params" || r12 === "selector") && e.markDirty()), true;
      }
    };
  }
  index(e) {
    return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
  }
  insertAfter(e, r12) {
    let n12 = this.index(e), a = this.normalize(r12, this.proxyOf.nodes[n12]).reverse();
    n12 = this.index(e);
    for (let i of a)
      this.proxyOf.nodes.splice(n12 + 1, 0, i);
    let o;
    for (let i in this.indexes)
      o = this.indexes[i], n12 < o && (this.indexes[i] = o + a.length);
    return this.markDirty(), this;
  }
  insertBefore(e, r12) {
    let n12 = this.index(e), a = n12 === 0 ? "prepend" : false, o = this.normalize(
      r12,
      this.proxyOf.nodes[n12],
      a
    ).reverse();
    n12 = this.index(e);
    for (let u of o)
      this.proxyOf.nodes.splice(n12, 0, u);
    let i;
    for (let u in this.indexes)
      i = this.indexes[u], n12 <= i && (this.indexes[u] = i + o.length);
    return this.markDirty(), this;
  }
  normalize(e, r12) {
    if (typeof e == "string")
      e = uYe(oYe(e).nodes);
    else if (typeof e > "u")
      e = [];
    else if (Array.isArray(e)) {
      e = e.slice(0);
      for (let a of e)
        a.parent && a.parent.removeChild(a, "ignore");
    } else if (e.type === "root" && this.type !== "document") {
      e = e.nodes.slice(0);
      for (let a of e)
        a.parent && a.parent.removeChild(a, "ignore");
    } else if (e.type)
      e = [e];
    else if (e.prop) {
      if (typeof e.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof e.value != "string" && (e.value = String(e.value)), e = [new rYe(e)];
    } else if (e.selector || e.selectors)
      e = [new X0e(e)];
    else if (e.name)
      e = [new H0e(e)];
    else if (e.text)
      e = [new tYe(e)];
    else
      throw new Error("Unknown node type in node creation");
    return e.map((a) => (a[aYe] || cYe.rebuild(a), a = a.proxyOf, a.parent && a.parent.removeChild(a), a[nYe] && sYe(a), a.raws || (a.raws = {}), typeof a.raws.before > "u" && r12 && typeof r12.raws.before < "u" && (a.raws.before = r12.raws.before.replace(/\S/g, "")), a.parent = this.proxyOf, a));
  }
  prepend(...e) {
    e = e.reverse();
    for (let r12 of e) {
      let n12 = this.normalize(r12, this.first, "prepend").reverse();
      for (let a of n12)
        this.proxyOf.nodes.unshift(a);
      for (let a in this.indexes)
        this.indexes[a] = this.indexes[a] + n12.length;
    }
    return this.markDirty(), this;
  }
  push(e) {
    return e.parent = this, this.proxyOf.nodes.push(e), this;
  }
  removeAll() {
    for (let e of this.proxyOf.nodes)
      e.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(e) {
    e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
    let r12;
    for (let n12 in this.indexes)
      r12 = this.indexes[n12], r12 >= e && (this.indexes[n12] = r12 - 1);
    return this.markDirty(), this;
  }
  replaceValues(e, r12, n12) {
    return n12 || (n12 = r12, r12 = {}), this.walkDecls((a) => {
      r12.props && !r12.props.includes(a.prop) || r12.fast && !a.value.includes(r12.fast) || (a.value = a.value.replace(e, n12));
    }), this.markDirty(), this;
  }
  some(e) {
    return this.nodes.some(e);
  }
  walk(e) {
    return this.each((r12, n12) => {
      let a;
      try {
        a = e(r12, n12);
      } catch (o) {
        throw r12.addToError(o);
      }
      return a !== false && r12.walk && (a = r12.walk(e)), a;
    });
  }
  walkAtRules(e, r12) {
    return r12 ? e instanceof RegExp ? this.walk((n12, a) => {
      if (n12.type === "atrule" && e.test(n12.name))
        return r12(n12, a);
    }) : this.walk((n12, a) => {
      if (n12.type === "atrule" && n12.name === e)
        return r12(n12, a);
    }) : (r12 = e, this.walk((n12, a) => {
      if (n12.type === "atrule")
        return r12(n12, a);
    }));
  }
  walkComments(e) {
    return this.walk((r12, n12) => {
      if (r12.type === "comment")
        return e(r12, n12);
    });
  }
  walkDecls(e, r12) {
    return r12 ? e instanceof RegExp ? this.walk((n12, a) => {
      if (n12.type === "decl" && e.test(n12.prop))
        return r12(n12, a);
    }) : this.walk((n12, a) => {
      if (n12.type === "decl" && n12.prop === e)
        return r12(n12, a);
    }) : (r12 = e, this.walk((n12, a) => {
      if (n12.type === "decl")
        return r12(n12, a);
    }));
  }
  walkRules(e, r12) {
    return r12 ? e instanceof RegExp ? this.walk((n12, a) => {
      if (n12.type === "rule" && e.test(n12.selector))
        return r12(n12, a);
    }) : this.walk((n12, a) => {
      if (n12.type === "rule" && n12.selector === e)
        return r12(n12, a);
    }) : (r12 = e, this.walk((n12, a) => {
      if (n12.type === "rule")
        return r12(n12, a);
    }));
  }
};
ua.registerParse = (t16) => {
  oYe = t16;
};
ua.registerRule = (t16) => {
  X0e = t16;
};
ua.registerAtRule = (t16) => {
  H0e = t16;
};
ua.registerRoot = (t16) => {
  iYe = t16;
};
var Eo = ua;
ua.default = ua;
ua.rebuild = (t16) => {
  t16.type === "atrule" ? Object.setPrototypeOf(t16, H0e.prototype) : t16.type === "rule" ? Object.setPrototypeOf(t16, X0e.prototype) : t16.type === "decl" ? Object.setPrototypeOf(t16, rYe.prototype) : t16.type === "comment" ? Object.setPrototypeOf(t16, tYe.prototype) : t16.type === "root" && Object.setPrototypeOf(t16, iYe.prototype), t16[aYe] = true, t16.nodes && t16.nodes.forEach((e) => {
    ua.rebuild(e);
  });
};
let lYe = Eo, B2 = class extends lYe {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var $0e = B2;
B2.default = B2;
lYe.registerAtRule(B2);
let z01 = Eo, pYe, dYe, Xs = class extends z01 {
  constructor(e) {
    super({ type: "document", ...e }), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new pYe(new dYe(), this, e).stringify();
  }
};
Xs.registerLazyResult = (t16) => {
  pYe = t16;
};
Xs.registerProcessor = (t16) => {
  dYe = t16;
};
var G0e = Xs;
Xs.default = Xs;
let A01 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", h01 = (t16 = 21) => {
  let e = "", r12 = t16 | 0;
  for (; r12--; )
    e += A01[Math.random() * 64 | 0];
  return e;
};
var v01 = { nanoid: h01 };
let { existsSync: m01, readFileSync: R01 } = on, { dirname: iQ, join: q01 } = on, { SourceMapConsumer: ije, SourceMapGenerator: uje } = on;
function T01(t16) {
  return Buffer ? Buffer.from(t16, "base64").toString() : window.atob(t16);
}
let BZ = class {
  constructor(e, r12) {
    if (r12.map === false)
      return;
    r12.unsafeMap && (this.unsafeMap = true), this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let n12 = r12.map ? r12.map.prev : void 0, a = this.loadMap(r12.from, n12);
    !this.mapFile && r12.from && (this.mapFile = r12.from), this.mapFile && (this.root = iQ(this.mapFile)), a && (this.text = a);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new ije(this.json || this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let r12 = /^data:application\/json;charset=utf-?8;base64,/, n12 = /^data:application\/json;base64,/, a = /^data:application\/json;charset=utf-?8,/, o = /^data:application\/json,/, i = e.match(a) || e.match(o);
    if (i)
      return decodeURIComponent(e.substr(i[0].length));
    let u = e.match(r12) || e.match(n12);
    if (u)
      return T01(e.substr(u[0].length));
    let s12 = e.slice(22);
    throw s12 = s12.slice(0, s12.indexOf(",")), new Error("Unsupported source map encoding " + s12);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? false : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let r12 = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!r12)
      return;
    let n12 = e.lastIndexOf(r12.pop()), a = e.indexOf("*/", n12);
    n12 > -1 && a > -1 && (this.annotation = this.getAnnotationURL(e.substring(n12, a)));
  }
  loadFile(e, r12, n12) {
    if (!(!n12 && !this.unsafeMap && !/\.map$/i.test(e)) && (this.root = iQ(e), m01(e)))
      return this.mapFile = e, R01(e, "utf-8").toString().trim();
  }
  loadMap(e, r12) {
    if (r12 === false)
      return false;
    if (r12) {
      if (typeof r12 == "string")
        return r12;
      if (typeof r12 == "function") {
        let n12 = r12(e);
        if (n12) {
          let a = this.loadFile(n12, e, true);
          if (!a)
            throw new Error(
              "Unable to load previous source map: " + n12.toString()
            );
          return a;
        }
      } else {
        if (r12 instanceof ije)
          return uje.fromSourceMap(r12).toString();
        if (r12 instanceof uje)
          return r12.toString();
        if (this.isMap(r12))
          return JSON.stringify(r12);
        throw new Error(
          "Unsupported previous source map format: " + r12.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let n12 = this.annotation;
        e && (n12 = q01(iQ(e), n12));
        let a = this.loadFile(n12, e, false);
        if (a)
          try {
            this.json = JSON.parse(a.replace(/^\)]}'[^\n]*\n/, ""));
          } catch {
            return;
          }
        return a;
      }
    }
  }
  startWith(e, r12) {
    return e ? e.substr(0, r12.length) === r12 : false;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var fYe = BZ;
BZ.default = BZ;
let { nanoid: y01 } = v01, { isAbsolute: xZ, resolve: UZ } = on, { SourceMapConsumer: S01, SourceMapGenerator: C01 } = on, { fileURLToPath: sje, pathToFileURL: ml } = on, cje = V0e, g01 = fYe, uQ = on, sQ = /* @__PURE__ */ Symbol("lineToIndexCache"), I01 = !!(S01 && C01), lje = !!(UZ && xZ);
function pje(t16) {
  if (t16[sQ])
    return t16[sQ];
  let e = t16.css.split(`
`), r12 = new Array(e.length), n12 = 0;
  for (let a = 0, o = e.length; a < o; a++)
    r12[a] = n12, n12 += e[a].length + 1;
  return t16[sQ] = r12, r12;
}
let x2 = class {
  get from() {
    return this.file || this.id;
  }
  constructor(e, r12 = {}) {
    if (e === null || typeof e > "u" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = true, this.css = this.css.slice(1)) : this.hasBOM = false, this.document = this.css, r12.document && (this.document = r12.document.toString()), r12.from && (!lje || /^\w+:\/\//.test(r12.from) || xZ(r12.from) ? this.file = r12.from : this.file = UZ(r12.from)), lje && I01) {
      let n12 = new g01(this.css, r12);
      if (n12.text) {
        this.map = n12;
        let a = n12.consumer().file;
        !this.file && a && (this.file = this.mapResolve(a));
      }
    }
    this.file || (this.id = "<input css " + y01(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, r12, n12, a = {}) {
    let o, i, u, s12, c;
    if (r12 && typeof r12 == "object") {
      let f = r12, p = n12;
      if (typeof f.offset == "number") {
        s12 = f.offset;
        let d = this.fromOffset(s12);
        r12 = d.line, n12 = d.col;
      } else
        r12 = f.line, n12 = f.column, s12 = this.fromLineAndColumn(r12, n12);
      if (typeof p.offset == "number") {
        u = p.offset;
        let d = this.fromOffset(u);
        i = d.line, o = d.col;
      } else
        i = p.line, o = p.column, u = this.fromLineAndColumn(p.line, p.column);
    } else if (n12)
      s12 = this.fromLineAndColumn(r12, n12);
    else {
      s12 = r12;
      let f = this.fromOffset(s12);
      r12 = f.line, n12 = f.col;
    }
    let l2 = this.origin(r12, n12, i, o);
    return l2 ? c = new cje(
      e,
      l2.endLine === void 0 ? l2.line : { column: l2.column, line: l2.line },
      l2.endLine === void 0 ? l2.column : { column: l2.endColumn, line: l2.endLine },
      l2.source,
      l2.file,
      a.plugin
    ) : c = new cje(
      e,
      i === void 0 ? r12 : { column: n12, line: r12 },
      i === void 0 ? n12 : { column: o, line: i },
      this.css,
      this.file,
      a.plugin
    ), c.input = {
      column: n12,
      endColumn: o,
      endLine: i,
      endOffset: u,
      line: r12,
      offset: s12,
      source: this.css
    }, this.file && (ml && (c.input.url = ml(this.file).toString()), c.input.file = this.file), c;
  }
  fromLineAndColumn(e, r12) {
    return pje(this)[e - 1] + r12 - 1;
  }
  fromOffset(e) {
    let r12 = pje(this), n12 = r12[r12.length - 1], a = 0;
    if (e >= n12)
      a = r12.length - 1;
    else {
      let o = r12.length - 2, i;
      for (; a < o; )
        if (i = a + (o - a >> 1), e < r12[i])
          o = i - 1;
        else if (e >= r12[i + 1])
          a = i + 1;
        else {
          a = i;
          break;
        }
    }
    return {
      col: e - r12[a] + 1,
      line: a + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : UZ(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, r12, n12, a) {
    if (!this.map)
      return false;
    let o = this.map.consumer(), i = o.originalPositionFor({ column: r12, line: e });
    if (!i.source)
      return false;
    let u;
    typeof n12 == "number" && (u = o.originalPositionFor({ column: a, line: n12 }));
    let s12;
    xZ(i.source) ? s12 = ml(i.source) : s12 = new URL(
      i.source,
      this.map.consumer().sourceRoot || ml(this.map.mapFile)
    );
    let c = {
      column: i.column,
      endColumn: u && u.column,
      endLine: u && u.line,
      line: i.line,
      url: s12.toString()
    };
    if (s12.protocol === "file:")
      if (sje)
        c.file = sje(s12);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let l2 = o.sourceContentFor(i.source);
    return l2 && (c.source = l2), c;
  }
  toJSON() {
    let e = {};
    for (let r12 of ["hasBOM", "css", "file", "id"])
      this[r12] != null && (e[r12] = this[r12]);
    return this.map && (e.map = { ...this.map }, e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
};
var Jp = x2;
x2.default = x2;
uQ && uQ.registerInput && uQ.registerInput(x2);
let bYe = Eo, MYe, OYe, Ri = class extends bYe {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, r12, n12) {
    let a = super.normalize(e);
    if (r12) {
      if (n12 === "prepend")
        this.nodes.length > 1 ? r12.raws.before = this.nodes[1].raws.before : delete r12.raws.before;
      else if (this.first !== r12)
        for (let o of a)
          o.raws.before = r12.raws.before;
    }
    return a;
  }
  removeChild(e, r12) {
    let n12 = this.index(e);
    return !r12 && n12 === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[n12].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new MYe(new OYe(), this, e).stringify();
  }
};
Ri.registerLazyResult = (t16) => {
  MYe = t16;
};
Ri.registerProcessor = (t16) => {
  OYe = t16;
};
var Ec = Ri;
Ri.default = Ri;
bYe.registerRoot(Ri);
let $s = {
  comma(t16) {
    return $s.split(t16, [","], true);
  },
  space(t16) {
    let e = [" ", `
`, "	"];
    return $s.split(t16, e);
  },
  split(t16, e, r12) {
    let n12 = [], a = "", o = false, i = 0, u = false, s12 = "", c = false;
    for (let l2 of t16)
      c ? c = false : l2 === "\\" ? c = true : u ? l2 === s12 && (u = false) : l2 === '"' || l2 === "'" ? (u = true, s12 = l2) : l2 === "(" ? i += 1 : l2 === ")" ? i > 0 && (i -= 1) : i === 0 && e.includes(l2) && (o = true), o ? (a !== "" && n12.push(a.trim()), a = "", o = false) : a += l2;
    return (r12 || a !== "") && n12.push(a.trim()), n12;
  }
};
var zYe = $s;
$s.default = $s;
let AYe = Eo, E01 = zYe, U2 = class extends AYe {
  get selectors() {
    return E01.comma(this.selector);
  }
  set selectors(e) {
    let r12 = this.selector ? this.selector.match(/,\s*/) : null, n12 = r12 ? r12[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(n12);
  }
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var Y0e = U2;
U2.default = U2;
AYe.registerRule(U2);
let L01 = $0e, P01 = Gp, D01 = Yp, W01 = Jp, N01 = fYe, w01 = Ec, B01 = Y0e;
function Gs(t16, e) {
  if (Array.isArray(t16))
    return t16.map((a) => Gs(a));
  let { inputs: r12, ...n12 } = t16;
  if (r12) {
    e = [];
    for (let a of r12) {
      let o = { ...a, __proto__: W01.prototype };
      o.map && (o.map = {
        ...o.map,
        __proto__: N01.prototype
      }), e.push(o);
    }
  }
  if (n12.nodes && (n12.nodes = t16.nodes.map((a) => Gs(a, e))), n12.source) {
    let { inputId: a, ...o } = n12.source;
    n12.source = o, a != null && (n12.source.input = e[a]);
  }
  if (n12.type === "root")
    return new w01(n12);
  if (n12.type === "decl")
    return new D01(n12);
  if (n12.type === "rule")
    return new B01(n12);
  if (n12.type === "comment")
    return new P01(n12);
  if (n12.type === "atrule")
    return new L01(n12);
  throw new Error("Unknown node type: " + t16.type);
}
var x01 = Gs;
Gs.default = Gs;
let { dirname: r2, relative: _Ye, resolve: hYe, sep: vYe } = on, { SourceMapConsumer: mYe, SourceMapGenerator: n2 } = on, { pathToFileURL: dje } = on, U01 = Jp, k01 = !!(mYe && n2), j01 = !!(r2 && hYe && _Ye && vYe), F01 = class {
  constructor(e, r12, n12, a) {
    this.stringify = e, this.mapOpts = n12.map || {}, this.root = r12, this.opts = n12, this.css = a, this.originalCSS = a, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let r12 = `
`;
    this.css.includes(`\r
`) && (r12 = `\r
`), this.css += r12 + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let r12 = this.toUrl(this.path(e.file)), n12 = e.root || r2(e.file), a;
      this.mapOpts.sourcesContent === false ? (a = new mYe(e.text), a.sourcesContent && (a.sourcesContent = null)) : a = e.consumer(), this.map.applySourceMap(a, r12, this.toUrl(this.path(n12)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== false) {
      if (this.root) {
        let e;
        for (let r12 = this.root.nodes.length - 1; r12 >= 0; r12--)
          e = this.root.nodes[r12], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(r12);
      } else if (this.css) {
        let e;
        for (; (e = this.css.lastIndexOf("/*#")) !== -1; ) {
          let r12 = this.css.indexOf("*/", e + 3);
          if (r12 === -1)
            break;
          for (; e > 0 && this.css[e - 1] === `
`; )
            e--;
          this.css = this.css.slice(0, e) + this.css.slice(r12 + 2);
        }
      }
    }
  }
  generate() {
    if (this.clearAnnotation(), j01 && k01 && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (r12) => {
        e += r12;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = n2.fromSourceMap(e, {
        ignoreInvalidMapping: true
      });
    } else
      this.map = new n2({
        file: this.outputFile(),
        ignoreInvalidMapping: true
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new n2({
      file: this.outputFile(),
      ignoreInvalidMapping: true
    });
    let e = 1, r12 = 1, n12 = "<no source>", a = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, o, i;
    this.stringify(this.root, (u, s12, c) => {
      if (this.css += u, s12 && c !== "end" && (a.generated.line = e, a.generated.column = r12 - 1, s12.source && s12.source.start ? (a.source = this.sourcePath(s12), a.original.line = s12.source.start.line, a.original.column = s12.source.start.column - 1, this.map.addMapping(a)) : (a.source = n12, a.original.line = 1, a.original.column = 0, this.map.addMapping(a))), i = u.match(/\n/g), i ? (e += i.length, o = u.lastIndexOf(`
`), r12 = u.length - o) : r12 += u.length, s12 && c !== "start") {
        let l2 = s12.parent || { raws: {} };
        (!(s12.type === "decl" || s12.type === "atrule" && !s12.nodes) || s12 !== l2.last || l2.raws.semicolon) && (s12.source && s12.source.end ? (a.source = this.sourcePath(s12), a.original.line = s12.source.end.line, a.original.column = s12.source.end.column - 1, a.generated.line = e, a.generated.column = r12 - 2, this.map.addMapping(a)) : (a.source = n12, a.original.line = 1, a.original.column = 0, a.generated.line = e, a.generated.column = r12 - 1, this.map.addMapping(a)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? true : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : true;
  }
  isInline() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e < "u" && e !== true ? false : this.previous().length ? this.previous().some((r12) => r12.inline) : true;
  }
  isMap() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : true;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e))
      return e;
    let r12 = this.memoizedPaths.get(e);
    if (r12)
      return r12;
    let n12 = this.opts.to ? r2(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (n12 = r2(hYe(n12, this.mapOpts.annotation)));
    let a = _Ye(n12, e);
    return this.memoizedPaths.set(e, a), a;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let r12 = e.source.input.map;
            this.previousMaps.includes(r12) || this.previousMaps.push(r12);
          }
        });
      else {
        let e = new U01(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((r12) => {
        if (r12.source) {
          let n12 = r12.source.input.from;
          if (n12 && !e[n12]) {
            e[n12] = true;
            let a = this.usesFileUrls ? this.toFileUrl(n12) : this.toUrl(this.path(n12));
            this.map.setSourceContent(a, r12.source.input.css);
          }
        }
      });
    else if (this.css) {
      let r12 = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(r12, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let r12 = this.memoizedFileURLs.get(e);
    if (r12)
      return r12;
    if (dje) {
      let n12 = dje(e).toString();
      return this.memoizedFileURLs.set(e, n12), n12;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let r12 = this.memoizedURLs.get(e);
    if (r12)
      return r12;
    vYe === "\\" && (e = e.replace(/\\/g, "/"));
    let n12 = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, n12), n12;
  }
};
var RYe = F01;
const cQ = 39, fje = 34, Rl = 92, bje = 47, ql = 10, ju = 32, Tl = 12, yl = 9, Sl = 13, V01 = 91, H01 = 93, X01 = 40, $01 = 41, G01 = 123, Y01 = 125, J01 = 59, K01 = 42, Q01 = 58, Z01 = 64, Cl = /[\t\n\f\r "#'()/;[\\\]{}]/g, gl = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, e11 = /.[\r\n"'(/\\]/, Mje = /[\da-f]/i;
var t11 = function(e, r12 = {}) {
  let n12 = e.css.valueOf(), a = r12.ignoreErrors, o, i, u, s12, c, l2, f, p, d, b, z = n12.length, _ = 0, q = [], S = [], N = -1;
  function v() {
    return _;
  }
  function C(j) {
    throw e.error("Unclosed " + j, _);
  }
  function L() {
    return S.length === 0 && _ >= z;
  }
  function B(j) {
    if (S.length)
      return S.pop();
    if (_ >= z)
      return;
    let $ = j ? j.ignoreUnclosed : false;
    switch (o = n12.charCodeAt(_), o) {
      case ql:
      case ju:
      case yl:
      case Sl:
      case Tl: {
        s12 = _;
        do
          s12 += 1, o = n12.charCodeAt(s12);
        while (o === ju || o === ql || o === yl || o === Sl || o === Tl);
        l2 = ["space", n12.slice(_, s12)], _ = s12 - 1;
        break;
      }
      case V01:
      case H01:
      case G01:
      case Y01:
      case Q01:
      case J01:
      case $01: {
        let W = String.fromCharCode(o);
        l2 = [W, W, _];
        break;
      }
      case X01: {
        if (b = q.length ? q.pop()[1] : "", d = n12.charCodeAt(_ + 1), b === "url" && d !== cQ && d !== fje && d !== ju && d !== ql && d !== yl && d !== Tl && d !== Sl) {
          s12 = _;
          do {
            if (f = false, s12 = n12.indexOf(")", s12 + 1), s12 === -1)
              if (a || $) {
                s12 = _;
                break;
              } else
                C("bracket");
            for (p = s12; n12.charCodeAt(p - 1) === Rl; )
              p -= 1, f = !f;
          } while (f);
          l2 = ["brackets", n12.slice(_, s12 + 1), _, s12], _ = s12;
        } else
          _ <= N ? l2 = ["(", "(", _] : (s12 = n12.indexOf(")", _ + 1), i = n12.slice(_, s12 + 1), s12 === -1 || e11.test(i) ? (N = s12 === -1 ? z : s12, l2 = ["(", "(", _]) : (l2 = ["brackets", i, _, s12], _ = s12));
        break;
      }
      case cQ:
      case fje: {
        c = o === cQ ? "'" : '"', s12 = _;
        do {
          if (f = false, s12 = n12.indexOf(c, s12 + 1), s12 === -1)
            if (a || $) {
              s12 = _ + 1;
              break;
            } else
              C("string");
          for (p = s12; n12.charCodeAt(p - 1) === Rl; )
            p -= 1, f = !f;
        } while (f);
        l2 = ["string", n12.slice(_, s12 + 1), _, s12], _ = s12;
        break;
      }
      case Z01: {
        Cl.lastIndex = _ + 1, Cl.test(n12), Cl.lastIndex === 0 ? s12 = n12.length - 1 : s12 = Cl.lastIndex - 2, l2 = ["at-word", n12.slice(_, s12 + 1), _, s12], _ = s12;
        break;
      }
      case Rl: {
        for (s12 = _, u = true; n12.charCodeAt(s12 + 1) === Rl; )
          s12 += 1, u = !u;
        if (o = n12.charCodeAt(s12 + 1), u && o !== bje && o !== ju && o !== ql && o !== yl && o !== Sl && o !== Tl && (s12 += 1, Mje.test(n12.charAt(s12)))) {
          for (; Mje.test(n12.charAt(s12 + 1)); )
            s12 += 1;
          n12.charCodeAt(s12 + 1) === ju && (s12 += 1);
        }
        l2 = ["word", n12.slice(_, s12 + 1), _, s12], _ = s12;
        break;
      }
      default: {
        o === bje && n12.charCodeAt(_ + 1) === K01 ? (s12 = n12.indexOf("*/", _ + 2) + 1, s12 === 0 && (a || $ ? s12 = n12.length : C("comment")), l2 = ["comment", n12.slice(_, s12 + 1), _, s12], _ = s12) : (gl.lastIndex = _ + 1, gl.test(n12), gl.lastIndex === 0 ? s12 = n12.length - 1 : s12 = gl.lastIndex - 2, l2 = ["word", n12.slice(_, s12 + 1), _, s12], q.push(l2), _ = s12);
        break;
      }
    }
    return _++, l2;
  }
  function P12(j) {
    S.push(j);
  }
  return {
    back: P12,
    endOfFile: L,
    nextToken: B,
    position: v
  };
};
let r11 = $0e, n11 = Gp, a11 = Yp, o11 = Ec, Oje = Y0e, i11 = t11;
const zje = {
  empty: true,
  space: true
};
function u11(t16) {
  for (let e = t16.length - 1; e >= 0; e--) {
    let r12 = t16[e], n12 = r12[3] || r12[2];
    if (n12)
      return n12;
  }
}
function lQ(t16, e, r12) {
  let n12 = "";
  for (let a = e; a < r12; a++)
    n12 += t16[a][1];
  return n12;
}
let s11 = class {
  constructor(e) {
    this.input = e, this.root = new o11(), this.current = this.root, this.spaces = "", this.semicolon = false, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let r12 = new r11();
    r12.name = e[1].slice(1), r12.name === "" && this.unnamedAtrule(r12, e), this.init(r12, e[2]);
    let n12, a, o, i = false, u = false, s12 = [], c = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), n12 = e[0], n12 === "(" || n12 === "[" ? c.push(n12 === "(" ? ")" : "]") : n12 === "{" && c.length > 0 ? c.push("}") : n12 === c[c.length - 1] && c.pop(), c.length === 0)
        if (n12 === ";") {
          r12.source.end = this.getPosition(e[2]), r12.source.end.offset++, this.semicolon = true;
          break;
        } else if (n12 === "{") {
          u = true;
          break;
        } else if (n12 === "}") {
          if (s12.length > 0) {
            for (o = s12.length - 1, a = s12[o]; a && a[0] === "space"; )
              a = s12[--o];
            a && (r12.source.end = this.getPosition(a[3] || a[2]), r12.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          s12.push(e);
      else
        s12.push(e);
      if (this.tokenizer.endOfFile()) {
        i = true;
        break;
      }
    }
    r12.raws.between = this.spacesAndCommentsFromEnd(s12), s12.length ? (r12.raws.afterName = this.spacesAndCommentsFromStart(s12), this.raw(r12, "params", s12), i && (e = s12[s12.length - 1], r12.source.end = this.getPosition(e[3] || e[2]), r12.source.end.offset++, this.spaces = r12.raws.between, r12.raws.between = "")) : (r12.raws.afterName = "", r12.params = ""), u && (r12.nodes = [], this.current = r12);
  }
  checkMissedSemicolon(e) {
    let r12 = this.colon(e);
    if (r12 === false)
      return;
    let n12 = 0, a;
    for (let o = r12 - 1; o >= 0 && (a = e[o], !(a[0] !== "space" && (n12 += 1, n12 === 2))); o--)
      ;
    throw this.input.error(
      "Missed semicolon",
      a[0] === "word" ? a[3] + 1 : a[2]
    );
  }
  colon(e) {
    let r12 = 0, n12, a, o;
    for (let [i, u] of e.entries()) {
      if (a = u, o = a[0], o === "(" && (r12 += 1), o === ")" && (r12 -= 1), r12 === 0 && o === ":")
        if (!n12)
          this.doubleColon(a);
        else {
          if (n12[0] === "word" && n12[1] === "progid")
            continue;
          return i;
        }
      n12 = a;
    }
    return false;
  }
  comment(e) {
    let r12 = new n11();
    this.init(r12, e[2]), r12.source.end = this.getPosition(e[3] || e[2]), r12.source.end.offset++;
    let n12 = e[1].slice(2, -2);
    if (!n12.trim())
      r12.text = "", r12.raws.left = n12, r12.raws.right = "";
    else {
      let a = n12.match(/^(\s*)([^]*\S)(\s*)$/);
      r12.text = a[2], r12.raws.left = a[1], r12.raws.right = a[3];
    }
  }
  createTokenizer() {
    this.tokenizer = i11(this.input);
  }
  decl(e, r12) {
    let n12 = new a11();
    this.init(n12, e[0][2]);
    let a = e[e.length - 1];
    a[0] === ";" && (this.semicolon = true, e.pop()), n12.source.end = this.getPosition(
      a[3] || a[2] || u11(e)
    ), n12.source.end.offset++;
    let o = 0;
    for (; e[o][0] !== "word"; )
      o === e.length - 1 && this.unknownWord([e[o]]), o++;
    n12.raws.before += lQ(e, 0, o), n12.source.start = this.getPosition(e[o][2]);
    let i = o;
    for (; o < e.length; ) {
      let p = e[o][0];
      if (p === ":" || p === "space" || p === "comment")
        break;
      o++;
    }
    n12.prop = lQ(e, i, o);
    let u = o, s12;
    for (; o < e.length && (s12 = e[o], o++, s12[0] !== ":"); )
      s12[0] === "word" && /\w/.test(s12[1]) && this.unknownWord([s12]);
    n12.raws.between = lQ(e, u, o), (n12.prop[0] === "_" || n12.prop[0] === "*") && (n12.raws.before += n12.prop[0], n12.prop = n12.prop.slice(1));
    let c = o;
    for (; o < e.length; ) {
      let p = e[o][0];
      if (p !== "space" && p !== "comment")
        break;
      o++;
    }
    let l2 = e.slice(c, o);
    e = e.slice(o), this.precheckMissedSemicolon(e);
    for (let p = e.length - 1; p >= 0; p--) {
      if (s12 = e[p], s12[1].toLowerCase() === "!important") {
        n12.important = true;
        let d = this.stringFrom(e, p);
        d = this.spacesFromEnd(e) + d, d !== " !important" && (n12.raws.important = d);
        break;
      } else if (s12[1].toLowerCase() === "important") {
        let d = e.slice(0), b = "";
        for (let z = p; z > 0; z--) {
          let _ = d[z][0];
          if (b.trim().startsWith("!") && _ !== "space")
            break;
          b = d.pop()[1] + b;
        }
        b.trim().startsWith("!") && (n12.important = true, n12.raws.important = b, e = d);
      }
      if (s12[0] !== "space" && s12[0] !== "comment")
        break;
    }
    e.some((p) => p[0] !== "space" && p[0] !== "comment") && (n12.raws.between += l2.map((p) => p[1]).join(""), l2 = []), this.raw(n12, "value", l2.concat(e), r12), n12.value.includes(":") && !r12 && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let r12 = new Oje();
    this.init(r12, e[2]), r12.selector = "", r12.raws.between = "", this.current = r12;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = false, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let r12 = this.current.nodes[this.current.nodes.length - 1];
      r12 && r12.type === "rule" && !r12.raws.ownSemicolon && (r12.raws.ownSemicolon = this.spaces, this.spaces = "", r12.source.end = this.getPosition(e[2]), r12.source.end.offset += r12.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(e) {
    let r12 = this.input.fromOffset(e);
    return {
      column: r12.col,
      line: r12.line,
      offset: e
    };
  }
  init(e, r12) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(r12)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = false);
  }
  other(e) {
    let r12 = false, n12 = null, a = false, o = null, i = [], u = e[1].startsWith("--"), s12 = [], c = e;
    for (; c; ) {
      if (n12 = c[0], s12.push(c), n12 === "(" || n12 === "[")
        o || (o = c), i.push(n12 === "(" ? ")" : "]");
      else if (u && a && n12 === "{")
        o || (o = c), i.push("}");
      else if (i.length === 0)
        if (n12 === ";")
          if (a) {
            this.decl(s12, u);
            return;
          } else
            break;
        else if (n12 === "{") {
          this.rule(s12);
          return;
        } else if (n12 === "}") {
          this.tokenizer.back(s12.pop()), r12 = true;
          break;
        } else
          n12 === ":" && (a = true);
      else
        n12 === i[i.length - 1] && (i.pop(), i.length === 0 && (o = null));
      c = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (r12 = true), i.length > 0 && this.unclosedBracket(o), r12 && a) {
      if (!u)
        for (; s12.length && (c = s12[s12.length - 1][0], !(c !== "space" && c !== "comment")); )
          this.tokenizer.back(s12.pop());
      this.decl(s12, u);
    } else
      this.unknownWord(s12);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, r12, n12, a) {
    let o, i, u = n12.length, s12 = "", c = true, l2, f;
    for (let p = 0; p < u; p += 1)
      o = n12[p], i = o[0], i === "space" && p === u - 1 && !a ? c = false : i === "comment" ? (f = n12[p - 1] ? n12[p - 1][0] : "empty", l2 = n12[p + 1] ? n12[p + 1][0] : "empty", !zje[f] && !zje[l2] ? s12.slice(-1) === "," ? c = false : s12 += o[1] : c = false) : s12 += o[1];
    if (!c) {
      let p = n12.reduce((d, b) => d + b[1], "");
      e.raws[r12] = { raw: p, value: s12 };
    }
    e[r12] = s12;
  }
  rule(e) {
    e.pop();
    let r12 = new Oje();
    this.init(r12, e[0][2]), r12.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(r12, "selector", e), this.current = r12;
  }
  spacesAndCommentsFromEnd(e) {
    let r12, n12 = "";
    for (; e.length && (r12 = e[e.length - 1][0], !(r12 !== "space" && r12 !== "comment")); )
      n12 = e.pop()[1] + n12;
    return n12;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let r12, n12 = "";
    for (; e.length && (r12 = e[0][0], !(r12 !== "space" && r12 !== "comment")); )
      n12 += e.shift()[1];
    return n12;
  }
  spacesFromEnd(e) {
    let r12, n12 = "";
    for (; e.length && (r12 = e[e.length - 1][0], r12 === "space"); )
      n12 = e.pop()[1] + n12;
    return n12;
  }
  stringFrom(e, r12) {
    let n12 = "";
    for (let a = r12; a < e.length; a++)
      n12 += e[a][1];
    return e.splice(r12, e.length - r12), n12;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word " + e[0][1],
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, r12) {
    throw this.input.error(
      "At-rule without name",
      { offset: r12[2] },
      { offset: r12[2] + r12[1].length }
    );
  }
};
var c11 = s11;
let l11 = Eo, p11 = Jp, d11 = c11;
function k2(t16, e) {
  let r12 = new p11(t16, e), n12 = new d11(r12);
  try {
    n12.parse();
  } catch (a) {
    throw process.env.NODE_ENV !== "production" && a.name === "CssSyntaxError" && e && e.from && (/\.scss$/i.test(e.from) ? a.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(e.from) ? a.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(e.from) && (a.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), a;
  }
  return n12.root;
}
var J0e = k2;
k2.default = k2;
l11.registerParse(k2);
let kZ = class {
  constructor(e, r12 = {}) {
    if (this.type = "warning", this.text = e, r12.node && r12.node.source) {
      let n12 = r12.node.rangeBy(r12);
      this.line = n12.start.line, this.column = n12.start.column, this.endLine = n12.end.line, this.endColumn = n12.end.column;
    }
    for (let n12 in r12)
      this[n12] = r12[n12];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var qYe = kZ;
kZ.default = kZ;
let f11 = qYe, jZ = class {
  get content() {
    return this.css;
  }
  constructor(e, r12, n12) {
    this.processor = e, this.messages = [], this.root = r12, this.opts = n12, this.css = "", this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, r12 = {}) {
    r12.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (r12.plugin = this.lastPlugin.postcssPlugin);
    let n12 = new f11(e, r12);
    return this.messages.push(n12), n12;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
};
var K0e = jZ;
jZ.default = jZ;
let Aje = {};
var TYe = function(e) {
  Aje[e] || (Aje[e] = true, typeof console < "u" && console.warn && console.warn(e));
};
let b11 = Eo, M11 = G0e, O11 = RYe, z11 = J0e, _je = K0e, A11 = Ec, _11 = Xp, { isClean: ln, my: h11 } = Ic, v11 = TYe;
const m11 = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, R11 = {
  AtRule: true,
  AtRuleExit: true,
  Comment: true,
  CommentExit: true,
  Declaration: true,
  DeclarationExit: true,
  Document: true,
  DocumentExit: true,
  Once: true,
  OnceExit: true,
  postcssPlugin: true,
  prepare: true,
  Root: true,
  RootExit: true,
  Rule: true,
  RuleExit: true
}, q11 = {
  Once: true,
  postcssPlugin: true,
  prepare: true
}, qi = 0;
function Fu(t16) {
  return typeof t16 == "object" && typeof t16.then == "function";
}
function yYe(t16) {
  let e = false, r12 = m11[t16.type];
  return t16.type === "decl" ? e = t16.prop.toLowerCase() : t16.type === "atrule" && (e = t16.name.toLowerCase()), e && t16.append ? [
    r12,
    r12 + "-" + e,
    qi,
    r12 + "Exit",
    r12 + "Exit-" + e
  ] : e ? [r12, r12 + "-" + e, r12 + "Exit", r12 + "Exit-" + e] : t16.append ? [r12, qi, r12 + "Exit"] : [r12, r12 + "Exit"];
}
function hje(t16) {
  let e;
  return t16.type === "document" ? e = ["Document", qi, "DocumentExit"] : t16.type === "root" ? e = ["Root", qi, "RootExit"] : e = yYe(t16), {
    eventIndex: 0,
    events: e,
    iterator: 0,
    node: t16,
    visitorIndex: 0,
    visitors: []
  };
}
function FZ(t16) {
  return t16[ln] = false, t16.nodes && t16.nodes.forEach((e) => FZ(e)), t16;
}
let VZ = {}, Ti = class SYe {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(e, r12, n12) {
    this.stringified = false, this.processed = false;
    let a;
    if (typeof r12 == "object" && r12 !== null && (r12.type === "root" || r12.type === "document"))
      a = FZ(r12);
    else if (r12 instanceof SYe || r12 instanceof _je)
      a = FZ(r12.root), r12.map && (typeof n12.map > "u" && (n12.map = {}), n12.map.inline || (n12.map.inline = false), n12.map.prev = r12.map);
    else {
      let o = z11;
      n12.syntax && (o = n12.syntax.parse), n12.parser && (o = n12.parser), o.parse && (o = o.parse);
      try {
        a = o(r12, n12);
      } catch (i) {
        this.processed = true, this.error = i;
      }
      a && !a[h11] && b11.rebuild(a);
    }
    this.result = new _je(e, a, n12), this.helpers = { ...VZ, postcss: VZ, result: this.result }, this.plugins = this.processor.plugins.map((o) => typeof o == "object" && o.prepare ? { ...o, ...o.prepare(this.result) } : o);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(e, r12) {
    let n12 = this.result.lastPlugin;
    try {
      if (r12 && r12.addToError(e), this.error = e, e.name === "CssSyntaxError" && !e.plugin)
        e.plugin = n12.postcssPlugin, e.setMessage();
      else if (n12.postcssVersion && process.env.NODE_ENV !== "production") {
        let a = n12.postcssPlugin, o = n12.postcssVersion, i = this.result.processor.version, u = o.split("."), s12 = i.split(".");
        (u[0] !== s12[0] || parseInt(u[1]) > parseInt(s12[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + i + ", but " + a + " uses " + o + ". Perhaps this is the source of the error below."
        );
      }
    } catch (a) {
      console && console.error && console.error(a);
    }
    return e;
  }
  prepareVisitors() {
    this.listeners = {};
    let e = (r12, n12, a) => {
      this.listeners[n12] || (this.listeners[n12] = []), this.listeners[n12].push([r12, a]);
    };
    for (let r12 of this.plugins)
      if (typeof r12 == "object")
        for (let n12 in r12) {
          if (!R11[n12] && /^[A-Z]/.test(n12))
            throw new Error(
              `Unknown event ${n12} in ${r12.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!q11[n12])
            if (typeof r12[n12] == "object")
              for (let a in r12[n12])
                a === "*" ? e(r12, n12, r12[n12][a]) : e(
                  r12,
                  n12 + "-" + a.toLowerCase(),
                  r12[n12][a]
                );
            else
              typeof r12[n12] == "function" && e(r12, n12, r12[n12]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let e = 0; e < this.plugins.length; e++) {
      let r12 = this.plugins[e], n12 = this.runOnRoot(r12);
      if (Fu(n12))
        try {
          await n12;
        } catch (a) {
          throw this.handleError(a);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[ln]; ) {
        e[ln] = true;
        let r12 = [hje(e)];
        for (; r12.length > 0; ) {
          let n12 = this.visitTick(r12);
          if (Fu(n12))
            try {
              await n12;
            } catch (a) {
              let o = r12[r12.length - 1].node;
              throw this.handleError(a, o);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [r12, n12] of this.listeners.OnceExit) {
          this.result.lastPlugin = r12;
          try {
            if (e.type === "document") {
              let a = e.nodes.map(
                (o) => n12(o, this.helpers)
              );
              await Promise.all(a);
            } else
              await n12(e, this.helpers);
          } catch (a) {
            throw this.handleError(a);
          }
        }
    }
    return this.processed = true, this.stringify();
  }
  runOnRoot(e) {
    this.result.lastPlugin = e;
    try {
      if (typeof e == "object" && e.Once) {
        if (this.result.root.type === "document") {
          let r12 = this.result.root.nodes.map(
            (n12) => e.Once(n12, this.helpers)
          );
          return Fu(r12[0]) ? Promise.all(r12) : r12;
        }
        return e.Once(this.result.root, this.helpers);
      } else if (typeof e == "function")
        return e(this.result.root, this.result);
    } catch (r12) {
      throw this.handleError(r12);
    }
  }
  stringify() {
    if (this.error)
      throw this.error;
    if (this.stringified)
      return this.result;
    this.stringified = true, this.sync();
    let e = this.result.opts, r12 = _11;
    e.syntax && (r12 = e.syntax.stringify), e.stringifier && (r12 = e.stringifier), r12.stringify && (r12 = r12.stringify);
    let n12 = this.result.root.source;
    if (e.map === void 0 && !(n12 && n12.input && n12.input.map)) {
      let i = "";
      return r12(this.result.root, (u) => {
        i += u;
      }), this.result.css = i, this.result;
    }
    let o = new O11(r12, this.result.root, this.result.opts).generate();
    return this.result.css = o[0], this.result.map = o[1], this.result;
  }
  sync() {
    if (this.error)
      throw this.error;
    if (this.processed)
      return this.result;
    if (this.processed = true, this.processing)
      throw this.getAsyncError();
    for (let e of this.plugins) {
      let r12 = this.runOnRoot(e);
      if (Fu(r12))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[ln]; )
        e[ln] = true, this.walkSync(e);
      if (this.listeners.OnceExit)
        if (e.type === "document")
          for (let r12 of e.nodes)
            this.visitSync(this.listeners.OnceExit, r12);
        else
          this.visitSync(this.listeners.OnceExit, e);
    }
    return this.result;
  }
  then(e, r12) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || v11(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, r12);
  }
  toString() {
    return this.css;
  }
  visitSync(e, r12) {
    for (let [n12, a] of e) {
      this.result.lastPlugin = n12;
      let o;
      try {
        o = a(r12, this.helpers);
      } catch (i) {
        throw this.handleError(i, r12.proxyOf);
      }
      if (r12.type !== "root" && r12.type !== "document" && !r12.parent)
        return true;
      if (Fu(o))
        throw this.getAsyncError();
    }
  }
  visitTick(e) {
    let r12 = e[e.length - 1], { node: n12, visitors: a } = r12;
    if (n12.type !== "root" && n12.type !== "document" && !n12.parent) {
      e.pop();
      return;
    }
    if (a.length > 0 && r12.visitorIndex < a.length) {
      let [i, u] = a[r12.visitorIndex];
      r12.visitorIndex += 1, r12.visitorIndex === a.length && (r12.visitors = [], r12.visitorIndex = 0), this.result.lastPlugin = i;
      try {
        return u(n12.toProxy(), this.helpers);
      } catch (s12) {
        throw this.handleError(s12, n12);
      }
    }
    if (r12.iterator !== 0) {
      let i = r12.iterator, u;
      for (; u = n12.nodes[n12.indexes[i]]; )
        if (n12.indexes[i] += 1, !u[ln]) {
          u[ln] = true, e.push(hje(u));
          return;
        }
      r12.iterator = 0, delete n12.indexes[i];
    }
    let o = r12.events;
    for (; r12.eventIndex < o.length; ) {
      let i = o[r12.eventIndex];
      if (r12.eventIndex += 1, i === qi) {
        n12.nodes && n12.nodes.length && (n12[ln] = true, r12.iterator = n12.getIterator());
        return;
      } else if (this.listeners[i]) {
        r12.visitors = this.listeners[i];
        return;
      }
    }
    e.pop();
  }
  walkSync(e) {
    e[ln] = true;
    let r12 = yYe(e);
    for (let n12 of r12)
      if (n12 === qi)
        e.nodes && e.each((a) => {
          a[ln] || this.walkSync(a);
        });
      else {
        let a = this.listeners[n12];
        if (a && this.visitSync(a, e.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
Ti.registerPostcss = (t16) => {
  VZ = t16;
};
var CYe = Ti;
Ti.default = Ti;
A11.registerLazyResult(Ti);
M11.registerLazyResult(Ti);
let T11 = RYe, y11 = J0e, S11 = K0e, C11 = Xp, g11 = TYe, HZ = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, r12 = y11;
    try {
      e = r12(this._css, this._opts);
    } catch (n12) {
      this.error = n12;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(e, r12, n12) {
    r12 = r12.toString(), this.stringified = false, this._processor = e, this._css = r12, this._opts = n12, this._map = void 0;
    let a = C11;
    this.result = new S11(this._processor, void 0, this._opts), this.result.css = r12;
    let o = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return o.root;
      }
    });
    let i = new T11(a, void 0, this._opts, r12);
    if (i.isMap()) {
      let [u, s12] = i.generate();
      u && (this.result.css = u), s12 && (this.result.map = s12);
    } else
      i.clearAnnotation(), this.result.css = i.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error)
      throw this.error;
    return this.result;
  }
  then(e, r12) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || g11(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, r12);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var I11 = HZ;
HZ.default = HZ;
let E11 = G0e, L11 = CYe, P11 = I11, D11 = Ec, Ys = class {
  constructor(e = []) {
    this.version = "8.5.15", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let r12 = [];
    for (let n12 of e)
      if (n12.postcss === true ? n12 = n12() : n12.postcss && (n12 = n12.postcss), typeof n12 == "object" && Array.isArray(n12.plugins))
        r12 = r12.concat(n12.plugins);
      else if (typeof n12 == "object" && n12.postcssPlugin)
        r12.push(n12);
      else if (typeof n12 == "function")
        r12.push(n12);
      else if (typeof n12 == "object" && (n12.parse || n12.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(n12 + " is not a PostCSS plugin");
    return r12;
  }
  process(e, r12 = {}) {
    return !this.plugins.length && !r12.parser && !r12.stringifier && !r12.syntax ? new P11(this, e, r12) : new L11(this, e, r12);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var W11 = Ys;
Ys.default = Ys;
D11.registerProcessor(Ys);
E11.registerProcessor(Ys);
let gYe = $0e, IYe = Gp, N11 = Eo, w11 = V0e, EYe = Yp, LYe = G0e, B11 = x01, x11 = Jp, U11 = CYe, k11 = zYe, j11 = $p, F11 = J0e, Q0e = W11, V11 = K0e, PYe = Ec, DYe = Y0e, H11 = Xp, X11 = qYe;
function t1(...t16) {
  return t16.length === 1 && Array.isArray(t16[0]) && (t16 = t16[0]), new Q0e(t16);
}
t1.plugin = function(e, r12) {
  let n12 = false;
  function a(...i) {
    console && console.warn && !n12 && (n12 = true, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let u = r12(...i);
    return u.postcssPlugin = e, u.postcssVersion = new Q0e().version, u;
  }
  let o;
  return Object.defineProperty(a, "postcss", {
    get() {
      return o || (o = a()), o;
    }
  }), a.process = function(i, u, s12) {
    return t1([a(s12)]).process(i, u);
  }, a;
};
t1.stringify = H11;
t1.parse = F11;
t1.fromJSON = B11;
t1.list = k11;
t1.comment = (t16) => new IYe(t16);
t1.atRule = (t16) => new gYe(t16);
t1.decl = (t16) => new EYe(t16);
t1.rule = (t16) => new DYe(t16);
t1.root = (t16) => new PYe(t16);
t1.document = (t16) => new LYe(t16);
t1.CssSyntaxError = w11;
t1.Declaration = EYe;
t1.Container = N11;
t1.Processor = Q0e;
t1.Document = LYe;
t1.Comment = IYe;
t1.Warning = X11;
t1.AtRule = gYe;
t1.Result = V11;
t1.Input = x11;
t1.Rule = DYe;
t1.Root = PYe;
t1.Node = j11;
U11.registerPostcss(t1);
var $11 = t1;
t1.default = t1;
const G11 = RGe, vje = Ue1, { isPlainObject: Y11 } = j0e, mje = t01, J11 = r01, { parse: K11 } = $11, Q11 = [
  "img",
  "audio",
  "video",
  "picture",
  "svg",
  "object",
  "map",
  "iframe",
  "embed"
], Z11 = ["script", "style"];
function Qo(t16, e) {
  t16 && Object.keys(t16).forEach(function(r12) {
    e(t16[r12], r12);
  });
}
function kn(t16, e) {
  return {}.hasOwnProperty.call(t16, e);
}
function Rje(t16, e) {
  const r12 = [];
  return Qo(t16, function(n12) {
    e(n12) && r12.push(n12);
  }), r12;
}
function et1(t16) {
  for (const e in t16)
    if (kn(t16, e))
      return false;
  return true;
}
function tt1(t16) {
  return t16.map(function(e) {
    if (!e.url)
      throw new Error("URL missing");
    return e.url + (e.w ? ` ${e.w}w` : "") + (e.h ? ` ${e.h}h` : "") + (e.d ? ` ${e.d}x` : "");
  }).join(", ");
}
const nt1 = /^[^\0\t\n\f\r /<=>]+$/;
function Js(t16, e, r12) {
  if (t16 == null)
    return "";
  typeof t16 == "number" && (t16 = t16.toString());
  let n12 = "", a = "";
  function o(I, Y) {
    const oe = this;
    this.tag = I, this.attribs = Y || {}, this.tagPosition = n12.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
      if (_.length) {
        const Z = _[_.length - 1];
        Z.text += oe.text;
      }
    }, this.updateParentNodeMediaChildren = function() {
      _.length && Q11.includes(this.tag) && _[_.length - 1].mediaChildren.push(this.tag);
    };
  }
  e = Object.assign({}, Js.defaults, e), e.parser = Object.assign({}, at1, e.parser);
  const i = function(I) {
    return e.allowedTags === false || (e.allowedTags || []).indexOf(I) > -1;
  };
  Z11.forEach(function(I) {
    i(I) && !e.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${I}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
  });
  const u = e.nonTextTags || [
    "script",
    "style",
    "textarea",
    "option"
  ];
  let s12, c;
  e.allowedAttributes && (s12 = {}, c = {}, Qo(e.allowedAttributes, function(I, Y) {
    s12[Y] = [];
    const oe = [];
    I.forEach(function(Z) {
      typeof Z == "string" && Z.indexOf("*") >= 0 ? oe.push(vje(Z).replace(/\\\*/g, ".*")) : s12[Y].push(Z);
    }), oe.length && (c[Y] = new RegExp("^(" + oe.join("|") + ")$"));
  }));
  const l2 = {}, f = {}, p = {};
  Qo(e.allowedClasses, function(I, Y) {
    if (s12 && (kn(s12, Y) || (s12[Y] = []), s12[Y].push("class")), l2[Y] = I, Array.isArray(I)) {
      const oe = [];
      l2[Y] = [], p[Y] = [], I.forEach(function(Z) {
        typeof Z == "string" && Z.indexOf("*") >= 0 ? oe.push(vje(Z).replace(/\\\*/g, ".*")) : Z instanceof RegExp ? p[Y].push(Z) : l2[Y].push(Z);
      }), oe.length && (f[Y] = new RegExp("^(" + oe.join("|") + ")$"));
    }
  });
  const d = {};
  let b;
  Qo(e.transformTags, function(I, Y) {
    let oe;
    typeof I == "function" ? oe = I : typeof I == "string" && (oe = Js.simpleTransform(I)), Y === "*" ? b = oe : d[Y] = oe;
  });
  let z, _, q, S, N, v, C = false;
  B();
  const L = new G11.Parser({
    onopentag: function(I, Y) {
      if (e.onOpenTag && e.onOpenTag(I, Y), e.enforceHtmlBoundary && I === "html" && B(), N) {
        v++;
        return;
      }
      const oe = new o(I, Y);
      _.push(oe);
      let Z = false;
      const se = !!oe.text;
      let Ie;
      if (kn(d, I) && (Ie = d[I](I, Y), oe.attribs = Y = Ie.attribs, Ie.text !== void 0 && (oe.innerText = Ie.text), I !== Ie.tagName && (oe.name = I = Ie.tagName, S[z] = Ie.tagName)), b && (Ie = b(I, Y), oe.attribs = Y = Ie.attribs, I !== Ie.tagName && (oe.name = I = Ie.tagName, S[z] = Ie.tagName)), (!i(I) || e.disallowedTagsMode === "recursiveEscape" && !et1(q) || e.nestingLimit != null && z >= e.nestingLimit) && (Z = true, q[z] = true, (e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") && u.indexOf(I) !== -1 && (N = true, v = 1)), z++, Z) {
        if (e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") {
          if (oe.innerText && !se) {
            const ne = P12(oe.innerText);
            e.textFilter ? n12 += e.textFilter(ne, I) : n12 += ne, C = true;
          }
          return;
        }
        a = n12, n12 = "";
      }
      n12 += "<" + I, I === "script" && (e.allowedScriptHostnames || e.allowedScriptDomains) && (oe.innerText = ""), Z && (e.disallowedTagsMode === "escape" || e.disallowedTagsMode === "recursiveEscape") && e.preserveEscapedAttributes ? Qo(Y, function(ne, k) {
        n12 += " " + k + '="' + P12(ne || "", true) + '"';
      }) : (!s12 || kn(s12, I) || s12["*"]) && Qo(Y, function(ne, k) {
        if (!nt1.test(k)) {
          delete oe.attribs[k];
          return;
        }
        if (ne === "" && !e.allowedEmptyAttributes.includes(k) && (e.nonBooleanAttributes.includes(k) || e.nonBooleanAttributes.includes("*"))) {
          delete oe.attribs[k];
          return;
        }
        let K = false;
        if (!s12 || kn(s12, I) && s12[I].indexOf(k) !== -1 || s12["*"] && s12["*"].indexOf(k) !== -1 || kn(c, I) && c[I].test(k) || c["*"] && c["*"].test(k))
          K = true;
        else if (s12 && s12[I]) {
          for (const G of s12[I])
            if (Y11(G) && G.name && G.name === k) {
              K = true;
              let Q = "";
              if (G.multiple === true) {
                const ce = ne.split(" ");
                for (const ve of ce)
                  G.values.indexOf(ve) !== -1 && (Q === "" ? Q = ve : Q += " " + ve);
              } else
                G.values.indexOf(ne) >= 0 && (Q = ne);
              ne = Q;
            }
        }
        if (K) {
          if (e.allowedSchemesAppliedToAttributes.indexOf(k) !== -1 && j(I, ne)) {
            delete oe.attribs[k];
            return;
          }
          if (I === "script" && k === "src") {
            let G = true;
            try {
              const Q = $(ne);
              if (e.allowedScriptHostnames || e.allowedScriptDomains) {
                const ce = (e.allowedScriptHostnames || []).find(function(Re) {
                  return Re === Q.url.hostname;
                }), ve = (e.allowedScriptDomains || []).find(function(Re) {
                  return Q.url.hostname === Re || Q.url.hostname.endsWith(`.${Re}`);
                });
                G = ce || ve;
              }
            } catch {
              G = false;
            }
            if (!G) {
              delete oe.attribs[k];
              return;
            }
          }
          if (I === "iframe" && k === "src") {
            let G = true;
            try {
              const Q = $(ne);
              if (Q.isRelativeUrl)
                G = kn(e, "allowIframeRelativeUrls") ? e.allowIframeRelativeUrls : !e.allowedIframeHostnames && !e.allowedIframeDomains;
              else if (e.allowedIframeHostnames || e.allowedIframeDomains) {
                const ce = (e.allowedIframeHostnames || []).find(function(Re) {
                  return Re === Q.url.hostname;
                }), ve = (e.allowedIframeDomains || []).find(function(Re) {
                  return Q.url.hostname === Re || Q.url.hostname.endsWith(`.${Re}`);
                });
                G = ce || ve;
              }
            } catch {
              G = false;
            }
            if (!G) {
              delete oe.attribs[k];
              return;
            }
          }
          if (k === "srcset")
            try {
              let G = J11(ne);
              if (G.forEach(function(Q) {
                j("srcset", Q.url) && (Q.evil = true);
              }), G = Rje(G, function(Q) {
                return !Q.evil;
              }), G.length)
                ne = tt1(Rje(G, function(Q) {
                  return !Q.evil;
                })), oe.attribs[k] = ne;
              else {
                delete oe.attribs[k];
                return;
              }
            } catch {
              delete oe.attribs[k];
              return;
            }
          if (k === "class") {
            const G = l2[I], Q = l2["*"], ce = f[I], ve = p[I], Re = p["*"], le = f["*"], Ae = [
              ce,
              le
            ].concat(ve, Re).filter(function(H) {
              return H;
            });
            if (G && Q ? ne = w(ne, mje(G, Q), Ae) : ne = w(ne, G || Q, Ae), !ne.length) {
              delete oe.attribs[k];
              return;
            }
          }
          if (k === "style") {
            if (e.parseStyleAttributes)
              try {
                const G = K11(I + " {" + ne + "}", { map: false }), Q = W(G, e.allowedStyles);
                if (ne = x(Q), ne.length === 0) {
                  delete oe.attribs[k];
                  return;
                }
              } catch {
                typeof window < "u" && console.warn('Failed to parse "' + I + " {" + ne + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete oe.attribs[k];
                return;
              }
            else if (e.allowedStyles)
              throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
          }
          n12 += " " + k, ne && ne.length ? n12 += '="' + P12(ne, true) + '"' : e.allowedEmptyAttributes.includes(k) && (n12 += '=""');
        } else
          delete oe.attribs[k];
      }), e.selfClosing.indexOf(I) !== -1 ? n12 += " />" : (n12 += ">", oe.innerText && !se && !e.textFilter && (n12 += P12(oe.innerText), C = true)), Z && (n12 = a + P12(n12), a = ""), oe.openingTagLength = n12.length - oe.tagPosition;
    },
    ontext: function(I) {
      if (N)
        return;
      const Y = _[_.length - 1];
      let oe;
      if (Y && (oe = Y.tag, I = Y.innerText !== void 0 ? Y.innerText : I), e.disallowedTagsMode === "completelyDiscard" && !i(oe))
        I = "";
      else if ((e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") && (oe === "script" || oe === "style"))
        n12 += I;
      else if (!C) {
        const Z = P12(I, false);
        e.textFilter ? n12 += e.textFilter(Z, oe) : n12 += Z;
      }
      if (_.length) {
        const Z = _[_.length - 1];
        Z.text += I;
      }
    },
    onclosetag: function(I, Y) {
      if (e.onCloseTag && e.onCloseTag(I, Y), N)
        if (v--, !v)
          N = false;
        else
          return;
      const oe = _.pop();
      if (!oe)
        return;
      if (oe.tag !== I) {
        _.push(oe);
        return;
      }
      N = e.enforceHtmlBoundary ? I === "html" : false, z--;
      const Z = q[z];
      if (Z) {
        if (delete q[z], e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") {
          oe.updateParentNodeText();
          return;
        }
        a = n12, n12 = "";
      }
      if (S[z] && (I = S[z], delete S[z]), e.exclusiveFilter) {
        const se = e.exclusiveFilter(oe);
        if (se === "excludeTag") {
          Z && (n12 = a, a = ""), n12 = n12.substring(0, oe.tagPosition) + n12.substring(oe.tagPosition + oe.openingTagLength);
          return;
        } else if (se) {
          n12 = n12.substring(0, oe.tagPosition);
          return;
        }
      }
      if (oe.updateParentNodeMediaChildren(), oe.updateParentNodeText(), // Already output />
      e.selfClosing.indexOf(I) !== -1 || // Escaped tag, closing tag is implied
      Y && !i(I) && ["escape", "recursiveEscape"].indexOf(e.disallowedTagsMode) >= 0) {
        Z && (n12 = a, a = "");
        return;
      }
      n12 += "</" + I + ">", Z && (n12 = a + P12(n12), a = ""), C = false;
    }
  }, e.parser);
  return L.write(t16), L.end(), n12;
  function B() {
    n12 = "", z = 0, _ = [], q = {}, S = {}, N = false, v = 0;
  }
  function P12(I, Y) {
    return typeof I != "string" && (I = I + ""), e.parser.decodeEntities && (I = I.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), Y && (I = I.replace(/"/g, "&quot;"))), I = I.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), Y && (I = I.replace(/"/g, "&quot;")), I;
  }
  function j(I, Y) {
    for (Y = Y.replace(/[\x00-\x20]+/g, ""); ; ) {
      const se = Y.indexOf("<!--");
      if (se === -1)
        break;
      const Ie = Y.indexOf("-->", se + 4);
      if (Ie === -1)
        break;
      Y = Y.substring(0, se) + Y.substring(Ie + 3);
    }
    const oe = Y.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!oe)
      return Y.match(/^[/\\]{2}/) ? !e.allowProtocolRelative : false;
    const Z = oe[1].toLowerCase();
    return kn(e.allowedSchemesByTag, I) ? e.allowedSchemesByTag[I].indexOf(Z) === -1 : !e.allowedSchemes || e.allowedSchemes.indexOf(Z) === -1;
  }
  function $(I) {
    if (I = I.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), I.startsWith("relative:"))
      throw new Error("relative: exploit attempt");
    let Y = "relative://relative-site";
    for (let se = 0; se < 100; se++)
      Y += `/${se}`;
    const oe = new URL(I, Y);
    return {
      isRelativeUrl: oe && oe.hostname === "relative-site" && oe.protocol === "relative:",
      url: oe
    };
  }
  function W(I, Y) {
    if (!Y)
      return I;
    const oe = I.nodes[0];
    let Z;
    return Y[oe.selector] && Y["*"] ? Z = mje(
      Y[oe.selector],
      Y["*"]
    ) : Z = Y[oe.selector] || Y["*"], Z && (I.nodes[0].nodes = oe.nodes.reduce(D(Z), [])), I;
  }
  function x(I) {
    return I.nodes[0].nodes.reduce(function(Y, oe) {
      return Y.push(
        `${oe.prop}:${oe.value}${oe.important ? " !important" : ""}`
      ), Y;
    }, []).join(";");
  }
  function D(I) {
    return function(Y, oe) {
      return kn(I, oe.prop) && I[oe.prop].some(function(se) {
        return se.test(oe.value);
      }) && Y.push(oe), Y;
    };
  }
  function w(I, Y, oe) {
    return Y ? (I = I.split(/\s+/), I.filter(function(Z) {
      return Y.indexOf(Z) !== -1 || oe.some(function(se) {
        return se.test(Z);
      });
    }).join(" ")) : I;
  }
}
const at1 = {
  decodeEntities: true
};
Js.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hgroup",
    "main",
    "nav",
    "section",
    // Text content
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "menu",
    "ol",
    "p",
    "pre",
    "ul",
    // Inline text semantics
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    // Table content
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
  ],
  // Tags that cannot be boolean
  nonBooleanAttributes: [
    "abbr",
    "accept",
    "accept-charset",
    "accesskey",
    "action",
    "allow",
    "alt",
    "as",
    "autocapitalize",
    "autocomplete",
    "blocking",
    "charset",
    "cite",
    "class",
    "color",
    "cols",
    "colspan",
    "content",
    "contenteditable",
    "coords",
    "crossorigin",
    "data",
    "datetime",
    "decoding",
    "dir",
    "dirname",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "fetchpriority",
    "for",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formtarget",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "http-equiv",
    "id",
    "imagesizes",
    "imagesrcset",
    "inputmode",
    "integrity",
    "is",
    "itemid",
    "itemprop",
    "itemref",
    "itemtype",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "name",
    "nonce",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "referrerpolicy",
    "rel",
    "rows",
    "rowspan",
    "sandbox",
    "scope",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "spellcheck",
    "src",
    "srcdoc",
    "srclang",
    "srcset",
    "start",
    "step",
    "style",
    "tabindex",
    "target",
    "title",
    "translate",
    "type",
    "usemap",
    "value",
    "width",
    "wrap",
    // Event handlers
    "onauxclick",
    "onafterprint",
    "onbeforematch",
    "onbeforeprint",
    "onbeforeunload",
    "onbeforetoggle",
    "onblur",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "onchange",
    "onclick",
    "onclose",
    "oncontextlost",
    "oncontextmenu",
    "oncontextrestored",
    "oncopy",
    "oncuechange",
    "oncut",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onerror",
    "onfocus",
    "onformdata",
    "onhashchange",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onlanguagechange",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmessage",
    "onmessageerror",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onoffline",
    "ononline",
    "onpagehide",
    "onpageshow",
    "onpaste",
    "onpause",
    "onplay",
    "onplaying",
    "onpopstate",
    "onprogress",
    "onratechange",
    "onreset",
    "onresize",
    "onrejectionhandled",
    "onscroll",
    "onscrollend",
    "onsecuritypolicyviolation",
    "onseeked",
    "onseeking",
    "onselect",
    "onslotchange",
    "onstalled",
    "onstorage",
    "onsubmit",
    "onsuspend",
    "ontimeupdate",
    "ontoggle",
    "onunhandledrejection",
    "onunload",
    "onvolumechange",
    "onwaiting",
    "onwheel"
  ],
  disallowedTagsMode: "discard",
  allowedAttributes: {
    a: ["href", "name", "target"],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
  },
  allowedEmptyAttributes: [
    "alt"
  ],
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
  // URL schemes we permit
  allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
  allowProtocolRelative: true,
  enforceHtmlBoundary: false,
  parseStyleAttributes: true,
  preserveEscapedAttributes: false
};
Js.simpleTransform = function(t16, e, r12) {
  return r12 = r12 === void 0 ? true : r12, e = e || {}, function(n12, a) {
    let o;
    if (r12)
      for (o in e)
        a[o] = e[o];
    else
      a = e;
    return {
      tagName: t16,
      attribs: a
    };
  };
};
var Jt = "top", Rr = "bottom", qr = "right", Kt = "left", e1e = "auto", Lc = [Jt, Rr, qr, Kt], yi = "start", Ks = "end", ot1 = "clippingParents", WYe = "viewport", Vu = "popper", it1 = "reference", qje = /* @__PURE__ */ Lc.reduce(function(t16, e) {
  return t16.concat([e + "-" + yi, e + "-" + Ks]);
}, []), NYe = /* @__PURE__ */ [].concat(Lc, [e1e]).reduce(function(t16, e) {
  return t16.concat([e, e + "-" + yi, e + "-" + Ks]);
}, []), ut1 = "beforeRead", st1 = "read", ct1 = "afterRead", lt1 = "beforeMain", pt1 = "main", dt1 = "afterMain", ft1 = "beforeWrite", bt1 = "write", Mt1 = "afterWrite", Ot1 = [ut1, st1, ct1, lt1, pt1, dt1, ft1, bt1, Mt1];
function vn(t16) {
  return t16 ? (t16.nodeName || "").toLowerCase() : null;
}
function un(t16) {
  if (t16 == null)
    return window;
  if (t16.toString() !== "[object Window]") {
    var e = t16.ownerDocument;
    return e && e.defaultView || window;
  }
  return t16;
}
function Si(t16) {
  var e = un(t16).Element;
  return t16 instanceof e || t16 instanceof Element;
}
function mr(t16) {
  var e = un(t16).HTMLElement;
  return t16 instanceof e || t16 instanceof HTMLElement;
}
function wYe(t16) {
  if (typeof ShadowRoot > "u")
    return false;
  var e = un(t16).ShadowRoot;
  return t16 instanceof e || t16 instanceof ShadowRoot;
}
function zt1(t16) {
  var e = t16.state;
  Object.keys(e.elements).forEach(function(r12) {
    var n12 = e.styles[r12] || {}, a = e.attributes[r12] || {}, o = e.elements[r12];
    !mr(o) || !vn(o) || (Object.assign(o.style, n12), Object.keys(a).forEach(function(i) {
      var u = a[i];
      u === false ? o.removeAttribute(i) : o.setAttribute(i, u === true ? "" : u);
    }));
  });
}
function At1(t16) {
  var e = t16.state, r12 = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, r12.popper), e.styles = r12, e.elements.arrow && Object.assign(e.elements.arrow.style, r12.arrow), function() {
    Object.keys(e.elements).forEach(function(n12) {
      var a = e.elements[n12], o = e.attributes[n12] || {}, i = Object.keys(e.styles.hasOwnProperty(n12) ? e.styles[n12] : r12[n12]), u = i.reduce(function(s12, c) {
        return s12[c] = "", s12;
      }, {});
      !mr(a) || !vn(a) || (Object.assign(a.style, u), Object.keys(o).forEach(function(s12) {
        a.removeAttribute(s12);
      }));
    });
  };
}
var BYe = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: zt1,
  effect: At1,
  requires: ["computeStyles"]
};
function On(t16) {
  return t16.split("-")[0];
}
var _o = Math.max, j2 = Math.min, Ci = Math.round;
function gi(t16, e) {
  e === void 0 && (e = false);
  var r12 = t16.getBoundingClientRect(), n12 = 1, a = 1;
  if (mr(t16) && e) {
    var o = t16.offsetHeight, i = t16.offsetWidth;
    i > 0 && (n12 = Ci(r12.width) / i || 1), o > 0 && (a = Ci(r12.height) / o || 1);
  }
  return {
    width: r12.width / n12,
    height: r12.height / a,
    top: r12.top / a,
    right: r12.right / n12,
    bottom: r12.bottom / a,
    left: r12.left / n12,
    x: r12.left / n12,
    y: r12.top / a
  };
}
function t1e(t16) {
  var e = gi(t16), r12 = t16.offsetWidth, n12 = t16.offsetHeight;
  return Math.abs(e.width - r12) <= 1 && (r12 = e.width), Math.abs(e.height - n12) <= 1 && (n12 = e.height), {
    x: t16.offsetLeft,
    y: t16.offsetTop,
    width: r12,
    height: n12
  };
}
function xYe(t16, e) {
  var r12 = e.getRootNode && e.getRootNode();
  if (t16.contains(e))
    return true;
  if (r12 && wYe(r12)) {
    var n12 = e;
    do {
      if (n12 && t16.isSameNode(n12))
        return true;
      n12 = n12.parentNode || n12.host;
    } while (n12);
  }
  return false;
}
function mn(t16) {
  return un(t16).getComputedStyle(t16);
}
function _t1(t16) {
  return ["table", "td", "th"].indexOf(vn(t16)) >= 0;
}
function Xa(t16) {
  return ((Si(t16) ? t16.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t16.document
  )) || window.document).documentElement;
}
function Kp(t16) {
  return vn(t16) === "html" ? t16 : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t16.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t16.parentNode || // DOM Element detected
    (wYe(t16) ? t16.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Xa(t16)
  );
}
function Tje(t16) {
  return !mr(t16) || // https://github.com/popperjs/popper-core/issues/837
  mn(t16).position === "fixed" ? null : t16.offsetParent;
}
function ht1(t16) {
  var e = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, r12 = navigator.userAgent.indexOf("Trident") !== -1;
  if (r12 && mr(t16)) {
    var n12 = mn(t16);
    if (n12.position === "fixed")
      return null;
  }
  for (var a = Kp(t16); mr(a) && ["html", "body"].indexOf(vn(a)) < 0; ) {
    var o = mn(a);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || e && o.willChange === "filter" || e && o.filter && o.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function Pc(t16) {
  for (var e = un(t16), r12 = Tje(t16); r12 && _t1(r12) && mn(r12).position === "static"; )
    r12 = Tje(r12);
  return r12 && (vn(r12) === "html" || vn(r12) === "body" && mn(r12).position === "static") ? e : r12 || ht1(t16) || e;
}
function r1e(t16) {
  return ["top", "bottom"].indexOf(t16) >= 0 ? "x" : "y";
}
function As(t16, e, r12) {
  return _o(t16, j2(e, r12));
}
function vt1(t16, e, r12) {
  var n12 = As(t16, e, r12);
  return n12 > r12 ? r12 : n12;
}
function UYe() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function kYe(t16) {
  return Object.assign({}, UYe(), t16);
}
function jYe(t16, e) {
  return e.reduce(function(r12, n12) {
    return r12[n12] = t16, r12;
  }, {});
}
var mt1 = function(e, r12) {
  return e = typeof e == "function" ? e(Object.assign({}, r12.rects, {
    placement: r12.placement
  })) : e, kYe(typeof e != "number" ? e : jYe(e, Lc));
};
function Rt1(t16) {
  var e, r12 = t16.state, n12 = t16.name, a = t16.options, o = r12.elements.arrow, i = r12.modifiersData.popperOffsets, u = On(r12.placement), s12 = r1e(u), c = [Kt, qr].indexOf(u) >= 0, l2 = c ? "height" : "width";
  if (!(!o || !i)) {
    var f = mt1(a.padding, r12), p = t1e(o), d = s12 === "y" ? Jt : Kt, b = s12 === "y" ? Rr : qr, z = r12.rects.reference[l2] + r12.rects.reference[s12] - i[s12] - r12.rects.popper[l2], _ = i[s12] - r12.rects.reference[s12], q = Pc(o), S = q ? s12 === "y" ? q.clientHeight || 0 : q.clientWidth || 0 : 0, N = z / 2 - _ / 2, v = f[d], C = S - p[l2] - f[b], L = S / 2 - p[l2] / 2 + N, B = As(v, L, C), P12 = s12;
    r12.modifiersData[n12] = (e = {}, e[P12] = B, e.centerOffset = B - L, e);
  }
}
function qt1(t16) {
  var e = t16.state, r12 = t16.options, n12 = r12.element, a = n12 === void 0 ? "[data-popper-arrow]" : n12;
  a != null && (typeof a == "string" && (a = e.elements.popper.querySelector(a), !a) || xYe(e.elements.popper, a) && (e.elements.arrow = a));
}
var Tt1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: Rt1,
  effect: qt1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ii(t16) {
  return t16.split("-")[1];
}
var yt1 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function St1(t16) {
  var e = t16.x, r12 = t16.y, n12 = window, a = n12.devicePixelRatio || 1;
  return {
    x: Ci(e * a) / a || 0,
    y: Ci(r12 * a) / a || 0
  };
}
function yje(t16) {
  var e, r12 = t16.popper, n12 = t16.popperRect, a = t16.placement, o = t16.variation, i = t16.offsets, u = t16.position, s12 = t16.gpuAcceleration, c = t16.adaptive, l2 = t16.roundOffsets, f = t16.isFixed, p = l2 === true ? St1(i) : typeof l2 == "function" ? l2(i) : i, d = p.x, b = d === void 0 ? 0 : d, z = p.y, _ = z === void 0 ? 0 : z, q = i.hasOwnProperty("x"), S = i.hasOwnProperty("y"), N = Kt, v = Jt, C = window;
  if (c) {
    var L = Pc(r12), B = "clientHeight", P12 = "clientWidth";
    if (L === un(r12) && (L = Xa(r12), mn(L).position !== "static" && u === "absolute" && (B = "scrollHeight", P12 = "scrollWidth")), L = L, a === Jt || (a === Kt || a === qr) && o === Ks) {
      v = Rr;
      var j = f && C.visualViewport ? C.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        L[B]
      );
      _ -= j - n12.height, _ *= s12 ? 1 : -1;
    }
    if (a === Kt || (a === Jt || a === Rr) && o === Ks) {
      N = qr;
      var $ = f && C.visualViewport ? C.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        L[P12]
      );
      b -= $ - n12.width, b *= s12 ? 1 : -1;
    }
  }
  var W = Object.assign({
    position: u
  }, c && yt1);
  if (s12) {
    var x;
    return Object.assign({}, W, (x = {}, x[v] = S ? "0" : "", x[N] = q ? "0" : "", x.transform = (C.devicePixelRatio || 1) <= 1 ? "translate(" + b + "px, " + _ + "px)" : "translate3d(" + b + "px, " + _ + "px, 0)", x));
  }
  return Object.assign({}, W, (e = {}, e[v] = S ? _ + "px" : "", e[N] = q ? b + "px" : "", e.transform = "", e));
}
function Ct1(t16) {
  var e = t16.state, r12 = t16.options, n12 = r12.gpuAcceleration, a = n12 === void 0 ? true : n12, o = r12.adaptive, i = o === void 0 ? true : o, u = r12.roundOffsets, s12 = u === void 0 ? true : u, c = {
    placement: On(e.placement),
    variation: Ii(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: a,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, yje(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: i,
    roundOffsets: s12
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, yje(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: false,
    roundOffsets: s12
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
var gt1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: Ct1,
  data: {}
}, Il = {
  passive: true
};
function It1(t16) {
  var e = t16.state, r12 = t16.instance, n12 = t16.options, a = n12.scroll, o = a === void 0 ? true : a, i = n12.resize, u = i === void 0 ? true : i, s12 = un(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return o && c.forEach(function(l2) {
    l2.addEventListener("scroll", r12.update, Il);
  }), u && s12.addEventListener("resize", r12.update, Il), function() {
    o && c.forEach(function(l2) {
      l2.removeEventListener("scroll", r12.update, Il);
    }), u && s12.removeEventListener("resize", r12.update, Il);
  };
}
var Et1 = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function() {
  },
  effect: It1,
  data: {}
}, Lt1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function a2(t16) {
  return t16.replace(/left|right|bottom|top/g, function(e) {
    return Lt1[e];
  });
}
var Pt1 = {
  start: "end",
  end: "start"
};
function Sje(t16) {
  return t16.replace(/start|end/g, function(e) {
    return Pt1[e];
  });
}
function n1e(t16) {
  var e = un(t16), r12 = e.pageXOffset, n12 = e.pageYOffset;
  return {
    scrollLeft: r12,
    scrollTop: n12
  };
}
function a1e(t16) {
  return gi(Xa(t16)).left + n1e(t16).scrollLeft;
}
function Dt1(t16) {
  var e = un(t16), r12 = Xa(t16), n12 = e.visualViewport, a = r12.clientWidth, o = r12.clientHeight, i = 0, u = 0;
  return n12 && (a = n12.width, o = n12.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (i = n12.offsetLeft, u = n12.offsetTop)), {
    width: a,
    height: o,
    x: i + a1e(t16),
    y: u
  };
}
function Wt1(t16) {
  var e, r12 = Xa(t16), n12 = n1e(t16), a = (e = t16.ownerDocument) == null ? void 0 : e.body, o = _o(r12.scrollWidth, r12.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), i = _o(r12.scrollHeight, r12.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), u = -n12.scrollLeft + a1e(t16), s12 = -n12.scrollTop;
  return mn(a || r12).direction === "rtl" && (u += _o(r12.clientWidth, a ? a.clientWidth : 0) - o), {
    width: o,
    height: i,
    x: u,
    y: s12
  };
}
function o1e(t16) {
  var e = mn(t16), r12 = e.overflow, n12 = e.overflowX, a = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(r12 + a + n12);
}
function FYe(t16) {
  return ["html", "body", "#document"].indexOf(vn(t16)) >= 0 ? t16.ownerDocument.body : mr(t16) && o1e(t16) ? t16 : FYe(Kp(t16));
}
function _s(t16, e) {
  var r12;
  e === void 0 && (e = []);
  var n12 = FYe(t16), a = n12 === ((r12 = t16.ownerDocument) == null ? void 0 : r12.body), o = un(n12), i = a ? [o].concat(o.visualViewport || [], o1e(n12) ? n12 : []) : n12, u = e.concat(i);
  return a ? u : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    u.concat(_s(Kp(i)))
  );
}
function XZ(t16) {
  return Object.assign({}, t16, {
    left: t16.x,
    top: t16.y,
    right: t16.x + t16.width,
    bottom: t16.y + t16.height
  });
}
function Nt1(t16) {
  var e = gi(t16);
  return e.top = e.top + t16.clientTop, e.left = e.left + t16.clientLeft, e.bottom = e.top + t16.clientHeight, e.right = e.left + t16.clientWidth, e.width = t16.clientWidth, e.height = t16.clientHeight, e.x = e.left, e.y = e.top, e;
}
function Cje(t16, e) {
  return e === WYe ? XZ(Dt1(t16)) : Si(e) ? Nt1(e) : XZ(Wt1(Xa(t16)));
}
function wt1(t16) {
  var e = _s(Kp(t16)), r12 = ["absolute", "fixed"].indexOf(mn(t16).position) >= 0, n12 = r12 && mr(t16) ? Pc(t16) : t16;
  return Si(n12) ? e.filter(function(a) {
    return Si(a) && xYe(a, n12) && vn(a) !== "body" && (r12 ? mn(a).position !== "static" : true);
  }) : [];
}
function Bt1(t16, e, r12) {
  var n12 = e === "clippingParents" ? wt1(t16) : [].concat(e), a = [].concat(n12, [r12]), o = a[0], i = a.reduce(function(u, s12) {
    var c = Cje(t16, s12);
    return u.top = _o(c.top, u.top), u.right = j2(c.right, u.right), u.bottom = j2(c.bottom, u.bottom), u.left = _o(c.left, u.left), u;
  }, Cje(t16, o));
  return i.width = i.right - i.left, i.height = i.bottom - i.top, i.x = i.left, i.y = i.top, i;
}
function VYe(t16) {
  var e = t16.reference, r12 = t16.element, n12 = t16.placement, a = n12 ? On(n12) : null, o = n12 ? Ii(n12) : null, i = e.x + e.width / 2 - r12.width / 2, u = e.y + e.height / 2 - r12.height / 2, s12;
  switch (a) {
    case Jt:
      s12 = {
        x: i,
        y: e.y - r12.height
      };
      break;
    case Rr:
      s12 = {
        x: i,
        y: e.y + e.height
      };
      break;
    case qr:
      s12 = {
        x: e.x + e.width,
        y: u
      };
      break;
    case Kt:
      s12 = {
        x: e.x - r12.width,
        y: u
      };
      break;
    default:
      s12 = {
        x: e.x,
        y: e.y
      };
  }
  var c = a ? r1e(a) : null;
  if (c != null) {
    var l2 = c === "y" ? "height" : "width";
    switch (o) {
      case yi:
        s12[c] = s12[c] - (e[l2] / 2 - r12[l2] / 2);
        break;
      case Ks:
        s12[c] = s12[c] + (e[l2] / 2 - r12[l2] / 2);
        break;
    }
  }
  return s12;
}
function Qs(t16, e) {
  e === void 0 && (e = {});
  var r12 = e, n12 = r12.placement, a = n12 === void 0 ? t16.placement : n12, o = r12.boundary, i = o === void 0 ? ot1 : o, u = r12.rootBoundary, s12 = u === void 0 ? WYe : u, c = r12.elementContext, l2 = c === void 0 ? Vu : c, f = r12.altBoundary, p = f === void 0 ? false : f, d = r12.padding, b = d === void 0 ? 0 : d, z = kYe(typeof b != "number" ? b : jYe(b, Lc)), _ = l2 === Vu ? it1 : Vu, q = t16.rects.popper, S = t16.elements[p ? _ : l2], N = Bt1(Si(S) ? S : S.contextElement || Xa(t16.elements.popper), i, s12), v = gi(t16.elements.reference), C = VYe({
    reference: v,
    element: q,
    placement: a
  }), L = XZ(Object.assign({}, q, C)), B = l2 === Vu ? L : v, P12 = {
    top: N.top - B.top + z.top,
    bottom: B.bottom - N.bottom + z.bottom,
    left: N.left - B.left + z.left,
    right: B.right - N.right + z.right
  }, j = t16.modifiersData.offset;
  if (l2 === Vu && j) {
    var $ = j[a];
    Object.keys(P12).forEach(function(W) {
      var x = [qr, Rr].indexOf(W) >= 0 ? 1 : -1, D = [Jt, Rr].indexOf(W) >= 0 ? "y" : "x";
      P12[W] += $[D] * x;
    });
  }
  return P12;
}
function xt1(t16, e) {
  e === void 0 && (e = {});
  var r12 = e, n12 = r12.placement, a = r12.boundary, o = r12.rootBoundary, i = r12.padding, u = r12.flipVariations, s12 = r12.allowedAutoPlacements, c = s12 === void 0 ? NYe : s12, l2 = Ii(n12), f = l2 ? u ? qje : qje.filter(function(b) {
    return Ii(b) === l2;
  }) : Lc, p = f.filter(function(b) {
    return c.indexOf(b) >= 0;
  });
  p.length === 0 && (p = f);
  var d = p.reduce(function(b, z) {
    return b[z] = Qs(t16, {
      placement: z,
      boundary: a,
      rootBoundary: o,
      padding: i
    })[On(z)], b;
  }, {});
  return Object.keys(d).sort(function(b, z) {
    return d[b] - d[z];
  });
}
function Ut1(t16) {
  if (On(t16) === e1e)
    return [];
  var e = a2(t16);
  return [Sje(t16), e, Sje(e)];
}
function kt1(t16) {
  var e = t16.state, r12 = t16.options, n12 = t16.name;
  if (!e.modifiersData[n12]._skip) {
    for (var a = r12.mainAxis, o = a === void 0 ? true : a, i = r12.altAxis, u = i === void 0 ? true : i, s12 = r12.fallbackPlacements, c = r12.padding, l2 = r12.boundary, f = r12.rootBoundary, p = r12.altBoundary, d = r12.flipVariations, b = d === void 0 ? true : d, z = r12.allowedAutoPlacements, _ = e.options.placement, q = On(_), S = q === _, N = s12 || (S || !b ? [a2(_)] : Ut1(_)), v = [_].concat(N).reduce(function(k, K) {
      return k.concat(On(K) === e1e ? xt1(e, {
        placement: K,
        boundary: l2,
        rootBoundary: f,
        padding: c,
        flipVariations: b,
        allowedAutoPlacements: z
      }) : K);
    }, []), C = e.rects.reference, L = e.rects.popper, B = /* @__PURE__ */ new Map(), P12 = true, j = v[0], $ = 0; $ < v.length; $++) {
      var W = v[$], x = On(W), D = Ii(W) === yi, w = [Jt, Rr].indexOf(x) >= 0, I = w ? "width" : "height", Y = Qs(e, {
        placement: W,
        boundary: l2,
        rootBoundary: f,
        altBoundary: p,
        padding: c
      }), oe = w ? D ? qr : Kt : D ? Rr : Jt;
      C[I] > L[I] && (oe = a2(oe));
      var Z = a2(oe), se = [];
      if (o && se.push(Y[x] <= 0), u && se.push(Y[oe] <= 0, Y[Z] <= 0), se.every(function(k) {
        return k;
      })) {
        j = W, P12 = false;
        break;
      }
      B.set(W, se);
    }
    if (P12)
      for (var Ie = b ? 3 : 1, ie = function(K) {
        var G = v.find(function(Q) {
          var ce = B.get(Q);
          if (ce)
            return ce.slice(0, K).every(function(ve) {
              return ve;
            });
        });
        if (G)
          return j = G, "break";
      }, ye = Ie; ye > 0; ye--) {
        var ne = ie(ye);
        if (ne === "break")
          break;
      }
    e.placement !== j && (e.modifiersData[n12]._skip = true, e.placement = j, e.reset = true);
  }
}
var jt1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: kt1,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function gje(t16, e, r12) {
  return r12 === void 0 && (r12 = {
    x: 0,
    y: 0
  }), {
    top: t16.top - e.height - r12.y,
    right: t16.right - e.width + r12.x,
    bottom: t16.bottom - e.height + r12.y,
    left: t16.left - e.width - r12.x
  };
}
function Ije(t16) {
  return [Jt, qr, Rr, Kt].some(function(e) {
    return t16[e] >= 0;
  });
}
function Ft1(t16) {
  var e = t16.state, r12 = t16.name, n12 = e.rects.reference, a = e.rects.popper, o = e.modifiersData.preventOverflow, i = Qs(e, {
    elementContext: "reference"
  }), u = Qs(e, {
    altBoundary: true
  }), s12 = gje(i, n12), c = gje(u, a, o), l2 = Ije(s12), f = Ije(c);
  e.modifiersData[r12] = {
    referenceClippingOffsets: s12,
    popperEscapeOffsets: c,
    isReferenceHidden: l2,
    hasPopperEscaped: f
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": l2,
    "data-popper-escaped": f
  });
}
var Vt1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Ft1
};
function Ht1(t16, e, r12) {
  var n12 = On(t16), a = [Kt, Jt].indexOf(n12) >= 0 ? -1 : 1, o = typeof r12 == "function" ? r12(Object.assign({}, e, {
    placement: t16
  })) : r12, i = o[0], u = o[1];
  return i = i || 0, u = (u || 0) * a, [Kt, qr].indexOf(n12) >= 0 ? {
    x: u,
    y: i
  } : {
    x: i,
    y: u
  };
}
function Xt1(t16) {
  var e = t16.state, r12 = t16.options, n12 = t16.name, a = r12.offset, o = a === void 0 ? [0, 0] : a, i = NYe.reduce(function(l2, f) {
    return l2[f] = Ht1(f, e.rects, o), l2;
  }, {}), u = i[e.placement], s12 = u.x, c = u.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += s12, e.modifiersData.popperOffsets.y += c), e.modifiersData[n12] = i;
}
var $t1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Xt1
};
function Gt1(t16) {
  var e = t16.state, r12 = t16.name;
  e.modifiersData[r12] = VYe({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
var Yt1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: Gt1,
  data: {}
};
function Jt1(t16) {
  return t16 === "x" ? "y" : "x";
}
function Kt1(t16) {
  var e = t16.state, r12 = t16.options, n12 = t16.name, a = r12.mainAxis, o = a === void 0 ? true : a, i = r12.altAxis, u = i === void 0 ? false : i, s12 = r12.boundary, c = r12.rootBoundary, l2 = r12.altBoundary, f = r12.padding, p = r12.tether, d = p === void 0 ? true : p, b = r12.tetherOffset, z = b === void 0 ? 0 : b, _ = Qs(e, {
    boundary: s12,
    rootBoundary: c,
    padding: f,
    altBoundary: l2
  }), q = On(e.placement), S = Ii(e.placement), N = !S, v = r1e(q), C = Jt1(v), L = e.modifiersData.popperOffsets, B = e.rects.reference, P12 = e.rects.popper, j = typeof z == "function" ? z(Object.assign({}, e.rects, {
    placement: e.placement
  })) : z, $ = typeof j == "number" ? {
    mainAxis: j,
    altAxis: j
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, j), W = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, x = {
    x: 0,
    y: 0
  };
  if (L) {
    if (o) {
      var D, w = v === "y" ? Jt : Kt, I = v === "y" ? Rr : qr, Y = v === "y" ? "height" : "width", oe = L[v], Z = oe + _[w], se = oe - _[I], Ie = d ? -P12[Y] / 2 : 0, ie = S === yi ? B[Y] : P12[Y], ye = S === yi ? -P12[Y] : -B[Y], ne = e.elements.arrow, k = d && ne ? t1e(ne) : {
        width: 0,
        height: 0
      }, K = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : UYe(), G = K[w], Q = K[I], ce = As(0, B[Y], k[Y]), ve = N ? B[Y] / 2 - Ie - ce - G - $.mainAxis : ie - ce - G - $.mainAxis, Re = N ? -B[Y] / 2 + Ie + ce + Q + $.mainAxis : ye + ce + Q + $.mainAxis, le = e.elements.arrow && Pc(e.elements.arrow), Ae = le ? v === "y" ? le.clientTop || 0 : le.clientLeft || 0 : 0, H = (D = W == null ? void 0 : W[v]) != null ? D : 0, re = oe + ve - H - Ae, ue = oe + Re - H, Me = As(d ? j2(Z, re) : Z, oe, d ? _o(se, ue) : se);
      L[v] = Me, x[v] = Me - oe;
    }
    if (u) {
      var Se, $e = v === "x" ? Jt : Kt, a0 = v === "x" ? Rr : qr, Ne = L[C], Ye = C === "y" ? "height" : "width", $0 = Ne + _[$e], Be = Ne - _[a0], o0 = [Jt, Kt].indexOf(q) !== -1, Ke = (Se = W == null ? void 0 : W[C]) != null ? Se : 0, I0 = o0 ? $0 : Ne - B[Ye] - P12[Ye] - Ke + $.altAxis, b0 = o0 ? Ne + B[Ye] + P12[Ye] - Ke - $.altAxis : Be, P1 = d && o0 ? vt1(I0, Ne, b0) : As(d ? I0 : $0, Ne, d ? b0 : Be);
      L[C] = P1, x[C] = P1 - Ne;
    }
    e.modifiersData[n12] = x;
  }
}
var Qt1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: Kt1,
  requiresIfExists: ["offset"]
};
function Zt1(t16) {
  return {
    scrollLeft: t16.scrollLeft,
    scrollTop: t16.scrollTop
  };
}
function er1(t16) {
  return t16 === un(t16) || !mr(t16) ? n1e(t16) : Zt1(t16);
}
function tr1(t16) {
  var e = t16.getBoundingClientRect(), r12 = Ci(e.width) / t16.offsetWidth || 1, n12 = Ci(e.height) / t16.offsetHeight || 1;
  return r12 !== 1 || n12 !== 1;
}
function rr1(t16, e, r12) {
  r12 === void 0 && (r12 = false);
  var n12 = mr(e), a = mr(e) && tr1(e), o = Xa(e), i = gi(t16, a), u = {
    scrollLeft: 0,
    scrollTop: 0
  }, s12 = {
    x: 0,
    y: 0
  };
  return (n12 || !n12 && !r12) && ((vn(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  o1e(o)) && (u = er1(e)), mr(e) ? (s12 = gi(e, true), s12.x += e.clientLeft, s12.y += e.clientTop) : o && (s12.x = a1e(o))), {
    x: i.left + u.scrollLeft - s12.x,
    y: i.top + u.scrollTop - s12.y,
    width: i.width,
    height: i.height
  };
}
function nr1(t16) {
  var e = /* @__PURE__ */ new Map(), r12 = /* @__PURE__ */ new Set(), n12 = [];
  t16.forEach(function(o) {
    e.set(o.name, o);
  });
  function a(o) {
    r12.add(o.name);
    var i = [].concat(o.requires || [], o.requiresIfExists || []);
    i.forEach(function(u) {
      if (!r12.has(u)) {
        var s12 = e.get(u);
        s12 && a(s12);
      }
    }), n12.push(o);
  }
  return t16.forEach(function(o) {
    r12.has(o.name) || a(o);
  }), n12;
}
function ar1(t16) {
  var e = nr1(t16);
  return Ot1.reduce(function(r12, n12) {
    return r12.concat(e.filter(function(a) {
      return a.phase === n12;
    }));
  }, []);
}
function or1(t16) {
  var e;
  return function() {
    return e || (e = new Promise(function(r12) {
      Promise.resolve().then(function() {
        e = void 0, r12(t16());
      });
    })), e;
  };
}
function ir1(t16) {
  var e = t16.reduce(function(r12, n12) {
    var a = r12[n12.name];
    return r12[n12.name] = a ? Object.assign({}, a, n12, {
      options: Object.assign({}, a.options, n12.options),
      data: Object.assign({}, a.data, n12.data)
    }) : n12, r12;
  }, {});
  return Object.keys(e).map(function(r12) {
    return e[r12];
  });
}
var Eje = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Lje() {
  for (var t16 = arguments.length, e = new Array(t16), r12 = 0; r12 < t16; r12++)
    e[r12] = arguments[r12];
  return !e.some(function(n12) {
    return !(n12 && typeof n12.getBoundingClientRect == "function");
  });
}
function ur1(t16) {
  t16 === void 0 && (t16 = {});
  var e = t16, r12 = e.defaultModifiers, n12 = r12 === void 0 ? [] : r12, a = e.defaultOptions, o = a === void 0 ? Eje : a;
  return function(u, s12, c) {
    c === void 0 && (c = o);
    var l2 = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Eje, o),
      modifiersData: {},
      elements: {
        reference: u,
        popper: s12
      },
      attributes: {},
      styles: {}
    }, f = [], p = false, d = {
      state: l2,
      setOptions: function(q) {
        var S = typeof q == "function" ? q(l2.options) : q;
        z(), l2.options = Object.assign({}, o, l2.options, S), l2.scrollParents = {
          reference: Si(u) ? _s(u) : u.contextElement ? _s(u.contextElement) : [],
          popper: _s(s12)
        };
        var N = ar1(ir1([].concat(n12, l2.options.modifiers)));
        return l2.orderedModifiers = N.filter(function(v) {
          return v.enabled;
        }), b(), d.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var q = l2.elements, S = q.reference, N = q.popper;
          if (Lje(S, N)) {
            l2.rects = {
              reference: rr1(S, Pc(N), l2.options.strategy === "fixed"),
              popper: t1e(N)
            }, l2.reset = false, l2.placement = l2.options.placement, l2.orderedModifiers.forEach(function($) {
              return l2.modifiersData[$.name] = Object.assign({}, $.data);
            });
            for (var v = 0; v < l2.orderedModifiers.length; v++) {
              if (l2.reset === true) {
                l2.reset = false, v = -1;
                continue;
              }
              var C = l2.orderedModifiers[v], L = C.fn, B = C.options, P12 = B === void 0 ? {} : B, j = C.name;
              typeof L == "function" && (l2 = L({
                state: l2,
                options: P12,
                name: j,
                instance: d
              }) || l2);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: or1(function() {
        return new Promise(function(_) {
          d.forceUpdate(), _(l2);
        });
      }),
      destroy: function() {
        z(), p = true;
      }
    };
    if (!Lje(u, s12))
      return d;
    d.setOptions(c).then(function(_) {
      !p && c.onFirstUpdate && c.onFirstUpdate(_);
    });
    function b() {
      l2.orderedModifiers.forEach(function(_) {
        var q = _.name, S = _.options, N = S === void 0 ? {} : S, v = _.effect;
        if (typeof v == "function") {
          var C = v({
            state: l2,
            name: q,
            instance: d,
            options: N
          }), L = function() {
          };
          f.push(C || L);
        }
      });
    }
    function z() {
      f.forEach(function(_) {
        return _();
      }), f = [];
    }
    return d;
  };
}
var sr1 = [Et1, Yt1, gt1, BYe, $t1, jt1, Qt1, Tt1, Vt1], cr1 = /* @__PURE__ */ ur1({
  defaultModifiers: sr1
}), lr1 = "tippy-box", HYe = "tippy-content", XYe = "tippy-backdrop", $Ye = "tippy-arrow", GYe = "tippy-svg-arrow", ao = {
  passive: true,
  capture: true
}, YYe = function() {
  return document.body;
};
function dQ(t16, e, r12) {
  if (Array.isArray(t16)) {
    var n12 = t16[e];
    return n12 ?? (Array.isArray(r12) ? r12[e] : r12);
  }
  return t16;
}
function i1e(t16, e) {
  var r12 = {}.toString.call(t16);
  return r12.indexOf("[object") === 0 && r12.indexOf(e + "]") > -1;
}
function JYe(t16, e) {
  return typeof t16 == "function" ? t16.apply(void 0, e) : t16;
}
function Pje(t16, e) {
  if (e === 0)
    return t16;
  var r12;
  return function(n12) {
    clearTimeout(r12), r12 = setTimeout(function() {
      t16(n12);
    }, e);
  };
}
function dr1(t16) {
  return t16.split(/\s+/).filter(Boolean);
}
function lo(t16) {
  return [].concat(t16);
}
function Dje(t16, e) {
  t16.indexOf(e) === -1 && t16.push(e);
}
function fr1(t16) {
  return t16.filter(function(e, r12) {
    return t16.indexOf(e) === r12;
  });
}
function KYe(t16) {
  return t16.split("-")[0];
}
function Ei(t16) {
  return [].slice.call(t16);
}
function Wje(t16) {
  return Object.keys(t16).reduce(function(e, r12) {
    return t16[r12] !== void 0 && (e[r12] = t16[r12]), e;
  }, {});
}
function ho() {
  return document.createElement("div");
}
function Qp(t16) {
  return ["Element", "Fragment"].some(function(e) {
    return i1e(t16, e);
  });
}
function br1(t16) {
  return i1e(t16, "NodeList");
}
function u1e(t16) {
  return i1e(t16, "MouseEvent");
}
function Mr1(t16) {
  return !!(t16 && t16._tippy && t16._tippy.reference === t16);
}
function Or1(t16) {
  return Qp(t16) ? [t16] : br1(t16) ? Ei(t16) : Array.isArray(t16) ? t16 : Ei(document.querySelectorAll(t16));
}
function fQ(t16, e) {
  t16.forEach(function(r12) {
    r12 && (r12.style.transitionDuration = e + "ms");
  });
}
function Zs(t16, e) {
  t16.forEach(function(r12) {
    r12 && r12.setAttribute("data-state", e);
  });
}
function QYe(t16) {
  var e, r12 = lo(t16), n12 = r12[0];
  return n12 != null && (e = n12.ownerDocument) != null && e.body ? n12.ownerDocument : document;
}
function zr1(t16, e) {
  var r12 = e.clientX, n12 = e.clientY;
  return t16.every(function(a) {
    var o = a.popperRect, i = a.popperState, u = a.props, s12 = u.interactiveBorder, c = KYe(i.placement), l2 = i.modifiersData.offset;
    if (!l2)
      return true;
    var f = c === "bottom" ? l2.top.y : 0, p = c === "top" ? l2.bottom.y : 0, d = c === "right" ? l2.left.x : 0, b = c === "left" ? l2.right.x : 0, z = o.top - n12 + f > s12, _ = n12 - o.bottom - p > s12, q = o.left - r12 + d > s12, S = r12 - o.right - b > s12;
    return z || _ || q || S;
  });
}
function bQ(t16, e, r12) {
  var n12 = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(a) {
    t16[n12](a, r12);
  });
}
function Nje(t16, e) {
  for (var r12 = e; r12; ) {
    var n12;
    if (t16.contains(r12))
      return true;
    r12 = r12.getRootNode == null || (n12 = r12.getRootNode()) == null ? void 0 : n12.host;
  }
  return false;
}
var pn = {
  isTouch: false
}, wje = 0;
function Ar1() {
  pn.isTouch || (pn.isTouch = true, window.performance && document.addEventListener("mousemove", ZYe));
}
function ZYe() {
  var t16 = performance.now();
  t16 - wje < 20 && (pn.isTouch = false, document.removeEventListener("mousemove", ZYe)), wje = t16;
}
function _r1() {
  var t16 = document.activeElement;
  if (Mr1(t16)) {
    var e = t16._tippy;
    t16.blur && !e.state.isVisible && t16.blur();
  }
}
function hr1() {
  document.addEventListener("touchstart", Ar1, ao), window.addEventListener("blur", _r1);
}
var vr1 = typeof window < "u" && typeof document < "u", mr1 = vr1 ? (
  // @ts-ignore
  !!window.msCrypto
) : false, Rr1 = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
}, qr1 = {
  allowHTML: false,
  animation: "fade",
  arrow: true,
  content: "",
  inertia: false,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Jr = Object.assign({
  appendTo: YYe,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: "mouseenter focus",
  triggerTarget: null
}, Rr1, qr1), Tr1 = Object.keys(Jr), yr1 = function(e) {
  var r12 = Object.keys(e);
  r12.forEach(function(n12) {
    Jr[n12] = e[n12];
  });
};
function eJe(t16) {
  var e = t16.plugins || [], r12 = e.reduce(function(n12, a) {
    var o = a.name, i = a.defaultValue;
    if (o) {
      var u;
      n12[o] = t16[o] !== void 0 ? t16[o] : (u = Jr[o]) != null ? u : i;
    }
    return n12;
  }, {});
  return Object.assign({}, t16, r12);
}
function Sr1(t16, e) {
  var r12 = e ? Object.keys(eJe(Object.assign({}, Jr, {
    plugins: e
  }))) : Tr1, n12 = r12.reduce(function(a, o) {
    var i = (t16.getAttribute("data-tippy-" + o) || "").trim();
    if (!i)
      return a;
    if (o === "content")
      a[o] = i;
    else
      try {
        a[o] = JSON.parse(i);
      } catch {
        a[o] = i;
      }
    return a;
  }, {});
  return n12;
}
function Bje(t16, e) {
  var r12 = Object.assign({}, e, {
    content: JYe(e.content, [t16])
  }, e.ignoreAttributes ? {} : Sr1(t16, e.plugins));
  return r12.aria = Object.assign({}, Jr.aria, r12.aria), r12.aria = {
    expanded: r12.aria.expanded === "auto" ? e.interactive : r12.aria.expanded,
    content: r12.aria.content === "auto" ? e.interactive ? null : "describedby" : r12.aria.content
  }, r12;
}
var Cr1 = function() {
  return "innerHTML";
};
function $Z(t16, e) {
  t16[Cr1()] = e;
}
function xje(t16) {
  var e = ho();
  return t16 === true ? e.className = $Ye : (e.className = GYe, Qp(t16) ? e.appendChild(t16) : $Z(e, t16)), e;
}
function Uje(t16, e) {
  Qp(e.content) ? ($Z(t16, ""), t16.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? $Z(t16, e.content) : t16.textContent = e.content);
}
function F2(t16) {
  var e = t16.firstElementChild, r12 = Ei(e.children);
  return {
    box: e,
    content: r12.find(function(n12) {
      return n12.classList.contains(HYe);
    }),
    arrow: r12.find(function(n12) {
      return n12.classList.contains($Ye) || n12.classList.contains(GYe);
    }),
    backdrop: r12.find(function(n12) {
      return n12.classList.contains(XYe);
    })
  };
}
function tJe(t16) {
  var e = ho(), r12 = ho();
  r12.className = lr1, r12.setAttribute("data-state", "hidden"), r12.setAttribute("tabindex", "-1");
  var n12 = ho();
  n12.className = HYe, n12.setAttribute("data-state", "hidden"), Uje(n12, t16.props), e.appendChild(r12), r12.appendChild(n12), a(t16.props, t16.props);
  function a(o, i) {
    var u = F2(e), s12 = u.box, c = u.content, l2 = u.arrow;
    i.theme ? s12.setAttribute("data-theme", i.theme) : s12.removeAttribute("data-theme"), typeof i.animation == "string" ? s12.setAttribute("data-animation", i.animation) : s12.removeAttribute("data-animation"), i.inertia ? s12.setAttribute("data-inertia", "") : s12.removeAttribute("data-inertia"), s12.style.maxWidth = typeof i.maxWidth == "number" ? i.maxWidth + "px" : i.maxWidth, i.role ? s12.setAttribute("role", i.role) : s12.removeAttribute("role"), (o.content !== i.content || o.allowHTML !== i.allowHTML) && Uje(c, t16.props), i.arrow ? l2 ? o.arrow !== i.arrow && (s12.removeChild(l2), s12.appendChild(xje(i.arrow))) : s12.appendChild(xje(i.arrow)) : l2 && s12.removeChild(l2);
  }
  return {
    popper: e,
    onUpdate: a
  };
}
tJe.$$tippy = true;
var gr1 = 1, El = [], MQ = [];
function Ir1(t16, e) {
  var r12 = Bje(t16, Object.assign({}, Jr, eJe(Wje(e)))), n12, a, o, i = false, u = false, s12 = false, c = false, l2, f, p, d = [], b = Pje(re, r12.interactiveDebounce), z, _ = gr1++, q = null, S = fr1(r12.plugins), N = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  }, v = {
    // properties
    id: _,
    reference: t16,
    popper: ho(),
    popperInstance: q,
    props: r12,
    state: N,
    plugins: S,
    // methods
    clearDelayTimeouts: I0,
    setProps: b0,
    setContent: P1,
    show: x0,
    hide: Mt,
    hideWithInteractivity: H1,
    enable: o0,
    disable: Ke,
    unmount: Wt,
    destroy: Zt
  };
  if (!r12.render)
    return v;
  var C = r12.render(v), L = C.popper, B = C.onUpdate;
  L.setAttribute("data-tippy-root", ""), L.id = "tippy-" + v.id, v.popper = L, t16._tippy = v, L._tippy = v;
  var P12 = S.map(function(be) {
    return be.fn(v);
  }), j = t16.hasAttribute("aria-expanded");
  return le(), Ie(), oe(), Z("onCreate", [v]), r12.showOnCreate && $0(), L.addEventListener("mouseenter", function() {
    v.props.interactive && v.state.isVisible && v.clearDelayTimeouts();
  }), L.addEventListener("mouseleave", function() {
    v.props.interactive && v.props.trigger.indexOf("mouseenter") >= 0 && w().addEventListener("mousemove", b);
  }), v;
  function $() {
    var be = v.props.touch;
    return Array.isArray(be) ? be : [be, 0];
  }
  function W() {
    return $()[0] === "hold";
  }
  function x() {
    var be;
    return !!((be = v.props.render) != null && be.$$tippy);
  }
  function D() {
    return z || t16;
  }
  function w() {
    var be = D().parentNode;
    return be ? QYe(be) : document;
  }
  function I() {
    return F2(L);
  }
  function Y(be) {
    return v.state.isMounted && !v.state.isVisible || pn.isTouch || l2 && l2.type === "focus" ? 0 : dQ(v.props.delay, be ? 0 : 1, Jr.delay);
  }
  function oe(be) {
    be === void 0 && (be = false), L.style.pointerEvents = v.props.interactive && !be ? "" : "none", L.style.zIndex = "" + v.props.zIndex;
  }
  function Z(be, Ue, d0) {
    if (d0 === void 0 && (d0 = true), P12.forEach(function(E0) {
      E0[be] && E0[be].apply(E0, Ue);
    }), d0) {
      var W0;
      (W0 = v.props)[be].apply(W0, Ue);
    }
  }
  function se() {
    var be = v.props.aria;
    if (be.content) {
      var Ue = "aria-" + be.content, d0 = L.id, W0 = lo(v.props.triggerTarget || t16);
      W0.forEach(function(E0) {
        var s1 = E0.getAttribute(Ue);
        if (v.state.isVisible)
          E0.setAttribute(Ue, s1 ? s1 + " " + d0 : d0);
        else {
          var Ot = s1 && s1.replace(d0, "").trim();
          Ot ? E0.setAttribute(Ue, Ot) : E0.removeAttribute(Ue);
        }
      });
    }
  }
  function Ie() {
    if (!(j || !v.props.aria.expanded)) {
      var be = lo(v.props.triggerTarget || t16);
      be.forEach(function(Ue) {
        v.props.interactive ? Ue.setAttribute("aria-expanded", v.state.isVisible && Ue === D() ? "true" : "false") : Ue.removeAttribute("aria-expanded");
      });
    }
  }
  function ie() {
    w().removeEventListener("mousemove", b), El = El.filter(function(be) {
      return be !== b;
    });
  }
  function ye(be) {
    if (!(pn.isTouch && (s12 || be.type === "mousedown"))) {
      var Ue = be.composedPath && be.composedPath()[0] || be.target;
      if (!(v.props.interactive && Nje(L, Ue))) {
        if (lo(v.props.triggerTarget || t16).some(function(d0) {
          return Nje(d0, Ue);
        })) {
          if (pn.isTouch || v.state.isVisible && v.props.trigger.indexOf("click") >= 0)
            return;
        } else
          Z("onClickOutside", [v, be]);
        v.props.hideOnClick === true && (v.clearDelayTimeouts(), v.hide(), u = true, setTimeout(function() {
          u = false;
        }), v.state.isMounted || G());
      }
    }
  }
  function ne() {
    s12 = true;
  }
  function k() {
    s12 = false;
  }
  function K() {
    var be = w();
    be.addEventListener("mousedown", ye, true), be.addEventListener("touchend", ye, ao), be.addEventListener("touchstart", k, ao), be.addEventListener("touchmove", ne, ao);
  }
  function G() {
    var be = w();
    be.removeEventListener("mousedown", ye, true), be.removeEventListener("touchend", ye, ao), be.removeEventListener("touchstart", k, ao), be.removeEventListener("touchmove", ne, ao);
  }
  function Q(be, Ue) {
    ve(be, function() {
      !v.state.isVisible && L.parentNode && L.parentNode.contains(L) && Ue();
    });
  }
  function ce(be, Ue) {
    ve(be, Ue);
  }
  function ve(be, Ue) {
    var d0 = I().box;
    function W0(E0) {
      E0.target === d0 && (bQ(d0, "remove", W0), Ue());
    }
    if (be === 0)
      return Ue();
    bQ(d0, "remove", f), bQ(d0, "add", W0), f = W0;
  }
  function Re(be, Ue, d0) {
    d0 === void 0 && (d0 = false);
    var W0 = lo(v.props.triggerTarget || t16);
    W0.forEach(function(E0) {
      E0.addEventListener(be, Ue, d0), d.push({
        node: E0,
        eventType: be,
        handler: Ue,
        options: d0
      });
    });
  }
  function le() {
    W() && (Re("touchstart", H, {
      passive: true
    }), Re("touchend", ue, {
      passive: true
    })), dr1(v.props.trigger).forEach(function(be) {
      if (be !== "manual")
        switch (Re(be, H), be) {
          case "mouseenter":
            Re("mouseleave", ue);
            break;
          case "focus":
            Re(mr1 ? "focusout" : "blur", Me);
            break;
          case "focusin":
            Re("focusout", Me);
            break;
        }
    });
  }
  function Ae() {
    d.forEach(function(be) {
      var Ue = be.node, d0 = be.eventType, W0 = be.handler, E0 = be.options;
      Ue.removeEventListener(d0, W0, E0);
    }), d = [];
  }
  function H(be) {
    var Ue, d0 = false;
    if (!(!v.state.isEnabled || Se(be) || u)) {
      var W0 = ((Ue = l2) == null ? void 0 : Ue.type) === "focus";
      l2 = be, z = be.currentTarget, Ie(), !v.state.isVisible && u1e(be) && El.forEach(function(E0) {
        return E0(be);
      }), be.type === "click" && (v.props.trigger.indexOf("mouseenter") < 0 || i) && v.props.hideOnClick !== false && v.state.isVisible ? d0 = true : $0(be), be.type === "click" && (i = !d0), d0 && !W0 && Be(be);
    }
  }
  function re(be) {
    var Ue = be.target, d0 = D().contains(Ue) || L.contains(Ue);
    if (!(be.type === "mousemove" && d0)) {
      var W0 = Ye().concat(L).map(function(E0) {
        var s1, Ot = E0._tippy, sn = (s1 = Ot.popperInstance) == null ? void 0 : s1.state;
        return sn ? {
          popperRect: E0.getBoundingClientRect(),
          popperState: sn,
          props: r12
        } : null;
      }).filter(Boolean);
      zr1(W0, be) && (ie(), Be(be));
    }
  }
  function ue(be) {
    var Ue = Se(be) || v.props.trigger.indexOf("click") >= 0 && i;
    if (!Ue) {
      if (v.props.interactive) {
        v.hideWithInteractivity(be);
        return;
      }
      Be(be);
    }
  }
  function Me(be) {
    v.props.trigger.indexOf("focusin") < 0 && be.target !== D() || v.props.interactive && be.relatedTarget && L.contains(be.relatedTarget) || Be(be);
  }
  function Se(be) {
    return pn.isTouch ? W() !== be.type.indexOf("touch") >= 0 : false;
  }
  function $e() {
    a0();
    var be = v.props, Ue = be.popperOptions, d0 = be.placement, W0 = be.offset, E0 = be.getReferenceClientRect, s1 = be.moveTransition, Ot = x() ? F2(L).arrow : null, sn = E0 ? {
      getBoundingClientRect: E0,
      contextElement: E0.contextElement || D()
    } : t16, h1 = {
      name: "$$tippy",
      enabled: true,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(cn) {
        var er = cn.state;
        if (x()) {
          var No = I(), En = No.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Ln) {
            Ln === "placement" ? En.setAttribute("data-placement", er.placement) : er.attributes.popper["data-popper-" + Ln] ? En.setAttribute("data-" + Ln, "") : En.removeAttribute("data-" + Ln);
          }), er.attributes.popper = {};
        }
      }
    }, zt = [{
      name: "offset",
      options: {
        offset: W0
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !s1
      }
    }, h1];
    x() && Ot && zt.push({
      name: "arrow",
      options: {
        element: Ot,
        padding: 3
      }
    }), zt.push.apply(zt, (Ue == null ? void 0 : Ue.modifiers) || []), v.popperInstance = cr1(sn, L, Object.assign({}, Ue, {
      placement: d0,
      onFirstUpdate: p,
      modifiers: zt
    }));
  }
  function a0() {
    v.popperInstance && (v.popperInstance.destroy(), v.popperInstance = null);
  }
  function Ne() {
    var be = v.props.appendTo, Ue, d0 = D();
    v.props.interactive && be === YYe || be === "parent" ? Ue = d0.parentNode : Ue = JYe(be, [d0]), Ue.contains(L) || Ue.appendChild(L), v.state.isMounted = true, $e();
  }
  function Ye() {
    return Ei(L.querySelectorAll("[data-tippy-root]"));
  }
  function $0(be) {
    v.clearDelayTimeouts(), be && Z("onTrigger", [v, be]), K();
    var Ue = Y(true), d0 = $(), W0 = d0[0], E0 = d0[1];
    pn.isTouch && W0 === "hold" && E0 && (Ue = E0), Ue ? n12 = setTimeout(function() {
      v.show();
    }, Ue) : v.show();
  }
  function Be(be) {
    if (v.clearDelayTimeouts(), Z("onUntrigger", [v, be]), !v.state.isVisible) {
      G();
      return;
    }
    if (!(v.props.trigger.indexOf("mouseenter") >= 0 && v.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(be.type) >= 0 && i)) {
      var Ue = Y(false);
      Ue ? a = setTimeout(function() {
        v.state.isVisible && v.hide();
      }, Ue) : o = requestAnimationFrame(function() {
        v.hide();
      });
    }
  }
  function o0() {
    v.state.isEnabled = true;
  }
  function Ke() {
    v.hide(), v.state.isEnabled = false;
  }
  function I0() {
    clearTimeout(n12), clearTimeout(a), cancelAnimationFrame(o);
  }
  function b0(be) {
    if (!v.state.isDestroyed) {
      Z("onBeforeUpdate", [v, be]), Ae();
      var Ue = v.props, d0 = Bje(t16, Object.assign({}, Ue, Wje(be), {
        ignoreAttributes: true
      }));
      v.props = d0, le(), Ue.interactiveDebounce !== d0.interactiveDebounce && (ie(), b = Pje(re, d0.interactiveDebounce)), Ue.triggerTarget && !d0.triggerTarget ? lo(Ue.triggerTarget).forEach(function(W0) {
        W0.removeAttribute("aria-expanded");
      }) : d0.triggerTarget && t16.removeAttribute("aria-expanded"), Ie(), oe(), B && B(Ue, d0), v.popperInstance && ($e(), Ye().forEach(function(W0) {
        requestAnimationFrame(W0._tippy.popperInstance.forceUpdate);
      })), Z("onAfterUpdate", [v, be]);
    }
  }
  function P1(be) {
    v.setProps({
      content: be
    });
  }
  function x0() {
    var be = v.state.isVisible, Ue = v.state.isDestroyed, d0 = !v.state.isEnabled, W0 = pn.isTouch && !v.props.touch, E0 = dQ(v.props.duration, 0, Jr.duration);
    if (!(be || Ue || d0 || W0) && !D().hasAttribute("disabled") && (Z("onShow", [v], false), v.props.onShow(v) !== false)) {
      if (v.state.isVisible = true, x() && (L.style.visibility = "visible"), oe(), K(), v.state.isMounted || (L.style.transition = "none"), x()) {
        var s1 = I(), Ot = s1.box, sn = s1.content;
        fQ([Ot, sn], 0);
      }
      p = function() {
        var zt;
        if (!(!v.state.isVisible || c)) {
          if (c = true, L.offsetHeight, L.style.transition = v.props.moveTransition, x() && v.props.animation) {
            var za = I(), cn = za.box, er = za.content;
            fQ([cn, er], E0), Zs([cn, er], "visible");
          }
          se(), Ie(), Dje(MQ, v), (zt = v.popperInstance) == null || zt.forceUpdate(), Z("onMount", [v]), v.props.animation && x() && ce(E0, function() {
            v.state.isShown = true, Z("onShown", [v]);
          });
        }
      }, Ne();
    }
  }
  function Mt() {
    var be = !v.state.isVisible, Ue = v.state.isDestroyed, d0 = !v.state.isEnabled, W0 = dQ(v.props.duration, 1, Jr.duration);
    if (!(be || Ue || d0) && (Z("onHide", [v], false), v.props.onHide(v) !== false)) {
      if (v.state.isVisible = false, v.state.isShown = false, c = false, i = false, x() && (L.style.visibility = "hidden"), ie(), G(), oe(true), x()) {
        var E0 = I(), s1 = E0.box, Ot = E0.content;
        v.props.animation && (fQ([s1, Ot], W0), Zs([s1, Ot], "hidden"));
      }
      se(), Ie(), v.props.animation ? x() && Q(W0, v.unmount) : v.unmount();
    }
  }
  function H1(be) {
    w().addEventListener("mousemove", b), Dje(El, b), b(be);
  }
  function Wt() {
    v.state.isVisible && v.hide(), v.state.isMounted && (a0(), Ye().forEach(function(be) {
      be._tippy.unmount();
    }), L.parentNode && L.parentNode.removeChild(L), MQ = MQ.filter(function(be) {
      return be !== v;
    }), v.state.isMounted = false, Z("onHidden", [v]));
  }
  function Zt() {
    v.state.isDestroyed || (v.clearDelayTimeouts(), v.unmount(), Ae(), delete t16._tippy, v.state.isDestroyed = true, Z("onDestroy", [v]));
  }
}
function i0(t16, e) {
  e === void 0 && (e = {});
  var r12 = Jr.plugins.concat(e.plugins || []);
  hr1();
  var n12 = Object.assign({}, e, {
    plugins: r12
  }), a = Or1(t16), o = a.reduce(function(i, u) {
    var s12 = u && Ir1(u, n12);
    return s12 && i.push(s12), i;
  }, []);
  return Qp(t16) ? o[0] : o;
}
i0.defaultProps = Jr;
i0.setDefaultProps = yr1;
i0.currentInput = pn;
Object.assign({}, BYe, {
  effect: function(e) {
    var r12 = e.state, n12 = {
      popper: {
        position: r12.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(r12.elements.popper.style, n12.popper), r12.styles = n12, r12.elements.arrow && Object.assign(r12.elements.arrow.style, n12.arrow);
  }
});
var Pr1 = {
  name: "animateFill",
  defaultValue: false,
  fn: function(e) {
    var r12;
    if (!((r12 = e.props.render) != null && r12.$$tippy))
      return {};
    var n12 = F2(e.popper), a = n12.box, o = n12.content, i = e.props.animateFill ? Dr1() : null;
    return {
      onCreate: function() {
        i && (a.insertBefore(i, a.firstElementChild), a.setAttribute("data-animatefill", ""), a.style.overflow = "hidden", e.setProps({
          arrow: false,
          animation: "shift-away"
        }));
      },
      onMount: function() {
        if (i) {
          var s12 = a.style.transitionDuration, c = Number(s12.replace("ms", ""));
          o.style.transitionDelay = Math.round(c / 10) + "ms", i.style.transitionDuration = s12, Zs([i], "visible");
        }
      },
      onShow: function() {
        i && (i.style.transitionDuration = "0ms");
      },
      onHide: function() {
        i && Zs([i], "hidden");
      }
    };
  }
};
function Dr1() {
  var t16 = ho();
  return t16.className = XYe, Zs([t16], "hidden"), t16;
}
var GZ = {
  clientX: 0,
  clientY: 0
}, Ll = [];
function rJe(t16) {
  var e = t16.clientX, r12 = t16.clientY;
  GZ = {
    clientX: e,
    clientY: r12
  };
}
function Wr1(t16) {
  t16.addEventListener("mousemove", rJe);
}
function Nr1(t16) {
  t16.removeEventListener("mousemove", rJe);
}
var wr1 = {
  name: "followCursor",
  defaultValue: false,
  fn: function(e) {
    var r12 = e.reference, n12 = QYe(e.props.triggerTarget || r12), a = false, o = false, i = true, u = e.props;
    function s12() {
      return e.props.followCursor === "initial" && e.state.isVisible;
    }
    function c() {
      n12.addEventListener("mousemove", p);
    }
    function l2() {
      n12.removeEventListener("mousemove", p);
    }
    function f() {
      a = true, e.setProps({
        getReferenceClientRect: null
      }), a = false;
    }
    function p(z) {
      var _ = z.target ? r12.contains(z.target) : true, q = e.props.followCursor, S = z.clientX, N = z.clientY, v = r12.getBoundingClientRect(), C = S - v.left, L = N - v.top;
      (_ || !e.props.interactive) && e.setProps({
        // @ts-ignore - unneeded DOMRect properties
        getReferenceClientRect: function() {
          var P12 = r12.getBoundingClientRect(), j = S, $ = N;
          q === "initial" && (j = P12.left + C, $ = P12.top + L);
          var W = q === "horizontal" ? P12.top : $, x = q === "vertical" ? P12.right : j, D = q === "horizontal" ? P12.bottom : $, w = q === "vertical" ? P12.left : j;
          return {
            width: x - w,
            height: D - W,
            top: W,
            right: x,
            bottom: D,
            left: w
          };
        }
      });
    }
    function d() {
      e.props.followCursor && (Ll.push({
        instance: e,
        doc: n12
      }), Wr1(n12));
    }
    function b() {
      Ll = Ll.filter(function(z) {
        return z.instance !== e;
      }), Ll.filter(function(z) {
        return z.doc === n12;
      }).length === 0 && Nr1(n12);
    }
    return {
      onCreate: d,
      onDestroy: b,
      onBeforeUpdate: function() {
        u = e.props;
      },
      onAfterUpdate: function(_, q) {
        var S = q.followCursor;
        a || S !== void 0 && u.followCursor !== S && (b(), S ? (d(), e.state.isMounted && !o && !s12() && c()) : (l2(), f()));
      },
      onMount: function() {
        e.props.followCursor && !o && (i && (p(GZ), i = false), s12() || c());
      },
      onTrigger: function(_, q) {
        u1e(q) && (GZ = {
          clientX: q.clientX,
          clientY: q.clientY
        }), o = q.type === "focus";
      },
      onHidden: function() {
        e.props.followCursor && (f(), l2(), i = true);
      }
    };
  }
};
function Br1(t16, e) {
  var r12;
  return {
    popperOptions: Object.assign({}, t16.popperOptions, {
      modifiers: [].concat((((r12 = t16.popperOptions) == null ? void 0 : r12.modifiers) || []).filter(function(n12) {
        var a = n12.name;
        return a !== e.name;
      }), [e])
    })
  };
}
var xr1 = {
  name: "inlinePositioning",
  defaultValue: false,
  fn: function(e) {
    var r12 = e.reference;
    function n12() {
      return !!e.props.inlinePositioning;
    }
    var a, o = -1, i = false, u = [], s12 = {
      name: "tippyInlinePositioning",
      enabled: true,
      phase: "afterWrite",
      fn: function(d) {
        var b = d.state;
        n12() && (u.indexOf(b.placement) !== -1 && (u = []), a !== b.placement && u.indexOf(b.placement) === -1 && (u.push(b.placement), e.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function() {
            return c(b.placement);
          }
        })), a = b.placement);
      }
    };
    function c(p) {
      return Ur1(KYe(p), r12.getBoundingClientRect(), Ei(r12.getClientRects()), o);
    }
    function l2(p) {
      i = true, e.setProps(p), i = false;
    }
    function f() {
      i || l2(Br1(e.props, s12));
    }
    return {
      onCreate: f,
      onAfterUpdate: f,
      onTrigger: function(d, b) {
        if (u1e(b)) {
          var z = Ei(e.reference.getClientRects()), _ = z.find(function(S) {
            return S.left - 2 <= b.clientX && S.right + 2 >= b.clientX && S.top - 2 <= b.clientY && S.bottom + 2 >= b.clientY;
          }), q = z.indexOf(_);
          o = q > -1 ? q : o;
        }
      },
      onHidden: function() {
        o = -1;
      }
    };
  }
};
function Ur1(t16, e, r12, n12) {
  if (r12.length < 2 || t16 === null)
    return e;
  if (r12.length === 2 && n12 >= 0 && r12[0].left > r12[1].right)
    return r12[n12] || e;
  switch (t16) {
    case "top":
    case "bottom": {
      var a = r12[0], o = r12[r12.length - 1], i = t16 === "top", u = a.top, s12 = o.bottom, c = i ? a.left : o.left, l2 = i ? a.right : o.right, f = l2 - c, p = s12 - u;
      return {
        top: u,
        bottom: s12,
        left: c,
        right: l2,
        width: f,
        height: p
      };
    }
    case "left":
    case "right": {
      var d = Math.min.apply(Math, r12.map(function(L) {
        return L.left;
      })), b = Math.max.apply(Math, r12.map(function(L) {
        return L.right;
      })), z = r12.filter(function(L) {
        return t16 === "left" ? L.left === d : L.right === b;
      }), _ = z[0].top, q = z[z.length - 1].bottom, S = d, N = b, v = N - S, C = q - _;
      return {
        top: _,
        bottom: q,
        left: S,
        right: N,
        width: v,
        height: C
      };
    }
    default:
      return e;
  }
}
var kr1 = {
  name: "sticky",
  defaultValue: false,
  fn: function(e) {
    var r12 = e.reference, n12 = e.popper;
    function a() {
      return e.popperInstance ? e.popperInstance.state.elements.reference : r12;
    }
    function o(c) {
      return e.props.sticky === true || e.props.sticky === c;
    }
    var i = null, u = null;
    function s12() {
      var c = o("reference") ? a().getBoundingClientRect() : null, l2 = o("popper") ? n12.getBoundingClientRect() : null;
      (c && kje(i, c) || l2 && kje(u, l2)) && e.popperInstance && e.popperInstance.update(), i = c, u = l2, e.state.isMounted && requestAnimationFrame(s12);
    }
    return {
      onMount: function() {
        e.props.sticky && s12();
      }
    };
  }
};
function kje(t16, e) {
  return t16 && e ? t16.top !== e.top || t16.right !== e.right || t16.bottom !== e.bottom || t16.left !== e.left : true;
}
i0.setDefaultProps({
  render: tJe
});
i0.setDefaultProps({
  //@ts-ignore
  onShow: (t16) => {
    if (!t16.props.content)
      return false;
  }
});
const Xr1 = [
  "a11y",
  "allowHTML",
  "arrow",
  "flip",
  "flipOnUpdate",
  "hideOnClick",
  "ignoreAttributes",
  "inertia",
  "interactive",
  "lazy",
  "multiple",
  "showOnInit",
  "touch",
  "touchHold"
];
let YZ = {};
Object.keys(i0.defaultProps).forEach((t16) => {
  Xr1.includes(t16) ? YZ[t16] = {
    type: Boolean,
    default: function() {
      return i0.defaultProps[t16];
    }
  } : YZ[t16] = {
    default: function() {
      return i0.defaultProps[t16];
    }
  };
});
const Gr1 = i0.setDefaultProps;
Gr1({
  ignoreAttributes: true,
  plugins: [kr1, xr1, wr1, Pr1]
});
N0.add(nr0);
N0.add(Gt0, aHe, nHe, vn0, Z10, zn0, ot0);
N0.add(dHe);
N0.add(Xt0, dc, lHe);
function Vje(t16, e) {
  var r12 = Object.keys(t16);
  if (Object.getOwnPropertySymbols) {
    var n12 = Object.getOwnPropertySymbols(t16);
    e && (n12 = n12.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t16, a).enumerable;
    })), r12.push.apply(r12, n12);
  }
  return r12;
}
function Rn(t16) {
  for (var e = 1; e < arguments.length; e++) {
    var r12 = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Vje(Object(r12), true).forEach(function(n12) {
      Xo1(t16, n12, r12[n12]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t16, Object.getOwnPropertyDescriptors(r12)) : Vje(Object(r12)).forEach(function(n12) {
      Object.defineProperty(t16, n12, Object.getOwnPropertyDescriptor(r12, n12));
    });
  }
  return t16;
}
function o2(t16) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? o2 = function(e) {
    return typeof e;
  } : o2 = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, o2(t16);
}
function Xo1(t16, e, r12) {
  return e in t16 ? Object.defineProperty(t16, e, {
    value: r12,
    enumerable: true,
    configurable: true,
    writable: true
  }) : t16[e] = r12, t16;
}
function sa() {
  return sa = Object.assign || function(t16) {
    for (var e = 1; e < arguments.length; e++) {
      var r12 = arguments[e];
      for (var n12 in r12)
        Object.prototype.hasOwnProperty.call(r12, n12) && (t16[n12] = r12[n12]);
    }
    return t16;
  }, sa.apply(this, arguments);
}
function $o1(t16, e) {
  if (t16 == null)
    return {};
  var r12 = {}, n12 = Object.keys(t16), a, o;
  for (o = 0; o < n12.length; o++)
    a = n12[o], !(e.indexOf(a) >= 0) && (r12[a] = t16[a]);
  return r12;
}
function Go1(t16, e) {
  if (t16 == null)
    return {};
  var r12 = $o1(t16, e), n12, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t16);
    for (a = 0; a < o.length; a++)
      n12 = o[a], !(e.indexOf(n12) >= 0) && Object.prototype.propertyIsEnumerable.call(t16, n12) && (r12[n12] = t16[n12]);
  }
  return r12;
}
var Yo1 = "1.15.6";
function Zn(t16) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(t16);
}
var Ma = Zn(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), wc = Zn(/Edge/i), Hje = Zn(/firefox/i), hs = Zn(/safari/i) && !Zn(/chrome/i) && !Zn(/android/i), s1e = Zn(/iP(ad|od|hone)/i), hJe = Zn(/chrome/i) && Zn(/android/i), vJe = {
  capture: false,
  passive: false
};
function j0(t16, e, r12) {
  t16.addEventListener(e, r12, !Ma && vJe);
}
function U0(t16, e, r12) {
  t16.removeEventListener(e, r12, !Ma && vJe);
}
function X2(t16, e) {
  if (e) {
    if (e[0] === ">" && (e = e.substring(1)), t16)
      try {
        if (t16.matches)
          return t16.matches(e);
        if (t16.msMatchesSelector)
          return t16.msMatchesSelector(e);
        if (t16.webkitMatchesSelector)
          return t16.webkitMatchesSelector(e);
      } catch {
        return false;
      }
    return false;
  }
}
function mJe(t16) {
  return t16.host && t16 !== document && t16.host.nodeType ? t16.host : t16.parentNode;
}
function Fr(t16, e, r12, n12) {
  if (t16) {
    r12 = r12 || document;
    do {
      if (e != null && (e[0] === ">" ? t16.parentNode === r12 && X2(t16, e) : X2(t16, e)) || n12 && t16 === r12)
        return t16;
      if (t16 === r12)
        break;
    } while (t16 = mJe(t16));
  }
  return null;
}
var Xje = /\s+/g;
function rr(t16, e, r12) {
  if (t16 && e)
    if (t16.classList)
      t16.classList[r12 ? "add" : "remove"](e);
    else {
      var n12 = (" " + t16.className + " ").replace(Xje, " ").replace(" " + e + " ", " ");
      t16.className = (n12 + (r12 ? " " + e : "")).replace(Xje, " ");
    }
}
function z0(t16, e, r12) {
  var n12 = t16 && t16.style;
  if (n12) {
    if (r12 === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? r12 = document.defaultView.getComputedStyle(t16, "") : t16.currentStyle && (r12 = t16.currentStyle), e === void 0 ? r12 : r12[e];
    !(e in n12) && e.indexOf("webkit") === -1 && (e = "-webkit-" + e), n12[e] = r12 + (typeof r12 == "string" ? "" : "px");
  }
}
function bi(t16, e) {
  var r12 = "";
  if (typeof t16 == "string")
    r12 = t16;
  else
    do {
      var n12 = z0(t16, "transform");
      n12 && n12 !== "none" && (r12 = n12 + " " + r12);
    } while (!e && (t16 = t16.parentNode));
  var a = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return a && new a(r12);
}
function RJe(t16, e, r12) {
  if (t16) {
    var n12 = t16.getElementsByTagName(e), a = 0, o = n12.length;
    if (r12)
      for (; a < o; a++)
        r12(n12[a], a);
    return n12;
  }
  return [];
}
function zn() {
  var t16 = document.scrollingElement;
  return t16 || document.documentElement;
}
function k1(t16, e, r12, n12, a) {
  if (!(!t16.getBoundingClientRect && t16 !== window)) {
    var o, i, u, s12, c, l2, f;
    if (t16 !== window && t16.parentNode && t16 !== zn() ? (o = t16.getBoundingClientRect(), i = o.top, u = o.left, s12 = o.bottom, c = o.right, l2 = o.height, f = o.width) : (i = 0, u = 0, s12 = window.innerHeight, c = window.innerWidth, l2 = window.innerHeight, f = window.innerWidth), (e || r12) && t16 !== window && (a = a || t16.parentNode, !Ma))
      do
        if (a && a.getBoundingClientRect && (z0(a, "transform") !== "none" || r12 && z0(a, "position") !== "static")) {
          var p = a.getBoundingClientRect();
          i -= p.top + parseInt(z0(a, "border-top-width")), u -= p.left + parseInt(z0(a, "border-left-width")), s12 = i + o.height, c = u + o.width;
          break;
        }
      while (a = a.parentNode);
    if (n12 && t16 !== window) {
      var d = bi(a || t16), b = d && d.a, z = d && d.d;
      d && (i /= z, u /= b, f /= b, l2 /= z, s12 = i + l2, c = u + f);
    }
    return {
      top: i,
      left: u,
      bottom: s12,
      right: c,
      width: f,
      height: l2
    };
  }
}
function $je(t16, e, r12) {
  for (var n12 = Pa(t16, true), a = k1(t16)[e]; n12; ) {
    var o = k1(n12)[r12], i = void 0;
    if (i = a >= o, !i)
      return n12;
    if (n12 === zn())
      break;
    n12 = Pa(n12, false);
  }
  return false;
}
function Li(t16, e, r12, n12) {
  for (var a = 0, o = 0, i = t16.children; o < i.length; ) {
    if (i[o].style.display !== "none" && i[o] !== A0.ghost && (n12 || i[o] !== A0.dragged) && Fr(i[o], r12.draggable, t16, false)) {
      if (a === e)
        return i[o];
      a++;
    }
    o++;
  }
  return null;
}
function c1e(t16, e) {
  for (var r12 = t16.lastElementChild; r12 && (r12 === A0.ghost || z0(r12, "display") === "none" || e && !X2(r12, e)); )
    r12 = r12.previousElementSibling;
  return r12 || null;
}
function Mr(t16, e) {
  var r12 = 0;
  if (!t16 || !t16.parentNode)
    return -1;
  for (; t16 = t16.previousElementSibling; )
    t16.nodeName.toUpperCase() !== "TEMPLATE" && t16 !== A0.clone && (!e || X2(t16, e)) && r12++;
  return r12;
}
function Gje(t16) {
  var e = 0, r12 = 0, n12 = zn();
  if (t16)
    do {
      var a = bi(t16), o = a.a, i = a.d;
      e += t16.scrollLeft * o, r12 += t16.scrollTop * i;
    } while (t16 !== n12 && (t16 = t16.parentNode));
  return [e, r12];
}
function Jo1(t16, e) {
  for (var r12 in t16)
    if (t16.hasOwnProperty(r12)) {
      for (var n12 in e)
        if (e.hasOwnProperty(n12) && e[n12] === t16[r12][n12])
          return Number(r12);
    }
  return -1;
}
function Pa(t16, e) {
  if (!t16 || !t16.getBoundingClientRect)
    return zn();
  var r12 = t16, n12 = false;
  do
    if (r12.clientWidth < r12.scrollWidth || r12.clientHeight < r12.scrollHeight) {
      var a = z0(r12);
      if (r12.clientWidth < r12.scrollWidth && (a.overflowX == "auto" || a.overflowX == "scroll") || r12.clientHeight < r12.scrollHeight && (a.overflowY == "auto" || a.overflowY == "scroll")) {
        if (!r12.getBoundingClientRect || r12 === document.body)
          return zn();
        if (n12 || e)
          return r12;
        n12 = true;
      }
    }
  while (r12 = r12.parentNode);
  return zn();
}
function Ko1(t16, e) {
  if (t16 && e)
    for (var r12 in e)
      e.hasOwnProperty(r12) && (t16[r12] = e[r12]);
  return t16;
}
function OQ(t16, e) {
  return Math.round(t16.top) === Math.round(e.top) && Math.round(t16.left) === Math.round(e.left) && Math.round(t16.height) === Math.round(e.height) && Math.round(t16.width) === Math.round(e.width);
}
var vs;
function qJe(t16, e) {
  return function() {
    if (!vs) {
      var r12 = arguments, n12 = this;
      r12.length === 1 ? t16.call(n12, r12[0]) : t16.apply(n12, r12), vs = setTimeout(function() {
        vs = void 0;
      }, e);
    }
  };
}
function Qo1() {
  clearTimeout(vs), vs = void 0;
}
function TJe(t16, e, r12) {
  t16.scrollLeft += e, t16.scrollTop += r12;
}
function yJe(t16) {
  var e = window.Polymer, r12 = window.jQuery || window.Zepto;
  return e && e.dom ? e.dom(t16).cloneNode(true) : r12 ? r12(t16).clone(true)[0] : t16.cloneNode(true);
}
function SJe(t16, e, r12) {
  var n12 = {};
  return Array.from(t16.children).forEach(function(a) {
    var o, i, u, s12;
    if (!(!Fr(a, e.draggable, t16, false) || a.animated || a === r12)) {
      var c = k1(a);
      n12.left = Math.min((o = n12.left) !== null && o !== void 0 ? o : 1 / 0, c.left), n12.top = Math.min((i = n12.top) !== null && i !== void 0 ? i : 1 / 0, c.top), n12.right = Math.max((u = n12.right) !== null && u !== void 0 ? u : -1 / 0, c.right), n12.bottom = Math.max((s12 = n12.bottom) !== null && s12 !== void 0 ? s12 : -1 / 0, c.bottom);
    }
  }), n12.width = n12.right - n12.left, n12.height = n12.bottom - n12.top, n12.x = n12.left, n12.y = n12.top, n12;
}
var $t = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function Zo1() {
  var t16 = [], e;
  return {
    captureAnimationState: function() {
      if (t16 = [], !!this.options.animation) {
        var n12 = [].slice.call(this.el.children);
        n12.forEach(function(a) {
          if (!(z0(a, "display") === "none" || a === A0.ghost)) {
            t16.push({
              target: a,
              rect: k1(a)
            });
            var o = Rn({}, t16[t16.length - 1].rect);
            if (a.thisAnimationDuration) {
              var i = bi(a, true);
              i && (o.top -= i.f, o.left -= i.e);
            }
            a.fromRect = o;
          }
        });
      }
    },
    addAnimationState: function(n12) {
      t16.push(n12);
    },
    removeAnimationState: function(n12) {
      t16.splice(Jo1(t16, {
        target: n12
      }), 1);
    },
    animateAll: function(n12) {
      var a = this;
      if (!this.options.animation) {
        clearTimeout(e), typeof n12 == "function" && n12();
        return;
      }
      var o = false, i = 0;
      t16.forEach(function(u) {
        var s12 = 0, c = u.target, l2 = c.fromRect, f = k1(c), p = c.prevFromRect, d = c.prevToRect, b = u.rect, z = bi(c, true);
        z && (f.top -= z.f, f.left -= z.e), c.toRect = f, c.thisAnimationDuration && OQ(p, f) && !OQ(l2, f) && // Make sure animatingRect is on line between toRect & fromRect
        (b.top - f.top) / (b.left - f.left) === (l2.top - f.top) / (l2.left - f.left) && (s12 = ti1(b, p, d, a.options)), OQ(f, l2) || (c.prevFromRect = l2, c.prevToRect = f, s12 || (s12 = a.options.animation), a.animate(c, b, f, s12)), s12 && (o = true, i = Math.max(i, s12), clearTimeout(c.animationResetTimer), c.animationResetTimer = setTimeout(function() {
          c.animationTime = 0, c.prevFromRect = null, c.fromRect = null, c.prevToRect = null, c.thisAnimationDuration = null;
        }, s12), c.thisAnimationDuration = s12);
      }), clearTimeout(e), o ? e = setTimeout(function() {
        typeof n12 == "function" && n12();
      }, i) : typeof n12 == "function" && n12(), t16 = [];
    },
    animate: function(n12, a, o, i) {
      if (i) {
        z0(n12, "transition", ""), z0(n12, "transform", "");
        var u = bi(this.el), s12 = u && u.a, c = u && u.d, l2 = (a.left - o.left) / (s12 || 1), f = (a.top - o.top) / (c || 1);
        n12.animatingX = !!l2, n12.animatingY = !!f, z0(n12, "transform", "translate3d(" + l2 + "px," + f + "px,0)"), this.forRepaintDummy = ei1(n12), z0(n12, "transition", "transform " + i + "ms" + (this.options.easing ? " " + this.options.easing : "")), z0(n12, "transform", "translate3d(0,0,0)"), typeof n12.animated == "number" && clearTimeout(n12.animated), n12.animated = setTimeout(function() {
          z0(n12, "transition", ""), z0(n12, "transform", ""), n12.animated = false, n12.animatingX = false, n12.animatingY = false;
        }, i);
      }
    }
  };
}
function ei1(t16) {
  return t16.offsetWidth;
}
function ti1(t16, e, r12, n12) {
  return Math.sqrt(Math.pow(e.top - t16.top, 2) + Math.pow(e.left - t16.left, 2)) / Math.sqrt(Math.pow(e.top - r12.top, 2) + Math.pow(e.left - r12.left, 2)) * n12.animation;
}
var Go = [], zQ = {
  initializeByDefault: true
}, Bc = {
  mount: function(e) {
    for (var r12 in zQ)
      zQ.hasOwnProperty(r12) && !(r12 in e) && (e[r12] = zQ[r12]);
    Go.forEach(function(n12) {
      if (n12.pluginName === e.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(e.pluginName, " more than once");
    }), Go.push(e);
  },
  pluginEvent: function(e, r12, n12) {
    var a = this;
    this.eventCanceled = false, n12.cancel = function() {
      a.eventCanceled = true;
    };
    var o = e + "Global";
    Go.forEach(function(i) {
      r12[i.pluginName] && (r12[i.pluginName][o] && r12[i.pluginName][o](Rn({
        sortable: r12
      }, n12)), r12.options[i.pluginName] && r12[i.pluginName][e] && r12[i.pluginName][e](Rn({
        sortable: r12
      }, n12)));
    });
  },
  initializePlugins: function(e, r12, n12, a) {
    Go.forEach(function(u) {
      var s12 = u.pluginName;
      if (!(!e.options[s12] && !u.initializeByDefault)) {
        var c = new u(e, r12, e.options);
        c.sortable = e, c.options = e.options, e[s12] = c, sa(n12, c.defaults);
      }
    });
    for (var o in e.options)
      if (e.options.hasOwnProperty(o)) {
        var i = this.modifyOption(e, o, e.options[o]);
        typeof i < "u" && (e.options[o] = i);
      }
  },
  getEventProperties: function(e, r12) {
    var n12 = {};
    return Go.forEach(function(a) {
      typeof a.eventProperties == "function" && sa(n12, a.eventProperties.call(r12[a.pluginName], e));
    }), n12;
  },
  modifyOption: function(e, r12, n12) {
    var a;
    return Go.forEach(function(o) {
      e[o.pluginName] && o.optionListeners && typeof o.optionListeners[r12] == "function" && (a = o.optionListeners[r12].call(e[o.pluginName], n12));
    }), a;
  }
};
function ri1(t16) {
  var e = t16.sortable, r12 = t16.rootEl, n12 = t16.name, a = t16.targetEl, o = t16.cloneEl, i = t16.toEl, u = t16.fromEl, s12 = t16.oldIndex, c = t16.newIndex, l2 = t16.oldDraggableIndex, f = t16.newDraggableIndex, p = t16.originalEvent, d = t16.putSortable, b = t16.extraEventProperties;
  if (e = e || r12 && r12[$t], !!e) {
    var z, _ = e.options, q = "on" + n12.charAt(0).toUpperCase() + n12.substr(1);
    window.CustomEvent && !Ma && !wc ? z = new CustomEvent(n12, {
      bubbles: true,
      cancelable: true
    }) : (z = document.createEvent("Event"), z.initEvent(n12, true, true)), z.to = i || r12, z.from = u || r12, z.item = a || r12, z.clone = o, z.oldIndex = s12, z.newIndex = c, z.oldDraggableIndex = l2, z.newDraggableIndex = f, z.originalEvent = p, z.pullMode = d ? d.lastPutMode : void 0;
    var S = Rn(Rn({}, b), Bc.getEventProperties(n12, e));
    for (var N in S)
      z[N] = S[N];
    r12 && r12.dispatchEvent(z), _[q] && _[q].call(e, z);
  }
}
var ni1 = ["evt"], xt = function(e, r12) {
  var n12 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = n12.evt, o = Go1(n12, ni1);
  Bc.pluginEvent.bind(A0)(e, r12, Rn({
    dragEl: We,
    parentEl: g1,
    ghostEl: T0,
    rootEl: v1,
    nextEl: oo,
    lastDownEl: i2,
    cloneEl: T1,
    cloneHidden: Ca,
    dragStarted: us,
    putSortable: lt,
    activeSortable: A0.active,
    originalEvent: a,
    oldIndex: oi,
    oldDraggableIndex: ms,
    newIndex: nr,
    newDraggableIndex: qa,
    hideGhostForTarget: EJe,
    unhideGhostForTarget: LJe,
    cloneNowHidden: function() {
      Ca = true;
    },
    cloneNowShown: function() {
      Ca = false;
    },
    dispatchSortableEvent: function(u) {
      It({
        sortable: r12,
        name: u,
        originalEvent: a
      });
    }
  }, o));
};
function It(t16) {
  ri1(Rn({
    putSortable: lt,
    cloneEl: T1,
    targetEl: We,
    rootEl: v1,
    oldIndex: oi,
    oldDraggableIndex: ms,
    newIndex: nr,
    newDraggableIndex: qa
  }, t16));
}
var We, g1, T0, v1, oo, i2, T1, Ca, oi, nr, ms, qa, Pl, lt, Zo = false, $2 = false, G2 = [], to, xr, AQ, _Q, Yje, Jje, us, Yo, Rs, qs = false, Dl = false, u2, At, hQ = [], JZ = false, Y2 = [], ed = typeof document < "u", Wl = s1e, Kje = wc || Ma ? "cssFloat" : "float", ai1 = ed && !hJe && !s1e && "draggable" in document.createElement("div"), CJe = (function() {
  if (ed) {
    if (Ma)
      return false;
    var t16 = document.createElement("x");
    return t16.style.cssText = "pointer-events:auto", t16.style.pointerEvents === "auto";
  }
})(), gJe = function(e, r12) {
  var n12 = z0(e), a = parseInt(n12.width) - parseInt(n12.paddingLeft) - parseInt(n12.paddingRight) - parseInt(n12.borderLeftWidth) - parseInt(n12.borderRightWidth), o = Li(e, 0, r12), i = Li(e, 1, r12), u = o && z0(o), s12 = i && z0(i), c = u && parseInt(u.marginLeft) + parseInt(u.marginRight) + k1(o).width, l2 = s12 && parseInt(s12.marginLeft) + parseInt(s12.marginRight) + k1(i).width;
  if (n12.display === "flex")
    return n12.flexDirection === "column" || n12.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (n12.display === "grid")
    return n12.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (o && u.float && u.float !== "none") {
    var f = u.float === "left" ? "left" : "right";
    return i && (s12.clear === "both" || s12.clear === f) ? "vertical" : "horizontal";
  }
  return o && (u.display === "block" || u.display === "flex" || u.display === "table" || u.display === "grid" || c >= a && n12[Kje] === "none" || i && n12[Kje] === "none" && c + l2 > a) ? "vertical" : "horizontal";
}, oi1 = function(e, r12, n12) {
  var a = n12 ? e.left : e.top, o = n12 ? e.right : e.bottom, i = n12 ? e.width : e.height, u = n12 ? r12.left : r12.top, s12 = n12 ? r12.right : r12.bottom, c = n12 ? r12.width : r12.height;
  return a === u || o === s12 || a + i / 2 === u + c / 2;
}, ii1 = function(e, r12) {
  var n12;
  return G2.some(function(a) {
    var o = a[$t].options.emptyInsertThreshold;
    if (!(!o || c1e(a))) {
      var i = k1(a), u = e >= i.left - o && e <= i.right + o, s12 = r12 >= i.top - o && r12 <= i.bottom + o;
      if (u && s12)
        return n12 = a;
    }
  }), n12;
}, IJe = function(e) {
  function r12(o, i) {
    return function(u, s12, c, l2) {
      var f = u.options.group.name && s12.options.group.name && u.options.group.name === s12.options.group.name;
      if (o == null && (i || f))
        return true;
      if (o == null || o === false)
        return false;
      if (i && o === "clone")
        return o;
      if (typeof o == "function")
        return r12(o(u, s12, c, l2), i)(u, s12, c, l2);
      var p = (i ? u : s12).options.group.name;
      return o === true || typeof o == "string" && o === p || o.join && o.indexOf(p) > -1;
    };
  }
  var n12 = {}, a = e.group;
  (!a || o2(a) != "object") && (a = {
    name: a
  }), n12.name = a.name, n12.checkPull = r12(a.pull, true), n12.checkPut = r12(a.put), n12.revertClone = a.revertClone, e.group = n12;
}, EJe = function() {
  !CJe && T0 && z0(T0, "display", "none");
}, LJe = function() {
  !CJe && T0 && z0(T0, "display", "");
};
ed && !hJe && document.addEventListener("click", function(t16) {
  if ($2)
    return t16.preventDefault(), t16.stopPropagation && t16.stopPropagation(), t16.stopImmediatePropagation && t16.stopImmediatePropagation(), $2 = false, false;
}, true);
var ro = function(e) {
  if (We) {
    e = e.touches ? e.touches[0] : e;
    var r12 = ii1(e.clientX, e.clientY);
    if (r12) {
      var n12 = {};
      for (var a in e)
        e.hasOwnProperty(a) && (n12[a] = e[a]);
      n12.target = n12.rootEl = r12, n12.preventDefault = void 0, n12.stopPropagation = void 0, r12[$t]._onDragOver(n12);
    }
  }
}, ui1 = function(e) {
  We && We.parentNode[$t]._isOutsideThisEl(e.target);
};
function A0(t16, e) {
  if (!(t16 && t16.nodeType && t16.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(t16));
  this.el = t16, this.options = e = sa({}, e), t16[$t] = this;
  var r12 = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(t16.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function() {
      return gJe(t16, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function(i, u) {
      i.setData("Text", u.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
    supportPointer: A0.supportPointer !== false && "PointerEvent" in window && (!hs || s1e),
    emptyInsertThreshold: 5
  };
  Bc.initializePlugins(this, t16, r12);
  for (var n12 in r12)
    !(n12 in e) && (e[n12] = r12[n12]);
  IJe(e);
  for (var a in this)
    a.charAt(0) === "_" && typeof this[a] == "function" && (this[a] = this[a].bind(this));
  this.nativeDraggable = e.forceFallback ? false : ai1, this.nativeDraggable && (this.options.touchStartThreshold = 1), e.supportPointer ? j0(t16, "pointerdown", this._onTapStart) : (j0(t16, "mousedown", this._onTapStart), j0(t16, "touchstart", this._onTapStart)), this.nativeDraggable && (j0(t16, "dragover", this), j0(t16, "dragenter", this)), G2.push(this.el), e.store && e.store.get && this.sort(e.store.get(this) || []), sa(this, Zo1());
}
A0.prototype = /** @lends Sortable.prototype */
{
  constructor: A0,
  _isOutsideThisEl: function(e) {
    !this.el.contains(e) && e !== this.el && (Yo = null);
  },
  _getDirection: function(e, r12) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, e, r12, We) : this.options.direction;
  },
  _onTapStart: function(e) {
    if (e.cancelable) {
      var r12 = this, n12 = this.el, a = this.options, o = a.preventOnFilter, i = e.type, u = e.touches && e.touches[0] || e.pointerType && e.pointerType === "touch" && e, s12 = (u || e).target, c = e.target.shadowRoot && (e.path && e.path[0] || e.composedPath && e.composedPath()[0]) || s12, l2 = a.filter;
      if (Mi1(n12), !We && !(/mousedown|pointerdown/.test(i) && e.button !== 0 || a.disabled) && !c.isContentEditable && !(!this.nativeDraggable && hs && s12 && s12.tagName.toUpperCase() === "SELECT") && (s12 = Fr(s12, a.draggable, n12, false), !(s12 && s12.animated) && i2 !== s12)) {
        if (oi = Mr(s12), ms = Mr(s12, a.draggable), typeof l2 == "function") {
          if (l2.call(this, e, s12, this)) {
            It({
              sortable: r12,
              rootEl: c,
              name: "filter",
              targetEl: s12,
              toEl: n12,
              fromEl: n12
            }), xt("filter", r12, {
              evt: e
            }), o && e.preventDefault();
            return;
          }
        } else if (l2 && (l2 = l2.split(",").some(function(f) {
          if (f = Fr(c, f.trim(), n12, false), f)
            return It({
              sortable: r12,
              rootEl: f,
              name: "filter",
              targetEl: s12,
              fromEl: n12,
              toEl: n12
            }), xt("filter", r12, {
              evt: e
            }), true;
        }), l2)) {
          o && e.preventDefault();
          return;
        }
        a.handle && !Fr(c, a.handle, n12, false) || this._prepareDragStart(e, u, s12);
      }
    }
  },
  _prepareDragStart: function(e, r12, n12) {
    var a = this, o = a.el, i = a.options, u = o.ownerDocument, s12;
    if (n12 && !We && n12.parentNode === o) {
      var c = k1(n12);
      if (v1 = o, We = n12, g1 = We.parentNode, oo = We.nextSibling, i2 = n12, Pl = i.group, A0.dragged = We, to = {
        target: We,
        clientX: (r12 || e).clientX,
        clientY: (r12 || e).clientY
      }, Yje = to.clientX - c.left, Jje = to.clientY - c.top, this._lastX = (r12 || e).clientX, this._lastY = (r12 || e).clientY, We.style["will-change"] = "all", s12 = function() {
        if (xt("delayEnded", a, {
          evt: e
        }), A0.eventCanceled) {
          a._onDrop();
          return;
        }
        a._disableDelayedDragEvents(), !Hje && a.nativeDraggable && (We.draggable = true), a._triggerDragStart(e, r12), It({
          sortable: a,
          name: "choose",
          originalEvent: e
        }), rr(We, i.chosenClass, true);
      }, i.ignore.split(",").forEach(function(l2) {
        RJe(We, l2.trim(), vQ);
      }), j0(u, "dragover", ro), j0(u, "mousemove", ro), j0(u, "touchmove", ro), i.supportPointer ? (j0(u, "pointerup", a._onDrop), !this.nativeDraggable && j0(u, "pointercancel", a._onDrop)) : (j0(u, "mouseup", a._onDrop), j0(u, "touchend", a._onDrop), j0(u, "touchcancel", a._onDrop)), Hje && this.nativeDraggable && (this.options.touchStartThreshold = 4, We.draggable = true), xt("delayStart", this, {
        evt: e
      }), i.delay && (!i.delayOnTouchOnly || r12) && (!this.nativeDraggable || !(wc || Ma))) {
        if (A0.eventCanceled) {
          this._onDrop();
          return;
        }
        i.supportPointer ? (j0(u, "pointerup", a._disableDelayedDrag), j0(u, "pointercancel", a._disableDelayedDrag)) : (j0(u, "mouseup", a._disableDelayedDrag), j0(u, "touchend", a._disableDelayedDrag), j0(u, "touchcancel", a._disableDelayedDrag)), j0(u, "mousemove", a._delayedDragTouchMoveHandler), j0(u, "touchmove", a._delayedDragTouchMoveHandler), i.supportPointer && j0(u, "pointermove", a._delayedDragTouchMoveHandler), a._dragStartTimer = setTimeout(s12, i.delay);
      } else
        s12();
    }
  },
  _delayedDragTouchMoveHandler: function(e) {
    var r12 = e.touches ? e.touches[0] : e;
    Math.max(Math.abs(r12.clientX - this._lastX), Math.abs(r12.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    We && vQ(We), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var e = this.el.ownerDocument;
    U0(e, "mouseup", this._disableDelayedDrag), U0(e, "touchend", this._disableDelayedDrag), U0(e, "touchcancel", this._disableDelayedDrag), U0(e, "pointerup", this._disableDelayedDrag), U0(e, "pointercancel", this._disableDelayedDrag), U0(e, "mousemove", this._delayedDragTouchMoveHandler), U0(e, "touchmove", this._delayedDragTouchMoveHandler), U0(e, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(e, r12) {
    r12 = r12 || e.pointerType == "touch" && e, !this.nativeDraggable || r12 ? this.options.supportPointer ? j0(document, "pointermove", this._onTouchMove) : r12 ? j0(document, "touchmove", this._onTouchMove) : j0(document, "mousemove", this._onTouchMove) : (j0(We, "dragend", this), j0(v1, "dragstart", this._onDragStart));
    try {
      document.selection ? s2(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(e, r12) {
    if (Zo = false, v1 && We) {
      xt("dragStarted", this, {
        evt: r12
      }), this.nativeDraggable && j0(document, "dragover", ui1);
      var n12 = this.options;
      !e && rr(We, n12.dragClass, false), rr(We, n12.ghostClass, true), A0.active = this, e && this._appendGhost(), It({
        sortable: this,
        name: "start",
        originalEvent: r12
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (xr) {
      this._lastX = xr.clientX, this._lastY = xr.clientY, EJe();
      for (var e = document.elementFromPoint(xr.clientX, xr.clientY), r12 = e; e && e.shadowRoot && (e = e.shadowRoot.elementFromPoint(xr.clientX, xr.clientY), e !== r12); )
        r12 = e;
      if (We.parentNode[$t]._isOutsideThisEl(e), r12)
        do {
          if (r12[$t]) {
            var n12 = void 0;
            if (n12 = r12[$t]._onDragOver({
              clientX: xr.clientX,
              clientY: xr.clientY,
              target: e,
              rootEl: r12
            }), n12 && !this.options.dragoverBubble)
              break;
          }
          e = r12;
        } while (r12 = mJe(r12));
      LJe();
    }
  },
  _onTouchMove: function(e) {
    if (to) {
      var r12 = this.options, n12 = r12.fallbackTolerance, a = r12.fallbackOffset, o = e.touches ? e.touches[0] : e, i = T0 && bi(T0, true), u = T0 && i && i.a, s12 = T0 && i && i.d, c = Wl && At && Gje(At), l2 = (o.clientX - to.clientX + a.x) / (u || 1) + (c ? c[0] - hQ[0] : 0) / (u || 1), f = (o.clientY - to.clientY + a.y) / (s12 || 1) + (c ? c[1] - hQ[1] : 0) / (s12 || 1);
      if (!A0.active && !Zo) {
        if (n12 && Math.max(Math.abs(o.clientX - this._lastX), Math.abs(o.clientY - this._lastY)) < n12)
          return;
        this._onDragStart(e, true);
      }
      if (T0) {
        i ? (i.e += l2 - (AQ || 0), i.f += f - (_Q || 0)) : i = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: l2,
          f
        };
        var p = "matrix(".concat(i.a, ",").concat(i.b, ",").concat(i.c, ",").concat(i.d, ",").concat(i.e, ",").concat(i.f, ")");
        z0(T0, "webkitTransform", p), z0(T0, "mozTransform", p), z0(T0, "msTransform", p), z0(T0, "transform", p), AQ = l2, _Q = f, xr = o;
      }
      e.cancelable && e.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!T0) {
      var e = this.options.fallbackOnBody ? document.body : v1, r12 = k1(We, true, Wl, true, e), n12 = this.options;
      if (Wl) {
        for (At = e; z0(At, "position") === "static" && z0(At, "transform") === "none" && At !== document; )
          At = At.parentNode;
        At !== document.body && At !== document.documentElement ? (At === document && (At = zn()), r12.top += At.scrollTop, r12.left += At.scrollLeft) : At = zn(), hQ = Gje(At);
      }
      T0 = We.cloneNode(true), rr(T0, n12.ghostClass, false), rr(T0, n12.fallbackClass, true), rr(T0, n12.dragClass, true), z0(T0, "transition", ""), z0(T0, "transform", ""), z0(T0, "box-sizing", "border-box"), z0(T0, "margin", 0), z0(T0, "top", r12.top), z0(T0, "left", r12.left), z0(T0, "width", r12.width), z0(T0, "height", r12.height), z0(T0, "opacity", "0.8"), z0(T0, "position", Wl ? "absolute" : "fixed"), z0(T0, "zIndex", "100000"), z0(T0, "pointerEvents", "none"), A0.ghost = T0, e.appendChild(T0), z0(T0, "transform-origin", Yje / parseInt(T0.style.width) * 100 + "% " + Jje / parseInt(T0.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(e, r12) {
    var n12 = this, a = e.dataTransfer, o = n12.options;
    if (xt("dragStart", this, {
      evt: e
    }), A0.eventCanceled) {
      this._onDrop();
      return;
    }
    xt("setupClone", this), A0.eventCanceled || (T1 = yJe(We), T1.removeAttribute("id"), T1.draggable = false, T1.style["will-change"] = "", this._hideClone(), rr(T1, this.options.chosenClass, false), A0.clone = T1), n12.cloneId = s2(function() {
      xt("clone", n12), !A0.eventCanceled && (n12.options.removeCloneOnHide || v1.insertBefore(T1, We), n12._hideClone(), It({
        sortable: n12,
        name: "clone"
      }));
    }), !r12 && rr(We, o.dragClass, true), r12 ? ($2 = true, n12._loopId = setInterval(n12._emulateDragOver, 50)) : (U0(document, "mouseup", n12._onDrop), U0(document, "touchend", n12._onDrop), U0(document, "touchcancel", n12._onDrop), a && (a.effectAllowed = "move", o.setData && o.setData.call(n12, a, We)), j0(document, "drop", n12), z0(We, "transform", "translateZ(0)")), Zo = true, n12._dragStartId = s2(n12._dragStarted.bind(n12, r12, e)), j0(document, "selectstart", n12), us = true, window.getSelection().removeAllRanges(), hs && z0(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(e) {
    var r12 = this.el, n12 = e.target, a, o, i, u = this.options, s12 = u.group, c = A0.active, l2 = Pl === s12, f = u.sort, p = lt || c, d, b = this, z = false;
    if (JZ)
      return;
    function _(Z, se) {
      xt(Z, b, Rn({
        evt: e,
        isOwner: l2,
        axis: d ? "vertical" : "horizontal",
        revert: i,
        dragRect: a,
        targetRect: o,
        canSort: f,
        fromSortable: p,
        target: n12,
        completed: S,
        onMove: function(ie, ye) {
          return Nl(v1, r12, We, a, ie, k1(ie), e, ye);
        },
        changed: N
      }, se));
    }
    function q() {
      _("dragOverAnimationCapture"), b.captureAnimationState(), b !== p && p.captureAnimationState();
    }
    function S(Z) {
      return _("dragOverCompleted", {
        insertion: Z
      }), Z && (l2 ? c._hideClone() : c._showClone(b), b !== p && (rr(We, lt ? lt.options.ghostClass : c.options.ghostClass, false), rr(We, u.ghostClass, true)), lt !== b && b !== A0.active ? lt = b : b === A0.active && lt && (lt = null), p === b && (b._ignoreWhileAnimating = n12), b.animateAll(function() {
        _("dragOverAnimationComplete"), b._ignoreWhileAnimating = null;
      }), b !== p && (p.animateAll(), p._ignoreWhileAnimating = null)), (n12 === We && !We.animated || n12 === r12 && !n12.animated) && (Yo = null), !u.dragoverBubble && !e.rootEl && n12 !== document && (We.parentNode[$t]._isOutsideThisEl(e.target), !Z && ro(e)), !u.dragoverBubble && e.stopPropagation && e.stopPropagation(), z = true;
    }
    function N() {
      nr = Mr(We), qa = Mr(We, u.draggable), It({
        sortable: b,
        name: "change",
        toEl: r12,
        newIndex: nr,
        newDraggableIndex: qa,
        originalEvent: e
      });
    }
    if (e.preventDefault !== void 0 && e.cancelable && e.preventDefault(), n12 = Fr(n12, u.draggable, r12, true), _("dragOver"), A0.eventCanceled)
      return z;
    if (We.contains(e.target) || n12.animated && n12.animatingX && n12.animatingY || b._ignoreWhileAnimating === n12)
      return S(false);
    if ($2 = false, c && !u.disabled && (l2 ? f || (i = g1 !== v1) : lt === this || (this.lastPutMode = Pl.checkPull(this, c, We, e)) && s12.checkPut(this, c, We, e))) {
      if (d = this._getDirection(e, n12) === "vertical", a = k1(We), _("dragOverValid"), A0.eventCanceled)
        return z;
      if (i)
        return g1 = v1, q(), this._hideClone(), _("revert"), A0.eventCanceled || (oo ? v1.insertBefore(We, oo) : v1.appendChild(We)), S(true);
      var v = c1e(r12, u.draggable);
      if (!v || pi1(e, d, this) && !v.animated) {
        if (v === We)
          return S(false);
        if (v && r12 === e.target && (n12 = v), n12 && (o = k1(n12)), Nl(v1, r12, We, a, n12, o, e, !!n12) !== false)
          return q(), v && v.nextSibling ? r12.insertBefore(We, v.nextSibling) : r12.appendChild(We), g1 = r12, N(), S(true);
      } else if (v && li1(e, d, this)) {
        var C = Li(r12, 0, u, true);
        if (C === We)
          return S(false);
        if (n12 = C, o = k1(n12), Nl(v1, r12, We, a, n12, o, e, false) !== false)
          return q(), r12.insertBefore(We, C), g1 = r12, N(), S(true);
      } else if (n12.parentNode === r12) {
        o = k1(n12);
        var L = 0, B, P12 = We.parentNode !== r12, j = !oi1(We.animated && We.toRect || a, n12.animated && n12.toRect || o, d), $ = d ? "top" : "left", W = $je(n12, "top", "top") || $je(We, "top", "top"), x = W ? W.scrollTop : void 0;
        Yo !== n12 && (B = o[$], qs = false, Dl = !j && u.invertSwap || P12), L = di1(e, n12, o, d, j ? 1 : u.swapThreshold, u.invertedSwapThreshold == null ? u.swapThreshold : u.invertedSwapThreshold, Dl, Yo === n12);
        var D;
        if (L !== 0) {
          var w = Mr(We);
          do
            w -= L, D = g1.children[w];
          while (D && (z0(D, "display") === "none" || D === T0));
        }
        if (L === 0 || D === n12)
          return S(false);
        Yo = n12, Rs = L;
        var I = n12.nextElementSibling, Y = false;
        Y = L === 1;
        var oe = Nl(v1, r12, We, a, n12, o, e, Y);
        if (oe !== false)
          return (oe === 1 || oe === -1) && (Y = oe === 1), JZ = true, setTimeout(ci1, 30), q(), Y && !I ? r12.appendChild(We) : n12.parentNode.insertBefore(We, Y ? I : n12), W && TJe(W, 0, x - W.scrollTop), g1 = We.parentNode, B !== void 0 && !Dl && (u2 = Math.abs(B - k1(n12)[$])), N(), S(true);
      }
      if (r12.contains(We))
        return S(false);
    }
    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    U0(document, "mousemove", this._onTouchMove), U0(document, "touchmove", this._onTouchMove), U0(document, "pointermove", this._onTouchMove), U0(document, "dragover", ro), U0(document, "mousemove", ro), U0(document, "touchmove", ro);
  },
  _offUpEvents: function() {
    var e = this.el.ownerDocument;
    U0(e, "mouseup", this._onDrop), U0(e, "touchend", this._onDrop), U0(e, "pointerup", this._onDrop), U0(e, "pointercancel", this._onDrop), U0(e, "touchcancel", this._onDrop), U0(document, "selectstart", this);
  },
  _onDrop: function(e) {
    var r12 = this.el, n12 = this.options;
    if (nr = Mr(We), qa = Mr(We, n12.draggable), xt("drop", this, {
      evt: e
    }), g1 = We && We.parentNode, nr = Mr(We), qa = Mr(We, n12.draggable), A0.eventCanceled) {
      this._nulling();
      return;
    }
    Zo = false, Dl = false, qs = false, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), KZ(this.cloneId), KZ(this._dragStartId), this.nativeDraggable && (U0(document, "drop", this), U0(r12, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), hs && z0(document.body, "user-select", ""), z0(We, "transform", ""), e && (us && (e.cancelable && e.preventDefault(), !n12.dropBubble && e.stopPropagation()), T0 && T0.parentNode && T0.parentNode.removeChild(T0), (v1 === g1 || lt && lt.lastPutMode !== "clone") && T1 && T1.parentNode && T1.parentNode.removeChild(T1), We && (this.nativeDraggable && U0(We, "dragend", this), vQ(We), We.style["will-change"] = "", us && !Zo && rr(We, lt ? lt.options.ghostClass : this.options.ghostClass, false), rr(We, this.options.chosenClass, false), It({
      sortable: this,
      name: "unchoose",
      toEl: g1,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: e
    }), v1 !== g1 ? (nr >= 0 && (It({
      rootEl: g1,
      name: "add",
      toEl: g1,
      fromEl: v1,
      originalEvent: e
    }), It({
      sortable: this,
      name: "remove",
      toEl: g1,
      originalEvent: e
    }), It({
      rootEl: g1,
      name: "sort",
      toEl: g1,
      fromEl: v1,
      originalEvent: e
    }), It({
      sortable: this,
      name: "sort",
      toEl: g1,
      originalEvent: e
    })), lt && lt.save()) : nr !== oi && nr >= 0 && (It({
      sortable: this,
      name: "update",
      toEl: g1,
      originalEvent: e
    }), It({
      sortable: this,
      name: "sort",
      toEl: g1,
      originalEvent: e
    })), A0.active && ((nr == null || nr === -1) && (nr = oi, qa = ms), It({
      sortable: this,
      name: "end",
      toEl: g1,
      originalEvent: e
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    xt("nulling", this), v1 = We = g1 = T0 = oo = T1 = i2 = Ca = to = xr = us = nr = qa = oi = ms = Yo = Rs = lt = Pl = A0.dragged = A0.ghost = A0.clone = A0.active = null, Y2.forEach(function(e) {
      e.checked = true;
    }), Y2.length = AQ = _Q = 0;
  },
  handleEvent: function(e) {
    switch (e.type) {
      case "drop":
      case "dragend":
        this._onDrop(e);
        break;
      case "dragenter":
      case "dragover":
        We && (this._onDragOver(e), si1(e));
        break;
      case "selectstart":
        e.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var e = [], r12, n12 = this.el.children, a = 0, o = n12.length, i = this.options; a < o; a++)
      r12 = n12[a], Fr(r12, i.draggable, this.el, false) && e.push(r12.getAttribute(i.dataIdAttr) || bi1(r12));
    return e;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(e, r12) {
    var n12 = {}, a = this.el;
    this.toArray().forEach(function(o, i) {
      var u = a.children[i];
      Fr(u, this.options.draggable, a, false) && (n12[o] = u);
    }, this), r12 && this.captureAnimationState(), e.forEach(function(o) {
      n12[o] && (a.removeChild(n12[o]), a.appendChild(n12[o]));
    }), r12 && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var e = this.options.store;
    e && e.set && e.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(e, r12) {
    return Fr(e, r12 || this.options.draggable, this.el, false);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(e, r12) {
    var n12 = this.options;
    if (r12 === void 0)
      return n12[e];
    var a = Bc.modifyOption(this, e, r12);
    typeof a < "u" ? n12[e] = a : n12[e] = r12, e === "group" && IJe(n12);
  },
  /**
   * Destroy
   */
  destroy: function() {
    xt("destroy", this);
    var e = this.el;
    e[$t] = null, U0(e, "mousedown", this._onTapStart), U0(e, "touchstart", this._onTapStart), U0(e, "pointerdown", this._onTapStart), this.nativeDraggable && (U0(e, "dragover", this), U0(e, "dragenter", this)), Array.prototype.forEach.call(e.querySelectorAll("[draggable]"), function(r12) {
      r12.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), G2.splice(G2.indexOf(this.el), 1), this.el = e = null;
  },
  _hideClone: function() {
    if (!Ca) {
      if (xt("hideClone", this), A0.eventCanceled)
        return;
      z0(T1, "display", "none"), this.options.removeCloneOnHide && T1.parentNode && T1.parentNode.removeChild(T1), Ca = true;
    }
  },
  _showClone: function(e) {
    if (e.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (Ca) {
      if (xt("showClone", this), A0.eventCanceled)
        return;
      We.parentNode == v1 && !this.options.group.revertClone ? v1.insertBefore(T1, We) : oo ? v1.insertBefore(T1, oo) : v1.appendChild(T1), this.options.group.revertClone && this.animate(We, T1), z0(T1, "display", ""), Ca = false;
    }
  }
};
function si1(t16) {
  t16.dataTransfer && (t16.dataTransfer.dropEffect = "move"), t16.cancelable && t16.preventDefault();
}
function Nl(t16, e, r12, n12, a, o, i, u) {
  var s12, c = t16[$t], l2 = c.options.onMove, f;
  return window.CustomEvent && !Ma && !wc ? s12 = new CustomEvent("move", {
    bubbles: true,
    cancelable: true
  }) : (s12 = document.createEvent("Event"), s12.initEvent("move", true, true)), s12.to = e, s12.from = t16, s12.dragged = r12, s12.draggedRect = n12, s12.related = a || e, s12.relatedRect = o || k1(e), s12.willInsertAfter = u, s12.originalEvent = i, t16.dispatchEvent(s12), l2 && (f = l2.call(c, s12, i)), f;
}
function vQ(t16) {
  t16.draggable = false;
}
function ci1() {
  JZ = false;
}
function li1(t16, e, r12) {
  var n12 = k1(Li(r12.el, 0, r12.options, true)), a = SJe(r12.el, r12.options, T0), o = 10;
  return e ? t16.clientX < a.left - o || t16.clientY < n12.top && t16.clientX < n12.right : t16.clientY < a.top - o || t16.clientY < n12.bottom && t16.clientX < n12.left;
}
function pi1(t16, e, r12) {
  var n12 = k1(c1e(r12.el, r12.options.draggable)), a = SJe(r12.el, r12.options, T0), o = 10;
  return e ? t16.clientX > a.right + o || t16.clientY > n12.bottom && t16.clientX > n12.left : t16.clientY > a.bottom + o || t16.clientX > n12.right && t16.clientY > n12.top;
}
function di1(t16, e, r12, n12, a, o, i, u) {
  var s12 = n12 ? t16.clientY : t16.clientX, c = n12 ? r12.height : r12.width, l2 = n12 ? r12.top : r12.left, f = n12 ? r12.bottom : r12.right, p = false;
  if (!i) {
    if (u && u2 < c * a) {
      if (!qs && (Rs === 1 ? s12 > l2 + c * o / 2 : s12 < f - c * o / 2) && (qs = true), qs)
        p = true;
      else if (Rs === 1 ? s12 < l2 + u2 : s12 > f - u2)
        return -Rs;
    } else if (s12 > l2 + c * (1 - a) / 2 && s12 < f - c * (1 - a) / 2)
      return fi1(e);
  }
  return p = p || i, p && (s12 < l2 + c * o / 2 || s12 > f - c * o / 2) ? s12 > l2 + c / 2 ? 1 : -1 : 0;
}
function fi1(t16) {
  return Mr(We) < Mr(t16) ? 1 : -1;
}
function bi1(t16) {
  for (var e = t16.tagName + t16.className + t16.src + t16.href + t16.textContent, r12 = e.length, n12 = 0; r12--; )
    n12 += e.charCodeAt(r12);
  return n12.toString(36);
}
function Mi1(t16) {
  Y2.length = 0;
  for (var e = t16.getElementsByTagName("input"), r12 = e.length; r12--; ) {
    var n12 = e[r12];
    n12.checked && Y2.push(n12);
  }
}
function s2(t16) {
  return setTimeout(t16, 0);
}
function KZ(t16) {
  return clearTimeout(t16);
}
ed && j0(document, "touchmove", function(t16) {
  (A0.active || Zo) && t16.cancelable && t16.preventDefault();
});
A0.utils = {
  on: j0,
  off: U0,
  css: z0,
  find: RJe,
  is: function(e, r12) {
    return !!Fr(e, r12, e, false);
  },
  extend: Ko1,
  throttle: qJe,
  closest: Fr,
  toggleClass: rr,
  clone: yJe,
  index: Mr,
  nextTick: s2,
  cancelNextTick: KZ,
  detectDirection: gJe,
  getChild: Li,
  expando: $t
};
A0.get = function(t16) {
  return t16[$t];
};
A0.mount = function() {
  for (var t16 = arguments.length, e = new Array(t16), r12 = 0; r12 < t16; r12++)
    e[r12] = arguments[r12];
  e[0].constructor === Array && (e = e[0]), e.forEach(function(n12) {
    if (!n12.prototype || !n12.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(n12));
    n12.utils && (A0.utils = Rn(Rn({}, A0.utils), n12.utils)), Bc.mount(n12);
  });
};
A0.create = function(t16, e) {
  return new A0(t16, e);
};
A0.version = Yo1;
var B1 = [], ss, QZ, ZZ = false, mQ, RQ, J2, cs;
function Oi1() {
  function t16() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    };
    for (var e in this)
      e.charAt(0) === "_" && typeof this[e] == "function" && (this[e] = this[e].bind(this));
  }
  return t16.prototype = {
    dragStarted: function(r12) {
      var n12 = r12.originalEvent;
      this.sortable.nativeDraggable ? j0(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? j0(document, "pointermove", this._handleFallbackAutoScroll) : n12.touches ? j0(document, "touchmove", this._handleFallbackAutoScroll) : j0(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(r12) {
      var n12 = r12.originalEvent;
      !this.options.dragOverBubble && !n12.rootEl && this._handleAutoScroll(n12);
    },
    drop: function() {
      this.sortable.nativeDraggable ? U0(document, "dragover", this._handleAutoScroll) : (U0(document, "pointermove", this._handleFallbackAutoScroll), U0(document, "touchmove", this._handleFallbackAutoScroll), U0(document, "mousemove", this._handleFallbackAutoScroll)), Qje(), c2(), Qo1();
    },
    nulling: function() {
      J2 = QZ = ss = ZZ = cs = mQ = RQ = null, B1.length = 0;
    },
    _handleFallbackAutoScroll: function(r12) {
      this._handleAutoScroll(r12, true);
    },
    _handleAutoScroll: function(r12, n12) {
      var a = this, o = (r12.touches ? r12.touches[0] : r12).clientX, i = (r12.touches ? r12.touches[0] : r12).clientY, u = document.elementFromPoint(o, i);
      if (J2 = r12, n12 || this.options.forceAutoScrollFallback || wc || Ma || hs) {
        qQ(r12, this.options, u, n12);
        var s12 = Pa(u, true);
        ZZ && (!cs || o !== mQ || i !== RQ) && (cs && Qje(), cs = setInterval(function() {
          var c = Pa(document.elementFromPoint(o, i), true);
          c !== s12 && (s12 = c, c2()), qQ(r12, a.options, c, n12);
        }, 10), mQ = o, RQ = i);
      } else {
        if (!this.options.bubbleScroll || Pa(u, true) === zn()) {
          c2();
          return;
        }
        qQ(r12, this.options, Pa(u, false), false);
      }
    }
  }, sa(t16, {
    pluginName: "scroll",
    initializeByDefault: true
  });
}
function c2() {
  B1.forEach(function(t16) {
    clearInterval(t16.pid);
  }), B1 = [];
}
function Qje() {
  clearInterval(cs);
}
var qQ = qJe(function(t16, e, r12, n12) {
  if (e.scroll) {
    var a = (t16.touches ? t16.touches[0] : t16).clientX, o = (t16.touches ? t16.touches[0] : t16).clientY, i = e.scrollSensitivity, u = e.scrollSpeed, s12 = zn(), c = false, l2;
    QZ !== r12 && (QZ = r12, c2(), ss = e.scroll, l2 = e.scrollFn, ss === true && (ss = Pa(r12, true)));
    var f = 0, p = ss;
    do {
      var d = p, b = k1(d), z = b.top, _ = b.bottom, q = b.left, S = b.right, N = b.width, v = b.height, C = void 0, L = void 0, B = d.scrollWidth, P12 = d.scrollHeight, j = z0(d), $ = d.scrollLeft, W = d.scrollTop;
      d === s12 ? (C = N < B && (j.overflowX === "auto" || j.overflowX === "scroll" || j.overflowX === "visible"), L = v < P12 && (j.overflowY === "auto" || j.overflowY === "scroll" || j.overflowY === "visible")) : (C = N < B && (j.overflowX === "auto" || j.overflowX === "scroll"), L = v < P12 && (j.overflowY === "auto" || j.overflowY === "scroll"));
      var x = C && (Math.abs(S - a) <= i && $ + N < B) - (Math.abs(q - a) <= i && !!$), D = L && (Math.abs(_ - o) <= i && W + v < P12) - (Math.abs(z - o) <= i && !!W);
      if (!B1[f])
        for (var w = 0; w <= f; w++)
          B1[w] || (B1[w] = {});
      (B1[f].vx != x || B1[f].vy != D || B1[f].el !== d) && (B1[f].el = d, B1[f].vx = x, B1[f].vy = D, clearInterval(B1[f].pid), (x != 0 || D != 0) && (c = true, B1[f].pid = setInterval((function() {
        n12 && this.layer === 0 && A0.active._onTouchMove(J2);
        var I = B1[this.layer].vy ? B1[this.layer].vy * u : 0, Y = B1[this.layer].vx ? B1[this.layer].vx * u : 0;
        typeof l2 == "function" && l2.call(A0.dragged.parentNode[$t], Y, I, t16, J2, B1[this.layer].el) !== "continue" || TJe(B1[this.layer].el, Y, I);
      }).bind({
        layer: f
      }), 24))), f++;
    } while (e.bubbleScroll && p !== s12 && (p = Pa(p, false)));
    ZZ = c;
  }
}, 30), PJe = function(e) {
  var r12 = e.originalEvent, n12 = e.putSortable, a = e.dragEl, o = e.activeSortable, i = e.dispatchSortableEvent, u = e.hideGhostForTarget, s12 = e.unhideGhostForTarget;
  if (r12) {
    var c = n12 || o;
    u();
    var l2 = r12.changedTouches && r12.changedTouches.length ? r12.changedTouches[0] : r12, f = document.elementFromPoint(l2.clientX, l2.clientY);
    s12(), c && !c.el.contains(f) && (i("spill"), this.onSpill({
      dragEl: a,
      putSortable: n12
    }));
  }
};
function l1e() {
}
l1e.prototype = {
  startIndex: null,
  dragStart: function(e) {
    var r12 = e.oldDraggableIndex;
    this.startIndex = r12;
  },
  onSpill: function(e) {
    var r12 = e.dragEl, n12 = e.putSortable;
    this.sortable.captureAnimationState(), n12 && n12.captureAnimationState();
    var a = Li(this.sortable.el, this.startIndex, this.options);
    a ? this.sortable.el.insertBefore(r12, a) : this.sortable.el.appendChild(r12), this.sortable.animateAll(), n12 && n12.animateAll();
  },
  drop: PJe
};
sa(l1e, {
  pluginName: "revertOnSpill"
});
function p1e() {
}
p1e.prototype = {
  onSpill: function(e) {
    var r12 = e.dragEl, n12 = e.putSortable, a = n12 || this.sortable;
    a.captureAnimationState(), r12.parentNode && r12.parentNode.removeChild(r12), a.animateAll();
  },
  drop: PJe
};
sa(p1e, {
  pluginName: "removeOnSpill"
});
A0.mount(new Oi1());
A0.mount(p1e, l1e);
var du1 = typeof l0 == "object" && l0 && l0.Object === Object && l0, BJe = du1, fu1 = BJe, bu1 = typeof self == "object" && self && self.Object === Object && self, Mu1 = fu1 || bu1 || Function("return this")(), In = Mu1, Ou1 = In, zu1 = Ou1.Symbol, d1e = zu1, Zje = d1e, xJe = Object.prototype, Au1 = xJe.hasOwnProperty, _u1 = xJe.toString, Hu = Zje ? Zje.toStringTag : void 0;
function hu1(t16) {
  var e = Au1.call(t16, Hu), r12 = t16[Hu];
  try {
    t16[Hu] = void 0;
    var n12 = true;
  } catch {
  }
  var a = _u1.call(t16);
  return n12 && (e ? t16[Hu] = r12 : delete t16[Hu]), a;
}
var vu1 = hu1, mu1 = Object.prototype, Ru1 = mu1.toString;
function qu1(t16) {
  return Ru1.call(t16);
}
var Tu1 = qu1, eFe = d1e, yu1 = vu1, Su1 = Tu1, Cu1 = "[object Null]", gu1 = "[object Undefined]", tFe = eFe ? eFe.toStringTag : void 0;
function Iu1(t16) {
  return t16 == null ? t16 === void 0 ? gu1 : Cu1 : tFe && tFe in Object(t16) ? yu1(t16) : Su1(t16);
}
var nd = Iu1;
function Eu1(t16) {
  var e = typeof t16;
  return t16 != null && (e == "object" || e == "function");
}
var xc = Eu1, Lu1 = nd, Pu1 = xc, Du1 = "[object AsyncFunction]", Wu1 = "[object Function]", Nu1 = "[object GeneratorFunction]", wu1 = "[object Proxy]";
function Bu1(t16) {
  if (!Pu1(t16))
    return false;
  var e = Lu1(t16);
  return e == Wu1 || e == Nu1 || e == Du1 || e == wu1;
}
var f1e = Bu1;
var Uu1 = In, ku1 = Uu1["__core-js_shared__"], ju1 = ku1, TQ = ju1, rFe = (function() {
  var t16 = /[^.]+$/.exec(TQ && TQ.keys && TQ.keys.IE_PROTO || "");
  return t16 ? "Symbol(src)_1." + t16 : "";
})();
function Fu1(t16) {
  return !!rFe && rFe in t16;
}
var Vu1 = Fu1, Hu1 = Function.prototype, Xu1 = Hu1.toString;
function $u1(t16) {
  if (t16 != null) {
    try {
      return Xu1.call(t16);
    } catch {
    }
    try {
      return t16 + "";
    } catch {
    }
  }
  return "";
}
var UJe = $u1, Gu1 = f1e, Yu1 = Vu1, Ju1 = xc, Ku1 = UJe, Qu1 = /[\\^$.*+?()[\]{}|]/g, Zu1 = /^\[object .+?Constructor\]$/, es1 = Function.prototype, ts1 = Object.prototype, rs1 = es1.toString, ns1 = ts1.hasOwnProperty, as1 = RegExp(
  "^" + rs1.call(ns1).replace(Qu1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function os1(t16) {
  if (!Ju1(t16) || Yu1(t16))
    return false;
  var e = Gu1(t16) ? as1 : Zu1;
  return e.test(Ku1(t16));
}
var is1 = os1;
function us1(t16, e) {
  return t16 == null ? void 0 : t16[e];
}
var ss1 = us1, cs1 = is1, ls1 = ss1;
function ps1(t16, e) {
  var r12 = ls1(t16, e);
  return cs1(r12) ? r12 : void 0;
}
var Lo = ps1, ds1 = Lo, fs1 = In, bs1 = ds1(fs1, "Map"), b1e = bs1, Ms1 = Lo;
Ms1(Object, "create");
var gc1 = Lo;
(function() {
  try {
    var t16 = gc1(Object, "defineProperty");
    return t16({}, "", {}), t16;
  } catch {
  }
})();
function Fc1(t16) {
  return t16 != null && typeof t16 == "object";
}
var Uc = Fc1, Vc1 = nd, Hc1 = Uc, Xc1 = "[object Arguments]";
function $c1(t16) {
  return Hc1(t16) && Vc1(t16) == Xc1;
}
var Gc1 = $c1, iFe = Gc1, Yc1 = Uc, FJe = Object.prototype, Jc1 = FJe.hasOwnProperty, Kc1 = FJe.propertyIsEnumerable;
iFe(/* @__PURE__ */ (function() {
  return arguments;
})()) ? iFe : function(t16) {
  return Yc1(t16) && Jc1.call(t16, "callee") && !Kc1.call(t16, "callee");
};
var K2 = { exports: {} };
function tl1() {
  return false;
}
var rl1 = tl1;
K2.exports;
(function(t16, e) {
  var r12 = In, n12 = rl1, a = e && !e.nodeType && e, o = a && true && t16 && !t16.nodeType && t16, i = o && o.exports === a, u = i ? r12.Buffer : void 0, s12 = u ? u.isBuffer : void 0, c = s12 || n12;
  t16.exports = c;
})(K2, K2.exports);
K2.exports;
var Q2 = { exports: {} };
Q2.exports;
(function(t16, e) {
  var r12 = BJe, n12 = e && !e.nodeType && e, a = n12 && true && t16 && !t16.nodeType && t16, o = a && a.exports === n12, i = o && r12.process, u = (function() {
    try {
      var s12 = a && a.require && a.require("util").types;
      return s12 || i && i.binding && i.binding("util");
    } catch {
    }
  })();
  t16.exports = u;
})(Q2, Q2.exports);
var z1e = Q2.exports, uFe = z1e;
uFe && uFe.isTypedArray;
var Z2 = { exports: {} };
Z2.exports;
(function(t16, e) {
  var r12 = In, n12 = e && !e.nodeType && e, a = n12 && true && t16 && !t16.nodeType && t16, o = a && a.exports === n12, i = o ? r12.Buffer : void 0, u = i ? i.allocUnsafe : void 0;
  function s12(c, l2) {
    if (l2)
      return c.slice();
    var f = c.length, p = u ? u(f) : new c.constructor(f);
    return c.copy(p), p;
  }
  t16.exports = s12;
})(Z2, Z2.exports);
Z2.exports;
var Tp1 = Lo, yp1 = In, Sp1 = Tp1(yp1, "DataView"), Cp1 = Sp1, gp1 = Lo, Ip1 = In, Ep1 = gp1(Ip1, "Promise"), Lp1 = Ep1, Pp1 = Lo, Dp1 = In, Wp1 = Pp1(Dp1, "Set"), Np1 = Wp1, wp1 = Lo, Bp1 = In, xp1 = wp1(Bp1, "WeakMap"), Up1 = xp1, eee = Cp1, tee = b1e, ree = Lp1, nee = Np1, aee = Up1, eKe = nd, Ji = UJe, lFe = "[object Map]", kp1 = "[object Object]", pFe = "[object Promise]", dFe = "[object Set]", fFe = "[object WeakMap]", bFe = "[object DataView]", jp1 = Ji(eee), Fp1 = Ji(tee), Vp1 = Ji(ree), Hp1 = Ji(nee), Xp1 = Ji(aee), io = eKe;
(eee && io(new eee(new ArrayBuffer(1))) != bFe || tee && io(new tee()) != lFe || ree && io(ree.resolve()) != pFe || nee && io(new nee()) != dFe || aee && io(new aee()) != fFe) && (io = function(t16) {
  var e = eKe(t16), r12 = e == kp1 ? t16.constructor : void 0, n12 = r12 ? Ji(r12) : "";
  if (n12)
    switch (n12) {
      case jp1:
        return bFe;
      case Fp1:
        return lFe;
      case Vp1:
        return pFe;
      case Hp1:
        return dFe;
      case Xp1:
        return fFe;
    }
  return e;
});
var Kp1 = In;
Kp1.Uint8Array;
var OFe = d1e, zFe = OFe ? OFe.prototype : void 0;
zFe ? zFe.valueOf : void 0;
var hFe = z1e;
hFe && hFe.isMap;
var mFe = z1e;
mFe && mFe.isSet;
N0.add(Dt0, jt0);
N0.add($t0);
N0.add(Cn0, kt0);
N0.add(nHe, aHe);
N0.add(Mp, fc);
var ht = /* @__PURE__ */ ((t16) => (t16.TopLeft = "top-left", t16.Top = "top", t16.TopRight = "top-right", t16.BottomLeft = "bottom-left", t16.Bottom = "bottom", t16.BottomRight = "bottom-right", t16))(ht || {});
const uKe = {
  alertType: dt.Toast,
  autoDismissAfter: 4e3,
  maxWidth: "600px",
  position: "bottom"
  /* Bottom */
};
class C31 {
  constructor(e, r12) {
    q0(this, "timerId");
    q0(this, "start");
    q0(this, "remaining");
    q0(this, "callback");
    this.callback = e, this.timerId = null, this.start = Date.now(), this.remaining = r12, this.resume();
  }
  pause() {
    this.timerId && clearTimeout(this.timerId), this.timerId = null, this.remaining -= Date.now() - this.start;
  }
  resume() {
    this.timerId || (this.start = Date.now(), this.timerId = setTimeout(() => {
      this.callback && this.callback();
    }, this.remaining));
  }
}
const ep = /* @__PURE__ */ ref([]);
function Ba(t16) {
  const e = {
    ...uKe,
    ...t16
  };
  e.autoDismissAfter && (e.timer = new C31(() => sKe(e, true), e.autoDismissAfter)), ep.value.push(e);
}
function ec(t16) {
  Ba({
    position: ht.TopRight,
    autoDismissAfter: void 0,
    content: {
      headline: "Error",
      message: t16,
      variant: l1.Error,
      alertType: dt.Inline,
      dismissible: true
    }
  });
}
function qt(t16, e) {
  const r12 = t16 != null && t16.errors ? t16.errors[0].message : t16 == null ? void 0 : t16.message;
  console.log(t16), ec(r12 || e);
}
function sKe(t16, e = false) {
  var n12;
  const r12 = ep.value.indexOf(t16);
  e && ((n12 = t16.content) != null && n12.onClose) && t16.content.onClose(), r12 !== -1 && ep.value.splice(r12, 1);
}
var Yn = /* @__PURE__ */ ((t16) => (t16.Invoice = "Invoice", t16.InvoiceLine = "InvoiceLine", t16.InvoiceItem = "InvoiceItem", t16.InvoiceLabor = "InvoiceLabor", t16.InvoiceExpense = "InvoiceExpense", t16))(Yn || {});
var L0 = /* @__PURE__ */ ((t16) => (t16.Pending = "Pending", t16.NeedsReview = "NeedsReview", t16.InReview = "InReview", t16.Error = "Error", t16.Duplicate = "Duplicate", t16.Rejected = "Rejected", t16.Sent = "Sent", t16.Deleted = "Deleted", t16))(L0 || {}), vo = /* @__PURE__ */ ((t16) => (t16.None = "None", t16.Warn = "Warn", t16.Block = "Block", t16))(vo || {}), Oi = /* @__PURE__ */ ((t16) => (t16.None = "None", t16.PurchaseOrder = "PurchaseOrder", t16.PurchaseOrderReceipts = "PurchaseOrderReceipts", t16))(Oi || {});
var q1e = /* @__PURE__ */ ((t16) => (t16.LookupSortLabelAsc = "LabelAsc", t16.LookupSortLabelDesc = "LabelDesc", t16.LookupSortSubLabelAsc = "SubLabelAsc", t16.LookupSortSubLabelDesc = "SubLabelDesc", t16))(q1e || {});
let W31 = class uee {
  constructor(e) {
    this.endpointOptions = e;
  }
  static create(e, r12) {
    const n12 = new uee(e), a = r12(n12);
    return a1.endpoints.push({ options: e, endpoint: a }), a;
  }
  static withBasePath(e) {
    return class extends uee {
      static create(r12, n12) {
        const a = {
          ...r12,
          base: `${e}${r12.base || ""}`
        };
        return super.create(a, n12);
      }
    };
  }
  getUrl(e = "", r12, n12) {
    return a1.getUrl({
      ...this.endpointOptions,
      method: "GET",
      url: e,
      params: r12,
      ...n12 || {}
    });
  }
  async get(e = "", r12, n12) {
    return a1.call({
      ...this.endpointOptions,
      method: "GET",
      url: e,
      params: r12,
      ...n12 || {}
    });
  }
  async post(e, r12, n12, a, o) {
    return a1.call(
      {
        ...this.endpointOptions,
        method: "POST",
        url: e,
        params: n12,
        data: r12,
        ...a || {}
      },
      o
    );
  }
  async put(e, r12, n12, a) {
    return a1.call({
      ...this.endpointOptions,
      method: "PUT",
      url: e,
      params: n12,
      data: r12,
      ...a || {}
    });
  }
  async patch(e, r12, n12, a) {
    return a1.call({
      ...this.endpointOptions,
      method: "PATCH",
      url: e,
      params: n12,
      data: r12,
      ...a || {}
    });
  }
  async delete(e = "", r12, n12, a) {
    return a1.call({
      ...this.endpointOptions,
      method: "DELETE",
      url: e,
      params: r12,
      data: a,
      ...n12 || {}
    });
  }
  async options(e = "", r12, n12) {
    return a1.call({
      ...this.endpointOptions,
      method: "OPTIONS",
      url: e,
      params: r12,
      ...n12 || {}
    });
  }
  async head(e = "", r12, n12) {
    return a1.call({
      ...this.endpointOptions,
      method: "HEAD",
      url: e,
      params: r12,
      ...n12 || {}
    });
  }
  api() {
    return a1;
  }
};
const Er = W31.withBasePath("/apinvscan/:product"), gFe = Er.create({ base: "/settings" }, (t16) => ({
  async getProductSettings(e) {
    return await t16.get("", { product: e });
  },
  async saveProductSettings(e, r12) {
    return await t16.patch("", r12, { product: e });
  }
})), N31 = Er.create({ base: "/config" }, (t16) => ({
  async getProductConfig(e) {
    return await t16.get("", { product: e });
  }
})), IFe = Er.create({ base: "/user-preferences" }, (t16) => ({
  async getUserPrefs(e) {
    return await t16.get("", { product: e });
  },
  async saveUserPrefs(e, r12) {
    return await t16.patch("", r12, { product: e });
  }
})), EFe = Er.create({ base: "" }, (t16) => ({
  async getSyncedMailboxes(e) {
    return await t16.post("/email-submissions/sync", {}, { product: e });
  },
  async updateMailboxes(e, r12) {
    return await t16.post("/email-submissions/mailboxes", r12, {
      product: e
    });
  }
})), St = /* @__PURE__ */ defineStore("product", () => {
  const t16 = /* @__PURE__ */ ref(), e = /* @__PURE__ */ ref({
    currencies: [],
    allowSkipApproval: false,
    defaultChildType: Yn.InvoiceLine,
    deleteButton: false,
    hasRecordConfigs: false,
    properties: {},
    requireApproval: false,
    requireApprovalText: "",
    reviewTitle: "",
    skipApprovalText: "",
    submitText: "",
    title: "",
    validChildTypes: [],
    visuals: [],
    enableClientValidation: false
  }), r12 = /* @__PURE__ */ ref({
    duplicateBehavior: vo.None,
    enableNotification: false,
    matchingBehavior: Oi.None,
    ignoreZeroAmountLineItems: false,
    emailSubmissions: false
  }), n12 = /* @__PURE__ */ ref({
    silenceDocumentsUploadedNotification: false
  }), a = async () => {
    if (!t16.value)
      return;
    e.value = await N31.getProductConfig(t16.value);
    const d = e.value.currencies.map((b) => ({
      id: Number(b.id),
      code: b.isoCode,
      precision: b.precision,
      isActive: true,
      isBaseCurrency: false,
      cultureCode: "",
      symbol: ""
    }));
    fe.DataCurrencies.splice(0, fe.DataCurrencies.length, ...d);
  }, o = async () => {
    t16.value && (r12.value = await gFe.getProductSettings(t16.value));
  }, i = async (d) => {
    if (!t16.value)
      return;
    (await gFe.saveProductSettings(t16.value, d)).message && (r12.value = d, a());
  }, u = async () => {
    t16.value && (n12.value = await IFe.getUserPrefs(t16.value));
  }, s12 = async (d) => {
    if (!t16.value)
      return;
    (await IFe.saveUserPrefs(t16.value, d)).message && (n12.value = d);
  }, c = computed(() => e.value.currencies.length > 1), l2 = /* @__PURE__ */ ref({ mailboxes: [] });
  return {
    getSettings: o,
    product: t16,
    saveSettings: i,
    settings: r12,
    getProductConfiguration: a,
    productConfiguration: e,
    getUserPrefs: u,
    saveUserPrefs: s12,
    userPreferences: n12,
    hasMultipleCurrencies: c,
    syncedMailboxes: l2,
    getSyncedMailboxes: async () => {
      t16.value && (l2.value = await EFe.getSyncedMailboxes(t16.value));
    },
    updateMailboxes: async (d) => t16.value ? await EFe.updateMailboxes(t16.value, d) : void 0
  };
});
function T1e() {
  return typeof window == "object" && (window == null ? void 0 : window.document) !== void 0;
}
var w31 = function() {
  var t16;
  if (T1e()) {
    var e = window, r12 = Array;
    if (e.Prototype !== void 0 && ((t16 = r12.prototype) === null || t16 === void 0 ? void 0 : t16.toJSON) !== void 0)
      return delete r12.prototype.toJSON, true;
  }
  return false;
}, lKe = { exports: {} };
(function(t16) {
  (function(e) {
    function r12(C, L) {
      var B = (C & 65535) + (L & 65535), P12 = (C >> 16) + (L >> 16) + (B >> 16);
      return P12 << 16 | B & 65535;
    }
    function n12(C, L) {
      return C << L | C >>> 32 - L;
    }
    function a(C, L, B, P12, j, $) {
      return r12(n12(r12(r12(L, C), r12(P12, $)), j), B);
    }
    function o(C, L, B, P12, j, $, W) {
      return a(L & B | ~L & P12, C, L, j, $, W);
    }
    function i(C, L, B, P12, j, $, W) {
      return a(L & P12 | B & ~P12, C, L, j, $, W);
    }
    function u(C, L, B, P12, j, $, W) {
      return a(L ^ B ^ P12, C, L, j, $, W);
    }
    function s12(C, L, B, P12, j, $, W) {
      return a(B ^ (L | ~P12), C, L, j, $, W);
    }
    function c(C, L) {
      C[L >> 5] |= 128 << L % 32, C[(L + 64 >>> 9 << 4) + 14] = L;
      var B, P12, j, $, W, x = 1732584193, D = -271733879, w = -1732584194, I = 271733878;
      for (B = 0; B < C.length; B += 16)
        P12 = x, j = D, $ = w, W = I, x = o(x, D, w, I, C[B], 7, -680876936), I = o(I, x, D, w, C[B + 1], 12, -389564586), w = o(w, I, x, D, C[B + 2], 17, 606105819), D = o(D, w, I, x, C[B + 3], 22, -1044525330), x = o(x, D, w, I, C[B + 4], 7, -176418897), I = o(I, x, D, w, C[B + 5], 12, 1200080426), w = o(w, I, x, D, C[B + 6], 17, -1473231341), D = o(D, w, I, x, C[B + 7], 22, -45705983), x = o(x, D, w, I, C[B + 8], 7, 1770035416), I = o(I, x, D, w, C[B + 9], 12, -1958414417), w = o(w, I, x, D, C[B + 10], 17, -42063), D = o(D, w, I, x, C[B + 11], 22, -1990404162), x = o(x, D, w, I, C[B + 12], 7, 1804603682), I = o(I, x, D, w, C[B + 13], 12, -40341101), w = o(w, I, x, D, C[B + 14], 17, -1502002290), D = o(D, w, I, x, C[B + 15], 22, 1236535329), x = i(x, D, w, I, C[B + 1], 5, -165796510), I = i(I, x, D, w, C[B + 6], 9, -1069501632), w = i(w, I, x, D, C[B + 11], 14, 643717713), D = i(D, w, I, x, C[B], 20, -373897302), x = i(x, D, w, I, C[B + 5], 5, -701558691), I = i(I, x, D, w, C[B + 10], 9, 38016083), w = i(w, I, x, D, C[B + 15], 14, -660478335), D = i(D, w, I, x, C[B + 4], 20, -405537848), x = i(x, D, w, I, C[B + 9], 5, 568446438), I = i(I, x, D, w, C[B + 14], 9, -1019803690), w = i(w, I, x, D, C[B + 3], 14, -187363961), D = i(D, w, I, x, C[B + 8], 20, 1163531501), x = i(x, D, w, I, C[B + 13], 5, -1444681467), I = i(I, x, D, w, C[B + 2], 9, -51403784), w = i(w, I, x, D, C[B + 7], 14, 1735328473), D = i(D, w, I, x, C[B + 12], 20, -1926607734), x = u(x, D, w, I, C[B + 5], 4, -378558), I = u(I, x, D, w, C[B + 8], 11, -2022574463), w = u(w, I, x, D, C[B + 11], 16, 1839030562), D = u(D, w, I, x, C[B + 14], 23, -35309556), x = u(x, D, w, I, C[B + 1], 4, -1530992060), I = u(I, x, D, w, C[B + 4], 11, 1272893353), w = u(w, I, x, D, C[B + 7], 16, -155497632), D = u(D, w, I, x, C[B + 10], 23, -1094730640), x = u(x, D, w, I, C[B + 13], 4, 681279174), I = u(I, x, D, w, C[B], 11, -358537222), w = u(w, I, x, D, C[B + 3], 16, -722521979), D = u(D, w, I, x, C[B + 6], 23, 76029189), x = u(x, D, w, I, C[B + 9], 4, -640364487), I = u(I, x, D, w, C[B + 12], 11, -421815835), w = u(w, I, x, D, C[B + 15], 16, 530742520), D = u(D, w, I, x, C[B + 2], 23, -995338651), x = s12(x, D, w, I, C[B], 6, -198630844), I = s12(I, x, D, w, C[B + 7], 10, 1126891415), w = s12(w, I, x, D, C[B + 14], 15, -1416354905), D = s12(D, w, I, x, C[B + 5], 21, -57434055), x = s12(x, D, w, I, C[B + 12], 6, 1700485571), I = s12(I, x, D, w, C[B + 3], 10, -1894986606), w = s12(w, I, x, D, C[B + 10], 15, -1051523), D = s12(D, w, I, x, C[B + 1], 21, -2054922799), x = s12(x, D, w, I, C[B + 8], 6, 1873313359), I = s12(I, x, D, w, C[B + 15], 10, -30611744), w = s12(w, I, x, D, C[B + 6], 15, -1560198380), D = s12(D, w, I, x, C[B + 13], 21, 1309151649), x = s12(x, D, w, I, C[B + 4], 6, -145523070), I = s12(I, x, D, w, C[B + 11], 10, -1120210379), w = s12(w, I, x, D, C[B + 2], 15, 718787259), D = s12(D, w, I, x, C[B + 9], 21, -343485551), x = r12(x, P12), D = r12(D, j), w = r12(w, $), I = r12(I, W);
      return [x, D, w, I];
    }
    function l2(C) {
      var L, B = "", P12 = C.length * 32;
      for (L = 0; L < P12; L += 8)
        B += String.fromCharCode(C[L >> 5] >>> L % 32 & 255);
      return B;
    }
    function f(C) {
      var L, B = [];
      for (B[(C.length >> 2) - 1] = void 0, L = 0; L < B.length; L += 1)
        B[L] = 0;
      var P12 = C.length * 8;
      for (L = 0; L < P12; L += 8)
        B[L >> 5] |= (C.charCodeAt(L / 8) & 255) << L % 32;
      return B;
    }
    function p(C) {
      return l2(c(f(C), C.length * 8));
    }
    function d(C, L) {
      var B, P12 = f(C), j = [], $ = [], W;
      for (j[15] = $[15] = void 0, P12.length > 16 && (P12 = c(P12, C.length * 8)), B = 0; B < 16; B += 1)
        j[B] = P12[B] ^ 909522486, $[B] = P12[B] ^ 1549556828;
      return W = c(j.concat(f(L)), 512 + L.length * 8), l2(c($.concat(W), 640));
    }
    function b(C) {
      var L = "0123456789abcdef", B = "", P12, j;
      for (j = 0; j < C.length; j += 1)
        P12 = C.charCodeAt(j), B += L.charAt(P12 >>> 4 & 15) + L.charAt(P12 & 15);
      return B;
    }
    function z(C) {
      return unescape(encodeURIComponent(C));
    }
    function _(C) {
      return p(z(C));
    }
    function q(C) {
      return b(_(C));
    }
    function S(C, L) {
      return d(z(C), z(L));
    }
    function N(C, L) {
      return b(S(C, L));
    }
    function v(C, L, B) {
      return L ? B ? S(L, C) : N(L, C) : B ? _(C) : q(C);
    }
    t16.exports ? t16.exports = v : e.md5 = v;
  })(l0);
})(lKe);
var B31 = lKe.exports;
const x31 = /* @__PURE__ */ Ni(B31), pKe = "%[a-f0-9]{2}", LFe = new RegExp("(" + pKe + ")|([^%]+?)", "gi"), PFe = new RegExp("(" + pKe + ")+", "gi");
function see(t16, e) {
  try {
    return [decodeURIComponent(t16.join(""))];
  } catch {
  }
  if (t16.length === 1)
    return t16;
  e = e || 1;
  const r12 = t16.slice(0, e), n12 = t16.slice(e);
  return Array.prototype.concat.call([], see(r12), see(n12));
}
function U31(t16) {
  try {
    return decodeURIComponent(t16);
  } catch {
    let e = t16.match(LFe) || [];
    for (let r12 = 1; r12 < e.length; r12++)
      t16 = see(e, r12).join(""), e = t16.match(LFe) || [];
    return t16;
  }
}
function k31(t16) {
  const e = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let r12 = PFe.exec(t16);
  for (; r12; ) {
    try {
      e[r12[0]] = decodeURIComponent(r12[0]);
    } catch {
      const a = U31(r12[0]);
      a !== r12[0] && (e[r12[0]] = a);
    }
    r12 = PFe.exec(t16);
  }
  e["%C2"] = "�";
  const n12 = Object.keys(e);
  for (const a of n12)
    t16 = t16.replace(new RegExp(a, "g"), e[a]);
  return t16;
}
function j31(t16) {
  if (typeof t16 != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof t16 + "`");
  try {
    return decodeURIComponent(t16);
  } catch {
    return k31(t16);
  }
}
function dKe(t16, e) {
  if (!(typeof t16 == "string" && typeof e == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (t16 === "" || e === "")
    return [];
  const r12 = t16.indexOf(e);
  return r12 === -1 ? [] : [
    t16.slice(0, r12),
    t16.slice(r12 + e.length)
  ];
}
function F31(t16, e) {
  const r12 = {};
  if (Array.isArray(e))
    for (const n12 of e) {
      const a = Object.getOwnPropertyDescriptor(t16, n12);
      a != null && a.enumerable && Object.defineProperty(r12, n12, a);
    }
  else
    for (const n12 of Reflect.ownKeys(t16)) {
      const a = Object.getOwnPropertyDescriptor(t16, n12);
      if (a.enumerable) {
        const o = t16[n12];
        e(n12, o, t16) && Object.defineProperty(r12, n12, a);
      }
    }
  return r12;
}
const V31 = (t16) => t16 == null, H31 = (t16) => encodeURIComponent(t16).replace(/[!'()*]/g, (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`), cee = /* @__PURE__ */ Symbol("encodeFragmentIdentifier");
function X31(t16) {
  switch (t16.arrayFormat) {
    case "index":
      return (e) => (r12, n12) => {
        const a = r12.length;
        return n12 === void 0 || t16.skipNull && n12 === null || t16.skipEmptyString && n12 === "" ? r12 : n12 === null ? [
          ...r12,
          [x1(e, t16), "[", a, "]"].join("")
        ] : [
          ...r12,
          [x1(e, t16), "[", x1(a, t16), "]=", x1(n12, t16)].join("")
        ];
      };
    case "bracket":
      return (e) => (r12, n12) => n12 === void 0 || t16.skipNull && n12 === null || t16.skipEmptyString && n12 === "" ? r12 : n12 === null ? [
        ...r12,
        [x1(e, t16), "[]"].join("")
      ] : [
        ...r12,
        [x1(e, t16), "[]=", x1(n12, t16)].join("")
      ];
    case "colon-list-separator":
      return (e) => (r12, n12) => n12 === void 0 || t16.skipNull && n12 === null || t16.skipEmptyString && n12 === "" ? r12 : n12 === null ? [
        ...r12,
        [x1(e, t16), ":list="].join("")
      ] : [
        ...r12,
        [x1(e, t16), ":list=", x1(n12, t16)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const e = t16.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (r12) => (n12, a) => a === void 0 || t16.skipNull && a === null || t16.skipEmptyString && a === "" ? n12 : (a = a === null ? "" : a, n12.length === 0 ? [[x1(r12, t16), e, x1(a, t16)].join("")] : [[n12, x1(a, t16)].join(t16.arrayFormatSeparator)]);
    }
    default:
      return (e) => (r12, n12) => n12 === void 0 || t16.skipNull && n12 === null || t16.skipEmptyString && n12 === "" ? r12 : n12 === null ? [
        ...r12,
        x1(e, t16)
      ] : [
        ...r12,
        [x1(e, t16), "=", x1(n12, t16)].join("")
      ];
  }
}
function $31(t16) {
  let e;
  switch (t16.arrayFormat) {
    case "index":
      return (r12, n12, a) => {
        if (e = /\[(\d*)]$/.exec(r12), r12 = r12.replace(/\[\d*]$/, ""), !e) {
          a[r12] = n12;
          return;
        }
        a[r12] === void 0 && (a[r12] = {}), a[r12][e[1]] = n12;
      };
    case "bracket":
      return (r12, n12, a) => {
        if (e = /(\[])$/.exec(r12), r12 = r12.replace(/\[]$/, ""), !e) {
          a[r12] = n12;
          return;
        }
        if (a[r12] === void 0) {
          a[r12] = [n12];
          return;
        }
        a[r12] = [...a[r12], n12];
      };
    case "colon-list-separator":
      return (r12, n12, a) => {
        if (e = /(:list)$/.exec(r12), r12 = r12.replace(/:list$/, ""), !e) {
          a[r12] = n12;
          return;
        }
        if (a[r12] === void 0) {
          a[r12] = [n12];
          return;
        }
        a[r12] = [...a[r12], n12];
      };
    case "comma":
    case "separator":
      return (r12, n12, a) => {
        const o = typeof n12 == "string" && n12.includes(t16.arrayFormatSeparator), i = typeof n12 == "string" && !o && Vn(n12, t16).includes(t16.arrayFormatSeparator);
        n12 = i ? Vn(n12, t16) : n12;
        const u = o || i ? n12.split(t16.arrayFormatSeparator).map((s12) => Vn(s12, t16)) : n12 === null ? n12 : Vn(n12, t16);
        a[r12] = u;
      };
    case "bracket-separator":
      return (r12, n12, a) => {
        const o = /(\[])$/.test(r12);
        if (r12 = r12.replace(/\[]$/, ""), !o) {
          a[r12] = n12 && Vn(n12, t16);
          return;
        }
        const i = n12 === null ? [] : n12.split(t16.arrayFormatSeparator).map((u) => Vn(u, t16));
        if (a[r12] === void 0) {
          a[r12] = i;
          return;
        }
        a[r12] = [...a[r12], ...i];
      };
    default:
      return (r12, n12, a) => {
        if (a[r12] === void 0) {
          a[r12] = n12;
          return;
        }
        a[r12] = [...[a[r12]].flat(), n12];
      };
  }
}
function fKe(t16) {
  if (typeof t16 != "string" || t16.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function x1(t16, e) {
  return e.encode ? e.strict ? H31(t16) : encodeURIComponent(t16) : t16;
}
function Vn(t16, e) {
  return e.decode ? j31(t16) : t16;
}
function bKe(t16) {
  return Array.isArray(t16) ? t16.sort() : typeof t16 == "object" ? bKe(Object.keys(t16)).sort((e, r12) => Number(e) - Number(r12)).map((e) => t16[e]) : t16;
}
function MKe(t16) {
  const e = t16.indexOf("#");
  return e !== -1 && (t16 = t16.slice(0, e)), t16;
}
function G31(t16) {
  let e = "";
  const r12 = t16.indexOf("#");
  return r12 !== -1 && (e = t16.slice(r12)), e;
}
function DFe(t16, e) {
  return e.parseNumbers && !Number.isNaN(Number(t16)) && typeof t16 == "string" && t16.trim() !== "" ? t16 = Number(t16) : e.parseBooleans && t16 !== null && (t16.toLowerCase() === "true" || t16.toLowerCase() === "false") && (t16 = t16.toLowerCase() === "true"), t16;
}
function y1e(t16) {
  t16 = MKe(t16);
  const e = t16.indexOf("?");
  return e === -1 ? "" : t16.slice(e + 1);
}
function S1e(t16, e) {
  e = {
    decode: true,
    sort: true,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: false,
    parseBooleans: false,
    ...e
  }, fKe(e.arrayFormatSeparator);
  const r12 = $31(e), n12 = /* @__PURE__ */ Object.create(null);
  if (typeof t16 != "string" || (t16 = t16.trim().replace(/^[?#&]/, ""), !t16))
    return n12;
  for (const a of t16.split("&")) {
    if (a === "")
      continue;
    const o = e.decode ? a.replace(/\+/g, " ") : a;
    let [i, u] = dKe(o, "=");
    i === void 0 && (i = o), u = u === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(e.arrayFormat) ? u : Vn(u, e), r12(Vn(i, e), u, n12);
  }
  for (const [a, o] of Object.entries(n12))
    if (typeof o == "object" && o !== null)
      for (const [i, u] of Object.entries(o))
        o[i] = DFe(u, e);
    else
      n12[a] = DFe(o, e);
  return e.sort === false ? n12 : (e.sort === true ? Object.keys(n12).sort() : Object.keys(n12).sort(e.sort)).reduce((a, o) => {
    const i = n12[o];
    return i && typeof i == "object" && !Array.isArray(i) ? a[o] = bKe(i) : a[o] = i, a;
  }, /* @__PURE__ */ Object.create(null));
}
function OKe(t16, e) {
  if (!t16)
    return "";
  e = {
    encode: true,
    strict: true,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...e
  }, fKe(e.arrayFormatSeparator);
  const r12 = (i) => e.skipNull && V31(t16[i]) || e.skipEmptyString && t16[i] === "", n12 = X31(e), a = {};
  for (const [i, u] of Object.entries(t16))
    r12(i) || (a[i] = u);
  const o = Object.keys(a);
  return e.sort !== false && o.sort(e.sort), o.map((i) => {
    const u = t16[i];
    return u === void 0 ? "" : u === null ? x1(i, e) : Array.isArray(u) ? u.length === 0 && e.arrayFormat === "bracket-separator" ? x1(i, e) + "[]" : u.reduce(n12(i), []).join("&") : x1(i, e) + "=" + x1(u, e);
  }).filter((i) => i.length > 0).join("&");
}
function zKe(t16, e) {
  var a;
  e = {
    decode: true,
    ...e
  };
  let [r12, n12] = dKe(t16, "#");
  return r12 === void 0 && (r12 = t16), {
    url: ((a = r12 == null ? void 0 : r12.split("?")) == null ? void 0 : a[0]) ?? "",
    query: S1e(y1e(t16), e),
    ...e && e.parseFragmentIdentifier && n12 ? { fragmentIdentifier: Vn(n12, e) } : {}
  };
}
function AKe(t16, e) {
  e = {
    encode: true,
    strict: true,
    [cee]: true,
    ...e
  };
  const r12 = MKe(t16.url).split("?")[0] || "", n12 = y1e(t16.url), a = {
    ...S1e(n12, { sort: false }),
    ...t16.query
  };
  let o = OKe(a, e);
  o && (o = `?${o}`);
  let i = G31(t16.url);
  if (t16.fragmentIdentifier) {
    const u = new URL(r12);
    u.hash = t16.fragmentIdentifier, i = e[cee] ? u.hash : `#${t16.fragmentIdentifier}`;
  }
  return `${r12}${o}${i}`;
}
function _Ke(t16, e, r12) {
  r12 = {
    parseFragmentIdentifier: true,
    [cee]: false,
    ...r12
  };
  const { url: n12, query: a, fragmentIdentifier: o } = zKe(t16, r12);
  return AKe({
    url: n12,
    query: F31(a, e),
    fragmentIdentifier: o
  }, r12);
}
function Y31(t16, e, r12) {
  const n12 = Array.isArray(e) ? (a) => !e.includes(a) : (a, o) => !e(a, o);
  return _Ke(t16, n12, r12);
}
const CQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude: Y31,
  extract: y1e,
  parse: S1e,
  parseUrl: zKe,
  pick: _Ke,
  stringify: OKe,
  stringifyUrl: AKe
}, Symbol.toStringTag, { value: "Module" }));
var lee = { exports: {} };
(function(t16, e) {
  (function(r12, n12) {
    var a = "0.7.33", o = "", i = "?", u = "function", s12 = "undefined", c = "object", l2 = "string", f = "major", p = "model", d = "name", b = "type", z = "vendor", _ = "version", q = "architecture", S = "console", N = "mobile", v = "tablet", C = "smarttv", L = "wearable", B = "embedded", P12 = 350, j = "Amazon", $ = "Apple", W = "ASUS", x = "BlackBerry", D = "Browser", w = "Chrome", I = "Edge", Y = "Firefox", oe = "Google", Z = "Huawei", se = "LG", Ie = "Microsoft", ie = "Motorola", ye = "Opera", ne = "Samsung", k = "Sharp", K = "Sony", G = "Xiaomi", Q = "Zebra", ce = "Facebook", ve = function(Be, o0) {
      var Ke = {};
      for (var I0 in Be)
        o0[I0] && o0[I0].length % 2 === 0 ? Ke[I0] = o0[I0].concat(Be[I0]) : Ke[I0] = Be[I0];
      return Ke;
    }, Re = function(Be) {
      for (var o0 = {}, Ke = 0; Ke < Be.length; Ke++)
        o0[Be[Ke].toUpperCase()] = Be[Ke];
      return o0;
    }, le = function(Be, o0) {
      return typeof Be === l2 ? Ae(o0).indexOf(Ae(Be)) !== -1 : false;
    }, Ae = function(Be) {
      return Be.toLowerCase();
    }, H = function(Be) {
      return typeof Be === l2 ? Be.replace(/[^\d\.]/g, o).split(".")[0] : n12;
    }, re = function(Be, o0) {
      if (typeof Be === l2)
        return Be = Be.replace(/^\s\s*/, o), typeof o0 === s12 ? Be : Be.substring(0, P12);
    }, ue = function(Be, o0) {
      for (var Ke = 0, I0, b0, P1, x0, Mt, H1; Ke < o0.length && !Mt; ) {
        var Wt = o0[Ke], Zt = o0[Ke + 1];
        for (I0 = b0 = 0; I0 < Wt.length && !Mt; )
          if (Mt = Wt[I0++].exec(Be), Mt)
            for (P1 = 0; P1 < Zt.length; P1++)
              H1 = Mt[++b0], x0 = Zt[P1], typeof x0 === c && x0.length > 0 ? x0.length === 2 ? typeof x0[1] == u ? this[x0[0]] = x0[1].call(this, H1) : this[x0[0]] = x0[1] : x0.length === 3 ? typeof x0[1] === u && !(x0[1].exec && x0[1].test) ? this[x0[0]] = H1 ? x0[1].call(this, H1, x0[2]) : n12 : this[x0[0]] = H1 ? H1.replace(x0[1], x0[2]) : n12 : x0.length === 4 && (this[x0[0]] = H1 ? x0[3].call(this, H1.replace(x0[1], x0[2])) : n12) : this[x0] = H1 || n12;
        Ke += 2;
      }
    }, Me = function(Be, o0) {
      for (var Ke in o0)
        if (typeof o0[Ke] === c && o0[Ke].length > 0) {
          for (var I0 = 0; I0 < o0[Ke].length; I0++)
            if (le(o0[Ke][I0], Be))
              return Ke === i ? n12 : Ke;
        } else if (le(o0[Ke], Be))
          return Ke === i ? n12 : Ke;
      return Be;
    }, Se = {
      "1.0": "/8",
      1.2: "/1",
      1.3: "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, $e = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      8.1: "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, a0 = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [_, [d, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [_, [d, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [d, _],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [_, [d, ye + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [_, [d, ye]],
        [
          // Mixed
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
          // Baidu Browser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [d, _],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [_, [d, "UC" + D]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i
        ],
        [_, [d, "WeChat(Win) Desktop"]],
        [
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [_, [d, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [_, [d, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [_, [d, "IE"]],
        [
          /yabrowser\/([\w\.]+)/i
          // Yandex
        ],
        [_, [d, "Yandex"]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[d, /(.+)/, "$1 Secure " + D], _],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [_, [d, Y + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [_, [d, ye + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [_, [d, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [_, [d, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [_, [d, ye + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [_, [d, "MIUI " + D]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [_, [d, Y]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[d, "360 " + D]],
        [/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i],
        [[d, /(.+)/, "$1 " + D], _],
        [
          // Oculus/Samsung/Sailfish/Huawei Browser
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[d, /_/g, " "], _],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/Baidu App/2345 Browser
        ],
        [d, _],
        [
          /(metasr)[\/ ]?([\w\.]+)/i,
          // SouGouBrowser
          /(lbbrowser)/i,
          // LieBao Browser
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [d],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[d, ce], _],
        [
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(chromium|instagram)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram
        ],
        [d, _],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [_, [d, "GSA"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [_, [d, w + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[d, w + " WebView"], _],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [_, [d, "Android " + D]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [d, _],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [_, [d, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [_, d],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [d, [_, Me, Se]],
        [/(webkit|khtml)\/([\w\.]+)/i],
        [d, _],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[d, "Netscape"], _],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [_, [d, Y + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i
          // Links
        ],
        [d, _],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [d, [_, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[q, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[q, Ae]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[q, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[q, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[q, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[q, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[q, /ower/, o, Ae]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[q, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[q, Ae]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          // Ordered by popularity
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [p, [z, ne], [b, v]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [p, [z, ne], [b, N]],
        [
          // Apple
          /((ipod|iphone)\d+,\d+)/i
          // iPod/iPhone model
        ],
        [p, [z, $], [b, N]],
        [
          /(ipad\d+,\d+)/i
          // iPad model
        ],
        [p, [z, $], [b, v]],
        [
          /\((ip(?:hone|od)[\w ]*);/i
          // iPod/iPhone
        ],
        [p, [z, $], [b, N]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [p, [z, $], [b, v]],
        [/(macintosh);/i],
        [p, [z, $]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [p, [z, Z], [b, v]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [p, [z, Z], [b, N]],
        [
          // Xiaomi
          /\b(poco[\w ]+)(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [
          [p, /_/g, " "],
          [z, G],
          [b, N]
        ],
        [
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [
          [p, /_/g, " "],
          [z, G],
          [b, v]
        ],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [p, [z, "OPPO"], [b, N]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [p, [z, "Vivo"], [b, N]],
        [
          // Realme
          /\b(rmx[12]\d{3})(?: bui|;|\))/i
        ],
        [p, [z, "Realme"], [b, N]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [p, [z, ie], [b, N]],
        [/\b(mz60\d|xoom[2 ]{0,2}) build\//i],
        [p, [z, ie], [b, v]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [p, [z, se], [b, v]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [p, [z, se], [b, N]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [p, [z, "Lenovo"], [b, v]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [
          [p, /_/g, " "],
          [z, "Nokia"],
          [b, N]
        ],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [p, [z, oe], [b, v]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [p, [z, oe], [b, N]],
        [
          // Sony
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [p, [z, K], [b, N]],
        [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i],
        [
          [p, "Xperia Tablet"],
          [z, K],
          [b, v]
        ],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [p, [z, "OnePlus"], [b, N]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi)( bui|\))/i,
          // Kindle Fire without Silk
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [p, [z, j], [b, v]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [
          [p, /(.+)/g, "Fire Phone $1"],
          [z, j],
          [b, N]
        ],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [p, z, [b, v]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [p, [z, x], [b, N]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [p, [z, W], [b, v]],
        [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],
        [p, [z, W], [b, N]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [p, [z, "HTC"], [b, v]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [z, [p, /_/g, " "], [b, N]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [p, [z, "Acer"], [b, v]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [p, [z, "Meizu"], [b, N]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [p, [z, k], [b, N]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [z, p, [b, N]],
        [
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [z, p, [b, v]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [p, [z, Ie], [b, v]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [p, [z, "Fairphone"], [b, N]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [p, [z, "AT&T"], [b, N]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [p, [z, "Siemens"], [b, N]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [p, [z, "RCA"], [b, v]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [p, [z, "Dell"], [b, v]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [p, [z, "Verizon"], [b, v]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [p, [z, "Barnes & Noble"], [b, v]],
        [/\b(tm\d{3}\w+) b/i],
        [p, [z, "NuVision"], [b, v]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [p, [z, "ZTE"], [b, v]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [p, [z, "ZTE"], [b, N]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [p, [z, "Swiss"], [b, N]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [p, [z, "Swiss"], [b, v]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [p, [z, "Zeki"], [b, v]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[z, "Dragon Touch"], p, [b, v]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [p, [z, "Insignia"], [b, v]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [p, [z, "NextBook"], [b, v]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[z, "Voice"], p, [b, N]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[z, "LvTel"], p, [b, N]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [p, [z, "Essential"], [b, N]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [p, [z, "Envizen"], [b, v]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [p, [z, "MachSpeed"], [b, v]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [p, [z, "Rotor"], [b, v]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [p, [z, "Nvidia"], [b, v]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [z, p, [b, N]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [
          [p, /\./g, " "],
          [z, Ie],
          [b, N]
        ],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [p, [z, Q], [b, v]],
        [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],
        [p, [z, Q], [b, N]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [z, p, [b, S]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [p, [z, "Nvidia"], [b, S]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [p, [z, K], [b, S]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [p, [z, Ie], [b, S]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [z, [b, C]],
        [/hbbtv.+maple;(\d+)/i],
        [
          [p, /^/, "SmartTV"],
          [z, ne],
          [b, C]
        ],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [
          [z, se],
          [b, C]
        ],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [z, [p, $ + " TV"], [b, C]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [
          [p, w + "cast"],
          [z, oe],
          [b, C]
        ],
        [
          /droid.+aft(\w)( bui|\))/i
          // Fire TV
        ],
        [p, [z, j], [b, C]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [p, [z, k], [b, C]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [p, [z, K], [b, C]],
        [
          /(mitv-\w{5}) bui/i
          // Xiaomi
        ],
        [p, [z, G], [b, C]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [
          [z, re],
          [p, re],
          [b, C]
        ],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[b, C]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [z, p, [b, L]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [p, [z, oe], [b, L]],
        [/droid.+; (wt63?0{2,3})\)/i],
        [p, [z, Q], [b, L]],
        [
          /(quest( 2)?)/i
          // Oculus Quest
        ],
        [p, [z, ce], [b, L]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [z, [b, B]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [p, [b, N]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [p, [b, v]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[b, v]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[b, N]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [p, [z, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [_, [d, I + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [_, [d, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i
          // iCab
        ],
        [d, _],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [_, d]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [d, _],
        [
          /(windows) nt 6\.2; (arm)/i,
          // Windows RT
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
          // Windows Phone
          /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
        ],
        [d, [_, Me, $e]],
        [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],
        [
          [d, "Windows"],
          [_, Me, $e]
        ],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /cfnetwork\/.+darwin/i
        ],
        [
          [_, /_/g, "."],
          [d, "iOS"]
        ],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [
          [d, "Mac OS"],
          [_, /_/g, "."]
        ],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [_, d],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [d, _],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [_, [d, x]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [_, [d, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [_, [d, Y + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [_, [d, "webOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [_, [d, w + "cast"]],
        [
          /(cros) [\w]+ ([\w\.]+\w)/i
          // Chromium OS
        ],
        [[d, "Chromium OS"], _],
        [
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [d, _],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[d, "Solaris"], _],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [d, _]
      ]
    }, Ne = function(Be, o0) {
      if (typeof Be === c && (o0 = Be, Be = n12), !(this instanceof Ne))
        return new Ne(Be, o0).getResult();
      var Ke = Be || (typeof r12 !== s12 && r12.navigator && r12.navigator.userAgent ? r12.navigator.userAgent : o), I0 = o0 ? ve(a0, o0) : a0;
      return this.getBrowser = function() {
        var b0 = {};
        return b0[d] = n12, b0[_] = n12, ue.call(b0, Ke, I0.browser), b0.major = H(b0.version), b0;
      }, this.getCPU = function() {
        var b0 = {};
        return b0[q] = n12, ue.call(b0, Ke, I0.cpu), b0;
      }, this.getDevice = function() {
        var b0 = {};
        return b0[z] = n12, b0[p] = n12, b0[b] = n12, ue.call(b0, Ke, I0.device), b0;
      }, this.getEngine = function() {
        var b0 = {};
        return b0[d] = n12, b0[_] = n12, ue.call(b0, Ke, I0.engine), b0;
      }, this.getOS = function() {
        var b0 = {};
        return b0[d] = n12, b0[_] = n12, ue.call(b0, Ke, I0.os), b0;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return Ke;
      }, this.setUA = function(b0) {
        return Ke = typeof b0 === l2 && b0.length > P12 ? re(b0, P12) : b0, this;
      }, this.setUA(Ke), this;
    };
    Ne.VERSION = a, Ne.BROWSER = Re([d, _, f]), Ne.CPU = Re([q]), Ne.DEVICE = Re([
      p,
      z,
      b,
      S,
      N,
      C,
      v,
      L,
      B
    ]), Ne.ENGINE = Ne.OS = Re([d, _]), t16.exports && (e = t16.exports = Ne), e.UAParser = Ne;
    var Ye = typeof r12 !== s12 && (r12.jQuery || r12.Zepto);
    if (Ye && !Ye.ua) {
      var $0 = new Ne();
      Ye.ua = $0.getResult(), Ye.ua.get = function() {
        return $0.getUA();
      }, Ye.ua.set = function(Be) {
        $0.setUA(Be);
        var o0 = $0.getResult();
        for (var Ke in o0)
          Ye.ua[Ke] = o0[Ke];
      };
    }
  })(typeof window == "object" ? window : l0);
})(lee, lee.exports);
var J31 = lee.exports;
const K31 = /* @__PURE__ */ Ni(J31);
var Q31 = (
  /** @class */
  (function() {
    function t16() {
    }
    return t16.prototype.getApplicationContext = function() {
      return {
        versionName: this.versionName,
        language: Z31(),
        platform: "Web",
        os: void 0,
        deviceModel: void 0
      };
    }, t16;
  })()
), Z31 = function() {
  return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
}, ez1 = (
  /** @class */
  (function() {
    function t16() {
      this.queue = [];
    }
    return t16.prototype.logEvent = function(e) {
      this.receiver ? this.receiver(e) : this.queue.length < 512 && this.queue.push(e);
    }, t16.prototype.setEventReceiver = function(e) {
      this.receiver = e, this.queue.length > 0 && (this.queue.forEach(function(r12) {
        e(r12);
      }), this.queue = []);
    }, t16;
  })()
), Ta = function() {
  return Ta = Object.assign || function(e) {
    for (var r12, n12 = 1, a = arguments.length; n12 < a; n12++) {
      r12 = arguments[n12];
      for (var o in r12)
        Object.prototype.hasOwnProperty.call(r12, o) && (e[o] = r12[o]);
    }
    return e;
  }, Ta.apply(this, arguments);
}, p2 = function(t16, e) {
  var r12 = ["string", "number", "boolean", "undefined"], n12 = typeof t16, a = typeof e;
  if (n12 !== a)
    return false;
  for (var o = 0, i = r12; o < i.length; o++) {
    var u = i[o];
    if (u === n12)
      return t16 === e;
  }
  if (t16 == null && e == null)
    return true;
  if (t16 == null || e == null || t16.length !== e.length)
    return false;
  var s12 = Array.isArray(t16), c = Array.isArray(e);
  if (s12 !== c)
    return false;
  if (s12 && c) {
    for (var l2 = 0; l2 < t16.length; l2++)
      if (!p2(t16[l2], e[l2]))
        return false;
  } else {
    var f = Object.keys(t16).sort(), p = Object.keys(e).sort();
    if (!p2(f, p))
      return false;
    var d = true;
    return Object.keys(t16).forEach(function(b) {
      p2(t16[b], e[b]) || (d = false);
    }), d;
  }
  return true;
}, tz1 = "$set", rz1 = "$unset", nz1 = "$clearAll";
Object.entries || (Object.entries = function(t16) {
  for (var e = Object.keys(t16), r12 = e.length, n12 = new Array(r12); r12--; )
    n12[r12] = [e[r12], t16[e[r12]]];
  return n12;
});
var az1 = (
  /** @class */
  (function() {
    function t16() {
      this.identity = { userProperties: {} }, this.listeners = /* @__PURE__ */ new Set();
    }
    return t16.prototype.editIdentity = function() {
      var e = this, r12 = Ta({}, this.identity.userProperties), n12 = Ta(Ta({}, this.identity), { userProperties: r12 });
      return {
        setUserId: function(a) {
          return n12.userId = a, this;
        },
        setDeviceId: function(a) {
          return n12.deviceId = a, this;
        },
        setUserProperties: function(a) {
          return n12.userProperties = a, this;
        },
        setOptOut: function(a) {
          return n12.optOut = a, this;
        },
        updateUserProperties: function(a) {
          for (var o = n12.userProperties || {}, i = 0, u = Object.entries(a); i < u.length; i++) {
            var s12 = u[i], c = s12[0], l2 = s12[1];
            switch (c) {
              case tz1:
                for (var f = 0, p = Object.entries(l2); f < p.length; f++) {
                  var d = p[f], b = d[0], z = d[1];
                  o[b] = z;
                }
                break;
              case rz1:
                for (var _ = 0, q = Object.keys(l2); _ < q.length; _++) {
                  var b = q[_];
                  delete o[b];
                }
                break;
              case nz1:
                o = {};
                break;
            }
          }
          return n12.userProperties = o, this;
        },
        commit: function() {
          return e.setIdentity(n12), this;
        }
      };
    }, t16.prototype.getIdentity = function() {
      return Ta({}, this.identity);
    }, t16.prototype.setIdentity = function(e) {
      var r12 = Ta({}, this.identity);
      this.identity = Ta({}, e), p2(r12, this.identity) || this.listeners.forEach(function(n12) {
        n12(e);
      });
    }, t16.prototype.addIdentityListener = function(e) {
      this.listeners.add(e);
    }, t16.prototype.removeIdentityListener = function(e) {
      this.listeners.delete(e);
    }, t16;
  })()
), $u = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : self, oz1 = (
  /** @class */
  (function() {
    function t16() {
      this.identityStore = new az1(), this.eventBridge = new ez1(), this.applicationContextProvider = new Q31();
    }
    return t16.getInstance = function(e) {
      return $u.analyticsConnectorInstances || ($u.analyticsConnectorInstances = {}), $u.analyticsConnectorInstances[e] || ($u.analyticsConnectorInstances[e] = new t16()), $u.analyticsConnectorInstances[e];
    }, t16;
  })()
);
function WFe(t16, e) {
  var r12 = Object.keys(t16);
  if (Object.getOwnPropertySymbols) {
    var n12 = Object.getOwnPropertySymbols(t16);
    e && (n12 = n12.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t16, a).enumerable;
    })), r12.push.apply(r12, n12);
  }
  return r12;
}
function pt(t16) {
  for (var e = 1; e < arguments.length; e++) {
    var r12 = arguments[e] != null ? arguments[e] : {};
    e % 2 ? WFe(Object(r12), true).forEach(function(n12) {
      ii(t16, n12, r12[n12]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t16, Object.getOwnPropertyDescriptors(r12)) : WFe(Object(r12)).forEach(function(n12) {
      Object.defineProperty(t16, n12, Object.getOwnPropertyDescriptor(r12, n12));
    });
  }
  return t16;
}
function pee(t16) {
  "@babel/helpers - typeof";
  return pee = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, pee(t16);
}
function C1e(t16, e) {
  if (!(t16 instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function NFe(t16, e) {
  for (var r12 = 0; r12 < e.length; r12++) {
    var n12 = e[r12];
    n12.enumerable = n12.enumerable || false, n12.configurable = true, "value" in n12 && (n12.writable = true), Object.defineProperty(t16, vKe(n12.key), n12);
  }
}
function g1e(t16, e, r12) {
  return e && NFe(t16.prototype, e), Object.defineProperty(t16, "prototype", {
    writable: false
  }), t16;
}
function ii(t16, e, r12) {
  return e = vKe(e), e in t16 ? Object.defineProperty(t16, e, {
    value: r12,
    enumerable: true,
    configurable: true,
    writable: true
  }) : t16[e] = r12, t16;
}
function iz1(t16) {
  return uz1(t16) || sz1(t16) || hKe(t16) || cz1();
}
function uz1(t16) {
  if (Array.isArray(t16))
    return dee(t16);
}
function sz1(t16) {
  if (typeof Symbol < "u" && t16[Symbol.iterator] != null || t16["@@iterator"] != null)
    return Array.from(t16);
}
function hKe(t16, e) {
  if (t16) {
    if (typeof t16 == "string")
      return dee(t16, e);
    var r12 = Object.prototype.toString.call(t16).slice(8, -1);
    if (r12 === "Object" && t16.constructor && (r12 = t16.constructor.name), r12 === "Map" || r12 === "Set")
      return Array.from(t16);
    if (r12 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r12))
      return dee(t16, e);
  }
}
function dee(t16, e) {
  (e == null || e > t16.length) && (e = t16.length);
  for (var r12 = 0, n12 = new Array(e); r12 < e; r12++)
    n12[r12] = t16[r12];
  return n12;
}
function cz1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lz1(t16, e) {
  var r12 = typeof Symbol < "u" && t16[Symbol.iterator] || t16["@@iterator"];
  if (!r12) {
    if (Array.isArray(t16) || (r12 = hKe(t16)) || e) {
      r12 && (t16 = r12);
      var n12 = 0, a = function() {
      };
      return {
        s: a,
        n: function() {
          return n12 >= t16.length ? {
            done: true
          } : {
            done: false,
            value: t16[n12++]
          };
        },
        e: function(s12) {
          throw s12;
        },
        f: a
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o = true, i = false, u;
  return {
    s: function() {
      r12 = r12.call(t16);
    },
    n: function() {
      var s12 = r12.next();
      return o = s12.done, s12;
    },
    e: function(s12) {
      i = true, u = s12;
    },
    f: function() {
      try {
        !o && r12.return != null && r12.return();
      } finally {
        if (i)
          throw u;
      }
    }
  };
}
function pz1(t16, e) {
  if (typeof t16 != "object" || t16 === null)
    return t16;
  var r12 = t16[Symbol.toPrimitive];
  if (r12 !== void 0) {
    var n12 = r12.call(t16, e);
    if (typeof n12 != "object")
      return n12;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t16);
}
function vKe(t16) {
  var e = pz1(t16, "string");
  return typeof e == "symbol" ? e : String(e);
}
var Pe = {
  DEFAULT_INSTANCE: "$default_instance",
  API_VERSION: 2,
  MAX_STRING_LENGTH: 4096,
  MAX_PROPERTY_KEYS: 1e3,
  IDENTIFY_EVENT: "$identify",
  GROUP_IDENTIFY_EVENT: "$groupidentify",
  EVENT_LOG_URL: "api.amplitude.com",
  EVENT_LOG_EU_URL: "api.eu.amplitude.com",
  DYNAMIC_CONFIG_URL: "regionconfig.amplitude.com",
  DYNAMIC_CONFIG_EU_URL: "regionconfig.eu.amplitude.com",
  // localStorageKeys
  LAST_EVENT_ID: "amplitude_lastEventId",
  LAST_EVENT_TIME: "amplitude_lastEventTime",
  LAST_IDENTIFY_ID: "amplitude_lastIdentifyId",
  LAST_SEQUENCE_NUMBER: "amplitude_lastSequenceNumber",
  SESSION_ID: "amplitude_sessionId",
  // Used in cookie as well
  DEVICE_ID: "amplitude_deviceId",
  OPT_OUT: "amplitude_optOut",
  USER_ID: "amplitude_userId",
  // indexes of properties in cookie v2 storage format
  DEVICE_ID_INDEX: 0,
  USER_ID_INDEX: 1,
  OPT_OUT_INDEX: 2,
  SESSION_ID_INDEX: 3,
  LAST_EVENT_TIME_INDEX: 4,
  EVENT_ID_INDEX: 5,
  IDENTIFY_ID_INDEX: 6,
  SEQUENCE_NUMBER_INDEX: 7,
  COOKIE_TEST_PREFIX: "amp_cookie_test",
  COOKIE_PREFIX: "amp",
  // Storage options
  STORAGE_DEFAULT: "",
  STORAGE_COOKIES: "cookies",
  STORAGE_NONE: "none",
  STORAGE_LOCAL: "localStorage",
  STORAGE_SESSION: "sessionStorage",
  // revenue keys
  REVENUE_EVENT: "revenue_amount",
  REVENUE_PRODUCT_ID: "$productId",
  REVENUE_QUANTITY: "$quantity",
  REVENUE_PRICE: "$price",
  REVENUE_REVENUE_TYPE: "$revenueType",
  AMP_DEVICE_ID_PARAM: "amp_device_id",
  // url param
  AMP_REFERRER_PARAM: "amp_referrer",
  // url param for overwriting the document.refer
  REFERRER: "referrer",
  REFERRING_DOMAIN: "referring_domain",
  // UTM Params
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign",
  UTM_TERM: "utm_term",
  UTM_CONTENT: "utm_content",
  ATTRIBUTION_EVENT: "[Amplitude] Attribution Captured",
  TRANSPORT_HTTP: "http",
  TRANSPORT_BEACON: "beacon"
}, wFe = {
  encode: function(e) {
    for (var r12 = "", n12 = 0; n12 < e.length; n12++) {
      var a = e.charCodeAt(n12);
      a < 128 ? r12 += String.fromCharCode(a) : a > 127 && a < 2048 ? (r12 += String.fromCharCode(a >> 6 | 192), r12 += String.fromCharCode(a & 63 | 128)) : (r12 += String.fromCharCode(a >> 12 | 224), r12 += String.fromCharCode(a >> 6 & 63 | 128), r12 += String.fromCharCode(a & 63 | 128));
    }
    return r12;
  },
  decode: function(e) {
    for (var r12 = "", n12 = 0, a = 0, o = 0, i = 0; n12 < e.length; )
      a = e.charCodeAt(n12), a < 128 ? (r12 += String.fromCharCode(a), n12++) : a > 191 && a < 224 ? (o = e.charCodeAt(n12 + 1), r12 += String.fromCharCode((a & 31) << 6 | o & 63), n12 += 2) : (o = e.charCodeAt(n12 + 1), i = e.charCodeAt(n12 + 2), r12 += String.fromCharCode((a & 15) << 12 | (o & 63) << 6 | i & 63), n12 += 3);
    return r12;
  }
}, P0 = (function() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
  if (typeof global < "u")
    return global;
})(), jt = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function(e) {
    try {
      if (P0.btoa && P0.atob)
        return P0.btoa(unescape(encodeURIComponent(e)));
    } catch {
    }
    return jt._encode(e);
  },
  _encode: function(e) {
    var r12 = "", n12, a, o, i, u, s12, c, l2 = 0;
    for (e = wFe.encode(e); l2 < e.length; )
      n12 = e.charCodeAt(l2++), a = e.charCodeAt(l2++), o = e.charCodeAt(l2++), i = n12 >> 2, u = (n12 & 3) << 4 | a >> 4, s12 = (a & 15) << 2 | o >> 6, c = o & 63, isNaN(a) ? s12 = c = 64 : isNaN(o) && (c = 64), r12 = r12 + jt._keyStr.charAt(i) + jt._keyStr.charAt(u) + jt._keyStr.charAt(s12) + jt._keyStr.charAt(c);
    return r12;
  },
  decode: function(e) {
    try {
      if (P0.btoa && P0.atob)
        return decodeURIComponent(escape(P0.atob(e)));
    } catch {
    }
    return jt._decode(e);
  },
  _decode: function(e) {
    var r12 = "", n12, a, o, i, u, s12, c, l2 = 0;
    for (e = e.replace(/[^A-Za-z0-9+/=]/g, ""); l2 < e.length; )
      i = jt._keyStr.indexOf(e.charAt(l2++)), u = jt._keyStr.indexOf(e.charAt(l2++)), s12 = jt._keyStr.indexOf(e.charAt(l2++)), c = jt._keyStr.indexOf(e.charAt(l2++)), n12 = i << 2 | u >> 4, a = (u & 15) << 4 | s12 >> 2, o = (s12 & 3) << 6 | c, r12 = r12 + String.fromCharCode(n12), s12 !== 64 && (r12 = r12 + String.fromCharCode(a)), c !== 64 && (r12 = r12 + String.fromCharCode(o));
    return r12 = wFe.decode(r12), r12;
  }
}, dz1 = Object.prototype.toString;
function s0(t16) {
  switch (dz1.call(t16)) {
    case "[object Date]":
      return "date";
    case "[object RegExp]":
      return "regexp";
    case "[object Arguments]":
      return "arguments";
    case "[object Array]":
      return "array";
    case "[object Error]":
      return "error";
  }
  return t16 === null ? "null" : t16 === void 0 ? "undefined" : t16 !== t16 ? "nan" : t16 && t16.nodeType === 1 ? "element" : typeof Buffer < "u" && typeof Buffer.isBuffer == "function" && Buffer.isBuffer(t16) ? "buffer" : (t16 = t16.valueOf ? t16.valueOf() : Object.prototype.valueOf.apply(t16), pee(t16));
}
var mo = {
  DISABLE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3
}, Ts = mo.WARN, fz1 = function(e) {
  Object.prototype.hasOwnProperty.call(mo, e) && (Ts = mo[e]);
}, bz1 = function() {
  return Ts;
}, ot = {
  error: function(e) {
    Ts >= mo.ERROR && gQ(e);
  },
  warn: function(e) {
    Ts >= mo.WARN && gQ(e);
  },
  info: function(e) {
    Ts >= mo.INFO && gQ(e);
  }
}, gQ = function(e) {
  try {
    console.log("[Amplitude] " + e);
  } catch {
  }
}, Mz1 = function(e) {
  return !e || e.length === 0;
}, Oz1 = function() {
  try {
    if (P0.sessionStorage)
      return true;
  } catch {
  }
  return false;
}, zz1 = function t12(e) {
  if (s0(e) === "array")
    for (var r12 = 0; r12 < e.length; r12++)
      e[r12] = t12(e[r12]);
  else if (s0(e) === "object")
    for (var n12 in e)
      n12 in e && (e[n12] = t12(e[n12]));
  else
    e = Az1(e);
  return e;
}, Az1 = function(e) {
  return s0(e) === "string" && e.length > Pe.MAX_STRING_LENGTH ? e.substring(0, Pe.MAX_STRING_LENGTH) : e;
}, sd = function(e, r12, n12) {
  return s0(e) !== n12 ? (ot.error("Invalid " + r12 + " input type. Expected " + n12 + " but received " + s0(e)), false) : true;
}, _z1 = function(e) {
  return sd(e, "deviceId", "string") ? e.indexOf(".") >= 0 ? (ot.error(`Device IDs may not contain '.' characters. Value will be ignored: "`.concat(e, '"')), false) : true : false;
}, hz1 = function(e) {
  return sd(e, "transport", "string") ? e !== Pe.TRANSPORT_HTTP && e !== Pe.TRANSPORT_BEACON ? (ot.error("transport value must be one of '".concat(Pe.TRANSPORT_BEACON, "' or '").concat(Pe.TRANSPORT_HTTP, "'")), false) : e !== Pe.TRANSPORT_HTTP && typeof navigator < "u" && !navigator.sendBeacon ? (ot.error("browser does not support sendBeacon, so transport must be HTTP"), false) : true : false;
}, fee = function(e) {
  var r12 = s0(e);
  if (r12 !== "object")
    return ot.error("Error: invalid properties format. Expecting Javascript object, received " + r12 + ", ignoring"), {};
  if (Object.keys(e).length > Pe.MAX_PROPERTY_KEYS)
    return ot.error("Error: too many properties (more than 1000), ignoring"), {};
  var n12 = {};
  for (var a in e)
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      var o = a, i = s0(o);
      i !== "string" && (o = String(o), ot.warn("WARNING: Non-string property key, received type " + i + ', coercing to string "' + o + '"'));
      var u = mz1(o, e[a]);
      u !== null && (n12[o] = u);
    }
  return n12;
}, vz1 = ["nan", "function", "arguments", "regexp", "element"], mz1 = function t13(e, r12) {
  var n12 = s0(r12);
  if (vz1.indexOf(n12) !== -1)
    ot.warn('WARNING: Property key "' + e + '" with invalid value type ' + n12 + ", ignoring"), r12 = null;
  else if (n12 === "undefined")
    r12 = null;
  else if (n12 === "error")
    r12 = String(r12), ot.warn('WARNING: Property key "' + e + '" with value type error, coercing to ' + r12);
  else if (n12 === "array") {
    for (var a = [], o = 0; o < r12.length; o++) {
      var i = r12[o], u = s0(i);
      if (u === "array") {
        ot.warn("WARNING: Cannot have " + u + " nested in an array property value, skipping");
        continue;
      } else
        u === "object" ? a.push(fee(i)) : a.push(t13(e, i));
    }
    r12 = a;
  } else
    n12 === "object" && (r12 = fee(r12));
  return r12;
}, Rz1 = function(e) {
  var r12 = s0(e);
  if (r12 !== "object")
    return ot.error("Error: invalid groups format. Expecting Javascript object, received " + r12 + ", ignoring"), {};
  var n12 = {};
  for (var a in e)
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      var o = a, i = s0(o);
      i !== "string" && (o = String(o), ot.warn("WARNING: Non-string groupType, received type " + i + ', coercing to string "' + o + '"'));
      var u = qz1(o, e[a]);
      u !== null && (n12[o] = u);
    }
  return n12;
}, qz1 = function(e, r12) {
  var n12 = s0(r12);
  if (n12 === "string")
    return r12;
  if (n12 === "date" || n12 === "number" || n12 === "boolean")
    return r12 = String(r12), ot.warn("WARNING: Non-string groupName, received type " + n12 + ', coercing to string "' + r12 + '"'), r12;
  if (n12 === "array") {
    for (var a = [], o = 0; o < r12.length; o++) {
      var i = r12[o], u = s0(i);
      if (u === "array" || u === "object") {
        ot.warn("WARNING: Skipping nested " + u + " in array groupName");
        continue;
      } else
        u === "string" ? a.push(i) : (u === "date" || u === "number" || u === "boolean") && (i = String(i), ot.warn("WARNING: Non-string groupName, received type " + u + ', coercing to string "' + i + '"'), a.push(i));
    }
    return a;
  }
  ot.warn("WARNING: Non-string groupName, received type " + n12 + ". Please use strings or array of strings for groupName");
}, Tz1 = function(e, r12) {
  e = e.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var n12 = new RegExp("[\\?&]" + e + "=([^&#]*)"), a = n12.exec(r12);
  return a === null ? void 0 : decodeURIComponent(a[1].replace(/\+/g, " "));
}, yz1 = function() {
  return typeof WorkerGlobalScope < "u";
}, Sz1 = function(e) {
  return sd(e, "sessionId", "number") && new Date(e).getTime() > 0 ? true : (ot.error("sessionId value must in milliseconds since epoch (Unix Timestamp)"), false);
}, Cz1 = function() {
  return P0.location;
}, gz1 = function(e) {
  var r12 = P0.location ? P0.location.hostname : "";
  if (e) {
    if (typeof document < "u") {
      var n12 = document.createElement("a");
      return n12.href = e, n12.hostname || r12;
    }
    if (typeof URL == "function") {
      var a = new URL(e);
      return a.hostname || r12;
    }
  }
  return r12;
}, _e = {
  setLogLevel: fz1,
  getLogLevel: bz1,
  logLevels: mo,
  log: ot,
  isEmptyString: Mz1,
  isWebWorkerEnvironment: yz1,
  getQueryParam: Tz1,
  sessionStorageEnabled: Oz1,
  truncate: zz1,
  validateGroups: Rz1,
  validateInput: sd,
  validateProperties: fee,
  validateDeviceId: _z1,
  validateTransport: hz1,
  validateSessionId: Sz1,
  getLocation: Cz1,
  getHost: gz1
}, mKe = function(e) {
  try {
    for (var r12 = document.cookie.split(";"), n12 = null, a = 0; a < r12.length; a++) {
      for (var o = r12[a]; o.charAt(0) === " "; )
        o = o.substring(1, o.length);
      if (o.indexOf(e) === 0) {
        n12 = o.substring(e.length, o.length);
        break;
      }
    }
    return n12;
  } catch {
    return null;
  }
}, Iz1 = function(e) {
  try {
    var r12 = document.cookie.split(";").map(function(u) {
      return u.trimStart();
    }), n12 = [], a = lz1(r12), o;
    try {
      for (a.s(); !(o = a.n()).done; ) {
        for (var i = o.value; i.charAt(0) === " "; )
          i = i.substring(1);
        i.indexOf(e) === 0 && n12.push(i.substring(e.length));
      }
    } catch (u) {
      a.e(u);
    } finally {
      a.f();
    }
    return n12;
  } catch {
    return [];
  }
}, bee = function(e, r12, n12) {
  var a = r12 !== null ? n12.expirationDays : -1;
  if (a) {
    var o = /* @__PURE__ */ new Date();
    o.setTime(o.getTime() + a * 24 * 60 * 60 * 1e3), a = o;
  }
  var i = e + "=" + r12;
  a && (i += "; expires=" + a.toUTCString()), i += "; path=/", n12.domain && (i += "; domain=" + n12.domain), n12.secure && (i += "; Secure"), n12.sameSite && (i += "; SameSite=" + n12.sameSite), document.cookie = i;
}, Mee = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", r12 = e.split(".")[Pe.LAST_EVENT_TIME_INDEX], n12;
  return r12 && (n12 = parseInt(r12, 32)), n12 || (_e.log.warn("unable to parse malformed cookie: ".concat(e)), 0);
}, Ez1 = function(e) {
  return iz1(e).sort(function(r12, n12) {
    var a = Mee(r12), o = Mee(n12);
    return o - a;
  });
}, Lz1 = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r12 = Pe.COOKIE_TEST_PREFIX;
  if (typeof document > "u")
    return false;
  var n12 = false;
  try {
    var a = String(Date.now());
    bee(r12, a, e), _e.log.info("Testing if cookies available"), n12 = mKe(r12 + "=") === a;
  } catch (o) {
    _e.log.warn('Error thrown when checking for cookies. Reason: "'.concat(o, '"'));
  } finally {
    _e.log.info("Cleaning up cookies availability test"), bee(r12, null, e);
  }
  return n12;
}, G1 = {
  set: bee,
  get: mKe,
  getAll: Iz1,
  getLastEventTime: Mee,
  sortByEventTime: Ez1,
  areCookiesEnabled: Lz1
}, Pz1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", I1e = function() {
  for (var e = "", r12 = 0; r12 < 22; ++r12)
    e += Pz1.charAt(Math.floor(Math.random() * 64));
  return e;
}, RKe = function(e) {
  var r12 = _e.getHost(e), n12 = r12.split("."), a = [], o = "_tldtest_" + I1e();
  if (_e.isWebWorkerEnvironment())
    return "";
  for (var i = n12.length - 2; i >= 0; --i)
    a.push(n12.slice(i).join("."));
  for (var u = 0; u < a.length; ++u) {
    var s12 = a[u], c = {
      domain: "." + s12
    };
    if (G1.set(o, 1, c), G1.get(o))
      return G1.set(o, null, c), s12;
  }
  return "";
}, Et = {
  expirationDays: void 0,
  domain: void 0
}, Dz1 = function() {
  Et = {
    expirationDays: void 0,
    domain: void 0
  };
}, Wz1 = function(e) {
  if (arguments.length === 0)
    return Et;
  e = e || {}, Et.expirationDays = e.expirationDays, Et.secure = e.secure, Et.sameSite = e.sameSite;
  var r12 = _e.isEmptyString(e.domain) ? "." + RKe(_e.getLocation().href) : e.domain, n12 = Math.random();
  Et.domain = r12, TKe("amplitude_test", n12);
  var a = qKe("amplitude_test");
  return (!a || a !== n12) && (r12 = null), yKe("amplitude_test"), Et.domain = r12, Et;
}, jc = function(e) {
  var r12 = "";
  return Et.domain && (r12 = Et.domain.charAt(0) === "." ? Et.domain.substring(1) : Et.domain), e + r12;
}, qKe = function(e) {
  var r12 = jc(e) + "=", n12 = G1.get(r12);
  try {
    if (n12)
      return JSON.parse(jt.decode(n12));
  } catch {
    return null;
  }
  return null;
}, TKe = function(e, r12) {
  try {
    return G1.set(jc(e), jt.encode(JSON.stringify(r12)), Et), true;
  } catch {
    return false;
  }
}, Nz1 = function(e, r12) {
  try {
    return G1.set(jc(e), r12, Et), true;
  } catch {
    return false;
  }
}, wz1 = function(e) {
  var r12 = jc(e) + "=";
  return G1.get(r12);
}, yKe = function(e) {
  try {
    return G1.set(jc(e), null, Et), true;
  } catch {
    return false;
  }
}, Bz1 = {
  reset: Dz1,
  options: Wz1,
  get: qKe,
  set: TKe,
  remove: yKe,
  setRaw: Nz1,
  getRaw: wz1
}, xz1 = /* @__PURE__ */ (function() {
  function t16() {
    C1e(this, t16), this.map = /* @__PURE__ */ new Map(), this.length = 0;
  }
  return g1e(t16, [{
    key: "key",
    value: function(r12) {
      var n12 = Array.from(this.map.keys()), a = n12[r12];
      return this.map.get(a);
    }
  }, {
    key: "getItem",
    value: function(r12) {
      return this.map.get(r12);
    }
  }, {
    key: "setItem",
    value: function(r12, n12) {
      this.map.has(r12) || (this.length += 1), this.map.set(r12, n12);
    }
  }, {
    key: "removeItem",
    value: function(r12) {
      this.map.has(r12) && (this.length -= 1, this.map.delete(r12));
    }
  }, {
    key: "clear",
    value: function() {
      this.map.clear(), this.length = 0;
    }
  }]), t16;
})(), ma;
{
  var Uz1 = function() {
    var e = /* @__PURE__ */ new Date(), r12;
    try {
      return P0.localStorage.setItem(e, e), r12 = P0.localStorage.getItem(e) === String(e), P0.localStorage.removeItem(e), r12;
    } catch {
    }
    return false;
  };
  if (Uz1())
    ma = P0.localStorage;
  else if (typeof P0 < "u" && P0.globalStorage)
    try {
      ma = P0.globalStorage[P0.location.hostname];
    } catch {
    }
  else if (typeof document < "u") {
    var C1 = document.createElement("div"), Un = "localStorage";
    C1.style.display = "none", document.getElementsByTagName("head")[0].appendChild(C1), C1.addBehavior && (C1.addBehavior("#default#userdata"), ma = {
      length: 0,
      setItem: function(e, r12) {
        C1.load(Un), C1.getAttribute(e) || this.length++, C1.setAttribute(e, r12), C1.save(Un);
      },
      getItem: function(e) {
        return C1.load(Un), C1.getAttribute(e);
      },
      removeItem: function(e) {
        C1.load(Un), C1.getAttribute(e) && this.length--, C1.removeAttribute(e), C1.save(Un);
      },
      clear: function() {
        C1.load(Un);
        for (var e = 0, r12; r12 = C1.XMLDocument.documentElement.attributes[e++]; )
          C1.removeAttribute(r12.name);
        C1.save(Un), this.length = 0;
      },
      key: function(e) {
        return C1.load(Un), C1.XMLDocument.documentElement.attributes[e];
      }
    }, C1.load(Un), ma.length = C1.XMLDocument.documentElement.attributes.length);
  } else
    _e.isWebWorkerEnvironment() && (ma = new xz1());
  ma || (ma = {
    length: 0,
    setItem: function(e, r12) {
    },
    getItem: function(e) {
    },
    removeItem: function(e) {
    },
    clear: function() {
    },
    key: function(e) {
    }
  });
}
var Kr = ma, SKe = function() {
  this.storage = null;
};
SKe.prototype.getStorage = function(t16) {
  if (this.storage !== null)
    return this.storage;
  if (!t16 && G1.areCookiesEnabled())
    this.storage = Bz1;
  else {
    var e = "amp_cookiestore_";
    this.storage = {
      _options: {
        expirationDays: void 0,
        domain: void 0,
        secure: false
      },
      reset: function() {
        this._options = {
          expirationDays: void 0,
          domain: void 0,
          secure: false
        };
      },
      options: function(n12) {
        return arguments.length === 0 ? this._options : (n12 = n12 || {}, this._options.expirationDays = n12.expirationDays || this._options.expirationDays, this._options.domain = n12.domain || this._options.domain || P0 && P0.location && P0.location.hostname, this._options.secure = n12.secure || false);
      },
      get: function(n12) {
        try {
          return JSON.parse(Kr.getItem(e + n12));
        } catch {
        }
        return null;
      },
      set: function(n12, a) {
        try {
          return Kr.setItem(e + n12, JSON.stringify(a)), true;
        } catch {
        }
        return false;
      },
      remove: function(n12) {
        try {
          Kr.removeItem(e + n12);
        } catch {
          return false;
        }
      }
    };
  }
  return this.storage;
};
var Jo, kz1 = (Jo = {}, ii(Jo, Pe.STORAGE_COOKIES, true), ii(Jo, Pe.STORAGE_NONE, true), ii(Jo, Pe.STORAGE_LOCAL, true), ii(Jo, Pe.STORAGE_SESSION, true), Jo), jz1 = /* @__PURE__ */ (function() {
  function t16(e) {
    var r12 = e.storageKey, n12 = e.disableCookies, a = e.domain, o = e.secure, i = e.sameSite, u = e.expirationDays, s12 = e.storage;
    C1e(this, t16), this.storageKey = r12, this.domain = a, this.secure = o, this.sameSite = i, this.expirationDays = u, this.cookieDomain = "";
    var c = _e.getLocation() ? _e.getLocation().href : void 0, l2 = n12 ? "" : RKe(c);
    if (this.cookieDomain = a || (l2 ? "." + l2 : null), kz1[s12])
      this.storage = s12;
    else {
      var f = n12 || !G1.areCookiesEnabled({
        domain: this.cookieDomain,
        secure: this.secure,
        sameSite: this.sameSite,
        expirationDays: this.expirationDays
      });
      f ? this.storage = Pe.STORAGE_LOCAL : this.storage = Pe.STORAGE_COOKIES;
    }
  }
  return g1e(t16, [{
    key: "getCookieStorageKey",
    value: function() {
      if (!this.domain)
        return this.storageKey;
      var r12 = this.domain.charAt(0) === "." ? this.domain.substring(1) : this.domain;
      return "".concat(this.storageKey).concat(r12 ? "_".concat(r12) : "");
    }
    /*
     * Data is saved as delimited values rather than JSO to minimize cookie space
     * Should not change order of the items
     */
  }, {
    key: "save",
    value: function(r12) {
      var n12 = r12.deviceId, a = r12.userId, o = r12.optOut, i = r12.sessionId, u = r12.lastEventTime, s12 = r12.eventId, c = r12.identifyId, l2 = r12.sequenceNumber;
      if (this.storage !== Pe.STORAGE_NONE) {
        var f = [
          n12,
          jt.encode(a || ""),
          // used to convert not unicode to alphanumeric since cookies only use alphanumeric
          o ? "1" : "",
          i ? i.toString(32) : "0",
          // generated when instantiated, timestamp (but re-uses session id in cookie if not expired) @TODO clients may want custom session id
          u ? u.toString(32) : "0",
          // last time an event was set
          s12 ? s12.toString(32) : "0",
          c ? c.toString(32) : "0",
          l2 ? l2.toString(32) : "0"
        ].join(".");
        switch (this.storage) {
          case Pe.STORAGE_SESSION:
            P0.sessionStorage && P0.sessionStorage.setItem(this.storageKey, f);
            break;
          case Pe.STORAGE_LOCAL:
            Kr.setItem(this.storageKey, f);
            break;
          case Pe.STORAGE_COOKIES:
            this.saveCookie(f);
            break;
        }
      }
    }
  }, {
    key: "saveCookie",
    value: function(r12) {
      G1.set(this.getCookieStorageKey(), r12, {
        domain: this.cookieDomain,
        secure: this.secure,
        sameSite: this.sameSite,
        expirationDays: this.expirationDays
      });
    }
  }, {
    key: "load",
    value: function() {
      var r12 = this, n12;
      if (this.storage === Pe.STORAGE_COOKIES) {
        var a = this.getCookieStorageKey() + "=", o = G1.getAll(a);
        if (o.length === 0 || o.length === 1)
          n12 = o[0];
        else {
          var i = G1.sortByEventTime(o)[0];
          o.forEach(function() {
            return G1.set(r12.getCookieStorageKey(), null, {});
          }), this.saveCookie(i), n12 = G1.get(a);
        }
      }
      if (n12 || (n12 = Kr.getItem(this.storageKey)), !n12)
        try {
          n12 = P0.sessionStorage && P0.sessionStorage.getItem(this.storageKey);
        } catch (c) {
          _e.log.info('window.sessionStorage unavailable. Reason: "'.concat(c, '"'));
        }
      if (!n12)
        return null;
      var u = n12.split("."), s12 = null;
      if (u[Pe.USER_ID_INDEX])
        try {
          s12 = jt.decode(u[Pe.USER_ID_INDEX]);
        } catch {
          s12 = null;
        }
      return {
        deviceId: u[Pe.DEVICE_ID_INDEX],
        userId: s12,
        optOut: u[Pe.OPT_OUT_INDEX] === "1",
        sessionId: parseInt(u[Pe.SESSION_ID_INDEX], 32),
        lastEventTime: parseInt(u[Pe.LAST_EVENT_TIME_INDEX], 32),
        eventId: parseInt(u[Pe.EVENT_ID_INDEX], 32),
        identifyId: parseInt(u[Pe.IDENTIFY_ID_INDEX], 32),
        sequenceNumber: parseInt(u[Pe.SEQUENCE_NUMBER_INDEX], 32)
      };
    }
    /**
     * Clears any saved metadata storage
     * @constructor AmplitudeClient
     * @public
     * @return {boolean} True if metadata was cleared, false if none existed
     */
  }, {
    key: "clear",
    value: function() {
      var r12;
      if (this.storage === Pe.STORAGE_COOKIES && (r12 = G1.get(this.getCookieStorageKey() + "="), G1.set(this.getCookieStorageKey(), null, {
        domain: this.cookieDomain,
        secure: this.secure,
        sameSite: this.sameSite,
        expirationDays: 0
      })), r12 || (r12 = Kr.getItem(this.storageKey), Kr.clear()), !r12)
        try {
          r12 = P0.sessionStorage && P0.sessionStorage.getItem(this.storageKey), P0.sessionStorage.clear();
        } catch (n12) {
          _e.log.info('window.sessionStorage unavailable. Reason: "'.concat(n12, '"'));
        }
      return !!r12;
    }
  }]), t16;
})(), Fz1 = function(e, r12) {
  var n12 = e ? "?" + e.split(".").slice(-1)[0].replace(/\|/g, "&") : "", a = function(d, b, z, _) {
    return _e.getQueryParam(d, b) || _e.getQueryParam(z, _);
  }, o = a(Pe.UTM_SOURCE, r12, "utmcsr", n12), i = a(Pe.UTM_MEDIUM, r12, "utmcmd", n12), u = a(Pe.UTM_CAMPAIGN, r12, "utmccn", n12), s12 = a(Pe.UTM_TERM, r12, "utmctr", n12), c = a(Pe.UTM_CONTENT, r12, "utmcct", n12), l2 = {}, f = function(d, b) {
    _e.isEmptyString(b) || (l2[d] = b);
  };
  return f(Pe.UTM_SOURCE, o), f(Pe.UTM_MEDIUM, i), f(Pe.UTM_CAMPAIGN, u), f(Pe.UTM_TERM, s12), f(Pe.UTM_CONTENT, c), l2;
}, Vz1 = "$add", Hz1 = "$append", Oee = "$clearAll", Xz1 = "$prepend", $z1 = "$set", Gz1 = "$setOnce", Yz1 = "$unset", Jz1 = "$preInsert", Kz1 = "$postInsert", Qz1 = "$remove", L1 = function() {
  this.userPropertiesOperations = {}, this.properties = [];
};
L1.prototype.add = function(t16, e) {
  return s0(e) === "number" || s0(e) === "string" ? this._addOperation(Vz1, t16, e) : _e.log.error("Unsupported type for value: " + s0(e) + ", expecting number or string"), this;
};
L1.prototype.append = function(t16, e) {
  return this._addOperation(Hz1, t16, e), this;
};
L1.prototype.clearAll = function() {
  return Object.keys(this.userPropertiesOperations).length > 0 ? (Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, Oee) || _e.log.error("Need to send $clearAll on its own Identify object without any other operations, skipping $clearAll"), this) : (this.userPropertiesOperations[Oee] = "-", this);
};
L1.prototype.prepend = function(t16, e) {
  return this._addOperation(Xz1, t16, e), this;
};
L1.prototype.set = function(t16, e) {
  return this._addOperation($z1, t16, e), this;
};
L1.prototype.setOnce = function(t16, e) {
  return this._addOperation(Gz1, t16, e), this;
};
L1.prototype.unset = function(t16) {
  return this._addOperation(Yz1, t16, "-"), this;
};
L1.prototype.preInsert = function(t16, e) {
  return this._addOperation(Jz1, t16, e), this;
};
L1.prototype.postInsert = function(t16, e) {
  return this._addOperation(Kz1, t16, e), this;
};
L1.prototype.remove = function(t16, e) {
  return this._addOperation(Qz1, t16, e), this;
};
L1.prototype._addOperation = function(t16, e, r12) {
  if (Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, Oee)) {
    _e.log.error("This identify already contains a $clearAll operation, skipping operation " + t16);
    return;
  }
  if (this.properties.indexOf(e) !== -1) {
    _e.log.error('User property "' + e + '" already used in this identify, skipping operation ' + t16);
    return;
  }
  Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, t16) || (this.userPropertiesOperations[t16] = {}), this.userPropertiesOperations[t16][e] = r12, this.properties.push(e);
};
var CKe = function(e, r12, n12) {
  this.url = e, this.data = r12 || {}, this.headers = n12;
}, Zz1 = "Cross-Origin-Resource-Policy";
function eA1(t16, e) {
  for (var r12 in e)
    r12 === Zz1 && !e[r12] || t16.setRequestHeader(r12, e[r12]);
}
CKe.prototype.send = function(t16) {
  var e = !!P0.XDomainRequest;
  if (e) {
    var r12 = new P0.XDomainRequest();
    r12.open("POST", this.url, true), r12.onload = function() {
      t16(200, r12.responseText);
    }, r12.onerror = function() {
      r12.responseText === "Request Entity Too Large" ? t16(413, r12.responseText) : t16(500, r12.responseText);
    }, r12.ontimeout = function() {
    }, r12.onprogress = function() {
    }, r12.send(CQ.stringify(this.data));
  } else if (typeof XMLHttpRequest < "u") {
    var n12 = new XMLHttpRequest();
    n12.open("POST", this.url, true), n12.onreadystatechange = function() {
      n12.readyState === 4 && t16(n12.status, n12.responseText);
    }, eA1(n12, this.headers), n12.send(CQ.stringify(this.data));
  } else {
    var a = void 0;
    fetch(this.url, {
      method: "POST",
      headers: this.headers,
      body: CQ.stringify(this.data)
    }).then(function(o) {
      return a = o.status, o.text();
    }).then(function(o) {
      t16(a, o);
    });
  }
};
var nn = function() {
  this._price = null, this._productId = null, this._quantity = 1, this._revenueType = null, this._properties = null;
};
nn.prototype.setProductId = function(e) {
  return s0(e) !== "string" ? _e.log.error("Unsupported type for productId: " + s0(e) + ", expecting string") : _e.isEmptyString(e) ? _e.log.error("Invalid empty productId") : this._productId = e, this;
};
nn.prototype.setQuantity = function(e) {
  return s0(e) !== "number" ? _e.log.error("Unsupported type for quantity: " + s0(e) + ", expecting number") : this._quantity = parseInt(e), this;
};
nn.prototype.setPrice = function(e) {
  return s0(e) !== "number" ? _e.log.error("Unsupported type for price: " + s0(e) + ", expecting number") : this._price = e, this;
};
nn.prototype.setRevenueType = function(e) {
  return s0(e) !== "string" ? _e.log.error("Unsupported type for revenueType: " + s0(e) + ", expecting string") : this._revenueType = e, this;
};
nn.prototype.setEventProperties = function(e) {
  return s0(e) !== "object" ? _e.log.error("Unsupported type for eventProperties: " + s0(e) + ", expecting object") : this._properties = _e.validateProperties(e), this;
};
nn.prototype._isValidRevenue = function() {
  return s0(this._price) !== "number" ? (_e.log.error("Invalid revenue, need to set price field"), false) : true;
};
nn.prototype._toJSONObject = function() {
  var e = s0(this._properties) === "object" ? this._properties : {};
  return this._productId !== null && (e[Pe.REVENUE_PRODUCT_ID] = this._productId), this._quantity !== null && (e[Pe.REVENUE_QUANTITY] = this._quantity), this._price !== null && (e[Pe.REVENUE_PRICE] = this._price), this._revenueType !== null && (e[Pe.REVENUE_REVENUE_TYPE] = this._revenueType), e;
};
var tA1 = function t14(e) {
  return e ? (
    // a random number from 0 to 15
    (e ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    e / 4).toString(16)
  ) : (
    // or otherwise a concatenated string:
    ("10000000-1000-4000-8000" + // -80000000 +
    -1e11).replace(
      // replacing
      /[018]/g,
      // zeroes, ones, and eights with
      t14
      // random hex digits
    )
  );
}, rA1 = function() {
  return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage) || "";
}, nA1 = {
  getLanguage: rA1
}, So = {
  US: "US",
  EU: "EU"
}, gKe = function(e) {
  var r12 = Pe.EVENT_LOG_URL;
  switch (e) {
    case So.EU:
      r12 = Pe.EVENT_LOG_EU_URL;
      break;
    case So.US:
      r12 = Pe.EVENT_LOG_URL;
      break;
  }
  return r12;
}, aA1 = function(e) {
  var r12 = Pe.DYNAMIC_CONFIG_URL;
  switch (e) {
    case So.EU:
      r12 = Pe.DYNAMIC_CONFIG_EU_URL;
      break;
    case So.US:
      r12 = Pe.DYNAMIC_CONFIG_URL;
      break;
  }
  return r12;
}, IKe = "8.21.9", ya = {
  apiEndpoint: Pe.EVENT_LOG_URL,
  batchEvents: false,
  cookieExpiration: 365,
  // 12 months is for GDPR compliance
  cookieName: "amplitude_id",
  // this is a deprecated option
  sameSiteCookie: "Lax",
  // cookie privacy policy
  cookieForceUpgrade: false,
  deferInitialization: false,
  disableCookies: false,
  // this is a deprecated option
  deviceIdFromUrlParam: false,
  domain: "",
  eventUploadPeriodMillis: 30 * 1e3,
  // 30s
  eventUploadThreshold: 30,
  forceHttps: true,
  includeFbclid: false,
  includeGclid: false,
  includeReferrer: false,
  includeUtm: false,
  ingestionMetadata: {
    sourceName: "",
    sourceVersion: ""
  },
  language: nA1.getLanguage(),
  library: {
    name: "amplitude-js",
    version: IKe
  },
  logLevel: "WARN",
  logAttributionCapturedEvent: false,
  optOut: false,
  onError: function() {
  },
  onExitPage: function() {
  },
  onNewSessionStart: function() {
  },
  plan: {
    branch: "",
    source: "",
    version: "",
    versionId: ""
  },
  platform: "Web",
  savedMaxCount: 1e3,
  saveEvents: true,
  saveParamsReferrerOncePerSession: true,
  secureCookie: false,
  sessionTimeout: 30 * 60 * 1e3,
  storage: Pe.STORAGE_DEFAULT,
  trackingOptions: {
    city: true,
    country: true,
    carrier: true,
    device_manufacturer: true,
    device_model: true,
    dma: true,
    ip_address: true,
    language: true,
    os_name: true,
    os_version: true,
    platform: true,
    region: true,
    version_name: true
  },
  transport: Pe.TRANSPORT_HTTP,
  unsetParamsReferrerOnNewSession: false,
  unsentKey: "amplitude_unsent",
  unsentIdentifyKey: "amplitude_unsent_identify",
  uploadBatchSize: 100,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    "Cross-Origin-Resource-Policy": "cross-origin"
  },
  serverZone: So.US,
  useDynamicConfig: false,
  serverZoneBasedApi: false,
  sessionId: null,
  partnerId: ""
}, oA1 = /* @__PURE__ */ (function() {
  function t16() {
    return C1e(this, t16), t16.instance || (this.ingestionEndpoint = Pe.EVENT_LOG_URL, t16.instance = this), t16.instance;
  }
  return g1e(t16, [{
    key: "refresh",
    value: function(r12, n12, a) {
      var o = "https";
      !n12 && P0.location.protocol !== "https:" && (o = "http");
      var i = o + "://" + aA1(r12), u = this, s12 = !!P0.XDomainRequest;
      if (s12) {
        var c = new P0.XDomainRequest();
        c.open("GET", i, true), c.onload = function() {
          var f = JSON.parse(c.responseText);
          u.ingestionEndpoint = f.ingestionEndpoint, a && a();
        }, c.onerror = function() {
        }, c.ontimeout = function() {
        }, c.onprogress = function() {
        }, c.send();
      } else {
        var l2 = new XMLHttpRequest();
        l2.open("GET", i, true), l2.onreadystatechange = function() {
          if (l2.readyState === 4 && l2.status === 200) {
            var f = JSON.parse(l2.responseText);
            u.ingestionEndpoint = f.ingestionEndpoint, a && a();
          }
        }, l2.send();
      }
    }
  }]), t16;
})(), BFe = new oA1(), xe = function(e) {
  !T1e() && !_e.isWebWorkerEnvironment() && _e.log.warn("amplitude-js will not work in a non-browser environment. If you are planning to add Amplitude to a node environment, please use @amplitude/node"), this._instanceName = _e.isEmptyString(e) ? Pe.DEFAULT_INSTANCE : e.toLowerCase(), this._unsentEvents = [], this._unsentIdentifys = [], this.options = pt(pt({}, ya), {}, {
    headers: pt({}, ya.headers),
    ingestionMetadata: pt({}, ya.ingestionMetadata),
    library: pt({}, ya.library),
    plan: pt({}, ya.plan),
    trackingOptions: pt({}, ya.trackingOptions)
  }), this._q = [], this._sending = false, this._updateScheduled = false, this._onInitCallbacks = [], this._onNewSessionStartCallbacks = [], this._eventId = 0, this._identifyId = 0, this._lastEventTime = null, this._newSession = false, this._sequenceNumber = 0, this._sessionId = null, this._isInitialized = false, this._connector = null, this._userAgent = typeof navigator < "u" && navigator && navigator.userAgent || null, this._ua = new K31(this._userAgent).getResult();
};
xe.prototype.Identify = L1;
xe.prototype.Revenue = nn;
xe.prototype.init = function(e, r12, n12, a) {
  var o = this;
  if (s0(e) !== "string" || _e.isEmptyString(e)) {
    _e.log.error("Invalid apiKey. Please re-initialize with a valid apiKey");
    return;
  }
  try {
    this._connector = oz1.getInstance(this._instanceName), iA1(this.options, n12), (T1e() || _e.isWebWorkerEnvironment()) && P0.Prototype !== void 0 && Array.prototype.toJSON && (w31(), _e.log.warn("Prototype.js injected Array.prototype.toJSON. Deleting Array.prototype.toJSON to prevent double-stringify")), this.options.cookieName !== ya.cookieName && _e.log.warn("The cookieName option is deprecated. We will be ignoring it for newer cookies"), this.options.serverZoneBasedApi && (this.options.apiEndpoint = gKe(this.options.serverZone)), this._refreshDynamicConfig(), this.options.apiKey = e, this._storageSuffix = "_" + e + (this._instanceName === Pe.DEFAULT_INSTANCE ? "" : "_" + this._instanceName), this._storageSuffixV5 = e.slice(0, 6), this._oldCookiename = this.options.cookieName + this._storageSuffix, this._unsentKey = this.options.unsentKey + this._storageSuffix, this._unsentIdentifyKey = this.options.unsentIdentifyKey + this._storageSuffix, this._cookieName = Pe.COOKIE_PREFIX + "_" + this._storageSuffixV5, this.cookieStorage = new SKe().getStorage(this.options.disableCookies), this.cookieStorage.options({
      expirationDays: this.options.cookieExpiration,
      domain: this.options.domain,
      secure: this.options.secureCookie,
      sameSite: this.options.sameSiteCookie
    }), this._metadataStorage = new jz1({
      storageKey: this._cookieName,
      disableCookies: this.options.disableCookies,
      expirationDays: this.options.cookieExpiration,
      domain: this.options.domain,
      secure: this.options.secureCookie,
      sameSite: this.options.sameSiteCookie,
      storage: this.options.storage
    });
    var i = !!this.cookieStorage.get(this._oldCookiename), u = !!this._metadataStorage.load();
    this._useOldCookie = !u && i && !this.options.cookieForceUpgrade;
    var s12 = u || i;
    if (this.options.deferInitialization && !s12) {
      this._deferInitialization(e, r12, n12, a);
      return;
    }
    this.options.domain = this.cookieStorage.options().domain, s0(this.options.logLevel) === "string" && _e.setLogLevel(this.options.logLevel);
    var c = lA1(this);
    this._apiPropertiesTrackingOptions = Object.keys(c).length > 0 ? {
      tracking_options: c
    } : {}, this.options.cookieForceUpgrade && i && (u || uA1(this), this.cookieStorage.remove(this._oldCookiename)), E1e(this), this._pendingReadStorage = true;
    var l2 = function(z) {
      n12 && n12.deviceId && !_e.validateDeviceId(n12.deviceId) && (_e.log.error('Invalid device ID rejected. Randomly generated UUID will be used instead of "'.concat(n12.deviceId, '"')), delete n12.deviceId), o.options.deviceId = o._getInitialDeviceId(n12 && n12.deviceId, z), o.options.userId = s0(r12) === "string" && !_e.isEmptyString(r12) && r12 || s0(r12) === "number" && r12.toString() || o.options.userId || null;
      var _ = (/* @__PURE__ */ new Date()).getTime(), q = !o._sessionId || !o._lastEventTime || _ - o._lastEventTime > o.options.sessionTimeout || o.options.sessionId;
      q && (o.options.unsetParamsReferrerOnNewSession && o._unsetUTMParams(), o._newSession = true, o._sessionId = o.options.sessionId || _, o.options.sessionId = void 0, o.options.saveParamsReferrerOncePerSession && o._trackParamsAndReferrer()), o.options.saveParamsReferrerOncePerSession || o._trackParamsAndReferrer(), o.options.saveEvents && (xFe(o._unsentEvents), xFe(o._unsentIdentifys)), o._lastEventTime = _, Oa(o), o._pendingReadStorage = false, o._sendEventsIfReady();
      for (var S = 0; S < o._onInitCallbacks.length; S++)
        o._onInitCallbacks[S](o);
      o._onInitCallbacks = [], o._isInitialized = true, q && o._runNewSessionStartCallbacks();
    };
    this.options.saveEvents && (this._unsentEvents = this._loadSavedUnsentEvents(this.options.unsentKey).map(function(b) {
      return {
        event: b
      };
    }).concat(this._unsentEvents), this._unsentIdentifys = this._loadSavedUnsentEvents(this.options.unsentIdentifyKey).map(function(b) {
      return {
        event: b
      };
    }).concat(this._unsentIdentifys)), n12 && n12.onNewSessionStart && this.onNewSessionStart(this.options.onNewSessionStart), l2(), this.runQueuedFunctions(), s0(a) === "function" && a(this);
    var f = this.options.onExitPage;
    if (s0(f) === "function" && P0.addEventListener && !this.pageHandlersAdded) {
      this.pageHandlersAdded = true;
      var p = function() {
        var z = o.options.transport;
        o.setTransport(Pe.TRANSPORT_BEACON), f(), o.setTransport(z);
      };
      P0.addEventListener("pagehide", function() {
        p();
      }, false);
    }
    this._connector.eventBridge.setEventReceiver(function(b) {
      o._logEvent(b.eventType, b.eventProperties, b.userProperties);
    });
    var d = this._connector.identityStore.editIdentity();
    this.options.deviceId && d.setDeviceId(this.options.deviceId), this.options.userId && d.setUserId(this.options.userId), d.commit();
  } catch (b) {
    _e.log.error(b), n12 && s0(n12.onError) === "function" && n12.onError(b);
  }
};
xe.prototype._runNewSessionStartCallbacks = function() {
  for (var t16 = 0; t16 < this._onNewSessionStartCallbacks.length; t16++)
    this._onNewSessionStartCallbacks[t16](this);
};
xe.prototype.deleteLowerLevelDomainCookies = function() {
  var t16 = _e.getHost(), e = this.options.domain && this.options.domain[0] === "." ? this.options.domain.slice(1) : this.options.domain;
  if (!(!e || !_e.isWebWorkerEnvironment()) && t16 !== e && new RegExp(e + "$").test(t16)) {
    for (var r12 = t16.split("."), n12 = e.split("."), a = r12.length; a > n12.length; --a) {
      var o = r12.slice(r12.length - a).join(".");
      G1.set(this._cookieName, null, {
        domain: "." + o
      });
    }
    G1.set(this._cookieName, null, {});
  }
};
xe.prototype._getInitialDeviceId = function(t16, e) {
  if (t16)
    return t16;
  if (this.options.deviceIdFromUrlParam) {
    var r12 = this._getDeviceIdFromUrlParam(this._getUrlParams());
    if (r12)
      return r12;
  }
  return this.options.deviceId ? this.options.deviceId : e || I1e();
};
var xFe = function(e) {
  for (var r12 = 0; r12 < e.length; r12++) {
    var n12 = e[r12].event.user_properties, a = e[r12].event.event_properties, o = e[r12].event.groups;
    e[r12].event.user_properties = _e.validateProperties(n12), e[r12].event.event_properties = _e.validateProperties(a), e[r12].event.groups = _e.validateGroups(o);
  }
};
xe.prototype._trackParamsAndReferrer = function() {
  var e, r12, n12, a;
  if (this.options.includeUtm && (e = this._initUtmData()), this.options.includeReferrer && (r12 = this._saveReferrer(this._getReferrer())), this.options.includeGclid && (n12 = this._saveGclid(this._getUrlParams())), this.options.includeFbclid && (a = this._saveFbclid(this._getUrlParams())), this.options.logAttributionCapturedEvent) {
    var o = pt(pt(pt(pt({}, e), r12), n12), a);
    Object.keys(o).length > 0 && this.logEvent(Pe.ATTRIBUTION_EVENT, o);
  }
};
var iA1 = function t15(e, r12) {
  if (s0(r12) === "object") {
    var n12 = /* @__PURE__ */ new Set(["headers"]), a = /* @__PURE__ */ new Set(["eventUploadPeriodMillis"]), o = function(s12) {
      if (Object.prototype.hasOwnProperty.call(e, s12)) {
        var c = r12[s12], l2 = s0(e[s12]);
        if (!(s12 === "transport" && !_e.validateTransport(c))) {
          if (s12 === "sessionId" && c !== null) {
            e[s12] = _e.validateSessionId(c) ? c : null;
            return;
          } else if (!_e.validateInput(c, s12 + " option", l2))
            return;
          l2 === "boolean" ? e[s12] = !!c : l2 === "string" && !_e.isEmptyString(c) || l2 === "number" && (c > 0 || c === 0 && a.has(s12)) || l2 === "function" ? e[s12] = c : l2 === "object" && t15(e[s12], c);
        }
      }
    };
    for (var i in r12)
      n12.has(i) ? e[i] = pt(pt({}, e[i]), r12[i]) : Object.prototype.hasOwnProperty.call(r12, i) && o(i);
  }
};
xe.prototype.runQueuedFunctions = function() {
  var t16 = this._q;
  this._q = [];
  for (var e = 0; e < t16.length; e++) {
    var r12 = this[t16[e][0]];
    s0(r12) === "function" && r12.apply(this, t16[e].slice(1));
  }
};
xe.prototype._apiKeySet = function(e) {
  return _e.isEmptyString(this.options.apiKey) ? (_e.log.error("Invalid apiKey. Please set a valid apiKey with init() before calling " + e), false) : true;
};
xe.prototype._loadSavedUnsentEvents = function(e) {
  var r12 = this._getFromStorage(Kr, e), n12 = this._parseSavedUnsentEventsString(r12, e);
  return this._setInStorage(Kr, e, JSON.stringify(n12)), n12;
};
xe.prototype._parseSavedUnsentEventsString = function(e, r12) {
  if (_e.isEmptyString(e))
    return [];
  if (s0(e) === "string")
    try {
      var n12 = JSON.parse(e);
      if (s0(n12) === "array")
        return n12;
    } catch {
    }
  return _e.log.error("Unable to load " + r12 + " events. Restart with a new empty queue."), [];
};
xe.prototype.isNewSession = function() {
  return this._newSession;
};
xe.prototype.onInit = function(e) {
  this._isInitialized ? e(this) : this._onInitCallbacks.push(e);
};
xe.prototype.onNewSessionStart = function(e) {
  this._onNewSessionStartCallbacks.push(e);
};
xe.prototype.getSessionId = function() {
  return this._sessionId;
};
xe.prototype.nextEventId = function() {
  return this._eventId++, this._eventId;
};
xe.prototype.nextIdentifyId = function() {
  return this._identifyId++, this._identifyId;
};
xe.prototype.nextSequenceNumber = function() {
  return this._sequenceNumber++, this._sequenceNumber;
};
xe.prototype._unsentCount = function() {
  return this._unsentEvents.length + this._unsentIdentifys.length;
};
xe.prototype._sendEventsIfReady = function() {
  return this._unsentCount() === 0 ? false : this.options.batchEvents ? this._unsentCount() >= this.options.eventUploadThreshold ? (this.sendEvents(), true) : this.options.transport === Pe.TRANSPORT_BEACON ? (this.sendEvents(), true) : (this._updateScheduled || (this._updateScheduled = true, setTimeout((function() {
    this._updateScheduled = false, this.sendEvents();
  }).bind(this), this.options.eventUploadPeriodMillis)), false) : (this.sendEvents(), true);
};
xe.prototype.clearStorage = function() {
  return this._metadataStorage.clear();
};
xe.prototype._getFromStorage = function(e, r12) {
  return e.getItem(r12 + this._storageSuffix);
};
xe.prototype._setInStorage = function(e, r12, n12) {
  e.setItem(r12 + this._storageSuffix, n12);
};
var E1e = function(e) {
  if (!e._useOldCookie) {
    var r12 = e._metadataStorage.load();
    s0(r12) === "object" && zee(e, r12);
    return;
  }
  var n12 = e.cookieStorage.get(e._oldCookiename);
  if (s0(n12) === "object") {
    zee(e, n12);
    return;
  }
}, uA1 = function(e) {
  var r12 = e.cookieStorage.get(e._oldCookiename);
  s0(r12) === "object" && (zee(e, r12), Oa(e));
}, zee = function(e, r12) {
  r12.deviceId && (e.options.deviceId = r12.deviceId), r12.userId && (e.options.userId = r12.userId), r12.optOut !== null && r12.optOut !== void 0 && r12.optOut !== false && (e.options.optOut = r12.optOut), r12.sessionId && (e._sessionId = parseInt(r12.sessionId, 10)), r12.lastEventTime && (e._lastEventTime = parseInt(r12.lastEventTime, 10)), r12.eventId && (e._eventId = parseInt(r12.eventId, 10)), r12.identifyId && (e._identifyId = parseInt(r12.identifyId, 10)), r12.sequenceNumber && (e._sequenceNumber = parseInt(r12.sequenceNumber, 10));
}, Oa = function(e) {
  var r12 = {
    deviceId: e.options.deviceId,
    userId: e.options.userId,
    optOut: e.options.optOut,
    sessionId: e._sessionId,
    lastEventTime: e._lastEventTime,
    eventId: e._eventId,
    identifyId: e._identifyId,
    sequenceNumber: e._sequenceNumber
  };
  e._useOldCookie ? e.cookieStorage.set(e.options.cookieName + e._storageSuffix, r12) : e._metadataStorage.save(r12);
};
xe.prototype._initUtmData = function(e, r12) {
  e = e || this._getUrlParams(), r12 = r12 || this.cookieStorage.get("__utmz");
  var n12 = Fz1(r12, e);
  return cd(this, n12), n12;
};
xe.prototype._unsetUTMParams = function() {
  var e = new L1();
  e.unset(Pe.REFERRER), e.unset(Pe.REFERRING_DOMAIN), e.unset(Pe.UTM_SOURCE), e.unset(Pe.UTM_MEDIUM), e.unset(Pe.UTM_CAMPAIGN), e.unset(Pe.UTM_TERM), e.unset(Pe.UTM_CONTENT), this.identify(e);
};
var cd = function(e, r12) {
  if (!(s0(r12) !== "object" || Object.keys(r12).length === 0)) {
    var n12 = new L1();
    for (var a in r12)
      Object.prototype.hasOwnProperty.call(r12, a) && (n12.setOnce("initial_" + a, r12[a]), n12.set(a, r12[a]));
    e.identify(n12);
  }
};
xe.prototype._getReferrer = function() {
  var e = this._getReferrerFromUrlParam(this._getUrlParams());
  return e || (typeof document < "u" ? document.referrer : "");
};
xe.prototype._getUrlParams = function() {
  return P0.location.search;
};
xe.prototype._saveGclid = function(e) {
  var r12 = _e.getQueryParam("gclid", e);
  if (!_e.isEmptyString(r12)) {
    var n12 = {
      gclid: r12
    };
    return cd(this, n12), n12;
  }
};
xe.prototype._saveFbclid = function(e) {
  var r12 = _e.getQueryParam("fbclid", e);
  if (!_e.isEmptyString(r12)) {
    var n12 = {
      fbclid: r12
    };
    return cd(this, n12), n12;
  }
};
xe.prototype._getDeviceIdFromUrlParam = function(e) {
  return _e.getQueryParam(Pe.AMP_DEVICE_ID_PARAM, e);
};
xe.prototype._getReferrerFromUrlParam = function(e) {
  return _e.getQueryParam(Pe.AMP_REFERRER_PARAM, e);
};
xe.prototype._getReferringDomain = function(e) {
  if (_e.isEmptyString(e))
    return null;
  var r12 = e.split("/");
  return r12.length >= 3 ? r12[2] : null;
};
xe.prototype._saveReferrer = function(e) {
  if (!_e.isEmptyString(e)) {
    var r12 = {
      referrer: e,
      referring_domain: this._getReferringDomain(e)
    };
    return cd(this, r12), r12;
  }
};
xe.prototype.saveEvents = function() {
  try {
    var e = JSON.stringify(this._unsentEvents.map(function(n12) {
      var a = n12.event;
      return a;
    }));
    this._setInStorage(Kr, this.options.unsentKey, e);
  } catch {
  }
  try {
    var r12 = JSON.stringify(this._unsentIdentifys.map(function(n12) {
      return n12.event;
    }));
    this._setInStorage(Kr, this.options.unsentIdentifyKey, r12);
  } catch {
  }
};
xe.prototype.setDomain = function(e) {
  if (this._shouldDeferCall())
    return this._q.push(["setDomain"].concat(Array.prototype.slice.call(arguments, 0)));
  if (_e.validateInput(e, "domain", "string"))
    try {
      this.cookieStorage.options({
        expirationDays: this.options.cookieExpiration,
        secure: this.options.secureCookie,
        domain: e,
        sameSite: this.options.sameSiteCookie
      }), this.options.domain = this.cookieStorage.options().domain, E1e(this), Oa(this);
    } catch (r12) {
      _e.log.error(r12);
    }
};
xe.prototype.setUserId = function(e) {
  var r12 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  if (_e.validateInput(r12, "startNewSession", "boolean")) {
    if (this._shouldDeferCall())
      return this._q.push(["setUserId"].concat(Array.prototype.slice.call(arguments, 0)));
    try {
      this.options.userId = e != null && "" + e || null, r12 && (this.options.unsetParamsReferrerOnNewSession && this._unsetUTMParams(), this._newSession = true, this._sessionId = (/* @__PURE__ */ new Date()).getTime(), this._runNewSessionStartCallbacks(), this.options.saveParamsReferrerOncePerSession && this._trackParamsAndReferrer()), Oa(this), this._connector && this._connector.identityStore.editIdentity().setUserId(this.options.userId).commit();
    } catch (n12) {
      _e.log.error(n12);
    }
  }
};
xe.prototype.setGroup = function(t16, e) {
  if (this._shouldDeferCall())
    return this._q.push(["setGroup"].concat(Array.prototype.slice.call(arguments, 0)));
  if (!(!this._apiKeySet("setGroup()") || !_e.validateInput(t16, "groupType", "string") || _e.isEmptyString(t16))) {
    var r12 = {};
    r12[t16] = e;
    var n12 = new L1().set(t16, e);
    this._logEvent(Pe.IDENTIFY_EVENT, null, null, n12.userPropertiesOperations, r12, null, null, null);
  }
};
xe.prototype.setOptOut = function(e) {
  if (this._shouldDeferCall())
    return this._q.push(["setOptOut"].concat(Array.prototype.slice.call(arguments, 0)));
  if (_e.validateInput(e, "enable", "boolean"))
    try {
      this.options.optOut = e, Oa(this);
    } catch (r12) {
      _e.log.error(r12);
    }
};
xe.prototype.setSessionId = function(e) {
  if (_e.validateInput(e, "sessionId", "number"))
    try {
      this._sessionId = e, Oa(this);
    } catch (r12) {
      _e.log.error(r12);
    }
};
xe.prototype.resetSessionId = function() {
  this.setSessionId((/* @__PURE__ */ new Date()).getTime());
};
xe.prototype.regenerateDeviceId = function() {
  if (this._shouldDeferCall())
    return this._q.push(["regenerateDeviceId"].concat(Array.prototype.slice.call(arguments, 0)));
  this.setDeviceId(I1e());
};
xe.prototype.setDeviceId = function(e) {
  if (this._shouldDeferCall())
    return this._q.push(["setDeviceId"].concat(Array.prototype.slice.call(arguments, 0)));
  if (_e.validateDeviceId(e))
    try {
      _e.isEmptyString(e) || (this.options.deviceId = "" + e, Oa(this), this._connector && this._connector.identityStore.editIdentity().setDeviceId(this.options.deviceId).commit());
    } catch (r12) {
      _e.log.error(r12);
    }
};
xe.prototype.setTransport = function(e) {
  if (this._shouldDeferCall())
    return this._q.push(["setTransport"].concat(Array.prototype.slice.call(arguments, 0)));
  _e.validateTransport(e) && (this.options.transport = e);
};
xe.prototype.setUserProperties = function(e) {
  if (this._shouldDeferCall())
    return this._q.push(["setUserProperties"].concat(Array.prototype.slice.call(arguments, 0)));
  if (!(!this._apiKeySet("setUserProperties()") || !_e.validateInput(e, "userProperties", "object"))) {
    var r12 = _e.truncate(_e.validateProperties(e));
    if (Object.keys(r12).length !== 0) {
      var n12 = new L1();
      for (var a in r12)
        Object.prototype.hasOwnProperty.call(r12, a) && n12.set(a, r12[a]);
      this.identify(n12);
    }
  }
};
xe.prototype.clearUserProperties = function() {
  if (this._shouldDeferCall())
    return this._q.push(["clearUserProperties"].concat(Array.prototype.slice.call(arguments, 0)));
  if (this._apiKeySet("clearUserProperties()")) {
    var e = new L1();
    e.clearAll(), this.identify(e);
  }
};
var L1e = function(e, r12) {
  for (var n12 = 0; n12 < r12._q.length; n12++) {
    var a = e[r12._q[n12][0]];
    s0(a) === "function" && a.apply(e, r12._q[n12].slice(1));
  }
  return e;
};
xe.prototype.identify = function(t16, e, r12, n12) {
  if (this._shouldDeferCall())
    return this._q.push(["identify"].concat(Array.prototype.slice.call(arguments, 0)));
  if (!this._apiKeySet("identify()")) {
    at(e, r12, 0, "No request sent", {
      reason: "API key is not set"
    });
    return;
  }
  if (s0(t16) === "object" && Object.prototype.hasOwnProperty.call(t16, "_q") && (t16 = L1e(new L1(), t16)), t16 instanceof L1) {
    if (Object.keys(t16.userPropertiesOperations).length > 0)
      return this._logEvent(Pe.IDENTIFY_EVENT, null, null, t16.userPropertiesOperations, null, null, null, e, r12, n12);
    at(e, r12, 0, "No request sent", {
      reason: "No user property operations"
    });
  } else
    _e.log.error("Invalid identify input type. Expected Identify object but saw " + s0(t16)), at(e, r12, 0, "No request sent", {
      reason: "Invalid identify input type"
    });
};
xe.prototype.groupIdentify = function(t16, e, r12, n12, a, o) {
  if (this._shouldDeferCall())
    return this._q.push(["groupIdentify"].concat(Array.prototype.slice.call(arguments, 0)));
  if (!this._apiKeySet("groupIdentify()")) {
    at(n12, a, 0, "No request sent", {
      reason: "API key is not set"
    });
    return;
  }
  if (!_e.validateInput(t16, "group_type", "string") || _e.isEmptyString(t16)) {
    at(n12, a, 0, "No request sent", {
      reason: "Invalid group type"
    });
    return;
  }
  if (e == null) {
    at(n12, a, 0, "No request sent", {
      reason: "Invalid group name"
    });
    return;
  }
  if (s0(r12) === "object" && Object.prototype.hasOwnProperty.call(r12, "_q") && (r12 = L1e(new L1(), r12)), r12 instanceof L1) {
    if (Object.keys(r12.userPropertiesOperations).length > 0)
      return this._logEvent(Pe.GROUP_IDENTIFY_EVENT, null, null, null, ii({}, t16, e), r12.userPropertiesOperations, null, n12, a, o);
    at(n12, a, 0, "No request sent", {
      reason: "No group property operations"
    });
  } else
    _e.log.error("Invalid identify input type. Expected Identify object but saw " + s0(r12)), at(n12, a, 0, "No request sent", {
      reason: "Invalid identify input type"
    });
};
xe.prototype.setVersionName = function(e) {
  if (this._shouldDeferCall())
    return this._q.push(["setVersionName"].concat(Array.prototype.slice.call(arguments, 0)));
  _e.validateInput(e, "versionName", "string") && (this.options.versionName = e);
};
xe.prototype._logEvent = function(e, r12, n12, a, o, i, u, s12, c, l2) {
  if (E1e(this), !e) {
    at(s12, c, 0, "No request sent", {
      reason: "Missing eventType"
    });
    return;
  }
  if (this.options.optOut) {
    at(s12, c, 0, "No request sent", {
      reason: "optOut is set to true"
    });
    return;
  }
  try {
    var f;
    e === Pe.IDENTIFY_EVENT || e === Pe.GROUP_IDENTIFY_EVENT ? f = this.nextIdentifyId() : f = this.nextEventId();
    var p = this.nextSequenceNumber(), d = s0(u) === "number" ? u : (/* @__PURE__ */ new Date()).getTime();
    l2 ? this._sessionId = -1 : (!this._sessionId || !this._lastEventTime || d - this._lastEventTime > this.options.sessionTimeout) && (this._sessionId = d, this._runNewSessionStartCallbacks()), this._lastEventTime = d, Oa(this);
    var b = this._ua.browser.name, z = this._ua.browser.major, _ = this._ua.device.model || this._ua.os.name, q = this._ua.device.vendor;
    a = a || {};
    var S = pt({}, this._apiPropertiesTrackingOptions);
    n12 = pt(pt({}, n12 || {}), S), r12 = r12 || {}, o = o || {}, i = i || {};
    var N = {
      device_id: this.options.deviceId,
      user_id: this.options.userId,
      timestamp: d,
      event_id: f,
      session_id: this._sessionId || -1,
      event_type: e,
      version_name: this.options.versionName || null,
      platform: uo(this, "platform") ? this.options.platform : null,
      os_name: uo(this, "os_name") && b || null,
      os_version: uo(this, "os_version") && z || null,
      device_model: uo(this, "device_model") && _ || null,
      device_manufacturer: uo(this, "device_manufacturer") && q || null,
      language: uo(this, "language") ? this.options.language : null,
      api_properties: n12,
      event_properties: _e.truncate(_e.validateProperties(r12)),
      user_properties: _e.truncate(_e.validateProperties(a)),
      uuid: tA1(),
      library: this.options.library,
      sequence_number: p,
      // for ordering events and identifys
      groups: _e.truncate(_e.validateGroups(o)),
      group_properties: _e.truncate(_e.validateProperties(i)),
      user_agent: this._userAgent,
      partner_id: this.options.partnerId || null
    };
    return sA1(this) && (N.plan = {
      branch: this.options.plan.branch || void 0,
      source: this.options.plan.source || void 0,
      version: this.options.plan.version || void 0,
      versionId: this.options.plan.versionId || void 0
    }), cA1(this) && (N.ingestion_metadata = {
      source_name: this.options.ingestionMetadata.sourceName || void 0,
      source_version: this.options.ingestionMetadata.sourceVersion || void 0
    }), e === Pe.IDENTIFY_EVENT || e === Pe.GROUP_IDENTIFY_EVENT ? (this._unsentIdentifys.push({
      event: N,
      callback: s12,
      errorCallback: c
    }), this._limitEventsQueued(this._unsentIdentifys)) : (this._unsentEvents.push({
      event: N,
      callback: s12,
      errorCallback: c
    }), this._limitEventsQueued(this._unsentEvents)), this.options.saveEvents && this.saveEvents(), this._sendEventsIfReady(), e === Pe.IDENTIFY_EVENT && this._connector && this._connector.identityStore.editIdentity().updateUserProperties(_e.truncate(_e.validateProperties(a))).commit(), f;
  } catch (v) {
    _e.log.error(v);
  }
};
var sA1 = function(e) {
  return e.options.plan && (e.options.plan.source || e.options.plan.branch || e.options.plan.version || e.options.plan.versionId);
}, cA1 = function(e) {
  return e.options.ingestionMetadata && (e.options.ingestionMetadata.sourceName || e.options.ingestionMetadata.sourceVersion);
}, uo = function(e, r12) {
  return !!e.options.trackingOptions[r12];
}, lA1 = function(e) {
  for (var r12 = ["city", "country", "dma", "ip_address", "region"], n12 = {}, a = 0; a < r12.length; a++) {
    var o = r12[a];
    uo(e, o) || (n12[o] = false);
  }
  return n12;
};
xe.prototype._limitEventsQueued = function(e) {
  if (e.length > this.options.savedMaxCount) {
    var r12 = e.splice(0, e.length - this.options.savedMaxCount);
    r12.forEach(function(n12) {
      at(n12.callback, n12.errorCallback, 0, "No request sent", {
        reason: "Event dropped because options.savedMaxCount exceeded. User may be offline or have a content blocker"
      });
    });
  }
};
xe.prototype.logEvent = function(e, r12, n12, a) {
  var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
  return this._shouldDeferCall() ? this._q.push(["logEvent"].concat(Array.prototype.slice.call(arguments, 0))) : this.logEventWithTimestamp(e, r12, null, n12, a, o);
};
xe.prototype.logEventWithTimestamp = function(e, r12, n12, a, o) {
  var i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
  return this._shouldDeferCall() ? this._q.push(["logEventWithTimestamp"].concat(Array.prototype.slice.call(arguments, 0))) : this._apiKeySet("logEvent()") ? _e.validateInput(e, "eventType", "string") ? _e.isEmptyString(e) ? (at(a, o, 0, "No request sent", {
    reason: "Missing eventType"
  }), -1) : (_e.validateInput(i, "outOfSession", "boolean") || at(a, o, 0, "No request sent", {
    reason: "Invalid outOfSession value"
  }), this._logEvent(e, r12, null, null, null, null, n12, a, o, i)) : (at(a, o, 0, "No request sent", {
    reason: "Invalid type for eventType"
  }), -1) : (at(a, o, 0, "No request sent", {
    reason: "API key not set"
  }), -1);
};
xe.prototype.logEventWithGroups = function(t16, e, r12, n12, a) {
  var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
  return this._shouldDeferCall() ? this._q.push(["logEventWithGroups"].concat(Array.prototype.slice.call(arguments, 0))) : this._apiKeySet("logEventWithGroups()") ? _e.validateInput(t16, "eventType", "string") ? (_e.validateInput(o, "outOfSession", "boolean") || at(event.callback, event.errorCallback, 0, "No request sent", {
    reason: "Invalid outOfSession value"
  }), this._logEvent(t16, e, null, null, r12, null, null, n12, a, o)) : (at(event.callback, event.errorCallback, 0, "No request sent", {
    reason: "Invalid type for eventType"
  }), -1) : (at(event.callback, event.errorCallback, 0, "No request sent", {
    reason: "API key not set"
  }), -1);
};
var UFe = function(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}, at = function(e, r12, n12, a, o) {
  s0(e) === "function" && e(n12, a, o), s0(r12) === "function" && r12(n12, a, o);
};
xe.prototype.logRevenueV2 = function(e) {
  if (this._shouldDeferCall())
    return this._q.push(["logRevenueV2"].concat(Array.prototype.slice.call(arguments, 0)));
  if (this._apiKeySet("logRevenueV2()"))
    if (s0(e) === "object" && Object.prototype.hasOwnProperty.call(e, "_q") && (e = L1e(new nn(), e)), e instanceof nn) {
      if (e && e._isValidRevenue())
        return this.logEvent(Pe.REVENUE_EVENT, e._toJSONObject());
    } else
      _e.log.error("Invalid revenue input type. Expected Revenue object but saw " + s0(e));
};
xe.prototype.logRevenue = function(e, r12, n12) {
  return this._shouldDeferCall() ? this._q.push(["logRevenue"].concat(Array.prototype.slice.call(arguments, 0))) : !this._apiKeySet("logRevenue()") || !UFe(e) || r12 !== void 0 && !UFe(r12) ? -1 : this._logEvent(Pe.REVENUE_EVENT, {}, {
    productId: n12,
    special: "revenue_amount",
    quantity: r12 || 1,
    price: e
  }, null, null, null, null, null);
};
xe.prototype._logErrorsOnEvents = function(e, r12, n12, a) {
  for (var o = ["_unsentEvents", "_unsentIdentifys"], i = 0; i < o.length; i++)
    for (var u = o[i], s12 = u === "_unsentEvents" ? e : r12, c = 0; c < this[u].length; c++) {
      var l2 = this[u][c];
      l2.event.event_id <= s12 && l2.errorCallback && l2.errorCallback(n12, a);
    }
};
xe.prototype.removeEvents = function(e, r12, n12, a) {
  kFe(this, "_unsentEvents", e, n12, a), kFe(this, "_unsentIdentifys", r12, n12, a);
};
var kFe = function(e, r12, n12, a, o) {
  if (!(n12 < 0)) {
    for (var i = [], u = 0; u < e[r12].length; u++) {
      var s12 = e[r12][u];
      s12.event.event_id > n12 ? i.push(s12) : s12.callback && s12.callback(a, o);
    }
    e[r12] = i;
  }
};
xe.prototype.sendEvents = function() {
  if (!this._apiKeySet("sendEvents()")) {
    this.removeEvents(1 / 0, 1 / 0, 0, "No request sent", {
      reason: "API key not set"
    });
    return;
  }
  if (this.options.optOut) {
    this.removeEvents(1 / 0, 1 / 0, 0, "No request sent", {
      reason: "Opt out is set to true"
    });
    return;
  }
  if (this._unsentCount() !== 0) {
    if (this.options.transport !== Pe.TRANSPORT_BEACON) {
      if (this._sending)
        return;
      this._sending = true;
    }
    var e = this.options.forceHttps || P0.location.protocol === "https:" ? "https" : "http", r12 = e + "://" + this.options.apiEndpoint, n12 = Math.min(this._unsentCount(), this.options.uploadBatchSize), a = this._mergeEventsAndIdentifys(n12), o = a.maxEventId, i = a.maxIdentifyId, u = JSON.stringify(a.eventsToSend.map(function(b) {
      var z = b.event;
      return z;
    })), s12 = (/* @__PURE__ */ new Date()).getTime(), c = {
      client: this.options.apiKey,
      e: u,
      v: Pe.API_VERSION,
      upload_time: s12,
      checksum: x31(Pe.API_VERSION + this.options.apiKey + u + s12)
    };
    if (this.options.transport === Pe.TRANSPORT_BEACON && typeof navigator < "u") {
      var l2 = navigator.sendBeacon(r12, new URLSearchParams(c));
      l2 ? (this.removeEvents(o, i, 200, "success"), this.options.saveEvents && this.saveEvents()) : this._logErrorsOnEvents(o, i, 0, "");
      return;
    }
    var f = this;
    try {
      new CKe(r12, c, this.options.headers).send(function(b, z) {
        f._sending = false;
        try {
          b === 200 ? (f.removeEvents(o, i, b, z), f.options.saveEvents && f.saveEvents(), f._sendEventsIfReady()) : (f._logErrorsOnEvents(o, i, b, z), b === 413 && (f.options.uploadBatchSize === 1 && f.removeEvents(o, i, b, z), f.options.uploadBatchSize = Math.ceil(n12 / 2), f.sendEvents()));
        } catch {
        }
      });
    } catch (b) {
      var p = 0, d = "Request failed to send";
      _e.log.error(d), f._logErrorsOnEvents(o, i, p, d), f.removeEvents(o, i, p, d, {
        reason: b.message
      });
    }
  }
};
xe.prototype._mergeEventsAndIdentifys = function(e) {
  for (var r12 = [], n12 = 0, a = -1, o = 0, i = -1; r12.length < e; ) {
    var u = void 0, s12 = o >= this._unsentIdentifys.length, c = n12 >= this._unsentEvents.length;
    if (c && s12) {
      _e.log.error("Merging Events and Identifys, less events and identifys than expected");
      break;
    } else
      s12 ? (u = this._unsentEvents[n12++], a = u.event.event_id) : c ? (u = this._unsentIdentifys[o++], i = u.event.event_id) : !("sequence_number" in this._unsentEvents[n12].event) || this._unsentEvents[n12].event.sequence_number < this._unsentIdentifys[o].event.sequence_number ? (u = this._unsentEvents[n12++], a = u.event.event_id) : (u = this._unsentIdentifys[o++], i = u.event.event_id);
    r12.push(u);
  }
  return {
    eventsToSend: r12,
    maxEventId: a,
    maxIdentifyId: i
  };
};
xe.prototype.setGlobalUserProperties = function(e) {
  this.setUserProperties(e);
};
xe.prototype.__VERSION__ = function() {
  return this.options.library.version;
};
xe.prototype.setLibrary = function(e, r12) {
  e !== null && typeof e < "u" && (this.options.library.name = e), r12 !== null && typeof r12 < "u" && (this.options.library.version = r12);
};
xe.prototype._shouldDeferCall = function() {
  return this._pendingReadStorage || this._initializationDeferred;
};
xe.prototype._deferInitialization = function() {
  this._initializationDeferred = true, this._q.push(["init"].concat(Array.prototype.slice.call(arguments, 0)));
};
xe.prototype.enableTracking = function() {
  this._initializationDeferred = false, Oa(this), this.runQueuedFunctions();
};
xe.prototype._refreshDynamicConfig = function() {
  this.options.useDynamicConfig && BFe.refresh(this.options.serverZone, this.options.forceHttps, (function() {
    this.options.apiEndpoint = BFe.ingestionEndpoint;
  }).bind(this));
};
xe.prototype.getDeviceId = function() {
  return this.options.deviceId;
};
xe.prototype.getUserId = function() {
  return this.options.userId;
};
xe.prototype.setMinTimeBetweenSessionsMillis = function(e) {
  if (_e.validateInput(e, "timeInMillis", "number")) {
    if (this._shouldDeferCall())
      return this._q.push(["setMinTimeBetweenSessionsMillis"].concat(Array.prototype.slice.call(arguments, 0)));
    try {
      this.options.sessionTimeout = e;
    } catch (r12) {
      _e.log.error(r12);
    }
  }
};
xe.prototype.setEventUploadThreshold = function(e) {
  if (_e.validateInput(e, "eventUploadThreshold", "number")) {
    if (this._shouldDeferCall())
      return this._q.push(["setEventUploadThreshold"].concat(Array.prototype.slice.call(arguments, 0)));
    try {
      this.options.eventUploadThreshold = e;
    } catch (r12) {
      _e.log.error(r12);
    }
  }
};
xe.prototype.setUseDynamicConfig = function(e) {
  if (_e.validateInput(e, "useDynamicConfig", "boolean")) {
    if (this._shouldDeferCall())
      return this._q.push(["setUseDynamicConfig"].concat(Array.prototype.slice.call(arguments, 0)));
    try {
      this.options.useDynamicConfig = e, this._refreshDynamicConfig();
    } catch (r12) {
      _e.log.error(r12);
    }
  }
};
xe.prototype.setServerZone = function(e) {
  var r12 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  if (!(e !== So.EU && e !== So.US || !_e.validateInput(r12, "serverZoneBasedApi", "boolean"))) {
    if (this._shouldDeferCall())
      return this._q.push(["setServerZone"].concat(Array.prototype.slice.call(arguments, 0)));
    try {
      this.options.serverZone = e, this.options.serverZoneBasedApi = r12, r12 && (this.options.apiEndpoint = gKe(this.options.serverZone));
    } catch (n12) {
      _e.log.error(n12);
    }
  }
};
xe.prototype.setServerUrl = function(e) {
  if (_e.validateInput(e, "serverUrl", "string")) {
    if (this._shouldDeferCall())
      return this._q.push(["setServerUrl"].concat(Array.prototype.slice.call(arguments, 0)));
    try {
      this.options.apiEndpoint = e;
    } catch (r12) {
      _e.log.error(r12);
    }
  }
};
var e1 = function() {
  this.options = pt({}, ya), this._q = [], this._instances = {};
};
e1.prototype.Identify = L1;
e1.prototype.Revenue = nn;
e1.prototype.getInstance = function(e) {
  e = _e.isEmptyString(e) ? Pe.DEFAULT_INSTANCE : e.toLowerCase();
  var r12 = this._instances[e];
  return r12 === void 0 && (r12 = new xe(e), this._instances[e] = r12), r12;
};
e1.prototype.init = function(e, r12, n12, a) {
  this.getInstance().init(e, r12, n12, (function(o) {
    this.options = o.options, s0(a) === "function" && a(o);
  }).bind(this));
}, e1.prototype.isNewSession = function() {
  return this.getInstance().isNewSession();
}, e1.prototype.getSessionId = function() {
  return this.getInstance().getSessionId();
}, e1.prototype.nextEventId = function() {
  return this.getInstance().nextEventId();
}, e1.prototype.nextIdentifyId = function() {
  return this.getInstance().nextIdentifyId();
}, e1.prototype.nextSequenceNumber = function() {
  return this.getInstance().nextSequenceNumber();
}, e1.prototype.saveEvents = function() {
  this.getInstance().saveEvents();
}, e1.prototype.setDomain = function(e) {
  this.getInstance().setDomain(e);
}, e1.prototype.setUserId = function(e) {
  this.getInstance().setUserId(e);
}, e1.prototype.setGroup = function(t16, e) {
  this.getInstance().setGroup(t16, e);
}, e1.prototype.setOptOut = function(e) {
  this.getInstance().setOptOut(e);
}, e1.prototype.regenerateDeviceId = function() {
  this.getInstance().regenerateDeviceId();
}, e1.prototype.setDeviceId = function(e) {
  this.getInstance().setDeviceId(e);
}, e1.prototype.setUserProperties = function(e) {
  this.getInstance().setUserProperties(e);
}, e1.prototype.clearUserProperties = function() {
  this.getInstance().clearUserProperties();
}, e1.prototype.identify = function(t16, e) {
  this.getInstance().identify(t16, e);
}, e1.prototype.setVersionName = function(e) {
  this.getInstance().setVersionName(e);
}, e1.prototype.logEvent = function(e, r12, n12) {
  return this.getInstance().logEvent(e, r12, n12);
}, e1.prototype.logEventWithGroups = function(t16, e, r12, n12) {
  return this.getInstance().logEventWithGroups(t16, e, r12, n12);
}, e1.prototype.logRevenueV2 = function(e) {
  return this.getInstance().logRevenueV2(e);
}, e1.prototype.logRevenue = function(e, r12, n12) {
  return this.getInstance().logRevenue(e, r12, n12);
}, e1.prototype.removeEvents = function(e, r12) {
  this.getInstance().removeEvents(e, r12);
}, e1.prototype.sendEvents = function(e) {
  this.getInstance().sendEvents(e);
}, e1.prototype.setGlobalUserProperties = function(e) {
  this.getInstance().setUserProperties(e);
};
e1.prototype.__VERSION__ = IKe;
var d2 = typeof P0 < "u" && P0.amplitude || {}, ui = new e1();
ui._q = d2._q || [];
for (var IQ in d2._iq)
  Object.prototype.hasOwnProperty.call(d2._iq, IQ) && (ui.getInstance(IQ)._q = d2._iq[IQ]._q || []);
/* @__PURE__ */ ref(new fe.PromiseObject());
Er.create({ base: "" }, (t16) => ({
  async getUserInfo(e) {
    return await t16.get("/user", { product: e });
  },
  async getTrackingInfo(e) {
    return await t16.get("/tracking", { product: e });
  }
}));
({
  [L0.Pending]: "Processing",
  [L0.NeedsReview]: "Needs review",
  [L0.InReview]: "In review",
  [L0.Error]: "Error",
  [L0.Duplicate]: "Duplicate",
  [L0.Rejected]: "Rejected",
  [L0.Sent]: "Sent",
  [L0.Deleted]: "Deleted"
});
({
  [L0.Pending]: "blue",
  [L0.NeedsReview]: "warning",
  [L0.InReview]: "blue",
  [L0.Error]: "error",
  [L0.Duplicate]: "error",
  [L0.Rejected]: "error",
  [L0.Sent]: "blue",
  [L0.Deleted]: "error"
});
const ca = Er.create({ base: "/staging-records" }, (t16) => ({
  async getStagingRecord(e, r12) {
    return await t16.get("/:id", { product: e, id: r12 });
  },
  async updateStagingRecord(e, r12, n12) {
    return await t16.patch("/:id", n12, { product: e, id: r12 });
  },
  async searchStagingRecords(e, r12, n12) {
    return await t16.post("", r12, { product: e, ...n12 });
  },
  async deleteStagingRecord(e, r12) {
    return await t16.delete("/:id", { product: e, id: r12 });
  },
  async propertySearch(e, r12, n12, a) {
    return await t16.post("/:id/property/search", a, {
      product: e,
      id: r12,
      ...n12
    });
  },
  async validateStagingRecord(e, r12) {
    return await t16.post("/:id/validate", {}, { product: e, id: r12 });
  },
  async getRecordConfig(e, r12) {
    return await t16.get("/:id/config", {
      product: e,
      id: r12
    });
  },
  async sendStagingRecord(e, r12, n12) {
    return await t16.post("/:id/send", n12, { product: e, id: r12 });
  }
}));
const {
  entries: PKe,
  setPrototypeOf: FFe,
  isFrozen: t_1,
  getPrototypeOf: r_1,
  getOwnPropertyDescriptor: n_1
} = Object;
let {
  freeze: Dt,
  seal: Tr,
  create: DKe
} = Object, {
  apply: Aee,
  construct: _ee
} = typeof Reflect < "u" && Reflect;
Dt || (Dt = function(e) {
  return e;
});
Tr || (Tr = function(e) {
  return e;
});
Aee || (Aee = function(e, r12, n12) {
  return e.apply(r12, n12);
});
_ee || (_ee = function(e, r12) {
  return new e(...r12);
});
const Bl = ur(Array.prototype.forEach), VFe = ur(Array.prototype.pop), Yu = ur(Array.prototype.push), f2 = ur(String.prototype.toLowerCase), EQ = ur(String.prototype.toString), HFe = ur(String.prototype.match), Ju = ur(String.prototype.replace), a_1 = ur(String.prototype.indexOf), o_1 = ur(String.prototype.trim), jr = ur(Object.prototype.hasOwnProperty), gt = ur(RegExp.prototype.test), Ku = i_1(TypeError);
function ur(t16) {
  return function(e) {
    for (var r12 = arguments.length, n12 = new Array(r12 > 1 ? r12 - 1 : 0), a = 1; a < r12; a++)
      n12[a - 1] = arguments[a];
    return Aee(t16, e, n12);
  };
}
function i_1(t16) {
  return function() {
    for (var e = arguments.length, r12 = new Array(e), n12 = 0; n12 < e; n12++)
      r12[n12] = arguments[n12];
    return _ee(t16, r12);
  };
}
function w0(t16, e) {
  let r12 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : f2;
  FFe && FFe(t16, null);
  let n12 = e.length;
  for (; n12--; ) {
    let a = e[n12];
    if (typeof a == "string") {
      const o = r12(a);
      o !== a && (t_1(e) || (e[n12] = o), a = o);
    }
    t16[a] = true;
  }
  return t16;
}
function u_1(t16) {
  for (let e = 0; e < t16.length; e++)
    jr(t16, e) || (t16[e] = null);
  return t16;
}
function so(t16) {
  const e = DKe(null);
  for (const [r12, n12] of PKe(t16))
    jr(t16, r12) && (Array.isArray(n12) ? e[r12] = u_1(n12) : n12 && typeof n12 == "object" && n12.constructor === Object ? e[r12] = so(n12) : e[r12] = n12);
  return e;
}
function Qu(t16, e) {
  for (; t16 !== null; ) {
    const n12 = n_1(t16, e);
    if (n12) {
      if (n12.get)
        return ur(n12.get);
      if (typeof n12.value == "function")
        return ur(n12.value);
    }
    t16 = r_1(t16);
  }
  function r12() {
    return null;
  }
  return r12;
}
const XFe = Dt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), LQ = Dt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), PQ = Dt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), s_1 = Dt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), DQ = Dt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), c_1 = Dt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), $Fe = Dt(["#text"]), GFe = Dt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), WQ = Dt(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), YFe = Dt(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), xl = Dt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), l_1 = Tr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), p_1 = Tr(/<%[\w\W]*|[\w\W]*%>/gm), d_1 = Tr(/\${[\w\W]*}/gm), f_1 = Tr(/^data-[\-\w.\u00B7-\uFFFF]/), b_1 = Tr(/^aria-[\-\w]+$/), WKe = Tr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), M_1 = Tr(/^(?:\w+script|data):/i), O_1 = Tr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), NKe = Tr(/^html$/i), z_1 = Tr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var JFe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: l_1,
  ERB_EXPR: p_1,
  TMPLIT_EXPR: d_1,
  DATA_ATTR: f_1,
  ARIA_ATTR: b_1,
  IS_ALLOWED_URI: WKe,
  IS_SCRIPT_OR_DATA: M_1,
  ATTR_WHITESPACE: O_1,
  DOCTYPE_NAME: NKe,
  CUSTOM_ELEMENT: z_1
});
const Zu = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, A_1 = function() {
  return typeof window > "u" ? null : window;
}, __1 = function(e, r12) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let n12 = null;
  const a = "data-tt-policy-suffix";
  r12 && r12.hasAttribute(a) && (n12 = r12.getAttribute(a));
  const o = "dompurify" + (n12 ? "#" + n12 : "");
  try {
    return e.createPolicy(o, {
      createHTML(i) {
        return i;
      },
      createScriptURL(i) {
        return i;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + o + " could not be created."), null;
  }
};
function wKe() {
  let t16 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : A_1();
  const e = (r0) => wKe(r0);
  if (e.version = "3.1.6", e.removed = [], !t16 || !t16.document || t16.document.nodeType !== Zu.document)
    return e.isSupported = false, e;
  let {
    document: r12
  } = t16;
  const n12 = r12, a = n12.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: i,
    Node: u,
    Element: s12,
    NodeFilter: c,
    NamedNodeMap: l2 = t16.NamedNodeMap || t16.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: p,
    trustedTypes: d
  } = t16, b = s12.prototype, z = Qu(b, "cloneNode"), _ = Qu(b, "remove"), q = Qu(b, "nextSibling"), S = Qu(b, "childNodes"), N = Qu(b, "parentNode");
  if (typeof i == "function") {
    const r0 = r12.createElement("template");
    r0.content && r0.content.ownerDocument && (r12 = r0.content.ownerDocument);
  }
  let v, C = "";
  const {
    implementation: L,
    createNodeIterator: B,
    createDocumentFragment: P12,
    getElementsByTagName: j
  } = r12, {
    importNode: $
  } = n12;
  let W = {};
  e.isSupported = typeof PKe == "function" && typeof N == "function" && L && L.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: x,
    ERB_EXPR: D,
    TMPLIT_EXPR: w,
    DATA_ATTR: I,
    ARIA_ATTR: Y,
    IS_SCRIPT_OR_DATA: oe,
    ATTR_WHITESPACE: Z,
    CUSTOM_ELEMENT: se
  } = JFe;
  let {
    IS_ALLOWED_URI: Ie
  } = JFe, ie = null;
  const ye = w0({}, [...XFe, ...LQ, ...PQ, ...DQ, ...$Fe]);
  let ne = null;
  const k = w0({}, [...GFe, ...WQ, ...YFe, ...xl]);
  let K = Object.seal(DKe(null, {
    tagNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: false
    }
  })), G = null, Q = null, ce = true, ve = true, Re = false, le = true, Ae = false, H = true, re = false, ue = false, Me = false, Se = false, $e = false, a0 = false, Ne = true, Ye = false;
  const $0 = "user-content-";
  let Be = true, o0 = false, Ke = {}, I0 = null;
  const b0 = w0({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let P1 = null;
  const x0 = w0({}, ["audio", "video", "img", "source", "image", "track"]);
  let Mt = null;
  const H1 = w0({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Wt = "http://www.w3.org/1998/Math/MathML", Zt = "http://www.w3.org/2000/svg", be = "http://www.w3.org/1999/xhtml";
  let Ue = be, d0 = false, W0 = null;
  const E0 = w0({}, [Wt, Zt, be], EQ);
  let s1 = null;
  const Ot = ["application/xhtml+xml", "text/html"], sn = "text/html";
  let h1 = null, zt = null;
  const za = r12.createElement("form"), cn = function(ee) {
    return ee instanceof RegExp || ee instanceof Function;
  }, er = function() {
    let ee = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(zt && zt === ee)) {
      if ((!ee || typeof ee != "object") && (ee = {}), ee = so(ee), s1 = // eslint-disable-next-line unicorn/prefer-includes
      Ot.indexOf(ee.PARSER_MEDIA_TYPE) === -1 ? sn : ee.PARSER_MEDIA_TYPE, h1 = s1 === "application/xhtml+xml" ? EQ : f2, ie = jr(ee, "ALLOWED_TAGS") ? w0({}, ee.ALLOWED_TAGS, h1) : ye, ne = jr(ee, "ALLOWED_ATTR") ? w0({}, ee.ALLOWED_ATTR, h1) : k, W0 = jr(ee, "ALLOWED_NAMESPACES") ? w0({}, ee.ALLOWED_NAMESPACES, EQ) : E0, Mt = jr(ee, "ADD_URI_SAFE_ATTR") ? w0(
        so(H1),
        // eslint-disable-line indent
        ee.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        h1
        // eslint-disable-line indent
      ) : H1, P1 = jr(ee, "ADD_DATA_URI_TAGS") ? w0(
        so(x0),
        // eslint-disable-line indent
        ee.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        h1
        // eslint-disable-line indent
      ) : x0, I0 = jr(ee, "FORBID_CONTENTS") ? w0({}, ee.FORBID_CONTENTS, h1) : b0, G = jr(ee, "FORBID_TAGS") ? w0({}, ee.FORBID_TAGS, h1) : {}, Q = jr(ee, "FORBID_ATTR") ? w0({}, ee.FORBID_ATTR, h1) : {}, Ke = jr(ee, "USE_PROFILES") ? ee.USE_PROFILES : false, ce = ee.ALLOW_ARIA_ATTR !== false, ve = ee.ALLOW_DATA_ATTR !== false, Re = ee.ALLOW_UNKNOWN_PROTOCOLS || false, le = ee.ALLOW_SELF_CLOSE_IN_ATTR !== false, Ae = ee.SAFE_FOR_TEMPLATES || false, H = ee.SAFE_FOR_XML !== false, re = ee.WHOLE_DOCUMENT || false, Se = ee.RETURN_DOM || false, $e = ee.RETURN_DOM_FRAGMENT || false, a0 = ee.RETURN_TRUSTED_TYPE || false, Me = ee.FORCE_BODY || false, Ne = ee.SANITIZE_DOM !== false, Ye = ee.SANITIZE_NAMED_PROPS || false, Be = ee.KEEP_CONTENT !== false, o0 = ee.IN_PLACE || false, Ie = ee.ALLOWED_URI_REGEXP || WKe, Ue = ee.NAMESPACE || be, K = ee.CUSTOM_ELEMENT_HANDLING || {}, ee.CUSTOM_ELEMENT_HANDLING && cn(ee.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (K.tagNameCheck = ee.CUSTOM_ELEMENT_HANDLING.tagNameCheck), ee.CUSTOM_ELEMENT_HANDLING && cn(ee.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (K.attributeNameCheck = ee.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), ee.CUSTOM_ELEMENT_HANDLING && typeof ee.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (K.allowCustomizedBuiltInElements = ee.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Ae && (ve = false), $e && (Se = true), Ke && (ie = w0({}, $Fe), ne = [], Ke.html === true && (w0(ie, XFe), w0(ne, GFe)), Ke.svg === true && (w0(ie, LQ), w0(ne, WQ), w0(ne, xl)), Ke.svgFilters === true && (w0(ie, PQ), w0(ne, WQ), w0(ne, xl)), Ke.mathMl === true && (w0(ie, DQ), w0(ne, YFe), w0(ne, xl))), ee.ADD_TAGS && (ie === ye && (ie = so(ie)), w0(ie, ee.ADD_TAGS, h1)), ee.ADD_ATTR && (ne === k && (ne = so(ne)), w0(ne, ee.ADD_ATTR, h1)), ee.ADD_URI_SAFE_ATTR && w0(Mt, ee.ADD_URI_SAFE_ATTR, h1), ee.FORBID_CONTENTS && (I0 === b0 && (I0 = so(I0)), w0(I0, ee.FORBID_CONTENTS, h1)), Be && (ie["#text"] = true), re && w0(ie, ["html", "head", "body"]), ie.table && (w0(ie, ["tbody"]), delete G.tbody), ee.TRUSTED_TYPES_POLICY) {
        if (typeof ee.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Ku('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof ee.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Ku('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        v = ee.TRUSTED_TYPES_POLICY, C = v.createHTML("");
      } else
        v === void 0 && (v = __1(d, a)), v !== null && typeof C == "string" && (C = v.createHTML(""));
      Dt && Dt(ee), zt = ee;
    }
  }, No = w0({}, ["mi", "mo", "mn", "ms", "mtext"]), En = w0({}, ["foreignobject", "annotation-xml"]), Ln = w0({}, ["title", "style", "font", "a", "script"]), Fc = w0({}, [...LQ, ...PQ, ...s_1]), Vc = w0({}, [...DQ, ...c_1]), pd = function(ee) {
    let Le = N(ee);
    (!Le || !Le.tagName) && (Le = {
      namespaceURI: Ue,
      tagName: "template"
    });
    const Qe = f2(ee.tagName), r1 = f2(Le.tagName);
    return W0[ee.namespaceURI] ? ee.namespaceURI === Zt ? Le.namespaceURI === be ? Qe === "svg" : Le.namespaceURI === Wt ? Qe === "svg" && (r1 === "annotation-xml" || No[r1]) : !!Fc[Qe] : ee.namespaceURI === Wt ? Le.namespaceURI === be ? Qe === "math" : Le.namespaceURI === Zt ? Qe === "math" && En[r1] : !!Vc[Qe] : ee.namespaceURI === be ? Le.namespaceURI === Zt && !En[r1] || Le.namespaceURI === Wt && !No[r1] ? false : !Vc[Qe] && (Ln[Qe] || !Fc[Qe]) : !!(s1 === "application/xhtml+xml" && W0[ee.namespaceURI]) : false;
  }, tr = function(ee) {
    Yu(e.removed, {
      element: ee
    });
    try {
      N(ee).removeChild(ee);
    } catch {
      _(ee);
    }
  }, wo = function(ee, Le) {
    try {
      Yu(e.removed, {
        attribute: Le.getAttributeNode(ee),
        from: Le
      });
    } catch {
      Yu(e.removed, {
        attribute: null,
        from: Le
      });
    }
    if (Le.removeAttribute(ee), ee === "is" && !ne[ee])
      if (Se || $e)
        try {
          tr(Le);
        } catch {
        }
      else
        try {
          Le.setAttribute(ee, "");
        } catch {
        }
  }, Hc = function(ee) {
    let Le = null, Qe = null;
    if (Me)
      ee = "<remove></remove>" + ee;
    else {
      const y1 = HFe(ee, /^[\r\n\t ]+/);
      Qe = y1 && y1[0];
    }
    s1 === "application/xhtml+xml" && Ue === be && (ee = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + ee + "</body></html>");
    const r1 = v ? v.createHTML(ee) : ee;
    if (Ue === be)
      try {
        Le = new p().parseFromString(r1, s1);
      } catch {
      }
    if (!Le || !Le.documentElement) {
      Le = L.createDocument(Ue, "template", null);
      try {
        Le.documentElement.innerHTML = d0 ? C : r1;
      } catch {
      }
    }
    const et = Le.body || Le.documentElement;
    return ee && Qe && et.insertBefore(r12.createTextNode(Qe), et.childNodes[0] || null), Ue === be ? j.call(Le, re ? "html" : "body")[0] : re ? Le.documentElement : et;
  }, Xc = function(ee) {
    return B.call(
      ee.ownerDocument || ee,
      ee,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, $c = function(ee) {
    return ee instanceof f && (typeof ee.nodeName != "string" || typeof ee.textContent != "string" || typeof ee.removeChild != "function" || !(ee.attributes instanceof l2) || typeof ee.removeAttribute != "function" || typeof ee.setAttribute != "function" || typeof ee.namespaceURI != "string" || typeof ee.insertBefore != "function" || typeof ee.hasChildNodes != "function");
  }, Gc = function(ee) {
    return typeof u == "function" && ee instanceof u;
  }, lr = function(ee, Le, Qe) {
    W[ee] && Bl(W[ee], (r1) => {
      r1.call(e, Le, Qe, zt);
    });
  }, Yc = function(ee) {
    let Le = null;
    if (lr("beforeSanitizeElements", ee, null), $c(ee))
      return tr(ee), true;
    const Qe = h1(ee.nodeName);
    if (lr("uponSanitizeElement", ee, {
      tagName: Qe,
      allowedTags: ie
    }), ee.hasChildNodes() && !Gc(ee.firstElementChild) && gt(/<[/\w]/g, ee.innerHTML) && gt(/<[/\w]/g, ee.textContent) || ee.nodeType === Zu.progressingInstruction || H && ee.nodeType === Zu.comment && gt(/<[/\w]/g, ee.data))
      return tr(ee), true;
    if (!ie[Qe] || G[Qe]) {
      if (!G[Qe] && Nt(Qe) && (K.tagNameCheck instanceof RegExp && gt(K.tagNameCheck, Qe) || K.tagNameCheck instanceof Function && K.tagNameCheck(Qe)))
        return false;
      if (Be && !I0[Qe]) {
        const r1 = N(ee) || ee.parentNode, et = S(ee) || ee.childNodes;
        if (et && r1) {
          const y1 = et.length;
          for (let S1 = y1 - 1; S1 >= 0; --S1) {
            const wt = z(et[S1], true);
            wt.__removalCount = (ee.__removalCount || 0) + 1, r1.insertBefore(wt, q(ee));
          }
        }
      }
      return tr(ee), true;
    }
    return ee instanceof s12 && !pd(ee) || (Qe === "noscript" || Qe === "noembed" || Qe === "noframes") && gt(/<\/no(script|embed|frames)/i, ee.innerHTML) ? (tr(ee), true) : (Ae && ee.nodeType === Zu.text && (Le = ee.textContent, Bl([x, D, w], (r1) => {
      Le = Ju(Le, r1, " ");
    }), ee.textContent !== Le && (Yu(e.removed, {
      element: ee.cloneNode()
    }), ee.textContent = Le)), lr("afterSanitizeElements", ee, null), false);
  }, pr = function(ee, Le, Qe) {
    if (Ne && (Le === "id" || Le === "name") && (Qe in r12 || Qe in za))
      return false;
    if (!(ve && !Q[Le] && gt(I, Le))) {
      if (!(ce && gt(Y, Le))) {
        if (!ne[Le] || Q[Le]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Nt(ee) && (K.tagNameCheck instanceof RegExp && gt(K.tagNameCheck, ee) || K.tagNameCheck instanceof Function && K.tagNameCheck(ee)) && (K.attributeNameCheck instanceof RegExp && gt(K.attributeNameCheck, Le) || K.attributeNameCheck instanceof Function && K.attributeNameCheck(Le)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            Le === "is" && K.allowCustomizedBuiltInElements && (K.tagNameCheck instanceof RegExp && gt(K.tagNameCheck, Qe) || K.tagNameCheck instanceof Function && K.tagNameCheck(Qe)))
          )
            return false;
        } else if (!Mt[Le]) {
          if (!gt(Ie, Ju(Qe, Z, ""))) {
            if (!((Le === "src" || Le === "xlink:href" || Le === "href") && ee !== "script" && a_1(Qe, "data:") === 0 && P1[ee])) {
              if (!(Re && !gt(oe, Ju(Qe, Z, "")))) {
                if (Qe)
                  return false;
              }
            }
          }
        }
      }
    }
    return true;
  }, Nt = function(ee) {
    return ee !== "annotation-xml" && HFe(ee, se);
  }, Pn = function(ee) {
    lr("beforeSanitizeAttributes", ee, null);
    const {
      attributes: Le
    } = ee;
    if (!Le)
      return;
    const Qe = {
      attrName: "",
      attrValue: "",
      keepAttr: true,
      allowedAttributes: ne
    };
    let r1 = Le.length;
    for (; r1--; ) {
      const et = Le[r1], {
        name: y1,
        namespaceURI: S1,
        value: wt
      } = et, it = h1(y1);
      let tt2 = y1 === "value" ? wt : o_1(wt);
      if (Qe.attrName = it, Qe.attrValue = tt2, Qe.keepAttr = true, Qe.forceKeepAttr = void 0, lr("uponSanitizeAttribute", ee, Qe), tt2 = Qe.attrValue, H && gt(/((--!?|])>)|<\/(style|title)/i, tt2)) {
        wo(y1, ee);
        continue;
      }
      if (Qe.forceKeepAttr || (wo(y1, ee), !Qe.keepAttr))
        continue;
      if (!le && gt(/\/>/i, tt2)) {
        wo(y1, ee);
        continue;
      }
      Ae && Bl([x, D, w], (Qi) => {
        tt2 = Ju(tt2, Qi, " ");
      });
      const Lr = h1(ee.nodeName);
      if (pr(Lr, it, tt2)) {
        if (Ye && (it === "id" || it === "name") && (wo(y1, ee), tt2 = $0 + tt2), v && typeof d == "object" && typeof d.getAttributeType == "function" && !S1)
          switch (d.getAttributeType(Lr, it)) {
            case "TrustedHTML": {
              tt2 = v.createHTML(tt2);
              break;
            }
            case "TrustedScriptURL": {
              tt2 = v.createScriptURL(tt2);
              break;
            }
          }
        try {
          S1 ? ee.setAttributeNS(S1, y1, tt2) : ee.setAttribute(y1, tt2), $c(ee) ? tr(ee) : VFe(e.removed);
        } catch {
        }
      }
    }
    lr("afterSanitizeAttributes", ee, null);
  }, Ki = function r0(ee) {
    let Le = null;
    const Qe = Xc(ee);
    for (lr("beforeSanitizeShadowDOM", ee, null); Le = Qe.nextNode(); )
      lr("uponSanitizeShadowNode", Le, null), !Yc(Le) && (Le.content instanceof o && r0(Le.content), Pn(Le));
    lr("afterSanitizeShadowDOM", ee, null);
  };
  return e.sanitize = function(r0) {
    let ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Le = null, Qe = null, r1 = null, et = null;
    if (d0 = !r0, d0 && (r0 = "<!-->"), typeof r0 != "string" && !Gc(r0))
      if (typeof r0.toString == "function") {
        if (r0 = r0.toString(), typeof r0 != "string")
          throw Ku("dirty is not a string, aborting");
      } else
        throw Ku("toString is not a function");
    if (!e.isSupported)
      return r0;
    if (ue || er(ee), e.removed = [], typeof r0 == "string" && (o0 = false), o0) {
      if (r0.nodeName) {
        const wt = h1(r0.nodeName);
        if (!ie[wt] || G[wt])
          throw Ku("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (r0 instanceof u)
      Le = Hc("<!---->"), Qe = Le.ownerDocument.importNode(r0, true), Qe.nodeType === Zu.element && Qe.nodeName === "BODY" || Qe.nodeName === "HTML" ? Le = Qe : Le.appendChild(Qe);
    else {
      if (!Se && !Ae && !re && // eslint-disable-next-line unicorn/prefer-includes
      r0.indexOf("<") === -1)
        return v && a0 ? v.createHTML(r0) : r0;
      if (Le = Hc(r0), !Le)
        return Se ? null : a0 ? C : "";
    }
    Le && Me && tr(Le.firstChild);
    const y1 = Xc(o0 ? r0 : Le);
    for (; r1 = y1.nextNode(); )
      Yc(r1) || (r1.content instanceof o && Ki(r1.content), Pn(r1));
    if (o0)
      return r0;
    if (Se) {
      if ($e)
        for (et = P12.call(Le.ownerDocument); Le.firstChild; )
          et.appendChild(Le.firstChild);
      else
        et = Le;
      return (ne.shadowroot || ne.shadowrootmode) && (et = $.call(n12, et, true)), et;
    }
    let S1 = re ? Le.outerHTML : Le.innerHTML;
    return re && ie["!doctype"] && Le.ownerDocument && Le.ownerDocument.doctype && Le.ownerDocument.doctype.name && gt(NKe, Le.ownerDocument.doctype.name) && (S1 = "<!DOCTYPE " + Le.ownerDocument.doctype.name + `>
` + S1), Ae && Bl([x, D, w], (wt) => {
      S1 = Ju(S1, wt, " ");
    }), v && a0 ? v.createHTML(S1) : S1;
  }, e.setConfig = function() {
    let r0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    er(r0), ue = true;
  }, e.clearConfig = function() {
    zt = null, ue = false;
  }, e.isValidAttribute = function(r0, ee, Le) {
    zt || er({});
    const Qe = h1(r0), r1 = h1(ee);
    return pr(Qe, r1, Le);
  }, e.addHook = function(r0, ee) {
    typeof ee == "function" && (W[r0] = W[r0] || [], Yu(W[r0], ee));
  }, e.removeHook = function(r0) {
    if (W[r0])
      return VFe(W[r0]);
  }, e.removeHooks = function(r0) {
    W[r0] && (W[r0] = []);
  }, e.removeAllHooks = function() {
    W = {};
  }, e;
}
wKe();
const T_1 = { class: "text-sm" }, y_1 = {
  key: 0,
  class: "text-sm text-gray-500"
};
/* @__PURE__ */ defineComponent({
  __name: "form-lookup-input",
  props: {
    stagingRecordId: {},
    propertyName: {},
    editor: { type: Boolean },
    rootID: {},
    label: { default: Hn.label },
    message: { default: Hn.message },
    messageRight: { default: Hn.messageRight },
    required: { type: Boolean, default: Hn.required },
    isDisabled: { type: Boolean, default: S0.isDisabled },
    messageClasses: {},
    editorContainerClasses: {},
    animateMenuIcon: { type: Boolean, default: S0.animateMenuIcon },
    clearable: { type: Boolean, default: S0.clearable },
    filterable: { type: Boolean, default: S0.filterable },
    filterMode: {},
    focused: { default: S0.focused },
    getOptionById: {},
    loading: { type: Boolean },
    menuHeight: { default: S0.menuHeight },
    menuIcon: { default: S0.menuIcon },
    menuOffsetX: { default: -10 },
    menuOffsetY: { default: 6 },
    modelValue: { default: S0.modelValue },
    multiple: { type: Boolean, default: S0.multiple },
    noOptionsText: { default: S0.noOptionsText },
    optionLabelField: { default: S0.optionLabelField },
    options: { default: S0.options },
    optionValueField: { default: S0.optionValueField },
    placeholder: { default: S0.placeholder },
    returnValue: { type: Boolean },
    valid: { type: [Boolean, Function], default: S0.valid },
    triggerValidation: {},
    selectionMax: { default: S0.selectionMax },
    selectionMin: { default: S0.selectionMin },
    selectionMaxDisplayed: {},
    valueComparator: { type: Function, default: S0.valueComparator },
    reset: { default: S0.reset }
  },
  emits: ["update:modelValue"],
  setup(t16, { emit: e }) {
    const r12 = t16, n12 = e, a = inject("pendingChanges"), { loadAsync: o, asyncsLoading: i } = Gee(), u = St(), s12 = /* @__PURE__ */ ref(r12.modelValue ? [r12.modelValue] : []), c = new fe.Debouncer(300), l2 = computed({
      get() {
        return r12.modelValue;
      },
      set(z) {
        n12("update:modelValue", z);
      }
    }), f = computed(() => r12.editor ? gHe : Oc), p = async (z) => {
      const _ = {
        property: r12.propertyName,
        query: z,
        sort: q1e.LookupSortLabelDesc,
        pendingChanges: a.value,
        rootID: r12.rootID
      };
      try {
        c.run(async () => {
          try {
            const q = await o(
              ca.propertySearch(
                u.product,
                r12.stagingRecordId,
                { next: "", limit: 100 },
                _
              )
            );
            s12.value = so0(q.results, "value");
          } catch (q) {
            qt(q, "There was an unexpected error loading lookup data.");
          }
        });
      } catch (q) {
        qt(q, "There was an unexpected error loading the lookup data.");
      }
    }, d = /* @__PURE__ */ ref(false), b = () => {
      var z;
      d.value || (d.value = true, p(((z = l2.value) == null ? void 0 : z.label) || ""));
    };
    return watch(
      () => a,
      () => {
        d.value = false;
      },
      { deep: true, immediate: true }
    ), (z, _) => (openBlock(), createBlock(resolveDynamicComponent(unref(f)), mergeProps(z.$props, {
      modelValue: unref(l2),
      "onUpdate:modelValue": _[0] || (_[0] = (q) => /* @__PURE__ */ isRef(l2) ? l2.value = q : null),
      options: unref(s12),
      "filter-mode": "remote",
      loading: unref(i),
      clearable: "",
      "onInput:filter": p,
      onFocusin: b,
      onClear: _[1] || (_[1] = (q) => p(q)),
      "onClick:clear": _[2] || (_[2] = (q) => p(q))
    }), {
      option: withCtx(({ option: q }) => [
        createBaseVNode("div", null, [
          createBaseVNode("div", T_1, toDisplayString(q.raw.label), 1),
          q.raw.sublabel ? (openBlock(), createElementBlock("div", y_1, toDisplayString(q.raw.sublabel), 1)) : createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 16, ["modelValue", "options", "loading"]));
  }
});
Er.create({ base: "/upload" }, (t16) => ({
  async uploadDocument(e, r12, n12) {
    const a = new FormData();
    for (let i = 0; i < r12.length; i++)
      if (r12[i].name.endsWith(".zip")) {
        const u = new Blob([r12[i]], { type: "application/zip" });
        a.append("file", u, r12[i].name);
      } else
        a.append("file", r12[i]);
    return await t16.post(
      "",
      a,
      { product: e },
      {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: (i) => {
          n12 && n12(i.loaded / i.total * 100);
        }
      }
    );
  },
  async uploadDocumentToExisting(e, r12, n12, a, o) {
    const i = new FormData();
    for (let s12 = 0; s12 < r12.length; s12++)
      if (r12[s12].name.endsWith(".zip")) {
        const c = new Blob([r12[s12]], { type: "application/zip" });
        i.append("file", c, r12[s12].name);
      } else
        i.append("file", r12[s12]);
    return await t16.post(
      "/:stagingRecordId",
      i,
      { product: e, stagingRecordId: n12 },
      {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: (s12) => {
          a && a(s12.loaded / s12.total * 100);
        }
      },
      o
    );
  }
}));
Er.create({ base: "/documents" }, (t16) => ({
  async delete(e, r12) {
    return await t16.delete("/:documentID", { product: e, documentID: r12 });
  }
}));
Er.create({ base: "/download" }, (t16) => ({
  async downloadDocument(e, r12, n12 = false) {
    return await t16.get(
      "/:documentID",
      { product: e, documentID: r12, download: !n12 },
      { dataType: "blob" }
    );
  },
  getDocumentDownloadUrl(e, r12, n12 = false) {
    return t16.getUrl(
      "/:documentID",
      { product: e, documentID: r12, download: !n12 },
      { dataType: "blob" }
    );
  }
}));
Er.create({ base: "/stats" }, (t16) => ({
  async getStatistics(e, r12) {
    return await t16.post("", r12, { product: e });
  }
}));
Er.create({ base: "/uploads" }, (t16) => ({
  async uploadDocuments(e, r12, n12) {
    const a = new FormData();
    for (let i = 0; i < r12.length; i++)
      if (r12[i].name.endsWith(".zip")) {
        const u = new Blob([r12[i]], { type: "application/zip" });
        a.append("file", u, r12[i].name);
      } else
        a.append("file", r12[i]);
    return await t16.post(
      "",
      a,
      { product: e },
      {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: (i) => {
          n12 && n12(i.loaded / i.total * 100);
        }
      }
    );
  }
}));
Er.create({ base: "/features" }, (t16) => ({
  async featureSupported(e, r12) {
    return await t16.post("", r12, { product: e });
  }
}));
const getChildStagingRecordByID = (stagingRecord, id) => {
  if (stagingRecord?.children && stagingRecord.children.length > 0) {
    return stagingRecord.children.find((ch2) => {
      return ch2.id === id;
    });
  }
};
const getLineItemEnumByType = (stagingRecordType) => {
  switch (stagingRecordType) {
    case Yn.InvoiceLabor:
      return StagingRecordLaborProperties;
    case Yn.InvoiceExpense:
      return StagingRecordExpenseProperties;
    case Yn.InvoiceItem:
      return StagingRecordItemProperties;
    case Yn.InvoiceLine:
    default:
      return StagingRecordLineProperties;
  }
};
const getStagingRecordPOLineTypeByOption = ({ label }) => [
  {
    key: StagingRecordPurchaseOrderLineKey.Expense,
    value: Yn.InvoiceExpense
  },
  {
    key: StagingRecordPurchaseOrderLineKey.Item,
    value: Yn.InvoiceItem
  },
  {
    key: StagingRecordPurchaseOrderLineKey.Labor,
    value: Yn.InvoiceLabor
  }
].find(({ key }) => label.startsWith(key))?.value ?? Yn.InvoiceLine;
const getStagingRecordValueObj = (record, propertyName) => {
  const valueArray = record?.values;
  if (valueArray && valueArray.length > 0) {
    const valueObj = valueArray.find((vo2) => {
      return vo2.property === propertyName;
    });
    return valueObj;
  }
};
const getRecordCurrency = ({
  currencies: currencies2,
  record
}) => {
  const currencyValue = getStagingRecordValueObj(
    record,
    StagingRecordInvoiceProperties.Currency
  );
  if (!currencyValue?.value) {
    return DEFAULT_CURRENCY;
  }
  const currencyKey = parseInt(currencyValue.value, 10);
  if (isNaN(currencyKey)) {
    return DEFAULT_CURRENCY;
  }
  const currency = currencies2.find((c) => c.key === currencyKey);
  return currency ?? DEFAULT_CURRENCY;
};
const keyNameModelToStagingValueUpdate = (knm) => ({
  option: {
    label: knm.name ?? "",
    sublabel: null,
    value: knm.key.toString()
  },
  value: knm.name ?? ""
});
const stringToStagingValueUpdate = (value) => ({
  value,
  option: null
});
const setStagingRecordValueObj = (record, propertyName, newValueObj) => {
  const valueArray = record.values;
  if (valueArray && valueArray.length > 0) {
    const valueObj = valueArray.find((vo2) => {
      return vo2.property === propertyName;
    });
    if (valueObj) {
      valueObj.value = newValueObj?.value ?? "";
      valueObj.option = newValueObj?.option ?? null;
    }
  }
};
const moveLineItem = ({
  oldRootRecord,
  newRecord
}) => {
  const oldRecord = getChildStagingRecordByID(oldRootRecord, newRecord.id);
  const oldLineType = getLineItemEnumByType(oldRecord?.type);
  const newLineType = getLineItemEnumByType(newRecord.type);
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.Account],
    getStagingRecordValueObj(
      oldRecord,
      oldLineType[LineItemPropertyNames.Account]
    )
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.Amount],
    getStagingRecordValueObj(
      oldRecord,
      oldLineType[LineItemPropertyNames.Amount]
    )
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.Date],
    getStagingRecordValueObj(oldRecord, oldLineType[LineItemPropertyNames.Date])
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.Description],
    getStagingRecordValueObj(
      oldRecord,
      oldLineType[LineItemPropertyNames.Description]
    )
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.ExpenseType],
    getStagingRecordValueObj(
      oldRecord,
      oldLineType[LineItemPropertyNames.ExpenseType]
    )
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.Hours],
    getStagingRecordValueObj(
      oldRecord,
      oldLineType[LineItemPropertyNames.Hours]
    )
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.Item],
    getStagingRecordValueObj(oldRecord, oldLineType[LineItemPropertyNames.Item])
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.LaborCategory],
    getStagingRecordValueObj(
      oldRecord,
      oldLineType[LineItemPropertyNames.LaborCategory]
    )
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.Organization],
    getStagingRecordValueObj(
      oldRecord,
      oldLineType[LineItemPropertyNames.Organization]
    )
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.Person],
    getStagingRecordValueObj(
      oldRecord,
      oldLineType[LineItemPropertyNames.Person]
    )
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.Project],
    getStagingRecordValueObj(
      oldRecord,
      oldLineType[LineItemPropertyNames.Project]
    )
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.ProjectType],
    getStagingRecordValueObj(
      oldRecord,
      oldLineType[LineItemPropertyNames.ProjectType]
    )
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.Quantity],
    getStagingRecordValueObj(
      oldRecord,
      oldLineType[LineItemPropertyNames.Quantity]
    )
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.Rate],
    getStagingRecordValueObj(oldRecord, oldLineType[LineItemPropertyNames.Rate])
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.Reference],
    getStagingRecordValueObj(
      oldRecord,
      oldLineType[LineItemPropertyNames.Reference]
    )
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.RelatesTo],
    { value: "", option: null }
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.Task],
    getStagingRecordValueObj(oldRecord, oldLineType[LineItemPropertyNames.Task])
  );
  setStagingRecordValueObj(
    newRecord,
    newLineType[LineItemPropertyNames.UOM],
    getStagingRecordValueObj(oldRecord, oldLineType[LineItemPropertyNames.UOM])
  );
};
const mapPurchasingLineDescriptorToStagingRecord = ({
  ignoreDescription = false,
  line: {
    account,
    description,
    organization,
    person,
    project,
    reference: reference2,
    task
  },
  lineType,
  record
}) => {
  const keyNameModels = [
    { recordKey: LineItemPropertyNames.Account, value: account },
    { recordKey: LineItemPropertyNames.Organization, value: organization },
    { recordKey: LineItemPropertyNames.Project, value: project },
    { recordKey: LineItemPropertyNames.Task, value: task },
    { recordKey: LineItemPropertyNames.Person, value: person }
  ];
  let strings = [
    { recordKey: LineItemPropertyNames.Description, value: description },
    { recordKey: LineItemPropertyNames.Reference, value: reference2 }
  ];
  if (ignoreDescription) {
    strings = strings.filter(
      (s12) => s12.recordKey !== LineItemPropertyNames.Description
    );
  }
  keyNameModels.forEach(({ recordKey, value }) => {
    if (value) {
      const stagingValueUpdate = keyNameModelToStagingValueUpdate(value);
      setStagingRecordValueObj(record, lineType[recordKey], stagingValueUpdate);
    }
  });
  strings.forEach(({ recordKey, value }) => {
    if (value) {
      const stagingValueUpdate = stringToStagingValueUpdate(value);
      setStagingRecordValueObj(record, lineType[recordKey], stagingValueUpdate);
    }
  });
  return record;
};
const mapPurchasingLineToStagingRecordByType = (params) => {
  switch (params.record.type) {
    case Yn.InvoiceExpense:
      _mapPurchasingExpenseLineToRecord(params);
      break;
    case Yn.InvoiceItem:
      _mapPurchasingItemLineToRecord(params);
      break;
    case Yn.InvoiceLabor:
      _mapPurchasingLaborLineToRecord(params);
      break;
    case Yn.InvoiceLine:
      log.warn({
        msg: `Vendor Invoice Automation: Invalid line type (${Yn.InvoiceLine}) passed to mapPurchasingLineToStagingRecordByType`
      });
      break;
  }
};
const _mapPurchasingExpenseLineToRecord = ({
  ignoreAmount,
  line: { amount, expenseType },
  lineType,
  record
}) => {
  if (!ignoreAmount && (amount || amount === 0)) {
    const amountValueUpdate = stringToStagingValueUpdate(amount.toString());
    setStagingRecordValueObj(
      record,
      lineType[LineItemPropertyNames.Amount],
      amountValueUpdate
    );
  }
  if (expenseType) {
    const expenseTypeValueUpdate = keyNameModelToStagingValueUpdate(expenseType);
    setStagingRecordValueObj(
      record,
      lineType[LineItemPropertyNames.ExpenseType],
      expenseTypeValueUpdate
    );
  }
  return record;
};
const _mapPurchasingItemLineToRecord = ({
  ignoreAmount,
  line: { amount, item, rate, quantity, unitOfMeasure },
  lineType,
  record
}) => {
  const keyNameModels = [
    { recordKey: LineItemPropertyNames.Item, value: item },
    { recordKey: LineItemPropertyNames.UOM, value: unitOfMeasure }
  ];
  let strings = [
    { recordKey: LineItemPropertyNames.Amount, value: amount },
    { recordKey: LineItemPropertyNames.Rate, value: rate },
    { recordKey: LineItemPropertyNames.Quantity, value: quantity }
  ];
  if (ignoreAmount) {
    strings = strings.filter(
      (s12) => s12.recordKey !== LineItemPropertyNames.Amount
    );
  }
  keyNameModels.forEach(({ recordKey, value }) => {
    if (value) {
      const stagingValueUpdate = keyNameModelToStagingValueUpdate(value);
      setStagingRecordValueObj(record, lineType[recordKey], stagingValueUpdate);
    }
  });
  strings.forEach(({ recordKey, value }) => {
    if (value) {
      const stagingValueUpdate = stringToStagingValueUpdate(value.toString());
      setStagingRecordValueObj(record, lineType[recordKey], stagingValueUpdate);
    }
  });
  return record;
};
const _mapPurchasingLaborLineToRecord = ({
  ignoreAmount,
  line: { amount, hours, laborCategory, rate },
  lineType,
  record
}) => {
  let strings = [
    { recordKey: LineItemPropertyNames.Amount, value: amount },
    { recordKey: LineItemPropertyNames.Hours, value: hours },
    { recordKey: LineItemPropertyNames.Rate, value: rate }
  ];
  if (ignoreAmount) {
    strings = strings.filter(
      (s12) => s12.recordKey !== LineItemPropertyNames.Amount
    );
  }
  strings.forEach(({ recordKey, value }) => {
    if (value || value === 0) {
      const stagingValueUpdate = stringToStagingValueUpdate(value.toString());
      setStagingRecordValueObj(record, lineType[recordKey], stagingValueUpdate);
    }
  });
  if (laborCategory) {
    const laborCatValueUpdate = keyNameModelToStagingValueUpdate(laborCategory);
    setStagingRecordValueObj(
      record,
      lineType[LineItemPropertyNames.LaborCategory],
      laborCatValueUpdate
    );
  }
};
const calculateAndSetDueDate = ({
  invoiceDate,
  paymentTerm,
  record
}) => {
  try {
    const dueDate = calculateDueDate({ invoiceDate, paymentTerm });
    const dueDateISOString = dueDate.toISODate() ?? "";
    setStagingRecordValueObj(record, StagingRecordInvoiceProperties.DueDate, {
      value: dueDateISOString,
      option: {
        value: dueDateISOString,
        label: fromDateString(dueDateISOString),
        sublabel: ""
      }
    });
  } catch (e) {
    log.warn({
      msg: "Vendor Invoice Automation: Failed to calculate and set due date",
      error: `${e}`,
      recordId: record.id
    });
  }
};
const calculateAndSetDiscountDate = ({
  invoiceDate,
  paymentTerm,
  record
}) => {
  try {
    const discountDate = calculateDiscountDate({ invoiceDate, paymentTerm });
    if (!discountDate) {
      setStagingRecordValueObj(
        record,
        StagingRecordInvoiceProperties.DiscountDate,
        {
          value: "",
          option: null
        }
      );
      return;
    }
    const discountDateISOString = discountDate.toISODate() ?? "";
    setStagingRecordValueObj(
      record,
      StagingRecordInvoiceProperties.DiscountDate,
      {
        value: discountDateISOString,
        option: {
          value: discountDateISOString,
          label: fromDateString(discountDateISOString),
          sublabel: ""
        }
      }
    );
  } catch (e) {
    log.warn({
      msg: "Vendor Invoice Automation: Failed to calculate and set discount date",
      error: `${e}`,
      recordId: record.id
    });
  }
};
const calculateAndSetDiscountAmount = ({
  currency,
  paymentTerm,
  record
}) => {
  try {
    const invoiceAmountValue = getStagingRecordValueObj(
      record,
      StagingRecordInvoiceProperties.InvoiceAmount
    );
    if (!invoiceAmountValue?.value) {
      setStagingRecordValueObj(
        record,
        StagingRecordInvoiceProperties.DiscountAmount,
        {
          value: "",
          option: null
        }
      );
      return;
    }
    const invoiceAmount = parseFloat(invoiceAmountValue.value);
    const result = calculateDiscountAmount({ invoiceAmount, paymentTerm });
    if (!result) {
      setStagingRecordValueObj(
        record,
        StagingRecordInvoiceProperties.DiscountAmount,
        {
          value: "",
          option: null
        }
      );
      return;
    }
    setStagingRecordValueObj(
      record,
      StagingRecordInvoiceProperties.DiscountAmount,
      {
        value: result.toFixed(currency.decimals),
        option: null
      }
    );
  } catch (e) {
    log.warn({
      msg: "Vendor Invoice Automation: Failed to calculate and set discount amount",
      error: `${e}`,
      recordId: record.id
    });
  }
};
const getFiscalPeriodForDate = async ({
  legalEntityKey,
  date = DateTime.now()
}) => {
  let defaultFiscalPeriod = null;
  if (legalEntityKey > 0) {
    const includeClosedPeriods = await !fetchProperty(
      "unanet.financials.disallow_posting_to_closed_fiscal_period"
    );
    const fiscalPeriods = await fetchVendorInvoiceFiscalPeriods({
      legalEntityKey,
      includeClosedPeriods,
      pageSize: MAX_PLATFORM_PAGE_SIZE
    });
    if (fiscalPeriods.items.length) {
      defaultFiscalPeriod = fiscalPeriods.items[0];
      for (const fp of fiscalPeriods.items) {
        if (fp.beginDate && fp.endDate) {
          if (date >= fp.beginDate && date <= fp.endDate) {
            defaultFiscalPeriod = fp;
            break;
          }
          const laterFiscalPeriodBeforeDate = defaultFiscalPeriod.endDate && defaultFiscalPeriod.endDate < date && fp.endDate > defaultFiscalPeriod.endDate;
          const earlierFiscalPeriodAfterDate = defaultFiscalPeriod.beginDate && defaultFiscalPeriod.beginDate > date && fp.beginDate < defaultFiscalPeriod.beginDate && fp.beginDate > date;
          if (laterFiscalPeriodBeforeDate || earlierFiscalPeriodAfterDate) {
            defaultFiscalPeriod = fp;
          }
        }
      }
    }
  }
  return defaultFiscalPeriod;
};
const fetchVendorInvoiceFiscalPeriods = async (params) => {
  try {
    const results = await fetchVendorInvoiceLegalEntityFiscalPeriods(params);
    return results.items ? {
      ...results,
      items: results.items.map(fromPlatformFiscalPeriod)
    } : {
      ...results,
      items: []
    };
  } catch (e) {
    log.warn({
      msg: `Error fetching vendor invoice fiscal periods for legal entity: ${params.legalEntityKey}`
    });
    throw e;
  }
};
const createVendorInvoiceFormat = async (requestBody) => {
  try {
    return await createVendorInvoiceFormat$1(requestBody);
  } catch (e) {
    log.warn({
      msg: "Creating new vendor invoice format failed",
      error: `${e}`
    });
    throw e;
  }
};
const createVendorInvoiceFormatSection = async (requestBody) => {
  try {
    return await createVendorInvoiceFormatSection$1(
      requestBody.vendorInvoiceFormatKey,
      requestBody
    );
  } catch (e) {
    log.warn({
      msg: "Creating new vendor invoice format section failed",
      error: `${e}`
    });
    throw e;
  }
};
const editVendorInvoiceFormat = async (requestBody) => {
  try {
    if (!requestBody.key) {
      throw new Error("Missing Vendor Invoice Format key");
    }
    await editVendorInvoiceFormat$1(requestBody);
    return { key: requestBody.key };
  } catch (e) {
    log.warn({
      msg: `Editing vendor invoice format failed (key: ${requestBody.key})`,
      error: `${e}`
    });
    throw e;
  }
};
const editVendorInvoiceFormatSection = async (requestBody) => {
  try {
    if (!requestBody.key) {
      throw new Error("Missing Vendor Invoice Format key");
    }
    return await editVendorInvoiceFormatSection$1(requestBody);
  } catch (e) {
    log.warn({
      msg: `Editing vendor invoice format section failed (key: ${requestBody.key})`,
      error: `${e}`
    });
    throw e;
  }
};
const deleteVendorInvoiceFormat = async (key) => {
  try {
    return await deleteVendorInvoiceFormat$1(key);
  } catch (e) {
    log.warn({
      msg: `Deleting vendor invoice format failed (key: ${key})`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchVendorInvoiceFormatByKey = async (key) => {
  try {
    return await fetchVendorInvoiceFormatByKey$1(key);
  } catch (e) {
    log.warn({
      msg: `Fetching vendor invoice (${key}) formats failed`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchVendorInvoiceFormatAndSections = async (key) => {
  try {
    const summary = await fetchVendorInvoiceFormatByKey$1(key);
    let sections = {
      [VendorInvoiceFormatSectionModel.TypeEnum.LABORDETAILS]: void 0,
      [VendorInvoiceFormatSectionModel.TypeEnum.EXPENSEDETAILS]: void 0,
      [VendorInvoiceFormatSectionModel.TypeEnum.MATCHEDEXPENSES]: void 0,
      [VendorInvoiceFormatSectionModel.TypeEnum.MATCHEDLABOR]: void 0,
      [VendorInvoiceFormatSectionModel.TypeEnum.ITEMDETAILS]: void 0,
      [VendorInvoiceFormatSectionModel.TypeEnum.POFUNDINGCAPADJUSTMENTS]: void 0
    };
    try {
      const sectionsArr = await fetchVendorInvoiceFormatSections(key);
      sections = sectionsArr.reduce((sections2, current) => {
        sections2[current.type] = current;
        return sections2;
      }, {});
    } catch (e) {
      log.warn({
        msg: `Fetching vendor invoice sections failed (${key})`,
        error: `${e}`
      });
    }
    return {
      summary,
      sections
    };
  } catch (e) {
    log.warn({
      msg: `Fetching vendor invoice format and sections (${key})`,
      error: `${e}`
    });
    throw e;
  }
};
const fetchVendorInvoiceFormats = async (page = 1, pageSize2 = 50) => {
  try {
    const results = await fetchVendorInvoiceFormats$1(
      page,
      pageSize2
    );
    return results;
  } catch (e) {
    log.warn({ msg: "Fetching vendor invoice formats failed", error: `${e}` });
    throw e;
  }
};
var VendorInvoiceApprovalsRequired = /* @__PURE__ */ ((VendorInvoiceApprovalsRequired2) => {
  VendorInvoiceApprovalsRequired2[VendorInvoiceApprovalsRequired2["REQUIRED"] = 0] = "REQUIRED";
  VendorInvoiceApprovalsRequired2[VendorInvoiceApprovalsRequired2["CONDITIONALLY_REQUIRED"] = 1] = "CONDITIONALLY_REQUIRED";
  VendorInvoiceApprovalsRequired2[VendorInvoiceApprovalsRequired2["OPTIONAL"] = 2] = "OPTIONAL";
  VendorInvoiceApprovalsRequired2[VendorInvoiceApprovalsRequired2["DISABLED"] = 3] = "DISABLED";
  return VendorInvoiceApprovalsRequired2;
})(VendorInvoiceApprovalsRequired || {});
const vendorInvoiceApprovalsRequiredMap = /* @__PURE__ */ new Map([
  [
    "R",
    0
    /* REQUIRED */
  ],
  [
    "C",
    1
    /* CONDITIONALLY_REQUIRED */
  ],
  [
    "O",
    2
    /* OPTIONAL */
  ],
  [
    "D",
    3
    /* DISABLED */
  ]
]);
const getVendorInvoiceApprovalsRequired = (code) => vendorInvoiceApprovalsRequiredMap.get(code) ?? 3;
const calculateDueDate = ({
  invoiceDate,
  paymentTerm
}) => {
  const days = paymentTerm?.days ?? 0;
  return invoiceDate.plus({ days });
};
const calculateDiscountDate = ({
  invoiceDate,
  paymentTerm
}) => {
  if (!paymentTerm.discountDays || paymentTerm.discountDays <= 0) {
    return null;
  }
  return invoiceDate.plus({ days: paymentTerm.discountDays });
};
const calculateDiscountAmount = ({
  invoiceAmount,
  paymentTerm
}) => {
  if (!paymentTerm.discountDays || paymentTerm.discountDays <= 0 || !paymentTerm.discountPercent || paymentTerm.discountPercent <= 0) {
    return null;
  }
  if (isNaN(invoiceAmount)) {
    return null;
  }
  return invoiceAmount * (paymentTerm.discountPercent / 100);
};
const createVendorInvoice = async (requestBody) => {
  try {
    return await createVendorInvoice$1(requestBody);
  } catch (e) {
    log.warn({ msg: "Creating new vendor invoice failed", error: `${e}` });
    throw e;
  }
};
const fetchVendorInvoice = async (key) => {
  try {
    const invoice = await fetchVendorInvoice$1(key);
    return invoice;
  } catch (e) {
    log.warn({
      msg: `Error fetching vendor invoice: ${key.vendorInvoiceKey}`
    });
    throw e;
  }
};
const fetchVendorInvoiceExpenseProjects = async (params) => {
  try {
    const items = await fetchVendorInvoiceExpenseProjects$1(params);
    return items;
  } catch (e) {
    log.warn({
      msg: `Error fetching vendor invoice expense projects for legal entity: ${params.legalEntityKey}`
    });
    throw e;
  }
};
const fetchVendorInvoiceItemProjects = async (params) => {
  try {
    const items = await fetchVendorInvoiceItemProjects$1(params);
    return items;
  } catch (e) {
    log.warn({
      msg: `Error fetching vendor invoice item projects for legal entity: ${params.legalEntityKey}`
    });
    throw e;
  }
};
const fetchVendorInvoiceLaborProjects = async (params) => {
  try {
    const items = await fetchVendorInvoiceLaborProjects$1(params);
    return items;
  } catch (e) {
    log.warn({
      msg: `Error fetching vendor invoice labor projects for legal entity: ${params.legalEntityKey}`
    });
    throw e;
  }
};
const fetchVendorInvoiceLegalEntityVendors = async (params) => {
  try {
    const items = await fetchVendorInvoiceLegalEntityVendors$1(params);
    return items;
  } catch (e) {
    log.warn({
      msg: `Error fetching vendor invoice vendors for legal entity: ${params.legalEntityKey}`
    });
    throw e;
  }
};
const fetchVendorInvoiceLegalEntityAPDefaults = async (params) => {
  try {
    return await fetchVendorInvoiceLegalEntityAPDefaults$1({
      id: params.id
    });
  } catch (e) {
    log.warn({
      msg: `Getting AP Defaults based on vendor key ${params.id} failed`,
      error: `${e}`
    });
  }
};
const postVendorInvoice = async (params) => {
  try {
    return await postVendorInvoice$1(params);
  } catch (e) {
    log.warn({
      msg: `Posting vendor invoice ${params.viKey} failed`,
      error: `${e}`
    });
  }
};
const postVendorInvoiceValidate = async (params) => {
  try {
    return await postVendorInvoiceValidate$1(params);
  } catch (e) {
    if (e instanceof HttpError && e.statusCode === 403) {
      return {
        errors: ["Vendor Invoice invalid for posting"],
        warnings: []
      };
    }
    log.warn({
      msg: `Validating vendor invoice ${params.viKey} for posting failed`,
      error: `${e}`
    });
  }
};
const submitVendorInvoice = async (params) => {
  try {
    return await submitVendorInvoice$1(params);
  } catch (e) {
    if (e instanceof HttpError && (e.statusCode === 400 || e.statusCode === 403)) {
      return {
        errors: e.details.errors,
        warnings: []
      };
    }
    log.warn({
      msg: `Submitting vendor invoice ${params.viKey} failed`,
      error: `${e}`
    });
  }
};
const isVendorInvoiceIntegrationUserConfigured = async () => {
  const users = await searchIntegrationUsers(
    {
      integrationUserType: IntegrationUserType.VENDORINVOICEAUTOMATION
    },
    1,
    1
  );
  return users.resultCount > 0;
};
const configureVendorInvoiceAutomation = async (orgKey) => {
  try {
    return await createIntegrationUser({
      orgKey,
      integrationUserType: IntegrationUserType.VENDORINVOICEAUTOMATION
    });
  } catch (e) {
    log.warn({
      msg: `Creating Vendor Invoice Automation Integration User failed`,
      error: `${e}`
    });
  }
};
export {
  ADD_TRANSACTION_POSTING_FEATURES,
  AccountCategoryModel,
  AccountExpenseTypeModel,
  AccountModel,
  AccountSourceSupplierModel,
  AccrualScheduleModel,
  AdvFundContractModCreateModel,
  AdvFundContractModModel,
  AdvFundContractStateHistoryModel,
  AlertPrefsModel,
  AllocationColor,
  AnalyticsPageEvents,
  AnomalyDetectionRequestModel,
  AppError,
  ApprovalGroupCreateModel,
  ApprovalGroupModel,
  ApprovalGroupSearchModel,
  ApprovalGroupType,
  ApproverAlternateModel,
  AssignablePlannedTimeModel,
  AssignablePlannedTimeSearchModel,
  AssignablePlannedTimeUnassignableReasons,
  AssigningMatrixSearchCriteriaModel,
  AssigningMatrixSearchCriteriaReadModel,
  AssigningMatrixSearchModel,
  AssignmentDefaultsModel,
  AssignmentMatrixData,
  AuditDataSearchModel,
  AuditLogCategoryType,
  BANK_REC_TOGGLE_STORAGE_KEY,
  BOT,
  BOTKey$1 as BOTKey,
  BOT_EOT_WORK_DAYS,
  BOT_STR$1 as BOT_STR,
  BankAccountModel,
  BankFeedStatus,
  BasePurchasingDocumentSearchModel,
  BillingTypeModel,
  BudgetByOptions,
  CashFlowOptimizationRequestModel,
  CategoryAccountKeyModel,
  CategoryAccountModel,
  ContractCreateModel,
  ContractDetailModel,
  ContractLineCreateModel,
  ContractLineModCreateModel,
  ContractLineModModel,
  ContractLineModel,
  ContractLineSearchModel,
  ContractListModel,
  ContractModel,
  CostElementModel,
  CostPlusInvoiceSectionFormatCreateModel,
  CostPlusInvoiceSectionFormatModel,
  CostReportElementModel,
  CostStructPoolRateModel,
  CostStructPoolRateUpdateModel,
  CustomLinkListModel,
  CustomLinkModel,
  CustomerPaymentIncludedModel,
  CustomerPaymentModel,
  CustomerPaymentSearchModel,
  DASHBOARD_MENU_IDS,
  DATALAKE_CRITERIA_DEFAULT_PERIOD_COUNT,
  DATALAKE_CRITERIA_MAX_PERIOD_COUNT,
  DATALAKE_CRITERIA_MIN_PERIOD_COUNT,
  DATALAKE_VIEWS,
  DATE_TIME_PICKER_ESCAPE_LITERALS,
  DEFAULT_CURRENCY,
  DEFAULT_CURRENCY_CODE,
  DEFAULT_EXCHANGE_RATE_TYPE,
  DEFAULT_MULTICURRENCY_CONFIG,
  DEFAULT_MULTICURRENCY_SETUP,
  DEFAULT_PERSON_CLASSIFICATION,
  DashboardLeftMenuId,
  DashboardTypePagedResponse,
  DataLakeCriteriaFieldsModel,
  DateTimeParser,
  DepositSearchModel,
  DepositSummaryModel,
  EOT,
  EOTKey$1 as EOTKey,
  EOT_STR$1 as EOT_STR,
  EmailTemplateModel,
  EntertainmentWizardModel,
  ErrorCode,
  ErrorInstance,
  ErrorResponse,
  ExpenseBaseModel,
  ExpenseCreateModel,
  ExpenseInvoiceSectionFormatCreateModel,
  ExpenseInvoiceSectionFormatModel,
  ExpenseLineModel,
  ExpenseModel,
  ExpenseSearchModel,
  ExpenseStatusHistoryModel,
  ExpenseTypeModel,
  ExpenseTypeSummaryModel,
  FeatureFlag,
  FinDocumentStatus,
  FinDocumentType,
  FinancialDocumentStatusHistoryModel,
  FixedAssetAlertModel,
  FixedAssetCreateModel,
  FixedAssetJournalEntryModel,
  FixedAssetModel,
  FixedAssetPostDocumentModel,
  FixedAssetSearchReadModel,
  FixedPriceInvoiceSectionFormatCreateModel,
  FixedPriceInvoiceSectionFormatModel,
  FixedPriceItemCreateModel,
  FixedPriceItemModel,
  ForecastRequestModel,
  ForecastingMatrixSearchCriteriaTypesEnum,
  FundedValueAdjustmentInvoiceSectionFormatCreateModel,
  FundedValueAdjustmentInvoiceSectionFormatModel,
  HashMap,
  HttpError,
  HubApi,
  HubTransactionStatus,
  IMPORT_ACTION_COLUMN,
  INT_ROLES,
  ImportAction,
  ImportCommand,
  ImportDefinitionColumnModel,
  ImportErrorModel,
  ImportResultStatus,
  ImportedExpenseSearchModel,
  IndirectCostRateTypes,
  IntegrationUserSearchModel,
  IntegrationUserType,
  IntegrationValueModel,
  InvoiceFormatCreateModel,
  InvoiceFormatModel,
  InvoiceListModel,
  InvoiceModel,
  InvoiceStatusHistoryModel,
  ItemCreateModel,
  ItemModel,
  JournalEntryExpenseDetailModel,
  JournalEntryItemDetailModel,
  JournalEntrySearchModel,
  JournalEntrySummaryModel,
  LINE_ITEM_INITIAL,
  LaborInvoiceSectionFormatCreateModel,
  LaborInvoiceSectionFormatModel,
  LeaveRequestModel,
  LeaveRequestSortByColumns,
  LeaveStatusHistoryModel,
  License,
  LineItemPropertyNames,
  LineState,
  LinkType,
  LogLevel,
  LogMessageModel,
  MAX_PLATFORM_PAGE_SIZE,
  MatrixPersonModel,
  MeTimesheetSearchModel,
  MileageRateSetModel,
  MimeTypes,
  NaturalLanguageSummaryRequestModel,
  NewCookie,
  OnetimeInvoiceSectionFormatCreateModel,
  OnetimeInvoiceSectionFormatModel,
  OrgAccessPersonSearchModel,
  Organization,
  OrganizationCreateModel,
  OrganizationModel,
  OrganizationSummaryModel,
  PAYMENT_TERM_DEFAULT_STATE,
  PERSON_CLASSIFICATIONS_KEY_CODE_NAME,
  PERSON_CLASSIFICATIONS_KEY_NAME,
  POAlertPreferencesModel,
  PODetail,
  POExpenseLineCreateModel,
  POExpenseLineFromApprovedCreateModel,
  POExpenseLineModel,
  POFormatOptionsModel,
  POItemLineCreateModel,
  POItemLineFromApprovedCreateModel,
  POItemLineModel,
  POLaborLineCreateModel,
  POLaborLineFromApprovedCreateModel,
  POLaborLineModel,
  POSTING_FEATURE_PERMISSIONS,
  PRExpenseLineModel,
  PRItemLineModel,
  PRLaborLineModel,
  PaidCustomerDocumentModel,
  PaidVendorDocumentModel,
  PayCodeModel,
  PayableCustomerDocumentModel,
  PayableVendorDocumentModel,
  PaymentMethodCreateModel,
  PaymentMethodModel,
  Period,
  PeriodType,
  Person,
  PersonAccrualPlanModel,
  PersonCreateModel,
  PersonModel,
  PersonRateBaseModel,
  PersonRateCreateModel,
  PersonRateModel,
  PersonSearchModel,
  PlanDefaultsModel,
  PlanSetAuditModel,
  PlannedTimeCreateModel,
  PlannedTimeModel,
  PlannedTimeSearchModel,
  PlannedTimeUneditableReason,
  PlanningMatrixSearchCriteriaModel,
  PlanningMatrixSearchCriteriaReadModel,
  PlanningMatrixSearchModel,
  PostingFeature,
  PostingGroupModel,
  PostingGroupSourceModel,
  PrebilledLaborInvoiceSectionFormatCreateModel,
  PrebilledLaborInvoiceSectionFormatModel,
  PrebilledLaborOffsetInvoiceSectionFormatCreateModel,
  PrebilledLaborOffsetInvoiceSectionFormatModel,
  ProjectAlertPrefsModel,
  ProjectAlertsModel,
  ProjectApproverModel,
  ProjectApproverUpdateModel,
  ProjectAssignmentCreateModel,
  ProjectAssignmentModel,
  ProjectAssignmentUpdateModel,
  ProjectBudgetHistoryModel,
  ProjectContractModel,
  ProjectControllerModel,
  ProjectCreateModel,
  ProjectFeeCreateModel,
  ProjectFeeModel,
  ProjectInvoiceCreateModel,
  ProjectInvoiceModel,
  ProjectItemUpdateModel,
  ProjectModel,
  ProjectPeopleAssignmentSearchModel,
  ProjectUpdateModel,
  PurchaseOrderCreateModel,
  PurchaseOrderModCreateModel,
  PurchaseOrderModModel,
  PurchaseOrderModel,
  PurchaseOrderSearchModel,
  PurchaseOrderSummaryModel,
  PurchaseRequisitionModCreateModel,
  PurchaseRequisitionModel,
  PurchaseRequisitionOrigCreateModel,
  PurchaseRequisitionSearchModel,
  PurchaseRequisitionSummaryModel,
  PurchasingApprovalHistoryModel,
  PurchasingBalanceModel,
  RATE_MAX_DECIMALS,
  RECEIVING_DOCUMENT_KEY_NAME_STATUSES,
  ReceivingDocumentModel,
  ReceivingDocumentSearchModel,
  ReceivingPurchaseOrderSearchModel,
  ReportExplanationRequestModel,
  ReportExplanationResponse,
  Role,
  SchedulingPersonSearchModel,
  SectionFilter,
  StagingRecordExpenseProperties,
  StagingRecordInvoiceProperties,
  StagingRecordItemProperties,
  StagingRecordLaborProperties,
  StagingRecordLineProperties,
  StagingRecordPurchaseOrderLineKey,
  StatisticalAccountJournalEntryModel,
  StatisticalAccountJournalEntrySearchModel,
  StatusType,
  TIMESHEET_TOGGLE_STORAGE_KEY,
  TIME_DASHBOARD_TOGGLE_STORAGE_KEY,
  TaskCreateModel,
  TaskDependencyCreateModel,
  TaskDependencyModel,
  TaskModel,
  TaskMoveModel,
  TaskSummaryModel,
  TaskUpdateModel,
  TaxInvoiceSectionFormatCreateModel,
  TaxInvoiceSectionFormatModel,
  TimeEntryIncrementHours,
  TimeEntryIncrementSet,
  TimeExtractModel,
  TimeListView,
  TimePeriodAvailabilityModel,
  TimePeriodSetupCreateModel,
  TimePeriodSetupModel,
  TimeStatusHistoryModel,
  TimesheetAdjustmentType,
  TimesheetListModel,
  TimesheetModel,
  TimesheetOwnerModel,
  TimesheetProjectModel,
  TimesheetSearchModel,
  TimesheetSortByColumns,
  TimesheetUpdateModel,
  ToggleStatus,
  TokenError,
  TrackingStatus,
  TransactionType,
  UDF_URL_CHARACTER_LIMIT,
  UNANET_LOGO,
  UNANET_LOGO_WHITE,
  USER_IMPORT_ACTIONS,
  UdfMetadataModel,
  UdfMetadataType,
  UnanetApplicationMode,
  UseLaborCategory,
  VendorInvoiceApprovalsRequired,
  VendorInvoiceExpenseModel,
  VendorInvoiceFormatSectionModel,
  VendorInvoiceFormatSectionTotalGroupModel,
  VendorInvoiceItemModel,
  VendorInvoiceLaborModel,
  VendorInvoiceLaborProjectModel,
  VendorInvoiceMatchedExpenseElementModel,
  VendorInvoiceMatchedItemElementModel,
  VendorInvoiceMatchedLaborElementModel,
  VendorInvoiceSearchModel,
  VendorInvoiceSummaryListModel,
  VendorInvoiceSummaryModel,
  VendorPaymentIncludedModel,
  VendorPaymentModel,
  VendorPaymentSearchModel,
  __TEST_STORE,
  index$3 as account,
  accounts,
  activateMulticurrency,
  addAlternateRoles,
  addApprovers,
  addFixedAssetLocation,
  addFixedAssetLocations,
  addFixedAssetStatus,
  addFixedAssetsClass,
  addLoggerTransport,
  addToMap,
  addWorkDays,
  adjustmentComments,
  advFundClinChanges,
  advFundContractMods,
  advFundSlinChanges,
  aggregateBankFeedsMatchData,
  allowTimesheetEdit,
  approvalGroup as approvalGroups,
  approveTimesheetAsManager,
  assigning,
  associateLeadProject,
  audit,
  auditComments,
  auditLogCategoryMap,
  auth,
  bankAccounts as bankAccount,
  bankReconciliation,
  bankTransactions,
  base64ToObjectURL,
  botToEOT,
  botToToday,
  buildDefaultExperienceCenterLink,
  buildExperienceCenterLink,
  buildImportHeaderRow,
  buildMatchedTransaction,
  buildURI,
  businessHoursBetween,
  businessWeeks,
  cached,
  calcTitoWorkHours,
  calcTotalTitoWorkHours,
  calculateAndSetDiscountAmount,
  calculateAndSetDiscountDate,
  calculateAndSetDueDate,
  calculateDiscountAmount,
  calculateDiscountDate,
  calculateDueDate,
  calendar,
  calendarCurrentMonth,
  calendarCurrentQuarter,
  canAdjustTimesheet,
  canAdminAdjustTimesheet,
  canDeleteTimesheet,
  canEditTimesheet,
  cancelLeaveRequest,
  cancelMyLeaveRequest,
  changeLoggerLevel,
  changeReasons,
  contractClauses as clauses,
  clearApiCache,
  clinProjectTaskMappings,
  combineAdjustments,
  commitAdvFundMod,
  completeReceipt,
  config$1 as config,
  configureVendorInvoiceAutomation,
  consoleTransport,
  contracts,
  convertAmountFromMinorUnits,
  convertDateTimeToEastern,
  convertDateTimeToServerTz,
  costElementsCachedApi,
  costReports,
  countDigits,
  createAdvFundMod,
  createAgencyCode,
  createApprovalGroup,
  createAssignedTimeSaveCriteria,
  createAssignedTimeSharedSaveCriteria,
  createAsyncImportRecordsFromCSV,
  createBankFeedsIntegrationUser,
  createBankReconciliation,
  createBankReconciliationAttachments,
  createClinChange,
  createClinProjectTaskMapping,
  createContract,
  createContractClause,
  createContractLine,
  createContractSubline,
  createDataLakeCriteria,
  createExchangeRate,
  createExchangeRateType,
  createFixedAsset,
  createFixedAssetAttachments,
  createForecastedTime,
  createForecastedTimeSaveCriteria,
  createForecastedTimeSharedSaveCriteria,
  createFundingItem,
  createImportJob,
  createImportRecordsFromCSV,
  createIncludedContractClause,
  createMyTimesheet,
  createOrganizationAlias,
  createPaymentMethod,
  createPaymentTerm,
  createPlannedTime,
  createPlannedTimeCriteria,
  createPlannedTimeSharedCriteria,
  createProjectAssignment,
  createProjectTaskPredecessor,
  createPropertyTemplate,
  createReceipt,
  createReceiptAttachments,
  createReceiptItem,
  createSingleImportRecordFromCSV,
  createSlinChange,
  createStatisticalJournalAttachments,
  createStatisticalJournalEntry,
  createStatisticalJournalEntryDetails,
  createTimesheet,
  createVendorInvoice,
  createVendorInvoiceFormat,
  createVendorInvoiceFormatSection,
  csvStringField,
  currencies,
  customLinks,
  dashboardItemEnumToDisplay,
  dashboards,
  datalakeCriteria as dataLakeCriteria,
  dateAfterStart,
  dateKey,
  dateWithinRange,
  datesWithinDays,
  deleteAdvFundMod,
  deleteAgencyCode,
  deleteApprovalGroup,
  deleteAssignedTimeSaveCriteria,
  deleteAssignedTimeSharedSaveCriteria,
  deleteBankReconciliation,
  deleteBankReconciliationAttachment,
  deleteClinChange,
  deleteClinProjectTaskMapping,
  deleteContractClause,
  deleteContractLine,
  deleteContractSubline,
  deleteDataLakeCriteria,
  deleteFixedAssetAlert,
  deleteForecastedTime,
  deleteForecastedTimeSaveCriteria,
  deleteForecastedTimeSharedSaveCriteria,
  deleteFundingItem,
  deleteIncludedContractClause,
  deleteLeaveRequest,
  deleteMatchedTransaction,
  deleteMyLeaveRequest,
  deleteMyTimesheet,
  deleteOrganizationAlias,
  deletePaymentMethod,
  deletePaymentTerm,
  deletePlannedTime,
  deletePlannedTimeSaveCriteria,
  deletePlannedTimeSharedSaveCriteria,
  deleteProjectAssignment,
  deleteProjectTaskPredecessor,
  deletePropertyTemplate,
  deleteReceipt,
  deleteReceiptAttachment,
  deleteReceiptItem,
  deleteSlinChange,
  deleteStatisticalJournalAttachment,
  deleteStatisticalJournalEntry,
  deleteStatisticalJournalEntryDetail,
  deleteTimesheet,
  deleteTimesheetAutofillRow,
  deleteVendorInvoiceFormat,
  destroy,
  destroyAllFixedAssetLocations,
  destroyFixedAsset,
  destroyFixedAssetAttachment,
  destroyFixedAssetClass,
  destroyFixedAssetLocation,
  destroyFixedAssetStatus,
  detectAnomalies,
  detectRisks,
  disapproveTimesheetAsManager,
  disassociateLeadProject,
  downloadAuditLogs,
  downloadFileFromUrl,
  editAgencyCode,
  editApprovalGroup,
  editApprovers,
  editContractClause,
  editExchangeRate,
  editExchangeRateType,
  editFixedAsset,
  editFixedAssetClassAccounts,
  editFixedAssetFilterCriteria,
  editFixedAssetLocation,
  editFixedAssetStatus,
  editFixedAssetsClass,
  editIncludedContractClause,
  editMulticurrencyConfig,
  editVendorInvoiceFormat,
  editVendorInvoiceFormatSection,
  effectiveDate,
  employeeTypes,
  emptyKeyName,
  emptyListPage,
  emptyPersonSummary,
  emptySession,
  exchangeRateTypes,
  exchangeRates,
  excludeMatchedTransactions,
  experienceCenterUrlDefault,
  explainReport,
  explainReportSimplified,
  extractErrorMessages,
  featureFlag as featureFlags,
  fetchAccounts,
  fetchAllAccounts,
  fetchAllApprovalGroupMembers,
  fetchAllApprovalGroups,
  fetchAllAvailableDashboards,
  fetchAllBankReconciliationDetails,
  fetchAllContractAgencies,
  fetchAllContractClauses,
  fetchAllCostElements,
  fetchAllCostStructureLabor,
  fetchAllCostStructures,
  fetchAllCurrencies,
  fetchAllExchangeRateTypes,
  fetchAllExchangeRates,
  fetchAllFeatureFlags,
  fetchAllFixedAssetSavedFilters,
  fetchAllFixedAssetStatuses,
  fetchAllFixedAssetsClasses,
  fetchAllIncludedContractClauses,
  fetchAllItems,
  fetchAllLaborCategories,
  fetchAllLaborCategoryRates,
  fetchAllLocations,
  fetchAllNaicsCodes,
  fetchAllPaymentMethods,
  fetchAllPaymentTerms,
  fetchAllProjectLaborCategories,
  fetchAllProjectLaborCategoriesDefaults,
  fetchAllProjectLocationsDefaults,
  fetchAllProjectPlanSets,
  fetchAllProjectSubmittersInApprovalGroup,
  fetchAllPropertyTemplateAuditDetails,
  fetchAllPropertyTemplates,
  fetchAllStatisticalAccountJournalFiscalPeriods,
  fetchAllStatisticalAccountJournalLegalEntities,
  fetchAllStatisticalAccountOrgs,
  fetchAllStatisticalAccounts,
  fetchAllTemplateOrgAuditHistory,
  fetchAllTemplateOrgHistory,
  fetchApproverGroupsForPerson,
  fetchBankAccounts,
  fetchBankAccountsByLegalEntity,
  fetchBankFeedSettings,
  fetchBankFeedTransactions,
  fetchBankReconciliation,
  fetchBankReconciliationAttachment,
  fetchBankReconciliationAttachments,
  fetchBankReconciliationAvailableCredits,
  fetchBankReconciliationAvailableDebits,
  fetchBankReconciliationDetails,
  fetchBankReconciliationVendors,
  fetchBankTransaction,
  fetchContextualHelpArticles,
  fetchContractClauseByKey,
  fetchContractClauseImportDefinition,
  fetchCustomerLogo,
  fetchDefaultValuesForProjectAssignment,
  fetchFeatureFlagById,
  fetchFixedAsset,
  fetchFixedAssetAttachment,
  fetchFixedAssetAttachments,
  fetchFixedAssetLegalEntityFiscalPeriods,
  fetchFixedAssetSavedFilter,
  fetchFixedAssets,
  fetchFixedAssetsClassAccountCategories,
  fetchFixedAssetsClassAccounts,
  fetchHubTransactions,
  fetchIndustries,
  fetchLatestBankRec,
  fetchLegalEntities,
  fetchList,
  fetchLocations,
  fetchMatchedTransactionDetail,
  fetchMatchedTransactions,
  fetchMulticurrencyConfig,
  fetchMulticurrencySetup,
  fetchOrganizationAliases,
  fetchPaymentMethod,
  fetchPaymentMethodAccountCategories,
  fetchPaymentMethodAccounts,
  fetchPaymentMethods,
  fetchPaymentTerm,
  fetchPaymentTerms,
  fetchPeopleList,
  fetchProject,
  fetchProjectLaborCategoriesExist,
  fetchProjectTask,
  fetchProperty,
  fetchRoles,
  fetchSocioeconomicStatuses,
  fetchStatisticalJournalAttachment,
  fetchStatisticalJournalAttachments,
  fetchUdfMetadataList,
  fetchVendorInvoice,
  fetchVendorInvoiceExpenseProjects,
  fetchVendorInvoiceFiscalPeriods,
  fetchVendorInvoiceFormatAndSections,
  fetchVendorInvoiceFormatByKey,
  fetchVendorInvoiceFormats,
  fetchVendorInvoiceItemProjects,
  fetchVendorInvoiceLaborProjects,
  fetchVendorInvoiceLegalEntityAPDefaults,
  fetchVendorInvoiceLegalEntityVendors,
  filterApprovalGroups,
  filterFixedAssetJournalEntriesByDateRange,
  filterImportResults,
  filterProjectAssignmentsByTask,
  findFiscalPeriodByDate,
  findFixedAssetScheduleByDate,
  fixedAssets,
  forecast,
  formatAmount,
  formatDate,
  formatDateCustom,
  formatDateRange,
  formatDateTime,
  formatLeadProject,
  formatProjectName,
  formatRate,
  formatTimestamp,
  formatTitoTimeRange,
  formatUdfValue,
  fromCalendarRangeModel,
  fromDataLakeCriteria,
  fromDateString,
  fromExpenseProjectModel,
  fromHoursNumber,
  fromISODateString,
  fromISODateTimeString,
  fromKeyNameOrEmpty,
  fromMulticurrencySetupModel,
  fromPaymentTermModel,
  fromPersonBaseModel,
  fromPersonBaseModelOrEmpty,
  fromPersonModel,
  fromPlatformFiscalPeriod,
  fromPlatformFixedAsset,
  fromPlatformFixedAssetCreateModel,
  fromPlatformFixedAssetJournalEntry,
  fromPlatformFixedAssetNoExtras,
  fromPlatformFixedAssetPostDocumentModel,
  fromPlatformFixedAssetSchedule,
  fromPlatformPayCode,
  fromPlatformProjectType,
  fromPlatformUdfValueListModel,
  fromPropertyTemplateModelSDK,
  fromPropertyTemplatePropertiesModelSDK,
  fromPurchaseOrderModel,
  fromPurchaseOrderSearch,
  fromPurchaseOrderSummaryModel,
  fromReceivingDocument,
  fromReceivingDocumentItem,
  fromTimesheetProjectModel,
  fromTimesheetTaskModel,
  generateCalendarQuarterPeriodsByCount,
  generateCalendarQuarterPeriodsByDates,
  generatePeriodsForSemiMonthByDates,
  generatePeriodsForSemiMonthByPeriods,
  generateSummary,
  get$1 as get,
  getAdminSetupLeftMenu,
  getAdvFundMod,
  getAdvFundModSummary,
  getAdvFundMods,
  getAllAssignablePlannedTime,
  getAllAssignedTimePersonOrganizations,
  getAllAssignedTimeProjectOrganizations,
  getAllAssignedTimeSaveCriteria,
  getAllAssignedTimeSharedSaveCriteria,
  getAllBillingAnalysts,
  getAllBillingTypes,
  getAllBusinessWeeks,
  getAllChangeReasons,
  getAllContractManagers,
  getAllContractStatuses,
  getAllContractTypes,
  getAllCostReportElements,
  getAllCostReports,
  getAllCustomLinks,
  getAllDataLakeCriteriaList,
  getAllDataLakeViews,
  getAllDeletedTimesheetAutofillRows,
  getAllEmployeeTypes,
  getAllFiscalYears,
  getAllFixedAssetDepreciationSchedules,
  getAllFixedAssetJournalEntries,
  getAllFixedAssetLegalEntityOrganizations,
  getAllFixedAssetPosters,
  getAllFixedAssetsAlerts,
  getAllFixedAssetsLegalEntities,
  getAllForecastedTimePersonOrganizations,
  getAllForecastedTimeProjectOrganizations,
  getAllForecastedTimeSaveCriteria,
  getAllForecastedTimeSharedSaveCriteria,
  getAllLegalEntities,
  getAllMasterContracts,
  getAllMeAlternatesFor,
  getAllMyTimesheetHistory,
  getAllOrganizationsVendorProfilesBatch,
  getAllOwningOrganizations,
  getAllPayCodes,
  getAllPlannedTimePersonOrganizations,
  getAllPlannedTimeSaveCriteria,
  getAllPlannedTimeSharedSaveCriteria,
  getAllProjectStatuses,
  getAllProjectTaskPredecessors,
  getAllProjectTypes,
  getAllProjectsTasksBatch,
  getAllPurchaseOrderAttachments,
  getAllPurchaseOrderLaborAssignments,
  getAllPurchaseOrderLegalEntities,
  getAllReceiptAttachments,
  getAllReceiptItems,
  getAllReceiptLegalEntities,
  getAllReceiptOwningOrgs,
  getAllReceiptProjects,
  getAllReceiptPurchaseOrderItems,
  getAllReceiptVendors,
  getAllSkillLevels,
  getAllSkillTypes,
  getAllStatisticalJournalEntryDetails,
  getAllTimesheetAttachments,
  getAllTimesheetAudits,
  getAllTimesheetAutofillRows,
  getAllTimesheetHistory,
  getAllTimesheetProjectLaborCategories,
  getAllTimesheetProjectLocations,
  getAllTimesheetProjectTypes,
  getAllTimesheetProjects,
  getAllTimesheetTaskLaborCategories,
  getAllTimesheetTaskLocations,
  getAllTimesheetsForApproval,
  getAnomalyDetectionInsight,
  getApprovalGroup,
  getAssignedTimePersonOrganizations,
  getAssignedTimeProjectOrganizations,
  getAssignedTimeSaveCriteria,
  getAssignedTimeSharedSaveCriteria,
  getAvailableExpenseTypes,
  getAvailableFixedPriceItems,
  getAvailableItems,
  getAvailableLaborCategories,
  getAvailableLeadProjects,
  getBankFeedTransaction,
  getBankFeedsIntegrationUser,
  getBankReconciliationInsight,
  getBookedPlannedTime,
  getBusinessHoursForPeriods,
  getBusinessWeek,
  getCalendarRanges,
  getChildStagingRecordByID,
  getClinChanges,
  getClinProjectTaskMapping,
  getClinProjectTaskMappings,
  getCloseReadinessInsight,
  getContract,
  getContractClauseCsv,
  getContractLeftMenu,
  getContractLine,
  getContractOfficers,
  getContractProvisions,
  getContractSubline,
  getContractUdfMetadata,
  getCoreUserInfo,
  getCostElements,
  getCostStructureLabor,
  getCostStructures,
  getCurrencySpec,
  getCurrentPageDashboardLeftMenuId,
  getCurrentPageDashboardMenuId,
  getCurrentTimesheet,
  getCustomLinks,
  getDataLakeCriteria,
  getDateForWorkDaysBetween,
  getDateLocalePartOrder,
  getDocumentLinkViewUrl,
  getEstimatedDataLakeRecordCount,
  getExpenseProjectDescription,
  getFinDocumentStatusDisplayName,
  getFinDocumentTypeDisplayName,
  getFiscalPeriodDisplay,
  getFiscalPeriodForDate,
  getFiscalYearBreakdown,
  getFixedAssetAlertDocumentTitle,
  getFixedAssetAlertDocumentType,
  getFixedAssetDepreciationSchedules,
  getFixedAssetImportDefinition,
  getFixedAssetJournalEntries,
  getFixedAssetLocations,
  getFixedAssetNetValue,
  getFixedAssetsCsv,
  getFixedAssetsUdfMetadata,
  getForecastInsight,
  getForecastedTime,
  getFundingItem,
  getFundingItems,
  getHasWageDeterminations,
  getHubAPI,
  getHubURL,
  getIceReadinessInsight,
  getImportDefault,
  getLeadProject,
  getLeaveRequests,
  getLegalEntityFiscalPeriodBalances,
  getLicenseHolder,
  getLicenses,
  getLineItemEnumByType,
  getLineItemNumber,
  getLocaleAwareDatePlaceholder,
  getMe,
  getMeAlternatesFor,
  getMostRecentPreviousForecast,
  getMyLeaveRequests,
  getMyLeftMenuBar,
  getMyMenu,
  getMyRates,
  getMyTimesheet,
  getMyTimesheetHistory,
  getMyTimesheets,
  getOrganization,
  getOrganizationContacts,
  getOrganizationList,
  getOrganizationVendorProfiles,
  getPageTypeAndId,
  getPermittedPostingFeatures,
  getPerson,
  getPersonClassificationByDate,
  getPersonRates,
  getPersonUdfMetadata,
  getPlannedTime,
  getPlannedTimePersonOrganizations,
  getPlannedTimeSaveCriteria,
  getPlannedTimeSaveCriteriaById,
  getPlannedTimeSharedSaveCriteria,
  getPlannedTimeSharedSaveCriteriaById,
  getProjectAssignment,
  getProjectAssignmentDefaults,
  getProjectForecastDefaults,
  getProjectPlanDefaults,
  getProjectTasks,
  getProjectTitle,
  getPropertyTemplateDetails,
  getPseudoRatesForClassification,
  getPurchaseOrder,
  getPurchaseOrderAssignmentType,
  getPurchaseOrderAvailableVendors,
  getPurchaseOrderBalances,
  getPurchaseOrderExpenseAssignments,
  getPurchaseOrderExpenses,
  getPurchaseOrderItems,
  getPurchaseOrderLabor,
  getPurchaseOrderLaborAssignments,
  getPurchaseOrderVIBalances,
  getReceipt,
  getReceiptAttachment,
  getReceiptAttachments,
  getReceiptItem,
  getReceiptsCsv,
  getReceiptsImportDefinition,
  getRecordCurrency,
  getRiskDetectionInsight,
  getSemiMonthStartEndDateByDates,
  getSemiMonthStartEndDateByPeriodCount,
  getSlinChanges,
  getStagingRecordPOLineTypeByOption,
  getStagingRecordValueObj,
  getStartEndDateByDates,
  getStartEndDateByPeriodCount,
  getStatisticalJournalEntry,
  getStatisticalJournalEntryDetails,
  getTimeEntryIncrementDecimalScale,
  getTimeLaborInsight,
  getTimesheet,
  getTimesheetAdjustments,
  getTimesheetHistory,
  getTimesheets,
  getTitoTimeIncrementSetting,
  getToken,
  getTransactionAddUrl,
  getTransactionTypeDisplayName,
  getTransactionTypeList,
  getTransactionViewUrl,
  getUnanetLocale,
  getUrlContext,
  getUtilizationForPeriods,
  getVendorInvoiceApprovalsRequired,
  getWbsHierarchy,
  getWeeklyStartEndDateByDates,
  getWeeklyStartEndDateByPeriodCount,
  hasAdministrativeRoles,
  hasLicense,
  hasPropertyTemplateAudit,
  hasRole,
  hasTemplateOrgAuditInfo,
  hasTimeListEditPermission,
  hasTimeManagerRoles,
  hasTimesheetRoles,
  hasTimesheetValidationErrorMessages,
  hasTimesheetValidationWarningMessages,
  helpers,
  hoursBetween,
  hydrateAudits,
  importContractClauses,
  importFixedAssets,
  importJobDuration,
  importJobIsComplete,
  importJobPercentComplete,
  importJobProcessedCounts,
  importJobStats,
  importReceipts,
  index$5 as imports,
  industry,
  integrations,
  isAbsoluteUrl,
  isBlank,
  isFixedAssetDisposed,
  isLastPage,
  isPendoExcludedUser,
  isPostingFeaturePermitted,
  isProduction,
  isVendorInvoiceIntegrationUserConfigured,
  isWeekdayIncluded,
  isWithinDigitLimits,
  keyNameModelToStagingValueUpdate,
  laborCategories,
  laborCategoriesCachedApi,
  lastNameFirstNameWithUsername,
  leadProject,
  leaveRequests,
  listPeople,
  loadAllProperties,
  locations,
  log,
  login,
  makeBrowserStorageTransport,
  makeLogger,
  makePlatformLogTransport,
  mapAssignedSaveCriteriaToForcastedSaveCriteria,
  mapErrorCodes,
  mapForecastedSaveCriteriaToAssignedSaveCriteria,
  mapForecastedSaveCriteriaToPlannedSaveCriteria,
  mapForecastingTimeToPlannedTime,
  mapListPage,
  mapPlannedSaveCriteriaToForcastedSaveCriteria,
  mapPlannedTimeCreateToProjectAssignmentCreate,
  mapPlannedTimeSearchToProjectAssignmentSearch,
  mapPlannedTimeToProjectAssignment,
  mapProjectAssignmentToPlannedTime,
  mapPurchasingLineDescriptorToStagingRecord,
  mapPurchasingLineToStagingRecordByType,
  matchTransaction,
  me$1 as me,
  mergeProjectTitos,
  mergeTitos,
  modelFromJSON,
  modelToJSON,
  moveLineItem,
  naicsCodes,
  nextWorkDay,
  noop$5 as noop,
  omit,
  optOutToggleForPerson,
  optimizeCashFlow,
  organizationDisplayName,
  organizationVendorProfileDisplayName,
  organizationVendorProfileSummaryDisplayName,
  index$1 as organizations,
  organizationsCachedApi,
  parseImportRecordAction,
  payCodes,
  paymentMethods,
  paymentTerms,
  index$2 as people,
  peopleCachedApi,
  ping$1 as ping,
  planning,
  index$4 as platform,
  post,
  postFile,
  postFixedAssets,
  postStatisticalJournalEntry,
  postVendorInvoice,
  postVendorInvoiceValidate,
  previousWorkDay,
  processImportBatch,
  projectRowKey,
  projects,
  projectsCachedApi,
  helpers as properties,
  propertyTemplates,
  purchaseOrderAccess,
  purchaseOrders,
  purchaseOrdersCachedApi,
  put,
  putStatisticalJournalEntryInUse,
  readBrowserStorageLogs,
  readPerson,
  receipts,
  reconcileBankReconciliation,
  refresh,
  refreshHubTransactions,
  removeApprover,
  removeEmptyName,
  removeEmptyUdfValues,
  removeExchangeRate,
  removeExchangeRateType,
  removeNullableEmptyName,
  replaceLineBreaksWithSpace,
  request,
  requestFileUpload,
  resetBankFeedsIntegrationUser,
  restoreMatchedTransactions,
  retractReceipt,
  returnAdvFundModToDraft,
  reviewMyTimesheet,
  richTito,
  index as roles,
  roundHours,
  roundPlannedHours,
  saveBankFeedSettings,
  saveFixedAssetFilterCriteria,
  searchAllApprovalGroups,
  searchAllAssignedTimePeople,
  searchAllAssignedTimeProjects,
  searchAllExchangeRates,
  searchAllFixedAssets,
  searchAllForecastedTime,
  searchAllForecastedTimePeople,
  searchAllForecastedTimeProjects,
  searchAllMyTimesheets,
  searchAllPeople,
  searchAllPeopleAssignments,
  searchAllPeopleByKeys,
  searchAllPeopleByName,
  searchAllPeopleSummaries,
  searchAllPeopleWithOrgAccess,
  searchAllPlannedTime,
  searchAllPlannedTimePeople,
  searchAllPlannedTimeProjects,
  searchAllProjectAssignments,
  searchAllProjects,
  searchAllPurchaseOrders,
  searchAllReceiptPeople,
  searchAllReceiptPurchaseOrders,
  searchAllReceipts,
  searchAllSkills,
  searchAllTasks,
  searchAllTimesheets,
  searchAssignablePlannedTime,
  searchAssignedTimeMatrix,
  searchAssignedTimePeople,
  searchAssignedTimePeopleAllocation,
  searchAssignedTimeProjects,
  searchBankReconciliationTransactions,
  searchBankReconciliations,
  searchContractDetails,
  searchContracts,
  searchFixedAssets,
  searchFixedAssetsPosts,
  searchForecastedTime,
  searchForecastedTimeMatrix,
  searchForecastedTimePeopleAllocation,
  searchOrganizations,
  searchPeople,
  searchPeopleAssignments,
  searchPeopleWithOrgAccess,
  searchPlannedTime,
  searchPlannedTimeMatrix,
  searchPlannedTimePeople,
  searchPlannedTimePeopleAllocation,
  searchProjectAssignments,
  searchProjects,
  searchPurchaseOrders,
  searchReceiptPurchaseOrders,
  searchReceipts,
  searchStatisticalJournals,
  searchTasks,
  setFixedAssetAlertReadStatus,
  setMode,
  setServerUrl,
  setStagingRecordValueObj,
  setToken,
  socioeconomicStatus,
  startPropertiesInterval,
  statisticalAccountJournals,
  statisticalAccounts,
  stopPropertiesInterval,
  stringToStagingValueUpdate,
  submitAdvFundModForReview,
  submitForm,
  submitFormInNewTab,
  submitMyTimesheet,
  submitStatisticalJournalEntry,
  submitTimesheet,
  submitVendorInvoice,
  time,
  timeEntryIncrementList,
  timesheetEffectiveStatus,
  toAlternateRole,
  toAttachmentList,
  toCreateModel,
  toCurrencyCodeDisplayModel,
  toCurrencyDisplayString,
  toDashboardItemEnum,
  toDataLakeCriteria,
  toDataLakeView,
  toDatabaseTime,
  toItemEntryUpdateModel,
  toKeyName,
  toNumber$1 as toNumber,
  toOrganizationAlias,
  toPaymentTermCreateModel,
  toPaymentTermModel,
  toPlatformApprovalGroupSearch,
  toPlatformFixedAssetCreateModel,
  toPlatformFixedAssetModel,
  toPlatformUdfValueListModel,
  toProjectUpdateModel,
  toPropertyTemplateModelSDK,
  toPropertyTemplatePropertiesModelSDK,
  toReceivingDocument,
  toReceivingDocumentItem,
  toReceivingPurchaseOrder,
  toTaskUpdateModel,
  toTimeApprovalQueue,
  toTimeStatusHistory,
  toTimesheetDateTime,
  toTimesheetDayUpdateModel,
  toTimesheetUpdateModel,
  toTimesheetUpdateModelFromVisualTimeRows,
  toTimeslipAdjustment,
  toTimeslipAudit,
  toTimeslipUpdateModel,
  toTitoUpdateModel,
  today,
  toggleOrganizationAliasActiveStatus,
  tomorrow,
  unanetCore,
  unpostFixedAsset,
  unreconcileBankReconciliation,
  updateAdvFundMod,
  updateAssignedTimeSaveCriteria,
  updateAssignedTimeSharedSaveCriteria,
  updateBankReconciliation,
  updateBankReconciliationDetails,
  updateClinChange,
  updateClinProjectTaskMapping,
  updateContract,
  updateContractLine,
  updateContractSubline,
  updateDataLakeCriteria,
  updateForecastedTime,
  updateForecastedTimeSaveCriteria,
  updateForecastedTimeSharedSaveCriteria,
  updateFundingItem,
  updateMatchedTransaction,
  updateMyTimesheet,
  updateOrganizationAlias,
  updatePaymentMethod,
  updatePaymentMethodAccounts,
  updatePaymentTerm,
  updatePersonRate,
  updatePlannedTime,
  updatePlannedTimeSaveCriteria,
  updatePlannedTimeSharedSaveCriteria,
  updateProject,
  updateProjectAssignment,
  updateProjectTask,
  updateProjectTaskPredecessor,
  updatePropertyTemplate,
  updateReceipt,
  updateReceiptItem,
  updateSlinChange,
  updateStatisticalJournalEntry,
  updateStatisticalJournalEntryDetails,
  updateTimesheet,
  validSession,
  validateClinProjectTaskMappings,
  validateForPost,
  validateForSubmit,
  validateMyTimesheet,
  validatePaymentTermForm,
  validateTimesheet,
  vendorInvoices,
  version,
  voidStatisticalJournalEntry,
  with404,
  workDaysBetween,
  workHoursBetween,
  yesterday
};
